/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 337);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FlowModuleEvents = /** @class */ (function () {
    function FlowModuleEvents() {
    }
    FlowModuleEvents.WON_BIG_WIN = 'FlowModuleEvents::__WON_BIG_WIN__';
    FlowModuleEvents.WON = 'FlowModuleEvents::__WON__';
    FlowModuleEvents.NO_WIN = 'FlowModuleEvents::__NO_WIN__';
    FlowModuleEvents.BONUS_GAME_WON = 'FlowModuleEvents::__BONUS_GAME_WON__';
    FlowModuleEvents.BONUS_GAME_START = 'FlowModuleEvents::__BONUS_GAME_START__';
    FlowModuleEvents.BONUS_GAME_END = 'FlowModuleEvents::__BONUS_GAME_END__';
    FlowModuleEvents.BONUS_GAME_RESTORED = 'FlowModuleEvents::__BONUS_GAME_RESTORED__';
    FlowModuleEvents.FREESPINS_WIN = 'FlowModuleEvents::__FREESPINS_WIN__';
    FlowModuleEvents.FREESPINS_RETRIGGER_WIN = 'FlowModuleEvents::__FREESPINS_RETRIGGER_WIN__';
    FlowModuleEvents.FREE_SPINS_FINISHED = 'FlowModuleEvents::__FREE_SPINS_FINISHED__';
    FlowModuleEvents.AVALANCHE_WON = 'FlowModuleEvents::__AVALANCHE_WON__';
    FlowModuleEvents.RESPIN_WON = 'FlowModuleEvents::__RESPIN_WON__';
    FlowModuleEvents.SCATTER_AND_AVALANCHE_WON = 'SCATTER_AND_AVALANCHE_WON';
    FlowModuleEvents.START_INDIVIDUAL_WIN = 'FlowModuleEvents::__START_INDIVIDUAL_WIN__';
    FlowModuleEvents.CAN_SPIN = 'FlowModuleEvents::__CAN_SPIN__';
    FlowModuleEvents.CAN_CONTINUE_SPIN = 'FlowModuleEvents::__CAN_CONTINUE_SPIN__';
    FlowModuleEvents.CAN_DROP_NEW = 'FlowModuleEvents::CAN_DROP_NEW';
    return FlowModuleEvents;
}());
exports.FlowModuleEvents = FlowModuleEvents;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * module state handles events
 */
var ModuleState = /** @class */ (function () {
    function ModuleState(module, name) {
        /**
         * the list of events we handle with this state
         */
        this._events = {};
        this._module = module;
        this._name = name;
        this.setupEvents();
    }
    Object.defineProperty(ModuleState.prototype, "module", {
        get: function () {
            return this._module;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModuleState.prototype, "view", {
        get: function () {
            return this._module.view;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ModuleState.prototype, "name", {
        get: function () {
            return this._name;
        },
        enumerable: true,
        configurable: true
    });
    ModuleState.prototype.removeMe = function () {
        if (this._events) {
            for (var event_1 in this._events) {
                this._events[event_1] = null;
            }
        }
    };
    /**
     * handles events
     * @param {number} id - event ID
     * @param args
     */
    ModuleState.prototype.handle = function (id) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var _a;
        this._events[id] && (_a = this._events)[id].apply(_a, args);
    };
    ModuleState.prototype.emit = function (id) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var _a;
        (_a = this._module.eventManager).emit.apply(_a, [id].concat(args));
    };
    /**
     * emitting event after the call stack if cleaned (next tick)
     * @param id event id
     * @param args arguments to pass with event
     */
    ModuleState.prototype.emitDelayed = function (id) {
        var _this = this;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        setTimeout(function () {
            _this.emit.apply(_this, [id].concat(args));
        }, 0);
    };
    ModuleState.prototype.on = function (id, listener) {
        this._events[id] = listener.bind(this, id);
    };
    return ModuleState;
}());
exports.ModuleState = ModuleState;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Device_1 = __webpack_require__(42);
var CoreDI_1 = __webpack_require__(32);
var ScreenEvents_1 = __webpack_require__(108);
var System_1 = __webpack_require__(52);
var UpdateManager_1 = __webpack_require__(70);
var DI_1 = __webpack_require__(51);
var StatedDebug_1 = __webpack_require__(489);
var ViewManager_1 = __webpack_require__(241);
var Logic_1 = __webpack_require__(73);
var SoundPlayer_1 = __webpack_require__(144);
var inversify_1 = __webpack_require__(14);
__webpack_require__(139);
var TimerUtils_1 = __webpack_require__(235);
/**
 * an abstract class for every game module to be extended from
 * handles views and module-to-module events.
 * also changes the states of current module and handles events from view
 */
var Module = /** @class */ (function () {
    function Module() {
        this._moduleStateHandlingEvents = [];
    }
    Module_1 = Module;
    Module.prototype.init = function () {
        this._states = {};
        this._timeUtils = new TimerUtils_1.TimerUtils(this.updateManager);
        this.setupViews();
        this.setupStates();
        this.setupEvents();
        this.enterFirstState();
        if (false) {
            if (!document.MODULES) {
                document.MODULES = {};
            }
            document.MODULES[this.constructor.name] = this;
        }
    };
    Module.prototype.afterInit = function () { };
    Module.prototype.addDebuggingComponent = function () { };
    Module.prototype.restore = function () { };
    Module.prototype.gotoState = function (name) {
        this.changeStateTo(name);
    };
    Module.prototype.gotoPreviousState = function () {
        if (this._previousStateName && this._previousStateName.length > 0) {
            var fromState = this._currentState ? this._currentState.name : '';
            this._currentState && this._currentState.onLeaveState();
            this._currentState = this._states[this._previousStateName];
            this._previousStateName = fromState;
            if (false) {
                Module_1._debugInfo.setModuleState(this.constructor.name, this._currentState.name);
                console.log('' + this.constructor.name + ': ' + fromState + ' -> ' + this.currentState.name);
            }
        }
        else {
            throw new Error('Module::gotoPreviousState previous state does not exist');
        }
    };
    Module.prototype.setupEvents = function () {
        if (this._view) {
            this.eventManager.on(ScreenEvents_1.ScreenEvents.LANDSCAPE_MODE, this._view.onLandscape.bind(this.view), this);
            this.eventManager.on(ScreenEvents_1.ScreenEvents.PORTRAIT_MODE, this._view.onPortrait.bind(this.view), this);
            this.eventManager.on(ScreenEvents_1.ScreenEvents.SCREEN_RESIZED, this._view.onResized.bind(this.view), this);
            this.eventManager.on(ScreenEvents_1.ScreenEvents.FULLSCREEN_ENTERED, this._view.onFullscreenEntered.bind(this.view), this);
            this.eventManager.on(ScreenEvents_1.ScreenEvents.FULLSCREEN_EXITED, this._view.onFullscreenExited.bind(this.view), this);
        }
    };
    Module.prototype.changeStateTo = function (name) {
        var fromState = this._currentState ? this._currentState.name : '';
        this._previousStateName = fromState;
        this._currentState && this._currentState.onLeaveState();
        this._currentState = this._states[name];
        this._currentState.onEnterState();
        if (false) {
            Module_1._debugInfo.setModuleState(this.constructor.name, this._currentState.name);
            console.log('' + this.constructor.name + ': ' + fromState + ' -> ' + this.currentState.name);
        }
    };
    Module.prototype.setView = function (viewName) {
        this._view = this._viewManager.getView(viewName);
    };
    Module.prototype.addState = function (module) {
        this._states[module.name] = module;
    };
    Module.prototype.on = function (id, listener, priority) {
        if (priority === void 0) { priority = 0; }
        this.eventManager.on(id, listener.bind(this, id), this, priority);
    };
    Module.prototype.off = function (id) {
        this.eventManager.off(id, this);
    };
    Module.prototype.onCurrentStateHandle = function (id) {
        if (this._moduleStateHandlingEvents.indexOf(id) < 0) {
            this._moduleStateHandlingEvents.push(id);
            this.on(id, this.onCurrentStateHandleEvent);
        }
    };
    Module.prototype.removeCurrentStateHandling = function (id) {
        var index = this._moduleStateHandlingEvents.indexOf(id);
        if (index >= 0) {
            this._moduleStateHandlingEvents.splice(index, 1);
            this.off(id);
        }
    };
    Module.prototype.onView = function (id, listener) {
        this.view.on(id, listener.bind(this, id), this);
    };
    Module.prototype.onViewCurrentStateHandle = function (id) {
        this.onView(id, this.onCurrentStateHandleEvent);
    };
    Module.prototype.onViewEmitEvent = function (viewEventID, eventToEmitID) {
        var _this = this;
        this.view.on(viewEventID, function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var _a;
            (_a = _this.eventManager).emit.apply(_a, [eventToEmitID].concat(args));
        }, this);
    };
    Module.prototype.onCurrentStateHandleEvent = function (eventID) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var _a;
        (_a = this.currentState).handle.apply(_a, [eventID].concat(args));
    };
    Object.defineProperty(Module.prototype, "eventManager", {
        get: function () {
            return this._eventManager;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Module.prototype, "currentState", {
        get: function () {
            return this._currentState;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Module.prototype, "settings", {
        get: function () {
            return this._settings;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Module.prototype, "view", {
        get: function () {
            return this._view;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Module.prototype, "system", {
        get: function () {
            return this._system;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Module.prototype, "updateManager", {
        get: function () {
            return this._updateManager;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Module.prototype, "logic", {
        get: function () {
            return this._logic;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Module.prototype, "soundPlayer", {
        get: function () {
            return this._soundPlayer;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Module.prototype, "device", {
        get: function () {
            return this._device;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Module.prototype, "timeUtils", {
        get: function () {
            return this._timeUtils;
        },
        enumerable: true,
        configurable: true
    });
    var Module_1;
    Module._debugInfo = new StatedDebug_1.StatedDebug();
    __decorate([
        inversify_1.inject(DI_1.default.ViewManager),
        __metadata("design:type", ViewManager_1.ViewManager)
    ], Module.prototype, "_viewManager", void 0);
    __decorate([
        inversify_1.inject(CoreDI_1.CoreDI.IEventManagerWithAsync),
        __metadata("design:type", Object)
    ], Module.prototype, "_eventManager", void 0);
    __decorate([
        inversify_1.inject(DI_1.default.ISettings),
        __metadata("design:type", Object)
    ], Module.prototype, "_settings", void 0);
    __decorate([
        inversify_1.inject(CoreDI_1.CoreDI.System),
        __metadata("design:type", System_1.System)
    ], Module.prototype, "_system", void 0);
    __decorate([
        inversify_1.inject(CoreDI_1.CoreDI.UpdateManager),
        __metadata("design:type", UpdateManager_1.UpdateManager)
    ], Module.prototype, "_updateManager", void 0);
    __decorate([
        inversify_1.inject(DI_1.default.Logic),
        __metadata("design:type", Logic_1.Logic)
    ], Module.prototype, "_logic", void 0);
    __decorate([
        inversify_1.inject(DI_1.default.SoundPlayer),
        __metadata("design:type", SoundPlayer_1.SoundPlayer)
    ], Module.prototype, "_soundPlayer", void 0);
    __decorate([
        inversify_1.inject(CoreDI_1.CoreDI.Device),
        __metadata("design:type", Device_1.Device)
    ], Module.prototype, "_device", void 0);
    Module = Module_1 = __decorate([
        inversify_1.injectable()
    ], Module);
    return Module;
}());
exports.Module = Module;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(59);
var inversify_1 = __webpack_require__(14);
var BasicView_1 = __webpack_require__(473);
var ViewTypes;
(function (ViewTypes) {
    ViewTypes[ViewTypes["DESKTOP"] = 0] = "DESKTOP";
    ViewTypes[ViewTypes["LANDSCAPE"] = 1] = "LANDSCAPE";
    ViewTypes[ViewTypes["PORTRAIT"] = 2] = "PORTRAIT";
})(ViewTypes = exports.ViewTypes || (exports.ViewTypes = {}));
/**
 * abstract class every view must be extended from. also has possibility to send events within the module
 * usually events are needed to module further consideration of actions
 */
var View = /** @class */ (function (_super) {
    __extends(View, _super);
    function View() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._views = [];
        _this._viewType = 0;
        _this._hasFewMobileViews = false;
        return _this;
    }
    View.prototype.setupViewType = function (viewType) {
        this._viewType = viewType;
    };
    View.prototype.setupParentView = function (view) {
        this._parentView = view;
    };
    View.prototype.addStandardMobileViews = function (viewIdentifier) {
        if (this._views && this._views.length > 0) {
            throw new Error('View::addStandardMobileViews this view already has views created');
        }
        var landscapeView = this._system.container.get(viewIdentifier);
        landscapeView.setupViewType(ViewTypes.LANDSCAPE);
        landscapeView.setupParentView(this);
        var portraitView = this._system.container.get(viewIdentifier);
        portraitView.setupViewType(ViewTypes.PORTRAIT);
        portraitView.setupParentView(this);
        this._landscapeView = landscapeView;
        this._portraitView = portraitView;
        this._views.push(this._landscapeView);
        this._views.push(this._portraitView);
        this._hasFewMobileViews = true;
    };
    View.prototype.addMobileViews = function (landscapeView, portraitView) {
        this._landscapeView = landscapeView;
        this._portraitView = portraitView;
        this._views.push(this._landscapeView);
        this._views.push(this._portraitView);
        this._hasFewMobileViews = true;
    };
    View.prototype.show = function () {
        if (this.hasFewMobileViews) {
            this._views.map(function (view) {
                view.show();
            });
        }
        else {
            _super.prototype.show.call(this);
        }
    };
    View.prototype.hide = function () {
        if (this.hasFewMobileViews) {
            this._views.map(function (view) {
                view.hide();
            });
        }
        else {
            _super.prototype.hide.call(this);
        }
    };
    View.prototype.on = function (id, callback, owner, priority, data) {
        if (priority === void 0) { priority = 0; }
        if (data === void 0) { data = null; }
        if (this.hasFewMobileViews) {
            this._views.map(function (view) {
                view.on(id, callback, owner, priority, data);
            });
        }
        else {
            _super.prototype.on.call(this, id, callback, owner, priority, data);
        }
    };
    View.prototype.off = function (id, owner) {
        if (this.hasFewMobileViews) {
            this._views.map(function (view) {
                view.off(id, owner);
            });
        }
        else {
            _super.prototype.off.call(this, id, owner);
        }
    };
    View.prototype.emit = function (id) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (this._hasFewMobileViews) {
            this._views.map(function (view) {
                view.emit.apply(view, [id].concat(args));
            });
        }
        else {
            _super.prototype.emit.apply(this, [id].concat(args));
        }
    };
    View.prototype.onLandscape = function () {
        if (this.hasFewMobileViews) {
            this._portraitView.hideContainer();
            this._landscapeView.showContainer();
        }
    };
    View.prototype.onPortrait = function () {
        if (this.hasFewMobileViews) {
            this._landscapeView.hideContainer();
            this._portraitView.showContainer();
        }
    };
    View.prototype.viewCallback = function (callback, functionName) {
        var _this = this;
        var argArray = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            argArray[_i - 2] = arguments[_i];
        }
        if (this._parentView) {
            return function () {
                var _a, _b;
                if (_this._parentView.landscapeView[functionName]) {
                    (_a = _this._parentView.landscapeView)[functionName].apply(_a, argArray);
                }
                else {
                    throw new Error("function " + functionName + " does not exist in landscape view " + _this.constructor.name);
                }
                if (_this._parentView.portraitView[functionName]) {
                    (_b = _this._parentView.portraitView)[functionName].apply(_b, argArray);
                }
                else {
                    throw new Error("function " + functionName + " does not exist in portrait view " + _this.constructor.name);
                }
            };
        }
        else {
            return function () {
                callback(argArray);
            };
        }
    };
    Object.defineProperty(View.prototype, "hasFewMobileViews", {
        get: function () {
            return this._hasFewMobileViews;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(View.prototype, "viewType", {
        get: function () {
            return this._viewType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(View.prototype, "landscapeView", {
        get: function () {
            return this._landscapeView;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(View.prototype, "portraitView", {
        get: function () {
            return this._portraitView;
        },
        enumerable: true,
        configurable: true
    });
    View = __decorate([
        inversify_1.injectable()
    ], View);
    return View;
}(BasicView_1.BasicView));
exports.View = View;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ReelsEvents = /** @class */ (function () {
    function ReelsEvents() {
    }
    ReelsEvents.SPIN_ENDED = 'ReelsEvents::__SPIN_ENDED__';
    ReelsEvents.AVALANCHE_ENDED = 'ReelsEvents::__AVALANCHE_ENDED__';
    ReelsEvents.REELS_SPINNING_STARTED = 'ReelsEvents::__REELS_SPINNING_STARTED__';
    ReelsEvents.REELS_RESPIN_STARTED = 'ReelsEvents::__REELS_RESPIN_STARTED__';
    ReelsEvents.REELS_AVALANCHE_STARTED = 'ReelsEvents::__REELS_AVALANCHE_STARTED__';
    ReelsEvents.REEL_STOPPED = 'ReelsEvents::__REEL_STOPPED__';
    ReelsEvents.ALL_REELS_STOPPED = 'ReelsEvents::__ALL_REELS_STOPPED__';
    ReelsEvents.REEL_PERCIEVED_STOP = 'ReelsEvents::REEL_PERCIEVED_STOP';
    ReelsEvents.REELS_FADING_OUT_FINISHED = 'ReelsEvents::REELS_FADING_OUT_FINISHED';
    ReelsEvents.REELS_FADING_OUT_STARTED = 'ReelsEvents::REELS_FADING_OUT_STARTED';
    ReelsEvents.REELS_FADING_IN_FINISHED = 'ReelsEvents::REELS_FADING_IN_FINISHED';
    ReelsEvents.REELS_FADING_IN_STARTED = 'ReelsEvents::REELS_FADING_IN_STARTED';
    return ReelsEvents;
}());
exports.ReelsEvents = ReelsEvents;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * String of the current PIXI version.
 *
 * @static
 * @constant
 * @memberof PIXI
 * @name VERSION
 * @type {string}
 */
var VERSION = exports.VERSION = '4.8.9';

/**
 * Two Pi.
 *
 * @static
 * @constant
 * @memberof PIXI
 * @type {number}
 */
var PI_2 = exports.PI_2 = Math.PI * 2;

/**
 * Conversion factor for converting radians to degrees.
 *
 * @static
 * @constant
 * @memberof PIXI
 * @type {number}
 */
var RAD_TO_DEG = exports.RAD_TO_DEG = 180 / Math.PI;

/**
 * Conversion factor for converting degrees to radians.
 *
 * @static
 * @constant
 * @memberof PIXI
 * @type {number}
 */
var DEG_TO_RAD = exports.DEG_TO_RAD = Math.PI / 180;

/**
 * Constant to identify the Renderer Type.
 *
 * @static
 * @constant
 * @memberof PIXI
 * @name RENDERER_TYPE
 * @type {object}
 * @property {number} UNKNOWN - Unknown render type.
 * @property {number} WEBGL - WebGL render type.
 * @property {number} CANVAS - Canvas render type.
 */
var RENDERER_TYPE = exports.RENDERER_TYPE = {
  UNKNOWN: 0,
  WEBGL: 1,
  CANVAS: 2
};

/**
 * Various blend modes supported by PIXI.
 *
 * IMPORTANT - The WebGL renderer only supports the NORMAL, ADD, MULTIPLY and SCREEN blend modes.
 * Anything else will silently act like NORMAL.
 *
 * @static
 * @constant
 * @memberof PIXI
 * @name BLEND_MODES
 * @type {object}
 * @property {number} NORMAL
 * @property {number} ADD
 * @property {number} MULTIPLY
 * @property {number} SCREEN
 * @property {number} OVERLAY
 * @property {number} DARKEN
 * @property {number} LIGHTEN
 * @property {number} COLOR_DODGE
 * @property {number} COLOR_BURN
 * @property {number} HARD_LIGHT
 * @property {number} SOFT_LIGHT
 * @property {number} DIFFERENCE
 * @property {number} EXCLUSION
 * @property {number} HUE
 * @property {number} SATURATION
 * @property {number} COLOR
 * @property {number} LUMINOSITY
 */
var BLEND_MODES = exports.BLEND_MODES = {
  NORMAL: 0,
  ADD: 1,
  MULTIPLY: 2,
  SCREEN: 3,
  OVERLAY: 4,
  DARKEN: 5,
  LIGHTEN: 6,
  COLOR_DODGE: 7,
  COLOR_BURN: 8,
  HARD_LIGHT: 9,
  SOFT_LIGHT: 10,
  DIFFERENCE: 11,
  EXCLUSION: 12,
  HUE: 13,
  SATURATION: 14,
  COLOR: 15,
  LUMINOSITY: 16,
  NORMAL_NPM: 17,
  ADD_NPM: 18,
  SCREEN_NPM: 19
};

/**
 * Various webgl draw modes. These can be used to specify which GL drawMode to use
 * under certain situations and renderers.
 *
 * @static
 * @constant
 * @memberof PIXI
 * @name DRAW_MODES
 * @type {object}
 * @property {number} POINTS
 * @property {number} LINES
 * @property {number} LINE_LOOP
 * @property {number} LINE_STRIP
 * @property {number} TRIANGLES
 * @property {number} TRIANGLE_STRIP
 * @property {number} TRIANGLE_FAN
 */
var DRAW_MODES = exports.DRAW_MODES = {
  POINTS: 0,
  LINES: 1,
  LINE_LOOP: 2,
  LINE_STRIP: 3,
  TRIANGLES: 4,
  TRIANGLE_STRIP: 5,
  TRIANGLE_FAN: 6
};

/**
 * The scale modes that are supported by pixi.
 *
 * The {@link PIXI.settings.SCALE_MODE} scale mode affects the default scaling mode of future operations.
 * It can be re-assigned to either LINEAR or NEAREST, depending upon suitability.
 *
 * @static
 * @constant
 * @memberof PIXI
 * @name SCALE_MODES
 * @type {object}
 * @property {number} LINEAR Smooth scaling
 * @property {number} NEAREST Pixelating scaling
 */
var SCALE_MODES = exports.SCALE_MODES = {
  LINEAR: 0,
  NEAREST: 1
};

/**
 * The wrap modes that are supported by pixi.
 *
 * The {@link PIXI.settings.WRAP_MODE} wrap mode affects the default wrapping mode of future operations.
 * It can be re-assigned to either CLAMP or REPEAT, depending upon suitability.
 * If the texture is non power of two then clamp will be used regardless as webGL can
 * only use REPEAT if the texture is po2.
 *
 * This property only affects WebGL.
 *
 * @static
 * @constant
 * @name WRAP_MODES
 * @memberof PIXI
 * @type {object}
 * @property {number} CLAMP - The textures uvs are clamped
 * @property {number} REPEAT - The texture uvs tile and repeat
 * @property {number} MIRRORED_REPEAT - The texture uvs tile and repeat with mirroring
 */
var WRAP_MODES = exports.WRAP_MODES = {
  CLAMP: 0,
  REPEAT: 1,
  MIRRORED_REPEAT: 2
};

/**
 * The gc modes that are supported by pixi.
 *
 * The {@link PIXI.settings.GC_MODE} Garbage Collection mode for PixiJS textures is AUTO
 * If set to GC_MODE, the renderer will occasionally check textures usage. If they are not
 * used for a specified period of time they will be removed from the GPU. They will of course
 * be uploaded again when they are required. This is a silent behind the scenes process that
 * should ensure that the GPU does not  get filled up.
 *
 * Handy for mobile devices!
 * This property only affects WebGL.
 *
 * @static
 * @constant
 * @name GC_MODES
 * @memberof PIXI
 * @type {object}
 * @property {number} AUTO - Garbage collection will happen periodically automatically
 * @property {number} MANUAL - Garbage collection will need to be called manually
 */
var GC_MODES = exports.GC_MODES = {
  AUTO: 0,
  MANUAL: 1
};

/**
 * Regexp for image type by extension.
 *
 * @static
 * @constant
 * @memberof PIXI
 * @type {RegExp|string}
 * @example `image.png`
 */
var URL_FILE_EXTENSION = exports.URL_FILE_EXTENSION = /\.(\w{3,4})(?:$|\?|#)/i;

/**
 * Regexp for data URI.
 * Based on: {@link https://github.com/ragingwind/data-uri-regex}
 *
 * @static
 * @constant
 * @name DATA_URI
 * @memberof PIXI
 * @type {RegExp|string}
 * @example data:image/png;base64
 */
var DATA_URI = exports.DATA_URI = /^\s*data:(?:([\w-]+)\/([\w+.-]+))?(?:;charset=([\w-]+))?(?:;(base64))?,(.*)/i;

/**
 * Regexp for SVG size.
 *
 * @static
 * @constant
 * @name SVG_SIZE
 * @memberof PIXI
 * @type {RegExp|string}
 * @example &lt;svg width="100" height="100"&gt;&lt;/svg&gt;
 */
var SVG_SIZE = exports.SVG_SIZE = /<svg[^>]*(?:\s(width|height)=('|")(\d*(?:\.\d+)?)(?:px)?('|"))[^>]*(?:\s(width|height)=('|")(\d*(?:\.\d+)?)(?:px)?('|"))[^>]*>/i; // eslint-disable-line max-len

/**
 * Constants that identify shapes, mainly to prevent `instanceof` calls.
 *
 * @static
 * @constant
 * @name SHAPES
 * @memberof PIXI
 * @type {object}
 * @property {number} POLY Polygon
 * @property {number} RECT Rectangle
 * @property {number} CIRC Circle
 * @property {number} ELIP Ellipse
 * @property {number} RREC Rounded Rectangle
 */
var SHAPES = exports.SHAPES = {
  POLY: 0,
  RECT: 1,
  CIRC: 2,
  ELIP: 3,
  RREC: 4
};

/**
 * Constants that specify float precision in shaders.
 *
 * @static
 * @constant
 * @name PRECISION
 * @memberof PIXI
 * @type {object}
 * @property {string} LOW='lowp'
 * @property {string} MEDIUM='mediump'
 * @property {string} HIGH='highp'
 */
var PRECISION = exports.PRECISION = {
  LOW: 'lowp',
  MEDIUM: 'mediump',
  HIGH: 'highp'
};

/**
 * Constants that specify the transform type.
 *
 * @static
 * @constant
 * @name TRANSFORM_MODE
 * @memberof PIXI
 * @type {object}
 * @property {number} STATIC
 * @property {number} DYNAMIC
 */
var TRANSFORM_MODE = exports.TRANSFORM_MODE = {
  STATIC: 0,
  DYNAMIC: 1
};

/**
 * Constants that define the type of gradient on text.
 *
 * @static
 * @constant
 * @name TEXT_GRADIENT
 * @memberof PIXI
 * @type {object}
 * @property {number} LINEAR_VERTICAL Vertical gradient
 * @property {number} LINEAR_HORIZONTAL Linear gradient
 */
var TEXT_GRADIENT = exports.TEXT_GRADIENT = {
  LINEAR_VERTICAL: 0,
  LINEAR_HORIZONTAL: 1
};

/**
 * Represents the update priorities used by internal PIXI classes when registered with
 * the {@link PIXI.ticker.Ticker} object. Higher priority items are updated first and lower
 * priority items, such as render, should go later.
 *
 * @static
 * @constant
 * @name UPDATE_PRIORITY
 * @memberof PIXI
 * @type {object}
 * @property {number} INTERACTION=50 Highest priority, used for {@link PIXI.interaction.InteractionManager}
 * @property {number} HIGH=25 High priority updating, {@link PIXI.VideoBaseTexture} and {@link PIXI.extras.AnimatedSprite}
 * @property {number} NORMAL=0 Default priority for ticker events, see {@link PIXI.ticker.Ticker#add}.
 * @property {number} LOW=-25 Low priority used for {@link PIXI.Application} rendering.
 * @property {number} UTILITY=-50 Lowest priority used for {@link PIXI.prepare.BasePrepare} utility.
 */
var UPDATE_PRIORITY = exports.UPDATE_PRIORITY = {
  INTERACTION: 50,
  HIGH: 25,
  NORMAL: 0,
  LOW: -25,
  UTILITY: -50
};
//# sourceMappingURL=const.js.map

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FreeSpinsEvents = /** @class */ (function () {
    function FreeSpinsEvents() {
    }
    FreeSpinsEvents.FREE_SPINS_INTRO_STARTED = 'FreeSpinsEvents::FREE_SPINS_INTRO_STARTED';
    FreeSpinsEvents.FREE_SPINS_RESTORE_INTRO_STARTED = 'FreeSpinsEvents::FREE_SPINS_RESTORE_INTRO_STARTED';
    FreeSpinsEvents.FREE_SPINS_OUTRO_STARTED = 'FreeSpinsEvents::FREE_SPINS_OUTRO_STARTED';
    FreeSpinsEvents.FREE_SPINS_START_READY = 'FreeSpinsEvents::FREE_SPINS_START_READY';
    FreeSpinsEvents.FREE_SPINS_INTRO_FINISHED = 'FreeSpinsEvents::FREE_SPINS_INTRO_FINISHED';
    FreeSpinsEvents.FREE_SPINS_OUTRO_FINISHED = 'FreeSpinsEvents::FREE_SPINS_OUTRO_FINISHED';
    FreeSpinsEvents.SHOWING_WIN_SUMMARY_SCREEN = 'FreeSpinsEvents::SHOWING_WIN_SUMMARY_SCREEN';
    FreeSpinsEvents.FREE_SPINS_CONTINUE_CLICKED = 'FreeSpinsEvents::FREE_SPINS_CONTINUE_CLICKED';
    FreeSpinsEvents.FREE_SPINS_OUTRO_CONTINUE_CLICKED = 'FreeSpinsEvents::FREE_SPINS_OUTRO_CONTINUE_CLICKED';
    FreeSpinsEvents.FREE_SPINS_RETRIGGER_STARTED = 'FreeSpinsEvents::FREE_SPINS_RETRIGGER_STARTED';
    FreeSpinsEvents.FREE_SPINS_RETRIGGER_FINISHED = 'FreeSpinsEvents::FREE_SPINS_RETRIGGER_FINISHED';
    FreeSpinsEvents.FREE_SPIN_STARTED = 'FreeSpinsEvents::FREE_SPIN_STARTED';
    FreeSpinsEvents.FREE_SPINS_INTRO_JINGLE_FINISHED = 'FreeSpinsEvents::FREE_SPINS_INTRO_JINGLE_FINISHED';
    return FreeSpinsEvents;
}());
exports.FreeSpinsEvents = FreeSpinsEvents;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.autoDetectRenderer = exports.Application = exports.Filter = exports.SpriteMaskFilter = exports.Quad = exports.RenderTarget = exports.ObjectRenderer = exports.WebGLManager = exports.Shader = exports.CanvasRenderTarget = exports.TextureUvs = exports.VideoBaseTexture = exports.BaseRenderTexture = exports.RenderTexture = exports.BaseTexture = exports.TextureMatrix = exports.Texture = exports.Spritesheet = exports.CanvasGraphicsRenderer = exports.GraphicsRenderer = exports.GraphicsData = exports.Graphics = exports.TextMetrics = exports.TextStyle = exports.Text = exports.SpriteRenderer = exports.CanvasTinter = exports.CanvasSpriteRenderer = exports.Sprite = exports.TransformBase = exports.TransformStatic = exports.Transform = exports.Container = exports.DisplayObject = exports.Bounds = exports.glCore = exports.WebGLRenderer = exports.CanvasRenderer = exports.ticker = exports.utils = exports.settings = undefined;

var _const = __webpack_require__(5);

Object.keys(_const).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _const[key];
    }
  });
});

var _math = __webpack_require__(20);

Object.keys(_math).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _math[key];
    }
  });
});

var _pixiGlCore = __webpack_require__(31);

Object.defineProperty(exports, 'glCore', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_pixiGlCore).default;
  }
});

var _Bounds = __webpack_require__(127);

Object.defineProperty(exports, 'Bounds', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Bounds).default;
  }
});

var _DisplayObject = __webpack_require__(181);

Object.defineProperty(exports, 'DisplayObject', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DisplayObject).default;
  }
});

var _Container = __webpack_require__(83);

Object.defineProperty(exports, 'Container', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Container).default;
  }
});

var _Transform = __webpack_require__(183);

Object.defineProperty(exports, 'Transform', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Transform).default;
  }
});

var _TransformStatic = __webpack_require__(182);

Object.defineProperty(exports, 'TransformStatic', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TransformStatic).default;
  }
});

var _TransformBase = __webpack_require__(129);

Object.defineProperty(exports, 'TransformBase', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TransformBase).default;
  }
});

var _Sprite = __webpack_require__(131);

Object.defineProperty(exports, 'Sprite', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Sprite).default;
  }
});

var _CanvasSpriteRenderer = __webpack_require__(368);

Object.defineProperty(exports, 'CanvasSpriteRenderer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CanvasSpriteRenderer).default;
  }
});

var _CanvasTinter = __webpack_require__(101);

Object.defineProperty(exports, 'CanvasTinter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CanvasTinter).default;
  }
});

var _SpriteRenderer = __webpack_require__(371);

Object.defineProperty(exports, 'SpriteRenderer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SpriteRenderer).default;
  }
});

var _Text = __webpack_require__(386);

Object.defineProperty(exports, 'Text', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Text).default;
  }
});

var _TextStyle = __webpack_require__(195);

Object.defineProperty(exports, 'TextStyle', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TextStyle).default;
  }
});

var _TextMetrics = __webpack_require__(196);

Object.defineProperty(exports, 'TextMetrics', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TextMetrics).default;
  }
});

var _Graphics = __webpack_require__(388);

Object.defineProperty(exports, 'Graphics', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Graphics).default;
  }
});

var _GraphicsData = __webpack_require__(197);

Object.defineProperty(exports, 'GraphicsData', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GraphicsData).default;
  }
});

var _GraphicsRenderer = __webpack_require__(390);

Object.defineProperty(exports, 'GraphicsRenderer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GraphicsRenderer).default;
  }
});

var _CanvasGraphicsRenderer = __webpack_require__(397);

Object.defineProperty(exports, 'CanvasGraphicsRenderer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CanvasGraphicsRenderer).default;
  }
});

var _Spritesheet = __webpack_require__(398);

Object.defineProperty(exports, 'Spritesheet', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Spritesheet).default;
  }
});

var _Texture = __webpack_require__(49);

Object.defineProperty(exports, 'Texture', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Texture).default;
  }
});

var _TextureMatrix = __webpack_require__(193);

Object.defineProperty(exports, 'TextureMatrix', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TextureMatrix).default;
  }
});

var _BaseTexture = __webpack_require__(68);

Object.defineProperty(exports, 'BaseTexture', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BaseTexture).default;
  }
});

var _RenderTexture = __webpack_require__(135);

Object.defineProperty(exports, 'RenderTexture', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RenderTexture).default;
  }
});

var _BaseRenderTexture = __webpack_require__(188);

Object.defineProperty(exports, 'BaseRenderTexture', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BaseRenderTexture).default;
  }
});

var _VideoBaseTexture = __webpack_require__(185);

Object.defineProperty(exports, 'VideoBaseTexture', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_VideoBaseTexture).default;
  }
});

var _TextureUvs = __webpack_require__(186);

Object.defineProperty(exports, 'TextureUvs', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TextureUvs).default;
  }
});

var _CanvasRenderTarget = __webpack_require__(189);

Object.defineProperty(exports, 'CanvasRenderTarget', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CanvasRenderTarget).default;
  }
});

var _Shader = __webpack_require__(86);

Object.defineProperty(exports, 'Shader', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Shader).default;
  }
});

var _WebGLManager = __webpack_require__(85);

Object.defineProperty(exports, 'WebGLManager', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_WebGLManager).default;
  }
});

var _ObjectRenderer = __webpack_require__(102);

Object.defineProperty(exports, 'ObjectRenderer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ObjectRenderer).default;
  }
});

var _RenderTarget = __webpack_require__(104);

Object.defineProperty(exports, 'RenderTarget', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RenderTarget).default;
  }
});

var _Quad = __webpack_require__(194);

Object.defineProperty(exports, 'Quad', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Quad).default;
  }
});

var _SpriteMaskFilter = __webpack_require__(191);

Object.defineProperty(exports, 'SpriteMaskFilter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SpriteMaskFilter).default;
  }
});

var _Filter = __webpack_require__(192);

Object.defineProperty(exports, 'Filter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Filter).default;
  }
});

var _Application = __webpack_require__(198);

Object.defineProperty(exports, 'Application', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Application).default;
  }
});

var _autoDetectRenderer = __webpack_require__(199);

Object.defineProperty(exports, 'autoDetectRenderer', {
  enumerable: true,
  get: function get() {
    return _autoDetectRenderer.autoDetectRenderer;
  }
});

var _utils = __webpack_require__(9);

var utils = _interopRequireWildcard(_utils);

var _ticker = __webpack_require__(134);

var ticker = _interopRequireWildcard(_ticker);

var _settings = __webpack_require__(17);

var _settings2 = _interopRequireDefault(_settings);

var _CanvasRenderer = __webpack_require__(84);

var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);

var _WebGLRenderer = __webpack_require__(103);

var _WebGLRenderer2 = _interopRequireDefault(_WebGLRenderer);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.settings = _settings2.default;
exports.utils = utils;
exports.ticker = ticker;
exports.CanvasRenderer = _CanvasRenderer2.default;
exports.WebGLRenderer = _WebGLRenderer2.default; /**
                                                  * @namespace PIXI
                                                  */
//# sourceMappingURL=index.js.map

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Views = /** @class */ (function () {
    function Views() {
    }
    Views.SPIN_BUTTON_VIEW = 'SpinButtonView';
    Views.SPIN_BUTTON_VIEW_MOBILE = 'SpinButtonViewMobile';
    Views.AVALANCHE_REELS_VIEW = 'AvalancheReelsView';
    Views.AVALANCHE_REELS_VIEW_MOBILE = 'AvalancheReelsViewMobile';
    Views.REELS_VIEW = 'ReelsView';
    Views.REELS_VIEW_MOBILE = 'ReelsViewMobile';
    Views.INDIVIDUAL_SYMBOLS_REELS_VIEW = 'IndividualSymbolReelsView';
    Views.INDIVIDUAL_SYMBOLS_REELS_VIEW_MOBILE = 'IndividualSymbolReelsViewMobile';
    Views.KEYPAD_INFO_ELEMENTS_VIEW = 'KeypadInfoElementsView';
    Views.KEYPAD_INFO_ELEMENTS_VIEW_MOBILE = 'KeypadInfoElementsViewMobile';
    Views.KEYPAD_CONTROLS_VIEW = 'KeypadControlsView';
    Views.KEYPAD_CONTROLS_VIEW_MOBILE = 'KeypadControlsViewMobile';
    Views.SWIPE_INTERACTION_VIEW = 'SwipeInteractionView';
    Views.SWIPE_INTERACTION_VIEW_MOBILE = 'SwipeInteractionViewMobile';
    Views.AUTOPLAY_VIEW = 'AutoplayView';
    Views.AUTOPLAY_VIEW_MOBILE = 'AutoplayViewMobile';
    Views.BET_LEVEL_MENU_VIEW = 'BetlevelMenuView';
    Views.BET_LEVEL_MENU_VIEW_MOBILE = 'BetlevelMenuViewMobile';
    Views.BET_VIEW = 'BetButtonView';
    Views.BET_VIEW_MOBILE = 'BetButtonViewMobile';
    Views.MENUBUTTON_VIEW = 'MenuButtonView';
    Views.MENUBUTTON_VIEW_MOBILE = 'MenuButtonViewMobile';
    Views.SOUND_POPUP_VIEW_MOBILE = 'SoundPopupViewMobile';
    Views.MAIN_MENU_VIEW = 'MainMenuView';
    Views.MAIN_MENU_VIEW_MOBILE = 'MainMenuViewMobile';
    Views.MENU_BAR_VIEW = 'MenuBarView';
    Views.MENU_BAR_VIEW_MOBILE = 'MenuBarViewMobile';
    Views.SETTINGS_VIEW = 'SettingsView';
    Views.SETTINGS_VIEW_MOBILE = 'SettingsViewMobile';
    Views.GAME_RULES_VIEW = 'GameRulesView';
    Views.GAME_RULES_VIEW_MOBILE = 'GameRulesViewMobile';
    Views.STARTSCREEN_VIEW = 'StartscreenView';
    Views.STARTSCREEN_VIEW_MOBILE = 'StartscreenViewMobile';
    Views.KEYPAD_VIEW = 'KeypadView';
    Views.KEYPAD_VIEW_MOBILE = 'KeypadViewMobile';
    Views.WIN_PRESENTATION_VIEW = 'WinPresentationView';
    Views.WIN_PRESENTATION_VIEW_MOBILE = 'WinPresentationViewMobile';
    Views.BIG_WIN_VIEW = 'BigWinView';
    Views.BIG_WIN_VIEW_MOBILE = 'BigWinViewMobile';
    Views.BONUS_VIEW = 'BonusView';
    Views.BONUS_VIEW_MOBILE = 'BonusViewMobile';
    Views.FREE_SPINS_INTRO_VIEW = 'FreeSpinsIntroView';
    Views.FREE_SPINS_INTRO_VIEW_MOBILE = 'FreeSpinsIntroViewMobile';
    Views.FREE_SPINS_OUTRO_VIEW = 'FreeSpinsOutroView';
    Views.FREE_SPINS_OUTRO_VIEW_MOBILE = 'FreeSpinsOutroViewMobile';
    Views.FREE_SPINS_RETRIGGER_VIEW = 'FreeSpinsRetriggerView';
    Views.FREE_SPINS_RETRIGGER_VIEW_MOBILE = 'FreeSpinsRetriggerViewMobile';
    Views.BACKGROUND_VIEW = 'BackgroundView';
    Views.BACKGROUND_VIEW_MOBILE = 'BackgroundViewMobileMobile';
    Views.AUTOPLAY_MENU_VIEW = 'AutoplayMenuView';
    Views.AUTOPLAY_MENU_VIEW_MOBILE = 'AutoplayMenuViewMobile';
    Views.ANTICIPATOR_VIEW = 'AnticipatorView';
    Views.ANTICIPATOR_VIEW_MOBILE = 'AnticipatorViewMobile';
    Views.FOREGROUND_VIEW = 'ForegroundView';
    Views.FOREGROUND_VIEW_MOBILE = 'ForegroundViewMobile';
    Views.PARTICLE_VIEW = 'ParticleView';
    Views.PARTICLE_VIEW_MOBILE = 'ParticleViewMobile';
    Views.CHEATS_VIEW = 'CheatsView';
    Views.CHEATS_VIEW_MOBILE = 'CheatsViewMobile';
    Views.STOP_AUTOPLAY_BUTTON_VIEW = 'StopAutoplayButtonView';
    Views.STOP_AUTOPLAY_BUTTON_VIEW_MOBILE = 'StopAutoplayButtonViewMobile';
    Views.ORIENTATION_NOTIFICATION_VIEW = 'OrientationNotificationView';
    Views.INFO_VIEW = 'InfoView';
    Views.INFO_VIEW_MOBILE = 'InfoViewMobile';
    Views.LOGOTYPE_VIEW = 'LogotypeView';
    Views.LOGOTYPE_VIEW_MOBILE = 'LogotypeViewMobile';
    Views.INFO_POPUP_VIEW = 'InfoPopupView';
    Views.INFO_POPUP_VIEW_MOBILE = 'InfoPopupViewMobile';
    Views.MICROGAMING_FREEROUNDS_VIEW = 'FreeRoundsScreenView';
    Views.MICROGAMING_FREEROUNDS_VIEW_MOBILE = 'FreeRoundsScreenViewMobile';
    Views.MICROGAMING_INFREEROUNDS_VIEW = 'InFreeRoundsScreenView';
    Views.MICROGAMING_INFREEROUNDS_VIEW_MOBILE = 'InFreeRoundsScreenViewMobile';
    Views.STATISTICS_WINDOW_VIEW = 'StatisticsWindowView';
    Views.STATISTICS_WINDOW_VIEW_MOBILE = 'StatisticsWindowViewMobile';
    Views.FREE_SPINS_INFO_VIEW = 'FreeSpinsInfoView';
    Views.FREE_SPINS_INFO_VIEW_MOBILE = 'FreeSpinsInfoViewMobile';
    Views.FREE_SPINS_VIEW = 'FreeSpinsView';
    Views.FREE_SPINS_VIEW_MOBILE = 'FreeSpinsViewMobile';
    Views.RELAX_FREEROUNDS_VIEW = 'RelaxFreeRoundsView';
    Views.RELAX_FREEROUNDS_INGAME_VIEW = 'RelaxInFreeRoundsView';
    Views.REEL_EFFECTS_VIEW = 'ReelEffectsView';
    Views.GAME_HISTORY_VIEW = 'GAME_HISTORY_VIEW';
    Views.RELAX_SCREEN_BLOCKER = 'RelaxScreenBlocker';
    return Views;
}());
exports.Views = Views;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.premultiplyBlendMode = exports.BaseTextureCache = exports.TextureCache = exports.earcut = exports.mixins = exports.pluginTarget = exports.EventEmitter = exports.removeItems = exports.isMobile = undefined;
exports.uid = uid;
exports.hex2rgb = hex2rgb;
exports.hex2string = hex2string;
exports.rgb2hex = rgb2hex;
exports.getResolutionOfUrl = getResolutionOfUrl;
exports.decomposeDataUri = decomposeDataUri;
exports.getUrlFileExtension = getUrlFileExtension;
exports.getSvgSize = getSvgSize;
exports.skipHello = skipHello;
exports.sayHello = sayHello;
exports.isWebGLSupported = isWebGLSupported;
exports.sign = sign;
exports.destroyTextureCache = destroyTextureCache;
exports.clearTextureCache = clearTextureCache;
exports.correctBlendMode = correctBlendMode;
exports.premultiplyTint = premultiplyTint;
exports.premultiplyRgba = premultiplyRgba;
exports.premultiplyTintToRgba = premultiplyTintToRgba;

var _const = __webpack_require__(5);

var _settings = __webpack_require__(17);

var _settings2 = _interopRequireDefault(_settings);

var _eventemitter = __webpack_require__(60);

var _eventemitter2 = _interopRequireDefault(_eventemitter);

var _pluginTarget = __webpack_require__(356);

var _pluginTarget2 = _interopRequireDefault(_pluginTarget);

var _mixin = __webpack_require__(357);

var mixins = _interopRequireWildcard(_mixin);

var _ismobilejs = __webpack_require__(128);

var isMobile = _interopRequireWildcard(_ismobilejs);

var _removeArrayItems = __webpack_require__(358);

var _removeArrayItems2 = _interopRequireDefault(_removeArrayItems);

var _mapPremultipliedBlendModes = __webpack_require__(359);

var _mapPremultipliedBlendModes2 = _interopRequireDefault(_mapPremultipliedBlendModes);

var _earcut = __webpack_require__(130);

var _earcut2 = _interopRequireDefault(_earcut);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var nextUid = 0;
var saidHello = false;

/**
 * Generalized convenience utilities for PIXI.
 * @example
 * // Extend PIXI's internal Event Emitter.
 * class MyEmitter extends PIXI.utils.EventEmitter {
 *   constructor() {
 *      super();
 *      console.log("Emitter created!");
 *   }
 * }
 *
 * // Get info on current device
 * console.log(PIXI.utils.isMobile);
 *
 * // Convert hex color to string
 * console.log(PIXI.utils.hex2string(0xff00ff)); // returns: "#ff00ff"
 * @namespace PIXI.utils
 */
exports.isMobile = isMobile;
exports.removeItems = _removeArrayItems2.default;
exports.EventEmitter = _eventemitter2.default;
exports.pluginTarget = _pluginTarget2.default;
exports.mixins = mixins;
exports.earcut = _earcut2.default;

/**
 * Gets the next unique identifier
 *
 * @memberof PIXI.utils
 * @function uid
 * @return {number} The next unique identifier to use.
 */

function uid() {
    return ++nextUid;
}

/**
 * Converts a hex color number to an [R, G, B] array
 *
 * @memberof PIXI.utils
 * @function hex2rgb
 * @param {number} hex - The number to convert
 * @param  {number[]} [out=[]] If supplied, this array will be used rather than returning a new one
 * @return {number[]} An array representing the [R, G, B] of the color.
 */
function hex2rgb(hex, out) {
    out = out || [];

    out[0] = (hex >> 16 & 0xFF) / 255;
    out[1] = (hex >> 8 & 0xFF) / 255;
    out[2] = (hex & 0xFF) / 255;

    return out;
}

/**
 * Converts a hex color number to a string.
 *
 * @memberof PIXI.utils
 * @function hex2string
 * @param {number} hex - Number in hex
 * @return {string} The string color.
 */
function hex2string(hex) {
    hex = hex.toString(16);
    hex = '000000'.substr(0, 6 - hex.length) + hex;

    return '#' + hex;
}

/**
 * Converts a color as an [R, G, B] array to a hex number
 *
 * @memberof PIXI.utils
 * @function rgb2hex
 * @param {number[]} rgb - rgb array
 * @return {number} The color number
 */
function rgb2hex(rgb) {
    return (rgb[0] * 255 << 16) + (rgb[1] * 255 << 8) + (rgb[2] * 255 | 0);
}

/**
 * get the resolution / device pixel ratio of an asset by looking for the prefix
 * used by spritesheets and image urls
 *
 * @memberof PIXI.utils
 * @function getResolutionOfUrl
 * @param {string} url - the image path
 * @param {number} [defaultValue=1] - the defaultValue if no filename prefix is set.
 * @return {number} resolution / device pixel ratio of an asset
 */
function getResolutionOfUrl(url, defaultValue) {
    var resolution = _settings2.default.RETINA_PREFIX.exec(url);

    if (resolution) {
        return parseFloat(resolution[1]);
    }

    return defaultValue !== undefined ? defaultValue : 1;
}

/**
 * Typedef for decomposeDataUri return object.
 *
 * @typedef {object} PIXI.utils~DecomposedDataUri
 * @property {mediaType} Media type, eg. `image`
 * @property {subType} Sub type, eg. `png`
 * @property {encoding} Data encoding, eg. `base64`
 * @property {data} The actual data
 */

/**
 * Split a data URI into components. Returns undefined if
 * parameter `dataUri` is not a valid data URI.
 *
 * @memberof PIXI.utils
 * @function decomposeDataUri
 * @param {string} dataUri - the data URI to check
 * @return {PIXI.utils~DecomposedDataUri|undefined} The decomposed data uri or undefined
 */
function decomposeDataUri(dataUri) {
    var dataUriMatch = _const.DATA_URI.exec(dataUri);

    if (dataUriMatch) {
        return {
            mediaType: dataUriMatch[1] ? dataUriMatch[1].toLowerCase() : undefined,
            subType: dataUriMatch[2] ? dataUriMatch[2].toLowerCase() : undefined,
            charset: dataUriMatch[3] ? dataUriMatch[3].toLowerCase() : undefined,
            encoding: dataUriMatch[4] ? dataUriMatch[4].toLowerCase() : undefined,
            data: dataUriMatch[5]
        };
    }

    return undefined;
}

/**
 * Get type of the image by regexp for extension. Returns undefined for unknown extensions.
 *
 * @memberof PIXI.utils
 * @function getUrlFileExtension
 * @param {string} url - the image path
 * @return {string|undefined} image extension
 */
function getUrlFileExtension(url) {
    var extension = _const.URL_FILE_EXTENSION.exec(url);

    if (extension) {
        return extension[1].toLowerCase();
    }

    return undefined;
}

/**
 * Typedef for Size object.
 *
 * @typedef {object} PIXI.utils~Size
 * @property {width} Width component
 * @property {height} Height component
 */

/**
 * Get size from an svg string using regexp.
 *
 * @memberof PIXI.utils
 * @function getSvgSize
 * @param {string} svgString - a serialized svg element
 * @return {PIXI.utils~Size|undefined} image extension
 */
function getSvgSize(svgString) {
    var sizeMatch = _const.SVG_SIZE.exec(svgString);
    var size = {};

    if (sizeMatch) {
        size[sizeMatch[1]] = Math.round(parseFloat(sizeMatch[3]));
        size[sizeMatch[5]] = Math.round(parseFloat(sizeMatch[7]));
    }

    return size;
}

/**
 * Skips the hello message of renderers that are created after this is run.
 *
 * @function skipHello
 * @memberof PIXI.utils
 */
function skipHello() {
    saidHello = true;
}

/**
 * Logs out the version and renderer information for this running instance of PIXI.
 * If you don't want to see this message you can run `PIXI.utils.skipHello()` before
 * creating your renderer. Keep in mind that doing that will forever makes you a jerk face.
 *
 * @static
 * @function sayHello
 * @memberof PIXI.utils
 * @param {string} type - The string renderer type to log.
 */
function sayHello(type) {
    if (saidHello) {
        return;
    }

    if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
        var args = ['\n %c %c %c PixiJS ' + _const.VERSION + ' - \u2730 ' + type + ' \u2730  %c  %c  http://www.pixijs.com/  %c %c \u2665%c\u2665%c\u2665 \n\n', 'background: #ff66a5; padding:5px 0;', 'background: #ff66a5; padding:5px 0;', 'color: #ff66a5; background: #030307; padding:5px 0;', 'background: #ff66a5; padding:5px 0;', 'background: #ffc3dc; padding:5px 0;', 'background: #ff66a5; padding:5px 0;', 'color: #ff2424; background: #fff; padding:5px 0;', 'color: #ff2424; background: #fff; padding:5px 0;', 'color: #ff2424; background: #fff; padding:5px 0;'];

        window.console.log.apply(console, args);
    } else if (window.console) {
        window.console.log('PixiJS ' + _const.VERSION + ' - ' + type + ' - http://www.pixijs.com/');
    }

    saidHello = true;
}

/**
 * Helper for checking for webgl support
 *
 * @memberof PIXI.utils
 * @function isWebGLSupported
 * @return {boolean} is webgl supported
 */
function isWebGLSupported() {
    var contextOptions = { stencil: true, failIfMajorPerformanceCaveat: true };

    try {
        if (!window.WebGLRenderingContext) {
            return false;
        }

        var canvas = document.createElement('canvas');
        var gl = canvas.getContext('webgl', contextOptions) || canvas.getContext('experimental-webgl', contextOptions);

        var success = !!(gl && gl.getContextAttributes().stencil);

        if (gl) {
            var loseContext = gl.getExtension('WEBGL_lose_context');

            if (loseContext) {
                loseContext.loseContext();
            }
        }

        gl = null;

        return success;
    } catch (e) {
        return false;
    }
}

/**
 * Returns sign of number
 *
 * @memberof PIXI.utils
 * @function sign
 * @param {number} n - the number to check the sign of
 * @returns {number} 0 if `n` is 0, -1 if `n` is negative, 1 if `n` is positive
 */
function sign(n) {
    if (n === 0) return 0;

    return n < 0 ? -1 : 1;
}

/**
 * @todo Describe property usage
 *
 * @memberof PIXI.utils
 * @private
 */
var TextureCache = exports.TextureCache = Object.create(null);

/**
 * @todo Describe property usage
 *
 * @memberof PIXI.utils
 * @private
 */
var BaseTextureCache = exports.BaseTextureCache = Object.create(null);

/**
 * Destroys all texture in the cache
 *
 * @memberof PIXI.utils
 * @function destroyTextureCache
 */
function destroyTextureCache() {
    var key = void 0;

    for (key in TextureCache) {
        TextureCache[key].destroy();
    }
    for (key in BaseTextureCache) {
        BaseTextureCache[key].destroy();
    }
}

/**
 * Removes all textures from cache, but does not destroy them
 *
 * @memberof PIXI.utils
 * @function clearTextureCache
 */
function clearTextureCache() {
    var key = void 0;

    for (key in TextureCache) {
        delete TextureCache[key];
    }
    for (key in BaseTextureCache) {
        delete BaseTextureCache[key];
    }
}

/**
 * maps premultiply flag and blendMode to adjusted blendMode
 * @memberof PIXI.utils
 * @const premultiplyBlendMode
 * @type {Array<number[]>}
 */
var premultiplyBlendMode = exports.premultiplyBlendMode = (0, _mapPremultipliedBlendModes2.default)();

/**
 * changes blendMode according to texture format
 *
 * @memberof PIXI.utils
 * @function correctBlendMode
 * @param {number} blendMode supposed blend mode
 * @param {boolean} premultiplied  whether source is premultiplied
 * @returns {number} true blend mode for this texture
 */
function correctBlendMode(blendMode, premultiplied) {
    return premultiplyBlendMode[premultiplied ? 1 : 0][blendMode];
}

/**
 * premultiplies tint
 *
 * @memberof PIXI.utils
 * @param {number} tint integet RGB
 * @param {number} alpha floating point alpha (0.0-1.0)
 * @returns {number} tint multiplied by alpha
 */
function premultiplyTint(tint, alpha) {
    if (alpha === 1.0) {
        return (alpha * 255 << 24) + tint;
    }
    if (alpha === 0.0) {
        return 0;
    }
    var R = tint >> 16 & 0xFF;
    var G = tint >> 8 & 0xFF;
    var B = tint & 0xFF;

    R = R * alpha + 0.5 | 0;
    G = G * alpha + 0.5 | 0;
    B = B * alpha + 0.5 | 0;

    return (alpha * 255 << 24) + (R << 16) + (G << 8) + B;
}

/**
 * combines rgb and alpha to out array
 *
 * @memberof PIXI.utils
 * @param {Float32Array|number[]} rgb input rgb
 * @param {number} alpha alpha param
 * @param {Float32Array} [out] output
 * @param {boolean} [premultiply=true] do premultiply it
 * @returns {Float32Array} vec4 rgba
 */
function premultiplyRgba(rgb, alpha, out, premultiply) {
    out = out || new Float32Array(4);
    if (premultiply || premultiply === undefined) {
        out[0] = rgb[0] * alpha;
        out[1] = rgb[1] * alpha;
        out[2] = rgb[2] * alpha;
    } else {
        out[0] = rgb[0];
        out[1] = rgb[1];
        out[2] = rgb[2];
    }
    out[3] = alpha;

    return out;
}

/**
 * converts integer tint and float alpha to vec4 form, premultiplies by default
 *
 * @memberof PIXI.utils
 * @param {number} tint input tint
 * @param {number} alpha alpha param
 * @param {Float32Array} [out] output
 * @param {boolean} [premultiply=true] do premultiply it
 * @returns {Float32Array} vec4 rgba
 */
function premultiplyTintToRgba(tint, alpha, out, premultiply) {
    out = out || new Float32Array(4);
    out[0] = (tint >> 16 & 0xFF) / 255.0;
    out[1] = (tint >> 8 & 0xFF) / 255.0;
    out[2] = (tint & 0xFF) / 255.0;
    if (premultiply || premultiply === undefined) {
        out[0] *= alpha;
        out[1] *= alpha;
        out[2] *= alpha;
    }
    out[3] = alpha;

    return out;
}
//# sourceMappingURL=index.js.map

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var PositionUtils = /** @class */ (function () {
    function PositionUtils() {
    }
    PositionUtils.isEqual = function (pos1, pos2) {
        if (!pos1 || !pos2) {
            return false;
        }
        return pos1.x === pos2.x && pos1.y === pos2.y;
    };
    return PositionUtils;
}());
exports.PositionUtils = PositionUtils;
var ReelConstants = /** @class */ (function () {
    function ReelConstants() {
    }
    ReelConstants.setReelsAmount = function (reels) {
        ReelConstants.REELS_AMOUNT = reels;
    };
    ReelConstants.setRowAmount = function (rows) {
        ReelConstants.ROW_AMOUNT = rows;
    };
    ReelConstants.setMaxRowAmount = function (rows) {
        ReelConstants.MAX_ROW_AMOUNT = rows;
    };
    ReelConstants.addReelsConfig = function (config, viewType) {
        if (viewType === void 0) { viewType = ReelConstants.DEFAULT_VIEW; }
        ReelConstants.REELS[viewType].push(config);
    };
    ReelConstants.recalculateNumbers = function (viewType) {
        if (viewType === void 0) { viewType = ReelConstants.DEFAULT_VIEW; }
        ReelConstants.REELS_CENTER[viewType] = {
            x: ReelConstants.REELS_OFFSETS[viewType].x + (ReelConstants.SYMBOL_SLOT[viewType].width * ReelConstants.REELS_AMOUNT) / 2,
            y: ReelConstants.REELS_OFFSETS[viewType].y + (ReelConstants.SYMBOL_SLOT[viewType].height * ReelConstants.ROW_AMOUNT) / 2,
        };
    };
    ReelConstants.initializeFromLayout = function (layout, viewType) {
        if (viewType === void 0) { viewType = ReelConstants.DEFAULT_VIEW; }
        var reelPosition = layout.getAbsolutePosition('REEL', viewType);
        var symbolSize = layout.getSize('SYMBOL_01', viewType);
        ReelConstants.REELS_OFFSETS[viewType] = { x: reelPosition.x, y: reelPosition.y };
        ReelConstants.SYMBOL_SLOT[viewType] = { width: symbolSize.width, height: symbolSize.height };
        ReelConstants.recalculateNumbers();
    };
    ReelConstants.getReelsOffsets = function (viewType) {
        if (viewType === void 0) { viewType = ReelConstants.DEFAULT_VIEW; }
        return ReelConstants.REELS_OFFSETS[viewType];
    };
    ReelConstants.getSymbolSlot = function (viewType) {
        if (viewType === void 0) { viewType = ReelConstants.DEFAULT_VIEW; }
        return ReelConstants.SYMBOL_SLOT[viewType];
    };
    ReelConstants.getReelsPositionConfig = function (viewType) {
        if (viewType === void 0) { viewType = ReelConstants.DEFAULT_VIEW; }
        return ReelConstants.REELS[viewType];
    };
    ReelConstants.getReelsCenter = function (viewType) {
        if (viewType === void 0) { viewType = ReelConstants.DEFAULT_VIEW; }
        return ReelConstants.REELS_CENTER[viewType];
    };
    ReelConstants.getReels = function (viewType) {
        if (viewType === void 0) { viewType = ReelConstants.DEFAULT_VIEW; }
        return ReelConstants.REELS[viewType];
    };
    ReelConstants.getSymbolPosition = function (position, viewType) {
        if (viewType === void 0) { viewType = ReelConstants.DEFAULT_VIEW; }
        var positionOnScreen = {
            x: ReelConstants.getReelsOffsets(viewType).x +
                ReelConstants.getSymbolSlot(viewType).width * position.x +
                ReelConstants.getSymbolSlot(viewType).width / 2,
            y: ReelConstants.getReelsOffsets(viewType).y +
                ReelConstants.getSymbolSlot(viewType).height * position.y +
                ReelConstants.getSymbolSlot(viewType).height / 2,
        };
        return positionOnScreen;
    };
    ReelConstants.FIRST_VISIBLE_ROW = 2;
    ReelConstants.FIRST_VISIBLE_ROW_ON_STOP = 1;
    ReelConstants.REELS_AMOUNT = 6;
    ReelConstants.ROW_AMOUNT = 6;
    ReelConstants.MAX_ROW_AMOUNT = 6;
    ReelConstants.LINES = 0;
    ReelConstants.BOTH_WAYS = false;
    ReelConstants.DEFAULT_VIEW = 0;
    ReelConstants.REELS_OFFSETS = [];
    ReelConstants.SYMBOL_SLOT = [];
    ReelConstants.REELS = [];
    ReelConstants.REELS_CENTER = [];
    return ReelConstants;
}());
exports.ReelConstants = ReelConstants;
var AvalancheConstants = /** @class */ (function () {
    function AvalancheConstants() {
    }
    AvalancheConstants.TIMER_BETWEEN_REELS_OUT = 45;
    AvalancheConstants.TIMER_BETWEEN_SYMBOLS_OUT = 17;
    AvalancheConstants.TIMER_BETWEEN_REELS_NEW = 100;
    AvalancheConstants.TIMER_BETWEEN_SYMBOLS_NEW = 17;
    AvalancheConstants.AVALANCHE_OUT_TIMER = 320;
    AvalancheConstants.AVALANCHE_NEW_TIMER = 270;
    AvalancheConstants.AVALANCHE_REPOSITION_TIMER = 450;
    return AvalancheConstants;
}());
exports.AvalancheConstants = AvalancheConstants;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LogicEvents = /** @class */ (function () {
    function LogicEvents() {
    }
    LogicEvents.INIT_RESPONSE = 'LogicEvents::INIT_RESPONSE';
    LogicEvents.SPIN_RESPONSE = 'LogicEvents::SPIN_RESPONSE';
    LogicEvents.FREE_SPIN_RESPONSE = 'LogicEvents::FREE_SPIN_RESPONSE';
    LogicEvents.RESPIN_RESPONSE = 'LogicEvents::RESPIN_RESPONSE';
    LogicEvents.AVALANCHE_RESPONSE = 'LogicEvents::AVALANCHE_RESPONSE';
    LogicEvents.PICK_RESPONSE = 'LogicEvents::PICK_RESPONSE';
    LogicEvents.SKIPPICK_RESPONSE = 'LogicEvents::SKIPPICK_RESPONSE';
    LogicEvents.SELECT_RESPONSE = 'LogicEvents::SELECT_RESPONSE';
    LogicEvents.PING_RESPONSE = 'LogicEvents::PING_RESPONSE';
    LogicEvents.ERROR_RESPONSE = 'LogicEvents::ERROR_RESPONSE';
    return LogicEvents;
}());
exports.LogicEvents = LogicEvents;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SpinButtonEvents = /** @class */ (function () {
    function SpinButtonEvents() {
    }
    SpinButtonEvents.PRE_SPIN_BUTTON_PRESSED = 'SpinButtonEvents::PRE_SPIN_BUTTON_PRESSED';
    SpinButtonEvents.SPIN_BUTTON_PRESSED = 'SpinButtonEvents::__SPIN_BUTTON_PRESSED__';
    SpinButtonEvents.QUICKSTOP_PRESSED = 'SpinButtonEvents::__QUICKSTOP_PRESSED__';
    SpinButtonEvents.SPIN_BUTTON_HOLD = 'SpinButtonEvents::__SPIN_BUTTON_HOLD__';
    SpinButtonEvents.START_AUTOPLAY_BUTTON_PRESSED = 'SpinButtonEvents::START_AUTOPLAY_BUTTON_PRESSED';
    SpinButtonEvents.STOP_AUTOPLAY_BUTTON_PRESSED = 'SpinButtonEvents::__STOP_AUTOPLAY_BUTTON_PRESSED__';
    SpinButtonEvents.SPIN_PRESSED_NOT_ENOUGH_MONEY = 'SpinButtonEvents::__SPIN_PRESSED_NOT_ENOUGH_MONEY__';
    SpinButtonEvents.SPACE_BUTTON_CLICKED = 'SpinButtonEvents::__SPACE_BUTTON_CLICKED__';
    SpinButtonEvents.SPIN_BUTTON_BECOMING_VISIBLE_AND_ENABLED = 'SpinButtonEvents::SPIN_BUTTON_BECOMING_VISIBLE_AND_ENABLED';
    SpinButtonEvents.REGULATION_SPIN_DELAY_PASSED = 'SpinButtonEvents::REGULATION_SPIN_DELAY_PASSED';
    SpinButtonEvents.REGULATION_SPIN_DELAY_STARTED = 'SpinButtonEvents::REGULATION_SPIN_DELAY_STARTED';
    SpinButtonEvents.DISABLE_SPIN_BY_SPIN = 'SpinButtonEvents::DISABLE_SPIN_BY_SPIN';
    SpinButtonEvents.ENABLE_SPIN_BY_SPIN = 'SpinButtonEvents::ENABLE_SPIN_BY_SPIN';
    SpinButtonEvents.SKIP_BY_SPIN_BUTTON_PRESSED = 'SpinButtonEvents::SKIP_BY_SPIN_BUTTON_PRESSED';
    SpinButtonEvents.SPIN_BUTTON_PHYSICALLY_CLICKED = 'SpinButtonEvents::SPIN_BUTTON_PHYSICALLY_CLICKED';
    SpinButtonEvents.SPIN_BUTTON_SPACE_PHYSICALLY_CLICKED = 'SpinButtonEvents::SPIN_BUTTON_SPACE_PHYSICALLY_CLICKED';
    return SpinButtonEvents;
}());
exports.SpinButtonEvents = SpinButtonEvents;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var WinPresentationEvents = /** @class */ (function () {
    function WinPresentationEvents() {
    }
    WinPresentationEvents.INITIAL_ANIMATION_STARTED = 'WinPresentationEvents::__INITIAL_ANIMATION_STARTED__';
    WinPresentationEvents.INDIVIDUAL_ANIMATION_STARTED = 'WinPresentationEvents::__INDIVIDUAL_ANIMATION_STARTED__';
    WinPresentationEvents.INITIAL_ANIMATION_FINISHED = 'WinPresentationEvents::__INITIAL_ANIMATION_FINISHED__';
    WinPresentationEvents.INITIAL_ANIMATION_SKIPPED = 'WinPresentationEvents::__INITIAL_ANIMATION_SKIPPED__';
    WinPresentationEvents.INDIVIDUAL_ANIMATION_SKIPPED = 'WinPresentationEvents::__INDIVIDUAL_ANIMATION_SKIPPED__';
    WinPresentationEvents.INDIVIDUAL_ANIMATION_FINISHED = 'WinPresentationEvents::__INDIVIDUAL_ANIMATION_FINISHED__';
    WinPresentationEvents.COUNTUP_STARTED = 'WinPresentationEvents::COUNTUP_STARTED';
    WinPresentationEvents.COUNTUP_FINISHED = 'WinPresentationEvents::COUNTUP_FINISHED';
    WinPresentationEvents.WIN_NUMBER_SHOWN_TO_PLAYER = 'WinPresentationEvents::WIN_NUMBER_SHOWN_TO_PLAYER';
    WinPresentationEvents.WIN_NUMBER_BOUNCE_FINISHED = 'WinPresentationEvents::WIN_NUMBER_BOUNCE_FINISHED';
    WinPresentationEvents.INITIAL_WIN_ANIMATION_FINISHED = 'WinPresentationEvents::INITIAL_WIN_ANIMATION_FINISHED';
    WinPresentationEvents.WIN_ANIMATION_FOR_SYMBOL_STARTED = 'WinPresentationEvents::__WIN_ANIMATION_FOR_SYMBOL_STARTED__';
    WinPresentationEvents.PLAYING_INDIVIDUAL_WIN_FOR_LINE = 'WinPresentationEvents::__PLAYING_INDIVIDUAL_WIN_FOR_LINE__';
    return WinPresentationEvents;
}());
exports.WinPresentationEvents = WinPresentationEvents;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var keys = __webpack_require__(18);
exports.METADATA_KEY = keys;
var container_1 = __webpack_require__(444);
exports.Container = container_1.Container;
var literal_types_1 = __webpack_require__(47);
exports.BindingScopeEnum = literal_types_1.BindingScopeEnum;
exports.BindingTypeEnum = literal_types_1.BindingTypeEnum;
exports.TargetTypeEnum = literal_types_1.TargetTypeEnum;
var container_module_1 = __webpack_require__(460);
exports.AsyncContainerModule = container_module_1.AsyncContainerModule;
exports.ContainerModule = container_module_1.ContainerModule;
var injectable_1 = __webpack_require__(461);
exports.injectable = injectable_1.injectable;
var tagged_1 = __webpack_require__(462);
exports.tagged = tagged_1.tagged;
var named_1 = __webpack_require__(463);
exports.named = named_1.named;
var inject_1 = __webpack_require__(225);
exports.inject = inject_1.inject;
exports.LazyServiceIdentifer = inject_1.LazyServiceIdentifer;
var optional_1 = __webpack_require__(464);
exports.optional = optional_1.optional;
var unmanaged_1 = __webpack_require__(465);
exports.unmanaged = unmanaged_1.unmanaged;
var multi_inject_1 = __webpack_require__(466);
exports.multiInject = multi_inject_1.multiInject;
var target_name_1 = __webpack_require__(467);
exports.targetName = target_name_1.targetName;
var post_construct_1 = __webpack_require__(468);
exports.postConstruct = post_construct_1.postConstruct;
var metadata_reader_1 = __webpack_require__(223);
exports.MetadataReader = metadata_reader_1.MetadataReader;
var guid_1 = __webpack_require__(61);
exports.guid = guid_1.guid;
var decorator_utils_1 = __webpack_require__(53);
exports.decorate = decorator_utils_1.decorate;
var constraint_helpers_1 = __webpack_require__(228);
exports.traverseAncerstors = constraint_helpers_1.traverseAncerstors;
exports.taggedConstraint = constraint_helpers_1.taggedConstraint;
exports.namedConstraint = constraint_helpers_1.namedConstraint;
exports.typeConstraint = constraint_helpers_1.typeConstraint;
var serialization_1 = __webpack_require__(89);
exports.getServiceIdentifierAsString = serialization_1.getServiceIdentifierAsString;
var binding_utils_1 = __webpack_require__(469);
exports.multiBindToService = binding_utils_1.multiBindToService;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AvalancheReelsEvents = /** @class */ (function () {
    function AvalancheReelsEvents() {
    }
    AvalancheReelsEvents.REEL_DROP_OUT_FINISHED = 'AvalancheReelsEvents::__REEL_DROP_OUT_FINISHED__';
    AvalancheReelsEvents.ALL_REELS_DROP_OUT_FINISHED = 'AvalancheReelsEvents::__ALL_REELS_DROP_OUT_FINISHED__';
    AvalancheReelsEvents.REEL_DROP_NEW_FINISHED = 'AvalancheReelsEvents::__REEL_DROP_NEW_FINISHED__';
    AvalancheReelsEvents.ALL_REELS_DROP_NEW_FINISHED = 'AvalancheReelsEvents::__ALL_REELS_DROP_NEW_FINISHED__';
    AvalancheReelsEvents.ALL_REELS_DROP_NEW_STARTED = 'AvalancheReelsEvents::__ALL_REELS_DROP_NEW_STARTED__';
    AvalancheReelsEvents.FILLING_VOIDS_FINISHED = 'AvalancheReelsEvents::__FILLING_VOIDS_FINISHED__';
    AvalancheReelsEvents.REMOVING_AVALANCE_SYMBOLS_STARTED = 'AvalancheReelsEvents::__REMOVING_AVALANCE_SYMBOLS_STARTED__';
    AvalancheReelsEvents.REMOVING_WIN_FINISHED = 'AvalancheReelsEvents::__REMOVING_WIN_FINISHED__';
    AvalancheReelsEvents.ADDING_NEW_FINISHED = 'AvalancheReelsEvents::__ADDING_NEW_FINISHED__';
    AvalancheReelsEvents.AVALANCHE_FINISHED = 'AvalancheReelsEvents::__AVALANCHE_FINISHED__';
    AvalancheReelsEvents.SYMBOLS_RESPIN_STARTED = 'AvalancheReelsEvents::__SYMBOLS_RESPIN_STARTED__';
    AvalancheReelsEvents.SYMBOLS_RESPIN_FINISHED = 'AvalancheReelsEvents::__SYMBOLS_RESPIN_FINISHED__';
    AvalancheReelsEvents.RESPIN_REMOVING_SYMBOLS_FINISHED = 'AvalancheReelsEvents::RESPIN_REMOVING_SYMBOLS_FINISHED';
    AvalancheReelsEvents.REELS_FADING_OUT_FINISHED = 'AvalancheReelsEvents::REELS_FADING_OUT_FINISHED';
    AvalancheReelsEvents.REELS_FADING_IN_FINISHED = 'AvalancheReelsEvents::REELS_FADING_IN_FINISHED';
    AvalancheReelsEvents.REELS_FADING_OUT_STARTED = 'AvalancheReelsEvents::REELS_FADING_OUT_STARTED';
    AvalancheReelsEvents.REELS_FADING_IN_STARTED = 'AvalancheReelsEvents::REELS_FADING_IN_STARTED';
    return AvalancheReelsEvents;
}());
exports.AvalancheReelsEvents = AvalancheReelsEvents;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Easing = {
    Linear: {
        None: function (k) { return k; },
    },
    Quadratic: {
        In: function (k) { return k * k; },
        Out: function (k) { return k * (2 - k); },
        InOut: function (k) {
            if ((k *= 2) < 1) {
                return 0.5 * k * k;
            }
            return -0.5 * (--k * (k - 2) - 1);
        },
    },
    Cubic: {
        In: function (k) { return k * k * k; },
        Out: function (k) { return --k * k * k + 1; },
        InOut: function (k) {
            if ((k *= 2) < 1) {
                return 0.5 * k * k * k;
            }
            return 0.5 * ((k -= 2) * k * k + 2);
        },
    },
    InverseCubic: {
        In: function (k) { return --k * k * k + 1; },
        Out: function (k) { return k * k * k; },
        InOut: function (k) {
            if ((k *= 2) < 1) {
                return 0.5 * ((k -= 2) * k * k + 2);
            }
            return 0.5 * k * k * k;
        },
    },
    Quartic: {
        In: function (k) { return k * k * k * k; },
        Out: function (k) { return 1 - --k * k * k * k; },
        InOut: function (k) {
            if ((k *= 2) < 1) {
                return 0.5 * k * k * k * k;
            }
            return -0.5 * ((k -= 2) * k * k * k - 2);
        },
    },
    Quintic: {
        In: function (k) { return k * k * k * k * k; },
        Out: function (k) { return --k * k * k * k * k + 1; },
        InOut: function (k) {
            if ((k *= 2) < 1) {
                return 0.5 * k * k * k * k * k;
            }
            return 0.5 * ((k -= 2) * k * k * k * k + 2);
        },
    },
    Sinusoidal: {
        In: function (k) { return 1 - Math.cos((k * Math.PI) / 2); },
        Out: function (k) { return Math.sin((k * Math.PI) / 2); },
        InOut: function (k) { return 0.5 * (1 - Math.cos(Math.PI * k)); },
    },
    Exponential: {
        In: function (k) { return (k === 0 ? 0 : Math.pow(1024, k - 1)); },
        Out: function (k) { return (k === 1 ? 1 : 1 - Math.pow(2, -10 * k)); },
        InOut: function (k) {
            if (k === 0) {
                return 0;
            }
            if (k === 1) {
                return 1;
            }
            if ((k *= 2) < 1) {
                return 0.5 * Math.pow(1024, k - 1);
            }
            return 0.5 * (-Math.pow(2, -10 * (k - 1)) + 2);
        },
    },
    Circular: {
        In: function (k) { return 1 - Math.sqrt(1 - k * k); },
        Out: function (k) { return Math.sqrt(1 - --k * k); },
        InOut: function (k) {
            if ((k *= 2) < 1) {
                return -0.5 * (Math.sqrt(1 - k * k) - 1);
            }
            return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);
        },
    },
    Elastic: {
        In: function (k) {
            if (k === 0) {
                return 0;
            }
            if (k === 1) {
                return 1;
            }
            return -Math.pow(2, 10 * (k - 1)) * Math.sin((k - 1.1) * 5 * Math.PI);
        },
        Out: function (k) {
            if (k === 0) {
                return 0;
            }
            if (k === 1) {
                return 1;
            }
            return Math.pow(2, -10 * k) * Math.sin((k - 0.1) * 5 * Math.PI) + 1;
        },
        InOut: function (k) {
            if (k === 0) {
                return 0;
            }
            if (k === 1) {
                return 1;
            }
            k *= 2;
            if (k < 1) {
                return -0.5 * Math.pow(2, 10 * (k - 1)) * Math.sin((k - 1.1) * 5 * Math.PI);
            }
            return 0.5 * Math.pow(2, -10 * (k - 1)) * Math.sin((k - 1.1) * 5 * Math.PI) + 1;
        },
    },
    Back: {
        In: function (k) {
            var s = 1.70158;
            return k * k * ((s + 1) * k - s);
        },
        Out: function (k) {
            var s = 1.70158;
            return --k * k * ((s + 1) * k + s) + 1;
        },
        InOut: function (k) {
            var s = 1.70158 * 1.525;
            if ((k *= 2) < 1) {
                return 0.5 * (k * k * ((s + 1) * k - s));
            }
            return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
        },
    },
    Bounce: {
        In: function (k) { return 1 - exports.Easing.Bounce.Out(1 - k); },
        Out: function (k) {
            if (k < 1 / 2.75) {
                return 7.5625 * k * k;
            }
            else if (k < 2 / 2.75) {
                return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
            }
            else if (k < 2.5 / 2.75) {
                return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
            }
            else {
                return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984375;
            }
        },
        InOut: function (k) {
            if (k < 0.5) {
                return exports.Easing.Bounce.In(k * 2) * 0.5;
            }
            return exports.Easing.Bounce.Out(k * 2 - 1) * 0.5 + 0.5;
        },
    },
    SingleBounce: {
        In: function (k) { return 1 - exports.Easing.Bounce.Out(1 - k); },
        Out: function (k) {
            if (k < 1.75 / 2.75) {
                return 2.469387 * k * k;
            }
            else {
                return 2.469387 * (k -= 2.25 / 2.75) * k + 0.91836738;
            }
        },
        InOut: function (k) {
            if (k < 0.5) {
                return exports.Easing.Bounce.In(k * 2) * 0.5;
            }
            return exports.Easing.Bounce.Out(k * 2 - 1) * 0.5 + 0.5;
        },
    },
};
var Bezier = /** @class */ (function () {
    function Bezier() {
    }
    Bezier.A = function (aA1, aA2) {
        return 1.0 - 3.0 * aA2 + 3.0 * aA1;
    };
    Bezier.B = function (aA1, aA2) {
        return 3.0 * aA2 - 6.0 * aA1;
    };
    Bezier.C = function (aA1) {
        return 3.0 * aA1;
    };
    // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
    Bezier.calcBezier = function (aT, aA1, aA2) {
        return ((Bezier.A(aA1, aA2) * aT + Bezier.B(aA1, aA2)) * aT + Bezier.C(aA1)) * aT;
    };
    // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
    Bezier.getSlope = function (aT, aA1, aA2) {
        return 3.0 * Bezier.A(aA1, aA2) * aT * aT + 2.0 * Bezier.B(aA1, aA2) * aT + Bezier.C(aA1);
    };
    Bezier.binarySubdivide = function (aX, aA, aB, mX1, mX2) {
        var currentX = 0;
        var currentT = 0;
        var i = 0;
        do {
            currentT = aA + (aB - aA) / 2.0;
            currentX = Bezier.calcBezier(currentT, mX1, mX2) - aX;
            if (currentX > 0.0) {
                aB = currentT;
            }
            else {
                aA = currentT;
            }
        } while (Math.abs(currentX) > Bezier.SUBDIVISION_PRECISION && ++i < Bezier.SUBDIVISION_MAX_ITERATIONS);
        return currentT;
    };
    Bezier.newtonRaphsonIterate = function (aX, aGuessT, mX1, mX2) {
        for (var i = 0; i < Bezier.NEWTON_ITERATIONS; ++i) {
            var currentSlope = Bezier.getSlope(aGuessT, mX1, mX2);
            if (currentSlope === 0.0) {
                return aGuessT;
            }
            var currentX = Bezier.calcBezier(aGuessT, mX1, mX2) - aX;
            aGuessT -= currentX / currentSlope;
        }
        return aGuessT;
    };
    Bezier.LinearEasing = function (x) {
        return x;
    };
    Bezier.bezier = function (mX1, mY1, mX2, mY2) {
        if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) {
            throw new Error('bezier x values must be in [0, 1] range');
        }
        if (mX1 === mY1 && mX2 === mY2) {
            return Bezier.LinearEasing;
        }
        // Precompute samples table
        var sampleValues = Bezier.float32ArraySupported ? new Float32Array(Bezier.kSplineTableSize) : new Array(Bezier.kSplineTableSize);
        for (var i = 0; i < Bezier.kSplineTableSize; ++i) {
            sampleValues[i] = Bezier.calcBezier(i * Bezier.kSampleStepSize, mX1, mX2);
        }
        function getTForX(aX) {
            var intervalStart = 0.0;
            var currentSample = 1;
            var lastSample = Bezier.kSplineTableSize - 1;
            for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
                intervalStart += Bezier.kSampleStepSize;
            }
            --currentSample;
            // Interpolate to provide an initial guess for t
            var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
            var guessForT = intervalStart + dist * Bezier.kSampleStepSize;
            var initialSlope = Bezier.getSlope(guessForT, mX1, mX2);
            if (initialSlope >= Bezier.NEWTON_MIN_SLOPE) {
                return Bezier.newtonRaphsonIterate(aX, guessForT, mX1, mX2);
            }
            else if (initialSlope === 0.0) {
                return guessForT;
            }
            else {
                return Bezier.binarySubdivide(aX, intervalStart, intervalStart + Bezier.kSampleStepSize, mX1, mX2);
            }
        }
        return function BezierEasing(x) {
            // Because JavaScript number are imprecise, we should guarantee the extremes are right.
            if (x === 0 || x === 1) {
                return x;
            }
            return Bezier.calcBezier(getTForX(x), mY1, mY2);
        };
    };
    /**
     * https://github.com/gre/bezier-easing
     * BezierEasing - use bezier curve for transition easing function
     * by Gaëtan Renaudeau 2014 - 2015 – MIT License
     */
    Bezier.NEWTON_ITERATIONS = 4;
    Bezier.NEWTON_MIN_SLOPE = 0.001;
    Bezier.SUBDIVISION_PRECISION = 0.0000001;
    Bezier.SUBDIVISION_MAX_ITERATIONS = 10;
    Bezier.kSplineTableSize = 11;
    Bezier.kSampleStepSize = 1.0 / (Bezier.kSplineTableSize - 1.0);
    Bezier.float32ArraySupported = typeof Float32Array === 'function';
    return Bezier;
}());
exports.Bezier = Bezier;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _maxRecommendedTextures = __webpack_require__(354);

var _maxRecommendedTextures2 = _interopRequireDefault(_maxRecommendedTextures);

var _canUploadSameBuffer = __webpack_require__(355);

var _canUploadSameBuffer2 = _interopRequireDefault(_canUploadSameBuffer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * User's customizable globals for overriding the default PIXI settings, such
 * as a renderer's default resolution, framerate, float percision, etc.
 * @example
 * // Use the native window resolution as the default resolution
 * // will support high-density displays when rendering
 * PIXI.settings.RESOLUTION = window.devicePixelRatio.
 *
 * // Disable interpolation when scaling, will make texture be pixelated
 * PIXI.settings.SCALE_MODE = PIXI.SCALE_MODES.NEAREST;
 * @namespace PIXI.settings
 */
exports.default = {

  /**
   * Target frames per millisecond.
   *
   * @static
   * @memberof PIXI.settings
   * @type {number}
   * @default 0.06
   */
  TARGET_FPMS: 0.06,

  /**
   * If set to true WebGL will attempt make textures mimpaped by default.
   * Mipmapping will only succeed if the base texture uploaded has power of two dimensions.
   *
   * @static
   * @memberof PIXI.settings
   * @type {boolean}
   * @default true
   */
  MIPMAP_TEXTURES: true,

  /**
   * Default resolution / device pixel ratio of the renderer.
   *
   * @static
   * @memberof PIXI.settings
   * @type {number}
   * @default 1
   */
  RESOLUTION: 1,

  /**
   * Default filter resolution.
   *
   * @static
   * @memberof PIXI.settings
   * @type {number}
   * @default 1
   */
  FILTER_RESOLUTION: 1,

  /**
   * The maximum textures that this device supports.
   *
   * @static
   * @memberof PIXI.settings
   * @type {number}
   * @default 32
   */
  SPRITE_MAX_TEXTURES: (0, _maxRecommendedTextures2.default)(32),

  // TODO: maybe change to SPRITE.BATCH_SIZE: 2000
  // TODO: maybe add PARTICLE.BATCH_SIZE: 15000

  /**
   * The default sprite batch size.
   *
   * The default aims to balance desktop and mobile devices.
   *
   * @static
   * @memberof PIXI.settings
   * @type {number}
   * @default 4096
   */
  SPRITE_BATCH_SIZE: 4096,

  /**
   * The prefix that denotes a URL is for a retina asset.
   *
   * @static
   * @memberof PIXI.settings
   * @type {RegExp}
   * @example `@2x`
   * @default /@([0-9\.]+)x/
   */
  RETINA_PREFIX: /@([0-9\.]+)x/,

  /**
   * The default render options if none are supplied to {@link PIXI.WebGLRenderer}
   * or {@link PIXI.CanvasRenderer}.
   *
   * @static
   * @constant
   * @memberof PIXI.settings
   * @type {object}
   * @property {HTMLCanvasElement} view=null
   * @property {number} resolution=1
   * @property {boolean} antialias=false
   * @property {boolean} forceFXAA=false
   * @property {boolean} autoResize=false
   * @property {boolean} transparent=false
   * @property {number} backgroundColor=0x000000
   * @property {boolean} clearBeforeRender=true
   * @property {boolean} preserveDrawingBuffer=false
   * @property {boolean} roundPixels=false
   * @property {number} width=800
   * @property {number} height=600
   * @property {boolean} legacy=false
   */
  RENDER_OPTIONS: {
    view: null,
    antialias: false,
    forceFXAA: false,
    autoResize: false,
    transparent: false,
    backgroundColor: 0x000000,
    clearBeforeRender: true,
    preserveDrawingBuffer: false,
    roundPixels: false,
    width: 800,
    height: 600,
    legacy: false
  },

  /**
   * Default transform type.
   *
   * @static
   * @memberof PIXI.settings
   * @type {PIXI.TRANSFORM_MODE}
   * @default PIXI.TRANSFORM_MODE.STATIC
   */
  TRANSFORM_MODE: 0,

  /**
   * Default Garbage Collection mode.
   *
   * @static
   * @memberof PIXI.settings
   * @type {PIXI.GC_MODES}
   * @default PIXI.GC_MODES.AUTO
   */
  GC_MODE: 0,

  /**
   * Default Garbage Collection max idle.
   *
   * @static
   * @memberof PIXI.settings
   * @type {number}
   * @default 3600
   */
  GC_MAX_IDLE: 60 * 60,

  /**
   * Default Garbage Collection maximum check count.
   *
   * @static
   * @memberof PIXI.settings
   * @type {number}
   * @default 600
   */
  GC_MAX_CHECK_COUNT: 60 * 10,

  /**
   * Default wrap modes that are supported by pixi.
   *
   * @static
   * @memberof PIXI.settings
   * @type {PIXI.WRAP_MODES}
   * @default PIXI.WRAP_MODES.CLAMP
   */
  WRAP_MODE: 0,

  /**
   * The scale modes that are supported by pixi.
   *
   * @static
   * @memberof PIXI.settings
   * @type {PIXI.SCALE_MODES}
   * @default PIXI.SCALE_MODES.LINEAR
   */
  SCALE_MODE: 0,

  /**
   * Default specify float precision in vertex shader.
   *
   * @static
   * @memberof PIXI.settings
   * @type {PIXI.PRECISION}
   * @default PIXI.PRECISION.HIGH
   */
  PRECISION_VERTEX: 'highp',

  /**
   * Default specify float precision in fragment shader.
   *
   * @static
   * @memberof PIXI.settings
   * @type {PIXI.PRECISION}
   * @default PIXI.PRECISION.MEDIUM
   */
  PRECISION_FRAGMENT: 'mediump',

  /**
   * Can we upload the same buffer in a single frame?
   *
   * @static
   * @constant
   * @memberof PIXI.settings
   * @type {boolean}
   */
  CAN_UPLOAD_SAME_BUFFER: (0, _canUploadSameBuffer2.default)(),

  /**
   * Default Mesh `canvasPadding`.
   *
   * @see PIXI.mesh.Mesh#canvasPadding
   * @static
   * @constant
   * @memberof PIXI.settings
   * @type {number}
   */
  MESH_CANVAS_PADDING: 0
};
//# sourceMappingURL=settings.js.map

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.NAMED_TAG = "named";
exports.NAME_TAG = "name";
exports.UNMANAGED_TAG = "unmanaged";
exports.OPTIONAL_TAG = "optional";
exports.INJECT_TAG = "inject";
exports.MULTI_INJECT_TAG = "multi_inject";
exports.TAGGED = "inversify:tagged";
exports.TAGGED_PROP = "inversify:tagged_props";
exports.PARAM_TYPES = "inversify:paramtypes";
exports.DESIGN_PARAM_TYPES = "design:paramtypes";
exports.POST_CONSTRUCT = "post_construct";


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Updatable_1 = __webpack_require__(71);
var Easing_1 = __webpack_require__(16);
var Interpolation_1 = __webpack_require__(476);
var Tween = /** @class */ (function (_super) {
    __extends(Tween, _super);
    function Tween(object) {
        var _this = _super.call(this) || this;
        _this._startTime = null;
        _this._duration = 1000;
        _this._isPlaying = false;
        _this._repeat = 0;
        _this._valuesStart = {};
        _this._valuesEnd = {};
        _this._valuesStartRepeat = {};
        _this._yoyo = false;
        _this._reversed = false;
        _this._delayTime = 0;
        _this._easingFunction = Easing_1.Easing.Linear.None;
        _this._interpolationFunction = Interpolation_1.Interpolation.Linear;
        _this._chainedTweens = [];
        _this._onStartCallback = null;
        _this._onStartCalledCallback = null;
        _this._onStartCallbackFired = false;
        _this._onUpdateCallback = null;
        _this._onRepeatCallback = null;
        _this._onCompleteCallback = null;
        _this._onStopCallback = null;
        if (object) {
            _this._object = object;
        }
        return _this;
    }
    Tween.prototype.path = function (p, duration) {
        if (p !== undefined) {
            this._path = p;
            var distance = this._path.totalDistance();
            this._pathFrom = 0;
            this._pathTo = distance;
        }
        if (duration !== undefined) {
            this._duration = duration;
        }
        return this;
    };
    Tween.prototype.to = function (properties, duration) {
        if (duration !== undefined) {
            this._duration = duration;
        }
        this._valuesEnd = properties;
        this.parseStartValues(properties);
        return this;
    };
    Tween.prototype.force = function () {
        for (var property in this._valuesEnd) {
            if (this._valuesEnd.hasOwnProperty(property)) {
                this._object[property] = this._valuesEnd[property];
            }
        }
    };
    Tween.prototype.startAt = function (time) {
        _super.prototype.start.call(this);
        this._onStartCalledCallback && this._onStartCalledCallback();
        this._onStartCallbackFired = false;
        this._startTime = time !== undefined ? time : Date.now();
        this._currentTime = this._startTime;
        this._startTime += this._delayTime;
        for (var property in this._valuesEnd) {
            if (this._valuesEnd.hasOwnProperty(property)) {
                // Check if an Array was provided as property value
                if (this._valuesEnd[property] instanceof Array) {
                    if (this._valuesEnd[property].length === 0) {
                        continue;
                    }
                    // Create a local copy of the Array with the start value at the front
                    this._valuesEnd[property] = [this._object[property]].concat(this._valuesEnd[property]);
                }
                // If `to()` specifies a property that doesn't exist in the source object,
                // we should not set that property in the object
                if (this._valuesStart[property] === undefined) {
                    continue;
                }
                this._valuesStart[property] = this._object[property];
                if (this._valuesStart[property] instanceof Array === false) {
                    this._valuesStart[property] *= 1.0; // Ensures we're using numbers, not strings
                }
                this._valuesStartRepeat[property] = this._valuesStart[property] || 0;
            }
        }
        return this;
    };
    Tween.prototype.start = function () {
        this.startAt();
        return this;
    };
    Tween.prototype.stop = function (goToEnd) {
        if (goToEnd === void 0) { goToEnd = false; }
        if (!this._isPlaying) {
            return;
        }
        _super.prototype.stop.call(this);
        if (goToEnd) {
            this.applyEndProperties();
        }
        if (this._onStopCallback !== null) {
            this._onStopCallback.call(this._object);
        }
        this.stopChainedTweens();
    };
    Tween.prototype.applyEndProperties = function () {
        for (var property in this._valuesEnd) {
            // Don't update properties that do not exist in the source object
            if (this._valuesStart[property] === undefined) {
                continue;
            }
            var end = this._valuesEnd[property];
            if (end instanceof Array) {
                this._object[property] = end;
            }
            else {
                // Parses relative end values with start as base (e.g.: +10, -3)
                if (typeof end === 'string') {
                    if (end.charAt(0) === '+' || end.charAt(0) === '-') {
                        end = parseFloat(end);
                    }
                    else {
                        end = parseFloat(end);
                    }
                }
                // Protect against non numeric properties.
                if (typeof end === 'number') {
                    this._object[property] = end;
                }
            }
        }
    };
    Tween.prototype.stopChainedTweens = function () {
        for (var i = 0, numChainedTweens = this._chainedTweens.length; i < numChainedTweens; i++) {
            this._chainedTweens[i].stop();
        }
    };
    Tween.prototype.delay = function (amount) {
        this._delayTime = amount;
        return this;
    };
    Tween.prototype.repeat = function (times) {
        this._repeat = times;
        return this;
    };
    Tween.prototype.getRepeat = function () {
        return this._repeat;
    };
    Tween.prototype.yoyo = function (yoyo) {
        this._yoyo = yoyo;
        return this;
    };
    Tween.prototype.easing = function (easing) {
        this._easingFunction = easing;
        return this;
    };
    Tween.prototype.interpolation = function (interpolation) {
        this._interpolationFunction = interpolation;
        return this;
    };
    Tween.prototype.chain = function (chain) {
        // if Tween[]
        if (chain.length) {
            this._chainedTweens = chain;
        }
        else {
            this._chainedTweens = [chain];
        }
        return this;
    };
    Tween.prototype.onStart = function (callback) {
        this._onStartCallback = callback;
        return this;
    };
    Tween.prototype.onStartCalled = function (callback) {
        this._onStartCalledCallback = callback;
        return this;
    };
    Tween.prototype.onRepeat = function (callback) {
        this._onRepeatCallback = callback;
        return this;
    };
    Tween.prototype.onUpdate = function (callback) {
        this._onUpdateCallback = callback;
        return this;
    };
    Tween.prototype.onComplete = function (callback) {
        this._onCompleteCallback = callback;
        return this;
    };
    Tween.prototype.onStop = function (callback) {
        this._onStopCallback = callback;
        return this;
    };
    Tween.prototype.update = function (dt) {
        if (this._skipFirstUpdate) {
            this._skipFirstUpdate = false;
            return;
        }
        this._currentTime += dt;
        var time = this._currentTime;
        var property;
        var elapsed;
        var value;
        if (time < this._startTime) {
            return;
        }
        if (!this._onStartCallbackFired) {
            if (this._onStartCallback !== null) {
                this._onStartCallback.call(this._object);
            }
            this._onStartCallbackFired = true;
        }
        elapsed = (time - this._startTime) / this._duration;
        elapsed = elapsed > 1 ? 1 : elapsed;
        value = this._easingFunction(elapsed);
        for (property in this._valuesEnd) {
            // Don't update properties that do not exist in the source object
            if (this._valuesStart[property] === undefined) {
                continue;
            }
            var start = this._valuesStart[property] || 0;
            var end = this._valuesEnd[property];
            if (end instanceof Array) {
                this._object[property] = this._interpolationFunction(end, value);
            }
            else {
                // Parses relative end values with start as base (e.g.: +10, -3)
                if (typeof end === 'string') {
                    if (end.charAt(0) === '+' || end.charAt(0) === '-') {
                        end = start + parseFloat(end);
                    }
                    else {
                        end = parseFloat(end);
                    }
                }
                // Protect against non numeric properties.
                if (typeof end === 'number') {
                    this._object[property] = start + (end - start) * value;
                }
            }
        }
        this.applyPath(elapsed);
        if (this._onUpdateCallback !== null) {
            this._onUpdateCallback.call(this._object, value);
        }
        if (elapsed === 1) {
            if (this._repeat > 0) {
                if (isFinite(this._repeat)) {
                    this._repeat--;
                }
                // Reassign starting values, restart by making startTime = now
                for (property in this._valuesStartRepeat) {
                    if (this._valuesStartRepeat.hasOwnProperty(property)) {
                        if (typeof this._valuesEnd[property] === 'string') {
                            this._valuesStartRepeat[property] = this._valuesStartRepeat[property] + parseFloat(this._valuesEnd[property]);
                        }
                        if (this._yoyo) {
                            var tmp = this._valuesStartRepeat[property];
                            this._valuesStartRepeat[property] = this._valuesEnd[property];
                            this._valuesEnd[property] = tmp;
                        }
                        this._valuesStart[property] = this._valuesStartRepeat[property];
                    }
                }
                if (this._yoyo) {
                    this._reversed = !this._reversed;
                }
                this._startTime = time + this._delayTime;
                this._currentTime = this._startTime;
                if (this._onRepeatCallback !== null) {
                    this._onRepeatCallback.call(this.object, value);
                }
                if (this._repeat === 0 && this._onCompleteCallback !== null) {
                    this._onCompleteCallback.call(this._object);
                }
            }
            else {
                if (this._onCompleteCallback !== null) {
                    this._onCompleteCallback.call(this._object);
                }
                for (var i = 0, numChainedTweens = this._chainedTweens.length; i < numChainedTweens; i++) {
                    this._updateManager.add(this._chainedTweens[i]);
                    // Make the chained tweens start exactly at the time they should,
                    // even if the `update()` method was called way past the duration of the tween
                    this._chainedTweens[i]._skipFirstUpdate = true;
                    this._chainedTweens[i].startAt(this._startTime + this._duration);
                }
                _super.prototype.stop.call(this);
            }
            /*
            if (this.path) {
                _to = this._pathTo;
                _from = this._pathFrom;
                this._pathTo = _from;
                this._pathFrom = _to;
            }*/
        }
    };
    Tween.prototype.getPredictedProperty = function (time, property) {
        var elapsed = (this._currentTime - this._startTime + time) / this._duration;
        elapsed = elapsed > 1 ? 1 : elapsed;
        var value = this._easingFunction(elapsed);
        var start = this._valuesStart[property] || 0;
        var end = this._valuesEnd[property];
        if (end instanceof Array) {
            return this._interpolationFunction(end, value);
        }
        else {
            // Parses relative end values with start as base (e.g.: +10, -3)
            if (typeof end === 'string') {
                if (end.charAt(0) === '+' || end.charAt(0) === '-') {
                    end = start + parseFloat(end);
                }
                else {
                    end = parseFloat(end);
                }
            }
            // Protect against non numeric properties.
            if (typeof end === 'number') {
                return start + (end - start) * value;
            }
        }
    };
    Tween.prototype.applyPath = function (elapsedTime) {
        if (this._path) {
            var time = this._duration;
            var b = this._pathFrom;
            var c = this._pathTo - this._pathFrom;
            var d = time;
            var t = time ? (elapsedTime * this._duration) / d : 1;
            var distance = b + c * this._easingFunction(t);
            var pos = this._path.getPointAtDistance(distance);
            this._object.position.set(pos.x, pos.y);
        }
    };
    Tween.prototype.parseStartValues = function (properties) {
        for (var field in properties) {
            if (properties.hasOwnProperty(field)) {
                try {
                    this._valuesStart[field] = parseFloat(this.object[field]);
                }
                catch (e) {
                    console.warn(e);
                }
            }
        }
    };
    Object.defineProperty(Tween.prototype, "chainedTweens", {
        get: function () {
            return this._chainedTweens;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Tween.prototype, "object", {
        get: function () {
            return this._object;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Tween.prototype, "duration", {
        get: function () {
            return this._duration;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Tween.prototype, "isPlaying", {
        get: function () {
            return this._isPlaying;
        },
        enumerable: true,
        configurable: true
    });
    return Tween;
}(Updatable_1.Updatable));
exports.Tween = Tween;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _Point = __webpack_require__(123);

Object.defineProperty(exports, 'Point', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Point).default;
  }
});

var _ObservablePoint = __webpack_require__(170);

Object.defineProperty(exports, 'ObservablePoint', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ObservablePoint).default;
  }
});

var _Matrix = __webpack_require__(124);

Object.defineProperty(exports, 'Matrix', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Matrix).default;
  }
});

var _GroupD = __webpack_require__(171);

Object.defineProperty(exports, 'GroupD8', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GroupD).default;
  }
});

var _Circle = __webpack_require__(344);

Object.defineProperty(exports, 'Circle', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Circle).default;
  }
});

var _Ellipse = __webpack_require__(345);

Object.defineProperty(exports, 'Ellipse', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Ellipse).default;
  }
});

var _Polygon = __webpack_require__(346);

Object.defineProperty(exports, 'Polygon', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Polygon).default;
  }
});

var _Rectangle = __webpack_require__(125);

Object.defineProperty(exports, 'Rectangle', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Rectangle).default;
  }
});

var _RoundedRectangle = __webpack_require__(347);

Object.defineProperty(exports, 'RoundedRectangle', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RoundedRectangle).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BigWinEvents = /** @class */ (function () {
    function BigWinEvents() {
    }
    BigWinEvents.STARTED = 'BigWinEvents::__STARTED__';
    BigWinEvents.FINISHED = 'BigWinEvents::__FINISHED__';
    BigWinEvents.COUNTUP_STARTED = 'BigWinEvents::__COUNTUP_STARTED__';
    BigWinEvents.COUNTUP_FINISHED = 'BigWinEvents::__COUNTUP_FINISHED__';
    BigWinEvents.TRANSITION_STARTED = 'BigWinEvents::__TRANSITION_STARTED__';
    BigWinEvents.TRANSITION_ENDED = 'BigWinEvents::__TRANSITION_ENDED__';
    BigWinEvents.EXPLOSION_STARTED = 'BigWinEvents::__EXPLOSION_STARTED__';
    BigWinEvents.BIG_WIN_STARTED = 'BigWinEvents::__BIG_WIN_STARTED__';
    BigWinEvents.ON_BEFORE_BIG_WIN = 'BigWinEvents::ON_BEFORE_BIG_WIN';
    BigWinEvents.ON_BEFORE_BIG_WIN_FINISHED = 'BigWinEvents::ON_BEFORE_BIG_WIN_FINISHED';
    return BigWinEvents;
}());
exports.BigWinEvents = BigWinEvents;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var StartScreenEvents = /** @class */ (function () {
    function StartScreenEvents() {
    }
    StartScreenEvents.INTRO_STARTED = 'StartScreenEvents::GAME_INTRO_STARTED';
    StartScreenEvents.INTRO_IDLE = 'StartScreenEvents::GAME_INTRO_IDLE';
    StartScreenEvents.INTRO_FINISHED = 'StartScreenEvents::GAME_INTRO_FINISHED';
    StartScreenEvents.EXIT_STARTED = 'StartScreenEvents::GAME_INTRO_EXIT_STARTED';
    StartScreenEvents.EXIT_FINISHED = 'StartScreenEvents::GAME_INTRO_EXIT_FINISHED';
    StartScreenEvents.PLAY_BUTTON_CLICKED = 'StartScreenEvents::PLAY_BUTTON_CLICKED';
    return StartScreenEvents;
}());
exports.StartScreenEvents = StartScreenEvents;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Module_1 = __webpack_require__(2);
var SpinButtonEvents_1 = __webpack_require__(12);
var AvalancheReelsInitState_1 = __webpack_require__(265);
var AvalancheReelsBasicState_1 = __webpack_require__(525);
var Views_1 = __webpack_require__(8);
var ReelsEvents_1 = __webpack_require__(4);
var AvalancheReelsDropOutState_1 = __webpack_require__(266);
var AvalancheReelsDropNewState_1 = __webpack_require__(267);
var AvalancheReelsView_1 = __webpack_require__(75);
var AvalancheReelsEvents_1 = __webpack_require__(15);
var AvalancheAddSymbolsState_1 = __webpack_require__(268);
var AvalancheRespinState_1 = __webpack_require__(269);
var AvalancheRemoveWinsState_1 = __webpack_require__(270);
var LogicEvents_1 = __webpack_require__(11);
var WinPresentationEvents_1 = __webpack_require__(13);
var FlowModuleEvents_1 = __webpack_require__(0);
var SwipeInteractionEvents_1 = __webpack_require__(65);
var BetlevelMenuEvents_1 = __webpack_require__(48);
var FreeSpinsEvents_1 = __webpack_require__(6);
var StartScreenEvents_1 = __webpack_require__(22);
/**
 * avalanche type of reels
 */
var AvalancheReelsModule = /** @class */ (function (_super) {
    __extends(AvalancheReelsModule, _super);
    function AvalancheReelsModule() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._isSpinResponseReceived = false;
        _this._isAvalancheResponseReceived = false;
        _this._isRespinResponseReceived = false;
        _this._isAllReelsStopped = true;
        return _this;
    }
    AvalancheReelsModule.prototype.init = function () {
        _super.prototype.init.call(this);
        this.setupDefaultReelset();
    };
    AvalancheReelsModule.prototype.setupDefaultReelset = function () {
        if (!this.logic.hasRestore) {
            this.view.createReelSet(null);
        }
    };
    AvalancheReelsModule.prototype.restore = function () {
        _super.prototype.restore.call(this);
        this.view.createReelSet(this.logic.getSpinResult().reels);
    };
    AvalancheReelsModule.prototype.setupStates = function () {
        this.addState(new AvalancheReelsBasicState_1.AvalancheReelsBasicState(this, AvalancheReelsModule.BASIC_STATE));
        this.addState(new AvalancheReelsInitState_1.AvalancheReelsInitState(this, AvalancheReelsModule.INIT_STATE));
        this.addState(new AvalancheReelsDropOutState_1.AvalancheReelsDropOutState(this, AvalancheReelsModule.DROPOUT_STATE));
        this.addState(new AvalancheReelsDropNewState_1.AvalancheReelsDropNewState(this, AvalancheReelsModule.DROPNEW_STATE));
        this.addState(new AvalancheRespinState_1.AvalancheRespinState(this, AvalancheReelsModule.RESPIN_STATE));
        this.addState(new AvalancheAddSymbolsState_1.AvalancheAddSymbolsState(this, AvalancheReelsModule.ADD_SYMBOLS_STATE));
        this.addState(new AvalancheRemoveWinsState_1.AvalancheRemoveWinsState(this, AvalancheReelsModule.REMOVE_WINS_STATE));
    };
    AvalancheReelsModule.prototype.enterFirstState = function () {
        this.changeStateTo(AvalancheReelsModule.INIT_STATE);
    };
    AvalancheReelsModule.prototype.setupViews = function () {
        this.setView(Views_1.Views.REELS_VIEW);
    };
    AvalancheReelsModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(SpinButtonEvents_1.SpinButtonEvents.SPIN_BUTTON_PRESSED, this.onSpinButtonPressed);
        this.on(LogicEvents_1.LogicEvents.SPIN_RESPONSE, this.onSpinResponseReceived);
        this.on(LogicEvents_1.LogicEvents.AVALANCHE_RESPONSE, this.onAvalancheResponseReveived);
        this.on(LogicEvents_1.LogicEvents.RESPIN_RESPONSE, this.onRespinResponse);
        this.onCurrentStateHandle(LogicEvents_1.LogicEvents.INIT_RESPONSE);
        this.on(FlowModuleEvents_1.FlowModuleEvents.RESPIN_WON, this.onRespinWon);
        this.on(FlowModuleEvents_1.FlowModuleEvents.AVALANCHE_WON, this.onAvalancheWon);
        this.onView(AvalancheReelsView_1.AvalancheReelsView.ALL_REELS_DROPPED_NEW, this.onAllReelsStoppedCallback);
        this.onView(AvalancheReelsView_1.AvalancheReelsView.ALL_REELS_DROPPED_OUT, this.onAllReelsDroppedOutCallback);
        this.onView(AvalancheReelsView_1.AvalancheReelsView.REEL_DROPPED_NEW, this.onReelDroppedNew);
        this.onView(AvalancheReelsView_1.AvalancheReelsView.REEL_DROPPED_OUT, this.onReelDroppedOut);
        this.onView(AvalancheReelsView_1.AvalancheReelsView.FILLING_VOIDS_FINISHED, this.onFillingVoidsFinished);
        this.onView(AvalancheReelsView_1.AvalancheReelsView.ADDING_SYMBOLS_FINISHED, this.onAddingSymbolsFinished);
        this.onView(AvalancheReelsView_1.AvalancheReelsView.REMOVING_SYMBOLS_FINISHED, this.onRemovingSymbolsFinished);
        this.on(WinPresentationEvents_1.WinPresentationEvents.WIN_ANIMATION_FOR_SYMBOL_STARTED, this.onWinAnimationPlayingForSymbol);
        this.on(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED, this.onInitialAnimationFinished);
        this.on(WinPresentationEvents_1.WinPresentationEvents.INDIVIDUAL_ANIMATION_FINISHED, this.onIndividualAnimationFinished);
        this.on(SwipeInteractionEvents_1.SwipeInteractionEvents.DRAGGING_STARTED, this.onDraggingStarted);
        this.on(BetlevelMenuEvents_1.BetlevelMenuEvents.BET_VALUE_UPDATED, this.onBetValueUpdated);
        this.onCurrentStateHandle(AvalancheReelsEvents_1.AvalancheReelsEvents.FILLING_VOIDS_FINISHED);
        this.onCurrentStateHandle(WinPresentationEvents_1.WinPresentationEvents.COUNTUP_FINISHED);
        this.onCurrentStateHandle(FlowModuleEvents_1.FlowModuleEvents.NO_WIN);
        this.onCurrentStateHandle(AvalancheReelsEvents_1.AvalancheReelsEvents.REMOVING_WIN_FINISHED);
        this.onCurrentStateHandle(AvalancheReelsEvents_1.AvalancheReelsEvents.ADDING_NEW_FINISHED);
        this.onCurrentStateHandle(FlowModuleEvents_1.FlowModuleEvents.CAN_DROP_NEW);
        this.onViewEmitEvent(AvalancheReelsView_1.AvalancheReelsView.REELS_FADING_OUT_FINISHED, AvalancheReelsEvents_1.AvalancheReelsEvents.REELS_FADING_OUT_FINISHED);
        this.onViewEmitEvent(AvalancheReelsView_1.AvalancheReelsView.REELS_FADING_OUT_STARTED, AvalancheReelsEvents_1.AvalancheReelsEvents.REELS_FADING_OUT_STARTED);
        this.onViewEmitEvent(AvalancheReelsView_1.AvalancheReelsView.REELS_FADING_IN_FINISHED, AvalancheReelsEvents_1.AvalancheReelsEvents.REELS_FADING_IN_FINISHED);
        this.onViewEmitEvent(AvalancheReelsView_1.AvalancheReelsView.REELS_FADING_IN_STARTED, AvalancheReelsEvents_1.AvalancheReelsEvents.REELS_FADING_IN_STARTED);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_INTRO_STARTED, this.onFreeSpinsIntroStarted);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_RESTORE_INTRO_STARTED, this.onFreeSpinsIntroRestoreStarted);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_INTRO_FINISHED, this.onFreeSpinsIntroFinished);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_OUTRO_STARTED, this.onFreeSpinsOutroStarted);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_OUTRO_FINISHED, this.onFreeSpinsOutroFinished);
        this.on(StartScreenEvents_1.StartScreenEvents.INTRO_STARTED, this.onStartScreenIntroStarted);
        this.on(StartScreenEvents_1.StartScreenEvents.EXIT_FINISHED, this.onStartScreenIntroFinished);
    };
    AvalancheReelsModule.prototype.onStartScreenIntroStarted = function () {
        this.view.hide();
    };
    AvalancheReelsModule.prototype.onStartScreenIntroFinished = function () {
        this.view.show();
    };
    AvalancheReelsModule.prototype.onFreeSpinsIntroRestoreStarted = function () {
        this.view.hide();
    };
    AvalancheReelsModule.prototype.onFreeSpinsIntroStarted = function () {
        this.view.fadeOutSymbols();
    };
    AvalancheReelsModule.prototype.onFreeSpinsIntroFinished = function () {
        this.view.show();
        this.view.fadeInSymbols();
    };
    AvalancheReelsModule.prototype.onFreeSpinsOutroStarted = function () {
        this.view.fadeOutSymbols();
    };
    AvalancheReelsModule.prototype.onFreeSpinsOutroFinished = function () {
        this.view.fadeInSymbols();
    };
    AvalancheReelsModule.prototype.onRespinWon = function () {
        this.gotoState(AvalancheReelsModule.RESPIN_STATE);
    };
    AvalancheReelsModule.prototype.onAvalancheWon = function () {
        this.isAvalancheResponseReceived = false;
        this.gotoState(AvalancheReelsModule.REMOVE_WINS_STATE);
    };
    AvalancheReelsModule.prototype.onWinAnimationPlayingForSymbol = function (eventId, pos) {
    };
    AvalancheReelsModule.prototype.onIndividualAnimationFinished = function () {
        this.view.showAllSymbols();
    };
    AvalancheReelsModule.prototype.onInitialAnimationFinished = function () {
        this.view.showAllSymbols();
    };
    AvalancheReelsModule.prototype.onDraggingStarted = function () {
        this.view.showAllSymbols();
    };
    AvalancheReelsModule.prototype.onBetValueUpdated = function () {
        this.view.showAllSymbols();
    };
    AvalancheReelsModule.prototype.onSpinButtonPressed = function () {
        this.resetParameters();
        this.logic.resetRound();
        this.currentState.handle(SpinButtonEvents_1.SpinButtonEvents.SPIN_BUTTON_PRESSED);
    };
    AvalancheReelsModule.prototype.onAllReelsStoppedCallback = function (eventID, reelNr) {
        this.currentState.handle(AvalancheReelsView_1.AvalancheReelsView.ALL_REELS_DROPPED_NEW);
        this.eventManager.emit(AvalancheReelsEvents_1.AvalancheReelsEvents.REEL_DROP_NEW_FINISHED, reelNr);
        this.eventManager.emit(ReelsEvents_1.ReelsEvents.ALL_REELS_STOPPED);
        this.eventManager.emit(ReelsEvents_1.ReelsEvents.AVALANCHE_ENDED);
        this.eventManager.emit(AvalancheReelsEvents_1.AvalancheReelsEvents.ALL_REELS_DROP_NEW_FINISHED);
    };
    AvalancheReelsModule.prototype.onAllReelsDroppedOutCallback = function (eventID, reelNr) {
        this.currentState.handle(AvalancheReelsView_1.AvalancheReelsView.ALL_REELS_DROPPED_OUT);
        this.eventManager.emit(AvalancheReelsEvents_1.AvalancheReelsEvents.REEL_DROP_OUT_FINISHED, reelNr);
        this.eventManager.emit(AvalancheReelsEvents_1.AvalancheReelsEvents.ALL_REELS_DROP_OUT_FINISHED);
    };
    AvalancheReelsModule.prototype.onReelDroppedNew = function (eventID, reelNr) {
        this.eventManager.emit(AvalancheReelsEvents_1.AvalancheReelsEvents.REEL_DROP_NEW_FINISHED, reelNr);
    };
    AvalancheReelsModule.prototype.onReelDroppedOut = function (eventID, reelNr) {
        this.eventManager.emit(AvalancheReelsEvents_1.AvalancheReelsEvents.REEL_DROP_OUT_FINISHED, reelNr);
    };
    AvalancheReelsModule.prototype.onFillingVoidsFinished = function (eventID, reelNr) {
        this.eventManager.emit(AvalancheReelsEvents_1.AvalancheReelsEvents.FILLING_VOIDS_FINISHED);
    };
    AvalancheReelsModule.prototype.onAddingSymbolsFinished = function (eventID, reelNr) {
        this.eventManager.emit(AvalancheReelsEvents_1.AvalancheReelsEvents.ADDING_NEW_FINISHED);
        // this.currentState.handle(AvalancheReelsEvents.ADDING_NEW_FINISHED);
        this._isRespinResponseReceived = false;
    };
    AvalancheReelsModule.prototype.onRemovingSymbolsFinished = function (eventID, symbols) {
        this.eventManager.emit(AvalancheReelsEvents_1.AvalancheReelsEvents.REMOVING_WIN_FINISHED);
    };
    AvalancheReelsModule.prototype.onSpinResponseReceived = function () {
        this._isSpinResponseReceived = true;
        this.currentState.handle(LogicEvents_1.LogicEvents.SPIN_RESPONSE);
    };
    AvalancheReelsModule.prototype.onAvalancheResponseReveived = function () {
        this.isAvalancheResponseReceived = true;
        this.currentState.handle(LogicEvents_1.LogicEvents.AVALANCHE_RESPONSE);
    };
    AvalancheReelsModule.prototype.onRespinResponse = function () {
        this._isRespinResponseReceived = true;
        this.currentState.handle(LogicEvents_1.LogicEvents.RESPIN_RESPONSE);
    };
    AvalancheReelsModule.prototype.resetParameters = function () {
        this._isSpinResponseReceived = false;
        this._isAllReelsStopped = false;
        this.isAvalancheResponseReceived = false;
        this._isRespinResponseReceived = false;
    };
    Object.defineProperty(AvalancheReelsModule.prototype, "isSpinResponseReceived", {
        get: function () {
            return this._isSpinResponseReceived;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AvalancheReelsModule.prototype, "isAvalancheResponseReceived", {
        get: function () {
            return this._isAvalancheResponseReceived;
        },
        set: function (v) {
            this._isAvalancheResponseReceived = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AvalancheReelsModule.prototype, "isRespinResponseReceived", {
        get: function () {
            return this._isRespinResponseReceived;
        },
        enumerable: true,
        configurable: true
    });
    AvalancheReelsModule.BASIC_STATE = 'AvalancheReelsModule::BASIC_STATE';
    AvalancheReelsModule.INIT_STATE = 'AvalancheReelsModule::INIT_STATE';
    AvalancheReelsModule.DROPOUT_STATE = 'AvalancheReelsModule::DROPOUT_STATE';
    AvalancheReelsModule.DROPNEW_STATE = 'AvalancheReelsModule::DROPNEW_STATE';
    AvalancheReelsModule.RESPIN_STATE = 'AvalancheReelsModule::RESPIN_STATE';
    AvalancheReelsModule.ADD_SYMBOLS_STATE = 'AvalancheReelsModule::ADD_SYMBOLS_STATE';
    AvalancheReelsModule.REMOVE_WINS_STATE = 'AvalancheReelsModule::REMOVE_WINS_STATE';
    return AvalancheReelsModule;
}(Module_1.Module));
exports.AvalancheReelsModule = AvalancheReelsModule;


/***/ }),
/* 24 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Spine = /** @class */ (function (_super) {
    __extends(Spine, _super);
    function Spine(spineData) {
        var _this = _super.call(this, spineData) || this;
        if (false) {
            _this.name = spineData.name;
        }
        _this.autoUpdate = false;
        return _this;
    }
    Spine.prototype.start = function () {
        this._isPlaying = true;
    };
    Spine.prototype.stop = function () {
        this._isPlaying = false;
        this._updateManager && this._updateManager.remove(this);
    };
    Spine.prototype.createSprite = function (slot, attachment, defName) {
        var region = attachment.region;
        if (slot.tempAttachment === attachment) {
            region = slot.tempRegion;
            slot.tempAttachment = null;
            slot.tempRegion = null;
        }
        var texture = region.texture;
        var sprite = this.newMaskSprite(texture, region.maskTexture);
        sprite.rotation = attachment.rotation * PIXI.spine.core.MathUtils.degRad;
        sprite.anchor.x = 0.5;
        sprite.anchor.y = 0.5;
        sprite.position.x = attachment.x;
        sprite.position.y = attachment.y;
        sprite.alpha = attachment.color.a;
        sprite.region = attachment.region;
        this.setSpriteRegion(attachment, sprite, attachment.region);
        slot.sprites = slot.sprites || {};
        slot.sprites[defName] = sprite;
        return sprite;
    };
    Spine.prototype.createMesh = function (slot, attachment) {
        var region = attachment.region;
        if (slot.tempAttachment === attachment) {
            region = slot.tempRegion;
            slot.tempAttachment = null;
            slot.tempRegion = null;
        }
        var strip = this.newMaskMesh(region.texture, region.maskTexture, new Float32Array(attachment.regionUVs.length), new Float32Array(attachment.regionUVs.length), new Uint16Array(attachment.triangles), PIXI.mesh.Mesh.DRAW_MODES.TRIANGLES);
        strip.canvasPadding = 1.5;
        strip.alpha = attachment.color.a;
        strip.region = attachment.region;
        // private method
        this.setMeshRegion(attachment, strip, region);
        slot.meshes = slot.meshes || {};
        slot.meshes[attachment.name] = strip;
        return strip;
    };
    Spine.prototype.update = function (dt) {
        _super.prototype.update.call(this, dt / 1000);
    };
    Spine.prototype.newMaskSprite = function (texture, maskTexture) {
        var sprite = new PIXI.spine.SpineSprite(texture);
        // use MaskSpriteRenderer
        if (maskTexture) {
            sprite.pluginName = 'maskSprite';
            sprite.maskTexture = maskTexture;
        }
        return sprite;
    };
    Spine.prototype.newMaskMesh = function (texture, maskTexture, vertices, uvs, indices, drawMode) {
        var mesh = new PIXI.spine.SpineMesh(texture, vertices, uvs, indices, drawMode);
        // use MaskSpriteRenderer
        if (maskTexture) {
            mesh.pluginName = 'maskMesh';
            mesh.maskTexture = maskTexture;
        }
        return mesh;
    };
    Object.defineProperty(Spine.prototype, "updateManager", {
        get: function () {
            return this._updateManager;
        },
        set: function (value) {
            this._updateManager = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Spine.prototype, "isPlaying", {
        get: function () {
            return this._isPlaying;
        },
        enumerable: true,
        configurable: true
    });
    return Spine;
}(PIXI.spine.Spine));
exports.Spine = Spine;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Container = PIXI.Container;
var GameUtils = /** @class */ (function () {
    function GameUtils() {
    }
    GameUtils.randomInt = function (min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    };
    GameUtils.findContainerInSpineByChildName = function (spine, childName) {
        for (var _i = 0, _a = spine.children; _i < _a.length; _i++) {
            var child = _a[_i];
            if (child instanceof Container) {
                var spineSprite = child.children[0];
                if (spineSprite && spineSprite.region && spineSprite.region.name === childName) {
                    return child;
                }
            }
        }
        return null;
    };
    GameUtils.shuffleArray = function (array) {
        for (var i = array.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            var temp = array[i];
            array[i] = array[j];
            array[j] = temp;
        }
    };
    GameUtils.radToDeg = function (rad) {
        return (rad * 180) / Math.PI;
    };
    GameUtils.degToRad = function (deg) {
        return (deg * Math.PI) / 180;
    };
    GameUtils.normalize = function (val, max, min) {
        return (val - min) / (max - min);
    };
    GameUtils.clamp = function (val, min, max) {
        if (min === void 0) { min = 0; }
        if (max === void 0) { max = 1; }
        return Math.min(max, Math.max(min, val));
    };
    GameUtils.getDistanceBetween = function (pt1, pt2) {
        return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
    };
    /** Linear interpolation */
    GameUtils.lerp = function (start, end, fraction) {
        return start * (1.0 - fraction) + end * fraction;
    };
    GameUtils.correctSpriteScale = function (sprite, maxSize, maxScale) {
        if (maxScale === void 0) { maxScale = 1; }
        var newScale = 1 / Math.max(maxScale, Math.max(sprite.width / maxSize.x, sprite.height / maxSize.y));
        var oldScale = sprite.scale;
        sprite.scale.set(oldScale.x * newScale, oldScale.y * newScale);
    };
    GameUtils.truncateValue = function (base, decimals) {
        var power = Math.pow(10, decimals);
        return Math.trunc(base * power) / power;
    };
    GameUtils.isInteger = function (num) {
        return Math.round(num) === num;
    };
    GameUtils.getFloatingNumbersPowerOfTen = function (num) {
        var powerOfTen = 1;
        while (!GameUtils.isInteger(num)) {
            num *= 10;
            powerOfTen *= 10;
        }
        return powerOfTen;
    };
    GameUtils.unixDateToSeconds = function (date) {
        var serverTimeParts = date.split(/[- :]/);
        return new Date(Number.parseInt(serverTimeParts[0], 10), Number.parseInt(serverTimeParts[1], 10), Number.parseInt(serverTimeParts[2], 10), Number.parseInt(serverTimeParts[3], 10), Number.parseInt(serverTimeParts[4], 10)).getTime();
    };
    return GameUtils;
}());
exports.GameUtils = GameUtils;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.DUPLICATED_INJECTABLE_DECORATOR = "Cannot apply @injectable decorator multiple times.";
exports.DUPLICATED_METADATA = "Metadata key was used more than once in a parameter:";
exports.NULL_ARGUMENT = "NULL argument";
exports.KEY_NOT_FOUND = "Key Not Found";
exports.AMBIGUOUS_MATCH = "Ambiguous match found for serviceIdentifier:";
exports.CANNOT_UNBIND = "Could not unbind serviceIdentifier:";
exports.NOT_REGISTERED = "No matching bindings found for serviceIdentifier:";
exports.MISSING_INJECTABLE_ANNOTATION = "Missing required @injectable annotation in:";
exports.MISSING_INJECT_ANNOTATION = "Missing required @inject or @multiInject annotation in:";
exports.UNDEFINED_INJECT_ANNOTATION = function (name) {
    return "@inject called with undefined this could mean that the class " + name + " has " +
        "a circular dependency problem. You can use a LazyServiceIdentifer to  " +
        "overcome this limitation.";
};
exports.CIRCULAR_DEPENDENCY = "Circular dependency found:";
exports.NOT_IMPLEMENTED = "Sorry, this feature is not fully implemented yet.";
exports.INVALID_BINDING_TYPE = "Invalid binding type:";
exports.NO_MORE_SNAPSHOTS_AVAILABLE = "No snapshot available to restore.";
exports.INVALID_MIDDLEWARE_RETURN = "Invalid return type in middleware. Middleware must return!";
exports.INVALID_FUNCTION_BINDING = "Value provided to function binding must be a function!";
exports.INVALID_TO_SELF_VALUE = "The toSelf function can only be applied when a constructor is " +
    "used as service identifier";
exports.INVALID_DECORATOR_OPERATION = "The @inject @multiInject @tagged and @named decorators " +
    "must be applied to the parameters of a class constructor or a class property.";
exports.ARGUMENTS_LENGTH_MISMATCH = function () {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    return "The number of constructor arguments in the derived class " +
        (values[0] + " must be >= than the number of constructor arguments of its base class.");
};
exports.CONTAINER_OPTIONS_MUST_BE_AN_OBJECT = "Invalid Container constructor argument. Container options " +
    "must be an object.";
exports.CONTAINER_OPTIONS_INVALID_DEFAULT_SCOPE = "Invalid Container option. Default scope must " +
    "be a string ('singleton' or 'transient').";
exports.CONTAINER_OPTIONS_INVALID_AUTO_BIND_INJECTABLE = "Invalid Container option. Auto bind injectable must " +
    "be a boolean";
exports.CONTAINER_OPTIONS_INVALID_SKIP_BASE_CHECK = "Invalid Container option. Skip base check must " +
    "be a boolean";
exports.MULTIPLE_POST_CONSTRUCT_METHODS = "Cannot apply @postConstruct decorator multiple times in the same class";
exports.POST_CONSTRUCT_ERROR = function () {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    return "@postConstruct error in class " + values[0] + ": " + values[1];
};
exports.CIRCULAR_DEPENDENCY_IN_FACTORY = function () {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    return "It looks like there is a circular dependency " +
        ("in one of the '" + values[0] + "' bindings. Please investigate bindings with") +
        ("service identifier '" + values[1] + "'.");
};
exports.STACK_OVERFLOW = "Maximum call stack size exceeded";


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Updatable_1 = __webpack_require__(71);
var Timer = /** @class */ (function (_super) {
    __extends(Timer, _super);
    function Timer(callback, duration, start) {
        var _this = _super.call(this, start) || this;
        _this._startTime = null;
        _this._callback = callback;
        _this._duration = duration;
        _this._startTime = Date.now();
        _this._currentTime = _this._startTime;
        return _this;
    }
    Timer.prototype.stopWithCallback = function () {
        _super.prototype.stop.call(this);
        this._callback();
    };
    Timer.prototype.start = function () {
        _super.prototype.start.call(this);
        this._startTime = Date.now();
        this._currentTime = this._startTime;
        return this;
    };
    Timer.prototype.update = function (dt) {
        this._currentTime += dt;
        var time = this._currentTime;
        if (time - this._startTime > this._duration) {
            this._callback();
            this.stop();
        }
    };
    return Timer;
}(Updatable_1.Updatable));
exports.Timer = Timer;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Action;
(function (Action) {
    Action["NONE"] = "Action::NONE";
    Action["INIT"] = "Action::INIT";
    Action["SPIN"] = "Action::SPIN";
    Action["FREESPIN"] = "Action::FREESPIN";
    Action["MIMICFREESPIN"] = "Action::MIMICFREESPIN";
    Action["RESPIN"] = "Action::RESPIN";
    Action["PICK"] = "Action::PICK";
    Action["SKIPPICK"] = "Action::SKIPPICK";
    Action["AVALANCHE"] = "Action::AVALANCHE";
    Action["SCATTER_AND_AVALANCHE"] = "Action::SCATTER_AND_AVALANCHE";
    Action["EXPLOSION"] = "Action::EXPLOSION";
})(Action = exports.Action || (exports.Action = {}));


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var StopAutoplayButtonEvents = /** @class */ (function () {
    function StopAutoplayButtonEvents() {
    }
    StopAutoplayButtonEvents.STOP_AUTOPLAY_BUTTON_CLICKED = 'StopAutoplayButtonEvents::__STOP_AUTOPLAY_BUTTON_CLICKED__';
    return StopAutoplayButtonEvents;
}());
exports.StopAutoplayButtonEvents = StopAutoplayButtonEvents;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

var gl = {
    createContext:          __webpack_require__(348),
    setVertexAttribArrays:  __webpack_require__(172),
    GLBuffer:               __webpack_require__(349),
    GLFramebuffer:          __webpack_require__(350),
    GLShader:               __webpack_require__(351),
    GLTexture:              __webpack_require__(173),
    VertexArrayObject:      __webpack_require__(352),
    shader:                 __webpack_require__(353)
};

// Export for Node-compatible environments
if (typeof module !== 'undefined' && module.exports)
{
    // Export the module
    module.exports = gl;
}

// Add to the browser window pixi.gl
if (typeof window !== 'undefined')
{
    // add the window object
    window.PIXI = window.PIXI || {};
    window.PIXI.glCore = gl;
}


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreDI = {
    System: Symbol('System'),
    UpdateManager: Symbol('UpdateManager'),
    Device: Symbol('Device'),
    FullscreenManager: Symbol('FullscreenManager'),
    ResolutionManager: Symbol('ResolutionManager'),
    Application: Symbol('PIXI.Application'),
    VisibilityManager: Symbol('VisibilityManager'),
    IAsyncEventManager: Symbol('IAsyncEventManager'),
    IEventManagerWithAsync: Symbol('IEventManagerWithAsync'),
    ResourceLoader: Symbol('ResourceLoader'),
    APIModule: Symbol('APIModule'),
};


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AutoplayMenuEvents = /** @class */ (function () {
    function AutoplayMenuEvents() {
    }
    AutoplayMenuEvents.UPDATE_AUTOPLAY_SPINS = 'AutoplayMenuEvents::UPDATE_AUTOPLAY_SPINS';
    AutoplayMenuEvents.ACCEPTED = 'AutoplayMenuEvents::ACCEPTED';
    AutoplayMenuEvents.CANCELLED = 'AutoplayMenuEvents::CANCELLED';
    AutoplayMenuEvents.BUTTON_PRESSED = 'AutoplayMenuEvents::BUTTON_PRESSED';
    AutoplayMenuEvents.AUTO_PLAY_MENU_OPENED = 'AutoplayMenuEvents::AUTO_PLAY_MENU_OPENED';
    AutoplayMenuEvents.AUTO_PLAY_MENU_CLOSED = 'AutoplayMenuEvents::AUTO_PLAY_MENU_CLOSED';
    AutoplayMenuEvents.UPDATE_AUTOPLAY_VALUES = 'AutoplayMenuEvent::UPDATE_AUTOPLAY_VALUES';
    AutoplayMenuEvents.TRIGGER_BET_MENU = 'AutoplayMenuEvents::TRIGGER_BET_MENU';
    return AutoplayMenuEvents;
}());
exports.AutoplayMenuEvents = AutoplayMenuEvents;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ReelConstants_1 = __webpack_require__(10);
var Easing_1 = __webpack_require__(16);
var GameReelConstants = /** @class */ (function (_super) {
    __extends(GameReelConstants, _super);
    function GameReelConstants() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameReelConstants.initializeFromLayoutGameSpecific = function (layout, viewType) {
        if (viewType === void 0) { viewType = ReelConstants_1.ReelConstants.DEFAULT_VIEW; }
        var reelPosition = layout.getAbsolutePosition('TOP_REEL', viewType);
        var topSymbolSize = layout.getSize('SYMBOL_01', viewType);
        var bottomSymbolSize = layout.getSize('SYMBOL_16', viewType);
        var bottomReelPosition = layout.getAbsolutePosition('BOTTOM_REEL', viewType);
        GameReelConstants.TOP_REELS_OFFSETS[viewType] = { x: reelPosition.x, y: reelPosition.y };
        GameReelConstants.TOP_SYMBOL_SLOT[viewType] = { width: topSymbolSize.width, height: topSymbolSize.height };
        GameReelConstants.BOTTOM_SYMBOL_SLOT[viewType] = { width: bottomSymbolSize.width, height: bottomSymbolSize.height };
        GameReelConstants.BOTTOM_REELS_OFFSETS[viewType] = { x: bottomReelPosition.x, y: bottomReelPosition.y };
        GameReelConstants.recalculateNumbersGameSpecific();
    };
    GameReelConstants.recalculateNumbersGameSpecific = function (viewType) {
        if (viewType === void 0) { viewType = ReelConstants_1.ReelConstants.DEFAULT_VIEW; }
        ReelConstants_1.ReelConstants.REELS_CENTER[viewType] = {
            x: GameReelConstants.TOP_REELS_OFFSETS[viewType].x + (GameReelConstants.TOP_SYMBOL_SLOT[viewType].width * ReelConstants_1.ReelConstants.REELS_AMOUNT) / 2,
            y: GameReelConstants.TOP_REELS_OFFSETS[viewType].y + (GameReelConstants.TOP_SYMBOL_SLOT[viewType].height * ReelConstants_1.ReelConstants.ROW_AMOUNT) / 2,
        };
    };
    GameReelConstants.getTopReelsOffsets = function (viewType) {
        if (viewType === void 0) { viewType = ReelConstants_1.ReelConstants.DEFAULT_VIEW; }
        return GameReelConstants.TOP_REELS_OFFSETS[viewType];
    };
    GameReelConstants.getBottomReelsOffsets = function (viewType) {
        if (viewType === void 0) { viewType = ReelConstants_1.ReelConstants.DEFAULT_VIEW; }
        return GameReelConstants.BOTTOM_REELS_OFFSETS[viewType];
    };
    GameReelConstants.getTopSymbolSlot = function (viewType) {
        if (viewType === void 0) { viewType = ReelConstants_1.ReelConstants.DEFAULT_VIEW; }
        return GameReelConstants.TOP_SYMBOL_SLOT[viewType];
    };
    GameReelConstants.getBottomSymbolSlot = function (viewType) {
        if (viewType === void 0) { viewType = ReelConstants_1.ReelConstants.DEFAULT_VIEW; }
        return GameReelConstants.BOTTOM_SYMBOL_SLOT[viewType];
    };
    GameReelConstants.getSpecificRowSymbolSlot = function (rowIndex) {
        if (rowIndex >= 0 && rowIndex < 3) {
            return GameReelConstants.getTopSymbolSlot();
        }
        else if (rowIndex >= 3 && rowIndex < ReelConstants_1.ReelConstants.ROW_AMOUNT) {
            return GameReelConstants.getBottomSymbolSlot();
        }
        throw new Error("GameReelConstants::getSpecificRowSymbolSlot impossible row " + rowIndex);
    };
    GameReelConstants.getSpecificRowYSymbolPosition = function (rowIndex) {
        if (rowIndex >= 0 && rowIndex < 3) {
            return GameReelConstants.getTopSymbolSlot().height * rowIndex;
        }
        else if (rowIndex >= 3 && rowIndex < ReelConstants_1.ReelConstants.ROW_AMOUNT) {
            return GameReelConstants.getBottomSymbolSlot().height * (rowIndex - 3);
        }
        throw new Error("GameReelConstants::getSpecificRowYSymbolPosition impossible row " + rowIndex);
    };
    GameReelConstants.getReelsOffsetForRow = function (rowIndex) {
        if (rowIndex >= 0 && rowIndex < 3) {
            return GameReelConstants.getTopReelsOffsets();
        }
        else if (rowIndex >= 3 && rowIndex < ReelConstants_1.ReelConstants.ROW_AMOUNT) {
            return GameReelConstants.getBottomReelsOffsets();
        }
        throw new Error("GameReelConstants::getReelsOffsetForRow impossible row " + rowIndex);
    };
    GameReelConstants.getGameSymbolPosition = function (pos) {
        if (pos.y >= 0 && pos.y < 3) {
            return { x: GameReelConstants.getTopReelsOffsets().x + GameReelConstants.getTopSymbolSlot().width * pos.x,
                y: GameReelConstants.getTopReelsOffsets().y + GameReelConstants.getTopSymbolSlot().height * pos.y };
        }
        else if (pos.y >= 3 && pos.y < ReelConstants_1.ReelConstants.ROW_AMOUNT) {
            return { x: GameReelConstants.getBottomReelsOffsets().x + GameReelConstants.getBottomSymbolSlot().width * pos.x,
                y: GameReelConstants.getBottomReelsOffsets().y + GameReelConstants.getBottomSymbolSlot().height * (pos.y - 3) };
        }
        throw new Error("GameReelConstants::getSpecificRowYSymbolPosition impossible row " + pos.y);
    };
    GameReelConstants.getGameSymbolCenterPosition = function (pos) {
        if (pos.y >= 0 && pos.y < 3) {
            return { x: GameReelConstants.getTopReelsOffsets().x + GameReelConstants.getTopSymbolSlot().width * pos.x + GameReelConstants.getTopSymbolSlot().width / 2,
                y: GameReelConstants.getTopReelsOffsets().y + GameReelConstants.getTopSymbolSlot().height * pos.y + GameReelConstants.getTopSymbolSlot().height / 2 };
        }
        else if (pos.y >= 3 && pos.y < ReelConstants_1.ReelConstants.ROW_AMOUNT) {
            return { x: GameReelConstants.getBottomReelsOffsets().x + GameReelConstants.getBottomSymbolSlot().width * pos.x + GameReelConstants.getBottomSymbolSlot().width / 2,
                y: GameReelConstants.getBottomReelsOffsets().y + GameReelConstants.getBottomSymbolSlot().height * (pos.y - 3) + GameReelConstants.getBottomSymbolSlot().height / 2 };
        }
        throw new Error("GameReelConstants::getSpecificRowYSymbolPosition impossible row " + pos.y);
    };
    GameReelConstants.getGameSymbolSize = function (pos) {
        if (pos.y >= 0 && pos.y < 3) {
            return GameReelConstants.getTopSymbolSlot();
        }
        else if (pos.y >= 3 && pos.y < ReelConstants_1.ReelConstants.ROW_AMOUNT) {
            return GameReelConstants.getBottomSymbolSlot();
        }
        throw new Error("GameReelConstants::getGameSymbolSize impossible row " + pos.y);
    };
    GameReelConstants.getAllReelsSize = function () {
        return { width: GameReelConstants.getTopSymbolSlot().width * GameReelConstants.REELS_AMOUNT,
            height: GameReelConstants.getTopSymbolSlot().height * GameReelConstants.TOP_PART_ROWS_AMOUNT
                + GameReelConstants.getBottomSymbolSlot().height * GameReelConstants.BOTTOM_PART_ROWS_AMOUNT };
    };
    GameReelConstants.TOP_SYMBOL_SLOT = [];
    GameReelConstants.BOTTOM_SYMBOL_SLOT = [];
    GameReelConstants.TOP_PART_ROWS_AMOUNT = 3;
    GameReelConstants.BOTTOM_PART_ROWS_AMOUNT = 3;
    GameReelConstants.TOP_REELS_OFFSETS = [];
    GameReelConstants.BOTTOM_REELS_OFFSETS = [];
    return GameReelConstants;
}(ReelConstants_1.ReelConstants));
exports.GameReelConstants = GameReelConstants;
var AvalancheDropConfig = /** @class */ (function () {
    function AvalancheDropConfig() {
    }
    return AvalancheDropConfig;
}());
exports.AvalancheDropConfig = AvalancheDropConfig;
var GameAvalancheConstants = /** @class */ (function (_super) {
    __extends(GameAvalancheConstants, _super);
    function GameAvalancheConstants() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameAvalancheConstants.initDropConfigs = function (isRegulatedMarket) {
        this.dropOutConfig = new AvalancheDropConfig();
        this.dropInConfig = new AvalancheDropConfig();
        this.dropExistingConfig = new AvalancheDropConfig();
        if (isRegulatedMarket) {
            this.dropOutConfig.dropDuration = 260;
            this.dropOutConfig.rowDelay = 80;
            this.dropOutConfig.reelDelay = 80;
            this.dropInConfig.dropDuration = 340;
            this.dropInConfig.rowDelay = 105;
            this.dropInConfig.reelDelay = 330;
            this.dropInConfig.rowDelayTop = 20;
            this.dropInConfig.reelDelayTop = 60;
            this.dropInConfig.topDelay = 1425;
        }
        else {
            this.dropOutConfig.dropDuration = 200;
            this.dropOutConfig.rowDelay = 50;
            this.dropOutConfig.reelDelay = 40;
            this.dropInConfig.dropDuration = 320;
            this.dropInConfig.rowDelay = 65;
            this.dropInConfig.reelDelay = 150;
            this.dropInConfig.rowDelayTop = 13;
            this.dropInConfig.reelDelayTop = 30;
            this.dropInConfig.topDelay = 710;
        }
        this.dropExistingConfig.dropDuration = 400;
        this.dropExistingConfig.rowDelay = 20;
        this.dropExistingConfig.reelDelay = 20;
    };
    GameAvalancheConstants.DROP_EASING = Easing_1.Bezier.bezier(0.2, 1.2, 0.7, 1);
    return GameAvalancheConstants;
}(ReelConstants_1.AvalancheConstants));
exports.GameAvalancheConstants = GameAvalancheConstants;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Module_1 = __webpack_require__(2);
var LogicEvents_1 = __webpack_require__(11);
var BonusGameEvents_1 = __webpack_require__(78);
var FlowModuleEvents_1 = __webpack_require__(0);
var FlowAvalancheState_1 = __webpack_require__(283);
var FlowBasicState_1 = __webpack_require__(284);
var FlowBonusState_1 = __webpack_require__(544);
var FlowFreeSpinsState_1 = __webpack_require__(285);
var FlowRespinState_1 = __webpack_require__(286);
var FlowRestoreState_1 = __webpack_require__(287);
var FlowWhileSpinningState_1 = __webpack_require__(288);
var FreeSpinsEvents_1 = __webpack_require__(6);
var AvalancheReelsEvents_1 = __webpack_require__(15);
var IndividualSymbolReelsEvents_1 = __webpack_require__(116);
var ReelsEvents_1 = __webpack_require__(4);
var RestoreScreenEvents_1 = __webpack_require__(251);
var FlowModule = /** @class */ (function (_super) {
    __extends(FlowModule, _super);
    function FlowModule() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._isRestore = false;
        _this._isInsideFreeSpins = false;
        _this._isInsideFreeSpinsRestore = false;
        _this._isRestoreMessageOnTheScreen = false;
        return _this;
    }
    FlowModule.prototype.setupStates = function () {
        this.addState(new FlowBasicState_1.FlowBasicState(this, FlowModule.BASIC_STATE, this.eventManager));
        this.addState(new FlowFreeSpinsState_1.FlowFreeSpinsState(this, FlowModule.FREE_SPINS_STATE, this.eventManager));
        this.addState(new FlowBonusState_1.FlowBonusState(this, FlowModule.BONUS_STATE, this.eventManager));
        this.addState(new FlowRestoreState_1.FlowRestoreState(this, FlowModule.RESTORE_STATE));
        this.addState(new FlowRespinState_1.FlowRespinState(this, FlowModule.RESPIN_STATE, this.eventManager));
        this.addState(new FlowAvalancheState_1.FlowAvalancheState(this, FlowModule.AVALANCHE_STATE, this.eventManager));
        this.addState(new FlowWhileSpinningState_1.FlowWhileSpinningState(this, FlowModule.WHILESPIN_STATE, this.eventManager));
    };
    FlowModule.prototype.restore = function () {
        _super.prototype.restore.call(this);
        if (this.logic.isFreeSpinsStarted) {
            this._isInsideFreeSpins = true;
            this.gotoState(FlowModule.FREE_SPINS_STATE);
        }
    };
    FlowModule.prototype.afterInit = function () {
        this.eventManager.emit(FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN);
        this.system.endLoading();
    };
    FlowModule.prototype.setupEvents = function () {
        this.onCurrentStateHandle(ReelsEvents_1.ReelsEvents.SPIN_ENDED);
        this.onCurrentStateHandle(AvalancheReelsEvents_1.AvalancheReelsEvents.AVALANCHE_FINISHED);
        this.onCurrentStateHandle(AvalancheReelsEvents_1.AvalancheReelsEvents.SYMBOLS_RESPIN_FINISHED);
        this.onCurrentStateHandle(AvalancheReelsEvents_1.AvalancheReelsEvents.SYMBOLS_RESPIN_STARTED);
        this.onCurrentStateHandle(FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN);
        this.onCurrentStateHandle(LogicEvents_1.LogicEvents.PICK_RESPONSE);
        this.onCurrentStateHandle(LogicEvents_1.LogicEvents.SKIPPICK_RESPONSE);
        this.onCurrentStateHandle(LogicEvents_1.LogicEvents.SPIN_RESPONSE);
        this.onCurrentStateHandle(FlowModuleEvents_1.FlowModuleEvents.CAN_CONTINUE_SPIN);
        this.onCurrentStateHandle(BonusGameEvents_1.BonusGameEvents.BONUS_OUTRO_FINISHED);
        this.onCurrentStateHandle(AvalancheReelsEvents_1.AvalancheReelsEvents.ADDING_NEW_FINISHED);
        this.onCurrentStateHandle(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_INTRO_FINISHED);
        this.onCurrentStateHandle(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_OUTRO_FINISHED);
        this.onCurrentStateHandle(IndividualSymbolReelsEvents_1.IndividualSymbolReelsEvents.INDIVIDUAL_RESPIN_FINISHED);
        this.on(ReelsEvents_1.ReelsEvents.REELS_SPINNING_STARTED, this.onReelsSpinningStarted);
        this.on(ReelsEvents_1.ReelsEvents.REELS_RESPIN_STARTED, this.onReelsReSpinningStarted);
        this.on(RestoreScreenEvents_1.RestoreScreenEvents.RESTORE_WINDOW_CLOSED, this.onRestoreWindowClosed);
        this.on(RestoreScreenEvents_1.RestoreScreenEvents.RESTORE_WINDOW_OPENED, this.onRestoreWindowOpened);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_INTRO_STARTED, this.onFreeSpinsIntroStarted);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_RESTORE_INTRO_STARTED, this.onFreeSpinsRestoreIntroStarted);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_OUTRO_FINISHED, this.onFreeSpinsOutroFinished);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_INTRO_FINISHED, this.onFreeSpinsIntroFinished);
    };
    FlowModule.prototype.onFreeSpinsIntroStarted = function () {
        this._isInsideFreeSpins = true;
    };
    FlowModule.prototype.onFreeSpinsRestoreIntroStarted = function () {
        this._isInsideFreeSpinsRestore = true;
    };
    FlowModule.prototype.onFreeSpinsIntroFinished = function () {
        if (this._isInsideFreeSpinsRestore) {
            this.gotoState(FlowModule.FREE_SPINS_STATE);
            this._isInsideFreeSpinsRestore = false;
        }
    };
    FlowModule.prototype.onFreeSpinsOutroFinished = function () {
        this._isInsideFreeSpins = false;
    };
    FlowModule.prototype.onRestoreWindowOpened = function () {
        this._isRestoreMessageOnTheScreen = true;
    };
    FlowModule.prototype.onRestoreWindowClosed = function () {
        this._isRestoreMessageOnTheScreen = false;
        if (!this._isInsideFreeSpinsRestore) {
            this._currentState.handle(ReelsEvents_1.ReelsEvents.SPIN_ENDED);
        }
    };
    FlowModule.prototype.onReelsSpinningStarted = function () {
        if (!this.logic.isFreeSpinsStarted) {
            this.gotoState(FlowModule.BASIC_STATE);
        }
        this._currentState.handle(ReelsEvents_1.ReelsEvents.REELS_SPINNING_STARTED);
        this.gotoState(FlowModule.WHILESPIN_STATE);
    };
    FlowModule.prototype.onReelsReSpinningStarted = function () { };
    FlowModule.prototype.setupViews = function () { };
    FlowModule.prototype.enterFirstState = function () {
        this.changeStateTo(FlowModule.BASIC_STATE);
    };
    Object.defineProperty(FlowModule.prototype, "isRestore", {
        get: function () {
            return this._isRestore;
        },
        set: function (isRestore) {
            this._isRestore = isRestore;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FlowModule.prototype, "isInsideFreeSpins", {
        get: function () {
            return this._isInsideFreeSpins;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FlowModule.prototype, "isInsideFreeSpinsRestore", {
        get: function () {
            return this._isInsideFreeSpinsRestore;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FlowModule.prototype, "isRestoreMessageOnTheScreen", {
        get: function () {
            return this._isRestoreMessageOnTheScreen;
        },
        enumerable: true,
        configurable: true
    });
    FlowModule.RESTORE_STATE = 'restore';
    FlowModule.BASIC_STATE = 'basic';
    FlowModule.FREE_SPINS_STATE = 'freespins';
    FlowModule.BONUS_STATE = 'bonus';
    FlowModule.RESPIN_STATE = 'respin';
    FlowModule.AVALANCHE_STATE = 'avalanche';
    FlowModule.WHILESPIN_STATE = 'whilespin';
    return FlowModule;
}(Module_1.Module));
exports.FlowModule = FlowModule;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var METADATA_KEY = __webpack_require__(18);
var Metadata = (function () {
    function Metadata(key, value) {
        this.key = key;
        this.value = value;
    }
    Metadata.prototype.toString = function () {
        if (this.key === METADATA_KEY.NAMED_TAG) {
            return "named: " + this.value.toString() + " ";
        }
        else {
            return "tagged: { key:" + this.key.toString() + ", value: " + this.value + " }";
        }
    };
    return Metadata;
}());
exports.Metadata = Metadata;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Updatable_1 = __webpack_require__(71);
var GameUtils_1 = __webpack_require__(26);
var SpineAnimation = /** @class */ (function (_super) {
    __extends(SpineAnimation, _super);
    function SpineAnimation(spine, name, loop, dontDestroyOnComplete) {
        var _this = _super.call(this) || this;
        _this._loopComplete = false;
        _this._loopCount = 0;
        _this._loopLimit = -1;
        _this._spine = spine;
        _this._name = name;
        _this._loop = loop;
        _this._dontDestroyOnComplete = dontDestroyOnComplete;
        return _this;
    }
    SpineAnimation.prototype.setOnComplete = function (callback) {
        this._completeCallback = callback;
    };
    SpineAnimation.prototype.setLoopLimit = function (loopLimit) {
        this._loopLimit = loopLimit;
    };
    SpineAnimation.prototype.start = function () {
        var _this = this;
        _super.prototype.start.call(this);
        if (false) {
            this.debugcheckHasAnimation(this._name);
        }
        this._spine.state.setAnimation(0, this._name, this._loop);
        if (!this._loop) {
            this._spine.state.addListener({
                complete: function () {
                    // we cannot destroy spine here because we're in the middle of Spine::update()
                    _this._completed = true;
                },
            });
        }
        else {
            if (this._loopLimit > 0) {
                this._spine.state.addListener({
                    complete: function () {
                        _this._loopCount++;
                        if (_this._loopCount === _this._loopLimit) {
                            _this._loopLimit = -1;
                            _this._completed = true;
                        }
                    },
                });
            }
        }
        // initial state
        this.update(0);
    };
    SpineAnimation.prototype.stop = function () {
        _super.prototype.stop.call(this);
        this.unChainIdleAnimation();
        if (!this._dontDestroyOnComplete) {
            if (this._spine && this._spine.skeleton) {
                this._spine.destroy();
            }
        }
    };
    SpineAnimation.prototype.forceDestroy = function () {
        this.stop();
        if (this._spine && this._spine.skeleton) {
            this._spine.destroy();
        }
    };
    SpineAnimation.prototype.hasAnimationWithName = function (name) {
        return this._spine.state.hasAnimation(name);
    };
    SpineAnimation.prototype.update = function (dt) {
        this._spine.update(dt);
        if (this._completed) {
            this._completed = false;
            this._completeCallback && this._completeCallback();
            if (this._chainedIdle && this.chainIdleAnimation) {
                this._completed = false;
                this.changeAnimationTo(this._chainedIdleAnimation, true);
                this.start();
            }
            else {
                this.stop();
            }
        }
    };
    SpineAnimation.prototype.changeAnimationTo = function (name, loop, loopLimit) {
        var _this = this;
        if (loopLimit === void 0) { loopLimit = -1; }
        this._name = name;
        this._loop = loop;
        this._loopCount = 0;
        this._loopLimit = loopLimit;
        if (false) {
            this.debugcheckHasAnimation(name);
        }
        this._spine.state.setAnimation(0, name, loop);
        if (!this._loop) {
            this._spine.state.addListener({
                complete: function () {
                    // we cannot destroy spine here because we're in the middle of Spine::update()
                    _this._completed = true;
                },
            });
        }
        else {
            this._spine.state.clearListeners();
            if (this._loopLimit > 0) {
                this._spine.state.addListener({
                    complete: function () {
                        _this._loopCount++;
                        if (_this._loopCount === _this._loopLimit) {
                            _this._loopLimit = -1;
                            _this._completed = true;
                        }
                    },
                });
            }
        }
        // initial state
        this.update(0);
    };
    SpineAnimation.prototype.chainIdleAnimation = function (name) {
        this._chainedIdle = true;
        this._chainedIdleAnimation = name;
    };
    SpineAnimation.prototype.unChainIdleAnimation = function () {
        this._chainedIdle = false;
        this._chainedIdleAnimation = null;
    };
    SpineAnimation.prototype.gotoRandomAnimationPosition = function () {
        this._spine.state.getCurrent(0).trackTime = GameUtils_1.GameUtils.randomInt(0, this._spine.state.getCurrent(0).animationEnd);
    };
    SpineAnimation.prototype.gotoAnimationFrame = function (frame, trackIndex) {
        if (trackIndex === void 0) { trackIndex = 0; }
        this._spine.state.getCurrent(trackIndex).trackTime = frame / 60;
    };
    Object.defineProperty(SpineAnimation.prototype, "timeScale", {
        get: function () {
            return this.container.state.timeScale;
        },
        set: function (value) {
            this.container.state.timeScale = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpineAnimation.prototype, "container", {
        get: function () {
            return this._spine;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpineAnimation.prototype, "name", {
        get: function () {
            return this._name;
        },
        enumerable: true,
        configurable: true
    });
    SpineAnimation.prototype.debugcheckHasAnimation = function (animationName) {
        var hasAnimation = !!this._spine.stateData.skeletonData.findAnimation(animationName);
        if (!hasAnimation) {
            console.warn("Animation " + animationName + " not found on: " + this._spine.stateData.skeletonData.name);
        }
        return hasAnimation;
    };
    return SpineAnimation;
}(Updatable_1.Updatable));
exports.SpineAnimation = SpineAnimation;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
var ReelConstants_1 = __webpack_require__(10);
var Symbols;
(function (Symbols) {
    Symbols[Symbols["WR"] = 0] = "WR";
    // medium wins
    Symbols[Symbols["M1"] = 1] = "M1";
    Symbols[Symbols["M2"] = 2] = "M2";
    Symbols[Symbols["M3"] = 3] = "M3";
    Symbols[Symbols["M4"] = 4] = "M4";
    Symbols[Symbols["M5"] = 5] = "M5";
    // low wins
    Symbols[Symbols["F6"] = 6] = "F6";
    Symbols[Symbols["F7"] = 7] = "F7";
    Symbols[Symbols["F8"] = 8] = "F8";
    Symbols[Symbols["F9"] = 9] = "F9";
    Symbols[Symbols["F10"] = 10] = "F10";
    // other
    Symbols[Symbols["BN"] = 11] = "BN";
    Symbols[Symbols["RS"] = 12] = "RS";
    Symbols[Symbols["TOP_WR"] = 13] = "TOP_WR";
    Symbols[Symbols["TOP_BN"] = 14] = "TOP_BN";
    Symbols[Symbols["TOP_RS"] = 15] = "TOP_RS";
})(Symbols = exports.Symbols || (exports.Symbols = {}));
var SymbolsCreation = /** @class */ (function () {
    function SymbolsCreation() {
    }
    SymbolsCreation.addBackgroundsIntoSprite = function (spr, resources, viewType) {
        if (viewType === void 0) { viewType = ReelConstants_1.ReelConstants.DEFAULT_VIEW; }
    };
    SymbolsCreation.addAllSymbolsIntoSprite = function (spr, resources, viewType) {
        if (viewType === void 0) { viewType = ReelConstants_1.ReelConstants.DEFAULT_VIEW; }
        spr.addChild(new PIXI.Sprite(resources.getSpritesheetTexture('SYMBOLS.json', "WR.png", viewType))); // wild x1
        spr.addChild(new PIXI.Sprite(resources.getSpritesheetTexture('SYMBOLS.json', "M1.png", viewType))); // medium win symbol
        spr.addChild(new PIXI.Sprite(resources.getSpritesheetTexture('SYMBOLS.json', "M2.png", viewType))); // medium win symbol
        spr.addChild(new PIXI.Sprite(resources.getSpritesheetTexture('SYMBOLS.json', "M3.png", viewType))); // medium win symbol
        spr.addChild(new PIXI.Sprite(resources.getSpritesheetTexture('SYMBOLS.json', "M4.png", viewType))); // medium win symbol
        spr.addChild(new PIXI.Sprite(resources.getSpritesheetTexture('SYMBOLS.json', "M5.png", viewType))); // medium win symbol
        spr.addChild(new PIXI.Sprite(resources.getSpritesheetTexture('SYMBOLS.json', "F6.png", viewType))); // low win symbol
        spr.addChild(new PIXI.Sprite(resources.getSpritesheetTexture('SYMBOLS.json', "F7.png", viewType))); // low win symbol
        spr.addChild(new PIXI.Sprite(resources.getSpritesheetTexture('SYMBOLS.json', "F8.png", viewType))); // low win symbol
        spr.addChild(new PIXI.Sprite(resources.getSpritesheetTexture('SYMBOLS.json', "F9.png", viewType))); // low win symbol
        spr.addChild(new PIXI.Sprite(resources.getSpritesheetTexture('SYMBOLS.json', "F10.png", viewType))); // low win symbol
        spr.addChild(new PIXI.Sprite(resources.getSpritesheetTexture('SYMBOLS.json', "BN.png", viewType))); // Scatter
        spr.addChild(new PIXI.Sprite(resources.getSpritesheetTexture('SYMBOLS.json', "RS.png", viewType))); // respin
        spr.addChild(new PIXI.Sprite(resources.getSpritesheetTexture('SYMBOLS.json', "TOP_WR.png", viewType))); // TOP wild
        spr.addChild(new PIXI.Sprite(resources.getSpritesheetTexture('SYMBOLS.json', "TOP_BN.png", viewType))); // TOP scatter
        spr.addChild(new PIXI.Sprite(resources.getSpritesheetTexture('SYMBOLS.json', "TOP_RS.png", viewType))); // TOP Respin
    };
    return SymbolsCreation;
}());
exports.SymbolsCreation = SymbolsCreation;
var SymbolMultipliers;
(function (SymbolMultipliers) {
    SymbolMultipliers[SymbolMultipliers["SYM_X_1"] = 1] = "SYM_X_1";
    SymbolMultipliers[SymbolMultipliers["SYM_X_2"] = 2] = "SYM_X_2";
    SymbolMultipliers[SymbolMultipliers["SYM_X_3"] = 3] = "SYM_X_3";
    SymbolMultipliers[SymbolMultipliers["SYM_X_4"] = 4] = "SYM_X_4";
    SymbolMultipliers[SymbolMultipliers["SYM_X_5"] = 5] = "SYM_X_5";
})(SymbolMultipliers = exports.SymbolMultipliers || (exports.SymbolMultipliers = {}));
var SymbolPayouts = /** @class */ (function () {
    function SymbolPayouts() {
    }
    SymbolPayouts.paytable = (_a = {},
        _a[Symbols.WR] = {
            values: (_b = {},
                _b[SymbolMultipliers.SYM_X_1] = 0,
                _b[SymbolMultipliers.SYM_X_2] = 0,
                _b[SymbolMultipliers.SYM_X_3] = 10,
                _b[SymbolMultipliers.SYM_X_4] = 70,
                _b[SymbolMultipliers.SYM_X_5] = 200,
                _b),
            id: Symbols.WR,
        },
        _a[Symbols.M1] = {
            values: (_c = {},
                _c[SymbolMultipliers.SYM_X_1] = 0,
                _c[SymbolMultipliers.SYM_X_2] = 0,
                _c[SymbolMultipliers.SYM_X_3] = 10,
                _c[SymbolMultipliers.SYM_X_4] = 70,
                _c[SymbolMultipliers.SYM_X_5] = 200,
                _c),
            id: Symbols.M1,
        },
        _a[Symbols.M2] = {
            values: (_d = {},
                _d[SymbolMultipliers.SYM_X_1] = 0,
                _d[SymbolMultipliers.SYM_X_2] = 0,
                _d[SymbolMultipliers.SYM_X_3] = 10,
                _d[SymbolMultipliers.SYM_X_4] = 60,
                _d[SymbolMultipliers.SYM_X_5] = 175,
                _d),
            id: Symbols.M2,
        },
        _a[Symbols.M3] = {
            values: (_e = {},
                _e[SymbolMultipliers.SYM_X_1] = 0,
                _e[SymbolMultipliers.SYM_X_2] = 0,
                _e[SymbolMultipliers.SYM_X_3] = 10,
                _e[SymbolMultipliers.SYM_X_4] = 50,
                _e[SymbolMultipliers.SYM_X_5] = 150,
                _e),
            id: Symbols.M3,
        },
        _a[Symbols.M4] = {
            values: (_f = {},
                _f[SymbolMultipliers.SYM_X_1] = 0,
                _f[SymbolMultipliers.SYM_X_2] = 0,
                _f[SymbolMultipliers.SYM_X_3] = 10,
                _f[SymbolMultipliers.SYM_X_4] = 40,
                _f[SymbolMultipliers.SYM_X_5] = 125,
                _f),
            id: Symbols.M4,
        },
        _a[Symbols.M5] = {
            values: (_g = {},
                _g[SymbolMultipliers.SYM_X_1] = 0,
                _g[SymbolMultipliers.SYM_X_2] = 0,
                _g[SymbolMultipliers.SYM_X_3] = 10,
                _g[SymbolMultipliers.SYM_X_4] = 30,
                _g[SymbolMultipliers.SYM_X_5] = 100,
                _g),
            id: Symbols.M5,
        },
        _a[Symbols.F6] = {
            values: (_h = {},
                _h[SymbolMultipliers.SYM_X_1] = 0,
                _h[SymbolMultipliers.SYM_X_2] = 0,
                _h[SymbolMultipliers.SYM_X_3] = 5,
                _h[SymbolMultipliers.SYM_X_4] = 15,
                _h[SymbolMultipliers.SYM_X_5] = 30,
                _h),
            id: Symbols.F6,
        },
        _a[Symbols.F7] = {
            values: (_j = {},
                _j[SymbolMultipliers.SYM_X_1] = 0,
                _j[SymbolMultipliers.SYM_X_2] = 0,
                _j[SymbolMultipliers.SYM_X_3] = 5,
                _j[SymbolMultipliers.SYM_X_4] = 15,
                _j[SymbolMultipliers.SYM_X_5] = 30,
                _j),
            id: Symbols.F7,
        },
        _a[Symbols.F8] = {
            values: (_k = {},
                _k[SymbolMultipliers.SYM_X_1] = 0,
                _k[SymbolMultipliers.SYM_X_2] = 0,
                _k[SymbolMultipliers.SYM_X_3] = 2,
                _k[SymbolMultipliers.SYM_X_4] = 10,
                _k[SymbolMultipliers.SYM_X_5] = 20,
                _k),
            id: Symbols.F8,
        },
        _a[Symbols.F9] = {
            values: (_l = {},
                _l[SymbolMultipliers.SYM_X_1] = 0,
                _l[SymbolMultipliers.SYM_X_2] = 0,
                _l[SymbolMultipliers.SYM_X_3] = 2,
                _l[SymbolMultipliers.SYM_X_4] = 10,
                _l[SymbolMultipliers.SYM_X_5] = 20,
                _l),
            id: Symbols.F9,
        },
        _a[Symbols.F10] = {
            values: (_m = {},
                _m[SymbolMultipliers.SYM_X_1] = 0,
                _m[SymbolMultipliers.SYM_X_2] = 0,
                _m[SymbolMultipliers.SYM_X_3] = 2,
                _m[SymbolMultipliers.SYM_X_4] = 10,
                _m[SymbolMultipliers.SYM_X_5] = 20,
                _m),
            id: Symbols.F10,
        },
        _a);
    return SymbolPayouts;
}());
exports.SymbolPayouts = SymbolPayouts;


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var GameAvalancheReelsEvents = /** @class */ (function () {
    function GameAvalancheReelsEvents() {
    }
    GameAvalancheReelsEvents.WIN_HIGHLIGHTING_FINISHED = 'GameAvalancheReelEvents::WIN_HIGHLIGHTING_FINISHED';
    GameAvalancheReelsEvents.WIN_HIGHLIGHTING_STARTED = 'GameAvalancheReelEvents::WIN_HIGHLIGHTING_STARTED';
    GameAvalancheReelsEvents.WIN_HIGHLIGHTING_WINLINE = 'GameAvalancheReelEvents::WIN_HIGHLIGHTING_WINLINE';
    GameAvalancheReelsEvents.WIN_SYMBOLS_EXPLOSION_STARTED = 'GameAvalancheReelEvents::WIN_SYMBOLS_EXPLOSION_STARTED';
    GameAvalancheReelsEvents.SYMBOL_PASSED_THROUGHT_LINE = 'GameAvalancheReelEvents::SYMBOL_PASSED_THROUGHT_LINE';
    GameAvalancheReelsEvents.SCATTER_ATTENTION_TRIGGERED = 'GameAvalancheReelEvents::SCATTER_ATTENTION_TRIGGERED';
    GameAvalancheReelsEvents.RESPIN_ATTENTION_TRIGGERED = 'GameAvalancheReelEvents::RESPIN_ATTENTION_TRIGGERED';
    GameAvalancheReelsEvents.FILLING_VOIDS_STARTED = 'GameAvalancheReelEvents::FILLING_VOIDS_STARTED';
    return GameAvalancheReelsEvents;
}());
exports.GameAvalancheReelsEvents = GameAvalancheReelsEvents;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var GameWinPresentationEvents = /** @class */ (function () {
    function GameWinPresentationEvents() {
    }
    GameWinPresentationEvents.AFTER_MULTIPLIER_COUNTING_FINISHED = 'GameWinPresentationEvents::AFTER_MULTIPLIER_COUNTING_FINISHED';
    GameWinPresentationEvents.PRE_MULTIPLIER_BIG_WIN_FINISHED = 'GameWinPresentationEvents::PRE_MULTIPLIER_BIG_WIN_FINISHED';
    GameWinPresentationEvents.COUNTING_STARTED = 'GameWinPresentationEvents::COUNTING_STARTED';
    return GameWinPresentationEvents;
}());
exports.GameWinPresentationEvents = GameWinPresentationEvents;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(50)))

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = __webpack_require__(14);
var DeviceType_1 = __webpack_require__(106);
var Device = /** @class */ (function () {
    function Device(onInitialized) {
        this._samsungNativeBrowser = false;
        this._isOppoBrowser = false;
        this._fullscreenDisabledByIntegration = false;
        this._iOSRunningAsDesktop = false;
        this._onInitialized = onInitialized;
        this._readyCheckListener = this._readyCheck.bind(this);
        if (document.readyState === 'complete' || document.readyState === 'interactive') {
            // why is there an additional timeout here?
            window.setTimeout(this._readyCheckListener, 0);
        }
        else {
            document.addEventListener('DOMContentLoaded', this._readyCheckListener, false);
            window.addEventListener('load', this._readyCheckListener, false);
        }
    }
    /**
     * check whether the host environment can play audio
     * @param type One of 'mp3, 'ogg', 'wav', 'opus'
     * @returns {boolean}
     */
    Device.prototype.canPlayAudio = function (type) {
        if (type === 'mp3' && this._mp3) {
            return true;
        }
        else if (type === 'm4a' && this._m4a) {
            return true;
        }
        else if (type === 'ogg' && (this._ogg || this._opus)) {
            return true;
        }
        else if (type === 'opus' && this._opus) {
            return true;
        }
        else if (type === 'wav' && this._wav) {
            return true;
        }
        return false;
    };
    Device.prototype.getSoundFormat = function () {
        if (this.canPlayAudio('ogg')) {
            return 'ogg';
        }
        else if (this.canPlayAudio('m4a')) {
            return 'm4a';
        }
        return null;
    };
    Device.prototype.getSoundQuality = function () {
        if (PIXI.sound.useLegacy) {
            return 'low';
        }
        else if (this.desktop) {
            return 'hi';
        }
        else {
            return 'mid';
        }
    };
    Device.prototype._readyCheck = function () {
        if (!document.body) {
            window.setTimeout(this._readyCheckListener, 20);
        }
        else if (!this._deviceReadyAt) {
            this._deviceReadyAt = Date.now();
            document.removeEventListener('DOMContentLoaded', this._readyCheckListener);
            window.removeEventListener('load', this._readyCheckListener);
            this._initialize();
            this._initialized = true;
            this._onInitialized(this);
        }
    };
    Device.prototype._initialize = function () {
        // Run the checks
        this._checkOS();
        this._checkBrowser();
        this._checkAudio();
        this._checkDevice();
        this._checkFeatures();
        this._checkFullScreenSupport();
        this._checkIframe();
        this._checkWebP();
        this._checkType();
    };
    Device.prototype._checkOS = function () {
        var ua = navigator.userAgent;
        if (/Playstation Vita/.test(ua)) {
            // this.vita = true;
        }
        else if (/Kindle/.test(ua) || /\bKF[A-Z][A-Z]+/.test(ua) || /Silk.*Mobile Safari/.test(ua)) {
            // this.kindle = true;
            // This will NOT detect early generations of Kindle Fire, I think there is no reliable way...
            // E.g. "Mozilla/5.0 (Macintosh; U; Intel Mac OS X 10_6_3; en-us; Silk/1.1.0-80)
            // AppleWebKit/533.16 (KHTML, like Gecko) Version/5.0 Safari/533.16 Silk-Accelerated=true"
        }
        else if (/Android/.test(ua)) {
            this._android = true;
        }
        else if (/CrOS/.test(ua)) {
            this._chromeOS = true;
        }
        else if (/iP[ao]d|iPhone/i.test(ua)) {
            this._iOS = true;
            navigator.appVersion.match(/OS (\d+)/);
            this._iOSVersion = parseInt(RegExp.$1, 10);
        }
        else if (/Linux/.test(ua)) {
            this._linux = true;
        }
        else if (/Mac OS/.test(ua)) {
            this._macOS = true;
        }
        else if (/Windows/.test(ua)) {
            this._windows = true;
        }
        // HEADSUP! Sneaky fix for Ipads running Request Desktop mode.
        // Should maybe work for Iphones too.
        // https://github.com/google/model-viewer/pull/779/files
        if (!this._iOS) {
            this._iOS = (/iPad|iPhone|iPod/.test(navigator.userAgent) && !self.MSStream) ||
                (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
            if (this._iOS) {
                // this._macOS = false;
                // this._desktop = false;
                this._iOSRunningAsDesktop = true;
            }
        }
        if (/Windows Phone/i.test(ua) || /IEMobile/i.test(ua)) {
            this._android = false;
            this._iOS = false;
            this._macOS = false;
            this._windows = true;
            this._windowsPhone = true;
        }
        var silk = /Silk/.test(ua); // detected in browsers
        if (this._windows || this._macOS || (this._linux && !silk) || this._chromeOS) {
            this._desktop = true;
        }
        // Windows Phone / Table reset
        if (this._windowsPhone || (/Windows NT/i.test(ua) && /Touch/i.test(ua))) {
            this._desktop = false;
        }
        this._iosChrome = ua.indexOf('CriOS') !== -1;
        this._touch = this._detectTouchscreen();
    };
    Device.prototype._detectTouchscreen = function () {
        // From https://patrickhlauke.github.io/touch/touchscreen-detection/
        var result = false;
        if (window.PointerEvent && ('maxTouchPoints' in navigator)) {
            // if Pointer Events are supported, just check maxTouchPoints
            if (navigator.maxTouchPoints > 0) {
                result = true;
            }
        }
        else {
            // no Pointer Events...
            if (window.matchMedia && window.matchMedia('(any-pointer:coarse)').matches) {
                // check for any-pointer:coarse which mostly means touchscreen
                result = true;
            }
            else if (window.TouchEvent || ('ontouchstart' in window)) {
                // last resort - check for exposed touch events API / event handler
                result = true;
            }
        }
        return result;
    };
    Device.prototype._checkFullScreenSupport = function () {
        var fs = [
            'requestFullscreen',
            'requestFullScreen',
            'webkitRequestFullscreen',
            'webkitRequestFullScreen',
            'msRequestFullscreen',
            'msRequestFullScreen',
            'mozRequestFullScreen',
            'mozRequestFullscreen',
        ];
        var element = document.createElement('div');
        for (var _i = 0, fs_1 = fs; _i < fs_1.length; _i++) {
            var fsValue = fs_1[_i];
            if (element[fsValue]) {
                this._fullscreen = true;
                this._requestFullscreen = fsValue;
                break;
            }
        }
        var cfs = [
            'cancelFullScreen',
            'exitFullscreen',
            'webkitCancelFullScreen',
            'webkitExitFullscreen',
            'msCancelFullScreen',
            'msExitFullscreen',
            'mozCancelFullScreen',
            'mozExitFullscreen',
        ];
        if (this._fullscreen) {
            for (var _a = 0, cfs_1 = cfs; _a < cfs_1.length; _a++) {
                var cfsValue = cfs_1[_a];
                if (element[cfsValue]) {
                    this._cancelFullscreen = cfsValue;
                    break;
                }
            }
        }
        var fse = [
            'fullscreenElement',
            'fullScreenElement',
            'webkitFullscreenElement',
            'webkitCurrentFullScreenElement',
            'mozFullScreenElement',
            'msFullscreenElement',
        ];
        if (this._fullscreen) {
            for (var _b = 0, fse_1 = fse; _b < fse_1.length; _b++) {
                var fseValue = fse_1[_b];
                if (fseValue in document) {
                    this._fullscreenElement = fseValue;
                    break;
                }
            }
        }
        // Keyboard Input?
        if (window.Element && window.Element.ALLOW_KEYBOARD_INPUT) {
            this._fullscreenKeyboard = true;
        }
    };
    Device.prototype._checkIframe = function () {
        // If the iFrame is cross origin it would throw an exception
        try {
            this._iframe = window.self !== window.top;
        }
        catch (e) {
            this._iframe = true;
        }
    };
    Device.prototype._checkBrowser = function () {
        var ua = navigator.userAgent;
        if (/Edge\/\d+/.test(ua)) {
            this._edge = true;
        }
        else if (/OppoBrowser\/(\d+)/.test(ua) && !this._windowsPhone) {
            this._isOppoBrowser = true;
        }
        else if (/SamsungBrowser\/(\d+)/.test(ua) && !this._windowsPhone) {
            this._samsungNativeBrowser = true;
        }
        else if (/Chrome\/(\d+)/.test(ua) && !this._windowsPhone) {
            this._chrome = true;
            this._chromeVersion = parseInt(RegExp.$1, 10);
        }
        else if (/Firefox\D+(\d+)/.test(ua)) {
            this._firefox = true;
            this._firefoxVersion = parseInt(RegExp.$1, 10);
        }
        else if (/AppleWebKit/.test(ua) && this._iOS) {
            this._mobileSafari = true;
        }
        else if (/MSIE (\d+\.\d+);/.test(ua)) {
            this._ie = true;
            this._ieVersion = parseInt(RegExp.$1, 10);
        }
        else if (/Opera/.test(ua)) {
            this._opera = true;
        }
        else if (/Safari\/(\d+)/.test(ua) && !this._windowsPhone) {
            this._safari = true;
            if (/Version\/(\d+)\./.test(ua)) {
                this._safariVersion = parseInt(RegExp.$1, 10);
            }
        }
        else if (/Trident\/(\d+\.\d+)(.*)rv:(\d+\.\d+)/.test(ua)) {
            this._ie = true;
            this._trident = true;
            this._tridentVersion = parseInt(RegExp.$1, 10);
            this._ieVersion = parseInt(RegExp.$3, 10);
        }
        // WebApp mode in iOS
        if (navigator.standalone) {
            this._webApp = true;
        }
    };
    Device.prototype._checkAudio = function () {
        this._audioData = !!window.Audio;
        this._webAudioContextConstructor = window.AudioContext || window.webkitAudioContext;
        var audioElement = document.createElement('audio');
        try {
            if (!!audioElement.canPlayType) {
                if (audioElement.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, '')) {
                    this._ogg = true;
                }
                if (audioElement.canPlayType('audio/ogg; codecs="opus"').replace(/^no$/, '') ||
                    audioElement.canPlayType('audio/opus;').replace(/^no$/, '')) {
                    this._opus = true;
                }
                if (audioElement.canPlayType('audio/mpeg;').replace(/^no$/, '')) {
                    this._mp3 = true;
                }
                // Mimetypes accepted:
                //   developer.mozilla.org/En/Media_formats_supported_by_the_audio_and_video_elements
                //   bit.ly/iphoneoscodecs
                if (audioElement.canPlayType('audio/wav; codecs="1"').replace(/^no$/, '')) {
                    this._wav = true;
                }
                if (audioElement.canPlayType('audio/x-m4a;') || audioElement.canPlayType('audio/aac;').replace(/^no$/, '')) {
                    this._m4a = true;
                }
            }
        }
        catch (e) {
            console.warn('Device check audio exception');
        }
    };
    Device.prototype._checkDevice = function () {
        this._pixelRatio = window.devicePixelRatio || 1;
        this._iPhone = navigator.userAgent.toLowerCase().indexOf('iphone') !== -1;
        this._iPhone4 = this._pixelRatio === 2 && this._iPhone;
        this._iPad = navigator.userAgent.toLowerCase().indexOf('ipad') !== -1;
        var ratio = window.devicePixelRatio || 1;
        // Define the users device screen dimensions
        var screen = {
            width: window.screen.width * ratio,
            height: window.screen.height * ratio,
        };
        this._iPhoneX = this._iPhone && screen.width === 1125 && screen.height === 2436;
    };
    Device.prototype._checkFeatures = function () {
        this._canvas = !!window.CanvasRenderingContext2D;
        var webGL = (function () {
            try {
                var canvas = document.createElement('canvas');
                return !!(window.WebGLRenderingContext && (canvas.getContext('webgl') || canvas.getContext('experimental-webgl')));
            }
            catch (e) {
                return false;
            }
        })();
        this._webGL = !!webGL;
    };
    Device.prototype._checkWebP = function () {
        var elem = document.createElement('canvas');
        if (!!(elem.getContext && elem.getContext('2d'))) {
            // was able or not to get WebP representation
            this._webP = elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
        }
        else {
            // very old browser like IE 8, canvas not supported
            this._webP = false;
        }
    };
    Device.prototype._checkType = function () {
        if (this._desktop) {
            this._type = DeviceType_1.DeviceType.DESKTOP;
        }
        else {
            this._type = DeviceType_1.DeviceType.MOBILE;
        }
    };
    /**
     * is 4:3
     * @returns {boolean}
     */
    Device.prototype.isIpadResolution = function () {
        var ratio = window.devicePixelRatio || 1;
        var screenWidth = Math.max(screen.width, screen.height) * ratio;
        var width = screenWidth;
        var height = Math.min(screen.width, screen.height) * ratio;
        return Math.abs(height / width - 0.75) < 0.04;
    };
    Object.defineProperty(Device.prototype, "canvas", {
        get: function () {
            return this._canvas;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "webGL", {
        get: function () {
            return this._webGL;
        },
        set: function (value) {
            this._webGL = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "webp", {
        get: function () {
            return this._webP;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "chrome", {
        get: function () {
            return this._chrome;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "chromeVersion", {
        get: function () {
            return this._chromeVersion;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "iOSVersion", {
        get: function () {
            return this._iOSVersion;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "firefox", {
        get: function () {
            return this._firefox;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "audioData", {
        get: function () {
            return this._audioData;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "webAudioContextConstructor", {
        get: function () {
            return this._webAudioContextConstructor;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "cancelFullscreen", {
        get: function () {
            return this._cancelFullscreen;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "fullscreenElement", {
        get: function () {
            return this._fullscreenElement;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "mobileSafari", {
        get: function () {
            return this._mobileSafari;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "webApp", {
        get: function () {
            return this._webApp;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "android", {
        get: function () {
            return this._android;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "iPhone4", {
        get: function () {
            return this._iPhone4;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "iPhoneX", {
        get: function () {
            return this._iPhoneX;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "iPhone", {
        get: function () {
            return this._iPhone;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "iOS", {
        get: function () {
            return this._iOS;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "isSafari", {
        get: function () {
            return this._safari;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "safariVersion", {
        get: function () {
            return this._safariVersion;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "fullscreen", {
        get: function () {
            return this._fullscreen;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "requestFullscreen", {
        get: function () {
            return this._requestFullscreen;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "desktop", {
        get: function () {
            return this._desktop;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "isMobile", {
        get: function () {
            return !this._desktop;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "isIOSChrome", {
        get: function () {
            return this._iosChrome;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "isOppoBrowser", {
        get: function () {
            return this._isOppoBrowser;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "isIE", {
        get: function () {
            return this._ie;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "IEVersion", {
        get: function () {
            return this.isIE ? this._ieVersion : 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "isMacOs", {
        get: function () {
            return this._macOS;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "isSamsungNative", {
        get: function () {
            return this._samsungNativeBrowser;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "isIframe", {
        get: function () {
            return this._iframe;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "fullscreenDisabledByIntegration", {
        set: function (isDisabled) {
            this._fullscreenDisabledByIntegration = isDisabled;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "isFullscreenDisabledByIntegration", {
        get: function () {
            return this._fullscreenDisabledByIntegration;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "iPad", {
        get: function () {
            return this._iPad;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "type", {
        get: function () {
            return this._type;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "hasTouch", {
        get: function () {
            return this._touch;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Device.prototype, "isIOSMobileRequestingDesktop", {
        get: function () {
            return this._iOSRunningAsDesktop;
        },
        enumerable: true,
        configurable: true
    });
    Device = __decorate([
        inversify_1.injectable(),
        __metadata("design:paramtypes", [Function])
    ], Device);
    return Device;
}());
exports.Device = Device;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var GameViews = /** @class */ (function () {
    function GameViews() {
    }
    // public static readonly LEVEL_REEL_VIEW: string = 'LevelReelView';
    GameViews.EXPANDED_WILD_VIEW = 'ExpandedWildView';
    GameViews.RESPIN_VIEW = 'RespinView';
    GameViews.REEL_EXPANDER_VIEW = 'ReelExpanderView';
    GameViews.FOREGROUND_VIEW = 'ForegroundView';
    GameViews.PAYTABLE_VIEW = 'PaytableView';
    GameViews.REELPOPUP_VIEW = 'ReelPopupView';
    GameViews.PAYTABLE_VIEW_MOBILE = 'PaytableViewMobile';
    GameViews.AUTOPLAY_MENU_VIEW = 'AutoPlayMenuView';
    GameViews.SETTINGS_VIEW = 'SettingsView';
    GameViews.LEVEL_BALL_VIEW = 'LevelBallView';
    GameViews.ANNOUNCEMENT_BOARD_VIEW = 'AnnouncementBoardView';
    GameViews.CHARACTER_CHOICE_SCREEN_VIEW = 'CharacterChoiceScreenView';
    GameViews.CARDS_LEVELLING_SCREEN_VIEW = 'CardsLevellingView';
    GameViews.HISTORY_BOX_VIEW = 'HistoryBoxView';
    GameViews.KEYS_VIEW = 'KeysView';
    GameViews.MERGING_BIG_SYMBOLS_VIEW = 'MergingBigSymbolsView';
    GameViews.SPLITTING_BIG_SYMBOLS_VIEW = 'SplittingBigSymbolsView';
    GameViews.RANDOM_MULTIPLIER_VIEW = 'RandomMultiplierView';
    GameViews.SYMBOLS_EXPLOSION_VIEW = 'SymbolsExplosionView';
    GameViews.MIMIC_FREE_SPINS_INTRO_VIEW = 'MimicFreeSpinsIntroView';
    GameViews.SCATTER_COUNTER_VIEW = 'ScatterCounterView';
    GameViews.STICKY_SYMBOLS_LAYER_VIEW = 'StickySymbolsLayerView';
    GameViews.RESPIN_FOREGROUND_VIEW = 'RespinForegroundView';
    GameViews.STAR_VIEW = 'StarView';
    GameViews.REEL_SCATTERS_VIEW = 'ReelScattersView';
    GameViews.REEL_FRAME_VIEW = 'ReelFrameView';
    GameViews.TOP_REELS_VIEW = 'TopReelsView';
    GameViews.UNDER_TOP_REELS_VIEW = 'UnderTopReelsView';
    GameViews.WILD_METER_VIEW = 'WildMeterView';
    GameViews.WIN_LINES_PRESENTATION_VIEW = 'WinLinesPresentationView';
    GameViews.WIN_FIELD_VIEW = 'WinFieldView';
    GameViews.FREE_SPINS_TRIGGER_VIEW = 'FreeSpinsTriggerView';
    return GameViews;
}());
exports.GameViews = GameViews;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MainMenuEvents = /** @class */ (function () {
    function MainMenuEvents() {
    }
    MainMenuEvents.MAIN_MENU_OPEN = 'MainMenuEvents::MAIN_MENU_OPEN';
    MainMenuEvents.MAIN_MENU_CLOSED = 'MainMenuEvents::MAIN_MENU_CLOSED';
    MainMenuEvents.MAIN_MENU_CLOSE_CLICKED = 'MainMenuEvents::MAIN_MENU_CLOSE_CLICKED';
    MainMenuEvents.MAIN_MENU_SETTINGS_OPEN = 'MainMenuEvents::MAIN_MENU_SETTINGS_OPEN';
    MainMenuEvents.MAIN_MENU_INFO_OPEN = 'MainMenuEvents::MAIN_MENU_RULES_OPEN';
    MainMenuEvents.MAIN_MENU_PAYTABLE_OPEN = 'MainMenuEvents::MAIN_MENU_PAYTABLE_OPEN';
    MainMenuEvents.MAIN_MENU_LOBBY_OPEN = 'MainMenuEvents::MAIN_MENU_LOBBY_OPEN';
    MainMenuEvents.MAIN_MENU_SETTINGS_CLOSE = 'MainMenuEvents::MAIN_MENU_SETTINGS_CLOSE';
    MainMenuEvents.MAIN_MENU_INFO_CLOSE = 'MainMenuEvents::MAIN_MENU_RULES_CLOSE';
    MainMenuEvents.MAIN_MENU_PAYTABLE_CLOSE = 'MainMenuEvents::MAIN_MENU_PAYTABLE_CLOSE';
    MainMenuEvents.MAIN_MENU_LOBBY_CLOSE = 'MainMenuEvents::MAIN_MENU_LOBBY_CLOSE';
    MainMenuEvents.MAIN_MENU_SETTINGS_CLICKED = 'MainMenuEvents::MAIN_MENU_SETTINGS_CLICKED';
    MainMenuEvents.MAIN_MENU_INFO_CLICKED = 'MainMenuEvents::MAIN_MENU_RULES_CLICKED';
    MainMenuEvents.MAIN_MENU_PAYTABLE_CLICKED = 'MainMenuEvents::MAIN_MENU_PAYTABLE_CLICKED';
    MainMenuEvents.MAIN_MENU_LOBBY_CLICKED = 'MainMenuEvents::MAIN_MENU_LOBBY_CLICKED';
    return MainMenuEvents;
}());
exports.MainMenuEvents = MainMenuEvents;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var WinNumbers = /** @class */ (function (_super) {
    __extends(WinNumbers, _super);
    function WinNumbers(resources, symbolIDPrefix, texture) {
        var _this = _super.call(this, texture) || this;
        _this._numberKerning = 0;
        _this._autoCenterMyself = true;
        _this._shouldAddShadow = false;
        _this._shadowTint = 0x000000;
        _this._shadowOffset = { x: 0, y: 0.15 };
        _this._additionalOffset = 0;
        _this._commaAdditionalOffset = 0;
        _this._resources = resources;
        _this._symbolIDPrefix = symbolIDPrefix;
        _this._numbersContainer = new PIXI.Sprite();
        _this._numbersContainer.anchor.set(0.5, 0.5);
        _this.numberAnchor = { x: 0, y: 0 };
        _this.addChild(_this._numbersContainer);
        return _this;
    }
    WinNumbers.isValidCharacter = function (char) {
        return typeof WinNumbers.ImageNumbers[char] !== 'undefined';
    };
    WinNumbers.prototype.setParent = function (container) {
        return _super.prototype.setParent.call(this, container);
    };
    WinNumbers.prototype.hasCurrency = function (numStr) {
        if (this.currencyISO && this.currencySign) {
            return numStr.indexOf(this.currencySign) > -1;
        }
        return false;
    };
    WinNumbers.prototype.splitCurrency = function (numStr) {
        return numStr.replace(this.currencySign, '~');
    };
    WinNumbers.prototype.showNumber = function (numStr) {
        this._numbersContainer.removeChildren();
        var hasCurrencySign = this.hasCurrency(numStr);
        if (hasCurrencySign) {
            numStr = this.splitCurrency(numStr);
        }
        var posOffset = 0;
        var prevIndividualNumber = '';
        for (var _i = 0, numStr_1 = numStr; _i < numStr_1.length; _i++) {
            var individualNum = numStr_1[_i];
            var numberSprite = void 0;
            if (individualNum === '.') {
                numberSprite = new PIXI.Sprite(this._resources.getSpritesheetTexture('NUMBERS.json', this._symbolIDPrefix + "DOT.png"));
            }
            else if (individualNum === ',') {
                numberSprite = new PIXI.Sprite(this._resources.getSpritesheetTexture('NUMBERS.json', this._symbolIDPrefix + "COMMA.png"));
            }
            else if (individualNum === 'x') {
                if (this._resources.getSpritesheetTexture('NUMBERS.json', this._symbolIDPrefix + "X.png")) {
                    numberSprite = new PIXI.Sprite(this._resources.getSpritesheetTexture('NUMBERS.json', this._symbolIDPrefix + "X.png"));
                }
                else {
                    numberSprite = new PIXI.Sprite(this._resources.getSpritesheetTexture('NUMBERS.json', "GOLD_X.png"));
                }
            }
            else if (individualNum === '/') {
                numberSprite = new PIXI.Sprite(this._resources.getSpritesheetTexture('NUMBERS.json', "SMALL_BACKSLASH.png"));
            }
            else if (individualNum === '\'') {
                numberSprite = new PIXI.Sprite(this._resources.getSpritesheetTexture('NUMBERS.json', this._symbolIDPrefix + "APOSTROPHE.png"));
            }
            else if (hasCurrencySign && individualNum === '~') {
                var currencyPrefix = this._currencyIDPrefix ? this._currencyIDPrefix : this._symbolIDPrefix;
                if (this._resources.getCurrencySpritesheetTexture(this._currencyISO, currencyPrefix + "CUR.png")) {
                    numberSprite = new PIXI.Sprite(this._resources.getCurrencySpritesheetTexture(this._currencyISO, currencyPrefix + "CUR.png"));
                }
                else {
                    numberSprite = new PIXI.Sprite(this._resources.getCurrencySpritesheetTexture(this._currencyISO, "LARGE_CUR.png"));
                }
            }
            else if (WinNumbers.isValidCharacter(individualNum)) {
                numberSprite = new PIXI.Sprite(this._resources.getSpritesheetTexture('NUMBERS.json', "" + this._symbolIDPrefix + individualNum + ".png"));
            }
            else {
                numberSprite = new PIXI.Sprite(PIXI.Texture.EMPTY);
                numberSprite.width = this._resources.getSpritesheetTexture('NUMBERS.json', this._symbolIDPrefix + "DOT.png").width;
            }
            numberSprite.position.set(posOffset, 0);
            this._numbersContainer.addChild(numberSprite);
            numberSprite.anchor.set(this.numberAnchor.x, this.numberAnchor.y);
            if (this._shouldTintNumbers) {
                numberSprite.tint = this.tintValue;
            }
            posOffset += numberSprite.width + this.numberKerning + this._additionalOffset;
            if (individualNum === '.' ||
                individualNum === ',' ||
                individualNum === '\'' ||
                prevIndividualNumber === '.' ||
                prevIndividualNumber === ',' ||
                prevIndividualNumber === '\'') {
                numberSprite.position.x += this._commaAdditionalOffset;
                posOffset += this._commaAdditionalOffset;
            }
            if (hasCurrencySign && individualNum === '~' && this._currencyOffset) {
                if (this._currencyOffset.x) {
                    numberSprite.position.x += this._currencyOffset.x;
                }
                if (this._currencyOffset.y) {
                    numberSprite.position.y += this._currencyOffset.y;
                }
            }
            if (this._shouldAddShadow) {
                var shadowSprite = new PIXI.Sprite(numberSprite.texture);
                shadowSprite.position.set(numberSprite.position.x + numberSprite.width * this._shadowOffset.x, numberSprite.position.y + numberSprite.height * this._shadowOffset.y);
                shadowSprite.tint = this._shadowTint;
                this._numbersContainer.addChildAt(shadowSprite, 0);
                shadowSprite.anchor.set(numberSprite.anchor.x, numberSprite.anchor.y);
            }
            prevIndividualNumber = individualNum;
        }
        if (this.autoCenterMyself) {
            this.centerMyself(posOffset - this.numberKerning);
        }
    };
    WinNumbers.prototype.centerMyself = function (width) {
        this._numbersContainer.position.set(width / -2, this.children[0].height / -2);
    };
    WinNumbers.prototype.centerHeight = function (height) {
        if (height) {
            this._numbersContainer.position.y = height / -2;
        }
    };
    WinNumbers.prototype.centerWidth = function (width) {
        if (width) {
            this._numbersContainer.position.y = width / -2;
        }
    };
    Object.defineProperty(WinNumbers.prototype, "additionalOffset", {
        set: function (value) {
            this._additionalOffset = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WinNumbers.prototype, "comaAdditionalOffset", {
        set: function (value) {
            this._commaAdditionalOffset = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WinNumbers.prototype, "numberKerning", {
        get: function () {
            return this._numberKerning;
        },
        set: function (value) {
            this._numberKerning = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WinNumbers.prototype, "autoCenterMyself", {
        get: function () {
            return this._autoCenterMyself;
        },
        set: function (value) {
            this._autoCenterMyself = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WinNumbers.prototype, "numberAnchor", {
        get: function () {
            return this._numberAnchor;
        },
        set: function (value) {
            this._numberAnchor = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WinNumbers.prototype, "currencySign", {
        get: function () {
            // return this._currencyFormatter.currencySign;
            return this._currencySign;
        },
        set: function (currencySign) {
            this._currencySign = currencySign;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WinNumbers.prototype, "currencyISO", {
        get: function () {
            // return this._currencyFormatter.currency
            return this._currencyISO;
        },
        set: function (currencyISO) {
            this._currencyISO = currencyISO;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WinNumbers.prototype, "container", {
        get: function () {
            return this._numbersContainer;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WinNumbers.prototype, "totalHeight", {
        get: function () {
            return this.container.getBounds().height;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WinNumbers.prototype, "totalWidth", {
        get: function () {
            return this.container.getBounds().width;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WinNumbers.prototype, "shouldTintNumbers", {
        set: function (value) {
            this._shouldTintNumbers = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WinNumbers.prototype, "tintValue", {
        get: function () {
            return this._tintValue;
        },
        set: function (value) {
            this._tintValue = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WinNumbers.prototype, "shadowTint", {
        set: function (tint) {
            this._shadowTint = tint;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WinNumbers.prototype, "shadowOffset", {
        set: function (offset) {
            this._shadowOffset = offset;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WinNumbers.prototype, "addShadow", {
        set: function (shouldAdd) {
            this._shouldAddShadow = shouldAdd;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WinNumbers.prototype, "currencyOffset", {
        set: function (value) {
            this._currencyOffset = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WinNumbers.prototype, "currencyIDPrefix", {
        set: function (value) {
            this._currencyIDPrefix = value;
        },
        enumerable: true,
        configurable: true
    });
    WinNumbers.ImageNumbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    return WinNumbers;
}(PIXI.Sprite));
exports.WinNumbers = WinNumbers;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FreeRoundsScreenEvents = /** @class */ (function () {
    function FreeRoundsScreenEvents() {
    }
    FreeRoundsScreenEvents.FREE_GAMES_STARTED = 'FreeRoundsScreenEvents::FREE_GAMES_STARTED';
    FreeRoundsScreenEvents.FREE_GAMES_RESUMED = 'FreeRoundsScreenEvents::FREE_GAMES_RESUMED';
    FreeRoundsScreenEvents.FREE_GAMES_FINISHED = 'FreeRoundsScreenEvents::FREE_GAMES_FINISHED';
    FreeRoundsScreenEvents.FREE_GAMES_POSTPONED = 'FreeRoundsScreenEvents::FREE_GAMES_POSTPONED';
    FreeRoundsScreenEvents.FREE_GAMES_REJECTED = 'FreeRoundsScreenEvents::FREE_GAMES_REJECTED';
    FreeRoundsScreenEvents.FREE_GAME_EXPIRED = 'FreeRoundsScreenEvents::FREE_GAME_EXPIRED';
    FreeRoundsScreenEvents.FREE_GAMES_NEXT_OFFER = 'FreeRoundsScreenEvents::FREE_GAMES_NEXT_OFFER';
    FreeRoundsScreenEvents.RESTORE_TO_IN_GAME = 'FreeRoundsScreenEvents::RESTORE_TO_IN_GAME';
    FreeRoundsScreenEvents.FREE_ROUNDS_SCREEN_SHOWN = 'FreeRoundsScreenEvents::FREE_ROUNDS_SCREEN_SHOWN';
    FreeRoundsScreenEvents.FREE_ROUNDS_SCREEN_HIDDEN = 'FreeRoundsScreenEvents::FREE_ROUNDS_SCREEN_HIDDEN';
    FreeRoundsScreenEvents.EXPECTED_TO_SHOW_FREE_ROUNDS_WINDOW = 'FreeRoundsScreenEvents::EXPECTED_TO_SHOW_FREE_ROUNDS_WINDOW';
    FreeRoundsScreenEvents.SOON_WILL_SHOW_FREE_ROUNDS_END = 'FreeRoundsScreenEvents::SOON_WILL_SHOW_FREE_ROUNDS_END';
    return FreeRoundsScreenEvents;
}());
exports.FreeRoundsScreenEvents = FreeRoundsScreenEvents;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BindingScopeEnum = {
    Request: "Request",
    Singleton: "Singleton",
    Transient: "Transient"
};
exports.BindingScopeEnum = BindingScopeEnum;
var BindingTypeEnum = {
    ConstantValue: "ConstantValue",
    Constructor: "Constructor",
    DynamicValue: "DynamicValue",
    Factory: "Factory",
    Function: "Function",
    Instance: "Instance",
    Invalid: "Invalid",
    Provider: "Provider"
};
exports.BindingTypeEnum = BindingTypeEnum;
var TargetTypeEnum = {
    ClassProperty: "ClassProperty",
    ConstructorArgument: "ConstructorArgument",
    Variable: "Variable"
};
exports.TargetTypeEnum = TargetTypeEnum;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BetlevelMenuEvents = /** @class */ (function () {
    function BetlevelMenuEvents() {
    }
    BetlevelMenuEvents.BET_VALUE_UPDATED = 'BetlevelMenuEvents::BET_VALUE_UPDATED';
    BetlevelMenuEvents.BET_LEVEL_MENU_OPENED = 'BetlevelMenuEvents::BET_LEVEL_MENU_OPENED';
    BetlevelMenuEvents.BET_LEVEL_MENU_CLOSED = 'BetlevelMenuEvents::BET_LEVEL_MENU_CLOSED';
    BetlevelMenuEvents.BET_LEVEL_MENU_CANCELLED = 'BetlevelMenuEvents::BET_LEVEL_MENU_CANCELLED';
    BetlevelMenuEvents.BET_LEVEL_MENU_SELECTED_BET_ACCEPTED = 'BetlevelMenuEvents::BET_LEVEL_MENU_OPTION_ACCEPTED';
    return BetlevelMenuEvents;
}());
exports.BetlevelMenuEvents = BetlevelMenuEvents;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseTexture = __webpack_require__(68);

var _BaseTexture2 = _interopRequireDefault(_BaseTexture);

var _VideoBaseTexture = __webpack_require__(185);

var _VideoBaseTexture2 = _interopRequireDefault(_VideoBaseTexture);

var _TextureUvs = __webpack_require__(186);

var _TextureUvs2 = _interopRequireDefault(_TextureUvs);

var _eventemitter = __webpack_require__(60);

var _eventemitter2 = _interopRequireDefault(_eventemitter);

var _math = __webpack_require__(20);

var _utils = __webpack_require__(9);

var _settings = __webpack_require__(17);

var _settings2 = _interopRequireDefault(_settings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * A texture stores the information that represents an image or part of an image. It cannot be added
 * to the display list directly. Instead use it as the texture for a Sprite. If no frame is provided
 * then the whole image is used.
 *
 * You can directly create a texture from an image and then reuse it multiple times like this :
 *
 * ```js
 * let texture = PIXI.Texture.fromImage('assets/image.png');
 * let sprite1 = new PIXI.Sprite(texture);
 * let sprite2 = new PIXI.Sprite(texture);
 * ```
 *
 * Textures made from SVGs, loaded or not, cannot be used before the file finishes processing.
 * You can check for this by checking the sprite's _textureID property.
 * ```js
 * var texture = PIXI.Texture.fromImage('assets/image.svg');
 * var sprite1 = new PIXI.Sprite(texture);
 * //sprite1._textureID should not be undefined if the texture has finished processing the SVG file
 * ```
 * You can use a ticker or rAF to ensure your sprites load the finished textures after processing. See issue #3068.
 *
 * @class
 * @extends EventEmitter
 * @memberof PIXI
 */
var Texture = function (_EventEmitter) {
    _inherits(Texture, _EventEmitter);

    /**
     * @param {PIXI.BaseTexture} baseTexture - The base texture source to create the texture from
     * @param {PIXI.Rectangle} [frame] - The rectangle frame of the texture to show
     * @param {PIXI.Rectangle} [orig] - The area of original texture
     * @param {PIXI.Rectangle} [trim] - Trimmed rectangle of original texture
     * @param {number} [rotate] - indicates how the texture was rotated by texture packer. See {@link PIXI.GroupD8}
     * @param {PIXI.Point} [anchor] - Default anchor point used for sprite placement / rotation
     */
    function Texture(baseTexture, frame, orig, trim, rotate, anchor) {
        _classCallCheck(this, Texture);

        /**
         * Does this Texture have any frame data assigned to it?
         *
         * @member {boolean}
         */
        var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

        _this.noFrame = false;

        if (!frame) {
            _this.noFrame = true;
            frame = new _math.Rectangle(0, 0, 1, 1);
        }

        if (baseTexture instanceof Texture) {
            baseTexture = baseTexture.baseTexture;
        }

        /**
         * The base texture that this texture uses.
         *
         * @member {PIXI.BaseTexture}
         */
        _this.baseTexture = baseTexture;

        /**
         * This is the area of the BaseTexture image to actually copy to the Canvas / WebGL when rendering,
         * irrespective of the actual frame size or placement (which can be influenced by trimmed texture atlases)
         *
         * @member {PIXI.Rectangle}
         */
        _this._frame = frame;

        /**
         * This is the trimmed area of original texture, before it was put in atlas
         * Please call `_updateUvs()` after you change coordinates of `trim` manually.
         *
         * @member {PIXI.Rectangle}
         */
        _this.trim = trim;

        /**
         * This will let the renderer know if the texture is valid. If it's not then it cannot be rendered.
         *
         * @member {boolean}
         */
        _this.valid = false;

        /**
         * This will let a renderer know that a texture has been updated (used mainly for webGL uv updates)
         *
         * @member {boolean}
         */
        _this.requiresUpdate = false;

        /**
         * The WebGL UV data cache.
         *
         * @member {PIXI.TextureUvs}
         * @private
         */
        _this._uvs = null;

        /**
         * This is the area of original texture, before it was put in atlas
         *
         * @member {PIXI.Rectangle}
         */
        _this.orig = orig || frame; // new Rectangle(0, 0, 1, 1);

        _this._rotate = Number(rotate || 0);

        if (rotate === true) {
            // this is old texturepacker legacy, some games/libraries are passing "true" for rotated textures
            _this._rotate = 2;
        } else if (_this._rotate % 2 !== 0) {
            throw new Error('attempt to use diamond-shaped UVs. If you are sure, set rotation manually');
        }

        if (baseTexture.hasLoaded) {
            if (_this.noFrame) {
                frame = new _math.Rectangle(0, 0, baseTexture.width, baseTexture.height);

                // if there is no frame we should monitor for any base texture changes..
                baseTexture.on('update', _this.onBaseTextureUpdated, _this);
            }
            _this.frame = frame;
        } else {
            baseTexture.once('loaded', _this.onBaseTextureLoaded, _this);
        }

        /**
         * Anchor point that is used as default if sprite is created with this texture.
         * Changing the `defaultAnchor` at a later point of time will not update Sprite's anchor point.
         * @member {PIXI.Point}
         * @default {0,0}
         */
        _this.defaultAnchor = anchor ? new _math.Point(anchor.x, anchor.y) : new _math.Point(0, 0);

        /**
         * Fired when the texture is updated. This happens if the frame or the baseTexture is updated.
         *
         * @event PIXI.Texture#update
         * @protected
         * @param {PIXI.Texture} texture - Instance of texture being updated.
         */

        _this._updateID = 0;

        /**
         * Contains data for uvs. May contain clamp settings and some matrices.
         * Its a bit heavy, so by default that object is not created.
         * @member {PIXI.TextureMatrix}
         * @default null
         */
        _this.transform = null;

        /**
         * The ids under which this Texture has been added to the texture cache. This is
         * automatically set as long as Texture.addToCache is used, but may not be set if a
         * Texture is added directly to the TextureCache array.
         *
         * @member {string[]}
         */
        _this.textureCacheIds = [];
        return _this;
    }

    /**
     * Updates this texture on the gpu.
     *
     */


    Texture.prototype.update = function update() {
        this.baseTexture.update();
    };

    /**
     * Called when the base texture is loaded
     *
     * @private
     * @param {PIXI.BaseTexture} baseTexture - The base texture.
     */


    Texture.prototype.onBaseTextureLoaded = function onBaseTextureLoaded(baseTexture) {
        this._updateID++;

        // TODO this code looks confusing.. boo to abusing getters and setters!
        if (this.noFrame) {
            this.frame = new _math.Rectangle(0, 0, baseTexture.width, baseTexture.height);
        } else {
            this.frame = this._frame;
        }

        this.baseTexture.on('update', this.onBaseTextureUpdated, this);
        this.emit('update', this);
    };

    /**
     * Called when the base texture is updated
     *
     * @private
     * @param {PIXI.BaseTexture} baseTexture - The base texture.
     */


    Texture.prototype.onBaseTextureUpdated = function onBaseTextureUpdated(baseTexture) {
        this._updateID++;

        this._frame.width = baseTexture.width;
        this._frame.height = baseTexture.height;

        this.emit('update', this);
    };

    /**
     * Destroys this texture
     *
     * @param {boolean} [destroyBase=false] Whether to destroy the base texture as well
     */


    Texture.prototype.destroy = function destroy(destroyBase) {
        if (this.baseTexture) {
            if (destroyBase) {
                // delete the texture if it exists in the texture cache..
                // this only needs to be removed if the base texture is actually destroyed too..
                if (_utils.TextureCache[this.baseTexture.imageUrl]) {
                    Texture.removeFromCache(this.baseTexture.imageUrl);
                }

                this.baseTexture.destroy();
            }

            this.baseTexture.off('update', this.onBaseTextureUpdated, this);
            this.baseTexture.off('loaded', this.onBaseTextureLoaded, this);

            this.baseTexture = null;
        }

        this._frame = null;
        this._uvs = null;
        this.trim = null;
        this.orig = null;

        this.valid = false;

        Texture.removeFromCache(this);
        this.textureCacheIds = null;
    };

    /**
     * Creates a new texture object that acts the same as this one.
     *
     * @return {PIXI.Texture} The new texture
     */


    Texture.prototype.clone = function clone() {
        return new Texture(this.baseTexture, this.frame, this.orig, this.trim, this.rotate, this.defaultAnchor);
    };

    /**
     * Updates the internal WebGL UV cache. Use it after you change `frame` or `trim` of the texture.
     */


    Texture.prototype._updateUvs = function _updateUvs() {
        if (!this._uvs) {
            this._uvs = new _TextureUvs2.default();
        }

        this._uvs.set(this._frame, this.baseTexture, this.rotate);

        this._updateID++;
    };

    /**
     * Helper function that creates a Texture object from the given image url.
     * If the image is not in the texture cache it will be  created and loaded.
     *
     * @static
     * @param {string} imageUrl - The image url of the texture
     * @param {boolean} [crossorigin] - Whether requests should be treated as crossorigin
     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
     * @param {number} [sourceScale=(auto)] - Scale for the original image, used with SVG images.
     * @return {PIXI.Texture} The newly created texture
     */


    Texture.fromImage = function fromImage(imageUrl, crossorigin, scaleMode, sourceScale) {
        var texture = _utils.TextureCache[imageUrl];

        if (!texture) {
            texture = new Texture(_BaseTexture2.default.fromImage(imageUrl, crossorigin, scaleMode, sourceScale));
            Texture.addToCache(texture, imageUrl);
        }

        return texture;
    };

    /**
     * Helper function that creates a sprite that will contain a texture from the TextureCache based on the frameId
     * The frame ids are created when a Texture packer file has been loaded
     *
     * @static
     * @param {string} frameId - The frame Id of the texture in the cache
     * @return {PIXI.Texture} The newly created texture
     */


    Texture.fromFrame = function fromFrame(frameId) {
        var texture = _utils.TextureCache[frameId];

        if (!texture) {
            throw new Error('The frameId "' + frameId + '" does not exist in the texture cache');
        }

        return texture;
    };

    /**
     * Helper function that creates a new Texture based on the given canvas element.
     *
     * @static
     * @param {HTMLCanvasElement} canvas - The canvas element source of the texture
     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
     * @param {string} [origin='canvas'] - A string origin of who created the base texture
     * @return {PIXI.Texture} The newly created texture
     */


    Texture.fromCanvas = function fromCanvas(canvas, scaleMode) {
        var origin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'canvas';

        return new Texture(_BaseTexture2.default.fromCanvas(canvas, scaleMode, origin));
    };

    /**
     * Helper function that creates a new Texture based on the given video element.
     *
     * @static
     * @param {HTMLVideoElement|string} video - The URL or actual element of the video
     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
     * @param {boolean} [crossorigin=(auto)] - Should use anonymous CORS? Defaults to true if the URL is not a data-URI.
     * @param {boolean} [autoPlay=true] - Start playing video as soon as it is loaded
     * @return {PIXI.Texture} The newly created texture
     */


    Texture.fromVideo = function fromVideo(video, scaleMode, crossorigin, autoPlay) {
        if (typeof video === 'string') {
            return Texture.fromVideoUrl(video, scaleMode, crossorigin, autoPlay);
        }

        return new Texture(_VideoBaseTexture2.default.fromVideo(video, scaleMode, autoPlay));
    };

    /**
     * Helper function that creates a new Texture based on the video url.
     *
     * @static
     * @param {string} videoUrl - URL of the video
     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
     * @param {boolean} [crossorigin=(auto)] - Should use anonymous CORS? Defaults to true if the URL is not a data-URI.
     * @param {boolean} [autoPlay=true] - Start playing video as soon as it is loaded
     * @return {PIXI.Texture} The newly created texture
     */


    Texture.fromVideoUrl = function fromVideoUrl(videoUrl, scaleMode, crossorigin, autoPlay) {
        return new Texture(_VideoBaseTexture2.default.fromUrl(videoUrl, scaleMode, crossorigin, autoPlay));
    };

    /**
     * Helper function that creates a new Texture based on the source you provide.
     * The source can be - frame id, image url, video url, canvas element, video element, base texture
     *
     * @static
     * @param {number|string|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement|PIXI.BaseTexture}
     *        source - Source to create texture from
     * @return {PIXI.Texture} The newly created texture
     */


    Texture.from = function from(source) {
        // TODO auto detect cross origin..
        // TODO pass in scale mode?
        if (typeof source === 'string') {
            var texture = _utils.TextureCache[source];

            if (!texture) {
                // check if its a video..
                var isVideo = source.match(/\.(mp4|webm|ogg|h264|avi|mov)$/) !== null;

                if (isVideo) {
                    return Texture.fromVideoUrl(source);
                }

                return Texture.fromImage(source);
            }

            return texture;
        } else if (source instanceof HTMLImageElement) {
            return new Texture(_BaseTexture2.default.from(source));
        } else if (source instanceof HTMLCanvasElement) {
            return Texture.fromCanvas(source, _settings2.default.SCALE_MODE, 'HTMLCanvasElement');
        } else if (source instanceof HTMLVideoElement) {
            return Texture.fromVideo(source);
        } else if (source instanceof _BaseTexture2.default) {
            return new Texture(source);
        }

        // lets assume its a texture!
        return source;
    };

    /**
     * Create a texture from a source and add to the cache.
     *
     * @static
     * @param {HTMLImageElement|HTMLCanvasElement} source - The input source.
     * @param {String} imageUrl - File name of texture, for cache and resolving resolution.
     * @param {String} [name] - Human readible name for the texture cache. If no name is
     *        specified, only `imageUrl` will be used as the cache ID.
     * @return {PIXI.Texture} Output texture
     */


    Texture.fromLoader = function fromLoader(source, imageUrl, name) {
        var baseTexture = new _BaseTexture2.default(source, undefined, (0, _utils.getResolutionOfUrl)(imageUrl));
        var texture = new Texture(baseTexture);

        baseTexture.imageUrl = imageUrl;

        // No name, use imageUrl instead
        if (!name) {
            name = imageUrl;
        }

        // lets also add the frame to pixi's global cache for fromFrame and fromImage fucntions
        _BaseTexture2.default.addToCache(texture.baseTexture, name);
        Texture.addToCache(texture, name);

        // also add references by url if they are different.
        if (name !== imageUrl) {
            _BaseTexture2.default.addToCache(texture.baseTexture, imageUrl);
            Texture.addToCache(texture, imageUrl);
        }

        return texture;
    };

    /**
     * Adds a Texture to the global TextureCache. This cache is shared across the whole PIXI object.
     *
     * @static
     * @param {PIXI.Texture} texture - The Texture to add to the cache.
     * @param {string} id - The id that the Texture will be stored against.
     */


    Texture.addToCache = function addToCache(texture, id) {
        if (id) {
            if (texture.textureCacheIds.indexOf(id) === -1) {
                texture.textureCacheIds.push(id);
            }

            // @if DEBUG
            /* eslint-disable no-console */
            if (_utils.TextureCache[id]) {
                console.warn('Texture added to the cache with an id [' + id + '] that already had an entry');
            }
            /* eslint-enable no-console */
            // @endif

            _utils.TextureCache[id] = texture;
        }
    };

    /**
     * Remove a Texture from the global TextureCache.
     *
     * @static
     * @param {string|PIXI.Texture} texture - id of a Texture to be removed, or a Texture instance itself
     * @return {PIXI.Texture|null} The Texture that was removed
     */


    Texture.removeFromCache = function removeFromCache(texture) {
        if (typeof texture === 'string') {
            var textureFromCache = _utils.TextureCache[texture];

            if (textureFromCache) {
                var index = textureFromCache.textureCacheIds.indexOf(texture);

                if (index > -1) {
                    textureFromCache.textureCacheIds.splice(index, 1);
                }

                delete _utils.TextureCache[texture];

                return textureFromCache;
            }
        } else if (texture && texture.textureCacheIds) {
            for (var i = 0; i < texture.textureCacheIds.length; ++i) {
                // Check that texture matches the one being passed in before deleting it from the cache.
                if (_utils.TextureCache[texture.textureCacheIds[i]] === texture) {
                    delete _utils.TextureCache[texture.textureCacheIds[i]];
                }
            }

            texture.textureCacheIds.length = 0;

            return texture;
        }

        return null;
    };

    /**
     * The frame specifies the region of the base texture that this texture uses.
     * Please call `_updateUvs()` after you change coordinates of `frame` manually.
     *
     * @member {PIXI.Rectangle}
     */


    _createClass(Texture, [{
        key: 'frame',
        get: function get() {
            return this._frame;
        },
        set: function set(frame) // eslint-disable-line require-jsdoc
        {
            this._frame = frame;

            this.noFrame = false;

            var x = frame.x,
                y = frame.y,
                width = frame.width,
                height = frame.height;

            var xNotFit = x + width > this.baseTexture.width;
            var yNotFit = y + height > this.baseTexture.height;

            if (xNotFit || yNotFit) {
                var relationship = xNotFit && yNotFit ? 'and' : 'or';
                var errorX = 'X: ' + x + ' + ' + width + ' = ' + (x + width) + ' > ' + this.baseTexture.width;
                var errorY = 'Y: ' + y + ' + ' + height + ' = ' + (y + height) + ' > ' + this.baseTexture.height;

                throw new Error('Texture Error: frame does not fit inside the base Texture dimensions: ' + (errorX + ' ' + relationship + ' ' + errorY));
            }

            // this.valid = width && height && this.baseTexture.source && this.baseTexture.hasLoaded;
            this.valid = width && height && this.baseTexture.hasLoaded;

            if (!this.trim && !this.rotate) {
                this.orig = frame;
            }

            if (this.valid) {
                this._updateUvs();
            }
        }

        /**
         * Indicates whether the texture is rotated inside the atlas
         * set to 2 to compensate for texture packer rotation
         * set to 6 to compensate for spine packer rotation
         * can be used to rotate or mirror sprites
         * See {@link PIXI.GroupD8} for explanation
         *
         * @member {number}
         */

    }, {
        key: 'rotate',
        get: function get() {
            return this._rotate;
        },
        set: function set(rotate) // eslint-disable-line require-jsdoc
        {
            this._rotate = rotate;
            if (this.valid) {
                this._updateUvs();
            }
        }

        /**
         * The width of the Texture in pixels.
         *
         * @member {number}
         */

    }, {
        key: 'width',
        get: function get() {
            return this.orig.width;
        }

        /**
         * The height of the Texture in pixels.
         *
         * @member {number}
         */

    }, {
        key: 'height',
        get: function get() {
            return this.orig.height;
        }
    }]);

    return Texture;
}(_eventemitter2.default);

exports.default = Texture;


function createWhiteTexture() {
    var canvas = document.createElement('canvas');

    canvas.width = 10;
    canvas.height = 10;

    var context = canvas.getContext('2d');

    context.fillStyle = 'white';
    context.fillRect(0, 0, 10, 10);

    return new Texture(new _BaseTexture2.default(canvas));
}

function removeAllHandlers(tex) {
    tex.destroy = function _emptyDestroy() {/* empty */};
    tex.on = function _emptyOn() {/* empty */};
    tex.once = function _emptyOnce() {/* empty */};
    tex.emit = function _emptyEmit() {/* empty */};
}

/**
 * An empty texture, used often to not have to create multiple empty textures.
 * Can not be destroyed.
 *
 * @static
 * @constant
 */
Texture.EMPTY = new Texture(new _BaseTexture2.default());
removeAllHandlers(Texture.EMPTY);
removeAllHandlers(Texture.EMPTY.baseTexture);

/**
 * A white texture of 10x10 size, used for graphics and other things
 * Can not be destroyed.
 *
 * @static
 * @constant
 */
Texture.WHITE = createWhiteTexture();
removeAllHandlers(Texture.WHITE);
removeAllHandlers(Texture.WHITE.baseTexture);
//# sourceMappingURL=Texture.js.map

/***/ }),
/* 50 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DI = {
    ISettings: Symbol('ISettings'),
    IModule: Symbol('IModule'),
    IView: Symbol('IView'),
    ProgressBar: Symbol('ProgressBar'),
    Translator: Symbol('Translator'),
    TextStyles: Symbol('TextStyles'),
    SpinButtonView: Symbol('SpinButtonView'),
    ViewManager: Symbol('ViewManager'),
    PixiStageContainer: Symbol('PixiStageContainer'),
    SoundManager: Symbol('SoundManager'),
    SoundPlayer: Symbol('SoundPlayer'),
    ObjectBuilder: Symbol('ObjectBuilder'),
    Logic: Symbol('Logic'),
    WinPresentationModule: Symbol('WinPresentationModule'),
    WinPresentationUtils: Symbol('WinPresentationUtils'),
    WinConfig: Symbol('WinConfig'),
    CheatModule: Symbol('CheatModule'),
    InfoPage: Symbol('InfoPage'),
    CurrencyFormatter: Symbol('CurrencyFormatter'),
    Layout: Symbol('Layout'),
};
exports.default = DI;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Device_1 = __webpack_require__(42);
var CoreDI_1 = __webpack_require__(32);
var TextStyles_1 = __webpack_require__(229);
var AsyncEventManager_1 = __webpack_require__(470);
var EventManagerWithAsync_1 = __webpack_require__(471);
var RectangleArea_1 = __webpack_require__(230);
var ResourcesLoader_1 = __webpack_require__(69);
var FullscreenManager_1 = __webpack_require__(107);
var ResolutionManager_1 = __webpack_require__(143);
var VisibilityManager_1 = __webpack_require__(231);
var UpdateManager_1 = __webpack_require__(70);
var CurrencyFormatter_1 = __webpack_require__(72);
var DI_1 = __webpack_require__(51);
var Layout_1 = __webpack_require__(146);
var Translator_1 = __webpack_require__(232);
var StaticStrings_1 = __webpack_require__(482);
var inversify_1 = __webpack_require__(14);
var WebFont = __webpack_require__(483);
var WebGlPerformanceCaveatResult;
(function (WebGlPerformanceCaveatResult) {
    WebGlPerformanceCaveatResult[WebGlPerformanceCaveatResult["SOFTWARE"] = 0] = "SOFTWARE";
    WebGlPerformanceCaveatResult[WebGlPerformanceCaveatResult["HARDWARE"] = 1] = "HARDWARE";
    WebGlPerformanceCaveatResult[WebGlPerformanceCaveatResult["NOT_IMPLEMENTED"] = 2] = "NOT_IMPLEMENTED";
})(WebGlPerformanceCaveatResult = exports.WebGlPerformanceCaveatResult || (exports.WebGlPerformanceCaveatResult = {}));
var System = /** @class */ (function () {
    function System(initViewport, onReady, getBaseUrlPath, majorCaveatPerformance) {
        if (getBaseUrlPath === void 0) { getBaseUrlPath = null; }
        if (majorCaveatPerformance === void 0) { majorCaveatPerformance = WebGlPerformanceCaveatResult.HARDWARE; }
        var _this = this;
        this._isTickerPaused = false;
        this._isOneFrameExpected = false;
        this._textHeadsUpItems = [];
        this._majorCaveatPerformance = majorCaveatPerformance;
        this._viewport = new RectangleArea_1.RectangleArea();
        this._urlParams = this.parseUrlParams();
        if (!getBaseUrlPath) {
            getBaseUrlPath = this.baseUrlPath.bind(this);
        }
        this._currencyFormatter = this.createCurrencyFormatter();
        var locale = this.getLocale();
        this.setupReelConstants();
        this._device = new Device_1.Device(function () {
            var fontPath = getBaseUrlPath('resources/fonts/FStyles.css');
            var fontFamily = _this.setFontFamily(locale);
            var currencyISO = _this.getCurrencyISO();
            var WebFontConfig = {
                custom: {
                    families: [fontFamily],
                    urls: [fontPath],
                },
                fontloading: function () {
                    function generateFontItem(fontFamily) {
                        var element = document.createElement('p');
                        element.style.fontFamily = fontFamily;
                        element.style.fontSize = '0px';
                        element.style.visibility = 'hidden';
                        element.innerHTML =
                            '{"BaseString:c_blΥπόλοι,wΚέρδςΠντάσμαyΝΑΊoΌΧΙkATRÁ%MINGupΤΜΟ ΔΡυθίεκηωήfφqΓγΖΩΕξmΣζd\\ΒΛΆΎώhLΦ.χKPOUCDEvV}WΗΞ2ΉΘ;!1<0>x[ύβψ9]34«»5()-6Έ&78F=+*@$¤ϋ/HJQXYZjz가개갸거게겨고괴괘교구귀궤규그긔기나내냐너네녀노뇌놰뇨누뉘눼뉴느늬니다대댜더데뎌도되돼됴두뒤뒈류드듸디라래랴러레려로뢰뢔료루뤼뤠르리마매먀머메며모뫼뫠묘무뮈뭬뮤므믜미바배뱌버베벼보뵈봬뵤부뷔붸뷰브븨비사새샤서세셔소쇠쇄쇼수쉬쉐슈아애야어에여오외왜요우위웨유으의이자재쟈저제져조죄좨죠주쥐줴쥬즈즤지차채챠처체쳐초최쵀쵸추취췌츄츠치카캐캬커케켜코쾨쾌쿄쿠퀴퀘큐크키타태탸터테텨토퇴퇘툐투튀퉤튜트틔티파패퍄퍼페펴포푀표푸퓌퓨프피하해햐허헤혀호회홰효후휘훼휴흐희히‘?’“”#÷×';
                        document.body.appendChild(element);
                    }
                    generateFontItem(fontFamily);
                },
                active: function () {
                    setTimeout(function () {
                        _this.loadAndStartGame(initViewport, onReady, getBaseUrlPath, locale, currencyISO);
                    }, 500);
                },
                inactive: function () {
                    setTimeout(function () {
                        _this.loadAndStartGame(initViewport, onReady, getBaseUrlPath, locale, currencyISO);
                    }, 500);
                },
            };
            WebFont.load(WebFontConfig);
        });
    }
    System_1 = System;
    System.prototype.endLoading = function () {
        this._resourcesLoader.endLoading();
    };
    System.prototype.setupMobileApproach = function (hasTwoViews) {
        System_1.MOBILE_HAS_TWO_VIEWS = hasTwoViews;
    };
    System.prototype.shouldUseMultipleViews = function () {
        return this.device.isMobile && System_1.MOBILE_HAS_TWO_VIEWS;
    };
    System.prototype.setupReelConstants = function () {
        throw new Error('Needs to be implemented.');
    };
    System.prototype.isSupportedDeviceAndBrowser = function (device) {
        return true;
    };
    System.prototype.showUnsupportedDeviceText = function () {
        // no strings for this.
    };
    System.prototype.showUnsupportedBrowserText = function () {
        // no strings for this
    };
    System.prototype.showUpdateBrowserText = function () {
        var text = StaticStrings_1.StaticStrings.updateBrowser(this.getLocale());
        this.addHeadsUpTextElement(text, 'update_browser');
    };
    System.prototype.showActivateHardwareAccelerationText = function () {
        var text = StaticStrings_1.StaticStrings.hardwareAcceleration(this.getLocale());
        this.addHeadsUpTextElement(text, 'hardware_acceleration');
    };
    System.prototype.showOptimizedForChromeText = function () {
        var text = StaticStrings_1.StaticStrings.optimizedForChrome(this.getLocale());
        this.addHeadsUpTextElement(text, 'optimized_for_chrome');
    };
    System.prototype.addHeadsUpTextElement = function (text, id) {
        var textItem = document.createElement('div');
        textItem.innerText = text;
        textItem.style.paddingBottom = '1.0em';
        textItem.style.fontSize = '1.0em';
        textItem.style.color = 'white';
        textItem.style.position = 'relative';
        textItem.style.webkitTransform = 'translateX(-50%)';
        textItem.style.transform = 'translateX(-50%)';
        textItem.id = id;
        textItem.className = 'FANTASMAHEADSUP';
        this.headsUpParent.appendChild(textItem);
        this._textHeadsUpItems.push(textItem);
        return textItem;
    };
    System.prototype.loadAndStartGame = function (initViewport, onReady, getBaseUrlPath, locale, currencyISO) {
        var _this = this;
        initViewport(this.device, this._viewport);
        this._resourcesLoader = this.createResourceLoader(getBaseUrlPath, locale);
        if (false) {
            this._resourcesLoader._useSingleSpineAtlas = this._urlParams.useSpineAtlas === 'true';
        }
        if (!this.isSupportedDeviceAndBrowser(this.device)) {
            // show error for unsupported device.
            this.showUpdateBrowserText();
            if (!this.device.chrome) {
                this.showOptimizedForChromeText();
            }
            // this._resourcesLoader.usingUnsupportedDeviceOrBrowser();
            // console.error('Device and browser combination is unsupported. Please upgrade');
            return;
        }
        if (this._majorCaveatPerformance === WebGlPerformanceCaveatResult.SOFTWARE) {
            this.showActivateHardwareAccelerationText();
        }
        if (this._majorCaveatPerformance === WebGlPerformanceCaveatResult.NOT_IMPLEMENTED) {
            this.showUpdateBrowserText();
            if (!this.device.chrome) {
                this.showOptimizedForChromeText();
            }
        }
        this._resourcesLoader.addCurrencyToResourcesList(function () { }, currencyISO);
        this._resourcesLoader.calculateExpectedTotal();
        this._resourcesLoader.loadConfigFiles(function () {
            _this._resourcesLoader.loadHelpStyles(function () {
                _this._resourcesLoader.loadHelpFiles(function () {
                    _this._resourcesLoader.loadTranslations(function () {
                        _this._resourcesLoader.loadLocaleTexts(function () {
                            _this._resourcesLoader.loadParticles(function () {
                                _this._resourcesLoader.loadSounds(function () {
                                    _this._resourcesLoader.loadSoundsConfig(function () {
                                        _this._resourcesLoader.loadSingleSpineAtlas(function () {
                                            _this._resourcesLoader.load(function () {
                                                _this.onInitialized();
                                                onReady();
                                            }, _this._device.isMobile ? ResourcesLoader_1.Platform.MOBILE : ResourcesLoader_1.Platform.DESKTOP);
                                        });
                                    });
                                });
                            });
                        }, locale);
                    }, locale);
                }, locale);
            });
        });
    };
    System.prototype.createResourceLoader = function (getBaseUrlPath, locale) {
        return new ResourcesLoader_1.ResourcesLoader(this.device, getBaseUrlPath, locale, this._majorCaveatPerformance);
    };
    System.prototype.createCurrencyFormatter = function () {
        return new CurrencyFormatter_1.CurrencyFormatter();
    };
    System.prototype.getCurrencyISO = function () {
        return 'USD';
    };
    System.prototype.baseUrlPath = function (resource) {
        return '../' + resource;
    };
    System.prototype.setFontFamily = function (locale) {
        var fontFamily = 'Black Han Sans';
        if (locale === 'ja') {
            fontFamily = 'Nicokaku';
        }
        else if (locale === 'bg' || locale === 'ru' || locale === 'el') {
            fontFamily = 'Alegreya Sans Sc';
        }
        else if (locale === 'th') {
            fontFamily = 'Pridi Regular';
        }
        return fontFamily;
    };
    System.prototype.parseUrlParams = function () {
        var urlParams = {};
        var pl = /\+/g; // regex for replacing addition symbol with a space
        var search = /([^&=]+)=?([^&]*)/g;
        var decode = function (s) {
            return decodeURIComponent(s.replace(pl, ' '));
        };
        var query = window.location.search.substring(1);
        var match;
        while ((match = search.exec(query))) {
            urlParams[decode(match[1])] = decode(match[2]);
        }
        return urlParams;
    };
    System.prototype.getLocale = function () {
        return this.urlParams && this.urlParams.locale ? this.urlParams.locale : 'en';
    };
    System.prototype.clearHeadsUpItems = function () {
        for (var item in this._textHeadsUpItems) {
            if (this._textHeadsUpItems.hasOwnProperty(item)) {
                var parent_1 = this._textHeadsUpItems[item].parentNode;
                parent_1.removeChild(this._textHeadsUpItems[item]);
            }
        }
        if (this._headsUpParent) {
            this._headsUpParent.parentNode.removeChild(this._headsUpParent);
        }
    };
    System.prototype.onInitialized = function () {
        var _this = this;
        this.clearHeadsUpItems();
        this._container = new inversify_1.Container();
        this._container.bind(CoreDI_1.CoreDI.System).toConstantValue(this);
        this._container.bind(CoreDI_1.CoreDI.ResourceLoader).toConstantValue(this._resourcesLoader);
        this._container
            .bind(DI_1.default.Layout)
            .to(Layout_1.Layout)
            .inSingletonScope();
        this._container
            .bind(CoreDI_1.CoreDI.IAsyncEventManager)
            .to(AsyncEventManager_1.AsyncEventManager)
            .inSingletonScope();
        this._container
            .bind(CoreDI_1.CoreDI.IEventManagerWithAsync)
            .to(EventManagerWithAsync_1.EventManagerWithAsync)
            .inSingletonScope();
        this._resolutionManager = new ResolutionManager_1.ResolutionManager(this._viewport, this._device);
        this._updateManager = new UpdateManager_1.UpdateManager();
        this._container
            .bind(DI_1.default.Translator)
            .to(Translator_1.Translator)
            .inSingletonScope();
        this._container.get(DI_1.default.Translator).init(this.getLocale());
        this._container.bind(DI_1.default.CurrencyFormatter).toConstantValue(this._currencyFormatter);
        this._container
            .bind(DI_1.default.TextStyles)
            .to(TextStyles_1.TextStyles)
            .inSingletonScope();
        this._container.get(DI_1.default.TextStyles).init(this.getLocale(), this._resolutionManager, this._device, this._resourcesLoader.getConfig('config.json'));
        this._app = new PIXI.Application({
            width: this._viewport.width,
            height: this._viewport.height,
            autoResize: true,
            resolution: 1,
            // resolution: this._resolutionManager.defaultViewportResolution.x,
            // webGL makes the screen flickering on v53 Chrome for Android (The issue is occurring only with alpha:false option.)
            // https://bugs.chromium.org/p/chromium/issues/detail?id=651470
            transparent: false,
        });
        ///////////////////////////////////////////////////////////////////////////////////////
        if (false) {
            document.addEventListener('keydown', this.keyboardInput.bind(this));
            window.tickerMultiplier = 1.0;
            var ticker = document.createElement('div');
            ticker.id = 'TickerComponent';
            ticker.style.top = '50px';
            ticker.style.right = '100px';
            ticker.style.position = 'absolute';
            ticker.style.zIndex = '191919';
            ticker.style.visibility = 'hidden';
            ticker.style.color = 'white';
            document.body.appendChild(ticker);
        }
        ///////////////////////////////////////////////////////////////////////////////////////
        this._app.renderer.on('prerender', function () {
            if (!_this._isTickerPaused || _this._isOneFrameExpected) {
                if (_this._isOneFrameExpected) {
                    _this._isOneFrameExpected = false;
                }
                if (false) {
                    _this._updateManager.update((_this.app.ticker.deltaTime / PIXI.settings.TARGET_FPMS) * window.tickerMultiplier);
                }
                if (true) {
                    _this._updateManager.update(_this.app.ticker.deltaTime / PIXI.settings.TARGET_FPMS);
                }
            }
        });
        this._container.bind(CoreDI_1.CoreDI.Device).toConstantValue(this._device);
        this._container.bind(CoreDI_1.CoreDI.UpdateManager).toConstantValue(this.updateManager);
        this._container.bind(CoreDI_1.CoreDI.ResolutionManager).toConstantValue(this._resolutionManager);
        this._container.bind(CoreDI_1.CoreDI.Application).toConstantValue(this.app);
        this.bindFullscreenManager();
        this._container
            .bind(CoreDI_1.CoreDI.VisibilityManager)
            .to(VisibilityManager_1.VisibilityManager)
            .inSingletonScope();
        this.initAndBindIntegrationSpecificServices();
        this._app.view.id = 'GameCanvas';
        this._app.view.style.position = 'absolute';
        var mainGameDiv = document.getElementById('gameContainer');
        mainGameDiv.appendChild(this._app.view);
        this._fullscreenManager = this._container.get(CoreDI_1.CoreDI.FullscreenManager);
    };
    System.prototype.initAndBindIntegrationSpecificServices = function () {
        //
    };
    System.prototype.bindFullscreenManager = function () {
        this._container
            .bind(CoreDI_1.CoreDI.FullscreenManager)
            .to(FullscreenManager_1.FullscreenManager)
            .inSingletonScope();
    };
    System.prototype.keyboardInput = function (event) {
        if (false) {
            if (event.code === 'ArrowUp') {
                if (event.shiftKey) {
                    window.tickerMultiplier += 0.01;
                }
                else if (event.ctrlKey) {
                    window.tickerMultiplier += 10.0;
                }
                else if (event.altKey) {
                    window.tickerMultiplier += 1.0;
                }
                else {
                    window.tickerMultiplier += 0.1;
                }
                document.getElementById('TickerComponent').innerHTML = window.tickerMultiplier;
            }
            if (event.code === 'ArrowDown') {
                if (event.shiftKey) {
                    window.tickerMultiplier += 0.01;
                }
                else if (event.ctrlKey) {
                    window.tickerMultiplier -= window.tickerMultiplier > 10 ? 10.0 : 0;
                }
                else if (event.altKey) {
                    window.tickerMultiplier -= window.tickerMultiplier > 1 ? 1.0 : 0;
                }
                else {
                    window.tickerMultiplier -= 0.1;
                }
                document.getElementById('TickerComponent').innerHTML = window.tickerMultiplier;
            }
            if (event.code === 'KeyP') {
                if (event.shiftKey) {
                    window.tickerMultiplier = 1;
                    document.getElementById('TickerComponent').style.visibility = 'hidden';
                }
                else if (event.altKey) {
                    window.tickerMultiplier = 0.1;
                    document.getElementById('TickerComponent').style.visibility = 'visible';
                }
                else {
                    this._isTickerPaused = !this._isTickerPaused;
                }
            }
            if (event.code === 'Period') {
                this._isOneFrameExpected = true;
            }
        }
    };
    Object.defineProperty(System.prototype, "headsUpParent", {
        get: function () {
            if (this._headsUpParent) {
                return this._headsUpParent;
            }
            this._headsUpParent = document.createElement('div');
            this._headsUpParent.style.position = 'absolute';
            this._headsUpParent.style.left = '50%';
            this._headsUpParent.style.top = '1em';
            document.body.appendChild(this._headsUpParent);
            return this._headsUpParent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(System.prototype, "updateManager", {
        get: function () {
            return this._updateManager;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(System.prototype, "app", {
        get: function () {
            return this._app;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(System.prototype, "device", {
        get: function () {
            return this._device;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(System.prototype, "urlParams", {
        get: function () {
            return this._urlParams;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(System.prototype, "resolutionManager", {
        get: function () {
            return this._resolutionManager;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(System.prototype, "container", {
        get: function () {
            return this._container;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(System.prototype, "viewport", {
        get: function () {
            return this._viewport;
        },
        enumerable: true,
        configurable: true
    });
    var System_1;
    System.MOBILE_HAS_TWO_VIEWS = false;
    System = System_1 = __decorate([
        inversify_1.injectable(),
        __metadata("design:paramtypes", [Function, Function,
            Function, Number])
    ], System);
    return System;
}());
exports.System = System;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ERROR_MSGS = __webpack_require__(27);
var METADATA_KEY = __webpack_require__(18);
function tagParameter(annotationTarget, propertyName, parameterIndex, metadata) {
    var metadataKey = METADATA_KEY.TAGGED;
    _tagParameterOrProperty(metadataKey, annotationTarget, propertyName, metadata, parameterIndex);
}
exports.tagParameter = tagParameter;
function tagProperty(annotationTarget, propertyName, metadata) {
    var metadataKey = METADATA_KEY.TAGGED_PROP;
    _tagParameterOrProperty(metadataKey, annotationTarget.constructor, propertyName, metadata);
}
exports.tagProperty = tagProperty;
function _tagParameterOrProperty(metadataKey, annotationTarget, propertyName, metadata, parameterIndex) {
    var paramsOrPropertiesMetadata = {};
    var isParameterDecorator = (typeof parameterIndex === "number");
    var key = (parameterIndex !== undefined && isParameterDecorator) ? parameterIndex.toString() : propertyName;
    if (isParameterDecorator && propertyName !== undefined) {
        throw new Error(ERROR_MSGS.INVALID_DECORATOR_OPERATION);
    }
    if (Reflect.hasOwnMetadata(metadataKey, annotationTarget)) {
        paramsOrPropertiesMetadata = Reflect.getMetadata(metadataKey, annotationTarget);
    }
    var paramOrPropertyMetadata = paramsOrPropertiesMetadata[key];
    if (!Array.isArray(paramOrPropertyMetadata)) {
        paramOrPropertyMetadata = [];
    }
    else {
        for (var _i = 0, paramOrPropertyMetadata_1 = paramOrPropertyMetadata; _i < paramOrPropertyMetadata_1.length; _i++) {
            var m = paramOrPropertyMetadata_1[_i];
            if (m.key === metadata.key) {
                throw new Error(ERROR_MSGS.DUPLICATED_METADATA + " " + m.key);
            }
        }
    }
    paramOrPropertyMetadata.push(metadata);
    paramsOrPropertiesMetadata[key] = paramOrPropertyMetadata;
    Reflect.defineMetadata(metadataKey, paramsOrPropertiesMetadata, annotationTarget);
}
function _decorate(decorators, target) {
    Reflect.decorate(decorators, target);
}
function _param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); };
}
function decorate(decorator, target, parameterIndex) {
    if (typeof parameterIndex === "number") {
        _decorate([_param(parameterIndex, decorator)], target);
    }
    else if (typeof parameterIndex === "string") {
        Reflect.decorate([decorator], target, parameterIndex);
    }
    else {
        _decorate([decorator], target);
    }
}
exports.decorate = decorate;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ButtonState;
(function (ButtonState) {
    ButtonState[ButtonState["UP"] = 0] = "UP";
    ButtonState[ButtonState["DOWN"] = 1] = "DOWN";
    ButtonState[ButtonState["OVER"] = 2] = "OVER";
    ButtonState[ButtonState["DISABLED"] = 3] = "DISABLED";
    ButtonState[ButtonState["SELECTED"] = 4] = "SELECTED";
})(ButtonState = exports.ButtonState || (exports.ButtonState = {}));
var Button = /** @class */ (function (_super) {
    __extends(Button, _super);
    function Button(callback) {
        var _this = _super.call(this) || this;
        _this._frames = {};
        _this._callback = callback;
        _this.setupInputCallbacks();
        return _this;
    }
    Button.prototype.enable = function () {
        if (this._over) {
            this.setState(ButtonState.OVER);
        }
        else {
            this.setState(ButtonState.UP);
        }
        this.interactive = true;
        this.buttonMode = true;
    };
    Button.prototype.disable = function () {
        this.setState(ButtonState.DISABLED);
        this.interactive = false;
        this.buttonMode = false;
    };
    Button.prototype.setupInputCallbacks = function () {
        this.on('mousedown', this.onMouseDown);
        this.on('mouseup', this.onMouseUp);
        this.on('mouseover', this.onMouseOver);
        this.on('mouseout', this.onMouseOut);
        this.on('click', this.onClick);
        this.on('tap', this.onClick);
        this.on('touchstart', this.onMouseDown);
        this.on('touchendoutside', this.onMouseOut);
        this.on('touchend', this.onMouseUp);
        this.on('touchleave', this.onMouseUp);
    };
    Button.prototype.updateFrame = function () { };
    Button.prototype.onMouseUp = function () {
        this.setState(ButtonState.UP);
    };
    Button.prototype.onMouseDown = function () {
        this.setState(ButtonState.DOWN);
        this._tapDownCallback && this._tapDownCallback();
    };
    Button.prototype.onMouseOver = function () {
        this._over = true;
        this.setState(ButtonState.OVER);
    };
    Button.prototype.onMouseOut = function () {
        this._mouseOutCallback && this._mouseOutCallback();
        this._over = false;
        this.setState(ButtonState.UP);
    };
    Button.prototype.onClick = function () {
        this.setState(ButtonState.OVER);
        if (this._callback) {
            this._callback(this._callbackParams);
        }
        else {
            console.warn('There is no a callback.');
        }
    };
    Button.prototype.cleanFrame = function () { };
    Button.prototype.setState = function (value, cleanFrame) {
        if (cleanFrame === void 0) { cleanFrame = true; }
        if (this._state !== value) {
            this._state = value;
            if (cleanFrame) {
                this.cleanFrame();
            }
            this.updateFrame();
        }
    };
    Object.defineProperty(Button.prototype, "callback", {
        set: function (value) {
            this._callback = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "callbackParams", {
        set: function (value) {
            this._callbackParams = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "tapDownCallback", {
        set: function (value) {
            this._tapDownCallback = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "mouseOutCallback", {
        set: function (value) {
            this._mouseOutCallback = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "currentState", {
        get: function () {
            return this._state;
        },
        enumerable: true,
        configurable: true
    });
    return Button;
}(PIXI.Sprite));
exports.Button = Button;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Button_1 = __webpack_require__(54);
var SpriteButton = /** @class */ (function (_super) {
    __extends(SpriteButton, _super);
    function SpriteButton(callback) {
        var _this = _super.call(this, callback) || this;
        _this.enable();
        return _this;
    }
    SpriteButton.prototype.setFramesNames = function (resources, sheetName, up, down, over, disabled) {
        var buttonUp = new PIXI.Sprite(resources.getSpritesheetTexture(sheetName, up));
        var buttonDown = new PIXI.Sprite(resources.getSpritesheetTexture(sheetName, down ? down : up));
        var buttonOver = new PIXI.Sprite(resources.getSpritesheetTexture(sheetName, over ? over : up));
        var buttonDisabled = new PIXI.Sprite(resources.getSpritesheetTexture(sheetName, disabled ? disabled : up));
        buttonUp.anchor.set(0.5, 0.5);
        buttonDown.anchor.set(0.5, 0.5);
        buttonOver.anchor.set(0.5, 0.5);
        buttonDisabled.anchor.set(0.5, 0.5);
        this.setFrames(buttonUp, buttonDown, buttonOver, buttonDisabled);
    };
    SpriteButton.prototype.setFrames = function (up, down, over, disabled) {
        this._frames[Button_1.ButtonState.UP] = up;
        this._frames[Button_1.ButtonState.DOWN] = down ? down : up;
        this._frames[Button_1.ButtonState.OVER] = over ? over : up;
        this._frames[Button_1.ButtonState.DISABLED] = disabled ? disabled : up;
        this.updateFrame();
    };
    SpriteButton.prototype.updateFrame = function () {
        if (this._frames[this._state]) {
            this.addChild(this._frames[this._state]);
        }
    };
    SpriteButton.prototype.cleanFrame = function () {
        this.removeChildren();
    };
    return SpriteButton;
}(Button_1.Button));
exports.SpriteButton = SpriteButton;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AutoplayHandlerEvents = /** @class */ (function () {
    function AutoplayHandlerEvents() {
    }
    AutoplayHandlerEvents.START_AUTOPLAY_SPIN = 'AutoplayHandlerEvents::START_AUTOPLAY_SPIN';
    AutoplayHandlerEvents.AUTOPLAY_ROUNDS_FINISHED = 'AutoplayHandlerEvents::AUTOPLAY_ROUNDS_FINISHED';
    AutoplayHandlerEvents.AUTOPLAY_STOPPED = 'AutoplayHandlerEvents::AUTOPLAY_STOPPED';
    AutoplayHandlerEvents.AUTOPLAY_STOPPED_ON_WIN_LIMIT = 'AutoplayHandlerEvents::AUTOPLAY_STOPPED_ON_WIN_LIMIT';
    AutoplayHandlerEvents.AUTOPLAY_STOPPED_ON_LOSE_LIMIT = 'AutoplayHandlerEvents::AUTOPLAY_STOPPED_ON_LOSE_LIMIT';
    AutoplayHandlerEvents.AUTOPLAY_STOPPED_ON_SINGLE_WIN_LIMIT = 'AutoplayHandlerEvents::AUTOPLAY_STOPPED_ON_SINGLE_WIN_LIMIT';
    return AutoplayHandlerEvents;
}());
exports.AutoplayHandlerEvents = AutoplayHandlerEvents;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var GameFlowEvents = /** @class */ (function () {
    function GameFlowEvents() {
    }
    GameFlowEvents.HAS_WIN_SYMBOLS_TO_HIGHLIGHT = 'GameFlowEvents::HAS_WIN_SYMBOLS_TO_HIGHLIGHT';
    GameFlowEvents.HAS_WIN_WITH_MULTIPLIER = 'GameFlowEvents::HAS_WIN_WITH_MULTIPLIER';
    GameFlowEvents.HAS_BIGWIN_WITH_MULTIPLIER = 'GameFlowEvents::HAS_BIGWIN_WITH_MULTIPLIER';
    GameFlowEvents.HAS_WIN_WITH_NO_MULTIPLIER = 'GameFlowEvents::HAS_WIN_WITH_NO_MULTIPLIER';
    GameFlowEvents.HAS_BIGWIN_WITH_NO_MULTIPLIER = 'GameFlowEvents::HAS_BIGWIN_WITH_NO_MULTIPLIER';
    GameFlowEvents.PLAY_FREE_SPINS_TRIGGER = 'GameFlowEvents::PLAY_FREE_SPINS_TRIGGER';
    return GameFlowEvents;
}());
exports.GameFlowEvents = GameFlowEvents;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var WinUtils = /** @class */ (function () {
    function WinUtils() {
    }
    WinUtils.isBigWin = function (logic) {
        return logic.getSpinWin() >= logic.getTotalBet() * WinUtils.BIG_WIN_THRESHOLD;
    };
    WinUtils.isNiceWin = function (logic) {
        // Not used in medallion.
        return logic.getSpinWin() >= logic.getTotalBet() * WinUtils.NICE_WIN_THRESHOLD_LOW && logic.getSpinWin() < logic.getTotalBet() * WinUtils.NICE_WIN_THRESHOLD_HIGH;
    };
    WinUtils.isBigWinNextRound = function (logic) {
        return logic.getNextSpinWin() >= logic.getTotalBet() * WinUtils.BIG_WIN_THRESHOLD;
    };
    WinUtils.isTotalWinBigWin = function (logic) {
        return logic.getWin() >= logic.getTotalBet() * WinUtils.BIG_WIN_THRESHOLD;
    };
    WinUtils.isSpinNiceWin = function (logic) {
        // Not used in medallion.
        return logic.getSpinWin() >= logic.getTotalBet() * WinUtils.NICE_WIN_ONE_ROUND_THRESHOLD_LOW && logic.getSpinWin() < logic.getTotalBet() * WinUtils.NICE_WIN_ONE_ROUND_THRESHOLD_HIGH;
    };
    WinUtils.isSpinExcellentWin = function (logic) {
        return logic.getSpinWin() >= logic.getTotalBet() * WinUtils.NICE_WIN_ONE_ROUND_THRESHOLD_HIGH;
    };
    WinUtils.isSpinAboveNormalWin = function (logic) {
        return logic.getSpinWin() >= logic.getTotalBet() * WinUtils.NICE_WIN_ONE_ROUND_THRESHOLD_LOW;
    };
    WinUtils.isRoundAboveNormalWin = function (logic) {
        return logic.getWin() >= logic.getTotalBet() * WinUtils.NICE_WIN_ONE_ROUND_THRESHOLD_LOW;
    };
    WinUtils.isRoundNiceWin = function (logic) {
        return logic.getWin() >= logic.getTotalBet() * WinUtils.NICE_WIN_ONE_ROUND_THRESHOLD_LOW && logic.getWin() < logic.getTotalBet() * WinUtils.NICE_WIN_ONE_ROUND_THRESHOLD_HIGH;
    };
    WinUtils.isRoundExcellentWin = function (logic) {
        return logic.getWin() >= logic.getTotalBet() * WinUtils.NICE_WIN_ONE_ROUND_THRESHOLD_HIGH;
    };
    WinUtils.inBigWinBigWin = function (logic) {
        return logic.getSpinWin() >= logic.getTotalBet() * WinUtils.BIG_WIN_THRESHOLD && logic.getSpinWin() < logic.getTotalBet() * WinUtils.SUPER_WIN_THRESHOLD;
    };
    WinUtils.inBigWinSuperWin = function (logic) {
        return logic.getSpinWin() >= logic.getTotalBet() * WinUtils.SUPER_WIN_THRESHOLD && logic.getSpinWin() < logic.getTotalBet() * WinUtils.MEGA_WIN_THRESHOLD;
    };
    WinUtils.inBigWinMegaWin = function (logic) {
        return logic.getSpinWin() >= logic.getTotalBet() * WinUtils.MEGA_WIN_THRESHOLD && logic.getSpinWin() < logic.getTotalBet() * WinUtils.EPIC_WIN_THRESHOLD;
    };
    WinUtils.inBigWinEpicWin = function (logic) {
        return logic.getSpinWin() >= logic.getTotalBet() * WinUtils.EPIC_WIN_THRESHOLD;
    };
    WinUtils.inBigWinBigWinNextSpin = function (logic) {
        return logic.getNextSpinWin() >= logic.getTotalBet() * WinUtils.BIG_WIN_THRESHOLD && logic.getNextSpinWin() < logic.getTotalBet() * WinUtils.SUPER_WIN_THRESHOLD;
    };
    WinUtils.inBigWinSuperWinNextSpin = function (logic) {
        return logic.getNextSpinWin() >= logic.getTotalBet() * WinUtils.SUPER_WIN_THRESHOLD && logic.getNextSpinWin() < logic.getTotalBet() * WinUtils.MEGA_WIN_THRESHOLD;
    };
    WinUtils.inBigWinMegaWinNextSpin = function (logic) {
        return logic.getNextSpinWin() >= logic.getTotalBet() * WinUtils.MEGA_WIN_THRESHOLD && logic.getNextSpinWin() < logic.getTotalBet() * WinUtils.EPIC_WIN_THRESHOLD;
    };
    WinUtils.inBigWinEpicWinNextSpin = function (logic) {
        return logic.getNextSpinWin() >= logic.getTotalBet() * WinUtils.EPIC_WIN_THRESHOLD;
    };
    WinUtils.isWin = function (logic) {
        return logic.getWin() > 0;
    };
    WinUtils.isSpinWin = function (logic) {
        return logic.getSpinWin() > 0;
    };
    WinUtils.isWinNumberExcellent = function (winNumber, bet) {
        return winNumber >= bet * WinUtils.NICE_WIN_ONE_ROUND_THRESHOLD_HIGH;
    };
    WinUtils.BIG_WIN_THRESHOLD = 15;
    WinUtils.SUPER_WIN_THRESHOLD = 40;
    WinUtils.MEGA_WIN_THRESHOLD = 70;
    WinUtils.EPIC_WIN_THRESHOLD = 100;
    WinUtils.NICE_WIN_THRESHOLD_LOW = 4;
    WinUtils.NICE_WIN_THRESHOLD_HIGH = 8;
    WinUtils.NICE_WIN_ONE_ROUND_THRESHOLD_LOW = 2;
    WinUtils.NICE_WIN_ONE_ROUND_THRESHOLD_HIGH = 5;
    return WinUtils;
}());
exports.WinUtils = WinUtils;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

exports.__esModule = true;
exports.loader = exports.prepare = exports.particles = exports.mesh = exports.loaders = exports.interaction = exports.filters = exports.extras = exports.extract = exports.accessibility = undefined;

var _polyfill = __webpack_require__(338);

Object.keys(_polyfill).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _polyfill[key];
        }
    });
});

var _core = __webpack_require__(7);

Object.keys(_core).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _core[key];
        }
    });
});

var _deprecation = __webpack_require__(399);

var _deprecation2 = _interopRequireDefault(_deprecation);

var _accessibility = __webpack_require__(400);

var accessibility = _interopRequireWildcard(_accessibility);

var _extract = __webpack_require__(402);

var extract = _interopRequireWildcard(_extract);

var _extras = __webpack_require__(201);

var extras = _interopRequireWildcard(_extras);

var _filters = __webpack_require__(412);

var filters = _interopRequireWildcard(_filters);

var _interaction = __webpack_require__(419);

var interaction = _interopRequireWildcard(_interaction);

var _loaders = __webpack_require__(421);

var loaders = _interopRequireWildcard(_loaders);

var _mesh = __webpack_require__(425);

var mesh = _interopRequireWildcard(_mesh);

var _particles = __webpack_require__(430);

var particles = _interopRequireWildcard(_particles);

var _prepare = __webpack_require__(435);

var prepare = _interopRequireWildcard(_prepare);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// export core
_core.utils.mixins.performMixins();

/**
 * Alias for {@link PIXI.loaders.shared}.
 * @name loader
 * @memberof PIXI
 * @type {PIXI.loader.Loader}
 */


// handle mixins now, after all code has been added, including deprecation


// export libs
// import polyfills. Done as an export to make sure polyfills are imported first
var loader = loaders.shared || null;

exports.accessibility = accessibility;
exports.extract = extract;
exports.extras = extras;
exports.filters = filters;
exports.interaction = interaction;
exports.loaders = loaders;
exports.mesh = mesh;
exports.particles = particles;
exports.prepare = prepare;
exports.loader = loader;

// Apply the deprecations

if (typeof _deprecation2.default === 'function') {
    (0, _deprecation2.default)(exports);
}

// Always export PixiJS globally.
global.PIXI = exports; // eslint-disable-line
//# sourceMappingURL=index.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @api private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {Mixed} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @api private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @api public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @api public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Boolean} exists Only check if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */
EventEmitter.prototype.listeners = function listeners(event, exists) {
  var evt = prefix ? prefix + event : event
    , available = this._events[evt];

  if (exists) return !!available;
  if (!available) return [];
  if (available.fn) return [available.fn];

  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
    ee[i] = available[i].fn;
  }

  return ee;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @api public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  var listener = new EE(fn, context || this)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  var listener = new EE(fn, context || this, true)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Remove the listeners of a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {Mixed} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
         listeners.fn === fn
      && (!once || listeners.once)
      && (!context || listeners.context === context)
    ) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
           listeners[i].fn !== fn
        || (once && !listeners[i].once)
        || (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {String|Symbol} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// This function doesn't apply anymore.
//
EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
  return this;
};

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if (true) {
  module.exports = EventEmitter;
}


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function guid() {
    function s4() {
        return Math.floor((Math.random() + 1) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return s4() + s4() + "-" + s4() + "-" + s4() + "-" +
        s4() + "-" + s4() + s4() + s4();
}
exports.guid = guid;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var GraphicsType;
(function (GraphicsType) {
    GraphicsType[GraphicsType["RECTANGLE"] = 0] = "RECTANGLE";
    GraphicsType[GraphicsType["ROUNDEDRECTANGLE"] = 1] = "ROUNDEDRECTANGLE";
    GraphicsType[GraphicsType["CIRCLE"] = 2] = "CIRCLE";
    GraphicsType[GraphicsType["ELLIPSE"] = 3] = "ELLIPSE";
    GraphicsType[GraphicsType["POLYGON"] = 4] = "POLYGON";
})(GraphicsType || (GraphicsType = {}));
var SpriteGraphics = /** @class */ (function () {
    function SpriteGraphics() {
    }
    SpriteGraphics.makeRectangle = function (width, height, color, alpha) {
        if (color === void 0) { color = 0xffffff; }
        if (alpha === void 0) { alpha = 1; }
        var sprite = this.makeGraphics({ type: GraphicsType.RECTANGLE, width: width, height: height }, color, alpha);
        return sprite;
    };
    SpriteGraphics.makeHiddenRectangle = function (width, height) {
        var graphicsObject = new PIXI.Graphics();
        graphicsObject.drawRect(0, 0, width, height);
        var spriteObject = new PIXI.Sprite(graphicsObject.generateCanvasTexture());
        graphicsObject.destroy();
        return spriteObject;
    };
    SpriteGraphics.makeRoundedRectangle = function (width, height, radius, color, alpha) {
        if (alpha === void 0) { alpha = 1; }
        var sprite = this.makeGraphics({ type: GraphicsType.ROUNDEDRECTANGLE, width: width, height: height, radius: radius }, color, alpha);
        return sprite;
    };
    SpriteGraphics.makeCircle = function (radius, color, alpha) {
        var sprite = this.makeGraphics({ type: GraphicsType.CIRCLE, radius: radius }, color, alpha);
        return sprite;
    };
    SpriteGraphics.makeHiddenCircle = function (radius) {
        var graphicsObject = new PIXI.Graphics();
        graphicsObject.drawCircle(0, 0, radius);
        var spriteObject = new PIXI.Sprite(graphicsObject.generateCanvasTexture());
        graphicsObject.destroy();
        return spriteObject;
    };
    SpriteGraphics.makeEllipse = function (width, height, color, alpha) {
        var sprite = this.makeGraphics({ type: GraphicsType.ELLIPSE, width: width, height: height }, color, alpha);
        return sprite;
    };
    SpriteGraphics.makeHiddenEllipse = function (width, height) {
        var graphicsObject = new PIXI.Graphics();
        graphicsObject.drawEllipse(0, 0, width, height);
        var spriteObject = new PIXI.Sprite(graphicsObject.generateCanvasTexture());
        graphicsObject.destroy();
        return spriteObject;
    };
    SpriteGraphics.makeGraphics = function (data, color, alpha) {
        if (color === void 0) { color = 0xffffff; }
        if (alpha === void 0) { alpha = 1; }
        var graphicsObject = new PIXI.Graphics();
        graphicsObject.beginFill(color, alpha);
        switch (data.type) {
            case GraphicsType.RECTANGLE:
                graphicsObject.drawRect(0, 0, data.width, data.height);
                break;
            case GraphicsType.ROUNDEDRECTANGLE:
                graphicsObject.drawRoundedRect(0, 0, data.width, data.height, data.radius);
                break;
            case GraphicsType.CIRCLE:
                graphicsObject.drawCircle(0, 0, data.radius);
                break;
            case GraphicsType.ELLIPSE:
                graphicsObject.drawEllipse(0, 0, data.width, data.height);
                break;
            default:
                graphicsObject.drawRect(0, 0, 100, 100);
                break;
        }
        graphicsObject.endFill();
        var graphicsSprite = new PIXI.Sprite(graphicsObject.generateCanvasTexture());
        graphicsObject.destroy();
        return graphicsSprite;
    };
    return SpriteGraphics;
}());
exports.SpriteGraphics = SpriteGraphics;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var InfoPopupEvents = /** @class */ (function () {
    function InfoPopupEvents() {
    }
    InfoPopupEvents.INFO_POPUP_CLOSED = 'InfoPopupEvents::__INFO_POPUP_CLOSED__';
    InfoPopupEvents.INFO_POPUP_HOME_CLICKED = 'InfoPopupEvents::INFO_POPUP_HOME_CLICKED';
    InfoPopupEvents.INFO_POPUP_OPENED = 'InfoPopupEvents::__INFO_POPUP_OPENED__';
    InfoPopupEvents.RESTORE_POPUP_OPENED = 'InfoPopupEvents::RESTORE_POPUP_OPENED';
    InfoPopupEvents.RESTORE_POPUP_CLOSED = 'InfoPopupEvents::RESTORE_POPUP_CLOSED';
    return InfoPopupEvents;
}());
exports.InfoPopupEvents = InfoPopupEvents;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Symbol from spin response
 * Can be used in different context
 */
var GameSymbol = /** @class */ (function () {
    function GameSymbol(sym, size, position) {
        this._sym = sym;
        this._size = size;
        this._position = position;
    }
    Object.defineProperty(GameSymbol.prototype, "sym", {
        get: function () {
            return this._sym;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GameSymbol.prototype, "size", {
        get: function () {
            return this._size;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GameSymbol.prototype, "position", {
        get: function () {
            return this._position;
        },
        enumerable: true,
        configurable: true
    });
    return GameSymbol;
}());
exports.GameSymbol = GameSymbol;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SwipeInteractionEvents = /** @class */ (function () {
    function SwipeInteractionEvents() {
    }
    SwipeInteractionEvents.DRAGGING_STARTED = 'SwipeInteractionEvents::DRAGGING_STARTED';
    SwipeInteractionEvents.DRAGGING_FINISHED = 'SwipeInteractionEvents::DRAGGING_FINISHED';
    SwipeInteractionEvents.START_SPIN = 'SwipeInteractionEvents::START_SPIN';
    // Occurs when the dista
    SwipeInteractionEvents.REEL_BOUNCE_BACK_STARTED = 'SwipeInteractionEvents::REEL_BOUNCE_BACK_STARTED';
    SwipeInteractionEvents.REEL_BOUNCE_BACK_FINISHED = 'SwipeInteractionEvents::REEL_BOUNCE_BACK_FINISHED';
    return SwipeInteractionEvents;
}());
exports.SwipeInteractionEvents = SwipeInteractionEvents;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var WildMeterEvents = /** @class */ (function () {
    function WildMeterEvents() {
    }
    WildMeterEvents.WIN_METER_WILDS_ANIMATIONS_FINISHED = 'WildMeterEvents::WIN_METER_WILDS_ANIMATIONS_FINISHED';
    WildMeterEvents.WIN_METER_EXIT_WIN_ANIMATION_STARTED = 'WildMeterEvents::WIN_METER_EXIT_WIN_ANIMATION_STARTED';
    WildMeterEvents.WIN_METER_EXIT_WIN_ANIMATION_FINISHED = 'WildMeterEvents::WIN_METER_EXIT_WIN_ANIMATION_FINISHED';
    WildMeterEvents.ADD_WILD_COIN_TO_REELS = 'WildMeterEvents::ADD_WILD_COIN_TO_REELS';
    WildMeterEvents.SEND_COIN_TO_METER = 'WildMeterEvents::SEND_COIN_TO_METER';
    WildMeterEvents.COIN_HIT_METER = 'WildMeterEvents::COIN_HIT_METER';
    WildMeterEvents.MULTIPLIER_UDPATE = 'WildMeterEvents::MULTIPLIER_UDPATE';
    WildMeterEvents.INDICATOR_LIT = 'WildMeterEvents::INDICATOR_LIT';
    return WildMeterEvents;
}());
exports.WildMeterEvents = WildMeterEvents;


/***/ }),
/* 67 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _utils = __webpack_require__(9);

var _settings = __webpack_require__(17);

var _settings2 = _interopRequireDefault(_settings);

var _eventemitter = __webpack_require__(60);

var _eventemitter2 = _interopRequireDefault(_eventemitter);

var _determineCrossOrigin = __webpack_require__(184);

var _determineCrossOrigin2 = _interopRequireDefault(_determineCrossOrigin);

var _bitTwiddle = __webpack_require__(133);

var _bitTwiddle2 = _interopRequireDefault(_bitTwiddle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * A texture stores the information that represents an image. All textures have a base texture.
 *
 * @class
 * @extends EventEmitter
 * @memberof PIXI
 */
var BaseTexture = function (_EventEmitter) {
    _inherits(BaseTexture, _EventEmitter);

    /**
     * @param {HTMLImageElement|HTMLCanvasElement} [source] - the source object of the texture.
     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
     * @param {number} [resolution=1] - The resolution / device pixel ratio of the texture
     */
    function BaseTexture(source, scaleMode, resolution) {
        _classCallCheck(this, BaseTexture);

        var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

        _this.uid = (0, _utils.uid)();

        _this.touched = 0;

        /**
         * The resolution / device pixel ratio of the texture
         *
         * @member {number}
         * @default 1
         */
        _this.resolution = resolution || _settings2.default.RESOLUTION;

        /**
         * The width of the base texture set when the image has loaded
         *
         * @readonly
         * @member {number}
         */
        _this.width = 100;

        /**
         * The height of the base texture set when the image has loaded
         *
         * @readonly
         * @member {number}
         */
        _this.height = 100;

        // TODO docs
        // used to store the actual dimensions of the source
        /**
         * Used to store the actual width of the source of this texture
         *
         * @readonly
         * @member {number}
         */
        _this.realWidth = 100;
        /**
         * Used to store the actual height of the source of this texture
         *
         * @readonly
         * @member {number}
         */
        _this.realHeight = 100;

        /**
         * The scale mode to apply when scaling this texture
         *
         * @member {number}
         * @default PIXI.settings.SCALE_MODE
         * @see PIXI.SCALE_MODES
         */
        _this.scaleMode = scaleMode !== undefined ? scaleMode : _settings2.default.SCALE_MODE;

        /**
         * Set to true once the base texture has successfully loaded.
         *
         * This is never true if the underlying source fails to load or has no texture data.
         *
         * @readonly
         * @member {boolean}
         */
        _this.hasLoaded = false;

        /**
         * Set to true if the source is currently loading.
         *
         * If an Image source is loading the 'loaded' or 'error' event will be
         * dispatched when the operation ends. An underyling source that is
         * immediately-available bypasses loading entirely.
         *
         * @readonly
         * @member {boolean}
         */
        _this.isLoading = false;

        /**
         * The image source that is used to create the texture.
         *
         * TODO: Make this a setter that calls loadSource();
         *
         * @readonly
         * @member {HTMLImageElement|HTMLCanvasElement}
         */
        _this.source = null; // set in loadSource, if at all

        /**
         * The image source that is used to create the texture. This is used to
         * store the original Svg source when it is replaced with a canvas element.
         *
         * TODO: Currently not in use but could be used when re-scaling svg.
         *
         * @readonly
         * @member {Image}
         */
        _this.origSource = null; // set in loadSvg, if at all

        /**
         * Type of image defined in source, eg. `png` or `svg`
         *
         * @readonly
         * @member {string}
         */
        _this.imageType = null; // set in updateImageType

        /**
         * Scale for source image. Used with Svg images to scale them before rasterization.
         *
         * @readonly
         * @member {number}
         */
        _this.sourceScale = 1.0;

        /**
         * Controls if RGB channels should be pre-multiplied by Alpha  (WebGL only)
         * All blend modes, and shaders written for default value. Change it on your own risk.
         *
         * @member {boolean}
         * @default true
         */
        _this.premultipliedAlpha = true;

        /**
         * The image url of the texture
         *
         * @member {string}
         */
        _this.imageUrl = null;

        /**
         * Whether or not the texture is a power of two, try to use power of two textures as much
         * as you can
         *
         * @private
         * @member {boolean}
         */
        _this.isPowerOfTwo = false;

        // used for webGL

        /**
         *
         * Set this to true if a mipmap of this texture needs to be generated. This value needs
         * to be set before the texture is used
         * Also the texture must be a power of two size to work
         *
         * @member {boolean}
         * @see PIXI.MIPMAP_TEXTURES
         */
        _this.mipmap = _settings2.default.MIPMAP_TEXTURES;

        /**
         *
         * WebGL Texture wrap mode
         *
         * @member {number}
         * @see PIXI.WRAP_MODES
         */
        _this.wrapMode = _settings2.default.WRAP_MODE;

        /**
         * A map of renderer IDs to webgl textures
         *
         * @private
         * @member {object<number, WebGLTexture>}
         */
        _this._glTextures = {};

        _this._enabled = 0;
        _this._virtalBoundId = -1;

        /**
         * If the object has been destroyed via destroy(). If true, it should not be used.
         *
         * @member {boolean}
         * @private
         * @readonly
         */
        _this._destroyed = false;

        /**
         * The ids under which this BaseTexture has been added to the base texture cache. This is
         * automatically set as long as BaseTexture.addToCache is used, but may not be set if a
         * BaseTexture is added directly to the BaseTextureCache array.
         *
         * @member {string[]}
         */
        _this.textureCacheIds = [];

        // if no source passed don't try to load
        if (source) {
            _this.loadSource(source);
        }

        /**
         * Fired when a not-immediately-available source finishes loading.
         *
         * @protected
         * @event PIXI.BaseTexture#loaded
         * @param {PIXI.BaseTexture} baseTexture - Resource loaded.
         */

        /**
         * Fired when a not-immediately-available source fails to load.
         *
         * @protected
         * @event PIXI.BaseTexture#error
         * @param {PIXI.BaseTexture} baseTexture - Resource errored.
         */

        /**
         * Fired when BaseTexture is updated.
         *
         * @protected
         * @event PIXI.BaseTexture#update
         * @param {PIXI.BaseTexture} baseTexture - Instance of texture being updated.
         */

        /**
         * Fired when BaseTexture is destroyed.
         *
         * @protected
         * @event PIXI.BaseTexture#dispose
         * @param {PIXI.BaseTexture} baseTexture - Instance of texture being destroyed.
         */
        return _this;
    }

    /**
     * Updates the texture on all the webgl renderers, this also assumes the src has changed.
     *
     * @fires PIXI.BaseTexture#update
     */


    BaseTexture.prototype.update = function update() {
        // Svg size is handled during load
        if (this.imageType !== 'svg') {
            this.realWidth = this.source.naturalWidth || this.source.videoWidth || this.source.width;
            this.realHeight = this.source.naturalHeight || this.source.videoHeight || this.source.height;

            this._updateDimensions();
        }

        this.emit('update', this);
    };

    /**
     * Update dimensions from real values
     */


    BaseTexture.prototype._updateDimensions = function _updateDimensions() {
        this.width = this.realWidth / this.resolution;
        this.height = this.realHeight / this.resolution;

        this.isPowerOfTwo = _bitTwiddle2.default.isPow2(this.realWidth) && _bitTwiddle2.default.isPow2(this.realHeight);
    };

    /**
     * Load a source.
     *
     * If the source is not-immediately-available, such as an image that needs to be
     * downloaded, then the 'loaded' or 'error' event will be dispatched in the future
     * and `hasLoaded` will remain false after this call.
     *
     * The logic state after calling `loadSource` directly or indirectly (eg. `fromImage`, `new BaseTexture`) is:
     *
     *     if (texture.hasLoaded) {
     *        // texture ready for use
     *     } else if (texture.isLoading) {
     *        // listen to 'loaded' and/or 'error' events on texture
     *     } else {
     *        // not loading, not going to load UNLESS the source is reloaded
     *        // (it may still make sense to listen to the events)
     *     }
     *
     * @protected
     * @param {HTMLImageElement|HTMLCanvasElement} source - the source object of the texture.
     */


    BaseTexture.prototype.loadSource = function loadSource(source) {
        var wasLoading = this.isLoading;

        this.hasLoaded = false;
        this.isLoading = false;

        if (wasLoading && this.source) {
            this.source.onload = null;
            this.source.onerror = null;
        }

        var firstSourceLoaded = !this.source;

        this.source = source;

        // Apply source if loaded. Otherwise setup appropriate loading monitors.
        if ((source.src && source.complete || source.getContext) && source.width && source.height) {
            this._updateImageType();

            if (this.imageType === 'svg') {
                this._loadSvgSource();
            } else {
                this._sourceLoaded();
            }

            if (firstSourceLoaded) {
                // send loaded event if previous source was null and we have been passed a pre-loaded IMG element
                this.emit('loaded', this);
            }
        } else if (!source.getContext) {
            // Image fail / not ready
            this.isLoading = true;

            var scope = this;

            source.onload = function () {
                scope._updateImageType();
                source.onload = null;
                source.onerror = null;

                if (!scope.isLoading) {
                    return;
                }

                scope.isLoading = false;
                scope._sourceLoaded();

                if (scope.imageType === 'svg') {
                    scope._loadSvgSource();

                    return;
                }

                scope.emit('loaded', scope);
            };

            source.onerror = function () {
                source.onload = null;
                source.onerror = null;

                if (!scope.isLoading) {
                    return;
                }

                scope.isLoading = false;
                scope.emit('error', scope);
            };

            // Per http://www.w3.org/TR/html5/embedded-content-0.html#the-img-element
            //   "The value of `complete` can thus change while a script is executing."
            // So complete needs to be re-checked after the callbacks have been added..
            // NOTE: complete will be true if the image has no src so best to check if the src is set.
            if (source.complete && source.src) {
                // ..and if we're complete now, no need for callbacks
                source.onload = null;
                source.onerror = null;

                if (scope.imageType === 'svg') {
                    scope._loadSvgSource();

                    return;
                }

                this.isLoading = false;

                if (source.width && source.height) {
                    this._sourceLoaded();

                    // If any previous subscribers possible
                    if (wasLoading) {
                        this.emit('loaded', this);
                    }
                }
                // If any previous subscribers possible
                else if (wasLoading) {
                        this.emit('error', this);
                    }
            }
        }
    };

    /**
     * Updates type of the source image.
     */


    BaseTexture.prototype._updateImageType = function _updateImageType() {
        if (!this.imageUrl) {
            return;
        }

        var dataUri = (0, _utils.decomposeDataUri)(this.imageUrl);
        var imageType = void 0;

        if (dataUri && dataUri.mediaType === 'image') {
            // Check for subType validity
            var firstSubType = dataUri.subType.split('+')[0];

            imageType = (0, _utils.getUrlFileExtension)('.' + firstSubType);

            if (!imageType) {
                throw new Error('Invalid image type in data URI.');
            }
        } else {
            imageType = (0, _utils.getUrlFileExtension)(this.imageUrl);

            if (!imageType) {
                imageType = 'png';
            }
        }

        this.imageType = imageType;
    };

    /**
     * Checks if `source` is an SVG image and whether it's loaded via a URL or a data URI. Then calls
     * `_loadSvgSourceUsingDataUri` or `_loadSvgSourceUsingXhr`.
     */


    BaseTexture.prototype._loadSvgSource = function _loadSvgSource() {
        if (this.imageType !== 'svg') {
            // Do nothing if source is not svg
            return;
        }

        var dataUri = (0, _utils.decomposeDataUri)(this.imageUrl);

        if (dataUri) {
            this._loadSvgSourceUsingDataUri(dataUri);
        } else {
            // We got an URL, so we need to do an XHR to check the svg size
            this._loadSvgSourceUsingXhr();
        }
    };

    /**
     * Reads an SVG string from data URI and then calls `_loadSvgSourceUsingString`.
     *
     * @param {string} dataUri - The data uri to load from.
     */


    BaseTexture.prototype._loadSvgSourceUsingDataUri = function _loadSvgSourceUsingDataUri(dataUri) {
        var svgString = void 0;

        if (dataUri.encoding === 'base64') {
            if (!atob) {
                throw new Error('Your browser doesn\'t support base64 conversions.');
            }
            svgString = atob(dataUri.data);
        } else {
            svgString = dataUri.data;
        }

        this._loadSvgSourceUsingString(svgString);
    };

    /**
     * Loads an SVG string from `imageUrl` using XHR and then calls `_loadSvgSourceUsingString`.
     */


    BaseTexture.prototype._loadSvgSourceUsingXhr = function _loadSvgSourceUsingXhr() {
        var _this2 = this;

        var svgXhr = new XMLHttpRequest();

        // This throws error on IE, so SVG Document can't be used
        // svgXhr.responseType = 'document';

        // This is not needed since we load the svg as string (breaks IE too)
        // but overrideMimeType() can be used to force the response to be parsed as XML
        // svgXhr.overrideMimeType('image/svg+xml');

        svgXhr.onload = function () {
            if (svgXhr.readyState !== svgXhr.DONE || svgXhr.status !== 200) {
                throw new Error('Failed to load SVG using XHR.');
            }

            _this2._loadSvgSourceUsingString(svgXhr.response);
        };

        svgXhr.onerror = function () {
            return _this2.emit('error', _this2);
        };

        svgXhr.open('GET', this.imageUrl, true);
        svgXhr.send();
    };

    /**
     * Loads texture using an SVG string. The original SVG Image is stored as `origSource` and the
     * created canvas is the new `source`. The SVG is scaled using `sourceScale`. Called by
     * `_loadSvgSourceUsingXhr` or `_loadSvgSourceUsingDataUri`.
     *
     * @param  {string} svgString SVG source as string
     *
     * @fires PIXI.BaseTexture#loaded
     */


    BaseTexture.prototype._loadSvgSourceUsingString = function _loadSvgSourceUsingString(svgString) {
        var svgSize = (0, _utils.getSvgSize)(svgString);

        var svgWidth = svgSize.width;
        var svgHeight = svgSize.height;

        if (!svgWidth || !svgHeight) {
            throw new Error('The SVG image must have width and height defined (in pixels), canvas API needs them.');
        }

        // Scale realWidth and realHeight
        this.realWidth = Math.round(svgWidth * this.sourceScale);
        this.realHeight = Math.round(svgHeight * this.sourceScale);

        this._updateDimensions();

        // Create a canvas element
        var canvas = document.createElement('canvas');

        canvas.width = this.realWidth;
        canvas.height = this.realHeight;
        canvas._pixiId = 'canvas_' + (0, _utils.uid)();

        // Draw the Svg to the canvas
        canvas.getContext('2d').drawImage(this.source, 0, 0, svgWidth, svgHeight, 0, 0, this.realWidth, this.realHeight);

        // Replace the original source image with the canvas
        this.origSource = this.source;
        this.source = canvas;

        // Add also the canvas in cache (destroy clears by `imageUrl` and `source._pixiId`)
        BaseTexture.addToCache(this, canvas._pixiId);

        this.isLoading = false;
        this._sourceLoaded();
        this.emit('loaded', this);
    };

    /**
     * Used internally to update the width, height, and some other tracking vars once
     * a source has successfully loaded.
     *
     * @private
     */


    BaseTexture.prototype._sourceLoaded = function _sourceLoaded() {
        this.hasLoaded = true;
        this.update();
    };

    /**
     * Destroys this base texture
     *
     */


    BaseTexture.prototype.destroy = function destroy() {
        if (this.imageUrl) {
            delete _utils.TextureCache[this.imageUrl];

            this.imageUrl = null;

            if (!navigator.isCocoonJS) {
                this.source.src = '';
            }
        }

        this.source = null;

        this.dispose();

        BaseTexture.removeFromCache(this);
        this.textureCacheIds = null;

        this._destroyed = true;
    };

    /**
     * Frees the texture from WebGL memory without destroying this texture object.
     * This means you can still use the texture later which will upload it to GPU
     * memory again.
     *
     * @fires PIXI.BaseTexture#dispose
     */


    BaseTexture.prototype.dispose = function dispose() {
        this.emit('dispose', this);
    };

    /**
     * Changes the source image of the texture.
     * The original source must be an Image element.
     *
     * @param {string} newSrc - the path of the image
     */


    BaseTexture.prototype.updateSourceImage = function updateSourceImage(newSrc) {
        this.source.src = newSrc;

        this.loadSource(this.source);
    };

    /**
     * Helper function that creates a base texture from the given image url.
     * If the image is not in the base texture cache it will be created and loaded.
     *
     * @static
     * @param {string} imageUrl - The image url of the texture
     * @param {boolean} [crossorigin=(auto)] - Should use anonymous CORS? Defaults to true if the URL is not a data-URI.
     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
     * @param {number} [sourceScale=(auto)] - Scale for the original image, used with Svg images.
     * @return {PIXI.BaseTexture} The new base texture.
     */


    BaseTexture.fromImage = function fromImage(imageUrl, crossorigin, scaleMode, sourceScale) {
        var baseTexture = _utils.BaseTextureCache[imageUrl];

        if (!baseTexture) {
            // new Image() breaks tex loading in some versions of Chrome.
            // See https://code.google.com/p/chromium/issues/detail?id=238071
            var image = new Image(); // document.createElement('img');

            if (crossorigin === undefined && imageUrl.indexOf('data:') !== 0) {
                image.crossOrigin = (0, _determineCrossOrigin2.default)(imageUrl);
            } else if (crossorigin) {
                image.crossOrigin = typeof crossorigin === 'string' ? crossorigin : 'anonymous';
            }

            baseTexture = new BaseTexture(image, scaleMode);
            baseTexture.imageUrl = imageUrl;

            if (sourceScale) {
                baseTexture.sourceScale = sourceScale;
            }

            // if there is an @2x at the end of the url we are going to assume its a highres image
            baseTexture.resolution = (0, _utils.getResolutionOfUrl)(imageUrl);

            image.src = imageUrl; // Setting this triggers load

            BaseTexture.addToCache(baseTexture, imageUrl);
        }

        return baseTexture;
    };

    /**
     * Helper function that creates a base texture from the given canvas element.
     *
     * @static
     * @param {HTMLCanvasElement} canvas - The canvas element source of the texture
     * @param {number} scaleMode - See {@link PIXI.SCALE_MODES} for possible values
     * @param {string} [origin='canvas'] - A string origin of who created the base texture
     * @return {PIXI.BaseTexture} The new base texture.
     */


    BaseTexture.fromCanvas = function fromCanvas(canvas, scaleMode) {
        var origin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'canvas';

        if (!canvas._pixiId) {
            canvas._pixiId = origin + '_' + (0, _utils.uid)();
        }

        var baseTexture = _utils.BaseTextureCache[canvas._pixiId];

        if (!baseTexture) {
            baseTexture = new BaseTexture(canvas, scaleMode);
            BaseTexture.addToCache(baseTexture, canvas._pixiId);
        }

        return baseTexture;
    };

    /**
     * Helper function that creates a base texture based on the source you provide.
     * The source can be - image url, image element, canvas element. If the
     * source is an image url or an image element and not in the base texture
     * cache, it will be created and loaded.
     *
     * @static
     * @param {string|HTMLImageElement|HTMLCanvasElement} source - The source to create base texture from.
     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
     * @param {number} [sourceScale=(auto)] - Scale for the original image, used with Svg images.
     * @return {PIXI.BaseTexture} The new base texture.
     */


    BaseTexture.from = function from(source, scaleMode, sourceScale) {
        if (typeof source === 'string') {
            return BaseTexture.fromImage(source, undefined, scaleMode, sourceScale);
        } else if (source instanceof HTMLImageElement) {
            var imageUrl = source.src;
            var baseTexture = _utils.BaseTextureCache[imageUrl];

            if (!baseTexture) {
                baseTexture = new BaseTexture(source, scaleMode);
                baseTexture.imageUrl = imageUrl;

                if (sourceScale) {
                    baseTexture.sourceScale = sourceScale;
                }

                // if there is an @2x at the end of the url we are going to assume its a highres image
                baseTexture.resolution = (0, _utils.getResolutionOfUrl)(imageUrl);

                BaseTexture.addToCache(baseTexture, imageUrl);
            }

            return baseTexture;
        } else if (source instanceof HTMLCanvasElement) {
            return BaseTexture.fromCanvas(source, scaleMode);
        }

        // lets assume its a base texture!
        return source;
    };

    /**
     * Adds a BaseTexture to the global BaseTextureCache. This cache is shared across the whole PIXI object.
     *
     * @static
     * @param {PIXI.BaseTexture} baseTexture - The BaseTexture to add to the cache.
     * @param {string} id - The id that the BaseTexture will be stored against.
     */


    BaseTexture.addToCache = function addToCache(baseTexture, id) {
        if (id) {
            if (baseTexture.textureCacheIds.indexOf(id) === -1) {
                baseTexture.textureCacheIds.push(id);
            }

            // @if DEBUG
            /* eslint-disable no-console */
            if (_utils.BaseTextureCache[id]) {
                console.warn('BaseTexture added to the cache with an id [' + id + '] that already had an entry');
            }
            /* eslint-enable no-console */
            // @endif

            _utils.BaseTextureCache[id] = baseTexture;
        }
    };

    /**
     * Remove a BaseTexture from the global BaseTextureCache.
     *
     * @static
     * @param {string|PIXI.BaseTexture} baseTexture - id of a BaseTexture to be removed, or a BaseTexture instance itself.
     * @return {PIXI.BaseTexture|null} The BaseTexture that was removed.
     */


    BaseTexture.removeFromCache = function removeFromCache(baseTexture) {
        if (typeof baseTexture === 'string') {
            var baseTextureFromCache = _utils.BaseTextureCache[baseTexture];

            if (baseTextureFromCache) {
                var index = baseTextureFromCache.textureCacheIds.indexOf(baseTexture);

                if (index > -1) {
                    baseTextureFromCache.textureCacheIds.splice(index, 1);
                }

                delete _utils.BaseTextureCache[baseTexture];

                return baseTextureFromCache;
            }
        } else if (baseTexture && baseTexture.textureCacheIds) {
            for (var i = 0; i < baseTexture.textureCacheIds.length; ++i) {
                delete _utils.BaseTextureCache[baseTexture.textureCacheIds[i]];
            }

            baseTexture.textureCacheIds.length = 0;

            return baseTexture;
        }

        return null;
    };

    return BaseTexture;
}(_eventemitter2.default);

exports.default = BaseTexture;
//# sourceMappingURL=BaseTexture.js.map

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Device_1 = __webpack_require__(42);
var Preloader_1 = __webpack_require__(472);
var System_1 = __webpack_require__(52);
var View_1 = __webpack_require__(3);
var inversify_1 = __webpack_require__(14);
// export interface NineSliceBorders {
// }
var Platform;
(function (Platform) {
    Platform[Platform["DESKTOP"] = 0] = "DESKTOP";
    Platform[Platform["MOBILE"] = 1] = "MOBILE";
})(Platform = exports.Platform || (exports.Platform = {}));
var ResourcesLoader = /** @class */ (function () {
    function ResourcesLoader(device, getUrlPath, locale, majorCaveatPerformance) {
        if (getUrlPath === void 0) { getUrlPath = null; }
        if (locale === void 0) { locale = 'EN'; }
        this._majorPerformanceCaveat = false;
        this._supportedLocales = ['en'];
        this.shouldRemoveUnsupportedLocales = false;
        this._mobileSoundResourcesFiles = [];
        this._mobileSoundDataFile = '';
        this._soundResources = [];
        this._particleResources = [];
        this._translationResources = [];
        this._resources = [];
        this._localeTexts = [];
        this._currencyResources = [];
        this._helpFiles = [];
        this._helpStyles = [];
        this._spineResources = [];
        this._configFiles = [];
        this._helpFilesMap = {};
        this._configFilesMap = {};
        this._styleSheets = {};
        this._textures = {};
        this._spines = {};
        this._spritesheets = {};
        this._sounds = {};
        this._soundConfig = {};
        this._nineslicedata = {};
        this._particleData = {};
        this._resourcesLoaded = -1;
        this._soundsLoaded = -1;
        this._soundConfigsLoaded = -1;
        this._particlesLoaded = -1;
        this._translationsLoaded = -1;
        this._localeTextsLoaded = -1;
        this._atlasLoaded = -1;
        this._helpFilesLoaded = -1;
        this._helpStylesLoaded = -1;
        this._currenciesLoaded = [];
        this._currenciesLoading = [];
        this._configFilesLoaded = -1;
        this._currentLoadingQueueIndex = -1;
        this._expectedToLoadInThisQueue = 0;
        this._useSingleSpineAtlas = false;
        // auto-populate? How to solve this depending on amount of assets?
        this._atlasImages = [];
        this._atlasMobileImages = [];
        this._spineAtlasImages = [];
        this._maxDownloadStreams = 8;
        this._loadingLandscapeAndPortraitResources = false;
        this._device = device;
        this._getUrlPath = getUrlPath;
        this._majorPerformanceCaveat = majorCaveatPerformance === 0 ? true : false;
        this._locale = locale;
        if (true) {
            this._useSingleSpineAtlas = true;
        }
        this.initialize();
        this.addPlatformSpecificArt();
        this.addPreloader();
    }
    ResourcesLoader_1 = ResourcesLoader;
    ResourcesLoader.isRecode = function () {
        return window.V;
    };
    ResourcesLoader.prototype.endLoading = function () {
        this._preloader.endLoading();
    };
    ResourcesLoader.prototype.load = function (loadingCallback, platform) {
        this._platform = platform;
        this._loadingCompletedCallback = loadingCallback;
        if (this._device.isMobile && this._loadingLandscapeAndPortraitResources) {
            this._expectedToLoad = this._resources.length * 2;
        }
        else {
            this._expectedToLoad = this._resources.length;
        }
        this._expectedToLoad = this._resources.length;
        this._loader = this.createLoader();
        this.loadNextResource(null, null);
    };
    ResourcesLoader.prototype.calculateExpectedTotal = function () {
        this._particlesExpectedToLoad = this._particleResources.length;
        this._soundsExpectedToLoad = this._device.isMobile ? this._mobileSoundResourcesFiles.length : this._soundResources.length;
        this._soundConfigsExpectedToLoad = this._device.isMobile ? 1 : 0;
        // one file for GR and one for Paytable. In case the locale is something other than english we load two more.
        this._helpFilesExpectedToLoad = this._locale === 'en' ? 2 : 4;
        this._configFilesExpectedToLoad = this._configFiles.length;
        this._helpStylesExpectedToLoad = 1;
        this._translationsExpectedToLoad = this._locale === 'en' ? 1 : 2;
        this._localeTextsExpectedToLoad = this._locale === 'en' || this._localeTexts.indexOf(this._localeTextData) < 0 ? 1 : 2;
        this._atlasExpectedToLoad = 1 + this._atlasImages.length;
        this._expectedToLoad = this._resources.length;
    };
    ResourcesLoader.prototype.loadSounds = function (loadingCallback) {
        this._soundsLoadingCompletedCallback = loadingCallback;
        this._soundsExpectedToLoad = this._device.isMobile ? this._mobileSoundResourcesFiles.length : this._soundResources.length;
        this._loader = this.createLoader();
        this.loadNextSound(null);
    };
    ResourcesLoader.prototype.loadSoundsConfig = function (loadingCallback) {
        this._soundConfigLoadingCompletedCallback = loadingCallback;
        this._soundConfigsExpectedToLoad = this._device.isMobile ? 1 : 0;
        this._loader = this.createLoader();
        this.loadSoundConfig(null);
    };
    ResourcesLoader.prototype.loadSoundConfig = function (resource) {
        if (resource && resource.data && resource.extension && resource.extension === 'json') {
            this._soundConfig = resource.data;
        }
        this._soundConfigsLoaded++;
        if (this._soundConfigsLoaded >= this._soundConfigsExpectedToLoad) {
            this._soundConfigLoadingCompletedCallback();
            return;
        }
        this._loader.reset();
        this._loader.add(this.getPathForResource(this._mobileSoundDataFile), {}, this.loadSoundConfig.bind(this));
        this._loader.load();
        this.updateProgress();
    };
    ResourcesLoader.prototype.loadParticles = function (loadingCallback) {
        this._particleLoadingCompletedCallback = loadingCallback;
        this._particlesExpectedToLoad = this._particleResources.length;
        this._loader = this.createLoader();
        this.loadNextParticle(null);
    };
    ResourcesLoader.prototype.loadConfigFiles = function (loadingCallback) {
        this._configFilesLoadingCompletedCallback = loadingCallback;
        this._loader = this.createLoader();
        this.loadNextConfigFile(null);
    };
    ResourcesLoader.prototype.loadNextConfigFile = function (resource) {
        if (this._configFilesLoaded >= 0) {
            if (resource.error === null && resource.url && resource.data !== null) {
                var name_1 = resource.url;
                this._configFilesMap[name_1.substring(name_1.lastIndexOf('/') + 1, name_1.length)] = resource.data;
            }
        }
        this._configFilesLoaded++;
        if (this._configFilesLoaded >= this._configFilesExpectedToLoad) {
            this._configFilesLoadingCompletedCallback();
            return;
        }
        this._loader.reset();
        this._loader.add(this.getPathForResource(this._configFiles[this._configFilesLoaded]), {}, this.loadNextConfigFile.bind(this));
        this._loader.load();
        this.updateProgress();
    };
    ResourcesLoader.prototype.loadHelpFiles = function (loadingCallback, locale) {
        this._helpFilesLoadingCompletedCallback = loadingCallback;
        // tODO: Add to function.
        this._helpFilesExpectedToLoad = 2; // needs to load english at least?
        // add correct locale files.
        // tODO: Check from list of available translations.
        if (this._locale !== 'en') {
            this._helpFilesExpectedToLoad += 2;
            this._helpFiles = this._helpFiles.concat([
                "HTML/PAYTABLE/Paytable_" + this._locale + ".htm",
                "HTML/GAMERULES/Gamerules_" + this._locale + ".htm",
            ]);
        }
        this._loader = this.createLoader();
        this.loadNextHelpFile(null);
    };
    ResourcesLoader.prototype.loadNextHelpFile = function (resource) {
        if (this._helpFilesLoaded >= 0) {
            if (resource.error === null && resource.url && resource.data !== null && resource.xhr && resource.xhr.responseText) {
                var bodyRegex = /(<body)(.|\r|\n)*(<\/body>)/gm;
                var responseText = resource.xhr.responseText;
                var bodyHTMLText = responseText.match(bodyRegex)[0];
                var helpfileItem = resource.url
                    .toLowerCase()
                    .split("resources/" + (this._device.isMobile ? 'mobile' : 'desktop') + "/")[1];
                this._helpFilesMap[helpfileItem] = bodyHTMLText;
            }
        }
        this._helpFilesLoaded++;
        if (this._helpFilesLoaded >= this._helpFilesExpectedToLoad) {
            this._helpFilesLoadingCompletedCallback();
            return;
        }
        this._loader.reset();
        this._loader.add(this.getDevicePathForResource(this._helpFiles[this._helpFilesLoaded]), {}, this.loadNextHelpFile.bind(this));
        // this._helpFiles[this._helpFilesLoaded], {}, this.loadNextHelpFile.bind(this);
        this._loader.load();
        this.updateProgress();
    };
    ResourcesLoader.prototype.loadHelpStyles = function (loadingCallback) {
        this._helpStylesLoadingCompletedCallback = loadingCallback;
        this._helpStylesExpectedToLoad = 1;
        this._loader = this.createLoader();
        this.loadNextHelpStyle(null);
    };
    ResourcesLoader.prototype.loadNextHelpStyle = function (resource) {
        if (this._helpStylesLoaded >= 0) {
            // checking for errors.
            if (resource.url && resource.error === null) {
                // tODO: Temp, replace with real getttttter for device and path.
                this._styleSheets[resource.url.split("resources/" + (this._device.isMobile ? 'Mobile' : 'Desktop') + "/")[1]] = resource.data;
            }
        }
        this._helpStylesLoaded++;
        if (this._helpStylesLoaded >= this._helpStylesExpectedToLoad) {
            this._helpStylesLoadingCompletedCallback();
            return;
        }
        this._loader.reset();
        this._loader.add(this.getDevicePathForResource(this._helpStyles[this._helpStylesLoaded]), {}, this.loadNextHelpStyle.bind(this));
        this._loader.load();
        this.updateProgress();
    };
    ResourcesLoader.prototype.addCurrencyToResourcesList = function (loadingCallback, currencyISO) {
        if (currencyISO === void 0) { currencyISO = 'EUR'; }
        var currencyResourceIndex = this._currencyResources.indexOf("CURRENCIES/" + currencyISO.toUpperCase() + ".json");
        if (currencyResourceIndex !== -1) {
            this._resources.push(this._currencyResources[currencyResourceIndex]);
        }
        loadingCallback();
    };
    ResourcesLoader.prototype.loadTranslations = function (loadingCallback, locale) {
        this._translationLoadingCompletedCallback = loadingCallback;
        this._translationsExpectedToLoad = 1;
        this._loader = this.createLoader();
        if (this.shouldRemoveUnsupportedLocales) {
            this._locale = this.isSupportedLocale(locale) ? locale : 'en';
        }
        else {
            this._locale = locale;
        }
        var languageFile = "resources/languages/" + this._locale + ".json";
        this._languageIndex = this._translationResources.indexOf(languageFile);
        if (this._languageIndex < 0) {
            this._locale = 'en';
            this._translationsExpectedToLoad = 1;
        }
        else {
            this._translationsExpectedToLoad += 1;
        }
        // makes it default to English which should be the first index of the resource-list.
        this._languageIndex = Math.max(0, this._languageIndex);
        this.loadTranslation(null);
    };
    ResourcesLoader.prototype.loadTranslation = function (resource) {
        if (resource && resource.data && resource.data.hasOwnProperty('BaseStrings') && this._translationsLoaded === 0) {
            this._englishLanguageData = resource.data;
        }
        else if (resource && resource.data && resource.data.hasOwnProperty('BaseStrings')) {
            this._languageData = resource.data;
        }
        this._translationsLoaded++;
        if (this._translationsLoaded >= this._translationsExpectedToLoad) {
            this._translationLoadingCompletedCallback();
            return;
        }
        this._loader.reset();
        if (this._translationsLoaded > 0) {
            this._loader.add(this.getPathForResource(this._translationResources[this._languageIndex]), {}, this.loadTranslation.bind(this));
        }
        else {
            this._loader.add(this.getPathForResource(this._translationResources[0]), {}, this.loadTranslation.bind(this));
        }
        this._loader.load();
        this.updateProgress();
    };
    ResourcesLoader.prototype.loadSingleSpineAtlas = function (loadingCallback) {
        this._atlasCompletedCallback = loadingCallback;
        this._atlasExpectedToLoad = 1 + this._atlasImages.length;
        if (!this._useSingleSpineAtlas) {
            this._atlasLoaded = this._atlasExpectedToLoad;
            this.updateProgress();
            this._atlasCompletedCallback();
            return;
        }
        this._loader = this.createLoader();
        this.loadSpineAtlasResource(null);
    };
    ResourcesLoader.prototype.loadSpineAtlasResource = function (resource) {
        if (resource && resource.data && resource.extension === 'atlas') {
            this._spineAtlasData = resource.data;
        }
        else if (resource && resource.data) {
            this._spineAtlasImages.push(resource);
        }
        this._atlasLoaded++;
        this._currentLoadingQueueIndex++;
        if (this._atlasLoaded >= this._atlasExpectedToLoad) {
            this._atlasCompletedCallback();
            return;
        }
        this.updateProgress();
        if (this._currentLoadingQueueIndex < this._expectedToLoadInThisQueue) {
            return;
        }
        this._loader.reset();
        var inProgressResources = 0;
        for (var i = 0; i < this._maxDownloadStreams; i++) {
            var atlasResource = this._atlasLoaded === 0 && i === 0 ? this._spineAtlasFile : this._atlasImages[this._atlasLoaded - 1 + i];
            if (atlasResource) {
                atlasResource = this.getDevicePathForResource(atlasResource);
                this._loader.add(atlasResource, {}, this.loadSpineAtlasResource.bind(this));
                inProgressResources++;
            }
        }
        this._currentLoadingQueueIndex = 0;
        this._expectedToLoadInThisQueue = inProgressResources;
        this._loader.load();
    };
    ResourcesLoader.prototype.loadLocaleTexts = function (loadingCallBack, locale) {
        var localeTextData = "LOCALE_TEXTS/" + locale + ".json";
        this._localeTextIndex = this._localeTexts.indexOf(localeTextData);
        if (this._localeTextIndex < 0) {
            localeTextData = "LOCALE_TEXTS/en.json";
            this._localeTextIndex = this._localeTexts.indexOf(localeTextData);
        }
        this._localeTextsExpectedToLoad = 1;
        this._localeTextLoadingCompletedCallback = loadingCallBack;
        this._loader = this.createLoader();
        this.loadLocaleText(null);
    };
    ResourcesLoader.prototype.loadLocaleText = function (resource) {
        if (resource && resource.data && resource.data.hasOwnProperty('frames')) {
            this._localeTextData = resource;
            if (resource.hasOwnProperty('name') &&
                resource.name.indexOf('LOCALE_TEXTS/en.json') > -1 &&
                resource.hasOwnProperty('spritesheet')) {
                this._englishLocaleTextData = resource;
                this._resources.splice(this._resources.indexOf('LOCALE_TEXTS/en.json'), 1);
                this._expectedToLoad--;
            }
        }
        this._localeTextsLoaded++;
        if (this._localeTextsLoaded >= this._localeTextsExpectedToLoad) {
            this._localeTextLoadingCompletedCallback();
            return;
        }
        this._loader.reset();
        this._loader.add(this.getDevicePathForResource(this._localeTexts[this._localeTextIndex + this._localeTextsLoaded]), {}, this.loadLocaleText.bind(this));
        this._loader.load();
        this.updateProgress();
    };
    ResourcesLoader.prototype.loadNextParticle = function (resource) {
        if (this._particlesLoaded >= 0) {
            if (resource.data.hasOwnProperty('maxParticles')) {
                this._particleData[this._particleResources[this._particlesLoaded]] = resource.data;
            }
            else if (resource.hasOwnProperty('spritesheet')) {
                this._spritesheets[resource.name] = resource.spritesheet;
            }
            else {
                this._textures[resource] = resource.texture;
            }
        }
        this._particlesLoaded++;
        if (this._particlesLoaded >= this._particlesExpectedToLoad) {
            this._particleLoadingCompletedCallback();
            return;
        }
        this._loader.reset();
        this._loader.add(this.getPathForResource(this._particleResources[this._particlesLoaded]), {}, this.loadNextParticle.bind(this));
        this._loader.load();
        this.updateProgress();
    };
    ResourcesLoader.prototype.getDevicePathForResource = function (resName) {
        var platformPath = this._device.isMobile ? 'resources/Mobile/' : 'resources/Desktop/';
        return this._getUrlPath(platformPath + resName);
    };
    ResourcesLoader.prototype.getPathForResource = function (resName) {
        return this._getUrlPath(resName);
    };
    ResourcesLoader.prototype.getTexture = function (id, viewType) {
        if (viewType === void 0) { viewType = View_1.ViewTypes.DESKTOP; }
        if (viewType === View_1.ViewTypes.PORTRAIT) {
            id = 'portrait_' + id;
        }
        if (viewType === View_1.ViewTypes.LANDSCAPE) {
            id = 'landscape_' + id;
        }
        // tODO: remove temporary
        if (!this.existsBoolean(this._textures, id)) {
            id = 'landscape_' + id;
        }
        this.exists(this._textures, id);
        return this._textures[id];
    };
    ResourcesLoader.prototype.getHelpFilesData = function (id) {
        this.exists(this._helpFilesMap, id);
        return this._helpFilesMap[id];
    };
    ResourcesLoader.prototype.getSpine = function (id, viewType) {
        if (viewType === void 0) { viewType = View_1.ViewTypes.DESKTOP; }
        if (viewType === View_1.ViewTypes.PORTRAIT) {
            id = 'portrait_' + id;
        }
        if (viewType === View_1.ViewTypes.LANDSCAPE) {
            id = 'landscape_' + id;
        }
        this.exists(this._spines, id);
        return this._spines[id];
    };
    ResourcesLoader.prototype.hasSpine = function (id) {
        return this.existsBoolean(this._spines, id);
    };
    ResourcesLoader.prototype.getNineSliceObject = function (sheetName, id) {
        return { texture: this.getSpritesheetTexture(sheetName, id), nine: this.getNineSliceData(sheetName, id) };
    };
    ResourcesLoader.prototype.getSpritesheetTexture = function (sheetName, id, viewType) {
        if (viewType === void 0) { viewType = View_1.ViewTypes.DESKTOP; }
        if (viewType === View_1.ViewTypes.PORTRAIT) {
            sheetName = 'portrait_' + sheetName;
        }
        if (viewType === View_1.ViewTypes.LANDSCAPE) {
            sheetName = 'landscape_' + sheetName;
        }
        // tODO: remove temporary
        if (!this.existsBoolean(this._spritesheets, sheetName)) {
            sheetName = 'landscape_' + sheetName;
        }
        this.exists(this._spritesheets, sheetName);
        this.exists(this._spritesheets[sheetName].textures, id);
        return this._spritesheets[sheetName].textures[id];
    };
    ResourcesLoader.prototype.getCurrencySpritesheetTexture = function (currencyISO, id) {
        var sheetName = "CURRENCIES/" + currencyISO + ".json";
        if (this.existsBoolean(this._spritesheets, sheetName)) {
            this.existsBoolean(this._spritesheets[sheetName].textures, id);
            return this._spritesheets[sheetName].textures[id];
        }
        else {
            try {
                this.loadCurrencyISOResource(currencyISO);
            }
            catch (error) {
                // console.error(error);
            }
            return PIXI.Texture.EMPTY;
        }
    };
    ResourcesLoader.prototype.getSpriteSheet = function (sheetName) {
        return this._spritesheets[sheetName];
    };
    ResourcesLoader.prototype.getTranslation = function () {
        return this._languageData;
    };
    ResourcesLoader.prototype.getEnglishStrings = function () {
        return this._englishLanguageData;
    };
    ResourcesLoader.prototype.getLocale = function () {
        return this._locale;
    };
    ResourcesLoader.prototype.getMobileSoundConfig = function () {
        return this._soundConfig;
    };
    ResourcesLoader.prototype.getConfig = function (configFileName) {
        return this._configFilesMap[configFileName];
    };
    ResourcesLoader.prototype.getPaytableHTML = function () {
        return this._helpFilesMap.hasOwnProperty("html/paytable/paytable_" + this.getLocale() + ".htm")
            ? this._helpFilesMap["html/paytable/paytable_" + this.getLocale() + ".htm"]
            : this._helpFilesMap['html/paytable/paytable_en.htm'];
    };
    ResourcesLoader.prototype.getGameRulesHTML = function () {
        return this._helpFilesMap.hasOwnProperty("html/gamerules/gamerules_" + this.getLocale() + ".htm")
            ? this._helpFilesMap["html/gamerules/gamerules_" + this.getLocale() + ".htm"]
            : this._helpFilesMap["html/gamerules/gamerules_en.htm"];
    };
    ResourcesLoader.prototype.getLocaleTextImage = function (id) {
        if (!this._localeTextData || !this._localeTextData.textures || !this._localeTextData.textures[id]) {
            // use for debug.
            if (false) {
                throw new Error("Cannot find texture:' " + id + " in Locale Atlas.");
            }
            // keep on Prod
            return this.getEnglishLocaleTextImage(id);
        }
        return this._localeTextData.textures[id];
    };
    ResourcesLoader.prototype.getEnglishLocaleTextImage = function (id) {
        if (!this._englishLocaleTextData.textures[id]) {
            return PIXI.Texture.EMPTY;
        }
        return this._englishLocaleTextData.textures[id];
    };
    ResourcesLoader.prototype.getParticleData = function (id) {
        this._particleData[id].speed.start /= 1000;
        this._particleData[id].speed.end /= 1000;
        this._particleData[id].acceleration.x /= 1000000;
        this._particleData[id].acceleration.y /= 1000000;
        this._particleData[id].maxSpeed /= 1000;
        this._particleData[id].rotationSpeed.min /= 1000;
        this._particleData[id].rotationSpeed.max /= 1000;
        this._particleData[id].lifetime.min *= 1000;
        this._particleData[id].lifetime.max *= 1000;
        this._particleData[id].frequency *= 1000;
        this._particleData[id].emitterLifetime *= 1000;
        return this._particleData[id];
    };
    ResourcesLoader.prototype.getSound = function (id) {
        this.exists(this._sounds, id);
        return this._sounds[id];
    };
    ResourcesLoader.prototype.getNineSliceData = function (atlasId, imageId) {
        if (this.exists(this._nineslicedata, atlasId)) {
            if (this.exists(this._nineslicedata[atlasId], imageId)) {
                return this._nineslicedata[atlasId][imageId].ninesliceborders;
            }
        }
        if (false) {
            throw new Error("Could not find resource: " + atlasId + " / " + imageId);
        }
    };
    ResourcesLoader.prototype.usingUnsupportedDeviceOrBrowser = function () {
        this._preloader.usingUnsupportedDeviceOrBrowser();
    };
    ResourcesLoader.prototype.initialize = function () {
        throw new Error('ReourcesLoader::initialize() must be overridden and some resources should be added');
    };
    ResourcesLoader.prototype.addPlatformSpecificArt = function () {
        if (ResourcesLoader_1.isRecode()) {
            this.addMicrogamingArt();
        }
    };
    ResourcesLoader.prototype.addPreloader = function () {
        this._preloader = new Preloader_1.Preloader(this._getUrlPath, this._device);
        this._preloader.createLoadingScreen();
    };
    ResourcesLoader.prototype.addMicrogamingArt = function () {
        // this._resources.push('FREE_GAMES_GENERIC_BUTTONS.json');
        this._resources.push('FREE-GAMES_SCREENS.json');
        this._resources.push('MICROGAMING.json');
    };
    ResourcesLoader.prototype.createLoader = function () {
        var loader = new PIXI.loaders.Loader();
        loader.onError.add(this.loadingError.bind(this));
        return loader;
    };
    ResourcesLoader.prototype.loadingError = function (error, loader, resource) {
        if (false) {
            console.warn(error);
            console.warn(resource);
        }
    };
    ResourcesLoader.prototype.loadNextSound = function (resource) {
        if (this._soundsLoaded >= 0) {
            if (resource.hasOwnProperty('sound')) {
                // get the correct asset name.
                var soundName = resource.name.slice(resource.name.lastIndexOf('resources/'));
                this._sounds[soundName] = resource.sound;
            }
        }
        this._soundsLoaded++;
        this._currentLoadingQueueIndex++;
        if (this._soundsLoaded >= this._soundsExpectedToLoad) {
            this._soundsLoadingCompletedCallback();
            this.updateProgress();
            return;
        }
        this.updateProgress();
        if (this._currentLoadingQueueIndex < this._expectedToLoadInThisQueue) {
            return;
        }
        this._loader.reset();
        var inProgressResources = 0;
        for (var i = 0; i < this._maxDownloadStreams; i++) {
            var resourceName = this._device.isMobile
                ? this._mobileSoundResourcesFiles[this._soundsLoaded + i]
                : this._soundResources[this._soundsLoaded + i];
            if (resourceName) {
                this._loader.add(this.getPathForResource(resourceName), {}, this.loadNextSound.bind(this));
                inProgressResources++;
            }
        }
        this._currentLoadingQueueIndex = 0;
        this._expectedToLoadInThisQueue = inProgressResources;
        this._loader.load();
    };
    ResourcesLoader.prototype.forceLoadCurrency = function (currencyISO, callback) {
        if (this._currenciesLoaded.indexOf(currencyISO) > -1) {
            callback && callback();
            return;
        }
        this._loader.reset();
        var currencyResourceName = this._currencyResources[this._currencyResources.indexOf("CURRENCIES/" + currencyISO + ".json")];
        this._loader.add(this.getDevicePathForResource(currencyResourceName), {}, this.forcedLoadCurrencyResource.bind(this, callback, currencyISO, currencyResourceName));
        this._loader.load();
    };
    ResourcesLoader.prototype.forcedLoadCurrencyResource = function (callback, currencyISO, resName, resource) {
        if (resource.hasOwnProperty('spritesheet')) {
            this._spritesheets[resName] = resource.spritesheet;
        }
        this._currenciesLoading.splice(this._currenciesLoading.indexOf(currencyISO), 1);
        this._currenciesLoaded.push(currencyISO);
        this._loader.reset();
        callback && callback();
    };
    ResourcesLoader.prototype.loadCurrencyISOResource = function (currencyISO) {
        if (this._currenciesLoading.length > 0) {
            if (this._currenciesLoading.indexOf(currencyISO) > -1) {
                return true;
            }
        }
        else if (this._currenciesLoaded.indexOf(currencyISO) > -1) {
            return true;
        }
        this._loader.reset();
        this._currenciesLoading.push(currencyISO);
        var currencyResourceName = this._currencyResources[this._currencyResources.indexOf("CURRENCIES/" + currencyISO + ".json")];
        this._loader.add(this.getDevicePathForResource(currencyResourceName), {}, this.loadCurrencyResource.bind(this, currencyISO, currencyResourceName));
        this._loader.load();
        return false;
    };
    ResourcesLoader.prototype.loadCurrencyResource = function (currencyISO, resName, resource) {
        if (resource.hasOwnProperty('spritesheet')) {
            this._spritesheets[resName] = resource.spritesheet;
        }
        this._currenciesLoading.splice(this._currenciesLoading.indexOf(currencyISO), 1);
        this._currenciesLoaded.push(currencyISO);
        // console.log(`Loaded currency ISO:${currencyISO}`);
        this._loader.reset();
    };
    ResourcesLoader.prototype.isSupportedLocale = function (locale) {
        if (this._supportedLocales.indexOf(locale) > -1) {
            return true;
        }
        return false;
    };
    // imageloader for Spine files. References a single atlas file and it's .pngs instead of loading the ones with the same name as the .json.
    ResourcesLoader.prototype.advancedImageLoader = function (loader, namePrefix, baseUrl, imageOptions) {
        return function (line, callback) {
            var url = baseUrl + line;
            var textureResource = imageOptions.metadata.find(function (item) {
                return item.name === url;
            });
            callback(textureResource.texture.baseTexture);
        };
    };
    ResourcesLoader.prototype.loadNextResource = function (resName, resource) {
        var metaData = {};
        if (this._resourcesLoaded >= 0) {
            var resFullPath = resource.name;
            if (resFullPath.toLocaleLowerCase().indexOf('portrait') >= 0) {
                resName = "portrait_" + resName;
            }
            else if (resFullPath.toLocaleLowerCase().indexOf('landscape') >= 0) {
                resName = "landscape_" + resName;
            }
            if (resource.hasOwnProperty('spineData')) {
                this._spines[resName] = resource.spineData;
                if (false) {
                    this._spines[resName].name = resName;
                }
            }
            else if (resource.hasOwnProperty('name') &&
                resource.name.indexOf('LOCALE_TEXTS/en.json') > -1 &&
                resource.hasOwnProperty('spritesheet')) {
                this._englishLocaleTextData = resource.spritesheet;
            }
            else if (resource.hasOwnProperty('spritesheet')) {
                this._spritesheets[resName] = resource.spritesheet;
                if (resource.data.hasOwnProperty('nineslicedata')) {
                    this._nineslicedata[resName] = resource.data.nineslicedata;
                    if (false) {
                        console.log(resource.data.nineslicedata);
                    }
                }
            }
            else {
                this._textures[resName] = resource.texture;
            }
        }
        this._resourcesLoaded++;
        this._currentLoadingQueueIndex++;
        if (this.isLoadingTwoBunchesOfResources()) {
            if (this._resourcesLoaded >= this._expectedToLoad * 2) {
                this._loadingCompletedCallback();
                this.updateProgress();
                return;
            }
        }
        else {
            if (this._resourcesLoaded >= this._expectedToLoad) {
                this._loadingCompletedCallback();
                this.updateProgress();
                return;
            }
        }
        this.updateProgress();
        if (this._currentLoadingQueueIndex < this._expectedToLoadInThisQueue) {
            return;
        }
        if (this.isLoadingTwoBunchesOfResources()) {
            this.loadBunchOfResourcesMobileLandscapePortrait(metaData);
        }
        else {
            this.loadBunchOfResources(metaData);
        }
    };
    ResourcesLoader.prototype.isLoadingTwoBunchesOfResources = function () {
        return this._device.isMobile && this._loadingLandscapeAndPortraitResources;
    };
    ResourcesLoader.prototype.loadBunchOfResources = function (metaData) {
        this._loader.reset();
        var inProgressResources = 0;
        for (var i = 0; i < this._maxDownloadStreams / 2; i++) {
            if (this._resources[this._resourcesLoaded + i]) {
                if (this._useSingleSpineAtlas && this.isSpineResource(this._resources[this._resourcesLoaded + i])) {
                    this._loader.add(this.getDevicePathForResource(this._resources[this._resourcesLoaded + i]), {
                        metadata: {
                            imageLoader: this.advancedImageLoader,
                            imageMetadata: this._spineAtlasImages,
                            atlasRawData: this._spineAtlasData,
                        },
                    }, this.loadNextResource.bind(this, this._resources[this._resourcesLoaded + i]));
                }
                else {
                    this._loader.add(this.getDevicePathForResource(this._resources[this._resourcesLoaded + i]), {}, this.loadNextResource.bind(this, this._resources[this._resourcesLoaded + i]));
                }
                inProgressResources++;
            }
        }
        this._currentLoadingQueueIndex = 0;
        this._expectedToLoadInThisQueue = inProgressResources;
        this._loader.load();
    };
    ResourcesLoader.prototype.loadBunchOfResourcesMobileLandscapePortrait = function (metaData) {
        this._loader.reset();
        var inProgressResources = 0;
        for (var i = 0; i < this._maxDownloadStreams / 2; i++) {
            var index = this._resourcesLoaded / 2 + i;
            if (this._resources[index]) {
                this._loader.add(this.getPortraitDevicePathForResource(this._resources[index]), metaData, this.loadNextResource.bind(this, this._resources[index]));
                inProgressResources++;
                this._loader.add(this.getLandscapeDevicePathForResource(this._resources[index]), metaData, this.loadNextResource.bind(this, this._resources[index]));
                inProgressResources++;
            }
            if (false) {
                console.log("about to load " + this._resources[index]);
            }
        }
        this._currentLoadingQueueIndex = 0;
        this._expectedToLoadInThisQueue = inProgressResources;
        this._loader.load();
    };
    ResourcesLoader.prototype.isSpineResource = function (name) {
        return this._spineResources.indexOf(name) > -1;
    };
    ResourcesLoader.prototype.getPortraitDevicePathForResource = function (resName) {
        return this._getUrlPath('resources/Mobile/PORTRAIT/' + resName);
    };
    ResourcesLoader.prototype.getLandscapeDevicePathForResource = function (resName) {
        return this._getUrlPath('resources/Mobile/LANDSCAPE/' + resName);
    };
    ResourcesLoader.prototype.getSpineAtlasAttachment = function (data) {
        // tODO: Hook up correctly and replace getSpine function.
        return this._spineJsonParser.readSkeletonData(data);
    };
    ResourcesLoader.prototype.exists = function (arr, id) {
        if (typeof arr === 'object') {
            if (arr.hasOwnProperty(id)) {
                return true;
            }
        }
        if (false) {
            throw new Error("Could not find resource: " + id);
        }
        return false;
    };
    ResourcesLoader.prototype.existsBoolean = function (arr, id) {
        if (typeof arr === 'object') {
            if (arr.hasOwnProperty(id)) {
                return true;
            }
        }
        return false;
    };
    ResourcesLoader.prototype.updateProgress = function () {
        var totalItems = this._expectedToLoad +
            this._soundsExpectedToLoad +
            this._soundConfigsExpectedToLoad +
            this._translationsExpectedToLoad +
            this._localeTextsExpectedToLoad +
            this._atlasExpectedToLoad +
            this._helpStylesExpectedToLoad +
            this._helpFilesExpectedToLoad +
            this._configFilesExpectedToLoad +
            this._particlesExpectedToLoad;
        // this._atlasResourcesExpectedToLoad +
        var current = Math.max(0, this._resourcesLoaded) +
            Math.max(0, this._soundsLoaded) +
            Math.max(0, this._soundConfigsLoaded) +
            Math.max(0, this._helpFilesLoaded) +
            Math.max(0, this._translationsLoaded) +
            Math.max(0, this._localeTextsLoaded) +
            Math.max(0, this._helpStylesLoaded) +
            Math.max(0, this._atlasLoaded) +
            Math.max(0, this._configFilesLoaded) +
            Math.max(0, this._particlesLoaded);
        this._preloader.updateProgress(totalItems, current);
    };
    Object.defineProperty(ResourcesLoader.prototype, "hasMajorPerformanceCaveat", {
        get: function () {
            return this._majorPerformanceCaveat;
        },
        enumerable: true,
        configurable: true
    });
    var ResourcesLoader_1;
    ResourcesLoader = ResourcesLoader_1 = __decorate([
        inversify_1.injectable(),
        __metadata("design:paramtypes", [Device_1.Device, Function, String, Number])
    ], ResourcesLoader);
    return ResourcesLoader;
}());
exports.ResourcesLoader = ResourcesLoader;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Updatable_1 = __webpack_require__(71);
var UpdateManager = /** @class */ (function (_super) {
    __extends(UpdateManager, _super);
    function UpdateManager() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._updatables = [];
        _this._needToRemove = [];
        return _this;
    }
    UpdateManager.prototype.update = function (dt) {
        for (var _i = 0, _a = this._updatables; _i < _a.length; _i++) {
            var updatable = _a[_i];
            updatable.isPlaying && updatable.update(dt);
        }
        this.cleanup();
    };
    UpdateManager.prototype.add = function (updatable) {
        this._updatables.push(updatable);
        updatable.updateManager = this;
    };
    UpdateManager.prototype.remove = function (updatable) {
        var index = this._updatables.indexOf(updatable);
        if (index !== -1) {
            this._needToRemove.push(updatable);
        }
    };
    UpdateManager.prototype.removeAll = function () {
        this._updatables.length = 0;
        this._needToRemove.length = 0;
    };
    UpdateManager.prototype.cleanup = function () {
        for (var _i = 0, _a = this._needToRemove; _i < _a.length; _i++) {
            var updatable = _a[_i];
            var index = this._updatables.indexOf(updatable);
            if (index !== -1) {
                updatable.updateManager = null;
                this._updatables.splice(index, 1);
            }
        }
        this._needToRemove.length = 0;
    };
    return UpdateManager;
}(Updatable_1.Updatable));
exports.UpdateManager = UpdateManager;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Updatable = /** @class */ (function () {
    function Updatable(start) {
        if (start === void 0) { start = false; }
        start && this.start();
    }
    Updatable.prototype.start = function () {
        this._isPlaying = true;
    };
    Updatable.prototype.stop = function () {
        this._isPlaying = false;
        this._updateManager && this._updateManager.remove(this);
    };
    Object.defineProperty(Updatable.prototype, "updateManager", {
        get: function () {
            return this._updateManager;
        },
        set: function (value) {
            this._updateManager = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Updatable.prototype, "isPlaying", {
        get: function () {
            return this._isPlaying;
        },
        enumerable: true,
        configurable: true
    });
    return Updatable;
}());
exports.Updatable = Updatable;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = __webpack_require__(14);
var CurrencyFormatter = /** @class */ (function () {
    function CurrencyFormatter() {
        // Temp
        this.setCurrencyData(this.parseCurrencyFormatting('USD', CurrencyFormatter_1.CurrenciesDisplayFormat.USD));
    }
    CurrencyFormatter_1 = CurrencyFormatter;
    CurrencyFormatter.prototype.formatCurrencyFromCents = function (cents) {
        return this.formatCurrency(cents / 100);
    };
    CurrencyFormatter.prototype.setupCurrencyFromISO = function (isoCode) {
        if (CurrencyFormatter_1.CurrenciesDisplayFormat[isoCode]) {
            this.setCurrencyData(this.parseCurrencyFormatting(isoCode, CurrencyFormatter_1.CurrenciesDisplayFormat[isoCode]));
        }
    };
    CurrencyFormatter.prototype.setCurrencyData = function (currencyData) {
        if (currencyData !== null) {
            this.currency = currencyData.currency;
            this.currencySign = currencyData.currencySign;
            this.currencyDecimals = currencyData.decimalPlaces;
            this.currencyPrefix = currencyData.currencyPrefix;
            this.currencySuffix = currencyData.currencySuffix;
            this.decimalSeparator = currencyData.decimalSeparator;
            this.thousandSeparator = currencyData.thousandSeparator;
        }
    };
    CurrencyFormatter.prototype.formatNumber = function (valueAmount, includeDecimals) {
        if (includeDecimals === void 0) { includeDecimals = true; }
        var currency = {
            currency: this.currency,
            decimalPlaces: this.currencyDecimals,
            thousandSeparator: this.thousandSeparator,
            decimalSeparator: this.decimalSeparator,
            currencyPrefix: this.currencyPrefix,
            currencySuffix: this.currencySuffix,
            currencySign: this.currencySign,
        };
        valueAmount = (valueAmount + '').replace(/[^0-9+\-Ee.]/g, '');
        var n = !isFinite(+valueAmount) ? 0 : +valueAmount;
        var prec = !isFinite(+currency.decimalPlaces) ? 0 : Math.abs(currency.decimalPlaces);
        var sep = typeof currency.thousandSeparator === 'undefined' ? ',' : currency.thousandSeparator;
        var dec = typeof currency.decimalSeparator === 'undefined' ? '.' : currency.decimalSeparator;
        var s = [''];
        // tslint:disable-next-line:no-shadowed-variable
        var toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + (Math.round(n * k) / k).toFixed(prec);
        };
        s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
        if (s[0].length > 3) {
            s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
        }
        if ((s[1] || '').length < prec) {
            s[1] = s[1] || '';
            s[1] += new Array(prec - s[1].length + 1).join('0');
        }
        return includeDecimals ? s.join(dec) : s[0];
    };
    CurrencyFormatter.prototype.formatCurrencyApi = function (value) {
        return this.formatCurrency(value, true);
    };
    CurrencyFormatter.prototype.formatCurrency = function (valueAmount, includeCurrencySign) {
        if (includeCurrencySign === void 0) { includeCurrencySign = true; }
        var currency = {
            currency: this.currency,
            decimalPlaces: this.currencyDecimals,
            thousandSeparator: this.thousandSeparator,
            decimalSeparator: this.decimalSeparator,
            currencyPrefix: this.currencyPrefix,
            currencySuffix: this.currencySuffix,
            currencySign: this.currencySign,
        };
        valueAmount = (valueAmount + '').replace(/[^0-9+\-Ee.]/g, '');
        var n = !isFinite(+valueAmount) ? 0 : +valueAmount;
        var prec = !isFinite(+currency.decimalPlaces) ? 0 : Math.abs(currency.decimalPlaces);
        var sep = typeof currency.thousandSeparator === 'undefined' ? ',' : currency.thousandSeparator;
        var dec = typeof currency.decimalSeparator === 'undefined' ? '.' : currency.decimalSeparator;
        var s = [''];
        // tslint:disable-next-line:no-shadowed-variable
        var toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + (Math.round(n * k) / k).toFixed(prec);
        };
        s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
        if (s[0].length > 3) {
            s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
        }
        if ((s[1] || '').length < prec) {
            s[1] = s[1] || '';
            s[1] += new Array(prec - s[1].length + 1).join('0');
        }
        return includeCurrencySign ? currency.currencyPrefix + s.join(dec) + currency.currencySuffix : s.join(dec);
    };
    CurrencyFormatter.prototype.parseCurrencyFormatting = function (isoCode, displayFormat) {
        /**
         * Should be 4 capturing groups.
         * 1: Prefix symbols
         * 2: Thousand separator.
         * 3: Decimal separator.
         * 4: Decimal places.
         * 5: Suffix symbols
         */
        // const regexMatch = /(.*)?(?:#)(['|,|.|\s])(?:###)([,|.|\s])?([#]*)?(.*)?/;
        var regexMatch = /([^#]*)?(?:#)(['|,|.|\s])(?:###)([,|.|\s])?([#]*)?(.*)?/;
        var dataObject = displayFormat.match(regexMatch);
        var currency = isoCode;
        var decimalPlaces = dataObject[4] ? dataObject[4].length : 0;
        var thousandSeparator = dataObject[2] ? dataObject[2] : ',';
        var decimalSeparator = dataObject[3] ? dataObject[3] : '.';
        var currencyPrefix = dataObject[1] ? dataObject[1] : '';
        var currencySuffix = dataObject[5] ? dataObject[5] : '';
        var currencySign = dataObject[1] ? currencyPrefix : currencySuffix;
        var currencyData = {
            currency: currency,
            currencySign: currencySign,
            decimalPlaces: decimalPlaces,
            thousandSeparator: thousandSeparator,
            decimalSeparator: decimalSeparator,
            currencyPrefix: currencyPrefix,
            currencySuffix: currencySuffix,
        };
        return currencyData;
    };
    Object.defineProperty(CurrencyFormatter.prototype, "currencySign", {
        get: function () {
            return this._currencySign;
        },
        set: function (value) {
            this._currencySign = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CurrencyFormatter.prototype, "currencyDecimals", {
        get: function () {
            return this._currencyDecimals;
        },
        set: function (value) {
            this._currencyDecimals = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CurrencyFormatter.prototype, "currencyPrefix", {
        get: function () {
            return this._currencyPrefix;
        },
        set: function (value) {
            this._currencyPrefix = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CurrencyFormatter.prototype, "currencySuffix", {
        get: function () {
            return this._currencySuffix;
        },
        set: function (value) {
            this._currencySuffix = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CurrencyFormatter.prototype, "thousandSeparator", {
        get: function () {
            return this._thousandSeparator;
        },
        set: function (value) {
            this._thousandSeparator = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CurrencyFormatter.prototype, "decimalSeparator", {
        get: function () {
            return this._decimalSeparator;
        },
        set: function (value) {
            this._decimalSeparator = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CurrencyFormatter.prototype, "currency", {
        get: function () {
            return this._currency;
        },
        set: function (value) {
            this._currency = value;
        },
        enumerable: true,
        configurable: true
    });
    var CurrencyFormatter_1;
    CurrencyFormatter.CurrenciesDisplayFormat = {
        AED: '#,###.##',
        ALL: '#,###.##',
        AMD: '#,###.##',
        AOA: 'Kz#,###',
        ARS: '$#,###.##',
        ATS: 'S #.###,##',
        AUD: '$#,###.##',
        BAM: '#,###.##',
        BEF: '#.###,##',
        BGN: '#,###.##',
        BIF: 'FBu#,###.##',
        BOB: '#,###.##',
        BRL: '#,###.##',
        BWP: 'P#,###',
        CAD: '$#,###.##',
        CDF: 'FC#,###',
        CHF: "SFr. #'###.##",
        CLP: '#,###.##',
        CNY: '¥#,###.##',
        COP: '$ #.###,##',
        CRC: '#,###',
        CVE: '$#,###',
        CZK: '# ###,## K',
        DEM: '#.###,## DM',
        DJF: 'Fdj#,###',
        DKK: 'kr #.###,##',
        DOP: '#,###.##',
        DZD: 'DA#,###',
        EEK: '# ###.## kr',
        EGP: 'E?#,###',
        ERN: 'Nfk#,###',
        ESP: '#.###,## Pts',
        ETB: 'Br#,###',
        EUR: '€ #.###,##',
        FIM: '# ###,## mk',
        FRF: '# ###,##',
        GBP: '£#,###.##',
        GEL: '#,###.##',
        GHC: '#,###.##',
        GHS: '₡ #,###.##',
        GMD: 'D#,###',
        GNF: 'FG#,###',
        GRD: '#.###,##',
        HKD: 'HK$#,###.##',
        HNL: '#,###.##',
        HRK: '#,###.##',
        HUF: '# ###,## Ft',
        IDR: '#,###.##',
        IQD: '#,###.###د.ع',
        IEP: '£#,###.##',
        ILS: '₪ #,###.##',
        INR: '#,###.##',
        IRR: '﷼#,###.##',
        ISK: '#.###,## kr.',
        ITL: '#.###,##',
        JPY: '¥#,###',
        KES: 'KSh#,###',
        KGS: '#,###.##',
        KHR: '#,###',
        KMF: 'CF#,###',
        KRW: '# ###.##',
        KZT: '#,###.##',
        LAK: '#,###',
        LRD: 'L$#,###',
        LSL: 'L#,###',
        LTL: '#,###.##',
        LVL: '#,###.##',
        LYD: 'LD#,###',
        MAD: '#,###.##',
        MDL: '#,###.##',
        MNT: '₮#,###.##',
        MMK: 'K#,###',
        MKD: 'ден#,###.##',
        MOP: '#,###.##',
        MRO: 'UM#,###',
        MUR: '#,###',
        MWK: 'MK#,###',
        MXN: '$#,###.##',
        MYR: 'RM#,###.##',
        MZN: 'MT#,###',
        NAD: '#,###.##',
        NGN: '#,###.##',
        NLG: 'ƒ #.###,##',
        NOK: 'kr # ###,##',
        NONE: '#,###.##',
        NZD: '$#,###.##',
        PEN: 'S/. #,###.##',
        PHP: 'Php#,###.##',
        PKR: 'Rs#,###.##',
        PLN: '# ###,## z',
        PTE: '#.###,## $',
        PYG: '#,###.##',
        RON: '#,###.##',
        RSD: '#,###.##',
        RUB: '# ###,##.',
        RWF: 'FRw#,###',
        SCR: 'SR#,###.##',
        SDG: '#,###.##',
        SEK: '#.###,## kr',
        SGD: '$#,###.##',
        SKK: '# ###,## Sk',
        SZL: 'L#,###',
        THB: '#,###.##',
        TND: '#,###.###د.ت',
        TRL: '#,###.##',
        TRY: '#,###.##',
        TWD: 'NT$#,###.##',
        TZS: 'TSh #,###.##',
        UAH: '#,###.##',
        UGX: '#,###.##',
        USD: '$#,###.##',
        UYU: '#,###.##',
        VEF: '#,###.##',
        VND: '#,###.##',
        XAF: '#,###.##',
        XCD: '#,###.##',
        XOF: '#,###.##',
        ZAR: 'R #,###.##',
        ZMW: 'K#,###.##',
    };
    CurrencyFormatter = CurrencyFormatter_1 = __decorate([
        inversify_1.injectable(),
        __metadata("design:paramtypes", [])
    ], CurrencyFormatter);
    return CurrencyFormatter;
}());
exports.CurrencyFormatter = CurrencyFormatter;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var CurrencyFormatter_1 = __webpack_require__(72);
var QuerystringHandler_1 = __webpack_require__(242);
var Action_1 = __webpack_require__(29);
var Communicator_1 = __webpack_require__(149);
var SpinResult_1 = __webpack_require__(110);
var Storage_1 = __webpack_require__(150);
var GameUtils_1 = __webpack_require__(26);
var inversify_1 = __webpack_require__(14);
var Device_1 = __webpack_require__(42);
var GameConfig_1 = __webpack_require__(142);
var Logic = /** @class */ (function () {
    function Logic(gameName, eventManager, communicator, device) {
        this._betLevel = 0;
        this._betValue = 0;
        this._rawBetValue = 0;
        this._skipIntro = false;
        this._spacebarSpinActive = true;
        this._dragReelToSpinActive = true;
        this._quickStopActive = true;
        this._fastPlayActive = false;
        this._voiceActive = true;
        this._soundEffectsActive = true;
        this._musicActive = true;
        this._soundAllActive = true;
        this._autoplayValues = [5, 10, 25, 50, 100];
        this._autoplayDefault = 25;
        this._balance = 100;
        this._totalBet = 0;
        this._previousAction = Action_1.Action.NONE;
        this._nextAction = Action_1.Action.SPIN;
        this._responsibleGaming = false;
        this._hasRestore = false;
        this._isFreeSpinsStarted = false;
        this._freespinsTotalAwarded = 0;
        this._freeSpinsLeft = 0;
        this._freeSpinsTotalWin = 0;
        this._freeSpinsMultiplier = 1;
        this._freeSpinsPreviousMultiplier = 1;
        this._eventManager = eventManager;
        this._gameName = gameName;
        this._device = device;
        this.createStorage();
        this.createCurrencyFormatter();
        this.createQuerystringHandler();
        this.createCommunicator(communicator);
    }
    Logic.prototype.initializeConfig = function (configData) {
        if (!this._config) {
            this._config = new GameConfig_1.GameConfig();
        }
        this._config.loadConfig(configData);
    };
    Logic.prototype.isEnoughMoneyForSpin = function () {
        return this._balance >= this.getTotalBet();
    };
    Logic.prototype.ping = function (cb) {
        throw new Error('Logic::init must be implemented');
    };
    Logic.prototype.init = function (cb) {
        throw new Error('Logic::init must be implemented');
    };
    Logic.prototype.spin = function (cb) {
        throw new Error('Logic::spin must be implemented');
    };
    Logic.prototype.freeSpin = function (cb) {
        throw new Error('Logic::freeSpin must be implemented');
    };
    Logic.prototype.respin = function (cb) {
        throw new Error('Logic::respin must be implemented');
    };
    Logic.prototype.freespin = function (cb) {
        throw new Error('Logic::freespin must be implemented');
    };
    Logic.prototype.avalanche = function (cb) {
        throw new Error('Logic::avalanche must be implemented');
    };
    Logic.prototype.pick = function (cb) {
        throw new Error('Logic::pick must be implemented');
    };
    Logic.prototype.skippick = function (cb) {
        throw new Error('Logic::skippick must be implemented');
    };
    Logic.prototype.initAutoplayDefaultValues = function () {
        this.autoplayDefault = 25;
        this.autoplayValues = [10, 25, 50, 100, 200, 500];
    };
    Logic.prototype.getSavedData = function () {
        return JSON.parse(this._storage.getItem("FNG_" + this._gameName));
    };
    Logic.prototype.generateDataToSave = function () {
        var autoplayData = { autoplayValue: this.autoplayDefault };
        // tODO: Verify if lastbet is correct.
        var lastBet = this.betValue;
        var lastBetWasMaxBet = this.isMaxBet(this.betValue);
        var lastAutoplayAmount = this.lastAutoplayAmount;
        var soundEffectsActive = this.soundEffectsActive;
        var voiceActive = this.voiceActive;
        var musicActive = this.musicActive;
        var soundAllActive = this.soundAllActive;
        var skipIntro = this.skipIntro;
        var spacebarSpinActive = this.spacebarSpinActive;
        var dragReelToSpinActive = this.dragReelToSpinActive;
        var data = {
            playerData: {
                autoplayData: autoplayData,
                lastBet: lastBet,
                lastBetWasMaxBet: lastBetWasMaxBet,
                lastAutoplayAmount: lastAutoplayAmount,
                soundEffectsActive: soundEffectsActive,
                voiceActive: voiceActive,
                musicActive: musicActive,
                soundAllActive: soundAllActive,
                skipIntro: skipIntro,
                spacebarSpinActive: spacebarSpinActive,
                dragReelToSpinActive: dragReelToSpinActive,
            },
        };
        return data;
    };
    Logic.prototype.saveData = function () {
        var data = this.generateDataToSave();
        this._storage.setItem("FNG_" + this._gameName, JSON.stringify(data));
    };
    Logic.prototype.startNextRound = function () {
        throw new Error('Logic::startNextRound must be overridden');
    };
    Logic.prototype.killRestore = function () {
        this._hasRestore = false;
    };
    Logic.prototype.getSpinResult = function () {
        return this._spin;
    };
    Logic.prototype.getWin = function () {
        if (this.getSpinResult()) {
            return isNaN(this.getSpinResult().win) ? 0 : this.getSpinResult().win;
        }
        return 0;
    };
    Logic.prototype.getSpinWin = function () {
        if (this.getSpinResult()) {
            return isNaN(this.getSpinResult().spinWin) ? 0 : this.getSpinResult().spinWin;
        }
        return 0;
    };
    Logic.prototype.getNextSpinWin = function () {
        if (this.getSpinResult()) {
            return isNaN(this.getSpinResult().nextSpinWin) ? 0 : this.getSpinResult().nextSpinWin;
        }
        return 0;
    };
    Logic.prototype.resetRound = function () { };
    Logic.prototype.getBonusWin = function () {
        return 0;
    };
    Logic.prototype.getTotalBet = function () {
        return this.betValue;
    };
    Logic.prototype.getSpinBalance = function () {
        if (this.getSpinResult()) {
            return this.getSpinResult().balance;
        }
        return 0;
    };
    Logic.prototype.finishFreeSpins = function () {
        this._nextAction = Action_1.Action.SPIN;
    };
    Logic.prototype.startFreeSpinsIntro = function () {
        this._nextAction = Action_1.Action.FREESPIN;
    };
    Logic.prototype.isFreeSpinsJustWon = function () {
        return this.freeSpinsLeft === this.freespinsTotalAwarded && this.freeSpinsLeft > 0;
    };
    Logic.prototype.createStorage = function () {
        this._storage = new Storage_1.BaseStorage();
    };
    Logic.prototype.createCommunicator = function (communicator) {
        if (this._queryStringHandler) {
            this.setCommunicatorValues();
        }
    };
    Logic.prototype.createQuerystringHandler = function () {
        this._queryStringHandler = new QuerystringHandler_1.QuerystringHandler();
        this.setTokenID(this._queryStringHandler);
        this.setRegulatedMarket(this._queryStringHandler);
    };
    Logic.prototype.createCurrencyFormatter = function () {
        this._currencyFormatter = new CurrencyFormatter_1.CurrencyFormatter();
    };
    Logic.prototype.setCommunicatorValues = function () {
        this._communicator.tokenID = this.tokenID;
        this._communicator.regulatedMarket = this.regulatedMarket;
    };
    Logic.prototype.parseSessionID = function (data) {
        this._sessionID = data.sessionId;
    };
    Logic.prototype.parsePlayerSavedData = function () {
        var data = this.getSavedData();
        if (data && data.playerData) {
            var playerData = data.playerData;
            if (typeof playerData.quickSpinActive !== 'undefined') {
                this.quickSpinActive = playerData.quickSpinActive;
            }
            if (typeof playerData.spacebarSpinActive !== 'undefined') {
                this.spacebarSpinActive = playerData.spacebarSpinActive;
            }
            if (typeof playerData.dragReelToSpinActive !== 'undefined') {
                this.dragReelToSpinActive = playerData.dragReelToSpinActive;
            }
            if (typeof playerData.quickStopActive !== 'undefined') {
                this.quickStopActive = playerData.quickStopActive;
            }
            if (typeof playerData.fastPlayActive !== 'undefined') {
                this.fastPlayActive = playerData.fastPlayActive;
            }
            if (typeof playerData.soundEffectsActive !== 'undefined') {
                this.soundEffectsActive = playerData.soundEffectsActive;
            }
            if (typeof playerData.voiceActive !== 'undefined') {
                this.voiceActive = playerData.voiceActive;
            }
            if (typeof playerData.musicActive !== 'undefined') {
                this.musicActive = playerData.musicActive;
            }
            if (typeof playerData.soundAllActive !== 'undefined') {
                this.soundAllActive = playerData.soundAllActive;
            }
            if (typeof playerData.lastBet !== 'undefined') {
                this.lastBet = playerData.lastBet;
                this.betValue = playerData.lastBet;
            }
            if (typeof playerData.lastBetWasMaxBet !== 'undefined') {
                this._lastBetWasMaxBet = playerData.lastBetWasMaxBet;
            }
            if (typeof playerData.skipIntro !== 'undefined') {
                this.skipIntro = playerData.skipIntro;
            }
            if (typeof playerData.autoplayData !== 'undefined') {
                this.autoplayDefault = playerData.autoplayData.autoplayValue;
            }
            if (typeof playerData.lastAutoplayAmount !== 'undefined') {
                this.lastAutoplayAmount = playerData.lastAutoplayAmount;
            }
            this.hasSavedData = true;
        }
    };
    Logic.prototype.isMaxBet = function (betvalue) {
        return betvalue === this.betValues[this.betValues.length - 1];
    };
    Logic.prototype.getLowerBet = function (betvalue) {
        var value = this.betValues[0];
        for (var _i = 0, _a = this.betValues; _i < _a.length; _i++) {
            var element = _a[_i];
            if (element < betvalue) {
                value = element;
            }
        }
        return value;
    };
    Logic.prototype.getHigherBet = function (betvalue) {
        var value = this.betValues[this.betValues.length - 1];
        for (var _i = 0, _a = this.betValues; _i < _a.length; _i++) {
            var element = _a[_i];
            if (element >= betvalue) {
                value = element;
            }
        }
        return value;
    };
    Logic.prototype.getClosestBet = function (betvalue) {
        var value = this.betValues[this.betValues.length - 1];
        for (var index = this.betValues.length - 1; index >= 0; index--) {
            var element = this.betValues[index];
            if (betvalue <= element) {
                value = element;
            }
        }
        return value;
    };
    Logic.prototype.createSpinResult = function () {
        return new SpinResult_1.SpinResult();
    };
    Logic.prototype.setCurrencySign = function (queryStringHandler) {
        if (queryStringHandler.getValue('currencyPrefix') !== '') {
            this.currencyFormatter.currencyPrefix = queryStringHandler.getValue('currencyPrefix');
        }
        if (queryStringHandler.getValue('currencySuffix') !== '') {
            this.currencyFormatter.currencySuffix = queryStringHandler.getValue('currencySuffix');
        }
    };
    Logic.prototype.setTokenID = function (queryStringHandler) {
        if (queryStringHandler.getValue('userId') !== '') {
            this.tokenID = queryStringHandler.getValue('userId');
        }
        else {
            this.tokenID = GameUtils_1.GameUtils.randomInt(100001, 999999).toString();
        }
    };
    Logic.prototype.setRegulatedMarket = function (queryStringHandler) {
        if (queryStringHandler.getValue('rm') !== '') {
            this._regulatedMarket = queryStringHandler.getValue('rm');
        }
        else {
            this._regulatedMarket = '';
        }
    };
    Object.defineProperty(Logic.prototype, "previousAction", {
        get: function () {
            return this._previousAction;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logic.prototype, "nextAction", {
        get: function () {
            return this._nextAction;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logic.prototype, "betValues", {
        get: function () {
            return this._betValues;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logic.prototype, "defaultBetValue", {
        get: function () {
            return this._defaultBet;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logic.prototype, "betValue", {
        get: function () {
            return this._betValue;
        },
        set: function (betvalue) {
            this._betValue = betvalue;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logic.prototype, "autoplayDefault", {
        get: function () {
            return this._autoplayDefault;
        },
        set: function (value) {
            this._autoplayDefault = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logic.prototype, "autoplayValues", {
        get: function () {
            return this._autoplayValues;
        },
        set: function (values) {
            this._autoplayValues = values;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logic.prototype, "hasRestore", {
        get: function () {
            return this._hasRestore;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logic.prototype, "soundEffectsActive", {
        get: function () {
            return this._soundEffectsActive;
        },
        set: function (value) {
            this._soundEffectsActive = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logic.prototype, "voiceActive", {
        get: function () {
            return this._voiceActive;
        },
        set: function (value) {
            this._voiceActive = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logic.prototype, "spacebarSpinActive", {
        get: function () {
            return this._spacebarSpinActive;
        },
        set: function (value) {
            this._spacebarSpinActive = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logic.prototype, "dragReelToSpinActive", {
        get: function () {
            return this._dragReelToSpinActive;
        },
        set: function (value) {
            this._dragReelToSpinActive = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logic.prototype, "fastPlayActive", {
        get: function () {
            return this._fastPlayActive;
        },
        set: function (value) {
            this._fastPlayActive = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logic.prototype, "quickStopActive", {
        get: function () {
            return this._quickStopActive;
        },
        set: function (value) {
            this._quickStopActive = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logic.prototype, "musicActive", {
        get: function () {
            return this._musicActive;
        },
        set: function (value) {
            this._musicActive = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logic.prototype, "skipIntro", {
        get: function () {
            return this._skipIntro;
        },
        set: function (value) {
            this._skipIntro = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logic.prototype, "soundAllActive", {
        get: function () {
            return this._soundAllActive;
        },
        set: function (value) {
            this._soundAllActive = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logic.prototype, "currentBalance", {
        get: function () {
            return this._balance;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logic.prototype, "preSpinBalance", {
        get: function () {
            return this._preSpinBalance;
        },
        set: function (value) {
            this._preSpinBalance = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logic.prototype, "lastBet", {
        get: function () {
            return this._lastBet;
        },
        set: function (value) {
            this._lastBet = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logic.prototype, "lastAutoplayAmount", {
        get: function () {
            return this._lastAutoplayAmount;
        },
        set: function (value) {
            this._lastAutoplayAmount = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logic.prototype, "quickSpinActive", {
        get: function () {
            return this._quickSpinActive;
        },
        set: function (value) {
            this._quickSpinActive = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logic.prototype, "hasSavedData", {
        get: function () {
            return this._hasSavedData;
        },
        set: function (value) {
            this._hasSavedData = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logic.prototype, "currencyFormatter", {
        get: function () {
            return this._currencyFormatter;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logic.prototype, "regulatedMarket", {
        get: function () {
            return this._regulatedMarket;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logic.prototype, "paytable", {
        get: function () {
            return this._paytable;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logic.prototype, "responsibleGaming", {
        get: function () {
            return this._responsibleGaming;
        },
        set: function (value) {
            this._responsibleGaming = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logic.prototype, "tokenID", {
        get: function () {
            return this._tokenID;
        },
        set: function (value) {
            this._tokenID = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logic.prototype, "communicator", {
        get: function () {
            return this._communicator;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logic.prototype, "autoplayData", {
        get: function () {
            return this._autoplayData;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logic.prototype, "isFreeSpinsStarted", {
        get: function () {
            return this._isFreeSpinsStarted;
        },
        set: function (value) {
            this._isFreeSpinsStarted = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logic.prototype, "freeSpinsLeft", {
        get: function () {
            return this._freeSpinsLeft;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logic.prototype, "freeSpinsPlayed", {
        get: function () {
            return this._freespinsTotalAwarded - this._freeSpinsLeft;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logic.prototype, "freespinsTotalAwarded", {
        get: function () {
            return this._freespinsTotalAwarded;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logic.prototype, "freeSpinsMultiplier", {
        get: function () {
            return this._freeSpinsMultiplier;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logic.prototype, "freeSpinsTotalWin", {
        get: function () {
            return this._freeSpinsTotalWin;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logic.prototype, "freeSpinsPreviousMultiplier", {
        get: function () {
            return this._freeSpinsPreviousMultiplier;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logic.prototype, "config", {
        get: function () {
            return this._config;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logic.prototype, "mathVersion", {
        get: function () {
            return '';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logic.prototype, "hasFreeSpinsRetrigger", {
        get: function () {
            return this._hasFreeSpinsRetrigger;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Logic.prototype, "freeSpinsAdded", {
        get: function () {
            return this._freeSpinsAdded;
        },
        enumerable: true,
        configurable: true
    });
    Logic.CENT_TO_A_DOLLAR = 0.01;
    Logic = __decorate([
        inversify_1.injectable(),
        __metadata("design:paramtypes", [String, Object, Communicator_1.Communicator, Device_1.Device])
    ], Logic);
    return Logic;
}());
exports.Logic = Logic;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var InfoPopupTypes;
(function (InfoPopupTypes) {
    InfoPopupTypes[InfoPopupTypes["RESTORE"] = 0] = "RESTORE";
    InfoPopupTypes[InfoPopupTypes["NO_MONEY"] = 1] = "NO_MONEY";
    InfoPopupTypes[InfoPopupTypes["WIN_LIMIT"] = 2] = "WIN_LIMIT";
    InfoPopupTypes[InfoPopupTypes["LOSS_LIMIT"] = 3] = "LOSS_LIMIT";
    InfoPopupTypes[InfoPopupTypes["MESSAGE"] = 4] = "MESSAGE";
    InfoPopupTypes[InfoPopupTypes["RELAX_MESSAGE"] = 5] = "RELAX_MESSAGE";
    InfoPopupTypes[InfoPopupTypes["RELAX_REALITY_CHECK"] = 6] = "RELAX_REALITY_CHECK";
})(InfoPopupTypes = exports.InfoPopupTypes || (exports.InfoPopupTypes = {}));


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var View_1 = __webpack_require__(3);
var ReelConstants_1 = __webpack_require__(10);
var ReelsUtils_1 = __webpack_require__(112);
var Tween_1 = __webpack_require__(19);
var Easing_1 = __webpack_require__(16);
var AvalancheReelsView = /** @class */ (function (_super) {
    __extends(AvalancheReelsView, _super);
    function AvalancheReelsView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._reels = [];
        _this._wasFillingVoidMessageSent = false;
        _this._currentMask = null;
        _this._currentReelToAddSymbolsIndex = 0;
        _this._isFallingFinished = true;
        return _this;
    }
    AvalancheReelsView.prototype.init = function () {
        _super.prototype.init.call(this);
        this.setupReelSetMaskForSpinning();
    };
    AvalancheReelsView.prototype.fadeOutSymbols = function () {
        var _this = this;
        this.emit(AvalancheReelsView.REELS_FADING_OUT_STARTED);
        var fadeOutTween = new Tween_1.Tween(this._reelsetContainer)
            .to({ alpha: 0 }, AvalancheReelsView.FADING_TIMER)
            .onComplete(function () {
            _this.emit(AvalancheReelsView.REELS_FADING_OUT_FINISHED);
        })
            .start();
        this.updateManager.add(fadeOutTween);
    };
    AvalancheReelsView.prototype.fadeInSymbols = function () {
        var _this = this;
        this.emit(AvalancheReelsView.REELS_FADING_IN_STARTED);
        var fadeOutTween = new Tween_1.Tween(this._reelsetContainer)
            .to({ alpha: 1 }, AvalancheReelsView.FADING_TIMER)
            .onComplete(function () {
            _this.emit(AvalancheReelsView.REELS_FADING_IN_FINISHED);
        })
            .start();
        this.updateManager.add(fadeOutTween);
    };
    AvalancheReelsView.prototype.hideSymbolsWithAlpha = function () {
        this._reelsetContainer.alpha = 0;
    };
    /**
     * old symbols falling down
     */
    AvalancheReelsView.prototype.dropOut = function () {
        this.soundPlayer.play('reelsFallStarted');
        for (var reelIndex = 0; reelIndex < ReelConstants_1.ReelConstants.REELS_AMOUNT; reelIndex++) {
            this._reels[reelIndex].dropOldSymbolsOut();
        }
    };
    /**
     * new symbols all reels dropping
     * @param reels - reels to drop down
     * @param rowsToShow - how many rows there are to show
     */
    AvalancheReelsView.prototype.dropNew = function (reels, rowsToShow) {
        for (var reelIndex = 0; reelIndex < ReelConstants_1.ReelConstants.REELS_AMOUNT; reelIndex++) {
            this._reels[reelIndex].setRowsToShow(rowsToShow);
            this._reels[reelIndex].dropSymbols(reels[reelIndex]);
        }
        this.rearrangeSymbolsOrder();
    };
    /**
     * removes certain symbols
     * @param symbols list
     */
    AvalancheReelsView.prototype.removeSymbolsOnAvalanche = function (symbols) {
        var lastReel = symbols[symbols.length - 1].x;
        for (var reelIndex = 0; reelIndex < ReelConstants_1.ReelConstants.REELS_AMOUNT; reelIndex++) {
            this._reels[reelIndex].removeAvalancheSymbols(this.getAllSymbolPositionsFromReel(reelIndex, symbols), reelIndex === lastReel ? this.onSymbolsRemovingFinshed.bind(this, symbols) : null);
        }
        this.soundPlayer.play('avalancheBlockBreak');
    };
    /**
     * drops down all the 'in-the-air" symbols
     */
    AvalancheReelsView.prototype.fillVoidAfterRemoval = function () {
        this._wasFillingVoidMessageSent = false;
        for (var reelIndex = 0; reelIndex < ReelConstants_1.ReelConstants.REELS_AMOUNT; reelIndex++) {
            this._reels[reelIndex].dropElementsToFillVoids();
        }
        if (!this.hasAnyReelsToFillVoid()) {
            this.onFillingVoidsFinished(0);
        }
        else {
            this.soundPlayer.play('symbolSlidedown');
        }
    };
    AvalancheReelsView.prototype.addNewSymbols = function (symbols) {
        var lastReel = symbols[symbols.length - 1].reel;
        for (var reelIndex = 0; reelIndex < ReelConstants_1.ReelConstants.REELS_AMOUNT; reelIndex++) {
            this._reels[reelIndex].addNewSymbols(this.getAllSymbolsFromReel(reelIndex, symbols), reelIndex === lastReel ? this.onSymbolsAddingFinshed.bind(this) : null);
        }
        this.rearrangeSymbolsOrder();
    };
    AvalancheReelsView.prototype.hideSymbolAt = function (pos) {
        this._reels[pos.x].hideSymbolAtPos(pos.y);
    };
    AvalancheReelsView.prototype.showAllSymbols = function () {
        for (var _i = 0, _a = this._reels; _i < _a.length; _i++) {
            var reel = _a[_i];
            reel.showAllSymbols();
        }
    };
    AvalancheReelsView.prototype.setupInitialRowsToShow = function (rowsToShow) {
        for (var reelIndex = 0; reelIndex < ReelConstants_1.ReelConstants.REELS_AMOUNT; reelIndex++) {
            this._reels[reelIndex].setRowsToShow(rowsToShow);
        }
    };
    AvalancheReelsView.prototype.setupInitialTopVisibleSymbolIndexes = function (initialReel) {
        for (var reelIndex = 0; reelIndex < ReelConstants_1.ReelConstants.REELS_AMOUNT; reelIndex++) {
            this._reels[reelIndex].initTopVisibleSymbolIndex(initialReel[reelIndex]);
        }
    };
    AvalancheReelsView.prototype.createReelSet = function (reels) {
        this._reelsetContainer = new PIXI.Sprite();
        this.container.children.length = 0;
        this._reels = [];
        this.container.addChild(this._reelsetContainer);
        for (var reelIndex = 0; reelIndex < ReelConstants_1.ReelConstants.REELS_AMOUNT; reelIndex++) {
            var offsets = {
                x: ReelConstants_1.ReelConstants.getReelsOffsets(this.viewType).x + reelIndex * ReelConstants_1.ReelConstants.getSymbolSlot(this.viewType).width,
                y: ReelConstants_1.ReelConstants.getReelsOffsets(this.viewType).y,
            };
            var reel = this.createReel(reelIndex, 0, offsets, this._reelsetContainer);
            reel.setupReel(this.resources, this.soundPlayer);
            reel.timerUtils = this.timeUtils;
            if (reels) {
                reel.init(reels[reelIndex]);
            }
            else {
                reel.init();
            }
            reel.onReelDropOutFinished = this.onReelDropOutFinished.bind(this);
            reel.onReelDropFirstSymbolFinished = this.onReelFirstSymbolDropped.bind(this);
            reel.onReelDropNewFinished = this.onReelDropNewFinished.bind(this);
            reel.onFillingVoidsFinished = this.onFillingVoidsFinished.bind(this);
            this.updateManager.add(reel);
            reel.start();
            this._reels.push(reel);
        }
        this._reels[ReelConstants_1.ReelConstants.REELS_AMOUNT - 1].onReelDropOutFinished = this.onLastReelDropOutFinished.bind(this);
        this._reels[ReelConstants_1.ReelConstants.REELS_AMOUNT - 1].onReelDropNewFinished = this.onLastReelDropNewFinished.bind(this);
        this.forceUpdateOrientation();
        this.setupInitialRowsToShow(ReelConstants_1.ReelConstants.ROW_AMOUNT);
    };
    AvalancheReelsView.prototype.rearrangeSymbolsOrder = function () {
    };
    AvalancheReelsView.prototype.startAddingNewSymbolsWithExpectedWin = function (reels, symbols, winLines) {
        if (this._isFallingFinished) {
            this._isFallingFinished = false;
            this._currentReelToAddSymbolsIndex = 0;
            this.addNewSymbolsWithExpectedWin(reels, symbols, winLines);
        }
    };
    AvalancheReelsView.prototype.recountSymbolsOnReels = function () {
        for (var reel = 0; reel < ReelConstants_1.ReelConstants.REELS_AMOUNT; reel++) {
            this._reels[reel].recountSymbolsOnReel();
        }
    };
    AvalancheReelsView.prototype.getWinSituationForSym = function (symPosition, winLines) {
        for (var _i = 0, winLines_1 = winLines; _i < winLines_1.length; _i++) {
            var wl = winLines_1[_i];
            for (var i = 0; i < wl.positions.length; i++) {
                var pos = wl.positions[i].x;
                if (pos === symPosition.x && i === symPosition.y) {
                    return wl;
                }
            }
        }
        return null;
    };
    AvalancheReelsView.prototype.getAllPositionsFromReel = function (positions, reelIndex) {
        var reelPositions = [];
        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
            var pos = positions_1[_i];
            if (pos.x === reelIndex) {
                reelPositions.push(pos);
            }
        }
        return reelPositions;
    };
    AvalancheReelsView.prototype.getNumberSymbolsInArray = function (reelIndex, syms) {
        var value = 0;
        for (var _i = 0, syms_1 = syms; _i < syms_1.length; _i++) {
            var pos = syms_1[_i];
            if (pos.x === reelIndex) {
                value++;
            }
        }
        return value;
    };
    AvalancheReelsView.prototype.addNewSymbolsWithExpectedWin = function (reels, symbols, winLines) {
        var _this = this;
        var lastReel = symbols[symbols.length - 1].reel;
        this.addReelSymbols(this._currentReelToAddSymbolsIndex, symbols, winLines, reels, function () {
            if (!_this._isFallingFinished) {
                _this._currentReelToAddSymbolsIndex++;
                if (_this._currentReelToAddSymbolsIndex <= lastReel) {
                    _this.addNewSymbolsWithExpectedWin(reels, symbols, winLines);
                }
            }
        }, function () {
            _this._currentReelToAddSymbolsIndex++;
            if (_this._currentReelToAddSymbolsIndex <= lastReel) {
                _this.addNewSymbolsWithExpectedWin(reels, symbols, winLines);
            }
        }, function (fallenReel) {
            if (fallenReel === lastReel) {
                _this._isFallingFinished = true;
                _this._currentReelToAddSymbolsIndex = 0;
                _this.onSymbolsAddingFinshed && _this.onSymbolsAddingFinshed();
            }
        });
    };
    /**
     * adding symbols on speceific reel
     * @param reelIndex
     * @param symbols - symbols to add
     * @param winLines - all the win lines
     * @param currentReels - reels
     * @param onExpectedWinAnimationCallback
     * @param onNoWinAnimationCallback
     * @param onSymbolFallenCallback
     */
    AvalancheReelsView.prototype.addReelSymbols = function (reelIndex, symbols, winLines, currentReels, onExpectedWinAnimationCallback, onNoWinAnimationCallback, onSymbolFallenCallback) {
        var _this = this;
        var reel = this._reels[reelIndex];
        var winSymbols = this.getAllWinningSymbolsBeforeReel(reelIndex, winLines);
        var newSymbols = this.getAllSymbolsFromReel(reelIndex, symbols);
        reel.addNewSymbols(newSymbols, function () {
            onSymbolFallenCallback && onSymbolFallenCallback(reelIndex);
            if (winSymbols && winSymbols.length > 0 && reelIndex > 1) {
                _this.tryToPlayExpectedWin(reelIndex, currentReels, winSymbols, newSymbols, onExpectedWinAnimationCallback);
            }
        });
        this.rearrangeSymbolsOrder();
        if (winSymbols.length === 0 || reelIndex < 2 || (reelIndex >= 2 && !this.hasAnyOfSymbolsInWinLine(newSymbols, winSymbols))) {
            onNoWinAnimationCallback && onNoWinAnimationCallback();
        }
    };
    AvalancheReelsView.prototype.getAllWinningSymbolsBeforeReel = function (reelIndex, winLines) {
        var winPositions = [];
        for (var _i = 0, winLines_2 = winLines; _i < winLines_2.length; _i++) {
            var wl = winLines_2[_i];
            for (var _a = 0, _b = wl.positions; _a < _b.length; _a++) {
                var pos = _b[_a];
                if (pos.x <= reelIndex) {
                    winPositions.push({ x: pos.x, y: pos.y });
                }
            }
        }
        return winPositions;
    };
    AvalancheReelsView.prototype.tryToPlayExpectedWin = function (reelIndex, currentReels, winSymbols, newSymbols, onExpectedWinAnimationCallback) {
        for (var _i = 0, newSymbols_1 = newSymbols; _i < newSymbols_1.length; _i++) {
            var symPos = newSymbols_1[_i];
            if (!this.isSymbolInWinLine({ x: symPos.reel, y: symPos.row }, winSymbols)) {
                continue;
            }
            var isFirst = true;
            for (var _a = 0, winSymbols_1 = winSymbols; _a < winSymbols_1.length; _a++) {
                var sym = winSymbols_1[_a];
                var reelSym = currentReels[sym.x][sym.y];
                if (!reelSym) {
                    continue;
                }
                var animationPosition = ReelsUtils_1.ReelsUtils.getPositionOnReels(sym, currentReels);
                animationPosition.y += (ReelConstants_1.ReelConstants.getSymbolSlot(this.viewType).height / 2) * (reelSym.size.height - 1);
                var preWinAnimation = this.createExpectedWinAnimation(reelSym.size.height, animationPosition);
                if (isFirst) {
                    isFirst = false;
                    this.soundPlayer.play('expectedWinReelComingDown');
                    onExpectedWinAnimationCallback && preWinAnimation.setOnComplete(onExpectedWinAnimationCallback);
                }
            }
        }
    };
    AvalancheReelsView.prototype.createExpectedWinAnimation = function (symSize, position) {
        return this.spineUtils
            .startSpineAnimationCreation('WIN.json', "EXPECT_WIN_WIN_" + symSize, false)
            .container(this.container)
            .position(position)
            .createAndStart();
    };
    AvalancheReelsView.prototype.hasAnyOfSymbolsInWinLine = function (positions, winLines) {
        for (var _i = 0, positions_2 = positions; _i < positions_2.length; _i++) {
            var symPos = positions_2[_i];
            for (var _a = 0, winLines_3 = winLines; _a < winLines_3.length; _a++) {
                var wl = winLines_3[_a];
                if (symPos.reel === wl.x && symPos.row === wl.y) {
                    return true;
                }
            }
        }
        return false;
    };
    AvalancheReelsView.prototype.isSymbolInWinLine = function (symPos, winLine) {
        for (var _i = 0, winLine_1 = winLine; _i < winLine_1.length; _i++) {
            var wp = winLine_1[_i];
            if (wp.y === symPos.y && wp.x === symPos.x) {
                return true;
            }
        }
        return false;
    };
    AvalancheReelsView.prototype.setupReelSetMaskForSpinning = function () {
        if (this.resources.hasMajorPerformanceCaveat) {
            this._currentMask = null;
            return;
        }
        this._currentMask = new PIXI.Graphics();
        this._currentMask.drawRect(0, 0, 1, 1);
        this._currentMask.x = 0;
        this._currentMask.y = 0;
        this._currentMask.width = this.resolutionManager.resolution.width;
        this._currentMask.height = this.resolutionManager.resolution.height;
        this.container.addChild(this._currentMask);
        this.container.mask = this._currentMask;
    };
    AvalancheReelsView.prototype.hasAnyReelsToFillVoid = function () {
        return false;
    };
    AvalancheReelsView.prototype.onSymbolsAddingFinshed = function () {
        this.emit(AvalancheReelsView.ADDING_SYMBOLS_FINISHED);
    };
    AvalancheReelsView.prototype.onSymbolsRemovingFinshed = function (symbols) {
        this.emit(AvalancheReelsView.REMOVING_SYMBOLS_FINISHED, symbols);
    };
    AvalancheReelsView.prototype.getAllSymbolsFromReel = function (reelIndex, symbols) {
        var syms = [];
        for (var _i = 0, symbols_1 = symbols; _i < symbols_1.length; _i++) {
            var sym = symbols_1[_i];
            if (sym.reel === reelIndex) {
                syms.push(sym);
            }
        }
        return syms;
    };
    AvalancheReelsView.prototype.getAllSymbolPositionsFromReel = function (reelIndex, symbols) {
        var syms = [];
        for (var _i = 0, symbols_2 = symbols; _i < symbols_2.length; _i++) {
            var sym = symbols_2[_i];
            if (sym.x === reelIndex) {
                syms.push(sym);
            }
        }
        return syms;
    };
    AvalancheReelsView.prototype.createReel = function (reelIndex, startReelPosition, offsets, container) {
        throw new Error('AvalancheReelsView::createReel should be implemented for the game');
    };
    AvalancheReelsView.prototype.onReelDropOutFinished = function (reelNr) {
        this.emit(AvalancheReelsView.REEL_DROPPED_OUT, reelNr);
    };
    AvalancheReelsView.prototype.onReelFirstSymbolDropped = function (reelNr) {
    };
    AvalancheReelsView.prototype.onLastReelDropOutFinished = function (reelNr) {
        this.emit(AvalancheReelsView.ALL_REELS_DROPPED_OUT, reelNr);
    };
    AvalancheReelsView.prototype.onReelDropNewFinished = function (reelNr) {
        this.emit(AvalancheReelsView.REEL_DROPPED_NEW, reelNr);
    };
    AvalancheReelsView.prototype.onLastReelDropNewFinished = function (reelNr) {
        this.emit(AvalancheReelsView.ALL_REELS_DROPPED_NEW, reelNr);
    };
    AvalancheReelsView.prototype.onFillingVoidsFinished = function (reelNr) {
        if (!this._wasFillingVoidMessageSent) {
            this.emit(AvalancheReelsView.FILLING_VOIDS_FINISHED);
            this._wasFillingVoidMessageSent = true;
        }
    };
    AvalancheReelsView.prototype.shakeReels = function (power, repeats) {
        if (power === void 0) { power = 1; }
        if (repeats === void 0) { repeats = NaN; }
        this._beforeShakingPosition = { x: this.container.x, y: this.container.y };
        this.stopShaking();
        var duration = Math.ceil(50 * power);
        var totalRepeats = Math.ceil(6 * power);
        if (!isNaN(repeats)) {
            totalRepeats = repeats;
        }
        var basePos = { x: this.resolutionManager.halfResolution.width, y: this.resolutionManager.halfResolution.height };
        this.container.pivot.set(basePos.x, basePos.y);
        var strength = 10 * power;
        var getValues = function () {
            return { x: (Math.random() - 0.5) * strength + basePos.x, y: (Math.random() - 0.5) * strength + basePos.y };
        };
        this.container.position.set(getValues().x, getValues().y);
        var shakeTween = new Tween_1.Tween(this.container)
            .to(getValues(), duration / totalRepeats)
            .repeat(totalRepeats)
            .yoyo(true)
            .easing(Easing_1.Easing.Linear.None)
            .onRepeat(function () {
            if (shakeTween.getRepeat() < totalRepeats) {
                shakeTween.to(getValues(), duration / (shakeTween.getRepeat() * shakeTween.getRepeat()));
            }
        })
            .onComplete(function () {
            shakeTween.to({ x: basePos.x, y: basePos.y }, duration);
        })
            .start();
        this.updateManager.add(shakeTween);
        this._currentShakingTween = shakeTween;
        var scaleTween = new Tween_1.Tween(this.container.scale)
            .to({ x: [Math.pow(1.03, power), 1], y: [Math.pow(1.03, power), 1] }, 250)
            .start();
        this.updateManager.add(scaleTween);
        this._currentScaleTween = scaleTween;
    };
    AvalancheReelsView.prototype.stopShaking = function () {
        if (this._currentShakingTween) {
            this._currentShakingTween.stop();
            this.updateManager.remove(this._currentShakingTween);
            this._currentShakingTween = null;
        }
        if (this._currentScaleTween) {
            this._currentScaleTween.stop();
            this.updateManager.remove(this._currentScaleTween);
            this._currentScaleTween = null;
        }
        this.container.scale.set(1.0);
        var basePos = { x: this.resolutionManager.halfResolution.width, y: this.resolutionManager.halfResolution.height };
        this.container.pivot.set(basePos.x, basePos.y);
        this.container.position.set(basePos.x, basePos.y);
    };
    AvalancheReelsView.FADING_TIMER = 500;
    AvalancheReelsView.ALL_REELS_DROPPED_OUT = 'AvalancheReelsView::ALL_REELS_DROPPED_OUT';
    AvalancheReelsView.REEL_DROPPED_OUT = 'AvalancheReelsView::REEL_DROPPED_OUT';
    AvalancheReelsView.ALL_REELS_DROPPED_NEW = 'AvalancheReelsView::ALL_REELS_DROPPED_NEW';
    AvalancheReelsView.REEL_DROPPED_NEW = 'AvalancheReelsView::REEL_DROPPED_NEW';
    AvalancheReelsView.FILLING_VOIDS_FINISHED = 'AvalancheReelsView::FILLING_VOIDS_FINISHED';
    AvalancheReelsView.ADDING_SYMBOLS_FINISHED = 'AvalancheReelsView::ADDING_SYMBOLS_FINISHED';
    AvalancheReelsView.REMOVING_SYMBOLS_FINISHED = 'AvalancheReelsView::REMOVING_SYMBOLS_FINISHED';
    AvalancheReelsView.RESPIN_REMOVING_SYMBOLS_FINISHED = 'AvalancheReelsView::RESPIN_REMOVING_SYMBOLS_FINISHED';
    AvalancheReelsView.REELS_FADING_OUT_FINISHED = 'AvalancheReelsView::REELS_FADING_OUT_FINISHED';
    AvalancheReelsView.REELS_FADING_IN_FINISHED = 'AvalancheReelsView::REELS_FADING_IN_FINISHED';
    AvalancheReelsView.REELS_FADING_OUT_STARTED = 'AvalancheReelsView::REELS_FADING_OUT_STARTED';
    AvalancheReelsView.REELS_FADING_IN_STARTED = 'AvalancheReelsView::REELS_FADING_IN_STARTED';
    return AvalancheReelsView;
}(View_1.View));
exports.AvalancheReelsView = AvalancheReelsView;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var FreeSpinsTriggerView_1 = __webpack_require__(275);
var Symbols_1 = __webpack_require__(38);
var GameViews_1 = __webpack_require__(43);
var GameFlowEvents_1 = __webpack_require__(57);
var Module_1 = __webpack_require__(2);
var FreeSpinsTriggerModule = /** @class */ (function (_super) {
    __extends(FreeSpinsTriggerModule, _super);
    function FreeSpinsTriggerModule() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._totalScattersCount = 0;
        return _this;
    }
    FreeSpinsTriggerModule.prototype.enterFirstState = function () {
    };
    FreeSpinsTriggerModule.prototype.setupStates = function () {
    };
    FreeSpinsTriggerModule.prototype.setupViews = function () {
        this.setView(GameViews_1.GameViews.FREE_SPINS_TRIGGER_VIEW);
    };
    FreeSpinsTriggerModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(GameFlowEvents_1.GameFlowEvents.PLAY_FREE_SPINS_TRIGGER, this.onPlayFreeSpinsTrigger);
        this.onView(FreeSpinsTriggerView_1.FreeSpinsTriggerView.ANIMATION_FINISHED_AT, this.onAnimationFinished);
    };
    FreeSpinsTriggerModule.prototype.onPlayFreeSpinsTrigger = function () {
        var _this = this;
        var logic = this.logic;
        var symbols = logic.getFinalSymbolsPosition().initialSymbols;
        symbols.forEach(function (reel) {
            reel.forEach(function (symbol) {
                if (symbol.sym === Symbols_1.Symbols.BN && symbol.position.y >= 3) {
                    _this.eventManager.emitDelayed(FreeSpinsTriggerModule.LEAVING_BONUS_AT, symbol.position);
                    _this.view.playTriggerAnimationAt(symbol.position);
                    _this._totalScattersCount++;
                }
            });
        });
    };
    FreeSpinsTriggerModule.prototype.onAnimationFinished = function (eventID, symPos) {
        this.eventManager.emitDelayed(FreeSpinsTriggerModule.BONUS_TRIGGER_ANIMATION_FINISHED_AT, symPos);
        if (--this._totalScattersCount === 0) {
            this.eventManager.emitDelayed(FreeSpinsTriggerModule.FREE_SPINS_TRIGGER_FINISHED);
        }
    };
    FreeSpinsTriggerModule.FREE_SPINS_TRIGGER_FINISHED = 'FREE_SPINS_TRIGGER_FINISHED';
    FreeSpinsTriggerModule.LEAVING_BONUS_AT = 'LEAVING_BONUS_AT';
    FreeSpinsTriggerModule.BONUS_TRIGGER_ANIMATION_FINISHED_AT = 'BONUS_TRIGGER_ANIMATION_FINISHED_AT';
    return FreeSpinsTriggerModule;
}(Module_1.Module));
exports.FreeSpinsTriggerModule = FreeSpinsTriggerModule;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Module_1 = __webpack_require__(2);
var WinPresentationView_1 = __webpack_require__(155);
var Views_1 = __webpack_require__(8);
var WinPresentationBasicState_1 = __webpack_require__(279);
var WinPresentationInitialState_1 = __webpack_require__(159);
var ReelsEvents_1 = __webpack_require__(4);
var AvalancheReelsEvents_1 = __webpack_require__(15);
var SwipeInteractionEvents_1 = __webpack_require__(65);
var WinPresentationEvents_1 = __webpack_require__(13);
var BetlevelMenuEvents_1 = __webpack_require__(48);
var FlowModuleEvents_1 = __webpack_require__(0);
var WinPresentationDebuggingComponent_1 = __webpack_require__(532);
var WinPresentationIndividualState_1 = __webpack_require__(533);
var FreeSpinsEvents_1 = __webpack_require__(6);
var WinPresentationInitialBeforeBigWin_1 = __webpack_require__(534);
var WinPresentationSkippedState_1 = __webpack_require__(535);
var SpinButtonEvents_1 = __webpack_require__(12);
/**
 * responsible for win presentation on symbols and win number
 */
var WinPresentationModule = /** @class */ (function (_super) {
    __extends(WinPresentationModule, _super);
    function WinPresentationModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WinPresentationModule.prototype.enterFirstState = function () {
        this.changeStateTo(WinPresentationModule.BASIC);
    };
    WinPresentationModule.prototype.setupStates = function () {
        this.addState(new WinPresentationBasicState_1.WinPresentationBasicState(this, WinPresentationModule.BASIC));
        this.addState(new WinPresentationIndividualState_1.WinPresentationIndividualState(this, WinPresentationModule.INDIVIDUAL));
        this.addState(new WinPresentationInitialState_1.WinPresentationInitialState(this, WinPresentationModule.INITIAL));
        this.addState(new WinPresentationInitialBeforeBigWin_1.WinPresentationInitialBeforeBigWin(this, WinPresentationModule.INITIALBEFOREBIGWIN));
        this.addState(new WinPresentationSkippedState_1.WinPresentationSkippedState(this, WinPresentationModule.SKIPPED));
    };
    WinPresentationModule.prototype.setupViews = function () {
        if (this.system.shouldUseMultipleViews()) {
            this.setView(Views_1.Views.WIN_PRESENTATION_VIEW_MOBILE);
        }
        else {
            this.setView(Views_1.Views.WIN_PRESENTATION_VIEW);
        }
    };
    WinPresentationModule.prototype.addDebuggingComponent = function () {
        new WinPresentationDebuggingComponent_1.WinPresentationDebuggingComponent(this, this.view);
    };
    WinPresentationModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.onCurrentStateHandle(ReelsEvents_1.ReelsEvents.REELS_SPINNING_STARTED);
        this.onCurrentStateHandle(AvalancheReelsEvents_1.AvalancheReelsEvents.REMOVING_AVALANCE_SYMBOLS_STARTED);
        this.onCurrentStateHandle(SwipeInteractionEvents_1.SwipeInteractionEvents.DRAGGING_STARTED);
        this.onCurrentStateHandle(BetlevelMenuEvents_1.BetlevelMenuEvents.BET_VALUE_UPDATED);
        this.onCurrentStateHandle(FlowModuleEvents_1.FlowModuleEvents.WON);
        this.onCurrentStateHandle(WinPresentationEvents_1.WinPresentationEvents.WIN_NUMBER_BOUNCE_FINISHED);
        this.onCurrentStateHandle(WinPresentationEvents_1.WinPresentationEvents.WIN_NUMBER_SHOWN_TO_PLAYER);
        this.onCurrentStateHandle(SpinButtonEvents_1.SpinButtonEvents.QUICKSTOP_PRESSED);
        this.onCurrentStateHandle(WinPresentationEvents_1.WinPresentationEvents.COUNTUP_FINISHED);
        this.onView(WinPresentationView_1.WinPresentationView.COUNTUP_ANIMATION_FINISHED, this.onEndAnimationFinished);
        this.onViewEmitEvent(WinPresentationView_1.WinPresentationView.COUNTUP_ANIMATION_STARTED, WinPresentationEvents_1.WinPresentationEvents.COUNTUP_STARTED);
        this.onViewEmitEvent(WinPresentationView_1.WinPresentationView.WIN_NUMBER_SHOWN_TO_PLAYER, WinPresentationEvents_1.WinPresentationEvents.WIN_NUMBER_SHOWN_TO_PLAYER);
        this.onViewEmitEvent(WinPresentationView_1.WinPresentationView.WIN_NUMBER_BOUNCE_FINISHED, WinPresentationEvents_1.WinPresentationEvents.WIN_NUMBER_BOUNCE_FINISHED);
        this.onViewEmitEvent(WinPresentationView_1.WinPresentationView.INITIAL_WIN_ANIMATION_FINISHED, WinPresentationEvents_1.WinPresentationEvents.INITIAL_WIN_ANIMATION_FINISHED);
        this.onViewCurrentStateHandle(WinPresentationView_1.WinPresentationView.WIN_ANIMATION_FINISHED);
        this.on(FlowModuleEvents_1.FlowModuleEvents.START_INDIVIDUAL_WIN, this.onShouldStartIndividualWin);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_OUTRO_STARTED, this.onFreeSpinsOutroStarted);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_INTRO_STARTED, this.onFreeSpinsIntroStarted);
        this.on(BetlevelMenuEvents_1.BetlevelMenuEvents.BET_LEVEL_MENU_SELECTED_BET_ACCEPTED, this.onBetChanged);
    };
    WinPresentationModule.prototype.onEndAnimationFinished = function () {
        this.eventManager.emit(WinPresentationEvents_1.WinPresentationEvents.COUNTUP_FINISHED);
        this.currentState.handle(WinPresentationView_1.WinPresentationView.COUNTUP_ANIMATION_FINISHED);
    };
    WinPresentationModule.prototype.onFreeSpinsOutroStarted = function () {
        this.view.forceKillWinNumbers();
        this.view.killCurrentWinPresentation();
        this.gotoState(WinPresentationModule.BASIC);
    };
    WinPresentationModule.prototype.onFreeSpinsIntroStarted = function () {
        this.view.forceKillWinNumbers();
        this.view.killCurrentWinPresentation();
        this.gotoState(WinPresentationModule.BASIC);
    };
    WinPresentationModule.prototype.onShouldStartIndividualWin = function () {
        this.gotoState(WinPresentationModule.INDIVIDUAL);
    };
    WinPresentationModule.prototype.onBetChanged = function () {
        this.gotoState(WinPresentationModule.BASIC);
    };
    WinPresentationModule.BASIC = 'basic';
    WinPresentationModule.INDIVIDUAL = 'individual';
    WinPresentationModule.INITIAL = 'initial';
    WinPresentationModule.INITIALBEFOREBIGWIN = 'initialbeforebigwin';
    WinPresentationModule.SKIPPED = 'skipped';
    return WinPresentationModule;
}(Module_1.Module));
exports.WinPresentationModule = WinPresentationModule;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BonusGameEvents = /** @class */ (function () {
    function BonusGameEvents() {
    }
    BonusGameEvents.BONUS_GAME_STARTED = 'BonusGameEvents::__BONUS_GAME_STARTED__';
    BonusGameEvents.BONUS_GAME_FINISHED = 'BonusGameEvents::__BONUS_GAME_FINISHED__';
    BonusGameEvents.BONUS_INTRO_STARTED = 'BonusGameEvents::__BONUS_INTRO_STARTED__';
    BonusGameEvents.BONUS_INTRO_FINISHED = 'BonusGameEvents::__BONUS_INTRO_FINISHED__';
    BonusGameEvents.BONUS_OUTRO_STARTED = 'BonusGameEvents::__BONUS_OUTRO_STARTED__';
    BonusGameEvents.BONUS_OUTRO_FINISHED = 'BonusGameEvents::__BONUS_OUTRO_FINISHED__';
    BonusGameEvents.PICK = 'BonusGameEvents::__PICK__';
    BonusGameEvents.WIN_RESULT_SHOWN = 'BonusGameEvents::WIN_RESULT_SHOWN';
    return BonusGameEvents;
}());
exports.BonusGameEvents = BonusGameEvents;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var RecodeEvents = /** @class */ (function () {
    function RecodeEvents() {
    }
    // Events sent from server.
    RecodeEvents.SERVER_SYSTEM_BALANCE_UPDATE = 'RecodeEvents::SERVER_SYSTEM_BALANCE_UPDATE';
    RecodeEvents.SERVER_PLUGIN_SET_MUTE = 'RecodeEvents::SERVER_PLUGIN_SET_MUTE';
    RecodeEvents.SERVER_GAMEPLAY_RESUME = 'RecodeEvents::SERVER_GAMEPLAY_RESUME';
    RecodeEvents.SERVER_AUTOPLAY_INTERRUPT = 'RecodeEvents::SERVER_AUTOPLAY_INTERRUPT';
    RecodeEvents.SERVER_PRELOADER_REMOVED = 'RecodeEvents::SERVER_PRELOADER_REMOVED';
    RecodeEvents.SERVER_LAUNCH_LOBBY = 'RecodeEvents::SERVER_LAUNCH_LOBBY';
    RecodeEvents.SERVER_LAUNCH_BANKING = 'RecodeEvents::SERVER_LAUNCH_BANKING';
    RecodeEvents.SHOWING_ERROR = 'RecodeEvents::SHOWING_ERROR';
    RecodeEvents.CLOSED_ERROR_DIALOG = 'RecodeEvents::CLOSED_ERROR_DIALOG';
    // Events sent from client.
    RecodeEvents.VALIDATED_BET = 'RecodeEvents::VALIDATED_BET';
    RecodeEvents.VALIDATED_BET_DIALOG_SHOWN = 'RecodeEvents::VALIDATED_BET_DIALOG_SHOWN';
    RecodeEvents.VALIDATED_BET_COIN_SIZE_CHANGED = 'RecodeEvents::VALIDATED_BET_COIN_SIZE_CHANGED';
    return RecodeEvents;
}());
exports.RecodeEvents = RecodeEvents;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var pna = __webpack_require__(121);
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = __webpack_require__(99);
util.inherits = __webpack_require__(67);
/*</replacement>*/

var Readable = __webpack_require__(305);
var Writable = __webpack_require__(309);

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Module_1 = __webpack_require__(2);
var AutoplayMenuEvents_1 = __webpack_require__(33);
var StopAutoplayButtonEvents_1 = __webpack_require__(30);
var ReelsEvents_1 = __webpack_require__(4);
var FlowModuleEvents_1 = __webpack_require__(0);
var AutoplayHandlerEvents_1 = __webpack_require__(56);
var OrientationEvents_1 = __webpack_require__(257);
var FreeSpinsEvents_1 = __webpack_require__(6);
var AutoplayBasicState_1 = __webpack_require__(321);
var AutoplayInProgressState_1 = __webpack_require__(628);
var AutoplayPausedState_1 = __webpack_require__(630);
var MessagesAPI_1 = __webpack_require__(166);
var AutoplayFreeSpinsState_1 = __webpack_require__(631);
var MainMenuEvents_1 = __webpack_require__(44);
exports.UnregulatedMarketAutoplaySettings = {
    lossLimitRequired: false,
    winLimitRequired: false,
    singleWinLimitRequired: false,
    maxSpinsRequired: false,
    maxSpins: 500,
    autoplayEnabled: true,
};
exports.UKRegulatedMarketAutoplaySettings = {
    lossLimitRequired: true,
    winLimitRequired: false,
    singleWinLimitRequired: false,
    maxSpinsRequired: true,
    maxSpins: 100,
    autoplayEnabled: true,
};
var AutoplayHandlerModule = /** @class */ (function (_super) {
    __extends(AutoplayHandlerModule, _super);
    function AutoplayHandlerModule() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._canSpin = true;
        _this._isWinBigWin = false;
        _this._isWaitingForSpinToFinish = false;
        _this._autospinsLeft = 0;
        _this._winLimit = 0;
        _this._lossLimit = 0;
        _this._isWaitingForGameResume = true;
        _this._isWaitingForMainMenuClose = true;
        return _this;
    }
    AutoplayHandlerModule.prototype.enterFirstState = function () {
        this.gotoState(AutoplayHandlerModule.BASIC);
    };
    AutoplayHandlerModule.prototype.setupStates = function () {
        this.addState(new AutoplayBasicState_1.AutoplayBasicState(this, AutoplayHandlerModule.BASIC));
        this.addState(new AutoplayInProgressState_1.AutoplayInProgressState(this, AutoplayHandlerModule.IN_PROGRESS));
        this.addState(new AutoplayPausedState_1.AutoplayPausedState(this, AutoplayHandlerModule.PAUSED));
        this.addState(new AutoplayFreeSpinsState_1.AutoplayFreeSpinsState(this, AutoplayHandlerModule.IN_FREESPINS));
    };
    AutoplayHandlerModule.prototype.setupViews = function () { };
    AutoplayHandlerModule.prototype.setupEvents = function () {
        this.onCurrentStateHandle(AutoplayMenuEvents_1.AutoplayMenuEvents.ACCEPTED);
        this.onCurrentStateHandle(StopAutoplayButtonEvents_1.StopAutoplayButtonEvents.STOP_AUTOPLAY_BUTTON_CLICKED);
        this.onCurrentStateHandle(FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN);
        this.onCurrentStateHandle(FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
        this.onCurrentStateHandle(FlowModuleEvents_1.FlowModuleEvents.WON_BIG_WIN);
        this.onCurrentStateHandle(FlowModuleEvents_1.FlowModuleEvents.NO_WIN);
        this.onCurrentStateHandle(FlowModuleEvents_1.FlowModuleEvents.WON);
        this.on(MessagesAPI_1.MessagesAPI.AUTOPLAY_PAUSED, this.onAutoplayShouldBePaused);
        this.on(MessagesAPI_1.MessagesAPI.GAME_HARD_PAUSED, this.onAutoplayShouldBePaused);
        this.on(MessagesAPI_1.MessagesAPI.GAME_RESUMED, this.onAutoplayShouldBeResumed);
        this.on(MainMenuEvents_1.MainMenuEvents.MAIN_MENU_OPEN, this.onMainMenuOpened);
        this.on(MainMenuEvents_1.MainMenuEvents.MAIN_MENU_CLOSED, this.onMainMenuClosed);
        this.on(AutoplayMenuEvents_1.AutoplayMenuEvents.UPDATE_AUTOPLAY_VALUES, this.onAutoplayValuesUpdated);
        this.on(ReelsEvents_1.ReelsEvents.REELS_SPINNING_STARTED, this.onSpinStarted);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_INTRO_STARTED, this.onFreeSpinsStarted);
        this.on(OrientationEvents_1.OrientationEvents.ORIENTATION_CHANGED_TO_PORTRAIT, this.onOrientationChanged);
        this.on(OrientationEvents_1.OrientationEvents.ORIENTATION_CHANGED_TO_LANDSCAPE, this.onOrientationChanged);
    };
    AutoplayHandlerModule.prototype.startAutoplay = function (spinsLeft) {
        this._autospinsLeft = spinsLeft;
        this._startAutospins = spinsLeft;
        if (this._stopOnLossLimit) {
            if (this._lossBalanceLimit < 0) {
                this._lossBalanceLimit = 0;
            }
        }
        if (this._canSpin) {
            this._winAmount = 0;
            this.tryToStartAutoplay();
        }
        else {
            this._isWaitingForSpinToFinish = true;
        }
    };
    AutoplayHandlerModule.prototype.onAutoplayShouldBePaused = function (eventID) {
        this._isWaitingForGameResume = false;
        this.currentState.handle(eventID);
    };
    AutoplayHandlerModule.prototype.onAutoplayShouldBeResumed = function (eventID) {
        this._isWaitingForGameResume = true;
        this.currentState.handle(eventID);
    };
    AutoplayHandlerModule.prototype.onMainMenuOpened = function (eventID) {
        this._isWaitingForMainMenuClose = false;
        this.currentState.handle(eventID);
    };
    AutoplayHandlerModule.prototype.onMainMenuClosed = function (eventID) {
        this._isWaitingForMainMenuClose = true;
        this.currentState.handle(eventID);
    };
    AutoplayHandlerModule.prototype.isFreeSpinsStarted = function () {
        return this.logic.isFreeSpinsStarted;
    };
    AutoplayHandlerModule.prototype.onOrientationChanged = function () {
        this.stopAutoplayAndEmitRoundsFinished();
    };
    AutoplayHandlerModule.prototype.onFreeSpinsStarted = function () {
        this.stopAutoplayAndEmitRoundsFinished();
    };
    AutoplayHandlerModule.prototype.bigWinUpdate = function () {
        this._isWinBigWin = true;
        this._totalAutoplayWin += this.logic.getWin();
        this._winAmount = this.logic.getWin();
    };
    AutoplayHandlerModule.prototype.onAutoplayValuesUpdated = function (eventID, autoplayValues) {
        if (autoplayValues.singleWinLimit > 0) {
            this._stopOnSingleWinLimit = true;
            this._singleWinLimit = autoplayValues.singleWinLimit;
        }
        else {
            this._singleWinLimit = null;
            this._stopOnSingleWinLimit = false;
        }
        if (autoplayValues.winLimit > 0) {
            this._stopOnWinLimit = true;
            this._winLimit = autoplayValues.winLimit;
        }
        else {
            this._stopOnWinLimit = false;
            this._winLimit = null;
        }
        if (autoplayValues.lossLimit > 0) {
            this._stopOnLossLimit = true;
            this._lossLimit = autoplayValues.lossLimit;
            this._lossBalanceLimit = this._logic.currentBalance - this._lossLimit;
        }
        else {
            this._stopOnLossLimit = false;
            this._lossLimit = null;
            this._lossBalanceLimit = 0;
        }
        this._stopOnAutoplayWin = autoplayValues.stopAutoplayOnWin;
        this._totalAutoplayWin = 0;
    };
    AutoplayHandlerModule.prototype.winUpdate = function () {
        if (!this._isWinBigWin) {
            // the isWinBigWin check is done because gameflow is currently setup to emit BigWin -> CanSpin -> Win.
            this._totalAutoplayWin += this.logic.getWin();
            this._winAmount = this.logic.getWin();
        }
        else {
            this._isWinBigWin = false;
        }
    };
    AutoplayHandlerModule.prototype.stopAutoplayOnReachingLimits = function () {
        if (this.shouldStopOnAutoplayLimits()) {
            if (this.shouldStopOnSingleWinLimit()) {
                this.eventManager.emit(AutoplayHandlerEvents_1.AutoplayHandlerEvents.AUTOPLAY_STOPPED_ON_SINGLE_WIN_LIMIT);
            }
            else if (this.shouldStopOnTotalAutoplayWin()) {
                this.eventManager.emit(AutoplayHandlerEvents_1.AutoplayHandlerEvents.AUTOPLAY_STOPPED_ON_WIN_LIMIT);
            }
            else if (this.shouldStopOnLossBalanceLimit()) {
                this.eventManager.emit(AutoplayHandlerEvents_1.AutoplayHandlerEvents.AUTOPLAY_STOPPED_ON_LOSE_LIMIT);
            }
            this.stopAutoplayAndEmitRoundsFinished();
        }
    };
    AutoplayHandlerModule.prototype.stopAutoplayOnFreeSpinWin = function () {
        if (this.isFreeSpinsStarted()) {
            this.stopAutoplayAndEmitRoundsFinished();
        }
    };
    AutoplayHandlerModule.prototype.onSpinStarted = function () {
        this._canSpin = false;
    };
    AutoplayHandlerModule.prototype.tryToStartSpin = function () {
        this._canSpin = true;
        if (this.shouldStopOnAutoplayLimits()) {
            this.stopAutoplayOnReachingLimits();
        }
        else if (this.isFreeSpinsStarted()) {
            this.stopAutoplayOnFreeSpinWin();
        }
        else {
            if (this._isWaitingForSpinToFinish) {
                this._isWaitingForSpinToFinish = false;
                this.tryToStartAutoplay();
            }
            else {
                this.tryToStartAutoplay();
            }
        }
    };
    AutoplayHandlerModule.prototype.setCanSpin = function (canSpin) {
        this._canSpin = canSpin;
    };
    AutoplayHandlerModule.prototype.tryToStartAutoplay = function () {
        this.timeUtils.killTimer(this._currentTimer);
        this._currentTimer = this.timeUtils.createTimer(this.startAutoplaySpin.bind(this), AutoplayHandlerModule.BEFORE_SPIN_TIMER);
    };
    AutoplayHandlerModule.prototype.stopAutoplayAndEmitRoundsFinished = function () {
        this.stopAutoplay();
        this.eventManager.emit(AutoplayHandlerEvents_1.AutoplayHandlerEvents.AUTOPLAY_ROUNDS_FINISHED);
    };
    AutoplayHandlerModule.prototype.stopAutoplay = function () {
        this.timeUtils.killTimer(this._currentTimer);
        this.eventManager.emit(AutoplayHandlerEvents_1.AutoplayHandlerEvents.AUTOPLAY_STOPPED);
        this._isWaitingForSpinToFinish = false;
    };
    AutoplayHandlerModule.prototype.startAutoplaySpin = function () {
        this._autospinsLeft--;
        this.eventManager.emit(AutoplayHandlerEvents_1.AutoplayHandlerEvents.START_AUTOPLAY_SPIN, this._autospinsLeft, this._startAutospins);
    };
    AutoplayHandlerModule.prototype.shouldStopOnAutoplayLimits = function () {
        return this.shouldStopOnAutoplayWinLimits() || this.shouldStopOnAutoplaySpinOrLossLimits() || this.shouldStopOnSingleWinLimit();
    };
    AutoplayHandlerModule.prototype.shouldStopOnAutoplayWinLimits = function () {
        return (this._stopOnAutoplayWin && this._winAmount > 0) || this.shouldStopOnSingleWinLimit() || this.shouldStopOnTotalAutoplayWin();
    };
    AutoplayHandlerModule.prototype.shouldStopOnAutoplaySpinOrLossLimits = function () {
        return this.shouldStopOnAutoplaySpinsLeft() || this.shouldStopOnLossBalanceLimit();
    };
    AutoplayHandlerModule.prototype.shouldStopOnAutoplaySpinsLeft = function () {
        return this._autospinsLeft <= 0;
    };
    AutoplayHandlerModule.prototype.shouldStopOnLossBalanceLimit = function () {
        if (this._stopOnLossLimit) {
            return this.logic.currentBalance <= this._lossBalanceLimit;
        }
        return false;
    };
    AutoplayHandlerModule.prototype.shouldStopOnTotalAutoplayWin = function () {
        if (this._stopOnWinLimit) {
            return this._winLimit > 0 && this._totalAutoplayWin >= this._winLimit;
        }
        return false;
    };
    AutoplayHandlerModule.prototype.shouldStopOnSingleWinLimit = function () {
        if (this._stopOnSingleWinLimit) {
            return this._singleWinLimit > 0 && this._singleWinLimit <= this._winAmount;
        }
        return false;
    };
    Object.defineProperty(AutoplayHandlerModule.prototype, "isWaitingForGameResume", {
        get: function () {
            return this._isWaitingForGameResume;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutoplayHandlerModule.prototype, "isWaitingForMainMenuClose", {
        get: function () {
            return this._isWaitingForMainMenuClose;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutoplayHandlerModule.prototype, "requiredSettings", {
        get: function () {
            return this._requiredSettings;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutoplayHandlerModule.prototype, "autospinsLeft", {
        set: function (value) {
            this._autospinsLeft = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutoplayHandlerModule.prototype, "startAutospins", {
        set: function (value) {
            this._startAutospins = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutoplayHandlerModule.prototype, "canSpin", {
        get: function () {
            return this._canSpin;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutoplayHandlerModule.prototype, "winAmount", {
        set: function (value) {
            this._winAmount = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutoplayHandlerModule.prototype, "isWaitingForSpinToFinish", {
        set: function (value) {
            this._isWaitingForSpinToFinish = value;
        },
        enumerable: true,
        configurable: true
    });
    AutoplayHandlerModule.BASIC = 'basic';
    AutoplayHandlerModule.IN_PROGRESS = 'inprogress';
    AutoplayHandlerModule.PAUSED = 'paused';
    AutoplayHandlerModule.IN_FREESPINS = 'in_freespins';
    AutoplayHandlerModule.BEFORE_SPIN_TIMER = 250;
    return AutoplayHandlerModule;
}(Module_1.Module));
exports.AutoplayHandlerModule = AutoplayHandlerModule;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Module_1 = __webpack_require__(2);
var Views_1 = __webpack_require__(8);
var LogicEvents_1 = __webpack_require__(11);
var AutoplayHandlerEvents_1 = __webpack_require__(56);
var BonusGameEvents_1 = __webpack_require__(78);
var FlowModuleEvents_1 = __webpack_require__(0);
var FreeSpinsEvents_1 = __webpack_require__(6);
var SpinButtonEvents_1 = __webpack_require__(12);
var SpinButtonView_1 = __webpack_require__(254);
var SpinButtonViewEvents_1 = __webpack_require__(111);
var SpinButtonBasicState_1 = __webpack_require__(324);
var SpinButtonFreeSpinsIntoState_1 = __webpack_require__(640);
var SpinButtonFreeSpinsState_1 = __webpack_require__(325);
var SpinButtonWhileSpinningState_1 = __webpack_require__(326);
var StopAutoplayButtonEvents_1 = __webpack_require__(30);
var SettingsEvents_1 = __webpack_require__(95);
var AutoplayMenuEvents_1 = __webpack_require__(33);
var BetlevelMenuEvents_1 = __webpack_require__(48);
var InfoPopupEvents_1 = __webpack_require__(63);
var ReelsEvents_1 = __webpack_require__(4);
var StartScreenEvents_1 = __webpack_require__(22);
var SwipeInteractionEvents_1 = __webpack_require__(65);
var Timer_1 = __webpack_require__(28);
var SpinButtonModule = /** @class */ (function (_super) {
    __extends(SpinButtonModule, _super);
    function SpinButtonModule() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._spaceRunsSpin = true;
        _this._canSpin = true;
        _this._canSwipeSpin = true;
        _this._isInAutoplay = false;
        _this._hasQuickstop = false;
        _this._isKeyboardInputEnabled = true;
        _this._isInFreeSpins = false;
        _this._autoplayMenuOpen = false;
        _this._infoPopupOpen = false;
        _this._hasSpinResponse = false;
        _this._spinTimeRegulation = 0;
        _this._regulationCanSpin = true;
        _this._canSpinBySpinButton = true;
        return _this;
    }
    SpinButtonModule.prototype.afterInit = function () {
        _super.prototype.afterInit.call(this);
        this.view.hideSpinButton();
        this._hasQuickstop = true;
    };
    SpinButtonModule.prototype.init = function () {
        _super.prototype.init.call(this);
        this.setupCertificationSettings();
    };
    SpinButtonModule.prototype.hasSpinTimeRegulation = function () {
        return this._spinTimeRegulation !== 0;
    };
    SpinButtonModule.prototype.startRegulationSpinTimer = function () {
        var _this = this;
        this.eventManager.emit(SpinButtonEvents_1.SpinButtonEvents.REGULATION_SPIN_DELAY_STARTED);
        this._regulationSpinTimer = new Timer_1.Timer(function () {
            _this._regulationCanSpin = true;
            _this.eventManager.emit(SpinButtonEvents_1.SpinButtonEvents.REGULATION_SPIN_DELAY_PASSED);
        }, this._spinTimeRegulation * 1.1, true);
        this.updateManager.add(this._regulationSpinTimer);
    };
    SpinButtonModule.prototype.setSpinStarted = function () {
        this.canSpin = false;
    };
    SpinButtonModule.prototype.setupCertificationSettings = function () {
        this._spinTimeRegulation = 0;
    };
    SpinButtonModule.prototype.validateSpaceSpinPress = function () {
        return this._spaceRunsSpin;
    };
    SpinButtonModule.prototype.validateSpinPress = function () {
        return this.canSpin && !this._isInAutoplay && !this._isInFreeSpins && this.view.isVisible();
    };
    SpinButtonModule.prototype.validateQuickStop = function () {
        return this.hasQuickstop && !this.canSpin && this._hasSpinResponse;
    };
    SpinButtonModule.prototype.validateAutoplaySpinPress = function () {
        return this.canSpin && this._isInAutoplay && !this._isInFreeSpins;
    };
    SpinButtonModule.prototype.userHasEnougMoneyToSpin = function () {
        return this.logic.isEnoughMoneyForSpin();
    };
    SpinButtonModule.prototype.restore = function () {
        _super.prototype.restore.call(this);
        this.canSpin = false;
        this.view.disableSpinButton();
        if (this.logic.isFreeSpinsStarted) {
            if (this.logic.freeSpinsLeft === this.logic.freespinsTotalAwarded) {
                this.gotoState(SpinButtonModule.FREE_SPINS_INTRO_STATE);
            }
            else {
                this.gotoState(SpinButtonModule.FREE_SPINS_STATE);
            }
        }
    };
    SpinButtonModule.prototype.setupViews = function () {
        if (this.system.shouldUseMultipleViews()) {
            this.setView(Views_1.Views.SPIN_BUTTON_VIEW_MOBILE);
        }
        else {
            this.setView(Views_1.Views.SPIN_BUTTON_VIEW);
        }
    };
    SpinButtonModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.onCurrentStateHandle(ReelsEvents_1.ReelsEvents.SPIN_ENDED);
        this.on(ReelsEvents_1.ReelsEvents.REELS_SPINNING_STARTED, this.onReelsSpinningStarted);
        this.onCurrentStateHandle(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_OUTRO_FINISHED);
        this.onCurrentStateHandle(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_INTRO_FINISHED);
        this.onCurrentStateHandle(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPIN_STARTED);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPIN_STARTED, this.onFreeSpinFlowStarted);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_CONTINUE_CLICKED, this.onFreeSpinsIntroContinueClicked);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_INTRO_FINISHED, this.onFreeSpinsIntroFinished);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_INTRO_STARTED, this.onFreeSpinsIntroStarted);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_OUTRO_FINISHED, this.onFreeSpinsOutroFinished);
        this.onCurrentStateHandle(FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN);
        this.on(FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN, this.onFreeSpinsWin);
        this.on(FlowModuleEvents_1.FlowModuleEvents.RESPIN_WON, this.onRespinWon);
        this.on(FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_START, this.onBonusGameStarted);
        this.on(FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_RESTORED, this.onBonusGameRestored);
        this.on(BonusGameEvents_1.BonusGameEvents.BONUS_OUTRO_FINISHED, this.onBonusOutroFinished);
        this.on(LogicEvents_1.LogicEvents.SPIN_RESPONSE, this.onSpinResponse);
        this.on(SwipeInteractionEvents_1.SwipeInteractionEvents.START_SPIN, this.onSwipeSpinStarted);
        this.on(SettingsEvents_1.SettingsEvents.TOGGLE_SPACEBAR_ON, this.onSpacebarOn);
        this.on(SettingsEvents_1.SettingsEvents.TOGGLE_SPACEBAR_OFF, this.onSpacebarOff);
        this.on(StartScreenEvents_1.StartScreenEvents.INTRO_STARTED, this.onIntroStarted);
        this.on(StartScreenEvents_1.StartScreenEvents.EXIT_FINISHED, this.onIntroFinished);
        this.on(BetlevelMenuEvents_1.BetlevelMenuEvents.BET_LEVEL_MENU_CLOSED, this.onBetLevelMenuClosed);
        this.on(BetlevelMenuEvents_1.BetlevelMenuEvents.BET_LEVEL_MENU_OPENED, this.onBetLevelMenuOpened);
        this.on(AutoplayMenuEvents_1.AutoplayMenuEvents.ACCEPTED, this.onStartAutoplay);
        this.on(AutoplayMenuEvents_1.AutoplayMenuEvents.AUTO_PLAY_MENU_CLOSED, this.onAutoPlayMenuClosed);
        this.on(AutoplayMenuEvents_1.AutoplayMenuEvents.AUTO_PLAY_MENU_OPENED, this.onAutoPlayMenuOpened);
        this.on(AutoplayHandlerEvents_1.AutoplayHandlerEvents.START_AUTOPLAY_SPIN, this.onAutoplaySpinStarted);
        this.on(InfoPopupEvents_1.InfoPopupEvents.INFO_POPUP_CLOSED, this.onInfoPopupClosed);
        this.on(InfoPopupEvents_1.InfoPopupEvents.INFO_POPUP_OPENED, this.onInfoPopupOpened);
        this.on(StopAutoplayButtonEvents_1.StopAutoplayButtonEvents.STOP_AUTOPLAY_BUTTON_CLICKED, this.onAutoplayStopClicked);
        this.on(SpinButtonEvents_1.SpinButtonEvents.DISABLE_SPIN_BY_SPIN, this.onDisableSpinBySpin);
        this.on(SpinButtonEvents_1.SpinButtonEvents.ENABLE_SPIN_BY_SPIN, this.onEnableSpinBySpin);
        this.onView(SpinButtonViewEvents_1.SpinButtonViewEvents.SPIN_BUTTON_CLICKED, this.onSpinButtonClicked);
        this.onViewEmitEvent(SpinButtonView_1.SpinButtonView.SPIN_BUTTON_BECOMING_VISIBLE_AND_ENABLED, SpinButtonEvents_1.SpinButtonEvents.SPIN_BUTTON_BECOMING_VISIBLE_AND_ENABLED);
        this.onCurrentStateHandle(FlowModuleEvents_1.FlowModuleEvents.CAN_CONTINUE_SPIN);
        this.onCurrentStateHandle(SpinButtonEvents_1.SpinButtonEvents.REGULATION_SPIN_DELAY_PASSED);
        this.logic.spacebarSpinActive ? this.onSpacebarOn() : this.onSpacebarOff();
    };
    SpinButtonModule.prototype.onDisableSpinBySpin = function () {
        this.view.enableSpinButton(false);
        this._canSpinBySpinButton = false;
    };
    SpinButtonModule.prototype.onEnableSpinBySpin = function () {
        this._canSpinBySpinButton = true;
    };
    SpinButtonModule.prototype.onFreeSpinsWin = function () {
        this._isInFreeSpins = true;
    };
    SpinButtonModule.prototype.onRespinWon = function () {
        this.view.disableSpinButton();
    };
    SpinButtonModule.prototype.onFreeSpinsIntroFinished = function () {
        this.gotoState(SpinButtonModule.FREE_SPINS_STATE);
    };
    SpinButtonModule.prototype.onFreeSpinsIntroStarted = function () {
        this.view.hideSpinButton();
    };
    SpinButtonModule.prototype.onFreeSpinsOutroFinished = function () {
        this.view.showSpinButton();
        this.view.enableSpinButton();
        this.canSpin = true;
        this._isInFreeSpins = false;
    };
    SpinButtonModule.prototype.onInfoPopupOpened = function () {
        this._infoPopupOpen = true;
        this._isKeyboardInputEnabled = false;
    };
    SpinButtonModule.prototype.onInfoPopupClosed = function (eventID, infoType) {
        this._infoPopupOpen = false;
        this.tryEnableKeyboardInput();
    };
    SpinButtonModule.prototype.tryEnableKeyboardInput = function () {
        if (!this._infoPopupOpen && !this._autoplayMenuOpen) {
            this._isKeyboardInputEnabled = true;
        }
    };
    SpinButtonModule.prototype.addKeyboardInput = function () {
        this.removeKeyboardInput();
        this._inputFunction = this.keyboardInput.bind(this);
        document.addEventListener('keydown', this._inputFunction);
    };
    SpinButtonModule.prototype.removeKeyboardInput = function () {
        document.removeEventListener('keydown', this._inputFunction);
    };
    SpinButtonModule.prototype.keyboardInput = function (event) {
        if (!this._isKeyboardInputEnabled) {
            return;
        }
        if (event.code === 'Space' || event.keyCode === 32) {
            if (this.validateSpaceSpinPress()) {
                this.eventManager.emit(SpinButtonEvents_1.SpinButtonEvents.SPACE_BUTTON_CLICKED);
                this.currentState.handle(SpinButtonEvents_1.SpinButtonEvents.SPACE_BUTTON_CLICKED);
            }
        }
    };
    SpinButtonModule.prototype.onBetLevelMenuOpened = function () {
        this._isKeyboardInputEnabled = false;
    };
    SpinButtonModule.prototype.onBetLevelMenuClosed = function () {
        this.tryEnableKeyboardInput();
    };
    SpinButtonModule.prototype.onAutoPlayMenuClosed = function () {
        this._autoplayMenuOpen = false;
        this.tryEnableKeyboardInput();
    };
    SpinButtonModule.prototype.onAutoPlayMenuOpened = function () {
        this._autoplayMenuOpen = true;
        this._isKeyboardInputEnabled = false;
    };
    SpinButtonModule.prototype.onIntroStarted = function () {
        this.canSpin = false;
    };
    SpinButtonModule.prototype.onIntroFinished = function () {
        if (!this.device.isMobile) {
            this.addKeyboardInput();
        }
        this.canSpin = true;
        this.onCurrentStateHandle(StartScreenEvents_1.StartScreenEvents.EXIT_FINISHED);
    };
    SpinButtonModule.prototype.onSpacebarOn = function () {
        this._spaceRunsSpin = true;
    };
    SpinButtonModule.prototype.onSpacebarOff = function () {
        this._spaceRunsSpin = false;
    };
    SpinButtonModule.prototype.setupStates = function () {
        this.addState(new SpinButtonBasicState_1.SpinButtonBasicState(this, SpinButtonModule.BASIC_STATE));
        this.addState(new SpinButtonFreeSpinsState_1.SpinButtonFreeSpinsState(this, SpinButtonModule.FREE_SPINS_STATE));
        this.addState(new SpinButtonWhileSpinningState_1.SpinButtonWhileSpinningState(this, SpinButtonModule.REELS_SPINNING_STATE));
        this.addState(new SpinButtonFreeSpinsIntoState_1.SpinButtonFreeSpinsIntoState(this, SpinButtonModule.FREE_SPINS_INTRO_STATE));
    };
    SpinButtonModule.prototype.onAutoplayStopClicked = function () {
        this.eventManager.emit(SpinButtonEvents_1.SpinButtonEvents.STOP_AUTOPLAY_BUTTON_PRESSED);
        if (this.logic.freeSpinsLeft <= 0) {
            this.view.uninitAutoplay();
        }
        this._isInAutoplay = false;
    };
    SpinButtonModule.prototype.onStartAutoplay = function () {
        this.view.initAutoplay();
        this._isInAutoplay = true;
    };
    SpinButtonModule.prototype.onBonusGameStarted = function () {
        this.view.disableSpinButton();
        this.view.hide();
    };
    SpinButtonModule.prototype.onBonusGameRestored = function () {
        this.view.hide();
    };
    SpinButtonModule.prototype.onBonusOutroFinished = function () {
        this.view.show();
    };
    SpinButtonModule.prototype.enterFirstState = function () {
        this.changeStateTo(SpinButtonModule.BASIC_STATE);
    };
    SpinButtonModule.prototype.onSpinButtonClicked = function () {
        this.eventManager.emit(SpinButtonEvents_1.SpinButtonEvents.SPIN_BUTTON_PHYSICALLY_CLICKED);
        this.handleSpinButtonClick();
    };
    SpinButtonModule.prototype.handleSpinButtonClick = function () {
        if (!this._canSpinBySpinButton) {
            this.eventManager.emit(SpinButtonEvents_1.SpinButtonEvents.SKIP_BY_SPIN_BUTTON_PRESSED);
            this.view.disableSpinButton();
        }
        else {
            this.currentState.handle(SpinButtonViewEvents_1.SpinButtonViewEvents.SPIN_BUTTON_CLICKED);
        }
    };
    SpinButtonModule.prototype.onAutoplaySpinStarted = function () {
        this.eventManager.emit(SpinButtonEvents_1.SpinButtonEvents.START_AUTOPLAY_BUTTON_PRESSED);
        this.currentState.handle(SpinButtonEvents_1.SpinButtonEvents.START_AUTOPLAY_BUTTON_PRESSED);
    };
    SpinButtonModule.prototype.onSwipeSpinStarted = function () {
        if (!this._isInAutoplay && this.canSpin) {
            this.handleSpinButtonClick();
        }
    };
    SpinButtonModule.prototype.onFreeSpinFlowStarted = function () {
        if (this.canSpin && this.logic.isFreeSpinsStarted) {
            this.handleSpinButtonClick();
        }
    };
    SpinButtonModule.prototype.onFreeSpinsIntroContinueClicked = function () {
        this.view.hide();
    };
    SpinButtonModule.prototype.onReelsSpinningStarted = function () {
        this._hasSpinResponse = false;
        this.currentState.handle(ReelsEvents_1.ReelsEvents.REELS_SPINNING_STARTED);
    };
    SpinButtonModule.prototype.onSpinResponse = function () {
        this._hasSpinResponse = true;
        this.currentState.handle(LogicEvents_1.LogicEvents.SPIN_RESPONSE);
    };
    Object.defineProperty(SpinButtonModule.prototype, "canSpin", {
        get: function () {
            return this._canSpin;
        },
        set: function (v) {
            this._canSpin = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpinButtonModule.prototype, "hasQuickstop", {
        get: function () {
            return this._hasQuickstop;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpinButtonModule.prototype, "hasSpinResponse", {
        get: function () {
            return this._hasSpinResponse;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpinButtonModule.prototype, "regulationCanSpin", {
        get: function () {
            return this._regulationCanSpin;
        },
        set: function (value) {
            this._regulationCanSpin = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpinButtonModule.prototype, "isInAutoplay", {
        get: function () {
            return this._isInAutoplay;
        },
        enumerable: true,
        configurable: true
    });
    SpinButtonModule.BASIC_STATE = 'basic';
    SpinButtonModule.REELS_SPINNING_STATE = 'spinning';
    SpinButtonModule.FREE_SPINS_STATE = 'freespins';
    SpinButtonModule.FREE_SPINS_INTRO_STATE = 'freespinsintro';
    return SpinButtonModule;
}(Module_1.Module));
exports.SpinButtonModule = SpinButtonModule;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(9);

var _DisplayObject2 = __webpack_require__(181);

var _DisplayObject3 = _interopRequireDefault(_DisplayObject2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * A Container represents a collection of display objects.
 * It is the base class of all display objects that act as a container for other objects.
 *
 *```js
 * let container = new PIXI.Container();
 * container.addChild(sprite);
 * ```
 *
 * @class
 * @extends PIXI.DisplayObject
 * @memberof PIXI
 */
var Container = function (_DisplayObject) {
    _inherits(Container, _DisplayObject);

    /**
     *
     */
    function Container() {
        _classCallCheck(this, Container);

        /**
         * The array of children of this container.
         *
         * @member {PIXI.DisplayObject[]}
         * @readonly
         */
        var _this = _possibleConstructorReturn(this, _DisplayObject.call(this));

        _this.children = [];
        return _this;
    }

    /**
     * Overridable method that can be used by Container subclasses whenever the children array is modified
     *
     * @private
     */


    Container.prototype.onChildrenChange = function onChildrenChange() {}
    /* empty */


    /**
     * Adds one or more children to the container.
     *
     * Multiple items can be added like so: `myContainer.addChild(thingOne, thingTwo, thingThree)`
     *
     * @param {...PIXI.DisplayObject} child - The DisplayObject(s) to add to the container
     * @return {PIXI.DisplayObject} The first child that was added.
     */
    ;

    Container.prototype.addChild = function addChild(child) {
        var argumentsLength = arguments.length;

        // if there is only one argument we can bypass looping through the them
        if (argumentsLength > 1) {
            // loop through the arguments property and add all children
            // use it the right way (.length and [i]) so that this function can still be optimised by JS runtimes
            for (var i = 0; i < argumentsLength; i++) {
                this.addChild(arguments[i]);
            }
        } else {
            // if the child has a parent then lets remove it as PixiJS objects can only exist in one place
            if (child.parent) {
                child.parent.removeChild(child);
            }

            child.parent = this;
            // ensure child transform will be recalculated
            child.transform._parentID = -1;

            this.children.push(child);

            // ensure bounds will be recalculated
            this._boundsID++;

            // TODO - lets either do all callbacks or all events.. not both!
            this.onChildrenChange(this.children.length - 1);
            child.emit('added', this);
        }

        return child;
    };

    /**
     * Adds a child to the container at a specified index. If the index is out of bounds an error will be thrown
     *
     * @param {PIXI.DisplayObject} child - The child to add
     * @param {number} index - The index to place the child in
     * @return {PIXI.DisplayObject} The child that was added.
     */


    Container.prototype.addChildAt = function addChildAt(child, index) {
        if (index < 0 || index > this.children.length) {
            throw new Error(child + 'addChildAt: The index ' + index + ' supplied is out of bounds ' + this.children.length);
        }

        if (child.parent) {
            child.parent.removeChild(child);
        }

        child.parent = this;
        // ensure child transform will be recalculated
        child.transform._parentID = -1;

        this.children.splice(index, 0, child);

        // ensure bounds will be recalculated
        this._boundsID++;

        // TODO - lets either do all callbacks or all events.. not both!
        this.onChildrenChange(index);
        child.emit('added', this);

        return child;
    };

    /**
     * Swaps the position of 2 Display Objects within this container.
     *
     * @param {PIXI.DisplayObject} child - First display object to swap
     * @param {PIXI.DisplayObject} child2 - Second display object to swap
     */


    Container.prototype.swapChildren = function swapChildren(child, child2) {
        if (child === child2) {
            return;
        }

        var index1 = this.getChildIndex(child);
        var index2 = this.getChildIndex(child2);

        this.children[index1] = child2;
        this.children[index2] = child;
        this.onChildrenChange(index1 < index2 ? index1 : index2);
    };

    /**
     * Returns the index position of a child DisplayObject instance
     *
     * @param {PIXI.DisplayObject} child - The DisplayObject instance to identify
     * @return {number} The index position of the child display object to identify
     */


    Container.prototype.getChildIndex = function getChildIndex(child) {
        var index = this.children.indexOf(child);

        if (index === -1) {
            throw new Error('The supplied DisplayObject must be a child of the caller');
        }

        return index;
    };

    /**
     * Changes the position of an existing child in the display object container
     *
     * @param {PIXI.DisplayObject} child - The child DisplayObject instance for which you want to change the index number
     * @param {number} index - The resulting index number for the child display object
     */


    Container.prototype.setChildIndex = function setChildIndex(child, index) {
        if (index < 0 || index >= this.children.length) {
            throw new Error('The index ' + index + ' supplied is out of bounds ' + this.children.length);
        }

        var currentIndex = this.getChildIndex(child);

        (0, _utils.removeItems)(this.children, currentIndex, 1); // remove from old position
        this.children.splice(index, 0, child); // add at new position

        this.onChildrenChange(index);
    };

    /**
     * Returns the child at the specified index
     *
     * @param {number} index - The index to get the child at
     * @return {PIXI.DisplayObject} The child at the given index, if any.
     */


    Container.prototype.getChildAt = function getChildAt(index) {
        if (index < 0 || index >= this.children.length) {
            throw new Error('getChildAt: Index (' + index + ') does not exist.');
        }

        return this.children[index];
    };

    /**
     * Removes one or more children from the container.
     *
     * @param {...PIXI.DisplayObject} child - The DisplayObject(s) to remove
     * @return {PIXI.DisplayObject} The first child that was removed.
     */


    Container.prototype.removeChild = function removeChild(child) {
        var argumentsLength = arguments.length;

        // if there is only one argument we can bypass looping through the them
        if (argumentsLength > 1) {
            // loop through the arguments property and add all children
            // use it the right way (.length and [i]) so that this function can still be optimised by JS runtimes
            for (var i = 0; i < argumentsLength; i++) {
                this.removeChild(arguments[i]);
            }
        } else {
            var index = this.children.indexOf(child);

            if (index === -1) return null;

            child.parent = null;
            // ensure child transform will be recalculated
            child.transform._parentID = -1;
            (0, _utils.removeItems)(this.children, index, 1);

            // ensure bounds will be recalculated
            this._boundsID++;

            // TODO - lets either do all callbacks or all events.. not both!
            this.onChildrenChange(index);
            child.emit('removed', this);
        }

        return child;
    };

    /**
     * Removes a child from the specified index position.
     *
     * @param {number} index - The index to get the child from
     * @return {PIXI.DisplayObject} The child that was removed.
     */


    Container.prototype.removeChildAt = function removeChildAt(index) {
        var child = this.getChildAt(index);

        // ensure child transform will be recalculated..
        child.parent = null;
        child.transform._parentID = -1;
        (0, _utils.removeItems)(this.children, index, 1);

        // ensure bounds will be recalculated
        this._boundsID++;

        // TODO - lets either do all callbacks or all events.. not both!
        this.onChildrenChange(index);
        child.emit('removed', this);

        return child;
    };

    /**
     * Removes all children from this container that are within the begin and end indexes.
     *
     * @param {number} [beginIndex=0] - The beginning position.
     * @param {number} [endIndex=this.children.length] - The ending position. Default value is size of the container.
     * @returns {DisplayObject[]} List of removed children
     */


    Container.prototype.removeChildren = function removeChildren() {
        var beginIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var endIndex = arguments[1];

        var begin = beginIndex;
        var end = typeof endIndex === 'number' ? endIndex : this.children.length;
        var range = end - begin;
        var removed = void 0;

        if (range > 0 && range <= end) {
            removed = this.children.splice(begin, range);

            for (var i = 0; i < removed.length; ++i) {
                removed[i].parent = null;
                if (removed[i].transform) {
                    removed[i].transform._parentID = -1;
                }
            }

            this._boundsID++;

            this.onChildrenChange(beginIndex);

            for (var _i = 0; _i < removed.length; ++_i) {
                removed[_i].emit('removed', this);
            }

            return removed;
        } else if (range === 0 && this.children.length === 0) {
            return [];
        }

        throw new RangeError('removeChildren: numeric values are outside the acceptable range.');
    };

    /**
     * Updates the transform on all children of this container for rendering
     */


    Container.prototype.updateTransform = function updateTransform() {
        this._boundsID++;

        this.transform.updateTransform(this.parent.transform);

        // TODO: check render flags, how to process stuff here
        this.worldAlpha = this.alpha * this.parent.worldAlpha;

        for (var i = 0, j = this.children.length; i < j; ++i) {
            var child = this.children[i];

            if (child.visible) {
                child.updateTransform();
            }
        }
    };

    /**
     * Recalculates the bounds of the container.
     *
     */


    Container.prototype.calculateBounds = function calculateBounds() {
        this._bounds.clear();

        this._calculateBounds();

        for (var i = 0; i < this.children.length; i++) {
            var child = this.children[i];

            if (!child.visible || !child.renderable) {
                continue;
            }

            child.calculateBounds();

            // TODO: filter+mask, need to mask both somehow
            if (child._mask) {
                child._mask.calculateBounds();
                this._bounds.addBoundsMask(child._bounds, child._mask._bounds);
            } else if (child.filterArea) {
                this._bounds.addBoundsArea(child._bounds, child.filterArea);
            } else {
                this._bounds.addBounds(child._bounds);
            }
        }

        this._lastBoundsID = this._boundsID;
    };

    /**
     * Recalculates the bounds of the object. Override this to
     * calculate the bounds of the specific object (not including children).
     *
     */


    Container.prototype._calculateBounds = function _calculateBounds() {}
    // FILL IN//


    /**
     * Renders the object using the WebGL renderer
     *
     * @param {PIXI.WebGLRenderer} renderer - The renderer
     */
    ;

    Container.prototype.renderWebGL = function renderWebGL(renderer) {
        // if the object is not visible or the alpha is 0 then no need to render this element
        if (!this.visible || this.worldAlpha <= 0 || !this.renderable) {
            return;
        }

        // do a quick check to see if this element has a mask or a filter.
        if (this._mask || this.filters && this.filters.length) {
            this.renderAdvancedWebGL(renderer);
        } else {
            this._renderWebGL(renderer);

            // simple render children!
            for (var i = 0, j = this.children.length; i < j; ++i) {
                this.children[i].renderWebGL(renderer);
            }
        }
    };

    /**
     * Render the object using the WebGL renderer and advanced features.
     *
     * @private
     * @param {PIXI.WebGLRenderer} renderer - The renderer
     */


    Container.prototype.renderAdvancedWebGL = function renderAdvancedWebGL(renderer) {
        renderer.flush();

        var filters = this._filters;
        var mask = this._mask;

        // push filter first as we need to ensure the stencil buffer is correct for any masking
        if (filters) {
            if (!this._enabledFilters) {
                this._enabledFilters = [];
            }

            this._enabledFilters.length = 0;

            for (var i = 0; i < filters.length; i++) {
                if (filters[i].enabled) {
                    this._enabledFilters.push(filters[i]);
                }
            }

            if (this._enabledFilters.length) {
                renderer.filterManager.pushFilter(this, this._enabledFilters);
            }
        }

        if (mask) {
            renderer.maskManager.pushMask(this, this._mask);
        }

        // add this object to the batch, only rendered if it has a texture.
        this._renderWebGL(renderer);

        // now loop through the children and make sure they get rendered
        for (var _i2 = 0, j = this.children.length; _i2 < j; _i2++) {
            this.children[_i2].renderWebGL(renderer);
        }

        renderer.flush();

        if (mask) {
            renderer.maskManager.popMask(this, this._mask);
        }

        if (filters && this._enabledFilters && this._enabledFilters.length) {
            renderer.filterManager.popFilter();
        }
    };

    /**
     * To be overridden by the subclasses.
     *
     * @private
     * @param {PIXI.WebGLRenderer} renderer - The renderer
     */


    Container.prototype._renderWebGL = function _renderWebGL(renderer) // eslint-disable-line no-unused-vars
    {}
    // this is where content itself gets rendered...


    /**
     * To be overridden by the subclass
     *
     * @private
     * @param {PIXI.CanvasRenderer} renderer - The renderer
     */
    ;

    Container.prototype._renderCanvas = function _renderCanvas(renderer) // eslint-disable-line no-unused-vars
    {}
    // this is where content itself gets rendered...


    /**
     * Renders the object using the Canvas renderer
     *
     * @param {PIXI.CanvasRenderer} renderer - The renderer
     */
    ;

    Container.prototype.renderCanvas = function renderCanvas(renderer) {
        // if not visible or the alpha is 0 then no need to render this
        if (!this.visible || this.worldAlpha <= 0 || !this.renderable) {
            return;
        }

        if (this._mask) {
            renderer.maskManager.pushMask(this._mask);
        }

        this._renderCanvas(renderer);
        for (var i = 0, j = this.children.length; i < j; ++i) {
            this.children[i].renderCanvas(renderer);
        }

        if (this._mask) {
            renderer.maskManager.popMask(renderer);
        }
    };

    /**
     * Removes all internal references and listeners as well as removes children from the display list.
     * Do not use a Container after calling `destroy`.
     *
     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
     *  have been set to that value
     * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
     *  method called as well. 'options' will be passed on to those calls.
     * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
     *  Should it destroy the texture of the child sprite
     * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
     *  Should it destroy the base texture of the child sprite
     */


    Container.prototype.destroy = function destroy(options) {
        _DisplayObject.prototype.destroy.call(this);

        var destroyChildren = typeof options === 'boolean' ? options : options && options.children;

        var oldChildren = this.removeChildren(0, this.children.length);

        if (destroyChildren) {
            for (var i = 0; i < oldChildren.length; ++i) {
                oldChildren[i].destroy(options);
            }
        }
    };

    /**
     * The width of the Container, setting this will actually modify the scale to achieve the value set
     *
     * @member {number}
     */


    _createClass(Container, [{
        key: 'width',
        get: function get() {
            return this.scale.x * this.getLocalBounds().width;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            var width = this.getLocalBounds().width;

            if (width !== 0) {
                this.scale.x = value / width;
            } else {
                this.scale.x = 1;
            }

            this._width = value;
        }

        /**
         * The height of the Container, setting this will actually modify the scale to achieve the value set
         *
         * @member {number}
         */

    }, {
        key: 'height',
        get: function get() {
            return this.scale.y * this.getLocalBounds().height;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            var height = this.getLocalBounds().height;

            if (height !== 0) {
                this.scale.y = value / height;
            } else {
                this.scale.y = 1;
            }

            this._height = value;
        }
    }]);

    return Container;
}(_DisplayObject3.default);

// performance increase to avoid using call.. (10x faster)


exports.default = Container;
Container.prototype.containerUpdateTransform = Container.prototype.updateTransform;
//# sourceMappingURL=Container.js.map

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _SystemRenderer2 = __webpack_require__(187);

var _SystemRenderer3 = _interopRequireDefault(_SystemRenderer2);

var _CanvasMaskManager = __webpack_require__(369);

var _CanvasMaskManager2 = _interopRequireDefault(_CanvasMaskManager);

var _CanvasRenderTarget = __webpack_require__(189);

var _CanvasRenderTarget2 = _interopRequireDefault(_CanvasRenderTarget);

var _mapCanvasBlendModesToPixi = __webpack_require__(370);

var _mapCanvasBlendModesToPixi2 = _interopRequireDefault(_mapCanvasBlendModesToPixi);

var _utils = __webpack_require__(9);

var _const = __webpack_require__(5);

var _settings = __webpack_require__(17);

var _settings2 = _interopRequireDefault(_settings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The CanvasRenderer draws the scene and all its content onto a 2d canvas. This renderer should
 * be used for browsers that do not support WebGL. Don't forget to add the CanvasRenderer.view to
 * your DOM or you will not see anything :)
 *
 * @class
 * @memberof PIXI
 * @extends PIXI.SystemRenderer
 */
var CanvasRenderer = function (_SystemRenderer) {
    _inherits(CanvasRenderer, _SystemRenderer);

    // eslint-disable-next-line valid-jsdoc
    /**
     * @param {object} [options] - The optional renderer parameters
     * @param {number} [options.width=800] - the width of the screen
     * @param {number} [options.height=600] - the height of the screen
     * @param {HTMLCanvasElement} [options.view] - the canvas to use as a view, optional
     * @param {boolean} [options.transparent=false] - If the render view is transparent, default false
     * @param {boolean} [options.autoResize=false] - If the render view is automatically resized, default false
     * @param {boolean} [options.antialias=false] - sets antialias (only applicable in chrome at the moment)
     * @param {number} [options.resolution=1] - The resolution / device pixel ratio of the renderer. The
     *  resolution of the renderer retina would be 2.
     * @param {boolean} [options.preserveDrawingBuffer=false] - enables drawing buffer preservation,
     *  enable this if you need to call toDataUrl on the webgl context.
     * @param {boolean} [options.clearBeforeRender=true] - This sets if the renderer will clear the canvas or
     *      not before the new render pass.
     * @param {number} [options.backgroundColor=0x000000] - The background color of the rendered area
     *  (shown if not transparent).
     * @param {boolean} [options.roundPixels=false] - If true PixiJS will Math.floor() x/y values when rendering,
     *  stopping pixel interpolation.
     */
    function CanvasRenderer(options, arg2, arg3) {
        _classCallCheck(this, CanvasRenderer);

        var _this = _possibleConstructorReturn(this, _SystemRenderer.call(this, 'Canvas', options, arg2, arg3));

        _this.type = _const.RENDERER_TYPE.CANVAS;

        /**
         * The root canvas 2d context that everything is drawn with.
         *
         * @member {CanvasRenderingContext2D}
         */
        _this.rootContext = _this.view.getContext('2d', { alpha: _this.transparent });

        /**
         * The currently active canvas 2d context (could change with renderTextures)
         *
         * @member {CanvasRenderingContext2D}
         */
        _this.context = _this.rootContext;

        /**
         * Boolean flag controlling canvas refresh.
         *
         * @member {boolean}
         */
        _this.refresh = true;

        /**
         * Instance of a CanvasMaskManager, handles masking when using the canvas renderer.
         *
         * @member {PIXI.CanvasMaskManager}
         */
        _this.maskManager = new _CanvasMaskManager2.default(_this);

        /**
         * The canvas property used to set the canvas smoothing property.
         *
         * @member {string}
         */
        _this.smoothProperty = 'imageSmoothingEnabled';

        if (!_this.rootContext.imageSmoothingEnabled) {
            if (_this.rootContext.webkitImageSmoothingEnabled) {
                _this.smoothProperty = 'webkitImageSmoothingEnabled';
            } else if (_this.rootContext.mozImageSmoothingEnabled) {
                _this.smoothProperty = 'mozImageSmoothingEnabled';
            } else if (_this.rootContext.oImageSmoothingEnabled) {
                _this.smoothProperty = 'oImageSmoothingEnabled';
            } else if (_this.rootContext.msImageSmoothingEnabled) {
                _this.smoothProperty = 'msImageSmoothingEnabled';
            }
        }

        _this.initPlugins();

        _this.blendModes = (0, _mapCanvasBlendModesToPixi2.default)();
        _this._activeBlendMode = null;

        _this.renderingToScreen = false;

        _this.resize(_this.options.width, _this.options.height);

        /**
         * Fired after rendering finishes.
         *
         * @event PIXI.CanvasRenderer#postrender
         */

        /**
         * Fired before rendering starts.
         *
         * @event PIXI.CanvasRenderer#prerender
         */
        return _this;
    }

    /**
     * Renders the object to this canvas view
     *
     * @param {PIXI.DisplayObject} displayObject - The object to be rendered
     * @param {PIXI.RenderTexture} [renderTexture] - A render texture to be rendered to.
     *  If unset, it will render to the root context.
     * @param {boolean} [clear=false] - Whether to clear the canvas before drawing
     * @param {PIXI.Matrix} [transform] - A transformation to be applied
     * @param {boolean} [skipUpdateTransform=false] - Whether to skip the update transform
     */


    CanvasRenderer.prototype.render = function render(displayObject, renderTexture, clear, transform, skipUpdateTransform) {
        if (!this.view) {
            return;
        }

        // can be handy to know!
        this.renderingToScreen = !renderTexture;

        this.emit('prerender');

        var rootResolution = this.resolution;

        if (renderTexture) {
            renderTexture = renderTexture.baseTexture || renderTexture;

            if (!renderTexture._canvasRenderTarget) {
                renderTexture._canvasRenderTarget = new _CanvasRenderTarget2.default(renderTexture.width, renderTexture.height, renderTexture.resolution);
                renderTexture.source = renderTexture._canvasRenderTarget.canvas;
                renderTexture.valid = true;
            }

            this.context = renderTexture._canvasRenderTarget.context;
            this.resolution = renderTexture._canvasRenderTarget.resolution;
        } else {
            this.context = this.rootContext;
        }

        var context = this.context;

        if (!renderTexture) {
            this._lastObjectRendered = displayObject;
        }

        if (!skipUpdateTransform) {
            // update the scene graph
            var cacheParent = displayObject.parent;
            var tempWt = this._tempDisplayObjectParent.transform.worldTransform;

            if (transform) {
                transform.copy(tempWt);

                // lets not forget to flag the parent transform as dirty...
                this._tempDisplayObjectParent.transform._worldID = -1;
            } else {
                tempWt.identity();
            }

            displayObject.parent = this._tempDisplayObjectParent;

            displayObject.updateTransform();
            displayObject.parent = cacheParent;
            // displayObject.hitArea = //TODO add a temp hit area
        }

        context.save();
        context.setTransform(1, 0, 0, 1, 0, 0);
        context.globalAlpha = 1;
        this._activeBlendMode = _const.BLEND_MODES.NORMAL;
        context.globalCompositeOperation = this.blendModes[_const.BLEND_MODES.NORMAL];

        if (navigator.isCocoonJS && this.view.screencanvas) {
            context.fillStyle = 'black';
            context.clear();
        }

        if (clear !== undefined ? clear : this.clearBeforeRender) {
            if (this.renderingToScreen) {
                if (this.transparent) {
                    context.clearRect(0, 0, this.width, this.height);
                } else {
                    context.fillStyle = this._backgroundColorString;
                    context.fillRect(0, 0, this.width, this.height);
                }
            } // else {
            // TODO: implement background for CanvasRenderTarget or RenderTexture?
            // }
        }

        // TODO RENDER TARGET STUFF HERE..
        var tempContext = this.context;

        this.context = context;
        displayObject.renderCanvas(this);
        this.context = tempContext;

        context.restore();

        this.resolution = rootResolution;

        this.emit('postrender');
    };

    /**
     * Clear the canvas of renderer.
     *
     * @param {string} [clearColor] - Clear the canvas with this color, except the canvas is transparent.
     */


    CanvasRenderer.prototype.clear = function clear(clearColor) {
        var context = this.context;

        clearColor = clearColor || this._backgroundColorString;

        if (!this.transparent && clearColor) {
            context.fillStyle = clearColor;
            context.fillRect(0, 0, this.width, this.height);
        } else {
            context.clearRect(0, 0, this.width, this.height);
        }
    };

    /**
     * Sets the blend mode of the renderer.
     *
     * @param {number} blendMode - See {@link PIXI.BLEND_MODES} for valid values.
     */


    CanvasRenderer.prototype.setBlendMode = function setBlendMode(blendMode) {
        if (this._activeBlendMode === blendMode) {
            return;
        }

        this._activeBlendMode = blendMode;
        this.context.globalCompositeOperation = this.blendModes[blendMode];
    };

    /**
     * Removes everything from the renderer and optionally removes the Canvas DOM element.
     *
     * @param {boolean} [removeView=false] - Removes the Canvas element from the DOM.
     */


    CanvasRenderer.prototype.destroy = function destroy(removeView) {
        this.destroyPlugins();

        // call the base destroy
        _SystemRenderer.prototype.destroy.call(this, removeView);

        this.context = null;

        this.refresh = true;

        this.maskManager.destroy();
        this.maskManager = null;

        this.smoothProperty = null;
    };

    /**
     * Resizes the canvas view to the specified width and height.
     *
     * @extends PIXI.SystemRenderer#resize
     *
     * @param {number} screenWidth - the new width of the screen
     * @param {number} screenHeight - the new height of the screen
     */


    CanvasRenderer.prototype.resize = function resize(screenWidth, screenHeight) {
        _SystemRenderer.prototype.resize.call(this, screenWidth, screenHeight);

        // reset the scale mode.. oddly this seems to be reset when the canvas is resized.
        // surely a browser bug?? Let PixiJS fix that for you..
        if (this.smoothProperty) {
            this.rootContext[this.smoothProperty] = _settings2.default.SCALE_MODE === _const.SCALE_MODES.LINEAR;
        }
    };

    /**
     * Checks if blend mode has changed.
     */


    CanvasRenderer.prototype.invalidateBlendMode = function invalidateBlendMode() {
        this._activeBlendMode = this.blendModes.indexOf(this.context.globalCompositeOperation);
    };

    return CanvasRenderer;
}(_SystemRenderer3.default);

/**
 * Collection of installed plugins. These are included by default in PIXI, but can be excluded
 * by creating a custom build. Consult the README for more information about creating custom
 * builds and excluding plugins.
 * @name PIXI.CanvasRenderer#plugins
 * @type {object}
 * @readonly
 * @property {PIXI.accessibility.AccessibilityManager} accessibility Support tabbing interactive elements.
 * @property {PIXI.extract.CanvasExtract} extract Extract image data from renderer.
 * @property {PIXI.interaction.InteractionManager} interaction Handles mouse, touch and pointer events.
 * @property {PIXI.prepare.CanvasPrepare} prepare Pre-render display objects.
 */

/**
 * Adds a plugin to the renderer.
 *
 * @method PIXI.CanvasRenderer#registerPlugin
 * @param {string} pluginName - The name of the plugin.
 * @param {Function} ctor - The constructor function or class for the plugin.
 */

exports.default = CanvasRenderer;
_utils.pluginTarget.mixin(CanvasRenderer);
//# sourceMappingURL=CanvasRenderer.js.map

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class
 * @memberof PIXI
 */
var WebGLManager = function () {
  /**
   * @param {PIXI.WebGLRenderer} renderer - The renderer this manager works for.
   */
  function WebGLManager(renderer) {
    _classCallCheck(this, WebGLManager);

    /**
     * The renderer this manager works for.
     *
     * @member {PIXI.WebGLRenderer}
     */
    this.renderer = renderer;

    this.renderer.on('context', this.onContextChange, this);
  }

  /**
   * Generic method called when there is a WebGL context change.
   *
   */


  WebGLManager.prototype.onContextChange = function onContextChange() {}
  // do some codes init!


  /**
   * Generic destroy methods to be overridden by the subclass
   *
   */
  ;

  WebGLManager.prototype.destroy = function destroy() {
    this.renderer.off('context', this.onContextChange, this);

    this.renderer = null;
  };

  return WebGLManager;
}();

exports.default = WebGLManager;
//# sourceMappingURL=WebGLManager.js.map

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _pixiGlCore = __webpack_require__(31);

var _settings = __webpack_require__(17);

var _settings2 = _interopRequireDefault(_settings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function checkPrecision(src, def) {
    if (src instanceof Array) {
        if (src[0].substring(0, 9) !== 'precision') {
            var copy = src.slice(0);

            copy.unshift('precision ' + def + ' float;');

            return copy;
        }
    } else if (src.trim().substring(0, 9) !== 'precision') {
        return 'precision ' + def + ' float;\n' + src;
    }

    return src;
}

/**
 * Wrapper class, webGL Shader for Pixi.
 * Adds precision string if vertexSrc or fragmentSrc have no mention of it.
 *
 * @class
 * @extends GLShader
 * @memberof PIXI
 */

var Shader = function (_GLShader) {
    _inherits(Shader, _GLShader);

    /**
     *
     * @param {WebGLRenderingContext} gl - The current WebGL rendering context
     * @param {string|string[]} vertexSrc - The vertex shader source as an array of strings.
     * @param {string|string[]} fragmentSrc - The fragment shader source as an array of strings.
     * @param {object} [attributeLocations] - A key value pair showing which location eact attribute should sit.
                       e.g. {position:0, uvs:1}.
     * @param {string} [precision] - The float precision of the shader. Options are 'lowp', 'mediump' or 'highp'.
     */
    function Shader(gl, vertexSrc, fragmentSrc, attributeLocations, precision) {
        _classCallCheck(this, Shader);

        return _possibleConstructorReturn(this, _GLShader.call(this, gl, checkPrecision(vertexSrc, precision || _settings2.default.PRECISION_VERTEX), checkPrecision(fragmentSrc, precision || _settings2.default.PRECISION_FRAGMENT), undefined, attributeLocations));
    }

    return Shader;
}(_pixiGlCore.GLShader);

exports.default = Shader;
//# sourceMappingURL=Shader.js.map

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// import Loader from './Loader';
// import Resource from './Resource';
// import * as async from './async';
// import * as b64 from './b64';

/* eslint-disable no-undef */

var Loader = __webpack_require__(422).Loader;
var Resource = __webpack_require__(137).Resource;
var async = __webpack_require__(214);
var b64 = __webpack_require__(215);

/**
 *
 * @static
 * @memberof Loader
 * @member {Class<Resource>}
 */
Loader.Resource = Resource;

/**
 *
 * @static
 * @memberof Loader
 * @member {Class<async>}
 */
Loader.async = async;

/**
 *
 * @static
 * @memberof Loader
 * @member {Class<encodeBinary>}
 */
Loader.encodeBinary = b64;

/**
 *
 * @deprecated
 * @see Loader.encodeBinary
 *
 * @static
 * @memberof Loader
 * @member {Class<encodeBinary>}
 */
Loader.base64 = b64;

// export manually, and also as default
module.exports = Loader;

// default & named export
module.exports.Loader = Loader;
module.exports.default = Loader;
//# sourceMappingURL=index.js.map

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _core = __webpack_require__(7);

var core = _interopRequireWildcard(_core);

var _Texture = __webpack_require__(49);

var _Texture2 = _interopRequireDefault(_Texture);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var tempPoint = new core.Point();
var tempPolygon = new core.Polygon();

/**
 * Base mesh class
 * @class
 * @extends PIXI.Container
 * @memberof PIXI.mesh
 */

var Mesh = function (_core$Container) {
    _inherits(Mesh, _core$Container);

    /**
     * @param {PIXI.Texture} texture - The texture to use
     * @param {Float32Array} [vertices] - if you want to specify the vertices
     * @param {Float32Array} [uvs] - if you want to specify the uvs
     * @param {Uint16Array} [indices] - if you want to specify the indices
     * @param {number} [drawMode] - the drawMode, can be any of the Mesh.DRAW_MODES consts
     */
    function Mesh(texture, vertices, uvs, indices, drawMode) {
        _classCallCheck(this, Mesh);

        /**
         * The texture of the Mesh
         *
         * @member {PIXI.Texture}
         * @default PIXI.Texture.EMPTY
         * @private
         */
        var _this = _possibleConstructorReturn(this, _core$Container.call(this));

        _this._texture = texture || _Texture2.default.EMPTY;

        /**
         * The Uvs of the Mesh
         *
         * @member {Float32Array}
         */
        _this.uvs = uvs || new Float32Array([0, 0, 1, 0, 1, 1, 0, 1]);

        /**
         * An array of vertices
         *
         * @member {Float32Array}
         */
        _this.vertices = vertices || new Float32Array([0, 0, 100, 0, 100, 100, 0, 100]);

        /**
         * An array containing the indices of the vertices
         *
         * @member {Uint16Array}
         */
        //  TODO auto generate this based on draw mode!
        _this.indices = indices || new Uint16Array([0, 1, 3, 2]);

        /**
         * Version of mesh uvs are dirty or not
         *
         * @member {number}
         */
        _this.dirty = 0;

        /**
         * Version of mesh indices
         *
         * @member {number}
         */
        _this.indexDirty = 0;

        /**
         * Version of mesh verticies array
         *
         * @member {number}
         */
        _this.vertexDirty = 0;

        /**
         * For backwards compatibility the default is to re-upload verticies each render call.
         * Set this to `false` and increase `vertexDirty` to manually re-upload the buffer.
         *
         * @member {boolean}
         */
        _this.autoUpdate = true;

        /**
         * The blend mode to be applied to the sprite. Set to `PIXI.BLEND_MODES.NORMAL` to remove
         * any blend mode.
         *
         * @member {number}
         * @default PIXI.BLEND_MODES.NORMAL
         * @see PIXI.BLEND_MODES
         */
        _this.blendMode = core.BLEND_MODES.NORMAL;

        /**
         * Triangles in canvas mode are automatically antialiased, use this value to force triangles
         * to overlap a bit with each other.
         *
         * @member {number}
         */
        _this.canvasPadding = core.settings.MESH_CANVAS_PADDING;

        /**
         * The way the Mesh should be drawn, can be any of the {@link PIXI.mesh.Mesh.DRAW_MODES} consts
         *
         * @member {number}
         * @see PIXI.mesh.Mesh.DRAW_MODES
         */
        _this.drawMode = drawMode || Mesh.DRAW_MODES.TRIANGLE_MESH;

        /**
         * The default shader that is used if a mesh doesn't have a more specific one.
         *
         * @member {PIXI.Shader}
         */
        _this.shader = null;

        /**
         * The tint applied to the mesh. This is a [r,g,b] value. A value of [1,1,1] will remove any
         * tint effect.
         *
         * @member {number}
         */
        _this.tintRgb = new Float32Array([1, 1, 1]);

        /**
         * A map of renderer IDs to webgl render data
         *
         * @private
         * @member {object<number, object>}
         */
        _this._glDatas = {};

        /**
         * transform that is applied to UV to get the texture coords
         * its updated independently from texture uvTransform
         * updates of uvs are tied to that thing
         *
         * @member {PIXI.TextureMatrix}
         * @private
         */
        _this._uvTransform = new core.TextureMatrix(_this._texture);

        /**
         * whether or not upload uvTransform to shader
         * if its false, then uvs should be pre-multiplied
         * if you change it for generated mesh, please call 'refresh(true)'
         * @member {boolean}
         * @default false
         */
        _this.uploadUvTransform = false;

        /**
         * Plugin that is responsible for rendering this element.
         * Allows to customize the rendering process without overriding '_renderWebGL' & '_renderCanvas' methods.
         * @member {string}
         * @default 'mesh'
         */
        _this.pluginName = 'mesh';
        return _this;
    }

    /**
     * Renders the object using the WebGL renderer
     *
     * @private
     * @param {PIXI.WebGLRenderer} renderer - a reference to the WebGL renderer
     */


    Mesh.prototype._renderWebGL = function _renderWebGL(renderer) {
        this.refresh();
        renderer.setObjectRenderer(renderer.plugins[this.pluginName]);
        renderer.plugins[this.pluginName].render(this);
    };

    /**
     * Renders the object using the Canvas renderer
     *
     * @private
     * @param {PIXI.CanvasRenderer} renderer - The canvas renderer.
     */


    Mesh.prototype._renderCanvas = function _renderCanvas(renderer) {
        this.refresh();
        renderer.plugins[this.pluginName].render(this);
    };

    /**
     * When the texture is updated, this event will fire to update the scale and frame
     *
     * @private
     */


    Mesh.prototype._onTextureUpdate = function _onTextureUpdate() {
        this._uvTransform.texture = this._texture;
        this.refresh();
    };

    /**
     * multiplies uvs only if uploadUvTransform is false
     * call it after you change uvs manually
     * make sure that texture is valid
     */


    Mesh.prototype.multiplyUvs = function multiplyUvs() {
        if (!this.uploadUvTransform) {
            this._uvTransform.multiplyUvs(this.uvs);
        }
    };

    /**
     * Refreshes uvs for generated meshes (rope, plane)
     * sometimes refreshes vertices too
     *
     * @param {boolean} [forceUpdate=false] if true, matrices will be updated any case
     */


    Mesh.prototype.refresh = function refresh(forceUpdate) {
        if (this.autoUpdate) {
            this.vertexDirty++;
        }
        if (this._uvTransform.update(forceUpdate)) {
            this._refresh();
        }
    };

    /**
     * re-calculates mesh coords
     * @protected
     */


    Mesh.prototype._refresh = function _refresh() {}
    /* empty */


    /**
     * Returns the bounds of the mesh as a rectangle. The bounds calculation takes the worldTransform into account.
     *
     */
    ;

    Mesh.prototype._calculateBounds = function _calculateBounds() {
        // TODO - we can cache local bounds and use them if they are dirty (like graphics)
        this._bounds.addVertices(this.transform, this.vertices, 0, this.vertices.length);
    };

    /**
     * Tests if a point is inside this mesh. Works only for TRIANGLE_MESH
     *
     * @param {PIXI.Point} point - the point to test
     * @return {boolean} the result of the test
     */


    Mesh.prototype.containsPoint = function containsPoint(point) {
        if (!this.getBounds().contains(point.x, point.y)) {
            return false;
        }

        this.worldTransform.applyInverse(point, tempPoint);

        var vertices = this.vertices;
        var points = tempPolygon.points;
        var indices = this.indices;
        var len = this.indices.length;
        var step = this.drawMode === Mesh.DRAW_MODES.TRIANGLES ? 3 : 1;

        for (var i = 0; i + 2 < len; i += step) {
            var ind0 = indices[i] * 2;
            var ind1 = indices[i + 1] * 2;
            var ind2 = indices[i + 2] * 2;

            points[0] = vertices[ind0];
            points[1] = vertices[ind0 + 1];
            points[2] = vertices[ind1];
            points[3] = vertices[ind1 + 1];
            points[4] = vertices[ind2];
            points[5] = vertices[ind2 + 1];

            if (tempPolygon.contains(tempPoint.x, tempPoint.y)) {
                return true;
            }
        }

        return false;
    };

    /**
     * The texture that the mesh uses.
     *
     * @member {PIXI.Texture}
     */


    /**
     * Destroys the Mesh object.
     *
     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all
     *  options have been set to that value
     * @param {boolean} [options.children=false] - if set to true, all the children will have
     *  their destroy method called as well. 'options' will be passed on to those calls.
     * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
     *  Should it destroy the texture of the child sprite
     * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
     *  Should it destroy the base texture of the child sprite
     */
    Mesh.prototype.destroy = function destroy(options) {
        // for each webgl data entry, destroy the WebGLGraphicsData
        for (var id in this._glDatas) {
            var data = this._glDatas[id];

            if (data.destroy) {
                data.destroy();
            } else {
                if (data.vertexBuffer) {
                    data.vertexBuffer.destroy();
                    data.vertexBuffer = null;
                }
                if (data.indexBuffer) {
                    data.indexBuffer.destroy();
                    data.indexBuffer = null;
                }
                if (data.uvBuffer) {
                    data.uvBuffer.destroy();
                    data.uvBuffer = null;
                }
                if (data.vao) {
                    data.vao.destroy();
                    data.vao = null;
                }
            }
        }

        this._glDatas = null;

        _core$Container.prototype.destroy.call(this, options);
    };

    _createClass(Mesh, [{
        key: 'texture',
        get: function get() {
            return this._texture;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            if (this._texture === value) {
                return;
            }

            this._texture = value;

            if (value) {
                // wait for the texture to load
                if (value.baseTexture.hasLoaded) {
                    this._onTextureUpdate();
                } else {
                    value.once('update', this._onTextureUpdate, this);
                }
            }
        }

        /**
         * The tint applied to the mesh. This is a hex value. A value of 0xFFFFFF will remove any tint effect.
         *
         * @member {number}
         * @default 0xFFFFFF
         */

    }, {
        key: 'tint',
        get: function get() {
            return core.utils.rgb2hex(this.tintRgb);
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.tintRgb = core.utils.hex2rgb(value, this.tintRgb);
        }
    }]);

    return Mesh;
}(core.Container);

/**
 * Different drawing buffer modes supported
 *
 * @static
 * @constant
 * @type {object}
 * @property {number} TRIANGLE_MESH
 * @property {number} TRIANGLES
 */


exports.default = Mesh;
Mesh.DRAW_MODES = {
    TRIANGLE_MESH: 0,
    TRIANGLES: 1
};
//# sourceMappingURL=Mesh.js.map

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ERROR_MSGS = __webpack_require__(27);
function getServiceIdentifierAsString(serviceIdentifier) {
    if (typeof serviceIdentifier === "function") {
        var _serviceIdentifier = serviceIdentifier;
        return _serviceIdentifier.name;
    }
    else if (typeof serviceIdentifier === "symbol") {
        return serviceIdentifier.toString();
    }
    else {
        var _serviceIdentifier = serviceIdentifier;
        return _serviceIdentifier;
    }
}
exports.getServiceIdentifierAsString = getServiceIdentifierAsString;
function listRegisteredBindingsForServiceIdentifier(container, serviceIdentifier, getBindings) {
    var registeredBindingsList = "";
    var registeredBindings = getBindings(container, serviceIdentifier);
    if (registeredBindings.length !== 0) {
        registeredBindingsList = "\nRegistered bindings:";
        registeredBindings.forEach(function (binding) {
            var name = "Object";
            if (binding.implementationType !== null) {
                name = getFunctionName(binding.implementationType);
            }
            registeredBindingsList = registeredBindingsList + "\n " + name;
            if (binding.constraint.metaData) {
                registeredBindingsList = registeredBindingsList + " - " + binding.constraint.metaData;
            }
        });
    }
    return registeredBindingsList;
}
exports.listRegisteredBindingsForServiceIdentifier = listRegisteredBindingsForServiceIdentifier;
function alreadyDependencyChain(request, serviceIdentifier) {
    if (request.parentRequest === null) {
        return false;
    }
    else if (request.parentRequest.serviceIdentifier === serviceIdentifier) {
        return true;
    }
    else {
        return alreadyDependencyChain(request.parentRequest, serviceIdentifier);
    }
}
function dependencyChainToString(request) {
    function _createStringArr(req, result) {
        if (result === void 0) { result = []; }
        var serviceIdentifier = getServiceIdentifierAsString(req.serviceIdentifier);
        result.push(serviceIdentifier);
        if (req.parentRequest !== null) {
            return _createStringArr(req.parentRequest, result);
        }
        return result;
    }
    var stringArr = _createStringArr(request);
    return stringArr.reverse().join(" --> ");
}
function circularDependencyToException(request) {
    request.childRequests.forEach(function (childRequest) {
        if (alreadyDependencyChain(childRequest, childRequest.serviceIdentifier)) {
            var services = dependencyChainToString(childRequest);
            throw new Error(ERROR_MSGS.CIRCULAR_DEPENDENCY + " " + services);
        }
        else {
            circularDependencyToException(childRequest);
        }
    });
}
exports.circularDependencyToException = circularDependencyToException;
function listMetadataForTarget(serviceIdentifierString, target) {
    if (target.isTagged() || target.isNamed()) {
        var m_1 = "";
        var namedTag = target.getNamedTag();
        var otherTags = target.getCustomTags();
        if (namedTag !== null) {
            m_1 += namedTag.toString() + "\n";
        }
        if (otherTags !== null) {
            otherTags.forEach(function (tag) {
                m_1 += tag.toString() + "\n";
            });
        }
        return " " + serviceIdentifierString + "\n " + serviceIdentifierString + " - " + m_1;
    }
    else {
        return " " + serviceIdentifierString;
    }
}
exports.listMetadataForTarget = listMetadataForTarget;
function getFunctionName(v) {
    if (v.name) {
        return v.name;
    }
    else {
        var name_1 = v.toString();
        var match = name_1.match(/^function\s*([^\s(]+)/);
        return match ? match[1] : "Anonymous function: " + name_1;
    }
}
exports.getFunctionName = getFunctionName;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Button_1 = __webpack_require__(54);
var SpriteButton_1 = __webpack_require__(55);
var SpriteGraphics_1 = __webpack_require__(62);
var GenericButton = /** @class */ (function (_super) {
    __extends(GenericButton, _super);
    function GenericButton(callback, textStyle) {
        var _this = _super.call(this, callback) || this;
        _this._clicked = false;
        _this._buttonContainer = new PIXI.Container();
        _this._textContainer = new PIXI.Container();
        _this._buttonContainer.interactiveChildren = false;
        _this._textContainer.interactiveChildren = false;
        _this._hiddenInputGraphics = SpriteGraphics_1.SpriteGraphics.makeHiddenRectangle(100, 100);
        _this._hiddenInputGraphics.anchor.set(0.5);
        _this.addChild(_this._buttonContainer);
        _this.addChild(_this._textContainer);
        _this.addChild(_this._hiddenInputGraphics);
        _this.setupText(textStyle);
        return _this;
    }
    GenericButton.prototype.setSelected = function () {
        this.setState(Button_1.ButtonState.DOWN);
        if (this._callback) {
            this._callback(false);
        }
    };
    GenericButton.prototype.resetState = function () {
        this._clicked = false;
        this.setState(Button_1.ButtonState.UP);
    };
    GenericButton.prototype.forceClicked = function () {
        this._clicked = true;
    };
    GenericButton.prototype.changeText = function (newText) {
        this._textObject.text = newText;
        this.updateTexts();
    };
    GenericButton.prototype.onMouseUp = function () {
        if (this._state === Button_1.ButtonState.DOWN) {
            this._clicked = true;
        }
        else {
            this.setState(Button_1.ButtonState.UP);
        }
    };
    GenericButton.prototype.scaleTextToFitContainer = function (scalar) {
        if (scalar === void 0) { scalar = 1; }
        this._textContainer.scale.set(1);
        if (this._textContainer.width > this._buttonContainer.width * scalar) {
            var procentage = (this._buttonContainer.width * scalar) / this._textContainer.width;
            this._textObject.scale.set(procentage);
        }
    };
    GenericButton.prototype.setState = function (value) {
        if (this._state !== value) {
            this._state = value;
            if (this._buttonContainer) {
                this.cleanFrame();
            }
            this.updateFrame();
        }
    };
    GenericButton.prototype.updateFrame = function () {
        if (this._frames[this._state]) {
            this._buttonContainer.addChild(this._frames[this._state]);
            this._hiddenInputGraphics.width = this._frames[this._state].width;
            this._hiddenInputGraphics.height = this._frames[this._state].height;
        }
    };
    GenericButton.prototype.cleanFrame = function () {
        this._buttonContainer.removeChildren();
    };
    GenericButton.prototype.updateTexts = function () {
        if (this._textObject) {
            this._textObject.x = this.width / 2;
            this._textObject.y = this.height / 2;
            this._textContainer.removeChild(this._textObject);
            this._textContainer.addChild(this._textObject);
        }
    };
    GenericButton.prototype.setupText = function (textStyle) {
        this._textObject = new PIXI.Text('', textStyle);
        this._textObject.anchor.set(0.5);
    };
    GenericButton.prototype.onMouseOver = function () {
        if (!(this._state === Button_1.ButtonState.DOWN)) {
            this._over = true;
            this.setState(Button_1.ButtonState.OVER);
        }
    };
    GenericButton.prototype.onClick = function () {
        if (!(this._state === Button_1.ButtonState.DOWN)) {
            this.setState(Button_1.ButtonState.OVER);
        }
        if (this._callback && this._state === Button_1.ButtonState.DOWN) {
            this._callback(true);
        }
    };
    GenericButton.prototype.onMouseOut = function () {
        this._mouseOutCallback && this._mouseOutCallback();
        if (!(this._state === Button_1.ButtonState.DOWN) || !this._clicked) {
            this._over = false;
            this.setState(Button_1.ButtonState.UP);
        }
    };
    GenericButton.prototype.onMouseDown = function () {
        this.setState(Button_1.ButtonState.DOWN);
        this._tapDownCallback && this._tapDownCallback();
        // this._clicked = true;
    };
    Object.defineProperty(GenericButton.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (v) {
            this._id = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GenericButton.prototype, "extraData", {
        get: function () {
            return this._extraData;
        },
        set: function (data) {
            this._extraData = data;
        },
        enumerable: true,
        configurable: true
    });
    return GenericButton;
}(SpriteButton_1.SpriteButton));
exports.GenericButton = GenericButton;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var View_1 = __webpack_require__(3);
var Tween_1 = __webpack_require__(19);
var Easing_1 = __webpack_require__(16);
var BackgroundView = /** @class */ (function (_super) {
    __extends(BackgroundView, _super);
    function BackgroundView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BackgroundView.prototype.init = function () {
        _super.prototype.init.call(this);
        this._window = new PIXI.Sprite();
        this.setupSprites();
        this.initBackgrounds();
    };
    BackgroundView.prototype.shakeBackground = function (power, repeats) {
        if (repeats === void 0) { repeats = NaN; }
        this._beforeShakingPosition = { x: this.container.x, y: this.container.y };
        this.stopShaking();
        var duration = Math.ceil(50 * power);
        var totalRepeats = Math.ceil(3 * power);
        if (!isNaN(repeats)) {
            totalRepeats = repeats;
        }
        var basePos = { x: this.resolutionManager.halfResolution.width, y: this.resolutionManager.halfResolution.height };
        this.container.pivot.set(basePos.x, basePos.y);
        var strength = 25 * power;
        var getValues = function () {
            return { x: (Math.random() - 0.5) * strength + basePos.x, y: (Math.random() - 0.5) * strength + basePos.y };
        };
        this.container.position.set(getValues().x, getValues().y);
        // const endTween: Tween = new Tween(this.container).to({x: basePos.x, y: basePos.y}, duration);
        var shakeTween = new Tween_1.Tween(this.container)
            .to(getValues(), duration / totalRepeats)
            .repeat(totalRepeats)
            .yoyo(true)
            .easing(Easing_1.Easing.Linear.None)
            .onRepeat(function () {
            if (shakeTween.getRepeat() < totalRepeats) {
                shakeTween.to(getValues(), duration / (shakeTween.getRepeat() * shakeTween.getRepeat()));
            }
        })
            .onComplete(function () {
            shakeTween.to({ x: basePos.x, y: basePos.y }, duration);
        })
            .start();
        this.updateManager.add(shakeTween);
        this._currentShakingTween = shakeTween;
        var scaleTween = new Tween_1.Tween(this.container.scale)
            .to({ x: [Math.pow(1.03, power), 1], y: [Math.pow(1.03, power), 1] }, 250)
            .start();
        this.updateManager.add(scaleTween);
        this._currentScaleTween = scaleTween;
    };
    BackgroundView.prototype.stopShaking = function () {
        if (this._currentShakingTween) {
            this._currentShakingTween.stop();
            this.updateManager.remove(this._currentShakingTween);
            this._currentShakingTween = null;
        }
        if (this._currentScaleTween) {
            this._currentScaleTween.stop();
            this.updateManager.remove(this._currentScaleTween);
            this._currentScaleTween = null;
        }
        this.container.scale.set(1.0);
        var basePos = { x: this.resolutionManager.halfResolution.width, y: this.resolutionManager.halfResolution.height };
        this.container.pivot.set(basePos.x, basePos.y);
        this.container.position.set(basePos.x, basePos.y);
    };
    BackgroundView.prototype.showMainGameBackground = function () {
        this._mainGameBackground.alpha = 1.0;
        if (this._freeSpinsBackground) {
            this._freeSpinsBackground.alpha = 0.0;
        }
    };
    BackgroundView.prototype.showFreeSpinsBackground = function () {
        this._mainGameBackground.alpha = 0.0;
        if (this._freeSpinsBackground) {
            this._freeSpinsBackground.alpha = 1.0;
        }
    };
    BackgroundView.prototype.playTransitionToMainGame = function () {
        var disappearTween = new Tween_1.Tween(this._freeSpinsBackground)
            .to({ alpha: 0.0 }, BackgroundView.TRANSFER_TIME)
            .onComplete(this.onTransitionToMainGameCompleted.bind(this))
            .start();
        var appearTween = new Tween_1.Tween(this._mainGameBackground).to({ alpha: 1.0 }, BackgroundView.TRANSFER_TIME).start();
        this.updateManager.add(disappearTween);
        this.updateManager.add(appearTween);
    };
    BackgroundView.prototype.playTransitionToFreeSpins = function () {
        var disappearTween = new Tween_1.Tween(this._mainGameBackground)
            .to({ alpha: 0.0 }, BackgroundView.TRANSFER_TIME)
            .onComplete(this.onTransitionToFreeSpinsCompleted.bind(this))
            .start();
        var appearTween = new Tween_1.Tween(this._freeSpinsBackground).to({ alpha: 1.0 }, BackgroundView.TRANSFER_TIME).start();
        this.updateManager.add(disappearTween);
        this.updateManager.add(appearTween);
    };
    BackgroundView.prototype.onTransitionToFreeSpinsCompleted = function () {
        this.emit(BackgroundView.VIEW_TRANSITION_TO_FREESPINS_COMPLETED);
    };
    BackgroundView.prototype.onTransitionToMainGameCompleted = function () {
        this.emit(BackgroundView.VIEW_TRANSITION_TO_MAINGAME_COMPLETED);
    };
    BackgroundView.prototype.setupSprites = function () {
        this._mainGameBackground = new PIXI.Sprite(this.resources.getTexture('BACKGROUND.png'));
    };
    BackgroundView.prototype.initBackgrounds = function () {
        this.container.addChild(this._window);
        this._window.addChild(this._mainGameBackground);
        if (this._freeSpinsBackground) {
            this._window.addChild(this._freeSpinsBackground);
        }
        this.showMainGameBackground();
        this.emit(BackgroundView.BACKGROUND_CREATED);
    };
    BackgroundView.TRANSFER_TIME = 500;
    BackgroundView.VIEW_TRANSITION_TO_MAINGAME_COMPLETED = 'BackgroundView::__VIEW_TRANSITION_TO_MAINGAME_COMPLETED__';
    BackgroundView.VIEW_TRANSITION_TO_FREESPINS_COMPLETED = 'BackgroundView::__VIEW_TRANSITION_TO_FREESPINS_COMPLETED__';
    BackgroundView.BACKGROUND_CREATED = 'BackgroundView::BACKGROUND_CREATED';
    return BackgroundView;
}(View_1.View));
exports.BackgroundView = BackgroundView;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var RespinEvents = /** @class */ (function () {
    function RespinEvents() {
    }
    RespinEvents.RESPIN_STARTED = 'RespinEvents::__RESPIN_STARTED__';
    RespinEvents.RESPIN_REMOVING_FINISHED = 'RespinEvents::__RESPIN_REMOVING_FINISHED__';
    RespinEvents.LEAVING_SCATTER_AT = 'RespinEvents::__LEAVING_SCATTER_AT__';
    RespinEvents.LEAVING_SYMBOL_AT = 'RespinEvents::__LEAVING_SYMBOL_AT__';
    RespinEvents.END_ANIM_TRIGGERED = 'RespinEvents::__END_ANIM_TRIGGERED__';
    return RespinEvents;
}());
exports.RespinEvents = RespinEvents;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BackgroundModule_1 = __webpack_require__(277);
var FreeSpinsEvents_1 = __webpack_require__(6);
var StartScreenEvents_1 = __webpack_require__(22);
var GameBackgroundModule = /** @class */ (function (_super) {
    __extends(GameBackgroundModule, _super);
    function GameBackgroundModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameBackgroundModule.prototype.restore = function () {
        _super.prototype.restore.call(this);
        if (this.logic.isFreeSpinsStarted) {
            this.gameView.isInFreeSpins = true;
            this.gameView.setupIdleAnimations();
            this.gameView.showFreeSpinsBackground();
        }
    };
    GameBackgroundModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_CONTINUE_CLICKED, this.onFreeSpinsStarted);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_OUTRO_CONTINUE_CLICKED, this.onFreeSpinsFinished);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_CONTINUE_CLICKED, this.onFreeSpinsContinueClicked);
        this.on(StartScreenEvents_1.StartScreenEvents.INTRO_STARTED, this.onStartScreenIntroStarted);
        this.on(StartScreenEvents_1.StartScreenEvents.EXIT_FINISHED, this.onStartScreenExitFinished);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_INTRO_STARTED, this.onFreeSpinsIntroStarted);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_RESTORE_INTRO_STARTED, this.onFreeSpinsIntroStarted);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_OUTRO_STARTED, this.onFreeSpinsOutroStarted);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_INTRO_FINISHED, this.onFreeSpinsIntroFinished);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_OUTRO_FINISHED, this.onFreeSpinsOutroFinished);
    };
    GameBackgroundModule.prototype.onFreeSpinsIntroStarted = function () {
        this.gameView.isInFreeSpins = true;
        this.gameView.setupIdleAnimations();
        this.gameView.hideReelBackground();
    };
    GameBackgroundModule.prototype.onFreeSpinsOutroStarted = function () {
        this.gameView.isInFreeSpins = false;
        this.gameView.setupIdleAnimations();
        this.gameView.hideReelBackground();
    };
    GameBackgroundModule.prototype.onFreeSpinsIntroFinished = function () {
        this.gameView.showReelBackground();
    };
    GameBackgroundModule.prototype.onFreeSpinsOutroFinished = function () {
        this.gameView.showReelBackground();
    };
    GameBackgroundModule.prototype.onStartScreenIntroStarted = function () {
        this.gameView.playStartAnimation();
        this.gameView.setReelsBackgroundAlphaToZero();
    };
    GameBackgroundModule.prototype.onFreeSpinsStarted = function () {
        this.gameView.playEnterFreeSpinsAnimation();
        this.gameView.showFreeSpinsBackground();
    };
    GameBackgroundModule.prototype.onFreeSpinsFinished = function () {
        this.gameView.playExitFreeSpinsAnimation();
        this.gameView.showMainGameBackground();
    };
    GameBackgroundModule.prototype.onStartScreenExitFinished = function () {
        this.eventManager.emit(GameBackgroundModule.TRANSITION_ANIMATION_STARTED);
        this.gameView.startTransition();
    };
    GameBackgroundModule.prototype.onFreeSpinsContinueClicked = function () {
        this.gameView.showFreeSpinsBackground();
    };
    Object.defineProperty(GameBackgroundModule.prototype, "gameView", {
        get: function () {
            return this._view;
        },
        enumerable: true,
        configurable: true
    });
    GameBackgroundModule.TRANSITION_ANIMATION_STARTED = 'GameBackgroundModule::TRANSITION_ANIMATION_STARTED';
    return GameBackgroundModule;
}(BackgroundModule_1.BackgroundModule));
exports.GameBackgroundModule = GameBackgroundModule;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var RecodeCurrencyFormatter_1 = __webpack_require__(240);
var ReCodeStorage_1 = __webpack_require__(541);
var Action_1 = __webpack_require__(29);
var FreeGamesData_1 = __webpack_require__(281);
var RecodeLogicEvents_1 = __webpack_require__(542);
var RecodeSpinResult_1 = __webpack_require__(282);
var Logic_1 = __webpack_require__(73);
var LogicEvents_1 = __webpack_require__(11);
var ReelConstants_1 = __webpack_require__(10);
var GameUtils_1 = __webpack_require__(26);
var RoundTypes;
(function (RoundTypes) {
    RoundTypes[RoundTypes["BASE_SPIN"] = 0] = "BASE_SPIN";
    RoundTypes[RoundTypes["WILD_EXPANSION"] = 1] = "WILD_EXPANSION";
    RoundTypes[RoundTypes["SCATTER_REPLACEMENT"] = 2] = "SCATTER_REPLACEMENT";
    RoundTypes[RoundTypes["AVALANCHE"] = 3] = "AVALANCHE";
    // BONUS = 4,
    RoundTypes[RoundTypes["SCATTER_REPLACEMENT_AND_AVALANCHE"] = 4] = "SCATTER_REPLACEMENT_AND_AVALANCHE";
    // FREESPIN = 5,
})(RoundTypes = exports.RoundTypes || (exports.RoundTypes = {}));
var ReelsTypes;
(function (ReelsTypes) {
    ReelsTypes[ReelsTypes["BASIC"] = 0] = "BASIC";
    ReelsTypes[ReelsTypes["BASIC_RESPIN"] = 1] = "BASIC_RESPIN";
    ReelsTypes[ReelsTypes["FREESPIN"] = 2] = "FREESPIN";
    ReelsTypes[ReelsTypes["FREESPIN_RESPIN"] = 3] = "FREESPIN_RESPIN";
    ReelsTypes[ReelsTypes["OTHER"] = 4] = "OTHER";
})(ReelsTypes = exports.ReelsTypes || (exports.ReelsTypes = {}));
var RecodeLogic = /** @class */ (function (_super) {
    __extends(RecodeLogic, _super);
    function RecodeLogic(gameName, eventManager, communicator, device) {
        var _this = _super.call(this, gameName, eventManager, communicator, device) || this;
        _this._wins = [];
        // for InGameProgress
        _this._roundTypes = [];
        _this._currentRound = 0;
        _this._reelsIndexOffset = 0;
        _this._totalRounds = 0;
        _this._expandedWildsMultipliers = [];
        _this._currentWildExpansion = 0;
        _this._baseWildsMultipliers = [];
        _this._currentMultiplierWilds = 0;
        _this._scatterReplacements = [];
        _this._currentScatterReplacement = 0;
        _this._waysRounds = [];
        _this._avalanches = [];
        _this._currentAvalanche = 0;
        _this._currentMultiplier = 1;
        _this._bonusGamesSymbols = [];
        _this._currentBonusGameSymbols = 0;
        _this._bonusGame = null;
        _this._bonusSymbolsToChoose = [];
        _this._wildMeterDeltas = [];
        _this._wildMeter = 1;
        _this._betMultiplier = 0;
        // If there was a free games session store the lastRealWager.
        _this._lastRealWager = null;
        _this._latestRequest = '';
        _this._isInFreeRounds = false;
        _this._hasExpiredFreeGames = false;
        _this._hasBonusGameFreeGamesRestore = false;
        _this._hasKilledFreeGamesRestore = false;
        _this._hasError = false;
        _this._isFatalError = false;
        _this._isRestoreAfterBonusGame = false;
        _this._hasClearedExpiredFreeGames = false;
        _this._restoredIntoBonusGame = false;
        _this.addDefaultValues();
        _this.initAutoplayValues();
        return _this;
    }
    RecodeLogic.prototype.killAllFreeGames = function () {
        this._freeGamesData = null;
        this._isInFreeRounds = false;
        this._currentFreeGameProgress = null;
        // this.validatePreviousBet();
    };
    RecodeLogic.prototype.startFreeGames = function () {
        this._isInFreeRounds = true;
        this.setFreeGameBetValue();
    };
    RecodeLogic.prototype.clearExpiredFreeGames = function () {
        this._currentFreeGameProgress = null;
        this._hasExpiredFreeGames = false;
        this._hasClearedExpiredFreeGames = true;
    };
    RecodeLogic.prototype.setFreeGameBetValue = function () {
        if (this.getCurrentFreeGamesData()) {
            // Changed to corrected betlogic.
            this._betValue = this.calculateTotalBetValueFromChipsNumChipsMultiplier(this.getCurrentFreeGamesData().betData.chipSize, this.getCurrentFreeGamesData().betData.numChips);
        }
        else {
            this._betValue = this.calculateTotalBetValueFromChipsNumChipsMultiplier(this.currentFreeGameProgress.wagerChipSize, this.currentFreeGameProgress.wagerNumChips);
        }
    };
    RecodeLogic.prototype.rejectFreeGames = function (cb) {
        var _this = this;
        this._communicator.rejectFreeGames(this.getCurrentFreeGamesData().offerID, this.getCurrentFreeGamesData().instanceID, function (data) {
            cb && cb(null);
            _this._eventManager.emit(RecodeLogicEvents_1.RecodeLogicEvents.FREE_GAMES_REJECTED_RESPONSE);
        }, null);
        this.finishCurrentFreeGames();
    };
    RecodeLogic.prototype.startNextRound = function () {
        if (this._currentRound < this._totalRounds - 1) {
            this._currentRound++;
            this.setResultsForCurrentRound();
        }
    };
    RecodeLogic.prototype.makeNextScattersList = function () {
        var currentScatters = this._scatterReplacements[this._currentScatterReplacement];
        this.getRecodeSpinResults().setScatters(currentScatters);
        this.getRecodeSpinResults().setRespinNewSymbols(this._reels[this._currentRound], currentScatters, this._reelsHeight[this._currentRound]);
        if (this._currentScatterReplacement < this._scatterReplacements.length - 1) {
            this._currentScatterReplacement++;
        }
        // Added for Medallion - every "tumble" should increase the multiplier.
        this._currentMultiplier++;
    };
    RecodeLogic.prototype.makeNextAvalanchesList = function () {
        this.getRecodeSpinResults().setAvalancheSymbolsToRemove(this._avalanches[this._currentAvalanche].symbolIndexes, this._reels[this._currentRound - 1]);
        this.getRecodeSpinResults().setAvalancheNewSymbols(this._reels[this._currentRound - 1], this._reels[this._currentRound], this._avalanches[this._currentAvalanche].symbolIndexes, this._reelsHeight[this._currentRound - 1], this._reelsHeight[this._currentRound]);
        if (this._currentAvalanche < this._avalanches.length - 1) {
            this._currentAvalanche++;
        }
        this._currentMultiplier++;
    };
    RecodeLogic.prototype.makeNextAvalancheScattersList = function () {
        // Scatter / Respin
        var currentScatters = this._scatterReplacements[this._currentScatterReplacement];
        this.getRecodeSpinResults().setScatters(currentScatters);
        this.getRecodeSpinResults().setRespinNewSymbols(this._reels[this._currentRound], currentScatters, this._reelsHeight[this._currentRound]);
        if (this._currentScatterReplacement < this._scatterReplacements.length - 1) {
            this._currentScatterReplacement++;
        }
        // Avalanche
        this.getRecodeSpinResults().setAvalancheSymbolsToRemove(this._avalanches[this._currentAvalanche].symbolIndexes, this._reels[this._currentRound - 1]);
        this._avalanches[this._currentAvalanche].symbolIndexes = this._avalanches[this._currentAvalanche].symbolIndexes.concat(currentScatters.scattersPositions.concat(currentScatters.symbolsPositions));
        this.getRecodeSpinResults().setAvalancheNewSymbols(this._reels[this._currentRound - 1], this._reels[this._currentRound], this._avalanches[this._currentAvalanche].symbolIndexes, this._reelsHeight[this._currentRound - 1], this._reelsHeight[this._currentRound]);
        if (this._currentAvalanche < this._avalanches.length - 1) {
            this._currentAvalanche++;
        }
        this._currentMultiplier++;
    };
    RecodeLogic.prototype.makeNextBonusSymbolsList = function () {
        this.getRecodeSpinResults().setBonusSymbolsList(this._bonusGamesSymbols[this._currentBonusGameSymbols].symbolPositions, this._bonusGame.maxWin, this._bonusGame.openedChests.length > 0 ? this._bonusGame.openedChests[0].amount : 0);
        if (this._currentBonusGameSymbols < this._bonusGamesSymbols.length - 1) {
            this._currentBonusGameSymbols++;
        }
    };
    RecodeLogic.prototype.getPreviousRoundReels = function () {
        return this.getRecodeSpinResults().makeGameReelsFromRecodeReels(this._reels[this._currentRound - 1], this._reelsHeight[this._currentRound - 1]);
    };
    RecodeLogic.prototype.hasScatterAvalanche = function () {
        return this.getCurrentRoundType() === RoundTypes.SCATTER_REPLACEMENT_AND_AVALANCHE;
    };
    RecodeLogic.prototype.hasMultiplierWilds = function () {
        // TODO: This is shit, fix.
        if (this._currentRound === this._totalRounds - 1) {
            return (this._baseWildsMultipliers.length > 0 &&
                this._baseWildsMultipliers[this._currentRound] &&
                this._baseWildsMultipliers[this._currentRound].multipliers.length > 0);
        }
        return (this._baseWildsMultipliers.length > 0 &&
            this._baseWildsMultipliers[this._currentRound] &&
            this._baseWildsMultipliers[this._currentRound].multipliers.length > 0);
    };
    RecodeLogic.prototype.clearAlreadyExpandedWilds = function () {
        this._alreadyExpandedWilds = [];
    };
    RecodeLogic.prototype.addToAlreadyExpandedWilds = function (reelIndex) {
        if (!this.isWildAlreadyExpanded(reelIndex)) {
            this._alreadyExpandedWilds.push(reelIndex);
        }
    };
    RecodeLogic.prototype.removeFromAlreadyExpandedWilds = function (reelIndex) {
        var index = this._alreadyExpandedWilds.indexOf(reelIndex);
        if (index > 0) {
            this._alreadyExpandedWilds.splice(index, 1);
        }
    };
    RecodeLogic.prototype.makeNextAvalancheMultiplier = function () {
        this.getRecodeSpinResults().setCurrentAvalancheMultiplier(this._currentMultiplier);
    };
    RecodeLogic.prototype.systemUpdateBalance = function (newBalance) {
        this._balance = newBalance;
    };
    RecodeLogic.prototype.getTransTotalWin = function () {
        return this._transTotalWin;
    };
    RecodeLogic.prototype.isEnoughMoneyForSpin = function () {
        return this._balance >= this.getTotalBetCents() || this.isInFreeRounds;
    };
    RecodeLogic.prototype.getTotalBetCents = function () {
        return this.betValue / RecodeLogic.CENT_TO_A_DOLLAR;
    };
    RecodeLogic.prototype.getWildSymbol = function () {
        throw new Error('RecodeLogic::getWildSymbol function should be game specific');
    };
    RecodeLogic.prototype.removeExpandedWild = function (reelIndex) {
        this.getRecodeSpinResults().removeExpandedWild(reelIndex);
    };
    RecodeLogic.prototype.finishRoundAfterBonusGame = function () {
        this._previousAction = this._nextAction;
        this._nextAction = Action_1.Action.SPIN;
    };
    RecodeLogic.prototype.hasFreeGames = function () {
        return this._freeGamesData && this._freeGamesData.length > 0;
    };
    RecodeLogic.prototype.hasNextFreeGames = function () {
        if (this.currentFreeGameProgress) {
            var currentGameIndex = this.findFreeGamesIndex(this.currentFreeGameProgress.instanceID, this.currentFreeGameProgress.offerID);
            if (currentGameIndex >= 0) {
                return this._freeGamesData.length > 1;
            }
            return this._freeGamesData.length > 0;
        }
        return this._freeGamesData.length > 1;
    };
    RecodeLogic.prototype.getCurrentFreeGamesData = function () {
        return this._freeGamesData ? this._freeGamesData[0] : null;
    };
    RecodeLogic.prototype.hasExpandingWilds = function () {
        if (this.getSpinResult().expandingWilds.length > 0) {
            for (var _i = 0, _a = this.getSpinResult().expandingWilds; _i < _a.length; _i++) {
                var expWildReel = _a[_i];
                if (!this.isWildAlreadyExpanded(expWildReel.reelIndex)) {
                    return true;
                }
            }
            return false;
        }
        else {
            return false;
        }
    };
    RecodeLogic.prototype.getRecodeSpinResults = function () {
        return this._spin;
    };
    RecodeLogic.prototype.getCurrentRoundType = function () {
        return this._roundTypes[this._currentRound];
    };
    RecodeLogic.prototype.getNextRoundType = function () {
        if (this._currentRound < this._roundTypes.length - 1) {
            return this._roundTypes[this._currentRound + 1];
        }
        return -1;
    };
    RecodeLogic.prototype.getMultiplierForCurrentRound = function () {
        return this.getMultiplierForRound(this._currentRound);
    };
    RecodeLogic.prototype.getCurrentFreeSpinsMultiplier = function () {
        return this._freeSpinsPreviousMultiplier;
    };
    RecodeLogic.prototype.isGameInProgress = function () {
        return this._latestRequest !== 'init';
    };
    RecodeLogic.prototype.postponeFreeGames = function () {
        this._freeGamesData.splice(0, 1);
        if (!this.getCurrentFreeGamesData()) {
            this._freeGamesData = null;
            this._isInFreeRounds = false;
            this._currentFreeGameProgress = null;
        }
        else {
            if (!this._currentFreeGameProgress) {
                this._currentFreeGameProgress = new FreeGamesData_1.FreeGamesInProgress(null);
            }
            this._currentFreeGameProgress.gamesPlayed =
                this.getCurrentFreeGamesData().gamesAwarded - this.getCurrentFreeGamesData().gamesRemaining;
            this._currentFreeGameProgress.offerID = this.getCurrentFreeGamesData().offerID;
            this._currentFreeGameProgress.instanceID = this.getCurrentFreeGamesData().instanceID;
            this._currentFreeGameProgress.gamesRemaining = this.getCurrentFreeGamesData().gamesRemaining;
            this._currentFreeGameProgress.sumWinnings = this.getCurrentFreeGamesData().sumWinnings;
        }
    };
    RecodeLogic.prototype.makeCurrenFreeGamesDataProgress = function () {
        if (!this._currentFreeGameProgress) {
            this._currentFreeGameProgress = this.createNewFreeGameInProgress(null);
        }
        this._currentFreeGameProgress.gamesPlayed =
            this.getCurrentFreeGamesData().gamesAwarded - this.getCurrentFreeGamesData().gamesRemaining;
        this._currentFreeGameProgress.offerID = this.getCurrentFreeGamesData().offerID;
        this._currentFreeGameProgress.instanceID = this.getCurrentFreeGamesData().instanceID;
        this._currentFreeGameProgress.gamesRemaining = this.getCurrentFreeGamesData().gamesRemaining;
        this._currentFreeGameProgress.sumWinnings = this.getCurrentFreeGamesData().sumWinnings;
    };
    RecodeLogic.prototype.finishCurrentFreeGames = function () {
        if (this.currentFreeGameProgress) {
            var currentGameIndex = this.findFreeGamesIndex(this.currentFreeGameProgress.instanceID, this.currentFreeGameProgress.offerID);
            if (currentGameIndex >= 0) {
                this._freeGamesData.splice(currentGameIndex, 1);
            }
        }
        this.setupFreeGameAfterFinishingCurrent();
    };
    RecodeLogic.prototype.init = function (cb) {
        var _this = this;
        this.parsePlayerSavedData();
        this._latestRequest = 'init';
        this._communicator.init(this._gameName, function (data) {
            // Check if there is an initialization error before anything else.
            if (data.Id.attributes.verb === 'Error') {
                if (false) {
                    console.log(data);
                }
                _this.parseError(data);
            }
            // Stop it here and don't continue. All errors are fatal in Recode.
            if (_this._hasError && _this._isFatalError) {
                return;
            }
            _this._freeGamesData = [];
            _this.parseFreeGames(data);
            if (_this._freeGamesData.length > 0 && data.Response.FreeGames.CurrentGame) {
                _this._currentFreeGameProgress = _this.createNewFreeGameInProgress(data);
                if (_this._currentFreeGameProgress.gamesRemaining === 0) {
                    _this._hasRestore = false;
                }
            }
            else {
                _this.parseExpiredGames(data);
                if (_this._currentFreeGameProgress && _this._currentFreeGameProgress.gamesRemaining === 0) {
                    _this._hasRestore = false;
                }
            }
            if (!_this.isCurrentGameInFreeGamesList()) {
                if (!_this.shouldShowCurrentFreeSpinsFinishedScreen() && !_this._hasExpiredFreeGames) {
                    _this._currentFreeGameProgress = null;
                }
            }
            _this._spin = _this.createSpinResult();
            _this.parseInit(data);
            if (_this._hasRestore) {
                _this.restoreRecodeBet();
            }
            if (_this.mustRestoreAfterBonusGame()) {
                // this._isRestoreAfterBonusGame = true;
                // this._hasRestore = true;
                // this.makeNextBonusSymbolsList();
                // this._roundTypes.push(RoundTypes.BONUS);
                // if (this._roundTypes.length === 2) {
                // 	this.setNextAction();
                // }
            }
            else {
                _this._isRestoreAfterBonusGame = false;
            }
            if (_this._gameState === 2 &&
                _this.hasFreeGames() &&
                _this._currentFreeGameProgress &&
                _this._currentFreeGameProgress.gamesRemaining > 0) {
                _this._hasBonusGameFreeGamesRestore = true;
                _this._hasRestore = false;
            }
            if (_this._gameState === 2 && _this._bonusGame.openedChests.length === 0) {
                _this._spin = _this.createSpinResult();
                _this.parseSpin(data);
                cb && cb(data);
                _this._eventManager.emit(LogicEvents_1.LogicEvents.INIT_RESPONSE);
            }
            else {
                cb && cb(data);
                _this._eventManager.emit(LogicEvents_1.LogicEvents.INIT_RESPONSE);
            }
        });
    };
    RecodeLogic.prototype.saveData = function () {
        // TODO: Get the last autoplay value.
        var autoplayData = { autoplayValue: this.autoplayDefault };
        // TODO: Verify if lastbet is correct.
        var lastBet = this.betValue;
        var lastBetWasMaxBet = this.isMaxBet(this.betValue);
        var lastAutoplayAmount = this.lastAutoplayAmount;
        var soundActive = this.soundEffectsActive;
        var musicActive = this.musicActive;
        var soundAllActive = this.soundAllActive;
        var skipIntro = this.skipIntro;
        var spacebarSpinActive = this.spacebarSpinActive;
        var dragReelToSpinActive = this.dragReelToSpinActive;
        var quickStopActive = this.quickStopActive;
        var fastPlayActive = this.fastPlayActive;
        var data = {
            playerData: {
                autoplayData: autoplayData,
                lastBet: lastBet,
                lastBetWasMaxBet: lastBetWasMaxBet,
                lastAutoplayAmount: lastAutoplayAmount,
                soundActive: soundActive,
                musicActive: musicActive,
                soundAllActive: soundAllActive,
                skipIntro: skipIntro,
                spacebarSpinActive: spacebarSpinActive,
                dragReelToSpinActive: dragReelToSpinActive,
                quickStopActive: quickStopActive,
                fastPlayActive: fastPlayActive,
            },
        };
        this._storage.setItem("FNG_" + this._gameName, JSON.stringify(data));
    };
    /**
     * returns true if coin size changed dialog was shown
     * @param callback
     */
    RecodeLogic.prototype.validatePreviousBet = function (callback) {
        if (callback === void 0) { callback = function () { }; }
        if (this.isInFreeRounds) {
            return false;
        }
        if (this.lastRealWager &&
            typeof this.lastRealWager.numChips !== 'undefined' &&
            typeof this.lastRealWager.chipSize !== 'undefined') {
            this._numChips = this.lastRealWager.numChips;
            this._chipSize = this.lastRealWager.chipSize;
            // this._betMultiplier = this.lastRealWager.activePaylines;
        }
        var lastBet = this.getRecodeCurrentBet();
        var isBetValueNotValid = !this.isValidBetValue(lastBet);
        return this.setValidBet(lastBet, isBetValueNotValid, callback);
    };
    RecodeLogic.prototype.recodeFreeGamesBonusGameRestore = function () {
        this._hasRestore = true;
        this._freeGamesBonusGameRestoreCallback();
        this._hasBonusGameFreeGamesRestore = false;
    };
    RecodeLogic.prototype.recodeFreeGamesBonusGameRestoreRejected = function () {
        this._hasBonusGameFreeGamesRestore = false;
        this._gameState = 0;
        this._previousAction = this._nextAction;
        this._nextAction = Action_1.Action.SPIN;
    };
    RecodeLogic.prototype.recodeExpireGame = function (instanceID, offerID) {
        if (this.currentFreeGameProgress &&
            this.currentFreeGameProgress.instanceID === instanceID &&
            this.currentFreeGameProgress.offerID === offerID) {
            this._currentFreeGameProgress = null;
        }
        var freeGameIndex = this.findFreeGamesIndex(instanceID, offerID);
        if (freeGameIndex >= 0) {
            this._freeGamesData.splice(freeGameIndex, 1);
        }
        this.setupFreeGameAfterFinishingCurrent();
    };
    RecodeLogic.prototype.spin = function (cb) {
        var _this = this;
        this._latestRequest = 'spin';
        this.preSpinBalance = this.currentBalance;
        this.saveData();
        if (this.freeSpinsLeft > 0) {
            this.freespin(cb);
            return;
        }
        var currentFreeGames;
        if (this.isInFreeRounds) {
            currentFreeGames = this.currentFreeGameProgress
                ? this.findFreeGame(this.currentFreeGameProgress.instanceID, this.currentFreeGameProgress.offerID)
                : this.getCurrentFreeGamesData();
        }
        this._communicator.spin(this._gameName, this._sessionID, this.getRecodeBet(this.betValue), function (data) {
            _this.getRecodeSpinResults().cleanup();
            _this.setSpin(_this.createSpinResult());
            _this.parseSpin(data);
            if (_this._isInFreeRounds) {
                _this._currentFreeGameProgress = _this.createNewFreeGameInProgress(data);
            }
            else {
                _this._currentFreeGameProgress = null;
            }
            if (_this._hasError) {
                return;
            }
            cb && cb(data);
            _this._eventManager.emit(LogicEvents_1.LogicEvents.SPIN_RESPONSE);
        }, currentFreeGames);
    };
    RecodeLogic.prototype.freespin = function (cb) {
        var _this = this;
        this._latestRequest = 'freespin';
        this.saveData();
        this._communicator.freespin(function (data) {
            _this.getRecodeSpinResults().cleanup();
            _this.setSpin(_this.createSpinResult());
            _this.parseSpin(data);
            if (_this._hasError) {
                return;
            }
            cb && cb(data);
            _this._eventManager.emit(LogicEvents_1.LogicEvents.SPIN_RESPONSE);
            // this._eventManager.emit(LogicEvents.FREE_SPIN_RESPONSE); // Setup Listeners
        });
    };
    RecodeLogic.prototype.respin = function (cb) {
        // this.makeNextScattersList();
        var _this = this;
        setTimeout(function () {
            cb && cb(null);
            _this._eventManager.emit(LogicEvents_1.LogicEvents.RESPIN_RESPONSE);
        });
    };
    RecodeLogic.prototype.pick = function (cb, pickId) {
        var _this = this;
        if (pickId === void 0) { pickId = null; }
        this._latestRequest = 'pick';
        if (!pickId) {
            pickId = this._bonusGame.openedChests.length > 0 ? this._bonusGame.openedChests[this._bonusGame.openedChests.length - 1].id : 0;
        }
        this._communicator.pick(pickId, function (data) {
            _this.setSpin(_this.createSpinResult());
            _this.parseSpin(data);
            if (_this._hasError) {
                return;
            }
            _this.tryToParseFreeGameInProgress(data);
            cb && cb(null);
            _this._eventManager.emit(LogicEvents_1.LogicEvents.PICK_RESPONSE);
        }, null);
    };
    RecodeLogic.prototype.skippick = function (cb) {
        var _this = this;
        this._latestRequest = 'skippick';
        var latestPickID = this._bonusGame.openedChests.length > 0 ? this._bonusGame.openedChests[this._bonusGame.openedChests.length - 1].id : 0;
        if (this._bonusGame.remaining.length > 1) {
            this._communicator.skippick(latestPickID, function (data) {
                cb && cb(null);
                _this._eventManager.emit(LogicEvents_1.LogicEvents.SKIPPICK_RESPONSE);
            }, null);
        }
        else {
            // Test if final chest works when we send a pick event.
            // Last chest is auto-picked on server once we send the skippick for second-to-last chest. (as described in math doc) So sending anything other will result in Error as a response.
            this._communicator.skippick(latestPickID, function (data) {
                _this.setSpin(_this.createSpinResult());
                _this.parseSpin(data);
                if (_this._hasError) {
                    return;
                }
                _this.tryToParseFreeGameInProgress(data);
                cb && cb(null);
                _this._eventManager.emit(LogicEvents_1.LogicEvents.SKIPPICK_RESPONSE);
            }, null);
        }
    };
    RecodeLogic.prototype.tryToParseFreeGameInProgress = function (data) {
        if (this._isInFreeRounds) {
            this._currentFreeGameProgress = this.createNewFreeGameInProgress(data);
        }
        else {
            this._currentFreeGameProgress = null;
        }
    };
    RecodeLogic.prototype.replaceElementInToChooseList = function (chooseIndex, remainingList) {
        if (remainingList && remainingList.length >= 3) {
            this._bonusSymbolsToChoose[chooseIndex] = remainingList[2];
        }
        else {
            this._bonusSymbolsToChoose[chooseIndex] = null;
        }
    };
    RecodeLogic.prototype.setupFreeGameAfterFinishingCurrent = function () {
        if (!this.getCurrentFreeGamesData()) {
            this._freeGamesData = null;
            this._isInFreeRounds = false;
            this._currentFreeGameProgress = null;
        }
        else {
            if (!this._currentFreeGameProgress) {
                this._currentFreeGameProgress = new FreeGamesData_1.FreeGamesInProgress(null);
            }
            this._currentFreeGameProgress.gamesPlayed =
                this.getCurrentFreeGamesData().gamesAwarded - this.getCurrentFreeGamesData().gamesRemaining;
            this._currentFreeGameProgress.offerID = this.getCurrentFreeGamesData().offerID;
            this._currentFreeGameProgress.instanceID = this.getCurrentFreeGamesData().instanceID;
            this._currentFreeGameProgress.gamesRemaining = this.getCurrentFreeGamesData().gamesRemaining;
            this._currentFreeGameProgress.sumWinnings = this.getCurrentFreeGamesData().sumWinnings;
        }
    };
    RecodeLogic.prototype.findFreeGamesIndex = function (instanceID, offerID) {
        if (this._freeGamesData) {
            var index = 0;
            for (var _i = 0, _a = this._freeGamesData; _i < _a.length; _i++) {
                var fg = _a[_i];
                if (fg.instanceID === instanceID && fg.offerID === offerID) {
                    return index;
                }
                index++;
            }
        }
        return -1;
    };
    RecodeLogic.prototype.findFreeGame = function (instanceID, offerID) {
        var index = 0;
        for (var _i = 0, _a = this._freeGamesData; _i < _a.length; _i++) {
            var fg = _a[_i];
            if (fg.instanceID === instanceID && fg.offerID === offerID) {
                return fg;
            }
            index++;
        }
        return null;
    };
    RecodeLogic.prototype.restoreRecodeBet = function () {
        var lastBet = this.getRecodeCurrentBet();
        // const test = !this.hasRestore && !this.isValidBetValue(lastBet);
        // this.setValidBet(lastBet, test);
        this.setValidBet(lastBet, false);
    };
    RecodeLogic.prototype.createSpinResult = function () {
        return new RecodeSpinResult_1.RecodeSpinResult();
    };
    RecodeLogic.prototype.createStorage = function () {
        this._storage = new ReCodeStorage_1.ReCodeStorage(window.V.API.Storage);
    };
    RecodeLogic.prototype.createCurrencyFormatter = function () {
        this._currencyFormatter = new RecodeCurrencyFormatter_1.RecodeCurrencyFormatter();
    };
    RecodeLogic.prototype.stringListToInt = function (stringList) {
        var resultList = [];
        for (var _i = 0, stringList_1 = stringList; _i < stringList_1.length; _i++) {
            var value = stringList_1[_i];
            if (value.toLocaleLowerCase() === 'none') {
                resultList.push(0);
            }
            else {
                resultList.push(parseInt(value, 10));
            }
        }
        return resultList;
    };
    RecodeLogic.prototype.stringListToFloat = function (stringList) {
        var resultList = [];
        for (var _i = 0, stringList_2 = stringList; _i < stringList_2.length; _i++) {
            var value = stringList_2[_i];
            if (value.toLocaleLowerCase() === 'none') {
                resultList.push(0);
            }
            else {
                resultList.push(parseFloat(value));
            }
        }
        return resultList;
    };
    RecodeLogic.prototype.initAutoplayValues = function () {
        var autoplayValues = this.communicator.getAutoplayData();
        var enabled = autoplayValues.enabled;
        var winLimitsAmounts = this.stringListToInt(autoplayValues.winLimitAmounts);
        var lossLimitsAmounts = this.stringListToInt(autoplayValues.lossLimitAmounts);
        ///////////////////////////////////////////////////////////////////////
        // As per AT1 in Medallion. WIN and LOSS limits should be in "dollars".
        winLimitsAmounts.forEach(function (item, index, array) {
            array[index] = item * RecodeLogic.CENT_TO_A_DOLLAR;
        });
        lossLimitsAmounts.forEach(function (item, index, array) {
            array[index] = item * RecodeLogic.CENT_TO_A_DOLLAR;
        });
        var winLimitDefault = parseInt(autoplayValues.winLimitDefault, 10) * RecodeLogic.CENT_TO_A_DOLLAR;
        var lossLimitDefault = parseInt(autoplayValues.lossLimitDefault, 10) * RecodeLogic.CENT_TO_A_DOLLAR;
        ///////////////////////////////////////////////////////////////////////
        var winLimitEnabled = autoplayValues.winLimitEnabled;
        var lossLimitEnabled = autoplayValues.lossLimitEnabled;
        var spinDefault = autoplayValues.spinCount[0];
        var spinCount = autoplayValues.spinCount;
        var untilStop = autoplayValues.untilStop;
        var maxSpinsUntilStop = parseInt(autoplayValues.maxSpinsUntilStop, 10);
        var alwaysDisplayCustomScreen = autoplayValues.alwaysDisplayCustomScreen;
        var hasCustom = autoplayValues.hasCustom;
        var useWagerLimitApi = autoplayValues.useWagerLimitApi;
        this._autoplayData = {
            enabled: enabled,
            spinCount: spinCount,
            spinDefault: spinDefault,
            untilStop: untilStop,
            maxSpinsUntilStop: maxSpinsUntilStop,
            winLimitEnabled: winLimitEnabled,
            winLimitsAmounts: winLimitsAmounts,
            winLimitDefault: winLimitDefault,
            lossLimitEnabled: lossLimitEnabled,
            lossLimitDefault: lossLimitDefault,
            lossLimitsAmounts: lossLimitsAmounts,
        };
        this._recodeAutoplayExtraData = {
            hasCustom: hasCustom,
            alwaysDisplayCustomScreen: alwaysDisplayCustomScreen,
            useWagerLimitApi: useWagerLimitApi,
        };
    };
    RecodeLogic.prototype.getRecodeBet = function (bet) {
        var betItem = this._recodeBetValues.find(function (item) { return item.totalValue === bet; });
        return betItem;
    };
    RecodeLogic.prototype.addDefaultValues = function () {
        this._balance = 1000;
        this._betValue = 1;
        this._betLevel = 1;
        this._win = 0;
        this.autoplayDefault = 25;
        this.autoplayValues = [10, 25, 50, 100, 200, 500];
    };
    RecodeLogic.prototype.createCommunicator = function (communicator) {
        this._communicator = communicator;
        // (window as any).fake = this._communicator;
        if (this._queryStringHandler) {
            this.setCommunicatorValues();
        }
    };
    RecodeLogic.prototype.createNewFreeGameInProgress = function (data) {
        var freeGames = new FreeGamesData_1.FreeGamesInProgress(data);
        this.lastRealWager = freeGames.lastRealWager ? freeGames.lastRealWager : this.lastRealWager;
        return freeGames;
    };
    RecodeLogic.prototype.setValidBet = function (bet, isBetValueNotValid, callback) {
        if (callback === void 0) { callback = function () { }; }
        if (isBetValueNotValid) {
            // If the last selected bet value is invalid. Pick the closest available bet value instead. Unless last bet was a MAX bet. Then go with that.
            // Just go to closest bet. Max bet caused some weird issues in some cases. (like 0.5$ being max and it restored to 1000$).
            // (window as any).V.API.Dialog.showCoinSizeChangedDialog(callback);
            this._communicator.api_showCoinSizeChangedDialog(callback);
            // bet = this._lastBetWasMaxBet ? this.getMaxValidBet() : this.getClosestBet(bet);
            bet = this.getClosestBet(bet);
        }
        this._betValue = bet;
        this._lastBet = this._betValue;
        this.saveData();
        if (!isBetValueNotValid && callback) {
            callback();
        }
        return isBetValueNotValid;
    };
    RecodeLogic.prototype.mustRestoreAfterBonusGame = function () {
        return (this.hasRestore &&
            this.gameState === 0 &&
            this.recodeBonusGame &&
            this.recodeBonusGame.openedChests &&
            this.recodeBonusGame.openedChests.length > 0);
    };
    RecodeLogic.prototype.shouldShowCurrentFreeSpinsFinishedScreen = function () {
        return !this.isCurrentGameInFreeGamesList() && this._currentFreeGameProgress && this._currentFreeGameProgress.gamesRemaining === 0;
    };
    RecodeLogic.prototype.isCurrentGameInFreeGamesList = function () {
        if (this._currentFreeGameProgress) {
            for (var _i = 0, _a = this._freeGamesData; _i < _a.length; _i++) {
                var currentFG = _a[_i];
                if (currentFG.instanceID === this._currentFreeGameProgress.instanceID &&
                    currentFG.offerID === this._currentFreeGameProgress.offerID) {
                    return true;
                }
            }
        }
        return false;
    };
    RecodeLogic.prototype.parseFreeGames = function (data) {
        this._serverTime = '';
        if (data.Response && data.Response.FreeGames && data.Response.FreeGames.Games && data.Response.FreeGames.Games.FreeGame) {
            if (!data.Response.FreeGames.Games.FreeGame.length) {
                data.Response.FreeGames.Games.FreeGame = [data.Response.FreeGames.Games.FreeGame];
            }
            if (data.Response.FreeGames.Games.attributes.serverTime) {
                this._serverTime = data.Response.FreeGames.Games.attributes.serverTime;
            }
            for (var _i = 0, _a = data.Response.FreeGames.Games.FreeGame; _i < _a.length; _i++) {
                var freeGameData = _a[_i];
                var freeGame = new FreeGamesData_1.FreeGamesData(freeGameData);
                if (this._serverTime) {
                    var serverTimer = GameUtils_1.GameUtils.unixDateToSeconds(this.serverTime);
                    var endTime = GameUtils_1.GameUtils.unixDateToSeconds(freeGame.endDate);
                    var timeBeforeExpiration = endTime - serverTimer;
                    if (timeBeforeExpiration > 0) {
                        this._freeGamesData.push(new FreeGamesData_1.FreeGamesData(freeGameData));
                    }
                }
                else {
                    this._freeGamesData.push(new FreeGamesData_1.FreeGamesData(freeGameData));
                }
            }
        }
    };
    RecodeLogic.prototype.parseExpiredGames = function (data) {
        this._currentFreeGameProgress = null;
        if (data.Response && data.Response.FreeGames && data.Response.FreeGames.Games && !data.Response.FreeGames.Games.FreeGame) {
            this._currentFreeGameProgress = this.createNewFreeGameInProgress(data);
            this._hasExpiredFreeGames = true;
        }
    };
    RecodeLogic.prototype.cleanup = function () { };
    RecodeLogic.prototype.parseSpin = function (data) {
        ////////////////////////////////////////////////////////////////////
        // Custom Spin override
        ////////////////////////////////////////////////////////////////////
        if (false) {
            if (document.spinOverride) {
                data = document.spinOverride;
            }
            if (!document.previousSpins || document.previousSpins.length < 1) {
                document.previousSpins = [];
            }
            document.previousSpins.push(data);
            document.lastSpinData = data;
            console.log('spin');
            console.log(data);
        }
        ////////////////////////////////////////////////////////////////////
        // End of override
        ////////////////////////////////////////////////////////////////////
        this.cleanup();
        this._bonusGame = null;
        this.parseID(data.Id.attributes);
        this.parseResponse(data);
        if (this._hasError) {
            return;
        }
        this.setResultsForCurrentRound();
    };
    RecodeLogic.prototype.parseInit = function (data) {
        ////////////////////////////////////////////////////////////////////
        // Custom Spin override
        ////////////////////////////////////////////////////////////////////
        if (false) {
            console.log('Init:', data);
            if (document.spinOverride) {
                data = document.spinOverride;
            }
            if (!document.previousSpins || document.previousSpins.length < 1) {
                document.previousSpins = [];
            }
            document.previousSpins.push(data);
            document.lastSpinData = data;
        }
        ////////////////////////////////////////////////////////////////////
        // End of override
        ////////////////////////////////////////////////////////////////////
        this._reelsIndexOffset = 0;
        this.clearAlreadyExpandedWilds();
        this.parseID(data.Id.attributes);
        this.parseResponse(data);
        this.restoreRecodeBet();
        this.initAutoplayDefaultValues();
        this.setupPaytable();
        this.setInitResults();
        if (this._hasRestore) {
            this.setResultsForCurrentRound();
        }
    };
    RecodeLogic.prototype.changeCurrentReelsetToFirstOfFreeSpins = function () {
        for (var i = 0; i < this._reelTypes.length; i++) {
            if (this._reelTypes[i] === ReelsTypes.FREESPIN) {
                this._reelsIndexOffset = i;
                return;
            }
        }
    };
    RecodeLogic.prototype.setupPaytable = function () { };
    RecodeLogic.prototype.parseID = function (data) {
        this._sessionID = data.sessionid;
    };
    RecodeLogic.prototype.parsePaytable = function (data) {
        this._paytable = {};
        for (var symbol in data) {
            if (data.hasOwnProperty(symbol)) {
                var element = data[symbol];
                var symbolValues = { id: element.id, values: {} };
                for (var count in element.values) {
                    if (element.values.hasOwnProperty(count)) {
                        var winAmount = element.values[count];
                        symbolValues.values[count] = winAmount;
                    }
                }
                this._paytable["" + symbol.toString()] = symbolValues;
            }
        }
    };
    RecodeLogic.prototype.parseResponse = function (data) {
        this._hasRestore = false;
        this._isRestoreAfterBonusGame = false;
        this._wildMeter = 0;
        var dataResponse = data.Response;
        if (data.Id.attributes.verb === 'Error') {
            this.parseError(data);
        }
        if (!dataResponse.Error) {
            this.parseSlot(dataResponse.Slot);
        }
        if (dataResponse.Tokens) {
            this.parseTokens(dataResponse.Tokens);
        }
        this.prepareInGameProgressValues();
        if (dataResponse.InGameProgress) {
            this.parseInGameProgress(dataResponse.InGameProgress);
            if (this.hasRestoreCondition()) {
                this._hasRestore = true;
                this.prepareFreeSpinsRestoreData(data);
            }
            if (this.isFreeSpinsStarted && this._latestRequest === 'init' && this.freeSpinsLeft < this.freespinsTotalAwarded) {
                this._freeSpinsPreviousMultiplier = this._freeSpinsMultiplier - this.getNumberOfMultiplierIncreasingRounds();
            }
        }
        else if (this.hasRestoreCondition()) {
            this._hasRestore = true;
            this.prepareFreeSpinsRestoreData(data);
        }
        else {
            // TODO: Remove if Recode provides symbol sizes.
            this.tempInitSymbolSizes();
        }
        if (!dataResponse.Error) {
            this.parseGameState(dataResponse.Game);
            this.parsePlayerData(dataResponse.Player);
            this.parseBet(dataResponse.Bet);
            this._hasError = false;
        }
        if (this._latestRequest === 'init') {
            this.setValidBetValues();
            this.parseDefaultBet();
        }
        if (dataResponse.BonusGames && dataResponse.BonusGames.Bonus) {
            this.parseBonus(dataResponse.BonusGames.Bonus);
        }
        // adding bonus game to game round types
        if (this._gameState === 2) {
            // this._roundTypes.push(RoundTypes.BONUS);
        }
        if (this._gameState === 3) {
            // this._roundTypes.push(RoundTypes.FREESPIN);
        }
    };
    RecodeLogic.prototype.prepareFreeSpinsRestoreData = function (data) {
        if (this._freespinsTotalAwarded > 0 && (this._freeSpinsLeft || this.hasRestore)) {
            this._isFreeSpinsStarted = true;
            this._freeSpinsMultiplier = Number.parseInt(data.Response.Slot.attributes.multiplier, 10);
        }
        if (this.shouldRemovePreviousRoundWin()) {
            this._wins = [];
            this._roundTypes = [0];
            this._avalanches = [];
            this._expandedWildsMultipliers = [];
        }
    };
    RecodeLogic.prototype.hasFreeSpinsRestoreCondition = function () {
        return this._freespinsTotalAwarded > 0 && this._freeSpinsLeft > 0;
    };
    RecodeLogic.prototype.hasRestoreCondition = function () {
        return (!this._hasBonusGameFreeGamesRestore &&
            this._latestRequest === 'init' &&
            (this._roundTypes.length > 1 ||
                (this._gameState !== 0 && this._gameState !== undefined) ||
                this._win > 0 ||
                this.hasFreeSpinsRestoreCondition()));
    };
    RecodeLogic.prototype.shouldRemovePreviousRoundWin = function () {
        return this.isFreeSpinsStarted && this._freespinsTotalAwarded === this._freeSpinsLeft;
    };
    RecodeLogic.prototype.parseError = function (data) {
        var errordata = data.Response.Error;
        if (errordata.attributes.servercode === '512') {
            this._isFatalError = false;
            this._communicator.api_showErrorMessage(errordata);
        }
        else {
            this._isFatalError = true;
            // Added for handling unknown errors.
            var includeErrorText = false;
            if (false) {
                includeErrorText = errordata.attributes.text;
            }
            var errorDetails = window.V.API.Core.getErrorDetails(data, includeErrorText);
            window.V.API.Core.handleFatalError(errorDetails);
        }
        this._hasError = true;
    };
    RecodeLogic.prototype.parseBonus = function (data) {
        var _this = this;
        this._bonusGame = {
            actionState: Number.parseInt(data.attributes.actionState, 10),
            bonusName: data.attributes.bonusName,
            chests: Number.parseInt(data.attributes.chests, 10),
            maxPrize: Number.parseInt(data.attributes.maxPrize, 10),
            maxWin: Number.parseInt(data.attributes.maxWin, 10),
            prize: Number.parseInt(data.attributes.prize, 10),
            remaining: [],
            state: Number.parseInt(data.attributes.state, 10),
            win: this.parseDollar(data.attributes.win),
            openedChests: [],
        };
        if (data.attributes.remaining && data.attributes.remaining.length > 0) {
            var remaining = data.attributes.remaining.split(',');
            remaining.forEach(function (value) {
                _this._bonusGame.remaining.push(Number.parseInt(value, 10));
            });
        }
        if (data.Chests && data.Chests.Chest) {
            this.parseChests(data.Chests.Chest);
        }
    };
    RecodeLogic.prototype.parseChests = function (data) {
        if (!data.length) {
            data = [data];
        }
        for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
            var chest = data_1[_i];
            var index = Number.parseInt(chest.attributes.id, 10);
            var amount = Number.parseInt(chest.attributes.amount, 10);
            var prize = Number.parseInt(chest.attributes.prize, 10);
            var state = Number.parseInt(chest.attributes.amount, 10);
            this._bonusGame.openedChests.push({
                id: index,
                amount: amount,
                prize: prize,
                state: state,
            });
        }
    };
    RecodeLogic.prototype.parseGameState = function (data) {
        this._gameState = Number.parseInt(data.attributes.state, 10);
    };
    RecodeLogic.prototype.parsePlayerData = function (data) {
        // this._balance = this.parseDollar(data.attributes.balance);
        this._balance = parseInt(data.attributes.balance, 10); // Should be received in "cents"
        this._loyalty = data.attributes.loyalty;
        this._userID = data.attributes.userID;
        this._transNumber = data.attributes.transNumber;
        this._totalWin = this.parseDollar(data.attributes.totalWin);
        this._type = data.attributes.type;
        this._currency = data.attributes.currency;
    };
    RecodeLogic.prototype.parseDefaultBet = function () {
        this._defaultBet = this.isValidBetValue(0.5) ? 0.5 : this.getLowerBet(0.5);
    };
    RecodeLogic.prototype.parseBet = function (data) {
        // chipSize: int
        // The chip / coin size for the current bet.
        var _this = this;
        // numChips: int
        // The number of chips / coins for the current bet.
        // activePaylines: string
        //    This is a list of the current active pay lines for the bet which will contain the player’s current selection.
        // maxChips: int
        // This is the maximum value that service will accept when specifying numChips in any incoming packet.
        // minChips: int
        // This is the minimum value that service will accept when specifying numChips in any incoming packet.
        // slotBetMethod: int
        // This value can be ignored by the client.
        // paylines: int
        // The maximum number of pay lines.
        // multiplier: int
        // Used as the ways multiplier or an alternative cost value to the number of pay lines.
        // This value will only be in the Refresh data if your bet profile requires it.
        // validChips: string
        // This is a list of comma separated chip sizes.
        // These are the values that the service will accept when specifying chipSize in any incoming packet.
        this._chipSize = Number.parseInt(data.attributes.chipSize, 10);
        this._numChips = Number.parseInt(data.attributes.numChips, 10);
        this._maxChips = Number.parseInt(data.attributes.maxChips, 10);
        this._minChips = Number.parseInt(data.attributes.minChips, 10);
        this._slotBetMethod = Number.parseInt(data.attributes.slotBetMethod, 10); // Unused
        this._paylines = Number.parseInt(data.attributes.paylines, 10);
        if (this._betMultiplier > 0 && !data.attributes.multiplier) {
            // do nothing
        }
        else {
            this._betMultiplier = data.attributes.multiplier
                ? Number.parseInt(data.attributes.multiplier, 10)
                : RecodeLogic.BET_WAYS_MULTIPLIER;
        }
        if (data.attributes.validChips) {
            var chips = data.attributes.validChips.split(',');
            this._validChips = [];
            chips.forEach(function (value) {
                _this._validChips.push(Number.parseInt(value, 10));
            });
        }
    };
    RecodeLogic.prototype.setValidBetValues = function () {
        this._betValues = [];
        this._recodeBetValues = [];
        for (var chip = this._minChips; chip <= this._maxChips; chip++) {
            for (var chipItem in this._validChips) {
                if (this._validChips.hasOwnProperty(chipItem)) {
                    var chipSize = this._validChips[chipItem];
                    var numChips = chip;
                    var totalValue = GameUtils_1.GameUtils.truncateValue(this.calculateTotalBetValueFromChipsNumChipsMultiplier(chipSize, numChips), 2);
                    var betItem = {
                        chipSize: chipSize,
                        numChips: numChips,
                        totalValue: totalValue,
                    };
                    if (this._betValues.indexOf(totalValue) === -1) {
                        this._betValues.push(totalValue);
                        this._recodeBetValues.push(betItem);
                    }
                }
            }
        }
        this._betValues.sort(function (a, b) {
            return a - b;
        });
    };
    RecodeLogic.prototype.calculateTotalBetValueFromChipsNumChipsMultiplier = function (chipSize, numChips) {
        return chipSize * numChips * this._betMultiplier * RecodeLogic.CENT_TO_A_DOLLAR;
    };
    RecodeLogic.prototype.getRecodeCurrentBet = function () {
        return GameUtils_1.GameUtils.truncateValue(this.calculateTotalBetValueFromChipsNumChipsMultiplier(this._chipSize, this._numChips), 2);
    };
    Object.defineProperty(RecodeLogic.prototype, "numChips", {
        get: function () {
            return this._numChips;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecodeLogic.prototype, "chipSize", {
        get: function () {
            return this._chipSize;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecodeLogic.prototype, "validChips", {
        get: function () {
            return this._validChips;
        },
        enumerable: true,
        configurable: true
    });
    RecodeLogic.prototype.isValidChipValue = function (chip) {
        return this._validChips.indexOf(chip) > -1;
    };
    RecodeLogic.prototype.isValidBetValue = function (betValue) {
        return this._betValues.indexOf(betValue) > -1;
    };
    RecodeLogic.prototype.getMinimumValidBet = function () {
        return this._betValues[0];
    };
    RecodeLogic.prototype.getMaxValidBet = function () {
        return this._betValues[this._betValues.length - 1];
    };
    RecodeLogic.prototype.parseDollar = function (value) {
        return Number.parseInt(value, 10) * RecodeLogic.CENT_TO_A_DOLLAR;
    };
    RecodeLogic.prototype.parseSlot = function (data) {
        this._win = this.parseDollar(data.attributes.win);
        this._transTotalWin = this.parseDollar(data.attributes.transTotalWin);
        this._stage = data.attributes.stage;
        this._nextStage = data.attributes.nextStage;
        this._multiplier = Number.parseInt(data.attributes.multiplier, 10);
        this._freespinsTotalAwarded = Number.parseInt(data.attributes.freeSpinTotalAwarded, 10);
        this._freeSpinsTotalWin = this.parseDollar(data.attributes.freeSpinTotalWin);
        this._freeSpinsLeft = Number.parseInt(data.attributes.freeSpins, 10);
        if (this._latestRequest === 'freespin') {
            this._freeSpinsPreviousMultiplier = this._freeSpinsMultiplier;
        }
        else {
            this._freeSpinsPreviousMultiplier = 1;
        }
        if (this.isFreeSpinsStarted) {
            this._freeSpinsMultiplier = Number.parseInt(data.attributes.multiplier, 10);
        }
        else {
            this._freeSpinsMultiplier = 1;
        }
        if (false) {
            console.warn(data.attributes);
        }
        this._scatterReplacements = [];
        this._currentScatterReplacement = 0;
        this._bonusGamesSymbols = [];
        this._currentBonusGameSymbols = 0;
        this._wins = [];
        this.parseResultSets(data);
        if (data.Wins) {
            this.parseWins(data.Wins);
        }
    };
    RecodeLogic.prototype.getNumberOfMultiplierIncreasingRounds = function () {
        var rounds = 0;
        for (var _i = 0, _a = this._roundTypes; _i < _a.length; _i++) {
            var val = _a[_i];
            if (val === RoundTypes.SCATTER_REPLACEMENT_AND_AVALANCHE ||
                val === RoundTypes.AVALANCHE ||
                val === RoundTypes.SCATTER_REPLACEMENT) {
                rounds++;
            }
        }
        return rounds;
    };
    RecodeLogic.prototype.parseResultSets = function (data) {
        this._reels = [];
        var stage = data.attributes.stage;
        var results = data.ResultSets.Result;
        var reelsIndex = 0;
        for (var _i = 0, results_1 = results; _i < results_1.length; _i++) {
            var res = results_1[_i];
            var name_1 = res.attributes.name;
            if (name_1.includes(stage)) {
                if (!res.Reels) {
                    continue;
                }
                if (!res.Reels.length) {
                    res.Reels = [res.Reels];
                }
                for (var _a = 0, _b = res.Reels; _a < _b.length; _a++) {
                    var reel = _b[_a];
                    this._reels[reelsIndex] = [];
                    var reelSymbols = reel.attributes.symbols.split(',');
                    for (var _c = 0, reelSymbols_1 = reelSymbols; _c < reelSymbols_1.length; _c++) {
                        var sym = reelSymbols_1[_c];
                        this._reels[reelsIndex].push(Number.parseInt(sym, 10));
                    }
                    reelsIndex++;
                }
            }
        }
    };
    RecodeLogic.prototype.parseSymbolsPerReel = function (symbolsPerReel) {
        // TEMP: Also set waystowin here.
        this._waysRounds = [];
        var symbols = symbolsPerReel.split(',');
        this._symbolsPerReel = [];
        var waysToWin = 1;
        for (var _i = 0, symbols_1 = symbols; _i < symbols_1.length; _i++) {
            var symbol = symbols_1[_i];
            var height = parseInt(symbol, 10);
            if (!isNaN(height)) {
                waysToWin *= height;
                this._symbolsPerReel.push(height);
            }
        }
        // TEMP
        this._waysRounds[0] = waysToWin;
        !true && console.log('SymbolsPerReel:', this._symbolsPerReel);
    };
    RecodeLogic.prototype.parseSymbolHeights = function (symbolHeights, roundIndex) {
        if (roundIndex === 0) {
            this._reelsHeight = [];
        }
        this._reelsHeight[roundIndex] = [];
        var results = symbolHeights.split(',');
        for (var i = 0; i < ReelConstants_1.ReelConstants.REELS_AMOUNT * ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT; i++) {
            this._reelsHeight[roundIndex].push(-1);
        }
        for (var reel = 0; reel < ReelConstants_1.ReelConstants.REELS_AMOUNT; reel++) {
            var heights = results.splice(0, this._symbolsPerReel[reel] + 1);
            for (var row = 1; row <= ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT; row++) {
                var element = -1;
                if (row < heights.length) {
                    element = parseInt(heights[row], 10);
                }
                var realIndex = reel + 6 * (row - 1);
                this._reelsHeight[roundIndex][realIndex] = element;
            }
        }
        !true && console.log('SymbolHeights:', roundIndex, this._reelsHeight[roundIndex]);
    };
    RecodeLogic.prototype.parseScatterSymbols = function (symbols, scattersTotal) {
        var scatterPositions = [];
        var symsPositions = [];
        for (var i = 0; i < symbols.length; i++) {
            if (i < scattersTotal) {
                scatterPositions.push(symbols[i]);
            }
            else {
                symsPositions.push(symbols[i]);
            }
        }
        this._scatterReplacements.push({ scattersPositions: scatterPositions, symbolsPositions: symsPositions });
    };
    RecodeLogic.prototype.parseWins = function (data) {
        var _this = this;
        if (!data.Win.length) {
            data.Win = [data.Win];
        }
        var currentWinIndex = 0;
        var _loop_1 = function (win) {
            var winReason = win.attributes.reason;
            if (winReason.includes('Scatter')) {
                var scattersAmountStr = winReason.substr(0, winReason.indexOf('Scatter'));
                var scattersTotal = Number.parseInt(scattersAmountStr, 10);
                var symbols_2 = [];
                win.attributes.winSymbols.split(',').forEach(function (value) {
                    symbols_2.push(Number.parseInt(value, 10));
                });
                this_1.parseScatterSymbols(symbols_2, scattersTotal);
            }
            else if (winReason.includes('Bonus')) {
                var bonusSymbols_2 = [];
                win.attributes.winSymbols.split(',').forEach(function (value) {
                    bonusSymbols_2.push(Number.parseInt(value, 10));
                });
                var bonusSymbolPositions = [];
                for (var _i = 0, bonusSymbols_1 = bonusSymbols_2; _i < bonusSymbols_1.length; _i++) {
                    var bonusSym = bonusSymbols_1[_i];
                    bonusSymbolPositions.push(bonusSym);
                }
                this_1._bonusGamesSymbols.push({ symbolPositions: bonusSymbolPositions });
            }
            else {
                // ordinary wins
                this_1._wins[currentWinIndex] = {
                    amount: this_1.parseDollar(win.attributes.amount),
                    multiplier: win.attributes.multiplier ? Number.parseInt(win.attributes.multiplier, 10) : 1,
                    payableID: Number.parseInt(win.attributes.paytableId, 10),
                    payline: Number.parseInt(win.attributes.payline, 10),
                    reason: win.attributes.reason,
                    round: Number.parseInt(win.attributes.round, 10) + 1,
                    ways: Number.parseInt(win.attributes.ways, 10),
                    winSymbols: [],
                };
                win.attributes.winSymbols.split(',').forEach(function (value) {
                    _this._wins[currentWinIndex].winSymbols.push(Number.parseInt(value, 10));
                });
                if (win.attributes.round === '0') {
                    // TODO: terrible hack!!!
                    currentWinIndex++;
                    this_1._wins[currentWinIndex] = {
                        amount: this_1.parseDollar(win.attributes.amount),
                        multiplier: win.attributes.multiplier ? Number.parseInt(win.attributes.multiplier, 10) : 1,
                        payableID: Number.parseInt(win.attributes.paytableId, 10),
                        payline: Number.parseInt(win.attributes.payline, 10),
                        reason: win.attributes.reason,
                        round: Number.parseInt(win.attributes.round, 10),
                        ways: Number.parseInt(win.attributes.ways, 10),
                        winSymbols: [],
                    };
                    win.attributes.winSymbols.split(',').forEach(function (value) {
                        _this._wins[currentWinIndex].winSymbols.push(Number.parseInt(value, 10));
                    });
                }
                if (false) {
                    console.warn('Wins:', this_1._wins[currentWinIndex]);
                }
                currentWinIndex++;
            }
        };
        var this_1 = this;
        for (var _i = 0, _a = data.Win; _i < _a.length; _i++) {
            var win = _a[_i];
            _loop_1(win);
        }
    };
    RecodeLogic.prototype.parseTokens = function (data) {
        var tokens = data;
        if (!tokens.length) {
            tokens = [tokens];
        }
        for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
            var token = tokens_1[_i];
            for (var _a = 0, _b = token.Token; _a < _b.length; _a++) {
                var attribute = _b[_a];
                if (attribute && attribute.attributes && attribute.attributes.name === 'WildMeter' && attribute.attributes.value) {
                    this._wildMeter = Number.parseInt(attribute.attributes.value, 10);
                }
            }
        }
    };
    RecodeLogic.prototype.prepareInGameProgressValues = function () {
        this._roundTypes = [];
        this._currentRound = 0;
        this._totalRounds = 0;
        this._waysRounds = [];
        this._avalanches = [];
        this._currentAvalanche = 0;
        this._currentMultiplier = 1;
        this._expandedWildsMultipliers = [];
        this._baseWildsMultipliers = [];
        this._currentWildExpansion = 0;
        this._currentMultiplierWilds = 0;
        this._wildMeterDeltas = [];
    };
    RecodeLogic.prototype.tempInitSymbolSizes = function () {
        this._reelsHeight = [];
        this._reelsHeight[this._currentRound] = [
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
            -1,
        ];
    };
    RecodeLogic.prototype.parseInGameProgress = function (data) {
        var _this = this;
        var progress = data.Progress;
        var roundData = [];
        var _loop_2 = function (elem) {
            var name_2 = elem.attributes.name;
            var value = elem.attributes.value;
            var splitName = name_2.split('_');
            var round = -1;
            if (splitName.length > 1) {
                name_2 = splitName[0];
                round = parseInt(splitName[1], 10);
            }
            if (round > -1 && !roundData[round]) {
                roundData[round] = {};
            }
            switch (name_2) {
                ////////////////////////////////////////////////////////////////////
                // Spin based data.
                ////////////////////////////////////////////////////////////////////
                case 'RoundTypes':
                    var roundTypes = value.split(',');
                    roundTypes.forEach(function (value) {
                        _this._roundTypes.push(Number.parseInt(value, 10));
                    });
                    break;
                case 'WildExpansions':
                    var wildExpRounds = value.split('|');
                    var wildIndex_1 = 0;
                    wildExpRounds.forEach(function (value) {
                        var wildExpansions = value.split(',');
                        _this._expandedWildsMultipliers[wildIndex_1] = { multipliers: [] };
                        wildExpansions.forEach(function (value) {
                            _this._expandedWildsMultipliers[wildIndex_1].multipliers.push(Number.parseInt(value, 10));
                        });
                        wildIndex_1++;
                    });
                    break;
                case 'Avalanches':
                    var avalanchesRounds = value.split('|');
                    var avalancheIndex_1 = 0;
                    avalanchesRounds.forEach(function (value) {
                        var avalanchePositions = value.split(',');
                        _this._avalanches[avalancheIndex_1] = { symbolIndexes: [] };
                        avalanchePositions.forEach(function (value) {
                            _this._avalanches[avalancheIndex_1].symbolIndexes.push(Number.parseInt(value, 10));
                        });
                        avalancheIndex_1++;
                    });
                    break;
                case 'Ways':
                    var waysNumbers = value.split(',');
                    waysNumbers.forEach(function (value) {
                        _this._waysRounds.push(Number.parseInt(value, 10));
                    });
                    break;
                case 'SymbolsPerReel':
                    this_2.parseSymbolsPerReel(value);
                    break;
                ////////////////////////////////////////////////////////////////////
                // Round based parsing.
                ////////////////////////////////////////////////////////////////////
                case 'FreeSpinsAwardedSymbols':
                    // console.log('FrespinsAwardedSymbols:', round, value);
                    break;
                case 'WildMultipliers':
                case 'SymbolsHeight':
                case 'ScatterToRemove':
                case 'WildMeterDeltas': {
                    var wildMeterDeltas = value.split(',');
                    wildMeterDeltas.forEach(function (value) {
                        _this._wildMeterDeltas.push(Number.parseInt(value, 10));
                    });
                    break;
                }
                case 'SymbolsToCollapse':
                    roundData[round][name_2] = { name: name_2, value: value };
                    break;
                default:
                    break;
            }
        };
        var this_2 = this;
        for (var _i = 0, progress_1 = progress; _i < progress_1.length; _i++) {
            var elem = progress_1[_i];
            _loop_2(elem);
        }
        for (var index = 0; index < roundData.length; index++) {
            this.parseRoundInGameProgressData(index, roundData[index]);
        }
        if (false) {
            for (var _a = 0, _b = this._roundTypes; _a < _b.length; _a++) {
                var round = _b[_a];
                console.log('Round', round, RoundTypes[round]);
            }
            console.warn(roundData);
        }
        this._totalRounds = this._roundTypes.length;
    };
    RecodeLogic.prototype.parseRoundInGameProgressData = function (round, roundData) {
        var _this = this;
        if (this._expandedWildsMultipliers.length < 1 &&
            roundData.WildMultipliers &&
            roundData.WildMultipliers.value &&
            this._roundTypes[round] !== RoundTypes.SCATTER_REPLACEMENT &&
            this._roundTypes[round] !== RoundTypes.WILD_EXPANSION) {
            var stringArray = roundData.WildMultipliers.value.split(',');
            var wilds = [];
            var wildsIndex = this._baseWildsMultipliers.length;
            this._baseWildsMultipliers[round + 1] = { multipliers: [], symbolIndexes: [] };
            for (var _i = 0, stringArray_1 = stringArray; _i < stringArray_1.length; _i++) {
                var str = stringArray_1[_i];
                wilds.push(Number.parseInt(str, 10));
            }
            wilds.shift(); // First element only dictates how many there are.
            for (var i = 0; i < wilds.length; i += 2) {
                this._baseWildsMultipliers[round + 1].symbolIndexes.push(wilds[i]);
                this._baseWildsMultipliers[round + 1].multipliers.push(wilds[i + 1]);
            }
            this._baseWildsMultipliers.push();
            // console.log('WildMultipliers:', round, roundData.WildMultipliers.value, this._baseWildsMultipliers);
        }
        if (roundData.SymbolsHeight && roundData.SymbolsHeight.value) {
            this.parseSymbolHeights(roundData.SymbolsHeight.value, round);
        }
        if (roundData.ScatterToRemove && roundData.ScatterToRemove.value) {
            !true && console.log('ScatterToRemove:', round, roundData.ScatterToRemove.value);
            var symbols_3 = [];
            roundData.ScatterToRemove.value.split(',').forEach(function (value) {
                var val = Number.parseInt(value, 10);
                if (!isNaN(val)) {
                    symbols_3.push(val);
                }
            });
            var scattersyms_1 = [];
            this._reels[round].filter(function (item, index) {
                if (item === 1) {
                    scattersyms_1.push(index);
                    symbols_3.unshift(index);
                    return item === 1;
                }
            });
            var symbolsTotal = scattersyms_1.length;
            !true && console.log(this._reels[round]);
            roundData.ScatterToRemove.scatterSymbols = scattersyms_1;
            this.parseScatterSymbols(symbols_3, symbolsTotal);
        }
        if (roundData.SymbolsToCollapse &&
            roundData.SymbolsToCollapse.value &&
            this._roundTypes[round + 1] !== RoundTypes.SCATTER_REPLACEMENT) {
            if (this._roundTypes[round + 1] === RoundTypes.SCATTER_REPLACEMENT_AND_AVALANCHE) {
                // value = value.replace()
                roundData.SymbolsToCollapse.value = roundData.SymbolsToCollapse.value.replace("," + roundData.ScatterToRemove.value, '');
                for (var _a = 0, _b = roundData.ScatterToRemove.scatterSymbols; _a < _b.length; _a++) {
                    var scatter = _b[_a];
                    roundData.SymbolsToCollapse.value = roundData.SymbolsToCollapse.value.substring(scatter.toString().length + 1);
                }
            }
            var avalanchePositions = roundData.SymbolsToCollapse.value.split(',');
            var avalancheIndex_2 = this._avalanches.length === 0 ? 0 : this._avalanches.length;
            this._avalanches[avalancheIndex_2] = { symbolIndexes: [] };
            avalanchePositions.forEach(function (value) {
                var number = Number.parseInt(value, 10);
                if (!isNaN(number)) {
                    _this._avalanches[avalancheIndex_2].symbolIndexes.push(number);
                }
            });
            !true && console.log('SymbolsToCollapse:', round, roundData.SymbolsToCollapse.value, this._avalanches);
        }
    };
    RecodeLogic.prototype.setResultsForCurrentRound = function () {
        if (this._currentRound > 0 && this._reels[this._currentRound - 1]) {
            this.getRecodeSpinResults().setPreviousReels(this._reels[this._currentRound - 1], this._reelsHeight[this._currentRound - 1]);
        }
        this.getRecodeSpinResults().setWaysToWin(this._waysRounds[0]); // It is the same for all rounds in this Medallion.
        // this.getRecodeSpinResults().setWaysToWin(this._waysRounds[this._currentRound]);
        this.getRecodeSpinResults().setReels(this._reels[this._currentRound], this._reelsHeight[this._currentRound]);
        var wins = this.getWinsFromRound(this._currentRound);
        this.getRecodeSpinResults().setWins(wins);
        this.getRecodeSpinResults().setRoundWin(this.getWinsSum(this.getWinsFromRound(this._currentRound)));
        this.getRecodeSpinResults().setNextRoundWin(this.getWinsSum(this.getWinsFromRound(this._currentRound + 1)));
        this.getRecodeSpinResults().setTotalWin(this._totalWin);
        /*	if (wins && wins.length > 0 && this.isFreeSpinsStarted) {
            this._freeSpinsMultiplier = wins[0].multiplier + 1;
        }*/
        this.setNextAction();
        // TODO: change current round values here
    };
    RecodeLogic.prototype.updateFreeSpinsMultipier = function () {
        this._freeSpinsPreviousMultiplier += this.isMultiplierIncreaseRound() ? 1 : 0;
    };
    RecodeLogic.prototype.isMultiplierIncreaseRound = function () {
        return (this.getCurrentRoundType() === RoundTypes.SCATTER_REPLACEMENT ||
            this.getCurrentRoundType() === RoundTypes.AVALANCHE ||
            this.getCurrentRoundType() === RoundTypes.SCATTER_REPLACEMENT_AND_AVALANCHE);
    };
    RecodeLogic.prototype.setResultFromInit = function () {
        this.getRecodeSpinResults().setRoundWin(this._win);
    };
    RecodeLogic.prototype.setNextAction = function () {
        this._previousAction = this._nextAction;
        switch (this.getNextRoundType()) {
            case RoundTypes.SCATTER_REPLACEMENT:
                this._nextAction = Action_1.Action.RESPIN;
                break;
            case RoundTypes.AVALANCHE:
                this._nextAction = Action_1.Action.AVALANCHE;
                break;
            case RoundTypes.SCATTER_REPLACEMENT_AND_AVALANCHE:
                this._nextAction = Action_1.Action.SCATTER_AND_AVALANCHE;
                break;
            // case RoundTypes.BONUS:
            // 	this._nextAction = Action.PICK;
            // 	break;
            // case RoundTypes.FREESPIN:
            // 	this._nextAction = Action.FREESPIN;
            // 	break;
            default:
                this._nextAction = this.freeSpinsLeft > 0 ? Action_1.Action.FREESPIN : Action_1.Action.SPIN;
                break;
        }
    };
    RecodeLogic.prototype.setInitResults = function () {
        this.getRecodeSpinResults().setReels(this._reels[this._currentRound], this._reelsHeight[this._currentRound]);
        this.setNextAction();
        // if (this.getNextRoundType() === RoundTypes.BONUS) {
        // 	this.makeNextBonusSymbolsList();
        // }
        if (this.freeSpinsLeft > 0) {
            // this.makeNextFreespin!
        }
    };
    RecodeLogic.prototype.getWinsFromRound = function (roundIndex) {
        var wins = [];
        for (var _i = 0, _a = this._wins; _i < _a.length; _i++) {
            var win = _a[_i];
            if (win.round === roundIndex) {
                wins.push(win);
            }
        }
        return wins;
    };
    RecodeLogic.prototype.getMultiplierForRound = function (roundIndex) {
        return this.getWinsFromRound(roundIndex)[0].multiplier;
    };
    RecodeLogic.prototype.getWinsSum = function (wins) {
        var totalWin = 0;
        for (var _i = 0, wins_1 = wins; _i < wins_1.length; _i++) {
            var win = wins_1[_i];
            totalWin += win.amount;
        }
        return totalWin;
    };
    Object.defineProperty(RecodeLogic.prototype, "sessionID", {
        get: function () {
            return this._sessionID;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * creates SymbolPosition from recode symbol position
     */
    RecodeLogic.prototype.makeSymbolPositionFromSymbol = function (symbol) {
        var reelPos = symbol % ReelConstants_1.ReelConstants.REELS_AMOUNT;
        var rowPos = Math.trunc(symbol / ReelConstants_1.ReelConstants.REELS_AMOUNT);
        return { x: reelPos, y: rowPos };
    };
    RecodeLogic.prototype.isWildInGameListOfExpandedWilds = function (reelIndex) {
        for (var _i = 0, _a = this._spin.expandingWilds; _i < _a.length; _i++) {
            var wild = _a[_i];
            if (wild.reelIndex === reelIndex) {
                return true;
            }
        }
        return false;
    };
    RecodeLogic.prototype.findWildPositionOnReel = function (reelIndex) {
        // const reel: GameSymbol[] = this._spin.reels[reelIndex];
        var reel = this._spin.previousReels[reelIndex];
        for (var i = 0; i < reel.length; i++) {
            var sym = reel[i];
            if (sym.sym === this.getWildSymbol()) {
                return i;
            }
        }
        return -1;
    };
    RecodeLogic.prototype.isWildAlreadyExpanded = function (reelIndex) {
        for (var _i = 0, _a = this._alreadyExpandedWilds; _i < _a.length; _i++) {
            var expWildReel = _a[_i];
            if (expWildReel === reelIndex) {
                return true;
            }
        }
        return false;
    };
    Object.defineProperty(RecodeLogic.prototype, "currentFreeGameProgress", {
        get: function () {
            return this._currentFreeGameProgress;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecodeLogic.prototype, "lastRealWager", {
        get: function () {
            return this._lastRealWager;
        },
        set: function (betData) {
            this._lastRealWager = betData;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecodeLogic.prototype, "isInFreeRounds", {
        get: function () {
            return this._isInFreeRounds;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecodeLogic.prototype, "hasExpiredFreeGames", {
        get: function () {
            return this._hasExpiredFreeGames;
        },
        enumerable: true,
        configurable: true
    });
    RecodeLogic.prototype.setSpin = function (newSpin) {
        this._spin = newSpin;
    };
    Object.defineProperty(RecodeLogic.prototype, "currentBalance", {
        get: function () {
            return this._balance * RecodeLogic.CENT_TO_A_DOLLAR;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecodeLogic.prototype, "currentBalanceCents", {
        get: function () {
            return this._balance;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecodeLogic.prototype, "transNumber", {
        get: function () {
            return this._transNumber;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecodeLogic.prototype, "hasClearedExpiredFreeGames", {
        get: function () {
            return this._hasClearedExpiredFreeGames;
        },
        set: function (bool) {
            this._hasClearedExpiredFreeGames = bool;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecodeLogic.prototype, "betValue", {
        get: function () {
            return this._betValue;
        },
        set: function (betvalue) {
            this._betValue = betvalue;
            // if (this.betValues && this.betValues.length > 1) {
            // 	this._betValue = this.isValidBetValue(betvalue) ? betvalue : this.getLowerBet(betvalue);
            // }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecodeLogic.prototype, "hasBonusGameFreeGamesRestore", {
        get: function () {
            return this._hasBonusGameFreeGamesRestore;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecodeLogic.prototype, "freeGamesBonusGameRestoreCallback", {
        set: function (value) {
            this._freeGamesBonusGameRestoreCallback = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecodeLogic.prototype, "bonusGameRemainingBoxes", {
        get: function () {
            return this._bonusGame.remaining;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecodeLogic.prototype, "recodeBonusGame", {
        get: function () {
            return this._bonusGame;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecodeLogic.prototype, "bonusSymbolsToChoose", {
        get: function () {
            return this._bonusSymbolsToChoose;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecodeLogic.prototype, "serverTime", {
        get: function () {
            return this._serverTime;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecodeLogic.prototype, "freeGamesData", {
        get: function () {
            return this._freeGamesData;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecodeLogic.prototype, "gameState", {
        get: function () {
            return this._gameState;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecodeLogic.prototype, "isRestoreAfterBonusGame", {
        get: function () {
            return this._isRestoreAfterBonusGame;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecodeLogic.prototype, "hasKilledFreeGamesRestore", {
        get: function () {
            return this._hasKilledFreeGamesRestore;
        },
        set: function (value) {
            this._hasKilledFreeGamesRestore = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecodeLogic.prototype, "restoredIntoBonusGame", {
        get: function () {
            return this._restoredIntoBonusGame;
        },
        set: function (bool) {
            this._restoredIntoBonusGame = bool;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecodeLogic.prototype, "recodeAutoplayExtraData", {
        get: function () {
            return this._recodeAutoplayExtraData;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecodeLogic.prototype, "paylines", {
        get: function () {
            return this._paylines;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecodeLogic.prototype, "multiplier", {
        get: function () {
            return this._multiplier;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecodeLogic.prototype, "reels", {
        get: function () {
            return this._reels;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecodeLogic.prototype, "roundTypes", {
        get: function () {
            return this._roundTypes;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecodeLogic.prototype, "avalanches", {
        get: function () {
            return this._avalanches;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecodeLogic.prototype, "wildMeterDeltas", {
        get: function () {
            return this._wildMeterDeltas;
        },
        enumerable: true,
        configurable: true
    });
    RecodeLogic.prototype.getTotalWildMeterDeltas = function () {
        var total = 0;
        for (var _i = 0, _a = this._wildMeterDeltas; _i < _a.length; _i++) {
            var delta = _a[_i];
            total += delta;
        }
        return total;
    };
    Object.defineProperty(RecodeLogic.prototype, "wildMeter", {
        get: function () {
            return this._wildMeter;
        },
        enumerable: true,
        configurable: true
    });
    RecodeLogic.CENT_TO_A_DOLLAR = 0.01;
    RecodeLogic.BET_WAYS_MULTIPLIER = 10; // Changed to 10 on 2019-06-28 to support lower min bet than 0.5$.
    return RecodeLogic;
}(Logic_1.Logic));
exports.RecodeLogic = RecodeLogic;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SettingsEvents = /** @class */ (function () {
    function SettingsEvents() {
    }
    SettingsEvents.TOGGLE_ALL_SOUND_OFF = 'SettingsEvents::TOGGLE_ALL_SOUND_OFF';
    SettingsEvents.TOGGLE_ALL_SOUND_ON = 'SettingsEvents::TOGGLE_ALL_SOUND_ON';
    SettingsEvents.TOGGLE_SOUND_EFFECTS_OFF = 'SettingsEvents::TOGGLE_SOUND_OFF';
    SettingsEvents.TOGGLE_SOUND_EFFECTS_ON = 'SettingsEvents::TOGGLE_SOUND_ON';
    SettingsEvents.TOGGLE_VOICE_OFF = 'SettingsEvents::TOGGLE_VOICE_OFF';
    SettingsEvents.TOGGLE_VOICE_ON = 'SettingsEvents::TOGGLE_VOICE_ON';
    SettingsEvents.TOGGLE_MUSIC_OFF = 'SettingsEvents::TOGGLE_MUSIC_OFF';
    SettingsEvents.TOGGLE_MUSIC_ON = 'SettingsEvents::TOGGLE_MUSIC_ON';
    SettingsEvents.TOGGLE_QUICKSPIN_OFF = 'SettingsEvents::TOGGLE_QUICKSPIN_OFF';
    SettingsEvents.TOGGLE_QUICKSPIN_ON = 'SettingsEvents::TOGGLE_QUICKSPIN_ON';
    SettingsEvents.TOGGLE_SPACEBAR_OFF = 'SettingsEvents::TOGGLE_SPACEBAR_OFF';
    SettingsEvents.TOGGLE_SPACEBAR_ON = 'SettingsEvents::TOGGLE_SPACEBAR_ON';
    SettingsEvents.TOGGLE_SKIP_INTRO_ON = 'SettingsEvents::TOGGLE_SKIP_INTRO_ON';
    SettingsEvents.TOGGLE_SKIP_INTRO_OFF = 'SettingsEvents::TOGGLE_SKIP_INTRO_OFF';
    SettingsEvents.TOGGLE_FAST_PLAY_ON = 'SettingsEvents::TOGGLE_FAST_PLAY_ON';
    SettingsEvents.TOGGLE_FAST_PLAY_OFF = 'SettingsEvents::TOGGLE_FAST_PLAY_OFF';
    SettingsEvents.TOGGLE_DRAG_REEL_TO_SPIN_ON = 'SettingsEvents::TOGGLE_DRAG_REEL_TO_SPIN_ON';
    SettingsEvents.TOGGLE_DRAG_REEL_TO_SPIN_OFF = 'SettingsEvents::TOGGLE_DRAG_REEL_TO_SPIN_OFF';
    return SettingsEvents;
}());
exports.SettingsEvents = SettingsEvents;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BigWinView_1 = __webpack_require__(119);
var Module_1 = __webpack_require__(2);
var Views_1 = __webpack_require__(8);
var BigWinBasicState_1 = __webpack_require__(296);
var BigWinPlayingState_1 = __webpack_require__(297);
var BigWinFinalState_1 = __webpack_require__(577);
var FlowModuleEvents_1 = __webpack_require__(0);
var BigWinEvents_1 = __webpack_require__(21);
var BigWinModule = /** @class */ (function (_super) {
    __extends(BigWinModule, _super);
    function BigWinModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BigWinModule.prototype.setupViews = function () {
        if (this.system.shouldUseMultipleViews()) {
            this.setView(Views_1.Views.BIG_WIN_VIEW_MOBILE);
        }
        else {
            this.setView(Views_1.Views.BIG_WIN_VIEW);
        }
    };
    BigWinModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.onViewCurrentStateHandle(BigWinView_1.BigWinView.METER_FINISHED);
        this.onViewCurrentStateHandle(BigWinView_1.BigWinView.SKIP_CLICKED);
        this.onViewCurrentStateHandle(BigWinView_1.BigWinView.END_ANIMATION_FINISHED);
        this.onCurrentStateHandle(FlowModuleEvents_1.FlowModuleEvents.WON_BIG_WIN);
        this.onViewEmitEvent(BigWinView_1.BigWinView.EXPLOSION_STARTED, BigWinEvents_1.BigWinEvents.EXPLOSION_STARTED);
        this.onViewEmitEvent(BigWinView_1.BigWinView.TRANSITION_STARTED, BigWinEvents_1.BigWinEvents.TRANSITION_STARTED);
        this.onViewEmitEvent(BigWinView_1.BigWinView.BIG_WIN_STARTED, BigWinEvents_1.BigWinEvents.BIG_WIN_STARTED);
        this.onViewEmitEvent(BigWinView_1.BigWinView.TRANSITION_ENDED, BigWinEvents_1.BigWinEvents.TRANSITION_ENDED);
    };
    BigWinModule.prototype.setupStates = function () {
        this.addState(new BigWinBasicState_1.BigWinBasicState(this, BigWinModule.BASIC_STATE));
        this.addState(new BigWinPlayingState_1.BigWinPlayingState(this, BigWinModule.PLAYING_STATE));
        this.addState(new BigWinFinalState_1.BigWinFinalState(this, BigWinModule.FINAL_STATE));
    };
    BigWinModule.prototype.enterFirstState = function () {
        this.changeStateTo(BigWinModule.BASIC_STATE);
    };
    BigWinModule.BASIC_STATE = 'basic';
    BigWinModule.PLAYING_STATE = 'playing';
    BigWinModule.FINAL_STATE = 'final';
    return BigWinModule;
}(Module_1.Module));
exports.BigWinModule = BigWinModule;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Module_1 = __webpack_require__(2);
var Views_1 = __webpack_require__(8);
var FlowModuleEvents_1 = __webpack_require__(0);
var FreeSpinsEvents_1 = __webpack_require__(6);
var FreeSpinsView_1 = __webpack_require__(120);
var FreeSpinsBasicState_1 = __webpack_require__(582);
var FreeSpinsIntroState_1 = __webpack_require__(162);
var FreeSpinsOutroState_1 = __webpack_require__(299);
var FreeSpinsProgressState_1 = __webpack_require__(583);
var FreeSpinsRestoreIntroState_1 = __webpack_require__(584);
var WinPresentationEvents_1 = __webpack_require__(13);
var ReelsEvents_1 = __webpack_require__(4);
var AvalancheReelsEvents_1 = __webpack_require__(15);
var FreeSpinsModule = /** @class */ (function (_super) {
    __extends(FreeSpinsModule, _super);
    function FreeSpinsModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FreeSpinsModule.prototype.addDebuggingComponent = function () { };
    FreeSpinsModule.prototype.restore = function () {
        _super.prototype.restore.call(this);
        if (this.logic.isFreeSpinsStarted) {
            if (this.logic.isFreeSpinsStarted && this.logic.freeSpinsPlayed === 0) {
                this.gotoState(FreeSpinsModule.INTRO_RESTORE_STATE);
            }
            else {
                this.gotoState(FreeSpinsModule.IN_PROGRESS_STATE);
            }
        }
    };
    FreeSpinsModule.prototype.enterFirstState = function () {
        this.changeStateTo(FreeSpinsModule.BASIC_STATE);
    };
    FreeSpinsModule.prototype.setupStates = function () {
        this.addState(new FreeSpinsBasicState_1.FreeSpinsBasicState(this, FreeSpinsModule.BASIC_STATE));
        this.addState(new FreeSpinsIntroState_1.FreeSpinsIntroState(this, FreeSpinsModule.INTRO_STATE));
        this.addState(new FreeSpinsOutroState_1.FreeSpinsOutroState(this, FreeSpinsModule.OUTRO_STATE));
        this.addState(new FreeSpinsRestoreIntroState_1.FreeSpinsRestoreIntroState(this, FreeSpinsModule.INTRO_RESTORE_STATE));
        this.addState(new FreeSpinsProgressState_1.FreeSpinsProgressState(this, FreeSpinsModule.IN_PROGRESS_STATE));
    };
    FreeSpinsModule.prototype.setupViews = function () {
        if (this.system.shouldUseMultipleViews()) {
            this.setView(Views_1.Views.FREE_SPINS_VIEW_MOBILE);
        }
        else {
            this.setView(Views_1.Views.FREE_SPINS_VIEW);
        }
    };
    FreeSpinsModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.onCurrentStateHandle(FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
        this.onCurrentStateHandle(FlowModuleEvents_1.FlowModuleEvents.FREE_SPINS_FINISHED);
        this.onCurrentStateHandle(FlowModuleEvents_1.FlowModuleEvents.FREESPINS_RETRIGGER_WIN);
        this.onCurrentStateHandle(FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN);
        this.onCurrentStateHandle(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED);
        this.onCurrentStateHandle(ReelsEvents_1.ReelsEvents.REELS_FADING_OUT_FINISHED);
        this.onCurrentStateHandle(AvalancheReelsEvents_1.AvalancheReelsEvents.REELS_FADING_OUT_FINISHED);
        this.onCurrentStateHandle(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPIN_STARTED);
        this.onViewEmitEvent(FreeSpinsView_1.FreeSpinsView.SHOWING_WIN_SUMMARY_SCREEN, FreeSpinsEvents_1.FreeSpinsEvents.SHOWING_WIN_SUMMARY_SCREEN);
        this.onViewEmitEvent(FreeSpinsView_1.FreeSpinsView.FREE_SPINS_INTRO_TRANSITION_FINISHED, FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_INTRO_FINISHED);
        this.onViewEmitEvent(FreeSpinsView_1.FreeSpinsView.FREE_SPINS_INFO_CONTINUE_CLICKED, FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_CONTINUE_CLICKED);
        this.onViewEmitEvent(FreeSpinsView_1.FreeSpinsView.FREE_SPINS_OUTRO_CONTINUE_CLICKED, FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_OUTRO_CONTINUE_CLICKED);
        this.onViewEmitEvent(FreeSpinsView_1.FreeSpinsView.RETRIGGER_STARTED, FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_RETRIGGER_STARTED);
        this.onViewEmitEvent(FreeSpinsView_1.FreeSpinsView.RETRIGGER_FINISHED, FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_RETRIGGER_FINISHED);
        this.onViewCurrentStateHandle(FreeSpinsView_1.FreeSpinsView.FREE_SPINS_INFO_CONTINUE_CLICKED);
        this.onViewCurrentStateHandle(FreeSpinsView_1.FreeSpinsView.FREE_SPINS_OUTRO_FINISHED);
        this.onViewCurrentStateHandle(FreeSpinsView_1.FreeSpinsView.FREE_SPINS_INTRO_FINISHED);
    };
    FreeSpinsModule.BASIC_STATE = 'BASIC';
    FreeSpinsModule.INTRO_STATE = 'INTRO';
    FreeSpinsModule.INTRO_RESTORE_STATE = 'INTRO_RESTORE';
    FreeSpinsModule.IN_PROGRESS_STATE = 'IN PROGRESS';
    FreeSpinsModule.OUTRO_STATE = 'OUTRO';
    return FreeSpinsModule;
}(Module_1.Module));
exports.FreeSpinsModule = FreeSpinsModule;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(591)
var ieee754 = __webpack_require__(592)
var isArray = __webpack_require__(301)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(98).Buffer))

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var View_1 = __webpack_require__(3);
var Spine_1 = __webpack_require__(25);
var SpineAnimation_1 = __webpack_require__(37);
var SpriteButton_1 = __webpack_require__(55);
var NineSliceSpriteButton_1 = __webpack_require__(649);
var NineSlicePlane_1 = __webpack_require__(253);
var ReelConstants_1 = __webpack_require__(10);
var FreeRoundsScreenView = /** @class */ (function (_super) {
    __extends(FreeRoundsScreenView, _super);
    function FreeRoundsScreenView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FreeRoundsScreenView.prototype.init = function () {
        _super.prototype.init.call(this);
        this.container.interactive = true;
    };
    FreeRoundsScreenView.prototype.hide = function () {
        _super.prototype.hide.call(this);
        this.emit(FreeRoundsScreenView.SCREEN_HIDDEN);
    };
    FreeRoundsScreenView.prototype.showStartscreen = function (freeGamesData) {
        this.show();
        this.showMenuAnimation('STARTSCREEN_IDLE', false);
        this._leftButton.callback = this.onPlayNowPressed.bind(this);
        this._rightButton.callback = this.onPlayLaterPressed.bind(this);
        this._discardButton.callback = this.onDiscardPressed.bind(this);
        this._infoButton.callback = this.onInfoPressed.bind(this);
        this.disableButon(this._middleButton);
        var congratulationsText = this.translator.getObject('BaseStrings', 'generic', 'g_freegames_congratulations_uppercase') || 'CONGRATULATIONS!';
        this._congratulationText.text = congratulationsText;
        this._youHaveText.text = '';
        var freeGamesNumberText = '';
        if (freeGamesData.gamesAwarded === 1) {
            freeGamesNumberText =
                this.translator.getObject('BaseStrings', 'generic', 'g_freegames_youhavefreegames_sg') ||
                    "YOU HAVE " + freeGamesData.gamesAwarded + " FREE GAME";
        }
        else {
            freeGamesNumberText =
                this.translator.getObject('BaseStrings', 'generic', 'g_freegames_youhavefreegames_pl') ||
                    "YOU HAVE " + freeGamesData.gamesAwarded + " FREE GAMES";
        }
        freeGamesNumberText = freeGamesNumberText.replace('{0}', "\n" + freeGamesData.gamesAwarded);
        this._freeGamesNumberText.text = freeGamesNumberText;
        var sessionIDText = this.translator.getObject('BaseStrings', 'generic', 'g_freegames_id_info') || "ID " + freeGamesData.offerID;
        this._sesionIDText.text = sessionIDText.replace('{0} - {1}', freeGamesData.offerID + " - " + freeGamesData.instanceID);
        this._leftButtonText.text = this.translator.getObject('BaseStrings', 'generic', 'g_freegames_play_now') || 'Play Now';
        this._rightButtonText.text = this.translator.getObject('BaseStrings', 'generic', 'g_freegames_play_later') || 'Play Later';
        this.emit(FreeRoundsScreenView.SCREEN_SHOWN);
    };
    FreeRoundsScreenView.prototype.showEndScreen = function (lastFreeGame, creditType, hasNextOffer) {
        this.show();
        var animationName = '';
        if (lastFreeGame.sumWinnings > 0 && hasNextOffer) {
            animationName = 'SUMMARY_SCREEN_02';
        }
        else if (lastFreeGame.sumWinnings > 0 && !hasNextOffer) {
            animationName = 'SUMMARY_SCREEN_01';
        }
        else if (lastFreeGame.sumWinnings === 0 && hasNextOffer) {
            animationName = 'SUMMARY_SCREEN_03';
        }
        else if (lastFreeGame.sumWinnings === 0 && !hasNextOffer) {
            animationName = 'SUMMARY_SCREEN_04';
        }
        this.showMenuAnimation(animationName, false);
        if (hasNextOffer) {
            this._leftButton.callback = this.onBackToTheGame.bind(this);
            this._rightButton.callback = this.onNextOffer.bind(this);
            this._leftButtonText.text = this.translator.getObject('BaseStrings', 'generic', 'g_freegames_backtogame') || 'Back To Game';
            this._rightButtonText.text = this.translator.getObject('BaseStrings', 'generic', 'g_freegames_next_offer') || 'Next Offer';
            this.disableButon(this._middleButton);
            this.disableButon(this._discardButton);
            this.disableButon(this._infoButton);
        }
        else {
            this._middleButton.callback = this.onBackToTheGame.bind(this);
            this._middleButtonText.text = this.translator.getObject('BaseStrings', 'generic', 'g_freegames_backtogame') || 'Back To Game';
            this.disableButon(this._leftButton);
            this.disableButon(this._rightButton);
            this.disableButon(this._discardButton);
            this.disableButon(this._infoButton);
        }
        if (lastFreeGame.sumWinnings > 0) {
            this._congratulationText.text =
                this.translator.getObject('BaseStrings', 'generic', 'g_freegames_congratulations_uppercase') || 'CONGRATULATIONS!';
            this._freeGamesCompltedWinText.text =
                this.translator.getObject('BaseStrings', 'generic', 'g_freegames_freegamescomplete_uppercase') || 'FREE GAMES COMPLETE';
            this._summaryYouHaveWonText.text =
                this.translator.getObject('BaseStrings', 'generic', 'g_freegames_youhavewon') || 'You Have Won';
            this._summaryTotalWinText.text = "" + window.V.API.Core.convertCurrency(lastFreeGame.sumWinnings);
            if (creditType === 0) {
                this._summaryGameInfoText.text =
                    this.translator.getObject('BaseStrings', 'generic', 'g_freegames_addedto_cashbalance_info') ||
                        'Winnings added to Cash balance';
            }
            else if (creditType === 1) {
                this._summaryGameInfoText.text =
                    this.translator.getObject('BaseStrings', 'generic', 'g_freegames_addedto_bonusbalance_info') ||
                        'Winnings added to Bonus balance';
            }
            else {
                this._summaryGameInfoText.text =
                    this.translator.getObject('BaseStrings', 'generic', 'g_freegames_alladdedtobalance') ||
                        'All winnings from those Free Games that were completed have already been added to your balance.';
            }
        }
        else {
            this._freeGamesCompletedNoWinText.text =
                this.translator.getObject('BaseStrings', 'generic', 'g_freegames_freegamescomplete_uppercase') || 'FREE GAMES COMPLETE';
            this._noMoreOffersText.text =
                this.translator.getObject('BaseStrings', 'generic', 'g_freegames_no_offers_available') ||
                    'There are no more offers available';
            this._summaryGameInfoText.text = "";
        }
        this.emit(FreeRoundsScreenView.SCREEN_SHOWN);
    };
    FreeRoundsScreenView.prototype.showRestoreScreen = function (lastFreeGame, canDiscard) {
        this.show();
        this.showMenuAnimation('RESUME_SCREEN_IDLE', false);
        this._middleButton.callback = this.onResumeFreeGamesPressed.bind(this);
        this._middleButtonText.text = this.translator.getObject('BaseStrings', 'generic', 'g_freegames_resume_play') || 'Resume Play';
        if (canDiscard) {
            this._discardButton.visible = true;
            this._discardButton.callback = this.onDiscardPressed.bind(this);
        }
        else {
            this._discardButton.callback = null;
            this._discardButton.visible = false;
            this.disableButon(this._discardButton);
        }
        this._infoButton.callback = this.onInfoPressed.bind(this);
        this._resumeRemainingText.text = '';
        this._resumeYouHaveText.text = '';
        var freeGamesNumberText = '';
        if (lastFreeGame.gamesRemaining === 0) {
            freeGamesNumberText =
                this.translator.getObject('BaseStrings', 'generic', 'g_freegames_freegamesremaining') || "YOU HAVE FREE GAMES REMAINING";
        }
        else if (lastFreeGame.gamesRemaining === 1) {
            freeGamesNumberText =
                this.translator.getObject('BaseStrings', 'generic', 'g_freegames_freegamesremaining_sg') ||
                    "YOU HAVE " + lastFreeGame.gamesRemaining + " FREE GAME";
        }
        else {
            freeGamesNumberText =
                this.translator.getObject('BaseStrings', 'generic', 'g_freegames_freegamesremaining_pl') ||
                    "YOU HAVE " + lastFreeGame.gamesRemaining + " FREE GAMES";
        }
        freeGamesNumberText = freeGamesNumberText.replace('{0}', "\n" + lastFreeGame.gamesRemaining);
        this._resumeFreeGamesNumberText.text = freeGamesNumberText;
        var sessionIDText = this.translator.getObject('BaseStrings', 'generic', 'g_freegames_id_info') || "ID " + lastFreeGame.offerID;
        this._sesionIDText.text = sessionIDText.replace('{0} - {1}', lastFreeGame.offerID + " - " + lastFreeGame.instanceID);
        this.disableButon(this._leftButton);
        this.disableButon(this._rightButton);
        this.emit(FreeRoundsScreenView.SCREEN_SHOWN);
    };
    FreeRoundsScreenView.prototype.showDiscardQuestionsScreen = function (freeGamesData) {
        this.show();
        this.showMenuAnimation('STARTSCREEN_DISCARD', false);
        this._leftButton.callback = this.onKeepIt.bind(this);
        this._rightButton.callback = this.onDiscardFinal.bind(this);
        this._leftButtonText.text = this.translator.getObject('BaseStrings', 'generic', 'g_freegames_keep_it') || 'Keep It';
        this._rightButtonText.text = this.translator.getObject('BaseStrings', 'generic', 'g_freegames_discard') || 'Discard';
        this._discardCaptionText.text =
            this.translator.getObject('BaseStrings', 'generic', 'g_freegames_discard_offer_uppercase') || 'DISCARD OFFER';
        if (this.translator.getObject('BaseStrings', 'generic', 'g_freegames_discard_confirmation') &&
            this.translator.getObject('BaseStrings', 'generic', 'g_freegames_action_cannotbe_undone')) {
            this._discardDescriptionText.text =
                this.translator.getObject('BaseStrings', 'generic', 'g_freegames_discard_confirmation') +
                    '\n' +
                    this.translator.getObject('BaseStrings', 'generic', 'g_freegames_action_cannotbe_undone');
        }
        else {
            this._discardDescriptionText.text = 'Are you sure you want to discard the offer now?\nThis action cannot be undone.';
        }
        var sessionIDText = this.translator.getObject('BaseStrings', 'generic', 'g_freegames_id_info') || "ID " + freeGamesData.offerID;
        this._sesionIDText.text = sessionIDText.replace('{0} - {1}', freeGamesData.offerID + " - " + freeGamesData.instanceID);
        this.disableButon(this._middleButton);
        this.disableButon(this._discardButton);
        this.disableButon(this._infoButton);
        this.emit(FreeRoundsScreenView.SCREEN_SHOWN);
    };
    FreeRoundsScreenView.prototype.showExpiryScreen = function (instanceID, offerID) {
        this.show();
        this.showMenuAnimation('EXPIRY_SCREEN_IDLE', false);
        this._middleButton.callback = this.onExpiryContinuePressed.bind(this);
        this._middleButtonText.text = this.translator.getObject('BaseStrings', 'generic', 'g_freegames_continue') || 'Continue';
        this._expiryCaptionInfoText.text =
            this.translator.getObject('BaseStrings', 'generic', 'g_freegames_alladdedtobalance') ||
                "All winnings from those Free Games that were completed have already been added to your balance";
        var sessionExpiredText = this.translator.getObject('BaseStrings', 'generic', 'g_freegames_freegamessession_expired') ||
            "FREE GAMES SESSION ID " + offerID + " - " + instanceID + " HAS EXPIRED";
        this._expiryCaptionText.text = sessionExpiredText.replace('{0} - {1}', offerID + " - " + instanceID);
        this.disableButon(this._leftButton);
        this.disableButon(this._rightButton);
        this.disableButon(this._discardButton);
        this.disableButon(this._infoButton);
        this.emit(FreeRoundsScreenView.SCREEN_SHOWN);
    };
    FreeRoundsScreenView.prototype.showInfoText = function (freeGamesData, hasLines, isBothWays) {
        if (hasLines === void 0) { hasLines = false; }
        if (isBothWays === void 0) { isBothWays = false; }
        var expiryText;
        if (this.translator.getObject('BaseStrings', 'generic', 'g_freegames_expiry_info')) {
            expiryText = this.translator
                .getObject('BaseStrings', 'generic', 'g_freegames_expiry_info')
                .replace('{0}', "" + freeGamesData.endDate);
        }
        else {
            expiryText = "Expiry: " + freeGamesData.endDate;
        }
        var betInfoText = '';
        // Bet Info: {50} Lines, {ChipSize} Coins @ {TotalBet/50 lines}
        if (freeGamesData.betData.chipSize === 1) {
            if (this.translator.getObject('BaseStrings', 'generic', 'g_freegames_bet_info_sg')) {
                betInfoText = this.translator.getObject('BaseStrings', 'generic', 'g_freegames_bet_info_sg');
                if (hasLines) {
                    var betValue = isBothWays ? "" + window.V.API.Core.convertCurrency(freeGamesData.betData.chipSize * ReelConstants_1.ReelConstants.LINES * 2) :
                        "" + window.V.API.Core.convertCurrency(freeGamesData.betData.chipSize * ReelConstants_1.ReelConstants.LINES);
                    betInfoText = betInfoText
                        .replace('{0}', "" + ReelConstants_1.ReelConstants.LINES)
                        .replace('{1}', "" + freeGamesData.betData.numChips * freeGamesData.betData.chipSize)
                        .replace('{2}', "" + betValue);
                }
                else {
                    var posOf0 = betInfoText.indexOf('{0}');
                    var lineToReplace = betInfoText.substr(posOf0, betInfoText.indexOf('{1}') - posOf0) + '{1}';
                    betInfoText = betInfoText
                        .replace(lineToReplace, "" + freeGamesData.betData.numChips * freeGamesData.betData.chipSize)
                        .replace('{2}', "" + window.V.API.Core.convertCurrency(freeGamesData.betData.chipSize * 50));
                }
            }
            else {
                betInfoText = "Bet Info: " + freeGamesData.betData.numChips + " Coin @ " + window.V.API.Core.convertCurrency(freeGamesData.betData.chipSize * 50);
            }
        }
        else {
            if (this.translator.getObject('BaseStrings', 'generic', 'g_freegames_bet_info_pl')) {
                betInfoText = this.translator.getObject('BaseStrings', 'generic', 'g_freegames_bet_info_pl');
                if (hasLines) {
                    var betValue = isBothWays ? "" + window.V.API.Core.convertCurrency(freeGamesData.betData.chipSize * ReelConstants_1.ReelConstants.LINES * 2) :
                        "" + window.V.API.Core.convertCurrency(freeGamesData.betData.chipSize * ReelConstants_1.ReelConstants.LINES);
                    betInfoText = betInfoText
                        .replace('{0}', "" + ReelConstants_1.ReelConstants.LINES)
                        .replace('{1}', "" + freeGamesData.betData.numChips * freeGamesData.betData.chipSize)
                        .replace('{2}', "" + betValue);
                }
                else {
                    var posOf0 = betInfoText.indexOf('{0}');
                    var lineToReplace = betInfoText.substr(posOf0, betInfoText.indexOf('{1}') - posOf0) + '{1}';
                    betInfoText = betInfoText
                        .replace(lineToReplace, "" + freeGamesData.betData.numChips * freeGamesData.betData.chipSize)
                        .replace('{2}', "" + window.V.API.Core.convertCurrency(freeGamesData.betData.chipSize * 50));
                }
            }
            else {
                betInfoText = "Bet Info: " + freeGamesData.betData.numChips * freeGamesData.betData.chipSize + " Coin @ " + window.V.API.Core.convertCurrency(freeGamesData.betData.chipSize * 50);
            }
        }
        var winningsAddedText;
        // creditType === 0 - cash balance;
        // creditType === 1 - bonus balance;
        if (freeGamesData.creditType === 0) {
            winningsAddedText =
                this.translator.getObject('BaseStrings', 'generic', 'g_freegames_addedto_cashbalance_info') ||
                    'Winnings added to Cash balance';
        }
        else {
            winningsAddedText =
                this.translator.getObject('BaseStrings', 'generic', 'g_freegames_addedto_bonusbalance_info') ||
                    'Winnings added to Bonus balance';
        }
        this._infoText.text = expiryText + "\n" + betInfoText + "\n" + winningsAddedText;
    };
    FreeRoundsScreenView.prototype.hideInfoText = function () {
        this._infoText.text = '';
    };
    FreeRoundsScreenView.prototype.setupElements = function (screenSpine) {
        this._infoButton = new SpriteButton_1.SpriteButton();
        this._discardButton = new SpriteButton_1.SpriteButton();
        this._leftButton = new NineSliceSpriteButton_1.NineSliceSpriteButton();
        this._middleButton = new NineSliceSpriteButton_1.NineSliceSpriteButton();
        this._rightButton = new NineSliceSpriteButton_1.NineSliceSpriteButton();
        this._congratulationsTextStyle = this.textStyles.freeRoundsCaptionStyle;
        this._youHaveTextStyle = this.textStyles.freeRoundsTextStyle;
        this._freeGamesTextStyle = this.textStyles.freeRoundsTextStyle;
        this._infoTextStyle = this.textStyles.freeRoundsSmallTextStyle;
        this._sesionIDStyle = this.textStyles.freeRoundsSuperSmallTextStyle;
        this._summaryGameInfoStyle = this.textStyles.freeRoundsTextStyle;
        this._freeGamesCompltedWinStyle = this.textStyles.freeRoundsTextStyle;
        this._summaryYouHaveWonStyle = this.textStyles.freeRoundsTextStyle;
        this._summaryTotalWinStyle = this.textStyles.freeRoundsTextStyle;
        this._freeGamesCompletedNoWinStyle = this.textStyles.freeRoundsTextStyle;
        this._noMoreOffersStyle = this.textStyles.freeRoundsTextStyle;
        this._resumeYouHaveStyle = this.textStyles.freeRoundsTextStyle;
        this._resumeFreeGamesNumberStyle = this.textStyles.freeRoundsTextStyle;
        this._resumeRemainingStyle = this.textStyles.freeRoundsTextStyle;
        this._discardCaptionStyle = this.textStyles.freeRoundsCaptionStyle;
        this._discardDescriptionStyle = this.textStyles.freeRoundsTextStyle;
        this._expiryCaptionStyle = this.textStyles.freeRoundsCaptionStyle;
        this._expiryCaptionInfoStyle = this.textStyles.freeRoundsCaptionStyle;
        this._congratulationText = new PIXI.Text('CoNgRaTuLaTiOnS', this._congratulationsTextStyle);
        this._congratulationText.anchor.set(0.5);
        this._youHaveText = new PIXI.Text('youHaveText', this._youHaveTextStyle);
        this._youHaveText.anchor.set(0.5);
        this._freeGamesNumberText = new PIXI.Text('N Free GaMeZZz', this._freeGamesTextStyle);
        this._freeGamesNumberText.anchor.set(0.5);
        this._freeGamesNumberText.style.align = 'center';
        this._infoText = new PIXI.Text('', this._infoTextStyle);
        this._infoText.anchor.set(0.5);
        this._sesionIDText = new PIXI.Text('session ID 0123456789', this._sesionIDStyle);
        this._sesionIDText.anchor.set(0.5);
        this._summaryGameInfoText = new PIXI.Text('summary info', this._summaryGameInfoStyle);
        this._summaryGameInfoText.anchor.set(0.5);
        this._freeGamesCompltedWinText = new PIXI.Text('', this._freeGamesCompltedWinStyle);
        this._freeGamesCompltedWinText.anchor.set(0.5);
        this._summaryYouHaveWonText = new PIXI.Text('', this._summaryYouHaveWonStyle);
        this._summaryYouHaveWonText.anchor.set(0.5);
        this._summaryTotalWinText = new PIXI.Text('', this._summaryTotalWinStyle);
        this._summaryTotalWinText.anchor.set(0.5);
        this._freeGamesCompletedNoWinText = new PIXI.Text('', this._freeGamesCompletedNoWinStyle);
        this._freeGamesCompletedNoWinText.anchor.set(0.5);
        this._noMoreOffersText = new PIXI.Text('', this._noMoreOffersStyle);
        this._noMoreOffersText.anchor.set(0.5);
        this._resumeYouHaveText = new PIXI.Text('', this._resumeYouHaveStyle);
        this._resumeYouHaveText.anchor.set(0.5);
        this._resumeFreeGamesNumberText = new PIXI.Text('', this._resumeFreeGamesNumberStyle);
        this._resumeFreeGamesNumberText.anchor.set(0.5);
        this._resumeFreeGamesNumberText.style.align = 'center';
        this._resumeRemainingText = new PIXI.Text('', this._resumeRemainingStyle);
        this._resumeRemainingText.anchor.set(0.5);
        this._discardCaptionText = new PIXI.Text('', this._discardCaptionStyle);
        this._discardCaptionText.anchor.set(0.5);
        this._discardDescriptionText = new PIXI.Text('', this._discardDescriptionStyle);
        this._discardDescriptionText.anchor.set(0.5);
        this._expiryCaptionText = new PIXI.Text('', this._expiryCaptionStyle);
        this._expiryCaptionText.anchor.set(0.5);
        this._expiryCaptionInfoText = new PIXI.Text('', this._expiryCaptionInfoStyle);
        this._expiryCaptionInfoText.anchor.set(0.5);
        this._buttonTextStyle = this.textStyles.freeRoundsButtonTextStyle;
        this._buttonTextStyle.wordWrap = true;
        this._buttonTextStyle.wordWrapWidth = FreeRoundsScreenView.BUTTONS_MIN_WIDTH - 20;
        ////////////////////////////////////////////////////////////////////
        // left Button
        ////////////////////////////////////////////////////////////////////
        var freeGamesMenuButton = {
            texture: this.resources.getSpritesheetTexture('MICROGAMING.json', 'FREEGAMES_MENU_BUTTONS.png'),
            nine: this.resources.getNineSliceData('MICROGAMING.json', 'FREEGAMES_MENU_BUTTONS.png'),
        };
        var freeGamesMenuButtonClicked = {
            texture: this.resources.getSpritesheetTexture('MICROGAMING.json', 'FREEGAMES_MENU_BUTTONS_CLICKED.png'),
            nine: this.resources.getNineSliceData('MICROGAMING.json', 'FREEGAMES_MENU_BUTTONS_CLICKED.png'),
        };
        var leftButtonUp = new NineSlicePlane_1.NineSlicePlane(freeGamesMenuButton.texture, freeGamesMenuButton.nine);
        var leftButtonDown = new NineSlicePlane_1.NineSlicePlane(freeGamesMenuButtonClicked.texture, freeGamesMenuButtonClicked.nine);
        var leftButtonOver = new NineSlicePlane_1.NineSlicePlane(freeGamesMenuButton.texture, freeGamesMenuButton.nine);
        var leftButtonDisabled = new NineSlicePlane_1.NineSlicePlane(freeGamesMenuButton.texture, freeGamesMenuButton.nine);
        this._leftButton.setFrames(leftButtonUp, leftButtonDown, leftButtonOver, leftButtonDisabled);
        this._leftButton.setSize({
            width: FreeRoundsScreenView.BUTTONS_MIN_WIDTH,
            height: FreeRoundsScreenView.BUTTONS_MIN_HEIGHT,
        });
        this._leftButtonText = new PIXI.Text('Left Button', this._buttonTextStyle);
        this._leftButtonText.anchor.set(0.5);
        ////////////////////////////////////////////////////////////////////
        // Middle Button
        ////////////////////////////////////////////////////////////////////
        var middleButtonUp = new NineSlicePlane_1.NineSlicePlane(freeGamesMenuButton.texture, freeGamesMenuButton.nine);
        var middleButtonDown = new NineSlicePlane_1.NineSlicePlane(freeGamesMenuButtonClicked.texture, freeGamesMenuButtonClicked.nine);
        var middleButtonOver = new NineSlicePlane_1.NineSlicePlane(freeGamesMenuButton.texture, freeGamesMenuButton.nine);
        var middleButtonDisabled = new NineSlicePlane_1.NineSlicePlane(freeGamesMenuButton.texture, freeGamesMenuButton.nine);
        this._middleButton.setFrames(middleButtonUp, middleButtonDown, middleButtonOver, middleButtonDisabled);
        this._middleButton.setSize({
            width: FreeRoundsScreenView.BUTTONS_MIN_WIDTH,
            height: FreeRoundsScreenView.BUTTONS_MIN_HEIGHT,
        });
        this._middleButtonText = new PIXI.Text('Middle Button', this._buttonTextStyle);
        this._middleButtonText.anchor.set(0.5);
        ////////////////////////////////////////////////////////////////////
        // Right Button
        ////////////////////////////////////////////////////////////////////
        var rightButtonUp = new NineSlicePlane_1.NineSlicePlane(freeGamesMenuButton.texture, freeGamesMenuButton.nine);
        var rightButtonDown = new NineSlicePlane_1.NineSlicePlane(freeGamesMenuButtonClicked.texture, freeGamesMenuButtonClicked.nine);
        var rightButtonOver = new NineSlicePlane_1.NineSlicePlane(freeGamesMenuButton.texture, freeGamesMenuButton.nine);
        var rightButtonDisabled = new NineSlicePlane_1.NineSlicePlane(freeGamesMenuButton.texture, freeGamesMenuButton.nine);
        this._rightButton.setFrames(rightButtonUp, rightButtonDown, rightButtonOver, rightButtonDisabled);
        this._rightButton.setSize({
            width: FreeRoundsScreenView.BUTTONS_MIN_WIDTH,
            height: FreeRoundsScreenView.BUTTONS_MIN_HEIGHT,
        });
        this._rightButtonText = new PIXI.Text('Right Button', this._buttonTextStyle);
        this._rightButtonText.anchor.set(0.5);
        ////////////////////////////////////////////////////////////////////
        // Info Button
        ////////////////////////////////////////////////////////////////////
        var infoButtonUp = new PIXI.Sprite(this.resources.getSpritesheetTexture('MICROGAMING.json', 'FREEGAMES_INFO_BUTTON.png'));
        var infoButtonDown = new PIXI.Sprite(this.resources.getSpritesheetTexture('MICROGAMING.json', 'FREEGAMES_INFO_BUTTON_CLICKED.png'));
        var infoButtonOver = new PIXI.Sprite(this.resources.getSpritesheetTexture('MICROGAMING.json', 'FREEGAMES_INFO_BUTTON.png'));
        var infoButtonDisabled = new PIXI.Sprite(this.resources.getSpritesheetTexture('MICROGAMING.json', 'FREEGAMES_INFO_BUTTON.png'));
        infoButtonUp.anchor.set(0.5, 0.5);
        infoButtonDown.anchor.set(0.5, 0.5);
        infoButtonOver.anchor.set(0.5, 0.5);
        infoButtonDisabled.anchor.set(0.5, 0.5);
        this._infoButton.setFrames(infoButtonUp, infoButtonDown, infoButtonOver, infoButtonDisabled);
        ////////////////////////////////////////////////////////////////////
        // Discard Button
        ////////////////////////////////////////////////////////////////////
        var discardButtonUp = new PIXI.Sprite(this.resources.getSpritesheetTexture('MICROGAMING.json', 'FREEGAMES_DISCARD_BUTTON.png'));
        var discardButtonDown = new PIXI.Sprite(this.resources.getSpritesheetTexture('MICROGAMING.json', 'FREEGAMES_DISCARD_BUTTON_CLICKED.png'));
        var discardButtonOver = new PIXI.Sprite(this.resources.getSpritesheetTexture('MICROGAMING.json', 'FREEGAMES_DISCARD_BUTTON.png'));
        var discardButtonDisabled = new PIXI.Sprite(this.resources.getSpritesheetTexture('MICROGAMING.json', 'FREEGAMES_DISCARD_BUTTON.png'));
        discardButtonUp.anchor.set(0.5, 0.5);
        discardButtonDown.anchor.set(0.5, 0.5);
        discardButtonOver.anchor.set(0.5, 0.5);
        discardButtonDisabled.anchor.set(0.5, 0.5);
        this._discardButton.setFrames(discardButtonUp, discardButtonDown, discardButtonOver, discardButtonDisabled);
        var leftButtonSlot = screenSpine.slotContainers[screenSpine.skeleton.findSlotIndex('BUTTON_BG01')];
        var centerButtonSlot = screenSpine.slotContainers[screenSpine.skeleton.findSlotIndex('BUTTON_BG03')];
        var rightButtonSlot = screenSpine.slotContainers[screenSpine.skeleton.findSlotIndex('BUTTON_BG02')];
        var infoButtonSlot = screenSpine.slotContainers[screenSpine.skeleton.findSlotIndex('INFO_BUTTON')];
        var discardButtonSlot = screenSpine.slotContainers[screenSpine.skeleton.findSlotIndex('DISCARD_BUTTON')];
        var leftButtonTextSlot = screenSpine.slotContainers[screenSpine.skeleton.findSlotIndex('TEXT01')];
        var centerButtonTextSlot = screenSpine.slotContainers[screenSpine.skeleton.findSlotIndex('TEXT03')];
        var rightButtonTextSlot = screenSpine.slotContainers[screenSpine.skeleton.findSlotIndex('TEXT02')];
        var congratulationsTextSlot = screenSpine.slotContainers[screenSpine.skeleton.findSlotIndex('CONGRATULATIONS_TEXT')];
        var youHaveTextSlot = screenSpine.slotContainers[screenSpine.skeleton.findSlotIndex('STARTSCREEN_YOU_HAVE_TEXT')];
        var winTextSlot = screenSpine.slotContainers[screenSpine.skeleton.findSlotIndex('STARTSCREEN_X_FREE_GAMES_TEXT')];
        var infoTextSlot = screenSpine.slotContainers[screenSpine.skeleton.findSlotIndex('INFO_TEXT')];
        var sessionTextSlot = screenSpine.slotContainers[screenSpine.skeleton.findSlotIndex('SESSION_IDENTIFICATION_NUMBER')];
        var summaryInfoSlot = screenSpine.slotContainers[screenSpine.skeleton.findSlotIndex('SUMMARY_GAME_INFORMATION')];
        var freeGameCompleteWinTextSlot = screenSpine.slotContainers[screenSpine.skeleton.findSlotIndex('SUMMARY_FREE_GAMES_COMPLETE_WIN_TEXT')];
        var summaryYouHaveWonTextSlot = screenSpine.slotContainers[screenSpine.skeleton.findSlotIndex('SUMMARY_YOU_HAVE_WON_TEXT')];
        var summaryWinNumberTextSlot = screenSpine.slotContainers[screenSpine.skeleton.findSlotIndex('SUMMARY_WIN_NUMBER_TEXT')];
        var summaryFreeGamesCompletedTextSlot = screenSpine.slotContainers[screenSpine.skeleton.findSlotIndex('SUMMARY_FREE_GAMES_COMPLETE_NO_WIN_TEXT')];
        var summaryNoMoreOffersTextSlot = screenSpine.slotContainers[screenSpine.skeleton.findSlotIndex('SUMMARY_NO_MORE_OFFERS_TEXT')];
        var resumeYouHaveTextSlot = screenSpine.slotContainers[screenSpine.skeleton.findSlotIndex('RESUME_SCREEN_YOU_HAVE_TEXT')];
        var resumeFreeGamesNumberTextSlot = screenSpine.slotContainers[screenSpine.skeleton.findSlotIndex('RESUME_SCREEN_X_FREE_GAMES_TEXT')];
        var resumeRemainingTextSlot = screenSpine.slotContainers[screenSpine.skeleton.findSlotIndex('RESUME_SCREEN_REMAINING_TEXT')];
        var discardCaptionTextSlot = screenSpine.slotContainers[screenSpine.skeleton.findSlotIndex('DISCARD_DISCARD_OFFER_TEXT')];
        var discardTextSlot = screenSpine.slotContainers[screenSpine.skeleton.findSlotIndex('DISCARD_DISCARD_OFFER_TEXT02')];
        var expiryCaptionTextSlot = screenSpine.slotContainers[screenSpine.skeleton.findSlotIndex('EXPIRY_SCREEN_EXPIRED_TEXT')];
        var expiryTextInfoSlot = screenSpine.slotContainers[screenSpine.skeleton.findSlotIndex('EXPIRY_SCREEN_EXPIRED_INFO_TEXT')];
        expiryCaptionTextSlot.addChild(this._expiryCaptionText);
        this._expiryCaptionText.transform = expiryCaptionTextSlot.children[0].transform;
        expiryCaptionTextSlot.children[0].visible = false;
        expiryTextInfoSlot.addChild(this._expiryCaptionInfoText);
        this._expiryCaptionInfoText.transform = expiryTextInfoSlot.children[0].transform;
        expiryTextInfoSlot.children[0].visible = false;
        discardCaptionTextSlot.addChild(this._discardCaptionText);
        this._discardCaptionText.transform = discardCaptionTextSlot.children[0].transform;
        discardCaptionTextSlot.children[0].visible = false;
        discardTextSlot.addChild(this._discardDescriptionText);
        this._discardDescriptionText.transform = discardTextSlot.children[0].transform;
        discardTextSlot.children[0].visible = false;
        resumeYouHaveTextSlot.addChild(this._resumeYouHaveText);
        this._resumeYouHaveText.transform = resumeYouHaveTextSlot.children[0].transform;
        resumeYouHaveTextSlot.children[0].visible = false;
        resumeFreeGamesNumberTextSlot.addChild(this._resumeFreeGamesNumberText);
        this._resumeFreeGamesNumberText.transform = resumeFreeGamesNumberTextSlot.children[0].transform;
        resumeFreeGamesNumberTextSlot.children[0].visible = false;
        resumeRemainingTextSlot.addChild(this._resumeRemainingText);
        this._resumeRemainingText.transform = resumeRemainingTextSlot.children[0].transform;
        resumeRemainingTextSlot.children[0].visible = false;
        freeGameCompleteWinTextSlot.addChild(this._freeGamesCompltedWinText);
        this._freeGamesCompltedWinText.transform = freeGameCompleteWinTextSlot.children[0].transform;
        freeGameCompleteWinTextSlot.children[0].visible = false;
        summaryYouHaveWonTextSlot.addChild(this._summaryYouHaveWonText);
        this._summaryYouHaveWonText.transform = summaryYouHaveWonTextSlot.children[0].transform;
        summaryYouHaveWonTextSlot.children[0].visible = false;
        summaryWinNumberTextSlot.addChild(this._summaryTotalWinText);
        this._summaryTotalWinText.transform = summaryWinNumberTextSlot.children[0].transform;
        summaryWinNumberTextSlot.children[0].visible = false;
        summaryFreeGamesCompletedTextSlot.addChild(this._freeGamesCompletedNoWinText);
        this._freeGamesCompletedNoWinText.transform = summaryFreeGamesCompletedTextSlot.children[0].transform;
        summaryFreeGamesCompletedTextSlot.children[0].visible = false;
        summaryNoMoreOffersTextSlot.addChild(this._noMoreOffersText);
        this._noMoreOffersText.transform = summaryNoMoreOffersTextSlot.children[0].transform;
        summaryNoMoreOffersTextSlot.children[0].visible = false;
        congratulationsTextSlot.addChild(this._congratulationText);
        this._congratulationText.transform = congratulationsTextSlot.children[0].transform;
        congratulationsTextSlot.children[0].visible = false;
        youHaveTextSlot.addChild(this._youHaveText);
        this._youHaveText.transform = youHaveTextSlot.children[0].transform;
        youHaveTextSlot.children[0].visible = false;
        winTextSlot.addChild(this._freeGamesNumberText);
        this._freeGamesNumberText.transform = winTextSlot.children[0].transform;
        winTextSlot.children[0].visible = false;
        infoTextSlot.addChild(this._infoText);
        this._infoText.transform = infoTextSlot.children[0].transform;
        infoTextSlot.children[0].visible = false;
        sessionTextSlot.addChild(this._sesionIDText);
        this._sesionIDText.transform = sessionTextSlot.children[0].transform;
        sessionTextSlot.children[0].visible = false;
        summaryInfoSlot.addChild(this._summaryGameInfoText);
        this._summaryGameInfoText.transform = summaryInfoSlot.children[0].transform;
        summaryInfoSlot.children[0].visible = false;
        leftButtonSlot.addChild(this._leftButton);
        this._leftButton.transform = leftButtonSlot.children[0].transform;
        leftButtonSlot.children[0].visible = false;
        leftButtonTextSlot.addChild(this._leftButtonText);
        this._leftButtonText.transform = leftButtonTextSlot.children[0].transform;
        leftButtonTextSlot.children[0].visible = false;
        centerButtonSlot.addChild(this._middleButton);
        this._middleButton.transform = centerButtonSlot.children[0].transform;
        centerButtonSlot.children[0].visible = false;
        centerButtonTextSlot.addChild(this._middleButtonText);
        this._middleButtonText.transform = centerButtonTextSlot.children[0].transform;
        centerButtonTextSlot.children[0].visible = false;
        rightButtonSlot.addChild(this._rightButton);
        this._rightButton.transform = rightButtonSlot.children[0].transform;
        rightButtonSlot.children[0].visible = false;
        rightButtonTextSlot.addChild(this._rightButtonText);
        this._rightButtonText.transform = rightButtonTextSlot.children[0].transform;
        rightButtonTextSlot.children[0].visible = false;
        infoButtonSlot.addChild(this._infoButton);
        this._infoButton.transform = infoButtonSlot.children[0].transform;
        infoButtonSlot.children[0].visible = false;
        discardButtonSlot.addChild(this._discardButton);
        this._discardButton.transform = discardButtonSlot.children[0].transform;
        discardButtonSlot.children[0].visible = false;
    };
    FreeRoundsScreenView.prototype.onExpiryContinuePressed = function () {
        this.hide();
        this.emit(FreeRoundsScreenView.EXPIRY_CONTINUE_PRESSED);
    };
    FreeRoundsScreenView.prototype.onKeepIt = function () {
        this.hide();
        this.emit(FreeRoundsScreenView.KEEP_IT_PRESSED);
    };
    FreeRoundsScreenView.prototype.onDiscardFinal = function () {
        this.hide();
        this.emit(FreeRoundsScreenView.DISCARD_FINAL_PRESSED);
    };
    FreeRoundsScreenView.prototype.onResumeFreeGamesPressed = function () {
        this.hide();
        this.emit(FreeRoundsScreenView.RESUME_PRESSED);
    };
    FreeRoundsScreenView.prototype.onPlayNowPressed = function () {
        this.hide();
        this.emit(FreeRoundsScreenView.PLAY_NOW_PRESSED);
    };
    FreeRoundsScreenView.prototype.onPlayLaterPressed = function () {
        this.hide();
        this.emit(FreeRoundsScreenView.PLAY_LATER_PRESSED);
    };
    FreeRoundsScreenView.prototype.onInfoPressed = function () {
        this.emit(FreeRoundsScreenView.INFO_PRESSED);
    };
    FreeRoundsScreenView.prototype.onBackToTheGame = function () {
        this.hide();
        this.emit(FreeRoundsScreenView.BACK_TO_GAME_PRESSED);
    };
    FreeRoundsScreenView.prototype.onNextOffer = function () {
        this.hide();
        this.emit(FreeRoundsScreenView.NEXT_OFFER_PRESSED);
    };
    FreeRoundsScreenView.prototype.onDiscardPressed = function () {
        this.hide();
        this.emit(FreeRoundsScreenView.DISCARD_PRESSED);
    };
    FreeRoundsScreenView.prototype.shouldReplaceLogoElement = function () {
        return this.resources.getLocale().toLowerCase().indexOf('zh') > -1;
    };
    FreeRoundsScreenView.prototype.getLocale = function () {
        var locale = this.resources.getLocale().toUpperCase();
        return locale.indexOf('ZH') > -1 ? locale.slice(0, 2) : locale;
    };
    FreeRoundsScreenView.prototype.showMenuAnimation = function (animationName, loop, stopOnComplete) {
        var _this = this;
        if (stopOnComplete === void 0) { stopOnComplete = true; }
        if (this._mainAnimation) {
            this.spineUtils.stopAndDestroyAnimation(this._mainAnimation);
        }
        var spine = new Spine_1.Spine(this.resources.getSpine('FREE-GAMES_SCREENS.json'));
        this.setupElements(spine);
        this._mainAnimation = new SpineAnimation_1.SpineAnimation(spine, animationName, loop, true);
        this._mainAnimation.container.position.set(this.resolutionManager.halfResolution.width, this.resolutionManager.halfResolution.height);
        if (this.shouldReplaceLogoElement()) {
            this.spineUtils.replaceElementInSpine(spine, 'GAME_LOGOTYPE', new PIXI.Sprite(this.resources.getTexture(this.getLocale() + "_INTRO_LOGO.png")));
        }
        this.container.addChild(this._mainAnimation.container);
        if (stopOnComplete) {
            this._mainAnimation.setOnComplete(function () {
                _this._mainAnimation.stop();
            });
        }
        this.updateManager.add(this._mainAnimation);
        this._mainAnimation.start();
        return this._mainAnimation;
    };
    FreeRoundsScreenView.prototype.disableButon = function (button) {
        button.interactive = false;
        button.buttonMode = false;
    };
    FreeRoundsScreenView.PLAY_NOW_PRESSED = 'PLAY_NOW_PRESSED';
    FreeRoundsScreenView.PLAY_LATER_PRESSED = 'PLAY_LATER_PRESSED';
    FreeRoundsScreenView.INFO_PRESSED = 'INFO_PRESSED';
    FreeRoundsScreenView.DISCARD_PRESSED = 'DISCARD_PRESSED';
    FreeRoundsScreenView.NEXT_OFFER_PRESSED = 'NEXT_OFFER_PRESSED';
    FreeRoundsScreenView.BACK_TO_GAME_PRESSED = 'BACK_TO_GAME_PRESSED';
    FreeRoundsScreenView.RESUME_PRESSED = 'RESUME_PRESSED';
    FreeRoundsScreenView.KEEP_IT_PRESSED = 'KEEP_IT_PRESSED';
    FreeRoundsScreenView.DISCARD_FINAL_PRESSED = 'DISCARD_FINAL_PRESSED';
    FreeRoundsScreenView.EXPIRY_CONTINUE_PRESSED = 'EXPIRY_CONTINUE_PRESSED';
    FreeRoundsScreenView.SCREEN_SHOWN = 'SCREEN_SHOWN';
    FreeRoundsScreenView.SCREEN_HIDDEN = 'SCREEN_HIDDEN';
    FreeRoundsScreenView.BUTTONS_MIN_WIDTH = 220;
    FreeRoundsScreenView.BUTTONS_MIN_HEIGHT = 110;
    return FreeRoundsScreenView;
}(View_1.View));
exports.FreeRoundsScreenView = FreeRoundsScreenView;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _utils = __webpack_require__(9);

var _canUseNewCanvasBlendModes = __webpack_require__(190);

var _canUseNewCanvasBlendModes2 = _interopRequireDefault(_canUseNewCanvasBlendModes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Utility methods for Sprite/Texture tinting.
 *
 * @class
 * @memberof PIXI
 */
var CanvasTinter = {
    /**
     * Basically this method just needs a sprite and a color and tints the sprite with the given color.
     *
     * @memberof PIXI.CanvasTinter
     * @param {PIXI.Sprite} sprite - the sprite to tint
     * @param {number} color - the color to use to tint the sprite with
     * @return {HTMLCanvasElement} The tinted canvas
     */
    getTintedTexture: function getTintedTexture(sprite, color) {
        var texture = sprite._texture;

        color = CanvasTinter.roundColor(color);

        var stringColor = '#' + ('00000' + (color | 0).toString(16)).substr(-6);

        texture.tintCache = texture.tintCache || {};

        var cachedTexture = texture.tintCache[stringColor];

        var canvas = void 0;

        if (cachedTexture) {
            if (cachedTexture.tintId === texture._updateID) {
                return texture.tintCache[stringColor];
            }

            canvas = texture.tintCache[stringColor];
        } else {
            canvas = CanvasTinter.canvas || document.createElement('canvas');
        }

        CanvasTinter.tintMethod(texture, color, canvas);

        canvas.tintId = texture._updateID;

        if (CanvasTinter.convertTintToImage) {
            // is this better?
            var tintImage = new Image();

            tintImage.src = canvas.toDataURL();

            texture.tintCache[stringColor] = tintImage;
        } else {
            texture.tintCache[stringColor] = canvas;
            // if we are not converting the texture to an image then we need to lose the reference to the canvas
            CanvasTinter.canvas = null;
        }

        return canvas;
    },

    /**
     * Tint a texture using the 'multiply' operation.
     *
     * @memberof PIXI.CanvasTinter
     * @param {PIXI.Texture} texture - the texture to tint
     * @param {number} color - the color to use to tint the sprite with
     * @param {HTMLCanvasElement} canvas - the current canvas
     */
    tintWithMultiply: function tintWithMultiply(texture, color, canvas) {
        var context = canvas.getContext('2d');
        var crop = texture._frame.clone();
        var resolution = texture.baseTexture.resolution;

        crop.x *= resolution;
        crop.y *= resolution;
        crop.width *= resolution;
        crop.height *= resolution;

        canvas.width = Math.ceil(crop.width);
        canvas.height = Math.ceil(crop.height);

        context.save();
        context.fillStyle = '#' + ('00000' + (color | 0).toString(16)).substr(-6);

        context.fillRect(0, 0, crop.width, crop.height);

        context.globalCompositeOperation = 'multiply';

        context.drawImage(texture.baseTexture.source, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);

        context.globalCompositeOperation = 'destination-atop';

        context.drawImage(texture.baseTexture.source, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);
        context.restore();
    },

    /**
     * Tint a texture using the 'overlay' operation.
     *
     * @memberof PIXI.CanvasTinter
     * @param {PIXI.Texture} texture - the texture to tint
     * @param {number} color - the color to use to tint the sprite with
     * @param {HTMLCanvasElement} canvas - the current canvas
     */
    tintWithOverlay: function tintWithOverlay(texture, color, canvas) {
        var context = canvas.getContext('2d');
        var crop = texture._frame.clone();
        var resolution = texture.baseTexture.resolution;

        crop.x *= resolution;
        crop.y *= resolution;
        crop.width *= resolution;
        crop.height *= resolution;

        canvas.width = Math.ceil(crop.width);
        canvas.height = Math.ceil(crop.height);

        context.save();
        context.globalCompositeOperation = 'copy';
        context.fillStyle = '#' + ('00000' + (color | 0).toString(16)).substr(-6);
        context.fillRect(0, 0, crop.width, crop.height);

        context.globalCompositeOperation = 'destination-atop';
        context.drawImage(texture.baseTexture.source, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);

        // context.globalCompositeOperation = 'copy';
        context.restore();
    },


    /**
     * Tint a texture pixel per pixel.
     *
     * @memberof PIXI.CanvasTinter
     * @param {PIXI.Texture} texture - the texture to tint
     * @param {number} color - the color to use to tint the sprite with
     * @param {HTMLCanvasElement} canvas - the current canvas
     */
    tintWithPerPixel: function tintWithPerPixel(texture, color, canvas) {
        var context = canvas.getContext('2d');
        var crop = texture._frame.clone();
        var resolution = texture.baseTexture.resolution;

        crop.x *= resolution;
        crop.y *= resolution;
        crop.width *= resolution;
        crop.height *= resolution;

        canvas.width = Math.ceil(crop.width);
        canvas.height = Math.ceil(crop.height);

        context.save();
        context.globalCompositeOperation = 'copy';
        context.drawImage(texture.baseTexture.source, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);
        context.restore();

        var rgbValues = (0, _utils.hex2rgb)(color);
        var r = rgbValues[0];
        var g = rgbValues[1];
        var b = rgbValues[2];

        var pixelData = context.getImageData(0, 0, crop.width, crop.height);

        var pixels = pixelData.data;

        for (var i = 0; i < pixels.length; i += 4) {
            pixels[i + 0] *= r;
            pixels[i + 1] *= g;
            pixels[i + 2] *= b;
        }

        context.putImageData(pixelData, 0, 0);
    },

    /**
     * Rounds the specified color according to the CanvasTinter.cacheStepsPerColorChannel.
     *
     * @memberof PIXI.CanvasTinter
     * @param {number} color - the color to round, should be a hex color
     * @return {number} The rounded color.
     */
    roundColor: function roundColor(color) {
        var step = CanvasTinter.cacheStepsPerColorChannel;

        var rgbValues = (0, _utils.hex2rgb)(color);

        rgbValues[0] = Math.min(255, rgbValues[0] / step * step);
        rgbValues[1] = Math.min(255, rgbValues[1] / step * step);
        rgbValues[2] = Math.min(255, rgbValues[2] / step * step);

        return (0, _utils.rgb2hex)(rgbValues);
    },

    /**
     * Number of steps which will be used as a cap when rounding colors.
     *
     * @memberof PIXI.CanvasTinter
     * @type {number}
     */
    cacheStepsPerColorChannel: 8,

    /**
     * Tint cache boolean flag.
     *
     * @memberof PIXI.CanvasTinter
     * @type {boolean}
     */
    convertTintToImage: false,

    /**
     * Whether or not the Canvas BlendModes are supported, consequently the ability to tint using the multiply method.
     *
     * @memberof PIXI.CanvasTinter
     * @type {boolean}
     */
    canUseMultiply: (0, _canUseNewCanvasBlendModes2.default)(),

    /**
     * The tinting method that will be used.
     *
     * @memberof PIXI.CanvasTinter
     * @type {tintMethodFunctionType}
     */
    tintMethod: 0
};

CanvasTinter.tintMethod = CanvasTinter.canUseMultiply ? CanvasTinter.tintWithMultiply : CanvasTinter.tintWithPerPixel;

/**
 * The tintMethod type.
 *
 * @memberof PIXI.CanvasTinter
 * @callback tintMethodFunctionType
 * @param texture {PIXI.Texture} the texture to tint
 * @param color {number} the color to use to tint the sprite with
 * @param canvas {HTMLCanvasElement} the current canvas
 */

exports.default = CanvasTinter;
//# sourceMappingURL=CanvasTinter.js.map

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _WebGLManager2 = __webpack_require__(85);

var _WebGLManager3 = _interopRequireDefault(_WebGLManager2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Base for a common object renderer that can be used as a system renderer plugin.
 *
 * @class
 * @extends PIXI.WebGLManager
 * @memberof PIXI
 */
var ObjectRenderer = function (_WebGLManager) {
  _inherits(ObjectRenderer, _WebGLManager);

  function ObjectRenderer() {
    _classCallCheck(this, ObjectRenderer);

    return _possibleConstructorReturn(this, _WebGLManager.apply(this, arguments));
  }

  /**
   * Starts the renderer and sets the shader
   *
   */
  ObjectRenderer.prototype.start = function start() {}
  // set the shader..


  /**
   * Stops the renderer
   *
   */
  ;

  ObjectRenderer.prototype.stop = function stop() {
    this.flush();
  };

  /**
   * Stub method for rendering content and emptying the current batch.
   *
   */


  ObjectRenderer.prototype.flush = function flush() {}
  // flush!


  /**
   * Renders an object
   *
   * @param {PIXI.DisplayObject} object - The object to render.
   */
  ;

  ObjectRenderer.prototype.render = function render(object) // eslint-disable-line no-unused-vars
  {
    // render the object
  };

  return ObjectRenderer;
}(_WebGLManager3.default);

exports.default = ObjectRenderer;
//# sourceMappingURL=ObjectRenderer.js.map

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _SystemRenderer2 = __webpack_require__(187);

var _SystemRenderer3 = _interopRequireDefault(_SystemRenderer2);

var _MaskManager = __webpack_require__(372);

var _MaskManager2 = _interopRequireDefault(_MaskManager);

var _StencilManager = __webpack_require__(374);

var _StencilManager2 = _interopRequireDefault(_StencilManager);

var _FilterManager = __webpack_require__(375);

var _FilterManager2 = _interopRequireDefault(_FilterManager);

var _RenderTarget = __webpack_require__(104);

var _RenderTarget2 = _interopRequireDefault(_RenderTarget);

var _ObjectRenderer = __webpack_require__(102);

var _ObjectRenderer2 = _interopRequireDefault(_ObjectRenderer);

var _TextureManager = __webpack_require__(377);

var _TextureManager2 = _interopRequireDefault(_TextureManager);

var _BaseTexture = __webpack_require__(68);

var _BaseTexture2 = _interopRequireDefault(_BaseTexture);

var _TextureGarbageCollector = __webpack_require__(378);

var _TextureGarbageCollector2 = _interopRequireDefault(_TextureGarbageCollector);

var _WebGLState = __webpack_require__(379);

var _WebGLState2 = _interopRequireDefault(_WebGLState);

var _mapWebGLDrawModesToPixi = __webpack_require__(381);

var _mapWebGLDrawModesToPixi2 = _interopRequireDefault(_mapWebGLDrawModesToPixi);

var _validateContext = __webpack_require__(382);

var _validateContext2 = _interopRequireDefault(_validateContext);

var _utils = __webpack_require__(9);

var _pixiGlCore = __webpack_require__(31);

var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);

var _const = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CONTEXT_UID = 0;

/**
 * The WebGLRenderer draws the scene and all its content onto a webGL enabled canvas. This renderer
 * should be used for browsers that support webGL. This Render works by automatically managing webGLBatchs.
 * So no need for Sprite Batches or Sprite Clouds.
 * Don't forget to add the view to your DOM or you will not see anything :)
 *
 * @class
 * @memberof PIXI
 * @extends PIXI.SystemRenderer
 */

var WebGLRenderer = function (_SystemRenderer) {
    _inherits(WebGLRenderer, _SystemRenderer);

    // eslint-disable-next-line valid-jsdoc
    /**
     *
     * @param {object} [options] - The optional renderer parameters
     * @param {number} [options.width=800] - the width of the screen
     * @param {number} [options.height=600] - the height of the screen
     * @param {HTMLCanvasElement} [options.view] - the canvas to use as a view, optional
     * @param {boolean} [options.transparent=false] - If the render view is transparent, default false
     * @param {boolean} [options.autoResize=false] - If the render view is automatically resized, default false
     * @param {boolean} [options.antialias=false] - sets antialias. If not available natively then FXAA
     *  antialiasing is used
     * @param {boolean} [options.forceFXAA=false] - forces FXAA antialiasing to be used over native.
     *  FXAA is faster, but may not always look as great
     * @param {number} [options.resolution=1] - The resolution / device pixel ratio of the renderer.
     *  The resolution of the renderer retina would be 2.
     * @param {boolean} [options.clearBeforeRender=true] - This sets if the renderer will clear
     *  the canvas or not before the new render pass. If you wish to set this to false, you *must* set
     *  preserveDrawingBuffer to `true`.
     * @param {boolean} [options.preserveDrawingBuffer=false] - enables drawing buffer preservation,
     *  enable this if you need to call toDataUrl on the webgl context.
     * @param {boolean} [options.roundPixels=false] - If true PixiJS will Math.floor() x/y values when
     *  rendering, stopping pixel interpolation.
     * @param {number} [options.backgroundColor=0x000000] - The background color of the rendered area
     *  (shown if not transparent).
     * @param {boolean} [options.legacy=false] - If true PixiJS will aim to ensure compatibility
     *  with older / less advanced devices. If you experience unexplained flickering try setting this to true.
     * @param {string} [options.powerPreference] - Parameter passed to webgl context, set to "high-performance"
     *  for devices with dual graphics card
     */
    function WebGLRenderer(options, arg2, arg3) {
        _classCallCheck(this, WebGLRenderer);

        var _this = _possibleConstructorReturn(this, _SystemRenderer.call(this, 'WebGL', options, arg2, arg3));

        _this.legacy = _this.options.legacy;

        if (_this.legacy) {
            _pixiGlCore2.default.VertexArrayObject.FORCE_NATIVE = true;
        }

        /**
         * The type of this renderer as a standardised const
         *
         * @member {number}
         * @see PIXI.RENDERER_TYPE
         */
        _this.type = _const.RENDERER_TYPE.WEBGL;

        _this.handleContextLost = _this.handleContextLost.bind(_this);
        _this.handleContextRestored = _this.handleContextRestored.bind(_this);

        _this.view.addEventListener('webglcontextlost', _this.handleContextLost, false);
        _this.view.addEventListener('webglcontextrestored', _this.handleContextRestored, false);

        /**
         * The options passed in to create a new webgl context.
         *
         * @member {object}
         * @private
         */
        _this._contextOptions = {
            alpha: _this.transparent,
            antialias: _this.options.antialias,
            premultipliedAlpha: _this.transparent && _this.transparent !== 'notMultiplied',
            stencil: true,
            preserveDrawingBuffer: _this.options.preserveDrawingBuffer,
            powerPreference: _this.options.powerPreference
        };

        _this._backgroundColorRgba[3] = _this.transparent ? 0 : 1;

        /**
         * Manages the masks using the stencil buffer.
         *
         * @member {PIXI.MaskManager}
         */
        _this.maskManager = new _MaskManager2.default(_this);

        /**
         * Manages the stencil buffer.
         *
         * @member {PIXI.StencilManager}
         */
        _this.stencilManager = new _StencilManager2.default(_this);

        /**
         * An empty renderer.
         *
         * @member {PIXI.ObjectRenderer}
         */
        _this.emptyRenderer = new _ObjectRenderer2.default(_this);

        /**
         * The currently active ObjectRenderer.
         *
         * @member {PIXI.ObjectRenderer}
         */
        _this.currentRenderer = _this.emptyRenderer;

        /**
         * Manages textures
         * @member {PIXI.TextureManager}
         */
        _this.textureManager = null;

        /**
         * Manages the filters.
         *
         * @member {PIXI.FilterManager}
         */
        _this.filterManager = null;

        _this.initPlugins();

        /**
         * The current WebGL rendering context, it is created here
         *
         * @member {WebGLRenderingContext}
         */
        // initialize the context so it is ready for the managers.
        if (_this.options.context) {
            // checks to see if a context is valid..
            (0, _validateContext2.default)(_this.options.context);
        }

        _this.gl = _this.options.context || _pixiGlCore2.default.createContext(_this.view, _this._contextOptions);

        _this.CONTEXT_UID = CONTEXT_UID++;

        /**
         * The currently active ObjectRenderer.
         *
         * @member {PIXI.WebGLState}
         */
        _this.state = new _WebGLState2.default(_this.gl);

        _this.renderingToScreen = true;

        /**
         * Holds the current state of textures bound to the GPU.
         * @type {Array}
         */
        _this.boundTextures = null;

        /**
         * Holds the current shader
         *
         * @member {PIXI.Shader}
         */
        _this._activeShader = null;

        _this._activeVao = null;

        /**
         * Holds the current render target
         *
         * @member {PIXI.RenderTarget}
         */
        _this._activeRenderTarget = null;

        _this._initContext();

        // map some webGL blend and drawmodes..
        _this.drawModes = (0, _mapWebGLDrawModesToPixi2.default)(_this.gl);

        _this._nextTextureLocation = 0;

        _this.setBlendMode(0);

        /**
         * Fired after rendering finishes.
         *
         * @event PIXI.WebGLRenderer#postrender
         */

        /**
         * Fired before rendering starts.
         *
         * @event PIXI.WebGLRenderer#prerender
         */

        /**
         * Fired when the WebGL context is set.
         *
         * @event PIXI.WebGLRenderer#context
         * @param {WebGLRenderingContext} gl - WebGL context.
         */
        return _this;
    }

    /**
     * Creates the WebGL context
     *
     * @private
     */


    WebGLRenderer.prototype._initContext = function _initContext() {
        var gl = this.gl;

        // restore a context if it was previously lost
        if (gl.isContextLost() && gl.getExtension('WEBGL_lose_context')) {
            gl.getExtension('WEBGL_lose_context').restoreContext();
        }

        var maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);

        this._activeShader = null;
        this._activeVao = null;

        this.boundTextures = new Array(maxTextures);
        this.emptyTextures = new Array(maxTextures);

        /**
         * Did someone temper with textures state? We'll overwrite them when we need to unbind something.
         * @member {boolean}
         * @private
         */
        this._unknownBoundTextures = false;

        // create a texture manager...
        this.textureManager = new _TextureManager2.default(this);
        this.filterManager = new _FilterManager2.default(this);
        this.textureGC = new _TextureGarbageCollector2.default(this);

        this.state.resetToDefault();

        this.rootRenderTarget = new _RenderTarget2.default(gl, this.width, this.height, null, this.resolution, true);
        this.rootRenderTarget.clearColor = this._backgroundColorRgba;

        this.bindRenderTarget(this.rootRenderTarget);

        // now lets fill up the textures with empty ones!
        var emptyGLTexture = new _pixiGlCore2.default.GLTexture.fromData(gl, null, 1, 1);

        var tempObj = { _glTextures: {} };

        tempObj._glTextures[this.CONTEXT_UID] = {};

        for (var i = 0; i < maxTextures; i++) {
            var empty = new _BaseTexture2.default();

            empty._glTextures[this.CONTEXT_UID] = emptyGLTexture;

            this.boundTextures[i] = tempObj;
            this.emptyTextures[i] = empty;
            this.bindTexture(null, i);
        }

        this.emit('context', gl);

        // setup the width/height properties and gl viewport
        this.resize(this.screen.width, this.screen.height);
    };

    /**
     * Renders the object to its webGL view
     *
     * @param {PIXI.DisplayObject} displayObject - the object to be rendered
     * @param {PIXI.RenderTexture} renderTexture - The render texture to render to.
     * @param {boolean} [clear] - Should the canvas be cleared before the new render
     * @param {PIXI.Matrix} [transform] - A transform to apply to the render texture before rendering.
     * @param {boolean} [skipUpdateTransform] - Should we skip the update transform pass?
     */


    WebGLRenderer.prototype.render = function render(displayObject, renderTexture, clear, transform, skipUpdateTransform) {
        // can be handy to know!
        this.renderingToScreen = !renderTexture;

        this.emit('prerender');

        // no point rendering if our context has been blown up!
        if (!this.gl || this.gl.isContextLost()) {
            return;
        }

        this._nextTextureLocation = 0;

        if (!renderTexture) {
            this._lastObjectRendered = displayObject;
        }

        if (!skipUpdateTransform) {
            // update the scene graph
            var cacheParent = displayObject.parent;

            displayObject.parent = this._tempDisplayObjectParent;
            displayObject.updateTransform();
            displayObject.parent = cacheParent;
            // displayObject.hitArea = //TODO add a temp hit area
        }

        this.bindRenderTexture(renderTexture, transform);

        this.currentRenderer.start();

        if (clear !== undefined ? clear : this.clearBeforeRender) {
            this._activeRenderTarget.clear();
        }

        displayObject.renderWebGL(this);

        // apply transform..
        this.currentRenderer.flush();

        // this.setObjectRenderer(this.emptyRenderer);

        this.textureGC.update();

        this.emit('postrender');
    };

    /**
     * Changes the current renderer to the one given in parameter
     *
     * @param {PIXI.ObjectRenderer} objectRenderer - The object renderer to use.
     */


    WebGLRenderer.prototype.setObjectRenderer = function setObjectRenderer(objectRenderer) {
        if (this.currentRenderer === objectRenderer) {
            return;
        }

        this.currentRenderer.stop();
        this.currentRenderer = objectRenderer;
        this.currentRenderer.start();
    };

    /**
     * This should be called if you wish to do some custom rendering
     * It will basically render anything that may be batched up such as sprites
     *
     */


    WebGLRenderer.prototype.flush = function flush() {
        this.setObjectRenderer(this.emptyRenderer);
    };

    /**
     * Resizes the webGL view to the specified width and height.
     *
     * @param {number} screenWidth - the new width of the screen
     * @param {number} screenHeight - the new height of the screen
     */


    WebGLRenderer.prototype.resize = function resize(screenWidth, screenHeight) {
        //  if(width * this.resolution === this.width && height * this.resolution === this.height)return;

        _SystemRenderer3.default.prototype.resize.call(this, screenWidth, screenHeight);

        this.rootRenderTarget.resize(screenWidth, screenHeight);

        if (this._activeRenderTarget === this.rootRenderTarget) {
            this.rootRenderTarget.activate();

            if (this._activeShader) {
                this._activeShader.uniforms.projectionMatrix = this.rootRenderTarget.projectionMatrix.toArray(true);
            }
        }
    };

    /**
     * Resizes the webGL view to the specified width and height.
     *
     * @param {number} blendMode - the desired blend mode
     */


    WebGLRenderer.prototype.setBlendMode = function setBlendMode(blendMode) {
        this.state.setBlendMode(blendMode);
    };

    /**
     * Erases the active render target and fills the drawing area with a colour
     *
     * @param {number} [clearColor] - The colour
     */


    WebGLRenderer.prototype.clear = function clear(clearColor) {
        this._activeRenderTarget.clear(clearColor);
    };

    /**
     * Sets the transform of the active render target to the given matrix
     *
     * @param {PIXI.Matrix} matrix - The transformation matrix
     */


    WebGLRenderer.prototype.setTransform = function setTransform(matrix) {
        this._activeRenderTarget.transform = matrix;
    };

    /**
     * Erases the render texture and fills the drawing area with a colour
     *
     * @param {PIXI.RenderTexture} renderTexture - The render texture to clear
     * @param {number} [clearColor] - The colour
     * @return {PIXI.WebGLRenderer} Returns itself.
     */


    WebGLRenderer.prototype.clearRenderTexture = function clearRenderTexture(renderTexture, clearColor) {
        var baseTexture = renderTexture.baseTexture;
        var renderTarget = baseTexture._glRenderTargets[this.CONTEXT_UID];

        if (renderTarget) {
            renderTarget.clear(clearColor);
        }

        return this;
    };

    /**
     * Binds a render texture for rendering
     *
     * @param {PIXI.RenderTexture} renderTexture - The render texture to render
     * @param {PIXI.Matrix} transform - The transform to be applied to the render texture
     * @return {PIXI.WebGLRenderer} Returns itself.
     */


    WebGLRenderer.prototype.bindRenderTexture = function bindRenderTexture(renderTexture, transform) {
        var renderTarget = void 0;

        if (renderTexture) {
            var baseTexture = renderTexture.baseTexture;

            if (!baseTexture._glRenderTargets[this.CONTEXT_UID]) {
                // bind the current texture
                this.textureManager.updateTexture(baseTexture, 0);
            }

            this.unbindTexture(baseTexture);

            renderTarget = baseTexture._glRenderTargets[this.CONTEXT_UID];
            renderTarget.setFrame(renderTexture.frame);
        } else {
            renderTarget = this.rootRenderTarget;
        }

        renderTarget.transform = transform;
        this.bindRenderTarget(renderTarget);

        return this;
    };

    /**
     * Changes the current render target to the one given in parameter
     *
     * @param {PIXI.RenderTarget} renderTarget - the new render target
     * @return {PIXI.WebGLRenderer} Returns itself.
     */


    WebGLRenderer.prototype.bindRenderTarget = function bindRenderTarget(renderTarget) {
        if (renderTarget !== this._activeRenderTarget) {
            this._activeRenderTarget = renderTarget;
            renderTarget.activate();

            if (this._activeShader) {
                this._activeShader.uniforms.projectionMatrix = renderTarget.projectionMatrix.toArray(true);
            }

            this.stencilManager.setMaskStack(renderTarget.stencilMaskStack);
        }

        return this;
    };

    /**
     * Changes the current shader to the one given in parameter
     *
     * @param {PIXI.Shader} shader - the new shader
     * @param {boolean} [autoProject=true] - Whether automatically set the projection matrix
     * @return {PIXI.WebGLRenderer} Returns itself.
     */


    WebGLRenderer.prototype.bindShader = function bindShader(shader, autoProject) {
        // TODO cache
        if (this._activeShader !== shader) {
            this._activeShader = shader;
            shader.bind();

            // `autoProject` normally would be a default parameter set to true
            // but because of how Babel transpiles default parameters
            // it hinders the performance of this method.
            if (autoProject !== false) {
                // automatically set the projection matrix
                shader.uniforms.projectionMatrix = this._activeRenderTarget.projectionMatrix.toArray(true);
            }
        }

        return this;
    };

    /**
     * Binds the texture. This will return the location of the bound texture.
     * It may not be the same as the one you pass in. This is due to optimisation that prevents
     * needless binding of textures. For example if the texture is already bound it will return the
     * current location of the texture instead of the one provided. To bypass this use force location
     *
     * @param {PIXI.Texture} texture - the new texture
     * @param {number} location - the suggested texture location
     * @param {boolean} forceLocation - force the location
     * @return {number} bound texture location
     */


    WebGLRenderer.prototype.bindTexture = function bindTexture(texture, location, forceLocation) {
        texture = texture || this.emptyTextures[location];
        texture = texture.baseTexture || texture;
        texture.touched = this.textureGC.count;

        if (!forceLocation) {
            // TODO - maybe look into adding boundIds.. save us the loop?
            for (var i = 0; i < this.boundTextures.length; i++) {
                if (this.boundTextures[i] === texture) {
                    return i;
                }
            }

            if (location === undefined) {
                this._nextTextureLocation++;
                this._nextTextureLocation %= this.boundTextures.length;
                location = this.boundTextures.length - this._nextTextureLocation - 1;
            }
        } else {
            location = location || 0;
        }

        var gl = this.gl;
        var glTexture = texture._glTextures[this.CONTEXT_UID];

        if (!glTexture) {
            // this will also bind the texture..
            this.textureManager.updateTexture(texture, location);
        } else {
            // bind the current texture
            this.boundTextures[location] = texture;
            gl.activeTexture(gl.TEXTURE0 + location);
            gl.bindTexture(gl.TEXTURE_2D, glTexture.texture);
        }

        return location;
    };

    /**
    * unbinds the texture ...
    *
    * @param {PIXI.Texture} texture - the texture to unbind
    * @return {PIXI.WebGLRenderer} Returns itself.
    */


    WebGLRenderer.prototype.unbindTexture = function unbindTexture(texture) {
        var gl = this.gl;

        texture = texture.baseTexture || texture;

        if (this._unknownBoundTextures) {
            this._unknownBoundTextures = false;
            // someone changed webGL state,
            // we have to be sure that our texture does not appear in multitexture renderer samplers

            for (var i = 0; i < this.boundTextures.length; i++) {
                if (this.boundTextures[i] === this.emptyTextures[i]) {
                    gl.activeTexture(gl.TEXTURE0 + i);
                    gl.bindTexture(gl.TEXTURE_2D, this.emptyTextures[i]._glTextures[this.CONTEXT_UID].texture);
                }
            }
        }

        for (var _i = 0; _i < this.boundTextures.length; _i++) {
            if (this.boundTextures[_i] === texture) {
                this.boundTextures[_i] = this.emptyTextures[_i];

                gl.activeTexture(gl.TEXTURE0 + _i);
                gl.bindTexture(gl.TEXTURE_2D, this.emptyTextures[_i]._glTextures[this.CONTEXT_UID].texture);
            }
        }

        return this;
    };

    /**
     * Creates a new VAO from this renderer's context and state.
     *
     * @return {VertexArrayObject} The new VAO.
     */


    WebGLRenderer.prototype.createVao = function createVao() {
        return new _pixiGlCore2.default.VertexArrayObject(this.gl, this.state.attribState);
    };

    /**
     * Changes the current Vao to the one given in parameter
     *
     * @param {PIXI.VertexArrayObject} vao - the new Vao
     * @return {PIXI.WebGLRenderer} Returns itself.
     */


    WebGLRenderer.prototype.bindVao = function bindVao(vao) {
        if (this._activeVao === vao) {
            return this;
        }

        if (vao) {
            vao.bind();
        } else if (this._activeVao) {
            // TODO this should always be true i think?
            this._activeVao.unbind();
        }

        this._activeVao = vao;

        return this;
    };

    /**
     * Resets the WebGL state so you can render things however you fancy!
     *
     * @return {PIXI.WebGLRenderer} Returns itself.
     */


    WebGLRenderer.prototype.reset = function reset() {
        this.setObjectRenderer(this.emptyRenderer);

        this.bindVao(null);
        this._activeShader = null;
        this._activeRenderTarget = this.rootRenderTarget;

        this._unknownBoundTextures = true;

        for (var i = 0; i < this.boundTextures.length; i++) {
            this.boundTextures[i] = this.emptyTextures[i];
        }

        // bind the main frame buffer (the screen);
        this.rootRenderTarget.activate();

        this.state.resetToDefault();

        return this;
    };

    /**
     * Handles a lost webgl context
     *
     * @private
     * @param {WebGLContextEvent} event - The context lost event.
     */


    WebGLRenderer.prototype.handleContextLost = function handleContextLost(event) {
        event.preventDefault();
    };

    /**
     * Handles a restored webgl context
     *
     * @private
     */


    WebGLRenderer.prototype.handleContextRestored = function handleContextRestored() {
        this.textureManager.removeAll();
        this.filterManager.destroy(true);
        this._initContext();
    };

    /**
     * Removes everything from the renderer (event listeners, spritebatch, etc...)
     *
     * @param {boolean} [removeView=false] - Removes the Canvas element from the DOM.
     *  See: https://github.com/pixijs/pixi.js/issues/2233
     */


    WebGLRenderer.prototype.destroy = function destroy(removeView) {
        this.destroyPlugins();

        // remove listeners
        this.view.removeEventListener('webglcontextlost', this.handleContextLost);
        this.view.removeEventListener('webglcontextrestored', this.handleContextRestored);

        this.textureManager.destroy();

        // call base destroy
        _SystemRenderer.prototype.destroy.call(this, removeView);

        this.uid = 0;

        // destroy the managers
        this.maskManager.destroy();
        this.stencilManager.destroy();
        this.filterManager.destroy();

        this.maskManager = null;
        this.filterManager = null;
        this.textureManager = null;
        this.currentRenderer = null;

        this.handleContextLost = null;
        this.handleContextRestored = null;

        this._contextOptions = null;
        this.gl.useProgram(null);

        if (this.gl.getExtension('WEBGL_lose_context')) {
            this.gl.getExtension('WEBGL_lose_context').loseContext();
        }

        this.gl = null;

        // this = null;
    };

    return WebGLRenderer;
}(_SystemRenderer3.default);

/**
 * Collection of installed plugins. These are included by default in PIXI, but can be excluded
 * by creating a custom build. Consult the README for more information about creating custom
 * builds and excluding plugins.
 * @name PIXI.WebGLRenderer#plugins
 * @type {object}
 * @readonly
 * @property {PIXI.accessibility.AccessibilityManager} accessibility Support tabbing interactive elements.
 * @property {PIXI.extract.WebGLExtract} extract Extract image data from renderer.
 * @property {PIXI.interaction.InteractionManager} interaction Handles mouse, touch and pointer events.
 * @property {PIXI.prepare.WebGLPrepare} prepare Pre-render display objects.
 */

/**
 * Adds a plugin to the renderer.
 *
 * @method PIXI.WebGLRenderer#registerPlugin
 * @param {string} pluginName - The name of the plugin.
 * @param {Function} ctor - The constructor function or class for the plugin.
 */

exports.default = WebGLRenderer;
_utils.pluginTarget.mixin(WebGLRenderer);
//# sourceMappingURL=WebGLRenderer.js.map

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _math = __webpack_require__(20);

var _const = __webpack_require__(5);

var _settings = __webpack_require__(17);

var _settings2 = _interopRequireDefault(_settings);

var _pixiGlCore = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class
 * @memberof PIXI
 */
var RenderTarget = function () {
  /**
   * @param {WebGLRenderingContext} gl - The current WebGL drawing context
   * @param {number} [width=0] - the horizontal range of the filter
   * @param {number} [height=0] - the vertical range of the filter
   * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
   * @param {number} [resolution=1] - The current resolution / device pixel ratio
   * @param {boolean} [root=false] - Whether this object is the root element or not
   */
  function RenderTarget(gl, width, height, scaleMode, resolution, root) {
    _classCallCheck(this, RenderTarget);

    // TODO Resolution could go here ( eg low res blurs )

    /**
     * The current WebGL drawing context.
     *
     * @member {WebGLRenderingContext}
     */
    this.gl = gl;

    // next time to create a frame buffer and texture

    /**
     * A frame buffer
     *
     * @member {PIXI.glCore.GLFramebuffer}
     */
    this.frameBuffer = null;

    /**
     * The texture
     *
     * @member {PIXI.glCore.GLTexture}
     */
    this.texture = null;

    /**
     * The background colour of this render target, as an array of [r,g,b,a] values
     *
     * @member {number[]}
     */
    this.clearColor = [0, 0, 0, 0];

    /**
     * The size of the object as a rectangle
     *
     * @member {PIXI.Rectangle}
     */
    this.size = new _math.Rectangle(0, 0, 1, 1);

    /**
     * The current resolution / device pixel ratio
     *
     * @member {number}
     * @default 1
     */
    this.resolution = resolution || _settings2.default.RESOLUTION;

    /**
     * The projection matrix
     *
     * @member {PIXI.Matrix}
     */
    this.projectionMatrix = new _math.Matrix();

    /**
     * The object's transform
     *
     * @member {PIXI.Matrix}
     */
    this.transform = null;

    /**
     * The frame.
     *
     * @member {PIXI.Rectangle}
     */
    this.frame = null;

    /**
     * The stencil buffer stores masking data for the render target
     *
     * @member {glCore.GLBuffer}
     */
    this.defaultFrame = new _math.Rectangle();
    this.destinationFrame = null;
    this.sourceFrame = null;

    /**
     * The stencil buffer stores masking data for the render target
     *
     * @member {glCore.GLBuffer}
     */
    this.stencilBuffer = null;

    /**
     * The data structure for the stencil masks
     *
     * @member {PIXI.Graphics[]}
     */
    this.stencilMaskStack = [];

    /**
     * Stores filter data for the render target
     *
     * @member {object[]}
     */
    this.filterData = null;

    /**
     * The key for pooled texture of FilterSystem
     * @private
     * @member {string}
     */
    this.filterPoolKey = '';

    /**
     * The scale mode.
     *
     * @member {number}
     * @default PIXI.settings.SCALE_MODE
     * @see PIXI.SCALE_MODES
     */
    this.scaleMode = scaleMode !== undefined ? scaleMode : _settings2.default.SCALE_MODE;

    /**
     * Whether this object is the root element or not
     *
     * @member {boolean}
     * @default false
     */
    this.root = root || false;

    if (!this.root) {
      this.frameBuffer = _pixiGlCore.GLFramebuffer.createRGBA(gl, 100, 100);

      if (this.scaleMode === _const.SCALE_MODES.NEAREST) {
        this.frameBuffer.texture.enableNearestScaling();
      } else {
        this.frameBuffer.texture.enableLinearScaling();
      }
      /*
          A frame buffer needs a target to render to..
          create a texture and bind it attach it to the framebuffer..
       */

      // this is used by the base texture
      this.texture = this.frameBuffer.texture;
    } else {
      // make it a null framebuffer..
      this.frameBuffer = new _pixiGlCore.GLFramebuffer(gl, 100, 100);
      this.frameBuffer.framebuffer = null;
    }

    this.setFrame();

    this.resize(width, height);
  }

  /**
   * Clears the filter texture.
   *
   * @param {number[]} [clearColor=this.clearColor] - Array of [r,g,b,a] to clear the framebuffer
   */


  RenderTarget.prototype.clear = function clear(clearColor) {
    var cc = clearColor || this.clearColor;

    this.frameBuffer.clear(cc[0], cc[1], cc[2], cc[3]); // r,g,b,a);
  };

  /**
   * Binds the stencil buffer.
   *
   */


  RenderTarget.prototype.attachStencilBuffer = function attachStencilBuffer() {
    // TODO check if stencil is done?
    /**
     * The stencil buffer is used for masking in pixi
     * lets create one and then add attach it to the framebuffer..
     */
    if (!this.root) {
      this.frameBuffer.enableStencil();
    }
  };

  /**
   * Sets the frame of the render target.
   *
   * @param {Rectangle} destinationFrame - The destination frame.
   * @param {Rectangle} sourceFrame - The source frame.
   */


  RenderTarget.prototype.setFrame = function setFrame(destinationFrame, sourceFrame) {
    this.destinationFrame = destinationFrame || this.destinationFrame || this.defaultFrame;
    this.sourceFrame = sourceFrame || this.sourceFrame || this.destinationFrame;
  };

  /**
   * Binds the buffers and initialises the viewport.
   *
   */


  RenderTarget.prototype.activate = function activate() {
    // TODO refactor usage of frame..
    var gl = this.gl;

    // make sure the texture is unbound!
    this.frameBuffer.bind();

    this.calculateProjection(this.destinationFrame, this.sourceFrame);

    if (this.transform) {
      this.projectionMatrix.append(this.transform);
    }

    // TODO add a check as them may be the same!
    if (this.destinationFrame !== this.sourceFrame) {
      gl.enable(gl.SCISSOR_TEST);
      gl.scissor(this.destinationFrame.x | 0, this.destinationFrame.y | 0, this.destinationFrame.width * this.resolution | 0, this.destinationFrame.height * this.resolution | 0);
    } else {
      gl.disable(gl.SCISSOR_TEST);
    }

    // TODO - does not need to be updated all the time??
    gl.viewport(this.destinationFrame.x | 0, this.destinationFrame.y | 0, this.destinationFrame.width * this.resolution | 0, this.destinationFrame.height * this.resolution | 0);
  };

  /**
   * Updates the projection matrix based on a projection frame (which is a rectangle)
   *
   * @param {Rectangle} destinationFrame - The destination frame.
   * @param {Rectangle} sourceFrame - The source frame.
   */


  RenderTarget.prototype.calculateProjection = function calculateProjection(destinationFrame, sourceFrame) {
    var pm = this.projectionMatrix;

    sourceFrame = sourceFrame || destinationFrame;

    pm.identity();

    // TODO: make dest scale source
    if (!this.root) {
      pm.a = 1 / destinationFrame.width * 2;
      pm.d = 1 / destinationFrame.height * 2;

      pm.tx = -1 - sourceFrame.x * pm.a;
      pm.ty = -1 - sourceFrame.y * pm.d;
    } else {
      pm.a = 1 / destinationFrame.width * 2;
      pm.d = -1 / destinationFrame.height * 2;

      pm.tx = -1 - sourceFrame.x * pm.a;
      pm.ty = 1 - sourceFrame.y * pm.d;
    }
  };

  /**
   * Resizes the texture to the specified width and height
   *
   * @param {number} width - the new width of the texture
   * @param {number} height - the new height of the texture
   */


  RenderTarget.prototype.resize = function resize(width, height) {
    width = width | 0;
    height = height | 0;

    if (this.size.width === width && this.size.height === height) {
      return;
    }

    this.size.width = width;
    this.size.height = height;

    this.defaultFrame.width = width;
    this.defaultFrame.height = height;

    this.frameBuffer.resize(width * this.resolution, height * this.resolution);

    var projectionFrame = this.frame || this.size;

    this.calculateProjection(projectionFrame);
  };

  /**
   * Destroys the render target.
   *
   */


  RenderTarget.prototype.destroy = function destroy() {
    if (this.frameBuffer.stencil) {
      this.gl.deleteRenderbuffer(this.frameBuffer.stencil);
    }
    this.frameBuffer.destroy();

    this.frameBuffer = null;
    this.texture = null;
  };

  return RenderTarget;
}();

exports.default = RenderTarget;
//# sourceMappingURL=RenderTarget.js.map

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (graphicsData, webGLData, webGLDataNativeLines) {
    if (graphicsData.nativeLines) {
        buildNativeLine(graphicsData, webGLDataNativeLines);
    } else {
        buildLine(graphicsData, webGLData);
    }
};

var _math = __webpack_require__(20);

var _utils = __webpack_require__(9);

/**
 * Builds a line to draw using the poligon method.
 *
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
 * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
 */
function buildLine(graphicsData, webGLData) {
    // TODO OPTIMISE!
    var points = graphicsData.points;

    if (points.length === 0) {
        return;
    }
    // if the line width is an odd number add 0.5 to align to a whole pixel
    // commenting this out fixes #711 and #1620
    // if (graphicsData.lineWidth%2)
    // {
    //     for (i = 0; i < points.length; i++)
    //     {
    //         points[i] += 0.5;
    //     }
    // }

    // get first and last point.. figure out the middle!
    var firstPoint = new _math.Point(points[0], points[1]);
    var lastPoint = new _math.Point(points[points.length - 2], points[points.length - 1]);

    // if the first point is the last point - gonna have issues :)
    if (firstPoint.x === lastPoint.x && firstPoint.y === lastPoint.y) {
        // need to clone as we are going to slightly modify the shape..
        points = points.slice();

        points.pop();
        points.pop();

        lastPoint = new _math.Point(points[points.length - 2], points[points.length - 1]);

        var midPointX = lastPoint.x + (firstPoint.x - lastPoint.x) * 0.5;
        var midPointY = lastPoint.y + (firstPoint.y - lastPoint.y) * 0.5;

        points.unshift(midPointX, midPointY);
        points.push(midPointX, midPointY);
    }

    var verts = webGLData.points;
    var indices = webGLData.indices;
    var length = points.length / 2;
    var indexCount = points.length;
    var indexStart = verts.length / 6;

    // DRAW the Line
    var width = graphicsData.lineWidth / 2;

    // sort color
    var color = (0, _utils.hex2rgb)(graphicsData.lineColor);
    var alpha = graphicsData.lineAlpha;
    var r = color[0] * alpha;
    var g = color[1] * alpha;
    var b = color[2] * alpha;

    var p1x = points[0];
    var p1y = points[1];
    var p2x = points[2];
    var p2y = points[3];
    var p3x = 0;
    var p3y = 0;

    var perpx = -(p1y - p2y);
    var perpy = p1x - p2x;
    var perp2x = 0;
    var perp2y = 0;
    var perp3x = 0;
    var perp3y = 0;

    var dist = Math.sqrt(perpx * perpx + perpy * perpy);

    perpx /= dist;
    perpy /= dist;
    perpx *= width;
    perpy *= width;

    var ratio = graphicsData.lineAlignment; // 0.5;
    var r1 = (1 - ratio) * 2;
    var r2 = ratio * 2;

    // start
    verts.push(p1x - perpx * r1, p1y - perpy * r1, r, g, b, alpha);

    verts.push(p1x + perpx * r2, p1y + perpy * r2, r, g, b, alpha);

    for (var i = 1; i < length - 1; ++i) {
        p1x = points[(i - 1) * 2];
        p1y = points[(i - 1) * 2 + 1];

        p2x = points[i * 2];
        p2y = points[i * 2 + 1];

        p3x = points[(i + 1) * 2];
        p3y = points[(i + 1) * 2 + 1];

        perpx = -(p1y - p2y);
        perpy = p1x - p2x;

        dist = Math.sqrt(perpx * perpx + perpy * perpy);
        perpx /= dist;
        perpy /= dist;
        perpx *= width;
        perpy *= width;

        perp2x = -(p2y - p3y);
        perp2y = p2x - p3x;

        dist = Math.sqrt(perp2x * perp2x + perp2y * perp2y);
        perp2x /= dist;
        perp2y /= dist;
        perp2x *= width;
        perp2y *= width;

        var a1 = -perpy + p1y - (-perpy + p2y);
        var b1 = -perpx + p2x - (-perpx + p1x);
        var c1 = (-perpx + p1x) * (-perpy + p2y) - (-perpx + p2x) * (-perpy + p1y);
        var a2 = -perp2y + p3y - (-perp2y + p2y);
        var b2 = -perp2x + p2x - (-perp2x + p3x);
        var c2 = (-perp2x + p3x) * (-perp2y + p2y) - (-perp2x + p2x) * (-perp2y + p3y);

        var denom = a1 * b2 - a2 * b1;

        if (Math.abs(denom) < 0.1) {
            denom += 10.1;
            verts.push(p2x - perpx * r1, p2y - perpy * r1, r, g, b, alpha);

            verts.push(p2x + perpx * r2, p2y + perpy * r2, r, g, b, alpha);

            continue;
        }

        var px = (b1 * c2 - b2 * c1) / denom;
        var py = (a2 * c1 - a1 * c2) / denom;
        var pdist = (px - p2x) * (px - p2x) + (py - p2y) * (py - p2y);

        if (pdist > 196 * width * width) {
            perp3x = perpx - perp2x;
            perp3y = perpy - perp2y;

            dist = Math.sqrt(perp3x * perp3x + perp3y * perp3y);
            perp3x /= dist;
            perp3y /= dist;
            perp3x *= width;
            perp3y *= width;

            verts.push(p2x - perp3x * r1, p2y - perp3y * r1);
            verts.push(r, g, b, alpha);

            verts.push(p2x + perp3x * r2, p2y + perp3y * r2);
            verts.push(r, g, b, alpha);

            verts.push(p2x - perp3x * r2 * r1, p2y - perp3y * r1);
            verts.push(r, g, b, alpha);

            indexCount++;
        } else {
            verts.push(p2x + (px - p2x) * r1, p2y + (py - p2y) * r1);
            verts.push(r, g, b, alpha);

            verts.push(p2x - (px - p2x) * r2, p2y - (py - p2y) * r2);
            verts.push(r, g, b, alpha);
        }
    }

    p1x = points[(length - 2) * 2];
    p1y = points[(length - 2) * 2 + 1];

    p2x = points[(length - 1) * 2];
    p2y = points[(length - 1) * 2 + 1];

    perpx = -(p1y - p2y);
    perpy = p1x - p2x;

    dist = Math.sqrt(perpx * perpx + perpy * perpy);
    perpx /= dist;
    perpy /= dist;
    perpx *= width;
    perpy *= width;

    verts.push(p2x - perpx * r1, p2y - perpy * r1);
    verts.push(r, g, b, alpha);

    verts.push(p2x + perpx * r2, p2y + perpy * r2);
    verts.push(r, g, b, alpha);

    indices.push(indexStart);

    for (var _i = 0; _i < indexCount; ++_i) {
        indices.push(indexStart++);
    }

    indices.push(indexStart - 1);
}

/**
 * Builds a line to draw using the gl.drawArrays(gl.LINES) method
 *
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
 * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
 */


/**
 * Builds a line to draw
 *
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
 * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
 * @param {object} webGLDataNativeLines - an object containing all the webGL-specific information to create nativeLines
 */
function buildNativeLine(graphicsData, webGLData) {
    var i = 0;
    var points = graphicsData.points;

    if (points.length === 0) return;

    var verts = webGLData.points;
    var length = points.length / 2;

    // sort color
    var color = (0, _utils.hex2rgb)(graphicsData.lineColor);
    var alpha = graphicsData.lineAlpha;
    var r = color[0] * alpha;
    var g = color[1] * alpha;
    var b = color[2] * alpha;

    for (i = 1; i < length; i++) {
        var p1x = points[(i - 1) * 2];
        var p1y = points[(i - 1) * 2 + 1];

        var p2x = points[i * 2];
        var p2y = points[i * 2 + 1];

        verts.push(p1x, p1y);
        verts.push(r, g, b, alpha);

        verts.push(p2x, p2y);
        verts.push(r, g, b, alpha);
    }
}
//# sourceMappingURL=buildLine.js.map

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DeviceType;
(function (DeviceType) {
    DeviceType["DESKTOP"] = "desktop";
    DeviceType["MOBILE"] = "mobile";
})(DeviceType = exports.DeviceType || (exports.DeviceType = {}));


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = __webpack_require__(14);
var Device_1 = __webpack_require__(42);
var System_1 = __webpack_require__(52);
var CoreDI_1 = __webpack_require__(32);
var DefaultFullscreenView_1 = __webpack_require__(474);
var ScreenEvents_1 = __webpack_require__(108);
var IOSFullScreenView_1 = __webpack_require__(475);
var ScreenOrientation;
(function (ScreenOrientation) {
    ScreenOrientation[ScreenOrientation["PORTRAIT"] = 0] = "PORTRAIT";
    ScreenOrientation[ScreenOrientation["LANDSCAPE"] = 1] = "LANDSCAPE";
})(ScreenOrientation = exports.ScreenOrientation || (exports.ScreenOrientation = {}));
var FullscreenManager = /** @class */ (function () {
    function FullscreenManager(device, app, system, eventManager) {
        /**
         * flag for iOS safari bug when semi-fullscreen shows after rotation
         */
        this._hasIOSBug = false;
        this._oldFullScreenStatus = false;
        this._previousFullscreen = false;
        this._device = device;
        this._app = app;
        this._system = system;
        this._eventManager = eventManager;
        this._canvas = this._app.view;
        window.addEventListener('resize', this.onOrientationChanged.bind(this));
        this.setCurrentParameters();
        this.screenUpdateCallback();
        if (this._device.mobileSafari) {
            this._view = new IOSFullScreenView_1.IOSFullScreenView();
        }
        else if (this._device.fullscreen) {
            this._view = new DefaultFullscreenView_1.DefaultFullscreenView();
            if (!this._device.desktop) {
                document.body.addEventListener('touchend', this.onElementClicked.bind(this));
            }
        }
        if (!this._device.isIframe && !this._device.isFullscreenDisabledByIntegration && this._device.android) {
            this._previousFullscreen = this.isFullscreen();
        }
        this.setOrientationFromWindowParams();
        this.resizeCanvas();
    }
    FullscreenManager.prototype.onFullscreenChange = function () {
        if (this.isFullscreen() !== this._previousFullscreen) {
            this._eventManager.emit(ScreenEvents_1.ScreenEvents.FULLSCREEN_STATUS_CHANGED);
            this.isFullscreen()
                ? this._eventManager.emit(ScreenEvents_1.ScreenEvents.FULLSCREEN_ENTERED)
                : this._eventManager.emit(ScreenEvents_1.ScreenEvents.FULLSCREEN_EXITED);
        }
        this._previousFullscreen = this.isFullscreen();
    };
    FullscreenManager.prototype.setCurrentParameters = function () {
        this._currentWidth = window.innerWidth;
        this._currentHeight = window.innerHeight;
        this._currentOuterHeight = window.outerHeight;
        this._currentOuterWidth = window.outerWidth;
        this._currentOrientation = this.getOrientation();
    };
    FullscreenManager.prototype.screenUpdateCallback = function () {
        var _this = this;
        // update orientation if it was changed or there is a special IOS bug
        if (this._currentOrientation !== this.getOrientation() || this._hasIOSBug) {
            this.onOrientationChanged();
        }
        // updating size of the screen if window size was changed or there is a special IOS bug
        if (window.innerWidth !== this._currentWidth || window.innerHeight !== this._currentHeight || this._hasIOSBug) {
            this.resize();
        }
        // if we have an iframe and window size changed
        if (this._device.isIframe && (window.outerWidth !== this._currentOuterWidth || window.outerHeight !== this._currentOuterHeight)) {
            this.onOrientationChanged();
            this._currentOuterHeight = window.outerHeight;
            this._currentOuterWidth = window.outerWidth;
        }
        // repeating this check every 100 ms
        setTimeout(function () {
            _this.screenUpdateCallback();
        }, 100);
    };
    FullscreenManager.prototype.forceUpdate = function () {
        this.onOrientationChanged();
    };
    FullscreenManager.prototype.windowPositionToCanvas = function (windowPosition) {
        var ratio = this._system.resolutionManager.resolution.width / this._canvasWidth;
        var position = { x: windowPosition.x * ratio, y: windowPosition.y * ratio };
        return position;
    };
    FullscreenManager.prototype.canvasPositionToWindow = function (canvasPosition) {
        var ratio = this._canvasWidth / this._system.resolutionManager.resolution.width;
        var position = { x: canvasPosition.x * ratio, y: canvasPosition.y * ratio };
        return position;
    };
    FullscreenManager.prototype.canGoToFullscreen = function () {
        return !this.isFullscreen() && !this._device.isFullscreenDisabledByIntegration && !this._device.isIframe;
    };
    FullscreenManager.prototype.onElementClicked = function () {
        var _this = this;
        // Blocking fullscreen on iframe. Because Dervico said so?
        if (this.canGoToFullscreen()) {
            document.body[this._device.requestFullscreen]();
            setTimeout(function () {
                _this.onFullscreenChange();
                if (document.getElementById('viewporter')) {
                    document.getElementById('viewporter').style.height = window.innerHeight + "px";
                    document.documentElement.style.minHeight = window.innerHeight + "px";
                }
            }, 500);
        }
    };
    FullscreenManager.prototype.isFullscreen = function () {
        return !!document[this._device.fullscreenElement];
    };
    FullscreenManager.prototype.onResized = function () {
        this._view.handle(this._orientation);
        this.resizeCanvas();
        var params = {
            width: this._width,
            height: this._height,
            orientation: this._orientation,
        };
        this._eventManager.emit(ScreenEvents_1.ScreenEvents.SCREEN_RESIZED, params);
    };
    FullscreenManager.prototype.resize = function () {
        this._view && this._view.handle(this._orientation);
        this.resizeCanvas();
        var params = {
            width: this._width,
            height: this._height,
            orientation: this._orientation,
        };
        this._currentWidth = window.innerWidth;
        this._currentHeight = window.innerHeight;
        this._eventManager.emit(ScreenEvents_1.ScreenEvents.SCREEN_RESIZED, params);
    };
    FullscreenManager.prototype.resizeCanvas = function () {
        if (!this._device.desktop) {
            if (this._orientation === ScreenOrientation.LANDSCAPE) {
                this._width = this._system.viewport.width;
                this._height = this._system.viewport.height;
            }
            else {
                this._width = this._system.viewport.height;
                this._height = this._system.viewport.width; // * window.innerHeight / window.innerWidth;
            }
            this._app.renderer.resize(this._width, this._height);
        }
        else {
            this._width = this._system.viewport.width;
            this._height = this._system.viewport.height;
            this._canvas.style.top = '0px';
            this._canvas.style.left = '0px';
        }
        var ratio = this._canvas.width / this._canvas.height;
        var w;
        var h;
        var innerWidth = 0;
        var innerHeight = 0;
        innerWidth = window.innerWidth;
        innerHeight = window.innerHeight;
        if (this._device.desktop /*|| this._orientation === ScreenOrientation.LANDSCAPE*/) {
            if (innerWidth / innerHeight >= ratio) {
                w = innerHeight * ratio;
                h = innerHeight;
            }
            else {
                w = innerWidth;
                h = innerWidth / ratio;
            }
        }
        else {
            if (!this._device.iOS) {
                if (!this._device.isIframe) {
                    innerWidth = window.outerWidth;
                    innerHeight = window.outerHeight;
                }
            }
            var dpr = window.devicePixelRatio;
            var innerRatio = innerWidth / innerHeight;
            if (innerRatio > ratio) {
                w = innerWidth * (ratio / innerRatio);
                h = innerHeight;
                var marginLeft = (innerWidth - w) / 2;
                var marginTop = (innerHeight - h) / 2;
                this._canvas.style.marginLeft = Math.ceil(marginLeft) + 'px';
                this._canvas.style.marginTop = Math.ceil(marginTop) + 'px';
                if (this._hasIOSBug && this._canvas.getBoundingClientRect().top !== 0) {
                    this._canvas.style.marginTop = Math.ceil(marginTop - this._canvas.getBoundingClientRect().top) + 'px';
                    this._hasIOSBug = false;
                }
            }
            else {
                w = innerWidth;
                h = innerHeight * (innerRatio / ratio);
                var marginLeft = (innerWidth - w) / 2;
                var marginTop = (innerHeight - h) / 2;
                this._canvas.style.marginLeft = Math.ceil(marginLeft) + 'px';
                this._canvas.style.marginTop = Math.ceil(marginTop) + 'px';
                if (this._hasIOSBug && this._canvas.getBoundingClientRect().top !== 0) {
                    this._canvas.style.marginTop = Math.ceil(marginTop - this._canvas.getBoundingClientRect().top) + 'px';
                    this._hasIOSBug = false;
                }
            }
        }
        this._canvas.style.width = Math.ceil(w) + 'px';
        this._canvas.style.height = Math.ceil(h) + 'px';
        this._canvasWidth = w;
        this._canvasHeight = h;
    };
    FullscreenManager.prototype.onOrientationChanged = function () {
        var _this = this;
        // special delays for different kind of devices
        var delay = this._device.iOS || this._device.isIOSMobileRequestingDesktop ? 200 : 0;
        delay = this._device.isSamsungNative ? 400 : delay;
        this._hasIOSBug = false;
        if (!this._device.isIframe && !this._device.isFullscreenDisabledByIntegration && this._device.android) {
            this.onFullscreenChange();
        }
        setTimeout(function () {
            var orientBefore = _this._orientation;
            _this.setOrientationFromWindowParams();
            if (orientBefore !== _this._orientation) {
                _this.updateScreenBasedOnOrientation();
            }
            else {
                if (_this._device.iOS && _this._device.mobileSafari) {
                    if (_this._oldFullScreenStatus && !_this.isFullscreenIOS(_this._orientation)) {
                        _this._hasIOSBug = true;
                    }
                }
                _this.updateScreenBasedOnOrientation();
            }
            _this._currentOrientation = _this._orientation;
            _this._oldFullScreenStatus = _this.isFullscreenIOS(_this._orientation);
        }, delay);
    };
    FullscreenManager.prototype.isFullscreenIOS = function (orientation) {
        if (orientation === ScreenOrientation.LANDSCAPE) {
            // for safari "window.innerHeight >= screen.width" is enough but for chrome we need to
            // have 20px navbar;
            var barHeight = 44;
            return window.innerHeight + barHeight >= screen.width;
        }
        else {
            var barHeight = 64;
            return window.innerHeight + barHeight >= screen.height;
        }
    };
    FullscreenManager.prototype.setOrientationFromWindowParams = function () {
        if (this._device.iOS && this._device.isMobile && window.hasOwnProperty('orientation')) {
            if (window.orientation === 90 || window.orientation === -90) {
                this._orientation = ScreenOrientation.LANDSCAPE;
            }
            else {
                this._orientation = ScreenOrientation.PORTRAIT;
            }
        }
        else {
            if (window.innerHeight <= window.innerWidth) {
                this._orientation = ScreenOrientation.LANDSCAPE;
            }
            else {
                this._orientation = ScreenOrientation.PORTRAIT;
            }
        }
    };
    FullscreenManager.prototype.getOrientation = function () {
        if (this._device.iOS && this._device.isMobile && window.hasOwnProperty('orientation')) {
            if (window.orientation === 90 || window.orientation === -90) {
                return ScreenOrientation.LANDSCAPE;
            }
            else {
                return ScreenOrientation.PORTRAIT;
            }
        }
        else {
            if (window.innerHeight <= window.innerWidth) {
                return ScreenOrientation.LANDSCAPE;
            }
            else {
                return ScreenOrientation.PORTRAIT;
            }
        }
    };
    FullscreenManager.prototype.updateScreenBasedOnOrientation = function () {
        if (this._device.isMobile) {
            if (this._orientation === ScreenOrientation.LANDSCAPE) {
                this._eventManager.emit(ScreenEvents_1.ScreenEvents.LANDSCAPE_MODE);
            }
            else {
                this._eventManager.emit(ScreenEvents_1.ScreenEvents.PORTRAIT_MODE);
            }
            this._eventManager.emit(ScreenEvents_1.ScreenEvents.ORIENTATION_CHANGED, this._orientation);
        }
        this.onResized();
    };
    FullscreenManager.prototype.fullscreenDisabledByIntegration = function (isDisabled) {
        this._device.fullscreenDisabledByIntegration = isDisabled;
    };
    Object.defineProperty(FullscreenManager.prototype, "orientation", {
        get: function () {
            return this._orientation;
        },
        enumerable: true,
        configurable: true
    });
    FullscreenManager = __decorate([
        inversify_1.injectable(),
        __param(0, inversify_1.inject(CoreDI_1.CoreDI.Device)),
        __param(1, inversify_1.inject(CoreDI_1.CoreDI.Application)),
        __param(2, inversify_1.inject(CoreDI_1.CoreDI.System)),
        __param(3, inversify_1.inject(CoreDI_1.CoreDI.IEventManagerWithAsync)),
        __metadata("design:paramtypes", [Device_1.Device, PIXI.Application, System_1.System, Object])
    ], FullscreenManager);
    return FullscreenManager;
}());
exports.FullscreenManager = FullscreenManager;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ScreenEvents = /** @class */ (function () {
    function ScreenEvents() {
    }
    ScreenEvents.BECAME_VISIBLE = 'ScreenEvents::BECAME_VISIBLE';
    ScreenEvents.BECAME_INVISIBLE = 'ScreenEvents::BECAME_INVISIBLE';
    ScreenEvents.SCREEN_RESIZED = 'ScreenEvents::SCREEN_RESIZED';
    ScreenEvents.ORIENTATION_CHANGED = 'ScreenEvents::ORIENTATION_CHANGED';
    ScreenEvents.LANDSCAPE_MODE = 'ScreenEvents::LANDSCAPE_MODE';
    ScreenEvents.PORTRAIT_MODE = 'ScreenEvents::PORTRAIT_MODE';
    ScreenEvents.FULLSCREEN_STATUS_CHANGED = 'ScreenEvents::FULLSCREEN_STATUS_CHANGED';
    ScreenEvents.FULLSCREEN_EXITED = 'FULLSCREEN_EXITED';
    ScreenEvents.FULLSCREEN_ENTERED = 'ScreenEvents::FULLSCREEN_ENTERED';
    return ScreenEvents;
}());
exports.ScreenEvents = ScreenEvents;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = __webpack_require__(14);
var Settings = /** @class */ (function () {
    function Settings() {
        this._settings = {};
        this.add(Settings_1.IS_QUICKSPIN_AVAILABLE, true);
        this.add(Settings_1.QUICKSPIN, false);
        this.add(Settings_1.SOUNDS_ON, true);
        this.add(Settings_1.MUSIC_ON, true);
    }
    Settings_1 = Settings;
    Settings.prototype.has = function (name) {
        return this._settings.hasOwnProperty(name);
    };
    Settings.prototype.add = function (name, value) {
        this._settings[name] = value;
    };
    Settings.prototype.remove = function (name) {
        delete this._settings[name];
    };
    Settings.prototype.get = function (name) {
        return this._settings[name];
    };
    var Settings_1;
    Settings.IS_QUICKSPIN_AVAILABLE = 'Settings::IsQuickSpinAvailable';
    Settings.QUICKSPIN = 'Settings::QuickSpin';
    Settings.SOUNDS_ON = 'Settings::SoundsOn';
    Settings.MUSIC_ON = 'Settings::MusicOn';
    Settings = Settings_1 = __decorate([
        inversify_1.injectable(),
        __metadata("design:paramtypes", [])
    ], Settings);
    return Settings;
}());
exports.Settings = Settings;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var WinLine_1 = __webpack_require__(490);
var ExplosionDirection;
(function (ExplosionDirection) {
    ExplosionDirection[ExplosionDirection["BIG_ONE"] = 0] = "BIG_ONE";
    ExplosionDirection[ExplosionDirection["LEFT_TOP"] = 1] = "LEFT_TOP";
    ExplosionDirection[ExplosionDirection["RIGHT_TOP"] = 2] = "RIGHT_TOP";
    ExplosionDirection[ExplosionDirection["RIGHT_BOTTOM"] = 3] = "RIGHT_BOTTOM";
    ExplosionDirection[ExplosionDirection["LEFT_BOTTOM"] = 4] = "LEFT_BOTTOM";
})(ExplosionDirection = exports.ExplosionDirection || (exports.ExplosionDirection = {}));
var ExpandingWildReel = /** @class */ (function () {
    function ExpandingWildReel(reelIndex, rowIndex, multiplier) {
        this._reelIndex = reelIndex;
        this._rowIndex = rowIndex;
        this._multiplier = multiplier;
    }
    Object.defineProperty(ExpandingWildReel.prototype, "reelIndex", {
        get: function () {
            return this._reelIndex;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExpandingWildReel.prototype, "rowIndex", {
        get: function () {
            return this._rowIndex;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExpandingWildReel.prototype, "multiplier", {
        get: function () {
            return this._multiplier;
        },
        enumerable: true,
        configurable: true
    });
    return ExpandingWildReel;
}());
exports.ExpandingWildReel = ExpandingWildReel;
var RespinScatterInfo = /** @class */ (function () {
    function RespinScatterInfo(respinScatterPosition, respinSymbols) {
        this._respinScatterPosition = respinScatterPosition;
        this._respinSymbols = respinSymbols;
    }
    Object.defineProperty(RespinScatterInfo.prototype, "respinScatterPosition", {
        get: function () {
            return this._respinScatterPosition;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RespinScatterInfo.prototype, "respinSymbols", {
        get: function () {
            return this._respinSymbols;
        },
        enumerable: true,
        configurable: true
    });
    return RespinScatterInfo;
}());
exports.RespinScatterInfo = RespinScatterInfo;
var ExplosionInfo = /** @class */ (function () {
    function ExplosionInfo(explosionSourcePosition, explodedSymbols, explosionDirection) {
        this._explosionSourcePosition = explosionSourcePosition;
        this._explodedSymbols = explodedSymbols;
        this._explosionDirection = explosionDirection;
    }
    Object.defineProperty(ExplosionInfo.prototype, "explosionSourcePosition", {
        get: function () {
            return this._explosionSourcePosition;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExplosionInfo.prototype, "explodedSymbols", {
        get: function () {
            return this._explodedSymbols;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExplosionInfo.prototype, "explosionDirection", {
        get: function () {
            return this._explosionDirection;
        },
        enumerable: true,
        configurable: true
    });
    return ExplosionInfo;
}());
exports.ExplosionInfo = ExplosionInfo;
var RespinNewSymbol = /** @class */ (function () {
    function RespinNewSymbol(reel, symbol, height) {
        this._reel = reel;
        this._symbol = symbol;
        this._height = height;
    }
    Object.defineProperty(RespinNewSymbol.prototype, "reel", {
        get: function () {
            return this._reel;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RespinNewSymbol.prototype, "symbol", {
        get: function () {
            return this._symbol;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RespinNewSymbol.prototype, "height", {
        get: function () {
            return this._height;
        },
        enumerable: true,
        configurable: true
    });
    return RespinNewSymbol;
}());
exports.RespinNewSymbol = RespinNewSymbol;
var GameWinLine = /** @class */ (function (_super) {
    __extends(GameWinLine, _super);
    function GameWinLine(index, symbol, positions, winPositions, win, betways, reelsInWin) {
        var _this = _super.call(this, index, symbol, positions, winPositions, win) || this;
        _this._betways = betways;
        _this._reelsInWin = reelsInWin;
        return _this;
    }
    Object.defineProperty(GameWinLine.prototype, "betways", {
        get: function () {
            return this._betways;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GameWinLine.prototype, "reelsInWin", {
        get: function () {
            return this._reelsInWin;
        },
        enumerable: true,
        configurable: true
    });
    return GameWinLine;
}(WinLine_1.WinLine));
exports.GameWinLine = GameWinLine;
var LevelData = /** @class */ (function () {
    function LevelData(position, offset, currentLevel) {
        this._position = position;
        this._offset = offset;
        this._currentLevel = currentLevel;
    }
    Object.defineProperty(LevelData.prototype, "position", {
        get: function () {
            return this._position;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LevelData.prototype, "offset", {
        get: function () {
            return this._offset;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LevelData.prototype, "currentLevel", {
        get: function () {
            return this._currentLevel;
        },
        enumerable: true,
        configurable: true
    });
    return LevelData;
}());
exports.LevelData = LevelData;
var AvalancheNewSymbol = /** @class */ (function () {
    function AvalancheNewSymbol(reel, row, symbol, height) {
        this._reel = reel;
        this._row = row;
        this._symbol = symbol;
        this._height = height;
    }
    Object.defineProperty(AvalancheNewSymbol.prototype, "reel", {
        get: function () {
            return this._reel;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AvalancheNewSymbol.prototype, "row", {
        get: function () {
            return this._row;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AvalancheNewSymbol.prototype, "symbol", {
        get: function () {
            return this._symbol;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AvalancheNewSymbol.prototype, "height", {
        get: function () {
            return this._height;
        },
        enumerable: true,
        configurable: true
    });
    return AvalancheNewSymbol;
}());
exports.AvalancheNewSymbol = AvalancheNewSymbol;
var SpinResult = /** @class */ (function () {
    function SpinResult() {
        this._expandingWilds = [];
        this._oldWilds = [];
    }
    Object.defineProperty(SpinResult.prototype, "stopPositions", {
        get: function () {
            return this._stopPositions;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpinResult.prototype, "spinWin", {
        get: function () {
            return this._spinWin;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpinResult.prototype, "nextSpinWin", {
        get: function () {
            return this._nextSpinWin;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpinResult.prototype, "win", {
        get: function () {
            return this._win;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpinResult.prototype, "winLines", {
        get: function () {
            return this._winLines;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpinResult.prototype, "reels", {
        get: function () {
            return this._reels;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpinResult.prototype, "previousReels", {
        get: function () {
            return this._previousReels;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpinResult.prototype, "balance", {
        get: function () {
            return this._balance;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpinResult.prototype, "symbolsToRemove", {
        get: function () {
            return this._symbolsToRemove;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpinResult.prototype, "symbolsToAdd", {
        get: function () {
            return this._symbolsToAdd;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpinResult.prototype, "respinNewSymbols", {
        get: function () {
            return this._respinNewSymbols;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpinResult.prototype, "expandingWilds", {
        get: function () {
            return this._expandingWilds;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpinResult.prototype, "individualSymbolsRespins", {
        get: function () {
            return this._individualSymbolsRespins;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpinResult.prototype, "expandedWildsToRemove", {
        get: function () {
            return this._expandedWildsToRemove;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpinResult.prototype, "respinScatters", {
        get: function () {
            return this._respinScatters;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpinResult.prototype, "explosions", {
        get: function () {
            return this._explosions;
        },
        enumerable: true,
        configurable: true
    });
    return SpinResult;
}());
exports.SpinResult = SpinResult;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SpinButtonViewEvents = /** @class */ (function () {
    function SpinButtonViewEvents() {
    }
    SpinButtonViewEvents.SPIN_BUTTON_CLICKED = 'SpinButtonViewEvents::__SPIN_BUTTON_CLICKED__';
    SpinButtonViewEvents.SPIN_BUTTON_HOLD = 'SpinButtonViewEvents::__SPIN_BUTTON_HOLD__';
    return SpinButtonViewEvents;
}());
exports.SpinButtonViewEvents = SpinButtonViewEvents;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ReelConstants_1 = __webpack_require__(10);
var ReelsUtils = /** @class */ (function () {
    function ReelsUtils() {
    }
    ReelsUtils.getReelCenterPosition = function (reelIndex, viewType) {
        if (viewType === void 0) { viewType = ReelConstants_1.ReelConstants.DEFAULT_VIEW; }
        return {
            x: ReelConstants_1.ReelConstants.getReelsOffsets(viewType).x +
                ReelConstants_1.ReelConstants.getSymbolSlot(viewType).width * reelIndex +
                ReelConstants_1.ReelConstants.getSymbolSlot(viewType).width / 2,
            y: ReelConstants_1.ReelConstants.getReelsOffsets(viewType).y +
                ReelConstants_1.ReelConstants.getSymbolSlot(viewType).height * (ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT / 2) +
                ReelConstants_1.ReelConstants.getSymbolSlot(viewType).height / 2,
        };
    };
    ReelsUtils.getSymbolScreenPosition = function (pos, viewType) {
        if (viewType === void 0) { viewType = ReelConstants_1.ReelConstants.DEFAULT_VIEW; }
        return {
            x: ReelConstants_1.ReelConstants.getReelsOffsets(viewType).x +
                ReelConstants_1.ReelConstants.getSymbolSlot(viewType).width * pos.x +
                ReelConstants_1.ReelConstants.getSymbolSlot(viewType).width / 2,
            y: ReelConstants_1.ReelConstants.getReelsOffsets(viewType).y +
                ReelConstants_1.ReelConstants.getSymbolSlot(viewType).height * pos.y +
                ReelConstants_1.ReelConstants.getSymbolSlot(viewType).height / 2,
        };
    };
    ReelsUtils.getPositionOnReels = function (pos, reels, viewType) {
        if (viewType === void 0) { viewType = ReelConstants_1.ReelConstants.DEFAULT_VIEW; }
        var xPos = ReelConstants_1.ReelConstants.getReelsOffsets(viewType).x +
            pos.x * ReelConstants_1.ReelConstants.getSymbolSlot(viewType).width +
            ReelConstants_1.ReelConstants.getSymbolSlot(viewType).width / 2;
        var ySymSizeOffset = this.getSymbolOnReelsPosition(pos, reels, viewType);
        var yPos = ReelConstants_1.ReelConstants.getReelsOffsets().y +
            ySymSizeOffset * ReelConstants_1.ReelConstants.getSymbolSlot(viewType).height +
            ReelConstants_1.ReelConstants.getSymbolSlot(viewType).height / 2;
        return { x: xPos, y: yPos };
    };
    ReelsUtils.getPositionInTheMiddleOfTheReel = function (reelIndex, viewType) {
        if (viewType === void 0) { viewType = ReelConstants_1.ReelConstants.DEFAULT_VIEW; }
        var xPos = ReelConstants_1.ReelConstants.getReelsOffsets(viewType).x +
            reelIndex * ReelConstants_1.ReelConstants.getSymbolSlot(viewType).width +
            ReelConstants_1.ReelConstants.getSymbolSlot(viewType).width / 2;
        var yPos = ReelConstants_1.ReelConstants.getReelsOffsets(viewType).y + (ReelConstants_1.ReelConstants.ROW_AMOUNT / 2) * ReelConstants_1.ReelConstants.getSymbolSlot(viewType).height;
        return { x: xPos, y: yPos };
    };
    ReelsUtils.getSymbolOnReelsPosition = function (pos, reels, viewType) {
        if (viewType === void 0) { viewType = ReelConstants_1.ReelConstants.DEFAULT_VIEW; }
        var offset = 0;
        for (var i = 0; i < pos.y; i++) {
            var sym = reels[pos.x][i];
            offset += sym.size.height;
        }
        return offset;
    };
    ReelsUtils.getVectorLengthFromPositions = function (fromPosition, toPosition) {
        var a = Math.pow(Math.abs(fromPosition.x - toPosition.x), 2);
        var b = Math.pow(Math.abs(fromPosition.y - toPosition.y), 2);
        return Math.sqrt(a + b);
    };
    /**
     *
     * Mapping -> [0,1][2,3]
     * To ->      [0,2,1,3]
     *
     * @memberof ReelsUtils
     */
    ReelsUtils.matrixToArray = function (reelMatrix) {
        var array = [];
        var totalLength = 0;
        for (var _i = 0, reelMatrix_1 = reelMatrix; _i < reelMatrix_1.length; _i++) {
            var col = reelMatrix_1[_i];
            totalLength += col.length;
        }
        var indexes = { row: -1, column: 0 };
        for (var index = 0; index < totalLength; index++) {
            indexes.column++;
            if (index % reelMatrix.length === 0) {
                indexes.row++;
                indexes.column = 0;
            }
            array.push(reelMatrix[indexes.column][indexes.row]);
        }
        return array;
    };
    ReelsUtils.matrixToArraySimple = function (reelMatrix) {
        var array = [];
        for (var col = 0; col < reelMatrix.length; col++) {
            var column = reelMatrix[col];
            for (var row = 0; row < column.length; row++) {
                var sym = column[row];
                array.push(sym);
            }
        }
        return array;
    };
    ReelsUtils.MatrixToArraySortingOrderByColumn = function (reelMatrix, indexes, index) {
        indexes.column++;
        if (index % reelMatrix.length === 0) {
            indexes.row++;
            indexes.column = 0;
        }
    };
    /**
     * Remaps an Array to a Matrix based on set columns.
     * Mapping is -> [0,1,2,3]
     * To ->        [0,2][1,3]
     *
     */
    ReelsUtils.arrayToMatrix = function (array, columns) {
        var matrix = [];
        var columnIndex = 0;
        for (var index = 0; index < array.length; index++) {
            if (!matrix[columnIndex]) {
                matrix.push([]);
            }
            matrix[columnIndex].push(array[index]);
            columnIndex++;
            if (columnIndex > columns - 1) {
                columnIndex = 0;
            }
        }
        return matrix;
    };
    /**
     *    Remaps an Array to a Matrix based on set columns and runs a provided callback function on each item.
     *    Mapping is -> [0,1,2,3]
     *  To ->         [0,2][1,3]
     *
     * @memberof ReelsUtils
     */
    ReelsUtils.arrayToMatrixWithCallback = function (array, columns, rows, itemCallback, orderLogic, pushLogic) {
        if (orderLogic === void 0) { orderLogic = ReelsUtils.MatrixSortingOrderByRow; }
        if (pushLogic === void 0) { pushLogic = ReelsUtils.IsNotNullPushMatrixColumn; }
        var matrix = [];
        var indexes = { row: 0, column: 0 };
        var limits = { columns: columns, rows: rows };
        for (var index = 0; index < array.length; index++) {
            var item = itemCallback(array[index], indexes, limits, index);
            pushLogic(matrix, item, indexes, index);
            orderLogic(matrix, indexes, limits, index);
        }
        return matrix;
    };
    ReelsUtils.AlwaysPushMatrixColumn = function (matrix, item, indexes, index) {
        if (!matrix[indexes.column]) {
            matrix.push([]);
        }
        matrix[indexes.column].push(item);
    };
    ReelsUtils.IsNotNullPushMatrixColumn = function (matrix, item, indexes, index) {
        if (!matrix[indexes.column]) {
            matrix.push([]);
        }
        if (item) {
            matrix[indexes.column].push(item);
        }
    };
    ReelsUtils.MatrixSortingOrderByRow = function (matrix, indexes, limits, index) {
        indexes.column++;
        if (indexes.column > limits.columns - 1) {
            indexes.row++;
            indexes.column = 0;
        }
    };
    ReelsUtils.MatrixSortingOrderByColumn = function (matrix, indexes, limits, index) {
        // TODO: Fix.
    };
    ReelsUtils.MatrixSortingOrderByRowReverse = function (matrix, indexes, limits, index) {
        // TODO: Fix.
    };
    ReelsUtils.MatrixSortingOrderByColumnReverse = function (matrix, indexes, limits, index) {
        // TODO: Fix.
    };
    ReelsUtils.MatrixSortingOrderRandom = function (matrix, indexes, limits, index) {
        // TODO: Fix.
    };
    return ReelsUtils;
}());
exports.ReelsUtils = ReelsUtils;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Meter_1 = __webpack_require__(522);
var Easing_1 = __webpack_require__(16);
var WinMeter = /** @class */ (function (_super) {
    __extends(WinMeter, _super);
    function WinMeter(winText, easing, formatter, includeCurrenySign, scale) {
        if (easing === void 0) { easing = Easing_1.Easing.Linear.None; }
        if (includeCurrenySign === void 0) { includeCurrenySign = false; }
        if (scale === void 0) { scale = 1; }
        var _this = _super.call(this, null, easing, formatter) || this;
        _this._resolutionPadding = 0;
        _this._autoFitWinNumbers = true;
        _this._winText = winText;
        _this._includeCurrencySign = includeCurrenySign;
        _this._winText.scale.set(scale);
        return _this;
    }
    WinMeter.prototype.forceUpdate = function () {
        this.onUpdate();
    };
    WinMeter.prototype.onUpdate = function () {
        if (this._winText) {
            this._winText.showNumber(this.format(this._valueWrapper.value, this._includeCurrencySign));
            if (this._resolutionWidth && this._autoFitWinNumbers) {
                this.checkBounds();
            }
        }
    };
    WinMeter.prototype.checkBounds = function () {
        if (this._resolutionWidth) {
            this.fitWinTextToScreenSize();
        }
    };
    WinMeter.prototype.fitWinTextToScreenSize = function () {
        var bounds = this._winText.getBounds();
        if (bounds.width / this._winText.scale.x > this._resolutionWidth) {
            if (this._winText.scale.y < 0) {
                this._winText.scale.set(this._resolutionWidth / (bounds.width / this._winText.scale.x), this._resolutionWidth / (bounds.width / this._winText.scale.x) * -1);
            }
            else {
                this._winText.scale.set(this._resolutionWidth / (bounds.width / this._winText.scale.x), this._resolutionWidth / (bounds.width / this._winText.scale.x));
            }
        }
    };
    WinMeter.prototype.format = function (value, includeCurrencySign) {
        if (includeCurrencySign === void 0) { includeCurrencySign = false; }
        return this._formatter ? this._formatter.formatCurrency(value, includeCurrencySign) : value.toFixed(2);
    };
    WinMeter.prototype.setTextAdditionalOffsets = function (numberOffset, comaAdditionalOffset) {
        this._winText.additionalOffset = numberOffset;
        this._winText.comaAdditionalOffset = comaAdditionalOffset;
    };
    Object.defineProperty(WinMeter.prototype, "bigWinText", {
        set: function (value) {
            this._winText = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WinMeter.prototype, "resolutionWidth", {
        set: function (value) {
            this._resolutionWidth = value - this.resolutionPadding;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WinMeter.prototype, "resolutionPadding", {
        get: function () {
            return this._resolutionPadding;
        },
        set: function (value) {
            this._resolutionPadding = value;
        },
        enumerable: true,
        configurable: true
    });
    return WinMeter;
}(Meter_1.Meter));
exports.WinMeter = WinMeter;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var FlowModule_1 = __webpack_require__(35);
var QueueEventsHandler_1 = __webpack_require__(115);
var FlowModuleEvents_1 = __webpack_require__(0);
var WinPresentationEvents_1 = __webpack_require__(13);
var BigWinEvents_1 = __webpack_require__(21);
var WinUtils_1 = __webpack_require__(58);
var FlowWinningState = /** @class */ (function (_super) {
    __extends(FlowWinningState, _super);
    function FlowWinningState(module, name, eventManager) {
        var _this = _super.call(this, module, name) || this;
        _this._queueEvents = new QueueEventsHandler_1.QueueEventsHandler(eventManager);
        _this.handler = _this.onKey.bind(_this);
        document.addEventListener('keydown', _this.handler, true);
        return _this;
    }
    FlowWinningState.prototype.onKey = function (event) {
        if (false) {
            if (event.code === 'KeyZ') {
                console.log("from class: " + this.constructor.name);
                if (this._queueEvents) {
                    this._queueEvents.printData();
                }
            }
        }
    };
    FlowWinningState.prototype.onEnterState = function () {
    };
    FlowWinningState.prototype.onLeaveState = function () {
        this._queueEvents.clearEventsQueue();
    };
    FlowWinningState.prototype.handle = function (id, data) {
        _super.prototype.handle.call(this, id, data);
        this._queueEvents.handleWaitingList(id, data);
    };
    FlowWinningState.prototype.setupEvents = function () {
    };
    FlowWinningState.prototype.sendOutCanSpin = function () {
        this.emit(FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN);
    };
    FlowWinningState.prototype.setupCantSpinNoWin = function () {
        this.emit(FlowModuleEvents_1.FlowModuleEvents.NO_WIN);
    };
    FlowWinningState.prototype.setupNoWin = function () {
        this.emit(FlowModuleEvents_1.FlowModuleEvents.NO_WIN);
        this.sendOutCanSpin();
        this.gotoBasicState();
    };
    FlowWinningState.prototype.setupCantSpinWin = function () {
        this.emit(FlowModuleEvents_1.FlowModuleEvents.WON);
    };
    FlowWinningState.prototype.setupWin = function () {
        this.emit(FlowModuleEvents_1.FlowModuleEvents.WON);
        this._queueEvents.addEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED, FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN);
        this._queueEvents.addEventToWaitingList(FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN, FlowModuleEvents_1.FlowModuleEvents.START_INDIVIDUAL_WIN);
    };
    FlowWinningState.prototype.setupCantSpinBigWin = function () {
        this.emit(FlowModuleEvents_1.FlowModuleEvents.WON_BIG_WIN);
    };
    FlowWinningState.prototype.setupBigWin = function () {
        this._queueEvents.addEventToWaitingList(BigWinEvents_1.BigWinEvents.FINISHED, FlowModuleEvents_1.FlowModuleEvents.WON);
        this._queueEvents.addEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED, FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN);
        this._queueEvents.addEventToWaitingList(FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN, FlowModuleEvents_1.FlowModuleEvents.START_INDIVIDUAL_WIN);
        this.emit(FlowModuleEvents_1.FlowModuleEvents.WON_BIG_WIN);
    };
    FlowWinningState.prototype.gotoBasicState = function () {
        this.module.logic.killRestore();
        this.module.gotoState(FlowModule_1.FlowModule.BASIC_STATE);
    };
    FlowWinningState.prototype.setupBigWinNoIndividualNoSpin = function () {
        this.emit(FlowModuleEvents_1.FlowModuleEvents.WON_BIG_WIN);
        this._queueEvents.addEventToWaitingList(BigWinEvents_1.BigWinEvents.FINISHED, FlowModuleEvents_1.FlowModuleEvents.WON);
    };
    FlowWinningState.prototype.isWin = function () {
        return WinUtils_1.WinUtils.isWin(this.module.logic);
    };
    FlowWinningState.prototype.isSpinWin = function () {
        return WinUtils_1.WinUtils.isSpinWin(this.module.logic);
    };
    FlowWinningState.prototype.isBigWin = function () {
        return WinUtils_1.WinUtils.isBigWin(this.module.logic);
    };
    FlowWinningState.prototype.isBigWinTotalWin = function () {
        return WinUtils_1.WinUtils.isTotalWinBigWin(this.module.logic);
    };
    return FlowWinningState;
}(ModuleState_1.ModuleState));
exports.FlowWinningState = FlowWinningState;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * class handles complex cases of events handling
 */
var QueueEventsHandler = /** @class */ (function () {
    function QueueEventsHandler(eventManager) {
        this._eventsQueue = {};
        this._eventsFunctionsQueue = {};
        this._eventsListBeforeCallback = [];
        this._eventsFlowPairs = [];
        this._eventManager = eventManager;
    }
    QueueEventsHandler.prototype.printData = function () {
        if (false) {
            console.log('_eventsQueue:');
            for (var event_1 in this._eventsQueue) {
                console.log("" + event_1);
            }
            console.log('_eventsFunctionsQueue:');
            for (var event_2 in this._eventsFunctionsQueue) {
                console.log("" + event_2);
            }
            console.log('_eventsListBeforeCallback:');
            for (var _i = 0, _a = this._eventsListBeforeCallback; _i < _a.length; _i++) {
                var event_3 = _a[_i];
                console.log('waitingForEvents:');
                for (var _b = 0, _c = event_3.waitingForEvents; _b < _c.length; _b++) {
                    var eventName = _c[_b];
                    console.log("" + eventName);
                }
            }
            console.log('_eventsFlowPairs:');
            for (var _d = 0, _e = this._eventsFlowPairs; _d < _e.length; _d++) {
                var event_4 = _e[_d];
                console.log("start: " + event_4.start + " end: " + event_4.end);
            }
        }
    };
    /**
     * callback is called when all the events were catched
     * @param events - events list
     * @param callback - callback function
     * @param args - args for callback
     */
    QueueEventsHandler.prototype.addEventsListWithCallback = function (events, callback) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        var _a;
        var eventsListWithCallback = { waitingForEvents: events, callback: callback };
        this._eventsListBeforeCallback.push(eventsListWithCallback);
        for (var _b = 0, events_1 = events; _b < events_1.length; _b++) {
            var event_5 = events_1[_b];
            this._eventManager.on(event_5, (_a = this.reactToListedEvent).bind.apply(_a, [this, event_5, callback, eventsListWithCallback].concat(args)), this);
        }
    };
    /**
     *
     * @param pairs - Array of event pairs with start event to fire and end event to listen for.
     * @param finalEvent - Final
     */
    QueueEventsHandler.prototype.addEventsPairFlow = function (pairs, finalEvent) {
        var _this = this;
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        if (!pairs || pairs.length === 0) {
            throw new Error("Argument: pairs cannot be null or empty.");
        }
        this._eventsFlowPairs = pairs;
        this._eventsFunctionsQueue = {};
        for (var _a = 0, pairs_1 = pairs; _a < pairs_1.length; _a++) {
            var pair = pairs_1[_a];
            this.addFunctionCallingEventToWaitingList(pair.end, function () {
                _this._eventsFlowPairs.splice(0, 1);
                if (_this._eventsFlowPairs.length === 0) {
                    if (typeof finalEvent === 'string') {
                        _this._eventManager.emitDelayed(finalEvent);
                    }
                    else {
                        finalEvent(args);
                    }
                }
                else {
                    _this._eventManager.emitDelayed(_this._eventsFlowPairs[0].start);
                }
            });
        }
        this._eventManager.emitDelayed(this._eventsFlowPairs[0].start);
    };
    /**
     * callback is called on event and it will be removed from the list of events
     * used for events sequencing
     * @param waitingForEvent - event
     * @param callback - callback function
     * @param args - args for callback
     */
    QueueEventsHandler.prototype.addFunctionCallingEventToWaitingList = function (waitingForEvent, callback) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        var _a;
        this._eventsFunctionsQueue[waitingForEvent] = callback;
        this._eventManager.on(waitingForEvent, (_a = this.reactToEventFunctionFromWaitingList).bind.apply(_a, [this, waitingForEvent, callback].concat(args)), this);
    };
    /**
     * fires event on another event and removes reaction from the list of events
     * @param waitingForEvent - event to listen to
     * @param eventToFire - event to fire
     * @param args - looks redundant to me
     */
    QueueEventsHandler.prototype.addEventToWaitingList = function (waitingForEvent, eventToFire) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        var _a;
        this._eventsQueue[waitingForEvent] = eventToFire;
        this._eventManager.on(waitingForEvent, (_a = this.reactToEventFromWaitingList).bind.apply(_a, [this, waitingForEvent, eventToFire].concat(args)), this);
    };
    /**
     * cleans current events list
     */
    QueueEventsHandler.prototype.clearEventsQueue = function () {
        for (var event_6 in this._eventsQueue) {
            if (this._eventsQueue.hasOwnProperty(event_6)) {
                this._eventManager.off(event_6, this);
            }
        }
        this._eventsQueue = {};
        for (var event_7 in this._eventsFunctionsQueue) {
            if (this._eventsFunctionsQueue.hasOwnProperty(event_7)) {
                this._eventManager.off(event_7, this);
            }
        }
        this._eventsFunctionsQueue = {};
    };
    /**
     * reacts to an event
     * @param id - event id
     * @param data - looks redundant
     */
    QueueEventsHandler.prototype.handleWaitingList = function (id, data) {
        if (this._eventsQueue[id]) {
            this.reactToEventFromWaitingList(id, this._eventsQueue[id]);
        }
        if (this._eventsFunctionsQueue[id]) {
            this.reactToEventFunctionFromWaitingList(id, this._eventsFunctionsQueue[id]);
        }
    };
    QueueEventsHandler.prototype.reactToListedEvent = function (waitingForEvent, callback, eventsList) {
        var args = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            args[_i - 3] = arguments[_i];
        }
        var index = eventsList.waitingForEvents.findIndex(function (item) {
            return item === waitingForEvent;
        });
        if (index >= 0) {
            eventsList.waitingForEvents.splice(index, 1);
            this._eventManager.off(waitingForEvent, this);
            if (eventsList.waitingForEvents.length === 0) {
                var eventListIndex = this._eventsListBeforeCallback.findIndex(function (item) {
                    return item.callback === callback;
                });
                if (eventListIndex >= 0) {
                    this._eventsListBeforeCallback.splice(eventListIndex, 1);
                }
                callback.apply(void 0, args);
            }
        }
    };
    QueueEventsHandler.prototype.reactToEventFromWaitingList = function (waitingForEvent, eventToFire) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        var _a;
        this._eventManager.off(waitingForEvent, this);
        (_a = this._eventManager).emit.apply(_a, [eventToFire].concat(args));
    };
    QueueEventsHandler.prototype.reactToEventFunctionFromWaitingList = function (waitingForEvent, callback) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        this._eventManager.off(waitingForEvent, this);
        callback.apply(void 0, args);
    };
    return QueueEventsHandler;
}());
exports.QueueEventsHandler = QueueEventsHandler;


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var IndividualSymbolReelsEvents = /** @class */ (function () {
    function IndividualSymbolReelsEvents() {
    }
    IndividualSymbolReelsEvents.SPINNING_STARTED = 'IndividualSymbolReelsEvents::SPINNING_STARTED';
    IndividualSymbolReelsEvents.SYMBOL_STOPPED = 'IndividualSymbolReelsEvents::SYMBOL_STOPPED';
    IndividualSymbolReelsEvents.ALL_SYMBOLS_STOPPED = 'IndividualSymbolReelsEvents::ALL_SYMBOLS_STOPPED';
    IndividualSymbolReelsEvents.ALL_SYMBOLS_ANIMATIONS_FINISHED = 'IndividualSymbolReelsEvents::ALL_SYMBOLS_ANIMATIONS_FINISHED';
    IndividualSymbolReelsEvents.INDIVIDUAL_RESPIN_FINISHED = 'IndividualSymbolReelsEvents::INDIVIDUAL_RESPIN_FINISHED';
    IndividualSymbolReelsEvents.INDIVIDUAL_RESPIN_STARTED = 'IndividualSymbolReelsEvents::INDIVIDUAL_RESPIN_STARTED';
    return IndividualSymbolReelsEvents;
}());
exports.IndividualSymbolReelsEvents = IndividualSymbolReelsEvents;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var WinUtils_1 = __webpack_require__(58);
var GameWinUtils = /** @class */ (function () {
    function GameWinUtils() {
    }
    GameWinUtils.isBigWinNoMultiplier = function (logic) {
        return logic.getLastAvalancheRunningTotal() >= logic.getTotalBet() * WinUtils_1.WinUtils.BIG_WIN_THRESHOLD;
    };
    GameWinUtils.isBigWinWithMultiplier = function (logic) {
        return logic.currentSpinWin >= logic.getTotalBet() * WinUtils_1.WinUtils.BIG_WIN_THRESHOLD;
    };
    return GameWinUtils;
}());
exports.GameWinUtils = GameWinUtils;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var InfoEvents = /** @class */ (function () {
    function InfoEvents() {
    }
    InfoEvents.WIN_UPDATED = 'InfoEvents::WIN_UPDATED';
    InfoEvents.BET_UPDATED = 'InfoEvents::BET_UPDATED';
    InfoEvents.BALANCE_UPDATED = 'InfoEvents::BALANCE_UPDATED';
    InfoEvents.UPDATE = 'InfoEvents::UPDATE';
    InfoEvents.TOGGLE_ALL_SOUND_OFF = 'InfoEvents::TOGGLE_ALL_SOUND_OFF';
    InfoEvents.TOGGLE_ALL_SOUND_ON = 'InfoEvents::TOGGLE_ALL_SOUND_ON';
    return InfoEvents;
}());
exports.InfoEvents = InfoEvents;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Easing_1 = __webpack_require__(16);
var Timer_1 = __webpack_require__(28);
var View_1 = __webpack_require__(3);
var WinMeter_1 = __webpack_require__(113);
var WinNumbers_1 = __webpack_require__(45);
var BigWinView = /** @class */ (function (_super) {
    __extends(BigWinView, _super);
    function BigWinView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._levelTextSprites = [];
        _this._backgroundContainer = new PIXI.Container();
        _this._middleContainer = new PIXI.Container();
        _this._foregroundContainer = new PIXI.Container();
        _this._effectAnimation = [];
        _this._isPlayingEndingEnd = false;
        return _this;
    }
    BigWinView.prototype.init = function () {
        _super.prototype.init.call(this);
        this.initializeLayers();
        this.addInput();
        this.setupWinNumber();
        this.setupCurrencyFormatter();
        this.setupLevelSprites();
        this.hide();
    };
    BigWinView.prototype.killAllAnimations = function () {
        this.killBackgroundAnimation();
        this.killCurrentAnimation();
        this.killEffectsAnimations();
    };
    BigWinView.prototype.killAllTimers = function () {
        if (this._transitionTimer) {
            this._transitionTimer.stop();
            this._transitionTimer = null;
        }
        if (this._finishingTimer) {
            this._finishingTimer.stop();
            this._finishingTimer = null;
        }
    };
    BigWinView.prototype.start = function (winValue, bigWinLevel) {
        this.killAllAnimations();
        this._currentWin = winValue;
        this._bigWinLevel = bigWinLevel;
        this._currentLevel = 1;
        this._isPlayingEndingEnd = false;
        this.playBigWinInitialSounds();
        this.show();
        this.initMeter(winValue);
        this.startInitialAnimations();
        this.showNumber('0');
        this.startCounting();
        this.addMeterInto();
        this.addCurrentText();
        // this.soundPlayer.playMusic('musicBigWin');
    };
    BigWinView.prototype.skipCounting = function () {
        this.soundPlayer.stop('bigWinCounting');
        this.soundPlayer.play('bigWinCountingEnd');
        this._meter.snapToFinalValue();
        this.onMeterFinished();
    };
    BigWinView.prototype.playBigWinEnd = function () {
        // this.soundPlayer.duckMusic();
        this.soundPlayer.play('bigWinMusicOutro');
        if (this._transitionTimer) {
            this._transitionTimer.stop();
        }
        this._currentLevel = this._bigWinLevel;
        this.playEndingEndAnimation();
        this.addCurrentText();
        this.addMeterInto();
    };
    BigWinView.prototype.playEndingEndAnimation = function () {
        var _this = this;
        if (this._finishingTimer) {
            this.updateManager.remove(this._finishingTimer);
            this._finishingTimer.stop();
            this._finishingTimer = null;
        }
        this.killCurrentAnimation();
        this.killBackgroundAnimation();
        this.killEffectsAnimations();
        this._backgroundAnimation = this.spineUtils
            .startSpineAnimationCreation('BIG_WINS_GLOW.json', "EXIT" + this.getCurrentLevelAnimationPostfix(), false)
            .position(this.bigWinScreenPosition.x, this.bigWinScreenPosition.y)
            .onComplete(function () {
            _this.killBackgroundAnimation();
            _this.emit(BigWinView.END_ANIMATION_FINISHED);
            _this.soundPlayer.stop('bigWinCounting');
        })
            .container(this._backgroundContainer)
            .createAndStart();
        this._currentAnimation = this.spineUtils
            .startSpineAnimationCreation('BIG_WINS.json', "EXIT" + this.getCurrentLevelAnimationPostfix(), false)
            .position(this.bigWinScreenPosition.x, this.bigWinScreenPosition.y)
            .container(this._foregroundContainer)
            .onComplete(function () {
            _this.killCurrentAnimation();
        })
            .createAndStart();
        var currentEffectIndex = 1;
        var hasMoreEffects = this.resources.hasSpine("BIG_WINS_EFFECT_0" + currentEffectIndex + ".json");
        while (hasMoreEffects) {
            var effect = this.spineUtils
                .startSpineAnimationCreation("BIG_WINS_EFFECT_0" + currentEffectIndex + ".json", "EXIT" + this.getCurrentLevelAnimationPostfix(), false)
                .position(this.bigWinScreenPosition.x, this.bigWinScreenPosition.y)
                .container(this.getEffectContainer(currentEffectIndex))
                .onComplete(function () {
                _this.killEffectsAnimations();
            })
                .createAndStart();
            this._effectAnimation.push(effect);
            currentEffectIndex++;
            hasMoreEffects = this.resources.hasSpine("BIG_WINS_EFFECT_0" + currentEffectIndex + ".json");
        }
        this._isPlayingEndingEnd = true;
    };
    BigWinView.prototype.playBigWinInitialSounds = function () {
        this.soundPlayer.play('bigWin');
        this.soundPlayer.fadeCurrentMusicTo('bigWinMusic');
    };
    BigWinView.prototype.getFontSize = function (isMobile) {
        return isMobile ? BigWinView.FONT_NAME_MOBILE : BigWinView.FONT_NAME_DESKTOP;
    };
    BigWinView.prototype.setupWinNumber = function () {
        var winNumberFont = this.getFontSize(this.device.isMobile);
        this._winNumber = new WinNumbers_1.WinNumbers(this.resources, winNumberFont);
        this._winNumber.currencyISO = this.currencyFormatter.currency;
        this._winNumber.currencySign = this.currencyFormatter.currencySign;
        this.container.addChild(this._winNumber);
    };
    BigWinView.prototype.addInput = function () {
        var _this = this;
        this.container.on('click', function () {
            if (!_this._isPlayingEndingEnd) {
                _this.emit(BigWinView.SKIP_CLICKED);
            }
        });
        this.container.on('touchend', function () {
            if (!_this._isPlayingEndingEnd) {
                _this.emit(BigWinView.SKIP_CLICKED);
            }
        });
        this.container.interactive = true;
    };
    BigWinView.prototype.setupLevelSprites = function () {
        for (var _i = 0, _a = BigWinView.LEVEL_TEXTS; _i < _a.length; _i++) {
            var levelSprName = _a[_i];
            var container = new PIXI.Sprite();
            var sprite = new PIXI.Sprite(this.resources.getLocaleTextImage("" + levelSprName));
            sprite.anchor.set(0.5, 0.5);
            container.addChild(sprite);
            this._levelTextSprites.push(container);
        }
    };
    BigWinView.prototype.initializeLayers = function () {
        this.container.addChild(this._backgroundContainer);
        this.container.addChild(this._middleContainer);
        this.container.addChild(this._foregroundContainer);
    };
    BigWinView.prototype.startInitialAnimations = function () {
        var _this = this;
        this._backgroundAnimation = this.spineUtils
            .startSpineAnimationCreation('BIG_WINS_GLOW.json', 'START', false)
            .position(this.bigWinScreenPosition.x, this.bigWinScreenPosition.y)
            .chainIdleAnimation("IDLE" + this.getCurrentLevelAnimationPostfix())
            .container(this._backgroundContainer)
            .createAndStart();
        this._currentAnimation = this.spineUtils
            .startSpineAnimationCreation('BIG_WINS.json', 'START', false)
            .position(this.bigWinScreenPosition.x, this.bigWinScreenPosition.y)
            .chainIdleAnimation("IDLE" + this.getCurrentLevelAnimationPostfix())
            .container(this._foregroundContainer)
            .onComplete(function () {
            _this.playBigWinLoop();
            _this.emit(BigWinView.BIG_WIN_STARTED);
        })
            .createAndStart();
        var currentEffectIndex = 1;
        var hasMoreEffects = this.resources.hasSpine("BIG_WINS_EFFECT_0" + currentEffectIndex + ".json");
        while (hasMoreEffects) {
            var effect = this.spineUtils
                .startSpineAnimationCreation("BIG_WINS_EFFECT_0" + currentEffectIndex + ".json", 'START', false)
                .position(this.bigWinScreenPosition.x, this.bigWinScreenPosition.y)
                .chainIdleAnimation("IDLE" + this.getCurrentLevelAnimationPostfix())
                .container(this.getEffectContainer(currentEffectIndex))
                .createAndStart();
            this._effectAnimation.push(effect);
            currentEffectIndex++;
            hasMoreEffects = this.resources.hasSpine("BIG_WINS_EFFECT_0" + currentEffectIndex + ".json");
        }
    };
    BigWinView.prototype.getEffectContainer = function (effectIndex) {
        return this._foregroundContainer;
    };
    BigWinView.prototype.setupCurrencyFormatter = function () {
        this._winNumber.currencyISO = this.currencyFormatter.currency;
        this._winNumber.currencySign = this.currencyFormatter.currencySign;
    };
    BigWinView.prototype.showNumber = function (newNumber) {
        newNumber = this.currencyFormatter.formatCurrency(newNumber, true);
        this._winNumber.showNumber(newNumber);
    };
    BigWinView.prototype.addMeterInto = function () {
        var container = this.spineUtils.findSlotContainerByName(this._currentAnimation.container, 'WIN_NUMBER');
        this._winNumber.rotation = Math.PI;
        this._winNumber.skew.y = Math.PI;
        this._winNumber.anchor.set(0.5, 0.5);
        this._winNumber.numberAnchor = { x: 0.0, y: 0.5 };
        container.removeChildren();
        container.addChild(this._winNumber);
    };
    BigWinView.prototype.initMeter = function (toValue) {
        this._meter = new WinMeter_1.WinMeter(this._winNumber, Easing_1.Easing.Cubic.Out, this.currencyFormatter, true);
        // this._meter.setTextAdditionalOffsets(0, -25);
        this._meter.onCompleteCallback = this.onMeterFinished.bind(this);
        this._meter.from(0).to(toValue, this.getCountingTime());
        this._meter.resolutionWidth = this.resolutionManager.resolution.width;
    };
    BigWinView.prototype.getCountingTime = function () {
        var totalCountingTime = this._bigWinLevel * 4000 + 3000;
        if (totalCountingTime > 21000) {
            return 21000;
        }
        return totalCountingTime;
    };
    BigWinView.prototype.startCounting = function () {
        this._meter.start();
        this.soundPlayer.play('bigWinCounting', true);
        this.updateManager.add(this._meter);
    };
    BigWinView.prototype.onMeterFinished = function () {
        this.soundPlayer.stop('bigWinCounting');
        this.soundPlayer.play('bigWinCountingEnd');
        this.emit(BigWinView.METER_FINISHED);
        this.emit(BigWinView.EXPLOSION_STARTED);
        this.startFinishingTimer();
    };
    BigWinView.prototype.startFinishingTimer = function () {
        var _this = this;
        this._finishingTimer = new Timer_1.Timer(function () {
            if (!_this._isPlayingEndingEnd) {
                _this.playEndingEndAnimation();
            }
        }, BigWinView.FINISHING_TIMER_VALUE, true);
        this.updateManager.add(this._finishingTimer);
    };
    BigWinView.prototype.playBigWinLoop = function () {
        var _this = this;
        this.addMeterInto();
        if (this._currentLevel < this._bigWinLevel) {
            this._transitionTimer = new Timer_1.Timer(function () {
                _this.playTransitionToNextLevel();
                _this.emit(BigWinView.TRANSITION_STARTED);
            }, this.getTimerValueUntilNextLevel(), true);
            this.updateManager.add(this._transitionTimer);
        }
    };
    BigWinView.prototype.getTimerValueUntilNextLevel = function () {
        return 4000 - (75 / 60) * 1000;
    };
    BigWinView.prototype.getCurrentLevelAnimationPostfix = function () {
        return this.getLevelPostfix(this._currentLevel);
    };
    BigWinView.prototype.getNextLevelAnimationPostfix = function () {
        return this.getLevelPostfix(this._currentLevel + 1);
    };
    BigWinView.prototype.getLevelPostfix = function (level) {
        switch (level) {
            case 1:
                return '_BIG';
            case 2:
                return '_SUPER';
            case 3:
                return '_MEGA';
            case 4:
                return '_EPIC';
            default:
                return '_EPIC';
        }
    };
    BigWinView.prototype.playTransitionToNextLevel = function () {
        var _this = this;
        this.soundPlayer.play('bigWinCountupTreshold');
        this.killCurrentAnimation();
        this.killBackgroundAnimation();
        this.killEffectsAnimations();
        this._backgroundAnimation = this.spineUtils
            .startSpineAnimationCreation('BIG_WINS_GLOW.json', "TRANSITION" + this.getCurrentLevelAnimationPostfix(), false)
            .position(this.bigWinScreenPosition.x, this.bigWinScreenPosition.y)
            .chainIdleAnimation("IDLE" + this.getNextLevelAnimationPostfix())
            .container(this._backgroundContainer)
            .createAndStart();
        this._currentAnimation = this.spineUtils
            .startSpineAnimationCreation('BIG_WINS.json', "TRANSITION" + this.getCurrentLevelAnimationPostfix(), false)
            .position(this.bigWinScreenPosition.x, this.bigWinScreenPosition.y)
            .chainIdleAnimation("IDLE" + this.getNextLevelAnimationPostfix())
            .container(this._foregroundContainer)
            .onComplete(function () {
            _this.playBigWinLoop();
        })
            .createAndStart();
        var currentEffectIndex = 1;
        var hasMoreEffects = this.resources.hasSpine("BIG_WINS_EFFECT_0" + currentEffectIndex + ".json");
        while (hasMoreEffects) {
            var effect = this.spineUtils
                .startSpineAnimationCreation("BIG_WINS_EFFECT_0" + currentEffectIndex + ".json", "TRANSITION" + this.getCurrentLevelAnimationPostfix(), false)
                .position(this.bigWinScreenPosition.x, this.bigWinScreenPosition.y)
                .container(this.getEffectContainer(currentEffectIndex))
                .chainIdleAnimation("IDLE" + this.getNextLevelAnimationPostfix())
                .createAndStart();
            this._effectAnimation.push(effect);
            currentEffectIndex++;
            hasMoreEffects = this.resources.hasSpine("BIG_WINS_EFFECT_0" + currentEffectIndex + ".json");
        }
        this.soundPlayer.play('bigWinTransition');
        this.addMeterInto();
        this.addCurrentText();
        this.addTransitionText();
        this.playCurrentLevelVoice();
        this._currentLevel++;
    };
    BigWinView.prototype.playCurrentLevelVoice = function () { };
    BigWinView.prototype.addTransitionText = function () {
        this.spineUtils.replaceElementInSpineAnimation(this._currentAnimation, this.getLevelTextSlotName(this._currentLevel + 1), this._levelTextSprites[this._currentLevel]);
    };
    BigWinView.prototype.addCurrentText = function () {
        this.spineUtils.replaceElementInSpineAnimation(this._currentAnimation, this.getLevelTextSlotName(this._currentLevel), this._levelTextSprites[this._currentLevel - 1]);
    };
    BigWinView.prototype.getLevelTextSlotName = function (level) {
        switch (level) {
            case 1:
                return 'BIG_WIN_TEXT';
            case 2:
                return 'SUPER_WIN_TEXT';
            case 3:
                return 'MEGA_WIN_TEXT';
            case 4:
                return 'EPIC_WIN_TEXT';
            default:
                throw new Error("BigWinView::getLevelTextSlotName impossible level - " + level);
        }
    };
    BigWinView.prototype.killCurrentAnimation = function () {
        if (this._currentAnimation) {
            this.spineUtils.stopAndDestroyAnimation(this._currentAnimation);
            this._currentAnimation = null;
        }
    };
    BigWinView.prototype.killBackgroundAnimation = function () {
        if (this._backgroundAnimation) {
            this.spineUtils.stopAndDestroyAnimation(this._backgroundAnimation);
            this._backgroundAnimation = null;
        }
    };
    BigWinView.prototype.killEffectsAnimations = function () {
        for (var _i = 0, _a = this._effectAnimation; _i < _a.length; _i++) {
            var anim = _a[_i];
            this.spineUtils.stopAndDestroyAnimation(anim);
        }
        this._effectAnimation = [];
    };
    Object.defineProperty(BigWinView.prototype, "bigWinScreenPosition", {
        get: function () {
            return { x: this.resolutionManager.halfResolution.width, y: this.resolutionManager.halfResolution.height };
        },
        enumerable: true,
        configurable: true
    });
    BigWinView.FINISHING_TIMER_VALUE = 3000;
    BigWinView.METER_FINISHED = 'METER_FINISHED';
    BigWinView.END_ANIMATION_FINISHED = 'END_ANIMATION_FINISHED';
    BigWinView.SKIP_CLICKED = 'SKIP_CLICKED';
    BigWinView.EXPLOSION_STARTED = 'EXPLOSION_START';
    BigWinView.BIG_WIN_STARTED = 'BIG_WIN_START';
    BigWinView.TRANSITION_STARTED = 'TRANSITION_START';
    BigWinView.TRANSITION_ENDED = 'TRANSITION_END';
    BigWinView.LEVEL_TEXTS = ['BIG_WIN_TEXT.png', 'SUPER_WIN_TEXT.png', 'MEGA_WIN_TEXT.png', 'EPIC_WIN_TEXT.png'];
    BigWinView.FONT_NAME_MOBILE = 'MED_';
    BigWinView.FONT_NAME_DESKTOP = 'LARGE_';
    return BigWinView;
}(View_1.View));
exports.BigWinView = BigWinView;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var View_1 = __webpack_require__(3);
var WinNumbers_1 = __webpack_require__(45);
var FreeSpinsView = /** @class */ (function (_super) {
    __extends(FreeSpinsView, _super);
    function FreeSpinsView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._currentFeature = 1;
        return _this;
    }
    ////////////////////////////////////////////////////////////////////
    // free spins retrigger
    FreeSpinsView.prototype.showAddedFreespins = function (addedFreeSpins) {
        var _this = this;
        var additionalFreespins = this.spineUtils
            .startSpineAnimationCreation('FREESPIN_ADDITIONAL_FREESPINS.json', 'ENTER', false)
            .onComplete(function () {
            _this.emit(FreeSpinsView.RETRIGGER_FINISHED);
        })
            .position(this.resolutionManager.halfResolution.width, this.resolutionManager.halfResolution.height)
            .createAndStart();
        this.spineUtils.replaceElementInSpineAnimation(additionalFreespins, 'TEXT', new PIXI.Sprite(this.resources.getLocaleTextImage('EXTRA_FREE_SPINS.png')));
        this.emit(FreeSpinsView.RETRIGGER_STARTED);
    };
    FreeSpinsView.prototype.startFreeSpinsIntro = function () {
        var _this = this;
        this._currentFeature = 1;
        this.killCurrentAnimation();
        this._currentIntroScreen = this.spineUtils
            .startSpineAnimationCreation('FREESPIN_STARTSCREEN.json', 'START', false)
            .chainIdleAnimation('IDLE')
            .onComplete(function () {
            _this.addInfo();
        })
            .createAndStart();
        this.replacePlayButtonWithLocalized();
    };
    FreeSpinsView.prototype.startFreeSpinsRestoredIntro = function () {
        this.killCurrentAnimation();
        this._currentIntroScreen = this.spineUtils
            .startSpineAnimationCreation('FREESPIN_STARTSCREEN.json', 'IDLE', true)
            .container(this.container)
            .createAndStart();
        this.replacePlayButtonWithLocalized();
        this.addInfo();
    };
    FreeSpinsView.prototype.replacePlayButtonWithLocalized = function () {
        this._playButton = this.spineUtils.createLocalizedSpineButton('PLAY_BUTTON.json', this.onStartButtonClicked.bind(this), ['PLAY_BUTTON.png', 'PLAY_BUTTON_CLICKED.png', 'PLAY_BUTTON_HOVER.png', 'PLAY_BUTTON_DISABLED.png'], ['BUTTON', 'PLAY_BUTTON_CLICKED', 'PLAY_BUTTON_HOVER', 'PLAY_BUTTON_DISABLED'], true, false, false, false);
        this.spineUtils.replaceElementInSpineAnimation(this._currentIntroScreen, 'PLAY_BUTTON', this._playButton);
        this._playButton.disable();
    };
    FreeSpinsView.prototype.setFreeSpinsAmount = function (amount) {
        this._freeSpins = amount;
    };
    FreeSpinsView.prototype.gotoPreviousFeature = function () {
        if (this._prevFeatureButton) {
            this.onLeftButtonClicked();
        }
    };
    FreeSpinsView.prototype.gotoNextFeature = function () {
        if (this._nextFeatureButton) {
            this.onRightButtonClicked();
        }
    };
    FreeSpinsView.prototype.proceed = function () {
        if (this._playButton && this._playButton.interactive) {
            this.onStartButtonClicked();
        }
    };
    FreeSpinsView.prototype.proceedToFreeSpins = function () {
        this.emit(FreeSpinsView.FREE_SPINS_INTRO_TRANSITION_FINISHED);
    };
    FreeSpinsView.prototype.startFreeSpinsOutro = function (totalWin) {
        this.emit(FreeSpinsView.FREE_SPINS_OUTRO_STARTED);
    };
    FreeSpinsView.prototype.getLocaleTextImage = function (name) {
        return new PIXI.Sprite(this.resources.getLocaleTextImage(name + ".png"));
    };
    FreeSpinsView.prototype.showWinSummaryScreen = function (totalWin, maximumSizeInPixels) {
        var _this = this;
        this.killWinSummaryScreen();
        if (totalWin === 0) {
            this._winSummaryScreenAnimation = this.spineUtils
                .startSpineAnimationCreation('FREESPIN_COMPLETE_SCREEN.json', 'START', false)
                .chainIdleAnimation('IDLE')
                .onComplete(function () {
                _this.emit(FreeSpinsView.SHOWING_WIN_SUMMARY_SCREEN);
            })
                .position(this.resolutionManager.halfResolution.width, this.resolutionManager.halfResolution.height)
                .container(this.container)
                .createAndStart();
            var textImage = this.getLocaleTextImage('FREESPIN_COMPLETE');
            this.spineUtils.replaceElementInSpineAnimation(this._winSummaryScreenAnimation, 'TEXT', textImage);
            this.adjustWinScreenLocalizedScale(textImage, true);
        }
        else {
            this._winSummaryScreenAnimation = this.spineUtils
                .startSpineAnimationCreation('WIN_SCREEN.json', 'START', false)
                .chainIdleAnimation('IDLE')
                .onComplete(function () {
                _this.emit(FreeSpinsView.SHOWING_WIN_SUMMARY_SCREEN);
                _this.fitElementIntoScreen(winAmount_1);
            })
                .position(this.resolutionManager.halfResolution.width, this.resolutionManager.halfResolution.height)
                .container(this.container)
                .createAndStart();
            var textImage = this.getLocaleTextImage('WIN_SCREEN');
            this.spineUtils.replaceElementInSpineAnimation(this._winSummaryScreenAnimation, 'TEXT', textImage);
            this.adjustWinScreenLocalizedScale(textImage, false);
            var winAmount_1 = new WinNumbers_1.WinNumbers(this.resources, this.getWinnumberSize(this.device.isMobile));
            winAmount_1.currencyISO = this.currencyFormatter.currency;
            winAmount_1.currencySign = this.currencyFormatter.currencySign;
            winAmount_1.numberAnchor.y = 0.5;
            winAmount_1.numberKerning = -10;
            winAmount_1.showNumber(this.currencyFormatter.formatCurrencyApi(totalWin));
            this.spineUtils.replaceElementInSpineAnimation(this._winSummaryScreenAnimation, 'NUMBER', winAmount_1);
            this.fitElementIntoScreen(winAmount_1);
        }
        this._exitButton = this.spineUtils.createSpineButton('FREESPIN_BUTTON.json', this.onExitWinSummaryButtonClicked.bind(this), true, false, false, false);
        var playPosition = this.spineUtils.getBoneAbsolutePosition(this.resources.getSpine('FREESPIN_STARTSCREEN.json'), 'PLAY_BUTTON');
        playPosition.y *= -1;
        this.container.addChild(this._exitButton);
        this._exitButton.position.set(playPosition.x, playPosition.y);
        this.soundPlayer.play('freeSpinsExit');
    };
    FreeSpinsView.prototype.adjustWinScreenLocalizedScale = function (textImage, isNoWin) { };
    FreeSpinsView.prototype.getWinnumberSize = function (isMobile) {
        return isMobile ? FreeSpinsView.FONT_NAME_MOBILE : FreeSpinsView.FONT_NAME_DESKTOP;
    };
    Object.defineProperty(FreeSpinsView.prototype, "numberElementLimit", {
        get: function () {
            return this.resolutionManager.resolution.width * 0.8;
        },
        enumerable: true,
        configurable: true
    });
    FreeSpinsView.prototype.fitElementIntoScreen = function (element) {
        element.scale.set(1, -1);
        var currentWidth = element.getBounds().width;
        if (currentWidth > this.numberElementLimit) {
            var currentScale = element.scale;
            var scaleFactor = this.numberElementLimit / currentWidth;
            var xScale = currentScale.x * scaleFactor;
            var yScale = -1 * Math.abs(currentScale.y) * scaleFactor;
            element.scale.set(xScale, yScale);
        }
    };
    FreeSpinsView.prototype.killCurrentAnimation = function () {
        if (this._currentIntroScreen) {
            this.spineUtils.stopAndDestroyAnimation(this._currentIntroScreen);
            this._currentIntroScreen = null;
        }
    };
    FreeSpinsView.prototype.enablePlayButton = function () {
        this._playButton.enable();
    };
    FreeSpinsView.prototype.addInfo = function () {
        var _this = this;
        this._currentFeatureAnimation = this.spineUtils
            .startSpineAnimationCreation('FREESPIN_FEATURE_SCREENS.json', 'FEATURE_1_ENTRY', false)
            .container(this.container)
            .position(this.resolutionManager.halfResolution.width, this.resolutionManager.halfResolution.height)
            .onComplete(function () {
            _this.emit(FreeSpinsView.FREE_SPINS_INTRO_FINISHED);
            _this.setupActiveInfoElements();
        })
            .createMultitrack();
        this.replaceInfoElementComponents();
    };
    FreeSpinsView.prototype.setupActiveInfoElements = function () {
        this.setupInput();
        this.spineUtils.stopAndDestroyAnimation(this._currentFeatureAnimation);
        this._currentFeatureAnimation = this.spineUtils
            .startSpineAnimationCreation('FREESPIN_FEATURE_SCREENS.json', 'FEATURE_1_IDLE', false)
            .container(this.container)
            .position(this.resolutionManager.halfResolution.width, this.resolutionManager.halfResolution.height)
            .createMultitrack();
        this.playIdleAnimation();
        this.setupTextStyle();
        this.replaceInfoElementComponents();
    };
    FreeSpinsView.prototype.adjustTitleScale = function (currentPage, currentTitle, title) {
        // E.g if currentPage === 1 and currentTitle = 4 and device is mobile. Set scale to 0.5.
    };
    FreeSpinsView.prototype.replaceInfoElementComponents = function () {
        var hasMorePages = true;
        var currentPage = 1;
        while (hasMorePages) {
            hasMorePages = !!this.spineUtils.findSlotContainerByName(this._currentFeatureAnimation.container, "FREE_SPINS_FEATURE_" + currentPage + "_1_TITLE");
            if (hasMorePages) {
                var hasMoreTitles = true;
                var currentTitle = 1;
                while (hasMoreTitles) {
                    hasMoreTitles = !!this.spineUtils.findSlotContainerByName(this._currentFeatureAnimation.container, "FREE_SPINS_FEATURE_" + currentPage + "_" + currentTitle + "_TITLE");
                    if (hasMoreTitles) {
                        var title = new PIXI.Sprite(this.resources.getLocaleTextImage("FREE_SPINS_FEATURE_" + currentPage + "_" + currentTitle + "_TITLE.png"));
                        this.spineUtils.replaceElementInSpineMultiTrack(this._currentFeatureAnimation, "FREE_SPINS_FEATURE_" + currentPage + "_" + currentTitle + "_TITLE", title);
                        this.adjustTitleScale(currentPage, currentTitle, title);
                    }
                    currentTitle++;
                }
            }
            currentPage++;
        }
        this._totalFeatures = currentPage - 2;
        for (var i = 1; i <= currentPage; i++) {
            var hasTextContainer = !!this.spineUtils.findSlotContainerByName(this._currentFeatureAnimation.container, "FEATURE_" + i + "_TEXT");
            if (hasTextContainer) {
                this.spineUtils.replaceElementInSpineMultiTrack(this._currentFeatureAnimation, "FEATURE_" + i + "_TEXT", this.createTranslatedTextObject(this.translator.getObject('BaseStrings', 'StartScreen', "page" + i, 'text')));
            }
        }
    };
    FreeSpinsView.prototype.createTranslatedTextObject = function (text) {
        var textObject = new PIXI.Text(text, this._featureTextStyle);
        return textObject;
    };
    FreeSpinsView.prototype.setupTextStyle = function () {
        var featureBackgroundReference = this.spineUtils.getSlotAttachmentDimensions(this.spineUtils.getSkeletonDataFromSpineAnimationMultiTrack(this._currentFeatureAnimation), 'TEXT_AREA');
        var descriptionWordWrapWidth = featureBackgroundReference.width * featureBackgroundReference.scale.x;
        this._featureTextStyle = this.textStyles.featureTextStyle;
        this._featureTextStyle.wordWrapWidth = descriptionWordWrapWidth;
    };
    FreeSpinsView.prototype.translateIncreasingMultiplierScreen = function () {
        var text = this.translator.getObject('BaseStrings', 'Freespin_StartScreen', 'page1', 'text');
        var paragraph = new PIXI.Text(text, this.textStyles.featureTextStyle);
        return paragraph;
    };
    FreeSpinsView.prototype.setupInput = function () {
        this._prevFeatureButton = this.spineUtils.createSpineButton('ARROW_BUTTON.json', this.onLeftButtonClicked.bind(this), true, false, false, false);
        this.spineUtils.replaceElementInSpineAnimation(this._currentIntroScreen, 'ARROW_LEFT', this._prevFeatureButton);
        this._nextFeatureButton = this.spineUtils.createSpineButton('ARROW_BUTTON.json', this.onRightButtonClicked.bind(this), true, false, false, false);
        this.spineUtils.replaceElementInSpineAnimation(this._currentIntroScreen, 'ARROW_RIGHT', this._nextFeatureButton);
        if (this.device.isMobile) {
            this._nextFeatureButton.setOnClickIsOverState(false);
            this._prevFeatureButton.setOnClickIsOverState(false);
        }
        this._playButton = this.spineUtils.createLocalizedSpineButton('PLAY_BUTTON.json', this.onStartButtonClicked.bind(this), ['PLAY_BUTTON.png', 'PLAY_BUTTON_CLICKED.png', 'PLAY_BUTTON_HOVER.png', 'PLAY_BUTTON_DISABLED.png'], ['BUTTON', 'PLAY_BUTTON_CLICKED', 'PLAY_BUTTON_HOVER', 'PLAY_BUTTON_DISABLED'], true, false, false, false);
        this.spineUtils.replaceElementInSpineAnimation(this._currentIntroScreen, 'PLAY_BUTTON', this._playButton);
        // this._playButton.disable();
    };
    FreeSpinsView.prototype.playIdleAnimation = function () {
        this._currentFeatureAnimation.play("FEATURE_" + this._currentFeature + "_IDLE", 0, true);
    };
    FreeSpinsView.prototype.onLeftButtonClicked = function () {
        if (this._prevFeatureButton.interactive) {
            this.soundPlayer.play('buttonClick');
            this._currentFeature--;
            if (this._currentFeature <= 0) {
                this._currentFeature = this._totalFeatures;
            }
            this._currentFeatureAnimation.play("FEATURE_" + this._currentFeature + "_ENTER_LEFT", 0, false);
            this._currentFeatureAnimation.setOnceOnComplete(this.playIdleAnimation.bind(this));
        }
    };
    FreeSpinsView.prototype.onRightButtonClicked = function () {
        if (this._prevFeatureButton.interactive) {
            this.soundPlayer.play('buttonClick');
            this._currentFeature++;
            if (this._currentFeature > this._totalFeatures) {
                this._currentFeature = 1;
            }
            this._currentFeatureAnimation.play("FEATURE_" + this._currentFeature + "_ENTER_RIGHT", 0, false);
            this._currentFeatureAnimation.setOnceOnComplete(this.playIdleAnimation.bind(this));
        }
    };
    FreeSpinsView.prototype.onStartButtonClicked = function () {
        this._playButton.disable();
        this.soundPlayer.play('buttonClick');
        if (this._nextFeatureButton) {
            this._nextFeatureButton.disable();
        }
        if (this._prevFeatureButton) {
            this._prevFeatureButton.disable();
        }
        this.emit(FreeSpinsView.FREE_SPINS_INFO_CONTINUE_CLICKED);
    };
    FreeSpinsView.prototype.endFreeSpinsIntro = function () {
        var _this = this;
        this.killCurrentFeatureAnimation();
        this._currentIntroScreen.changeAnimationTo('EXIT', false);
        this._currentIntroScreen.setOnComplete(function () {
            _this.cleanupIntro();
            _this.proceedToFreeSpins();
        });
    };
    FreeSpinsView.prototype.killCurrentFeatureAnimation = function () {
        this.spineUtils.stopAndDestroyAnimation(this._currentFeatureAnimation);
        this._currentFeatureAnimation = null;
    };
    FreeSpinsView.prototype.cleanupIntro = function () {
        this.spineUtils.stopAndDestroyAnimation(this._currentIntroScreen);
    };
    FreeSpinsView.prototype.onExitWinSummaryButtonClicked = function () {
        var _this = this;
        this.emit(FreeSpinsView.FREE_SPINS_OUTRO_CONTINUE_CLICKED);
        this._exitButton.destroy();
        this._winSummaryScreenAnimation.changeAnimationTo('EXIT', false);
        this._winSummaryScreenAnimation.setOnComplete(function () {
            _this.killWinSummaryScreen();
            _this.emit(FreeSpinsView.FREE_SPINS_OUTRO_FINISHED);
        });
    };
    FreeSpinsView.prototype.killWinSummaryScreen = function () {
        this.spineUtils.stopAndDestroyAnimation(this._winSummaryScreenAnimation);
        this._winSummaryScreenAnimation = null;
    };
    FreeSpinsView.FREE_SPINS_INTRO_FINISHED = 'FreeSpinsView::FREE_SPINS_INTRO_FINISHED';
    FreeSpinsView.FREE_SPINS_INFO_CONTINUE_CLICKED = 'FreeSpinsView::FREE_SPINS_INFO_CONTINUE_CLICKED';
    FreeSpinsView.FREE_SPINS_INTRO_TRANSITION_FINISHED = 'FreeSpinsView::FREE_SPINS_INTRO_TRANSITION_FINISHED';
    FreeSpinsView.FREE_SPINS_OUTRO_STARTED = 'FreeSpinsView::FREE_SPINS_OUTRO_STARTED';
    FreeSpinsView.FREE_SPINS_OUTRO_CONTINUE_CLICKED = 'FreeSpinsView::FREE_SPINS_OUTRO_CONTINUE_CLICKED';
    FreeSpinsView.FREE_SPINS_OUTRO_FINISHED = 'FreeSpinsView::FREE_SPINS_OUTRO_FINISHED';
    FreeSpinsView.SHOWING_WIN_SUMMARY_SCREEN = 'FreeSpinsView::SHOWING_WIN_SUMMARY_SCREEN';
    FreeSpinsView.RETRIGGER_STARTED = 'FreeSpinsView::RETRIGGER_STARTED';
    FreeSpinsView.RETRIGGER_FINISHED = 'FreeSpinsView::RETRIGGER_FINISHED';
    FreeSpinsView.FONT_NAME_MOBILE = 'MED_';
    FreeSpinsView.FONT_NAME_DESKTOP = 'MED_';
    return FreeSpinsView;
}(View_1.View));
exports.FreeSpinsView = FreeSpinsView;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (typeof process === 'undefined' ||
    !process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(50)))

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(98)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The Point object represents a location in a two-dimensional coordinate system, where x represents
 * the horizontal axis and y represents the vertical axis.
 *
 * @class
 * @memberof PIXI
 */
var Point = function () {
  /**
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */
  function Point() {
    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    _classCallCheck(this, Point);

    /**
     * @member {number}
     * @default 0
     */
    this.x = x;

    /**
     * @member {number}
     * @default 0
     */
    this.y = y;
  }

  /**
   * Creates a clone of this point
   *
   * @return {PIXI.Point} a copy of the point
   */


  Point.prototype.clone = function clone() {
    return new Point(this.x, this.y);
  };

  /**
   * Copies x and y from the given point
   *
   * @param {PIXI.Point} p - The point to copy.
   */


  Point.prototype.copy = function copy(p) {
    this.set(p.x, p.y);
  };

  /**
   * Returns true if the given point is equal to this point
   *
   * @param {PIXI.Point} p - The point to check
   * @returns {boolean} Whether the given point equal to this point
   */


  Point.prototype.equals = function equals(p) {
    return p.x === this.x && p.y === this.y;
  };

  /**
   * Sets the point to a new x and y position.
   * If y is omitted, both x and y will be set to x.
   *
   * @param {number} [x=0] - position of the point on the x axis
   * @param {number} [y=0] - position of the point on the y axis
   */


  Point.prototype.set = function set(x, y) {
    this.x = x || 0;
    this.y = y || (y !== 0 ? this.x : 0);
  };

  return Point;
}();

exports.default = Point;
//# sourceMappingURL=Point.js.map

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Point = __webpack_require__(123);

var _Point2 = _interopRequireDefault(_Point);

var _const = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The PixiJS Matrix class as an object, which makes it a lot faster,
 * here is a representation of it :
 * | a | c | tx|
 * | b | d | ty|
 * | 0 | 0 | 1 |
 *
 * @class
 * @memberof PIXI
 */
var Matrix = function () {
    /**
     * @param {number} [a=1] - x scale
     * @param {number} [b=0] - x skew
     * @param {number} [c=0] - y skew
     * @param {number} [d=1] - y scale
     * @param {number} [tx=0] - x translation
     * @param {number} [ty=0] - y translation
     */
    function Matrix() {
        var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        var d = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
        var tx = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
        var ty = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

        _classCallCheck(this, Matrix);

        /**
         * @member {number}
         * @default 1
         */
        this.a = a;

        /**
         * @member {number}
         * @default 0
         */
        this.b = b;

        /**
         * @member {number}
         * @default 0
         */
        this.c = c;

        /**
         * @member {number}
         * @default 1
         */
        this.d = d;

        /**
         * @member {number}
         * @default 0
         */
        this.tx = tx;

        /**
         * @member {number}
         * @default 0
         */
        this.ty = ty;

        this.array = null;
    }

    /**
     * Creates a Matrix object based on the given array. The Element to Matrix mapping order is as follows:
     *
     * a = array[0]
     * b = array[1]
     * c = array[3]
     * d = array[4]
     * tx = array[2]
     * ty = array[5]
     *
     * @param {number[]} array - The array that the matrix will be populated from.
     */


    Matrix.prototype.fromArray = function fromArray(array) {
        this.a = array[0];
        this.b = array[1];
        this.c = array[3];
        this.d = array[4];
        this.tx = array[2];
        this.ty = array[5];
    };

    /**
     * sets the matrix properties
     *
     * @param {number} a - Matrix component
     * @param {number} b - Matrix component
     * @param {number} c - Matrix component
     * @param {number} d - Matrix component
     * @param {number} tx - Matrix component
     * @param {number} ty - Matrix component
     *
     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
     */


    Matrix.prototype.set = function set(a, b, c, d, tx, ty) {
        this.a = a;
        this.b = b;
        this.c = c;
        this.d = d;
        this.tx = tx;
        this.ty = ty;

        return this;
    };

    /**
     * Creates an array from the current Matrix object.
     *
     * @param {boolean} transpose - Whether we need to transpose the matrix or not
     * @param {Float32Array} [out=new Float32Array(9)] - If provided the array will be assigned to out
     * @return {number[]} the newly created array which contains the matrix
     */


    Matrix.prototype.toArray = function toArray(transpose, out) {
        if (!this.array) {
            this.array = new Float32Array(9);
        }

        var array = out || this.array;

        if (transpose) {
            array[0] = this.a;
            array[1] = this.b;
            array[2] = 0;
            array[3] = this.c;
            array[4] = this.d;
            array[5] = 0;
            array[6] = this.tx;
            array[7] = this.ty;
            array[8] = 1;
        } else {
            array[0] = this.a;
            array[1] = this.c;
            array[2] = this.tx;
            array[3] = this.b;
            array[4] = this.d;
            array[5] = this.ty;
            array[6] = 0;
            array[7] = 0;
            array[8] = 1;
        }

        return array;
    };

    /**
     * Get a new position with the current transformation applied.
     * Can be used to go from a child's coordinate space to the world coordinate space. (e.g. rendering)
     *
     * @param {PIXI.Point} pos - The origin
     * @param {PIXI.Point} [newPos] - The point that the new position is assigned to (allowed to be same as input)
     * @return {PIXI.Point} The new point, transformed through this matrix
     */


    Matrix.prototype.apply = function apply(pos, newPos) {
        newPos = newPos || new _Point2.default();

        var x = pos.x;
        var y = pos.y;

        newPos.x = this.a * x + this.c * y + this.tx;
        newPos.y = this.b * x + this.d * y + this.ty;

        return newPos;
    };

    /**
     * Get a new position with the inverse of the current transformation applied.
     * Can be used to go from the world coordinate space to a child's coordinate space. (e.g. input)
     *
     * @param {PIXI.Point} pos - The origin
     * @param {PIXI.Point} [newPos] - The point that the new position is assigned to (allowed to be same as input)
     * @return {PIXI.Point} The new point, inverse-transformed through this matrix
     */


    Matrix.prototype.applyInverse = function applyInverse(pos, newPos) {
        newPos = newPos || new _Point2.default();

        var id = 1 / (this.a * this.d + this.c * -this.b);

        var x = pos.x;
        var y = pos.y;

        newPos.x = this.d * id * x + -this.c * id * y + (this.ty * this.c - this.tx * this.d) * id;
        newPos.y = this.a * id * y + -this.b * id * x + (-this.ty * this.a + this.tx * this.b) * id;

        return newPos;
    };

    /**
     * Translates the matrix on the x and y.
     *
     * @param {number} x How much to translate x by
     * @param {number} y How much to translate y by
     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
     */


    Matrix.prototype.translate = function translate(x, y) {
        this.tx += x;
        this.ty += y;

        return this;
    };

    /**
     * Applies a scale transformation to the matrix.
     *
     * @param {number} x The amount to scale horizontally
     * @param {number} y The amount to scale vertically
     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
     */


    Matrix.prototype.scale = function scale(x, y) {
        this.a *= x;
        this.d *= y;
        this.c *= x;
        this.b *= y;
        this.tx *= x;
        this.ty *= y;

        return this;
    };

    /**
     * Applies a rotation transformation to the matrix.
     *
     * @param {number} angle - The angle in radians.
     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
     */


    Matrix.prototype.rotate = function rotate(angle) {
        var cos = Math.cos(angle);
        var sin = Math.sin(angle);

        var a1 = this.a;
        var c1 = this.c;
        var tx1 = this.tx;

        this.a = a1 * cos - this.b * sin;
        this.b = a1 * sin + this.b * cos;
        this.c = c1 * cos - this.d * sin;
        this.d = c1 * sin + this.d * cos;
        this.tx = tx1 * cos - this.ty * sin;
        this.ty = tx1 * sin + this.ty * cos;

        return this;
    };

    /**
     * Appends the given Matrix to this Matrix.
     *
     * @param {PIXI.Matrix} matrix - The matrix to append.
     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
     */


    Matrix.prototype.append = function append(matrix) {
        var a1 = this.a;
        var b1 = this.b;
        var c1 = this.c;
        var d1 = this.d;

        this.a = matrix.a * a1 + matrix.b * c1;
        this.b = matrix.a * b1 + matrix.b * d1;
        this.c = matrix.c * a1 + matrix.d * c1;
        this.d = matrix.c * b1 + matrix.d * d1;

        this.tx = matrix.tx * a1 + matrix.ty * c1 + this.tx;
        this.ty = matrix.tx * b1 + matrix.ty * d1 + this.ty;

        return this;
    };

    /**
     * Sets the matrix based on all the available properties
     *
     * @param {number} x - Position on the x axis
     * @param {number} y - Position on the y axis
     * @param {number} pivotX - Pivot on the x axis
     * @param {number} pivotY - Pivot on the y axis
     * @param {number} scaleX - Scale on the x axis
     * @param {number} scaleY - Scale on the y axis
     * @param {number} rotation - Rotation in radians
     * @param {number} skewX - Skew on the x axis
     * @param {number} skewY - Skew on the y axis
     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
     */


    Matrix.prototype.setTransform = function setTransform(x, y, pivotX, pivotY, scaleX, scaleY, rotation, skewX, skewY) {
        this.a = Math.cos(rotation + skewY) * scaleX;
        this.b = Math.sin(rotation + skewY) * scaleX;
        this.c = -Math.sin(rotation - skewX) * scaleY;
        this.d = Math.cos(rotation - skewX) * scaleY;

        this.tx = x - (pivotX * this.a + pivotY * this.c);
        this.ty = y - (pivotX * this.b + pivotY * this.d);

        return this;
    };

    /**
     * Prepends the given Matrix to this Matrix.
     *
     * @param {PIXI.Matrix} matrix - The matrix to prepend
     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
     */


    Matrix.prototype.prepend = function prepend(matrix) {
        var tx1 = this.tx;

        if (matrix.a !== 1 || matrix.b !== 0 || matrix.c !== 0 || matrix.d !== 1) {
            var a1 = this.a;
            var c1 = this.c;

            this.a = a1 * matrix.a + this.b * matrix.c;
            this.b = a1 * matrix.b + this.b * matrix.d;
            this.c = c1 * matrix.a + this.d * matrix.c;
            this.d = c1 * matrix.b + this.d * matrix.d;
        }

        this.tx = tx1 * matrix.a + this.ty * matrix.c + matrix.tx;
        this.ty = tx1 * matrix.b + this.ty * matrix.d + matrix.ty;

        return this;
    };

    /**
     * Decomposes the matrix (x, y, scaleX, scaleY, and rotation) and sets the properties on to a transform.
     *
     * @param {PIXI.Transform|PIXI.TransformStatic} transform - The transform to apply the properties to.
     * @return {PIXI.Transform|PIXI.TransformStatic} The transform with the newly applied properties
     */


    Matrix.prototype.decompose = function decompose(transform) {
        // sort out rotation / skew..
        var a = this.a;
        var b = this.b;
        var c = this.c;
        var d = this.d;

        var skewX = -Math.atan2(-c, d);
        var skewY = Math.atan2(b, a);

        var delta = Math.abs(skewX + skewY);

        if (delta < 0.00001 || Math.abs(_const.PI_2 - delta) < 0.00001) {
            transform.rotation = skewY;
            transform.skew.x = transform.skew.y = 0;
        } else {
            transform.rotation = 0;
            transform.skew.x = skewX;
            transform.skew.y = skewY;
        }

        // next set scale
        transform.scale.x = Math.sqrt(a * a + b * b);
        transform.scale.y = Math.sqrt(c * c + d * d);

        // next set position
        transform.position.x = this.tx;
        transform.position.y = this.ty;

        return transform;
    };

    /**
     * Inverts this matrix
     *
     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
     */


    Matrix.prototype.invert = function invert() {
        var a1 = this.a;
        var b1 = this.b;
        var c1 = this.c;
        var d1 = this.d;
        var tx1 = this.tx;
        var n = a1 * d1 - b1 * c1;

        this.a = d1 / n;
        this.b = -b1 / n;
        this.c = -c1 / n;
        this.d = a1 / n;
        this.tx = (c1 * this.ty - d1 * tx1) / n;
        this.ty = -(a1 * this.ty - b1 * tx1) / n;

        return this;
    };

    /**
     * Resets this Matix to an identity (default) matrix.
     *
     * @return {PIXI.Matrix} This matrix. Good for chaining method calls.
     */


    Matrix.prototype.identity = function identity() {
        this.a = 1;
        this.b = 0;
        this.c = 0;
        this.d = 1;
        this.tx = 0;
        this.ty = 0;

        return this;
    };

    /**
     * Creates a new Matrix object with the same values as this one.
     *
     * @return {PIXI.Matrix} A copy of this matrix. Good for chaining method calls.
     */


    Matrix.prototype.clone = function clone() {
        var matrix = new Matrix();

        matrix.a = this.a;
        matrix.b = this.b;
        matrix.c = this.c;
        matrix.d = this.d;
        matrix.tx = this.tx;
        matrix.ty = this.ty;

        return matrix;
    };

    /**
     * Changes the values of the given matrix to be the same as the ones in this matrix
     *
     * @param {PIXI.Matrix} matrix - The matrix to copy from.
     * @return {PIXI.Matrix} The matrix given in parameter with its values updated.
     */


    Matrix.prototype.copy = function copy(matrix) {
        matrix.a = this.a;
        matrix.b = this.b;
        matrix.c = this.c;
        matrix.d = this.d;
        matrix.tx = this.tx;
        matrix.ty = this.ty;

        return matrix;
    };

    /**
     * A default (identity) matrix
     *
     * @static
     * @const
     */


    _createClass(Matrix, null, [{
        key: 'IDENTITY',
        get: function get() {
            return new Matrix();
        }

        /**
         * A temp matrix
         *
         * @static
         * @const
         */

    }, {
        key: 'TEMP_MATRIX',
        get: function get() {
            return new Matrix();
        }
    }]);

    return Matrix;
}();

exports.default = Matrix;
//# sourceMappingURL=Matrix.js.map

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _const = __webpack_require__(5);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Rectangle object is an area defined by its position, as indicated by its top-left corner
 * point (x, y) and by its width and its height.
 *
 * @class
 * @memberof PIXI
 */
var Rectangle = function () {
  /**
   * @param {number} [x=0] - The X coordinate of the upper-left corner of the rectangle
   * @param {number} [y=0] - The Y coordinate of the upper-left corner of the rectangle
   * @param {number} [width=0] - The overall width of this rectangle
   * @param {number} [height=0] - The overall height of this rectangle
   */
  function Rectangle() {
    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var height = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

    _classCallCheck(this, Rectangle);

    /**
     * @member {number}
     * @default 0
     */
    this.x = Number(x);

    /**
     * @member {number}
     * @default 0
     */
    this.y = Number(y);

    /**
     * @member {number}
     * @default 0
     */
    this.width = Number(width);

    /**
     * @member {number}
     * @default 0
     */
    this.height = Number(height);

    /**
     * The type of the object, mainly used to avoid `instanceof` checks
     *
     * @member {number}
     * @readOnly
     * @default PIXI.SHAPES.RECT
     * @see PIXI.SHAPES
     */
    this.type = _const.SHAPES.RECT;
  }

  /**
   * returns the left edge of the rectangle
   *
   * @member {number}
   */


  /**
   * Creates a clone of this Rectangle
   *
   * @return {PIXI.Rectangle} a copy of the rectangle
   */
  Rectangle.prototype.clone = function clone() {
    return new Rectangle(this.x, this.y, this.width, this.height);
  };

  /**
   * Copies another rectangle to this one.
   *
   * @param {PIXI.Rectangle} rectangle - The rectangle to copy.
   * @return {PIXI.Rectangle} Returns itself.
   */


  Rectangle.prototype.copy = function copy(rectangle) {
    this.x = rectangle.x;
    this.y = rectangle.y;
    this.width = rectangle.width;
    this.height = rectangle.height;

    return this;
  };

  /**
   * Checks whether the x and y coordinates given are contained within this Rectangle
   *
   * @param {number} x - The X coordinate of the point to test
   * @param {number} y - The Y coordinate of the point to test
   * @return {boolean} Whether the x/y coordinates are within this Rectangle
   */


  Rectangle.prototype.contains = function contains(x, y) {
    if (this.width <= 0 || this.height <= 0) {
      return false;
    }

    if (x >= this.x && x < this.x + this.width) {
      if (y >= this.y && y < this.y + this.height) {
        return true;
      }
    }

    return false;
  };

  /**
   * Pads the rectangle making it grow in all directions.
   *
   * @param {number} paddingX - The horizontal padding amount.
   * @param {number} [paddingY] - The vertical padding amount.
   */


  Rectangle.prototype.pad = function pad(paddingX, paddingY) {
    paddingX = paddingX || 0;
    paddingY = paddingY || (paddingY !== 0 ? paddingX : 0);

    this.x -= paddingX;
    this.y -= paddingY;

    this.width += paddingX * 2;
    this.height += paddingY * 2;
  };

  /**
   * Fits this rectangle around the passed one.
   *
   * @param {PIXI.Rectangle} rectangle - The rectangle to fit.
   */


  Rectangle.prototype.fit = function fit(rectangle) {
    var x1 = Math.max(this.x, rectangle.x);
    var x2 = Math.min(this.x + this.width, rectangle.x + rectangle.width);
    var y1 = Math.max(this.y, rectangle.y);
    var y2 = Math.min(this.y + this.height, rectangle.y + rectangle.height);

    this.x = x1;
    this.width = Math.max(x2 - x1, 0);
    this.y = y1;
    this.height = Math.max(y2 - y1, 0);
  };

  /**
   * Enlarges this rectangle to include the passed rectangle.
   *
   * @param {PIXI.Rectangle} rectangle - The rectangle to include.
   */


  Rectangle.prototype.enlarge = function enlarge(rectangle) {
    var x1 = Math.min(this.x, rectangle.x);
    var x2 = Math.max(this.x + this.width, rectangle.x + rectangle.width);
    var y1 = Math.min(this.y, rectangle.y);
    var y2 = Math.max(this.y + this.height, rectangle.y + rectangle.height);

    this.x = x1;
    this.width = x2 - x1;
    this.y = y1;
    this.height = y2 - y1;
  };

  /**
   * Enlarges rectangle that way its corners lie on grid
   *
   * @param {number} [resolution=1] resolution
   * @param {number} [eps=0.001] precision
   */


  Rectangle.prototype.ceil = function ceil() {
    var resolution = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var eps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.001;

    var x2 = Math.ceil((this.x + this.width - eps) * resolution) / resolution;
    var y2 = Math.ceil((this.y + this.height - eps) * resolution) / resolution;

    this.x = Math.floor((this.x + eps) * resolution) / resolution;
    this.y = Math.floor((this.y + eps) * resolution) / resolution;

    this.width = x2 - this.x;
    this.height = y2 - this.y;
  };

  _createClass(Rectangle, [{
    key: 'left',
    get: function get() {
      return this.x;
    }

    /**
     * returns the right edge of the rectangle
     *
     * @member {number}
     */

  }, {
    key: 'right',
    get: function get() {
      return this.x + this.width;
    }

    /**
     * returns the top edge of the rectangle
     *
     * @member {number}
     */

  }, {
    key: 'top',
    get: function get() {
      return this.y;
    }

    /**
     * returns the bottom edge of the rectangle
     *
     * @member {number}
     */

  }, {
    key: 'bottom',
    get: function get() {
      return this.y + this.height;
    }

    /**
     * A constant empty rectangle.
     *
     * @static
     * @constant
     */

  }], [{
    key: 'EMPTY',
    get: function get() {
      return new Rectangle(0, 0, 0, 0);
    }
  }]);

  return Rectangle;
}();

exports.default = Rectangle;
//# sourceMappingURL=Rectangle.js.map

/***/ }),
/* 126 */
/***/ (function(module, exports) {



var mapType = function(gl, type) 
{
    if(!GL_TABLE) 
    {
        var typeNames = Object.keys(GL_TO_GLSL_TYPES);

        GL_TABLE = {};

        for(var i = 0; i < typeNames.length; ++i) 
        {
            var tn = typeNames[i];
            GL_TABLE[ gl[tn] ] = GL_TO_GLSL_TYPES[tn];
        }
    }

  return GL_TABLE[type];
};

var GL_TABLE = null;

var GL_TO_GLSL_TYPES = {
  'FLOAT':       'float',
  'FLOAT_VEC2':  'vec2',
  'FLOAT_VEC3':  'vec3',
  'FLOAT_VEC4':  'vec4',

  'INT':         'int',
  'INT_VEC2':    'ivec2',
  'INT_VEC3':    'ivec3',
  'INT_VEC4':    'ivec4',
  
  'BOOL':        'bool',
  'BOOL_VEC2':   'bvec2',
  'BOOL_VEC3':   'bvec3',
  'BOOL_VEC4':   'bvec4',
  
  'FLOAT_MAT2':  'mat2',
  'FLOAT_MAT3':  'mat3',
  'FLOAT_MAT4':  'mat4',
  
  'SAMPLER_2D':  'sampler2D'  
};

module.exports = mapType;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _math = __webpack_require__(20);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * 'Builder' pattern for bounds rectangles
 * Axis-Aligned Bounding Box
 * It is not a shape! Its mutable thing, no 'EMPTY' or that kind of problems
 *
 * @class
 * @memberof PIXI
 */
var Bounds = function () {
    /**
     *
     */
    function Bounds() {
        _classCallCheck(this, Bounds);

        /**
         * @member {number}
         * @default 0
         */
        this.minX = Infinity;

        /**
         * @member {number}
         * @default 0
         */
        this.minY = Infinity;

        /**
         * @member {number}
         * @default 0
         */
        this.maxX = -Infinity;

        /**
         * @member {number}
         * @default 0
         */
        this.maxY = -Infinity;

        this.rect = null;
    }

    /**
     * Checks if bounds are empty.
     *
     * @return {boolean} True if empty.
     */


    Bounds.prototype.isEmpty = function isEmpty() {
        return this.minX > this.maxX || this.minY > this.maxY;
    };

    /**
     * Clears the bounds and resets.
     *
     */


    Bounds.prototype.clear = function clear() {
        this.updateID++;

        this.minX = Infinity;
        this.minY = Infinity;
        this.maxX = -Infinity;
        this.maxY = -Infinity;
    };

    /**
     * Can return Rectangle.EMPTY constant, either construct new rectangle, either use your rectangle
     * It is not guaranteed that it will return tempRect
     *
     * @param {PIXI.Rectangle} rect - temporary object will be used if AABB is not empty
     * @returns {PIXI.Rectangle} A rectangle of the bounds
     */


    Bounds.prototype.getRectangle = function getRectangle(rect) {
        if (this.minX > this.maxX || this.minY > this.maxY) {
            return _math.Rectangle.EMPTY;
        }

        rect = rect || new _math.Rectangle(0, 0, 1, 1);

        rect.x = this.minX;
        rect.y = this.minY;
        rect.width = this.maxX - this.minX;
        rect.height = this.maxY - this.minY;

        return rect;
    };

    /**
     * This function should be inlined when its possible.
     *
     * @param {PIXI.Point} point - The point to add.
     */


    Bounds.prototype.addPoint = function addPoint(point) {
        this.minX = Math.min(this.minX, point.x);
        this.maxX = Math.max(this.maxX, point.x);
        this.minY = Math.min(this.minY, point.y);
        this.maxY = Math.max(this.maxY, point.y);
    };

    /**
     * Adds a quad, not transformed
     *
     * @param {Float32Array} vertices - The verts to add.
     */


    Bounds.prototype.addQuad = function addQuad(vertices) {
        var minX = this.minX;
        var minY = this.minY;
        var maxX = this.maxX;
        var maxY = this.maxY;

        var x = vertices[0];
        var y = vertices[1];

        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;

        x = vertices[2];
        y = vertices[3];
        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;

        x = vertices[4];
        y = vertices[5];
        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;

        x = vertices[6];
        y = vertices[7];
        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;

        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    };

    /**
     * Adds sprite frame, transformed.
     *
     * @param {PIXI.TransformBase} transform - TODO
     * @param {number} x0 - TODO
     * @param {number} y0 - TODO
     * @param {number} x1 - TODO
     * @param {number} y1 - TODO
     */


    Bounds.prototype.addFrame = function addFrame(transform, x0, y0, x1, y1) {
        var matrix = transform.worldTransform;
        var a = matrix.a;
        var b = matrix.b;
        var c = matrix.c;
        var d = matrix.d;
        var tx = matrix.tx;
        var ty = matrix.ty;

        var minX = this.minX;
        var minY = this.minY;
        var maxX = this.maxX;
        var maxY = this.maxY;

        var x = a * x0 + c * y0 + tx;
        var y = b * x0 + d * y0 + ty;

        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;

        x = a * x1 + c * y0 + tx;
        y = b * x1 + d * y0 + ty;
        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;

        x = a * x0 + c * y1 + tx;
        y = b * x0 + d * y1 + ty;
        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;

        x = a * x1 + c * y1 + tx;
        y = b * x1 + d * y1 + ty;
        minX = x < minX ? x : minX;
        minY = y < minY ? y : minY;
        maxX = x > maxX ? x : maxX;
        maxY = y > maxY ? y : maxY;

        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    };

    /**
     * Add an array of vertices
     *
     * @param {PIXI.TransformBase} transform - TODO
     * @param {Float32Array} vertices - TODO
     * @param {number} beginOffset - TODO
     * @param {number} endOffset - TODO
     */


    Bounds.prototype.addVertices = function addVertices(transform, vertices, beginOffset, endOffset) {
        var matrix = transform.worldTransform;
        var a = matrix.a;
        var b = matrix.b;
        var c = matrix.c;
        var d = matrix.d;
        var tx = matrix.tx;
        var ty = matrix.ty;

        var minX = this.minX;
        var minY = this.minY;
        var maxX = this.maxX;
        var maxY = this.maxY;

        for (var i = beginOffset; i < endOffset; i += 2) {
            var rawX = vertices[i];
            var rawY = vertices[i + 1];
            var x = a * rawX + c * rawY + tx;
            var y = d * rawY + b * rawX + ty;

            minX = x < minX ? x : minX;
            minY = y < minY ? y : minY;
            maxX = x > maxX ? x : maxX;
            maxY = y > maxY ? y : maxY;
        }

        this.minX = minX;
        this.minY = minY;
        this.maxX = maxX;
        this.maxY = maxY;
    };

    /**
     * Adds other Bounds
     *
     * @param {PIXI.Bounds} bounds - TODO
     */


    Bounds.prototype.addBounds = function addBounds(bounds) {
        var minX = this.minX;
        var minY = this.minY;
        var maxX = this.maxX;
        var maxY = this.maxY;

        this.minX = bounds.minX < minX ? bounds.minX : minX;
        this.minY = bounds.minY < minY ? bounds.minY : minY;
        this.maxX = bounds.maxX > maxX ? bounds.maxX : maxX;
        this.maxY = bounds.maxY > maxY ? bounds.maxY : maxY;
    };

    /**
     * Adds other Bounds, masked with Bounds
     *
     * @param {PIXI.Bounds} bounds - TODO
     * @param {PIXI.Bounds} mask - TODO
     */


    Bounds.prototype.addBoundsMask = function addBoundsMask(bounds, mask) {
        var _minX = bounds.minX > mask.minX ? bounds.minX : mask.minX;
        var _minY = bounds.minY > mask.minY ? bounds.minY : mask.minY;
        var _maxX = bounds.maxX < mask.maxX ? bounds.maxX : mask.maxX;
        var _maxY = bounds.maxY < mask.maxY ? bounds.maxY : mask.maxY;

        if (_minX <= _maxX && _minY <= _maxY) {
            var minX = this.minX;
            var minY = this.minY;
            var maxX = this.maxX;
            var maxY = this.maxY;

            this.minX = _minX < minX ? _minX : minX;
            this.minY = _minY < minY ? _minY : minY;
            this.maxX = _maxX > maxX ? _maxX : maxX;
            this.maxY = _maxY > maxY ? _maxY : maxY;
        }
    };

    /**
     * Adds other Bounds, masked with Rectangle
     *
     * @param {PIXI.Bounds} bounds - TODO
     * @param {PIXI.Rectangle} area - TODO
     */


    Bounds.prototype.addBoundsArea = function addBoundsArea(bounds, area) {
        var _minX = bounds.minX > area.x ? bounds.minX : area.x;
        var _minY = bounds.minY > area.y ? bounds.minY : area.y;
        var _maxX = bounds.maxX < area.x + area.width ? bounds.maxX : area.x + area.width;
        var _maxY = bounds.maxY < area.y + area.height ? bounds.maxY : area.y + area.height;

        if (_minX <= _maxX && _minY <= _maxY) {
            var minX = this.minX;
            var minY = this.minY;
            var maxX = this.maxX;
            var maxY = this.maxY;

            this.minX = _minX < minX ? _minX : minX;
            this.minY = _minY < minY ? _minY : minY;
            this.maxX = _maxX > maxX ? _maxX : maxX;
            this.maxY = _maxY > maxY ? _maxY : maxY;
        }
    };

    return Bounds;
}();

exports.default = Bounds;
//# sourceMappingURL=Bounds.js.map

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(e){var n=/iPhone/i,t=/iPod/i,r=/iPad/i,a=/\bAndroid(?:.+)Mobile\b/i,p=/Android/i,b=/\bAndroid(?:.+)SD4930UR\b/i,l=/\bAndroid(?:.+)(?:KF[A-Z]{2,4})\b/i,f=/Windows Phone/i,s=/\bWindows(?:.+)ARM\b/i,u=/BlackBerry/i,c=/BB10/i,h=/Opera Mini/i,v=/\b(CriOS|Chrome)(?:.+)Mobile/i,w=/Mobile(?:.+)Firefox\b/i;function m(e,i){return e.test(i)}function i(e){var i=e||("undefined"!=typeof navigator?navigator.userAgent:""),o=i.split("[FBAN");void 0!==o[1]&&(i=o[0]),void 0!==(o=i.split("Twitter"))[1]&&(i=o[0]);var d={apple:{phone:m(n,i)&&!m(f,i),ipod:m(t,i),tablet:!m(n,i)&&m(r,i)&&!m(f,i),device:(m(n,i)||m(t,i)||m(r,i))&&!m(f,i)},amazon:{phone:m(b,i),tablet:!m(b,i)&&m(l,i),device:m(b,i)||m(l,i)},android:{phone:!m(f,i)&&m(b,i)||!m(f,i)&&m(a,i),tablet:!m(f,i)&&!m(b,i)&&!m(a,i)&&(m(l,i)||m(p,i)),device:!m(f,i)&&(m(b,i)||m(l,i)||m(a,i)||m(p,i))||m(/\bokhttp\b/i,i)},windows:{phone:m(f,i),tablet:m(s,i),device:m(f,i)||m(s,i)},other:{blackberry:m(u,i),blackberry10:m(c,i),opera:m(h,i),firefox:m(w,i),chrome:m(v,i),device:m(u,i)||m(c,i)||m(h,i)||m(w,i)||m(v,i)}};return d.any=d.apple.device||d.android.device||d.windows.device||d.other.device,d.phone=d.apple.phone||d.android.phone||d.windows.phone,d.tablet=d.apple.tablet||d.android.tablet||d.windows.tablet,d}"undefined"!=typeof module&&module.exports&&"undefined"==typeof window?module.exports=i:"undefined"!=typeof module&&module.exports&&"undefined"!=typeof window?(module.exports=i(),module.exports.isMobile=i): true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (e.isMobile=i()),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):e.isMobile=i()}(this);

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _math = __webpack_require__(20);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Generic class to deal with traditional 2D matrix transforms
 *
 * @class
 * @memberof PIXI
 */
var TransformBase = function () {
  /**
   *
   */
  function TransformBase() {
    _classCallCheck(this, TransformBase);

    /**
     * The global matrix transform. It can be swapped temporarily by some functions like getLocalBounds()
     *
     * @member {PIXI.Matrix}
     */
    this.worldTransform = new _math.Matrix();

    /**
     * The local matrix transform
     *
     * @member {PIXI.Matrix}
     */
    this.localTransform = new _math.Matrix();

    this._worldID = 0;
    this._parentID = 0;
  }

  /**
   * TransformBase does not have decomposition, so this function wont do anything
   */


  TransformBase.prototype.updateLocalTransform = function updateLocalTransform() {}
  // empty


  /**
   * Updates the values of the object and applies the parent's transform.
   *
   * @param {PIXI.TransformBase} parentTransform - The transform of the parent of this object
   */
  ;

  TransformBase.prototype.updateTransform = function updateTransform(parentTransform) {
    var pt = parentTransform.worldTransform;
    var wt = this.worldTransform;
    var lt = this.localTransform;

    // concat the parent matrix with the objects transform.
    wt.a = lt.a * pt.a + lt.b * pt.c;
    wt.b = lt.a * pt.b + lt.b * pt.d;
    wt.c = lt.c * pt.a + lt.d * pt.c;
    wt.d = lt.c * pt.b + lt.d * pt.d;
    wt.tx = lt.tx * pt.a + lt.ty * pt.c + pt.tx;
    wt.ty = lt.tx * pt.b + lt.ty * pt.d + pt.ty;

    this._worldID++;
  };

  return TransformBase;
}();

/**
 * Updates the values of the object and applies the parent's transform.
 * @param  parentTransform {PIXI.Transform} The transform of the parent of this object
 *
 */


exports.default = TransformBase;
TransformBase.prototype.updateWorldTransform = TransformBase.prototype.updateTransform;

TransformBase.IDENTITY = new TransformBase();
//# sourceMappingURL=TransformBase.js.map

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = earcut;
module.exports.default = earcut;

function earcut(data, holeIndices, dim) {

    dim = dim || 2;

    var hasHoles = holeIndices && holeIndices.length,
        outerLen = hasHoles ? holeIndices[0] * dim : data.length,
        outerNode = linkedList(data, 0, outerLen, dim, true),
        triangles = [];

    if (!outerNode || outerNode.next === outerNode.prev) return triangles;

    var minX, minY, maxX, maxY, x, y, invSize;

    if (hasHoles) outerNode = eliminateHoles(data, holeIndices, outerNode, dim);

    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
    if (data.length > 80 * dim) {
        minX = maxX = data[0];
        minY = maxY = data[1];

        for (var i = dim; i < outerLen; i += dim) {
            x = data[i];
            y = data[i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
        }

        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
        invSize = Math.max(maxX - minX, maxY - minY);
        invSize = invSize !== 0 ? 1 / invSize : 0;
    }

    earcutLinked(outerNode, triangles, dim, minX, minY, invSize);

    return triangles;
}

// create a circular doubly linked list from polygon points in the specified winding order
function linkedList(data, start, end, dim, clockwise) {
    var i, last;

    if (clockwise === (signedArea(data, start, end, dim) > 0)) {
        for (i = start; i < end; i += dim) last = insertNode(i, data[i], data[i + 1], last);
    } else {
        for (i = end - dim; i >= start; i -= dim) last = insertNode(i, data[i], data[i + 1], last);
    }

    if (last && equals(last, last.next)) {
        removeNode(last);
        last = last.next;
    }

    return last;
}

// eliminate colinear or duplicate points
function filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;

    var p = start,
        again;
    do {
        again = false;

        if (!p.steiner && (equals(p, p.next) || area(p.prev, p, p.next) === 0)) {
            removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;

        } else {
            p = p.next;
        }
    } while (again || p !== end);

    return end;
}

// main ear slicing loop which triangulates a polygon (given as a linked list)
function earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;

    // interlink polygon nodes in z-order
    if (!pass && invSize) indexCurve(ear, minX, minY, invSize);

    var stop = ear,
        prev, next;

    // iterate through ears, slicing them one by one
    while (ear.prev !== ear.next) {
        prev = ear.prev;
        next = ear.next;

        if (invSize ? isEarHashed(ear, minX, minY, invSize) : isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim);
            triangles.push(ear.i / dim);
            triangles.push(next.i / dim);

            removeNode(ear);

            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;

            continue;
        }

        ear = next;

        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) {
                earcutLinked(filterPoints(ear), triangles, dim, minX, minY, invSize, 1);

            // if this didn't work, try curing all small self-intersections locally
            } else if (pass === 1) {
                ear = cureLocalIntersections(filterPoints(ear), triangles, dim);
                earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);

            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) {
                splitEarcut(ear, triangles, dim, minX, minY, invSize);
            }

            break;
        }
    }
}

// check whether a polygon node forms a valid ear with adjacent nodes
function isEar(ear) {
    var a = ear.prev,
        b = ear,
        c = ear.next;

    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear

    // now make sure we don't have other points inside the potential ear
    var p = ear.next.next;

    while (p !== ear.prev) {
        if (pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
            area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }

    return true;
}

function isEarHashed(ear, minX, minY, invSize) {
    var a = ear.prev,
        b = ear,
        c = ear.next;

    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear

    // triangle bbox; min & max are calculated like this for speed
    var minTX = a.x < b.x ? (a.x < c.x ? a.x : c.x) : (b.x < c.x ? b.x : c.x),
        minTY = a.y < b.y ? (a.y < c.y ? a.y : c.y) : (b.y < c.y ? b.y : c.y),
        maxTX = a.x > b.x ? (a.x > c.x ? a.x : c.x) : (b.x > c.x ? b.x : c.x),
        maxTY = a.y > b.y ? (a.y > c.y ? a.y : c.y) : (b.y > c.y ? b.y : c.y);

    // z-order range for the current triangle bbox;
    var minZ = zOrder(minTX, minTY, minX, minY, invSize),
        maxZ = zOrder(maxTX, maxTY, minX, minY, invSize);

    var p = ear.prevZ,
        n = ear.nextZ;

    // look for points inside the triangle in both directions
    while (p && p.z >= minZ && n && n.z <= maxZ) {
        if (p !== ear.prev && p !== ear.next &&
            pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
            area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;

        if (n !== ear.prev && n !== ear.next &&
            pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) &&
            area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }

    // look for remaining points in decreasing z-order
    while (p && p.z >= minZ) {
        if (p !== ear.prev && p !== ear.next &&
            pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
            area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }

    // look for remaining points in increasing z-order
    while (n && n.z <= maxZ) {
        if (n !== ear.prev && n !== ear.next &&
            pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) &&
            area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }

    return true;
}

// go through all polygon nodes and cure small local self-intersections
function cureLocalIntersections(start, triangles, dim) {
    var p = start;
    do {
        var a = p.prev,
            b = p.next.next;

        if (!equals(a, b) && intersects(a, p, p.next, b) && locallyInside(a, b) && locallyInside(b, a)) {

            triangles.push(a.i / dim);
            triangles.push(p.i / dim);
            triangles.push(b.i / dim);

            // remove two nodes involved
            removeNode(p);
            removeNode(p.next);

            p = start = b;
        }
        p = p.next;
    } while (p !== start);

    return filterPoints(p);
}

// try splitting polygon into two and triangulate them independently
function splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    var a = start;
    do {
        var b = a.next.next;
        while (b !== a.prev) {
            if (a.i !== b.i && isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                var c = splitPolygon(a, b);

                // filter colinear points around the cuts
                a = filterPoints(a, a.next);
                c = filterPoints(c, c.next);

                // run earcut on each half
                earcutLinked(a, triangles, dim, minX, minY, invSize);
                earcutLinked(c, triangles, dim, minX, minY, invSize);
                return;
            }
            b = b.next;
        }
        a = a.next;
    } while (a !== start);
}

// link every hole into the outer loop, producing a single-ring polygon without holes
function eliminateHoles(data, holeIndices, outerNode, dim) {
    var queue = [],
        i, len, start, end, list;

    for (i = 0, len = holeIndices.length; i < len; i++) {
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push(getLeftmost(list));
    }

    queue.sort(compareX);

    // process holes from left to right
    for (i = 0; i < queue.length; i++) {
        eliminateHole(queue[i], outerNode);
        outerNode = filterPoints(outerNode, outerNode.next);
    }

    return outerNode;
}

function compareX(a, b) {
    return a.x - b.x;
}

// find a bridge between vertices that connects hole with an outer ring and and link it
function eliminateHole(hole, outerNode) {
    outerNode = findHoleBridge(hole, outerNode);
    if (outerNode) {
        var b = splitPolygon(outerNode, hole);

        // filter collinear points around the cuts
        filterPoints(outerNode, outerNode.next);
        filterPoints(b, b.next);
    }
}

// David Eberly's algorithm for finding a bridge between hole and outer polygon
function findHoleBridge(hole, outerNode) {
    var p = outerNode,
        hx = hole.x,
        hy = hole.y,
        qx = -Infinity,
        m;

    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                if (x === hx) {
                    if (hy === p.y) return p;
                    if (hy === p.next.y) return p.next;
                }
                m = p.x < p.next.x ? p : p.next;
            }
        }
        p = p.next;
    } while (p !== outerNode);

    if (!m) return null;

    if (hx === qx) return m; // hole touches outer segment; pick leftmost endpoint

    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point

    var stop = m,
        mx = m.x,
        my = m.y,
        tanMin = Infinity,
        tan;

    p = m;

    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x &&
                pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {

            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential

            if (locallyInside(p, hole) &&
                (tan < tanMin || (tan === tanMin && (p.x > m.x || (p.x === m.x && sectorContainsSector(m, p)))))) {
                m = p;
                tanMin = tan;
            }
        }

        p = p.next;
    } while (p !== stop);

    return m;
}

// whether sector in vertex m contains sector in vertex p in the same coordinates
function sectorContainsSector(m, p) {
    return area(m.prev, m, p.prev) < 0 && area(p.next, m, m.next) < 0;
}

// interlink polygon nodes in z-order
function indexCurve(start, minX, minY, invSize) {
    var p = start;
    do {
        if (p.z === null) p.z = zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    } while (p !== start);

    p.prevZ.nextZ = null;
    p.prevZ = null;

    sortLinked(p);
}

// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function sortLinked(list) {
    var i, p, q, e, tail, numMerges, pSize, qSize,
        inSize = 1;

    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;

        while (p) {
            numMerges++;
            q = p;
            pSize = 0;
            for (i = 0; i < inSize; i++) {
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;

            while (pSize > 0 || (qSize > 0 && q)) {

                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }

                if (tail) tail.nextZ = e;
                else list = e;

                e.prevZ = tail;
                tail = e;
            }

            p = q;
        }

        tail.nextZ = null;
        inSize *= 2;

    } while (numMerges > 1);

    return list;
}

// z-order of a point given coords and inverse of the longer side of data bbox
function zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = 32767 * (x - minX) * invSize;
    y = 32767 * (y - minY) * invSize;

    x = (x | (x << 8)) & 0x00FF00FF;
    x = (x | (x << 4)) & 0x0F0F0F0F;
    x = (x | (x << 2)) & 0x33333333;
    x = (x | (x << 1)) & 0x55555555;

    y = (y | (y << 8)) & 0x00FF00FF;
    y = (y | (y << 4)) & 0x0F0F0F0F;
    y = (y | (y << 2)) & 0x33333333;
    y = (y | (y << 1)) & 0x55555555;

    return x | (y << 1);
}

// find the leftmost node of a polygon ring
function getLeftmost(start) {
    var p = start,
        leftmost = start;
    do {
        if (p.x < leftmost.x || (p.x === leftmost.x && p.y < leftmost.y)) leftmost = p;
        p = p.next;
    } while (p !== start);

    return leftmost;
}

// check if a point lies within a convex triangle
function pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) - (ax - px) * (cy - py) >= 0 &&
           (ax - px) * (by - py) - (bx - px) * (ay - py) >= 0 &&
           (bx - px) * (cy - py) - (cx - px) * (by - py) >= 0;
}

// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !intersectsPolygon(a, b) && // dones't intersect other edges
           (locallyInside(a, b) && locallyInside(b, a) && middleInside(a, b) && // locally visible
            (area(a.prev, a, b.prev) || area(a, b.prev, b)) || // does not create opposite-facing sectors
            equals(a, b) && area(a.prev, a, a.next) > 0 && area(b.prev, b, b.next) > 0); // special zero-length case
}

// signed area of a triangle
function area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}

// check if two points are equal
function equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}

// check if two segments intersect
function intersects(p1, q1, p2, q2) {
    var o1 = sign(area(p1, q1, p2));
    var o2 = sign(area(p1, q1, q2));
    var o3 = sign(area(p2, q2, p1));
    var o4 = sign(area(p2, q2, q1));

    if (o1 !== o2 && o3 !== o4) return true; // general case

    if (o1 === 0 && onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2

    return false;
}

// for collinear points p, q, r, check if point q lies on segment pr
function onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}

function sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}

// check if a polygon diagonal intersects any polygon segments
function intersectsPolygon(a, b) {
    var p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i &&
                intersects(p, p.next, a, b)) return true;
        p = p.next;
    } while (p !== a);

    return false;
}

// check if a polygon diagonal is locally inside the polygon
function locallyInside(a, b) {
    return area(a.prev, a, a.next) < 0 ?
        area(a, b, a.next) >= 0 && area(a, a.prev, b) >= 0 :
        area(a, b, a.prev) < 0 || area(a, a.next, b) < 0;
}

// check if the middle point of a polygon diagonal is inside the polygon
function middleInside(a, b) {
    var p = a,
        inside = false,
        px = (a.x + b.x) / 2,
        py = (a.y + b.y) / 2;
    do {
        if (((p.y > py) !== (p.next.y > py)) && p.next.y !== p.y &&
                (px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x))
            inside = !inside;
        p = p.next;
    } while (p !== a);

    return inside;
}

// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function splitPolygon(a, b) {
    var a2 = new Node(a.i, a.x, a.y),
        b2 = new Node(b.i, b.x, b.y),
        an = a.next,
        bp = b.prev;

    a.next = b;
    b.prev = a;

    a2.next = an;
    an.prev = a2;

    b2.next = a2;
    a2.prev = b2;

    bp.next = b2;
    b2.prev = bp;

    return b2;
}

// create a node and optionally link it with previous one (in a circular doubly linked list)
function insertNode(i, x, y, last) {
    var p = new Node(i, x, y);

    if (!last) {
        p.prev = p;
        p.next = p;

    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}

function removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;

    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}

function Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;

    // vertex coordinates
    this.x = x;
    this.y = y;

    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;

    // z-order curve value
    this.z = null;

    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;

    // indicates whether this is a steiner point
    this.steiner = false;
}

// return a percentage difference between the polygon area and its triangulation area;
// used to verify correctness of triangulation
earcut.deviation = function (data, holeIndices, dim, triangles) {
    var hasHoles = holeIndices && holeIndices.length;
    var outerLen = hasHoles ? holeIndices[0] * dim : data.length;

    var polygonArea = Math.abs(signedArea(data, 0, outerLen, dim));
    if (hasHoles) {
        for (var i = 0, len = holeIndices.length; i < len; i++) {
            var start = holeIndices[i] * dim;
            var end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
            polygonArea -= Math.abs(signedArea(data, start, end, dim));
        }
    }

    var trianglesArea = 0;
    for (i = 0; i < triangles.length; i += 3) {
        var a = triangles[i] * dim;
        var b = triangles[i + 1] * dim;
        var c = triangles[i + 2] * dim;
        trianglesArea += Math.abs(
            (data[a] - data[c]) * (data[b + 1] - data[a + 1]) -
            (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
    }

    return polygonArea === 0 && trianglesArea === 0 ? 0 :
        Math.abs((trianglesArea - polygonArea) / polygonArea);
};

function signedArea(data, start, end, dim) {
    var sum = 0;
    for (var i = start, j = end - dim; i < end; i += dim) {
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}

// turn a polygon in a multi-dimensional array form (e.g. as in GeoJSON) into a form Earcut accepts
earcut.flatten = function (data) {
    var dim = data[0][0].length,
        result = {vertices: [], holes: [], dimensions: dim},
        holeIndex = 0;

    for (var i = 0; i < data.length; i++) {
        for (var j = 0; j < data[i].length; j++) {
            for (var d = 0; d < dim; d++) result.vertices.push(data[i][j][d]);
        }
        if (i > 0) {
            holeIndex += data[i - 1].length;
            result.holes.push(holeIndex);
        }
    }
    return result;
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _math = __webpack_require__(20);

var _utils = __webpack_require__(9);

var _const = __webpack_require__(5);

var _Texture = __webpack_require__(49);

var _Texture2 = _interopRequireDefault(_Texture);

var _Container2 = __webpack_require__(83);

var _Container3 = _interopRequireDefault(_Container2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var tempPoint = new _math.Point();

/**
 * The Sprite object is the base for all textured objects that are rendered to the screen
 *
 * A sprite can be created directly from an image like this:
 *
 * ```js
 * let sprite = new PIXI.Sprite.fromImage('assets/image.png');
 * ```
 *
 * The more efficient way to create sprites is using a {@link PIXI.Spritesheet}:
 *
 * ```js
 * PIXI.loader.add("assets/spritesheet.json").load(setup);
 *
 * function setup() {
 *   let sheet = PIXI.loader.resources["assets/spritesheet.json"].spritesheet;
 *   let sprite = new PIXI.Sprite(sheet.textures["image.png"]);
 *   ...
 * }
 * ```
 *
 * @class
 * @extends PIXI.Container
 * @memberof PIXI
 */

var Sprite = function (_Container) {
    _inherits(Sprite, _Container);

    /**
     * @param {PIXI.Texture} texture - The texture for this sprite
     */
    function Sprite(texture) {
        _classCallCheck(this, Sprite);

        /**
         * The anchor sets the origin point of the texture.
         * The default is 0,0 or taken from the {@link PIXI.Texture#defaultAnchor|Texture}
         * passed to the constructor. A value of 0,0 means the texture's origin is the top left.
         * Setting the anchor to 0.5,0.5 means the texture's origin is centered.
         * Setting the anchor to 1,1 would mean the texture's origin point will be the bottom right corner.
         * Note: Updating the {@link PIXI.Texture#defaultAnchor} after a Texture is
         * created does _not_ update the Sprite's anchor values.
         *
         * @member {PIXI.ObservablePoint}
         * @private
         */
        var _this = _possibleConstructorReturn(this, _Container.call(this));

        _this._anchor = new _math.ObservablePoint(_this._onAnchorUpdate, _this, texture ? texture.defaultAnchor.x : 0, texture ? texture.defaultAnchor.y : 0);

        /**
         * The texture that the sprite is using
         *
         * @private
         * @member {PIXI.Texture}
         */
        _this._texture = null;

        /**
         * The width of the sprite (this is initially set by the texture)
         *
         * @private
         * @member {number}
         */
        _this._width = 0;

        /**
         * The height of the sprite (this is initially set by the texture)
         *
         * @private
         * @member {number}
         */
        _this._height = 0;

        /**
         * The tint applied to the sprite. This is a hex value. A value of 0xFFFFFF will remove any tint effect.
         *
         * @private
         * @member {number}
         * @default 0xFFFFFF
         */
        _this._tint = null;
        _this._tintRGB = null;
        _this.tint = 0xFFFFFF;

        /**
         * The blend mode to be applied to the sprite. Apply a value of `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.
         *
         * @member {number}
         * @default PIXI.BLEND_MODES.NORMAL
         * @see PIXI.BLEND_MODES
         */
        _this.blendMode = _const.BLEND_MODES.NORMAL;

        /**
         * The shader that will be used to render the sprite. Set to null to remove a current shader.
         *
         * @member {PIXI.Filter|PIXI.Shader}
         */
        _this.shader = null;

        /**
         * An internal cached value of the tint.
         *
         * @private
         * @member {number}
         * @default 0xFFFFFF
         */
        _this.cachedTint = 0xFFFFFF;

        // call texture setter
        _this.texture = texture || _Texture2.default.EMPTY;

        /**
         * this is used to store the vertex data of the sprite (basically a quad)
         *
         * @private
         * @member {Float32Array}
         */
        _this.vertexData = new Float32Array(8);

        /**
         * This is used to calculate the bounds of the object IF it is a trimmed sprite
         *
         * @private
         * @member {Float32Array}
         */
        _this.vertexTrimmedData = null;

        _this._transformID = -1;
        _this._textureID = -1;

        _this._transformTrimmedID = -1;
        _this._textureTrimmedID = -1;

        /**
         * Plugin that is responsible for rendering this element.
         * Allows to customize the rendering process without overriding '_renderWebGL' & '_renderCanvas' methods.
         *
         * @member {string}
         * @default 'sprite'
         */
        _this.pluginName = 'sprite';
        return _this;
    }

    /**
     * When the texture is updated, this event will fire to update the scale and frame
     *
     * @private
     */


    Sprite.prototype._onTextureUpdate = function _onTextureUpdate() {
        this._textureID = -1;
        this._textureTrimmedID = -1;
        this.cachedTint = 0xFFFFFF;

        // so if _width is 0 then width was not set..
        if (this._width) {
            this.scale.x = (0, _utils.sign)(this.scale.x) * this._width / this._texture.orig.width;
        }

        if (this._height) {
            this.scale.y = (0, _utils.sign)(this.scale.y) * this._height / this._texture.orig.height;
        }
    };

    /**
     * Called when the anchor position updates.
     *
     * @private
     */


    Sprite.prototype._onAnchorUpdate = function _onAnchorUpdate() {
        this._transformID = -1;
        this._transformTrimmedID = -1;
    };

    /**
     * calculates worldTransform * vertices, store it in vertexData
     */


    Sprite.prototype.calculateVertices = function calculateVertices() {
        if (this._transformID === this.transform._worldID && this._textureID === this._texture._updateID) {
            return;
        }

        this._transformID = this.transform._worldID;
        this._textureID = this._texture._updateID;

        // set the vertex data

        var texture = this._texture;
        var wt = this.transform.worldTransform;
        var a = wt.a;
        var b = wt.b;
        var c = wt.c;
        var d = wt.d;
        var tx = wt.tx;
        var ty = wt.ty;
        var vertexData = this.vertexData;
        var trim = texture.trim;
        var orig = texture.orig;
        var anchor = this._anchor;

        var w0 = 0;
        var w1 = 0;
        var h0 = 0;
        var h1 = 0;

        if (trim) {
            // if the sprite is trimmed and is not a tilingsprite then we need to add the extra
            // space before transforming the sprite coords.
            w1 = trim.x - anchor._x * orig.width;
            w0 = w1 + trim.width;

            h1 = trim.y - anchor._y * orig.height;
            h0 = h1 + trim.height;
        } else {
            w1 = -anchor._x * orig.width;
            w0 = w1 + orig.width;

            h1 = -anchor._y * orig.height;
            h0 = h1 + orig.height;
        }

        // xy
        vertexData[0] = a * w1 + c * h1 + tx;
        vertexData[1] = d * h1 + b * w1 + ty;

        // xy
        vertexData[2] = a * w0 + c * h1 + tx;
        vertexData[3] = d * h1 + b * w0 + ty;

        // xy
        vertexData[4] = a * w0 + c * h0 + tx;
        vertexData[5] = d * h0 + b * w0 + ty;

        // xy
        vertexData[6] = a * w1 + c * h0 + tx;
        vertexData[7] = d * h0 + b * w1 + ty;
    };

    /**
     * calculates worldTransform * vertices for a non texture with a trim. store it in vertexTrimmedData
     * This is used to ensure that the true width and height of a trimmed texture is respected
     */


    Sprite.prototype.calculateTrimmedVertices = function calculateTrimmedVertices() {
        if (!this.vertexTrimmedData) {
            this.vertexTrimmedData = new Float32Array(8);
        } else if (this._transformTrimmedID === this.transform._worldID && this._textureTrimmedID === this._texture._updateID) {
            return;
        }

        this._transformTrimmedID = this.transform._worldID;
        this._textureTrimmedID = this._texture._updateID;

        // lets do some special trim code!
        var texture = this._texture;
        var vertexData = this.vertexTrimmedData;
        var orig = texture.orig;
        var anchor = this._anchor;

        // lets calculate the new untrimmed bounds..
        var wt = this.transform.worldTransform;
        var a = wt.a;
        var b = wt.b;
        var c = wt.c;
        var d = wt.d;
        var tx = wt.tx;
        var ty = wt.ty;

        var w1 = -anchor._x * orig.width;
        var w0 = w1 + orig.width;

        var h1 = -anchor._y * orig.height;
        var h0 = h1 + orig.height;

        // xy
        vertexData[0] = a * w1 + c * h1 + tx;
        vertexData[1] = d * h1 + b * w1 + ty;

        // xy
        vertexData[2] = a * w0 + c * h1 + tx;
        vertexData[3] = d * h1 + b * w0 + ty;

        // xy
        vertexData[4] = a * w0 + c * h0 + tx;
        vertexData[5] = d * h0 + b * w0 + ty;

        // xy
        vertexData[6] = a * w1 + c * h0 + tx;
        vertexData[7] = d * h0 + b * w1 + ty;
    };

    /**
    *
    * Renders the object using the WebGL renderer
    *
    * @private
    * @param {PIXI.WebGLRenderer} renderer - The webgl renderer to use.
    */


    Sprite.prototype._renderWebGL = function _renderWebGL(renderer) {
        this.calculateVertices();

        renderer.setObjectRenderer(renderer.plugins[this.pluginName]);
        renderer.plugins[this.pluginName].render(this);
    };

    /**
    * Renders the object using the Canvas renderer
    *
    * @private
    * @param {PIXI.CanvasRenderer} renderer - The renderer
    */


    Sprite.prototype._renderCanvas = function _renderCanvas(renderer) {
        renderer.plugins[this.pluginName].render(this);
    };

    /**
     * Updates the bounds of the sprite.
     *
     * @private
     */


    Sprite.prototype._calculateBounds = function _calculateBounds() {
        var trim = this._texture.trim;
        var orig = this._texture.orig;

        // First lets check to see if the current texture has a trim..
        if (!trim || trim.width === orig.width && trim.height === orig.height) {
            // no trim! lets use the usual calculations..
            this.calculateVertices();
            this._bounds.addQuad(this.vertexData);
        } else {
            // lets calculate a special trimmed bounds...
            this.calculateTrimmedVertices();
            this._bounds.addQuad(this.vertexTrimmedData);
        }
    };

    /**
     * Gets the local bounds of the sprite object.
     *
     * @param {PIXI.Rectangle} rect - The output rectangle.
     * @return {PIXI.Rectangle} The bounds.
     */


    Sprite.prototype.getLocalBounds = function getLocalBounds(rect) {
        // we can do a fast local bounds if the sprite has no children!
        if (this.children.length === 0) {
            this._bounds.minX = this._texture.orig.width * -this._anchor._x;
            this._bounds.minY = this._texture.orig.height * -this._anchor._y;
            this._bounds.maxX = this._texture.orig.width * (1 - this._anchor._x);
            this._bounds.maxY = this._texture.orig.height * (1 - this._anchor._y);

            if (!rect) {
                if (!this._localBoundsRect) {
                    this._localBoundsRect = new _math.Rectangle();
                }

                rect = this._localBoundsRect;
            }

            return this._bounds.getRectangle(rect);
        }

        return _Container.prototype.getLocalBounds.call(this, rect);
    };

    /**
     * Tests if a point is inside this sprite
     *
     * @param {PIXI.Point} point - the point to test
     * @return {boolean} the result of the test
     */


    Sprite.prototype.containsPoint = function containsPoint(point) {
        this.worldTransform.applyInverse(point, tempPoint);

        var width = this._texture.orig.width;
        var height = this._texture.orig.height;
        var x1 = -width * this.anchor.x;
        var y1 = 0;

        if (tempPoint.x >= x1 && tempPoint.x < x1 + width) {
            y1 = -height * this.anchor.y;

            if (tempPoint.y >= y1 && tempPoint.y < y1 + height) {
                return true;
            }
        }

        return false;
    };

    /**
     * Destroys this sprite and optionally its texture and children
     *
     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
     *  have been set to that value
     * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
     *      method called as well. 'options' will be passed on to those calls.
     * @param {boolean} [options.texture=false] - Should it destroy the current texture of the sprite as well
     * @param {boolean} [options.baseTexture=false] - Should it destroy the base texture of the sprite as well
     */


    Sprite.prototype.destroy = function destroy(options) {
        _Container.prototype.destroy.call(this, options);

        this._texture.off('update', this._onTextureUpdate, this);

        this._anchor = null;

        var destroyTexture = typeof options === 'boolean' ? options : options && options.texture;

        if (destroyTexture) {
            var destroyBaseTexture = typeof options === 'boolean' ? options : options && options.baseTexture;

            this._texture.destroy(!!destroyBaseTexture);
        }

        this._texture = null;
        this.shader = null;
    };

    // some helper functions..

    /**
     * Helper function that creates a new sprite based on the source you provide.
     * The source can be - frame id, image url, video url, canvas element, video element, base texture
     *
     * @static
     * @param {number|string|PIXI.BaseTexture|HTMLCanvasElement|HTMLVideoElement} source Source to create texture from
     * @return {PIXI.Sprite} The newly created sprite
     */


    Sprite.from = function from(source) {
        return new Sprite(_Texture2.default.from(source));
    };

    /**
     * Helper function that creates a sprite that will contain a texture from the TextureCache based on the frameId
     * The frame ids are created when a Texture packer file has been loaded
     *
     * @static
     * @param {string} frameId - The frame Id of the texture in the cache
     * @return {PIXI.Sprite} A new Sprite using a texture from the texture cache matching the frameId
     */


    Sprite.fromFrame = function fromFrame(frameId) {
        var texture = _utils.TextureCache[frameId];

        if (!texture) {
            throw new Error('The frameId "' + frameId + '" does not exist in the texture cache');
        }

        return new Sprite(texture);
    };

    /**
     * Helper function that creates a sprite that will contain a texture based on an image url
     * If the image is not in the texture cache it will be loaded
     *
     * @static
     * @param {string} imageId - The image url of the texture
     * @param {boolean} [crossorigin=(auto)] - if you want to specify the cross-origin parameter
     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - if you want to specify the scale mode,
     *  see {@link PIXI.SCALE_MODES} for possible values
     * @return {PIXI.Sprite} A new Sprite using a texture from the texture cache matching the image id
     */


    Sprite.fromImage = function fromImage(imageId, crossorigin, scaleMode) {
        return new Sprite(_Texture2.default.fromImage(imageId, crossorigin, scaleMode));
    };

    /**
     * The width of the sprite, setting this will actually modify the scale to achieve the value set
     *
     * @member {number}
     */


    _createClass(Sprite, [{
        key: 'width',
        get: function get() {
            return Math.abs(this.scale.x) * this._texture.orig.width;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            var s = (0, _utils.sign)(this.scale.x) || 1;

            this.scale.x = s * value / this._texture.orig.width;
            this._width = value;
        }

        /**
         * The height of the sprite, setting this will actually modify the scale to achieve the value set
         *
         * @member {number}
         */

    }, {
        key: 'height',
        get: function get() {
            return Math.abs(this.scale.y) * this._texture.orig.height;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            var s = (0, _utils.sign)(this.scale.y) || 1;

            this.scale.y = s * value / this._texture.orig.height;
            this._height = value;
        }

        /**
         * The anchor sets the origin point of the texture.
         * The default is 0,0 or taken from the {@link PIXI.Texture|Texture} passed to the constructor.
         * Setting the texture at a later point of time does not change the anchor.
         *
         * 0,0 means the texture's origin is the top left, 0.5,0.5 is the center, 1,1 the bottom right corner.
         *
         * @member {PIXI.ObservablePoint}
         */

    }, {
        key: 'anchor',
        get: function get() {
            return this._anchor;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this._anchor.copy(value);
        }

        /**
         * The tint applied to the sprite. This is a hex value.
         * A value of 0xFFFFFF will remove any tint effect.
         *
         * @member {number}
         * @default 0xFFFFFF
         */

    }, {
        key: 'tint',
        get: function get() {
            return this._tint;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this._tint = value;
            this._tintRGB = (value >> 16) + (value & 0xff00) + ((value & 0xff) << 16);
        }

        /**
         * The texture that the sprite is using
         *
         * @member {PIXI.Texture}
         */

    }, {
        key: 'texture',
        get: function get() {
            return this._texture;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            if (this._texture === value) {
                return;
            }

            this._texture = value || _Texture2.default.EMPTY;
            this.cachedTint = 0xFFFFFF;

            this._textureID = -1;
            this._textureTrimmedID = -1;

            if (value) {
                // wait for the texture to load
                if (value.baseTexture.hasLoaded) {
                    this._onTextureUpdate();
                } else {
                    value.once('update', this._onTextureUpdate, this);
                }
            }
        }
    }]);

    return Sprite;
}(_Container3.default);

exports.default = Sprite;
//# sourceMappingURL=Sprite.js.map

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var punycode = __webpack_require__(360);
var util = __webpack_require__(362);

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = __webpack_require__(363);

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Bit twiddling hacks for JavaScript.
 *
 * Author: Mikola Lysenko
 *
 * Ported from Stanford bit twiddling hack library:
 *    http://graphics.stanford.edu/~seander/bithacks.html
 */

 "use restrict";

//Number of bits in an integer
var INT_BITS = 32;

//Constants
exports.INT_BITS  = INT_BITS;
exports.INT_MAX   =  0x7fffffff;
exports.INT_MIN   = -1<<(INT_BITS-1);

//Returns -1, 0, +1 depending on sign of x
exports.sign = function(v) {
  return (v > 0) - (v < 0);
}

//Computes absolute value of integer
exports.abs = function(v) {
  var mask = v >> (INT_BITS-1);
  return (v ^ mask) - mask;
}

//Computes minimum of integers x and y
exports.min = function(x, y) {
  return y ^ ((x ^ y) & -(x < y));
}

//Computes maximum of integers x and y
exports.max = function(x, y) {
  return x ^ ((x ^ y) & -(x < y));
}

//Checks if a number is a power of two
exports.isPow2 = function(v) {
  return !(v & (v-1)) && (!!v);
}

//Computes log base 2 of v
exports.log2 = function(v) {
  var r, shift;
  r =     (v > 0xFFFF) << 4; v >>>= r;
  shift = (v > 0xFF  ) << 3; v >>>= shift; r |= shift;
  shift = (v > 0xF   ) << 2; v >>>= shift; r |= shift;
  shift = (v > 0x3   ) << 1; v >>>= shift; r |= shift;
  return r | (v >> 1);
}

//Computes log base 10 of v
exports.log10 = function(v) {
  return  (v >= 1000000000) ? 9 : (v >= 100000000) ? 8 : (v >= 10000000) ? 7 :
          (v >= 1000000) ? 6 : (v >= 100000) ? 5 : (v >= 10000) ? 4 :
          (v >= 1000) ? 3 : (v >= 100) ? 2 : (v >= 10) ? 1 : 0;
}

//Counts number of bits
exports.popCount = function(v) {
  v = v - ((v >>> 1) & 0x55555555);
  v = (v & 0x33333333) + ((v >>> 2) & 0x33333333);
  return ((v + (v >>> 4) & 0xF0F0F0F) * 0x1010101) >>> 24;
}

//Counts number of trailing zeros
function countTrailingZeros(v) {
  var c = 32;
  v &= -v;
  if (v) c--;
  if (v & 0x0000FFFF) c -= 16;
  if (v & 0x00FF00FF) c -= 8;
  if (v & 0x0F0F0F0F) c -= 4;
  if (v & 0x33333333) c -= 2;
  if (v & 0x55555555) c -= 1;
  return c;
}
exports.countTrailingZeros = countTrailingZeros;

//Rounds to next power of 2
exports.nextPow2 = function(v) {
  v += v === 0;
  --v;
  v |= v >>> 1;
  v |= v >>> 2;
  v |= v >>> 4;
  v |= v >>> 8;
  v |= v >>> 16;
  return v + 1;
}

//Rounds down to previous power of 2
exports.prevPow2 = function(v) {
  v |= v >>> 1;
  v |= v >>> 2;
  v |= v >>> 4;
  v |= v >>> 8;
  v |= v >>> 16;
  return v - (v>>>1);
}

//Computes parity of word
exports.parity = function(v) {
  v ^= v >>> 16;
  v ^= v >>> 8;
  v ^= v >>> 4;
  v &= 0xf;
  return (0x6996 >>> v) & 1;
}

var REVERSE_TABLE = new Array(256);

(function(tab) {
  for(var i=0; i<256; ++i) {
    var v = i, r = i, s = 7;
    for (v >>>= 1; v; v >>>= 1) {
      r <<= 1;
      r |= v & 1;
      --s;
    }
    tab[i] = (r << s) & 0xff;
  }
})(REVERSE_TABLE);

//Reverse bits in a 32 bit word
exports.reverse = function(v) {
  return  (REVERSE_TABLE[ v         & 0xff] << 24) |
          (REVERSE_TABLE[(v >>> 8)  & 0xff] << 16) |
          (REVERSE_TABLE[(v >>> 16) & 0xff] << 8)  |
           REVERSE_TABLE[(v >>> 24) & 0xff];
}

//Interleave bits of 2 coordinates with 16 bits.  Useful for fast quadtree codes
exports.interleave2 = function(x, y) {
  x &= 0xFFFF;
  x = (x | (x << 8)) & 0x00FF00FF;
  x = (x | (x << 4)) & 0x0F0F0F0F;
  x = (x | (x << 2)) & 0x33333333;
  x = (x | (x << 1)) & 0x55555555;

  y &= 0xFFFF;
  y = (y | (y << 8)) & 0x00FF00FF;
  y = (y | (y << 4)) & 0x0F0F0F0F;
  y = (y | (y << 2)) & 0x33333333;
  y = (y | (y << 1)) & 0x55555555;

  return x | (y << 1);
}

//Extracts the nth interleaved component
exports.deinterleave2 = function(v, n) {
  v = (v >>> n) & 0x55555555;
  v = (v | (v >>> 1))  & 0x33333333;
  v = (v | (v >>> 2))  & 0x0F0F0F0F;
  v = (v | (v >>> 4))  & 0x00FF00FF;
  v = (v | (v >>> 16)) & 0x000FFFF;
  return (v << 16) >> 16;
}


//Interleave bits of 3 coordinates, each with 10 bits.  Useful for fast octree codes
exports.interleave3 = function(x, y, z) {
  x &= 0x3FF;
  x  = (x | (x<<16)) & 4278190335;
  x  = (x | (x<<8))  & 251719695;
  x  = (x | (x<<4))  & 3272356035;
  x  = (x | (x<<2))  & 1227133513;

  y &= 0x3FF;
  y  = (y | (y<<16)) & 4278190335;
  y  = (y | (y<<8))  & 251719695;
  y  = (y | (y<<4))  & 3272356035;
  y  = (y | (y<<2))  & 1227133513;
  x |= (y << 1);
  
  z &= 0x3FF;
  z  = (z | (z<<16)) & 4278190335;
  z  = (z | (z<<8))  & 251719695;
  z  = (z | (z<<4))  & 3272356035;
  z  = (z | (z<<2))  & 1227133513;
  
  return x | (z << 2);
}

//Extracts nth interleaved component of a 3-tuple
exports.deinterleave3 = function(v, n) {
  v = (v >>> n)       & 1227133513;
  v = (v | (v>>>2))   & 3272356035;
  v = (v | (v>>>4))   & 251719695;
  v = (v | (v>>>8))   & 4278190335;
  v = (v | (v>>>16))  & 0x3FF;
  return (v<<22)>>22;
}

//Computes next combination in colexicographic order (this is mistakenly called nextPermutation on the bit twiddling hacks page)
exports.nextCombination = function(v) {
  var t = v | (v - 1);
  return (t + 1) | (((~t & -~t) - 1) >>> (countTrailingZeros(v) + 1));
}



/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Ticker = exports.shared = undefined;

var _Ticker = __webpack_require__(366);

var _Ticker2 = _interopRequireDefault(_Ticker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The shared ticker instance used by {@link PIXI.extras.AnimatedSprite}.
 * and by {@link PIXI.interaction.InteractionManager}.
 * The property {@link PIXI.ticker.Ticker#autoStart} is set to `true`
 * for this instance. Please follow the examples for usage, including
 * how to opt-out of auto-starting the shared ticker.
 *
 * @example
 * let ticker = PIXI.ticker.shared;
 * // Set this to prevent starting this ticker when listeners are added.
 * // By default this is true only for the PIXI.ticker.shared instance.
 * ticker.autoStart = false;
 * // FYI, call this to ensure the ticker is stopped. It should be stopped
 * // if you have not attempted to render anything yet.
 * ticker.stop();
 * // Call this when you are ready for a running shared ticker.
 * ticker.start();
 *
 * @example
 * // You may use the shared ticker to render...
 * let renderer = PIXI.autoDetectRenderer(800, 600);
 * let stage = new PIXI.Container();
 * let interactionManager = PIXI.interaction.InteractionManager(renderer);
 * document.body.appendChild(renderer.view);
 * ticker.add(function (time) {
 *     renderer.render(stage);
 * });
 *
 * @example
 * // Or you can just update it manually.
 * ticker.autoStart = false;
 * ticker.stop();
 * function animate(time) {
 *     ticker.update(time);
 *     renderer.render(stage);
 *     requestAnimationFrame(animate);
 * }
 * animate(performance.now());
 *
 * @type {PIXI.ticker.Ticker}
 * @memberof PIXI.ticker
 */
var shared = new _Ticker2.default();

shared.autoStart = true;
shared.destroy = function () {
  // protect destroying shared ticker
  // this is used by other internal systems
  // like AnimatedSprite and InteractionManager
};

/**
 * This namespace contains an API for interacting with PIXI's internal global update loop.
 *
 * This ticker is used for rendering, {@link PIXI.extras.AnimatedSprite AnimatedSprite},
 * {@link PIXI.interaction.InteractionManager InteractionManager} and many other time-based PIXI systems.
 * @example
 * const ticker = new PIXI.ticker.Ticker();
 * ticker.stop();
 * ticker.add((deltaTime) => {
 *   // do something every frame
 * });
 * ticker.start();
 * @namespace PIXI.ticker
 */
exports.shared = shared;
exports.Ticker = _Ticker2.default;
//# sourceMappingURL=index.js.map

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _BaseRenderTexture = __webpack_require__(188);

var _BaseRenderTexture2 = _interopRequireDefault(_BaseRenderTexture);

var _Texture2 = __webpack_require__(49);

var _Texture3 = _interopRequireDefault(_Texture2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * A RenderTexture is a special texture that allows any PixiJS display object to be rendered to it.
 *
 * __Hint__: All DisplayObjects (i.e. Sprites) that render to a RenderTexture should be preloaded
 * otherwise black rectangles will be drawn instead.
 *
 * A RenderTexture takes a snapshot of any Display Object given to its render method. For example:
 *
 * ```js
 * let renderer = PIXI.autoDetectRenderer(1024, 1024);
 * let renderTexture = PIXI.RenderTexture.create(800, 600);
 * let sprite = PIXI.Sprite.fromImage("spinObj_01.png");
 *
 * sprite.position.x = 800/2;
 * sprite.position.y = 600/2;
 * sprite.anchor.x = 0.5;
 * sprite.anchor.y = 0.5;
 *
 * renderer.render(sprite, renderTexture);
 * ```
 *
 * The Sprite in this case will be rendered using its local transform. To render this sprite at 0,0
 * you can clear the transform
 *
 * ```js
 *
 * sprite.setTransform()
 *
 * let renderTexture = new PIXI.RenderTexture.create(100, 100);
 *
 * renderer.render(sprite, renderTexture);  // Renders to center of RenderTexture
 * ```
 *
 * @class
 * @extends PIXI.Texture
 * @memberof PIXI
 */
var RenderTexture = function (_Texture) {
    _inherits(RenderTexture, _Texture);

    /**
     * @param {PIXI.BaseRenderTexture} baseRenderTexture - The renderer used for this RenderTexture
     * @param {PIXI.Rectangle} [frame] - The rectangle frame of the texture to show
     */
    function RenderTexture(baseRenderTexture, frame) {
        _classCallCheck(this, RenderTexture);

        // support for legacy..
        var _legacyRenderer = null;

        if (!(baseRenderTexture instanceof _BaseRenderTexture2.default)) {
            /* eslint-disable prefer-rest-params, no-console */
            var width = arguments[1];
            var height = arguments[2];
            var scaleMode = arguments[3];
            var resolution = arguments[4];

            // we have an old render texture..
            console.warn('Please use RenderTexture.create(' + width + ', ' + height + ') instead of the ctor directly.');
            _legacyRenderer = arguments[0];
            /* eslint-enable prefer-rest-params, no-console */

            frame = null;
            baseRenderTexture = new _BaseRenderTexture2.default(width, height, scaleMode, resolution);
        }

        /**
         * The base texture object that this texture uses
         *
         * @member {BaseTexture}
         */

        var _this = _possibleConstructorReturn(this, _Texture.call(this, baseRenderTexture, frame));

        _this.legacyRenderer = _legacyRenderer;

        /**
         * This will let the renderer know if the texture is valid. If it's not then it cannot be rendered.
         *
         * @member {boolean}
         */
        _this.valid = true;

        _this._updateUvs();
        return _this;
    }

    /**
     * Resizes the RenderTexture.
     *
     * @param {number} width - The width to resize to.
     * @param {number} height - The height to resize to.
     * @param {boolean} doNotResizeBaseTexture - Should the baseTexture.width and height values be resized as well?
     */


    RenderTexture.prototype.resize = function resize(width, height, doNotResizeBaseTexture) {
        width = Math.ceil(width);
        height = Math.ceil(height);

        // TODO - could be not required..
        this.valid = width > 0 && height > 0;

        this._frame.width = this.orig.width = width;
        this._frame.height = this.orig.height = height;

        if (!doNotResizeBaseTexture) {
            this.baseTexture.resize(width, height);
        }

        this._updateUvs();
    };

    /**
     * A short hand way of creating a render texture.
     *
     * @param {number} [width=100] - The width of the render texture
     * @param {number} [height=100] - The height of the render texture
     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
     * @param {number} [resolution=1] - The resolution / device pixel ratio of the texture being generated
     * @return {PIXI.RenderTexture} The new render texture
     */


    RenderTexture.create = function create(width, height, scaleMode, resolution) {
        return new RenderTexture(new _BaseRenderTexture2.default(width, height, scaleMode, resolution));
    };

    return RenderTexture;
}(_Texture3.default);

exports.default = RenderTexture;
//# sourceMappingURL=RenderTexture.js.map

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createIndicesForQuads;
/**
 * Generic Mask Stack data structure
 *
 * @memberof PIXI
 * @function createIndicesForQuads
 * @private
 * @param {number} size - Number of quads
 * @return {Uint16Array} indices
 */
function createIndicesForQuads(size) {
    // the total number of indices in our array, there are 6 points per quad.

    var totalIndices = size * 6;

    var indices = new Uint16Array(totalIndices);

    // fill the indices with the quads to draw
    for (var i = 0, j = 0; i < totalIndices; i += 6, j += 4) {
        indices[i + 0] = j + 0;
        indices[i + 1] = j + 1;
        indices[i + 2] = j + 2;
        indices[i + 3] = j + 0;
        indices[i + 4] = j + 2;
        indices[i + 5] = j + 3;
    }

    return indices;
}
//# sourceMappingURL=createIndicesForQuads.js.map

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Resource = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _parseUri = __webpack_require__(213);

var _parseUri2 = _interopRequireDefault(_parseUri);

var _miniSignals = __webpack_require__(212);

var _miniSignals2 = _interopRequireDefault(_miniSignals);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// tests if CORS is supported in XHR, if not we need to use XDR
var useXdr = !!(window.XDomainRequest && !('withCredentials' in new XMLHttpRequest()));
var tempAnchor = null;

// some status constants
var STATUS_NONE = 0;
var STATUS_OK = 200;
var STATUS_EMPTY = 204;
var STATUS_IE_BUG_EMPTY = 1223;
var STATUS_TYPE_OK = 2;

// noop
function _noop() {} /* empty */

/**
 * Manages the state and loading of a resource and all child resources.
 *
 * @class
 */

var Resource = exports.Resource = function () {
    /**
     * Sets the load type to be used for a specific extension.
     *
     * @static
     * @param {string} extname - The extension to set the type for, e.g. "png" or "fnt"
     * @param {Resource.LOAD_TYPE} loadType - The load type to set it to.
     */
    Resource.setExtensionLoadType = function setExtensionLoadType(extname, loadType) {
        setExtMap(Resource._loadTypeMap, extname, loadType);
    };

    /**
     * Sets the load type to be used for a specific extension.
     *
     * @static
     * @param {string} extname - The extension to set the type for, e.g. "png" or "fnt"
     * @param {Resource.XHR_RESPONSE_TYPE} xhrType - The xhr type to set it to.
     */


    Resource.setExtensionXhrType = function setExtensionXhrType(extname, xhrType) {
        setExtMap(Resource._xhrTypeMap, extname, xhrType);
    };

    /**
     * @param {string} name - The name of the resource to load.
     * @param {string|string[]} url - The url for this resource, for audio/video loads you can pass
     *      an array of sources.
     * @param {object} [options] - The options for the load.
     * @param {string|boolean} [options.crossOrigin] - Is this request cross-origin? Default is to
     *      determine automatically.
     * @param {number} [options.timeout=0] - A timeout in milliseconds for the load. If the load takes
     *      longer than this time it is cancelled and the load is considered a failure. If this value is
     *      set to `0` then there is no explicit timeout.
     * @param {Resource.LOAD_TYPE} [options.loadType=Resource.LOAD_TYPE.XHR] - How should this resource
     *      be loaded?
     * @param {Resource.XHR_RESPONSE_TYPE} [options.xhrType=Resource.XHR_RESPONSE_TYPE.DEFAULT] - How
     *      should the data being loaded be interpreted when using XHR?
     * @param {Resource.IMetadata} [options.metadata] - Extra configuration for middleware and the Resource object.
     */


    function Resource(name, url, options) {
        _classCallCheck(this, Resource);

        if (typeof name !== 'string' || typeof url !== 'string') {
            throw new Error('Both name and url are required for constructing a resource.');
        }

        options = options || {};

        /**
         * The state flags of this resource.
         *
         * @private
         * @member {number}
         */
        this._flags = 0;

        // set data url flag, needs to be set early for some _determineX checks to work.
        this._setFlag(Resource.STATUS_FLAGS.DATA_URL, url.indexOf('data:') === 0);

        /**
         * The name of this resource.
         *
         * @readonly
         * @member {string}
         */
        this.name = name;

        /**
         * The url used to load this resource.
         *
         * @readonly
         * @member {string}
         */
        this.url = url;

        /**
         * The extension used to load this resource.
         *
         * @readonly
         * @member {string}
         */
        this.extension = this._getExtension();

        /**
         * The data that was loaded by the resource.
         *
         * @member {any}
         */
        this.data = null;

        /**
         * Is this request cross-origin? If unset, determined automatically.
         *
         * @member {string}
         */
        this.crossOrigin = options.crossOrigin === true ? 'anonymous' : options.crossOrigin;

        /**
         * A timeout in milliseconds for the load. If the load takes longer than this time
         * it is cancelled and the load is considered a failure. If this value is set to `0`
         * then there is no explicit timeout.
         *
         * @member {number}
         */
        this.timeout = options.timeout || 0;

        /**
         * The method of loading to use for this resource.
         *
         * @member {Resource.LOAD_TYPE}
         */
        this.loadType = options.loadType || this._determineLoadType();

        /**
         * The type used to load the resource via XHR. If unset, determined automatically.
         *
         * @member {string}
         */
        this.xhrType = options.xhrType;

        /**
         * Extra info for middleware, and controlling specifics about how the resource loads.
         *
         * Note that if you pass in a `loadElement`, the Resource class takes ownership of it.
         * Meaning it will modify it as it sees fit.
         *
         * @member {Resource.IMetadata}
         */
        this.metadata = options.metadata || {};

        /**
         * The error that occurred while loading (if any).
         *
         * @readonly
         * @member {Error}
         */
        this.error = null;

        /**
         * The XHR object that was used to load this resource. This is only set
         * when `loadType` is `Resource.LOAD_TYPE.XHR`.
         *
         * @readonly
         * @member {XMLHttpRequest}
         */
        this.xhr = null;

        /**
         * The child resources this resource owns.
         *
         * @readonly
         * @member {Resource[]}
         */
        this.children = [];

        /**
         * The resource type.
         *
         * @readonly
         * @member {Resource.TYPE}
         */
        this.type = Resource.TYPE.UNKNOWN;

        /**
         * The progress chunk owned by this resource.
         *
         * @readonly
         * @member {number}
         */
        this.progressChunk = 0;

        /**
         * The `dequeue` method that will be used a storage place for the async queue dequeue method
         * used privately by the loader.
         *
         * @private
         * @member {function}
         */
        this._dequeue = _noop;

        /**
         * Used a storage place for the on load binding used privately by the loader.
         *
         * @private
         * @member {function}
         */
        this._onLoadBinding = null;

        /**
         * The timer for element loads to check if they timeout.
         *
         * @private
         * @member {number}
         */
        this._elementTimer = 0;

        /**
         * The `complete` function bound to this resource's context.
         *
         * @private
         * @member {function}
         */
        this._boundComplete = this.complete.bind(this);

        /**
         * The `_onError` function bound to this resource's context.
         *
         * @private
         * @member {function}
         */
        this._boundOnError = this._onError.bind(this);

        /**
         * The `_onProgress` function bound to this resource's context.
         *
         * @private
         * @member {function}
         */
        this._boundOnProgress = this._onProgress.bind(this);

        /**
         * The `_onTimeout` function bound to this resource's context.
         *
         * @private
         * @member {function}
         */
        this._boundOnTimeout = this._onTimeout.bind(this);

        // xhr callbacks
        this._boundXhrOnError = this._xhrOnError.bind(this);
        this._boundXhrOnTimeout = this._xhrOnTimeout.bind(this);
        this._boundXhrOnAbort = this._xhrOnAbort.bind(this);
        this._boundXhrOnLoad = this._xhrOnLoad.bind(this);

        /**
         * Dispatched when the resource beings to load.
         *
         * The callback looks like {@link Resource.OnStartSignal}.
         *
         * @member {Signal<Resource.OnStartSignal>}
         */
        this.onStart = new _miniSignals2.default();

        /**
         * Dispatched each time progress of this resource load updates.
         * Not all resources types and loader systems can support this event
         * so sometimes it may not be available. If the resource
         * is being loaded on a modern browser, using XHR, and the remote server
         * properly sets Content-Length headers, then this will be available.
         *
         * The callback looks like {@link Resource.OnProgressSignal}.
         *
         * @member {Signal<Resource.OnProgressSignal>}
         */
        this.onProgress = new _miniSignals2.default();

        /**
         * Dispatched once this resource has loaded, if there was an error it will
         * be in the `error` property.
         *
         * The callback looks like {@link Resource.OnCompleteSignal}.
         *
         * @member {Signal<Resource.OnCompleteSignal>}
         */
        this.onComplete = new _miniSignals2.default();

        /**
         * Dispatched after this resource has had all the *after* middleware run on it.
         *
         * The callback looks like {@link Resource.OnCompleteSignal}.
         *
         * @member {Signal<Resource.OnCompleteSignal>}
         */
        this.onAfterMiddleware = new _miniSignals2.default();
    }

    /**
     * When the resource starts to load.
     *
     * @memberof Resource
     * @callback OnStartSignal
     * @param {Resource} resource - The resource that the event happened on.
     */

    /**
     * When the resource reports loading progress.
     *
     * @memberof Resource
     * @callback OnProgressSignal
     * @param {Resource} resource - The resource that the event happened on.
     * @param {number} percentage - The progress of the load in the range [0, 1].
     */

    /**
     * When the resource finishes loading.
     *
     * @memberof Resource
     * @callback OnCompleteSignal
     * @param {Resource} resource - The resource that the event happened on.
     */

    /**
     * @memberof Resource
     * @typedef {object} IMetadata
     * @property {HTMLImageElement|HTMLAudioElement|HTMLVideoElement} [loadElement=null] - The
     *      element to use for loading, instead of creating one.
     * @property {boolean} [skipSource=false] - Skips adding source(s) to the load element. This
     *      is useful if you want to pass in a `loadElement` that you already added load sources to.
     * @property {string|string[]} [mimeType] - The mime type to use for the source element
     *      of a video/audio elment. If the urls are an array, you can pass this as an array as well
     *      where each index is the mime type to use for the corresponding url index.
     */

    /**
     * Stores whether or not this url is a data url.
     *
     * @readonly
     * @member {boolean}
     */


    /**
     * Marks the resource as complete.
     *
     */
    Resource.prototype.complete = function complete() {
        this._clearEvents();
        this._finish();
    };

    /**
     * Aborts the loading of this resource, with an optional message.
     *
     * @param {string} message - The message to use for the error
     */


    Resource.prototype.abort = function abort(message) {
        // abort can be called multiple times, ignore subsequent calls.
        if (this.error) {
            return;
        }

        // store error
        this.error = new Error(message);

        // clear events before calling aborts
        this._clearEvents();

        // abort the actual loading
        if (this.xhr) {
            this.xhr.abort();
        } else if (this.xdr) {
            this.xdr.abort();
        } else if (this.data) {
            // single source
            if (this.data.src) {
                this.data.src = Resource.EMPTY_GIF;
            }
            // multi-source
            else {
                    while (this.data.firstChild) {
                        this.data.removeChild(this.data.firstChild);
                    }
                }
        }

        // done now.
        this._finish();
    };

    /**
     * Kicks off loading of this resource. This method is asynchronous.
     *
     * @param {Resource.OnCompleteSignal} [cb] - Optional callback to call once the resource is loaded.
     */


    Resource.prototype.load = function load(cb) {
        var _this = this;

        if (this.isLoading) {
            return;
        }

        if (this.isComplete) {
            if (cb) {
                setTimeout(function () {
                    return cb(_this);
                }, 1);
            }

            return;
        } else if (cb) {
            this.onComplete.once(cb);
        }

        this._setFlag(Resource.STATUS_FLAGS.LOADING, true);

        this.onStart.dispatch(this);

        // if unset, determine the value
        if (this.crossOrigin === false || typeof this.crossOrigin !== 'string') {
            this.crossOrigin = this._determineCrossOrigin(this.url);
        }

        switch (this.loadType) {
            case Resource.LOAD_TYPE.IMAGE:
                this.type = Resource.TYPE.IMAGE;
                this._loadElement('image');
                break;

            case Resource.LOAD_TYPE.AUDIO:
                this.type = Resource.TYPE.AUDIO;
                this._loadSourceElement('audio');
                break;

            case Resource.LOAD_TYPE.VIDEO:
                this.type = Resource.TYPE.VIDEO;
                this._loadSourceElement('video');
                break;

            case Resource.LOAD_TYPE.XHR:
            /* falls through */
            default:
                if (useXdr && this.crossOrigin) {
                    this._loadXdr();
                } else {
                    this._loadXhr();
                }
                break;
        }
    };

    /**
     * Checks if the flag is set.
     *
     * @private
     * @param {number} flag - The flag to check.
     * @return {boolean} True if the flag is set.
     */


    Resource.prototype._hasFlag = function _hasFlag(flag) {
        return (this._flags & flag) !== 0;
    };

    /**
     * (Un)Sets the flag.
     *
     * @private
     * @param {number} flag - The flag to (un)set.
     * @param {boolean} value - Whether to set or (un)set the flag.
     */


    Resource.prototype._setFlag = function _setFlag(flag, value) {
        this._flags = value ? this._flags | flag : this._flags & ~flag;
    };

    /**
     * Clears all the events from the underlying loading source.
     *
     * @private
     */


    Resource.prototype._clearEvents = function _clearEvents() {
        clearTimeout(this._elementTimer);

        if (this.data && this.data.removeEventListener) {
            this.data.removeEventListener('error', this._boundOnError, false);
            this.data.removeEventListener('load', this._boundComplete, false);
            this.data.removeEventListener('progress', this._boundOnProgress, false);
            this.data.removeEventListener('canplaythrough', this._boundComplete, false);
        }

        if (this.xhr) {
            if (this.xhr.removeEventListener) {
                this.xhr.removeEventListener('error', this._boundXhrOnError, false);
                this.xhr.removeEventListener('timeout', this._boundXhrOnTimeout, false);
                this.xhr.removeEventListener('abort', this._boundXhrOnAbort, false);
                this.xhr.removeEventListener('progress', this._boundOnProgress, false);
                this.xhr.removeEventListener('load', this._boundXhrOnLoad, false);
            } else {
                this.xhr.onerror = null;
                this.xhr.ontimeout = null;
                this.xhr.onprogress = null;
                this.xhr.onload = null;
            }
        }
    };

    /**
     * Finalizes the load.
     *
     * @private
     */


    Resource.prototype._finish = function _finish() {
        if (this.isComplete) {
            throw new Error('Complete called again for an already completed resource.');
        }

        this._setFlag(Resource.STATUS_FLAGS.COMPLETE, true);
        this._setFlag(Resource.STATUS_FLAGS.LOADING, false);

        this.onComplete.dispatch(this);
    };

    /**
     * Loads this resources using an element that has a single source,
     * like an HTMLImageElement.
     *
     * @private
     * @param {string} type - The type of element to use.
     */


    Resource.prototype._loadElement = function _loadElement(type) {
        if (this.metadata.loadElement) {
            this.data = this.metadata.loadElement;
        } else if (type === 'image' && typeof window.Image !== 'undefined') {
            this.data = new Image();
        } else {
            this.data = document.createElement(type);
        }

        if (this.crossOrigin) {
            this.data.crossOrigin = this.crossOrigin;
        }

        if (!this.metadata.skipSource) {
            this.data.src = this.url;
        }

        this.data.addEventListener('error', this._boundOnError, false);
        this.data.addEventListener('load', this._boundComplete, false);
        this.data.addEventListener('progress', this._boundOnProgress, false);

        if (this.timeout) {
            this._elementTimer = setTimeout(this._boundOnTimeout, this.timeout);
        }
    };

    /**
     * Loads this resources using an element that has multiple sources,
     * like an HTMLAudioElement or HTMLVideoElement.
     *
     * @private
     * @param {string} type - The type of element to use.
     */


    Resource.prototype._loadSourceElement = function _loadSourceElement(type) {
        if (this.metadata.loadElement) {
            this.data = this.metadata.loadElement;
        } else if (type === 'audio' && typeof window.Audio !== 'undefined') {
            this.data = new Audio();
        } else {
            this.data = document.createElement(type);
        }

        if (this.data === null) {
            this.abort('Unsupported element: ' + type);

            return;
        }

        if (this.crossOrigin) {
            this.data.crossOrigin = this.crossOrigin;
        }

        if (!this.metadata.skipSource) {
            // support for CocoonJS Canvas+ runtime, lacks document.createElement('source')
            if (navigator.isCocoonJS) {
                this.data.src = Array.isArray(this.url) ? this.url[0] : this.url;
            } else if (Array.isArray(this.url)) {
                var mimeTypes = this.metadata.mimeType;

                for (var i = 0; i < this.url.length; ++i) {
                    this.data.appendChild(this._createSource(type, this.url[i], Array.isArray(mimeTypes) ? mimeTypes[i] : mimeTypes));
                }
            } else {
                var _mimeTypes = this.metadata.mimeType;

                this.data.appendChild(this._createSource(type, this.url, Array.isArray(_mimeTypes) ? _mimeTypes[0] : _mimeTypes));
            }
        }

        this.data.addEventListener('error', this._boundOnError, false);
        this.data.addEventListener('load', this._boundComplete, false);
        this.data.addEventListener('progress', this._boundOnProgress, false);
        this.data.addEventListener('canplaythrough', this._boundComplete, false);

        this.data.load();

        if (this.timeout) {
            this._elementTimer = setTimeout(this._boundOnTimeout, this.timeout);
        }
    };

    /**
     * Loads this resources using an XMLHttpRequest.
     *
     * @private
     */


    Resource.prototype._loadXhr = function _loadXhr() {
        // if unset, determine the value
        if (typeof this.xhrType !== 'string') {
            this.xhrType = this._determineXhrType();
        }

        var xhr = this.xhr = new XMLHttpRequest();

        // set the request type and url
        xhr.open('GET', this.url, true);

        xhr.timeout = this.timeout;

        // load json as text and parse it ourselves. We do this because some browsers
        // *cough* safari *cough* can't deal with it.
        if (this.xhrType === Resource.XHR_RESPONSE_TYPE.JSON || this.xhrType === Resource.XHR_RESPONSE_TYPE.DOCUMENT) {
            xhr.responseType = Resource.XHR_RESPONSE_TYPE.TEXT;
        } else {
            xhr.responseType = this.xhrType;
        }

        xhr.addEventListener('error', this._boundXhrOnError, false);
        xhr.addEventListener('timeout', this._boundXhrOnTimeout, false);
        xhr.addEventListener('abort', this._boundXhrOnAbort, false);
        xhr.addEventListener('progress', this._boundOnProgress, false);
        xhr.addEventListener('load', this._boundXhrOnLoad, false);

        xhr.send();
    };

    /**
     * Loads this resources using an XDomainRequest. This is here because we need to support IE9 (gross).
     *
     * @private
     */


    Resource.prototype._loadXdr = function _loadXdr() {
        // if unset, determine the value
        if (typeof this.xhrType !== 'string') {
            this.xhrType = this._determineXhrType();
        }

        var xdr = this.xhr = new XDomainRequest(); // eslint-disable-line no-undef

        // XDomainRequest has a few quirks. Occasionally it will abort requests
        // A way to avoid this is to make sure ALL callbacks are set even if not used
        // More info here: http://stackoverflow.com/questions/15786966/xdomainrequest-aborts-post-on-ie-9
        xdr.timeout = this.timeout || 5000; // XDR needs a timeout value or it breaks in IE9

        xdr.onerror = this._boundXhrOnError;
        xdr.ontimeout = this._boundXhrOnTimeout;
        xdr.onprogress = this._boundOnProgress;
        xdr.onload = this._boundXhrOnLoad;

        xdr.open('GET', this.url, true);

        // Note: The xdr.send() call is wrapped in a timeout to prevent an
        // issue with the interface where some requests are lost if multiple
        // XDomainRequests are being sent at the same time.
        // Some info here: https://github.com/photonstorm/phaser/issues/1248
        setTimeout(function () {
            return xdr.send();
        }, 1);
    };

    /**
     * Creates a source used in loading via an element.
     *
     * @private
     * @param {string} type - The element type (video or audio).
     * @param {string} url - The source URL to load from.
     * @param {string} [mime] - The mime type of the video
     * @return {HTMLSourceElement} The source element.
     */


    Resource.prototype._createSource = function _createSource(type, url, mime) {
        if (!mime) {
            mime = type + '/' + this._getExtension(url);
        }

        var source = document.createElement('source');

        source.src = url;
        source.type = mime;

        return source;
    };

    /**
     * Called if a load errors out.
     *
     * @param {Event} event - The error event from the element that emits it.
     * @private
     */


    Resource.prototype._onError = function _onError(event) {
        this.abort('Failed to load element using: ' + event.target.nodeName);
    };

    /**
     * Called if a load progress event fires for an element or xhr/xdr.
     *
     * @private
     * @param {XMLHttpRequestProgressEvent|Event} event - Progress event.
     */


    Resource.prototype._onProgress = function _onProgress(event) {
        if (event && event.lengthComputable) {
            this.onProgress.dispatch(this, event.loaded / event.total);
        }
    };

    /**
     * Called if a timeout event fires for an element.
     *
     * @private
     */


    Resource.prototype._onTimeout = function _onTimeout() {
        this.abort('Load timed out.');
    };

    /**
     * Called if an error event fires for xhr/xdr.
     *
     * @private
     */


    Resource.prototype._xhrOnError = function _xhrOnError() {
        var xhr = this.xhr;

        this.abort(reqType(xhr) + ' Request failed. Status: ' + xhr.status + ', text: "' + xhr.statusText + '"');
    };

    /**
     * Called if an error event fires for xhr/xdr.
     *
     * @private
     */


    Resource.prototype._xhrOnTimeout = function _xhrOnTimeout() {
        var xhr = this.xhr;

        this.abort(reqType(xhr) + ' Request timed out.');
    };

    /**
     * Called if an abort event fires for xhr/xdr.
     *
     * @private
     */


    Resource.prototype._xhrOnAbort = function _xhrOnAbort() {
        var xhr = this.xhr;

        this.abort(reqType(xhr) + ' Request was aborted by the user.');
    };

    /**
     * Called when data successfully loads from an xhr/xdr request.
     *
     * @private
     * @param {XMLHttpRequestLoadEvent|Event} event - Load event
     */


    Resource.prototype._xhrOnLoad = function _xhrOnLoad() {
        var xhr = this.xhr;
        var text = '';
        var status = typeof xhr.status === 'undefined' ? STATUS_OK : xhr.status; // XDR has no `.status`, assume 200.

        // responseText is accessible only if responseType is '' or 'text' and on older browsers
        if (xhr.responseType === '' || xhr.responseType === 'text' || typeof xhr.responseType === 'undefined') {
            text = xhr.responseText;
        }

        // status can be 0 when using the `file://` protocol so we also check if a response is set.
        // If it has a response, we assume 200; otherwise a 0 status code with no contents is an aborted request.
        if (status === STATUS_NONE && (text.length > 0 || xhr.responseType === Resource.XHR_RESPONSE_TYPE.BUFFER)) {
            status = STATUS_OK;
        }
        // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
        else if (status === STATUS_IE_BUG_EMPTY) {
                status = STATUS_EMPTY;
            }

        var statusType = status / 100 | 0;

        if (statusType === STATUS_TYPE_OK) {
            // if text, just return it
            if (this.xhrType === Resource.XHR_RESPONSE_TYPE.TEXT) {
                this.data = text;
                this.type = Resource.TYPE.TEXT;
            }
            // if json, parse into json object
            else if (this.xhrType === Resource.XHR_RESPONSE_TYPE.JSON) {
                    try {
                        this.data = JSON.parse(text);
                        this.type = Resource.TYPE.JSON;
                    } catch (e) {
                        this.abort('Error trying to parse loaded json: ' + e);

                        return;
                    }
                }
                // if xml, parse into an xml document or div element
                else if (this.xhrType === Resource.XHR_RESPONSE_TYPE.DOCUMENT) {
                        try {
                            if (window.DOMParser) {
                                var domparser = new DOMParser();

                                this.data = domparser.parseFromString(text, 'text/xml');
                            } else {
                                var div = document.createElement('div');

                                div.innerHTML = text;

                                this.data = div;
                            }

                            this.type = Resource.TYPE.XML;
                        } catch (e) {
                            this.abort('Error trying to parse loaded xml: ' + e);

                            return;
                        }
                    }
                    // other types just return the response
                    else {
                            this.data = xhr.response || text;
                        }
        } else {
            this.abort('[' + xhr.status + '] ' + xhr.statusText + ': ' + xhr.responseURL);

            return;
        }

        this.complete();
    };

    /**
     * Sets the `crossOrigin` property for this resource based on if the url
     * for this resource is cross-origin. If crossOrigin was manually set, this
     * function does nothing.
     *
     * @private
     * @param {string} url - The url to test.
     * @param {object} [loc=window.location] - The location object to test against.
     * @return {string} The crossOrigin value to use (or empty string for none).
     */


    Resource.prototype._determineCrossOrigin = function _determineCrossOrigin(url, loc) {
        // data: and javascript: urls are considered same-origin
        if (url.indexOf('data:') === 0) {
            return '';
        }

        // A sandboxed iframe without the 'allow-same-origin' attribute will have a special
        // origin designed not to match window.location.origin, and will always require
        // crossOrigin requests regardless of whether the location matches.
        if (window.origin !== window.location.origin) {
            return 'anonymous';
        }

        // default is window.location
        loc = loc || window.location;

        if (!tempAnchor) {
            tempAnchor = document.createElement('a');
        }

        // let the browser determine the full href for the url of this resource and then
        // parse with the node url lib, we can't use the properties of the anchor element
        // because they don't work in IE9 :(
        tempAnchor.href = url;
        url = (0, _parseUri2.default)(tempAnchor.href, { strictMode: true });

        var samePort = !url.port && loc.port === '' || url.port === loc.port;
        var protocol = url.protocol ? url.protocol + ':' : '';

        // if cross origin
        if (url.host !== loc.hostname || !samePort || protocol !== loc.protocol) {
            return 'anonymous';
        }

        return '';
    };

    /**
     * Determines the responseType of an XHR request based on the extension of the
     * resource being loaded.
     *
     * @private
     * @return {Resource.XHR_RESPONSE_TYPE} The responseType to use.
     */


    Resource.prototype._determineXhrType = function _determineXhrType() {
        return Resource._xhrTypeMap[this.extension] || Resource.XHR_RESPONSE_TYPE.TEXT;
    };

    /**
     * Determines the loadType of a resource based on the extension of the
     * resource being loaded.
     *
     * @private
     * @return {Resource.LOAD_TYPE} The loadType to use.
     */


    Resource.prototype._determineLoadType = function _determineLoadType() {
        return Resource._loadTypeMap[this.extension] || Resource.LOAD_TYPE.XHR;
    };

    /**
     * Extracts the extension (sans '.') of the file being loaded by the resource.
     *
     * @private
     * @return {string} The extension.
     */


    Resource.prototype._getExtension = function _getExtension() {
        var url = this.url;
        var ext = '';

        if (this.isDataUrl) {
            var slashIndex = url.indexOf('/');

            ext = url.substring(slashIndex + 1, url.indexOf(';', slashIndex));
        } else {
            var queryStart = url.indexOf('?');
            var hashStart = url.indexOf('#');
            var index = Math.min(queryStart > -1 ? queryStart : url.length, hashStart > -1 ? hashStart : url.length);

            url = url.substring(0, index);
            ext = url.substring(url.lastIndexOf('.') + 1);
        }

        return ext.toLowerCase();
    };

    /**
     * Determines the mime type of an XHR request based on the responseType of
     * resource being loaded.
     *
     * @private
     * @param {Resource.XHR_RESPONSE_TYPE} type - The type to get a mime type for.
     * @return {string} The mime type to use.
     */


    Resource.prototype._getMimeFromXhrType = function _getMimeFromXhrType(type) {
        switch (type) {
            case Resource.XHR_RESPONSE_TYPE.BUFFER:
                return 'application/octet-binary';

            case Resource.XHR_RESPONSE_TYPE.BLOB:
                return 'application/blob';

            case Resource.XHR_RESPONSE_TYPE.DOCUMENT:
                return 'application/xml';

            case Resource.XHR_RESPONSE_TYPE.JSON:
                return 'application/json';

            case Resource.XHR_RESPONSE_TYPE.DEFAULT:
            case Resource.XHR_RESPONSE_TYPE.TEXT:
            /* falls through */
            default:
                return 'text/plain';
        }
    };

    _createClass(Resource, [{
        key: 'isDataUrl',
        get: function get() {
            return this._hasFlag(Resource.STATUS_FLAGS.DATA_URL);
        }

        /**
         * Describes if this resource has finished loading. Is true when the resource has completely
         * loaded.
         *
         * @readonly
         * @member {boolean}
         */

    }, {
        key: 'isComplete',
        get: function get() {
            return this._hasFlag(Resource.STATUS_FLAGS.COMPLETE);
        }

        /**
         * Describes if this resource is currently loading. Is true when the resource starts loading,
         * and is false again when complete.
         *
         * @readonly
         * @member {boolean}
         */

    }, {
        key: 'isLoading',
        get: function get() {
            return this._hasFlag(Resource.STATUS_FLAGS.LOADING);
        }
    }]);

    return Resource;
}();

/**
 * The types of resources a resource could represent.
 *
 * @static
 * @readonly
 * @enum {number}
 */


Resource.STATUS_FLAGS = {
    NONE: 0,
    DATA_URL: 1 << 0,
    COMPLETE: 1 << 1,
    LOADING: 1 << 2
};

/**
 * The types of resources a resource could represent.
 *
 * @static
 * @readonly
 * @enum {number}
 */
Resource.TYPE = {
    UNKNOWN: 0,
    JSON: 1,
    XML: 2,
    IMAGE: 3,
    AUDIO: 4,
    VIDEO: 5,
    TEXT: 6
};

/**
 * The types of loading a resource can use.
 *
 * @static
 * @readonly
 * @enum {number}
 */
Resource.LOAD_TYPE = {
    /** Uses XMLHttpRequest to load the resource. */
    XHR: 1,
    /** Uses an `Image` object to load the resource. */
    IMAGE: 2,
    /** Uses an `Audio` object to load the resource. */
    AUDIO: 3,
    /** Uses a `Video` object to load the resource. */
    VIDEO: 4
};

/**
 * The XHR ready states, used internally.
 *
 * @static
 * @readonly
 * @enum {string}
 */
Resource.XHR_RESPONSE_TYPE = {
    /** string */
    DEFAULT: 'text',
    /** ArrayBuffer */
    BUFFER: 'arraybuffer',
    /** Blob */
    BLOB: 'blob',
    /** Document */
    DOCUMENT: 'document',
    /** Object */
    JSON: 'json',
    /** String */
    TEXT: 'text'
};

Resource._loadTypeMap = {
    // images
    gif: Resource.LOAD_TYPE.IMAGE,
    png: Resource.LOAD_TYPE.IMAGE,
    bmp: Resource.LOAD_TYPE.IMAGE,
    jpg: Resource.LOAD_TYPE.IMAGE,
    jpeg: Resource.LOAD_TYPE.IMAGE,
    tif: Resource.LOAD_TYPE.IMAGE,
    tiff: Resource.LOAD_TYPE.IMAGE,
    webp: Resource.LOAD_TYPE.IMAGE,
    tga: Resource.LOAD_TYPE.IMAGE,
    svg: Resource.LOAD_TYPE.IMAGE,
    'svg+xml': Resource.LOAD_TYPE.IMAGE, // for SVG data urls

    // audio
    mp3: Resource.LOAD_TYPE.AUDIO,
    ogg: Resource.LOAD_TYPE.AUDIO,
    wav: Resource.LOAD_TYPE.AUDIO,

    // videos
    mp4: Resource.LOAD_TYPE.VIDEO,
    webm: Resource.LOAD_TYPE.VIDEO
};

Resource._xhrTypeMap = {
    // xml
    xhtml: Resource.XHR_RESPONSE_TYPE.DOCUMENT,
    html: Resource.XHR_RESPONSE_TYPE.DOCUMENT,
    htm: Resource.XHR_RESPONSE_TYPE.DOCUMENT,
    xml: Resource.XHR_RESPONSE_TYPE.DOCUMENT,
    tmx: Resource.XHR_RESPONSE_TYPE.DOCUMENT,
    svg: Resource.XHR_RESPONSE_TYPE.DOCUMENT,

    // This was added to handle Tiled Tileset XML, but .tsx is also a TypeScript React Component.
    // Since it is way less likely for people to be loading TypeScript files instead of Tiled files,
    // this should probably be fine.
    tsx: Resource.XHR_RESPONSE_TYPE.DOCUMENT,

    // images
    gif: Resource.XHR_RESPONSE_TYPE.BLOB,
    png: Resource.XHR_RESPONSE_TYPE.BLOB,
    bmp: Resource.XHR_RESPONSE_TYPE.BLOB,
    jpg: Resource.XHR_RESPONSE_TYPE.BLOB,
    jpeg: Resource.XHR_RESPONSE_TYPE.BLOB,
    tif: Resource.XHR_RESPONSE_TYPE.BLOB,
    tiff: Resource.XHR_RESPONSE_TYPE.BLOB,
    webp: Resource.XHR_RESPONSE_TYPE.BLOB,
    tga: Resource.XHR_RESPONSE_TYPE.BLOB,

    // json
    json: Resource.XHR_RESPONSE_TYPE.JSON,

    // text
    text: Resource.XHR_RESPONSE_TYPE.TEXT,
    txt: Resource.XHR_RESPONSE_TYPE.TEXT,

    // fonts
    ttf: Resource.XHR_RESPONSE_TYPE.BUFFER,
    otf: Resource.XHR_RESPONSE_TYPE.BUFFER
};

// We can't set the `src` attribute to empty string, so on abort we set it to this 1px transparent gif
Resource.EMPTY_GIF = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';

/**
 * Quick helper to set a value on one of the extension maps. Ensures there is no
 * dot at the start of the extension.
 *
 * @ignore
 * @param {object} map - The map to set on.
 * @param {string} extname - The extension (or key) to set.
 * @param {number} val - The value to set.
 */
function setExtMap(map, extname, val) {
    if (extname && extname.indexOf('.') === 0) {
        extname = extname.substring(1);
    }

    if (!extname) {
        return;
    }

    map[extname] = val;
}

/**
 * Quick helper to get string xhr type.
 *
 * @ignore
 * @param {XMLHttpRequest|XDomainRequest} xhr - The request to check.
 * @return {string} The type.
 */
function reqType(xhr) {
    return xhr.toString().replace('object ', '');
}

// Backwards compat
if (true) {
    module.exports.default = Resource; // eslint-disable-line no-undef
}
//# sourceMappingURL=Resource.js.map

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _core = __webpack_require__(7);

var core = _interopRequireWildcard(_core);

var _CountLimiter = __webpack_require__(219);

var _CountLimiter2 = _interopRequireDefault(_CountLimiter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SharedTicker = core.ticker.shared;

/**
 * Default number of uploads per frame using prepare plugin.
 *
 * @static
 * @memberof PIXI.settings
 * @name UPLOADS_PER_FRAME
 * @type {number}
 * @default 4
 */
core.settings.UPLOADS_PER_FRAME = 4;

/**
 * The prepare manager provides functionality to upload content to the GPU. BasePrepare handles
 * basic queuing functionality and is extended by {@link PIXI.prepare.WebGLPrepare} and {@link PIXI.prepare.CanvasPrepare}
 * to provide preparation capabilities specific to their respective renderers.
 *
 * @example
 * // Create a sprite
 * const sprite = new PIXI.Sprite.fromImage('something.png');
 *
 * // Load object into GPU
 * app.renderer.plugins.prepare.upload(sprite, () => {
 *
 *     //Texture(s) has been uploaded to GPU
 *     app.stage.addChild(sprite);
 *
 * })
 *
 * @abstract
 * @class
 * @memberof PIXI.prepare
 */

var BasePrepare = function () {
    /**
     * @param {PIXI.SystemRenderer} renderer - A reference to the current renderer
     */
    function BasePrepare(renderer) {
        var _this = this;

        _classCallCheck(this, BasePrepare);

        /**
         * The limiter to be used to control how quickly items are prepared.
         * @type {PIXI.prepare.CountLimiter|PIXI.prepare.TimeLimiter}
         */
        this.limiter = new _CountLimiter2.default(core.settings.UPLOADS_PER_FRAME);

        /**
         * Reference to the renderer.
         * @type {PIXI.SystemRenderer}
         * @protected
         */
        this.renderer = renderer;

        /**
         * The only real difference between CanvasPrepare and WebGLPrepare is what they pass
         * to upload hooks. That different parameter is stored here.
         * @type {PIXI.prepare.CanvasPrepare|PIXI.WebGLRenderer}
         * @protected
         */
        this.uploadHookHelper = null;

        /**
         * Collection of items to uploads at once.
         * @type {Array<*>}
         * @private
         */
        this.queue = [];

        /**
         * Collection of additional hooks for finding assets.
         * @type {Array<Function>}
         * @private
         */
        this.addHooks = [];

        /**
         * Collection of additional hooks for processing assets.
         * @type {Array<Function>}
         * @private
         */
        this.uploadHooks = [];

        /**
         * Callback to call after completed.
         * @type {Array<Function>}
         * @private
         */
        this.completes = [];

        /**
         * If prepare is ticking (running).
         * @type {boolean}
         * @private
         */
        this.ticking = false;

        /**
         * 'bound' call for prepareItems().
         * @type {Function}
         * @private
         */
        this.delayedTick = function () {
            // unlikely, but in case we were destroyed between tick() and delayedTick()
            if (!_this.queue) {
                return;
            }
            _this.prepareItems();
        };

        // hooks to find the correct texture
        this.registerFindHook(findText);
        this.registerFindHook(findTextStyle);
        this.registerFindHook(findMultipleBaseTextures);
        this.registerFindHook(findBaseTexture);
        this.registerFindHook(findTexture);

        // upload hooks
        this.registerUploadHook(drawText);
        this.registerUploadHook(calculateTextStyle);
    }

    /**
     * Upload all the textures and graphics to the GPU.
     *
     * @param {Function|PIXI.DisplayObject|PIXI.Container|PIXI.BaseTexture|PIXI.Texture|PIXI.Graphics|PIXI.Text} item -
     *        Either the container or display object to search for items to upload, the items to upload themselves,
     *        or the callback function, if items have been added using `prepare.add`.
     * @param {Function} [done] - Optional callback when all queued uploads have completed
     */


    BasePrepare.prototype.upload = function upload(item, done) {
        if (typeof item === 'function') {
            done = item;
            item = null;
        }

        // If a display object, search for items
        // that we could upload
        if (item) {
            this.add(item);
        }

        // Get the items for upload from the display
        if (this.queue.length) {
            if (done) {
                this.completes.push(done);
            }

            if (!this.ticking) {
                this.ticking = true;
                SharedTicker.addOnce(this.tick, this, core.UPDATE_PRIORITY.UTILITY);
            }
        } else if (done) {
            done();
        }
    };

    /**
     * Handle tick update
     *
     * @private
     */


    BasePrepare.prototype.tick = function tick() {
        setTimeout(this.delayedTick, 0);
    };

    /**
     * Actually prepare items. This is handled outside of the tick because it will take a while
     * and we do NOT want to block the current animation frame from rendering.
     *
     * @private
     */


    BasePrepare.prototype.prepareItems = function prepareItems() {
        this.limiter.beginFrame();
        // Upload the graphics
        while (this.queue.length && this.limiter.allowedToUpload()) {
            var item = this.queue[0];
            var uploaded = false;

            if (item && !item._destroyed) {
                for (var i = 0, len = this.uploadHooks.length; i < len; i++) {
                    if (this.uploadHooks[i](this.uploadHookHelper, item)) {
                        this.queue.shift();
                        uploaded = true;
                        break;
                    }
                }
            }

            if (!uploaded) {
                this.queue.shift();
            }
        }

        // We're finished
        if (!this.queue.length) {
            this.ticking = false;

            var completes = this.completes.slice(0);

            this.completes.length = 0;

            for (var _i = 0, _len = completes.length; _i < _len; _i++) {
                completes[_i]();
            }
        } else {
            // if we are not finished, on the next rAF do this again
            SharedTicker.addOnce(this.tick, this, core.UPDATE_PRIORITY.UTILITY);
        }
    };

    /**
     * Adds hooks for finding items.
     *
     * @param {Function} addHook - Function call that takes two parameters: `item:*, queue:Array`
     *          function must return `true` if it was able to add item to the queue.
     * @return {PIXI.BasePrepare} Instance of plugin for chaining.
     */


    BasePrepare.prototype.registerFindHook = function registerFindHook(addHook) {
        if (addHook) {
            this.addHooks.push(addHook);
        }

        return this;
    };

    /**
     * Adds hooks for uploading items.
     *
     * @param {Function} uploadHook - Function call that takes two parameters: `prepare:CanvasPrepare, item:*` and
     *          function must return `true` if it was able to handle upload of item.
     * @return {PIXI.BasePrepare} Instance of plugin for chaining.
     */


    BasePrepare.prototype.registerUploadHook = function registerUploadHook(uploadHook) {
        if (uploadHook) {
            this.uploadHooks.push(uploadHook);
        }

        return this;
    };

    /**
     * Manually add an item to the uploading queue.
     *
     * @param {PIXI.DisplayObject|PIXI.Container|PIXI.BaseTexture|PIXI.Texture|PIXI.Graphics|PIXI.Text|*} item - Object to
     *        add to the queue
     * @return {PIXI.CanvasPrepare} Instance of plugin for chaining.
     */


    BasePrepare.prototype.add = function add(item) {
        // Add additional hooks for finding elements on special
        // types of objects that
        for (var i = 0, len = this.addHooks.length; i < len; i++) {
            if (this.addHooks[i](item, this.queue)) {
                break;
            }
        }

        // Get childen recursively
        if (item instanceof core.Container) {
            for (var _i2 = item.children.length - 1; _i2 >= 0; _i2--) {
                this.add(item.children[_i2]);
            }
        }

        return this;
    };

    /**
     * Destroys the plugin, don't use after this.
     *
     */


    BasePrepare.prototype.destroy = function destroy() {
        if (this.ticking) {
            SharedTicker.remove(this.tick, this);
        }
        this.ticking = false;
        this.addHooks = null;
        this.uploadHooks = null;
        this.renderer = null;
        this.completes = null;
        this.queue = null;
        this.limiter = null;
        this.uploadHookHelper = null;
    };

    return BasePrepare;
}();

/**
 * Built-in hook to find multiple textures from objects like AnimatedSprites.
 *
 * @private
 * @param {PIXI.DisplayObject} item - Display object to check
 * @param {Array<*>} queue - Collection of items to upload
 * @return {boolean} if a PIXI.Texture object was found.
 */


exports.default = BasePrepare;
function findMultipleBaseTextures(item, queue) {
    var result = false;

    // Objects with mutliple textures
    if (item && item._textures && item._textures.length) {
        for (var i = 0; i < item._textures.length; i++) {
            if (item._textures[i] instanceof core.Texture) {
                var baseTexture = item._textures[i].baseTexture;

                if (queue.indexOf(baseTexture) === -1) {
                    queue.push(baseTexture);
                    result = true;
                }
            }
        }
    }

    return result;
}

/**
 * Built-in hook to find BaseTextures from Sprites.
 *
 * @private
 * @param {PIXI.DisplayObject} item - Display object to check
 * @param {Array<*>} queue - Collection of items to upload
 * @return {boolean} if a PIXI.Texture object was found.
 */
function findBaseTexture(item, queue) {
    // Objects with textures, like Sprites/Text
    if (item instanceof core.BaseTexture) {
        if (queue.indexOf(item) === -1) {
            queue.push(item);
        }

        return true;
    }

    return false;
}

/**
 * Built-in hook to find textures from objects.
 *
 * @private
 * @param {PIXI.DisplayObject} item - Display object to check
 * @param {Array<*>} queue - Collection of items to upload
 * @return {boolean} if a PIXI.Texture object was found.
 */
function findTexture(item, queue) {
    if (item._texture && item._texture instanceof core.Texture) {
        var texture = item._texture.baseTexture;

        if (queue.indexOf(texture) === -1) {
            queue.push(texture);
        }

        return true;
    }

    return false;
}

/**
 * Built-in hook to draw PIXI.Text to its texture.
 *
 * @private
 * @param {PIXI.WebGLRenderer|PIXI.CanvasPrepare} helper - Not used by this upload handler
 * @param {PIXI.DisplayObject} item - Item to check
 * @return {boolean} If item was uploaded.
 */
function drawText(helper, item) {
    if (item instanceof core.Text) {
        // updating text will return early if it is not dirty
        item.updateText(true);

        return true;
    }

    return false;
}

/**
 * Built-in hook to calculate a text style for a PIXI.Text object.
 *
 * @private
 * @param {PIXI.WebGLRenderer|PIXI.CanvasPrepare} helper - Not used by this upload handler
 * @param {PIXI.DisplayObject} item - Item to check
 * @return {boolean} If item was uploaded.
 */
function calculateTextStyle(helper, item) {
    if (item instanceof core.TextStyle) {
        var font = item.toFontString();

        core.TextMetrics.measureFont(font);

        return true;
    }

    return false;
}

/**
 * Built-in hook to find Text objects.
 *
 * @private
 * @param {PIXI.DisplayObject} item - Display object to check
 * @param {Array<*>} queue - Collection of items to upload
 * @return {boolean} if a PIXI.Text object was found.
 */
function findText(item, queue) {
    if (item instanceof core.Text) {
        // push the text style to prepare it - this can be really expensive
        if (queue.indexOf(item.style) === -1) {
            queue.push(item.style);
        }
        // also push the text object so that we can render it (to canvas/texture) if needed
        if (queue.indexOf(item) === -1) {
            queue.push(item);
        }
        // also push the Text's texture for upload to GPU
        var texture = item._texture.baseTexture;

        if (queue.indexOf(texture) === -1) {
            queue.push(texture);
        }

        return true;
    }

    return false;
}

/**
 * Built-in hook to find TextStyle objects.
 *
 * @private
 * @param {PIXI.TextStyle} item - Display object to check
 * @param {Array<*>} queue - Collection of items to upload
 * @return {boolean} if a PIXI.TextStyle object was found.
 */
function findTextStyle(item, queue) {
    if (item instanceof core.TextStyle) {
        if (queue.indexOf(item) === -1) {
            queue.push(item);
        }

        return true;
    }

    return false;
}
//# sourceMappingURL=BasePrepare.js.map

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {/*! *****************************************************************************
Copyright (C) Microsoft. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var Reflect;
(function (Reflect) {
    // Metadata Proposal
    // https://rbuckton.github.io/reflect-metadata/
    (function (factory) {
        var root = typeof global === "object" ? global :
            typeof self === "object" ? self :
                typeof this === "object" ? this :
                    Function("return this;")();
        var exporter = makeExporter(Reflect);
        if (typeof root.Reflect === "undefined") {
            root.Reflect = Reflect;
        }
        else {
            exporter = makeExporter(root.Reflect, exporter);
        }
        factory(exporter);
        function makeExporter(target, previous) {
            return function (key, value) {
                if (typeof target[key] !== "function") {
                    Object.defineProperty(target, key, { configurable: true, writable: true, value: value });
                }
                if (previous)
                    previous(key, value);
            };
        }
    })(function (exporter) {
        var hasOwn = Object.prototype.hasOwnProperty;
        // feature test for Symbol support
        var supportsSymbol = typeof Symbol === "function";
        var toPrimitiveSymbol = supportsSymbol && typeof Symbol.toPrimitive !== "undefined" ? Symbol.toPrimitive : "@@toPrimitive";
        var iteratorSymbol = supportsSymbol && typeof Symbol.iterator !== "undefined" ? Symbol.iterator : "@@iterator";
        var supportsCreate = typeof Object.create === "function"; // feature test for Object.create support
        var supportsProto = { __proto__: [] } instanceof Array; // feature test for __proto__ support
        var downLevel = !supportsCreate && !supportsProto;
        var HashMap = {
            // create an object in dictionary mode (a.k.a. "slow" mode in v8)
            create: supportsCreate
                ? function () { return MakeDictionary(Object.create(null)); }
                : supportsProto
                    ? function () { return MakeDictionary({ __proto__: null }); }
                    : function () { return MakeDictionary({}); },
            has: downLevel
                ? function (map, key) { return hasOwn.call(map, key); }
                : function (map, key) { return key in map; },
            get: downLevel
                ? function (map, key) { return hasOwn.call(map, key) ? map[key] : undefined; }
                : function (map, key) { return map[key]; },
        };
        // Load global or shim versions of Map, Set, and WeakMap
        var functionPrototype = Object.getPrototypeOf(Function);
        var usePolyfill = typeof process === "object" && process.env && process.env["REFLECT_METADATA_USE_MAP_POLYFILL"] === "true";
        var _Map = !usePolyfill && typeof Map === "function" && typeof Map.prototype.entries === "function" ? Map : CreateMapPolyfill();
        var _Set = !usePolyfill && typeof Set === "function" && typeof Set.prototype.entries === "function" ? Set : CreateSetPolyfill();
        var _WeakMap = !usePolyfill && typeof WeakMap === "function" ? WeakMap : CreateWeakMapPolyfill();
        // [[Metadata]] internal slot
        // https://rbuckton.github.io/reflect-metadata/#ordinary-object-internal-methods-and-internal-slots
        var Metadata = new _WeakMap();
        /**
         * Applies a set of decorators to a property of a target object.
         * @param decorators An array of decorators.
         * @param target The target object.
         * @param propertyKey (Optional) The property key to decorate.
         * @param attributes (Optional) The property descriptor for the target key.
         * @remarks Decorators are applied in reverse order.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     Example = Reflect.decorate(decoratorsArray, Example);
         *
         *     // property (on constructor)
         *     Reflect.decorate(decoratorsArray, Example, "staticProperty");
         *
         *     // property (on prototype)
         *     Reflect.decorate(decoratorsArray, Example.prototype, "property");
         *
         *     // method (on constructor)
         *     Object.defineProperty(Example, "staticMethod",
         *         Reflect.decorate(decoratorsArray, Example, "staticMethod",
         *             Object.getOwnPropertyDescriptor(Example, "staticMethod")));
         *
         *     // method (on prototype)
         *     Object.defineProperty(Example.prototype, "method",
         *         Reflect.decorate(decoratorsArray, Example.prototype, "method",
         *             Object.getOwnPropertyDescriptor(Example.prototype, "method")));
         *
         */
        function decorate(decorators, target, propertyKey, attributes) {
            if (!IsUndefined(propertyKey)) {
                if (!IsArray(decorators))
                    throw new TypeError();
                if (!IsObject(target))
                    throw new TypeError();
                if (!IsObject(attributes) && !IsUndefined(attributes) && !IsNull(attributes))
                    throw new TypeError();
                if (IsNull(attributes))
                    attributes = undefined;
                propertyKey = ToPropertyKey(propertyKey);
                return DecorateProperty(decorators, target, propertyKey, attributes);
            }
            else {
                if (!IsArray(decorators))
                    throw new TypeError();
                if (!IsConstructor(target))
                    throw new TypeError();
                return DecorateConstructor(decorators, target);
            }
        }
        exporter("decorate", decorate);
        // 4.1.2 Reflect.metadata(metadataKey, metadataValue)
        // https://rbuckton.github.io/reflect-metadata/#reflect.metadata
        /**
         * A default metadata decorator factory that can be used on a class, class member, or parameter.
         * @param metadataKey The key for the metadata entry.
         * @param metadataValue The value for the metadata entry.
         * @returns A decorator function.
         * @remarks
         * If `metadataKey` is already defined for the target and target key, the
         * metadataValue for that key will be overwritten.
         * @example
         *
         *     // constructor
         *     @Reflect.metadata(key, value)
         *     class Example {
         *     }
         *
         *     // property (on constructor, TypeScript only)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         static staticProperty;
         *     }
         *
         *     // property (on prototype, TypeScript only)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         property;
         *     }
         *
         *     // method (on constructor)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         static staticMethod() { }
         *     }
         *
         *     // method (on prototype)
         *     class Example {
         *         @Reflect.metadata(key, value)
         *         method() { }
         *     }
         *
         */
        function metadata(metadataKey, metadataValue) {
            function decorator(target, propertyKey) {
                if (!IsObject(target))
                    throw new TypeError();
                if (!IsUndefined(propertyKey) && !IsPropertyKey(propertyKey))
                    throw new TypeError();
                OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
            }
            return decorator;
        }
        exporter("metadata", metadata);
        /**
         * Define a unique metadata entry on the target.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param metadataValue A value that contains attached metadata.
         * @param target The target object on which to define metadata.
         * @param propertyKey (Optional) The property key for the target.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     Reflect.defineMetadata("custom:annotation", options, Example);
         *
         *     // property (on constructor)
         *     Reflect.defineMetadata("custom:annotation", options, Example, "staticProperty");
         *
         *     // property (on prototype)
         *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "property");
         *
         *     // method (on constructor)
         *     Reflect.defineMetadata("custom:annotation", options, Example, "staticMethod");
         *
         *     // method (on prototype)
         *     Reflect.defineMetadata("custom:annotation", options, Example.prototype, "method");
         *
         *     // decorator factory as metadata-producing annotation.
         *     function MyAnnotation(options): Decorator {
         *         return (target, key?) => Reflect.defineMetadata("custom:annotation", options, target, key);
         *     }
         *
         */
        function defineMetadata(metadataKey, metadataValue, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryDefineOwnMetadata(metadataKey, metadataValue, target, propertyKey);
        }
        exporter("defineMetadata", defineMetadata);
        /**
         * Gets a value indicating whether the target object or its prototype chain has the provided metadata key defined.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata key was defined on the target object or its prototype chain; otherwise, `false`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.hasMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.hasMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.hasMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.hasMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function hasMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryHasMetadata(metadataKey, target, propertyKey);
        }
        exporter("hasMetadata", hasMetadata);
        /**
         * Gets a value indicating whether the target object has the provided metadata key defined.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata key was defined on the target object; otherwise, `false`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.hasOwnMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function hasOwnMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryHasOwnMetadata(metadataKey, target, propertyKey);
        }
        exporter("hasOwnMetadata", hasOwnMetadata);
        /**
         * Gets the metadata value for the provided metadata key on the target object or its prototype chain.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function getMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryGetMetadata(metadataKey, target, propertyKey);
        }
        exporter("getMetadata", getMetadata);
        /**
         * Gets the metadata value for the provided metadata key on the target object.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns The metadata value for the metadata key if found; otherwise, `undefined`.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getOwnMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getOwnMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function getOwnMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryGetOwnMetadata(metadataKey, target, propertyKey);
        }
        exporter("getOwnMetadata", getOwnMetadata);
        /**
         * Gets the metadata keys defined on the target object or its prototype chain.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns An array of unique metadata keys.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getMetadataKeys(Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getMetadataKeys(Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getMetadataKeys(Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getMetadataKeys(Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getMetadataKeys(Example.prototype, "method");
         *
         */
        function getMetadataKeys(target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryMetadataKeys(target, propertyKey);
        }
        exporter("getMetadataKeys", getMetadataKeys);
        /**
         * Gets the unique metadata keys defined on the target object.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns An array of unique metadata keys.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.getOwnMetadataKeys(Example);
         *
         *     // property (on constructor)
         *     result = Reflect.getOwnMetadataKeys(Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.getOwnMetadataKeys(Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.getOwnMetadataKeys(Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.getOwnMetadataKeys(Example.prototype, "method");
         *
         */
        function getOwnMetadataKeys(target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            return OrdinaryOwnMetadataKeys(target, propertyKey);
        }
        exporter("getOwnMetadataKeys", getOwnMetadataKeys);
        /**
         * Deletes the metadata entry from the target object with the provided key.
         * @param metadataKey A key used to store and retrieve metadata.
         * @param target The target object on which the metadata is defined.
         * @param propertyKey (Optional) The property key for the target.
         * @returns `true` if the metadata entry was found and deleted; otherwise, false.
         * @example
         *
         *     class Example {
         *         // property declarations are not part of ES6, though they are valid in TypeScript:
         *         // static staticProperty;
         *         // property;
         *
         *         constructor(p) { }
         *         static staticMethod(p) { }
         *         method(p) { }
         *     }
         *
         *     // constructor
         *     result = Reflect.deleteMetadata("custom:annotation", Example);
         *
         *     // property (on constructor)
         *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticProperty");
         *
         *     // property (on prototype)
         *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "property");
         *
         *     // method (on constructor)
         *     result = Reflect.deleteMetadata("custom:annotation", Example, "staticMethod");
         *
         *     // method (on prototype)
         *     result = Reflect.deleteMetadata("custom:annotation", Example.prototype, "method");
         *
         */
        function deleteMetadata(metadataKey, target, propertyKey) {
            if (!IsObject(target))
                throw new TypeError();
            if (!IsUndefined(propertyKey))
                propertyKey = ToPropertyKey(propertyKey);
            var metadataMap = GetOrCreateMetadataMap(target, propertyKey, /*Create*/ false);
            if (IsUndefined(metadataMap))
                return false;
            if (!metadataMap.delete(metadataKey))
                return false;
            if (metadataMap.size > 0)
                return true;
            var targetMetadata = Metadata.get(target);
            targetMetadata.delete(propertyKey);
            if (targetMetadata.size > 0)
                return true;
            Metadata.delete(target);
            return true;
        }
        exporter("deleteMetadata", deleteMetadata);
        function DecorateConstructor(decorators, target) {
            for (var i = decorators.length - 1; i >= 0; --i) {
                var decorator = decorators[i];
                var decorated = decorator(target);
                if (!IsUndefined(decorated) && !IsNull(decorated)) {
                    if (!IsConstructor(decorated))
                        throw new TypeError();
                    target = decorated;
                }
            }
            return target;
        }
        function DecorateProperty(decorators, target, propertyKey, descriptor) {
            for (var i = decorators.length - 1; i >= 0; --i) {
                var decorator = decorators[i];
                var decorated = decorator(target, propertyKey, descriptor);
                if (!IsUndefined(decorated) && !IsNull(decorated)) {
                    if (!IsObject(decorated))
                        throw new TypeError();
                    descriptor = decorated;
                }
            }
            return descriptor;
        }
        function GetOrCreateMetadataMap(O, P, Create) {
            var targetMetadata = Metadata.get(O);
            if (IsUndefined(targetMetadata)) {
                if (!Create)
                    return undefined;
                targetMetadata = new _Map();
                Metadata.set(O, targetMetadata);
            }
            var metadataMap = targetMetadata.get(P);
            if (IsUndefined(metadataMap)) {
                if (!Create)
                    return undefined;
                metadataMap = new _Map();
                targetMetadata.set(P, metadataMap);
            }
            return metadataMap;
        }
        // 3.1.1.1 OrdinaryHasMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryhasmetadata
        function OrdinaryHasMetadata(MetadataKey, O, P) {
            var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
            if (hasOwn)
                return true;
            var parent = OrdinaryGetPrototypeOf(O);
            if (!IsNull(parent))
                return OrdinaryHasMetadata(MetadataKey, parent, P);
            return false;
        }
        // 3.1.2.1 OrdinaryHasOwnMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryhasownmetadata
        function OrdinaryHasOwnMetadata(MetadataKey, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
            if (IsUndefined(metadataMap))
                return false;
            return ToBoolean(metadataMap.has(MetadataKey));
        }
        // 3.1.3.1 OrdinaryGetMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarygetmetadata
        function OrdinaryGetMetadata(MetadataKey, O, P) {
            var hasOwn = OrdinaryHasOwnMetadata(MetadataKey, O, P);
            if (hasOwn)
                return OrdinaryGetOwnMetadata(MetadataKey, O, P);
            var parent = OrdinaryGetPrototypeOf(O);
            if (!IsNull(parent))
                return OrdinaryGetMetadata(MetadataKey, parent, P);
            return undefined;
        }
        // 3.1.4.1 OrdinaryGetOwnMetadata(MetadataKey, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarygetownmetadata
        function OrdinaryGetOwnMetadata(MetadataKey, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
            if (IsUndefined(metadataMap))
                return undefined;
            return metadataMap.get(MetadataKey);
        }
        // 3.1.5.1 OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarydefineownmetadata
        function OrdinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P) {
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ true);
            metadataMap.set(MetadataKey, MetadataValue);
        }
        // 3.1.6.1 OrdinaryMetadataKeys(O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinarymetadatakeys
        function OrdinaryMetadataKeys(O, P) {
            var ownKeys = OrdinaryOwnMetadataKeys(O, P);
            var parent = OrdinaryGetPrototypeOf(O);
            if (parent === null)
                return ownKeys;
            var parentKeys = OrdinaryMetadataKeys(parent, P);
            if (parentKeys.length <= 0)
                return ownKeys;
            if (ownKeys.length <= 0)
                return parentKeys;
            var set = new _Set();
            var keys = [];
            for (var _i = 0, ownKeys_1 = ownKeys; _i < ownKeys_1.length; _i++) {
                var key = ownKeys_1[_i];
                var hasKey = set.has(key);
                if (!hasKey) {
                    set.add(key);
                    keys.push(key);
                }
            }
            for (var _a = 0, parentKeys_1 = parentKeys; _a < parentKeys_1.length; _a++) {
                var key = parentKeys_1[_a];
                var hasKey = set.has(key);
                if (!hasKey) {
                    set.add(key);
                    keys.push(key);
                }
            }
            return keys;
        }
        // 3.1.7.1 OrdinaryOwnMetadataKeys(O, P)
        // https://rbuckton.github.io/reflect-metadata/#ordinaryownmetadatakeys
        function OrdinaryOwnMetadataKeys(O, P) {
            var keys = [];
            var metadataMap = GetOrCreateMetadataMap(O, P, /*Create*/ false);
            if (IsUndefined(metadataMap))
                return keys;
            var keysObj = metadataMap.keys();
            var iterator = GetIterator(keysObj);
            var k = 0;
            while (true) {
                var next = IteratorStep(iterator);
                if (!next) {
                    keys.length = k;
                    return keys;
                }
                var nextValue = IteratorValue(next);
                try {
                    keys[k] = nextValue;
                }
                catch (e) {
                    try {
                        IteratorClose(iterator);
                    }
                    finally {
                        throw e;
                    }
                }
                k++;
            }
        }
        // 6 ECMAScript Data Typ0es and Values
        // https://tc39.github.io/ecma262/#sec-ecmascript-data-types-and-values
        function Type(x) {
            if (x === null)
                return 1 /* Null */;
            switch (typeof x) {
                case "undefined": return 0 /* Undefined */;
                case "boolean": return 2 /* Boolean */;
                case "string": return 3 /* String */;
                case "symbol": return 4 /* Symbol */;
                case "number": return 5 /* Number */;
                case "object": return x === null ? 1 /* Null */ : 6 /* Object */;
                default: return 6 /* Object */;
            }
        }
        // 6.1.1 The Undefined Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-undefined-type
        function IsUndefined(x) {
            return x === undefined;
        }
        // 6.1.2 The Null Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-null-type
        function IsNull(x) {
            return x === null;
        }
        // 6.1.5 The Symbol Type
        // https://tc39.github.io/ecma262/#sec-ecmascript-language-types-symbol-type
        function IsSymbol(x) {
            return typeof x === "symbol";
        }
        // 6.1.7 The Object Type
        // https://tc39.github.io/ecma262/#sec-object-type
        function IsObject(x) {
            return typeof x === "object" ? x !== null : typeof x === "function";
        }
        // 7.1 Type Conversion
        // https://tc39.github.io/ecma262/#sec-type-conversion
        // 7.1.1 ToPrimitive(input [, PreferredType])
        // https://tc39.github.io/ecma262/#sec-toprimitive
        function ToPrimitive(input, PreferredType) {
            switch (Type(input)) {
                case 0 /* Undefined */: return input;
                case 1 /* Null */: return input;
                case 2 /* Boolean */: return input;
                case 3 /* String */: return input;
                case 4 /* Symbol */: return input;
                case 5 /* Number */: return input;
            }
            var hint = PreferredType === 3 /* String */ ? "string" : PreferredType === 5 /* Number */ ? "number" : "default";
            var exoticToPrim = GetMethod(input, toPrimitiveSymbol);
            if (exoticToPrim !== undefined) {
                var result = exoticToPrim.call(input, hint);
                if (IsObject(result))
                    throw new TypeError();
                return result;
            }
            return OrdinaryToPrimitive(input, hint === "default" ? "number" : hint);
        }
        // 7.1.1.1 OrdinaryToPrimitive(O, hint)
        // https://tc39.github.io/ecma262/#sec-ordinarytoprimitive
        function OrdinaryToPrimitive(O, hint) {
            if (hint === "string") {
                var toString_1 = O.toString;
                if (IsCallable(toString_1)) {
                    var result = toString_1.call(O);
                    if (!IsObject(result))
                        return result;
                }
                var valueOf = O.valueOf;
                if (IsCallable(valueOf)) {
                    var result = valueOf.call(O);
                    if (!IsObject(result))
                        return result;
                }
            }
            else {
                var valueOf = O.valueOf;
                if (IsCallable(valueOf)) {
                    var result = valueOf.call(O);
                    if (!IsObject(result))
                        return result;
                }
                var toString_2 = O.toString;
                if (IsCallable(toString_2)) {
                    var result = toString_2.call(O);
                    if (!IsObject(result))
                        return result;
                }
            }
            throw new TypeError();
        }
        // 7.1.2 ToBoolean(argument)
        // https://tc39.github.io/ecma262/2016/#sec-toboolean
        function ToBoolean(argument) {
            return !!argument;
        }
        // 7.1.12 ToString(argument)
        // https://tc39.github.io/ecma262/#sec-tostring
        function ToString(argument) {
            return "" + argument;
        }
        // 7.1.14 ToPropertyKey(argument)
        // https://tc39.github.io/ecma262/#sec-topropertykey
        function ToPropertyKey(argument) {
            var key = ToPrimitive(argument, 3 /* String */);
            if (IsSymbol(key))
                return key;
            return ToString(key);
        }
        // 7.2 Testing and Comparison Operations
        // https://tc39.github.io/ecma262/#sec-testing-and-comparison-operations
        // 7.2.2 IsArray(argument)
        // https://tc39.github.io/ecma262/#sec-isarray
        function IsArray(argument) {
            return Array.isArray
                ? Array.isArray(argument)
                : argument instanceof Object
                    ? argument instanceof Array
                    : Object.prototype.toString.call(argument) === "[object Array]";
        }
        // 7.2.3 IsCallable(argument)
        // https://tc39.github.io/ecma262/#sec-iscallable
        function IsCallable(argument) {
            // NOTE: This is an approximation as we cannot check for [[Call]] internal method.
            return typeof argument === "function";
        }
        // 7.2.4 IsConstructor(argument)
        // https://tc39.github.io/ecma262/#sec-isconstructor
        function IsConstructor(argument) {
            // NOTE: This is an approximation as we cannot check for [[Construct]] internal method.
            return typeof argument === "function";
        }
        // 7.2.7 IsPropertyKey(argument)
        // https://tc39.github.io/ecma262/#sec-ispropertykey
        function IsPropertyKey(argument) {
            switch (Type(argument)) {
                case 3 /* String */: return true;
                case 4 /* Symbol */: return true;
                default: return false;
            }
        }
        // 7.3 Operations on Objects
        // https://tc39.github.io/ecma262/#sec-operations-on-objects
        // 7.3.9 GetMethod(V, P)
        // https://tc39.github.io/ecma262/#sec-getmethod
        function GetMethod(V, P) {
            var func = V[P];
            if (func === undefined || func === null)
                return undefined;
            if (!IsCallable(func))
                throw new TypeError();
            return func;
        }
        // 7.4 Operations on Iterator Objects
        // https://tc39.github.io/ecma262/#sec-operations-on-iterator-objects
        function GetIterator(obj) {
            var method = GetMethod(obj, iteratorSymbol);
            if (!IsCallable(method))
                throw new TypeError(); // from Call
            var iterator = method.call(obj);
            if (!IsObject(iterator))
                throw new TypeError();
            return iterator;
        }
        // 7.4.4 IteratorValue(iterResult)
        // https://tc39.github.io/ecma262/2016/#sec-iteratorvalue
        function IteratorValue(iterResult) {
            return iterResult.value;
        }
        // 7.4.5 IteratorStep(iterator)
        // https://tc39.github.io/ecma262/#sec-iteratorstep
        function IteratorStep(iterator) {
            var result = iterator.next();
            return result.done ? false : result;
        }
        // 7.4.6 IteratorClose(iterator, completion)
        // https://tc39.github.io/ecma262/#sec-iteratorclose
        function IteratorClose(iterator) {
            var f = iterator["return"];
            if (f)
                f.call(iterator);
        }
        // 9.1 Ordinary Object Internal Methods and Internal Slots
        // https://tc39.github.io/ecma262/#sec-ordinary-object-internal-methods-and-internal-slots
        // 9.1.1.1 OrdinaryGetPrototypeOf(O)
        // https://tc39.github.io/ecma262/#sec-ordinarygetprototypeof
        function OrdinaryGetPrototypeOf(O) {
            var proto = Object.getPrototypeOf(O);
            if (typeof O !== "function" || O === functionPrototype)
                return proto;
            // TypeScript doesn't set __proto__ in ES5, as it's non-standard.
            // Try to determine the superclass constructor. Compatible implementations
            // must either set __proto__ on a subclass constructor to the superclass constructor,
            // or ensure each class has a valid `constructor` property on its prototype that
            // points back to the constructor.
            // If this is not the same as Function.[[Prototype]], then this is definately inherited.
            // This is the case when in ES6 or when using __proto__ in a compatible browser.
            if (proto !== functionPrototype)
                return proto;
            // If the super prototype is Object.prototype, null, or undefined, then we cannot determine the heritage.
            var prototype = O.prototype;
            var prototypeProto = prototype && Object.getPrototypeOf(prototype);
            if (prototypeProto == null || prototypeProto === Object.prototype)
                return proto;
            // If the constructor was not a function, then we cannot determine the heritage.
            var constructor = prototypeProto.constructor;
            if (typeof constructor !== "function")
                return proto;
            // If we have some kind of self-reference, then we cannot determine the heritage.
            if (constructor === O)
                return proto;
            // we have a pretty good guess at the heritage.
            return constructor;
        }
        // naive Map shim
        function CreateMapPolyfill() {
            var cacheSentinel = {};
            var arraySentinel = [];
            var MapIterator = /** @class */ (function () {
                function MapIterator(keys, values, selector) {
                    this._index = 0;
                    this._keys = keys;
                    this._values = values;
                    this._selector = selector;
                }
                MapIterator.prototype["@@iterator"] = function () { return this; };
                MapIterator.prototype[iteratorSymbol] = function () { return this; };
                MapIterator.prototype.next = function () {
                    var index = this._index;
                    if (index >= 0 && index < this._keys.length) {
                        var result = this._selector(this._keys[index], this._values[index]);
                        if (index + 1 >= this._keys.length) {
                            this._index = -1;
                            this._keys = arraySentinel;
                            this._values = arraySentinel;
                        }
                        else {
                            this._index++;
                        }
                        return { value: result, done: false };
                    }
                    return { value: undefined, done: true };
                };
                MapIterator.prototype.throw = function (error) {
                    if (this._index >= 0) {
                        this._index = -1;
                        this._keys = arraySentinel;
                        this._values = arraySentinel;
                    }
                    throw error;
                };
                MapIterator.prototype.return = function (value) {
                    if (this._index >= 0) {
                        this._index = -1;
                        this._keys = arraySentinel;
                        this._values = arraySentinel;
                    }
                    return { value: value, done: true };
                };
                return MapIterator;
            }());
            return /** @class */ (function () {
                function Map() {
                    this._keys = [];
                    this._values = [];
                    this._cacheKey = cacheSentinel;
                    this._cacheIndex = -2;
                }
                Object.defineProperty(Map.prototype, "size", {
                    get: function () { return this._keys.length; },
                    enumerable: true,
                    configurable: true
                });
                Map.prototype.has = function (key) { return this._find(key, /*insert*/ false) >= 0; };
                Map.prototype.get = function (key) {
                    var index = this._find(key, /*insert*/ false);
                    return index >= 0 ? this._values[index] : undefined;
                };
                Map.prototype.set = function (key, value) {
                    var index = this._find(key, /*insert*/ true);
                    this._values[index] = value;
                    return this;
                };
                Map.prototype.delete = function (key) {
                    var index = this._find(key, /*insert*/ false);
                    if (index >= 0) {
                        var size = this._keys.length;
                        for (var i = index + 1; i < size; i++) {
                            this._keys[i - 1] = this._keys[i];
                            this._values[i - 1] = this._values[i];
                        }
                        this._keys.length--;
                        this._values.length--;
                        if (key === this._cacheKey) {
                            this._cacheKey = cacheSentinel;
                            this._cacheIndex = -2;
                        }
                        return true;
                    }
                    return false;
                };
                Map.prototype.clear = function () {
                    this._keys.length = 0;
                    this._values.length = 0;
                    this._cacheKey = cacheSentinel;
                    this._cacheIndex = -2;
                };
                Map.prototype.keys = function () { return new MapIterator(this._keys, this._values, getKey); };
                Map.prototype.values = function () { return new MapIterator(this._keys, this._values, getValue); };
                Map.prototype.entries = function () { return new MapIterator(this._keys, this._values, getEntry); };
                Map.prototype["@@iterator"] = function () { return this.entries(); };
                Map.prototype[iteratorSymbol] = function () { return this.entries(); };
                Map.prototype._find = function (key, insert) {
                    if (this._cacheKey !== key) {
                        this._cacheIndex = this._keys.indexOf(this._cacheKey = key);
                    }
                    if (this._cacheIndex < 0 && insert) {
                        this._cacheIndex = this._keys.length;
                        this._keys.push(key);
                        this._values.push(undefined);
                    }
                    return this._cacheIndex;
                };
                return Map;
            }());
            function getKey(key, _) {
                return key;
            }
            function getValue(_, value) {
                return value;
            }
            function getEntry(key, value) {
                return [key, value];
            }
        }
        // naive Set shim
        function CreateSetPolyfill() {
            return /** @class */ (function () {
                function Set() {
                    this._map = new _Map();
                }
                Object.defineProperty(Set.prototype, "size", {
                    get: function () { return this._map.size; },
                    enumerable: true,
                    configurable: true
                });
                Set.prototype.has = function (value) { return this._map.has(value); };
                Set.prototype.add = function (value) { return this._map.set(value, value), this; };
                Set.prototype.delete = function (value) { return this._map.delete(value); };
                Set.prototype.clear = function () { this._map.clear(); };
                Set.prototype.keys = function () { return this._map.keys(); };
                Set.prototype.values = function () { return this._map.values(); };
                Set.prototype.entries = function () { return this._map.entries(); };
                Set.prototype["@@iterator"] = function () { return this.keys(); };
                Set.prototype[iteratorSymbol] = function () { return this.keys(); };
                return Set;
            }());
        }
        // naive WeakMap shim
        function CreateWeakMapPolyfill() {
            var UUID_SIZE = 16;
            var keys = HashMap.create();
            var rootKey = CreateUniqueKey();
            return /** @class */ (function () {
                function WeakMap() {
                    this._key = CreateUniqueKey();
                }
                WeakMap.prototype.has = function (target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? HashMap.has(table, this._key) : false;
                };
                WeakMap.prototype.get = function (target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? HashMap.get(table, this._key) : undefined;
                };
                WeakMap.prototype.set = function (target, value) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ true);
                    table[this._key] = value;
                    return this;
                };
                WeakMap.prototype.delete = function (target) {
                    var table = GetOrCreateWeakMapTable(target, /*create*/ false);
                    return table !== undefined ? delete table[this._key] : false;
                };
                WeakMap.prototype.clear = function () {
                    // NOTE: not a real clear, just makes the previous data unreachable
                    this._key = CreateUniqueKey();
                };
                return WeakMap;
            }());
            function CreateUniqueKey() {
                var key;
                do
                    key = "@@WeakMap@@" + CreateUUID();
                while (HashMap.has(keys, key));
                keys[key] = true;
                return key;
            }
            function GetOrCreateWeakMapTable(target, create) {
                if (!hasOwn.call(target, rootKey)) {
                    if (!create)
                        return undefined;
                    Object.defineProperty(target, rootKey, { value: HashMap.create() });
                }
                return target[rootKey];
            }
            function FillRandomBytes(buffer, size) {
                for (var i = 0; i < size; ++i)
                    buffer[i] = Math.random() * 0xff | 0;
                return buffer;
            }
            function GenRandomBytes(size) {
                if (typeof Uint8Array === "function") {
                    if (typeof crypto !== "undefined")
                        return crypto.getRandomValues(new Uint8Array(size));
                    if (typeof msCrypto !== "undefined")
                        return msCrypto.getRandomValues(new Uint8Array(size));
                    return FillRandomBytes(new Uint8Array(size), size);
                }
                return FillRandomBytes(new Array(size), size);
            }
            function CreateUUID() {
                var data = GenRandomBytes(UUID_SIZE);
                // mark as random - RFC 4122 § 4.4
                data[6] = data[6] & 0x4f | 0x40;
                data[8] = data[8] & 0xbf | 0x80;
                var result = "";
                for (var offset = 0; offset < UUID_SIZE; ++offset) {
                    var byte = data[offset];
                    if (offset === 4 || offset === 6 || offset === 8)
                        result += "-";
                    if (byte < 16)
                        result += "0";
                    result += byte.toString(16).toLowerCase();
                }
                return result;
            }
        }
        // uses a heuristic used by v8 and chakra to force an object into dictionary mode.
        function MakeDictionary(obj) {
            obj.__ = undefined;
            delete obj.__;
            return obj;
        }
    });
})(Reflect || (Reflect = {}));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(50), __webpack_require__(24)))

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var binding_when_syntax_1 = __webpack_require__(141);
var BindingOnSyntax = (function () {
    function BindingOnSyntax(binding) {
        this._binding = binding;
    }
    BindingOnSyntax.prototype.onActivation = function (handler) {
        this._binding.onActivation = handler;
        return new binding_when_syntax_1.BindingWhenSyntax(this._binding);
    };
    return BindingOnSyntax;
}());
exports.BindingOnSyntax = BindingOnSyntax;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var binding_on_syntax_1 = __webpack_require__(140);
var constraint_helpers_1 = __webpack_require__(228);
var BindingWhenSyntax = (function () {
    function BindingWhenSyntax(binding) {
        this._binding = binding;
    }
    BindingWhenSyntax.prototype.when = function (constraint) {
        this._binding.constraint = constraint;
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenTargetNamed = function (name) {
        this._binding.constraint = constraint_helpers_1.namedConstraint(name);
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenTargetIsDefault = function () {
        this._binding.constraint = function (request) {
            var targetIsDefault = (request.target !== null) &&
                (!request.target.isNamed()) &&
                (!request.target.isTagged());
            return targetIsDefault;
        };
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenTargetTagged = function (tag, value) {
        this._binding.constraint = constraint_helpers_1.taggedConstraint(tag)(value);
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenInjectedInto = function (parent) {
        this._binding.constraint = function (request) {
            return constraint_helpers_1.typeConstraint(parent)(request.parentRequest);
        };
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenParentNamed = function (name) {
        this._binding.constraint = function (request) {
            return constraint_helpers_1.namedConstraint(name)(request.parentRequest);
        };
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenParentTagged = function (tag, value) {
        this._binding.constraint = function (request) {
            return constraint_helpers_1.taggedConstraint(tag)(value)(request.parentRequest);
        };
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenAnyAncestorIs = function (ancestor) {
        this._binding.constraint = function (request) {
            return constraint_helpers_1.traverseAncerstors(request, constraint_helpers_1.typeConstraint(ancestor));
        };
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenNoAncestorIs = function (ancestor) {
        this._binding.constraint = function (request) {
            return !constraint_helpers_1.traverseAncerstors(request, constraint_helpers_1.typeConstraint(ancestor));
        };
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenAnyAncestorNamed = function (name) {
        this._binding.constraint = function (request) {
            return constraint_helpers_1.traverseAncerstors(request, constraint_helpers_1.namedConstraint(name));
        };
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenNoAncestorNamed = function (name) {
        this._binding.constraint = function (request) {
            return !constraint_helpers_1.traverseAncerstors(request, constraint_helpers_1.namedConstraint(name));
        };
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenAnyAncestorTagged = function (tag, value) {
        this._binding.constraint = function (request) {
            return constraint_helpers_1.traverseAncerstors(request, constraint_helpers_1.taggedConstraint(tag)(value));
        };
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenNoAncestorTagged = function (tag, value) {
        this._binding.constraint = function (request) {
            return !constraint_helpers_1.traverseAncerstors(request, constraint_helpers_1.taggedConstraint(tag)(value));
        };
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenAnyAncestorMatches = function (constraint) {
        this._binding.constraint = function (request) {
            return constraint_helpers_1.traverseAncerstors(request, constraint);
        };
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenNoAncestorMatches = function (constraint) {
        this._binding.constraint = function (request) {
            return !constraint_helpers_1.traverseAncerstors(request, constraint);
        };
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    return BindingWhenSyntax;
}());
exports.BindingWhenSyntax = BindingWhenSyntax;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var RecordData = /** @class */ (function () {
    function RecordData() {
        this._record = {};
        this._name = '';
    }
    RecordData.prototype.getParameter = function (parameter) {
        return this._record[parameter];
    };
    Object.defineProperty(RecordData.prototype, "record", {
        get: function () {
            return this._record;
        },
        set: function (value) {
            this._record = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecordData.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (value) {
            this._name = value;
        },
        enumerable: true,
        configurable: true
    });
    return RecordData;
}());
exports.RecordData = RecordData;
var GameConfig = /** @class */ (function () {
    function GameConfig() {
        this._config = [];
    }
    GameConfig.prototype.loadConfig = function (configData) {
        for (var data in configData) {
            var record = new RecordData;
            record.record = configData[data];
            record.name = configData[data].name;
            this._config.push(record);
        }
    };
    GameConfig.prototype.getConfigByName = function (name) {
        return this._config.find(function (record) { return record.name === name; });
    };
    return GameConfig;
}());
exports.GameConfig = GameConfig;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = __webpack_require__(14);
var RectangleArea_1 = __webpack_require__(230);
var Device_1 = __webpack_require__(42);
var ResolutionManager = /** @class */ (function () {
    function ResolutionManager(viewport, device) {
        if (device.desktop) {
            this._resolution = new RectangleArea_1.RectangleArea(1920, 1080);
            this._halfResolution = new RectangleArea_1.RectangleArea(960, 540);
        }
        else {
            this._resolution = new RectangleArea_1.RectangleArea(720, 1280);
            this._halfResolution = new RectangleArea_1.RectangleArea(360, 640);
        }
        this._device = device;
        this.initViewPortResolution(viewport);
    }
    ResolutionManager_1 = ResolutionManager;
    ResolutionManager.prototype.updateViewPortResolution = function (x, y) {
        this._viewportResolution = new PIXI.Point(x, y);
    };
    ResolutionManager.prototype.initViewPortResolution = function (viewport) {
        this._viewportResolution = new PIXI.Point(this._resolution.width / viewport.width, this._resolution.height / viewport.height);
        this._defaultViewportResolution = this._viewportResolution.clone();
    };
    Object.defineProperty(ResolutionManager.prototype, "defaultViewportResolution", {
        get: function () {
            return this._defaultViewportResolution;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ResolutionManager.prototype, "resolution", {
        get: function () {
            return this._resolution;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ResolutionManager.prototype, "halfResolution", {
        get: function () {
            return this._halfResolution;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ResolutionManager.prototype, "viewportResolution", {
        get: function () {
            return this._viewportResolution;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ResolutionManager.prototype, "mobToPcFractional", {
        get: function () {
            return ResolutionManager_1.MOBILE_TO_DESKTOP_FRACTIONAL;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ResolutionManager.prototype, "pcToMobFractional", {
        get: function () {
            return ResolutionManager_1.DESKTOP_TO_MOBILE_FRACTIONAL;
        },
        enumerable: true,
        configurable: true
    });
    var ResolutionManager_1;
    ResolutionManager.MOBILE_TO_DESKTOP_FRACTIONAL = 1080 / 1280;
    ResolutionManager.DESKTOP_TO_MOBILE_FRACTIONAL = 1280 / 1080;
    ResolutionManager = ResolutionManager_1 = __decorate([
        inversify_1.injectable(),
        __metadata("design:paramtypes", [RectangleArea_1.RectangleArea, Device_1.Device])
    ], ResolutionManager);
    return ResolutionManager;
}());
exports.ResolutionManager = ResolutionManager;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Device_1 = __webpack_require__(42);
var CoreDI_1 = __webpack_require__(32);
var VisibilityManager_1 = __webpack_require__(231);
var Tween_1 = __webpack_require__(19);
var UpdateManager_1 = __webpack_require__(70);
var DI_1 = __webpack_require__(51);
var SoundManager_1 = __webpack_require__(145);
var SoundsDuckingConfig_1 = __webpack_require__(477);
var inversify_1 = __webpack_require__(14);
var SoundPlayer = /** @class */ (function () {
    function SoundPlayer() {
        this._currentMusicID = '';
        this._isSoundEnabled = true;
        this._mobileSoundsPlaying = {};
        this._currentFadings = {};
        this.setupSoundsDuckingConfig();
        if (false) {
            window.soundPlayer = this;
        }
    }
    SoundPlayer.prototype.init = function () {
        this._isMobile = this._device.isMobile;
        this._visibilityManager.onVisibleCallback = this.onPageShow.bind(this);
        this._visibilityManager.onInvisibleCallback = this.onPageHide.bind(this);
    };
    SoundPlayer.prototype.enableAllSound = function () {
        PIXI.sound.unmuteAll();
        this._isSoundEnabled = true;
        if (this._allSoundsStatusChangedCallback) {
            this._allSoundsStatusChangedCallback(true);
        }
    };
    SoundPlayer.prototype.disableAllSound = function () {
        PIXI.sound.muteAll();
        this._isSoundEnabled = false;
        if (this._allSoundsStatusChangedCallback) {
            this._allSoundsStatusChangedCallback(false);
        }
    };
    SoundPlayer.prototype.enableMusic = function () {
        this._soundManager.unmuteAllMusic();
        if (this._backgroundMusicStatusChangedCallback) {
            this._backgroundMusicStatusChangedCallback(true);
        }
    };
    SoundPlayer.prototype.disableMusic = function () {
        this._soundManager.muteAllMusic();
        if (this._backgroundMusicStatusChangedCallback) {
            this._backgroundMusicStatusChangedCallback(false);
        }
    };
    SoundPlayer.prototype.enableVoice = function () {
        this._soundManager.unmuteAllVoice();
    };
    SoundPlayer.prototype.disableVoice = function () {
        this._soundManager.muteAllVoice();
    };
    SoundPlayer.prototype.enableSounds = function () {
        this._soundManager.unmuteAllSounds();
        if (this._gameSoundsStatusChangedCallback) {
            this._gameSoundsStatusChangedCallback(true);
        }
    };
    SoundPlayer.prototype.disableSounds = function () {
        this._soundManager.muteAllSounds();
        if (this._gameSoundsStatusChangedCallback) {
            this._gameSoundsStatusChangedCallback(false);
        }
    };
    SoundPlayer.prototype.play = function (soundID, loop, chainIntoId, loopChain) {
        this.removeFromFadings(soundID);
        if (this._isMobile) {
            this.playMobileSound(soundID, loop, chainIntoId, loopChain);
        }
        else {
            this.playDesktopSound(soundID, loop, chainIntoId, loopChain);
        }
    };
    SoundPlayer.prototype.playVoice = function (voiceID) {
        if (this._isMobile) {
            this.playMobileVoice(voiceID);
        }
        else {
            this.playDesktopVoice(voiceID);
        }
    };
    SoundPlayer.prototype.stop = function (soundID) {
        if (this._isMobile) {
            this.stopMobileSound(soundID);
        }
        else {
            this.stopDesktopSound(soundID);
        }
    };
    SoundPlayer.prototype.stopFadeSound = function (soundID, fadeTime, callback) {
        var _this = this;
        var sfx = this._soundManager.getEffect(soundID);
        if (!sfx && this._isMobile) {
            sfx = this._mobileSoundsPlaying[soundID];
        }
        if (sfx) {
            if (!sfx.loop && fadeTime > this.getSoundLength(soundID) * 1000) {
                throw new Error("Cannot run fade longer than sound length.");
            }
            this.removeFromFadings(soundID);
            var fadeTween = new Tween_1.Tween(sfx)
                .to({ volume: 0.0 }, fadeTime)
                .start()
                .onComplete(function () {
                // If it's not 0 the sound has probably been restarted/played from some other place and should not be stopped by this.
                if (sfx.volume === 0) {
                    _this.stop(soundID);
                }
                if (callback) {
                    callback();
                }
                _this.removeFromFadings(soundID);
            });
            this._currentFadings[soundID] = fadeTween;
            this._updateManager.add(fadeTween);
        }
    };
    SoundPlayer.prototype.removeFromFadings = function (soundID) {
        var tween = this._currentFadings[soundID];
        if (tween && tween.isPlaying) {
            tween.stop(true);
            this._currentFadings[soundID] = null;
        }
    };
    SoundPlayer.prototype.playMusic = function (musicID) {
        this.stopMusic();
        if (this._soundManager.hasMusic(musicID)) {
            var music = this._soundManager.getMusic(musicID);
            var volume = this._soundManager.getSoundVolume(musicID);
            if (!music.isPlaying) {
                music.play({ loop: true });
            }
            else if (volume > music.volume) {
                music.stop();
                music.play({ loop: true });
            }
            music.volume = volume;
            this._isMusicPlaying = true;
            this._currentMusicID = musicID;
        }
    };
    SoundPlayer.prototype.fadeCurrentMusicTo = function (musicID, transitionDuration) {
        if (transitionDuration === void 0) { transitionDuration = 4000; }
        if (this._soundManager.hasMusic(musicID) && musicID !== this._currentMusicID) {
            var curMusic = this._soundManager.getMusic(this._currentMusicID);
            this.killCurrentMusicFadingOutTween();
            this.killCurrentNewMusicTween();
            if (curMusic && curMusic.isPlaying) {
                var currentMusicTween = new Tween_1.Tween(curMusic).to({ volume: 0.0 }, transitionDuration).start();
                this._updateManager.add(currentMusicTween);
                this._currentFadingMusicTween = currentMusicTween;
            }
            var newMusic = this._soundManager.getMusic(musicID);
            var volume = this._soundManager.getSoundVolume(musicID);
            if (!newMusic.isPlaying) {
                if (newMusic.instances[0]) {
                    newMusic.instances[0].progress = 0;
                }
                newMusic.play({ loop: true });
            }
            this._isMusicPlaying = true;
            this._currentMusicID = musicID;
            newMusic.volume = 0;
            var newMusicTween = new Tween_1.Tween(newMusic).to({ volume: volume }, transitionDuration).start();
            this._updateManager.add(newMusicTween);
            this._currentNewMusicTween = newMusicTween;
        }
        else {
            // Case where it tries to transition from itself.
            if (this._soundManager.hasMusic(musicID) && musicID === this._currentMusicID) {
                this.killCurrentMusicFadingOutTween();
                this.killCurrentNewMusicTween();
                var newMusic = this._soundManager.getMusic(musicID);
                var volume = this._soundManager.getSoundVolume(musicID);
                if (volume === 1) {
                    return;
                }
                if (!newMusic.isPlaying) {
                    newMusic.play({ loop: true });
                }
                this._isMusicPlaying = true;
                this._currentMusicID = musicID;
                newMusic.volume = volume;
                var newMusicTween = new Tween_1.Tween(newMusic).to({ volume: volume }, transitionDuration).start();
                this._updateManager.add(newMusicTween);
                this._currentNewMusicTween = newMusicTween;
            }
        }
    };
    SoundPlayer.prototype.fadeCurrentMusic = function (transitionDuration) {
        if (transitionDuration === void 0) { transitionDuration = 4000; }
        var curMusic = this._soundManager.getMusic(this._currentMusicID);
        if (curMusic && curMusic.isPlaying) {
            this.killCurrentEffectsDuckingTween();
            this.killCurrentNewMusicTween();
            var currentMusicTween = new Tween_1.Tween(curMusic).to({ volume: 0.0 }, transitionDuration).start();
            this._updateManager.add(currentMusicTween);
            this._currentFadingMusicTween = currentMusicTween;
        }
        this._isMusicPlaying = false;
        this._currentMusicID = null;
    };
    SoundPlayer.prototype.stopMusic = function () {
        if (this._isMusicPlaying) {
            this._soundManager.getMusic(this._currentMusicID).stop();
            this._isMusicPlaying = false;
        }
    };
    SoundPlayer.prototype.isMusicPlaying = function () {
        return this._isMusicPlaying;
    };
    SoundPlayer.prototype.duckMusic = function (duckingTime) {
        if (duckingTime === void 0) { duckingTime = 500; }
        this.killCurrentMusicDuckingTween();
        var music = this._soundManager.getMusic(this._currentMusicID);
        if (music) {
            this._currentMusicDuckingTween = new Tween_1.Tween(music).to({ volume: 0.0 }, duckingTime).start();
            this._updateManager.add(this._currentMusicDuckingTween);
        }
    };
    SoundPlayer.prototype.unduckMusic = function (unduckingTime) {
        if (unduckingTime === void 0) { unduckingTime = 500; }
        this.killCurrentMusicDuckingTween();
        var music = this._soundManager.getMusic(this._currentMusicID);
        if (music) {
            this._currentMusicDuckingTween = new Tween_1.Tween(music).to({ volume: 1.0 }, unduckingTime).start();
            this._updateManager.add(this._currentMusicDuckingTween);
        }
    };
    SoundPlayer.prototype.duckEffects = function (duckingTime) {
        if (duckingTime === void 0) { duckingTime = 500; }
        this.killCurrentEffectsDuckingTween();
        var effects = this._soundManager.getAllPlayingEffects();
        if (effects.length) {
            this._currentEffectsDuckingTween = this.tweenAttributeForListOfSoundInstances('volume', effects, 1, 0, duckingTime);
        }
    };
    SoundPlayer.prototype.unduckEffects = function (unduckingTime) {
        if (unduckingTime === void 0) { unduckingTime = 300; }
        this.killCurrentEffectsDuckingTween();
        var effects = this._soundManager.getAllPlayingEffects();
        if (effects.length) {
            this._currentEffectsDuckingTween = this.tweenAttributeForListOfSoundInstances('volume', effects, 0, 1, unduckingTime);
        }
    };
    SoundPlayer.prototype.duckVoices = function (duckingTime) {
        if (duckingTime === void 0) { duckingTime = 500; }
        this.killCurrentVoicesDuckingTween();
        var voices = this._soundManager.getAllPlayingVoices();
        if (voices.length) {
            this._currentVoicesDuckingTween = this.tweenAttributeForListOfSoundInstances('volume', voices, 1, 0, duckingTime);
        }
    };
    SoundPlayer.prototype.unduckVoices = function (unduckingTime) {
        if (unduckingTime === void 0) { unduckingTime = 300; }
        this.killCurrentVoicesDuckingTween();
        var voices = this._soundManager.getAllPlayingVoices();
        if (voices.length) {
            this._currentVoicesDuckingTween = this.tweenAttributeForListOfSoundInstances('volume', voices, 0, 1, unduckingTime);
        }
    };
    SoundPlayer.prototype.restoreGameMusic = function (logic) {
        throw new Error('SoundPlayer::restoreGameMusic must be overridden in order to be used');
    };
    SoundPlayer.prototype.getSoundLength = function (id) {
        return this._soundManager.getSoundLength(id);
    };
    SoundPlayer.prototype.getMusicLength = function (id) {
        return this._soundManager.getMusicLength(id);
    };
    SoundPlayer.prototype.getVoiceLength = function (id) {
        return this._soundManager.getVoiceLength(id);
    };
    SoundPlayer.prototype.tweenAttributeForListOfSoundInstances = function (attribute, list, start, goal, duration) {
        var _this = this;
        if (attribute === void 0) { attribute = 'volume'; }
        if (start === void 0) { start = 0; }
        if (goal === void 0) { goal = 1; }
        if (duration === void 0) { duration = 500; }
        var tweenObject = { tweenValue: start };
        var tween = new Tween_1.Tween(tweenObject)
            .to({ tweenValue: goal }, duration)
            .onUpdate(function () {
            for (var i = list.length - 1; i >= 0; i--) {
                var mediaInstance = list[i];
                // This check is added because media is null when the sound is finished.
                if (mediaInstance) {
                    if (_this.isMediaInstanceFinishedPlaying(mediaInstance)) {
                        list.splice(i, 1);
                        continue;
                    }
                    else {
                        mediaInstance[attribute] = tweenObject.tweenValue;
                    }
                }
            }
        })
            .start();
        this._updateManager.add(tween);
        return tween;
    };
    SoundPlayer.prototype.isMediaInstanceFinishedPlaying = function (mediaInstance) {
        return mediaInstance._media === null;
    };
    SoundPlayer.prototype.setupSoundsDuckingConfig = function () {
        this._soundsDuckingConfig = new SoundsDuckingConfig_1.SoundsDuckingConfig();
    };
    SoundPlayer.prototype.onPageHide = function () {
        if (this._isSoundEnabled) {
            this.disableAllSound();
        }
    };
    SoundPlayer.prototype.onPageShow = function () {
        if (!this._isSoundEnabled) {
            this.enableAllSound();
        }
    };
    SoundPlayer.prototype.playDesktopSound = function (soundID, loop, chainIntoId, loopChain) {
        var effect = this._soundManager.getEffect(soundID);
        var volume = this._soundManager.getSoundVolume(soundID);
        if (effect) {
            effect.volume = volume;
        }
        var chainedSound = this._soundManager.getEffect(chainIntoId);
        var chainedSoundVolume = this._soundManager.getSoundVolume(chainIntoId);
        if (chainedSound) {
            chainedSound.volume = chainedSoundVolume;
        }
        if (!effect) {
            if (false) {
                console.warn("There's no sound: '" + soundID + "'");
            }
            return;
        }
        if (this._soundsDuckingConfig.hasDuckingTimeFor(soundID)) {
            this.duckSoundsForSoundId(soundID);
            effect.play({ loop: loop, complete: this.onDuckingSndCompleted.bind(this) });
        }
        else {
            if (chainIntoId) {
                effect.play({ loop: loop, complete: function () {
                        chainedSound.play({ loop: loopChain });
                    } });
            }
            else {
                effect.play({ loop: loop });
            }
        }
    };
    SoundPlayer.prototype.duckSoundsForSoundId = function (soundID) {
        var sounds = this._soundsDuckingConfig.getDuckingSoundsFor(soundID);
        var duckingTime = this._soundsDuckingConfig.getDuckingTimeFor(soundID);
        if (sounds.music && duckingTime) {
            this.duckMusic(duckingTime);
        }
        if (sounds.effects && duckingTime) {
            this.duckEffects(duckingTime);
        }
        if (sounds.voice && duckingTime) {
            this.duckVoices(duckingTime);
        }
    };
    SoundPlayer.prototype.unduckSoundsForSoundId = function (soundID) {
        var sounds = this._soundsDuckingConfig.getDuckingSoundsFor(soundID);
        var unduckingTime = this._soundsDuckingConfig.getUnduckingTimeFor(soundID);
        if (sounds.music && unduckingTime) {
            this.duckMusic(unduckingTime);
        }
        if (sounds.effects && unduckingTime) {
            this.duckEffects(unduckingTime);
        }
        if (sounds.voice && unduckingTime) {
            this.duckVoices(unduckingTime);
        }
    };
    SoundPlayer.prototype.playMobileSound = function (soundID, loop, chainIntoId, loopChain) {
        var _this = this;
        if (loop === void 0) { loop = false; }
        var sound = this._soundManager.getEffect('allSound');
        var volume = this._soundManager.getSoundVolume(soundID);
        if (sound && sound.sprites.hasOwnProperty(soundID)) {
            var currentSoundInstance = void 0;
            if (this._soundsDuckingConfig.hasDuckingTimeFor(soundID)) {
                this.duckSoundsForSoundId(soundID);
                currentSoundInstance = sound.play({
                    sprite: soundID,
                    volume: volume,
                }, this.onDuckingSndCompleted.bind(this));
            }
            else {
                currentSoundInstance = sound.play({
                    sprite: soundID,
                    loop: loop,
                    volume: volume,
                    complete: function () {
                        if (chainIntoId) {
                            _this.playMobileSound(chainIntoId, loopChain);
                        }
                    }
                });
            }
            if (currentSoundInstance) {
                this._mobileSoundsPlaying[soundID] = currentSoundInstance;
            }
        }
        else if (this._soundManager.getEffect(soundID)) {
            var sfx = this._soundManager.getEffect(soundID);
            sfx.volume = volume;
            if (this._soundsDuckingConfig.hasDuckingTimeFor(soundID)) {
                this.duckSoundsForSoundId(soundID);
                sfx.play({ loop: loop, complete: this.onDuckingSndCompleted.bind(this) });
            }
            else {
                sfx.play({ loop: loop, complete: function () {
                        if (chainIntoId) {
                            _this.playMobileSound(chainIntoId, loopChain);
                        }
                    } });
            }
            sfx.loop = loop;
        }
    };
    SoundPlayer.prototype.playMobileVoice = function (voiceID) {
        this.playMobileSound(voiceID);
    };
    SoundPlayer.prototype.playDesktopVoice = function (voiceID) {
        var voice = this._soundManager.getVoice(voiceID);
        var volume = this._soundManager.getSoundVolume(voiceID);
        if (voice) {
            voice.volume = volume;
        }
        if (!voice) {
            if (false) {
                console.warn("There's no sound (Voice) called: '" + voiceID + "'");
            }
            return;
        }
        if (this._soundsDuckingConfig.hasDuckingTimeFor(voiceID)) {
            this.duckSoundsForSoundId(voiceID);
            voice.play({ loop: false, complete: this.onDuckingSndCompleted.bind(this) });
        }
        else {
            voice.play({ loop: false });
        }
    };
    SoundPlayer.prototype.onDuckingSndCompleted = function (sound) {
        this.unduckMusic();
    };
    SoundPlayer.prototype.stopDesktopSound = function (soundID) {
        var sound = this._soundManager.getEffect(soundID);
        if (!sound) {
            if (false) {
                console.warn("There's no sound-effect called: '" + soundID + "'");
            }
            return;
        }
        sound.stop();
        if (this._soundsDuckingConfig.hasDuckingTimeFor(soundID)) {
            this.unduckMusic();
        }
    };
    SoundPlayer.prototype.stopMobileSound = function (soundID) {
        var sfx = this._soundManager.getEffect(soundID);
        if (sfx) {
            if (sfx.isPlaying) {
                sfx.stop();
            }
        }
        else {
            for (var key in this._mobileSoundsPlaying) {
                if (this._mobileSoundsPlaying.hasOwnProperty(key)) {
                    var sound = this._mobileSoundsPlaying[key];
                    if (key === soundID) {
                        sound.stop();
                    }
                }
            }
        }
    };
    SoundPlayer.prototype.killCurrentVoicesDuckingTween = function () {
        this.killTween(this._currentVoicesDuckingTween);
    };
    SoundPlayer.prototype.killCurrentEffectsDuckingTween = function () {
        this.killTween(this._currentEffectsDuckingTween);
    };
    SoundPlayer.prototype.killCurrentMusicDuckingTween = function () {
        this.killTween(this._currentMusicDuckingTween);
    };
    SoundPlayer.prototype.killCurrentMusicFadingOutTween = function () {
        this.killTween(this._currentFadingMusicTween, true);
    };
    SoundPlayer.prototype.killCurrentNewMusicTween = function () {
        this.killTween(this._currentNewMusicTween, true);
    };
    SoundPlayer.prototype.killTween = function (tween, goToEnd) {
        if (goToEnd === void 0) { goToEnd = false; }
        if (tween && tween.isPlaying) {
            tween.stop(goToEnd);
            this._updateManager.remove(tween);
        }
    };
    Object.defineProperty(SoundPlayer.prototype, "gameSoundsStatusChangedCallback", {
        set: function (value) {
            this._gameSoundsStatusChangedCallback = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SoundPlayer.prototype, "backgroundMusicStatusChangedCallback", {
        set: function (value) {
            this._backgroundMusicStatusChangedCallback = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SoundPlayer.prototype, "allSoundsStatusChangedCallback", {
        set: function (value) {
            this._allSoundsStatusChangedCallback = value;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        inversify_1.inject(DI_1.default.SoundManager),
        __metadata("design:type", SoundManager_1.SoundManager)
    ], SoundPlayer.prototype, "_soundManager", void 0);
    __decorate([
        inversify_1.inject(CoreDI_1.CoreDI.UpdateManager),
        __metadata("design:type", UpdateManager_1.UpdateManager)
    ], SoundPlayer.prototype, "_updateManager", void 0);
    __decorate([
        inversify_1.inject(CoreDI_1.CoreDI.Device),
        __metadata("design:type", Device_1.Device)
    ], SoundPlayer.prototype, "_device", void 0);
    __decorate([
        inversify_1.inject(CoreDI_1.CoreDI.VisibilityManager),
        __metadata("design:type", VisibilityManager_1.VisibilityManager)
    ], SoundPlayer.prototype, "_visibilityManager", void 0);
    SoundPlayer = __decorate([
        inversify_1.injectable(),
        __metadata("design:paramtypes", [])
    ], SoundPlayer);
    return SoundPlayer;
}());
exports.SoundPlayer = SoundPlayer;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var CoreDI_1 = __webpack_require__(32);
var ResourcesLoader_1 = __webpack_require__(69);
var inversify_1 = __webpack_require__(14);
__webpack_require__(220);
var SoundManager = /** @class */ (function () {
    function SoundManager() {
        this._effects = {};
        this._music = {};
        this._voices = {};
        this._volumes = {};
    }
    Object.defineProperty(SoundManager.prototype, "loader", {
        get: function () {
            return this._loader;
        },
        enumerable: true,
        configurable: true
    });
    SoundManager.prototype.init = function (device) {
        this.initEffects();
        this.initMusic();
        this.initVoice();
        this.initVolumes();
    };
    SoundManager.prototype.hasEffect = function (soundID) {
        return !!this._effects[soundID];
    };
    SoundManager.prototype.hasMusic = function (musicID) {
        return !!this._music[musicID];
    };
    SoundManager.prototype.hasVoice = function (voiceID) {
        return !!this._voices[voiceID];
    };
    SoundManager.prototype.getEffect = function (soundID) {
        return this._effects[soundID];
    };
    SoundManager.prototype.getMusic = function (musicID) {
        return this._music[musicID];
    };
    SoundManager.prototype.getVoice = function (voiceID) {
        return this._voices[voiceID];
    };
    SoundManager.prototype.getSoundVolume = function (soundID) {
        return this._volumes[soundID] ? this._volumes[soundID] : 1;
    };
    SoundManager.prototype.getAllPlayingEffects = function () {
        return this.getAllPlayingInstancesFromSoundList(this._effects);
    };
    SoundManager.prototype.getAllPlayingVoices = function () {
        return this.getAllPlayingInstancesFromSoundList(this._voices);
    };
    SoundManager.prototype.getAllPlayingMusic = function () {
        return this.getAllPlayingInstancesFromSoundList(this._music);
    };
    SoundManager.prototype.muteAllSounds = function () {
        for (var key in this._effects) {
            if (this._effects.hasOwnProperty(key)) {
                this._effects[key].muted = true;
            }
        }
    };
    SoundManager.prototype.unmuteAllSounds = function () {
        for (var key in this._effects) {
            if (this._effects.hasOwnProperty(key)) {
                this._effects[key].muted = false;
            }
        }
    };
    SoundManager.prototype.muteAllMusic = function () {
        for (var key in this._music) {
            if (this._music.hasOwnProperty(key)) {
                this._music[key].muted = true;
            }
        }
    };
    SoundManager.prototype.unmuteAllMusic = function () {
        for (var key in this._music) {
            if (this._music.hasOwnProperty(key)) {
                this._music[key].muted = false;
            }
        }
    };
    SoundManager.prototype.muteAllVoice = function () {
        for (var key in this._voices) {
            if (this._voices.hasOwnProperty(key)) {
                this._voices[key].muted = true;
            }
        }
    };
    SoundManager.prototype.unmuteAllVoice = function () {
        for (var key in this._voices) {
            if (this._voices.hasOwnProperty(key)) {
                this._voices[key].muted = false;
            }
        }
    };
    SoundManager.prototype.getSoundLength = function (id) {
        return this._effects[id].duration;
    };
    SoundManager.prototype.getMusicLength = function (id) {
        return this._music[id].duration;
    };
    SoundManager.prototype.getVoiceLength = function (id) {
        return this._voices[id].duration;
    };
    SoundManager.prototype.initEffects = function () { };
    SoundManager.prototype.initMusic = function () { };
    SoundManager.prototype.initVoice = function () { };
    SoundManager.prototype.initVolumes = function () { };
    SoundManager.prototype.getAllPlayingInstancesFromSoundList = function (soundList) {
        var sounds = [];
        for (var sfx in soundList) {
            if (soundList.hasOwnProperty(sfx)) {
                var element = soundList[sfx];
                var instances = element.instances;
                if (instances.length) {
                    sounds.push.apply(sounds, instances);
                }
            }
        }
        return sounds;
    };
    __decorate([
        inversify_1.inject(CoreDI_1.CoreDI.ResourceLoader),
        __metadata("design:type", ResourcesLoader_1.ResourcesLoader)
    ], SoundManager.prototype, "_loader", void 0);
    SoundManager = __decorate([
        inversify_1.injectable(),
        __metadata("design:paramtypes", [])
    ], SoundManager);
    return SoundManager;
}());
exports.SoundManager = SoundManager;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = __webpack_require__(14);
var ResourcesLoader_1 = __webpack_require__(69);
var CoreDI_1 = __webpack_require__(32);
var ReelConstants_1 = __webpack_require__(10);
var Spine_1 = __webpack_require__(25);
var Device_1 = __webpack_require__(42);
var FullscreenManager_1 = __webpack_require__(107);
var ResolutionManager_1 = __webpack_require__(143);
var View_1 = __webpack_require__(3);
var Layout = /** @class */ (function () {
    function Layout() {
        /** The relative positions of the bones.     */
        this._layoutPositions = {};
        /** The absolute positions of the bones. */
        this._layoutAbsolutePositions = {};
        /** The attachments' size. */
        this._layoutObjects = {};
        /** The attachments region texture size (same as in .atlas file). */
        this._layoutRegionObjects = {};
        this._isLoaded = false;
    }
    Layout.prototype.getViewPrefix = function (viewType) {
        if (viewType === View_1.ViewTypes.PORTRAIT) {
            return 'portrait_';
        }
        if (viewType === View_1.ViewTypes.LANDSCAPE) {
            return 'landscape_';
        }
        return '';
    };
    Layout.prototype.loadLayout = function (layoutResource, viewType) {
        if (viewType === void 0) { viewType = ReelConstants_1.ReelConstants.DEFAULT_VIEW; }
        var devicePrefix = this.getViewPrefix(viewType);
        var skeleton = this._resources.getSpine(layoutResource, viewType);
        var spine = new Spine_1.Spine(skeleton);
        for (var _i = 0, _a = skeleton.bones; _i < _a.length; _i++) {
            var bone = _a[_i];
            var layoutName = devicePrefix + bone.name;
            if (this._layoutObjects[layoutName]) {
                if (false) {
                    console.warn("Bone data for " + layoutName + " already exists / has already been added. Ignoring.");
                }
                continue;
            }
            this._layoutPositions[layoutName] = { x: bone.x, y: bone.y * -1 };
            this._layoutAbsolutePositions[layoutName] = this.calculateAbsolutePositions(bone);
            var slot = spine.skeleton.findSlot(bone.name);
            if (slot && slot.attachment) {
                this._layoutObjects[layoutName] = {
                    width: slot.attachment.width,
                    height: slot.attachment.height,
                    scale: { x: slot.data.boneData.scaleX, y: slot.data.boneData.scaleY },
                };
                var region = slot.attachment.region;
                if (region) {
                    this._layoutRegionObjects[layoutName] = { width: region.width, height: region.height,
                        scale: { x: 1, y: 1 } };
                }
            }
        }
        this._isLoaded = true;
    };
    Layout.prototype.getPosition = function (resourceName, viewType) {
        if (viewType === void 0) { viewType = ReelConstants_1.ReelConstants.DEFAULT_VIEW; }
        var devicePrefix = this.getViewPrefix(viewType);
        resourceName = devicePrefix + resourceName;
        return this._layoutPositions[resourceName]
            ? { x: this._layoutPositions[resourceName].x, y: this._layoutPositions[resourceName].y }
            : null;
    };
    Layout.prototype.calculateAbsolutePositions = function (bone) {
        var position = { x: bone.x, y: bone.y };
        var parent = bone.parent;
        while (parent !== null) {
            position.x += parent.x;
            position.y += parent.y;
            parent = parent.parent;
        }
        position.y *= -1;
        return position;
    };
    Layout.prototype.getAbsolutePosition = function (resourceName, viewType) {
        if (viewType === void 0) { viewType = ReelConstants_1.ReelConstants.DEFAULT_VIEW; }
        var devicePrefix = this.getViewPrefix(viewType);
        resourceName = devicePrefix + resourceName;
        return this._layoutAbsolutePositions[resourceName]
            ? { x: this._layoutAbsolutePositions[resourceName].x, y: this._layoutAbsolutePositions[resourceName].y }
            : null;
    };
    Layout.prototype.getTextureRegionSize = function (resourceName, viewType) {
        if (viewType === void 0) { viewType = ReelConstants_1.ReelConstants.DEFAULT_VIEW; }
        var devicePrefix = this.getViewPrefix(viewType);
        resourceName = devicePrefix + resourceName;
        return this._layoutRegionObjects[resourceName]
            ? {
                width: this._layoutRegionObjects[resourceName].width,
                height: this._layoutRegionObjects[resourceName].height
            }
            : null;
    };
    Layout.prototype.getSize = function (resourceName, viewType) {
        if (viewType === void 0) { viewType = ReelConstants_1.ReelConstants.DEFAULT_VIEW; }
        var devicePrefix = this.getViewPrefix(viewType);
        resourceName = devicePrefix + resourceName;
        return this._layoutObjects[resourceName]
            ? { width: this._layoutObjects[resourceName].width, height: this._layoutObjects[resourceName].height }
            : null;
    };
    Layout.prototype.getScale = function (resourceName) {
        return this._layoutObjects[resourceName]
            ? { x: this._layoutObjects[resourceName].scale.x, y: this._layoutObjects[resourceName].scale.y }
            : null;
    };
    Layout.prototype.getCenterOfScreen = function (viewType) {
        if (viewType === View_1.ViewTypes.DESKTOP) {
            return { x: this._resolutionManager.halfResolution.width, y: this._resolutionManager.halfResolution.height };
        }
        else {
            if (viewType === View_1.ViewTypes.PORTRAIT) {
                return {
                    x: this._resolutionManager.halfResolution.width,
                    y: this._resolutionManager.halfResolution.height
                };
            }
            else {
                return {
                    x: this._resolutionManager.halfResolution.height,
                    y: this._resolutionManager.halfResolution.width
                };
            }
        }
    };
    Layout.prototype.isLoaded = function () {
        return this._isLoaded;
    };
    __decorate([
        inversify_1.inject(CoreDI_1.CoreDI.ResourceLoader),
        __metadata("design:type", ResourcesLoader_1.ResourcesLoader)
    ], Layout.prototype, "_resources", void 0);
    __decorate([
        inversify_1.inject(CoreDI_1.CoreDI.Device),
        __metadata("design:type", Device_1.Device)
    ], Layout.prototype, "_device", void 0);
    __decorate([
        inversify_1.inject(CoreDI_1.CoreDI.FullscreenManager),
        __metadata("design:type", FullscreenManager_1.FullscreenManager)
    ], Layout.prototype, "_fullscreenManager", void 0);
    __decorate([
        inversify_1.inject(CoreDI_1.CoreDI.ResolutionManager),
        __metadata("design:type", ResolutionManager_1.ResolutionManager)
    ], Layout.prototype, "_resolutionManager", void 0);
    Layout = __decorate([
        inversify_1.injectable()
    ], Layout);
    return Layout;
}());
exports.Layout = Layout;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Updatable_1 = __webpack_require__(71);
var SpineAnimationMultiTrack = /** @class */ (function (_super) {
    __extends(SpineAnimationMultiTrack, _super);
    function SpineAnimationMultiTrack(spine, name, loop) {
        var _this = _super.call(this) || this;
        _this._completeCallbackMap = {};
        _this._completedTrack = {};
        _this._name = name;
        _this._loop = loop;
        _this._spine = spine;
        return _this;
    }
    SpineAnimationMultiTrack.prototype.setOnComplete = function (callback) {
        this._onceCallback = false;
        this._completeCallback = callback;
    };
    SpineAnimationMultiTrack.prototype.setTrackOnCompleteCallback = function (trackIndex, callback, runOnce) {
        if (runOnce === void 0) { runOnce = true; }
        this._completeCallbackMap[trackIndex] = { callback: callback, runOnce: runOnce };
    };
    SpineAnimationMultiTrack.prototype.removeTrackCompleteCallback = function (trackIndex) {
        this._completeCallbackMap[trackIndex] = null;
    };
    SpineAnimationMultiTrack.prototype.clearAllTrackData = function () {
        this._completeCallbackMap = {};
        this._completedTrack = {};
    };
    SpineAnimationMultiTrack.prototype.setOnceOnComplete = function (callback) {
        this._onceCallback = true;
        this._completeCallback = callback;
    };
    SpineAnimationMultiTrack.prototype.start = function () {
        var _this = this;
        if (!this._isPlaying) {
            _super.prototype.start.call(this);
            if (this.name) {
                this.play(this.name, 0, this._loop);
            }
        }
        this._completed = false;
        this._completedTrack[0] = { isComplete: false, isActive: true };
        this.spineState.clearListeners();
        this.spineState.addListener({
            complete: function (data) {
                if (_this._completedTrack[data.trackIndex] && _this._completedTrack[data.trackIndex].isActive) {
                    _this._completedTrack[data.trackIndex].isComplete = true;
                }
                if (_this.isAllTracksComplete()) {
                    _this._completed = true;
                }
            },
        });
        // initial state.
        if (!this._isPlaying) {
            this.update(0);
        }
    };
    SpineAnimationMultiTrack.prototype.play = function (animationName, track, loop) {
        if (track === void 0) { track = 1; }
        if (loop === void 0) { loop = true; }
        if (!this._spine.skeleton) {
            return;
        }
        var trackEntry = this.spineState.setAnimation(track, animationName, loop);
        this.clearCallback();
        this._completedTrack[track] = { isComplete: false, isActive: true };
        this._completed = false;
        return this;
    };
    SpineAnimationMultiTrack.prototype.playAdd = function (animationName, track, loop) {
        if (track === void 0) { track = 1; }
        if (loop === void 0) { loop = true; }
        if (!this._spine.skeleton) {
            return;
        }
        this.spineState.addAnimation(track, animationName, loop, 0);
        this._completedTrack[track] = { isComplete: false, isActive: true };
        this._completed = false;
        return this;
    };
    SpineAnimationMultiTrack.prototype.playEmpty = function (track, mixDuration) {
        if (mixDuration === void 0) { mixDuration = 0; }
        if (!this._spine.skeleton) {
            return;
        }
        this.spineState.setEmptyAnimation(track, mixDuration);
        return this;
    };
    SpineAnimationMultiTrack.prototype.getAnimationNameOnTrack = function (track) {
        if (this.isSomethingPlayingOnTrack(track)) {
            return this.spineState.getCurrent(track).animation.name;
        }
        return '';
    };
    SpineAnimationMultiTrack.prototype.isSomethingPlayingOnTrack = function (track) {
        return this.spineState.getCurrent(track) === null ? false : true;
    };
    SpineAnimationMultiTrack.prototype.stop = function () {
        this._isPlaying = false;
        // super.stop();
    };
    SpineAnimationMultiTrack.prototype.stopTrack = function (trackIndex, runCompleteCallback) {
        this.spineState.setEmptyAnimation(trackIndex, 0);
        if (runCompleteCallback && this._completeCallbackMap[trackIndex] && this._completeCallbackMap[trackIndex].callback) {
            this._completeCallbackMap[trackIndex].callback();
        }
    };
    SpineAnimationMultiTrack.prototype.forceDestroy = function () {
        this.stop();
        if (this._spine && this._spine.skeleton) {
            this._spine.destroy();
        }
    };
    SpineAnimationMultiTrack.prototype.update = function (dt) {
        this._spine.update(dt);
        for (var track in this._completedTrack) {
            if (this._completedTrack.hasOwnProperty(track)) {
                if (this.hasCompleteCallback(track) && this.isTrackActiveAndComplete(track)) {
                    this.runCompleteCallbackOnTrack(track);
                }
            }
        }
        if (this._completed) {
            this._completed = false;
            this._completeCallback && this._completeCallback();
            if (this._chainedIdle && this.chainIdleAnimation && this.spineState) {
                this.play(this._chainedIdleAnimation, 0, true);
                this.start();
            }
            if (this._onceCallback) {
                this._onceCallback = false;
                this.clearCallback();
            }
        }
    };
    SpineAnimationMultiTrack.prototype.clearCallback = function () {
        this._completeCallback = function () { };
    };
    SpineAnimationMultiTrack.prototype.chainIdleAnimation = function (name) {
        this._chainedIdle = true;
        this._chainedIdleAnimation = name;
    };
    SpineAnimationMultiTrack.prototype.unChainIdleAnimation = function () {
        this._chainedIdle = false;
        this._chainedIdleAnimation = null;
    };
    SpineAnimationMultiTrack.prototype.isAllTracksComplete = function () {
        var complete = true;
        for (var track in this._completedTrack) {
            if (this._completedTrack.hasOwnProperty(track)) {
                var value = this._completedTrack[track].isComplete;
                complete = complete && value;
            }
        }
        return complete;
    };
    SpineAnimationMultiTrack.prototype.trackIsActive = function (trackIndex) {
        return this._completedTrack.hasOwnProperty(trackIndex) && this._completedTrack[trackIndex].isActive;
    };
    SpineAnimationMultiTrack.prototype.trackIsComplete = function (trackIndex) {
        return this._completedTrack.hasOwnProperty(trackIndex) && this._completedTrack[trackIndex].isComplete;
    };
    SpineAnimationMultiTrack.prototype.isTrackActiveAndComplete = function (trackIndex) {
        return (this._completedTrack.hasOwnProperty(trackIndex) &&
            this._completedTrack[trackIndex].isActive &&
            this._completedTrack[trackIndex].isComplete);
    };
    SpineAnimationMultiTrack.prototype.hasCompleteCallback = function (track) {
        return !!this._completeCallbackMap[track] && !!this._completeCallbackMap[track].callback;
    };
    SpineAnimationMultiTrack.prototype.runCompleteCallbackOnTrack = function (track) {
        var trackData = this._completedTrack[track];
        if (trackData.isActive && trackData.isComplete && this.hasCompleteCallback(track)) {
            this._completeCallbackMap[track].callback();
            if (this._completeCallbackMap[track].runOnce) {
                this._completeCallbackMap[track].callback = null;
                this.removeTrackCompleteCallback(track);
            }
        }
    };
    Object.defineProperty(SpineAnimationMultiTrack.prototype, "container", {
        get: function () {
            return this._spine;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpineAnimationMultiTrack.prototype, "name", {
        get: function () {
            return this._name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SpineAnimationMultiTrack.prototype, "spineState", {
        get: function () {
            return this._spine.state;
        },
        enumerable: true,
        configurable: true
    });
    return SpineAnimationMultiTrack;
}(Updatable_1.Updatable));
exports.SpineAnimationMultiTrack = SpineAnimationMultiTrack;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var DragComponent_1 = __webpack_require__(481);
// TODO: Decouple Scrollbar from both PIXI and graphics. Make abstract class and implement from that.
var ScrollbarConstants = /** @class */ (function () {
    function ScrollbarConstants() {
    }
    ScrollbarConstants.SCROLLBAR_WIDTH = 12;
    ScrollbarConstants.SCROLLBAR_WIDTH_MOBILE = 20;
    return ScrollbarConstants;
}());
exports.ScrollbarConstants = ScrollbarConstants;
var AbstractScrollbar = /** @class */ (function () {
    function AbstractScrollbar() {
    }
    AbstractScrollbar.prototype.moveTo = function (newPosition) {
        this._barObject.moveTo(newPosition);
    };
    return AbstractScrollbar;
}());
exports.AbstractScrollbar = AbstractScrollbar;
var Scrollbar = /** @class */ (function (_super) {
    __extends(Scrollbar, _super);
    function Scrollbar(width, totalBarHeight, visibleHeight, containerTotalHeight, bgColor, barColor) {
        if (bgColor === void 0) { bgColor = 0x222222; }
        if (barColor === void 0) { barColor = 0xcccccc; }
        var _this = _super.call(this) || this;
        _this._barWidth = width;
        _this._totalBarHeight = totalBarHeight;
        _this._visibleHeight = visibleHeight;
        _this._containerTotalHeight = containerTotalHeight;
        _this.initialize(width, totalBarHeight, bgColor, barColor);
        return _this;
    }
    Scrollbar.prototype.moveBarObject = function (newPosition) {
        this._barObject.moveTo(newPosition);
    };
    Scrollbar.prototype.onDragUpdateEvent = function (data) {
        this.moveBarObject(1 - data.fractY);
    };
    Scrollbar.prototype.setupInput = function () {
        this.barObject.interactive = this.barObject.buttonMode = true;
    };
    Scrollbar.prototype.updateListeners = function (data) {
        for (var index = 0; index < this._listeningComponents.length; index++) {
            var component = this._listeningComponents[index];
            component.updateFromController(data);
        }
    };
    Scrollbar.prototype.bindListener = function (object) {
        this._listeningComponents.push(object);
    };
    Scrollbar.prototype.unbindListener = function (object) {
        if (this._listeningComponents.indexOf(object) > -1) {
            this._listeningComponents.splice(this._listeningComponents.indexOf(object), 1);
        }
    };
    Scrollbar.prototype.updateFromController = function (data) {
        this.onDragUpdateEvent(data);
    };
    Scrollbar.prototype.initialize = function (width, height, bgColor, barColor) {
        this.createBg(width, height, bgColor);
        this.createBarObject(width, barColor);
    };
    Scrollbar.prototype.createBg = function (width, height, color) {
        var bgGFX = new PIXI.Graphics();
        bgGFX.beginFill(color, 0.5);
        bgGFX.drawRect(0, 0, width, height);
        bgGFX.endFill();
        this._background = new PIXI.Sprite(bgGFX.generateCanvasTexture());
        this.addChild(this._background);
        bgGFX.destroy();
    };
    Scrollbar.prototype.createBarObject = function (width, color) {
        var bgGFX = new PIXI.Graphics();
        var height = (this._visibleHeight / this._containerTotalHeight) * this._totalBarHeight;
        bgGFX.beginFill(color, 0.5);
        bgGFX.drawRect(0, 0, width, height);
        bgGFX.endFill();
        this._barObject = new BarObject(bgGFX.generateCanvasTexture());
        this._barObject.setLimits(0, this._totalBarHeight - height);
        this._barObject.moveTo(0);
        this.addChild(this._barObject);
        bgGFX.destroy();
    };
    Object.defineProperty(Scrollbar.prototype, "barObject", {
        get: function () {
            return this._barObject;
        },
        enumerable: true,
        configurable: true
    });
    return Scrollbar;
}(PIXI.Sprite));
exports.Scrollbar = Scrollbar;
/**
 * An interactive scrollbar that takes input from the user.
 *
 * @export
 * @class InteractiveScrollbar
 * @extends {Scrollbar}
 */
var InteractiveScrollbar = /** @class */ (function (_super) {
    __extends(InteractiveScrollbar, _super);
    function InteractiveScrollbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InteractiveScrollbar.prototype.setupInteraction = function (updateManager, targetContainer, isMobile, targetLimits) {
        this._dragComponent = new DragComponent_1.DragComponent(updateManager, targetContainer, this._barObject, isMobile);
        this._dragComponent.maxY = targetLimits.maxY;
        this._dragComponent.minY = targetLimits.minY;
        this._dragComponent.maxX = targetContainer.x;
        this._dragComponent.minX = targetContainer.x;
        this._dragComponent.interactionMaxY = this._barObject.maxY;
        this._dragComponent.interactionMinY = this._barObject.minY;
        this._dragComponent.interactionMaxX = this._barObject.x;
        this._dragComponent.interactionMinX = this._barObject.x;
        this._dragComponent.canDrag = true;
    };
    InteractiveScrollbar.prototype.canDrag = function (bool) {
        this._dragComponent.canDrag = bool;
    };
    InteractiveScrollbar.prototype.createBarObject = function (width, color) {
        var bgGFX = new PIXI.Graphics();
        var height = (this._visibleHeight / this._containerTotalHeight) * this._totalBarHeight;
        bgGFX.beginFill(color, 0.5);
        bgGFX.drawRect(0, 0, width, height);
        bgGFX.endFill();
        this._barObject = new InteractiveBarObject(bgGFX.generateCanvasTexture());
        this._barObject.setLimits(0, this._totalBarHeight - height);
        this._barObject.moveTo(0);
        this.addChild(this._barObject);
        bgGFX.destroy();
    };
    InteractiveScrollbar.prototype.onTouch = function () {
        // this._dragComponent.
    };
    InteractiveScrollbar.prototype.addEventListeners = function () { };
    InteractiveScrollbar.prototype.clearEventListeners = function () { };
    return InteractiveScrollbar;
}(Scrollbar));
exports.InteractiveScrollbar = InteractiveScrollbar;
/**
 * Base Bar Object.
 *
 * @class BarObject
 * @extends {PIXI.Sprite}
 */
var BarObject = /** @class */ (function (_super) {
    __extends(BarObject, _super);
    function BarObject(texture) {
        var _this = _super.call(this, texture) || this;
        _this._minY = 0;
        _this._maxY = 0;
        return _this;
    }
    /**
     *
     * @param {number} newY Should be provided in a 0-1 range from max to min.
     * @memberof BarObject
     */
    BarObject.prototype.moveTo = function (newY) {
        newY = Math.abs(this._minY - this._maxY) * newY;
        newY = newY > this._maxY ? this._maxY : newY < this._minY ? this._minY : newY;
        this.y = newY;
    };
    BarObject.prototype.setLimits = function (minY, maxY) {
        this._minY = minY ? minY : 0;
        this._maxY = maxY ? maxY : 0;
    };
    Object.defineProperty(BarObject.prototype, "minY", {
        get: function () {
            return this._minY;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarObject.prototype, "maxY", {
        get: function () {
            return this._maxY;
        },
        enumerable: true,
        configurable: true
    });
    return BarObject;
}(PIXI.Sprite));
/**
 * Interactive bar object, takes input from user.
 *
 * @class InteractiveBarObject
 * @extends {BarObject}
 */
var InteractiveBarObject = /** @class */ (function (_super) {
    __extends(InteractiveBarObject, _super);
    function InteractiveBarObject(texture) {
        var _this = _super.call(this, texture) || this;
        _this.interactive = _this.buttonMode = true;
        return _this;
    }
    InteractiveBarObject.prototype.enable = function () {
        this.interactive = this.buttonMode = true;
    };
    InteractiveBarObject.prototype.disable = function () {
        this.interactive = this.buttonMode = false;
    };
    return InteractiveBarObject;
}(BarObject));


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Communicator = /** @class */ (function () {
    function Communicator() {
    }
    Object.defineProperty(Communicator.prototype, "tokenID", {
        get: function () {
            return this._tokenID;
        },
        set: function (value) {
            this._tokenID = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Communicator.prototype, "regulatedMarket", {
        get: function () {
            return this._regulatedMarket;
        },
        set: function (value) {
            this._regulatedMarket = value;
        },
        enumerable: true,
        configurable: true
    });
    return Communicator;
}());
exports.Communicator = Communicator;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var UserStorage = /** @class */ (function () {
    function UserStorage() {
    }
    return UserStorage;
}());
exports.UserStorage = UserStorage;
var BaseStorage = /** @class */ (function () {
    function BaseStorage() {
    }
    BaseStorage.prototype.setItem = function (key, value) {
        localStorage.setItem(key, value);
    };
    BaseStorage.prototype.getItem = function (key) {
        return localStorage.getItem(key);
    };
    BaseStorage.prototype.getKey = function (key) {
        return localStorage.key(key);
    };
    BaseStorage.prototype.removeItem = function (key) {
        localStorage.removeItem(key);
    };
    BaseStorage.prototype.hasItem = function (key) {
        return localStorage.hasItem(key);
    };
    BaseStorage.prototype.each = function (key) {
    };
    BaseStorage.prototype.clear = function () {
        localStorage.clear();
    };
    return BaseStorage;
}());
exports.BaseStorage = BaseStorage;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// TODO: DI this maybe? To keep a single keyboard input setup and better track of keys.
// Listen to events? Add event handler?
var DebuggingComponent = /** @class */ (function () {
    function DebuggingComponent(mod, view) {
        this._hasAddedKeyboardInput = false;
        this._keyMap = {};
        this._functionMap = {};
        this._module = mod;
        this._view = view;
        this.init();
    }
    DebuggingComponent.prototype.init = function () {
    };
    DebuggingComponent.prototype.addKeyFunction = function (key, name, callback, keyOptions) {
        if (keyOptions === void 0) { keyOptions = { shiftKey: false, altKey: false, ctrlKey: false }; }
        this._keyMap[key] = { name: name, options: keyOptions };
        this._functionMap[name] = callback;
    };
    DebuggingComponent.prototype.addFunction = function (name, callback) {
        this._functionMap[name] = callback;
    };
    /**
     * Adds a window call function. To use: window['name'](...args);
     *
     * @param {string} name
     * @param {Function} func
     * @memberof DebuggingComponent
     */
    DebuggingComponent.prototype.addWindowFunction = function (name, func) {
        window[name] = func;
        if (!window.debuggingFunctions && typeof window.debuggingFunctions !== 'object') {
            window.debuggingFunctions = [];
        }
        window.debuggingFunctions.push(name);
    };
    /**
     * Adds keyboardinput.
     * @memberof DebuggingComponent
     */
    DebuggingComponent.prototype.setupInput = function () {
        if (!this._hasAddedKeyboardInput) {
            this._hasAddedKeyboardInput = true;
            document.addEventListener('keydown', this.keyboardInput.bind(this));
        }
    };
    DebuggingComponent.prototype.keyboardInput = function (event) {
        this.runKeyFunction(event.code, { altKey: event.altKey, ctrlKey: event.ctrlKey, shiftKey: event.shiftKey });
    };
    DebuggingComponent.prototype.runKeyFunction = function (key, keyOptions) {
        if (this._keyMap[key] && this.compareOptions(this._keyMap[key].options, keyOptions)) {
            this._functionMap[this._keyMap[key].name]();
        }
    };
    DebuggingComponent.prototype.compareOptions = function (base, comparison) {
        return base.altKey === comparison.altKey && base.ctrlKey === comparison.ctrlKey && base.shiftKey === comparison.shiftKey;
    };
    DebuggingComponent.prototype.runFunction = function (name) {
        if (this._functionMap[name] && this._functionMap[name].call) {
            this._functionMap[name]();
        }
    };
    DebuggingComponent.prototype.logAllKeys = function () {
        for (var item in this._keyMap) {
            if (this._keyMap.hasOwnProperty(item)) {
                var element = this._keyMap[item];
                console.log(element);
            }
        }
    };
    DebuggingComponent.prototype.logAllFunctions = function () {
        this._functionMap.forEach(function (item) {
            console.log(item);
        });
    };
    Object.defineProperty(DebuggingComponent.prototype, "view", {
        get: function () {
            return this._view;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DebuggingComponent.prototype, "module", {
        get: function () {
            return this._module;
        },
        enumerable: true,
        configurable: true
    });
    return DebuggingComponent;
}());
exports.DebuggingComponent = DebuggingComponent;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MenuButtonEvents = /** @class */ (function () {
    function MenuButtonEvents() {
    }
    MenuButtonEvents.MENU_BUTTON_CLICKED = 'MenuButtonEvents::MENU_BUTTON_CLICKED';
    return MenuButtonEvents;
}());
exports.MenuButtonEvents = MenuButtonEvents;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MenuButtonViewEvents = /** @class */ (function () {
    function MenuButtonViewEvents() {
    }
    MenuButtonViewEvents.MENU_BUTTON_CLICKED = 'MenuButtonViewEvents::__MENU_BUTTON_CLICKED__';
    MenuButtonViewEvents.STOP_MENU_BUTTON_CLICKED = 'MenuButtonViewEvents::__STOP_MENU_BUTTON_CLICKED__';
    return MenuButtonViewEvents;
}());
exports.MenuButtonViewEvents = MenuButtonViewEvents;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AnimationNames = /** @class */ (function () {
    function AnimationNames() {
    }
    AnimationNames.GENERIC_BUTTON = {
        Name: {
            IDLE: 'IDLE',
            HOVER: 'HOVER',
            CLICK: 'CLICK',
        },
        Mix: {},
    };
    AnimationNames.MAIN_MENU = {
        Name: {
            IDLE_VISIBLE: 'IDLE',
            IDLE_HIDDEN: 'HIDDEN',
            ENTER: 'BACKGROUND_POPUP',
            EXIT: 'BACKGROUND_EXIT',
        },
        Mix: {},
    };
    AnimationNames.SETTINGS_CONFIG_TOGGLE = {
        Name: {
            ACTIVE: 'SETTINGS_BUTTON_ACTIVE_IDLE',
            INACTIVE: 'SETTINGS_BUTTON_IDLE',
            ACTIVATED: 'SETTINGS_BUTTON_ACTIVE',
        },
        Mix: {},
    };
    return AnimationNames;
}());
exports.AnimationNames = AnimationNames;
var IAnimationNamesObject = /** @class */ (function () {
    function IAnimationNamesObject() {
    }
    return IAnimationNamesObject;
}());
exports.IAnimationNamesObject = IAnimationNamesObject;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var SpineAnimation_1 = __webpack_require__(37);
var Easing_1 = __webpack_require__(16);
var View_1 = __webpack_require__(3);
var ReelConstants_1 = __webpack_require__(10);
var ReelsUtils_1 = __webpack_require__(112);
var ReelSymbol_1 = __webpack_require__(156);
var WinMeter_1 = __webpack_require__(113);
var WinNumbers_1 = __webpack_require__(45);
var Tween_1 = __webpack_require__(19);
var GlowFilter_1 = __webpack_require__(523);
var Timer_1 = __webpack_require__(28);
var WinPresentationView = /** @class */ (function (_super) {
    __extends(WinPresentationView, _super);
    function WinPresentationView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._winPresentationAnimations = [];
        _this._winSymbols = [];
        _this._isPlayingEndAnimation = false;
        _this._currentSymbolsAnimations = [];
        return _this;
    }
    WinPresentationView.prototype.init = function () {
        _super.prototype.init.call(this);
        this.setupCurrencyFormatter();
        this.initContainers();
        this.createWinSymbols();
        this.createWinTextContainer();
        this._winLineBlur1 = new PIXI.filters.BlurFilter();
        this._winLineBlur1.blur = 16;
        this._winLineBlur2 = new PIXI.filters.BlurFilter();
        this._winLineBlur2.blur = 4;
    };
    WinPresentationView.prototype.playWinPresentationFor = function (isInitial, winLines, reels, reelsToSkip, addLine, PAYLINES) {
        this.killCurrentWinPresentation();
        this.hideWinPresentationSymbols();
        if (addLine && !isInitial) {
            this.tryToAddWinLines(winLines, PAYLINES);
        }
        this.addWinSymbolsIndication(winLines, reels, reelsToSkip);
    };
    WinPresentationView.prototype.playWinPresentationBeforeBigWin = function (isInitial, winLines, reels, reelsToSkip, addLine, PAYLINES) {
        this.killCurrentWinPresentation();
        this.hideWinPresentationSymbols();
        if (addLine && !isInitial) {
            this.tryToAddWinLines(winLines, PAYLINES);
        }
        this.addWinSymbolsIndicationBeforeBigWin(winLines, reels, reelsToSkip);
    };
    WinPresentationView.prototype.tryToAddWinLines = function (winLines, PAYLINES) {
        if (winLines[0]) {
            var nonWinningPartOfLine = this.buildNonWinPositionsOfLine(winLines[0].positions, winLines[0].index, PAYLINES);
            if (nonWinningPartOfLine.length > 0) {
                var lastWinningSymbolIndex = winLines[0].positions.length - 1;
                var lineWidth = this.device.isMobile
                    ? WinPresentationView.MOBILE_WINLINE_WIDTH
                    : WinPresentationView.DESKTOP_WINLINE_WIDTH;
                var winLine = this.buildWinLine(winLines[0].positions[lastWinningSymbolIndex], nonWinningPartOfLine, lineWidth);
                this._winLinesContainer.addChild(winLine);
            }
        }
    };
    WinPresentationView.prototype.addWinSymbolsIndication = function (winLines, reels, reelsToSkip) {
        for (var _i = 0, winLines_1 = winLines; _i < winLines_1.length; _i++) {
            var line = winLines_1[_i];
            for (var _a = 0, _b = line.positions; _a < _b.length; _a++) {
                var pos = _b[_a];
                if (!reelsToSkip || reelsToSkip.indexOf(pos.x) === -1) {
                    var sym = this.createAndAddWinSymbol(pos, reels);
                    var wpFilter = new GlowFilter_1.GlowFilter(20, 6, 2, 0xffff00);
                    sym.filters = [wpFilter];
                    this._winSymbolsContainer.addChild(sym);
                    this.emit(WinPresentationView.WIN_ANIMATION_PLAYING_FOR_SYMBOL, pos);
                }
            }
        }
        this.onInitialWinAnimationFinished();
    };
    WinPresentationView.prototype.addWinSymbolsIndicationBeforeBigWin = function (winLines, reels, reelsToSkip) {
        for (var _i = 0, winLines_2 = winLines; _i < winLines_2.length; _i++) {
            var line = winLines_2[_i];
            for (var _a = 0, _b = line.positions; _a < _b.length; _a++) {
                var pos = _b[_a];
                if (!reelsToSkip || reelsToSkip.indexOf(pos.x) === -1) {
                    var sym = this.createAndAddWinSymbol(pos, reels);
                    var wpFilter = new GlowFilter_1.GlowFilter(20, 6, 2, 0xffff00);
                    sym.filters = [wpFilter];
                    this._winSymbolsContainer.addChild(sym);
                    this.emit(WinPresentationView.WIN_ANIMATION_PLAYING_FOR_SYMBOL, pos);
                }
            }
        }
        this.onInitialWinAnimationFinishedBeforeBigWin();
    };
    WinPresentationView.prototype.buildNonWinPositionsOfLine = function (winSymbols, lineIndex, PAYLINES) {
        var nonWinningPositions = [];
        for (var i = winSymbols.length; i < ReelConstants_1.ReelConstants.REELS_AMOUNT; i++) {
            // TODO: Replace this.
            var rowPos = PAYLINES[lineIndex][i];
            nonWinningPositions.push({ x: i, y: rowPos });
        }
        return nonWinningPositions;
    };
    WinPresentationView.prototype.killCurrentWinPresentation = function () {
        this.killAllSpineAnimations();
        this.killWinLines();
        this.hideWinPresentationSymbols();
        this.killWinSymbols();
        if (this._meter) {
            this._meter.stop();
            this._meter = null;
        }
        for (var _i = 0, _a = this._winPresentationAnimations; _i < _a.length; _i++) {
            var anim = _a[_i];
            this.spineUtils.stopAndDestroyAnimation(anim);
        }
        this._winPresentationAnimations = [];
    };
    WinPresentationView.prototype.hideWinPresentationSymbols = function () {
        for (var reelIndex = 0; reelIndex < ReelConstants_1.ReelConstants.REELS_AMOUNT; reelIndex++) {
            for (var rowIndex = 0; rowIndex < ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT; rowIndex++) {
                this._winSymbols[reelIndex][rowIndex].visible = false;
                this._winSymbols[reelIndex][rowIndex].alpha = 1;
            }
        }
    };
    WinPresentationView.prototype.playWinNumberCounter = function (finalNumber, isAboveNormalWin, level, isIndividualWin) {
        var _this = this;
        this._currentFinalNumber = finalNumber;
        this.forceKillWinNumbers();
        this._isPlayingEndAnimation = false;
        if (isAboveNormalWin && level === 3) {
            this._currentWinNumbers = this._biggerWinNumber;
        }
        else {
            this._currentWinNumbers = this._winNumber;
        }
        this.initMeter();
        this._currentLevel = level;
        if (isAboveNormalWin) {
            this._meter.resolutionPadding = 100;
            this._meter.resolutionWidth = this.resolutionManager.resolution.width - 50;
            this._meter.from(0).to(finalNumber, this.getCountingTime());
        }
        else {
            this._meter.from(finalNumber).to(finalNumber, this.getCountingTime());
            this._meter.resolutionWidth = this.resolutionManager.resolution.width - 50;
        }
        this._meter.start();
        this.updateManager.add(this._meter);
        this.killCurrentAnimation();
        this._isEndingAnimationInProgress = false;
        var animPosition = this.getAnimationPosition();
        this._currentWinNumberAnimation = this.spineUtils
            .startSpineAnimationCreation('WIN_NUMBERS.json', 'START', false)
            .position(animPosition)
            .chainIdleAnimation('IDLE')
            .onComplete(function () {
            _this.emitWinNumberBounceFinished();
            _this.scaleNumbersDown();
            if (!isAboveNormalWin && !isIndividualWin) {
                _this.emitWinNumberShownToPlayer();
            }
        })
            .createAndStart();
        this.spineUtils.replaceElementInSpineAnimation(this._currentWinNumberAnimation, 'NUMBER', this._currentWinNumbers);
        var zeroNumber = this.currencyFormatter.formatCurrency(0);
        this._currentWinNumbers.showNumber(zeroNumber);
        this._currentWinNumbers.visible = true;
    };
    WinPresentationView.prototype.getAnimationPosition = function () {
        return { x: ReelConstants_1.ReelConstants.getReelsCenter().x, y: ReelConstants_1.ReelConstants.getReelsCenter().y - ReelConstants_1.ReelConstants.getSymbolSlot().height / 2 };
    };
    WinPresentationView.prototype.skipWin = function (finalNumber, isAboveNormalWin) {
        if (this._isPlayingEndAnimation) {
            return;
        }
        if (!this._meter) {
            this._isPlayingEndAnimation = false;
            if (isAboveNormalWin && this._currentLevel === 3) {
                this._currentWinNumbers = this._biggerWinNumber;
            }
            else {
                this._currentWinNumbers = this._winNumber;
            }
            this.initMeter();
            this._meter.start();
            this.updateManager.add(this._meter);
            this._meter.from(finalNumber).to(finalNumber, this.getCountingTime());
            this._currentWinNumbers.visible = true;
        }
        this.playWinEndAnimation();
    };
    WinPresentationView.prototype.playWinEndAnimation = function () {
        var _this = this;
        this.stopDelayWinEndTimer();
        if (this._isPlayingEndAnimation) {
            return;
        }
        this._isPlayingEndAnimation = true;
        if (!this._isEndingAnimationInProgress) {
            if (!this._meter) {
                this.initMeter();
                this._meter.from(this._currentFinalNumber).to(this._currentFinalNumber, this.getCountingTime());
            }
            this.killCurrentAnimation();
            this._meter.snapToFinalValue();
            this._isEndingAnimationInProgress = true;
            var animPosition = this.getAnimationPosition();
            this._currentWinNumberAnimation = this.spineUtils
                .startSpineAnimationCreation('WIN_NUMBERS.json', 'EXIT', false)
                .position(animPosition)
                .onComplete(function () {
                _this._isEndingAnimationInProgress = false;
                _this.emit(WinPresentationView.WIN_ANIMATION_FINISHED);
            })
                .createAndStart();
            this.spineUtils.replaceElementInSpineAnimation(this._currentWinNumberAnimation, 'NUMBER', this._currentWinNumbers);
            this.endAllWinIndications();
            this._meter.forceUpdate();
            this.emit(WinPresentationView.COUNTUP_ANIMATION_FINISHED);
        }
    };
    WinPresentationView.prototype.endAllWinIndications = function () {
        for (var _i = 0, _a = this._winPresentationAnimations; _i < _a.length; _i++) {
            var anim = _a[_i];
            if (anim.isPlaying) {
                if (anim.hasAnimationWithName('EXIT')) {
                    anim.changeAnimationTo('EXIT', false);
                }
                anim.unChainIdleAnimation();
            }
        }
    };
    WinPresentationView.prototype.stopDelayWinEndTimer = function () {
        if (this._delayPlayWinEndTimer && this._delayPlayWinEndTimer.isPlaying) {
            this._delayPlayWinEndTimer.stop();
            this._delayPlayWinEndTimer = null;
        }
    };
    WinPresentationView.prototype.forceKillWinNumbers = function () {
        if (this._currentWinNumbers) {
            this._currentWinNumbers.visible = false;
        }
    };
    WinPresentationView.prototype.setupCurrencyFormatter = function () {
        if (this._winNumber && this._biggerWinNumber) {
            this._winNumber.currencyISO = this._biggerWinNumber.currencyISO = this.currencyFormatter.currency;
            this._winNumber.currencySign = this._biggerWinNumber.currencySign = this.currencyFormatter.currencySign;
        }
    };
    Object.defineProperty(WinPresentationView.prototype, "winTextContainer", {
        set: function (value) {
            this._winTextContainer = value;
            var winnumberResource = this.getWinnumberResource(this.device.isMobile, false);
            this._winNumber = new WinNumbers_1.WinNumbers(this.resources, winnumberResource);
            this._winNumber.numberAnchor = { x: 0, y: 0.5 };
            this._winTextContainer.addChild(this._winNumber);
            this._winNumber.visible = false;
            var biggerWinNumberResource = this.getWinnumberResource(this.device.isMobile, true);
            this._biggerWinNumber = new WinNumbers_1.WinNumbers(this.resources, biggerWinNumberResource);
            this._biggerWinNumber.numberAnchor = { x: 0, y: 0.5 };
            this._winTextContainer.addChild(this._biggerWinNumber);
            this._biggerWinNumber.visible = false;
            this.setupWinNumbersSettings();
        },
        enumerable: true,
        configurable: true
    });
    WinPresentationView.prototype.getWinnumberResource = function (isMobile, isBigger) {
        if (isBigger) {
            return isMobile ? 'MED_' : 'MED_';
        }
        return isMobile ? 'SMALL_' : 'MED_';
    };
    WinPresentationView.prototype.initContainers = function () {
        this._winLinesContainer = new PIXI.Container();
        this._winSymbolsContainer = new PIXI.Container();
        this.container.addChild(this._winLinesContainer);
        this.container.addChild(this._winSymbolsContainer);
    };
    WinPresentationView.prototype.buildWinLine = function (prevSymbol, positions, lineWidth) {
        if (lineWidth === void 0) { lineWidth = 15; }
        var container = new PIXI.Container();
        var startPos = ReelConstants_1.ReelConstants.getSymbolPosition(prevSymbol);
        startPos.x += ReelConstants_1.ReelConstants.getSymbolSlot().width / 2;
        if (prevSymbol.y > positions[0].y) {
            startPos.y -= ReelConstants_1.ReelConstants.getSymbolSlot().height / 2;
        }
        if (prevSymbol.y < positions[0].y) {
            startPos.y += ReelConstants_1.ReelConstants.getSymbolSlot().height / 2;
        }
        var endPos = ReelConstants_1.ReelConstants.getSymbolPosition(positions[positions.length - 1]);
        endPos.x += ReelConstants_1.ReelConstants.getSymbolSlot().width / 2;
        var line1 = this.makeGraphicsLine(startPos, endPos, positions, lineWidth * 1.5, 0xfbc30b, 1);
        var line3 = this.makeGraphicsLine(startPos, endPos, positions, lineWidth, 0xffffff);
        var line1Container = new PIXI.Container();
        var line3Container = new PIXI.Container();
        container.addChild(line1Container);
        container.addChild(line3Container);
        line1Container.addChild(line1);
        line3Container.addChild(line3);
        if (this.device.desktop) {
            line1Container.filters = [this._winLineBlur1];
            var line2Container = new PIXI.Container();
            container.addChildAt(line2Container, 1);
            var line2 = this.makeGraphicsLine(startPos, endPos, positions, lineWidth * 1.2, 0xfbc30b, 1);
            line2Container.addChild(line2);
            line2Container.filters = [this._winLineBlur1];
        }
        return container;
    };
    WinPresentationView.prototype.makeGraphicsLine = function (startPos, endPos, positions, lineWidth, lineColor, lineAlpha) {
        if (lineWidth === void 0) { lineWidth = 15; }
        if (lineColor === void 0) { lineColor = 0xaa0000; }
        if (lineAlpha === void 0) { lineAlpha = 1; }
        var line = new PIXI.Graphics();
        line.lineStyle(lineWidth, lineColor, lineAlpha);
        line.moveTo(startPos.x, startPos.y);
        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
            var pos = positions_1[_i];
            var symPos = ReelConstants_1.ReelConstants.getSymbolPosition(pos);
            line.lineTo(symPos.x, symPos.y);
        }
        line.lineTo(endPos.x, endPos.y);
        return line;
    };
    WinPresentationView.prototype.killWinLines = function () {
        this._winLinesContainer.removeChildren();
    };
    WinPresentationView.prototype.killWinSymbols = function () {
        this._winSymbolsContainer.removeChildren();
    };
    WinPresentationView.prototype.addAllSymbolsIntoSprite = function (spr, resources) {
        throw new Error('WinPresentationView::addAllSymbolsIntoSprite must be overriden');
    };
    WinPresentationView.prototype.addBackgroundsIntoSprite = function (spr, resources) {
        throw new Error('WinPresentationView::addBackgroundsIntoSprite must be overriden');
    };
    WinPresentationView.prototype.getSizedSimpleWinAnimationName = function (isInitial, size) {
        throw new Error('WinPresentationView::getSizedSimpleWinAnimationName must be overriden');
    };
    WinPresentationView.prototype.addForegroundIntoSprite = function (spr) {
        throw new Error('WinPresentationView::addForegroundIntoSprite must be overriden');
    };
    WinPresentationView.prototype.makeSizedSymbol = function (symbol, size) {
        if (size === void 0) { size = { width: 1, height: 1 }; }
        throw new Error('WinPresentationView::makeSizedSymbol must be overriden');
    };
    WinPresentationView.prototype.getWinSymbolPosition = function (posOnReels, reels) {
        var position = ReelsUtils_1.ReelsUtils.getPositionOnReels(posOnReels, reels);
        return {
            x: position.x - ReelConstants_1.ReelConstants.getSymbolSlot().width / 2,
            y: position.y - ReelConstants_1.ReelConstants.getSymbolSlot().height / 2,
        };
    };
    WinPresentationView.prototype.createWinTextContainer = function () {
        var winTextContainer = new PIXI.Container();
        var winTextPosition = this.layout.getPosition('WIN_POSITION');
        winTextContainer.position.set(winTextPosition.x, winTextPosition.y);
        this.container.addChild(winTextContainer);
        this.winTextContainer = winTextContainer;
    };
    WinPresentationView.prototype.createWinSymbols = function () {
        for (var reelIndex = 0; reelIndex < ReelConstants_1.ReelConstants.REELS_AMOUNT; reelIndex++) {
            this._winSymbols[reelIndex] = [];
            for (var rowIndex = 0; rowIndex < ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT; rowIndex++) {
                var symbolsSprite = new PIXI.Sprite();
                this.addAllSymbolsIntoSprite(symbolsSprite, this.resources);
                var symbolBackground = new PIXI.Sprite();
                this.addBackgroundsIntoSprite(symbolBackground, this.resources);
                var symbolForeground = new PIXI.Sprite();
                this.addForegroundIntoSprite(symbolForeground);
                var symbol = this.createReelSymbol();
                symbol.setSpineUtils(this.spineUtils);
                symbol.init(symbolsSprite, symbolBackground, symbolForeground);
                symbol.setSymbol(1);
                var offsets = {
                    x: ReelConstants_1.ReelConstants.getReelsOffsets().x + reelIndex * ReelConstants_1.ReelConstants.getSymbolSlot().width,
                    y: ReelConstants_1.ReelConstants.getReelsOffsets().y,
                };
                symbol.x = offsets.x;
                symbol.y = offsets.y + rowIndex * ReelConstants_1.ReelConstants.getSymbolSlot().height;
                symbol.visible = false;
                this._winSymbolsContainer.addChild(symbol);
                this._winSymbols[reelIndex][rowIndex] = symbol;
            }
        }
    };
    WinPresentationView.prototype.createAndAddWinSymbol = function (pos, reels) {
        var sym = this._winSymbols[pos.x][pos.y];
        var symSize = reels[pos.x][pos.y].size;
        var symPosition = this.getWinSymbolPosition(pos, reels);
        sym.visible = true;
        sym.x = symPosition.x;
        sym.y = symPosition.y;
        sym.setSymbol(this.makeSizedSymbol(reels[pos.x][pos.y].sym, symSize));
        return sym;
    };
    WinPresentationView.prototype.killAllSpineAnimations = function () {
        for (var _i = 0, _a = this._currentSymbolsAnimations; _i < _a.length; _i++) {
            var anim = _a[_i];
            if (anim instanceof SpineAnimation_1.SpineAnimation) {
                this.spineUtils.stopAndDestroyAnimation(anim);
            }
            if (anim instanceof Tween_1.Tween) {
                anim.stop();
            }
        }
        this._currentSymbolsAnimations = [];
    };
    WinPresentationView.prototype.getSumOfHeightsBefore = function (symPos, reels) {
        var sum = 0;
        for (var i = reels[symPos.x].length - 1; i >= symPos.y; i--) {
            sum += reels[symPos.x][i].size.height;
        }
        return sum;
    };
    WinPresentationView.prototype.onInitialWinAnimationFinished = function () {
        this.emitDelayed(WinPresentationView.INITIAL_WIN_ANIMATION_FINISHED);
    };
    WinPresentationView.prototype.onInitialWinAnimationFinishedBeforeBigWin = function () {
        this.emitDelayed(WinPresentationView.INITIAL_WIN_ANIMATION_FINISHED);
        this.emitDelayed(WinPresentationView.WIN_ANIMATION_FINISHED);
    };
    WinPresentationView.prototype.setupMeter = function () {
        this._meter.resolutionPadding = 100;
        this._meter.resolutionWidth = this.resolutionManager.resolution.width;
    };
    WinPresentationView.prototype.getCurrentWinNumbersPosition = function () {
        return {
            x: ReelConstants_1.ReelConstants.getReelsOffsets().x + ReelConstants_1.ReelConstants.getSymbolSlot().width * (ReelConstants_1.ReelConstants.REELS_AMOUNT / 2),
            y: ReelConstants_1.ReelConstants.getReelsOffsets().y +
                ReelConstants_1.ReelConstants.getSymbolSlot().height +
                (ReelConstants_1.ReelConstants.ROW_AMOUNT / 2) * ReelConstants_1.ReelConstants.getSymbolSlot().height,
        };
    };
    WinPresentationView.prototype.scaleNumbersDown = function () {
        var parent = this._currentWinNumbers.container;
        if (this._currentWinNumbers.totalWidth > this.resolutionManager.resolution.width) {
            var width = this._currentWinNumbers.totalWidth;
            parent.scale.set(this.resolutionManager.resolution.width / width);
        }
        else {
            parent.scale.set(1);
        }
    };
    WinPresentationView.prototype.emitWinNumberBounceFinished = function () {
        this.emit(WinPresentationView.WIN_NUMBER_BOUNCE_FINISHED);
    };
    WinPresentationView.prototype.emitWinNumberShownToPlayer = function () {
        this.emit(WinPresentationView.WIN_NUMBER_SHOWN_TO_PLAYER);
    };
    WinPresentationView.prototype.initMeter = function () {
        this._meter = new WinMeter_1.WinMeter(this._currentWinNumbers, Easing_1.Easing.Linear.None, this.currencyFormatter, true);
        this._meter.onCompleteCallback = this.onMeterFinished.bind(this);
    };
    WinPresentationView.prototype.killCurrentAnimation = function () {
        this.spineUtils.stopAndDestroyAnimation(this._currentWinNumberAnimation);
    };
    WinPresentationView.prototype.onMeterFinished = function () {
        var _this = this;
        var delay = 0;
        if (this._currentLevel === 2) {
            delay = 300;
        }
        if (this._currentLevel === 3) {
            delay = 600;
        }
        this._delayPlayWinEndTimer = new Timer_1.Timer(function () {
            _this.playWinEndAnimation();
        }, delay, true);
        this.updateManager.add(this._delayPlayWinEndTimer);
    };
    WinPresentationView.prototype.getCountingTime = function () {
        switch (this._currentLevel) {
            case 2:
                return 1000;
            case 3:
                return 2300;
            default:
                return 2000;
        }
    };
    WinPresentationView.prototype.createReelSymbol = function () {
        return new ReelSymbol_1.ReelSymbol();
    };
    WinPresentationView.prototype.setupWinNumbersSettings = function () {
        this._winNumber.currencyISO = this.currencyFormatter.currency;
        this._winNumber.currencySign = this.currencyFormatter.currencySign;
        this._biggerWinNumber.currencyISO = this.currencyFormatter.currency;
        this._biggerWinNumber.currencySign = this.currencyFormatter.currencySign;
    };
    WinPresentationView.COUNTUP_ANIMATION_FINISHED = 'WinPresentationView::COUNTUP_ANIMATION_FINISHED';
    WinPresentationView.COUNTUP_ANIMATION_STARTED = 'WinPresentationView::COUNTUP_ANIMATION_STARTED';
    WinPresentationView.WIN_NUMBER_SHOWN_TO_PLAYER = 'WinPresentationView::WIN_NUMBER_SHOWN_TO_PLAYER';
    WinPresentationView.WIN_NUMBER_BOUNCE_FINISHED = 'WinPresentationView::NUMBER_BOUNCE_FINISHED';
    WinPresentationView.WIN_ANIMATION_PLAYING_FOR_SYMBOL = 'WinPresentationView::WIN_ANIMATION_PLAYING_FOR_SYMBOL';
    // win indication + extra time to check it
    WinPresentationView.WIN_ANIMATION_FINISHED = 'WinPresentationView::WIN_ANIMATION_FINISHED';
    // win symbols indication animation finished
    WinPresentationView.INITIAL_WIN_ANIMATION_FINISHED = 'WinPresentationView::INITIAL_WIN_ANIMATION_FINISHED';
    WinPresentationView.DESKTOP_WINLINE_WIDTH = 15;
    WinPresentationView.MOBILE_WINLINE_WIDTH = 10;
    WinPresentationView.FREESPIN_WINANIMATION_FINISHED_DELAY = 3000;
    WinPresentationView.BASEGAME_WINANIMATION_FINISHED_DELAY = 500;
    return WinPresentationView;
}(View_1.View));
exports.WinPresentationView = WinPresentationView;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ReelConstants_1 = __webpack_require__(10);
var ReelSymbol = /** @class */ (function (_super) {
    __extends(ReelSymbol, _super);
    function ReelSymbol() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._viewType = ReelConstants_1.ReelConstants.DEFAULT_VIEW;
        _this._size = { width: 1, height: 1 };
        return _this;
    }
    ReelSymbol.prototype.init = function (parentSym, background, foreground, spinningSymbol) {
        this.setupLayersOrder(parentSym, background, foreground, spinningSymbol);
    };
    ReelSymbol.prototype.setupLayersOrder = function (parentSym, background, foreground, spinningSymbol) {
        this._container = new PIXI.Container();
        this.addChild(this._container);
        this._symbolContainer = new PIXI.Sprite();
        this._container.addChild(this._symbolContainer);
        if (background) {
            this._symbolContainer.addChild(background);
        }
        this._symbolContainer.addChild(parentSym);
        if (foreground) {
            this._symbolContainer.addChild(foreground);
        }
        if (spinningSymbol) {
            this._symbolContainer.addChild(spinningSymbol);
            this._spinningSymbol = spinningSymbol;
        }
        this._symbol = parentSym;
        this._symbolBackground = background;
        this._symbolForeground = foreground;
    };
    ReelSymbol.prototype.setContainerParameters = function () { };
    ReelSymbol.prototype.removeContainerParemeters = function () { };
    ReelSymbol.prototype.setSymbol = function (symbolID) {
        this.hideSymbol();
        this.hideSpinningSymbol();
        this._symbol.getChildAt(symbolID).visible = true;
        this._symbolType = symbolID;
        this.setupSymbol();
        if (this._symbolBackground) {
            this.setupBackground();
            this._symbolBackground.visible = this.hasBackground();
        }
        if (this._symbolForeground) {
            this.setupForeground();
            this._symbolForeground.visible = this.hasForeground();
        }
    };
    ReelSymbol.prototype.setSpinningSymbol = function (symbolID) {
        this.hideSymbol();
        this.hideSpinningSymbol();
        this._spinningSymbol.getChildAt(symbolID).visible = true;
        this._symbolType = symbolID;
    };
    ReelSymbol.prototype.hideSymbol = function () {
        for (var _i = 0, _a = this._symbol.children; _i < _a.length; _i++) {
            var child = _a[_i];
            child.visible = false;
        }
    };
    ReelSymbol.prototype.hideSpinningSymbol = function () {
        if (this._spinningSymbol) {
            for (var _i = 0, _a = this._spinningSymbol.children; _i < _a.length; _i++) {
                var child = _a[_i];
                child.visible = false;
            }
        }
    };
    ReelSymbol.prototype.addAndPlayStopAnimation = function (anim) {
        var _this = this;
        this.hideSymbol();
        this._stopAnimation = anim;
        this._stopAnimation.start();
        this._stopAnimation.container.position.set(ReelConstants_1.ReelConstants.getSymbolSlot().width / 2, ReelConstants_1.ReelConstants.getSymbolSlot().height / 2);
        this._symbolContainer.addChild(this._stopAnimation.container);
        this._stopAnimation.setOnComplete(function () {
            _this.setSymbol(_this._symbolType);
        });
    };
    ReelSymbol.prototype.forceKillStopAnimation = function () {
        if (this._stopAnimation) {
            this._stopAnimation.stop();
            this.removeChild(this._stopAnimation.container);
            this.setSymbol(this._symbolType);
        }
    };
    ReelSymbol.prototype.setSpineUtils = function (spineUtils) {
        this._spineUtils = spineUtils;
    };
    ReelSymbol.prototype.setTimerUtils = function (timerUtils) {
        this._timerUtils = timerUtils;
    };
    ReelSymbol.prototype.setupBackground = function () { };
    ReelSymbol.prototype.setupForeground = function () { };
    ReelSymbol.prototype.setupSymbol = function () { };
    ReelSymbol.prototype.hideBackground = function () {
        for (var i = 0; i < this._symbolBackground.children.length; i++) {
            this._symbolBackground.getChildAt(i).visible = false;
        }
    };
    ReelSymbol.prototype.makeCleanup = function () {
    };
    ReelSymbol.prototype.hasBackground = function () {
        return false;
    };
    ReelSymbol.prototype.hasForeground = function () {
        return false;
    };
    Object.defineProperty(ReelSymbol.prototype, "index", {
        get: function () {
            return this._index;
        },
        set: function (value) {
            this._index = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReelSymbol.prototype, "animationContainer", {
        get: function () {
            return this._animationContainer;
        },
        set: function (value) {
            this._animationContainer = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReelSymbol.prototype, "symbolType", {
        get: function () {
            return this._symbolType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReelSymbol.prototype, "container", {
        get: function () {
            return this._container;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReelSymbol.prototype, "positionOnReel", {
        get: function () {
            return this._positionOnReel;
        },
        set: function (value) {
            this._positionOnReel = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReelSymbol.prototype, "size", {
        get: function () {
            return this._size;
        },
        set: function (value) {
            this._size = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReelSymbol.prototype, "viewType", {
        set: function (value) {
            this._viewType = value;
        },
        enumerable: true,
        configurable: true
    });
    return ReelSymbol;
}(PIXI.Sprite));
exports.ReelSymbol = ReelSymbol;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var AvalancheReelsView_1 = __webpack_require__(75);
var ReelConstants_1 = __webpack_require__(10);
var GameAvalancheReel_1 = __webpack_require__(261);
var GameSymbol_1 = __webpack_require__(64);
var GameReelConstants_1 = __webpack_require__(34);
var Symbols_1 = __webpack_require__(38);
var Tween_1 = __webpack_require__(19);
var BackgroundView_1 = __webpack_require__(91);
var TimingConstants_1 = __webpack_require__(158);
var GameAvalancheReelsView = /** @class */ (function (_super) {
    __extends(GameAvalancheReelsView, _super);
    function GameAvalancheReelsView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._currentScatterIndex = 0;
        _this._reelsWithScatters = [];
        return _this;
    }
    GameAvalancheReelsView.prototype.createReel = function (reelIndex, startReelPosition, offsets, container) {
        return new GameAvalancheReel_1.GameAvalancheReel(reelIndex, startReelPosition, offsets, container);
    };
    GameAvalancheReelsView.prototype.removeSymbolsOnAvalancheWithSound = function (symbols, win, bet) {
        var _this = this;
        var delay = 0;
        var lastReelWithRemovedSymbols = 0;
        symbols.forEach(function (symPos) {
            if (symPos.x > lastReelWithRemovedSymbols) {
                lastReelWithRemovedSymbols = symPos.x;
            }
        });
        var _loop_1 = function (reelIndex) {
            var symbolsOnReel = this_1.getAllSymbolPositionsFromReel(reelIndex, symbols);
            var gameSymbols = this_1.makeSizedGameSymbolsFromSymbols(symbolsOnReel);
            if (symbolsOnReel.length) {
                this_1.timeUtils.createTimer(function () {
                    _this._reels[reelIndex].removeAvalancheSymbols(symbolsOnReel, reelIndex === lastReelWithRemovedSymbols ? _this.onSymbolsRemovingFinshed.bind(_this) : null);
                    _this.playAvalancheDestroyAnimationFor(gameSymbols, null);
                }, delay);
                delay += TimingConstants_1.TimingConstants.SYMBOL_REMOVE_STAGGER_DELAY;
            }
        };
        var this_1 = this;
        for (var reelIndex = 0; reelIndex < ReelConstants_1.ReelConstants.REELS_AMOUNT; reelIndex++) {
            _loop_1(reelIndex);
        }
    };
    GameAvalancheReelsView.prototype.playAvalancheDestroyAnimationFor = function (gameSymbolsForAnimation, onFinishedCallback) {
        var _this = this;
        var isLast = false;
        var index = 0;
        for (var _i = 0, gameSymbolsForAnimation_1 = gameSymbolsForAnimation; _i < gameSymbolsForAnimation_1.length; _i++) {
            var sym = gameSymbolsForAnimation_1[_i];
            if (index === gameSymbolsForAnimation.length - 1) {
                isLast = true;
            }
            this.playAvalancheExplodeAnimationAt(sym, isLast ? function () {
                _this.timeUtils.createTimer(function () {
                    onFinishedCallback && onFinishedCallback(_this.makeSymbolsPositionsFromGameSymbols(gameSymbolsForAnimation));
                }, 150);
            } : null);
            index++;
        }
    };
    GameAvalancheReelsView.prototype.makeSymbolsPositionsFromGameSymbols = function (gameSymbols) {
        var positions = [];
        for (var _i = 0, gameSymbols_1 = gameSymbols; _i < gameSymbols_1.length; _i++) {
            var sym = gameSymbols_1[_i];
            positions.push({ x: sym.position.x, y: sym.position.y });
        }
        return positions;
    };
    GameAvalancheReelsView.prototype.makeSizedGameSymbolsFromSymbols = function (symbols) {
        var gameSymbols = [];
        for (var _i = 0, symbols_1 = symbols; _i < symbols_1.length; _i++) {
            var sym = symbols_1[_i];
            gameSymbols.push(new GameSymbol_1.GameSymbol(this._reels[sym.x].getSymbolTypeOnReelIndex(sym.y), { width: 1, height: 1 }, { x: sym.x, y: sym.y }));
        }
        return gameSymbols;
    };
    GameAvalancheReelsView.prototype.playAvalancheExplodeAnimationAt = function (sym, onCompleted) {
        var posOnScreen = GameReelConstants_1.GameReelConstants.getGameSymbolCenterPosition(sym.position);
        var animation = this.createSizedBlowAvalancheAnimation(posOnScreen, sym.sym);
        var isWildSymbol = sym.sym === Symbols_1.Symbols.WR || sym.sym === Symbols_1.Symbols.TOP_WR;
        !isWildSymbol && (animation.timeScale = 1.25);
        animation.setOnComplete(function () {
            onCompleted && onCompleted();
        });
    };
    GameAvalancheReelsView.prototype.createSizedBlowAvalancheAnimation = function (posOnScreen, symbolNumber) {
        return this.spineUtils
            .startSpineAnimationCreation(this.getBlowAnimationSpineName(symbolNumber), this.getBlowAnimationName(symbolNumber), false)
            .container(this.container)
            .position(posOnScreen.x, posOnScreen.y)
            .createAndStart();
    };
    GameAvalancheReelsView.prototype.getBlowAnimationName = function (symbolNumber) {
        var isWildSymbol = symbolNumber === Symbols_1.Symbols.WR || symbolNumber === Symbols_1.Symbols.TOP_WR;
        return isWildSymbol ? 'EXIT' : 'EXIT';
    };
    GameAvalancheReelsView.prototype.getBlowAnimationSpineName = function (symbolNumber) {
        var isWildSymbol = symbolNumber === Symbols_1.Symbols.WR || symbolNumber === Symbols_1.Symbols.TOP_WR;
        return isWildSymbol ? 'WILD.json' : 'INITIAL_WIN.json';
    };
    /**
     * adding symbols on speceific reel
     * @param reelIndex
     * @param symbols - symbols to add
     * @param winLines - all the win lines
     * @param currentReels - reels
     * @param onExpectedWinAnimationCallback
     * @param onNoWinAnimationCallback
     * @param onSymbolFallenCallback
     */
    GameAvalancheReelsView.prototype.addReelSymbols = function (reelIndex, symbols, winLines, currentReels, onExpectedWinAnimationCallback, onNoWinAnimationCallback, onSymbolFallenCallback) {
        var reel = this._reels[reelIndex];
        var newSymbols = this.getAllSymbolsFromReel(reelIndex, symbols);
        reel.addNewSymbols(newSymbols, function () {
            onSymbolFallenCallback && onSymbolFallenCallback(reelIndex);
        });
        this.rearrangeSymbolsOrder();
        this.fixSymbolsVisibilityDuringAvalanches();
        onNoWinAnimationCallback && onNoWinAnimationCallback();
    };
    GameAvalancheReelsView.prototype.setupLayers = function () {
        this.container.children.length = 0;
        this._reels = [];
        this._reelsetContainer = new PIXI.Sprite();
        this._reelsMask = new PIXI.Container();
        this._oversizedLayer = new PIXI.Container();
        this._reelsMask.addChild(this._currentMask);
        this._reelsMask.mask = this._currentMask;
        this.container.addChild(this._reelsMask);
        this.container.addChild(this._oversizedLayer);
        this._reelsMask.addChild(this._reelsetContainer);
    };
    GameAvalancheReelsView.prototype.createReelSet = function (reels) {
        this.setupLayers();
        for (var reelIndex = 0; reelIndex < ReelConstants_1.ReelConstants.REELS_AMOUNT; reelIndex++) {
            var offsets = {
                x: GameReelConstants_1.GameReelConstants.getReelsOffsetForRow(0).x + reelIndex * GameReelConstants_1.GameReelConstants.getTopSymbolSlot().width,
                y: GameReelConstants_1.GameReelConstants.getReelsOffsetForRow(0).y,
            };
            var reel = this.createReel(reelIndex, 0, offsets, this._reelsetContainer);
            reel.setupReel(this.resources, this.soundPlayer);
            reel.timerUtils = this.timeUtils;
            reel.lineYPosition = this.layout.getAbsolutePosition('ROW_DIVIDER_03').y;
            if (reels) {
                reel.init(reels[reelIndex]);
            }
            else {
                reel.init();
            }
            reel.onReelDropOutFinished = this.onReelDropOutFinished.bind(this);
            reel.onReelDropFirstSymbolFinished = this.onReelFirstSymbolDropped.bind(this);
            reel.onReelDropNewFinished = this.onReelDropNewFinished.bind(this);
            reel.onFillingVoidsFinished = this.onFillingVoidsFinished.bind(this);
            reel.movingThroughTheLineCallback = this.onPassingThroughLine.bind(this);
            reel.respinAttentionTriggeredCallback = this.onRespinAttentionTriggered.bind(this);
            this.updateManager.add(reel);
            reel.start();
            this._reels.push(reel);
        }
        this._reels[ReelConstants_1.ReelConstants.REELS_AMOUNT - 1].onReelDropOutFinished = this.onLastReelDropOutFinished.bind(this);
        this._reels[ReelConstants_1.ReelConstants.REELS_AMOUNT - 1].onReelDropNewFinished = this.onLastReelDropNewFinished.bind(this);
        this.forceUpdateOrientation();
        this.setupInitialRowsToShow(ReelConstants_1.ReelConstants.ROW_AMOUNT);
        this.setOversizedLayer();
    };
    GameAvalancheReelsView.prototype.onReelFirstSymbolDropped = function (reelNr) {
        this.tryToPlayScatterAnimationOnReel(reelNr);
    };
    GameAvalancheReelsView.prototype.onFillingVoidsFinished = function (reelNr) {
        _super.prototype.onFillingVoidsFinished.call(this, reelNr);
        this.tryToPlayScatterAnimationOnReel(reelNr);
    };
    GameAvalancheReelsView.prototype.tryToPlayAnimationOverScatters = function () {
        for (var reel = 0; reel < ReelConstants_1.ReelConstants.REELS_AMOUNT; reel++) {
            this.tryToPlayScatterAnimationOnReel(reel);
        }
    };
    GameAvalancheReelsView.prototype.tryToPlayScatterAnimationOnReel = function (reelIndex) {
        if (!this.hasAlreadyPlayedScatterAttentionOnReel(reelIndex)) {
            for (var i = 3; i < GameReelConstants_1.GameReelConstants.ROW_AMOUNT; i++) {
                var symbolType = this._reels[reelIndex].getSymbolTypeOnReelIndex(i);
                if (symbolType === Symbols_1.Symbols.TOP_BN || symbolType === Symbols_1.Symbols.BN) {
                    this._reels[reelIndex]
                        .getSymbolFromPosition(i)
                        .playScatterBonusLanding(++this._currentScatterIndex, this.updateScatterIdleAnimation.bind(this));
                    this.emit(GameAvalancheReelsView.SCATTER_ATTENTION_TRIGGERED, this._currentScatterIndex);
                    this._reelsWithScatters.push(reelIndex);
                }
            }
        }
    };
    GameAvalancheReelsView.prototype.updateScatterIdleAnimation = function () {
        for (var reelIndex = 0; reelIndex < GameReelConstants_1.GameReelConstants.REELS_AMOUNT; reelIndex++) {
            for (var rowIndex = 3; rowIndex < GameReelConstants_1.GameReelConstants.ROW_AMOUNT; rowIndex++) {
                var symbolType = this._reels[reelIndex].getSymbolTypeOnReelIndex(rowIndex);
                if (symbolType === Symbols_1.Symbols.TOP_BN || symbolType === Symbols_1.Symbols.BN) {
                    this._reels[reelIndex]
                        .getSymbolFromPosition(rowIndex)
                        .playScatterBonusIdleAnimation(this._currentScatterIndex);
                }
            }
        }
    };
    GameAvalancheReelsView.prototype.updateIdleAnimationOnRestore = function () {
        for (var reelIndex = 0; reelIndex < GameReelConstants_1.GameReelConstants.REELS_AMOUNT; reelIndex++) {
            for (var rowIndex = 3; rowIndex < GameReelConstants_1.GameReelConstants.ROW_AMOUNT; rowIndex++) {
                var symbolType = this._reels[reelIndex].getSymbolTypeOnReelIndex(rowIndex);
                var symbolFromReel = this._reels[reelIndex].getSymbolFromPosition(rowIndex);
                if (symbolType === Symbols_1.Symbols.BN) {
                    this._currentScatterIndex++;
                    this._reelsWithScatters.push(reelIndex);
                    this.updateScatterIdleAnimation();
                }
                else if (symbolFromReel.shouldHaveWildIdleAnimation() || symbolFromReel.shouldHaveRespinAttentionAnimation()) {
                    symbolFromReel.addIdleAnimation();
                }
            }
        }
    };
    GameAvalancheReelsView.prototype.hasAlreadyPlayedScatterAttentionOnReel = function (reelIndex) {
        return this._reelsWithScatters.indexOf(reelIndex) >= 0;
    };
    GameAvalancheReelsView.prototype.onPassingThroughLine = function (symbolID, newRowPos) {
        this.emit(GameAvalancheReelsView.SYMBOL_PASSED_THROUGHT_LINE, symbolID, newRowPos);
    };
    GameAvalancheReelsView.prototype.onRespinAttentionTriggered = function () {
        this.emit(GameAvalancheReelsView.RESPIN_ATTENTION_TRIGGERED);
    };
    GameAvalancheReelsView.prototype.removeScatterAt = function (symPos) {
        this._reels[symPos.x].removeScatterRespinAs(symPos);
    };
    GameAvalancheReelsView.prototype.removeRespinSymbol = function (symPos, symbol, finishedCallback) {
        this._reels[symPos.x].playRespinAnimationAt(symPos, symbol, finishedCallback);
    };
    GameAvalancheReelsView.prototype.removeIdleAnimationAt = function (symPos) {
        var symbol = this._reels[symPos.x].getSymbolFromPosition(symPos.y);
        symbol.removeIdleAnimation();
        symbol.visible = false;
    };
    GameAvalancheReelsView.prototype.startBonusIdleAnimationAt = function (symPos) {
        var symbol = this._reels[symPos.x].getSymbolFromPosition(symPos.y);
        symbol.visible = true;
        symbol.playScatterBonusIdleAnimation(3);
    };
    GameAvalancheReelsView.prototype.removeRespinSymbolsFromReels = function (symPositions) {
        for (var reel = 0; reel < ReelConstants_1.ReelConstants.REELS_AMOUNT; reel++) {
            this._reels[reel].removeRespinSymbol(this.getAllPositionsFromReel(symPositions, reel));
        }
    };
    GameAvalancheReelsView.prototype.dropNew = function (reels, rowsToShow) {
        this._currentScatterIndex = 0;
        this._reelsWithScatters = [];
        for (var reelIndex = 0; reelIndex < ReelConstants_1.ReelConstants.REELS_AMOUNT; reelIndex++) {
            this._reels[reelIndex].moveSymbolsFromOversizedToReelContainer();
            this._reels[reelIndex].makeCleanup();
            this._reels[reelIndex].setRowsToShow(rowsToShow);
            this._reels[reelIndex].dropSymbols(reels[reelIndex]);
        }
        this.fixSymbolsVisibilityBeforeNewDrop();
    };
    GameAvalancheReelsView.prototype.fixSymbolsVisibilityBeforeNewDrop = function () {
        for (var reelIndex = 0; reelIndex < ReelConstants_1.ReelConstants.REELS_AMOUNT; reelIndex++) {
            this._reels[reelIndex].fixSymbolsBeforeNewDrop();
        }
    };
    GameAvalancheReelsView.prototype.fixSymbolsVisibilityDuringAvalanches = function () {
        for (var reelIndex = 0; reelIndex < ReelConstants_1.ReelConstants.REELS_AMOUNT; reelIndex++) {
            this._reels[reelIndex].fixSymbolsBeforeNewDrop();
        }
    };
    GameAvalancheReelsView.prototype.getBNSymbolsCountFromReel = function (symbols) {
        var bnSymbolCount = 0;
        for (var _i = 0, symbols_2 = symbols; _i < symbols_2.length; _i++) {
            var sym = symbols_2[_i];
            if ((sym.sym === Symbols_1.Symbols.BN || sym.sym === Symbols_1.Symbols.TOP_BN) && sym.position.y >= 3) {
                bnSymbolCount++;
            }
        }
        return bnSymbolCount;
    };
    GameAvalancheReelsView.prototype.getBNSymbolsCountFromAvalanche = function (symbols) {
        var bnSymbolCount = 0;
        for (var _i = 0, symbols_3 = symbols; _i < symbols_3.length; _i++) {
            var sym = symbols_3[_i];
            if ((sym.symbol === Symbols_1.Symbols.BN || sym.symbol === Symbols_1.Symbols.TOP_BN) && sym.row >= 3) {
                bnSymbolCount++;
            }
        }
        return bnSymbolCount;
    };
    GameAvalancheReelsView.prototype.setupReelSetMaskForSpinning = function () {
        /*if (this.resources.hasMajorPerformanceCaveat) {
            this._currentMask = null;

            return;
        } - we can't not have mask in this game, so fuck those cheap devices */
        this._currentMask = new PIXI.Graphics();
        var scale = this.layout.getScale('BOTTOM_REEL_MASK');
        var noScaleSize = this.layout.getSize('BOTTOM_REEL_MASK');
        var maskSize = { width: noScaleSize.width * scale.x, height: noScaleSize.height * scale.y };
        var maskPos = this.layout.getAbsolutePosition('BOTTOM_REEL_MASK');
        this._currentMask.drawRect(0, 0, 1, 1);
        this._currentMask.x = maskPos.x - maskSize.width / 2;
        this._currentMask.y = maskPos.y - maskSize.height / 2;
        this._currentMask.width = maskSize.width;
        this._currentMask.height = maskSize.height;
    };
    GameAvalancheReelsView.prototype.hasAnyReelsToFillVoid = function () {
        for (var reelIndex = 0; reelIndex < ReelConstants_1.ReelConstants.REELS_AMOUNT; reelIndex++) {
            if (this._reels[reelIndex].hasAnythingToDropFillingTheVoid) {
                return true;
            }
        }
        return false;
    };
    GameAvalancheReelsView.prototype.fillVoidAfterRemoval = function () {
        _super.prototype.fillVoidAfterRemoval.call(this);
        this.emit(GameAvalancheReelsView.FILLING_VOIDS_STARTED);
        this.fixSymbolsVisibilityDuringAvalanches();
    };
    GameAvalancheReelsView.prototype.addWinIndicationToSymbols = function (winLines) {
        var _this = this;
        // Sort win lines
        winLines.sort(function (a, b) {
            // --TEMP FIX. Shouldn't be needed once parsing is working
            a.isRightToLeft = a.winPositions[0].x > a.winPositions[1].x;
            b.isRightToLeft = b.winPositions[0].x > b.winPositions[1].x;
            // --
            var aVal = a.isRightToLeft ? 1 : 2;
            var bVal = b.isRightToLeft ? 1 : 2;
            return bVal - aVal;
        });
        var totalTimerDuration = 0;
        var _loop_2 = function (wl) {
            var isWinLineRightToLeft = wl.isRightToLeft;
            var animationCounter = 0;
            var _loop_3 = function (pos) {
                animationCounter++;
                this_2.timeUtils.createTimer(function () {
                    if (_this.isWinLineStarted(pos, isWinLineRightToLeft)) {
                        _this.emit(GameAvalancheReelsView.INITIAL_WIN_INDICATION_WINLINE);
                    }
                    _this._reels[pos.x].addWinIndicationAt(pos, isWinLineRightToLeft);
                }, totalTimerDuration + animationCounter * TimingConstants_1.TimingConstants.WIN_LINE_STAGGER_DELAY);
            };
            for (var _i = 0, _a = wl.winPositions; _i < _a.length; _i++) {
                var pos = _a[_i];
                _loop_3(pos);
            }
            totalTimerDuration += ReelConstants_1.ReelConstants.REELS_AMOUNT * TimingConstants_1.TimingConstants.WIN_LINE_STAGGER_DELAY + TimingConstants_1.TimingConstants.WIN_LINE_DELAY_BEFORE_NEXT_LINE;
        };
        var this_2 = this;
        for (var _i = 0, winLines_1 = winLines; _i < winLines_1.length; _i++) {
            var wl = winLines_1[_i];
            _loop_2(wl);
        }
        var animDuration = this.resources.getSpine('INITIAL_WIN.json').findAnimation('EXIT').duration * 1000;
        totalTimerDuration += animDuration - TimingConstants_1.TimingConstants.WIN_LINE_DELAY_BEFORE_NEXT_LINE;
        this.timeUtils.createTimer(function () {
            _this.removeAllWinIndications();
            _this.emit(GameAvalancheReelsView.INITIAL_WIN_INDICATION_FINISHED);
        }, totalTimerDuration);
        this.emit(GameAvalancheReelsView.INITIAL_WIN_INDICATION_STARTED, totalTimerDuration);
    };
    GameAvalancheReelsView.prototype.removeAllWinIndications = function () {
        for (var _i = 0, _a = this._reels; _i < _a.length; _i++) {
            var reel = _a[_i];
            reel.removeAllWinIndications();
        }
    };
    GameAvalancheReelsView.prototype.setOversizedLayer = function () {
        for (var reelIndex = 0; reelIndex < ReelConstants_1.ReelConstants.REELS_AMOUNT; reelIndex++) {
            this._reels[reelIndex].setOversizedLayer(this._oversizedLayer);
        }
    };
    GameAvalancheReelsView.prototype.isWinLineStarted = function (pos, isWinLineRightToLeft) {
        return (!isWinLineRightToLeft && pos.x === 0) || (isWinLineRightToLeft && pos.x === 4);
    };
    GameAvalancheReelsView.prototype.setReelsContainerAlphaToZero = function () {
        this.container.alpha = 0;
    };
    GameAvalancheReelsView.prototype.playReelContainerTransition = function () {
        var appearTween = new Tween_1.Tween(this.container)
            .to({ alpha: 1.0 }, BackgroundView_1.BackgroundView.TRANSFER_TIME)
            .start();
        this.updateManager.add(appearTween);
    };
    GameAvalancheReelsView.INITIAL_WIN_INDICATION_FINISHED = 'GameAvalancheReelsView::INITIAL_WIN_INDICATION_FINISHED';
    GameAvalancheReelsView.INITIAL_WIN_INDICATION_STARTED = 'GameAvalancheReelsView::INITIAL_WIN_INDICATION_STARTED';
    GameAvalancheReelsView.INITIAL_WIN_INDICATION_WINLINE = 'GameAvalancheReelsView::INITIAL_WIN_INDICATION_WINLINE';
    GameAvalancheReelsView.SYMBOL_PASSED_THROUGHT_LINE = 'GameAvalancheReelsView::SYMBOL_PASSED_THROUGHT_LINE';
    GameAvalancheReelsView.SCATTER_ATTENTION_TRIGGERED = 'GameAvalancheReelsView::SCATTER_ATTENTION_TRIGGERED';
    GameAvalancheReelsView.RESPIN_ATTENTION_TRIGGERED = 'GameAvalancheReelsView::RESPIN_ATTENTION_TRIGGERED';
    GameAvalancheReelsView.FILLING_VOIDS_STARTED = 'GameAvalancheReelsView::FILL_VOIDS_STARTED';
    return GameAvalancheReelsView;
}(AvalancheReelsView_1.AvalancheReelsView));
exports.GameAvalancheReelsView = GameAvalancheReelsView;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TimingConstants = /** @class */ (function () {
    function TimingConstants() {
    }
    TimingConstants.WIN_LINE_STAGGER_DELAY = 70;
    TimingConstants.WIN_LINE_DELAY_BEFORE_NEXT_LINE = 300;
    TimingConstants.SYMBOL_REMOVE_STAGGER_DELAY = 50;
    TimingConstants.SEND_COIN_STAGGER_DELAY = 285;
    TimingConstants.START_SEND_COINS_DELAY = 1800;
    TimingConstants.ADD_COIN_COMPLETE_DELAY = 300;
    TimingConstants.SEND_COINS_COMPLETE_DELAY = 300;
    return TimingConstants;
}());
exports.TimingConstants = TimingConstants;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var SwipeInteractionEvents_1 = __webpack_require__(65);
var ModuleState_1 = __webpack_require__(1);
var WinPresentationView_1 = __webpack_require__(155);
var WinPresentationModule_1 = __webpack_require__(77);
var WinPresentationEvents_1 = __webpack_require__(13);
var ReelsEvents_1 = __webpack_require__(4);
var AvalancheReelsEvents_1 = __webpack_require__(15);
var Timer_1 = __webpack_require__(28);
var BetlevelMenuEvents_1 = __webpack_require__(48);
var WinPresentationInitialState = /** @class */ (function (_super) {
    __extends(WinPresentationInitialState, _super);
    function WinPresentationInitialState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WinPresentationInitialState.prototype.onEnterState = function () {
        this.killCurrentTimer();
        this._beforeInitialTimer =
            new Timer_1.Timer(this.startInitialWinPresentation.bind(this), WinPresentationInitialState.BEFORE_INITIAL_WIN_DELAY, true);
        this.module.updateManager.add(this._beforeInitialTimer);
    };
    WinPresentationInitialState.prototype.onLeaveState = function () {
        this.stopWinPresentation();
        this._beforeInitialTimer.stop();
        this._beforeInitialTimer = null;
    };
    WinPresentationInitialState.prototype.setupEvents = function () {
        this.on(ReelsEvents_1.ReelsEvents.REELS_SPINNING_STARTED, this.onReelSpinningStarted);
        this.on(AvalancheReelsEvents_1.AvalancheReelsEvents.REMOVING_AVALANCE_SYMBOLS_STARTED, this.onRemovingWinStarted);
        this.on(SwipeInteractionEvents_1.SwipeInteractionEvents.DRAGGING_STARTED, this.onSwipeInteractionStarted);
        this.on(BetlevelMenuEvents_1.BetlevelMenuEvents.BET_VALUE_UPDATED, this.onBetValueUpdated);
        this.on(WinPresentationView_1.WinPresentationView.WIN_ANIMATION_FINISHED, this.onWinAnimationFinished);
    };
    WinPresentationInitialState.prototype.onWinAnimationFinished = function () {
        this.emit(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED);
    };
    WinPresentationInitialState.prototype.onBetValueUpdated = function () {
        this.stopWinPresentation();
    };
    WinPresentationInitialState.prototype.killCurrentTimer = function () {
        if (this._beforeInitialTimer) {
            this._beforeInitialTimer.stop();
            this._beforeInitialTimer = null;
        }
    };
    WinPresentationInitialState.prototype.onReelSpinningStarted = function () {
        var _this = this;
        var beforeKillingTimer = new Timer_1.Timer(function () {
            _this.stopWinPresentation();
            _this.view.forceKillWinNumbers();
            _this.module.gotoState(WinPresentationModule_1.WinPresentationModule.BASIC);
        }, WinPresentationInitialState.BEFORE_INITIAL_WIN_DELAY, true);
        this.module.updateManager.add(beforeKillingTimer);
        this.view.playWinEndAnimation();
    };
    WinPresentationInitialState.prototype.onWinAnimationEndFinished = function () {
        this.view.playWinEndAnimation();
    };
    WinPresentationInitialState.prototype.onSwipeInteractionStarted = function () {
        this.view.killCurrentWinPresentation();
        this.view.playWinEndAnimation();
    };
    WinPresentationInitialState.prototype.stopWinPresentation = function () {
        this.view.killCurrentWinPresentation();
        this.view.playWinEndAnimation();
        this.emitDelayed(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_SKIPPED);
    };
    WinPresentationInitialState.prototype.onRemovingWinStarted = function () {
        this.module.gotoState(WinPresentationModule_1.WinPresentationModule.BASIC);
    };
    WinPresentationInitialState.prototype.startInitialWinPresentation = function () {
        this.emit(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_STARTED);
    };
    WinPresentationInitialState.BEFORE_INITIAL_WIN_DELAY = 300;
    return WinPresentationInitialState;
}(ModuleState_1.ModuleState));
exports.WinPresentationInitialState = WinPresentationInitialState;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var WinPresentationInitialState_1 = __webpack_require__(159);
var WinUtils_1 = __webpack_require__(58);
var WinPresentationEvents_1 = __webpack_require__(13);
var Timer_1 = __webpack_require__(28);
var WinPresentationModule_1 = __webpack_require__(77);
var SpinButtonEvents_1 = __webpack_require__(12);
var GameWinPresentationInitialState = /** @class */ (function (_super) {
    __extends(GameWinPresentationInitialState, _super);
    function GameWinPresentationInitialState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._isBounceFinished = false;
        _this._isWinNumberShown = false;
        return _this;
    }
    GameWinPresentationInitialState.prototype.onEnterState = function () {
        _super.prototype.onEnterState.call(this);
        this._isBounceFinished = false;
        this._isWinNumberShown = false;
    };
    GameWinPresentationInitialState.prototype.onLeaveState = function () {
        _super.prototype.onLeaveState.call(this);
        this.killWPTimer();
    };
    GameWinPresentationInitialState.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(WinPresentationEvents_1.WinPresentationEvents.WIN_NUMBER_BOUNCE_FINISHED, this.onWinNumbersBounceFinished);
        this.on(WinPresentationEvents_1.WinPresentationEvents.WIN_NUMBER_SHOWN_TO_PLAYER, this.onWinNumberShown);
    };
    GameWinPresentationInitialState.prototype.killWPTimer = function () {
        if (this._currentWPTimer) {
            this._currentWPTimer.stop();
            this._currentWPTimer = null;
        }
    };
    GameWinPresentationInitialState.prototype.onWinNumberShown = function () {
        this._isWinNumberShown = true;
        this.tryToFinishWinPresentation();
    };
    GameWinPresentationInitialState.prototype.onWinNumbersBounceFinished = function () {
        this._isBounceFinished = true;
        this.tryToFinishWinPresentation();
    };
    GameWinPresentationInitialState.prototype.tryToFinishWinPresentation = function () {
        var _this = this;
        if (this._isWinNumberShown && this._isBounceFinished) {
            this.killWPTimer();
            var logic = this.module.logic;
            var duration = logic.getTotalWildMeterDeltas() < 3 ? 800 : 2000;
            this._currentWPTimer = new Timer_1.Timer(function () {
                _this.onWinAnimationFinished();
            }, duration, true);
            this.module.updateManager.add(this._currentWPTimer);
            this._isBounceFinished = false;
            this._isWinNumberShown = false;
        }
    };
    GameWinPresentationInitialState.prototype.startInitialWinPresentation = function () {
        var logic = this.module.logic;
        if (logic.getWin() > 0) {
            this.view.playWinNumberCounter(logic.getWin(), WinUtils_1.WinUtils.isRoundExcellentWin(logic), 0, false);
        }
        this.emit(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_STARTED);
    };
    GameWinPresentationInitialState.prototype.onWinAnimationFinished = function () {
        this.emit(SpinButtonEvents_1.SpinButtonEvents.ENABLE_SPIN_BY_SPIN);
        this.emit(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED);
        this.view.killCurrentWinPresentation();
        this.view.playWinEndAnimation();
        this.view.forceKillWinNumbers();
        this.module.gotoState(WinPresentationModule_1.WinPresentationModule.BASIC);
    };
    return GameWinPresentationInitialState;
}(WinPresentationInitialState_1.WinPresentationInitialState));
exports.GameWinPresentationInitialState = GameWinPresentationInitialState;


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var LogicEvents_1 = __webpack_require__(11);
var BigWinEvents_1 = __webpack_require__(21);
var BonusGameEvents_1 = __webpack_require__(78);
var FlowModuleEvents_1 = __webpack_require__(0);
var InfoEvents_1 = __webpack_require__(118);
var SpinButtonEvents_1 = __webpack_require__(12);
var WinPresentationEvents_1 = __webpack_require__(13);
var ReelsEvents_1 = __webpack_require__(4);
var WinUtils_1 = __webpack_require__(58);
var InfoModuleBasicState = /** @class */ (function (_super) {
    __extends(InfoModuleBasicState, _super);
    function InfoModuleBasicState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._isSpinning = false;
        return _this;
    }
    InfoModuleBasicState.prototype.onEnterState = function () { };
    InfoModuleBasicState.prototype.onLeaveState = function () { };
    InfoModuleBasicState.prototype.setupEvents = function () {
        this.on(InfoEvents_1.InfoEvents.UPDATE, this.onUpdate);
        // this.on(WinPresentationEvents.INITIAL_ANIMATION_SKIPPED, this.onInitialWinAnimationSkipped);
        this.on(WinPresentationEvents_1.WinPresentationEvents.INDIVIDUAL_ANIMATION_SKIPPED, this.onWinPresentationStopped);
        this.on(WinPresentationEvents_1.WinPresentationEvents.COUNTUP_FINISHED, this.onWinCountupFinished);
        this.on(WinPresentationEvents_1.WinPresentationEvents.WIN_NUMBER_SHOWN_TO_PLAYER, this.onWinShownToPlayer);
        // onWinInitialWinFinished
        this.on(FlowModuleEvents_1.FlowModuleEvents.NO_WIN, this.onNoWin);
        this.on(BonusGameEvents_1.BonusGameEvents.BONUS_OUTRO_FINISHED, this.onBonusOutroFinished);
        this.on(BigWinEvents_1.BigWinEvents.COUNTUP_FINISHED, this.onBigWinFinished);
        this.on(LogicEvents_1.LogicEvents.INIT_RESPONSE, this.onInitResponse);
        this.on(LogicEvents_1.LogicEvents.SPIN_RESPONSE, this.onSpinResponse);
        this.on(SpinButtonEvents_1.SpinButtonEvents.SPIN_BUTTON_PRESSED, this.onSpinButtonPressed);
        this.on(SpinButtonEvents_1.SpinButtonEvents.SPIN_PRESSED_NOT_ENOUGH_MONEY, this.onSpinButtonPressedNotEnoughMoney);
        this.on(ReelsEvents_1.ReelsEvents.ALL_REELS_STOPPED, this.onAllReelsStopped);
        this.on(FlowModuleEvents_1.FlowModuleEvents.WON, this.onWon);
        this.on(FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN, this.onCanSpin);
    };
    InfoModuleBasicState.prototype.updateBalance = function (balance) {
        this.view.setBalance(balance);
    };
    InfoModuleBasicState.prototype.updateBet = function () {
        var bet = this.module.logic.getTotalBet();
        this.view.setBet(bet);
    };
    InfoModuleBasicState.prototype.updateWin = function (win) {
        if (!this.module.shownWin && win === 0) {
            this.module.shownWin = true;
            win = this.module.lastWin;
            return;
        }
        this.module.lastWin = win;
        this.view.setWins(win);
    };
    InfoModuleBasicState.prototype.onAllReelsStopped = function () {
        this._isSpinning = false;
        this.module.clearWin();
    };
    InfoModuleBasicState.prototype.onCanSpin = function () { };
    InfoModuleBasicState.prototype.onWon = function () {
        this.module.lastWin = this.module.logic.getWin();
        this.module.shownWin = false;
    };
    InfoModuleBasicState.prototype.onSpinResponse = function () {
        this.module.preSpinBalanceUpdate();
        this.module.clearWin();
    };
    InfoModuleBasicState.prototype.updateAll = function () {
        var win = this.module.logic.getWin();
        this.updateWin(win);
        this.updateBalance(this.module.logic.currentBalance);
        this.updateBet();
    };
    InfoModuleBasicState.prototype.onSpinButtonPressed = function () {
        this._isSpinning = true;
    };
    InfoModuleBasicState.prototype.onSpinButtonPressedNotEnoughMoney = function () {
        this.module.clearWin();
    };
    InfoModuleBasicState.prototype.onUpdate = function () {
        this.updateAll();
    };
    InfoModuleBasicState.prototype.onWinPresentationStopped = function () {
    };
    InfoModuleBasicState.prototype.onInitResponse = function () {
        if (this.module.logic.hasRestore) {
            this.updateBalance(this.module.logic.currentBalance - this.module.logic.getWin());
        }
        else {
            this.updateBalance(this.module.logic.currentBalance);
        }
        this.updateBet();
        this.updateWin(0);
    };
    InfoModuleBasicState.prototype.onWinCountupFinished = function () {
        this.updateData();
    };
    InfoModuleBasicState.prototype.onWinShownToPlayer = function () {
        this.updateData();
    };
    InfoModuleBasicState.prototype.updateData = function () {
        var win = this.module.logic.getSpinWin();
        if (this.shouldUpdateBalance()) {
            this.updateBalance(this.module.logic.currentBalance);
        }
        if (!WinUtils_1.WinUtils.isBigWin(this.module.logic)) {
            this.updateWin(win);
        }
    };
    InfoModuleBasicState.prototype.onWinNumberShownToPlayer = function () {
        var win = this.module.logic.getSpinWin();
        if (this.shouldUpdateBalance()) {
            this.updateBalance(this.module.logic.currentBalance);
        }
        if (!WinUtils_1.WinUtils.isBigWin(this.module.logic)) {
            this.updateWin(win);
        }
    };
    InfoModuleBasicState.prototype.shouldUpdateBalance = function () {
        return !this.module.logic.isFreeSpinsJustWon();
    };
    InfoModuleBasicState.prototype.onBigWinFinished = function () {
        var win = this.module.logic.getSpinWin();
        if (this.shouldUpdateBalance()) {
            this.updateBalance(this.module.logic.currentBalance);
        }
        this.updateWin(win);
    };
    InfoModuleBasicState.prototype.onNoWin = function () {
        this.updateData();
    };
    InfoModuleBasicState.prototype.onBonusOutroFinished = function () {
        var win = this.module.logic.getBonusWin();
        this.updateWin(win);
        this.updateBalance(this.module.logic.currentBalance);
    };
    return InfoModuleBasicState;
}(ModuleState_1.ModuleState));
exports.InfoModuleBasicState = InfoModuleBasicState;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var FreeSpinsEvents_1 = __webpack_require__(6);
var FreeSpinsModule_1 = __webpack_require__(97);
var FreeSpinsView_1 = __webpack_require__(120);
var ReelsEvents_1 = __webpack_require__(4);
var AvalancheReelsEvents_1 = __webpack_require__(15);
var FreeSpinsIntroState = /** @class */ (function (_super) {
    __extends(FreeSpinsIntroState, _super);
    function FreeSpinsIntroState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FreeSpinsIntroState.prototype.onEnterState = function () {
        this.view.setFreeSpinsAmount(this.module.logic.freeSpinsLeft);
        this.emit(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_INTRO_STARTED);
    };
    FreeSpinsIntroState.prototype.onLeaveState = function () {
        this.removeKeyboardInput();
    };
    FreeSpinsIntroState.prototype.setupEvents = function () {
        this.on(FreeSpinsView_1.FreeSpinsView.FREE_SPINS_INFO_CONTINUE_CLICKED, this.onFreeSpinsIntroContinueClicked);
        this.on(FreeSpinsView_1.FreeSpinsView.FREE_SPINS_INTRO_FINISHED, this.onFreeSpinsIntroFinished);
        this.on(ReelsEvents_1.ReelsEvents.REELS_FADING_OUT_FINISHED, this.onReelsFadingOutFinished);
        this.on(AvalancheReelsEvents_1.AvalancheReelsEvents.REELS_FADING_OUT_FINISHED, this.onReelsFadingOutFinished);
    };
    FreeSpinsIntroState.prototype.onFreeSpinsIntroContinueClicked = function () {
        this.removeKeyboardInput();
        this.module.gotoState(FreeSpinsModule_1.FreeSpinsModule.IN_PROGRESS_STATE);
        this.view.endFreeSpinsIntro();
    };
    FreeSpinsIntroState.prototype.onReelsFadingOutFinished = function () {
        this.startFreeSpinsIntroAnimation();
    };
    FreeSpinsIntroState.prototype.startFreeSpinsIntroAnimation = function () {
        this.view.startFreeSpinsIntro();
    };
    FreeSpinsIntroState.prototype.keyboardInput = function (event) {
        if (this.view.isVisible()) {
            if (event.code === 'Space' || event.code === 'Enter') {
                this.proceed();
            }
            if (event.code === 'KeyA' || event.code === 'ArrowLeft') {
                this.view.gotoPreviousFeature();
            }
            if (event.code === 'KeyD' || event.code === 'ArrowRight') {
                this.view.gotoNextFeature();
            }
        }
    };
    FreeSpinsIntroState.prototype.proceed = function () {
        this.removeKeyboardInput();
        this.view.proceed();
        // this.module.gotoState(FreeSpinsModule.IN_PROGRESS_STATE);
    };
    FreeSpinsIntroState.prototype.addKeyboardInput = function () {
        if (!this.module.device.isMobile) {
            this._inputFunction = this.keyboardInput.bind(this);
            document.addEventListener('keydown', this._inputFunction);
        }
    };
    FreeSpinsIntroState.prototype.removeKeyboardInput = function () {
        document.removeEventListener('keydown', this._inputFunction);
    };
    FreeSpinsIntroState.prototype.onFreeSpinsIntroFinished = function () {
        this.addKeyboardInput();
        this.emit(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_START_READY);
        this.view.enablePlayButton();
    };
    return FreeSpinsIntroState;
}(ModuleState_1.ModuleState));
exports.FreeSpinsIntroState = FreeSpinsIntroState;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var RecodeLogic_1 = __webpack_require__(94);
var Symbols_1 = __webpack_require__(38);
var GameReelConstants_1 = __webpack_require__(34);
var ReelConstants_1 = __webpack_require__(10);
var RecodeToPrototypeConverter = /** @class */ (function () {
    function RecodeToPrototypeConverter() {
    }
    RecodeToPrototypeConverter.convertInit = function (data, logic) {
        var response = {};
        response.limits = {};
        response.limits.defaultBet = logic.chipSize;
        response.limits.legalBets = [];
        for (var _i = 0, _a = logic.validChips; _i < _a.length; _i++) {
            var chip = _a[_i];
            response.limits.legalBets.push(chip * logic.chipSize);
        }
        response.stats = {};
        response.stats.b = logic.currentBalance;
        return __assign({}, response, this.convertSpin(data, logic));
    };
    RecodeToPrototypeConverter.convertSpin = function (data, logic) {
        var response = {};
        response.stats = {};
        response.stats.b = logic.currentBalance;
        var win = Number.parseFloat(data.Response.Slot.attributes.win);
        var freeSpinsLeft = Number.parseInt(data.Response.Slot.attributes.freeSpins, 10);
        var freeSpinsTotalAwarded = Number.parseInt(data.Response.Slot.attributes.freeSpinTotalAwarded, 10);
        response.totalFS = freeSpinsTotalAwarded;
        response.spinWin = win;
        response.spinsLeft = freeSpinsLeft;
        var roundTypes = logic.roundTypes;
        var roundIndex = 0;
        var initialWildMeterValue = logic.isFreeSpinsStarted ? logic.wildMeter - logic.getTotalWildMeterDeltas() : 0;
        var currentWildMeter = initialWildMeterValue;
        response.generations = [];
        for (var _i = 0, _a = logic.reels; _i < _a.length; _i++) {
            var reels = _a[_i];
            var currentSymbols = this.makeProtSymbolsFromRecode(reels);
            var generation = {
                runningTotal: 0,
                wildMeter: 0,
                winnings: [],
                win: 0,
                symbols: currentSymbols,
                symbolsNew: [],
                removal: [],
            };
            response.generations.push(generation);
            var currentRoundType = roundTypes[roundIndex + 1];
            if (currentRoundType === 2) {
                generation.removal = this.makeRemovalsList(data, logic, roundIndex, currentSymbols);
            }
            currentWildMeter += logic.wildMeterDeltas[roundIndex] !== undefined ? logic.wildMeterDeltas[roundIndex] : 0;
            generation.wildMeter = currentWildMeter;
            roundIndex++;
        }
        if (data.Response.Slot.Wins) {
            this.parseWins(data.Response.Slot.Wins, response.generations);
        }
        response.spinWin = win;
        if (freeSpinsLeft === 0) {
            var reels = logic.freeSpinsTriggerReels;
            var symbols = this.makeProtSymbolsFromRecode(reels);
            logic.updateFreeSpinsTriggerSymbols(symbols);
        }
        return response;
    };
    RecodeToPrototypeConverter.makeRemovalsList = function (data, logic, roundIndex, reels) {
        var removal = [];
        var avalanche = logic.avalanches[roundIndex];
        var respins = this.findAllRespins(reels);
        var itemsPerRespin = Math.floor(avalanche.symbolIndexes.length / respins.length);
        var currentItemInRespin = 0;
        var respinIndex = 0;
        var currentRemovalObject = { removal: [], x: respins[respinIndex].x, y: respins[respinIndex].y };
        for (var _i = 0, _a = avalanche.symbolIndexes; _i < _a.length; _i++) {
            var symRecPos = _a[_i];
            var symbolPos = {
                x: symRecPos % ReelConstants_1.ReelConstants.REELS_AMOUNT,
                y: Math.trunc(symRecPos / ReelConstants_1.ReelConstants.REELS_AMOUNT),
            };
            var isCorrectRemoval = true;
            for (var _b = 0, respins_1 = respins; _b < respins_1.length; _b++) {
                var respin = respins_1[_b];
                if ((symbolPos.x === respin.x && symbolPos.y === respin.y)) {
                    isCorrectRemoval = false;
                }
            }
            if (isCorrectRemoval) {
                currentRemovalObject.removal.push({ x: symbolPos.x, y: symbolPos.y });
            }
            currentItemInRespin++;
            if (currentItemInRespin >= itemsPerRespin && respinIndex !== respins.length - 1) {
                respinIndex++;
                currentItemInRespin = 0;
                removal.push(currentRemovalObject);
                currentRemovalObject = { removal: [], x: respins[respinIndex].x, y: respins[respinIndex].y };
            }
        }
        removal.push(currentRemovalObject);
        return removal;
    };
    RecodeToPrototypeConverter.findAllRespins = function (reels) {
        var skullsPositions = [];
        for (var reelIndex = 0; reelIndex < reels.length; reelIndex++) {
            for (var rowIndex = 0; rowIndex < reels[reelIndex].length; rowIndex++) {
                if (reels[reelIndex][rowIndex] === 'RS' && rowIndex >= 3) {
                    skullsPositions.push({ x: reelIndex, y: rowIndex });
                }
            }
        }
        return skullsPositions;
    };
    RecodeToPrototypeConverter.parseWins = function (data, generations) {
        if (!data.Win.length) {
            data.Win = [data.Win];
        }
        var currentWinIndex = 0;
        var currentRunningTotal = 0;
        var _loop_1 = function (win) {
            var winReason = win.attributes.reason;
            // ordinary wins
            var winValue = {
                amount: 0,
                multiplier: win.attributes.multiplier ? Number.parseInt(win.attributes.multiplier, 10) : 1,
                payableID: Number.parseInt(win.attributes.paytableId, 10),
                payline: Number.parseInt(win.attributes.payline, 10),
                reason: win.attributes.reason,
                round: Number.parseInt(win.attributes.round, 10),
                ways: Number.parseInt(win.attributes.ways, 10),
                winSymbols: [],
            };
            winValue.amount = (Number.parseInt(win.attributes.amount, 10) * RecodeLogic_1.RecodeLogic.CENT_TO_A_DOLLAR) / winValue.multiplier;
            win.attributes.winSymbols.split(',').forEach(function (value) {
                winValue.winSymbols.push(Number.parseInt(value, 10));
            });
            var isRtoL = winValue.reason[winValue.reason.length - 1] === 'R' ? 1 : 0;
            currentRunningTotal += winValue.amount;
            generations[winValue.round + 1].runningTotal = currentRunningTotal;
            generations[winValue.round].winnings.push(['normal', winValue.payline, winValue.amount, [], 'NONE', isRtoL]);
            var lastWinningIndex = generations[winValue.round].winnings.length - 1;
            for (var _i = 0, _a = winValue.winSymbols; _i < _a.length; _i++) {
                var wp = _a[_i];
                var symbolPos = {
                    x: wp % ReelConstants_1.ReelConstants.REELS_AMOUNT,
                    y: Math.trunc(wp / ReelConstants_1.ReelConstants.REELS_AMOUNT),
                };
                generations[winValue.round].winnings[lastWinningIndex][3].push(symbolPos);
            }
            currentWinIndex++;
        };
        for (var _i = 0, _a = data.Win; _i < _a.length; _i++) {
            var win = _a[_i];
            _loop_1(win);
        }
        if (generations.length > 1 && generations[generations.length - 1].runningTotal === 0) {
            generations[generations.length - 1].runningTotal = generations[generations.length - 2].runningTotal;
        }
    };
    RecodeToPrototypeConverter.makeProtSymbolsFromRecode = function (symbols) {
        var reels = [];
        var symbolIndex = 0;
        var reelIndex = 0;
        for (var symIndex = 0; symIndex < symbols.length; symIndex++) {
            var symbol = symbols[symIndex];
            // for (const symbol of symbols) {
            if (!reels[reelIndex]) {
                reels.push([]);
            }
            var gameSymbol = RecodeToPrototypeConverter.recodeToPrototypeSymbol(symbol);
            if (gameSymbol) {
                reels[reelIndex].push(gameSymbol);
            }
            reelIndex++;
            if (reelIndex > GameReelConstants_1.GameReelConstants.REELS_AMOUNT - 1) {
                symbolIndex++;
                reelIndex = 0;
            }
        }
        return reels;
    };
    RecodeToPrototypeConverter.recodeToGameSymbol = function (recodeSymbolID) {
        switch (recodeSymbolID) {
            case 1:
                return Symbols_1.Symbols.WR;
            case 2:
                return Symbols_1.Symbols.M1;
            case 3:
                return Symbols_1.Symbols.M2;
            case 4:
                return Symbols_1.Symbols.M3;
            case 5:
                return Symbols_1.Symbols.M4;
            case 6:
                return Symbols_1.Symbols.M5;
            case 7:
                return Symbols_1.Symbols.F6;
            case 8:
                return Symbols_1.Symbols.F7;
            case 9:
                return Symbols_1.Symbols.F8;
            case 10:
                return Symbols_1.Symbols.F9;
            case 11:
                return Symbols_1.Symbols.F10;
            case 12:
                return Symbols_1.Symbols.BN;
            case 13:
                return Symbols_1.Symbols.RS;
            default:
                return -1;
        }
    };
    RecodeToPrototypeConverter.recodeToPrototypeSymbol = function (recodeSymbolID) {
        switch (recodeSymbolID) {
            case 1:
                return 'WR';
            case 2:
                return 'M1';
            case 3:
                return 'M2';
            case 4:
                return 'M3';
            case 5:
                return 'M4';
            case 6:
                return 'M5';
            case 7:
                return 'F6';
            case 8:
                return 'F7';
            case 9:
                return 'F8';
            case 10:
                return 'F9';
            case 11:
                return 'F10';
            case 12:
                return 'BN';
            case 13:
                return 'RS';
            default:
                return ' ';
        }
    };
    RecodeToPrototypeConverter.gameSymbolNameToId = function (symbolName) {
        switch (symbolName) {
            case 'WR':
                return 0;
            case 'M1':
                return 1;
            case 'M2':
                return 2;
            case 'M3':
                return 3;
            case 'M4':
                return 4;
            case 'M5':
                return 5;
            case 'F6':
                return 6;
            case 'F7':
                return 7;
            case 'F8':
                return 8;
            case 'F9':
                return 9;
            case 'F10':
                return 10;
            case 'BN':
                return 11;
            case 'RS':
                return 12;
            default:
                return -1;
        }
    };
    RecodeToPrototypeConverter.serverSymbolNames = [];
    return RecodeToPrototypeConverter;
}());
exports.RecodeToPrototypeConverter = RecodeToPrototypeConverter;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServerWaysWinChecker_1 = __webpack_require__(313);
var ServerAvalancheReels_1 = __webpack_require__(606);
var ServerRandomUtils_1 = __webpack_require__(314);
var ServerSymbols_1 = __webpack_require__(165);
var ServerData_1 = __webpack_require__(315);
var ServerEvents;
(function (ServerEvents) {
    ServerEvents[ServerEvents["SPIN"] = 0] = "SPIN";
    ServerEvents[ServerEvents["AVALANCHE"] = 1] = "AVALANCHE";
    ServerEvents[ServerEvents["WILD_EXPANDING"] = 2] = "WILD_EXPANDING";
    ServerEvents[ServerEvents["RESPIN"] = 3] = "RESPIN";
    ServerEvents[ServerEvents["EXPLOSION"] = 4] = "EXPLOSION";
    ServerEvents[ServerEvents["MIMIC_FS"] = 5] = "MIMIC_FS";
    ServerEvents[ServerEvents["BATTLE_FS"] = 6] = "BATTLE_FS";
    ServerEvents[ServerEvents["FREE_SPIN"] = 7] = "FREE_SPIN";
})(ServerEvents = exports.ServerEvents || (exports.ServerEvents = {}));
var CurrentGameState;
(function (CurrentGameState) {
    CurrentGameState[CurrentGameState["BASE_GAME"] = 0] = "BASE_GAME";
    CurrentGameState[CurrentGameState["MIMIC_FREE_SPIN"] = 1] = "MIMIC_FREE_SPIN";
    CurrentGameState[CurrentGameState["FREE_SPINS"] = 2] = "FREE_SPINS";
})(CurrentGameState = exports.CurrentGameState || (exports.CurrentGameState = {}));
exports.GAME_REELS = 6;
exports.GAME_ROWS = 6;
var ServerAvalancheReelsRound = /** @class */ (function () {
    function ServerAvalancheReelsRound() {
        this._rounds = [];
        // [round index][win lines of that round]
        this._winLines = [];
        this._gameEvents = [];
        this._currentGameState = 0;
        this._reelsWithFeatureSymbols = [];
        this._randomMultiplier = 1;
        this._avalancheMultiplier = 1;
        this._hasExpandedWilds = false;
        this._expandedWilds = [];
        this._hasRespins = false;
        this._respins = [];
        this._hasExplosions = false;
        this._explosions = [];
        this._featuresOffset = [0, 0, 0];
        this._isMimicFSRound = false;
        this._isFreeSpinRound = false;
        this._currentTotalFreeSpins = 0;
        this._currentFreeSpinsPlayed = 0;
        this._keysInRound = 0;
        this._additionalFSInThisRound = 0;
    }
    ServerAvalancheReelsRound.prototype.initialize = function () {
        this._currentReels = new ServerAvalancheReels_1.ServerAvalancheReels();
        this._winChecker = new ServerWaysWinChecker_1.ServerWaysWinChecker();
        this._hasChest = false;
        this._insideChest = { hasExpandedWild: false, hasExplotion: false, hasMimicFreeSpins: false, hasRespin: false };
    };
    ServerAvalancheReelsRound.prototype.spin = function (serverData, cheats) {
        this.initialize();
        if (cheats.isCheatsEnabled && cheats.shouldTriggerBattleFreeSpins) {
            serverData.activateFeature(ServerData_1.ServerGameFeatures.RESPIN);
            serverData.activateFeature(ServerData_1.ServerGameFeatures.EXPANDED_WILD);
            serverData.activateFeature(ServerData_1.ServerGameFeatures.EXPLOSION);
        }
        this._currentServerData = serverData;
        var nextReelset = ServerAvalancheReels_1.Reelsets.BASIC;
        // in mimic free spins there is a 20% chance to take reels from MIMIC_FREE_SPIN Reelset
        if (serverData.isInMimicFreeSpins) {
            var mimicReelsChance = ServerRandomUtils_1.ServerRandomUtils.randomInt(1, 100);
            if (mimicReelsChance <= 20) {
                nextReelset = ServerAvalancheReels_1.Reelsets.MIMIC_FS;
            }
        }
        // generating initial combination
        this._initialCombination = this._currentReels.generateNewCombination(nextReelset, cheats);
        console.log(this._initialCombination.visibleReelsPositions);
        console.log(this._initialCombination.visibleReels);
        // if we're in basic game
        if (!serverData.isInMimicFreeSpins && !serverData.isInFreeSpins) {
            // if 3 features are unlocked
            if (serverData.activeFeaturesNumber >= 3) {
                // adding keys symbols
                this.addKeysSymbols(this._initialCombination, cheats);
            }
            else {
                // adding chests
                this.addChest(this._initialCombination, serverData, cheats);
            }
        }
        this._initialCombination = this._currentReels.tryToAddMegablocks(this._initialCombination);
        var currentActiveFeatures = serverData.featuresActiveStatus;
        if (serverData.isInMimicFreeSpins || serverData.isInFreeSpins) {
            currentActiveFeatures = serverData.FSFeaturesActiveStatus;
        }
        // adding feature symbols
        this._reelsWithFeatureSymbols = [];
        for (var i = 0; i < 3; i++) {
            if (currentActiveFeatures[i]) {
                this.addFeatureSymbol(this._initialCombination, this._currentGameState, currentActiveFeatures, ServerSymbols_1.E + i, cheats);
            }
        }
        if (serverData.isInFreeSpins) {
            // TODO: if a feature removes a beast symbol +1 FS is awarded (not in math)
            this.addBeastSymbols(this._initialCombination);
        }
        this.addRandomMultiplier(serverData.isInFreeSpins, serverData.isInMimicFreeSpins);
        this._gameEvents.push(ServerEvents.SPIN);
        var winLines = this._winChecker.findWins(this._initialCombination.visibleReels);
        this._currentCombination = this.makeCopyOfCurrentReelsCombination(this._initialCombination);
        this.applyFeatures(this._currentCombination, serverData, winLines, cheats);
        winLines = this._winChecker.findWins(this._currentCombination.visibleReels);
        while (winLines.length > 0) {
            this._winLines.push(winLines);
            this._currentReels.killWinLinesSymbols(this._currentCombination, winLines);
            this._currentReels.dropDownSymbols(this._currentCombination);
            var newSymbols = this._currentReels.addNewSymbols(this._currentCombination, ServerAvalancheReels_1.Reelsets.BASIC, this._randomMultiplier, this._avalancheMultiplier);
            this._rounds.push({
                newSymbols: newSymbols,
                reelsCombination: this.makeCopyOfCurrentReelsCombination(this._currentCombination),
            });
            winLines = this._winChecker.findWins(this._currentCombination.visibleReels);
            this._gameEvents.push(ServerEvents.AVALANCHE);
        }
        if (serverData.isInMimicFreeSpins) {
            this._isMimicFSRound = true;
            serverData.makeMimicFreeSpin();
            this._currentTotalFreeSpins = serverData.totalMimcFreeSpin;
            this._currentFreeSpinsPlayed = serverData.mimicFreeSpinsPlayed;
        }
        if (serverData.isInFreeSpins) {
            this._isFreeSpinRound = true;
            serverData.makeFreeSpin();
            this._currentTotalFreeSpins = serverData.totalFreeSpins;
            this._currentFreeSpinsPlayed = serverData.freeSpinsPlayed;
        }
        if (this._insideChest.hasMimicFreeSpins) {
            this._currentGameState = CurrentGameState.MIMIC_FREE_SPIN;
            serverData.startMimicFreeSpins(5);
            this._currentTotalFreeSpins = serverData.totalMimcFreeSpin;
            this._currentFreeSpinsPlayed = serverData.mimicFreeSpinsPlayed;
            this._gameEvents.push(ServerEvents.MIMIC_FS);
        }
        if (this._keysInRound >= 3) {
            var totalFS = 5;
            if (this._keysInRound === 4) {
                totalFS = 6;
            }
            if (this._keysInRound === 5) {
                totalFS = 8;
            }
            if (this._keysInRound === 6) {
                totalFS = 10;
            }
            this._currentGameState = CurrentGameState.FREE_SPINS;
            serverData.startFreeSpins(totalFS);
            this._currentTotalFreeSpins = totalFS;
            this._currentFreeSpinsPlayed = 0;
            this._gameEvents.push(ServerEvents.BATTLE_FS);
        }
    };
    ServerAvalancheReelsRound.prototype.applyFeatures = function (round, server, winLines, cheats) {
        var currentActiveFeatures = server.featuresActiveStatus;
        if (server.isInMimicFreeSpins) {
            currentActiveFeatures = server.FSFeaturesActiveStatus;
        }
        // has expanded wild feature active
        if (currentActiveFeatures[ServerData_1.ServerGameFeatures.EXPANDED_WILD]) {
            var wilds = this.getWildsOnReels(round);
            if (cheats.isCheatsEnabled && cheats.expandedWildReels.length > 0) {
                wilds = [];
                for (var _i = 0, _a = cheats.expandedWildReels; _i < _a.length; _i++) {
                    var reelIndex = _a[_i];
                    wilds.push({ reel: reelIndex, row: 0 });
                }
            }
            if (wilds && wilds.length > 0) {
                this.applyFeatureExpandedWild(wilds, round);
                this._gameEvents.push(ServerEvents.WILD_EXPANDING);
                this._rounds.push({
                    newSymbols: [[], [], [], [], [], []],
                    reelsCombination: this.makeCopyOfCurrentReelsCombination(round),
                });
            }
        }
        // has explode feature active
        // TODO: should always try to add megablock instead (if possible)
        if (currentActiveFeatures[ServerData_1.ServerGameFeatures.EXPLOSION]) {
            var explodes = this.getExplodeSymbols(round);
            if (explodes && explodes.length > 0) {
                this.applyFeatureExplode(explodes, round);
                this._gameEvents.push(ServerEvents.EXPLOSION);
                this._currentReels.dropDownSymbols(this._currentCombination);
                var newSymbols = this._currentReels.addNewSymbols(this._currentCombination, ServerAvalancheReels_1.Reelsets.BASIC, this._randomMultiplier, this._avalancheMultiplier);
                this._rounds.push({
                    newSymbols: newSymbols,
                    reelsCombination: this.makeCopyOfCurrentReelsCombination(round),
                });
            }
        }
        // has respin feature active
        if (currentActiveFeatures[ServerData_1.ServerGameFeatures.RESPIN]) {
            var respins = this.getRespinSymbols(round);
            if (respins && respins.length > 0) {
                this.applyFeatureRespin(respins, round);
                this._gameEvents.push(ServerEvents.RESPIN);
                this._currentReels.dropDownSymbols(this._currentCombination);
                var newSymbols = this._currentReels.addNewSymbols(this._currentCombination, ServerAvalancheReels_1.Reelsets.BASIC, this._randomMultiplier, this._avalancheMultiplier);
                this._rounds.push({
                    newSymbols: newSymbols,
                    reelsCombination: this.makeCopyOfCurrentReelsCombination(round),
                });
            }
        }
        return round;
    };
    ServerAvalancheReelsRound.prototype.getExplodeSymbols = function (round) {
        var explodes = [];
        for (var reelIndex = 0; reelIndex < round.visibleReels.length; reelIndex++) {
            for (var rowIndex = 0; rowIndex < round.visibleReels[reelIndex].length; rowIndex++) {
                if (round.visibleReels[reelIndex][rowIndex] === ServerSymbols_1.E || round.visibleReels[reelIndex][rowIndex] === ServerSymbols_1.CHEST_EXPLODE) {
                    explodes.push({ reel: reelIndex, row: rowIndex });
                }
            }
        }
        return explodes;
    };
    ServerAvalancheReelsRound.prototype.getRespinSymbols = function (round) {
        var respins = [];
        for (var reelIndex = 0; reelIndex < round.visibleReels.length; reelIndex++) {
            for (var rowIndex = 0; rowIndex < round.visibleReels[reelIndex].length; rowIndex++) {
                if (round.visibleReels[reelIndex][rowIndex] === ServerSymbols_1.SC || round.visibleReels[reelIndex][rowIndex] === ServerSymbols_1.CHEST_RESPIN) {
                    respins.push({ reel: reelIndex, row: rowIndex });
                }
            }
        }
        return respins;
    };
    ServerAvalancheReelsRound.prototype.getWildsOnReels = function (round) {
        var wilds = [];
        for (var reelIndex = 0; reelIndex < round.visibleReels.length; reelIndex++) {
            for (var rowIndex = 0; rowIndex < round.visibleReels[reelIndex].length; rowIndex++) {
                if (round.visibleReels[reelIndex][rowIndex] === ServerSymbols_1.W || round.visibleReels[reelIndex][rowIndex] === ServerSymbols_1.CHEST_WILD) {
                    // assuming there can't be 2 wilds on the same reel
                    wilds.push({ reel: reelIndex, row: rowIndex });
                }
            }
        }
        return wilds;
    };
    ServerAvalancheReelsRound.prototype.addBeastSymbols = function (round) {
        for (var reelIndex = 0; reelIndex < round.visibleReels.length; reelIndex++) {
            for (var rowIndex = 0; rowIndex < round.visibleReels[reelIndex].length; rowIndex++) {
                if (round.visibleReels[reelIndex][rowIndex] === ServerSymbols_1.L4) {
                    round.visibleReels[reelIndex][rowIndex] = ServerSymbols_1.BA;
                }
                if (round.visibleReels[reelIndex][rowIndex] === ServerSymbols_1.L3) {
                    round.visibleReels[reelIndex][rowIndex] = ServerSymbols_1.BB;
                }
                if (round.visibleReels[reelIndex][rowIndex] === ServerSymbols_1.L2) {
                    round.visibleReels[reelIndex][rowIndex] = ServerSymbols_1.BC;
                }
            }
        }
        return round;
    };
    ServerAvalancheReelsRound.prototype.addRandomMultiplier = function (isInFreeSpins, isInMimicFreeSpins) {
        this._hasRandomMultiplier = false;
        this._randomMultiplier = 1;
        if (!isInFreeSpins && !isInMimicFreeSpins) {
            var chance = ServerRandomUtils_1.ServerRandomUtils.randomInt(1, 100);
            if (chance <= 2) {
                this._hasRandomMultiplier = true;
                this._randomMultiplier = this.generateMultiplier();
            }
        }
        else {
            if (!isInMimicFreeSpins) {
                var chance = ServerRandomUtils_1.ServerRandomUtils.randomInt(1, 100);
                if (chance <= 30) {
                    this._hasRandomMultiplier = true;
                    this._randomMultiplier = this.generateMultiplier();
                }
            }
        }
        if (this._hasRandomMultiplier && this._randomMultiplier > 4) {
            this._randomMultiplier = this.generateMultiplier();
        }
    };
    ServerAvalancheReelsRound.prototype.generateMultiplier = function () {
        var values = [
            10,
            9,
            9,
            8,
            8,
            8,
            7,
            7,
            7,
            7,
            6,
            6,
            6,
            6,
            6,
            5,
            5,
            5,
            5,
            5,
            5,
            5,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            3,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
            2,
        ];
        return values[ServerRandomUtils_1.ServerRandomUtils.randomInt(0, values.length - 1)];
    };
    /**
     * should be called in base game only if all 3 characters are opened
     * @param round - current round
     */
    ServerAvalancheReelsRound.prototype.addKeysSymbols = function (round, cheats) {
        if (cheats.shouldTriggerBattleFreeSpins) {
            round.visibleReels[1][ServerRandomUtils_1.ServerRandomUtils.randomInt(0, 5)] = ServerSymbols_1.KEY;
            round.visibleReels[3][ServerRandomUtils_1.ServerRandomUtils.randomInt(0, 5)] = ServerSymbols_1.KEY;
            round.visibleReels[5][ServerRandomUtils_1.ServerRandomUtils.randomInt(0, 5)] = ServerSymbols_1.KEY;
            this._keysInRound = 3;
        }
        else {
            var randomNumber1 = ServerRandomUtils_1.ServerRandomUtils.randomInt(0, 9999);
            if (randomNumber1 < 80) {
                round.visibleReels[1][0] = ServerSymbols_1.KEY;
                round.visibleReels[1][5] = ServerSymbols_1.KEY;
                this._keysInRound += 2;
            }
            else if (randomNumber1 < 1400) {
                round.visibleReels[1][ServerRandomUtils_1.ServerRandomUtils.randomInt(0, 5)] = ServerSymbols_1.KEY;
                this._keysInRound++;
            }
            var randomNumber2 = ServerRandomUtils_1.ServerRandomUtils.randomInt(0, 9999);
            if (randomNumber2 < 80) {
                round.visibleReels[3][0] = ServerSymbols_1.KEY;
                round.visibleReels[3][5] = ServerSymbols_1.KEY;
                this._keysInRound += 2;
            }
            else if (randomNumber2 < 1400) {
                round.visibleReels[3][ServerRandomUtils_1.ServerRandomUtils.randomInt(0, 5)] = ServerSymbols_1.KEY;
                this._keysInRound++;
            }
            var randomNumber3 = ServerRandomUtils_1.ServerRandomUtils.randomInt(0, 9999);
            if (randomNumber3 < 80) {
                round.visibleReels[5][0] = ServerSymbols_1.KEY;
                round.visibleReels[5][5] = ServerSymbols_1.KEY;
                this._keysInRound += 2;
            }
            else if (randomNumber3 < 1400) {
                round.visibleReels[5][ServerRandomUtils_1.ServerRandomUtils.randomInt(0, 5)] = ServerSymbols_1.KEY;
                this._keysInRound++;
            }
        }
        return round;
    };
    /**
     * only in base game and if not all features unlocked
     */
    ServerAvalancheReelsRound.prototype.addChest = function (round, data, cheats) {
        var randomChance = ServerRandomUtils_1.ServerRandomUtils.randomInt(1, 100);
        if (randomChance <= 24 || (cheats.isCheatsEnabled && cheats.shouldAddChest)) {
            var positionX = ServerRandomUtils_1.ServerRandomUtils.randomInt(1, 5);
            var positionY = ServerRandomUtils_1.ServerRandomUtils.randomInt(0, 5);
            this.openChest(round, { reel: positionX, row: positionY }, data.priorityFeatureIndex, data.nonPriorityFeatureIndex, data.initiallyUnlockedFeatureIndex, cheats);
        }
        return round;
    };
    ServerAvalancheReelsRound.prototype.openChest = function (round, position, priorityFeatureIndex, nonPriorityFeatureIndex, initialFeatureIndex, cheats) {
        var mimicFSChance = ServerRandomUtils_1.ServerRandomUtils.randomInt(1, 100);
        this._hasChest = true;
        this._chestPosition = { reel: position.reel, row: position.row };
        if (cheats.shouldNOTWinMimicFS) {
            mimicFSChance = 13;
        }
        if (mimicFSChance <= 12 || (cheats.isCheatsEnabled && cheats.chestContent.hasMimicFreeSpins)) {
            this._insideChest.hasMimicFreeSpins = true;
            round.visibleReels[position.reel][position.row] = ServerSymbols_1.MIMIC_CHEST;
        }
        else {
            if (cheats.isCheatsEnabled &&
                (cheats.chestContent.hasExpandedWild || cheats.chestContent.hasRespin || cheats.chestContent.hasExplotion)) {
                if (cheats.chestContent.hasExpandedWild) {
                    this.applyChest(ServerData_1.ServerGameFeatures.EXPANDED_WILD, round, position);
                    this._insideChest.hasExpandedWild = true;
                }
                if (cheats.chestContent.hasExplotion) {
                    this.applyChest(ServerData_1.ServerGameFeatures.EXPLOSION, round, position);
                    this._insideChest.hasExplotion = true;
                }
                if (cheats.chestContent.hasRespin) {
                    this.applyChest(ServerData_1.ServerGameFeatures.RESPIN, round, position);
                    this._insideChest.hasRespin = true;
                }
                return round;
            }
            var feature = void 0;
            // there are 2 features opened
            if (nonPriorityFeatureIndex < 0) {
                feature = ServerRandomUtils_1.ServerRandomUtils.randomInt(0, 2);
                round.visibleReels[position.reel][position.row] = this.getFeatureSymbol(feature);
            }
            else {
                var featureChestChance = ServerRandomUtils_1.ServerRandomUtils.randomInt(1, 100);
                if (featureChestChance <= 14) {
                    feature = nonPriorityFeatureIndex;
                    this.applyChest(nonPriorityFeatureIndex, round, position);
                }
                else if (featureChestChance < 40) {
                    feature = initialFeatureIndex;
                    this.applyChest(initialFeatureIndex, round, position);
                }
                else {
                    feature = priorityFeatureIndex;
                    this.applyChest(priorityFeatureIndex, round, position);
                }
            }
            switch (feature) {
                case ServerData_1.ServerGameFeatures.EXPANDED_WILD:
                    this._insideChest.hasExpandedWild = true;
                    break;
                case ServerData_1.ServerGameFeatures.RESPIN:
                    this._insideChest.hasRespin = true;
                    break;
                case ServerData_1.ServerGameFeatures.EXPLOSION:
                    this._insideChest.hasExplotion = true;
                    break;
                default:
                    throw new Error('openChest impossible feature - ' + feature);
            }
        }
        return round;
    };
    ServerAvalancheReelsRound.prototype.applyChest = function (feature, round, position) {
        if (!this._currentServerData.featuresActiveStatus[feature]) {
            round.visibleReels[position.reel][position.row] = this.getFeatureSymbol(feature);
            this._currentServerData.setLevelValue(feature, this._currentServerData.featuresLevels[feature] + 1);
            this._featuresOffset[feature]++;
            if (this._currentServerData.featuresLevels[feature] >= 5) {
                this._currentServerData.activateFeature(feature);
            }
        }
    };
    ServerAvalancheReelsRound.prototype.getFeatureSymbol = function (feature) {
        switch (feature) {
            case ServerData_1.ServerGameFeatures.EXPANDED_WILD:
                return ServerSymbols_1.CHEST_WILD;
            case ServerData_1.ServerGameFeatures.EXPLOSION:
                return ServerSymbols_1.CHEST_EXPLODE;
            case ServerData_1.ServerGameFeatures.RESPIN:
                return ServerSymbols_1.CHEST_RESPIN;
            default:
                throw new Error('getFeatureSymbol invalid feature - ' + feature);
        }
    };
    ServerAvalancheReelsRound.prototype.addFeatureSymbol = function (round, currentGameState, activeFeatures, symbol, cheats) {
        var canBeAwarded = 1;
        var chanceForIncrease = ServerRandomUtils_1.ServerRandomUtils.randomInt(1, 100);
        if (chanceForIncrease <= 5) {
            canBeAwarded++;
        }
        if (currentGameState === CurrentGameState.FREE_SPINS) {
            var freeGamesChanceForIncrease = ServerRandomUtils_1.ServerRandomUtils.randomInt(1, 1000);
            if (freeGamesChanceForIncrease <= 125) {
                canBeAwarded++;
            }
        }
        var featuresUnlocked = 0;
        for (var _i = 0, activeFeatures_1 = activeFeatures; _i < activeFeatures_1.length; _i++) {
            var isFeatureUnlocked = activeFeatures_1[_i];
            if (isFeatureUnlocked) {
                featuresUnlocked++;
            }
        }
        if (featuresUnlocked === 0) {
            throw new Error('ServerAvalancheReelsRound::addExpandedWildSymbols featuresUnlocked cant be 0');
        }
        var featuresAwarded = 0;
        for (var i = 0; i < canBeAwarded; i++) {
            var featureAwardChance = 20 / featuresUnlocked;
            var featureAwardRandom = ServerRandomUtils_1.ServerRandomUtils.randomInt(1, 100);
            if (featureAwardChance <= featureAwardRandom) {
                featuresAwarded++;
            }
        }
        for (var _a = 0, _b = this._expandedWilds; _a < _b.length; _a++) {
            var ew = _b[_a];
            this._reelsWithFeatureSymbols.push(ew.wildPosition.reel);
        }
        if (this._hasChest) {
            this._reelsWithFeatureSymbols.push(this._chestPosition.reel);
        }
        for (var featureIndex = 0; featureIndex < featuresAwarded; featureIndex++) {
            if (this._reelsWithFeatureSymbols.length < 6) {
                if (cheats.isCheatsEnabled &&
                    symbol === ServerSymbols_1.W &&
                    cheats.expandedWildReels.length > 0 &&
                    featureIndex < cheats.expandedWildReels.length) {
                    var featureReelIndex = cheats.expandedWildReels[featureIndex];
                    this._reelsWithFeatureSymbols.push(featureReelIndex);
                    round.visibleReels[featureReelIndex][ServerRandomUtils_1.ServerRandomUtils.randomInt(0, 5)] = symbol;
                }
                else {
                    // feature symbol should be generated on a reel with no other feature symbols
                    var featureReelIndex = ServerRandomUtils_1.ServerRandomUtils.randomIntValueWithExceptions(0, 5, this._reelsWithFeatureSymbols);
                    this._reelsWithFeatureSymbols.push(featureReelIndex);
                    var foundGoodPosition = false;
                    while (!foundGoodPosition) {
                        // we should
                        var posReel = ServerRandomUtils_1.ServerRandomUtils.randomInt(0, 5);
                        if (round.visibleReels[featureReelIndex][posReel] !== ServerSymbols_1.KEY) {
                            foundGoodPosition = true;
                            round.visibleReels[featureReelIndex][posReel] = symbol;
                        }
                    }
                }
            }
        }
        return round;
    };
    ServerAvalancheReelsRound.prototype.applyFeatureExpandedWild = function (wildsPositions, round) {
        this._hasExpandedWilds = wildsPositions.length > 0;
        this._expandedWilds = [];
        var multipliers = [9, 8, 7, 6, 5, 5, 5, 5, 4, 4, 4, 4, 4, 3, 3, 3, 3, 3, 3, 2, 2, 2, 2, 2, 2, 2, 2];
        for (var _i = 0, wildsPositions_1 = wildsPositions; _i < wildsPositions_1.length; _i++) {
            var wildPos = wildsPositions_1[_i];
            round.visibleReels[wildPos.reel][0] = ServerSymbols_1.W;
            for (var rowIndex = 1; rowIndex < round.visibleReels[wildPos.reel].length; rowIndex++) {
                if (round.visibleReels[wildPos.reel][rowIndex] === ServerSymbols_1.BA ||
                    round.visibleReels[wildPos.reel][rowIndex] === ServerSymbols_1.BB ||
                    round.visibleReels[wildPos.reel][rowIndex] === ServerSymbols_1.BC) {
                    this._additionalFSInThisRound++;
                }
                round.visibleReels[wildPos.reel][rowIndex] = -2;
            }
            if (!this.hasExpandedWildOnReel(wildPos.reel)) {
                this._expandedWilds.push({
                    wildPosition: { reel: wildPos.reel, row: wildPos.row },
                    multiplier: multipliers[ServerRandomUtils_1.ServerRandomUtils.randomInt(0, multipliers.length - 1)],
                });
            }
        }
        return round;
    };
    ServerAvalancheReelsRound.prototype.hasExpandedWildOnReel = function (reelIndex) {
        for (var _i = 0, _a = this._expandedWilds; _i < _a.length; _i++) {
            var ew = _a[_i];
            if (ew.wildPosition.reel === reelIndex) {
                return true;
            }
        }
        return false;
    };
    ServerAvalancheReelsRound.prototype.applyFeatureRespin = function (scatters, round) {
        this._hasRespins = scatters.length > 0;
        this._respins = [];
        var nonWinningPositions = this._currentReels.getNonWinningSymolZzList(round, this._expandedWilds);
        var positionToRemove = [];
        // removing all respin symbols positions from positions list
        // so that every respin symbol will remove at least itself
        for (var _i = 0, scatters_1 = scatters; _i < scatters_1.length; _i++) {
            var scatter = scatters_1[_i];
            positionToRemove.push({ reel: scatter.reel, row: scatter.row });
        }
        var _loop_1 = function (posToRemove) {
            nonWinningPositions.forEach(function (item, index) {
                if (item.reel === posToRemove.reel && item.row === posToRemove.row) {
                    nonWinningPositions.splice(index, 1);
                }
            });
        };
        for (var _a = 0, positionToRemove_1 = positionToRemove; _a < positionToRemove_1.length; _a++) {
            var posToRemove = positionToRemove_1[_a];
            _loop_1(posToRemove);
        }
        for (var _b = 0, scatters_2 = scatters; _b < scatters_2.length; _b++) {
            var scatter = scatters_2[_b];
            var respinData = { respinSymbolPosition: scatter, otherSymbolsToRemove: [] };
            var symbolsToRemoveAmount = Math.abs(ServerRandomUtils_1.ServerRandomUtils.randomInt(0, 12) + ServerRandomUtils_1.ServerRandomUtils.randomInt(0, 11) + ServerRandomUtils_1.ServerRandomUtils.randomInt(0, 11) - 17) + 2;
            round.visibleReels[scatter.reel][scatter.row] = -1;
            var numberOfSymbolsToRespin = symbolsToRemoveAmount <= nonWinningPositions.length ? symbolsToRemoveAmount : nonWinningPositions.length;
            while (numberOfSymbolsToRespin > 0) {
                var randomIndex = ServerRandomUtils_1.ServerRandomUtils.randomInt(0, nonWinningPositions.length - 1);
                var respinPos = {
                    reel: nonWinningPositions[randomIndex].reel,
                    row: nonWinningPositions[randomIndex].row,
                };
                if (round.visibleReels[respinPos.reel][respinPos.row] !== ServerSymbols_1.SC && round.visibleReels[respinPos.reel][respinPos.row] !== ServerSymbols_1.E) {
                    respinData.otherSymbolsToRemove.push(respinPos);
                    if (round.visibleReels[respinPos.reel][respinPos.row] === ServerSymbols_1.BA ||
                        round.visibleReels[respinPos.reel][respinPos.row] === ServerSymbols_1.BB ||
                        round.visibleReels[respinPos.reel][respinPos.row] === ServerSymbols_1.BC) {
                        this._additionalFSInThisRound++;
                    }
                    round.visibleReels[respinPos.reel][respinPos.row] = -1;
                    nonWinningPositions.splice(randomIndex, 1);
                    numberOfSymbolsToRespin--;
                }
            }
            this._respins.push(respinData);
        }
        return round;
    };
    ServerAvalancheReelsRound.prototype.applyFeatureExplode = function (explodeSymbolsPositions, round) {
        var var1Symbols = [ServerSymbols_1.L4, ServerSymbols_1.L3, ServerSymbols_1.L2, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.H4];
        var var2Symbols = [ServerSymbols_1.H3, ServerSymbols_1.H2, ServerSymbols_1.H1];
        this._hasExplosions = explodeSymbolsPositions.length > 0;
        this._explosions = [];
        var nonWinningPositions = this._currentReels.getNonWinningSymolZzList(round, this._expandedWilds);
        for (var _i = 0, explodeSymbolsPositions_1 = explodeSymbolsPositions; _i < explodeSymbolsPositions_1.length; _i++) {
            var explodePos = explodeSymbolsPositions_1[_i];
            var explosion = { explosionCenter: explodePos, explosionPositions: [] };
            var awardedSymbolChance = ServerRandomUtils_1.ServerRandomUtils.randomInt(1, 100);
            var awardedSymbol = void 0;
            if (awardedSymbolChance <= 20) {
                awardedSymbol = var1Symbols[ServerRandomUtils_1.ServerRandomUtils.randomInt(0, var1Symbols.length - 1)];
            }
            else {
                awardedSymbol = var2Symbols[ServerRandomUtils_1.ServerRandomUtils.randomInt(0, var2Symbols.length - 1)];
            }
            var threeByThreeChance = ServerRandomUtils_1.ServerRandomUtils.randomInt(1, 100);
            // 3x3
            if (threeByThreeChance <= 20 && !this.isWallPosition(explodePos)) {
                explosion.explosionPositions.push({ reel: explodePos.reel + 1, row: explodePos.row });
                explosion.explosionPositions.push({ reel: explodePos.reel, row: explodePos.row + 1 });
                explosion.explosionPositions.push({ reel: explodePos.reel - 1, row: explodePos.row });
                explosion.explosionPositions.push({ reel: explodePos.reel, row: explodePos.row - 1 });
                explosion.explosionPositions.push({ reel: explodePos.reel + 1, row: explodePos.row + 1 });
                explosion.explosionPositions.push({ reel: explodePos.reel - 1, row: explodePos.row - 1 });
                explosion.explosionPositions.push({ reel: explodePos.reel + 1, row: explodePos.row - 1 });
                explosion.explosionPositions.push({ reel: explodePos.reel - 1, row: explodePos.row + 1 });
            }
            else {
                // 2x2
                if (!this.isWallPosition(explodePos)) {
                    explosion.explosionPositions.push({ reel: explodePos.reel - 1, row: explodePos.row - 1 });
                    explosion.explosionPositions.push({ reel: explodePos.reel, row: explodePos.row - 1 });
                    explosion.explosionPositions.push({ reel: explodePos.reel - 1, row: explodePos.row });
                }
                else {
                    if (explodePos.reel < ServerAvalancheReels_1.ServerAvalancheReels.REELS - 1 && explodePos.row === 0) {
                        explosion.explosionPositions.push({ reel: explodePos.reel + 1, row: explodePos.row + 1 });
                        explosion.explosionPositions.push({ reel: explodePos.reel, row: explodePos.row + 1 });
                        explosion.explosionPositions.push({ reel: explodePos.reel + 1, row: explodePos.row });
                    }
                    else if (explodePos.reel === ServerAvalancheReels_1.ServerAvalancheReels.REELS - 1 && explodePos.row < ServerAvalancheReels_1.ServerAvalancheReels.ROWS - 1) {
                        explosion.explosionPositions.push({ reel: explodePos.reel - 1, row: explodePos.row + 1 });
                        explosion.explosionPositions.push({ reel: explodePos.reel, row: explodePos.row + 1 });
                        explosion.explosionPositions.push({ reel: explodePos.reel - 1, row: explodePos.row });
                    }
                    else if (explodePos.reel > 0 && explodePos.row === ServerAvalancheReels_1.ServerAvalancheReels.ROWS - 1) {
                        explosion.explosionPositions.push({ reel: explodePos.reel - 1, row: explodePos.row - 1 });
                        explosion.explosionPositions.push({ reel: explodePos.reel, row: explodePos.row - 1 });
                        explosion.explosionPositions.push({ reel: explodePos.reel - 1, row: explodePos.row });
                    }
                    else {
                        explosion.explosionPositions.push({ reel: explodePos.reel + 1, row: explodePos.row - 1 });
                        explosion.explosionPositions.push({ reel: explodePos.reel, row: explodePos.row - 1 });
                        explosion.explosionPositions.push({ reel: explodePos.reel + 1, row: explodePos.row });
                    }
                }
            }
            var _loop_2 = function (i) {
                var pos = explosion.explosionPositions[i];
                var index = nonWinningPositions.findIndex(function (winSymbol) {
                    return pos.reel === winSymbol.reel && pos.row === winSymbol.row;
                });
                if (index >= 0 &&
                    round.visibleReels[pos.reel][pos.row] !== ServerSymbols_1.W &&
                    round.visibleReels[pos.reel][pos.row] !== -2 &&
                    round.visibleReels[pos.reel][pos.row] !== ServerSymbols_1.E &&
                    round.visibleReels[pos.reel][pos.row] !== ServerSymbols_1.SC &&
                    round.visibleReels[pos.reel][pos.row] !== -1) {
                    if (round.visibleReels[pos.reel][pos.row] === ServerSymbols_1.BA ||
                        round.visibleReels[pos.reel][pos.row] === ServerSymbols_1.BB ||
                        round.visibleReels[pos.reel][pos.row] === ServerSymbols_1.BC) {
                        this_1._additionalFSInThisRound++;
                    }
                    round.visibleReels[pos.reel][pos.row] = -1;
                }
                else {
                    explosion.explosionPositions.splice(i, 1);
                    i--;
                }
                out_i_1 = i;
            };
            var this_1 = this, out_i_1;
            for (var i = 0; i < explosion.explosionPositions.length; i++) {
                _loop_2(i);
                i = out_i_1;
            }
            this._explosions.push(explosion);
            round.visibleReels[explosion.explosionCenter.reel][explosion.explosionCenter.row] = -1;
        }
        return round;
    };
    ServerAvalancheReelsRound.prototype.isWallPosition = function (pos) {
        return pos.row === 0 || pos.row === ServerAvalancheReels_1.ServerAvalancheReels.ROWS - 1 || pos.reel === 0 || pos.reel === ServerAvalancheReels_1.ServerAvalancheReels.REELS - 1;
    };
    ServerAvalancheReelsRound.prototype.isCornerPosition = function (pos) {
        return ((pos.reel === 0 && pos.row === 0) ||
            (pos.reel === ServerAvalancheReels_1.ServerAvalancheReels.REELS - 1 && pos.row === ServerAvalancheReels_1.ServerAvalancheReels.ROWS - 1) ||
            (pos.reel === 0 && pos.row === ServerAvalancheReels_1.ServerAvalancheReels.ROWS - 1) ||
            (pos.reel === ServerAvalancheReels_1.ServerAvalancheReels.REELS - 1 && pos.row === 0));
    };
    ServerAvalancheReelsRound.prototype.makeCopyOfCurrentReelsCombination = function (round) {
        var visibleReelsPositions = round.visibleReelsPositions.slice();
        var visibleReels = [];
        for (var _i = 0, _a = round.visibleReels; _i < _a.length; _i++) {
            var reel = _a[_i];
            visibleReels.push(reel.slice());
        }
        return { visibleReelsPositions: visibleReelsPositions, visibleReels: visibleReels };
    };
    ServerAvalancheReelsRound.prototype.getCurrentRoundResult = function () {
        return JSON.parse(this.getCurrentRoundAsString());
    };
    ServerAvalancheReelsRound.prototype.getCurrentRoundAsString = function () {
        var result = '{';
        // adding initial values
        result += '"initial": [';
        for (var reelIndex = 0; reelIndex < this._initialCombination.visibleReels.length; reelIndex++) {
            result += '[';
            for (var rowIndex = 0; rowIndex < this._initialCombination.visibleReels[reelIndex].length; rowIndex++) {
                result += "" + this._initialCombination.visibleReels[reelIndex][rowIndex];
                if (rowIndex !== this._initialCombination.visibleReels[reelIndex].length - 1) {
                    result += ',';
                }
            }
            result += '],';
        }
        result = result.substring(0, result.length - 1);
        result += ']';
        if (this._rounds && this._rounds.length > 0) {
            result += ',"newsymbols": [';
            for (var _i = 0, _a = this._rounds; _i < _a.length; _i++) {
                var round = _a[_i];
                result += '[';
                for (var reelIndex = 0; reelIndex < round.newSymbols.length; reelIndex++) {
                    result += '[';
                    for (var rowIndex = 0; rowIndex < round.newSymbols[reelIndex].length; rowIndex++) {
                        result += "" + round.newSymbols[reelIndex][rowIndex];
                        if (rowIndex !== round.newSymbols[reelIndex].length - 1) {
                            result += ',';
                        }
                    }
                    result += '],';
                }
                result = result.substring(0, result.length - 1);
                result += '],';
            }
            result = result.substring(0, result.length - 1);
            result += '],';
            result += '"currentreels": [';
            for (var _b = 0, _c = this._rounds; _b < _c.length; _b++) {
                var round = _c[_b];
                result += '[';
                for (var reelIndex = 0; reelIndex < round.reelsCombination.visibleReels.length; reelIndex++) {
                    result += '[';
                    for (var rowIndex = 0; rowIndex < round.reelsCombination.visibleReels[reelIndex].length; rowIndex++) {
                        result += "" + round.reelsCombination.visibleReels[reelIndex][rowIndex];
                        if (rowIndex !== round.reelsCombination.visibleReels[reelIndex].length - 1) {
                            result += ',';
                        }
                    }
                    result += '],';
                }
                result = result.substring(0, result.length - 1);
                result += '],';
            }
            result = result.substring(0, result.length - 1);
            result += ']';
        }
        if (this._winLines.length > 0) {
            result += ',"wins":[';
            for (var _d = 0, _e = this._winLines; _d < _e.length; _d++) {
                var roundWinLines = _e[_d];
                result += '[';
                for (var _f = 0, roundWinLines_1 = roundWinLines; _f < roundWinLines_1.length; _f++) {
                    var wl = roundWinLines_1[_f];
                    result += '{';
                    result += '"positions": [';
                    for (var _g = 0, _h = wl.winSymbols; _g < _h.length; _g++) {
                        var ws = _h[_g];
                        result += "{\"reel\":" + ws.position.reel + ",\"row\":" + ws.position.row + ",\"symbol\":" + ws.symbol + "},";
                    }
                    result = result.substring(0, result.length - 1);
                    result += '],';
                    result += "\"win\": " + wl.win + ",";
                    result += "\"mainsymbol\": " + wl.mainWinSymbol;
                    result += '},';
                }
                result = result.substring(0, result.length - 1);
                result += '],';
            }
            result = result.substring(0, result.length - 1);
            result += ']';
        }
        if (this._hasExpandedWilds) {
            result += ',"expandedWilds":[';
            for (var _j = 0, _k = this._expandedWilds; _j < _k.length; _j++) {
                var expandedWild = _k[_j];
                result += '{';
                result += "\"multiplier\":" + expandedWild.multiplier + ",\"reel\":" + expandedWild.wildPosition.reel + ",\"row\":" + expandedWild.wildPosition.row;
                result += '},';
            }
            result = result.substring(0, result.length - 1);
            result += ']';
        }
        if (this._gameEvents.length > 0) {
            result += ',"events":[';
            for (var _l = 0, _m = this._gameEvents; _l < _m.length; _l++) {
                var event_1 = _m[_l];
                result += event_1 + ",";
            }
            result = result.substring(0, result.length - 1);
            result += ']';
        }
        if (this._respins.length > 0) {
            result += ',"respins":[';
            for (var _o = 0, _p = this._respins; _o < _p.length; _o++) {
                var respin = _p[_o];
                result += '{';
                result += "\"scatter\": {\"reel\":" + respin.respinSymbolPosition.reel + ",\"row\":" + respin.respinSymbolPosition.row + "},";
                result += '"symbols":[';
                for (var _q = 0, _r = respin.otherSymbolsToRemove; _q < _r.length; _q++) {
                    var pos = _r[_q];
                    result += "{\"reel\":" + pos.reel + ",\"row\":" + pos.row + "},";
                }
                result = result.substring(0, result.length - 1);
                result += ']';
                result += '},';
            }
            result = result.substring(0, result.length - 1);
            result += ']';
        }
        if (this._explosions.length > 0) {
            result += ',"explosions":[';
            for (var _s = 0, _t = this._explosions; _s < _t.length; _s++) {
                var explosion = _t[_s];
                result += '{';
                result += "\"explosionCenter\": {\"reel\":" + explosion.explosionCenter.reel + ",\"row\":" + explosion.explosionCenter.row + "},";
                result += '"symbols":[';
                for (var _u = 0, _v = explosion.explosionPositions; _u < _v.length; _u++) {
                    var pos = _v[_u];
                    result += "{\"reel\":" + pos.reel + ",\"row\":" + pos.row + "},";
                }
                if (explosion.explosionPositions.length > 0) {
                    result = result.substring(0, result.length - 1);
                }
                result += ']';
                result += '},';
            }
            result = result.substring(0, result.length - 1);
            result += ']';
        }
        if (this._isMimicFSRound) {
            result += ',"mimicFreeSpinsData":{';
            result += "\"freeSpinsTotal\":" + this._currentTotalFreeSpins + ",";
            result += "\"freeSpinsPlayed\":" + this._currentFreeSpinsPlayed;
            result += '}';
        }
        if (this._isFreeSpinRound) {
            result += ',"freeSpinsData":{';
            result += "\"freeSpinsTotal\":" + this._currentTotalFreeSpins + ",";
            result += "\"freeSpinsPlayed\":" + this._currentFreeSpinsPlayed;
            result += '}';
        }
        if (this._currentReels.currentMegablock && this._currentReels.currentMegablock.isFull) {
            result += ',"megablock":{';
            result += "\"size\":" + this._currentReels.currentMegablock.size + ",";
            result += "\"position\":{\"reel\":" + this._currentReels.currentMegablock.position.reel + ",\"row\":" + this._currentReels.currentMegablock.position.row + "}";
            result += '}';
        }
        result += ',"features":{';
        result += '"expanded_wild": {';
        result += "\"current\":" + this._currentServerData.featuresLevels[ServerData_1.ServerGameFeatures.EXPANDED_WILD] + ",\"offset\":" + this._featuresOffset[ServerData_1.ServerGameFeatures.EXPANDED_WILD];
        result += '},';
        result += '"respin": {';
        result += "\"current\":" + this._currentServerData.featuresLevels[ServerData_1.ServerGameFeatures.RESPIN] + ",\"offset\":" + this._featuresOffset[ServerData_1.ServerGameFeatures.RESPIN];
        result += '},';
        result += '"explosion": {';
        result += "\"current\":" + this._currentServerData.featuresLevels[ServerData_1.ServerGameFeatures.EXPLOSION] + ",\"offset\":" + this._featuresOffset[ServerData_1.ServerGameFeatures.EXPLOSION];
        result += '}';
        result += '}';
        result += '}';
        console.log(result);
        return result;
    };
    ServerAvalancheReelsRound.prototype.printCombination = function (combination) {
        var finalData = '';
        finalData += 'positions: ' + combination.visibleReelsPositions.toString() + '\n\n';
        for (var rowIndex = 0; rowIndex < exports.GAME_ROWS; rowIndex++) {
            for (var reelIndex = 0; reelIndex < exports.GAME_REELS; reelIndex++) {
                finalData += combination.visibleReels[reelIndex][rowIndex] + ' ';
            }
            finalData += '\n';
        }
        console.log(finalData);
    };
    ServerAvalancheReelsRound.prototype.printWinLines = function (winLines) {
        var finalData = '';
        for (var _i = 0, winLines_1 = winLines; _i < winLines_1.length; _i++) {
            var wl = winLines_1[_i];
            finalData += "win symbol: " + wl.mainWinSymbol + " multiplier: " + wl.multiplier + "\n";
            for (var _a = 0, _b = wl.winSymbols; _a < _b.length; _a++) {
                var ws = _b[_a];
                finalData += "symbol: " + ws.symbol + " reel: " + ws.position.reel + " row: " + ws.position.row + "\n";
            }
            finalData += '\n';
        }
        console.log(finalData);
    };
    Object.defineProperty(ServerAvalancheReelsRound.prototype, "currentGameState", {
        get: function () {
            return this._currentGameState;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ServerAvalancheReelsRound.prototype, "additionalFSInThisRound", {
        get: function () {
            return this._additionalFSInThisRound;
        },
        enumerable: true,
        configurable: true
    });
    return ServerAvalancheReelsRound;
}());
exports.ServerAvalancheReelsRound = ServerAvalancheReelsRound;
window.server = new ServerAvalancheReelsRound();


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.E = 0;
exports.SC = 1;
exports.W = 2;
exports.H1 = 3;
exports.H2 = 4;
exports.H3 = 5;
exports.H4 = 6;
exports.H5 = 7;
exports.L1 = 8;
exports.L2 = 9;
exports.L3 = 10;
exports.L4 = 11;
exports.BA = 12;
exports.BB = 13;
exports.BC = 14;
exports.MIMIC_CHEST = 15; // mimic
exports.CHEST_WILD = 16;
exports.CHEST_EXPLODE = 17;
exports.CHEST_RESPIN = 18;
exports.KEY = 19;
exports.LAST_SYMBOL = 20;
var ServerSymbols = /** @class */ (function () {
    function ServerSymbols() {
    }
    ServerSymbols.isWild = function (symbol) {
        return symbol === exports.W;
    };
    ServerSymbols.isOrdinarySymbol = function (symbol) {
        return symbol === exports.H1
            || symbol === exports.H2
            || symbol === exports.H3
            || symbol === exports.H4
            || symbol === exports.H5
            || symbol === exports.L1
            || symbol === exports.L2
            || symbol === exports.L3
            || symbol === exports.L4;
    };
    ServerSymbols.isScatter = function (symbol) {
        return symbol === exports.SC;
    };
    ServerSymbols.getWilds = function () {
        return [exports.W];
    };
    ServerSymbols.isChest = function (symbol) {
        return symbol === exports.CHEST_WILD || symbol === exports.CHEST_EXPLODE || symbol === exports.CHEST_RESPIN;
    };
    return ServerSymbols;
}());
exports.ServerSymbols = ServerSymbols;


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
var RgPostMessageAPI_esm_1 = __webpack_require__(629);
var MessagesAPI = /** @class */ (function () {
    function MessagesAPI() {
    }
    MessagesAPI.init = function (eventManager) {
        RgPostMessageAPI_esm_1.RgPostMessageAPI.init(true, undefined, null);
        window.addEventListener('rg_pause', function (evt) {
            if (evt.data && evt.data.autoPlayOnly) {
                eventManager.emit(MessagesAPI.AUTOPLAY_PAUSED);
            }
            else {
                /* A hard pause. Once any unfinished round has completed, disable
                controls(so a new round cannot be started), pause autoplay, and
                call ​RgPostMessageAPI.reportPaused().​ */
                eventManager.emit(MessagesAPI.GAME_HARD_PAUSED);
                RgPostMessageAPI_esm_1.RgPostMessageAPI.reportPaused(null);
            }
        });
        window.addEventListener('rg_resume', function () {
            /* Reality check was closed; the game can now continue.   Re-enable controls and resume autoplay if it was paused by   'rg_pause' */
            eventManager.emit(MessagesAPI.GAME_RESUMED);
        });
        window.addEventListener('rg_updateBalance', function () {
            // Account balance has changed.
            // Request balance by calling /game/getbalance.
            eventManager.emit(MessagesAPI.BALANCE_UPDATED);
        });
    };
    MessagesAPI.gameReady = function () {
        RgPostMessageAPI_esm_1.RgPostMessageAPI.reportGameReady();
    };
    MessagesAPI.gameRoundStarted = function () {
        RgPostMessageAPI_esm_1.RgPostMessageAPI.gameRoundStarted();
    };
    MessagesAPI.gameRoundFinished = function () {
        RgPostMessageAPI_esm_1.RgPostMessageAPI.gameRoundEnded();
    };
    MessagesAPI.AUTOPLAY_PAUSED = 'MessagesAPI::AUTOPLAY_PAUSED';
    MessagesAPI.GAME_HARD_PAUSED = 'MessagesAPI::GAME_HARD_PAUSED';
    MessagesAPI.GAME_RESUMED = 'MessagesAPI::GAME_HARD_PAUSED';
    MessagesAPI.BALANCE_UPDATED = 'MessagesAPI::BALANCE_UPDATED';
    return MessagesAPI;
}());
exports.MessagesAPI = MessagesAPI;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var RelaxEvents = /** @class */ (function () {
    function RelaxEvents() {
    }
    RelaxEvents.SHOW_REALITY_CHECK = 'RelaxEvents::SHOW_REALITY_CHECK';
    return RelaxEvents;
}());
exports.RelaxEvents = RelaxEvents;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SettingsViewEvents = /** @class */ (function () {
    function SettingsViewEvents() {
    }
    SettingsViewEvents.TOGGLE_SOUND_OFF = 'SettingsViewEvents::TOGGLE_SOUND_OFF';
    SettingsViewEvents.TOGGLE_SOUND_ON = 'SettingsViewEvents::TOGGLE_SOUND_ON';
    SettingsViewEvents.TOGGLE_VOICE_OFF = 'SettingsViewEvents::TOGGLE_VOICE_OFF';
    SettingsViewEvents.TOGGLE_VOICE_ON = 'SettingsViewEvents::TOGGLE_VOICE_ON';
    SettingsViewEvents.TOGGLE_MUSIC_OFF = 'SettingsViewEvents::TOGGLE_MUSIC_OFF';
    SettingsViewEvents.TOGGLE_MUSIC_ON = 'SettingsViewEvents::TOGGLE_MUSIC_ON';
    SettingsViewEvents.TOGGLE_QUICKSPIN_OFF = 'SettingsViewEvents::TOGGLE_QUICKSPIN_OFF';
    SettingsViewEvents.TOGGLE_QUICKSPIN_ON = 'SettingsViewEvents::TOGGLE_QUICKSPIN_ON';
    SettingsViewEvents.TOGGLE_SPACEBAR_OFF = 'SettingsViewEvents::TOGGLE_SPACEBAR_OFF';
    SettingsViewEvents.TOGGLE_SPACEBAR_ON = 'SettingsViewEvents::TOGGLE_SPACEBAR_ON';
    SettingsViewEvents.TOGGLE_SKIP_INTRO_ON = 'SettingsViewEvents::TOGGLE_SKIP_INTRO_ON';
    SettingsViewEvents.TOGGLE_SKIP_INTRO_OFF = 'SettingsViewEvents::TOGGLE_SKIP_INTRO_OFF';
    SettingsViewEvents.TOGGLE_FAST_PLAY_ON = 'SettingsViewEvents::TOGGLE_FAST_PLAY_ON';
    SettingsViewEvents.TOGGLE_FAST_PLAY_OFF = 'SettingsViewEvents::TOGGLE_FAST_PLAY_OFF';
    SettingsViewEvents.TOGGLE_DRAG_REEL_TO_SPIN_ON = 'SettingsViewEvents::TOGGLE_DRAG_REEL_TO_SPIN_ON';
    SettingsViewEvents.TOGGLE_DRAG_REEL_TO_SPIN_OFF = 'SettingsViewEvents::TOGGLE_DRAG_REEL_TO_SPIN_OFF';
    return SettingsViewEvents;
}());
exports.SettingsViewEvents = SettingsViewEvents;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MainMenuViewEvents = /** @class */ (function () {
    function MainMenuViewEvents() {
    }
    MainMenuViewEvents.MAIN_MENU_OPEN = 'MainMenuViewEvents::MAIN_MENU_OPEN';
    MainMenuViewEvents.MAIN_MENU_CLOSED = 'MainMenuViewEvents::MAIN_MENU_CLOSED';
    MainMenuViewEvents.MAIN_MENU_CLOSE_CLICKED = 'MainMenuViewEvents::MAIN_MENU_CLOSE_CLICKED';
    MainMenuViewEvents.MAIN_MENU_SETTINGS_OPEN = 'MainMenuViewEvents::MAIN_MENU_SETTINGS_OPEN';
    MainMenuViewEvents.MAIN_MENU_INFO_OPEN = 'MainMenuViewEvents::MAIN_MENU_RULES_OPEN';
    MainMenuViewEvents.MAIN_MENU_PAYTABLE_OPEN = 'MainMenuViewEvents::MAIN_MENU_PAYTABLE_OPEN';
    MainMenuViewEvents.MAIN_MENU_LOBBY_OPEN = 'MainMenuViewEvents::MAIN_MENU_LOBBY_OPEN';
    MainMenuViewEvents.MAIN_MENU_SETTINGS_CLOSE = 'MainMenuViewEvents::MAIN_MENU_SETTINGS_CLOSE';
    MainMenuViewEvents.MAIN_MENU_INFO_CLOSE = 'MainMenuViewEvents::MAIN_MENU_RULES_CLOSE';
    MainMenuViewEvents.MAIN_MENU_PAYTABLE_CLOSE = 'MainMenuViewEvents::MAIN_MENU_PAYTABLE_CLOSE';
    MainMenuViewEvents.MAIN_MENU_LOBBY_CLOSE = 'MainMenuViewEvents::MAIN_MENU_LOBBY_CLOSE';
    MainMenuViewEvents.MAIN_MENU_SETTINGS_CLICKED = 'MainMenuViewEvents::MAIN_MENU_SETTINGS_CLICKED';
    MainMenuViewEvents.MAIN_MENU_INFO_CLICKED = 'MainMenuViewEvents::MAIN_MENU_RULES_CLICKED';
    MainMenuViewEvents.MAIN_MENU_PAYTABLE_CLICKED = 'MainMenuViewEvents::MAIN_MENU_PAYTABLE_CLICKED';
    MainMenuViewEvents.MAIN_MENU_LOBBY_CLICKED = 'MainMenuViewEvents::MAIN_MENU_LOBBY_CLICKED';
    return MainMenuViewEvents;
}());
exports.MainMenuViewEvents = MainMenuViewEvents;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The Point object represents a location in a two-dimensional coordinate system, where x represents
 * the horizontal axis and y represents the vertical axis.
 * An observable point is a point that triggers a callback when the point's position is changed.
 *
 * @class
 * @memberof PIXI
 */
var ObservablePoint = function () {
    /**
     * @param {Function} cb - callback when changed
     * @param {object} scope - owner of callback
     * @param {number} [x=0] - position of the point on the x axis
     * @param {number} [y=0] - position of the point on the y axis
     */
    function ObservablePoint(cb, scope) {
        var x = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        var y = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

        _classCallCheck(this, ObservablePoint);

        this._x = x;
        this._y = y;

        this.cb = cb;
        this.scope = scope;
    }

    /**
     * Creates a clone of this point.
     * The callback and scope params can be overidden otherwise they will default
     * to the clone object's values.
     *
     * @override
     * @param {Function} [cb=null] - callback when changed
     * @param {object} [scope=null] - owner of callback
     * @return {PIXI.ObservablePoint} a copy of the point
     */


    ObservablePoint.prototype.clone = function clone() {
        var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        var _cb = cb || this.cb;
        var _scope = scope || this.scope;

        return new ObservablePoint(_cb, _scope, this._x, this._y);
    };

    /**
     * Sets the point to a new x and y position.
     * If y is omitted, both x and y will be set to x.
     *
     * @param {number} [x=0] - position of the point on the x axis
     * @param {number} [y=0] - position of the point on the y axis
     */


    ObservablePoint.prototype.set = function set(x, y) {
        var _x = x || 0;
        var _y = y || (y !== 0 ? _x : 0);

        if (this._x !== _x || this._y !== _y) {
            this._x = _x;
            this._y = _y;
            this.cb.call(this.scope);
        }
    };

    /**
     * Copies the data from another point
     *
     * @param {PIXI.Point|PIXI.ObservablePoint} point - point to copy from
     */


    ObservablePoint.prototype.copy = function copy(point) {
        if (this._x !== point.x || this._y !== point.y) {
            this._x = point.x;
            this._y = point.y;
            this.cb.call(this.scope);
        }
    };

    /**
     * Returns true if the given point is equal to this point
     *
     * @param {PIXI.Point|PIXI.ObservablePoint} p - The point to check
     * @returns {boolean} Whether the given point equal to this point
     */


    ObservablePoint.prototype.equals = function equals(p) {
        return p.x === this._x && p.y === this._y;
    };

    /**
     * The position of the displayObject on the x axis relative to the local coordinates of the parent.
     *
     * @member {number}
     */


    _createClass(ObservablePoint, [{
        key: "x",
        get: function get() {
            return this._x;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            if (this._x !== value) {
                this._x = value;
                this.cb.call(this.scope);
            }
        }

        /**
         * The position of the displayObject on the x axis relative to the local coordinates of the parent.
         *
         * @member {number}
         */

    }, {
        key: "y",
        get: function get() {
            return this._y;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            if (this._y !== value) {
                this._y = value;
                this.cb.call(this.scope);
            }
        }
    }]);

    return ObservablePoint;
}();

exports.default = ObservablePoint;
//# sourceMappingURL=ObservablePoint.js.map

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _Matrix = __webpack_require__(124);

var _Matrix2 = _interopRequireDefault(_Matrix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ux = [1, 1, 0, -1, -1, -1, 0, 1, 1, 1, 0, -1, -1, -1, 0, 1]; // Your friendly neighbour https://en.wikipedia.org/wiki/Dihedral_group of order 16

var uy = [0, 1, 1, 1, 0, -1, -1, -1, 0, 1, 1, 1, 0, -1, -1, -1];
var vx = [0, -1, -1, -1, 0, 1, 1, 1, 0, 1, 1, 1, 0, -1, -1, -1];
var vy = [1, 1, 0, -1, -1, -1, 0, 1, -1, -1, 0, 1, 1, 1, 0, -1];
var tempMatrices = [];

var mul = [];

function signum(x) {
    if (x < 0) {
        return -1;
    }
    if (x > 0) {
        return 1;
    }

    return 0;
}

function init() {
    for (var i = 0; i < 16; i++) {
        var row = [];

        mul.push(row);

        for (var j = 0; j < 16; j++) {
            var _ux = signum(ux[i] * ux[j] + vx[i] * uy[j]);
            var _uy = signum(uy[i] * ux[j] + vy[i] * uy[j]);
            var _vx = signum(ux[i] * vx[j] + vx[i] * vy[j]);
            var _vy = signum(uy[i] * vx[j] + vy[i] * vy[j]);

            for (var k = 0; k < 16; k++) {
                if (ux[k] === _ux && uy[k] === _uy && vx[k] === _vx && vy[k] === _vy) {
                    row.push(k);
                    break;
                }
            }
        }
    }

    for (var _i = 0; _i < 16; _i++) {
        var mat = new _Matrix2.default();

        mat.set(ux[_i], uy[_i], vx[_i], vy[_i], 0, 0);
        tempMatrices.push(mat);
    }
}

init();

/**
 * Implements Dihedral Group D_8, see [group D4]{@link http://mathworld.wolfram.com/DihedralGroupD4.html},
 * D8 is the same but with diagonals. Used for texture rotations.
 *
 * Vector xX(i), xY(i) is U-axis of sprite with rotation i
 * Vector yY(i), yY(i) is V-axis of sprite with rotation i
 * Rotations: 0 grad (0), 90 grad (2), 180 grad (4), 270 grad (6)
 * Mirrors: vertical (8), main diagonal (10), horizontal (12), reverse diagonal (14)
 * This is the small part of gameofbombs.com portal system. It works.
 *
 * @author Ivan @ivanpopelyshev
 * @class
 * @memberof PIXI
 */
var GroupD8 = {
    E: 0,
    SE: 1,
    S: 2,
    SW: 3,
    W: 4,
    NW: 5,
    N: 6,
    NE: 7,
    MIRROR_VERTICAL: 8,
    MIRROR_HORIZONTAL: 12,
    uX: function uX(ind) {
        return ux[ind];
    },
    uY: function uY(ind) {
        return uy[ind];
    },
    vX: function vX(ind) {
        return vx[ind];
    },
    vY: function vY(ind) {
        return vy[ind];
    },
    inv: function inv(rotation) {
        if (rotation & 8) {
            return rotation & 15;
        }

        return -rotation & 7;
    },
    add: function add(rotationSecond, rotationFirst) {
        return mul[rotationSecond][rotationFirst];
    },
    sub: function sub(rotationSecond, rotationFirst) {
        return mul[rotationSecond][GroupD8.inv(rotationFirst)];
    },

    /**
     * Adds 180 degrees to rotation. Commutative operation.
     *
     * @memberof PIXI.GroupD8
     * @param {number} rotation - The number to rotate.
     * @returns {number} rotated number
     */
    rotate180: function rotate180(rotation) {
        return rotation ^ 4;
    },

    /**
     * Direction of main vector can be horizontal, vertical or diagonal.
     * Some objects work with vertical directions different.
     *
     * @memberof PIXI.GroupD8
     * @param {number} rotation - The number to check.
     * @returns {boolean} Whether or not the direction is vertical
     */
    isVertical: function isVertical(rotation) {
        return (rotation & 3) === 2;
    },

    /**
     * @memberof PIXI.GroupD8
     * @param {number} dx - TODO
     * @param {number} dy - TODO
     *
     * @return {number} TODO
     */
    byDirection: function byDirection(dx, dy) {
        if (Math.abs(dx) * 2 <= Math.abs(dy)) {
            if (dy >= 0) {
                return GroupD8.S;
            }

            return GroupD8.N;
        } else if (Math.abs(dy) * 2 <= Math.abs(dx)) {
            if (dx > 0) {
                return GroupD8.E;
            }

            return GroupD8.W;
        } else if (dy > 0) {
            if (dx > 0) {
                return GroupD8.SE;
            }

            return GroupD8.SW;
        } else if (dx > 0) {
            return GroupD8.NE;
        }

        return GroupD8.NW;
    },

    /**
     * Helps sprite to compensate texture packer rotation.
     *
     * @memberof PIXI.GroupD8
     * @param {PIXI.Matrix} matrix - sprite world matrix
     * @param {number} rotation - The rotation factor to use.
     * @param {number} tx - sprite anchoring
     * @param {number} ty - sprite anchoring
     */
    matrixAppendRotationInv: function matrixAppendRotationInv(matrix, rotation) {
        var tx = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        var ty = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

        // Packer used "rotation", we use "inv(rotation)"
        var mat = tempMatrices[GroupD8.inv(rotation)];

        mat.tx = tx;
        mat.ty = ty;
        matrix.append(mat);
    }
};

exports.default = GroupD8;
//# sourceMappingURL=GroupD8.js.map

/***/ }),
/* 172 */
/***/ (function(module, exports) {

// var GL_MAP = {};

/**
 * @param gl {WebGLRenderingContext} The current WebGL context
 * @param attribs {*}
 * @param state {*}
 */
var setVertexAttribArrays = function (gl, attribs, state)
{
    var i;
    if(state)
    {
        var tempAttribState = state.tempAttribState,
            attribState = state.attribState;

        for (i = 0; i < tempAttribState.length; i++)
        {
            tempAttribState[i] = false;
        }

        // set the new attribs
        for (i = 0; i < attribs.length; i++)
        {
            tempAttribState[attribs[i].attribute.location] = true;
        }

        for (i = 0; i < attribState.length; i++)
        {
            if (attribState[i] !== tempAttribState[i])
            {
                attribState[i] = tempAttribState[i];

                if (state.attribState[i])
                {
                    gl.enableVertexAttribArray(i);
                }
                else
                {
                    gl.disableVertexAttribArray(i);
                }
            }
        }

    }
    else
    {
        for (i = 0; i < attribs.length; i++)
        {
            var attrib = attribs[i];
            gl.enableVertexAttribArray(attrib.attribute.location);
        }
    }
};

module.exports = setVertexAttribArrays;


/***/ }),
/* 173 */
/***/ (function(module, exports) {


/**
 * Helper class to create a WebGL Texture
 *
 * @class
 * @memberof PIXI.glCore
 * @param gl {WebGLRenderingContext} The current WebGL context
 * @param width {number} the width of the texture
 * @param height {number} the height of the texture
 * @param format {number} the pixel format of the texture. defaults to gl.RGBA
 * @param type {number} the gl type of the texture. defaults to gl.UNSIGNED_BYTE
 */
var Texture = function(gl, width, height, format, type)
{
	/**
	 * The current WebGL rendering context
	 *
	 * @member {WebGLRenderingContext}
	 */
	this.gl = gl;


	/**
	 * The WebGL texture
	 *
	 * @member {WebGLTexture}
	 */
	this.texture = gl.createTexture();

	/**
	 * If mipmapping was used for this texture, enable and disable with enableMipmap()
	 *
	 * @member {Boolean}
	 */
	// some settings..
	this.mipmap = false;


	/**
	 * Set to true to enable pre-multiplied alpha
	 *
	 * @member {Boolean}
	 */
	this.premultiplyAlpha = false;

	/**
	 * The width of texture
	 *
	 * @member {Number}
	 */
	this.width = width || -1;
	/**
	 * The height of texture
	 *
	 * @member {Number}
	 */
	this.height = height || -1;

	/**
	 * The pixel format of the texture. defaults to gl.RGBA
	 *
	 * @member {Number}
	 */
	this.format = format || gl.RGBA;

	/**
	 * The gl type of the texture. defaults to gl.UNSIGNED_BYTE
	 *
	 * @member {Number}
	 */
	this.type = type || gl.UNSIGNED_BYTE;


};

/**
 * Uploads this texture to the GPU
 * @param source {HTMLImageElement|ImageData|HTMLVideoElement} the source image of the texture
 */
Texture.prototype.upload = function(source)
{
	this.bind();

	var gl = this.gl;


	gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, this.premultiplyAlpha);

	var newWidth = source.videoWidth || source.width;
	var newHeight = source.videoHeight || source.height;

	if(newHeight !== this.height || newWidth !== this.width)
	{
		gl.texImage2D(gl.TEXTURE_2D, 0, this.format, this.format, this.type, source);
	}
	else
	{
    	gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, this.format, this.type, source);
	}

	// if the source is a video, we need to use the videoWidth / videoHeight properties as width / height will be incorrect.
	this.width = newWidth;
	this.height = newHeight;

};

var FLOATING_POINT_AVAILABLE = false;

/**
 * Use a data source and uploads this texture to the GPU
 * @param data {TypedArray} the data to upload to the texture
 * @param width {number} the new width of the texture
 * @param height {number} the new height of the texture
 */
Texture.prototype.uploadData = function(data, width, height)
{
	this.bind();

	var gl = this.gl;


	if(data instanceof Float32Array)
	{
		if(!FLOATING_POINT_AVAILABLE)
		{
			var ext = gl.getExtension("OES_texture_float");

			if(ext)
			{
				FLOATING_POINT_AVAILABLE = true;
			}
			else
			{
				throw new Error('floating point textures not available');
			}
		}

		this.type = gl.FLOAT;
	}
	else
	{
		// TODO support for other types
		this.type = this.type || gl.UNSIGNED_BYTE;
	}

	// what type of data?
	gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, this.premultiplyAlpha);


	if(width !== this.width || height !== this.height)
	{
		gl.texImage2D(gl.TEXTURE_2D, 0, this.format,  width, height, 0, this.format, this.type, data || null);
	}
	else
	{
		gl.texSubImage2D(gl.TEXTURE_2D, 0, 0, 0, width, height, this.format, this.type, data || null);
	}

	this.width = width;
	this.height = height;


//	texSubImage2D
};

/**
 * Binds the texture
 * @param  location
 */
Texture.prototype.bind = function(location)
{
	var gl = this.gl;

	if(location !== undefined)
	{
		gl.activeTexture(gl.TEXTURE0 + location);
	}

	gl.bindTexture(gl.TEXTURE_2D, this.texture);
};

/**
 * Unbinds the texture
 */
Texture.prototype.unbind = function()
{
	var gl = this.gl;
	gl.bindTexture(gl.TEXTURE_2D, null);
};

/**
 * @param linear {Boolean} if we want to use linear filtering or nearest neighbour interpolation
 */
Texture.prototype.minFilter = function( linear )
{
	var gl = this.gl;

	this.bind();

	if(this.mipmap)
	{
		gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, linear ? gl.LINEAR_MIPMAP_LINEAR : gl.NEAREST_MIPMAP_NEAREST);
	}
	else
	{
		gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, linear ? gl.LINEAR : gl.NEAREST);
	}
};

/**
 * @param linear {Boolean} if we want to use linear filtering or nearest neighbour interpolation
 */
Texture.prototype.magFilter = function( linear )
{
	var gl = this.gl;

	this.bind();

	gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, linear ? gl.LINEAR : gl.NEAREST);
};

/**
 * Enables mipmapping
 */
Texture.prototype.enableMipmap = function()
{
	var gl = this.gl;

	this.bind();

	this.mipmap = true;

	gl.generateMipmap(gl.TEXTURE_2D);
};

/**
 * Enables linear filtering
 */
Texture.prototype.enableLinearScaling = function()
{
	this.minFilter(true);
	this.magFilter(true);
};

/**
 * Enables nearest neighbour interpolation
 */
Texture.prototype.enableNearestScaling = function()
{
	this.minFilter(false);
	this.magFilter(false);
};

/**
 * Enables clamping on the texture so WebGL will not repeat it
 */
Texture.prototype.enableWrapClamp = function()
{
	var gl = this.gl;

	this.bind();

	gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
};

/**
 * Enable tiling on the texture
 */
Texture.prototype.enableWrapRepeat = function()
{
	var gl = this.gl;

	this.bind();

	gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.REPEAT);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.REPEAT);
};

Texture.prototype.enableWrapMirrorRepeat = function()
{
	var gl = this.gl;

	this.bind();

	gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.MIRRORED_REPEAT);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.MIRRORED_REPEAT);
};


/**
 * Destroys this texture
 */
Texture.prototype.destroy = function()
{
	var gl = this.gl;
	//TODO
	gl.deleteTexture(this.texture);
};

/**
 * @static
 * @param gl {WebGLRenderingContext} The current WebGL context
 * @param source {HTMLImageElement|ImageData} the source image of the texture
 * @param premultiplyAlpha {Boolean} If we want to use pre-multiplied alpha
 */
Texture.fromSource = function(gl, source, premultiplyAlpha)
{
	var texture = new Texture(gl);
	texture.premultiplyAlpha = premultiplyAlpha || false;
	texture.upload(source);

	return texture;
};

/**
 * @static
 * @param gl {WebGLRenderingContext} The current WebGL context
 * @param data {TypedArray} the data to upload to the texture
 * @param width {number} the new width of the texture
 * @param height {number} the new height of the texture
 */
Texture.fromData = function(gl, data, width, height)
{
	//console.log(data, width, height);
	var texture = new Texture(gl);
	texture.uploadData(data, width, height);

	return texture;
};


module.exports = Texture;


/***/ }),
/* 174 */
/***/ (function(module, exports) {


/**
 * @class
 * @memberof PIXI.glCore.shader
 * @param gl {WebGLRenderingContext} The current WebGL context {WebGLProgram}
 * @param vertexSrc {string|string[]} The vertex shader source as an array of strings.
 * @param fragmentSrc {string|string[]} The fragment shader source as an array of strings.
 * @param attributeLocations {Object} An attribute location map that lets you manually set the attribute locations
 * @return {WebGLProgram} the shader program
 */
var compileProgram = function(gl, vertexSrc, fragmentSrc, attributeLocations)
{
    var glVertShader = compileShader(gl, gl.VERTEX_SHADER, vertexSrc);
    var glFragShader = compileShader(gl, gl.FRAGMENT_SHADER, fragmentSrc);

    var program = gl.createProgram();

    gl.attachShader(program, glVertShader);
    gl.attachShader(program, glFragShader);

    // optionally, set the attributes manually for the program rather than letting WebGL decide..
    if(attributeLocations)
    {
        for(var i in attributeLocations)
        {
            gl.bindAttribLocation(program, attributeLocations[i], i);
        }
    }


    gl.linkProgram(program);

    // if linking fails, then log and cleanup
    if (!gl.getProgramParameter(program, gl.LINK_STATUS))
    {
        console.error('Pixi.js Error: Could not initialize shader.');
        console.error('gl.VALIDATE_STATUS', gl.getProgramParameter(program, gl.VALIDATE_STATUS));
        console.error('gl.getError()', gl.getError());

        // if there is a program info log, log it
        if (gl.getProgramInfoLog(program) !== '')
        {
            console.warn('Pixi.js Warning: gl.getProgramInfoLog()', gl.getProgramInfoLog(program));
        }

        gl.deleteProgram(program);
        program = null;
    }

    // clean up some shaders
    gl.deleteShader(glVertShader);
    gl.deleteShader(glFragShader);

    return program;
};

/**
 * @private
 * @param gl {WebGLRenderingContext} The current WebGL context {WebGLProgram}
 * @param type {Number} the type, can be either VERTEX_SHADER or FRAGMENT_SHADER
 * @param vertexSrc {string|string[]} The vertex shader source as an array of strings.
 * @return {WebGLShader} the shader
 */
var compileShader = function (gl, type, src)
{
    var shader = gl.createShader(type);

    gl.shaderSource(shader, src);
    gl.compileShader(shader);

    if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS))
    {
        console.log(gl.getShaderInfoLog(shader));
        return null;
    }

    return shader;
};

module.exports = compileProgram;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {


var mapType = __webpack_require__(126);
var mapSize = __webpack_require__(176);

/**
 * Extracts the attributes
 * @class
 * @memberof PIXI.glCore.shader
 * @param gl {WebGLRenderingContext} The current WebGL rendering context
 * @param program {WebGLProgram} The shader program to get the attributes from
 * @return attributes {Object}
 */
var extractAttributes = function(gl, program)
{
    var attributes = {};

    var totalAttributes = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);

    for (var i = 0; i < totalAttributes; i++)
    {
        var attribData = gl.getActiveAttrib(program, i);
        var type = mapType(gl, attribData.type);

        attributes[attribData.name] = {
            type:type,
            size:mapSize(type),
            location:gl.getAttribLocation(program, attribData.name),
            //TODO - make an attribute object
            pointer: pointer
        };
    }

    return attributes;
};

var pointer = function(type, normalized, stride, start){
    // console.log(this.location)
    gl.vertexAttribPointer(this.location,this.size, type || gl.FLOAT, normalized || false, stride || 0, start || 0);
};

module.exports = extractAttributes;


/***/ }),
/* 176 */
/***/ (function(module, exports) {

/**
 * @class
 * @memberof PIXI.glCore.shader
 * @param type {String}
 * @return {Number}
 */
var mapSize = function(type) 
{ 
    return GLSL_TO_SIZE[type];
};


var GLSL_TO_SIZE = {
    'float':    1,
    'vec2':     2,
    'vec3':     3,
    'vec4':     4,

    'int':      1,
    'ivec2':    2,
    'ivec3':    3,
    'ivec4':    4,

    'bool':     1,
    'bvec2':    2,
    'bvec3':    3,
    'bvec4':    4,

    'mat2':     4,
    'mat3':     9,
    'mat4':     16,

    'sampler2D':  1
};

module.exports = mapSize;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var mapType = __webpack_require__(126);
var defaultValue = __webpack_require__(178);

/**
 * Extracts the uniforms
 * @class
 * @memberof PIXI.glCore.shader
 * @param gl {WebGLRenderingContext} The current WebGL rendering context
 * @param program {WebGLProgram} The shader program to get the uniforms from
 * @return uniforms {Object}
 */
var extractUniforms = function(gl, program)
{
	var uniforms = {};

    var totalUniforms = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);

    for (var i = 0; i < totalUniforms; i++)
    {
    	var uniformData = gl.getActiveUniform(program, i);
    	var name = uniformData.name.replace(/\[.*?\]/, "");
        var type = mapType(gl, uniformData.type );

    	uniforms[name] = {
    		type:type,
    		size:uniformData.size,
    		location:gl.getUniformLocation(program, name),
    		value:defaultValue(type, uniformData.size)
    	};
    }

	return uniforms;
};

module.exports = extractUniforms;


/***/ }),
/* 178 */
/***/ (function(module, exports) {

/**
 * @class
 * @memberof PIXI.glCore.shader
 * @param type {String} Type of value
 * @param size {Number}
 */
var defaultValue = function(type, size) 
{
    switch (type)
    {
        case 'float':
            return 0;

        case 'vec2': 
            return new Float32Array(2 * size);

        case 'vec3':
            return new Float32Array(3 * size);

        case 'vec4':     
            return new Float32Array(4 * size);
            
        case 'int':
        case 'sampler2D':
            return 0;

        case 'ivec2':   
            return new Int32Array(2 * size);

        case 'ivec3':
            return new Int32Array(3 * size);

        case 'ivec4': 
            return new Int32Array(4 * size);

        case 'bool':     
            return false;

        case 'bvec2':

            return booleanArray( 2 * size);

        case 'bvec3':
            return booleanArray(3 * size);

        case 'bvec4':
            return booleanArray(4 * size);

        case 'mat2':
            return new Float32Array([1, 0,
                                     0, 1]);

        case 'mat3': 
            return new Float32Array([1, 0, 0,
                                     0, 1, 0,
                                     0, 0, 1]);

        case 'mat4':
            return new Float32Array([1, 0, 0, 0,
                                     0, 1, 0, 0,
                                     0, 0, 1, 0,
                                     0, 0, 0, 1]);
    }
};

var booleanArray = function(size)
{
    var array = new Array(size);

    for (var i = 0; i < array.length; i++) 
    {
        array[i] = false;
    }

    return array;
};

module.exports = defaultValue;


/***/ }),
/* 179 */
/***/ (function(module, exports) {

/**
 * Sets the float precision on the shader. If the precision is already present this function will do nothing
 * @param {string} src       the shader source
 * @param {string} precision The float precision of the shader. Options are 'lowp', 'mediump' or 'highp'.
 *
 * @return {string} modified shader source
 */
var setPrecision = function(src, precision)
{
    if(src.substring(0, 9) !== 'precision')
    {
        return 'precision ' + precision + ' float;\n' + src;
    }

    return src;
};

module.exports = setPrecision;


/***/ }),
/* 180 */
/***/ (function(module, exports) {

/**
 * Extracts the attributes
 * @class
 * @memberof PIXI.glCore.shader
 * @param gl {WebGLRenderingContext} The current WebGL rendering context
 * @param uniforms {Array} @mat ?
 * @return attributes {Object}
 */
var generateUniformAccessObject = function(gl, uniformData)
{
    // this is the object we will be sending back.
    // an object hierachy will be created for structs
    var uniforms = {data:{}};

    uniforms.gl = gl;

    var uniformKeys= Object.keys(uniformData);

    for (var i = 0; i < uniformKeys.length; i++)
    {
        var fullName = uniformKeys[i];

        var nameTokens = fullName.split('.');
        var name = nameTokens[nameTokens.length - 1];


        var uniformGroup = getUniformGroup(nameTokens, uniforms);

        var uniform =  uniformData[fullName];
        uniformGroup.data[name] = uniform;

        uniformGroup.gl = gl;

        Object.defineProperty(uniformGroup, name, {
            get: generateGetter(name),
            set: generateSetter(name, uniform)
        });
    }

    return uniforms;
};

var generateGetter = function(name)
{
    return function() {
        return this.data[name].value;
    };
};

var GLSL_SINGLE_SETTERS = {
    float: function setSingleFloat(gl, location, value) { gl.uniform1f(location, value); },
    vec2: function setSingleVec2(gl, location, value) { gl.uniform2f(location, value[0], value[1]); },
    vec3: function setSingleVec3(gl, location, value) { gl.uniform3f(location, value[0], value[1], value[2]); },
    vec4: function setSingleVec4(gl, location, value) { gl.uniform4f(location, value[0], value[1], value[2], value[3]); },

    int: function setSingleInt(gl, location, value) { gl.uniform1i(location, value); },
    ivec2: function setSingleIvec2(gl, location, value) { gl.uniform2i(location, value[0], value[1]); },
    ivec3: function setSingleIvec3(gl, location, value) { gl.uniform3i(location, value[0], value[1], value[2]); },
    ivec4: function setSingleIvec4(gl, location, value) { gl.uniform4i(location, value[0], value[1], value[2], value[3]); },

    bool: function setSingleBool(gl, location, value) { gl.uniform1i(location, value); },
    bvec2: function setSingleBvec2(gl, location, value) { gl.uniform2i(location, value[0], value[1]); },
    bvec3: function setSingleBvec3(gl, location, value) { gl.uniform3i(location, value[0], value[1], value[2]); },
    bvec4: function setSingleBvec4(gl, location, value) { gl.uniform4i(location, value[0], value[1], value[2], value[3]); },

    mat2: function setSingleMat2(gl, location, value) { gl.uniformMatrix2fv(location, false, value); },
    mat3: function setSingleMat3(gl, location, value) { gl.uniformMatrix3fv(location, false, value); },
    mat4: function setSingleMat4(gl, location, value) { gl.uniformMatrix4fv(location, false, value); },

    sampler2D: function setSingleSampler2D(gl, location, value) { gl.uniform1i(location, value); },
};

var GLSL_ARRAY_SETTERS = {
    float: function setFloatArray(gl, location, value) { gl.uniform1fv(location, value); },
    vec2: function setVec2Array(gl, location, value) { gl.uniform2fv(location, value); },
    vec3: function setVec3Array(gl, location, value) { gl.uniform3fv(location, value); },
    vec4: function setVec4Array(gl, location, value) { gl.uniform4fv(location, value); },
    int: function setIntArray(gl, location, value) { gl.uniform1iv(location, value); },
    ivec2: function setIvec2Array(gl, location, value) { gl.uniform2iv(location, value); },
    ivec3: function setIvec3Array(gl, location, value) { gl.uniform3iv(location, value); },
    ivec4: function setIvec4Array(gl, location, value) { gl.uniform4iv(location, value); },
    bool: function setBoolArray(gl, location, value) { gl.uniform1iv(location, value); },
    bvec2: function setBvec2Array(gl, location, value) { gl.uniform2iv(location, value); },
    bvec3: function setBvec3Array(gl, location, value) { gl.uniform3iv(location, value); },
    bvec4: function setBvec4Array(gl, location, value) { gl.uniform4iv(location, value); },
    sampler2D: function setSampler2DArray(gl, location, value) { gl.uniform1iv(location, value); },
};

function generateSetter(name, uniform)
{
    return function(value) {
        this.data[name].value = value;
        var location = this.data[name].location;
        if (uniform.size === 1)
        {
            GLSL_SINGLE_SETTERS[uniform.type](this.gl, location, value);
        }
        else
        {
            // glslSetArray(gl, location, type, value) {
            GLSL_ARRAY_SETTERS[uniform.type](this.gl, location, value);
        }
    };
}

function getUniformGroup(nameTokens, uniform)
{
    var cur = uniform;

    for (var i = 0; i < nameTokens.length - 1; i++)
    {
        var o = cur[nameTokens[i]] || {data:{}};
        cur[nameTokens[i]] = o;
        cur = o;
    }

    return cur;
}


module.exports = generateUniformAccessObject;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _eventemitter = __webpack_require__(60);

var _eventemitter2 = _interopRequireDefault(_eventemitter);

var _const = __webpack_require__(5);

var _settings = __webpack_require__(17);

var _settings2 = _interopRequireDefault(_settings);

var _TransformStatic = __webpack_require__(182);

var _TransformStatic2 = _interopRequireDefault(_TransformStatic);

var _Transform = __webpack_require__(183);

var _Transform2 = _interopRequireDefault(_Transform);

var _Bounds = __webpack_require__(127);

var _Bounds2 = _interopRequireDefault(_Bounds);

var _math = __webpack_require__(20);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// _tempDisplayObjectParent = new DisplayObject();

/**
 * The base class for all objects that are rendered on the screen.
 * This is an abstract class and should not be used on its own rather it should be extended.
 *
 * @class
 * @extends EventEmitter
 * @memberof PIXI
 */
var DisplayObject = function (_EventEmitter) {
    _inherits(DisplayObject, _EventEmitter);

    /**
     *
     */
    function DisplayObject() {
        _classCallCheck(this, DisplayObject);

        var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

        var TransformClass = _settings2.default.TRANSFORM_MODE === _const.TRANSFORM_MODE.STATIC ? _TransformStatic2.default : _Transform2.default;

        _this.tempDisplayObjectParent = null;

        // TODO: need to create Transform from factory
        /**
         * World transform and local transform of this object.
         * This will become read-only later, please do not assign anything there unless you know what are you doing
         *
         * @member {PIXI.TransformBase}
         */
        _this.transform = new TransformClass();

        /**
         * The opacity of the object.
         *
         * @member {number}
         */
        _this.alpha = 1;

        /**
         * The visibility of the object. If false the object will not be drawn, and
         * the updateTransform function will not be called.
         *
         * Only affects recursive calls from parent. You can ask for bounds or call updateTransform manually
         *
         * @member {boolean}
         */
        _this.visible = true;

        /**
         * Can this object be rendered, if false the object will not be drawn but the updateTransform
         * methods will still be called.
         *
         * Only affects recursive calls from parent. You can ask for bounds manually
         *
         * @member {boolean}
         */
        _this.renderable = true;

        /**
         * The display object container that contains this display object.
         *
         * @member {PIXI.Container}
         * @readonly
         */
        _this.parent = null;

        /**
         * The multiplied alpha of the displayObject
         *
         * @member {number}
         * @readonly
         */
        _this.worldAlpha = 1;

        /**
         * The area the filter is applied to. This is used as more of an optimisation
         * rather than figuring out the dimensions of the displayObject each frame you can set this rectangle
         *
         * Also works as an interaction mask
         *
         * @member {PIXI.Rectangle}
         */
        _this.filterArea = null;

        _this._filters = null;
        _this._enabledFilters = null;

        /**
         * The bounds object, this is used to calculate and store the bounds of the displayObject
         *
         * @member {PIXI.Rectangle}
         * @private
         */
        _this._bounds = new _Bounds2.default();
        _this._boundsID = 0;
        _this._lastBoundsID = -1;
        _this._boundsRect = null;
        _this._localBoundsRect = null;

        /**
         * The original, cached mask of the object
         *
         * @member {PIXI.Graphics|PIXI.Sprite}
         * @private
         */
        _this._mask = null;

        /**
         * If the object has been destroyed via destroy(). If true, it should not be used.
         *
         * @member {boolean}
         * @private
         * @readonly
         */
        _this._destroyed = false;

        /**
         * Fired when this DisplayObject is added to a Container.
         *
         * @event PIXI.DisplayObject#added
         * @param {PIXI.Container} container - The container added to.
         */

        /**
         * Fired when this DisplayObject is removed from a Container.
         *
         * @event PIXI.DisplayObject#removed
         * @param {PIXI.Container} container - The container removed from.
         */
        return _this;
    }

    /**
     * @private
     * @member {PIXI.DisplayObject}
     */


    /**
     * Updates the object transform for rendering
     *
     * TODO - Optimization pass!
     */
    DisplayObject.prototype.updateTransform = function updateTransform() {
        this.transform.updateTransform(this.parent.transform);
        // multiply the alphas..
        this.worldAlpha = this.alpha * this.parent.worldAlpha;

        this._bounds.updateID++;
    };

    /**
     * recursively updates transform of all objects from the root to this one
     * internal function for toLocal()
     */


    DisplayObject.prototype._recursivePostUpdateTransform = function _recursivePostUpdateTransform() {
        if (this.parent) {
            this.parent._recursivePostUpdateTransform();
            this.transform.updateTransform(this.parent.transform);
        } else {
            this.transform.updateTransform(this._tempDisplayObjectParent.transform);
        }
    };

    /**
     * Retrieves the bounds of the displayObject as a rectangle object.
     *
     * @param {boolean} skipUpdate - setting to true will stop the transforms of the scene graph from
     *  being updated. This means the calculation returned MAY be out of date BUT will give you a
     *  nice performance boost
     * @param {PIXI.Rectangle} rect - Optional rectangle to store the result of the bounds calculation
     * @return {PIXI.Rectangle} the rectangular bounding area
     */


    DisplayObject.prototype.getBounds = function getBounds(skipUpdate, rect) {
        if (!skipUpdate) {
            if (!this.parent) {
                this.parent = this._tempDisplayObjectParent;
                this.updateTransform();
                this.parent = null;
            } else {
                this._recursivePostUpdateTransform();
                this.updateTransform();
            }
        }

        if (this._boundsID !== this._lastBoundsID) {
            this.calculateBounds();
        }

        if (!rect) {
            if (!this._boundsRect) {
                this._boundsRect = new _math.Rectangle();
            }

            rect = this._boundsRect;
        }

        return this._bounds.getRectangle(rect);
    };

    /**
     * Retrieves the local bounds of the displayObject as a rectangle object
     *
     * @param {PIXI.Rectangle} [rect] - Optional rectangle to store the result of the bounds calculation
     * @return {PIXI.Rectangle} the rectangular bounding area
     */


    DisplayObject.prototype.getLocalBounds = function getLocalBounds(rect) {
        var transformRef = this.transform;
        var parentRef = this.parent;

        this.parent = null;
        this.transform = this._tempDisplayObjectParent.transform;

        if (!rect) {
            if (!this._localBoundsRect) {
                this._localBoundsRect = new _math.Rectangle();
            }

            rect = this._localBoundsRect;
        }

        var bounds = this.getBounds(false, rect);

        this.parent = parentRef;
        this.transform = transformRef;

        return bounds;
    };

    /**
     * Calculates the global position of the display object
     *
     * @param {PIXI.Point} position - The world origin to calculate from
     * @param {PIXI.Point} [point] - A Point object in which to store the value, optional
     *  (otherwise will create a new Point)
     * @param {boolean} [skipUpdate=false] - Should we skip the update transform.
     * @return {PIXI.Point} A point object representing the position of this object
     */


    DisplayObject.prototype.toGlobal = function toGlobal(position, point) {
        var skipUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        if (!skipUpdate) {
            this._recursivePostUpdateTransform();

            // this parent check is for just in case the item is a root object.
            // If it is we need to give it a temporary parent so that displayObjectUpdateTransform works correctly
            // this is mainly to avoid a parent check in the main loop. Every little helps for performance :)
            if (!this.parent) {
                this.parent = this._tempDisplayObjectParent;
                this.displayObjectUpdateTransform();
                this.parent = null;
            } else {
                this.displayObjectUpdateTransform();
            }
        }

        // don't need to update the lot
        return this.worldTransform.apply(position, point);
    };

    /**
     * Calculates the local position of the display object relative to another point
     *
     * @param {PIXI.Point} position - The world origin to calculate from
     * @param {PIXI.DisplayObject} [from] - The DisplayObject to calculate the global position from
     * @param {PIXI.Point} [point] - A Point object in which to store the value, optional
     *  (otherwise will create a new Point)
     * @param {boolean} [skipUpdate=false] - Should we skip the update transform
     * @return {PIXI.Point} A point object representing the position of this object
     */


    DisplayObject.prototype.toLocal = function toLocal(position, from, point, skipUpdate) {
        if (from) {
            position = from.toGlobal(position, point, skipUpdate);
        }

        if (!skipUpdate) {
            this._recursivePostUpdateTransform();

            // this parent check is for just in case the item is a root object.
            // If it is we need to give it a temporary parent so that displayObjectUpdateTransform works correctly
            // this is mainly to avoid a parent check in the main loop. Every little helps for performance :)
            if (!this.parent) {
                this.parent = this._tempDisplayObjectParent;
                this.displayObjectUpdateTransform();
                this.parent = null;
            } else {
                this.displayObjectUpdateTransform();
            }
        }

        // simply apply the matrix..
        return this.worldTransform.applyInverse(position, point);
    };

    /**
     * Renders the object using the WebGL renderer
     *
     * @param {PIXI.WebGLRenderer} renderer - The renderer
     */


    DisplayObject.prototype.renderWebGL = function renderWebGL(renderer) // eslint-disable-line no-unused-vars
    {}
    // OVERWRITE;


    /**
     * Renders the object using the Canvas renderer
     *
     * @param {PIXI.CanvasRenderer} renderer - The renderer
     */
    ;

    DisplayObject.prototype.renderCanvas = function renderCanvas(renderer) // eslint-disable-line no-unused-vars
    {}
    // OVERWRITE;


    /**
     * Set the parent Container of this DisplayObject
     *
     * @param {PIXI.Container} container - The Container to add this DisplayObject to
     * @return {PIXI.Container} The Container that this DisplayObject was added to
     */
    ;

    DisplayObject.prototype.setParent = function setParent(container) {
        if (!container || !container.addChild) {
            throw new Error('setParent: Argument must be a Container');
        }

        container.addChild(this);

        return container;
    };

    /**
     * Convenience function to set the position, scale, skew and pivot at once.
     *
     * @param {number} [x=0] - The X position
     * @param {number} [y=0] - The Y position
     * @param {number} [scaleX=1] - The X scale value
     * @param {number} [scaleY=1] - The Y scale value
     * @param {number} [rotation=0] - The rotation
     * @param {number} [skewX=0] - The X skew value
     * @param {number} [skewY=0] - The Y skew value
     * @param {number} [pivotX=0] - The X pivot value
     * @param {number} [pivotY=0] - The Y pivot value
     * @return {PIXI.DisplayObject} The DisplayObject instance
     */


    DisplayObject.prototype.setTransform = function setTransform() {
        var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var scaleX = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        var scaleY = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
        var rotation = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
        var skewX = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
        var skewY = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
        var pivotX = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
        var pivotY = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 0;

        this.position.x = x;
        this.position.y = y;
        this.scale.x = !scaleX ? 1 : scaleX;
        this.scale.y = !scaleY ? 1 : scaleY;
        this.rotation = rotation;
        this.skew.x = skewX;
        this.skew.y = skewY;
        this.pivot.x = pivotX;
        this.pivot.y = pivotY;

        return this;
    };

    /**
     * Base destroy method for generic display objects. This will automatically
     * remove the display object from its parent Container as well as remove
     * all current event listeners and internal references. Do not use a DisplayObject
     * after calling `destroy`.
     *
     */


    DisplayObject.prototype.destroy = function destroy() {
        this.removeAllListeners();
        if (this.parent) {
            this.parent.removeChild(this);
        }
        this.transform = null;

        this.parent = null;

        this._bounds = null;
        this._currentBounds = null;
        this._mask = null;

        this.filterArea = null;

        this.interactive = false;
        this.interactiveChildren = false;

        this._destroyed = true;
    };

    /**
     * The position of the displayObject on the x axis relative to the local coordinates of the parent.
     * An alias to position.x
     *
     * @member {number}
     */


    _createClass(DisplayObject, [{
        key: '_tempDisplayObjectParent',
        get: function get() {
            if (this.tempDisplayObjectParent === null) {
                this.tempDisplayObjectParent = new DisplayObject();
            }

            return this.tempDisplayObjectParent;
        }
    }, {
        key: 'x',
        get: function get() {
            return this.position.x;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.transform.position.x = value;
        }

        /**
         * The position of the displayObject on the y axis relative to the local coordinates of the parent.
         * An alias to position.y
         *
         * @member {number}
         */

    }, {
        key: 'y',
        get: function get() {
            return this.position.y;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.transform.position.y = value;
        }

        /**
         * Current transform of the object based on world (parent) factors
         *
         * @member {PIXI.Matrix}
         * @readonly
         */

    }, {
        key: 'worldTransform',
        get: function get() {
            return this.transform.worldTransform;
        }

        /**
         * Current transform of the object based on local factors: position, scale, other stuff
         *
         * @member {PIXI.Matrix}
         * @readonly
         */

    }, {
        key: 'localTransform',
        get: function get() {
            return this.transform.localTransform;
        }

        /**
         * The coordinate of the object relative to the local coordinates of the parent.
         * Assignment by value since pixi-v4.
         *
         * @member {PIXI.Point|PIXI.ObservablePoint}
         */

    }, {
        key: 'position',
        get: function get() {
            return this.transform.position;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.transform.position.copy(value);
        }

        /**
         * The scale factor of the object.
         * Assignment by value since pixi-v4.
         *
         * @member {PIXI.Point|PIXI.ObservablePoint}
         */

    }, {
        key: 'scale',
        get: function get() {
            return this.transform.scale;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.transform.scale.copy(value);
        }

        /**
         * The pivot point of the displayObject that it rotates around.
         * Assignment by value since pixi-v4.
         *
         * @member {PIXI.Point|PIXI.ObservablePoint}
         */

    }, {
        key: 'pivot',
        get: function get() {
            return this.transform.pivot;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.transform.pivot.copy(value);
        }

        /**
         * The skew factor for the object in radians.
         * Assignment by value since pixi-v4.
         *
         * @member {PIXI.ObservablePoint}
         */

    }, {
        key: 'skew',
        get: function get() {
            return this.transform.skew;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.transform.skew.copy(value);
        }

        /**
         * The rotation of the object in radians.
         *
         * @member {number}
         */

    }, {
        key: 'rotation',
        get: function get() {
            return this.transform.rotation;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.transform.rotation = value;
        }

        /**
         * Indicates if the object is globally visible.
         *
         * @member {boolean}
         * @readonly
         */

    }, {
        key: 'worldVisible',
        get: function get() {
            var item = this;

            do {
                if (!item.visible) {
                    return false;
                }

                item = item.parent;
            } while (item);

            return true;
        }

        /**
         * Sets a mask for the displayObject. A mask is an object that limits the visibility of an
         * object to the shape of the mask applied to it. In PIXI a regular mask must be a
         * PIXI.Graphics or a PIXI.Sprite object. This allows for much faster masking in canvas as it
         * utilises shape clipping. To remove a mask, set this property to null.
         *
         * @todo For the moment, PIXI.CanvasRenderer doesn't support PIXI.Sprite as mask.
         *
         * @member {PIXI.Graphics|PIXI.Sprite}
         */

    }, {
        key: 'mask',
        get: function get() {
            return this._mask;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            if (this._mask) {
                this._mask.renderable = true;
                this._mask.isMask = false;
            }

            this._mask = value;

            if (this._mask) {
                this._mask.renderable = false;
                this._mask.isMask = true;
            }
        }

        /**
         * Sets the filters for the displayObject.
         * * IMPORTANT: This is a webGL only feature and will be ignored by the canvas renderer.
         * To remove filters simply set this property to 'null'
         *
         * @member {PIXI.Filter[]}
         */

    }, {
        key: 'filters',
        get: function get() {
            return this._filters && this._filters.slice();
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this._filters = value && value.slice();
        }
    }]);

    return DisplayObject;
}(_eventemitter2.default);

// performance increase to avoid using call.. (10x faster)


exports.default = DisplayObject;
DisplayObject.prototype.displayObjectUpdateTransform = DisplayObject.prototype.updateTransform;
//# sourceMappingURL=DisplayObject.js.map

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _math = __webpack_require__(20);

var _TransformBase2 = __webpack_require__(129);

var _TransformBase3 = _interopRequireDefault(_TransformBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Transform that takes care about its versions
 *
 * @class
 * @extends PIXI.TransformBase
 * @memberof PIXI
 */
var TransformStatic = function (_TransformBase) {
    _inherits(TransformStatic, _TransformBase);

    /**
     *
     */
    function TransformStatic() {
        _classCallCheck(this, TransformStatic);

        /**
        * The coordinate of the object relative to the local coordinates of the parent.
        *
        * @member {PIXI.ObservablePoint}
        */
        var _this = _possibleConstructorReturn(this, _TransformBase.call(this));

        _this.position = new _math.ObservablePoint(_this.onChange, _this, 0, 0);

        /**
         * The scale factor of the object.
         *
         * @member {PIXI.ObservablePoint}
         */
        _this.scale = new _math.ObservablePoint(_this.onChange, _this, 1, 1);

        /**
         * The pivot point of the displayObject that it rotates around.
         *
         * @member {PIXI.ObservablePoint}
         */
        _this.pivot = new _math.ObservablePoint(_this.onChange, _this, 0, 0);

        /**
         * The skew amount, on the x and y axis.
         *
         * @member {PIXI.ObservablePoint}
         */
        _this.skew = new _math.ObservablePoint(_this.updateSkew, _this, 0, 0);

        _this._rotation = 0;

        _this._cx = 1; // cos rotation + skewY;
        _this._sx = 0; // sin rotation + skewY;
        _this._cy = 0; // cos rotation + Math.PI/2 - skewX;
        _this._sy = 1; // sin rotation + Math.PI/2 - skewX;

        _this._localID = 0;
        _this._currentLocalID = 0;
        return _this;
    }

    /**
     * Called when a value changes.
     *
     * @private
     */


    TransformStatic.prototype.onChange = function onChange() {
        this._localID++;
    };

    /**
     * Called when skew or rotation changes
     *
     * @private
     */


    TransformStatic.prototype.updateSkew = function updateSkew() {
        this._cx = Math.cos(this._rotation + this.skew._y);
        this._sx = Math.sin(this._rotation + this.skew._y);
        this._cy = -Math.sin(this._rotation - this.skew._x); // cos, added PI/2
        this._sy = Math.cos(this._rotation - this.skew._x); // sin, added PI/2

        this._localID++;
    };

    /**
     * Updates only local matrix
     */


    TransformStatic.prototype.updateLocalTransform = function updateLocalTransform() {
        var lt = this.localTransform;

        if (this._localID !== this._currentLocalID) {
            // get the matrix values of the displayobject based on its transform properties..
            lt.a = this._cx * this.scale._x;
            lt.b = this._sx * this.scale._x;
            lt.c = this._cy * this.scale._y;
            lt.d = this._sy * this.scale._y;

            lt.tx = this.position._x - (this.pivot._x * lt.a + this.pivot._y * lt.c);
            lt.ty = this.position._y - (this.pivot._x * lt.b + this.pivot._y * lt.d);
            this._currentLocalID = this._localID;

            // force an update..
            this._parentID = -1;
        }
    };

    /**
     * Updates the values of the object and applies the parent's transform.
     *
     * @param {PIXI.Transform} parentTransform - The transform of the parent of this object
     */


    TransformStatic.prototype.updateTransform = function updateTransform(parentTransform) {
        var lt = this.localTransform;

        if (this._localID !== this._currentLocalID) {
            // get the matrix values of the displayobject based on its transform properties..
            lt.a = this._cx * this.scale._x;
            lt.b = this._sx * this.scale._x;
            lt.c = this._cy * this.scale._y;
            lt.d = this._sy * this.scale._y;

            lt.tx = this.position._x - (this.pivot._x * lt.a + this.pivot._y * lt.c);
            lt.ty = this.position._y - (this.pivot._x * lt.b + this.pivot._y * lt.d);
            this._currentLocalID = this._localID;

            // force an update..
            this._parentID = -1;
        }

        if (this._parentID !== parentTransform._worldID) {
            // concat the parent matrix with the objects transform.
            var pt = parentTransform.worldTransform;
            var wt = this.worldTransform;

            wt.a = lt.a * pt.a + lt.b * pt.c;
            wt.b = lt.a * pt.b + lt.b * pt.d;
            wt.c = lt.c * pt.a + lt.d * pt.c;
            wt.d = lt.c * pt.b + lt.d * pt.d;
            wt.tx = lt.tx * pt.a + lt.ty * pt.c + pt.tx;
            wt.ty = lt.tx * pt.b + lt.ty * pt.d + pt.ty;

            this._parentID = parentTransform._worldID;

            // update the id of the transform..
            this._worldID++;
        }
    };

    /**
     * Decomposes a matrix and sets the transforms properties based on it.
     *
     * @param {PIXI.Matrix} matrix - The matrix to decompose
     */


    TransformStatic.prototype.setFromMatrix = function setFromMatrix(matrix) {
        matrix.decompose(this);
        this._localID++;
    };

    /**
     * The rotation of the object in radians.
     *
     * @member {number}
     */


    _createClass(TransformStatic, [{
        key: 'rotation',
        get: function get() {
            return this._rotation;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            if (this._rotation !== value) {
                this._rotation = value;
                this.updateSkew();
            }
        }
    }]);

    return TransformStatic;
}(_TransformBase3.default);

exports.default = TransformStatic;
//# sourceMappingURL=TransformStatic.js.map

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _math = __webpack_require__(20);

var _TransformBase2 = __webpack_require__(129);

var _TransformBase3 = _interopRequireDefault(_TransformBase2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Generic class to deal with traditional 2D matrix transforms
 * local transformation is calculated from position,scale,skew and rotation
 *
 * @class
 * @extends PIXI.TransformBase
 * @memberof PIXI
 */
var Transform = function (_TransformBase) {
  _inherits(Transform, _TransformBase);

  /**
   *
   */
  function Transform() {
    _classCallCheck(this, Transform);

    /**
    * The coordinate of the object relative to the local coordinates of the parent.
    *
    * @member {PIXI.Point}
    */
    var _this = _possibleConstructorReturn(this, _TransformBase.call(this));

    _this.position = new _math.Point(0, 0);

    /**
     * The scale factor of the object.
     *
     * @member {PIXI.Point}
     */
    _this.scale = new _math.Point(1, 1);

    /**
     * The skew amount, on the x and y axis.
     *
     * @member {PIXI.ObservablePoint}
     */
    _this.skew = new _math.ObservablePoint(_this.updateSkew, _this, 0, 0);

    /**
     * The pivot point of the displayObject that it rotates around.
     *
     * @member {PIXI.Point}
     */
    _this.pivot = new _math.Point(0, 0);

    /**
     * The rotation value of the object, in radians
     *
     * @member {Number}
     * @private
     */
    _this._rotation = 0;

    _this._cx = 1; // cos rotation + skewY;
    _this._sx = 0; // sin rotation + skewY;
    _this._cy = 0; // cos rotation + Math.PI/2 - skewX;
    _this._sy = 1; // sin rotation + Math.PI/2 - skewX;
    return _this;
  }

  /**
   * Updates the skew values when the skew or rotation changes.
   *
   * @private
   */


  Transform.prototype.updateSkew = function updateSkew() {
    this._cx = Math.cos(this._rotation + this.skew._y);
    this._sx = Math.sin(this._rotation + this.skew._y);
    this._cy = -Math.sin(this._rotation - this.skew._x); // cos, added PI/2
    this._sy = Math.cos(this._rotation - this.skew._x); // sin, added PI/2
  };

  /**
   * Updates only local matrix
   */


  Transform.prototype.updateLocalTransform = function updateLocalTransform() {
    var lt = this.localTransform;

    lt.a = this._cx * this.scale.x;
    lt.b = this._sx * this.scale.x;
    lt.c = this._cy * this.scale.y;
    lt.d = this._sy * this.scale.y;

    lt.tx = this.position.x - (this.pivot.x * lt.a + this.pivot.y * lt.c);
    lt.ty = this.position.y - (this.pivot.x * lt.b + this.pivot.y * lt.d);
  };

  /**
   * Updates the values of the object and applies the parent's transform.
   *
   * @param {PIXI.Transform} parentTransform - The transform of the parent of this object
   */


  Transform.prototype.updateTransform = function updateTransform(parentTransform) {
    var lt = this.localTransform;

    lt.a = this._cx * this.scale.x;
    lt.b = this._sx * this.scale.x;
    lt.c = this._cy * this.scale.y;
    lt.d = this._sy * this.scale.y;

    lt.tx = this.position.x - (this.pivot.x * lt.a + this.pivot.y * lt.c);
    lt.ty = this.position.y - (this.pivot.x * lt.b + this.pivot.y * lt.d);

    // concat the parent matrix with the objects transform.
    var pt = parentTransform.worldTransform;
    var wt = this.worldTransform;

    wt.a = lt.a * pt.a + lt.b * pt.c;
    wt.b = lt.a * pt.b + lt.b * pt.d;
    wt.c = lt.c * pt.a + lt.d * pt.c;
    wt.d = lt.c * pt.b + lt.d * pt.d;
    wt.tx = lt.tx * pt.a + lt.ty * pt.c + pt.tx;
    wt.ty = lt.tx * pt.b + lt.ty * pt.d + pt.ty;

    this._worldID++;
  };

  /**
   * Decomposes a matrix and sets the transforms properties based on it.
   *
   * @param {PIXI.Matrix} matrix - The matrix to decompose
   */


  Transform.prototype.setFromMatrix = function setFromMatrix(matrix) {
    matrix.decompose(this);
  };

  /**
   * The rotation of the object in radians.
   *
   * @member {number}
   */


  _createClass(Transform, [{
    key: 'rotation',
    get: function get() {
      return this._rotation;
    },
    set: function set(value) // eslint-disable-line require-jsdoc
    {
      this._rotation = value;
      this.updateSkew();
    }
  }]);

  return Transform;
}(_TransformBase3.default);

exports.default = Transform;
//# sourceMappingURL=Transform.js.map

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = determineCrossOrigin;

var _url2 = __webpack_require__(132);

var _url3 = _interopRequireDefault(_url2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tempAnchor = void 0;

/**
 * Sets the `crossOrigin` property for this resource based on if the url
 * for this resource is cross-origin. If crossOrigin was manually set, this
 * function does nothing.
 * Nipped from the resource loader!
 *
 * @ignore
 * @param {string} url - The url to test.
 * @param {object} [loc=window.location] - The location object to test against.
 * @return {string} The crossOrigin value to use (or empty string for none).
 */
function determineCrossOrigin(url) {
    var loc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location;

    // data: and javascript: urls are considered same-origin
    if (url.indexOf('data:') === 0) {
        return '';
    }

    // default is window.location
    loc = loc || window.location;

    if (!tempAnchor) {
        tempAnchor = document.createElement('a');
    }

    // let the browser determine the full href for the url of this resource and then
    // parse with the node url lib, we can't use the properties of the anchor element
    // because they don't work in IE9 :(
    tempAnchor.href = url;
    url = _url3.default.parse(tempAnchor.href);

    var samePort = !url.port && loc.port === '' || url.port === loc.port;

    // if cross origin
    if (url.hostname !== loc.hostname || !samePort || url.protocol !== loc.protocol) {
        return 'anonymous';
    }

    return '';
}
//# sourceMappingURL=determineCrossOrigin.js.map

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _BaseTexture2 = __webpack_require__(68);

var _BaseTexture3 = _interopRequireDefault(_BaseTexture2);

var _utils = __webpack_require__(9);

var _ticker = __webpack_require__(134);

var _const = __webpack_require__(5);

var _determineCrossOrigin = __webpack_require__(184);

var _determineCrossOrigin2 = _interopRequireDefault(_determineCrossOrigin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * A texture of a [playing] Video.
 *
 * Video base textures mimic PixiJS BaseTexture.from.... method in their creation process.
 *
 * This can be used in several ways, such as:
 *
 * ```js
 * let texture = PIXI.VideoBaseTexture.fromUrl('http://mydomain.com/video.mp4');
 *
 * let texture = PIXI.VideoBaseTexture.fromUrl({ src: 'http://mydomain.com/video.mp4', mime: 'video/mp4' });
 *
 * let texture = PIXI.VideoBaseTexture.fromUrls(['/video.webm', '/video.mp4']);
 *
 * let texture = PIXI.VideoBaseTexture.fromUrls([
 *     { src: '/video.webm', mime: 'video/webm' },
 *     { src: '/video.mp4', mime: 'video/mp4' }
 * ]);
 * ```
 *
 * See the ["deus" demo](http://www.goodboydigital.com/pixijs/examples/deus/).
 *
 * @class
 * @extends PIXI.BaseTexture
 * @memberof PIXI
 */
var VideoBaseTexture = function (_BaseTexture) {
    _inherits(VideoBaseTexture, _BaseTexture);

    /**
     * @param {HTMLVideoElement} source - Video source
     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
     * @param {boolean} [autoPlay=true] - Start playing video as soon as it is loaded
     */
    function VideoBaseTexture(source, scaleMode) {
        var autoPlay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

        _classCallCheck(this, VideoBaseTexture);

        if (!source) {
            throw new Error('No video source element specified.');
        }

        // hook in here to check if video is already available.
        // BaseTexture looks for a source.complete boolean, plus width & height.

        if ((source.readyState === source.HAVE_ENOUGH_DATA || source.readyState === source.HAVE_FUTURE_DATA) && source.width && source.height) {
            source.complete = true;
        }

        var _this = _possibleConstructorReturn(this, _BaseTexture.call(this, source, scaleMode));

        _this.width = source.videoWidth;
        _this.height = source.videoHeight;

        _this._autoUpdate = true;
        _this._isAutoUpdating = false;

        /**
         * When set to true will automatically play videos used by this texture once
         * they are loaded. If false, it will not modify the playing state.
         *
         * @member {boolean}
         * @default true
         */
        _this.autoPlay = autoPlay;

        _this.update = _this.update.bind(_this);
        _this._onCanPlay = _this._onCanPlay.bind(_this);

        source.addEventListener('play', _this._onPlayStart.bind(_this));
        source.addEventListener('pause', _this._onPlayStop.bind(_this));
        _this.hasLoaded = false;
        _this.__loaded = false;

        if (!_this._isSourceReady()) {
            source.addEventListener('canplay', _this._onCanPlay);
            source.addEventListener('canplaythrough', _this._onCanPlay);
        } else {
            _this._onCanPlay();
        }
        return _this;
    }

    /**
     * Returns true if the underlying source is playing.
     *
     * @private
     * @return {boolean} True if playing.
     */


    VideoBaseTexture.prototype._isSourcePlaying = function _isSourcePlaying() {
        var source = this.source;

        return source.currentTime > 0 && source.paused === false && source.ended === false && source.readyState > 2;
    };

    /**
     * Returns true if the underlying source is ready for playing.
     *
     * @private
     * @return {boolean} True if ready.
     */


    VideoBaseTexture.prototype._isSourceReady = function _isSourceReady() {
        return this.source.readyState === 3 || this.source.readyState === 4;
    };

    /**
     * Runs the update loop when the video is ready to play
     *
     * @private
     */


    VideoBaseTexture.prototype._onPlayStart = function _onPlayStart() {
        // Just in case the video has not received its can play even yet..
        if (!this.hasLoaded) {
            this._onCanPlay();
        }

        if (!this._isAutoUpdating && this.autoUpdate) {
            _ticker.shared.add(this.update, this, _const.UPDATE_PRIORITY.HIGH);
            this._isAutoUpdating = true;
        }
    };

    /**
     * Fired when a pause event is triggered, stops the update loop
     *
     * @private
     */


    VideoBaseTexture.prototype._onPlayStop = function _onPlayStop() {
        if (this._isAutoUpdating) {
            _ticker.shared.remove(this.update, this);
            this._isAutoUpdating = false;
        }
    };

    /**
     * Fired when the video is loaded and ready to play
     *
     * @private
     */


    VideoBaseTexture.prototype._onCanPlay = function _onCanPlay() {
        this.hasLoaded = true;

        if (this.source) {
            this.source.removeEventListener('canplay', this._onCanPlay);
            this.source.removeEventListener('canplaythrough', this._onCanPlay);

            this.width = this.source.videoWidth;
            this.height = this.source.videoHeight;

            // prevent multiple loaded dispatches..
            if (!this.__loaded) {
                this.__loaded = true;
                this.emit('loaded', this);
            }

            if (this._isSourcePlaying()) {
                this._onPlayStart();
            } else if (this.autoPlay) {
                this.source.play();
            }
        }
    };

    /**
     * Destroys this texture
     *
     */


    VideoBaseTexture.prototype.destroy = function destroy() {
        if (this._isAutoUpdating) {
            _ticker.shared.remove(this.update, this);
        }

        if (this.source && this.source._pixiId) {
            _BaseTexture3.default.removeFromCache(this.source._pixiId);
            delete this.source._pixiId;

            this.source.pause();
            this.source.src = '';
            this.source.load();
        }

        _BaseTexture.prototype.destroy.call(this);
    };

    /**
     * Mimic PixiJS BaseTexture.from.... method.
     *
     * @static
     * @param {HTMLVideoElement} video - Video to create texture from
     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
     * @param {boolean} [autoPlay=true] - Start playing video as soon as it is loaded
     * @return {PIXI.VideoBaseTexture} Newly created VideoBaseTexture
     */


    VideoBaseTexture.fromVideo = function fromVideo(video, scaleMode, autoPlay) {
        if (!video._pixiId) {
            video._pixiId = 'video_' + (0, _utils.uid)();
        }

        var baseTexture = _utils.BaseTextureCache[video._pixiId];

        if (!baseTexture) {
            baseTexture = new VideoBaseTexture(video, scaleMode, autoPlay);
            _BaseTexture3.default.addToCache(baseTexture, video._pixiId);
        }

        return baseTexture;
    };

    /**
     * Helper function that creates a new BaseTexture based on the given video element.
     * This BaseTexture can then be used to create a texture
     *
     * @static
     * @param {string|object|string[]|object[]} videoSrc - The URL(s) for the video.
     * @param {string} [videoSrc.src] - One of the source urls for the video
     * @param {string} [videoSrc.mime] - The mimetype of the video (e.g. 'video/mp4'). If not specified
     *  the url's extension will be used as the second part of the mime type.
     * @param {number} scaleMode - See {@link PIXI.SCALE_MODES} for possible values
     * @param {boolean} [crossorigin=(auto)] - Should use anonymous CORS? Defaults to true if the URL is not a data-URI.
     * @param {boolean} [autoPlay=true] - Start playing video as soon as it is loaded
     * @return {PIXI.VideoBaseTexture} Newly created VideoBaseTexture
     */


    VideoBaseTexture.fromUrl = function fromUrl(videoSrc, scaleMode, crossorigin, autoPlay) {
        var video = document.createElement('video');

        video.setAttribute('webkit-playsinline', '');
        video.setAttribute('playsinline', '');

        var url = Array.isArray(videoSrc) ? videoSrc[0].src || videoSrc[0] : videoSrc.src || videoSrc;

        if (crossorigin === undefined && url.indexOf('data:') !== 0) {
            video.crossOrigin = (0, _determineCrossOrigin2.default)(url);
        } else if (crossorigin) {
            video.crossOrigin = typeof crossorigin === 'string' ? crossorigin : 'anonymous';
        }

        // array of objects or strings
        if (Array.isArray(videoSrc)) {
            for (var i = 0; i < videoSrc.length; ++i) {
                video.appendChild(createSource(videoSrc[i].src || videoSrc[i], videoSrc[i].mime));
            }
        }
        // single object or string
        else {
                video.appendChild(createSource(url, videoSrc.mime));
            }

        video.load();

        return VideoBaseTexture.fromVideo(video, scaleMode, autoPlay);
    };

    /**
     * Should the base texture automatically update itself, set to true by default
     *
     * @member {boolean}
     */


    _createClass(VideoBaseTexture, [{
        key: 'autoUpdate',
        get: function get() {
            return this._autoUpdate;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            if (value !== this._autoUpdate) {
                this._autoUpdate = value;

                if (!this._autoUpdate && this._isAutoUpdating) {
                    _ticker.shared.remove(this.update, this);
                    this._isAutoUpdating = false;
                } else if (this._autoUpdate && !this._isAutoUpdating) {
                    _ticker.shared.add(this.update, this, _const.UPDATE_PRIORITY.HIGH);
                    this._isAutoUpdating = true;
                }
            }
        }
    }]);

    return VideoBaseTexture;
}(_BaseTexture3.default);

exports.default = VideoBaseTexture;


VideoBaseTexture.fromUrls = VideoBaseTexture.fromUrl;

function createSource(path, type) {
    if (!type) {
        var purePath = path.split('?').shift().toLowerCase();

        type = 'video/' + purePath.substr(purePath.lastIndexOf('.') + 1);
    }

    var source = document.createElement('source');

    source.src = path;
    source.type = type;

    return source;
}
//# sourceMappingURL=VideoBaseTexture.js.map

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _GroupD = __webpack_require__(171);

var _GroupD2 = _interopRequireDefault(_GroupD);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * A standard object to store the Uvs of a texture
 *
 * @class
 * @private
 * @memberof PIXI
 */
var TextureUvs = function () {
    /**
     *
     */
    function TextureUvs() {
        _classCallCheck(this, TextureUvs);

        this.x0 = 0;
        this.y0 = 0;

        this.x1 = 1;
        this.y1 = 0;

        this.x2 = 1;
        this.y2 = 1;

        this.x3 = 0;
        this.y3 = 1;

        this.uvsUint32 = new Uint32Array(4);
    }

    /**
     * Sets the texture Uvs based on the given frame information.
     *
     * @private
     * @param {PIXI.Rectangle} frame - The frame of the texture
     * @param {PIXI.Rectangle} baseFrame - The base frame of the texture
     * @param {number} rotate - Rotation of frame, see {@link PIXI.GroupD8}
     */


    TextureUvs.prototype.set = function set(frame, baseFrame, rotate) {
        var tw = baseFrame.width;
        var th = baseFrame.height;

        if (rotate) {
            // width and height div 2 div baseFrame size
            var w2 = frame.width / 2 / tw;
            var h2 = frame.height / 2 / th;

            // coordinates of center
            var cX = frame.x / tw + w2;
            var cY = frame.y / th + h2;

            rotate = _GroupD2.default.add(rotate, _GroupD2.default.NW); // NW is top-left corner
            this.x0 = cX + w2 * _GroupD2.default.uX(rotate);
            this.y0 = cY + h2 * _GroupD2.default.uY(rotate);

            rotate = _GroupD2.default.add(rotate, 2); // rotate 90 degrees clockwise
            this.x1 = cX + w2 * _GroupD2.default.uX(rotate);
            this.y1 = cY + h2 * _GroupD2.default.uY(rotate);

            rotate = _GroupD2.default.add(rotate, 2);
            this.x2 = cX + w2 * _GroupD2.default.uX(rotate);
            this.y2 = cY + h2 * _GroupD2.default.uY(rotate);

            rotate = _GroupD2.default.add(rotate, 2);
            this.x3 = cX + w2 * _GroupD2.default.uX(rotate);
            this.y3 = cY + h2 * _GroupD2.default.uY(rotate);
        } else {
            this.x0 = frame.x / tw;
            this.y0 = frame.y / th;

            this.x1 = (frame.x + frame.width) / tw;
            this.y1 = frame.y / th;

            this.x2 = (frame.x + frame.width) / tw;
            this.y2 = (frame.y + frame.height) / th;

            this.x3 = frame.x / tw;
            this.y3 = (frame.y + frame.height) / th;
        }

        this.uvsUint32[0] = (Math.round(this.y0 * 65535) & 0xFFFF) << 16 | Math.round(this.x0 * 65535) & 0xFFFF;
        this.uvsUint32[1] = (Math.round(this.y1 * 65535) & 0xFFFF) << 16 | Math.round(this.x1 * 65535) & 0xFFFF;
        this.uvsUint32[2] = (Math.round(this.y2 * 65535) & 0xFFFF) << 16 | Math.round(this.x2 * 65535) & 0xFFFF;
        this.uvsUint32[3] = (Math.round(this.y3 * 65535) & 0xFFFF) << 16 | Math.round(this.x3 * 65535) & 0xFFFF;
    };

    return TextureUvs;
}();

exports.default = TextureUvs;
//# sourceMappingURL=TextureUvs.js.map

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(9);

var _math = __webpack_require__(20);

var _const = __webpack_require__(5);

var _settings = __webpack_require__(17);

var _settings2 = _interopRequireDefault(_settings);

var _Container = __webpack_require__(83);

var _Container2 = _interopRequireDefault(_Container);

var _RenderTexture = __webpack_require__(135);

var _RenderTexture2 = _interopRequireDefault(_RenderTexture);

var _eventemitter = __webpack_require__(60);

var _eventemitter2 = _interopRequireDefault(_eventemitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var tempMatrix = new _math.Matrix();

/**
 * The SystemRenderer is the base for a PixiJS Renderer. It is extended by the {@link PIXI.CanvasRenderer}
 * and {@link PIXI.WebGLRenderer} which can be used for rendering a PixiJS scene.
 *
 * @abstract
 * @class
 * @extends EventEmitter
 * @memberof PIXI
 */

var SystemRenderer = function (_EventEmitter) {
  _inherits(SystemRenderer, _EventEmitter);

  // eslint-disable-next-line valid-jsdoc
  /**
   * @param {string} system - The name of the system this renderer is for.
   * @param {object} [options] - The optional renderer parameters
   * @param {number} [options.width=800] - the width of the screen
   * @param {number} [options.height=600] - the height of the screen
   * @param {HTMLCanvasElement} [options.view] - the canvas to use as a view, optional
   * @param {boolean} [options.transparent=false] - If the render view is transparent, default false
   * @param {boolean} [options.autoResize=false] - If the render view is automatically resized, default false
   * @param {boolean} [options.antialias=false] - sets antialias (only applicable in chrome at the moment)
   * @param {number} [options.resolution=1] - The resolution / device pixel ratio of the renderer. The
   *  resolution of the renderer retina would be 2.
   * @param {boolean} [options.preserveDrawingBuffer=false] - enables drawing buffer preservation,
   *  enable this if you need to call toDataUrl on the webgl context.
   * @param {boolean} [options.clearBeforeRender=true] - This sets if the renderer will clear the canvas or
   *      not before the new render pass.
   * @param {number} [options.backgroundColor=0x000000] - The background color of the rendered area
   *  (shown if not transparent).
   * @param {boolean} [options.roundPixels=false] - If true PixiJS will Math.floor() x/y values when rendering,
   *  stopping pixel interpolation.
   */
  function SystemRenderer(system, options, arg2, arg3) {
    _classCallCheck(this, SystemRenderer);

    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

    (0, _utils.sayHello)(system);

    // Support for constructor(system, screenWidth, screenHeight, options)
    if (typeof options === 'number') {
      options = Object.assign({
        width: options,
        height: arg2 || _settings2.default.RENDER_OPTIONS.height
      }, arg3);
    }

    // Add the default render options
    options = Object.assign({}, _settings2.default.RENDER_OPTIONS, options);

    /**
     * The supplied constructor options.
     *
     * @member {Object}
     * @readOnly
     */
    _this.options = options;

    /**
     * The type of the renderer.
     *
     * @member {number}
     * @default PIXI.RENDERER_TYPE.UNKNOWN
     * @see PIXI.RENDERER_TYPE
     */
    _this.type = _const.RENDERER_TYPE.UNKNOWN;

    /**
     * Measurements of the screen. (0, 0, screenWidth, screenHeight)
     *
     * Its safe to use as filterArea or hitArea for whole stage
     *
     * @member {PIXI.Rectangle}
     */
    _this.screen = new _math.Rectangle(0, 0, options.width, options.height);

    /**
     * The canvas element that everything is drawn to
     *
     * @member {HTMLCanvasElement}
     */
    _this.view = options.view || document.createElement('canvas');

    /**
     * The resolution / device pixel ratio of the renderer
     *
     * @member {number}
     * @default 1
     */
    _this.resolution = options.resolution || _settings2.default.RESOLUTION;

    /**
     * Whether the render view is transparent
     *
     * @member {boolean}
     */
    _this.transparent = options.transparent;

    /**
     * Whether css dimensions of canvas view should be resized to screen dimensions automatically
     *
     * @member {boolean}
     */
    _this.autoResize = options.autoResize || false;

    /**
     * Tracks the blend modes useful for this renderer.
     *
     * @member {object<string, mixed>}
     */
    _this.blendModes = null;

    /**
     * The value of the preserveDrawingBuffer flag affects whether or not the contents of
     * the stencil buffer is retained after rendering.
     *
     * @member {boolean}
     */
    _this.preserveDrawingBuffer = options.preserveDrawingBuffer;

    /**
     * This sets if the CanvasRenderer will clear the canvas or not before the new render pass.
     * If the scene is NOT transparent PixiJS will use a canvas sized fillRect operation every
     * frame to set the canvas background color. If the scene is transparent PixiJS will use clearRect
     * to clear the canvas every frame. Disable this by setting this to false. For example if
     * your game has a canvas filling background image you often don't need this set.
     *
     * @member {boolean}
     * @default
     */
    _this.clearBeforeRender = options.clearBeforeRender;

    /**
     * If true PixiJS will Math.floor() x/y values when rendering, stopping pixel interpolation.
     * Handy for crisp pixel art and speed on legacy devices.
     *
     * @member {boolean}
     */
    _this.roundPixels = options.roundPixels;

    /**
     * The background color as a number.
     *
     * @member {number}
     * @private
     */
    _this._backgroundColor = 0x000000;

    /**
     * The background color as an [R, G, B] array.
     *
     * @member {number[]}
     * @private
     */
    _this._backgroundColorRgba = [0, 0, 0, 0];

    /**
     * The background color as a string.
     *
     * @member {string}
     * @private
     */
    _this._backgroundColorString = '#000000';

    _this.backgroundColor = options.backgroundColor || _this._backgroundColor; // run bg color setter

    /**
     * This temporary display object used as the parent of the currently being rendered item
     *
     * @member {PIXI.DisplayObject}
     * @private
     */
    _this._tempDisplayObjectParent = new _Container2.default();

    /**
     * The last root object that the renderer tried to render.
     *
     * @member {PIXI.DisplayObject}
     * @private
     */
    _this._lastObjectRendered = _this._tempDisplayObjectParent;
    return _this;
  }

  /**
   * Same as view.width, actual number of pixels in the canvas by horizontal
   *
   * @member {number}
   * @readonly
   * @default 800
   */


  /**
   * Resizes the screen and canvas to the specified width and height
   * Canvas dimensions are multiplied by resolution
   *
   * @param {number} screenWidth - the new width of the screen
   * @param {number} screenHeight - the new height of the screen
   */
  SystemRenderer.prototype.resize = function resize(screenWidth, screenHeight) {
    this.screen.width = screenWidth;
    this.screen.height = screenHeight;

    this.view.width = screenWidth * this.resolution;
    this.view.height = screenHeight * this.resolution;

    if (this.autoResize) {
      this.view.style.width = screenWidth + 'px';
      this.view.style.height = screenHeight + 'px';
    }
  };

  /**
   * Useful function that returns a texture of the display object that can then be used to create sprites
   * This can be quite useful if your displayObject is complicated and needs to be reused multiple times.
   *
   * @param {PIXI.DisplayObject} displayObject - The displayObject the object will be generated from
   * @param {number} scaleMode - Should be one of the scaleMode consts
   * @param {number} resolution - The resolution / device pixel ratio of the texture being generated
   * @param {PIXI.Rectangle} [region] - The region of the displayObject, that shall be rendered,
   *        if no region is specified, defaults to the local bounds of the displayObject.
   * @return {PIXI.Texture} a texture of the graphics object
   */


  SystemRenderer.prototype.generateTexture = function generateTexture(displayObject, scaleMode, resolution, region) {
    region = region || displayObject.getLocalBounds();

    var renderTexture = _RenderTexture2.default.create(region.width | 0, region.height | 0, scaleMode, resolution);

    tempMatrix.tx = -region.x;
    tempMatrix.ty = -region.y;

    this.render(displayObject, renderTexture, false, tempMatrix, !!displayObject.parent);

    return renderTexture;
  };

  /**
   * Removes everything from the renderer and optionally removes the Canvas DOM element.
   *
   * @param {boolean} [removeView=false] - Removes the Canvas element from the DOM.
   */


  SystemRenderer.prototype.destroy = function destroy(removeView) {
    if (removeView && this.view.parentNode) {
      this.view.parentNode.removeChild(this.view);
    }

    this.type = _const.RENDERER_TYPE.UNKNOWN;

    this.view = null;

    this.screen = null;

    this.resolution = 0;

    this.transparent = false;

    this.autoResize = false;

    this.blendModes = null;

    this.options = null;

    this.preserveDrawingBuffer = false;
    this.clearBeforeRender = false;

    this.roundPixels = false;

    this._backgroundColor = 0;
    this._backgroundColorRgba = null;
    this._backgroundColorString = null;

    this._tempDisplayObjectParent = null;
    this._lastObjectRendered = null;
  };

  /**
   * The background color to fill if not transparent
   *
   * @member {number}
   */


  _createClass(SystemRenderer, [{
    key: 'width',
    get: function get() {
      return this.view.width;
    }

    /**
     * Same as view.height, actual number of pixels in the canvas by vertical
     *
     * @member {number}
     * @readonly
     * @default 600
     */

  }, {
    key: 'height',
    get: function get() {
      return this.view.height;
    }
  }, {
    key: 'backgroundColor',
    get: function get() {
      return this._backgroundColor;
    },
    set: function set(value) // eslint-disable-line require-jsdoc
    {
      this._backgroundColor = value;
      this._backgroundColorString = (0, _utils.hex2string)(value);
      (0, _utils.hex2rgb)(value, this._backgroundColorRgba);
    }
  }]);

  return SystemRenderer;
}(_eventemitter2.default);

exports.default = SystemRenderer;
//# sourceMappingURL=SystemRenderer.js.map

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _BaseTexture2 = __webpack_require__(68);

var _BaseTexture3 = _interopRequireDefault(_BaseTexture2);

var _settings = __webpack_require__(17);

var _settings2 = _interopRequireDefault(_settings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * A BaseRenderTexture is a special texture that allows any PixiJS display object to be rendered to it.
 *
 * __Hint__: All DisplayObjects (i.e. Sprites) that render to a BaseRenderTexture should be preloaded
 * otherwise black rectangles will be drawn instead.
 *
 * A BaseRenderTexture takes a snapshot of any Display Object given to its render method. The position
 * and rotation of the given Display Objects is ignored. For example:
 *
 * ```js
 * let renderer = PIXI.autoDetectRenderer(1024, 1024);
 * let baseRenderTexture = new PIXI.BaseRenderTexture(800, 600);
 * let renderTexture = new PIXI.RenderTexture(baseRenderTexture);
 * let sprite = PIXI.Sprite.fromImage("spinObj_01.png");
 *
 * sprite.position.x = 800/2;
 * sprite.position.y = 600/2;
 * sprite.anchor.x = 0.5;
 * sprite.anchor.y = 0.5;
 *
 * renderer.render(sprite, renderTexture);
 * ```
 *
 * The Sprite in this case will be rendered using its local transform. To render this sprite at 0,0
 * you can clear the transform
 *
 * ```js
 *
 * sprite.setTransform()
 *
 * let baseRenderTexture = new PIXI.BaseRenderTexture(100, 100);
 * let renderTexture = new PIXI.RenderTexture(baseRenderTexture);
 *
 * renderer.render(sprite, renderTexture);  // Renders to center of RenderTexture
 * ```
 *
 * @class
 * @extends PIXI.BaseTexture
 * @memberof PIXI
 */
var BaseRenderTexture = function (_BaseTexture) {
  _inherits(BaseRenderTexture, _BaseTexture);

  /**
   * @param {number} [width=100] - The width of the base render texture
   * @param {number} [height=100] - The height of the base render texture
   * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - See {@link PIXI.SCALE_MODES} for possible values
   * @param {number} [resolution=1] - The resolution / device pixel ratio of the texture being generated
   */
  function BaseRenderTexture() {
    var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100;
    var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
    var scaleMode = arguments[2];
    var resolution = arguments[3];

    _classCallCheck(this, BaseRenderTexture);

    var _this = _possibleConstructorReturn(this, _BaseTexture.call(this, null, scaleMode));

    _this.resolution = resolution || _settings2.default.RESOLUTION;

    _this.width = Math.ceil(width);
    _this.height = Math.ceil(height);

    _this.realWidth = _this.width * _this.resolution;
    _this.realHeight = _this.height * _this.resolution;

    _this.scaleMode = scaleMode !== undefined ? scaleMode : _settings2.default.SCALE_MODE;
    _this.hasLoaded = true;

    /**
     * A map of renderer IDs to webgl renderTargets
     *
     * @private
     * @member {object<number, WebGLTexture>}
     */
    _this._glRenderTargets = {};

    /**
     * A reference to the canvas render target (we only need one as this can be shared across renderers)
     *
     * @private
     * @member {object<number, WebGLTexture>}
     */
    _this._canvasRenderTarget = null;

    /**
     * This will let the renderer know if the texture is valid. If it's not then it cannot be rendered.
     *
     * @member {boolean}
     */
    _this.valid = false;
    return _this;
  }

  /**
   * Resizes the BaseRenderTexture.
   *
   * @param {number} width - The width to resize to.
   * @param {number} height - The height to resize to.
   */


  BaseRenderTexture.prototype.resize = function resize(width, height) {
    width = Math.ceil(width);
    height = Math.ceil(height);

    if (width === this.width && height === this.height) {
      return;
    }

    this.valid = width > 0 && height > 0;

    this.width = width;
    this.height = height;

    this.realWidth = this.width * this.resolution;
    this.realHeight = this.height * this.resolution;

    if (!this.valid) {
      return;
    }

    this.emit('update', this);
  };

  /**
   * Destroys this texture
   *
   */


  BaseRenderTexture.prototype.destroy = function destroy() {
    _BaseTexture.prototype.destroy.call(this, true);
    this.renderer = null;
  };

  return BaseRenderTexture;
}(_BaseTexture3.default);

exports.default = BaseRenderTexture;
//# sourceMappingURL=BaseRenderTexture.js.map

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _settings = __webpack_require__(17);

var _settings2 = _interopRequireDefault(_settings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Creates a Canvas element of the given size.
 *
 * @class
 * @memberof PIXI
 */
var CanvasRenderTarget = function () {
  /**
   * @param {number} width - the width for the newly created canvas
   * @param {number} height - the height for the newly created canvas
   * @param {number} [resolution=1] - The resolution / device pixel ratio of the canvas
   */
  function CanvasRenderTarget(width, height, resolution) {
    _classCallCheck(this, CanvasRenderTarget);

    /**
     * The Canvas object that belongs to this CanvasRenderTarget.
     *
     * @member {HTMLCanvasElement}
     */
    this.canvas = document.createElement('canvas');

    /**
     * A CanvasRenderingContext2D object representing a two-dimensional rendering context.
     *
     * @member {CanvasRenderingContext2D}
     */
    this.context = this.canvas.getContext('2d');

    this.resolution = resolution || _settings2.default.RESOLUTION;

    this.resize(width, height);
  }

  /**
   * Clears the canvas that was created by the CanvasRenderTarget class.
   *
   * @private
   */


  CanvasRenderTarget.prototype.clear = function clear() {
    this.context.setTransform(1, 0, 0, 1, 0, 0);
    this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
  };

  /**
   * Resizes the canvas to the specified width and height.
   *
   * @param {number} width - the new width of the canvas
   * @param {number} height - the new height of the canvas
   */


  CanvasRenderTarget.prototype.resize = function resize(width, height) {
    this.canvas.width = width * this.resolution;
    this.canvas.height = height * this.resolution;
  };

  /**
   * Destroys this canvas.
   *
   */


  CanvasRenderTarget.prototype.destroy = function destroy() {
    this.context = null;
    this.canvas = null;
  };

  /**
   * The width of the canvas buffer in pixels.
   *
   * @member {number}
   */


  _createClass(CanvasRenderTarget, [{
    key: 'width',
    get: function get() {
      return this.canvas.width;
    },
    set: function set(val) // eslint-disable-line require-jsdoc
    {
      this.canvas.width = val;
    }

    /**
     * The height of the canvas buffer in pixels.
     *
     * @member {number}
     */

  }, {
    key: 'height',
    get: function get() {
      return this.canvas.height;
    },
    set: function set(val) // eslint-disable-line require-jsdoc
    {
      this.canvas.height = val;
    }
  }]);

  return CanvasRenderTarget;
}();

exports.default = CanvasRenderTarget;
//# sourceMappingURL=CanvasRenderTarget.js.map

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = canUseNewCanvasBlendModes;
/**
 * Creates a little colored canvas
 *
 * @ignore
 * @param {string} color - The color to make the canvas
 * @return {canvas} a small canvas element
 */
function createColoredCanvas(color) {
    var canvas = document.createElement('canvas');

    canvas.width = 6;
    canvas.height = 1;

    var context = canvas.getContext('2d');

    context.fillStyle = color;
    context.fillRect(0, 0, 6, 1);

    return canvas;
}

/**
 * Checks whether the Canvas BlendModes are supported by the current browser
 *
 * @return {boolean} whether they are supported
 */
function canUseNewCanvasBlendModes() {
    if (typeof document === 'undefined') {
        return false;
    }

    var magenta = createColoredCanvas('#ff00ff');
    var yellow = createColoredCanvas('#ffff00');

    var canvas = document.createElement('canvas');

    canvas.width = 6;
    canvas.height = 1;

    var context = canvas.getContext('2d');

    context.globalCompositeOperation = 'multiply';
    context.drawImage(magenta, 0, 0);
    context.drawImage(yellow, 2, 0);

    var imageData = context.getImageData(2, 0, 1, 1);

    if (!imageData) {
        return false;
    }

    var data = imageData.data;

    return data[0] === 255 && data[1] === 0 && data[2] === 0;
}
//# sourceMappingURL=canUseNewCanvasBlendModes.js.map

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _Filter2 = __webpack_require__(192);

var _Filter3 = _interopRequireDefault(_Filter2);

var _math = __webpack_require__(20);

var _path = __webpack_require__(41);

var _TextureMatrix = __webpack_require__(193);

var _TextureMatrix2 = _interopRequireDefault(_TextureMatrix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The SpriteMaskFilter class
 *
 * @class
 * @extends PIXI.Filter
 * @memberof PIXI
 */
var SpriteMaskFilter = function (_Filter) {
    _inherits(SpriteMaskFilter, _Filter);

    /**
     * @param {PIXI.Sprite} sprite - the target sprite
     */
    function SpriteMaskFilter(sprite) {
        _classCallCheck(this, SpriteMaskFilter);

        var maskMatrix = new _math.Matrix();

        var _this = _possibleConstructorReturn(this, _Filter.call(this, 'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 otherMatrix;\n\nvarying vec2 vMaskCoord;\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = aTextureCoord;\n    vMaskCoord = ( otherMatrix * vec3( aTextureCoord, 1.0)  ).xy;\n}\n', 'varying vec2 vMaskCoord;\nvarying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform sampler2D mask;\nuniform float alpha;\nuniform vec4 maskClamp;\n\nvoid main(void)\n{\n    float clip = step(3.5,\n        step(maskClamp.x, vMaskCoord.x) +\n        step(maskClamp.y, vMaskCoord.y) +\n        step(vMaskCoord.x, maskClamp.z) +\n        step(vMaskCoord.y, maskClamp.w));\n\n    vec4 original = texture2D(uSampler, vTextureCoord);\n    vec4 masky = texture2D(mask, vMaskCoord);\n\n    original *= (masky.r * masky.a * alpha * clip);\n\n    gl_FragColor = original;\n}\n'));

        sprite.renderable = false;

        _this.maskSprite = sprite;
        _this.maskMatrix = maskMatrix;
        return _this;
    }

    /**
     * Applies the filter
     *
     * @param {PIXI.FilterManager} filterManager - The renderer to retrieve the filter from
     * @param {PIXI.RenderTarget} input - The input render target.
     * @param {PIXI.RenderTarget} output - The target to output to.
     * @param {boolean} clear - Should the output be cleared before rendering to it
     */


    SpriteMaskFilter.prototype.apply = function apply(filterManager, input, output, clear) {
        var maskSprite = this.maskSprite;
        var tex = this.maskSprite.texture;

        if (!tex.valid) {
            return;
        }
        if (!tex.transform) {
            // margin = 0.0, let it bleed a bit, shader code becomes easier
            // assuming that atlas textures were made with 1-pixel padding
            tex.transform = new _TextureMatrix2.default(tex, 0.0);
        }
        tex.transform.update();

        this.uniforms.mask = tex;
        this.uniforms.otherMatrix = filterManager.calculateSpriteMatrix(this.maskMatrix, maskSprite).prepend(tex.transform.mapCoord);
        this.uniforms.alpha = maskSprite.worldAlpha;
        this.uniforms.maskClamp = tex.transform.uClampFrame;

        filterManager.applyFilter(this, input, output, clear);
    };

    return SpriteMaskFilter;
}(_Filter3.default);

exports.default = SpriteMaskFilter;
//# sourceMappingURL=SpriteMaskFilter.js.map

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extractUniformsFromSrc = __webpack_require__(373);

var _extractUniformsFromSrc2 = _interopRequireDefault(_extractUniformsFromSrc);

var _utils = __webpack_require__(9);

var _const = __webpack_require__(5);

var _settings = __webpack_require__(17);

var _settings2 = _interopRequireDefault(_settings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SOURCE_KEY_MAP = {};

// let math = require('../../../math');
/**
 * @class
 * @memberof PIXI
 * @extends PIXI.Shader
 */

var Filter = function () {
  /**
   * @param {string} [vertexSrc] - The source of the vertex shader.
   * @param {string} [fragmentSrc] - The source of the fragment shader.
   * @param {object} [uniformData] - Custom uniforms to use to augment the built-in ones.
   */
  function Filter(vertexSrc, fragmentSrc, uniformData) {
    _classCallCheck(this, Filter);

    /**
     * The vertex shader.
     *
     * @member {string}
     */
    this.vertexSrc = vertexSrc || Filter.defaultVertexSrc;

    /**
     * The fragment shader.
     *
     * @member {string}
     */
    this.fragmentSrc = fragmentSrc || Filter.defaultFragmentSrc;

    this._blendMode = _const.BLEND_MODES.NORMAL;

    this.uniformData = uniformData || (0, _extractUniformsFromSrc2.default)(this.vertexSrc, this.fragmentSrc, 'projectionMatrix|uSampler');

    /**
     * An object containing the current values of custom uniforms.
     * @example <caption>Updating the value of a custom uniform</caption>
     * filter.uniforms.time = performance.now();
     *
     * @member {object}
     */
    this.uniforms = {};

    for (var i in this.uniformData) {
      this.uniforms[i] = this.uniformData[i].value;
      if (this.uniformData[i].type) {
        this.uniformData[i].type = this.uniformData[i].type.toLowerCase();
      }
    }

    // this is where we store shader references..
    // TODO we could cache this!
    this.glShaders = {};

    // used for caching.. sure there is a better way!
    if (!SOURCE_KEY_MAP[this.vertexSrc + this.fragmentSrc]) {
      SOURCE_KEY_MAP[this.vertexSrc + this.fragmentSrc] = (0, _utils.uid)();
    }

    this.glShaderKey = SOURCE_KEY_MAP[this.vertexSrc + this.fragmentSrc];

    /**
     * The padding of the filter. Some filters require extra space to breath such as a blur.
     * Increasing this will add extra width and height to the bounds of the object that the
     * filter is applied to.
     *
     * @member {number}
     */
    this.padding = 4;

    /**
     * The resolution of the filter. Setting this to be lower will lower the quality but
     * increase the performance of the filter.
     *
     * @member {number}
     */
    this.resolution = _settings2.default.FILTER_RESOLUTION;

    /**
     * If enabled is true the filter is applied, if false it will not.
     *
     * @member {boolean}
     */
    this.enabled = true;

    /**
     * If enabled, PixiJS will fit the filter area into boundaries for better performance.
     * Switch it off if it does not work for specific shader.
     *
     * @member {boolean}
     */
    this.autoFit = true;
  }

  /**
   * Applies the filter
   *
   * @param {PIXI.FilterManager} filterManager - The renderer to retrieve the filter from
   * @param {PIXI.RenderTarget} input - The input render target.
   * @param {PIXI.RenderTarget} output - The target to output to.
   * @param {boolean} clear - Should the output be cleared before rendering to it
   * @param {object} [currentState] - It's current state of filter.
   *        There are some useful properties in the currentState :
   *        target, filters, sourceFrame, destinationFrame, renderTarget, resolution
   */


  Filter.prototype.apply = function apply(filterManager, input, output, clear, currentState) // eslint-disable-line no-unused-vars
  {
    // --- //
    //  this.uniforms.filterMatrix = filterManager.calculateSpriteMatrix(tempMatrix, window.panda );

    // do as you please!

    filterManager.applyFilter(this, input, output, clear);

    // or just do a regular render..
  };

  /**
   * Sets the blendmode of the filter
   *
   * @member {number}
   * @default PIXI.BLEND_MODES.NORMAL
   */


  _createClass(Filter, [{
    key: 'blendMode',
    get: function get() {
      return this._blendMode;
    },
    set: function set(value) // eslint-disable-line require-jsdoc
    {
      this._blendMode = value;
    }

    /**
     * The default vertex shader source
     *
     * @static
     * @constant
     */

  }], [{
    key: 'defaultVertexSrc',
    get: function get() {
      return ['attribute vec2 aVertexPosition;', 'attribute vec2 aTextureCoord;', 'uniform mat3 projectionMatrix;', 'uniform mat3 filterMatrix;', 'varying vec2 vTextureCoord;', 'varying vec2 vFilterCoord;', 'void main(void){', '   gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);', '   vFilterCoord = ( filterMatrix * vec3( aTextureCoord, 1.0)  ).xy;', '   vTextureCoord = aTextureCoord ;', '}'].join('\n');
    }

    /**
     * The default fragment shader source
     *
     * @static
     * @constant
     */

  }, {
    key: 'defaultFragmentSrc',
    get: function get() {
      return ['varying vec2 vTextureCoord;', 'varying vec2 vFilterCoord;', 'uniform sampler2D uSampler;', 'uniform sampler2D filterSampler;', 'void main(void){', '   vec4 masky = texture2D(filterSampler, vFilterCoord);', '   vec4 sample = texture2D(uSampler, vTextureCoord);', '   vec4 color;', '   if(mod(vFilterCoord.x, 1.0) > 0.5)', '   {', '     color = vec4(1.0, 0.0, 0.0, 1.0);', '   }', '   else', '   {', '     color = vec4(0.0, 1.0, 0.0, 1.0);', '   }',
      // '   gl_FragColor = vec4(mod(vFilterCoord.x, 1.5), vFilterCoord.y,0.0,1.0);',
      '   gl_FragColor = mix(sample, masky, 0.5);', '   gl_FragColor *= sample.a;', '}'].join('\n');
    }
  }]);

  return Filter;
}();

exports.default = Filter;
//# sourceMappingURL=Filter.js.map

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Matrix = __webpack_require__(124);

var _Matrix2 = _interopRequireDefault(_Matrix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var tempMat = new _Matrix2.default();

/**
 * Class controls uv transform and frame clamp for texture
 * Can be used in Texture "transform" field, or separately, you can use different clamp settings on the same texture.
 * If you want to add support for texture region of certain feature or filter, that's what you're looking for.
 *
 * @see PIXI.Texture
 * @see PIXI.mesh.Mesh
 * @see PIXI.extras.TilingSprite
 * @class
 * @memberof PIXI
 */

var TextureMatrix = function () {
    /**
     *
     * @param {PIXI.Texture} texture observed texture
     * @param {number} [clampMargin] Changes frame clamping, 0.5 by default. Use -0.5 for extra border.
     * @constructor
     */
    function TextureMatrix(texture, clampMargin) {
        _classCallCheck(this, TextureMatrix);

        this._texture = texture;

        this.mapCoord = new _Matrix2.default();

        this.uClampFrame = new Float32Array(4);

        this.uClampOffset = new Float32Array(2);

        this._lastTextureID = -1;

        /**
         * Changes frame clamping
         * Works with TilingSprite and Mesh
         * Change to 1.5 if you texture has repeated right and bottom lines, that leads to smoother borders
         *
         * @default 0
         * @member {number}
         */
        this.clampOffset = 0;

        /**
         * Changes frame clamping
         * Works with TilingSprite and Mesh
         * Change to -0.5 to add a pixel to the edge, recommended for transparent trimmed textures in atlas
         *
         * @default 0.5
         * @member {number}
         */
        this.clampMargin = typeof clampMargin === 'undefined' ? 0.5 : clampMargin;
    }

    /**
     * texture property
     * @member {PIXI.Texture}
     */


    /**
     * Multiplies uvs array to transform
     * @param {Float32Array} uvs mesh uvs
     * @param {Float32Array} [out=uvs] output
     * @returns {Float32Array} output
     */
    TextureMatrix.prototype.multiplyUvs = function multiplyUvs(uvs, out) {
        if (out === undefined) {
            out = uvs;
        }

        var mat = this.mapCoord;

        for (var i = 0; i < uvs.length; i += 2) {
            var x = uvs[i];
            var y = uvs[i + 1];

            out[i] = x * mat.a + y * mat.c + mat.tx;
            out[i + 1] = x * mat.b + y * mat.d + mat.ty;
        }

        return out;
    };

    /**
     * updates matrices if texture was changed
     * @param {boolean} forceUpdate if true, matrices will be updated any case
     * @returns {boolean} whether or not it was updated
     */


    TextureMatrix.prototype.update = function update(forceUpdate) {
        var tex = this._texture;

        if (!tex || !tex.valid) {
            return false;
        }

        if (!forceUpdate && this._lastTextureID === tex._updateID) {
            return false;
        }

        this._lastTextureID = tex._updateID;

        var uvs = tex._uvs;

        this.mapCoord.set(uvs.x1 - uvs.x0, uvs.y1 - uvs.y0, uvs.x3 - uvs.x0, uvs.y3 - uvs.y0, uvs.x0, uvs.y0);

        var orig = tex.orig;
        var trim = tex.trim;

        if (trim) {
            tempMat.set(orig.width / trim.width, 0, 0, orig.height / trim.height, -trim.x / trim.width, -trim.y / trim.height);
            this.mapCoord.append(tempMat);
        }

        var texBase = tex.baseTexture;
        var frame = this.uClampFrame;
        var margin = this.clampMargin / texBase.resolution;
        var offset = this.clampOffset;

        frame[0] = (tex._frame.x + margin + offset) / texBase.width;
        frame[1] = (tex._frame.y + margin + offset) / texBase.height;
        frame[2] = (tex._frame.x + tex._frame.width - margin + offset) / texBase.width;
        frame[3] = (tex._frame.y + tex._frame.height - margin + offset) / texBase.height;
        this.uClampOffset[0] = offset / texBase.realWidth;
        this.uClampOffset[1] = offset / texBase.realHeight;

        return true;
    };

    _createClass(TextureMatrix, [{
        key: 'texture',
        get: function get() {
            return this._texture;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this._texture = value;
            this._lastTextureID = -1;
        }
    }]);

    return TextureMatrix;
}();

exports.default = TextureMatrix;
//# sourceMappingURL=TextureMatrix.js.map

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _pixiGlCore = __webpack_require__(31);

var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);

var _createIndicesForQuads = __webpack_require__(136);

var _createIndicesForQuads2 = _interopRequireDefault(_createIndicesForQuads);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Helper class to create a quad
 *
 * @class
 * @memberof PIXI
 */
var Quad = function () {
  /**
   * @param {WebGLRenderingContext} gl - The gl context for this quad to use.
   * @param {object} state - TODO: Description
   */
  function Quad(gl, state) {
    _classCallCheck(this, Quad);

    /**
     * the current WebGL drawing context
     *
     * @member {WebGLRenderingContext}
     */
    this.gl = gl;

    /**
     * An array of vertices
     *
     * @member {Float32Array}
     */
    this.vertices = new Float32Array([-1, -1, 1, -1, 1, 1, -1, 1]);

    /**
     * The Uvs of the quad
     *
     * @member {Float32Array}
     */
    this.uvs = new Float32Array([0, 0, 1, 0, 1, 1, 0, 1]);

    this.interleaved = new Float32Array(8 * 2);

    for (var i = 0; i < 4; i++) {
      this.interleaved[i * 4] = this.vertices[i * 2];
      this.interleaved[i * 4 + 1] = this.vertices[i * 2 + 1];
      this.interleaved[i * 4 + 2] = this.uvs[i * 2];
      this.interleaved[i * 4 + 3] = this.uvs[i * 2 + 1];
    }

    /**
     * An array containing the indices of the vertices
     *
     * @member {Uint16Array}
     */
    this.indices = (0, _createIndicesForQuads2.default)(1);

    /**
     * The vertex buffer
     *
     * @member {glCore.GLBuffer}
     */
    this.vertexBuffer = _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, this.interleaved, gl.STATIC_DRAW);

    /**
     * The index buffer
     *
     * @member {glCore.GLBuffer}
     */
    this.indexBuffer = _pixiGlCore2.default.GLBuffer.createIndexBuffer(gl, this.indices, gl.STATIC_DRAW);

    /**
     * The vertex array object
     *
     * @member {glCore.VertexArrayObject}
     */
    this.vao = new _pixiGlCore2.default.VertexArrayObject(gl, state);
  }

  /**
   * Initialises the vaos and uses the shader.
   *
   * @param {PIXI.Shader} shader - the shader to use
   */


  Quad.prototype.initVao = function initVao(shader) {
    this.vao.clear().addIndex(this.indexBuffer).addAttribute(this.vertexBuffer, shader.attributes.aVertexPosition, this.gl.FLOAT, false, 4 * 4, 0).addAttribute(this.vertexBuffer, shader.attributes.aTextureCoord, this.gl.FLOAT, false, 4 * 4, 2 * 4);
  };

  /**
   * Maps two Rectangle to the quad.
   *
   * @param {PIXI.Rectangle} targetTextureFrame - the first rectangle
   * @param {PIXI.Rectangle} destinationFrame - the second rectangle
   * @return {PIXI.Quad} Returns itself.
   */


  Quad.prototype.map = function map(targetTextureFrame, destinationFrame) {
    var x = 0; // destinationFrame.x / targetTextureFrame.width;
    var y = 0; // destinationFrame.y / targetTextureFrame.height;

    this.uvs[0] = x;
    this.uvs[1] = y;

    this.uvs[2] = x + destinationFrame.width / targetTextureFrame.width;
    this.uvs[3] = y;

    this.uvs[4] = x + destinationFrame.width / targetTextureFrame.width;
    this.uvs[5] = y + destinationFrame.height / targetTextureFrame.height;

    this.uvs[6] = x;
    this.uvs[7] = y + destinationFrame.height / targetTextureFrame.height;

    x = destinationFrame.x;
    y = destinationFrame.y;

    this.vertices[0] = x;
    this.vertices[1] = y;

    this.vertices[2] = x + destinationFrame.width;
    this.vertices[3] = y;

    this.vertices[4] = x + destinationFrame.width;
    this.vertices[5] = y + destinationFrame.height;

    this.vertices[6] = x;
    this.vertices[7] = y + destinationFrame.height;

    return this;
  };

  /**
   * Binds the buffer and uploads the data
   *
   * @return {PIXI.Quad} Returns itself.
   */


  Quad.prototype.upload = function upload() {
    for (var i = 0; i < 4; i++) {
      this.interleaved[i * 4] = this.vertices[i * 2];
      this.interleaved[i * 4 + 1] = this.vertices[i * 2 + 1];
      this.interleaved[i * 4 + 2] = this.uvs[i * 2];
      this.interleaved[i * 4 + 3] = this.uvs[i * 2 + 1];
    }

    this.vertexBuffer.upload(this.interleaved);

    return this;
  };

  /**
   * Removes this quad from WebGL
   */


  Quad.prototype.destroy = function destroy() {
    var gl = this.gl;

    gl.deleteBuffer(this.vertexBuffer);
    gl.deleteBuffer(this.indexBuffer);
  };

  return Quad;
}();

exports.default = Quad;
//# sourceMappingURL=Quad.js.map

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); // disabling eslint for now, going to rewrite this in v5
/* eslint-disable */

var _const = __webpack_require__(5);

var _utils = __webpack_require__(9);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var defaultStyle = {
    align: 'left',
    breakWords: false,
    dropShadow: false,
    dropShadowAlpha: 1,
    dropShadowAngle: Math.PI / 6,
    dropShadowBlur: 0,
    dropShadowColor: 'black',
    dropShadowDistance: 5,
    fill: 'black',
    fillGradientType: _const.TEXT_GRADIENT.LINEAR_VERTICAL,
    fillGradientStops: [],
    fontFamily: 'Arial',
    fontSize: 26,
    fontStyle: 'normal',
    fontVariant: 'normal',
    fontWeight: 'normal',
    letterSpacing: 0,
    lineHeight: 0,
    lineJoin: 'miter',
    miterLimit: 10,
    padding: 0,
    stroke: 'black',
    strokeThickness: 0,
    textBaseline: 'alphabetic',
    trim: false,
    whiteSpace: 'pre',
    wordWrap: false,
    wordWrapWidth: 100,
    leading: 0
};

var genericFontFamilies = ['serif', 'sans-serif', 'monospace', 'cursive', 'fantasy', 'system-ui'];

/**
 * A TextStyle Object decorates a Text Object. It can be shared between
 * multiple Text objects. Changing the style will update all text objects using it.
 * It can be generated [here](https://pixijs.io/pixi-text-style).
 *
 * @class
 * @memberof PIXI
 */

var TextStyle = function () {
    /**
     * @param {object} [style] - The style parameters
     * @param {string} [style.align='left'] - Alignment for multiline text ('left', 'center' or 'right'),
     *  does not affect single line text
     * @param {boolean} [style.breakWords=false] - Indicates if lines can be wrapped within words, it
     *  needs wordWrap to be set to true
     * @param {boolean} [style.dropShadow=false] - Set a drop shadow for the text
     * @param {number} [style.dropShadowAlpha=1] - Set alpha for the drop shadow
     * @param {number} [style.dropShadowAngle=Math.PI/6] - Set a angle of the drop shadow
     * @param {number} [style.dropShadowBlur=0] - Set a shadow blur radius
     * @param {string|number} [style.dropShadowColor='black'] - A fill style to be used on the dropshadow e.g 'red', '#00FF00'
     * @param {number} [style.dropShadowDistance=5] - Set a distance of the drop shadow
     * @param {string|string[]|number|number[]|CanvasGradient|CanvasPattern} [style.fill='black'] - A canvas
     *  fillstyle that will be used on the text e.g 'red', '#00FF00'. Can be an array to create a gradient
     *  eg ['#000000','#FFFFFF']
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/fillStyle|MDN}
     * @param {number} [style.fillGradientType=PIXI.TEXT_GRADIENT.LINEAR_VERTICAL] - If fill is an array of colours
     *  to create a gradient, this can change the type/direction of the gradient. See {@link PIXI.TEXT_GRADIENT}
     * @param {number[]} [style.fillGradientStops] - If fill is an array of colours to create a gradient, this array can set
     * the stop points (numbers between 0 and 1) for the color, overriding the default behaviour of evenly spacing them.
     * @param {string|string[]} [style.fontFamily='Arial'] - The font family
     * @param {number|string} [style.fontSize=26] - The font size (as a number it converts to px, but as a string,
     *  equivalents are '26px','20pt','160%' or '1.6em')
     * @param {string} [style.fontStyle='normal'] - The font style ('normal', 'italic' or 'oblique')
     * @param {string} [style.fontVariant='normal'] - The font variant ('normal' or 'small-caps')
     * @param {string} [style.fontWeight='normal'] - The font weight ('normal', 'bold', 'bolder', 'lighter' and '100',
     *  '200', '300', '400', '500', '600', '700', 800' or '900')
     * @param {number} [style.leading=0] - The space between lines
     * @param {number} [style.letterSpacing=0] - The amount of spacing between letters, default is 0
     * @param {number} [style.lineHeight] - The line height, a number that represents the vertical space that a letter uses
     * @param {string} [style.lineJoin='miter'] - The lineJoin property sets the type of corner created, it can resolve
     *      spiked text issues. Possible values "miter" (creates a sharp corner), "round" (creates a round corner) or "bevel"
     *      (creates a squared corner).
     * @param {number} [style.miterLimit=10] - The miter limit to use when using the 'miter' lineJoin mode. This can reduce
     *      or increase the spikiness of rendered text.
     * @param {number} [style.padding=0] - Occasionally some fonts are cropped. Adding some padding will prevent this from
     *     happening by adding padding to all sides of the text.
     * @param {string|number} [style.stroke='black'] - A canvas fillstyle that will be used on the text stroke
     *  e.g 'blue', '#FCFF00'
     * @param {number} [style.strokeThickness=0] - A number that represents the thickness of the stroke.
     *  Default is 0 (no stroke)
     * @param {boolean} [style.trim=false] - Trim transparent borders
     * @param {string} [style.textBaseline='alphabetic'] - The baseline of the text that is rendered.
     * @param {boolean} [style.whiteSpace='pre'] - Determines whether newlines & spaces are collapsed or preserved "normal"
     *      (collapse, collapse), "pre" (preserve, preserve) | "pre-line" (preserve, collapse). It needs wordWrap to be set to true
     * @param {boolean} [style.wordWrap=false] - Indicates if word wrap should be used
     * @param {number} [style.wordWrapWidth=100] - The width at which text will wrap, it needs wordWrap to be set to true
     */
    function TextStyle(style) {
        _classCallCheck(this, TextStyle);

        this.styleID = 0;

        this.reset();

        deepCopyProperties(this, style, style);
    }

    /**
     * Creates a new TextStyle object with the same values as this one.
     * Note that the only the properties of the object are cloned.
     *
     * @return {PIXI.TextStyle} New cloned TextStyle object
     */


    TextStyle.prototype.clone = function clone() {
        var clonedProperties = {};

        deepCopyProperties(clonedProperties, this, defaultStyle);

        return new TextStyle(clonedProperties);
    };

    /**
     * Resets all properties to the defaults specified in TextStyle.prototype._default
     */


    TextStyle.prototype.reset = function reset() {
        deepCopyProperties(this, defaultStyle, defaultStyle);
    };

    /**
     * Alignment for multiline text ('left', 'center' or 'right'), does not affect single line text
     *
     * @member {string}
     */


    /**
     * Generates a font style string to use for `TextMetrics.measureFont()`.
     *
     * @return {string} Font style string, for passing to `TextMetrics.measureFont()`
     */
    TextStyle.prototype.toFontString = function toFontString() {
        // build canvas api font setting from individual components. Convert a numeric this.fontSize to px
        var fontSizeString = typeof this.fontSize === 'number' ? this.fontSize + 'px' : this.fontSize;

        // Clean-up fontFamily property by quoting each font name
        // this will support font names with spaces
        var fontFamilies = this.fontFamily;

        if (!Array.isArray(this.fontFamily)) {
            fontFamilies = this.fontFamily.split(',');
        }

        for (var i = fontFamilies.length - 1; i >= 0; i--) {
            // Trim any extra white-space
            var fontFamily = fontFamilies[i].trim();

            // Check if font is already escaped in quotes except for CSS generic fonts
            if (!/([\"\'])[^\'\"]+\1/.test(fontFamily) && genericFontFamilies.indexOf(fontFamily) < 0) {
                fontFamily = '"' + fontFamily + '"';
            }
            fontFamilies[i] = fontFamily;
        }

        return this.fontStyle + ' ' + this.fontVariant + ' ' + this.fontWeight + ' ' + fontSizeString + ' ' + fontFamilies.join(',');
    };

    _createClass(TextStyle, [{
        key: 'align',
        get: function get() {
            return this._align;
        },
        set: function set(align) // eslint-disable-line require-jsdoc
        {
            if (this._align !== align) {
                this._align = align;
                this.styleID++;
            }
        }

        /**
         * Indicates if lines can be wrapped within words, it needs wordWrap to be set to true
         *
         * @member {boolean}
         */

    }, {
        key: 'breakWords',
        get: function get() {
            return this._breakWords;
        },
        set: function set(breakWords) // eslint-disable-line require-jsdoc
        {
            if (this._breakWords !== breakWords) {
                this._breakWords = breakWords;
                this.styleID++;
            }
        }

        /**
         * Set a drop shadow for the text
         *
         * @member {boolean}
         */

    }, {
        key: 'dropShadow',
        get: function get() {
            return this._dropShadow;
        },
        set: function set(dropShadow) // eslint-disable-line require-jsdoc
        {
            if (this._dropShadow !== dropShadow) {
                this._dropShadow = dropShadow;
                this.styleID++;
            }
        }

        /**
         * Set alpha for the drop shadow
         *
         * @member {number}
         */

    }, {
        key: 'dropShadowAlpha',
        get: function get() {
            return this._dropShadowAlpha;
        },
        set: function set(dropShadowAlpha) // eslint-disable-line require-jsdoc
        {
            if (this._dropShadowAlpha !== dropShadowAlpha) {
                this._dropShadowAlpha = dropShadowAlpha;
                this.styleID++;
            }
        }

        /**
         * Set a angle of the drop shadow
         *
         * @member {number}
         */

    }, {
        key: 'dropShadowAngle',
        get: function get() {
            return this._dropShadowAngle;
        },
        set: function set(dropShadowAngle) // eslint-disable-line require-jsdoc
        {
            if (this._dropShadowAngle !== dropShadowAngle) {
                this._dropShadowAngle = dropShadowAngle;
                this.styleID++;
            }
        }

        /**
         * Set a shadow blur radius
         *
         * @member {number}
         */

    }, {
        key: 'dropShadowBlur',
        get: function get() {
            return this._dropShadowBlur;
        },
        set: function set(dropShadowBlur) // eslint-disable-line require-jsdoc
        {
            if (this._dropShadowBlur !== dropShadowBlur) {
                this._dropShadowBlur = dropShadowBlur;
                this.styleID++;
            }
        }

        /**
         * A fill style to be used on the dropshadow e.g 'red', '#00FF00'
         *
         * @member {string|number}
         */

    }, {
        key: 'dropShadowColor',
        get: function get() {
            return this._dropShadowColor;
        },
        set: function set(dropShadowColor) // eslint-disable-line require-jsdoc
        {
            var outputColor = getColor(dropShadowColor);
            if (this._dropShadowColor !== outputColor) {
                this._dropShadowColor = outputColor;
                this.styleID++;
            }
        }

        /**
         * Set a distance of the drop shadow
         *
         * @member {number}
         */

    }, {
        key: 'dropShadowDistance',
        get: function get() {
            return this._dropShadowDistance;
        },
        set: function set(dropShadowDistance) // eslint-disable-line require-jsdoc
        {
            if (this._dropShadowDistance !== dropShadowDistance) {
                this._dropShadowDistance = dropShadowDistance;
                this.styleID++;
            }
        }

        /**
         * A canvas fillstyle that will be used on the text e.g 'red', '#00FF00'.
         * Can be an array to create a gradient eg ['#000000','#FFFFFF']
         * {@link https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/fillStyle|MDN}
         *
         * @member {string|string[]|number|number[]|CanvasGradient|CanvasPattern}
         */

    }, {
        key: 'fill',
        get: function get() {
            return this._fill;
        },
        set: function set(fill) // eslint-disable-line require-jsdoc
        {
            var outputColor = getColor(fill);
            if (this._fill !== outputColor) {
                this._fill = outputColor;
                this.styleID++;
            }
        }

        /**
         * If fill is an array of colours to create a gradient, this can change the type/direction of the gradient.
         * See {@link PIXI.TEXT_GRADIENT}
         *
         * @member {number}
         */

    }, {
        key: 'fillGradientType',
        get: function get() {
            return this._fillGradientType;
        },
        set: function set(fillGradientType) // eslint-disable-line require-jsdoc
        {
            if (this._fillGradientType !== fillGradientType) {
                this._fillGradientType = fillGradientType;
                this.styleID++;
            }
        }

        /**
         * If fill is an array of colours to create a gradient, this array can set the stop points
         * (numbers between 0 and 1) for the color, overriding the default behaviour of evenly spacing them.
         *
         * @member {number[]}
         */

    }, {
        key: 'fillGradientStops',
        get: function get() {
            return this._fillGradientStops;
        },
        set: function set(fillGradientStops) // eslint-disable-line require-jsdoc
        {
            if (!areArraysEqual(this._fillGradientStops, fillGradientStops)) {
                this._fillGradientStops = fillGradientStops;
                this.styleID++;
            }
        }

        /**
         * The font family
         *
         * @member {string|string[]}
         */

    }, {
        key: 'fontFamily',
        get: function get() {
            return this._fontFamily;
        },
        set: function set(fontFamily) // eslint-disable-line require-jsdoc
        {
            if (this.fontFamily !== fontFamily) {
                this._fontFamily = fontFamily;
                this.styleID++;
            }
        }

        /**
         * The font size
         * (as a number it converts to px, but as a string, equivalents are '26px','20pt','160%' or '1.6em')
         *
         * @member {number|string}
         */

    }, {
        key: 'fontSize',
        get: function get() {
            return this._fontSize;
        },
        set: function set(fontSize) // eslint-disable-line require-jsdoc
        {
            if (this._fontSize !== fontSize) {
                this._fontSize = fontSize;
                this.styleID++;
            }
        }

        /**
         * The font style
         * ('normal', 'italic' or 'oblique')
         *
         * @member {string}
         */

    }, {
        key: 'fontStyle',
        get: function get() {
            return this._fontStyle;
        },
        set: function set(fontStyle) // eslint-disable-line require-jsdoc
        {
            if (this._fontStyle !== fontStyle) {
                this._fontStyle = fontStyle;
                this.styleID++;
            }
        }

        /**
         * The font variant
         * ('normal' or 'small-caps')
         *
         * @member {string}
         */

    }, {
        key: 'fontVariant',
        get: function get() {
            return this._fontVariant;
        },
        set: function set(fontVariant) // eslint-disable-line require-jsdoc
        {
            if (this._fontVariant !== fontVariant) {
                this._fontVariant = fontVariant;
                this.styleID++;
            }
        }

        /**
         * The font weight
         * ('normal', 'bold', 'bolder', 'lighter' and '100', '200', '300', '400', '500', '600', '700', 800' or '900')
         *
         * @member {string}
         */

    }, {
        key: 'fontWeight',
        get: function get() {
            return this._fontWeight;
        },
        set: function set(fontWeight) // eslint-disable-line require-jsdoc
        {
            if (this._fontWeight !== fontWeight) {
                this._fontWeight = fontWeight;
                this.styleID++;
            }
        }

        /**
         * The amount of spacing between letters, default is 0
         *
         * @member {number}
         */

    }, {
        key: 'letterSpacing',
        get: function get() {
            return this._letterSpacing;
        },
        set: function set(letterSpacing) // eslint-disable-line require-jsdoc
        {
            if (this._letterSpacing !== letterSpacing) {
                this._letterSpacing = letterSpacing;
                this.styleID++;
            }
        }

        /**
         * The line height, a number that represents the vertical space that a letter uses
         *
         * @member {number}
         */

    }, {
        key: 'lineHeight',
        get: function get() {
            return this._lineHeight;
        },
        set: function set(lineHeight) // eslint-disable-line require-jsdoc
        {
            if (this._lineHeight !== lineHeight) {
                this._lineHeight = lineHeight;
                this.styleID++;
            }
        }

        /**
         * The space between lines
         *
         * @member {number}
         */

    }, {
        key: 'leading',
        get: function get() {
            return this._leading;
        },
        set: function set(leading) // eslint-disable-line require-jsdoc
        {
            if (this._leading !== leading) {
                this._leading = leading;
                this.styleID++;
            }
        }

        /**
         * The lineJoin property sets the type of corner created, it can resolve spiked text issues.
         * Default is 'miter' (creates a sharp corner).
         *
         * @member {string}
         */

    }, {
        key: 'lineJoin',
        get: function get() {
            return this._lineJoin;
        },
        set: function set(lineJoin) // eslint-disable-line require-jsdoc
        {
            if (this._lineJoin !== lineJoin) {
                this._lineJoin = lineJoin;
                this.styleID++;
            }
        }

        /**
         * The miter limit to use when using the 'miter' lineJoin mode
         * This can reduce or increase the spikiness of rendered text.
         *
         * @member {number}
         */

    }, {
        key: 'miterLimit',
        get: function get() {
            return this._miterLimit;
        },
        set: function set(miterLimit) // eslint-disable-line require-jsdoc
        {
            if (this._miterLimit !== miterLimit) {
                this._miterLimit = miterLimit;
                this.styleID++;
            }
        }

        /**
         * Occasionally some fonts are cropped. Adding some padding will prevent this from happening
         * by adding padding to all sides of the text.
         *
         * @member {number}
         */

    }, {
        key: 'padding',
        get: function get() {
            return this._padding;
        },
        set: function set(padding) // eslint-disable-line require-jsdoc
        {
            if (this._padding !== padding) {
                this._padding = padding;
                this.styleID++;
            }
        }

        /**
         * A canvas fillstyle that will be used on the text stroke
         * e.g 'blue', '#FCFF00'
         *
         * @member {string|number}
         */

    }, {
        key: 'stroke',
        get: function get() {
            return this._stroke;
        },
        set: function set(stroke) // eslint-disable-line require-jsdoc
        {
            var outputColor = getColor(stroke);
            if (this._stroke !== outputColor) {
                this._stroke = outputColor;
                this.styleID++;
            }
        }

        /**
         * A number that represents the thickness of the stroke.
         * Default is 0 (no stroke)
         *
         * @member {number}
         */

    }, {
        key: 'strokeThickness',
        get: function get() {
            return this._strokeThickness;
        },
        set: function set(strokeThickness) // eslint-disable-line require-jsdoc
        {
            if (this._strokeThickness !== strokeThickness) {
                this._strokeThickness = strokeThickness;
                this.styleID++;
            }
        }

        /**
         * The baseline of the text that is rendered.
         *
         * @member {string}
         */

    }, {
        key: 'textBaseline',
        get: function get() {
            return this._textBaseline;
        },
        set: function set(textBaseline) // eslint-disable-line require-jsdoc
        {
            if (this._textBaseline !== textBaseline) {
                this._textBaseline = textBaseline;
                this.styleID++;
            }
        }

        /**
         * Trim transparent borders
         *
         * @member {boolean}
         */

    }, {
        key: 'trim',
        get: function get() {
            return this._trim;
        },
        set: function set(trim) // eslint-disable-line require-jsdoc
        {
            if (this._trim !== trim) {
                this._trim = trim;
                this.styleID++;
            }
        }

        /**
         * How newlines and spaces should be handled.
         * Default is 'pre' (preserve, preserve).
         *
         *  value       | New lines     |   Spaces
         *  ---         | ---           |   ---
         * 'normal'     | Collapse      |   Collapse
         * 'pre'        | Preserve      |   Preserve
         * 'pre-line'   | Preserve      |   Collapse
         *
         * @member {string}
         */

    }, {
        key: 'whiteSpace',
        get: function get() {
            return this._whiteSpace;
        },
        set: function set(whiteSpace) // eslint-disable-line require-jsdoc
        {
            if (this._whiteSpace !== whiteSpace) {
                this._whiteSpace = whiteSpace;
                this.styleID++;
            }
        }

        /**
         * Indicates if word wrap should be used
         *
         * @member {boolean}
         */

    }, {
        key: 'wordWrap',
        get: function get() {
            return this._wordWrap;
        },
        set: function set(wordWrap) // eslint-disable-line require-jsdoc
        {
            if (this._wordWrap !== wordWrap) {
                this._wordWrap = wordWrap;
                this.styleID++;
            }
        }

        /**
         * The width at which text will wrap, it needs wordWrap to be set to true
         *
         * @member {number}
         */

    }, {
        key: 'wordWrapWidth',
        get: function get() {
            return this._wordWrapWidth;
        },
        set: function set(wordWrapWidth) // eslint-disable-line require-jsdoc
        {
            if (this._wordWrapWidth !== wordWrapWidth) {
                this._wordWrapWidth = wordWrapWidth;
                this.styleID++;
            }
        }
    }]);

    return TextStyle;
}();

/**
 * Utility function to convert hexadecimal colors to strings, and simply return the color if it's a string.
 * @private
 * @param {number|number[]} color
 * @return {string} The color as a string.
 */


exports.default = TextStyle;
function getSingleColor(color) {
    if (typeof color === 'number') {
        return (0, _utils.hex2string)(color);
    } else if (typeof color === 'string') {
        if (color.indexOf('0x') === 0) {
            color = color.replace('0x', '#');
        }
    }

    return color;
}

/**
 * Utility function to convert hexadecimal colors to strings, and simply return the color if it's a string.
 * This version can also convert array of colors
 * @private
 * @param {number|number[]} color
 * @return {string} The color as a string.
 */
function getColor(color) {
    if (!Array.isArray(color)) {
        return getSingleColor(color);
    } else {
        for (var i = 0; i < color.length; ++i) {
            color[i] = getSingleColor(color[i]);
        }

        return color;
    }
}

/**
 * Utility function to convert hexadecimal colors to strings, and simply return the color if it's a string.
 * This version can also convert array of colors
 * @private
 * @param {Array} array1 First array to compare
 * @param {Array} array2 Second array to compare
 * @return {boolean} Do the arrays contain the same values in the same order
 */
function areArraysEqual(array1, array2) {
    if (!Array.isArray(array1) || !Array.isArray(array2)) {
        return false;
    }

    if (array1.length !== array2.length) {
        return false;
    }

    for (var i = 0; i < array1.length; ++i) {
        if (array1[i] !== array2[i]) {
            return false;
        }
    }

    return true;
}

/**
 * Utility function to ensure that object properties are copied by value, and not by reference
 * @private
 * @param {Object} target Target object to copy properties into
 * @param {Object} source Source object for the proporties to copy
 * @param {string} propertyObj Object containing properties names we want to loop over
 */
function deepCopyProperties(target, source, propertyObj) {
    for (var prop in propertyObj) {
        if (Array.isArray(source[prop])) {
            target[prop] = source[prop].slice();
        } else {
            target[prop] = source[prop];
        }
    }
}
//# sourceMappingURL=TextStyle.js.map

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The TextMetrics object represents the measurement of a block of text with a specified style.
 *
 * ```js
 * let style = new PIXI.TextStyle({fontFamily : 'Arial', fontSize: 24, fill : 0xff1010, align : 'center'})
 * let textMetrics = PIXI.TextMetrics.measureText('Your text', style)
 * ```
 *
 * @class
 * @memberOf PIXI
 */
var TextMetrics = function () {
    /**
     * @param {string} text - the text that was measured
     * @param {PIXI.TextStyle} style - the style that was measured
     * @param {number} width - the measured width of the text
     * @param {number} height - the measured height of the text
     * @param {array} lines - an array of the lines of text broken by new lines and wrapping if specified in style
     * @param {array} lineWidths - an array of the line widths for each line matched to `lines`
     * @param {number} lineHeight - the measured line height for this style
     * @param {number} maxLineWidth - the maximum line width for all measured lines
     * @param {Object} fontProperties - the font properties object from TextMetrics.measureFont
     */
    function TextMetrics(text, style, width, height, lines, lineWidths, lineHeight, maxLineWidth, fontProperties) {
        _classCallCheck(this, TextMetrics);

        this.text = text;
        this.style = style;
        this.width = width;
        this.height = height;
        this.lines = lines;
        this.lineWidths = lineWidths;
        this.lineHeight = lineHeight;
        this.maxLineWidth = maxLineWidth;
        this.fontProperties = fontProperties;
    }

    /**
     * Measures the supplied string of text and returns a Rectangle.
     *
     * @param {string} text - the text to measure.
     * @param {PIXI.TextStyle} style - the text style to use for measuring
     * @param {boolean} [wordWrap] - optional override for if word-wrap should be applied to the text.
     * @param {HTMLCanvasElement} [canvas] - optional specification of the canvas to use for measuring.
     * @return {PIXI.TextMetrics} measured width and height of the text.
     */


    TextMetrics.measureText = function measureText(text, style, wordWrap) {
        var canvas = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : TextMetrics._canvas;

        wordWrap = wordWrap === undefined || wordWrap === null ? style.wordWrap : wordWrap;
        var font = style.toFontString();
        var fontProperties = TextMetrics.measureFont(font);
        var context = canvas.getContext('2d');

        context.font = font;

        var outputText = wordWrap ? TextMetrics.wordWrap(text, style, canvas) : text;
        var lines = outputText.split(/(?:\r\n|\r|\n)/);
        var lineWidths = new Array(lines.length);
        var maxLineWidth = 0;

        for (var i = 0; i < lines.length; i++) {
            var lineWidth = context.measureText(lines[i]).width + (lines[i].length - 1) * style.letterSpacing;

            lineWidths[i] = lineWidth;
            maxLineWidth = Math.max(maxLineWidth, lineWidth);
        }
        var width = maxLineWidth + style.strokeThickness;

        if (style.dropShadow) {
            width += style.dropShadowDistance;
        }

        var lineHeight = style.lineHeight || fontProperties.fontSize + style.strokeThickness;
        var height = Math.max(lineHeight, fontProperties.fontSize + style.strokeThickness) + (lines.length - 1) * (lineHeight + style.leading);

        if (style.dropShadow) {
            height += style.dropShadowDistance;
        }

        return new TextMetrics(text, style, width, height, lines, lineWidths, lineHeight + style.leading, maxLineWidth, fontProperties);
    };

    /**
     * Applies newlines to a string to have it optimally fit into the horizontal
     * bounds set by the Text object's wordWrapWidth property.
     *
     * @private
     * @param {string} text - String to apply word wrapping to
     * @param {PIXI.TextStyle} style - the style to use when wrapping
     * @param {HTMLCanvasElement} [canvas] - optional specification of the canvas to use for measuring.
     * @return {string} New string with new lines applied where required
     */


    TextMetrics.wordWrap = function wordWrap(text, style) {
        var canvas = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : TextMetrics._canvas;

        var context = canvas.getContext('2d');

        var width = 0;
        var line = '';
        var lines = '';

        var cache = {};
        var letterSpacing = style.letterSpacing,
            whiteSpace = style.whiteSpace;

        // How to handle whitespaces

        var collapseSpaces = TextMetrics.collapseSpaces(whiteSpace);
        var collapseNewlines = TextMetrics.collapseNewlines(whiteSpace);

        // whether or not spaces may be added to the beginning of lines
        var canPrependSpaces = !collapseSpaces;

        // There is letterSpacing after every char except the last one
        // t_h_i_s_' '_i_s_' '_a_n_' '_e_x_a_m_p_l_e_' '_!
        // so for convenience the above needs to be compared to width + 1 extra letterSpace
        // t_h_i_s_' '_i_s_' '_a_n_' '_e_x_a_m_p_l_e_' '_!_
        // ________________________________________________
        // And then the final space is simply no appended to each line
        var wordWrapWidth = style.wordWrapWidth + letterSpacing;

        // break text into words, spaces and newline chars
        var tokens = TextMetrics.tokenize(text);

        for (var i = 0; i < tokens.length; i++) {
            // get the word, space or newlineChar
            var token = tokens[i];

            // if word is a new line
            if (TextMetrics.isNewline(token)) {
                // keep the new line
                if (!collapseNewlines) {
                    lines += TextMetrics.addLine(line);
                    canPrependSpaces = !collapseSpaces;
                    line = '';
                    width = 0;
                    continue;
                }

                // if we should collapse new lines
                // we simply convert it into a space
                token = ' ';
            }

            // if we should collapse repeated whitespaces
            if (collapseSpaces) {
                // check both this and the last tokens for spaces
                var currIsBreakingSpace = TextMetrics.isBreakingSpace(token);
                var lastIsBreakingSpace = TextMetrics.isBreakingSpace(line[line.length - 1]);

                if (currIsBreakingSpace && lastIsBreakingSpace) {
                    continue;
                }
            }

            // get word width from cache if possible
            var tokenWidth = TextMetrics.getFromCache(token, letterSpacing, cache, context);

            // word is longer than desired bounds
            if (tokenWidth > wordWrapWidth) {
                // if we are not already at the beginning of a line
                if (line !== '') {
                    // start newlines for overflow words
                    lines += TextMetrics.addLine(line);
                    line = '';
                    width = 0;
                }

                // break large word over multiple lines
                if (TextMetrics.canBreakWords(token, style.breakWords)) {
                    // break word into characters
                    var characters = token.split('');

                    // loop the characters
                    for (var j = 0; j < characters.length; j++) {
                        var char = characters[j];

                        var k = 1;
                        // we are not at the end of the token

                        while (characters[j + k]) {
                            var nextChar = characters[j + k];
                            var lastChar = char[char.length - 1];

                            // should not split chars
                            if (!TextMetrics.canBreakChars(lastChar, nextChar, token, j, style.breakWords)) {
                                // combine chars & move forward one
                                char += nextChar;
                            } else {
                                break;
                            }

                            k++;
                        }

                        j += char.length - 1;

                        var characterWidth = TextMetrics.getFromCache(char, letterSpacing, cache, context);

                        if (characterWidth + width > wordWrapWidth) {
                            lines += TextMetrics.addLine(line);
                            canPrependSpaces = false;
                            line = '';
                            width = 0;
                        }

                        line += char;
                        width += characterWidth;
                    }
                }

                // run word out of the bounds
                else {
                        // if there are words in this line already
                        // finish that line and start a new one
                        if (line.length > 0) {
                            lines += TextMetrics.addLine(line);
                            line = '';
                            width = 0;
                        }

                        var isLastToken = i === tokens.length - 1;

                        // give it its own line if it's not the end
                        lines += TextMetrics.addLine(token, !isLastToken);
                        canPrependSpaces = false;
                        line = '';
                        width = 0;
                    }
            }

            // word could fit
            else {
                    // word won't fit because of existing words
                    // start a new line
                    if (tokenWidth + width > wordWrapWidth) {
                        // if its a space we don't want it
                        canPrependSpaces = false;

                        // add a new line
                        lines += TextMetrics.addLine(line);

                        // start a new line
                        line = '';
                        width = 0;
                    }

                    // don't add spaces to the beginning of lines
                    if (line.length > 0 || !TextMetrics.isBreakingSpace(token) || canPrependSpaces) {
                        // add the word to the current line
                        line += token;

                        // update width counter
                        width += tokenWidth;
                    }
                }
        }

        lines += TextMetrics.addLine(line, false);

        return lines;
    };

    /**
     * Convienience function for logging each line added during the wordWrap
     * method
     *
     * @private
     * @param  {string}   line        - The line of text to add
     * @param  {boolean}  newLine     - Add new line character to end
     * @return {string}   A formatted line
     */


    TextMetrics.addLine = function addLine(line) {
        var newLine = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        line = TextMetrics.trimRight(line);

        line = newLine ? line + '\n' : line;

        return line;
    };

    /**
     * Gets & sets the widths of calculated characters in a cache object
     *
     * @private
     * @param  {string}                    key            The key
     * @param  {number}                    letterSpacing  The letter spacing
     * @param  {object}                    cache          The cache
     * @param  {CanvasRenderingContext2D}  context        The canvas context
     * @return {number}                    The from cache.
     */


    TextMetrics.getFromCache = function getFromCache(key, letterSpacing, cache, context) {
        var width = cache[key];

        if (width === undefined) {
            var spacing = key.length * letterSpacing;

            width = context.measureText(key).width + spacing;
            cache[key] = width;
        }

        return width;
    };

    /**
     * Determines whether we should collapse breaking spaces
     *
     * @private
     * @param  {string}   whiteSpace  The TextStyle property whiteSpace
     * @return {boolean}  should collapse
     */


    TextMetrics.collapseSpaces = function collapseSpaces(whiteSpace) {
        return whiteSpace === 'normal' || whiteSpace === 'pre-line';
    };

    /**
     * Determines whether we should collapse newLine chars
     *
     * @private
     * @param  {string}   whiteSpace  The white space
     * @return {boolean}  should collapse
     */


    TextMetrics.collapseNewlines = function collapseNewlines(whiteSpace) {
        return whiteSpace === 'normal';
    };

    /**
     * trims breaking whitespaces from string
     *
     * @private
     * @param  {string}  text  The text
     * @return {string}  trimmed string
     */


    TextMetrics.trimRight = function trimRight(text) {
        if (typeof text !== 'string') {
            return '';
        }

        for (var i = text.length - 1; i >= 0; i--) {
            var char = text[i];

            if (!TextMetrics.isBreakingSpace(char)) {
                break;
            }

            text = text.slice(0, -1);
        }

        return text;
    };

    /**
     * Determines if char is a newline.
     *
     * @private
     * @param  {string}  char  The character
     * @return {boolean}  True if newline, False otherwise.
     */


    TextMetrics.isNewline = function isNewline(char) {
        if (typeof char !== 'string') {
            return false;
        }

        return TextMetrics._newlines.indexOf(char.charCodeAt(0)) >= 0;
    };

    /**
     * Determines if char is a breaking whitespace.
     *
     * @private
     * @param  {string}  char  The character
     * @return {boolean}  True if whitespace, False otherwise.
     */


    TextMetrics.isBreakingSpace = function isBreakingSpace(char) {
        if (typeof char !== 'string') {
            return false;
        }

        return TextMetrics._breakingSpaces.indexOf(char.charCodeAt(0)) >= 0;
    };

    /**
     * Splits a string into words, breaking-spaces and newLine characters
     *
     * @private
     * @param  {string}  text       The text
     * @return {array}  A tokenized array
     */


    TextMetrics.tokenize = function tokenize(text) {
        var tokens = [];
        var token = '';

        if (typeof text !== 'string') {
            return tokens;
        }

        for (var i = 0; i < text.length; i++) {
            var char = text[i];

            if (TextMetrics.isBreakingSpace(char) || TextMetrics.isNewline(char)) {
                if (token !== '') {
                    tokens.push(token);
                    token = '';
                }

                tokens.push(char);

                continue;
            }

            token += char;
        }

        if (token !== '') {
            tokens.push(token);
        }

        return tokens;
    };

    /**
     * This method exists to be easily overridden
     * It allows one to customise which words should break
     * Examples are if the token is CJK or numbers.
     * It must return a boolean.
     *
     * @private
     * @param  {string}  token       The token
     * @param  {boolean}  breakWords  The style attr break words
     * @return {boolean} whether to break word or not
     */


    TextMetrics.canBreakWords = function canBreakWords(token, breakWords) {
        return breakWords;
    };

    /**
     * This method exists to be easily overridden
     * It allows one to determine whether a pair of characters
     * should be broken by newlines
     * For example certain characters in CJK langs or numbers.
     * It must return a boolean.
     *
     * @private
     * @param  {string}  char      The character
     * @param  {string}  nextChar  The next character
     * @param  {string}  token     The token/word the characters are from
     * @param  {number}  index     The index in the token of the char
     * @param  {boolean}  breakWords  The style attr break words
     * @return {boolean} whether to break word or not
     */


    TextMetrics.canBreakChars = function canBreakChars(char, nextChar, token, index, breakWords) // eslint-disable-line no-unused-vars
    {
        return true;
    };

    /**
     * Calculates the ascent, descent and fontSize of a given font-style
     *
     * @static
     * @param {string} font - String representing the style of the font
     * @return {PIXI.TextMetrics~FontMetrics} Font properties object
     */


    TextMetrics.measureFont = function measureFont(font) {
        // as this method is used for preparing assets, don't recalculate things if we don't need to
        if (TextMetrics._fonts[font]) {
            return TextMetrics._fonts[font];
        }

        var properties = {};

        var canvas = TextMetrics._canvas;
        var context = TextMetrics._context;

        context.font = font;

        var metricsString = TextMetrics.METRICS_STRING + TextMetrics.BASELINE_SYMBOL;
        var width = Math.ceil(context.measureText(metricsString).width);
        var baseline = Math.ceil(context.measureText(TextMetrics.BASELINE_SYMBOL).width);
        var height = 2 * baseline;

        baseline = baseline * TextMetrics.BASELINE_MULTIPLIER | 0;

        canvas.width = width;
        canvas.height = height;

        context.fillStyle = '#f00';
        context.fillRect(0, 0, width, height);

        context.font = font;

        context.textBaseline = 'alphabetic';
        context.fillStyle = '#000';
        context.fillText(metricsString, 0, baseline);

        var imagedata = context.getImageData(0, 0, width, height).data;
        var pixels = imagedata.length;
        var line = width * 4;

        var i = 0;
        var idx = 0;
        var stop = false;

        // ascent. scan from top to bottom until we find a non red pixel
        for (i = 0; i < baseline; ++i) {
            for (var j = 0; j < line; j += 4) {
                if (imagedata[idx + j] !== 255) {
                    stop = true;
                    break;
                }
            }
            if (!stop) {
                idx += line;
            } else {
                break;
            }
        }

        properties.ascent = baseline - i;

        idx = pixels - line;
        stop = false;

        // descent. scan from bottom to top until we find a non red pixel
        for (i = height; i > baseline; --i) {
            for (var _j = 0; _j < line; _j += 4) {
                if (imagedata[idx + _j] !== 255) {
                    stop = true;
                    break;
                }
            }

            if (!stop) {
                idx -= line;
            } else {
                break;
            }
        }

        properties.descent = i - baseline;
        properties.fontSize = properties.ascent + properties.descent;

        TextMetrics._fonts[font] = properties;

        return properties;
    };

    /**
     * Clear font metrics in metrics cache.
     *
     * @static
     * @param {string} [font] - font name. If font name not set then clear cache for all fonts.
     */


    TextMetrics.clearMetrics = function clearMetrics() {
        var font = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

        if (font) {
            delete TextMetrics._fonts[font];
        } else {
            TextMetrics._fonts = {};
        }
    };

    return TextMetrics;
}();

/**
 * Internal return object for {@link PIXI.TextMetrics.measureFont `TextMetrics.measureFont`}.
 * @class FontMetrics
 * @memberof PIXI.TextMetrics~
 * @property {number} ascent - The ascent distance
 * @property {number} descent - The descent distance
 * @property {number} fontSize - Font size from ascent to descent
 */

exports.default = TextMetrics;
var canvas = document.createElement('canvas');

canvas.width = canvas.height = 10;

/**
 * Cached canvas element for measuring text
 * @memberof PIXI.TextMetrics
 * @type {HTMLCanvasElement}
 * @private
 */
TextMetrics._canvas = canvas;

/**
 * Cache for context to use.
 * @memberof PIXI.TextMetrics
 * @type {CanvasRenderingContext2D}
 * @private
 */
TextMetrics._context = canvas.getContext('2d');

/**
 * Cache of PIXI.TextMetrics~FontMetrics objects.
 * @memberof PIXI.TextMetrics
 * @type {Object}
 * @private
 */
TextMetrics._fonts = {};

/**
 * String used for calculate font metrics.
 * @static
 * @memberof PIXI.TextMetrics
 * @name METRICS_STRING
 * @type {string}
 * @default |Éq
 */
TextMetrics.METRICS_STRING = '|Éq';

/**
 * Baseline symbol for calculate font metrics.
 * @static
 * @memberof PIXI.TextMetrics
 * @name BASELINE_SYMBOL
 * @type {string}
 * @default M
 */
TextMetrics.BASELINE_SYMBOL = 'M';

/**
 * Baseline multiplier for calculate font metrics.
 * @static
 * @memberof PIXI.TextMetrics
 * @name BASELINE_MULTIPLIER
 * @type {number}
 * @default 1.4
 */
TextMetrics.BASELINE_MULTIPLIER = 1.4;

/**
 * Cache of new line chars.
 * @memberof PIXI.TextMetrics
 * @type {number[]}
 * @private
 */
TextMetrics._newlines = [0x000A, // line feed
0x000D];

/**
 * Cache of breaking spaces.
 * @memberof PIXI.TextMetrics
 * @type {number[]}
 * @private
 */
TextMetrics._breakingSpaces = [0x0009, // character tabulation
0x0020, // space
0x2000, // en quad
0x2001, // em quad
0x2002, // en space
0x2003, // em space
0x2004, // three-per-em space
0x2005, // four-per-em space
0x2006, // six-per-em space
0x2008, // punctuation space
0x2009, // thin space
0x200A, // hair space
0x205F, // medium mathematical space
0x3000];
//# sourceMappingURL=TextMetrics.js.map

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * A GraphicsData object.
 *
 * @class
 * @memberof PIXI
 */
var GraphicsData = function () {
  /**
   *
   * @param {number} lineWidth - the width of the line to draw
   * @param {number} lineColor - the color of the line to draw
   * @param {number} lineAlpha - the alpha of the line to draw
   * @param {number} fillColor - the color of the fill
   * @param {number} fillAlpha - the alpha of the fill
   * @param {boolean} fill - whether or not the shape is filled with a colour
   * @param {boolean} nativeLines - the method for drawing lines
   * @param {PIXI.Circle|PIXI.Rectangle|PIXI.Ellipse|PIXI.Polygon} shape - The shape object to draw.
   * @param {number} lineAlignment - the alignment of the line.
   */
  function GraphicsData(lineWidth, lineColor, lineAlpha, fillColor, fillAlpha, fill, nativeLines, shape, lineAlignment) {
    _classCallCheck(this, GraphicsData);

    /**
     * the width of the line to draw
     * @member {number}
     */
    this.lineWidth = lineWidth;

    /**
     * The alignment of any lines drawn (0.5 = middle, 1 = outter, 0 = inner).
     *
     * @member {number}
     * @default 0
     */
    this.lineAlignment = lineAlignment;

    /**
     * if true the liens will be draw using LINES instead of TRIANGLE_STRIP
     * @member {boolean}
     */
    this.nativeLines = nativeLines;

    /**
     * the color of the line to draw
     * @member {number}
     */
    this.lineColor = lineColor;

    /**
     * the alpha of the line to draw
     * @member {number}
     */
    this.lineAlpha = lineAlpha;

    /**
     * cached tint of the line to draw
     * @member {number}
     * @private
     */
    this._lineTint = lineColor;

    /**
     * the color of the fill
     * @member {number}
     */
    this.fillColor = fillColor;

    /**
     * the alpha of the fill
     * @member {number}
     */
    this.fillAlpha = fillAlpha;

    /**
     * cached tint of the fill
     * @member {number}
     * @private
     */
    this._fillTint = fillColor;

    /**
     * whether or not the shape is filled with a colour
     * @member {boolean}
     */
    this.fill = fill;

    this.holes = [];

    /**
     * The shape object to draw.
     * @member {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle}
     */
    this.shape = shape;

    /**
     * The type of the shape, see the Const.Shapes file for all the existing types,
     * @member {number}
     */
    this.type = shape.type;
  }

  /**
   * Creates a new GraphicsData object with the same values as this one.
   *
   * @return {PIXI.GraphicsData} Cloned GraphicsData object
   */


  GraphicsData.prototype.clone = function clone() {
    return new GraphicsData(this.lineWidth, this.lineColor, this.lineAlpha, this.fillColor, this.fillAlpha, this.fill, this.nativeLines, this.shape, this.lineAlignment);
  };

  /**
   * Adds a hole to the shape.
   *
   * @param {PIXI.Rectangle|PIXI.Circle} shape - The shape of the hole.
   */


  GraphicsData.prototype.addHole = function addHole(shape) {
    this.holes.push(shape);
  };

  /**
   * Destroys the Graphics data.
   */


  GraphicsData.prototype.destroy = function destroy() {
    this.shape = null;
    this.holes = null;
  };

  return GraphicsData;
}();

exports.default = GraphicsData;
//# sourceMappingURL=GraphicsData.js.map

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _autoDetectRenderer = __webpack_require__(199);

var _Container = __webpack_require__(83);

var _Container2 = _interopRequireDefault(_Container);

var _ticker = __webpack_require__(134);

var _settings = __webpack_require__(17);

var _settings2 = _interopRequireDefault(_settings);

var _const = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Convenience class to create a new PIXI application.
 * This class automatically creates the renderer, ticker
 * and root container.
 *
 * @example
 * // Create the application
 * const app = new PIXI.Application();
 *
 * // Add the view to the DOM
 * document.body.appendChild(app.view);
 *
 * // ex, add display objects
 * app.stage.addChild(PIXI.Sprite.fromImage('something.png'));
 *
 * @class
 * @memberof PIXI
 */
var Application = function () {
    // eslint-disable-next-line valid-jsdoc
    /**
     * @param {object} [options] - The optional renderer parameters
     * @param {boolean} [options.autoStart=true] - automatically starts the rendering after the construction.
     *     Note that setting this parameter to false does NOT stop the shared ticker even if you set
     *     options.sharedTicker to true in case that it is already started. Stop it by your own.
     * @param {number} [options.width=800] - the width of the renderers view
     * @param {number} [options.height=600] - the height of the renderers view
     * @param {HTMLCanvasElement} [options.view] - the canvas to use as a view, optional
     * @param {boolean} [options.transparent=false] - If the render view is transparent, default false
     * @param {boolean} [options.antialias=false] - sets antialias (only applicable in chrome at the moment)
     * @param {boolean} [options.preserveDrawingBuffer=false] - enables drawing buffer preservation, enable this if you
     *  need to call toDataUrl on the webgl context
     * @param {number} [options.resolution=1] - The resolution / device pixel ratio of the renderer, retina would be 2
     * @param {boolean} [options.forceCanvas=false] - prevents selection of WebGL renderer, even if such is present
     * @param {number} [options.backgroundColor=0x000000] - The background color of the rendered area
     *  (shown if not transparent).
     * @param {boolean} [options.clearBeforeRender=true] - This sets if the renderer will clear the canvas or
     *   not before the new render pass.
     * @param {boolean} [options.roundPixels=false] - If true PixiJS will Math.floor() x/y values when rendering,
     *  stopping pixel interpolation.
     * @param {boolean} [options.forceFXAA=false] - forces FXAA antialiasing to be used over native.
     *  FXAA is faster, but may not always look as great **webgl only**
     * @param {boolean} [options.legacy=false] - `true` to ensure compatibility with older / less advanced devices.
     *  If you experience unexplained flickering try setting this to true. **webgl only**
     * @param {string} [options.powerPreference] - Parameter passed to webgl context, set to "high-performance"
     *  for devices with dual graphics card **webgl only**
     * @param {boolean} [options.sharedTicker=false] - `true` to use PIXI.ticker.shared, `false` to create new ticker.
     * @param {boolean} [options.sharedLoader=false] - `true` to use PIXI.loaders.shared, `false` to create new Loader.
     */
    function Application(options, arg2, arg3, arg4, arg5) {
        _classCallCheck(this, Application);

        // Support for constructor(width, height, options, noWebGL, useSharedTicker)
        if (typeof options === 'number') {
            options = Object.assign({
                width: options,
                height: arg2 || _settings2.default.RENDER_OPTIONS.height,
                forceCanvas: !!arg4,
                sharedTicker: !!arg5
            }, arg3);
        }

        /**
         * The default options, so we mixin functionality later.
         * @member {object}
         * @protected
         */
        this._options = options = Object.assign({
            autoStart: true,
            sharedTicker: false,
            forceCanvas: false,
            sharedLoader: false
        }, options);

        /**
         * WebGL renderer if available, otherwise CanvasRenderer
         * @member {PIXI.WebGLRenderer|PIXI.CanvasRenderer}
         */
        this.renderer = (0, _autoDetectRenderer.autoDetectRenderer)(options);

        /**
         * The root display container that's rendered.
         * @member {PIXI.Container}
         */
        this.stage = new _Container2.default();

        /**
         * Internal reference to the ticker
         * @member {PIXI.ticker.Ticker}
         * @private
         */
        this._ticker = null;

        /**
         * Ticker for doing render updates.
         * @member {PIXI.ticker.Ticker}
         * @default PIXI.ticker.shared
         */
        this.ticker = options.sharedTicker ? _ticker.shared : new _ticker.Ticker();

        // Start the rendering
        if (options.autoStart) {
            this.start();
        }
    }

    /**
     * Render the current stage.
     */
    Application.prototype.render = function render() {
        this.renderer.render(this.stage);
    };

    /**
     * Convenience method for stopping the render.
     */


    Application.prototype.stop = function stop() {
        this._ticker.stop();
    };

    /**
     * Convenience method for starting the render.
     */


    Application.prototype.start = function start() {
        this._ticker.start();
    };

    /**
     * Reference to the renderer's canvas element.
     * @member {HTMLCanvasElement}
     * @readonly
     */


    /**
     * Destroy and don't use after this.
     * @param {Boolean} [removeView=false] Automatically remove canvas from DOM.
     * @param {object|boolean} [stageOptions] - Options parameter. A boolean will act as if all options
     *  have been set to that value
     * @param {boolean} [stageOptions.children=false] - if set to true, all the children will have their destroy
     *  method called as well. 'stageOptions' will be passed on to those calls.
     * @param {boolean} [stageOptions.texture=false] - Only used for child Sprites if stageOptions.children is set
     *  to true. Should it destroy the texture of the child sprite
     * @param {boolean} [stageOptions.baseTexture=false] - Only used for child Sprites if stageOptions.children is set
     *  to true. Should it destroy the base texture of the child sprite
     */
    Application.prototype.destroy = function destroy(removeView, stageOptions) {
        if (this._ticker) {
            var oldTicker = this._ticker;

            this.ticker = null;
            oldTicker.destroy();
        }

        this.stage.destroy(stageOptions);
        this.stage = null;

        this.renderer.destroy(removeView);
        this.renderer = null;

        this._options = null;
    };

    _createClass(Application, [{
        key: 'ticker',
        set: function set(ticker) // eslint-disable-line require-jsdoc
        {
            if (this._ticker) {
                this._ticker.remove(this.render, this);
            }
            this._ticker = ticker;
            if (ticker) {
                ticker.add(this.render, this, _const.UPDATE_PRIORITY.LOW);
            }
        },
        get: function get() // eslint-disable-line require-jsdoc
        {
            return this._ticker;
        }
    }, {
        key: 'view',
        get: function get() {
            return this.renderer.view;
        }

        /**
         * Reference to the renderer's screen rectangle. Its safe to use as filterArea or hitArea for whole screen
         * @member {PIXI.Rectangle}
         * @readonly
         */

    }, {
        key: 'screen',
        get: function get() {
            return this.renderer.screen;
        }
    }]);

    return Application;
}();

exports.default = Application;
//# sourceMappingURL=Application.js.map

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.autoDetectRenderer = autoDetectRenderer;

var _utils = __webpack_require__(9);

var utils = _interopRequireWildcard(_utils);

var _CanvasRenderer = __webpack_require__(84);

var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);

var _WebGLRenderer = __webpack_require__(103);

var _WebGLRenderer2 = _interopRequireDefault(_WebGLRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// eslint-disable-next-line valid-jsdoc
/**
 * This helper function will automatically detect which renderer you should be using.
 * WebGL is the preferred renderer as it is a lot faster. If webGL is not supported by
 * the browser then this function will return a canvas renderer
 *
 * @memberof PIXI
 * @function autoDetectRenderer
 * @param {object} [options] - The optional renderer parameters
 * @param {number} [options.width=800] - the width of the renderers view
 * @param {number} [options.height=600] - the height of the renderers view
 * @param {HTMLCanvasElement} [options.view] - the canvas to use as a view, optional
 * @param {boolean} [options.transparent=false] - If the render view is transparent, default false
 * @param {boolean} [options.antialias=false] - sets antialias (only applicable in chrome at the moment)
 * @param {boolean} [options.preserveDrawingBuffer=false] - enables drawing buffer preservation, enable this if you
 *  need to call toDataUrl on the webgl context
 * @param {number} [options.backgroundColor=0x000000] - The background color of the rendered area
 *  (shown if not transparent).
 * @param {boolean} [options.clearBeforeRender=true] - This sets if the renderer will clear the canvas or
 *   not before the new render pass.
 * @param {number} [options.resolution=1] - The resolution / device pixel ratio of the renderer, retina would be 2
 * @param {boolean} [options.forceCanvas=false] - prevents selection of WebGL renderer, even if such is present
 * @param {boolean} [options.roundPixels=false] - If true PixiJS will Math.floor() x/y values when rendering,
 *  stopping pixel interpolation.
 * @param {boolean} [options.forceFXAA=false] - forces FXAA antialiasing to be used over native.
 *  FXAA is faster, but may not always look as great **webgl only**
 * @param {boolean} [options.legacy=false] - `true` to ensure compatibility with older / less advanced devices.
 *  If you experience unexplained flickering try setting this to true. **webgl only**
 * @param {string} [options.powerPreference] - Parameter passed to webgl context, set to "high-performance"
 *  for devices with dual graphics card **webgl only**
 * @return {PIXI.WebGLRenderer|PIXI.CanvasRenderer} Returns WebGL renderer if available, otherwise CanvasRenderer
 */
function autoDetectRenderer(options, arg1, arg2, arg3) {
    // Backward-compatible support for noWebGL option
    var forceCanvas = options && options.forceCanvas;

    if (arg3 !== undefined) {
        forceCanvas = arg3;
    }

    if (!forceCanvas && utils.isWebGLSupported()) {
        return new _WebGLRenderer2.default(options, arg1, arg2);
    }

    return new _CanvasRenderer2.default(options, arg1, arg2);
}
//# sourceMappingURL=autoDetectRenderer.js.map

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Default property values of accessible objects
 * used by {@link PIXI.accessibility.AccessibilityManager}.
 *
 * @function accessibleTarget
 * @memberof PIXI.accessibility
 * @example
 *      function MyObject() {}
 *
 *      Object.assign(
 *          MyObject.prototype,
 *          PIXI.accessibility.accessibleTarget
 *      );
 */
exports.default = {
  /**
   *  Flag for if the object is accessible. If true AccessibilityManager will overlay a
   *   shadow div with attributes set
   *
   * @member {boolean}
   */
  accessible: false,

  /**
   * Sets the title attribute of the shadow div
   * If accessibleTitle AND accessibleHint has not been this will default to 'displayObject [tabIndex]'
   *
   * @member {string}
   */
  accessibleTitle: null,

  /**
   * Sets the aria-label attribute of the shadow div
   *
   * @member {string}
   */
  accessibleHint: null,

  /**
   * @todo Needs docs.
   */
  tabIndex: 0,

  /**
   * @todo Needs docs.
   */
  _accessibleActive: false,

  /**
   * @todo Needs docs.
   */
  _accessibleDiv: false
};
//# sourceMappingURL=accessibleTarget.js.map

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.BitmapText = exports.TilingSpriteRenderer = exports.TilingSprite = exports.AnimatedSprite = undefined;

var _AnimatedSprite = __webpack_require__(405);

Object.defineProperty(exports, 'AnimatedSprite', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AnimatedSprite).default;
  }
});

var _TilingSprite = __webpack_require__(406);

Object.defineProperty(exports, 'TilingSprite', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TilingSprite).default;
  }
});

var _TilingSpriteRenderer = __webpack_require__(407);

Object.defineProperty(exports, 'TilingSpriteRenderer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TilingSpriteRenderer).default;
  }
});

var _BitmapText = __webpack_require__(408);

Object.defineProperty(exports, 'BitmapText', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BitmapText).default;
  }
});

__webpack_require__(409);

__webpack_require__(410);

__webpack_require__(411);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// imported for side effect of extending the prototype only, contains no exports
//# sourceMappingURL=index.js.map

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _core = __webpack_require__(7);

var core = _interopRequireWildcard(_core);

var _generateBlurVertSource = __webpack_require__(203);

var _generateBlurVertSource2 = _interopRequireDefault(_generateBlurVertSource);

var _generateBlurFragSource = __webpack_require__(204);

var _generateBlurFragSource2 = _interopRequireDefault(_generateBlurFragSource);

var _getMaxBlurKernelSize = __webpack_require__(205);

var _getMaxBlurKernelSize2 = _interopRequireDefault(_getMaxBlurKernelSize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The BlurXFilter applies a horizontal Gaussian blur to an object.
 *
 * @class
 * @extends PIXI.Filter
 * @memberof PIXI.filters
 */
var BlurXFilter = function (_core$Filter) {
    _inherits(BlurXFilter, _core$Filter);

    /**
     * @param {number} strength - The strength of the blur filter.
     * @param {number} quality - The quality of the blur filter.
     * @param {number} resolution - The resolution of the blur filter.
     * @param {number} [kernelSize=5] - The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15.
     */
    function BlurXFilter(strength, quality, resolution, kernelSize) {
        _classCallCheck(this, BlurXFilter);

        kernelSize = kernelSize || 5;
        var vertSrc = (0, _generateBlurVertSource2.default)(kernelSize, true);
        var fragSrc = (0, _generateBlurFragSource2.default)(kernelSize);

        var _this = _possibleConstructorReturn(this, _core$Filter.call(this,
        // vertex shader
        vertSrc,
        // fragment shader
        fragSrc));

        _this.resolution = resolution || core.settings.RESOLUTION;

        _this._quality = 0;

        _this.quality = quality || 4;
        _this.strength = strength || 8;

        _this.firstRun = true;
        return _this;
    }

    /**
     * Applies the filter.
     *
     * @param {PIXI.FilterManager} filterManager - The manager.
     * @param {PIXI.RenderTarget} input - The input target.
     * @param {PIXI.RenderTarget} output - The output target.
     * @param {boolean} clear - Should the output be cleared before rendering?
     */


    BlurXFilter.prototype.apply = function apply(filterManager, input, output, clear) {
        if (this.firstRun) {
            var gl = filterManager.renderer.gl;
            var kernelSize = (0, _getMaxBlurKernelSize2.default)(gl);

            this.vertexSrc = (0, _generateBlurVertSource2.default)(kernelSize, true);
            this.fragmentSrc = (0, _generateBlurFragSource2.default)(kernelSize);

            this.firstRun = false;
        }

        this.uniforms.strength = 1 / output.size.width * (output.size.width / input.size.width);

        // screen space!
        this.uniforms.strength *= this.strength;
        this.uniforms.strength /= this.passes; // / this.passes//Math.pow(1, this.passes);

        if (this.passes === 1) {
            filterManager.applyFilter(this, input, output, clear);
        } else {
            var renderTarget = filterManager.getRenderTarget(true);
            var flip = input;
            var flop = renderTarget;

            for (var i = 0; i < this.passes - 1; i++) {
                filterManager.applyFilter(this, flip, flop, true);

                var temp = flop;

                flop = flip;
                flip = temp;
            }

            filterManager.applyFilter(this, flip, output, clear);

            filterManager.returnRenderTarget(renderTarget);
        }
    };

    /**
     * Sets the strength of both the blur.
     *
     * @member {number}
     * @default 16
     */


    _createClass(BlurXFilter, [{
        key: 'blur',
        get: function get() {
            return this.strength;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.padding = Math.abs(value) * 2;
            this.strength = value;
        }

        /**
        * Sets the quality of the blur by modifying the number of passes. More passes means higher
        * quaility bluring but the lower the performance.
        *
        * @member {number}
        * @default 4
        */

    }, {
        key: 'quality',
        get: function get() {
            return this._quality;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this._quality = value;
            this.passes = value;
        }
    }]);

    return BlurXFilter;
}(core.Filter);

exports.default = BlurXFilter;
//# sourceMappingURL=BlurXFilter.js.map

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = generateVertBlurSource;
var vertTemplate = ['attribute vec2 aVertexPosition;', 'attribute vec2 aTextureCoord;', 'uniform float strength;', 'uniform mat3 projectionMatrix;', 'varying vec2 vBlurTexCoords[%size%];', 'void main(void)', '{', 'gl_Position = vec4((projectionMatrix * vec3((aVertexPosition), 1.0)).xy, 0.0, 1.0);', '%blur%', '}'].join('\n');

function generateVertBlurSource(kernelSize, x) {
    var halfLength = Math.ceil(kernelSize / 2);

    var vertSource = vertTemplate;

    var blurLoop = '';
    var template = void 0;
    // let value;

    if (x) {
        template = 'vBlurTexCoords[%index%] = aTextureCoord + vec2(%sampleIndex% * strength, 0.0);';
    } else {
        template = 'vBlurTexCoords[%index%] = aTextureCoord + vec2(0.0, %sampleIndex% * strength);';
    }

    for (var i = 0; i < kernelSize; i++) {
        var blur = template.replace('%index%', i);

        // value = i;

        // if(i >= halfLength)
        // {
        //     value = kernelSize - i - 1;
        // }

        blur = blur.replace('%sampleIndex%', i - (halfLength - 1) + '.0');

        blurLoop += blur;
        blurLoop += '\n';
    }

    vertSource = vertSource.replace('%blur%', blurLoop);
    vertSource = vertSource.replace('%size%', kernelSize);

    return vertSource;
}
//# sourceMappingURL=generateBlurVertSource.js.map

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = generateFragBlurSource;
var GAUSSIAN_VALUES = {
    5: [0.153388, 0.221461, 0.250301],
    7: [0.071303, 0.131514, 0.189879, 0.214607],
    9: [0.028532, 0.067234, 0.124009, 0.179044, 0.20236],
    11: [0.0093, 0.028002, 0.065984, 0.121703, 0.175713, 0.198596],
    13: [0.002406, 0.009255, 0.027867, 0.065666, 0.121117, 0.174868, 0.197641],
    15: [0.000489, 0.002403, 0.009246, 0.02784, 0.065602, 0.120999, 0.174697, 0.197448]
};

var fragTemplate = ['varying vec2 vBlurTexCoords[%size%];', 'uniform sampler2D uSampler;', 'void main(void)', '{', '    gl_FragColor = vec4(0.0);', '    %blur%', '}'].join('\n');

function generateFragBlurSource(kernelSize) {
    var kernel = GAUSSIAN_VALUES[kernelSize];
    var halfLength = kernel.length;

    var fragSource = fragTemplate;

    var blurLoop = '';
    var template = 'gl_FragColor += texture2D(uSampler, vBlurTexCoords[%index%]) * %value%;';
    var value = void 0;

    for (var i = 0; i < kernelSize; i++) {
        var blur = template.replace('%index%', i);

        value = i;

        if (i >= halfLength) {
            value = kernelSize - i - 1;
        }

        blur = blur.replace('%value%', kernel[value]);

        blurLoop += blur;
        blurLoop += '\n';
    }

    fragSource = fragSource.replace('%blur%', blurLoop);
    fragSource = fragSource.replace('%size%', kernelSize);

    return fragSource;
}
//# sourceMappingURL=generateBlurFragSource.js.map

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getMaxKernelSize;
function getMaxKernelSize(gl) {
    var maxVaryings = gl.getParameter(gl.MAX_VARYING_VECTORS);
    var kernelSize = 15;

    while (kernelSize > maxVaryings) {
        kernelSize -= 2;
    }

    return kernelSize;
}
//# sourceMappingURL=getMaxBlurKernelSize.js.map

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _core = __webpack_require__(7);

var core = _interopRequireWildcard(_core);

var _generateBlurVertSource = __webpack_require__(203);

var _generateBlurVertSource2 = _interopRequireDefault(_generateBlurVertSource);

var _generateBlurFragSource = __webpack_require__(204);

var _generateBlurFragSource2 = _interopRequireDefault(_generateBlurFragSource);

var _getMaxBlurKernelSize = __webpack_require__(205);

var _getMaxBlurKernelSize2 = _interopRequireDefault(_getMaxBlurKernelSize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The BlurYFilter applies a horizontal Gaussian blur to an object.
 *
 * @class
 * @extends PIXI.Filter
 * @memberof PIXI.filters
 */
var BlurYFilter = function (_core$Filter) {
    _inherits(BlurYFilter, _core$Filter);

    /**
     * @param {number} strength - The strength of the blur filter.
     * @param {number} quality - The quality of the blur filter.
     * @param {number} resolution - The resolution of the blur filter.
     * @param {number} [kernelSize=5] - The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15.
     */
    function BlurYFilter(strength, quality, resolution, kernelSize) {
        _classCallCheck(this, BlurYFilter);

        kernelSize = kernelSize || 5;
        var vertSrc = (0, _generateBlurVertSource2.default)(kernelSize, false);
        var fragSrc = (0, _generateBlurFragSource2.default)(kernelSize);

        var _this = _possibleConstructorReturn(this, _core$Filter.call(this,
        // vertex shader
        vertSrc,
        // fragment shader
        fragSrc));

        _this.resolution = resolution || core.settings.RESOLUTION;

        _this._quality = 0;

        _this.quality = quality || 4;
        _this.strength = strength || 8;

        _this.firstRun = true;
        return _this;
    }

    /**
     * Applies the filter.
     *
     * @param {PIXI.FilterManager} filterManager - The manager.
     * @param {PIXI.RenderTarget} input - The input target.
     * @param {PIXI.RenderTarget} output - The output target.
     * @param {boolean} clear - Should the output be cleared before rendering?
     */


    BlurYFilter.prototype.apply = function apply(filterManager, input, output, clear) {
        if (this.firstRun) {
            var gl = filterManager.renderer.gl;
            var kernelSize = (0, _getMaxBlurKernelSize2.default)(gl);

            this.vertexSrc = (0, _generateBlurVertSource2.default)(kernelSize, false);
            this.fragmentSrc = (0, _generateBlurFragSource2.default)(kernelSize);

            this.firstRun = false;
        }

        this.uniforms.strength = 1 / output.size.height * (output.size.height / input.size.height);

        this.uniforms.strength *= this.strength;
        this.uniforms.strength /= this.passes;

        if (this.passes === 1) {
            filterManager.applyFilter(this, input, output, clear);
        } else {
            var renderTarget = filterManager.getRenderTarget(true);
            var flip = input;
            var flop = renderTarget;

            for (var i = 0; i < this.passes - 1; i++) {
                filterManager.applyFilter(this, flip, flop, true);

                var temp = flop;

                flop = flip;
                flip = temp;
            }

            filterManager.applyFilter(this, flip, output, clear);

            filterManager.returnRenderTarget(renderTarget);
        }
    };

    /**
     * Sets the strength of both the blur.
     *
     * @member {number}
     * @default 2
     */


    _createClass(BlurYFilter, [{
        key: 'blur',
        get: function get() {
            return this.strength;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.padding = Math.abs(value) * 2;
            this.strength = value;
        }

        /**
         * Sets the quality of the blur by modifying the number of passes. More passes means higher
         * quaility bluring but the lower the performance.
         *
         * @member {number}
         * @default 4
         */

    }, {
        key: 'quality',
        get: function get() {
            return this._quality;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this._quality = value;
            this.passes = value;
        }
    }]);

    return BlurYFilter;
}(core.Filter);

exports.default = BlurYFilter;
//# sourceMappingURL=BlurYFilter.js.map

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _core = __webpack_require__(7);

var core = _interopRequireWildcard(_core);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Holds all information related to an Interaction event
 *
 * @class
 * @memberof PIXI.interaction
 */
var InteractionData = function () {
  /**
   *
   */
  function InteractionData() {
    _classCallCheck(this, InteractionData);

    /**
     * This point stores the global coords of where the touch/mouse event happened
     *
     * @member {PIXI.Point}
     */
    this.global = new core.Point();

    /**
     * The target DisplayObject that was interacted with
     *
     * @member {PIXI.DisplayObject}
     */
    this.target = null;

    /**
     * When passed to an event handler, this will be the original DOM Event that was captured
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent
     * @see https://developer.mozilla.org/en-US/docs/Web/API/TouchEvent
     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent
     * @member {MouseEvent|TouchEvent|PointerEvent}
     */
    this.originalEvent = null;

    /**
     * Unique identifier for this interaction
     *
     * @member {number}
     */
    this.identifier = null;

    /**
     * Indicates whether or not the pointer device that created the event is the primary pointer.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/isPrimary
     * @type {Boolean}
     */
    this.isPrimary = false;

    /**
     * Indicates which button was pressed on the mouse or pointer device to trigger the event.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
     * @type {number}
     */
    this.button = 0;

    /**
     * Indicates which buttons are pressed on the mouse or pointer device when the event is triggered.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/buttons
     * @type {number}
     */
    this.buttons = 0;

    /**
     * The width of the pointer's contact along the x-axis, measured in CSS pixels.
     * radiusX of TouchEvents will be represented by this value.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/width
     * @type {number}
     */
    this.width = 0;

    /**
     * The height of the pointer's contact along the y-axis, measured in CSS pixels.
     * radiusY of TouchEvents will be represented by this value.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/height
     * @type {number}
     */
    this.height = 0;

    /**
     * The angle, in degrees, between the pointer device and the screen.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/tiltX
     * @type {number}
     */
    this.tiltX = 0;

    /**
     * The angle, in degrees, between the pointer device and the screen.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/tiltY
     * @type {number}
     */
    this.tiltY = 0;

    /**
     * The type of pointer that triggered the event.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/pointerType
     * @type {string}
     */
    this.pointerType = null;

    /**
     * Pressure applied by the pointing device during the event. A Touch's force property
     * will be represented by this value.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/pressure
     * @type {number}
     */
    this.pressure = 0;

    /**
     * From TouchEvents (not PointerEvents triggered by touches), the rotationAngle of the Touch.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Touch/rotationAngle
     * @type {number}
     */
    this.rotationAngle = 0;

    /**
     * Twist of a stylus pointer.
     * @see https://w3c.github.io/pointerevents/#pointerevent-interface
     * @type {number}
     */
    this.twist = 0;

    /**
     * Barrel pressure on a stylus pointer.
     * @see https://w3c.github.io/pointerevents/#pointerevent-interface
     * @type {number}
     */
    this.tangentialPressure = 0;
  }

  /**
   * The unique identifier of the pointer. It will be the same as `identifier`.
   * @readonly
   * @member {number}
   * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/pointerId
   */


  /**
   * This will return the local coordinates of the specified displayObject for this InteractionData
   *
   * @param {PIXI.DisplayObject} displayObject - The DisplayObject that you would like the local
   *  coords off
   * @param {PIXI.Point} [point] - A Point object in which to store the value, optional (otherwise
   *  will create a new point)
   * @param {PIXI.Point} [globalPos] - A Point object containing your custom global coords, optional
   *  (otherwise will use the current global coords)
   * @return {PIXI.Point} A point containing the coordinates of the InteractionData position relative
   *  to the DisplayObject
   */
  InteractionData.prototype.getLocalPosition = function getLocalPosition(displayObject, point, globalPos) {
    return displayObject.worldTransform.applyInverse(globalPos || this.global, point);
  };

  /**
   * Copies properties from normalized event data.
   *
   * @param {Touch|MouseEvent|PointerEvent} event The normalized event data
   */


  InteractionData.prototype.copyEvent = function copyEvent(event) {
    // isPrimary should only change on touchstart/pointerdown, so we don't want to overwrite
    // it with "false" on later events when our shim for it on touch events might not be
    // accurate
    if (event.isPrimary) {
      this.isPrimary = true;
    }
    this.button = event.button;
    // event.buttons is not available in all browsers (ie. Safari), but it does have a non-standard
    // event.which property instead, which conveys the same information.
    this.buttons = Number.isInteger(event.buttons) ? event.buttons : event.which;
    this.width = event.width;
    this.height = event.height;
    this.tiltX = event.tiltX;
    this.tiltY = event.tiltY;
    this.pointerType = event.pointerType;
    this.pressure = event.pressure;
    this.rotationAngle = event.rotationAngle;
    this.twist = event.twist || 0;
    this.tangentialPressure = event.tangentialPressure || 0;
  };

  /**
   * Resets the data for pooling.
   */


  InteractionData.prototype.reset = function reset() {
    // isPrimary is the only property that we really need to reset - everything else is
    // guaranteed to be overwritten
    this.isPrimary = false;
  };

  _createClass(InteractionData, [{
    key: 'pointerId',
    get: function get() {
      return this.identifier;
    }
  }]);

  return InteractionData;
}();

exports.default = InteractionData;
//# sourceMappingURL=InteractionData.js.map

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Event class that mimics native DOM events.
 *
 * @class
 * @memberof PIXI.interaction
 */
var InteractionEvent = function () {
  /**
   *
   */
  function InteractionEvent() {
    _classCallCheck(this, InteractionEvent);

    /**
     * Whether this event will continue propagating in the tree
     *
     * @member {boolean}
     */
    this.stopped = false;

    /**
     * The object which caused this event to be dispatched.
     * For listener callback see {@link PIXI.interaction.InteractionEvent.currentTarget}.
     *
     * @member {PIXI.DisplayObject}
     */
    this.target = null;

    /**
     * The object whose event listener’s callback is currently being invoked.
     *
     * @member {PIXI.DisplayObject}
     */
    this.currentTarget = null;

    /**
     * Type of the event
     *
     * @member {string}
     */
    this.type = null;

    /**
     * InteractionData related to this event
     *
     * @member {PIXI.interaction.InteractionData}
     */
    this.data = null;
  }

  /**
   * Prevents event from reaching any objects other than the current object.
   *
   */


  InteractionEvent.prototype.stopPropagation = function stopPropagation() {
    this.stopped = true;
  };

  /**
   * Resets the event.
   */


  InteractionEvent.prototype.reset = function reset() {
    this.stopped = false;
    this.currentTarget = null;
    this.target = null;
  };

  return InteractionEvent;
}();

exports.default = InteractionEvent;
//# sourceMappingURL=InteractionEvent.js.map

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * DisplayObjects with the {@link PIXI.interaction.interactiveTarget} mixin use this class to track interactions
 *
 * @class
 * @private
 * @memberof PIXI.interaction
 */
var InteractionTrackingData = function () {
    /**
     * @param {number} pointerId - Unique pointer id of the event
     */
    function InteractionTrackingData(pointerId) {
        _classCallCheck(this, InteractionTrackingData);

        this._pointerId = pointerId;
        this._flags = InteractionTrackingData.FLAGS.NONE;
    }

    /**
     *
     * @private
     * @param {number} flag - The interaction flag to set
     * @param {boolean} yn - Should the flag be set or unset
     */


    InteractionTrackingData.prototype._doSet = function _doSet(flag, yn) {
        if (yn) {
            this._flags = this._flags | flag;
        } else {
            this._flags = this._flags & ~flag;
        }
    };

    /**
     * Unique pointer id of the event
     *
     * @readonly
     * @member {number}
     */


    _createClass(InteractionTrackingData, [{
        key: "pointerId",
        get: function get() {
            return this._pointerId;
        }

        /**
         * State of the tracking data, expressed as bit flags
         *
         * @member {number}
         * @memberof PIXI.interaction.InteractionTrackingData#
         */

    }, {
        key: "flags",
        get: function get() {
            return this._flags;
        }

        /**
         * Set the flags for the tracking data
         *
         * @param {number} flags - Flags to set
         */
        ,
        set: function set(flags) {
            this._flags = flags;
        }

        /**
         * Is the tracked event inactive (not over or down)?
         *
         * @member {number}
         * @memberof PIXI.interaction.InteractionTrackingData#
         */

    }, {
        key: "none",
        get: function get() {
            return this._flags === this.constructor.FLAGS.NONE;
        }

        /**
         * Is the tracked event over the DisplayObject?
         *
         * @member {boolean}
         * @memberof PIXI.interaction.InteractionTrackingData#
         */

    }, {
        key: "over",
        get: function get() {
            return (this._flags & this.constructor.FLAGS.OVER) !== 0;
        }

        /**
         * Set the over flag
         *
         * @param {boolean} yn - Is the event over?
         */
        ,
        set: function set(yn) {
            this._doSet(this.constructor.FLAGS.OVER, yn);
        }

        /**
         * Did the right mouse button come down in the DisplayObject?
         *
         * @member {boolean}
         * @memberof PIXI.interaction.InteractionTrackingData#
         */

    }, {
        key: "rightDown",
        get: function get() {
            return (this._flags & this.constructor.FLAGS.RIGHT_DOWN) !== 0;
        }

        /**
         * Set the right down flag
         *
         * @param {boolean} yn - Is the right mouse button down?
         */
        ,
        set: function set(yn) {
            this._doSet(this.constructor.FLAGS.RIGHT_DOWN, yn);
        }

        /**
         * Did the left mouse button come down in the DisplayObject?
         *
         * @member {boolean}
         * @memberof PIXI.interaction.InteractionTrackingData#
         */

    }, {
        key: "leftDown",
        get: function get() {
            return (this._flags & this.constructor.FLAGS.LEFT_DOWN) !== 0;
        }

        /**
         * Set the left down flag
         *
         * @param {boolean} yn - Is the left mouse button down?
         */
        ,
        set: function set(yn) {
            this._doSet(this.constructor.FLAGS.LEFT_DOWN, yn);
        }
    }]);

    return InteractionTrackingData;
}();

exports.default = InteractionTrackingData;


InteractionTrackingData.FLAGS = Object.freeze({
    NONE: 0,
    OVER: 1 << 0,
    LEFT_DOWN: 1 << 1,
    RIGHT_DOWN: 1 << 2
});
//# sourceMappingURL=InteractionTrackingData.js.map

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Default property values of interactive objects
 * Used by {@link PIXI.interaction.InteractionManager} to automatically give all DisplayObjects these properties
 *
 * @private
 * @name interactiveTarget
 * @memberof PIXI.interaction
 * @example
 *      function MyObject() {}
 *
 *      Object.assign(
 *          core.DisplayObject.prototype,
 *          PIXI.interaction.interactiveTarget
 *      );
 */
exports.default = {

  /**
   * Enable interaction events for the DisplayObject. Touch, pointer and mouse
   * events will not be emitted unless `interactive` is set to `true`.
   *
   * @example
   * const sprite = new PIXI.Sprite(texture);
   * sprite.interactive = true;
   * sprite.on('tap', (event) => {
   *    //handle event
   * });
   * @member {boolean}
   * @memberof PIXI.DisplayObject#
   */
  interactive: false,

  /**
   * Determines if the children to the displayObject can be clicked/touched
   * Setting this to false allows PixiJS to bypass a recursive `hitTest` function
   *
   * @member {boolean}
   * @memberof PIXI.Container#
   */
  interactiveChildren: true,

  /**
   * Interaction shape. Children will be hit first, then this shape will be checked.
   * Setting this will cause this shape to be checked in hit tests rather than the displayObject's bounds.
   *
   * @example
   * const sprite = new PIXI.Sprite(texture);
   * sprite.interactive = true;
   * sprite.hitArea = new PIXI.Rectangle(0, 0, 100, 100);
   * @member {PIXI.Rectangle|PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.RoundedRectangle}
   * @memberof PIXI.DisplayObject#
   */
  hitArea: null,

  /**
   * If enabled, the mouse cursor use the pointer behavior when hovered over the displayObject if it is interactive
   * Setting this changes the 'cursor' property to `'pointer'`.
   *
   * @example
   * const sprite = new PIXI.Sprite(texture);
   * sprite.interactive = true;
   * sprite.buttonMode = true;
   * @member {boolean}
   * @memberof PIXI.DisplayObject#
   */
  get buttonMode() {
    return this.cursor === 'pointer';
  },
  set buttonMode(value) {
    if (value) {
      this.cursor = 'pointer';
    } else if (this.cursor === 'pointer') {
      this.cursor = null;
    }
  },

  /**
   * This defines what cursor mode is used when the mouse cursor
   * is hovered over the displayObject.
   *
   * @example
   * const sprite = new PIXI.Sprite(texture);
   * sprite.interactive = true;
   * sprite.cursor = 'wait';
   * @see https://developer.mozilla.org/en/docs/Web/CSS/cursor
   *
   * @member {string}
   * @memberof PIXI.DisplayObject#
   */
  cursor: null,

  /**
   * Internal set of all active pointers, by identifier
   *
   * @member {Map<number, InteractionTrackingData>}
   * @memberof PIXI.DisplayObject#
   * @private
   */
  get trackedPointers() {
    if (this._trackedPointers === undefined) this._trackedPointers = {};

    return this._trackedPointers;
  },

  /**
   * Map of all tracked pointers, by identifier. Use trackedPointers to access.
   *
   * @private
   * @type {Map<number, InteractionTrackingData>}
   */
  _trackedPointers: undefined
};
//# sourceMappingURL=interactiveTarget.js.map

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.parse = parse;

exports.default = function () {
    return function bitmapFontParser(resource, next) {
        // skip if no data or not xml data
        if (!resource.data || resource.type !== _resourceLoader.Resource.TYPE.XML) {
            next();

            return;
        }

        // skip if not bitmap font data, using some silly duck-typing
        if (resource.data.getElementsByTagName('page').length === 0 || resource.data.getElementsByTagName('info').length === 0 || resource.data.getElementsByTagName('info')[0].getAttribute('face') === null) {
            next();

            return;
        }

        var xmlUrl = !resource.isDataUrl ? path.dirname(resource.url) : '';

        if (resource.isDataUrl) {
            if (xmlUrl === '.') {
                xmlUrl = '';
            }

            if (this.baseUrl && xmlUrl) {
                // if baseurl has a trailing slash then add one to xmlUrl so the replace works below
                if (this.baseUrl.charAt(this.baseUrl.length - 1) === '/') {
                    xmlUrl += '/';
                }
            }
        }

        // remove baseUrl from xmlUrl
        xmlUrl = xmlUrl.replace(this.baseUrl, '');

        // if there is an xmlUrl now, it needs a trailing slash. Ensure that it does if the string isn't empty.
        if (xmlUrl && xmlUrl.charAt(xmlUrl.length - 1) !== '/') {
            xmlUrl += '/';
        }

        var pages = resource.data.getElementsByTagName('page');
        var textures = {};

        // Handle completed, when the number of textures
        // load is the same number as references in the fnt file
        var completed = function completed(page) {
            textures[page.metadata.pageFile] = page.texture;

            if (Object.keys(textures).length === pages.length) {
                parse(resource, textures);
                next();
            }
        };

        for (var i = 0; i < pages.length; ++i) {
            var pageFile = pages[i].getAttribute('file');
            var url = xmlUrl + pageFile;
            var exists = false;

            // incase the image is loaded outside
            // using the same loader, resource will be available
            for (var name in this.resources) {
                var bitmapResource = this.resources[name];

                if (bitmapResource.url === url) {
                    bitmapResource.metadata.pageFile = pageFile;
                    if (bitmapResource.texture) {
                        completed(bitmapResource);
                    } else {
                        bitmapResource.onAfterMiddleware.add(completed);
                    }
                    exists = true;
                    break;
                }
            }

            // texture is not loaded, we'll attempt to add
            // it to the load and add the texture to the list
            if (!exists) {
                // Standard loading options for images
                var options = {
                    crossOrigin: resource.crossOrigin,
                    loadType: _resourceLoader.Resource.LOAD_TYPE.IMAGE,
                    metadata: Object.assign({ pageFile: pageFile }, resource.metadata.imageMetadata),
                    parentResource: resource
                };

                this.add(url, options, completed);
            }
        }
    };
};

var _path = __webpack_require__(41);

var path = _interopRequireWildcard(_path);

var _resourceLoader = __webpack_require__(87);

var _extras = __webpack_require__(201);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Register a BitmapText font from loader resource.
 *
 * @function parseBitmapFontData
 * @memberof PIXI.loaders
 * @param {PIXI.loaders.Resource} resource - Loader resource.
 * @param {PIXI.Texture|PIXI.Texture[]} textures - List of textures for each page.
 */
function parse(resource, textures) {
    resource.bitmapFont = _extras.BitmapText.registerFont(resource.data, textures);
}
//# sourceMappingURL=bitmapFontParser.js.map

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var MiniSignalBinding = (function () {
  function MiniSignalBinding(fn, once, thisArg) {
    if (once === undefined) once = false;

    _classCallCheck(this, MiniSignalBinding);

    this._fn = fn;
    this._once = once;
    this._thisArg = thisArg;
    this._next = this._prev = this._owner = null;
  }

  _createClass(MiniSignalBinding, [{
    key: 'detach',
    value: function detach() {
      if (this._owner === null) return false;
      this._owner.detach(this);
      return true;
    }
  }]);

  return MiniSignalBinding;
})();

function _addMiniSignalBinding(self, node) {
  if (!self._head) {
    self._head = node;
    self._tail = node;
  } else {
    self._tail._next = node;
    node._prev = self._tail;
    self._tail = node;
  }

  node._owner = self;

  return node;
}

var MiniSignal = (function () {
  function MiniSignal() {
    _classCallCheck(this, MiniSignal);

    this._head = this._tail = undefined;
  }

  _createClass(MiniSignal, [{
    key: 'handlers',
    value: function handlers() {
      var exists = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];

      var node = this._head;

      if (exists) return !!node;

      var ee = [];

      while (node) {
        ee.push(node);
        node = node._next;
      }

      return ee;
    }
  }, {
    key: 'has',
    value: function has(node) {
      if (!(node instanceof MiniSignalBinding)) {
        throw new Error('MiniSignal#has(): First arg must be a MiniSignalBinding object.');
      }

      return node._owner === this;
    }
  }, {
    key: 'dispatch',
    value: function dispatch() {
      var node = this._head;

      if (!node) return false;

      while (node) {
        if (node._once) this.detach(node);
        node._fn.apply(node._thisArg, arguments);
        node = node._next;
      }

      return true;
    }
  }, {
    key: 'add',
    value: function add(fn) {
      var thisArg = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];

      if (typeof fn !== 'function') {
        throw new Error('MiniSignal#add(): First arg must be a Function.');
      }
      return _addMiniSignalBinding(this, new MiniSignalBinding(fn, false, thisArg));
    }
  }, {
    key: 'once',
    value: function once(fn) {
      var thisArg = arguments.length <= 1 || arguments[1] === undefined ? null : arguments[1];

      if (typeof fn !== 'function') {
        throw new Error('MiniSignal#once(): First arg must be a Function.');
      }
      return _addMiniSignalBinding(this, new MiniSignalBinding(fn, true, thisArg));
    }
  }, {
    key: 'detach',
    value: function detach(node) {
      if (!(node instanceof MiniSignalBinding)) {
        throw new Error('MiniSignal#detach(): First arg must be a MiniSignalBinding object.');
      }
      if (node._owner !== this) return this;

      if (node._prev) node._prev._next = node._next;
      if (node._next) node._next._prev = node._prev;

      if (node === this._head) {
        this._head = node._next;
        if (node._next === null) {
          this._tail = null;
        }
      } else if (node === this._tail) {
        this._tail = node._prev;
        this._tail._next = null;
      }

      node._owner = null;
      return this;
    }
  }, {
    key: 'detachAll',
    value: function detachAll() {
      var node = this._head;
      if (!node) return this;

      this._head = this._tail = null;

      while (node) {
        node._owner = null;
        node = node._next;
      }
      return this;
    }
  }]);

  return MiniSignal;
})();

MiniSignal.MiniSignalBinding = MiniSignalBinding;

exports['default'] = MiniSignal;
module.exports = exports['default'];


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function parseURI (str, opts) {
  if (!str) return undefined

  opts = opts || {}

  var o = {
    key: [
      'source',
      'protocol',
      'authority',
      'userInfo',
      'user',
      'password',
      'host',
      'port',
      'relative',
      'path',
      'directory',
      'file',
      'query',
      'anchor'
    ],
    q: {
      name: 'queryKey',
      parser: /(?:^|&)([^&=]*)=?([^&]*)/g
    },
    parser: {
      strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/,
      loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/
    }
  }

  var m = o.parser[opts.strictMode ? 'strict' : 'loose'].exec(str)
  var uri = {}
  var i = 14

  while (i--) uri[o.key[i]] = m[i] || ''

  uri[o.q.name] = {}
  uri[o.key[12]].replace(o.q.parser, function ($0, $1, $2) {
    if ($1) uri[o.q.name][$1] = $2
  })

  return uri
}

module.exports = parseURI


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.eachSeries = eachSeries;
exports.queue = queue;
/**
 * Smaller version of the async library constructs.
 *
 * @namespace async
 */

/**
 * Noop function
 *
 * @ignore
 * @function
 * @memberof async
 */
function _noop() {} /* empty */

/**
 * Iterates an array in series.
 *
 * @memberof async
 * @param {Array.<*>} array - Array to iterate.
 * @param {function} iterator - Function to call for each element.
 * @param {function} callback - Function to call when done, or on error.
 * @param {boolean} [deferNext=false] - Break synchronous each loop by calling next with a setTimeout of 1.
 */
function eachSeries(array, iterator, callback, deferNext) {
    var i = 0;
    var len = array.length;

    (function next(err) {
        if (err || i === len) {
            if (callback) {
                callback(err);
            }

            return;
        }

        if (deferNext) {
            setTimeout(function () {
                iterator(array[i++], next);
            }, 1);
        } else {
            iterator(array[i++], next);
        }
    })();
}

/**
 * Ensures a function is only called once.
 *
 * @ignore
 * @memberof async
 * @param {function} fn - The function to wrap.
 * @return {function} The wrapping function.
 */
function onlyOnce(fn) {
    return function onceWrapper() {
        if (fn === null) {
            throw new Error('Callback was already called.');
        }

        var callFn = fn;

        fn = null;
        callFn.apply(this, arguments);
    };
}

/**
 * Async queue implementation,
 *
 * @memberof async
 * @param {function} worker - The worker function to call for each task.
 * @param {number} concurrency - How many workers to run in parrallel.
 * @return {*} The async queue object.
 */
function queue(worker, concurrency) {
    if (concurrency == null) {
        // eslint-disable-line no-eq-null,eqeqeq
        concurrency = 1;
    } else if (concurrency === 0) {
        throw new Error('Concurrency must not be zero');
    }

    var workers = 0;
    var q = {
        _tasks: [],
        concurrency: concurrency,
        saturated: _noop,
        unsaturated: _noop,
        buffer: concurrency / 4,
        empty: _noop,
        drain: _noop,
        error: _noop,
        started: false,
        paused: false,
        push: function push(data, callback) {
            _insert(data, false, callback);
        },
        kill: function kill() {
            workers = 0;
            q.drain = _noop;
            q.started = false;
            q._tasks = [];
        },
        unshift: function unshift(data, callback) {
            _insert(data, true, callback);
        },
        process: function process() {
            while (!q.paused && workers < q.concurrency && q._tasks.length) {
                var task = q._tasks.shift();

                if (q._tasks.length === 0) {
                    q.empty();
                }

                workers += 1;

                if (workers === q.concurrency) {
                    q.saturated();
                }

                worker(task.data, onlyOnce(_next(task)));
            }
        },
        length: function length() {
            return q._tasks.length;
        },
        running: function running() {
            return workers;
        },
        idle: function idle() {
            return q._tasks.length + workers === 0;
        },
        pause: function pause() {
            if (q.paused === true) {
                return;
            }

            q.paused = true;
        },
        resume: function resume() {
            if (q.paused === false) {
                return;
            }

            q.paused = false;

            // Need to call q.process once per concurrent
            // worker to preserve full concurrency after pause
            for (var w = 1; w <= q.concurrency; w++) {
                q.process();
            }
        }
    };

    function _insert(data, insertAtFront, callback) {
        if (callback != null && typeof callback !== 'function') {
            // eslint-disable-line no-eq-null,eqeqeq
            throw new Error('task callback must be a function');
        }

        q.started = true;

        if (data == null && q.idle()) {
            // eslint-disable-line no-eq-null,eqeqeq
            // call drain immediately if there are no tasks
            setTimeout(function () {
                return q.drain();
            }, 1);

            return;
        }

        var item = {
            data: data,
            callback: typeof callback === 'function' ? callback : _noop
        };

        if (insertAtFront) {
            q._tasks.unshift(item);
        } else {
            q._tasks.push(item);
        }

        setTimeout(function () {
            return q.process();
        }, 1);
    }

    function _next(task) {
        return function next() {
            workers -= 1;

            task.callback.apply(task, arguments);

            if (arguments[0] != null) {
                // eslint-disable-line no-eq-null,eqeqeq
                q.error(arguments[0], task.data);
            }

            if (workers <= q.concurrency - q.buffer) {
                q.unsaturated();
            }

            if (q.idle()) {
                q.drain();
            }

            q.process();
        };
    }

    return q;
}
//# sourceMappingURL=async.js.map

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.encodeBinary = encodeBinary;
var _keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

/**
 * Encodes binary into base64.
 *
 * @param {string} input The input data to encode.
 * @returns {string} The encoded base64 string
 */
function encodeBinary(input) {
    var output = '';
    var inx = 0;

    while (inx < input.length) {
        // Fill byte buffer array
        var bytebuffer = [0, 0, 0];
        var encodedCharIndexes = [0, 0, 0, 0];

        for (var jnx = 0; jnx < bytebuffer.length; ++jnx) {
            if (inx < input.length) {
                // throw away high-order byte, as documented at:
                // https://developer.mozilla.org/En/Using_XMLHttpRequest#Handling_binary_data
                bytebuffer[jnx] = input.charCodeAt(inx++) & 0xff;
            } else {
                bytebuffer[jnx] = 0;
            }
        }

        // Get each encoded character, 6 bits at a time
        // index 1: first 6 bits
        encodedCharIndexes[0] = bytebuffer[0] >> 2;

        // index 2: second 6 bits (2 least significant bits from input byte 1 + 4 most significant bits from byte 2)
        encodedCharIndexes[1] = (bytebuffer[0] & 0x3) << 4 | bytebuffer[1] >> 4;

        // index 3: third 6 bits (4 least significant bits from input byte 2 + 2 most significant bits from byte 3)
        encodedCharIndexes[2] = (bytebuffer[1] & 0x0f) << 2 | bytebuffer[2] >> 6;

        // index 3: forth 6 bits (6 least significant bits from input byte 3)
        encodedCharIndexes[3] = bytebuffer[2] & 0x3f;

        // Determine whether padding happened, and adjust accordingly
        var paddingBytes = inx - (input.length - 1);

        switch (paddingBytes) {
            case 2:
                // Set last 2 characters to padding char
                encodedCharIndexes[3] = 64;
                encodedCharIndexes[2] = 64;
                break;

            case 1:
                // Set last character to padding char
                encodedCharIndexes[3] = 64;
                break;

            default:
                break; // No padding - proceed
        }

        // Now we will grab each appropriate character out of our keystring
        // based on our index array and append it to the output string
        for (var _jnx = 0; _jnx < encodedCharIndexes.length; ++_jnx) {
            output += _keyStr.charAt(encodedCharIndexes[_jnx]);
        }
    }

    return output;
}

// Backwards compat
if (true) {
    module.exports.default = encodeBinary; // eslint-disable-line no-undef
}
//# sourceMappingURL=b64.js.map

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function () {
    return function spritesheetParser(resource, next) {
        var imageResourceName = resource.name + '_image';

        // skip if no data, its not json, it isn't spritesheet data, or the image resource already exists
        if (!resource.data || resource.type !== _resourceLoader.Resource.TYPE.JSON || !resource.data.frames || this.resources[imageResourceName]) {
            next();

            return;
        }

        var loadOptions = {
            crossOrigin: resource.crossOrigin,
            metadata: resource.metadata.imageMetadata,
            parentResource: resource
        };

        var resourcePath = getResourcePath(resource, this.baseUrl);

        // load the image for this sheet
        this.add(imageResourceName, resourcePath, loadOptions, function onImageLoad(res) {
            if (res.error) {
                next(res.error);

                return;
            }

            var spritesheet = new _core.Spritesheet(res.texture.baseTexture, resource.data, resource.url);

            spritesheet.parse(function () {
                resource.spritesheet = spritesheet;
                resource.textures = spritesheet.textures;
                next();
            });
        });
    };
};

exports.getResourcePath = getResourcePath;

var _resourceLoader = __webpack_require__(87);

var _url = __webpack_require__(132);

var _url2 = _interopRequireDefault(_url);

var _core = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getResourcePath(resource, baseUrl) {
    // Prepend url path unless the resource image is a data url
    if (resource.isDataUrl) {
        return resource.data.meta.image;
    }

    return _url2.default.resolve(resource.url.replace(baseUrl, ''), resource.data.meta.image);
}
//# sourceMappingURL=spritesheetParser.js.map

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function () {
    return function textureParser(resource, next) {
        // create a new texture if the data is an Image object
        if (resource.data && resource.type === _resourceLoader.Resource.TYPE.IMAGE) {
            resource.texture = _Texture2.default.fromLoader(resource.data, resource.url, resource.name);
        }
        next();
    };
};

var _resourceLoader = __webpack_require__(87);

var _Texture = __webpack_require__(49);

var _Texture2 = _interopRequireDefault(_Texture);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=textureParser.js.map

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _Mesh2 = __webpack_require__(88);

var _Mesh3 = _interopRequireDefault(_Mesh2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The Plane allows you to draw a texture across several points and them manipulate these points
 *
 *```js
 * for (let i = 0; i < 20; i++) {
 *     points.push(new PIXI.Point(i * 50, 0));
 * };
 * let Plane = new PIXI.Plane(PIXI.Texture.fromImage("snake.png"), points);
 *  ```
 *
 * @class
 * @extends PIXI.mesh.Mesh
 * @memberof PIXI.mesh
 *
 */
var Plane = function (_Mesh) {
    _inherits(Plane, _Mesh);

    /**
     * @param {PIXI.Texture} texture - The texture to use on the Plane.
     * @param {number} [verticesX=10] - The number of vertices in the x-axis
     * @param {number} [verticesY=10] - The number of vertices in the y-axis
     */
    function Plane(texture, verticesX, verticesY) {
        _classCallCheck(this, Plane);

        /**
         * Tracker for if the Plane is ready to be drawn. Needed because Mesh ctor can
         * call _onTextureUpdated which could call refresh too early.
         *
         * @member {boolean}
         * @private
         */
        var _this = _possibleConstructorReturn(this, _Mesh.call(this, texture));

        _this._ready = true;

        _this.verticesX = verticesX || 10;
        _this.verticesY = verticesY || 10;

        _this.drawMode = _Mesh3.default.DRAW_MODES.TRIANGLES;
        _this.refresh();
        return _this;
    }

    /**
     * Refreshes plane coordinates
     *
     */


    Plane.prototype._refresh = function _refresh() {
        var texture = this._texture;
        var total = this.verticesX * this.verticesY;
        var verts = [];
        var colors = [];
        var uvs = [];
        var indices = [];

        var segmentsX = this.verticesX - 1;
        var segmentsY = this.verticesY - 1;

        var sizeX = texture.width / segmentsX;
        var sizeY = texture.height / segmentsY;

        for (var i = 0; i < total; i++) {
            var x = i % this.verticesX;
            var y = i / this.verticesX | 0;

            verts.push(x * sizeX, y * sizeY);

            uvs.push(x / segmentsX, y / segmentsY);
        }

        //  cons

        var totalSub = segmentsX * segmentsY;

        for (var _i = 0; _i < totalSub; _i++) {
            var xpos = _i % segmentsX;
            var ypos = _i / segmentsX | 0;

            var value = ypos * this.verticesX + xpos;
            var value2 = ypos * this.verticesX + xpos + 1;
            var value3 = (ypos + 1) * this.verticesX + xpos;
            var value4 = (ypos + 1) * this.verticesX + xpos + 1;

            indices.push(value, value2, value3);
            indices.push(value2, value4, value3);
        }

        // console.log(indices)
        this.vertices = new Float32Array(verts);
        this.uvs = new Float32Array(uvs);
        this.colors = new Float32Array(colors);
        this.indices = new Uint16Array(indices);

        this.dirty++;
        this.indexDirty++;

        this.multiplyUvs();
    };

    /**
     * Clear texture UVs when new texture is set
     *
     * @private
     */


    Plane.prototype._onTextureUpdate = function _onTextureUpdate() {
        _Mesh3.default.prototype._onTextureUpdate.call(this);

        // wait for the Plane ctor to finish before calling refresh
        if (this._ready) {
            this.refresh();
        }
    };

    return Plane;
}(_Mesh3.default);

exports.default = Plane;
//# sourceMappingURL=Plane.js.map

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * CountLimiter limits the number of items handled by a {@link PIXI.prepare.BasePrepare} to a specified
 * number of items per frame.
 *
 * @class
 * @memberof PIXI
 */
var CountLimiter = function () {
  /**
   * @param {number} maxItemsPerFrame - The maximum number of items that can be prepared each frame.
   */
  function CountLimiter(maxItemsPerFrame) {
    _classCallCheck(this, CountLimiter);

    /**
     * The maximum number of items that can be prepared each frame.
     * @private
     */
    this.maxItemsPerFrame = maxItemsPerFrame;
    /**
     * The number of items that can be prepared in the current frame.
     * @type {number}
     * @private
     */
    this.itemsLeft = 0;
  }

  /**
   * Resets any counting properties to start fresh on a new frame.
   */


  CountLimiter.prototype.beginFrame = function beginFrame() {
    this.itemsLeft = this.maxItemsPerFrame;
  };

  /**
   * Checks to see if another item can be uploaded. This should only be called once per item.
   * @return {boolean} If the item is allowed to be uploaded.
   */


  CountLimiter.prototype.allowedToUpload = function allowedToUpload() {
    return this.itemsLeft-- > 0;
  };

  return CountLimiter;
}();

exports.default = CountLimiter;
//# sourceMappingURL=CountLimiter.js.map

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(setImmediate) {/*!
 * pixi-sound - v2.1.4
 * https://github.com/pixijs/pixi-sound
 * Compiled Wed, 08 May 2019 20:12:45 UTC
 *
 * pixi-sound is licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license
 */
if("undefined"==typeof PIXI)throw"PixiJS required";var t=setTimeout;function e(){}function n(t){if(!(this instanceof n))throw new TypeError("Promises must be constructed via new");if("function"!=typeof t)throw new TypeError("not a function");this._state=0,this._handled=!1,this._value=void 0,this._deferreds=[],a(t,this)}function o(t,e){for(;3===t._state;)t=t._value;0!==t._state?(t._handled=!0,n._immediateFn(function(){var n=1===t._state?e.onFulfilled:e.onRejected;if(null!==n){var o;try{o=n(t._value)}catch(t){return void r(e.promise,t)}i(e.promise,o)}else(1===t._state?i:r)(e.promise,t._value)})):t._deferreds.push(e)}function i(t,e){try{if(e===t)throw new TypeError("A promise cannot be resolved with itself.");if(e&&("object"==typeof e||"function"==typeof e)){var o=e.then;if(e instanceof n)return t._state=3,t._value=e,void s(t);if("function"==typeof o)return void a((i=o,u=e,function(){i.apply(u,arguments)}),t)}t._state=1,t._value=e,s(t)}catch(e){r(t,e)}var i,u}function r(t,e){t._state=2,t._value=e,s(t)}function s(t){2===t._state&&0===t._deferreds.length&&n._immediateFn(function(){t._handled||n._unhandledRejectionFn(t._value)});for(var e=0,i=t._deferreds.length;e<i;e++)o(t,t._deferreds[e]);t._deferreds=null}function u(t,e,n){this.onFulfilled="function"==typeof t?t:null,this.onRejected="function"==typeof e?e:null,this.promise=n}function a(t,e){var n=!1;try{t(function(t){n||(n=!0,i(e,t))},function(t){n||(n=!0,r(e,t))})}catch(t){if(n)return;n=!0,r(e,t)}}n.prototype.catch=function(t){return this.then(null,t)},n.prototype.then=function(t,n){var i=new this.constructor(e);return o(this,new u(t,n,i)),i},n.prototype.finally=function(t){var e=this.constructor;return this.then(function(n){return e.resolve(t()).then(function(){return n})},function(n){return e.resolve(t()).then(function(){return e.reject(n)})})},n.all=function(t){return new n(function(e,n){if(!t||void 0===t.length)throw new TypeError("Promise.all accepts an array");var o=Array.prototype.slice.call(t);if(0===o.length)return e([]);var i=o.length;function r(t,s){try{if(s&&("object"==typeof s||"function"==typeof s)){var u=s.then;if("function"==typeof u)return void u.call(s,function(e){r(t,e)},n)}o[t]=s,0==--i&&e(o)}catch(t){n(t)}}for(var s=0;s<o.length;s++)r(s,o[s])})},n.resolve=function(t){return t&&"object"==typeof t&&t.constructor===n?t:new n(function(e){e(t)})},n.reject=function(t){return new n(function(e,n){n(t)})},n.race=function(t){return new n(function(e,n){for(var o=0,i=t.length;o<i;o++)t[o].then(e,n)})},n._immediateFn="function"==typeof setImmediate&&function(t){setImmediate(t)}||function(e){t(e,0)},n._unhandledRejectionFn=function(t){"undefined"!=typeof console&&console};var c=function(){function t(t,e){this._output=e,this._input=t}return Object.defineProperty(t.prototype,"destination",{get:function(){return this._input},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"filters",{get:function(){return this._filters},set:function(t){var e=this;if(this._filters&&(this._filters.forEach(function(t){t&&t.disconnect()}),this._filters=null,this._input.connect(this._output)),t&&t.length){this._filters=t.slice(0),this._input.disconnect();var n=null;t.forEach(function(t){null===n?e._input.connect(t.destination):n.connect(t.destination),n=t}),n.connect(this._output)}},enumerable:!0,configurable:!0}),t.prototype.destroy=function(){this.filters=null,this._input=null,this._output=null},t}(),l=function(){function t(t,e){this.init(t,e)}return t.prototype.init=function(t,e){this.destination=t,this.source=e||t},t.prototype.connect=function(t){this.source.connect(t)},t.prototype.disconnect=function(){this.source.disconnect()},t.prototype.destroy=function(){this.disconnect(),this.destination=null,this.source=null},t}(),p=function(t,e){return(p=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])})(t,e)};function h(t,e){function n(){this.constructor=t}p(t,e),t.prototype=null===e?Object.create(e):(n.prototype=e.prototype,new n)}var f,d=function(){return(d=Object.assign||function(t){for(var e,n=1,o=arguments.length;n<o;n++)for(var i in e=arguments[n])Object.prototype.hasOwnProperty.call(e,i)&&(t[i]=e[i]);return t}).apply(this,arguments)};function _(){return f}var y=function(){function t(){}return t.setParamValue=function(t,e){if(t.setValueAtTime){var n=_().context;t.setValueAtTime(e,n.audioContext.currentTime)}else t.value=e;return e},t}(),m=0,g=function(t){function e(e){var n=t.call(this)||this;return n.id=m++,n._media=null,n._paused=!1,n._muted=!1,n._elapsed=0,n.init(e),n}return h(e,t),e.prototype.stop=function(){this._source&&(this._internalStop(),this.emit("stop"))},Object.defineProperty(e.prototype,"speed",{get:function(){return this._speed},set:function(t){this._speed=t,this.refresh(),this._update(!0)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"volume",{get:function(){return this._volume},set:function(t){this._volume=t,this.refresh()},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"muted",{get:function(){return this._muted},set:function(t){this._muted=t,this.refresh()},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"loop",{get:function(){return this._loop},set:function(t){this._loop=t,this.refresh()},enumerable:!0,configurable:!0}),e.prototype.refresh=function(){if(this._source){var t=this._media.context,e=this._media.parent;this._source.loop=this._loop||e.loop;var n=t.volume*(t.muted?0:1),o=e.volume*(e.muted?0:1),i=this._volume*(this._muted?0:1);y.setParamValue(this._gain.gain,i*o*n),y.setParamValue(this._source.playbackRate,this._speed*e.speed*t.speed)}},e.prototype.refreshPaused=function(){var t=this._media.context,e=this._media.parent,n=this._paused||e.paused||t.paused;n!==this._pausedReal&&(this._pausedReal=n,n?(this._internalStop(),this.emit("paused")):(this.emit("resumed"),this.play({start:this._elapsed%this._duration,end:this._end,speed:this._speed,loop:this._loop,volume:this._volume})),this.emit("pause",n))},e.prototype.play=function(t){var e=t.start,n=t.end,o=t.speed,i=t.loop,r=t.volume,s=t.muted;this._paused=!1;var u=this._media.nodes.cloneBufferSource(),a=u.source,c=u.gain;this._source=a,this._gain=c,this._speed=o,this._volume=r,this._loop=!!i,this._muted=s,this.refresh();var l=this._source.buffer.duration;this._duration=l,this._end=n,this._lastUpdate=this._now(),this._elapsed=e,this._source.onended=this._onComplete.bind(this),this._loop?(this._source.loopEnd=n,this._source.loopStart=e,this._source.start(0,e)):n?this._source.start(0,e,n-e):this._source.start(0,e),this.emit("start"),this._update(!0),this._enabled=!0},e.prototype._toSec=function(t){return t>10&&(t/=1e3),t||0},Object.defineProperty(e.prototype,"_enabled",{set:function(t){PIXI.ticker.shared.remove(this._updateListener,this),t&&PIXI.ticker.shared.add(this._updateListener,this)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"progress",{get:function(){return this._progress},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"paused",{get:function(){return this._paused},set:function(t){this._paused=t,this.refreshPaused()},enumerable:!0,configurable:!0}),e.prototype.destroy=function(){this.removeAllListeners(),this._internalStop(),this._source&&(this._source.disconnect(),this._source=null),this._gain&&(this._gain.disconnect(),this._gain=null),this._media&&(this._media.context.events.off("refresh",this.refresh,this),this._media.context.events.off("refreshPaused",this.refreshPaused,this),this._media=null),this._end=null,this._speed=1,this._volume=1,this._loop=!1,this._elapsed=0,this._duration=0,this._paused=!1,this._muted=!1,this._pausedReal=!1},e.prototype.toString=function(){return"[WebAudioInstance id="+this.id+"]"},e.prototype._now=function(){return this._media.context.audioContext.currentTime},e.prototype._updateListener=function(){this._update()},e.prototype._update=function(t){if(void 0===t&&(t=!1),this._source){var e=this._now(),n=e-this._lastUpdate;if(n>0||t){var o=this._source.playbackRate.value;this._elapsed+=n*o,this._lastUpdate=e;var i=this._duration,r=void 0;if(this._source.loopStart){var s=this._source.loopEnd-this._source.loopStart;r=(this._source.loopStart+this._elapsed%s)/i}else r=this._elapsed%i/i;this._progress=r,this.emit("progress",this._progress,i)}}},e.prototype.init=function(t){this._media=t,t.context.events.on("refresh",this.refresh,this),t.context.events.on("refreshPaused",this.refreshPaused,this)},e.prototype._internalStop=function(){this._source&&(this._enabled=!1,this._source.onended=null,this._source.stop(0),this._source=null)},e.prototype._onComplete=function(){this._source&&(this._enabled=!1,this._source.onended=null),this._source=null,this._progress=1,this.emit("progress",1,this._duration),this.emit("end",this)},e}(PIXI.utils.EventEmitter),b=function(t){function e(e){var n=this,o=e.audioContext,i=o.createBufferSource(),r=o.createGain(),s=o.createAnalyser();return i.connect(s),s.connect(r),r.connect(e.destination),(n=t.call(this,s,r)||this).context=e,n.bufferSource=i,n.gain=r,n.analyser=s,n}return h(e,t),Object.defineProperty(e.prototype,"script",{get:function(){return this._script||(this._script=this.context.audioContext.createScriptProcessor(e.BUFFER_SIZE),this._script.connect(this.context.destination)),this._script},enumerable:!0,configurable:!0}),e.prototype.destroy=function(){t.prototype.destroy.call(this),this.bufferSource.disconnect(),this._script&&this._script.disconnect(),this.gain.disconnect(),this.analyser.disconnect(),this.bufferSource=null,this._script=null,this.gain=null,this.analyser=null,this.context=null},e.prototype.cloneBufferSource=function(){var t=this.bufferSource,e=this.context.audioContext.createBufferSource();e.buffer=t.buffer,y.setParamValue(e.playbackRate,t.playbackRate.value),e.loop=t.loop;var n=this.context.audioContext.createGain();return e.connect(n),n.connect(this.destination),{source:e,gain:n}},Object.defineProperty(e.prototype,"bufferSize",{get:function(){return this.script.bufferSize},enumerable:!0,configurable:!0}),e.BUFFER_SIZE=0,e}(c),v=function(){function t(){}return t.prototype.init=function(t){this.parent=t,this._nodes=new b(this.context),this._source=this._nodes.bufferSource,this.source=t.options.source},t.prototype.destroy=function(){this.parent=null,this._nodes.destroy(),this._nodes=null,this._source=null,this.source=null},t.prototype.create=function(){return new g(this)},Object.defineProperty(t.prototype,"context",{get:function(){return this.parent.context},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"isPlayable",{get:function(){return!!this._source&&!!this._source.buffer},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"filters",{get:function(){return this._nodes.filters},set:function(t){this._nodes.filters=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"duration",{get:function(){return this._source.buffer.duration},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"buffer",{get:function(){return this._source.buffer},set:function(t){this._source.buffer=t},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"nodes",{get:function(){return this._nodes},enumerable:!0,configurable:!0}),t.prototype.load=function(t){this.source?this._decode(this.source,t):this.parent.url?this._loadUrl(t):t&&t(new Error("sound.url or sound.source must be set"))},t.prototype._loadUrl=function(t){var e=this,n=new XMLHttpRequest,o=this.parent.url;n.open("GET",o,!0),n.responseType="arraybuffer",n.onload=function(){e.source=n.response,e._decode(n.response,t)},n.send()},t.prototype._decode=function(t,e){var n=this;this.parent.context.decode(t,function(t,o){if(t)e&&e(t);else{n.parent.isLoaded=!0,n.buffer=o;var i=n.parent.autoPlayStart();e&&e(null,n.parent,i)}})},t}(),P=function(t){function e(){var n=this,o=window,i=new e.AudioContext,r=i.createDynamicsCompressor(),s=i.createAnalyser();return s.connect(r),r.connect(i.destination),(n=t.call(this,s,r)||this)._ctx=i,n._offlineCtx=new e.OfflineAudioContext(1,2,o.OfflineAudioContext?i.sampleRate:44100),n._unlocked=!1,n.compressor=r,n.analyser=s,n.events=new PIXI.utils.EventEmitter,n.volume=1,n.speed=1,n.muted=!1,n.paused=!1,"running"!==i.state&&(n._unlock(),n._unlock=n._unlock.bind(n),document.addEventListener("mousedown",n._unlock,!0),document.addEventListener("touchstart",n._unlock,!0),document.addEventListener("touchend",n._unlock,!0)),n}return h(e,t),e.prototype._unlock=function(){this._unlocked||(this.playEmptySound(),"running"===this._ctx.state&&(document.removeEventListener("mousedown",this._unlock,!0),document.removeEventListener("touchend",this._unlock,!0),document.removeEventListener("touchstart",this._unlock,!0),this._unlocked=!0))},e.prototype.playEmptySound=function(){var t=this._ctx.createBufferSource();t.buffer=this._ctx.createBuffer(1,1,22050),t.connect(this._ctx.destination),t.start(0,0,0),"suspended"===t.context.state&&t.context.resume()},Object.defineProperty(e,"AudioContext",{get:function(){var t=window;return t.AudioContext||t.webkitAudioContext||null},enumerable:!0,configurable:!0}),Object.defineProperty(e,"OfflineAudioContext",{get:function(){var t=window;return t.OfflineAudioContext||t.webkitOfflineAudioContext||null},enumerable:!0,configurable:!0}),e.prototype.destroy=function(){t.prototype.destroy.call(this);var e=this._ctx;void 0!==e.close&&e.close(),this.events.removeAllListeners(),this.analyser.disconnect(),this.compressor.disconnect(),this.analyser=null,this.compressor=null,this.events=null,this._offlineCtx=null,this._ctx=null},Object.defineProperty(e.prototype,"audioContext",{get:function(){return this._ctx},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"offlineContext",{get:function(){return this._offlineCtx},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"paused",{get:function(){return this._paused},set:function(t){t&&"running"===this._ctx.state?this._ctx.suspend():t||"suspended"!==this._ctx.state||this._ctx.resume(),this._paused=t},enumerable:!0,configurable:!0}),e.prototype.refresh=function(){this.events.emit("refresh")},e.prototype.refreshPaused=function(){this.events.emit("refreshPaused")},e.prototype.toggleMute=function(){return this.muted=!this.muted,this.refresh(),this.muted},e.prototype.togglePause=function(){return this.paused=!this.paused,this.refreshPaused(),this._paused},e.prototype.decode=function(t,e){this._offlineCtx.decodeAudioData(t,function(t){e(null,t)},function(t){e(new Error(t.message||"Unable to decode file"))})},e}(c),x=Object.freeze({WebAudioMedia:v,WebAudioInstance:g,WebAudioNodes:b,WebAudioContext:P,WebAudioUtils:y}),O=function(t){function e(n,o,i,r,s,u,a,c,l,p){void 0===n&&(n=0),void 0===o&&(o=0),void 0===i&&(i=0),void 0===r&&(r=0),void 0===s&&(s=0),void 0===u&&(u=0),void 0===a&&(a=0),void 0===c&&(c=0),void 0===l&&(l=0),void 0===p&&(p=0);var h=this;if(!_().useLegacy){var f=[{f:e.F32,type:"lowshelf",gain:n},{f:e.F64,type:"peaking",gain:o},{f:e.F125,type:"peaking",gain:i},{f:e.F250,type:"peaking",gain:r},{f:e.F500,type:"peaking",gain:s},{f:e.F1K,type:"peaking",gain:u},{f:e.F2K,type:"peaking",gain:a},{f:e.F4K,type:"peaking",gain:c},{f:e.F8K,type:"peaking",gain:l},{f:e.F16K,type:"highshelf",gain:p}].map(function(t){var e=_().context.audioContext.createBiquadFilter();return e.type=t.type,y.setParamValue(e.Q,1),e.frequency.value=t.f,y.setParamValue(e.gain,t.gain),e});(h=t.call(this,f[0],f[f.length-1])||this).bands=f,h.bandsMap={};for(var d=0;d<h.bands.length;d++){var m=h.bands[d];d>0&&h.bands[d-1].connect(m),h.bandsMap[m.frequency.value]=m}return h}h=t.call(this,null)||this}return h(e,t),e.prototype.setGain=function(t,e){if(void 0===e&&(e=0),!this.bandsMap[t])throw new Error("No band found for frequency "+t);y.setParamValue(this.bandsMap[t].gain,e)},e.prototype.getGain=function(t){if(!this.bandsMap[t])throw new Error("No band found for frequency "+t);return this.bandsMap[t].gain.value},Object.defineProperty(e.prototype,"f32",{get:function(){return this.getGain(e.F32)},set:function(t){this.setGain(e.F32,t)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"f64",{get:function(){return this.getGain(e.F64)},set:function(t){this.setGain(e.F64,t)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"f125",{get:function(){return this.getGain(e.F125)},set:function(t){this.setGain(e.F125,t)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"f250",{get:function(){return this.getGain(e.F250)},set:function(t){this.setGain(e.F250,t)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"f500",{get:function(){return this.getGain(e.F500)},set:function(t){this.setGain(e.F500,t)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"f1k",{get:function(){return this.getGain(e.F1K)},set:function(t){this.setGain(e.F1K,t)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"f2k",{get:function(){return this.getGain(e.F2K)},set:function(t){this.setGain(e.F2K,t)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"f4k",{get:function(){return this.getGain(e.F4K)},set:function(t){this.setGain(e.F4K,t)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"f8k",{get:function(){return this.getGain(e.F8K)},set:function(t){this.setGain(e.F8K,t)},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"f16k",{get:function(){return this.getGain(e.F16K)},set:function(t){this.setGain(e.F16K,t)},enumerable:!0,configurable:!0}),e.prototype.reset=function(){this.bands.forEach(function(t){y.setParamValue(t.gain,0)})},e.prototype.destroy=function(){this.bands.forEach(function(t){t.disconnect()}),this.bands=null,this.bandsMap=null},e.F32=32,e.F64=64,e.F125=125,e.F250=250,e.F500=500,e.F1K=1e3,e.F2K=2e3,e.F4K=4e3,e.F8K=8e3,e.F16K=16e3,e}(l),j=function(t){function e(e){void 0===e&&(e=0);var n=this;if(!_().useLegacy){var o=_().context.audioContext.createWaveShaper();return(n=t.call(this,o)||this)._distortion=o,n.amount=e,n}n=t.call(this,null)||this}return h(e,t),Object.defineProperty(e.prototype,"amount",{get:function(){return this._amount},set:function(t){t*=1e3,this._amount=t;for(var e,n=new Float32Array(44100),o=Math.PI/180,i=0;i<44100;++i)e=2*i/44100-1,n[i]=(3+t)*e*20*o/(Math.PI+t*Math.abs(e));this._distortion.curve=n,this._distortion.oversample="4x"},enumerable:!0,configurable:!0}),e.prototype.destroy=function(){this._distortion=null,t.prototype.destroy.call(this)},e}(l),w=function(t){function e(e){void 0===e&&(e=0);var n=this;if(!_().useLegacy){var o,i,r,s=_().context.audioContext;return s.createStereoPanner?r=o=s.createStereoPanner():((i=s.createPanner()).panningModel="equalpower",r=i),(n=t.call(this,r)||this)._stereo=o,n._panner=i,n.pan=e,n}n=t.call(this,null)||this}return h(e,t),Object.defineProperty(e.prototype,"pan",{get:function(){return this._pan},set:function(t){this._pan=t,this._stereo?y.setParamValue(this._stereo.pan,t):this._panner.setPosition(t,0,1-Math.abs(t))},enumerable:!0,configurable:!0}),e.prototype.destroy=function(){t.prototype.destroy.call(this),this._stereo=null,this._panner=null},e}(l),E=function(t){function e(e,n,o){void 0===e&&(e=3),void 0===n&&(n=2),void 0===o&&(o=!1);var i=this;if(!_().useLegacy)return(i=t.call(this,null)||this)._seconds=i._clamp(e,1,50),i._decay=i._clamp(n,0,100),i._reverse=o,i._rebuild(),i;i=t.call(this,null)||this}return h(e,t),e.prototype._clamp=function(t,e,n){return Math.min(n,Math.max(e,t))},Object.defineProperty(e.prototype,"seconds",{get:function(){return this._seconds},set:function(t){this._seconds=this._clamp(t,1,50),this._rebuild()},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"decay",{get:function(){return this._decay},set:function(t){this._decay=this._clamp(t,0,100),this._rebuild()},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"reverse",{get:function(){return this._reverse},set:function(t){this._reverse=t,this._rebuild()},enumerable:!0,configurable:!0}),e.prototype._rebuild=function(){for(var t,e=_().context.audioContext,n=e.sampleRate,o=n*this._seconds,i=e.createBuffer(2,o,n),r=i.getChannelData(0),s=i.getChannelData(1),u=0;u<o;u++)t=this._reverse?o-u:u,r[u]=(2*Math.random()-1)*Math.pow(1-t/o,this._decay),s[u]=(2*Math.random()-1)*Math.pow(1-t/o,this._decay);var a=_().context.audioContext.createConvolver();a.buffer=i,this.init(a)},e}(l),I=function(t){function e(){var e=this;if(!_().useLegacy){var n=_().context.audioContext,o=n.createChannelSplitter(),i=n.createChannelMerger();return i.connect(o),(e=t.call(this,i,o)||this)._merger=i,e}e=t.call(this,null)||this}return h(e,t),e.prototype.destroy=function(){this._merger.disconnect(),this._merger=null,t.prototype.destroy.call(this)},e}(l),A=function(t){function e(){if(!_().useLegacy){var e=_().context.audioContext,n=e.createBiquadFilter(),o=e.createBiquadFilter(),i=e.createBiquadFilter(),r=e.createBiquadFilter();return n.type="lowpass",y.setParamValue(n.frequency,2e3),o.type="lowpass",y.setParamValue(o.frequency,2e3),i.type="highpass",y.setParamValue(i.frequency,500),r.type="highpass",y.setParamValue(r.frequency,500),n.connect(o),o.connect(i),i.connect(r),t.call(this,n,r)||this}t.call(this,null)}return h(e,t),e}(l),F=Object.freeze({Filter:l,EqualizerFilter:O,DistortionFilter:j,StereoFilter:w,ReverbFilter:E,MonoFilter:I,TelephoneFilter:A}),S=0,C=function(t){function e(e){var n=t.call(this)||this;return n.id=S++,n.init(e),n}return h(e,t),Object.defineProperty(e.prototype,"progress",{get:function(){return this._source.currentTime/this._duration},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"paused",{get:function(){return this._paused},set:function(t){this._paused=t,this.refreshPaused()},enumerable:!0,configurable:!0}),e.prototype._onPlay=function(){this._playing=!0},e.prototype._onPause=function(){this._playing=!1},e.prototype.init=function(t){this._playing=!1,this._duration=t.source.duration;var e=this._source=t.source.cloneNode(!1);e.src=t.parent.url,e.onplay=this._onPlay.bind(this),e.onpause=this._onPause.bind(this),t.context.on("refresh",this.refresh,this),t.context.on("refreshPaused",this.refreshPaused,this),this._media=t},e.prototype._internalStop=function(){this._source&&this._playing&&(this._source.onended=null,this._source.pause())},e.prototype.stop=function(){this._internalStop(),this._source&&this.emit("stop")},Object.defineProperty(e.prototype,"speed",{get:function(){return this._speed},set:function(t){this._speed=t,this.refresh()},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"volume",{get:function(){return this._volume},set:function(t){this._volume=t,this.refresh()},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"loop",{get:function(){return this._loop},set:function(t){this._loop=t,this.refresh()},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"muted",{get:function(){return this._muted},set:function(t){this._muted=t,this.refresh()},enumerable:!0,configurable:!0}),e.prototype.refresh=function(){var t=this._media.context,e=this._media.parent;this._source.loop=this._loop||e.loop;var n=t.volume*(t.muted?0:1),o=e.volume*(e.muted?0:1),i=this._volume*(this._muted?0:1);this._source.volume=i*n*o,this._source.playbackRate=this._speed*t.speed*e.speed},e.prototype.refreshPaused=function(){var t=this._media.context,e=this._media.parent,n=this._paused||e.paused||t.paused;n!==this._pausedReal&&(this._pausedReal=n,n?(this._internalStop(),this.emit("paused")):(this.emit("resumed"),this.play({start:this._source.currentTime,end:this._end,volume:this._volume,speed:this._speed,loop:this._loop})),this.emit("pause",n))},e.prototype.play=function(t){var n=this,o=t.start,i=t.end,r=t.speed,s=t.loop,u=t.volume,a=t.muted;this._speed=r,this._volume=u,this._loop=!!s,this._muted=a,this.refresh(),this.loop&&null!==i&&(this.loop=!1),this._start=o,this._end=i||this._duration,this._start=Math.max(0,this._start-e.PADDING),this._end=Math.min(this._end+e.PADDING,this._duration),this._source.onloadedmetadata=function(){n._source&&(n._source.currentTime=o,n._source.onloadedmetadata=null,n.emit("progress",o,n._duration),PIXI.ticker.shared.add(n._onUpdate,n))},this._source.onended=this._onComplete.bind(this),this._source.play(),this.emit("start")},e.prototype._onUpdate=function(){this.emit("progress",this.progress,this._duration),this._source.currentTime>=this._end&&!this._source.loop&&this._onComplete()},e.prototype._onComplete=function(){PIXI.ticker.shared.remove(this._onUpdate,this),this._internalStop(),this.emit("progress",1,this._duration),this.emit("end",this)},e.prototype.destroy=function(){PIXI.ticker.shared.remove(this._onUpdate,this),this.removeAllListeners();var t=this._source;t&&(t.onended=null,t.onplay=null,t.onpause=null,this._internalStop()),this._source=null,this._speed=1,this._volume=1,this._loop=!1,this._end=null,this._start=0,this._duration=0,this._playing=!1,this._pausedReal=!1,this._paused=!1,this._muted=!1,this._media&&(this._media.context.off("refresh",this.refresh,this),this._media.context.off("refreshPaused",this.refreshPaused,this),this._media=null)},e.prototype.toString=function(){return"[HTMLAudioInstance id="+this.id+"]"},e.PADDING=.1,e}(PIXI.utils.EventEmitter),L=function(t){function e(){return null!==t&&t.apply(this,arguments)||this}return h(e,t),e.prototype.init=function(t){this.parent=t,this._source=t.options.source||new Audio,t.url&&(this._source.src=t.url)},e.prototype.create=function(){return new C(this)},Object.defineProperty(e.prototype,"isPlayable",{get:function(){return!!this._source&&4===this._source.readyState},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"duration",{get:function(){return this._source.duration},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"context",{get:function(){return this.parent.context},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"filters",{get:function(){return null},set:function(t){},enumerable:!0,configurable:!0}),e.prototype.destroy=function(){this.removeAllListeners(),this.parent=null,this._source&&(this._source.src="",this._source.load(),this._source=null)},Object.defineProperty(e.prototype,"source",{get:function(){return this._source},enumerable:!0,configurable:!0}),e.prototype.load=function(t){var e=this._source,n=this.parent;if(4!==e.readyState){if(!n.url)return t(new Error("sound.url or sound.source must be set"));e.src=n.url;var o=function(){e.removeEventListener("canplaythrough",i),e.removeEventListener("load",i),e.removeEventListener("abort",r),e.removeEventListener("error",s)},i=function(){o(),n.isLoaded=!0;var e=n.autoPlayStart();t&&t(null,n,e)},r=function(){o(),t&&t(new Error("Sound loading has been aborted"))},s=function(){o();var n="Failed to load audio element (code: "+e.error.code+")";t&&t(new Error(n))};e.addEventListener("canplaythrough",i,!1),e.addEventListener("load",i,!1),e.addEventListener("abort",r,!1),e.addEventListener("error",s,!1),e.load()}else{n.isLoaded=!0;var u=n.autoPlayStart();t&&setTimeout(function(){t(null,n,u)},0)}},e}(PIXI.utils.EventEmitter),M=function(t){function e(){var e=t.call(this)||this;return e.speed=1,e.volume=1,e.muted=!1,e.paused=!1,e}return h(e,t),e.prototype.refresh=function(){this.emit("refresh")},e.prototype.refreshPaused=function(){this.emit("refreshPaused")},Object.defineProperty(e.prototype,"filters",{get:function(){return null},set:function(t){},enumerable:!0,configurable:!0}),Object.defineProperty(e.prototype,"audioContext",{get:function(){return null},enumerable:!0,configurable:!0}),e.prototype.toggleMute=function(){return this.muted=!this.muted,this.refresh(),this.muted},e.prototype.togglePause=function(){return this.paused=!this.paused,this.refreshPaused(),this.paused},e.prototype.destroy=function(){this.removeAllListeners()},e}(PIXI.utils.EventEmitter),k=Object.freeze({HTMLAudioMedia:L,HTMLAudioInstance:C,HTMLAudioContext:M}),T=["mp3","ogg","oga","opus","mpeg","wav","m4a","aiff","wma","mid"];var R,G,X,K,B=(R={m4a:"mp4",oga:"ogg"},G=document.createElement("audio"),X={},K=/^no$/,T.forEach(function(t){var e=R[t]||t,n=G.canPlayType("audio/"+t).replace(K,""),o=G.canPlayType("audio/"+e).replace(K,"");X[t]=!!n||!!o}),Object.freeze(X)),D=/\.(\{([^\}]+)\})(\?.*)?$/;function q(t){var e=D,n="string"==typeof t?t:t.url;if(e.test(n)){for(var o=e.exec(n),i=o[2].split(","),r=i[i.length-1],s=0,u=i.length;s<u;s++){var a=i[s];if(B[a]){r=a;break}}var c=n.replace(o[1],r);return"string"!=typeof t&&(t.extension=r,t.url=c),c}return n}var U=function(){function t(){}return t.add=function(){t.legacy=_().useLegacy},Object.defineProperty(t,"legacy",{set:function(t){var e=PIXI.loaders.Resource,n=T;t?n.forEach(function(t){e.setExtensionXhrType(t,e.XHR_RESPONSE_TYPE.DEFAULT),e.setExtensionLoadType(t,e.LOAD_TYPE.AUDIO)}):n.forEach(function(t){e.setExtensionXhrType(t,e.XHR_RESPONSE_TYPE.BUFFER),e.setExtensionLoadType(t,e.LOAD_TYPE.XHR)})},enumerable:!0,configurable:!0}),t.pre=function(t,e){q(t),e()},t.use=function(t,e){t.data&&T.indexOf(t.extension)>-1?t.sound=_().add(t.name,{loaded:e,preload:!0,url:t.url,source:t.data}):e()},t}(),V=function(t){function e(e,n){var o=t.call(this,e,n)||this;return o.use(U.use),o.pre(U.pre),o}return h(e,t),e.addPixiMiddleware=function(e){t.addPixiMiddleware.call(this,e)},e}(PIXI.loaders.Loader),H=function(){function t(t,e){this.parent=t,Object.assign(this,e),this.duration=this.end-this.start}return t.prototype.play=function(t){return this.parent.play({complete:t,speed:this.speed||this.parent.speed,end:this.end,start:this.start,loop:this.loop})},t.prototype.destroy=function(){this.parent=null},t}(),N=function(){function t(t,e){this.media=t,this.options=e,this._instances=[],this._sprites={},this.media.init(this);var n=e.complete;this._autoPlayOptions=n?{complete:n}:null,this.isLoaded=!1,this.isPlaying=!1,this.autoPlay=e.autoPlay,this.singleInstance=e.singleInstance,this.preload=e.preload||this.autoPlay,this.url=e.url,this.speed=e.speed,this.volume=e.volume,this.loop=e.loop,e.sprites&&this.addSprites(e.sprites),this.preload&&this._preload(e.loaded)}return t.from=function(e){var n={};return"string"==typeof e?n.url=e:e instanceof ArrayBuffer||e instanceof HTMLAudioElement?n.source=e:n=e,(n=d({autoPlay:!1,singleInstance:!1,url:null,source:null,preload:!1,volume:1,speed:1,complete:null,loaded:null,loop:!1},n)).url&&(n.url=q(n.url)),Object.freeze(n),new t(_().useLegacy?new L:new v,n)},Object.defineProperty(t.prototype,"context",{get:function(){return _().context},enumerable:!0,configurable:!0}),t.prototype.pause=function(){return this.isPlaying=!1,this.paused=!0,this},t.prototype.resume=function(){return this.isPlaying=this._instances.length>0,this.paused=!1,this},Object.defineProperty(t.prototype,"paused",{get:function(){return this._paused},set:function(t){this._paused=t,this.refreshPaused()},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"speed",{get:function(){return this._speed},set:function(t){this._speed=t,this.refresh()},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"filters",{get:function(){return this.media.filters},set:function(t){this.media.filters=t},enumerable:!0,configurable:!0}),t.prototype.addSprites=function(t,e){if("object"==typeof t){var n={};for(var o in t)n[o]=this.addSprites(o,t[o]);return n}if("string"==typeof t){var i=new H(this,e);return this._sprites[t]=i,i}},t.prototype.destroy=function(){this._removeInstances(),this.removeSprites(),this.media.destroy(),this.media=null,this._sprites=null,this._instances=null},t.prototype.removeSprites=function(t){if(t){var e=this._sprites[t];void 0!==e&&(e.destroy(),delete this._sprites[t])}else for(var n in this._sprites)this.removeSprites(n);return this},Object.defineProperty(t.prototype,"isPlayable",{get:function(){return this.isLoaded&&this.media&&this.media.isPlayable},enumerable:!0,configurable:!0}),t.prototype.stop=function(){if(!this.isPlayable)return this.autoPlay=!1,this._autoPlayOptions=null,this;this.isPlaying=!1;for(var t=this._instances.length-1;t>=0;t--)this._instances[t].stop();return this},t.prototype.play=function(t,e){var n,o=this;"string"==typeof t?n={sprite:r=t,loop:this.loop,complete:e}:"function"==typeof t?(n={}).complete=t:n=t;if((n=d({complete:null,loaded:null,sprite:null,end:null,start:0,volume:1,speed:1,muted:!1,loop:!1},n||{})).sprite){var i=n.sprite,r=this._sprites[i];n.start=r.start,n.end=r.end,n.speed=r.speed||1,n.loop=r.loop||n.loop,delete n.sprite}if(n.offset&&(n.start=n.offset),!this.isLoaded)return new Promise(function(t,e){o.autoPlay=!0,o._autoPlayOptions=n,o._preload(function(o,i,r){o?e(o):(n.loaded&&n.loaded(o,i,r),t(r))})});this.singleInstance&&this._removeInstances();var s=this._createInstance();return this._instances.push(s),this.isPlaying=!0,s.once("end",function(){n.complete&&n.complete(o),o._onComplete(s)}),s.once("stop",function(){o._onComplete(s)}),s.play(n),s},t.prototype.refresh=function(){for(var t=this._instances.length,e=0;e<t;e++)this._instances[e].refresh()},t.prototype.refreshPaused=function(){for(var t=this._instances.length,e=0;e<t;e++)this._instances[e].refreshPaused()},Object.defineProperty(t.prototype,"volume",{get:function(){return this._volume},set:function(t){this._volume=t,this.refresh()},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"muted",{get:function(){return this._muted},set:function(t){this._muted=t,this.refresh()},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"loop",{get:function(){return this._loop},set:function(t){this._loop=t,this.refresh()},enumerable:!0,configurable:!0}),t.prototype._preload=function(t){this.media.load(t)},Object.defineProperty(t.prototype,"instances",{get:function(){return this._instances},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"sprites",{get:function(){return this._sprites},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"duration",{get:function(){return this.media.duration},enumerable:!0,configurable:!0}),t.prototype.autoPlayStart=function(){var t;return this.autoPlay&&(t=this.play(this._autoPlayOptions)),t},t.prototype._removeInstances=function(){for(var t=this._instances.length-1;t>=0;t--)this._poolInstance(this._instances[t]);this._instances.length=0},t.prototype._onComplete=function(t){if(this._instances){var e=this._instances.indexOf(t);e>-1&&this._instances.splice(e,1),this.isPlaying=this._instances.length>0}this._poolInstance(t)},t.prototype._createInstance=function(){if(t._pool.length>0){var e=t._pool.pop();return e.init(this.media),e}return this.media.create()},t.prototype._poolInstance=function(e){e.destroy(),t._pool.indexOf(e)<0&&t._pool.push(e)},t._pool=[],t}(),z=function(){function t(){this.init()}return t.prototype.init=function(){return this.supported&&(this._webAudioContext=new P),this._htmlAudioContext=new M,this._sounds={},this.useLegacy=!this.supported,this},Object.defineProperty(t.prototype,"context",{get:function(){return this._context},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"filtersAll",{get:function(){return this.useLegacy?[]:this._context.filters},set:function(t){this.useLegacy||(this._context.filters=t)},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"supported",{get:function(){return null!==P.AudioContext},enumerable:!0,configurable:!0}),t.prototype.add=function(t,e){if("object"==typeof t){var n={};for(var o in t){var i=this._getOptions(t[o],e);n[o]=this.add(o,i)}return n}if("string"==typeof t){if(e instanceof N)return this._sounds[t]=e,e;i=this._getOptions(e);var r=N.from(i);return this._sounds[t]=r,r}},t.prototype._getOptions=function(t,e){var n;return n="string"==typeof t?{url:t}:t instanceof ArrayBuffer||t instanceof HTMLAudioElement?{source:t}:t,n=d({},n,e||{})},Object.defineProperty(t.prototype,"useLegacy",{get:function(){return this._useLegacy},set:function(t){U.legacy=t,this._useLegacy=t,this._context=!t&&this.supported?this._webAudioContext:this._htmlAudioContext},enumerable:!0,configurable:!0}),t.prototype.remove=function(t){return this.exists(t,!0),this._sounds[t].destroy(),delete this._sounds[t],this},Object.defineProperty(t.prototype,"volumeAll",{get:function(){return this._context.volume},set:function(t){this._context.volume=t,this._context.refresh()},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"speedAll",{get:function(){return this._context.speed},set:function(t){this._context.speed=t,this._context.refresh()},enumerable:!0,configurable:!0}),t.prototype.togglePauseAll=function(){return this._context.togglePause()},t.prototype.pauseAll=function(){return this._context.paused=!0,this._context.refreshPaused(),this},t.prototype.resumeAll=function(){return this._context.paused=!1,this._context.refreshPaused(),this},t.prototype.toggleMuteAll=function(){return this._context.toggleMute()},t.prototype.muteAll=function(){return this._context.muted=!0,this._context.refresh(),this},t.prototype.unmuteAll=function(){return this._context.muted=!1,this._context.refresh(),this},t.prototype.removeAll=function(){for(var t in this._sounds)this._sounds[t].destroy(),delete this._sounds[t];return this},t.prototype.stopAll=function(){for(var t in this._sounds)this._sounds[t].stop();return this},t.prototype.exists=function(t,e){return void 0===e&&(e=!1),!!this._sounds[t]},t.prototype.find=function(t){return this.exists(t,!0),this._sounds[t]},t.prototype.play=function(t,e){return this.find(t).play(e)},t.prototype.stop=function(t){return this.find(t).stop()},t.prototype.pause=function(t){return this.find(t).pause()},t.prototype.resume=function(t){return this.find(t).resume()},t.prototype.volume=function(t,e){var n=this.find(t);return void 0!==e&&(n.volume=e),n.volume},t.prototype.speed=function(t,e){var n=this.find(t);return void 0!==e&&(n.speed=e),n.speed},t.prototype.duration=function(t){return this.find(t).duration},t.prototype.close=function(){return this.removeAll(),this._sounds=null,this._webAudioContext&&(this._webAudioContext.destroy(),this._webAudioContext=null),this._htmlAudioContext&&(this._htmlAudioContext.destroy(),this._htmlAudioContext=null),this._context=null,this},t}(),W=0;var Y=Object.freeze({get PLAY_ID(){return W},playOnce:function(t,e){var n="alias"+W++;return _().add(n,{url:t,preload:!0,autoPlay:!0,loaded:function(t){t&&(_().remove(n),e&&e(t))},complete:function(){_().remove(n),e&&e(null)}}),n},render:function(t,e){var n=document.createElement("canvas");e=d({width:512,height:128,fill:"black"},e||{}),n.width=e.width,n.height=e.height;var o=PIXI.BaseTexture.fromCanvas(n);if(!(t.media instanceof v))return o;var i=t.media,r=n.getContext("2d");r.fillStyle=e.fill;for(var s=i.buffer.getChannelData(0),u=Math.ceil(s.length/e.width),a=e.height/2,c=0;c<e.width;c++){for(var l=1,p=-1,h=0;h<u;h++){var f=s[c*u+h];f<l&&(l=f),f>p&&(p=f)}r.fillRect(c,(1+l)*a,1,Math.max(1,(p-l)*a))}return o},resolveUrl:q,sineTone:function(t,e){void 0===t&&(t=200),void 0===e&&(e=1);var n=N.from({singleInstance:!0});if(!(n.media instanceof v))return n;for(var o=n.media,i=n.context.audioContext.createBuffer(1,48e3*e,48e3),r=i.getChannelData(0),s=0;s<r.length;s++){var u=t*(s/i.sampleRate)*Math.PI;r[s]=2*Math.sin(u)}return o.buffer=i,n.isLoaded=!0,n},extensions:T,supported:B}),Z=function(t){return f=t,t}(new z),$=window,J=PIXI;if("undefined"==typeof Promise&&($.Promise=n),void 0!==PIXI.loaders){var Q=parseInt(PIXI.VERSION.split(".")[0],10);4===Q?(PIXI.loaders.Loader=V,U.add(),PIXI.loader.use(U.use),PIXI.loader.pre(U.pre)):Q>=5&&J.Loader.registerPlugin(U)}void 0===$.__pixiSound&&delete $.__pixiSound,J.sound||(Object.defineProperty(J,"sound",{get:function(){return Z}}),Object.defineProperties(Z,{Filterable:{get:function(){return c}},filters:{get:function(){return F}},htmlaudio:{get:function(){return k}},Sound:{get:function(){return N}},SoundLibrary:{get:function(){return z}},SoundSprite:{get:function(){return H}},utils:{get:function(){return Y}},webaudio:{get:function(){return x}},sound:{get:function(){return Z}}}));/* harmony default export */ __webpack_exports__["default"] = (Z);
//# sourceMappingURL=pixi-sound.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(221).setImmediate))

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(439);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var require;var require;/*!
 * pixi-particles - v3.2.0
 * Compiled Mon, 18 Feb 2019 15:03:44 UTC
 *
 * pixi-particles is licensed under the MIT License.
 * http://www.opensource.org/licenses/mit-license
 */
!function(t){if(true)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{var i;i="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this,i.pixiParticles=t()}}(function(){return function(){function t(i,e,s){function a(r,o){if(!e[r]){if(!i[r]){var h="function"==typeof require&&require;if(!o&&h)return require(r,!0);if(n)return n(r,!0);var l=new Error("Cannot find module '"+r+"'");throw l.code="MODULE_NOT_FOUND",l}var p=e[r]={exports:{}};i[r][0].call(p.exports,function(t){var e=i[r][1][t];return a(e||t)},p,p.exports,t,i,e,s)}return e[r].exports}for(var n="function"==typeof require&&require,r=0;r<s.length;r++)a(s[r]);return a}return t}()({1:[function(t,i,e){"use strict";var s=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,i){t.__proto__=i}||function(t,i){for(var e in i)i.hasOwnProperty(e)&&(t[e]=i[e])};return function(i,e){function s(){this.constructor=i}t(i,e),i.prototype=null===e?Object.create(e):(s.prototype=e.prototype,new s)}}();Object.defineProperty(e,"__esModule",{value:!0});var a=t("./Particle"),n=PIXI.Texture,r=function(t){function i(i){var e=t.call(this,i)||this;return e.textures=null,e.duration=0,e.framerate=0,e.elapsed=0,e.loop=!1,e}return s(i,t),i.prototype.init=function(){this.Particle_init(),this.elapsed=0,this.framerate<0&&(this.duration=this.maxLife,this.framerate=this.textures.length/this.duration)},i.prototype.applyArt=function(t){this.textures=t.textures,this.framerate=t.framerate,this.duration=t.duration,this.loop=t.loop},i.prototype.update=function(t){var i=this.Particle_update(t);if(i>=0){this.elapsed+=t,this.elapsed>this.duration&&(this.loop?this.elapsed=this.elapsed%this.duration:this.elapsed=this.duration-1e-6);var e=this.elapsed*this.framerate+1e-7|0;this.texture=this.textures[e]||PIXI.Texture.EMPTY}return i},i.prototype.destroy=function(){this.Particle_destroy(),this.textures=null},i.parseArt=function(t){for(var i,e,s,a,r,o=[],h=0;h<t.length;++h){i=t[h],o[h]=e={},e.textures=r=[],s=i.textures;for(var l=0;l<s.length;++l)if("string"==typeof(a=s[l]))r.push(n.fromImage(a));else if(a instanceof n)r.push(a);else{var p=a.count||1;for(a="string"==typeof a.texture?n.fromImage(a.texture):a.texture;p>0;--p)r.push(a)}"matchLife"==i.framerate?(e.framerate=-1,e.duration=0,e.loop=!1):(e.loop=!!i.loop,e.framerate=i.framerate>0?i.framerate:60,e.duration=r.length/e.framerate)}return o},i}(a.default);e.default=r},{"./Particle":3}],2:[function(t,i,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var s=t("./ParticleUtils"),a=t("./Particle"),n=t("./PropertyNode"),r=t("./PolygonalChain"),o=PIXI.ticker.shared,h=new PIXI.Point,l=function(){function t(t,i,e){this._particleConstructor=a.default,this.particleImages=null,this.startAlpha=null,this.startSpeed=null,this.minimumSpeedMultiplier=1,this.acceleration=null,this.maxSpeed=NaN,this.startScale=null,this.minimumScaleMultiplier=1,this.startColor=null,this.minLifetime=0,this.maxLifetime=0,this.minStartRotation=0,this.maxStartRotation=0,this.noRotation=!1,this.minRotationSpeed=0,this.maxRotationSpeed=0,this.particleBlendMode=0,this.customEase=null,this.extraData=null,this._frequency=1,this.spawnChance=1,this.maxParticles=1e3,this.emitterLifetime=-1,this.spawnPos=null,this.spawnType=null,this._spawnFunc=null,this.spawnRect=null,this.spawnCircle=null,this.spawnPolygonalChain=null,this.particlesPerWave=1,this.particleSpacing=0,this.angleStart=0,this.rotation=0,this.ownerPos=null,this._prevEmitterPos=null,this._prevPosIsValid=!1,this._posChanged=!1,this._parent=null,this.addAtBack=!1,this.particleCount=0,this._emit=!1,this._spawnTimer=0,this._emitterLife=-1,this._activeParticlesFirst=null,this._activeParticlesLast=null,this._poolFirst=null,this._origConfig=null,this._origArt=null,this._autoUpdate=!1,this._destroyWhenComplete=!1,this._completeCallback=null,this.parent=t,i&&e&&this.init(i,e),this.recycle=this.recycle,this.update=this.update,this.rotate=this.rotate,this.updateSpawnPos=this.updateSpawnPos,this.updateOwnerPos=this.updateOwnerPos}return Object.defineProperty(t.prototype,"frequency",{get:function(){return this._frequency},set:function(t){this._frequency="number"==typeof t&&t>0?t:1},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"particleConstructor",{get:function(){return this._particleConstructor},set:function(t){if(t!=this._particleConstructor){this._particleConstructor=t,this.cleanup();for(var i=this._poolFirst;i;i=i.next)i.destroy();this._poolFirst=null,this._origConfig&&this._origArt&&this.init(this._origArt,this._origConfig)}},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"parent",{get:function(){return this._parent},set:function(t){this.cleanup(),this._parent=t},enumerable:!0,configurable:!0}),t.prototype.init=function(t,i){if(t&&i){this.cleanup(),this._origConfig=i,this._origArt=t,t=Array.isArray(t)?t.slice():[t];var e=this._particleConstructor;this.particleImages=e.parseArt?e.parseArt(t):t,i.alpha?this.startAlpha=n.default.createList(i.alpha):this.startAlpha=new n.default(1,0),i.speed?(this.startSpeed=n.default.createList(i.speed),this.minimumSpeedMultiplier=i.speed.minimumSpeedMultiplier||1):(this.minimumSpeedMultiplier=1,this.startSpeed=new n.default(0,0));var a=i.acceleration;a&&(a.x||a.y)?(this.startSpeed.next=null,this.acceleration=new PIXI.Point(a.x,a.y),this.maxSpeed=i.maxSpeed||NaN):this.acceleration=new PIXI.Point,i.scale?(this.startScale=n.default.createList(i.scale),this.minimumScaleMultiplier=i.scale.minimumScaleMultiplier||1):(this.startScale=new n.default(1,0),this.minimumScaleMultiplier=1),i.color?this.startColor=n.default.createList(i.color):this.startColor=new n.default({r:255,g:255,b:255},0),i.startRotation?(this.minStartRotation=i.startRotation.min,this.maxStartRotation=i.startRotation.max):this.minStartRotation=this.maxStartRotation=0,i.noRotation&&(this.minStartRotation||this.maxStartRotation)?this.noRotation=!!i.noRotation:this.noRotation=!1,i.rotationSpeed?(this.minRotationSpeed=i.rotationSpeed.min,this.maxRotationSpeed=i.rotationSpeed.max):this.minRotationSpeed=this.maxRotationSpeed=0,this.minLifetime=i.lifetime.min,this.maxLifetime=i.lifetime.max,this.particleBlendMode=s.default.getBlendMode(i.blendMode),i.ease?this.customEase="function"==typeof i.ease?i.ease:s.default.generateEase(i.ease):this.customEase=null,e.parseData?this.extraData=e.parseData(i.extraData):this.extraData=i.extraData||null,this.spawnRect=this.spawnCircle=null,this.particlesPerWave=1,i.particlesPerWave&&i.particlesPerWave>1&&(this.particlesPerWave=i.particlesPerWave),this.particleSpacing=0,this.angleStart=0;var o;switch(i.spawnType){case"rect":this.spawnType="rect",this._spawnFunc=this._spawnRect;var h=i.spawnRect;this.spawnRect=new PIXI.Rectangle(h.x,h.y,h.w,h.h);break;case"circle":this.spawnType="circle",this._spawnFunc=this._spawnCircle,o=i.spawnCircle,this.spawnCircle=new PIXI.Circle(o.x,o.y,o.r);break;case"ring":this.spawnType="ring",this._spawnFunc=this._spawnRing,o=i.spawnCircle,this.spawnCircle=new PIXI.Circle(o.x,o.y,o.r),this.spawnCircle.minRadius=o.minR;break;case"burst":this.spawnType="burst",this._spawnFunc=this._spawnBurst,this.particleSpacing=i.particleSpacing,this.angleStart=i.angleStart?i.angleStart:0;break;case"point":this.spawnType="point",this._spawnFunc=this._spawnPoint;break;case"polygonalChain":this.spawnType="polygonalChain",this._spawnFunc=this._spawnPolygonalChain,this.spawnPolygonalChain=new r.default(i.spawnPolygon);break;default:this.spawnType="point",this._spawnFunc=this._spawnPoint}this.frequency=i.frequency,this.spawnChance="number"==typeof i.spawnChance&&i.spawnChance>0?i.spawnChance:1,this.emitterLifetime=i.emitterLifetime||-1,this.maxParticles=i.maxParticles>0?i.maxParticles:1e3,this.addAtBack=!!i.addAtBack,this.rotation=0,this.ownerPos=new PIXI.Point,this.spawnPos=new PIXI.Point(i.pos.x,i.pos.y),this._prevEmitterPos=this.spawnPos.clone(),this._prevPosIsValid=!1,this._spawnTimer=0,this.emit=void 0===i.emit||!!i.emit,this.autoUpdate=void 0!==i.autoUpdate&&!!i.autoUpdate}},t.prototype.recycle=function(t){t.next&&(t.next.prev=t.prev),t.prev&&(t.prev.next=t.next),t==this._activeParticlesLast&&(this._activeParticlesLast=t.prev),t==this._activeParticlesFirst&&(this._activeParticlesFirst=t.next),t.prev=null,t.next=this._poolFirst,this._poolFirst=t,t.parent&&t.parent.removeChild(t),--this.particleCount},t.prototype.rotate=function(t){if(this.rotation!=t){var i=t-this.rotation;this.rotation=t,s.default.rotatePoint(i,this.spawnPos),this._posChanged=!0}},t.prototype.updateSpawnPos=function(t,i){this._posChanged=!0,this.spawnPos.x=t,this.spawnPos.y=i},t.prototype.updateOwnerPos=function(t,i){this._posChanged=!0,this.ownerPos.x=t,this.ownerPos.y=i},t.prototype.resetPositionTracking=function(){this._prevPosIsValid=!1},Object.defineProperty(t.prototype,"emit",{get:function(){return this._emit},set:function(t){this._emit=!!t,this._emitterLife=this.emitterLifetime},enumerable:!0,configurable:!0}),Object.defineProperty(t.prototype,"autoUpdate",{get:function(){return this._autoUpdate},set:function(t){this._autoUpdate&&!t?o.remove(this.update,this):!this._autoUpdate&&t&&o.add(this.update,this),this._autoUpdate=!!t},enumerable:!0,configurable:!0}),t.prototype.playOnceAndDestroy=function(t){this.autoUpdate=!0,this.emit=!0,this._destroyWhenComplete=!0,this._completeCallback=t},t.prototype.playOnce=function(t){this.emit=!0,this._completeCallback=t},t.prototype.update=function(t){if(this._autoUpdate&&(t=t/PIXI.settings.TARGET_FPMS/1e3),this._parent){var i,e,s;for(e=this._activeParticlesFirst;e;e=s)s=e.next,e.update(t);var a,n;this._prevPosIsValid&&(a=this._prevEmitterPos.x,n=this._prevEmitterPos.y);var r=this.ownerPos.x+this.spawnPos.x,o=this.ownerPos.y+this.spawnPos.y;if(this._emit)for(this._spawnTimer-=t<0?0:t;this._spawnTimer<=0;){if(this._emitterLife>0&&(this._emitterLife-=this._frequency,this._emitterLife<=0)){this._spawnTimer=0,this._emitterLife=0,this.emit=!1;break}if(this.particleCount>=this.maxParticles)this._spawnTimer+=this._frequency;else{var h=void 0;if(h=this.minLifetime==this.maxLifetime?this.minLifetime:Math.random()*(this.maxLifetime-this.minLifetime)+this.minLifetime,-this._spawnTimer<h){var l=void 0,p=void 0;if(this._prevPosIsValid&&this._posChanged){var c=1+this._spawnTimer/t;l=(r-a)*c+a,p=(o-n)*c+n}else l=r,p=o;i=0;for(var u=Math.min(this.particlesPerWave,this.maxParticles-this.particleCount);i<u;++i)if(!(this.spawnChance<1&&Math.random()>=this.spawnChance)){var d=void 0;if(this._poolFirst?(d=this._poolFirst,this._poolFirst=this._poolFirst.next,d.next=null):d=new this.particleConstructor(this),this.particleImages.length>1?d.applyArt(this.particleImages[Math.floor(Math.random()*this.particleImages.length)]):d.applyArt(this.particleImages[0]),d.alphaList.reset(this.startAlpha),1!=this.minimumSpeedMultiplier&&(d.speedMultiplier=Math.random()*(1-this.minimumSpeedMultiplier)+this.minimumSpeedMultiplier),d.speedList.reset(this.startSpeed),d.acceleration.x=this.acceleration.x,d.acceleration.y=this.acceleration.y,d.maxSpeed=this.maxSpeed,1!=this.minimumScaleMultiplier&&(d.scaleMultiplier=Math.random()*(1-this.minimumScaleMultiplier)+this.minimumScaleMultiplier),d.scaleList.reset(this.startScale),d.colorList.reset(this.startColor),this.minRotationSpeed==this.maxRotationSpeed?d.rotationSpeed=this.minRotationSpeed:d.rotationSpeed=Math.random()*(this.maxRotationSpeed-this.minRotationSpeed)+this.minRotationSpeed,d.noRotation=this.noRotation,d.maxLife=h,d.blendMode=this.particleBlendMode,d.ease=this.customEase,d.extraData=this.extraData,this._spawnFunc(d,l,p,i),d.init(),d.update(-this._spawnTimer),d.parent){var f=this._parent.children;if(f[0]==d)f.shift();else if(f[f.length-1]==d)f.pop();else{var m=f.indexOf(d);f.splice(m,1)}this.addAtBack?f.unshift(d):f.push(d)}else this.addAtBack?this._parent.addChildAt(d,0):this._parent.addChild(d);this._activeParticlesLast?(this._activeParticlesLast.next=d,d.prev=this._activeParticlesLast,this._activeParticlesLast=d):this._activeParticlesLast=this._activeParticlesFirst=d,++this.particleCount}}this._spawnTimer+=this._frequency}}this._posChanged&&(this._prevEmitterPos.x=r,this._prevEmitterPos.y=o,this._prevPosIsValid=!0,this._posChanged=!1),this._emit||this._activeParticlesFirst||(this._completeCallback&&this._completeCallback(),this._destroyWhenComplete&&this.destroy())}},t.prototype._spawnPoint=function(t,i,e){this.minStartRotation==this.maxStartRotation?t.rotation=this.minStartRotation+this.rotation:t.rotation=Math.random()*(this.maxStartRotation-this.minStartRotation)+this.minStartRotation+this.rotation,t.position.x=i,t.position.y=e},t.prototype._spawnRect=function(t,i,e){this.minStartRotation==this.maxStartRotation?t.rotation=this.minStartRotation+this.rotation:t.rotation=Math.random()*(this.maxStartRotation-this.minStartRotation)+this.minStartRotation+this.rotation,h.x=Math.random()*this.spawnRect.width+this.spawnRect.x,h.y=Math.random()*this.spawnRect.height+this.spawnRect.y,0!==this.rotation&&s.default.rotatePoint(this.rotation,h),t.position.x=i+h.x,t.position.y=e+h.y},t.prototype._spawnCircle=function(t,i,e){this.minStartRotation==this.maxStartRotation?t.rotation=this.minStartRotation+this.rotation:t.rotation=Math.random()*(this.maxStartRotation-this.minStartRotation)+this.minStartRotation+this.rotation,h.x=Math.random()*this.spawnCircle.radius,h.y=0,s.default.rotatePoint(360*Math.random(),h),h.x+=this.spawnCircle.x,h.y+=this.spawnCircle.y,0!==this.rotation&&s.default.rotatePoint(this.rotation,h),t.position.x=i+h.x,t.position.y=e+h.y},t.prototype._spawnRing=function(t,i,e){var a=this.spawnCircle;this.minStartRotation==this.maxStartRotation?t.rotation=this.minStartRotation+this.rotation:t.rotation=Math.random()*(this.maxStartRotation-this.minStartRotation)+this.minStartRotation+this.rotation,a.minRadius!==a.radius?h.x=Math.random()*(a.radius-a.minRadius)+a.minRadius:h.x=a.radius,h.y=0;var n=360*Math.random();t.rotation+=n,s.default.rotatePoint(n,h),h.x+=this.spawnCircle.x,h.y+=this.spawnCircle.y,0!==this.rotation&&s.default.rotatePoint(this.rotation,h),t.position.x=i+h.x,t.position.y=e+h.y},t.prototype._spawnPolygonalChain=function(t,i,e){this.minStartRotation==this.maxStartRotation?t.rotation=this.minStartRotation+this.rotation:t.rotation=Math.random()*(this.maxStartRotation-this.minStartRotation)+this.minStartRotation+this.rotation,this.spawnPolygonalChain.getRandomPoint(h),0!==this.rotation&&s.default.rotatePoint(this.rotation,h),t.position.x=i+h.x,t.position.y=e+h.y},t.prototype._spawnBurst=function(t,i,e,s){0===this.particleSpacing?t.rotation=360*Math.random():t.rotation=this.angleStart+this.particleSpacing*s+this.rotation,t.position.x=i,t.position.y=e},t.prototype.cleanup=function(){var t,i;for(t=this._activeParticlesFirst;t;t=i)i=t.next,this.recycle(t),t.parent&&t.parent.removeChild(t);this._activeParticlesFirst=this._activeParticlesLast=null,this.particleCount=0},t.prototype.destroy=function(){this.autoUpdate=!1,this.cleanup();for(var t,i=this._poolFirst;i;i=t)t=i.next,i.destroy();this._poolFirst=this._parent=this.particleImages=this.spawnPos=this.ownerPos=this.startColor=this.startScale=this.startAlpha=this.startSpeed=this.customEase=this._completeCallback=null},t}();e.default=l},{"./Particle":3,"./ParticleUtils":4,"./PolygonalChain":6,"./PropertyNode":8}],3:[function(t,i,e){"use strict";var s=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,i){t.__proto__=i}||function(t,i){for(var e in i)i.hasOwnProperty(e)&&(t[e]=i[e])};return function(i,e){function s(){this.constructor=i}t(i,e),i.prototype=null===e?Object.create(e):(s.prototype=e.prototype,new s)}}();Object.defineProperty(e,"__esModule",{value:!0});var a=t("./ParticleUtils"),n=t("./PropertyList"),r=PIXI.Sprite,o=function(t){function i(e){var s=t.call(this)||this;return s.emitter=e,s.anchor.x=s.anchor.y=.5,s.velocity=new PIXI.Point,s.maxLife=0,s.age=0,s.ease=null,s.extraData=null,s.alphaList=new n.default,s.speedList=new n.default,s.speedMultiplier=1,s.acceleration=new PIXI.Point,s.maxSpeed=NaN,s.scaleList=new n.default,s.scaleMultiplier=1,s.colorList=new n.default(!0),s._doAlpha=!1,s._doScale=!1,s._doSpeed=!1,s._doAcceleration=!1,s._doColor=!1,s._doNormalMovement=!1,s._oneOverLife=0,s.next=null,s.prev=null,s.init=s.init,s.Particle_init=i.prototype.init,s.update=s.update,s.Particle_update=i.prototype.update,s.Sprite_destroy=t.prototype.destroy,s.Particle_destroy=i.prototype.destroy,s.applyArt=s.applyArt,s.kill=s.kill,s}return s(i,t),i.prototype.init=function(){this.age=0,this.velocity.x=this.speedList.current.value*this.speedMultiplier,this.velocity.y=0,a.default.rotatePoint(this.rotation,this.velocity),this.noRotation?this.rotation=0:this.rotation*=a.default.DEG_TO_RADS,this.rotationSpeed*=a.default.DEG_TO_RADS,this.alpha=this.alphaList.current.value,this.scale.x=this.scale.y=this.scaleList.current.value,this._doAlpha=!!this.alphaList.current.next,this._doSpeed=!!this.speedList.current.next,this._doScale=!!this.scaleList.current.next,this._doColor=!!this.colorList.current.next,this._doAcceleration=0!==this.acceleration.x||0!==this.acceleration.y,this._doNormalMovement=this._doSpeed||0!==this.speedList.current.value||this._doAcceleration,this._oneOverLife=1/this.maxLife;var t=this.colorList.current.value;this.tint=a.default.combineRGBComponents(t.r,t.g,t.b),this.visible=!0},i.prototype.applyArt=function(t){this.texture=t||PIXI.Texture.EMPTY},i.prototype.update=function(t){if(this.age+=t,this.age>=this.maxLife||this.age<0)return this.kill(),-1;var i=this.age*this._oneOverLife;if(this.ease&&(i=4==this.ease.length?this.ease(i,0,1,1):this.ease(i)),this._doAlpha&&(this.alpha=this.alphaList.interpolate(i)),this._doScale){var e=this.scaleList.interpolate(i)*this.scaleMultiplier;this.scale.x=this.scale.y=e}if(this._doNormalMovement){if(this._doSpeed){var s=this.speedList.interpolate(i)*this.speedMultiplier;a.default.normalize(this.velocity),a.default.scaleBy(this.velocity,s)}else if(this._doAcceleration&&(this.velocity.x+=this.acceleration.x*t,this.velocity.y+=this.acceleration.y*t,this.maxSpeed)){var n=a.default.length(this.velocity);n>this.maxSpeed&&a.default.scaleBy(this.velocity,this.maxSpeed/n)}this.position.x+=this.velocity.x*t,this.position.y+=this.velocity.y*t}return this._doColor&&(this.tint=this.colorList.interpolate(i)),0!==this.rotationSpeed?this.rotation+=this.rotationSpeed*t:this.acceleration&&!this.noRotation&&(this.rotation=Math.atan2(this.velocity.y,this.velocity.x)),i},i.prototype.kill=function(){this.emitter.recycle(this)},i.prototype.destroy=function(){this.parent&&this.parent.removeChild(this),this.Sprite_destroy(),this.emitter=this.velocity=this.colorList=this.scaleList=this.alphaList=this.speedList=this.ease=this.next=this.prev=null},i.parseArt=function(t){var i;for(i=t.length;i>=0;--i)"string"==typeof t[i]&&(t[i]=PIXI.Texture.fromImage(t[i]));if(a.default.verbose)for(i=t.length-1;i>0;--i)if(t[i].baseTexture!=t[i-1].baseTexture){window.console&&console.warn("PixiParticles: using particle textures from different images may hinder performance in WebGL");break}return t},i.parseData=function(t){return t},i}(r);e.default=o},{"./ParticleUtils":4,"./PropertyList":7}],4:[function(t,i,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var s=PIXI.BLEND_MODES,a=t("./PropertyNode"),n={verbose:!1,DEG_TO_RADS:Math.PI/180,rotatePoint:function(t,i){if(t){t*=n.DEG_TO_RADS;var e=Math.sin(t),s=Math.cos(t),a=i.x*s-i.y*e,r=i.x*e+i.y*s;i.x=a,i.y=r}},combineRGBComponents:function(t,i,e){return t<<16|i<<8|e},normalize:function(t){var i=1/n.length(t);t.x*=i,t.y*=i},scaleBy:function(t,i){t.x*=i,t.y*=i},length:function(t){return Math.sqrt(t.x*t.x+t.y*t.y)},hexToRGB:function(t,i){i||(i={}),"#"==t.charAt(0)?t=t.substr(1):0===t.indexOf("0x")&&(t=t.substr(2));var e;return 8==t.length&&(e=t.substr(0,2),t=t.substr(2)),i.r=parseInt(t.substr(0,2),16),i.g=parseInt(t.substr(2,2),16),i.b=parseInt(t.substr(4,2),16),e&&(i.a=parseInt(e,16)),i},generateEase:function(t){var i=t.length,e=1/i;return function(s){var a,n,r=i*s|0;return a=(s-r*e)*i,n=t[r]||t[i-1],n.s+a*(2*(1-a)*(n.cp-n.s)+a*(n.e-n.s))}},getBlendMode:function(t){if(!t)return s.NORMAL;for(t=t.toUpperCase();t.indexOf(" ")>=0;)t=t.replace(" ","_");return s[t]||s.NORMAL},createSteppedGradient:function(t,i){void 0===i&&(i=10),("number"!=typeof i||i<=0)&&(i=10);var e=new a.default(t[0].value,t[0].time);e.isStepped=!0;for(var s=e,r=t[0],o=1,h=t[o],l=1;l<i;++l){for(var p=l/i;p>h.time;)r=h,h=t[++o];p=(p-r.time)/(h.time-r.time);var c=n.hexToRGB(r.value),u=n.hexToRGB(h.value),d={};d.r=(u.r-c.r)*p+c.r,d.g=(u.g-c.g)*p+c.g,d.b=(u.b-c.b)*p+c.b,s.next=new a.default(d,l/i),s=s.next}return e}};e.default=n},{"./PropertyNode":8}],5:[function(t,i,e){"use strict";var s=this&&this.__extends||function(){var t=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,i){t.__proto__=i}||function(t,i){for(var e in i)i.hasOwnProperty(e)&&(t[e]=i[e])};return function(i,e){function s(){this.constructor=i}t(i,e),i.prototype=null===e?Object.create(e):(s.prototype=e.prototype,new s)}}();Object.defineProperty(e,"__esModule",{value:!0});var a=t("./ParticleUtils"),n=t("./Particle"),r=new PIXI.Point,o=["pow","sqrt","abs","floor","round","ceil","E","PI","sin","cos","tan","asin","acos","atan","atan2","log"],h=new RegExp(["[01234567890\\.\\*\\-\\+\\/\\(\\)x ,]"].concat(o).join("|"),"g"),l=function(t){for(var i=t.match(h),e=i.length-1;e>=0;--e)o.indexOf(i[e])>=0&&(i[e]="Math."+i[e]);return t=i.join(""),new Function("x","return "+t+";")},p=function(t){function i(i){var e=t.call(this,i)||this;return e.path=null,e.initialRotation=0,e.initialPosition=new PIXI.Point,e.movement=0,e}return s(i,t),i.prototype.init=function(){this.initialRotation=this.rotation,this.Particle_init(),this.path=this.extraData.path,this._doNormalMovement=!this.path,this.movement=0,this.initialPosition.x=this.position.x,this.initialPosition.y=this.position.y},i.prototype.update=function(t){var i=this.Particle_update(t);if(i>=0&&this.path){var e=this.speedList.interpolate(i)*this.speedMultiplier;this.movement+=e*t,r.x=this.movement,r.y=this.path(this.movement),a.default.rotatePoint(this.initialRotation,r),this.position.x=this.initialPosition.x+r.x,this.position.y=this.initialPosition.y+r.y}return i},i.prototype.destroy=function(){this.Particle_destroy(),this.path=this.initialPosition=null},i.parseArt=function(t){return n.default.parseArt(t)},i.parseData=function(t){var i={};if(t&&t.path)try{i.path=l(t.path)}catch(t){a.default.verbose&&console.error("PathParticle: error in parsing path expression"),i.path=null}else a.default.verbose&&console.error("PathParticle requires a path string in extraData!"),i.path=null;return i},i}(n.default);e.default=p},{"./Particle":3,"./ParticleUtils":4}],6:[function(t,i,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var s=function(){function t(t){this.segments=[],this.countingLengths=[],this.totalLength=0,this.init(t)}return t.prototype.init=function(t){if(t&&t.length)if(Array.isArray(t[0]))for(var i=0;i<t.length;++i)for(var e=t[i],s=e[0],a=1;a<e.length;++a){var n=e[a];this.segments.push({p1:s,p2:n,l:0}),s=n}else for(var s=t[0],i=1;i<t.length;++i){var n=t[i];this.segments.push({p1:s,p2:n,l:0}),s=n}else this.segments.push({p1:{x:0,y:0},p2:{x:0,y:0},l:0});for(var i=0;i<this.segments.length;++i){var r=this.segments[i],o=r.p1,h=r.p2,l=Math.sqrt((h.x-o.x)*(h.x-o.x)+(h.y-o.y)*(h.y-o.y));this.segments[i].l=l,this.totalLength+=l,this.countingLengths.push(this.totalLength)}},t.prototype.getRandomPoint=function(t){var i,e,s=Math.random()*this.totalLength;if(1===this.segments.length)i=this.segments[0],e=s;else for(var a=0;a<this.countingLengths.length;++a)if(s<this.countingLengths[a]){i=this.segments[a],e=0===a?s:s-this.countingLengths[a-1];break}e/=i.l||1;var n=i.p1,r=i.p2;t.x=n.x+e*(r.x-n.x),t.y=n.y+e*(r.y-n.y)},t}();e.default=s},{}],7:[function(t,i,e){"use strict";function s(t){return this.ease&&(t=this.ease(t)),(this.next.value-this.current.value)*t+this.current.value}function a(t){this.ease&&(t=this.ease(t));var i=this.current.value,e=this.next.value,s=(e.r-i.r)*t+i.r,a=(e.g-i.g)*t+i.g,n=(e.b-i.b)*t+i.b;return l.default.combineRGBComponents(s,a,n)}function n(t){for(this.ease&&(t=this.ease(t));t>this.next.time;)this.current=this.next,this.next=this.next.next;return t=(t-this.current.time)/(this.next.time-this.current.time),(this.next.value-this.current.value)*t+this.current.value}function r(t){for(this.ease&&(t=this.ease(t));t>this.next.time;)this.current=this.next,this.next=this.next.next;t=(t-this.current.time)/(this.next.time-this.current.time);var i=this.current.value,e=this.next.value,s=(e.r-i.r)*t+i.r,a=(e.g-i.g)*t+i.g,n=(e.b-i.b)*t+i.b;return l.default.combineRGBComponents(s,a,n)}function o(t){for(this.ease&&(t=this.ease(t));this.next&&t>this.next.time;)this.current=this.next,this.next=this.next.next;return this.current.value}function h(t){for(this.ease&&(t=this.ease(t));this.next&&t>this.next.time;)this.current=this.next,this.next=this.next.next;var i=this.current.value;return l.default.combineRGBComponents(i.r,i.g,i.b)}Object.defineProperty(e,"__esModule",{value:!0});var l=t("./ParticleUtils"),p=function(){function t(t){void 0===t&&(t=!1),this.current=null,this.next=null,this.isColor=!!t,this.interpolate=null,this.ease=null}return t.prototype.reset=function(t){this.current=t,this.next=t.next,this.next&&this.next.time>=1?this.interpolate=this.isColor?a:s:t.isStepped?this.interpolate=this.isColor?h:o:this.interpolate=this.isColor?r:n,this.ease=this.current.ease},t}();e.default=p},{"./ParticleUtils":4}],8:[function(t,i,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var s=t("./ParticleUtils"),a=function(){function t(t,i,e){this.value="string"==typeof t?s.default.hexToRGB(t):t,this.time=i,this.next=null,this.isStepped=!1,this.ease=e?"function"==typeof e?e:s.default.generateEase(e):null}return t.createList=function(i){if(Array.isArray(i.list)){var e=i.list,s=void 0,a=void 0;if(a=s=new t(e[0].value,e[0].time,i.ease),e.length>2||2===e.length&&e[1].value!==e[0].value)for(var n=1;n<e.length;++n)s.next=new t(e[n].value,e[n].time),s=s.next;return a.isStepped=!!i.isStepped,a}var r=new t(i.start,0);return i.end!==i.start&&(r.next=new t(i.end,1)),r},t}();e.default=a},{"./ParticleUtils":4}],9:[function(t,i,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var s=t("./ParticleUtils.js");e.ParticleUtils=s.default;var a=t("./Particle.js");e.Particle=a.default;var n=t("./Emitter.js");e.Emitter=n.default;var r=t("./PathParticle.js");e.PathParticle=r.default;var o=t("./AnimatedParticle.js");e.AnimatedParticle=o.default},{"./AnimatedParticle.js":1,"./Emitter.js":2,"./Particle.js":3,"./ParticleUtils.js":4,"./PathParticle.js":5}],10:[function(t,i,e){"use strict";if(Object.defineProperty(e,"__esModule",{value:!0}),"undefined"==typeof PIXI)throw"pixi-particles requires pixi.js to be loaded first";PIXI.particles||(PIXI.particles={});var s=t("./particles");for(var a in s)PIXI.particles[a]=s[a];void 0!==i&&i.exports&&(i.exports=s)},{"./particles":9}]},{},[10])(10)});
//# sourceMappingURL=pixi-particles.min.js.map


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var METADATA_KEY = __webpack_require__(18);
var MetadataReader = (function () {
    function MetadataReader() {
    }
    MetadataReader.prototype.getConstructorMetadata = function (constructorFunc) {
        var compilerGeneratedMetadata = Reflect.getMetadata(METADATA_KEY.PARAM_TYPES, constructorFunc);
        var userGeneratedMetadata = Reflect.getMetadata(METADATA_KEY.TAGGED, constructorFunc);
        return {
            compilerGeneratedMetadata: compilerGeneratedMetadata,
            userGeneratedMetadata: userGeneratedMetadata || {}
        };
    };
    MetadataReader.prototype.getPropertiesMetadata = function (constructorFunc) {
        var userGeneratedMetadata = Reflect.getMetadata(METADATA_KEY.TAGGED_PROP, constructorFunc) || [];
        return userGeneratedMetadata;
    };
    return MetadataReader;
}());
exports.MetadataReader = MetadataReader;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ERROR_MSGS = __webpack_require__(27);
function isStackOverflowExeption(error) {
    return (error instanceof RangeError ||
        error.message === ERROR_MSGS.STACK_OVERFLOW);
}
exports.isStackOverflowExeption = isStackOverflowExeption;


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var error_msgs_1 = __webpack_require__(27);
var METADATA_KEY = __webpack_require__(18);
var metadata_1 = __webpack_require__(36);
var decorator_utils_1 = __webpack_require__(53);
var LazyServiceIdentifer = (function () {
    function LazyServiceIdentifer(cb) {
        this._cb = cb;
    }
    LazyServiceIdentifer.prototype.unwrap = function () {
        return this._cb();
    };
    return LazyServiceIdentifer;
}());
exports.LazyServiceIdentifer = LazyServiceIdentifer;
function inject(serviceIdentifier) {
    return function (target, targetKey, index) {
        if (serviceIdentifier === undefined) {
            throw new Error(error_msgs_1.UNDEFINED_INJECT_ANNOTATION(target.name));
        }
        var metadata = new metadata_1.Metadata(METADATA_KEY.INJECT_TAG, serviceIdentifier);
        if (typeof index === "number") {
            decorator_utils_1.tagParameter(target, targetKey, index, metadata);
        }
        else {
            decorator_utils_1.tagProperty(target, targetKey, metadata);
        }
    };
}
exports.inject = inject;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var METADATA_KEY = __webpack_require__(18);
var guid_1 = __webpack_require__(61);
var metadata_1 = __webpack_require__(36);
var queryable_string_1 = __webpack_require__(451);
var Target = (function () {
    function Target(type, name, serviceIdentifier, namedOrTagged) {
        this.guid = guid_1.guid();
        this.type = type;
        this.serviceIdentifier = serviceIdentifier;
        this.name = new queryable_string_1.QueryableString(name || "");
        this.metadata = new Array();
        var metadataItem = null;
        if (typeof namedOrTagged === "string") {
            metadataItem = new metadata_1.Metadata(METADATA_KEY.NAMED_TAG, namedOrTagged);
        }
        else if (namedOrTagged instanceof metadata_1.Metadata) {
            metadataItem = namedOrTagged;
        }
        if (metadataItem !== null) {
            this.metadata.push(metadataItem);
        }
    }
    Target.prototype.hasTag = function (key) {
        for (var _i = 0, _a = this.metadata; _i < _a.length; _i++) {
            var m = _a[_i];
            if (m.key === key) {
                return true;
            }
        }
        return false;
    };
    Target.prototype.isArray = function () {
        return this.hasTag(METADATA_KEY.MULTI_INJECT_TAG);
    };
    Target.prototype.matchesArray = function (name) {
        return this.matchesTag(METADATA_KEY.MULTI_INJECT_TAG)(name);
    };
    Target.prototype.isNamed = function () {
        return this.hasTag(METADATA_KEY.NAMED_TAG);
    };
    Target.prototype.isTagged = function () {
        return this.metadata.some(function (m) {
            return (m.key !== METADATA_KEY.INJECT_TAG) &&
                (m.key !== METADATA_KEY.MULTI_INJECT_TAG) &&
                (m.key !== METADATA_KEY.NAME_TAG) &&
                (m.key !== METADATA_KEY.UNMANAGED_TAG) &&
                (m.key !== METADATA_KEY.NAMED_TAG);
        });
    };
    Target.prototype.isOptional = function () {
        return this.matchesTag(METADATA_KEY.OPTIONAL_TAG)(true);
    };
    Target.prototype.getNamedTag = function () {
        if (this.isNamed()) {
            return this.metadata.filter(function (m) { return m.key === METADATA_KEY.NAMED_TAG; })[0];
        }
        return null;
    };
    Target.prototype.getCustomTags = function () {
        if (this.isTagged()) {
            return this.metadata.filter(function (m) {
                return (m.key !== METADATA_KEY.INJECT_TAG) &&
                    (m.key !== METADATA_KEY.MULTI_INJECT_TAG) &&
                    (m.key !== METADATA_KEY.NAME_TAG) &&
                    (m.key !== METADATA_KEY.UNMANAGED_TAG) &&
                    (m.key !== METADATA_KEY.NAMED_TAG);
            });
        }
        return null;
    };
    Target.prototype.matchesNamedTag = function (name) {
        return this.matchesTag(METADATA_KEY.NAMED_TAG)(name);
    };
    Target.prototype.matchesTag = function (key) {
        var _this = this;
        return function (value) {
            for (var _i = 0, _a = _this.metadata; _i < _a.length; _i++) {
                var m = _a[_i];
                if (m.key === key && m.value === value) {
                    return true;
                }
            }
            return false;
        };
    };
    return Target;
}());
exports.Target = Target;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var binding_on_syntax_1 = __webpack_require__(140);
var binding_when_syntax_1 = __webpack_require__(141);
var BindingWhenOnSyntax = (function () {
    function BindingWhenOnSyntax(binding) {
        this._binding = binding;
        this._bindingWhenSyntax = new binding_when_syntax_1.BindingWhenSyntax(this._binding);
        this._bindingOnSyntax = new binding_on_syntax_1.BindingOnSyntax(this._binding);
    }
    BindingWhenOnSyntax.prototype.when = function (constraint) {
        return this._bindingWhenSyntax.when(constraint);
    };
    BindingWhenOnSyntax.prototype.whenTargetNamed = function (name) {
        return this._bindingWhenSyntax.whenTargetNamed(name);
    };
    BindingWhenOnSyntax.prototype.whenTargetIsDefault = function () {
        return this._bindingWhenSyntax.whenTargetIsDefault();
    };
    BindingWhenOnSyntax.prototype.whenTargetTagged = function (tag, value) {
        return this._bindingWhenSyntax.whenTargetTagged(tag, value);
    };
    BindingWhenOnSyntax.prototype.whenInjectedInto = function (parent) {
        return this._bindingWhenSyntax.whenInjectedInto(parent);
    };
    BindingWhenOnSyntax.prototype.whenParentNamed = function (name) {
        return this._bindingWhenSyntax.whenParentNamed(name);
    };
    BindingWhenOnSyntax.prototype.whenParentTagged = function (tag, value) {
        return this._bindingWhenSyntax.whenParentTagged(tag, value);
    };
    BindingWhenOnSyntax.prototype.whenAnyAncestorIs = function (ancestor) {
        return this._bindingWhenSyntax.whenAnyAncestorIs(ancestor);
    };
    BindingWhenOnSyntax.prototype.whenNoAncestorIs = function (ancestor) {
        return this._bindingWhenSyntax.whenNoAncestorIs(ancestor);
    };
    BindingWhenOnSyntax.prototype.whenAnyAncestorNamed = function (name) {
        return this._bindingWhenSyntax.whenAnyAncestorNamed(name);
    };
    BindingWhenOnSyntax.prototype.whenAnyAncestorTagged = function (tag, value) {
        return this._bindingWhenSyntax.whenAnyAncestorTagged(tag, value);
    };
    BindingWhenOnSyntax.prototype.whenNoAncestorNamed = function (name) {
        return this._bindingWhenSyntax.whenNoAncestorNamed(name);
    };
    BindingWhenOnSyntax.prototype.whenNoAncestorTagged = function (tag, value) {
        return this._bindingWhenSyntax.whenNoAncestorTagged(tag, value);
    };
    BindingWhenOnSyntax.prototype.whenAnyAncestorMatches = function (constraint) {
        return this._bindingWhenSyntax.whenAnyAncestorMatches(constraint);
    };
    BindingWhenOnSyntax.prototype.whenNoAncestorMatches = function (constraint) {
        return this._bindingWhenSyntax.whenNoAncestorMatches(constraint);
    };
    BindingWhenOnSyntax.prototype.onActivation = function (handler) {
        return this._bindingOnSyntax.onActivation(handler);
    };
    return BindingWhenOnSyntax;
}());
exports.BindingWhenOnSyntax = BindingWhenOnSyntax;


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var METADATA_KEY = __webpack_require__(18);
var metadata_1 = __webpack_require__(36);
var traverseAncerstors = function (request, constraint) {
    var parent = request.parentRequest;
    if (parent !== null) {
        return constraint(parent) ? true : traverseAncerstors(parent, constraint);
    }
    else {
        return false;
    }
};
exports.traverseAncerstors = traverseAncerstors;
var taggedConstraint = function (key) { return function (value) {
    var constraint = function (request) {
        return request !== null && request.target !== null && request.target.matchesTag(key)(value);
    };
    constraint.metaData = new metadata_1.Metadata(key, value);
    return constraint;
}; };
exports.taggedConstraint = taggedConstraint;
var namedConstraint = taggedConstraint(METADATA_KEY.NAMED_TAG);
exports.namedConstraint = namedConstraint;
var typeConstraint = function (type) { return function (request) {
    var binding = null;
    if (request !== null) {
        binding = request.bindings[0];
        if (typeof type === "string") {
            var serviceIdentifier = binding.serviceIdentifier;
            return serviceIdentifier === type;
        }
        else {
            var constructor = request.bindings[0].implementationType;
            return type === constructor;
        }
    }
    return false;
}; };
exports.typeConstraint = typeConstraint;


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = __webpack_require__(14);
var GameConfig_1 = __webpack_require__(142);
var TextStyles = /** @class */ (function () {
    function TextStyles() {
        this._specialFontMap = {
            el: 'Alegreya Sans Sc',
            bg: 'Alegreya Sans Sc',
            ru: 'Alegreya Sans Sc',
            th: 'Pridi Regular',
            ja: 'Nicokaku',
            ka: 'Calibri',
            standard: 'Black Han Sans',
        };
        this._baseFontMap = {
            standard: 'Arial',
        };
        this._strongFontMap = {
            th: 'Pridi Regular',
            standard: 'Arial Black',
            iOs: 'Verdana-Bold',
            iphone: 'Verdana-Bold',
        };
    }
    TextStyles.prototype.init = function (locale, resolutionManager, device, config) {
        this.locale = locale;
        this._resolutionManager = resolutionManager;
        this._device = device;
        this._config = new GameConfig_1.GameConfig();
        this._config.loadConfig(config);
        this.generateFonts(locale);
    };
    TextStyles.prototype.generateFonts = function (locale) {
        // const baseFontSize: number = this.device.isMobile ? 26 : 30;
        var smallFontSize = 18;
        var notTooSmallFontSize = 22;
        var baseFontSize = 26;
        var lowerMiddleFontSize = 30;
        var middleFontSize = 36;
        var bigFontSize = 42;
        var biggestFontSize = 46;
        var blackColor = '#000000';
        var standardColor = '#ffffff';
        var redColor = '#ff0000';
        var errorColor = '#ffffff';
        var titleColor = '#fadf47';
        var ocurrenceColor = '#efc107';
        var baseFontFamily = this.getFontFamily(locale, this._baseFontMap);
        var strongFontFamily = this.getFontFamily(locale, this._strongFontMap);
        if (this._device.iOS || this._device.iPhone) {
            strongFontFamily = this.getFontFamily('iOs', this._strongFontMap);
        }
        var specialFont = this.getFontFamily(locale, this._specialFontMap);
        var wordWrapWidth = this._resolutionManager.resolution.width * 0.8;
        this._freeRoundsCaptionStyle = new PIXI.TextStyle({
            fontFamily: this.getConfigData('freeRoundsCaptionStyle', 'fontFamily', baseFontFamily),
            fontSize: this.getConfigData('freeRoundsCaptionStyle', 'fontSize', bigFontSize),
            align: this.getConfigData('freeRoundsCaptionStyle', 'align', 'center'),
            fontWeight: this.getConfigData('freeRoundsCaptionStyle', 'fontWeight', 'bold'),
            wordWrap: true,
            wordWrapWidth: wordWrapWidth,
            fill: this.getConfigData('freeRoundsCaptionStyle', 'fill', [standardColor]),
        });
        this._freeRoundsTextStyle = new PIXI.TextStyle({
            fontFamily: this.getConfigData('freeRoundsTextStyle', 'fontFamily', baseFontFamily),
            fontSize: this.getConfigData('freeRoundsTextStyle', 'fontSize', lowerMiddleFontSize),
            align: this.getConfigData('freeRoundsTextStyle', 'align', 'center'),
            fontWeight: this.getConfigData('freeRoundsTextStyle', 'fontWeight', 'bold'),
            wordWrap: true,
            wordWrapWidth: wordWrapWidth,
            fill: this.getConfigData('freeRoundsTextStyle', 'fill', [standardColor]),
        });
        this._freeRoundsDisclaimerStyle = new PIXI.TextStyle({
            fontFamily: this.getConfigData('freeRoundsDisclaimerStyle', 'fontFamily', baseFontFamily),
            fontSize: this.getConfigData('freeRoundsDisclaimerStyle', 'fontSize', lowerMiddleFontSize),
            align: this.getConfigData('freeRoundsDisclaimerStyle', 'align', 'center'),
            fontWeight: this.getConfigData('freeRoundsDisclaimerStyle', 'fontWeight', 'bold'),
            wordWrap: true,
            wordWrapWidth: wordWrapWidth,
            fill: this.getConfigData('freeRoundsDisclaimerStyle', 'fill', [redColor]),
        });
        this._freeRoundsSmallTextStyle = new PIXI.TextStyle({
            fontFamily: this.getConfigData('freeRoundsSmallTextStyle', 'fontFamily', baseFontFamily),
            fontSize: this.getConfigData('freeRoundsSmallTextStyle', 'fontSize', baseFontSize),
            align: this.getConfigData('freeRoundsSmallTextStyle', 'align', 'center'),
            fontWeight: this.getConfigData('freeRoundsSmallTextStyle', 'fontWeight', 'bold'),
            wordWrap: true,
            wordWrapWidth: wordWrapWidth,
            fill: this.getConfigData('freeRoundsSmallTextStyle', 'fill', [standardColor]),
        });
        this._freeRoundsButtonTextStyle = new PIXI.TextStyle({
            fontFamily: this.getConfigData('freeRoundsButtonTextStyle', 'fontFamily', baseFontFamily),
            fontSize: this.getConfigData('freeRoundsButtonTextStyle', 'fontSize', baseFontSize),
            align: this.getConfigData('freeRoundsButtonTextStyle', 'align', 'center'),
            fontWeight: this.getConfigData('freeRoundsButtonTextStyle', 'fontWeight', 'bold'),
            fill: this.getConfigData('freeRoundsButtonTextStyle', 'fill', titleColor),
            stroke: this.getConfigData('freeRoundsButtonTextStyle', 'stroke', '#bbbb00'),
            wordWrap: true,
            wordWrapWidth: wordWrapWidth,
        });
        this._freeRoundsSuperSmallTextStyle = new PIXI.TextStyle({
            fontFamily: this.getConfigData('freeRoundsSuperSmallTextStyle', 'fontFamily', baseFontFamily),
            fontSize: this.getConfigData('freeRoundsSuperSmallTextStyle', 'fontSize', smallFontSize),
            align: this.getConfigData('freeRoundsSuperSmallTextStyle', 'align', 'center'),
            fontWeight: this.getConfigData('freeRoundsSuperSmallTextStyle', 'fontWeight', 'bold'),
            wordWrap: true,
            wordWrapWidth: wordWrapWidth,
            fill: this.getConfigData('freeRoundsSuperSmallTextStyle', 'fill', [standardColor]),
        });
        if (locale === 'ka') {
            this._freeRoundsCaptionStyle.padding = bigFontSize * 0.5;
            this._freeRoundsTextStyle.padding = lowerMiddleFontSize * 0.5;
            this._freeRoundsDisclaimerStyle.padding = lowerMiddleFontSize * 0.5;
            this._freeRoundsSmallTextStyle.padding = baseFontSize * 0.5;
            this._freeRoundsButtonTextStyle.padding = baseFontSize * 0.5;
            this._freeRoundsSuperSmallTextStyle.padding = smallFontSize * 0.5;
        }
        this._baseFontArial = new PIXI.TextStyle({
            fontFamily: this.getConfigData('baseFontArial', 'fontFamily', baseFontFamily),
            fontSize: this.getConfigData('baseFontArial', 'fontSize', smallFontSize),
            fontWeight: this.getConfigData('baseFontArial', 'fontWeight', 'bold'),
            wordWrap: true,
            fill: this.getConfigData('baseFontArial', 'fill', [standardColor]),
        });
        this._cheatFontArial = new PIXI.TextStyle({
            fontFamily: this.getConfigData('cheatFontArial', 'fontFamily', baseFontFamily),
            fontSize: this.getConfigData('cheatFontArial', 'fontSize', smallFontSize),
            fontStyle: this.getConfigData('cheatFontArial', 'fontStyle', 'italic'),
            fontWeight: this.getConfigData('cheatFontArial', 'fontWeight', 'bold'),
            fill: this.getConfigData('cheatFontArial', 'fill', ['#00ff99']),
        });
        this._featureTextStyle = new PIXI.TextStyle({
            align: this.getConfigData('featureTextStyle', 'align', 'center'),
            fontFamily: this.getConfigData('featureTextStyle', 'fontFamily', baseFontFamily),
            fontSize: this.getConfigData('featureTextStyle', 'fontSize', baseFontSize),
            fontWeight: this.getConfigData('featureTextStyle', 'fontWeight', 'bold'),
            fill: this.getConfigData('featureTextStyle', 'fill', ['#ffffff']),
            wordWrap: true,
        });
        this._featureScreenTextStyle = new PIXI.TextStyle({
            align: this.getConfigData('featureScreenTextStyle', 'align', 'left'),
            fontFamily: this.getConfigData('featureScreenTextStyle', 'fontFamily', baseFontFamily),
            fontSize: this.getConfigData('featureScreenTextStyle', 'fontSize', notTooSmallFontSize),
            fontWeight: this.getConfigData('featureScreenTextStyle', 'fontWeight', 'bold'),
            fill: this.getConfigData('featureScreenTextStyle', 'fill', ['#ffffff']),
            wordWrap: true,
            wordWrapWidth: this._resolutionManager.resolution.width * (580 / this._resolutionManager.resolution.width),
        });
        this._featureScreenCaptionTextStyle = new PIXI.TextStyle({
            align: this.getConfigData('featureScreenCaptionTextStyle', 'align', 'left'),
            fontFamily: this.getConfigData('featureScreenCaptionTextStyle', 'fontFamily', baseFontFamily),
            fontSize: this.getConfigData('featureScreenCaptionTextStyle', 'fontSize', notTooSmallFontSize),
            fontWeight: this.getConfigData('featureScreenCaptionTextStyle', 'fontWeight', 'bold'),
            fill: this.getConfigData('featureScreenCaptionTextStyle', 'fill', ['#ffffff']),
            wordWrap: true,
            wordWrapWidth: this._resolutionManager.resolution.width,
        });
        if (locale === 'ka') {
            this._featureTextStyle.padding = 10;
        }
        this._titlesFont = new PIXI.TextStyle({
            align: this.getConfigData('titlesFont', 'align', 'center'),
            fontFamily: this.getConfigData('titlesFont', 'fontFamily', specialFont),
            fontWeight: this.getConfigData('titlesFont', 'fontWeight', '900'),
            fill: this.getConfigData('titlesFont', 'fill', [standardColor]),
            fontSize: this.getConfigData('titlesFont', 'fontSize', bigFontSize),
            wordWrap: true,
            padding: this.getConfigData('titlesFont', 'padding', 10),
            breakWords: true,
            wordWrapWidth: this._resolutionManager.resolution.width * 0.8,
        });
        this._specialTitlesFont = new PIXI.TextStyle({
            align: this.getConfigData('specialTitlesFont', 'align', 'center'),
            fontFamily: this.getConfigData('specialTitlesFont', 'fontFamily', specialFont),
            fontWeight: this.getConfigData('specialTitlesFont', 'fontWeight', '900'),
            fill: this.getConfigData('specialTitlesFont', 'fill', [standardColor]),
            fontSize: this.getConfigData('specialTitlesFont', 'fontSize', bigFontSize),
            wordWrap: true,
            padding: this.getConfigData('specialTitlesFont', 'padding', 10),
        });
        this._subtitlesFont = new PIXI.TextStyle({
            align: this.getConfigData('subtitlesFont', 'align', 'center'),
            fontFamily: this.getConfigData('subtitlesFont', 'fontFamily', baseFontFamily),
            fontWeight: this.getConfigData('subtitlesFont', 'fontWeight', '600'),
            fontStyle: this.getConfigData('subtitlesFont', 'fontStyle', 'italic'),
            fill: this.getConfigData('subtitlesFont', 'fill', [standardColor]),
            fontSize: this.getConfigData('subtitlesFont', 'fontSize', middleFontSize),
        });
        this._breadTextFont = new PIXI.TextStyle({
            fontFamily: this.getConfigData('breadTextFont', 'fontFamily', baseFontFamily),
            fontSize: this.getConfigData('breadTextFont', 'fontSize', baseFontSize),
            align: this.getConfigData('breadTextFont', 'align', 'left'),
            fill: this.getConfigData('breadTextFont', 'fill', [standardColor]),
            wordWrap: true,
            wordWrapWidth: this._resolutionManager.resolution.width * 0.8,
        });
        this._gameRulesTextStyle = new PIXI.TextStyle({
            fontFamily: this.getConfigData('gameRulesTextStyle', 'fontFamily', baseFontFamily),
            fontSize: this.getConfigData('gameRulesTextStyle', 'fontSize', baseFontSize),
            align: this.getConfigData('gameRulesTextStyle', 'align', 'left'),
            fill: this.getConfigData('gameRulesTextStyle', 'fill', [standardColor]),
            wordWrap: true,
            wordWrapWidth: this._resolutionManager.resolution.width * 0.8,
        });
        this._breadTextHeavyFont = new PIXI.TextStyle({
            fontFamily: this.getConfigData('breadTextHeavyFont', 'fontFamily', baseFontFamily),
            fontSize: this.getConfigData('breadTextHeavyFont', 'fontSize', lowerMiddleFontSize),
            align: this.getConfigData('breadTextHeavyFont', 'align', 'left'),
            fill: this.getConfigData('breadTextHeavyFont', 'fill', [ocurrenceColor]),
            fontWeight: this.getConfigData('breadTextHeavyFont', 'fontWeight', '900'),
            wordWrap: true,
        });
        this._breadTextHeavyWhiteFont = new PIXI.TextStyle({
            fontFamily: this.getConfigData('breadTextHeavyWhiteFont', 'fontFamily', baseFontFamily),
            fontSize: this.getConfigData('breadTextHeavyWhiteFont', 'fontSize', lowerMiddleFontSize),
            align: this.getConfigData('breadTextHeavyWhiteFont', 'align', 'left'),
            fill: this.getConfigData('breadTextHeavyWhiteFont', 'fill', [standardColor]),
            fontWeight: this.getConfigData('breadTextHeavyWhiteFont', 'fontWeight', '900'),
            wordWrap: true,
        });
        this._guiInfoNumbers = new PIXI.TextStyle({
            fontFamily: this.getConfigData('guiInfoNumbers', 'fontFamily', strongFontFamily),
            fontWeight: this.getConfigData('guiInfoNumbers', 'fontWeight', '600'),
            fontSize: this.getConfigData('guiInfoNumbers', 'fontSize', this._device.isMobile ? baseFontSize + 2 : baseFontSize),
            fill: this.getConfigData('guiInfoNumbers', 'fill', [standardColor]),
            stroke: this.getConfigData('guiInfoNumbers', 'stroke', 'white'),
            strokeThickness: this.getConfigData('guiInfoNumbers', 'strokeThickness', 1),
        });
        this._guiInfoText = new PIXI.TextStyle({
            fontFamily: this.getConfigData('guiInfoText', 'fontFamily', baseFontFamily),
            fontSize: this.getConfigData('guiInfoText', 'fontSize', baseFontSize),
            fontWeight: this.getConfigData('guiInfoText', 'fontWeight', '600'),
            fill: this.getConfigData('guiInfoText', 'fill', [standardColor]),
            stroke: this.getConfigData('guiInfoText', 'stroke', 'white'),
            strokeThickness: this.getConfigData('guiInfoText', 'strokeThickness', 1),
        });
        this._guiInfoWinFieldNumbers = new PIXI.TextStyle({
            fontFamily: this.getConfigData('guiInfoWinFieldNumbers', 'fontFamily', strongFontFamily),
            fontWeight: this.getConfigData('guiInfoWinFieldNumbers', 'fontWeight', '600'),
            fontSize: this.getConfigData('guiInfoWinFieldNumbers', 'fontSize', this._device.isMobile ? baseFontSize + 2 : baseFontSize),
            fill: this.getConfigData('guiInfoWinFieldNumbers', 'fill', [standardColor]),
            stroke: this.getConfigData('guiInfoWinFieldNumbers', 'stroke', 'white'),
            strokeThickness: this.getConfigData('guiInfoWinFieldNumbers', 'strokeThickness', 1),
        });
        this._gameSpecificWinFieldNumbers = new PIXI.TextStyle({
            fontFamily: this.getConfigData('gameSpecificWinFieldNumbers', 'fontFamily', strongFontFamily),
            fontWeight: this.getConfigData('gameSpecificWinFieldNumbers', 'fontWeight', '600'),
            fontSize: this.getConfigData('gameSpecificWinFieldNumbers', 'fontSize', this._device.isMobile ? baseFontSize + 2 : baseFontSize),
            fill: this.getConfigData('gameSpecificWinFieldNumbers', 'fill', [standardColor]),
            stroke: this.getConfigData('gameSpecificWinFieldNumbers', 'stroke', 'white'),
            strokeThickness: this.getConfigData('gameSpecificWinFieldNumbers', 'strokeThickness', 1),
        });
        this._guiInfoWinFieldText = new PIXI.TextStyle({
            fontFamily: this.getConfigData('guiInfoWinFieldText', 'fontFamily', baseFontFamily),
            fontWeight: this.getConfigData('guiInfoWinFieldText', 'fontWeight', '600'),
            fontSize: this.getConfigData('guiInfoWinFieldText', 'fontSize', baseFontSize),
            fill: this.getConfigData('guiInfoWinFieldText', 'fill', [standardColor]),
            stroke: this.getConfigData('guiInfoWinFieldText', 'stroke', 'white'),
            strokeThickness: this.getConfigData('guiInfoWinFieldText', 'strokeThickness', 1),
        });
        var menuLeading = locale === 'th' ? 0 : 7;
        var menuSpacing = locale === 'th' ? 0 : 5;
        this._mainMenuTitle = new PIXI.TextStyle({
            align: this.getConfigData('mainMenuTitle', 'align', 'center'),
            fontFamily: this.getConfigData('mainMenuTitle', 'fontFamily', specialFont),
            fontSize: this.getConfigData('mainMenuTitle', 'fontSize', biggestFontSize),
            fill: this.getConfigData('mainMenuTitle', 'fill', [titleColor]),
            stroke: this.getConfigData('mainMenuTitle', 'stroke', '#bbbb00'),
            strokeThickness: this.getConfigData('mainMenuTitle', 'strokeThickness', 2),
            letterSpacing: this.getConfigData('mainMenuTitle', 'letterSpacing', menuSpacing),
            wordWrap: true,
            lineHeight: this.getConfigData('mainMenuTitle', 'lineHeight', biggestFontSize * 0.9),
            padding: this.getConfigData('mainMenuTitle', 'padding', 10),
            dropShadow: this.getConfigData('mainMenuTitle', 'dropShadow', false),
            dropShadowAngle: this.getConfigData('mainMenuTitle', 'dropShadowAngle', 1),
            dropShadowBlur: this.getConfigData('mainMenuTitle', 'dropShadowBlur', 1),
            dropShadowColor: this.getConfigData('mainMenuTitle', 'dropShadowColor', blackColor),
            dropShadowDistance: this.getConfigData('mainMenuTitle', 'dropShadowDistance', 1),
        });
        this._mainMenuBread = new PIXI.TextStyle({
            fontFamily: this.getConfigData('mainMenuBread', 'fontFamily', specialFont),
            fontSize: this.getConfigData('mainMenuBread', 'fontSize', bigFontSize),
            fill: this.getConfigData('mainMenuBread', 'fill', [standardColor]),
            stroke: this.getConfigData('mainMenuBread', 'stroke', '#bbbb00'),
            strokeThickness: this.getConfigData('mainMenuBread', 'strokeThickness', 2),
            letterSpacing: this.getConfigData('mainMenuBread', 'letterSpacing', menuSpacing),
            wordWrap: true,
        });
        var settingsLeading = locale === 'th' ? 0 : 7;
        var settingsSpacing = locale === 'th' ? 0 : 5;
        this._settingsSubtitle = new PIXI.TextStyle({
            fontFamily: this.getConfigData('settingsSubtitle', 'fontFamily', specialFont),
            align: this.getConfigData('settingsSubtitle', 'align', 'center'),
            fontSize: this.getConfigData('settingsSubtitle', 'fontSize', biggestFontSize),
            fill: this.getConfigData('settingsSubtitle', 'fill', ['#ffe846']),
            leading: this.getConfigData('settingsSubtitle', 'leading', settingsLeading),
            letterSpacing: this.getConfigData('settingsSubtitle', 'letterSpacing', settingsSpacing),
        });
        this._settingsDescription = new PIXI.TextStyle({
            fontFamily: this.getConfigData('settingsDescription', 'fontFamily', specialFont),
            align: this.getConfigData('settingsDescription', 'align', 'left'),
            fontSize: this.getConfigData('settingsDescription', 'fontSize', middleFontSize),
            fill: this.getConfigData('settingsDescription', 'fill', ['#ffe846']),
            leading: this.getConfigData('settingsDescription', 'leading', settingsLeading),
            letterSpacing: this.getConfigData('settingsDescription', 'letterSpacing', 0),
            lineHeight: this.getConfigData('settingsDescription', 'lineHeight', middleFontSize * 0.95),
            wordWrap: true,
        });
        this._autoplaySettingsDescription = new PIXI.TextStyle({
            fontFamily: this.getConfigData('autoplaySettingsDescription', 'fontFamily', specialFont),
            align: this.getConfigData('autoplaySettingsDescription', 'align', 'left'),
            fontSize: this.getConfigData('autoplaySettingsDescription', 'fontSize', middleFontSize),
            fill: this.getConfigData('autoplaySettingsDescription', 'fill', ['#ffe846']),
            leading: this.getConfigData('autoplaySettingsDescription', 'leading', settingsLeading),
            letterSpacing: this.getConfigData('autoplaySettingsDescription', 'letterSpacing', 0),
            lineHeight: this.getConfigData('autoplaySettingsDescription', 'lineHeight', middleFontSize * 0.95),
        });
        this._autoplaySettingsDescription.wordWrapWidth = this._resolutionManager.resolution.width * 0.6;
        if (locale === 'th' || locale === 'zh-cn' || locale === 'zh-tw') {
            this._autoplaySettingsDescription.fontSize = middleFontSize;
        }
        else if (locale === 'sl' || locale === 'vi') {
            this._autoplaySettingsDescription.fontSize = notTooSmallFontSize;
        }
        else {
            this._autoplaySettingsDescription.fontSize = baseFontSize;
        }
        this._buttonMenuTitleStyle = new PIXI.TextStyle({
            align: this.getConfigData('buttonMenuTitleStyle', 'align', 'center'),
            fontFamily: this.getConfigData('buttonMenuTitleStyle', 'fontFamily', specialFont),
            fontSize: this.getConfigData('buttonMenuTitleStyle', 'fontSize', biggestFontSize),
            fill: this.getConfigData('buttonMenuTitleStyle', 'fill', [titleColor]),
            stroke: this.getConfigData('buttonMenuTitleStyle', 'stroke', '#bbbb00'),
            strokeThickness: this.getConfigData('buttonMenuTitleStyle', 'strokeThickness', 2),
            letterSpacing: this.getConfigData('buttonMenuTitleStyle', 'letterSpacing', menuSpacing),
            wordWrap: true,
            lineHeight: this.getConfigData('buttonMenuTitleStyle', 'lineHeight', biggestFontSize * 0.9),
            padding: this.getConfigData('buttonMenuTitleStyle', 'padding', 10),
            dropShadow: this.getConfigData('buttonMenuTitleStyle', 'dropShadow', false),
            dropShadowAngle: this.getConfigData('buttonMenuTitleStyle', 'dropShadowAngle', 1),
            dropShadowBlur: this.getConfigData('buttonMenuTitleStyle', 'dropShadowBlur', 1),
            dropShadowColor: this.getConfigData('buttonMenuTitleStyle', 'dropShadowColor', blackColor),
            dropShadowDistance: this.getConfigData('buttonMenuTitleStyle', 'dropShadowDistance', 1),
        });
        this._buttonBaseStyle = new PIXI.TextStyle({
            fontFamily: this.getConfigData('buttonBaseStyle', 'fontFamily', strongFontFamily),
            fontSize: this.getConfigData('buttonBaseStyle', 'fontSize', middleFontSize),
            fill: this.getConfigData('buttonBaseStyle', 'fill', ['#ffff66']),
            dropShadow: this.getConfigData('buttonBaseStyle', 'dropShadow', true),
            dropShadowBlur: this.getConfigData('buttonBaseStyle', 'dropShadowBlur', 3),
            dropShadowDistance: this.getConfigData('buttonBaseStyle', 'dropShadowDistance', 2),
            dropShadowColor: this.getConfigData('buttonBaseStyle', 'dropShadowColor', blackColor),
        });
        this._smallButtonBaseStyle = new PIXI.TextStyle({
            fontFamily: this.getConfigData('smallButtonBaseStyle', 'fontFamily', strongFontFamily),
            fontSize: this.getConfigData('smallButtonBaseStyle', 'fontSize', smallFontSize + 4),
            fill: this.getConfigData('smallButtonBaseStyle', 'fill', ['#ffff66']),
            stroke: this.getConfigData('smallButtonBaseStyle', 'stroke', '#bbbb00'),
            strokeThickness: this.getConfigData('smallButtonBaseStyle', 'strokeThickness', 2),
        });
        this._buttonOverStyle = new PIXI.TextStyle({
            fontFamily: this.getConfigData('buttonOverStyle', 'fontFamily', strongFontFamily),
            fontSize: this.getConfigData('buttonOverStyle', 'fontSize', middleFontSize),
            fill: this.getConfigData('buttonOverStyle', 'fill', [standardColor]),
            dropShadow: this.getConfigData('buttonOverStyle', 'dropShadow', true),
            dropShadowBlur: this.getConfigData('buttonOverStyle', 'dropShadowBlur', 3),
            dropShadowDistance: this.getConfigData('buttonOverStyle', 'dropShadowDistance', 2),
            dropShadowColor: this.getConfigData('buttonOverStyle', 'dropShadowColor', blackColor),
        });
        this._buttonDownStyle = new PIXI.TextStyle({
            fontFamily: this.getConfigData('buttonDownStyle', 'fontFamily', strongFontFamily),
            fontSize: this.getConfigData('buttonDownStyle', 'fontSize', middleFontSize),
            fill: this.getConfigData('buttonDownStyle', 'fill', ['#dddddd']),
            dropShadow: this.getConfigData('buttonDownStyle', 'dropShadow', true),
            dropShadowBlur: this.getConfigData('buttonDownStyle', 'dropShadowBlur', 3),
            dropShadowDistance: this.getConfigData('buttonDownStyle', 'dropShadowDistance', 2),
            dropShadowColor: this.getConfigData('buttonDownStyle', 'dropShadowColor', blackColor),
        });
        this._buttonDisabledStyle = new PIXI.TextStyle({
            fontFamily: this.getConfigData('buttonDisabledStyle', 'fontFamily', strongFontFamily),
            fontSize: this.getConfigData('buttonDisabledStyle', 'fontSize', middleFontSize),
            fill: this.getConfigData('buttonDisabledStyle', 'fill', ['#666666']),
            dropShadow: this.getConfigData('buttonDisabledStyle', 'dropShadow', true),
            dropShadowBlur: this.getConfigData('buttonDisabledStyle', 'dropShadowBlur', 3),
            dropShadowDistance: this.getConfigData('buttonDisabledStyle', 'dropShadowDistance', 2),
            dropShadowColor: this.getConfigData('buttonDisabledStyle', 'dropShadowColor', blackColor),
        });
        this._limitErrorTextStyle = new PIXI.TextStyle({
            fontFamily: this.getConfigData('limitErrorTextStyle', 'fontFamily', strongFontFamily),
            fontSize: this.getConfigData('limitErrorTextStyle', 'fontFamily', notTooSmallFontSize),
            align: this.getConfigData('limitErrorTextStyle', 'fontFamily', 'left'),
            wordWrap: true,
            wordWrapWidth: this._resolutionManager.resolution.width * 0.6,
            fill: this.getConfigData('limitErrorTextStyle', 'fontFamily', [errorColor]),
        });
        this._infoPopup = new PIXI.TextStyle({
            fontFamily: this.getConfigData('infoPopup', 'fontFamily', baseFontFamily),
            fontSize: this.getConfigData('infoPopup', 'fontSize', baseFontSize),
            fontWeight: this.getConfigData('infoPopup', 'fontWeight', '700'),
            fill: this.getConfigData('infoPopup', 'fill', [standardColor]),
            stroke: this.getConfigData('infoPopup', 'stroke', '#4a1850'),
            strokeThickness: this.getConfigData('infoPopup', 'strokeThickness', 3),
            wordWrap: true,
            wordWrapWidth: 600 - 220,
            align: this.getConfigData('infoPopup', 'align', 'center'),
        });
        this._spinsLeftStyle = new PIXI.TextStyle({
            fontFamily: this.getConfigData('spinsLeftStyle', 'fontFamily', baseFontFamily),
            fontSize: this.getConfigData('spinsLeftStyle', 'fontSize', 20),
            fontWeight: this.getConfigData('spinsLeftStyle', 'fontWeight', 'bold'),
            fill: this.getConfigData('spinsLeftStyle', 'fill', [standardColor]),
            stroke: this.getConfigData('spinsLeftStyle', 'stroke', blackColor),
            strokeThickness: this.getConfigData('spinsLeftStyle', 'strokeThickness', 4),
        });
        this._historyBoxFont = new PIXI.TextStyle({
            fontFamily: this.getConfigData('historyBoxFont', 'fontFamily', specialFont),
            fontSize: this.getConfigData('historyBoxFont', 'fontFamily', 20),
            fontWeight: this.getConfigData('historyBoxFont', 'fontFamily', 'normal'),
            fill: this.getConfigData('historyBoxFont', 'fontFamily', [standardColor]),
        });
        this._historyBoxMultiplierFont = new PIXI.TextStyle({
            fontFamily: this.getConfigData('historyBoxMultiplierFont', 'fontFamily', specialFont),
            fontSize: this.getConfigData('historyBoxMultiplierFont', 'fontSize', baseFontSize),
            fontWeight: this.getConfigData('historyBoxMultiplierFont', 'fontWeight', 'normal'),
            fill: this.getConfigData('historyBoxMultiplierFont', 'fill', [standardColor]),
        });
    };
    TextStyles.prototype.getFontFamily = function (locale, fontMap) {
        if (!fontMap.hasOwnProperty(locale)) {
            return fontMap.standard;
        }
        return fontMap[locale];
    };
    TextStyles.prototype.getConfigData = function (configName, parameterName, parameterByDefault) {
        var config = this._config.getConfigByName(configName);
        if (!config) {
            return parameterByDefault;
        }
        var parameterDataFromConfig = config.getParameter(parameterName);
        if (parameterDataFromConfig instanceof Array) {
            return parameterDataFromConfig.length > 0 ? config.getParameter(parameterName) : parameterByDefault;
        }
        return parameterDataFromConfig ? parameterDataFromConfig : parameterByDefault;
    };
    Object.defineProperty(TextStyles.prototype, "baseFontArial", {
        get: function () {
            return this._baseFontArial;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextStyles.prototype, "cheatFontArial", {
        get: function () {
            return this._cheatFontArial;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextStyles.prototype, "guiInfoText", {
        get: function () {
            return this._guiInfoText;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextStyles.prototype, "guiInfoNumbers", {
        get: function () {
            return this._guiInfoNumbers;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextStyles.prototype, "guiInfoWinFieldText", {
        get: function () {
            return this._guiInfoWinFieldText;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextStyles.prototype, "guiInfoWinFieldNumbers", {
        get: function () {
            return this._guiInfoWinFieldNumbers;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextStyles.prototype, "titlesFont", {
        get: function () {
            return this._titlesFont;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextStyles.prototype, "specialTitlesFont", {
        get: function () {
            return this._specialTitlesFont;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextStyles.prototype, "subtitlesFont", {
        get: function () {
            return this._subtitlesFont;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextStyles.prototype, "breadTextFont", {
        get: function () {
            return this._breadTextFont;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextStyles.prototype, "breadTextHeavyFont", {
        get: function () {
            return this._breadTextHeavyFont;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextStyles.prototype, "breadTextHeavyWhiteFont", {
        get: function () {
            return this._breadTextHeavyWhiteFont;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextStyles.prototype, "mainMenuTitle", {
        get: function () {
            return this._mainMenuTitle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextStyles.prototype, "mainMenuBread", {
        get: function () {
            return this._mainMenuBread;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextStyles.prototype, "settingsSubtitle", {
        get: function () {
            return this._settingsSubtitle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextStyles.prototype, "settingsDescription", {
        get: function () {
            return this._settingsDescription;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextStyles.prototype, "autoplaySettingsDescription", {
        get: function () {
            return this._autoplaySettingsDescription;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextStyles.prototype, "buttonMenuTitleStyle", {
        get: function () {
            return this._buttonMenuTitleStyle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextStyles.prototype, "buttonBaseStyle", {
        get: function () {
            return this._buttonBaseStyle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextStyles.prototype, "smallButtonBaseStyle", {
        get: function () {
            return this._smallButtonBaseStyle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextStyles.prototype, "buttonOverStyle", {
        get: function () {
            return this._buttonOverStyle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextStyles.prototype, "buttonDownStyle", {
        get: function () {
            return this._buttonDownStyle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextStyles.prototype, "buttonDisabledStyle", {
        get: function () {
            return this._buttonDisabledStyle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextStyles.prototype, "infoPopup", {
        get: function () {
            return this._infoPopup;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextStyles.prototype, "spinsLeftStyle", {
        get: function () {
            return this._spinsLeftStyle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextStyles.prototype, "featureTextStyle", {
        get: function () {
            return this._featureTextStyle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextStyles.prototype, "featureScreenTextStyle", {
        get: function () {
            return this._featureScreenTextStyle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextStyles.prototype, "featureScreenCaptionTextStyle", {
        get: function () {
            return this._featureScreenCaptionTextStyle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextStyles.prototype, "freeRoundsCaptionStyle", {
        get: function () {
            return this._freeRoundsCaptionStyle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextStyles.prototype, "freeRoundsTextStyle", {
        get: function () {
            return this._freeRoundsTextStyle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextStyles.prototype, "freeRoundsDisclaimerStyle", {
        get: function () {
            return this._freeRoundsDisclaimerStyle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextStyles.prototype, "freeRoundsSmallTextStyle", {
        get: function () {
            return this._freeRoundsSmallTextStyle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextStyles.prototype, "freeRoundsButtonTextStyle", {
        get: function () {
            return this._freeRoundsButtonTextStyle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextStyles.prototype, "freeRoundsSuperSmallTextStyle", {
        get: function () {
            return this._freeRoundsSuperSmallTextStyle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextStyles.prototype, "limitErrorTextStyle", {
        get: function () {
            return this._limitErrorTextStyle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextStyles.prototype, "gameRulesTextStyle", {
        get: function () {
            return this._gameRulesTextStyle;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextStyles.prototype, "historyBoxFont", {
        get: function () {
            return this._historyBoxFont;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextStyles.prototype, "historyBoxMultiplierFont", {
        get: function () {
            return this._historyBoxMultiplierFont;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextStyles.prototype, "gameSpecificWinFieldNumbers", {
        get: function () {
            return this._gameSpecificWinFieldNumbers;
        },
        enumerable: true,
        configurable: true
    });
    TextStyles = __decorate([
        inversify_1.injectable(),
        __metadata("design:paramtypes", [])
    ], TextStyles);
    return TextStyles;
}());
exports.TextStyles = TextStyles;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var RectangleArea = /** @class */ (function () {
    function RectangleArea(width, height) {
        if (width === void 0) { width = 0; }
        if (height === void 0) { height = 0; }
        this._width = width;
        this._height = height;
    }
    Object.defineProperty(RectangleArea.prototype, "width", {
        get: function () {
            return this._width;
        },
        set: function (value) {
            this._width = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RectangleArea.prototype, "height", {
        get: function () {
            return this._height;
        },
        set: function (value) {
            this._height = value;
        },
        enumerable: true,
        configurable: true
    });
    return RectangleArea;
}());
exports.RectangleArea = RectangleArea;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = __webpack_require__(14);
var CoreDI_1 = __webpack_require__(32);
var ScreenEvents_1 = __webpack_require__(108);
var Device_1 = __webpack_require__(42);
var VisibilityManager = /** @class */ (function () {
    function VisibilityManager() {
        var _this = this;
        this._visible = true;
        var hidden;
        var visibilityState;
        var visibilityChange;
        if ('hidden' in document) {
            hidden = 'hidden';
            visibilityChange = 'visibilitychange';
            visibilityState = 'visibilityState';
        }
        else if ('mozHidden' in document) {
            hidden = 'mozHidden';
            visibilityChange = 'mozvisibilitychange';
            visibilityState = 'mozVisibilityState';
        }
        else if ('msHidden' in document) {
            hidden = 'msHidden';
            visibilityChange = 'msvisibilitychange';
            visibilityState = 'msVisibilityState';
        }
        else if ('webkitHidden' in document) {
            hidden = 'webkitHidden';
            visibilityChange = 'webkitvisibilitychange';
            visibilityState = 'webkitVisibilityState';
        }
        window.onblur = this.onChange.bind(this);
        window.onfocus = this.onChange.bind(this);
        window.onpagehide = this.onChange.bind(this);
        window.onpageshow = this.onChange.bind(this);
        if (document.addEventListener && hidden) {
            document.addEventListener(visibilityChange, function () {
                if (document[visibilityState] === 'visible') {
                    _this._visible = true;
                    _this._eventManager.emit(ScreenEvents_1.ScreenEvents.BECAME_VISIBLE);
                    _this._onVisibleCallback && _this._onVisibleCallback();
                }
                else if (document[visibilityState] === 'hidden') {
                    _this._visible = false;
                    _this._eventManager.emit(ScreenEvents_1.ScreenEvents.BECAME_INVISIBLE);
                    _this._onInvisibleCallback && _this._onInvisibleCallback();
                }
            }, false);
        }
    }
    VisibilityManager.prototype.onChange = function (event) {
        if (this._device.isMobile) {
            if (event.type === 'pagehide' || event.type === 'blur') {
                this._visible = false;
                this._onInvisibleCallback && this._onInvisibleCallback();
                this._eventManager.emit(ScreenEvents_1.ScreenEvents.BECAME_INVISIBLE);
            }
            else if (event.type === 'pageshow' || event.type === 'focus') {
                this._visible = true;
                this._eventManager.emit(ScreenEvents_1.ScreenEvents.BECAME_VISIBLE);
                this._onVisibleCallback && this._onVisibleCallback();
            }
        }
    };
    Object.defineProperty(VisibilityManager.prototype, "visible", {
        get: function () {
            return this._visible;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisibilityManager.prototype, "onVisibleCallback", {
        set: function (value) {
            this._onVisibleCallback = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VisibilityManager.prototype, "onInvisibleCallback", {
        set: function (value) {
            this._onInvisibleCallback = value;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        inversify_1.inject(CoreDI_1.CoreDI.IEventManagerWithAsync),
        __metadata("design:type", Object)
    ], VisibilityManager.prototype, "_eventManager", void 0);
    __decorate([
        inversify_1.inject(CoreDI_1.CoreDI.Device),
        __metadata("design:type", Device_1.Device)
    ], VisibilityManager.prototype, "_device", void 0);
    VisibilityManager = __decorate([
        inversify_1.injectable(),
        __metadata("design:paramtypes", [])
    ], VisibilityManager);
    return VisibilityManager;
}());
exports.VisibilityManager = VisibilityManager;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = __webpack_require__(14);
var Translator = /** @class */ (function () {
    function Translator() {
    }
    Translator.prototype.init = function (locale) {
        this.locale = locale;
    };
    Translator.prototype.getObject = function (id) {
        var _this = this;
        var subIds = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            subIds[_i - 1] = arguments[_i];
        }
        if (this.localeObjects && this.localeObjects[id]) {
            if (subIds.length > 0) {
                var reducedStrings = subIds.reduce(function (result, item) {
                    if (!result || !result[item]) {
                        if (false) {
                            console.warn("MISSING TRANSLATION / STRING FOR \"" + item + "\".");
                        }
                        return _this.getEnglishObject.apply(_this, [id].concat(subIds));
                    }
                    return result[item];
                }, this.localeObjects[id]);
                return this.flattenString(reducedStrings);
            }
            return this.flattenString(this.localeObjects[id]);
        }
        return this.getEnglishObject.apply(this, [id].concat(subIds));
    };
    Translator.prototype.getEnglishObject = function (id) {
        var subIds = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            subIds[_i - 1] = arguments[_i];
        }
        if (this._englishLocale && this._englishLocale[id]) {
            if (subIds.length > 0) {
                var reducedStrings = subIds.reduce(function (result, item) {
                    if (!result || !result[item]) {
                        return '';
                    }
                    return result[item];
                }, this._englishLocale[id]);
                return this.flattenString(reducedStrings);
            }
            return this.flattenString(this._englishLocale[id]);
        }
        return '';
    };
    Translator.prototype.flattenString = function (stringObject) {
        if (Array.isArray(stringObject)) {
            var flattenedObject = stringObject.join(' ');
            return flattenedObject;
        }
        else {
            return stringObject;
        }
    };
    Object.defineProperty(Translator.prototype, "locale", {
        get: function () {
            return this._locale;
        },
        set: function (value) {
            this._locale = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Translator.prototype, "localeObjects", {
        get: function () {
            return this._localeStrings;
        },
        set: function (value) {
            this._localeStrings = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Translator.prototype, "englishObject", {
        get: function () {
            return this._englishLocale;
        },
        set: function (value) {
            this._englishLocale = value;
        },
        enumerable: true,
        configurable: true
    });
    Translator = __decorate([
        inversify_1.injectable(),
        __metadata("design:paramtypes", [])
    ], Translator);
    return Translator;
}());
exports.Translator = Translator;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SpineAnimation_1 = __webpack_require__(37);
var SpineAnimationMultiTrack_1 = __webpack_require__(147);
var SpineButton_1 = __webpack_require__(234);
var Spine_1 = __webpack_require__(25);
var View_1 = __webpack_require__(3);
var LocalizedSpineButton_1 = __webpack_require__(478);
var SpineUtils = /** @class */ (function () {
    function SpineUtils(resources, updateManager, container) {
        this._isCreationStarted = false;
        this._resources = resources;
        this._defaultUpdateManager = updateManager;
        this._defaultContainer = container;
    }
    SpineUtils.prototype.setSkin = function (skeleton, skinName) {
        skeleton.setSkin(null);
        skeleton.setSkinByName(skinName);
    };
    SpineUtils.prototype.startSpineAnimationCreation = function (spineName, animationName, loop, loopLimit) {
        if (loopLimit === void 0) { loopLimit = -1; }
        if (this._isCreationStarted) {
            throw new Error('SpineUtils last object creation was not finished properly. Maybe createAndStart was not called');
        }
        this._isCreationStarted = true;
        this._currentSpineName = spineName;
        this._currentAnimationName = animationName;
        this._currentLoopState = loop;
        this._currentLoopLimit = loopLimit;
        // setting up default values
        this._currentPosition = { x: 0, y: 0 };
        this._currentRotation = 0;
        this._currentDontDestroyOnCompleteState = false;
        this._currentContainer = this._defaultContainer;
        this._currentUpdateManager = this._defaultUpdateManager;
        this._currentOnComplete = null;
        this._chainedIdleAnimation = null;
        this._currentViewType = View_1.ViewTypes.DESKTOP;
        return this;
    };
    SpineUtils.prototype.viewType = function (viewType) {
        this._currentViewType = viewType;
        return this;
    };
    SpineUtils.prototype.onComplete = function (callback) {
        this._currentOnComplete = callback;
        return this;
    };
    SpineUtils.prototype.position = function (newX, newY) {
        if (newX.x) {
            this._currentPosition = newX;
        }
        else {
            this._currentPosition = { x: newX, y: newY };
        }
        return this;
    };
    SpineUtils.prototype.rotation = function (angle) {
        this._currentRotation = angle;
        return this;
    };
    SpineUtils.prototype.dontDestroyOnCompleted = function (newDontDestroyOnCompletedStatus) {
        this._currentDontDestroyOnCompleteState = newDontDestroyOnCompletedStatus;
        return this;
    };
    SpineUtils.prototype.container = function (newContainer) {
        this._currentContainer = newContainer;
        return this;
    };
    SpineUtils.prototype.updateManager = function (newUpdateManager) {
        this._currentUpdateManager = newUpdateManager;
        return this;
    };
    SpineUtils.prototype.chainIdleAnimation = function (animation) {
        this._chainedIdleAnimation = animation;
        return this;
    };
    SpineUtils.prototype.createAndStart = function () {
        var spineAnimation = new SpineAnimation_1.SpineAnimation(new Spine_1.Spine(this._resources.getSpine(this._currentSpineName, this._currentViewType)), this._currentAnimationName, this._currentLoopState, this._currentDontDestroyOnCompleteState);
        if (this._currentLoopLimit > 0) {
            spineAnimation.setLoopLimit(this._currentLoopLimit);
        }
        if (this._chainedIdleAnimation) {
            spineAnimation.chainIdleAnimation(this._chainedIdleAnimation);
        }
        if (this._currentRotation) {
            spineAnimation.container.rotation = this._currentRotation;
        }
        spineAnimation.start();
        if (false) {
            if (!spineAnimation.container.skeleton) {
                throw new Error("Spine Skeleton does not exist. Probably missing keyframes in starting animation. Skeleton-name:" + spineAnimation.container.name + " Animation-name:" + spineAnimation.name);
            }
        }
        this._currentUpdateManager.add(spineAnimation);
        this._currentContainer.addChild(spineAnimation.container);
        spineAnimation.container.position.set(this._currentPosition.x, this._currentPosition.y);
        if (this._currentOnComplete) {
            spineAnimation.setOnComplete(this._currentOnComplete);
        }
        this._isCreationStarted = false;
        return spineAnimation;
    };
    SpineUtils.prototype.startExit = function (animation, exitAnimationName, onComplete) {
        if (!animation) {
            throw new Error('SpineUtils::startExit animation can not be null');
        }
        animation.unChainIdleAnimation();
        animation.changeAnimationTo(exitAnimationName, false);
        animation.setOnComplete(onComplete);
    };
    SpineUtils.prototype.createMultitrack = function () {
        var spineMultitrack = new SpineAnimationMultiTrack_1.SpineAnimationMultiTrack(new Spine_1.Spine(this._resources.getSpine(this._currentSpineName)), this._currentAnimationName, this._currentLoopState);
        if (this._chainedIdleAnimation) {
            spineMultitrack.chainIdleAnimation(this._chainedIdleAnimation);
        }
        spineMultitrack.start();
        this._currentUpdateManager.add(spineMultitrack);
        this._currentContainer.addChild(spineMultitrack.container);
        spineMultitrack.container.position.set(this._currentPosition.x, this._currentPosition.y);
        if (this._currentOnComplete) {
            spineMultitrack.setOnComplete(this._currentOnComplete);
        }
        this._isCreationStarted = false;
        return spineMultitrack;
    };
    SpineUtils.prototype.replaceElementInSpineAnimation = function (animation, slotName, newSprite) {
        var slotIndex = animation.container.skeleton.findSlotIndex(slotName);
        var container = animation.container.slotContainers[slotIndex];
        this.replaceItemInContainer(container, newSprite);
    };
    SpineUtils.prototype.replaceElementInSpineMultiTrack = function (animation, slotName, newSprite) {
        var slotIndex = animation.container.skeleton.findSlotIndex(slotName);
        var container = animation.container.slotContainers[slotIndex];
        this.replaceItemInContainer(container, newSprite);
    };
    SpineUtils.prototype.replaceElementInSpine = function (spine, slotName, newSprite) {
        var container = spine.slotContainers[spine.skeleton.findSlotIndex(slotName)];
        if (false) {
            if (!container) {
                throw new Error("SpineUtils::replaceElementInSpine - no Slot named: " + slotName + " in " + spine.spineData.name);
            }
        }
        this.replaceItemInContainer(container, newSprite);
    };
    SpineUtils.prototype.destroyAllPlaceholderGraphic = function (spine) {
        this.destroyAllGraphicsWithName(spine, 'PLACEHOLDER');
    };
    SpineUtils.prototype.destroyAllGraphicsWithName = function (spine, textureName) {
        var slotContainers = spine.slotContainers;
        if (slotContainers && slotContainers.length) {
            slotContainers.forEach(function (slot) {
                if (slot.children) {
                    slot.children.forEach(function (child) {
                        if (child.region && child.region.name === textureName) {
                            child.destroy();
                        }
                    });
                }
            });
        }
    };
    SpineUtils.prototype.findSlotContainerByName = function (spine, slotName) {
        return spine.slotContainers[spine.skeleton.findSlotIndex(slotName)];
    };
    SpineUtils.prototype.clearSlotContainerByName = function (spine, slotName) {
        this.findSlotContainerByName(spine, slotName).children.forEach(function (child) {
            child.visible = false;
            child.parent = null;
        });
    };
    SpineUtils.prototype.stopAndDestroyAnimation = function (animation) {
        if (animation) {
            animation.forceDestroy();
            if (animation.container.parent) {
                animation.container.parent.removeChild(animation.container);
            }
        }
    };
    SpineUtils.prototype.createSpineButton = function (resourceName, clickCallback, loopIdle, loopDown, loopOver, loopDisabled) {
        if (loopIdle === void 0) { loopIdle = false; }
        var button = new SpineButton_1.SpineButton(clickCallback);
        button.setupButton(new Spine_1.Spine(this._resources.getSpine(resourceName)), this._defaultUpdateManager);
        button.setAnimations('IDLE', 'CLICK', 'HOVER', 'DISABLED');
        button.setAnimationsLoop(loopIdle, loopDown, loopOver, loopDisabled);
        button.anchor.set(0.5, 0.5);
        button.enable();
        return button;
    };
    SpineUtils.prototype.createLocalizedSpineButton = function (resourceName, clickCallback, locals, slots, loopIdle, loopDown, loopOver, loopDisabled) {
        if (loopIdle === void 0) { loopIdle = false; }
        var button = new LocalizedSpineButton_1.LocalizedSpineButton(clickCallback, this, this._resources);
        button.setupButton(new Spine_1.Spine(this._resources.getSpine(resourceName)), this._defaultUpdateManager);
        button.setAnimations('IDLE', 'CLICK', 'HOVER', 'DISABLED');
        button.setAnimationsLoop(loopIdle, loopDown, loopOver, loopDisabled);
        button.setupLocales(locals[0], locals[1] ? locals[1] : locals[0], locals[2] ? locals[2] : locals[0], locals[3] ? locals[3] : locals[0]);
        button.setupButtonSlots(slots[0], slots[1] ? slots[1] : slots[0], slots[2] ? slots[2] : slots[0], slots[3] ? slots[3] : slots[0]);
        button.anchor.set(0.5, 0.5);
        button.enable();
        return button;
    };
    SpineUtils.prototype.getAnimationDuration = function (resourceName, animationName) {
        return this._resources.getSpine(resourceName).findAnimation(animationName).duration;
    };
    SpineUtils.prototype.getAnimationsTotalDuration = function (resourceName, animationNames) {
        var totalDuration = 0;
        for (var anim in animationNames) {
            if (animationNames.hasOwnProperty(anim)) {
                var name_1 = animationNames[anim];
                totalDuration += this.getAnimationDuration(resourceName, name_1);
            }
        }
        return totalDuration;
    };
    SpineUtils.prototype.getSkeletonDataFromSpine = function (spine) {
        return spine.skeleton.data;
    };
    SpineUtils.prototype.getSkeletonDataFromSpineAnimation = function (spineAnimation) {
        return spineAnimation.container.skeleton.data;
    };
    SpineUtils.prototype.getSkeletonDataFromSpineAnimationMultiTrack = function (spineAnimation) {
        return spineAnimation.container.skeleton.data;
    };
    /**
     *  Takes a skeleton data object and parses the absolute position of the bone in setup pose.
     * @param {PIXI.spine.core.SkeletonData} skeletonData
     * @param {string} boneName
     * @returns {Position}
     * @memberof SpineUtils
     */
    SpineUtils.prototype.getBoneAbsolutePosition = function (skeletonData, boneName) {
        var bone = skeletonData.findBone(boneName);
        var position = { x: 0, y: 0 };
        while (bone.parent) {
            position.x += bone.x;
            position.y += bone.y;
            bone = bone.parent;
        }
        return position;
    };
    SpineUtils.prototype.getSlotAttachmentData = function (skeletonData, slot) {
        var slotObject = skeletonData.findSlot(slot);
        return skeletonData.defaultSkin.getAttachment(slotObject.index, slotObject.attachmentName);
    };
    SpineUtils.prototype.getSlotAttachmentDimensions = function (skeletonData, slot) {
        var attachment = this.getSlotAttachmentData(skeletonData, slot);
        return { width: attachment.width, height: attachment.height, scale: { x: attachment.scaleX, y: attachment.scaleY } };
    };
    SpineUtils.prototype.replaceItemInContainer = function (container, sprite) {
        sprite.anchor.set(0.5, 0.5);
        sprite.position.set(-sprite.height * 0.5);
        if (container.children[0]) {
            sprite.transform = container.children[0].transform;
        }
        else {
            sprite.rotation = Math.PI;
            sprite.skew.y = Math.PI;
        }
        container.removeChildren();
        container.addChild(sprite);
    };
    Object.defineProperty(SpineUtils.prototype, "defaultUpdateManager", {
        get: function () {
            return this._defaultUpdateManager;
        },
        enumerable: true,
        configurable: true
    });
    return SpineUtils;
}());
exports.SpineUtils = SpineUtils;


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Button_1 = __webpack_require__(54);
var SpineAnimation_1 = __webpack_require__(37);
var SpineButton = /** @class */ (function (_super) {
    __extends(SpineButton, _super);
    function SpineButton(callback) {
        var _this = _super.call(this, callback) || this;
        _this._animation = {};
        _this._animationLoop = {};
        _this._skin = '';
        _this._onClickIsOverState = true;
        return _this;
    }
    SpineButton.prototype.remove = function () {
        this._spineAnimation.stop();
        this._spine.destroy();
        this.destroy();
    };
    SpineButton.prototype.setOnClickIsOverState = function (clickIsOverState) {
        this._onClickIsOverState = clickIsOverState;
    };
    SpineButton.prototype.setupButton = function (spine, updateManager, skin) {
        this._updateManager = updateManager;
        this._spine = spine;
        this.addChild(this._spine);
        this._skin = skin;
        this._spineAnimation = new SpineAnimation_1.SpineAnimation(spine, 'IDLE', true, true);
        this.setSkinOnAnimation();
        this._spineAnimation.start();
        this._updateManager.add(this._spineAnimation);
    };
    SpineButton.prototype.setAnimations = function (up, down, over, disabled) {
        this._animation[Button_1.ButtonState.UP] = up;
        this._animation[Button_1.ButtonState.DOWN] = down ? down : up;
        this._animation[Button_1.ButtonState.OVER] = over ? over : up;
        this._animation[Button_1.ButtonState.DISABLED] = disabled ? disabled : up;
    };
    SpineButton.prototype.setAnimationsLoop = function (up, down, over, disabled) {
        this._animationLoop[Button_1.ButtonState.UP] = up;
        this._animationLoop[Button_1.ButtonState.DOWN] = this.isUndefined(down) ? up : down;
        this._animationLoop[Button_1.ButtonState.OVER] = this.isUndefined(over) ? up : over;
        this._animationLoop[Button_1.ButtonState.DISABLED] = this.isUndefined(disabled) ? up : disabled;
    };
    SpineButton.prototype.onClick = function () {
        if (this._onClickIsOverState) {
            _super.prototype.onClick.call(this);
        }
        else {
            if (this._callback) {
                this._callback();
            }
            else {
                console.warn('There is no a callback.');
            }
        }
    };
    SpineButton.prototype.cleanFrame = function () {
        if (this._spineAnimation && this._spineAnimation.isPlaying) {
            this._spineAnimation.stop();
        }
    };
    SpineButton.prototype.updateFrame = function () {
        if (this._animation[this._state]) {
            this.cleanFrame();
            this._spineAnimation = new SpineAnimation_1.SpineAnimation(this._spine, this._animation[this._state], this._animationLoop[this._state], true);
            this.setSkinOnAnimation();
            this._updateManager.add(this._spineAnimation);
            this._spineAnimation.start();
        }
    };
    SpineButton.prototype.setSkinOnAnimation = function () {
        if (this._skin && this._skin.length > 0) {
            this._spineAnimation.container.skeleton.setSkin(null);
            this._spineAnimation.container.skeleton.setSkinByName(this._skin);
        }
    };
    SpineButton.prototype.isUndefined = function (value) {
        return typeof value === 'undefined';
    };
    Object.defineProperty(SpineButton.prototype, "container", {
        get: function () {
            return this._spine;
        },
        enumerable: true,
        configurable: true
    });
    return SpineButton;
}(Button_1.Button));
exports.SpineButton = SpineButton;


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Timer_1 = __webpack_require__(28);
var TimerUtils = /** @class */ (function () {
    function TimerUtils(updateManager) {
        this._updateManager = updateManager;
    }
    TimerUtils.prototype.oneFrameTimer = function (callback) {
        var timer = new Timer_1.Timer(callback, 0, true);
        this._updateManager.add(timer);
        return timer;
    };
    TimerUtils.prototype.createTimer = function (callback, delay) {
        var timer = new Timer_1.Timer(callback, delay, true);
        this._updateManager.add(timer);
        return timer;
    };
    TimerUtils.prototype.killTimer = function (timer) {
        if (timer) {
            timer.stop();
        }
    };
    return TimerUtils;
}());
exports.TimerUtils = TimerUtils;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var System_1 = __webpack_require__(52);
var GameResourceLoader_1 = __webpack_require__(237);
var ReelConstants_1 = __webpack_require__(10);
var GameSystem = /** @class */ (function (_super) {
    __extends(GameSystem, _super);
    function GameSystem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameSystem.prototype.createResourceLoader = function (getBaseUrlPath) {
        return new GameResourceLoader_1.GameResourceLoader(this.device, getBaseUrlPath, this.getLocale(), this._majorCaveatPerformance);
    };
    GameSystem.prototype.isSupportedDeviceAndBrowser = function (device) {
        var deviceIsSupported = true;
        if (deviceIsSupported && device.isMobile && device.isOppoBrowser) {
            deviceIsSupported = false;
        }
        return deviceIsSupported;
    };
    GameSystem.prototype.setupReelConstants = function () {
        ReelConstants_1.ReelConstants.setReelsAmount(5);
        ReelConstants_1.ReelConstants.setRowAmount(3);
    };
    GameSystem.prototype.getCurrencyISO = function () {
        this._currencyFormatter.setupCurrencyFromISO(this.urlParams
            && this.urlParams.currency
            ? this.urlParams.currency : 'USD');
        return this.urlParams && this.urlParams.currency ? this.urlParams.currency : 'USD';
    };
    return GameSystem;
}(System_1.System));
exports.GameSystem = GameSystem;


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var ResourcesLoader_1 = __webpack_require__(69);
var inversify_1 = __webpack_require__(14);
var MicrogamingPreloaderV2_1 = __webpack_require__(238);
var BaseMicorgamingPreloaderView_1 = __webpack_require__(485);
var GameResourceLoader = /** @class */ (function (_super) {
    __extends(GameResourceLoader, _super);
    function GameResourceLoader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameResourceLoader.prototype.addLocaleLogo = function () {
        if (this._locale.indexOf('zh') > -1) {
            if (this._locale.indexOf('cn') > -1) {
                this._resources.push('LOGO_ZH_CN.png');
                this._resources.push('LOGO_ZH_CN_STARTSCREEN.png');
            }
            else {
                this._resources.push('LOGO_ZH_TW.png');
                this._resources.push('LOGO_ZH_TW_STARTSCREEN.png');
            }
        }
        else {
            this._resources.push('LOGOTYPE.png');
        }
    };
    GameResourceLoader.prototype.removeUnsupportedLocales = function () {
        var _this = this;
        // For debugging and developing.
        if (!this.shouldRemoveUnsupportedLocales) {
            return;
        }
        this._translationResources = this._translationResources.filter(function (item) {
            var lang = item.split('/languages/')[1].split('.')[0];
            if (_this._supportedLocales.indexOf(lang) > -1) {
                return true;
            }
        });
        this._localeTexts = this._localeTexts.filter(function (item) {
            var lang = item.split('LOCALE_TEXTS/')[1].split('.')[0];
            if (_this._supportedLocales.indexOf(lang) > -1) {
                return true;
            }
        });
    };
    GameResourceLoader.prototype.addPreloader = function () {
        this._preloader = new MicrogamingPreloaderV2_1.MicrogamingPreloaderV2(this._getUrlPath, this._device, BaseMicorgamingPreloaderView_1.BaseMicrogamingPreloaderView);
        this._preloader.createLoadingScreen();
    };
    GameResourceLoader.prototype.getPaytableHTML = function () {
        if (!this.shouldRemoveUnsupportedLocales || this._supportedLocales.indexOf[this.getLocale()] > -1) {
            return _super.prototype.getPaytableHTML.call(this);
        }
        return this._helpFilesMap["html/paytable/paytable_en.htm"];
    };
    GameResourceLoader.prototype.getGameRulesHTML = function () {
        if (!this.shouldRemoveUnsupportedLocales || this._supportedLocales.indexOf[this.getLocale()] > -1) {
            return _super.prototype.getGameRulesHTML.call(this);
        }
        return this._helpFilesMap["html/gamerules/gamerules_en.htm"];
    };
    GameResourceLoader.prototype.initialize = function () {
        this._loadingLandscapeAndPortraitResources = false;
        this.shouldRemoveUnsupportedLocales = false;
        this._mobileSoundResourcesFiles = [
            'resources/mobileSounds/all.mp3',
            // music
            'resources/sounds/music/music_main_1.mp3',
            'resources/sounds/music/music_main_2.mp3',
            'resources/sounds/music/music_main_3.mp3',
            'resources/sounds/music/music_fs.mp3',
            'resources/sounds/music/win_bigwin_loop.mp3',
        ];
        this._soundResources = [
            'resources/sounds/atn_respin.mp3',
            'resources/sounds/atn_scatter_1.mp3',
            'resources/sounds/atn_scatter_2.mp3',
            'resources/sounds/atn_scatter_3.mp3',
            'resources/sounds/btn_general.mp3',
            'resources/sounds/btn_spin_start.mp3',
            'resources/sounds/btn_spin_stop.mp3',
            'resources/sounds/mult_collect_fly.mp3',
            'resources/sounds/mult_collect_hit.mp3',
            'resources/sounds/mult_collect_indicator.mp3',
            'resources/sounds/mult_update.mp3',
            'resources/sounds/mult_update_fs.mp3',
            'resources/sounds/mult_wildbreak.mp3',
            'resources/sounds/mult_win.mp3',
            'resources/sounds/music/music_main_1.mp3',
            'resources/sounds/music/music_main_2.mp3',
            'resources/sounds/music/music_main_3.mp3',
            'resources/sounds/music/music_fs.mp3',
            'resources/sounds/near_fs.mp3',
            'resources/sounds/reels_fall_in.mp3',
            'resources/sounds/reels_fall_in_3sec.mp3',
            'resources/sounds/reels_fall_out.mp3',
            'resources/sounds/reels_remove.mp3',
            'resources/sounds/rsp_activate.mp3',
            'resources/sounds/rsp_hit01.mp3',
            'resources/sounds/rsp_hit02.mp3',
            'resources/sounds/rsp_hit03.mp3',
            'resources/sounds/rsp_move.mp3',
            'resources/sounds/rsp_end.mp3',
            'resources/sounds/trans_game_intro.mp3',
            'resources/sounds/trans_fs_intro.mp3',
            'resources/sounds/trans_fs_outro.mp3',
            'resources/sounds/win_bigwin_buildup.mp3',
            'resources/sounds/win_bigwin_end.mp3',
            'resources/sounds/music/win_bigwin_loop.mp3',
            'resources/sounds/win_bigwin_threshold.mp3',
            'resources/sounds/win_countup.mp3',
            'resources/sounds/win_excellent.mp3',
            'resources/sounds/win_indicate_lr.mp3',
            'resources/sounds/win_indicate_rl.mp3',
            'resources/sounds/win_nice.mp3',
            'resources/sounds/win_normal.mp3',
            'resources/sounds/win_retrigger.mp3',
        ];
        this._configFiles = ['resources/config.json'];
        this._spineAtlasFile = 'SPINE_TEXTURES.atlas';
        this._atlasImages = ['SPINE_TEXTURES.png', 'SPINE_TEXTURES2.png', 'SPINE_TEXTURES3.png', 'SPINE_TEXTURES4.png', 'SPINE_TEXTURES5.png', 'SPINE_TEXTURES6.png', 'SPINE_TEXTURES7.png', 'SPINE_TEXTURES8.png'];
        if (this._device.isMobile) {
            this._atlasImages = ['SPINE_TEXTURES.png', 'SPINE_TEXTURES2.png', 'SPINE_TEXTURES3.png', 'SPINE_TEXTURES4.png'];
        }
        this._helpStyles = ['HTML/STYLE.css'];
        this._helpFiles = ['HTML/PAYTABLE/Paytable_en.htm', 'HTML/GAMERULES/Gamerules_en.htm']; // Load the english ones.
        this._mobileSoundDataFile = 'resources/mobileSounds/all.json';
        this._particleResources = [
            // particles
            'resources/particles/NICE_WIN_COINS.json',
            'resources/particles/EXCELLENT_WIN_COINS.json',
            'resources/particles/BIG_WIN_COINS.json',
            'resources/particles/SUPER_WIN_COINS.json',
            'resources/particles/MEGA_WIN_COINS.json',
            'resources/particles/EPIC_WIN_COINS.json',
            'resources/particles/EPIC_WIN_WAVE_COINS.json',
            "resources/particles/" + (this._device.isMobile ? 'MOBILE' : 'DESKTOP') + "/COIN.json",
        ];
        this._translationResources = [
            'resources/languages/en.json',
            'resources/languages/bg.json',
            'resources/languages/cs.json',
            'resources/languages/da.json',
            'resources/languages/de.json',
            'resources/languages/el.json',
            'resources/languages/es.json',
            'resources/languages/es-419.json',
            'resources/languages/et.json',
            'resources/languages/fi.json',
            'resources/languages/fr.json',
            'resources/languages/hr.json',
            'resources/languages/hu.json',
            'resources/languages/id.json',
            'resources/languages/is.json',
            'resources/languages/it.json',
            'resources/languages/ja.json',
            'resources/languages/ko.json',
            'resources/languages/lt.json',
            'resources/languages/lv.json',
            'resources/languages/nl.json',
            'resources/languages/no.json',
            'resources/languages/pl.json',
            'resources/languages/pt.json',
            'resources/languages/pt-br.json',
            'resources/languages/ro.json',
            'resources/languages/ru.json',
            'resources/languages/sk.json',
            'resources/languages/sl.json',
            'resources/languages/sv.json',
            'resources/languages/sr.json',
            'resources/languages/th.json',
            'resources/languages/tr.json',
            'resources/languages/vi.json',
            'resources/languages/zh.json',
            'resources/languages/zh-cn.json',
            'resources/languages/zh-hant.json',
            'resources/languages/zh-tw.json',
        ];
        this._spineResources = [
            'ACCEPT_BUTTON.json',
            'ARROW_BUTTON.json',
            'AUTOPLAY_BUTTON.json',
            'AUTOPLAY_MENU.json',
            'BIG_WINS.json',
            'BIG_WINS_GLOW.json',
            'BIG_WINS_EFFECT_01.json',
            'BIG_WINS_EFFECT_02.json',
            'BIG_WINS_EFFECT_03.json',
            'BONUS_SCATTER.json',
            'BOX_MENU.json',
            'DECLINE_BUTTON.json',
            'ERROR_MESSAGE.png',
            'FEATURE_SCREENS.json',
            'FREESPIN_BUTTON.json',
            'FREESPIN_STARTSCREEN.json',
            'FREESPIN_COMPLETE_SCREEN.json',
            'FREESPIN_FEATURE_SCREENS.json',
            'GENERIC_BUTTON.json',
            'SETTINGS_MENU.json',
            'GUI_INFO.json',
            'LOGOTYPE.json',
            'PLAY_BUTTON.json',
            'BET_BUTTON.json',
            'MENU_BUTTON.json',
            'MAIN_MENU.json',
            'SETTINGS_CONFIG_BUTTON.json',
            'STARTSCREEN.json',
            'SPIN_BUTTON_NOGLOW.json',
            'SPIN_BUTTON_GLOW.json',
            'SPIN_BUTTON_NOGLOW_AUTOPLAY.json',
            'INFO_MESSAGE.png',
            'START_BUTTON.json',
            'WIN_NUMBERS.json',
            'RESPIN.json',
            'WIN_SCREEN.json',
            'BASEGAME_BACKGROUND.json',
            'FREESPINS_BACKGROUND.json',
            'LAYOUT_TEMPLATE.json',
            'LAYOUT_TEMPLATE_FREESPIN.json',
            'TOP_REEL.json',
            'TOP_REEL_EFFECT.json',
            'ROW_DIVIDER.json',
            'ROW_DIVIDER_EFFECT.json',
            'SYMBOL_REMOVE.json',
            'TOP_BONUS.json',
            'TOP_RESPIN.json',
            'TOP_WILD.json',
            'WILD_MULTIPLIER_METER.json',
            'WILD_MULTIPLIER.json',
            'WILD.json',
            'WILD_SOUL.json',
            'INITIAL_WIN.json',
            'INITIAL_WIN_COVER.json',
            'TEXT_ANNOUNCEMENT.json',
            'WILD_MULTIPLIER_EFFECT.json',
        ];
        this._resources = [
            'LAYOUT_TEMPLATE.json',
            'LAYOUT_TEMPLATE_FREESPIN.json',
            'TILT_ICON.png',
            'TOUCH_ICON.png',
            'INFO_MESSAGE.png',
            'ERROR_MESSAGE.png',
            'SYMBOLS.json',
            'HUD.json',
            'NUMBERS.json',
            // Added for safety check.
            'LOCALE_TEXTS/en.json',
        ];
        this.addLocaleLogo();
        this._resources = this._resources.concat(this._spineResources);
        ////////////////////////////////////////////////////////////////////
        // Device specific resources.
        ////////////////////////////////////////////////////////////////////
        if (!this._device.isMobile) {
            ////////////////////////////////////////////////////////////////////
            // PC
            ////////////////////////////////////////////////////////////////////
            var pcResources = [];
            this._resources = this._resources.concat(pcResources);
        }
        else {
            ////////////////////////////////////////////////////////////////////
            // Mobile
            ////////////////////////////////////////////////////////////////////
            var mobileResources = ['TOUCH_ICON.png'];
            this._resources = this._resources.concat(mobileResources);
        }
        this._localeTexts = [
            'LOCALE_TEXTS/en.json',
            'LOCALE_TEXTS/bg.json',
            'LOCALE_TEXTS/cs.json',
            'LOCALE_TEXTS/da.json',
            'LOCALE_TEXTS/de.json',
            'LOCALE_TEXTS/el.json',
            'LOCALE_TEXTS/es.json',
            'LOCALE_TEXTS/es-419.json',
            'LOCALE_TEXTS/et.json',
            'LOCALE_TEXTS/fi.json',
            'LOCALE_TEXTS/fr.json',
            'LOCALE_TEXTS/hr.json',
            'LOCALE_TEXTS/hu.json',
            'LOCALE_TEXTS/id.json',
            'LOCALE_TEXTS/is.json',
            'LOCALE_TEXTS/it.json',
            'LOCALE_TEXTS/ja.json',
            'LOCALE_TEXTS/ko.json',
            'LOCALE_TEXTS/lt.json',
            'LOCALE_TEXTS/lv.json',
            'LOCALE_TEXTS/nl.json',
            'LOCALE_TEXTS/no.json',
            'LOCALE_TEXTS/pt.json',
            'LOCALE_TEXTS/pl.json',
            'LOCALE_TEXTS/pt-br.json',
            'LOCALE_TEXTS/ro.json',
            'LOCALE_TEXTS/ru.json',
            'LOCALE_TEXTS/sk.json',
            'LOCALE_TEXTS/sl.json',
            'LOCALE_TEXTS/sv.json',
            'LOCALE_TEXTS/sr.json',
            'LOCALE_TEXTS/th.json',
            'LOCALE_TEXTS/tr.json',
            'LOCALE_TEXTS/vi.json',
            'LOCALE_TEXTS/zh.json',
            'LOCALE_TEXTS/zh-cn.json',
            'LOCALE_TEXTS/zh-hant.json',
            'LOCALE_TEXTS/zh-tw.json',
        ];
        this._currencyResources = [
            'CURRENCIES/AED.json',
            'CURRENCIES/ALL.json',
            'CURRENCIES/AMD.json',
            'CURRENCIES/AOA.json',
            'CURRENCIES/ARS.json',
            'CURRENCIES/ATS.json',
            'CURRENCIES/AUD.json',
            'CURRENCIES/BAM.json',
            'CURRENCIES/BEF.json',
            'CURRENCIES/BGN.json',
            'CURRENCIES/BOB.json',
            'CURRENCIES/BRL.json',
            'CURRENCIES/CAD.json',
            'CURRENCIES/CDF.json',
            'CURRENCIES/CHF.json',
            'CURRENCIES/CNY.json',
            'CURRENCIES/COP.json',
            'CURRENCIES/CRC.json',
            'CURRENCIES/CVE.json',
            'CURRENCIES/CZK.json',
            'CURRENCIES/DEM.json',
            'CURRENCIES/DJF.json',
            'CURRENCIES/DKK.json',
            'CURRENCIES/DOP.json',
            'CURRENCIES/DZD.json',
            'CURRENCIES/EEK.json',
            'CURRENCIES/EGP.json',
            'CURRENCIES/ERN.json',
            'CURRENCIES/ESP.json',
            'CURRENCIES/ETB.json',
            'CURRENCIES/EUR.json',
            'CURRENCIES/FIM.json',
            'CURRENCIES/FRF.json',
            'CURRENCIES/GBP.json',
            'CURRENCIES/GEL.json',
            'CURRENCIES/GHC.json',
            'CURRENCIES/GHS.json',
            'CURRENCIES/GMD.json',
            'CURRENCIES/GNF.json',
            'CURRENCIES/GRD.json',
            'CURRENCIES/HKD.json',
            'CURRENCIES/HNL.json',
            'CURRENCIES/HRK.json',
            'CURRENCIES/HUF.json',
            'CURRENCIES/IDR.json',
            'CURRENCIES/IEP.json',
            'CURRENCIES/ILS.json',
            'CURRENCIES/INR.json',
            'CURRENCIES/ITL.json',
            'CURRENCIES/JPY.json',
            'CURRENCIES/KES.json',
            'CURRENCIES/KGS.json',
            'CURRENCIES/KHR.json',
            'CURRENCIES/KMF.json',
            'CURRENCIES/KRW.json',
            'CURRENCIES/KZT.json',
            'CURRENCIES/LAK.json',
            'CURRENCIES/LRD.json',
            'CURRENCIES/LSL.json',
            'CURRENCIES/LTL.json',
            'CURRENCIES/LVL.json',
            'CURRENCIES/LYD.json',
            'CURRENCIES/MAD.json',
            'CURRENCIES/MDL.json',
            'CURRENCIES/MMK.json',
            'CURRENCIES/MOP.json',
            'CURRENCIES/MRO.json',
            'CURRENCIES/MUR.json',
            'CURRENCIES/MWK.json',
            'CURRENCIES/MXN.json',
            'CURRENCIES/MYR.json',
            'CURRENCIES/MZN.json',
            'CURRENCIES/NAD.json',
            'CURRENCIES/NGN.json',
            'CURRENCIES/NLG.json',
            'CURRENCIES/NOK.json',
            'CURRENCIES/NZD.json',
            'CURRENCIES/PEN.json',
            'CURRENCIES/PHP.json',
            'CURRENCIES/PKR.json',
            'CURRENCIES/PLN.json',
            'CURRENCIES/PTE.json',
            'CURRENCIES/PYG.json',
            'CURRENCIES/RDS.json',
            'CURRENCIES/RON.json',
            'CURRENCIES/RUB.json',
            'CURRENCIES/RWF.json',
            'CURRENCIES/SCR.json',
            'CURRENCIES/SDG.json',
            'CURRENCIES/SEK.json',
            'CURRENCIES/SGD.json',
            'CURRENCIES/SIK.json',
            'CURRENCIES/SKK.json',
            'CURRENCIES/SZL.json',
            'CURRENCIES/THB.json',
            'CURRENCIES/TRL.json',
            'CURRENCIES/TRY.json',
            'CURRENCIES/TWD.json',
            'CURRENCIES/TZH.json',
            'CURRENCIES/UAH.json',
            'CURRENCIES/UGX.json',
            'CURRENCIES/USD.json',
            'CURRENCIES/UYU.json',
            'CURRENCIES/VEF.json',
            'CURRENCIES/VND.json',
            'CURRENCIES/XAF.json',
            'CURRENCIES/XCD.json',
            'CURRENCIES/XOF.json',
            'CURRENCIES/ZAR.json',
            'CURRENCIES/ZMW.json',
        ];
    };
    GameResourceLoader.prototype.loadNextConfigFile = function (resource) {
        if (this._configFilesLoaded >= 0) {
            if (resource.error === null && resource.url && resource.data !== null) {
                var name_1 = resource.url;
                this._configFilesMap[name_1.substring(name_1.lastIndexOf('/') + 1, name_1.length)] = resource.data;
            }
        }
        this._configFilesLoaded++;
        if (this._configFilesLoaded >= this._configFilesExpectedToLoad) {
            this._configFilesLoadingCompletedCallback();
            return;
        }
        this._loader.reset();
        if (this._configFiles[this._configFilesLoaded].indexOf('cdnconfig.json') >= 0) {
            this._loader.add(location.protocol + "//" + location.host + "/casino/cdnconfig.json", {}, this.loadNextConfigFile.bind(this));
        }
        else {
            this._loader.add(this.getPathForResource(this._configFiles[this._configFilesLoaded]), {}, this.loadNextConfigFile.bind(this));
        }
        this._loader.load();
        this.updateProgress();
    };
    GameResourceLoader = __decorate([
        inversify_1.injectable()
    ], GameResourceLoader);
    return GameResourceLoader;
}(ResourcesLoader_1.ResourcesLoader));
exports.GameResourceLoader = GameResourceLoader;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MicrogamingPreloaderUtils_1 = __webpack_require__(239);
var MicrogamingPreloaderV2 = /** @class */ (function () {
    function MicrogamingPreloaderV2(baseUrlPath, device, preloaderViewClass) {
        this._hasPublisherSplash = true;
        this._canUpdateProgress = false;
        this._getUrlPath = device.isMobile ?
            function (path) { return baseUrlPath('resources/Mobile/' + path); } :
            function (path) { return baseUrlPath('resources/Desktop/' + path); };
        this._device = device;
        this._preloaderViewClass = preloaderViewClass;
        // load Microgaming css styles
        var _link = document.createElement('link');
        _link.type = 'text/css';
        _link.rel = 'stylesheet';
        _link.href = MicrogamingPreloaderUtils_1.MicrogamingPreloaderUtils.getContentUrl() + MicrogamingPreloaderUtils_1.MicrogamingPreloaderUtils.getPublisherPath() + 'pub.css';
        document.head.appendChild(_link);
        // if (!__PRODUCTION__) {
        // 	// Overide brand temporarily.
        // 	const brand: string = Publishers.DGC;
        //
        // 	if (brand) {
        // 		(window as any).mgsConfig.casinoInfo.publisher = brand;
        // 		(window as any).mgsConfig.branding.publisher.path = (window as any).mgsConfig.branding.publisher.path.replace('mgs', brand);
        // 	}
        // }
        if (window.mgsConfig.casinoInfo.publisher) {
            this._publisherName = window.mgsConfig.casinoInfo.publisher;
        }
        if (window.mgsConfig.branding) {
            this._isPoweredByEnabled = window.mgsConfig.branding.poweredBy.enabled;
        }
        this._canHaveFantasmaStuff = this._isPoweredByEnabled && (this._publisherName === 'mgs' || this._publisherName === 'quickfire');
        window._canHaveFantasmaStuff = this._canHaveFantasmaStuff;
    }
    MicrogamingPreloaderV2.prototype.getExtraConfigLogic = function () {
        return null;
    };
    MicrogamingPreloaderV2.prototype.createLoadingScreen = function () {
        var _this = this;
        this.checkIfPublisherSplashExists(function () {
            var config = _this.getConfig();
            _this._view = new _this._preloaderViewClass();
            var parentItem = document.getElementById('preloader');
            _this._view.init(parentItem, config, _this._getUrlPath);
            _this._onResizeBind = _this.onResizeEvent.bind(_this);
            window.addEventListener('resize', _this._onResizeBind);
            _this.onResizeEvent();
            _this._canUpdateProgress = true;
        });
    };
    MicrogamingPreloaderV2.prototype.endLoading = function () {
        this._view.endLoading();
        window.removeEventListener('resize', this._onResizeBind);
    };
    MicrogamingPreloaderV2.prototype.updateProgress = function (totalItems, current) {
        if (this._canUpdateProgress) {
            this._view.updateProgress(totalItems, current);
        }
    };
    MicrogamingPreloaderV2.prototype.usingUnsupportedDeviceOrBrowser = function () {
    };
    MicrogamingPreloaderV2.prototype.checkIfPublisherSplashExists = function (callback) {
        var _this = this;
        var msgConfig = window.mgsConfig;
        var publisherName = msgConfig.casinoInfo.publisher;
        var triedLoads = 0;
        var totalShouldLoad = 1;
        var onerror = function () {
            _this._hasPublisherSplash = false;
            triedLoads += 1;
            if (triedLoads >= totalShouldLoad) {
                callback && callback();
            }
        };
        var onload = function () {
            _this._hasPublisherSplash = _this._hasPublisherSplash && true;
            triedLoads += 1;
            if (triedLoads >= totalShouldLoad) {
                callback && callback();
            }
        };
        switch (publisherName) {
            case Publishers.DGC:
            case Publishers.Microgaming_Asia:
            case Publishers.UPG:
            case Publishers.Microgaming:
            case Publishers.Microgaming_QuickFire:
                if (publisherName === Publishers.DGC || publisherName === Publishers.UPG || publisherName === Publishers.Microgaming_Asia) {
                    // Try loading PublisherSplash.jpg and PublisherSplashPortrait.jpg.
                    totalShouldLoad = 2;
                    if (publisherName === Publishers.DGC) {
                        // Try loading PublisherSplash.jpg, PublisherSplashPortrait.jpg and disclaimer.png
                        totalShouldLoad = 3;
                        var checkPublisherLogo_1 = MicrogamingPreloaderUtils_1.MicrogamingPreloaderUtils.createImage('PublisherDisclaimer');
                        checkPublisherLogo_1.onerror = onerror;
                        checkPublisherLogo_1.onload = onload;
                        checkPublisherLogo_1.src = MicrogamingPreloaderUtils_1.MicrogamingPreloaderUtils.getPublisherLogoPathRoot(false) + "disclaimer.png";
                    }
                    var checkPublisherLogo = MicrogamingPreloaderUtils_1.MicrogamingPreloaderUtils.createImage('PublisherSplash');
                    var checkPublisherPortraitLogo = MicrogamingPreloaderUtils_1.MicrogamingPreloaderUtils.createImage('PublisherSplashPortrait');
                    checkPublisherLogo.onload = onload;
                    checkPublisherLogo.onerror = onerror;
                    checkPublisherPortraitLogo.onload = onload;
                    checkPublisherPortraitLogo.onerror = onerror;
                    checkPublisherLogo.src = MicrogamingPreloaderUtils_1.MicrogamingPreloaderUtils.getPublisherLogoPathRoot(true) + "/PublisherSplash.jpg";
                    checkPublisherPortraitLogo.src = MicrogamingPreloaderUtils_1.MicrogamingPreloaderUtils.getPublisherLogoPathRoot(true) + "/PublisherSplashPortrait.jpg";
                }
                else {
                    var checkPublisherLogo = MicrogamingPreloaderUtils_1.MicrogamingPreloaderUtils.createImage('PublisherLogo');
                    checkPublisherLogo.onerror = onerror;
                    checkPublisherLogo.onload = onload;
                    checkPublisherLogo.src = MicrogamingPreloaderUtils_1.MicrogamingPreloaderUtils.getPublisherLogoPathRoot(false) + "logo.png";
                }
                break;
            default:
                callback && callback();
                break;
        }
    };
    MicrogamingPreloaderV2.prototype.getConfig = function () {
        var msgConfig = window.mgsConfig;
        var config = {
            loadingBarColor: LoadingBarColor.STUDIO,
            contentRequired: [LoaderParts.GAME, LoaderParts.STUDIO],
            poweredBy: false,
            extra: null,
            publisherName: null,
            publisherFallback: null,
            usePublisherFallback: false,
            hasPublisherSplash: false,
            setDesign: false,
        };
        if (msgConfig.casinoInfo.publisher) {
            var publisherName = msgConfig.casinoInfo.publisher;
            config.poweredBy = msgConfig.branding.poweredBy.enabled;
            config.publisherName = publisherName;
            config.hasPublisherSplash = this._hasPublisherSplash;
            if (!this._hasPublisherSplash) {
                // Some resource is mising. Default to Game Brand only.
                publisherName = '';
            }
            switch (publisherName) {
                case Publishers.Microgaming:
                    config.setDesign = false;
                    config.loadingBarColor = LoadingBarColor.WHITE;
                    config.contentRequired = config.poweredBy ?
                        [LoaderParts.PUBLISHER_LOGO, LoaderParts.STUDIO, LoaderParts.LOADING_BAR] :
                        [LoaderParts.GAME, LoaderParts.LOADING_BAR];
                    break;
                case Publishers.Microgaming_QuickFire:
                    config.setDesign = false;
                    config.loadingBarColor = LoadingBarColor.WHITE;
                    config.contentRequired = config.poweredBy ?
                        [LoaderParts.PUBLISHER_LOGO, LoaderParts.STUDIO, LoaderParts.LOADING_BAR] :
                        [LoaderParts.GAME, LoaderParts.LOADING_BAR];
                    break;
                case Publishers.Microgaming_Asia:
                    config.setDesign = true;
                    config.loadingBarColor = LoadingBarColor.WHITE;
                    config.contentRequired = [LoaderParts.PUBLISHER_LOGO, LoaderParts.LOADING_BAR];
                    break;
                case Publishers.UPG:
                    config.setDesign = true;
                    config.loadingBarColor = LoadingBarColor.WHITE;
                    config.contentRequired = [LoaderParts.PUBLISHER_LOGO, LoaderParts.LOADING_BAR];
                    break;
                case Publishers.DGC:
                    config.setDesign = true;
                    config.loadingBarColor = LoadingBarColor.MULTI_COLORED;
                    config.contentRequired = [LoaderParts.PUBLISHER_LOGO, LoaderParts.DISCLAIMER, LoaderParts.LOADING_BAR];
                    break;
                default:
                    config.setDesign = false;
                    config.loadingBarColor = LoadingBarColor.STUDIO;
                    config.contentRequired = [LoaderParts.GAME, LoaderParts.LOADING_BAR];
                    break;
            }
        }
        if (this.getExtraConfigLogic()) {
            config.extra = this.getExtraConfigLogic();
        }
        return config;
    };
    MicrogamingPreloaderV2.prototype.onResizeEvent = function () {
        var _this = this;
        setTimeout(function () {
            _this._view.resize(_this._device);
        }, (this._device.iOS && this._device.isIOSChrome) || this._device.isIOSMobileRequestingDesktop ? 200 : 0);
    };
    return MicrogamingPreloaderV2;
}());
exports.MicrogamingPreloaderV2 = MicrogamingPreloaderV2;
var LoadingBarColor;
(function (LoadingBarColor) {
    LoadingBarColor[LoadingBarColor["WHITE"] = 0] = "WHITE";
    LoadingBarColor[LoadingBarColor["STUDIO"] = 1] = "STUDIO";
    LoadingBarColor[LoadingBarColor["MULTI_COLORED"] = 2] = "MULTI_COLORED";
})(LoadingBarColor = exports.LoadingBarColor || (exports.LoadingBarColor = {}));
var Publishers;
(function (Publishers) {
    Publishers["Microgaming"] = "mgs";
    Publishers["Microgaming_QuickFire"] = "quickfire";
    Publishers["Microgaming_Asia"] = "mgsasia";
    Publishers["UPG"] = "upg";
    Publishers["DGC"] = "dgc";
})(Publishers = exports.Publishers || (exports.Publishers = {}));
var LoaderParts;
(function (LoaderParts) {
    LoaderParts[LoaderParts["STUDIO"] = 0] = "STUDIO";
    LoaderParts[LoaderParts["GAME"] = 1] = "GAME";
    LoaderParts[LoaderParts["PUBLISHER_LOGO"] = 2] = "PUBLISHER_LOGO";
    LoaderParts[LoaderParts["DISCLAIMER"] = 3] = "DISCLAIMER";
    LoaderParts[LoaderParts["LOADING_BAR"] = 4] = "LOADING_BAR";
})(LoaderParts = exports.LoaderParts || (exports.LoaderParts = {}));


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MicrogamingPreloaderUtils = /** @class */ (function () {
    function MicrogamingPreloaderUtils() {
    }
    MicrogamingPreloaderUtils.getContentUrl = function () {
        return window.V.API.UrlHelper.getContentUrl();
    };
    MicrogamingPreloaderUtils.getPublisherPath = function () {
        return window.mgsConfig.branding.publisher.path;
    };
    MicrogamingPreloaderUtils.getMicrogamingResolution = function () {
        var fallbackResolution = '1024x768';
        var detectedResolution = window.mgsCasinoParams.resolution;
        var supportedResolutions = ['1024x768', '1136x640'];
        if (supportedResolutions.indexOf(detectedResolution) !== -1) {
            return detectedResolution;
        }
        return fallbackResolution;
    };
    MicrogamingPreloaderUtils.getPublisherLogoPathRoot = function (includeResolution) {
        if (includeResolution) {
            return this.getContentUrl() + (this.getPublisherPath() + "/" + this.getMicrogamingResolution());
        }
        return this.getContentUrl() + ("" + this.getPublisherPath());
    };
    MicrogamingPreloaderUtils.createImage = function (name) {
        var image = new Image();
        image.id = name;
        image.style.position = 'absolute';
        return image;
    };
    MicrogamingPreloaderUtils.createPublisherLogo = function (imageName, fallback, includeResolution) {
        if (includeResolution === void 0) { includeResolution = true; }
        var logo = this.createImage(imageName);
        logo.src = this.getPublisherLogoPathRoot(includeResolution) + "/" + imageName;
        logo.onerror = function () {
            logo.src = fallback;
            logo.onerror = function () {
            };
        };
        return logo;
    };
    MicrogamingPreloaderUtils.createDisclaimer = function () {
        var logo = this.createImage('disclaimer');
        logo.src = this.getContentUrl() + this.getPublisherPath() + 'disclaimer.png';
        return logo;
    };
    MicrogamingPreloaderUtils.createBar = function (id, color, transform) {
        var bar = document.createElement('div');
        bar.id = id;
        bar.className = id;
        bar.style.position = 'absolute';
        bar.style.backgroundColor = color;
        bar.style.webkitTransform = transform;
        bar.style.transform = transform;
        return bar;
    };
    return MicrogamingPreloaderUtils;
}());
exports.MicrogamingPreloaderUtils = MicrogamingPreloaderUtils;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var CurrencyFormatter_1 = __webpack_require__(72);
var RecodeCurrencyFormatter = /** @class */ (function (_super) {
    __extends(RecodeCurrencyFormatter, _super);
    function RecodeCurrencyFormatter() {
        var _this = _super.call(this) || this;
        _this._currencyAvailableOnAPI = true;
        _this._useApiFormatter = false;
        var displayFormat = window.V.API.Core.getCasinoState().player.currencyDisplayFormat;
        var isoCode = window.V.API.Core.getCasinoState().player.currencyIsoCode;
        if (displayFormat === '####.##') {
            _this._currencyAvailableOnAPI = false;
            // Special case for IDR currency : Indonesian Rupiah-
            _this.setINDCurrency(isoCode, displayFormat);
            return _this;
        }
        _this.setCurrencyData(_this.parseCurrencyFormatting(isoCode, displayFormat));
        return _this;
    }
    RecodeCurrencyFormatter.prototype.formatCurrencyApi = function (value) {
        if (this._currencyAvailableOnAPI) {
            return window.V.API.Core.convertCurrency(value);
        }
        return this.formatCurrency(value / 100, true);
    };
    RecodeCurrencyFormatter.prototype.formatCurrency = function (value, showCurrencySign) {
        if (this.useApiFormatter) {
            return this.formatCurrencyApi(value);
        }
        var result = _super.prototype.formatCurrency.call(this, value, showCurrencySign);
        return result;
    };
    RecodeCurrencyFormatter.prototype.setINDCurrency = function (isoCode, displayFormat) {
        this.currency = isoCode;
        this.currencyDecimals = 2;
        this.thousandSeparator = '';
        this.decimalSeparator = '.';
        this.currencyPrefix = '';
        this.currencySuffix = '';
        // this.currencySign = dataObject[1] ? dataObject[1] : '';
        this.currencySign = this.currencyPrefix;
    };
    Object.defineProperty(RecodeCurrencyFormatter.prototype, "useApiFormatter", {
        get: function () {
            return this._useApiFormatter;
        },
        set: function (v) {
            this._useApiFormatter = v;
        },
        enumerable: true,
        configurable: true
    });
    return RecodeCurrencyFormatter;
}(CurrencyFormatter_1.CurrencyFormatter));
exports.RecodeCurrencyFormatter = RecodeCurrencyFormatter;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var CoreDI_1 = __webpack_require__(32);
var ResourcesLoader_1 = __webpack_require__(69);
var System_1 = __webpack_require__(52);
var QuerystringHandler_1 = __webpack_require__(242);
var DI_1 = __webpack_require__(51);
var View_1 = __webpack_require__(3);
var Views_1 = __webpack_require__(8);
var IViewsManager_1 = __webpack_require__(243);
var Layout_1 = __webpack_require__(146);
var ReelConstants_1 = __webpack_require__(10);
var inversify_1 = __webpack_require__(14);
/**
 * stores and gives access to all the game views
 */
var ViewManager = /** @class */ (function () {
    function ViewManager() {
        this._views = {};
        this._zOrder = {};
        this._hasFewMobileViews = false;
    }
    ViewManager.prototype.init = function () {
        this._container = this._system.container;
        // this.setupReelsViewConstants(reelsConfigSprite);
        this.createBackgroundView();
        this.createOrientationNotificationView();
        this.createSpinButtonView();
        this.createAutoPlayButtonView();
        this.createBetButtonView();
        this.createMenuButtonView();
        this.createReelsView();
        this.createWinPresentationView();
        this.createBigWinView();
        this.createParticleView();
        this.createBetlevelMenuView();
        this.createAutoplayMenuView();
        this.createStopAutoplayButtonView();
        this.creareInfoPopupView();
        this.createSwipeInteractionView();
        this.createGameInfoView();
        this.createLogotypeView();
        this.createGameSpecificViews();
        this.createPlatformSpecificViews();
        if (false) {
            this.createCheatsPageView();
            this.createStatisticsWindowView();
        }
        for (var layer = 0; layer < IViewsManager_1.Layers.TOTAL_LAYERS; layer++) {
            for (var key in this._views) {
                if (this._views.hasOwnProperty(key) && this._zOrder[key] === layer) {
                    this._views[key].init();
                }
            }
        }
        this.postInitialize();
    };
    ViewManager.prototype.getView = function (name) {
        return this._views[name];
    };
    ViewManager.prototype.createPlatformSpecificViews = function () {
        var query = new QuerystringHandler_1.QuerystringHandler();
        var platform = query.getValue('platform');
    };
    ViewManager.prototype.createRelaxFreeRoundsView = function () {
        var viewName = Views_1.Views.RELAX_FREEROUNDS_VIEW;
        var view = this._container.get(viewName);
        this._views[viewName] = view;
        this._zOrder[viewName] = IViewsManager_1.Layers.SYSTEM_POPUPS_LAYER;
    };
    ViewManager.prototype.createRelaxInFreeRoundsView = function () {
        var viewName = Views_1.Views.RELAX_FREEROUNDS_INGAME_VIEW;
        var view = this._container.get(viewName);
        this._views[viewName] = view;
        this._zOrder[viewName] = IViewsManager_1.Layers.KEYPAD_LAYER;
    };
    ViewManager.prototype.createLogotypeView = function () {
        var logoViewName = this._system.shouldUseMultipleViews() ? Views_1.Views.LOGOTYPE_VIEW_MOBILE : Views_1.Views.LOGOTYPE_VIEW;
        var view = this._container.get(logoViewName);
        this._views[logoViewName] = view;
        this._zOrder[logoViewName] = IViewsManager_1.Layers.LOGOTYPE_LAYER;
        if (this._system.shouldUseMultipleViews()) {
            view.addStandardMobileViews(Views_1.Views.LOGOTYPE_VIEW);
        }
    };
    ViewManager.prototype.createGameInfoView = function () {
        var viewName = this._system.shouldUseMultipleViews() ? Views_1.Views.INFO_VIEW_MOBILE : Views_1.Views.INFO_VIEW;
        var view = this._container.get(viewName);
        this._views[viewName] = view;
        this._zOrder[viewName] = IViewsManager_1.Layers.GUI_INFO_LAYER;
        if (this._system.shouldUseMultipleViews()) {
            view.addStandardMobileViews(Views_1.Views.INFO_VIEW);
        }
    };
    ViewManager.prototype.createStatisticsWindowView = function () {
        var viewName = 
        /* this._system.shouldUseMultipleViews() ? Views.STATISTICS_WINDOW_VIEW_MOBILE :*/ Views_1.Views.STATISTICS_WINDOW_VIEW;
        var view = this._container.get(viewName);
        this._views[viewName] = view;
        this._zOrder[viewName] = IViewsManager_1.Layers.SYSTEM_POPUPS_LAYER;
        /*if (this._system.shouldUseMultipleViews()) {
            view.addStandardMobileViews(Views.STATISTICS_WINDOW_VIEW);
        }*/
    };
    ViewManager.prototype.createSwipeInteractionView = function () {
        var viewName = this._system.shouldUseMultipleViews() ? Views_1.Views.SWIPE_INTERACTION_VIEW_MOBILE : Views_1.Views.SWIPE_INTERACTION_VIEW;
        var view = this._container.get(viewName);
        this._views[viewName] = view;
        this._zOrder[viewName] = IViewsManager_1.Layers.REELS_LAYER;
        if (this._system.shouldUseMultipleViews()) {
            view.addStandardMobileViews(Views_1.Views.SWIPE_INTERACTION_VIEW);
        }
    };
    ViewManager.prototype.creareInfoPopupView = function () {
        var viewName = this._system.shouldUseMultipleViews() ? Views_1.Views.INFO_POPUP_VIEW_MOBILE : Views_1.Views.INFO_POPUP_VIEW;
        var view = this._container.get(viewName);
        this._views[viewName] = view;
        this._zOrder[viewName] = IViewsManager_1.Layers.INFORMATION_POPUPS_LAYER;
        if (this._system.shouldUseMultipleViews()) {
            view.addStandardMobileViews(Views_1.Views.INFO_POPUP_VIEW);
        }
    };
    ViewManager.prototype.createStopAutoplayButtonView = function () {
        var viewName = this._system.shouldUseMultipleViews()
            ? Views_1.Views.STOP_AUTOPLAY_BUTTON_VIEW_MOBILE
            : Views_1.Views.STOP_AUTOPLAY_BUTTON_VIEW;
        var view = this._container.get(viewName);
        this._views[viewName] = view;
        this._zOrder[viewName] = IViewsManager_1.Layers.KEYPAD_LAYER;
        if (this._system.shouldUseMultipleViews()) {
            view.addStandardMobileViews(Views_1.Views.STOP_AUTOPLAY_BUTTON_VIEW);
        }
    };
    ViewManager.prototype.createCheatsPageView = function () {
        var viewName = Views_1.Views.CHEATS_VIEW;
        var view = this._container.get(viewName);
        this._views[viewName] = view;
        this._zOrder[viewName] = IViewsManager_1.Layers.CHEATS_LAYER;
        /*if (this._system.shouldUseMultipleViews()) {
            view.addStandardMobileViews(Views.CHEATS_VIEW);
        }*/
    };
    ViewManager.prototype.createBigWinView = function () {
        var viewName = this._system.shouldUseMultipleViews() ? Views_1.Views.BIG_WIN_VIEW_MOBILE : Views_1.Views.BIG_WIN_VIEW;
        var view = this._container.get(viewName);
        this._views[viewName] = view;
        this._zOrder[viewName] = IViewsManager_1.Layers.POPUPS_LAYER;
        if (this._system.shouldUseMultipleViews()) {
            view.addStandardMobileViews(Views_1.Views.BIG_WIN_VIEW);
        }
    };
    ViewManager.prototype.createBackgroundView = function () {
        var viewName = this._system.shouldUseMultipleViews() ? Views_1.Views.BACKGROUND_VIEW_MOBILE : Views_1.Views.BACKGROUND_VIEW;
        var view = this._container.get(viewName);
        this._views[viewName] = view;
        this._zOrder[viewName] = IViewsManager_1.Layers.BACKGROUND_LAYER;
        if (this._system.shouldUseMultipleViews()) {
            view.addStandardMobileViews(Views_1.Views.BACKGROUND_VIEW);
        }
    };
    ViewManager.prototype.createSpinButtonView = function () {
        var keypadSpinButtonViewName = this._system.shouldUseMultipleViews()
            ? Views_1.Views.SPIN_BUTTON_VIEW_MOBILE
            : Views_1.Views.SPIN_BUTTON_VIEW;
        var keypadSpinButtonView = this._container.get(keypadSpinButtonViewName);
        this._views[keypadSpinButtonViewName] = keypadSpinButtonView;
        this._zOrder[keypadSpinButtonViewName] = IViewsManager_1.Layers.KEYPAD_LAYER;
        if (this._system.shouldUseMultipleViews()) {
            keypadSpinButtonView.addStandardMobileViews(Views_1.Views.SPIN_BUTTON_VIEW);
        }
    };
    ViewManager.prototype.createAutoPlayButtonView = function () {
        var viewName = this._system.shouldUseMultipleViews() ? Views_1.Views.AUTOPLAY_VIEW_MOBILE : Views_1.Views.AUTOPLAY_VIEW;
        var view = this._container.get(viewName);
        this._views[viewName] = view;
        this._zOrder[viewName] = IViewsManager_1.Layers.KEYPAD_LAYER;
        if (this._system.shouldUseMultipleViews()) {
            view.addStandardMobileViews(Views_1.Views.AUTOPLAY_VIEW);
        }
    };
    ViewManager.prototype.createMenuButtonView = function () {
        var viewName = this._system.shouldUseMultipleViews() ? Views_1.Views.MENUBUTTON_VIEW_MOBILE : Views_1.Views.MENUBUTTON_VIEW;
        var view = this._container.get(viewName);
        this._views[viewName] = view;
        this._zOrder[viewName] = IViewsManager_1.Layers.OVER_KEYPAD_LAYER;
        if (this._system.shouldUseMultipleViews()) {
            view.addStandardMobileViews(Views_1.Views.MENUBUTTON_VIEW);
        }
    };
    ViewManager.prototype.createBetButtonView = function () {
        var viewName = this._system.shouldUseMultipleViews() ? Views_1.Views.BET_VIEW_MOBILE : Views_1.Views.BET_VIEW;
        var view = this._container.get(viewName);
        this._views[viewName] = view;
        this._zOrder[viewName] = IViewsManager_1.Layers.KEYPAD_LAYER;
        if (this._system.shouldUseMultipleViews()) {
            view.addStandardMobileViews(Views_1.Views.BET_VIEW);
        }
    };
    ViewManager.prototype.createBetlevelMenuView = function () {
        var viewName = this._system.shouldUseMultipleViews() ? Views_1.Views.BET_LEVEL_MENU_VIEW_MOBILE : Views_1.Views.BET_LEVEL_MENU_VIEW;
        var view = this._container.get(viewName);
        this._views[viewName] = view;
        this._zOrder[viewName] = IViewsManager_1.Layers.MENU_LAYER;
        if (this._system.shouldUseMultipleViews()) {
            view.addStandardMobileViews(Views_1.Views.BET_LEVEL_MENU_VIEW);
        }
    };
    ViewManager.prototype.createAutoplayMenuView = function () {
        var viewName = this._system.shouldUseMultipleViews() ? Views_1.Views.AUTOPLAY_MENU_VIEW_MOBILE : Views_1.Views.AUTOPLAY_MENU_VIEW;
        var view = this._container.get(viewName);
        this._views[viewName] = view;
        this._zOrder[viewName] = IViewsManager_1.Layers.MENU_LAYER;
        if (this._system.shouldUseMultipleViews()) {
            view.addStandardMobileViews(Views_1.Views.AUTOPLAY_MENU_VIEW);
        }
    };
    ViewManager.prototype.createReelsView = function () {
        this.setupLayout();
        var viewName = this._system.shouldUseMultipleViews() ? Views_1.Views.REELS_VIEW_MOBILE : Views_1.Views.REELS_VIEW;
        var view = this._container.get(viewName);
        this._views[viewName] = view;
        this._zOrder[viewName] = IViewsManager_1.Layers.REELS_LAYER;
        if (this._system.shouldUseMultipleViews()) {
            view.addStandardMobileViews(Views_1.Views.REELS_VIEW);
        }
    };
    ViewManager.prototype.setupLayout = function () {
        if (this.canInitializeFromLayout()) {
            ReelConstants_1.ReelConstants.initializeFromLayout(this._layout);
        }
        else {
            throw new Error('ViewManager::createReelsView can not initialize from layout');
        }
    };
    ViewManager.prototype.canInitializeFromLayout = function (viewType) {
        if (viewType === void 0) { viewType = View_1.ViewTypes.DESKTOP; }
        return (this._layout.isLoaded() &&
            this._layout.getPosition('REEL', viewType) !== null &&
            this._layout.getSize('SYMBOL_1', viewType) !== null);
    };
    ViewManager.prototype.createWinPresentationView = function () {
        var viewName = this._system.shouldUseMultipleViews() ? Views_1.Views.WIN_PRESENTATION_VIEW_MOBILE : Views_1.Views.WIN_PRESENTATION_VIEW;
        var view = this._container.get(viewName);
        this._views[viewName] = view;
        this._zOrder[viewName] = IViewsManager_1.Layers.WIN_TEXT_LAYER;
        if (this._system.shouldUseMultipleViews()) {
            view.addStandardMobileViews(Views_1.Views.WIN_PRESENTATION_VIEW);
        }
    };
    ViewManager.prototype.createParticleView = function () {
        var viewName = this._system.shouldUseMultipleViews() ? Views_1.Views.PARTICLE_VIEW_MOBILE : Views_1.Views.PARTICLE_VIEW;
        var view = this._container.get(viewName);
        this._views[viewName] = view;
        this._zOrder[viewName] = IViewsManager_1.Layers.GUI_INFO_LAYER;
        if (this._system.shouldUseMultipleViews()) {
            view.addStandardMobileViews(Views_1.Views.PARTICLE_VIEW);
        }
    };
    ViewManager.prototype.createOrientationNotificationView = function () {
        var view = this._container.get(Views_1.Views.ORIENTATION_NOTIFICATION_VIEW);
        this._views[Views_1.Views.ORIENTATION_NOTIFICATION_VIEW] = view;
        this._zOrder[Views_1.Views.ORIENTATION_NOTIFICATION_VIEW] = IViewsManager_1.Layers.POPUPS_LAYER;
    };
    ViewManager.prototype.createMicrogamingFreeRoundsView = function () {
        var viewName = this._system.shouldUseMultipleViews()
            ? Views_1.Views.MICROGAMING_FREEROUNDS_VIEW_MOBILE
            : Views_1.Views.MICROGAMING_FREEROUNDS_VIEW;
        var view = this._container.get(viewName);
        this._views[viewName] = view;
        this._zOrder[viewName] = IViewsManager_1.Layers.SYSTEM_POPUPS_LAYER;
        if (this._system.shouldUseMultipleViews()) {
            view.addStandardMobileViews(Views_1.Views.MICROGAMING_FREEROUNDS_VIEW);
        }
    };
    ViewManager.prototype.createMicrogamingFreeRoundsInGameView = function () {
        var viewName = this._system.shouldUseMultipleViews()
            ? Views_1.Views.MICROGAMING_INFREEROUNDS_VIEW_MOBILE
            : Views_1.Views.MICROGAMING_INFREEROUNDS_VIEW;
        var view = this._container.get(viewName);
        this._views[viewName] = view;
        this._zOrder[viewName] = IViewsManager_1.Layers.KEYPAD_LAYER;
        if (this._system.shouldUseMultipleViews()) {
            view.addStandardMobileViews(Views_1.Views.MICROGAMING_INFREEROUNDS_VIEW);
        }
    };
    ViewManager.prototype.createGameSpecificViews = function () { };
    ViewManager.prototype.setupReelsViewConstants = function (reelsConfigSprite, viewType) {
        var reelIndex = 0;
        var currentReel;
        do {
            currentReel = reelsConfigSprite.getChildByName('reel' + reelIndex);
            if (currentReel) {
                ReelConstants_1.ReelConstants.addReelsConfig({
                    x: currentReel.x,
                    y: currentReel.y,
                    symsPositions: [],
                }, viewType);
                var currentSym = void 0;
                var symIndex = 0;
                do {
                    currentSym = currentReel.getChildByName('sym' + symIndex);
                    if (currentSym) {
                        ReelConstants_1.ReelConstants.getReels(viewType)[reelIndex].symsPositions.push({
                            x: currentReel.x + currentSym.x,
                            y: currentReel.y + currentSym.y,
                        });
                        symIndex++;
                    }
                } while (currentSym);
                reelIndex++;
            }
        } while (currentReel);
        ReelConstants_1.ReelConstants.REELS_AMOUNT = ReelConstants_1.ReelConstants.getReels(viewType).length;
        ReelConstants_1.ReelConstants.ROW_AMOUNT = ReelConstants_1.ReelConstants.getReels(viewType)[0].symsPositions.length;
    };
    ViewManager.prototype.postInitialize = function () {
        this.translate();
        if (false) {
            document.VIEWMANAGER = this;
        }
    };
    ViewManager.prototype.translate = function () {
        for (var key in this._views) {
            if (this._views.hasOwnProperty(key)) {
                this._views[key].translator.englishObject = this._resourcesLoader.getEnglishStrings();
                this._views[key].translator.localeObjects = this._resourcesLoader.getTranslation();
                this._views[key].translate();
            }
        }
    };
    __decorate([
        inversify_1.inject(CoreDI_1.CoreDI.System),
        __metadata("design:type", System_1.System)
    ], ViewManager.prototype, "_system", void 0);
    __decorate([
        inversify_1.inject(DI_1.default.ISettings),
        __metadata("design:type", Object)
    ], ViewManager.prototype, "_settings", void 0);
    __decorate([
        inversify_1.inject(CoreDI_1.CoreDI.ResourceLoader),
        __metadata("design:type", ResourcesLoader_1.ResourcesLoader)
    ], ViewManager.prototype, "_resourcesLoader", void 0);
    __decorate([
        inversify_1.inject(DI_1.default.Layout),
        __metadata("design:type", Layout_1.Layout)
    ], ViewManager.prototype, "_layout", void 0);
    ViewManager = __decorate([
        inversify_1.injectable()
    ], ViewManager);
    return ViewManager;
}());
exports.ViewManager = ViewManager;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var QuerystringHandler = /** @class */ (function () {
    function QuerystringHandler() {
        this.queryString = document.location.search.substring(1);
        try {
            this.queryStringData = this.getQueryParams(decodeURIComponent(this.queryString));
        }
        catch (error) { }
    }
    Object.defineProperty(QuerystringHandler.prototype, "queryString", {
        get: function () {
            return this._queryString;
        },
        set: function (value) {
            this._queryString = value;
        },
        enumerable: true,
        configurable: true
    });
    QuerystringHandler.prototype.getValue = function (key) {
        if (this.queryStringData[key]) {
            return this.queryStringData[key];
        }
        return '';
    };
    Object.defineProperty(QuerystringHandler.prototype, "queryStringData", {
        get: function () {
            return this._queryStringData;
        },
        set: function (value) {
            this._queryStringData = value;
        },
        enumerable: true,
        configurable: true
    });
    QuerystringHandler.prototype.getQueryParams = function (queryString) {
        var queryParameters = {};
        try {
            var data = queryString.split('&');
            for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                var item = data_1[_i];
                var element = item.split('=');
                var key = element[0];
                var value = element[1];
                queryParameters["" + key] = value;
            }
        }
        catch (error) {
            // console.log('No querystring data found');
        }
        return queryParameters;
    };
    return QuerystringHandler;
}());
exports.QuerystringHandler = QuerystringHandler;


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Layers;
(function (Layers) {
    Layers[Layers["HIDDEN_LAYER"] = 0] = "HIDDEN_LAYER";
    Layers[Layers["BACKGROUND_LAYER"] = 1] = "BACKGROUND_LAYER";
    Layers[Layers["BEHIND_THE_REELS"] = 2] = "BEHIND_THE_REELS";
    Layers[Layers["LOGOTYPE_BACKGROUND_LAYER"] = 3] = "LOGOTYPE_BACKGROUND_LAYER";
    Layers[Layers["REELS_LAYER"] = 4] = "REELS_LAYER";
    Layers[Layers["REELS_FRAME_LAYER"] = 5] = "REELS_FRAME_LAYER";
    Layers[Layers["SYMBOLS_ANIMATIONS_LAYER"] = 6] = "SYMBOLS_ANIMATIONS_LAYER";
    Layers[Layers["SYMBOLS_ANIMATIONS_LAYER_2"] = 7] = "SYMBOLS_ANIMATIONS_LAYER_2";
    Layers[Layers["SYMBOLS_ANIMATIONS_LAYER_3"] = 8] = "SYMBOLS_ANIMATIONS_LAYER_3";
    Layers[Layers["REELS_WIN_LAYER"] = 9] = "REELS_WIN_LAYER";
    Layers[Layers["STICKY_SYMBOLS_LAYER"] = 10] = "STICKY_SYMBOLS_LAYER";
    Layers[Layers["WIN_LINES_LAYER"] = 11] = "WIN_LINES_LAYER";
    Layers[Layers["WIN_TEXT_LAYER"] = 12] = "WIN_TEXT_LAYER";
    Layers[Layers["REEL_POPUP_LAYER"] = 13] = "REEL_POPUP_LAYER";
    Layers[Layers["FOREGROUND_LAYER"] = 14] = "FOREGROUND_LAYER";
    Layers[Layers["KEYPAD_LAYER"] = 15] = "KEYPAD_LAYER";
    Layers[Layers["OVER_KEYPAD_LAYER"] = 16] = "OVER_KEYPAD_LAYER";
    Layers[Layers["BONUS_LAYER"] = 17] = "BONUS_LAYER";
    Layers[Layers["MENU_LAYER"] = 18] = "MENU_LAYER";
    Layers[Layers["GUI_INFO_LAYER"] = 19] = "GUI_INFO_LAYER";
    Layers[Layers["POPUPS_LAYER"] = 20] = "POPUPS_LAYER";
    Layers[Layers["OVER_POPUP_LAYER"] = 21] = "OVER_POPUP_LAYER";
    Layers[Layers["OVER_POPUP2_LAYER"] = 22] = "OVER_POPUP2_LAYER";
    Layers[Layers["OVER_POPUP3_LAYER"] = 23] = "OVER_POPUP3_LAYER";
    Layers[Layers["INFORMATION_POPUPS_LAYER"] = 24] = "INFORMATION_POPUPS_LAYER";
    Layers[Layers["SYSTEM_POPUPS_LAYER"] = 25] = "SYSTEM_POPUPS_LAYER";
    Layers[Layers["SCREEN_BLOCKER_LAYER"] = 26] = "SCREEN_BLOCKER_LAYER";
    Layers[Layers["LOGOTYPE_LAYER"] = 27] = "LOGOTYPE_LAYER";
    Layers[Layers["CHEATS_LAYER"] = 28] = "CHEATS_LAYER";
    Layers[Layers["TOTAL_LAYERS"] = 29] = "TOTAL_LAYERS";
})(Layers = exports.Layers || (exports.Layers = {}));


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LogotypeViewEvents = /** @class */ (function () {
    function LogotypeViewEvents() {
    }
    LogotypeViewEvents.LOGOTYPE_DOUBLE_TAPPED = 'LogotypeViewEvents::LOGOTYPE_DOUBLE_TAPPED';
    return LogotypeViewEvents;
}());
exports.LogotypeViewEvents = LogotypeViewEvents;


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BetButtonViewEvents = /** @class */ (function () {
    function BetButtonViewEvents() {
    }
    BetButtonViewEvents.BET_BUTTON_CLICKED = 'BetButtonViewEvents::__BET_BUTTON_CLICKED__';
    BetButtonViewEvents.STOP_BET_BUTTON_CLICKED = 'BetButtonViewEvents::__STOP_BET_BUTTON_CLICKED__';
    return BetButtonViewEvents;
}());
exports.BetButtonViewEvents = BetButtonViewEvents;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var View_1 = __webpack_require__(3);
var StopAutoplayButton_1 = __webpack_require__(497);
var StopAutoplayButtonView = /** @class */ (function (_super) {
    __extends(StopAutoplayButtonView, _super);
    function StopAutoplayButtonView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StopAutoplayButtonView.prototype.init = function () {
        _super.prototype.init.call(this);
        this.setupSpinButton();
        this.setupSpinsLeftText();
    };
    StopAutoplayButtonView.prototype.updateSpinsLeft = function (currentSpin, totalSpins) {
        this._autoplayButton.addChild(this._spinsLeftText);
        this._spinsLeftText.alpha = 0;
        this._spinsLeftText.text = currentSpin + "/" + totalSpins;
        this._spinsLeftText.alpha = 1;
    };
    StopAutoplayButtonView.prototype.initAutoplay = function () {
        this._autoplayButton.visible = true;
        this._spinsLeftText.text = '';
        this._spinsLeftText.visible = true;
    };
    StopAutoplayButtonView.prototype.uninitAutoplay = function () {
        this._autoplayButton.visible = false;
        this._spinsLeftText.visible = false;
    };
    StopAutoplayButtonView.prototype.setupSpinButton = function () {
        this._autoplayButton = new StopAutoplayButton_1.StopAutoplayButton(null, this.updateManager, this.resources);
        this.setupEventsForButtons();
        this.container.addChild(this._autoplayButton);
        var autplayButtonPosition = this.layout.getPosition('SPIN_BUTTON');
        this._autoplayButton.position.set(autplayButtonPosition.x, autplayButtonPosition.y);
        this._autoplayButton.enable();
        var size = this.layout.getSize('SPIN_BUTTON', this.viewType);
        this._autoplayButton.hitArea = new PIXI.Circle(0, 0, size.width / 2);
    };
    StopAutoplayButtonView.prototype.setupSpinsLeftText = function () {
        this._spinsLeftStyle = this.textStyles.spinsLeftStyle;
        this._spinsLeftText = new PIXI.Text('', this._spinsLeftStyle);
        this._spinsLeftText.anchor.set(0.5, 0.5);
        this.uninitAutoplay();
    };
    StopAutoplayButtonView.prototype.setupEventsForButtons = function () {
        this._autoplayButton.callback = this.onStopAutoplayButtonClicked.bind(this);
    };
    StopAutoplayButtonView.prototype.onStopAutoplayButtonClicked = function () {
        this.uninitAutoplay();
        this.emit(StopAutoplayButtonView.STOP_AUTOPLAY_BUTTON_CLICKED);
    };
    StopAutoplayButtonView.STOP_AUTOPLAY_BUTTON_CLICKED = 'STOP_AUTOPLAY_BUTTON_CLICKED';
    return StopAutoplayButtonView;
}(View_1.View));
exports.StopAutoplayButtonView = StopAutoplayButtonView;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var SpriteButton_1 = __webpack_require__(55);
var Spine_1 = __webpack_require__(25);
var SpineAnimation_1 = __webpack_require__(37);
var Button_1 = __webpack_require__(54);
var SpinButton = /** @class */ (function (_super) {
    __extends(SpinButton, _super);
    function SpinButton(callback, updateManager, resources) {
        var _this = _super.call(this, callback) || this;
        _this._isDisabled = false;
        _this._updateManager = updateManager;
        _this._resources = resources;
        _this.interactive = true;
        _this.buttonMode = true;
        _this._previousState = Button_1.ButtonState.UP;
        return _this;
    }
    SpinButton.prototype.enable = function () {
        this._isDisabled = false;
        this.buttonMode = true;
        if (this._over) {
            this.setState(Button_1.ButtonState.OVER);
        }
        else {
            this.setState(Button_1.ButtonState.UP);
        }
    };
    SpinButton.prototype.disable = function () {
        this.setState(Button_1.ButtonState.DISABLED);
        this._isDisabled = true;
        this.buttonMode = false;
    };
    SpinButton.prototype.setState = function (value) {
        if (this._state !== value && this._updateManager && !this._isDisabled) {
            this._previousState = this._state;
            this._state = value;
            switch (value) {
                case Button_1.ButtonState.DISABLED: {
                    this.stopCurrentAnimation();
                    this.stopAdditionalAnimation();
                    this.startAdditionalAnimation('RELEASE', false);
                    this.startButtonAnimation('SPIN', true);
                    break;
                }
                case Button_1.ButtonState.DOWN: {
                    this.stopCurrentAnimation();
                    this.stopAdditionalAnimation();
                    this.startButtonAnimation('PRESSED', false, true);
                    break;
                }
                case Button_1.ButtonState.UP: {
                    if (this._previousState === Button_1.ButtonState.OVER) {
                        this.stopAdditionalAnimation();
                    }
                    else {
                        this.stopCurrentAnimation();
                        this.stopAdditionalAnimation();
                        this.startButtonAnimation('IDLE', true);
                    }
                    break;
                }
                case Button_1.ButtonState.OVER: {
                    if (this._previousState === Button_1.ButtonState.UP) {
                        this.stopAdditionalAnimation();
                        this.startAdditionalAnimation('HOVER', true);
                    }
                    else {
                        this.stopCurrentAnimation();
                        this.stopAdditionalAnimation();
                        this.startButtonAnimation('IDLE', true);
                        this.startAdditionalAnimation('HOVER', true);
                    }
                    break;
                }
                default:
                    break;
            }
        }
    };
    SpinButton.prototype.onClick = function () {
        this.setState(Button_1.ButtonState.OVER);
        if (this._callback) {
            if (!this._isDisabled) {
                this._callback();
            }
        }
        else {
            // console.warn('There is no a callback.');
        }
    };
    SpinButton.prototype.startButtonAnimation = function (animationName, loop, dontDestroyOnComplete) {
        this.stopCurrentAnimation();
        this._currentAnimation = new SpineAnimation_1.SpineAnimation(new Spine_1.Spine(this._resources.getSpine('SPIN_BUTTON_NOGLOW.json')), animationName, loop, dontDestroyOnComplete);
        this._updateManager.add(this._currentAnimation);
        this.addChild(this._currentAnimation.container);
        this._currentAnimation.start();
    };
    SpinButton.prototype.startAdditionalAnimation = function (animationName, loop, dontDestroyOnComplete) {
        this.stopAdditionalAnimation();
        this._additionalAnimation = new SpineAnimation_1.SpineAnimation(new Spine_1.Spine(this._resources.getSpine('SPIN_BUTTON_GLOW.json')), animationName, loop, dontDestroyOnComplete);
        this._updateManager.add(this._additionalAnimation);
        this.addChild(this._additionalAnimation.container);
        this._additionalAnimation.start();
    };
    SpinButton.prototype.stopCurrentAnimation = function () {
        if (this._currentAnimation) {
            this.removeChild(this._currentAnimation.container);
            this._currentAnimation.forceDestroy();
            this._currentAnimation = null;
        }
    };
    SpinButton.prototype.stopAdditionalAnimation = function () {
        if (this._additionalAnimation) {
            this.removeChild(this._additionalAnimation.container);
            this._additionalAnimation.forceDestroy();
            this._additionalAnimation = null;
        }
    };
    SpinButton.prototype.updateFrame = function () {
    };
    return SpinButton;
}(SpriteButton_1.SpriteButton));
exports.SpinButton = SpinButton;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Spine_1 = __webpack_require__(25);
var AnimationNames_1 = __webpack_require__(154);
var View_1 = __webpack_require__(3);
var AutoplaySlider_1 = __webpack_require__(498);
var SliderNumberBox_1 = __webpack_require__(501);
var AutoplayMenuViewEvents_1 = __webpack_require__(249);
var GenericButton_1 = __webpack_require__(90);
var GameUtils_1 = __webpack_require__(26);
var AutoplayMenuView = /** @class */ (function (_super) {
    __extends(AutoplayMenuView, _super);
    function AutoplayMenuView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._buttons = [];
        _this._buttonDisabledTint = 0xffffff;
        _this._buttonValues = [];
        _this._acceptEnabled = false;
        _this._xOffset = 0;
        _this._yOffset = 0;
        _this._stopAutoplayAfterWinChecked = false;
        _this._lossLimitSlotNames = [];
        _this._singleWinLimitSlotNames = [];
        _this._winLimitSlotNames = [];
        _this._stopConfigSlotNames = [];
        _this._untilStopSlotNames = [];
        _this._isAcceptDisabled = true;
        _this._buttonScaleMod = 0.85; // Magic number...
        return _this;
    }
    AutoplayMenuView.prototype.init = function () {
        _super.prototype.init.call(this);
        this.setupTextStyles();
        this.setupBaseLayout();
        this.setupBaseButtons();
        this.setupCheckboxes();
        this._buttonsCallback = this.setAutoplay;
        this._acceptButton.disable();
        this._isAcceptDisabled = true;
        this.title = 'AUTO PLAY';
    };
    AutoplayMenuView.prototype.setupOptionsVisibility = function (autoplayData) {
        var slotsToHide = [];
        var slotsToShow = [];
        if (autoplayData.lossLimitEnabled) {
            slotsToShow.push.apply(slotsToShow, this._lossLimitSlotNames);
        }
        else {
            slotsToHide.push.apply(slotsToHide, this._lossLimitSlotNames);
        }
        if (autoplayData.winLimitEnabled) {
            slotsToShow.push.apply(slotsToShow, this._singleWinLimitSlotNames);
            slotsToShow.push.apply(slotsToShow, this._stopConfigSlotNames);
            slotsToShow.push.apply(slotsToShow, this._winLimitSlotNames);
        }
        else {
            slotsToHide.push.apply(slotsToHide, this._singleWinLimitSlotNames);
            slotsToHide.push.apply(slotsToHide, this._stopConfigSlotNames);
            slotsToHide.push.apply(slotsToHide, this._winLimitSlotNames);
        }
        if (autoplayData.untilStop) {
            slotsToShow.push.apply(slotsToShow, this._untilStopSlotNames);
        }
        else {
            slotsToHide.push.apply(slotsToHide, this._untilStopSlotNames);
        }
        for (var _i = 0, slotsToHide_1 = slotsToHide; _i < slotsToHide_1.length; _i++) {
            var slotName = slotsToHide_1[_i];
            this.spineUtils.findSlotContainerByName(this._spineLayout, slotName).visible = false;
        }
        for (var _a = 0, slotsToShow_1 = slotsToShow; _a < slotsToShow_1.length; _a++) {
            var slotName = slotsToShow_1[_a];
            this.spineUtils.findSlotContainerByName(this._spineLayout, slotName).visible = true;
        }
    };
    AutoplayMenuView.prototype.hideAutoplaySettings = function (autoplayData) { };
    AutoplayMenuView.prototype.showAutoplaySettings = function (autoplayData) { };
    AutoplayMenuView.prototype.disableMenuDueToLossLimitExceedsBet = function () {
        this._acceptButton.disable();
        this._limitErrorText.text = this.getLimitText('loss');
        this._limitErrorText.visible = true;
    };
    AutoplayMenuView.prototype.disableMenuDueToWinLimitTooLow = function () {
        this._acceptButton.disable();
        this._limitErrorText.text = this.getLimitText('win');
        this._limitErrorText.visible = true;
    };
    AutoplayMenuView.prototype.disableMenuDueToSingleWinLimitTooLow = function () {
        this._acceptButton.disable();
        this._limitErrorText.text = this.getLimitText('singleWin');
        this._limitErrorText.visible = true;
    };
    AutoplayMenuView.prototype.disableMenuDueToSpinAmountTooHigh = function () {
        this._acceptButton.disable();
        this._limitErrorText.text = this.getLimitText('maxSpins');
        this._limitErrorText.visible = true;
    };
    AutoplayMenuView.prototype.enableMenuLimitsOK = function () {
        this._acceptButton.enable();
        this._limitErrorText.visible = false;
    };
    AutoplayMenuView.prototype.enableMenuLossLimitOK = function () {
        this._acceptButton.enable();
        this._limitErrorText.visible = false;
    };
    // If we dont get any autoplaySettings we default with 100 values based on current bet.
    // The 100 and 1000 values are taken from another popular game on the market with this type of autoplay menu.
    AutoplayMenuView.prototype.setSliderValues = function (autoplaySettings, value) {
        if (!autoplaySettings) {
            var singleWinValues = [];
            var winValues = [];
            var lossValues = [];
            for (var i = 0; i <= 100; i++) {
                singleWinValues.push(i * value * 0.5);
                winValues.push(i * value);
                lossValues.push(i * value);
            }
            this._singleWinSlider.updateValues(singleWinValues);
            this._winSlider.updateValues(winValues);
            this._lossSlider.updateValues(lossValues);
        }
        else {
            this._singleWinSlider.updateValues(autoplaySettings.winLimitsAmounts, this.getNumberArrayIndex(autoplaySettings.winLimitsAmounts, autoplaySettings.winLimitDefault));
            this._winSlider.updateValues(autoplaySettings.winLimitsAmounts, this.getNumberArrayIndex(autoplaySettings.winLimitsAmounts, autoplaySettings.winLimitDefault));
            this._lossSlider.updateValues(autoplaySettings.lossLimitsAmounts, this.getNumberArrayIndex(autoplaySettings.lossLimitsAmounts, autoplaySettings.lossLimitDefault));
        }
    };
    AutoplayMenuView.prototype.getCurrentAutoplayParameters = function () {
        var autoplayValues;
        autoplayValues = {
            singleWinLimit: this._singleWinSlider.currentValue,
            winLimit: this._winSlider.currentValue,
            lossLimit: this._lossSlider.currentValue,
            stopAutoplayOnWin: this._stopAutoplayAfterWinChecked,
        };
        return autoplayValues;
    };
    AutoplayMenuView.prototype.resetSliders = function () {
        this._singleWinSlider.reset();
        this._winSlider.reset();
        this._lossSlider.reset();
    };
    Object.defineProperty(AutoplayMenuView.prototype, "title", {
        set: function (title) {
            this._menuTitle.text = title;
        },
        enumerable: true,
        configurable: true
    });
    AutoplayMenuView.prototype.getNumberArrayIndex = function (array, valueToFind) {
        return array.findIndex(function (item) {
            return item === valueToFind;
        });
    };
    Object.defineProperty(AutoplayMenuView.prototype, "buttonDisabledTint", {
        set: function (value) {
            this._buttonDisabledTint = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutoplayMenuView.prototype, "autoplayAmount", {
        get: function () {
            return this._autoplayAmount;
        },
        set: function (v) {
            this._autoplayAmount = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutoplayMenuView.prototype, "autoplayDefault", {
        get: function () {
            return this._autoplayDefault;
        },
        set: function (value) {
            this._autoplayDefault = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutoplayMenuView.prototype, "offset", {
        set: function (_a) {
            var xOffset = _a[0], yOffset = _a[1];
            this._xOffset = xOffset;
            this._yOffset = yOffset;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutoplayMenuView.prototype, "lastAutoplayAmount", {
        set: function (value) {
            this.restoreToLastAutoplayAmount(value);
            this._lastAutoplayAmount = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutoplayMenuView.prototype, "buttonValues", {
        set: function (buttonValues) {
            this._buttonValues = buttonValues;
            this.generateButtons();
        },
        enumerable: true,
        configurable: true
    });
    AutoplayMenuView.prototype.translate = function () {
        var titleText = this.translator.getObject('BaseStrings', 'generic', 'g_autoplay') || 'AUTO PLAY';
        this.title = titleText.toUpperCase();
        var textStyle;
        var locale = this.resources.getLocale();
        if (locale !== 'th' && locale !== 'zh-cn' && locale !== 'zh-tw' && locale !== 'sl' && locale !== 'vi') {
            textStyle = this.textStyles.settingsDescription;
        }
        else {
            textStyle = this.textStyles.autoplaySettingsDescription;
        }
        var translations = [];
        translations.push(this.insertTexts(this._spineLayout.slotContainers[this._spineLayout.skeleton.findSlotIndex('STOP_AUTOPLAY_TEXT')], textStyle, 'g_autoplay_stopautoplay', 'STOP AUTOPLAY AFTER WIN'));
        translations.push(this.insertTexts(this._spineLayout.slotContainers[this._spineLayout.skeleton.findSlotIndex('SINGLE_WIN_TEXT')], textStyle, 'g_autoplay_singlewinlimit', 'SINGLE WIN LIMIT'));
        translations.push(this.insertTexts(this._spineLayout.slotContainers[this._spineLayout.skeleton.findSlotIndex('WIN_LIMIT_TEXT')], textStyle, 'g_autoplay_winlimit', 'WIN LIMIT'));
        translations.push(this.insertTexts(this._spineLayout.slotContainers[this._spineLayout.skeleton.findSlotIndex('LOSS_LIMIT_TEXT')], textStyle, 'g_autoplay_losslimit', 'LOSS LIMIT'));
        var limitErrorText = this.translator.getObject('BaseStrings', 'generic', 'g_currentbet_losslimit') || 'Current Bet Exceeds Loss Limit';
        this._limitErrorText.text = limitErrorText;
        this.updateTitleScale();
        if (locale !== 'th' && locale !== 'zh-cn' && locale !== 'zh-tw' && locale !== 'sl' && locale !== 'vi') {
            this.updateTextsScale(translations);
        }
    };
    AutoplayMenuView.prototype.preCallback = function (valueId) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        for (var _a = 0, _b = this._buttons; _a < _b.length; _a++) {
            var button = _b[_a];
            if (button.id !== valueId) {
                button.resetState();
            }
        }
    };
    AutoplayMenuView.prototype.setupTextStyles = function () {
        this._titleStyle = this.textStyles.buttonMenuTitleStyle;
        this._titleStyle.wordWrapWidth = this.resolutionManager.resolution.width;
        this._buttonStyle = this.textStyles.buttonBaseStyle;
        this._buttonOverStyle = this.textStyles.buttonOverStyle;
        this._buttonDownStyle = this.textStyles.buttonDownStyle;
        this._buttonDisabledStyle = this.textStyles.buttonDisabledStyle;
        this._limitErrorStyle = this.textStyles.limitErrorTextStyle;
    };
    AutoplayMenuView.prototype.setupBaseButtons = function () {
        var acceptPosition = this._spineLayout.skeleton.findBone('ACCEPT_BUTTON').data;
        var cancelPosition = this._spineLayout.skeleton.findBone('DECLINE_BUTTON').data;
        this._acceptButton = this.spineUtils.createSpineButton('ACCEPT_BUTTON.json', this.onAcceptPressed.bind(this));
        this._acceptButton.position.set(this.resolutionManager.halfResolution.width, this.resolutionManager.halfResolution.height);
        this._acceptButton.setTransform(this.resolutionManager.halfResolution.width + acceptPosition.x, this.resolutionManager.resolution.height - (this.resolutionManager.halfResolution.height + acceptPosition.y));
        this._isAcceptDisabled = true;
        this._cancelButton = this.spineUtils.createSpineButton('DECLINE_BUTTON.json', this.onCancelPressed.bind(this));
        this._cancelButton.position.set(this.resolutionManager.halfResolution.width, this.resolutionManager.halfResolution.height);
        this._cancelButton.setTransform(this.resolutionManager.halfResolution.width + cancelPosition.x, this.resolutionManager.resolution.height - (this.resolutionManager.halfResolution.height + cancelPosition.y));
        this.container.addChild(this._acceptButton);
        this.container.addChild(this._cancelButton);
        // TODO: Propose max position or count of Bone children in hierarchy to determine buttons per row.
        var choiceButton1Position = this._spineLayout.skeleton.findBone('BOX_CONTAINER1');
        var choiceButton2Position = this._spineLayout.skeleton.findBone('BOX_CONTAINER2');
        var choiceButton3Position = this._spineLayout.skeleton.findBone('BOX_CONTAINER3');
        // this.offset = [choiceButton1Position.x - choiceButton2Position.x, yOffset];
        this.offset = [choiceButton1Position.x - choiceButton2Position.x, choiceButton1Position.y - choiceButton3Position.y];
    };
    AutoplayMenuView.prototype.getLimitText = function (limitType) {
        switch (limitType) {
            case 'loss':
                return this.translator.getObject('BaseStrings', 'generic', 'g_currentbet_losslimit') || 'Current Bet Exceeds Loss Limit';
            case 'win':
                return this.translator.getObject('BaseStrings', 'generic', 'g_currentbet_winlimit') || 'Current Win Limit is too low';
            case 'singleWin':
                return (this.translator.getObject('BaseStrings', 'generic', 'g_currentbet_singlewinlimit') ||
                    'Current Single Win Limit is too Low');
            case 'maxSpins':
                return (this.translator.getObject('BaseStrings', 'generic', 'g_currentbet_maxspinslimit') || 'Current Spin amount is too high');
            default:
                return this.translator.getObject('BaseStrings', 'generic', 'g_currentbet_invalidlimit') || 'Current Settings are invalid';
        }
    };
    AutoplayMenuView.prototype.updateTitleScale = function () {
        var maxSize = {
            x: this._titleStyle.wordWrapWidth,
            y: this._titleBackground.children[0].height,
        };
        if (this._menuTitle.width > maxSize.x || this._menuTitle.height > maxSize.y) {
            GameUtils_1.GameUtils.correctSpriteScale(this._menuTitle, maxSize);
            // this._menuTitle.scale.y *= -1;
        }
    };
    AutoplayMenuView.prototype.updateTextsScale = function (texts) {
        var maxLength = 0;
        var longestText;
        for (var _i = 0, texts_1 = texts; _i < texts_1.length; _i++) {
            var text = texts_1[_i];
            if (text.text.length > maxLength) {
                maxLength = text.text.length;
                longestText = text;
            }
        }
        var maxSize = { x: 140, y: 150 };
        if (this.device.isMobile) {
            maxSize = { x: 175, y: 300 };
        }
        GameUtils_1.GameUtils.correctSpriteScale(longestText, maxSize);
        for (var _a = 0, texts_2 = texts; _a < texts_2.length; _a++) {
            var text = texts_2[_a];
            text.scale = longestText.scale;
        }
    };
    AutoplayMenuView.prototype.setupBaseLayout = function () {
        this._spineLayout = new Spine_1.Spine(this.resources.getSpine('AUTOPLAY_MENU.json'));
        this._background = this.spineUtils.findSlotContainerByName(this._spineLayout, 'BACKGROUND_SOLID');
        this._titleBackground = this.spineUtils.findSlotContainerByName(this._spineLayout, 'MENU_TITLE_BACKGROUND');
        this._background.interactive = true;
        this.cleanListOfSpineChildrenFromSlotNames(this._spineLayout, [
            'BOX_CONTAINER1',
            'BOX_CONTAINER2',
            'ACCEPT_BUTTON',
            'ACCEPT_BUTTON_CONFIRM',
            'DECLINE_BUTTON',
            'DECLINE_BUTTON_EXIT',
        ]);
        // Menu title adding
        this._menuTitle = new PIXI.Text('Title', this._titleStyle);
        this.spineUtils.replaceElementInSpine(this._spineLayout, 'MENU_TITLE', this._menuTitle);
        // Adding limit error text.
        this._limitErrorText = new PIXI.Text('Current Bet Exceeds Loss Limit', this._limitErrorStyle);
        this.spineUtils.replaceElementInSpine(this._spineLayout, 'LIMIT_MESSAGE', this._limitErrorText);
        ////////////////////////////////////////////////////////////////////
        // Create autoplay sliders.
        ////////////////////////////////////////////////////////////////////
        // createSliders
        this._singleWinSlider = this.makeNewAutoplaySlider('SINGLE_WIN_SLIDER', this.onSingleWinLimitChanged.bind(this), 'SINGLE_WIN_BOX_NUMBER');
        this._winSlider = this.makeNewAutoplaySlider('WIN_LIMIT_SLIDER', this.onWinLimitChanged.bind(this), 'WIN_LIMIT_BOX');
        this._lossSlider = this.makeNewAutoplaySlider('LOSS_LIMIT_SLIDER', this.onLossLimitChanged.bind(this), 'LOSS_LIMIT_BOX');
        ////////////////////////////////////////////////////////////////////
        // Add spinelayout, destroyPlaceholderGraphics and update once.
        ////////////////////////////////////////////////////////////////////
        this.destroyAllPlaceholderGraphic(this._spineLayout);
        this.container.addChild(this._spineLayout);
        this._spineLayout.position.set(this.resolutionManager.halfResolution.width, this.resolutionManager.halfResolution.height);
        this._spineLayout.update(0);
        // Anchors need to be set here or they will reset on layout update(0).
        this._menuTitle.anchor.set(0.5, 0.5);
        this._limitErrorText.anchor.set(0, 0.5);
    };
    AutoplayMenuView.prototype.cleanListOfSpineChildrenFromSlotNames = function (spine, slotNames) {
        for (var item = 0; item < slotNames.length; item++) {
            var slot = slotNames[item];
            var slotContainer = this.spineUtils.findSlotContainerByName(spine, slot);
            if (slotContainer) {
                slotContainer.removeChildren();
            }
        }
    };
    AutoplayMenuView.prototype.makeNewAutoplaySlider = function (slotName, onValueChangedCallback, sliderNumberBoxSlot) {
        var slider = new AutoplaySlider_1.AutoplaySlider(this.spineUtils.findSlotContainerByName(this._spineLayout, slotName), new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'AUTOPLAY_SLIDER.png')), new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'AUTOPLAY_SLIDER_FULL.png')), new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'AUTOPLAY_SLIDER_DOT.png')), this.device.isMobile);
        slider.currencyFormatter = this.currencyFormatter;
        slider.onValueChangedCallback = onValueChangedCallback;
        slider.sliderNumberBox = this.makeSliderNumberBox(sliderNumberBoxSlot);
        return slider;
    };
    AutoplayMenuView.prototype.makeSliderNumberBox = function (slotName) {
        var numberBox = new SliderNumberBox_1.SliderNumberBox(new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'AUTOPLAY_MENU_BOX.png')), this._buttonStyle, this.device.isMobile, this.sliderNumberTextScaleMod);
        this.spineUtils.replaceElementInSpine(this._spineLayout, slotName, numberBox);
        return numberBox;
    };
    AutoplayMenuView.prototype.destroyAllPlaceholderGraphic = function (spine) {
        var slots = spine.slotContainers;
        slots.forEach(function (slot) {
            slot.children.forEach(function (child) {
                if (child.region && child.region.name === 'PLACEHOLDER') {
                    child.destroy();
                }
            });
        });
    };
    AutoplayMenuView.prototype.onLossLimitChanged = function (newValue) {
        this.emit(AutoplayMenuView.LOSS_LIMIT_CHANGED, newValue);
    };
    AutoplayMenuView.prototype.onWinLimitChanged = function (newValue) {
        this.emit(AutoplayMenuView.WIN_LIMIT_CHANGED, newValue);
    };
    AutoplayMenuView.prototype.onSingleWinLimitChanged = function (newValue) {
        this.emit(AutoplayMenuView.SINGLE_WIN_LIMIT_CHANGED, newValue);
    };
    AutoplayMenuView.prototype.insertTexts = function (slot, style, tag, fallbackText) {
        var translation = this.translator.getObject('BaseStrings', 'generic', tag) || fallbackText;
        var text = new PIXI.Text(translation.toUpperCase(), style);
        text.transform.updateTransform(slot.transform);
        slot.removeChildren();
        slot.addChild(text);
        text.scale.set(1, -1);
        text.anchor.set(0, 0.5);
        return text;
    };
    AutoplayMenuView.prototype.setAutoplay = function (value, isRealClick) {
        if (isRealClick) {
            this.soundPlayer.play('buttonClick');
        }
        this.preCallback(value);
        // this._acceptButton.enable();
        // this._isAcceptDisabled = false;
        this.autoplayAmount = value;
        this.onSpinsAmountChanged();
    };
    AutoplayMenuView.prototype.onSpinsAmountChanged = function () {
        this.emit(AutoplayMenuView.SPINS_AMOUNT_CHANGED, this.autoplayAmount);
    };
    AutoplayMenuView.prototype.emitAccepted = function () {
        this.emit(AutoplayMenuViewEvents_1.AutoplayMenuViewEvents.ACCEPTED, this._autoplayAmount);
    };
    AutoplayMenuView.prototype.emitButtonPressed = function () {
        this.emit(AutoplayMenuViewEvents_1.AutoplayMenuViewEvents.BUTTON_PRESSED);
    };
    AutoplayMenuView.prototype.emitCancelled = function () {
        this.emit(AutoplayMenuViewEvents_1.AutoplayMenuViewEvents.CANCELLED);
    };
    AutoplayMenuView.prototype.emitClosed = function () {
        this.emit(AutoplayMenuViewEvents_1.AutoplayMenuViewEvents.AUTO_PLAY_MENU_CLOSED);
    };
    AutoplayMenuView.prototype.emitOpened = function () {
        this.emit(AutoplayMenuViewEvents_1.AutoplayMenuViewEvents.AUTO_PLAY_MENU_OPENED);
    };
    AutoplayMenuView.prototype.formatText = function (text) {
        return 'x' + text;
    };
    AutoplayMenuView.prototype.restoreToLastAutoplayAmount = function (value) {
        var lastAutoplayAmount = this._buttons.find(function (button) { return button.id === value; });
        if (lastAutoplayAmount) {
            lastAutoplayAmount.setSelected();
            lastAutoplayAmount.forceClicked();
            this.setAutoplay(value, false);
        }
    };
    AutoplayMenuView.prototype.generateButtons = function () {
        for (var _i = 0, _a = this._buttonValues; _i < _a.length; _i++) {
            var buttonValue = _a[_i];
            var button = this.createButton(buttonValue);
            this._buttons.push(button);
            this.container.addChild(button);
        }
        this.layoutButtons();
    };
    AutoplayMenuView.prototype.onCancelPressed = function () {
        this.soundPlayer.play('buttonClick');
        this.emitCancelled();
        this.hide();
    };
    AutoplayMenuView.prototype.onAcceptPressed = function () {
        this.soundPlayer.play('buttonClick');
        this.emitAccepted();
        this.hide();
    };
    AutoplayMenuView.prototype.createButton = function (value) {
        var button = new GenericButton_1.GenericButton(this._buttonsCallback.bind(this, value));
        button.id = value;
        var textValue = this.formatText(value);
        var up = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'AUTOPLAY_MENU_BOX.png'));
        var down = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'AUTOPLAY_MENU_BOX_CLICKED.png'));
        var over = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'AUTOPLAY_MENU_BOX_HOVER.png'));
        var disabled = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'AUTOPLAY_MENU_BOX_DISABLED.png'));
        up.anchor.set(0.5, 0.5);
        down.anchor.set(0.5, 0.5);
        over.anchor.set(0.5, 0.5);
        disabled.anchor.set(0.5, 0.5);
        var textUp = new PIXI.Text(textValue, this._buttonStyle);
        textUp.anchor.set(0.5, 0.5);
        up.addChild(textUp);
        var textDown = new PIXI.Text(textValue, this._buttonDownStyle);
        textDown.anchor.set(0.5, 0.5);
        down.addChild(textDown);
        var textOver = new PIXI.Text(textValue, this._buttonOverStyle);
        textOver.anchor.set(0.5, 0.5);
        over.addChild(textOver);
        var textDisabled = new PIXI.Text(textValue, this._buttonDisabledStyle);
        textDisabled.anchor.set(0.5, 0.5);
        disabled.addChild(textDisabled);
        disabled.tint = this.buttonDisabledTint;
        button.setFrames(up, down, over, disabled);
        return button;
    };
    AutoplayMenuView.prototype.layoutButtons = function () {
        var Start = this._spineLayout.skeleton.findBone('BOX_CONTAINER1').data;
        var startPosition = {
            x: Start.x + this.resolutionManager.halfResolution.width,
            y: this.resolutionManager.halfResolution.height - Start.y,
        };
        for (var button = 0; button < this._buttons.length; button++) {
            var xPosition = this._xOffset * -(button % AutoplayMenuView.MAX_BUTTONS_PER_ROW) + startPosition.x;
            var yPosition = this._yOffset * Math.floor(button / AutoplayMenuView.MAX_BUTTONS_PER_ROW) + startPosition.y;
            this._buttons[button].position.set(xPosition, yPosition);
        }
    };
    AutoplayMenuView.prototype.setupCheckboxes = function () {
        this._stopAutoplayAfterWinCheckbox = new Spine_1.Spine(this.resources.getSpine('SETTINGS_CONFIG_BUTTON.json'));
        var slot = this._spineLayout.slotContainers[this._spineLayout.skeleton.findSlotIndex('STOP_AUTOPLAY_CONFIG')];
        slot.addChild(this._stopAutoplayAfterWinCheckbox);
        this._stopAutoplayAfterWinCheckbox.state.setAnimation(0, this.getToggleAnimation(this._stopAutoplayAfterWinChecked), false);
        this._stopAutoplayAfterWinCheckbox.update(0);
        this._stopAutoplayAfterWinCheckbox.interactive = true;
        this._stopAutoplayAfterWinCheckbox.buttonMode = true;
        this._stopAutoplayAfterWinCheckbox.on('mousedown', this.stopAutoplayAfterWinToggle.bind(this));
        this._stopAutoplayAfterWinCheckbox.on('touchstart', this.stopAutoplayAfterWinToggle.bind(this));
    };
    AutoplayMenuView.prototype.getToggleAnimation = function (isActive) {
        return isActive ? AnimationNames_1.AnimationNames.SETTINGS_CONFIG_TOGGLE.Name.ACTIVE : AnimationNames_1.AnimationNames.SETTINGS_CONFIG_TOGGLE.Name.INACTIVE;
    };
    AutoplayMenuView.prototype.stopAutoplayAfterWinToggle = function () {
        if (this._stopAutoplayAfterWinChecked) {
            this._stopAutoplayAfterWinCheckbox.state.setAnimation(0, AnimationNames_1.AnimationNames.SETTINGS_CONFIG_TOGGLE.Name.INACTIVE, true);
            this._stopAutoplayAfterWinChecked = false;
        }
        else {
            this._stopAutoplayAfterWinCheckbox.state.setAnimation(0, AnimationNames_1.AnimationNames.SETTINGS_CONFIG_TOGGLE.Name.ACTIVE, true);
            this._stopAutoplayAfterWinChecked = true;
        }
        this._stopAutoplayAfterWinCheckbox.update(0);
    };
    Object.defineProperty(AutoplayMenuView.prototype, "sliderNumberTextScaleMod", {
        get: function () {
            return this._buttonScaleMod;
        },
        enumerable: true,
        configurable: true
    });
    AutoplayMenuView.LOSS_LIMIT_CHANGED = 'AutoplayMenuView::LOSS_LIMIT_CHANGED';
    AutoplayMenuView.SINGLE_WIN_LIMIT_CHANGED = 'AutoplayMenuView::SINGLE_WIN_LIMIT_CHANGED';
    AutoplayMenuView.WIN_LIMIT_CHANGED = 'AutoplayMenuView::WIN_LIMIT_CHANGED';
    AutoplayMenuView.SPINS_AMOUNT_CHANGED = 'AutoplayMenuView::SPIN_AMOUNT_CHANGED';
    AutoplayMenuView.MAX_BUTTONS_PER_ROW = 4;
    AutoplayMenuView.Y_BUTTON_OFFSET = 90;
    return AutoplayMenuView;
}(View_1.View));
exports.AutoplayMenuView = AutoplayMenuView;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AutoplayMenuViewEvents = /** @class */ (function () {
    function AutoplayMenuViewEvents() {
    }
    AutoplayMenuViewEvents.UPDATE_AUTOPLAY_SPINS = 'AutoplayMenuViewEvents::UPDATE_AUTOPLAY_SPINS';
    AutoplayMenuViewEvents.ACCEPTED = 'AutoplayMenuViewEvents::ACCEPTED';
    AutoplayMenuViewEvents.CANCELLED = 'AutoplayMenuViewEvents::CANCELLED';
    AutoplayMenuViewEvents.BUTTON_PRESSED = 'AutoplayMenuViewEvents::BUTTON_PRESSED';
    AutoplayMenuViewEvents.AUTO_PLAY_MENU_OPENED = 'AutoplayMenuViewEvents::AUTO_PLAY_MENU_OPENED';
    AutoplayMenuViewEvents.AUTO_PLAY_MENU_CLOSED = 'AutoplayMenuViewEvents::AUTO_PLAY_MENU_CLOSED';
    AutoplayMenuViewEvents.UPDATE_AUTOPLAY_VALUES = 'AutoplayMenuViewEvents::UPDATE_AUTOPLAY_VALUES';
    return AutoplayMenuViewEvents;
}());
exports.AutoplayMenuViewEvents = AutoplayMenuViewEvents;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BetlevelMenuViewEvents = /** @class */ (function () {
    function BetlevelMenuViewEvents() {
    }
    BetlevelMenuViewEvents.ACCEPTED = 'BetlevelMenuViewEvents::ACCEPTED';
    BetlevelMenuViewEvents.CANCELLED = 'BetlevelMenuViewEvents::CANCELLED';
    BetlevelMenuViewEvents.BUTTON_PRESSED = 'BetlevelMenuViewEvents::BUTTON_PRESSED';
    BetlevelMenuViewEvents.BET_LEVEL_MENU_OPENED = 'BetlevelMenuViewEvents::BET_LEVEL_MENU_OPENED';
    BetlevelMenuViewEvents.BET_LEVEL_MENU_CLOSED = 'BetlevelMenuViewEvents::BET_LEVEL_MENU_CLOSED';
    return BetlevelMenuViewEvents;
}());
exports.BetlevelMenuViewEvents = BetlevelMenuViewEvents;


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var RestoreScreenEvents = /** @class */ (function () {
    function RestoreScreenEvents() {
    }
    RestoreScreenEvents.RESTORE_WINDOW_CLOSED = 'RestoreScreenEvents::RESTORE_WINDOW_CLOSED';
    RestoreScreenEvents.RESTORE_WINDOW_OPENED = 'RestoreScreenEvents::RESTORE_WINDOW_OPENED';
    return RestoreScreenEvents;
}());
exports.RestoreScreenEvents = RestoreScreenEvents;


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var NineSlicePlane_1 = __webpack_require__(253);
var View_1 = __webpack_require__(3);
var GenericButton_1 = __webpack_require__(90);
var Timer_1 = __webpack_require__(28);
var InfoPopupView = /** @class */ (function (_super) {
    __extends(InfoPopupView, _super);
    function InfoPopupView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._disabledTint = 0x888888;
        return _this;
    }
    InfoPopupView.prototype.init = function () {
        _super.prototype.init.call(this);
        this._background = new PIXI.Graphics();
        this._background.beginFill(0x000000, 0.5);
        this._background.drawRect(0, 0, this.resolutionManager.resolution.width, this.resolutionManager.resolution.height);
        this._background.endFill();
        this._window9Slice = new NineSlicePlane_1.NineSlicePlane(this.resources.getSpritesheetTexture('HUD.json', 'INFO_MESSAGE.png'), this.resources.getNineSliceData('HUD.json', 'INFO_MESSAGE.png'));
        this._window9SliceRealityCheck = new NineSlicePlane_1.NineSlicePlane(this.resources.getSpritesheetTexture('HUD.json', 'INFO_MESSAGE.png'), this.resources.getNineSliceData('HUD.json', 'INFO_MESSAGE.png'));
        this._window9SliceError = new NineSlicePlane_1.NineSlicePlane(this.resources.getSpritesheetTexture('HUD.json', 'ERROR_MESSAGE.png'), this.resources.getNineSliceData('HUD.json', 'ERROR_MESSAGE.png'));
        this._okButton = this.createOKButton();
        this._okRealityCheckButton = this.createOKButton();
        this._okErrorButton = this.createOKButton();
        this._homeButton = this.createHomeButton();
        this._window9Slice.addChild(this._okButton);
        this._window9SliceError.addChild(this._okErrorButton);
        this._window9SliceRealityCheck.addChild(this._okRealityCheckButton);
        this._window9SliceRealityCheck.addChild(this._homeButton);
        this._textStyle = this.textStyles.infoPopup;
        this._infoText = new PIXI.Text('', this._textStyle);
        this._infoRealityCheckText = new PIXI.Text('', this._textStyle);
        this._window9Slice.addChild(this._infoText);
        this._window9SliceRealityCheck.addChild(this._infoRealityCheckText);
        this._infoErrorText = new PIXI.Text('', this._textStyle);
        this._window9SliceError.addChild(this._infoErrorText);
        this.container.interactive = true;
        this.container.on('mousedown', function () { });
        this.container.on('mouseup', function () { });
        this.container.on('mouseover', function () { });
        this.container.on('mouseout', function () { });
        this.container.on('click', function () { });
        this.container.on('tap', function () { });
        this.container.on('touchstart', function () { });
        this.container.on('touchendoutside', function () { });
        this.container.on('touchend', function () { });
    };
    InfoPopupView.prototype.showFatalErrorMessage = function (messageText) {
        this._window9SliceError.width = 600;
        this._window9SliceError.x = this.resolutionManager.halfResolution.width - this._window9SliceError.width / 2;
        this._infoErrorText.text = messageText;
        this._window9SliceError.height = 400 + this._infoErrorText.height;
        this._window9SliceError.y = this.resolutionManager.halfResolution.height - this._window9SliceError.height / 2;
        this._infoErrorText.x = this._window9SliceError.width / 2 - this._infoErrorText.getBounds().width / 2;
        this._infoErrorText.y = 110;
        this.container.addChild(this._background);
        this.container.addChild(this._window9SliceError);
    };
    InfoPopupView.prototype.showErrorMessage = function (messageText) {
        this._window9SliceError.width = 600;
        this._window9SliceError.x = this.resolutionManager.halfResolution.width - this._window9SliceError.width / 2;
        this._infoErrorText.text = messageText;
        this._window9SliceError.height = 400 + this._infoErrorText.height;
        this._window9SliceError.y = this.resolutionManager.halfResolution.height - this._window9SliceError.height / 2;
        this._okErrorButton.visible = true;
        this._okErrorButton.x = this._window9SliceError.width / 2;
        this._okErrorButton.y = this._window9SliceError.height - 110 - this._okErrorButton.height;
        this._infoErrorText.x = this._window9SliceError.width / 2 - this._infoErrorText.getBounds().width / 2;
        this._infoErrorText.y = 110;
        this.container.addChild(this._background);
        this.container.addChild(this._window9SliceError);
    };
    InfoPopupView.prototype.showOKMessage = function (messageText) {
        this._window9Slice.width = 600;
        this._window9Slice.x = this.resolutionManager.halfResolution.width - this._window9Slice.width / 2;
        this._infoText.text = messageText;
        this._window9Slice.height = 400 + this._infoText.height;
        this._window9Slice.y = this.resolutionManager.halfResolution.height - this._window9Slice.height / 2;
        this._okButton.visible = true;
        this._okButton.x = this._window9Slice.width / 2;
        this._okButton.y = this._window9Slice.height - 110 - this._okButton.height;
        this._infoText.x = this._window9Slice.width / 2 - this._infoText.getBounds().width / 2;
        this._infoText.y = 110;
        this.container.addChild(this._background);
        this.container.addChild(this._window9Slice);
    };
    InfoPopupView.prototype.showRealityCheckWithExitOptionMessage = function (messageText) {
        this._window9SliceRealityCheck.width = 600;
        this._window9SliceRealityCheck.x = this.resolutionManager.halfResolution.width - this._window9SliceRealityCheck.width / 2;
        this._infoRealityCheckText.text = messageText;
        this._window9SliceRealityCheck.height = 400 + this._infoRealityCheckText.height;
        this._window9SliceRealityCheck.y = this.resolutionManager.halfResolution.height - this._window9SliceRealityCheck.height / 2;
        this._okRealityCheckButton.visible = true;
        this._okRealityCheckButton.x = this._window9SliceRealityCheck.width / 2 - 120;
        this._okRealityCheckButton.y = this._window9SliceRealityCheck.height - 110 - this._okRealityCheckButton.height;
        this._homeButton.visible = true;
        this._homeButton.x = this._window9SliceRealityCheck.width / 2 + 120;
        this._homeButton.y = this._window9SliceRealityCheck.height - 110 - this._homeButton.height;
        this._infoRealityCheckText.x = this._window9SliceRealityCheck.width / 2 - this._infoRealityCheckText.getBounds().width / 2;
        this._infoRealityCheckText.y = 110;
        this.container.addChild(this._background);
        this.container.addChild(this._window9SliceRealityCheck);
    };
    InfoPopupView.prototype.showSimpleMessage = function (messageText) {
        var _this = this;
        this.showOKMessage(messageText);
        this._okButton.visible = false;
        this.container.on('click', this.onContainerClick.bind(this));
        this.container.on('tap', this.onContainerClick.bind(this));
        this._currentSimpleMessageTimer = new Timer_1.Timer(function () {
            _this.onContainerClick();
        }, 5000, true);
        this.updateManager.add(this._currentSimpleMessageTimer);
    };
    InfoPopupView.prototype.createOKButton = function () {
        var okButton = new GenericButton_1.GenericButton(this.onOkClicked.bind(this));
        var up = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'MENU_BUTTONS.png'));
        var down = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'MENU_BUTTONS.png'));
        var over = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'MENU_BUTTONS.png'));
        var disabled = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'MENU_BUTTONS.png'));
        up.anchor.set(0.5, 0.5);
        down.anchor.set(0.5, 0.5);
        over.anchor.set(0.5, 0.5);
        disabled.anchor.set(0.5, 0.5);
        disabled.tint = this.disabledTint;
        okButton.setFrames(up);
        okButton.anchor.set(0.5, 0.5);
        var confirmImage = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'CONFIRM.png'));
        confirmImage.anchor.set(0.5, 0.5);
        up.addChild(confirmImage);
        return okButton;
    };
    InfoPopupView.prototype.createHomeButton = function () {
        var okButton = new GenericButton_1.GenericButton(this.onHomeClicked.bind(this));
        var up = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'MENU_BUTTONS.png'));
        var down = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'MENU_BUTTONS.png'));
        var over = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'MENU_BUTTONS.png'));
        var disabled = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'MENU_BUTTONS.png'));
        up.anchor.set(0.5, 0.5);
        down.anchor.set(0.5, 0.5);
        over.anchor.set(0.5, 0.5);
        disabled.anchor.set(0.5, 0.5);
        disabled.tint = this.disabledTint;
        okButton.setFrames(up);
        okButton.anchor.set(0.5, 0.5);
        var confirmImageUp = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'HOME_BUTTON.png'));
        confirmImageUp.anchor.set(0.5, 0.5);
        up.addChild(confirmImageUp);
        var confirmImageDown = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'HOME_BUTTON_CLICKED.png'));
        confirmImageDown.anchor.set(0.5, 0.5);
        down.addChild(confirmImageDown);
        var confirmImageOver = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'HOME_BUTTON.png'));
        confirmImageOver.anchor.set(0.5, 0.5);
        over.addChild(confirmImageOver);
        return okButton;
    };
    InfoPopupView.prototype.onContainerClick = function () {
        this.container.off('click');
        this.container.off('tap');
        this.updateManager.remove(this._currentSimpleMessageTimer);
        this._currentSimpleMessageTimer = null;
        this.onOkClicked();
    };
    InfoPopupView.prototype.onOkClicked = function () {
        this.container.removeChild(this._window9Slice);
        this.container.removeChild(this._window9SliceError);
        this.container.removeChild(this._window9SliceRealityCheck);
        this.container.removeChild(this._background);
        this.emit(InfoPopupView.OK_CLICKED);
    };
    InfoPopupView.prototype.onHomeClicked = function () {
        this.container.removeChild(this._window9Slice);
        this.container.removeChild(this._window9SliceError);
        this.container.removeChild(this._window9SliceRealityCheck);
        this.container.removeChild(this._background);
        this.emit(InfoPopupView.HOME_CLICKED);
    };
    Object.defineProperty(InfoPopupView.prototype, "disabledTint", {
        set: function (value) {
            this._disabledTint = value;
        },
        enumerable: true,
        configurable: true
    });
    InfoPopupView.OK_CLICKED = 'InfoPopupView::OK_CLICKED';
    InfoPopupView.HOME_CLICKED = 'InfoPopupView::HOME_CLICKED';
    return InfoPopupView;
}(View_1.View));
exports.InfoPopupView = InfoPopupView;


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var NineSlicePlane = /** @class */ (function (_super) {
    __extends(NineSlicePlane, _super);
    function NineSlicePlane(texture, nineSliceBorders) {
        var _this = _super.call(this, texture, nineSliceBorders.leftWidth, nineSliceBorders.topHeight, nineSliceBorders.rightWidth, nineSliceBorders.bottomHeight) || this;
        _this._anchor = { x: 0.5, y: 0.5 };
        _this.updatePositionFromAnchor();
        return _this;
    }
    NineSlicePlane.prototype.updatePositionFromAnchor = function () {
        this.position.x = -(this.width * this._anchor.x);
        this.position.y = -(this.height * this._anchor.y);
    };
    Object.defineProperty(NineSlicePlane.prototype, "anchor", {
        set: function (newAnchor) {
            this._anchor = newAnchor;
            this.updatePositionFromAnchor();
        },
        enumerable: true,
        configurable: true
    });
    return NineSlicePlane;
}(PIXI.mesh.NineSlicePlane));
exports.NineSlicePlane = NineSlicePlane;
var NineSlicePlaneFromObject = /** @class */ (function (_super) {
    __extends(NineSlicePlaneFromObject, _super);
    function NineSlicePlaneFromObject(nineSliceObject) {
        return _super.call(this, nineSliceObject.texture, nineSliceObject.nine) || this;
    }
    return NineSlicePlaneFromObject;
}(NineSlicePlane));
exports.NineSlicePlaneFromObject = NineSlicePlaneFromObject;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(59);
var View_1 = __webpack_require__(3);
var SpinButtonViewEvents_1 = __webpack_require__(111);
var SpinButton_1 = __webpack_require__(247);
var Button_1 = __webpack_require__(54);
var SpinButtonView = /** @class */ (function (_super) {
    __extends(SpinButtonView, _super);
    function SpinButtonView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SpinButtonView.prototype.init = function () {
        _super.prototype.init.call(this);
        this.setupSpinButton();
    };
    SpinButtonView.prototype.initAutoplay = function () {
        this.hideSpinButton();
    };
    SpinButtonView.prototype.uninitAutoplay = function () {
        this.showSpinButton();
    };
    SpinButtonView.prototype.hideSpinButton = function () {
        this._spinButton.visible = false;
    };
    SpinButtonView.prototype.showSpinButton = function () {
        this._spinButton.visible = true;
    };
    SpinButtonView.prototype.enableSpinButton = function (emitButtonBecameVisible) {
        if (emitButtonBecameVisible === void 0) { emitButtonBecameVisible = true; }
        if (this._spinButton.visible && emitButtonBecameVisible) {
            this.emit(SpinButtonView.SPIN_BUTTON_BECOMING_VISIBLE_AND_ENABLED);
        }
        this._spinButton.enable();
    };
    SpinButtonView.prototype.disableSpinButton = function () {
        this._spinButton.disable();
    };
    SpinButtonView.prototype.isSpinButtonVisibleAndEnabled = function () {
        return this._spinButton.currentState !== Button_1.ButtonState.DISABLED && this._spinButton.interactive && this._spinButton.visible;
    };
    SpinButtonView.prototype.spinButtonClickAction = function () { };
    SpinButtonView.prototype.setupSpinButton = function () {
        this._spinButton = new SpinButton_1.SpinButton(null, this.updateManager, this.resources);
        this.setupEventsForButtons();
        this.container.addChild(this._spinButton);
        this._spinButton.enable();
        var spinButtonPosition = this.layout.getPosition('SPIN_BUTTON', this.viewType);
        this._spinButton.position.set(spinButtonPosition.x, spinButtonPosition.y);
        var size = this.layout.getSize('SPIN_BUTTON', this.viewType);
        this._spinButton.hitArea = new PIXI.Circle(0, 0, size.width / 2);
        this.uninitAutoplay();
    };
    SpinButtonView.prototype.centerIn = function (source, parentWidth, parentHeight) {
        source.x = parentWidth / 2 - source.width / 2;
        source.y = parentHeight / 2 - source.height / 2;
        return source;
    };
    SpinButtonView.prototype.addTint = function (source, tint) {
        for (var _i = 0, _a = source.children; _i < _a.length; _i++) {
            var child = _a[_i];
            if (child instanceof PIXI.Sprite) {
                child.tint = tint;
            }
        }
        return source;
    };
    SpinButtonView.prototype.setupEventsForButtons = function () {
        this._spinButton.callback = this.onSpinButtonClicked.bind(this);
    };
    SpinButtonView.prototype.onSpinButtonClicked = function () {
        this.emit(SpinButtonViewEvents_1.SpinButtonViewEvents.SPIN_BUTTON_CLICKED);
    };
    SpinButtonView.SPIN_BUTTON_BECOMING_VISIBLE_AND_ENABLED = 'SpinButtonView::SPIN_BUTTON_BECOMING_VISIBLE_AND_ENABLED';
    return SpinButtonView;
}(View_1.View));
exports.SpinButtonView = SpinButtonView;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var View_1 = __webpack_require__(3);
var HTMLCreationUtils_1 = __webpack_require__(256);
var OrientationView = /** @class */ (function (_super) {
    __extends(OrientationView, _super);
    function OrientationView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /*	protected _fullscreenTouchImage: HTMLImageElement;
        protected _fullscreenTouchBackground: HTMLElement;
        protected _fullscreenTouchTween: Tween;*/
    OrientationView.prototype.init = function () {
        _super.prototype.init.call(this);
        // (window as any).debugText1 = this.addDebugText('Debug1');
        // (window as any).debugText2 = this.addDebugText('Debug2', 250);
        // (window as any).debugText3 = this.addDebugText('Debug3', 350);
        if (this.device.isMobile) {
            this.setupGraphicElements();
        }
    };
    OrientationView.prototype.addDebugText = function (text, y, x) {
        if (y === void 0) { y = 150; }
        if (x === void 0) { x = this.resolutionManager.halfResolution.width / 2; }
        var debugText = new PIXI.Text(text, this.textStyles.freeRoundsCaptionStyle);
        debugText.position.x = x;
        debugText.position.y = y;
        this.container.addChild(debugText);
        return debugText;
    };
    OrientationView.prototype.onPortrait = function () {
        var _this = this;
        _super.prototype.onPortrait.call(this);
        setTimeout(function () {
            _this.toggleNotification(true);
        }, 0);
        this.emit(OrientationView.ORIENTATION_CHANGED_TO_PORTRAIT);
    };
    OrientationView.prototype.onLandscape = function () {
        var _this = this;
        _super.prototype.onLandscape.call(this);
        setTimeout(function () {
            _this.toggleNotification(false);
        }, 0);
        this.emit(OrientationView.ORIENTATION_CHANGED_TO_LANDSCAPE);
    };
    OrientationView.prototype.onFullscreenEntered = function () {
        _super.prototype.onFullscreenEntered.call(this);
        /*
                if (!this.device.isIframe && this.device.android) {
                    this.hideFullscreenTouchOverlay();
                }*/
    };
    OrientationView.prototype.onFullscreenExited = function () {
        _super.prototype.onFullscreenExited.call(this);
        /*		if (!this.device.isIframe && this.device.android) {
                    this.showFullscreenTouchOverlay();
                }*/
    };
    /*	protected startFullscreenTouchIconAnimation(): void {
            this.stopFullscreenTouchIconAnimation();

            const tweenObj = {y: 1};

            this._fullscreenTouchTween = new Tween(tweenObj)
                .to({y: [0.7, 1]}, 1500)
                .easing(Easing.Back.InOut)
                .onUpdate(() => {
                    this._fullscreenTouchImage.style.transform = `translateX(-50%) translateY(-50%) scale(${tweenObj.y})`;
                    this._fullscreenTouchImage.style.top = `${40 + (tweenObj.y - 0.7) * 10}%`;
                })
                .onComplete(() => {
                    this.startFullscreenTouchIconAnimation();
                })
                .repeat(3)
                .start();

            this.updateManager.add(this._fullscreenTouchTween);
        }

        protected stopFullscreenTouchIconAnimation(): void {
            if (this._fullscreenTouchTween && this._fullscreenTouchTween.isPlaying) {
                this._fullscreenTouchTween.stop();
                this._fullscreenTouchImage.style.transform = `translateX(-50%) translateY(-50%) scale(1)`;
            }
        }

        protected showFullscreenTouchOverlay(): void {
            this._fullscreenTouchImage.style.display = 'block';
            this._fullscreenTouchBackground.style.display = 'block';
            this.startFullscreenTouchIconAnimation();
        }

        protected hideFullscreenTouchOverlay(): void {
            this._fullscreenTouchImage.style.display = 'none';
            this._fullscreenTouchBackground.style.display = 'none';
            this.stopFullscreenTouchIconAnimation();
        }

        protected isFullscreenOverlayVisible(): boolean {
            return this._fullscreenTouchImage.style.display === 'block' ? true : false;
        }*/
    OrientationView.prototype.setupGraphicElements = function () {
        // if (!this._background) {
        this._background = HTMLCreationUtils_1.HTMLCreationUtils.createBackground('tiltNotificationBackground');
        this._image = HTMLCreationUtils_1.HTMLCreationUtils.createOverlayImage('TILT_ICON.png', this._background, this.resources);
        this._background.style.display = 'none';
        this._image.style.display = 'none';
        /*
                this._fullscreenTouchBackground = HTMLCreationUtils.createBackground('fullscreenNotificationBackground', 'rgba(0,0,0,0.5)');
                this._fullscreenTouchImage = HTMLCreationUtils.createOverlayImage(
                    'TOUCH_ICON.png',
                    this._fullscreenTouchBackground,
                    this.resources,
                );


                this._fullscreenTouchBackground.style.display = 'none';
                this._fullscreenTouchImage.style.display = 'none';

                if (!this.device.android) {
                    this.hideFullscreenTouchOverlay();
                }*/
    };
    OrientationView.prototype.isFullscreen = function () {
        return !!document[this.device.fullscreenElement];
    };
    OrientationView.prototype.toggleNotification = function (isPortrait) {
        if (isPortrait) {
            this._image.style.display = 'none';
            this._background.style.display = 'none';
            /*	if (!this.device.isIframe && this.device.android && !this.isFullscreen()) {
                    this.showFullscreenTouchOverlay();
                }*/
            this.parent.visible = true;
        }
        else {
            /*	if (!this.device.isIframe && this.device.android && this.isFullscreenOverlayVisible()) {
                    this.hideFullscreenTouchOverlay();
                }*/
            this._image.style.display = 'block';
            this._background.style.display = 'block';
            this.parent.visible = false;
        }
    };
    OrientationView.ORIENTATION_CHANGED_TO_PORTRAIT = 'OrientationView::ORIENTATION_CHANGED_TO_PORTRAIT';
    OrientationView.ORIENTATION_CHANGED_TO_LANDSCAPE = 'OrientationView::ORIENTATION_CHANGED_TO_LANDSCAPE';
    return OrientationView;
}(View_1.View));
exports.OrientationView = OrientationView;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var HTMLCreationUtils = /** @class */ (function () {
    function HTMLCreationUtils() {
    }
    HTMLCreationUtils.createBackground = function (elementId, backgroundColor, target) {
        if (backgroundColor === void 0) { backgroundColor = 'rgba(0,0,0,1)'; }
        if (target === void 0) { target = document.body; }
        var background = document.createElement('div');
        background.style.position = 'absolute';
        background.style.width = '100%';
        background.style.height = '100%';
        background.style.backgroundColor = backgroundColor;
        background.style.left = '0px';
        background.style.top = '0px';
        background.id = elementId;
        target.appendChild(background);
        return background;
    };
    HTMLCreationUtils.createOverlayImage = function (textureName, target, resourceLoader) {
        if (target === void 0) { target = document.body; }
        var image = document.createElement('img');
        image.src = resourceLoader.getTexture(textureName).baseTexture.imageUrl;
        image.style.position = 'absolute';
        image.style.left = '50%';
        image.style.webkitTransform = 'translateX(-50%) translateY(-50%)';
        image.style.transform = 'translateX(-50%) translateY(-50%)';
        image.style.top = '50%';
        document.body.appendChild(image);
        return image;
    };
    HTMLCreationUtils.getResourceImageUrl = function (textureName, resourceLoader) {
        return resourceLoader.getTexture(textureName).baseTexture.imageUrl;
    };
    HTMLCreationUtils.getResourceUrl = function (resourceName, resourseLoader) {
        return resourseLoader.getPathForResource(resourceName);
    };
    /**
     * For dynamically loading a script component or a vss component to the game.
     *
     * Example uses:
     * loadjscssfile("myscript.js", "js") //dynamically load and add this .js file
     * loadjscssfile("javascript.php", "js") //dynamically load "javascript.php" as a JavaScript
     * file
     * loadjscssfile("mystyle.css", "css") // dynamically load and add this .css file
     * @memberof HTMLCreationUtils
     */
    HTMLCreationUtils.loadJsCssFile = function (fileName, fileType, target) {
        if (target === void 0) { target = null; }
        var fileReference = null;
        if (fileType === 'js') {
            // if filename is a external JavaScript file
            fileReference = document.createElement('script');
            fileReference.setAttribute('type', 'text/javascript');
            fileReference.setAttribute('src', fileName);
        }
        else if (fileType === 'css') {
            // if filename is an external CSS file
            fileReference = document.createElement('link');
            fileReference.setAttribute('rel', 'stylesheet');
            fileReference.setAttribute('type', 'text/css');
            fileReference.setAttribute('href', fileName);
        }
        if (fileReference) {
            if (!target) {
                document.getElementsByTagName('head')[0].appendChild(fileReference);
            }
            else {
                target.appendChild(fileReference);
            }
        }
    };
    return HTMLCreationUtils;
}());
exports.HTMLCreationUtils = HTMLCreationUtils;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var OrientationEvents = /** @class */ (function () {
    function OrientationEvents() {
    }
    OrientationEvents.ORIENTATION_CHANGED_TO_PORTRAIT = 'OrientationEvents::ORIENTATION_CHANGED_TO_PORTRAIT';
    OrientationEvents.ORIENTATION_CHANGED_TO_LANDSCAPE = 'OrientationEvents::ORIENTATION_CHANGED_TO_LANDSCAPE';
    return OrientationEvents;
}());
exports.OrientationEvents = OrientationEvents;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var View_1 = __webpack_require__(3);
var LogotypeView = /** @class */ (function (_super) {
    __extends(LogotypeView, _super);
    function LogotypeView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LogotypeView.prototype.init = function () {
        _super.prototype.init.call(this);
        this.setupLogotype();
    };
    LogotypeView.prototype.shouldReplaceLogoElement = function () {
        return (this.resources
            .getLocale()
            .toLowerCase()
            .indexOf('zh') > -1);
    };
    LogotypeView.prototype.getLocale = function () {
        var locale = this.resources.getLocale().toUpperCase();
        if (locale.indexOf('ZH') > -1) {
            locale = locale.split('-').join('_');
        }
        return locale;
    };
    LogotypeView.prototype.setupLogotype = function () {
        var _this = this;
        var position = this.layout.getAbsolutePosition('GAME_LOGO', this.viewType);
        var logo = this.spineUtils
            .startSpineAnimationCreation('LOGOTYPE.json', 'IDLE', true)
            .position(position)
            .createAndStart();
        if (this.shouldReplaceLogoElement()) {
            this.spineUtils.replaceElementInSpineAnimation(logo, 'LOGO', new PIXI.Sprite(this.resources.getTexture("LOGO_" + this.getLocale() + ".png")));
        }
        if (false) {
            if (this.device.isMobile) {
                logo.container.interactive = logo.container.buttonMode = true;
                var lastTap_1 = 0;
                var timeout_1 = null;
                logo.container.on('touchend', function () {
                    var currentTime = new Date().getTime();
                    var tapLength = currentTime - lastTap_1;
                    clearTimeout(timeout_1);
                    if (tapLength < 500 && tapLength > 0) {
                        _this.emit(LogotypeView.LOGOTYPE_DOUBLE_TAPPED);
                        lastTap_1 = 0;
                    }
                    else {
                        timeout_1 = setTimeout(function () {
                            clearTimeout(timeout_1);
                        }, 500);
                        lastTap_1 = currentTime;
                    }
                });
            }
        }
    };
    LogotypeView.LOGOTYPE_DOUBLE_TAPPED = 'LogotypeView::LOGOTYPE_DOUBLE_TAPPED';
    return LogotypeView;
}(View_1.View));
exports.LogotypeView = LogotypeView;


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var SpriteGraphics_1 = __webpack_require__(62);
var HTMLCreationUtils_1 = __webpack_require__(256);
var View_1 = __webpack_require__(3);
var Scrollbar_1 = __webpack_require__(148);
var GameUtils_1 = __webpack_require__(26);
var error_1 = __webpack_require__(517);
var HTMLPageView = /** @class */ (function (_super) {
    __extends(HTMLPageView, _super);
    function HTMLPageView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._uiStageOffsetY = 0;
        _this._uiStageMaxY = 0;
        _this._hasLoaded = false;
        _this._yOffset = 0;
        _this._minYDrag = 0;
        _this._maxYDrag = 0;
        _this._resourcesPath = 'HTML/';
        _this._containerId = 'FANTASMA_CONTAINER';
        return _this;
    }
    HTMLPageView.prototype.init = function () {
        var _this = this;
        _super.prototype.init.call(this);
        this.setupPathsAndIds();
        this._gameCanvas = document.getElementById('GameCanvas');
        this.setupUiOffset();
        this.setupHTML();
        this.hide();
        if (false) {
            window.isGameRulesVisible = function () {
                return _this._mainContainer.style.visibility === 'visible';
            };
        }
    };
    HTMLPageView.prototype.show = function () {
        _super.prototype.show.call(this);
        this._mainContainer.style.display = this.device.isIE || this.device.isMacOs ? 'block' : 'grid';
        if (this.device.isIOSMobileRequestingDesktop) {
            this._mainContainer.style.display = 'grid';
        }
        this._mainContainer.style.visibility = 'visible';
        if (this.device.isMobile || this.device.hasTouch) {
            this._minYDrag = this._mainBody.offsetHeight - this.resolutionManager.halfResolution.height * 0.5;
            this._minYDrag *= -1;
            if (!this._scrollBar) {
                this.addScrollbar();
            }
        }
    };
    HTMLPageView.prototype.hide = function () {
        _super.prototype.hide.call(this);
        this._mainContainer.style.display = 'none';
        this._mainContainer.style.visibility = 'hidden';
    };
    HTMLPageView.prototype.onResized = function (screenParams) {
        this.resizeHTML();
    };
    /** Prefer not to use this. */
    HTMLPageView.prototype.spriteSheetTextureToHTMLImage = function (texture, className) {
        var atlasCropper = document.createElement('div');
        var imageDiv = document.createElement('img');
        atlasCropper.appendChild(imageDiv);
        atlasCropper.className = className;
        imageDiv.className = 'croppedImage';
        imageDiv.style.webkitTransform = "translateX(-" + texture.orig.x + "px) translateY(-" + texture.orig.y + ")";
        imageDiv.style.transform = "translateX(-" + texture.orig.x + "px) translateY(-" + texture.orig.y + ")";
        imageDiv.src = texture.baseTexture.imageUrl;
        return atlasCropper;
    };
    HTMLPageView.prototype.setupPathsAndIds = function () {
    };
    HTMLPageView.prototype.setupUiOffset = function () {
        var menuSkeleton = this.resources.getSpine('MAIN_MENU.json');
        var yPosTop = this.spineUtils.getBoneAbsolutePosition(menuSkeleton, 'TEXT_CUT_POSITION_TOP').y;
        var yPosBottom = this.spineUtils.getBoneAbsolutePosition(menuSkeleton, 'TEXT_CUT_POSITION_BOTTOM').y;
        this._uiStageOffsetY = this.resolutionManager.halfResolution.height - yPosTop;
        this._uiStageMaxY = this.resolutionManager.halfResolution.height - yPosBottom;
    };
    HTMLPageView.prototype.setupHTML = function () {
        this.setupMainContainer();
        this.setupMainDiv();
        this._mainContainer.appendChild(this._mainBody);
        this._gameCanvas.parentElement.appendChild(this._mainContainer);
        this.loadCss();
        this.resizeHTML();
        this._mainContainer.style.transformOrigin = "0px 0px";
        var totalHeight = this._uiStageMaxY - this._uiStageOffsetY;
        this._mainContainer.style.maxHeight = this._mainContainer.style.height = totalHeight + "px";
    };
    HTMLPageView.prototype.loadCss = function () {
        // Add check for file loaded or not.
        HTMLCreationUtils_1.HTMLCreationUtils.loadJsCssFile(this.resources.getDevicePathForResource('HTML/STYLE.css'), 'css');
    };
    HTMLPageView.prototype.setupMainContainer = function () {
        this._mainContainer = document.createElement('div');
        this._mainContainer.id = this._containerId;
        this._mainContainer.style.display = 'none';
        this._mainContainer.style.position = 'absolute';
        this._mainContainer.style.visibility = 'hidden';
        this._mainContainer.style.height = this.resolutionManager.resolution.height - this._uiStageOffsetY + 'px';
        this._mainContainer.style.width = this.resolutionManager.resolution.width + 'px';
    };
    HTMLPageView.prototype.setupMainDiv = function () {
        this._mainBody = document.createElement('div');
        this._mainBody.innerHTML = this.getBodyContent();
        this._mainBody.id = 'FANTASMA_PAYTABLE';
        // this._mainBody.style.width = '100%';
        this._mainBody.style.width = this.device.isMobile ? this._mainContainer.style.width : '100%';
        this._mainBody.style.height = '100%';
        this.onDivComplete();
    };
    HTMLPageView.prototype.onDivComplete = function () {
        this._hasLoaded = true;
        this.replaceImages();
        if (this.device.isMobile || this.device.hasTouch) {
            this.setupForIOS();
        }
        else {
            this.setupInputForDesktop();
        }
    };
    HTMLPageView.prototype.getIframeContent = function () {
        throw new error_1.Error('Needs implementation.');
    };
    HTMLPageView.prototype.getBodyContent = function () {
        throw new error_1.Error('Needs implementation.');
    };
    /**
     * Only use for Iframe which is unpreffered.
     */
    HTMLPageView.prototype.onLoadComplete = function () {
        this._hasLoaded = true;
        // const iframeBody = this._mainIframe.contentDocument.body;
        // this._mainBody = iframeBody;
        if (this.device.iOS || this.device.iPad || this.device.hasTouch) {
            this.setupForIOS();
        }
        this.replaceImages();
    };
    HTMLPageView.prototype.setupInputForDesktop = function () {
        this._mainContainer.style.overflowY = 'scroll';
        this._mainContainer.style.webkitUserSelect = 'none';
        this._mainContainer.style.userSelect = 'none';
        this._mainContainer.style.msUserSelect = 'none';
        this._mainContainer.style.touchAction = 'none';
        this._mainBody.style.pointerEvents = 'none';
        this._mainBody.style.touchAction = 'none';
    };
    HTMLPageView.prototype.setupForIOS = function () {
        // this._mainContainer.appendChild(this._mainBody);
        this._mainContainer.style.overflowY = 'scroll';
        this._mainContainer.style.pointerEvents = 'none';
        this._mainContainer.style.touchAction = 'none';
        this._mainBody.style.pointerEvents = 'none';
        this._mainBody.style.touchAction = 'none';
        this.setupInput();
    };
    HTMLPageView.prototype.addScrollbar = function () {
        var contentHeight = this._uiStageMaxY - this._uiStageOffsetY;
        var scrollBarWidth = 12;
        this._scrollBar = new Scrollbar_1.Scrollbar(scrollBarWidth, contentHeight, contentHeight, this._mainBody.scrollHeight);
        this.container.addChild(this._scrollBar);
        this._scrollBar.position.set(this.resolutionManager.resolution.width - scrollBarWidth, this._uiStageOffsetY);
    };
    HTMLPageView.prototype.setupInput = function () {
        this._dragInput = SpriteGraphics_1.SpriteGraphics.makeHiddenRectangle(this.resolutionManager.resolution.width, this._uiStageMaxY - this._uiStageOffsetY);
        this._dragInput.interactive = true;
        this.container.addChild(this._dragInput);
        this._dragInput.position.y = this._uiStageOffsetY;
        this._dragInput.on('touchstart', this.onInputTouchStart.bind(this));
        this._dragInput.on('mousedown', this.onInputTouchStart.bind(this));
        this.onDragStopBoundFunction = this.removeInput.bind(this);
    };
    HTMLPageView.prototype.onInputTouchStart = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (this._isDragging) {
            return;
        }
        this._isDragging = true;
        document.addEventListener('touchend', this.onDragStopBoundFunction);
        document.addEventListener('touchcancel', this.onDragStopBoundFunction);
        document.addEventListener('mouseup', this.onDragStopBoundFunction);
        document.addEventListener('mouseleave', this.onDragStopBoundFunction);
        document.addEventListener('mouseout', this.onDragStopBoundFunction);
        this._dragStartY = event.data.global.y;
        this._dragInput.on('touchmove', this.onInputMove.bind(this));
        this._dragInput.on('mousemove', this.onInputMove.bind(this));
    };
    HTMLPageView.prototype.removeInput = function () {
        document.removeEventListener('touchend', this.onDragStopBoundFunction);
        document.removeEventListener('touchcancel', this.onDragStopBoundFunction);
        document.removeEventListener('mouseup', this.onDragStopBoundFunction);
        document.removeEventListener('mouseleave', this.onDragStopBoundFunction);
        document.removeEventListener('mouseout', this.onDragStopBoundFunction);
        this._dragInput.removeListener('touchmove');
        this._dragInput.removeListener('mousemove');
        this._isDragging = false;
    };
    HTMLPageView.prototype.onInputMove = function (event) {
        var deltaY = event.data.global.y - this._dragStartY;
        this._dragStartY = event.data.global.y;
        this._yOffset += deltaY;
        this._yOffset = Math.max(Math.min(this._yOffset, this._maxYDrag), this._minYDrag);
        this._mainBody.style.webkitTransform = "translateY(" + this._yOffset + "px)";
        this._mainBody.style.transform = "translateY(" + this._yOffset + "px)";
        var positionScalar = GameUtils_1.GameUtils.normalize(this._yOffset, 0, this._minYDrag);
        this._scrollBar.moveBarObject(1 - positionScalar);
    };
    HTMLPageView.prototype.replaceImages = function () {
        var images = this._mainBody.getElementsByTagName('img');
        // }
        var originalPath = '';
        // tslint:disable-next-line: prefer-for-of
        for (var i = 0; i < images.length; i++) {
            var image = images[i];
            originalPath = image.getAttribute('src').replace('./', '');
            var imageResource = this.resources.getDevicePathForResource(this._resourcesPath + originalPath);
            image.setAttribute('src', imageResource);
        }
    };
    HTMLPageView.prototype.resizeHTML = function () {
        var scale = parseFloat(this._gameCanvas.style.width) / this.resolutionManager.resolution.width;
        this._mainContainer.style.transform = "scale(" + scale + ")";
        this._mainContainer.style.top = this._uiStageOffsetY * scale + "px";
        this._mainContainer.style.marginLeft = "" + this._gameCanvas.style.marginLeft;
        this._mainContainer.style.marginTop = "" + this._gameCanvas.style.marginTop;
    };
    HTMLPageView.prototype.goToPage = function (id) {
        // TODO: If time,
        // Maybe implement as a regular HTML goto.
    };
    return HTMLPageView;
}(View_1.View));
exports.HTMLPageView = HTMLPageView;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var WinPresentationView_1 = __webpack_require__(155);
var Symbols_1 = __webpack_require__(38);
var ReelsUtils_1 = __webpack_require__(112);
var GameReelConstants_1 = __webpack_require__(34);
var WinNumbers_1 = __webpack_require__(45);
var GameWinPresentationView = /** @class */ (function (_super) {
    __extends(GameWinPresentationView, _super);
    function GameWinPresentationView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameWinPresentationView.prototype.addAllSymbolsIntoSprite = function (spr, resources) {
        Symbols_1.SymbolsCreation.addAllSymbolsIntoSprite(spr, resources);
    };
    GameWinPresentationView.prototype.addBackgroundsIntoSprite = function (spr, resources) {
        Symbols_1.SymbolsCreation.addBackgroundsIntoSprite(spr, resources);
    };
    GameWinPresentationView.prototype.getSizedSimpleWinAnimationName = function (isInitial, size) {
        return isInitial ? "INITIAL_WIN_" + size.height : "INDIVIDUAL_WIN_" + size.height;
    };
    GameWinPresentationView.prototype.addForegroundIntoSprite = function (spr) {
    };
    GameWinPresentationView.prototype.makeSizedSymbol = function (symbol, size) {
        return symbol;
    };
    GameWinPresentationView.prototype.getCurrentWinNumbersPosition = function () {
        return this.layout.getAbsolutePosition('WIN_NUMBER_POSITION');
    };
    GameWinPresentationView.prototype.setupWinNumbersSettings = function () {
        _super.prototype.setupWinNumbersSettings.call(this);
        this._winNumber.numberAnchor.y = 0.5;
        this._biggerWinNumber.numberAnchor.y = 0.5;
    };
    GameWinPresentationView.prototype.playWinPresentationFor = function (isInitial, winLines, reels, reelsToSkip, addLine) {
        this.killCurrentWinPresentation();
        this.hideWinPresentationSymbols();
        this.onInitialWinAnimationFinished();
    };
    GameWinPresentationView.prototype.getAnimationPosition = function () {
        return this.layout.getAbsolutePosition('WIN_POSITION');
    };
    GameWinPresentationView.prototype.getWinSymbolPosition = function (posOnReels, reels) {
        var position = ReelsUtils_1.ReelsUtils.getPositionOnReels(posOnReels, reels);
        return {
            x: position.x - GameReelConstants_1.GameReelConstants.getBottomSymbolSlot().width / 2,
            y: position.y - GameReelConstants_1.GameReelConstants.getBottomSymbolSlot().height / 2,
        };
    };
    GameWinPresentationView.prototype.createWinSymbols = function () {
    };
    GameWinPresentationView.prototype.skipCountUp = function () {
        if (this._meter.isPlaying) {
            this._meter.snapToFinalValue();
            this.onWinMeterCompleted();
        }
    };
    GameWinPresentationView.prototype.playCountingFormToAfterMultiplier = function (fromValue, toValue) {
        this._currentFinalNumber = toValue;
        this.forceKillWinNumbers();
        this._isPlayingEndAnimation = false;
        this._currentWinNumbers = this._biggerWinNumber;
        this.initMeter();
        this._meter.resolutionPadding = 100;
        this._meter.resolutionWidth = this.resolutionManager.resolution.width;
        this._meter.from(fromValue).to(toValue, this.getCountingTime());
        this._meter.onCompleteCallback = this.onWinMeterCompleted.bind(this);
        this._meter.start();
        this.updateManager.add(this._meter);
        this.killCurrentAnimation();
        this._isEndingAnimationInProgress = false;
        var animPosition = this.getAnimationPosition();
        this.spineUtils.startSpineAnimationCreation('WILD_MULTIPLIER_EFFECT.json', 'EFFECT_01', false)
            .position(animPosition)
            .createAndStart();
        this._currentWinNumberAnimation = this.spineUtils
            .startSpineAnimationCreation('WIN_NUMBERS.json', 'IDLE', true)
            .position(animPosition)
            .createAndStart();
        this.spineUtils.replaceElementInSpineAnimation(this._currentWinNumberAnimation, 'NUMBER', this._currentWinNumbers);
        var zeroNumber = this.currencyFormatter.formatCurrency(fromValue);
        this._currentWinNumbers.showNumber(zeroNumber);
        this._currentWinNumbers.visible = true;
    };
    GameWinPresentationView.prototype.onWinMeterCompleted = function () {
        this.emit(GameWinPresentationView.AFTER_MULTIPLIER_COUNTING_FINISHED);
    };
    Object.defineProperty(GameWinPresentationView.prototype, "winTextContainer", {
        set: function (value) {
            this._winTextContainer = value;
            var winnumberResource = this.getWinnumberResource(this.device.isMobile, false);
            this._winNumber = new WinNumbers_1.WinNumbers(this.resources, winnumberResource);
            this._winNumber.numberAnchor = { x: 0, y: 0.5 };
            this._winNumber.numberKerning = -20;
            this.adjustCurrencyOffset(this._winNumber);
            this._winTextContainer.addChild(this._winNumber);
            this._winNumber.visible = false;
            var biggerWinNumberResource = this.getWinnumberResource(this.device.isMobile, true);
            this._biggerWinNumber = new WinNumbers_1.WinNumbers(this.resources, biggerWinNumberResource);
            this._biggerWinNumber.numberAnchor = { x: 0, y: 0.5 };
            this._biggerWinNumber.numberKerning = -20;
            this.adjustCurrencyOffset(this._biggerWinNumber);
            this._winTextContainer.addChild(this._biggerWinNumber);
            this._biggerWinNumber.visible = false;
            this.setupWinNumbersSettings();
        },
        enumerable: true,
        configurable: true
    });
    GameWinPresentationView.prototype.adjustCurrencyOffset = function (numbers) {
        var currency = this.currencyFormatter.currency;
        if (currency === 'EUR' || currency === 'GBP' || currency === 'MYR' || currency === 'THB'
            || currency === 'JPY' || currency === 'BOB' || currency === 'CAD' || currency === 'CHF'
            || currency === 'CNY' || currency === 'COP' || currency === 'ARS' || currency === 'AUD'
            || currency === 'DKK' || currency === 'GHS' || currency === 'HKD' || currency === 'ILS'
            || currency === 'KES' || currency === 'MMK' || currency === 'MXN' || currency === 'NOK'
            || currency === 'NZD' || currency === 'PEN' || currency === 'PHP' || currency === 'RWF'
            || currency === 'SGD' || currency === 'TWD' || currency === 'ZAR') {
            numbers.currencyOffset = { x: 0, y: 0 };
        }
        else if (currency === 'PKR') {
            numbers.currencyOffset = { x: 0, y: 0 };
        }
        else if (currency === 'PLN' || currency === 'SEK') {
            numbers.currencyOffset = { x: 0, y: 0 };
        }
        else if (currency === 'CZK' || currency === 'HRK' || currency === 'HUF' || currency === 'RUB') {
            numbers.currencyOffset = { x: 0, y: 0 };
        }
        else {
            numbers.currencyOffset = { x: 0, y: 10 };
        }
    };
    GameWinPresentationView.prototype.getCountingTime = function () {
        switch (this._currentLevel) {
            case 2:
                return 800;
            case 3:
                return 2300;
            default:
                return 2000;
        }
    };
    GameWinPresentationView.prototype.onMeterFinished = function () {
    };
    GameWinPresentationView.prototype.hideWinPresentationSymbols = function () {
    };
    GameWinPresentationView.AFTER_MULTIPLIER_COUNTING_FINISHED = 'GameWinPresentationView::AFTER_MULTIPLIER_COUNTING_FINISHED';
    return GameWinPresentationView;
}(WinPresentationView_1.WinPresentationView));
exports.GameWinPresentationView = GameWinPresentationView;


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var AvalancheReel_1 = __webpack_require__(524);
var Symbols_1 = __webpack_require__(38);
var ReelConstants_1 = __webpack_require__(10);
var GameSymbol_1 = __webpack_require__(64);
var Easing_1 = __webpack_require__(16);
var Tween_1 = __webpack_require__(19);
var GameReelConstants_1 = __webpack_require__(34);
var GameReelSymbol_1 = __webpack_require__(262);
var TopReelSymbol_1 = __webpack_require__(263);
var GameAvalancheReel = /** @class */ (function (_super) {
    __extends(GameAvalancheReel, _super);
    function GameAvalancheReel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // is there any symbols hanging in the air to drop down before new symbols will come up
        _this._hasAnythingToDropFillingTheVoid = false;
        return _this;
    }
    GameAvalancheReel.prototype.dropSymbols = function (symbols) {
        var _this = this;
        var index = 0;
        var offset = 0;
        var lastDelay = 0;
        var ifFirst = true;
        this.topVisibleSymbolIndex = this._rowsToShow - symbols.length;
        this.symbolsOnReel = symbols.length;
        for (var i = ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT - 1; i >= ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT - this._rowsToShow; i--) {
            var symbol = this._symbols[i];
            if (index < symbols.length) {
                var symIndex = symbols.length - 1 - index;
                offset += symbols[symIndex].size.height - 1;
                this.setSymbolInPosition(symbols, i, symIndex, offset);
                symbol.visible = true;
                var rowIndex = i - offset;
                var yToPos = this.getYPositionForRow(rowIndex);
                if (index > 2) { /* Is top reels */
                    lastDelay = index * GameReelConstants_1.GameAvalancheConstants.dropInConfig.rowDelayTop + this._reelIndex * GameReelConstants_1.GameAvalancheConstants.dropInConfig.reelDelayTop;
                    lastDelay += GameReelConstants_1.GameAvalancheConstants.dropInConfig.topDelay;
                }
                else {
                    lastDelay = index * GameReelConstants_1.GameAvalancheConstants.dropInConfig.rowDelay + this._reelIndex * GameReelConstants_1.GameAvalancheConstants.dropInConfig.reelDelay;
                }
                var dropNewTween = this.dropNewSymbolToPosition(i, yToPos, lastDelay, GameReelConstants_1.GameAvalancheConstants.DROP_EASING);
                if (ifFirst) {
                    dropNewTween.onComplete(function () {
                        _this.onFirstSymbolDropped();
                    });
                    ifFirst = false;
                }
                if (index === symbols.length - 1) {
                    dropNewTween.onComplete(function () {
                        _this.onLastSymbolDropped();
                    });
                }
                index++;
            }
            else {
                symbol.visible = false;
            }
        }
    };
    GameAvalancheReel.prototype.dropOldSymbolsOut = function () {
        var index = 0;
        var _loop_1 = function (i) {
            var symbol = this_1._symbols[i];
            var delay = index * GameReelConstants_1.GameAvalancheConstants.dropOutConfig.rowDelay + this_1._reelIndex * GameReelConstants_1.GameAvalancheConstants.dropOutConfig.reelDelay;
            var dropOutTween = new Tween_1.Tween(symbol)
                .to({ y: symbol.y + 1024 }, GameReelConstants_1.GameAvalancheConstants.dropOutConfig.dropDuration)
                .delay(delay)
                .easing(Easing_1.Easing.Cubic.In)
                .onUpdate(function () {
                if (symbol.y >= GameReelConstants_1.GameReelConstants.getBottomSymbolSlot().height * GameReelConstants_1.GameReelConstants.ROW_AMOUNT) {
                    symbol.removeIdleAnimation();
                }
            });
            this_1.add(dropOutTween);
            dropOutTween.start();
            index++;
            if (i === ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT - this_1._rowsToShow) {
                dropOutTween.onComplete(this_1.onLastSymbolDroppedOut.bind(this_1));
            }
        };
        var this_1 = this;
        for (var i = ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT - 1; i >= ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT - this._rowsToShow; i--) {
            _loop_1(i);
        }
    };
    GameAvalancheReel.prototype.dropExistingSymbolWithLineCallback = function (symIndex, yPosition, delay, shake, newRowPos, isDroppingFromDivider) {
        var _this = this;
        if (shake) {
            this._symbols[symIndex].container.rotation = (Math.PI / 180) * -4;
        }
        var dropNewTween = new Tween_1.Tween(this._symbols[symIndex])
            .to({ y: yPosition }, GameReelConstants_1.GameAvalancheConstants.dropExistingConfig.dropDuration)
            .onUpdate(function () {
            var symbol = _this._symbols[symIndex];
            if (!symbol.symbolMovedThroughLine && (symbol.y + GameReelConstants_1.GameReelConstants.getBottomSymbolSlot().height / 2) > _this._lineYPosition) {
                _this._movingThroughTheLineCallback && _this._movingThroughTheLineCallback(symbol.symbolType, newRowPos);
                symbol.symbolMovedThroughLine = true;
                _this.tryToAddRespinAttention(symbol);
            }
        })
            .easing(GameReelConstants_1.GameAvalancheConstants.DROP_EASING)
            .delay(delay);
        this.add(dropNewTween);
        dropNewTween.start();
        /* Symbols dropping from under divider (row 3) gets a quick alpha fade to avoid glitchy look */
        if (isDroppingFromDivider && !(this._symbols[symIndex] instanceof TopReelSymbol_1.TopReelSymbol)) {
            this._symbols[symIndex].alpha = 0;
            var alphaTween = new Tween_1.Tween(this._symbols[symIndex])
                .to({ alpha: 1 }, GameReelConstants_1.GameAvalancheConstants.dropExistingConfig.dropDuration * 0.15)
                .easing(Easing_1.Easing.Quadratic.In)
                .delay(delay);
            this.add(alphaTween);
            alphaTween.start();
        }
        if (shake) {
            var symRotTween = new Tween_1.Tween(this._symbols[symIndex].container)
                .to({ rotation: (Math.PI / 180) * 4 }, 150)
                .repeat(GameReelConstants_1.GameAvalancheConstants.dropExistingConfig.dropDuration / 180)
                .yoyo(true)
                .delay(delay)
                .onComplete(function () {
                _this._symbols[symIndex].container.rotation = 0;
            })
                .start();
            this.add(symRotTween);
            symRotTween.start();
        }
        return dropNewTween;
    };
    GameAvalancheReel.prototype.dropElementsToFillVoids = function () {
        var _this = this;
        var offset = 0;
        var isFirstTween = true;
        this._hasAnythingToDropFillingTheVoid = false;
        for (var i = ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT - 1; i >= 0; i--) {
            // 1a. if the symbols is visible (not destroyed)
            if (this._symbols[i].visible) {
                var pos = this._symbols[i].positionOnReel;
                var height = this._symbols[i].size.height;
                // 2a. and it is not on the expected place
                if (pos !== offset + height - 1) {
                    var moveOffset = pos - (offset + height - 1);
                    var rowIndex = this.getPositionOnReel(pos, moveOffset);
                    var newYPos = this.getYPositionForRow(rowIndex);
                    var delay = (ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT - rowIndex - 1) * GameReelConstants_1.GameAvalancheConstants.dropExistingConfig.rowDelay + this._reelIndex * GameReelConstants_1.GameAvalancheConstants.dropExistingConfig.reelDelay;
                    var isDroppingFromDivider = (rowIndex - moveOffset) === 2;
                    // 3a. then we're dropping it down with a tween
                    var tween = this.dropExistingSymbolWithLineCallback(i, newYPos, delay, false, rowIndex, isDroppingFromDivider);
                    this._symbols[i].positionOnReel -= moveOffset;
                    this._symbols[i].setContainerParameters();
                    if (isFirstTween) {
                        isFirstTween = false;
                        this._hasAnythingToDropFillingTheVoid = true;
                        tween.onComplete(function () {
                            _this.cleanAfterFall();
                            _this._onFillingVoidsFinished(_this._reelIndex);
                        });
                    }
                }
                offset += height;
                this.topVisibleSymbolIndex = i;
            }
            else {
                // 1b. if this is a last element on reel and it is invisible it means
                // there is no symbols left on this reel
                // so top visible element has the index of top element + 1
                // so that next falling symbol we receive 1st position on the reel
                if (i === ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT - 1) {
                    this.topVisibleSymbolIndex = ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT;
                }
                return;
            }
        }
    };
    /**
     * adds new symbols after win lines were destroyed or re-spin took place
     * @param symbols - array of new symbols
     * @param onAddingFinishedCallback - callback for when symbols were added
     */
    GameAvalancheReel.prototype.addNewSymbols = function (symbols, onAddingFinishedCallback) {
        var _this = this;
        symbols = symbols.sort(function (s1, s2) { return s2.row - s1.row; });
        this._onAddingSymbolsFinished = onAddingFinishedCallback;
        this.symbolsOnReel += symbols.length;
        var lastTween;
        var lastDelay = 0;
        var isFirst = true;
        var firstSymbolPos;
        var firstSymbolSize;
        if (symbols.length === 0) {
            onAddingFinishedCallback && onAddingFinishedCallback();
        }
        // going through all the symbols
        for (var i = 0; i < symbols.length; i++) {
            var symbol = symbols[i];
            // taking highest visible symbol on reel
            var prevSym = this._symbols[this.topVisibleSymbolIndex];
            var prevElementReelPos = void 0;
            // taking previous symbol's reel position or setting it to -1 so that next position will be 0
            if (prevSym) {
                prevElementReelPos = prevSym.positionOnReel;
            }
            else {
                prevElementReelPos = -1;
            }
            // taking a new symbol from the reel and setting it up
            var currentSym = this._symbols[this.topVisibleSymbolIndex - 1];
            currentSym.visible = true;
            currentSym.positionOnReel = prevElementReelPos + symbol.height;
            currentSym.size = { width: 1, height: symbol.height };
            currentSym.setSymbol(this.makeSizedSymbol(symbol.symbol, currentSym.size));
            currentSym.setContainerParameters();
            var rowIndex = ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT - (prevElementReelPos + 1 + symbol.height);
            // coming up with a new y position for this symbol and delay for dropping tween
            var yToPos = this.getYPositionForRow(rowIndex);
            lastDelay = (ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT - rowIndex - 4) * GameReelConstants_1.GameAvalancheConstants.dropExistingConfig.rowDelay + this._reelIndex * GameReelConstants_1.GameAvalancheConstants.dropExistingConfig.reelDelay;
            // making a tween to drop a symbol onto a reel
            lastTween = this.dropNewSymbolToPosition(this.topVisibleSymbolIndex - 1, yToPos, lastDelay, GameReelConstants_1.GameAvalancheConstants.DROP_EASING, GameReelConstants_1.GameAvalancheConstants.dropExistingConfig.dropDuration);
            this.topVisibleSymbolIndex--;
            if (isFirst) {
                isFirst = false;
                firstSymbolPos = { x: this._reelIndex, y: ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT - (prevElementReelPos + 1) };
                firstSymbolSize = symbol.height;
            }
        }
        if (lastTween) {
            lastTween.onComplete(function () {
                // here is what's happening after symbols fallen down
                _this.cleanAfterFall();
                if (_this._onAddingSymbolsFinished) {
                    _this._onAddingSymbolsFinished();
                    _this._onAddingSymbolsFinished = null;
                }
                if (symbols.length > 0) {
                    // playing dropped sound for the biggest symbol size on the screen
                    _this.playNewSymbolDroppingSound(_this.getBiggestSymbolSizeOf(symbols), lastDelay);
                }
                // playing avalanche landing animation for the first falling symbol
                _this.playAvalancheLandingAnimationAt(firstSymbolPos, firstSymbolSize);
            });
        }
    };
    GameAvalancheReel.prototype.addAllSymbolsIntoSprite = function (spr, resources) {
        Symbols_1.SymbolsCreation.addAllSymbolsIntoSprite(spr, resources);
    };
    GameAvalancheReel.prototype.addBackgroundsIntoSprite = function (spr, resources) {
    };
    GameAvalancheReel.prototype.addForegroundIntoSprite = function (spr, resources) {
    };
    GameAvalancheReel.prototype.addWinIndicationAt = function (position, isRightToLeft) {
        this._symbols[position.y].addWinIndication(isRightToLeft);
    };
    GameAvalancheReel.prototype.removeWinIndicationAt = function (position) {
        this._symbols[position.y].removeWinIndication();
    };
    GameAvalancheReel.prototype.removeAllWinIndications = function () {
        for (var _i = 0, _a = this._symbols; _i < _a.length; _i++) {
            var sym = _a[_i];
            sym.removeWinIndication();
        }
    };
    GameAvalancheReel.prototype.makeSizedSymbol = function (symbol, size) {
        return symbol;
    };
    GameAvalancheReel.prototype.playAvalancheLandingAnimationAt = function (pos, height) {
    };
    GameAvalancheReel.prototype.playRemoveAnimationAt = function (sym, onCompleted) {
        sym.playWinRemoveAnimation(function () {
            sym.visible = false;
            onCompleted && onCompleted();
        });
        var fadeOutTween = new Tween_1.Tween(sym)
            .to({ alpha: 0 }, 200)
            .easing(Easing_1.Easing.Sinusoidal.InOut)
            .delay(50)
            .onComplete(function () {
            sym.hideSymbol();
            sym.alpha = 1;
            sym.makeCleanup();
        });
        this.add(fadeOutTween);
        fadeOutTween.start();
    };
    GameAvalancheReel.prototype.fixSymbolsBeforeNewDrop = function () {
        for (var rowIndex = 0; rowIndex < ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT; rowIndex++) {
            this._symbols[rowIndex].fixTopReelSymbolBeforeNew();
        }
    };
    GameAvalancheReel.prototype.fixSymbolsDuringAvalanches = function () {
        for (var rowIndex = 0; rowIndex < ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT; rowIndex++) {
            this._symbols[rowIndex].fixTopReelSymbol();
        }
    };
    GameAvalancheReel.prototype.createReel = function (initialReel) {
        for (var rowIndex = 0; rowIndex < ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT; rowIndex++) {
            var symbolsSprite = new PIXI.Sprite();
            this.addAllSymbolsIntoSprite(symbolsSprite, this._resources);
            /*	for (const child of symbolsSprite.children) {
                    (child as PIXI.Sprite).anchor.set(0.5);
                }

                const symSize: SymbolSizes = GameReelConstants.getGameSymbolSize({x: 0, y: rowIndex});
                symbolsSprite.position.set(symSize.width / 2, symSize.height / 2);
    */
            var symbolBackground = new PIXI.Sprite();
            this.addBackgroundsIntoSprite(symbolBackground, this._resources);
            var symbolForeground = new PIXI.Sprite();
            this.addForegroundIntoSprite(symbolForeground, this._resources);
            var symbol = this.createReelSymbol();
            symbol.init(symbolsSprite, symbolBackground, symbolForeground);
            symbol.setSpineUtils(this.spineUtils);
            symbol.setTimerUtils(this._timerUtils);
            this.setInitialSymbolAtPosition(symbol, rowIndex, this._initialStrip[rowIndex]);
            symbol.index = rowIndex;
            symbol.x = GameReelConstants_1.GameReelConstants.getReelsOffsetForRow(rowIndex).x + GameReelConstants_1.GameReelConstants.getGameSymbolSize({
                x: this._reelIndex,
                y: 0,
            }).width * this._reelIndex;
            symbol.y = this.getYPositionForRow(rowIndex);
            /*	symbol.pivot.set(GameReelConstants.getGameSymbolSize({x: 0, y: rowIndex}).width / - 2,
                    GameReelConstants.getGameSymbolSize({x: 0, y: rowIndex}).height / -2);*/
            this._symbols[rowIndex] = symbol;
            this._container.addChild(symbol);
        }
        if (initialReel) {
            this.symbolsOnReel = initialReel.length;
        }
        for (var rowIndex = 0; rowIndex < ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT; rowIndex++) {
            this._symbols[rowIndex].positionOnReel = rowIndex;
            this._symbols[rowIndex].size = { width: 1, height: 1 };
        }
        if (initialReel) {
            this.setupInitialReel(initialReel);
        }
        else {
            this.setupInitialReel(GameAvalancheReel.INITIAL_REELS[this._reelIndex]);
        }
        this.fixSymbolsBeforeNewDrop();
    };
    GameAvalancheReel.prototype.setupInitialReel = function (initialReel) {
        var index = 0;
        var reelPosition = 0;
        this.topVisibleSymbolIndex = 0;
        for (var rowIndex = ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT - 1; rowIndex >= 0; rowIndex--) {
            var sym = this._symbols[rowIndex];
            var pos = initialReel[initialReel.length - 1 - index];
            if (index < initialReel.length) {
                sym.size = pos.size;
                sym.setSymbol(this.makeSizedSymbol(pos.sym, pos.size));
                sym.positionOnReel = reelPosition + pos.size.height - 1;
                sym.y = this.getYPositionForRow(rowIndex);
                reelPosition += pos.size.height;
                sym.visible = true;
            }
            else {
                sym.visible = false;
            }
            index++;
        }
    };
    GameAvalancheReel.prototype.filterNullSymbols = function (reelSymbols) {
        return reelSymbols;
    };
    /**
     * counting up y position of a symbol on a reel
     * @param indexOffset - symbol index on reel
     * @param symHeight - symbol height
     */
    GameAvalancheReel.prototype.getInitialSymbolPositionY = function (rowIndex, symHeight) {
        return null;
    };
    GameAvalancheReel.prototype.getYPositionForRow = function (rowIndex) {
        return GameReelConstants_1.GameReelConstants.getReelsOffsetForRow(rowIndex).y + GameReelConstants_1.GameReelConstants.getSpecificRowYSymbolPosition(rowIndex);
    };
    GameAvalancheReel.prototype.dropNewSymbolToPosition = function (symIndex, yPosition, delay, easing, duration) {
        if (easing === void 0) { easing = Easing_1.Easing.Quadratic.In; }
        if (duration === void 0) { duration = GameReelConstants_1.GameAvalancheConstants.dropInConfig.dropDuration; }
        var symbol = this._symbols[symIndex];
        symbol.y =
            yPosition - GameReelConstants_1.GameReelConstants.getTopSymbolSlot().height * ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT - GameReelConstants_1.GameReelConstants.getReelsOffsetForRow(symIndex).y;
        var dropNewTween = new Tween_1.Tween(symbol)
            .to({ y: yPosition }, duration)
            .easing(easing)
            .delay(delay);
        this.add(dropNewTween);
        dropNewTween.start();
        var timeToBounce = GameReelConstants_1.GameAvalancheConstants.dropInConfig.dropDuration + delay - AvalancheReel_1.AvalancheReel.STOP_ANIMATION_TIMER_OFFSET;
        this.tryToAddRespinAttention(symbol, timeToBounce);
        symbol.symbolMovedThroughLine = symIndex >= 3;
        return dropNewTween;
    };
    GameAvalancheReel.prototype.tryToAddRespinAttention = function (symbol, timeToBounce) {
        var _this = this;
        if (symbol.shouldHaveRespinAttentionAnimation()) {
            if (timeToBounce) {
                this._timerUtils.createTimer(function () {
                    symbol.playRespinAttention();
                    _this.sendRespinAttentionTriggeredCallback();
                }, timeToBounce);
            }
            else {
                symbol.playRespinAttention();
                this.sendRespinAttentionTriggeredCallback();
            }
        }
        else if (symbol.shouldHaveWildIdleAnimation()) {
            symbol.addIdleAnimation();
        }
    };
    GameAvalancheReel.prototype.sendRespinAttentionTriggeredCallback = function () {
        this._respinAttentionTriggeredCallback && this._respinAttentionTriggeredCallback();
    };
    GameAvalancheReel.prototype.removeScatterRespinAs = function (symPos) {
        var sym = this._symbols[this.getSymbolOnReelIndex(symPos.y)];
        if (sym.symbolType === Symbols_1.Symbols.RS || sym.symbolType === Symbols_1.Symbols.TOP_RS) {
            sym.removeIdleAnimation();
            sym.removeStopAnimation();
            this.moveSymbolFromOversizedToReelContainer(sym);
            sym.hideSymbol();
            sym.visible = false;
        }
        else {
            throw new Error("removeScatterRespinAs:: Not a scatter at " + symPos);
        }
    };
    GameAvalancheReel.prototype.playRespinAnimationAt = function (symPos, symbol, onCompleted) {
        var sym = this._symbols[this.getSymbolOnReelIndex(symPos.y)];
        sym.visible = false;
        this._timerUtils.createTimer(function () {
            onCompleted && onCompleted();
        }, 200);
    };
    GameAvalancheReel.prototype.removeRespinSymbol = function (positions) {
        var topPosition = this.getSymbolOnReelIndex(0);
        positions = positions.sort(function (s1, s2) { return s1.y - s2.y; });
        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
            var pos = positions_1[_i];
            var sym = this._symbols[topPosition + pos.y];
            this._symbols.splice(topPosition + pos.y, 1);
            this._symbols.unshift(sym);
            this.symbolsOnReel--;
            for (var rowIndex = 0; rowIndex < ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT; rowIndex++) {
                this._symbols[rowIndex].index = rowIndex;
            }
        }
        this.topVisibleSymbolIndex += positions.length;
    };
    /**
     * getting reel symbols array index from y position of symbol
     * @param yPosition - position of symbol
     */
    GameAvalancheReel.prototype.getSymbolOnReelIndex = function (yPosition) {
        return ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT - this.symbolsOnReel + yPosition;
    };
    GameAvalancheReel.prototype.createReelSymbol = function () {
        return new GameReelSymbol_1.GameReelSymbol();
    };
    Object.defineProperty(GameAvalancheReel.prototype, "hasAnythingToDropFillingTheVoid", {
        get: function () {
            return this._hasAnythingToDropFillingTheVoid;
        },
        enumerable: true,
        configurable: true
    });
    /**
     *    Get the symbolType of the symbol on y position.
     * @param yPosition
     */
    GameAvalancheReel.prototype.getSymbolTypeOnReelIndex = function (yPosition) {
        if (this.symbolsOnReel === 0) {
            return -1;
        }
        var index = this.getSymbolOnReelIndex(yPosition);
        if (index < 0 || index >= ReelConstants_1.ReelConstants.ROW_AMOUNT) {
            return -1;
        }
        return this._symbols[this.getSymbolOnReelIndex(yPosition)].symbolType;
    };
    GameAvalancheReel.prototype.getSymbolFromPosition = function (yPosition) {
        if (this.symbolsOnReel === 0) {
            return null;
        }
        var index = this.getSymbolOnReelIndex(yPosition);
        if (index < 0 || index >= ReelConstants_1.ReelConstants.ROW_AMOUNT) {
            return null;
        }
        return this._symbols[this.getSymbolOnReelIndex(yPosition)];
    };
    Object.defineProperty(GameAvalancheReel.prototype, "lineYPosition", {
        set: function (value) {
            this._lineYPosition = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GameAvalancheReel.prototype, "movingThroughTheLineCallback", {
        set: function (value) {
            this._movingThroughTheLineCallback = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GameAvalancheReel.prototype, "respinAttentionTriggeredCallback", {
        set: function (value) {
            this._respinAttentionTriggeredCallback = value;
        },
        enumerable: true,
        configurable: true
    });
    GameAvalancheReel.prototype.moveSymbolFromOversizedToReelContainer = function (symbol) {
        if (symbol.oversizedLayer && symbol.oversizedLayer.children.length > 0) {
            this._container.addChild(symbol.oversizedLayer.children[0]);
        }
    };
    GameAvalancheReel.prototype.moveSymbolsFromOversizedToReelContainer = function () {
        for (var _i = 0, _a = this._symbols; _i < _a.length; _i++) {
            var sym = _a[_i];
            var symbol = sym;
            if (symbol.oversizedLayer && symbol.oversizedLayer.children.length > 0) {
                this._container.addChild(symbol.oversizedLayer.children[0]);
            }
        }
    };
    GameAvalancheReel.prototype.setOversizedLayer = function (oversizedLayer) {
        for (var _i = 0, _a = this._symbols; _i < _a.length; _i++) {
            var sym = _a[_i];
            sym.oversizedLayer = oversizedLayer;
        }
    };
    GameAvalancheReel.INITIAL_REELS = [
        [
            new GameSymbol_1.GameSymbol(Symbols_1.Symbols.TOP_RS, { width: 1, height: 1 }),
            new GameSymbol_1.GameSymbol(Symbols_1.Symbols.BN, { width: 1, height: 1 }),
            new GameSymbol_1.GameSymbol(Symbols_1.Symbols.F7, { width: 1, height: 1 }),
            new GameSymbol_1.GameSymbol(Symbols_1.Symbols.F9, { width: 1, height: 1 }),
            new GameSymbol_1.GameSymbol(Symbols_1.Symbols.F8, { width: 1, height: 1 }),
            new GameSymbol_1.GameSymbol(Symbols_1.Symbols.F7, { width: 1, height: 1 }),
        ],
        [
            new GameSymbol_1.GameSymbol(Symbols_1.Symbols.F9, { width: 1, height: 1 }),
            new GameSymbol_1.GameSymbol(Symbols_1.Symbols.TOP_BN, { width: 1, height: 1 }),
            new GameSymbol_1.GameSymbol(Symbols_1.Symbols.F7, { width: 1, height: 1 }),
            new GameSymbol_1.GameSymbol(Symbols_1.Symbols.F9, { width: 1, height: 1 }),
            new GameSymbol_1.GameSymbol(Symbols_1.Symbols.F8, { width: 1, height: 1 }),
            new GameSymbol_1.GameSymbol(Symbols_1.Symbols.F7, { width: 1, height: 1 }),
        ],
        [
            new GameSymbol_1.GameSymbol(Symbols_1.Symbols.F9, { width: 1, height: 1 }),
            new GameSymbol_1.GameSymbol(Symbols_1.Symbols.F8, { width: 1, height: 1 }),
            new GameSymbol_1.GameSymbol(Symbols_1.Symbols.BN, { width: 1, height: 1 }),
            new GameSymbol_1.GameSymbol(Symbols_1.Symbols.F9, { width: 1, height: 1 }),
            new GameSymbol_1.GameSymbol(Symbols_1.Symbols.F8, { width: 1, height: 1 }),
            new GameSymbol_1.GameSymbol(Symbols_1.Symbols.F7, { width: 1, height: 1 }),
        ],
        [
            new GameSymbol_1.GameSymbol(Symbols_1.Symbols.F9, { width: 1, height: 1 }),
            new GameSymbol_1.GameSymbol(Symbols_1.Symbols.F8, { width: 1, height: 1 }),
            new GameSymbol_1.GameSymbol(Symbols_1.Symbols.F7, { width: 1, height: 1 }),
            new GameSymbol_1.GameSymbol(Symbols_1.Symbols.F9, { width: 1, height: 1 }),
            new GameSymbol_1.GameSymbol(Symbols_1.Symbols.F8, { width: 1, height: 1 }),
            new GameSymbol_1.GameSymbol(Symbols_1.Symbols.F7, { width: 1, height: 1 }),
        ],
        [
            new GameSymbol_1.GameSymbol(Symbols_1.Symbols.F9, { width: 1, height: 1 }),
            new GameSymbol_1.GameSymbol(Symbols_1.Symbols.F8, { width: 1, height: 1 }),
            new GameSymbol_1.GameSymbol(Symbols_1.Symbols.F7, { width: 1, height: 1 }),
            new GameSymbol_1.GameSymbol(Symbols_1.Symbols.F9, { width: 1, height: 1 }),
            new GameSymbol_1.GameSymbol(Symbols_1.Symbols.F8, { width: 1, height: 1 }),
            new GameSymbol_1.GameSymbol(Symbols_1.Symbols.F7, { width: 1, height: 1 }),
        ],
    ];
    return GameAvalancheReel;
}(AvalancheReel_1.AvalancheReel));
exports.GameAvalancheReel = GameAvalancheReel;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ReelSymbol_1 = __webpack_require__(156);
var GameReelConstants_1 = __webpack_require__(34);
var Symbols_1 = __webpack_require__(38);
var GameReelSymbol = /** @class */ (function (_super) {
    __extends(GameReelSymbol, _super);
    function GameReelSymbol() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._symbolMovedThroughLine = false;
        return _this;
    }
    GameReelSymbol.prototype.setupSymbol = function () {
    };
    GameReelSymbol.prototype.setupLayersOrder = function (parentSym, background, foreground, spinningSymbol) {
        this._container = new PIXI.Container();
        this.addChild(this._container);
        this._intenseIdleAnimationContainer = new PIXI.Container();
        this._symbolContainer = new PIXI.Sprite();
        this._container.addChild(this._symbolContainer);
        this._symbolContainer.addChild(this._intenseIdleAnimationContainer);
        if (background) {
            this._symbolContainer.addChild(background);
        }
        this._symbolContainer.addChild(parentSym);
        if (foreground) {
            this._symbolContainer.addChild(foreground);
        }
        if (spinningSymbol) {
            this._symbolContainer.addChild(spinningSymbol);
            this._spinningSymbol = spinningSymbol;
        }
        this._symbol = parentSym;
        this._symbolBackground = background;
        this._symbolForeground = foreground;
    };
    GameReelSymbol.prototype.fixTopReelSymbol = function () {
        this.container.visible = true;
        if (this.positionOnReel >= 3) {
            this.container.visible = false;
        }
    };
    GameReelSymbol.prototype.fixTopReelSymbolBeforeNew = function () {
        this.container.visible = true;
        if (this.positionOnReel >= 3) {
            this.container.visible = false;
        }
    };
    GameReelSymbol.prototype.hasWinIndication = function () {
        return this._symbolForeground.visible && !!this._winIndication;
    };
    GameReelSymbol.prototype.playStopAnimation = function (animationName) {
        this._symbol.visible = false;
        this._stopAnimation = this._spineUtils.startSpineAnimationCreation(this.getIdleSpineName(), animationName, false)
            .container(this._symbolContainer)
            .position(GameReelConstants_1.GameReelConstants.getBottomSymbolSlot().width / 2, GameReelConstants_1.GameReelConstants.getBottomSymbolSlot().height / 2)
            .createAndStart();
    };
    GameReelSymbol.prototype.playRespinAttention = function () {
        this.removeStopAnimation();
        if (this.oversizedLayer) {
            this._symbol.visible = false;
            this.oversizedLayer.addChild(this);
            this._stopAnimation = this._spineUtils.startSpineAnimationCreation('RESPIN.json', 'ATTENTION', false)
                .container(this._symbolContainer)
                .position(GameReelConstants_1.GameReelConstants.getBottomSymbolSlot().width / 2, GameReelConstants_1.GameReelConstants.getBottomSymbolSlot().height / 2)
                .chainIdleAnimation('IDLE')
                .createAndStart();
        }
    };
    GameReelSymbol.prototype.playScatterBonusIdleAnimation = function (scatterIndex) {
        this.removeStopAnimation();
        this.removeIdleAnimation();
        this._symbol.visible = false;
        var index = scatterIndex > 3 ? 3 : scatterIndex;
        this._idleAnimation = this._spineUtils.startSpineAnimationCreation('BONUS_SCATTER.json', "0" + index + "_IDLE", true)
            .container(this._symbolContainer)
            .position(GameReelConstants_1.GameReelConstants.getBottomSymbolSlot().width / 2, GameReelConstants_1.GameReelConstants.getBottomSymbolSlot().height / 2)
            .createAndStart();
    };
    GameReelSymbol.prototype.playScatterBonusLanding = function (scatterIndex, cb) {
        this.removeStopAnimation();
        this._symbol.visible = false;
        var index = scatterIndex > 3 ? 3 : scatterIndex;
        this._stopAnimation = this._spineUtils.startSpineAnimationCreation('BONUS_SCATTER.json', "0" + index + "_LAND", false)
            .container(this._symbolContainer)
            .position(GameReelConstants_1.GameReelConstants.getBottomSymbolSlot().width / 2, GameReelConstants_1.GameReelConstants.getBottomSymbolSlot().height / 2)
            .chainIdleAnimation("0" + index + "_IDLE")
            .onComplete(function () { return cb && cb(); })
            .createAndStart();
    };
    GameReelSymbol.prototype.removeStopAnimation = function () {
        if (this._stopAnimation) {
            this._spineUtils.stopAndDestroyAnimation(this._stopAnimation);
            this._stopAnimation = null;
        }
    };
    GameReelSymbol.prototype.addWinIndication = function (isRightToLeft) {
        this._symbolForeground.visible = true;
        this._symbolBackground.visible = true;
        if (this.symbolType === Symbols_1.Symbols.WR) {
            this.removeIdleAnimation();
            this.addIdleAnimation('IDLE_INTENSE');
        }
        this._winIndication = this._spineUtils.startSpineAnimationCreation('INITIAL_WIN.json', this.getWinIndictionAnimationName(isRightToLeft), false)
            .container(this._symbolForeground)
            .position(GameReelConstants_1.GameReelConstants.getBottomSymbolSlot().width / 2, GameReelConstants_1.GameReelConstants.getBottomSymbolSlot().height / 2)
            .createAndStart();
        var winIndicationBack = this._spineUtils.startSpineAnimationCreation('INITIAL_WIN_COVER.json', 'INITIAL_WIN', false)
            .container(this._symbolBackground)
            .position(GameReelConstants_1.GameReelConstants.getBottomSymbolSlot().width / 2, GameReelConstants_1.GameReelConstants.getBottomSymbolSlot().height / 2)
            .createAndStart();
        if (this.symbolType === Symbols_1.Symbols.TOP_WR || this.symbolType === Symbols_1.Symbols.WR) {
            this._spineUtils.setSkin(this._winIndication.container.skeleton, 'WILD');
            this._spineUtils.setSkin(winIndicationBack.container.skeleton, 'WILD');
        }
        else if (this.symbolType === Symbols_1.Symbols.M1 || this.symbolType === Symbols_1.Symbols.M2 || this.symbolType === Symbols_1.Symbols.M3 || this.symbolType === Symbols_1.Symbols.M4 || this.symbolType === Symbols_1.Symbols.M5) {
            this._spineUtils.setSkin(this._winIndication.container.skeleton, 'HIGH');
            this._spineUtils.setSkin(winIndicationBack.container.skeleton, 'HIGH');
        }
        else {
            this._spineUtils.setSkin(this._winIndication.container.skeleton, 'LOW');
            this._spineUtils.setSkin(winIndicationBack.container.skeleton, 'LOW');
        }
    };
    GameReelSymbol.prototype.playWinRemoveAnimation = function (onComplete) {
        // INITIAL_WIN.json EXIT (on top)
        // INITAL_WIN_COVER EXIT (bottom)
        var _this = this;
        this._symbolBackground.visible = true;
        var winIndicationBack = this._spineUtils.startSpineAnimationCreation('INITIAL_WIN_COVER.json', 'EXIT', false)
            .onComplete(function () {
            _this._symbolBackground.visible = false;
            onComplete && onComplete();
        })
            .container(this._symbolBackground)
            .position(GameReelConstants_1.GameReelConstants.getBottomSymbolSlot().width / 2, GameReelConstants_1.GameReelConstants.getBottomSymbolSlot().height / 2)
            .createAndStart();
        if (this.symbolType === Symbols_1.Symbols.TOP_WR || this.symbolType === Symbols_1.Symbols.WR) {
            this._spineUtils.setSkin(winIndicationBack.container.skeleton, 'WILD');
        }
        else if (this.symbolType === Symbols_1.Symbols.M1 || this.symbolType === Symbols_1.Symbols.M2 || this.symbolType === Symbols_1.Symbols.M3 || this.symbolType === Symbols_1.Symbols.M4 || this.symbolType === Symbols_1.Symbols.M5) {
            this._spineUtils.setSkin(winIndicationBack.container.skeleton, 'HIGH');
        }
        else {
            this._spineUtils.setSkin(winIndicationBack.container.skeleton, 'LOW');
        }
    };
    GameReelSymbol.prototype.getWinIndictionAnimationName = function (isRightToLeft) {
        // MHNOTE: Animations are swapped due to rotation direction.
        return !isRightToLeft ? 'INITIAL_WIN_RIGHT_TO_LEFT' : 'INITIAL_WIN_LEFT_TO_RIGHT';
    };
    GameReelSymbol.prototype.addIdleAnimation = function (animationName) {
        this.removeStopAnimation();
        this._symbol.visible = false;
        this._idleAnimation = this._spineUtils.startSpineAnimationCreation(this.getIdleSpineName(), animationName ? animationName : 'IDLE', true)
            .container(animationName ? this._intenseIdleAnimationContainer : this._symbolContainer)
            .position(GameReelConstants_1.GameReelConstants.getSpecificRowSymbolSlot(this.index).width / 2, GameReelConstants_1.GameReelConstants.getSpecificRowSymbolSlot(this.index).height / 2)
            .createAndStart();
    };
    GameReelSymbol.prototype.removeIdleAnimation = function () {
        this._symbol.visible = true;
        if (this._idleAnimation) {
            this._spineUtils.stopAndDestroyAnimation(this._idleAnimation);
            this._idleAnimation = null;
        }
    };
    GameReelSymbol.prototype.removeWinIndication = function () {
        this._symbolForeground.visible = false;
        if (this._winIndication) {
            this._spineUtils.stopAndDestroyAnimation(this._winIndication);
            this._winIndication = null;
        }
    };
    GameReelSymbol.prototype.getIdleSpineName = function () {
        switch (this.symbolType) {
            case Symbols_1.Symbols.TOP_WR: {
                return 'TOP_WILD.json';
            }
            case Symbols_1.Symbols.TOP_BN: {
                return 'TOP_BONUS.json';
            }
            case Symbols_1.Symbols.TOP_RS: {
                return 'TOP_RESPIN.json';
            }
            case Symbols_1.Symbols.RS: {
                return 'RESPIN.json';
            }
            case Symbols_1.Symbols.WR: {
                return 'WILD.json';
            }
            default:
                break;
        }
    };
    Object.defineProperty(GameReelSymbol.prototype, "symbolMovedThroughLine", {
        get: function () {
            return this._symbolMovedThroughLine;
        },
        set: function (value) {
            this._symbolMovedThroughLine = value;
        },
        enumerable: true,
        configurable: true
    });
    GameReelSymbol.prototype.shouldHaveRespinAttentionAnimation = function () {
        return this.symbolType === Symbols_1.Symbols.RS && this.index >= 3;
    };
    GameReelSymbol.prototype.shouldHaveWildIdleAnimation = function () {
        return this.symbolType === Symbols_1.Symbols.WR && this.index >= 3;
    };
    GameReelSymbol.prototype.shouldHaveScatterLandingAnimation = function () {
        return (this.symbolType === Symbols_1.Symbols.BN || this.symbolType === Symbols_1.Symbols.TOP_BN) && this.index >= 3;
    };
    GameReelSymbol.prototype.shouldHaveSpecialLandingAnimation = function () {
        return this.shouldHaveRespinAttentionAnimation() || this.shouldHaveScatterLandingAnimation();
    };
    GameReelSymbol.prototype.makeCleanup = function () {
        this.removeIdleAnimation();
        this.removeStopAnimation();
        this.removeWinIndication();
    };
    Object.defineProperty(GameReelSymbol.prototype, "oversizedLayer", {
        get: function () {
            return this._oversizedLayer;
        },
        set: function (value) {
            this._oversizedLayer = value;
        },
        enumerable: true,
        configurable: true
    });
    return GameReelSymbol;
}(ReelSymbol_1.ReelSymbol));
exports.GameReelSymbol = GameReelSymbol;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var GameReelSymbol_1 = __webpack_require__(262);
var Symbols_1 = __webpack_require__(38);
var TopReelSymbol = /** @class */ (function (_super) {
    __extends(TopReelSymbol, _super);
    function TopReelSymbol() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TopReelSymbol.prototype.fixTopReelSymbol = function () {
        this._symbolContainer.visible = true;
        this.container.visible = true;
        if (this.positionOnReel >= 3) {
            if (this.symbolType === Symbols_1.Symbols.BN) {
                this.setSymbol(Symbols_1.Symbols.TOP_BN);
            }
            else if (this.symbolType === Symbols_1.Symbols.WR) {
                this.setSymbol(Symbols_1.Symbols.TOP_WR);
            }
            else if (this.symbolType === Symbols_1.Symbols.RS) {
                this.setSymbol(Symbols_1.Symbols.TOP_RS);
            }
            else {
                if (this.symbolType !== Symbols_1.Symbols.TOP_BN
                    && this.symbolType !== Symbols_1.Symbols.TOP_WR
                    && this.symbolType !== Symbols_1.Symbols.TOP_RS) {
                    this._symbolContainer.visible = false;
                }
            }
        }
    };
    TopReelSymbol.prototype.shouldHaveScatterLandingAnimation = function () {
        return false;
    };
    TopReelSymbol.prototype.fixTopReelSymbolBeforeNew = function () {
        this._symbolContainer.visible = true;
        this.container.visible = true;
        if (this.positionOnReel < 3) {
            this.removeIdleAnimation();
            this.container.visible = false;
        }
        else {
            if (this.symbolType === Symbols_1.Symbols.BN) {
                this.setSymbol(Symbols_1.Symbols.TOP_BN);
                this.addIdleAnimation();
            }
            else if (this.symbolType === Symbols_1.Symbols.WR) {
                this.setSymbol(Symbols_1.Symbols.TOP_WR);
                this.addIdleAnimation();
            }
            else if (this.symbolType === Symbols_1.Symbols.RS) {
                this.setSymbol(Symbols_1.Symbols.TOP_RS);
                this.addIdleAnimation();
            }
            else {
                if (this.symbolType !== Symbols_1.Symbols.TOP_BN
                    && this.symbolType !== Symbols_1.Symbols.TOP_WR
                    && this.symbolType !== Symbols_1.Symbols.TOP_RS) {
                    this.removeIdleAnimation();
                    this._symbolContainer.visible = false;
                }
            }
        }
    };
    return TopReelSymbol;
}(GameReelSymbol_1.GameReelSymbol));
exports.TopReelSymbol = TopReelSymbol;


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var AvalancheReelsModule_1 = __webpack_require__(23);
var GameAvalancheReelsDropNewState_1 = __webpack_require__(271);
var GameAvalancheRemoveWinsState_1 = __webpack_require__(272);
var GameAvalancheAddSymbolsState_1 = __webpack_require__(273);
var GameAvalancheRespinState_1 = __webpack_require__(274);
var RespinEvents_1 = __webpack_require__(92);
var GameAvalancheReelsView_1 = __webpack_require__(157);
var GameAvalancheReelsEvents_1 = __webpack_require__(39);
var GameFlowEvents_1 = __webpack_require__(57);
var WildMeterEvents_1 = __webpack_require__(66);
var FreeSpinsEvents_1 = __webpack_require__(6);
var GameAvalancheReelsInitState_1 = __webpack_require__(527);
var FreeSpinsTriggerModule_1 = __webpack_require__(76);
var GameReelsStats_1 = __webpack_require__(276);
var GameReelConstants_1 = __webpack_require__(34);
var GameBackgroundModule_1 = __webpack_require__(93);
var GameAvalancheReelsModule = /** @class */ (function (_super) {
    __extends(GameAvalancheReelsModule, _super);
    function GameAvalancheReelsModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameAvalancheReelsModule.prototype.restore = function () {
        this.view.createReelSet(this.logic.getRecodeSpinResults().reels);
        this.view.updateIdleAnimationOnRestore();
    };
    GameAvalancheReelsModule.prototype.afterInit = function () {
        _super.prototype.afterInit.call(this);
        if (window._certificationSettings && window._certificationSettings.hasOwnProperty('spinDelay')) {
            GameReelsStats_1.GameReelsStats.IS_ON_REGULATED_MARKET = true;
            GameReelsStats_1.GameReelsStats.MINIMUM_TIME_TO_FINISH_DROP = (GameReelConstants_1.GameReelConstants.ROW_AMOUNT - 1) * GameReelConstants_1.GameAvalancheConstants.TIMER_BETWEEN_SYMBOLS_NEW
                + (GameReelConstants_1.GameReelConstants.REELS_AMOUNT - 1) * GameReelConstants_1.GameAvalancheConstants.TIMER_BETWEEN_REELS_NEW
                + GameReelConstants_1.GameAvalancheConstants.AVALANCHE_NEW_TIMER;
            GameReelsStats_1.GameReelsStats.EXPECTED_TIME_ON_REGULATED_MARKET = window._certificationSettings.spinDelay;
        }
        GameReelConstants_1.GameAvalancheConstants.initDropConfigs(GameReelsStats_1.GameReelsStats.IS_ON_REGULATED_MARKET);
    };
    GameAvalancheReelsModule.prototype.setupDefaultReelset = function () {
    };
    GameAvalancheReelsModule.prototype.setupStates = function () {
        _super.prototype.setupStates.call(this);
        this.addState(new GameAvalancheReelsDropNewState_1.GameAvalancheReelsDropNewState(this, AvalancheReelsModule_1.AvalancheReelsModule.DROPNEW_STATE));
        this.addState(new GameAvalancheRemoveWinsState_1.GameAvalancheRemoveWinsState(this, AvalancheReelsModule_1.AvalancheReelsModule.REMOVE_WINS_STATE));
        this.addState(new GameAvalancheAddSymbolsState_1.GameAvalancheAddSymbolsState(this, AvalancheReelsModule_1.AvalancheReelsModule.ADD_SYMBOLS_STATE));
        this.addState(new GameAvalancheRespinState_1.GameAvalancheRespinState(this, AvalancheReelsModule_1.AvalancheReelsModule.RESPIN_STATE));
        this.addState(new GameAvalancheReelsInitState_1.GameAvalancheReelsInitState(this, AvalancheReelsModule_1.AvalancheReelsModule.INIT_STATE));
    };
    GameAvalancheReelsModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.onCurrentStateHandle(RespinEvents_1.RespinEvents.LEAVING_SCATTER_AT);
        this.onCurrentStateHandle(RespinEvents_1.RespinEvents.LEAVING_SYMBOL_AT);
        this.onCurrentStateHandle(RespinEvents_1.RespinEvents.RESPIN_REMOVING_FINISHED);
        this.onCurrentStateHandle(WildMeterEvents_1.WildMeterEvents.WIN_METER_WILDS_ANIMATIONS_FINISHED);
        this.onViewEmitEvent(GameAvalancheReelsView_1.GameAvalancheReelsView.INITIAL_WIN_INDICATION_FINISHED, GameAvalancheReelsEvents_1.GameAvalancheReelsEvents.WIN_HIGHLIGHTING_FINISHED);
        this.onViewEmitEvent(GameAvalancheReelsView_1.GameAvalancheReelsView.INITIAL_WIN_INDICATION_STARTED, GameAvalancheReelsEvents_1.GameAvalancheReelsEvents.WIN_HIGHLIGHTING_STARTED);
        this.onViewEmitEvent(GameAvalancheReelsView_1.GameAvalancheReelsView.INITIAL_WIN_INDICATION_WINLINE, GameAvalancheReelsEvents_1.GameAvalancheReelsEvents.WIN_HIGHLIGHTING_WINLINE);
        this.onViewEmitEvent(GameAvalancheReelsView_1.GameAvalancheReelsView.SYMBOL_PASSED_THROUGHT_LINE, GameAvalancheReelsEvents_1.GameAvalancheReelsEvents.SYMBOL_PASSED_THROUGHT_LINE);
        this.onViewEmitEvent(GameAvalancheReelsView_1.GameAvalancheReelsView.SCATTER_ATTENTION_TRIGGERED, GameAvalancheReelsEvents_1.GameAvalancheReelsEvents.SCATTER_ATTENTION_TRIGGERED);
        this.onViewEmitEvent(GameAvalancheReelsView_1.GameAvalancheReelsView.RESPIN_ATTENTION_TRIGGERED, GameAvalancheReelsEvents_1.GameAvalancheReelsEvents.RESPIN_ATTENTION_TRIGGERED);
        this.onViewEmitEvent(GameAvalancheReelsView_1.GameAvalancheReelsView.FILLING_VOIDS_STARTED, GameAvalancheReelsEvents_1.GameAvalancheReelsEvents.FILLING_VOIDS_STARTED);
        this.on(GameFlowEvents_1.GameFlowEvents.HAS_WIN_SYMBOLS_TO_HIGHLIGHT, this.onHasSymbolToHighlight);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_OUTRO_CONTINUE_CLICKED, this.onFreeSpinsOutroContinueClicked);
        this.on(FreeSpinsTriggerModule_1.FreeSpinsTriggerModule.LEAVING_BONUS_AT, this.onLeavingBonusAt);
        this.on(FreeSpinsTriggerModule_1.FreeSpinsTriggerModule.BONUS_TRIGGER_ANIMATION_FINISHED_AT, this.onBonusTriggerAnimationFinishedAt);
        this.on(GameBackgroundModule_1.GameBackgroundModule.TRANSITION_ANIMATION_STARTED, this.onTransitionAnimationStarted);
    };
    GameAvalancheReelsModule.prototype.onSpinButtonPressed = function () {
        _super.prototype.onSpinButtonPressed.call(this);
        this._spinPressedTimestamp = new Date().getTime();
    };
    GameAvalancheReelsModule.prototype.onSpinResponseReceived = function () {
        _super.prototype.onSpinResponseReceived.call(this);
        GameReelsStats_1.GameReelsStats.TIME_SINCE_SPIN_PRESSED = new Date().getTime() - this._spinPressedTimestamp;
    };
    GameAvalancheReelsModule.prototype.onHasSymbolToHighlight = function () {
        var logic = this.logic;
        var winLines = logic.getAllWinLinesFromCurrentRound();
        this.view.addWinIndicationToSymbols(winLines);
    };
    GameAvalancheReelsModule.prototype.onFreeSpinsOutroContinueClicked = function () {
        this.view.createReelSet(this.logic.freeSpinsTriggerSymbols);
    };
    GameAvalancheReelsModule.prototype.onLeavingBonusAt = function (eventID, symPos) {
        this.view.removeIdleAnimationAt(symPos);
    };
    GameAvalancheReelsModule.prototype.onBonusTriggerAnimationFinishedAt = function (eventID, symPos) {
        this.view.startBonusIdleAnimationAt(symPos);
    };
    GameAvalancheReelsModule.prototype.onStartScreenIntroStarted = function () {
        this.view.setReelsContainerAlphaToZero();
    };
    GameAvalancheReelsModule.prototype.onTransitionAnimationStarted = function () {
        this.view.playReelContainerTransition();
    };
    GameAvalancheReelsModule.prototype.onStartScreenIntroFinished = function () {
    };
    return GameAvalancheReelsModule;
}(AvalancheReelsModule_1.AvalancheReelsModule));
exports.GameAvalancheReelsModule = GameAvalancheReelsModule;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var AvalancheReelsModule_1 = __webpack_require__(23);
var LogicEvents_1 = __webpack_require__(11);
var AvalancheReelsInitState = /** @class */ (function (_super) {
    __extends(AvalancheReelsInitState, _super);
    function AvalancheReelsInitState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AvalancheReelsInitState.prototype.onEnterState = function () {
    };
    AvalancheReelsInitState.prototype.onLeaveState = function () {
    };
    AvalancheReelsInitState.prototype.setupEvents = function () {
        this.on(LogicEvents_1.LogicEvents.INIT_RESPONSE, this.onInitResponse);
    };
    AvalancheReelsInitState.prototype.onInitResponse = function () {
        this.module.gotoState(AvalancheReelsModule_1.AvalancheReelsModule.BASIC_STATE);
    };
    return AvalancheReelsInitState;
}(ModuleState_1.ModuleState));
exports.AvalancheReelsInitState = AvalancheReelsInitState;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var AvalancheReelsView_1 = __webpack_require__(75);
var AvalancheReelsModule_1 = __webpack_require__(23);
var ReelsEvents_1 = __webpack_require__(4);
/**
 * here we're dropping old symbols at the beginning of new spin
 */
var AvalancheReelsDropOutState = /** @class */ (function (_super) {
    __extends(AvalancheReelsDropOutState, _super);
    function AvalancheReelsDropOutState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AvalancheReelsDropOutState.prototype.onEnterState = function () {
        this.emit(ReelsEvents_1.ReelsEvents.REELS_SPINNING_STARTED);
        this.view.showAllSymbols();
        this.view.dropOut();
    };
    AvalancheReelsDropOutState.prototype.onLeaveState = function () {
    };
    AvalancheReelsDropOutState.prototype.setupEvents = function () {
        this.on(AvalancheReelsView_1.AvalancheReelsView.ALL_REELS_DROPPED_OUT, this.onAllReelsDroppedOut);
    };
    AvalancheReelsDropOutState.prototype.onAllReelsDroppedOut = function () {
        this.module.gotoState(AvalancheReelsModule_1.AvalancheReelsModule.DROPNEW_STATE);
    };
    return AvalancheReelsDropOutState;
}(ModuleState_1.ModuleState));
exports.AvalancheReelsDropOutState = AvalancheReelsDropOutState;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var AvalancheReelsView_1 = __webpack_require__(75);
var AvalancheReelsModule_1 = __webpack_require__(23);
var ReelsEvents_1 = __webpack_require__(4);
var LogicEvents_1 = __webpack_require__(11);
/**
 * here we're dropping new bunch of symbols at the beginning of spin after the old ones are gone
 */
var AvalancheReelsDropNewState = /** @class */ (function (_super) {
    __extends(AvalancheReelsDropNewState, _super);
    function AvalancheReelsDropNewState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AvalancheReelsDropNewState.prototype.onEnterState = function () {
        if (this.module.isSpinResponseReceived) {
            this.dropNewSymbols();
        }
    };
    AvalancheReelsDropNewState.prototype.onLeaveState = function () {
    };
    AvalancheReelsDropNewState.prototype.dropNewSymbols = function () {
        throw new Error('AvalancheReelsDropNewState::dropNewSymbols must be overridden');
    };
    AvalancheReelsDropNewState.prototype.setupEvents = function () {
        this.on(AvalancheReelsView_1.AvalancheReelsView.ALL_REELS_DROPPED_NEW, this.onAllReelsDroppedNew);
        this.on(LogicEvents_1.LogicEvents.SPIN_RESPONSE, this.onSpinResponse);
    };
    AvalancheReelsDropNewState.prototype.onAllReelsDroppedNew = function () {
        this.module.gotoState(AvalancheReelsModule_1.AvalancheReelsModule.BASIC_STATE);
        this.emit(ReelsEvents_1.ReelsEvents.SPIN_ENDED);
    };
    AvalancheReelsDropNewState.prototype.onSpinResponse = function () {
        this.dropNewSymbols();
    };
    return AvalancheReelsDropNewState;
}(ModuleState_1.ModuleState));
exports.AvalancheReelsDropNewState = AvalancheReelsDropNewState;


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var AvalancheReelsModule_1 = __webpack_require__(23);
var LogicEvents_1 = __webpack_require__(11);
var AvalancheReelsEvents_1 = __webpack_require__(15);
/**
 * in this state we're moving all the symbols which stuck in the air to the floor and then
 * throwing new symbols on top
 */
var AvalancheAddSymbolsState = /** @class */ (function (_super) {
    __extends(AvalancheAddSymbolsState, _super);
    function AvalancheAddSymbolsState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._isWaitingForAvalancheResponse = false;
        return _this;
    }
    AvalancheAddSymbolsState.prototype.onEnterState = function () {
        this.view.fillVoidAfterRemoval();
    };
    AvalancheAddSymbolsState.prototype.onLeaveState = function () {
    };
    AvalancheAddSymbolsState.prototype.setupEvents = function () {
        this.on(LogicEvents_1.LogicEvents.AVALANCHE_RESPONSE, this.onAvalancheResponse);
        this.on(AvalancheReelsEvents_1.AvalancheReelsEvents.FILLING_VOIDS_FINISHED, this.onFillingVoidFinished);
        this.on(AvalancheReelsEvents_1.AvalancheReelsEvents.ADDING_NEW_FINISHED, this.onAddingNewFinished);
    };
    AvalancheAddSymbolsState.prototype.onAvalancheResponse = function () {
        if (this._isWaitingForAvalancheResponse) {
            this._isWaitingForAvalancheResponse = false;
            this.onFillingVoidFinished();
        }
    };
    AvalancheAddSymbolsState.prototype.onFillingVoidFinished = function () {
        if (this.module.isAvalancheResponseReceived) {
            this.startAddingNewSymbols();
        }
        else {
            this._isWaitingForAvalancheResponse = true;
        }
    };
    AvalancheAddSymbolsState.prototype.onAddingNewFinished = function () {
        this.module.gotoState(AvalancheReelsModule_1.AvalancheReelsModule.BASIC_STATE);
        this.emit(AvalancheReelsEvents_1.AvalancheReelsEvents.AVALANCHE_FINISHED);
    };
    AvalancheAddSymbolsState.prototype.startAddingNewSymbols = function () {
        throw new Error('AvalancheAddSymbolsState::startAddingNewSymbols must be overridden');
    };
    return AvalancheAddSymbolsState;
}(ModuleState_1.ModuleState));
exports.AvalancheAddSymbolsState = AvalancheAddSymbolsState;


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var LogicEvents_1 = __webpack_require__(11);
var AvalancheReelsEvents_1 = __webpack_require__(15);
/**
 * here we're re-spinning (whatever this means in terms of the game)
 */
var AvalancheRespinState = /** @class */ (function (_super) {
    __extends(AvalancheRespinState, _super);
    function AvalancheRespinState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._isWaitingForRespin = false;
        return _this;
    }
    AvalancheRespinState.prototype.onEnterState = function () {
    };
    AvalancheRespinState.prototype.onLeaveState = function () {
    };
    AvalancheRespinState.prototype.setupEvents = function () {
        this.on(LogicEvents_1.LogicEvents.RESPIN_RESPONSE, this.onRespinResponse);
        this.on(AvalancheReelsEvents_1.AvalancheReelsEvents.FILLING_VOIDS_FINISHED, this.onFillingVoidFinished);
    };
    AvalancheRespinState.prototype.onRespinResponse = function () {
        if (this._isWaitingForRespin) {
            this._isWaitingForRespin = false;
            this.startAddingNewSymbols();
        }
    };
    AvalancheRespinState.prototype.onFillingVoidFinished = function () {
        if (this.module.isRespinResponseReceived) {
            this.startAddingNewSymbols();
        }
        else {
            this._isWaitingForRespin = true;
        }
    };
    AvalancheRespinState.prototype.startAddingNewSymbols = function () {
        throw new Error('AvalancheRespinState::startAddingNewSymbols must be overridden');
    };
    return AvalancheRespinState;
}(ModuleState_1.ModuleState));
exports.AvalancheRespinState = AvalancheRespinState;


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var AvalancheReelsModule_1 = __webpack_require__(23);
var AvalancheReelsEvents_1 = __webpack_require__(15);
var WinPresentationEvents_1 = __webpack_require__(13);
var FlowModuleEvents_1 = __webpack_require__(0);
/**
 * here we're removing winning symbols
 */
var AvalancheRemoveWinsState = /** @class */ (function (_super) {
    __extends(AvalancheRemoveWinsState, _super);
    function AvalancheRemoveWinsState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AvalancheRemoveWinsState.prototype.onEnterState = function () {
    };
    AvalancheRemoveWinsState.prototype.onLeaveState = function () {
    };
    AvalancheRemoveWinsState.prototype.setupEvents = function () {
        this.on(AvalancheReelsEvents_1.AvalancheReelsEvents.REMOVING_WIN_FINISHED, this.onRemovingFinished);
        this.on(WinPresentationEvents_1.WinPresentationEvents.COUNTUP_FINISHED, this.onInitialWinCountupFinished);
        this.on(FlowModuleEvents_1.FlowModuleEvents.NO_WIN, this.onNoWin);
    };
    AvalancheRemoveWinsState.prototype.onInitialWinCountupFinished = function () {
        this.startSymbolsRemoving();
        this.emit(AvalancheReelsEvents_1.AvalancheReelsEvents.REMOVING_AVALANCE_SYMBOLS_STARTED);
    };
    AvalancheRemoveWinsState.prototype.onNoWin = function () {
        this.onInitialWinCountupFinished();
    };
    AvalancheRemoveWinsState.prototype.startSymbolsRemoving = function () {
        throw new Error('AvalancheRemoveWinsState::startSymbolsRemoving must be overridden');
    };
    AvalancheRemoveWinsState.prototype.onRemovingFinished = function () {
        this.module.gotoState(AvalancheReelsModule_1.AvalancheReelsModule.ADD_SYMBOLS_STATE);
    };
    AvalancheRemoveWinsState.prototype.finishRemoving = function () {
        this.module.gotoState(AvalancheReelsModule_1.AvalancheReelsModule.ADD_SYMBOLS_STATE);
    };
    return AvalancheRemoveWinsState;
}(ModuleState_1.ModuleState));
exports.AvalancheRemoveWinsState = AvalancheRemoveWinsState;


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var AvalancheReelsDropNewState_1 = __webpack_require__(267);
var ReelConstants_1 = __webpack_require__(10);
var AvalancheReelsEvents_1 = __webpack_require__(15);
var AvalancheReelsModule_1 = __webpack_require__(23);
var GameAvalancheReelsDropNewState = /** @class */ (function (_super) {
    __extends(GameAvalancheReelsDropNewState, _super);
    function GameAvalancheReelsDropNewState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameAvalancheReelsDropNewState.prototype.dropNewSymbols = function () {
        this.view.dropNew(this.module.logic.getSpinResult().reels, ReelConstants_1.ReelConstants.ROW_AMOUNT);
        this.emit(AvalancheReelsEvents_1.AvalancheReelsEvents.ALL_REELS_DROP_NEW_STARTED);
    };
    GameAvalancheReelsDropNewState.prototype.onAllReelsDroppedNew = function () {
        this.module.gotoState(AvalancheReelsModule_1.AvalancheReelsModule.BASIC_STATE);
    };
    return GameAvalancheReelsDropNewState;
}(AvalancheReelsDropNewState_1.AvalancheReelsDropNewState));
exports.GameAvalancheReelsDropNewState = GameAvalancheReelsDropNewState;


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var AvalancheRemoveWinsState_1 = __webpack_require__(270);
var GameAvalancheReelEvents_1 = __webpack_require__(526);
var GameAvalancheReelsEvents_1 = __webpack_require__(39);
var AvalancheReelsModule_1 = __webpack_require__(23);
var WildMeterEvents_1 = __webpack_require__(66);
var GameAvalancheRemoveWinsState = /** @class */ (function (_super) {
    __extends(GameAvalancheRemoveWinsState, _super);
    function GameAvalancheRemoveWinsState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameAvalancheRemoveWinsState.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(WildMeterEvents_1.WildMeterEvents.WIN_METER_WILDS_ANIMATIONS_FINISHED, this.onWinMeterWildsAnimationFinished);
    };
    GameAvalancheRemoveWinsState.prototype.onEnterState = function () {
        this.emit(GameAvalancheReelEvents_1.GameAvalancheReelEvents.REMOVING_STARTED);
        this.startSymbolsRemoving();
    };
    GameAvalancheRemoveWinsState.prototype.onWinMeterWildsAnimationFinished = function () {
        this.module.gotoState(AvalancheReelsModule_1.AvalancheReelsModule.ADD_SYMBOLS_STATE);
    };
    GameAvalancheRemoveWinsState.prototype.startSymbolsRemoving = function () {
        var _this = this;
        var delay = GameAvalancheRemoveWinsState.BEFORE_REMOVE_TIMEOUT;
        this.module.timeUtils.createTimer(function () {
            var gameLogic = _this.module.logic;
            _this.view.removeSymbolsOnAvalancheWithSound(gameLogic.getSpinResult().symbolsToRemove, gameLogic.getSpinWin(), gameLogic.getTotalBet());
            _this.emit(GameAvalancheReelsEvents_1.GameAvalancheReelsEvents.WIN_SYMBOLS_EXPLOSION_STARTED, gameLogic.getSpinResult().symbolsToRemove);
        }, delay);
    };
    GameAvalancheRemoveWinsState.prototype.onRemovingFinished = function () {
        var logic = this.module.logic;
        var wildWinPositions = logic.getCurrentRoundWinningWilds();
        if (wildWinPositions.length <= 0) {
            _super.prototype.onRemovingFinished.call(this);
        }
    };
    GameAvalancheRemoveWinsState.prototype.finishRemoving = function () {
        var logic = this.module.logic;
        var wildWinPositions = logic.getCurrentRoundWinningWilds();
        if (wildWinPositions.length <= 0) {
            _super.prototype.finishRemoving.call(this);
        }
    };
    GameAvalancheRemoveWinsState.BEFORE_REMOVE_TIMEOUT = 75;
    return GameAvalancheRemoveWinsState;
}(AvalancheRemoveWinsState_1.AvalancheRemoveWinsState));
exports.GameAvalancheRemoveWinsState = GameAvalancheRemoveWinsState;


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var AvalancheAddSymbolsState_1 = __webpack_require__(268);
var AvalancheReelsModule_1 = __webpack_require__(23);
var AvalancheReelsEvents_1 = __webpack_require__(15);
var GameAvalancheAddSymbolsState = /** @class */ (function (_super) {
    __extends(GameAvalancheAddSymbolsState, _super);
    function GameAvalancheAddSymbolsState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameAvalancheAddSymbolsState.prototype.startAddingNewSymbols = function () {
        var logic = this.module.logic;
        this.view.startAddingNewSymbolsWithExpectedWin(logic.getSpinResult().reels, logic.getSpinResult().symbolsToAdd, logic.getSpinResult().winLines);
    };
    GameAvalancheAddSymbolsState.prototype.onFillingVoidFinished = function () {
        this.startAddingNewSymbols();
    };
    GameAvalancheAddSymbolsState.prototype.onAvalancheResponse = function () {
    };
    GameAvalancheAddSymbolsState.prototype.onAddingNewFinished = function () {
        var logic = this.module.logic;
        logic.startNextRound();
        this.module.gotoState(AvalancheReelsModule_1.AvalancheReelsModule.BASIC_STATE);
        this.emitDelayed(AvalancheReelsEvents_1.AvalancheReelsEvents.AVALANCHE_FINISHED);
    };
    return GameAvalancheAddSymbolsState;
}(AvalancheAddSymbolsState_1.AvalancheAddSymbolsState));
exports.GameAvalancheAddSymbolsState = GameAvalancheAddSymbolsState;


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var AvalancheRespinState_1 = __webpack_require__(269);
var AvalancheReelsEvents_1 = __webpack_require__(15);
var AvalancheReelsModule_1 = __webpack_require__(23);
var ReelsEvents_1 = __webpack_require__(4);
var AvalancheReelsView_1 = __webpack_require__(75);
var RespinEvents_1 = __webpack_require__(92);
var GameAvalancheRespinState = /** @class */ (function (_super) {
    __extends(GameAvalancheRespinState, _super);
    function GameAvalancheRespinState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameAvalancheRespinState.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(AvalancheReelsView_1.AvalancheReelsView.RESPIN_REMOVING_SYMBOLS_FINISHED, this.onRespinSymbolsRemovalFinished);
        this.on(RespinEvents_1.RespinEvents.LEAVING_SCATTER_AT, this.onLeavingScatterAt);
        this.on(RespinEvents_1.RespinEvents.LEAVING_SYMBOL_AT, this.onLeavingSymbolAt);
        this.on(RespinEvents_1.RespinEvents.RESPIN_REMOVING_FINISHED, this.onRespinFinished);
        this.on(AvalancheReelsEvents_1.AvalancheReelsEvents.ADDING_NEW_FINISHED, this.onAddingNewFinished);
    };
    GameAvalancheRespinState.prototype.onLeavingScatterAt = function (eventID, symPos) {
        this.view.removeScatterAt(symPos);
    };
    GameAvalancheRespinState.prototype.onLeavingSymbolAt = function (eventID, symPos) {
        this.view.removeRespinSymbol(symPos, null, null);
    };
    GameAvalancheRespinState.prototype.onRespinFinished = function () {
        var _this = this;
        this.module.timeUtils.createTimer(function () {
            var respinScatters = _this.module.logic.getSpinResult().respinScatters;
            var removePositions = [];
            for (var _i = 0, respinScatters_1 = respinScatters; _i < respinScatters_1.length; _i++) {
                var scatterInfo = respinScatters_1[_i];
                removePositions.push(scatterInfo.respinScatterPosition);
                removePositions.push.apply(removePositions, scatterInfo.respinSymbols);
            }
            _this.view.removeRespinSymbolsFromReels(removePositions);
            _this.view.fillVoidAfterRemoval();
            _this.emit(AvalancheReelsEvents_1.AvalancheReelsEvents.SYMBOLS_RESPIN_STARTED);
        }, 300);
    };
    GameAvalancheRespinState.prototype.startAddingNewSymbols = function () {
        var logic = this.module.logic;
        this.view.startAddingNewSymbolsWithExpectedWin(logic.getSpinResult().reels, logic.getSpinResult().symbolsToAdd, logic.getSpinResult().winLines);
    };
    GameAvalancheRespinState.prototype.onRespinSymbolsRemovalFinished = function () {
        this.emit(ReelsEvents_1.ReelsEvents.REELS_RESPIN_STARTED);
    };
    GameAvalancheRespinState.prototype.onAddingNewFinished = function () {
        var logic = this.module.logic;
        logic.startNextRound();
        this.module.gotoState(AvalancheReelsModule_1.AvalancheReelsModule.BASIC_STATE);
        this.emitDelayed(AvalancheReelsEvents_1.AvalancheReelsEvents.SYMBOLS_RESPIN_FINISHED);
    };
    return GameAvalancheRespinState;
}(AvalancheRespinState_1.AvalancheRespinState));
exports.GameAvalancheRespinState = GameAvalancheRespinState;


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var View_1 = __webpack_require__(3);
var GameReelConstants_1 = __webpack_require__(34);
var FreeSpinsTriggerView = /** @class */ (function (_super) {
    __extends(FreeSpinsTriggerView, _super);
    function FreeSpinsTriggerView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FreeSpinsTriggerView.prototype.playTriggerAnimationAt = function (symbolPos) {
        var _this = this;
        var startPos = GameReelConstants_1.GameReelConstants.getGameSymbolCenterPosition(symbolPos);
        var triggerAnim = this.spineUtils.startSpineAnimationCreation('BONUS_SCATTER.json', 'TRIGGER_BONUS', false)
            .container(this.container)
            .onComplete(function () {
            _this.playExitAnimationAt(startPos, symbolPos);
            _this.spineUtils.stopAndDestroyAnimation(triggerAnim);
        })
            .position(startPos)
            .createAndStart();
    };
    FreeSpinsTriggerView.prototype.playExitAnimationAt = function (startPos, symbolPos) {
        var _this = this;
        var exitrAnim = this.spineUtils.startSpineAnimationCreation('BONUS_SCATTER.json', 'EXIT', false)
            .container(this.container)
            .onComplete(function () {
            _this.emit(FreeSpinsTriggerView.ANIMATION_FINISHED_AT, symbolPos);
            _this.spineUtils.stopAndDestroyAnimation(exitrAnim);
        })
            .position(startPos)
            .createAndStart();
    };
    FreeSpinsTriggerView.ANIMATION_FINISHED_AT = 'ANIMATION_FINISHED_AT';
    return FreeSpinsTriggerView;
}(View_1.View));
exports.FreeSpinsTriggerView = FreeSpinsTriggerView;


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var GameReelsStats = /** @class */ (function () {
    function GameReelsStats() {
    }
    GameReelsStats.TIME_SINCE_SPIN_PRESSED = 0;
    GameReelsStats.MINIMUM_TIME_TO_FINISH_DROP = 0;
    GameReelsStats.EXPECTED_TIME_ON_REGULATED_MARKET = 0;
    GameReelsStats.IS_ON_REGULATED_MARKET = false;
    return GameReelsStats;
}());
exports.GameReelsStats = GameReelsStats;


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BackgroundView_1 = __webpack_require__(91);
var Module_1 = __webpack_require__(2);
var Views_1 = __webpack_require__(8);
var BackgroundBasicState_1 = __webpack_require__(528);
var BackgroundDebuggingComponent_1 = __webpack_require__(529);
var BackgroundModule = /** @class */ (function (_super) {
    __extends(BackgroundModule, _super);
    function BackgroundModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BackgroundModule.prototype.setupViews = function () {
        if (this.system.shouldUseMultipleViews()) {
            this.setView(Views_1.Views.BACKGROUND_VIEW_MOBILE);
        }
        else {
            this.setView(Views_1.Views.BACKGROUND_VIEW);
        }
    };
    BackgroundModule.prototype.addDebuggingComponent = function () {
        new BackgroundDebuggingComponent_1.BackgroundDebuggingComponent(this, this.view);
    };
    BackgroundModule.prototype.setupStates = function () {
        _super.prototype.setupEvents.call(this);
        this.addState(new BackgroundBasicState_1.BackgroundBasicState(this, BackgroundModule.BASIC_STATE));
    };
    BackgroundModule.prototype.enterFirstState = function () {
        this.changeStateTo(BackgroundModule.BASIC_STATE);
    };
    BackgroundModule.prototype.setupEvents = function () {
        this.onViewCurrentStateHandle(BackgroundView_1.BackgroundView.VIEW_TRANSITION_TO_MAINGAME_COMPLETED);
        this.onViewCurrentStateHandle(BackgroundView_1.BackgroundView.VIEW_TRANSITION_TO_FREESPINS_COMPLETED);
        this.onViewEmitEvent(BackgroundView_1.BackgroundView.BACKGROUND_CREATED, BackgroundModule.BACKGROUND_CREATED_EVENT);
    };
    BackgroundModule.BASIC_STATE = 'basic';
    BackgroundModule.BACKGROUND_CREATED_EVENT = 'BackgroundModule::BACKGROUND_CREATED_EVENT';
    return BackgroundModule;
}(Module_1.Module));
exports.BackgroundModule = BackgroundModule;


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var WinPresentationModule_1 = __webpack_require__(77);
var GameWinPresentationBasicState_1 = __webpack_require__(536);
var GameFlowEvents_1 = __webpack_require__(57);
var GameWinPresentationBigWinWithMultiplierState_1 = __webpack_require__(537);
var GameWinPresentationInitialWinNoMultiplierState_1 = __webpack_require__(538);
var GameWinPresentationInitialWinWithMultiplierState_1 = __webpack_require__(539);
var WildMeterEvents_1 = __webpack_require__(66);
var GameWinPresentationView_1 = __webpack_require__(260);
var GameWinPresentationEvents_1 = __webpack_require__(40);
var SpinButtonEvents_1 = __webpack_require__(12);
var GameWinPresentationModule = /** @class */ (function (_super) {
    __extends(GameWinPresentationModule, _super);
    function GameWinPresentationModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameWinPresentationModule.prototype.setupStates = function () {
        this.addState(new GameWinPresentationBasicState_1.GameWinPresentationBasicState(this, WinPresentationModule_1.WinPresentationModule.BASIC));
        this.addState(new GameWinPresentationBigWinWithMultiplierState_1.GameWinPresentationBigWinWithMultiplierState(this, GameWinPresentationModule.BIG_WIN_WITH_MULTILPLER_STATE));
        this.addState(new GameWinPresentationInitialWinNoMultiplierState_1.GameWinPresentationInitialWinNoMultiplierState(this, GameWinPresentationModule.WIN_NO_MULTIPLIER_STATE));
        this.addState(new GameWinPresentationInitialWinWithMultiplierState_1.GameWinPresentationInitialWinWithMultiplierState(this, GameWinPresentationModule.WIN_WITH_MULTIPLIER_STATE));
    };
    GameWinPresentationModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.onCurrentStateHandle(SpinButtonEvents_1.SpinButtonEvents.SKIP_BY_SPIN_BUTTON_PRESSED);
        this.onCurrentStateHandle(GameFlowEvents_1.GameFlowEvents.HAS_WIN_WITH_MULTIPLIER);
        this.onCurrentStateHandle(GameFlowEvents_1.GameFlowEvents.HAS_BIGWIN_WITH_MULTIPLIER);
        this.onCurrentStateHandle(GameFlowEvents_1.GameFlowEvents.HAS_WIN_WITH_NO_MULTIPLIER);
        this.onCurrentStateHandle(WildMeterEvents_1.WildMeterEvents.WIN_METER_EXIT_WIN_ANIMATION_FINISHED);
        this.onCurrentStateHandle(GameWinPresentationEvents_1.GameWinPresentationEvents.AFTER_MULTIPLIER_COUNTING_FINISHED);
        this.onViewEmitEvent(GameWinPresentationView_1.GameWinPresentationView.AFTER_MULTIPLIER_COUNTING_FINISHED, GameWinPresentationEvents_1.GameWinPresentationEvents.AFTER_MULTIPLIER_COUNTING_FINISHED);
    };
    GameWinPresentationModule.WIN_WITH_MULTIPLIER_STATE = 'winwithmultiplierstate';
    GameWinPresentationModule.WIN_NO_MULTIPLIER_STATE = 'winnomultiplierstate';
    GameWinPresentationModule.BIG_WIN_WITH_MULTILPLER_STATE = 'bigwinwithmultiplierstate';
    return GameWinPresentationModule;
}(WinPresentationModule_1.WinPresentationModule));
exports.GameWinPresentationModule = GameWinPresentationModule;


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var WinPresentationModule_1 = __webpack_require__(77);
var FlowModuleEvents_1 = __webpack_require__(0);
var WinUtils_1 = __webpack_require__(58);
var WinPresentationBasicState = /** @class */ (function (_super) {
    __extends(WinPresentationBasicState, _super);
    function WinPresentationBasicState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WinPresentationBasicState.prototype.onEnterState = function () {
    };
    WinPresentationBasicState.prototype.onLeaveState = function () {
    };
    WinPresentationBasicState.prototype.setupEvents = function () {
        this.on(FlowModuleEvents_1.FlowModuleEvents.WON, this.onWon);
    };
    WinPresentationBasicState.prototype.onWon = function () {
        if (WinUtils_1.WinUtils.isBigWin(this.module.logic)) {
            this.module.gotoState(WinPresentationModule_1.WinPresentationModule.INITIALBEFOREBIGWIN);
        }
        else {
            this.module.gotoState(WinPresentationModule_1.WinPresentationModule.INITIAL);
        }
    };
    return WinPresentationBasicState;
}(ModuleState_1.ModuleState));
exports.WinPresentationBasicState = WinPresentationBasicState;


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var View_1 = __webpack_require__(3);
var Tween_1 = __webpack_require__(19);
var GameReelConstants_1 = __webpack_require__(34);
var RespinView = /** @class */ (function (_super) {
    __extends(RespinView, _super);
    function RespinView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._respinsData = [];
        _this._bounceTweenDuration = 150;
        return _this;
    }
    RespinView.prototype.tryToStartRespinSymbols = function (respinScatters) {
        this._respinsData = [];
        if (respinScatters.length > 0) {
            for (var _i = 0, respinScatters_1 = respinScatters; _i < respinScatters_1.length; _i++) {
                var respin = respinScatters_1[_i];
                this.initReplacePositions(respin);
            }
            this.startRespin();
        }
    };
    RespinView.prototype.startRespin = function () {
        this._currentRespinData = this._respinsData.shift();
        var scatterPos = this._currentRespinData.currentScatterPosition;
        this.emitDelayed(RespinView.LEAVING_RESPIN_SYMBOL, scatterPos);
        if (this._currentRespinData.replaceSymbolsPositions.length > 1) {
            this.playStartAnimationAt(scatterPos);
        }
        else {
            this.playOneSymbolRespin();
        }
    };
    RespinView.prototype.playOneSymbolRespin = function () {
        var startPos = this._currentRespinData.replaceSymbolsPositions[0];
        this.playSymbolRemoveAnimation(startPos);
        this.playEndAnimation(startPos, true);
        this.emitDelayed(RespinView.SYMBOL_WAS_SHOT, startPos);
    };
    RespinView.prototype.initReplacePositions = function (respinScatters) {
        var data = {
            currentScatterPosition: respinScatters.respinScatterPosition,
            currentRespinSymbolIndex: 0,
            replaceSymbolsPositions: [respinScatters.respinScatterPosition],
        };
        for (var _i = 0, _a = respinScatters.respinSymbols; _i < _a.length; _i++) {
            var symbol = _a[_i];
            data.replaceSymbolsPositions.push(symbol);
        }
        this._respinsData.push(data);
    };
    RespinView.prototype.playStartAnimationAt = function (scatterPos) {
        var _this = this;
        var startPos = GameReelConstants_1.GameReelConstants.getGameSymbolCenterPosition(scatterPos);
        var endPos = GameReelConstants_1.GameReelConstants.getGameSymbolCenterPosition(this.getNextRespinPosition());
        var angle = this.getAngle(startPos, endPos);
        var startAnim = this.spineUtils.startSpineAnimationCreation("RESPIN.json", 'START', false)
            .container(this.container)
            .onComplete(function () {
            _this.playSymbolRemoveAnimation(startPos);
            _this.prepareNextFlight();
            _this.spineUtils.stopAndDestroyAnimation(startAnim);
        })
            .position(startPos)
            .rotation(angle)
            .createAndStart();
        this.adjustAnimScale(angle, startAnim.container);
    };
    RespinView.prototype.prepareNextFlight = function () {
        if (this._currentRespinData.currentRespinSymbolIndex + 1 < this._currentRespinData.replaceSymbolsPositions.length) {
            this.setFromToReelsPositions(this._currentRespinData.replaceSymbolsPositions[this._currentRespinData.currentRespinSymbolIndex], this.getNextRespinPosition(), this.prepareNextFlight.bind(this));
            // this check made because zero index is scatter itself. Which is emitted earlier
            if (this._currentRespinData.currentRespinSymbolIndex !== 0) {
                this.emitDelayed(RespinView.SYMBOL_WAS_SHOT, this._currentRespinData.replaceSymbolsPositions[this._currentRespinData.currentRespinSymbolIndex]);
            }
            this._currentRespinData.currentRespinSymbolIndex++;
        }
        else {
            var startPos = this._currentRespinData.replaceSymbolsPositions[this._currentRespinData.currentRespinSymbolIndex];
            var isLast = this._respinsData.length === 0;
            this.playEndAnimation(startPos, isLast);
            this.emitDelayed(RespinView.SYMBOL_WAS_SHOT, startPos);
        }
    };
    RespinView.prototype.getNextRespinPosition = function () {
        return this._currentRespinData.replaceSymbolsPositions[this._currentRespinData.currentRespinSymbolIndex + 1];
    };
    RespinView.prototype.setFromToReelsPositions = function (fromPos, toPos, onFinishedCallback) {
        var fromReelPos = GameReelConstants_1.GameReelConstants.getGameSymbolCenterPosition(fromPos);
        var toReelPos = GameReelConstants_1.GameReelConstants.getGameSymbolCenterPosition(toPos);
        this.startBounceFromTo(fromReelPos, toReelPos, onFinishedCallback);
    };
    RespinView.prototype.startBounceFromTo = function (startPos, endPos, onFinishedCallback) {
        var _this = this;
        var angle = this.getAngle(startPos, endPos);
        var bounceAnim = this.spineUtils.startSpineAnimationCreation("RESPIN.json", 'BOUNCE', false)
            .container(this.container)
            .position(startPos)
            .rotation(angle)
            .createAndStart();
        var scale = this.getDistanceBetween(startPos, endPos) / this.getBoltLength();
        bounceAnim.container.scale.set(1, scale);
        var tween = new Tween_1.Tween(bounceAnim.container)
            .to({ x: endPos.x, y: endPos.y }, this._bounceTweenDuration)
            .onComplete(function () {
            _this.playSymbolRemoveAnimation(endPos);
            onFinishedCallback && onFinishedCallback();
            _this.spineUtils.stopAndDestroyAnimation(bounceAnim);
        })
            .start();
        this.updateManager.add(tween);
    };
    RespinView.prototype.playSymbolRemoveAnimation = function (pos) {
        var _this = this;
        var removeAnim = this.spineUtils.startSpineAnimationCreation("SYMBOL_REMOVE.json", 'SYMBOL_RESPIN_REMOVE', false)
            .container(this.container)
            .onComplete(function () {
            _this.spineUtils.stopAndDestroyAnimation(removeAnim);
        })
            .position(pos)
            .createAndStart();
    };
    RespinView.prototype.playEndAnimation = function (pos, isLast) {
        var _this = this;
        var animPos = GameReelConstants_1.GameReelConstants.getGameSymbolCenterPosition(pos);
        var endAnim = this.spineUtils.startSpineAnimationCreation("RESPIN.json", 'END', false)
            .container(this.container)
            .onComplete(function () {
            _this.playExitAnimation(animPos, isLast);
            _this.spineUtils.stopAndDestroyAnimation(endAnim);
        })
            .position(animPos)
            .createAndStart();
    };
    RespinView.prototype.playExitAnimation = function (pos, isLast) {
        var _this = this;
        var exitAnim = this.spineUtils.startSpineAnimationCreation("RESPIN.json", 'EXIT', false)
            .container(this.container)
            .onComplete(function () {
            if (isLast) {
                _this._respinsData = [];
                _this.emitDelayed(RespinView.FINISHED);
            }
            else {
                _this.startRespin();
            }
            _this.spineUtils.stopAndDestroyAnimation(exitAnim);
        })
            .position(pos)
            .createAndStart();
        this.emitDelayed(RespinView.RESPIN_END_ANIM_TRIGGERED);
    };
    RespinView.prototype.getAngle = function (startPos, endPos) {
        return Math.atan2(endPos.y - startPos.y, endPos.x - startPos.x);
    };
    RespinView.prototype.adjustAnimScale = function (angle, animContainer) {
        if (Math.abs(angle) > 1) {
            animContainer.scale.set(1, -1);
        }
    };
    RespinView.prototype.getDistanceBetween = function (pt1, pt2) {
        return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
    };
    RespinView.prototype.getBoltLength = function () {
        return GameReelConstants_1.GameReelConstants.getBottomSymbolSlot().width * 5;
    };
    RespinView.RESPIN_END_ANIM_TRIGGERED = 'RESPIN_END_ANIM_TRIGGERED';
    RespinView.SYMBOL_WAS_SHOT = 'SYMBOL_WAS_SHOT';
    RespinView.LEAVING_RESPIN_SYMBOL = 'LEAVING_RESPIN_SYMBOL';
    RespinView.FINISHED = 'FINISHED';
    return RespinView;
}(View_1.View));
exports.RespinView = RespinView;


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FreeGamesInProgress = /** @class */ (function () {
    function FreeGamesInProgress(data) {
        this.parseFreeGamesInProgress(data);
    }
    FreeGamesInProgress.prototype.parseFreeGamesInProgress = function (data) {
        if (!data) {
            return;
        }
        var freeGames = data.Response.FreeGames;
        if (freeGames && freeGames.CurrentGame) {
            this._gamesPlayed = Number.parseInt(freeGames.CurrentGame.attributes.gamesPlayed, 10);
            this._gamesRemaining = Number.parseInt(freeGames.CurrentGame.attributes.gamesRemaining, 10);
            this._sumWinnings = Number.parseInt(freeGames.CurrentGame.attributes.sumWinnings, 10);
            this._instanceID = freeGames.CurrentGame.attributes.instanceId;
            this._offerID = freeGames.CurrentGame.attributes.offerId;
            if (freeGames.LastRealWager) {
                this._wagerChipSize = Number.parseInt(freeGames.LastRealWager.attributes.chipSize, 10);
                this._wagerNumChips = Number.parseInt(freeGames.LastRealWager.attributes.numChips, 10);
                this._wagerActivePaylines = Number.parseInt(freeGames.LastRealWager.attributes.activePaylines, 10);
            }
        }
    };
    FreeGamesInProgress.prototype.setData = function (gamesPlayed, gamesRemaining, instanceID, offerID, sumWinnings, wagerChipSize, wagerNumChips, wagerActivePaylines) {
        this._gamesPlayed = gamesPlayed;
        this._gamesRemaining = gamesRemaining;
        this._instanceID = instanceID;
        this._offerID = offerID;
        this._sumWinnings = sumWinnings;
        this._wagerChipSize = wagerChipSize;
        this._wagerNumChips = wagerNumChips;
        this._wagerActivePaylines = wagerActivePaylines;
    };
    Object.defineProperty(FreeGamesInProgress.prototype, "gamesPlayed", {
        get: function () {
            return this._gamesPlayed;
        },
        set: function (value) {
            this._gamesPlayed = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FreeGamesInProgress.prototype, "gamesRemaining", {
        get: function () {
            return this._gamesRemaining;
        },
        set: function (value) {
            this._gamesRemaining = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FreeGamesInProgress.prototype, "instanceID", {
        get: function () {
            return this._instanceID;
        },
        set: function (value) {
            this._instanceID = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FreeGamesInProgress.prototype, "offerID", {
        get: function () {
            return this._offerID;
        },
        set: function (value) {
            this._offerID = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FreeGamesInProgress.prototype, "sumWinnings", {
        get: function () {
            return this._sumWinnings;
        },
        set: function (value) {
            this._sumWinnings = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FreeGamesInProgress.prototype, "wagerChipSize", {
        get: function () {
            return this._wagerChipSize;
        },
        set: function (value) {
            this._wagerChipSize = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FreeGamesInProgress.prototype, "wagerNumChips", {
        get: function () {
            return this._wagerNumChips;
        },
        set: function (value) {
            this._wagerNumChips = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FreeGamesInProgress.prototype, "wagerActivePaylines", {
        get: function () {
            return this._wagerActivePaylines;
        },
        set: function (value) {
            this._wagerActivePaylines = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FreeGamesInProgress.prototype, "lastRealWager", {
        get: function () {
            return { chipSize: this.wagerChipSize, numChips: this.wagerNumChips, activePaylines: this.wagerActivePaylines };
        },
        enumerable: true,
        configurable: true
    });
    return FreeGamesInProgress;
}());
exports.FreeGamesInProgress = FreeGamesInProgress;
var FreeGamesData = /** @class */ (function () {
    function FreeGamesData(data) {
        if (data) {
            this.parseFreeGamesData(data);
        }
    }
    // TODO: remove
    FreeGamesData.prototype.setData = function (betData, creditType, endDate, gamesAwarded, gamesRemaining, instanceID, maxCost, name0, name1, offerID, sumWinnings) {
        this._betData = betData;
        this._creditType = creditType;
        this._endDate = endDate;
        this._gamesAwarded = gamesAwarded;
        this._gamesRemaining = gamesRemaining;
        this._instanceID = instanceID;
        this._maxCost = maxCost;
        this._name0 = name0;
        this._name1 = name1;
        this._offerID = offerID;
        this._sumWinnings = sumWinnings;
    };
    FreeGamesData.prototype.parseFreeGamesData = function (data) {
        this._betData = {
            activePaylines: Number.parseInt(data.DefaultBet.attributes.activePaylines, 10),
            chipSize: Number.parseInt(data.DefaultBet.attributes.chipSize, 10),
            numChips: Number.parseInt(data.DefaultBet.attributes.numChips, 10),
        };
        this._creditType = Number.parseInt(data.attributes.creditType, 10);
        this._endDate = data.attributes.endDate;
        this._gamesAwarded = Number.parseInt(data.attributes.gamesAwarded, 10);
        this._gamesRemaining = this._gamesAwarded - Number.parseInt(data.attributes.gamesPlayed, 10);
        this._instanceID = data.attributes.instanceId;
        this._maxCost = Number.parseInt(data.attributes.maxCost, 10);
        this._name0 = data.attributes.name0;
        this._name1 = data.attributes.name1;
        this._offerID = data.attributes.offerId;
        this._sumWinnings = Number.parseInt(data.attributes.sumWinnings, 10);
    };
    Object.defineProperty(FreeGamesData.prototype, "betData", {
        get: function () {
            return this._betData;
        },
        set: function (value) {
            this._betData = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FreeGamesData.prototype, "creditType", {
        get: function () {
            return this._creditType;
        },
        set: function (value) {
            this._creditType = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FreeGamesData.prototype, "endDate", {
        get: function () {
            return this._endDate;
        },
        set: function (value) {
            this._endDate = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FreeGamesData.prototype, "gamesAwarded", {
        get: function () {
            return this._gamesAwarded;
        },
        set: function (value) {
            this._gamesAwarded = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FreeGamesData.prototype, "gamesRemaining", {
        get: function () {
            return this._gamesRemaining;
        },
        set: function (value) {
            this._gamesRemaining = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FreeGamesData.prototype, "instanceID", {
        get: function () {
            return this._instanceID;
        },
        set: function (value) {
            this._instanceID = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FreeGamesData.prototype, "maxCost", {
        get: function () {
            return this._maxCost;
        },
        set: function (value) {
            this._maxCost = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FreeGamesData.prototype, "name0", {
        get: function () {
            return this._name0;
        },
        set: function (value) {
            this._name0 = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FreeGamesData.prototype, "name1", {
        get: function () {
            return this._name1;
        },
        set: function (value) {
            this._name1 = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FreeGamesData.prototype, "offerID", {
        get: function () {
            return this._offerID;
        },
        set: function (value) {
            this._offerID = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FreeGamesData.prototype, "sumWinnings", {
        get: function () {
            return this._sumWinnings;
        },
        set: function (value) {
            this._sumWinnings = value;
        },
        enumerable: true,
        configurable: true
    });
    return FreeGamesData;
}());
exports.FreeGamesData = FreeGamesData;


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ReelConstants_1 = __webpack_require__(10);
var SpinResult_1 = __webpack_require__(110);
var RecodeSpinResult = /** @class */ (function (_super) {
    __extends(RecodeSpinResult, _super);
    function RecodeSpinResult() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RecodeSpinResult.prototype.cleanup = function () {
        this._winLines = [];
    };
    RecodeSpinResult.prototype.setReels = function (symbols, symbolHeights) {
        this._reels = this.makeGameReelsFromRecodeReels(symbols, symbolHeights);
    };
    RecodeSpinResult.prototype.setPreviousReels = function (symbols, symbolHeights) {
        this._previousReels = this.makeGameReelsFromRecodeReels(symbols, symbolHeights);
    };
    RecodeSpinResult.prototype.makeGameReelsFromRecodeReels = function (symbols, symbolHeights) {
        var reels = [];
        var symbolIndex = 0;
        var reelIndex = 0;
        for (var symIndex = 0; symIndex < symbols.length; symIndex++) {
            var symbol = symbols[symIndex];
            // for (const symbol of symbols) {
            if (!reels[reelIndex]) {
                reels.push([]);
            }
            var gameSymbol = this.makeGameSymbolFrom(symbol, symbolHeights[symIndex], {
                x: reelIndex,
                y: symbolIndex,
            });
            if (gameSymbol) {
                reels[reelIndex].push(gameSymbol);
            }
            reelIndex++;
            if (reelIndex > ReelConstants_1.ReelConstants.REELS_AMOUNT - 1) {
                symbolIndex++;
                reelIndex = 0;
            }
        }
        return reels;
    };
    RecodeSpinResult.prototype.setWaysToWin = function (wtw) {
        this._waysToWin = wtw;
    };
    RecodeSpinResult.prototype.setTotalWin = function (win) {
        this._win = win;
    };
    RecodeSpinResult.prototype.setRoundWin = function (win) {
        this._spinWin = win;
    };
    RecodeSpinResult.prototype.setNextRoundWin = function (win) {
        this._nextSpinWin = win;
    };
    RecodeSpinResult.prototype.setScatters = function (currentScatters) {
        this._respinScatters = [];
        var respinSymbols = [];
        var currentScatter = 0;
        var symsInScatter = Math.floor(currentScatters.symbolsPositions.length / currentScatters.scattersPositions.length);
        var currentSymbols = currentScatters.symbolsPositions.slice();
        while (currentSymbols.length > 0) {
            var sym = currentSymbols.pop();
            respinSymbols.push(this.makeSymbolPositionFromSymbol(sym));
            if (respinSymbols.length >= symsInScatter && currentScatter < currentScatters.scattersPositions.length - 1) {
                var scatter_1 = currentScatters.scattersPositions[currentScatter];
                var scatterPos_1 = this.makeSymbolPositionFromSymbol(scatter_1);
                this._respinScatters.push(new SpinResult_1.RespinScatterInfo(scatterPos_1, respinSymbols));
                currentScatter++;
                respinSymbols = [];
            }
        }
        var scatter = currentScatters.scattersPositions[currentScatter];
        var scatterPos = this.makeSymbolPositionFromSymbol(scatter);
        this._respinScatters.push(new SpinResult_1.RespinScatterInfo(scatterPos, respinSymbols));
    };
    RecodeSpinResult.prototype.setWins = function (wins) {
        this._winLines = [];
        var expandingWilds = [];
        if (this.expandingWilds && this.expandingWilds.length > 0) {
            for (var reel = 0; reel < ReelConstants_1.ReelConstants.REELS_AMOUNT; reel++) {
                expandingWilds[reel] = null;
            }
        }
        for (var _i = 0, wins_1 = wins; _i < wins_1.length; _i++) {
            var win = wins_1[_i];
            var positions = [];
            for (var _a = 0, _b = win.winSymbols; _a < _b.length; _a++) {
                var pos = _b[_a];
                var symbolPos = {
                    x: pos % ReelConstants_1.ReelConstants.REELS_AMOUNT,
                    y: Math.trunc(pos / ReelConstants_1.ReelConstants.REELS_AMOUNT),
                };
                if (!expandingWilds[symbolPos.x] && this.expandingWilds) {
                    // TODO: Add exp wild to winline.
                }
                positions.push(symbolPos);
            }
            this._winLines.push(new SpinResult_1.GameWinLine(win.payline, this.convertPaytableReasonToSymID(win.reason), positions, positions, win.amount, win.ways, this.convertPaytableReasonToSymbolCount(win.reason)));
        }
    };
    RecodeSpinResult.prototype.setRespinNewSymbols = function (currentRoundSymbols, currentScatters, currentSymbolHeights) {
        this._respinNewSymbols = [];
        for (var reelIndex = 0; reelIndex < ReelConstants_1.ReelConstants.REELS_AMOUNT; reelIndex++) {
            // getting all the removed symbols indexes from scatters list
            var symbolsFromReel = this.getSymbolsPositionsFromReel(currentScatters.symbolsPositions.concat(currentScatters.scattersPositions), reelIndex);
            // cycling through that list to add the same amount of new symbols from the new reels
            for (var reelSymIndex = 0; reelSymIndex < symbolsFromReel.length; reelSymIndex++) {
                var symIndex = this.getRecodeSymbolIndexFromPosition({ x: reelIndex, y: reelSymIndex });
                var gameSymbol = this.makeGameSymbolFrom(currentRoundSymbols[symIndex], currentSymbolHeights[symIndex], {
                    x: reelIndex,
                    y: symIndex,
                });
                var newSymbol = new SpinResult_1.AvalancheNewSymbol(reelIndex, reelSymIndex, gameSymbol.sym, gameSymbol.size.height);
                this._respinNewSymbols.push(newSymbol);
            }
        }
    };
    RecodeSpinResult.prototype.setAvalancheSymbolsToRemove = function (symbolsToRemove, symbols) {
        this._symbolsToRemove = [];
        // for(const sym of symbolsToRemove) {
        for (var index = 0; index < symbolsToRemove.length; index++) {
            var sym = symbolsToRemove[index];
            if (!this.isExpandedWild(symbols[sym])) {
                this._symbolsToRemove.push(this.makeSymbolPositionFromSymbol(sym));
            }
        }
    };
    RecodeSpinResult.prototype.setAvalancheNewSymbols = function (previousRoundSymbols, currentRoundSymbols, symbolsToRemove, previousRoundSymbolHeight, currentRoundSymbolsHeight) {
        var _this = this;
        this._symbolsToAdd = [];
        this._expandedWildsToRemove = [];
        for (var reelIndex = 0; reelIndex < ReelConstants_1.ReelConstants.REELS_AMOUNT; reelIndex++) {
            // getting all the removed symbols indexes from list
            var symbolsFromReel = this.getSymbolsPositionsFromReel(symbolsToRemove, reelIndex);
            var reelHasExpandingWild = false;
            var symbolsFromReelWithoutNulls = symbolsFromReel.filter(function (item) {
                return previousRoundSymbols[_this.getRecodeSymbolIndexFromPosition(item)] !== 7;
            });
            if (symbolsFromReelWithoutNulls.length === 1 && this.reelHasExpandedWild(previousRoundSymbols, reelIndex)) {
                this._expandedWildsToRemove.push(reelIndex);
                reelHasExpandingWild = true;
            }
            var reelInitialHeight = this.getSymbolsHeight(this.getSymbolsFromReel(currentRoundSymbols, reelIndex), this.getSymbolsFromReel(currentRoundSymbolsHeight, reelIndex));
            var reelSize = reelInitialHeight;
            if (reelHasExpandingWild) {
                reelSize = 0;
            }
            else {
                for (var _i = 0, symbolsFromReel_1 = symbolsFromReel; _i < symbolsFromReel_1.length; _i++) {
                    var sym = symbolsFromReel_1[_i];
                    var symIndex = this.getRecodeSymbolIndexFromPosition(sym);
                    var gameSymbol = this.makeGameSymbolFrom(previousRoundSymbols[symIndex], previousRoundSymbolHeight[symIndex], { x: sym.x, y: sym.y });
                    reelSize -= gameSymbol.size.height;
                }
            }
            var reelSymIndex = 0;
            while (reelSize < reelInitialHeight) {
                var symIndex = this.getRecodeSymbolIndexFromPosition({ x: reelIndex, y: reelSymIndex });
                var gameSymbol = this.makeGameSymbolFrom(currentRoundSymbols[symIndex], currentRoundSymbolsHeight[symIndex], {
                    x: reelIndex,
                    y: reelSymIndex,
                });
                if (gameSymbol) {
                    var newSymbol = new SpinResult_1.AvalancheNewSymbol(reelIndex, reelSymIndex, gameSymbol.sym, gameSymbol.size.height);
                    this._symbolsToAdd.push(newSymbol);
                    // reelSymIndex++;
                    reelSize += gameSymbol.size.height;
                }
                // TODO: How shit does this smell?
                reelSymIndex++;
            }
        }
    };
    RecodeSpinResult.prototype.setCurrentAvalancheMultiplier = function (multiplier) {
        this._multiplier = multiplier;
    };
    RecodeSpinResult.prototype.setBonusSymbolsList = function () {
        var data = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
        }
        return;
    };
    RecodeSpinResult.prototype.removeExpandedWild = function (reelIndex) {
        var indexToRemove = -1;
        for (var i = 0; i < this.expandingWilds.length; i++) {
            if (this.expandingWilds[i].reelIndex === reelIndex) {
                indexToRemove = i;
            }
        }
        if (indexToRemove >= 0) {
            this.expandingWilds.splice(indexToRemove, 1);
        }
    };
    RecodeSpinResult.prototype.parseBalance = function (data) {
        var balance = data.Response.Player.attributes.balance;
        this._balance = parseFloat(balance);
    };
    /**
     * creates game symbol with height from recode symbol
     */
    RecodeSpinResult.prototype.makeGameSymbolFrom = function (symbol, symbolHeight, position) {
        throw Error('RecodeSpinResult::makeGameSymbolFrom must be game specific');
    };
    RecodeSpinResult.prototype.convertPaytableReasonToSymbolCount = function (reason) {
        return Number.parseInt(reason.substr(0, 1), 10);
    };
    RecodeSpinResult.prototype.convertPaytableReasonToSymID = function (reason) {
        throw new Error('RecodeSpinResult::convertPaytableReasonToSymID must be game specific');
    };
    RecodeSpinResult.prototype.isAnExpandingWildOnReel = function (reel) {
        for (var ew in this.expandingWilds) {
            if (this.expandingWilds.hasOwnProperty(ew)) {
                var element = this.expandingWilds[ew];
                if (element.reelIndex === reel) {
                    return true;
                }
            }
        }
        return false;
    };
    /**
     * creates SymbolPosition from recode symbol position
     * @param symbol
     */
    RecodeSpinResult.prototype.makeSymbolPositionFromSymbol = function (symbol) {
        var reelPos = symbol % ReelConstants_1.ReelConstants.REELS_AMOUNT;
        var rowPos = Math.trunc(symbol / ReelConstants_1.ReelConstants.REELS_AMOUNT);
        return { x: reelPos, y: rowPos };
    };
    /**
     * get all the symbols positions from specified reel from recode reels
     * @param allSymbols
     * @param reelIndex
     */
    RecodeSpinResult.prototype.getSymbolsPositionsFromReel = function (allSymbols, reelIndex) {
        var reelSymbols = [];
        for (var _i = 0, allSymbols_1 = allSymbols; _i < allSymbols_1.length; _i++) {
            var sym = allSymbols_1[_i];
            var symPos = this.makeSymbolPositionFromSymbol(sym);
            if (symPos.x === reelIndex) {
                reelSymbols.push(symPos);
            }
        }
        return reelSymbols;
    };
    RecodeSpinResult.prototype.getSymbolsFromReel = function (allSymbols, reelIndex) {
        var reelSymbols = [];
        for (var i = 0; i < allSymbols.length; i++) {
            var symPos = this.makeSymbolPositionFromSymbol(i);
            if (symPos.x === reelIndex) {
                reelSymbols.push(allSymbols[i]);
            }
        }
        return reelSymbols;
    };
    /**
     * makes recode symbol position from game symbol position
     * @param pos
     */
    RecodeSpinResult.prototype.getRecodeSymbolIndexFromPosition = function (pos) {
        return pos.y * ReelConstants_1.ReelConstants.REELS_AMOUNT + pos.x;
    };
    RecodeSpinResult.prototype.createReelsFromSymbolsList = function (symbols, heights) {
        var gameSymbols = [];
        for (var reel = 0; reel < ReelConstants_1.ReelConstants.REELS_AMOUNT; reel++) {
            gameSymbols[reel] = [];
        }
        var symbolIndex = 0;
        var reelIndex = 0;
        for (var index = 0; index < symbols.length; index++) {
            var symbol = symbols[index];
            var height = heights[index];
            var gameSymbol = this.makeGameSymbolFrom(symbol, height, {
                x: reelIndex,
                y: index % reelIndex,
            });
            if (gameSymbol) {
                gameSymbols[reelIndex].push(gameSymbol);
            }
            reelIndex++;
            if (reelIndex > ReelConstants_1.ReelConstants.REELS_AMOUNT - 1) {
                symbolIndex++;
                reelIndex = 0;
            }
        }
        return gameSymbols;
    };
    RecodeSpinResult.prototype.isExpandedWild = function (symbol) {
        // symbol = symbol > 50 ? 50 : symbol;
        switch (symbol) {
            case 0:
            case 7:
                // case 50:
                return true;
                break;
            default:
                return false;
                break;
        }
    };
    RecodeSpinResult.prototype.getSymbolsHeight = function (symbols, symbolsHeights) {
        var totalHeight = 0;
        // for (const sym of symbols) {
        for (var index = 0; index < symbols.length; index++) {
            var sym = symbols[index];
            var symheight = symbolsHeights[index];
            var gameSymbol = this.makeGameSymbolFrom(sym, symheight, { x: 0, y: 0 });
            if (gameSymbol) {
                totalHeight += gameSymbol.size.height;
            }
        }
        return totalHeight;
    };
    RecodeSpinResult.prototype.reelHasNullSymbol = function (symbolsFromReel) {
        for (var _i = 0, symbolsFromReel_2 = symbolsFromReel; _i < symbolsFromReel_2.length; _i++) {
            var sym = symbolsFromReel_2[_i];
            if (sym === 7) {
                return true;
            }
        }
        return false;
    };
    RecodeSpinResult.prototype.reelHasExpandedWild = function (currentRoundSymbols, reelIndex) {
        var symbolsFromReel = this.getSymbolsFromReel(currentRoundSymbols, reelIndex);
        var expandedWildsFound = 0;
        var reelHasNullSymbol = false;
        for (var _i = 0, symbolsFromReel_3 = symbolsFromReel; _i < symbolsFromReel_3.length; _i++) {
            var sym = symbolsFromReel_3[_i];
            if (sym === 0) {
                expandedWildsFound++;
            }
            if (sym > 50) {
                reelHasNullSymbol = this.reelHasNullSymbol(symbolsFromReel);
                if (reelHasNullSymbol) {
                    expandedWildsFound++;
                }
            }
        }
        if (expandedWildsFound > 1) {
            throw new Error('RecodeSpinResult::reelHasExpandedWild wierd stuff on reel ' + reelIndex);
        }
        return expandedWildsFound === 1;
    };
    RecodeSpinResult.PAYLINES = [
        [1, 1, 1, 1, 1],
        [0, 0, 0, 0, 0],
        [2, 2, 2, 2, 2],
        [0, 1, 2, 1, 0],
        [2, 1, 0, 1, 2],
        [0, 0, 1, 0, 0],
        [2, 2, 1, 2, 2],
        [1, 2, 2, 2, 1],
        [1, 0, 0, 0, 1],
        [1, 0, 1, 0, 1],
        [1, 2, 1, 2, 1],
        [0, 1, 0, 1, 0],
        [2, 1, 2, 1, 2],
        [1, 1, 0, 1, 1],
        [1, 1, 2, 1, 1],
        [2, 1, 1, 1, 2],
        [0, 1, 1, 1, 0],
        [2, 0, 1, 0, 2],
        [0, 2, 1, 2, 0],
        [2, 0, 2, 0, 2],
    ];
    return RecodeSpinResult;
}(SpinResult_1.SpinResult));
exports.RecodeSpinResult = RecodeSpinResult;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var FlowModule_1 = __webpack_require__(35);
var Action_1 = __webpack_require__(29);
var AvalancheReelsEvents_1 = __webpack_require__(15);
var FlowModuleEvents_1 = __webpack_require__(0);
var WinPresentationEvents_1 = __webpack_require__(13);
var FlowWinningState_1 = __webpack_require__(114);
var BigWinEvents_1 = __webpack_require__(21);
var FlowAvalancheState = /** @class */ (function (_super) {
    __extends(FlowAvalancheState, _super);
    function FlowAvalancheState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FlowAvalancheState.prototype.onEnterState = function () {
    };
    FlowAvalancheState.prototype.onLeaveState = function () {
        _super.prototype.onLeaveState.call(this);
    };
    FlowAvalancheState.prototype.setupEvents = function () {
        this.on(AvalancheReelsEvents_1.AvalancheReelsEvents.AVALANCHE_FINISHED, this.onAvalancheEnded);
    };
    FlowAvalancheState.prototype.hasAnyBeforeWinFeatures = function () {
        return false;
    };
    FlowAvalancheState.prototype.addBeforeWinFeatures = function () {
    };
    FlowAvalancheState.prototype.onAvalancheEnded = function () {
        this._queueEvents.clearEventsQueue();
        if (this.hasAnyBeforeWinFeatures()) {
            this.addBeforeWinFeatures();
        }
        else {
            this.decideOnNextAction();
        }
    };
    FlowAvalancheState.prototype.decideOnNextAction = function () {
        switch (this.module.logic.nextAction) {
            case Action_1.Action.SPIN: {
                this.setupNextStateSpinFlow();
                break;
            }
            case Action_1.Action.RESPIN: {
                this.setupNextStateRespin();
                break;
            }
            case Action_1.Action.FREESPIN: {
                this.handleNextActionFreeSpin();
                break;
            }
            case Action_1.Action.PICK: {
                this.setupNextStateBonusGameFlow();
                break;
            }
            case Action_1.Action.AVALANCHE: {
                this.setupNextStateAvalancheFlow();
                break;
            }
            default:
                this.setupOtherActions(this.module.logic.nextAction);
                break;
        }
    };
    FlowAvalancheState.prototype.setupOtherActions = function (nextAction) {
    };
    FlowAvalancheState.prototype.handleNextActionFreeSpin = function () {
        var _this = this;
        this._queueEvents.addFunctionCallingEventToWaitingList(FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN, function () {
            _this.module.gotoState(FlowModule_1.FlowModule.FREE_SPINS_STATE);
        });
        this.setupNextStateFreeSpinsFlow();
    };
    FlowAvalancheState.prototype.setupNextStateRespin = function () {
        this.emitDelayed(FlowModuleEvents_1.FlowModuleEvents.RESPIN_WON);
        this.module.gotoState(FlowModule_1.FlowModule.RESPIN_STATE);
    };
    FlowAvalancheState.prototype.setupNextStateFreeSpinsFlow = function () {
        if (this.isSpinWin()) {
            if (this.isBigWin()) {
                this._queueEvents.addEventToWaitingList(BigWinEvents_1.BigWinEvents.FINISHED, FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
                this.setupBigWinNoIndividualNoSpin();
                this.setupCantSpinBigWin();
            }
            else {
                this._queueEvents.addEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED, FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
                this.setupCantSpinWin();
            }
        }
        else {
            this.setupCantSpinNoWin();
            this.emit(FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
        }
    };
    FlowAvalancheState.prototype.setupNextStateSpinFlow = function () {
        if (this.isBigWin()) {
            this.setupBigWin();
            this.addCheckForExitFreeSpin();
        }
        else if (this.isSpinWin()) {
            this.setupWin();
            this.addCheckForExitFreeSpin();
        }
        else {
            this.setupNoWin();
        }
    };
    FlowAvalancheState.prototype.addCheckForExitFreeSpin = function () {
        if (this.module.logic.isFreeSpinsStarted && this.module.logic.freeSpinsLeft <= 0) {
            this._queueEvents.addFunctionCallingEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED, this.gotoBasicState.bind(this));
        }
    };
    FlowAvalancheState.prototype.setupBigWin = function () {
        var _this = this;
        this._queueEvents.addFunctionCallingEventToWaitingList(FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN, function () {
            _this.module.gotoState(FlowModule_1.FlowModule.BASIC_STATE);
        });
        this._queueEvents.addEventToWaitingList(BigWinEvents_1.BigWinEvents.FINISHED, FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN);
        this.emit(FlowModuleEvents_1.FlowModuleEvents.WON_BIG_WIN);
    };
    FlowAvalancheState.prototype.setupWin = function () {
        var _this = this;
        this._queueEvents.addFunctionCallingEventToWaitingList(FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN, function () {
            _this.module.gotoState(FlowModule_1.FlowModule.BASIC_STATE);
        });
        this._queueEvents.addEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_STARTED, FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN);
        this.emit(FlowModuleEvents_1.FlowModuleEvents.WON);
    };
    FlowAvalancheState.prototype.setupNextStateBonusGameFlow = function () {
        var _this = this;
        this._queueEvents.addFunctionCallingEventToWaitingList(FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_START, function () {
            _this.module.gotoState(FlowModule_1.FlowModule.BONUS_STATE);
        });
        if (this.isBigWin()) {
            this.setupBigWinNoIndividualNoSpin();
            this._queueEvents.addEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED, FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_WON);
            this._queueEvents.addEventToWaitingList(FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_WON, FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_START);
        }
        else if (this.isSpinWin()) {
            this._queueEvents.addEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED, FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_WON);
            this._queueEvents.addEventToWaitingList(FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_WON, FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_START);
            this.setupCantSpinWin();
        }
        else {
            this.setupCantSpinNoWin();
            this.emit(FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_WON);
            this.emit(FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_START);
        }
    };
    FlowAvalancheState.prototype.setupNextStateAvalancheFlow = function () {
        if (this.isBigWin()) {
            this.setupBigWinNoIndividualNoSpin();
            this._queueEvents.addEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED, FlowModuleEvents_1.FlowModuleEvents.AVALANCHE_WON);
        }
        else if (this.isSpinWin()) {
            this.setupCantSpinWin();
            this._queueEvents.addEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED, FlowModuleEvents_1.FlowModuleEvents.AVALANCHE_WON);
        }
        else {
            this.emit(FlowModuleEvents_1.FlowModuleEvents.AVALANCHE_WON);
            this.setupCantSpinNoWin();
        }
    };
    return FlowAvalancheState;
}(FlowWinningState_1.FlowWinningState));
exports.FlowAvalancheState = FlowAvalancheState;


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var FlowModule_1 = __webpack_require__(35);
var ReelsEvents_1 = __webpack_require__(4);
var Action_1 = __webpack_require__(29);
var FlowModuleEvents_1 = __webpack_require__(0);
var WinPresentationEvents_1 = __webpack_require__(13);
var BigWinEvents_1 = __webpack_require__(21);
var FlowWinningState_1 = __webpack_require__(114);
var FlowBasicState = /** @class */ (function (_super) {
    __extends(FlowBasicState, _super);
    function FlowBasicState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FlowBasicState.prototype.onEnterState = function () {
        if (this.shouldFinishFreeSpins()) {
            this.emit(FlowModuleEvents_1.FlowModuleEvents.FREE_SPINS_FINISHED);
        }
    };
    FlowBasicState.prototype.shouldFinishFreeSpins = function () {
        return this.module.logic.isFreeSpinsStarted && this.module.logic.freeSpinsLeft === 0;
    };
    FlowBasicState.prototype.handle = function (id, data) {
        _super.prototype.handle.call(this, id, data);
        this._queueEvents.handleWaitingList(id, data);
    };
    FlowBasicState.prototype.setupEvents = function () {
        this.on(ReelsEvents_1.ReelsEvents.SPIN_ENDED, this.onAllReelsStopped);
        this.on(ReelsEvents_1.ReelsEvents.REELS_SPINNING_STARTED, this.onSpinStarted);
    };
    FlowBasicState.prototype.onSpinStarted = function () {
        this._queueEvents.clearEventsQueue();
    };
    FlowBasicState.prototype.onAllReelsStopped = function () {
        this._queueEvents.clearEventsQueue();
        if (this.hasAnyBeforeWinFeatures()) {
            this.addBeforeWinFeatures();
        }
        else {
            this.decideOnNextAction();
        }
    };
    FlowBasicState.prototype.decideOnNextAction = function () {
        switch (this.module.logic.nextAction) {
            case Action_1.Action.SPIN: {
                this.setupNextStateSpinFlow();
                break;
            }
            case Action_1.Action.FREESPIN: {
                this.handleNextActionFreeSpin();
                break;
            }
            case Action_1.Action.PICK: {
                this.setupNextStateBonusGameFlow();
                break;
            }
            case Action_1.Action.AVALANCHE: {
                this.setupNextStateAvalancheFlow();
                break;
            }
            case Action_1.Action.RESPIN: {
                this.setupNextStateRespin();
                break;
            }
            case Action_1.Action.EXPLOSION: {
                this.setupExplosionNextState();
                break;
            }
            default:
                this.setupOtherActions(this.module.logic.nextAction);
                break;
        }
    };
    FlowBasicState.prototype.setupOtherActions = function (nextAction) {
    };
    FlowBasicState.prototype.setupNextStateRespin = function () {
        this.emitDelayed(FlowModuleEvents_1.FlowModuleEvents.RESPIN_WON);
        this.module.gotoState(FlowModule_1.FlowModule.RESPIN_STATE);
    };
    FlowBasicState.prototype.handleNextActionFreeSpin = function () {
        var _this = this;
        this._queueEvents.addFunctionCallingEventToWaitingList(FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN, function () {
            _this.module.gotoState(FlowModule_1.FlowModule.FREE_SPINS_STATE);
        });
        this.setupNextStateFreeSpinsFlow();
    };
    FlowBasicState.prototype.setupExplosionNextState = function () {
        throw new Error('FlowBasicState::setupExplosionNextState explosion handling must be implemented');
    };
    FlowBasicState.prototype.hasAnyBeforeWinFeatures = function () {
        return false;
    };
    FlowBasicState.prototype.addBeforeWinFeatures = function () {
    };
    FlowBasicState.prototype.setupNextStateSpinFlow = function () {
        if (this.isBigWin()) {
            this.setupBigWin();
        }
        else if (this.isSpinWin()) {
            this.setupWin();
        }
        else {
            this.setupNoWin();
        }
    };
    FlowBasicState.prototype.setupNextStateFreeSpinsFlow = function () {
        if (this.isSpinWin()) {
            if (this.isBigWin()) {
                this._queueEvents.addEventToWaitingList(BigWinEvents_1.BigWinEvents.FINISHED, FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
                this.setupBigWinNoIndividualNoSpin();
                this.setupCantSpinBigWin();
            }
            else {
                this._queueEvents.addEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED, FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
                this.setupCantSpinWin();
            }
        }
        else {
            this.setupCantSpinNoWin();
            this.emit(FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
        }
    };
    FlowBasicState.prototype.setupNextStateBonusGameFlow = function () {
        var _this = this;
        this._queueEvents.addFunctionCallingEventToWaitingList(FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_START, function () {
            _this.module.gotoState(FlowModule_1.FlowModule.BONUS_STATE);
        });
        if (this.isBigWin()) {
            this.setupBigWinNoIndividualNoSpin();
            this._queueEvents.addEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED, FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_WON);
            this._queueEvents.addEventToWaitingList(FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_WON, FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_START);
        }
        else if (this.isSpinWin()) {
            this.setupCantSpinWin();
            this._queueEvents.addEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED, FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_WON);
            this._queueEvents.addEventToWaitingList(FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_WON, FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_START);
        }
        else {
            this.setupCantSpinNoWin();
            this.emit(FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_WON);
            if (this.module.logic.hasRestore) {
                this.emit(FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_RESTORED);
            }
            this.emit(FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_START);
        }
    };
    FlowBasicState.prototype.setupNextStateAvalancheFlow = function () {
        var _this = this;
        this._queueEvents.addFunctionCallingEventToWaitingList(FlowModuleEvents_1.FlowModuleEvents.AVALANCHE_WON, function () {
            _this.module.gotoState(FlowModule_1.FlowModule.AVALANCHE_STATE);
        });
        if (this.isBigWin()) {
            this.setupBigWinNoIndividualNoSpin();
            this._queueEvents.addEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_STARTED, FlowModuleEvents_1.FlowModuleEvents.AVALANCHE_WON);
        }
        else if (this.isSpinWin()) {
            this.setupCantSpinWin();
            this._queueEvents.addEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_STARTED, FlowModuleEvents_1.FlowModuleEvents.AVALANCHE_WON);
        }
        else {
            this.emit(FlowModuleEvents_1.FlowModuleEvents.AVALANCHE_WON);
            this.setupCantSpinNoWin();
        }
    };
    return FlowBasicState;
}(FlowWinningState_1.FlowWinningState));
exports.FlowBasicState = FlowBasicState;


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var FlowModule_1 = __webpack_require__(35);
var ReelsEvents_1 = __webpack_require__(4);
var FlowModuleEvents_1 = __webpack_require__(0);
var Action_1 = __webpack_require__(29);
var FlowWinningState_1 = __webpack_require__(114);
var WinPresentationEvents_1 = __webpack_require__(13);
var FreeSpinsEvents_1 = __webpack_require__(6);
var AvalancheReelsEvents_1 = __webpack_require__(15);
var FlowFreeSpinsState = /** @class */ (function (_super) {
    __extends(FlowFreeSpinsState, _super);
    function FlowFreeSpinsState(module, name, eventManager) {
        return _super.call(this, module, name, eventManager) || this;
    }
    FlowFreeSpinsState.prototype.onEnterState = function () {
        if (!(this.module.logic.hasRestore && this.module.isRestoreMessageOnTheScreen)) {
            this.emit(FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN);
        }
    };
    FlowFreeSpinsState.prototype.setupEvents = function () {
        this.on(ReelsEvents_1.ReelsEvents.SPIN_ENDED, this.onAllReelsStopped);
        this.on(AvalancheReelsEvents_1.AvalancheReelsEvents.SYMBOLS_RESPIN_FINISHED, this.onAllReelsStopped);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_INTRO_FINISHED, this.onFreeSpinsIntroFinished);
    };
    FlowFreeSpinsState.prototype.hasAnyBeforeWinFeatures = function () {
        return false;
    };
    FlowFreeSpinsState.prototype.addBeforeWinFeatures = function () {
    };
    FlowFreeSpinsState.prototype.onFreeSpinsIntroFinished = function () {
        this.emit(FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN);
    };
    FlowFreeSpinsState.prototype.onAllReelsStopped = function () {
        this._queueEvents.clearEventsQueue();
        if (this.hasAnyBeforeWinFeatures()) {
            this.addBeforeWinFeatures();
        }
        else {
            this.decideOnNextAction();
        }
    };
    FlowFreeSpinsState.prototype.decideOnNextAction = function () {
        this._queueEvents.clearEventsQueue();
        switch (this.module.logic.nextAction) {
            case Action_1.Action.FREESPIN: {
                this.setupNextStateFreeSpinFlow();
                break;
            }
            case Action_1.Action.SPIN: {
                this.setupNextStateSpinFlow();
                break;
            }
            case Action_1.Action.PICK: {
                this.setupNextStatePickFlow();
                break;
            }
            case Action_1.Action.AVALANCHE: {
                this.setupNextStateAvalancheFlow();
                break;
            }
            case Action_1.Action.RESPIN: {
                this.setupNextRespinFlow();
                break;
            }
            case Action_1.Action.SCATTER_AND_AVALANCHE: {
                this.handleScatterAvalancheNextState();
                break;
            }
            case Action_1.Action.EXPLOSION: {
                this.handleExplosionNextState();
                break;
            }
            default:
                this.setupOtherActions(this.module.logic.nextAction);
                break;
        }
    };
    FlowFreeSpinsState.prototype.setupOtherActions = function (nextAction) {
    };
    FlowFreeSpinsState.prototype.setupNextStatePickFlow = function () {
        this.emit(FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_WON);
    };
    FlowFreeSpinsState.prototype.setupNextStateSpinFlow = function () {
        if (this.isBigWin()) {
            this.setupBigWin();
            this.addCheckForExitFreeSpin();
        }
        else if (this.isSpinWin()) {
            this.setupWin();
            this.addCheckForExitFreeSpin();
        }
        else {
            this.setupNoWin();
            this.gotoBasicState();
        }
    };
    FlowFreeSpinsState.prototype.addCheckForExitFreeSpin = function () {
        if (this.module.logic.isFreeSpinsStarted && this.module.logic.freeSpinsLeft <= 0) {
            this._queueEvents.addFunctionCallingEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED, this.gotoBasicState.bind(this));
        }
    };
    FlowFreeSpinsState.prototype.setupNextRespinFlow = function () {
        this.emitDelayed(FlowModuleEvents_1.FlowModuleEvents.RESPIN_WON);
        this.module.gotoState(FlowModule_1.FlowModule.RESPIN_STATE);
    };
    FlowFreeSpinsState.prototype.handleScatterAvalancheNextState = function () {
        throw new Error('FlowFreeSpinsState::setupExplosionNextState explosion handling must be implemented');
    };
    FlowFreeSpinsState.prototype.handleExplosionNextState = function () {
        throw new Error('FlowFreeSpinsState::setupExplosionNextState explosion handling must be implemented');
    };
    FlowFreeSpinsState.prototype.setupNextStateAvalancheFlow = function () {
        var _this = this;
        this._queueEvents.addFunctionCallingEventToWaitingList(FlowModuleEvents_1.FlowModuleEvents.AVALANCHE_WON, function () {
            _this.module.gotoState(FlowModule_1.FlowModule.AVALANCHE_STATE);
        });
        if (this.isBigWin()) {
            this.setupBigWinNoIndividualNoSpin();
            this._queueEvents.addEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_STARTED, FlowModuleEvents_1.FlowModuleEvents.AVALANCHE_WON);
        }
        else if (this.isSpinWin()) {
            this.setupCantSpinWin();
            this._queueEvents.addEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_STARTED, FlowModuleEvents_1.FlowModuleEvents.AVALANCHE_WON);
        }
        else {
            this.emit(FlowModuleEvents_1.FlowModuleEvents.AVALANCHE_WON);
            this.setupCantSpinNoWin();
        }
    };
    FlowFreeSpinsState.prototype.setupNextStateFreeSpinFlow = function () {
        if (this.isBigWin()) {
            this.setupBigWin();
        }
        else if (this.isSpinWin()) {
            this.setupWin();
        }
        else {
            this.setupNoWin();
        }
    };
    FlowFreeSpinsState.prototype.setupNoWin = function () {
        this.emit(FlowModuleEvents_1.FlowModuleEvents.NO_WIN);
        this.sendOutCanSpin();
    };
    return FlowFreeSpinsState;
}(FlowWinningState_1.FlowWinningState));
exports.FlowFreeSpinsState = FlowFreeSpinsState;


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var FlowModule_1 = __webpack_require__(35);
var AvalancheReelsEvents_1 = __webpack_require__(15);
var Action_1 = __webpack_require__(29);
var FlowModuleEvents_1 = __webpack_require__(0);
var BigWinEvents_1 = __webpack_require__(21);
var WinPresentationEvents_1 = __webpack_require__(13);
var FlowWinningState_1 = __webpack_require__(114);
var ReelsEvents_1 = __webpack_require__(4);
var IndividualSymbolReelsEvents_1 = __webpack_require__(116);
var FlowRespinState = /** @class */ (function (_super) {
    __extends(FlowRespinState, _super);
    function FlowRespinState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FlowRespinState.prototype.onEnterState = function () {
    };
    FlowRespinState.prototype.setupEvents = function () {
        this.on(AvalancheReelsEvents_1.AvalancheReelsEvents.SYMBOLS_RESPIN_FINISHED, this.onRespinFinished);
        this.on(IndividualSymbolReelsEvents_1.IndividualSymbolReelsEvents.INDIVIDUAL_RESPIN_FINISHED, this.onRespinFinished);
        this.on(ReelsEvents_1.ReelsEvents.SPIN_ENDED, this.onRespinFinished);
    };
    FlowRespinState.prototype.onRespinFinished = function () {
        this._queueEvents.clearEventsQueue();
        if (this.hasAnyBeforeWinFeatures()) {
            this.addBeforeWinFeatures();
        }
        else {
            this.decideOnNextAction();
        }
    };
    FlowRespinState.prototype.hasAnyBeforeWinFeatures = function () {
        return false;
    };
    FlowRespinState.prototype.addBeforeWinFeatures = function () {
    };
    FlowRespinState.prototype.decideOnNextAction = function () {
        switch (this.module.logic.nextAction) {
            case Action_1.Action.SPIN: {
                this.setupNextStateSpinFlow();
                break;
            }
            case Action_1.Action.AVALANCHE: {
                this.setupNextStateAvalancheFlow();
                break;
            }
            case Action_1.Action.FREESPIN: {
                this.handleNextActionFreeSpin();
                break;
            }
            case Action_1.Action.PICK: {
                this.setupNextStateBonusGameFlow();
                break;
            }
            case Action_1.Action.RESPIN: {
                this.setupNextStateRespinFlow();
                break;
            }
            case Action_1.Action.EXPLOSION: {
                this.handleExplosionNextState();
                break;
            }
            default:
                this.setupOtherActions(this.module.logic.nextAction);
                break;
        }
    };
    FlowRespinState.prototype.setupOtherActions = function (nextAction) {
    };
    FlowRespinState.prototype.setupNextStateRespinFlow = function () {
        this.emitDelayed(FlowModuleEvents_1.FlowModuleEvents.RESPIN_WON);
    };
    FlowRespinState.prototype.handleNextActionFreeSpin = function () {
        var _this = this;
        this._queueEvents.addFunctionCallingEventToWaitingList(FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN, function () {
            _this.module.gotoState(FlowModule_1.FlowModule.FREE_SPINS_STATE);
        });
        this.setupNextStateFreeSpinsFlow();
    };
    FlowRespinState.prototype.handleExplosionNextState = function () {
        throw new Error('FlowRespinState::setupExplosionNextState explosion handling must be implemented');
    };
    FlowRespinState.prototype.setupNextStateAvalancheFlow = function () {
        var _this = this;
        this._queueEvents.addFunctionCallingEventToWaitingList(FlowModuleEvents_1.FlowModuleEvents.AVALANCHE_WON, function () {
            _this.module.gotoState(FlowModule_1.FlowModule.AVALANCHE_STATE);
        });
        if (this.isBigWin()) {
            this.setupBigWinNoIndividualNoSpin();
            this._queueEvents.addEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED, FlowModuleEvents_1.FlowModuleEvents.AVALANCHE_WON);
        }
        else if (this.isSpinWin()) {
            this.setupCantSpinWin();
            this._queueEvents.addEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED, FlowModuleEvents_1.FlowModuleEvents.AVALANCHE_WON);
        }
        else {
            this.emit(FlowModuleEvents_1.FlowModuleEvents.AVALANCHE_WON);
            this.setupCantSpinNoWin();
        }
    };
    FlowRespinState.prototype.setupNextStateSpinFlow = function () {
        if (this.isBigWin()) {
            this.setupBigWin();
            this.addCheckForExitFreeSpin();
        }
        else if (this.isSpinWin()) {
            this.setupWin();
            this.addCheckForExitFreeSpin();
        }
        else {
            this.setupNoWin();
        }
    };
    FlowRespinState.prototype.addCheckForExitFreeSpin = function () {
        if (this.module.logic.isFreeSpinsStarted && this.module.logic.freeSpinsLeft <= 0) {
            this._queueEvents.addFunctionCallingEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED, this.gotoBasicState.bind(this));
        }
    };
    FlowRespinState.prototype.setupNextStateFreeSpinsFlow = function () {
        if (this.isSpinWin()) {
            if (this.isBigWin()) {
                this.setupCantSpinBigWin();
                this._queueEvents.addEventToWaitingList(BigWinEvents_1.BigWinEvents.FINISHED, FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
            }
            else {
                this.setupCantSpinWin();
                this._queueEvents.addEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED, FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
            }
        }
        else {
            this.setupCantSpinNoWin();
            this.emit(FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
        }
    };
    FlowRespinState.prototype.setupNextStateBonusGameFlow = function () {
        var _this = this;
        this._queueEvents.addFunctionCallingEventToWaitingList(FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_START, function () {
            _this.module.gotoState(FlowModule_1.FlowModule.BONUS_STATE);
        });
        if (this.isBigWin()) {
            this.setupBigWinNoIndividualNoSpin();
            this._queueEvents.addEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED, FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_WON);
            this._queueEvents.addEventToWaitingList(FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_WON, FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_START);
        }
        else if (this.isSpinWin()) {
            this.setupCantSpinWin();
            this._queueEvents.addEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED, FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_WON);
            this._queueEvents.addEventToWaitingList(FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_WON, FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_START);
        }
        else {
            this.setupCantSpinNoWin();
            this.emit(FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_WON);
            this.emit(FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_START);
        }
    };
    return FlowRespinState;
}(FlowWinningState_1.FlowWinningState));
exports.FlowRespinState = FlowRespinState;


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var FlowModule_1 = __webpack_require__(35);
var Action_1 = __webpack_require__(29);
var FlowRestoreState = /** @class */ (function (_super) {
    __extends(FlowRestoreState, _super);
    function FlowRestoreState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FlowRestoreState.prototype.setupEvents = function () {
    };
    FlowRestoreState.prototype.onEnterState = function () {
        switch (this.module.logic.nextAction) {
            case Action_1.Action.FREESPIN: {
                this.restoreFreespins();
                break;
            }
            case Action_1.Action.RESPIN: {
                this.restoreRespin();
                break;
            }
            case Action_1.Action.PICK: {
                this.restorePickBonus();
                break;
            }
            case Action_1.Action.AVALANCHE: {
                this.restoreAvalanche();
                break;
            }
            default:
                this.module.gotoState(FlowModule_1.FlowModule.BASIC_STATE);
                break;
        }
    };
    FlowRestoreState.prototype.onLeaveState = function () {
    };
    FlowRestoreState.prototype.restoreFreespins = function () {
    };
    FlowRestoreState.prototype.restoreRespin = function () {
    };
    FlowRestoreState.prototype.restorePickBonus = function () {
    };
    FlowRestoreState.prototype.restoreAvalanche = function () {
    };
    return FlowRestoreState;
}(ModuleState_1.ModuleState));
exports.FlowRestoreState = FlowRestoreState;


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var QueueEventsHandler_1 = __webpack_require__(115);
var LogicEvents_1 = __webpack_require__(11);
var FlowModuleEvents_1 = __webpack_require__(0);
var FlowWhileSpinningState = /** @class */ (function (_super) {
    __extends(FlowWhileSpinningState, _super);
    function FlowWhileSpinningState(module, name, eventManager) {
        var _this = _super.call(this, module, name) || this;
        _this._queueEvents = new QueueEventsHandler_1.QueueEventsHandler(eventManager);
        return _this;
    }
    FlowWhileSpinningState.prototype.onEnterState = function () {
    };
    FlowWhileSpinningState.prototype.onLeaveState = function () {
    };
    FlowWhileSpinningState.prototype.setupEvents = function () {
        this.on(LogicEvents_1.LogicEvents.SPIN_RESPONSE, this.onSpinResponse);
    };
    FlowWhileSpinningState.prototype.onSpinResponse = function () {
        this.continueToGameplay();
    };
    FlowWhileSpinningState.prototype.continueToGameplay = function () {
        this.emitDelayed(FlowModuleEvents_1.FlowModuleEvents.CAN_CONTINUE_SPIN);
        this.module.gotoPreviousState();
    };
    return FlowWhileSpinningState;
}(ModuleState_1.ModuleState));
exports.FlowWhileSpinningState = FlowWhileSpinningState;


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Module_1 = __webpack_require__(2);
var Views_1 = __webpack_require__(8);
var LogicEvents_1 = __webpack_require__(11);
var BigWinEvents_1 = __webpack_require__(21);
var BonusGameEvents_1 = __webpack_require__(78);
var FlowModuleEvents_1 = __webpack_require__(0);
var FreeSpinsEvents_1 = __webpack_require__(6);
var InfoEvents_1 = __webpack_require__(118);
var InfoViewEvents_1 = __webpack_require__(290);
var InfoModuleBasicState_1 = __webpack_require__(161);
var InfoModuleFreeSpinsState_1 = __webpack_require__(291);
var SpinButtonEvents_1 = __webpack_require__(12);
var MainMenuEvents_1 = __webpack_require__(44);
var SettingsEvents_1 = __webpack_require__(95);
var AutoplayMenuEvents_1 = __webpack_require__(33);
var BetlevelMenuEvents_1 = __webpack_require__(48);
var StartScreenEvents_1 = __webpack_require__(22);
var WinPresentationEvents_1 = __webpack_require__(13);
var ReelsEvents_1 = __webpack_require__(4);
/**
 * represents text information on the screen: clock, wins, bets, balance, logo etc.
 */
var InfoModule = /** @class */ (function (_super) {
    __extends(InfoModule, _super);
    function InfoModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InfoModule.prototype.init = function () {
        _super.prototype.init.call(this);
        this.view.setSoundButtonStatus(!this.logic.soundAllActive, false);
    };
    InfoModule.prototype.restore = function () {
        _super.prototype.restore.call(this);
        if (this.logic.isFreeSpinsStarted) {
            this.gotoState(InfoModule.FREESPINS);
        }
    };
    InfoModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.onView(InfoViewEvents_1.InfoViewEvents.TOGGLE_ALL_SOUND_OFF, this.onViewToggleAllSoundOff);
        this.onView(InfoViewEvents_1.InfoViewEvents.TOGGLE_ALL_SOUND_ON, this.onViewToggleAllSoundOn);
        // Passing along these events.
        this.onViewEmitEvent(InfoViewEvents_1.InfoViewEvents.BALANCE_UPDATED, InfoEvents_1.InfoEvents.BALANCE_UPDATED);
        this.onViewEmitEvent(InfoViewEvents_1.InfoViewEvents.BET_UPDATED, InfoEvents_1.InfoEvents.BET_UPDATED);
        this.onViewEmitEvent(InfoViewEvents_1.InfoViewEvents.WIN_UPDATED, InfoEvents_1.InfoEvents.WIN_UPDATED);
        this.on(SettingsEvents_1.SettingsEvents.TOGGLE_ALL_SOUND_OFF, this.onToggleAllSoundsOff);
        this.on(SettingsEvents_1.SettingsEvents.TOGGLE_ALL_SOUND_ON, this.onToggleAllSoundsOn);
        this.on(SettingsEvents_1.SettingsEvents.TOGGLE_MUSIC_ON, this.onToggleMusicOn);
        this.on(SettingsEvents_1.SettingsEvents.TOGGLE_MUSIC_OFF, this.onToggleMusicOff);
        this.on(SettingsEvents_1.SettingsEvents.TOGGLE_VOICE_ON, this.onToggleVoiceOn);
        this.on(SettingsEvents_1.SettingsEvents.TOGGLE_VOICE_OFF, this.onToggleVoiceOff);
        this.on(SettingsEvents_1.SettingsEvents.TOGGLE_SOUND_EFFECTS_ON, this.onToggleSoundEffectsOn);
        this.on(SettingsEvents_1.SettingsEvents.TOGGLE_SOUND_EFFECTS_OFF, this.onToggleSoundEffectsOff);
        this.onCurrentStateHandle(WinPresentationEvents_1.WinPresentationEvents.INITIAL_WIN_ANIMATION_FINISHED);
        this.onCurrentStateHandle(WinPresentationEvents_1.WinPresentationEvents.COUNTUP_FINISHED);
        this.onCurrentStateHandle(WinPresentationEvents_1.WinPresentationEvents.WIN_NUMBER_SHOWN_TO_PLAYER);
        this.on(MainMenuEvents_1.MainMenuEvents.MAIN_MENU_OPEN, this.onMainMenuOpen);
        this.on(MainMenuEvents_1.MainMenuEvents.MAIN_MENU_CLOSED, this.onMainMenuClosed);
        this.on(BetlevelMenuEvents_1.BetlevelMenuEvents.BET_LEVEL_MENU_OPENED, this.onBetlevelMenuOpened);
        this.on(BetlevelMenuEvents_1.BetlevelMenuEvents.BET_LEVEL_MENU_CLOSED, this.onBetlevelMenuClosed);
        this.on(AutoplayMenuEvents_1.AutoplayMenuEvents.AUTO_PLAY_MENU_OPENED, this.onAutoplayMenuOpened);
        this.on(AutoplayMenuEvents_1.AutoplayMenuEvents.AUTO_PLAY_MENU_CLOSED, this.onAutoplayMenuClosed);
        this.on(StartScreenEvents_1.StartScreenEvents.EXIT_FINISHED, this.onStartScreenExitFinished);
        this.onCurrentStateHandle(BigWinEvents_1.BigWinEvents.FINISHED);
        this.onCurrentStateHandle(FlowModuleEvents_1.FlowModuleEvents.WON_BIG_WIN);
        this.onCurrentStateHandle(FlowModuleEvents_1.FlowModuleEvents.WON);
        this.onCurrentStateHandle(FlowModuleEvents_1.FlowModuleEvents.NO_WIN);
        this.onCurrentStateHandle(FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN);
        this.on(FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_START, this.onBonusGameStart);
        this.on(FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_END, this.onBonusGameEnd);
        this.onCurrentStateHandle(BonusGameEvents_1.BonusGameEvents.BONUS_OUTRO_FINISHED);
        this.onCurrentStateHandle(BigWinEvents_1.BigWinEvents.COUNTUP_FINISHED);
        this.onCurrentStateHandle(LogicEvents_1.LogicEvents.SPIN_RESPONSE);
        this.onCurrentStateHandle(LogicEvents_1.LogicEvents.INIT_RESPONSE);
        this.onCurrentStateHandle(SpinButtonEvents_1.SpinButtonEvents.SPIN_BUTTON_PRESSED);
        this.onCurrentStateHandle(SpinButtonEvents_1.SpinButtonEvents.SPIN_PRESSED_NOT_ENOUGH_MONEY);
        this.onCurrentStateHandle(ReelsEvents_1.ReelsEvents.ALL_REELS_STOPPED);
        this.on(BetlevelMenuEvents_1.BetlevelMenuEvents.BET_VALUE_UPDATED, this.onBetValueUpdated);
        this.onCurrentStateHandle(InfoEvents_1.InfoEvents.UPDATE);
        this.onCurrentStateHandle(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_SKIPPED);
        this.onCurrentStateHandle(WinPresentationEvents_1.WinPresentationEvents.INDIVIDUAL_ANIMATION_SKIPPED);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_INTRO_STARTED, this.onFreeSpinsStarted);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_OUTRO_FINISHED, this.onFreeSpinsFinished);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.SHOWING_WIN_SUMMARY_SCREEN, this.onShowingFinalFreeSpinValue);
    };
    InfoModule.prototype.preSpinBalanceUpdate = function () {
        var logic = this.logic;
        if (!!!logic.freeRoundsData) {
            var balance = logic.preSpinBalance;
            var betValue = logic.betValue;
            var newBalance = balance - betValue;
            if (newBalance >= 0) {
                this.view.setBalance(newBalance);
            }
        }
    };
    InfoModule.prototype.clearWin = function () {
        this._lastWin = 0;
        this.view.setWins(0);
    };
    InfoModule.prototype.updateWin = function (win) {
        if (!this._shownWin && win === 0) {
            this._shownWin = true;
            win = this._lastWin;
            return;
        }
        this._lastWin = win;
        this.view.setWins(win);
    };
    InfoModule.prototype.updateBalance = function () {
        var balance = this.logic.currentBalance;
        this.view.setBalance(balance);
    };
    InfoModule.prototype.updateBet = function () {
        var bet = this.logic.getTotalBet();
        this.view.setBet(bet);
    };
    InfoModule.prototype.setupStates = function () {
        this.addState(new InfoModuleBasicState_1.InfoModuleBasicState(this, InfoModule.BASIC));
        this.addState(new InfoModuleFreeSpinsState_1.InfoModuleFreeSpinsState(this, InfoModule.FREESPINS));
    };
    InfoModule.prototype.enterFirstState = function () {
        this.changeStateTo(InfoModule.BASIC);
    };
    InfoModule.prototype.setupViews = function () {
        if (this.system.shouldUseMultipleViews()) {
            this.setView(Views_1.Views.INFO_VIEW_MOBILE);
        }
        else {
            this.setView(Views_1.Views.INFO_VIEW);
        }
    };
    InfoModule.prototype.onShowingFinalFreeSpinValue = function () {
        if (!this.logic.hasRestore) {
            this.view.setBalance(this.logic.currentBalance);
        }
        this.updateBalance();
    };
    InfoModule.prototype.onFreeSpinsStarted = function () {
        this.gotoState(InfoModule.FREESPINS);
    };
    InfoModule.prototype.onFreeSpinsFinished = function () {
        this.gotoState(InfoModule.BASIC);
    };
    InfoModule.prototype.onBetValueUpdated = function () {
        this.updateBet();
        if (!this.logic.hasRestore) {
            this.clearWin();
        }
    };
    InfoModule.prototype.onViewToggleAllSoundOff = function (eventId, clicked) {
        if (clicked === void 0) { clicked = true; }
        this.eventManager.emit(InfoEvents_1.InfoEvents.TOGGLE_ALL_SOUND_OFF, clicked);
    };
    InfoModule.prototype.onViewToggleAllSoundOn = function (eventId, clicked) {
        if (clicked === void 0) { clicked = true; }
        this.eventManager.emit(InfoEvents_1.InfoEvents.TOGGLE_ALL_SOUND_ON, clicked);
    };
    InfoModule.prototype.onToggleAllSoundsOff = function () { };
    InfoModule.prototype.onToggleAllSoundsOn = function () { };
    InfoModule.prototype.onToggleMusicOn = function () {
        if (!this.logic.soundAllActive) {
            this.view.setSoundButtonStatus(false, false);
            this.onViewToggleAllSoundOn(null, false);
        }
    };
    InfoModule.prototype.onToggleVoiceOn = function () {
        if (!this.logic.soundAllActive) {
            this.view.setSoundButtonStatus(false, false);
            this.onViewToggleAllSoundOn(null, false);
        }
    };
    InfoModule.prototype.onToggleSoundEffectsOn = function () {
        if (!this.logic.soundAllActive) {
            this.view.setSoundButtonStatus(false, false);
            this.onViewToggleAllSoundOn(null, false);
        }
    };
    InfoModule.prototype.onToggleMusicOff = function () {
        if (this.logic.soundAllActive && !this.voiceActive && !this.soundActive) {
            this.view.setSoundButtonStatus(true, true);
            this.onViewToggleAllSoundOff(null, false);
        }
    };
    InfoModule.prototype.onToggleVoiceOff = function () {
        if (this.logic.soundAllActive && !this.soundActive && !this.musicActive) {
            this.view.setSoundButtonStatus(true, true);
            this.onViewToggleAllSoundOff(null, false);
        }
    };
    InfoModule.prototype.onToggleSoundEffectsOff = function () {
        var voiceActive = this.device.isMobile ? false : this.voiceActive;
        if (this.logic.soundAllActive && !this.musicActive && !voiceActive) {
            this.view.setSoundButtonStatus(true, true);
            this.onViewToggleAllSoundOff(null, false);
        }
    };
    InfoModule.prototype.onStartScreenExitFinished = function () {
        this.view.playEntryAnimation();
    };
    InfoModule.prototype.onBetlevelMenuOpened = function () { };
    InfoModule.prototype.onBetlevelMenuClosed = function () { };
    InfoModule.prototype.onAutoplayMenuOpened = function () { };
    InfoModule.prototype.onAutoplayMenuClosed = function () { };
    InfoModule.prototype.onMainMenuOpen = function () { };
    InfoModule.prototype.onMainMenuClosed = function () { };
    InfoModule.prototype.onBonusGameEnd = function () { };
    InfoModule.prototype.onBonusGameStart = function () { };
    Object.defineProperty(InfoModule.prototype, "voiceActive", {
        get: function () {
            // This option doesn't exist on mobile.
            return this.device.isMobile ? this.logic.soundEffectsActive : this.logic.voiceActive;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfoModule.prototype, "soundActive", {
        get: function () {
            return this.logic.soundEffectsActive;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfoModule.prototype, "musicActive", {
        get: function () {
            return this.logic.musicActive;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfoModule.prototype, "lastWin", {
        get: function () {
            return this._lastWin;
        },
        set: function (value) {
            this._lastWin = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfoModule.prototype, "shownWin", {
        get: function () {
            return this._shownWin;
        },
        set: function (value) {
            this._shownWin = value;
        },
        enumerable: true,
        configurable: true
    });
    InfoModule.BASIC = 'basic';
    InfoModule.FREESPINS = 'freespins';
    InfoModule.MULTILINES_COUNTER_DURATION = 500;
    InfoModule.WIN_CLEAR_DELAY = 500;
    return InfoModule;
}(Module_1.Module));
exports.InfoModule = InfoModule;


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var InfoViewEvents = /** @class */ (function () {
    function InfoViewEvents() {
    }
    InfoViewEvents.WIN_UPDATED = 'InfoViewEvents::WIN_UPDATED';
    InfoViewEvents.BET_UPDATED = 'InfoViewEvents::BET_UPDATED';
    InfoViewEvents.BALANCE_UPDATED = 'InfoViewEvents::BALANCE_UPDATED';
    InfoViewEvents.TIME_UPDATED = 'InfoViewEvents::TIME_UPDATED';
    InfoViewEvents.TEXT_INITIALIZED = 'InfoViewEvents::TEXT_INITIALIZED';
    InfoViewEvents.TOGGLE_ALL_SOUND_OFF = 'InfoViewEvents::TOGGLE_ALL_SOUND_OFF';
    InfoViewEvents.TOGGLE_ALL_SOUND_ON = 'InfoViewEvents::TOGGLE_ALL_SOUND_ON';
    return InfoViewEvents;
}());
exports.InfoViewEvents = InfoViewEvents;


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var InfoModuleBasicState_1 = __webpack_require__(161);
var InfoModuleFreeSpinsState = /** @class */ (function (_super) {
    __extends(InfoModuleFreeSpinsState, _super);
    function InfoModuleFreeSpinsState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InfoModuleFreeSpinsState.prototype.onEnterState = function () {
        _super.prototype.onEnterState.call(this);
    };
    InfoModuleFreeSpinsState.prototype.onLeaveState = function () {
        _super.prototype.onLeaveState.call(this);
    };
    InfoModuleFreeSpinsState.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
    };
    InfoModuleFreeSpinsState.prototype.onInitResponse = function () {
        this.updateBalance(this.module.logic.currentBalance);
        this.updateBet();
    };
    InfoModuleFreeSpinsState.prototype.onAllReelsStopped = function () {
    };
    InfoModuleFreeSpinsState.prototype.onSpinButtonPressed = function () {
    };
    InfoModuleFreeSpinsState.prototype.onSpinButtonPressedNotEnoughMoney = function () {
    };
    InfoModuleFreeSpinsState.prototype.onWinPresentationStopped = function () {
    };
    InfoModuleFreeSpinsState.prototype.onSpinResponse = function () {
    };
    InfoModuleFreeSpinsState.prototype.onWinNumberShownToPlayer = function () {
        this.updateData();
    };
    InfoModuleFreeSpinsState.prototype.onInitialWinPresentationStarted = function () {
    };
    InfoModuleFreeSpinsState.prototype.onWinCountupFinished = function () {
        this.updateData();
    };
    InfoModuleFreeSpinsState.prototype.updateData = function () {
        var win = this.module.logic.freeSpinsTotalWin;
        this.updateWin(win);
    };
    InfoModuleFreeSpinsState.prototype.onBigWinFinished = function () {
        this.updateData();
    };
    InfoModuleFreeSpinsState.prototype.onNoWin = function () {
    };
    return InfoModuleFreeSpinsState;
}(InfoModuleBasicState_1.InfoModuleBasicState));
exports.InfoModuleFreeSpinsState = InfoModuleFreeSpinsState;


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var InfoModuleBasicState_1 = __webpack_require__(161);
var FlowModuleEvents_1 = __webpack_require__(0);
var RecodeInfoModuleBasicState = /** @class */ (function (_super) {
    __extends(RecodeInfoModuleBasicState, _super);
    function RecodeInfoModuleBasicState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RecodeInfoModuleBasicState.prototype.restoreRoundWin = function () {
        var logic = this.module.logic;
        this.updateWin(logic.getTransTotalWin());
    };
    RecodeInfoModuleBasicState.prototype.onSpinButtonPressed = function () {
        _super.prototype.onSpinButtonPressed.call(this);
        this.module.spinCumulativeWins = 0;
    };
    RecodeInfoModuleBasicState.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(FlowModuleEvents_1.FlowModuleEvents.WON_BIG_WIN, this.onWonBigWin);
    };
    RecodeInfoModuleBasicState.prototype.onBigWinFinished = function () {
        var win = this.module.spinCumulativeWins + this.module.logic.getNextSpinWin();
        this.updateWin(win);
    };
    RecodeInfoModuleBasicState.prototype.onSpinResponse = function () {
        var logic = this.module.logic;
        if (!logic.isInFreeRounds) {
            this.module.preSpinBalanceUpdate();
            this.module.clearWin();
        }
    };
    RecodeInfoModuleBasicState.prototype.onInitResponse = function () {
        if (this.module.logic.hasRestore) {
            var lastRoundWin = this.module.logic.getWin();
            // Should not go to negative balance.
            var newBalance = Math.max(0, this.module.logic.currentBalance - lastRoundWin);
            this.updateBalance(newBalance);
        }
        else {
            this.updateBalance(this.module.logic.currentBalance);
        }
        this.updateBet();
        this.updateWin(0);
    };
    RecodeInfoModuleBasicState.prototype.onCanSpin = function () {
        if (!this.module.logic.hasRestore) {
            this.updateWin(this.module.lastWin);
        }
        this.updateBalance(this.module.logic.currentBalance);
    };
    RecodeInfoModuleBasicState.prototype.onWonBigWin = function () { };
    RecodeInfoModuleBasicState.prototype.onNoWin = function () { };
    return RecodeInfoModuleBasicState;
}(InfoModuleBasicState_1.InfoModuleBasicState));
exports.RecodeInfoModuleBasicState = RecodeInfoModuleBasicState;


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var InfoModuleFreeSpinsState_1 = __webpack_require__(291);
var FlowModuleEvents_1 = __webpack_require__(0);
var LogicEvents_1 = __webpack_require__(11);
var RecodeInfoModuleFreeSpinsState = /** @class */ (function (_super) {
    __extends(RecodeInfoModuleFreeSpinsState, _super);
    function RecodeInfoModuleFreeSpinsState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RecodeInfoModuleFreeSpinsState.prototype.onLeaveState = function () {
        _super.prototype.onLeaveState.call(this);
        this.module.spinCumulativeWins = 0;
    };
    RecodeInfoModuleFreeSpinsState.prototype.onEnterState = function () {
        _super.prototype.onEnterState.call(this);
        var logic = this.module.logic;
        if (this.module.logic.freeSpinsPlayed === 0) {
            this.module.spinCumulativeWins = 0;
        }
        else {
            this.module.spinCumulativeWins = logic.getTransTotalWin() - this.module.logic.getWin();
        }
    };
    RecodeInfoModuleFreeSpinsState.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN, this.onCanSpin);
        this.on(LogicEvents_1.LogicEvents.SPIN_RESPONSE, this.onSpinResponse);
    };
    RecodeInfoModuleFreeSpinsState.prototype.onSpinResponse = function () { };
    RecodeInfoModuleFreeSpinsState.prototype.onNoWin = function () { };
    RecodeInfoModuleFreeSpinsState.prototype.onBigWinFinished = function () {
        var logic = this.module.logic;
        var win = logic.getTransTotalWin();
        // this.updateBalance(this.module.logic.currentBalance); should not update balance in free spins
        this.updateWin(win);
    };
    RecodeInfoModuleFreeSpinsState.prototype.onInitResponse = function () {
        var logic = this.module.logic;
        var newBalance = Math.max(0, this.module.logic.currentBalance - logic.getTransTotalWin());
        if (this.module.logic.hasRestore) {
            this.updateBalance(newBalance);
        }
        else {
            this.updateBalance(newBalance);
            this.updateWin(logic.getTransTotalWin());
        }
        this.updateBet();
    };
    RecodeInfoModuleFreeSpinsState.prototype.onWinNumberShownToPlayer = function () {
        var logic = this.module.logic;
        var win = logic.getTransTotalWin();
        this.updateWin(win);
    };
    return RecodeInfoModuleFreeSpinsState;
}(InfoModuleFreeSpinsState_1.InfoModuleFreeSpinsState));
exports.RecodeInfoModuleFreeSpinsState = RecodeInfoModuleFreeSpinsState;


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var View_1 = __webpack_require__(3);
var WinNumbers_1 = __webpack_require__(45);
var GameReelConstants_1 = __webpack_require__(34);
var Tween_1 = __webpack_require__(19);
var Easing_1 = __webpack_require__(16);
var TimingConstants_1 = __webpack_require__(158);
var BackgroundView_1 = __webpack_require__(91);
var WildMeterView = /** @class */ (function (_super) {
    __extends(WildMeterView, _super);
    function WildMeterView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._currentCoinsOnMeter = 0;
        _this._currentMultiplierValue = 1;
        _this._wildCoinsOnReels = [];
        _this._currentCoinFlyingIndex = 0;
        _this._isInFreeSpins = false;
        return _this;
    }
    WildMeterView.prototype.init = function () {
        _super.prototype.init.call(this);
        this._meterLayer = new PIXI.Container();
        this.container.addChild(this._meterLayer);
        this._multiplierNumberLayer = new PIXI.Container();
        this.container.addChild(this._multiplierNumberLayer);
        this._meter = this.spineUtils.startSpineAnimationCreation('WILD_MULTIPLIER_METER.json', 'STAGE_00_IDLE', true)
            .position(this.layout.getAbsolutePosition('MULTIPLIER_METER'))
            .container(this._meterLayer)
            .createMultitrack();
        this.playMultiplierIdleAnimation();
        this._multiplier = this.spineUtils.startSpineAnimationCreation('WILD_MULTIPLIER.json', 'IDLE', true)
            .position(this.layout.getAbsolutePosition('MULTIPLIER_METER'))
            .container(this._multiplierNumberLayer)
            .createAndStart();
        this.setMultiplierValue(1);
    };
    WildMeterView.prototype.playMultiplierIdleAnimation = function (lvl) {
        if (lvl === void 0) { lvl = 0; }
        this._meter.play("IDLE_0" + lvl, 1, true);
    };
    WildMeterView.prototype.setMultiplierValue = function (value, forNewNumber, isFlyingWin) {
        if (forNewNumber === void 0) { forNewNumber = false; }
        if (isFlyingWin === void 0) { isFlyingWin = false; }
        var multiplierNumber = new WinNumbers_1.WinNumbers(this.resources, value === 1 ? 'MULTIPLIER_SILVER_' : 'MULTIPLIER_');
        multiplierNumber.numberAnchor = { x: 0, y: 0.5 };
        multiplierNumber.autoCenterMyself = true;
        multiplierNumber.additionalOffset = -30;
        multiplierNumber.numberKerning = -15;
        multiplierNumber.showNumber("x" + value.toString());
        var multiplier = isFlyingWin ? this._flyingWin : this._multiplier;
        this.spineUtils.replaceElementInSpineAnimation(multiplier, forNewNumber ? 'MULTIPLIER_NUMBER_NEW' : 'MULTIPLIER_NUMBER_OLD', multiplierNumber);
        multiplierNumber.position.x = -30;
    };
    WildMeterView.prototype.playMultiplierTransition = function (fromValue, toValue, isSecond, onCompleted) {
        var _this = this;
        if (isSecond === void 0) { isSecond = false; }
        this.killMultiplier();
        this.checkIfMultiplierIdleShouldBeUpdated(toValue);
        this._multiplier = this.spineUtils.startSpineAnimationCreation('WILD_MULTIPLIER.json', 'TRANSITION', false)
            .position(this.layout.getAbsolutePosition('MULTIPLIER_METER'))
            .chainIdleAnimation('IDLE')
            .container(this._multiplierNumberLayer)
            .onComplete(function () {
            _this.setMultiplierValue(toValue);
            onCompleted && onCompleted();
        })
            .createAndStart();
        isSecond && this._multiplier.gotoAnimationFrame(15);
        this.setMultiplierValue(fromValue);
        this.setMultiplierValue(toValue, true);
    };
    WildMeterView.prototype.checkIfMultiplierIdleShouldBeUpdated = function (toValue) {
        if (WildMeterView.MP_LVL_TO_UPGRADE_IDLE.indexOf(toValue) === -1) {
            return;
        }
        this.updateMultiplierIdleAnimation(toValue);
    };
    WildMeterView.prototype.updateMultiplierIdleAnimation = function (toValue) {
        var _this = this;
        var to = (Math.min(Math.round(toValue / 2), WildMeterView.MAX_IDLE_LVL));
        var idle = (Math.min(Math.round(toValue / 2), WildMeterView.MAX_IDLE_LVL));
        this._meter.play("UPPDATE_0" + (to - 1) + "_TO_0" + to, 1, false)
            .setTrackOnCompleteCallback(1, function () {
            return _this.playMultiplierIdleAnimation(idle);
        });
    };
    WildMeterView.prototype.playWinAimation = function () {
        var _this = this;
        this._flyingWin =
            this.spineUtils.startSpineAnimationCreation('WILD_MULTIPLIER.json', 'EXIT_WIN', false)
                .position(this.layout.getAbsolutePosition('MULTIPLIER_METER'))
                .container(this._multiplierNumberLayer)
                .onComplete(function () {
                _this._flyingWin = null;
                _this.emit(WildMeterView.WIN_METER_EXIT_WIN_ANIMATION_FINISHED);
            })
                .createAndStart();
        this.emit(WildMeterView.WIN_METER_EXIT_WIN_ANIMATION_STARTED);
    };
    WildMeterView.prototype.restoreLastMultiplier = function () {
        this.restoreMultiplier(this._currentMultiplierValue);
    };
    WildMeterView.prototype.restoreMultiplier = function (toValue) {
        if (toValue === void 0) { toValue = 1; }
        this.killMultiplier();
        if (!this._multiplier) {
            this._multiplier = this.spineUtils.startSpineAnimationCreation('WILD_MULTIPLIER.json', 'ENTER', false)
                .position(this.layout.getAbsolutePosition('MULTIPLIER_METER'))
                .container(this._multiplierNumberLayer)
                .chainIdleAnimation('IDLE')
                .createAndStart();
        }
        this.setMultiplierValue(toValue);
    };
    WildMeterView.prototype.addCoin = function (onCompleted, targetCoinOnMeter) {
        var _this = this;
        this._meter.play("TRANSITION_0" + (targetCoinOnMeter - 1) + "_TO_0" + targetCoinOnMeter, 0, false)
            .setTrackOnCompleteCallback(0, function () {
            if (targetCoinOnMeter >= 3) {
                _this.timeUtils.createTimer(function () {
                    _this._meter.play('STAGE_00_IDLE', 0, true);
                }, 700);
            }
            else {
                _this._meter.play("STAGE_0" + targetCoinOnMeter + "_IDLE", 0, true);
            }
            _this.timeUtils.createTimer(function () {
                if (targetCoinOnMeter === 3) {
                    if (_this._isInFreeSpins) {
                        _this.playMultiplierTransitionIncremented();
                        _this.timeUtils.createTimer(function () {
                            _this.playMultiplierTransitionIncremented(function () {
                                onCompleted && onCompleted();
                            }, true);
                        }, 670);
                    }
                    else {
                        _this.playMultiplierTransitionIncremented(function () {
                            onCompleted && onCompleted();
                        });
                    }
                    _this.emit(WildMeterView.MULTIPLIER_UDPATE);
                    _this._currentCoinsOnMeter = 0;
                }
                else {
                    onCompleted && onCompleted();
                }
            }, TimingConstants_1.TimingConstants.ADD_COIN_COMPLETE_DELAY);
        });
        this.emit(WildMeterView.INDICATOR_LIT);
    };
    WildMeterView.prototype.playMultiplierTransitionIncremented = function (onCompleted, isSecond) {
        if (onCompleted === void 0) { onCompleted = null; }
        if (isSecond === void 0) { isSecond = false; }
        this.playMultiplierTransition(this._currentMultiplierValue, this._currentMultiplierValue + 1, isSecond, function () {
            onCompleted && onCompleted();
        });
        this._currentMultiplierValue++;
    };
    WildMeterView.prototype.resetCoins = function () {
        var _this = this;
        if (this._currentCoinsOnMeter === 1) {
            this._meter.play('EXIT_01', 0, false)
                .setTrackOnCompleteCallback(0, function () {
                _this._meter.play('STAGE_00_IDLE');
            });
        }
        if (this._currentCoinsOnMeter === 2) {
            this._meter.play('EXIT_02', 0, false)
                .setTrackOnCompleteCallback(0, function () {
                _this._meter.play('STAGE_00_IDLE');
            });
        }
        this._currentCoinsOnMeter = 0;
        this._currentMultiplierValue = 1;
        this._currentCoinFlyingIndex = 0;
        this.cleanupCoins();
    };
    WildMeterView.prototype.cleanupCoins = function () {
        for (var _i = 0, _a = this._wildCoinsOnReels; _i < _a.length; _i++) {
            var coin = _a[_i];
            if (coin.animation) {
                this.spineUtils.stopAndDestroyAnimation(coin.animation);
            }
        }
        this._wildCoinsOnReels = [];
    };
    WildMeterView.prototype.addWildCoinOntoReels = function (symbolPosition) {
        var animation = this.spineUtils.startSpineAnimationCreation('WILD_SOUL.json', 'ENTER', false)
            .chainIdleAnimation('IDLE')
            .position(GameReelConstants_1.GameReelConstants.getGameSymbolCenterPosition(symbolPosition))
            .createAndStart();
        this._wildCoinsOnReels.push({ animation: animation, symbolPosition: symbolPosition });
        this.emit(WildMeterView.ADD_WILD_COIN_TO_REELS);
    };
    WildMeterView.prototype.startSendingCoinsToWildMeter = function () {
        this.sortCoinsToBeSent();
        this.sendNextBatch(this._currentCoinFlyingIndex, this.onCoinAddingFinished.bind(this));
    };
    WildMeterView.prototype.sortCoinsToBeSent = function () {
        var wildCoinsToSort = this._wildCoinsOnReels.splice(this._currentCoinFlyingIndex);
        var vesselPos = this.device.isMobile ? { x: 4, y: 6 } : { x: -1, y: 3 };
        wildCoinsToSort.sort(function (a, b) {
            var aDist = Math.hypot(vesselPos.x - a.symbolPosition.x, vesselPos.y - a.symbolPosition.y);
            var bDist = Math.hypot(vesselPos.x - b.symbolPosition.x, vesselPos.y - b.symbolPosition.y);
            return aDist - bDist;
        });
        this._wildCoinsOnReels = this._wildCoinsOnReels.concat(wildCoinsToSort);
    };
    WildMeterView.prototype.onCoinAddingFinished = function () {
        var _this = this;
        if (this._currentCoinFlyingIndex >= this._wildCoinsOnReels.length) {
            this.timeUtils.createTimer(function () {
                _this.emit(WildMeterView.WIN_METER_WILDS_ANIMATIONS_FINISHED);
            }, TimingConstants_1.TimingConstants.SEND_COINS_COMPLETE_DELAY);
        }
        else {
            this.sendNextBatch(this._currentCoinFlyingIndex, this.onCoinAddingFinished.bind(this));
        }
    };
    WildMeterView.prototype.sendNextBatch = function (coinIndex, onComplete) {
        var _this = this;
        var numCoinsToSend = Math.min(this._wildCoinsOnReels.length - coinIndex, 3 - this._currentCoinsOnMeter);
        var delay = 0;
        var _loop_1 = function (i) {
            this_1.timeUtils.createTimer(function () {
                var targetCoinOnMeter = _this._currentCoinsOnMeter + 1;
                _this.sendNextCoin(coinIndex + i, targetCoinOnMeter, (i === numCoinsToSend - 1) ? onComplete : null);
                _this._currentCoinsOnMeter++;
            }, delay);
            delay += TimingConstants_1.TimingConstants.SEND_COIN_STAGGER_DELAY;
        };
        var this_1 = this;
        for (var i = 0; i < numCoinsToSend; i++) {
            _loop_1(i);
        }
        this._currentCoinFlyingIndex += numCoinsToSend;
    };
    WildMeterView.prototype.sendNextCoin = function (coinIndex, targetCoinOnMeter, onComplete) {
        var _this = this;
        var meterPosition = this.layout.getAbsolutePosition("MULTIPLIER_METER");
        /* TODO Hookup to position in spine when that exists */
        if (this.device.isMobile) {
            meterPosition.y += 2;
            meterPosition.x += 91;
        }
        else {
            meterPosition.y -= 91;
            meterPosition.x += 4;
        }
        var currentCoin = this._wildCoinsOnReels[coinIndex];
        this.spineUtils.stopAndDestroyAnimation(currentCoin.animation);
        currentCoin.animation = null;
        currentCoin.animation = this.spineUtils.startSpineAnimationCreation('WILD_SOUL.json', 'BOUNCE', true)
            .position(GameReelConstants_1.GameReelConstants.getGameSymbolCenterPosition(currentCoin.symbolPosition))
            .createAndStart();
        var movingTween = new Tween_1.Tween(currentCoin.animation.container.position)
            .to({ x: meterPosition.x, y: meterPosition.y }, 400).easing(Easing_1.Easing.Quintic.In)
            .onComplete(function () {
            _this.spineUtils.stopAndDestroyAnimation(currentCoin.animation);
            coinIndex === 0 && _this._currentMultiplierValue === 1 && _this.playMultiplierIdleAnimation(_this._currentMultiplierValue);
            currentCoin.animation = null;
            currentCoin.animation = _this.spineUtils.startSpineAnimationCreation('WILD_SOUL.json', 'EXIT', false)
                .position(meterPosition)
                .createAndStart();
            _this.addCoin(onComplete, targetCoinOnMeter);
            _this.emit(WildMeterView.COIN_HIT_METER);
        })
            .start();
        this.updateManager.add(movingTween);
        this.emit(WildMeterView.SEND_COIN_TO_METER);
    };
    WildMeterView.prototype.killMeter = function () {
        if (this._meter) {
            this.spineUtils.stopAndDestroyAnimation(this._meter);
            this._meter = null;
        }
    };
    WildMeterView.prototype.killMultiplier = function () {
        if (this._multiplier) {
            this.spineUtils.stopAndDestroyAnimation(this._multiplier);
            this._multiplier = null;
        }
    };
    WildMeterView.prototype.clearMultiplier = function () {
        if (this._currentMultiplierValue > 1 && this._multiplierNumberLayer) {
            this.killMultiplier();
            this._multiplierNumberLayer.removeChildren();
        }
    };
    WildMeterView.prototype.resetMultiplierIdleAnimation = function () {
        this.playMultiplierIdleAnimation();
    };
    WildMeterView.prototype.fullMultiplierRestore = function () {
        if (this._currentMultiplierValue > 1) {
            this.clearMultiplier();
            this.restoreMultiplier();
        }
        this.resetCoins();
        this.resetMultiplierIdleAnimation();
    };
    Object.defineProperty(WildMeterView.prototype, "isInFreeSpins", {
        set: function (value) {
            this._isInFreeSpins = value;
        },
        enumerable: true,
        configurable: true
    });
    WildMeterView.prototype.updateCoinsOnMeter = function (value) {
        this._currentCoinsOnMeter = value;
        this.addCoin(null, this._currentCoinsOnMeter);
    };
    Object.defineProperty(WildMeterView.prototype, "currentMultiplierValue", {
        set: function (value) {
            this._currentMultiplierValue = value;
        },
        enumerable: true,
        configurable: true
    });
    WildMeterView.prototype.setReelsContainerAlphaToZero = function () {
        this.container.alpha = 0;
    };
    WildMeterView.prototype.playReelContainerTransition = function () {
        var appearTween = new Tween_1.Tween(this.container)
            .to({ alpha: 1.0 }, BackgroundView_1.BackgroundView.TRANSFER_TIME)
            .start();
        this.updateManager.add(appearTween);
    };
    WildMeterView.WIN_METER_WILDS_ANIMATIONS_FINISHED = 'WildMeterView::WIN_METER_WILDS_ANIMATIONS_FINISHED';
    WildMeterView.WIN_METER_EXIT_WIN_ANIMATION_STARTED = 'WildMeterView::WIN_METER_EXIT_WIN_ANIMATION_STARTED';
    WildMeterView.WIN_METER_EXIT_WIN_ANIMATION_FINISHED = 'WildMeterView::WIN_METER_EXIT_WIN_ANIMATION_FINISHED';
    WildMeterView.ADD_WILD_COIN_TO_REELS = 'WildMeterView::ADD_WILD_COIN_TO_REELS';
    WildMeterView.SEND_COIN_TO_METER = 'WildMeterView::SEND_COIN_TO_METER';
    WildMeterView.COIN_HIT_METER = 'WildMeterView::COIN_HIT_METER';
    WildMeterView.MULTIPLIER_UDPATE = 'WildMeterView::MULTIPLIER_UDPATE';
    WildMeterView.INDICATOR_LIT = 'WildMeterView::INDICATOR_LIT';
    WildMeterView.MAX_IDLE_LVL = 5;
    WildMeterView.MP_LVL_TO_UPGRADE_IDLE = [3, 5, 7, 9];
    return WildMeterView;
}(View_1.View));
exports.WildMeterView = WildMeterView;


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BigWinModule_1 = __webpack_require__(96);
var GameBigWinPlayingState_1 = __webpack_require__(298);
var GameBigWinPlayingMultiplierState_1 = __webpack_require__(578);
var GameBigWinBasicState_1 = __webpack_require__(579);
var GameBigWinModule = /** @class */ (function (_super) {
    __extends(GameBigWinModule, _super);
    function GameBigWinModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameBigWinModule.prototype.setupStates = function () {
        _super.prototype.setupStates.call(this);
        this.addState(new GameBigWinPlayingState_1.GameBigWinPlayingState(this, BigWinModule_1.BigWinModule.PLAYING_STATE));
        this.addState(new GameBigWinPlayingMultiplierState_1.GameBigWinPlayingMultiplierState(this, GameBigWinModule.PLAYINGMULTIPLIER_STATE));
        this.addState(new GameBigWinBasicState_1.GameBigWinBasicState(this, BigWinModule_1.BigWinModule.BASIC_STATE));
    };
    GameBigWinModule.PLAYINGMULTIPLIER_STATE = 'playingmultiplier';
    return GameBigWinModule;
}(BigWinModule_1.BigWinModule));
exports.GameBigWinModule = GameBigWinModule;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var BigWinModule_1 = __webpack_require__(96);
var FlowModuleEvents_1 = __webpack_require__(0);
var BigWinBasicState = /** @class */ (function (_super) {
    __extends(BigWinBasicState, _super);
    function BigWinBasicState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BigWinBasicState.prototype.onEnterState = function () {
        this.view.hide();
    };
    BigWinBasicState.prototype.onLeaveState = function () {
    };
    BigWinBasicState.prototype.setupEvents = function () {
        this.on(FlowModuleEvents_1.FlowModuleEvents.WON_BIG_WIN, this.onBigWinWon);
    };
    BigWinBasicState.prototype.onBigWinWon = function () {
        this.module.gotoState(BigWinModule_1.BigWinModule.PLAYING_STATE);
    };
    return BigWinBasicState;
}(ModuleState_1.ModuleState));
exports.BigWinBasicState = BigWinBasicState;


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var WinUtils_1 = __webpack_require__(58);
var BigWinEvents_1 = __webpack_require__(21);
var BigWinModule_1 = __webpack_require__(96);
var BigWinView_1 = __webpack_require__(119);
var BigWinPlayingState = /** @class */ (function (_super) {
    __extends(BigWinPlayingState, _super);
    function BigWinPlayingState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BigWinPlayingState.prototype.onEnterState = function () {
        var _this = this;
        this.emit(BigWinEvents_1.BigWinEvents.ON_BEFORE_BIG_WIN);
        this.module.timeUtils.createTimer(function () {
            var win = _this.module.logic.getSpinResult().spinWin;
            _this.view.start(win, _this.getBigWinLevelFromWinNumber(win));
            _this.emit(BigWinEvents_1.BigWinEvents.STARTED);
            _this.emit(BigWinEvents_1.BigWinEvents.COUNTUP_STARTED);
        }, BigWinPlayingState.BEFORE_BIG_WIN_PAUSE);
    };
    BigWinPlayingState.prototype.onLeaveState = function () { };
    BigWinPlayingState.prototype.setupEvents = function () {
        this.on(BigWinView_1.BigWinView.SKIP_CLICKED, this.onSkipClicked);
        this.on(BigWinView_1.BigWinView.METER_FINISHED, this.onMeterFinished);
    };
    BigWinPlayingState.prototype.getBigWinLevelFromWinNumber = function (win) {
        if (win >= this.module.logic.getTotalBet() * BigWinPlayingState.LEVEL4_TRESHOLD) {
            return 4;
        }
        if (win >= this.module.logic.getTotalBet() * BigWinPlayingState.LEVEL3_TRESHOLD && win < this.module.logic.getTotalBet() * BigWinPlayingState.LEVEL4_TRESHOLD) {
            return 3;
        }
        if (win >= this.module.logic.getTotalBet() * BigWinPlayingState.LEVEL2_TRESHOLD && win < this.module.logic.getTotalBet() * BigWinPlayingState.LEVEL3_TRESHOLD) {
            return 2;
        }
        return 1;
    };
    BigWinPlayingState.prototype.onSkipClicked = function () {
        this.view.skipCounting();
    };
    BigWinPlayingState.prototype.onMeterFinished = function () {
        this.module.gotoState(BigWinModule_1.BigWinModule.FINAL_STATE);
    };
    BigWinPlayingState.prototype.getBigWinLevel = function () {
        if (WinUtils_1.WinUtils.inBigWinEpicWin(this.module.logic)) {
            return 4;
        }
        if (WinUtils_1.WinUtils.inBigWinMegaWin(this.module.logic)) {
            return 3;
        }
        if (WinUtils_1.WinUtils.inBigWinSuperWin(this.module.logic)) {
            return 2;
        }
        return 1;
    };
    BigWinPlayingState.LEVEL4_TRESHOLD = 100;
    BigWinPlayingState.LEVEL3_TRESHOLD = 70;
    BigWinPlayingState.LEVEL2_TRESHOLD = 40;
    BigWinPlayingState.BEFORE_BIG_WIN_PAUSE = 800;
    return BigWinPlayingState;
}(ModuleState_1.ModuleState));
exports.BigWinPlayingState = BigWinPlayingState;


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BigWinPlayingState_1 = __webpack_require__(297);
var BigWinEvents_1 = __webpack_require__(21);
var GameBigWinPlayingState = /** @class */ (function (_super) {
    __extends(GameBigWinPlayingState, _super);
    function GameBigWinPlayingState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameBigWinPlayingState.prototype.onEnterState = function () {
        var _this = this;
        this.emit(BigWinEvents_1.BigWinEvents.ON_BEFORE_BIG_WIN);
        this.module.timeUtils.createTimer(function () {
            var logic = _this.module.logic;
            var win = logic.currentSpinWin;
            _this.view.start(win, _this.getBigWinLevelFromWinNumber(win));
            _this.emit(BigWinEvents_1.BigWinEvents.STARTED);
            _this.emit(BigWinEvents_1.BigWinEvents.COUNTUP_STARTED);
        }, BigWinPlayingState_1.BigWinPlayingState.BEFORE_BIG_WIN_PAUSE);
    };
    return GameBigWinPlayingState;
}(BigWinPlayingState_1.BigWinPlayingState));
exports.GameBigWinPlayingState = GameBigWinPlayingState;


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var FreeSpinsEvents_1 = __webpack_require__(6);
var FreeSpinsModule_1 = __webpack_require__(97);
var FreeSpinsView_1 = __webpack_require__(120);
var ReelsEvents_1 = __webpack_require__(4);
var AvalancheReelsEvents_1 = __webpack_require__(15);
var FreeSpinsOutroState = /** @class */ (function (_super) {
    __extends(FreeSpinsOutroState, _super);
    function FreeSpinsOutroState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FreeSpinsOutroState.prototype.onEnterState = function () {
        this.emit(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_OUTRO_STARTED);
    };
    FreeSpinsOutroState.prototype.onLeaveState = function () {
        this.emit(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_OUTRO_FINISHED);
    };
    FreeSpinsOutroState.prototype.freeSpinsOutroFinished = function () {
        this.module.gotoState(FreeSpinsModule_1.FreeSpinsModule.BASIC_STATE);
    };
    FreeSpinsOutroState.prototype.setupEvents = function () {
        this.on(FreeSpinsView_1.FreeSpinsView.FREE_SPINS_OUTRO_FINISHED, this.freeSpinsOutroFinished);
        this.on(ReelsEvents_1.ReelsEvents.REELS_FADING_OUT_FINISHED, this.onReelsFadingOutFinished);
        this.on(AvalancheReelsEvents_1.AvalancheReelsEvents.REELS_FADING_OUT_FINISHED, this.onReelsFadingOutFinished);
    };
    FreeSpinsOutroState.prototype.onReelsFadingOutFinished = function () {
        var freeSpinTotalWin = this.module.logic.freeSpinsTotalWin;
        this.view.showWinSummaryScreen(freeSpinTotalWin * 100);
    };
    return FreeSpinsOutroState;
}(ModuleState_1.ModuleState));
exports.FreeSpinsOutroState = FreeSpinsOutroState;


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var ClientRequest = __webpack_require__(590)
var response = __webpack_require__(303)
var extend = __webpack_require__(599)
var statusCodes = __webpack_require__(600)
var url = __webpack_require__(132)

var http = exports

http.request = function (opts, cb) {
	if (typeof opts === 'string')
		opts = url.parse(opts)
	else
		opts = extend(opts)

	// Normally, the page is loaded from http or https, so not specifying a protocol
	// will result in a (valid) protocol-relative url. However, this won't work if
	// the protocol is something else, like 'file:'
	var defaultProtocol = global.location.protocol.search(/^https?:$/) === -1 ? 'http:' : ''

	var protocol = opts.protocol || defaultProtocol
	var host = opts.hostname || opts.host
	var port = opts.port
	var path = opts.path || '/'

	// Necessary for IPv6 addresses
	if (host && host.indexOf(':') !== -1)
		host = '[' + host + ']'

	// This may be a relative url. The browser should always be able to interpret it correctly.
	opts.url = (host ? (protocol + '//' + host) : '') + (port ? ':' + port : '') + path
	opts.method = (opts.method || 'GET').toUpperCase()
	opts.headers = opts.headers || {}

	// Also valid opts.auth, opts.mode

	var req = new ClientRequest(opts)
	if (cb)
		req.on('response', cb)
	return req
}

http.get = function get (opts, cb) {
	var req = http.request(opts, cb)
	req.end()
	return req
}

http.ClientRequest = ClientRequest
http.IncomingMessage = response.IncomingMessage

http.Agent = function () {}
http.Agent.defaultMaxSockets = 4

http.globalAgent = new http.Agent()

http.STATUS_CODES = statusCodes

http.METHODS = [
	'CHECKOUT',
	'CONNECT',
	'COPY',
	'DELETE',
	'GET',
	'HEAD',
	'LOCK',
	'M-SEARCH',
	'MERGE',
	'MKACTIVITY',
	'MKCOL',
	'MOVE',
	'NOTIFY',
	'OPTIONS',
	'PATCH',
	'POST',
	'PROPFIND',
	'PROPPATCH',
	'PURGE',
	'PUT',
	'REPORT',
	'SEARCH',
	'SUBSCRIBE',
	'TRACE',
	'UNLOCK',
	'UNSUBSCRIBE'
]
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 301 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {exports.fetch = isFunction(global.fetch) && isFunction(global.ReadableStream)

exports.writableStream = isFunction(global.WritableStream)

exports.abortController = isFunction(global.AbortController)

exports.blobConstructor = false
try {
	new Blob([new ArrayBuffer(1)])
	exports.blobConstructor = true
} catch (e) {}

// The xhr request to example.com may violate some restrictive CSP configurations,
// so if we're running in a browser that supports `fetch`, avoid calling getXHR()
// and assume support for certain features below.
var xhr
function getXHR () {
	// Cache the xhr value
	if (xhr !== undefined) return xhr

	if (global.XMLHttpRequest) {
		xhr = new global.XMLHttpRequest()
		// If XDomainRequest is available (ie only, where xhr might not work
		// cross domain), use the page location. Otherwise use example.com
		// Note: this doesn't actually make an http request.
		try {
			xhr.open('GET', global.XDomainRequest ? '/' : 'https://example.com')
		} catch(e) {
			xhr = null
		}
	} else {
		// Service workers don't have XHR
		xhr = null
	}
	return xhr
}

function checkTypeSupport (type) {
	var xhr = getXHR()
	if (!xhr) return false
	try {
		xhr.responseType = type
		return xhr.responseType === type
	} catch (e) {}
	return false
}

// For some strange reason, Safari 7.0 reports typeof global.ArrayBuffer === 'object'.
// Safari 7.1 appears to have fixed this bug.
var haveArrayBuffer = typeof global.ArrayBuffer !== 'undefined'
var haveSlice = haveArrayBuffer && isFunction(global.ArrayBuffer.prototype.slice)

// If fetch is supported, then arraybuffer will be supported too. Skip calling
// checkTypeSupport(), since that calls getXHR().
exports.arraybuffer = exports.fetch || (haveArrayBuffer && checkTypeSupport('arraybuffer'))

// These next two tests unavoidably show warnings in Chrome. Since fetch will always
// be used if it's available, just return false for these to avoid the warnings.
exports.msstream = !exports.fetch && haveSlice && checkTypeSupport('ms-stream')
exports.mozchunkedarraybuffer = !exports.fetch && haveArrayBuffer &&
	checkTypeSupport('moz-chunked-arraybuffer')

// If fetch is supported, then overrideMimeType will be supported too. Skip calling
// getXHR().
exports.overrideMimeType = exports.fetch || (getXHR() ? isFunction(getXHR().overrideMimeType) : false)

exports.vbArray = isFunction(global.VBArray)

function isFunction (value) {
	return typeof value === 'function'
}

xhr = null // Help gc

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, Buffer, global) {var capability = __webpack_require__(302)
var inherits = __webpack_require__(67)
var stream = __webpack_require__(304)

var rStates = exports.readyStates = {
	UNSENT: 0,
	OPENED: 1,
	HEADERS_RECEIVED: 2,
	LOADING: 3,
	DONE: 4
}

var IncomingMessage = exports.IncomingMessage = function (xhr, response, mode, fetchTimer) {
	var self = this
	stream.Readable.call(self)

	self._mode = mode
	self.headers = {}
	self.rawHeaders = []
	self.trailers = {}
	self.rawTrailers = []

	// Fake the 'close' event, but only once 'end' fires
	self.on('end', function () {
		// The nextTick is necessary to prevent the 'request' module from causing an infinite loop
		process.nextTick(function () {
			self.emit('close')
		})
	})

	if (mode === 'fetch') {
		self._fetchResponse = response

		self.url = response.url
		self.statusCode = response.status
		self.statusMessage = response.statusText
		
		response.headers.forEach(function (header, key){
			self.headers[key.toLowerCase()] = header
			self.rawHeaders.push(key, header)
		})

		if (capability.writableStream) {
			var writable = new WritableStream({
				write: function (chunk) {
					return new Promise(function (resolve, reject) {
						if (self._destroyed) {
							reject()
						} else if(self.push(new Buffer(chunk))) {
							resolve()
						} else {
							self._resumeFetch = resolve
						}
					})
				},
				close: function () {
					global.clearTimeout(fetchTimer)
					if (!self._destroyed)
						self.push(null)
				},
				abort: function (err) {
					if (!self._destroyed)
						self.emit('error', err)
				}
			})

			try {
				response.body.pipeTo(writable).catch(function (err) {
					global.clearTimeout(fetchTimer)
					if (!self._destroyed)
						self.emit('error', err)
				})
				return
			} catch (e) {} // pipeTo method isn't defined. Can't find a better way to feature test this
		}
		// fallback for when writableStream or pipeTo aren't available
		var reader = response.body.getReader()
		function read () {
			reader.read().then(function (result) {
				if (self._destroyed)
					return
				if (result.done) {
					global.clearTimeout(fetchTimer)
					self.push(null)
					return
				}
				self.push(new Buffer(result.value))
				read()
			}).catch(function (err) {
				global.clearTimeout(fetchTimer)
				if (!self._destroyed)
					self.emit('error', err)
			})
		}
		read()
	} else {
		self._xhr = xhr
		self._pos = 0

		self.url = xhr.responseURL
		self.statusCode = xhr.status
		self.statusMessage = xhr.statusText
		var headers = xhr.getAllResponseHeaders().split(/\r?\n/)
		headers.forEach(function (header) {
			var matches = header.match(/^([^:]+):\s*(.*)/)
			if (matches) {
				var key = matches[1].toLowerCase()
				if (key === 'set-cookie') {
					if (self.headers[key] === undefined) {
						self.headers[key] = []
					}
					self.headers[key].push(matches[2])
				} else if (self.headers[key] !== undefined) {
					self.headers[key] += ', ' + matches[2]
				} else {
					self.headers[key] = matches[2]
				}
				self.rawHeaders.push(matches[1], matches[2])
			}
		})

		self._charset = 'x-user-defined'
		if (!capability.overrideMimeType) {
			var mimeType = self.rawHeaders['mime-type']
			if (mimeType) {
				var charsetMatch = mimeType.match(/;\s*charset=([^;])(;|$)/)
				if (charsetMatch) {
					self._charset = charsetMatch[1].toLowerCase()
				}
			}
			if (!self._charset)
				self._charset = 'utf-8' // best guess
		}
	}
}

inherits(IncomingMessage, stream.Readable)

IncomingMessage.prototype._read = function () {
	var self = this

	var resolve = self._resumeFetch
	if (resolve) {
		self._resumeFetch = null
		resolve()
	}
}

IncomingMessage.prototype._onXHRProgress = function () {
	var self = this

	var xhr = self._xhr

	var response = null
	switch (self._mode) {
		case 'text:vbarray': // For IE9
			if (xhr.readyState !== rStates.DONE)
				break
			try {
				// This fails in IE8
				response = new global.VBArray(xhr.responseBody).toArray()
			} catch (e) {}
			if (response !== null) {
				self.push(new Buffer(response))
				break
			}
			// Falls through in IE8	
		case 'text':
			try { // This will fail when readyState = 3 in IE9. Switch mode and wait for readyState = 4
				response = xhr.responseText
			} catch (e) {
				self._mode = 'text:vbarray'
				break
			}
			if (response.length > self._pos) {
				var newData = response.substr(self._pos)
				if (self._charset === 'x-user-defined') {
					var buffer = new Buffer(newData.length)
					for (var i = 0; i < newData.length; i++)
						buffer[i] = newData.charCodeAt(i) & 0xff

					self.push(buffer)
				} else {
					self.push(newData, self._charset)
				}
				self._pos = response.length
			}
			break
		case 'arraybuffer':
			if (xhr.readyState !== rStates.DONE || !xhr.response)
				break
			response = xhr.response
			self.push(new Buffer(new Uint8Array(response)))
			break
		case 'moz-chunked-arraybuffer': // take whole
			response = xhr.response
			if (xhr.readyState !== rStates.LOADING || !response)
				break
			self.push(new Buffer(new Uint8Array(response)))
			break
		case 'ms-stream':
			response = xhr.response
			if (xhr.readyState !== rStates.LOADING)
				break
			var reader = new global.MSStreamReader()
			reader.onprogress = function () {
				if (reader.result.byteLength > self._pos) {
					self.push(new Buffer(new Uint8Array(reader.result.slice(self._pos))))
					self._pos = reader.result.byteLength
				}
			}
			reader.onload = function () {
				self.push(null)
			}
			// reader.onerror = ??? // TODO: this
			reader.readAsArrayBuffer(response)
			break
	}

	// The ms-stream case handles end separately in reader.onload()
	if (self._xhr.readyState === rStates.DONE && self._mode !== 'ms-stream') {
		self.push(null)
	}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(50), __webpack_require__(98).Buffer, __webpack_require__(24)))

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(305);
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(309);
exports.Duplex = __webpack_require__(80);
exports.Transform = __webpack_require__(311);
exports.PassThrough = __webpack_require__(597);


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var pna = __webpack_require__(121);
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__(301);
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__(306).EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(307);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(122).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = __webpack_require__(99);
util.inherits = __webpack_require__(67);
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(593);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __webpack_require__(594);
var destroyImpl = __webpack_require__(308);
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__(80);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__(310).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__(80);

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__(310).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, unpipeInfo);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24), __webpack_require__(50)))

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function $getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return $getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = $getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  var args = [];
  for (var i = 0; i < arguments.length; i++) args.push(arguments[i]);
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    ReflectApply(this.listener, this.target, args);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      if (typeof listener !== 'function') {
        throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
      }
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      if (typeof listener !== 'function') {
        throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
      }

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(306).EventEmitter;


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

var pna = __webpack_require__(121);
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
      pna.nextTick(emitErrorNT, this, err);
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      pna.nextTick(emitErrorNT, _this, err);
      if (_this._writableState) {
        _this._writableState.errorEmitted = true;
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



/*<replacement>*/

var pna = __webpack_require__(121);
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = __webpack_require__(99);
util.inherits = __webpack_require__(67);
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(596)
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(307);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(122).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = __webpack_require__(308);

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__(80);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__(80);

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }
  if (state.corkedRequestsFree) {
    state.corkedRequestsFree.next = corkReq;
  } else {
    state.corkedRequestsFree = corkReq;
  }
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(50), __webpack_require__(221).setImmediate, __webpack_require__(24)))

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = __webpack_require__(122).Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__(80);

/*<replacement>*/
var util = __webpack_require__(99);
util.inherits = __webpack_require__(67);
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Logic_1 = __webpack_require__(73);
var SpinResult_1 = __webpack_require__(110);
var GameSymbol_1 = __webpack_require__(64);
var ReelConstants_1 = __webpack_require__(10);
var PrototypeSpinResult = /** @class */ (function (_super) {
    __extends(PrototypeSpinResult, _super);
    function PrototypeSpinResult() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._scattersNum = 0;
        return _this;
    }
    PrototypeSpinResult.prototype.cleanup = function () {
        this._winLines = [];
        this._scattersNum = 0;
    };
    PrototypeSpinResult.prototype.setReelsForWinning = function (gamereels) {
        this._reels = [];
        for (var reelIndex = 0; reelIndex < ReelConstants_1.ReelConstants.REELS_AMOUNT; reelIndex++) {
            this.reels.push([]);
            for (var rowIndex = 0; rowIndex < ReelConstants_1.ReelConstants.ROW_AMOUNT; rowIndex++) {
                this._reels[reelIndex].push(gamereels[reelIndex * ReelConstants_1.ReelConstants.ROW_AMOUNT + rowIndex]);
            }
        }
    };
    PrototypeSpinResult.prototype.setSymbolsToRemove = function (avalanche, avalancheReels) {
        this._symbolsToRemove = [];
        for (var _i = 0, _a = avalanche.winnings; _i < _a.length; _i++) {
            var winnning = _a[_i];
            var _loop_1 = function (pos) {
                if (!this_1.hasExpandingWildOnReel(pos.x, avalancheReels)) {
                    var hasSymbol = !!this_1._symbolsToRemove.find(function (item) {
                        return item.x === pos.x && item.y === pos.y;
                    });
                    if (!hasSymbol) {
                        this_1._symbolsToRemove.push(pos);
                    }
                }
            };
            var this_1 = this;
            for (var _b = 0, _c = winnning.winPositions; _b < _c.length; _b++) {
                var pos = _c[_b];
                _loop_1(pos);
            }
        }
        var ewReels = [];
        if (avalancheReels.length > 0) {
            for (var _d = 0, avalancheReels_1 = avalancheReels; _d < avalancheReels_1.length; _d++) {
                var wildIndex = avalancheReels_1[_d];
                if (this.hasWinningOnReel(wildIndex, avalanche)) {
                    ewReels.push(wildIndex);
                }
            }
        }
        this.setExpandedWildsToRemove(ewReels);
    };
    PrototypeSpinResult.prototype.setSymbolsToAdd = function (avalanche) {
        this._symbolsToAdd = [];
        for (var reel = 0; reel < avalanche.newSymbols.length; reel++) {
            for (var row = 0; row < avalanche.newSymbols[reel].length; row++) {
                this._symbolsToAdd.push(new SpinResult_1.AvalancheNewSymbol(reel, row, avalanche.newSymbols[reel][row].sym, 1));
            }
        }
    };
    PrototypeSpinResult.prototype.clearSymbolsToAdd = function () {
        this._symbolsToAdd = [];
    };
    PrototypeSpinResult.prototype.hasExpandingWildOnReel = function (reelIndex, avalancheReels) {
        for (var _i = 0, avalancheReels_2 = avalancheReels; _i < avalancheReels_2.length; _i++) {
            var avalancheReel = avalancheReels_2[_i];
            if (reelIndex === avalancheReel) {
                return true;
            }
        }
        return false;
    };
    PrototypeSpinResult.prototype.hasPositionInWinLines = function (position, avalanche) {
        for (var _i = 0, _a = avalanche.winnings; _i < _a.length; _i++) {
            var winnning = _a[_i];
            var index = winnning.winPositions.findIndex(function (elem) {
                return elem.x === position.x && elem.y === position.y;
            });
            if (index >= 0) {
                return true;
            }
        }
        return false;
    };
    PrototypeSpinResult.prototype.hasWinningOnReel = function (reelIndex, avalanche) {
        for (var _i = 0, _a = avalanche.winnings; _i < _a.length; _i++) {
            var winnning = _a[_i];
            var index = winnning.winPositions.findIndex(function (elem) {
                return elem.x === reelIndex;
            });
            if (index >= 0) {
                return true;
            }
        }
        return false;
    };
    PrototypeSpinResult.prototype.setExpandedWildsToRemove = function (expandedWildsToRemove) {
        this._expandedWildsToRemove = expandedWildsToRemove;
    };
    PrototypeSpinResult.prototype.setWins = function (wins) {
        this._winLines = [];
        if (!wins) {
            return;
        }
        for (var _i = 0, wins_1 = wins; _i < wins_1.length; _i++) {
            var win = wins_1[_i];
            this._winLines.push(new SpinResult_1.GameWinLine(-1, win.winSymbol, win.winPositions, win.winPositions, win.win, 0, win.winPositions.length));
        }
    };
    PrototypeSpinResult.prototype.setTotalWin = function (win) {
        this._win = win;
    };
    PrototypeSpinResult.prototype.setRoundWin = function (win) {
        this._spinWin = win;
    };
    PrototypeSpinResult.prototype.setCurrentRoundSymbols = function (symbols) {
        if (symbols) {
            this._reels = [];
            for (var reelIndex = 0; reelIndex < symbols.length; reelIndex++) {
                this._reels[reelIndex] = [];
                for (var rowIndex = 0; rowIndex < symbols[reelIndex].length; rowIndex++) {
                    var sym = symbols[reelIndex][rowIndex];
                    this._reels[reelIndex].push(new GameSymbol_1.GameSymbol(sym.sym, { width: 1, height: 1 }, {
                        x: sym.position.x,
                        y: sym.position.y,
                    }));
                }
            }
        }
    };
    PrototypeSpinResult.prototype.setRespins = function (respin, locked, newSymbols) {
        this._individualSymbolsRespins = respin;
        this._individualSymbolsLocked = locked;
        this._individualSymbolsNewSymbols = newSymbols;
    };
    PrototypeSpinResult.prototype.setBalance = function (value) {
        this._balance = value;
    };
    Object.defineProperty(PrototypeSpinResult.prototype, "balance", {
        get: function () {
            return this._balance * Logic_1.Logic.CENT_TO_A_DOLLAR;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PrototypeSpinResult.prototype, "win", {
        get: function () {
            return this._win * Logic_1.Logic.CENT_TO_A_DOLLAR;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PrototypeSpinResult.prototype, "spinWin", {
        get: function () {
            return this._spinWin * Logic_1.Logic.CENT_TO_A_DOLLAR;
        },
        enumerable: true,
        configurable: true
    });
    PrototypeSpinResult.prototype.setStopPositions = function (positions) {
        this._stopPositions = positions;
    };
    Object.defineProperty(PrototypeSpinResult.prototype, "individualSymbolsRespins", {
        get: function () {
            return this._individualSymbolsRespins;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PrototypeSpinResult.prototype, "individualSymbolsNewSymbols", {
        get: function () {
            return this._individualSymbolsNewSymbols;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PrototypeSpinResult.prototype, "individualSymbolsLocked", {
        get: function () {
            return this._individualSymbolsLocked;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PrototypeSpinResult.prototype, "scattersNum", {
        get: function () {
            return this._scattersNum;
        },
        set: function (value) {
            this._scattersNum = value;
        },
        enumerable: true,
        configurable: true
    });
    return PrototypeSpinResult;
}(SpinResult_1.SpinResult));
exports.PrototypeSpinResult = PrototypeSpinResult;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServerWinLine_1 = __webpack_require__(605);
var ServerSymbols_1 = __webpack_require__(165);
var ServerWaysWinChecker = /** @class */ (function () {
    function ServerWaysWinChecker() {
    }
    ServerWaysWinChecker.prototype.findWins = function (reels, specialParams) {
        if (!specialParams) {
            this._currentWinningParams = ServerWaysWinChecker.defaultParams;
        }
        else {
            this._currentWinningParams = specialParams;
        }
        var lines = [];
        for (var symbol = 0; symbol < ServerSymbols_1.LAST_SYMBOL; symbol++) {
            if (ServerSymbols_1.ServerSymbols.isOrdinarySymbol(symbol)) {
                var symMatrix = this.getSymbolsWinMatrixWithWilds(reels, symbol);
                if (symMatrix) {
                    var line = this.tryToMakeWinLineFormMatrix(symMatrix, symbol);
                    if (line) {
                        lines.push(line);
                    }
                }
            }
        }
        return lines;
    };
    ServerWaysWinChecker.prototype.getSymbolOnReelPositions = function (symbol, reelIndex, reels) {
        var positions = [];
        for (var i = 0; i < reels[reelIndex].length; i++) {
            if (reels[reelIndex][i] === symbol) {
                positions.push(i);
            }
        }
        return positions;
    };
    ServerWaysWinChecker.prototype.getSymbolsWinMatrixWithWilds = function (reels, symbol) {
        var symbolPositions = this.getAllPositionsOfSymbol(reels, symbol);
        if (symbolPositions.length < 1) {
            return null;
        }
        var wildsPositions = [];
        var wilds = ServerSymbols_1.ServerSymbols.getWilds();
        for (var _i = 0, wilds_1 = wilds; _i < wilds_1.length; _i++) {
            var wild = wilds_1[_i];
            wildsPositions.push.apply(wildsPositions, this.getAllPositionsOfSymbol(reels, wild));
        }
        var symbolsMatrix = [];
        for (var reelIndex = 0; reelIndex < reels.length; reelIndex++) {
            symbolsMatrix[reelIndex] = [];
            for (var _a = 0, _b = reels[reelIndex]; _a < _b.length; _a++) {
                var row = _b[_a];
                symbolsMatrix[reelIndex].push(0);
            }
        }
        for (var _c = 0, wildsPositions_1 = wildsPositions; _c < wildsPositions_1.length; _c++) {
            var wp = wildsPositions_1[_c];
            symbolsMatrix[wp.reel][wp.row] = 2;
        }
        for (var _d = 0, symbolPositions_1 = symbolPositions; _d < symbolPositions_1.length; _d++) {
            var sp = symbolPositions_1[_d];
            symbolsMatrix[sp.reel][sp.row] = 1;
        }
        return symbolsMatrix;
    };
    ServerWaysWinChecker.prototype.tryToMakeWinLineFormMatrix = function (symbolMatrix, symbol) {
        if (this.hasLineInMatrix(symbolMatrix)) {
            var line = new ServerWinLine_1.ServerWinLine();
            line.mainWinSymbol = symbol;
            line.multiplier = 1;
            line.win = 1;
            for (var reelIndex = 0; reelIndex < symbolMatrix.length; reelIndex++) {
                var symsOnReel = 0;
                for (var rowIndex = 0; rowIndex < symbolMatrix[reelIndex].length; rowIndex++) {
                    if (symbolMatrix[reelIndex][rowIndex] === 1) {
                        line.addWinPosition(reelIndex, rowIndex, symbol);
                        symsOnReel++;
                    }
                    if (symbolMatrix[reelIndex][rowIndex] === 2) {
                        line.addWinPosition(reelIndex, rowIndex, ServerSymbols_1.W);
                        symsOnReel++;
                    }
                }
                if (symsOnReel === 0) {
                    return line;
                }
                else {
                    line.multiplier *= symsOnReel;
                }
            }
            return line;
        }
        return null;
    };
    ServerWaysWinChecker.prototype.hasLineInMatrix = function (symbolMatrix) {
        for (var reelIndex = 0; reelIndex < symbolMatrix.length; reelIndex++) {
            var positionsOnCurrentReel = [];
            for (var rowIndex = 0; rowIndex < symbolMatrix[reelIndex].length; rowIndex++) {
                if (symbolMatrix[reelIndex][rowIndex] > 0) {
                    positionsOnCurrentReel.push({ reel: reelIndex, row: rowIndex });
                }
            }
            if (reelIndex >= this._currentWinningParams.MINIMUM_SYMBOLS_TO_WIN) {
                return true;
            }
            if (positionsOnCurrentReel.length <= 0) {
                return false;
            }
        }
    };
    ServerWaysWinChecker.prototype.getAllPositionsOfSymbol = function (reels, symbol) {
        var positions = [];
        for (var reelIndex = 0; reelIndex < reels.length; reelIndex++) {
            for (var rowIndex = 0; rowIndex < reels[reelIndex].length; rowIndex++) {
                if (reels[reelIndex][rowIndex] === symbol) {
                    positions.push({ reel: reelIndex, row: rowIndex });
                }
            }
        }
        return positions;
    };
    ServerWaysWinChecker.defaultParams = {
        FROM_CORNER: true,
        LEFT_TO_RIGHT: true,
        RIGHT_TO_LEFT: false,
        MINIMUM_SYMBOLS_TO_WIN: 3,
    };
    return ServerWaysWinChecker;
}());
exports.ServerWaysWinChecker = ServerWaysWinChecker;


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServerRandomUtils = /** @class */ (function () {
    function ServerRandomUtils() {
    }
    // return random in [min, max]
    ServerRandomUtils.randomInt = function (min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    };
    ServerRandomUtils.randomValueWithWeights = function (values, weights) {
        if (values.length !== weights.length) {
            throw new Error('ServerRandomUtils::randomValueWithWeights number of values should be the same as number of weights');
        }
        if (!ServerRandomUtils.checkAllPositiveNoZeros(weights)) {
            throw new Error('ServerRandomUtils::randomValueWithWeights weights values must be >= 0');
        }
        if (!ServerRandomUtils.checkAllIntegers(weights)) {
            throw new Error('ServerRandomUtils::randomValueWithWeights weights values must be all integers');
        }
        var totalWeights = ServerRandomUtils.sumOf(weights);
        var randomValue = ServerRandomUtils.randomInt(0, totalWeights - 1);
        var current = 0;
        var index = 0;
        for (var _i = 0, weights_1 = weights; _i < weights_1.length; _i++) {
            var num = weights_1[_i];
            current += num;
            if (randomValue < current) {
                return values[index];
            }
            index++;
        }
        // shouldn't happen.
        return null;
    };
    ServerRandomUtils.randomIntValueWithExceptions = function (min, max, exceptions) {
        if (max - min < exceptions.length) {
            throw new Error('ServerRandomUtils::randomIntValueWithExceptions too many exceptions or somthing wrong with numbers');
        }
        while (true) {
            var genNumber = ServerRandomUtils.randomInt(min, max);
            if (exceptions.indexOf(genNumber) === -1) {
                return genNumber;
            }
        }
    };
    ServerRandomUtils.sumOf = function (numsArr) {
        var total = 0;
        for (var _i = 0, numsArr_1 = numsArr; _i < numsArr_1.length; _i++) {
            var num = numsArr_1[_i];
            total += num;
        }
        return total;
    };
    ServerRandomUtils.checkAllPositiveNoZeros = function (numsArr) {
        for (var _i = 0, numsArr_2 = numsArr; _i < numsArr_2.length; _i++) {
            var num = numsArr_2[_i];
            if (num <= 0) {
                return false;
            }
        }
        return true;
    };
    ServerRandomUtils.checkAllIntegers = function (numsArr) {
        for (var _i = 0, numsArr_3 = numsArr; _i < numsArr_3.length; _i++) {
            var num = numsArr_3[_i];
            if (!Number.isInteger(num)) {
                return false;
            }
        }
        return true;
    };
    return ServerRandomUtils;
}());
exports.ServerRandomUtils = ServerRandomUtils;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServerGameFeatures;
(function (ServerGameFeatures) {
    ServerGameFeatures[ServerGameFeatures["EXPLOSION"] = 0] = "EXPLOSION";
    ServerGameFeatures[ServerGameFeatures["RESPIN"] = 1] = "RESPIN";
    ServerGameFeatures[ServerGameFeatures["EXPANDED_WILD"] = 2] = "EXPANDED_WILD";
})(ServerGameFeatures = exports.ServerGameFeatures || (exports.ServerGameFeatures = {}));
var ServerData = /** @class */ (function () {
    function ServerData() {
        this._betLevel = 1;
        this._coinValue = 1;
        this._balance = 10000;
        this._featuresActiveStatus = [false, false, false];
        this._featuresLevels = [0, 0, 0];
        this._FSFeaturesActiveStatus = [true, true, true];
        this._FSFeatureLevels = [5, 5, 5];
        this._isInFreeSpins = false;
        this._isInMimicFreeSpins = false;
    }
    ServerData.prototype.makePriorityFeatures = function () {
        var activeFeatures = this.totalActivatedFeatures();
        if (activeFeatures <= 0 || activeFeatures > 3) {
            throw new Error('ServerData::makePriorityFeatures number of active features should be > 0 && <= 3. Currently it is ' + activeFeatures);
        }
        if (activeFeatures === 1) {
            var hasPriorityFeature = false;
            for (var i = 0; i < 3; i++) {
                if (!this._featuresActiveStatus[i]) {
                    if (hasPriorityFeature) {
                        this._nonPriorityFeatureIndex = i;
                    }
                    else {
                        hasPriorityFeature = true;
                        this._priorityFeatureIndex = i;
                    }
                }
                else {
                    this._initiallyUnlockedFeatureIndex = i;
                }
            }
        }
    };
    ServerData.prototype.totalActivatedFeatures = function () {
        var activatedFeatures = 0;
        for (var _i = 0, _a = this._featuresActiveStatus; _i < _a.length; _i++) {
            var feature = _a[_i];
            if (feature) {
                activatedFeatures++;
            }
        }
        return activatedFeatures;
    };
    ServerData.prototype.activateFeature = function (feature) {
        this._featuresActiveStatus[feature] = true;
        this._featuresLevels[feature] = 5;
        this.makePriorityFeatures();
    };
    ServerData.prototype.makeFreeSpin = function () {
        this._freeSpinsPlayed++;
        if (this.isFreeSpinsFinished()) {
            this.finishFreeSpins();
        }
    };
    ServerData.prototype.makeMimicFreeSpin = function () {
        this._mimicFreeSpinsPlayed++;
        if (this.isMimicFreeSpinsFinished()) {
            this.finishMimicFreeSpins();
        }
    };
    ServerData.prototype.isFreeSpinsFinished = function () {
        return this._freeSpinsPlayed === this._totalFreeSpins;
    };
    ServerData.prototype.isMimicFreeSpinsFinished = function () {
        return this._mimicFreeSpinsPlayed === this._totalMimcFreeSpin;
    };
    Object.defineProperty(ServerData.prototype, "isInFreeSpins", {
        get: function () {
            return this._isInFreeSpins;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ServerData.prototype, "isInMimicFreeSpins", {
        get: function () {
            return this._isInMimicFreeSpins;
        },
        enumerable: true,
        configurable: true
    });
    ServerData.prototype.startFreeSpins = function (totalFS) {
        this._freeSpinsPlayed = 0;
        this._totalFreeSpins = totalFS;
        this._isInFreeSpins = true;
    };
    ServerData.prototype.startMimicFreeSpins = function (totalMFS) {
        this._mimicFreeSpinsPlayed = 0;
        this._totalMimcFreeSpin = totalMFS;
        this._isInMimicFreeSpins = true;
    };
    ServerData.prototype.finishFreeSpins = function () {
        this._isInFreeSpins = false;
    };
    ServerData.prototype.finishMimicFreeSpins = function () {
        this._isInMimicFreeSpins = false;
    };
    Object.defineProperty(ServerData.prototype, "totalFreeSpins", {
        get: function () {
            return this._totalFreeSpins;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ServerData.prototype, "freeSpinsPlayed", {
        get: function () {
            return this._freeSpinsPlayed;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ServerData.prototype, "totalMimcFreeSpin", {
        get: function () {
            return this._totalMimcFreeSpin;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ServerData.prototype, "mimicFreeSpinsPlayed", {
        get: function () {
            return this._mimicFreeSpinsPlayed;
        },
        enumerable: true,
        configurable: true
    });
    ServerData.prototype.addToTotalFreeSpins = function (freeSpinsToAdd) {
        this._totalFreeSpins += freeSpinsToAdd;
    };
    ServerData.prototype.setLevelValue = function (feature, value) {
        this._featuresLevels[feature] = value;
    };
    Object.defineProperty(ServerData.prototype, "betLevel", {
        get: function () {
            return this._betLevel;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ServerData.prototype, "coinValue", {
        get: function () {
            return this._coinValue;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ServerData.prototype, "balance", {
        get: function () {
            return this._balance;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ServerData.prototype, "featuresActiveStatus", {
        get: function () {
            return this._featuresActiveStatus;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ServerData.prototype, "activeFeaturesNumber", {
        get: function () {
            var total = 0;
            for (var i = 0; i < 3; i++) {
                if (this.featuresActiveStatus[i]) {
                    total++;
                }
            }
            return total;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ServerData.prototype, "featuresLevels", {
        get: function () {
            return this._featuresLevels;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ServerData.prototype, "priorityFeatureIndex", {
        get: function () {
            return this._priorityFeatureIndex;
        },
        set: function (value) {
            this._priorityFeatureIndex = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ServerData.prototype, "nonPriorityFeatureIndex", {
        get: function () {
            return this._nonPriorityFeatureIndex;
        },
        set: function (value) {
            this._nonPriorityFeatureIndex = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ServerData.prototype, "initiallyUnlockedFeatureIndex", {
        get: function () {
            return this._initiallyUnlockedFeatureIndex;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ServerData.prototype, "FSFeaturesActiveStatus", {
        get: function () {
            return this._FSFeaturesActiveStatus;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ServerData.prototype, "FSFeatureLevels", {
        get: function () {
            return this._FSFeatureLevels;
        },
        enumerable: true,
        configurable: true
    });
    ServerData.MAX_FEATURE_LEVEL = 5;
    return ServerData;
}());
exports.ServerData = ServerData;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Server_1 = __webpack_require__(607);
var Communicator_1 = __webpack_require__(149);
var http = __webpack_require__(300);
var PrototypeCommunicator = /** @class */ (function (_super) {
    __extends(PrototypeCommunicator, _super);
    function PrototypeCommunicator() {
        var _this = _super.call(this) || this;
        _this.options = {
            host: '5.150.199.195',
            port: '4071',
            protocol: 'http:',
            path: '/simserver/Init?g=avalancheslot',
            method: 'GET',
            headers: { 'content-type': 'application/json;charset=ISO-8859-1' },
        };
        _this.gameID = 'avalancheslot';
        _this._fakeResponses = [];
        _this._server = new Server_1.Server();
        if (false) {
            window.cheatAdditionalData = '';
            window.fake = _this;
        }
        return _this;
    }
    PrototypeCommunicator.prototype.api_autoPlayStarted = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
    };
    PrototypeCommunicator.prototype.api_autoPlayStopped = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
    };
    PrototypeCommunicator.prototype.api_balanceUpdate = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
    };
    PrototypeCommunicator.prototype.api_betSizeUpdate = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
    };
    PrototypeCommunicator.prototype.api_gameRoundCompleted = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
    };
    PrototypeCommunicator.prototype.api_gameSetMute = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
    };
    PrototypeCommunicator.prototype.api_gamemenuClosed = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
    };
    PrototypeCommunicator.prototype.api_gamemenuOpen = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
    };
    PrototypeCommunicator.prototype.api_gameplayPause = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
    };
    PrototypeCommunicator.prototype.api_gameplayStart = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
    };
    PrototypeCommunicator.prototype.api_playerInformationRecieved = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
    };
    PrototypeCommunicator.prototype.api_showErrorMessage = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
    };
    PrototypeCommunicator.prototype.api_winUpdate = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
    };
    PrototypeCommunicator.prototype.freeSpin = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
    };
    PrototypeCommunicator.prototype.pick = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
    };
    PrototypeCommunicator.prototype.ping = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
    };
    PrototypeCommunicator.prototype.requestSavedData = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
    };
    PrototypeCommunicator.prototype.saveData = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
    };
    PrototypeCommunicator.prototype.skippick = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
    };
    PrototypeCommunicator.prototype.addFakeResponse = function (response) {
        this._fakeResponses.push(response);
    };
    PrototypeCommunicator.prototype.init = function (gameID, callback) {
        this.sendRequest("", callback);
    };
    PrototypeCommunicator.prototype.spin = function (sid, bet, callback) {
        var _this = this;
        if (this._fakeResponses.length > 0) {
            setTimeout(function () {
                callback(_this._fakeResponses[0]);
                _this._fakeResponses.splice(0, 1);
            }, 100);
        }
        else {
            this.options.path = "/simserver/Spin?g=" + this.gameID + "&ba=" + bet + "&sid=" + sid;
            this.addCheatToSpin();
            this.sendRequest("", callback);
        }
    };
    PrototypeCommunicator.prototype.addCheatToSpin = function () { };
    PrototypeCommunicator.prototype.freespin = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
    };
    PrototypeCommunicator.prototype.initFeatures = function (featureIndexes, callback) {
        var _this = this;
        setTimeout(function () {
            _this._server.init(featureIndexes);
            callback();
        }, 0);
    };
    PrototypeCommunicator.prototype.play = function (gameID, sessID, chanel, language, currency, callback) {
        var _this = this;
        setTimeout(function () {
            _this._server.spin();
            var fsRounds = _this._server.hasMimicFSRounds() ? _this._server.getCurrentMimicFS() : _this._server.getCurrentFS();
            callback(_this._server.getCurrentRoundResult(), fsRounds);
        }, 0);
    };
    PrototypeCommunicator.prototype.avalanche = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
    };
    PrototypeCommunicator.prototype.respin = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
    };
    PrototypeCommunicator.prototype.sendRequest = function (writeString, callback) {
        var cb = function (response) {
            var str = '';
            response.on('data', function (chunk) {
                str += chunk;
            });
            response.on('end', function () {
                // console.log(str);
                callback(str);
            });
        };
        var req = http.request(this.options, cb);
        req.write(writeString);
        req.end();
    };
    return PrototypeCommunicator;
}(Communicator_1.Communicator));
exports.PrototypeCommunicator = PrototypeCommunicator;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Module_1 = __webpack_require__(2);
var ReelsEvents_1 = __webpack_require__(4);
var NetworkBasicState_1 = __webpack_require__(318);
var AvalancheReelsEvents_1 = __webpack_require__(15);
var IndividualSymbolReelsEvents_1 = __webpack_require__(116);
var NetworkModule = /** @class */ (function (_super) {
    __extends(NetworkModule, _super);
    function NetworkModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NetworkModule.prototype.setupViews = function () {
        this.onCurrentStateHandle(ReelsEvents_1.ReelsEvents.REELS_SPINNING_STARTED);
        this.onCurrentStateHandle(ReelsEvents_1.ReelsEvents.REELS_RESPIN_STARTED);
        this.onCurrentStateHandle(AvalancheReelsEvents_1.AvalancheReelsEvents.REMOVING_AVALANCE_SYMBOLS_STARTED);
        this.onCurrentStateHandle(AvalancheReelsEvents_1.AvalancheReelsEvents.SYMBOLS_RESPIN_STARTED);
        this.onCurrentStateHandle(IndividualSymbolReelsEvents_1.IndividualSymbolReelsEvents.SPINNING_STARTED);
        this.onCurrentStateHandle(IndividualSymbolReelsEvents_1.IndividualSymbolReelsEvents.INDIVIDUAL_RESPIN_STARTED);
    };
    NetworkModule.prototype.setupStates = function () {
        this.addState(new NetworkBasicState_1.NetworkBasicState(this, NetworkModule.BASIC_STATE));
    };
    NetworkModule.prototype.enterFirstState = function () {
        this.changeStateTo(NetworkModule.BASIC_STATE);
    };
    NetworkModule.prototype.setupEvents = function () {
    };
    NetworkModule.BASIC_STATE = 'basic';
    return NetworkModule;
}(Module_1.Module));
exports.NetworkModule = NetworkModule;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var ReelsEvents_1 = __webpack_require__(4);
var Action_1 = __webpack_require__(29);
var AvalancheReelsEvents_1 = __webpack_require__(15);
var IndividualSymbolReelsEvents_1 = __webpack_require__(116);
var NetworkBasicState = /** @class */ (function (_super) {
    __extends(NetworkBasicState, _super);
    function NetworkBasicState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NetworkBasicState.prototype.onEnterState = function () {
    };
    NetworkBasicState.prototype.onLeaveState = function () {
    };
    NetworkBasicState.prototype.setupEvents = function () {
        this.on(ReelsEvents_1.ReelsEvents.REELS_SPINNING_STARTED, this.onReelsSpinningStarted);
        this.on(ReelsEvents_1.ReelsEvents.REELS_RESPIN_STARTED, this.onReelsRespinStarted);
        this.on(AvalancheReelsEvents_1.AvalancheReelsEvents.REMOVING_AVALANCE_SYMBOLS_STARTED, this.onAvalanche);
        this.on(AvalancheReelsEvents_1.AvalancheReelsEvents.SYMBOLS_RESPIN_STARTED, this.onReelsRespinStarted);
        this.on(IndividualSymbolReelsEvents_1.IndividualSymbolReelsEvents.INDIVIDUAL_RESPIN_STARTED, this.onReelsRespinStarted);
    };
    NetworkBasicState.prototype.onReelsSpinningStarted = function () {
        switch (this.module.logic.nextAction) {
            case Action_1.Action.SPIN: {
                this.module.logic.spin(null);
                // this.module.logic.saveData(null);
                break;
            }
            case Action_1.Action.FREESPIN: {
                this.module.logic.freeSpin(null);
                break;
            }
            default:
                this.otherActionHandling(this.module.logic.nextAction);
                break;
        }
    };
    NetworkBasicState.prototype.otherActionHandling = function (nextAction) {
    };
    NetworkBasicState.prototype.onAvalanche = function () {
        if (this.module.logic.nextAction !== Action_1.Action.AVALANCHE) {
            throw new Error('wrong next action = ' + this.module.logic.nextAction + ' expected to be respin');
        }
        this.module.logic.avalanche(null);
    };
    NetworkBasicState.prototype.onReelsRespinStarted = function () {
        if (this.module.logic.nextAction !== Action_1.Action.RESPIN) {
            throw new Error('wrong next action = ' + this.module.logic.nextAction + ' expected to be respin');
        }
        this.module.logic.respin(null);
    };
    return NetworkBasicState;
}(ModuleState_1.ModuleState));
exports.NetworkBasicState = NetworkBasicState;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var NetworkBasicState_1 = __webpack_require__(318);
var Action_1 = __webpack_require__(29);
var GameNetworkBasicState = /** @class */ (function (_super) {
    __extends(GameNetworkBasicState, _super);
    function GameNetworkBasicState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameNetworkBasicState.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
    };
    GameNetworkBasicState.prototype.onPick = function () {
        this.module.logic.pick(null);
    };
    GameNetworkBasicState.prototype.onSkipPick = function () {
        this.module.logic.skippick(null);
    };
    GameNetworkBasicState.prototype.onReelsSpinningStarted = function () {
        switch (this.module.logic.nextAction) {
            case Action_1.Action.SPIN:
                this.module.logic.spin(null);
                break;
            case Action_1.Action.FREESPIN:
                this.module.logic.freespin(null);
                break;
            default:
                break;
        }
    };
    return GameNetworkBasicState;
}(NetworkBasicState_1.NetworkBasicState));
exports.GameNetworkBasicState = GameNetworkBasicState;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BetButtonEvents = /** @class */ (function () {
    function BetButtonEvents() {
    }
    BetButtonEvents.BET_BUTTON_CLICKED = 'BetButtonEvents::BET_BUTTON_CLICKED';
    BetButtonEvents.BET_BUTTON_DISABLED = 'BetButtonEvents::BET_BUTTON_DISABLED';
    return BetButtonEvents;
}());
exports.BetButtonEvents = BetButtonEvents;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var AutoplayHandlerModule_1 = __webpack_require__(81);
var AutoplayMenuEvents_1 = __webpack_require__(33);
var FlowModuleEvents_1 = __webpack_require__(0);
var AutoplayBasicState = /** @class */ (function (_super) {
    __extends(AutoplayBasicState, _super);
    function AutoplayBasicState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AutoplayBasicState.prototype.onEnterState = function () { };
    AutoplayBasicState.prototype.onLeaveState = function () { };
    AutoplayBasicState.prototype.setupEvents = function () {
        this.on(AutoplayMenuEvents_1.AutoplayMenuEvents.ACCEPTED, this.onAutoPlaySettingsAccepted);
        this.on(FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN, this.onCanSpin);
    };
    AutoplayBasicState.prototype.onCanSpin = function () {
        this.module.setCanSpin(true);
    };
    AutoplayBasicState.prototype.onAutoPlaySettingsAccepted = function (eventID, spinsLeft) {
        this.module.logic.lastAutoplayAmount = spinsLeft;
        this.module.startAutoplay(spinsLeft);
        this.module.gotoState(AutoplayHandlerModule_1.AutoplayHandlerModule.IN_PROGRESS);
    };
    return AutoplayBasicState;
}(ModuleState_1.ModuleState));
exports.AutoplayBasicState = AutoplayBasicState;


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AutoPlayButtonEvents = /** @class */ (function () {
    function AutoPlayButtonEvents() {
    }
    AutoPlayButtonEvents.AUTO_PLAYBUTTON_CLICKED = 'AutoPlayButtonEvents::__AUTOPLAY_BUTTON_CLICKED__';
    AutoPlayButtonEvents.STOP_AUTOPLAY_BUTTON_CLICKED = 'AutoPlayButtonEvents::__STOP_AUTOPLAY_BUTTON_CLICKED__';
    return AutoPlayButtonEvents;
}());
exports.AutoPlayButtonEvents = AutoPlayButtonEvents;


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var RecodeGameAutoplayHandlerModuleEvents = /** @class */ (function () {
    function RecodeGameAutoplayHandlerModuleEvents() {
    }
    RecodeGameAutoplayHandlerModuleEvents.RECODE_AUTOPLAY_SHOW_POPUP = 'RecodeGameAutoplayModuleEvents::RECODE_AUTOPLAY_SHOW_POPUP';
    return RecodeGameAutoplayHandlerModuleEvents;
}());
exports.RecodeGameAutoplayHandlerModuleEvents = RecodeGameAutoplayHandlerModuleEvents;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var FlowModuleEvents_1 = __webpack_require__(0);
var SpinButtonEvents_1 = __webpack_require__(12);
var SpinButtonModule_1 = __webpack_require__(82);
var SpinButtonViewEvents_1 = __webpack_require__(111);
var ReelsEvents_1 = __webpack_require__(4);
var StartScreenEvents_1 = __webpack_require__(22);
var SpinButtonBasicState = /** @class */ (function (_super) {
    __extends(SpinButtonBasicState, _super);
    function SpinButtonBasicState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._isTryingToRunSpinBySpaceButton = false;
        return _this;
    }
    SpinButtonBasicState.prototype.onEnterState = function () {
        this._isTryingToRunSpinBySpaceButton = false;
    };
    SpinButtonBasicState.prototype.onLeaveState = function () { };
    SpinButtonBasicState.prototype.setupEvents = function () {
        this.on(SpinButtonEvents_1.SpinButtonEvents.START_AUTOPLAY_BUTTON_PRESSED, this.onStartAutoPlayButtonPressed);
        this.on(SpinButtonViewEvents_1.SpinButtonViewEvents.SPIN_BUTTON_CLICKED, this.onSpinButtonClicked);
        this.on(ReelsEvents_1.ReelsEvents.REELS_SPINNING_STARTED, this.onReelsSpinStarted);
        this.on(FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN, this.onCanSpin);
        this.on(SpinButtonEvents_1.SpinButtonEvents.SPACE_BUTTON_CLICKED, this.onSpaceButtonClicked);
        this.on(StartScreenEvents_1.StartScreenEvents.EXIT_FINISHED, this.onIntroFinished);
    };
    SpinButtonBasicState.prototype.onIntroFinished = function () {
        this.view.showSpinButton();
    };
    SpinButtonBasicState.prototype.onSpaceButtonClicked = function () {
        this._isTryingToRunSpinBySpaceButton = true;
        if (this.module.validateSpaceSpinPress()) {
            this.proceedWithSpin();
        }
    };
    SpinButtonBasicState.prototype.onStartAutoPlayButtonPressed = function () {
        if (this.module.validateAutoplaySpinPress()) {
            this.trySpinIfEnoughMoneyElseEmitNotEnough();
        }
    };
    SpinButtonBasicState.prototype.onSpinButtonClicked = function () {
        this._isTryingToRunSpinBySpaceButton = false;
        this.proceedWithSpin();
    };
    SpinButtonBasicState.prototype.proceedWithSpin = function () {
        if (this.module.hasSpinTimeRegulation()) {
            if (this.module.regulationCanSpin) {
                if (this.module.validateSpinPress()) {
                    this.trySpinIfEnoughMoneyElseEmitNotEnough();
                }
            }
        }
        else {
            if (this.module.validateSpinPress()) {
                this.trySpinIfEnoughMoneyElseEmitNotEnough();
            }
        }
    };
    SpinButtonBasicState.prototype.trySpinIfEnoughMoneyElseEmitNotEnough = function () {
        if (this._isTryingToRunSpinBySpaceButton) {
            this.emit(SpinButtonEvents_1.SpinButtonEvents.SPIN_BUTTON_SPACE_PHYSICALLY_CLICKED);
        }
        if (this.module.userHasEnougMoneyToSpin()) {
            this.tryToStartSpin();
            this.view.spinButtonClickAction();
            this.module.setSpinStarted();
        }
        else {
            this.emit(SpinButtonEvents_1.SpinButtonEvents.SPIN_PRESSED_NOT_ENOUGH_MONEY);
        }
    };
    SpinButtonBasicState.prototype.tryToStartSpin = function () {
        if (this.module.canSpin) {
            // all the _logic goes here
            this.view.disableSpinButton();
            if (this.module.userHasEnougMoneyToSpin()) {
                this.emit(SpinButtonEvents_1.SpinButtonEvents.PRE_SPIN_BUTTON_PRESSED);
                this.emit(SpinButtonEvents_1.SpinButtonEvents.SPIN_BUTTON_PRESSED);
                this.view.spinButtonClickAction();
                this.module.canSpin = false;
            }
            else {
                this.emit(SpinButtonEvents_1.SpinButtonEvents.SPIN_PRESSED_NOT_ENOUGH_MONEY);
            }
        }
    };
    SpinButtonBasicState.prototype.onCanSpin = function () {
        if (!this.module.logic.isFreeSpinsStarted && this.module.logic.freeSpinsLeft <= 0) {
            this.view.enableSpinButton();
            this.module.canSpin = true;
        }
    };
    SpinButtonBasicState.prototype.onReelsSpinStarted = function () {
        this._isTryingToRunSpinBySpaceButton = false;
        if (this.module.hasSpinTimeRegulation()) {
            this.module.regulationCanSpin = false;
            this.module.startRegulationSpinTimer();
        }
        this.module.gotoState(SpinButtonModule_1.SpinButtonModule.REELS_SPINNING_STATE);
    };
    return SpinButtonBasicState;
}(ModuleState_1.ModuleState));
exports.SpinButtonBasicState = SpinButtonBasicState;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var FlowModuleEvents_1 = __webpack_require__(0);
var FreeSpinsEvents_1 = __webpack_require__(6);
var SpinButtonEvents_1 = __webpack_require__(12);
var SpinButtonModule_1 = __webpack_require__(82);
var SpinButtonFreeSpinsState = /** @class */ (function (_super) {
    __extends(SpinButtonFreeSpinsState, _super);
    function SpinButtonFreeSpinsState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SpinButtonFreeSpinsState.prototype.onLeaveState = function () {
        this.view.show();
    };
    SpinButtonFreeSpinsState.prototype.onEnterState = function () {
        this.setupFreeSpinView();
    };
    SpinButtonFreeSpinsState.prototype.setupFreeSpinView = function () {
        this.view.hide();
    };
    SpinButtonFreeSpinsState.prototype.onCanSpin = function () {
        var _this = this;
        this.module.timeUtils.createTimer(function () {
            if (_this.canStartFreeSpin()) {
                _this.module.canSpin = true;
                _this.emit(SpinButtonEvents_1.SpinButtonEvents.SPIN_BUTTON_PRESSED);
                _this.module.canSpin = false;
            }
        }, SpinButtonFreeSpinsState.PAUSE_BEFORE_FREESPIN);
    };
    SpinButtonFreeSpinsState.prototype.canStartFreeSpin = function () {
        return (this.module.logic.isFreeSpinsStarted && this.module.logic.freeSpinsLeft > 0);
    };
    SpinButtonFreeSpinsState.prototype.onFreeSpinsOutroFinished = function () {
        this.module.gotoState(SpinButtonModule_1.SpinButtonModule.BASIC_STATE);
        this.view.enableSpinButton();
    };
    SpinButtonFreeSpinsState.prototype.setupEvents = function () {
        this.on(FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN, this.onCanSpin);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_OUTRO_FINISHED, this.onFreeSpinsOutroFinished);
    };
    SpinButtonFreeSpinsState.PAUSE_BEFORE_FREESPIN = 750;
    return SpinButtonFreeSpinsState;
}(ModuleState_1.ModuleState));
exports.SpinButtonFreeSpinsState = SpinButtonFreeSpinsState;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var LogicEvents_1 = __webpack_require__(11);
var FlowModuleEvents_1 = __webpack_require__(0);
var SpinButtonEvents_1 = __webpack_require__(12);
var SpinButtonModule_1 = __webpack_require__(82);
var SpinButtonViewEvents_1 = __webpack_require__(111);
var ReelsEvents_1 = __webpack_require__(4);
var StartScreenEvents_1 = __webpack_require__(22);
var SpinButtonWhileSpinningState = /** @class */ (function (_super) {
    __extends(SpinButtonWhileSpinningState, _super);
    function SpinButtonWhileSpinningState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._wasQuickstopPressed = false;
        _this._canContinueSpin = false;
        _this._spinResponseReceived = false;
        _this._waitingForAutospinToStart = false;
        return _this;
    }
    SpinButtonWhileSpinningState.prototype.onEnterState = function () {
        this._wasQuickstopPressed = false;
        this._waitingForAutospinToStart = false;
    };
    SpinButtonWhileSpinningState.prototype.onLeaveState = function () { };
    SpinButtonWhileSpinningState.prototype.setupEvents = function () {
        this.on(ReelsEvents_1.ReelsEvents.SPIN_ENDED, this.onAllReelsStopped);
        this.on(SpinButtonViewEvents_1.SpinButtonViewEvents.SPIN_BUTTON_CLICKED, this.onSpinButtonClicked);
        this.on(FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN, this.onCanSpin);
        this.on(LogicEvents_1.LogicEvents.SPIN_RESPONSE, this.onSpinResponse);
        this.on(SpinButtonEvents_1.SpinButtonEvents.SPACE_BUTTON_CLICKED, this.onSpaceButtonClicked);
        this.on(StartScreenEvents_1.StartScreenEvents.EXIT_FINISHED, this.onIntroFinished);
        this.on(FlowModuleEvents_1.FlowModuleEvents.CAN_CONTINUE_SPIN, this.onCanContinueSpin);
        this.on(SpinButtonEvents_1.SpinButtonEvents.REGULATION_SPIN_DELAY_PASSED, this.onRegulationSpinDelayPassed);
        this.on(SpinButtonEvents_1.SpinButtonEvents.START_AUTOPLAY_BUTTON_PRESSED, this.onStartAutoPlayButtonPressed);
    };
    SpinButtonWhileSpinningState.prototype.onStartAutoPlayButtonPressed = function () {
        this._waitingForAutospinToStart = true;
    };
    SpinButtonWhileSpinningState.prototype.onCanContinueSpin = function () {
        if (!this.hasSpinTimeRegulation() && this._spinResponseReceived && this.module.hasQuickstop) {
            this.view.enableSpinButton();
        }
        this._canContinueSpin = true;
    };
    SpinButtonWhileSpinningState.prototype.onRegulationSpinDelayPassed = function () {
        if (!this.hasSpinTimeRegulation()) {
            return;
        }
        if (this.module.regulationCanSpin && this.module.canSpin) {
            this.view.enableSpinButton();
            this.module.gotoState(SpinButtonModule_1.SpinButtonModule.BASIC_STATE);
            if (this._waitingForAutospinToStart && this.module.isInAutoplay) {
                this._waitingForAutospinToStart = false;
                this.module.currentState.handle(SpinButtonEvents_1.SpinButtonEvents.START_AUTOPLAY_BUTTON_PRESSED);
            }
        }
    };
    SpinButtonWhileSpinningState.prototype.hasSpinTimeRegulation = function () {
        return this.module.hasSpinTimeRegulation();
    };
    SpinButtonWhileSpinningState.prototype.onIntroFinished = function () {
        this.view.showSpinButton();
    };
    SpinButtonWhileSpinningState.prototype.onAllReelsStopped = function () {
        this.view.disableSpinButton();
        this._canContinueSpin = false;
        this._spinResponseReceived = false;
    };
    SpinButtonWhileSpinningState.prototype.onEnableSpinButtonBySpinResponse = function () {
        this.view.enableSpinButton();
    };
    SpinButtonWhileSpinningState.prototype.onCanSpin = function () {
        if (this.hasSpinTimeRegulation()) {
            if (this.module.regulationCanSpin) {
                this.view.enableSpinButton();
                this.module.gotoState(SpinButtonModule_1.SpinButtonModule.BASIC_STATE);
            }
        }
        else {
            this.view.enableSpinButton();
            this.module.gotoState(SpinButtonModule_1.SpinButtonModule.BASIC_STATE);
        }
        this.module.canSpin = true;
    };
    SpinButtonWhileSpinningState.prototype.onSpaceButtonClicked = function () {
        if (this.view.isSpinButtonVisibleAndEnabled()) {
            if (this._canContinueSpin && this._spinResponseReceived) {
                this.onSpinButtonClicked();
            }
        }
    };
    SpinButtonWhileSpinningState.prototype.onSpinButtonClicked = function () {
        if (this.module.validateQuickStop() && !this._wasQuickstopPressed) {
            this.view.disableSpinButton();
            this.emit(SpinButtonEvents_1.SpinButtonEvents.QUICKSTOP_PRESSED);
            this._wasQuickstopPressed = true;
        }
    };
    SpinButtonWhileSpinningState.prototype.onSpinResponse = function () {
        if (this._canContinueSpin && this.module.hasQuickstop) {
            this.view.enableSpinButton();
        }
        this._spinResponseReceived = true;
    };
    return SpinButtonWhileSpinningState;
}(ModuleState_1.ModuleState));
exports.SpinButtonWhileSpinningState = SpinButtonWhileSpinningState;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var SpinButtonEvents_1 = __webpack_require__(12);
var SpinButtonModule_1 = __webpack_require__(82);
var SpinButtonWhileSpinningState_1 = __webpack_require__(326);
var FlowModuleEvents_1 = __webpack_require__(0);
var GameSpinButtonModule_1 = __webpack_require__(644);
var GameSpinButtonWhileSpinningState = /** @class */ (function (_super) {
    __extends(GameSpinButtonWhileSpinningState, _super);
    function GameSpinButtonWhileSpinningState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._canContinueSpin = false;
        _this._spinResponseReceived = false;
        return _this;
    }
    GameSpinButtonWhileSpinningState.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(FlowModuleEvents_1.FlowModuleEvents.CAN_CONTINUE_SPIN, this.onCanContinueSpin);
        this.on(GameSpinButtonModule_1.GameSpinButtonModule.REGULATION_SPIN_DELAY_PASSED, this.onRegulationSpinDelayPassed);
    };
    GameSpinButtonWhileSpinningState.prototype.onSpaceButtonClicked = function () {
        if (this._canContinueSpin && this._spinResponseReceived) {
            this.onSpinButtonClicked();
        }
    };
    GameSpinButtonWhileSpinningState.prototype.onSpinButtonClicked = function () {
        if (this.module.validateQuickStop() && !this._wasQuickstopPressed && this._spinResponseReceived) {
            this.view.disableSpinButton();
            this.emit(SpinButtonEvents_1.SpinButtonEvents.QUICKSTOP_PRESSED);
            this._wasQuickstopPressed = true;
        }
    };
    GameSpinButtonWhileSpinningState.prototype.onRegulationSpinDelayPassed = function () {
        if (!this.hasSpinTimeRegulation()) {
            return;
        }
        if (this.module.regulationCanSpin && this.module.canSpin) {
            this.view.enableSpinButton();
            this.module.gotoState(SpinButtonModule_1.SpinButtonModule.BASIC_STATE);
        }
    };
    GameSpinButtonWhileSpinningState.prototype.onCanSpin = function () {
        if (this.hasSpinTimeRegulation()) {
            if (this.module.regulationCanSpin) {
                this.view.enableSpinButton();
                this.module.gotoState(SpinButtonModule_1.SpinButtonModule.BASIC_STATE);
            }
        }
        else {
            this.view.enableSpinButton();
            this.module.gotoState(SpinButtonModule_1.SpinButtonModule.BASIC_STATE);
        }
        this.module.canSpin = true;
    };
    GameSpinButtonWhileSpinningState.prototype.onAllReelsStopped = function () {
        this.view.disableSpinButton();
        this._canContinueSpin = false;
        this._spinResponseReceived = false;
    };
    GameSpinButtonWhileSpinningState.prototype.onCanContinueSpin = function () {
        if (!this.hasSpinTimeRegulation() && this._spinResponseReceived && this.module.hasQuickstop) {
            this.view.enableSpinButton();
        }
        this._canContinueSpin = true;
    };
    GameSpinButtonWhileSpinningState.prototype.onSpinResponse = function () {
        if (this._canContinueSpin) {
            _super.prototype.onSpinResponse.call(this);
        }
        this._spinResponseReceived = true;
    };
    GameSpinButtonWhileSpinningState.prototype.hasSpinTimeRegulation = function () {
        return this.module.hasSpinTimeRegulation();
    };
    return GameSpinButtonWhileSpinningState;
}(SpinButtonWhileSpinningState_1.SpinButtonWhileSpinningState));
exports.GameSpinButtonWhileSpinningState = GameSpinButtonWhileSpinningState;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var InFreeRoundsEvents = /** @class */ (function () {
    function InFreeRoundsEvents() {
    }
    InFreeRoundsEvents.DISCARD_PRESSED = 'InFreeRoundsEvents::DISCARD_PRESSED';
    return InFreeRoundsEvents;
}());
exports.InFreeRoundsEvents = InFreeRoundsEvents;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var View_1 = __webpack_require__(3);
var Spine_1 = __webpack_require__(25);
var SpriteButton_1 = __webpack_require__(55);
var SpineAnimation_1 = __webpack_require__(37);
var InFreeRoundsView = /** @class */ (function (_super) {
    __extends(InFreeRoundsView, _super);
    function InFreeRoundsView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._isButtonVisible = true;
        _this._isEnabled = true;
        _this._isNoDiscardButton = false;
        return _this;
    }
    InFreeRoundsView.prototype.showInGameScreen = function (freeGamesData, lastFreeGame, isAutoplay) {
        this.show();
        var animationName = 'IN_GAME_IDLE';
        if (lastFreeGame && lastFreeGame.gamesRemaining === 0) {
            animationName = 'IN_GAME_CONCLUSION';
        }
        this.showMenuAnimation(animationName, false);
        if (this._isButtonVisible) {
            this.showDiscardButton();
        }
        else {
            this.hideDiscardButton();
        }
        if (lastFreeGame && lastFreeGame.gamesRemaining === 0) {
            this._inGameDiscardButton.callback = null;
            this._inGameDiscardButton.interactive = false;
            this._inGameDiscardButton.buttonMode = false;
            this._isNoDiscardButton = true;
        }
        else {
            this._inGameDiscardButton.callback = this.onDiscardPressed.bind(this);
            this._isNoDiscardButton = false;
        }
        if (isAutoplay) {
            this.disableDiscardButton();
        }
        if (!this._isEnabled) {
            this.disableDiscardButton();
        }
        var freeGamesText = this.translator.getObject('BaseStrings', 'generic', 'g_freegames_freegamesn') || "FREE GAMES";
        if (lastFreeGame) {
            freeGamesText = freeGamesText.replace('{0}', "" + lastFreeGame.gamesRemaining);
            freeGamesText = freeGamesText.replace('{1}', "" + (lastFreeGame.gamesRemaining + lastFreeGame.gamesPlayed));
        }
        else {
            freeGamesText = freeGamesText.replace('{0}', "" + freeGamesData.gamesRemaining);
            freeGamesText = freeGamesText.replace('{1}', "" + freeGamesData.gamesAwarded);
        }
        this._ingameFreeGamesText.text = freeGamesText;
        this._ingameFreeGamesText.scale.x = 0.8;
        this._ingameFreeGamesText.scale.y = -0.8;
    };
    InFreeRoundsView.prototype.disableDiscardButton = function () {
        this._isEnabled = false;
        if (this._inGameDiscardButton) {
            this._inGameDiscardButton.interactive = false;
            this._inGameDiscardButton.buttonMode = false;
        }
    };
    InFreeRoundsView.prototype.enableDiscardButton = function () {
        if (this._isNoDiscardButton) {
            return;
        }
        this._isEnabled = true;
        if (this._inGameDiscardButton) {
            this._inGameDiscardButton.interactive = true;
            this._inGameDiscardButton.buttonMode = true;
        }
    };
    InFreeRoundsView.prototype.hideDiscardButton = function () {
        if (this._inGameDiscardButton) {
            this._inGameDiscardButton.visible = false;
        }
        this._isButtonVisible = false;
    };
    InFreeRoundsView.prototype.showDiscardButton = function () {
        if (this._inGameDiscardButton) {
            this._inGameDiscardButton.visible = true;
        }
        this._isButtonVisible = true;
    };
    InFreeRoundsView.prototype.removeScreen = function () {
        if (this._mainAnimation) {
            this._mainAnimation.forceDestroy();
            this.updateManager.remove(this._mainAnimation);
            this.container.removeChild(this._mainAnimation.container);
        }
    };
    InFreeRoundsView.prototype.setupButtons = function (screenSpine) {
        this._inGameDiscardButton = new SpriteButton_1.SpriteButton();
        this._ingameFreeGamesStyle = this.textStyles.breadTextFont;
        this._ingameFreeGamesStyle.wordWrapWidth = this.resolutionManager.resolution.width;
        this._ingameFreeGamesText = new PIXI.Text('', this._ingameFreeGamesStyle);
        this._ingameFreeGamesText.anchor.set(0.5);
        ////////////////////////////////////////////////////////////////////
        // In BaseGame Discard Button
        ////////////////////////////////////////////////////////////////////
        var ingameDiscardButtonUp = new PIXI.Sprite(this.resources.getSpritesheetTexture('MICROGAMING.json', 'FREEGAMES_DISCARD_BUTTON.png'));
        var ingameDiscardButtonDown = new PIXI.Sprite(this.resources.getSpritesheetTexture('MICROGAMING.json', 'FREEGAMES_DISCARD_BUTTON_CLICKED.png'));
        var ingameDiscardButtonOver = new PIXI.Sprite(this.resources.getSpritesheetTexture('MICROGAMING.json', 'FREEGAMES_DISCARD_BUTTON.png'));
        var ingameDiscardButtonDisabled = new PIXI.Sprite(this.resources.getSpritesheetTexture('MICROGAMING.json', 'FREEGAMES_DISCARD_BUTTON.png'));
        ingameDiscardButtonUp.anchor.set(0.5, 0.5);
        ingameDiscardButtonDown.anchor.set(0.5, 0.5);
        ingameDiscardButtonOver.anchor.set(0.5, 0.5);
        ingameDiscardButtonDisabled.anchor.set(0.5, 0.5);
        this._inGameDiscardButton.setFrames(ingameDiscardButtonUp, ingameDiscardButtonDown, ingameDiscardButtonOver, ingameDiscardButtonDisabled);
        var ingameFreeGamesTextSlot = screenSpine.slotContainers[screenSpine.skeleton.findSlotIndex('FREE_GAMES_TEXT')];
        ingameFreeGamesTextSlot.addChild(this._ingameFreeGamesText);
        this._ingameFreeGamesText.transform = ingameFreeGamesTextSlot.children[0].transform;
        ingameFreeGamesTextSlot.children[0].visible = false;
        var inGameDiscardButtonSlot = screenSpine.slotContainers[screenSpine.skeleton.findSlotIndex('IN_GAME_DISCARD_BUTTON')];
        inGameDiscardButtonSlot.addChild(this._inGameDiscardButton);
        this._inGameDiscardButton.transform = inGameDiscardButtonSlot.children[0].transform;
        inGameDiscardButtonSlot.children[0].visible = false;
    };
    InFreeRoundsView.prototype.onDiscardPressed = function () {
        this.emit(InFreeRoundsView.DISCARD_PRESSED);
    };
    InFreeRoundsView.prototype.showMenuAnimation = function (animationName, loop, stopOnComplete) {
        var _this = this;
        if (stopOnComplete === void 0) { stopOnComplete = true; }
        this.removeScreen();
        var spine = new Spine_1.Spine(this.resources.getSpine('FREE-GAMES_SCREENS.json'));
        this.setupButtons(spine);
        this._mainAnimation = new SpineAnimation_1.SpineAnimation(spine, animationName, loop, true);
        this._mainAnimation.container.position.set(this.resolutionManager.halfResolution.width, this.resolutionManager.halfResolution.height);
        this.container.addChild(this._mainAnimation.container);
        if (stopOnComplete) {
            this._mainAnimation.setOnComplete(function () {
                _this._mainAnimation.stop();
            });
        }
        this.updateManager.add(this._mainAnimation);
        this._mainAnimation.start();
        return this._mainAnimation;
    };
    InFreeRoundsView.DISCARD_PRESSED = 'DISCARD_PRESSED';
    return InFreeRoundsView;
}(View_1.View));
exports.InFreeRoundsView = InFreeRoundsView;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AutoPlayButtonViewEvents = /** @class */ (function () {
    function AutoPlayButtonViewEvents() {
    }
    AutoPlayButtonViewEvents.AUTO_PLAYBUTTON_CLICKED = 'AutoPlayButtonViewEvents::__AUTOPLAY_BUTTON_CLICKED__';
    AutoPlayButtonViewEvents.STOP_AUTOPLAY_BUTTON_CLICKED = 'AutoPlayButtonViewEvents::__STOP_AUTOPLAY_BUTTON_CLICKED__';
    return AutoPlayButtonViewEvents;
}());
exports.AutoPlayButtonViewEvents = AutoPlayButtonViewEvents;


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var FlowModuleEvents_1 = __webpack_require__(0);
var Module_1 = __webpack_require__(2);
var Views_1 = __webpack_require__(8);
var ReelsEvents_1 = __webpack_require__(4);
var AutoplayHandlerEvents_1 = __webpack_require__(56);
var StopAutoplayButtonEvents_1 = __webpack_require__(30);
var AutoPlayButtonViewEvents_1 = __webpack_require__(330);
var AutoPlayButtonBasicState_1 = __webpack_require__(661);
var AutoPlayButtonEvents_1 = __webpack_require__(322);
var InfoPopupTypes_1 = __webpack_require__(74);
var InfoPopupEvents_1 = __webpack_require__(63);
var SpinButtonEvents_1 = __webpack_require__(12);
var FreeSpinsEvents_1 = __webpack_require__(6);
var StartScreenEvents_1 = __webpack_require__(22);
var AutoPlayButtonWhileSpinningState_1 = __webpack_require__(662);
var AutoPlayButtonModule = /** @class */ (function (_super) {
    __extends(AutoPlayButtonModule, _super);
    function AutoPlayButtonModule() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._autoPlayActive = false;
        _this._isFreeSpins = false;
        _this._startscreenExitFinished = false;
        return _this;
    }
    AutoPlayButtonModule.prototype.afterInit = function () {
        _super.prototype.afterInit.call(this);
        this.hideAutoplayButton();
    };
    AutoPlayButtonModule.prototype.restore = function () {
        _super.prototype.restore.call(this);
        if (this.logic.isFreeSpinsStarted) {
            this._isFreeSpins = true;
            this.hideAutoplayButton();
        }
    };
    AutoPlayButtonModule.prototype.setupViews = function () {
        if (this.system.shouldUseMultipleViews()) {
            this.setView(Views_1.Views.AUTOPLAY_VIEW_MOBILE);
        }
        else {
            this.setView(Views_1.Views.AUTOPLAY_VIEW);
        }
    };
    AutoPlayButtonModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(AutoplayHandlerEvents_1.AutoplayHandlerEvents.START_AUTOPLAY_SPIN, this.onStartAutoplaySpin);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_INTRO_STARTED, this.onFreeSpinsStarted);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_OUTRO_FINISHED, this.onFreeSpinsFinished);
        this.onCurrentStateHandle(StopAutoplayButtonEvents_1.StopAutoplayButtonEvents.STOP_AUTOPLAY_BUTTON_CLICKED);
        this.on(FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN, this.onFreeSpinsWin);
        this.on(FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_START, this.onBonusGameStarted);
        this.on(FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_RESTORED, this.onBonusGameRestored);
        this.on(SpinButtonEvents_1.SpinButtonEvents.SPIN_PRESSED_NOT_ENOUGH_MONEY, this.onNotEnoughMoneyToSpin);
        this.on(ReelsEvents_1.ReelsEvents.REELS_SPINNING_STARTED, this.onReelsStartedSpinning);
        this.on(InfoPopupEvents_1.InfoPopupEvents.INFO_POPUP_CLOSED, this.onInfoPopupOkClicked);
        this.on(StartScreenEvents_1.StartScreenEvents.EXIT_FINISHED, this.onStartScreenExitFinished);
        this.onCurrentStateHandle(FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN);
        this.onViewEmitEvent(AutoPlayButtonViewEvents_1.AutoPlayButtonViewEvents.AUTO_PLAYBUTTON_CLICKED, AutoPlayButtonEvents_1.AutoPlayButtonEvents.AUTO_PLAYBUTTON_CLICKED);
    };
    AutoPlayButtonModule.prototype.setupStates = function () {
        this.addState(new AutoPlayButtonBasicState_1.AutoPlayButtonBasicState(this, AutoPlayButtonModule.BASIC_STATE));
        this.addState(new AutoPlayButtonWhileSpinningState_1.AutoPlayButtonWhileSpinningState(this, AutoPlayButtonModule.WHILESPINNING_STATE));
    };
    AutoPlayButtonModule.prototype.enterFirstState = function () {
        this.changeStateTo(AutoPlayButtonModule.BASIC_STATE);
    };
    AutoPlayButtonModule.prototype.onStartScreenExitFinished = function () {
        this._startscreenExitFinished = true;
        this.showAutoplayButton();
    };
    AutoPlayButtonModule.prototype.onFreeSpinsStarted = function () {
        this._isFreeSpins = true;
        this.hideAutoplayButton();
        this.disableAutoplayButton();
    };
    AutoPlayButtonModule.prototype.onFreeSpinsFinished = function () {
        this._isFreeSpins = false;
        if (!this.autoPlayActive) {
            this.showAutoplayButton();
        }
        this.enableAutoplayButton();
    };
    AutoPlayButtonModule.prototype.onNotEnoughMoneyToSpin = function () {
        this.showAutoplayButton();
    };
    AutoPlayButtonModule.prototype.onInfoPopupOkClicked = function (eventId, eventType) {
        if (eventType === InfoPopupTypes_1.InfoPopupTypes.RESTORE || eventType === InfoPopupTypes_1.InfoPopupTypes.NO_MONEY) {
            this.showAutoplayButton();
        }
        if (eventType === InfoPopupTypes_1.InfoPopupTypes.RESTORE) {
            this.hideAutoplayButton();
        }
    };
    AutoPlayButtonModule.prototype.onCanSpin = function () {
        this.gotoState(AutoPlayButtonModule.BASIC_STATE);
    };
    AutoPlayButtonModule.prototype.onStartAutoplaySpin = function () {
        if (this.logic.isEnoughMoneyForSpin()) {
            this.autoPlayActive = true;
            this.hideAutoplayButton();
        }
        else {
            this.autoPlayActive = false;
            this.showAutoplayButton();
        }
    };
    AutoPlayButtonModule.prototype.onFreeSpinsWin = function () {
        this._isFreeSpins = true;
        this.hideAutoplayButton();
    };
    AutoPlayButtonModule.prototype.onBonusGameStarted = function () {
        this.hideAutoplayButton();
        this.disableAutoplayButton();
    };
    AutoPlayButtonModule.prototype.onBonusGameRestored = function () {
        this.hideAutoplayButton();
        this.disableAutoplayButton();
    };
    AutoPlayButtonModule.prototype.onReelsStartedSpinning = function () {
        this.gotoState(AutoPlayButtonModule.WHILESPINNING_STATE);
    };
    AutoPlayButtonModule.prototype.hideAutoplayButton = function () {
        this.view.hideAutoplayButton();
    };
    AutoPlayButtonModule.prototype.showAutoplayButton = function () {
        if (!this._isFreeSpins) {
            this.view.showAutoplayButton();
        }
    };
    AutoPlayButtonModule.prototype.enableAutoplayButton = function () {
        this.view.enableAutoplayButton();
    };
    AutoPlayButtonModule.prototype.disableAutoplayButton = function () {
        this.view.disableAutoplayButton();
    };
    AutoPlayButtonModule.prototype.showView = function () {
        if (!this._isFreeSpins) {
            this.view.show();
            this.view.showAutoplayButton();
        }
    };
    AutoPlayButtonModule.prototype.hideView = function () {
        this.view.hide();
        this.view.hideAutoplayButton();
    };
    Object.defineProperty(AutoPlayButtonModule.prototype, "autoPlayActive", {
        get: function () {
            return this._autoPlayActive;
        },
        set: function (value) {
            this._autoPlayActive = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutoPlayButtonModule.prototype, "startscreenExitFinished", {
        get: function () {
            return this._startscreenExitFinished;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutoPlayButtonModule.prototype, "isFreeSpins", {
        get: function () {
            return this._isFreeSpins;
        },
        enumerable: true,
        configurable: true
    });
    AutoPlayButtonModule.BASIC_STATE = 'basic';
    AutoPlayButtonModule.WHILESPINNING_STATE = 'whilespinning';
    return AutoPlayButtonModule;
}(Module_1.Module));
exports.AutoPlayButtonModule = AutoPlayButtonModule;


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Module_1 = __webpack_require__(2);
var Views_1 = __webpack_require__(8);
var AutoplayHandlerEvents_1 = __webpack_require__(56);
var FlowModuleEvents_1 = __webpack_require__(0);
var FreeSpinsEvents_1 = __webpack_require__(6);
var BetButtonEvents_1 = __webpack_require__(320);
var BetButtonViewEvents_1 = __webpack_require__(245);
var StopAutoplayButtonEvents_1 = __webpack_require__(30);
var InfoPopupEvents_1 = __webpack_require__(63);
var InfoPopupTypes_1 = __webpack_require__(74);
var ReelsEvents_1 = __webpack_require__(4);
var StartScreenEvents_1 = __webpack_require__(22);
var BetButtonBasicState_1 = __webpack_require__(664);
var BetButtonWhileSpinningState_1 = __webpack_require__(665);
var BetButtonModule = /** @class */ (function (_super) {
    __extends(BetButtonModule, _super);
    function BetButtonModule() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._autoPlayActive = false;
        _this._isFreeSpins = false;
        _this._startscreenExitFinished = false;
        return _this;
    }
    BetButtonModule.prototype.afterInit = function () {
        _super.prototype.afterInit.call(this);
        this.hideBetButton();
    };
    BetButtonModule.prototype.restore = function () {
        _super.prototype.restore.call(this);
        if (this.logic.isFreeSpinsStarted) {
            this._isFreeSpins = true;
            this.hideBetButton();
        }
    };
    BetButtonModule.prototype.setupViews = function () {
        if (this.system.shouldUseMultipleViews()) {
            this.setView(Views_1.Views.BET_VIEW_MOBILE);
        }
        else {
            this.setView(Views_1.Views.BET_VIEW);
        }
    };
    BetButtonModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(AutoplayHandlerEvents_1.AutoplayHandlerEvents.START_AUTOPLAY_SPIN, this.onStartAutoplaySpin);
        this.onCurrentStateHandle(StopAutoplayButtonEvents_1.StopAutoplayButtonEvents.STOP_AUTOPLAY_BUTTON_CLICKED);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_INTRO_STARTED, this.onFreeSpinsStarted);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_OUTRO_FINISHED, this.onFreeSpinsFinished);
        this.on(FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN, this.onFreeSpinsWin);
        this.on(FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_START, this.onBonusGameStarted);
        this.on(FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_RESTORED, this.onBonusGameRestored);
        this.on(ReelsEvents_1.ReelsEvents.REELS_SPINNING_STARTED, this.onReelsSpinningStarted);
        this.on(InfoPopupEvents_1.InfoPopupEvents.INFO_POPUP_CLOSED, this.onInfoPopupOkClicked);
        this.on(StartScreenEvents_1.StartScreenEvents.EXIT_FINISHED, this.onStartScreenExitFinished);
        this.onCurrentStateHandle(FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN);
        this.onViewEmitEvent(BetButtonViewEvents_1.BetButtonViewEvents.BET_BUTTON_CLICKED, BetButtonEvents_1.BetButtonEvents.BET_BUTTON_CLICKED);
    };
    BetButtonModule.prototype.setupStates = function () {
        this.addState(new BetButtonBasicState_1.BetButtonBasicState(this, BetButtonModule.BASIC));
        this.addState(new BetButtonWhileSpinningState_1.BetButtonWhileSpinningState(this, BetButtonModule.WHILESPINNING));
    };
    BetButtonModule.prototype.enterFirstState = function () {
        this.gotoState(BetButtonModule.BASIC);
    };
    BetButtonModule.prototype.onStartScreenExitFinished = function () {
        this._startscreenExitFinished = true;
        this.showBetButton();
    };
    BetButtonModule.prototype.onInfoPopupOkClicked = function (eventId, eventType) {
        if (eventType === InfoPopupTypes_1.InfoPopupTypes.RESTORE || eventType === InfoPopupTypes_1.InfoPopupTypes.NO_MONEY) {
            this.showBetButton();
        }
        if (eventType === InfoPopupTypes_1.InfoPopupTypes.RESTORE) {
            this.hideBetButton();
        }
    };
    BetButtonModule.prototype.onFreeSpinsStarted = function () {
        this._isFreeSpins = true;
        this.hideBetButton();
    };
    BetButtonModule.prototype.onFreeSpinsFinished = function () {
        this._isFreeSpins = false;
        if (!this.autoPlayActive) {
            this.showBetButton();
        }
        this.enableBetButton();
    };
    BetButtonModule.prototype.onFreeSpinsWin = function () {
        this._isFreeSpins = true;
        this.hideBetButton();
    };
    BetButtonModule.prototype.onBonusGameStarted = function () {
        this.hideBetButton();
        this.disableBetButton();
    };
    BetButtonModule.prototype.onBonusGameRestored = function () {
        this.hideBetButton();
        this.disableBetButton();
    };
    BetButtonModule.prototype.onStartAutoplaySpin = function () {
        if (this.logic.isEnoughMoneyForSpin()) {
            this.autoPlayActive = true;
            this.hideBetButton();
        }
        else {
            this.autoPlayActive = false;
            this.showBetButton();
        }
    };
    BetButtonModule.prototype.onCanSpin = function () {
        this.gotoState(BetButtonModule.BASIC);
    };
    BetButtonModule.prototype.onReelsSpinningStarted = function () {
        this.gotoState(BetButtonModule.WHILESPINNING);
    };
    BetButtonModule.prototype.hideBetButton = function () {
        this.view.hideBetButton();
    };
    BetButtonModule.prototype.showBetButton = function () {
        if (!this._isFreeSpins) {
            this.view.showBetButton();
        }
    };
    BetButtonModule.prototype.enableBetButton = function () {
        this.view.enableBetButton();
    };
    BetButtonModule.prototype.disableBetButton = function () {
        this.view.disableBetButton();
    };
    BetButtonModule.prototype.showView = function () {
        if (!this._isFreeSpins) {
            this.view.show();
            this.showBetButton();
        }
    };
    BetButtonModule.prototype.hideView = function () {
        this.view.hide();
        this.hideBetButton();
    };
    Object.defineProperty(BetButtonModule.prototype, "autoPlayActive", {
        get: function () {
            return this._autoPlayActive;
        },
        set: function (value) {
            this._autoPlayActive = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BetButtonModule.prototype, "startscreenExitFinished", {
        get: function () {
            return this._startscreenExitFinished;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BetButtonModule.prototype, "isFreeSpins", {
        get: function () {
            return this._isFreeSpins;
        },
        enumerable: true,
        configurable: true
    });
    BetButtonModule.BET_CLICKED_STATE = 'betClicked';
    BetButtonModule.BASIC = 'basic';
    BetButtonModule.WHILESPINNING = 'whilespinning';
    return BetButtonModule;
}(Module_1.Module));
exports.BetButtonModule = BetButtonModule;


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SwipeInteractionViewEvents = /** @class */ (function () {
    function SwipeInteractionViewEvents() {
    }
    SwipeInteractionViewEvents.DRAGGING_STARTED = 'SwipeInteractionViewEvents::DRAGGING_STARTED';
    SwipeInteractionViewEvents.DRAGGING_FINISHED = 'SwipeInteractionViewEvents::DRAGGING_FINISHED';
    SwipeInteractionViewEvents.START_SPIN = 'SwipeInteractionViewEvents::START_SPIN';
    // Occurs when the distance is too great and the object should bounce back.
    SwipeInteractionViewEvents.REEL_BOUNCE_BACK_STARTED = 'SwipeInteractionViewEvents::REEL_BOUNCE_BACK_STARTED';
    SwipeInteractionViewEvents.REEL_BOUNCE_BACK_FINISHED = 'SwipeInteractionViewEvents::REEL_BOUNCE_BACK_FINISHED';
    return SwipeInteractionViewEvents;
}());
exports.SwipeInteractionViewEvents = SwipeInteractionViewEvents;


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var View_1 = __webpack_require__(3);
var StartScreenViewEvents_1 = __webpack_require__(335);
var Spine_1 = __webpack_require__(25);
var SpineAnimationMultiTrack_1 = __webpack_require__(147);
var Tween_1 = __webpack_require__(19);
var Easing_1 = __webpack_require__(16);
var SpriteGraphics_1 = __webpack_require__(62);
var StartScreenView = /** @class */ (function (_super) {
    __extends(StartScreenView, _super);
    function StartScreenView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._exitFinished = false;
        _this._currentFeature = 1;
        _this._playingExitAnimation = false;
        return _this;
    }
    StartScreenView.prototype.init = function () {
        _super.prototype.init.call(this);
        this.setupIntro();
        this.setupInput();
        this.setupTextStyle();
    };
    StartScreenView.prototype.translate = function () {
        var hasMorePages = true;
        var currentPage = 1;
        while (hasMorePages) {
            hasMorePages = !!this._introFeatures.skeleton.findBone("FEATURE_" + currentPage);
            if (hasMorePages) {
                var hasMoreTitles = true;
                var currentTitle = 1;
                while (hasMoreTitles) {
                    hasMoreTitles = !!this.spineUtils.findSlotContainerByName(this._introFeatures, "FEATURE_" + currentPage + "_" + currentTitle + "_TITLE");
                    if (hasMoreTitles) {
                        this.spineUtils.replaceElementInSpine(this._introFeatures, "FEATURE_" + currentPage + "_" + currentTitle + "_TITLE", new PIXI.Sprite(this.resources.getLocaleTextImage("FEATURE_" + currentPage + "_" + currentTitle + "_TITLE.png")));
                    }
                    currentTitle++;
                }
            }
            currentPage++;
        }
        this._totalFeatures = currentPage - 2;
        for (var i = 1; i <= currentPage; i++) {
            var hasTextContainer = !!this.spineUtils.findSlotContainerByName(this._introFeatures, "FEATURE_" + i + "_TEXT");
            if (hasTextContainer) {
                this.spineUtils.replaceElementInSpine(this._introFeatures, "FEATURE_" + i + "_TEXT", this.createTranslatedTextObject(this.translator.getObject('BaseStrings', 'StartScreen', "page" + i, 'text')));
            }
        }
    };
    StartScreenView.prototype.createTranslatedTextObject = function (text) {
        var textObject = new PIXI.Text(text, this._featureTextStyle);
        return textObject;
    };
    StartScreenView.prototype.setupTextStyle = function () {
        var featureBackgroundReference = this._introFeatures.skeleton.findSlot('TEXT_AREA').attachment;
        var descriptionWordWrapWidth = featureBackgroundReference.width *
            featureBackgroundReference.scaleX;
        this._featureTextStyle = this.textStyles.featureTextStyle;
        this._featureTextStyle.wordWrapWidth = descriptionWordWrapWidth;
    };
    StartScreenView.prototype.playIntroAnimation = function () {
        var _this = this;
        this.container.addChild(this._introScreen);
        this.container.addChild(this._introFeatures);
        this.container.addChild(this._extraBackground);
        this._extraBackground.interactive = true;
        // TODO: Add sounds.
        this.updateManager.add(this._featuresAnimations);
        this.updateManager.add(this._screenAnimations);
        this._featuresAnimations.play('FEATURE_1_ENTRY', 0, false);
        this._screenAnimations.play('START', 0, false);
        this._featuresAnimations.setOnceOnComplete(function () {
            _this.emitIntroFinished();
            _this.playIdleFeature();
            _this._playButton.visible = true;
            _this._playButton.enable();
            _this._prevFeatureButton.visible = true;
            _this._prevFeatureButton.enable();
            _this._nextFeatureButton.visible = true;
            _this._nextFeatureButton.enable();
        });
        this.container.setChildIndex(this._extraBackground, 0);
        this.emitIntroAnimationStarted();
        this.playIntroMusic();
    };
    StartScreenView.prototype.playIntroMusic = function () {
        this.soundPlayer.playMusic('musicLobby');
    };
    StartScreenView.prototype.proceed = function () {
        if (this._playButton.interactive) {
            this.onPlayPressed();
        }
        else if (this._playingExitAnimation) {
            this.skipIntro();
        }
    };
    StartScreenView.prototype.previousFeature = function () {
        if (this._nextFeatureButton.interactive) {
            this._currentFeature = (this._currentFeature % this._totalFeatures) + 1;
            // TODO: Add sounds
            this._featuresAnimations.play("FEATURE_" + this._currentFeature + "_ENTER_RIGHT", 0, false);
            this._featuresAnimations.setOnceOnComplete(this.playIdleFeature.bind(this));
        }
    };
    StartScreenView.prototype.nextFeature = function () {
        if (this._prevFeatureButton.interactive) {
            // TODO: Add sounds
            this._currentFeature = this._currentFeature - 1 < 1 ? this._totalFeatures : (this._currentFeature - 1) % this._totalFeatures;
            this._featuresAnimations.play("FEATURE_" + this._currentFeature + "_ENTER_LEFT", 0, false);
            this._featuresAnimations.setOnceOnComplete(this.playIdleFeature.bind(this));
        }
    };
    StartScreenView.prototype.emitIntroAnimationStarted = function () {
        this.emit(StartScreenViewEvents_1.StartScreenViewEvents.INTRO_STARTED);
    };
    StartScreenView.prototype.emitIntroIdle = function () {
        this.emit(StartScreenViewEvents_1.StartScreenViewEvents.INTRO_IDLE);
    };
    StartScreenView.prototype.emitIntroFinished = function () {
        this.emit(StartScreenViewEvents_1.StartScreenViewEvents.INTRO_FINISHED);
    };
    StartScreenView.prototype.emitExitAnimationStarted = function () {
        this.emit(StartScreenViewEvents_1.StartScreenViewEvents.EXIT_STARTED);
        this.soundPlayer.play('intro');
    };
    StartScreenView.prototype.emitExitAnimationFinished = function () {
        this.emit(StartScreenViewEvents_1.StartScreenViewEvents.EXIT_FINISHED);
    };
    StartScreenView.prototype.onExitFinished = function () {
        if (!this._exitFinished) {
            this._exitFinished = true;
            this.emitExitAnimationFinished();
            this.cleanupAll();
        }
    };
    StartScreenView.prototype.skipIntro = function () {
        this.onExitFinished();
        this.soundPlayer.stop('intro');
    };
    StartScreenView.prototype.cleanupAll = function () {
        this.cleanUpAnimation(this._screenAnimations);
        this.cleanUpAnimation(this._featuresAnimations);
        this.safeDestroy(this._introScreen);
        this.safeDestroy(this._introFeatures);
        this.safeDestroy(this._nextFeatureButton);
        this.safeDestroy(this._prevFeatureButton);
        this.safeDestroy(this._extraBackground);
    };
    StartScreenView.prototype.safeDestroy = function (object) {
        if (object && object.destroy && object.texture) {
            object.destroy();
        }
    };
    StartScreenView.prototype.cleanUpAnimation = function (animation) {
        if (animation && animation.stop) {
            animation.stop();
            this.updateManager.remove(animation);
            animation = null;
        }
    };
    StartScreenView.prototype.setupIntro = function () {
        this._introScreen = new Spine_1.Spine(this.resources.getSpine('STARTSCREEN.json', this.viewType));
        this._introFeatures = new Spine_1.Spine(this.resources.getSpine('FEATURE_SCREENS.json', this.viewType));
        this._extraBackground = SpriteGraphics_1.SpriteGraphics.makeHiddenRectangle(this.resolutionManager.resolution.width, this.resolutionManager.resolution.height);
        var introPosition = this.layout.getCenterOfScreen(this.viewType);
        this._introFeatures.position.set(introPosition.x, introPosition.y);
        this._screenAnimations = new SpineAnimationMultiTrack_1.SpineAnimationMultiTrack(this._introScreen);
        this._featuresAnimations = new SpineAnimationMultiTrack_1.SpineAnimationMultiTrack(this._introFeatures);
        this._screenAnimations.start();
        this._featuresAnimations.start();
        this.setupTranslatedWinUpTo();
    };
    StartScreenView.prototype.setupTranslatedWinUpTo = function () { };
    StartScreenView.prototype.setupInput = function () {
        this.setupPlayButton();
        this.setupFeatureArrows();
    };
    StartScreenView.prototype.setupPlayButton = function () {
        this._playButton = this.spineUtils.createLocalizedSpineButton('PLAY_BUTTON.json', this.onPlayPressed.bind(this), ['PLAY_BUTTON.png', 'PLAY_BUTTON_CLICKED.png', 'PLAY_BUTTON_HOVER.png', 'PLAY_BUTTON_DISABLED.png'], ['BUTTON', 'PLAY_BUTTON_CLICKED', 'PLAY_BUTTON_HOVER', 'PLAY_BUTTON_DISABLED'], true, false, false, false);
        this.spineUtils.replaceElementInSpine(this._introScreen, 'PLAY_BUTTON', this._playButton);
        this._playButton.disable();
        this._playButton.visible = false;
    };
    StartScreenView.prototype.setupFeatureArrows = function () {
        this._nextFeatureButton = this.spineUtils.createSpineButton('ARROW_BUTTON.json', this.onNextFeatureClicked.bind(this), true, false, false, false);
        this.spineUtils.replaceElementInSpine(this._introScreen, 'ARROW_RIGHT', this._nextFeatureButton);
        this._nextFeatureButton.visible = false;
        this._nextFeatureButton.disable();
        this._prevFeatureButton = this.spineUtils.createSpineButton('ARROW_BUTTON.json', this.onPreviousFeatureClicked.bind(this), true, false, false, false);
        this.spineUtils.replaceElementInSpine(this._introScreen, 'ARROW_LEFT', this._prevFeatureButton);
        this._prevFeatureButton.visible = false;
        this._prevFeatureButton.disable();
        if (this.device.isMobile) {
            this._nextFeatureButton.setOnClickIsOverState(false);
            this._prevFeatureButton.setOnClickIsOverState(false);
        }
    };
    StartScreenView.prototype.onPlayPressed = function () {
        if (this._playButton.interactive) {
            this.emit(StartScreenView.PLAY_BUTTON_CLICKED);
            this.soundPlayer.play('buttonClick');
            this._playButton.interactive = false;
            this._extraBackground.on('click', this.skipIntro.bind(this));
            this._extraBackground.on('touchend', this.skipIntro.bind(this));
            this.playExitAnimation();
        }
    };
    StartScreenView.prototype.playIdleFeature = function () {
        this._featuresAnimations.play("FEATURE_" + this._currentFeature + "_IDLE", 0, true);
    };
    StartScreenView.prototype.playExitAnimation = function () {
        var _this = this;
        this._screenAnimations.play('EXIT', 0, false);
        var featuresExitTween = new Tween_1.Tween(this._introFeatures.position)
            .to({ y: +2000 }, 500)
            .easing(Easing_1.Easing.Back.InOut)
            .start();
        this.updateManager.add(featuresExitTween);
        this._introScreen.alpha = 1;
        var backgroundScreenRemoval = new Tween_1.Tween(this._introScreen)
            .to({ alpha: 0 }, 1500)
            .easing(Easing_1.Easing.Sinusoidal.In)
            .onComplete(function () {
            _this.onExitFinished();
        })
            .start();
        this.updateManager.add(backgroundScreenRemoval);
        // TODO: Add sounds.
        this.emitExitAnimationStarted();
        this._playingExitAnimation = true;
    };
    StartScreenView.prototype.onProceedPressed = function () {
        this.soundPlayer.play('buttonClick');
        this.proceed();
    };
    StartScreenView.prototype.onNextFeatureClicked = function () {
        this.soundPlayer.play('buttonClick');
        this.previousFeature();
    };
    StartScreenView.prototype.onPreviousFeatureClicked = function () {
        this.soundPlayer.play('buttonClick');
        this.nextFeature();
    };
    StartScreenView.PLAY_BUTTON_CLICKED = 'StartScreenView::PLAY_BUTTON_CLICKED';
    return StartScreenView;
}(View_1.View));
exports.StartScreenView = StartScreenView;


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var StartScreenViewEvents = /** @class */ (function () {
    function StartScreenViewEvents() {
    }
    StartScreenViewEvents.INTRO_STARTED = 'StartScreenViewEvents::GAME_VIEW_INTRO_STARTED';
    StartScreenViewEvents.INTRO_IDLE = 'StartScreenViewEvents::GAME_VIEW_INTRO_IDLE';
    StartScreenViewEvents.INTRO_FINISHED = 'StartScreenViewEvents::GAME_VIEW_INTRO_FINISHED';
    StartScreenViewEvents.EXIT_STARTED = 'StartScreenViewEvents::GAME_VIEW_INTRO_EXIT_STARTED';
    StartScreenViewEvents.EXIT_FINISHED = 'StartScreenViewEvents::GAME_VIEW_INTRO_EXIT_FINISHED';
    return StartScreenViewEvents;
}());
exports.StartScreenViewEvents = StartScreenViewEvents;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Module_1 = __webpack_require__(2);
var MenuButtonEvents_1 = __webpack_require__(152);
var MainMenuEvents_1 = __webpack_require__(44);
var MainMenuViewEvents_1 = __webpack_require__(169);
var MainMenuBasicState_1 = __webpack_require__(682);
var MainMenuOpenState_1 = __webpack_require__(683);
var Views_1 = __webpack_require__(8);
var LogicEvents_1 = __webpack_require__(11);
var SpinButtonEvents_1 = __webpack_require__(12);
var AutoplayHandlerEvents_1 = __webpack_require__(56);
var AutoplayMenuEvents_1 = __webpack_require__(33);
var FreeSpinsEvents_1 = __webpack_require__(6);
var RelaxEvents_1 = __webpack_require__(167);
var MENU;
(function (MENU) {
    MENU[MENU["PAYTABLE"] = 0] = "PAYTABLE";
    MENU[MENU["SETTINGS"] = 1] = "SETTINGS";
    MENU[MENU["INFO"] = 2] = "INFO";
})(MENU = exports.MENU || (exports.MENU = {}));
var MainMenuModule = /** @class */ (function (_super) {
    __extends(MainMenuModule, _super);
    function MainMenuModule() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._isInAutoplay = false;
        _this._lastMenu = MENU.PAYTABLE;
        return _this;
    }
    MainMenuModule.prototype.setupStates = function () {
        this.addState(new MainMenuBasicState_1.MainMenuBasicState(this, MainMenuModule.BASIC));
        this.addState(new MainMenuOpenState_1.MainMenuOpenState(this, MainMenuModule.OPEN));
    };
    MainMenuModule.prototype.enterFirstState = function () {
        this.changeStateTo(MainMenuModule.BASIC);
    };
    MainMenuModule.prototype.setupViews = function () {
        if (this.system.shouldUseMultipleViews()) {
            this.setView(Views_1.Views.MAIN_MENU_VIEW_MOBILE);
        }
        else {
            this.setView(Views_1.Views.MAIN_MENU_VIEW);
        }
    };
    MainMenuModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(MainMenuEvents_1.MainMenuEvents.MAIN_MENU_CLOSE_CLICKED, this.hideMenu);
        this.on(MenuButtonEvents_1.MenuButtonEvents.MENU_BUTTON_CLICKED, this.showMenu);
        this.on(AutoplayMenuEvents_1.AutoplayMenuEvents.ACCEPTED, this.onStartAutoplay);
        this.on(AutoplayHandlerEvents_1.AutoplayHandlerEvents.AUTOPLAY_STOPPED, this.onAutoplayStopped);
        this.on(SpinButtonEvents_1.SpinButtonEvents.SPACE_BUTTON_CLICKED, this.onSpaceBarClicked);
        this.onView(MainMenuViewEvents_1.MainMenuViewEvents.MAIN_MENU_CLOSE_CLICKED, this.hideMenu);
        this.onViewEmitEvent(MainMenuViewEvents_1.MainMenuViewEvents.MAIN_MENU_INFO_OPEN, MainMenuEvents_1.MainMenuEvents.MAIN_MENU_INFO_OPEN);
        this.onViewEmitEvent(MainMenuViewEvents_1.MainMenuViewEvents.MAIN_MENU_LOBBY_OPEN, MainMenuEvents_1.MainMenuEvents.MAIN_MENU_LOBBY_OPEN);
        this.onViewEmitEvent(MainMenuViewEvents_1.MainMenuViewEvents.MAIN_MENU_SETTINGS_OPEN, MainMenuEvents_1.MainMenuEvents.MAIN_MENU_SETTINGS_OPEN);
        this.onViewEmitEvent(MainMenuViewEvents_1.MainMenuViewEvents.MAIN_MENU_PAYTABLE_OPEN, MainMenuEvents_1.MainMenuEvents.MAIN_MENU_PAYTABLE_OPEN);
        this.onViewEmitEvent(MainMenuViewEvents_1.MainMenuViewEvents.MAIN_MENU_INFO_CLOSE, MainMenuEvents_1.MainMenuEvents.MAIN_MENU_INFO_CLOSE);
        this.onViewEmitEvent(MainMenuViewEvents_1.MainMenuViewEvents.MAIN_MENU_LOBBY_CLOSE, MainMenuEvents_1.MainMenuEvents.MAIN_MENU_LOBBY_CLOSE);
        this.onViewEmitEvent(MainMenuViewEvents_1.MainMenuViewEvents.MAIN_MENU_SETTINGS_CLOSE, MainMenuEvents_1.MainMenuEvents.MAIN_MENU_SETTINGS_CLOSE);
        this.onViewEmitEvent(MainMenuViewEvents_1.MainMenuViewEvents.MAIN_MENU_PAYTABLE_CLOSE, MainMenuEvents_1.MainMenuEvents.MAIN_MENU_PAYTABLE_CLOSE);
        this.on(MainMenuEvents_1.MainMenuEvents.MAIN_MENU_INFO_OPEN, this.setLastMenu.bind(this, MENU.INFO));
        this.on(MainMenuEvents_1.MainMenuEvents.MAIN_MENU_LOBBY_OPEN, this.setLastMenu.bind(this, MENU.PAYTABLE));
        this.on(MainMenuEvents_1.MainMenuEvents.MAIN_MENU_SETTINGS_OPEN, this.setLastMenu.bind(this, MENU.SETTINGS));
        this.on(MainMenuEvents_1.MainMenuEvents.MAIN_MENU_PAYTABLE_OPEN, this.setLastMenu.bind(this, MENU.PAYTABLE));
        this.onCurrentStateHandle(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_INTRO_STARTED);
        this.onCurrentStateHandle(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_OUTRO_STARTED);
        this.onCurrentStateHandle(RelaxEvents_1.RelaxEvents.SHOW_REALITY_CHECK);
        this.onCurrentStateHandle(LogicEvents_1.LogicEvents.ERROR_RESPONSE);
    };
    MainMenuModule.prototype.onStartAutoplay = function () {
        this._isInAutoplay = true;
    };
    MainMenuModule.prototype.onAutoplayStopped = function () {
        this._isInAutoplay = false;
    };
    MainMenuModule.prototype.onSpaceBarClicked = function () {
        if (!this._isInAutoplay) {
            this.currentState.handle(SpinButtonEvents_1.SpinButtonEvents.SPACE_BUTTON_CLICKED);
        }
    };
    MainMenuModule.prototype.setLastMenu = function (menu) {
        this._lastMenu = menu;
    };
    MainMenuModule.prototype.showMenu = function () {
        this.gotoState(MainMenuModule.OPEN);
    };
    MainMenuModule.prototype.hideMenu = function () {
        this.gotoState(MainMenuModule.BASIC);
    };
    MainMenuModule.BASIC = 'BASIC';
    MainMenuModule.OPEN = 'OPEN';
    return MainMenuModule;
}(Module_1.Module));
exports.MainMenuModule = MainMenuModule;


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(59);
__webpack_require__(220);
__webpack_require__(222);
__webpack_require__(440);
__webpack_require__(139);
var DI_1 = __webpack_require__(51);
var RecodeGame_1 = __webpack_require__(441);
var CoreDI_1 = __webpack_require__(32);
var RecodeGameInstaller_1 = __webpack_require__(487);
var System_1 = __webpack_require__(52);
var game;
window.initGame = function (config, assets, deviceProps, callback, automation, callbackObj, gameSettingsConfig) {
    // console.log(config, assets, deviceProps, callback, automation, callbackObj, gameSettingsConfig);
    // console.log((window as any).V);
    // (window as any).V.API.Events.subscribe('gameEvent', gameEvent, callbackObj);
    var gameBasePath = getGameUrl;
    if (gameSettingsConfig) {
        window._certificationSettings = window.V.API.Core.processCertificationSettings(gameSettingsConfig);
    }
    // TODO: Add check for IE and set context to webgl-experimental.
    var performanceCaveat = getMajorPerformanceCaveat();
    if (false) {
        console.warn(performanceCaveat);
        console.warn("Version: " + __VERSION__);
    }
    game = new RecodeGame_1.RecodeGame('mysterywin', gameReady.bind(this, callback, callbackObj), gameBasePath, performanceCaveat);
};
function getMajorPerformanceCaveat() {
    var canvas = document.createElement('canvas');
    canvas.width = canvas.height = 1;
    document.body.appendChild(canvas);
    var gl = canvas.getContext('webgl', { failIfMajorPerformanceCaveat: true }) ||
        canvas.getContext('experimental-webgl', { failIfMajorPerformanceCaveat: true });
    canvas.parentNode.removeChild(canvas);
    if (!gl) {
        return System_1.WebGlPerformanceCaveatResult.SOFTWARE;
    }
    if (typeof gl.getContextAttributes().failIfMajorPerformanceCaveat === 'undefined') {
        return System_1.WebGlPerformanceCaveatResult.NOT_IMPLEMENTED;
    }
    return System_1.WebGlPerformanceCaveatResult.HARDWARE;
}
function getGameUrl(data) {
    return window.V.API.UrlHelper.getGameUrl(data);
}
function gameEvent(eventName) {
    var data = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        data[_i - 1] = arguments[_i];
    }
    // console.log(eventName, data);
}
function gameReady(callback, callbackObj) {
    RecodeGameInstaller_1.RecodeGameInstaller.run(game, window.V);
    var container = game.system.container;
    var modules = container.getAll(DI_1.default.IModule);
    container.get(DI_1.default.Layout).loadLayout('LAYOUT_TEMPLATE.json');
    container.get(DI_1.default.Layout).loadLayout('LAYOUT_TEMPLATE_FREESPIN.json');
    container.get(DI_1.default.Logic).init(function () {
        container.get(DI_1.default.SoundManager).init(game.system.device);
        container.get(DI_1.default.ViewManager).init();
        for (var _i = 0, modules_1 = modules; _i < modules_1.length; _i++) {
            var module_1 = modules_1[_i];
            module_1.init();
        }
        for (var _a = 0, modules_2 = modules; _a < modules_2.length; _a++) {
            var module_2 = modules_2[_a];
            module_2.afterInit();
        }
        if (false) {
            console.warn('NOT IN PRODUCTION');
            for (var _b = 0, modules_3 = modules; _b < modules_3.length; _b++) {
                var module_3 = modules_3[_b];
                module_3.addDebuggingComponent();
            }
            // tslint:disable-next-line: no-string-literal
            document['GAME'] = game;
            console.warn(game);
        }
        if (container.get(DI_1.default.Logic).hasRestore) {
            for (var _c = 0, modules_4 = modules; _c < modules_4.length; _c++) {
                var module_4 = modules_4[_c];
                module_4.restore();
            }
        }
        else if (container.get(DI_1.default.Logic).hasBonusGameFreeGamesRestore) {
            container.get(DI_1.default.Logic).freeGamesBonusGameRestoreCallback = function () {
                for (var _i = 0, modules_5 = modules; _i < modules_5.length; _i++) {
                    var module_5 = modules_5[_i];
                    module_5.restore();
                }
            };
        }
        if (!game.system.device.desktop) {
            container.get(CoreDI_1.CoreDI.FullscreenManager).forceUpdate();
        }
        // game.system.endLoading();
    });
    callback.call(callbackObj);
}


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(339);

__webpack_require__(341);

__webpack_require__(342);

__webpack_require__(343);

if (!window.ArrayBuffer) {
    window.ArrayBuffer = Array;
}

if (!window.Float32Array) {
    window.Float32Array = Array;
}

if (!window.Uint32Array) {
    window.Uint32Array = Array;
}

if (!window.Uint16Array) {
    window.Uint16Array = Array;
}
//# sourceMappingURL=index.js.map

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _objectAssign = __webpack_require__(340);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (!Object.assign) {
    Object.assign = _objectAssign2.default;
} // References:
// https://github.com/sindresorhus/object-assign
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
//# sourceMappingURL=Object.assign.js.map

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// References:
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// https://gist.github.com/1579671
// http://updates.html5rocks.com/2012/05/requestAnimationFrame-API-now-with-sub-millisecond-precision
// https://gist.github.com/timhall/4078614
// https://github.com/Financial-Times/polyfill-service/tree/master/polyfills/requestAnimationFrame

// Expected to be used with Browserfiy
// Browserify automatically detects the use of `global` and passes the
// correct reference of `global`, `self`, and finally `window`

var ONE_FRAME_TIME = 16;

// Date.now
if (!(Date.now && Date.prototype.getTime)) {
    Date.now = function now() {
        return new Date().getTime();
    };
}

// performance.now
if (!(global.performance && global.performance.now)) {
    var startTime = Date.now();

    if (!global.performance) {
        global.performance = {};
    }

    global.performance.now = function () {
        return Date.now() - startTime;
    };
}

// requestAnimationFrame
var lastTime = Date.now();
var vendors = ['ms', 'moz', 'webkit', 'o'];

for (var x = 0; x < vendors.length && !global.requestAnimationFrame; ++x) {
    var p = vendors[x];

    global.requestAnimationFrame = global[p + 'RequestAnimationFrame'];
    global.cancelAnimationFrame = global[p + 'CancelAnimationFrame'] || global[p + 'CancelRequestAnimationFrame'];
}

if (!global.requestAnimationFrame) {
    global.requestAnimationFrame = function (callback) {
        if (typeof callback !== 'function') {
            throw new TypeError(callback + 'is not a function');
        }

        var currentTime = Date.now();
        var delay = ONE_FRAME_TIME + lastTime - currentTime;

        if (delay < 0) {
            delay = 0;
        }

        lastTime = currentTime;

        return setTimeout(function () {
            lastTime = Date.now();
            callback(performance.now());
        }, delay);
    };
}

if (!global.cancelAnimationFrame) {
    global.cancelAnimationFrame = function (id) {
        return clearTimeout(id);
    };
}
//# sourceMappingURL=requestAnimationFrame.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// References:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/sign

if (!Math.sign) {
    Math.sign = function mathSign(x) {
        x = Number(x);

        if (x === 0 || isNaN(x)) {
            return x;
        }

        return x > 0 ? 1 : -1;
    };
}
//# sourceMappingURL=Math.sign.js.map

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// References:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger

if (!Number.isInteger) {
    Number.isInteger = function numberIsInteger(value) {
        return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
    };
}
//# sourceMappingURL=Number.isInteger.js.map

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _Rectangle = __webpack_require__(125);

var _Rectangle2 = _interopRequireDefault(_Rectangle);

var _const = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The Circle object can be used to specify a hit area for displayObjects
 *
 * @class
 * @memberof PIXI
 */
var Circle = function () {
  /**
   * @param {number} [x=0] - The X coordinate of the center of this circle
   * @param {number} [y=0] - The Y coordinate of the center of this circle
   * @param {number} [radius=0] - The radius of the circle
   */
  function Circle() {
    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var radius = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    _classCallCheck(this, Circle);

    /**
     * @member {number}
     * @default 0
     */
    this.x = x;

    /**
     * @member {number}
     * @default 0
     */
    this.y = y;

    /**
     * @member {number}
     * @default 0
     */
    this.radius = radius;

    /**
     * The type of the object, mainly used to avoid `instanceof` checks
     *
     * @member {number}
     * @readOnly
     * @default PIXI.SHAPES.CIRC
     * @see PIXI.SHAPES
     */
    this.type = _const.SHAPES.CIRC;
  }

  /**
   * Creates a clone of this Circle instance
   *
   * @return {PIXI.Circle} a copy of the Circle
   */


  Circle.prototype.clone = function clone() {
    return new Circle(this.x, this.y, this.radius);
  };

  /**
   * Checks whether the x and y coordinates given are contained within this circle
   *
   * @param {number} x - The X coordinate of the point to test
   * @param {number} y - The Y coordinate of the point to test
   * @return {boolean} Whether the x/y coordinates are within this Circle
   */


  Circle.prototype.contains = function contains(x, y) {
    if (this.radius <= 0) {
      return false;
    }

    var r2 = this.radius * this.radius;
    var dx = this.x - x;
    var dy = this.y - y;

    dx *= dx;
    dy *= dy;

    return dx + dy <= r2;
  };

  /**
  * Returns the framing rectangle of the circle as a Rectangle object
  *
  * @return {PIXI.Rectangle} the framing rectangle
  */


  Circle.prototype.getBounds = function getBounds() {
    return new _Rectangle2.default(this.x - this.radius, this.y - this.radius, this.radius * 2, this.radius * 2);
  };

  return Circle;
}();

exports.default = Circle;
//# sourceMappingURL=Circle.js.map

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _Rectangle = __webpack_require__(125);

var _Rectangle2 = _interopRequireDefault(_Rectangle);

var _const = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The Ellipse object can be used to specify a hit area for displayObjects
 *
 * @class
 * @memberof PIXI
 */
var Ellipse = function () {
  /**
   * @param {number} [x=0] - The X coordinate of the center of this ellipse
   * @param {number} [y=0] - The Y coordinate of the center of this ellipse
   * @param {number} [halfWidth=0] - The half width of this ellipse
   * @param {number} [halfHeight=0] - The half height of this ellipse
   */
  function Ellipse() {
    var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var halfWidth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var halfHeight = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

    _classCallCheck(this, Ellipse);

    /**
     * @member {number}
     * @default 0
     */
    this.x = x;

    /**
     * @member {number}
     * @default 0
     */
    this.y = y;

    /**
     * @member {number}
     * @default 0
     */
    this.width = halfWidth;

    /**
     * @member {number}
     * @default 0
     */
    this.height = halfHeight;

    /**
     * The type of the object, mainly used to avoid `instanceof` checks
     *
     * @member {number}
     * @readOnly
     * @default PIXI.SHAPES.ELIP
     * @see PIXI.SHAPES
     */
    this.type = _const.SHAPES.ELIP;
  }

  /**
   * Creates a clone of this Ellipse instance
   *
   * @return {PIXI.Ellipse} a copy of the ellipse
   */


  Ellipse.prototype.clone = function clone() {
    return new Ellipse(this.x, this.y, this.width, this.height);
  };

  /**
   * Checks whether the x and y coordinates given are contained within this ellipse
   *
   * @param {number} x - The X coordinate of the point to test
   * @param {number} y - The Y coordinate of the point to test
   * @return {boolean} Whether the x/y coords are within this ellipse
   */


  Ellipse.prototype.contains = function contains(x, y) {
    if (this.width <= 0 || this.height <= 0) {
      return false;
    }

    // normalize the coords to an ellipse with center 0,0
    var normx = (x - this.x) / this.width;
    var normy = (y - this.y) / this.height;

    normx *= normx;
    normy *= normy;

    return normx + normy <= 1;
  };

  /**
   * Returns the framing rectangle of the ellipse as a Rectangle object
   *
   * @return {PIXI.Rectangle} the framing rectangle
   */


  Ellipse.prototype.getBounds = function getBounds() {
    return new _Rectangle2.default(this.x - this.width, this.y - this.height, this.width, this.height);
  };

  return Ellipse;
}();

exports.default = Ellipse;
//# sourceMappingURL=Ellipse.js.map

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _Point = __webpack_require__(123);

var _Point2 = _interopRequireDefault(_Point);

var _const = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class
 * @memberof PIXI
 */
var Polygon = function () {
    /**
     * @param {PIXI.Point[]|number[]} points - This can be an array of Points
     *  that form the polygon, a flat array of numbers that will be interpreted as [x,y, x,y, ...], or
     *  the arguments passed can be all the points of the polygon e.g.
     *  `new PIXI.Polygon(new PIXI.Point(), new PIXI.Point(), ...)`, or the arguments passed can be flat
     *  x,y values e.g. `new Polygon(x,y, x,y, x,y, ...)` where `x` and `y` are Numbers.
     */
    function Polygon() {
        for (var _len = arguments.length, points = Array(_len), _key = 0; _key < _len; _key++) {
            points[_key] = arguments[_key];
        }

        _classCallCheck(this, Polygon);

        if (Array.isArray(points[0])) {
            points = points[0];
        }

        // if this is an array of points, convert it to a flat array of numbers
        if (points[0] instanceof _Point2.default) {
            var p = [];

            for (var i = 0, il = points.length; i < il; i++) {
                p.push(points[i].x, points[i].y);
            }

            points = p;
        }

        this.closed = true;

        /**
         * An array of the points of this polygon
         *
         * @member {number[]}
         */
        this.points = points;

        /**
         * The type of the object, mainly used to avoid `instanceof` checks
         *
         * @member {number}
         * @readOnly
         * @default PIXI.SHAPES.POLY
         * @see PIXI.SHAPES
         */
        this.type = _const.SHAPES.POLY;
    }

    /**
     * Creates a clone of this polygon
     *
     * @return {PIXI.Polygon} a copy of the polygon
     */


    Polygon.prototype.clone = function clone() {
        return new Polygon(this.points.slice());
    };

    /**
     * Closes the polygon, adding points if necessary.
     *
     */


    Polygon.prototype.close = function close() {
        var points = this.points;

        // close the poly if the value is true!
        if (points[0] !== points[points.length - 2] || points[1] !== points[points.length - 1]) {
            points.push(points[0], points[1]);
        }
    };

    /**
     * Checks whether the x and y coordinates passed to this function are contained within this polygon
     *
     * @param {number} x - The X coordinate of the point to test
     * @param {number} y - The Y coordinate of the point to test
     * @return {boolean} Whether the x/y coordinates are within this polygon
     */


    Polygon.prototype.contains = function contains(x, y) {
        var inside = false;

        // use some raycasting to test hits
        // https://github.com/substack/point-in-polygon/blob/master/index.js
        var length = this.points.length / 2;

        for (var i = 0, j = length - 1; i < length; j = i++) {
            var xi = this.points[i * 2];
            var yi = this.points[i * 2 + 1];
            var xj = this.points[j * 2];
            var yj = this.points[j * 2 + 1];
            var intersect = yi > y !== yj > y && x < (xj - xi) * ((y - yi) / (yj - yi)) + xi;

            if (intersect) {
                inside = !inside;
            }
        }

        return inside;
    };

    return Polygon;
}();

exports.default = Polygon;
//# sourceMappingURL=Polygon.js.map

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _const = __webpack_require__(5);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * The Rounded Rectangle object is an area that has nice rounded corners, as indicated by its
 * top-left corner point (x, y) and by its width and its height and its radius.
 *
 * @class
 * @memberof PIXI
 */
var RoundedRectangle = function () {
    /**
     * @param {number} [x=0] - The X coordinate of the upper-left corner of the rounded rectangle
     * @param {number} [y=0] - The Y coordinate of the upper-left corner of the rounded rectangle
     * @param {number} [width=0] - The overall width of this rounded rectangle
     * @param {number} [height=0] - The overall height of this rounded rectangle
     * @param {number} [radius=20] - Controls the radius of the rounded corners
     */
    function RoundedRectangle() {
        var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        var height = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        var radius = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 20;

        _classCallCheck(this, RoundedRectangle);

        /**
         * @member {number}
         * @default 0
         */
        this.x = x;

        /**
         * @member {number}
         * @default 0
         */
        this.y = y;

        /**
         * @member {number}
         * @default 0
         */
        this.width = width;

        /**
         * @member {number}
         * @default 0
         */
        this.height = height;

        /**
         * @member {number}
         * @default 20
         */
        this.radius = radius;

        /**
         * The type of the object, mainly used to avoid `instanceof` checks
         *
         * @member {number}
         * @readonly
         * @default PIXI.SHAPES.RREC
         * @see PIXI.SHAPES
         */
        this.type = _const.SHAPES.RREC;
    }

    /**
     * Creates a clone of this Rounded Rectangle
     *
     * @return {PIXI.RoundedRectangle} a copy of the rounded rectangle
     */


    RoundedRectangle.prototype.clone = function clone() {
        return new RoundedRectangle(this.x, this.y, this.width, this.height, this.radius);
    };

    /**
     * Checks whether the x and y coordinates given are contained within this Rounded Rectangle
     *
     * @param {number} x - The X coordinate of the point to test
     * @param {number} y - The Y coordinate of the point to test
     * @return {boolean} Whether the x/y coordinates are within this Rounded Rectangle
     */


    RoundedRectangle.prototype.contains = function contains(x, y) {
        if (this.width <= 0 || this.height <= 0) {
            return false;
        }
        if (x >= this.x && x <= this.x + this.width) {
            if (y >= this.y && y <= this.y + this.height) {
                if (y >= this.y + this.radius && y <= this.y + this.height - this.radius || x >= this.x + this.radius && x <= this.x + this.width - this.radius) {
                    return true;
                }
                var dx = x - (this.x + this.radius);
                var dy = y - (this.y + this.radius);
                var radius2 = this.radius * this.radius;

                if (dx * dx + dy * dy <= radius2) {
                    return true;
                }
                dx = x - (this.x + this.width - this.radius);
                if (dx * dx + dy * dy <= radius2) {
                    return true;
                }
                dy = y - (this.y + this.height - this.radius);
                if (dx * dx + dy * dy <= radius2) {
                    return true;
                }
                dx = x - (this.x + this.radius);
                if (dx * dx + dy * dy <= radius2) {
                    return true;
                }
            }
        }

        return false;
    };

    return RoundedRectangle;
}();

exports.default = RoundedRectangle;
//# sourceMappingURL=RoundedRectangle.js.map

/***/ }),
/* 348 */
/***/ (function(module, exports) {


/**
 * Helper class to create a webGL Context
 *
 * @class
 * @memberof PIXI.glCore
 * @param canvas {HTMLCanvasElement} the canvas element that we will get the context from
 * @param options {Object} An options object that gets passed in to the canvas element containing the context attributes,
 *                         see https://developer.mozilla.org/en/docs/Web/API/HTMLCanvasElement/getContext for the options available
 * @return {WebGLRenderingContext} the WebGL context
 */
var createContext = function(canvas, options)
{
    var gl = canvas.getContext('webgl', options) || 
         canvas.getContext('experimental-webgl', options);

    if (!gl)
    {
        // fail, not able to get a context
        throw new Error('This browser does not support webGL. Try using the canvas renderer');
    }

    return gl;
};

module.exports = createContext;


/***/ }),
/* 349 */
/***/ (function(module, exports) {

var EMPTY_ARRAY_BUFFER = new ArrayBuffer(0);

/**
 * Helper class to create a webGL buffer
 *
 * @class
 * @memberof PIXI.glCore
 * @param gl {WebGLRenderingContext} The current WebGL rendering context
 * @param type {gl.ARRAY_BUFFER | gl.ELEMENT_ARRAY_BUFFER} @mat
 * @param data {ArrayBuffer| SharedArrayBuffer|ArrayBufferView} an array of data
 * @param drawType {gl.STATIC_DRAW|gl.DYNAMIC_DRAW|gl.STREAM_DRAW}
 */
var Buffer = function(gl, type, data, drawType)
{

	/**
     * The current WebGL rendering context
     *
     * @member {WebGLRenderingContext}
     */
	this.gl = gl;

	/**
     * The WebGL buffer, created upon instantiation
     *
     * @member {WebGLBuffer}
     */
	this.buffer = gl.createBuffer();

	/**
     * The type of the buffer
     *
     * @member {gl.ARRAY_BUFFER|gl.ELEMENT_ARRAY_BUFFER}
     */
	this.type = type || gl.ARRAY_BUFFER;

	/**
     * The draw type of the buffer
     *
     * @member {gl.STATIC_DRAW|gl.DYNAMIC_DRAW|gl.STREAM_DRAW}
     */
	this.drawType = drawType || gl.STATIC_DRAW;

	/**
     * The data in the buffer, as a typed array
     *
     * @member {ArrayBuffer| SharedArrayBuffer|ArrayBufferView}
     */
	this.data = EMPTY_ARRAY_BUFFER;

	if(data)
	{
		this.upload(data);
	}

	this._updateID = 0;
};

/**
 * Uploads the buffer to the GPU
 * @param data {ArrayBuffer| SharedArrayBuffer|ArrayBufferView} an array of data to upload
 * @param offset {Number} if only a subset of the data should be uploaded, this is the amount of data to subtract
 * @param dontBind {Boolean} whether to bind the buffer before uploading it
 */
Buffer.prototype.upload = function(data, offset, dontBind)
{
	// todo - needed?
	if(!dontBind) this.bind();

	var gl = this.gl;

	data = data || this.data;
	offset = offset || 0;

	if(this.data.byteLength >= data.byteLength)
	{
		gl.bufferSubData(this.type, offset, data);
	}
	else
	{
		gl.bufferData(this.type, data, this.drawType);
	}

	this.data = data;
};
/**
 * Binds the buffer
 *
 */
Buffer.prototype.bind = function()
{
	var gl = this.gl;
	gl.bindBuffer(this.type, this.buffer);
};

Buffer.createVertexBuffer = function(gl, data, drawType)
{
	return new Buffer(gl, gl.ARRAY_BUFFER, data, drawType);
};

Buffer.createIndexBuffer = function(gl, data, drawType)
{
	return new Buffer(gl, gl.ELEMENT_ARRAY_BUFFER, data, drawType);
};

Buffer.create = function(gl, type, data, drawType)
{
	return new Buffer(gl, type, data, drawType);
};

/**
 * Destroys the buffer
 *
 */
Buffer.prototype.destroy = function(){
	this.gl.deleteBuffer(this.buffer);
};

module.exports = Buffer;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {


var Texture = __webpack_require__(173);

/**
 * Helper class to create a webGL Framebuffer
 *
 * @class
 * @memberof PIXI.glCore
 * @param gl {WebGLRenderingContext} The current WebGL rendering context
 * @param width {Number} the width of the drawing area of the frame buffer
 * @param height {Number} the height of the drawing area of the frame buffer
 */
var Framebuffer = function(gl, width, height)
{
    /**
     * The current WebGL rendering context
     *
     * @member {WebGLRenderingContext}
     */
    this.gl = gl;

    /**
     * The frame buffer
     *
     * @member {WebGLFramebuffer}
     */
    this.framebuffer = gl.createFramebuffer();

    /**
     * The stencil buffer
     *
     * @member {WebGLRenderbuffer}
     */
    this.stencil = null;

    /**
     * The stencil buffer
     *
     * @member {PIXI.glCore.GLTexture}
     */
    this.texture = null;

    /**
     * The width of the drawing area of the buffer
     *
     * @member {Number}
     */
    this.width = width || 100;
    /**
     * The height of the drawing area of the buffer
     *
     * @member {Number}
     */
    this.height = height || 100;
};

/**
 * Adds a texture to the frame buffer
 * @param texture {PIXI.glCore.GLTexture}
 */
Framebuffer.prototype.enableTexture = function(texture)
{
    var gl = this.gl;

    this.texture = texture || new Texture(gl);

    this.texture.bind();

    //gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA,  this.width, this.height, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);

    this.bind();

    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, this.texture.texture, 0);
};

/**
 * Initialises the stencil buffer
 */
Framebuffer.prototype.enableStencil = function()
{
    if(this.stencil)return;

    var gl = this.gl;

    this.stencil = gl.createRenderbuffer();

    gl.bindRenderbuffer(gl.RENDERBUFFER, this.stencil);

    // TODO.. this is depth AND stencil?
    gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_STENCIL_ATTACHMENT, gl.RENDERBUFFER, this.stencil);
    gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_STENCIL,  this.width  , this.height );


};

/**
 * Erases the drawing area and fills it with a colour
 * @param  r {Number} the red value of the clearing colour
 * @param  g {Number} the green value of the clearing colour
 * @param  b {Number} the blue value of the clearing colour
 * @param  a {Number} the alpha value of the clearing colour
 */
Framebuffer.prototype.clear = function( r, g, b, a )
{
    this.bind();

    var gl = this.gl;

    gl.clearColor(r, g, b, a);
    gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
};

/**
 * Binds the frame buffer to the WebGL context
 */
Framebuffer.prototype.bind = function()
{
    var gl = this.gl;
    gl.bindFramebuffer(gl.FRAMEBUFFER, this.framebuffer );
};

/**
 * Unbinds the frame buffer to the WebGL context
 */
Framebuffer.prototype.unbind = function()
{
    var gl = this.gl;
    gl.bindFramebuffer(gl.FRAMEBUFFER, null );
};
/**
 * Resizes the drawing area of the buffer to the given width and height
 * @param  width  {Number} the new width
 * @param  height {Number} the new height
 */
Framebuffer.prototype.resize = function(width, height)
{
    var gl = this.gl;

    this.width = width;
    this.height = height;

    if ( this.texture )
    {
        this.texture.uploadData(null, width, height);
    }

    if ( this.stencil )
    {
        // update the stencil buffer width and height
        gl.bindRenderbuffer(gl.RENDERBUFFER, this.stencil);
        gl.renderbufferStorage(gl.RENDERBUFFER, gl.DEPTH_STENCIL, width, height);
    }
};

/**
 * Destroys this buffer
 */
Framebuffer.prototype.destroy = function()
{
    var gl = this.gl;

    //TODO
    if(this.texture)
    {
        this.texture.destroy();
    }

    gl.deleteFramebuffer(this.framebuffer);

    this.gl = null;

    this.stencil = null;
    this.texture = null;
};

/**
 * Creates a frame buffer with a texture containing the given data
 * @static
 * @param gl {WebGLRenderingContext} The current WebGL rendering context
 * @param width {Number} the width of the drawing area of the frame buffer
 * @param height {Number} the height of the drawing area of the frame buffer
 * @param data {ArrayBuffer| SharedArrayBuffer|ArrayBufferView} an array of data
 */
Framebuffer.createRGBA = function(gl, width, height, data)
{
    var texture = Texture.fromData(gl, null, width, height);
    texture.enableNearestScaling();
    texture.enableWrapClamp();

    //now create the framebuffer object and attach the texture to it.
    var fbo = new Framebuffer(gl, width, height);
    fbo.enableTexture(texture);
    //fbo.enableStencil(); // get this back on soon!

    //fbo.enableStencil(); // get this back on soon!

    fbo.unbind();

    return fbo;
};

/**
 * Creates a frame buffer with a texture containing the given data
 * @static
 * @param gl {WebGLRenderingContext} The current WebGL rendering context
 * @param width {Number} the width of the drawing area of the frame buffer
 * @param height {Number} the height of the drawing area of the frame buffer
 * @param data {ArrayBuffer| SharedArrayBuffer|ArrayBufferView} an array of data
 */
Framebuffer.createFloat32 = function(gl, width, height, data)
{
    // create a new texture..
    var texture = new Texture.fromData(gl, data, width, height);
    texture.enableNearestScaling();
    texture.enableWrapClamp();

    //now create the framebuffer object and attach the texture to it.
    var fbo = new Framebuffer(gl, width, height);
    fbo.enableTexture(texture);

    fbo.unbind();

    return fbo;
};

module.exports = Framebuffer;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {


var compileProgram = __webpack_require__(174),
	extractAttributes = __webpack_require__(175),
	extractUniforms = __webpack_require__(177),
	setPrecision = __webpack_require__(179),
	generateUniformAccessObject = __webpack_require__(180);

/**
 * Helper class to create a webGL Shader
 *
 * @class
 * @memberof PIXI.glCore
 * @param gl {WebGLRenderingContext}
 * @param vertexSrc {string|string[]} The vertex shader source as an array of strings.
 * @param fragmentSrc {string|string[]} The fragment shader source as an array of strings.
 * @param precision {string} The float precision of the shader. Options are 'lowp', 'mediump' or 'highp'.
 * @param attributeLocations {object} A key value pair showing which location eact attribute should sit eg {position:0, uvs:1}
 */
var Shader = function(gl, vertexSrc, fragmentSrc, precision, attributeLocations)
{
	/**
	 * The current WebGL rendering context
	 *
	 * @member {WebGLRenderingContext}
	 */
	this.gl = gl;

	if(precision)
	{
		vertexSrc = setPrecision(vertexSrc, precision);
		fragmentSrc = setPrecision(fragmentSrc, precision);
	}

	/**
	 * The shader program
	 *
	 * @member {WebGLProgram}
	 */
	// First compile the program..
	this.program = compileProgram(gl, vertexSrc, fragmentSrc, attributeLocations);

	/**
	 * The attributes of the shader as an object containing the following properties
	 * {
	 * 	type,
	 * 	size,
	 * 	location,
	 * 	pointer
	 * }
	 * @member {Object}
	 */
	// next extract the attributes
	this.attributes = extractAttributes(gl, this.program);

    this.uniformData = extractUniforms(gl, this.program);

	/**
	 * The uniforms of the shader as an object containing the following properties
	 * {
	 * 	gl,
	 * 	data
	 * }
	 * @member {Object}
	 */
	this.uniforms = generateUniformAccessObject( gl, this.uniformData );

};
/**
 * Uses this shader
 * 
 * @return {PIXI.glCore.GLShader} Returns itself.
 */
Shader.prototype.bind = function()
{
	this.gl.useProgram(this.program);
	return this;
};

/**
 * Destroys this shader
 * TODO
 */
Shader.prototype.destroy = function()
{
	this.attributes = null;
	this.uniformData = null;
	this.uniforms = null;

	var gl = this.gl;
	gl.deleteProgram(this.program);
};


module.exports = Shader;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {


// state object//
var setVertexAttribArrays = __webpack_require__( 172 );

/**
 * Helper class to work with WebGL VertexArrayObjects (vaos)
 * Only works if WebGL extensions are enabled (they usually are)
 *
 * @class
 * @memberof PIXI.glCore
 * @param gl {WebGLRenderingContext} The current WebGL rendering context
 */
function VertexArrayObject(gl, state)
{
    this.nativeVaoExtension = null;

    if(!VertexArrayObject.FORCE_NATIVE)
    {
        this.nativeVaoExtension = gl.getExtension('OES_vertex_array_object') ||
                                  gl.getExtension('MOZ_OES_vertex_array_object') ||
                                  gl.getExtension('WEBKIT_OES_vertex_array_object');
    }

    this.nativeState = state;

    if(this.nativeVaoExtension)
    {
        this.nativeVao = this.nativeVaoExtension.createVertexArrayOES();

        var maxAttribs = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);

        // VAO - overwrite the state..
        this.nativeState = {
            tempAttribState: new Array(maxAttribs),
            attribState: new Array(maxAttribs)
        };
    }

    /**
     * The current WebGL rendering context
     *
     * @member {WebGLRenderingContext}
     */
    this.gl = gl;

    /**
     * An array of attributes
     *
     * @member {Array}
     */
    this.attributes = [];

    /**
     * @member {PIXI.glCore.GLBuffer}
     */
    this.indexBuffer = null;

    /**
     * A boolean flag
     *
     * @member {Boolean}
     */
    this.dirty = false;
}

VertexArrayObject.prototype.constructor = VertexArrayObject;
module.exports = VertexArrayObject;

/**
* Some devices behave a bit funny when using the newer extensions (im looking at you ipad 2!)
* If you find on older devices that things have gone a bit weird then set this to true.
*/
/**
 * Lets the VAO know if you should use the WebGL extension or the native methods.
 * Some devices behave a bit funny when using the newer extensions (im looking at you ipad 2!)
 * If you find on older devices that things have gone a bit weird then set this to true.
 * @static
 * @property {Boolean} FORCE_NATIVE
 */
VertexArrayObject.FORCE_NATIVE = false;

/**
 * Binds the buffer
 */
VertexArrayObject.prototype.bind = function()
{
    if(this.nativeVao)
    {
        this.nativeVaoExtension.bindVertexArrayOES(this.nativeVao);

        if(this.dirty)
        {
            this.dirty = false;
            this.activate();
            return this;
        }
        if (this.indexBuffer)
        {
            this.indexBuffer.bind();
        }
    }
    else
    {
        this.activate();
    }

    return this;
};

/**
 * Unbinds the buffer
 */
VertexArrayObject.prototype.unbind = function()
{
    if(this.nativeVao)
    {
        this.nativeVaoExtension.bindVertexArrayOES(null);
    }

    return this;
};

/**
 * Uses this vao
 */
VertexArrayObject.prototype.activate = function()
{

    var gl = this.gl;
    var lastBuffer = null;

    for (var i = 0; i < this.attributes.length; i++)
    {
        var attrib = this.attributes[i];

        if(lastBuffer !== attrib.buffer)
        {
            attrib.buffer.bind();
            lastBuffer = attrib.buffer;
        }

        gl.vertexAttribPointer(attrib.attribute.location,
                               attrib.attribute.size,
                               attrib.type || gl.FLOAT,
                               attrib.normalized || false,
                               attrib.stride || 0,
                               attrib.start || 0);
    }

    setVertexAttribArrays(gl, this.attributes, this.nativeState);

    if(this.indexBuffer)
    {
        this.indexBuffer.bind();
    }

    return this;
};

/**
 *
 * @param buffer     {PIXI.gl.GLBuffer}
 * @param attribute  {*}
 * @param type       {String}
 * @param normalized {Boolean}
 * @param stride     {Number}
 * @param start      {Number}
 */
VertexArrayObject.prototype.addAttribute = function(buffer, attribute, type, normalized, stride, start)
{
    this.attributes.push({
        buffer:     buffer,
        attribute:  attribute,

        location:   attribute.location,
        type:       type || this.gl.FLOAT,
        normalized: normalized || false,
        stride:     stride || 0,
        start:      start || 0
    });

    this.dirty = true;

    return this;
};

/**
 *
 * @param buffer   {PIXI.gl.GLBuffer}
 */
VertexArrayObject.prototype.addIndex = function(buffer/*, options*/)
{
    this.indexBuffer = buffer;

    this.dirty = true;

    return this;
};

/**
 * Unbinds this vao and disables it
 */
VertexArrayObject.prototype.clear = function()
{
    // var gl = this.gl;

    // TODO - should this function unbind after clear?
    // for now, no but lets see what happens in the real world!
    if(this.nativeVao)
    {
        this.nativeVaoExtension.bindVertexArrayOES(this.nativeVao);
    }

    this.attributes.length = 0;
    this.indexBuffer = null;

    return this;
};

/**
 * @param type  {Number}
 * @param size  {Number}
 * @param start {Number}
 */
VertexArrayObject.prototype.draw = function(type, size, start)
{
    var gl = this.gl;

    if(this.indexBuffer)
    {
        gl.drawElements(type, size || this.indexBuffer.data.length, gl.UNSIGNED_SHORT, (start || 0) * 2 );
    }
    else
    {
        // TODO need a better way to calculate size..
        gl.drawArrays(type, start, size || this.getSize());
    }

    return this;
};

/**
 * Destroy this vao
 */
VertexArrayObject.prototype.destroy = function()
{
    // lose references
    this.gl = null;
    this.indexBuffer = null;
    this.attributes = null;
    this.nativeState = null;

    if(this.nativeVao)
    {
        this.nativeVaoExtension.deleteVertexArrayOES(this.nativeVao);
    }

    this.nativeVaoExtension = null;
    this.nativeVao = null;
};

VertexArrayObject.prototype.getSize = function()
{
    var attrib = this.attributes[0];
    return attrib.buffer.data.length / (( attrib.stride/4 ) || attrib.attribute.size);
};


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
    compileProgram: __webpack_require__(174),
    defaultValue: __webpack_require__(178),
    extractAttributes: __webpack_require__(175),
    extractUniforms: __webpack_require__(177),
    generateUniformAccessObject: __webpack_require__(180),
    setPrecision: __webpack_require__(179),
    mapSize: __webpack_require__(176),
    mapType: __webpack_require__(126)
};

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = maxRecommendedTextures;

var _ismobilejs = __webpack_require__(128);

var _ismobilejs2 = _interopRequireDefault(_ismobilejs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function maxRecommendedTextures(max) {
    if (_ismobilejs2.default.tablet || _ismobilejs2.default.phone) {
        // check if the res is iphone 6 or higher..
        return 4;
    }

    // desktop should be ok
    return max;
}
//# sourceMappingURL=maxRecommendedTextures.js.map

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = canUploadSameBuffer;
function canUploadSameBuffer() {
	// Uploading the same buffer multiple times in a single frame can cause perf issues.
	// Apparent on IOS so only check for that at the moment
	// this check may become more complex if this issue pops up elsewhere.
	var ios = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

	return !ios;
}
//# sourceMappingURL=canUploadSameBuffer.js.map

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Mixins functionality to make an object have "plugins".
 *
 * @example
 *      function MyObject() {}
 *
 *      pluginTarget.mixin(MyObject);
 *
 * @mixin
 * @memberof PIXI.utils
 * @param {object} obj - The object to mix into.
 */
function pluginTarget(obj) {
    obj.__plugins = {};

    /**
     * Adds a plugin to an object
     *
     * @param {string} pluginName - The events that should be listed.
     * @param {Function} ctor - The constructor function for the plugin.
     */
    obj.registerPlugin = function registerPlugin(pluginName, ctor) {
        obj.__plugins[pluginName] = ctor;
    };

    /**
     * Instantiates all the plugins of this object
     *
     */
    obj.prototype.initPlugins = function initPlugins() {
        this.plugins = this.plugins || {};

        for (var o in obj.__plugins) {
            this.plugins[o] = new obj.__plugins[o](this);
        }
    };

    /**
     * Removes all the plugins of this object
     *
     */
    obj.prototype.destroyPlugins = function destroyPlugins() {
        for (var o in this.plugins) {
            this.plugins[o].destroy();
            this.plugins[o] = null;
        }

        this.plugins = null;
    };
}

exports.default = {
    /**
     * Mixes in the properties of the pluginTarget into another object
     *
     * @param {object} obj - The obj to mix into
     */
    mixin: function mixin(obj) {
        pluginTarget(obj);
    }
};
//# sourceMappingURL=pluginTarget.js.map

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.mixin = mixin;
exports.delayMixin = delayMixin;
exports.performMixins = performMixins;
/**
 * Mixes all enumerable properties and methods from a source object to a target object.
 *
 * @memberof PIXI.utils.mixins
 * @function mixin
 * @param {object} target The prototype or instance that properties and methods should be added to.
 * @param {object} source The source of properties and methods to mix in.
 */
function mixin(target, source) {
    if (!target || !source) return;
    // in ES8/ES2017, this would be really easy:
    // Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));

    // get all the enumerable property keys
    var keys = Object.keys(source);

    // loop through properties
    for (var i = 0; i < keys.length; ++i) {
        var propertyName = keys[i];

        // Set the property using the property descriptor - this works for accessors and normal value properties
        Object.defineProperty(target, propertyName, Object.getOwnPropertyDescriptor(source, propertyName));
    }
}

var mixins = [];

/**
 * Queues a mixin to be handled towards the end of the initialization of PIXI, so that deprecation
 * can take effect.
 *
 * @memberof PIXI.utils.mixins
 * @function delayMixin
 * @private
 * @param {object} target The prototype or instance that properties and methods should be added to.
 * @param {object} source The source of properties and methods to mix in.
 */
function delayMixin(target, source) {
    mixins.push(target, source);
}

/**
 * Handles all mixins queued via delayMixin().
 *
 * @memberof PIXI.utils.mixins
 * @function performMixins
 * @private
 */
function performMixins() {
    for (var i = 0; i < mixins.length; i += 2) {
        mixin(mixins[i], mixins[i + 1]);
    }
    mixins.length = 0;
}
//# sourceMappingURL=mixin.js.map

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Remove a range of items from an array
 *
 * @function removeItems
 * @param {Array<*>} arr The target array
 * @param {number} startIdx The index to begin removing from (inclusive)
 * @param {number} removeCount How many items to remove
 */
module.exports = function removeItems (arr, startIdx, removeCount) {
  var i, length = arr.length

  if (startIdx >= length || removeCount === 0) {
    return
  }

  removeCount = (startIdx + removeCount > length ? length - startIdx : removeCount)

  var len = length - removeCount

  for (i = startIdx; i < len; ++i) {
    arr[i] = arr[i + removeCount]
  }

  arr.length = len
}


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = mapPremultipliedBlendModes;

var _const = __webpack_require__(5);

/**
 * Corrects PixiJS blend, takes premultiplied alpha into account
 *
 * @memberof PIXI
 * @function mapPremultipliedBlendModes
 * @private
 * @param {Array<number[]>} [array] - The array to output into.
 * @return {Array<number[]>} Mapped modes.
 */

function mapPremultipliedBlendModes() {
    var pm = [];
    var npm = [];

    for (var i = 0; i < 32; i++) {
        pm[i] = i;
        npm[i] = i;
    }

    pm[_const.BLEND_MODES.NORMAL_NPM] = _const.BLEND_MODES.NORMAL;
    pm[_const.BLEND_MODES.ADD_NPM] = _const.BLEND_MODES.ADD;
    pm[_const.BLEND_MODES.SCREEN_NPM] = _const.BLEND_MODES.SCREEN;

    npm[_const.BLEND_MODES.NORMAL] = _const.BLEND_MODES.NORMAL_NPM;
    npm[_const.BLEND_MODES.ADD] = _const.BLEND_MODES.ADD_NPM;
    npm[_const.BLEND_MODES.SCREEN] = _const.BLEND_MODES.SCREEN_NPM;

    var array = [];

    array.push(npm);
    array.push(pm);

    return array;
}
//# sourceMappingURL=mapPremultipliedBlendModes.js.map

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
			return punycode;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(361)(module), __webpack_require__(24)))

/***/ }),
/* 361 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(364);
exports.encode = exports.stringify = __webpack_require__(365);


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _settings = __webpack_require__(17);

var _settings2 = _interopRequireDefault(_settings);

var _const = __webpack_require__(5);

var _TickerListener = __webpack_require__(367);

var _TickerListener2 = _interopRequireDefault(_TickerListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * A Ticker class that runs an update loop that other objects listen to.
 * This class is composed around listeners
 * meant for execution on the next requested animation frame.
 * Animation frames are requested only when necessary,
 * e.g. When the ticker is started and the emitter has listeners.
 *
 * @class
 * @memberof PIXI.ticker
 */
var Ticker = function () {
    /**
     *
     */
    function Ticker() {
        var _this = this;

        _classCallCheck(this, Ticker);

        /**
         * The first listener. All new listeners added are chained on this.
         * @private
         * @type {TickerListener}
         */
        this._head = new _TickerListener2.default(null, null, Infinity);

        /**
         * Internal current frame request ID
         * @private
         */
        this._requestId = null;

        /**
         * Internal value managed by minFPS property setter and getter.
         * This is the maximum allowed milliseconds between updates.
         * @private
         */
        this._maxElapsedMS = 100;

        /**
         * Whether or not this ticker should invoke the method
         * {@link PIXI.ticker.Ticker#start} automatically
         * when a listener is added.
         *
         * @member {boolean}
         * @default false
         */
        this.autoStart = false;

        /**
         * Scalar time value from last frame to this frame.
         * This value is capped by setting {@link PIXI.ticker.Ticker#minFPS}
         * and is scaled with {@link PIXI.ticker.Ticker#speed}.
         * **Note:** The cap may be exceeded by scaling.
         *
         * @member {number}
         * @default 1
         */
        this.deltaTime = 1;

        /**
         * Time elapsed in milliseconds from last frame to this frame.
         * Opposed to what the scalar {@link PIXI.ticker.Ticker#deltaTime}
         * is based, this value is neither capped nor scaled.
         * If the platform supports DOMHighResTimeStamp,
         * this value will have a precision of 1 µs.
         * Defaults to target frame time
         *
         * @member {number}
         * @default 16.66
         */
        this.elapsedMS = 1 / _settings2.default.TARGET_FPMS;

        /**
         * The last time {@link PIXI.ticker.Ticker#update} was invoked.
         * This value is also reset internally outside of invoking
         * update, but only when a new animation frame is requested.
         * If the platform supports DOMHighResTimeStamp,
         * this value will have a precision of 1 µs.
         *
         * @member {number}
         * @default -1
         */
        this.lastTime = -1;

        /**
         * Factor of current {@link PIXI.ticker.Ticker#deltaTime}.
         * @example
         * // Scales ticker.deltaTime to what would be
         * // the equivalent of approximately 120 FPS
         * ticker.speed = 2;
         *
         * @member {number}
         * @default 1
         */
        this.speed = 1;

        /**
         * Whether or not this ticker has been started.
         * `true` if {@link PIXI.ticker.Ticker#start} has been called.
         * `false` if {@link PIXI.ticker.Ticker#stop} has been called.
         * While `false`, this value may change to `true` in the
         * event of {@link PIXI.ticker.Ticker#autoStart} being `true`
         * and a listener is added.
         *
         * @member {boolean}
         * @default false
         */
        this.started = false;

        /**
         * Internal tick method bound to ticker instance.
         * This is because in early 2015, Function.bind
         * is still 60% slower in high performance scenarios.
         * Also separating frame requests from update method
         * so listeners may be called at any time and with
         * any animation API, just invoke ticker.update(time).
         *
         * @private
         * @param {number} time - Time since last tick.
         */
        this._tick = function (time) {
            _this._requestId = null;

            if (_this.started) {
                // Invoke listeners now
                _this.update(time);
                // Listener side effects may have modified ticker state.
                if (_this.started && _this._requestId === null && _this._head.next) {
                    _this._requestId = requestAnimationFrame(_this._tick);
                }
            }
        };
    }

    /**
     * Conditionally requests a new animation frame.
     * If a frame has not already been requested, and if the internal
     * emitter has listeners, a new frame is requested.
     *
     * @private
     */


    Ticker.prototype._requestIfNeeded = function _requestIfNeeded() {
        if (this._requestId === null && this._head.next) {
            // ensure callbacks get correct delta
            this.lastTime = performance.now();
            this._requestId = requestAnimationFrame(this._tick);
        }
    };

    /**
     * Conditionally cancels a pending animation frame.
     *
     * @private
     */


    Ticker.prototype._cancelIfNeeded = function _cancelIfNeeded() {
        if (this._requestId !== null) {
            cancelAnimationFrame(this._requestId);
            this._requestId = null;
        }
    };

    /**
     * Conditionally requests a new animation frame.
     * If the ticker has been started it checks if a frame has not already
     * been requested, and if the internal emitter has listeners. If these
     * conditions are met, a new frame is requested. If the ticker has not
     * been started, but autoStart is `true`, then the ticker starts now,
     * and continues with the previous conditions to request a new frame.
     *
     * @private
     */


    Ticker.prototype._startIfPossible = function _startIfPossible() {
        if (this.started) {
            this._requestIfNeeded();
        } else if (this.autoStart) {
            this.start();
        }
    };

    /**
     * Register a handler for tick events. Calls continuously unless
     * it is removed or the ticker is stopped.
     *
     * @param {Function} fn - The listener function to be added for updates
     * @param {Function} [context] - The listener context
     * @param {number} [priority=PIXI.UPDATE_PRIORITY.NORMAL] - The priority for emitting
     * @returns {PIXI.ticker.Ticker} This instance of a ticker
     */


    Ticker.prototype.add = function add(fn, context) {
        var priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _const.UPDATE_PRIORITY.NORMAL;

        return this._addListener(new _TickerListener2.default(fn, context, priority));
    };

    /**
     * Add a handler for the tick event which is only execute once.
     *
     * @param {Function} fn - The listener function to be added for one update
     * @param {Function} [context] - The listener context
     * @param {number} [priority=PIXI.UPDATE_PRIORITY.NORMAL] - The priority for emitting
     * @returns {PIXI.ticker.Ticker} This instance of a ticker
     */


    Ticker.prototype.addOnce = function addOnce(fn, context) {
        var priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _const.UPDATE_PRIORITY.NORMAL;

        return this._addListener(new _TickerListener2.default(fn, context, priority, true));
    };

    /**
     * Internally adds the event handler so that it can be sorted by priority.
     * Priority allows certain handler (user, AnimatedSprite, Interaction) to be run
     * before the rendering.
     *
     * @private
     * @param {TickerListener} listener - Current listener being added.
     * @returns {PIXI.ticker.Ticker} This instance of a ticker
     */


    Ticker.prototype._addListener = function _addListener(listener) {
        // For attaching to head
        var current = this._head.next;
        var previous = this._head;

        // Add the first item
        if (!current) {
            listener.connect(previous);
        } else {
            // Go from highest to lowest priority
            while (current) {
                if (listener.priority > current.priority) {
                    listener.connect(previous);
                    break;
                }
                previous = current;
                current = current.next;
            }

            // Not yet connected
            if (!listener.previous) {
                listener.connect(previous);
            }
        }

        this._startIfPossible();

        return this;
    };

    /**
     * Removes any handlers matching the function and context parameters.
     * If no handlers are left after removing, then it cancels the animation frame.
     *
     * @param {Function} fn - The listener function to be removed
     * @param {Function} [context] - The listener context to be removed
     * @returns {PIXI.ticker.Ticker} This instance of a ticker
     */


    Ticker.prototype.remove = function remove(fn, context) {
        var listener = this._head.next;

        while (listener) {
            // We found a match, lets remove it
            // no break to delete all possible matches
            // incase a listener was added 2+ times
            if (listener.match(fn, context)) {
                listener = listener.destroy();
            } else {
                listener = listener.next;
            }
        }

        if (!this._head.next) {
            this._cancelIfNeeded();
        }

        return this;
    };

    /**
     * Starts the ticker. If the ticker has listeners
     * a new animation frame is requested at this point.
     */


    Ticker.prototype.start = function start() {
        if (!this.started) {
            this.started = true;
            this._requestIfNeeded();
        }
    };

    /**
     * Stops the ticker. If the ticker has requested
     * an animation frame it is canceled at this point.
     */


    Ticker.prototype.stop = function stop() {
        if (this.started) {
            this.started = false;
            this._cancelIfNeeded();
        }
    };

    /**
     * Destroy the ticker and don't use after this. Calling
     * this method removes all references to internal events.
     */


    Ticker.prototype.destroy = function destroy() {
        this.stop();

        var listener = this._head.next;

        while (listener) {
            listener = listener.destroy(true);
        }

        this._head.destroy();
        this._head = null;
    };

    /**
     * Triggers an update. An update entails setting the
     * current {@link PIXI.ticker.Ticker#elapsedMS},
     * the current {@link PIXI.ticker.Ticker#deltaTime},
     * invoking all listeners with current deltaTime,
     * and then finally setting {@link PIXI.ticker.Ticker#lastTime}
     * with the value of currentTime that was provided.
     * This method will be called automatically by animation
     * frame callbacks if the ticker instance has been started
     * and listeners are added.
     *
     * @param {number} [currentTime=performance.now()] - the current time of execution
     */


    Ticker.prototype.update = function update() {
        var currentTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();

        var elapsedMS = void 0;

        // If the difference in time is zero or negative, we ignore most of the work done here.
        // If there is no valid difference, then should be no reason to let anyone know about it.
        // A zero delta, is exactly that, nothing should update.
        //
        // The difference in time can be negative, and no this does not mean time traveling.
        // This can be the result of a race condition between when an animation frame is requested
        // on the current JavaScript engine event loop, and when the ticker's start method is invoked
        // (which invokes the internal _requestIfNeeded method). If a frame is requested before
        // _requestIfNeeded is invoked, then the callback for the animation frame the ticker requests,
        // can receive a time argument that can be less than the lastTime value that was set within
        // _requestIfNeeded. This difference is in microseconds, but this is enough to cause problems.
        //
        // This check covers this browser engine timing issue, as well as if consumers pass an invalid
        // currentTime value. This may happen if consumers opt-out of the autoStart, and update themselves.

        if (currentTime > this.lastTime) {
            // Save uncapped elapsedMS for measurement
            elapsedMS = this.elapsedMS = currentTime - this.lastTime;

            // cap the milliseconds elapsed used for deltaTime
            if (elapsedMS > this._maxElapsedMS) {
                elapsedMS = this._maxElapsedMS;
            }

            this.deltaTime = elapsedMS * _settings2.default.TARGET_FPMS * this.speed;

            // Cache a local reference, in-case ticker is destroyed
            // during the emit, we can still check for head.next
            var head = this._head;

            // Invoke listeners added to internal emitter
            var listener = head.next;

            while (listener) {
                listener = listener.emit(this.deltaTime);
            }

            if (!head.next) {
                this._cancelIfNeeded();
            }
        } else {
            this.deltaTime = this.elapsedMS = 0;
        }

        this.lastTime = currentTime;
    };

    /**
     * The frames per second at which this ticker is running.
     * The default is approximately 60 in most modern browsers.
     * **Note:** This does not factor in the value of
     * {@link PIXI.ticker.Ticker#speed}, which is specific
     * to scaling {@link PIXI.ticker.Ticker#deltaTime}.
     *
     * @member {number}
     * @readonly
     */


    _createClass(Ticker, [{
        key: 'FPS',
        get: function get() {
            return 1000 / this.elapsedMS;
        }

        /**
         * Manages the maximum amount of milliseconds allowed to
         * elapse between invoking {@link PIXI.ticker.Ticker#update}.
         * This value is used to cap {@link PIXI.ticker.Ticker#deltaTime},
         * but does not effect the measured value of {@link PIXI.ticker.Ticker#FPS}.
         * When setting this property it is clamped to a value between
         * `0` and `PIXI.settings.TARGET_FPMS * 1000`.
         *
         * @member {number}
         * @default 10
         */

    }, {
        key: 'minFPS',
        get: function get() {
            return 1000 / this._maxElapsedMS;
        },
        set: function set(fps) // eslint-disable-line require-jsdoc
        {
            // Clamp: 0 to TARGET_FPMS
            var minFPMS = Math.min(Math.max(0, fps) / 1000, _settings2.default.TARGET_FPMS);

            this._maxElapsedMS = 1 / minFPMS;
        }
    }]);

    return Ticker;
}();

exports.default = Ticker;
//# sourceMappingURL=Ticker.js.map

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Internal class for handling the priority sorting of ticker handlers.
 *
 * @private
 * @class
 * @memberof PIXI.ticker
 */
var TickerListener = function () {
    /**
     * Constructor
     *
     * @param {Function} fn - The listener function to be added for one update
     * @param {Function} [context=null] - The listener context
     * @param {number} [priority=0] - The priority for emitting
     * @param {boolean} [once=false] - If the handler should fire once
     */
    function TickerListener(fn) {
        var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        var once = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        _classCallCheck(this, TickerListener);

        /**
         * The handler function to execute.
         * @member {Function}
         */
        this.fn = fn;

        /**
         * The calling to execute.
         * @member {Function}
         */
        this.context = context;

        /**
         * The current priority.
         * @member {number}
         */
        this.priority = priority;

        /**
         * If this should only execute once.
         * @member {boolean}
         */
        this.once = once;

        /**
         * The next item in chain.
         * @member {TickerListener}
         */
        this.next = null;

        /**
         * The previous item in chain.
         * @member {TickerListener}
         */
        this.previous = null;

        /**
         * `true` if this listener has been destroyed already.
         * @member {boolean}
         * @private
         */
        this._destroyed = false;
    }

    /**
     * Simple compare function to figure out if a function and context match.
     *
     * @param {Function} fn - The listener function to be added for one update
     * @param {Function} context - The listener context
     * @return {boolean} `true` if the listener match the arguments
     */


    TickerListener.prototype.match = function match(fn, context) {
        context = context || null;

        return this.fn === fn && this.context === context;
    };

    /**
     * Emit by calling the current function.
     * @param {number} deltaTime - time since the last emit.
     * @return {TickerListener} Next ticker
     */


    TickerListener.prototype.emit = function emit(deltaTime) {
        if (this.fn) {
            if (this.context) {
                this.fn.call(this.context, deltaTime);
            } else {
                this.fn(deltaTime);
            }
        }

        var redirect = this.next;

        if (this.once) {
            this.destroy(true);
        }

        // Soft-destroying should remove
        // the next reference
        if (this._destroyed) {
            this.next = null;
        }

        return redirect;
    };

    /**
     * Connect to the list.
     * @param {TickerListener} previous - Input node, previous listener
     */


    TickerListener.prototype.connect = function connect(previous) {
        this.previous = previous;
        if (previous.next) {
            previous.next.previous = this;
        }
        this.next = previous.next;
        previous.next = this;
    };

    /**
     * Destroy and don't use after this.
     * @param {boolean} [hard = false] `true` to remove the `next` reference, this
     *        is considered a hard destroy. Soft destroy maintains the next reference.
     * @return {TickerListener} The listener to redirect while emitting or removing.
     */


    TickerListener.prototype.destroy = function destroy() {
        var hard = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        this._destroyed = true;
        this.fn = null;
        this.context = null;

        // Disconnect, hook up next and previous
        if (this.previous) {
            this.previous.next = this.next;
        }

        if (this.next) {
            this.next.previous = this.previous;
        }

        // Redirect to the next item
        var redirect = this.next;

        // Remove references
        this.next = hard ? null : redirect;
        this.previous = null;

        return redirect;
    };

    return TickerListener;
}();

exports.default = TickerListener;
//# sourceMappingURL=TickerListener.js.map

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _CanvasRenderer = __webpack_require__(84);

var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);

var _const = __webpack_require__(5);

var _math = __webpack_require__(20);

var _CanvasTinter = __webpack_require__(101);

var _CanvasTinter2 = _interopRequireDefault(_CanvasTinter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var canvasRenderWorldTransform = new _math.Matrix();

/**
 * @author Mat Groves
 *
 * Big thanks to the very clever Matt DesLauriers <mattdesl> https://github.com/mattdesl/
 * for creating the original PixiJS version!
 * Also a thanks to https://github.com/bchevalier for tweaking the tint and alpha so that they now
 * share 4 bytes on the vertex buffer
 *
 * Heavily inspired by LibGDX's CanvasSpriteRenderer:
 * https://github.com/libgdx/libgdx/blob/master/gdx/src/com/badlogic/gdx/graphics/g2d/CanvasSpriteRenderer.java
 */

/**
 * Renderer dedicated to drawing and batching sprites.
 *
 * @class
 * @private
 * @memberof PIXI
 */

var CanvasSpriteRenderer = function () {
    /**
     * @param {PIXI.WebGLRenderer} renderer -The renderer sprite this batch works for.
     */
    function CanvasSpriteRenderer(renderer) {
        _classCallCheck(this, CanvasSpriteRenderer);

        this.renderer = renderer;
    }

    /**
     * Renders the sprite object.
     *
     * @param {PIXI.Sprite} sprite - the sprite to render when using this spritebatch
     */


    CanvasSpriteRenderer.prototype.render = function render(sprite) {
        var texture = sprite._texture;
        var renderer = this.renderer;

        var width = texture._frame.width;
        var height = texture._frame.height;

        var wt = sprite.transform.worldTransform;
        var dx = 0;
        var dy = 0;

        if (texture.orig.width <= 0 || texture.orig.height <= 0 || !texture.baseTexture.source) {
            return;
        }

        renderer.setBlendMode(sprite.blendMode);

        //  Ignore null sources
        if (texture.valid) {
            renderer.context.globalAlpha = sprite.worldAlpha;

            // If smoothingEnabled is supported and we need to change the smoothing property for sprite texture
            var smoothingEnabled = texture.baseTexture.scaleMode === _const.SCALE_MODES.LINEAR;

            if (renderer.smoothProperty && renderer.context[renderer.smoothProperty] !== smoothingEnabled) {
                renderer.context[renderer.smoothProperty] = smoothingEnabled;
            }

            if (texture.trim) {
                dx = texture.trim.width / 2 + texture.trim.x - sprite.anchor.x * texture.orig.width;
                dy = texture.trim.height / 2 + texture.trim.y - sprite.anchor.y * texture.orig.height;
            } else {
                dx = (0.5 - sprite.anchor.x) * texture.orig.width;
                dy = (0.5 - sprite.anchor.y) * texture.orig.height;
            }

            if (texture.rotate) {
                wt.copy(canvasRenderWorldTransform);
                wt = canvasRenderWorldTransform;
                _math.GroupD8.matrixAppendRotationInv(wt, texture.rotate, dx, dy);
                // the anchor has already been applied above, so lets set it to zero
                dx = 0;
                dy = 0;
            }

            dx -= width / 2;
            dy -= height / 2;

            // Allow for pixel rounding
            if (renderer.roundPixels) {
                renderer.context.setTransform(wt.a, wt.b, wt.c, wt.d, wt.tx * renderer.resolution | 0, wt.ty * renderer.resolution | 0);

                dx = dx | 0;
                dy = dy | 0;
            } else {
                renderer.context.setTransform(wt.a, wt.b, wt.c, wt.d, wt.tx * renderer.resolution, wt.ty * renderer.resolution);
            }

            var resolution = texture.baseTexture.resolution;

            if (sprite.tint !== 0xFFFFFF) {
                if (sprite.cachedTint !== sprite.tint || sprite.tintedTexture.tintId !== sprite._texture._updateID) {
                    sprite.cachedTint = sprite.tint;

                    // TODO clean up caching - how to clean up the caches?
                    sprite.tintedTexture = _CanvasTinter2.default.getTintedTexture(sprite, sprite.tint);
                }

                renderer.context.drawImage(sprite.tintedTexture, 0, 0, width * resolution, height * resolution, dx * renderer.resolution, dy * renderer.resolution, width * renderer.resolution, height * renderer.resolution);
            } else {
                renderer.context.drawImage(texture.baseTexture.source, texture._frame.x * resolution, texture._frame.y * resolution, width * resolution, height * resolution, dx * renderer.resolution, dy * renderer.resolution, width * renderer.resolution, height * renderer.resolution);
            }
        }
    };

    /**
     * destroy the sprite object.
     *
     */


    CanvasSpriteRenderer.prototype.destroy = function destroy() {
        this.renderer = null;
    };

    return CanvasSpriteRenderer;
}();

exports.default = CanvasSpriteRenderer;


_CanvasRenderer2.default.registerPlugin('sprite', CanvasSpriteRenderer);
//# sourceMappingURL=CanvasSpriteRenderer.js.map

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _const = __webpack_require__(5);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * A set of functions used to handle masking.
 *
 * @class
 * @memberof PIXI
 */
var CanvasMaskManager = function () {
    /**
     * @param {PIXI.CanvasRenderer} renderer - The canvas renderer.
     */
    function CanvasMaskManager(renderer) {
        _classCallCheck(this, CanvasMaskManager);

        this.renderer = renderer;
    }

    /**
     * This method adds it to the current stack of masks.
     *
     * @param {object} maskData - the maskData that will be pushed
     */


    CanvasMaskManager.prototype.pushMask = function pushMask(maskData) {
        var renderer = this.renderer;

        renderer.context.save();

        var cacheAlpha = maskData.alpha;
        var transform = maskData.transform.worldTransform;
        var resolution = renderer.resolution;

        renderer.context.setTransform(transform.a * resolution, transform.b * resolution, transform.c * resolution, transform.d * resolution, transform.tx * resolution, transform.ty * resolution);

        // TODO suport sprite alpha masks??
        // lots of effort required. If demand is great enough..
        if (!maskData._texture) {
            this.renderGraphicsShape(maskData);
            renderer.context.clip();
        }

        maskData.worldAlpha = cacheAlpha;
    };

    /**
     * Renders a PIXI.Graphics shape.
     *
     * @param {PIXI.Graphics} graphics - The object to render.
     */


    CanvasMaskManager.prototype.renderGraphicsShape = function renderGraphicsShape(graphics) {
        var context = this.renderer.context;
        var len = graphics.graphicsData.length;

        if (len === 0) {
            return;
        }

        context.beginPath();

        for (var i = 0; i < len; i++) {
            var data = graphics.graphicsData[i];
            var shape = data.shape;

            if (data.type === _const.SHAPES.POLY) {
                var points = shape.points;
                var holes = data.holes;
                var outerArea = void 0;
                var innerArea = void 0;

                context.moveTo(points[0], points[1]);

                for (var j = 2; j < points.length; j += 2) {
                    context.lineTo(points[j], points[j + 1]);
                }

                // if the first and last point are the same close the path - much neater :)
                if (points[0] === points[points.length - 2] && points[1] === points[points.length - 1]) {
                    context.closePath();
                }

                if (holes.length > 0) {
                    outerArea = 0;
                    for (var _j = 0; _j < points.length; _j += 2) {
                        outerArea += points[_j] * points[_j + 3] - points[_j + 1] * points[_j + 2];
                    }

                    for (var k = 0; k < holes.length; k++) {
                        points = holes[k].points;

                        innerArea = 0;
                        for (var _j2 = 0; _j2 < points.length; _j2 += 2) {
                            innerArea += points[_j2] * points[_j2 + 3] - points[_j2 + 1] * points[_j2 + 2];
                        }

                        context.moveTo(points[0], points[1]);

                        if (innerArea * outerArea < 0) {
                            for (var _j3 = 2; _j3 < points.length; _j3 += 2) {
                                context.lineTo(points[_j3], points[_j3 + 1]);
                            }
                        } else {
                            for (var _j4 = points.length - 2; _j4 >= 2; _j4 -= 2) {
                                context.lineTo(points[_j4], points[_j4 + 1]);
                            }
                        }
                    }
                }
            } else if (data.type === _const.SHAPES.RECT) {
                context.rect(shape.x, shape.y, shape.width, shape.height);
                context.closePath();
            } else if (data.type === _const.SHAPES.CIRC) {
                // TODO - need to be Undefined!
                context.arc(shape.x, shape.y, shape.radius, 0, 2 * Math.PI);
                context.closePath();
            } else if (data.type === _const.SHAPES.ELIP) {
                // ellipse code taken from: http://stackoverflow.com/questions/2172798/how-to-draw-an-oval-in-html5-canvas

                var w = shape.width * 2;
                var h = shape.height * 2;

                var x = shape.x - w / 2;
                var y = shape.y - h / 2;

                var kappa = 0.5522848;
                var ox = w / 2 * kappa; // control point offset horizontal
                var oy = h / 2 * kappa; // control point offset vertical
                var xe = x + w; // x-end
                var ye = y + h; // y-end
                var xm = x + w / 2; // x-middle
                var ym = y + h / 2; // y-middle

                context.moveTo(x, ym);
                context.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
                context.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
                context.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
                context.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);
                context.closePath();
            } else if (data.type === _const.SHAPES.RREC) {
                var rx = shape.x;
                var ry = shape.y;
                var width = shape.width;
                var height = shape.height;
                var radius = shape.radius;

                var maxRadius = Math.min(width, height) / 2 | 0;

                radius = radius > maxRadius ? maxRadius : radius;

                context.moveTo(rx, ry + radius);
                context.lineTo(rx, ry + height - radius);
                context.quadraticCurveTo(rx, ry + height, rx + radius, ry + height);
                context.lineTo(rx + width - radius, ry + height);
                context.quadraticCurveTo(rx + width, ry + height, rx + width, ry + height - radius);
                context.lineTo(rx + width, ry + radius);
                context.quadraticCurveTo(rx + width, ry, rx + width - radius, ry);
                context.lineTo(rx + radius, ry);
                context.quadraticCurveTo(rx, ry, rx, ry + radius);
                context.closePath();
            }
        }
    };

    /**
     * Restores the current drawing context to the state it was before the mask was applied.
     *
     * @param {PIXI.CanvasRenderer} renderer - The renderer context to use.
     */


    CanvasMaskManager.prototype.popMask = function popMask(renderer) {
        renderer.context.restore();
        renderer.invalidateBlendMode();
    };

    /**
     * Destroys this canvas mask manager.
     *
     */


    CanvasMaskManager.prototype.destroy = function destroy() {
        /* empty */
    };

    return CanvasMaskManager;
}();

exports.default = CanvasMaskManager;
//# sourceMappingURL=CanvasMaskManager.js.map

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = mapCanvasBlendModesToPixi;

var _const = __webpack_require__(5);

var _canUseNewCanvasBlendModes = __webpack_require__(190);

var _canUseNewCanvasBlendModes2 = _interopRequireDefault(_canUseNewCanvasBlendModes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Maps blend combinations to Canvas.
 *
 * @memberof PIXI
 * @function mapCanvasBlendModesToPixi
 * @private
 * @param {string[]} [array=[]] - The array to output into.
 * @return {string[]} Mapped modes.
 */
function mapCanvasBlendModesToPixi() {
    var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    if ((0, _canUseNewCanvasBlendModes2.default)()) {
        array[_const.BLEND_MODES.NORMAL] = 'source-over';
        array[_const.BLEND_MODES.ADD] = 'lighter'; // IS THIS OK???
        array[_const.BLEND_MODES.MULTIPLY] = 'multiply';
        array[_const.BLEND_MODES.SCREEN] = 'screen';
        array[_const.BLEND_MODES.OVERLAY] = 'overlay';
        array[_const.BLEND_MODES.DARKEN] = 'darken';
        array[_const.BLEND_MODES.LIGHTEN] = 'lighten';
        array[_const.BLEND_MODES.COLOR_DODGE] = 'color-dodge';
        array[_const.BLEND_MODES.COLOR_BURN] = 'color-burn';
        array[_const.BLEND_MODES.HARD_LIGHT] = 'hard-light';
        array[_const.BLEND_MODES.SOFT_LIGHT] = 'soft-light';
        array[_const.BLEND_MODES.DIFFERENCE] = 'difference';
        array[_const.BLEND_MODES.EXCLUSION] = 'exclusion';
        array[_const.BLEND_MODES.HUE] = 'hue';
        array[_const.BLEND_MODES.SATURATION] = 'saturate';
        array[_const.BLEND_MODES.COLOR] = 'color';
        array[_const.BLEND_MODES.LUMINOSITY] = 'luminosity';
    } else {
        // this means that the browser does not support the cool new blend modes in canvas 'cough' ie 'cough'
        array[_const.BLEND_MODES.NORMAL] = 'source-over';
        array[_const.BLEND_MODES.ADD] = 'lighter'; // IS THIS OK???
        array[_const.BLEND_MODES.MULTIPLY] = 'source-over';
        array[_const.BLEND_MODES.SCREEN] = 'source-over';
        array[_const.BLEND_MODES.OVERLAY] = 'source-over';
        array[_const.BLEND_MODES.DARKEN] = 'source-over';
        array[_const.BLEND_MODES.LIGHTEN] = 'source-over';
        array[_const.BLEND_MODES.COLOR_DODGE] = 'source-over';
        array[_const.BLEND_MODES.COLOR_BURN] = 'source-over';
        array[_const.BLEND_MODES.HARD_LIGHT] = 'source-over';
        array[_const.BLEND_MODES.SOFT_LIGHT] = 'source-over';
        array[_const.BLEND_MODES.DIFFERENCE] = 'source-over';
        array[_const.BLEND_MODES.EXCLUSION] = 'source-over';
        array[_const.BLEND_MODES.HUE] = 'source-over';
        array[_const.BLEND_MODES.SATURATION] = 'source-over';
        array[_const.BLEND_MODES.COLOR] = 'source-over';
        array[_const.BLEND_MODES.LUMINOSITY] = 'source-over';
    }
    // not-premultiplied, only for webgl
    array[_const.BLEND_MODES.NORMAL_NPM] = array[_const.BLEND_MODES.NORMAL];
    array[_const.BLEND_MODES.ADD_NPM] = array[_const.BLEND_MODES.ADD];
    array[_const.BLEND_MODES.SCREEN_NPM] = array[_const.BLEND_MODES.SCREEN];

    return array;
}
//# sourceMappingURL=mapCanvasBlendModesToPixi.js.map

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _ObjectRenderer2 = __webpack_require__(102);

var _ObjectRenderer3 = _interopRequireDefault(_ObjectRenderer2);

var _WebGLRenderer = __webpack_require__(103);

var _WebGLRenderer2 = _interopRequireDefault(_WebGLRenderer);

var _createIndicesForQuads = __webpack_require__(136);

var _createIndicesForQuads2 = _interopRequireDefault(_createIndicesForQuads);

var _generateMultiTextureShader = __webpack_require__(383);

var _generateMultiTextureShader2 = _interopRequireDefault(_generateMultiTextureShader);

var _checkMaxIfStatmentsInShader = __webpack_require__(384);

var _checkMaxIfStatmentsInShader2 = _interopRequireDefault(_checkMaxIfStatmentsInShader);

var _BatchBuffer = __webpack_require__(385);

var _BatchBuffer2 = _interopRequireDefault(_BatchBuffer);

var _settings = __webpack_require__(17);

var _settings2 = _interopRequireDefault(_settings);

var _utils = __webpack_require__(9);

var _pixiGlCore = __webpack_require__(31);

var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);

var _bitTwiddle = __webpack_require__(133);

var _bitTwiddle2 = _interopRequireDefault(_bitTwiddle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TICK = 0;
var TEXTURE_TICK = 0;

/**
 * Renderer dedicated to drawing and batching sprites.
 *
 * @class
 * @private
 * @memberof PIXI
 * @extends PIXI.ObjectRenderer
 */

var SpriteRenderer = function (_ObjectRenderer) {
    _inherits(SpriteRenderer, _ObjectRenderer);

    /**
     * @param {PIXI.WebGLRenderer} renderer - The renderer this sprite batch works for.
     */
    function SpriteRenderer(renderer) {
        _classCallCheck(this, SpriteRenderer);

        /**
         * Number of values sent in the vertex buffer.
         * aVertexPosition(2), aTextureCoord(1), aColor(1), aTextureId(1) = 5
         *
         * @member {number}
         */
        var _this = _possibleConstructorReturn(this, _ObjectRenderer.call(this, renderer));

        _this.vertSize = 5;

        /**
         * The size of the vertex information in bytes.
         *
         * @member {number}
         */
        _this.vertByteSize = _this.vertSize * 4;

        /**
         * The number of images in the SpriteRenderer before it flushes.
         *
         * @member {number}
         */
        _this.size = _settings2.default.SPRITE_BATCH_SIZE; // 2000 is a nice balance between mobile / desktop

        // the total number of bytes in our batch
        // let numVerts = this.size * 4 * this.vertByteSize;

        _this.buffers = [];
        for (var i = 1; i <= _bitTwiddle2.default.nextPow2(_this.size); i *= 2) {
            _this.buffers.push(new _BatchBuffer2.default(i * 4 * _this.vertByteSize));
        }

        /**
         * Holds the indices of the geometry (quads) to draw
         *
         * @member {Uint16Array}
         */
        _this.indices = (0, _createIndicesForQuads2.default)(_this.size);

        /**
         * The default shaders that is used if a sprite doesn't have a more specific one.
         * there is a shader for each number of textures that can be rendererd.
         * These shaders will also be generated on the fly as required.
         * @member {PIXI.Shader[]}
         */
        _this.shader = null;

        _this.currentIndex = 0;
        _this.groups = [];

        for (var k = 0; k < _this.size; k++) {
            _this.groups[k] = { textures: [], textureCount: 0, ids: [], size: 0, start: 0, blend: 0 };
        }

        _this.sprites = [];

        _this.vertexBuffers = [];
        _this.vaos = [];

        _this.vaoMax = 2;
        _this.vertexCount = 0;

        _this.renderer.on('prerender', _this.onPrerender, _this);
        return _this;
    }

    /**
     * Sets up the renderer context and necessary buffers.
     *
     * @private
     */


    SpriteRenderer.prototype.onContextChange = function onContextChange() {
        var gl = this.renderer.gl;

        if (this.renderer.legacy) {
            this.MAX_TEXTURES = 1;
        } else {
            // step 1: first check max textures the GPU can handle.
            this.MAX_TEXTURES = Math.min(gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS), _settings2.default.SPRITE_MAX_TEXTURES);

            // step 2: check the maximum number of if statements the shader can have too..
            this.MAX_TEXTURES = (0, _checkMaxIfStatmentsInShader2.default)(this.MAX_TEXTURES, gl);
        }

        this.shader = (0, _generateMultiTextureShader2.default)(gl, this.MAX_TEXTURES);

        // create a couple of buffers
        this.indexBuffer = _pixiGlCore2.default.GLBuffer.createIndexBuffer(gl, this.indices, gl.STATIC_DRAW);

        // we use the second shader as the first one depending on your browser may omit aTextureId
        // as it is not used by the shader so is optimized out.

        this.renderer.bindVao(null);

        var attrs = this.shader.attributes;

        for (var i = 0; i < this.vaoMax; i++) {
            /* eslint-disable max-len */
            var vertexBuffer = this.vertexBuffers[i] = _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, null, gl.STREAM_DRAW);
            /* eslint-enable max-len */

            // build the vao object that will render..
            var vao = this.renderer.createVao().addIndex(this.indexBuffer).addAttribute(vertexBuffer, attrs.aVertexPosition, gl.FLOAT, false, this.vertByteSize, 0).addAttribute(vertexBuffer, attrs.aTextureCoord, gl.UNSIGNED_SHORT, true, this.vertByteSize, 2 * 4).addAttribute(vertexBuffer, attrs.aColor, gl.UNSIGNED_BYTE, true, this.vertByteSize, 3 * 4);

            if (attrs.aTextureId) {
                vao.addAttribute(vertexBuffer, attrs.aTextureId, gl.FLOAT, false, this.vertByteSize, 4 * 4);
            }

            this.vaos[i] = vao;
        }

        this.vao = this.vaos[0];
        this.currentBlendMode = 99999;

        this.boundTextures = new Array(this.MAX_TEXTURES);
    };

    /**
     * Called before the renderer starts rendering.
     *
     */


    SpriteRenderer.prototype.onPrerender = function onPrerender() {
        this.vertexCount = 0;
    };

    /**
     * Renders the sprite object.
     *
     * @param {PIXI.Sprite} sprite - the sprite to render when using this spritebatch
     */


    SpriteRenderer.prototype.render = function render(sprite) {
        // TODO set blend modes..
        // check texture..
        if (this.currentIndex >= this.size) {
            this.flush();
        }

        // get the uvs for the texture

        // if the uvs have not updated then no point rendering just yet!
        if (!sprite._texture._uvs) {
            return;
        }

        // push a texture.
        // increment the batchsize
        this.sprites[this.currentIndex++] = sprite;
    };

    /**
     * Renders the content and empties the current batch.
     *
     */


    SpriteRenderer.prototype.flush = function flush() {
        if (this.currentIndex === 0) {
            return;
        }

        var gl = this.renderer.gl;
        var MAX_TEXTURES = this.MAX_TEXTURES;

        var np2 = _bitTwiddle2.default.nextPow2(this.currentIndex);
        var log2 = _bitTwiddle2.default.log2(np2);
        var buffer = this.buffers[log2];

        var sprites = this.sprites;
        var groups = this.groups;

        var float32View = buffer.float32View;
        var uint32View = buffer.uint32View;

        var boundTextures = this.boundTextures;
        var rendererBoundTextures = this.renderer.boundTextures;
        var touch = this.renderer.textureGC.count;

        var index = 0;
        var nextTexture = void 0;
        var currentTexture = void 0;
        var groupCount = 1;
        var textureCount = 0;
        var currentGroup = groups[0];
        var vertexData = void 0;
        var uvs = void 0;
        var blendMode = _utils.premultiplyBlendMode[sprites[0]._texture.baseTexture.premultipliedAlpha ? 1 : 0][sprites[0].blendMode];

        currentGroup.textureCount = 0;
        currentGroup.start = 0;
        currentGroup.blend = blendMode;

        TICK++;

        var i = void 0;

        // copy textures..
        for (i = 0; i < MAX_TEXTURES; ++i) {
            var bt = rendererBoundTextures[i];

            if (bt._enabled === TICK) {
                boundTextures[i] = this.renderer.emptyTextures[i];
                continue;
            }

            boundTextures[i] = bt;
            bt._virtalBoundId = i;
            bt._enabled = TICK;
        }
        TICK++;

        for (i = 0; i < this.currentIndex; ++i) {
            // upload the sprite elemetns...
            // they have all ready been calculated so we just need to push them into the buffer.
            var sprite = sprites[i];

            sprites[i] = null;

            nextTexture = sprite._texture.baseTexture;

            var spriteBlendMode = _utils.premultiplyBlendMode[Number(nextTexture.premultipliedAlpha)][sprite.blendMode];

            if (blendMode !== spriteBlendMode) {
                // finish a group..
                blendMode = spriteBlendMode;

                // force the batch to break!
                currentTexture = null;
                textureCount = MAX_TEXTURES;
                TICK++;
            }

            if (currentTexture !== nextTexture) {
                currentTexture = nextTexture;

                if (nextTexture._enabled !== TICK) {
                    if (textureCount === MAX_TEXTURES) {
                        TICK++;

                        currentGroup.size = i - currentGroup.start;

                        textureCount = 0;

                        currentGroup = groups[groupCount++];
                        currentGroup.blend = blendMode;
                        currentGroup.textureCount = 0;
                        currentGroup.start = i;
                    }

                    nextTexture.touched = touch;

                    if (nextTexture._virtalBoundId === -1) {
                        for (var j = 0; j < MAX_TEXTURES; ++j) {
                            var tIndex = (j + TEXTURE_TICK) % MAX_TEXTURES;

                            var t = boundTextures[tIndex];

                            if (t._enabled !== TICK) {
                                TEXTURE_TICK++;

                                t._virtalBoundId = -1;

                                nextTexture._virtalBoundId = tIndex;

                                boundTextures[tIndex] = nextTexture;
                                break;
                            }
                        }
                    }

                    nextTexture._enabled = TICK;

                    currentGroup.textureCount++;
                    currentGroup.ids[textureCount] = nextTexture._virtalBoundId;
                    currentGroup.textures[textureCount++] = nextTexture;
                }
            }

            vertexData = sprite.vertexData;

            // TODO this sum does not need to be set each frame..
            uvs = sprite._texture._uvs.uvsUint32;

            if (this.renderer.roundPixels) {
                var resolution = this.renderer.resolution;

                // xy
                float32View[index] = (vertexData[0] * resolution | 0) / resolution;
                float32View[index + 1] = (vertexData[1] * resolution | 0) / resolution;

                // xy
                float32View[index + 5] = (vertexData[2] * resolution | 0) / resolution;
                float32View[index + 6] = (vertexData[3] * resolution | 0) / resolution;

                // xy
                float32View[index + 10] = (vertexData[4] * resolution | 0) / resolution;
                float32View[index + 11] = (vertexData[5] * resolution | 0) / resolution;

                // xy
                float32View[index + 15] = (vertexData[6] * resolution | 0) / resolution;
                float32View[index + 16] = (vertexData[7] * resolution | 0) / resolution;
            } else {
                // xy
                float32View[index] = vertexData[0];
                float32View[index + 1] = vertexData[1];

                // xy
                float32View[index + 5] = vertexData[2];
                float32View[index + 6] = vertexData[3];

                // xy
                float32View[index + 10] = vertexData[4];
                float32View[index + 11] = vertexData[5];

                // xy
                float32View[index + 15] = vertexData[6];
                float32View[index + 16] = vertexData[7];
            }

            uint32View[index + 2] = uvs[0];
            uint32View[index + 7] = uvs[1];
            uint32View[index + 12] = uvs[2];
            uint32View[index + 17] = uvs[3];
            /* eslint-disable max-len */
            var alpha = Math.min(sprite.worldAlpha, 1.0);
            // we dont call extra function if alpha is 1.0, that's faster
            var argb = alpha < 1.0 && nextTexture.premultipliedAlpha ? (0, _utils.premultiplyTint)(sprite._tintRGB, alpha) : sprite._tintRGB + (alpha * 255 << 24);

            uint32View[index + 3] = uint32View[index + 8] = uint32View[index + 13] = uint32View[index + 18] = argb;
            float32View[index + 4] = float32View[index + 9] = float32View[index + 14] = float32View[index + 19] = nextTexture._virtalBoundId;
            /* eslint-enable max-len */

            index += 20;
        }

        currentGroup.size = i - currentGroup.start;

        if (!_settings2.default.CAN_UPLOAD_SAME_BUFFER) {
            // this is still needed for IOS performance..
            // it really does not like uploading to the same buffer in a single frame!
            if (this.vaoMax <= this.vertexCount) {
                this.vaoMax++;

                var attrs = this.shader.attributes;

                /* eslint-disable max-len */
                var vertexBuffer = this.vertexBuffers[this.vertexCount] = _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, null, gl.STREAM_DRAW);
                /* eslint-enable max-len */

                // build the vao object that will render..
                var vao = this.renderer.createVao().addIndex(this.indexBuffer).addAttribute(vertexBuffer, attrs.aVertexPosition, gl.FLOAT, false, this.vertByteSize, 0).addAttribute(vertexBuffer, attrs.aTextureCoord, gl.UNSIGNED_SHORT, true, this.vertByteSize, 2 * 4).addAttribute(vertexBuffer, attrs.aColor, gl.UNSIGNED_BYTE, true, this.vertByteSize, 3 * 4);

                if (attrs.aTextureId) {
                    vao.addAttribute(vertexBuffer, attrs.aTextureId, gl.FLOAT, false, this.vertByteSize, 4 * 4);
                }

                this.vaos[this.vertexCount] = vao;
            }

            this.renderer.bindVao(this.vaos[this.vertexCount]);

            this.vertexBuffers[this.vertexCount].upload(buffer.vertices, 0, false);

            this.vertexCount++;
        } else {
            // lets use the faster option, always use buffer number 0
            this.vertexBuffers[this.vertexCount].upload(buffer.vertices, 0, true);
        }

        for (i = 0; i < MAX_TEXTURES; ++i) {
            rendererBoundTextures[i]._virtalBoundId = -1;
        }

        // render the groups..
        for (i = 0; i < groupCount; ++i) {
            var group = groups[i];
            var groupTextureCount = group.textureCount;

            for (var _j = 0; _j < groupTextureCount; _j++) {
                currentTexture = group.textures[_j];

                // reset virtual ids..
                // lets do a quick check..
                if (rendererBoundTextures[group.ids[_j]] !== currentTexture) {
                    this.renderer.bindTexture(currentTexture, group.ids[_j], true);
                }

                // reset the virtualId..
                currentTexture._virtalBoundId = -1;
            }

            // set the blend mode..
            this.renderer.state.setBlendMode(group.blend);

            gl.drawElements(gl.TRIANGLES, group.size * 6, gl.UNSIGNED_SHORT, group.start * 6 * 2);
        }

        // reset elements for the next flush
        this.currentIndex = 0;
    };

    /**
     * Starts a new sprite batch.
     */


    SpriteRenderer.prototype.start = function start() {
        this.renderer.bindShader(this.shader);

        if (_settings2.default.CAN_UPLOAD_SAME_BUFFER) {
            // bind buffer #0, we don't need others
            this.renderer.bindVao(this.vaos[this.vertexCount]);

            this.vertexBuffers[this.vertexCount].bind();
        }
    };

    /**
     * Stops and flushes the current batch.
     *
     */


    SpriteRenderer.prototype.stop = function stop() {
        this.flush();
    };

    /**
     * Destroys the SpriteRenderer.
     *
     */


    SpriteRenderer.prototype.destroy = function destroy() {
        for (var i = 0; i < this.vaoMax; i++) {
            if (this.vertexBuffers[i]) {
                this.vertexBuffers[i].destroy();
            }
            if (this.vaos[i]) {
                this.vaos[i].destroy();
            }
        }

        if (this.indexBuffer) {
            this.indexBuffer.destroy();
        }

        this.renderer.off('prerender', this.onPrerender, this);

        _ObjectRenderer.prototype.destroy.call(this);

        if (this.shader) {
            this.shader.destroy();
            this.shader = null;
        }

        this.vertexBuffers = null;
        this.vaos = null;
        this.indexBuffer = null;
        this.indices = null;

        this.sprites = null;

        for (var _i = 0; _i < this.buffers.length; ++_i) {
            this.buffers[_i].destroy();
        }
    };

    return SpriteRenderer;
}(_ObjectRenderer3.default);

exports.default = SpriteRenderer;


_WebGLRenderer2.default.registerPlugin('sprite', SpriteRenderer);
//# sourceMappingURL=SpriteRenderer.js.map

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _WebGLManager2 = __webpack_require__(85);

var _WebGLManager3 = _interopRequireDefault(_WebGLManager2);

var _SpriteMaskFilter = __webpack_require__(191);

var _SpriteMaskFilter2 = _interopRequireDefault(_SpriteMaskFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class
 * @extends PIXI.WebGLManager
 * @memberof PIXI
 */
var MaskManager = function (_WebGLManager) {
    _inherits(MaskManager, _WebGLManager);

    /**
     * @param {PIXI.WebGLRenderer} renderer - The renderer this manager works for.
     */
    function MaskManager(renderer) {
        _classCallCheck(this, MaskManager);

        // TODO - we don't need both!
        var _this = _possibleConstructorReturn(this, _WebGLManager.call(this, renderer));

        _this.scissor = false;
        _this.scissorData = null;
        _this.scissorRenderTarget = null;

        _this.enableScissor = true;

        _this.alphaMaskPool = [];
        _this.alphaMaskIndex = 0;
        return _this;
    }

    /**
     * Applies the Mask and adds it to the current filter stack.
     *
     * @param {PIXI.DisplayObject} target - Display Object to push the mask to
     * @param {PIXI.Sprite|PIXI.Graphics} maskData - The masking data.
     */


    MaskManager.prototype.pushMask = function pushMask(target, maskData) {
        // TODO the root check means scissor rect will not
        // be used on render textures more info here:
        // https://github.com/pixijs/pixi.js/pull/3545

        if (maskData.texture) {
            this.pushSpriteMask(target, maskData);
        } else if (this.enableScissor && !this.scissor && this.renderer._activeRenderTarget.root && !this.renderer.stencilManager.stencilMaskStack.length && maskData.isFastRect()) {
            var matrix = maskData.worldTransform;

            var rot = Math.atan2(matrix.b, matrix.a);

            // use the nearest degree!
            rot = Math.round(rot * (180 / Math.PI));

            if (rot % 90) {
                this.pushStencilMask(maskData);
            } else {
                this.pushScissorMask(target, maskData);
            }
        } else {
            this.pushStencilMask(maskData);
        }
    };

    /**
     * Removes the last mask from the mask stack and doesn't return it.
     *
     * @param {PIXI.DisplayObject} target - Display Object to pop the mask from
     * @param {PIXI.Sprite|PIXI.Graphics} maskData - The masking data.
     */


    MaskManager.prototype.popMask = function popMask(target, maskData) {
        if (maskData.texture) {
            this.popSpriteMask(target, maskData);
        } else if (this.enableScissor && !this.renderer.stencilManager.stencilMaskStack.length) {
            this.popScissorMask(target, maskData);
        } else {
            this.popStencilMask(target, maskData);
        }
    };

    /**
     * Applies the Mask and adds it to the current filter stack.
     *
     * @param {PIXI.RenderTarget} target - Display Object to push the sprite mask to
     * @param {PIXI.Sprite} maskData - Sprite to be used as the mask
     */


    MaskManager.prototype.pushSpriteMask = function pushSpriteMask(target, maskData) {
        var alphaMaskFilter = this.alphaMaskPool[this.alphaMaskIndex];

        if (!alphaMaskFilter) {
            alphaMaskFilter = this.alphaMaskPool[this.alphaMaskIndex] = [new _SpriteMaskFilter2.default(maskData)];
        }

        alphaMaskFilter[0].resolution = this.renderer.resolution;
        alphaMaskFilter[0].maskSprite = maskData;

        var stashFilterArea = target.filterArea;

        target.filterArea = maskData.getBounds(true);
        this.renderer.filterManager.pushFilter(target, alphaMaskFilter);
        target.filterArea = stashFilterArea;

        this.alphaMaskIndex++;
    };

    /**
     * Removes the last filter from the filter stack and doesn't return it.
     *
     */


    MaskManager.prototype.popSpriteMask = function popSpriteMask() {
        this.renderer.filterManager.popFilter();
        this.alphaMaskIndex--;
    };

    /**
     * Applies the Mask and adds it to the current filter stack.
     *
     * @param {PIXI.Sprite|PIXI.Graphics} maskData - The masking data.
     */


    MaskManager.prototype.pushStencilMask = function pushStencilMask(maskData) {
        this.renderer.currentRenderer.stop();
        this.renderer.stencilManager.pushStencil(maskData);
    };

    /**
     * Removes the last filter from the filter stack and doesn't return it.
     *
     */


    MaskManager.prototype.popStencilMask = function popStencilMask() {
        this.renderer.currentRenderer.stop();
        this.renderer.stencilManager.popStencil();
    };

    /**
     *
     * @param {PIXI.DisplayObject} target - Display Object to push the mask to
     * @param {PIXI.Graphics} maskData - The masking data.
     */


    MaskManager.prototype.pushScissorMask = function pushScissorMask(target, maskData) {
        maskData.renderable = true;

        var renderTarget = this.renderer._activeRenderTarget;

        var bounds = maskData.getBounds();

        bounds.fit(renderTarget.size);
        maskData.renderable = false;

        this.renderer.gl.enable(this.renderer.gl.SCISSOR_TEST);

        var resolution = this.renderer.resolution;

        this.renderer.gl.scissor(bounds.x * resolution, (renderTarget.root ? renderTarget.size.height - bounds.y - bounds.height : bounds.y) * resolution, bounds.width * resolution, bounds.height * resolution);

        this.scissorRenderTarget = renderTarget;
        this.scissorData = maskData;
        this.scissor = true;
    };

    /**
     *
     *
     */


    MaskManager.prototype.popScissorMask = function popScissorMask() {
        this.scissorRenderTarget = null;
        this.scissorData = null;
        this.scissor = false;

        // must be scissor!
        var gl = this.renderer.gl;

        gl.disable(gl.SCISSOR_TEST);
    };

    return MaskManager;
}(_WebGLManager3.default);

exports.default = MaskManager;
//# sourceMappingURL=MaskManager.js.map

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = extractUniformsFromSrc;

var _pixiGlCore = __webpack_require__(31);

var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultValue = _pixiGlCore2.default.shader.defaultValue;

function extractUniformsFromSrc(vertexSrc, fragmentSrc, mask) {
    var vertUniforms = extractUniformsFromString(vertexSrc, mask);
    var fragUniforms = extractUniformsFromString(fragmentSrc, mask);

    return Object.assign(vertUniforms, fragUniforms);
}

function extractUniformsFromString(string) {
    var maskRegex = new RegExp('^(projectionMatrix|uSampler|filterArea|filterClamp)$');

    var uniforms = {};
    var nameSplit = void 0;

    // clean the lines a little - remove extra spaces / tabs etc
    // then split along ';'
    var lines = string.replace(/\s+/g, ' ').split(/\s*;\s*/);

    // loop through..
    for (var i = 0; i < lines.length; i++) {
        var line = lines[i].trim();

        if (line.indexOf('uniform') > -1) {
            var splitLine = line.split(' ');
            var type = splitLine[1];

            var name = splitLine[2];
            var size = 1;

            if (name.indexOf('[') > -1) {
                // array!
                nameSplit = name.split(/\[|]/);
                name = nameSplit[0];
                size *= Number(nameSplit[1]);
            }

            if (!name.match(maskRegex)) {
                uniforms[name] = {
                    value: defaultValue(type, size),
                    name: name,
                    type: type
                };
            }
        }
    }

    return uniforms;
}
//# sourceMappingURL=extractUniformsFromSrc.js.map

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _WebGLManager2 = __webpack_require__(85);

var _WebGLManager3 = _interopRequireDefault(_WebGLManager2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class
 * @extends PIXI.WebGLManager
 * @memberof PIXI
 */
var StencilManager = function (_WebGLManager) {
    _inherits(StencilManager, _WebGLManager);

    /**
     * @param {PIXI.WebGLRenderer} renderer - The renderer this manager works for.
     */
    function StencilManager(renderer) {
        _classCallCheck(this, StencilManager);

        var _this = _possibleConstructorReturn(this, _WebGLManager.call(this, renderer));

        _this.stencilMaskStack = null;
        return _this;
    }

    /**
     * Changes the mask stack that is used by this manager.
     *
     * @param {PIXI.Graphics[]} stencilMaskStack - The mask stack
     */


    StencilManager.prototype.setMaskStack = function setMaskStack(stencilMaskStack) {
        this.stencilMaskStack = stencilMaskStack;

        var gl = this.renderer.gl;

        if (stencilMaskStack.length === 0) {
            gl.disable(gl.STENCIL_TEST);
        } else {
            gl.enable(gl.STENCIL_TEST);
        }
    };

    /**
     * Applies the Mask and adds it to the current stencil stack. @alvin
     *
     * @param {PIXI.Graphics} graphics - The mask
     */


    StencilManager.prototype.pushStencil = function pushStencil(graphics) {
        this.renderer.setObjectRenderer(this.renderer.plugins.graphics);

        this.renderer._activeRenderTarget.attachStencilBuffer();

        var gl = this.renderer.gl;
        var prevMaskCount = this.stencilMaskStack.length;

        if (prevMaskCount === 0) {
            gl.enable(gl.STENCIL_TEST);
        }

        this.stencilMaskStack.push(graphics);

        // Increment the reference stencil value where the new mask overlaps with the old ones.
        gl.colorMask(false, false, false, false);
        gl.stencilFunc(gl.EQUAL, prevMaskCount, this._getBitwiseMask());
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.INCR);
        this.renderer.plugins.graphics.render(graphics);

        this._useCurrent();
    };

    /**
     * Removes the last mask from the stencil stack. @alvin
     */


    StencilManager.prototype.popStencil = function popStencil() {
        this.renderer.setObjectRenderer(this.renderer.plugins.graphics);

        var gl = this.renderer.gl;
        var graphics = this.stencilMaskStack.pop();

        if (this.stencilMaskStack.length === 0) {
            // the stack is empty!
            gl.disable(gl.STENCIL_TEST);
            gl.clear(gl.STENCIL_BUFFER_BIT);
            gl.clearStencil(0);
        } else {
            // Decrement the reference stencil value where the popped mask overlaps with the other ones
            gl.colorMask(false, false, false, false);
            gl.stencilOp(gl.KEEP, gl.KEEP, gl.DECR);
            this.renderer.plugins.graphics.render(graphics);

            this._useCurrent();
        }
    };

    /**
     * Setup renderer to use the current stencil data.
     */


    StencilManager.prototype._useCurrent = function _useCurrent() {
        var gl = this.renderer.gl;

        gl.colorMask(true, true, true, true);
        gl.stencilFunc(gl.EQUAL, this.stencilMaskStack.length, this._getBitwiseMask());
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
    };

    /**
     * Fill 1s equal to the number of acitve stencil masks.
     *
     * @return {number} The bitwise mask.
     */


    StencilManager.prototype._getBitwiseMask = function _getBitwiseMask() {
        return (1 << this.stencilMaskStack.length) - 1;
    };

    /**
     * Destroys the mask stack.
     *
     */


    StencilManager.prototype.destroy = function destroy() {
        _WebGLManager3.default.prototype.destroy.call(this);

        this.stencilMaskStack.stencilStack = null;
    };

    return StencilManager;
}(_WebGLManager3.default);

exports.default = StencilManager;
//# sourceMappingURL=StencilManager.js.map

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _WebGLManager2 = __webpack_require__(85);

var _WebGLManager3 = _interopRequireDefault(_WebGLManager2);

var _RenderTarget = __webpack_require__(104);

var _RenderTarget2 = _interopRequireDefault(_RenderTarget);

var _Quad = __webpack_require__(194);

var _Quad2 = _interopRequireDefault(_Quad);

var _math = __webpack_require__(20);

var _Shader = __webpack_require__(86);

var _Shader2 = _interopRequireDefault(_Shader);

var _filterTransforms = __webpack_require__(376);

var filterTransforms = _interopRequireWildcard(_filterTransforms);

var _bitTwiddle = __webpack_require__(133);

var _bitTwiddle2 = _interopRequireDefault(_bitTwiddle);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @ignore
 * @class
 */
var FilterState = function () {
    /**
     *
     */
    function FilterState() {
        _classCallCheck(this, FilterState);

        this.renderTarget = null;
        this.target = null;
        this.resolution = 1;

        // those three objects are used only for root
        // re-assigned for everything else
        this.sourceFrame = new _math.Rectangle();
        this.destinationFrame = new _math.Rectangle();
        this.filters = [];
    }

    /**
     * clears the state
     */


    FilterState.prototype.clear = function clear() {
        this.filters = null;
        this.target = null;
        this.renderTarget = null;
    };

    return FilterState;
}();

var screenKey = 'screen';

/**
 * @class
 * @memberof PIXI
 * @extends PIXI.WebGLManager
 */

var FilterManager = function (_WebGLManager) {
    _inherits(FilterManager, _WebGLManager);

    /**
     * @param {PIXI.WebGLRenderer} renderer - The renderer this manager works for.
     */
    function FilterManager(renderer) {
        _classCallCheck(this, FilterManager);

        var _this = _possibleConstructorReturn(this, _WebGLManager.call(this, renderer));

        _this.gl = _this.renderer.gl;
        // know about sprites!
        _this.quad = new _Quad2.default(_this.gl, renderer.state.attribState);

        _this.shaderCache = {};
        // todo add default!
        _this.pool = {};

        _this.filterData = null;

        _this.managedFilters = [];

        _this.renderer.on('prerender', _this.onPrerender, _this);

        _this._screenWidth = renderer.view.width;
        _this._screenHeight = renderer.view.height;
        return _this;
    }

    /**
     * Adds a new filter to the manager.
     *
     * @param {PIXI.DisplayObject} target - The target of the filter to render.
     * @param {PIXI.Filter[]} filters - The filters to apply.
     */


    FilterManager.prototype.pushFilter = function pushFilter(target, filters) {
        var renderer = this.renderer;

        var filterData = this.filterData;

        if (!filterData) {
            filterData = this.renderer._activeRenderTarget.filterStack;

            // add new stack
            var filterState = new FilterState();

            filterState.sourceFrame = filterState.destinationFrame = this.renderer._activeRenderTarget.size;
            filterState.renderTarget = renderer._activeRenderTarget;

            this.renderer._activeRenderTarget.filterData = filterData = {
                index: 0,
                stack: [filterState]
            };

            this.filterData = filterData;
        }

        // get the current filter state..
        var currentState = filterData.stack[++filterData.index];
        var renderTargetFrame = filterData.stack[0].destinationFrame;

        if (!currentState) {
            currentState = filterData.stack[filterData.index] = new FilterState();
        }

        var fullScreen = target.filterArea && target.filterArea.x === 0 && target.filterArea.y === 0 && target.filterArea.width === renderer.screen.width && target.filterArea.height === renderer.screen.height;

        // for now we go off the filter of the first resolution..
        var resolution = filters[0].resolution;
        var padding = filters[0].padding | 0;
        var targetBounds = fullScreen ? renderer.screen : target.filterArea || target.getBounds(true);
        var sourceFrame = currentState.sourceFrame;
        var destinationFrame = currentState.destinationFrame;

        sourceFrame.x = (targetBounds.x * resolution | 0) / resolution;
        sourceFrame.y = (targetBounds.y * resolution | 0) / resolution;
        sourceFrame.width = (targetBounds.width * resolution | 0) / resolution;
        sourceFrame.height = (targetBounds.height * resolution | 0) / resolution;

        if (!fullScreen) {
            if (filterData.stack[0].renderTarget.transform) {//

                // TODO we should fit the rect around the transform..
            } else if (filters[0].autoFit) {
                sourceFrame.fit(renderTargetFrame);
            }

            // lets apply the padding After we fit the element to the screen.
            // this should stop the strange side effects that can occur when cropping to the edges
            sourceFrame.pad(padding);
        }

        destinationFrame.width = sourceFrame.width;
        destinationFrame.height = sourceFrame.height;

        // lets play the padding after we fit the element to the screen.
        // this should stop the strange side effects that can occur when cropping to the edges

        var renderTarget = this.getPotRenderTarget(renderer.gl, sourceFrame.width, sourceFrame.height, resolution);

        currentState.target = target;
        currentState.filters = filters;
        currentState.resolution = resolution;
        currentState.renderTarget = renderTarget;

        // bind the render target to draw the shape in the top corner..

        renderTarget.setFrame(destinationFrame, sourceFrame);

        // bind the render target
        renderer.bindRenderTarget(renderTarget);
        renderTarget.clear();
    };

    /**
     * Pops off the filter and applies it.
     *
     */


    FilterManager.prototype.popFilter = function popFilter() {
        var filterData = this.filterData;

        var lastState = filterData.stack[filterData.index - 1];
        var currentState = filterData.stack[filterData.index];

        this.quad.map(currentState.renderTarget.size, currentState.sourceFrame).upload();

        var filters = currentState.filters;

        if (filters.length === 1) {
            filters[0].apply(this, currentState.renderTarget, lastState.renderTarget, false, currentState);
            this.freePotRenderTarget(currentState.renderTarget);
        } else {
            var flip = currentState.renderTarget;
            var flop = this.getPotRenderTarget(this.renderer.gl, currentState.sourceFrame.width, currentState.sourceFrame.height, currentState.resolution);

            flop.setFrame(currentState.destinationFrame, currentState.sourceFrame);

            // finally lets clear the render target before drawing to it..
            flop.clear();

            var i = 0;

            for (i = 0; i < filters.length - 1; ++i) {
                filters[i].apply(this, flip, flop, true, currentState);

                var t = flip;

                flip = flop;
                flop = t;
            }

            filters[i].apply(this, flip, lastState.renderTarget, false, currentState);

            this.freePotRenderTarget(flip);
            this.freePotRenderTarget(flop);
        }

        currentState.clear();
        filterData.index--;

        if (filterData.index === 0) {
            this.filterData = null;
        }
    };

    /**
     * Draws a filter.
     *
     * @param {PIXI.Filter} filter - The filter to draw.
     * @param {PIXI.RenderTarget} input - The input render target.
     * @param {PIXI.RenderTarget} output - The target to output to.
     * @param {boolean} clear - Should the output be cleared before rendering to it
     */


    FilterManager.prototype.applyFilter = function applyFilter(filter, input, output, clear) {
        var renderer = this.renderer;
        var gl = renderer.gl;

        var shader = filter.glShaders[renderer.CONTEXT_UID];

        // caching..
        if (!shader) {
            if (filter.glShaderKey) {
                shader = this.shaderCache[filter.glShaderKey];

                if (!shader) {
                    shader = new _Shader2.default(this.gl, filter.vertexSrc, filter.fragmentSrc);

                    filter.glShaders[renderer.CONTEXT_UID] = this.shaderCache[filter.glShaderKey] = shader;
                    this.managedFilters.push(filter);
                }
            } else {
                shader = filter.glShaders[renderer.CONTEXT_UID] = new _Shader2.default(this.gl, filter.vertexSrc, filter.fragmentSrc);
                this.managedFilters.push(filter);
            }

            // TODO - this only needs to be done once?
            renderer.bindVao(null);

            this.quad.initVao(shader);
        }

        renderer.bindVao(this.quad.vao);

        renderer.bindRenderTarget(output);

        if (clear) {
            gl.disable(gl.SCISSOR_TEST);
            renderer.clear(); // [1, 1, 1, 1]);
            gl.enable(gl.SCISSOR_TEST);
        }

        // in case the render target is being masked using a scissor rect
        if (output === renderer.maskManager.scissorRenderTarget) {
            renderer.maskManager.pushScissorMask(null, renderer.maskManager.scissorData);
        }

        renderer.bindShader(shader);

        // free unit 0 for us, doesn't matter what was there
        // don't try to restore it, because syncUniforms can upload it to another slot
        // and it'll be a problem
        var tex = this.renderer.emptyTextures[0];

        this.renderer.boundTextures[0] = tex;
        // this syncs the PixiJS filters  uniforms with glsl uniforms
        this.syncUniforms(shader, filter);

        renderer.state.setBlendMode(filter.blendMode);

        gl.activeTexture(gl.TEXTURE0);
        gl.bindTexture(gl.TEXTURE_2D, input.texture.texture);

        this.quad.vao.draw(this.renderer.gl.TRIANGLES, 6, 0);

        gl.bindTexture(gl.TEXTURE_2D, tex._glTextures[this.renderer.CONTEXT_UID].texture);
    };

    /**
     * Uploads the uniforms of the filter.
     *
     * @param {GLShader} shader - The underlying gl shader.
     * @param {PIXI.Filter} filter - The filter we are synchronizing.
     */


    FilterManager.prototype.syncUniforms = function syncUniforms(shader, filter) {
        var uniformData = filter.uniformData;
        var uniforms = filter.uniforms;

        // 0 is reserved for the PixiJS texture so we start at 1!
        var textureCount = 1;
        var currentState = void 0;

        // filterArea and filterClamp that are handled by FilterManager directly
        // they must not appear in uniformData

        if (shader.uniforms.filterArea) {
            currentState = this.filterData.stack[this.filterData.index];

            var filterArea = shader.uniforms.filterArea;

            filterArea[0] = currentState.renderTarget.size.width;
            filterArea[1] = currentState.renderTarget.size.height;
            filterArea[2] = currentState.sourceFrame.x;
            filterArea[3] = currentState.sourceFrame.y;

            shader.uniforms.filterArea = filterArea;
        }

        // use this to clamp displaced texture coords so they belong to filterArea
        // see displacementFilter fragment shader for an example
        if (shader.uniforms.filterClamp) {
            currentState = currentState || this.filterData.stack[this.filterData.index];

            var filterClamp = shader.uniforms.filterClamp;

            filterClamp[0] = 0;
            filterClamp[1] = 0;
            filterClamp[2] = (currentState.sourceFrame.width - 1) / currentState.renderTarget.size.width;
            filterClamp[3] = (currentState.sourceFrame.height - 1) / currentState.renderTarget.size.height;

            shader.uniforms.filterClamp = filterClamp;
        }

        // TODO Caching layer..
        for (var i in uniformData) {
            if (!shader.uniforms.data[i]) {
                continue;
            }

            var type = uniformData[i].type;

            if (type === 'sampler2d' && uniforms[i] !== 0) {
                if (uniforms[i].baseTexture) {
                    shader.uniforms[i] = this.renderer.bindTexture(uniforms[i].baseTexture, textureCount);
                } else {
                    shader.uniforms[i] = textureCount;

                    // TODO
                    // this is helpful as renderTargets can also be set.
                    // Although thinking about it, we could probably
                    // make the filter texture cache return a RenderTexture
                    // rather than a renderTarget
                    var gl = this.renderer.gl;

                    this.renderer.boundTextures[textureCount] = this.renderer.emptyTextures[textureCount];
                    gl.activeTexture(gl.TEXTURE0 + textureCount);

                    uniforms[i].texture.bind();
                }

                textureCount++;
            } else if (type === 'mat3') {
                // check if its PixiJS matrix..
                if (uniforms[i].a !== undefined) {
                    shader.uniforms[i] = uniforms[i].toArray(true);
                } else {
                    shader.uniforms[i] = uniforms[i];
                }
            } else if (type === 'vec2') {
                // check if its a point..
                if (uniforms[i].x !== undefined) {
                    var val = shader.uniforms[i] || new Float32Array(2);

                    val[0] = uniforms[i].x;
                    val[1] = uniforms[i].y;
                    shader.uniforms[i] = val;
                } else {
                    shader.uniforms[i] = uniforms[i];
                }
            } else if (type === 'float') {
                if (shader.uniforms.data[i].value !== uniformData[i]) {
                    shader.uniforms[i] = uniforms[i];
                }
            } else {
                shader.uniforms[i] = uniforms[i];
            }
        }
    };

    /**
     * Gets a render target from the pool, or creates a new one.
     *
     * @param {boolean} clear - Should we clear the render texture when we get it?
     * @param {number} resolution - The resolution of the target.
     * @return {PIXI.RenderTarget} The new render target
     */


    FilterManager.prototype.getRenderTarget = function getRenderTarget(clear, resolution) {
        var currentState = this.filterData.stack[this.filterData.index];
        var renderTarget = this.getPotRenderTarget(this.renderer.gl, currentState.sourceFrame.width, currentState.sourceFrame.height, resolution || currentState.resolution);

        renderTarget.setFrame(currentState.destinationFrame, currentState.sourceFrame);

        return renderTarget;
    };

    /**
     * Returns a render target to the pool.
     *
     * @param {PIXI.RenderTarget} renderTarget - The render target to return.
     */


    FilterManager.prototype.returnRenderTarget = function returnRenderTarget(renderTarget) {
        this.freePotRenderTarget(renderTarget);
    };

    /**
     * Calculates the mapped matrix.
     *
     * TODO playing around here.. this is temporary - (will end up in the shader)
     * this returns a matrix that will normalise map filter cords in the filter to screen space
     *
     * @param {PIXI.Matrix} outputMatrix - the matrix to output to.
     * @return {PIXI.Matrix} The mapped matrix.
     */


    FilterManager.prototype.calculateScreenSpaceMatrix = function calculateScreenSpaceMatrix(outputMatrix) {
        var currentState = this.filterData.stack[this.filterData.index];

        return filterTransforms.calculateScreenSpaceMatrix(outputMatrix, currentState.sourceFrame, currentState.renderTarget.size);
    };

    /**
     * Multiply vTextureCoord to this matrix to achieve (0,0,1,1) for filterArea
     *
     * @param {PIXI.Matrix} outputMatrix - The matrix to output to.
     * @return {PIXI.Matrix} The mapped matrix.
     */


    FilterManager.prototype.calculateNormalizedScreenSpaceMatrix = function calculateNormalizedScreenSpaceMatrix(outputMatrix) {
        var currentState = this.filterData.stack[this.filterData.index];

        return filterTransforms.calculateNormalizedScreenSpaceMatrix(outputMatrix, currentState.sourceFrame, currentState.renderTarget.size, currentState.destinationFrame);
    };

    /**
     * This will map the filter coord so that a texture can be used based on the transform of a sprite
     *
     * @param {PIXI.Matrix} outputMatrix - The matrix to output to.
     * @param {PIXI.Sprite} sprite - The sprite to map to.
     * @return {PIXI.Matrix} The mapped matrix.
     */


    FilterManager.prototype.calculateSpriteMatrix = function calculateSpriteMatrix(outputMatrix, sprite) {
        var currentState = this.filterData.stack[this.filterData.index];

        return filterTransforms.calculateSpriteMatrix(outputMatrix, currentState.sourceFrame, currentState.renderTarget.size, sprite);
    };

    /**
     * Destroys this Filter Manager.
     *
     * @param {boolean} [contextLost=false] context was lost, do not free shaders
     *
     */


    FilterManager.prototype.destroy = function destroy() {
        var contextLost = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        var renderer = this.renderer;
        var filters = this.managedFilters;

        renderer.off('prerender', this.onPrerender, this);

        for (var i = 0; i < filters.length; i++) {
            if (!contextLost) {
                filters[i].glShaders[renderer.CONTEXT_UID].destroy();
            }
            delete filters[i].glShaders[renderer.CONTEXT_UID];
        }

        this.shaderCache = {};
        if (!contextLost) {
            this.emptyPool();
        } else {
            this.pool = {};
        }
    };

    /**
     * Gets a Power-of-Two render texture.
     *
     * TODO move to a separate class could be on renderer?
     * also - could cause issue with multiple contexts?
     *
     * @private
     * @param {WebGLRenderingContext} gl - The webgl rendering context
     * @param {number} minWidth - The minimum width of the render target.
     * @param {number} minHeight - The minimum height of the render target.
     * @param {number} resolution - The resolution of the render target.
     * @return {PIXI.RenderTarget} The new render target.
     */


    FilterManager.prototype.getPotRenderTarget = function getPotRenderTarget(gl, minWidth, minHeight, resolution) {
        var key = screenKey;

        minWidth *= resolution;
        minHeight *= resolution;

        if (minWidth !== this._screenWidth || minHeight !== this._screenHeight) {
            // TODO you could return a bigger texture if there is not one in the pool?
            minWidth = _bitTwiddle2.default.nextPow2(minWidth);
            minHeight = _bitTwiddle2.default.nextPow2(minHeight);
            key = (minWidth & 0xFFFF) << 16 | minHeight & 0xFFFF;
        }

        if (!this.pool[key]) {
            this.pool[key] = [];
        }

        var renderTarget = this.pool[key].pop();

        // creating render target will cause texture to be bound!
        if (!renderTarget) {
            // temporary bypass cache..
            var tex = this.renderer.boundTextures[0];

            gl.activeTexture(gl.TEXTURE0);

            // internally - this will cause a texture to be bound..
            renderTarget = new _RenderTarget2.default(gl, minWidth, minHeight, null, 1);

            // set the current one back
            gl.bindTexture(gl.TEXTURE_2D, tex._glTextures[this.renderer.CONTEXT_UID].texture);
        }

        // manually tweak the resolution...
        // this will not modify the size of the frame buffer, just its resolution.
        renderTarget.resolution = resolution;
        renderTarget.defaultFrame.width = renderTarget.size.width = minWidth / resolution;
        renderTarget.defaultFrame.height = renderTarget.size.height = minHeight / resolution;
        renderTarget.filterPoolKey = key;

        return renderTarget;
    };

    /**
     * Empties the texture pool.
     *
     */


    FilterManager.prototype.emptyPool = function emptyPool() {
        for (var i in this.pool) {
            var textures = this.pool[i];

            if (textures) {
                for (var j = 0; j < textures.length; j++) {
                    textures[j].destroy(true);
                }
            }
        }

        this.pool = {};
    };

    /**
     * Frees a render target back into the pool.
     *
     * @param {PIXI.RenderTarget} renderTarget - The renderTarget to free
     */


    FilterManager.prototype.freePotRenderTarget = function freePotRenderTarget(renderTarget) {
        this.pool[renderTarget.filterPoolKey].push(renderTarget);
    };

    /**
     * Called before the renderer starts rendering.
     *
     */


    FilterManager.prototype.onPrerender = function onPrerender() {
        if (this._screenWidth !== this.renderer.view.width || this._screenHeight !== this.renderer.view.height) {
            this._screenWidth = this.renderer.view.width;
            this._screenHeight = this.renderer.view.height;

            var textures = this.pool[screenKey];

            if (textures) {
                for (var j = 0; j < textures.length; j++) {
                    textures[j].destroy(true);
                }
            }
            this.pool[screenKey] = [];
        }
    };

    return FilterManager;
}(_WebGLManager3.default);

exports.default = FilterManager;
//# sourceMappingURL=FilterManager.js.map

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.calculateScreenSpaceMatrix = calculateScreenSpaceMatrix;
exports.calculateNormalizedScreenSpaceMatrix = calculateNormalizedScreenSpaceMatrix;
exports.calculateSpriteMatrix = calculateSpriteMatrix;

var _math = __webpack_require__(20);

/**
 * Calculates the mapped matrix
 * @param filterArea {Rectangle} The filter area
 * @param sprite {Sprite} the target sprite
 * @param outputMatrix {Matrix} @alvin
 * @private
 */
// TODO playing around here.. this is temporary - (will end up in the shader)
// this returns a matrix that will normalise map filter cords in the filter to screen space
function calculateScreenSpaceMatrix(outputMatrix, filterArea, textureSize) {
    // let worldTransform = sprite.worldTransform.copy(Matrix.TEMP_MATRIX),
    // let texture = {width:1136, height:700};//sprite._texture.baseTexture;

    // TODO unwrap?
    var mappedMatrix = outputMatrix.identity();

    mappedMatrix.translate(filterArea.x / textureSize.width, filterArea.y / textureSize.height);

    mappedMatrix.scale(textureSize.width, textureSize.height);

    return mappedMatrix;
}

function calculateNormalizedScreenSpaceMatrix(outputMatrix, filterArea, textureSize) {
    var mappedMatrix = outputMatrix.identity();

    mappedMatrix.translate(filterArea.x / textureSize.width, filterArea.y / textureSize.height);

    var translateScaleX = textureSize.width / filterArea.width;
    var translateScaleY = textureSize.height / filterArea.height;

    mappedMatrix.scale(translateScaleX, translateScaleY);

    return mappedMatrix;
}

// this will map the filter coord so that a texture can be used based on the transform of a sprite
function calculateSpriteMatrix(outputMatrix, filterArea, textureSize, sprite) {
    var orig = sprite._texture.orig;
    var mappedMatrix = outputMatrix.set(textureSize.width, 0, 0, textureSize.height, filterArea.x, filterArea.y);
    var worldTransform = sprite.worldTransform.copy(_math.Matrix.TEMP_MATRIX);

    worldTransform.invert();
    mappedMatrix.prepend(worldTransform);
    mappedMatrix.scale(1.0 / orig.width, 1.0 / orig.height);
    mappedMatrix.translate(sprite.anchor.x, sprite.anchor.y);

    return mappedMatrix;
}
//# sourceMappingURL=filterTransforms.js.map

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _pixiGlCore = __webpack_require__(31);

var _const = __webpack_require__(5);

var _RenderTarget = __webpack_require__(104);

var _RenderTarget2 = _interopRequireDefault(_RenderTarget);

var _utils = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Helper class to create a webGL Texture
 *
 * @class
 * @memberof PIXI
 */
var TextureManager = function () {
    /**
     * @param {PIXI.WebGLRenderer} renderer - A reference to the current renderer
     */
    function TextureManager(renderer) {
        _classCallCheck(this, TextureManager);

        /**
         * A reference to the current renderer
         *
         * @member {PIXI.WebGLRenderer}
         */
        this.renderer = renderer;

        /**
         * The current WebGL rendering context
         *
         * @member {WebGLRenderingContext}
         */
        this.gl = renderer.gl;

        /**
         * Track textures in the renderer so we can no longer listen to them on destruction.
         *
         * @member {Array<*>}
         * @private
         */
        this._managedTextures = [];
    }

    /**
     * Binds a texture.
     *
     */


    TextureManager.prototype.bindTexture = function bindTexture() {}
    // empty


    /**
     * Gets a texture.
     *
     */
    ;

    TextureManager.prototype.getTexture = function getTexture() {}
    // empty


    /**
     * Updates and/or Creates a WebGL texture for the renderer's context.
     *
     * @param {PIXI.BaseTexture|PIXI.Texture} texture - the texture to update
     * @param {number} location - the location the texture will be bound to.
     * @return {GLTexture} The gl texture.
     */
    ;

    TextureManager.prototype.updateTexture = function updateTexture(texture, location) {
        // assume it good!
        // texture = texture.baseTexture || texture;

        var gl = this.gl;

        var isRenderTexture = !!texture._glRenderTargets;

        if (!texture.hasLoaded) {
            return null;
        }

        var boundTextures = this.renderer.boundTextures;

        // if the location is undefined then this may have been called by n event.
        // this being the case the texture may already be bound to a slot. As a texture can only be bound once
        // we need to find its current location if it exists.
        if (location === undefined) {
            location = 0;

            // TODO maybe we can use texture bound ids later on...
            // check if texture is already bound..
            for (var i = 0; i < boundTextures.length; ++i) {
                if (boundTextures[i] === texture) {
                    location = i;
                    break;
                }
            }
        }

        boundTextures[location] = texture;

        gl.activeTexture(gl.TEXTURE0 + location);

        var glTexture = texture._glTextures[this.renderer.CONTEXT_UID];

        if (!glTexture) {
            if (isRenderTexture) {
                var renderTarget = new _RenderTarget2.default(this.gl, texture.width, texture.height, texture.scaleMode, texture.resolution);

                renderTarget.resize(texture.width, texture.height);
                texture._glRenderTargets[this.renderer.CONTEXT_UID] = renderTarget;
                glTexture = renderTarget.texture;

                // framebuffer constructor disactivates current framebuffer
                if (!this.renderer._activeRenderTarget.root) {
                    this.renderer._activeRenderTarget.frameBuffer.bind();
                }
            } else {
                glTexture = new _pixiGlCore.GLTexture(this.gl, null, null, null, null);
                glTexture.bind(location);
                glTexture.premultiplyAlpha = true;
                glTexture.upload(texture.source);
            }

            texture._glTextures[this.renderer.CONTEXT_UID] = glTexture;

            texture.on('update', this.updateTexture, this);
            texture.on('dispose', this.destroyTexture, this);

            this._managedTextures.push(texture);

            if (texture.isPowerOfTwo) {
                if (texture.mipmap) {
                    glTexture.enableMipmap();
                }

                if (texture.wrapMode === _const.WRAP_MODES.CLAMP) {
                    glTexture.enableWrapClamp();
                } else if (texture.wrapMode === _const.WRAP_MODES.REPEAT) {
                    glTexture.enableWrapRepeat();
                } else {
                    glTexture.enableWrapMirrorRepeat();
                }
            } else {
                glTexture.enableWrapClamp();
            }

            if (texture.scaleMode === _const.SCALE_MODES.NEAREST) {
                glTexture.enableNearestScaling();
            } else {
                glTexture.enableLinearScaling();
            }
        }
        // the texture already exists so we only need to update it..
        else if (isRenderTexture) {
                texture._glRenderTargets[this.renderer.CONTEXT_UID].resize(texture.width, texture.height);
            } else {
                glTexture.upload(texture.source);
            }

        return glTexture;
    };

    /**
     * Deletes the texture from WebGL
     *
     * @param {PIXI.BaseTexture|PIXI.Texture} texture - the texture to destroy
     * @param {boolean} [skipRemove=false] - Whether to skip removing the texture from the TextureManager.
     */


    TextureManager.prototype.destroyTexture = function destroyTexture(texture, skipRemove) {
        texture = texture.baseTexture || texture;

        if (!texture.hasLoaded) {
            return;
        }

        var renderer = this.renderer;
        var uid = renderer.CONTEXT_UID;
        var glTextures = texture._glTextures;
        var glRenderTargets = texture._glRenderTargets;

        if (glTextures[uid]) {
            renderer.unbindTexture(texture);

            glTextures[uid].destroy();
            texture.off('update', this.updateTexture, this);
            texture.off('dispose', this.destroyTexture, this);

            delete glTextures[uid];

            if (!skipRemove) {
                var i = this._managedTextures.indexOf(texture);

                if (i !== -1) {
                    (0, _utils.removeItems)(this._managedTextures, i, 1);
                }
            }
        }

        if (glRenderTargets && glRenderTargets[uid]) {
            if (renderer._activeRenderTarget === glRenderTargets[uid]) {
                renderer.bindRenderTarget(renderer.rootRenderTarget);
            }

            glRenderTargets[uid].destroy();
            delete glRenderTargets[uid];
        }
    };

    /**
     * Deletes all the textures from WebGL
     */


    TextureManager.prototype.removeAll = function removeAll() {
        // empty all the old gl textures as they are useless now
        for (var i = 0; i < this._managedTextures.length; ++i) {
            var texture = this._managedTextures[i];

            if (texture._glTextures[this.renderer.CONTEXT_UID]) {
                delete texture._glTextures[this.renderer.CONTEXT_UID];
            }
        }
    };

    /**
     * Destroys this manager and removes all its textures
     */


    TextureManager.prototype.destroy = function destroy() {
        // destroy managed textures
        for (var i = 0; i < this._managedTextures.length; ++i) {
            var texture = this._managedTextures[i];

            this.destroyTexture(texture, true);

            texture.off('update', this.updateTexture, this);
            texture.off('dispose', this.destroyTexture, this);
        }

        this._managedTextures = null;
    };

    return TextureManager;
}();

exports.default = TextureManager;
//# sourceMappingURL=TextureManager.js.map

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _const = __webpack_require__(5);

var _settings = __webpack_require__(17);

var _settings2 = _interopRequireDefault(_settings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * TextureGarbageCollector. This class manages the GPU and ensures that it does not get clogged
 * up with textures that are no longer being used.
 *
 * @class
 * @memberof PIXI
 */
var TextureGarbageCollector = function () {
    /**
     * @param {PIXI.WebGLRenderer} renderer - The renderer this manager works for.
     */
    function TextureGarbageCollector(renderer) {
        _classCallCheck(this, TextureGarbageCollector);

        this.renderer = renderer;

        this.count = 0;
        this.checkCount = 0;
        this.maxIdle = _settings2.default.GC_MAX_IDLE;
        this.checkCountMax = _settings2.default.GC_MAX_CHECK_COUNT;
        this.mode = _settings2.default.GC_MODE;
    }

    /**
     * Checks to see when the last time a texture was used
     * if the texture has not been used for a specified amount of time it will be removed from the GPU
     */


    TextureGarbageCollector.prototype.update = function update() {
        this.count++;

        if (this.mode === _const.GC_MODES.MANUAL) {
            return;
        }

        this.checkCount++;

        if (this.checkCount > this.checkCountMax) {
            this.checkCount = 0;

            this.run();
        }
    };

    /**
     * Checks to see when the last time a texture was used
     * if the texture has not been used for a specified amount of time it will be removed from the GPU
     */


    TextureGarbageCollector.prototype.run = function run() {
        var tm = this.renderer.textureManager;
        var managedTextures = tm._managedTextures;
        var wasRemoved = false;

        for (var i = 0; i < managedTextures.length; i++) {
            var texture = managedTextures[i];

            // only supports non generated textures at the moment!
            if (!texture._glRenderTargets && this.count - texture.touched > this.maxIdle) {
                tm.destroyTexture(texture, true);
                managedTextures[i] = null;
                wasRemoved = true;
            }
        }

        if (wasRemoved) {
            var j = 0;

            for (var _i = 0; _i < managedTextures.length; _i++) {
                if (managedTextures[_i] !== null) {
                    managedTextures[j++] = managedTextures[_i];
                }
            }

            managedTextures.length = j;
        }
    };

    /**
     * Removes all the textures within the specified displayObject and its children from the GPU
     *
     * @param {PIXI.DisplayObject} displayObject - the displayObject to remove the textures from.
     */


    TextureGarbageCollector.prototype.unload = function unload(displayObject) {
        var tm = this.renderer.textureManager;

        // only destroy non generated textures
        if (displayObject._texture && displayObject._texture._glRenderTargets) {
            tm.destroyTexture(displayObject._texture, true);
        }

        for (var i = displayObject.children.length - 1; i >= 0; i--) {
            this.unload(displayObject.children[i]);
        }
    };

    return TextureGarbageCollector;
}();

exports.default = TextureGarbageCollector;
//# sourceMappingURL=TextureGarbageCollector.js.map

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _mapWebGLBlendModesToPixi = __webpack_require__(380);

var _mapWebGLBlendModesToPixi2 = _interopRequireDefault(_mapWebGLBlendModesToPixi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BLEND = 0;
var DEPTH_TEST = 1;
var FRONT_FACE = 2;
var CULL_FACE = 3;
var BLEND_FUNC = 4;

/**
 * A WebGL state machines
 *
 * @memberof PIXI
 * @class
 */

var WebGLState = function () {
    /**
     * @param {WebGLRenderingContext} gl - The current WebGL rendering context
     */
    function WebGLState(gl) {
        _classCallCheck(this, WebGLState);

        /**
         * The current active state
         *
         * @member {Uint8Array}
         */
        this.activeState = new Uint8Array(16);

        /**
         * The default state
         *
         * @member {Uint8Array}
         */
        this.defaultState = new Uint8Array(16);

        // default blend mode..
        this.defaultState[0] = 1;

        /**
         * The current state index in the stack
         *
         * @member {number}
         * @private
         */
        this.stackIndex = 0;

        /**
         * The stack holding all the different states
         *
         * @member {Array<*>}
         * @private
         */
        this.stack = [];

        /**
         * The current WebGL rendering context
         *
         * @member {WebGLRenderingContext}
         */
        this.gl = gl;

        this.maxAttribs = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);

        this.attribState = {
            tempAttribState: new Array(this.maxAttribs),
            attribState: new Array(this.maxAttribs)
        };

        this.blendModes = (0, _mapWebGLBlendModesToPixi2.default)(gl);

        // check we have vao..
        this.nativeVaoExtension = gl.getExtension('OES_vertex_array_object') || gl.getExtension('MOZ_OES_vertex_array_object') || gl.getExtension('WEBKIT_OES_vertex_array_object');
    }

    /**
     * Pushes a new active state
     */


    WebGLState.prototype.push = function push() {
        // next state..
        var state = this.stack[this.stackIndex];

        if (!state) {
            state = this.stack[this.stackIndex] = new Uint8Array(16);
        }

        ++this.stackIndex;

        // copy state..
        // set active state so we can force overrides of gl state
        for (var i = 0; i < this.activeState.length; i++) {
            state[i] = this.activeState[i];
        }
    };

    /**
     * Pops a state out
     */


    WebGLState.prototype.pop = function pop() {
        var state = this.stack[--this.stackIndex];

        this.setState(state);
    };

    /**
     * Sets the current state
     *
     * @param {*} state - The state to set.
     */


    WebGLState.prototype.setState = function setState(state) {
        this.setBlend(state[BLEND]);
        this.setDepthTest(state[DEPTH_TEST]);
        this.setFrontFace(state[FRONT_FACE]);
        this.setCullFace(state[CULL_FACE]);
        this.setBlendMode(state[BLEND_FUNC]);
    };

    /**
     * Enables or disabled blending.
     *
     * @param {boolean} value - Turn on or off webgl blending.
     */


    WebGLState.prototype.setBlend = function setBlend(value) {
        value = value ? 1 : 0;

        if (this.activeState[BLEND] === value) {
            return;
        }

        this.activeState[BLEND] = value;
        this.gl[value ? 'enable' : 'disable'](this.gl.BLEND);
    };

    /**
     * Sets the blend mode.
     *
     * @param {number} value - The blend mode to set to.
     */


    WebGLState.prototype.setBlendMode = function setBlendMode(value) {
        if (value === this.activeState[BLEND_FUNC]) {
            return;
        }

        this.activeState[BLEND_FUNC] = value;

        var mode = this.blendModes[value];

        if (mode.length === 2) {
            this.gl.blendFunc(mode[0], mode[1]);
        } else {
            this.gl.blendFuncSeparate(mode[0], mode[1], mode[2], mode[3]);
        }
    };

    /**
     * Sets whether to enable or disable depth test.
     *
     * @param {boolean} value - Turn on or off webgl depth testing.
     */


    WebGLState.prototype.setDepthTest = function setDepthTest(value) {
        value = value ? 1 : 0;

        if (this.activeState[DEPTH_TEST] === value) {
            return;
        }

        this.activeState[DEPTH_TEST] = value;
        this.gl[value ? 'enable' : 'disable'](this.gl.DEPTH_TEST);
    };

    /**
     * Sets whether to enable or disable cull face.
     *
     * @param {boolean} value - Turn on or off webgl cull face.
     */


    WebGLState.prototype.setCullFace = function setCullFace(value) {
        value = value ? 1 : 0;

        if (this.activeState[CULL_FACE] === value) {
            return;
        }

        this.activeState[CULL_FACE] = value;
        this.gl[value ? 'enable' : 'disable'](this.gl.CULL_FACE);
    };

    /**
     * Sets the gl front face.
     *
     * @param {boolean} value - true is clockwise and false is counter-clockwise
     */


    WebGLState.prototype.setFrontFace = function setFrontFace(value) {
        value = value ? 1 : 0;

        if (this.activeState[FRONT_FACE] === value) {
            return;
        }

        this.activeState[FRONT_FACE] = value;
        this.gl.frontFace(this.gl[value ? 'CW' : 'CCW']);
    };

    /**
     * Disables all the vaos in use
     *
     */


    WebGLState.prototype.resetAttributes = function resetAttributes() {
        for (var i = 0; i < this.attribState.tempAttribState.length; i++) {
            this.attribState.tempAttribState[i] = 0;
        }

        for (var _i = 0; _i < this.attribState.attribState.length; _i++) {
            this.attribState.attribState[_i] = 0;
        }

        // im going to assume one is always active for performance reasons.
        for (var _i2 = 1; _i2 < this.maxAttribs; _i2++) {
            this.gl.disableVertexAttribArray(_i2);
        }
    };

    // used
    /**
     * Resets all the logic and disables the vaos
     */


    WebGLState.prototype.resetToDefault = function resetToDefault() {
        // unbind any VAO if they exist..
        if (this.nativeVaoExtension) {
            this.nativeVaoExtension.bindVertexArrayOES(null);
        }

        // reset all attributes..
        this.resetAttributes();

        // set active state so we can force overrides of gl state
        for (var i = 0; i < this.activeState.length; ++i) {
            this.activeState[i] = 32;
        }

        this.gl.pixelStorei(this.gl.UNPACK_FLIP_Y_WEBGL, false);

        this.setState(this.defaultState);
    };

    return WebGLState;
}();

exports.default = WebGLState;
//# sourceMappingURL=WebGLState.js.map

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = mapWebGLBlendModesToPixi;

var _const = __webpack_require__(5);

/**
 * Maps gl blend combinations to WebGL.
 *
 * @memberof PIXI
 * @function mapWebGLBlendModesToPixi
 * @private
 * @param {WebGLRenderingContext} gl - The rendering context.
 * @param {string[]} [array=[]] - The array to output into.
 * @return {string[]} Mapped modes.
 */
function mapWebGLBlendModesToPixi(gl) {
    var array = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    // TODO - premultiply alpha would be different.
    // add a boolean for that!
    array[_const.BLEND_MODES.NORMAL] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
    array[_const.BLEND_MODES.ADD] = [gl.ONE, gl.ONE];
    array[_const.BLEND_MODES.MULTIPLY] = [gl.DST_COLOR, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
    array[_const.BLEND_MODES.SCREEN] = [gl.ONE, gl.ONE_MINUS_SRC_COLOR, gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
    array[_const.BLEND_MODES.OVERLAY] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
    array[_const.BLEND_MODES.DARKEN] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
    array[_const.BLEND_MODES.LIGHTEN] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
    array[_const.BLEND_MODES.COLOR_DODGE] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
    array[_const.BLEND_MODES.COLOR_BURN] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
    array[_const.BLEND_MODES.HARD_LIGHT] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
    array[_const.BLEND_MODES.SOFT_LIGHT] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
    array[_const.BLEND_MODES.DIFFERENCE] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
    array[_const.BLEND_MODES.EXCLUSION] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
    array[_const.BLEND_MODES.HUE] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
    array[_const.BLEND_MODES.SATURATION] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
    array[_const.BLEND_MODES.COLOR] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
    array[_const.BLEND_MODES.LUMINOSITY] = [gl.ONE, gl.ONE_MINUS_SRC_ALPHA];

    // not-premultiplied blend modes
    array[_const.BLEND_MODES.NORMAL_NPM] = [gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA];
    array[_const.BLEND_MODES.ADD_NPM] = [gl.SRC_ALPHA, gl.ONE, gl.ONE, gl.ONE];
    array[_const.BLEND_MODES.SCREEN_NPM] = [gl.SRC_ALPHA, gl.ONE_MINUS_SRC_COLOR, gl.ONE, gl.ONE_MINUS_SRC_ALPHA];

    return array;
}
//# sourceMappingURL=mapWebGLBlendModesToPixi.js.map

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = mapWebGLDrawModesToPixi;

var _const = __webpack_require__(5);

/**
 * Generic Mask Stack data structure.
 *
 * @memberof PIXI
 * @function mapWebGLDrawModesToPixi
 * @private
 * @param {WebGLRenderingContext} gl - The current WebGL drawing context
 * @param {object} [object={}] - The object to map into
 * @return {object} The mapped draw modes.
 */
function mapWebGLDrawModesToPixi(gl) {
  var object = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  object[_const.DRAW_MODES.POINTS] = gl.POINTS;
  object[_const.DRAW_MODES.LINES] = gl.LINES;
  object[_const.DRAW_MODES.LINE_LOOP] = gl.LINE_LOOP;
  object[_const.DRAW_MODES.LINE_STRIP] = gl.LINE_STRIP;
  object[_const.DRAW_MODES.TRIANGLES] = gl.TRIANGLES;
  object[_const.DRAW_MODES.TRIANGLE_STRIP] = gl.TRIANGLE_STRIP;
  object[_const.DRAW_MODES.TRIANGLE_FAN] = gl.TRIANGLE_FAN;

  return object;
}
//# sourceMappingURL=mapWebGLDrawModesToPixi.js.map

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = validateContext;
function validateContext(gl) {
    var attributes = gl.getContextAttributes();

    // this is going to be fairly simple for now.. but at least we have room to grow!
    if (!attributes.stencil) {
        /* eslint-disable no-console */
        console.warn('Provided WebGL context does not have a stencil buffer, masks may not render correctly');
        /* eslint-enable no-console */
    }
}
//# sourceMappingURL=validateContext.js.map

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = generateMultiTextureShader;

var _Shader = __webpack_require__(86);

var _Shader2 = _interopRequireDefault(_Shader);

var _path = __webpack_require__(41);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fragTemplate = ['varying vec2 vTextureCoord;', 'varying vec4 vColor;', 'varying float vTextureId;', 'uniform sampler2D uSamplers[%count%];', 'void main(void){', 'vec4 color;', '%forloop%', 'gl_FragColor = color * vColor;', '}'].join('\n');

function generateMultiTextureShader(gl, maxTextures) {
    var vertexSrc = 'precision highp float;\nattribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\nattribute vec4 aColor;\nattribute float aTextureId;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\nvarying vec4 vColor;\nvarying float vTextureId;\n\nvoid main(void){\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = aTextureCoord;\n    vTextureId = aTextureId;\n    vColor = aColor;\n}\n';
    var fragmentSrc = fragTemplate;

    fragmentSrc = fragmentSrc.replace(/%count%/gi, maxTextures);
    fragmentSrc = fragmentSrc.replace(/%forloop%/gi, generateSampleSrc(maxTextures));

    var shader = new _Shader2.default(gl, vertexSrc, fragmentSrc);

    var sampleValues = [];

    for (var i = 0; i < maxTextures; i++) {
        sampleValues[i] = i;
    }

    shader.bind();
    shader.uniforms.uSamplers = sampleValues;

    return shader;
}

function generateSampleSrc(maxTextures) {
    var src = '';

    src += '\n';
    src += '\n';

    for (var i = 0; i < maxTextures; i++) {
        if (i > 0) {
            src += '\nelse ';
        }

        if (i < maxTextures - 1) {
            src += 'if(vTextureId < ' + i + '.5)';
        }

        src += '\n{';
        src += '\n\tcolor = texture2D(uSamplers[' + i + '], vTextureCoord);';
        src += '\n}';
    }

    src += '\n';
    src += '\n';

    return src;
}
//# sourceMappingURL=generateMultiTextureShader.js.map

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = checkMaxIfStatmentsInShader;

var _pixiGlCore = __webpack_require__(31);

var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fragTemplate = ['precision mediump float;', 'void main(void){', 'float test = 0.1;', '%forloop%', 'gl_FragColor = vec4(0.0);', '}'].join('\n');

function checkMaxIfStatmentsInShader(maxIfs, gl) {
    var createTempContext = !gl;

    // @if DEBUG
    if (maxIfs === 0) {
        throw new Error('Invalid value of `0` passed to `checkMaxIfStatementsInShader`');
    }
    // @endif

    if (createTempContext) {
        var tinyCanvas = document.createElement('canvas');

        tinyCanvas.width = 1;
        tinyCanvas.height = 1;

        gl = _pixiGlCore2.default.createContext(tinyCanvas);
    }

    var shader = gl.createShader(gl.FRAGMENT_SHADER);

    while (true) // eslint-disable-line no-constant-condition
    {
        var fragmentSrc = fragTemplate.replace(/%forloop%/gi, generateIfTestSrc(maxIfs));

        gl.shaderSource(shader, fragmentSrc);
        gl.compileShader(shader);

        if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
            maxIfs = maxIfs / 2 | 0;
        } else {
            // valid!
            break;
        }
    }

    if (createTempContext) {
        // get rid of context
        if (gl.getExtension('WEBGL_lose_context')) {
            gl.getExtension('WEBGL_lose_context').loseContext();
        }
    }

    return maxIfs;
}

function generateIfTestSrc(maxIfs) {
    var src = '';

    for (var i = 0; i < maxIfs; ++i) {
        if (i > 0) {
            src += '\nelse ';
        }

        if (i < maxIfs - 1) {
            src += 'if(test == ' + i + '.0){}';
        }
    }

    return src;
}
//# sourceMappingURL=checkMaxIfStatmentsInShader.js.map

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class
 * @memberof PIXI
 */
var Buffer = function () {
  /**
   * @param {number} size - The size of the buffer in bytes.
   */
  function Buffer(size) {
    _classCallCheck(this, Buffer);

    this.vertices = new ArrayBuffer(size);

    /**
     * View on the vertices as a Float32Array for positions
     *
     * @member {Float32Array}
     */
    this.float32View = new Float32Array(this.vertices);

    /**
     * View on the vertices as a Uint32Array for uvs
     *
     * @member {Float32Array}
     */
    this.uint32View = new Uint32Array(this.vertices);
  }

  /**
   * Destroys the buffer.
   *
   */


  Buffer.prototype.destroy = function destroy() {
    this.vertices = null;
    this.positions = null;
    this.uvs = null;
    this.colors = null;
  };

  return Buffer;
}();

exports.default = Buffer;
//# sourceMappingURL=BatchBuffer.js.map

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Sprite2 = __webpack_require__(131);

var _Sprite3 = _interopRequireDefault(_Sprite2);

var _Texture = __webpack_require__(49);

var _Texture2 = _interopRequireDefault(_Texture);

var _math = __webpack_require__(20);

var _utils = __webpack_require__(9);

var _const = __webpack_require__(5);

var _settings = __webpack_require__(17);

var _settings2 = _interopRequireDefault(_settings);

var _TextStyle = __webpack_require__(195);

var _TextStyle2 = _interopRequireDefault(_TextStyle);

var _TextMetrics = __webpack_require__(196);

var _TextMetrics2 = _interopRequireDefault(_TextMetrics);

var _trimCanvas = __webpack_require__(387);

var _trimCanvas2 = _interopRequireDefault(_trimCanvas);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint max-depth: [2, 8] */


var defaultDestroyOptions = {
    texture: true,
    children: false,
    baseTexture: true
};

/**
 * A Text Object will create a line or multiple lines of text. To split a line you can use '\n' in your text string,
 * or add a wordWrap property set to true and and wordWrapWidth property with a value in the style object.
 *
 * A Text can be created directly from a string and a style object,
 * which can be generated [here](https://pixijs.io/pixi-text-style).
 *
 * ```js
 * let text = new PIXI.Text('This is a PixiJS text',{fontFamily : 'Arial', fontSize: 24, fill : 0xff1010, align : 'center'});
 * ```
 *
 * @class
 * @extends PIXI.Sprite
 * @memberof PIXI
 */

var Text = function (_Sprite) {
    _inherits(Text, _Sprite);

    /**
     * @param {string} text - The string that you would like the text to display
     * @param {object|PIXI.TextStyle} [style] - The style parameters
     * @param {HTMLCanvasElement} [canvas] - The canvas element for drawing text
     */
    function Text(text, style, canvas) {
        _classCallCheck(this, Text);

        canvas = canvas || document.createElement('canvas');

        canvas.width = 3;
        canvas.height = 3;

        var texture = _Texture2.default.fromCanvas(canvas, _settings2.default.SCALE_MODE, 'text');

        texture.orig = new _math.Rectangle();
        texture.trim = new _math.Rectangle();

        // base texture is already automatically added to the cache, now adding the actual texture
        var _this = _possibleConstructorReturn(this, _Sprite.call(this, texture));

        _Texture2.default.addToCache(_this._texture, _this._texture.baseTexture.textureCacheIds[0]);

        /**
         * The canvas element that everything is drawn to
         *
         * @member {HTMLCanvasElement}
         */
        _this.canvas = canvas;

        /**
         * The canvas 2d context that everything is drawn with
         * @member {CanvasRenderingContext2D}
         */
        _this.context = _this.canvas.getContext('2d');

        /**
         * The resolution / device pixel ratio of the canvas. This is set automatically by the renderer.
         * @member {number}
         * @default 1
         */
        _this.resolution = _settings2.default.RESOLUTION;

        /**
         * Private tracker for the current text.
         *
         * @member {string}
         * @private
         */
        _this._text = null;

        /**
         * Private tracker for the current style.
         *
         * @member {object}
         * @private
         */
        _this._style = null;
        /**
         * Private listener to track style changes.
         *
         * @member {Function}
         * @private
         */
        _this._styleListener = null;

        /**
         * Private tracker for the current font.
         *
         * @member {string}
         * @private
         */
        _this._font = '';

        _this.text = text;
        _this.style = style;

        _this.localStyleID = -1;
        return _this;
    }

    /**
     * Renders text and updates it when needed.
     *
     * @private
     * @param {boolean} respectDirty - Whether to abort updating the text if the Text isn't dirty and the function is called.
     */


    Text.prototype.updateText = function updateText(respectDirty) {
        var style = this._style;

        // check if style has changed..
        if (this.localStyleID !== style.styleID) {
            this.dirty = true;
            this.localStyleID = style.styleID;
        }

        if (!this.dirty && respectDirty) {
            return;
        }

        this._font = this._style.toFontString();

        var context = this.context;
        var measured = _TextMetrics2.default.measureText(this._text, this._style, this._style.wordWrap, this.canvas);
        var width = measured.width;
        var height = measured.height;
        var lines = measured.lines;
        var lineHeight = measured.lineHeight;
        var lineWidths = measured.lineWidths;
        var maxLineWidth = measured.maxLineWidth;
        var fontProperties = measured.fontProperties;

        this.canvas.width = Math.ceil((Math.max(1, width) + style.padding * 2) * this.resolution);
        this.canvas.height = Math.ceil((Math.max(1, height) + style.padding * 2) * this.resolution);

        context.scale(this.resolution, this.resolution);

        context.clearRect(0, 0, this.canvas.width, this.canvas.height);

        context.font = this._font;
        context.strokeStyle = style.stroke;
        context.lineWidth = style.strokeThickness;
        context.textBaseline = style.textBaseline;
        context.lineJoin = style.lineJoin;
        context.miterLimit = style.miterLimit;

        var linePositionX = void 0;
        var linePositionY = void 0;

        if (style.dropShadow) {
            context.fillStyle = style.dropShadowColor;
            context.globalAlpha = style.dropShadowAlpha;
            context.shadowBlur = style.dropShadowBlur;

            if (style.dropShadowBlur > 0) {
                context.shadowColor = style.dropShadowColor;
            }

            var xShadowOffset = Math.cos(style.dropShadowAngle) * style.dropShadowDistance;
            var yShadowOffset = Math.sin(style.dropShadowAngle) * style.dropShadowDistance;

            for (var i = 0; i < lines.length; i++) {
                linePositionX = style.strokeThickness / 2;
                linePositionY = style.strokeThickness / 2 + i * lineHeight + fontProperties.ascent;

                if (style.align === 'right') {
                    linePositionX += maxLineWidth - lineWidths[i];
                } else if (style.align === 'center') {
                    linePositionX += (maxLineWidth - lineWidths[i]) / 2;
                }

                if (style.fill) {
                    this.drawLetterSpacing(lines[i], linePositionX + xShadowOffset + style.padding, linePositionY + yShadowOffset + style.padding);

                    if (style.stroke && style.strokeThickness) {
                        context.strokeStyle = style.dropShadowColor;
                        this.drawLetterSpacing(lines[i], linePositionX + xShadowOffset + style.padding, linePositionY + yShadowOffset + style.padding, true);
                        context.strokeStyle = style.stroke;
                    }
                }
            }
        }

        // reset the shadow blur and alpha that was set by the drop shadow, for the regular text
        context.shadowBlur = 0;
        context.globalAlpha = 1;

        // set canvas text styles
        context.fillStyle = this._generateFillStyle(style, lines);

        // draw lines line by line
        for (var _i = 0; _i < lines.length; _i++) {
            linePositionX = style.strokeThickness / 2;
            linePositionY = style.strokeThickness / 2 + _i * lineHeight + fontProperties.ascent;

            if (style.align === 'right') {
                linePositionX += maxLineWidth - lineWidths[_i];
            } else if (style.align === 'center') {
                linePositionX += (maxLineWidth - lineWidths[_i]) / 2;
            }

            if (style.stroke && style.strokeThickness) {
                this.drawLetterSpacing(lines[_i], linePositionX + style.padding, linePositionY + style.padding, true);
            }

            if (style.fill) {
                this.drawLetterSpacing(lines[_i], linePositionX + style.padding, linePositionY + style.padding);
            }
        }

        this.updateTexture();
    };

    /**
     * Render the text with letter-spacing.
     * @param {string} text - The text to draw
     * @param {number} x - Horizontal position to draw the text
     * @param {number} y - Vertical position to draw the text
     * @param {boolean} [isStroke=false] - Is this drawing for the outside stroke of the
     *  text? If not, it's for the inside fill
     * @private
     */


    Text.prototype.drawLetterSpacing = function drawLetterSpacing(text, x, y) {
        var isStroke = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        var style = this._style;

        // letterSpacing of 0 means normal
        var letterSpacing = style.letterSpacing;

        if (letterSpacing === 0) {
            if (isStroke) {
                this.context.strokeText(text, x, y);
            } else {
                this.context.fillText(text, x, y);
            }

            return;
        }

        var characters = String.prototype.split.call(text, '');
        var currentPosition = x;
        var index = 0;
        var current = '';
        var previousWidth = this.context.measureText(text).width;
        var currentWidth = 0;

        while (index < text.length) {
            current = characters[index++];
            if (isStroke) {
                this.context.strokeText(current, currentPosition, y);
            } else {
                this.context.fillText(current, currentPosition, y);
            }
            currentWidth = this.context.measureText(text.substring(index)).width;
            currentPosition += previousWidth - currentWidth + letterSpacing;
            previousWidth = currentWidth;
        }
    };

    /**
     * Updates texture size based on canvas size
     *
     * @private
     */


    Text.prototype.updateTexture = function updateTexture() {
        var canvas = this.canvas;

        if (this._style.trim) {
            var trimmed = (0, _trimCanvas2.default)(canvas);

            if (trimmed.data) {
                canvas.width = trimmed.width;
                canvas.height = trimmed.height;
                this.context.putImageData(trimmed.data, 0, 0);
            }
        }

        var texture = this._texture;
        var style = this._style;
        var padding = style.trim ? 0 : style.padding;
        var baseTexture = texture.baseTexture;

        baseTexture.hasLoaded = true;
        baseTexture.resolution = this.resolution;

        baseTexture.realWidth = canvas.width;
        baseTexture.realHeight = canvas.height;
        baseTexture.width = canvas.width / this.resolution;
        baseTexture.height = canvas.height / this.resolution;

        texture.trim.width = texture._frame.width = canvas.width / this.resolution;
        texture.trim.height = texture._frame.height = canvas.height / this.resolution;
        texture.trim.x = -padding;
        texture.trim.y = -padding;

        texture.orig.width = texture._frame.width - padding * 2;
        texture.orig.height = texture._frame.height - padding * 2;

        // call sprite onTextureUpdate to update scale if _width or _height were set
        this._onTextureUpdate();

        baseTexture.emit('update', baseTexture);

        this.dirty = false;
    };

    /**
     * Renders the object using the WebGL renderer
     *
     * @param {PIXI.WebGLRenderer} renderer - The renderer
     */


    Text.prototype.renderWebGL = function renderWebGL(renderer) {
        if (this.resolution !== renderer.resolution) {
            this.resolution = renderer.resolution;
            this.dirty = true;
        }

        this.updateText(true);

        _Sprite.prototype.renderWebGL.call(this, renderer);
    };

    /**
     * Renders the object using the Canvas renderer
     *
     * @private
     * @param {PIXI.CanvasRenderer} renderer - The renderer
     */


    Text.prototype._renderCanvas = function _renderCanvas(renderer) {
        if (this.resolution !== renderer.resolution) {
            this.resolution = renderer.resolution;
            this.dirty = true;
        }

        this.updateText(true);

        _Sprite.prototype._renderCanvas.call(this, renderer);
    };

    /**
     * Gets the local bounds of the text object.
     *
     * @param {Rectangle} rect - The output rectangle.
     * @return {Rectangle} The bounds.
     */


    Text.prototype.getLocalBounds = function getLocalBounds(rect) {
        this.updateText(true);

        return _Sprite.prototype.getLocalBounds.call(this, rect);
    };

    /**
     * calculates the bounds of the Text as a rectangle. The bounds calculation takes the worldTransform into account.
     */


    Text.prototype._calculateBounds = function _calculateBounds() {
        this.updateText(true);
        this.calculateVertices();
        // if we have already done this on THIS frame.
        this._bounds.addQuad(this.vertexData);
    };

    /**
     * Method to be called upon a TextStyle change.
     * @private
     */


    Text.prototype._onStyleChange = function _onStyleChange() {
        this.dirty = true;
    };

    /**
     * Generates the fill style. Can automatically generate a gradient based on the fill style being an array
     *
     * @private
     * @param {object} style - The style.
     * @param {string[]} lines - The lines of text.
     * @return {string|number|CanvasGradient} The fill style
     */


    Text.prototype._generateFillStyle = function _generateFillStyle(style, lines) {
        if (!Array.isArray(style.fill)) {
            return style.fill;
        }

        // cocoon on canvas+ cannot generate textures, so use the first colour instead
        if (navigator.isCocoonJS) {
            return style.fill[0];
        }

        // the gradient will be evenly spaced out according to how large the array is.
        // ['#FF0000', '#00FF00', '#0000FF'] would created stops at 0.25, 0.5 and 0.75
        var gradient = void 0;
        var totalIterations = void 0;
        var currentIteration = void 0;
        var stop = void 0;

        var width = this.canvas.width / this.resolution;
        var height = this.canvas.height / this.resolution;

        // make a copy of the style settings, so we can manipulate them later
        var fill = style.fill.slice();
        var fillGradientStops = style.fillGradientStops.slice();

        // wanting to evenly distribute the fills. So an array of 4 colours should give fills of 0.25, 0.5 and 0.75
        if (!fillGradientStops.length) {
            var lengthPlus1 = fill.length + 1;

            for (var i = 1; i < lengthPlus1; ++i) {
                fillGradientStops.push(i / lengthPlus1);
            }
        }

        // stop the bleeding of the last gradient on the line above to the top gradient of the this line
        // by hard defining the first gradient colour at point 0, and last gradient colour at point 1
        fill.unshift(style.fill[0]);
        fillGradientStops.unshift(0);

        fill.push(style.fill[style.fill.length - 1]);
        fillGradientStops.push(1);

        if (style.fillGradientType === _const.TEXT_GRADIENT.LINEAR_VERTICAL) {
            // start the gradient at the top center of the canvas, and end at the bottom middle of the canvas
            gradient = this.context.createLinearGradient(width / 2, 0, width / 2, height);

            // we need to repeat the gradient so that each individual line of text has the same vertical gradient effect
            // ['#FF0000', '#00FF00', '#0000FF'] over 2 lines would create stops at 0.125, 0.25, 0.375, 0.625, 0.75, 0.875
            totalIterations = (fill.length + 1) * lines.length;
            currentIteration = 0;
            for (var _i2 = 0; _i2 < lines.length; _i2++) {
                currentIteration += 1;
                for (var j = 0; j < fill.length; j++) {
                    if (typeof fillGradientStops[j] === 'number') {
                        stop = fillGradientStops[j] / lines.length + _i2 / lines.length;
                    } else {
                        stop = currentIteration / totalIterations;
                    }
                    gradient.addColorStop(stop, fill[j]);
                    currentIteration++;
                }
            }
        } else {
            // start the gradient at the center left of the canvas, and end at the center right of the canvas
            gradient = this.context.createLinearGradient(0, height / 2, width, height / 2);

            // can just evenly space out the gradients in this case, as multiple lines makes no difference
            // to an even left to right gradient
            totalIterations = fill.length + 1;
            currentIteration = 1;

            for (var _i3 = 0; _i3 < fill.length; _i3++) {
                if (typeof fillGradientStops[_i3] === 'number') {
                    stop = fillGradientStops[_i3];
                } else {
                    stop = currentIteration / totalIterations;
                }
                gradient.addColorStop(stop, fill[_i3]);
                currentIteration++;
            }
        }

        return gradient;
    };

    /**
     * Destroys this text object.
     * Note* Unlike a Sprite, a Text object will automatically destroy its baseTexture and texture as
     * the majority of the time the texture will not be shared with any other Sprites.
     *
     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
     *  have been set to that value
     * @param {boolean} [options.children=false] - if set to true, all the children will have their
     *  destroy method called as well. 'options' will be passed on to those calls.
     * @param {boolean} [options.texture=true] - Should it destroy the current texture of the sprite as well
     * @param {boolean} [options.baseTexture=true] - Should it destroy the base texture of the sprite as well
     */


    Text.prototype.destroy = function destroy(options) {
        if (typeof options === 'boolean') {
            options = { children: options };
        }

        options = Object.assign({}, defaultDestroyOptions, options);

        _Sprite.prototype.destroy.call(this, options);

        // make sure to reset the the context and canvas.. dont want this hanging around in memory!
        this.context = null;
        this.canvas = null;

        this._style = null;
    };

    /**
     * The width of the Text, setting this will actually modify the scale to achieve the value set
     *
     * @member {number}
     */


    _createClass(Text, [{
        key: 'width',
        get: function get() {
            this.updateText(true);

            return Math.abs(this.scale.x) * this._texture.orig.width;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.updateText(true);

            var s = (0, _utils.sign)(this.scale.x) || 1;

            this.scale.x = s * value / this._texture.orig.width;
            this._width = value;
        }

        /**
         * The height of the Text, setting this will actually modify the scale to achieve the value set
         *
         * @member {number}
         */

    }, {
        key: 'height',
        get: function get() {
            this.updateText(true);

            return Math.abs(this.scale.y) * this._texture.orig.height;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.updateText(true);

            var s = (0, _utils.sign)(this.scale.y) || 1;

            this.scale.y = s * value / this._texture.orig.height;
            this._height = value;
        }

        /**
         * Set the style of the text. Set up an event listener to listen for changes on the style
         * object and mark the text as dirty.
         *
         * @member {object|PIXI.TextStyle}
         */

    }, {
        key: 'style',
        get: function get() {
            return this._style;
        },
        set: function set(style) // eslint-disable-line require-jsdoc
        {
            style = style || {};

            if (style instanceof _TextStyle2.default) {
                this._style = style;
            } else {
                this._style = new _TextStyle2.default(style);
            }

            this.localStyleID = -1;
            this.dirty = true;
        }

        /**
         * Set the copy for the text object. To split a line you can use '\n'.
         *
         * @member {string}
         */

    }, {
        key: 'text',
        get: function get() {
            return this._text;
        },
        set: function set(text) // eslint-disable-line require-jsdoc
        {
            text = String(text === '' || text === null || text === undefined ? ' ' : text);

            if (this._text === text) {
                return;
            }
            this._text = text;
            this.dirty = true;
        }
    }]);

    return Text;
}(_Sprite3.default);

exports.default = Text;
//# sourceMappingURL=Text.js.map

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = trimCanvas;
/**
 * Trim transparent borders from a canvas
 *
 * @memberof PIXI
 * @function trimCanvas
 * @private
 * @param {HTMLCanvasElement} canvas - the canvas to trim
 * @returns {object} Trim data
 */
function trimCanvas(canvas) {
    // https://gist.github.com/remy/784508

    var width = canvas.width;
    var height = canvas.height;

    var context = canvas.getContext('2d');
    var imageData = context.getImageData(0, 0, width, height);
    var pixels = imageData.data;
    var len = pixels.length;

    var bound = {
        top: null,
        left: null,
        right: null,
        bottom: null
    };
    var data = null;
    var i = void 0;
    var x = void 0;
    var y = void 0;

    for (i = 0; i < len; i += 4) {
        if (pixels[i + 3] !== 0) {
            x = i / 4 % width;
            y = ~~(i / 4 / width);

            if (bound.top === null) {
                bound.top = y;
            }

            if (bound.left === null) {
                bound.left = x;
            } else if (x < bound.left) {
                bound.left = x;
            }

            if (bound.right === null) {
                bound.right = x + 1;
            } else if (bound.right < x) {
                bound.right = x + 1;
            }

            if (bound.bottom === null) {
                bound.bottom = y;
            } else if (bound.bottom < y) {
                bound.bottom = y;
            }
        }
    }

    if (bound.top !== null) {
        width = bound.right - bound.left;
        height = bound.bottom - bound.top + 1;
        data = context.getImageData(bound.left, bound.top, width, height);
    }

    return {
        height: height,
        width: width,
        data: data
    };
}
//# sourceMappingURL=trimCanvas.js.map

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _Container2 = __webpack_require__(83);

var _Container3 = _interopRequireDefault(_Container2);

var _RenderTexture = __webpack_require__(135);

var _RenderTexture2 = _interopRequireDefault(_RenderTexture);

var _Texture = __webpack_require__(49);

var _Texture2 = _interopRequireDefault(_Texture);

var _GraphicsData = __webpack_require__(197);

var _GraphicsData2 = _interopRequireDefault(_GraphicsData);

var _Sprite = __webpack_require__(131);

var _Sprite2 = _interopRequireDefault(_Sprite);

var _math = __webpack_require__(20);

var _utils = __webpack_require__(9);

var _const = __webpack_require__(5);

var _Bounds = __webpack_require__(127);

var _Bounds2 = _interopRequireDefault(_Bounds);

var _bezierCurveTo2 = __webpack_require__(389);

var _bezierCurveTo3 = _interopRequireDefault(_bezierCurveTo2);

var _CanvasRenderer = __webpack_require__(84);

var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var canvasRenderer = void 0;
var tempMatrix = new _math.Matrix();
var tempPoint = new _math.Point();
var tempColor1 = new Float32Array(4);
var tempColor2 = new Float32Array(4);

/**
 * The Graphics class contains methods used to draw primitive shapes such as lines, circles and
 * rectangles to the display, and to color and fill them.
 *
 * @class
 * @extends PIXI.Container
 * @memberof PIXI
 */

var Graphics = function (_Container) {
    _inherits(Graphics, _Container);

    /**
     *
     * @param {boolean} [nativeLines=false] - If true the lines will be draw using LINES instead of TRIANGLE_STRIP
     */
    function Graphics() {
        var nativeLines = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        _classCallCheck(this, Graphics);

        /**
         * The alpha value used when filling the Graphics object.
         *
         * @member {number}
         * @default 1
         */
        var _this = _possibleConstructorReturn(this, _Container.call(this));

        _this.fillAlpha = 1;

        /**
         * The width (thickness) of any lines drawn.
         *
         * @member {number}
         * @default 0
         */
        _this.lineWidth = 0;

        /**
         * If true the lines will be draw using LINES instead of TRIANGLE_STRIP
         *
         * @member {boolean}
         */
        _this.nativeLines = nativeLines;

        /**
         * The color of any lines drawn.
         *
         * @member {string}
         * @default 0
         */
        _this.lineColor = 0;

        /**
         * The alignment of any lines drawn (0.5 = middle, 1 = outter, 0 = inner).
         *
         * @member {number}
         * @default 0.5
         */
        _this.lineAlignment = 0.5;

        /**
         * Graphics data
         *
         * @member {PIXI.GraphicsData[]}
         * @private
         */
        _this.graphicsData = [];

        /**
         * The tint applied to the graphic shape. This is a hex value. Apply a value of 0xFFFFFF to
         * reset the tint.
         *
         * @member {number}
         * @default 0xFFFFFF
         */
        _this.tint = 0xFFFFFF;

        /**
         * The previous tint applied to the graphic shape. Used to compare to the current tint and
         * check if theres change.
         *
         * @member {number}
         * @private
         * @default 0xFFFFFF
         */
        _this._prevTint = 0xFFFFFF;

        /**
         * The blend mode to be applied to the graphic shape. Apply a value of
         * `PIXI.BLEND_MODES.NORMAL` to reset the blend mode.
         *
         * @member {number}
         * @default PIXI.BLEND_MODES.NORMAL;
         * @see PIXI.BLEND_MODES
         */
        _this.blendMode = _const.BLEND_MODES.NORMAL;

        /**
         * Current path
         *
         * @member {PIXI.GraphicsData}
         * @private
         */
        _this.currentPath = null;

        /**
         * Array containing some WebGL-related properties used by the WebGL renderer.
         *
         * @member {object<number, object>}
         * @private
         */
        // TODO - _webgl should use a prototype object, not a random undocumented object...
        _this._webGL = {};

        /**
         * Whether this shape is being used as a mask.
         *
         * @member {boolean}
         */
        _this.isMask = false;

        /**
         * The bounds' padding used for bounds calculation.
         *
         * @member {number}
         */
        _this.boundsPadding = 0;

        /**
         * A cache of the local bounds to prevent recalculation.
         *
         * @member {PIXI.Rectangle}
         * @private
         */
        _this._localBounds = new _Bounds2.default();

        /**
         * Used to detect if the graphics object has changed. If this is set to true then the graphics
         * object will be recalculated.
         *
         * @member {boolean}
         * @private
         */
        _this.dirty = 0;

        /**
         * Used to detect if we need to do a fast rect check using the id compare method
         * @type {Number}
         */
        _this.fastRectDirty = -1;

        /**
         * Used to detect if we clear the graphics webGL data
         * @type {Number}
         */
        _this.clearDirty = 0;

        /**
         * Used to detect if we we need to recalculate local bounds
         * @type {Number}
         */
        _this.boundsDirty = -1;

        /**
         * Used to detect if the cached sprite object needs to be updated.
         *
         * @member {boolean}
         * @private
         */
        _this.cachedSpriteDirty = false;

        _this._spriteRect = null;
        _this._fastRect = false;

        _this._prevRectTint = null;
        _this._prevRectFillColor = null;

        /**
         * When cacheAsBitmap is set to true the graphics object will be rendered as if it was a sprite.
         * This is useful if your graphics element does not change often, as it will speed up the rendering
         * of the object in exchange for taking up texture memory. It is also useful if you need the graphics
         * object to be anti-aliased, because it will be rendered using canvas. This is not recommended if
         * you are constantly redrawing the graphics element.
         *
         * @name cacheAsBitmap
         * @member {boolean}
         * @memberof PIXI.Graphics#
         * @default false
         */
        return _this;
    }

    /**
     * Creates a new Graphics object with the same values as this one.
     * Note that the only the properties of the object are cloned, not its transform (position,scale,etc)
     *
     * @return {PIXI.Graphics} A clone of the graphics object
     */


    Graphics.prototype.clone = function clone() {
        var clone = new Graphics();

        clone.renderable = this.renderable;
        clone.fillAlpha = this.fillAlpha;
        clone.lineWidth = this.lineWidth;
        clone.lineColor = this.lineColor;
        clone.lineAlignment = this.lineAlignment;
        clone.tint = this.tint;
        clone.blendMode = this.blendMode;
        clone.isMask = this.isMask;
        clone.boundsPadding = this.boundsPadding;
        clone.dirty = 0;
        clone.cachedSpriteDirty = this.cachedSpriteDirty;

        // copy graphics data
        for (var i = 0; i < this.graphicsData.length; ++i) {
            clone.graphicsData.push(this.graphicsData[i].clone());
        }

        clone.currentPath = clone.graphicsData[clone.graphicsData.length - 1];

        clone.updateLocalBounds();

        return clone;
    };

    /**
     * Calculate length of quadratic curve
     * @see {@link http://www.malczak.linuxpl.com/blog/quadratic-bezier-curve-length/}
     * for the detailed explanation of math behind this.
     *
     * @private
     * @param {number} fromX - x-coordinate of curve start point
     * @param {number} fromY - y-coordinate of curve start point
     * @param {number} cpX - x-coordinate of curve control point
     * @param {number} cpY - y-coordinate of curve control point
     * @param {number} toX - x-coordinate of curve end point
     * @param {number} toY - y-coordinate of curve end point
     * @return {number} Length of quadratic curve
     */


    Graphics.prototype._quadraticCurveLength = function _quadraticCurveLength(fromX, fromY, cpX, cpY, toX, toY) {
        var ax = fromX - 2.0 * cpX + toX;
        var ay = fromY - 2.0 * cpY + toY;
        var bx = 2.0 * cpX - 2.0 * fromX;
        var by = 2.0 * cpY - 2.0 * fromY;
        var a = 4.0 * (ax * ax + ay * ay);
        var b = 4.0 * (ax * bx + ay * by);
        var c = bx * bx + by * by;

        var s = 2.0 * Math.sqrt(a + b + c);
        var a2 = Math.sqrt(a);
        var a32 = 2.0 * a * a2;
        var c2 = 2.0 * Math.sqrt(c);
        var ba = b / a2;

        return (a32 * s + a2 * b * (s - c2) + (4.0 * c * a - b * b) * Math.log((2.0 * a2 + ba + s) / (ba + c2))) / (4.0 * a32);
    };

    /**
     * Calculate length of bezier curve.
     * Analytical solution is impossible, since it involves an integral that does not integrate in general.
     * Therefore numerical solution is used.
     *
     * @private
     * @param {number} fromX - Starting point x
     * @param {number} fromY - Starting point y
     * @param {number} cpX - Control point x
     * @param {number} cpY - Control point y
     * @param {number} cpX2 - Second Control point x
     * @param {number} cpY2 - Second Control point y
     * @param {number} toX - Destination point x
     * @param {number} toY - Destination point y
     * @return {number} Length of bezier curve
     */


    Graphics.prototype._bezierCurveLength = function _bezierCurveLength(fromX, fromY, cpX, cpY, cpX2, cpY2, toX, toY) {
        var n = 10;
        var result = 0.0;
        var t = 0.0;
        var t2 = 0.0;
        var t3 = 0.0;
        var nt = 0.0;
        var nt2 = 0.0;
        var nt3 = 0.0;
        var x = 0.0;
        var y = 0.0;
        var dx = 0.0;
        var dy = 0.0;
        var prevX = fromX;
        var prevY = fromY;

        for (var i = 1; i <= n; ++i) {
            t = i / n;
            t2 = t * t;
            t3 = t2 * t;
            nt = 1.0 - t;
            nt2 = nt * nt;
            nt3 = nt2 * nt;

            x = nt3 * fromX + 3.0 * nt2 * t * cpX + 3.0 * nt * t2 * cpX2 + t3 * toX;
            y = nt3 * fromY + 3.0 * nt2 * t * cpY + 3 * nt * t2 * cpY2 + t3 * toY;
            dx = prevX - x;
            dy = prevY - y;
            prevX = x;
            prevY = y;

            result += Math.sqrt(dx * dx + dy * dy);
        }

        return result;
    };

    /**
     * Calculate number of segments for the curve based on its length to ensure its smoothness.
     *
     * @private
     * @param {number} length - length of curve
     * @return {number} Number of segments
     */


    Graphics.prototype._segmentsCount = function _segmentsCount(length) {
        var result = Math.ceil(length / Graphics.CURVES.maxLength);

        if (result < Graphics.CURVES.minSegments) {
            result = Graphics.CURVES.minSegments;
        } else if (result > Graphics.CURVES.maxSegments) {
            result = Graphics.CURVES.maxSegments;
        }

        return result;
    };

    /**
     * Specifies the line style used for subsequent calls to Graphics methods such as the lineTo()
     * method or the drawCircle() method.
     *
     * @param {number} [lineWidth=0] - width of the line to draw, will update the objects stored style
     * @param {number} [color=0] - color of the line to draw, will update the objects stored style
     * @param {number} [alpha=1] - alpha of the line to draw, will update the objects stored style
     * @param {number} [alignment=0.5] - alignment of the line to draw, (0 = inner, 0.5 = middle, 1 = outter)
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */


    Graphics.prototype.lineStyle = function lineStyle() {
        var lineWidth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var alpha = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        var alignment = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0.5;

        this.lineWidth = lineWidth;
        this.lineColor = color;
        this.lineAlpha = alpha;
        this.lineAlignment = alignment;

        if (this.currentPath) {
            if (this.currentPath.shape.points.length) {
                // halfway through a line? start a new one!
                var shape = new _math.Polygon(this.currentPath.shape.points.slice(-2));

                shape.closed = false;

                this.drawShape(shape);
            } else {
                // otherwise its empty so lets just set the line properties
                this.currentPath.lineWidth = this.lineWidth;
                this.currentPath.lineColor = this.lineColor;
                this.currentPath.lineAlpha = this.lineAlpha;
                this.currentPath.lineAlignment = this.lineAlignment;
            }
        }

        return this;
    };

    /**
     * Moves the current drawing position to x, y.
     *
     * @param {number} x - the X coordinate to move to
     * @param {number} y - the Y coordinate to move to
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */


    Graphics.prototype.moveTo = function moveTo(x, y) {
        var shape = new _math.Polygon([x, y]);

        shape.closed = false;
        this.drawShape(shape);

        return this;
    };

    /**
     * Draws a line using the current line style from the current drawing position to (x, y);
     * The current drawing position is then set to (x, y).
     *
     * @param {number} x - the X coordinate to draw to
     * @param {number} y - the Y coordinate to draw to
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */


    Graphics.prototype.lineTo = function lineTo(x, y) {
        var points = this.currentPath.shape.points;

        var fromX = points[points.length - 2];
        var fromY = points[points.length - 1];

        if (fromX !== x || fromY !== y) {
            points.push(x, y);
            this.dirty++;
        }

        return this;
    };

    /**
     * Calculate the points for a quadratic bezier curve and then draws it.
     * Based on: https://stackoverflow.com/questions/785097/how-do-i-implement-a-bezier-curve-in-c
     *
     * @param {number} cpX - Control point x
     * @param {number} cpY - Control point y
     * @param {number} toX - Destination point x
     * @param {number} toY - Destination point y
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */


    Graphics.prototype.quadraticCurveTo = function quadraticCurveTo(cpX, cpY, toX, toY) {
        if (this.currentPath) {
            if (this.currentPath.shape.points.length === 0) {
                this.currentPath.shape.points = [0, 0];
            }
        } else {
            this.moveTo(0, 0);
        }

        var points = this.currentPath.shape.points;
        var xa = 0;
        var ya = 0;

        if (points.length === 0) {
            this.moveTo(0, 0);
        }

        var fromX = points[points.length - 2];
        var fromY = points[points.length - 1];
        var n = Graphics.CURVES.adaptive ? this._segmentsCount(this._quadraticCurveLength(fromX, fromY, cpX, cpY, toX, toY)) : 20;

        for (var i = 1; i <= n; ++i) {
            var j = i / n;

            xa = fromX + (cpX - fromX) * j;
            ya = fromY + (cpY - fromY) * j;

            points.push(xa + (cpX + (toX - cpX) * j - xa) * j, ya + (cpY + (toY - cpY) * j - ya) * j);
        }

        this.dirty++;

        return this;
    };

    /**
     * Calculate the points for a bezier curve and then draws it.
     *
     * @param {number} cpX - Control point x
     * @param {number} cpY - Control point y
     * @param {number} cpX2 - Second Control point x
     * @param {number} cpY2 - Second Control point y
     * @param {number} toX - Destination point x
     * @param {number} toY - Destination point y
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */


    Graphics.prototype.bezierCurveTo = function bezierCurveTo(cpX, cpY, cpX2, cpY2, toX, toY) {
        if (this.currentPath) {
            if (this.currentPath.shape.points.length === 0) {
                this.currentPath.shape.points = [0, 0];
            }
        } else {
            this.moveTo(0, 0);
        }

        var points = this.currentPath.shape.points;

        var fromX = points[points.length - 2];
        var fromY = points[points.length - 1];

        points.length -= 2;

        var n = Graphics.CURVES.adaptive ? this._segmentsCount(this._bezierCurveLength(fromX, fromY, cpX, cpY, cpX2, cpY2, toX, toY)) : 20;

        (0, _bezierCurveTo3.default)(fromX, fromY, cpX, cpY, cpX2, cpY2, toX, toY, n, points);

        this.dirty++;

        return this;
    };

    /**
     * The arcTo() method creates an arc/curve between two tangents on the canvas.
     *
     * "borrowed" from https://code.google.com/p/fxcanvas/ - thanks google!
     *
     * @param {number} x1 - The x-coordinate of the beginning of the arc
     * @param {number} y1 - The y-coordinate of the beginning of the arc
     * @param {number} x2 - The x-coordinate of the end of the arc
     * @param {number} y2 - The y-coordinate of the end of the arc
     * @param {number} radius - The radius of the arc
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */


    Graphics.prototype.arcTo = function arcTo(x1, y1, x2, y2, radius) {
        if (this.currentPath) {
            if (this.currentPath.shape.points.length === 0) {
                this.currentPath.shape.points.push(x1, y1);
            }
        } else {
            this.moveTo(x1, y1);
        }

        var points = this.currentPath.shape.points;
        var fromX = points[points.length - 2];
        var fromY = points[points.length - 1];
        var a1 = fromY - y1;
        var b1 = fromX - x1;
        var a2 = y2 - y1;
        var b2 = x2 - x1;
        var mm = Math.abs(a1 * b2 - b1 * a2);

        if (mm < 1.0e-8 || radius === 0) {
            if (points[points.length - 2] !== x1 || points[points.length - 1] !== y1) {
                points.push(x1, y1);
            }
        } else {
            var dd = a1 * a1 + b1 * b1;
            var cc = a2 * a2 + b2 * b2;
            var tt = a1 * a2 + b1 * b2;
            var k1 = radius * Math.sqrt(dd) / mm;
            var k2 = radius * Math.sqrt(cc) / mm;
            var j1 = k1 * tt / dd;
            var j2 = k2 * tt / cc;
            var cx = k1 * b2 + k2 * b1;
            var cy = k1 * a2 + k2 * a1;
            var px = b1 * (k2 + j1);
            var py = a1 * (k2 + j1);
            var qx = b2 * (k1 + j2);
            var qy = a2 * (k1 + j2);
            var startAngle = Math.atan2(py - cy, px - cx);
            var endAngle = Math.atan2(qy - cy, qx - cx);

            this.arc(cx + x1, cy + y1, radius, startAngle, endAngle, b1 * a2 > b2 * a1);
        }

        this.dirty++;

        return this;
    };

    /**
     * The arc method creates an arc/curve (used to create circles, or parts of circles).
     *
     * @param {number} cx - The x-coordinate of the center of the circle
     * @param {number} cy - The y-coordinate of the center of the circle
     * @param {number} radius - The radius of the circle
     * @param {number} startAngle - The starting angle, in radians (0 is at the 3 o'clock position
     *  of the arc's circle)
     * @param {number} endAngle - The ending angle, in radians
     * @param {boolean} [anticlockwise=false] - Specifies whether the drawing should be
     *  counter-clockwise or clockwise. False is default, and indicates clockwise, while true
     *  indicates counter-clockwise.
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */


    Graphics.prototype.arc = function arc(cx, cy, radius, startAngle, endAngle) {
        var anticlockwise = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

        if (startAngle === endAngle) {
            return this;
        }

        if (!anticlockwise && endAngle <= startAngle) {
            endAngle += _const.PI_2;
        } else if (anticlockwise && startAngle <= endAngle) {
            startAngle += _const.PI_2;
        }

        var sweep = endAngle - startAngle;
        var segs = Graphics.CURVES.adaptive ? this._segmentsCount(Math.abs(sweep) * radius) : Math.ceil(Math.abs(sweep) / _const.PI_2) * 40;

        if (sweep === 0) {
            return this;
        }

        var startX = cx + Math.cos(startAngle) * radius;
        var startY = cy + Math.sin(startAngle) * radius;

        // If the currentPath exists, take its points. Otherwise call `moveTo` to start a path.
        var points = this.currentPath ? this.currentPath.shape.points : null;

        if (points) {
            // We check how far our start is from the last existing point
            var xDiff = Math.abs(points[points.length - 2] - startX);
            var yDiff = Math.abs(points[points.length - 1] - startY);

            if (xDiff < 0.001 && yDiff < 0.001) {
                // If the point is very close, we don't add it, since this would lead to artifacts
                // during tesselation due to floating point imprecision.
            } else {
                points.push(startX, startY);
            }
        } else {
            this.moveTo(startX, startY);
            points = this.currentPath.shape.points;
        }

        var theta = sweep / (segs * 2);
        var theta2 = theta * 2;

        var cTheta = Math.cos(theta);
        var sTheta = Math.sin(theta);

        var segMinus = segs - 1;

        var remainder = segMinus % 1 / segMinus;

        for (var i = 0; i <= segMinus; ++i) {
            var real = i + remainder * i;

            var angle = theta + startAngle + theta2 * real;

            var c = Math.cos(angle);
            var s = -Math.sin(angle);

            points.push((cTheta * c + sTheta * s) * radius + cx, (cTheta * -s + sTheta * c) * radius + cy);
        }

        this.dirty++;

        return this;
    };

    /**
     * Specifies a simple one-color fill that subsequent calls to other Graphics methods
     * (such as lineTo() or drawCircle()) use when drawing.
     *
     * @param {number} [color=0] - the color of the fill
     * @param {number} [alpha=1] - the alpha of the fill
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */


    Graphics.prototype.beginFill = function beginFill() {
        var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

        this.filling = true;
        this.fillColor = color;
        this.fillAlpha = alpha;

        if (this.currentPath) {
            if (this.currentPath.shape.points.length <= 2) {
                this.currentPath.fill = this.filling;
                this.currentPath.fillColor = this.fillColor;
                this.currentPath.fillAlpha = this.fillAlpha;
            }
        }

        return this;
    };

    /**
     * Applies a fill to the lines and shapes that were added since the last call to the beginFill() method.
     *
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */


    Graphics.prototype.endFill = function endFill() {
        this.filling = false;
        this.fillColor = null;
        this.fillAlpha = 1;

        return this;
    };

    /**
     *
     * @param {number} x - The X coord of the top-left of the rectangle
     * @param {number} y - The Y coord of the top-left of the rectangle
     * @param {number} width - The width of the rectangle
     * @param {number} height - The height of the rectangle
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */


    Graphics.prototype.drawRect = function drawRect(x, y, width, height) {
        this.drawShape(new _math.Rectangle(x, y, width, height));

        return this;
    };

    /**
     *
     * @param {number} x - The X coord of the top-left of the rectangle
     * @param {number} y - The Y coord of the top-left of the rectangle
     * @param {number} width - The width of the rectangle
     * @param {number} height - The height of the rectangle
     * @param {number} radius - Radius of the rectangle corners
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */


    Graphics.prototype.drawRoundedRect = function drawRoundedRect(x, y, width, height, radius) {
        this.drawShape(new _math.RoundedRectangle(x, y, width, height, radius));

        return this;
    };

    /**
     * Draws a circle.
     *
     * @param {number} x - The X coordinate of the center of the circle
     * @param {number} y - The Y coordinate of the center of the circle
     * @param {number} radius - The radius of the circle
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */


    Graphics.prototype.drawCircle = function drawCircle(x, y, radius) {
        this.drawShape(new _math.Circle(x, y, radius));

        return this;
    };

    /**
     * Draws an ellipse.
     *
     * @param {number} x - The X coordinate of the center of the ellipse
     * @param {number} y - The Y coordinate of the center of the ellipse
     * @param {number} width - The half width of the ellipse
     * @param {number} height - The half height of the ellipse
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */


    Graphics.prototype.drawEllipse = function drawEllipse(x, y, width, height) {
        this.drawShape(new _math.Ellipse(x, y, width, height));

        return this;
    };

    /**
     * Draws a polygon using the given path.
     *
     * @param {number[]|PIXI.Point[]|PIXI.Polygon} path - The path data used to construct the polygon.
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */


    Graphics.prototype.drawPolygon = function drawPolygon(path) {
        // prevents an argument assignment deopt
        // see section 3.1: https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#3-managing-arguments
        var points = path;

        var closed = true;

        if (points instanceof _math.Polygon) {
            closed = points.closed;
            points = points.points;
        }

        if (!Array.isArray(points)) {
            // prevents an argument leak deopt
            // see section 3.2: https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#3-managing-arguments
            points = new Array(arguments.length);

            for (var i = 0; i < points.length; ++i) {
                points[i] = arguments[i]; // eslint-disable-line prefer-rest-params
            }
        }

        var shape = new _math.Polygon(points);

        shape.closed = closed;

        this.drawShape(shape);

        return this;
    };

    /**
     * Draw a star shape with an abitrary number of points.
     *
     * @param {number} x - Center X position of the star
     * @param {number} y - Center Y position of the star
     * @param {number} points - The number of points of the star, must be > 1
     * @param {number} radius - The outer radius of the star
     * @param {number} [innerRadius] - The inner radius between points, default half `radius`
     * @param {number} [rotation=0] - The rotation of the star in radians, where 0 is vertical
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */


    Graphics.prototype.drawStar = function drawStar(x, y, points, radius, innerRadius) {
        var rotation = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

        innerRadius = innerRadius || radius / 2;

        var startAngle = -1 * Math.PI / 2 + rotation;
        var len = points * 2;
        var delta = _const.PI_2 / len;
        var polygon = [];

        for (var i = 0; i < len; i++) {
            var r = i % 2 ? innerRadius : radius;
            var angle = i * delta + startAngle;

            polygon.push(x + r * Math.cos(angle), y + r * Math.sin(angle));
        }

        return this.drawPolygon(polygon);
    };

    /**
     * Clears the graphics that were drawn to this Graphics object, and resets fill and line style settings.
     *
     * @return {PIXI.Graphics} This Graphics object. Good for chaining method calls
     */


    Graphics.prototype.clear = function clear() {
        if (this.lineWidth || this.filling || this.graphicsData.length > 0) {
            this.lineWidth = 0;
            this.lineAlignment = 0.5;

            this.filling = false;

            this.boundsDirty = -1;
            this.canvasTintDirty = -1;
            this.dirty++;
            this.clearDirty++;
            this.graphicsData.length = 0;
        }

        this.currentPath = null;
        this._spriteRect = null;

        return this;
    };

    /**
     * True if graphics consists of one rectangle, and thus, can be drawn like a Sprite and
     * masked with gl.scissor.
     *
     * @returns {boolean} True if only 1 rect.
     */


    Graphics.prototype.isFastRect = function isFastRect() {
        return this.graphicsData.length === 1 && this.graphicsData[0].shape.type === _const.SHAPES.RECT && !this.graphicsData[0].lineWidth;
    };

    /**
     * Renders the object using the WebGL renderer
     *
     * @private
     * @param {PIXI.WebGLRenderer} renderer - The renderer
     */


    Graphics.prototype._renderWebGL = function _renderWebGL(renderer) {
        // if the sprite is not visible or the alpha is 0 then no need to render this element
        if (this.dirty !== this.fastRectDirty) {
            this.fastRectDirty = this.dirty;
            this._fastRect = this.isFastRect();
        }

        // TODO this check can be moved to dirty?
        if (this._fastRect) {
            this._renderSpriteRect(renderer);
        } else {
            renderer.setObjectRenderer(renderer.plugins.graphics);
            renderer.plugins.graphics.render(this);
        }
    };

    /**
     * Renders a sprite rectangle.
     *
     * @private
     * @param {PIXI.WebGLRenderer} renderer - The renderer
     */


    Graphics.prototype._renderSpriteRect = function _renderSpriteRect(renderer) {
        var rect = this.graphicsData[0].shape;

        if (!this._spriteRect) {
            this._spriteRect = new _Sprite2.default(new _Texture2.default(_Texture2.default.WHITE));
        }

        var sprite = this._spriteRect;
        var fillColor = this.graphicsData[0].fillColor;

        if (this.tint === 0xffffff) {
            sprite.tint = fillColor;
        } else if (this.tint !== this._prevRectTint || fillColor !== this._prevRectFillColor) {
            var t1 = tempColor1;
            var t2 = tempColor2;

            (0, _utils.hex2rgb)(fillColor, t1);
            (0, _utils.hex2rgb)(this.tint, t2);

            t1[0] *= t2[0];
            t1[1] *= t2[1];
            t1[2] *= t2[2];

            sprite.tint = (0, _utils.rgb2hex)(t1);

            this._prevRectTint = this.tint;
            this._prevRectFillColor = fillColor;
        }

        sprite.alpha = this.graphicsData[0].fillAlpha;
        sprite.worldAlpha = this.worldAlpha * sprite.alpha;
        sprite.blendMode = this.blendMode;

        sprite._texture._frame.width = rect.width;
        sprite._texture._frame.height = rect.height;

        sprite.transform.worldTransform = this.transform.worldTransform;

        sprite.anchor.set(-rect.x / rect.width, -rect.y / rect.height);
        sprite._onAnchorUpdate();

        sprite._renderWebGL(renderer);
    };

    /**
     * Renders the object using the Canvas renderer
     *
     * @private
     * @param {PIXI.CanvasRenderer} renderer - The renderer
     */


    Graphics.prototype._renderCanvas = function _renderCanvas(renderer) {
        if (this.isMask === true) {
            return;
        }

        renderer.plugins.graphics.render(this);
    };

    /**
     * Retrieves the bounds of the graphic shape as a rectangle object
     *
     * @private
     */


    Graphics.prototype._calculateBounds = function _calculateBounds() {
        if (this.boundsDirty !== this.dirty) {
            this.boundsDirty = this.dirty;
            this.updateLocalBounds();

            this.cachedSpriteDirty = true;
        }

        var lb = this._localBounds;

        this._bounds.addFrame(this.transform, lb.minX, lb.minY, lb.maxX, lb.maxY);
    };

    /**
     * Tests if a point is inside this graphics object
     *
     * @param {PIXI.Point} point - the point to test
     * @return {boolean} the result of the test
     */


    Graphics.prototype.containsPoint = function containsPoint(point) {
        this.worldTransform.applyInverse(point, tempPoint);

        var graphicsData = this.graphicsData;

        for (var i = 0; i < graphicsData.length; ++i) {
            var data = graphicsData[i];

            if (!data.fill) {
                continue;
            }

            // only deal with fills..
            if (data.shape) {
                if (data.shape.contains(tempPoint.x, tempPoint.y)) {
                    var hitHole = false;

                    if (data.holes) {
                        for (var _i = 0; _i < data.holes.length; _i++) {
                            var hole = data.holes[_i];

                            if (hole.contains(tempPoint.x, tempPoint.y)) {
                                hitHole = true;
                                break;
                            }
                        }
                    }

                    if (!hitHole) {
                        return true;
                    }
                }
            }
        }

        return false;
    };

    /**
     * Update the bounds of the object
     *
     */


    Graphics.prototype.updateLocalBounds = function updateLocalBounds() {
        var minX = Infinity;
        var maxX = -Infinity;

        var minY = Infinity;
        var maxY = -Infinity;

        if (this.graphicsData.length) {
            var shape = 0;
            var x = 0;
            var y = 0;
            var w = 0;
            var h = 0;

            for (var i = 0; i < this.graphicsData.length; i++) {
                var data = this.graphicsData[i];
                var type = data.type;
                var lineWidth = data.lineWidth;
                var lineAlignment = data.lineAlignment;

                var lineOffset = lineWidth * lineAlignment;

                shape = data.shape;

                if (type === _const.SHAPES.RECT || type === _const.SHAPES.RREC) {
                    x = shape.x - lineOffset;
                    y = shape.y - lineOffset;
                    w = shape.width + lineOffset * 2;
                    h = shape.height + lineOffset * 2;

                    minX = x < minX ? x : minX;
                    maxX = x + w > maxX ? x + w : maxX;

                    minY = y < minY ? y : minY;
                    maxY = y + h > maxY ? y + h : maxY;
                } else if (type === _const.SHAPES.CIRC) {
                    x = shape.x;
                    y = shape.y;
                    w = shape.radius + lineOffset;
                    h = shape.radius + lineOffset;

                    minX = x - w < minX ? x - w : minX;
                    maxX = x + w > maxX ? x + w : maxX;

                    minY = y - h < minY ? y - h : minY;
                    maxY = y + h > maxY ? y + h : maxY;
                } else if (type === _const.SHAPES.ELIP) {
                    x = shape.x;
                    y = shape.y;
                    w = shape.width + lineOffset;
                    h = shape.height + lineOffset;

                    minX = x - w < minX ? x - w : minX;
                    maxX = x + w > maxX ? x + w : maxX;

                    minY = y - h < minY ? y - h : minY;
                    maxY = y + h > maxY ? y + h : maxY;
                } else {
                    // POLY
                    var points = shape.points;
                    var x2 = 0;
                    var y2 = 0;
                    var dx = 0;
                    var dy = 0;
                    var rw = 0;
                    var rh = 0;
                    var cx = 0;
                    var cy = 0;

                    for (var j = 0; j + 2 < points.length; j += 2) {
                        x = points[j];
                        y = points[j + 1];
                        x2 = points[j + 2];
                        y2 = points[j + 3];
                        dx = Math.abs(x2 - x);
                        dy = Math.abs(y2 - y);
                        h = lineOffset * 2;
                        w = Math.sqrt(dx * dx + dy * dy);

                        if (w < 1e-9) {
                            continue;
                        }

                        rw = (h / w * dy + dx) / 2;
                        rh = (h / w * dx + dy) / 2;
                        cx = (x2 + x) / 2;
                        cy = (y2 + y) / 2;

                        minX = cx - rw < minX ? cx - rw : minX;
                        maxX = cx + rw > maxX ? cx + rw : maxX;

                        minY = cy - rh < minY ? cy - rh : minY;
                        maxY = cy + rh > maxY ? cy + rh : maxY;
                    }
                }
            }
        } else {
            minX = 0;
            maxX = 0;
            minY = 0;
            maxY = 0;
        }

        var padding = this.boundsPadding;

        this._localBounds.minX = minX - padding;
        this._localBounds.maxX = maxX + padding;

        this._localBounds.minY = minY - padding;
        this._localBounds.maxY = maxY + padding;
    };

    /**
     * Draws the given shape to this Graphics object. Can be any of Circle, Rectangle, Ellipse, Line or Polygon.
     *
     * @param {PIXI.Circle|PIXI.Ellipse|PIXI.Polygon|PIXI.Rectangle|PIXI.RoundedRectangle} shape - The shape object to draw.
     * @return {PIXI.GraphicsData} The generated GraphicsData object.
     */


    Graphics.prototype.drawShape = function drawShape(shape) {
        if (this.currentPath) {
            // check current path!
            if (this.currentPath.shape.points.length <= 2) {
                this.graphicsData.pop();
            }
        }

        this.currentPath = null;

        var data = new _GraphicsData2.default(this.lineWidth, this.lineColor, this.lineAlpha, this.fillColor, this.fillAlpha, this.filling, this.nativeLines, shape, this.lineAlignment);

        this.graphicsData.push(data);

        if (data.type === _const.SHAPES.POLY) {
            data.shape.closed = data.shape.closed;
            this.currentPath = data;
        }

        this.dirty++;

        return data;
    };

    /**
     * Generates a canvas texture.
     *
     * @param {number} scaleMode - The scale mode of the texture.
     * @param {number} resolution - The resolution of the texture.
     * @return {PIXI.Texture} The new texture.
     */


    Graphics.prototype.generateCanvasTexture = function generateCanvasTexture(scaleMode) {
        var resolution = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

        var bounds = this.getLocalBounds();

        var canvasBuffer = _RenderTexture2.default.create(bounds.width, bounds.height, scaleMode, resolution);

        if (!canvasRenderer) {
            canvasRenderer = new _CanvasRenderer2.default();
        }

        this.transform.updateLocalTransform();
        this.transform.localTransform.copy(tempMatrix);

        tempMatrix.invert();

        tempMatrix.tx -= bounds.x;
        tempMatrix.ty -= bounds.y;

        canvasRenderer.render(this, canvasBuffer, true, tempMatrix);

        var texture = _Texture2.default.fromCanvas(canvasBuffer.baseTexture._canvasRenderTarget.canvas, scaleMode, 'graphics');

        texture.baseTexture.resolution = resolution;
        texture.baseTexture.update();

        return texture;
    };

    /**
     * Closes the current path.
     *
     * @return {PIXI.Graphics} Returns itself.
     */


    Graphics.prototype.closePath = function closePath() {
        // ok so close path assumes next one is a hole!
        var currentPath = this.currentPath;

        if (currentPath && currentPath.shape) {
            currentPath.shape.close();
        }

        return this;
    };

    /**
     * Adds a hole in the current path.
     *
     * @return {PIXI.Graphics} Returns itself.
     */


    Graphics.prototype.addHole = function addHole() {
        // this is a hole!
        var hole = this.graphicsData.pop();

        this.currentPath = this.graphicsData[this.graphicsData.length - 1];

        this.currentPath.addHole(hole.shape);
        this.currentPath = null;

        return this;
    };

    /**
     * Destroys the Graphics object.
     *
     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all
     *  options have been set to that value
     * @param {boolean} [options.children=false] - if set to true, all the children will have
     *  their destroy method called as well. 'options' will be passed on to those calls.
     * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
     *  Should it destroy the texture of the child sprite
     * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
     *  Should it destroy the base texture of the child sprite
     */


    Graphics.prototype.destroy = function destroy(options) {
        _Container.prototype.destroy.call(this, options);

        // destroy each of the GraphicsData objects
        for (var i = 0; i < this.graphicsData.length; ++i) {
            this.graphicsData[i].destroy();
        }

        // for each webgl data entry, destroy the WebGLGraphicsData
        for (var id in this._webGL) {
            for (var j = 0; j < this._webGL[id].data.length; ++j) {
                this._webGL[id].data[j].destroy();
            }
        }

        if (this._spriteRect) {
            this._spriteRect.destroy();
        }

        this.graphicsData = null;

        this.currentPath = null;
        this._webGL = null;
        this._localBounds = null;
    };

    return Graphics;
}(_Container3.default);

exports.default = Graphics;


Graphics._SPRITE_TEXTURE = null;

/**
 * Graphics curves resolution settings. If `adaptive` flag is set to `true`,
 * the resolution is calculated based on the curve's length to ensure better visual quality.
 * Adaptive draw works with `bezierCurveTo` and `quadraticCurveTo`.
 *
 * @static
 * @constant
 * @memberof PIXI.Graphics
 * @name CURVES
 * @type {object}
 * @property {boolean} adaptive=false - flag indicating if the resolution should be adaptive
 * @property {number} maxLength=10 - maximal length of a single segment of the curve (if adaptive = false, ignored)
 * @property {number} minSegments=8 - minimal number of segments in the curve (if adaptive = false, ignored)
 * @property {number} maxSegments=2048 - maximal number of segments in the curve (if adaptive = false, ignored)
 */
Graphics.CURVES = {
    adaptive: false,
    maxLength: 10,
    minSegments: 8,
    maxSegments: 2048
};
//# sourceMappingURL=Graphics.js.map

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = bezierCurveTo;
/**
 * Calculate the points for a bezier curve and then draws it.
 *
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @param {number} fromX - Starting point x
 * @param {number} fromY - Starting point y
 * @param {number} cpX - Control point x
 * @param {number} cpY - Control point y
 * @param {number} cpX2 - Second Control point x
 * @param {number} cpY2 - Second Control point y
 * @param {number} toX - Destination point x
 * @param {number} toY - Destination point y
 * @param {number} n - Number of segments approximating the bezier curve
 * @param {number[]} [path=[]] - Path array to push points into
 * @return {number[]} Array of points of the curve
 */
function bezierCurveTo(fromX, fromY, cpX, cpY, cpX2, cpY2, toX, toY, n) {
    var path = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : [];

    var dt = 0;
    var dt2 = 0;
    var dt3 = 0;
    var t2 = 0;
    var t3 = 0;

    path.push(fromX, fromY);

    for (var i = 1, j = 0; i <= n; ++i) {
        j = i / n;

        dt = 1 - j;
        dt2 = dt * dt;
        dt3 = dt2 * dt;

        t2 = j * j;
        t3 = t2 * j;

        path.push(dt3 * fromX + 3 * dt2 * j * cpX + 3 * dt * t2 * cpX2 + t3 * toX, dt3 * fromY + 3 * dt2 * j * cpY + 3 * dt * t2 * cpY2 + t3 * toY);
    }

    return path;
}
//# sourceMappingURL=bezierCurveTo.js.map

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _utils = __webpack_require__(9);

var _const = __webpack_require__(5);

var _ObjectRenderer2 = __webpack_require__(102);

var _ObjectRenderer3 = _interopRequireDefault(_ObjectRenderer2);

var _WebGLRenderer = __webpack_require__(103);

var _WebGLRenderer2 = _interopRequireDefault(_WebGLRenderer);

var _WebGLGraphicsData = __webpack_require__(391);

var _WebGLGraphicsData2 = _interopRequireDefault(_WebGLGraphicsData);

var _PrimitiveShader = __webpack_require__(392);

var _PrimitiveShader2 = _interopRequireDefault(_PrimitiveShader);

var _buildPoly = __webpack_require__(393);

var _buildPoly2 = _interopRequireDefault(_buildPoly);

var _buildRectangle = __webpack_require__(394);

var _buildRectangle2 = _interopRequireDefault(_buildRectangle);

var _buildRoundedRectangle = __webpack_require__(395);

var _buildRoundedRectangle2 = _interopRequireDefault(_buildRoundedRectangle);

var _buildCircle = __webpack_require__(396);

var _buildCircle2 = _interopRequireDefault(_buildCircle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Renders the graphics object.
 *
 * @class
 * @memberof PIXI
 * @extends PIXI.ObjectRenderer
 */
var GraphicsRenderer = function (_ObjectRenderer) {
    _inherits(GraphicsRenderer, _ObjectRenderer);

    /**
     * @param {PIXI.WebGLRenderer} renderer - The renderer this object renderer works for.
     */
    function GraphicsRenderer(renderer) {
        _classCallCheck(this, GraphicsRenderer);

        var _this = _possibleConstructorReturn(this, _ObjectRenderer.call(this, renderer));

        _this.graphicsDataPool = [];

        _this.primitiveShader = null;

        _this.gl = renderer.gl;

        // easy access!
        _this.CONTEXT_UID = 0;
        return _this;
    }

    /**
     * Called when there is a WebGL context change
     *
     * @private
     *
     */


    GraphicsRenderer.prototype.onContextChange = function onContextChange() {
        this.gl = this.renderer.gl;
        this.CONTEXT_UID = this.renderer.CONTEXT_UID;
        this.primitiveShader = new _PrimitiveShader2.default(this.gl);
    };

    /**
     * Destroys this renderer.
     *
     */


    GraphicsRenderer.prototype.destroy = function destroy() {
        _ObjectRenderer3.default.prototype.destroy.call(this);

        for (var i = 0; i < this.graphicsDataPool.length; ++i) {
            this.graphicsDataPool[i].destroy();
        }

        this.graphicsDataPool = null;
    };

    /**
     * Renders a graphics object.
     *
     * @param {PIXI.Graphics} graphics - The graphics object to render.
     */


    GraphicsRenderer.prototype.render = function render(graphics) {
        var renderer = this.renderer;
        var gl = renderer.gl;

        var webGLData = void 0;
        var webGL = graphics._webGL[this.CONTEXT_UID];

        if (!webGL || graphics.dirty !== webGL.dirty) {
            this.updateGraphics(graphics);

            webGL = graphics._webGL[this.CONTEXT_UID];
        }

        // This  could be speeded up for sure!
        var shader = this.primitiveShader;

        renderer.bindShader(shader);
        renderer.state.setBlendMode(graphics.blendMode);

        for (var i = 0, n = webGL.data.length; i < n; i++) {
            webGLData = webGL.data[i];
            var shaderTemp = webGLData.shader;

            renderer.bindShader(shaderTemp);
            shaderTemp.uniforms.translationMatrix = graphics.transform.worldTransform.toArray(true);
            shaderTemp.uniforms.tint = (0, _utils.hex2rgb)(graphics.tint);
            shaderTemp.uniforms.alpha = graphics.worldAlpha;

            renderer.bindVao(webGLData.vao);

            if (webGLData.nativeLines) {
                gl.drawArrays(gl.LINES, 0, webGLData.points.length / 6);
            } else {
                webGLData.vao.draw(gl.TRIANGLE_STRIP, webGLData.indices.length);
            }
        }
    };

    /**
     * Updates the graphics object
     *
     * @private
     * @param {PIXI.Graphics} graphics - The graphics object to update
     */


    GraphicsRenderer.prototype.updateGraphics = function updateGraphics(graphics) {
        var gl = this.renderer.gl;

        // get the contexts graphics object
        var webGL = graphics._webGL[this.CONTEXT_UID];

        // if the graphics object does not exist in the webGL context time to create it!
        if (!webGL) {
            webGL = graphics._webGL[this.CONTEXT_UID] = { lastIndex: 0, data: [], gl: gl, clearDirty: -1, dirty: -1 };
        }

        // flag the graphics as not dirty as we are about to update it...
        webGL.dirty = graphics.dirty;

        // if the user cleared the graphics object we will need to clear every object
        if (graphics.clearDirty !== webGL.clearDirty) {
            webGL.clearDirty = graphics.clearDirty;

            // loop through and return all the webGLDatas to the object pool so than can be reused later on
            for (var i = 0; i < webGL.data.length; i++) {
                this.graphicsDataPool.push(webGL.data[i]);
            }

            // clear the array and reset the index..
            webGL.data.length = 0;
            webGL.lastIndex = 0;
        }

        var webGLData = void 0;
        var webGLDataNativeLines = void 0;

        // loop through the graphics datas and construct each one..
        // if the object is a complex fill then the new stencil buffer technique will be used
        // other wise graphics objects will be pushed into a batch..
        for (var _i = webGL.lastIndex; _i < graphics.graphicsData.length; _i++) {
            var data = graphics.graphicsData[_i];

            // TODO - this can be simplified
            webGLData = this.getWebGLData(webGL, 0);

            if (data.nativeLines && data.lineWidth) {
                webGLDataNativeLines = this.getWebGLData(webGL, 0, true);
                webGL.lastIndex++;
            }

            if (data.type === _const.SHAPES.POLY) {
                (0, _buildPoly2.default)(data, webGLData, webGLDataNativeLines);
            }
            if (data.type === _const.SHAPES.RECT) {
                (0, _buildRectangle2.default)(data, webGLData, webGLDataNativeLines);
            } else if (data.type === _const.SHAPES.CIRC || data.type === _const.SHAPES.ELIP) {
                (0, _buildCircle2.default)(data, webGLData, webGLDataNativeLines);
            } else if (data.type === _const.SHAPES.RREC) {
                (0, _buildRoundedRectangle2.default)(data, webGLData, webGLDataNativeLines);
            }

            webGL.lastIndex++;
        }

        this.renderer.bindVao(null);

        // upload all the dirty data...
        for (var _i2 = 0; _i2 < webGL.data.length; _i2++) {
            webGLData = webGL.data[_i2];

            if (webGLData.dirty) {
                webGLData.upload();
            }
        }
    };

    /**
     *
     * @private
     * @param {WebGLRenderingContext} gl - the current WebGL drawing context
     * @param {number} type - TODO @Alvin
     * @param {number} nativeLines - indicate whether the webGLData use for nativeLines.
     * @return {*} TODO
     */


    GraphicsRenderer.prototype.getWebGLData = function getWebGLData(gl, type, nativeLines) {
        var webGLData = gl.data[gl.data.length - 1];

        if (!webGLData || webGLData.nativeLines !== nativeLines || webGLData.points.length > 320000) {
            webGLData = this.graphicsDataPool.pop() || new _WebGLGraphicsData2.default(this.renderer.gl, this.primitiveShader, this.renderer.state.attribsState);
            webGLData.nativeLines = nativeLines;
            webGLData.reset(type);
            gl.data.push(webGLData);
        }

        webGLData.dirty = true;

        return webGLData;
    };

    return GraphicsRenderer;
}(_ObjectRenderer3.default);

exports.default = GraphicsRenderer;


_WebGLRenderer2.default.registerPlugin('graphics', GraphicsRenderer);
//# sourceMappingURL=GraphicsRenderer.js.map

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _pixiGlCore = __webpack_require__(31);

var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * An object containing WebGL specific properties to be used by the WebGL renderer
 *
 * @class
 * @private
 * @memberof PIXI
 */
var WebGLGraphicsData = function () {
  /**
   * @param {WebGLRenderingContext} gl - The current WebGL drawing context
   * @param {PIXI.Shader} shader - The shader
   * @param {object} attribsState - The state for the VAO
   */
  function WebGLGraphicsData(gl, shader, attribsState) {
    _classCallCheck(this, WebGLGraphicsData);

    /**
     * The current WebGL drawing context
     *
     * @member {WebGLRenderingContext}
     */
    this.gl = gl;

    // TODO does this need to be split before uploading??
    /**
     * An array of color components (r,g,b)
     * @member {number[]}
     */
    this.color = [0, 0, 0]; // color split!

    /**
     * An array of points to draw
     * @member {PIXI.Point[]}
     */
    this.points = [];

    /**
     * The indices of the vertices
     * @member {number[]}
     */
    this.indices = [];
    /**
     * The main buffer
     * @member {WebGLBuffer}
     */
    this.buffer = _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl);

    /**
     * The index buffer
     * @member {WebGLBuffer}
     */
    this.indexBuffer = _pixiGlCore2.default.GLBuffer.createIndexBuffer(gl);

    /**
     * Whether this graphics is dirty or not
     * @member {boolean}
     */
    this.dirty = true;

    /**
     * Whether this graphics is nativeLines or not
     * @member {boolean}
     */
    this.nativeLines = false;

    this.glPoints = null;
    this.glIndices = null;

    /**
     *
     * @member {PIXI.Shader}
     */
    this.shader = shader;

    this.vao = new _pixiGlCore2.default.VertexArrayObject(gl, attribsState).addIndex(this.indexBuffer).addAttribute(this.buffer, shader.attributes.aVertexPosition, gl.FLOAT, false, 4 * 6, 0).addAttribute(this.buffer, shader.attributes.aColor, gl.FLOAT, false, 4 * 6, 2 * 4);
  }

  /**
   * Resets the vertices and the indices
   */


  WebGLGraphicsData.prototype.reset = function reset() {
    this.points.length = 0;
    this.indices.length = 0;
  };

  /**
   * Binds the buffers and uploads the data
   */


  WebGLGraphicsData.prototype.upload = function upload() {
    this.glPoints = new Float32Array(this.points);
    this.buffer.upload(this.glPoints);

    this.glIndices = new Uint16Array(this.indices);
    this.indexBuffer.upload(this.glIndices);

    this.dirty = false;
  };

  /**
   * Empties all the data
   */


  WebGLGraphicsData.prototype.destroy = function destroy() {
    this.color = null;
    this.points = null;
    this.indices = null;

    this.vao.destroy();
    this.buffer.destroy();
    this.indexBuffer.destroy();

    this.gl = null;

    this.buffer = null;
    this.indexBuffer = null;

    this.glPoints = null;
    this.glIndices = null;
  };

  return WebGLGraphicsData;
}();

exports.default = WebGLGraphicsData;
//# sourceMappingURL=WebGLGraphicsData.js.map

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _Shader2 = __webpack_require__(86);

var _Shader3 = _interopRequireDefault(_Shader2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * This shader is used to draw simple primitive shapes for {@link PIXI.Graphics}.
 *
 * @class
 * @memberof PIXI
 * @extends PIXI.Shader
 */
var PrimitiveShader = function (_Shader) {
    _inherits(PrimitiveShader, _Shader);

    /**
     * @param {WebGLRenderingContext} gl - The webgl shader manager this shader works for.
     */
    function PrimitiveShader(gl) {
        _classCallCheck(this, PrimitiveShader);

        return _possibleConstructorReturn(this, _Shader.call(this, gl,
        // vertex shader
        ['attribute vec2 aVertexPosition;', 'attribute vec4 aColor;', 'uniform mat3 translationMatrix;', 'uniform mat3 projectionMatrix;', 'uniform float alpha;', 'uniform vec3 tint;', 'varying vec4 vColor;', 'void main(void){', '   gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);', '   vColor = aColor * vec4(tint * alpha, alpha);', '}'].join('\n'),
        // fragment shader
        ['varying vec4 vColor;', 'void main(void){', '   gl_FragColor = vColor;', '}'].join('\n')));
    }

    return PrimitiveShader;
}(_Shader3.default);

exports.default = PrimitiveShader;
//# sourceMappingURL=PrimitiveShader.js.map

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = buildPoly;

var _buildLine = __webpack_require__(105);

var _buildLine2 = _interopRequireDefault(_buildLine);

var _utils = __webpack_require__(9);

var _earcut = __webpack_require__(130);

var _earcut2 = _interopRequireDefault(_earcut);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Builds a polygon to draw
 *
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
 * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
 * @param {object} webGLDataNativeLines - an object containing all the webGL-specific information to create nativeLines
 */
function buildPoly(graphicsData, webGLData, webGLDataNativeLines) {
    graphicsData.points = graphicsData.shape.points.slice();

    var points = graphicsData.points;

    if (graphicsData.fill && points.length >= 6) {
        var holeArray = [];
        // Process holes..
        var holes = graphicsData.holes;

        for (var i = 0; i < holes.length; i++) {
            var hole = holes[i];

            holeArray.push(points.length / 2);

            points = points.concat(hole.points);
        }

        // get first and last point.. figure out the middle!
        var verts = webGLData.points;
        var indices = webGLData.indices;

        var length = points.length / 2;

        // sort color
        var color = (0, _utils.hex2rgb)(graphicsData.fillColor);
        var alpha = graphicsData.fillAlpha;
        var r = color[0] * alpha;
        var g = color[1] * alpha;
        var b = color[2] * alpha;

        var triangles = (0, _earcut2.default)(points, holeArray, 2);

        if (!triangles) {
            return;
        }

        var vertPos = verts.length / 6;

        for (var _i = 0; _i < triangles.length; _i += 3) {
            indices.push(triangles[_i] + vertPos);
            indices.push(triangles[_i] + vertPos);
            indices.push(triangles[_i + 1] + vertPos);
            indices.push(triangles[_i + 2] + vertPos);
            indices.push(triangles[_i + 2] + vertPos);
        }

        for (var _i2 = 0; _i2 < length; _i2++) {
            verts.push(points[_i2 * 2], points[_i2 * 2 + 1], r, g, b, alpha);
        }
    }

    if (graphicsData.lineWidth > 0) {
        (0, _buildLine2.default)(graphicsData, webGLData, webGLDataNativeLines);
    }
}
//# sourceMappingURL=buildPoly.js.map

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = buildRectangle;

var _buildLine = __webpack_require__(105);

var _buildLine2 = _interopRequireDefault(_buildLine);

var _utils = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Builds a rectangle to draw
 *
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
 * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
 * @param {object} webGLDataNativeLines - an object containing all the webGL-specific information to create nativeLines
 */
function buildRectangle(graphicsData, webGLData, webGLDataNativeLines) {
    // --- //
    // need to convert points to a nice regular data
    //
    var rectData = graphicsData.shape;
    var x = rectData.x;
    var y = rectData.y;
    var width = rectData.width;
    var height = rectData.height;

    if (graphicsData.fill) {
        var color = (0, _utils.hex2rgb)(graphicsData.fillColor);
        var alpha = graphicsData.fillAlpha;

        var r = color[0] * alpha;
        var g = color[1] * alpha;
        var b = color[2] * alpha;

        var verts = webGLData.points;
        var indices = webGLData.indices;

        var vertPos = verts.length / 6;

        // start
        verts.push(x, y);
        verts.push(r, g, b, alpha);

        verts.push(x + width, y);
        verts.push(r, g, b, alpha);

        verts.push(x, y + height);
        verts.push(r, g, b, alpha);

        verts.push(x + width, y + height);
        verts.push(r, g, b, alpha);

        // insert 2 dead triangles..
        indices.push(vertPos, vertPos, vertPos + 1, vertPos + 2, vertPos + 3, vertPos + 3);
    }

    if (graphicsData.lineWidth) {
        var tempPoints = graphicsData.points;

        graphicsData.points = [x, y, x + width, y, x + width, y + height, x, y + height, x, y];

        (0, _buildLine2.default)(graphicsData, webGLData, webGLDataNativeLines);

        graphicsData.points = tempPoints;
    }
}
//# sourceMappingURL=buildRectangle.js.map

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = buildRoundedRectangle;

var _earcut = __webpack_require__(130);

var _earcut2 = _interopRequireDefault(_earcut);

var _buildLine = __webpack_require__(105);

var _buildLine2 = _interopRequireDefault(_buildLine);

var _utils = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Builds a rounded rectangle to draw
 *
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object containing all the necessary properties
 * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
 * @param {object} webGLDataNativeLines - an object containing all the webGL-specific information to create nativeLines
 */
function buildRoundedRectangle(graphicsData, webGLData, webGLDataNativeLines) {
    var rrectData = graphicsData.shape;
    var x = rrectData.x;
    var y = rrectData.y;
    var width = rrectData.width;
    var height = rrectData.height;

    var radius = rrectData.radius;

    var recPoints = [];

    recPoints.push(x + radius, y);
    quadraticBezierCurve(x + width - radius, y, x + width, y, x + width, y + radius, recPoints);
    quadraticBezierCurve(x + width, y + height - radius, x + width, y + height, x + width - radius, y + height, recPoints);
    quadraticBezierCurve(x + radius, y + height, x, y + height, x, y + height - radius, recPoints);
    quadraticBezierCurve(x, y + radius, x, y, x + radius + 0.0000000001, y, recPoints);

    // this tiny number deals with the issue that occurs when points overlap and earcut fails to triangulate the item.
    // TODO - fix this properly, this is not very elegant.. but it works for now.

    if (graphicsData.fill) {
        var color = (0, _utils.hex2rgb)(graphicsData.fillColor);
        var alpha = graphicsData.fillAlpha;

        var r = color[0] * alpha;
        var g = color[1] * alpha;
        var b = color[2] * alpha;

        var verts = webGLData.points;
        var indices = webGLData.indices;

        var vecPos = verts.length / 6;

        var triangles = (0, _earcut2.default)(recPoints, null, 2);

        for (var i = 0, j = triangles.length; i < j; i += 3) {
            indices.push(triangles[i] + vecPos);
            indices.push(triangles[i] + vecPos);
            indices.push(triangles[i + 1] + vecPos);
            indices.push(triangles[i + 2] + vecPos);
            indices.push(triangles[i + 2] + vecPos);
        }

        for (var _i = 0, _j = recPoints.length; _i < _j; _i++) {
            verts.push(recPoints[_i], recPoints[++_i], r, g, b, alpha);
        }
    }

    if (graphicsData.lineWidth) {
        var tempPoints = graphicsData.points;

        graphicsData.points = recPoints;

        (0, _buildLine2.default)(graphicsData, webGLData, webGLDataNativeLines);

        graphicsData.points = tempPoints;
    }
}

/**
 * Calculate a single point for a quadratic bezier curve.
 * Utility function used by quadraticBezierCurve.
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {number} n1 - first number
 * @param {number} n2 - second number
 * @param {number} perc - percentage
 * @return {number} the result
 *
 */
function getPt(n1, n2, perc) {
    var diff = n2 - n1;

    return n1 + diff * perc;
}

/**
 * Calculate the points for a quadratic bezier curve. (helper function..)
 * Based on: https://stackoverflow.com/questions/785097/how-do-i-implement-a-bezier-curve-in-c
 *
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {number} fromX - Origin point x
 * @param {number} fromY - Origin point x
 * @param {number} cpX - Control point x
 * @param {number} cpY - Control point y
 * @param {number} toX - Destination point x
 * @param {number} toY - Destination point y
 * @param {number[]} [out=[]] - The output array to add points into. If not passed, a new array is created.
 * @return {number[]} an array of points
 */
function quadraticBezierCurve(fromX, fromY, cpX, cpY, toX, toY) {
    var out = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];

    var n = 20;
    var points = out;

    var xa = 0;
    var ya = 0;
    var xb = 0;
    var yb = 0;
    var x = 0;
    var y = 0;

    for (var i = 0, j = 0; i <= n; ++i) {
        j = i / n;

        // The Green Line
        xa = getPt(fromX, cpX, j);
        ya = getPt(fromY, cpY, j);
        xb = getPt(cpX, toX, j);
        yb = getPt(cpY, toY, j);

        // The Black Dot
        x = getPt(xa, xb, j);
        y = getPt(ya, yb, j);

        points.push(x, y);
    }

    return points;
}
//# sourceMappingURL=buildRoundedRectangle.js.map

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = buildCircle;

var _buildLine = __webpack_require__(105);

var _buildLine2 = _interopRequireDefault(_buildLine);

var _const = __webpack_require__(5);

var _utils = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Builds a circle to draw
 *
 * Ignored from docs since it is not directly exposed.
 *
 * @ignore
 * @private
 * @param {PIXI.WebGLGraphicsData} graphicsData - The graphics object to draw
 * @param {object} webGLData - an object containing all the webGL-specific information to create this shape
 * @param {object} webGLDataNativeLines - an object containing all the webGL-specific information to create nativeLines
 */
function buildCircle(graphicsData, webGLData, webGLDataNativeLines) {
    // need to convert points to a nice regular data
    var circleData = graphicsData.shape;
    var x = circleData.x;
    var y = circleData.y;
    var width = void 0;
    var height = void 0;

    // TODO - bit hacky??
    if (graphicsData.type === _const.SHAPES.CIRC) {
        width = circleData.radius;
        height = circleData.radius;
    } else {
        width = circleData.width;
        height = circleData.height;
    }

    if (width === 0 || height === 0) {
        return;
    }

    var totalSegs = Math.floor(30 * Math.sqrt(circleData.radius)) || Math.floor(15 * Math.sqrt(circleData.width + circleData.height));

    var seg = Math.PI * 2 / totalSegs;

    if (graphicsData.fill) {
        var color = (0, _utils.hex2rgb)(graphicsData.fillColor);
        var alpha = graphicsData.fillAlpha;

        var r = color[0] * alpha;
        var g = color[1] * alpha;
        var b = color[2] * alpha;

        var verts = webGLData.points;
        var indices = webGLData.indices;

        var vecPos = verts.length / 6;

        indices.push(vecPos);

        for (var i = 0; i < totalSegs + 1; i++) {
            verts.push(x, y, r, g, b, alpha);

            verts.push(x + Math.sin(seg * i) * width, y + Math.cos(seg * i) * height, r, g, b, alpha);

            indices.push(vecPos++, vecPos++);
        }

        indices.push(vecPos - 1);
    }

    if (graphicsData.lineWidth) {
        var tempPoints = graphicsData.points;

        graphicsData.points = [];

        for (var _i = 0; _i < totalSegs; _i++) {
            graphicsData.points.push(x + Math.sin(seg * -_i) * width, y + Math.cos(seg * -_i) * height);
        }

        graphicsData.points.push(graphicsData.points[0], graphicsData.points[1]);

        (0, _buildLine2.default)(graphicsData, webGLData, webGLDataNativeLines);

        graphicsData.points = tempPoints;
    }
}
//# sourceMappingURL=buildCircle.js.map

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _CanvasRenderer = __webpack_require__(84);

var _CanvasRenderer2 = _interopRequireDefault(_CanvasRenderer);

var _const = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @author Mat Groves
 *
 * Big thanks to the very clever Matt DesLauriers <mattdesl> https://github.com/mattdesl/
 * for creating the original PixiJS version!
 * Also a thanks to https://github.com/bchevalier for tweaking the tint and alpha so that they
 * now share 4 bytes on the vertex buffer
 *
 * Heavily inspired by LibGDX's CanvasGraphicsRenderer:
 * https://github.com/libgdx/libgdx/blob/1.0.0/gdx/src/com/badlogic/gdx/graphics/glutils/ShapeRenderer.java
 */

/**
 * Renderer dedicated to drawing and batching graphics objects.
 *
 * @class
 * @private
 * @memberof PIXI
 */
var CanvasGraphicsRenderer = function () {
    /**
     * @param {PIXI.CanvasRenderer} renderer - The current PIXI renderer.
     */
    function CanvasGraphicsRenderer(renderer) {
        _classCallCheck(this, CanvasGraphicsRenderer);

        this.renderer = renderer;
    }

    /**
     * Renders a Graphics object to a canvas.
     *
     * @param {PIXI.Graphics} graphics - the actual graphics object to render
     */


    CanvasGraphicsRenderer.prototype.render = function render(graphics) {
        var renderer = this.renderer;
        var context = renderer.context;
        var worldAlpha = graphics.worldAlpha;
        var transform = graphics.transform.worldTransform;
        var resolution = renderer.resolution;

        context.setTransform(transform.a * resolution, transform.b * resolution, transform.c * resolution, transform.d * resolution, transform.tx * resolution, transform.ty * resolution);

        // update tint if graphics was dirty
        if (graphics.canvasTintDirty !== graphics.dirty || graphics._prevTint !== graphics.tint) {
            this.updateGraphicsTint(graphics);
        }

        renderer.setBlendMode(graphics.blendMode);

        for (var i = 0; i < graphics.graphicsData.length; i++) {
            var data = graphics.graphicsData[i];
            var shape = data.shape;

            var fillColor = data._fillTint;
            var lineColor = data._lineTint;

            context.lineWidth = data.lineWidth;

            if (data.type === _const.SHAPES.POLY) {
                context.beginPath();

                var points = shape.points;
                var holes = data.holes;
                var outerArea = void 0;
                var innerArea = void 0;
                var px = void 0;
                var py = void 0;

                context.moveTo(points[0], points[1]);

                for (var j = 2; j < points.length; j += 2) {
                    context.lineTo(points[j], points[j + 1]);
                }

                // if the first and last point are the same close the path - much neater :)
                if (shape.closed) {
                    context.closePath();
                }

                if (holes.length > 0) {
                    outerArea = 0;
                    px = points[0];
                    py = points[1];
                    for (var _j = 2; _j + 2 < points.length; _j += 2) {
                        outerArea += (points[_j] - px) * (points[_j + 3] - py) - (points[_j + 2] - px) * (points[_j + 1] - py);
                    }

                    for (var k = 0; k < holes.length; k++) {
                        points = holes[k].points;

                        if (!points) {
                            continue;
                        }

                        innerArea = 0;
                        px = points[0];
                        py = points[1];
                        for (var _j2 = 2; _j2 + 2 < points.length; _j2 += 2) {
                            innerArea += (points[_j2] - px) * (points[_j2 + 3] - py) - (points[_j2 + 2] - px) * (points[_j2 + 1] - py);
                        }

                        if (innerArea * outerArea < 0) {
                            context.moveTo(points[0], points[1]);

                            for (var _j3 = 2; _j3 < points.length; _j3 += 2) {
                                context.lineTo(points[_j3], points[_j3 + 1]);
                            }
                        } else {
                            context.moveTo(points[points.length - 2], points[points.length - 1]);

                            for (var _j4 = points.length - 4; _j4 >= 0; _j4 -= 2) {
                                context.lineTo(points[_j4], points[_j4 + 1]);
                            }
                        }

                        if (holes[k].close) {
                            context.closePath();
                        }
                    }
                }

                if (data.fill) {
                    context.globalAlpha = data.fillAlpha * worldAlpha;
                    context.fillStyle = '#' + ('00000' + (fillColor | 0).toString(16)).substr(-6);
                    context.fill();
                }
                if (data.lineWidth) {
                    context.globalAlpha = data.lineAlpha * worldAlpha;
                    context.strokeStyle = '#' + ('00000' + (lineColor | 0).toString(16)).substr(-6);
                    context.stroke();
                }
            } else if (data.type === _const.SHAPES.RECT) {
                if (data.fillColor || data.fillColor === 0) {
                    context.globalAlpha = data.fillAlpha * worldAlpha;
                    context.fillStyle = '#' + ('00000' + (fillColor | 0).toString(16)).substr(-6);
                    context.fillRect(shape.x, shape.y, shape.width, shape.height);
                }
                if (data.lineWidth) {
                    context.globalAlpha = data.lineAlpha * worldAlpha;
                    context.strokeStyle = '#' + ('00000' + (lineColor | 0).toString(16)).substr(-6);
                    context.strokeRect(shape.x, shape.y, shape.width, shape.height);
                }
            } else if (data.type === _const.SHAPES.CIRC) {
                // TODO - need to be Undefined!
                context.beginPath();
                context.arc(shape.x, shape.y, shape.radius, 0, 2 * Math.PI);
                context.closePath();

                if (data.fill) {
                    context.globalAlpha = data.fillAlpha * worldAlpha;
                    context.fillStyle = '#' + ('00000' + (fillColor | 0).toString(16)).substr(-6);
                    context.fill();
                }
                if (data.lineWidth) {
                    context.globalAlpha = data.lineAlpha * worldAlpha;
                    context.strokeStyle = '#' + ('00000' + (lineColor | 0).toString(16)).substr(-6);
                    context.stroke();
                }
            } else if (data.type === _const.SHAPES.ELIP) {
                // ellipse code taken from: http://stackoverflow.com/questions/2172798/how-to-draw-an-oval-in-html5-canvas

                var w = shape.width * 2;
                var h = shape.height * 2;

                var x = shape.x - w / 2;
                var y = shape.y - h / 2;

                context.beginPath();

                var kappa = 0.5522848;
                var ox = w / 2 * kappa; // control point offset horizontal
                var oy = h / 2 * kappa; // control point offset vertical
                var xe = x + w; // x-end
                var ye = y + h; // y-end
                var xm = x + w / 2; // x-middle
                var ym = y + h / 2; // y-middle

                context.moveTo(x, ym);
                context.bezierCurveTo(x, ym - oy, xm - ox, y, xm, y);
                context.bezierCurveTo(xm + ox, y, xe, ym - oy, xe, ym);
                context.bezierCurveTo(xe, ym + oy, xm + ox, ye, xm, ye);
                context.bezierCurveTo(xm - ox, ye, x, ym + oy, x, ym);

                context.closePath();

                if (data.fill) {
                    context.globalAlpha = data.fillAlpha * worldAlpha;
                    context.fillStyle = '#' + ('00000' + (fillColor | 0).toString(16)).substr(-6);
                    context.fill();
                }
                if (data.lineWidth) {
                    context.globalAlpha = data.lineAlpha * worldAlpha;
                    context.strokeStyle = '#' + ('00000' + (lineColor | 0).toString(16)).substr(-6);
                    context.stroke();
                }
            } else if (data.type === _const.SHAPES.RREC) {
                var rx = shape.x;
                var ry = shape.y;
                var width = shape.width;
                var height = shape.height;
                var radius = shape.radius;

                var maxRadius = Math.min(width, height) / 2 | 0;

                radius = radius > maxRadius ? maxRadius : radius;

                context.beginPath();
                context.moveTo(rx, ry + radius);
                context.lineTo(rx, ry + height - radius);
                context.quadraticCurveTo(rx, ry + height, rx + radius, ry + height);
                context.lineTo(rx + width - radius, ry + height);
                context.quadraticCurveTo(rx + width, ry + height, rx + width, ry + height - radius);
                context.lineTo(rx + width, ry + radius);
                context.quadraticCurveTo(rx + width, ry, rx + width - radius, ry);
                context.lineTo(rx + radius, ry);
                context.quadraticCurveTo(rx, ry, rx, ry + radius);
                context.closePath();

                if (data.fillColor || data.fillColor === 0) {
                    context.globalAlpha = data.fillAlpha * worldAlpha;
                    context.fillStyle = '#' + ('00000' + (fillColor | 0).toString(16)).substr(-6);
                    context.fill();
                }

                if (data.lineWidth) {
                    context.globalAlpha = data.lineAlpha * worldAlpha;
                    context.strokeStyle = '#' + ('00000' + (lineColor | 0).toString(16)).substr(-6);
                    context.stroke();
                }
            }
        }
    };

    /**
     * Updates the tint of a graphics object
     *
     * @private
     * @param {PIXI.Graphics} graphics - the graphics that will have its tint updated
     */


    CanvasGraphicsRenderer.prototype.updateGraphicsTint = function updateGraphicsTint(graphics) {
        graphics._prevTint = graphics.tint;
        graphics.canvasTintDirty = graphics.dirty;

        var tintR = (graphics.tint >> 16 & 0xFF) / 255;
        var tintG = (graphics.tint >> 8 & 0xFF) / 255;
        var tintB = (graphics.tint & 0xFF) / 255;

        for (var i = 0; i < graphics.graphicsData.length; ++i) {
            var data = graphics.graphicsData[i];

            var fillColor = data.fillColor | 0;
            var lineColor = data.lineColor | 0;

            // super inline, cos optimization :)
            data._fillTint = ((fillColor >> 16 & 0xFF) / 255 * tintR * 255 << 16) + ((fillColor >> 8 & 0xFF) / 255 * tintG * 255 << 8) + (fillColor & 0xFF) / 255 * tintB * 255;

            data._lineTint = ((lineColor >> 16 & 0xFF) / 255 * tintR * 255 << 16) + ((lineColor >> 8 & 0xFF) / 255 * tintG * 255 << 8) + (lineColor & 0xFF) / 255 * tintB * 255;
        }
    };

    /**
     * Renders a polygon.
     *
     * @param {PIXI.Point[]} points - The points to render
     * @param {boolean} close - Should the polygon be closed
     * @param {CanvasRenderingContext2D} context - The rendering context to use
     */


    CanvasGraphicsRenderer.prototype.renderPolygon = function renderPolygon(points, close, context) {
        context.moveTo(points[0], points[1]);

        for (var j = 1; j < points.length / 2; ++j) {
            context.lineTo(points[j * 2], points[j * 2 + 1]);
        }

        if (close) {
            context.closePath();
        }
    };

    /**
     * destroy graphics object
     *
     */


    CanvasGraphicsRenderer.prototype.destroy = function destroy() {
        this.renderer = null;
    };

    return CanvasGraphicsRenderer;
}();

exports.default = CanvasGraphicsRenderer;


_CanvasRenderer2.default.registerPlugin('graphics', CanvasGraphicsRenderer);
//# sourceMappingURL=CanvasGraphicsRenderer.js.map

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ = __webpack_require__(7);

var _utils = __webpack_require__(9);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Utility class for maintaining reference to a collection
 * of Textures on a single Spritesheet.
 *
 * To access a sprite sheet from your code pass its JSON data file to Pixi's loader:
 *
 * ```js
 * PIXI.loader.add("images/spritesheet.json").load(setup);
 *
 * function setup() {
 *   let sheet = PIXI.loader.resources["images/spritesheet.json"].spritesheet;
 *   ...
 * }
 * ```
 * With the `sheet.textures` you can create Sprite objects,`sheet.animations` can be used to create an AnimatedSprite.
 *
 * Sprite sheets can be packed using tools like {@link https://codeandweb.com/texturepacker|TexturePacker},
 * {@link https://renderhjs.net/shoebox/|Shoebox} or {@link https://github.com/krzysztof-o/spritesheet.js|Spritesheet.js}.
 * Default anchor points (see {@link PIXI.Texture#defaultAnchor}) and grouping of animation sprites are currently only
 * supported by TexturePacker.
 *
 * @class
 * @memberof PIXI
 */
var Spritesheet = function () {
    _createClass(Spritesheet, null, [{
        key: 'BATCH_SIZE',

        /**
         * The maximum number of Textures to build per process.
         *
         * @type {number}
         * @default 1000
         */
        get: function get() {
            return 1000;
        }

        /**
         * @param {PIXI.BaseTexture} baseTexture Reference to the source BaseTexture object.
         * @param {Object} data - Spritesheet image data.
         * @param {string} [resolutionFilename] - The filename to consider when determining
         *        the resolution of the spritesheet. If not provided, the imageUrl will
         *        be used on the BaseTexture.
         */

    }]);

    function Spritesheet(baseTexture, data) {
        var resolutionFilename = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

        _classCallCheck(this, Spritesheet);

        /**
         * Reference to ths source texture
         * @type {PIXI.BaseTexture}
         */
        this.baseTexture = baseTexture;

        /**
         * A map containing all textures of the sprite sheet.
         * Can be used to create a {@link PIXI.Sprite|Sprite}:
         * ```js
         * new PIXI.Sprite(sheet.textures["image.png"]);
         * ```
         * @member {Object}
         */
        this.textures = {};

        /**
         * A map containing the textures for each animation.
         * Can be used to create an {@link PIXI.extras.AnimatedSprite|AnimatedSprite}:
         * ```js
         * new PIXI.extras.AnimatedSprite(sheet.animations["anim_name"])
         * ```
         * @member {Object}
         */
        this.animations = {};

        /**
         * Reference to the original JSON data.
         * @type {Object}
         */
        this.data = data;

        /**
         * The resolution of the spritesheet.
         * @type {number}
         */
        this.resolution = this._updateResolution(resolutionFilename || this.baseTexture.imageUrl);

        /**
         * Map of spritesheet frames.
         * @type {Object}
         * @private
         */
        this._frames = this.data.frames;

        /**
         * Collection of frame names.
         * @type {string[]}
         * @private
         */
        this._frameKeys = Object.keys(this._frames);

        /**
         * Current batch index being processed.
         * @type {number}
         * @private
         */
        this._batchIndex = 0;

        /**
         * Callback when parse is completed.
         * @type {Function}
         * @private
         */
        this._callback = null;
    }

    /**
     * Generate the resolution from the filename or fallback
     * to the meta.scale field of the JSON data.
     *
     * @private
     * @param {string} resolutionFilename - The filename to use for resolving
     *        the default resolution.
     * @return {number} Resolution to use for spritesheet.
     */


    Spritesheet.prototype._updateResolution = function _updateResolution(resolutionFilename) {
        var scale = this.data.meta.scale;

        // Use a defaultValue of `null` to check if a url-based resolution is set
        var resolution = (0, _utils.getResolutionOfUrl)(resolutionFilename, null);

        // No resolution found via URL
        if (resolution === null) {
            // Use the scale value or default to 1
            resolution = scale !== undefined ? parseFloat(scale) : 1;
        }

        // For non-1 resolutions, update baseTexture
        if (resolution !== 1) {
            this.baseTexture.resolution = resolution;
            this.baseTexture.update();
        }

        return resolution;
    };

    /**
     * Parser spritesheet from loaded data. This is done asynchronously
     * to prevent creating too many Texture within a single process.
     *
     * @param {Function} callback - Callback when complete returns
     *        a map of the Textures for this spritesheet.
     */


    Spritesheet.prototype.parse = function parse(callback) {
        this._batchIndex = 0;
        this._callback = callback;

        if (this._frameKeys.length <= Spritesheet.BATCH_SIZE) {
            this._processFrames(0);
            this._processAnimations();
            this._parseComplete();
        } else {
            this._nextBatch();
        }
    };

    /**
     * Process a batch of frames
     *
     * @private
     * @param {number} initialFrameIndex - The index of frame to start.
     */


    Spritesheet.prototype._processFrames = function _processFrames(initialFrameIndex) {
        var frameIndex = initialFrameIndex;
        var maxFrames = Spritesheet.BATCH_SIZE;
        var sourceScale = this.baseTexture.sourceScale;

        while (frameIndex - initialFrameIndex < maxFrames && frameIndex < this._frameKeys.length) {
            var i = this._frameKeys[frameIndex];
            var data = this._frames[i];
            var rect = data.frame;

            if (rect) {
                var frame = null;
                var trim = null;
                var sourceSize = data.trimmed !== false && data.sourceSize ? data.sourceSize : data.frame;

                var orig = new _.Rectangle(0, 0, Math.floor(sourceSize.w * sourceScale) / this.resolution, Math.floor(sourceSize.h * sourceScale) / this.resolution);

                if (data.rotated) {
                    frame = new _.Rectangle(Math.floor(rect.x * sourceScale) / this.resolution, Math.floor(rect.y * sourceScale) / this.resolution, Math.floor(rect.h * sourceScale) / this.resolution, Math.floor(rect.w * sourceScale) / this.resolution);
                } else {
                    frame = new _.Rectangle(Math.floor(rect.x * sourceScale) / this.resolution, Math.floor(rect.y * sourceScale) / this.resolution, Math.floor(rect.w * sourceScale) / this.resolution, Math.floor(rect.h * sourceScale) / this.resolution);
                }

                //  Check to see if the sprite is trimmed
                if (data.trimmed !== false && data.spriteSourceSize) {
                    trim = new _.Rectangle(Math.floor(data.spriteSourceSize.x * sourceScale) / this.resolution, Math.floor(data.spriteSourceSize.y * sourceScale) / this.resolution, Math.floor(rect.w * sourceScale) / this.resolution, Math.floor(rect.h * sourceScale) / this.resolution);
                }

                this.textures[i] = new _.Texture(this.baseTexture, frame, orig, trim, data.rotated ? 2 : 0, data.anchor);

                // lets also add the frame to pixi's global cache for fromFrame and fromImage functions
                _.Texture.addToCache(this.textures[i], i);
            }

            frameIndex++;
        }
    };

    /**
     * Parse animations config
     *
     * @private
     */


    Spritesheet.prototype._processAnimations = function _processAnimations() {
        var animations = this.data.animations || {};

        for (var animName in animations) {
            this.animations[animName] = [];
            for (var _iterator = animations[animName], _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                var _ref;

                if (_isArray) {
                    if (_i >= _iterator.length) break;
                    _ref = _iterator[_i++];
                } else {
                    _i = _iterator.next();
                    if (_i.done) break;
                    _ref = _i.value;
                }

                var frameName = _ref;

                this.animations[animName].push(this.textures[frameName]);
            }
        }
    };

    /**
     * The parse has completed.
     *
     * @private
     */


    Spritesheet.prototype._parseComplete = function _parseComplete() {
        var callback = this._callback;

        this._callback = null;
        this._batchIndex = 0;
        callback.call(this, this.textures);
    };

    /**
     * Begin the next batch of textures.
     *
     * @private
     */


    Spritesheet.prototype._nextBatch = function _nextBatch() {
        var _this = this;

        this._processFrames(this._batchIndex * Spritesheet.BATCH_SIZE);
        this._batchIndex++;
        setTimeout(function () {
            if (_this._batchIndex * Spritesheet.BATCH_SIZE < _this._frameKeys.length) {
                _this._nextBatch();
            } else {
                _this._processAnimations();
                _this._parseComplete();
            }
        }, 0);
    };

    /**
     * Destroy Spritesheet and don't use after this.
     *
     * @param {boolean} [destroyBase=false] Whether to destroy the base texture as well
     */


    Spritesheet.prototype.destroy = function destroy() {
        var destroyBase = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        for (var i in this.textures) {
            this.textures[i].destroy();
        }
        this._frames = null;
        this._frameKeys = null;
        this.data = null;
        this.textures = null;
        if (destroyBase) {
            this.baseTexture.destroy();
        }
        this.baseTexture = null;
    };

    return Spritesheet;
}();

exports.default = Spritesheet;
//# sourceMappingURL=Spritesheet.js.map

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = deprecation;
// provide method to give a stack track for warnings
// useful for tracking-down where deprecated methods/properties/classes
// are being used within the code

// A map of warning messages already fired
var warnings = {};

// provide method to give a stack track for warnings
// useful for tracking-down where deprecated methods/properties/classes
// are being used within the code
function warn(msg) {
    // Ignore duplicat
    if (warnings[msg]) {
        return;
    }

    /* eslint-disable no-console */
    var stack = new Error().stack;

    // Handle IE < 10 and Safari < 6
    if (typeof stack === 'undefined') {
        console.warn('Deprecation Warning: ', msg);
    } else {
        // chop off the stack trace which includes pixi.js internal calls
        stack = stack.split('\n').splice(3).join('\n');

        if (console.groupCollapsed) {
            console.groupCollapsed('%cDeprecation Warning: %c%s', 'color:#614108;background:#fffbe6', 'font-weight:normal;color:#614108;background:#fffbe6', msg);
            console.warn(stack);
            console.groupEnd();
        } else {
            console.warn('Deprecation Warning: ', msg);
            console.warn(stack);
        }
    }
    /* eslint-enable no-console */

    warnings[msg] = true;
}

function deprecation(core) {
    var mesh = core.mesh,
        particles = core.particles,
        extras = core.extras,
        filters = core.filters,
        prepare = core.prepare,
        loaders = core.loaders,
        interaction = core.interaction;


    Object.defineProperties(core, {

        /**
         * @class
         * @private
         * @name SpriteBatch
         * @memberof PIXI
         * @see PIXI.ParticleContainer
         * @throws {ReferenceError} SpriteBatch does not exist any more, please use the new ParticleContainer instead.
         * @deprecated since version 3.0.0
         */
        SpriteBatch: {
            get: function get() {
                throw new ReferenceError('SpriteBatch does not exist any more, ' + 'please use the new ParticleContainer instead.');
            }
        },

        /**
         * @class
         * @private
         * @name AssetLoader
         * @memberof PIXI
         * @see PIXI.loaders.Loader
         * @throws {ReferenceError} The loader system was overhauled in PixiJS v3,
         * please see the new PIXI.loaders.Loader class.
         * @deprecated since version 3.0.0
         */
        AssetLoader: {
            get: function get() {
                throw new ReferenceError('The loader system was overhauled in PixiJS v3, ' + 'please see the new PIXI.loaders.Loader class.');
            }
        },

        /**
         * @class
         * @private
         * @name Stage
         * @memberof PIXI
         * @see PIXI.Container
         * @deprecated since version 3.0.0
         */
        Stage: {
            get: function get() {
                warn('You do not need to use a PIXI Stage any more, you can simply render any container.');

                return core.Container;
            }
        },

        /**
         * @class
         * @private
         * @name DisplayObjectContainer
         * @memberof PIXI
         * @see PIXI.Container
         * @deprecated since version 3.0.0
         */
        DisplayObjectContainer: {
            get: function get() {
                warn('DisplayObjectContainer has been shortened to Container, please use Container from now on.');

                return core.Container;
            }
        },

        /**
         * @class
         * @private
         * @name Strip
         * @memberof PIXI
         * @see PIXI.mesh.Mesh
         * @deprecated since version 3.0.0
         */
        Strip: {
            get: function get() {
                warn('The Strip class has been renamed to Mesh and moved to mesh.Mesh, please use mesh.Mesh from now on.');

                return mesh.Mesh;
            }
        },

        /**
         * @class
         * @private
         * @name Rope
         * @memberof PIXI
         * @see PIXI.mesh.Rope
         * @deprecated since version 3.0.0
         */
        Rope: {
            get: function get() {
                warn('The Rope class has been moved to mesh.Rope, please use mesh.Rope from now on.');

                return mesh.Rope;
            }
        },

        /**
         * @class
         * @private
         * @name ParticleContainer
         * @memberof PIXI
         * @see PIXI.particles.ParticleContainer
         * @deprecated since version 4.0.0
         */
        ParticleContainer: {
            get: function get() {
                warn('The ParticleContainer class has been moved to particles.ParticleContainer, ' + 'please use particles.ParticleContainer from now on.');

                return particles.ParticleContainer;
            }
        },

        /**
         * @class
         * @private
         * @name MovieClip
         * @memberof PIXI
         * @see PIXI.extras.MovieClip
         * @deprecated since version 3.0.0
         */
        MovieClip: {
            get: function get() {
                warn('The MovieClip class has been moved to extras.AnimatedSprite, please use extras.AnimatedSprite.');

                return extras.AnimatedSprite;
            }
        },

        /**
         * @class
         * @private
         * @name TilingSprite
         * @memberof PIXI
         * @see PIXI.extras.TilingSprite
         * @deprecated since version 3.0.0
         */
        TilingSprite: {
            get: function get() {
                warn('The TilingSprite class has been moved to extras.TilingSprite, ' + 'please use extras.TilingSprite from now on.');

                return extras.TilingSprite;
            }
        },

        /**
         * @class
         * @private
         * @name BitmapText
         * @memberof PIXI
         * @see PIXI.extras.BitmapText
         * @deprecated since version 3.0.0
         */
        BitmapText: {
            get: function get() {
                warn('The BitmapText class has been moved to extras.BitmapText, ' + 'please use extras.BitmapText from now on.');

                return extras.BitmapText;
            }
        },

        /**
         * @class
         * @private
         * @name blendModes
         * @memberof PIXI
         * @see PIXI.BLEND_MODES
         * @deprecated since version 3.0.0
         */
        blendModes: {
            get: function get() {
                warn('The blendModes has been moved to BLEND_MODES, please use BLEND_MODES from now on.');

                return core.BLEND_MODES;
            }
        },

        /**
         * @class
         * @private
         * @name scaleModes
         * @memberof PIXI
         * @see PIXI.SCALE_MODES
         * @deprecated since version 3.0.0
         */
        scaleModes: {
            get: function get() {
                warn('The scaleModes has been moved to SCALE_MODES, please use SCALE_MODES from now on.');

                return core.SCALE_MODES;
            }
        },

        /**
         * @class
         * @private
         * @name BaseTextureCache
         * @memberof PIXI
         * @see PIXI.utils.BaseTextureCache
         * @deprecated since version 3.0.0
         */
        BaseTextureCache: {
            get: function get() {
                warn('The BaseTextureCache class has been moved to utils.BaseTextureCache, ' + 'please use utils.BaseTextureCache from now on.');

                return core.utils.BaseTextureCache;
            }
        },

        /**
         * @class
         * @private
         * @name TextureCache
         * @memberof PIXI
         * @see PIXI.utils.TextureCache
         * @deprecated since version 3.0.0
         */
        TextureCache: {
            get: function get() {
                warn('The TextureCache class has been moved to utils.TextureCache, ' + 'please use utils.TextureCache from now on.');

                return core.utils.TextureCache;
            }
        },

        /**
         * @namespace
         * @private
         * @name math
         * @memberof PIXI
         * @see PIXI
         * @deprecated since version 3.0.6
         */
        math: {
            get: function get() {
                warn('The math namespace is deprecated, please access members already accessible on PIXI.');

                return core;
            }
        },

        /**
         * @class
         * @private
         * @name PIXI.AbstractFilter
         * @see PIXI.Filter
         * @deprecated since version 3.0.6
         */
        AbstractFilter: {
            get: function get() {
                warn('AstractFilter has been renamed to Filter, please use PIXI.Filter');

                return core.Filter;
            }
        },

        /**
         * @class
         * @private
         * @name PIXI.TransformManual
         * @see PIXI.TransformBase
         * @deprecated since version 4.0.0
         */
        TransformManual: {
            get: function get() {
                warn('TransformManual has been renamed to TransformBase, please update your pixi-spine');

                return core.TransformBase;
            }
        },

        /**
         * @static
         * @constant
         * @name PIXI.TARGET_FPMS
         * @see PIXI.settings.TARGET_FPMS
         * @deprecated since version 4.2.0
         */
        TARGET_FPMS: {
            get: function get() {
                warn('PIXI.TARGET_FPMS has been deprecated, please use PIXI.settings.TARGET_FPMS');

                return core.settings.TARGET_FPMS;
            },
            set: function set(value) {
                warn('PIXI.TARGET_FPMS has been deprecated, please use PIXI.settings.TARGET_FPMS');

                core.settings.TARGET_FPMS = value;
            }
        },

        /**
         * @static
         * @constant
         * @name PIXI.FILTER_RESOLUTION
         * @see PIXI.settings.FILTER_RESOLUTION
         * @deprecated since version 4.2.0
         */
        FILTER_RESOLUTION: {
            get: function get() {
                warn('PIXI.FILTER_RESOLUTION has been deprecated, please use PIXI.settings.FILTER_RESOLUTION');

                return core.settings.FILTER_RESOLUTION;
            },
            set: function set(value) {
                warn('PIXI.FILTER_RESOLUTION has been deprecated, please use PIXI.settings.FILTER_RESOLUTION');

                core.settings.FILTER_RESOLUTION = value;
            }
        },

        /**
         * @static
         * @constant
         * @name PIXI.RESOLUTION
         * @see PIXI.settings.RESOLUTION
         * @deprecated since version 4.2.0
         */
        RESOLUTION: {
            get: function get() {
                warn('PIXI.RESOLUTION has been deprecated, please use PIXI.settings.RESOLUTION');

                return core.settings.RESOLUTION;
            },
            set: function set(value) {
                warn('PIXI.RESOLUTION has been deprecated, please use PIXI.settings.RESOLUTION');

                core.settings.RESOLUTION = value;
            }
        },

        /**
         * @static
         * @constant
         * @name PIXI.MIPMAP_TEXTURES
         * @see PIXI.settings.MIPMAP_TEXTURES
         * @deprecated since version 4.2.0
         */
        MIPMAP_TEXTURES: {
            get: function get() {
                warn('PIXI.MIPMAP_TEXTURES has been deprecated, please use PIXI.settings.MIPMAP_TEXTURES');

                return core.settings.MIPMAP_TEXTURES;
            },
            set: function set(value) {
                warn('PIXI.MIPMAP_TEXTURES has been deprecated, please use PIXI.settings.MIPMAP_TEXTURES');

                core.settings.MIPMAP_TEXTURES = value;
            }
        },

        /**
         * @static
         * @constant
         * @name PIXI.SPRITE_BATCH_SIZE
         * @see PIXI.settings.SPRITE_BATCH_SIZE
         * @deprecated since version 4.2.0
         */
        SPRITE_BATCH_SIZE: {
            get: function get() {
                warn('PIXI.SPRITE_BATCH_SIZE has been deprecated, please use PIXI.settings.SPRITE_BATCH_SIZE');

                return core.settings.SPRITE_BATCH_SIZE;
            },
            set: function set(value) {
                warn('PIXI.SPRITE_BATCH_SIZE has been deprecated, please use PIXI.settings.SPRITE_BATCH_SIZE');

                core.settings.SPRITE_BATCH_SIZE = value;
            }
        },

        /**
         * @static
         * @constant
         * @name PIXI.SPRITE_MAX_TEXTURES
         * @see PIXI.settings.SPRITE_MAX_TEXTURES
         * @deprecated since version 4.2.0
         */
        SPRITE_MAX_TEXTURES: {
            get: function get() {
                warn('PIXI.SPRITE_MAX_TEXTURES has been deprecated, please use PIXI.settings.SPRITE_MAX_TEXTURES');

                return core.settings.SPRITE_MAX_TEXTURES;
            },
            set: function set(value) {
                warn('PIXI.SPRITE_MAX_TEXTURES has been deprecated, please use PIXI.settings.SPRITE_MAX_TEXTURES');

                core.settings.SPRITE_MAX_TEXTURES = value;
            }
        },

        /**
         * @static
         * @constant
         * @name PIXI.RETINA_PREFIX
         * @see PIXI.settings.RETINA_PREFIX
         * @deprecated since version 4.2.0
         */
        RETINA_PREFIX: {
            get: function get() {
                warn('PIXI.RETINA_PREFIX has been deprecated, please use PIXI.settings.RETINA_PREFIX');

                return core.settings.RETINA_PREFIX;
            },
            set: function set(value) {
                warn('PIXI.RETINA_PREFIX has been deprecated, please use PIXI.settings.RETINA_PREFIX');

                core.settings.RETINA_PREFIX = value;
            }
        },

        /**
         * @static
         * @constant
         * @name PIXI.DEFAULT_RENDER_OPTIONS
         * @see PIXI.settings.RENDER_OPTIONS
         * @deprecated since version 4.2.0
         */
        DEFAULT_RENDER_OPTIONS: {
            get: function get() {
                warn('PIXI.DEFAULT_RENDER_OPTIONS has been deprecated, please use PIXI.settings.DEFAULT_RENDER_OPTIONS');

                return core.settings.RENDER_OPTIONS;
            }
        }
    });

    // Move the default properties to settings
    var defaults = [{ parent: 'TRANSFORM_MODE', target: 'TRANSFORM_MODE' }, { parent: 'GC_MODES', target: 'GC_MODE' }, { parent: 'WRAP_MODES', target: 'WRAP_MODE' }, { parent: 'SCALE_MODES', target: 'SCALE_MODE' }, { parent: 'PRECISION', target: 'PRECISION_FRAGMENT' }];

    var _loop = function _loop(i) {
        var deprecation = defaults[i];

        Object.defineProperty(core[deprecation.parent], 'DEFAULT', {
            get: function get() {
                warn('PIXI.' + deprecation.parent + '.DEFAULT has been deprecated, ' + ('please use PIXI.settings.' + deprecation.target));

                return core.settings[deprecation.target];
            },
            set: function set(value) {
                warn('PIXI.' + deprecation.parent + '.DEFAULT has been deprecated, ' + ('please use PIXI.settings.' + deprecation.target));

                core.settings[deprecation.target] = value;
            }
        });
    };

    for (var i = 0; i < defaults.length; i++) {
        _loop(i);
    }

    Object.defineProperties(core.settings, {

        /**
         * @static
         * @name PRECISION
         * @memberof PIXI.settings
         * @see PIXI.PRECISION
         * @deprecated since version 4.4.0
         */
        PRECISION: {
            get: function get() {
                warn('PIXI.settings.PRECISION has been deprecated, please use PIXI.settings.PRECISION_FRAGMENT');

                return core.settings.PRECISION_FRAGMENT;
            },
            set: function set(value) {
                warn('PIXI.settings.PRECISION has been deprecated, please use PIXI.settings.PRECISION_FRAGMENT');

                core.settings.PRECISION_FRAGMENT = value;
            }
        }
    });

    if (extras.AnimatedSprite) {
        Object.defineProperties(extras, {

            /**
             * @class
             * @name MovieClip
             * @memberof PIXI.extras
             * @see PIXI.extras.AnimatedSprite
             * @deprecated since version 4.2.0
             */
            MovieClip: {
                get: function get() {
                    warn('The MovieClip class has been renamed to AnimatedSprite, please use AnimatedSprite from now on.');

                    return extras.AnimatedSprite;
                }
            }
        });
    }

    if (extras) {
        Object.defineProperties(extras, {
            /**
             * @class
             * @name TextureTransform
             * @memberof PIXI.extras
             * @see PIXI.TextureMatrix
             * @deprecated since version 4.6.0
             */
            TextureTransform: {
                get: function get() {
                    warn('The TextureTransform class has been renamed to TextureMatrix, ' + 'please use PIXI.TextureMatrix from now on.');

                    return core.TextureMatrix;
                }
            }
        });
    }

    core.DisplayObject.prototype.generateTexture = function generateTexture(renderer, scaleMode, resolution) {
        warn('generateTexture has moved to the renderer, please use renderer.generateTexture(displayObject)');

        return renderer.generateTexture(this, scaleMode, resolution);
    };

    core.Graphics.prototype.generateTexture = function generateTexture(scaleMode, resolution) {
        warn('graphics generate texture has moved to the renderer. ' + 'Or to render a graphics to a texture using canvas please use generateCanvasTexture');

        return this.generateCanvasTexture(scaleMode, resolution);
    };

    /**
     * @method
     * @name PIXI.GroupD8.isSwapWidthHeight
     * @see PIXI.GroupD8.isVertical
     * @param {number} rotation - The number to check.
     * @returns {boolean} Whether or not the direction is vertical
     * @deprecated since version 4.6.0
     */
    core.GroupD8.isSwapWidthHeight = function isSwapWidthHeight(rotation) {
        warn('GroupD8.isSwapWidthHeight was renamed to GroupD8.isVertical');

        return core.GroupD8.isVertical(rotation);
    };

    core.RenderTexture.prototype.render = function render(displayObject, matrix, clear, updateTransform) {
        this.legacyRenderer.render(displayObject, this, clear, matrix, !updateTransform);
        warn('RenderTexture.render is now deprecated, please use renderer.render(displayObject, renderTexture)');
    };

    core.RenderTexture.prototype.getImage = function getImage(target) {
        warn('RenderTexture.getImage is now deprecated, please use renderer.extract.image(target)');

        return this.legacyRenderer.extract.image(target);
    };

    core.RenderTexture.prototype.getBase64 = function getBase64(target) {
        warn('RenderTexture.getBase64 is now deprecated, please use renderer.extract.base64(target)');

        return this.legacyRenderer.extract.base64(target);
    };

    core.RenderTexture.prototype.getCanvas = function getCanvas(target) {
        warn('RenderTexture.getCanvas is now deprecated, please use renderer.extract.canvas(target)');

        return this.legacyRenderer.extract.canvas(target);
    };

    core.RenderTexture.prototype.getPixels = function getPixels(target) {
        warn('RenderTexture.getPixels is now deprecated, please use renderer.extract.pixels(target)');

        return this.legacyRenderer.pixels(target);
    };

    /**
     * @method
     * @private
     * @name PIXI.Sprite#setTexture
     * @see PIXI.Sprite#texture
     * @deprecated since version 3.0.0
     * @param {PIXI.Texture} texture - The texture to set to.
     */
    core.Sprite.prototype.setTexture = function setTexture(texture) {
        this.texture = texture;
        warn('setTexture is now deprecated, please use the texture property, e.g : sprite.texture = texture;');
    };

    if (extras.BitmapText) {
        /**
         * @method
         * @name PIXI.extras.BitmapText#setText
         * @see PIXI.extras.BitmapText#text
         * @deprecated since version 3.0.0
         * @param {string} text - The text to set to.
         */
        extras.BitmapText.prototype.setText = function setText(text) {
            this.text = text;
            warn('setText is now deprecated, please use the text property, e.g : myBitmapText.text = \'my text\';');
        };
    }

    /**
     * @method
     * @name PIXI.Text#setText
     * @see PIXI.Text#text
     * @deprecated since version 3.0.0
     * @param {string} text - The text to set to.
     */
    core.Text.prototype.setText = function setText(text) {
        this.text = text;
        warn('setText is now deprecated, please use the text property, e.g : myText.text = \'my text\';');
    };

    /**
     * Calculates the ascent, descent and fontSize of a given fontStyle
     *
     * @name PIXI.Text.calculateFontProperties
     * @see PIXI.TextMetrics.measureFont
     * @deprecated since version 4.5.0
     * @param {string} font - String representing the style of the font
     * @return {Object} Font properties object
     */
    core.Text.calculateFontProperties = function calculateFontProperties(font) {
        warn('Text.calculateFontProperties is now deprecated, please use the TextMetrics.measureFont');

        return core.TextMetrics.measureFont(font);
    };

    Object.defineProperties(core.Text, {
        fontPropertiesCache: {
            get: function get() {
                warn('Text.fontPropertiesCache is deprecated');

                return core.TextMetrics._fonts;
            }
        },
        fontPropertiesCanvas: {
            get: function get() {
                warn('Text.fontPropertiesCanvas is deprecated');

                return core.TextMetrics._canvas;
            }
        },
        fontPropertiesContext: {
            get: function get() {
                warn('Text.fontPropertiesContext is deprecated');

                return core.TextMetrics._context;
            }
        }
    });

    /**
     * @method
     * @name PIXI.Text#setStyle
     * @see PIXI.Text#style
     * @deprecated since version 3.0.0
     * @param {*} style - The style to set to.
     */
    core.Text.prototype.setStyle = function setStyle(style) {
        this.style = style;
        warn('setStyle is now deprecated, please use the style property, e.g : myText.style = style;');
    };

    /**
     * @method
     * @name PIXI.Text#determineFontProperties
     * @see PIXI.Text#measureFontProperties
     * @deprecated since version 4.2.0
     * @private
     * @param {string} fontStyle - String representing the style of the font
     * @return {Object} Font properties object
     */
    core.Text.prototype.determineFontProperties = function determineFontProperties(fontStyle) {
        warn('determineFontProperties is now deprecated, please use TextMetrics.measureFont method');

        return core.TextMetrics.measureFont(fontStyle);
    };

    /**
     * @method
     * @name PIXI.Text.getFontStyle
     * @see PIXI.TextMetrics.getFontStyle
     * @deprecated since version 4.5.0
     * @param {PIXI.TextStyle} style - The style to use.
     * @return {string} Font string
     */
    core.Text.getFontStyle = function getFontStyle(style) {
        warn('getFontStyle is now deprecated, please use TextStyle.toFontString() instead');

        style = style || {};

        if (!(style instanceof core.TextStyle)) {
            style = new core.TextStyle(style);
        }

        return style.toFontString();
    };

    Object.defineProperties(core.TextStyle.prototype, {
        /**
         * Set all properties of a font as a single string
         *
         * @name PIXI.TextStyle#font
         * @deprecated since version 4.0.0
         */
        font: {
            get: function get() {
                warn('text style property \'font\' is now deprecated, please use the ' + '\'fontFamily\', \'fontSize\', \'fontStyle\', \'fontVariant\' and \'fontWeight\' properties from now on');

                var fontSizeString = typeof this._fontSize === 'number' ? this._fontSize + 'px' : this._fontSize;

                return this._fontStyle + ' ' + this._fontVariant + ' ' + this._fontWeight + ' ' + fontSizeString + ' ' + this._fontFamily;
            },
            set: function set(font) {
                warn('text style property \'font\' is now deprecated, please use the ' + '\'fontFamily\',\'fontSize\',fontStyle\',\'fontVariant\' and \'fontWeight\' properties from now on');

                // can work out fontStyle from search of whole string
                if (font.indexOf('italic') > 1) {
                    this._fontStyle = 'italic';
                } else if (font.indexOf('oblique') > -1) {
                    this._fontStyle = 'oblique';
                } else {
                    this._fontStyle = 'normal';
                }

                // can work out fontVariant from search of whole string
                if (font.indexOf('small-caps') > -1) {
                    this._fontVariant = 'small-caps';
                } else {
                    this._fontVariant = 'normal';
                }

                // fontWeight and fontFamily are tricker to find, but it's easier to find the fontSize due to it's units
                var splits = font.split(' ');
                var fontSizeIndex = -1;

                this._fontSize = 26;
                for (var i = 0; i < splits.length; ++i) {
                    if (splits[i].match(/(px|pt|em|%)/)) {
                        fontSizeIndex = i;
                        this._fontSize = splits[i];
                        break;
                    }
                }

                // we can now search for fontWeight as we know it must occur before the fontSize
                this._fontWeight = 'normal';
                for (var _i = 0; _i < fontSizeIndex; ++_i) {
                    if (splits[_i].match(/(bold|bolder|lighter|100|200|300|400|500|600|700|800|900)/)) {
                        this._fontWeight = splits[_i];
                        break;
                    }
                }

                // and finally join everything together after the fontSize in case the font family has multiple words
                if (fontSizeIndex > -1 && fontSizeIndex < splits.length - 1) {
                    this._fontFamily = '';
                    for (var _i2 = fontSizeIndex + 1; _i2 < splits.length; ++_i2) {
                        this._fontFamily += splits[_i2] + ' ';
                    }

                    this._fontFamily = this._fontFamily.slice(0, -1);
                } else {
                    this._fontFamily = 'Arial';
                }

                this.styleID++;
            }
        }
    });

    /**
     * @method
     * @name PIXI.Texture#setFrame
     * @see PIXI.Texture#setFrame
     * @deprecated since version 3.0.0
     * @param {PIXI.Rectangle} frame - The frame to set.
     */
    core.Texture.prototype.setFrame = function setFrame(frame) {
        this.frame = frame;
        warn('setFrame is now deprecated, please use the frame property, e.g: myTexture.frame = frame;');
    };

    /**
     * @static
     * @function
     * @name PIXI.Texture.addTextureToCache
     * @see PIXI.Texture.addToCache
     * @deprecated since 4.5.0
     * @param {PIXI.Texture} texture - The Texture to add to the cache.
     * @param {string} id - The id that the texture will be stored against.
     */
    core.Texture.addTextureToCache = function addTextureToCache(texture, id) {
        core.Texture.addToCache(texture, id);
        warn('Texture.addTextureToCache is deprecated, please use Texture.addToCache from now on.');
    };

    /**
     * @static
     * @function
     * @name PIXI.Texture.removeTextureFromCache
     * @see PIXI.Texture.removeFromCache
     * @deprecated since 4.5.0
     * @param {string} id - The id of the texture to be removed
     * @return {PIXI.Texture|null} The texture that was removed
     */
    core.Texture.removeTextureFromCache = function removeTextureFromCache(id) {
        warn('Texture.removeTextureFromCache is deprecated, please use Texture.removeFromCache from now on. ' + 'Be aware that Texture.removeFromCache does not automatically its BaseTexture from the BaseTextureCache. ' + 'For that, use BaseTexture.removeFromCache');

        core.BaseTexture.removeFromCache(id);

        return core.Texture.removeFromCache(id);
    };

    Object.defineProperties(filters, {

        /**
         * @class
         * @private
         * @name PIXI.filters.AbstractFilter
         * @see PIXI.AbstractFilter
         * @deprecated since version 3.0.6
         */
        AbstractFilter: {
            get: function get() {
                warn('AstractFilter has been renamed to Filter, please use PIXI.Filter');

                return core.AbstractFilter;
            }
        },

        /**
         * @class
         * @private
         * @name PIXI.filters.SpriteMaskFilter
         * @see PIXI.SpriteMaskFilter
         * @deprecated since version 3.0.6
         */
        SpriteMaskFilter: {
            get: function get() {
                warn('filters.SpriteMaskFilter is an undocumented alias, please use SpriteMaskFilter from now on.');

                return core.SpriteMaskFilter;
            }
        },

        /**
         * @class
         * @private
         * @name PIXI.filters.VoidFilter
         * @see PIXI.filters.AlphaFilter
         * @deprecated since version 4.5.7
         */
        VoidFilter: {
            get: function get() {
                warn('VoidFilter has been renamed to AlphaFilter, please use PIXI.filters.AlphaFilter');

                return filters.AlphaFilter;
            }
        }
    });

    /**
     * @method
     * @name PIXI.utils.uuid
     * @see PIXI.utils.uid
     * @deprecated since version 3.0.6
     * @return {number} The uid
     */
    core.utils.uuid = function () {
        warn('utils.uuid() is deprecated, please use utils.uid() from now on.');

        return core.utils.uid();
    };

    /**
     * @method
     * @name PIXI.utils.canUseNewCanvasBlendModes
     * @see PIXI.CanvasTinter
     * @deprecated
     * @return {boolean} Can use blend modes.
     */
    core.utils.canUseNewCanvasBlendModes = function () {
        warn('utils.canUseNewCanvasBlendModes() is deprecated, please use CanvasTinter.canUseMultiply from now on');

        return core.CanvasTinter.canUseMultiply;
    };

    var saidHello = true;

    /**
     * @name PIXI.utils._saidHello
     * @type {boolean}
     * @see PIXI.utils.skipHello
     * @deprecated since 4.1.0
     */
    Object.defineProperty(core.utils, '_saidHello', {
        set: function set(bool) {
            if (bool) {
                warn('PIXI.utils._saidHello is deprecated, please use PIXI.utils.skipHello()');
                this.skipHello();
            }
            saidHello = bool;
        },
        get: function get() {
            return saidHello;
        }
    });

    if (prepare.BasePrepare) {
        /**
         * @method
         * @name PIXI.prepare.BasePrepare#register
         * @see PIXI.prepare.BasePrepare#registerFindHook
         * @deprecated since version 4.4.2
         * @param {Function} [addHook] - Function call that takes two parameters: `item:*, queue:Array`
         *        function must return `true` if it was able to add item to the queue.
         * @param {Function} [uploadHook] - Function call that takes two parameters: `prepare:CanvasPrepare, item:*` and
         *        function must return `true` if it was able to handle upload of item.
         * @return {PIXI.BasePrepare} Instance of plugin for chaining.
         */
        prepare.BasePrepare.prototype.register = function register(addHook, uploadHook) {
            warn('renderer.plugins.prepare.register is now deprecated, ' + 'please use renderer.plugins.prepare.registerFindHook & renderer.plugins.prepare.registerUploadHook');

            if (addHook) {
                this.registerFindHook(addHook);
            }

            if (uploadHook) {
                this.registerUploadHook(uploadHook);
            }

            return this;
        };
    }

    if (prepare.canvas) {
        /**
         * The number of graphics or textures to upload to the GPU.
         *
         * @name PIXI.prepare.canvas.UPLOADS_PER_FRAME
         * @static
         * @type {number}
         * @see PIXI.prepare.BasePrepare.limiter
         * @deprecated since 4.2.0
         */
        Object.defineProperty(prepare.canvas, 'UPLOADS_PER_FRAME', {
            set: function set() {
                warn('PIXI.CanvasPrepare.UPLOADS_PER_FRAME has been removed. Please set ' + 'renderer.plugins.prepare.limiter.maxItemsPerFrame on your renderer');
                // because we don't have a reference to the renderer, we can't actually set
                // the uploads per frame, so we'll have to stick with the warning.
            },
            get: function get() {
                warn('PIXI.CanvasPrepare.UPLOADS_PER_FRAME has been removed. Please use ' + 'renderer.plugins.prepare.limiter');

                return NaN;
            }
        });
    }

    if (prepare.webgl) {
        /**
         * The number of graphics or textures to upload to the GPU.
         *
         * @name PIXI.prepare.webgl.UPLOADS_PER_FRAME
         * @static
         * @type {number}
         * @see PIXI.prepare.BasePrepare.limiter
         * @deprecated since 4.2.0
         */
        Object.defineProperty(prepare.webgl, 'UPLOADS_PER_FRAME', {
            set: function set() {
                warn('PIXI.WebGLPrepare.UPLOADS_PER_FRAME has been removed. Please set ' + 'renderer.plugins.prepare.limiter.maxItemsPerFrame on your renderer');
                // because we don't have a reference to the renderer, we can't actually set
                // the uploads per frame, so we'll have to stick with the warning.
            },
            get: function get() {
                warn('PIXI.WebGLPrepare.UPLOADS_PER_FRAME has been removed. Please use ' + 'renderer.plugins.prepare.limiter');

                return NaN;
            }
        });
    }

    if (loaders.Loader) {
        var Resource = loaders.Resource;
        var Loader = loaders.Loader;

        Object.defineProperties(Resource.prototype, {
            isJson: {
                get: function get() {
                    warn('The isJson property is deprecated, please use `resource.type === Resource.TYPE.JSON`.');

                    return this.type === Resource.TYPE.JSON;
                }
            },
            isXml: {
                get: function get() {
                    warn('The isXml property is deprecated, please use `resource.type === Resource.TYPE.XML`.');

                    return this.type === Resource.TYPE.XML;
                }
            },
            isImage: {
                get: function get() {
                    warn('The isImage property is deprecated, please use `resource.type === Resource.TYPE.IMAGE`.');

                    return this.type === Resource.TYPE.IMAGE;
                }
            },
            isAudio: {
                get: function get() {
                    warn('The isAudio property is deprecated, please use `resource.type === Resource.TYPE.AUDIO`.');

                    return this.type === Resource.TYPE.AUDIO;
                }
            },
            isVideo: {
                get: function get() {
                    warn('The isVideo property is deprecated, please use `resource.type === Resource.TYPE.VIDEO`.');

                    return this.type === Resource.TYPE.VIDEO;
                }
            }
        });

        Object.defineProperties(Loader.prototype, {
            before: {
                get: function get() {
                    warn('The before() method is deprecated, please use pre().');

                    return this.pre;
                }
            },
            after: {
                get: function get() {
                    warn('The after() method is deprecated, please use use().');

                    return this.use;
                }
            }
        });
    }

    if (interaction.interactiveTarget) {
        /**
         * @name PIXI.interaction.interactiveTarget#defaultCursor
         * @static
         * @type {number}
         * @see PIXI.interaction.interactiveTarget#cursor
         * @deprecated since 4.3.0
         */
        Object.defineProperty(interaction.interactiveTarget, 'defaultCursor', {
            set: function set(value) {
                warn('Property defaultCursor has been replaced with \'cursor\'. ');
                this.cursor = value;
            },
            get: function get() {
                warn('Property defaultCursor has been replaced with \'cursor\'. ');

                return this.cursor;
            }
        });
    }

    if (interaction.InteractionManager) {
        /**
         * @name PIXI.interaction.InteractionManager#defaultCursorStyle
         * @static
         * @type {string}
         * @see PIXI.interaction.InteractionManager#cursorStyles
         * @deprecated since 4.3.0
         */
        Object.defineProperty(interaction.InteractionManager, 'defaultCursorStyle', {
            set: function set(value) {
                warn('Property defaultCursorStyle has been replaced with \'cursorStyles.default\'. ');
                this.cursorStyles.default = value;
            },
            get: function get() {
                warn('Property defaultCursorStyle has been replaced with \'cursorStyles.default\'. ');

                return this.cursorStyles.default;
            }
        });

        /**
         * @name PIXI.interaction.InteractionManager#currentCursorStyle
         * @static
         * @type {string}
         * @see PIXI.interaction.InteractionManager#cursorStyles
         * @deprecated since 4.3.0
         */
        Object.defineProperty(interaction.InteractionManager, 'currentCursorStyle', {
            set: function set(value) {
                warn('Property currentCursorStyle has been removed.' + 'See the currentCursorMode property, which works differently.');
                this.currentCursorMode = value;
            },
            get: function get() {
                warn('Property currentCursorStyle has been removed.' + 'See the currentCursorMode property, which works differently.');

                return this.currentCursorMode;
            }
        });
    }
}
//# sourceMappingURL=deprecation.js.map

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _accessibleTarget = __webpack_require__(200);

Object.defineProperty(exports, 'accessibleTarget', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_accessibleTarget).default;
  }
});

var _AccessibilityManager = __webpack_require__(401);

Object.defineProperty(exports, 'AccessibilityManager', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AccessibilityManager).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _core = __webpack_require__(7);

var core = _interopRequireWildcard(_core);

var _ismobilejs = __webpack_require__(128);

var _ismobilejs2 = _interopRequireDefault(_ismobilejs);

var _accessibleTarget = __webpack_require__(200);

var _accessibleTarget2 = _interopRequireDefault(_accessibleTarget);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// add some extra variables to the container..
core.utils.mixins.delayMixin(core.DisplayObject.prototype, _accessibleTarget2.default);

var KEY_CODE_TAB = 9;

var DIV_TOUCH_SIZE = 100;
var DIV_TOUCH_POS_X = 0;
var DIV_TOUCH_POS_Y = 0;
var DIV_TOUCH_ZINDEX = 2;

var DIV_HOOK_SIZE = 1;
var DIV_HOOK_POS_X = -1000;
var DIV_HOOK_POS_Y = -1000;
var DIV_HOOK_ZINDEX = 2;

/**
 * The Accessibility manager recreates the ability to tab and have content read by screen
 * readers. This is very important as it can possibly help people with disabilities access pixi
 * content.
 *
 * Much like interaction any DisplayObject can be made accessible. This manager will map the
 * events as if the mouse was being used, minimizing the effort required to implement.
 *
 * An instance of this class is automatically created by default, and can be found at renderer.plugins.accessibility
 *
 * @class
 * @memberof PIXI.accessibility
 */

var AccessibilityManager = function () {
    /**
     * @param {PIXI.CanvasRenderer|PIXI.WebGLRenderer} renderer - A reference to the current renderer
     */
    function AccessibilityManager(renderer) {
        _classCallCheck(this, AccessibilityManager);

        if ((_ismobilejs2.default.tablet || _ismobilejs2.default.phone) && !navigator.isCocoonJS) {
            this.createTouchHook();
        }

        // first we create a div that will sit over the PixiJS element. This is where the div overlays will go.
        var div = document.createElement('div');

        div.style.width = DIV_TOUCH_SIZE + 'px';
        div.style.height = DIV_TOUCH_SIZE + 'px';
        div.style.position = 'absolute';
        div.style.top = DIV_TOUCH_POS_X + 'px';
        div.style.left = DIV_TOUCH_POS_Y + 'px';
        div.style.zIndex = DIV_TOUCH_ZINDEX;

        /**
         * This is the dom element that will sit over the PixiJS element. This is where the div overlays will go.
         *
         * @type {HTMLElement}
         * @private
         */
        this.div = div;

        /**
         * A simple pool for storing divs.
         *
         * @type {*}
         * @private
         */
        this.pool = [];

        /**
         * This is a tick used to check if an object is no longer being rendered.
         *
         * @type {Number}
         * @private
         */
        this.renderId = 0;

        /**
         * Setting this to true will visually show the divs.
         *
         * @type {boolean}
         */
        this.debug = false;

        /**
         * The renderer this accessibility manager works for.
         *
         * @member {PIXI.SystemRenderer}
         */
        this.renderer = renderer;

        /**
         * The array of currently active accessible items.
         *
         * @member {Array<*>}
         * @private
         */
        this.children = [];

        /**
         * pre-bind the functions
         *
         * @private
         */
        this._onKeyDown = this._onKeyDown.bind(this);
        this._onMouseMove = this._onMouseMove.bind(this);

        /**
         * stores the state of the manager. If there are no accessible objects or the mouse is moving, this will be false.
         *
         * @member {Array<*>}
         * @private
         */
        this.isActive = false;
        this.isMobileAccessabillity = false;

        // let listen for tab.. once pressed we can fire up and show the accessibility layer
        window.addEventListener('keydown', this._onKeyDown, false);
    }

    /**
     * Creates the touch hooks.
     *
     */


    AccessibilityManager.prototype.createTouchHook = function createTouchHook() {
        var _this = this;

        var hookDiv = document.createElement('button');

        hookDiv.style.width = DIV_HOOK_SIZE + 'px';
        hookDiv.style.height = DIV_HOOK_SIZE + 'px';
        hookDiv.style.position = 'absolute';
        hookDiv.style.top = DIV_HOOK_POS_X + 'px';
        hookDiv.style.left = DIV_HOOK_POS_Y + 'px';
        hookDiv.style.zIndex = DIV_HOOK_ZINDEX;
        hookDiv.style.backgroundColor = '#FF0000';
        hookDiv.title = 'HOOK DIV';

        hookDiv.addEventListener('focus', function () {
            _this.isMobileAccessabillity = true;
            _this.activate();
            document.body.removeChild(hookDiv);
        });

        document.body.appendChild(hookDiv);
    };

    /**
     * Activating will cause the Accessibility layer to be shown. This is called when a user
     * preses the tab key.
     *
     * @private
     */


    AccessibilityManager.prototype.activate = function activate() {
        if (this.isActive) {
            return;
        }

        this.isActive = true;

        window.document.addEventListener('mousemove', this._onMouseMove, true);
        window.removeEventListener('keydown', this._onKeyDown, false);

        this.renderer.on('postrender', this.update, this);

        if (this.renderer.view.parentNode) {
            this.renderer.view.parentNode.appendChild(this.div);
        }
    };

    /**
     * Deactivating will cause the Accessibility layer to be hidden. This is called when a user moves
     * the mouse.
     *
     * @private
     */


    AccessibilityManager.prototype.deactivate = function deactivate() {
        if (!this.isActive || this.isMobileAccessabillity) {
            return;
        }

        this.isActive = false;

        window.document.removeEventListener('mousemove', this._onMouseMove, true);
        window.addEventListener('keydown', this._onKeyDown, false);

        this.renderer.off('postrender', this.update);

        if (this.div.parentNode) {
            this.div.parentNode.removeChild(this.div);
        }
    };

    /**
     * This recursive function will run through the scene graph and add any new accessible objects to the DOM layer.
     *
     * @private
     * @param {PIXI.Container} displayObject - The DisplayObject to check.
     */


    AccessibilityManager.prototype.updateAccessibleObjects = function updateAccessibleObjects(displayObject) {
        if (!displayObject.visible) {
            return;
        }

        if (displayObject.accessible && displayObject.interactive) {
            if (!displayObject._accessibleActive) {
                this.addChild(displayObject);
            }

            displayObject.renderId = this.renderId;
        }

        var children = displayObject.children;

        for (var i = 0; i < children.length; i++) {
            this.updateAccessibleObjects(children[i]);
        }
    };

    /**
     * Before each render this function will ensure that all divs are mapped correctly to their DisplayObjects.
     *
     * @private
     */


    AccessibilityManager.prototype.update = function update() {
        if (!this.renderer.renderingToScreen) {
            return;
        }

        // update children...
        this.updateAccessibleObjects(this.renderer._lastObjectRendered);

        var rect = this.renderer.view.getBoundingClientRect();
        var sx = rect.width / this.renderer.width;
        var sy = rect.height / this.renderer.height;

        var div = this.div;

        div.style.left = rect.left + 'px';
        div.style.top = rect.top + 'px';
        div.style.width = this.renderer.width + 'px';
        div.style.height = this.renderer.height + 'px';

        for (var i = 0; i < this.children.length; i++) {
            var child = this.children[i];

            if (child.renderId !== this.renderId) {
                child._accessibleActive = false;

                core.utils.removeItems(this.children, i, 1);
                this.div.removeChild(child._accessibleDiv);
                this.pool.push(child._accessibleDiv);
                child._accessibleDiv = null;

                i--;

                if (this.children.length === 0) {
                    this.deactivate();
                }
            } else {
                // map div to display..
                div = child._accessibleDiv;
                var hitArea = child.hitArea;
                var wt = child.worldTransform;

                if (child.hitArea) {
                    div.style.left = (wt.tx + hitArea.x * wt.a) * sx + 'px';
                    div.style.top = (wt.ty + hitArea.y * wt.d) * sy + 'px';

                    div.style.width = hitArea.width * wt.a * sx + 'px';
                    div.style.height = hitArea.height * wt.d * sy + 'px';
                } else {
                    hitArea = child.getBounds();

                    this.capHitArea(hitArea);

                    div.style.left = hitArea.x * sx + 'px';
                    div.style.top = hitArea.y * sy + 'px';

                    div.style.width = hitArea.width * sx + 'px';
                    div.style.height = hitArea.height * sy + 'px';

                    // update button titles and hints if they exist and they've changed
                    if (div.title !== child.accessibleTitle && child.accessibleTitle !== null) {
                        div.title = child.accessibleTitle;
                    }
                    if (div.getAttribute('aria-label') !== child.accessibleHint && child.accessibleHint !== null) {
                        div.setAttribute('aria-label', child.accessibleHint);
                    }
                }
            }
        }

        // increment the render id..
        this.renderId++;
    };

    /**
     * TODO: docs.
     *
     * @param {Rectangle} hitArea - TODO docs
     */


    AccessibilityManager.prototype.capHitArea = function capHitArea(hitArea) {
        if (hitArea.x < 0) {
            hitArea.width += hitArea.x;
            hitArea.x = 0;
        }

        if (hitArea.y < 0) {
            hitArea.height += hitArea.y;
            hitArea.y = 0;
        }

        if (hitArea.x + hitArea.width > this.renderer.width) {
            hitArea.width = this.renderer.width - hitArea.x;
        }

        if (hitArea.y + hitArea.height > this.renderer.height) {
            hitArea.height = this.renderer.height - hitArea.y;
        }
    };

    /**
     * Adds a DisplayObject to the accessibility manager
     *
     * @private
     * @param {DisplayObject} displayObject - The child to make accessible.
     */


    AccessibilityManager.prototype.addChild = function addChild(displayObject) {
        //    this.activate();

        var div = this.pool.pop();

        if (!div) {
            div = document.createElement('button');

            div.style.width = DIV_TOUCH_SIZE + 'px';
            div.style.height = DIV_TOUCH_SIZE + 'px';
            div.style.backgroundColor = this.debug ? 'rgba(255,0,0,0.5)' : 'transparent';
            div.style.position = 'absolute';
            div.style.zIndex = DIV_TOUCH_ZINDEX;
            div.style.borderStyle = 'none';

            // ARIA attributes ensure that button title and hint updates are announced properly
            if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
                // Chrome doesn't need aria-live to work as intended; in fact it just gets more confused.
                div.setAttribute('aria-live', 'off');
            } else {
                div.setAttribute('aria-live', 'polite');
            }

            if (navigator.userAgent.match(/rv:.*Gecko\//)) {
                // FireFox needs this to announce only the new button name
                div.setAttribute('aria-relevant', 'additions');
            } else {
                // required by IE, other browsers don't much care
                div.setAttribute('aria-relevant', 'text');
            }

            div.addEventListener('click', this._onClick.bind(this));
            div.addEventListener('focus', this._onFocus.bind(this));
            div.addEventListener('focusout', this._onFocusOut.bind(this));
        }

        if (displayObject.accessibleTitle && displayObject.accessibleTitle !== null) {
            div.title = displayObject.accessibleTitle;
        } else if (!displayObject.accessibleHint || displayObject.accessibleHint === null) {
            div.title = 'displayObject ' + displayObject.tabIndex;
        }

        if (displayObject.accessibleHint && displayObject.accessibleHint !== null) {
            div.setAttribute('aria-label', displayObject.accessibleHint);
        }

        //

        displayObject._accessibleActive = true;
        displayObject._accessibleDiv = div;
        div.displayObject = displayObject;

        this.children.push(displayObject);
        this.div.appendChild(displayObject._accessibleDiv);
        displayObject._accessibleDiv.tabIndex = displayObject.tabIndex;
    };

    /**
     * Maps the div button press to pixi's InteractionManager (click)
     *
     * @private
     * @param {MouseEvent} e - The click event.
     */


    AccessibilityManager.prototype._onClick = function _onClick(e) {
        var interactionManager = this.renderer.plugins.interaction;

        interactionManager.dispatchEvent(e.target.displayObject, 'click', interactionManager.eventData);
    };

    /**
     * Maps the div focus events to pixi's InteractionManager (mouseover)
     *
     * @private
     * @param {FocusEvent} e - The focus event.
     */


    AccessibilityManager.prototype._onFocus = function _onFocus(e) {
        if (!e.target.getAttribute('aria-live', 'off')) {
            e.target.setAttribute('aria-live', 'assertive');
        }
        var interactionManager = this.renderer.plugins.interaction;

        interactionManager.dispatchEvent(e.target.displayObject, 'mouseover', interactionManager.eventData);
    };

    /**
     * Maps the div focus events to pixi's InteractionManager (mouseout)
     *
     * @private
     * @param {FocusEvent} e - The focusout event.
     */


    AccessibilityManager.prototype._onFocusOut = function _onFocusOut(e) {
        if (!e.target.getAttribute('aria-live', 'off')) {
            e.target.setAttribute('aria-live', 'polite');
        }
        var interactionManager = this.renderer.plugins.interaction;

        interactionManager.dispatchEvent(e.target.displayObject, 'mouseout', interactionManager.eventData);
    };

    /**
     * Is called when a key is pressed
     *
     * @private
     * @param {KeyboardEvent} e - The keydown event.
     */


    AccessibilityManager.prototype._onKeyDown = function _onKeyDown(e) {
        if (e.keyCode !== KEY_CODE_TAB) {
            return;
        }

        this.activate();
    };

    /**
     * Is called when the mouse moves across the renderer element
     *
     * @private
     * @param {MouseEvent} e - The mouse event.
     */


    AccessibilityManager.prototype._onMouseMove = function _onMouseMove(e) {
        if (e.movementX === 0 && e.movementY === 0) {
            return;
        }

        this.deactivate();
    };

    /**
     * Destroys the accessibility manager
     *
     */


    AccessibilityManager.prototype.destroy = function destroy() {
        this.div = null;

        for (var i = 0; i < this.children.length; i++) {
            this.children[i].div = null;
        }

        window.document.removeEventListener('mousemove', this._onMouseMove, true);
        window.removeEventListener('keydown', this._onKeyDown);

        this.pool = null;
        this.children = null;
        this.renderer = null;
    };

    return AccessibilityManager;
}();

exports.default = AccessibilityManager;


core.WebGLRenderer.registerPlugin('accessibility', AccessibilityManager);
core.CanvasRenderer.registerPlugin('accessibility', AccessibilityManager);
//# sourceMappingURL=AccessibilityManager.js.map

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _WebGLExtract = __webpack_require__(403);

Object.defineProperty(exports, 'webgl', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_WebGLExtract).default;
  }
});

var _CanvasExtract = __webpack_require__(404);

Object.defineProperty(exports, 'canvas', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CanvasExtract).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _core = __webpack_require__(7);

var core = _interopRequireWildcard(_core);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TEMP_RECT = new core.Rectangle();
var BYTES_PER_PIXEL = 4;

/**
 * The extract manager provides functionality to export content from the renderers.
 *
 * An instance of this class is automatically created by default, and can be found at renderer.plugins.extract
 *
 * @class
 * @memberof PIXI.extract
 */

var WebGLExtract = function () {
    /**
     * @param {PIXI.WebGLRenderer} renderer - A reference to the current renderer
     */
    function WebGLExtract(renderer) {
        _classCallCheck(this, WebGLExtract);

        this.renderer = renderer;
        /**
         * Collection of methods for extracting data (image, pixels, etc.) from a display object or render texture
         *
         * @member {PIXI.extract.WebGLExtract} extract
         * @memberof PIXI.WebGLRenderer#
         * @see PIXI.extract.WebGLExtract
         */
        renderer.extract = this;
    }

    /**
     * Will return a HTML Image of the target
     *
     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
     *  to convert. If left empty will use use the main renderer
     * @return {HTMLImageElement} HTML Image of the target
     */


    WebGLExtract.prototype.image = function image(target) {
        var image = new Image();

        image.src = this.base64(target);

        return image;
    };

    /**
     * Will return a a base64 encoded string of this target. It works by calling
     *  `WebGLExtract.getCanvas` and then running toDataURL on that.
     *
     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
     *  to convert. If left empty will use use the main renderer
     * @return {string} A base64 encoded string of the texture.
     */


    WebGLExtract.prototype.base64 = function base64(target) {
        return this.canvas(target).toDataURL();
    };

    /**
     * Creates a Canvas element, renders this target to it and then returns it.
     *
     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
     *  to convert. If left empty will use use the main renderer
     * @return {HTMLCanvasElement} A Canvas element with the texture rendered on.
     */


    WebGLExtract.prototype.canvas = function canvas(target) {
        var renderer = this.renderer;
        var textureBuffer = void 0;
        var resolution = void 0;
        var frame = void 0;
        var flipY = false;
        var renderTexture = void 0;
        var generated = false;

        if (target) {
            if (target instanceof core.RenderTexture) {
                renderTexture = target;
            } else {
                renderTexture = this.renderer.generateTexture(target);
                generated = true;
            }
        }

        if (renderTexture) {
            textureBuffer = renderTexture.baseTexture._glRenderTargets[this.renderer.CONTEXT_UID];
            resolution = textureBuffer.resolution;
            frame = renderTexture.frame;
            flipY = false;
        } else {
            textureBuffer = this.renderer.rootRenderTarget;
            resolution = textureBuffer.resolution;
            flipY = true;

            frame = TEMP_RECT;
            frame.width = textureBuffer.size.width;
            frame.height = textureBuffer.size.height;
        }

        var width = Math.floor(frame.width * resolution + 1e-4);
        var height = Math.floor(frame.height * resolution + 1e-4);

        var canvasBuffer = new core.CanvasRenderTarget(width, height, 1);

        if (textureBuffer) {
            // bind the buffer
            renderer.bindRenderTarget(textureBuffer);

            // set up an array of pixels
            var webglPixels = new Uint8Array(BYTES_PER_PIXEL * width * height);

            // read pixels to the array
            var gl = renderer.gl;

            gl.readPixels(frame.x * resolution, frame.y * resolution, width, height, gl.RGBA, gl.UNSIGNED_BYTE, webglPixels);

            // add the pixels to the canvas
            var canvasData = canvasBuffer.context.getImageData(0, 0, width, height);

            canvasData.data.set(webglPixels);

            canvasBuffer.context.putImageData(canvasData, 0, 0);

            // pulling pixels
            if (flipY) {
                canvasBuffer.context.scale(1, -1);
                canvasBuffer.context.drawImage(canvasBuffer.canvas, 0, -height);
            }
        }

        if (generated) {
            renderTexture.destroy(true);
        }
        // send the canvas back..

        return canvasBuffer.canvas;
    };

    /**
     * Will return a one-dimensional array containing the pixel data of the entire texture in RGBA
     * order, with integer values between 0 and 255 (included).
     *
     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
     *  to convert. If left empty will use use the main renderer
     * @return {Uint8ClampedArray} One-dimensional array containing the pixel data of the entire texture
     */


    WebGLExtract.prototype.pixels = function pixels(target) {
        var renderer = this.renderer;
        var textureBuffer = void 0;
        var resolution = void 0;
        var frame = void 0;
        var renderTexture = void 0;
        var generated = false;

        if (target) {
            if (target instanceof core.RenderTexture) {
                renderTexture = target;
            } else {
                renderTexture = this.renderer.generateTexture(target);
                generated = true;
            }
        }

        if (renderTexture) {
            textureBuffer = renderTexture.baseTexture._glRenderTargets[this.renderer.CONTEXT_UID];
            resolution = textureBuffer.resolution;
            frame = renderTexture.frame;
        } else {
            textureBuffer = this.renderer.rootRenderTarget;
            resolution = textureBuffer.resolution;

            frame = TEMP_RECT;
            frame.width = textureBuffer.size.width;
            frame.height = textureBuffer.size.height;
        }

        var width = frame.width * resolution;
        var height = frame.height * resolution;

        var webglPixels = new Uint8Array(BYTES_PER_PIXEL * width * height);

        if (textureBuffer) {
            // bind the buffer
            renderer.bindRenderTarget(textureBuffer);
            // read pixels to the array
            var gl = renderer.gl;

            gl.readPixels(frame.x * resolution, frame.y * resolution, width, height, gl.RGBA, gl.UNSIGNED_BYTE, webglPixels);
        }

        if (generated) {
            renderTexture.destroy(true);
        }

        return webglPixels;
    };

    /**
     * Destroys the extract
     *
     */


    WebGLExtract.prototype.destroy = function destroy() {
        this.renderer.extract = null;
        this.renderer = null;
    };

    return WebGLExtract;
}();

exports.default = WebGLExtract;


core.WebGLRenderer.registerPlugin('extract', WebGLExtract);
//# sourceMappingURL=WebGLExtract.js.map

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _core = __webpack_require__(7);

var core = _interopRequireWildcard(_core);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TEMP_RECT = new core.Rectangle();

/**
 * The extract manager provides functionality to export content from the renderers.
 *
 * An instance of this class is automatically created by default, and can be found at renderer.plugins.extract
 *
 * @class
 * @memberof PIXI.extract
 */

var CanvasExtract = function () {
    /**
     * @param {PIXI.CanvasRenderer} renderer - A reference to the current renderer
     */
    function CanvasExtract(renderer) {
        _classCallCheck(this, CanvasExtract);

        this.renderer = renderer;
        /**
         * Collection of methods for extracting data (image, pixels, etc.) from a display object or render texture
         *
         * @member {PIXI.extract.CanvasExtract} extract
         * @memberof PIXI.CanvasRenderer#
         * @see PIXI.extract.CanvasExtract
         */
        renderer.extract = this;
    }

    /**
     * Will return a HTML Image of the target
     *
     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
     *  to convert. If left empty will use use the main renderer
     * @return {HTMLImageElement} HTML Image of the target
     */


    CanvasExtract.prototype.image = function image(target) {
        var image = new Image();

        image.src = this.base64(target);

        return image;
    };

    /**
     * Will return a a base64 encoded string of this target. It works by calling
     *  `CanvasExtract.getCanvas` and then running toDataURL on that.
     *
     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
     *  to convert. If left empty will use use the main renderer
     * @return {string} A base64 encoded string of the texture.
     */


    CanvasExtract.prototype.base64 = function base64(target) {
        return this.canvas(target).toDataURL();
    };

    /**
     * Creates a Canvas element, renders this target to it and then returns it.
     *
     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
     *  to convert. If left empty will use use the main renderer
     * @return {HTMLCanvasElement} A Canvas element with the texture rendered on.
     */


    CanvasExtract.prototype.canvas = function canvas(target) {
        var renderer = this.renderer;
        var context = void 0;
        var resolution = void 0;
        var frame = void 0;
        var renderTexture = void 0;

        if (target) {
            if (target instanceof core.RenderTexture) {
                renderTexture = target;
            } else {
                renderTexture = renderer.generateTexture(target);
            }
        }

        if (renderTexture) {
            context = renderTexture.baseTexture._canvasRenderTarget.context;
            resolution = renderTexture.baseTexture._canvasRenderTarget.resolution;
            frame = renderTexture.frame;
        } else {
            context = renderer.rootContext;
            resolution = renderer.resolution;
            frame = TEMP_RECT;
            frame.width = this.renderer.width;
            frame.height = this.renderer.height;
        }

        var width = Math.floor(frame.width * resolution + 1e-4);
        var height = Math.floor(frame.height * resolution + 1e-4);

        var canvasBuffer = new core.CanvasRenderTarget(width, height, 1);
        var canvasData = context.getImageData(frame.x * resolution, frame.y * resolution, width, height);

        canvasBuffer.context.putImageData(canvasData, 0, 0);

        // send the canvas back..
        return canvasBuffer.canvas;
    };

    /**
     * Will return a one-dimensional array containing the pixel data of the entire texture in RGBA
     * order, with integer values between 0 and 255 (included).
     *
     * @param {PIXI.DisplayObject|PIXI.RenderTexture} target - A displayObject or renderTexture
     *  to convert. If left empty will use use the main renderer
     * @return {Uint8ClampedArray} One-dimensional array containing the pixel data of the entire texture
     */


    CanvasExtract.prototype.pixels = function pixels(target) {
        var renderer = this.renderer;
        var context = void 0;
        var resolution = void 0;
        var frame = void 0;
        var renderTexture = void 0;

        if (target) {
            if (target instanceof core.RenderTexture) {
                renderTexture = target;
            } else {
                renderTexture = renderer.generateTexture(target);
            }
        }

        if (renderTexture) {
            context = renderTexture.baseTexture._canvasRenderTarget.context;
            resolution = renderTexture.baseTexture._canvasRenderTarget.resolution;
            frame = renderTexture.frame;
        } else {
            context = renderer.rootContext;

            frame = TEMP_RECT;
            frame.width = renderer.width;
            frame.height = renderer.height;
        }

        return context.getImageData(0, 0, frame.width * resolution, frame.height * resolution).data;
    };

    /**
     * Destroys the extract
     *
     */


    CanvasExtract.prototype.destroy = function destroy() {
        this.renderer.extract = null;
        this.renderer = null;
    };

    return CanvasExtract;
}();

exports.default = CanvasExtract;


core.CanvasRenderer.registerPlugin('extract', CanvasExtract);
//# sourceMappingURL=CanvasExtract.js.map

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _core = __webpack_require__(7);

var core = _interopRequireWildcard(_core);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @typedef PIXI.extras.AnimatedSprite~FrameObject
 * @type {object}
 * @property {PIXI.Texture} texture - The {@link PIXI.Texture} of the frame
 * @property {number} time - the duration of the frame in ms
 */

/**
 * An AnimatedSprite is a simple way to display an animation depicted by a list of textures.
 *
 * ```js
 * let alienImages = ["image_sequence_01.png","image_sequence_02.png","image_sequence_03.png","image_sequence_04.png"];
 * let textureArray = [];
 *
 * for (let i=0; i < 4; i++)
 * {
 *      let texture = PIXI.Texture.fromImage(alienImages[i]);
 *      textureArray.push(texture);
 * };
 *
 * let animatedSprite = new PIXI.extras.AnimatedSprite(textureArray);
 * ```
 *
 * The more efficient and simpler way to create an animated sprite is using a {@link PIXI.Spritesheet}
 * containing the animation definitions:
 *
 * ```js
 * PIXI.loader.add("assets/spritesheet.json").load(setup);
 *
 * function setup() {
 *   let sheet = PIXI.loader.resources["assets/spritesheet.json"].spritesheet;
 *   animatedSprite = new PIXI.extras.AnimatedSprite(sheet.animations["image_sequence"]);
 *   ...
 * }
 * ```
 *
 * @class
 * @extends PIXI.Sprite
 * @memberof PIXI.extras
 */
var AnimatedSprite = function (_core$Sprite) {
    _inherits(AnimatedSprite, _core$Sprite);

    /**
     * @param {PIXI.Texture[]|PIXI.extras.AnimatedSprite~FrameObject[]} textures - an array of {@link PIXI.Texture} or frame
     *  objects that make up the animation
     * @param {boolean} [autoUpdate=true] - Whether to use PIXI.ticker.shared to auto update animation time.
     */
    function AnimatedSprite(textures, autoUpdate) {
        _classCallCheck(this, AnimatedSprite);

        /**
         * @private
         */
        var _this = _possibleConstructorReturn(this, _core$Sprite.call(this, textures[0] instanceof core.Texture ? textures[0] : textures[0].texture));

        _this._textures = null;

        /**
         * @private
         */
        _this._durations = null;

        _this.textures = textures;

        /**
         * `true` uses PIXI.ticker.shared to auto update animation time.
         * @type {boolean}
         * @default true
         * @private
         */
        _this._autoUpdate = autoUpdate !== false;

        /**
         * The speed that the AnimatedSprite will play at. Higher is faster, lower is slower
         *
         * @member {number}
         * @default 1
         */
        _this.animationSpeed = 1;

        /**
         * Whether or not the animate sprite repeats after playing.
         *
         * @member {boolean}
         * @default true
         */
        _this.loop = true;

        /**
         * Update anchor to [Texture's defaultAnchor]{@link PIXI.Texture#defaultAnchor} when frame changes.
         *
         * Useful with [sprite sheet animations]{@link PIXI.Spritesheet#animations} created with tools.
         * Changing anchor for each frame allows to pin sprite origin to certain moving feature
         * of the frame (e.g. left foot).
         *
         * Note: Enabling this will override any previously set `anchor` on each frame change.
         *
         * @member {boolean}
         * @default false
         */
        _this.updateAnchor = false;

        /**
         * Function to call when a AnimatedSprite finishes playing
         *
         * @member {Function}
         */
        _this.onComplete = null;

        /**
         * Function to call when a AnimatedSprite changes which texture is being rendered
         *
         * @member {Function}
         */
        _this.onFrameChange = null;

        /**
        * Function to call when 'loop' is true, and an AnimatedSprite is played and loops around to start again
        *
        * @member {Function}
        */
        _this.onLoop = null;

        /**
         * Elapsed time since animation has been started, used internally to display current texture
         *
         * @member {number}
         * @private
         */
        _this._currentTime = 0;

        /**
         * Indicates if the AnimatedSprite is currently playing
         *
         * @member {boolean}
         * @readonly
         */
        _this.playing = false;
        return _this;
    }

    /**
     * Stops the AnimatedSprite
     *
     */


    AnimatedSprite.prototype.stop = function stop() {
        if (!this.playing) {
            return;
        }

        this.playing = false;
        if (this._autoUpdate) {
            core.ticker.shared.remove(this.update, this);
        }
    };

    /**
     * Plays the AnimatedSprite
     *
     */


    AnimatedSprite.prototype.play = function play() {
        if (this.playing) {
            return;
        }

        this.playing = true;
        if (this._autoUpdate) {
            core.ticker.shared.add(this.update, this, core.UPDATE_PRIORITY.HIGH);
        }
    };

    /**
     * Stops the AnimatedSprite and goes to a specific frame
     *
     * @param {number} frameNumber - frame index to stop at
     */


    AnimatedSprite.prototype.gotoAndStop = function gotoAndStop(frameNumber) {
        this.stop();

        var previousFrame = this.currentFrame;

        this._currentTime = frameNumber;

        if (previousFrame !== this.currentFrame) {
            this.updateTexture();
        }
    };

    /**
     * Goes to a specific frame and begins playing the AnimatedSprite
     *
     * @param {number} frameNumber - frame index to start at
     */


    AnimatedSprite.prototype.gotoAndPlay = function gotoAndPlay(frameNumber) {
        var previousFrame = this.currentFrame;

        this._currentTime = frameNumber;

        if (previousFrame !== this.currentFrame) {
            this.updateTexture();
        }

        this.play();
    };

    /**
     * Updates the object transform for rendering.
     *
     * @private
     * @param {number} deltaTime - Time since last tick.
     */


    AnimatedSprite.prototype.update = function update(deltaTime) {
        var elapsed = this.animationSpeed * deltaTime;
        var previousFrame = this.currentFrame;

        if (this._durations !== null) {
            var lag = this._currentTime % 1 * this._durations[this.currentFrame];

            lag += elapsed / 60 * 1000;

            while (lag < 0) {
                this._currentTime--;
                lag += this._durations[this.currentFrame];
            }

            var sign = Math.sign(this.animationSpeed * deltaTime);

            this._currentTime = Math.floor(this._currentTime);

            while (lag >= this._durations[this.currentFrame]) {
                lag -= this._durations[this.currentFrame] * sign;
                this._currentTime += sign;
            }

            this._currentTime += lag / this._durations[this.currentFrame];
        } else {
            this._currentTime += elapsed;
        }

        if (this._currentTime < 0 && !this.loop) {
            this.gotoAndStop(0);

            if (this.onComplete) {
                this.onComplete();
            }
        } else if (this._currentTime >= this._textures.length && !this.loop) {
            this.gotoAndStop(this._textures.length - 1);

            if (this.onComplete) {
                this.onComplete();
            }
        } else if (previousFrame !== this.currentFrame) {
            if (this.loop && this.onLoop) {
                if (this.animationSpeed > 0 && this.currentFrame < previousFrame) {
                    this.onLoop();
                } else if (this.animationSpeed < 0 && this.currentFrame > previousFrame) {
                    this.onLoop();
                }
            }

            this.updateTexture();
        }
    };

    /**
     * Updates the displayed texture to match the current frame index
     *
     * @private
     */


    AnimatedSprite.prototype.updateTexture = function updateTexture() {
        this._texture = this._textures[this.currentFrame];
        this._textureID = -1;
        this.cachedTint = 0xFFFFFF;

        if (this.updateAnchor) {
            this._anchor.copy(this._texture.defaultAnchor);
        }

        if (this.onFrameChange) {
            this.onFrameChange(this.currentFrame);
        }
    };

    /**
     * Stops the AnimatedSprite and destroys it
     *
     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
     *  have been set to that value
     * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
     *      method called as well. 'options' will be passed on to those calls.
     * @param {boolean} [options.texture=false] - Should it destroy the current texture of the sprite as well
     * @param {boolean} [options.baseTexture=false] - Should it destroy the base texture of the sprite as well
     */


    AnimatedSprite.prototype.destroy = function destroy(options) {
        this.stop();
        _core$Sprite.prototype.destroy.call(this, options);
    };

    /**
     * A short hand way of creating a movieclip from an array of frame ids
     *
     * @static
     * @param {string[]} frames - The array of frames ids the movieclip will use as its texture frames
     * @return {AnimatedSprite} The new animated sprite with the specified frames.
     */


    AnimatedSprite.fromFrames = function fromFrames(frames) {
        var textures = [];

        for (var i = 0; i < frames.length; ++i) {
            textures.push(core.Texture.fromFrame(frames[i]));
        }

        return new AnimatedSprite(textures);
    };

    /**
     * A short hand way of creating a movieclip from an array of image ids
     *
     * @static
     * @param {string[]} images - the array of image urls the movieclip will use as its texture frames
     * @return {AnimatedSprite} The new animate sprite with the specified images as frames.
     */


    AnimatedSprite.fromImages = function fromImages(images) {
        var textures = [];

        for (var i = 0; i < images.length; ++i) {
            textures.push(core.Texture.fromImage(images[i]));
        }

        return new AnimatedSprite(textures);
    };

    /**
     * totalFrames is the total number of frames in the AnimatedSprite. This is the same as number of textures
     * assigned to the AnimatedSprite.
     *
     * @readonly
     * @member {number}
     * @default 0
     */


    _createClass(AnimatedSprite, [{
        key: 'totalFrames',
        get: function get() {
            return this._textures.length;
        }

        /**
         * The array of textures used for this AnimatedSprite
         *
         * @member {PIXI.Texture[]}
         */

    }, {
        key: 'textures',
        get: function get() {
            return this._textures;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            if (value[0] instanceof core.Texture) {
                this._textures = value;
                this._durations = null;
            } else {
                this._textures = [];
                this._durations = [];

                for (var i = 0; i < value.length; i++) {
                    this._textures.push(value[i].texture);
                    this._durations.push(value[i].time);
                }
            }
            this.gotoAndStop(0);
            this.updateTexture();
        }

        /**
        * The AnimatedSprites current frame index
        *
        * @member {number}
        * @readonly
        */

    }, {
        key: 'currentFrame',
        get: function get() {
            var currentFrame = Math.floor(this._currentTime) % this._textures.length;

            if (currentFrame < 0) {
                currentFrame += this._textures.length;
            }

            return currentFrame;
        }
    }]);

    return AnimatedSprite;
}(core.Sprite);

exports.default = AnimatedSprite;
//# sourceMappingURL=AnimatedSprite.js.map

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _core = __webpack_require__(7);

var core = _interopRequireWildcard(_core);

var _CanvasTinter = __webpack_require__(101);

var _CanvasTinter2 = _interopRequireDefault(_CanvasTinter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var tempPoint = new core.Point();

/**
 * A tiling sprite is a fast way of rendering a tiling image
 *
 * @class
 * @extends PIXI.Sprite
 * @memberof PIXI.extras
 */

var TilingSprite = function (_core$Sprite) {
    _inherits(TilingSprite, _core$Sprite);

    /**
     * @param {PIXI.Texture} texture - the texture of the tiling sprite
     * @param {number} [width=100] - the width of the tiling sprite
     * @param {number} [height=100] - the height of the tiling sprite
     */
    function TilingSprite(texture) {
        var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
        var height = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;

        _classCallCheck(this, TilingSprite);

        /**
         * Tile transform
         *
         * @member {PIXI.TransformStatic}
         */
        var _this = _possibleConstructorReturn(this, _core$Sprite.call(this, texture));

        _this.tileTransform = new core.TransformStatic();

        // /// private

        /**
         * The with of the tiling sprite
         *
         * @member {number}
         * @private
         */
        _this._width = width;

        /**
         * The height of the tiling sprite
         *
         * @member {number}
         * @private
         */
        _this._height = height;

        /**
         * Canvas pattern
         *
         * @type {CanvasPattern}
         * @private
         */
        _this._canvasPattern = null;

        /**
         * transform that is applied to UV to get the texture coords
         *
         * @member {PIXI.TextureMatrix}
         */
        _this.uvTransform = texture.transform || new core.TextureMatrix(texture);

        /**
         * Plugin that is responsible for rendering this element.
         * Allows to customize the rendering process without overriding '_renderWebGL' method.
         *
         * @member {string}
         * @default 'tilingSprite'
         */
        _this.pluginName = 'tilingSprite';

        /**
         * Whether or not anchor affects uvs
         *
         * @member {boolean}
         * @default false
         */
        _this.uvRespectAnchor = false;
        return _this;
    }
    /**
     * Changes frame clamping in corresponding textureTransform, shortcut
     * Change to -0.5 to add a pixel to the edge, recommended for transparent trimmed textures in atlas
     *
     * @default 0.5
     * @member {number}
     */


    /**
     * @private
     */
    TilingSprite.prototype._onTextureUpdate = function _onTextureUpdate() {
        if (this.uvTransform) {
            this.uvTransform.texture = this._texture;
        }
        this.cachedTint = 0xFFFFFF;
    };

    /**
     * Renders the object using the WebGL renderer
     *
     * @private
     * @param {PIXI.WebGLRenderer} renderer - The renderer
     */


    TilingSprite.prototype._renderWebGL = function _renderWebGL(renderer) {
        // tweak our texture temporarily..
        var texture = this._texture;

        if (!texture || !texture.valid) {
            return;
        }

        this.tileTransform.updateLocalTransform();
        this.uvTransform.update();

        renderer.setObjectRenderer(renderer.plugins[this.pluginName]);
        renderer.plugins[this.pluginName].render(this);
    };

    /**
     * Renders the object using the Canvas renderer
     *
     * @private
     * @param {PIXI.CanvasRenderer} renderer - a reference to the canvas renderer
     */


    TilingSprite.prototype._renderCanvas = function _renderCanvas(renderer) {
        var texture = this._texture;

        if (!texture.baseTexture.hasLoaded) {
            return;
        }

        var context = renderer.context;
        var transform = this.worldTransform;
        var resolution = renderer.resolution;
        var isTextureRotated = texture.rotate === 2;
        var baseTexture = texture.baseTexture;
        var baseTextureResolution = baseTexture.resolution;
        var modX = this.tilePosition.x / this.tileScale.x % texture.orig.width * baseTextureResolution;
        var modY = this.tilePosition.y / this.tileScale.y % texture.orig.height * baseTextureResolution;

        // create a nice shiny pattern!
        if (this._textureID !== this._texture._updateID || this.cachedTint !== this.tint) {
            this._textureID = this._texture._updateID;
            // cut an object from a spritesheet..
            var tempCanvas = new core.CanvasRenderTarget(texture.orig.width, texture.orig.height, baseTextureResolution);

            // Tint the tiling sprite
            if (this.tint !== 0xFFFFFF) {
                this.tintedTexture = _CanvasTinter2.default.getTintedTexture(this, this.tint);
                tempCanvas.context.drawImage(this.tintedTexture, 0, 0);
            } else {
                var sx = texture._frame.x * baseTextureResolution;
                var sy = texture._frame.y * baseTextureResolution;
                var sWidth = texture._frame.width * baseTextureResolution;
                var sHeight = texture._frame.height * baseTextureResolution;
                var dWidth = (texture.trim ? texture.trim.width : texture.orig.width) * baseTextureResolution;
                var dHeight = (texture.trim ? texture.trim.height : texture.orig.height) * baseTextureResolution;
                var dx = (texture.trim ? texture.trim.x : 0) * baseTextureResolution;
                var dy = (texture.trim ? texture.trim.y : 0) * baseTextureResolution;

                if (isTextureRotated) {
                    // Apply rotation and transform
                    tempCanvas.context.rotate(-Math.PI / 2);
                    tempCanvas.context.translate(-dHeight, 0);
                    tempCanvas.context.drawImage(baseTexture.source, sx, sy, sWidth, sHeight, -dy, dx, dHeight, dWidth);
                } else {
                    tempCanvas.context.drawImage(baseTexture.source, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);
                }
            }

            this.cachedTint = this.tint;
            this._canvasPattern = tempCanvas.context.createPattern(tempCanvas.canvas, 'repeat');
        }

        // set context state..
        context.globalAlpha = this.worldAlpha;
        context.setTransform(transform.a * resolution, transform.b * resolution, transform.c * resolution, transform.d * resolution, transform.tx * resolution, transform.ty * resolution);

        renderer.setBlendMode(this.blendMode);

        // fill the pattern!
        context.fillStyle = this._canvasPattern;

        // TODO - this should be rolled into the setTransform above..
        context.scale(this.tileScale.x / baseTextureResolution, this.tileScale.y / baseTextureResolution);

        var anchorX = this.anchor.x * -this._width * baseTextureResolution;
        var anchorY = this.anchor.y * -this._height * baseTextureResolution;

        if (this.uvRespectAnchor) {
            context.translate(modX, modY);

            context.fillRect(-modX + anchorX, -modY + anchorY, this._width / this.tileScale.x * baseTextureResolution, this._height / this.tileScale.y * baseTextureResolution);
        } else {
            context.translate(modX + anchorX, modY + anchorY);

            context.fillRect(-modX, -modY, this._width / this.tileScale.x * baseTextureResolution, this._height / this.tileScale.y * baseTextureResolution);
        }
    };

    /**
     * Updates the bounds of the tiling sprite.
     *
     * @private
     */


    TilingSprite.prototype._calculateBounds = function _calculateBounds() {
        var minX = this._width * -this._anchor._x;
        var minY = this._height * -this._anchor._y;
        var maxX = this._width * (1 - this._anchor._x);
        var maxY = this._height * (1 - this._anchor._y);

        this._bounds.addFrame(this.transform, minX, minY, maxX, maxY);
    };

    /**
     * Gets the local bounds of the sprite object.
     *
     * @param {PIXI.Rectangle} rect - The output rectangle.
     * @return {PIXI.Rectangle} The bounds.
     */


    TilingSprite.prototype.getLocalBounds = function getLocalBounds(rect) {
        // we can do a fast local bounds if the sprite has no children!
        if (this.children.length === 0) {
            this._bounds.minX = this._width * -this._anchor._x;
            this._bounds.minY = this._height * -this._anchor._y;
            this._bounds.maxX = this._width * (1 - this._anchor._x);
            this._bounds.maxY = this._height * (1 - this._anchor._y);

            if (!rect) {
                if (!this._localBoundsRect) {
                    this._localBoundsRect = new core.Rectangle();
                }

                rect = this._localBoundsRect;
            }

            return this._bounds.getRectangle(rect);
        }

        return _core$Sprite.prototype.getLocalBounds.call(this, rect);
    };

    /**
     * Checks if a point is inside this tiling sprite.
     *
     * @param {PIXI.Point} point - the point to check
     * @return {boolean} Whether or not the sprite contains the point.
     */


    TilingSprite.prototype.containsPoint = function containsPoint(point) {
        this.worldTransform.applyInverse(point, tempPoint);

        var width = this._width;
        var height = this._height;
        var x1 = -width * this.anchor._x;

        if (tempPoint.x >= x1 && tempPoint.x < x1 + width) {
            var y1 = -height * this.anchor._y;

            if (tempPoint.y >= y1 && tempPoint.y < y1 + height) {
                return true;
            }
        }

        return false;
    };

    /**
     * Destroys this sprite and optionally its texture and children
     *
     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
     *  have been set to that value
     * @param {boolean} [options.children=false] - if set to true, all the children will have their destroy
     *      method called as well. 'options' will be passed on to those calls.
     * @param {boolean} [options.texture=false] - Should it destroy the current texture of the sprite as well
     * @param {boolean} [options.baseTexture=false] - Should it destroy the base texture of the sprite as well
     */


    TilingSprite.prototype.destroy = function destroy(options) {
        _core$Sprite.prototype.destroy.call(this, options);

        this.tileTransform = null;
        this.uvTransform = null;
    };

    /**
     * Helper function that creates a new tiling sprite based on the source you provide.
     * The source can be - frame id, image url, video url, canvas element, video element, base texture
     *
     * @static
     * @param {number|string|PIXI.BaseTexture|HTMLCanvasElement|HTMLVideoElement} source - Source to create texture from
     * @param {number} width - the width of the tiling sprite
     * @param {number} height - the height of the tiling sprite
     * @return {PIXI.Texture} The newly created texture
     */


    TilingSprite.from = function from(source, width, height) {
        return new TilingSprite(core.Texture.from(source), width, height);
    };

    /**
     * Helper function that creates a tiling sprite that will use a texture from the TextureCache based on the frameId
     * The frame ids are created when a Texture packer file has been loaded
     *
     * @static
     * @param {string} frameId - The frame Id of the texture in the cache
     * @param {number} width - the width of the tiling sprite
     * @param {number} height - the height of the tiling sprite
     * @return {PIXI.extras.TilingSprite} A new TilingSprite using a texture from the texture cache matching the frameId
     */


    TilingSprite.fromFrame = function fromFrame(frameId, width, height) {
        var texture = core.utils.TextureCache[frameId];

        if (!texture) {
            throw new Error('The frameId "' + frameId + '" does not exist in the texture cache ' + this);
        }

        return new TilingSprite(texture, width, height);
    };

    /**
     * Helper function that creates a sprite that will contain a texture based on an image url
     * If the image is not in the texture cache it will be loaded
     *
     * @static
     * @param {string} imageId - The image url of the texture
     * @param {number} width - the width of the tiling sprite
     * @param {number} height - the height of the tiling sprite
     * @param {boolean} [crossorigin] - if you want to specify the cross-origin parameter
     * @param {number} [scaleMode=PIXI.settings.SCALE_MODE] - if you want to specify the scale mode,
     *  see {@link PIXI.SCALE_MODES} for possible values
     * @return {PIXI.extras.TilingSprite} A new TilingSprite using a texture from the texture cache matching the image id
     */


    TilingSprite.fromImage = function fromImage(imageId, width, height, crossorigin, scaleMode) {
        return new TilingSprite(core.Texture.fromImage(imageId, crossorigin, scaleMode), width, height);
    };

    /**
     * The width of the sprite, setting this will actually modify the scale to achieve the value set
     *
     * @member {number}
     */


    _createClass(TilingSprite, [{
        key: 'clampMargin',
        get: function get() {
            return this.uvTransform.clampMargin;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.uvTransform.clampMargin = value;
            this.uvTransform.update(true);
        }

        /**
         * The scaling of the image that is being tiled
         *
         * @member {PIXI.ObservablePoint}
         */

    }, {
        key: 'tileScale',
        get: function get() {
            return this.tileTransform.scale;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.tileTransform.scale.copy(value);
        }

        /**
         * The offset of the image that is being tiled
         *
         * @member {PIXI.ObservablePoint}
         */

    }, {
        key: 'tilePosition',
        get: function get() {
            return this.tileTransform.position;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.tileTransform.position.copy(value);
        }
    }, {
        key: 'width',
        get: function get() {
            return this._width;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this._width = value;
        }

        /**
         * The height of the TilingSprite, setting this will actually modify the scale to achieve the value set
         *
         * @member {number}
         */

    }, {
        key: 'height',
        get: function get() {
            return this._height;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this._height = value;
        }
    }]);

    return TilingSprite;
}(core.Sprite);

exports.default = TilingSprite;
//# sourceMappingURL=TilingSprite.js.map

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _core = __webpack_require__(7);

var core = _interopRequireWildcard(_core);

var _const = __webpack_require__(5);

var _path = __webpack_require__(41);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var tempMat = new core.Matrix();

/**
 * WebGL renderer plugin for tiling sprites
 *
 * @class
 * @memberof PIXI.extras
 * @extends PIXI.ObjectRenderer
 */

var TilingSpriteRenderer = function (_core$ObjectRenderer) {
    _inherits(TilingSpriteRenderer, _core$ObjectRenderer);

    /**
     * constructor for renderer
     *
     * @param {WebGLRenderer} renderer The renderer this tiling awesomeness works for.
     */
    function TilingSpriteRenderer(renderer) {
        _classCallCheck(this, TilingSpriteRenderer);

        var _this = _possibleConstructorReturn(this, _core$ObjectRenderer.call(this, renderer));

        _this.shader = null;
        _this.simpleShader = null;
        _this.quad = null;
        return _this;
    }

    /**
     * Sets up the renderer context and necessary buffers.
     *
     * @private
     */


    TilingSpriteRenderer.prototype.onContextChange = function onContextChange() {
        var gl = this.renderer.gl;

        this.shader = new core.Shader(gl, 'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 translationMatrix;\nuniform mat3 uTransform;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = (uTransform * vec3(aTextureCoord, 1.0)).xy;\n}\n', 'varying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform vec4 uColor;\nuniform mat3 uMapCoord;\nuniform vec4 uClampFrame;\nuniform vec2 uClampOffset;\n\nvoid main(void)\n{\n    vec2 coord = mod(vTextureCoord - uClampOffset, vec2(1.0, 1.0)) + uClampOffset;\n    coord = (uMapCoord * vec3(coord, 1.0)).xy;\n    coord = clamp(coord, uClampFrame.xy, uClampFrame.zw);\n\n    vec4 sample = texture2D(uSampler, coord);\n    gl_FragColor = sample * uColor;\n}\n');
        this.simpleShader = new core.Shader(gl, 'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 translationMatrix;\nuniform mat3 uTransform;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = (uTransform * vec3(aTextureCoord, 1.0)).xy;\n}\n', 'varying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform vec4 uColor;\n\nvoid main(void)\n{\n    vec4 sample = texture2D(uSampler, vTextureCoord);\n    gl_FragColor = sample * uColor;\n}\n');

        this.renderer.bindVao(null);
        this.quad = new core.Quad(gl, this.renderer.state.attribState);
        this.quad.initVao(this.shader);
    };

    /**
     *
     * @param {PIXI.extras.TilingSprite} ts tilingSprite to be rendered
     */


    TilingSpriteRenderer.prototype.render = function render(ts) {
        var renderer = this.renderer;
        var quad = this.quad;

        renderer.bindVao(quad.vao);

        var vertices = quad.vertices;

        vertices[0] = vertices[6] = ts._width * -ts.anchor.x;
        vertices[1] = vertices[3] = ts._height * -ts.anchor.y;

        vertices[2] = vertices[4] = ts._width * (1.0 - ts.anchor.x);
        vertices[5] = vertices[7] = ts._height * (1.0 - ts.anchor.y);

        if (ts.uvRespectAnchor) {
            vertices = quad.uvs;

            vertices[0] = vertices[6] = -ts.anchor.x;
            vertices[1] = vertices[3] = -ts.anchor.y;

            vertices[2] = vertices[4] = 1.0 - ts.anchor.x;
            vertices[5] = vertices[7] = 1.0 - ts.anchor.y;
        }

        quad.upload();

        var tex = ts._texture;
        var baseTex = tex.baseTexture;
        var lt = ts.tileTransform.localTransform;
        var uv = ts.uvTransform;
        var isSimple = baseTex.isPowerOfTwo && tex.frame.width === baseTex.width && tex.frame.height === baseTex.height;

        // auto, force repeat wrapMode for big tiling textures
        if (isSimple) {
            if (!baseTex._glTextures[renderer.CONTEXT_UID]) {
                if (baseTex.wrapMode === _const.WRAP_MODES.CLAMP) {
                    baseTex.wrapMode = _const.WRAP_MODES.REPEAT;
                }
            } else {
                isSimple = baseTex.wrapMode !== _const.WRAP_MODES.CLAMP;
            }
        }

        var shader = isSimple ? this.simpleShader : this.shader;

        renderer.bindShader(shader);

        var w = tex.width;
        var h = tex.height;
        var W = ts._width;
        var H = ts._height;

        tempMat.set(lt.a * w / W, lt.b * w / H, lt.c * h / W, lt.d * h / H, lt.tx / W, lt.ty / H);

        // that part is the same as above:
        // tempMat.identity();
        // tempMat.scale(tex.width, tex.height);
        // tempMat.prepend(lt);
        // tempMat.scale(1.0 / ts._width, 1.0 / ts._height);

        tempMat.invert();
        if (isSimple) {
            tempMat.prepend(uv.mapCoord);
        } else {
            shader.uniforms.uMapCoord = uv.mapCoord.toArray(true);
            shader.uniforms.uClampFrame = uv.uClampFrame;
            shader.uniforms.uClampOffset = uv.uClampOffset;
        }

        shader.uniforms.uTransform = tempMat.toArray(true);
        shader.uniforms.uColor = core.utils.premultiplyTintToRgba(ts.tint, ts.worldAlpha, shader.uniforms.uColor, baseTex.premultipliedAlpha);
        shader.uniforms.translationMatrix = ts.transform.worldTransform.toArray(true);

        shader.uniforms.uSampler = renderer.bindTexture(tex);

        renderer.setBlendMode(core.utils.correctBlendMode(ts.blendMode, baseTex.premultipliedAlpha));

        quad.vao.draw(this.renderer.gl.TRIANGLES, 6, 0);
    };

    return TilingSpriteRenderer;
}(core.ObjectRenderer);

exports.default = TilingSpriteRenderer;


core.WebGLRenderer.registerPlugin('tilingSprite', TilingSpriteRenderer);
//# sourceMappingURL=TilingSpriteRenderer.js.map

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _core = __webpack_require__(7);

var core = _interopRequireWildcard(_core);

var _ObservablePoint = __webpack_require__(170);

var _ObservablePoint2 = _interopRequireDefault(_ObservablePoint);

var _utils = __webpack_require__(9);

var _settings = __webpack_require__(17);

var _settings2 = _interopRequireDefault(_settings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * A BitmapText object will create a line or multiple lines of text using bitmap font. To
 * split a line you can use '\n', '\r' or '\r\n' in your string. You can generate the fnt files using:
 *
 * A BitmapText can only be created when the font is loaded
 *
 * ```js
 * // in this case the font is in a file called 'desyrel.fnt'
 * let bitmapText = new PIXI.extras.BitmapText("text using a fancy font!", {font: "35px Desyrel", align: "right"});
 * ```
 *
 * http://www.angelcode.com/products/bmfont/ for windows or
 * http://www.bmglyph.com/ for mac.
 *
 * @class
 * @extends PIXI.Container
 * @memberof PIXI.extras
 */
var BitmapText = function (_core$Container) {
    _inherits(BitmapText, _core$Container);

    /**
     * @param {string} text - The copy that you would like the text to display
     * @param {object} style - The style parameters
     * @param {string|object} style.font - The font descriptor for the object, can be passed as a string of form
     *      "24px FontName" or "FontName" or as an object with explicit name/size properties.
     * @param {string} [style.font.name] - The bitmap font id
     * @param {number} [style.font.size] - The size of the font in pixels, e.g. 24
     * @param {string} [style.align='left'] - Alignment for multiline text ('left', 'center' or 'right'), does not affect
     *      single line text
     * @param {number} [style.tint=0xFFFFFF] - The tint color
     */
    function BitmapText(text) {
        var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        _classCallCheck(this, BitmapText);

        /**
         * Private tracker for the width of the overall text
         *
         * @member {number}
         * @private
         */
        var _this = _possibleConstructorReturn(this, _core$Container.call(this));

        _this._textWidth = 0;

        /**
         * Private tracker for the height of the overall text
         *
         * @member {number}
         * @private
         */
        _this._textHeight = 0;

        /**
         * Private tracker for the letter sprite pool.
         *
         * @member {PIXI.Sprite[]}
         * @private
         */
        _this._glyphs = [];

        /**
         * Private tracker for the current style.
         *
         * @member {object}
         * @private
         */
        _this._font = {
            tint: style.tint !== undefined ? style.tint : 0xFFFFFF,
            align: style.align || 'left',
            name: null,
            size: 0
        };

        /**
         * Private tracker for the current font.
         *
         * @member {object}
         * @private
         */
        _this.font = style.font; // run font setter

        /**
         * Private tracker for the current text.
         *
         * @member {string}
         * @private
         */
        _this._text = text;

        /**
         * The max width of this bitmap text in pixels. If the text provided is longer than the
         * value provided, line breaks will be automatically inserted in the last whitespace.
         * Disable by setting value to 0
         *
         * @member {number}
         * @private
         */
        _this._maxWidth = 0;

        /**
         * The max line height. This is useful when trying to use the total height of the Text,
         * ie: when trying to vertically align.
         *
         * @member {number}
         * @private
         */
        _this._maxLineHeight = 0;

        /**
         * Letter spacing. This is useful for setting the space between characters.
         * @member {number}
         * @private
         */
        _this._letterSpacing = 0;

        /**
         * Text anchor. read-only
         *
         * @member {PIXI.ObservablePoint}
         * @private
         */
        _this._anchor = new _ObservablePoint2.default(function () {
            _this.dirty = true;
        }, _this, 0, 0);

        /**
         * The dirty state of this object.
         *
         * @member {boolean}
         */
        _this.dirty = false;

        _this.updateText();
        return _this;
    }

    /**
     * Renders text and updates it when needed
     *
     * @private
     */


    BitmapText.prototype.updateText = function updateText() {
        var data = BitmapText.fonts[this._font.name];
        var scale = this._font.size / data.size;
        var pos = new core.Point();
        var chars = [];
        var lineWidths = [];
        var text = this.text.replace(/(?:\r\n|\r)/g, '\n');
        var textLength = text.length;
        var maxWidth = this._maxWidth * data.size / this._font.size;

        var prevCharCode = null;
        var lastLineWidth = 0;
        var maxLineWidth = 0;
        var line = 0;
        var lastBreakPos = -1;
        var lastBreakWidth = 0;
        var spacesRemoved = 0;
        var maxLineHeight = 0;

        for (var i = 0; i < textLength; i++) {
            var charCode = text.charCodeAt(i);
            var char = text.charAt(i);

            if (/(?:\s)/.test(char)) {
                lastBreakPos = i;
                lastBreakWidth = lastLineWidth;
            }

            if (char === '\r' || char === '\n') {
                lineWidths.push(lastLineWidth);
                maxLineWidth = Math.max(maxLineWidth, lastLineWidth);
                ++line;
                ++spacesRemoved;

                pos.x = 0;
                pos.y += data.lineHeight;
                prevCharCode = null;
                continue;
            }

            var charData = data.chars[charCode];

            if (!charData) {
                continue;
            }

            if (prevCharCode && charData.kerning[prevCharCode]) {
                pos.x += charData.kerning[prevCharCode];
            }

            chars.push({
                texture: charData.texture,
                line: line,
                charCode: charCode,
                position: new core.Point(pos.x + charData.xOffset + this._letterSpacing / 2, pos.y + charData.yOffset)
            });
            pos.x += charData.xAdvance + this._letterSpacing;
            lastLineWidth = pos.x;
            maxLineHeight = Math.max(maxLineHeight, charData.yOffset + charData.texture.height);
            prevCharCode = charCode;

            if (lastBreakPos !== -1 && maxWidth > 0 && pos.x > maxWidth) {
                ++spacesRemoved;
                core.utils.removeItems(chars, 1 + lastBreakPos - spacesRemoved, 1 + i - lastBreakPos);
                i = lastBreakPos;
                lastBreakPos = -1;

                lineWidths.push(lastBreakWidth);
                maxLineWidth = Math.max(maxLineWidth, lastBreakWidth);
                line++;

                pos.x = 0;
                pos.y += data.lineHeight;
                prevCharCode = null;
            }
        }

        var lastChar = text.charAt(text.length - 1);

        if (lastChar !== '\r' && lastChar !== '\n') {
            if (/(?:\s)/.test(lastChar)) {
                lastLineWidth = lastBreakWidth;
            }

            lineWidths.push(lastLineWidth);
            maxLineWidth = Math.max(maxLineWidth, lastLineWidth);
        }

        var lineAlignOffsets = [];

        for (var _i = 0; _i <= line; _i++) {
            var alignOffset = 0;

            if (this._font.align === 'right') {
                alignOffset = maxLineWidth - lineWidths[_i];
            } else if (this._font.align === 'center') {
                alignOffset = (maxLineWidth - lineWidths[_i]) / 2;
            }

            lineAlignOffsets.push(alignOffset);
        }

        var lenChars = chars.length;
        var tint = this.tint;

        for (var _i2 = 0; _i2 < lenChars; _i2++) {
            var c = this._glyphs[_i2]; // get the next glyph sprite

            if (c) {
                c.texture = chars[_i2].texture;
            } else {
                c = new core.Sprite(chars[_i2].texture);
                this._glyphs.push(c);
            }

            c.position.x = (chars[_i2].position.x + lineAlignOffsets[chars[_i2].line]) * scale;
            c.position.y = chars[_i2].position.y * scale;
            c.scale.x = c.scale.y = scale;
            c.tint = tint;

            if (!c.parent) {
                this.addChild(c);
            }
        }

        // remove unnecessary children.
        for (var _i3 = lenChars; _i3 < this._glyphs.length; ++_i3) {
            this.removeChild(this._glyphs[_i3]);
        }

        this._textWidth = maxLineWidth * scale;
        this._textHeight = (pos.y + data.lineHeight) * scale;

        // apply anchor
        if (this.anchor.x !== 0 || this.anchor.y !== 0) {
            for (var _i4 = 0; _i4 < lenChars; _i4++) {
                this._glyphs[_i4].x -= this._textWidth * this.anchor.x;
                this._glyphs[_i4].y -= this._textHeight * this.anchor.y;
            }
        }
        this._maxLineHeight = maxLineHeight * scale;
    };

    /**
     * Updates the transform of this object
     *
     * @private
     */


    BitmapText.prototype.updateTransform = function updateTransform() {
        this.validate();
        this.containerUpdateTransform();
    };

    /**
     * Validates text before calling parent's getLocalBounds
     *
     * @return {PIXI.Rectangle} The rectangular bounding area
     */


    BitmapText.prototype.getLocalBounds = function getLocalBounds() {
        this.validate();

        return _core$Container.prototype.getLocalBounds.call(this);
    };

    /**
     * Updates text when needed
     *
     * @private
     */


    BitmapText.prototype.validate = function validate() {
        if (this.dirty) {
            this.updateText();
            this.dirty = false;
        }
    };

    /**
     * The tint of the BitmapText object
     *
     * @member {number}
     */


    /**
     * Register a bitmap font with data and a texture.
     *
     * @static
     * @param {XMLDocument} xml - The XML document data.
     * @param {Object.<string, PIXI.Texture>|PIXI.Texture|PIXI.Texture[]} textures - List of textures for each page.
     *  If providing an object, the key is the `<page>` element's `file` attribute in the FNT file.
     * @return {Object} Result font object with font, size, lineHeight and char fields.
     */
    BitmapText.registerFont = function registerFont(xml, textures) {
        var data = {};
        var info = xml.getElementsByTagName('info')[0];
        var common = xml.getElementsByTagName('common')[0];
        var pages = xml.getElementsByTagName('page');
        var res = (0, _utils.getResolutionOfUrl)(pages[0].getAttribute('file'), _settings2.default.RESOLUTION);
        var pagesTextures = {};

        data.font = info.getAttribute('face');
        data.size = parseInt(info.getAttribute('size'), 10);
        data.lineHeight = parseInt(common.getAttribute('lineHeight'), 10) / res;
        data.chars = {};

        // Single texture, convert to list
        if (textures instanceof core.Texture) {
            textures = [textures];
        }

        // Convert the input Texture, Textures or object
        // into a page Texture lookup by "id"
        for (var i = 0; i < pages.length; i++) {
            var id = pages[i].getAttribute('id');
            var file = pages[i].getAttribute('file');

            pagesTextures[id] = textures instanceof Array ? textures[i] : textures[file];
        }

        // parse letters
        var letters = xml.getElementsByTagName('char');

        for (var _i5 = 0; _i5 < letters.length; _i5++) {
            var letter = letters[_i5];
            var charCode = parseInt(letter.getAttribute('id'), 10);
            var page = letter.getAttribute('page') || 0;
            var textureRect = new core.Rectangle(parseInt(letter.getAttribute('x'), 10) / res + pagesTextures[page].frame.x / res, parseInt(letter.getAttribute('y'), 10) / res + pagesTextures[page].frame.y / res, parseInt(letter.getAttribute('width'), 10) / res, parseInt(letter.getAttribute('height'), 10) / res);

            data.chars[charCode] = {
                xOffset: parseInt(letter.getAttribute('xoffset'), 10) / res,
                yOffset: parseInt(letter.getAttribute('yoffset'), 10) / res,
                xAdvance: parseInt(letter.getAttribute('xadvance'), 10) / res,
                kerning: {},
                texture: new core.Texture(pagesTextures[page].baseTexture, textureRect),
                page: page
            };
        }

        // parse kernings
        var kernings = xml.getElementsByTagName('kerning');

        for (var _i6 = 0; _i6 < kernings.length; _i6++) {
            var kerning = kernings[_i6];
            var first = parseInt(kerning.getAttribute('first'), 10) / res;
            var second = parseInt(kerning.getAttribute('second'), 10) / res;
            var amount = parseInt(kerning.getAttribute('amount'), 10) / res;

            if (data.chars[second]) {
                data.chars[second].kerning[first] = amount;
            }
        }

        // I'm leaving this as a temporary fix so we can test the bitmap fonts in v3
        // but it's very likely to change
        BitmapText.fonts[data.font] = data;

        return data;
    };

    _createClass(BitmapText, [{
        key: 'tint',
        get: function get() {
            return this._font.tint;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this._font.tint = typeof value === 'number' && value >= 0 ? value : 0xFFFFFF;

            this.dirty = true;
        }

        /**
         * The alignment of the BitmapText object
         *
         * @member {string}
         * @default 'left'
         */

    }, {
        key: 'align',
        get: function get() {
            return this._font.align;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this._font.align = value || 'left';

            this.dirty = true;
        }

        /**
         * The anchor sets the origin point of the text.
         * The default is 0,0 this means the text's origin is the top left
         * Setting the anchor to 0.5,0.5 means the text's origin is centered
         * Setting the anchor to 1,1 would mean the text's origin point will be the bottom right corner
         *
         * @member {PIXI.Point | number}
         */

    }, {
        key: 'anchor',
        get: function get() {
            return this._anchor;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            if (typeof value === 'number') {
                this._anchor.set(value);
            } else {
                this._anchor.copy(value);
            }
        }

        /**
         * The font descriptor of the BitmapText object
         *
         * @member {string|object}
         */

    }, {
        key: 'font',
        get: function get() {
            return this._font;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            if (!value) {
                return;
            }

            if (typeof value === 'string') {
                value = value.split(' ');

                this._font.name = value.length === 1 ? value[0] : value.slice(1).join(' ');
                this._font.size = value.length >= 2 ? parseInt(value[0], 10) : BitmapText.fonts[this._font.name].size;
            } else {
                this._font.name = value.name;
                this._font.size = typeof value.size === 'number' ? value.size : parseInt(value.size, 10);
            }

            this.dirty = true;
        }

        /**
         * The text of the BitmapText object
         *
         * @member {string}
         */

    }, {
        key: 'text',
        get: function get() {
            return this._text;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            value = value.toString() || ' ';
            if (this._text === value) {
                return;
            }
            this._text = value;
            this.dirty = true;
        }

        /**
         * The max width of this bitmap text in pixels. If the text provided is longer than the
         * value provided, line breaks will be automatically inserted in the last whitespace.
         * Disable by setting value to 0
         *
         * @member {number}
         */

    }, {
        key: 'maxWidth',
        get: function get() {
            return this._maxWidth;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            if (this._maxWidth === value) {
                return;
            }
            this._maxWidth = value;
            this.dirty = true;
        }

        /**
         * The max line height. This is useful when trying to use the total height of the Text,
         * ie: when trying to vertically align.
         *
         * @member {number}
         * @readonly
         */

    }, {
        key: 'maxLineHeight',
        get: function get() {
            this.validate();

            return this._maxLineHeight;
        }

        /**
         * The width of the overall text, different from fontSize,
         * which is defined in the style object
         *
         * @member {number}
         * @readonly
         */

    }, {
        key: 'textWidth',
        get: function get() {
            this.validate();

            return this._textWidth;
        }

        /**
         * Additional space between characters.
         *
         * @member {number}
         */

    }, {
        key: 'letterSpacing',
        get: function get() {
            return this._letterSpacing;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            if (this._letterSpacing !== value) {
                this._letterSpacing = value;
                this.dirty = true;
            }
        }

        /**
         * The height of the overall text, different from fontSize,
         * which is defined in the style object
         *
         * @member {number}
         * @readonly
         */

    }, {
        key: 'textHeight',
        get: function get() {
            this.validate();

            return this._textHeight;
        }
    }]);

    return BitmapText;
}(core.Container);

exports.default = BitmapText;


BitmapText.fonts = {};
//# sourceMappingURL=BitmapText.js.map

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var core = _interopRequireWildcard(_core);

var _Texture = __webpack_require__(49);

var _Texture2 = _interopRequireDefault(_Texture);

var _BaseTexture = __webpack_require__(68);

var _BaseTexture2 = _interopRequireDefault(_BaseTexture);

var _utils = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DisplayObject = core.DisplayObject;
var _tempMatrix = new core.Matrix();

DisplayObject.prototype._cacheAsBitmap = false;
DisplayObject.prototype._cacheData = false;

// figured theres no point adding ALL the extra variables to prototype.
// this model can hold the information needed. This can also be generated on demand as
// most objects are not cached as bitmaps.
/**
 * @class
 * @ignore
 */

var CacheData =
/**
 *
 */
function CacheData() {
    _classCallCheck(this, CacheData);

    this.textureCacheId = null;

    this.originalRenderWebGL = null;
    this.originalRenderCanvas = null;
    this.originalCalculateBounds = null;
    this.originalGetLocalBounds = null;

    this.originalUpdateTransform = null;
    this.originalHitTest = null;
    this.originalDestroy = null;
    this.originalMask = null;
    this.originalFilterArea = null;
    this.sprite = null;
};

Object.defineProperties(DisplayObject.prototype, {
    /**
     * Set this to true if you want this display object to be cached as a bitmap.
     * This basically takes a snap shot of the display object as it is at that moment. It can
     * provide a performance benefit for complex static displayObjects.
     * To remove simply set this property to 'false'
     *
     * IMPORTANT GOTCHA - make sure that all your textures are preloaded BEFORE setting this property to true
     * as it will take a snapshot of what is currently there. If the textures have not loaded then they will not appear.
     *
     * @member {boolean}
     * @memberof PIXI.DisplayObject#
     */
    cacheAsBitmap: {
        get: function get() {
            return this._cacheAsBitmap;
        },
        set: function set(value) {
            if (this._cacheAsBitmap === value) {
                return;
            }

            this._cacheAsBitmap = value;

            var data = void 0;

            if (value) {
                if (!this._cacheData) {
                    this._cacheData = new CacheData();
                }

                data = this._cacheData;

                data.originalRenderWebGL = this.renderWebGL;
                data.originalRenderCanvas = this.renderCanvas;

                data.originalUpdateTransform = this.updateTransform;
                data.originalCalculateBounds = this.calculateBounds;
                data.originalGetLocalBounds = this.getLocalBounds;

                data.originalDestroy = this.destroy;

                data.originalContainsPoint = this.containsPoint;

                data.originalMask = this._mask;
                data.originalFilterArea = this.filterArea;

                this.renderWebGL = this._renderCachedWebGL;
                this.renderCanvas = this._renderCachedCanvas;

                this.destroy = this._cacheAsBitmapDestroy;
            } else {
                data = this._cacheData;

                if (data.sprite) {
                    this._destroyCachedDisplayObject();
                }

                this.renderWebGL = data.originalRenderWebGL;
                this.renderCanvas = data.originalRenderCanvas;
                this.calculateBounds = data.originalCalculateBounds;
                this.getLocalBounds = data.originalGetLocalBounds;

                this.destroy = data.originalDestroy;

                this.updateTransform = data.originalUpdateTransform;
                this.containsPoint = data.originalContainsPoint;

                this._mask = data.originalMask;
                this.filterArea = data.originalFilterArea;
            }
        }
    }
});

/**
 * Renders a cached version of the sprite with WebGL
 *
 * @private
 * @memberof PIXI.DisplayObject#
 * @param {PIXI.WebGLRenderer} renderer - the WebGL renderer
 */
DisplayObject.prototype._renderCachedWebGL = function _renderCachedWebGL(renderer) {
    if (!this.visible || this.worldAlpha <= 0 || !this.renderable) {
        return;
    }

    this._initCachedDisplayObject(renderer);

    this._cacheData.sprite.transform._worldID = this.transform._worldID;
    this._cacheData.sprite.worldAlpha = this.worldAlpha;
    this._cacheData.sprite._renderWebGL(renderer);
};

/**
 * Prepares the WebGL renderer to cache the sprite
 *
 * @private
 * @memberof PIXI.DisplayObject#
 * @param {PIXI.WebGLRenderer} renderer - the WebGL renderer
 */
DisplayObject.prototype._initCachedDisplayObject = function _initCachedDisplayObject(renderer) {
    if (this._cacheData && this._cacheData.sprite) {
        return;
    }

    // make sure alpha is set to 1 otherwise it will get rendered as invisible!
    var cacheAlpha = this.alpha;

    this.alpha = 1;

    // first we flush anything left in the renderer (otherwise it would get rendered to the cached texture)
    renderer.currentRenderer.flush();
    // this.filters= [];

    // next we find the dimensions of the untransformed object
    // this function also calls updatetransform on all its children as part of the measuring.
    // This means we don't need to update the transform again in this function
    // TODO pass an object to clone too? saves having to create a new one each time!
    var bounds = this.getLocalBounds().clone();

    // add some padding!
    if (this._filters && this._filters.length) {
        var padding = this._filters[0].padding;

        bounds.pad(padding);
    }

    bounds.ceil(core.settings.RESOLUTION);

    // for now we cache the current renderTarget that the webGL renderer is currently using.
    // this could be more elegent..
    var cachedRenderTarget = renderer._activeRenderTarget;
    // We also store the filter stack - I will definitely look to change how this works a little later down the line.
    var stack = renderer.filterManager.filterStack;

    // this renderTexture will be used to store the cached DisplayObject

    var renderTexture = core.RenderTexture.create(bounds.width, bounds.height);

    var textureCacheId = 'cacheAsBitmap_' + (0, _utils.uid)();

    this._cacheData.textureCacheId = textureCacheId;

    _BaseTexture2.default.addToCache(renderTexture.baseTexture, textureCacheId);
    _Texture2.default.addToCache(renderTexture, textureCacheId);

    // need to set //
    var m = _tempMatrix;

    m.tx = -bounds.x;
    m.ty = -bounds.y;

    // reset
    this.transform.worldTransform.identity();

    // set all properties to there original so we can render to a texture
    this.renderWebGL = this._cacheData.originalRenderWebGL;

    renderer.render(this, renderTexture, true, m, true);
    // now restore the state be setting the new properties

    renderer.bindRenderTarget(cachedRenderTarget);

    renderer.filterManager.filterStack = stack;

    this.renderWebGL = this._renderCachedWebGL;
    // the rest is the same as for Canvas
    this.updateTransform = this.displayObjectUpdateTransform;
    this.calculateBounds = this._calculateCachedBounds;
    this.getLocalBounds = this._getCachedLocalBounds;

    this._mask = null;
    this.filterArea = null;

    // create our cached sprite
    var cachedSprite = new core.Sprite(renderTexture);

    cachedSprite.transform.worldTransform = this.transform.worldTransform;
    cachedSprite.anchor.x = -(bounds.x / bounds.width);
    cachedSprite.anchor.y = -(bounds.y / bounds.height);
    cachedSprite.alpha = cacheAlpha;
    cachedSprite._bounds = this._bounds;

    this._cacheData.sprite = cachedSprite;

    this.transform._parentID = -1;
    // restore the transform of the cached sprite to avoid the nasty flicker..
    if (!this.parent) {
        this.parent = renderer._tempDisplayObjectParent;
        this.updateTransform();
        this.parent = null;
    } else {
        this.updateTransform();
    }

    // map the hit test..
    this.containsPoint = cachedSprite.containsPoint.bind(cachedSprite);
};

/**
 * Renders a cached version of the sprite with canvas
 *
 * @private
 * @memberof PIXI.DisplayObject#
 * @param {PIXI.WebGLRenderer} renderer - the WebGL renderer
 */
DisplayObject.prototype._renderCachedCanvas = function _renderCachedCanvas(renderer) {
    if (!this.visible || this.worldAlpha <= 0 || !this.renderable) {
        return;
    }

    this._initCachedDisplayObjectCanvas(renderer);

    this._cacheData.sprite.worldAlpha = this.worldAlpha;
    this._cacheData.sprite._renderCanvas(renderer);
};

// TODO this can be the same as the webGL verison.. will need to do a little tweaking first though..
/**
 * Prepares the Canvas renderer to cache the sprite
 *
 * @private
 * @memberof PIXI.DisplayObject#
 * @param {PIXI.WebGLRenderer} renderer - the WebGL renderer
 */
DisplayObject.prototype._initCachedDisplayObjectCanvas = function _initCachedDisplayObjectCanvas(renderer) {
    if (this._cacheData && this._cacheData.sprite) {
        return;
    }

    // get bounds actually transforms the object for us already!
    var bounds = this.getLocalBounds();

    var cacheAlpha = this.alpha;

    this.alpha = 1;

    var cachedRenderTarget = renderer.context;

    bounds.ceil(core.settings.RESOLUTION);

    var renderTexture = core.RenderTexture.create(bounds.width, bounds.height);

    var textureCacheId = 'cacheAsBitmap_' + (0, _utils.uid)();

    this._cacheData.textureCacheId = textureCacheId;

    _BaseTexture2.default.addToCache(renderTexture.baseTexture, textureCacheId);
    _Texture2.default.addToCache(renderTexture, textureCacheId);

    // need to set //
    var m = _tempMatrix;

    this.transform.localTransform.copy(m);
    m.invert();

    m.tx -= bounds.x;
    m.ty -= bounds.y;

    // m.append(this.transform.worldTransform.)
    // set all properties to there original so we can render to a texture
    this.renderCanvas = this._cacheData.originalRenderCanvas;

    // renderTexture.render(this, m, true);
    renderer.render(this, renderTexture, true, m, false);

    // now restore the state be setting the new properties
    renderer.context = cachedRenderTarget;

    this.renderCanvas = this._renderCachedCanvas;
    // the rest is the same as for WebGL
    this.updateTransform = this.displayObjectUpdateTransform;
    this.calculateBounds = this._calculateCachedBounds;
    this.getLocalBounds = this._getCachedLocalBounds;

    this._mask = null;
    this.filterArea = null;

    // create our cached sprite
    var cachedSprite = new core.Sprite(renderTexture);

    cachedSprite.transform.worldTransform = this.transform.worldTransform;
    cachedSprite.anchor.x = -(bounds.x / bounds.width);
    cachedSprite.anchor.y = -(bounds.y / bounds.height);
    cachedSprite.alpha = cacheAlpha;
    cachedSprite._bounds = this._bounds;

    this._cacheData.sprite = cachedSprite;

    this.transform._parentID = -1;
    // restore the transform of the cached sprite to avoid the nasty flicker..
    if (!this.parent) {
        this.parent = renderer._tempDisplayObjectParent;
        this.updateTransform();
        this.parent = null;
    } else {
        this.updateTransform();
    }

    // map the hit test..
    this.containsPoint = cachedSprite.containsPoint.bind(cachedSprite);
};

/**
 * Calculates the bounds of the cached sprite
 *
 * @private
 */
DisplayObject.prototype._calculateCachedBounds = function _calculateCachedBounds() {
    this._bounds.clear();
    this._cacheData.sprite.transform._worldID = this.transform._worldID;
    this._cacheData.sprite._calculateBounds();
    this._lastBoundsID = this._boundsID;
};

/**
 * Gets the bounds of the cached sprite.
 *
 * @private
 * @return {Rectangle} The local bounds.
 */
DisplayObject.prototype._getCachedLocalBounds = function _getCachedLocalBounds() {
    return this._cacheData.sprite.getLocalBounds();
};

/**
 * Destroys the cached sprite.
 *
 * @private
 */
DisplayObject.prototype._destroyCachedDisplayObject = function _destroyCachedDisplayObject() {
    this._cacheData.sprite._texture.destroy(true);
    this._cacheData.sprite = null;

    _BaseTexture2.default.removeFromCache(this._cacheData.textureCacheId);
    _Texture2.default.removeFromCache(this._cacheData.textureCacheId);

    this._cacheData.textureCacheId = null;
};

/**
 * Destroys the cached object.
 *
 * @private
 * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
 *  have been set to that value.
 *  Used when destroying containers, see the Container.destroy method.
 */
DisplayObject.prototype._cacheAsBitmapDestroy = function _cacheAsBitmapDestroy(options) {
    this.cacheAsBitmap = false;
    this.destroy(options);
};
//# sourceMappingURL=cacheAsBitmap.js.map

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var core = _interopRequireWildcard(_core);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * The instance name of the object.
 *
 * @memberof PIXI.DisplayObject#
 * @member {string} name
 */
core.DisplayObject.prototype.name = null;

/**
 * Returns the display object in the container
 *
 * @method getChildByName
 * @memberof PIXI.Container#
 * @param {string} name - instance name
 * @return {PIXI.DisplayObject} The child with the specified name.
 */
core.Container.prototype.getChildByName = function getChildByName(name) {
    for (var i = 0; i < this.children.length; i++) {
        if (this.children[i].name === name) {
            return this.children[i];
        }
    }

    return null;
};
//# sourceMappingURL=getChildByName.js.map

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _core = __webpack_require__(7);

var core = _interopRequireWildcard(_core);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/**
 * Returns the global position of the displayObject. Does not depend on object scale, rotation and pivot.
 *
 * @method getGlobalPosition
 * @memberof PIXI.DisplayObject#
 * @param {Point} point - the point to write the global value to. If null a new point will be returned
 * @param {boolean} skipUpdate - setting to true will stop the transforms of the scene graph from
 *  being updated. This means the calculation returned MAY be out of date BUT will give you a
 *  nice performance boost
 * @return {Point} The updated point
 */
core.DisplayObject.prototype.getGlobalPosition = function getGlobalPosition() {
    var point = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new core.Point();
    var skipUpdate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (this.parent) {
        this.parent.toGlobal(this.position, point, skipUpdate);
    } else {
        point.x = this.position.x;
        point.y = this.position.y;
    }

    return point;
};
//# sourceMappingURL=getGlobalPosition.js.map

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _FXAAFilter = __webpack_require__(413);

Object.defineProperty(exports, 'FXAAFilter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FXAAFilter).default;
  }
});

var _NoiseFilter = __webpack_require__(414);

Object.defineProperty(exports, 'NoiseFilter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_NoiseFilter).default;
  }
});

var _DisplacementFilter = __webpack_require__(415);

Object.defineProperty(exports, 'DisplacementFilter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DisplacementFilter).default;
  }
});

var _BlurFilter = __webpack_require__(416);

Object.defineProperty(exports, 'BlurFilter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BlurFilter).default;
  }
});

var _BlurXFilter = __webpack_require__(202);

Object.defineProperty(exports, 'BlurXFilter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BlurXFilter).default;
  }
});

var _BlurYFilter = __webpack_require__(206);

Object.defineProperty(exports, 'BlurYFilter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BlurYFilter).default;
  }
});

var _ColorMatrixFilter = __webpack_require__(417);

Object.defineProperty(exports, 'ColorMatrixFilter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ColorMatrixFilter).default;
  }
});

var _AlphaFilter = __webpack_require__(418);

Object.defineProperty(exports, 'AlphaFilter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AlphaFilter).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _core = __webpack_require__(7);

var core = _interopRequireWildcard(_core);

var _path = __webpack_require__(41);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 *
 * Basic FXAA implementation based on the code on geeks3d.com with the
 * modification that the texture2DLod stuff was removed since it's
 * unsupported by WebGL.
 *
 * @see https://github.com/mitsuhiko/webgl-meincraft
 *
 * @class
 * @extends PIXI.Filter
 * @memberof PIXI.filters
 *
 */
var FXAAFilter = function (_core$Filter) {
    _inherits(FXAAFilter, _core$Filter);

    /**
     *
     */
    function FXAAFilter() {
        _classCallCheck(this, FXAAFilter);

        // TODO - needs work
        return _possibleConstructorReturn(this, _core$Filter.call(this,
        // vertex shader
        '\nattribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 v_rgbNW;\nvarying vec2 v_rgbNE;\nvarying vec2 v_rgbSW;\nvarying vec2 v_rgbSE;\nvarying vec2 v_rgbM;\n\nuniform vec4 filterArea;\n\nvarying vec2 vTextureCoord;\n\nvec2 mapCoord( vec2 coord )\n{\n    coord *= filterArea.xy;\n    coord += filterArea.zw;\n\n    return coord;\n}\n\nvec2 unmapCoord( vec2 coord )\n{\n    coord -= filterArea.zw;\n    coord /= filterArea.xy;\n\n    return coord;\n}\n\nvoid texcoords(vec2 fragCoord, vec2 resolution,\n               out vec2 v_rgbNW, out vec2 v_rgbNE,\n               out vec2 v_rgbSW, out vec2 v_rgbSE,\n               out vec2 v_rgbM) {\n    vec2 inverseVP = 1.0 / resolution.xy;\n    v_rgbNW = (fragCoord + vec2(-1.0, -1.0)) * inverseVP;\n    v_rgbNE = (fragCoord + vec2(1.0, -1.0)) * inverseVP;\n    v_rgbSW = (fragCoord + vec2(-1.0, 1.0)) * inverseVP;\n    v_rgbSE = (fragCoord + vec2(1.0, 1.0)) * inverseVP;\n    v_rgbM = vec2(fragCoord * inverseVP);\n}\n\nvoid main(void) {\n\n   gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n   vTextureCoord = aTextureCoord;\n\n   vec2 fragCoord = vTextureCoord * filterArea.xy;\n\n   texcoords(fragCoord, filterArea.xy, v_rgbNW, v_rgbNE, v_rgbSW, v_rgbSE, v_rgbM);\n}',
        // fragment shader
        'varying vec2 v_rgbNW;\nvarying vec2 v_rgbNE;\nvarying vec2 v_rgbSW;\nvarying vec2 v_rgbSE;\nvarying vec2 v_rgbM;\n\nvarying vec2 vTextureCoord;\nuniform sampler2D uSampler;\nuniform vec4 filterArea;\n\n/**\n Basic FXAA implementation based on the code on geeks3d.com with the\n modification that the texture2DLod stuff was removed since it\'s\n unsupported by WebGL.\n \n --\n \n From:\n https://github.com/mitsuhiko/webgl-meincraft\n \n Copyright (c) 2011 by Armin Ronacher.\n \n Some rights reserved.\n \n Redistribution and use in source and binary forms, with or without\n modification, are permitted provided that the following conditions are\n met:\n \n * Redistributions of source code must retain the above copyright\n notice, this list of conditions and the following disclaimer.\n \n * Redistributions in binary form must reproduce the above\n copyright notice, this list of conditions and the following\n disclaimer in the documentation and/or other materials provided\n with the distribution.\n \n * The names of the contributors may not be used to endorse or\n promote products derived from this software without specific\n prior written permission.\n \n THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS\n "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT\n LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR\n A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT\n OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,\n SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT\n LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,\n DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY\n THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT\n (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE\n OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.\n */\n\n#ifndef FXAA_REDUCE_MIN\n#define FXAA_REDUCE_MIN   (1.0/ 128.0)\n#endif\n#ifndef FXAA_REDUCE_MUL\n#define FXAA_REDUCE_MUL   (1.0 / 8.0)\n#endif\n#ifndef FXAA_SPAN_MAX\n#define FXAA_SPAN_MAX     8.0\n#endif\n\n//optimized version for mobile, where dependent\n//texture reads can be a bottleneck\nvec4 fxaa(sampler2D tex, vec2 fragCoord, vec2 resolution,\n          vec2 v_rgbNW, vec2 v_rgbNE,\n          vec2 v_rgbSW, vec2 v_rgbSE,\n          vec2 v_rgbM) {\n    vec4 color;\n    mediump vec2 inverseVP = vec2(1.0 / resolution.x, 1.0 / resolution.y);\n    vec3 rgbNW = texture2D(tex, v_rgbNW).xyz;\n    vec3 rgbNE = texture2D(tex, v_rgbNE).xyz;\n    vec3 rgbSW = texture2D(tex, v_rgbSW).xyz;\n    vec3 rgbSE = texture2D(tex, v_rgbSE).xyz;\n    vec4 texColor = texture2D(tex, v_rgbM);\n    vec3 rgbM  = texColor.xyz;\n    vec3 luma = vec3(0.299, 0.587, 0.114);\n    float lumaNW = dot(rgbNW, luma);\n    float lumaNE = dot(rgbNE, luma);\n    float lumaSW = dot(rgbSW, luma);\n    float lumaSE = dot(rgbSE, luma);\n    float lumaM  = dot(rgbM,  luma);\n    float lumaMin = min(lumaM, min(min(lumaNW, lumaNE), min(lumaSW, lumaSE)));\n    float lumaMax = max(lumaM, max(max(lumaNW, lumaNE), max(lumaSW, lumaSE)));\n    \n    mediump vec2 dir;\n    dir.x = -((lumaNW + lumaNE) - (lumaSW + lumaSE));\n    dir.y =  ((lumaNW + lumaSW) - (lumaNE + lumaSE));\n    \n    float dirReduce = max((lumaNW + lumaNE + lumaSW + lumaSE) *\n                          (0.25 * FXAA_REDUCE_MUL), FXAA_REDUCE_MIN);\n    \n    float rcpDirMin = 1.0 / (min(abs(dir.x), abs(dir.y)) + dirReduce);\n    dir = min(vec2(FXAA_SPAN_MAX, FXAA_SPAN_MAX),\n              max(vec2(-FXAA_SPAN_MAX, -FXAA_SPAN_MAX),\n                  dir * rcpDirMin)) * inverseVP;\n    \n    vec3 rgbA = 0.5 * (\n                       texture2D(tex, fragCoord * inverseVP + dir * (1.0 / 3.0 - 0.5)).xyz +\n                       texture2D(tex, fragCoord * inverseVP + dir * (2.0 / 3.0 - 0.5)).xyz);\n    vec3 rgbB = rgbA * 0.5 + 0.25 * (\n                                     texture2D(tex, fragCoord * inverseVP + dir * -0.5).xyz +\n                                     texture2D(tex, fragCoord * inverseVP + dir * 0.5).xyz);\n    \n    float lumaB = dot(rgbB, luma);\n    if ((lumaB < lumaMin) || (lumaB > lumaMax))\n        color = vec4(rgbA, texColor.a);\n    else\n        color = vec4(rgbB, texColor.a);\n    return color;\n}\n\nvoid main() {\n\n      vec2 fragCoord = vTextureCoord * filterArea.xy;\n\n      vec4 color;\n\n    color = fxaa(uSampler, fragCoord, filterArea.xy, v_rgbNW, v_rgbNE, v_rgbSW, v_rgbSE, v_rgbM);\n\n      gl_FragColor = color;\n}\n'));
    }

    return FXAAFilter;
}(core.Filter);

exports.default = FXAAFilter;
//# sourceMappingURL=FXAAFilter.js.map

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _core = __webpack_require__(7);

var core = _interopRequireWildcard(_core);

var _path = __webpack_require__(41);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @author Vico @vicocotea
 * original filter: https://github.com/evanw/glfx.js/blob/master/src/filters/adjust/noise.js
 */

/**
 * A Noise effect filter.
 *
 * @class
 * @extends PIXI.Filter
 * @memberof PIXI.filters
 */
var NoiseFilter = function (_core$Filter) {
    _inherits(NoiseFilter, _core$Filter);

    /**
     * @param {number} noise - The noise intensity, should be a normalized value in the range [0, 1].
     * @param {number} seed - A random seed for the noise generation. Default is `Math.random()`.
     */
    function NoiseFilter() {
        var noise = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.5;
        var seed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Math.random();

        _classCallCheck(this, NoiseFilter);

        var _this = _possibleConstructorReturn(this, _core$Filter.call(this,
        // vertex shader
        'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n    vTextureCoord = aTextureCoord;\n}',
        // fragment shader
        'precision highp float;\n\nvarying vec2 vTextureCoord;\nvarying vec4 vColor;\n\nuniform float uNoise;\nuniform float uSeed;\nuniform sampler2D uSampler;\n\nfloat rand(vec2 co)\n{\n    return fract(sin(dot(co.xy, vec2(12.9898, 78.233))) * 43758.5453);\n}\n\nvoid main()\n{\n    vec4 color = texture2D(uSampler, vTextureCoord);\n    float randomValue = rand(gl_FragCoord.xy * uSeed);\n    float diff = (randomValue - 0.5) * uNoise;\n\n    // Un-premultiply alpha before applying the color matrix. See issue #3539.\n    if (color.a > 0.0) {\n        color.rgb /= color.a;\n    }\n\n    color.r += diff;\n    color.g += diff;\n    color.b += diff;\n\n    // Premultiply alpha again.\n    color.rgb *= color.a;\n\n    gl_FragColor = color;\n}\n'));

        _this.noise = noise;
        _this.seed = seed;
        return _this;
    }

    /**
     * The amount of noise to apply, this value should be in the range (0, 1].
     *
     * @member {number}
     * @default 0.5
     */


    _createClass(NoiseFilter, [{
        key: 'noise',
        get: function get() {
            return this.uniforms.uNoise;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.uniforms.uNoise = value;
        }

        /**
         * A seed value to apply to the random noise generation. `Math.random()` is a good value to use.
         *
         * @member {number}
         */

    }, {
        key: 'seed',
        get: function get() {
            return this.uniforms.uSeed;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.uniforms.uSeed = value;
        }
    }]);

    return NoiseFilter;
}(core.Filter);

exports.default = NoiseFilter;
//# sourceMappingURL=NoiseFilter.js.map

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _core = __webpack_require__(7);

var core = _interopRequireWildcard(_core);

var _path = __webpack_require__(41);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The DisplacementFilter class uses the pixel values from the specified texture
 * (called the displacement map) to perform a displacement of an object. You can
 * use this filter to apply all manor of crazy warping effects. Currently the r
 * property of the texture is used to offset the x and the g property of the texture
 * is used to offset the y.
 *
 * @class
 * @extends PIXI.Filter
 * @memberof PIXI.filters
 */
var DisplacementFilter = function (_core$Filter) {
    _inherits(DisplacementFilter, _core$Filter);

    /**
     * @param {PIXI.Sprite} sprite - The sprite used for the displacement map. (make sure its added to the scene!)
     * @param {number} scale - The scale of the displacement
     */
    function DisplacementFilter(sprite, scale) {
        _classCallCheck(this, DisplacementFilter);

        var maskMatrix = new core.Matrix();

        sprite.renderable = false;

        var _this = _possibleConstructorReturn(this, _core$Filter.call(this,
        // vertex shader
        'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 filterMatrix;\n\nvarying vec2 vTextureCoord;\nvarying vec2 vFilterCoord;\n\nvoid main(void)\n{\n   gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n   vFilterCoord = ( filterMatrix * vec3( aTextureCoord, 1.0)  ).xy;\n   vTextureCoord = aTextureCoord;\n}',
        // fragment shader
        'varying vec2 vFilterCoord;\nvarying vec2 vTextureCoord;\n\nuniform vec2 scale;\n\nuniform sampler2D uSampler;\nuniform sampler2D mapSampler;\n\nuniform vec4 filterArea;\nuniform vec4 filterClamp;\n\nvoid main(void)\n{\n  vec4 map =  texture2D(mapSampler, vFilterCoord);\n\n  map -= 0.5;\n  map.xy *= scale / filterArea.xy;\n\n  gl_FragColor = texture2D(uSampler, clamp(vec2(vTextureCoord.x + map.x, vTextureCoord.y + map.y), filterClamp.xy, filterClamp.zw));\n}\n'));

        _this.maskSprite = sprite;
        _this.maskMatrix = maskMatrix;

        _this.uniforms.mapSampler = sprite._texture;
        _this.uniforms.filterMatrix = maskMatrix;
        _this.uniforms.scale = { x: 1, y: 1 };

        if (scale === null || scale === undefined) {
            scale = 20;
        }

        _this.scale = new core.Point(scale, scale);
        return _this;
    }

    /**
     * Applies the filter.
     *
     * @param {PIXI.FilterManager} filterManager - The manager.
     * @param {PIXI.RenderTarget} input - The input target.
     * @param {PIXI.RenderTarget} output - The output target.
     */


    DisplacementFilter.prototype.apply = function apply(filterManager, input, output) {
        this.uniforms.filterMatrix = filterManager.calculateSpriteMatrix(this.maskMatrix, this.maskSprite);
        this.uniforms.scale.x = this.scale.x;
        this.uniforms.scale.y = this.scale.y;

        // draw the filter...
        filterManager.applyFilter(this, input, output);
    };

    /**
     * The texture used for the displacement map. Must be power of 2 sized texture.
     *
     * @member {PIXI.Texture}
     */


    _createClass(DisplacementFilter, [{
        key: 'map',
        get: function get() {
            return this.uniforms.mapSampler;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.uniforms.mapSampler = value;
        }
    }]);

    return DisplacementFilter;
}(core.Filter);

exports.default = DisplacementFilter;
//# sourceMappingURL=DisplacementFilter.js.map

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _core = __webpack_require__(7);

var core = _interopRequireWildcard(_core);

var _BlurXFilter = __webpack_require__(202);

var _BlurXFilter2 = _interopRequireDefault(_BlurXFilter);

var _BlurYFilter = __webpack_require__(206);

var _BlurYFilter2 = _interopRequireDefault(_BlurYFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The BlurFilter applies a Gaussian blur to an object.
 * The strength of the blur can be set for x- and y-axis separately.
 *
 * @class
 * @extends PIXI.Filter
 * @memberof PIXI.filters
 */
var BlurFilter = function (_core$Filter) {
    _inherits(BlurFilter, _core$Filter);

    /**
     * @param {number} strength - The strength of the blur filter.
     * @param {number} quality - The quality of the blur filter.
     * @param {number} resolution - The resolution of the blur filter.
     * @param {number} [kernelSize=5] - The kernelSize of the blur filter.Options: 5, 7, 9, 11, 13, 15.
     */
    function BlurFilter(strength, quality, resolution, kernelSize) {
        _classCallCheck(this, BlurFilter);

        var _this = _possibleConstructorReturn(this, _core$Filter.call(this));

        _this.blurXFilter = new _BlurXFilter2.default(strength, quality, resolution, kernelSize);
        _this.blurYFilter = new _BlurYFilter2.default(strength, quality, resolution, kernelSize);

        _this.padding = 0;
        _this.resolution = resolution || core.settings.RESOLUTION;
        _this.quality = quality || 4;
        _this.blur = strength || 8;
        return _this;
    }

    /**
     * Applies the filter.
     *
     * @param {PIXI.FilterManager} filterManager - The manager.
     * @param {PIXI.RenderTarget} input - The input target.
     * @param {PIXI.RenderTarget} output - The output target.
     */


    BlurFilter.prototype.apply = function apply(filterManager, input, output) {
        var renderTarget = filterManager.getRenderTarget(true);

        this.blurXFilter.apply(filterManager, input, renderTarget, true);
        this.blurYFilter.apply(filterManager, renderTarget, output, false);

        filterManager.returnRenderTarget(renderTarget);
    };

    /**
     * Sets the strength of both the blurX and blurY properties simultaneously
     *
     * @member {number}
     * @default 2
     */


    _createClass(BlurFilter, [{
        key: 'blur',
        get: function get() {
            return this.blurXFilter.blur;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.blurXFilter.blur = this.blurYFilter.blur = value;
            this.padding = Math.max(Math.abs(this.blurXFilter.strength), Math.abs(this.blurYFilter.strength)) * 2;
        }

        /**
         * Sets the number of passes for blur. More passes means higher quaility bluring.
         *
         * @member {number}
         * @default 1
         */

    }, {
        key: 'quality',
        get: function get() {
            return this.blurXFilter.quality;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.blurXFilter.quality = this.blurYFilter.quality = value;
        }

        /**
         * Sets the strength of the blurX property
         *
         * @member {number}
         * @default 2
         */

    }, {
        key: 'blurX',
        get: function get() {
            return this.blurXFilter.blur;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.blurXFilter.blur = value;
            this.padding = Math.max(Math.abs(this.blurXFilter.strength), Math.abs(this.blurYFilter.strength)) * 2;
        }

        /**
         * Sets the strength of the blurY property
         *
         * @member {number}
         * @default 2
         */

    }, {
        key: 'blurY',
        get: function get() {
            return this.blurYFilter.blur;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.blurYFilter.blur = value;
            this.padding = Math.max(Math.abs(this.blurXFilter.strength), Math.abs(this.blurYFilter.strength)) * 2;
        }

        /**
         * Sets the blendmode of the filter
         *
         * @member {number}
         * @default PIXI.BLEND_MODES.NORMAL
         */

    }, {
        key: 'blendMode',
        get: function get() {
            return this.blurYFilter._blendMode;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.blurYFilter._blendMode = value;
        }
    }]);

    return BlurFilter;
}(core.Filter);

exports.default = BlurFilter;
//# sourceMappingURL=BlurFilter.js.map

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _core = __webpack_require__(7);

var core = _interopRequireWildcard(_core);

var _path = __webpack_require__(41);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The ColorMatrixFilter class lets you apply a 5x4 matrix transformation on the RGBA
 * color and alpha values of every pixel on your displayObject to produce a result
 * with a new set of RGBA color and alpha values. It's pretty powerful!
 *
 * ```js
 *  let colorMatrix = new PIXI.filters.ColorMatrixFilter();
 *  container.filters = [colorMatrix];
 *  colorMatrix.contrast(2);
 * ```
 * @author Clément Chenebault <clement@goodboydigital.com>
 * @class
 * @extends PIXI.Filter
 * @memberof PIXI.filters
 */
var ColorMatrixFilter = function (_core$Filter) {
    _inherits(ColorMatrixFilter, _core$Filter);

    /**
     *
     */
    function ColorMatrixFilter() {
        _classCallCheck(this, ColorMatrixFilter);

        var _this = _possibleConstructorReturn(this, _core$Filter.call(this,
        // vertex shader
        'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n    vTextureCoord = aTextureCoord;\n}',
        // fragment shader
        'varying vec2 vTextureCoord;\nuniform sampler2D uSampler;\nuniform float m[20];\nuniform float uAlpha;\n\nvoid main(void)\n{\n    vec4 c = texture2D(uSampler, vTextureCoord);\n\n    if (uAlpha == 0.0) {\n        gl_FragColor = c;\n        return;\n    }\n\n    // Un-premultiply alpha before applying the color matrix. See issue #3539.\n    if (c.a > 0.0) {\n      c.rgb /= c.a;\n    }\n\n    vec4 result;\n\n    result.r = (m[0] * c.r);\n        result.r += (m[1] * c.g);\n        result.r += (m[2] * c.b);\n        result.r += (m[3] * c.a);\n        result.r += m[4];\n\n    result.g = (m[5] * c.r);\n        result.g += (m[6] * c.g);\n        result.g += (m[7] * c.b);\n        result.g += (m[8] * c.a);\n        result.g += m[9];\n\n    result.b = (m[10] * c.r);\n       result.b += (m[11] * c.g);\n       result.b += (m[12] * c.b);\n       result.b += (m[13] * c.a);\n       result.b += m[14];\n\n    result.a = (m[15] * c.r);\n       result.a += (m[16] * c.g);\n       result.a += (m[17] * c.b);\n       result.a += (m[18] * c.a);\n       result.a += m[19];\n\n    vec3 rgb = mix(c.rgb, result.rgb, uAlpha);\n\n    // Premultiply alpha again.\n    rgb *= result.a;\n\n    gl_FragColor = vec4(rgb, result.a);\n}\n'));

        _this.uniforms.m = [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0];

        _this.alpha = 1;
        return _this;
    }

    /**
     * Transforms current matrix and set the new one
     *
     * @param {number[]} matrix - 5x4 matrix
     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */


    ColorMatrixFilter.prototype._loadMatrix = function _loadMatrix(matrix) {
        var multiply = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var newMatrix = matrix;

        if (multiply) {
            this._multiply(newMatrix, this.uniforms.m, matrix);
            newMatrix = this._colorMatrix(newMatrix);
        }

        // set the new matrix
        this.uniforms.m = newMatrix;
    };

    /**
     * Multiplies two mat5's
     *
     * @private
     * @param {number[]} out - 5x4 matrix the receiving matrix
     * @param {number[]} a - 5x4 matrix the first operand
     * @param {number[]} b - 5x4 matrix the second operand
     * @returns {number[]} 5x4 matrix
     */


    ColorMatrixFilter.prototype._multiply = function _multiply(out, a, b) {
        // Red Channel
        out[0] = a[0] * b[0] + a[1] * b[5] + a[2] * b[10] + a[3] * b[15];
        out[1] = a[0] * b[1] + a[1] * b[6] + a[2] * b[11] + a[3] * b[16];
        out[2] = a[0] * b[2] + a[1] * b[7] + a[2] * b[12] + a[3] * b[17];
        out[3] = a[0] * b[3] + a[1] * b[8] + a[2] * b[13] + a[3] * b[18];
        out[4] = a[0] * b[4] + a[1] * b[9] + a[2] * b[14] + a[3] * b[19] + a[4];

        // Green Channel
        out[5] = a[5] * b[0] + a[6] * b[5] + a[7] * b[10] + a[8] * b[15];
        out[6] = a[5] * b[1] + a[6] * b[6] + a[7] * b[11] + a[8] * b[16];
        out[7] = a[5] * b[2] + a[6] * b[7] + a[7] * b[12] + a[8] * b[17];
        out[8] = a[5] * b[3] + a[6] * b[8] + a[7] * b[13] + a[8] * b[18];
        out[9] = a[5] * b[4] + a[6] * b[9] + a[7] * b[14] + a[8] * b[19] + a[9];

        // Blue Channel
        out[10] = a[10] * b[0] + a[11] * b[5] + a[12] * b[10] + a[13] * b[15];
        out[11] = a[10] * b[1] + a[11] * b[6] + a[12] * b[11] + a[13] * b[16];
        out[12] = a[10] * b[2] + a[11] * b[7] + a[12] * b[12] + a[13] * b[17];
        out[13] = a[10] * b[3] + a[11] * b[8] + a[12] * b[13] + a[13] * b[18];
        out[14] = a[10] * b[4] + a[11] * b[9] + a[12] * b[14] + a[13] * b[19] + a[14];

        // Alpha Channel
        out[15] = a[15] * b[0] + a[16] * b[5] + a[17] * b[10] + a[18] * b[15];
        out[16] = a[15] * b[1] + a[16] * b[6] + a[17] * b[11] + a[18] * b[16];
        out[17] = a[15] * b[2] + a[16] * b[7] + a[17] * b[12] + a[18] * b[17];
        out[18] = a[15] * b[3] + a[16] * b[8] + a[17] * b[13] + a[18] * b[18];
        out[19] = a[15] * b[4] + a[16] * b[9] + a[17] * b[14] + a[18] * b[19] + a[19];

        return out;
    };

    /**
     * Create a Float32 Array and normalize the offset component to 0-1
     *
     * @private
     * @param {number[]} matrix - 5x4 matrix
     * @return {number[]} 5x4 matrix with all values between 0-1
     */


    ColorMatrixFilter.prototype._colorMatrix = function _colorMatrix(matrix) {
        // Create a Float32 Array and normalize the offset component to 0-1
        var m = new Float32Array(matrix);

        m[4] /= 255;
        m[9] /= 255;
        m[14] /= 255;
        m[19] /= 255;

        return m;
    };

    /**
     * Adjusts brightness
     *
     * @param {number} b - value of the brigthness (0-1, where 0 is black)
     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */


    ColorMatrixFilter.prototype.brightness = function brightness(b, multiply) {
        var matrix = [b, 0, 0, 0, 0, 0, b, 0, 0, 0, 0, 0, b, 0, 0, 0, 0, 0, 1, 0];

        this._loadMatrix(matrix, multiply);
    };

    /**
     * Set the matrices in grey scales
     *
     * @param {number} scale - value of the grey (0-1, where 0 is black)
     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */


    ColorMatrixFilter.prototype.greyscale = function greyscale(scale, multiply) {
        var matrix = [scale, scale, scale, 0, 0, scale, scale, scale, 0, 0, scale, scale, scale, 0, 0, 0, 0, 0, 1, 0];

        this._loadMatrix(matrix, multiply);
    };

    /**
     * Set the black and white matrice.
     *
     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */


    ColorMatrixFilter.prototype.blackAndWhite = function blackAndWhite(multiply) {
        var matrix = [0.3, 0.6, 0.1, 0, 0, 0.3, 0.6, 0.1, 0, 0, 0.3, 0.6, 0.1, 0, 0, 0, 0, 0, 1, 0];

        this._loadMatrix(matrix, multiply);
    };

    /**
     * Set the hue property of the color
     *
     * @param {number} rotation - in degrees
     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */


    ColorMatrixFilter.prototype.hue = function hue(rotation, multiply) {
        rotation = (rotation || 0) / 180 * Math.PI;

        var cosR = Math.cos(rotation);
        var sinR = Math.sin(rotation);
        var sqrt = Math.sqrt;

        /* a good approximation for hue rotation
         This matrix is far better than the versions with magic luminance constants
         formerly used here, but also used in the starling framework (flash) and known from this
         old part of the internet: quasimondo.com/archives/000565.php
          This new matrix is based on rgb cube rotation in space. Look here for a more descriptive
         implementation as a shader not a general matrix:
         https://github.com/evanw/glfx.js/blob/58841c23919bd59787effc0333a4897b43835412/src/filters/adjust/huesaturation.js
          This is the source for the code:
         see http://stackoverflow.com/questions/8507885/shift-hue-of-an-rgb-color/8510751#8510751
         */

        var w = 1 / 3;
        var sqrW = sqrt(w); // weight is

        var a00 = cosR + (1.0 - cosR) * w;
        var a01 = w * (1.0 - cosR) - sqrW * sinR;
        var a02 = w * (1.0 - cosR) + sqrW * sinR;

        var a10 = w * (1.0 - cosR) + sqrW * sinR;
        var a11 = cosR + w * (1.0 - cosR);
        var a12 = w * (1.0 - cosR) - sqrW * sinR;

        var a20 = w * (1.0 - cosR) - sqrW * sinR;
        var a21 = w * (1.0 - cosR) + sqrW * sinR;
        var a22 = cosR + w * (1.0 - cosR);

        var matrix = [a00, a01, a02, 0, 0, a10, a11, a12, 0, 0, a20, a21, a22, 0, 0, 0, 0, 0, 1, 0];

        this._loadMatrix(matrix, multiply);
    };

    /**
     * Set the contrast matrix, increase the separation between dark and bright
     * Increase contrast : shadows darker and highlights brighter
     * Decrease contrast : bring the shadows up and the highlights down
     *
     * @param {number} amount - value of the contrast (0-1)
     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */


    ColorMatrixFilter.prototype.contrast = function contrast(amount, multiply) {
        var v = (amount || 0) + 1;
        var o = -0.5 * (v - 1);

        var matrix = [v, 0, 0, 0, o, 0, v, 0, 0, o, 0, 0, v, 0, o, 0, 0, 0, 1, 0];

        this._loadMatrix(matrix, multiply);
    };

    /**
     * Set the saturation matrix, increase the separation between colors
     * Increase saturation : increase contrast, brightness, and sharpness
     *
     * @param {number} amount - The saturation amount (0-1)
     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */


    ColorMatrixFilter.prototype.saturate = function saturate() {
        var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var multiply = arguments[1];

        var x = amount * 2 / 3 + 1;
        var y = (x - 1) * -0.5;

        var matrix = [x, y, y, 0, 0, y, x, y, 0, 0, y, y, x, 0, 0, 0, 0, 0, 1, 0];

        this._loadMatrix(matrix, multiply);
    };

    /**
     * Desaturate image (remove color)
     *
     * Call the saturate function
     *
     */


    ColorMatrixFilter.prototype.desaturate = function desaturate() // eslint-disable-line no-unused-vars
    {
        this.saturate(-1);
    };

    /**
     * Negative image (inverse of classic rgb matrix)
     *
     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */


    ColorMatrixFilter.prototype.negative = function negative(multiply) {
        var matrix = [-1, 0, 0, 1, 0, 0, -1, 0, 1, 0, 0, 0, -1, 1, 0, 0, 0, 0, 1, 0];

        this._loadMatrix(matrix, multiply);
    };

    /**
     * Sepia image
     *
     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */


    ColorMatrixFilter.prototype.sepia = function sepia(multiply) {
        var matrix = [0.393, 0.7689999, 0.18899999, 0, 0, 0.349, 0.6859999, 0.16799999, 0, 0, 0.272, 0.5339999, 0.13099999, 0, 0, 0, 0, 0, 1, 0];

        this._loadMatrix(matrix, multiply);
    };

    /**
     * Color motion picture process invented in 1916 (thanks Dominic Szablewski)
     *
     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */


    ColorMatrixFilter.prototype.technicolor = function technicolor(multiply) {
        var matrix = [1.9125277891456083, -0.8545344976951645, -0.09155508482755585, 0, 11.793603434377337, -0.3087833385928097, 1.7658908555458428, -0.10601743074722245, 0, -70.35205161461398, -0.231103377548616, -0.7501899197440212, 1.847597816108189, 0, 30.950940869491138, 0, 0, 0, 1, 0];

        this._loadMatrix(matrix, multiply);
    };

    /**
     * Polaroid filter
     *
     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */


    ColorMatrixFilter.prototype.polaroid = function polaroid(multiply) {
        var matrix = [1.438, -0.062, -0.062, 0, 0, -0.122, 1.378, -0.122, 0, 0, -0.016, -0.016, 1.483, 0, 0, 0, 0, 0, 1, 0];

        this._loadMatrix(matrix, multiply);
    };

    /**
     * Filter who transforms : Red -> Blue and Blue -> Red
     *
     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */


    ColorMatrixFilter.prototype.toBGR = function toBGR(multiply) {
        var matrix = [0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 1, 0];

        this._loadMatrix(matrix, multiply);
    };

    /**
     * Color reversal film introduced by Eastman Kodak in 1935. (thanks Dominic Szablewski)
     *
     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */


    ColorMatrixFilter.prototype.kodachrome = function kodachrome(multiply) {
        var matrix = [1.1285582396593525, -0.3967382283601348, -0.03992559172921793, 0, 63.72958762196502, -0.16404339962244616, 1.0835251566291304, -0.05498805115633132, 0, 24.732407896706203, -0.16786010706155763, -0.5603416277695248, 1.6014850761964943, 0, 35.62982807460946, 0, 0, 0, 1, 0];

        this._loadMatrix(matrix, multiply);
    };

    /**
     * Brown delicious browni filter (thanks Dominic Szablewski)
     *
     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */


    ColorMatrixFilter.prototype.browni = function browni(multiply) {
        var matrix = [0.5997023498159715, 0.34553243048391263, -0.2708298674538042, 0, 47.43192855600873, -0.037703249837783157, 0.8609577587992641, 0.15059552388459913, 0, -36.96841498319127, 0.24113635128153335, -0.07441037908422492, 0.44972182064877153, 0, -7.562075277591283, 0, 0, 0, 1, 0];

        this._loadMatrix(matrix, multiply);
    };

    /**
     * Vintage filter (thanks Dominic Szablewski)
     *
     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */


    ColorMatrixFilter.prototype.vintage = function vintage(multiply) {
        var matrix = [0.6279345635605994, 0.3202183420819367, -0.03965408211312453, 0, 9.651285835294123, 0.02578397704808868, 0.6441188644374771, 0.03259127616149294, 0, 7.462829176470591, 0.0466055556782719, -0.0851232987247891, 0.5241648018700465, 0, 5.159190588235296, 0, 0, 0, 1, 0];

        this._loadMatrix(matrix, multiply);
    };

    /**
     * We don't know exactly what it does, kind of gradient map, but funny to play with!
     *
     * @param {number} desaturation - Tone values.
     * @param {number} toned - Tone values.
     * @param {string} lightColor - Tone values, example: `0xFFE580`
     * @param {string} darkColor - Tone values, example: `0xFFE580`
     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */


    ColorMatrixFilter.prototype.colorTone = function colorTone(desaturation, toned, lightColor, darkColor, multiply) {
        desaturation = desaturation || 0.2;
        toned = toned || 0.15;
        lightColor = lightColor || 0xFFE580;
        darkColor = darkColor || 0x338000;

        var lR = (lightColor >> 16 & 0xFF) / 255;
        var lG = (lightColor >> 8 & 0xFF) / 255;
        var lB = (lightColor & 0xFF) / 255;

        var dR = (darkColor >> 16 & 0xFF) / 255;
        var dG = (darkColor >> 8 & 0xFF) / 255;
        var dB = (darkColor & 0xFF) / 255;

        var matrix = [0.3, 0.59, 0.11, 0, 0, lR, lG, lB, desaturation, 0, dR, dG, dB, toned, 0, lR - dR, lG - dG, lB - dB, 0, 0];

        this._loadMatrix(matrix, multiply);
    };

    /**
     * Night effect
     *
     * @param {number} intensity - The intensity of the night effect.
     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */


    ColorMatrixFilter.prototype.night = function night(intensity, multiply) {
        intensity = intensity || 0.1;
        var matrix = [intensity * -2.0, -intensity, 0, 0, 0, -intensity, 0, intensity, 0, 0, 0, intensity, intensity * 2.0, 0, 0, 0, 0, 0, 1, 0];

        this._loadMatrix(matrix, multiply);
    };

    /**
     * Predator effect
     *
     * Erase the current matrix by setting a new indepent one
     *
     * @param {number} amount - how much the predator feels his future victim
     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */


    ColorMatrixFilter.prototype.predator = function predator(amount, multiply) {
        var matrix = [
        // row 1
        11.224130630493164 * amount, -4.794486999511719 * amount, -2.8746118545532227 * amount, 0 * amount, 0.40342438220977783 * amount,
        // row 2
        -3.6330697536468506 * amount, 9.193157196044922 * amount, -2.951810836791992 * amount, 0 * amount, -1.316135048866272 * amount,
        // row 3
        -3.2184197902679443 * amount, -4.2375030517578125 * amount, 7.476448059082031 * amount, 0 * amount, 0.8044459223747253 * amount,
        // row 4
        0, 0, 0, 1, 0];

        this._loadMatrix(matrix, multiply);
    };

    /**
     * LSD effect
     *
     * Multiply the current matrix
     *
     * @param {boolean} multiply - if true, current matrix and matrix are multiplied. If false,
     *  just set the current matrix with @param matrix
     */


    ColorMatrixFilter.prototype.lsd = function lsd(multiply) {
        var matrix = [2, -0.4, 0.5, 0, 0, -0.5, 2, -0.4, 0, 0, -0.4, -0.5, 3, 0, 0, 0, 0, 0, 1, 0];

        this._loadMatrix(matrix, multiply);
    };

    /**
     * Erase the current matrix by setting the default one
     *
     */


    ColorMatrixFilter.prototype.reset = function reset() {
        var matrix = [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0];

        this._loadMatrix(matrix, false);
    };

    /**
     * The matrix of the color matrix filter
     *
     * @member {number[]}
     * @default [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0]
     */


    _createClass(ColorMatrixFilter, [{
        key: 'matrix',
        get: function get() {
            return this.uniforms.m;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.uniforms.m = value;
        }

        /**
         * The opacity value to use when mixing the original and resultant colors.
         *
         * When the value is 0, the original color is used without modification.
         * When the value is 1, the result color is used.
         * When in the range (0, 1) the color is interpolated between the original and result by this amount.
         *
         * @member {number}
         * @default 1
         */

    }, {
        key: 'alpha',
        get: function get() {
            return this.uniforms.uAlpha;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.uniforms.uAlpha = value;
        }
    }]);

    return ColorMatrixFilter;
}(core.Filter);

// Americanized alias


exports.default = ColorMatrixFilter;
ColorMatrixFilter.prototype.grayscale = ColorMatrixFilter.prototype.greyscale;
//# sourceMappingURL=ColorMatrixFilter.js.map

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _core = __webpack_require__(7);

var core = _interopRequireWildcard(_core);

var _path = __webpack_require__(41);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Simplest filter - applies alpha
 *
 * Use this instead of Container's alpha property to avoid visual layering of individual elements.
 * AlphaFilter applies alpha evenly across the entire display object and any opaque elements it contains.
 * If elements are not opaque, they will blend with each other anyway.
 *
 * Very handy if you want to use common features of all filters:
 *
 * 1. Assign a blendMode to this filter, blend all elements inside display object with background.
 *
 * 2. To use clipping in display coordinates, assign a filterArea to the same container that has this filter.
 *
 * @class
 * @extends PIXI.Filter
 * @memberof PIXI.filters
 */
var AlphaFilter = function (_core$Filter) {
    _inherits(AlphaFilter, _core$Filter);

    /**
     * @param {number} [alpha=1] Amount of alpha from 0 to 1, where 0 is transparent
     */
    function AlphaFilter() {
        var alpha = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1.0;

        _classCallCheck(this, AlphaFilter);

        var _this = _possibleConstructorReturn(this, _core$Filter.call(this,
        // vertex shader
        'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n    vTextureCoord = aTextureCoord;\n}',
        // fragment shader
        'varying vec2 vTextureCoord;\n\nuniform sampler2D uSampler;\nuniform float uAlpha;\n\nvoid main(void)\n{\n   gl_FragColor = texture2D(uSampler, vTextureCoord) * uAlpha;\n}\n'));

        _this.alpha = alpha;
        _this.glShaderKey = 'alpha';
        return _this;
    }

    /**
     * Coefficient for alpha multiplication
     *
     * @member {number}
     * @default 1
     */


    _createClass(AlphaFilter, [{
        key: 'alpha',
        get: function get() {
            return this.uniforms.uAlpha;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this.uniforms.uAlpha = value;
        }
    }]);

    return AlphaFilter;
}(core.Filter);

exports.default = AlphaFilter;
//# sourceMappingURL=AlphaFilter.js.map

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _InteractionData = __webpack_require__(207);

Object.defineProperty(exports, 'InteractionData', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InteractionData).default;
  }
});

var _InteractionManager = __webpack_require__(420);

Object.defineProperty(exports, 'InteractionManager', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InteractionManager).default;
  }
});

var _interactiveTarget = __webpack_require__(210);

Object.defineProperty(exports, 'interactiveTarget', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_interactiveTarget).default;
  }
});

var _InteractionTrackingData = __webpack_require__(209);

Object.defineProperty(exports, 'InteractionTrackingData', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InteractionTrackingData).default;
  }
});

var _InteractionEvent = __webpack_require__(208);

Object.defineProperty(exports, 'InteractionEvent', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InteractionEvent).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _core = __webpack_require__(7);

var core = _interopRequireWildcard(_core);

var _InteractionData = __webpack_require__(207);

var _InteractionData2 = _interopRequireDefault(_InteractionData);

var _InteractionEvent = __webpack_require__(208);

var _InteractionEvent2 = _interopRequireDefault(_InteractionEvent);

var _InteractionTrackingData = __webpack_require__(209);

var _InteractionTrackingData2 = _interopRequireDefault(_InteractionTrackingData);

var _eventemitter = __webpack_require__(60);

var _eventemitter2 = _interopRequireDefault(_eventemitter);

var _interactiveTarget = __webpack_require__(210);

var _interactiveTarget2 = _interopRequireDefault(_interactiveTarget);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Mix interactiveTarget into core.DisplayObject.prototype, after deprecation has been handled
core.utils.mixins.delayMixin(core.DisplayObject.prototype, _interactiveTarget2.default);

var MOUSE_POINTER_ID = 1;

// helpers for hitTest() - only used inside hitTest()
var hitTestEvent = {
    target: null,
    data: {
        global: null
    }
};

/**
 * The interaction manager deals with mouse, touch and pointer events. Any DisplayObject can be interactive
 * if its interactive parameter is set to true
 * This manager also supports multitouch.
 *
 * An instance of this class is automatically created by default, and can be found at renderer.plugins.interaction
 *
 * @class
 * @extends EventEmitter
 * @memberof PIXI.interaction
 */

var InteractionManager = function (_EventEmitter) {
    _inherits(InteractionManager, _EventEmitter);

    /**
     * @param {PIXI.CanvasRenderer|PIXI.WebGLRenderer} renderer - A reference to the current renderer
     * @param {object} [options] - The options for the manager.
     * @param {boolean} [options.autoPreventDefault=true] - Should the manager automatically prevent default browser actions.
     * @param {number} [options.interactionFrequency=10] - Frequency increases the interaction events will be checked.
     */
    function InteractionManager(renderer, options) {
        _classCallCheck(this, InteractionManager);

        var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));

        options = options || {};

        /**
         * The renderer this interaction manager works for.
         *
         * @member {PIXI.SystemRenderer}
         */
        _this.renderer = renderer;

        /**
         * Should default browser actions automatically be prevented.
         * Does not apply to pointer events for backwards compatibility
         * preventDefault on pointer events stops mouse events from firing
         * Thus, for every pointer event, there will always be either a mouse of touch event alongside it.
         *
         * @member {boolean}
         * @default true
         */
        _this.autoPreventDefault = options.autoPreventDefault !== undefined ? options.autoPreventDefault : true;

        /**
         * Frequency in milliseconds that the mousemove, moveover & mouseout interaction events will be checked.
         *
         * @member {number}
         * @default 10
         */
        _this.interactionFrequency = options.interactionFrequency || 10;

        /**
         * The mouse data
         *
         * @member {PIXI.interaction.InteractionData}
         */
        _this.mouse = new _InteractionData2.default();
        _this.mouse.identifier = MOUSE_POINTER_ID;

        // setting the mouse to start off far off screen will mean that mouse over does
        //  not get called before we even move the mouse.
        _this.mouse.global.set(-999999);

        /**
         * Actively tracked InteractionData
         *
         * @private
         * @member {Object.<number,PIXI.interation.InteractionData>}
         */
        _this.activeInteractionData = {};
        _this.activeInteractionData[MOUSE_POINTER_ID] = _this.mouse;

        /**
         * Pool of unused InteractionData
         *
         * @private
         * @member {PIXI.interation.InteractionData[]}
         */
        _this.interactionDataPool = [];

        /**
         * An event data object to handle all the event tracking/dispatching
         *
         * @member {object}
         */
        _this.eventData = new _InteractionEvent2.default();

        /**
         * The DOM element to bind to.
         *
         * @private
         * @member {HTMLElement}
         */
        _this.interactionDOMElement = null;

        /**
         * This property determines if mousemove and touchmove events are fired only when the cursor
         * is over the object.
         * Setting to true will make things work more in line with how the DOM verison works.
         * Setting to false can make things easier for things like dragging
         * It is currently set to false as this is how PixiJS used to work. This will be set to true in
         * future versions of pixi.
         *
         * @member {boolean}
         * @default false
         */
        _this.moveWhenInside = false;

        /**
         * Have events been attached to the dom element?
         *
         * @private
         * @member {boolean}
         */
        _this.eventsAdded = false;

        /**
         * Is the mouse hovering over the renderer?
         *
         * @private
         * @member {boolean}
         */
        _this.mouseOverRenderer = false;

        /**
         * Does the device support touch events
         * https://www.w3.org/TR/touch-events/
         *
         * @readonly
         * @member {boolean}
         */
        _this.supportsTouchEvents = 'ontouchstart' in window;

        /**
         * Does the device support pointer events
         * https://www.w3.org/Submission/pointer-events/
         *
         * @readonly
         * @member {boolean}
         */
        _this.supportsPointerEvents = !!window.PointerEvent;

        // this will make it so that you don't have to call bind all the time

        /**
         * @private
         * @member {Function}
         */
        _this.onPointerUp = _this.onPointerUp.bind(_this);
        _this.processPointerUp = _this.processPointerUp.bind(_this);

        /**
         * @private
         * @member {Function}
         */
        _this.onPointerCancel = _this.onPointerCancel.bind(_this);
        _this.processPointerCancel = _this.processPointerCancel.bind(_this);

        /**
         * @private
         * @member {Function}
         */
        _this.onPointerDown = _this.onPointerDown.bind(_this);
        _this.processPointerDown = _this.processPointerDown.bind(_this);

        /**
         * @private
         * @member {Function}
         */
        _this.onPointerMove = _this.onPointerMove.bind(_this);
        _this.processPointerMove = _this.processPointerMove.bind(_this);

        /**
         * @private
         * @member {Function}
         */
        _this.onPointerOut = _this.onPointerOut.bind(_this);
        _this.processPointerOverOut = _this.processPointerOverOut.bind(_this);

        /**
         * @private
         * @member {Function}
         */
        _this.onPointerOver = _this.onPointerOver.bind(_this);

        /**
         * Dictionary of how different cursor modes are handled. Strings are handled as CSS cursor
         * values, objects are handled as dictionaries of CSS values for interactionDOMElement,
         * and functions are called instead of changing the CSS.
         * Default CSS cursor values are provided for 'default' and 'pointer' modes.
         * @member {Object.<string, (string|Function|Object.<string, string>)>}
         */
        _this.cursorStyles = {
            default: 'inherit',
            pointer: 'pointer'
        };

        /**
         * The mode of the cursor that is being used.
         * The value of this is a key from the cursorStyles dictionary.
         *
         * @member {string}
         */
        _this.currentCursorMode = null;

        /**
         * Internal cached let.
         *
         * @private
         * @member {string}
         */
        _this.cursor = null;

        /**
         * Internal cached let.
         *
         * @private
         * @member {PIXI.Point}
         */
        _this._tempPoint = new core.Point();

        /**
         * The current resolution / device pixel ratio.
         *
         * @member {number}
         * @default 1
         */
        _this.resolution = 1;

        _this.setTargetElement(_this.renderer.view, _this.renderer.resolution);

        /**
         * Fired when a pointer device button (usually a mouse left-button) is pressed on the display
         * object.
         *
         * @event PIXI.interaction.InteractionManager#mousedown
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device secondary button (usually a mouse right-button) is pressed
         * on the display object.
         *
         * @event PIXI.interaction.InteractionManager#rightdown
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device button (usually a mouse left-button) is released over the display
         * object.
         *
         * @event PIXI.interaction.InteractionManager#mouseup
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device secondary button (usually a mouse right-button) is released
         * over the display object.
         *
         * @event PIXI.interaction.InteractionManager#rightup
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device button (usually a mouse left-button) is pressed and released on
         * the display object.
         *
         * @event PIXI.interaction.InteractionManager#click
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device secondary button (usually a mouse right-button) is pressed
         * and released on the display object.
         *
         * @event PIXI.interaction.InteractionManager#rightclick
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device button (usually a mouse left-button) is released outside the
         * display object that initially registered a
         * [mousedown]{@link PIXI.interaction.InteractionManager#event:mousedown}.
         *
         * @event PIXI.interaction.InteractionManager#mouseupoutside
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device secondary button (usually a mouse right-button) is released
         * outside the display object that initially registered a
         * [rightdown]{@link PIXI.interaction.InteractionManager#event:rightdown}.
         *
         * @event PIXI.interaction.InteractionManager#rightupoutside
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device (usually a mouse) is moved while over the display object
         *
         * @event PIXI.interaction.InteractionManager#mousemove
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device (usually a mouse) is moved onto the display object
         *
         * @event PIXI.interaction.InteractionManager#mouseover
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device (usually a mouse) is moved off the display object
         *
         * @event PIXI.interaction.InteractionManager#mouseout
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device button is pressed on the display object.
         *
         * @event PIXI.interaction.InteractionManager#pointerdown
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device button is released over the display object.
         * Not always fired when some buttons are held down while others are released. In those cases,
         * use [mousedown]{@link PIXI.interaction.InteractionManager#event:mousedown} and
         * [mouseup]{@link PIXI.interaction.InteractionManager#event:mouseup} instead.
         *
         * @event PIXI.interaction.InteractionManager#pointerup
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when the operating system cancels a pointer event
         *
         * @event PIXI.interaction.InteractionManager#pointercancel
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device button is pressed and released on the display object.
         *
         * @event PIXI.interaction.InteractionManager#pointertap
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device button is released outside the display object that initially
         * registered a [pointerdown]{@link PIXI.interaction.InteractionManager#event:pointerdown}.
         *
         * @event PIXI.interaction.InteractionManager#pointerupoutside
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device is moved while over the display object
         *
         * @event PIXI.interaction.InteractionManager#pointermove
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device is moved onto the display object
         *
         * @event PIXI.interaction.InteractionManager#pointerover
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device is moved off the display object
         *
         * @event PIXI.interaction.InteractionManager#pointerout
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a touch point is placed on the display object.
         *
         * @event PIXI.interaction.InteractionManager#touchstart
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a touch point is removed from the display object.
         *
         * @event PIXI.interaction.InteractionManager#touchend
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when the operating system cancels a touch
         *
         * @event PIXI.interaction.InteractionManager#touchcancel
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a touch point is placed and removed from the display object.
         *
         * @event PIXI.interaction.InteractionManager#tap
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a touch point is removed outside of the display object that initially
         * registered a [touchstart]{@link PIXI.interaction.InteractionManager#event:touchstart}.
         *
         * @event PIXI.interaction.InteractionManager#touchendoutside
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a touch point is moved along the display object.
         *
         * @event PIXI.interaction.InteractionManager#touchmove
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device button (usually a mouse left-button) is pressed on the display.
         * object. DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#mousedown
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device secondary button (usually a mouse right-button) is pressed
         * on the display object. DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#rightdown
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device button (usually a mouse left-button) is released over the display
         * object. DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#mouseup
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device secondary button (usually a mouse right-button) is released
         * over the display object. DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#rightup
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device button (usually a mouse left-button) is pressed and released on
         * the display object. DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#click
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device secondary button (usually a mouse right-button) is pressed
         * and released on the display object. DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#rightclick
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device button (usually a mouse left-button) is released outside the
         * display object that initially registered a
         * [mousedown]{@link PIXI.DisplayObject#event:mousedown}.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#mouseupoutside
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device secondary button (usually a mouse right-button) is released
         * outside the display object that initially registered a
         * [rightdown]{@link PIXI.DisplayObject#event:rightdown}.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#rightupoutside
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device (usually a mouse) is moved while over the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#mousemove
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device (usually a mouse) is moved onto the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#mouseover
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device (usually a mouse) is moved off the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#mouseout
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device button is pressed on the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#pointerdown
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device button is released over the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#pointerup
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when the operating system cancels a pointer event.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#pointercancel
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device button is pressed and released on the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#pointertap
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device button is released outside the display object that initially
         * registered a [pointerdown]{@link PIXI.DisplayObject#event:pointerdown}.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#pointerupoutside
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device is moved while over the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#pointermove
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device is moved onto the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#pointerover
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a pointer device is moved off the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#pointerout
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a touch point is placed on the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#touchstart
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a touch point is removed from the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#touchend
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when the operating system cancels a touch.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#touchcancel
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a touch point is placed and removed from the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#tap
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a touch point is removed outside of the display object that initially
         * registered a [touchstart]{@link PIXI.DisplayObject#event:touchstart}.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#touchendoutside
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */

        /**
         * Fired when a touch point is moved along the display object.
         * DisplayObject's `interactive` property must be set to `true` to fire event.
         *
         * @event PIXI.DisplayObject#touchmove
         * @param {PIXI.interaction.InteractionEvent} event - Interaction event
         */
        return _this;
    }

    /**
     * Hit tests a point against the display tree, returning the first interactive object that is hit.
     *
     * @param {PIXI.Point} globalPoint - A point to hit test with, in global space.
     * @param {PIXI.Container} [root] - The root display object to start from. If omitted, defaults
     * to the last rendered root of the associated renderer.
     * @return {PIXI.DisplayObject} The hit display object, if any.
     */


    InteractionManager.prototype.hitTest = function hitTest(globalPoint, root) {
        // clear the target for our hit test
        hitTestEvent.target = null;
        // assign the global point
        hitTestEvent.data.global = globalPoint;
        // ensure safety of the root
        if (!root) {
            root = this.renderer._lastObjectRendered;
        }
        // run the hit test
        this.processInteractive(hitTestEvent, root, null, true);
        // return our found object - it'll be null if we didn't hit anything

        return hitTestEvent.target;
    };

    /**
     * Sets the DOM element which will receive mouse/touch events. This is useful for when you have
     * other DOM elements on top of the renderers Canvas element. With this you'll be bale to deletegate
     * another DOM element to receive those events.
     *
     * @param {HTMLCanvasElement} element - the DOM element which will receive mouse and touch events.
     * @param {number} [resolution=1] - The resolution / device pixel ratio of the new element (relative to the canvas).
     */


    InteractionManager.prototype.setTargetElement = function setTargetElement(element) {
        var resolution = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

        this.removeEvents();

        this.interactionDOMElement = element;

        this.resolution = resolution;

        this.addEvents();
    };

    /**
     * Registers all the DOM events
     *
     * @private
     */


    InteractionManager.prototype.addEvents = function addEvents() {
        if (!this.interactionDOMElement) {
            return;
        }

        core.ticker.shared.add(this.update, this, core.UPDATE_PRIORITY.INTERACTION);

        if (window.navigator.msPointerEnabled) {
            this.interactionDOMElement.style['-ms-content-zooming'] = 'none';
            this.interactionDOMElement.style['-ms-touch-action'] = 'none';
        } else if (this.supportsPointerEvents) {
            this.interactionDOMElement.style['touch-action'] = 'none';
        }

        /**
         * These events are added first, so that if pointer events are normalised, they are fired
         * in the same order as non-normalised events. ie. pointer event 1st, mouse / touch 2nd
         */
        if (this.supportsPointerEvents) {
            window.document.addEventListener('pointermove', this.onPointerMove, true);
            this.interactionDOMElement.addEventListener('pointerdown', this.onPointerDown, true);
            // pointerout is fired in addition to pointerup (for touch events) and pointercancel
            // we already handle those, so for the purposes of what we do in onPointerOut, we only
            // care about the pointerleave event
            this.interactionDOMElement.addEventListener('pointerleave', this.onPointerOut, true);
            this.interactionDOMElement.addEventListener('pointerover', this.onPointerOver, true);
            window.addEventListener('pointercancel', this.onPointerCancel, true);
            window.addEventListener('pointerup', this.onPointerUp, true);
        } else {
            window.document.addEventListener('mousemove', this.onPointerMove, true);
            this.interactionDOMElement.addEventListener('mousedown', this.onPointerDown, true);
            this.interactionDOMElement.addEventListener('mouseout', this.onPointerOut, true);
            this.interactionDOMElement.addEventListener('mouseover', this.onPointerOver, true);
            window.addEventListener('mouseup', this.onPointerUp, true);
        }

        // always look directly for touch events so that we can provide original data
        // In a future version we should change this to being just a fallback and rely solely on
        // PointerEvents whenever available
        if (this.supportsTouchEvents) {
            this.interactionDOMElement.addEventListener('touchstart', this.onPointerDown, true);
            this.interactionDOMElement.addEventListener('touchcancel', this.onPointerCancel, true);
            this.interactionDOMElement.addEventListener('touchend', this.onPointerUp, true);
            this.interactionDOMElement.addEventListener('touchmove', this.onPointerMove, true);
        }

        this.eventsAdded = true;
    };

    /**
     * Removes all the DOM events that were previously registered
     *
     * @private
     */


    InteractionManager.prototype.removeEvents = function removeEvents() {
        if (!this.interactionDOMElement) {
            return;
        }

        core.ticker.shared.remove(this.update, this);

        if (window.navigator.msPointerEnabled) {
            this.interactionDOMElement.style['-ms-content-zooming'] = '';
            this.interactionDOMElement.style['-ms-touch-action'] = '';
        } else if (this.supportsPointerEvents) {
            this.interactionDOMElement.style['touch-action'] = '';
        }

        if (this.supportsPointerEvents) {
            window.document.removeEventListener('pointermove', this.onPointerMove, true);
            this.interactionDOMElement.removeEventListener('pointerdown', this.onPointerDown, true);
            this.interactionDOMElement.removeEventListener('pointerleave', this.onPointerOut, true);
            this.interactionDOMElement.removeEventListener('pointerover', this.onPointerOver, true);
            window.removeEventListener('pointercancel', this.onPointerCancel, true);
            window.removeEventListener('pointerup', this.onPointerUp, true);
        } else {
            window.document.removeEventListener('mousemove', this.onPointerMove, true);
            this.interactionDOMElement.removeEventListener('mousedown', this.onPointerDown, true);
            this.interactionDOMElement.removeEventListener('mouseout', this.onPointerOut, true);
            this.interactionDOMElement.removeEventListener('mouseover', this.onPointerOver, true);
            window.removeEventListener('mouseup', this.onPointerUp, true);
        }

        if (this.supportsTouchEvents) {
            this.interactionDOMElement.removeEventListener('touchstart', this.onPointerDown, true);
            this.interactionDOMElement.removeEventListener('touchcancel', this.onPointerCancel, true);
            this.interactionDOMElement.removeEventListener('touchend', this.onPointerUp, true);
            this.interactionDOMElement.removeEventListener('touchmove', this.onPointerMove, true);
        }

        this.interactionDOMElement = null;

        this.eventsAdded = false;
    };

    /**
     * Updates the state of interactive objects.
     * Invoked by a throttled ticker update from {@link PIXI.ticker.shared}.
     *
     * @param {number} deltaTime - time delta since last tick
     */


    InteractionManager.prototype.update = function update(deltaTime) {
        this._deltaTime += deltaTime;

        if (this._deltaTime < this.interactionFrequency) {
            return;
        }

        this._deltaTime = 0;

        if (!this.interactionDOMElement) {
            return;
        }

        // if the user move the mouse this check has already been done using the mouse move!
        if (this.didMove) {
            this.didMove = false;

            return;
        }

        this.cursor = null;

        // Resets the flag as set by a stopPropagation call. This flag is usually reset by a user interaction of any kind,
        // but there was a scenario of a display object moving under a static mouse cursor.
        // In this case, mouseover and mouseevents would not pass the flag test in dispatchEvent function
        for (var k in this.activeInteractionData) {
            // eslint-disable-next-line no-prototype-builtins
            if (this.activeInteractionData.hasOwnProperty(k)) {
                var interactionData = this.activeInteractionData[k];

                if (interactionData.originalEvent && interactionData.pointerType !== 'touch') {
                    var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, interactionData.originalEvent, interactionData);

                    this.processInteractive(interactionEvent, this.renderer._lastObjectRendered, this.processPointerOverOut, true);
                }
            }
        }

        this.setCursorMode(this.cursor);

        // TODO
    };

    /**
     * Sets the current cursor mode, handling any callbacks or CSS style changes.
     *
     * @param {string} mode - cursor mode, a key from the cursorStyles dictionary
     */


    InteractionManager.prototype.setCursorMode = function setCursorMode(mode) {
        mode = mode || 'default';
        // if the mode didn't actually change, bail early
        if (this.currentCursorMode === mode) {
            return;
        }
        this.currentCursorMode = mode;
        var style = this.cursorStyles[mode];

        // only do things if there is a cursor style for it
        if (style) {
            switch (typeof style === 'undefined' ? 'undefined' : _typeof(style)) {
                case 'string':
                    // string styles are handled as cursor CSS
                    this.interactionDOMElement.style.cursor = style;
                    break;
                case 'function':
                    // functions are just called, and passed the cursor mode
                    style(mode);
                    break;
                case 'object':
                    // if it is an object, assume that it is a dictionary of CSS styles,
                    // apply it to the interactionDOMElement
                    Object.assign(this.interactionDOMElement.style, style);
                    break;
            }
        } else if (typeof mode === 'string' && !Object.prototype.hasOwnProperty.call(this.cursorStyles, mode)) {
            // if it mode is a string (not a Symbol) and cursorStyles doesn't have any entry
            // for the mode, then assume that the dev wants it to be CSS for the cursor.
            this.interactionDOMElement.style.cursor = mode;
        }
    };

    /**
     * Dispatches an event on the display object that was interacted with
     *
     * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - the display object in question
     * @param {string} eventString - the name of the event (e.g, mousedown)
     * @param {object} eventData - the event data object
     * @private
     */


    InteractionManager.prototype.dispatchEvent = function dispatchEvent(displayObject, eventString, eventData) {
        if (!eventData.stopped) {
            eventData.currentTarget = displayObject;
            eventData.type = eventString;

            displayObject.emit(eventString, eventData);

            if (displayObject[eventString]) {
                displayObject[eventString](eventData);
            }
        }
    };

    /**
     * Maps x and y coords from a DOM object and maps them correctly to the PixiJS view. The
     * resulting value is stored in the point. This takes into account the fact that the DOM
     * element could be scaled and positioned anywhere on the screen.
     *
     * @param  {PIXI.Point} point - the point that the result will be stored in
     * @param  {number} x - the x coord of the position to map
     * @param  {number} y - the y coord of the position to map
     */


    InteractionManager.prototype.mapPositionToPoint = function mapPositionToPoint(point, x, y) {
        var rect = void 0;

        // IE 11 fix
        if (!this.interactionDOMElement.parentElement) {
            rect = { x: 0, y: 0, width: 0, height: 0 };
        } else {
            rect = this.interactionDOMElement.getBoundingClientRect();
        }

        var resolutionMultiplier = navigator.isCocoonJS ? this.resolution : 1.0 / this.resolution;

        point.x = (x - rect.left) * (this.interactionDOMElement.width / rect.width) * resolutionMultiplier;
        point.y = (y - rect.top) * (this.interactionDOMElement.height / rect.height) * resolutionMultiplier;
    };

    /**
     * This function is provides a neat way of crawling through the scene graph and running a
     * specified function on all interactive objects it finds. It will also take care of hit
     * testing the interactive objects and passes the hit across in the function.
     *
     * @private
     * @param {PIXI.interaction.InteractionEvent} interactionEvent - event containing the point that
     *  is tested for collision
     * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - the displayObject
     *  that will be hit test (recursively crawls its children)
     * @param {Function} [func] - the function that will be called on each interactive object. The
     *  interactionEvent, displayObject and hit will be passed to the function
     * @param {boolean} [hitTest] - this indicates if the objects inside should be hit test against the point
     * @param {boolean} [interactive] - Whether the displayObject is interactive
     * @return {boolean} returns true if the displayObject hit the point
     */


    InteractionManager.prototype.processInteractive = function processInteractive(interactionEvent, displayObject, func, hitTest, interactive) {
        if (!displayObject || !displayObject.visible) {
            return false;
        }

        var point = interactionEvent.data.global;

        // Took a little while to rework this function correctly! But now it is done and nice and optimised. ^_^
        //
        // This function will now loop through all objects and then only hit test the objects it HAS
        // to, not all of them. MUCH faster..
        // An object will be hit test if the following is true:
        //
        // 1: It is interactive.
        // 2: It belongs to a parent that is interactive AND one of the parents children have not already been hit.
        //
        // As another little optimisation once an interactive object has been hit we can carry on
        // through the scenegraph, but we know that there will be no more hits! So we can avoid extra hit tests
        // A final optimisation is that an object is not hit test directly if a child has already been hit.

        interactive = displayObject.interactive || interactive;

        var hit = false;
        var interactiveParent = interactive;

        // Flag here can set to false if the event is outside the parents hitArea or mask
        var hitTestChildren = true;

        // If there is a hitArea, no need to test against anything else if the pointer is not within the hitArea
        // There is also no longer a need to hitTest children.
        if (displayObject.hitArea) {
            if (hitTest) {
                displayObject.worldTransform.applyInverse(point, this._tempPoint);
                if (!displayObject.hitArea.contains(this._tempPoint.x, this._tempPoint.y)) {
                    hitTest = false;
                    hitTestChildren = false;
                } else {
                    hit = true;
                }
            }
            interactiveParent = false;
        }
        // If there is a mask, no need to test against anything else if the pointer is not within the mask
        else if (displayObject._mask) {
                if (hitTest) {
                    if (!displayObject._mask.containsPoint(point)) {
                        hitTest = false;
                        hitTestChildren = false;
                    }
                }
            }

        // ** FREE TIP **! If an object is not interactive or has no buttons in it
        // (such as a game scene!) set interactiveChildren to false for that displayObject.
        // This will allow PixiJS to completely ignore and bypass checking the displayObjects children.
        if (hitTestChildren && displayObject.interactiveChildren && displayObject.children) {
            var children = displayObject.children;

            for (var i = children.length - 1; i >= 0; i--) {
                var child = children[i];

                // time to get recursive.. if this function will return if something is hit..
                var childHit = this.processInteractive(interactionEvent, child, func, hitTest, interactiveParent);

                if (childHit) {
                    // its a good idea to check if a child has lost its parent.
                    // this means it has been removed whilst looping so its best
                    if (!child.parent) {
                        continue;
                    }

                    // we no longer need to hit test any more objects in this container as we we
                    // now know the parent has been hit
                    interactiveParent = false;

                    // If the child is interactive , that means that the object hit was actually
                    // interactive and not just the child of an interactive object.
                    // This means we no longer need to hit test anything else. We still need to run
                    // through all objects, but we don't need to perform any hit tests.

                    if (childHit) {
                        if (interactionEvent.target) {
                            hitTest = false;
                        }
                        hit = true;
                    }
                }
            }
        }

        // no point running this if the item is not interactive or does not have an interactive parent.
        if (interactive) {
            // if we are hit testing (as in we have no hit any objects yet)
            // We also don't need to worry about hit testing if once of the displayObjects children
            // has already been hit - but only if it was interactive, otherwise we need to keep
            // looking for an interactive child, just in case we hit one
            if (hitTest && !interactionEvent.target) {
                // already tested against hitArea if it is defined
                if (!displayObject.hitArea && displayObject.containsPoint) {
                    if (displayObject.containsPoint(point)) {
                        hit = true;
                    }
                }
            }

            if (displayObject.interactive) {
                if (hit && !interactionEvent.target) {
                    interactionEvent.target = displayObject;
                }

                if (func) {
                    func(interactionEvent, displayObject, !!hit);
                }
            }
        }

        return hit;
    };

    /**
     * Is called when the pointer button is pressed down on the renderer element
     *
     * @private
     * @param {PointerEvent} originalEvent - The DOM event of a pointer button being pressed down
     */


    InteractionManager.prototype.onPointerDown = function onPointerDown(originalEvent) {
        // if we support touch events, then only use those for touch events, not pointer events
        if (this.supportsTouchEvents && originalEvent.pointerType === 'touch') return;

        var events = this.normalizeToPointerData(originalEvent);

        /**
         * No need to prevent default on natural pointer events, as there are no side effects
         * Normalized events, however, may have the double mousedown/touchstart issue on the native android browser,
         * so still need to be prevented.
         */

        // Guaranteed that there will be at least one event in events, and all events must have the same pointer type

        if (this.autoPreventDefault && events[0].isNormalized) {
            originalEvent.preventDefault();
        }

        var eventLen = events.length;

        for (var i = 0; i < eventLen; i++) {
            var event = events[i];

            var interactionData = this.getInteractionDataForPointerId(event);

            var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);

            interactionEvent.data.originalEvent = originalEvent;

            this.processInteractive(interactionEvent, this.renderer._lastObjectRendered, this.processPointerDown, true);

            this.emit('pointerdown', interactionEvent);
            if (event.pointerType === 'touch') {
                this.emit('touchstart', interactionEvent);
            }
            // emit a mouse event for "pen" pointers, the way a browser would emit a fallback event
            else if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
                    var isRightButton = event.button === 2;

                    this.emit(isRightButton ? 'rightdown' : 'mousedown', this.eventData);
                }
        }
    };

    /**
     * Processes the result of the pointer down check and dispatches the event if need be
     *
     * @private
     * @param {PIXI.interaction.InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
     * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - The display object that was tested
     * @param {boolean} hit - the result of the hit test on the display object
     */


    InteractionManager.prototype.processPointerDown = function processPointerDown(interactionEvent, displayObject, hit) {
        var data = interactionEvent.data;
        var id = interactionEvent.data.identifier;

        if (hit) {
            if (!displayObject.trackedPointers[id]) {
                displayObject.trackedPointers[id] = new _InteractionTrackingData2.default(id);
            }
            this.dispatchEvent(displayObject, 'pointerdown', interactionEvent);

            if (data.pointerType === 'touch') {
                this.dispatchEvent(displayObject, 'touchstart', interactionEvent);
            } else if (data.pointerType === 'mouse' || data.pointerType === 'pen') {
                var isRightButton = data.button === 2;

                if (isRightButton) {
                    displayObject.trackedPointers[id].rightDown = true;
                } else {
                    displayObject.trackedPointers[id].leftDown = true;
                }

                this.dispatchEvent(displayObject, isRightButton ? 'rightdown' : 'mousedown', interactionEvent);
            }
        }
    };

    /**
     * Is called when the pointer button is released on the renderer element
     *
     * @private
     * @param {PointerEvent} originalEvent - The DOM event of a pointer button being released
     * @param {boolean} cancelled - true if the pointer is cancelled
     * @param {Function} func - Function passed to {@link processInteractive}
     */


    InteractionManager.prototype.onPointerComplete = function onPointerComplete(originalEvent, cancelled, func) {
        var events = this.normalizeToPointerData(originalEvent);

        var eventLen = events.length;

        // if the event wasn't targeting our canvas, then consider it to be pointerupoutside
        // in all cases (unless it was a pointercancel)
        var eventAppend = originalEvent.target !== this.interactionDOMElement ? 'outside' : '';

        for (var i = 0; i < eventLen; i++) {
            var event = events[i];

            var interactionData = this.getInteractionDataForPointerId(event);

            var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);

            interactionEvent.data.originalEvent = originalEvent;

            // perform hit testing for events targeting our canvas or cancel events
            this.processInteractive(interactionEvent, this.renderer._lastObjectRendered, func, cancelled || !eventAppend);

            this.emit(cancelled ? 'pointercancel' : 'pointerup' + eventAppend, interactionEvent);

            if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
                var isRightButton = event.button === 2;

                this.emit(isRightButton ? 'rightup' + eventAppend : 'mouseup' + eventAppend, interactionEvent);
            } else if (event.pointerType === 'touch') {
                this.emit(cancelled ? 'touchcancel' : 'touchend' + eventAppend, interactionEvent);
                this.releaseInteractionDataForPointerId(event.pointerId, interactionData);
            }
        }
    };

    /**
     * Is called when the pointer button is cancelled
     *
     * @private
     * @param {PointerEvent} event - The DOM event of a pointer button being released
     */


    InteractionManager.prototype.onPointerCancel = function onPointerCancel(event) {
        // if we support touch events, then only use those for touch events, not pointer events
        if (this.supportsTouchEvents && event.pointerType === 'touch') return;

        this.onPointerComplete(event, true, this.processPointerCancel);
    };

    /**
     * Processes the result of the pointer cancel check and dispatches the event if need be
     *
     * @private
     * @param {PIXI.interaction.InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
     * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - The display object that was tested
     */


    InteractionManager.prototype.processPointerCancel = function processPointerCancel(interactionEvent, displayObject) {
        var data = interactionEvent.data;

        var id = interactionEvent.data.identifier;

        if (displayObject.trackedPointers[id] !== undefined) {
            delete displayObject.trackedPointers[id];
            this.dispatchEvent(displayObject, 'pointercancel', interactionEvent);

            if (data.pointerType === 'touch') {
                this.dispatchEvent(displayObject, 'touchcancel', interactionEvent);
            }
        }
    };

    /**
     * Is called when the pointer button is released on the renderer element
     *
     * @private
     * @param {PointerEvent} event - The DOM event of a pointer button being released
     */


    InteractionManager.prototype.onPointerUp = function onPointerUp(event) {
        // if we support touch events, then only use those for touch events, not pointer events
        if (this.supportsTouchEvents && event.pointerType === 'touch') return;

        this.onPointerComplete(event, false, this.processPointerUp);
    };

    /**
     * Processes the result of the pointer up check and dispatches the event if need be
     *
     * @private
     * @param {PIXI.interaction.InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
     * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - The display object that was tested
     * @param {boolean} hit - the result of the hit test on the display object
     */


    InteractionManager.prototype.processPointerUp = function processPointerUp(interactionEvent, displayObject, hit) {
        var data = interactionEvent.data;

        var id = interactionEvent.data.identifier;

        var trackingData = displayObject.trackedPointers[id];

        var isTouch = data.pointerType === 'touch';

        var isMouse = data.pointerType === 'mouse' || data.pointerType === 'pen';
        // need to track mouse down status in the mouse block so that we can emit
        // event in a later block
        var isMouseTap = false;

        // Mouse only
        if (isMouse) {
            var isRightButton = data.button === 2;

            var flags = _InteractionTrackingData2.default.FLAGS;

            var test = isRightButton ? flags.RIGHT_DOWN : flags.LEFT_DOWN;

            var isDown = trackingData !== undefined && trackingData.flags & test;

            if (hit) {
                this.dispatchEvent(displayObject, isRightButton ? 'rightup' : 'mouseup', interactionEvent);

                if (isDown) {
                    this.dispatchEvent(displayObject, isRightButton ? 'rightclick' : 'click', interactionEvent);
                    // because we can confirm that the mousedown happened on this object, flag for later emit of pointertap
                    isMouseTap = true;
                }
            } else if (isDown) {
                this.dispatchEvent(displayObject, isRightButton ? 'rightupoutside' : 'mouseupoutside', interactionEvent);
            }
            // update the down state of the tracking data
            if (trackingData) {
                if (isRightButton) {
                    trackingData.rightDown = false;
                } else {
                    trackingData.leftDown = false;
                }
            }
        }

        // Pointers and Touches, and Mouse
        if (hit) {
            this.dispatchEvent(displayObject, 'pointerup', interactionEvent);
            if (isTouch) this.dispatchEvent(displayObject, 'touchend', interactionEvent);

            if (trackingData) {
                // emit pointertap if not a mouse, or if the mouse block decided it was a tap
                if (!isMouse || isMouseTap) {
                    this.dispatchEvent(displayObject, 'pointertap', interactionEvent);
                }
                if (isTouch) {
                    this.dispatchEvent(displayObject, 'tap', interactionEvent);
                    // touches are no longer over (if they ever were) when we get the touchend
                    // so we should ensure that we don't keep pretending that they are
                    trackingData.over = false;
                }
            }
        } else if (trackingData) {
            this.dispatchEvent(displayObject, 'pointerupoutside', interactionEvent);
            if (isTouch) this.dispatchEvent(displayObject, 'touchendoutside', interactionEvent);
        }
        // Only remove the tracking data if there is no over/down state still associated with it
        if (trackingData && trackingData.none) {
            delete displayObject.trackedPointers[id];
        }
    };

    /**
     * Is called when the pointer moves across the renderer element
     *
     * @private
     * @param {PointerEvent} originalEvent - The DOM event of a pointer moving
     */


    InteractionManager.prototype.onPointerMove = function onPointerMove(originalEvent) {
        // if we support touch events, then only use those for touch events, not pointer events
        if (this.supportsTouchEvents && originalEvent.pointerType === 'touch') return;

        var events = this.normalizeToPointerData(originalEvent);

        if (events[0].pointerType === 'mouse' || events[0].pointerType === 'pen') {
            this.didMove = true;

            this.cursor = null;
        }

        var eventLen = events.length;

        for (var i = 0; i < eventLen; i++) {
            var event = events[i];

            var interactionData = this.getInteractionDataForPointerId(event);

            var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);

            interactionEvent.data.originalEvent = originalEvent;

            var interactive = event.pointerType === 'touch' ? this.moveWhenInside : true;

            this.processInteractive(interactionEvent, this.renderer._lastObjectRendered, this.processPointerMove, interactive);
            this.emit('pointermove', interactionEvent);
            if (event.pointerType === 'touch') this.emit('touchmove', interactionEvent);
            if (event.pointerType === 'mouse' || event.pointerType === 'pen') this.emit('mousemove', interactionEvent);
        }

        if (events[0].pointerType === 'mouse') {
            this.setCursorMode(this.cursor);

            // TODO BUG for parents interactive object (border order issue)
        }
    };

    /**
     * Processes the result of the pointer move check and dispatches the event if need be
     *
     * @private
     * @param {PIXI.interaction.InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
     * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - The display object that was tested
     * @param {boolean} hit - the result of the hit test on the display object
     */


    InteractionManager.prototype.processPointerMove = function processPointerMove(interactionEvent, displayObject, hit) {
        var data = interactionEvent.data;

        var isTouch = data.pointerType === 'touch';

        var isMouse = data.pointerType === 'mouse' || data.pointerType === 'pen';

        if (isMouse) {
            this.processPointerOverOut(interactionEvent, displayObject, hit);
        }

        if (!this.moveWhenInside || hit) {
            this.dispatchEvent(displayObject, 'pointermove', interactionEvent);
            if (isTouch) this.dispatchEvent(displayObject, 'touchmove', interactionEvent);
            if (isMouse) this.dispatchEvent(displayObject, 'mousemove', interactionEvent);
        }
    };

    /**
     * Is called when the pointer is moved out of the renderer element
     *
     * @private
     * @param {PointerEvent} originalEvent - The DOM event of a pointer being moved out
     */


    InteractionManager.prototype.onPointerOut = function onPointerOut(originalEvent) {
        // if we support touch events, then only use those for touch events, not pointer events
        if (this.supportsTouchEvents && originalEvent.pointerType === 'touch') return;

        var events = this.normalizeToPointerData(originalEvent);

        // Only mouse and pointer can call onPointerOut, so events will always be length 1
        var event = events[0];

        if (event.pointerType === 'mouse') {
            this.mouseOverRenderer = false;
            this.setCursorMode(null);
        }

        var interactionData = this.getInteractionDataForPointerId(event);

        var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);

        interactionEvent.data.originalEvent = event;

        this.processInteractive(interactionEvent, this.renderer._lastObjectRendered, this.processPointerOverOut, false);

        this.emit('pointerout', interactionEvent);
        if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
            this.emit('mouseout', interactionEvent);
        } else {
            // we can get touchleave events after touchend, so we want to make sure we don't
            // introduce memory leaks
            this.releaseInteractionDataForPointerId(interactionData.identifier);
        }
    };

    /**
     * Processes the result of the pointer over/out check and dispatches the event if need be
     *
     * @private
     * @param {PIXI.interaction.InteractionEvent} interactionEvent - The interaction event wrapping the DOM event
     * @param {PIXI.Container|PIXI.Sprite|PIXI.extras.TilingSprite} displayObject - The display object that was tested
     * @param {boolean} hit - the result of the hit test on the display object
     */


    InteractionManager.prototype.processPointerOverOut = function processPointerOverOut(interactionEvent, displayObject, hit) {
        var data = interactionEvent.data;

        var id = interactionEvent.data.identifier;

        var isMouse = data.pointerType === 'mouse' || data.pointerType === 'pen';

        var trackingData = displayObject.trackedPointers[id];

        // if we just moused over the display object, then we need to track that state
        if (hit && !trackingData) {
            trackingData = displayObject.trackedPointers[id] = new _InteractionTrackingData2.default(id);
        }

        if (trackingData === undefined) return;

        if (hit && this.mouseOverRenderer) {
            if (!trackingData.over) {
                trackingData.over = true;
                this.dispatchEvent(displayObject, 'pointerover', interactionEvent);
                if (isMouse) {
                    this.dispatchEvent(displayObject, 'mouseover', interactionEvent);
                }
            }

            // only change the cursor if it has not already been changed (by something deeper in the
            // display tree)
            if (isMouse && this.cursor === null) {
                this.cursor = displayObject.cursor;
            }
        } else if (trackingData.over) {
            trackingData.over = false;
            this.dispatchEvent(displayObject, 'pointerout', this.eventData);
            if (isMouse) {
                this.dispatchEvent(displayObject, 'mouseout', interactionEvent);
            }
            // if there is no mouse down information for the pointer, then it is safe to delete
            if (trackingData.none) {
                delete displayObject.trackedPointers[id];
            }
        }
    };

    /**
     * Is called when the pointer is moved into the renderer element
     *
     * @private
     * @param {PointerEvent} originalEvent - The DOM event of a pointer button being moved into the renderer view
     */


    InteractionManager.prototype.onPointerOver = function onPointerOver(originalEvent) {
        var events = this.normalizeToPointerData(originalEvent);

        // Only mouse and pointer can call onPointerOver, so events will always be length 1
        var event = events[0];

        var interactionData = this.getInteractionDataForPointerId(event);

        var interactionEvent = this.configureInteractionEventForDOMEvent(this.eventData, event, interactionData);

        interactionEvent.data.originalEvent = event;

        if (event.pointerType === 'mouse') {
            this.mouseOverRenderer = true;
        }

        this.emit('pointerover', interactionEvent);
        if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
            this.emit('mouseover', interactionEvent);
        }
    };

    /**
     * Get InteractionData for a given pointerId. Store that data as well
     *
     * @private
     * @param {PointerEvent} event - Normalized pointer event, output from normalizeToPointerData
     * @return {PIXI.interaction.InteractionData} - Interaction data for the given pointer identifier
     */


    InteractionManager.prototype.getInteractionDataForPointerId = function getInteractionDataForPointerId(event) {
        var pointerId = event.pointerId;

        var interactionData = void 0;

        if (pointerId === MOUSE_POINTER_ID || event.pointerType === 'mouse') {
            interactionData = this.mouse;
        } else if (this.activeInteractionData[pointerId]) {
            interactionData = this.activeInteractionData[pointerId];
        } else {
            interactionData = this.interactionDataPool.pop() || new _InteractionData2.default();
            interactionData.identifier = pointerId;
            this.activeInteractionData[pointerId] = interactionData;
        }
        // copy properties from the event, so that we can make sure that touch/pointer specific
        // data is available
        interactionData.copyEvent(event);

        return interactionData;
    };

    /**
     * Return unused InteractionData to the pool, for a given pointerId
     *
     * @private
     * @param {number} pointerId - Identifier from a pointer event
     */


    InteractionManager.prototype.releaseInteractionDataForPointerId = function releaseInteractionDataForPointerId(pointerId) {
        var interactionData = this.activeInteractionData[pointerId];

        if (interactionData) {
            delete this.activeInteractionData[pointerId];
            interactionData.reset();
            this.interactionDataPool.push(interactionData);
        }
    };

    /**
     * Configure an InteractionEvent to wrap a DOM PointerEvent and InteractionData
     *
     * @private
     * @param {PIXI.interaction.InteractionEvent} interactionEvent - The event to be configured
     * @param {PointerEvent} pointerEvent - The DOM event that will be paired with the InteractionEvent
     * @param {PIXI.interaction.InteractionData} interactionData - The InteractionData that will be paired
     *        with the InteractionEvent
     * @return {PIXI.interaction.InteractionEvent} the interaction event that was passed in
     */


    InteractionManager.prototype.configureInteractionEventForDOMEvent = function configureInteractionEventForDOMEvent(interactionEvent, pointerEvent, interactionData) {
        interactionEvent.data = interactionData;

        this.mapPositionToPoint(interactionData.global, pointerEvent.clientX, pointerEvent.clientY);

        // This is the way InteractionManager processed touch events before the refactoring, so I've kept
        // it here. But it doesn't make that much sense to me, since mapPositionToPoint already factors
        // in this.resolution, so this just divides by this.resolution twice for touch events...
        if (navigator.isCocoonJS && pointerEvent.pointerType === 'touch') {
            interactionData.global.x = interactionData.global.x / this.resolution;
            interactionData.global.y = interactionData.global.y / this.resolution;
        }

        // Not really sure why this is happening, but it's how a previous version handled things
        if (pointerEvent.pointerType === 'touch') {
            pointerEvent.globalX = interactionData.global.x;
            pointerEvent.globalY = interactionData.global.y;
        }

        interactionData.originalEvent = pointerEvent;
        interactionEvent.reset();

        return interactionEvent;
    };

    /**
     * Ensures that the original event object contains all data that a regular pointer event would have
     *
     * @private
     * @param {TouchEvent|MouseEvent|PointerEvent} event - The original event data from a touch or mouse event
     * @return {PointerEvent[]} An array containing a single normalized pointer event, in the case of a pointer
     *  or mouse event, or a multiple normalized pointer events if there are multiple changed touches
     */


    InteractionManager.prototype.normalizeToPointerData = function normalizeToPointerData(event) {
        var normalizedEvents = [];

        if (this.supportsTouchEvents && event instanceof TouchEvent) {
            for (var i = 0, li = event.changedTouches.length; i < li; i++) {
                var touch = event.changedTouches[i];

                if (typeof touch.button === 'undefined') touch.button = event.touches.length ? 1 : 0;
                if (typeof touch.buttons === 'undefined') touch.buttons = event.touches.length ? 1 : 0;
                if (typeof touch.isPrimary === 'undefined') {
                    touch.isPrimary = event.touches.length === 1 && event.type === 'touchstart';
                }
                if (typeof touch.width === 'undefined') touch.width = touch.radiusX || 1;
                if (typeof touch.height === 'undefined') touch.height = touch.radiusY || 1;
                if (typeof touch.tiltX === 'undefined') touch.tiltX = 0;
                if (typeof touch.tiltY === 'undefined') touch.tiltY = 0;
                if (typeof touch.pointerType === 'undefined') touch.pointerType = 'touch';
                if (typeof touch.pointerId === 'undefined') touch.pointerId = touch.identifier || 0;
                if (typeof touch.pressure === 'undefined') touch.pressure = touch.force || 0.5;
                if (typeof touch.twist === 'undefined') touch.twist = 0;
                if (typeof touch.tangentialPressure === 'undefined') touch.tangentialPressure = 0;
                // TODO: Remove these, as layerX/Y is not a standard, is deprecated, has uneven
                // support, and the fill ins are not quite the same
                // offsetX/Y might be okay, but is not the same as clientX/Y when the canvas's top
                // left is not 0,0 on the page
                if (typeof touch.layerX === 'undefined') touch.layerX = touch.offsetX = touch.clientX;
                if (typeof touch.layerY === 'undefined') touch.layerY = touch.offsetY = touch.clientY;

                // mark the touch as normalized, just so that we know we did it
                touch.isNormalized = true;

                normalizedEvents.push(touch);
            }
        }
        // apparently PointerEvent subclasses MouseEvent, so yay
        else if (event instanceof MouseEvent && (!this.supportsPointerEvents || !(event instanceof window.PointerEvent))) {
                if (typeof event.isPrimary === 'undefined') event.isPrimary = true;
                if (typeof event.width === 'undefined') event.width = 1;
                if (typeof event.height === 'undefined') event.height = 1;
                if (typeof event.tiltX === 'undefined') event.tiltX = 0;
                if (typeof event.tiltY === 'undefined') event.tiltY = 0;
                if (typeof event.pointerType === 'undefined') event.pointerType = 'mouse';
                if (typeof event.pointerId === 'undefined') event.pointerId = MOUSE_POINTER_ID;
                if (typeof event.pressure === 'undefined') event.pressure = 0.5;
                if (typeof event.twist === 'undefined') event.twist = 0;
                if (typeof event.tangentialPressure === 'undefined') event.tangentialPressure = 0;

                // mark the mouse event as normalized, just so that we know we did it
                event.isNormalized = true;

                normalizedEvents.push(event);
            } else {
                normalizedEvents.push(event);
            }

        return normalizedEvents;
    };

    /**
     * Destroys the interaction manager
     *
     */


    InteractionManager.prototype.destroy = function destroy() {
        this.removeEvents();

        this.removeAllListeners();

        this.renderer = null;

        this.mouse = null;

        this.eventData = null;

        this.interactionDOMElement = null;

        this.onPointerDown = null;
        this.processPointerDown = null;

        this.onPointerUp = null;
        this.processPointerUp = null;

        this.onPointerCancel = null;
        this.processPointerCancel = null;

        this.onPointerMove = null;
        this.processPointerMove = null;

        this.onPointerOut = null;
        this.processPointerOverOut = null;

        this.onPointerOver = null;

        this._tempPoint = null;
    };

    return InteractionManager;
}(_eventemitter2.default);

exports.default = InteractionManager;


core.WebGLRenderer.registerPlugin('interaction', InteractionManager);
core.CanvasRenderer.registerPlugin('interaction', InteractionManager);
//# sourceMappingURL=InteractionManager.js.map

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.shared = exports.Resource = exports.textureParser = exports.getResourcePath = exports.spritesheetParser = exports.parseBitmapFontData = exports.bitmapFontParser = exports.Loader = undefined;

var _bitmapFontParser = __webpack_require__(211);

Object.defineProperty(exports, 'bitmapFontParser', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_bitmapFontParser).default;
    }
});
Object.defineProperty(exports, 'parseBitmapFontData', {
    enumerable: true,
    get: function get() {
        return _bitmapFontParser.parse;
    }
});

var _spritesheetParser = __webpack_require__(216);

Object.defineProperty(exports, 'spritesheetParser', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_spritesheetParser).default;
    }
});
Object.defineProperty(exports, 'getResourcePath', {
    enumerable: true,
    get: function get() {
        return _spritesheetParser.getResourcePath;
    }
});

var _textureParser = __webpack_require__(217);

Object.defineProperty(exports, 'textureParser', {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_textureParser).default;
    }
});

var _resourceLoader = __webpack_require__(87);

Object.defineProperty(exports, 'Resource', {
    enumerable: true,
    get: function get() {
        return _resourceLoader.Resource;
    }
});

var _Application = __webpack_require__(198);

var _Application2 = _interopRequireDefault(_Application);

var _loader = __webpack_require__(423);

var _loader2 = _interopRequireDefault(_loader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This namespace contains APIs which extends the {@link https://github.com/englercj/resource-loader resource-loader} module
 * for loading assets, data, and other resources dynamically.
 * @example
 * const loader = new PIXI.loaders.Loader();
 * loader.add('bunny', 'data/bunny.png')
 *       .add('spaceship', 'assets/spritesheet.json');
 * loader.load((loader, resources) => {
 *    // resources.bunny
 *    // resources.spaceship
 * });
 * @namespace PIXI.loaders
 */
exports.Loader = _loader2.default;


/**
 * A premade instance of the loader that can be used to load resources.
 * @name shared
 * @memberof PIXI.loaders
 * @type {PIXI.loaders.Loader}
 */
var shared = new _loader2.default();

shared.destroy = function () {
    // protect destroying shared loader
};

exports.shared = shared;

// Mixin the loader construction

var AppPrototype = _Application2.default.prototype;

AppPrototype._loader = null;

/**
 * Loader instance to help with asset loading.
 * @name PIXI.Application#loader
 * @type {PIXI.loaders.Loader}
 */
Object.defineProperty(AppPrototype, 'loader', {
    get: function get() {
        if (!this._loader) {
            var sharedLoader = this._options.sharedLoader;

            this._loader = sharedLoader ? shared : new _loader2.default();
        }

        return this._loader;
    }
});

// Override the destroy function
// making sure to destroy the current Loader
AppPrototype._parentDestroy = AppPrototype.destroy;
AppPrototype.destroy = function destroy(removeView, stageOptions) {
    if (this._loader) {
        this._loader.destroy();
        this._loader = null;
    }
    this._parentDestroy(removeView, stageOptions);
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Loader = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _miniSignals = __webpack_require__(212);

var _miniSignals2 = _interopRequireDefault(_miniSignals);

var _parseUri = __webpack_require__(213);

var _parseUri2 = _interopRequireDefault(_parseUri);

var _async = __webpack_require__(214);

var async = _interopRequireWildcard(_async);

var _Resource = __webpack_require__(137);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// some constants
var MAX_PROGRESS = 100;
var rgxExtractUrlHash = /(#[\w-]+)?$/;

/**
 * Manages the state and loading of multiple resources to load.
 *
 * @class
 */

var Loader = exports.Loader = function () {
    /**
     * @param {string} [baseUrl=''] - The base url for all resources loaded by this loader.
     * @param {number} [concurrency=10] - The number of resources to load concurrently.
     */
    function Loader() {
        var _this = this;

        var baseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var concurrency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;

        _classCallCheck(this, Loader);

        /**
         * The base url for all resources loaded by this loader.
         *
         * @member {string}
         */
        this.baseUrl = baseUrl;

        /**
         * The progress percent of the loader going through the queue.
         *
         * @member {number}
         */
        this.progress = 0;

        /**
         * Loading state of the loader, true if it is currently loading resources.
         *
         * @member {boolean}
         */
        this.loading = false;

        /**
         * A querystring to append to every URL added to the loader.
         *
         * This should be a valid query string *without* the question-mark (`?`). The loader will
         * also *not* escape values for you. Make sure to escape your parameters with
         * [`encodeURIComponent`](https://mdn.io/encodeURIComponent) before assigning this property.
         *
         * @example
         * const loader = new Loader();
         *
         * loader.defaultQueryString = 'user=me&password=secret';
         *
         * // This will request 'image.png?user=me&password=secret'
         * loader.add('image.png').load();
         *
         * loader.reset();
         *
         * // This will request 'image.png?v=1&user=me&password=secret'
         * loader.add('iamge.png?v=1').load();
         *
         * @member {string}
         */
        this.defaultQueryString = '';

        /**
         * The middleware to run before loading each resource.
         *
         * @private
         * @member {function[]}
         */
        this._beforeMiddleware = [];

        /**
         * The middleware to run after loading each resource.
         *
         * @private
         * @member {function[]}
         */
        this._afterMiddleware = [];

        /**
         * The tracks the resources we are currently completing parsing for.
         *
         * @private
         * @member {Resource[]}
         */
        this._resourcesParsing = [];

        /**
         * The `_loadResource` function bound with this object context.
         *
         * @private
         * @member {function}
         * @param {Resource} r - The resource to load
         * @param {Function} d - The dequeue function
         * @return {undefined}
         */
        this._boundLoadResource = function (r, d) {
            return _this._loadResource(r, d);
        };

        /**
         * The resources waiting to be loaded.
         *
         * @private
         * @member {Resource[]}
         */
        this._queue = async.queue(this._boundLoadResource, concurrency);

        this._queue.pause();

        /**
         * All the resources for this loader keyed by name.
         *
         * @member {object<string, Resource>}
         */
        this.resources = {};

        /**
         * Dispatched once per loaded or errored resource.
         *
         * The callback looks like {@link Loader.OnProgressSignal}.
         *
         * @member {Signal<Loader.OnProgressSignal>}
         */
        this.onProgress = new _miniSignals2.default();

        /**
         * Dispatched once per errored resource.
         *
         * The callback looks like {@link Loader.OnErrorSignal}.
         *
         * @member {Signal<Loader.OnErrorSignal>}
         */
        this.onError = new _miniSignals2.default();

        /**
         * Dispatched once per loaded resource.
         *
         * The callback looks like {@link Loader.OnLoadSignal}.
         *
         * @member {Signal<Loader.OnLoadSignal>}
         */
        this.onLoad = new _miniSignals2.default();

        /**
         * Dispatched when the loader begins to process the queue.
         *
         * The callback looks like {@link Loader.OnStartSignal}.
         *
         * @member {Signal<Loader.OnStartSignal>}
         */
        this.onStart = new _miniSignals2.default();

        /**
         * Dispatched when the queued resources all load.
         *
         * The callback looks like {@link Loader.OnCompleteSignal}.
         *
         * @member {Signal<Loader.OnCompleteSignal>}
         */
        this.onComplete = new _miniSignals2.default();

        // Add default before middleware
        for (var i = 0; i < Loader._defaultBeforeMiddleware.length; ++i) {
            this.pre(Loader._defaultBeforeMiddleware[i]);
        }

        // Add default after middleware
        for (var _i = 0; _i < Loader._defaultAfterMiddleware.length; ++_i) {
            this.use(Loader._defaultAfterMiddleware[_i]);
        }
    }

    /**
     * When the progress changes the loader and resource are disaptched.
     *
     * @memberof Loader
     * @callback OnProgressSignal
     * @param {Loader} loader - The loader the progress is advancing on.
     * @param {Resource} resource - The resource that has completed or failed to cause the progress to advance.
     */

    /**
     * When an error occurrs the loader and resource are disaptched.
     *
     * @memberof Loader
     * @callback OnErrorSignal
     * @param {Loader} loader - The loader the error happened in.
     * @param {Resource} resource - The resource that caused the error.
     */

    /**
     * When a load completes the loader and resource are disaptched.
     *
     * @memberof Loader
     * @callback OnLoadSignal
     * @param {Loader} loader - The loader that laoded the resource.
     * @param {Resource} resource - The resource that has completed loading.
     */

    /**
     * When the loader starts loading resources it dispatches this callback.
     *
     * @memberof Loader
     * @callback OnStartSignal
     * @param {Loader} loader - The loader that has started loading resources.
     */

    /**
     * When the loader completes loading resources it dispatches this callback.
     *
     * @memberof Loader
     * @callback OnCompleteSignal
     * @param {Loader} loader - The loader that has finished loading resources.
     */

    /**
     * Options for a call to `.add()`.
     *
     * @see Loader#add
     *
     * @typedef {object} IAddOptions
     * @property {string} [name] - The name of the resource to load, if not passed the url is used.
     * @property {string} [key] - Alias for `name`.
     * @property {string} [url] - The url for this resource, relative to the baseUrl of this loader.
     * @property {string|boolean} [crossOrigin] - Is this request cross-origin? Default is to
     *      determine automatically.
     * @property {number} [timeout=0] - A timeout in milliseconds for the load. If the load takes
     *      longer than this time it is cancelled and the load is considered a failure. If this value is
     *      set to `0` then there is no explicit timeout.
     * @property {Resource.LOAD_TYPE} [loadType=Resource.LOAD_TYPE.XHR] - How should this resource
     *      be loaded?
     * @property {Resource.XHR_RESPONSE_TYPE} [xhrType=Resource.XHR_RESPONSE_TYPE.DEFAULT] - How
     *      should the data being loaded be interpreted when using XHR?
     * @property {Resource.OnCompleteSignal} [onComplete] - Callback to add an an onComplete signal istener.
     * @property {Resource.OnCompleteSignal} [callback] - Alias for `onComplete`.
     * @property {Resource.IMetadata} [metadata] - Extra configuration for middleware and the Resource object.
     */

    /* eslint-disable require-jsdoc,valid-jsdoc */
    /**
     * Adds a resource (or multiple resources) to the loader queue.
     *
     * This function can take a wide variety of different parameters. The only thing that is always
     * required the url to load. All the following will work:
     *
     * ```js
     * loader
     *     // normal param syntax
     *     .add('key', 'http://...', function () {})
     *     .add('http://...', function () {})
     *     .add('http://...')
     *
     *     // object syntax
     *     .add({
     *         name: 'key2',
     *         url: 'http://...'
     *     }, function () {})
     *     .add({
     *         url: 'http://...'
     *     }, function () {})
     *     .add({
     *         name: 'key3',
     *         url: 'http://...'
     *         onComplete: function () {}
     *     })
     *     .add({
     *         url: 'https://...',
     *         onComplete: function () {},
     *         crossOrigin: true
     *     })
     *
     *     // you can also pass an array of objects or urls or both
     *     .add([
     *         { name: 'key4', url: 'http://...', onComplete: function () {} },
     *         { url: 'http://...', onComplete: function () {} },
     *         'http://...'
     *     ])
     *
     *     // and you can use both params and options
     *     .add('key', 'http://...', { crossOrigin: true }, function () {})
     *     .add('http://...', { crossOrigin: true }, function () {});
     * ```
     *
     * @function
     * @variation 1
     * @param {string} name - The name of the resource to load.
     * @param {string} url - The url for this resource, relative to the baseUrl of this loader.
     * @param {Resource.OnCompleteSignal} [callback] - Function to call when this specific resource completes loading.
     * @return {this} Returns itself.
     */ /**
        * @function
        * @variation 2
        * @param {string} name - The name of the resource to load.
        * @param {string} url - The url for this resource, relative to the baseUrl of this loader.
        * @param {IAddOptions} [options] - The options for the load.
        * @param {Resource.OnCompleteSignal} [callback] - Function to call when this specific resource completes loading.
        * @return {this} Returns itself.
        */ /**
           * @function
           * @variation 3
           * @param {string} url - The url for this resource, relative to the baseUrl of this loader.
           * @param {Resource.OnCompleteSignal} [callback] - Function to call when this specific resource completes loading.
           * @return {this} Returns itself.
           */ /**
              * @function
              * @variation 4
              * @param {string} url - The url for this resource, relative to the baseUrl of this loader.
              * @param {IAddOptions} [options] - The options for the load.
              * @param {Resource.OnCompleteSignal} [callback] - Function to call when this specific resource completes loading.
              * @return {this} Returns itself.
              */ /**
                 * @function
                 * @variation 5
                 * @param {IAddOptions} options - The options for the load. This object must contain a `url` property.
                 * @param {Resource.OnCompleteSignal} [callback] - Function to call when this specific resource completes loading.
                 * @return {this} Returns itself.
                 */ /**
                    * @function
                    * @variation 6
                    * @param {Array<IAddOptions|string>} resources - An array of resources to load, where each is
                    *      either an object with the options or a string url. If you pass an object, it must contain a `url` property.
                    * @param {Resource.OnCompleteSignal} [callback] - Function to call when this specific resource completes loading.
                    * @return {this} Returns itself.
                    */


    Loader.prototype.add = function add(name, url, options, cb) {
        // special case of an array of objects or urls
        if (Array.isArray(name)) {
            for (var i = 0; i < name.length; ++i) {
                this.add(name[i]);
            }

            return this;
        }

        // if an object is passed instead of params
        if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
            cb = url || name.callback || name.onComplete;
            options = name;
            url = name.url;
            name = name.name || name.key || name.url;
        }

        // case where no name is passed shift all args over by one.
        if (typeof url !== 'string') {
            cb = options;
            options = url;
            url = name;
        }

        // now that we shifted make sure we have a proper url.
        if (typeof url !== 'string') {
            throw new Error('No url passed to add resource to loader.');
        }

        // options are optional so people might pass a function and no options
        if (typeof options === 'function') {
            cb = options;
            options = null;
        }

        // if loading already you can only add resources that have a parent.
        if (this.loading && (!options || !options.parentResource)) {
            throw new Error('Cannot add resources while the loader is running.');
        }

        // check if resource already exists.
        if (this.resources[name]) {
            throw new Error('Resource named "' + name + '" already exists.');
        }

        // add base url if this isn't an absolute url
        url = this._prepareUrl(url);

        // create the store the resource
        this.resources[name] = new _Resource.Resource(name, url, options);

        if (typeof cb === 'function') {
            this.resources[name].onAfterMiddleware.once(cb);
        }

        // if actively loading, make sure to adjust progress chunks for that parent and its children
        if (this.loading) {
            var parent = options.parentResource;
            var incompleteChildren = [];

            for (var _i2 = 0; _i2 < parent.children.length; ++_i2) {
                if (!parent.children[_i2].isComplete) {
                    incompleteChildren.push(parent.children[_i2]);
                }
            }

            var fullChunk = parent.progressChunk * (incompleteChildren.length + 1); // +1 for parent
            var eachChunk = fullChunk / (incompleteChildren.length + 2); // +2 for parent & new child

            parent.children.push(this.resources[name]);
            parent.progressChunk = eachChunk;

            for (var _i3 = 0; _i3 < incompleteChildren.length; ++_i3) {
                incompleteChildren[_i3].progressChunk = eachChunk;
            }

            this.resources[name].progressChunk = eachChunk;
        }

        // add the resource to the queue
        this._queue.push(this.resources[name]);

        return this;
    };
    /* eslint-enable require-jsdoc,valid-jsdoc */

    /**
     * Sets up a middleware function that will run *before* the
     * resource is loaded.
     *
     * @param {function} fn - The middleware function to register.
     * @return {this} Returns itself.
     */


    Loader.prototype.pre = function pre(fn) {
        this._beforeMiddleware.push(fn);

        return this;
    };

    /**
     * Sets up a middleware function that will run *after* the
     * resource is loaded.
     *
     * @param {function} fn - The middleware function to register.
     * @return {this} Returns itself.
     */


    Loader.prototype.use = function use(fn) {
        this._afterMiddleware.push(fn);

        return this;
    };

    /**
     * Resets the queue of the loader to prepare for a new load.
     *
     * @return {this} Returns itself.
     */


    Loader.prototype.reset = function reset() {
        this.progress = 0;
        this.loading = false;

        this._queue.kill();
        this._queue.pause();

        // abort all resource loads
        for (var k in this.resources) {
            var res = this.resources[k];

            if (res._onLoadBinding) {
                res._onLoadBinding.detach();
            }

            if (res.isLoading) {
                res.abort();
            }
        }

        this.resources = {};

        return this;
    };

    /**
     * Starts loading the queued resources.
     *
     * @param {function} [cb] - Optional callback that will be bound to the `complete` event.
     * @return {this} Returns itself.
     */


    Loader.prototype.load = function load(cb) {
        // register complete callback if they pass one
        if (typeof cb === 'function') {
            this.onComplete.once(cb);
        }

        // if the queue has already started we are done here
        if (this.loading) {
            return this;
        }

        if (this._queue.idle()) {
            this._onStart();
            this._onComplete();
        } else {
            // distribute progress chunks
            var numTasks = this._queue._tasks.length;
            var chunk = MAX_PROGRESS / numTasks;

            for (var i = 0; i < this._queue._tasks.length; ++i) {
                this._queue._tasks[i].data.progressChunk = chunk;
            }

            // notify we are starting
            this._onStart();

            // start loading
            this._queue.resume();
        }

        return this;
    };

    /**
     * The number of resources to load concurrently.
     *
     * @member {number}
     * @default 10
     */


    /**
     * Prepares a url for usage based on the configuration of this object
     *
     * @private
     * @param {string} url - The url to prepare.
     * @return {string} The prepared url.
     */
    Loader.prototype._prepareUrl = function _prepareUrl(url) {
        var parsedUrl = (0, _parseUri2.default)(url, { strictMode: true });
        var result = void 0;

        // absolute url, just use it as is.
        if (parsedUrl.protocol || !parsedUrl.path || url.indexOf('//') === 0) {
            result = url;
        }
        // if baseUrl doesn't end in slash and url doesn't start with slash, then add a slash inbetween
        else if (this.baseUrl.length && this.baseUrl.lastIndexOf('/') !== this.baseUrl.length - 1 && url.charAt(0) !== '/') {
                result = this.baseUrl + '/' + url;
            } else {
                result = this.baseUrl + url;
            }

        // if we need to add a default querystring, there is a bit more work
        if (this.defaultQueryString) {
            var hash = rgxExtractUrlHash.exec(result)[0];

            result = result.substr(0, result.length - hash.length);

            if (result.indexOf('?') !== -1) {
                result += '&' + this.defaultQueryString;
            } else {
                result += '?' + this.defaultQueryString;
            }

            result += hash;
        }

        return result;
    };

    /**
     * Loads a single resource.
     *
     * @private
     * @param {Resource} resource - The resource to load.
     * @param {function} dequeue - The function to call when we need to dequeue this item.
     */


    Loader.prototype._loadResource = function _loadResource(resource, dequeue) {
        var _this2 = this;

        resource._dequeue = dequeue;

        // run before middleware
        async.eachSeries(this._beforeMiddleware, function (fn, next) {
            fn.call(_this2, resource, function () {
                // if the before middleware marks the resource as complete,
                // break and don't process any more before middleware
                next(resource.isComplete ? {} : null);
            });
        }, function () {
            if (resource.isComplete) {
                _this2._onLoad(resource);
            } else {
                resource._onLoadBinding = resource.onComplete.once(_this2._onLoad, _this2);
                resource.load();
            }
        }, true);
    };

    /**
     * Called once loading has started.
     *
     * @private
     */


    Loader.prototype._onStart = function _onStart() {
        this.progress = 0;
        this.loading = true;
        this.onStart.dispatch(this);
    };

    /**
     * Called once each resource has loaded.
     *
     * @private
     */


    Loader.prototype._onComplete = function _onComplete() {
        this.progress = MAX_PROGRESS;
        this.loading = false;
        this.onComplete.dispatch(this, this.resources);
    };

    /**
     * Called each time a resources is loaded.
     *
     * @private
     * @param {Resource} resource - The resource that was loaded
     */


    Loader.prototype._onLoad = function _onLoad(resource) {
        var _this3 = this;

        resource._onLoadBinding = null;

        // remove this resource from the async queue, and add it to our list of resources that are being parsed
        this._resourcesParsing.push(resource);
        resource._dequeue();

        // run all the after middleware for this resource
        async.eachSeries(this._afterMiddleware, function (fn, next) {
            fn.call(_this3, resource, next);
        }, function () {
            resource.onAfterMiddleware.dispatch(resource);

            _this3.progress = Math.min(MAX_PROGRESS, _this3.progress + resource.progressChunk);
            _this3.onProgress.dispatch(_this3, resource);

            if (resource.error) {
                _this3.onError.dispatch(resource.error, _this3, resource);
            } else {
                _this3.onLoad.dispatch(_this3, resource);
            }

            _this3._resourcesParsing.splice(_this3._resourcesParsing.indexOf(resource), 1);

            // do completion check
            if (_this3._queue.idle() && _this3._resourcesParsing.length === 0) {
                _this3._onComplete();
            }
        }, true);
    };

    _createClass(Loader, [{
        key: 'concurrency',
        get: function get() {
            return this._queue.concurrency;
        }
        // eslint-disable-next-line require-jsdoc
        ,
        set: function set(concurrency) {
            this._queue.concurrency = concurrency;
        }
    }]);

    return Loader;
}();

/**
 * A default array of middleware to run before loading each resource.
 * Each of these middlewares are added to any new Loader instances when they are created.
 *
 * @private
 * @member {function[]}
 */


Loader._defaultBeforeMiddleware = [];

/**
 * A default array of middleware to run after loading each resource.
 * Each of these middlewares are added to any new Loader instances when they are created.
 *
 * @private
 * @member {function[]}
 */
Loader._defaultAfterMiddleware = [];

/**
 * Sets up a middleware function that will run *before* the
 * resource is loaded.
 *
 * @static
 * @param {function} fn - The middleware function to register.
 * @return {Loader} Returns itself.
 */
Loader.pre = function LoaderPreStatic(fn) {
    Loader._defaultBeforeMiddleware.push(fn);

    return Loader;
};

/**
 * Sets up a middleware function that will run *after* the
 * resource is loaded.
 *
 * @static
 * @param {function} fn - The middleware function to register.
 * @return {Loader} Returns itself.
 */
Loader.use = function LoaderUseStatic(fn) {
    Loader._defaultAfterMiddleware.push(fn);

    return Loader;
};
//# sourceMappingURL=Loader.js.map

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _resourceLoader = __webpack_require__(87);

var _resourceLoader2 = _interopRequireDefault(_resourceLoader);

var _blob = __webpack_require__(424);

var _eventemitter = __webpack_require__(60);

var _eventemitter2 = _interopRequireDefault(_eventemitter);

var _textureParser = __webpack_require__(217);

var _textureParser2 = _interopRequireDefault(_textureParser);

var _spritesheetParser = __webpack_require__(216);

var _spritesheetParser2 = _interopRequireDefault(_spritesheetParser);

var _bitmapFontParser = __webpack_require__(211);

var _bitmapFontParser2 = _interopRequireDefault(_bitmapFontParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 *
 * The new loader, extends Resource Loader by Chad Engler: https://github.com/englercj/resource-loader
 *
 * ```js
 * const loader = PIXI.loader; // PixiJS exposes a premade instance for you to use.
 * //or
 * const loader = new PIXI.loaders.Loader(); // you can also create your own if you want
 *
 * const sprites = {};
 *
 * // Chainable `add` to enqueue a resource
 * loader.add('bunny', 'data/bunny.png')
 *       .add('spaceship', 'assets/spritesheet.json');
 * loader.add('scoreFont', 'assets/score.fnt');
 *
 * // Chainable `pre` to add a middleware that runs for each resource, *before* loading that resource.
 * // This is useful to implement custom caching modules (using filesystem, indexeddb, memory, etc).
 * loader.pre(cachingMiddleware);
 *
 * // Chainable `use` to add a middleware that runs for each resource, *after* loading that resource.
 * // This is useful to implement custom parsing modules (like spritesheet parsers, spine parser, etc).
 * loader.use(parsingMiddleware);
 *
 * // The `load` method loads the queue of resources, and calls the passed in callback called once all
 * // resources have loaded.
 * loader.load((loader, resources) => {
 *     // resources is an object where the key is the name of the resource loaded and the value is the resource object.
 *     // They have a couple default properties:
 *     // - `url`: The URL that the resource was loaded from
 *     // - `error`: The error that happened when trying to load (if any)
 *     // - `data`: The raw data that was loaded
 *     // also may contain other properties based on the middleware that runs.
 *     sprites.bunny = new PIXI.TilingSprite(resources.bunny.texture);
 *     sprites.spaceship = new PIXI.TilingSprite(resources.spaceship.texture);
 *     sprites.scoreFont = new PIXI.TilingSprite(resources.scoreFont.texture);
 * });
 *
 * // throughout the process multiple signals can be dispatched.
 * loader.onProgress.add(() => {}); // called once per loaded/errored file
 * loader.onError.add(() => {}); // called once per errored file
 * loader.onLoad.add(() => {}); // called once per loaded file
 * loader.onComplete.add(() => {}); // called once when the queued resources all load.
 * ```
 *
 * @see https://github.com/englercj/resource-loader
 *
 * @class
 * @extends module:resource-loader.ResourceLoader
 * @memberof PIXI.loaders
 */
var Loader = function (_ResourceLoader) {
    _inherits(Loader, _ResourceLoader);

    /**
     * @param {string} [baseUrl=''] - The base url for all resources loaded by this loader.
     * @param {number} [concurrency=10] - The number of resources to load concurrently.
     */
    function Loader(baseUrl, concurrency) {
        _classCallCheck(this, Loader);

        var _this = _possibleConstructorReturn(this, _ResourceLoader.call(this, baseUrl, concurrency));

        _eventemitter2.default.call(_this);

        for (var i = 0; i < Loader._pixiMiddleware.length; ++i) {
            _this.use(Loader._pixiMiddleware[i]());
        }

        // Compat layer, translate the new v2 signals into old v1 events.
        _this.onStart.add(function (l) {
            return _this.emit('start', l);
        });
        _this.onProgress.add(function (l, r) {
            return _this.emit('progress', l, r);
        });
        _this.onError.add(function (e, l, r) {
            return _this.emit('error', e, l, r);
        });
        _this.onLoad.add(function (l, r) {
            return _this.emit('load', l, r);
        });
        _this.onComplete.add(function (l, r) {
            return _this.emit('complete', l, r);
        });
        return _this;
    }

    /**
     * Adds a default middleware to the PixiJS loader.
     *
     * @static
     * @param {Function} fn - The middleware to add.
     */


    Loader.addPixiMiddleware = function addPixiMiddleware(fn) {
        Loader._pixiMiddleware.push(fn);
    };

    /**
     * Destroy the loader, removes references.
     */


    Loader.prototype.destroy = function destroy() {
        this.removeAllListeners();
        this.reset();
    };

    return Loader;
}(_resourceLoader2.default);

// Copy EE3 prototype (mixin)


exports.default = Loader;
for (var k in _eventemitter2.default.prototype) {
    Loader.prototype[k] = _eventemitter2.default.prototype[k];
}

Loader._pixiMiddleware = [
// parse any blob into more usable objects (e.g. Image)
_blob.blobMiddlewareFactory,
// parse any Image objects into textures
_textureParser2.default,
// parse any spritesheet data into multiple textures
_spritesheetParser2.default,
// parse bitmap font data into multiple textures
_bitmapFontParser2.default];

// Add custom extentions
var Resource = _resourceLoader2.default.Resource;

Resource.setExtensionXhrType('fnt', Resource.XHR_RESPONSE_TYPE.DOCUMENT);
//# sourceMappingURL=loader.js.map

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.blobMiddlewareFactory = blobMiddlewareFactory;

var _Resource = __webpack_require__(137);

var _b = __webpack_require__(215);

var Url = window.URL || window.webkitURL;

// a middleware for transforming XHR loaded Blobs into more useful objects
function blobMiddlewareFactory() {
    return function blobMiddleware(resource, next) {
        if (!resource.data) {
            next();

            return;
        }

        // if this was an XHR load of a blob
        if (resource.xhr && resource.xhrType === _Resource.Resource.XHR_RESPONSE_TYPE.BLOB) {
            // if there is no blob support we probably got a binary string back
            if (!window.Blob || typeof resource.data === 'string') {
                var type = resource.xhr.getResponseHeader('content-type');

                // this is an image, convert the binary string into a data url
                if (type && type.indexOf('image') === 0) {
                    resource.data = new Image();
                    resource.data.src = 'data:' + type + ';base64,' + (0, _b.encodeBinary)(resource.xhr.responseText);

                    resource.type = _Resource.Resource.TYPE.IMAGE;

                    // wait until the image loads and then callback
                    resource.data.onload = function () {
                        resource.data.onload = null;

                        next();
                    };

                    // next will be called on load
                    return;
                }
            }
            // if content type says this is an image, then we should transform the blob into an Image object
            else if (resource.data.type.indexOf('image') === 0) {
                    var src = Url.createObjectURL(resource.data);

                    resource.blob = resource.data;
                    resource.data = new Image();
                    resource.data.src = src;

                    resource.type = _Resource.Resource.TYPE.IMAGE;

                    // cleanup the no longer used blob after the image loads
                    // TODO: Is this correct? Will the image be invalid after revoking?
                    resource.data.onload = function () {
                        Url.revokeObjectURL(src);
                        resource.data.onload = null;

                        next();
                    };

                    // next will be called on load.
                    return;
                }
        }

        next();
    };
}
//# sourceMappingURL=blob.js.map

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _Mesh = __webpack_require__(88);

Object.defineProperty(exports, 'Mesh', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Mesh).default;
  }
});

var _MeshRenderer = __webpack_require__(426);

Object.defineProperty(exports, 'MeshRenderer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MeshRenderer).default;
  }
});

var _CanvasMeshRenderer = __webpack_require__(427);

Object.defineProperty(exports, 'CanvasMeshRenderer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CanvasMeshRenderer).default;
  }
});

var _Plane = __webpack_require__(218);

Object.defineProperty(exports, 'Plane', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Plane).default;
  }
});

var _NineSlicePlane = __webpack_require__(428);

Object.defineProperty(exports, 'NineSlicePlane', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_NineSlicePlane).default;
  }
});

var _Rope = __webpack_require__(429);

Object.defineProperty(exports, 'Rope', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Rope).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _core = __webpack_require__(7);

var core = _interopRequireWildcard(_core);

var _pixiGlCore = __webpack_require__(31);

var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);

var _Mesh = __webpack_require__(88);

var _Mesh2 = _interopRequireDefault(_Mesh);

var _path = __webpack_require__(41);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var matrixIdentity = core.Matrix.IDENTITY;

/**
 * WebGL renderer plugin for tiling sprites
 *
 * @class
 * @memberof PIXI
 * @extends PIXI.ObjectRenderer
 */

var MeshRenderer = function (_core$ObjectRenderer) {
    _inherits(MeshRenderer, _core$ObjectRenderer);

    /**
     * constructor for renderer
     *
     * @param {WebGLRenderer} renderer The renderer this tiling awesomeness works for.
     */
    function MeshRenderer(renderer) {
        _classCallCheck(this, MeshRenderer);

        var _this = _possibleConstructorReturn(this, _core$ObjectRenderer.call(this, renderer));

        _this.shader = null;
        return _this;
    }

    /**
     * Sets up the renderer context and necessary buffers.
     *
     * @private
     */


    MeshRenderer.prototype.onContextChange = function onContextChange() {
        var gl = this.renderer.gl;

        this.shader = new core.Shader(gl, 'attribute vec2 aVertexPosition;\nattribute vec2 aTextureCoord;\n\nuniform mat3 projectionMatrix;\nuniform mat3 translationMatrix;\nuniform mat3 uTransform;\n\nvarying vec2 vTextureCoord;\n\nvoid main(void)\n{\n    gl_Position = vec4((projectionMatrix * translationMatrix * vec3(aVertexPosition, 1.0)).xy, 0.0, 1.0);\n\n    vTextureCoord = (uTransform * vec3(aTextureCoord, 1.0)).xy;\n}\n', 'varying vec2 vTextureCoord;\nuniform vec4 uColor;\n\nuniform sampler2D uSampler;\n\nvoid main(void)\n{\n    gl_FragColor = texture2D(uSampler, vTextureCoord) * uColor;\n}\n');
    };

    /**
     * renders mesh
     *
     * @param {PIXI.mesh.Mesh} mesh mesh instance
     */


    MeshRenderer.prototype.render = function render(mesh) {
        var renderer = this.renderer;
        var gl = renderer.gl;
        var texture = mesh._texture;

        if (!texture.valid) {
            return;
        }

        var glData = mesh._glDatas[renderer.CONTEXT_UID];

        if (!glData) {
            renderer.bindVao(null);

            glData = {
                shader: this.shader,
                vertexBuffer: _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, mesh.vertices, gl.STREAM_DRAW),
                uvBuffer: _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, mesh.uvs, gl.STREAM_DRAW),
                indexBuffer: _pixiGlCore2.default.GLBuffer.createIndexBuffer(gl, mesh.indices, gl.STATIC_DRAW),
                // build the vao object that will render..
                vao: null,
                dirty: mesh.dirty,
                indexDirty: mesh.indexDirty,
                vertexDirty: mesh.vertexDirty
            };

            // build the vao object that will render..
            glData.vao = new _pixiGlCore2.default.VertexArrayObject(gl).addIndex(glData.indexBuffer).addAttribute(glData.vertexBuffer, glData.shader.attributes.aVertexPosition, gl.FLOAT, false, 2 * 4, 0).addAttribute(glData.uvBuffer, glData.shader.attributes.aTextureCoord, gl.FLOAT, false, 2 * 4, 0);

            mesh._glDatas[renderer.CONTEXT_UID] = glData;
        }

        renderer.bindVao(glData.vao);

        if (mesh.dirty !== glData.dirty) {
            glData.dirty = mesh.dirty;
            glData.uvBuffer.upload(mesh.uvs);
        }

        if (mesh.indexDirty !== glData.indexDirty) {
            glData.indexDirty = mesh.indexDirty;
            glData.indexBuffer.upload(mesh.indices);
        }

        if (mesh.vertexDirty !== glData.vertexDirty) {
            glData.vertexDirty = mesh.vertexDirty;
            glData.vertexBuffer.upload(mesh.vertices);
        }

        renderer.bindShader(glData.shader);

        glData.shader.uniforms.uSampler = renderer.bindTexture(texture);

        renderer.state.setBlendMode(core.utils.correctBlendMode(mesh.blendMode, texture.baseTexture.premultipliedAlpha));

        if (glData.shader.uniforms.uTransform) {
            if (mesh.uploadUvTransform) {
                glData.shader.uniforms.uTransform = mesh._uvTransform.mapCoord.toArray(true);
            } else {
                glData.shader.uniforms.uTransform = matrixIdentity.toArray(true);
            }
        }
        glData.shader.uniforms.translationMatrix = mesh.worldTransform.toArray(true);

        glData.shader.uniforms.uColor = core.utils.premultiplyRgba(mesh.tintRgb, mesh.worldAlpha, glData.shader.uniforms.uColor, texture.baseTexture.premultipliedAlpha);

        var drawMode = mesh.drawMode === _Mesh2.default.DRAW_MODES.TRIANGLE_MESH ? gl.TRIANGLE_STRIP : gl.TRIANGLES;

        glData.vao.draw(drawMode, mesh.indices.length, 0);
    };

    return MeshRenderer;
}(core.ObjectRenderer);

exports.default = MeshRenderer;


core.WebGLRenderer.registerPlugin('mesh', MeshRenderer);
//# sourceMappingURL=MeshRenderer.js.map

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _core = __webpack_require__(7);

var core = _interopRequireWildcard(_core);

var _Mesh = __webpack_require__(88);

var _Mesh2 = _interopRequireDefault(_Mesh);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Renderer dedicated to meshes.
 *
 * @class
 * @private
 * @memberof PIXI
 */
var MeshSpriteRenderer = function () {
    /**
     * @param {PIXI.CanvasRenderer} renderer - The renderer this downport works for
     */
    function MeshSpriteRenderer(renderer) {
        _classCallCheck(this, MeshSpriteRenderer);

        this.renderer = renderer;
    }

    /**
     * Renders the Mesh
     *
     * @param {PIXI.mesh.Mesh} mesh - the Mesh to render
     */


    MeshSpriteRenderer.prototype.render = function render(mesh) {
        var renderer = this.renderer;
        var context = renderer.context;

        var transform = mesh.worldTransform;
        var res = renderer.resolution;

        if (renderer.roundPixels) {
            context.setTransform(transform.a * res, transform.b * res, transform.c * res, transform.d * res, transform.tx * res | 0, transform.ty * res | 0);
        } else {
            context.setTransform(transform.a * res, transform.b * res, transform.c * res, transform.d * res, transform.tx * res, transform.ty * res);
        }

        renderer.context.globalAlpha = mesh.worldAlpha;
        renderer.setBlendMode(mesh.blendMode);

        if (mesh.drawMode === _Mesh2.default.DRAW_MODES.TRIANGLE_MESH) {
            this._renderTriangleMesh(mesh);
        } else {
            this._renderTriangles(mesh);
        }
    };

    /**
     * Draws the object in Triangle Mesh mode
     *
     * @private
     * @param {PIXI.mesh.Mesh} mesh - the Mesh to render
     */


    MeshSpriteRenderer.prototype._renderTriangleMesh = function _renderTriangleMesh(mesh) {
        // draw triangles!!
        var length = mesh.vertices.length / 2;

        for (var i = 0; i < length - 2; i++) {
            // draw some triangles!
            var index = i * 2;

            this._renderDrawTriangle(mesh, index, index + 2, index + 4);
        }
    };

    /**
     * Draws the object in triangle mode using canvas
     *
     * @private
     * @param {PIXI.mesh.Mesh} mesh - the current mesh
     */


    MeshSpriteRenderer.prototype._renderTriangles = function _renderTriangles(mesh) {
        // draw triangles!!
        var indices = mesh.indices;
        var length = indices.length;

        for (var i = 0; i < length; i += 3) {
            // draw some triangles!
            var index0 = indices[i] * 2;
            var index1 = indices[i + 1] * 2;
            var index2 = indices[i + 2] * 2;

            this._renderDrawTriangle(mesh, index0, index1, index2);
        }
    };

    /**
     * Draws one of the triangles that from the Mesh
     *
     * @private
     * @param {PIXI.mesh.Mesh} mesh - the current mesh
     * @param {number} index0 - the index of the first vertex
     * @param {number} index1 - the index of the second vertex
     * @param {number} index2 - the index of the third vertex
     */


    MeshSpriteRenderer.prototype._renderDrawTriangle = function _renderDrawTriangle(mesh, index0, index1, index2) {
        var context = this.renderer.context;
        var uvs = mesh.uvs;
        var vertices = mesh.vertices;
        var texture = mesh._texture;

        if (!texture.valid) {
            return;
        }

        var base = texture.baseTexture;
        var textureSource = base.source;
        var textureWidth = base.width;
        var textureHeight = base.height;

        var u0 = void 0;
        var u1 = void 0;
        var u2 = void 0;
        var v0 = void 0;
        var v1 = void 0;
        var v2 = void 0;

        if (mesh.uploadUvTransform) {
            var ut = mesh._uvTransform.mapCoord;

            u0 = (uvs[index0] * ut.a + uvs[index0 + 1] * ut.c + ut.tx) * base.width;
            u1 = (uvs[index1] * ut.a + uvs[index1 + 1] * ut.c + ut.tx) * base.width;
            u2 = (uvs[index2] * ut.a + uvs[index2 + 1] * ut.c + ut.tx) * base.width;
            v0 = (uvs[index0] * ut.b + uvs[index0 + 1] * ut.d + ut.ty) * base.height;
            v1 = (uvs[index1] * ut.b + uvs[index1 + 1] * ut.d + ut.ty) * base.height;
            v2 = (uvs[index2] * ut.b + uvs[index2 + 1] * ut.d + ut.ty) * base.height;
        } else {
            u0 = uvs[index0] * base.width;
            u1 = uvs[index1] * base.width;
            u2 = uvs[index2] * base.width;
            v0 = uvs[index0 + 1] * base.height;
            v1 = uvs[index1 + 1] * base.height;
            v2 = uvs[index2 + 1] * base.height;
        }

        var x0 = vertices[index0];
        var x1 = vertices[index1];
        var x2 = vertices[index2];
        var y0 = vertices[index0 + 1];
        var y1 = vertices[index1 + 1];
        var y2 = vertices[index2 + 1];

        var canvasPadding = mesh.canvasPadding / this.renderer.resolution;

        if (canvasPadding > 0) {
            var paddingX = canvasPadding / Math.abs(mesh.worldTransform.a);
            var paddingY = canvasPadding / Math.abs(mesh.worldTransform.d);
            var centerX = (x0 + x1 + x2) / 3;
            var centerY = (y0 + y1 + y2) / 3;

            var normX = x0 - centerX;
            var normY = y0 - centerY;

            var dist = Math.sqrt(normX * normX + normY * normY);

            x0 = centerX + normX / dist * (dist + paddingX);
            y0 = centerY + normY / dist * (dist + paddingY);

            //

            normX = x1 - centerX;
            normY = y1 - centerY;

            dist = Math.sqrt(normX * normX + normY * normY);
            x1 = centerX + normX / dist * (dist + paddingX);
            y1 = centerY + normY / dist * (dist + paddingY);

            normX = x2 - centerX;
            normY = y2 - centerY;

            dist = Math.sqrt(normX * normX + normY * normY);
            x2 = centerX + normX / dist * (dist + paddingX);
            y2 = centerY + normY / dist * (dist + paddingY);
        }

        context.save();
        context.beginPath();

        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);

        context.closePath();

        context.clip();

        // Compute matrix transform
        var delta = u0 * v1 + v0 * u2 + u1 * v2 - v1 * u2 - v0 * u1 - u0 * v2;
        var deltaA = x0 * v1 + v0 * x2 + x1 * v2 - v1 * x2 - v0 * x1 - x0 * v2;
        var deltaB = u0 * x1 + x0 * u2 + u1 * x2 - x1 * u2 - x0 * u1 - u0 * x2;
        var deltaC = u0 * v1 * x2 + v0 * x1 * u2 + x0 * u1 * v2 - x0 * v1 * u2 - v0 * u1 * x2 - u0 * x1 * v2;
        var deltaD = y0 * v1 + v0 * y2 + y1 * v2 - v1 * y2 - v0 * y1 - y0 * v2;
        var deltaE = u0 * y1 + y0 * u2 + u1 * y2 - y1 * u2 - y0 * u1 - u0 * y2;
        var deltaF = u0 * v1 * y2 + v0 * y1 * u2 + y0 * u1 * v2 - y0 * v1 * u2 - v0 * u1 * y2 - u0 * y1 * v2;

        context.transform(deltaA / delta, deltaD / delta, deltaB / delta, deltaE / delta, deltaC / delta, deltaF / delta);

        context.drawImage(textureSource, 0, 0, textureWidth * base.resolution, textureHeight * base.resolution, 0, 0, textureWidth, textureHeight);

        context.restore();
        this.renderer.invalidateBlendMode();
    };

    /**
     * Renders a flat Mesh
     *
     * @private
     * @param {PIXI.mesh.Mesh} mesh - The Mesh to render
     */


    MeshSpriteRenderer.prototype.renderMeshFlat = function renderMeshFlat(mesh) {
        var context = this.renderer.context;
        var vertices = mesh.vertices;
        var length = vertices.length / 2;

        // this.count++;

        context.beginPath();

        for (var i = 1; i < length - 2; ++i) {
            // draw some triangles!
            var index = i * 2;

            var x0 = vertices[index];
            var y0 = vertices[index + 1];

            var x1 = vertices[index + 2];
            var y1 = vertices[index + 3];

            var x2 = vertices[index + 4];
            var y2 = vertices[index + 5];

            context.moveTo(x0, y0);
            context.lineTo(x1, y1);
            context.lineTo(x2, y2);
        }

        context.fillStyle = '#FF0000';
        context.fill();
        context.closePath();
    };

    /**
     * destroy the the renderer.
     *
     */


    MeshSpriteRenderer.prototype.destroy = function destroy() {
        this.renderer = null;
    };

    return MeshSpriteRenderer;
}();

exports.default = MeshSpriteRenderer;


core.CanvasRenderer.registerPlugin('mesh', MeshSpriteRenderer);
//# sourceMappingURL=CanvasMeshRenderer.js.map

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Plane2 = __webpack_require__(218);

var _Plane3 = _interopRequireDefault(_Plane2);

var _CanvasTinter = __webpack_require__(101);

var _CanvasTinter2 = _interopRequireDefault(_CanvasTinter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT_BORDER_SIZE = 10;

/**
 * The NineSlicePlane allows you to stretch a texture using 9-slice scaling. The corners will remain unscaled (useful
 * for buttons with rounded corners for example) and the other areas will be scaled horizontally and or vertically
 *
 *```js
 * let Plane9 = new PIXI.NineSlicePlane(PIXI.Texture.fromImage('BoxWithRoundedCorners.png'), 15, 15, 15, 15);
 *  ```
 * <pre>
 *      A                          B
 *    +---+----------------------+---+
 *  C | 1 |          2           | 3 |
 *    +---+----------------------+---+
 *    |   |                      |   |
 *    | 4 |          5           | 6 |
 *    |   |                      |   |
 *    +---+----------------------+---+
 *  D | 7 |          8           | 9 |
 *    +---+----------------------+---+

 *  When changing this objects width and/or height:
 *     areas 1 3 7 and 9 will remain unscaled.
 *     areas 2 and 8 will be stretched horizontally
 *     areas 4 and 6 will be stretched vertically
 *     area 5 will be stretched both horizontally and vertically
 * </pre>
 *
 * @class
 * @extends PIXI.mesh.Plane
 * @memberof PIXI.mesh
 *
 */

var NineSlicePlane = function (_Plane) {
    _inherits(NineSlicePlane, _Plane);

    /**
     * @param {PIXI.Texture} texture - The texture to use on the NineSlicePlane.
     * @param {int} [leftWidth=10] size of the left vertical bar (A)
     * @param {int} [topHeight=10] size of the top horizontal bar (C)
     * @param {int} [rightWidth=10] size of the right vertical bar (B)
     * @param {int} [bottomHeight=10] size of the bottom horizontal bar (D)
     */
    function NineSlicePlane(texture, leftWidth, topHeight, rightWidth, bottomHeight) {
        _classCallCheck(this, NineSlicePlane);

        var _this = _possibleConstructorReturn(this, _Plane.call(this, texture, 4, 4));

        _this._origWidth = texture.orig.width;
        _this._origHeight = texture.orig.height;

        /**
         * The width of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane
         *
         * @member {number}
         * @memberof PIXI.NineSlicePlane#
         * @override
         */
        _this._width = _this._origWidth;

        /**
         * The height of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane
         *
         * @member {number}
         * @memberof PIXI.NineSlicePlane#
         * @override
         */
        _this._height = _this._origHeight;

        /**
         * The width of the left column (a)
         *
         * @member {number}
         * @memberof PIXI.NineSlicePlane#
         * @override
         */
        _this._leftWidth = typeof leftWidth !== 'undefined' ? leftWidth : DEFAULT_BORDER_SIZE;

        /**
         * The width of the right column (b)
         *
         * @member {number}
         * @memberof PIXI.NineSlicePlane#
         * @override
         */
        _this._rightWidth = typeof rightWidth !== 'undefined' ? rightWidth : DEFAULT_BORDER_SIZE;

        /**
         * The height of the top row (c)
         *
         * @member {number}
         * @memberof PIXI.NineSlicePlane#
         * @override
         */
        _this._topHeight = typeof topHeight !== 'undefined' ? topHeight : DEFAULT_BORDER_SIZE;

        /**
         * The height of the bottom row (d)
         *
         * @member {number}
         * @memberof PIXI.NineSlicePlane#
         * @override
         */
        _this._bottomHeight = typeof bottomHeight !== 'undefined' ? bottomHeight : DEFAULT_BORDER_SIZE;

        /**
         * Cached tint value so we can tell when the tint is changed.
         *
         * @member {number}
         * @protected
         */
        _this._cachedTint = 0xFFFFFF;

        /**
         * Cached tinted texture.
         *
         * @member {HTMLCanvasElement}
         * @protected
         */
        _this._tintedTexture = null;

        /**
         * Temporary storage for canvas source coords
         *
         * @member {number[]}
         * @private
         */
        _this._canvasUvs = null;

        _this.refresh(true);
        return _this;
    }

    /**
     * Updates the horizontal vertices.
     *
     */


    NineSlicePlane.prototype.updateHorizontalVertices = function updateHorizontalVertices() {
        var vertices = this.vertices;

        var h = this._topHeight + this._bottomHeight;
        var scale = this._height > h ? 1.0 : this._height / h;

        vertices[9] = vertices[11] = vertices[13] = vertices[15] = this._topHeight * scale;
        vertices[17] = vertices[19] = vertices[21] = vertices[23] = this._height - this._bottomHeight * scale;
        vertices[25] = vertices[27] = vertices[29] = vertices[31] = this._height;
    };

    /**
     * Updates the vertical vertices.
     *
     */


    NineSlicePlane.prototype.updateVerticalVertices = function updateVerticalVertices() {
        var vertices = this.vertices;

        var w = this._leftWidth + this._rightWidth;
        var scale = this._width > w ? 1.0 : this._width / w;

        vertices[2] = vertices[10] = vertices[18] = vertices[26] = this._leftWidth * scale;
        vertices[4] = vertices[12] = vertices[20] = vertices[28] = this._width - this._rightWidth * scale;
        vertices[6] = vertices[14] = vertices[22] = vertices[30] = this._width;
    };

    /**
     * Renders the object using the Canvas renderer
     *
     * @private
     * @param {PIXI.CanvasRenderer} renderer - The canvas renderer to render with.
     */


    NineSlicePlane.prototype._renderCanvas = function _renderCanvas(renderer) {
        var context = renderer.context;
        var transform = this.worldTransform;
        var res = renderer.resolution;
        var isTinted = this.tint !== 0xFFFFFF;
        var texture = this._texture;

        // Work out tinting
        if (isTinted) {
            if (this._cachedTint !== this.tint) {
                // Tint has changed, need to update the tinted texture and use that instead

                this._cachedTint = this.tint;

                this._tintedTexture = _CanvasTinter2.default.getTintedTexture(this, this.tint);
            }
        }

        var textureSource = !isTinted ? texture.baseTexture.source : this._tintedTexture;

        if (!this._canvasUvs) {
            this._canvasUvs = [0, 0, 0, 0, 0, 0, 0, 0];
        }

        var vertices = this.vertices;
        var uvs = this._canvasUvs;
        var u0 = isTinted ? 0 : texture.frame.x;
        var v0 = isTinted ? 0 : texture.frame.y;
        var u1 = u0 + texture.frame.width;
        var v1 = v0 + texture.frame.height;

        uvs[0] = u0;
        uvs[1] = u0 + this._leftWidth;
        uvs[2] = u1 - this._rightWidth;
        uvs[3] = u1;
        uvs[4] = v0;
        uvs[5] = v0 + this._topHeight;
        uvs[6] = v1 - this._bottomHeight;
        uvs[7] = v1;

        for (var i = 0; i < 8; i++) {
            uvs[i] *= texture.baseTexture.resolution;
        }

        context.globalAlpha = this.worldAlpha;
        renderer.setBlendMode(this.blendMode);

        if (renderer.roundPixels) {
            context.setTransform(transform.a * res, transform.b * res, transform.c * res, transform.d * res, transform.tx * res | 0, transform.ty * res | 0);
        } else {
            context.setTransform(transform.a * res, transform.b * res, transform.c * res, transform.d * res, transform.tx * res, transform.ty * res);
        }

        for (var row = 0; row < 3; row++) {
            for (var col = 0; col < 3; col++) {
                var ind = col * 2 + row * 8;
                var sw = Math.max(1, uvs[col + 1] - uvs[col]);
                var sh = Math.max(1, uvs[row + 5] - uvs[row + 4]);
                var dw = Math.max(1, vertices[ind + 10] - vertices[ind]);
                var dh = Math.max(1, vertices[ind + 11] - vertices[ind + 1]);

                context.drawImage(textureSource, uvs[col], uvs[row + 4], sw, sh, vertices[ind], vertices[ind + 1], dw, dh);
            }
        }
    };

    /**
     * The width of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane
     *
     * @member {number}
     */


    /**
     * Refreshes NineSlicePlane coords. All of them.
     */
    NineSlicePlane.prototype._refresh = function _refresh() {
        _Plane.prototype._refresh.call(this);

        var uvs = this.uvs;
        var texture = this._texture;

        this._origWidth = texture.orig.width;
        this._origHeight = texture.orig.height;

        var _uvw = 1.0 / this._origWidth;
        var _uvh = 1.0 / this._origHeight;

        uvs[0] = uvs[8] = uvs[16] = uvs[24] = 0;
        uvs[1] = uvs[3] = uvs[5] = uvs[7] = 0;
        uvs[6] = uvs[14] = uvs[22] = uvs[30] = 1;
        uvs[25] = uvs[27] = uvs[29] = uvs[31] = 1;

        uvs[2] = uvs[10] = uvs[18] = uvs[26] = _uvw * this._leftWidth;
        uvs[4] = uvs[12] = uvs[20] = uvs[28] = 1 - _uvw * this._rightWidth;
        uvs[9] = uvs[11] = uvs[13] = uvs[15] = _uvh * this._topHeight;
        uvs[17] = uvs[19] = uvs[21] = uvs[23] = 1 - _uvh * this._bottomHeight;

        this.updateHorizontalVertices();
        this.updateVerticalVertices();

        this.dirty++;

        this.multiplyUvs();
    };

    _createClass(NineSlicePlane, [{
        key: 'width',
        get: function get() {
            return this._width;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this._width = value;
            this._refresh();
        }

        /**
         * The height of the NineSlicePlane, setting this will actually modify the vertices and UV's of this plane
         *
         * @member {number}
         */

    }, {
        key: 'height',
        get: function get() {
            return this._height;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this._height = value;
            this._refresh();
        }

        /**
         * The width of the left column
         *
         * @member {number}
         */

    }, {
        key: 'leftWidth',
        get: function get() {
            return this._leftWidth;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this._leftWidth = value;
            this._refresh();
        }

        /**
         * The width of the right column
         *
         * @member {number}
         */

    }, {
        key: 'rightWidth',
        get: function get() {
            return this._rightWidth;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this._rightWidth = value;
            this._refresh();
        }

        /**
         * The height of the top row
         *
         * @member {number}
         */

    }, {
        key: 'topHeight',
        get: function get() {
            return this._topHeight;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this._topHeight = value;
            this._refresh();
        }

        /**
         * The height of the bottom row
         *
         * @member {number}
         */

    }, {
        key: 'bottomHeight',
        get: function get() {
            return this._bottomHeight;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this._bottomHeight = value;
            this._refresh();
        }
    }]);

    return NineSlicePlane;
}(_Plane3.default);

exports.default = NineSlicePlane;
//# sourceMappingURL=NineSlicePlane.js.map

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _Mesh2 = __webpack_require__(88);

var _Mesh3 = _interopRequireDefault(_Mesh2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The rope allows you to draw a texture across several points and them manipulate these points
 *
 *```js
 * for (let i = 0; i < 20; i++) {
 *     points.push(new PIXI.Point(i * 50, 0));
 * };
 * let rope = new PIXI.Rope(PIXI.Texture.fromImage("snake.png"), points);
 *  ```
 *
 * @class
 * @extends PIXI.mesh.Mesh
 * @memberof PIXI.mesh
 *
 */
var Rope = function (_Mesh) {
    _inherits(Rope, _Mesh);

    /**
     * @param {PIXI.Texture} texture - The texture to use on the rope.
     * @param {PIXI.Point[]} points - An array of {@link PIXI.Point} objects to construct this rope.
     */
    function Rope(texture, points) {
        _classCallCheck(this, Rope);

        /**
         * An array of points that determine the rope
         *
         * @member {PIXI.Point[]}
         */
        var _this = _possibleConstructorReturn(this, _Mesh.call(this, texture));

        _this.points = points;

        /**
         * An array of vertices used to construct this rope.
         *
         * @member {Float32Array}
         */
        _this.vertices = new Float32Array(points.length * 4);

        /**
         * The WebGL Uvs of the rope.
         *
         * @member {Float32Array}
         */
        _this.uvs = new Float32Array(points.length * 4);

        /**
         * An array containing the color components
         *
         * @member {Float32Array}
         */
        _this.colors = new Float32Array(points.length * 2);

        /**
         * An array containing the indices of the vertices
         *
         * @member {Uint16Array}
         */
        _this.indices = new Uint16Array(points.length * 2);

        /**
         * refreshes vertices on every updateTransform
         * @member {boolean}
         * @default true
         */
        _this.autoUpdate = true;

        _this.refresh();
        return _this;
    }

    /**
     * Refreshes
     *
     */


    Rope.prototype._refresh = function _refresh() {
        var points = this.points;

        // if too little points, or texture hasn't got UVs set yet just move on.
        if (points.length < 1 || !this._texture._uvs) {
            return;
        }

        // if the number of points has changed we will need to recreate the arraybuffers
        if (this.vertices.length / 4 !== points.length) {
            this.vertices = new Float32Array(points.length * 4);
            this.uvs = new Float32Array(points.length * 4);
            this.colors = new Float32Array(points.length * 2);
            this.indices = new Uint16Array(points.length * 2);
        }

        var uvs = this.uvs;

        var indices = this.indices;
        var colors = this.colors;

        uvs[0] = 0;
        uvs[1] = 0;
        uvs[2] = 0;
        uvs[3] = 1;

        colors[0] = 1;
        colors[1] = 1;

        indices[0] = 0;
        indices[1] = 1;

        var total = points.length;

        for (var i = 1; i < total; i++) {
            // time to do some smart drawing!
            var index = i * 4;
            var amount = i / (total - 1);

            uvs[index] = amount;
            uvs[index + 1] = 0;

            uvs[index + 2] = amount;
            uvs[index + 3] = 1;

            index = i * 2;
            colors[index] = 1;
            colors[index + 1] = 1;

            index = i * 2;
            indices[index] = index;
            indices[index + 1] = index + 1;
        }

        // ensure that the changes are uploaded
        this.dirty++;
        this.indexDirty++;

        this.multiplyUvs();
        this.refreshVertices();
    };

    /**
     * refreshes vertices of Rope mesh
     */


    Rope.prototype.refreshVertices = function refreshVertices() {
        var points = this.points;

        if (points.length < 1) {
            return;
        }

        var lastPoint = points[0];
        var nextPoint = void 0;
        var perpX = 0;
        var perpY = 0;

        // this.count -= 0.2;

        var vertices = this.vertices;
        var total = points.length;

        for (var i = 0; i < total; i++) {
            var point = points[i];
            var index = i * 4;

            if (i < points.length - 1) {
                nextPoint = points[i + 1];
            } else {
                nextPoint = point;
            }

            perpY = -(nextPoint.x - lastPoint.x);
            perpX = nextPoint.y - lastPoint.y;

            var ratio = (1 - i / (total - 1)) * 10;

            if (ratio > 1) {
                ratio = 1;
            }

            var perpLength = Math.sqrt(perpX * perpX + perpY * perpY);
            var num = this._texture.height / 2; // (20 + Math.abs(Math.sin((i + this.count) * 0.3) * 50) )* ratio;

            perpX /= perpLength;
            perpY /= perpLength;

            perpX *= num;
            perpY *= num;

            vertices[index] = point.x + perpX;
            vertices[index + 1] = point.y + perpY;
            vertices[index + 2] = point.x - perpX;
            vertices[index + 3] = point.y - perpY;

            lastPoint = point;
        }
    };

    /**
     * Updates the object transform for rendering
     *
     * @private
     */


    Rope.prototype.updateTransform = function updateTransform() {
        if (this.autoUpdate) {
            this.refreshVertices();
        }
        this.containerUpdateTransform();
    };

    return Rope;
}(_Mesh3.default);

exports.default = Rope;
//# sourceMappingURL=Rope.js.map

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _ParticleContainer = __webpack_require__(431);

Object.defineProperty(exports, 'ParticleContainer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ParticleContainer).default;
  }
});

var _ParticleRenderer = __webpack_require__(432);

Object.defineProperty(exports, 'ParticleRenderer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ParticleRenderer).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _core = __webpack_require__(7);

var core = _interopRequireWildcard(_core);

var _utils = __webpack_require__(9);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The ParticleContainer class is a really fast version of the Container built solely for speed,
 * so use when you need a lot of sprites or particles. The tradeoff of the ParticleContainer is that most advanced
 * functionality will not work. ParticleContainer implements the basic object transform (position, scale, rotation)
 * and some advanced functionality like tint (as of v4.5.6).
 * Other more advanced functionality like masking, children, filters, etc will not work on sprites in this batch.
 *
 * It's extremely easy to use :
 *
 * ```js
 * let container = new ParticleContainer();
 *
 * for (let i = 0; i < 100; ++i)
 * {
 *     let sprite = new PIXI.Sprite.fromImage("myImage.png");
 *     container.addChild(sprite);
 * }
 * ```
 *
 * And here you have a hundred sprites that will be rendered at the speed of light.
 *
 * @class
 * @extends PIXI.Container
 * @memberof PIXI.particles
 */
var ParticleContainer = function (_core$Container) {
    _inherits(ParticleContainer, _core$Container);

    /**
     * @param {number} [maxSize=1500] - The maximum number of particles that can be rendered by the container.
     *  Affects size of allocated buffers.
     * @param {object} [properties] - The properties of children that should be uploaded to the gpu and applied.
     * @param {boolean} [properties.vertices=false] - When true, vertices be uploaded and applied.
     *                  if sprite's ` scale/anchor/trim/frame/orig` is dynamic, please set `true`.
     * @param {boolean} [properties.position=true] - When true, position be uploaded and applied.
     * @param {boolean} [properties.rotation=false] - When true, rotation be uploaded and applied.
     * @param {boolean} [properties.uvs=false] - When true, uvs be uploaded and applied.
     * @param {boolean} [properties.tint=false] - When true, alpha and tint be uploaded and applied.
     * @param {number} [batchSize=16384] - Number of particles per batch. If less than maxSize, it uses maxSize instead.
     * @param {boolean} [autoResize=false] If true, container allocates more batches in case
     *  there are more than `maxSize` particles.
     */
    function ParticleContainer() {
        var maxSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1500;
        var properties = arguments[1];
        var batchSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 16384;
        var autoResize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        _classCallCheck(this, ParticleContainer);

        // Making sure the batch size is valid
        // 65535 is max vertex index in the index buffer (see ParticleRenderer)
        // so max number of particles is 65536 / 4 = 16384
        var _this = _possibleConstructorReturn(this, _core$Container.call(this));

        var maxBatchSize = 16384;

        if (batchSize > maxBatchSize) {
            batchSize = maxBatchSize;
        }

        if (batchSize > maxSize) {
            batchSize = maxSize;
        }

        /**
         * Set properties to be dynamic (true) / static (false)
         *
         * @member {boolean[]}
         * @private
         */
        _this._properties = [false, true, false, false, false];

        /**
         * @member {number}
         * @private
         */
        _this._maxSize = maxSize;

        /**
         * @member {number}
         * @private
         */
        _this._batchSize = batchSize;

        /**
         * @member {object<number, WebGLBuffer>}
         * @private
         */
        _this._glBuffers = {};

        /**
         * for every batch stores _updateID corresponding to the last change in that batch
         * @member {number[]}
         * @private
         */
        _this._bufferUpdateIDs = [];

        /**
         * when child inserted, removed or changes position this number goes up
         * @member {number[]}
         * @private
         */
        _this._updateID = 0;

        /**
         * @member {boolean}
         *
         */
        _this.interactiveChildren = false;

        /**
         * The blend mode to be applied to the sprite. Apply a value of `PIXI.BLEND_MODES.NORMAL`
         * to reset the blend mode.
         *
         * @member {number}
         * @default PIXI.BLEND_MODES.NORMAL
         * @see PIXI.BLEND_MODES
         */
        _this.blendMode = core.BLEND_MODES.NORMAL;

        /**
         * If true, container allocates more batches in case there are more than `maxSize` particles.
         * @member {boolean}
         * @default false
         */
        _this.autoResize = autoResize;

        /**
         * Used for canvas renderering. If true then the elements will be positioned at the
         * nearest pixel. This provides a nice speed boost.
         *
         * @member {boolean}
         * @default true;
         */
        _this.roundPixels = true;

        /**
         * The texture used to render the children.
         *
         * @readonly
         * @member {BaseTexture}
         */
        _this.baseTexture = null;

        _this.setProperties(properties);

        /**
         * The tint applied to the container.
         * This is a hex value. A value of 0xFFFFFF will remove any tint effect.
         *
         * @private
         * @member {number}
         * @default 0xFFFFFF
         */
        _this._tint = 0;
        _this.tintRgb = new Float32Array(4);
        _this.tint = 0xFFFFFF;
        return _this;
    }

    /**
     * Sets the private properties array to dynamic / static based on the passed properties object
     *
     * @param {object} properties - The properties to be uploaded
     */


    ParticleContainer.prototype.setProperties = function setProperties(properties) {
        if (properties) {
            this._properties[0] = 'vertices' in properties || 'scale' in properties ? !!properties.vertices || !!properties.scale : this._properties[0];
            this._properties[1] = 'position' in properties ? !!properties.position : this._properties[1];
            this._properties[2] = 'rotation' in properties ? !!properties.rotation : this._properties[2];
            this._properties[3] = 'uvs' in properties ? !!properties.uvs : this._properties[3];
            this._properties[4] = 'tint' in properties || 'alpha' in properties ? !!properties.tint || !!properties.alpha : this._properties[4];
        }
    };

    /**
     * Updates the object transform for rendering
     *
     * @private
     */


    ParticleContainer.prototype.updateTransform = function updateTransform() {
        // TODO don't need to!
        this.displayObjectUpdateTransform();
        //  PIXI.Container.prototype.updateTransform.call( this );
    };

    /**
     * The tint applied to the container. This is a hex value.
     * A value of 0xFFFFFF will remove any tint effect.
     ** IMPORTANT: This is a webGL only feature and will be ignored by the canvas renderer.
     * @member {number}
     * @default 0xFFFFFF
     */


    /**
     * Renders the container using the WebGL renderer
     *
     * @private
     * @param {PIXI.WebGLRenderer} renderer - The webgl renderer
     */
    ParticleContainer.prototype.renderWebGL = function renderWebGL(renderer) {
        var _this2 = this;

        if (!this.visible || this.worldAlpha <= 0 || !this.children.length || !this.renderable) {
            return;
        }

        if (!this.baseTexture) {
            this.baseTexture = this.children[0]._texture.baseTexture;
            if (!this.baseTexture.hasLoaded) {
                this.baseTexture.once('update', function () {
                    return _this2.onChildrenChange(0);
                });
            }
        }

        renderer.setObjectRenderer(renderer.plugins.particle);
        renderer.plugins.particle.render(this);
    };

    /**
     * Set the flag that static data should be updated to true
     *
     * @private
     * @param {number} smallestChildIndex - The smallest child index
     */


    ParticleContainer.prototype.onChildrenChange = function onChildrenChange(smallestChildIndex) {
        var bufferIndex = Math.floor(smallestChildIndex / this._batchSize);

        while (this._bufferUpdateIDs.length < bufferIndex) {
            this._bufferUpdateIDs.push(0);
        }
        this._bufferUpdateIDs[bufferIndex] = ++this._updateID;
    };

    /**
     * Renders the object using the Canvas renderer
     *
     * @private
     * @param {PIXI.CanvasRenderer} renderer - The canvas renderer
     */


    ParticleContainer.prototype.renderCanvas = function renderCanvas(renderer) {
        if (!this.visible || this.worldAlpha <= 0 || !this.children.length || !this.renderable) {
            return;
        }

        var context = renderer.context;
        var transform = this.worldTransform;
        var isRotated = true;

        var positionX = 0;
        var positionY = 0;

        var finalWidth = 0;
        var finalHeight = 0;

        renderer.setBlendMode(this.blendMode);

        context.globalAlpha = this.worldAlpha;

        this.displayObjectUpdateTransform();

        for (var i = 0; i < this.children.length; ++i) {
            var child = this.children[i];

            if (!child.visible) {
                continue;
            }

            var frame = child._texture.frame;

            context.globalAlpha = this.worldAlpha * child.alpha;

            if (child.rotation % (Math.PI * 2) === 0) {
                // this is the fastest  way to optimise! - if rotation is 0 then we can avoid any kind of setTransform call
                if (isRotated) {
                    context.setTransform(transform.a, transform.b, transform.c, transform.d, transform.tx * renderer.resolution, transform.ty * renderer.resolution);

                    isRotated = false;
                }

                positionX = child.anchor.x * (-frame.width * child.scale.x) + child.position.x + 0.5;
                positionY = child.anchor.y * (-frame.height * child.scale.y) + child.position.y + 0.5;

                finalWidth = frame.width * child.scale.x;
                finalHeight = frame.height * child.scale.y;
            } else {
                if (!isRotated) {
                    isRotated = true;
                }

                child.displayObjectUpdateTransform();

                var childTransform = child.worldTransform;

                if (renderer.roundPixels) {
                    context.setTransform(childTransform.a, childTransform.b, childTransform.c, childTransform.d, childTransform.tx * renderer.resolution | 0, childTransform.ty * renderer.resolution | 0);
                } else {
                    context.setTransform(childTransform.a, childTransform.b, childTransform.c, childTransform.d, childTransform.tx * renderer.resolution, childTransform.ty * renderer.resolution);
                }

                positionX = child.anchor.x * -frame.width + 0.5;
                positionY = child.anchor.y * -frame.height + 0.5;

                finalWidth = frame.width;
                finalHeight = frame.height;
            }

            var resolution = child._texture.baseTexture.resolution;

            context.drawImage(child._texture.baseTexture.source, frame.x * resolution, frame.y * resolution, frame.width * resolution, frame.height * resolution, positionX * renderer.resolution, positionY * renderer.resolution, finalWidth * renderer.resolution, finalHeight * renderer.resolution);
        }
    };

    /**
     * Destroys the container
     *
     * @param {object|boolean} [options] - Options parameter. A boolean will act as if all options
     *  have been set to that value
     * @param {boolean} [options.children=false] - if set to true, all the children will have their
     *  destroy method called as well. 'options' will be passed on to those calls.
     * @param {boolean} [options.texture=false] - Only used for child Sprites if options.children is set to true
     *  Should it destroy the texture of the child sprite
     * @param {boolean} [options.baseTexture=false] - Only used for child Sprites if options.children is set to true
     *  Should it destroy the base texture of the child sprite
     */


    ParticleContainer.prototype.destroy = function destroy(options) {
        _core$Container.prototype.destroy.call(this, options);

        if (this._buffers) {
            for (var i = 0; i < this._buffers.length; ++i) {
                this._buffers[i].destroy();
            }
        }

        this._properties = null;
        this._buffers = null;
        this._bufferUpdateIDs = null;
    };

    _createClass(ParticleContainer, [{
        key: 'tint',
        get: function get() {
            return this._tint;
        },
        set: function set(value) // eslint-disable-line require-jsdoc
        {
            this._tint = value;
            (0, _utils.hex2rgb)(value, this.tintRgb);
        }
    }]);

    return ParticleContainer;
}(core.Container);

exports.default = ParticleContainer;
//# sourceMappingURL=ParticleContainer.js.map

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _core = __webpack_require__(7);

var core = _interopRequireWildcard(_core);

var _ParticleShader = __webpack_require__(433);

var _ParticleShader2 = _interopRequireDefault(_ParticleShader);

var _ParticleBuffer = __webpack_require__(434);

var _ParticleBuffer2 = _interopRequireDefault(_ParticleBuffer);

var _utils = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @author Mat Groves
 *
 * Big thanks to the very clever Matt DesLauriers <mattdesl> https://github.com/mattdesl/
 * for creating the original PixiJS version!
 * Also a thanks to https://github.com/bchevalier for tweaking the tint and alpha so that they now
 * share 4 bytes on the vertex buffer
 *
 * Heavily inspired by LibGDX's ParticleRenderer:
 * https://github.com/libgdx/libgdx/blob/master/gdx/src/com/badlogic/gdx/graphics/g2d/ParticleRenderer.java
 */

/**
 *
 * @class
 * @private
 * @memberof PIXI
 */
var ParticleRenderer = function (_core$ObjectRenderer) {
    _inherits(ParticleRenderer, _core$ObjectRenderer);

    /**
     * @param {PIXI.WebGLRenderer} renderer - The renderer this sprite batch works for.
     */
    function ParticleRenderer(renderer) {
        _classCallCheck(this, ParticleRenderer);

        // 65535 is max vertex index in the index buffer (see ParticleRenderer)
        // so max number of particles is 65536 / 4 = 16384
        // and max number of element in the index buffer is 16384 * 6 = 98304
        // Creating a full index buffer, overhead is 98304 * 2 = 196Ko
        // let numIndices = 98304;

        /**
         * The default shader that is used if a sprite doesn't have a more specific one.
         *
         * @member {PIXI.Shader}
         */
        var _this = _possibleConstructorReturn(this, _core$ObjectRenderer.call(this, renderer));

        _this.shader = null;

        _this.indexBuffer = null;

        _this.properties = null;

        _this.tempMatrix = new core.Matrix();

        _this.CONTEXT_UID = 0;
        return _this;
    }

    /**
     * When there is a WebGL context change
     *
     * @private
     */


    ParticleRenderer.prototype.onContextChange = function onContextChange() {
        var gl = this.renderer.gl;

        this.CONTEXT_UID = this.renderer.CONTEXT_UID;

        // setup default shader
        this.shader = new _ParticleShader2.default(gl);

        this.properties = [
        // verticesData
        {
            attribute: this.shader.attributes.aVertexPosition,
            size: 2,
            uploadFunction: this.uploadVertices,
            offset: 0
        },
        // positionData
        {
            attribute: this.shader.attributes.aPositionCoord,
            size: 2,
            uploadFunction: this.uploadPosition,
            offset: 0
        },
        // rotationData
        {
            attribute: this.shader.attributes.aRotation,
            size: 1,
            uploadFunction: this.uploadRotation,
            offset: 0
        },
        // uvsData
        {
            attribute: this.shader.attributes.aTextureCoord,
            size: 2,
            uploadFunction: this.uploadUvs,
            offset: 0
        },
        // tintData
        {
            attribute: this.shader.attributes.aColor,
            size: 1,
            unsignedByte: true,
            uploadFunction: this.uploadTint,
            offset: 0
        }];
    };

    /**
     * Starts a new particle batch.
     *
     */


    ParticleRenderer.prototype.start = function start() {
        this.renderer.bindShader(this.shader);
    };

    /**
     * Renders the particle container object.
     *
     * @param {PIXI.ParticleContainer} container - The container to render using this ParticleRenderer
     */


    ParticleRenderer.prototype.render = function render(container) {
        var children = container.children;
        var maxSize = container._maxSize;
        var batchSize = container._batchSize;
        var renderer = this.renderer;
        var totalChildren = children.length;

        if (totalChildren === 0) {
            return;
        } else if (totalChildren > maxSize) {
            totalChildren = maxSize;
        }

        var buffers = container._glBuffers[renderer.CONTEXT_UID];

        if (!buffers) {
            buffers = container._glBuffers[renderer.CONTEXT_UID] = this.generateBuffers(container);
        }

        var baseTexture = children[0]._texture.baseTexture;

        // if the uvs have not updated then no point rendering just yet!
        this.renderer.setBlendMode(core.utils.correctBlendMode(container.blendMode, baseTexture.premultipliedAlpha));

        var gl = renderer.gl;

        var m = container.worldTransform.copy(this.tempMatrix);

        m.prepend(renderer._activeRenderTarget.projectionMatrix);

        this.shader.uniforms.projectionMatrix = m.toArray(true);

        this.shader.uniforms.uColor = core.utils.premultiplyRgba(container.tintRgb, container.worldAlpha, this.shader.uniforms.uColor, baseTexture.premultipliedAlpha);

        // make sure the texture is bound..
        this.shader.uniforms.uSampler = renderer.bindTexture(baseTexture);

        var updateStatic = false;

        // now lets upload and render the buffers..
        for (var i = 0, j = 0; i < totalChildren; i += batchSize, j += 1) {
            var amount = totalChildren - i;

            if (amount > batchSize) {
                amount = batchSize;
            }

            if (j >= buffers.length) {
                if (!container.autoResize) {
                    break;
                }
                buffers.push(this._generateOneMoreBuffer(container));
            }

            var buffer = buffers[j];

            // we always upload the dynamic
            buffer.uploadDynamic(children, i, amount);

            var bid = container._bufferUpdateIDs[j] || 0;

            updateStatic = updateStatic || buffer._updateID < bid;
            // we only upload the static content when we have to!
            if (updateStatic) {
                buffer._updateID = container._updateID;
                buffer.uploadStatic(children, i, amount);
            }

            // bind the buffer
            renderer.bindVao(buffer.vao);
            buffer.vao.draw(gl.TRIANGLES, amount * 6);
        }
    };

    /**
     * Creates one particle buffer for each child in the container we want to render and updates internal properties
     *
     * @param {PIXI.ParticleContainer} container - The container to render using this ParticleRenderer
     * @return {PIXI.ParticleBuffer[]} The buffers
     */


    ParticleRenderer.prototype.generateBuffers = function generateBuffers(container) {
        var gl = this.renderer.gl;
        var buffers = [];
        var size = container._maxSize;
        var batchSize = container._batchSize;
        var dynamicPropertyFlags = container._properties;

        for (var i = 0; i < size; i += batchSize) {
            buffers.push(new _ParticleBuffer2.default(gl, this.properties, dynamicPropertyFlags, batchSize));
        }

        return buffers;
    };

    /**
     * Creates one more particle buffer, because container has autoResize feature
     *
     * @param {PIXI.ParticleContainer} container - The container to render using this ParticleRenderer
     * @return {PIXI.ParticleBuffer} generated buffer
     * @private
     */


    ParticleRenderer.prototype._generateOneMoreBuffer = function _generateOneMoreBuffer(container) {
        var gl = this.renderer.gl;
        var batchSize = container._batchSize;
        var dynamicPropertyFlags = container._properties;

        return new _ParticleBuffer2.default(gl, this.properties, dynamicPropertyFlags, batchSize);
    };

    /**
     * Uploads the verticies.
     *
     * @param {PIXI.DisplayObject[]} children - the array of display objects to render
     * @param {number} startIndex - the index to start from in the children array
     * @param {number} amount - the amount of children that will have their vertices uploaded
     * @param {number[]} array - The vertices to upload.
     * @param {number} stride - Stride to use for iteration.
     * @param {number} offset - Offset to start at.
     */


    ParticleRenderer.prototype.uploadVertices = function uploadVertices(children, startIndex, amount, array, stride, offset) {
        var w0 = 0;
        var w1 = 0;
        var h0 = 0;
        var h1 = 0;

        for (var i = 0; i < amount; ++i) {
            var sprite = children[startIndex + i];
            var texture = sprite._texture;
            var sx = sprite.scale.x;
            var sy = sprite.scale.y;
            var trim = texture.trim;
            var orig = texture.orig;

            if (trim) {
                // if the sprite is trimmed and is not a tilingsprite then we need to add the
                // extra space before transforming the sprite coords..
                w1 = trim.x - sprite.anchor.x * orig.width;
                w0 = w1 + trim.width;

                h1 = trim.y - sprite.anchor.y * orig.height;
                h0 = h1 + trim.height;
            } else {
                w0 = orig.width * (1 - sprite.anchor.x);
                w1 = orig.width * -sprite.anchor.x;

                h0 = orig.height * (1 - sprite.anchor.y);
                h1 = orig.height * -sprite.anchor.y;
            }

            array[offset] = w1 * sx;
            array[offset + 1] = h1 * sy;

            array[offset + stride] = w0 * sx;
            array[offset + stride + 1] = h1 * sy;

            array[offset + stride * 2] = w0 * sx;
            array[offset + stride * 2 + 1] = h0 * sy;

            array[offset + stride * 3] = w1 * sx;
            array[offset + stride * 3 + 1] = h0 * sy;

            offset += stride * 4;
        }
    };

    /**
     *
     * @param {PIXI.DisplayObject[]} children - the array of display objects to render
     * @param {number} startIndex - the index to start from in the children array
     * @param {number} amount - the amount of children that will have their positions uploaded
     * @param {number[]} array - The vertices to upload.
     * @param {number} stride - Stride to use for iteration.
     * @param {number} offset - Offset to start at.
     */


    ParticleRenderer.prototype.uploadPosition = function uploadPosition(children, startIndex, amount, array, stride, offset) {
        for (var i = 0; i < amount; i++) {
            var spritePosition = children[startIndex + i].position;

            array[offset] = spritePosition.x;
            array[offset + 1] = spritePosition.y;

            array[offset + stride] = spritePosition.x;
            array[offset + stride + 1] = spritePosition.y;

            array[offset + stride * 2] = spritePosition.x;
            array[offset + stride * 2 + 1] = spritePosition.y;

            array[offset + stride * 3] = spritePosition.x;
            array[offset + stride * 3 + 1] = spritePosition.y;

            offset += stride * 4;
        }
    };

    /**
     *
     * @param {PIXI.DisplayObject[]} children - the array of display objects to render
     * @param {number} startIndex - the index to start from in the children array
     * @param {number} amount - the amount of children that will have their rotation uploaded
     * @param {number[]} array - The vertices to upload.
     * @param {number} stride - Stride to use for iteration.
     * @param {number} offset - Offset to start at.
     */


    ParticleRenderer.prototype.uploadRotation = function uploadRotation(children, startIndex, amount, array, stride, offset) {
        for (var i = 0; i < amount; i++) {
            var spriteRotation = children[startIndex + i].rotation;

            array[offset] = spriteRotation;
            array[offset + stride] = spriteRotation;
            array[offset + stride * 2] = spriteRotation;
            array[offset + stride * 3] = spriteRotation;

            offset += stride * 4;
        }
    };

    /**
     *
     * @param {PIXI.DisplayObject[]} children - the array of display objects to render
     * @param {number} startIndex - the index to start from in the children array
     * @param {number} amount - the amount of children that will have their rotation uploaded
     * @param {number[]} array - The vertices to upload.
     * @param {number} stride - Stride to use for iteration.
     * @param {number} offset - Offset to start at.
     */


    ParticleRenderer.prototype.uploadUvs = function uploadUvs(children, startIndex, amount, array, stride, offset) {
        for (var i = 0; i < amount; ++i) {
            var textureUvs = children[startIndex + i]._texture._uvs;

            if (textureUvs) {
                array[offset] = textureUvs.x0;
                array[offset + 1] = textureUvs.y0;

                array[offset + stride] = textureUvs.x1;
                array[offset + stride + 1] = textureUvs.y1;

                array[offset + stride * 2] = textureUvs.x2;
                array[offset + stride * 2 + 1] = textureUvs.y2;

                array[offset + stride * 3] = textureUvs.x3;
                array[offset + stride * 3 + 1] = textureUvs.y3;

                offset += stride * 4;
            } else {
                // TODO you know this can be easier!
                array[offset] = 0;
                array[offset + 1] = 0;

                array[offset + stride] = 0;
                array[offset + stride + 1] = 0;

                array[offset + stride * 2] = 0;
                array[offset + stride * 2 + 1] = 0;

                array[offset + stride * 3] = 0;
                array[offset + stride * 3 + 1] = 0;

                offset += stride * 4;
            }
        }
    };

    /**
     *
     * @param {PIXI.DisplayObject[]} children - the array of display objects to render
     * @param {number} startIndex - the index to start from in the children array
     * @param {number} amount - the amount of children that will have their rotation uploaded
     * @param {number[]} array - The vertices to upload.
     * @param {number} stride - Stride to use for iteration.
     * @param {number} offset - Offset to start at.
     */


    ParticleRenderer.prototype.uploadTint = function uploadTint(children, startIndex, amount, array, stride, offset) {
        for (var i = 0; i < amount; ++i) {
            var sprite = children[startIndex + i];
            var premultiplied = sprite._texture.baseTexture.premultipliedAlpha;
            var alpha = sprite.alpha;
            // we dont call extra function if alpha is 1.0, that's faster
            var argb = alpha < 1.0 && premultiplied ? (0, _utils.premultiplyTint)(sprite._tintRGB, alpha) : sprite._tintRGB + (alpha * 255 << 24);

            array[offset] = argb;
            array[offset + stride] = argb;
            array[offset + stride * 2] = argb;
            array[offset + stride * 3] = argb;

            offset += stride * 4;
        }
    };

    /**
     * Destroys the ParticleRenderer.
     *
     */


    ParticleRenderer.prototype.destroy = function destroy() {
        if (this.renderer.gl) {
            this.renderer.gl.deleteBuffer(this.indexBuffer);
        }

        _core$ObjectRenderer.prototype.destroy.call(this);

        this.shader.destroy();

        this.indices = null;
        this.tempMatrix = null;
    };

    return ParticleRenderer;
}(core.ObjectRenderer);

exports.default = ParticleRenderer;


core.WebGLRenderer.registerPlugin('particle', ParticleRenderer);
//# sourceMappingURL=ParticleRenderer.js.map

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _Shader2 = __webpack_require__(86);

var _Shader3 = _interopRequireDefault(_Shader2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class
 * @extends PIXI.Shader
 * @memberof PIXI
 */
var ParticleShader = function (_Shader) {
    _inherits(ParticleShader, _Shader);

    /**
     * @param {PIXI.Shader} gl - The webgl shader manager this shader works for.
     */
    function ParticleShader(gl) {
        _classCallCheck(this, ParticleShader);

        return _possibleConstructorReturn(this, _Shader.call(this, gl,
        // vertex shader
        ['attribute vec2 aVertexPosition;', 'attribute vec2 aTextureCoord;', 'attribute vec4 aColor;', 'attribute vec2 aPositionCoord;', 'attribute float aRotation;', 'uniform mat3 projectionMatrix;', 'uniform vec4 uColor;', 'varying vec2 vTextureCoord;', 'varying vec4 vColor;', 'void main(void){', '   float x = (aVertexPosition.x) * cos(aRotation) - (aVertexPosition.y) * sin(aRotation);', '   float y = (aVertexPosition.x) * sin(aRotation) + (aVertexPosition.y) * cos(aRotation);', '   vec2 v = vec2(x, y);', '   v = v + aPositionCoord;', '   gl_Position = vec4((projectionMatrix * vec3(v, 1.0)).xy, 0.0, 1.0);', '   vTextureCoord = aTextureCoord;', '   vColor = aColor * uColor;', '}'].join('\n'),
        // hello
        ['varying vec2 vTextureCoord;', 'varying vec4 vColor;', 'uniform sampler2D uSampler;', 'void main(void){', '  vec4 color = texture2D(uSampler, vTextureCoord) * vColor;', '  gl_FragColor = color;', '}'].join('\n')));
    }

    return ParticleShader;
}(_Shader3.default);

exports.default = ParticleShader;
//# sourceMappingURL=ParticleShader.js.map

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _pixiGlCore = __webpack_require__(31);

var _pixiGlCore2 = _interopRequireDefault(_pixiGlCore);

var _createIndicesForQuads = __webpack_require__(136);

var _createIndicesForQuads2 = _interopRequireDefault(_createIndicesForQuads);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @author Mat Groves
 *
 * Big thanks to the very clever Matt DesLauriers <mattdesl> https://github.com/mattdesl/
 * for creating the original PixiJS version!
 * Also a thanks to https://github.com/bchevalier for tweaking the tint and alpha so that
 * they now share 4 bytes on the vertex buffer
 *
 * Heavily inspired by LibGDX's ParticleBuffer:
 * https://github.com/libgdx/libgdx/blob/master/gdx/src/com/badlogic/gdx/graphics/g2d/ParticleBuffer.java
 */

/**
 * The particle buffer manages the static and dynamic buffers for a particle container.
 *
 * @class
 * @private
 * @memberof PIXI
 */
var ParticleBuffer = function () {
    /**
     * @param {WebGLRenderingContext} gl - The rendering context.
     * @param {object} properties - The properties to upload.
     * @param {boolean[]} dynamicPropertyFlags - Flags for which properties are dynamic.
     * @param {number} size - The size of the batch.
     */
    function ParticleBuffer(gl, properties, dynamicPropertyFlags, size) {
        _classCallCheck(this, ParticleBuffer);

        /**
         * The current WebGL drawing context.
         *
         * @member {WebGLRenderingContext}
         */
        this.gl = gl;

        /**
         * The number of particles the buffer can hold
         *
         * @member {number}
         */
        this.size = size;

        /**
         * A list of the properties that are dynamic.
         *
         * @member {object[]}
         */
        this.dynamicProperties = [];

        /**
         * A list of the properties that are static.
         *
         * @member {object[]}
         */
        this.staticProperties = [];

        for (var i = 0; i < properties.length; ++i) {
            var property = properties[i];

            // Make copy of properties object so that when we edit the offset it doesn't
            // change all other instances of the object literal
            property = {
                attribute: property.attribute,
                size: property.size,
                uploadFunction: property.uploadFunction,
                unsignedByte: property.unsignedByte,
                offset: property.offset
            };

            if (dynamicPropertyFlags[i]) {
                this.dynamicProperties.push(property);
            } else {
                this.staticProperties.push(property);
            }
        }

        this.staticStride = 0;
        this.staticBuffer = null;
        this.staticData = null;
        this.staticDataUint32 = null;

        this.dynamicStride = 0;
        this.dynamicBuffer = null;
        this.dynamicData = null;
        this.dynamicDataUint32 = null;

        this._updateID = 0;

        this.initBuffers();
    }

    /**
     * Sets up the renderer context and necessary buffers.
     *
     * @private
     */


    ParticleBuffer.prototype.initBuffers = function initBuffers() {
        var gl = this.gl;
        var dynamicOffset = 0;

        /**
         * Holds the indices of the geometry (quads) to draw
         *
         * @member {Uint16Array}
         */
        this.indices = (0, _createIndicesForQuads2.default)(this.size);
        this.indexBuffer = _pixiGlCore2.default.GLBuffer.createIndexBuffer(gl, this.indices, gl.STATIC_DRAW);

        this.dynamicStride = 0;

        for (var i = 0; i < this.dynamicProperties.length; ++i) {
            var property = this.dynamicProperties[i];

            property.offset = dynamicOffset;
            dynamicOffset += property.size;
            this.dynamicStride += property.size;
        }

        var dynBuffer = new ArrayBuffer(this.size * this.dynamicStride * 4 * 4);

        this.dynamicData = new Float32Array(dynBuffer);
        this.dynamicDataUint32 = new Uint32Array(dynBuffer);
        this.dynamicBuffer = _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, dynBuffer, gl.STREAM_DRAW);

        // static //
        var staticOffset = 0;

        this.staticStride = 0;

        for (var _i = 0; _i < this.staticProperties.length; ++_i) {
            var _property = this.staticProperties[_i];

            _property.offset = staticOffset;
            staticOffset += _property.size;
            this.staticStride += _property.size;
        }

        var statBuffer = new ArrayBuffer(this.size * this.staticStride * 4 * 4);

        this.staticData = new Float32Array(statBuffer);
        this.staticDataUint32 = new Uint32Array(statBuffer);
        this.staticBuffer = _pixiGlCore2.default.GLBuffer.createVertexBuffer(gl, statBuffer, gl.STATIC_DRAW);

        this.vao = new _pixiGlCore2.default.VertexArrayObject(gl).addIndex(this.indexBuffer);

        for (var _i2 = 0; _i2 < this.dynamicProperties.length; ++_i2) {
            var _property2 = this.dynamicProperties[_i2];

            if (_property2.unsignedByte) {
                this.vao.addAttribute(this.dynamicBuffer, _property2.attribute, gl.UNSIGNED_BYTE, true, this.dynamicStride * 4, _property2.offset * 4);
            } else {
                this.vao.addAttribute(this.dynamicBuffer, _property2.attribute, gl.FLOAT, false, this.dynamicStride * 4, _property2.offset * 4);
            }
        }

        for (var _i3 = 0; _i3 < this.staticProperties.length; ++_i3) {
            var _property3 = this.staticProperties[_i3];

            if (_property3.unsignedByte) {
                this.vao.addAttribute(this.staticBuffer, _property3.attribute, gl.UNSIGNED_BYTE, true, this.staticStride * 4, _property3.offset * 4);
            } else {
                this.vao.addAttribute(this.staticBuffer, _property3.attribute, gl.FLOAT, false, this.staticStride * 4, _property3.offset * 4);
            }
        }
    };

    /**
     * Uploads the dynamic properties.
     *
     * @param {PIXI.DisplayObject[]} children - The children to upload.
     * @param {number} startIndex - The index to start at.
     * @param {number} amount - The number to upload.
     */


    ParticleBuffer.prototype.uploadDynamic = function uploadDynamic(children, startIndex, amount) {
        for (var i = 0; i < this.dynamicProperties.length; i++) {
            var property = this.dynamicProperties[i];

            property.uploadFunction(children, startIndex, amount, property.unsignedByte ? this.dynamicDataUint32 : this.dynamicData, this.dynamicStride, property.offset);
        }

        this.dynamicBuffer.upload();
    };

    /**
     * Uploads the static properties.
     *
     * @param {PIXI.DisplayObject[]} children - The children to upload.
     * @param {number} startIndex - The index to start at.
     * @param {number} amount - The number to upload.
     */


    ParticleBuffer.prototype.uploadStatic = function uploadStatic(children, startIndex, amount) {
        for (var i = 0; i < this.staticProperties.length; i++) {
            var property = this.staticProperties[i];

            property.uploadFunction(children, startIndex, amount, property.unsignedByte ? this.staticDataUint32 : this.staticData, this.staticStride, property.offset);
        }

        this.staticBuffer.upload();
    };

    /**
     * Destroys the ParticleBuffer.
     *
     */


    ParticleBuffer.prototype.destroy = function destroy() {
        this.dynamicProperties = null;
        this.dynamicBuffer.destroy();
        this.dynamicBuffer = null;
        this.dynamicData = null;
        this.dynamicDataUint32 = null;

        this.staticProperties = null;
        this.staticBuffer.destroy();
        this.staticBuffer = null;
        this.staticData = null;
        this.staticDataUint32 = null;
    };

    return ParticleBuffer;
}();

exports.default = ParticleBuffer;
//# sourceMappingURL=ParticleBuffer.js.map

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _WebGLPrepare = __webpack_require__(436);

Object.defineProperty(exports, 'webgl', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_WebGLPrepare).default;
  }
});

var _CanvasPrepare = __webpack_require__(437);

Object.defineProperty(exports, 'canvas', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CanvasPrepare).default;
  }
});

var _BasePrepare = __webpack_require__(138);

Object.defineProperty(exports, 'BasePrepare', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BasePrepare).default;
  }
});

var _CountLimiter = __webpack_require__(219);

Object.defineProperty(exports, 'CountLimiter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CountLimiter).default;
  }
});

var _TimeLimiter = __webpack_require__(438);

Object.defineProperty(exports, 'TimeLimiter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TimeLimiter).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _core = __webpack_require__(7);

var core = _interopRequireWildcard(_core);

var _BasePrepare2 = __webpack_require__(138);

var _BasePrepare3 = _interopRequireDefault(_BasePrepare2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The prepare manager provides functionality to upload content to the GPU.
 *
 * An instance of this class is automatically created by default, and can be found at renderer.plugins.prepare
 *
 * @class
 * @extends PIXI.prepare.BasePrepare
 * @memberof PIXI.prepare
 */
var WebGLPrepare = function (_BasePrepare) {
    _inherits(WebGLPrepare, _BasePrepare);

    /**
     * @param {PIXI.WebGLRenderer} renderer - A reference to the current renderer
     */
    function WebGLPrepare(renderer) {
        _classCallCheck(this, WebGLPrepare);

        var _this = _possibleConstructorReturn(this, _BasePrepare.call(this, renderer));

        _this.uploadHookHelper = _this.renderer;

        // Add textures and graphics to upload
        _this.registerFindHook(findGraphics);
        _this.registerUploadHook(uploadBaseTextures);
        _this.registerUploadHook(uploadGraphics);
        return _this;
    }

    return WebGLPrepare;
}(_BasePrepare3.default);
/**
 * Built-in hook to upload PIXI.Texture objects to the GPU.
 *
 * @private
 * @param {PIXI.WebGLRenderer} renderer - instance of the webgl renderer
 * @param {PIXI.DisplayObject} item - Item to check
 * @return {boolean} If item was uploaded.
 */


exports.default = WebGLPrepare;
function uploadBaseTextures(renderer, item) {
    if (item instanceof core.BaseTexture) {
        // if the texture already has a GL texture, then the texture has been prepared or rendered
        // before now. If the texture changed, then the changer should be calling texture.update() which
        // reuploads the texture without need for preparing it again
        if (!item._glTextures[renderer.CONTEXT_UID]) {
            renderer.textureManager.updateTexture(item);
        }

        return true;
    }

    return false;
}

/**
 * Built-in hook to upload PIXI.Graphics to the GPU.
 *
 * @private
 * @param {PIXI.WebGLRenderer} renderer - instance of the webgl renderer
 * @param {PIXI.DisplayObject} item - Item to check
 * @return {boolean} If item was uploaded.
 */
function uploadGraphics(renderer, item) {
    if (item instanceof core.Graphics) {
        // if the item is not dirty and already has webgl data, then it got prepared or rendered
        // before now and we shouldn't waste time updating it again
        if (item.dirty || item.clearDirty || !item._webGL[renderer.plugins.graphics.CONTEXT_UID]) {
            renderer.plugins.graphics.updateGraphics(item);
        }

        return true;
    }

    return false;
}

/**
 * Built-in hook to find graphics.
 *
 * @private
 * @param {PIXI.DisplayObject} item - Display object to check
 * @param {Array<*>} queue - Collection of items to upload
 * @return {boolean} if a PIXI.Graphics object was found.
 */
function findGraphics(item, queue) {
    if (item instanceof core.Graphics) {
        queue.push(item);

        return true;
    }

    return false;
}

core.WebGLRenderer.registerPlugin('prepare', WebGLPrepare);
//# sourceMappingURL=WebGLPrepare.js.map

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _core = __webpack_require__(7);

var core = _interopRequireWildcard(_core);

var _BasePrepare2 = __webpack_require__(138);

var _BasePrepare3 = _interopRequireDefault(_BasePrepare2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CANVAS_START_SIZE = 16;

/**
 * The prepare manager provides functionality to upload content to the GPU
 * This cannot be done directly for Canvas like in WebGL, but the effect can be achieved by drawing
 * textures to an offline canvas.
 * This draw call will force the texture to be moved onto the GPU.
 *
 * An instance of this class is automatically created by default, and can be found at renderer.plugins.prepare
 *
 * @class
 * @extends PIXI.prepare.BasePrepare
 * @memberof PIXI.prepare
 */

var CanvasPrepare = function (_BasePrepare) {
    _inherits(CanvasPrepare, _BasePrepare);

    /**
     * @param {PIXI.CanvasRenderer} renderer - A reference to the current renderer
     */
    function CanvasPrepare(renderer) {
        _classCallCheck(this, CanvasPrepare);

        var _this = _possibleConstructorReturn(this, _BasePrepare.call(this, renderer));

        _this.uploadHookHelper = _this;

        /**
        * An offline canvas to render textures to
        * @type {HTMLCanvasElement}
        * @private
        */
        _this.canvas = document.createElement('canvas');
        _this.canvas.width = CANVAS_START_SIZE;
        _this.canvas.height = CANVAS_START_SIZE;

        /**
         * The context to the canvas
        * @type {CanvasRenderingContext2D}
        * @private
        */
        _this.ctx = _this.canvas.getContext('2d');

        // Add textures to upload
        _this.registerUploadHook(uploadBaseTextures);
        return _this;
    }

    /**
     * Destroys the plugin, don't use after this.
     *
     */


    CanvasPrepare.prototype.destroy = function destroy() {
        _BasePrepare.prototype.destroy.call(this);
        this.ctx = null;
        this.canvas = null;
    };

    return CanvasPrepare;
}(_BasePrepare3.default);

/**
 * Built-in hook to upload PIXI.Texture objects to the GPU.
 *
 * @private
 * @param {*} prepare - Instance of CanvasPrepare
 * @param {*} item - Item to check
 * @return {boolean} If item was uploaded.
 */


exports.default = CanvasPrepare;
function uploadBaseTextures(prepare, item) {
    if (item instanceof core.BaseTexture) {
        var image = item.source;

        // Sometimes images (like atlas images) report a size of zero, causing errors on windows phone.
        // So if the width or height is equal to zero then use the canvas size
        // Otherwise use whatever is smaller, the image dimensions or the canvas dimensions.
        var imageWidth = image.width === 0 ? prepare.canvas.width : Math.min(prepare.canvas.width, image.width);
        var imageHeight = image.height === 0 ? prepare.canvas.height : Math.min(prepare.canvas.height, image.height);

        // Only a small subsections is required to be drawn to have the whole texture uploaded to the GPU
        // A smaller draw can be faster.
        prepare.ctx.drawImage(image, 0, 0, imageWidth, imageHeight, 0, 0, prepare.canvas.width, prepare.canvas.height);

        return true;
    }

    return false;
}

core.CanvasRenderer.registerPlugin('prepare', CanvasPrepare);
//# sourceMappingURL=CanvasPrepare.js.map

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * TimeLimiter limits the number of items handled by a {@link PIXI.BasePrepare} to a specified
 * number of milliseconds per frame.
 *
 * @class
 * @memberof PIXI
 */
var TimeLimiter = function () {
  /**
   * @param {number} maxMilliseconds - The maximum milliseconds that can be spent preparing items each frame.
   */
  function TimeLimiter(maxMilliseconds) {
    _classCallCheck(this, TimeLimiter);

    /**
     * The maximum milliseconds that can be spent preparing items each frame.
     * @private
     */
    this.maxMilliseconds = maxMilliseconds;
    /**
     * The start time of the current frame.
     * @type {number}
     * @private
     */
    this.frameStart = 0;
  }

  /**
   * Resets any counting properties to start fresh on a new frame.
   */


  TimeLimiter.prototype.beginFrame = function beginFrame() {
    this.frameStart = Date.now();
  };

  /**
   * Checks to see if another item can be uploaded. This should only be called once per item.
   * @return {boolean} If the item is allowed to be uploaded.
   */


  TimeLimiter.prototype.allowedToUpload = function allowedToUpload() {
    return Date.now() - this.frameStart < this.maxMilliseconds;
  };

  return TimeLimiter;
}();

exports.default = TimeLimiter;
//# sourceMappingURL=TimeLimiter.js.map

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24), __webpack_require__(50)))

/***/ }),
/* 440 */
/***/ (function(module, exports) {

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var pixi_spine;
(function (pixi_spine) {
    var core;
    (function (core) {
        var Animation = (function () {
            function Animation(name, timelines, duration) {
                if (name == null)
                    throw new Error("name cannot be null.");
                if (timelines == null)
                    throw new Error("timelines cannot be null.");
                this.name = name;
                this.timelines = timelines;
                this.duration = duration;
            }
            Animation.prototype.apply = function (skeleton, lastTime, time, loop, events, alpha, blend, direction) {
                if (skeleton == null)
                    throw new Error("skeleton cannot be null.");
                if (loop && this.duration != 0) {
                    time %= this.duration;
                    if (lastTime > 0)
                        lastTime %= this.duration;
                }
                var timelines = this.timelines;
                for (var i = 0, n = timelines.length; i < n; i++)
                    timelines[i].apply(skeleton, lastTime, time, events, alpha, blend, direction);
            };
            Animation.binarySearch = function (values, target, step) {
                if (step === void 0) { step = 1; }
                var low = 0;
                var high = values.length / step - 2;
                if (high == 0)
                    return step;
                var current = high >>> 1;
                while (true) {
                    if (values[(current + 1) * step] <= target)
                        low = current + 1;
                    else
                        high = current;
                    if (low == high)
                        return (low + 1) * step;
                    current = (low + high) >>> 1;
                }
            };
            Animation.linearSearch = function (values, target, step) {
                for (var i = 0, last = values.length - step; i <= last; i += step)
                    if (values[i] > target)
                        return i;
                return -1;
            };
            return Animation;
        }());
        core.Animation = Animation;
        var MixBlend;
        (function (MixBlend) {
            MixBlend[MixBlend["setup"] = 0] = "setup";
            MixBlend[MixBlend["first"] = 1] = "first";
            MixBlend[MixBlend["replace"] = 2] = "replace";
            MixBlend[MixBlend["add"] = 3] = "add";
        })(MixBlend = core.MixBlend || (core.MixBlend = {}));
        var MixDirection;
        (function (MixDirection) {
            MixDirection[MixDirection["mixIn"] = 0] = "mixIn";
            MixDirection[MixDirection["mixOut"] = 1] = "mixOut";
        })(MixDirection = core.MixDirection || (core.MixDirection = {}));
        var TimelineType;
        (function (TimelineType) {
            TimelineType[TimelineType["rotate"] = 0] = "rotate";
            TimelineType[TimelineType["translate"] = 1] = "translate";
            TimelineType[TimelineType["scale"] = 2] = "scale";
            TimelineType[TimelineType["shear"] = 3] = "shear";
            TimelineType[TimelineType["attachment"] = 4] = "attachment";
            TimelineType[TimelineType["color"] = 5] = "color";
            TimelineType[TimelineType["deform"] = 6] = "deform";
            TimelineType[TimelineType["event"] = 7] = "event";
            TimelineType[TimelineType["drawOrder"] = 8] = "drawOrder";
            TimelineType[TimelineType["ikConstraint"] = 9] = "ikConstraint";
            TimelineType[TimelineType["transformConstraint"] = 10] = "transformConstraint";
            TimelineType[TimelineType["pathConstraintPosition"] = 11] = "pathConstraintPosition";
            TimelineType[TimelineType["pathConstraintSpacing"] = 12] = "pathConstraintSpacing";
            TimelineType[TimelineType["pathConstraintMix"] = 13] = "pathConstraintMix";
            TimelineType[TimelineType["twoColor"] = 14] = "twoColor";
        })(TimelineType = core.TimelineType || (core.TimelineType = {}));
        var CurveTimeline = (function () {
            function CurveTimeline(frameCount) {
                if (frameCount <= 0)
                    throw new Error("frameCount must be > 0: " + frameCount);
                this.curves = core.Utils.newFloatArray((frameCount - 1) * CurveTimeline.BEZIER_SIZE);
            }
            CurveTimeline.prototype.getFrameCount = function () {
                return this.curves.length / CurveTimeline.BEZIER_SIZE + 1;
            };
            CurveTimeline.prototype.setLinear = function (frameIndex) {
                this.curves[frameIndex * CurveTimeline.BEZIER_SIZE] = CurveTimeline.LINEAR;
            };
            CurveTimeline.prototype.setStepped = function (frameIndex) {
                this.curves[frameIndex * CurveTimeline.BEZIER_SIZE] = CurveTimeline.STEPPED;
            };
            CurveTimeline.prototype.getCurveType = function (frameIndex) {
                var index = frameIndex * CurveTimeline.BEZIER_SIZE;
                if (index == this.curves.length)
                    return CurveTimeline.LINEAR;
                var type = this.curves[index];
                if (type == CurveTimeline.LINEAR)
                    return CurveTimeline.LINEAR;
                if (type == CurveTimeline.STEPPED)
                    return CurveTimeline.STEPPED;
                return CurveTimeline.BEZIER;
            };
            CurveTimeline.prototype.setCurve = function (frameIndex, cx1, cy1, cx2, cy2) {
                var tmpx = (-cx1 * 2 + cx2) * 0.03, tmpy = (-cy1 * 2 + cy2) * 0.03;
                var dddfx = ((cx1 - cx2) * 3 + 1) * 0.006, dddfy = ((cy1 - cy2) * 3 + 1) * 0.006;
                var ddfx = tmpx * 2 + dddfx, ddfy = tmpy * 2 + dddfy;
                var dfx = cx1 * 0.3 + tmpx + dddfx * 0.16666667, dfy = cy1 * 0.3 + tmpy + dddfy * 0.16666667;
                var i = frameIndex * CurveTimeline.BEZIER_SIZE;
                var curves = this.curves;
                curves[i++] = CurveTimeline.BEZIER;
                var x = dfx, y = dfy;
                for (var n = i + CurveTimeline.BEZIER_SIZE - 1; i < n; i += 2) {
                    curves[i] = x;
                    curves[i + 1] = y;
                    dfx += ddfx;
                    dfy += ddfy;
                    ddfx += dddfx;
                    ddfy += dddfy;
                    x += dfx;
                    y += dfy;
                }
            };
            CurveTimeline.prototype.getCurvePercent = function (frameIndex, percent) {
                percent = core.MathUtils.clamp(percent, 0, 1);
                var curves = this.curves;
                var i = frameIndex * CurveTimeline.BEZIER_SIZE;
                var type = curves[i];
                if (type == CurveTimeline.LINEAR)
                    return percent;
                if (type == CurveTimeline.STEPPED)
                    return 0;
                i++;
                var x = 0;
                for (var start = i, n = i + CurveTimeline.BEZIER_SIZE - 1; i < n; i += 2) {
                    x = curves[i];
                    if (x >= percent) {
                        var prevX = void 0, prevY = void 0;
                        if (i == start) {
                            prevX = 0;
                            prevY = 0;
                        }
                        else {
                            prevX = curves[i - 2];
                            prevY = curves[i - 1];
                        }
                        return prevY + (curves[i + 1] - prevY) * (percent - prevX) / (x - prevX);
                    }
                }
                var y = curves[i - 1];
                return y + (1 - y) * (percent - x) / (1 - x);
            };
            CurveTimeline.LINEAR = 0;
            CurveTimeline.STEPPED = 1;
            CurveTimeline.BEZIER = 2;
            CurveTimeline.BEZIER_SIZE = 10 * 2 - 1;
            return CurveTimeline;
        }());
        core.CurveTimeline = CurveTimeline;
        var RotateTimeline = (function (_super) {
            __extends(RotateTimeline, _super);
            function RotateTimeline(frameCount) {
                var _this = _super.call(this, frameCount) || this;
                _this.frames = core.Utils.newFloatArray(frameCount << 1);
                return _this;
            }
            RotateTimeline.prototype.getPropertyId = function () {
                return (TimelineType.rotate << 24) + this.boneIndex;
            };
            RotateTimeline.prototype.setFrame = function (frameIndex, time, degrees) {
                frameIndex <<= 1;
                this.frames[frameIndex] = time;
                this.frames[frameIndex + RotateTimeline.ROTATION] = degrees;
            };
            RotateTimeline.prototype.apply = function (skeleton, lastTime, time, events, alpha, blend, direction) {
                var frames = this.frames;
                var bone = skeleton.bones[this.boneIndex];
                if (!bone.active)
                    return;
                if (time < frames[0]) {
                    switch (blend) {
                        case MixBlend.setup:
                            bone.rotation = bone.data.rotation;
                            return;
                        case MixBlend.first:
                            var r_1 = bone.data.rotation - bone.rotation;
                            bone.rotation += (r_1 - (16384 - ((16384.499999999996 - r_1 / 360) | 0)) * 360) * alpha;
                    }
                    return;
                }
                if (time >= frames[frames.length - RotateTimeline.ENTRIES]) {
                    var r_2 = frames[frames.length + RotateTimeline.PREV_ROTATION];
                    switch (blend) {
                        case MixBlend.setup:
                            bone.rotation = bone.data.rotation + r_2 * alpha;
                            break;
                        case MixBlend.first:
                        case MixBlend.replace:
                            r_2 += bone.data.rotation - bone.rotation;
                            r_2 -= (16384 - ((16384.499999999996 - r_2 / 360) | 0)) * 360;
                        case MixBlend.add:
                            bone.rotation += r_2 * alpha;
                    }
                    return;
                }
                var frame = Animation.binarySearch(frames, time, RotateTimeline.ENTRIES);
                var prevRotation = frames[frame + RotateTimeline.PREV_ROTATION];
                var frameTime = frames[frame];
                var percent = this.getCurvePercent((frame >> 1) - 1, 1 - (time - frameTime) / (frames[frame + RotateTimeline.PREV_TIME] - frameTime));
                var r = frames[frame + RotateTimeline.ROTATION] - prevRotation;
                r = prevRotation + (r - (16384 - ((16384.499999999996 - r / 360) | 0)) * 360) * percent;
                switch (blend) {
                    case MixBlend.setup:
                        bone.rotation = bone.data.rotation + (r - (16384 - ((16384.499999999996 - r / 360) | 0)) * 360) * alpha;
                        break;
                    case MixBlend.first:
                    case MixBlend.replace:
                        r += bone.data.rotation - bone.rotation;
                    case MixBlend.add:
                        bone.rotation += (r - (16384 - ((16384.499999999996 - r / 360) | 0)) * 360) * alpha;
                }
            };
            RotateTimeline.ENTRIES = 2;
            RotateTimeline.PREV_TIME = -2;
            RotateTimeline.PREV_ROTATION = -1;
            RotateTimeline.ROTATION = 1;
            return RotateTimeline;
        }(CurveTimeline));
        core.RotateTimeline = RotateTimeline;
        var TranslateTimeline = (function (_super) {
            __extends(TranslateTimeline, _super);
            function TranslateTimeline(frameCount) {
                var _this = _super.call(this, frameCount) || this;
                _this.frames = core.Utils.newFloatArray(frameCount * TranslateTimeline.ENTRIES);
                return _this;
            }
            TranslateTimeline.prototype.getPropertyId = function () {
                return (TimelineType.translate << 24) + this.boneIndex;
            };
            TranslateTimeline.prototype.setFrame = function (frameIndex, time, x, y) {
                frameIndex *= TranslateTimeline.ENTRIES;
                this.frames[frameIndex] = time;
                this.frames[frameIndex + TranslateTimeline.X] = x;
                this.frames[frameIndex + TranslateTimeline.Y] = y;
            };
            TranslateTimeline.prototype.apply = function (skeleton, lastTime, time, events, alpha, blend, direction) {
                var frames = this.frames;
                var bone = skeleton.bones[this.boneIndex];
                if (!bone.active)
                    return;
                if (time < frames[0]) {
                    switch (blend) {
                        case MixBlend.setup:
                            bone.x = bone.data.x;
                            bone.y = bone.data.y;
                            return;
                        case MixBlend.first:
                            bone.x += (bone.data.x - bone.x) * alpha;
                            bone.y += (bone.data.y - bone.y) * alpha;
                    }
                    return;
                }
                var x = 0, y = 0;
                if (time >= frames[frames.length - TranslateTimeline.ENTRIES]) {
                    x = frames[frames.length + TranslateTimeline.PREV_X];
                    y = frames[frames.length + TranslateTimeline.PREV_Y];
                }
                else {
                    var frame = Animation.binarySearch(frames, time, TranslateTimeline.ENTRIES);
                    x = frames[frame + TranslateTimeline.PREV_X];
                    y = frames[frame + TranslateTimeline.PREV_Y];
                    var frameTime = frames[frame];
                    var percent = this.getCurvePercent(frame / TranslateTimeline.ENTRIES - 1, 1 - (time - frameTime) / (frames[frame + TranslateTimeline.PREV_TIME] - frameTime));
                    x += (frames[frame + TranslateTimeline.X] - x) * percent;
                    y += (frames[frame + TranslateTimeline.Y] - y) * percent;
                }
                switch (blend) {
                    case MixBlend.setup:
                        bone.x = bone.data.x + x * alpha;
                        bone.y = bone.data.y + y * alpha;
                        break;
                    case MixBlend.first:
                    case MixBlend.replace:
                        bone.x += (bone.data.x + x - bone.x) * alpha;
                        bone.y += (bone.data.y + y - bone.y) * alpha;
                        break;
                    case MixBlend.add:
                        bone.x += x * alpha;
                        bone.y += y * alpha;
                }
            };
            TranslateTimeline.ENTRIES = 3;
            TranslateTimeline.PREV_TIME = -3;
            TranslateTimeline.PREV_X = -2;
            TranslateTimeline.PREV_Y = -1;
            TranslateTimeline.X = 1;
            TranslateTimeline.Y = 2;
            return TranslateTimeline;
        }(CurveTimeline));
        core.TranslateTimeline = TranslateTimeline;
        var ScaleTimeline = (function (_super) {
            __extends(ScaleTimeline, _super);
            function ScaleTimeline(frameCount) {
                return _super.call(this, frameCount) || this;
            }
            ScaleTimeline.prototype.getPropertyId = function () {
                return (TimelineType.scale << 24) + this.boneIndex;
            };
            ScaleTimeline.prototype.apply = function (skeleton, lastTime, time, events, alpha, blend, direction) {
                var frames = this.frames;
                var bone = skeleton.bones[this.boneIndex];
                if (!bone.active)
                    return;
                if (time < frames[0]) {
                    switch (blend) {
                        case MixBlend.setup:
                            bone.scaleX = bone.data.scaleX;
                            bone.scaleY = bone.data.scaleY;
                            return;
                        case MixBlend.first:
                            bone.scaleX += (bone.data.scaleX - bone.scaleX) * alpha;
                            bone.scaleY += (bone.data.scaleY - bone.scaleY) * alpha;
                    }
                    return;
                }
                var x = 0, y = 0;
                if (time >= frames[frames.length - ScaleTimeline.ENTRIES]) {
                    x = frames[frames.length + ScaleTimeline.PREV_X] * bone.data.scaleX;
                    y = frames[frames.length + ScaleTimeline.PREV_Y] * bone.data.scaleY;
                }
                else {
                    var frame = Animation.binarySearch(frames, time, ScaleTimeline.ENTRIES);
                    x = frames[frame + ScaleTimeline.PREV_X];
                    y = frames[frame + ScaleTimeline.PREV_Y];
                    var frameTime = frames[frame];
                    var percent = this.getCurvePercent(frame / ScaleTimeline.ENTRIES - 1, 1 - (time - frameTime) / (frames[frame + ScaleTimeline.PREV_TIME] - frameTime));
                    x = (x + (frames[frame + ScaleTimeline.X] - x) * percent) * bone.data.scaleX;
                    y = (y + (frames[frame + ScaleTimeline.Y] - y) * percent) * bone.data.scaleY;
                }
                if (alpha == 1) {
                    if (blend == MixBlend.add) {
                        bone.scaleX += x - bone.data.scaleX;
                        bone.scaleY += y - bone.data.scaleY;
                    }
                    else {
                        bone.scaleX = x;
                        bone.scaleY = y;
                    }
                }
                else {
                    var bx = 0, by = 0;
                    if (direction == MixDirection.mixOut) {
                        switch (blend) {
                            case MixBlend.setup:
                                bx = bone.data.scaleX;
                                by = bone.data.scaleY;
                                bone.scaleX = bx + (Math.abs(x) * core.MathUtils.signum(bx) - bx) * alpha;
                                bone.scaleY = by + (Math.abs(y) * core.MathUtils.signum(by) - by) * alpha;
                                break;
                            case MixBlend.first:
                            case MixBlend.replace:
                                bx = bone.scaleX;
                                by = bone.scaleY;
                                bone.scaleX = bx + (Math.abs(x) * core.MathUtils.signum(bx) - bx) * alpha;
                                bone.scaleY = by + (Math.abs(y) * core.MathUtils.signum(by) - by) * alpha;
                                break;
                            case MixBlend.add:
                                bx = bone.scaleX;
                                by = bone.scaleY;
                                bone.scaleX = bx + (Math.abs(x) * core.MathUtils.signum(bx) - bone.data.scaleX) * alpha;
                                bone.scaleY = by + (Math.abs(y) * core.MathUtils.signum(by) - bone.data.scaleY) * alpha;
                        }
                    }
                    else {
                        switch (blend) {
                            case MixBlend.setup:
                                bx = Math.abs(bone.data.scaleX) * core.MathUtils.signum(x);
                                by = Math.abs(bone.data.scaleY) * core.MathUtils.signum(y);
                                bone.scaleX = bx + (x - bx) * alpha;
                                bone.scaleY = by + (y - by) * alpha;
                                break;
                            case MixBlend.first:
                            case MixBlend.replace:
                                bx = Math.abs(bone.scaleX) * core.MathUtils.signum(x);
                                by = Math.abs(bone.scaleY) * core.MathUtils.signum(y);
                                bone.scaleX = bx + (x - bx) * alpha;
                                bone.scaleY = by + (y - by) * alpha;
                                break;
                            case MixBlend.add:
                                bx = core.MathUtils.signum(x);
                                by = core.MathUtils.signum(y);
                                bone.scaleX = Math.abs(bone.scaleX) * bx + (x - Math.abs(bone.data.scaleX) * bx) * alpha;
                                bone.scaleY = Math.abs(bone.scaleY) * by + (y - Math.abs(bone.data.scaleY) * by) * alpha;
                        }
                    }
                }
            };
            return ScaleTimeline;
        }(TranslateTimeline));
        core.ScaleTimeline = ScaleTimeline;
        var ShearTimeline = (function (_super) {
            __extends(ShearTimeline, _super);
            function ShearTimeline(frameCount) {
                return _super.call(this, frameCount) || this;
            }
            ShearTimeline.prototype.getPropertyId = function () {
                return (TimelineType.shear << 24) + this.boneIndex;
            };
            ShearTimeline.prototype.apply = function (skeleton, lastTime, time, events, alpha, blend, direction) {
                var frames = this.frames;
                var bone = skeleton.bones[this.boneIndex];
                if (!bone.active)
                    return;
                if (time < frames[0]) {
                    switch (blend) {
                        case MixBlend.setup:
                            bone.shearX = bone.data.shearX;
                            bone.shearY = bone.data.shearY;
                            return;
                        case MixBlend.first:
                            bone.shearX += (bone.data.shearX - bone.shearX) * alpha;
                            bone.shearY += (bone.data.shearY - bone.shearY) * alpha;
                    }
                    return;
                }
                var x = 0, y = 0;
                if (time >= frames[frames.length - ShearTimeline.ENTRIES]) {
                    x = frames[frames.length + ShearTimeline.PREV_X];
                    y = frames[frames.length + ShearTimeline.PREV_Y];
                }
                else {
                    var frame = Animation.binarySearch(frames, time, ShearTimeline.ENTRIES);
                    x = frames[frame + ShearTimeline.PREV_X];
                    y = frames[frame + ShearTimeline.PREV_Y];
                    var frameTime = frames[frame];
                    var percent = this.getCurvePercent(frame / ShearTimeline.ENTRIES - 1, 1 - (time - frameTime) / (frames[frame + ShearTimeline.PREV_TIME] - frameTime));
                    x = x + (frames[frame + ShearTimeline.X] - x) * percent;
                    y = y + (frames[frame + ShearTimeline.Y] - y) * percent;
                }
                switch (blend) {
                    case MixBlend.setup:
                        bone.shearX = bone.data.shearX + x * alpha;
                        bone.shearY = bone.data.shearY + y * alpha;
                        break;
                    case MixBlend.first:
                    case MixBlend.replace:
                        bone.shearX += (bone.data.shearX + x - bone.shearX) * alpha;
                        bone.shearY += (bone.data.shearY + y - bone.shearY) * alpha;
                        break;
                    case MixBlend.add:
                        bone.shearX += x * alpha;
                        bone.shearY += y * alpha;
                }
            };
            return ShearTimeline;
        }(TranslateTimeline));
        core.ShearTimeline = ShearTimeline;
        var ColorTimeline = (function (_super) {
            __extends(ColorTimeline, _super);
            function ColorTimeline(frameCount) {
                var _this = _super.call(this, frameCount) || this;
                _this.frames = core.Utils.newFloatArray(frameCount * ColorTimeline.ENTRIES);
                return _this;
            }
            ColorTimeline.prototype.getPropertyId = function () {
                return (TimelineType.color << 24) + this.slotIndex;
            };
            ColorTimeline.prototype.setFrame = function (frameIndex, time, r, g, b, a) {
                frameIndex *= ColorTimeline.ENTRIES;
                this.frames[frameIndex] = time;
                this.frames[frameIndex + ColorTimeline.R] = r;
                this.frames[frameIndex + ColorTimeline.G] = g;
                this.frames[frameIndex + ColorTimeline.B] = b;
                this.frames[frameIndex + ColorTimeline.A] = a;
            };
            ColorTimeline.prototype.apply = function (skeleton, lastTime, time, events, alpha, blend, direction) {
                var slot = skeleton.slots[this.slotIndex];
                if (!slot.bone.active)
                    return;
                var frames = this.frames;
                if (time < frames[0]) {
                    switch (blend) {
                        case MixBlend.setup:
                            slot.color.setFromColor(slot.data.color);
                            return;
                        case MixBlend.first:
                            var color = slot.color, setup = slot.data.color;
                            color.add((setup.r - color.r) * alpha, (setup.g - color.g) * alpha, (setup.b - color.b) * alpha, (setup.a - color.a) * alpha);
                    }
                    return;
                }
                var r = 0, g = 0, b = 0, a = 0;
                if (time >= frames[frames.length - ColorTimeline.ENTRIES]) {
                    var i = frames.length;
                    r = frames[i + ColorTimeline.PREV_R];
                    g = frames[i + ColorTimeline.PREV_G];
                    b = frames[i + ColorTimeline.PREV_B];
                    a = frames[i + ColorTimeline.PREV_A];
                }
                else {
                    var frame = Animation.binarySearch(frames, time, ColorTimeline.ENTRIES);
                    r = frames[frame + ColorTimeline.PREV_R];
                    g = frames[frame + ColorTimeline.PREV_G];
                    b = frames[frame + ColorTimeline.PREV_B];
                    a = frames[frame + ColorTimeline.PREV_A];
                    var frameTime = frames[frame];
                    var percent = this.getCurvePercent(frame / ColorTimeline.ENTRIES - 1, 1 - (time - frameTime) / (frames[frame + ColorTimeline.PREV_TIME] - frameTime));
                    r += (frames[frame + ColorTimeline.R] - r) * percent;
                    g += (frames[frame + ColorTimeline.G] - g) * percent;
                    b += (frames[frame + ColorTimeline.B] - b) * percent;
                    a += (frames[frame + ColorTimeline.A] - a) * percent;
                }
                if (alpha == 1)
                    slot.color.set(r, g, b, a);
                else {
                    var color = slot.color;
                    if (blend == MixBlend.setup)
                        color.setFromColor(slot.data.color);
                    color.add((r - color.r) * alpha, (g - color.g) * alpha, (b - color.b) * alpha, (a - color.a) * alpha);
                }
            };
            ColorTimeline.ENTRIES = 5;
            ColorTimeline.PREV_TIME = -5;
            ColorTimeline.PREV_R = -4;
            ColorTimeline.PREV_G = -3;
            ColorTimeline.PREV_B = -2;
            ColorTimeline.PREV_A = -1;
            ColorTimeline.R = 1;
            ColorTimeline.G = 2;
            ColorTimeline.B = 3;
            ColorTimeline.A = 4;
            return ColorTimeline;
        }(CurveTimeline));
        core.ColorTimeline = ColorTimeline;
        var TwoColorTimeline = (function (_super) {
            __extends(TwoColorTimeline, _super);
            function TwoColorTimeline(frameCount) {
                var _this = _super.call(this, frameCount) || this;
                _this.frames = core.Utils.newFloatArray(frameCount * TwoColorTimeline.ENTRIES);
                return _this;
            }
            TwoColorTimeline.prototype.getPropertyId = function () {
                return (TimelineType.twoColor << 24) + this.slotIndex;
            };
            TwoColorTimeline.prototype.setFrame = function (frameIndex, time, r, g, b, a, r2, g2, b2) {
                frameIndex *= TwoColorTimeline.ENTRIES;
                this.frames[frameIndex] = time;
                this.frames[frameIndex + TwoColorTimeline.R] = r;
                this.frames[frameIndex + TwoColorTimeline.G] = g;
                this.frames[frameIndex + TwoColorTimeline.B] = b;
                this.frames[frameIndex + TwoColorTimeline.A] = a;
                this.frames[frameIndex + TwoColorTimeline.R2] = r2;
                this.frames[frameIndex + TwoColorTimeline.G2] = g2;
                this.frames[frameIndex + TwoColorTimeline.B2] = b2;
            };
            TwoColorTimeline.prototype.apply = function (skeleton, lastTime, time, events, alpha, blend, direction) {
                var slot = skeleton.slots[this.slotIndex];
                if (!slot.bone.active)
                    return;
                var frames = this.frames;
                if (time < frames[0]) {
                    switch (blend) {
                        case MixBlend.setup:
                            slot.color.setFromColor(slot.data.color);
                            slot.darkColor.setFromColor(slot.data.darkColor);
                            return;
                        case MixBlend.first:
                            var light = slot.color, dark = slot.darkColor, setupLight = slot.data.color, setupDark = slot.data.darkColor;
                            light.add((setupLight.r - light.r) * alpha, (setupLight.g - light.g) * alpha, (setupLight.b - light.b) * alpha, (setupLight.a - light.a) * alpha);
                            dark.add((setupDark.r - dark.r) * alpha, (setupDark.g - dark.g) * alpha, (setupDark.b - dark.b) * alpha, 0);
                    }
                    return;
                }
                var r = 0, g = 0, b = 0, a = 0, r2 = 0, g2 = 0, b2 = 0;
                if (time >= frames[frames.length - TwoColorTimeline.ENTRIES]) {
                    var i = frames.length;
                    r = frames[i + TwoColorTimeline.PREV_R];
                    g = frames[i + TwoColorTimeline.PREV_G];
                    b = frames[i + TwoColorTimeline.PREV_B];
                    a = frames[i + TwoColorTimeline.PREV_A];
                    r2 = frames[i + TwoColorTimeline.PREV_R2];
                    g2 = frames[i + TwoColorTimeline.PREV_G2];
                    b2 = frames[i + TwoColorTimeline.PREV_B2];
                }
                else {
                    var frame = Animation.binarySearch(frames, time, TwoColorTimeline.ENTRIES);
                    r = frames[frame + TwoColorTimeline.PREV_R];
                    g = frames[frame + TwoColorTimeline.PREV_G];
                    b = frames[frame + TwoColorTimeline.PREV_B];
                    a = frames[frame + TwoColorTimeline.PREV_A];
                    r2 = frames[frame + TwoColorTimeline.PREV_R2];
                    g2 = frames[frame + TwoColorTimeline.PREV_G2];
                    b2 = frames[frame + TwoColorTimeline.PREV_B2];
                    var frameTime = frames[frame];
                    var percent = this.getCurvePercent(frame / TwoColorTimeline.ENTRIES - 1, 1 - (time - frameTime) / (frames[frame + TwoColorTimeline.PREV_TIME] - frameTime));
                    r += (frames[frame + TwoColorTimeline.R] - r) * percent;
                    g += (frames[frame + TwoColorTimeline.G] - g) * percent;
                    b += (frames[frame + TwoColorTimeline.B] - b) * percent;
                    a += (frames[frame + TwoColorTimeline.A] - a) * percent;
                    r2 += (frames[frame + TwoColorTimeline.R2] - r2) * percent;
                    g2 += (frames[frame + TwoColorTimeline.G2] - g2) * percent;
                    b2 += (frames[frame + TwoColorTimeline.B2] - b2) * percent;
                }
                if (alpha == 1) {
                    slot.color.set(r, g, b, a);
                    slot.darkColor.set(r2, g2, b2, 1);
                }
                else {
                    var light = slot.color, dark = slot.darkColor;
                    if (blend == MixBlend.setup) {
                        light.setFromColor(slot.data.color);
                        dark.setFromColor(slot.data.darkColor);
                    }
                    light.add((r - light.r) * alpha, (g - light.g) * alpha, (b - light.b) * alpha, (a - light.a) * alpha);
                    dark.add((r2 - dark.r) * alpha, (g2 - dark.g) * alpha, (b2 - dark.b) * alpha, 0);
                }
            };
            TwoColorTimeline.ENTRIES = 8;
            TwoColorTimeline.PREV_TIME = -8;
            TwoColorTimeline.PREV_R = -7;
            TwoColorTimeline.PREV_G = -6;
            TwoColorTimeline.PREV_B = -5;
            TwoColorTimeline.PREV_A = -4;
            TwoColorTimeline.PREV_R2 = -3;
            TwoColorTimeline.PREV_G2 = -2;
            TwoColorTimeline.PREV_B2 = -1;
            TwoColorTimeline.R = 1;
            TwoColorTimeline.G = 2;
            TwoColorTimeline.B = 3;
            TwoColorTimeline.A = 4;
            TwoColorTimeline.R2 = 5;
            TwoColorTimeline.G2 = 6;
            TwoColorTimeline.B2 = 7;
            return TwoColorTimeline;
        }(CurveTimeline));
        core.TwoColorTimeline = TwoColorTimeline;
        var AttachmentTimeline = (function () {
            function AttachmentTimeline(frameCount) {
                this.frames = core.Utils.newFloatArray(frameCount);
                this.attachmentNames = new Array(frameCount);
            }
            AttachmentTimeline.prototype.getPropertyId = function () {
                return (TimelineType.attachment << 24) + this.slotIndex;
            };
            AttachmentTimeline.prototype.getFrameCount = function () {
                return this.frames.length;
            };
            AttachmentTimeline.prototype.setFrame = function (frameIndex, time, attachmentName) {
                this.frames[frameIndex] = time;
                this.attachmentNames[frameIndex] = attachmentName;
            };
            AttachmentTimeline.prototype.apply = function (skeleton, lastTime, time, events, alpha, blend, direction) {
                var slot = skeleton.slots[this.slotIndex];
                if (!slot.bone.active)
                    return;
                if (direction == MixDirection.mixOut && blend == MixBlend.setup) {
                    var attachmentName_1 = slot.data.attachmentName;
                    slot.setAttachment(attachmentName_1 == null ? null : skeleton.getAttachment(this.slotIndex, attachmentName_1));
                    return;
                }
                var frames = this.frames;
                if (time < frames[0]) {
                    if (blend == MixBlend.setup || blend == MixBlend.first) {
                        var attachmentName_2 = slot.data.attachmentName;
                        slot.setAttachment(attachmentName_2 == null ? null : skeleton.getAttachment(this.slotIndex, attachmentName_2));
                    }
                    return;
                }
                var frameIndex = 0;
                if (time >= frames[frames.length - 1])
                    frameIndex = frames.length - 1;
                else
                    frameIndex = Animation.binarySearch(frames, time, 1) - 1;
                var attachmentName = this.attachmentNames[frameIndex];
                skeleton.slots[this.slotIndex]
                    .setAttachment(attachmentName == null ? null : skeleton.getAttachment(this.slotIndex, attachmentName));
            };
            return AttachmentTimeline;
        }());
        core.AttachmentTimeline = AttachmentTimeline;
        var zeros = null;
        var DeformTimeline = (function (_super) {
            __extends(DeformTimeline, _super);
            function DeformTimeline(frameCount) {
                var _this = _super.call(this, frameCount) || this;
                _this.frames = core.Utils.newFloatArray(frameCount);
                _this.frameVertices = new Array(frameCount);
                if (zeros == null)
                    zeros = core.Utils.newFloatArray(64);
                return _this;
            }
            DeformTimeline.prototype.getPropertyId = function () {
                return (TimelineType.deform << 27) + +this.attachment.id + this.slotIndex;
            };
            DeformTimeline.prototype.setFrame = function (frameIndex, time, vertices) {
                this.frames[frameIndex] = time;
                this.frameVertices[frameIndex] = vertices;
            };
            DeformTimeline.prototype.apply = function (skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
                var slot = skeleton.slots[this.slotIndex];
                if (!slot.bone.active)
                    return;
                var slotAttachment = slot.getAttachment();
                if (!(slotAttachment instanceof core.VertexAttachment) || !(slotAttachment.deformAttachment == this.attachment))
                    return;
                var deformArray = slot.deform;
                if (deformArray.length == 0)
                    blend = MixBlend.setup;
                var frameVertices = this.frameVertices;
                var vertexCount = frameVertices[0].length;
                var frames = this.frames;
                if (time < frames[0]) {
                    var vertexAttachment = slotAttachment;
                    switch (blend) {
                        case MixBlend.setup:
                            deformArray.length = 0;
                            return;
                        case MixBlend.first:
                            if (alpha == 1) {
                                deformArray.length = 0;
                                break;
                            }
                            var deform_1 = core.Utils.setArraySize(deformArray, vertexCount);
                            if (vertexAttachment.bones == null) {
                                var setupVertices = vertexAttachment.vertices;
                                for (var i = 0; i < vertexCount; i++)
                                    deform_1[i] += (setupVertices[i] - deform_1[i]) * alpha;
                            }
                            else {
                                alpha = 1 - alpha;
                                for (var i = 0; i < vertexCount; i++)
                                    deform_1[i] *= alpha;
                            }
                    }
                    return;
                }
                var deform = core.Utils.setArraySize(deformArray, vertexCount);
                if (time >= frames[frames.length - 1]) {
                    var lastVertices = frameVertices[frames.length - 1];
                    if (alpha == 1) {
                        if (blend == MixBlend.add) {
                            var vertexAttachment = slotAttachment;
                            if (vertexAttachment.bones == null) {
                                var setupVertices = vertexAttachment.vertices;
                                for (var i_1 = 0; i_1 < vertexCount; i_1++) {
                                    deform[i_1] += lastVertices[i_1] - setupVertices[i_1];
                                }
                            }
                            else {
                                for (var i_2 = 0; i_2 < vertexCount; i_2++)
                                    deform[i_2] += lastVertices[i_2];
                            }
                        }
                        else {
                            core.Utils.arrayCopy(lastVertices, 0, deform, 0, vertexCount);
                        }
                    }
                    else {
                        switch (blend) {
                            case MixBlend.setup: {
                                var vertexAttachment_1 = slotAttachment;
                                if (vertexAttachment_1.bones == null) {
                                    var setupVertices = vertexAttachment_1.vertices;
                                    for (var i_3 = 0; i_3 < vertexCount; i_3++) {
                                        var setup = setupVertices[i_3];
                                        deform[i_3] = setup + (lastVertices[i_3] - setup) * alpha;
                                    }
                                }
                                else {
                                    for (var i_4 = 0; i_4 < vertexCount; i_4++)
                                        deform[i_4] = lastVertices[i_4] * alpha;
                                }
                                break;
                            }
                            case MixBlend.first:
                            case MixBlend.replace:
                                for (var i_5 = 0; i_5 < vertexCount; i_5++)
                                    deform[i_5] += (lastVertices[i_5] - deform[i_5]) * alpha;
                            case MixBlend.add:
                                var vertexAttachment = slotAttachment;
                                if (vertexAttachment.bones == null) {
                                    var setupVertices = vertexAttachment.vertices;
                                    for (var i_6 = 0; i_6 < vertexCount; i_6++) {
                                        deform[i_6] += (lastVertices[i_6] - setupVertices[i_6]) * alpha;
                                    }
                                }
                                else {
                                    for (var i_7 = 0; i_7 < vertexCount; i_7++)
                                        deform[i_7] += lastVertices[i_7] * alpha;
                                }
                        }
                    }
                    return;
                }
                var frame = Animation.binarySearch(frames, time);
                var prevVertices = frameVertices[frame - 1];
                var nextVertices = frameVertices[frame];
                var frameTime = frames[frame];
                var percent = this.getCurvePercent(frame - 1, 1 - (time - frameTime) / (frames[frame - 1] - frameTime));
                if (alpha == 1) {
                    if (blend == MixBlend.add) {
                        var vertexAttachment = slotAttachment;
                        if (vertexAttachment.bones == null) {
                            var setupVertices = vertexAttachment.vertices;
                            for (var i_8 = 0; i_8 < vertexCount; i_8++) {
                                var prev = prevVertices[i_8];
                                deform[i_8] += prev + (nextVertices[i_8] - prev) * percent - setupVertices[i_8];
                            }
                        }
                        else {
                            for (var i_9 = 0; i_9 < vertexCount; i_9++) {
                                var prev = prevVertices[i_9];
                                deform[i_9] += prev + (nextVertices[i_9] - prev) * percent;
                            }
                        }
                    }
                    else {
                        for (var i_10 = 0; i_10 < vertexCount; i_10++) {
                            var prev = prevVertices[i_10];
                            deform[i_10] = prev + (nextVertices[i_10] - prev) * percent;
                        }
                    }
                }
                else {
                    switch (blend) {
                        case MixBlend.setup: {
                            var vertexAttachment_2 = slotAttachment;
                            if (vertexAttachment_2.bones == null) {
                                var setupVertices = vertexAttachment_2.vertices;
                                for (var i_11 = 0; i_11 < vertexCount; i_11++) {
                                    var prev = prevVertices[i_11], setup = setupVertices[i_11];
                                    deform[i_11] = setup + (prev + (nextVertices[i_11] - prev) * percent - setup) * alpha;
                                }
                            }
                            else {
                                for (var i_12 = 0; i_12 < vertexCount; i_12++) {
                                    var prev = prevVertices[i_12];
                                    deform[i_12] = (prev + (nextVertices[i_12] - prev) * percent) * alpha;
                                }
                            }
                            break;
                        }
                        case MixBlend.first:
                        case MixBlend.replace:
                            for (var i_13 = 0; i_13 < vertexCount; i_13++) {
                                var prev = prevVertices[i_13];
                                deform[i_13] += (prev + (nextVertices[i_13] - prev) * percent - deform[i_13]) * alpha;
                            }
                            break;
                        case MixBlend.add:
                            var vertexAttachment = slotAttachment;
                            if (vertexAttachment.bones == null) {
                                var setupVertices = vertexAttachment.vertices;
                                for (var i_14 = 0; i_14 < vertexCount; i_14++) {
                                    var prev = prevVertices[i_14];
                                    deform[i_14] += (prev + (nextVertices[i_14] - prev) * percent - setupVertices[i_14]) * alpha;
                                }
                            }
                            else {
                                for (var i_15 = 0; i_15 < vertexCount; i_15++) {
                                    var prev = prevVertices[i_15];
                                    deform[i_15] += (prev + (nextVertices[i_15] - prev) * percent) * alpha;
                                }
                            }
                    }
                }
            };
            return DeformTimeline;
        }(CurveTimeline));
        core.DeformTimeline = DeformTimeline;
        var EventTimeline = (function () {
            function EventTimeline(frameCount) {
                this.frames = core.Utils.newFloatArray(frameCount);
                this.events = new Array(frameCount);
            }
            EventTimeline.prototype.getPropertyId = function () {
                return TimelineType.event << 24;
            };
            EventTimeline.prototype.getFrameCount = function () {
                return this.frames.length;
            };
            EventTimeline.prototype.setFrame = function (frameIndex, event) {
                this.frames[frameIndex] = event.time;
                this.events[frameIndex] = event;
            };
            EventTimeline.prototype.apply = function (skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
                if (firedEvents == null)
                    return;
                var frames = this.frames;
                var frameCount = this.frames.length;
                if (lastTime > time) {
                    this.apply(skeleton, lastTime, Number.MAX_VALUE, firedEvents, alpha, blend, direction);
                    lastTime = -1;
                }
                else if (lastTime >= frames[frameCount - 1])
                    return;
                if (time < frames[0])
                    return;
                var frame = 0;
                if (lastTime < frames[0])
                    frame = 0;
                else {
                    frame = Animation.binarySearch(frames, lastTime);
                    var frameTime = frames[frame];
                    while (frame > 0) {
                        if (frames[frame - 1] != frameTime)
                            break;
                        frame--;
                    }
                }
                for (; frame < frameCount && time >= frames[frame]; frame++)
                    firedEvents.push(this.events[frame]);
            };
            return EventTimeline;
        }());
        core.EventTimeline = EventTimeline;
        var DrawOrderTimeline = (function () {
            function DrawOrderTimeline(frameCount) {
                this.frames = core.Utils.newFloatArray(frameCount);
                this.drawOrders = new Array(frameCount);
            }
            DrawOrderTimeline.prototype.getPropertyId = function () {
                return TimelineType.drawOrder << 24;
            };
            DrawOrderTimeline.prototype.getFrameCount = function () {
                return this.frames.length;
            };
            DrawOrderTimeline.prototype.setFrame = function (frameIndex, time, drawOrder) {
                this.frames[frameIndex] = time;
                this.drawOrders[frameIndex] = drawOrder;
            };
            DrawOrderTimeline.prototype.apply = function (skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
                var drawOrder = skeleton.drawOrder;
                var slots = skeleton.slots;
                if (direction == MixDirection.mixOut && blend == MixBlend.setup) {
                    core.Utils.arrayCopy(skeleton.slots, 0, skeleton.drawOrder, 0, skeleton.slots.length);
                    return;
                }
                var frames = this.frames;
                if (time < frames[0]) {
                    if (blend == MixBlend.setup || blend == MixBlend.first)
                        core.Utils.arrayCopy(skeleton.slots, 0, skeleton.drawOrder, 0, skeleton.slots.length);
                    return;
                }
                var frame = 0;
                if (time >= frames[frames.length - 1])
                    frame = frames.length - 1;
                else
                    frame = Animation.binarySearch(frames, time) - 1;
                var drawOrderToSetupIndex = this.drawOrders[frame];
                if (drawOrderToSetupIndex == null)
                    core.Utils.arrayCopy(slots, 0, drawOrder, 0, slots.length);
                else {
                    for (var i = 0, n = drawOrderToSetupIndex.length; i < n; i++)
                        drawOrder[i] = slots[drawOrderToSetupIndex[i]];
                }
            };
            return DrawOrderTimeline;
        }());
        core.DrawOrderTimeline = DrawOrderTimeline;
        var IkConstraintTimeline = (function (_super) {
            __extends(IkConstraintTimeline, _super);
            function IkConstraintTimeline(frameCount) {
                var _this = _super.call(this, frameCount) || this;
                _this.frames = core.Utils.newFloatArray(frameCount * IkConstraintTimeline.ENTRIES);
                return _this;
            }
            IkConstraintTimeline.prototype.getPropertyId = function () {
                return (TimelineType.ikConstraint << 24) + this.ikConstraintIndex;
            };
            IkConstraintTimeline.prototype.setFrame = function (frameIndex, time, mix, softness, bendDirection, compress, stretch) {
                frameIndex *= IkConstraintTimeline.ENTRIES;
                this.frames[frameIndex] = time;
                this.frames[frameIndex + IkConstraintTimeline.MIX] = mix;
                this.frames[frameIndex + IkConstraintTimeline.SOFTNESS] = softness;
                this.frames[frameIndex + IkConstraintTimeline.BEND_DIRECTION] = bendDirection;
                this.frames[frameIndex + IkConstraintTimeline.COMPRESS] = compress ? 1 : 0;
                this.frames[frameIndex + IkConstraintTimeline.STRETCH] = stretch ? 1 : 0;
            };
            IkConstraintTimeline.prototype.apply = function (skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
                var frames = this.frames;
                var constraint = skeleton.ikConstraints[this.ikConstraintIndex];
                if (!constraint.active)
                    return;
                if (time < frames[0]) {
                    switch (blend) {
                        case MixBlend.setup:
                            constraint.mix = constraint.data.mix;
                            constraint.softness = constraint.data.softness;
                            constraint.bendDirection = constraint.data.bendDirection;
                            constraint.compress = constraint.data.compress;
                            constraint.stretch = constraint.data.stretch;
                            return;
                        case MixBlend.first:
                            constraint.mix += (constraint.data.mix - constraint.mix) * alpha;
                            constraint.softness += (constraint.data.softness - constraint.softness) * alpha;
                            constraint.bendDirection = constraint.data.bendDirection;
                            constraint.compress = constraint.data.compress;
                            constraint.stretch = constraint.data.stretch;
                    }
                    return;
                }
                if (time >= frames[frames.length - IkConstraintTimeline.ENTRIES]) {
                    if (blend == MixBlend.setup) {
                        constraint.mix = constraint.data.mix + (frames[frames.length + IkConstraintTimeline.PREV_MIX] - constraint.data.mix) * alpha;
                        constraint.softness = constraint.data.softness
                            + (frames[frames.length + IkConstraintTimeline.PREV_SOFTNESS] - constraint.data.softness) * alpha;
                        if (direction == MixDirection.mixOut) {
                            constraint.bendDirection = constraint.data.bendDirection;
                            constraint.compress = constraint.data.compress;
                            constraint.stretch = constraint.data.stretch;
                        }
                        else {
                            constraint.bendDirection = frames[frames.length + IkConstraintTimeline.PREV_BEND_DIRECTION];
                            constraint.compress = frames[frames.length + IkConstraintTimeline.PREV_COMPRESS] != 0;
                            constraint.stretch = frames[frames.length + IkConstraintTimeline.PREV_STRETCH] != 0;
                        }
                    }
                    else {
                        constraint.mix += (frames[frames.length + IkConstraintTimeline.PREV_MIX] - constraint.mix) * alpha;
                        constraint.softness += (frames[frames.length + IkConstraintTimeline.PREV_SOFTNESS] - constraint.softness) * alpha;
                        if (direction == MixDirection.mixIn) {
                            constraint.bendDirection = frames[frames.length + IkConstraintTimeline.PREV_BEND_DIRECTION];
                            constraint.compress = frames[frames.length + IkConstraintTimeline.PREV_COMPRESS] != 0;
                            constraint.stretch = frames[frames.length + IkConstraintTimeline.PREV_STRETCH] != 0;
                        }
                    }
                    return;
                }
                var frame = Animation.binarySearch(frames, time, IkConstraintTimeline.ENTRIES);
                var mix = frames[frame + IkConstraintTimeline.PREV_MIX];
                var softness = frames[frame + IkConstraintTimeline.PREV_SOFTNESS];
                var frameTime = frames[frame];
                var percent = this.getCurvePercent(frame / IkConstraintTimeline.ENTRIES - 1, 1 - (time - frameTime) / (frames[frame + IkConstraintTimeline.PREV_TIME] - frameTime));
                if (blend == MixBlend.setup) {
                    constraint.mix = constraint.data.mix + (mix + (frames[frame + IkConstraintTimeline.MIX] - mix) * percent - constraint.data.mix) * alpha;
                    constraint.softness = constraint.data.softness
                        + (softness + (frames[frame + IkConstraintTimeline.SOFTNESS] - softness) * percent - constraint.data.softness) * alpha;
                    if (direction == MixDirection.mixOut) {
                        constraint.bendDirection = constraint.data.bendDirection;
                        constraint.compress = constraint.data.compress;
                        constraint.stretch = constraint.data.stretch;
                    }
                    else {
                        constraint.bendDirection = frames[frame + IkConstraintTimeline.PREV_BEND_DIRECTION];
                        constraint.compress = frames[frame + IkConstraintTimeline.PREV_COMPRESS] != 0;
                        constraint.stretch = frames[frame + IkConstraintTimeline.PREV_STRETCH] != 0;
                    }
                }
                else {
                    constraint.mix += (mix + (frames[frame + IkConstraintTimeline.MIX] - mix) * percent - constraint.mix) * alpha;
                    constraint.softness += (softness + (frames[frame + IkConstraintTimeline.SOFTNESS] - softness) * percent - constraint.softness) * alpha;
                    if (direction == MixDirection.mixIn) {
                        constraint.bendDirection = frames[frame + IkConstraintTimeline.PREV_BEND_DIRECTION];
                        constraint.compress = frames[frame + IkConstraintTimeline.PREV_COMPRESS] != 0;
                        constraint.stretch = frames[frame + IkConstraintTimeline.PREV_STRETCH] != 0;
                    }
                }
            };
            IkConstraintTimeline.ENTRIES = 6;
            IkConstraintTimeline.PREV_TIME = -6;
            IkConstraintTimeline.PREV_MIX = -5;
            IkConstraintTimeline.PREV_SOFTNESS = -4;
            IkConstraintTimeline.PREV_BEND_DIRECTION = -3;
            IkConstraintTimeline.PREV_COMPRESS = -2;
            IkConstraintTimeline.PREV_STRETCH = -1;
            IkConstraintTimeline.MIX = 1;
            IkConstraintTimeline.SOFTNESS = 2;
            IkConstraintTimeline.BEND_DIRECTION = 3;
            IkConstraintTimeline.COMPRESS = 4;
            IkConstraintTimeline.STRETCH = 5;
            return IkConstraintTimeline;
        }(CurveTimeline));
        core.IkConstraintTimeline = IkConstraintTimeline;
        var TransformConstraintTimeline = (function (_super) {
            __extends(TransformConstraintTimeline, _super);
            function TransformConstraintTimeline(frameCount) {
                var _this = _super.call(this, frameCount) || this;
                _this.frames = core.Utils.newFloatArray(frameCount * TransformConstraintTimeline.ENTRIES);
                return _this;
            }
            TransformConstraintTimeline.prototype.getPropertyId = function () {
                return (TimelineType.transformConstraint << 24) + this.transformConstraintIndex;
            };
            TransformConstraintTimeline.prototype.setFrame = function (frameIndex, time, rotateMix, translateMix, scaleMix, shearMix) {
                frameIndex *= TransformConstraintTimeline.ENTRIES;
                this.frames[frameIndex] = time;
                this.frames[frameIndex + TransformConstraintTimeline.ROTATE] = rotateMix;
                this.frames[frameIndex + TransformConstraintTimeline.TRANSLATE] = translateMix;
                this.frames[frameIndex + TransformConstraintTimeline.SCALE] = scaleMix;
                this.frames[frameIndex + TransformConstraintTimeline.SHEAR] = shearMix;
            };
            TransformConstraintTimeline.prototype.apply = function (skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
                var frames = this.frames;
                var constraint = skeleton.transformConstraints[this.transformConstraintIndex];
                if (!constraint.active)
                    return;
                if (time < frames[0]) {
                    var data = constraint.data;
                    switch (blend) {
                        case MixBlend.setup:
                            constraint.rotateMix = data.rotateMix;
                            constraint.translateMix = data.translateMix;
                            constraint.scaleMix = data.scaleMix;
                            constraint.shearMix = data.shearMix;
                            return;
                        case MixBlend.first:
                            constraint.rotateMix += (data.rotateMix - constraint.rotateMix) * alpha;
                            constraint.translateMix += (data.translateMix - constraint.translateMix) * alpha;
                            constraint.scaleMix += (data.scaleMix - constraint.scaleMix) * alpha;
                            constraint.shearMix += (data.shearMix - constraint.shearMix) * alpha;
                    }
                    return;
                }
                var rotate = 0, translate = 0, scale = 0, shear = 0;
                if (time >= frames[frames.length - TransformConstraintTimeline.ENTRIES]) {
                    var i = frames.length;
                    rotate = frames[i + TransformConstraintTimeline.PREV_ROTATE];
                    translate = frames[i + TransformConstraintTimeline.PREV_TRANSLATE];
                    scale = frames[i + TransformConstraintTimeline.PREV_SCALE];
                    shear = frames[i + TransformConstraintTimeline.PREV_SHEAR];
                }
                else {
                    var frame = Animation.binarySearch(frames, time, TransformConstraintTimeline.ENTRIES);
                    rotate = frames[frame + TransformConstraintTimeline.PREV_ROTATE];
                    translate = frames[frame + TransformConstraintTimeline.PREV_TRANSLATE];
                    scale = frames[frame + TransformConstraintTimeline.PREV_SCALE];
                    shear = frames[frame + TransformConstraintTimeline.PREV_SHEAR];
                    var frameTime = frames[frame];
                    var percent = this.getCurvePercent(frame / TransformConstraintTimeline.ENTRIES - 1, 1 - (time - frameTime) / (frames[frame + TransformConstraintTimeline.PREV_TIME] - frameTime));
                    rotate += (frames[frame + TransformConstraintTimeline.ROTATE] - rotate) * percent;
                    translate += (frames[frame + TransformConstraintTimeline.TRANSLATE] - translate) * percent;
                    scale += (frames[frame + TransformConstraintTimeline.SCALE] - scale) * percent;
                    shear += (frames[frame + TransformConstraintTimeline.SHEAR] - shear) * percent;
                }
                if (blend == MixBlend.setup) {
                    var data = constraint.data;
                    constraint.rotateMix = data.rotateMix + (rotate - data.rotateMix) * alpha;
                    constraint.translateMix = data.translateMix + (translate - data.translateMix) * alpha;
                    constraint.scaleMix = data.scaleMix + (scale - data.scaleMix) * alpha;
                    constraint.shearMix = data.shearMix + (shear - data.shearMix) * alpha;
                }
                else {
                    constraint.rotateMix += (rotate - constraint.rotateMix) * alpha;
                    constraint.translateMix += (translate - constraint.translateMix) * alpha;
                    constraint.scaleMix += (scale - constraint.scaleMix) * alpha;
                    constraint.shearMix += (shear - constraint.shearMix) * alpha;
                }
            };
            TransformConstraintTimeline.ENTRIES = 5;
            TransformConstraintTimeline.PREV_TIME = -5;
            TransformConstraintTimeline.PREV_ROTATE = -4;
            TransformConstraintTimeline.PREV_TRANSLATE = -3;
            TransformConstraintTimeline.PREV_SCALE = -2;
            TransformConstraintTimeline.PREV_SHEAR = -1;
            TransformConstraintTimeline.ROTATE = 1;
            TransformConstraintTimeline.TRANSLATE = 2;
            TransformConstraintTimeline.SCALE = 3;
            TransformConstraintTimeline.SHEAR = 4;
            return TransformConstraintTimeline;
        }(CurveTimeline));
        core.TransformConstraintTimeline = TransformConstraintTimeline;
        var PathConstraintPositionTimeline = (function (_super) {
            __extends(PathConstraintPositionTimeline, _super);
            function PathConstraintPositionTimeline(frameCount) {
                var _this = _super.call(this, frameCount) || this;
                _this.frames = core.Utils.newFloatArray(frameCount * PathConstraintPositionTimeline.ENTRIES);
                return _this;
            }
            PathConstraintPositionTimeline.prototype.getPropertyId = function () {
                return (TimelineType.pathConstraintPosition << 24) + this.pathConstraintIndex;
            };
            PathConstraintPositionTimeline.prototype.setFrame = function (frameIndex, time, value) {
                frameIndex *= PathConstraintPositionTimeline.ENTRIES;
                this.frames[frameIndex] = time;
                this.frames[frameIndex + PathConstraintPositionTimeline.VALUE] = value;
            };
            PathConstraintPositionTimeline.prototype.apply = function (skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
                var frames = this.frames;
                var constraint = skeleton.pathConstraints[this.pathConstraintIndex];
                if (!constraint.active)
                    return;
                if (time < frames[0]) {
                    switch (blend) {
                        case MixBlend.setup:
                            constraint.position = constraint.data.position;
                            return;
                        case MixBlend.first:
                            constraint.position += (constraint.data.position - constraint.position) * alpha;
                    }
                    return;
                }
                var position = 0;
                if (time >= frames[frames.length - PathConstraintPositionTimeline.ENTRIES])
                    position = frames[frames.length + PathConstraintPositionTimeline.PREV_VALUE];
                else {
                    var frame = Animation.binarySearch(frames, time, PathConstraintPositionTimeline.ENTRIES);
                    position = frames[frame + PathConstraintPositionTimeline.PREV_VALUE];
                    var frameTime = frames[frame];
                    var percent = this.getCurvePercent(frame / PathConstraintPositionTimeline.ENTRIES - 1, 1 - (time - frameTime) / (frames[frame + PathConstraintPositionTimeline.PREV_TIME] - frameTime));
                    position += (frames[frame + PathConstraintPositionTimeline.VALUE] - position) * percent;
                }
                if (blend == MixBlend.setup)
                    constraint.position = constraint.data.position + (position - constraint.data.position) * alpha;
                else
                    constraint.position += (position - constraint.position) * alpha;
            };
            PathConstraintPositionTimeline.ENTRIES = 2;
            PathConstraintPositionTimeline.PREV_TIME = -2;
            PathConstraintPositionTimeline.PREV_VALUE = -1;
            PathConstraintPositionTimeline.VALUE = 1;
            return PathConstraintPositionTimeline;
        }(CurveTimeline));
        core.PathConstraintPositionTimeline = PathConstraintPositionTimeline;
        var PathConstraintSpacingTimeline = (function (_super) {
            __extends(PathConstraintSpacingTimeline, _super);
            function PathConstraintSpacingTimeline(frameCount) {
                return _super.call(this, frameCount) || this;
            }
            PathConstraintSpacingTimeline.prototype.getPropertyId = function () {
                return (TimelineType.pathConstraintSpacing << 24) + this.pathConstraintIndex;
            };
            PathConstraintSpacingTimeline.prototype.apply = function (skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
                var frames = this.frames;
                var constraint = skeleton.pathConstraints[this.pathConstraintIndex];
                if (!constraint.active)
                    return;
                if (time < frames[0]) {
                    switch (blend) {
                        case MixBlend.setup:
                            constraint.spacing = constraint.data.spacing;
                            return;
                        case MixBlend.first:
                            constraint.spacing += (constraint.data.spacing - constraint.spacing) * alpha;
                    }
                    return;
                }
                var spacing = 0;
                if (time >= frames[frames.length - PathConstraintSpacingTimeline.ENTRIES])
                    spacing = frames[frames.length + PathConstraintSpacingTimeline.PREV_VALUE];
                else {
                    var frame = Animation.binarySearch(frames, time, PathConstraintSpacingTimeline.ENTRIES);
                    spacing = frames[frame + PathConstraintSpacingTimeline.PREV_VALUE];
                    var frameTime = frames[frame];
                    var percent = this.getCurvePercent(frame / PathConstraintSpacingTimeline.ENTRIES - 1, 1 - (time - frameTime) / (frames[frame + PathConstraintSpacingTimeline.PREV_TIME] - frameTime));
                    spacing += (frames[frame + PathConstraintSpacingTimeline.VALUE] - spacing) * percent;
                }
                if (blend == MixBlend.setup)
                    constraint.spacing = constraint.data.spacing + (spacing - constraint.data.spacing) * alpha;
                else
                    constraint.spacing += (spacing - constraint.spacing) * alpha;
            };
            return PathConstraintSpacingTimeline;
        }(PathConstraintPositionTimeline));
        core.PathConstraintSpacingTimeline = PathConstraintSpacingTimeline;
        var PathConstraintMixTimeline = (function (_super) {
            __extends(PathConstraintMixTimeline, _super);
            function PathConstraintMixTimeline(frameCount) {
                var _this = _super.call(this, frameCount) || this;
                _this.frames = core.Utils.newFloatArray(frameCount * PathConstraintMixTimeline.ENTRIES);
                return _this;
            }
            PathConstraintMixTimeline.prototype.getPropertyId = function () {
                return (TimelineType.pathConstraintMix << 24) + this.pathConstraintIndex;
            };
            PathConstraintMixTimeline.prototype.setFrame = function (frameIndex, time, rotateMix, translateMix) {
                frameIndex *= PathConstraintMixTimeline.ENTRIES;
                this.frames[frameIndex] = time;
                this.frames[frameIndex + PathConstraintMixTimeline.ROTATE] = rotateMix;
                this.frames[frameIndex + PathConstraintMixTimeline.TRANSLATE] = translateMix;
            };
            PathConstraintMixTimeline.prototype.apply = function (skeleton, lastTime, time, firedEvents, alpha, blend, direction) {
                var frames = this.frames;
                var constraint = skeleton.pathConstraints[this.pathConstraintIndex];
                if (!constraint.active)
                    return;
                if (time < frames[0]) {
                    switch (blend) {
                        case MixBlend.setup:
                            constraint.rotateMix = constraint.data.rotateMix;
                            constraint.translateMix = constraint.data.translateMix;
                            return;
                        case MixBlend.first:
                            constraint.rotateMix += (constraint.data.rotateMix - constraint.rotateMix) * alpha;
                            constraint.translateMix += (constraint.data.translateMix - constraint.translateMix) * alpha;
                    }
                    return;
                }
                var rotate = 0, translate = 0;
                if (time >= frames[frames.length - PathConstraintMixTimeline.ENTRIES]) {
                    rotate = frames[frames.length + PathConstraintMixTimeline.PREV_ROTATE];
                    translate = frames[frames.length + PathConstraintMixTimeline.PREV_TRANSLATE];
                }
                else {
                    var frame = Animation.binarySearch(frames, time, PathConstraintMixTimeline.ENTRIES);
                    rotate = frames[frame + PathConstraintMixTimeline.PREV_ROTATE];
                    translate = frames[frame + PathConstraintMixTimeline.PREV_TRANSLATE];
                    var frameTime = frames[frame];
                    var percent = this.getCurvePercent(frame / PathConstraintMixTimeline.ENTRIES - 1, 1 - (time - frameTime) / (frames[frame + PathConstraintMixTimeline.PREV_TIME] - frameTime));
                    rotate += (frames[frame + PathConstraintMixTimeline.ROTATE] - rotate) * percent;
                    translate += (frames[frame + PathConstraintMixTimeline.TRANSLATE] - translate) * percent;
                }
                if (blend == MixBlend.setup) {
                    constraint.rotateMix = constraint.data.rotateMix + (rotate - constraint.data.rotateMix) * alpha;
                    constraint.translateMix = constraint.data.translateMix + (translate - constraint.data.translateMix) * alpha;
                }
                else {
                    constraint.rotateMix += (rotate - constraint.rotateMix) * alpha;
                    constraint.translateMix += (translate - constraint.translateMix) * alpha;
                }
            };
            PathConstraintMixTimeline.ENTRIES = 3;
            PathConstraintMixTimeline.PREV_TIME = -3;
            PathConstraintMixTimeline.PREV_ROTATE = -2;
            PathConstraintMixTimeline.PREV_TRANSLATE = -1;
            PathConstraintMixTimeline.ROTATE = 1;
            PathConstraintMixTimeline.TRANSLATE = 2;
            return PathConstraintMixTimeline;
        }(CurveTimeline));
        core.PathConstraintMixTimeline = PathConstraintMixTimeline;
    })(core = pixi_spine.core || (pixi_spine.core = {}));
})(pixi_spine || (pixi_spine = {}));
var pixi_spine;
(function (pixi_spine) {
    var core;
    (function (core) {
        var AnimationState = (function () {
            function AnimationState(data) {
                this.tracks = new Array();
                this.events = new Array();
                this.listeners = new Array();
                this.queue = new EventQueue(this);
                this.propertyIDs = new core.IntSet();
                this.animationsChanged = false;
                this.timeScale = 1;
                this.trackEntryPool = new core.Pool(function () { return new TrackEntry(); });
                this.data = data;
            }
            AnimationState.prototype.update = function (delta) {
                delta *= this.timeScale;
                var tracks = this.tracks;
                for (var i = 0, n = tracks.length; i < n; i++) {
                    var current = tracks[i];
                    if (current == null)
                        continue;
                    current.animationLast = current.nextAnimationLast;
                    current.trackLast = current.nextTrackLast;
                    var currentDelta = delta * current.timeScale;
                    if (current.delay > 0) {
                        current.delay -= currentDelta;
                        if (current.delay > 0)
                            continue;
                        currentDelta = -current.delay;
                        current.delay = 0;
                    }
                    var next = current.next;
                    if (next != null) {
                        var nextTime = current.trackLast - next.delay;
                        if (nextTime >= 0) {
                            next.delay = 0;
                            next.trackTime = current.timeScale == 0 ? 0 : (nextTime / current.timeScale + delta) * next.timeScale;
                            current.trackTime += currentDelta;
                            this.setCurrent(i, next, true);
                            while (next.mixingFrom != null) {
                                next.mixTime += delta;
                                next = next.mixingFrom;
                            }
                            continue;
                        }
                    }
                    else if (current.trackLast >= current.trackEnd && current.mixingFrom == null) {
                        tracks[i] = null;
                        this.queue.end(current);
                        this.disposeNext(current);
                        continue;
                    }
                    if (current.mixingFrom != null && this.updateMixingFrom(current, delta)) {
                        var from = current.mixingFrom;
                        current.mixingFrom = null;
                        if (from != null)
                            from.mixingTo = null;
                        while (from != null) {
                            this.queue.end(from);
                            from = from.mixingFrom;
                        }
                    }
                    current.trackTime += currentDelta;
                }
                this.queue.drain();
            };
            AnimationState.prototype.updateMixingFrom = function (to, delta) {
                var from = to.mixingFrom;
                if (from == null)
                    return true;
                var finished = this.updateMixingFrom(from, delta);
                from.animationLast = from.nextAnimationLast;
                from.trackLast = from.nextTrackLast;
                if (to.mixTime > 0 && to.mixTime >= to.mixDuration) {
                    if (from.totalAlpha == 0 || to.mixDuration == 0) {
                        to.mixingFrom = from.mixingFrom;
                        if (from.mixingFrom != null)
                            from.mixingFrom.mixingTo = to;
                        to.interruptAlpha = from.interruptAlpha;
                        this.queue.end(from);
                    }
                    return finished;
                }
                from.trackTime += delta * from.timeScale;
                to.mixTime += delta;
                return false;
            };
            AnimationState.prototype.apply = function (skeleton) {
                if (skeleton == null)
                    throw new Error("skeleton cannot be null.");
                if (this.animationsChanged)
                    this._animationsChanged();
                var events = this.events;
                var tracks = this.tracks;
                var applied = false;
                for (var i = 0, n = tracks.length; i < n; i++) {
                    var current = tracks[i];
                    if (current == null || current.delay > 0)
                        continue;
                    applied = true;
                    var blend = i == 0 ? core.MixBlend.first : current.mixBlend;
                    var mix = current.alpha;
                    if (current.mixingFrom != null)
                        mix *= this.applyMixingFrom(current, skeleton, blend);
                    else if (current.trackTime >= current.trackEnd && current.next == null)
                        mix = 0;
                    var animationLast = current.animationLast, animationTime = current.getAnimationTime();
                    var timelineCount = current.animation.timelines.length;
                    var timelines = current.animation.timelines;
                    if ((i == 0 && mix == 1) || blend == core.MixBlend.add) {
                        for (var ii = 0; ii < timelineCount; ii++) {
                            core.Utils.webkit602BugfixHelper(mix, blend);
                            timelines[ii].apply(skeleton, animationLast, animationTime, events, mix, blend, core.MixDirection.mixIn);
                        }
                    }
                    else {
                        var timelineMode = current.timelineMode;
                        var firstFrame = current.timelinesRotation.length == 0;
                        if (firstFrame)
                            core.Utils.setArraySize(current.timelinesRotation, timelineCount << 1, null);
                        var timelinesRotation = current.timelinesRotation;
                        for (var ii = 0; ii < timelineCount; ii++) {
                            var timeline = timelines[ii];
                            var timelineBlend = (timelineMode[ii] & (AnimationState.NOT_LAST - 1)) == AnimationState.SUBSEQUENT ? blend : core.MixBlend.setup;
                            if (timeline instanceof core.RotateTimeline) {
                                this.applyRotateTimeline(timeline, skeleton, animationTime, mix, timelineBlend, timelinesRotation, ii << 1, firstFrame);
                            }
                            else {
                                core.Utils.webkit602BugfixHelper(mix, blend);
                                timeline.apply(skeleton, animationLast, animationTime, events, mix, timelineBlend, core.MixDirection.mixIn);
                            }
                        }
                    }
                    this.queueEvents(current, animationTime);
                    events.length = 0;
                    current.nextAnimationLast = animationTime;
                    current.nextTrackLast = current.trackTime;
                }
                this.queue.drain();
                return applied;
            };
            AnimationState.prototype.applyMixingFrom = function (to, skeleton, blend) {
                var from = to.mixingFrom;
                if (from.mixingFrom != null)
                    this.applyMixingFrom(from, skeleton, blend);
                var mix = 0;
                if (to.mixDuration == 0) {
                    mix = 1;
                    if (blend == core.MixBlend.first)
                        blend = core.MixBlend.setup;
                }
                else {
                    mix = to.mixTime / to.mixDuration;
                    if (mix > 1)
                        mix = 1;
                    if (blend != core.MixBlend.first)
                        blend = from.mixBlend;
                }
                var events = mix < from.eventThreshold ? this.events : null;
                var attachments = mix < from.attachmentThreshold, drawOrder = mix < from.drawOrderThreshold;
                var animationLast = from.animationLast, animationTime = from.getAnimationTime();
                var timelineCount = from.animation.timelines.length;
                var timelines = from.animation.timelines;
                var alphaHold = from.alpha * to.interruptAlpha, alphaMix = alphaHold * (1 - mix);
                if (blend == core.MixBlend.add) {
                    for (var i = 0; i < timelineCount; i++)
                        timelines[i].apply(skeleton, animationLast, animationTime, events, alphaMix, blend, core.MixDirection.mixOut);
                }
                else {
                    var timelineMode = from.timelineMode;
                    var timelineHoldMix = from.timelineHoldMix;
                    var firstFrame = from.timelinesRotation.length == 0;
                    if (firstFrame)
                        core.Utils.setArraySize(from.timelinesRotation, timelineCount << 1, null);
                    var timelinesRotation = from.timelinesRotation;
                    from.totalAlpha = 0;
                    for (var i = 0; i < timelineCount; i++) {
                        var timeline = timelines[i];
                        var direction = core.MixDirection.mixOut;
                        var timelineBlend = void 0;
                        var alpha = 0;
                        switch (timelineMode[i] & (AnimationState.NOT_LAST - 1)) {
                            case AnimationState.SUBSEQUENT:
                                if (!attachments && timeline instanceof core.AttachmentTimeline) {
                                    if ((timelineMode[i] & AnimationState.NOT_LAST) == AnimationState.NOT_LAST)
                                        continue;
                                    blend = core.MixBlend.setup;
                                }
                                if (!drawOrder && timeline instanceof core.DrawOrderTimeline)
                                    continue;
                                timelineBlend = blend;
                                alpha = alphaMix;
                                break;
                            case AnimationState.FIRST:
                                timelineBlend = core.MixBlend.setup;
                                alpha = alphaMix;
                                break;
                            case AnimationState.HOLD:
                                timelineBlend = core.MixBlend.setup;
                                alpha = alphaHold;
                                break;
                            default:
                                timelineBlend = core.MixBlend.setup;
                                var holdMix = timelineHoldMix[i];
                                alpha = alphaHold * Math.max(0, 1 - holdMix.mixTime / holdMix.mixDuration);
                                break;
                        }
                        from.totalAlpha += alpha;
                        if (timeline instanceof core.RotateTimeline)
                            this.applyRotateTimeline(timeline, skeleton, animationTime, alpha, timelineBlend, timelinesRotation, i << 1, firstFrame);
                        else {
                            core.Utils.webkit602BugfixHelper(alpha, blend);
                            if (timelineBlend == core.MixBlend.setup) {
                                if (timeline instanceof core.AttachmentTimeline) {
                                    if (attachments || (timelineMode[i] & AnimationState.NOT_LAST) == AnimationState.NOT_LAST)
                                        direction = core.MixDirection.mixIn;
                                }
                                else if (timeline instanceof core.DrawOrderTimeline) {
                                    if (drawOrder)
                                        direction = core.MixDirection.mixIn;
                                }
                            }
                            timeline.apply(skeleton, animationLast, animationTime, events, alpha, timelineBlend, direction);
                        }
                    }
                }
                if (to.mixDuration > 0)
                    this.queueEvents(from, animationTime);
                this.events.length = 0;
                from.nextAnimationLast = animationTime;
                from.nextTrackLast = from.trackTime;
                return mix;
            };
            AnimationState.prototype.applyRotateTimeline = function (timeline, skeleton, time, alpha, blend, timelinesRotation, i, firstFrame) {
                if (firstFrame)
                    timelinesRotation[i] = 0;
                if (alpha == 1) {
                    timeline.apply(skeleton, 0, time, null, 1, blend, core.MixDirection.mixIn);
                    return;
                }
                var rotateTimeline = timeline;
                var frames = rotateTimeline.frames;
                var bone = skeleton.bones[rotateTimeline.boneIndex];
                if (!bone.active)
                    return;
                var r1 = 0, r2 = 0;
                if (time < frames[0]) {
                    switch (blend) {
                        case core.MixBlend.setup:
                            bone.rotation = bone.data.rotation;
                        default:
                            return;
                        case core.MixBlend.first:
                            r1 = bone.rotation;
                            r2 = bone.data.rotation;
                    }
                }
                else {
                    r1 = blend == core.MixBlend.setup ? bone.data.rotation : bone.rotation;
                    if (time >= frames[frames.length - core.RotateTimeline.ENTRIES])
                        r2 = bone.data.rotation + frames[frames.length + core.RotateTimeline.PREV_ROTATION];
                    else {
                        var frame = core.Animation.binarySearch(frames, time, core.RotateTimeline.ENTRIES);
                        var prevRotation = frames[frame + core.RotateTimeline.PREV_ROTATION];
                        var frameTime = frames[frame];
                        var percent = rotateTimeline.getCurvePercent((frame >> 1) - 1, 1 - (time - frameTime) / (frames[frame + core.RotateTimeline.PREV_TIME] - frameTime));
                        r2 = frames[frame + core.RotateTimeline.ROTATION] - prevRotation;
                        r2 -= (16384 - ((16384.499999999996 - r2 / 360) | 0)) * 360;
                        r2 = prevRotation + r2 * percent + bone.data.rotation;
                        r2 -= (16384 - ((16384.499999999996 - r2 / 360) | 0)) * 360;
                    }
                }
                var total = 0, diff = r2 - r1;
                diff -= (16384 - ((16384.499999999996 - diff / 360) | 0)) * 360;
                if (diff == 0) {
                    total = timelinesRotation[i];
                }
                else {
                    var lastTotal = 0, lastDiff = 0;
                    if (firstFrame) {
                        lastTotal = 0;
                        lastDiff = diff;
                    }
                    else {
                        lastTotal = timelinesRotation[i];
                        lastDiff = timelinesRotation[i + 1];
                    }
                    var current = diff > 0, dir = lastTotal >= 0;
                    if (core.MathUtils.signum(lastDiff) != core.MathUtils.signum(diff) && Math.abs(lastDiff) <= 90) {
                        if (Math.abs(lastTotal) > 180)
                            lastTotal += 360 * core.MathUtils.signum(lastTotal);
                        dir = current;
                    }
                    total = diff + lastTotal - lastTotal % 360;
                    if (dir != current)
                        total += 360 * core.MathUtils.signum(lastTotal);
                    timelinesRotation[i] = total;
                }
                timelinesRotation[i + 1] = diff;
                r1 += total * alpha;
                bone.rotation = r1 - (16384 - ((16384.499999999996 - r1 / 360) | 0)) * 360;
            };
            AnimationState.prototype.queueEvents = function (entry, animationTime) {
                var animationStart = entry.animationStart, animationEnd = entry.animationEnd;
                var duration = animationEnd - animationStart;
                var trackLastWrapped = entry.trackLast % duration;
                var events = this.events;
                var i = 0, n = events.length;
                for (; i < n; i++) {
                    var event_1 = events[i];
                    if (event_1.time < trackLastWrapped)
                        break;
                    if (event_1.time > animationEnd)
                        continue;
                    this.queue.event(entry, event_1);
                }
                var complete = false;
                if (entry.loop)
                    complete = duration == 0 || trackLastWrapped > entry.trackTime % duration;
                else
                    complete = animationTime >= animationEnd && entry.animationLast < animationEnd;
                if (complete)
                    this.queue.complete(entry);
                for (; i < n; i++) {
                    var event_2 = events[i];
                    if (event_2.time < animationStart)
                        continue;
                    this.queue.event(entry, events[i]);
                }
            };
            AnimationState.prototype.clearTracks = function () {
                var oldDrainDisabled = this.queue.drainDisabled;
                this.queue.drainDisabled = true;
                for (var i = 0, n = this.tracks.length; i < n; i++)
                    this.clearTrack(i);
                this.tracks.length = 0;
                this.queue.drainDisabled = oldDrainDisabled;
                this.queue.drain();
            };
            AnimationState.prototype.clearTrack = function (trackIndex) {
                if (trackIndex >= this.tracks.length)
                    return;
                var current = this.tracks[trackIndex];
                if (current == null)
                    return;
                this.queue.end(current);
                this.disposeNext(current);
                var entry = current;
                while (true) {
                    var from = entry.mixingFrom;
                    if (from == null)
                        break;
                    this.queue.end(from);
                    entry.mixingFrom = null;
                    entry.mixingTo = null;
                    entry = from;
                }
                this.tracks[current.trackIndex] = null;
                this.queue.drain();
            };
            AnimationState.prototype.setCurrent = function (index, current, interrupt) {
                var from = this.expandToIndex(index);
                this.tracks[index] = current;
                if (from != null) {
                    if (interrupt)
                        this.queue.interrupt(from);
                    current.mixingFrom = from;
                    from.mixingTo = current;
                    current.mixTime = 0;
                    if (from.mixingFrom != null && from.mixDuration > 0)
                        current.interruptAlpha *= Math.min(1, from.mixTime / from.mixDuration);
                    from.timelinesRotation.length = 0;
                }
                this.queue.start(current);
            };
            AnimationState.prototype.setAnimation = function (trackIndex, animationName, loop) {
                var animation = this.data.skeletonData.findAnimation(animationName);
                if (animation == null)
                    throw new Error("Animation not found: " + animationName);
                return this.setAnimationWith(trackIndex, animation, loop);
            };
            AnimationState.prototype.setAnimationWith = function (trackIndex, animation, loop) {
                if (animation == null)
                    throw new Error("animation cannot be null.");
                var interrupt = true;
                var current = this.expandToIndex(trackIndex);
                if (current != null) {
                    if (current.nextTrackLast == -1) {
                        this.tracks[trackIndex] = current.mixingFrom;
                        this.queue.interrupt(current);
                        this.queue.end(current);
                        this.disposeNext(current);
                        current = current.mixingFrom;
                        interrupt = false;
                    }
                    else
                        this.disposeNext(current);
                }
                var entry = this.trackEntry(trackIndex, animation, loop, current);
                this.setCurrent(trackIndex, entry, interrupt);
                this.queue.drain();
                return entry;
            };
            AnimationState.prototype.addAnimation = function (trackIndex, animationName, loop, delay) {
                var animation = this.data.skeletonData.findAnimation(animationName);
                if (animation == null)
                    throw new Error("Animation not found: " + animationName);
                return this.addAnimationWith(trackIndex, animation, loop, delay);
            };
            AnimationState.prototype.addAnimationWith = function (trackIndex, animation, loop, delay) {
                if (animation == null)
                    throw new Error("animation cannot be null.");
                var last = this.expandToIndex(trackIndex);
                if (last != null) {
                    while (last.next != null)
                        last = last.next;
                }
                var entry = this.trackEntry(trackIndex, animation, loop, last);
                if (last == null) {
                    this.setCurrent(trackIndex, entry, true);
                    this.queue.drain();
                }
                else {
                    last.next = entry;
                    if (delay <= 0) {
                        var duration = last.animationEnd - last.animationStart;
                        if (duration != 0) {
                            if (last.loop)
                                delay += duration * (1 + ((last.trackTime / duration) | 0));
                            else
                                delay += Math.max(duration, last.trackTime);
                            delay -= this.data.getMix(last.animation, animation);
                        }
                        else
                            delay = last.trackTime;
                    }
                }
                entry.delay = delay;
                return entry;
            };
            AnimationState.prototype.setEmptyAnimation = function (trackIndex, mixDuration) {
                var entry = this.setAnimationWith(trackIndex, AnimationState.emptyAnimation, false);
                entry.mixDuration = mixDuration;
                entry.trackEnd = mixDuration;
                return entry;
            };
            AnimationState.prototype.addEmptyAnimation = function (trackIndex, mixDuration, delay) {
                if (delay <= 0)
                    delay -= mixDuration;
                var entry = this.addAnimationWith(trackIndex, AnimationState.emptyAnimation, false, delay);
                entry.mixDuration = mixDuration;
                entry.trackEnd = mixDuration;
                return entry;
            };
            AnimationState.prototype.setEmptyAnimations = function (mixDuration) {
                var oldDrainDisabled = this.queue.drainDisabled;
                this.queue.drainDisabled = true;
                for (var i = 0, n = this.tracks.length; i < n; i++) {
                    var current = this.tracks[i];
                    if (current != null)
                        this.setEmptyAnimation(current.trackIndex, mixDuration);
                }
                this.queue.drainDisabled = oldDrainDisabled;
                this.queue.drain();
            };
            AnimationState.prototype.expandToIndex = function (index) {
                if (index < this.tracks.length)
                    return this.tracks[index];
                core.Utils.ensureArrayCapacity(this.tracks, index + 1, null);
                this.tracks.length = index + 1;
                return null;
            };
            AnimationState.prototype.trackEntry = function (trackIndex, animation, loop, last) {
                var entry = this.trackEntryPool.obtain();
                entry.trackIndex = trackIndex;
                entry.animation = animation;
                entry.loop = loop;
                entry.holdPrevious = false;
                entry.eventThreshold = 0;
                entry.attachmentThreshold = 0;
                entry.drawOrderThreshold = 0;
                entry.animationStart = 0;
                entry.animationEnd = animation.duration;
                entry.animationLast = -1;
                entry.nextAnimationLast = -1;
                entry.delay = 0;
                entry.trackTime = 0;
                entry.trackLast = -1;
                entry.nextTrackLast = -1;
                entry.trackEnd = Number.MAX_VALUE;
                entry.timeScale = 1;
                entry.alpha = 1;
                entry.interruptAlpha = 1;
                entry.mixTime = 0;
                entry.mixDuration = last == null ? 0 : this.data.getMix(last.animation, animation);
                return entry;
            };
            AnimationState.prototype.disposeNext = function (entry) {
                var next = entry.next;
                while (next != null) {
                    this.queue.dispose(next);
                    next = next.next;
                }
                entry.next = null;
            };
            AnimationState.prototype._animationsChanged = function () {
                this.animationsChanged = false;
                this.propertyIDs.clear();
                for (var i = 0, n = this.tracks.length; i < n; i++) {
                    var entry = this.tracks[i];
                    if (entry == null)
                        continue;
                    while (entry.mixingFrom != null)
                        entry = entry.mixingFrom;
                    do {
                        if (entry.mixingFrom == null || entry.mixBlend != core.MixBlend.add)
                            this.computeHold(entry);
                        entry = entry.mixingTo;
                    } while (entry != null);
                }
                this.propertyIDs.clear();
                for (var i = this.tracks.length - 1; i >= 0; i--) {
                    var entry = this.tracks[i];
                    while (entry != null) {
                        this.computeNotLast(entry);
                        entry = entry.mixingFrom;
                    }
                }
            };
            AnimationState.prototype.computeHold = function (entry) {
                var to = entry.mixingTo;
                var timelines = entry.animation.timelines;
                var timelinesCount = entry.animation.timelines.length;
                var timelineMode = core.Utils.setArraySize(entry.timelineMode, timelinesCount);
                entry.timelineHoldMix.length = 0;
                var timelineDipMix = core.Utils.setArraySize(entry.timelineHoldMix, timelinesCount);
                var propertyIDs = this.propertyIDs;
                if (to != null && to.holdPrevious) {
                    for (var i = 0; i < timelinesCount; i++) {
                        propertyIDs.add(timelines[i].getPropertyId());
                        timelineMode[i] = AnimationState.HOLD;
                    }
                    return;
                }
                outer: for (var i = 0; i < timelinesCount; i++) {
                    var timeline = timelines[i];
                    var id = timeline.getPropertyId();
                    if (!propertyIDs.add(id))
                        timelineMode[i] = AnimationState.SUBSEQUENT;
                    else if (to == null || timeline instanceof core.AttachmentTimeline || timeline instanceof core.DrawOrderTimeline
                        || timeline instanceof core.EventTimeline || !this.hasTimeline(to, id)) {
                        timelineMode[i] = AnimationState.FIRST;
                    }
                    else {
                        for (var next = to.mixingTo; next != null; next = next.mixingTo) {
                            if (this.hasTimeline(next, id))
                                continue;
                            if (entry.mixDuration > 0) {
                                timelineMode[i] = AnimationState.HOLD_MIX;
                                timelineDipMix[i] = next;
                                continue outer;
                            }
                            break;
                        }
                        timelineMode[i] = AnimationState.HOLD;
                    }
                }
            };
            AnimationState.prototype.computeNotLast = function (entry) {
                var timelines = entry.animation.timelines;
                var timelinesCount = entry.animation.timelines.length;
                var timelineMode = entry.timelineMode;
                var propertyIDs = this.propertyIDs;
                for (var i = 0; i < timelinesCount; i++) {
                    if (timelines[i] instanceof core.AttachmentTimeline) {
                        var timeline = timelines[i];
                        if (!propertyIDs.add(timeline.slotIndex))
                            timelineMode[i] |= AnimationState.NOT_LAST;
                    }
                }
            };
            AnimationState.prototype.hasTimeline = function (entry, id) {
                var timelines = entry.animation.timelines;
                for (var i = 0, n = timelines.length; i < n; i++)
                    if (timelines[i].getPropertyId() == id)
                        return true;
                return false;
            };
            AnimationState.prototype.getCurrent = function (trackIndex) {
                if (trackIndex >= this.tracks.length)
                    return null;
                return this.tracks[trackIndex];
            };
            AnimationState.prototype.addListener = function (listener) {
                if (listener == null)
                    throw new Error("listener cannot be null.");
                this.listeners.push(listener);
            };
            AnimationState.prototype.removeListener = function (listener) {
                var index = this.listeners.indexOf(listener);
                if (index >= 0)
                    this.listeners.splice(index, 1);
            };
            AnimationState.prototype.clearListeners = function () {
                this.listeners.length = 0;
            };
            AnimationState.prototype.clearListenerNotifications = function () {
                this.queue.clear();
            };
            AnimationState.prototype.setAnimationByName = function (trackIndex, animationName, loop) {
                if (!AnimationState.deprecatedWarning1) {
                    AnimationState.deprecatedWarning1 = true;
                    console.warn("Spine Deprecation Warning: AnimationState.setAnimationByName is deprecated, please use setAnimation from now on.");
                }
                this.setAnimation(trackIndex, animationName, loop);
            };
            AnimationState.prototype.addAnimationByName = function (trackIndex, animationName, loop, delay) {
                if (!AnimationState.deprecatedWarning2) {
                    AnimationState.deprecatedWarning2 = true;
                    console.warn("Spine Deprecation Warning: AnimationState.addAnimationByName is deprecated, please use addAnimation from now on.");
                }
                this.addAnimation(trackIndex, animationName, loop, delay);
            };
            AnimationState.prototype.hasAnimation = function (animationName) {
                var animation = this.data.skeletonData.findAnimation(animationName);
                return animation !== null;
            };
            AnimationState.prototype.hasAnimationByName = function (animationName) {
                if (!AnimationState.deprecatedWarning3) {
                    AnimationState.deprecatedWarning3 = true;
                    console.warn("Spine Deprecation Warning: AnimationState.hasAnimationByName is deprecated, please use hasAnimation from now on.");
                }
                return this.hasAnimation(animationName);
            };
            AnimationState.emptyAnimation = new core.Animation("<empty>", [], 0);
            AnimationState.SUBSEQUENT = 0;
            AnimationState.FIRST = 1;
            AnimationState.HOLD = 2;
            AnimationState.HOLD_MIX = 3;
            AnimationState.NOT_LAST = 4;
            AnimationState.deprecatedWarning1 = false;
            AnimationState.deprecatedWarning2 = false;
            AnimationState.deprecatedWarning3 = false;
            return AnimationState;
        }());
        core.AnimationState = AnimationState;
        var TrackEntry = (function () {
            function TrackEntry() {
                this.mixBlend = core.MixBlend.replace;
                this.timelineMode = new Array();
                this.timelineHoldMix = new Array();
                this.timelinesRotation = new Array();
            }
            TrackEntry.prototype.reset = function () {
                this.next = null;
                this.mixingFrom = null;
                this.mixingTo = null;
                this.animation = null;
                this.listener = null;
                this.timelineMode.length = 0;
                this.timelineHoldMix.length = 0;
                this.timelinesRotation.length = 0;
            };
            TrackEntry.prototype.getAnimationTime = function () {
                if (this.loop) {
                    var duration = this.animationEnd - this.animationStart;
                    if (duration == 0)
                        return this.animationStart;
                    return (this.trackTime % duration) + this.animationStart;
                }
                return Math.min(this.trackTime + this.animationStart, this.animationEnd);
            };
            TrackEntry.prototype.setAnimationLast = function (animationLast) {
                this.animationLast = animationLast;
                this.nextAnimationLast = animationLast;
            };
            TrackEntry.prototype.isComplete = function () {
                return this.trackTime >= this.animationEnd - this.animationStart;
            };
            TrackEntry.prototype.resetRotationDirections = function () {
                this.timelinesRotation.length = 0;
            };
            Object.defineProperty(TrackEntry.prototype, "time", {
                get: function () {
                    if (!TrackEntry.deprecatedWarning1) {
                        TrackEntry.deprecatedWarning1 = true;
                        console.warn("Spine Deprecation Warning: TrackEntry.time is deprecated, please use trackTime from now on.");
                    }
                    return this.trackTime;
                },
                set: function (value) {
                    if (!TrackEntry.deprecatedWarning1) {
                        TrackEntry.deprecatedWarning1 = true;
                        console.warn("Spine Deprecation Warning: TrackEntry.time is deprecated, please use trackTime from now on.");
                    }
                    this.trackTime = value;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(TrackEntry.prototype, "endTime", {
                get: function () {
                    if (!TrackEntry.deprecatedWarning2) {
                        TrackEntry.deprecatedWarning2 = true;
                        console.warn("Spine Deprecation Warning: TrackEntry.endTime is deprecated, please use trackEnd from now on.");
                    }
                    return this.trackTime;
                },
                set: function (value) {
                    if (!TrackEntry.deprecatedWarning2) {
                        TrackEntry.deprecatedWarning2 = true;
                        console.warn("Spine Deprecation Warning: TrackEntry.endTime is deprecated, please use trackEnd from now on.");
                    }
                    this.trackTime = value;
                },
                enumerable: true,
                configurable: true
            });
            TrackEntry.prototype.loopsCount = function () {
                return Math.floor(this.trackTime / this.trackEnd);
            };
            TrackEntry.deprecatedWarning1 = false;
            TrackEntry.deprecatedWarning2 = false;
            return TrackEntry;
        }());
        core.TrackEntry = TrackEntry;
        var EventQueue = (function () {
            function EventQueue(animState) {
                this.objects = [];
                this.drainDisabled = false;
                this.animState = animState;
            }
            EventQueue.prototype.start = function (entry) {
                this.objects.push(EventType.start);
                this.objects.push(entry);
                this.animState.animationsChanged = true;
            };
            EventQueue.prototype.interrupt = function (entry) {
                this.objects.push(EventType.interrupt);
                this.objects.push(entry);
            };
            EventQueue.prototype.end = function (entry) {
                this.objects.push(EventType.end);
                this.objects.push(entry);
                this.animState.animationsChanged = true;
            };
            EventQueue.prototype.dispose = function (entry) {
                this.objects.push(EventType.dispose);
                this.objects.push(entry);
            };
            EventQueue.prototype.complete = function (entry) {
                this.objects.push(EventType.complete);
                this.objects.push(entry);
            };
            EventQueue.prototype.event = function (entry, event) {
                this.objects.push(EventType.event);
                this.objects.push(entry);
                this.objects.push(event);
            };
            EventQueue.prototype.deprecateStuff = function () {
                if (!EventQueue.deprecatedWarning1) {
                    EventQueue.deprecatedWarning1 = true;
                    console.warn("Spine Deprecation Warning: onComplete, onStart, onEnd, onEvent art deprecated, please use listeners from now on. 'state.addListener({ complete: function(track, event) { } })'");
                }
                return true;
            };
            EventQueue.prototype.drain = function () {
                if (this.drainDisabled)
                    return;
                this.drainDisabled = true;
                var objects = this.objects;
                var listeners = this.animState.listeners;
                for (var i = 0; i < objects.length; i += 2) {
                    var type = objects[i];
                    var entry = objects[i + 1];
                    switch (type) {
                        case EventType.start:
                            if (entry.listener != null && entry.listener.start)
                                entry.listener.start(entry);
                            for (var ii = 0; ii < listeners.length; ii++)
                                if (listeners[ii].start)
                                    listeners[ii].start(entry);
                            entry.onStart && this.deprecateStuff() && entry.onStart(entry.trackIndex);
                            this.animState.onStart && this.deprecateStuff() && this.deprecateStuff && this.animState.onStart(entry.trackIndex);
                            break;
                        case EventType.interrupt:
                            if (entry.listener != null && entry.listener.interrupt)
                                entry.listener.interrupt(entry);
                            for (var ii = 0; ii < listeners.length; ii++)
                                if (listeners[ii].interrupt)
                                    listeners[ii].interrupt(entry);
                            break;
                        case EventType.end:
                            if (entry.listener != null && entry.listener.end)
                                entry.listener.end(entry);
                            for (var ii = 0; ii < listeners.length; ii++)
                                if (listeners[ii].end)
                                    listeners[ii].end(entry);
                            entry.onEnd && this.deprecateStuff() && entry.onEnd(entry.trackIndex);
                            this.animState.onEnd && this.deprecateStuff() && this.animState.onEnd(entry.trackIndex);
                        case EventType.dispose:
                            if (entry.listener != null && entry.listener.dispose)
                                entry.listener.dispose(entry);
                            for (var ii = 0; ii < listeners.length; ii++)
                                if (listeners[ii].dispose)
                                    listeners[ii].dispose(entry);
                            this.animState.trackEntryPool.free(entry);
                            break;
                        case EventType.complete:
                            if (entry.listener != null && entry.listener.complete)
                                entry.listener.complete(entry);
                            for (var ii = 0; ii < listeners.length; ii++)
                                if (listeners[ii].complete)
                                    listeners[ii].complete(entry);
                            var count = core.MathUtils.toInt(entry.loopsCount());
                            entry.onComplete && this.deprecateStuff() && entry.onComplete(entry.trackIndex, count);
                            this.animState.onComplete && this.deprecateStuff() && this.animState.onComplete(entry.trackIndex, count);
                            break;
                        case EventType.event:
                            var event_3 = objects[i++ + 2];
                            if (entry.listener != null && entry.listener.event)
                                entry.listener.event(entry, event_3);
                            for (var ii = 0; ii < listeners.length; ii++)
                                if (listeners[ii].event)
                                    listeners[ii].event(entry, event_3);
                            entry.onEvent && this.deprecateStuff() && entry.onEvent(entry.trackIndex, event_3);
                            this.animState.onEvent && this.deprecateStuff() && this.animState.onEvent(entry.trackIndex, event_3);
                            break;
                    }
                }
                this.clear();
                this.drainDisabled = false;
            };
            EventQueue.prototype.clear = function () {
                this.objects.length = 0;
            };
            EventQueue.deprecatedWarning1 = false;
            return EventQueue;
        }());
        core.EventQueue = EventQueue;
        var EventType;
        (function (EventType) {
            EventType[EventType["start"] = 0] = "start";
            EventType[EventType["interrupt"] = 1] = "interrupt";
            EventType[EventType["end"] = 2] = "end";
            EventType[EventType["dispose"] = 3] = "dispose";
            EventType[EventType["complete"] = 4] = "complete";
            EventType[EventType["event"] = 5] = "event";
        })(EventType = core.EventType || (core.EventType = {}));
        var AnimationStateAdapter2 = (function () {
            function AnimationStateAdapter2() {
            }
            AnimationStateAdapter2.prototype.start = function (entry) {
            };
            AnimationStateAdapter2.prototype.interrupt = function (entry) {
            };
            AnimationStateAdapter2.prototype.end = function (entry) {
            };
            AnimationStateAdapter2.prototype.dispose = function (entry) {
            };
            AnimationStateAdapter2.prototype.complete = function (entry) {
            };
            AnimationStateAdapter2.prototype.event = function (entry, event) {
            };
            return AnimationStateAdapter2;
        }());
        core.AnimationStateAdapter2 = AnimationStateAdapter2;
    })(core = pixi_spine.core || (pixi_spine.core = {}));
})(pixi_spine || (pixi_spine = {}));
var pixi_spine;
(function (pixi_spine) {
    var core;
    (function (core) {
        var AnimationStateData = (function () {
            function AnimationStateData(skeletonData) {
                this.animationToMixTime = {};
                this.defaultMix = 0;
                if (skeletonData == null)
                    throw new Error("skeletonData cannot be null.");
                this.skeletonData = skeletonData;
            }
            AnimationStateData.prototype.setMix = function (fromName, toName, duration) {
                var from = this.skeletonData.findAnimation(fromName);
                if (from == null)
                    throw new Error("Animation not found: " + fromName);
                var to = this.skeletonData.findAnimation(toName);
                if (to == null)
                    throw new Error("Animation not found: " + toName);
                this.setMixWith(from, to, duration);
            };
            AnimationStateData.prototype.setMixByName = function (fromName, toName, duration) {
                if (!AnimationStateData.deprecatedWarning1) {
                    AnimationStateData.deprecatedWarning1 = true;
                    console.warn("Deprecation Warning: AnimationStateData.setMixByName is deprecated, please use setMix from now on.");
                }
                this.setMix(fromName, toName, duration);
            };
            AnimationStateData.prototype.setMixWith = function (from, to, duration) {
                if (from == null)
                    throw new Error("from cannot be null.");
                if (to == null)
                    throw new Error("to cannot be null.");
                var key = from.name + "." + to.name;
                this.animationToMixTime[key] = duration;
            };
            AnimationStateData.prototype.getMix = function (from, to) {
                var key = from.name + "." + to.name;
                var value = this.animationToMixTime[key];
                return value === undefined ? this.defaultMix : value;
            };
            AnimationStateData.deprecatedWarning1 = false;
            return AnimationStateData;
        }());
        core.AnimationStateData = AnimationStateData;
    })(core = pixi_spine.core || (pixi_spine.core = {}));
})(pixi_spine || (pixi_spine = {}));
var pixi_spine;
(function (pixi_spine) {
    var core;
    (function (core) {
        var AtlasAttachmentLoader = (function () {
            function AtlasAttachmentLoader(atlas) {
                this.atlas = atlas;
            }
            AtlasAttachmentLoader.prototype.newRegionAttachment = function (skin, name, path) {
                var region = this.atlas.findRegion(path);
                if (region == null)
                    throw new Error("Region not found in atlas: " + path + " (region attachment: " + name + ")");
                var attachment = new core.RegionAttachment(name);
                attachment.region = region;
                return attachment;
            };
            AtlasAttachmentLoader.prototype.newMeshAttachment = function (skin, name, path) {
                var region = this.atlas.findRegion(path);
                if (region == null)
                    throw new Error("Region not found in atlas: " + path + " (mesh attachment: " + name + ")");
                var attachment = new core.MeshAttachment(name);
                attachment.region = region;
                return attachment;
            };
            AtlasAttachmentLoader.prototype.newBoundingBoxAttachment = function (skin, name) {
                return new core.BoundingBoxAttachment(name);
            };
            AtlasAttachmentLoader.prototype.newPathAttachment = function (skin, name) {
                return new core.PathAttachment(name);
            };
            AtlasAttachmentLoader.prototype.newPointAttachment = function (skin, name) {
                return new core.PointAttachment(name);
            };
            AtlasAttachmentLoader.prototype.newClippingAttachment = function (skin, name) {
                return new core.ClippingAttachment(name);
            };
            return AtlasAttachmentLoader;
        }());
        core.AtlasAttachmentLoader = AtlasAttachmentLoader;
    })(core = pixi_spine.core || (pixi_spine.core = {}));
})(pixi_spine || (pixi_spine = {}));
var pixi_spine;
(function (pixi_spine) {
    var core;
    (function (core) {
        var BlendMode;
        (function (BlendMode) {
            BlendMode[BlendMode["Normal"] = 0] = "Normal";
            BlendMode[BlendMode["Additive"] = 1] = "Additive";
            BlendMode[BlendMode["Multiply"] = 2] = "Multiply";
            BlendMode[BlendMode["Screen"] = 3] = "Screen";
        })(BlendMode = core.BlendMode || (core.BlendMode = {}));
    })(core = pixi_spine.core || (pixi_spine.core = {}));
})(pixi_spine || (pixi_spine = {}));
var pixi_spine;
(function (pixi_spine) {
    var core;
    (function (core) {
        var Bone = (function () {
            function Bone(data, skeleton, parent) {
                this.matrix = new PIXI.Matrix();
                this.children = new Array();
                this.x = 0;
                this.y = 0;
                this.rotation = 0;
                this.scaleX = 0;
                this.scaleY = 0;
                this.shearX = 0;
                this.shearY = 0;
                this.ax = 0;
                this.ay = 0;
                this.arotation = 0;
                this.ascaleX = 0;
                this.ascaleY = 0;
                this.ashearX = 0;
                this.ashearY = 0;
                this.appliedValid = false;
                this.sorted = false;
                this.active = false;
                if (data == null)
                    throw new Error("data cannot be null.");
                if (skeleton == null)
                    throw new Error("skeleton cannot be null.");
                this.data = data;
                this.skeleton = skeleton;
                this.parent = parent;
                this.setToSetupPose();
            }
            Object.defineProperty(Bone.prototype, "worldX", {
                get: function () {
                    return this.matrix.tx;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Bone.prototype, "worldY", {
                get: function () {
                    return this.matrix.ty;
                },
                enumerable: true,
                configurable: true
            });
            Bone.prototype.isActive = function () {
                return this.active;
            };
            Bone.prototype.update = function () {
                this.updateWorldTransformWith(this.x, this.y, this.rotation, this.scaleX, this.scaleY, this.shearX, this.shearY);
            };
            Bone.prototype.updateWorldTransform = function () {
                this.updateWorldTransformWith(this.x, this.y, this.rotation, this.scaleX, this.scaleY, this.shearX, this.shearY);
            };
            Bone.prototype.updateWorldTransformWith = function (x, y, rotation, scaleX, scaleY, shearX, shearY) {
                this.ax = x;
                this.ay = y;
                this.arotation = rotation;
                this.ascaleX = scaleX;
                this.ascaleY = scaleY;
                this.ashearX = shearX;
                this.ashearY = shearY;
                this.appliedValid = true;
                var parent = this.parent;
                var m = this.matrix;
                var sx = this.skeleton.scaleX;
                var sy = Bone.yDown ? -this.skeleton.scaleY : this.skeleton.scaleY;
                if (parent == null) {
                    var skeleton = this.skeleton;
                    var rotationY = rotation + 90 + shearY;
                    m.a = core.MathUtils.cosDeg(rotation + shearX) * scaleX * sx;
                    m.c = core.MathUtils.cosDeg(rotationY) * scaleY * sx;
                    m.b = core.MathUtils.sinDeg(rotation + shearX) * scaleX * sy;
                    m.d = core.MathUtils.sinDeg(rotationY) * scaleY * sy;
                    m.tx = x * sx + skeleton.x;
                    m.ty = y * sy + skeleton.y;
                    return;
                }
                var pa = parent.matrix.a, pb = parent.matrix.c, pc = parent.matrix.b, pd = parent.matrix.d;
                m.tx = pa * x + pb * y + parent.matrix.tx;
                m.ty = pc * x + pd * y + parent.matrix.ty;
                switch (this.data.transformMode) {
                    case core.TransformMode.Normal: {
                        var rotationY = rotation + 90 + shearY;
                        var la = core.MathUtils.cosDeg(rotation + shearX) * scaleX;
                        var lb = core.MathUtils.cosDeg(rotationY) * scaleY;
                        var lc = core.MathUtils.sinDeg(rotation + shearX) * scaleX;
                        var ld = core.MathUtils.sinDeg(rotationY) * scaleY;
                        m.a = pa * la + pb * lc;
                        m.c = pa * lb + pb * ld;
                        m.b = pc * la + pd * lc;
                        m.d = pc * lb + pd * ld;
                        return;
                    }
                    case core.TransformMode.OnlyTranslation: {
                        var rotationY = rotation + 90 + shearY;
                        m.a = core.MathUtils.cosDeg(rotation + shearX) * scaleX;
                        m.c = core.MathUtils.cosDeg(rotationY) * scaleY;
                        m.b = core.MathUtils.sinDeg(rotation + shearX) * scaleX;
                        m.d = core.MathUtils.sinDeg(rotationY) * scaleY;
                        break;
                    }
                    case core.TransformMode.NoRotationOrReflection: {
                        var s = pa * pa + pc * pc;
                        var prx = 0;
                        if (s > 0.0001) {
                            s = Math.abs(pa * pd - pb * pc) / s;
                            pb = pc * s;
                            pd = pa * s;
                            prx = Math.atan2(pc, pa) * core.MathUtils.radDeg;
                        }
                        else {
                            pa = 0;
                            pc = 0;
                            prx = 90 - Math.atan2(pd, pb) * core.MathUtils.radDeg;
                        }
                        var rx = rotation + shearX - prx;
                        var ry = rotation + shearY - prx + 90;
                        var la = core.MathUtils.cosDeg(rx) * scaleX;
                        var lb = core.MathUtils.cosDeg(ry) * scaleY;
                        var lc = core.MathUtils.sinDeg(rx) * scaleX;
                        var ld = core.MathUtils.sinDeg(ry) * scaleY;
                        m.a = pa * la - pb * lc;
                        m.c = pa * lb - pb * ld;
                        m.b = pc * la + pd * lc;
                        m.d = pc * lb + pd * ld;
                        break;
                    }
                    case core.TransformMode.NoScale:
                    case core.TransformMode.NoScaleOrReflection: {
                        var cos = core.MathUtils.cosDeg(rotation);
                        var sin = core.MathUtils.sinDeg(rotation);
                        var za = (pa * cos + pb * sin) / sx;
                        var zc = (pc * cos + pd * sin) / sy;
                        var s = Math.sqrt(za * za + zc * zc);
                        if (s > 0.00001)
                            s = 1 / s;
                        za *= s;
                        zc *= s;
                        s = Math.sqrt(za * za + zc * zc);
                        if (this.data.transformMode == core.TransformMode.NoScale
                            && (pa * pd - pb * pc < 0) != (Bone.yDown ?
                                (this.skeleton.scaleX < 0 != this.skeleton.scaleY > 0) :
                                (this.skeleton.scaleX < 0 != this.skeleton.scaleY < 0)))
                            s = -s;
                        var r = Math.PI / 2 + Math.atan2(zc, za);
                        var zb = Math.cos(r) * s;
                        var zd = Math.sin(r) * s;
                        var la = core.MathUtils.cosDeg(shearX) * scaleX;
                        var lb = core.MathUtils.cosDeg(90 + shearY) * scaleY;
                        var lc = core.MathUtils.sinDeg(shearX) * scaleX;
                        var ld = core.MathUtils.sinDeg(90 + shearY) * scaleY;
                        m.a = za * la + zb * lc;
                        m.c = za * lb + zb * ld;
                        m.b = zc * la + zd * lc;
                        m.d = zc * lb + zd * ld;
                        break;
                    }
                }
                m.a *= sx;
                m.c *= sx;
                m.b *= sy;
                m.d *= sy;
            };
            Bone.prototype.setToSetupPose = function () {
                var data = this.data;
                this.x = data.x;
                this.y = data.y;
                this.rotation = data.rotation;
                this.scaleX = data.scaleX;
                this.scaleY = data.scaleY;
                this.shearX = data.shearX;
                this.shearY = data.shearY;
            };
            Bone.prototype.getWorldRotationX = function () {
                return Math.atan2(this.matrix.b, this.matrix.a) * core.MathUtils.radDeg;
            };
            Bone.prototype.getWorldRotationY = function () {
                return Math.atan2(this.matrix.d, this.matrix.c) * core.MathUtils.radDeg;
            };
            Bone.prototype.getWorldScaleX = function () {
                var m = this.matrix;
                return Math.sqrt(m.a * m.a + m.c * m.c);
            };
            Bone.prototype.getWorldScaleY = function () {
                var m = this.matrix;
                return Math.sqrt(m.b * m.b + m.d * m.d);
            };
            Bone.prototype.updateAppliedTransform = function () {
                this.appliedValid = true;
                var parent = this.parent;
                var m = this.matrix;
                if (parent == null) {
                    this.ax = m.tx;
                    this.ay = m.ty;
                    this.arotation = Math.atan2(m.b, m.a) * core.MathUtils.radDeg;
                    this.ascaleX = Math.sqrt(m.a * m.a + m.b * m.b);
                    this.ascaleY = Math.sqrt(m.c * m.c + m.d * m.d);
                    this.ashearX = 0;
                    this.ashearY = Math.atan2(m.a * m.c + m.b * m.d, m.a * m.d - m.b * m.c) * core.MathUtils.radDeg;
                    return;
                }
                var pm = parent.matrix;
                var pid = 1 / (pm.a * pm.d - pm.b * pm.c);
                var dx = m.tx - pm.tx, dy = m.ty - pm.ty;
                this.ax = (dx * pm.d * pid - dy * pm.c * pid);
                this.ay = (dy * pm.a * pid - dx * pm.b * pid);
                var ia = pid * pm.d;
                var id = pid * pm.a;
                var ib = pid * pm.c;
                var ic = pid * pm.b;
                var ra = ia * m.a - ib * m.b;
                var rb = ia * m.c - ib * m.d;
                var rc = id * m.b - ic * m.a;
                var rd = id * m.d - ic * m.c;
                this.ashearX = 0;
                this.ascaleX = Math.sqrt(ra * ra + rc * rc);
                if (this.ascaleX > 0.0001) {
                    var det = ra * rd - rb * rc;
                    this.ascaleY = det / this.ascaleX;
                    this.ashearY = Math.atan2(ra * rb + rc * rd, det) * core.MathUtils.radDeg;
                    this.arotation = Math.atan2(rc, ra) * core.MathUtils.radDeg;
                }
                else {
                    this.ascaleX = 0;
                    this.ascaleY = Math.sqrt(rb * rb + rd * rd);
                    this.ashearY = 0;
                    this.arotation = 90 - Math.atan2(rd, rb) * core.MathUtils.radDeg;
                }
            };
            Bone.prototype.worldToLocal = function (world) {
                var m = this.matrix;
                var a = m.a, b = m.c, c = m.b, d = m.d;
                var invDet = 1 / (a * d - b * c);
                var x = world.x - m.tx, y = world.y - m.ty;
                world.x = (x * d * invDet - y * b * invDet);
                world.y = (y * a * invDet - x * c * invDet);
                return world;
            };
            Bone.prototype.localToWorld = function (local) {
                var m = this.matrix;
                var x = local.x, y = local.y;
                local.x = x * m.a + y * m.c + m.tx;
                local.y = x * m.b + y * m.d + m.ty;
                return local;
            };
            Bone.prototype.worldToLocalRotation = function (worldRotation) {
                var sin = core.MathUtils.sinDeg(worldRotation), cos = core.MathUtils.cosDeg(worldRotation);
                var mat = this.matrix;
                return Math.atan2(mat.a * sin - mat.b * cos, mat.d * cos - mat.c * sin) * core.MathUtils.radDeg;
            };
            Bone.prototype.localToWorldRotation = function (localRotation) {
                var sin = core.MathUtils.sinDeg(localRotation), cos = core.MathUtils.cosDeg(localRotation);
                var mat = this.matrix;
                return Math.atan2(cos * mat.b + sin * mat.d, cos * mat.a + sin * mat.c) * core.MathUtils.radDeg;
            };
            Bone.prototype.rotateWorld = function (degrees) {
                var mat = this.matrix;
                var a = mat.a, b = mat.c, c = mat.b, d = mat.d;
                var cos = core.MathUtils.cosDeg(degrees), sin = core.MathUtils.sinDeg(degrees);
                mat.a = cos * a - sin * c;
                mat.c = cos * b - sin * d;
                mat.b = sin * a + cos * c;
                mat.d = sin * b + cos * d;
                this.appliedValid = false;
            };
            Bone.yDown = false;
            return Bone;
        }());
        core.Bone = Bone;
    })(core = pixi_spine.core || (pixi_spine.core = {}));
})(pixi_spine || (pixi_spine = {}));
var pixi_spine;
(function (pixi_spine) {
    var core;
    (function (core) {
        var BoneData = (function () {
            function BoneData(index, name, parent) {
                this.x = 0;
                this.y = 0;
                this.rotation = 0;
                this.scaleX = 1;
                this.scaleY = 1;
                this.shearX = 0;
                this.shearY = 0;
                this.transformMode = TransformMode.Normal;
                this.skinRequired = false;
                this.color = new core.Color();
                if (index < 0)
                    throw new Error("index must be >= 0.");
                if (name == null)
                    throw new Error("name cannot be null.");
                this.index = index;
                this.name = name;
                this.parent = parent;
            }
            return BoneData;
        }());
        core.BoneData = BoneData;
        var TransformMode;
        (function (TransformMode) {
            TransformMode[TransformMode["Normal"] = 0] = "Normal";
            TransformMode[TransformMode["OnlyTranslation"] = 1] = "OnlyTranslation";
            TransformMode[TransformMode["NoRotationOrReflection"] = 2] = "NoRotationOrReflection";
            TransformMode[TransformMode["NoScale"] = 3] = "NoScale";
            TransformMode[TransformMode["NoScaleOrReflection"] = 4] = "NoScaleOrReflection";
        })(TransformMode = core.TransformMode || (core.TransformMode = {}));
    })(core = pixi_spine.core || (pixi_spine.core = {}));
})(pixi_spine || (pixi_spine = {}));
var pixi_spine;
(function (pixi_spine) {
    var core;
    (function (core) {
        var ConstraintData = (function () {
            function ConstraintData(name, order, skinRequired) {
                this.name = name;
                this.order = order;
                this.skinRequired = skinRequired;
            }
            return ConstraintData;
        }());
        core.ConstraintData = ConstraintData;
    })(core = pixi_spine.core || (pixi_spine.core = {}));
})(pixi_spine || (pixi_spine = {}));
var pixi_spine;
(function (pixi_spine) {
    var core;
    (function (core) {
        var Event = (function () {
            function Event(time, data) {
                if (data == null)
                    throw new Error("data cannot be null.");
                this.time = time;
                this.data = data;
            }
            return Event;
        }());
        core.Event = Event;
    })(core = pixi_spine.core || (pixi_spine.core = {}));
})(pixi_spine || (pixi_spine = {}));
var pixi_spine;
(function (pixi_spine) {
    var core;
    (function (core) {
        var EventData = (function () {
            function EventData(name) {
                this.name = name;
            }
            return EventData;
        }());
        core.EventData = EventData;
    })(core = pixi_spine.core || (pixi_spine.core = {}));
})(pixi_spine || (pixi_spine = {}));
var pixi_spine;
(function (pixi_spine) {
    var core;
    (function (core) {
        var IkConstraint = (function () {
            function IkConstraint(data, skeleton) {
                this.bendDirection = 0;
                this.compress = false;
                this.stretch = false;
                this.mix = 1;
                this.softness = 0;
                this.active = false;
                if (data == null)
                    throw new Error("data cannot be null.");
                if (skeleton == null)
                    throw new Error("skeleton cannot be null.");
                this.data = data;
                this.mix = data.mix;
                this.softness = data.softness;
                this.bendDirection = data.bendDirection;
                this.compress = data.compress;
                this.stretch = data.stretch;
                this.bones = new Array();
                for (var i = 0; i < data.bones.length; i++)
                    this.bones.push(skeleton.findBone(data.bones[i].name));
                this.target = skeleton.findBone(data.target.name);
            }
            IkConstraint.prototype.isActive = function () {
                return this.active;
            };
            IkConstraint.prototype.apply = function () {
                this.update();
            };
            IkConstraint.prototype.update = function () {
                var target = this.target;
                var bones = this.bones;
                switch (bones.length) {
                    case 1:
                        this.apply1(bones[0], target.worldX, target.worldY, this.compress, this.stretch, this.data.uniform, this.mix);
                        break;
                    case 2:
                        this.apply2(bones[0], bones[1], target.worldX, target.worldY, this.bendDirection, this.stretch, this.softness, this.mix);
                        break;
                }
            };
            IkConstraint.prototype.apply1 = function (bone, targetX, targetY, compress, stretch, uniform, alpha) {
                if (!bone.appliedValid)
                    bone.updateAppliedTransform();
                var p = bone.parent.matrix;
                var id = 1 / (p.a * p.d - p.b * p.c);
                var x = targetX - p.tx, y = targetY - p.ty;
                var tx = (x * p.d - y * p.c) * id - bone.ax, ty = (y * p.a - x * p.b) * id - bone.ay;
                var rotationIK = Math.atan2(ty, tx) * core.MathUtils.radDeg - bone.ashearX - bone.arotation;
                if (bone.ascaleX < 0)
                    rotationIK += 180;
                if (rotationIK > 180)
                    rotationIK -= 360;
                else if (rotationIK < -180)
                    rotationIK += 360;
                var sx = bone.ascaleX, sy = bone.ascaleY;
                if (compress || stretch) {
                    var b = bone.data.length * sx, dd = Math.sqrt(tx * tx + ty * ty);
                    if ((compress && dd < b) || (stretch && dd > b) && b > 0.0001) {
                        var s = (dd / b - 1) * alpha + 1;
                        sx *= s;
                        if (uniform)
                            sy *= s;
                    }
                }
                bone.updateWorldTransformWith(bone.ax, bone.ay, bone.arotation + rotationIK * alpha, sx, sy, bone.ashearX, bone.ashearY);
            };
            IkConstraint.prototype.apply2 = function (parent, child, targetX, targetY, bendDir, stretch, softness, alpha) {
                if (alpha == 0) {
                    child.updateWorldTransform();
                    return;
                }
                if (!parent.appliedValid)
                    parent.updateAppliedTransform();
                if (!child.appliedValid)
                    child.updateAppliedTransform();
                var px = parent.ax, py = parent.ay, psx = parent.ascaleX, sx = psx, psy = parent.ascaleY, csx = child.ascaleX;
                var pmat = parent.matrix;
                var os1 = 0, os2 = 0, s2 = 0;
                if (psx < 0) {
                    psx = -psx;
                    os1 = 180;
                    s2 = -1;
                }
                else {
                    os1 = 0;
                    s2 = 1;
                }
                if (psy < 0) {
                    psy = -psy;
                    s2 = -s2;
                }
                if (csx < 0) {
                    csx = -csx;
                    os2 = 180;
                }
                else
                    os2 = 0;
                var cx = child.ax, cy = 0, cwx = 0, cwy = 0, a = pmat.a, b = pmat.c, c = pmat.b, d = pmat.d;
                var u = Math.abs(psx - psy) <= 0.0001;
                if (!u) {
                    cy = 0;
                    cwx = a * cx + pmat.tx;
                    cwy = c * cx + pmat.ty;
                }
                else {
                    cy = child.ay;
                    cwx = a * cx + b * cy + pmat.tx;
                    cwy = c * cx + d * cy + pmat.ty;
                }
                var pp = parent.parent.matrix;
                a = pp.a;
                b = pp.c;
                c = pp.b;
                d = pp.d;
                var id = 1 / (a * d - b * c), x = cwx - pp.tx, y = cwy - pp.ty;
                var dx = (x * d - y * b) * id - px, dy = (y * a - x * c) * id - py;
                var l1 = Math.sqrt(dx * dx + dy * dy), l2 = child.data.length * csx, a1, a2;
                if (l1 < 0.0001) {
                    this.apply1(parent, targetX, targetY, false, stretch, false, alpha);
                    child.updateWorldTransformWith(cx, cy, 0, child.ascaleX, child.ascaleY, child.ashearX, child.ashearY);
                    return;
                }
                x = targetX - pp.tx;
                y = targetY - pp.ty;
                var tx = (x * d - y * b) * id - px, ty = (y * a - x * c) * id - py;
                var dd = tx * tx + ty * ty;
                if (softness != 0) {
                    softness *= psx * (csx + 1) / 2;
                    var td = Math.sqrt(dd), sd = td - l1 - l2 * psx + softness;
                    if (sd > 0) {
                        var p = Math.min(1, sd / (softness * 2)) - 1;
                        p = (sd - softness * (1 - p * p)) / td;
                        tx -= p * tx;
                        ty -= p * ty;
                        dd = tx * tx + ty * ty;
                    }
                }
                outer: if (u) {
                    l2 *= psx;
                    var cos = (dd - l1 * l1 - l2 * l2) / (2 * l1 * l2);
                    if (cos < -1)
                        cos = -1;
                    else if (cos > 1) {
                        cos = 1;
                        if (stretch)
                            sx *= (Math.sqrt(dd) / (l1 + l2) - 1) * alpha + 1;
                    }
                    a2 = Math.acos(cos) * bendDir;
                    a = l1 + l2 * cos;
                    b = l2 * Math.sin(a2);
                    a1 = Math.atan2(ty * a - tx * b, tx * a + ty * b);
                }
                else {
                    a = psx * l2;
                    b = psy * l2;
                    var aa = a * a, bb = b * b, ta = Math.atan2(ty, tx);
                    c = bb * l1 * l1 + aa * dd - aa * bb;
                    var c1 = -2 * bb * l1, c2 = bb - aa;
                    d = c1 * c1 - 4 * c2 * c;
                    if (d >= 0) {
                        var q = Math.sqrt(d);
                        if (c1 < 0)
                            q = -q;
                        q = -(c1 + q) / 2;
                        var r0 = q / c2, r1 = c / q;
                        var r = Math.abs(r0) < Math.abs(r1) ? r0 : r1;
                        if (r * r <= dd) {
                            y = Math.sqrt(dd - r * r) * bendDir;
                            a1 = ta - Math.atan2(y, r);
                            a2 = Math.atan2(y / psy, (r - l1) / psx);
                            break outer;
                        }
                    }
                    var minAngle = core.MathUtils.PI, minX = l1 - a, minDist = minX * minX, minY = 0;
                    var maxAngle = 0, maxX = l1 + a, maxDist = maxX * maxX, maxY = 0;
                    c = -a * l1 / (aa - bb);
                    if (c >= -1 && c <= 1) {
                        c = Math.acos(c);
                        x = a * Math.cos(c) + l1;
                        y = b * Math.sin(c);
                        d = x * x + y * y;
                        if (d < minDist) {
                            minAngle = c;
                            minDist = d;
                            minX = x;
                            minY = y;
                        }
                        if (d > maxDist) {
                            maxAngle = c;
                            maxDist = d;
                            maxX = x;
                            maxY = y;
                        }
                    }
                    if (dd <= (minDist + maxDist) / 2) {
                        a1 = ta - Math.atan2(minY * bendDir, minX);
                        a2 = minAngle * bendDir;
                    }
                    else {
                        a1 = ta - Math.atan2(maxY * bendDir, maxX);
                        a2 = maxAngle * bendDir;
                    }
                }
                var os = Math.atan2(cy, cx) * s2;
                var rotation = parent.arotation;
                a1 = (a1 - os) * core.MathUtils.radDeg + os1 - rotation;
                if (a1 > 180)
                    a1 -= 360;
                else if (a1 < -180)
                    a1 += 360;
                parent.updateWorldTransformWith(px, py, rotation + a1 * alpha, sx, parent.ascaleY, 0, 0);
                rotation = child.arotation;
                a2 = ((a2 + os) * core.MathUtils.radDeg - child.ashearX) * s2 + os2 - rotation;
                if (a2 > 180)
                    a2 -= 360;
                else if (a2 < -180)
                    a2 += 360;
                child.updateWorldTransformWith(cx, cy, rotation + a2 * alpha, child.ascaleX, child.ascaleY, child.ashearX, child.ashearY);
            };
            return IkConstraint;
        }());
        core.IkConstraint = IkConstraint;
    })(core = pixi_spine.core || (pixi_spine.core = {}));
})(pixi_spine || (pixi_spine = {}));
var pixi_spine;
(function (pixi_spine) {
    var core;
    (function (core) {
        var IkConstraintData = (function (_super) {
            __extends(IkConstraintData, _super);
            function IkConstraintData(name) {
                var _this = _super.call(this, name, 0, false) || this;
                _this.bones = new Array();
                _this.bendDirection = 1;
                _this.compress = false;
                _this.stretch = false;
                _this.uniform = false;
                _this.mix = 1;
                _this.softness = 0;
                return _this;
            }
            return IkConstraintData;
        }(core.ConstraintData));
        core.IkConstraintData = IkConstraintData;
    })(core = pixi_spine.core || (pixi_spine.core = {}));
})(pixi_spine || (pixi_spine = {}));
var pixi_spine;
(function (pixi_spine) {
    var core;
    (function (core) {
        var PathConstraint = (function () {
            function PathConstraint(data, skeleton) {
                this.position = 0;
                this.spacing = 0;
                this.rotateMix = 0;
                this.translateMix = 0;
                this.spaces = new Array();
                this.positions = new Array();
                this.world = new Array();
                this.curves = new Array();
                this.lengths = new Array();
                this.segments = new Array();
                this.active = false;
                if (data == null)
                    throw new Error("data cannot be null.");
                if (skeleton == null)
                    throw new Error("skeleton cannot be null.");
                this.data = data;
                this.bones = new Array();
                for (var i = 0, n = data.bones.length; i < n; i++)
                    this.bones.push(skeleton.findBone(data.bones[i].name));
                this.target = skeleton.findSlot(data.target.name);
                this.position = data.position;
                this.spacing = data.spacing;
                this.rotateMix = data.rotateMix;
                this.translateMix = data.translateMix;
            }
            PathConstraint.prototype.isActive = function () {
                return this.active;
            };
            PathConstraint.prototype.apply = function () {
                this.update();
            };
            PathConstraint.prototype.update = function () {
                var attachment = this.target.getAttachment();
                if (!(attachment instanceof core.PathAttachment))
                    return;
                var rotateMix = this.rotateMix, translateMix = this.translateMix;
                var translate = translateMix > 0, rotate = rotateMix > 0;
                if (!translate && !rotate)
                    return;
                var data = this.data;
                var spacingMode = data.spacingMode;
                var lengthSpacing = spacingMode == core.SpacingMode.Length;
                var rotateMode = data.rotateMode;
                var tangents = rotateMode == core.RotateMode.Tangent, scale = rotateMode == core.RotateMode.ChainScale;
                var boneCount = this.bones.length, spacesCount = tangents ? boneCount : boneCount + 1;
                var bones = this.bones;
                var spaces = core.Utils.setArraySize(this.spaces, spacesCount), lengths = null;
                var spacing = this.spacing;
                if (scale || lengthSpacing) {
                    if (scale)
                        lengths = core.Utils.setArraySize(this.lengths, boneCount);
                    for (var i = 0, n = spacesCount - 1; i < n;) {
                        var bone = bones[i];
                        var setupLength = bone.data.length;
                        if (setupLength < PathConstraint.epsilon) {
                            if (scale)
                                lengths[i] = 0;
                            spaces[++i] = 0;
                        }
                        else {
                            var x = setupLength * bone.matrix.a, y = setupLength * bone.matrix.b;
                            var length_1 = Math.sqrt(x * x + y * y);
                            if (scale)
                                lengths[i] = length_1;
                            spaces[++i] = (lengthSpacing ? setupLength + spacing : spacing) * length_1 / setupLength;
                        }
                    }
                }
                else {
                    for (var i = 1; i < spacesCount; i++)
                        spaces[i] = spacing;
                }
                var positions = this.computeWorldPositions(attachment, spacesCount, tangents, data.positionMode == core.PositionMode.Percent, spacingMode == core.SpacingMode.Percent);
                var boneX = positions[0], boneY = positions[1], offsetRotation = data.offsetRotation;
                var tip = false;
                if (offsetRotation == 0)
                    tip = rotateMode == core.RotateMode.Chain;
                else {
                    tip = false;
                    var p = this.target.bone.matrix;
                    offsetRotation *= p.a * p.d - p.b * p.c > 0 ? core.MathUtils.degRad : -core.MathUtils.degRad;
                }
                for (var i = 0, p = 3; i < boneCount; i++, p += 3) {
                    var bone = bones[i];
                    var mat = bone.matrix;
                    mat.tx += (boneX - mat.tx) * translateMix;
                    mat.ty += (boneY - mat.ty) * translateMix;
                    var x = positions[p], y = positions[p + 1], dx = x - boneX, dy = y - boneY;
                    if (scale) {
                        var length_2 = lengths[i];
                        if (length_2 != 0) {
                            var s = (Math.sqrt(dx * dx + dy * dy) / length_2 - 1) * rotateMix + 1;
                            mat.a *= s;
                            mat.b *= s;
                        }
                    }
                    boneX = x;
                    boneY = y;
                    if (rotate) {
                        var a = mat.a, b = mat.c, c = mat.b, d = mat.d, r = 0, cos = 0, sin = 0;
                        if (tangents)
                            r = positions[p - 1];
                        else if (spaces[i + 1] == 0)
                            r = positions[p + 2];
                        else
                            r = Math.atan2(dy, dx);
                        r -= Math.atan2(c, a);
                        if (tip) {
                            cos = Math.cos(r);
                            sin = Math.sin(r);
                            var length_3 = bone.data.length;
                            boneX += (length_3 * (cos * a - sin * c) - dx) * rotateMix;
                            boneY += (length_3 * (sin * a + cos * c) - dy) * rotateMix;
                        }
                        else {
                            r += offsetRotation;
                        }
                        if (r > core.MathUtils.PI)
                            r -= core.MathUtils.PI2;
                        else if (r < -core.MathUtils.PI)
                            r += core.MathUtils.PI2;
                        r *= rotateMix;
                        cos = Math.cos(r);
                        sin = Math.sin(r);
                        mat.a = cos * a - sin * c;
                        mat.c = cos * b - sin * d;
                        mat.b = sin * a + cos * c;
                        mat.d = sin * b + cos * d;
                    }
                    bone.appliedValid = false;
                }
            };
            PathConstraint.prototype.computeWorldPositions = function (path, spacesCount, tangents, percentPosition, percentSpacing) {
                var target = this.target;
                var position = this.position;
                var spaces = this.spaces, out = core.Utils.setArraySize(this.positions, spacesCount * 3 + 2), world = null;
                var closed = path.closed;
                var verticesLength = path.worldVerticesLength, curveCount = verticesLength / 6, prevCurve = PathConstraint.NONE;
                if (!path.constantSpeed) {
                    var lengths = path.lengths;
                    curveCount -= closed ? 1 : 2;
                    var pathLength_1 = lengths[curveCount];
                    if (percentPosition)
                        position *= pathLength_1;
                    if (percentSpacing) {
                        for (var i = 0; i < spacesCount; i++)
                            spaces[i] *= pathLength_1;
                    }
                    world = core.Utils.setArraySize(this.world, 8);
                    for (var i = 0, o = 0, curve = 0; i < spacesCount; i++, o += 3) {
                        var space = spaces[i];
                        position += space;
                        var p = position;
                        if (closed) {
                            p %= pathLength_1;
                            if (p < 0)
                                p += pathLength_1;
                            curve = 0;
                        }
                        else if (p < 0) {
                            if (prevCurve != PathConstraint.BEFORE) {
                                prevCurve = PathConstraint.BEFORE;
                                path.computeWorldVertices(target, 2, 4, world, 0, 2);
                            }
                            this.addBeforePosition(p, world, 0, out, o);
                            continue;
                        }
                        else if (p > pathLength_1) {
                            if (prevCurve != PathConstraint.AFTER) {
                                prevCurve = PathConstraint.AFTER;
                                path.computeWorldVertices(target, verticesLength - 6, 4, world, 0, 2);
                            }
                            this.addAfterPosition(p - pathLength_1, world, 0, out, o);
                            continue;
                        }
                        for (;; curve++) {
                            var length_4 = lengths[curve];
                            if (p > length_4)
                                continue;
                            if (curve == 0)
                                p /= length_4;
                            else {
                                var prev = lengths[curve - 1];
                                p = (p - prev) / (length_4 - prev);
                            }
                            break;
                        }
                        if (curve != prevCurve) {
                            prevCurve = curve;
                            if (closed && curve == curveCount) {
                                path.computeWorldVertices(target, verticesLength - 4, 4, world, 0, 2);
                                path.computeWorldVertices(target, 0, 4, world, 4, 2);
                            }
                            else
                                path.computeWorldVertices(target, curve * 6 + 2, 8, world, 0, 2);
                        }
                        this.addCurvePosition(p, world[0], world[1], world[2], world[3], world[4], world[5], world[6], world[7], out, o, tangents || (i > 0 && space == 0));
                    }
                    return out;
                }
                if (closed) {
                    verticesLength += 2;
                    world = core.Utils.setArraySize(this.world, verticesLength);
                    path.computeWorldVertices(target, 2, verticesLength - 4, world, 0, 2);
                    path.computeWorldVertices(target, 0, 2, world, verticesLength - 4, 2);
                    world[verticesLength - 2] = world[0];
                    world[verticesLength - 1] = world[1];
                }
                else {
                    curveCount--;
                    verticesLength -= 4;
                    world = core.Utils.setArraySize(this.world, verticesLength);
                    path.computeWorldVertices(target, 2, verticesLength, world, 0, 2);
                }
                var curves = core.Utils.setArraySize(this.curves, curveCount);
                var pathLength = 0;
                var x1 = world[0], y1 = world[1], cx1 = 0, cy1 = 0, cx2 = 0, cy2 = 0, x2 = 0, y2 = 0;
                var tmpx = 0, tmpy = 0, dddfx = 0, dddfy = 0, ddfx = 0, ddfy = 0, dfx = 0, dfy = 0;
                for (var i = 0, w = 2; i < curveCount; i++, w += 6) {
                    cx1 = world[w];
                    cy1 = world[w + 1];
                    cx2 = world[w + 2];
                    cy2 = world[w + 3];
                    x2 = world[w + 4];
                    y2 = world[w + 5];
                    tmpx = (x1 - cx1 * 2 + cx2) * 0.1875;
                    tmpy = (y1 - cy1 * 2 + cy2) * 0.1875;
                    dddfx = ((cx1 - cx2) * 3 - x1 + x2) * 0.09375;
                    dddfy = ((cy1 - cy2) * 3 - y1 + y2) * 0.09375;
                    ddfx = tmpx * 2 + dddfx;
                    ddfy = tmpy * 2 + dddfy;
                    dfx = (cx1 - x1) * 0.75 + tmpx + dddfx * 0.16666667;
                    dfy = (cy1 - y1) * 0.75 + tmpy + dddfy * 0.16666667;
                    pathLength += Math.sqrt(dfx * dfx + dfy * dfy);
                    dfx += ddfx;
                    dfy += ddfy;
                    ddfx += dddfx;
                    ddfy += dddfy;
                    pathLength += Math.sqrt(dfx * dfx + dfy * dfy);
                    dfx += ddfx;
                    dfy += ddfy;
                    pathLength += Math.sqrt(dfx * dfx + dfy * dfy);
                    dfx += ddfx + dddfx;
                    dfy += ddfy + dddfy;
                    pathLength += Math.sqrt(dfx * dfx + dfy * dfy);
                    curves[i] = pathLength;
                    x1 = x2;
                    y1 = y2;
                }
                if (percentPosition)
                    position *= pathLength;
                if (percentSpacing) {
                    for (var i = 0; i < spacesCount; i++)
                        spaces[i] *= pathLength;
                }
                var segments = this.segments;
                var curveLength = 0;
                for (var i = 0, o = 0, curve = 0, segment = 0; i < spacesCount; i++, o += 3) {
                    var space = spaces[i];
                    position += space;
                    var p = position;
                    if (closed) {
                        p %= pathLength;
                        if (p < 0)
                            p += pathLength;
                        curve = 0;
                    }
                    else if (p < 0) {
                        this.addBeforePosition(p, world, 0, out, o);
                        continue;
                    }
                    else if (p > pathLength) {
                        this.addAfterPosition(p - pathLength, world, verticesLength - 4, out, o);
                        continue;
                    }
                    for (;; curve++) {
                        var length_5 = curves[curve];
                        if (p > length_5)
                            continue;
                        if (curve == 0)
                            p /= length_5;
                        else {
                            var prev = curves[curve - 1];
                            p = (p - prev) / (length_5 - prev);
                        }
                        break;
                    }
                    if (curve != prevCurve) {
                        prevCurve = curve;
                        var ii = curve * 6;
                        x1 = world[ii];
                        y1 = world[ii + 1];
                        cx1 = world[ii + 2];
                        cy1 = world[ii + 3];
                        cx2 = world[ii + 4];
                        cy2 = world[ii + 5];
                        x2 = world[ii + 6];
                        y2 = world[ii + 7];
                        tmpx = (x1 - cx1 * 2 + cx2) * 0.03;
                        tmpy = (y1 - cy1 * 2 + cy2) * 0.03;
                        dddfx = ((cx1 - cx2) * 3 - x1 + x2) * 0.006;
                        dddfy = ((cy1 - cy2) * 3 - y1 + y2) * 0.006;
                        ddfx = tmpx * 2 + dddfx;
                        ddfy = tmpy * 2 + dddfy;
                        dfx = (cx1 - x1) * 0.3 + tmpx + dddfx * 0.16666667;
                        dfy = (cy1 - y1) * 0.3 + tmpy + dddfy * 0.16666667;
                        curveLength = Math.sqrt(dfx * dfx + dfy * dfy);
                        segments[0] = curveLength;
                        for (ii = 1; ii < 8; ii++) {
                            dfx += ddfx;
                            dfy += ddfy;
                            ddfx += dddfx;
                            ddfy += dddfy;
                            curveLength += Math.sqrt(dfx * dfx + dfy * dfy);
                            segments[ii] = curveLength;
                        }
                        dfx += ddfx;
                        dfy += ddfy;
                        curveLength += Math.sqrt(dfx * dfx + dfy * dfy);
                        segments[8] = curveLength;
                        dfx += ddfx + dddfx;
                        dfy += ddfy + dddfy;
                        curveLength += Math.sqrt(dfx * dfx + dfy * dfy);
                        segments[9] = curveLength;
                        segment = 0;
                    }
                    p *= curveLength;
                    for (;; segment++) {
                        var length_6 = segments[segment];
                        if (p > length_6)
                            continue;
                        if (segment == 0)
                            p /= length_6;
                        else {
                            var prev = segments[segment - 1];
                            p = segment + (p - prev) / (length_6 - prev);
                        }
                        break;
                    }
                    this.addCurvePosition(p * 0.1, x1, y1, cx1, cy1, cx2, cy2, x2, y2, out, o, tangents || (i > 0 && space == 0));
                }
                return out;
            };
            PathConstraint.prototype.addBeforePosition = function (p, temp, i, out, o) {
                var x1 = temp[i], y1 = temp[i + 1], dx = temp[i + 2] - x1, dy = temp[i + 3] - y1, r = Math.atan2(dy, dx);
                out[o] = x1 + p * Math.cos(r);
                out[o + 1] = y1 + p * Math.sin(r);
                out[o + 2] = r;
            };
            PathConstraint.prototype.addAfterPosition = function (p, temp, i, out, o) {
                var x1 = temp[i + 2], y1 = temp[i + 3], dx = x1 - temp[i], dy = y1 - temp[i + 1], r = Math.atan2(dy, dx);
                out[o] = x1 + p * Math.cos(r);
                out[o + 1] = y1 + p * Math.sin(r);
                out[o + 2] = r;
            };
            PathConstraint.prototype.addCurvePosition = function (p, x1, y1, cx1, cy1, cx2, cy2, x2, y2, out, o, tangents) {
                if (p == 0 || isNaN(p))
                    p = 0.0001;
                var tt = p * p, ttt = tt * p, u = 1 - p, uu = u * u, uuu = uu * u;
                var ut = u * p, ut3 = ut * 3, uut3 = u * ut3, utt3 = ut3 * p;
                var x = x1 * uuu + cx1 * uut3 + cx2 * utt3 + x2 * ttt, y = y1 * uuu + cy1 * uut3 + cy2 * utt3 + y2 * ttt;
                out[o] = x;
                out[o + 1] = y;
                if (tangents)
                    out[o + 2] = Math.atan2(y - (y1 * uu + cy1 * ut * 2 + cy2 * tt), x - (x1 * uu + cx1 * ut * 2 + cx2 * tt));
            };
            PathConstraint.NONE = -1;
            PathConstraint.BEFORE = -2;
            PathConstraint.AFTER = -3;
            PathConstraint.epsilon = 0.00001;
            return PathConstraint;
        }());
        core.PathConstraint = PathConstraint;
    })(core = pixi_spine.core || (pixi_spine.core = {}));
})(pixi_spine || (pixi_spine = {}));
var pixi_spine;
(function (pixi_spine) {
    var core;
    (function (core) {
        var PathConstraintData = (function (_super) {
            __extends(PathConstraintData, _super);
            function PathConstraintData(name) {
                var _this = _super.call(this, name, 0, false) || this;
                _this.bones = new Array();
                return _this;
            }
            return PathConstraintData;
        }(core.ConstraintData));
        core.PathConstraintData = PathConstraintData;
        var PositionMode;
        (function (PositionMode) {
            PositionMode[PositionMode["Fixed"] = 0] = "Fixed";
            PositionMode[PositionMode["Percent"] = 1] = "Percent";
        })(PositionMode = core.PositionMode || (core.PositionMode = {}));
        var SpacingMode;
        (function (SpacingMode) {
            SpacingMode[SpacingMode["Length"] = 0] = "Length";
            SpacingMode[SpacingMode["Fixed"] = 1] = "Fixed";
            SpacingMode[SpacingMode["Percent"] = 2] = "Percent";
        })(SpacingMode = core.SpacingMode || (core.SpacingMode = {}));
        var RotateMode;
        (function (RotateMode) {
            RotateMode[RotateMode["Tangent"] = 0] = "Tangent";
            RotateMode[RotateMode["Chain"] = 1] = "Chain";
            RotateMode[RotateMode["ChainScale"] = 2] = "ChainScale";
        })(RotateMode = core.RotateMode || (core.RotateMode = {}));
    })(core = pixi_spine.core || (pixi_spine.core = {}));
})(pixi_spine || (pixi_spine = {}));
var pixi_spine;
(function (pixi_spine) {
    var core;
    (function (core) {
        var Skeleton = (function () {
            function Skeleton(data) {
                this._updateCache = new Array();
                this.updateCacheReset = new Array();
                this.time = 0;
                this.scaleX = 1;
                this.scaleY = 1;
                this.x = 0;
                this.y = 0;
                if (data == null)
                    throw new Error("data cannot be null.");
                this.data = data;
                this.bones = new Array();
                for (var i = 0; i < data.bones.length; i++) {
                    var boneData = data.bones[i];
                    var bone = void 0;
                    if (boneData.parent == null)
                        bone = new core.Bone(boneData, this, null);
                    else {
                        var parent_1 = this.bones[boneData.parent.index];
                        bone = new core.Bone(boneData, this, parent_1);
                        parent_1.children.push(bone);
                    }
                    this.bones.push(bone);
                }
                this.slots = new Array();
                this.drawOrder = new Array();
                for (var i = 0; i < data.slots.length; i++) {
                    var slotData = data.slots[i];
                    var bone = this.bones[slotData.boneData.index];
                    var slot = new core.Slot(slotData, bone);
                    this.slots.push(slot);
                    this.drawOrder.push(slot);
                }
                this.ikConstraints = new Array();
                for (var i = 0; i < data.ikConstraints.length; i++) {
                    var ikConstraintData = data.ikConstraints[i];
                    this.ikConstraints.push(new core.IkConstraint(ikConstraintData, this));
                }
                this.transformConstraints = new Array();
                for (var i = 0; i < data.transformConstraints.length; i++) {
                    var transformConstraintData = data.transformConstraints[i];
                    this.transformConstraints.push(new core.TransformConstraint(transformConstraintData, this));
                }
                this.pathConstraints = new Array();
                for (var i = 0; i < data.pathConstraints.length; i++) {
                    var pathConstraintData = data.pathConstraints[i];
                    this.pathConstraints.push(new core.PathConstraint(pathConstraintData, this));
                }
                this.color = new core.Color(1, 1, 1, 1);
                this.updateCache();
            }
            Skeleton.prototype.updateCache = function () {
                var updateCache = this._updateCache;
                updateCache.length = 0;
                this.updateCacheReset.length = 0;
                var bones = this.bones;
                for (var i = 0, n = bones.length; i < n; i++) {
                    var bone = bones[i];
                    bone.sorted = bone.data.skinRequired;
                    bone.active = !bone.sorted;
                }
                if (this.skin != null) {
                    var skinBones = this.skin.bones;
                    for (var i = 0, n = this.skin.bones.length; i < n; i++) {
                        var bone = this.bones[skinBones[i].index];
                        do {
                            bone.sorted = false;
                            bone.active = true;
                            bone = bone.parent;
                        } while (bone != null);
                    }
                }
                var ikConstraints = this.ikConstraints;
                var transformConstraints = this.transformConstraints;
                var pathConstraints = this.pathConstraints;
                var ikCount = ikConstraints.length, transformCount = transformConstraints.length, pathCount = pathConstraints.length;
                var constraintCount = ikCount + transformCount + pathCount;
                outer: for (var i = 0; i < constraintCount; i++) {
                    for (var ii = 0; ii < ikCount; ii++) {
                        var constraint = ikConstraints[ii];
                        if (constraint.data.order == i) {
                            this.sortIkConstraint(constraint);
                            continue outer;
                        }
                    }
                    for (var ii = 0; ii < transformCount; ii++) {
                        var constraint = transformConstraints[ii];
                        if (constraint.data.order == i) {
                            this.sortTransformConstraint(constraint);
                            continue outer;
                        }
                    }
                    for (var ii = 0; ii < pathCount; ii++) {
                        var constraint = pathConstraints[ii];
                        if (constraint.data.order == i) {
                            this.sortPathConstraint(constraint);
                            continue outer;
                        }
                    }
                }
                for (var i = 0, n = bones.length; i < n; i++)
                    this.sortBone(bones[i]);
            };
            Skeleton.prototype.sortIkConstraint = function (constraint) {
                constraint.active = constraint.target.isActive() && (!constraint.data.skinRequired || (this.skin != null && core.Utils.contains(this.skin.constraints, constraint.data, true)));
                if (!constraint.active)
                    return;
                var target = constraint.target;
                this.sortBone(target);
                var constrained = constraint.bones;
                var parent = constrained[0];
                this.sortBone(parent);
                if (constrained.length > 1) {
                    var child = constrained[constrained.length - 1];
                    if (!(this._updateCache.indexOf(child) > -1))
                        this.updateCacheReset.push(child);
                }
                this._updateCache.push(constraint);
                this.sortReset(parent.children);
                constrained[constrained.length - 1].sorted = true;
            };
            Skeleton.prototype.sortPathConstraint = function (constraint) {
                constraint.active = constraint.target.bone.isActive() && (!constraint.data.skinRequired || (this.skin != null && core.Utils.contains(this.skin.constraints, constraint.data, true)));
                if (!constraint.active)
                    return;
                var slot = constraint.target;
                var slotIndex = slot.data.index;
                var slotBone = slot.bone;
                if (this.skin != null)
                    this.sortPathConstraintAttachment(this.skin, slotIndex, slotBone);
                if (this.data.defaultSkin != null && this.data.defaultSkin != this.skin)
                    this.sortPathConstraintAttachment(this.data.defaultSkin, slotIndex, slotBone);
                for (var i = 0, n = this.data.skins.length; i < n; i++)
                    this.sortPathConstraintAttachment(this.data.skins[i], slotIndex, slotBone);
                var attachment = slot.getAttachment();
                if (attachment instanceof core.PathAttachment)
                    this.sortPathConstraintAttachmentWith(attachment, slotBone);
                var constrained = constraint.bones;
                var boneCount = constrained.length;
                for (var i = 0; i < boneCount; i++)
                    this.sortBone(constrained[i]);
                this._updateCache.push(constraint);
                for (var i = 0; i < boneCount; i++)
                    this.sortReset(constrained[i].children);
                for (var i = 0; i < boneCount; i++)
                    constrained[i].sorted = true;
            };
            Skeleton.prototype.sortTransformConstraint = function (constraint) {
                constraint.active = constraint.target.isActive() && (!constraint.data.skinRequired || (this.skin != null && core.Utils.contains(this.skin.constraints, constraint.data, true)));
                if (!constraint.active)
                    return;
                this.sortBone(constraint.target);
                var constrained = constraint.bones;
                var boneCount = constrained.length;
                if (constraint.data.local) {
                    for (var i = 0; i < boneCount; i++) {
                        var child = constrained[i];
                        this.sortBone(child.parent);
                        if (!(this._updateCache.indexOf(child) > -1))
                            this.updateCacheReset.push(child);
                    }
                }
                else {
                    for (var i = 0; i < boneCount; i++) {
                        this.sortBone(constrained[i]);
                    }
                }
                this._updateCache.push(constraint);
                for (var ii = 0; ii < boneCount; ii++)
                    this.sortReset(constrained[ii].children);
                for (var ii = 0; ii < boneCount; ii++)
                    constrained[ii].sorted = true;
            };
            Skeleton.prototype.sortPathConstraintAttachment = function (skin, slotIndex, slotBone) {
                var attachments = skin.attachments[slotIndex];
                if (!attachments)
                    return;
                for (var key in attachments) {
                    this.sortPathConstraintAttachmentWith(attachments[key], slotBone);
                }
            };
            Skeleton.prototype.sortPathConstraintAttachmentWith = function (attachment, slotBone) {
                if (!(attachment instanceof core.PathAttachment))
                    return;
                var pathBones = attachment.bones;
                if (pathBones == null)
                    this.sortBone(slotBone);
                else {
                    var bones = this.bones;
                    var i = 0;
                    while (i < pathBones.length) {
                        var boneCount = pathBones[i++];
                        for (var n = i + boneCount; i < n; i++) {
                            var boneIndex = pathBones[i];
                            this.sortBone(bones[boneIndex]);
                        }
                    }
                }
            };
            Skeleton.prototype.sortBone = function (bone) {
                if (bone.sorted)
                    return;
                var parent = bone.parent;
                if (parent != null)
                    this.sortBone(parent);
                bone.sorted = true;
                this._updateCache.push(bone);
            };
            Skeleton.prototype.sortReset = function (bones) {
                for (var i = 0, n = bones.length; i < n; i++) {
                    var bone = bones[i];
                    if (!bone.active)
                        continue;
                    if (bone.sorted)
                        this.sortReset(bone.children);
                    bone.sorted = false;
                }
            };
            Skeleton.prototype.updateWorldTransform = function () {
                var updateCacheReset = this.updateCacheReset;
                for (var i = 0, n = updateCacheReset.length; i < n; i++) {
                    var bone = updateCacheReset[i];
                    bone.ax = bone.x;
                    bone.ay = bone.y;
                    bone.arotation = bone.rotation;
                    bone.ascaleX = bone.scaleX;
                    bone.ascaleY = bone.scaleY;
                    bone.ashearX = bone.shearX;
                    bone.ashearY = bone.shearY;
                    bone.appliedValid = true;
                }
                var updateCache = this._updateCache;
                for (var i = 0, n = updateCache.length; i < n; i++)
                    updateCache[i].update();
            };
            Skeleton.prototype.setToSetupPose = function () {
                this.setBonesToSetupPose();
                this.setSlotsToSetupPose();
            };
            Skeleton.prototype.setBonesToSetupPose = function () {
                var bones = this.bones;
                for (var i = 0, n = bones.length; i < n; i++)
                    bones[i].setToSetupPose();
                var ikConstraints = this.ikConstraints;
                for (var i = 0, n = ikConstraints.length; i < n; i++) {
                    var constraint = ikConstraints[i];
                    constraint.mix = constraint.data.mix;
                    constraint.softness = constraint.data.softness;
                    constraint.bendDirection = constraint.data.bendDirection;
                    constraint.compress = constraint.data.compress;
                    constraint.stretch = constraint.data.stretch;
                }
                var transformConstraints = this.transformConstraints;
                for (var i = 0, n = transformConstraints.length; i < n; i++) {
                    var constraint = transformConstraints[i];
                    var data = constraint.data;
                    constraint.rotateMix = data.rotateMix;
                    constraint.translateMix = data.translateMix;
                    constraint.scaleMix = data.scaleMix;
                    constraint.shearMix = data.shearMix;
                }
                var pathConstraints = this.pathConstraints;
                for (var i = 0, n = pathConstraints.length; i < n; i++) {
                    var constraint = pathConstraints[i];
                    var data = constraint.data;
                    constraint.position = data.position;
                    constraint.spacing = data.spacing;
                    constraint.rotateMix = data.rotateMix;
                    constraint.translateMix = data.translateMix;
                }
            };
            Skeleton.prototype.setSlotsToSetupPose = function () {
                var slots = this.slots;
                core.Utils.arrayCopy(slots, 0, this.drawOrder, 0, slots.length);
                for (var i = 0, n = slots.length; i < n; i++)
                    slots[i].setToSetupPose();
            };
            Skeleton.prototype.getRootBone = function () {
                if (this.bones.length == 0)
                    return null;
                return this.bones[0];
            };
            Skeleton.prototype.findBone = function (boneName) {
                if (boneName == null)
                    throw new Error("boneName cannot be null.");
                var bones = this.bones;
                for (var i = 0, n = bones.length; i < n; i++) {
                    var bone = bones[i];
                    if (bone.data.name == boneName)
                        return bone;
                }
                return null;
            };
            Skeleton.prototype.findBoneIndex = function (boneName) {
                if (boneName == null)
                    throw new Error("boneName cannot be null.");
                var bones = this.bones;
                for (var i = 0, n = bones.length; i < n; i++)
                    if (bones[i].data.name == boneName)
                        return i;
                return -1;
            };
            Skeleton.prototype.findSlot = function (slotName) {
                if (slotName == null)
                    throw new Error("slotName cannot be null.");
                var slots = this.slots;
                for (var i = 0, n = slots.length; i < n; i++) {
                    var slot = slots[i];
                    if (slot.data.name == slotName)
                        return slot;
                }
                return null;
            };
            Skeleton.prototype.findSlotIndex = function (slotName) {
                if (slotName == null)
                    throw new Error("slotName cannot be null.");
                var slots = this.slots;
                for (var i = 0, n = slots.length; i < n; i++)
                    if (slots[i].data.name == slotName)
                        return i;
                return -1;
            };
            Skeleton.prototype.setSkinByName = function (skinName) {
                var skin = this.data.findSkin(skinName);
                if (skin == null)
                    throw new Error("Skin not found: " + skinName);
                this.setSkin(skin);
            };
            Skeleton.prototype.setSkin = function (newSkin) {
                if (newSkin == this.skin)
                    return;
                if (newSkin != null) {
                    if (this.skin != null)
                        newSkin.attachAll(this, this.skin);
                    else {
                        var slots = this.slots;
                        for (var i = 0, n = slots.length; i < n; i++) {
                            var slot = slots[i];
                            var name_1 = slot.data.attachmentName;
                            if (name_1 != null) {
                                var attachment = newSkin.getAttachment(i, name_1);
                                if (attachment != null)
                                    slot.setAttachment(attachment);
                            }
                        }
                    }
                }
                this.skin = newSkin;
                this.updateCache();
            };
            Skeleton.prototype.getAttachmentByName = function (slotName, attachmentName) {
                return this.getAttachment(this.data.findSlotIndex(slotName), attachmentName);
            };
            Skeleton.prototype.getAttachment = function (slotIndex, attachmentName) {
                if (attachmentName == null)
                    throw new Error("attachmentName cannot be null.");
                if (this.skin != null) {
                    var attachment = this.skin.getAttachment(slotIndex, attachmentName);
                    if (attachment != null)
                        return attachment;
                }
                if (this.data.defaultSkin != null)
                    return this.data.defaultSkin.getAttachment(slotIndex, attachmentName);
                return null;
            };
            Skeleton.prototype.setAttachment = function (slotName, attachmentName) {
                if (slotName == null)
                    throw new Error("slotName cannot be null.");
                var slots = this.slots;
                for (var i = 0, n = slots.length; i < n; i++) {
                    var slot = slots[i];
                    if (slot.data.name == slotName) {
                        var attachment = null;
                        if (attachmentName != null) {
                            attachment = this.getAttachment(i, attachmentName);
                            if (attachment == null)
                                throw new Error("Attachment not found: " + attachmentName + ", for slot: " + slotName);
                        }
                        slot.setAttachment(attachment);
                        return;
                    }
                }
                throw new Error("Slot not found: " + slotName);
            };
            Skeleton.prototype.findIkConstraint = function (constraintName) {
                if (constraintName == null)
                    throw new Error("constraintName cannot be null.");
                var ikConstraints = this.ikConstraints;
                for (var i = 0, n = ikConstraints.length; i < n; i++) {
                    var ikConstraint = ikConstraints[i];
                    if (ikConstraint.data.name == constraintName)
                        return ikConstraint;
                }
                return null;
            };
            Skeleton.prototype.findTransformConstraint = function (constraintName) {
                if (constraintName == null)
                    throw new Error("constraintName cannot be null.");
                var transformConstraints = this.transformConstraints;
                for (var i = 0, n = transformConstraints.length; i < n; i++) {
                    var constraint = transformConstraints[i];
                    if (constraint.data.name == constraintName)
                        return constraint;
                }
                return null;
            };
            Skeleton.prototype.findPathConstraint = function (constraintName) {
                if (constraintName == null)
                    throw new Error("constraintName cannot be null.");
                var pathConstraints = this.pathConstraints;
                for (var i = 0, n = pathConstraints.length; i < n; i++) {
                    var constraint = pathConstraints[i];
                    if (constraint.data.name == constraintName)
                        return constraint;
                }
                return null;
            };
            Skeleton.prototype.getBounds = function (offset, size, temp) {
                if (temp === void 0) { temp = new Array(2); }
                if (offset == null)
                    throw new Error("offset cannot be null.");
                if (size == null)
                    throw new Error("size cannot be null.");
                var drawOrder = this.drawOrder;
                var minX = Number.POSITIVE_INFINITY, minY = Number.POSITIVE_INFINITY, maxX = Number.NEGATIVE_INFINITY, maxY = Number.NEGATIVE_INFINITY;
                for (var i = 0, n = drawOrder.length; i < n; i++) {
                    var slot = drawOrder[i];
                    if (!slot.bone.active)
                        continue;
                    var verticesLength = 0;
                    var vertices = null;
                    var attachment = slot.getAttachment();
                    if (attachment instanceof core.RegionAttachment) {
                        verticesLength = 8;
                        vertices = core.Utils.setArraySize(temp, verticesLength, 0);
                        attachment.computeWorldVertices(slot.bone, vertices, 0, 2);
                    }
                    else if (attachment instanceof core.MeshAttachment) {
                        var mesh = attachment;
                        verticesLength = mesh.worldVerticesLength;
                        vertices = core.Utils.setArraySize(temp, verticesLength, 0);
                        mesh.computeWorldVertices(slot, 0, verticesLength, vertices, 0, 2);
                    }
                    if (vertices != null) {
                        for (var ii = 0, nn = vertices.length; ii < nn; ii += 2) {
                            var x = vertices[ii], y = vertices[ii + 1];
                            minX = Math.min(minX, x);
                            minY = Math.min(minY, y);
                            maxX = Math.max(maxX, x);
                            maxY = Math.max(maxY, y);
                        }
                    }
                }
                offset.set(minX, minY);
                size.set(maxX - minX, maxY - minY);
            };
            Skeleton.prototype.update = function (delta) {
                this.time += delta;
            };
            Object.defineProperty(Skeleton.prototype, "flipX", {
                get: function () {
                    return this.scaleX == -1;
                },
                set: function (value) {
                    if (!Skeleton.deprecatedWarning1) {
                        Skeleton.deprecatedWarning1 = true;
                        console.warn("Spine Deprecation Warning: `Skeleton.flipX/flipY` was deprecated, please use scaleX/scaleY");
                    }
                    this.scaleX = value ? 1.0 : -1.0;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(Skeleton.prototype, "flipY", {
                get: function () {
                    return this.scaleY == -1;
                },
                set: function (value) {
                    if (!Skeleton.deprecatedWarning1) {
                        Skeleton.deprecatedWarning1 = true;
                        console.warn("Spine Deprecation Warning: `Skeleton.flipX/flipY` was deprecated, please use scaleX/scaleY");
                    }
                    this.scaleY = value ? 1.0 : -1.0;
                },
                enumerable: true,
                configurable: true
            });
            Skeleton.deprecatedWarning1 = false;
            return Skeleton;
        }());
        core.Skeleton = Skeleton;
    })(core = pixi_spine.core || (pixi_spine.core = {}));
})(pixi_spine || (pixi_spine = {}));
var pixi_spine;
(function (pixi_spine) {
    var core;
    (function (core) {
        var SkeletonBinary = (function () {
            function SkeletonBinary(attachmentLoader) {
                this.scale = 1;
                this.linkedMeshes = new Array();
                this.attachmentLoader = attachmentLoader;
            }
            SkeletonBinary.prototype.readSkeletonData = function (binary) {
                var scale = this.scale;
                var skeletonData = new core.SkeletonData();
                skeletonData.name = "";
                var input = new BinaryInput(binary);
                skeletonData.hash = input.readString();
                skeletonData.version = input.readString();
                skeletonData.x = input.readFloat();
                skeletonData.y = input.readFloat();
                skeletonData.width = input.readFloat();
                skeletonData.height = input.readFloat();
                var nonessential = input.readBoolean();
                if (nonessential) {
                    skeletonData.fps = input.readFloat();
                    skeletonData.imagesPath = input.readString();
                    skeletonData.audioPath = input.readString();
                }
                var n = 0;
                n = input.readInt(true);
                for (var i = 0; i < n; i++)
                    input.strings.push(input.readString());
                n = input.readInt(true);
                for (var i = 0; i < n; i++) {
                    var name_2 = input.readString();
                    var parent_2 = i == 0 ? null : skeletonData.bones[input.readInt(true)];
                    var data = new core.BoneData(i, name_2, parent_2);
                    data.rotation = input.readFloat();
                    data.x = input.readFloat() * scale;
                    data.y = input.readFloat() * scale;
                    data.scaleX = input.readFloat();
                    data.scaleY = input.readFloat();
                    data.shearX = input.readFloat();
                    data.shearY = input.readFloat();
                    data.length = input.readFloat() * scale;
                    data.transformMode = SkeletonBinary.TransformModeValues[input.readInt(true)];
                    data.skinRequired = input.readBoolean();
                    if (nonessential)
                        core.Color.rgba8888ToColor(data.color, input.readInt32());
                    skeletonData.bones.push(data);
                }
                n = input.readInt(true);
                for (var i = 0; i < n; i++) {
                    var slotName = input.readString();
                    var boneData = skeletonData.bones[input.readInt(true)];
                    var data = new core.SlotData(i, slotName, boneData);
                    core.Color.rgba8888ToColor(data.color, input.readInt32());
                    var darkColor = input.readInt32();
                    if (darkColor != -1)
                        core.Color.rgb888ToColor(data.darkColor = new core.Color(), darkColor);
                    data.attachmentName = input.readStringRef();
                    data.blendMode = SkeletonBinary.BlendModeValues[input.readInt(true)];
                    skeletonData.slots.push(data);
                }
                n = input.readInt(true);
                for (var i = 0, nn = void 0; i < n; i++) {
                    var data = new core.IkConstraintData(input.readString());
                    data.order = input.readInt(true);
                    data.skinRequired = input.readBoolean();
                    nn = input.readInt(true);
                    for (var ii = 0; ii < nn; ii++)
                        data.bones.push(skeletonData.bones[input.readInt(true)]);
                    data.target = skeletonData.bones[input.readInt(true)];
                    data.mix = input.readFloat();
                    data.softness = input.readFloat() * scale;
                    data.bendDirection = input.readByte();
                    data.compress = input.readBoolean();
                    data.stretch = input.readBoolean();
                    data.uniform = input.readBoolean();
                    skeletonData.ikConstraints.push(data);
                }
                n = input.readInt(true);
                for (var i = 0, nn = void 0; i < n; i++) {
                    var data = new core.TransformConstraintData(input.readString());
                    data.order = input.readInt(true);
                    data.skinRequired = input.readBoolean();
                    nn = input.readInt(true);
                    for (var ii = 0; ii < nn; ii++)
                        data.bones.push(skeletonData.bones[input.readInt(true)]);
                    data.target = skeletonData.bones[input.readInt(true)];
                    data.local = input.readBoolean();
                    data.relative = input.readBoolean();
                    data.offsetRotation = input.readFloat();
                    data.offsetX = input.readFloat() * scale;
                    data.offsetY = input.readFloat() * scale;
                    data.offsetScaleX = input.readFloat();
                    data.offsetScaleY = input.readFloat();
                    data.offsetShearY = input.readFloat();
                    data.rotateMix = input.readFloat();
                    data.translateMix = input.readFloat();
                    data.scaleMix = input.readFloat();
                    data.shearMix = input.readFloat();
                    skeletonData.transformConstraints.push(data);
                }
                n = input.readInt(true);
                for (var i = 0, nn = void 0; i < n; i++) {
                    var data = new core.PathConstraintData(input.readString());
                    data.order = input.readInt(true);
                    data.skinRequired = input.readBoolean();
                    nn = input.readInt(true);
                    for (var ii = 0; ii < nn; ii++)
                        data.bones.push(skeletonData.bones[input.readInt(true)]);
                    data.target = skeletonData.slots[input.readInt(true)];
                    data.positionMode = SkeletonBinary.PositionModeValues[input.readInt(true)];
                    data.spacingMode = SkeletonBinary.SpacingModeValues[input.readInt(true)];
                    data.rotateMode = SkeletonBinary.RotateModeValues[input.readInt(true)];
                    data.offsetRotation = input.readFloat();
                    data.position = input.readFloat();
                    if (data.positionMode == core.PositionMode.Fixed)
                        data.position *= scale;
                    data.spacing = input.readFloat();
                    if (data.spacingMode == core.SpacingMode.Length || data.spacingMode == core.SpacingMode.Fixed)
                        data.spacing *= scale;
                    data.rotateMix = input.readFloat();
                    data.translateMix = input.readFloat();
                    skeletonData.pathConstraints.push(data);
                }
                var defaultSkin = this.readSkin(input, skeletonData, true, nonessential);
                if (defaultSkin != null) {
                    skeletonData.defaultSkin = defaultSkin;
                    skeletonData.skins.push(defaultSkin);
                }
                {
                    var i = skeletonData.skins.length;
                    core.Utils.setArraySize(skeletonData.skins, n = i + input.readInt(true));
                    for (; i < n; i++)
                        skeletonData.skins[i] = this.readSkin(input, skeletonData, false, nonessential);
                }
                n = this.linkedMeshes.length;
                for (var i = 0; i < n; i++) {
                    var linkedMesh = this.linkedMeshes[i];
                    var skin = linkedMesh.skin == null ? skeletonData.defaultSkin : skeletonData.findSkin(linkedMesh.skin);
                    if (skin == null)
                        throw new Error("Skin not found: " + linkedMesh.skin);
                    var parent_3 = skin.getAttachment(linkedMesh.slotIndex, linkedMesh.parent);
                    if (parent_3 == null)
                        throw new Error("Parent mesh not found: " + linkedMesh.parent);
                    linkedMesh.mesh.deformAttachment = linkedMesh.inheritDeform ? parent_3 : linkedMesh.mesh;
                    linkedMesh.mesh.setParentMesh(parent_3);
                }
                this.linkedMeshes.length = 0;
                n = input.readInt(true);
                for (var i = 0; i < n; i++) {
                    var data = new core.EventData(input.readStringRef());
                    data.intValue = input.readInt(false);
                    data.floatValue = input.readFloat();
                    data.stringValue = input.readString();
                    data.audioPath = input.readString();
                    if (data.audioPath != null) {
                        data.volume = input.readFloat();
                        data.balance = input.readFloat();
                    }
                    skeletonData.events.push(data);
                }
                n = input.readInt(true);
                for (var i = 0; i < n; i++)
                    skeletonData.animations.push(this.readAnimation(input, input.readString(), skeletonData));
                return skeletonData;
            };
            SkeletonBinary.prototype.readSkin = function (input, skeletonData, defaultSkin, nonessential) {
                var skin = new core.Skin(defaultSkin ? "default" : input.readStringRef());
                if (!defaultSkin) {
                    skin.bones.length = input.readInt(true);
                    for (var i = 0, n = skin.bones.length; i < n; i++)
                        skin.bones[i] = skeletonData.bones[input.readInt(true)];
                    for (var i = 0, n = input.readInt(true); i < n; i++)
                        skin.constraints.push(skeletonData.ikConstraints[input.readInt(true)]);
                    for (var i = 0, n = input.readInt(true); i < n; i++)
                        skin.constraints.push(skeletonData.transformConstraints[input.readInt(true)]);
                    for (var i = 0, n = input.readInt(true); i < n; i++)
                        skin.constraints.push(skeletonData.pathConstraints[input.readInt(true)]);
                }
                for (var i = 0, n = input.readInt(true); i < n; i++) {
                    var slotIndex = input.readInt(true);
                    for (var ii = 0, nn = input.readInt(true); ii < nn; ii++) {
                        var name_3 = input.readStringRef();
                        var attachment = this.readAttachment(input, skeletonData, skin, slotIndex, name_3, nonessential);
                        if (attachment != null)
                            skin.setAttachment(slotIndex, name_3, attachment);
                    }
                }
                return skin;
            };
            SkeletonBinary.prototype.readAttachment = function (input, skeletonData, skin, slotIndex, attachmentName, nonessential) {
                var scale = this.scale;
                var name = input.readStringRef();
                if (name == null)
                    name = attachmentName;
                var typeIndex = input.readByte();
                var type = SkeletonBinary.AttachmentTypeValues[typeIndex];
                switch (type) {
                    case core.AttachmentType.Region: {
                        var path = input.readStringRef();
                        var rotation = input.readFloat();
                        var x = input.readFloat();
                        var y = input.readFloat();
                        var scaleX = input.readFloat();
                        var scaleY = input.readFloat();
                        var width = input.readFloat();
                        var height = input.readFloat();
                        var color = input.readInt32();
                        if (path == null)
                            path = name;
                        var region = this.attachmentLoader.newRegionAttachment(skin, name, path);
                        if (region == null)
                            return null;
                        region.path = path;
                        region.x = x * scale;
                        region.y = y * scale;
                        region.scaleX = scaleX;
                        region.scaleY = scaleY;
                        region.rotation = rotation;
                        region.width = width * scale;
                        region.height = height * scale;
                        core.Color.rgba8888ToColor(region.color, color);
                        return region;
                    }
                    case core.AttachmentType.BoundingBox: {
                        var vertexCount = input.readInt(true);
                        var vertices = this.readVertices(input, vertexCount);
                        var color = nonessential ? input.readInt32() : 0;
                        var box = this.attachmentLoader.newBoundingBoxAttachment(skin, name);
                        if (box == null)
                            return null;
                        box.worldVerticesLength = vertexCount << 1;
                        box.vertices = vertices.vertices;
                        box.bones = vertices.bones;
                        if (nonessential)
                            core.Color.rgba8888ToColor(box.color, color);
                        return box;
                    }
                    case core.AttachmentType.Mesh: {
                        var path = input.readStringRef();
                        var color = input.readInt32();
                        var vertexCount = input.readInt(true);
                        var uvs = this.readFloatArray(input, vertexCount << 1, 1);
                        var triangles = this.readShortArray(input);
                        var vertices = this.readVertices(input, vertexCount);
                        var hullLength = input.readInt(true);
                        var edges = null;
                        var width = 0, height = 0;
                        if (nonessential) {
                            edges = this.readShortArray(input);
                            width = input.readFloat();
                            height = input.readFloat();
                        }
                        if (path == null)
                            path = name;
                        var mesh = this.attachmentLoader.newMeshAttachment(skin, name, path);
                        if (mesh == null)
                            return null;
                        mesh.path = path;
                        core.Color.rgba8888ToColor(mesh.color, color);
                        mesh.bones = vertices.bones;
                        mesh.vertices = vertices.vertices;
                        mesh.worldVerticesLength = vertexCount << 1;
                        mesh.triangles = triangles;
                        mesh.regionUVs = new Float32Array(uvs);
                        mesh.hullLength = hullLength << 1;
                        if (nonessential) {
                            mesh.edges = edges;
                            mesh.width = width * scale;
                            mesh.height = height * scale;
                        }
                        return mesh;
                    }
                    case core.AttachmentType.LinkedMesh: {
                        var path = input.readStringRef();
                        var color = input.readInt32();
                        var skinName = input.readStringRef();
                        var parent_4 = input.readStringRef();
                        var inheritDeform = input.readBoolean();
                        var width = 0, height = 0;
                        if (nonessential) {
                            width = input.readFloat();
                            height = input.readFloat();
                        }
                        if (path == null)
                            path = name;
                        var mesh = this.attachmentLoader.newMeshAttachment(skin, name, path);
                        if (mesh == null)
                            return null;
                        mesh.path = path;
                        core.Color.rgba8888ToColor(mesh.color, color);
                        if (nonessential) {
                            mesh.width = width * scale;
                            mesh.height = height * scale;
                        }
                        this.linkedMeshes.push(new LinkedMesh(mesh, skinName, slotIndex, parent_4, inheritDeform));
                        return mesh;
                    }
                    case core.AttachmentType.Path: {
                        var closed_1 = input.readBoolean();
                        var constantSpeed = input.readBoolean();
                        var vertexCount = input.readInt(true);
                        var vertices = this.readVertices(input, vertexCount);
                        var lengths = core.Utils.newArray(vertexCount / 3, 0);
                        for (var i = 0, n = lengths.length; i < n; i++)
                            lengths[i] = input.readFloat() * scale;
                        var color = nonessential ? input.readInt32() : 0;
                        var path = this.attachmentLoader.newPathAttachment(skin, name);
                        if (path == null)
                            return null;
                        path.closed = closed_1;
                        path.constantSpeed = constantSpeed;
                        path.worldVerticesLength = vertexCount << 1;
                        path.vertices = vertices.vertices;
                        path.bones = vertices.bones;
                        path.lengths = lengths;
                        if (nonessential)
                            core.Color.rgba8888ToColor(path.color, color);
                        return path;
                    }
                    case core.AttachmentType.Point: {
                        var rotation = input.readFloat();
                        var x = input.readFloat();
                        var y = input.readFloat();
                        var color = nonessential ? input.readInt32() : 0;
                        var point = this.attachmentLoader.newPointAttachment(skin, name);
                        if (point == null)
                            return null;
                        point.x = x * scale;
                        point.y = y * scale;
                        point.rotation = rotation;
                        if (nonessential)
                            core.Color.rgba8888ToColor(point.color, color);
                        return point;
                    }
                    case core.AttachmentType.Clipping: {
                        var endSlotIndex = input.readInt(true);
                        var vertexCount = input.readInt(true);
                        var vertices = this.readVertices(input, vertexCount);
                        var color = nonessential ? input.readInt32() : 0;
                        var clip = this.attachmentLoader.newClippingAttachment(skin, name);
                        if (clip == null)
                            return null;
                        clip.endSlot = skeletonData.slots[endSlotIndex];
                        clip.worldVerticesLength = vertexCount << 1;
                        clip.vertices = vertices.vertices;
                        clip.bones = vertices.bones;
                        if (nonessential)
                            core.Color.rgba8888ToColor(clip.color, color);
                        return clip;
                    }
                }
                return null;
            };
            SkeletonBinary.prototype.readVertices = function (input, vertexCount) {
                var verticesLength = vertexCount << 1;
                var vertices = new Vertices();
                var scale = this.scale;
                if (!input.readBoolean()) {
                    vertices.vertices = this.readFloatArray(input, verticesLength, scale);
                    return vertices;
                }
                var weights = new Array();
                var bonesArray = new Array();
                for (var i = 0; i < vertexCount; i++) {
                    var boneCount = input.readInt(true);
                    bonesArray.push(boneCount);
                    for (var ii = 0; ii < boneCount; ii++) {
                        bonesArray.push(input.readInt(true));
                        weights.push(input.readFloat() * scale);
                        weights.push(input.readFloat() * scale);
                        weights.push(input.readFloat());
                    }
                }
                vertices.vertices = core.Utils.toFloatArray(weights);
                vertices.bones = bonesArray;
                return vertices;
            };
            SkeletonBinary.prototype.readFloatArray = function (input, n, scale) {
                var array = new Array(n);
                if (scale == 1) {
                    for (var i = 0; i < n; i++)
                        array[i] = input.readFloat();
                }
                else {
                    for (var i = 0; i < n; i++)
                        array[i] = input.readFloat() * scale;
                }
                return array;
            };
            SkeletonBinary.prototype.readShortArray = function (input) {
                var n = input.readInt(true);
                var array = new Array(n);
                for (var i = 0; i < n; i++)
                    array[i] = input.readShort();
                return array;
            };
            SkeletonBinary.prototype.readAnimation = function (input, name, skeletonData) {
                var timelines = new Array();
                var scale = this.scale;
                var duration = 0;
                var tempColor1 = new core.Color();
                var tempColor2 = new core.Color();
                for (var i = 0, n = input.readInt(true); i < n; i++) {
                    var slotIndex = input.readInt(true);
                    for (var ii = 0, nn = input.readInt(true); ii < nn; ii++) {
                        var timelineType = input.readByte();
                        var frameCount = input.readInt(true);
                        switch (timelineType) {
                            case SkeletonBinary.SLOT_ATTACHMENT: {
                                var timeline = new core.AttachmentTimeline(frameCount);
                                timeline.slotIndex = slotIndex;
                                for (var frameIndex = 0; frameIndex < frameCount; frameIndex++)
                                    timeline.setFrame(frameIndex, input.readFloat(), input.readStringRef());
                                timelines.push(timeline);
                                duration = Math.max(duration, timeline.frames[frameCount - 1]);
                                break;
                            }
                            case SkeletonBinary.SLOT_COLOR: {
                                var timeline = new core.ColorTimeline(frameCount);
                                timeline.slotIndex = slotIndex;
                                for (var frameIndex = 0; frameIndex < frameCount; frameIndex++) {
                                    var time = input.readFloat();
                                    core.Color.rgba8888ToColor(tempColor1, input.readInt32());
                                    timeline.setFrame(frameIndex, time, tempColor1.r, tempColor1.g, tempColor1.b, tempColor1.a);
                                    if (frameIndex < frameCount - 1)
                                        this.readCurve(input, frameIndex, timeline);
                                }
                                timelines.push(timeline);
                                duration = Math.max(duration, timeline.frames[(frameCount - 1) * core.ColorTimeline.ENTRIES]);
                                break;
                            }
                            case SkeletonBinary.SLOT_TWO_COLOR: {
                                var timeline = new core.TwoColorTimeline(frameCount);
                                timeline.slotIndex = slotIndex;
                                for (var frameIndex = 0; frameIndex < frameCount; frameIndex++) {
                                    var time = input.readFloat();
                                    core.Color.rgba8888ToColor(tempColor1, input.readInt32());
                                    core.Color.rgb888ToColor(tempColor2, input.readInt32());
                                    timeline.setFrame(frameIndex, time, tempColor1.r, tempColor1.g, tempColor1.b, tempColor1.a, tempColor2.r, tempColor2.g, tempColor2.b);
                                    if (frameIndex < frameCount - 1)
                                        this.readCurve(input, frameIndex, timeline);
                                }
                                timelines.push(timeline);
                                duration = Math.max(duration, timeline.frames[(frameCount - 1) * core.TwoColorTimeline.ENTRIES]);
                                break;
                            }
                        }
                    }
                }
                for (var i = 0, n = input.readInt(true); i < n; i++) {
                    var boneIndex = input.readInt(true);
                    for (var ii = 0, nn = input.readInt(true); ii < nn; ii++) {
                        var timelineType = input.readByte();
                        var frameCount = input.readInt(true);
                        switch (timelineType) {
                            case SkeletonBinary.BONE_ROTATE: {
                                var timeline = new core.RotateTimeline(frameCount);
                                timeline.boneIndex = boneIndex;
                                for (var frameIndex = 0; frameIndex < frameCount; frameIndex++) {
                                    timeline.setFrame(frameIndex, input.readFloat(), input.readFloat());
                                    if (frameIndex < frameCount - 1)
                                        this.readCurve(input, frameIndex, timeline);
                                }
                                timelines.push(timeline);
                                duration = Math.max(duration, timeline.frames[(frameCount - 1) * core.RotateTimeline.ENTRIES]);
                                break;
                            }
                            case SkeletonBinary.BONE_TRANSLATE:
                            case SkeletonBinary.BONE_SCALE:
                            case SkeletonBinary.BONE_SHEAR: {
                                var timeline = void 0;
                                var timelineScale = 1;
                                if (timelineType == SkeletonBinary.BONE_SCALE)
                                    timeline = new core.ScaleTimeline(frameCount);
                                else if (timelineType == SkeletonBinary.BONE_SHEAR)
                                    timeline = new core.ShearTimeline(frameCount);
                                else {
                                    timeline = new core.TranslateTimeline(frameCount);
                                    timelineScale = scale;
                                }
                                timeline.boneIndex = boneIndex;
                                for (var frameIndex = 0; frameIndex < frameCount; frameIndex++) {
                                    timeline.setFrame(frameIndex, input.readFloat(), input.readFloat() * timelineScale, input.readFloat() * timelineScale);
                                    if (frameIndex < frameCount - 1)
                                        this.readCurve(input, frameIndex, timeline);
                                }
                                timelines.push(timeline);
                                duration = Math.max(duration, timeline.frames[(frameCount - 1) * core.TranslateTimeline.ENTRIES]);
                                break;
                            }
                        }
                    }
                }
                for (var i = 0, n = input.readInt(true); i < n; i++) {
                    var index = input.readInt(true);
                    var frameCount = input.readInt(true);
                    var timeline = new core.IkConstraintTimeline(frameCount);
                    timeline.ikConstraintIndex = index;
                    for (var frameIndex = 0; frameIndex < frameCount; frameIndex++) {
                        timeline.setFrame(frameIndex, input.readFloat(), input.readFloat(), input.readFloat() * scale, input.readByte(), input.readBoolean(), input.readBoolean());
                        if (frameIndex < frameCount - 1)
                            this.readCurve(input, frameIndex, timeline);
                    }
                    timelines.push(timeline);
                    duration = Math.max(duration, timeline.frames[(frameCount - 1) * core.IkConstraintTimeline.ENTRIES]);
                }
                for (var i = 0, n = input.readInt(true); i < n; i++) {
                    var index = input.readInt(true);
                    var frameCount = input.readInt(true);
                    var timeline = new core.TransformConstraintTimeline(frameCount);
                    timeline.transformConstraintIndex = index;
                    for (var frameIndex = 0; frameIndex < frameCount; frameIndex++) {
                        timeline.setFrame(frameIndex, input.readFloat(), input.readFloat(), input.readFloat(), input.readFloat(), input.readFloat());
                        if (frameIndex < frameCount - 1)
                            this.readCurve(input, frameIndex, timeline);
                    }
                    timelines.push(timeline);
                    duration = Math.max(duration, timeline.frames[(frameCount - 1) * core.TransformConstraintTimeline.ENTRIES]);
                }
                for (var i = 0, n = input.readInt(true); i < n; i++) {
                    var index = input.readInt(true);
                    var data = skeletonData.pathConstraints[index];
                    for (var ii = 0, nn = input.readInt(true); ii < nn; ii++) {
                        var timelineType = input.readByte();
                        var frameCount = input.readInt(true);
                        switch (timelineType) {
                            case SkeletonBinary.PATH_POSITION:
                            case SkeletonBinary.PATH_SPACING: {
                                var timeline = void 0;
                                var timelineScale = 1;
                                if (timelineType == SkeletonBinary.PATH_SPACING) {
                                    timeline = new core.PathConstraintSpacingTimeline(frameCount);
                                    if (data.spacingMode == core.SpacingMode.Length || data.spacingMode == core.SpacingMode.Fixed)
                                        timelineScale = scale;
                                }
                                else {
                                    timeline = new core.PathConstraintPositionTimeline(frameCount);
                                    if (data.positionMode == core.PositionMode.Fixed)
                                        timelineScale = scale;
                                }
                                timeline.pathConstraintIndex = index;
                                for (var frameIndex = 0; frameIndex < frameCount; frameIndex++) {
                                    timeline.setFrame(frameIndex, input.readFloat(), input.readFloat() * timelineScale);
                                    if (frameIndex < frameCount - 1)
                                        this.readCurve(input, frameIndex, timeline);
                                }
                                timelines.push(timeline);
                                duration = Math.max(duration, timeline.frames[(frameCount - 1) * core.PathConstraintPositionTimeline.ENTRIES]);
                                break;
                            }
                            case SkeletonBinary.PATH_MIX: {
                                var timeline = new core.PathConstraintMixTimeline(frameCount);
                                timeline.pathConstraintIndex = index;
                                for (var frameIndex = 0; frameIndex < frameCount; frameIndex++) {
                                    timeline.setFrame(frameIndex, input.readFloat(), input.readFloat(), input.readFloat());
                                    if (frameIndex < frameCount - 1)
                                        this.readCurve(input, frameIndex, timeline);
                                }
                                timelines.push(timeline);
                                duration = Math.max(duration, timeline.frames[(frameCount - 1) * core.PathConstraintMixTimeline.ENTRIES]);
                                break;
                            }
                        }
                    }
                }
                for (var i = 0, n = input.readInt(true); i < n; i++) {
                    var skin = skeletonData.skins[input.readInt(true)];
                    for (var ii = 0, nn = input.readInt(true); ii < nn; ii++) {
                        var slotIndex = input.readInt(true);
                        for (var iii = 0, nnn = input.readInt(true); iii < nnn; iii++) {
                            var attachment = skin.getAttachment(slotIndex, input.readStringRef());
                            var weighted = attachment.bones != null;
                            var vertices = attachment.vertices;
                            var deformLength = weighted ? vertices.length / 3 * 2 : vertices.length;
                            var frameCount = input.readInt(true);
                            var timeline = new core.DeformTimeline(frameCount);
                            timeline.slotIndex = slotIndex;
                            timeline.attachment = attachment;
                            for (var frameIndex = 0; frameIndex < frameCount; frameIndex++) {
                                var time = input.readFloat();
                                var deform = void 0;
                                var end = input.readInt(true);
                                if (end == 0)
                                    deform = weighted ? core.Utils.newFloatArray(deformLength) : vertices;
                                else {
                                    deform = core.Utils.newFloatArray(deformLength);
                                    var start = input.readInt(true);
                                    end += start;
                                    if (scale == 1) {
                                        for (var v = start; v < end; v++)
                                            deform[v] = input.readFloat();
                                    }
                                    else {
                                        for (var v = start; v < end; v++)
                                            deform[v] = input.readFloat() * scale;
                                    }
                                    if (!weighted) {
                                        for (var v = 0, vn = deform.length; v < vn; v++)
                                            deform[v] += vertices[v];
                                    }
                                }
                                timeline.setFrame(frameIndex, time, deform);
                                if (frameIndex < frameCount - 1)
                                    this.readCurve(input, frameIndex, timeline);
                            }
                            timelines.push(timeline);
                            duration = Math.max(duration, timeline.frames[frameCount - 1]);
                        }
                    }
                }
                var drawOrderCount = input.readInt(true);
                if (drawOrderCount > 0) {
                    var timeline = new core.DrawOrderTimeline(drawOrderCount);
                    var slotCount = skeletonData.slots.length;
                    for (var i = 0; i < drawOrderCount; i++) {
                        var time = input.readFloat();
                        var offsetCount = input.readInt(true);
                        var drawOrder = core.Utils.newArray(slotCount, 0);
                        for (var ii = slotCount - 1; ii >= 0; ii--)
                            drawOrder[ii] = -1;
                        var unchanged = core.Utils.newArray(slotCount - offsetCount, 0);
                        var originalIndex = 0, unchangedIndex = 0;
                        for (var ii = 0; ii < offsetCount; ii++) {
                            var slotIndex = input.readInt(true);
                            while (originalIndex != slotIndex)
                                unchanged[unchangedIndex++] = originalIndex++;
                            drawOrder[originalIndex + input.readInt(true)] = originalIndex++;
                        }
                        while (originalIndex < slotCount)
                            unchanged[unchangedIndex++] = originalIndex++;
                        for (var ii = slotCount - 1; ii >= 0; ii--)
                            if (drawOrder[ii] == -1)
                                drawOrder[ii] = unchanged[--unchangedIndex];
                        timeline.setFrame(i, time, drawOrder);
                    }
                    timelines.push(timeline);
                    duration = Math.max(duration, timeline.frames[drawOrderCount - 1]);
                }
                var eventCount = input.readInt(true);
                if (eventCount > 0) {
                    var timeline = new core.EventTimeline(eventCount);
                    for (var i = 0; i < eventCount; i++) {
                        var time = input.readFloat();
                        var eventData = skeletonData.events[input.readInt(true)];
                        var event_4 = new core.Event(time, eventData);
                        event_4.intValue = input.readInt(false);
                        event_4.floatValue = input.readFloat();
                        event_4.stringValue = input.readBoolean() ? input.readString() : eventData.stringValue;
                        if (event_4.data.audioPath != null) {
                            event_4.volume = input.readFloat();
                            event_4.balance = input.readFloat();
                        }
                        timeline.setFrame(i, event_4);
                    }
                    timelines.push(timeline);
                    duration = Math.max(duration, timeline.frames[eventCount - 1]);
                }
                return new core.Animation(name, timelines, duration);
            };
            SkeletonBinary.prototype.readCurve = function (input, frameIndex, timeline) {
                switch (input.readByte()) {
                    case SkeletonBinary.CURVE_STEPPED:
                        timeline.setStepped(frameIndex);
                        break;
                    case SkeletonBinary.CURVE_BEZIER:
                        this.setCurve(timeline, frameIndex, input.readFloat(), input.readFloat(), input.readFloat(), input.readFloat());
                        break;
                }
            };
            SkeletonBinary.prototype.setCurve = function (timeline, frameIndex, cx1, cy1, cx2, cy2) {
                timeline.setCurve(frameIndex, cx1, cy1, cx2, cy2);
            };
            SkeletonBinary.AttachmentTypeValues = [0, 1, 2, 3, 4, 5, 6];
            SkeletonBinary.TransformModeValues = [core.TransformMode.Normal, core.TransformMode.OnlyTranslation, core.TransformMode.NoRotationOrReflection, core.TransformMode.NoScale, core.TransformMode.NoScaleOrReflection];
            SkeletonBinary.PositionModeValues = [core.PositionMode.Fixed, core.PositionMode.Percent];
            SkeletonBinary.SpacingModeValues = [core.SpacingMode.Length, core.SpacingMode.Fixed, core.SpacingMode.Percent];
            SkeletonBinary.RotateModeValues = [core.RotateMode.Tangent, core.RotateMode.Chain, core.RotateMode.ChainScale];
            SkeletonBinary.BlendModeValues = [core.BlendMode.Normal, core.BlendMode.Additive, core.BlendMode.Multiply, core.BlendMode.Screen];
            SkeletonBinary.BONE_ROTATE = 0;
            SkeletonBinary.BONE_TRANSLATE = 1;
            SkeletonBinary.BONE_SCALE = 2;
            SkeletonBinary.BONE_SHEAR = 3;
            SkeletonBinary.SLOT_ATTACHMENT = 0;
            SkeletonBinary.SLOT_COLOR = 1;
            SkeletonBinary.SLOT_TWO_COLOR = 2;
            SkeletonBinary.PATH_POSITION = 0;
            SkeletonBinary.PATH_SPACING = 1;
            SkeletonBinary.PATH_MIX = 2;
            SkeletonBinary.CURVE_LINEAR = 0;
            SkeletonBinary.CURVE_STEPPED = 1;
            SkeletonBinary.CURVE_BEZIER = 2;
            return SkeletonBinary;
        }());
        core.SkeletonBinary = SkeletonBinary;
        var BinaryInput = (function () {
            function BinaryInput(data, strings, index, buffer) {
                if (strings === void 0) { strings = new Array(); }
                if (index === void 0) { index = 0; }
                if (buffer === void 0) { buffer = new DataView(data.buffer); }
                this.strings = strings;
                this.index = index;
                this.buffer = buffer;
            }
            BinaryInput.prototype.readByte = function () {
                return this.buffer.getInt8(this.index++);
            };
            BinaryInput.prototype.readShort = function () {
                var value = this.buffer.getInt16(this.index);
                this.index += 2;
                return value;
            };
            BinaryInput.prototype.readInt32 = function () {
                var value = this.buffer.getInt32(this.index);
                this.index += 4;
                return value;
            };
            BinaryInput.prototype.readInt = function (optimizePositive) {
                var b = this.readByte();
                var result = b & 0x7F;
                if ((b & 0x80) != 0) {
                    b = this.readByte();
                    result |= (b & 0x7F) << 7;
                    if ((b & 0x80) != 0) {
                        b = this.readByte();
                        result |= (b & 0x7F) << 14;
                        if ((b & 0x80) != 0) {
                            b = this.readByte();
                            result |= (b & 0x7F) << 21;
                            if ((b & 0x80) != 0) {
                                b = this.readByte();
                                result |= (b & 0x7F) << 28;
                            }
                        }
                    }
                }
                return optimizePositive ? result : ((result >>> 1) ^ -(result & 1));
            };
            BinaryInput.prototype.readStringRef = function () {
                var index = this.readInt(true);
                return index == 0 ? null : this.strings[index - 1];
            };
            BinaryInput.prototype.readString = function () {
                var byteCount = this.readInt(true);
                switch (byteCount) {
                    case 0:
                        return null;
                    case 1:
                        return "";
                }
                byteCount--;
                var chars = "";
                var charCount = 0;
                for (var i = 0; i < byteCount;) {
                    var b = this.readByte();
                    switch (b >> 4) {
                        case 12:
                        case 13:
                            chars += String.fromCharCode(((b & 0x1F) << 6 | this.readByte() & 0x3F));
                            i += 2;
                            break;
                        case 14:
                            chars += String.fromCharCode(((b & 0x0F) << 12 | (this.readByte() & 0x3F) << 6 | this.readByte() & 0x3F));
                            i += 3;
                            break;
                        default:
                            chars += String.fromCharCode(b);
                            i++;
                    }
                }
                return chars;
            };
            BinaryInput.prototype.readFloat = function () {
                var value = this.buffer.getFloat32(this.index);
                this.index += 4;
                return value;
            };
            BinaryInput.prototype.readBoolean = function () {
                return this.readByte() != 0;
            };
            return BinaryInput;
        }());
        var LinkedMesh = (function () {
            function LinkedMesh(mesh, skin, slotIndex, parent, inheritDeform) {
                this.mesh = mesh;
                this.skin = skin;
                this.slotIndex = slotIndex;
                this.parent = parent;
                this.inheritDeform = inheritDeform;
            }
            return LinkedMesh;
        }());
        var Vertices = (function () {
            function Vertices(bones, vertices) {
                if (bones === void 0) { bones = null; }
                if (vertices === void 0) { vertices = null; }
                this.bones = bones;
                this.vertices = vertices;
            }
            return Vertices;
        }());
    })(core = pixi_spine.core || (pixi_spine.core = {}));
})(pixi_spine || (pixi_spine = {}));
var pixi_spine;
(function (pixi_spine) {
    var core;
    (function (core) {
        var SkeletonBounds = (function () {
            function SkeletonBounds() {
                this.minX = 0;
                this.minY = 0;
                this.maxX = 0;
                this.maxY = 0;
                this.boundingBoxes = new Array();
                this.polygons = new Array();
                this.polygonPool = new core.Pool(function () {
                    return core.Utils.newFloatArray(16);
                });
            }
            SkeletonBounds.prototype.update = function (skeleton, updateAabb) {
                if (skeleton == null)
                    throw new Error("skeleton cannot be null.");
                var boundingBoxes = this.boundingBoxes;
                var polygons = this.polygons;
                var polygonPool = this.polygonPool;
                var slots = skeleton.slots;
                var slotCount = slots.length;
                boundingBoxes.length = 0;
                polygonPool.freeAll(polygons);
                polygons.length = 0;
                for (var i = 0; i < slotCount; i++) {
                    var slot = slots[i];
                    if (!slot.bone.active)
                        continue;
                    var attachment = slot.getAttachment();
                    if (attachment instanceof core.BoundingBoxAttachment) {
                        var boundingBox = attachment;
                        boundingBoxes.push(boundingBox);
                        var polygon = polygonPool.obtain();
                        if (polygon.length != boundingBox.worldVerticesLength) {
                            polygon = core.Utils.newFloatArray(boundingBox.worldVerticesLength);
                        }
                        polygons.push(polygon);
                        boundingBox.computeWorldVertices(slot, 0, boundingBox.worldVerticesLength, polygon, 0, 2);
                    }
                }
                if (updateAabb) {
                    this.aabbCompute();
                }
                else {
                    this.minX = Number.POSITIVE_INFINITY;
                    this.minY = Number.POSITIVE_INFINITY;
                    this.maxX = Number.NEGATIVE_INFINITY;
                    this.maxY = Number.NEGATIVE_INFINITY;
                }
            };
            SkeletonBounds.prototype.aabbCompute = function () {
                var minX = Number.POSITIVE_INFINITY, minY = Number.POSITIVE_INFINITY, maxX = Number.NEGATIVE_INFINITY, maxY = Number.NEGATIVE_INFINITY;
                var polygons = this.polygons;
                for (var i = 0, n = polygons.length; i < n; i++) {
                    var polygon = polygons[i];
                    var vertices = polygon;
                    for (var ii = 0, nn = polygon.length; ii < nn; ii += 2) {
                        var x = vertices[ii];
                        var y = vertices[ii + 1];
                        minX = Math.min(minX, x);
                        minY = Math.min(minY, y);
                        maxX = Math.max(maxX, x);
                        maxY = Math.max(maxY, y);
                    }
                }
                this.minX = minX;
                this.minY = minY;
                this.maxX = maxX;
                this.maxY = maxY;
            };
            SkeletonBounds.prototype.aabbContainsPoint = function (x, y) {
                return x >= this.minX && x <= this.maxX && y >= this.minY && y <= this.maxY;
            };
            SkeletonBounds.prototype.aabbIntersectsSegment = function (x1, y1, x2, y2) {
                var minX = this.minX;
                var minY = this.minY;
                var maxX = this.maxX;
                var maxY = this.maxY;
                if ((x1 <= minX && x2 <= minX) || (y1 <= minY && y2 <= minY) || (x1 >= maxX && x2 >= maxX) || (y1 >= maxY && y2 >= maxY))
                    return false;
                var m = (y2 - y1) / (x2 - x1);
                var y = m * (minX - x1) + y1;
                if (y > minY && y < maxY)
                    return true;
                y = m * (maxX - x1) + y1;
                if (y > minY && y < maxY)
                    return true;
                var x = (minY - y1) / m + x1;
                if (x > minX && x < maxX)
                    return true;
                x = (maxY - y1) / m + x1;
                if (x > minX && x < maxX)
                    return true;
                return false;
            };
            SkeletonBounds.prototype.aabbIntersectsSkeleton = function (bounds) {
                return this.minX < bounds.maxX && this.maxX > bounds.minX && this.minY < bounds.maxY && this.maxY > bounds.minY;
            };
            SkeletonBounds.prototype.containsPoint = function (x, y) {
                var polygons = this.polygons;
                for (var i = 0, n = polygons.length; i < n; i++)
                    if (this.containsPointPolygon(polygons[i], x, y))
                        return this.boundingBoxes[i];
                return null;
            };
            SkeletonBounds.prototype.containsPointPolygon = function (polygon, x, y) {
                var vertices = polygon;
                var nn = polygon.length;
                var prevIndex = nn - 2;
                var inside = false;
                for (var ii = 0; ii < nn; ii += 2) {
                    var vertexY = vertices[ii + 1];
                    var prevY = vertices[prevIndex + 1];
                    if ((vertexY < y && prevY >= y) || (prevY < y && vertexY >= y)) {
                        var vertexX = vertices[ii];
                        if (vertexX + (y - vertexY) / (prevY - vertexY) * (vertices[prevIndex] - vertexX) < x)
                            inside = !inside;
                    }
                    prevIndex = ii;
                }
                return inside;
            };
            SkeletonBounds.prototype.intersectsSegment = function (x1, y1, x2, y2) {
                var polygons = this.polygons;
                for (var i = 0, n = polygons.length; i < n; i++)
                    if (this.intersectsSegmentPolygon(polygons[i], x1, y1, x2, y2))
                        return this.boundingBoxes[i];
                return null;
            };
            SkeletonBounds.prototype.intersectsSegmentPolygon = function (polygon, x1, y1, x2, y2) {
                var vertices = polygon;
                var nn = polygon.length;
                var width12 = x1 - x2, height12 = y1 - y2;
                var det1 = x1 * y2 - y1 * x2;
                var x3 = vertices[nn - 2], y3 = vertices[nn - 1];
                for (var ii = 0; ii < nn; ii += 2) {
                    var x4 = vertices[ii], y4 = vertices[ii + 1];
                    var det2 = x3 * y4 - y3 * x4;
                    var width34 = x3 - x4, height34 = y3 - y4;
                    var det3 = width12 * height34 - height12 * width34;
                    var x = (det1 * width34 - width12 * det2) / det3;
                    if (((x >= x3 && x <= x4) || (x >= x4 && x <= x3)) && ((x >= x1 && x <= x2) || (x >= x2 && x <= x1))) {
                        var y = (det1 * height34 - height12 * det2) / det3;
                        if (((y >= y3 && y <= y4) || (y >= y4 && y <= y3)) && ((y >= y1 && y <= y2) || (y >= y2 && y <= y1)))
                            return true;
                    }
                    x3 = x4;
                    y3 = y4;
                }
                return false;
            };
            SkeletonBounds.prototype.getPolygon = function (boundingBox) {
                if (boundingBox == null)
                    throw new Error("boundingBox cannot be null.");
                var index = this.boundingBoxes.indexOf(boundingBox);
                return index == -1 ? null : this.polygons[index];
            };
            SkeletonBounds.prototype.getWidth = function () {
                return this.maxX - this.minX;
            };
            SkeletonBounds.prototype.getHeight = function () {
                return this.maxY - this.minY;
            };
            return SkeletonBounds;
        }());
        core.SkeletonBounds = SkeletonBounds;
    })(core = pixi_spine.core || (pixi_spine.core = {}));
})(pixi_spine || (pixi_spine = {}));
var pixi_spine;
(function (pixi_spine) {
    var core;
    (function (core) {
        var SkeletonClipping = (function () {
            function SkeletonClipping() {
                this.triangulator = new core.Triangulator();
                this.clippingPolygon = new Array();
                this.clipOutput = new Array();
                this.clippedVertices = new Array();
                this.clippedTriangles = new Array();
                this.scratch = new Array();
            }
            SkeletonClipping.prototype.clipStart = function (slot, clip) {
                if (this.clipAttachment != null)
                    return 0;
                this.clipAttachment = clip;
                var n = clip.worldVerticesLength;
                var vertices = core.Utils.setArraySize(this.clippingPolygon, n);
                clip.computeWorldVertices(slot, 0, n, vertices, 0, 2);
                var clippingPolygon = this.clippingPolygon;
                SkeletonClipping.makeClockwise(clippingPolygon);
                var clippingPolygons = this.clippingPolygons = this.triangulator.decompose(clippingPolygon, this.triangulator.triangulate(clippingPolygon));
                for (var i = 0, n_1 = clippingPolygons.length; i < n_1; i++) {
                    var polygon = clippingPolygons[i];
                    SkeletonClipping.makeClockwise(polygon);
                    polygon.push(polygon[0]);
                    polygon.push(polygon[1]);
                }
                return clippingPolygons.length;
            };
            SkeletonClipping.prototype.clipEndWithSlot = function (slot) {
                if (this.clipAttachment != null && this.clipAttachment.endSlot == slot.data)
                    this.clipEnd();
            };
            SkeletonClipping.prototype.clipEnd = function () {
                if (this.clipAttachment == null)
                    return;
                this.clipAttachment = null;
                this.clippingPolygons = null;
                this.clippedVertices.length = 0;
                this.clippedTriangles.length = 0;
                this.clippingPolygon.length = 0;
            };
            SkeletonClipping.prototype.isClipping = function () {
                return this.clipAttachment != null;
            };
            SkeletonClipping.prototype.clipTriangles = function (vertices, verticesLength, triangles, trianglesLength, uvs, light, dark, twoColor) {
                var clipOutput = this.clipOutput, clippedVertices = this.clippedVertices;
                var clippedTriangles = this.clippedTriangles;
                var polygons = this.clippingPolygons;
                var polygonsCount = this.clippingPolygons.length;
                var vertexSize = twoColor ? 12 : 8;
                var index = 0;
                clippedVertices.length = 0;
                clippedTriangles.length = 0;
                outer: for (var i = 0; i < trianglesLength; i += 3) {
                    var vertexOffset = triangles[i] << 1;
                    var x1 = vertices[vertexOffset], y1 = vertices[vertexOffset + 1];
                    var u1 = uvs[vertexOffset], v1 = uvs[vertexOffset + 1];
                    vertexOffset = triangles[i + 1] << 1;
                    var x2 = vertices[vertexOffset], y2 = vertices[vertexOffset + 1];
                    var u2 = uvs[vertexOffset], v2 = uvs[vertexOffset + 1];
                    vertexOffset = triangles[i + 2] << 1;
                    var x3 = vertices[vertexOffset], y3 = vertices[vertexOffset + 1];
                    var u3 = uvs[vertexOffset], v3 = uvs[vertexOffset + 1];
                    for (var p = 0; p < polygonsCount; p++) {
                        var s = clippedVertices.length;
                        if (this.clip(x1, y1, x2, y2, x3, y3, polygons[p], clipOutput)) {
                            var clipOutputLength = clipOutput.length;
                            if (clipOutputLength == 0)
                                continue;
                            var d0 = y2 - y3, d1 = x3 - x2, d2 = x1 - x3, d4 = y3 - y1;
                            var d = 1 / (d0 * d2 + d1 * (y1 - y3));
                            var clipOutputCount = clipOutputLength >> 1;
                            var clipOutputItems = this.clipOutput;
                            var clippedVerticesItems = core.Utils.setArraySize(clippedVertices, s + clipOutputCount * vertexSize);
                            for (var ii = 0; ii < clipOutputLength; ii += 2) {
                                var x = clipOutputItems[ii], y = clipOutputItems[ii + 1];
                                clippedVerticesItems[s] = x;
                                clippedVerticesItems[s + 1] = y;
                                clippedVerticesItems[s + 2] = light.r;
                                clippedVerticesItems[s + 3] = light.g;
                                clippedVerticesItems[s + 4] = light.b;
                                clippedVerticesItems[s + 5] = light.a;
                                var c0 = x - x3, c1 = y - y3;
                                var a = (d0 * c0 + d1 * c1) * d;
                                var b = (d4 * c0 + d2 * c1) * d;
                                var c = 1 - a - b;
                                clippedVerticesItems[s + 6] = u1 * a + u2 * b + u3 * c;
                                clippedVerticesItems[s + 7] = v1 * a + v2 * b + v3 * c;
                                if (twoColor) {
                                    clippedVerticesItems[s + 8] = dark.r;
                                    clippedVerticesItems[s + 9] = dark.g;
                                    clippedVerticesItems[s + 10] = dark.b;
                                    clippedVerticesItems[s + 11] = dark.a;
                                }
                                s += vertexSize;
                            }
                            s = clippedTriangles.length;
                            var clippedTrianglesItems = core.Utils.setArraySize(clippedTriangles, s + 3 * (clipOutputCount - 2));
                            clipOutputCount--;
                            for (var ii = 1; ii < clipOutputCount; ii++) {
                                clippedTrianglesItems[s] = index;
                                clippedTrianglesItems[s + 1] = (index + ii);
                                clippedTrianglesItems[s + 2] = (index + ii + 1);
                                s += 3;
                            }
                            index += clipOutputCount + 1;
                        }
                        else {
                            var clippedVerticesItems = core.Utils.setArraySize(clippedVertices, s + 3 * vertexSize);
                            clippedVerticesItems[s] = x1;
                            clippedVerticesItems[s + 1] = y1;
                            clippedVerticesItems[s + 2] = light.r;
                            clippedVerticesItems[s + 3] = light.g;
                            clippedVerticesItems[s + 4] = light.b;
                            clippedVerticesItems[s + 5] = light.a;
                            if (!twoColor) {
                                clippedVerticesItems[s + 6] = u1;
                                clippedVerticesItems[s + 7] = v1;
                                clippedVerticesItems[s + 8] = x2;
                                clippedVerticesItems[s + 9] = y2;
                                clippedVerticesItems[s + 10] = light.r;
                                clippedVerticesItems[s + 11] = light.g;
                                clippedVerticesItems[s + 12] = light.b;
                                clippedVerticesItems[s + 13] = light.a;
                                clippedVerticesItems[s + 14] = u2;
                                clippedVerticesItems[s + 15] = v2;
                                clippedVerticesItems[s + 16] = x3;
                                clippedVerticesItems[s + 17] = y3;
                                clippedVerticesItems[s + 18] = light.r;
                                clippedVerticesItems[s + 19] = light.g;
                                clippedVerticesItems[s + 20] = light.b;
                                clippedVerticesItems[s + 21] = light.a;
                                clippedVerticesItems[s + 22] = u3;
                                clippedVerticesItems[s + 23] = v3;
                            }
                            else {
                                clippedVerticesItems[s + 6] = u1;
                                clippedVerticesItems[s + 7] = v1;
                                clippedVerticesItems[s + 8] = dark.r;
                                clippedVerticesItems[s + 9] = dark.g;
                                clippedVerticesItems[s + 10] = dark.b;
                                clippedVerticesItems[s + 11] = dark.a;
                                clippedVerticesItems[s + 12] = x2;
                                clippedVerticesItems[s + 13] = y2;
                                clippedVerticesItems[s + 14] = light.r;
                                clippedVerticesItems[s + 15] = light.g;
                                clippedVerticesItems[s + 16] = light.b;
                                clippedVerticesItems[s + 17] = light.a;
                                clippedVerticesItems[s + 18] = u2;
                                clippedVerticesItems[s + 19] = v2;
                                clippedVerticesItems[s + 20] = dark.r;
                                clippedVerticesItems[s + 21] = dark.g;
                                clippedVerticesItems[s + 22] = dark.b;
                                clippedVerticesItems[s + 23] = dark.a;
                                clippedVerticesItems[s + 24] = x3;
                                clippedVerticesItems[s + 25] = y3;
                                clippedVerticesItems[s + 26] = light.r;
                                clippedVerticesItems[s + 27] = light.g;
                                clippedVerticesItems[s + 28] = light.b;
                                clippedVerticesItems[s + 29] = light.a;
                                clippedVerticesItems[s + 30] = u3;
                                clippedVerticesItems[s + 31] = v3;
                                clippedVerticesItems[s + 32] = dark.r;
                                clippedVerticesItems[s + 33] = dark.g;
                                clippedVerticesItems[s + 34] = dark.b;
                                clippedVerticesItems[s + 35] = dark.a;
                            }
                            s = clippedTriangles.length;
                            var clippedTrianglesItems = core.Utils.setArraySize(clippedTriangles, s + 3);
                            clippedTrianglesItems[s] = index;
                            clippedTrianglesItems[s + 1] = (index + 1);
                            clippedTrianglesItems[s + 2] = (index + 2);
                            index += 3;
                            continue outer;
                        }
                    }
                }
            };
            SkeletonClipping.prototype.clip = function (x1, y1, x2, y2, x3, y3, clippingArea, output) {
                var originalOutput = output;
                var clipped = false;
                var input = null;
                if (clippingArea.length % 4 >= 2) {
                    input = output;
                    output = this.scratch;
                }
                else
                    input = this.scratch;
                input.length = 0;
                input.push(x1);
                input.push(y1);
                input.push(x2);
                input.push(y2);
                input.push(x3);
                input.push(y3);
                input.push(x1);
                input.push(y1);
                output.length = 0;
                var clippingVertices = clippingArea;
                var clippingVerticesLast = clippingArea.length - 4;
                for (var i = 0;; i += 2) {
                    var edgeX = clippingVertices[i], edgeY = clippingVertices[i + 1];
                    var edgeX2 = clippingVertices[i + 2], edgeY2 = clippingVertices[i + 3];
                    var deltaX = edgeX - edgeX2, deltaY = edgeY - edgeY2;
                    var inputVertices = input;
                    var inputVerticesLength = input.length - 2, outputStart = output.length;
                    for (var ii = 0; ii < inputVerticesLength; ii += 2) {
                        var inputX = inputVertices[ii], inputY = inputVertices[ii + 1];
                        var inputX2 = inputVertices[ii + 2], inputY2 = inputVertices[ii + 3];
                        var side2 = deltaX * (inputY2 - edgeY2) - deltaY * (inputX2 - edgeX2) > 0;
                        if (deltaX * (inputY - edgeY2) - deltaY * (inputX - edgeX2) > 0) {
                            if (side2) {
                                output.push(inputX2);
                                output.push(inputY2);
                                continue;
                            }
                            var c0 = inputY2 - inputY, c2 = inputX2 - inputX;
                            var ua = (c2 * (edgeY - inputY) - c0 * (edgeX - inputX)) / (c0 * (edgeX2 - edgeX) - c2 * (edgeY2 - edgeY));
                            output.push(edgeX + (edgeX2 - edgeX) * ua);
                            output.push(edgeY + (edgeY2 - edgeY) * ua);
                        }
                        else if (side2) {
                            var c0 = inputY2 - inputY, c2 = inputX2 - inputX;
                            var ua = (c2 * (edgeY - inputY) - c0 * (edgeX - inputX)) / (c0 * (edgeX2 - edgeX) - c2 * (edgeY2 - edgeY));
                            output.push(edgeX + (edgeX2 - edgeX) * ua);
                            output.push(edgeY + (edgeY2 - edgeY) * ua);
                            output.push(inputX2);
                            output.push(inputY2);
                        }
                        clipped = true;
                    }
                    if (outputStart == output.length) {
                        originalOutput.length = 0;
                        return true;
                    }
                    output.push(output[0]);
                    output.push(output[1]);
                    if (i == clippingVerticesLast)
                        break;
                    var temp = output;
                    output = input;
                    output.length = 0;
                    input = temp;
                }
                if (originalOutput != output) {
                    originalOutput.length = 0;
                    for (var i = 0, n = output.length - 2; i < n; i++)
                        originalOutput[i] = output[i];
                }
                else
                    originalOutput.length = originalOutput.length - 2;
                return clipped;
            };
            SkeletonClipping.makeClockwise = function (polygon) {
                var vertices = polygon;
                var verticeslength = polygon.length;
                var area = vertices[verticeslength - 2] * vertices[1] - vertices[0] * vertices[verticeslength - 1], p1x = 0, p1y = 0, p2x = 0, p2y = 0;
                for (var i = 0, n = verticeslength - 3; i < n; i += 2) {
                    p1x = vertices[i];
                    p1y = vertices[i + 1];
                    p2x = vertices[i + 2];
                    p2y = vertices[i + 3];
                    area += p1x * p2y - p2x * p1y;
                }
                if (area < 0)
                    return;
                for (var i = 0, lastX = verticeslength - 2, n = verticeslength >> 1; i < n; i += 2) {
                    var x = vertices[i], y = vertices[i + 1];
                    var other = lastX - i;
                    vertices[i] = vertices[other];
                    vertices[i + 1] = vertices[other + 1];
                    vertices[other] = x;
                    vertices[other + 1] = y;
                }
            };
            return SkeletonClipping;
        }());
        core.SkeletonClipping = SkeletonClipping;
    })(core = pixi_spine.core || (pixi_spine.core = {}));
})(pixi_spine || (pixi_spine = {}));
var pixi_spine;
(function (pixi_spine) {
    var core;
    (function (core) {
        var SkeletonData = (function () {
            function SkeletonData() {
                this.bones = new Array();
                this.slots = new Array();
                this.skins = new Array();
                this.events = new Array();
                this.animations = new Array();
                this.ikConstraints = new Array();
                this.transformConstraints = new Array();
                this.pathConstraints = new Array();
                this.fps = 0;
            }
            SkeletonData.prototype.findBone = function (boneName) {
                if (boneName == null)
                    throw new Error("boneName cannot be null.");
                var bones = this.bones;
                for (var i = 0, n = bones.length; i < n; i++) {
                    var bone = bones[i];
                    if (bone.name == boneName)
                        return bone;
                }
                return null;
            };
            SkeletonData.prototype.findBoneIndex = function (boneName) {
                if (boneName == null)
                    throw new Error("boneName cannot be null.");
                var bones = this.bones;
                for (var i = 0, n = bones.length; i < n; i++)
                    if (bones[i].name == boneName)
                        return i;
                return -1;
            };
            SkeletonData.prototype.findSlot = function (slotName) {
                if (slotName == null)
                    throw new Error("slotName cannot be null.");
                var slots = this.slots;
                for (var i = 0, n = slots.length; i < n; i++) {
                    var slot = slots[i];
                    if (slot.name == slotName)
                        return slot;
                }
                return null;
            };
            SkeletonData.prototype.findSlotIndex = function (slotName) {
                if (slotName == null)
                    throw new Error("slotName cannot be null.");
                var slots = this.slots;
                for (var i = 0, n = slots.length; i < n; i++)
                    if (slots[i].name == slotName)
                        return i;
                return -1;
            };
            SkeletonData.prototype.findSkin = function (skinName) {
                if (skinName == null)
                    throw new Error("skinName cannot be null.");
                var skins = this.skins;
                for (var i = 0, n = skins.length; i < n; i++) {
                    var skin = skins[i];
                    if (skin.name == skinName)
                        return skin;
                }
                return null;
            };
            SkeletonData.prototype.findEvent = function (eventDataName) {
                if (eventDataName == null)
                    throw new Error("eventDataName cannot be null.");
                var events = this.events;
                for (var i = 0, n = events.length; i < n; i++) {
                    var event_5 = events[i];
                    if (event_5.name == eventDataName)
                        return event_5;
                }
                return null;
            };
            SkeletonData.prototype.findAnimation = function (animationName) {
                if (animationName == null)
                    throw new Error("animationName cannot be null.");
                var animations = this.animations;
                for (var i = 0, n = animations.length; i < n; i++) {
                    var animation = animations[i];
                    if (animation.name == animationName)
                        return animation;
                }
                return null;
            };
            SkeletonData.prototype.findIkConstraint = function (constraintName) {
                if (constraintName == null)
                    throw new Error("constraintName cannot be null.");
                var ikConstraints = this.ikConstraints;
                for (var i = 0, n = ikConstraints.length; i < n; i++) {
                    var constraint = ikConstraints[i];
                    if (constraint.name == constraintName)
                        return constraint;
                }
                return null;
            };
            SkeletonData.prototype.findTransformConstraint = function (constraintName) {
                if (constraintName == null)
                    throw new Error("constraintName cannot be null.");
                var transformConstraints = this.transformConstraints;
                for (var i = 0, n = transformConstraints.length; i < n; i++) {
                    var constraint = transformConstraints[i];
                    if (constraint.name == constraintName)
                        return constraint;
                }
                return null;
            };
            SkeletonData.prototype.findPathConstraint = function (constraintName) {
                if (constraintName == null)
                    throw new Error("constraintName cannot be null.");
                var pathConstraints = this.pathConstraints;
                for (var i = 0, n = pathConstraints.length; i < n; i++) {
                    var constraint = pathConstraints[i];
                    if (constraint.name == constraintName)
                        return constraint;
                }
                return null;
            };
            SkeletonData.prototype.findPathConstraintIndex = function (pathConstraintName) {
                if (pathConstraintName == null)
                    throw new Error("pathConstraintName cannot be null.");
                var pathConstraints = this.pathConstraints;
                for (var i = 0, n = pathConstraints.length; i < n; i++)
                    if (pathConstraints[i].name == pathConstraintName)
                        return i;
                return -1;
            };
            return SkeletonData;
        }());
        core.SkeletonData = SkeletonData;
    })(core = pixi_spine.core || (pixi_spine.core = {}));
})(pixi_spine || (pixi_spine = {}));
var pixi_spine;
(function (pixi_spine) {
    var core;
    (function (core) {
        var SkeletonJson = (function () {
            function SkeletonJson(attachmentLoader) {
                this.scale = 1;
                this.linkedMeshes = new Array();
                this.attachmentLoader = attachmentLoader;
            }
            SkeletonJson.prototype.readSkeletonData = function (json) {
                var scale = this.scale;
                var skeletonData = new core.SkeletonData();
                var root = typeof (json) === "string" ? JSON.parse(json) : json;
                var skeletonMap = root.skeleton;
                if (skeletonMap != null) {
                    skeletonData.hash = skeletonMap.hash;
                    skeletonData.version = skeletonMap.spine;
                    skeletonData.x = skeletonMap.x;
                    skeletonData.y = skeletonMap.y;
                    skeletonData.width = skeletonMap.width;
                    skeletonData.height = skeletonMap.height;
                    skeletonData.fps = skeletonMap.fps;
                    skeletonData.imagesPath = skeletonMap.images;
                }
                if (root.bones) {
                    for (var i = 0; i < root.bones.length; i++) {
                        var boneMap = root.bones[i];
                        var parent_5 = null;
                        var parentName = this.getValue(boneMap, "parent", null);
                        if (parentName != null) {
                            parent_5 = skeletonData.findBone(parentName);
                            if (parent_5 == null)
                                throw new Error("Parent bone not found: " + parentName);
                        }
                        var data = new core.BoneData(skeletonData.bones.length, boneMap.name, parent_5);
                        data.length = this.getValue(boneMap, "length", 0) * scale;
                        data.x = this.getValue(boneMap, "x", 0) * scale;
                        data.y = this.getValue(boneMap, "y", 0) * scale;
                        data.rotation = this.getValue(boneMap, "rotation", 0);
                        data.scaleX = this.getValue(boneMap, "scaleX", 1);
                        data.scaleY = this.getValue(boneMap, "scaleY", 1);
                        data.shearX = this.getValue(boneMap, "shearX", 0);
                        data.shearY = this.getValue(boneMap, "shearY", 0);
                        data.transformMode = SkeletonJson.transformModeFromString(this.getValue(boneMap, "transform", "normal"));
                        data.skinRequired = this.getValue(boneMap, "skin", false);
                        skeletonData.bones.push(data);
                    }
                }
                if (root.slots) {
                    for (var i = 0; i < root.slots.length; i++) {
                        var slotMap = root.slots[i];
                        var slotName = slotMap.name;
                        var boneName = slotMap.bone;
                        var boneData = skeletonData.findBone(boneName);
                        if (boneData == null)
                            throw new Error("Slot bone not found: " + boneName);
                        var data = new core.SlotData(skeletonData.slots.length, slotName, boneData);
                        var color = this.getValue(slotMap, "color", null);
                        if (color != null)
                            data.color.setFromString(color);
                        var dark = this.getValue(slotMap, "dark", null);
                        if (dark != null) {
                            data.darkColor = new core.Color(1, 1, 1, 1);
                            data.darkColor.setFromString(dark);
                        }
                        data.attachmentName = this.getValue(slotMap, "attachment", null);
                        data.blendMode = SkeletonJson.blendModeFromString(this.getValue(slotMap, "blend", "normal"));
                        skeletonData.slots.push(data);
                    }
                }
                if (root.ik) {
                    for (var i = 0; i < root.ik.length; i++) {
                        var constraintMap = root.ik[i];
                        var data = new core.IkConstraintData(constraintMap.name);
                        data.order = this.getValue(constraintMap, "order", 0);
                        data.skinRequired = this.getValue(constraintMap, "skin", false);
                        for (var j = 0; j < constraintMap.bones.length; j++) {
                            var boneName = constraintMap.bones[j];
                            var bone = skeletonData.findBone(boneName);
                            if (bone == null)
                                throw new Error("IK bone not found: " + boneName);
                            data.bones.push(bone);
                        }
                        var targetName = constraintMap.target;
                        data.target = skeletonData.findBone(targetName);
                        if (data.target == null)
                            throw new Error("IK target bone not found: " + targetName);
                        data.mix = this.getValue(constraintMap, "mix", 1);
                        data.softness = this.getValue(constraintMap, "softness", 0) * scale;
                        data.bendDirection = this.getValue(constraintMap, "bendPositive", true) ? 1 : -1;
                        data.compress = this.getValue(constraintMap, "compress", false);
                        data.stretch = this.getValue(constraintMap, "stretch", false);
                        data.uniform = this.getValue(constraintMap, "uniform", false);
                        skeletonData.ikConstraints.push(data);
                    }
                }
                if (root.transform) {
                    for (var i = 0; i < root.transform.length; i++) {
                        var constraintMap = root.transform[i];
                        var data = new core.TransformConstraintData(constraintMap.name);
                        data.order = this.getValue(constraintMap, "order", 0);
                        data.skinRequired = this.getValue(constraintMap, "skin", false);
                        for (var j = 0; j < constraintMap.bones.length; j++) {
                            var boneName = constraintMap.bones[j];
                            var bone = skeletonData.findBone(boneName);
                            if (bone == null)
                                throw new Error("Transform constraint bone not found: " + boneName);
                            data.bones.push(bone);
                        }
                        var targetName = constraintMap.target;
                        data.target = skeletonData.findBone(targetName);
                        if (data.target == null)
                            throw new Error("Transform constraint target bone not found: " + targetName);
                        data.local = this.getValue(constraintMap, "local", false);
                        data.relative = this.getValue(constraintMap, "relative", false);
                        data.offsetRotation = this.getValue(constraintMap, "rotation", 0);
                        data.offsetX = this.getValue(constraintMap, "x", 0) * scale;
                        data.offsetY = this.getValue(constraintMap, "y", 0) * scale;
                        data.offsetScaleX = this.getValue(constraintMap, "scaleX", 0);
                        data.offsetScaleY = this.getValue(constraintMap, "scaleY", 0);
                        data.offsetShearY = this.getValue(constraintMap, "shearY", 0);
                        data.rotateMix = this.getValue(constraintMap, "rotateMix", 1);
                        data.translateMix = this.getValue(constraintMap, "translateMix", 1);
                        data.scaleMix = this.getValue(constraintMap, "scaleMix", 1);
                        data.shearMix = this.getValue(constraintMap, "shearMix", 1);
                        skeletonData.transformConstraints.push(data);
                    }
                }
                if (root.path) {
                    for (var i = 0; i < root.path.length; i++) {
                        var constraintMap = root.path[i];
                        var data = new core.PathConstraintData(constraintMap.name);
                        data.order = this.getValue(constraintMap, "order", 0);
                        data.skinRequired = this.getValue(constraintMap, "skin", false);
                        for (var j = 0; j < constraintMap.bones.length; j++) {
                            var boneName = constraintMap.bones[j];
                            var bone = skeletonData.findBone(boneName);
                            if (bone == null)
                                throw new Error("Transform constraint bone not found: " + boneName);
                            data.bones.push(bone);
                        }
                        var targetName = constraintMap.target;
                        data.target = skeletonData.findSlot(targetName);
                        if (data.target == null)
                            throw new Error("Path target slot not found: " + targetName);
                        data.positionMode = SkeletonJson.positionModeFromString(this.getValue(constraintMap, "positionMode", "percent"));
                        data.spacingMode = SkeletonJson.spacingModeFromString(this.getValue(constraintMap, "spacingMode", "length"));
                        data.rotateMode = SkeletonJson.rotateModeFromString(this.getValue(constraintMap, "rotateMode", "tangent"));
                        data.offsetRotation = this.getValue(constraintMap, "rotation", 0);
                        data.position = this.getValue(constraintMap, "position", 0);
                        if (data.positionMode == core.PositionMode.Fixed)
                            data.position *= scale;
                        data.spacing = this.getValue(constraintMap, "spacing", 0);
                        if (data.spacingMode == core.SpacingMode.Length || data.spacingMode == core.SpacingMode.Fixed)
                            data.spacing *= scale;
                        data.rotateMix = this.getValue(constraintMap, "rotateMix", 1);
                        data.translateMix = this.getValue(constraintMap, "translateMix", 1);
                        skeletonData.pathConstraints.push(data);
                    }
                }
                if (root.skins) {
                    for (var i = 0; i < root.skins.length; i++) {
                        var skinMap = root.skins[i];
                        var skin = new core.Skin(skinMap.name);
                        if (skinMap.bones) {
                            for (var ii = 0; ii < skinMap.bones.length; ii++) {
                                var bone = skeletonData.findBone(skinMap.bones[ii]);
                                if (bone == null)
                                    throw new Error("Skin bone not found: " + skinMap.bones[i]);
                                skin.bones.push(bone);
                            }
                        }
                        if (skinMap.ik) {
                            for (var ii = 0; ii < skinMap.ik.length; ii++) {
                                var constraint = skeletonData.findIkConstraint(skinMap.ik[ii]);
                                if (constraint == null)
                                    throw new Error("Skin IK constraint not found: " + skinMap.ik[i]);
                                skin.constraints.push(constraint);
                            }
                        }
                        if (skinMap.transform) {
                            for (var ii = 0; ii < skinMap.transform.length; ii++) {
                                var constraint = skeletonData.findTransformConstraint(skinMap.transform[ii]);
                                if (constraint == null)
                                    throw new Error("Skin transform constraint not found: " + skinMap.transform[i]);
                                skin.constraints.push(constraint);
                            }
                        }
                        if (skinMap.path) {
                            for (var ii = 0; ii < skinMap.path.length; ii++) {
                                var constraint = skeletonData.findPathConstraint(skinMap.path[ii]);
                                if (constraint == null)
                                    throw new Error("Skin path constraint not found: " + skinMap.path[i]);
                                skin.constraints.push(constraint);
                            }
                        }
                        for (var slotName in skinMap.attachments) {
                            var slot = skeletonData.findSlot(slotName);
                            if (slot == null)
                                throw new Error("Slot not found: " + slotName);
                            var slotMap = skinMap.attachments[slotName];
                            for (var entryName in slotMap) {
                                var attachment = this.readAttachment(slotMap[entryName], skin, slot.index, entryName, skeletonData);
                                if (attachment != null)
                                    skin.setAttachment(slot.index, entryName, attachment);
                            }
                        }
                        skeletonData.skins.push(skin);
                        if (skin.name == "default")
                            skeletonData.defaultSkin = skin;
                    }
                }
                for (var i = 0, n = this.linkedMeshes.length; i < n; i++) {
                    var linkedMesh = this.linkedMeshes[i];
                    var skin = linkedMesh.skin == null ? skeletonData.defaultSkin : skeletonData.findSkin(linkedMesh.skin);
                    if (skin == null)
                        throw new Error("Skin not found: " + linkedMesh.skin);
                    var parent_6 = skin.getAttachment(linkedMesh.slotIndex, linkedMesh.parent);
                    if (parent_6 == null)
                        throw new Error("Parent mesh not found: " + linkedMesh.parent);
                    linkedMesh.mesh.deformAttachment = linkedMesh.inheritDeform ? parent_6 : linkedMesh.mesh;
                    linkedMesh.mesh.setParentMesh(parent_6);
                }
                this.linkedMeshes.length = 0;
                if (root.events) {
                    for (var eventName in root.events) {
                        var eventMap = root.events[eventName];
                        var data = new core.EventData(eventName);
                        data.intValue = this.getValue(eventMap, "int", 0);
                        data.floatValue = this.getValue(eventMap, "float", 0);
                        data.stringValue = this.getValue(eventMap, "string", "");
                        data.audioPath = this.getValue(eventMap, "audio", null);
                        if (data.audioPath != null) {
                            data.volume = this.getValue(eventMap, "volume", 1);
                            data.balance = this.getValue(eventMap, "balance", 0);
                        }
                        skeletonData.events.push(data);
                    }
                }
                if (root.animations) {
                    for (var animationName in root.animations) {
                        var animationMap = root.animations[animationName];
                        this.readAnimation(animationMap, animationName, skeletonData);
                    }
                }
                return skeletonData;
            };
            SkeletonJson.prototype.readAttachment = function (map, skin, slotIndex, name, skeletonData) {
                var scale = this.scale;
                name = this.getValue(map, "name", name);
                var type = this.getValue(map, "type", "region");
                switch (type) {
                    case "region": {
                        var path = this.getValue(map, "path", name);
                        var region = this.attachmentLoader.newRegionAttachment(skin, name, path);
                        if (region == null)
                            return null;
                        region.path = path;
                        region.x = this.getValue(map, "x", 0) * scale;
                        region.y = this.getValue(map, "y", 0) * scale;
                        region.scaleX = this.getValue(map, "scaleX", 1);
                        region.scaleY = this.getValue(map, "scaleY", 1);
                        region.rotation = this.getValue(map, "rotation", 0);
                        region.width = map.width * scale;
                        region.height = map.height * scale;
                        var color = this.getValue(map, "color", null);
                        if (color != null)
                            region.color.setFromString(color);
                        return region;
                    }
                    case "boundingbox": {
                        var box = this.attachmentLoader.newBoundingBoxAttachment(skin, name);
                        if (box == null)
                            return null;
                        this.readVertices(map, box, map.vertexCount << 1);
                        var color = this.getValue(map, "color", null);
                        if (color != null)
                            box.color.setFromString(color);
                        return box;
                    }
                    case "mesh":
                    case "linkedmesh": {
                        var path = this.getValue(map, "path", name);
                        var mesh = this.attachmentLoader.newMeshAttachment(skin, name, path);
                        if (mesh == null)
                            return null;
                        mesh.path = path;
                        var color = this.getValue(map, "color", null);
                        if (color != null)
                            mesh.color.setFromString(color);
                        mesh.width = this.getValue(map, "width", 0) * scale;
                        mesh.height = this.getValue(map, "height", 0) * scale;
                        var parent_7 = this.getValue(map, "parent", null);
                        if (parent_7 != null) {
                            this.linkedMeshes.push(new LinkedMesh(mesh, this.getValue(map, "skin", null), slotIndex, parent_7, this.getValue(map, "deform", true)));
                            return mesh;
                        }
                        var uvs = map.uvs;
                        this.readVertices(map, mesh, uvs.length);
                        mesh.triangles = map.triangles;
                        mesh.regionUVs = new Float32Array(uvs);
                        mesh.edges = this.getValue(map, "edges", null);
                        mesh.hullLength = this.getValue(map, "hull", 0) * 2;
                        return mesh;
                    }
                    case "path": {
                        var path = this.attachmentLoader.newPathAttachment(skin, name);
                        if (path == null)
                            return null;
                        path.closed = this.getValue(map, "closed", false);
                        path.constantSpeed = this.getValue(map, "constantSpeed", true);
                        var vertexCount = map.vertexCount;
                        this.readVertices(map, path, vertexCount << 1);
                        var lengths = core.Utils.newArray(vertexCount / 3, 0);
                        for (var i = 0; i < map.lengths.length; i++)
                            lengths[i] = map.lengths[i] * scale;
                        path.lengths = lengths;
                        var color = this.getValue(map, "color", null);
                        if (color != null)
                            path.color.setFromString(color);
                        return path;
                    }
                    case "point": {
                        var point = this.attachmentLoader.newPointAttachment(skin, name);
                        if (point == null)
                            return null;
                        point.x = this.getValue(map, "x", 0) * scale;
                        point.y = this.getValue(map, "y", 0) * scale;
                        point.rotation = this.getValue(map, "rotation", 0);
                        var color = this.getValue(map, "color", null);
                        if (color != null)
                            point.color.setFromString(color);
                        return point;
                    }
                    case "clipping": {
                        var clip = this.attachmentLoader.newClippingAttachment(skin, name);
                        if (clip == null)
                            return null;
                        var end = this.getValue(map, "end", null);
                        if (end != null) {
                            var slot = skeletonData.findSlot(end);
                            if (slot == null)
                                throw new Error("Clipping end slot not found: " + end);
                            clip.endSlot = slot;
                        }
                        var vertexCount = map.vertexCount;
                        this.readVertices(map, clip, vertexCount << 1);
                        var color = this.getValue(map, "color", null);
                        if (color != null)
                            clip.color.setFromString(color);
                        return clip;
                    }
                }
                return null;
            };
            SkeletonJson.prototype.readVertices = function (map, attachment, verticesLength) {
                var scale = this.scale;
                attachment.worldVerticesLength = verticesLength;
                var vertices = map.vertices;
                if (verticesLength == vertices.length) {
                    var scaledVertices = core.Utils.toFloatArray(vertices);
                    if (scale != 1) {
                        for (var i = 0, n = vertices.length; i < n; i++)
                            scaledVertices[i] *= scale;
                    }
                    attachment.vertices = scaledVertices;
                    return;
                }
                var weights = new Array();
                var bones = new Array();
                for (var i = 0, n = vertices.length; i < n;) {
                    var boneCount = vertices[i++];
                    bones.push(boneCount);
                    for (var nn = i + boneCount * 4; i < nn; i += 4) {
                        bones.push(vertices[i]);
                        weights.push(vertices[i + 1] * scale);
                        weights.push(vertices[i + 2] * scale);
                        weights.push(vertices[i + 3]);
                    }
                }
                attachment.bones = bones;
                attachment.vertices = core.Utils.toFloatArray(weights);
            };
            SkeletonJson.prototype.readAnimation = function (map, name, skeletonData) {
                var scale = this.scale;
                var timelines = new Array();
                var duration = 0;
                if (map.slots) {
                    for (var slotName in map.slots) {
                        var slotMap = map.slots[slotName];
                        var slotIndex = skeletonData.findSlotIndex(slotName);
                        if (slotIndex == -1)
                            throw new Error("Slot not found: " + slotName);
                        for (var timelineName in slotMap) {
                            var timelineMap = slotMap[timelineName];
                            if (timelineName == "attachment") {
                                var timeline = new core.AttachmentTimeline(timelineMap.length);
                                timeline.slotIndex = slotIndex;
                                var frameIndex = 0;
                                for (var i = 0; i < timelineMap.length; i++) {
                                    var valueMap = timelineMap[i];
                                    timeline.setFrame(frameIndex++, this.getValue(valueMap, "time", 0), valueMap.name);
                                }
                                timelines.push(timeline);
                                duration = Math.max(duration, timeline.frames[timeline.getFrameCount() - 1]);
                            }
                            else if (timelineName == "color") {
                                var timeline = new core.ColorTimeline(timelineMap.length);
                                timeline.slotIndex = slotIndex;
                                var frameIndex = 0;
                                for (var i = 0; i < timelineMap.length; i++) {
                                    var valueMap = timelineMap[i];
                                    var color = new core.Color();
                                    color.setFromString(valueMap.color || "ffffffff");
                                    timeline.setFrame(frameIndex, this.getValue(valueMap, "time", 0), color.r, color.g, color.b, color.a);
                                    this.readCurve(valueMap, timeline, frameIndex);
                                    frameIndex++;
                                }
                                timelines.push(timeline);
                                duration = Math.max(duration, timeline.frames[(timeline.getFrameCount() - 1) * core.ColorTimeline.ENTRIES]);
                            }
                            else if (timelineName == "twoColor") {
                                var timeline = new core.TwoColorTimeline(timelineMap.length);
                                timeline.slotIndex = slotIndex;
                                var frameIndex = 0;
                                for (var i = 0; i < timelineMap.length; i++) {
                                    var valueMap = timelineMap[i];
                                    var light = new core.Color();
                                    var dark = new core.Color();
                                    light.setFromString(valueMap.light);
                                    dark.setFromString(valueMap.dark);
                                    timeline.setFrame(frameIndex, this.getValue(valueMap, "time", 0), light.r, light.g, light.b, light.a, dark.r, dark.g, dark.b);
                                    this.readCurve(valueMap, timeline, frameIndex);
                                    frameIndex++;
                                }
                                timelines.push(timeline);
                                duration = Math.max(duration, timeline.frames[(timeline.getFrameCount() - 1) * core.TwoColorTimeline.ENTRIES]);
                            }
                            else
                                throw new Error("Invalid timeline type for a slot: " + timelineName + " (" + slotName + ")");
                        }
                    }
                }
                if (map.bones) {
                    for (var boneName in map.bones) {
                        var boneMap = map.bones[boneName];
                        var boneIndex = skeletonData.findBoneIndex(boneName);
                        if (boneIndex == -1)
                            throw new Error("Bone not found: " + boneName);
                        for (var timelineName in boneMap) {
                            var timelineMap = boneMap[timelineName];
                            if (timelineName === "rotate") {
                                var timeline = new core.RotateTimeline(timelineMap.length);
                                timeline.boneIndex = boneIndex;
                                var frameIndex = 0;
                                for (var i = 0; i < timelineMap.length; i++) {
                                    var valueMap = timelineMap[i];
                                    timeline.setFrame(frameIndex, this.getValue(valueMap, "time", 0), this.getValue(valueMap, "angle", 0));
                                    this.readCurve(valueMap, timeline, frameIndex);
                                    frameIndex++;
                                }
                                timelines.push(timeline);
                                duration = Math.max(duration, timeline.frames[(timeline.getFrameCount() - 1) * core.RotateTimeline.ENTRIES]);
                            }
                            else if (timelineName === "translate" || timelineName === "scale" || timelineName === "shear") {
                                var timeline = null;
                                var timelineScale = 1, defaultValue = 0;
                                if (timelineName === "scale") {
                                    timeline = new core.ScaleTimeline(timelineMap.length);
                                    defaultValue = 1;
                                }
                                else if (timelineName === "shear")
                                    timeline = new core.ShearTimeline(timelineMap.length);
                                else {
                                    timeline = new core.TranslateTimeline(timelineMap.length);
                                    timelineScale = scale;
                                }
                                timeline.boneIndex = boneIndex;
                                var frameIndex = 0;
                                for (var i = 0; i < timelineMap.length; i++) {
                                    var valueMap = timelineMap[i];
                                    var x = this.getValue(valueMap, "x", defaultValue), y = this.getValue(valueMap, "y", defaultValue);
                                    timeline.setFrame(frameIndex, this.getValue(valueMap, "time", 0), x * timelineScale, y * timelineScale);
                                    this.readCurve(valueMap, timeline, frameIndex);
                                    frameIndex++;
                                }
                                timelines.push(timeline);
                                duration = Math.max(duration, timeline.frames[(timeline.getFrameCount() - 1) * core.TranslateTimeline.ENTRIES]);
                            }
                            else
                                throw new Error("Invalid timeline type for a bone: " + timelineName + " (" + boneName + ")");
                        }
                    }
                }
                if (map.ik) {
                    for (var constraintName in map.ik) {
                        var constraintMap = map.ik[constraintName];
                        var constraint = skeletonData.findIkConstraint(constraintName);
                        var timeline = new core.IkConstraintTimeline(constraintMap.length);
                        timeline.ikConstraintIndex = skeletonData.ikConstraints.indexOf(constraint);
                        var frameIndex = 0;
                        for (var i = 0; i < constraintMap.length; i++) {
                            var valueMap = constraintMap[i];
                            timeline.setFrame(frameIndex, this.getValue(valueMap, "time", 0), this.getValue(valueMap, "mix", 1), this.getValue(valueMap, "softness", 0) * scale, this.getValue(valueMap, "bendPositive", true) ? 1 : -1, this.getValue(valueMap, "compress", false), this.getValue(valueMap, "stretch", false));
                            this.readCurve(valueMap, timeline, frameIndex);
                            frameIndex++;
                        }
                        timelines.push(timeline);
                        duration = Math.max(duration, timeline.frames[(timeline.getFrameCount() - 1) * core.IkConstraintTimeline.ENTRIES]);
                    }
                }
                if (map.transform) {
                    for (var constraintName in map.transform) {
                        var constraintMap = map.transform[constraintName];
                        var constraint = skeletonData.findTransformConstraint(constraintName);
                        var timeline = new core.TransformConstraintTimeline(constraintMap.length);
                        timeline.transformConstraintIndex = skeletonData.transformConstraints.indexOf(constraint);
                        var frameIndex = 0;
                        for (var i = 0; i < constraintMap.length; i++) {
                            var valueMap = constraintMap[i];
                            timeline.setFrame(frameIndex, this.getValue(valueMap, "time", 0), this.getValue(valueMap, "rotateMix", 1), this.getValue(valueMap, "translateMix", 1), this.getValue(valueMap, "scaleMix", 1), this.getValue(valueMap, "shearMix", 1));
                            this.readCurve(valueMap, timeline, frameIndex);
                            frameIndex++;
                        }
                        timelines.push(timeline);
                        duration = Math.max(duration, timeline.frames[(timeline.getFrameCount() - 1) * core.TransformConstraintTimeline.ENTRIES]);
                    }
                }
                if (map.path) {
                    for (var constraintName in map.path) {
                        var constraintMap = map.path[constraintName];
                        var index = skeletonData.findPathConstraintIndex(constraintName);
                        if (index == -1)
                            throw new Error("Path constraint not found: " + constraintName);
                        var data = skeletonData.pathConstraints[index];
                        for (var timelineName in constraintMap) {
                            var timelineMap = constraintMap[timelineName];
                            if (timelineName === "position" || timelineName === "spacing") {
                                var timeline = null;
                                var timelineScale = 1;
                                if (timelineName === "spacing") {
                                    timeline = new core.PathConstraintSpacingTimeline(timelineMap.length);
                                    if (data.spacingMode == core.SpacingMode.Length || data.spacingMode == core.SpacingMode.Fixed)
                                        timelineScale = scale;
                                }
                                else {
                                    timeline = new core.PathConstraintPositionTimeline(timelineMap.length);
                                    if (data.positionMode == core.PositionMode.Fixed)
                                        timelineScale = scale;
                                }
                                timeline.pathConstraintIndex = index;
                                var frameIndex = 0;
                                for (var i = 0; i < timelineMap.length; i++) {
                                    var valueMap = timelineMap[i];
                                    timeline.setFrame(frameIndex, this.getValue(valueMap, "time", 0), this.getValue(valueMap, timelineName, 0) * timelineScale);
                                    this.readCurve(valueMap, timeline, frameIndex);
                                    frameIndex++;
                                }
                                timelines.push(timeline);
                                duration = Math.max(duration, timeline.frames[(timeline.getFrameCount() - 1) * core.PathConstraintPositionTimeline.ENTRIES]);
                            }
                            else if (timelineName === "mix") {
                                var timeline = new core.PathConstraintMixTimeline(timelineMap.length);
                                timeline.pathConstraintIndex = index;
                                var frameIndex = 0;
                                for (var i = 0; i < timelineMap.length; i++) {
                                    var valueMap = timelineMap[i];
                                    timeline.setFrame(frameIndex, this.getValue(valueMap, "time", 0), this.getValue(valueMap, "rotateMix", 1), this.getValue(valueMap, "translateMix", 1));
                                    this.readCurve(valueMap, timeline, frameIndex);
                                    frameIndex++;
                                }
                                timelines.push(timeline);
                                duration = Math.max(duration, timeline.frames[(timeline.getFrameCount() - 1) * core.PathConstraintMixTimeline.ENTRIES]);
                            }
                        }
                    }
                }
                if (map.deform) {
                    for (var deformName in map.deform) {
                        var deformMap = map.deform[deformName];
                        var skin = skeletonData.findSkin(deformName);
                        if (skin == null)
                            throw new Error("Skin not found: " + deformName);
                        for (var slotName in deformMap) {
                            var slotMap = deformMap[slotName];
                            var slotIndex = skeletonData.findSlotIndex(slotName);
                            if (slotIndex == -1)
                                throw new Error("Slot not found: " + slotMap.name);
                            for (var timelineName in slotMap) {
                                var timelineMap = slotMap[timelineName];
                                var attachment = skin.getAttachment(slotIndex, timelineName);
                                if (attachment == null)
                                    throw new Error("Deform attachment not found: " + timelineMap.name);
                                var weighted = attachment.bones != null;
                                var vertices = attachment.vertices;
                                var deformLength = weighted ? vertices.length / 3 * 2 : vertices.length;
                                var timeline = new core.DeformTimeline(timelineMap.length);
                                timeline.slotIndex = slotIndex;
                                timeline.attachment = attachment;
                                var frameIndex = 0;
                                for (var j = 0; j < timelineMap.length; j++) {
                                    var valueMap = timelineMap[j];
                                    var deform = void 0;
                                    var verticesValue = this.getValue(valueMap, "vertices", null);
                                    if (verticesValue == null)
                                        deform = weighted ? core.Utils.newFloatArray(deformLength) : vertices;
                                    else {
                                        deform = core.Utils.newFloatArray(deformLength);
                                        var start = this.getValue(valueMap, "offset", 0);
                                        core.Utils.arrayCopy(verticesValue, 0, deform, start, verticesValue.length);
                                        if (scale != 1) {
                                            for (var i = start, n = i + verticesValue.length; i < n; i++)
                                                deform[i] *= scale;
                                        }
                                        if (!weighted) {
                                            for (var i = 0; i < deformLength; i++)
                                                deform[i] += vertices[i];
                                        }
                                    }
                                    timeline.setFrame(frameIndex, this.getValue(valueMap, "time", 0), deform);
                                    this.readCurve(valueMap, timeline, frameIndex);
                                    frameIndex++;
                                }
                                timelines.push(timeline);
                                duration = Math.max(duration, timeline.frames[timeline.getFrameCount() - 1]);
                            }
                        }
                    }
                }
                var drawOrderNode = map.drawOrder;
                if (drawOrderNode == null)
                    drawOrderNode = map.draworder;
                if (drawOrderNode != null) {
                    var timeline = new core.DrawOrderTimeline(drawOrderNode.length);
                    var slotCount = skeletonData.slots.length;
                    var frameIndex = 0;
                    for (var j = 0; j < drawOrderNode.length; j++) {
                        var drawOrderMap = drawOrderNode[j];
                        var drawOrder = null;
                        var offsets = this.getValue(drawOrderMap, "offsets", null);
                        if (offsets != null) {
                            drawOrder = core.Utils.newArray(slotCount, -1);
                            var unchanged = core.Utils.newArray(slotCount - offsets.length, 0);
                            var originalIndex = 0, unchangedIndex = 0;
                            for (var i = 0; i < offsets.length; i++) {
                                var offsetMap = offsets[i];
                                var slotIndex = skeletonData.findSlotIndex(offsetMap.slot);
                                if (slotIndex == -1)
                                    throw new Error("Slot not found: " + offsetMap.slot);
                                while (originalIndex != slotIndex)
                                    unchanged[unchangedIndex++] = originalIndex++;
                                drawOrder[originalIndex + offsetMap.offset] = originalIndex++;
                            }
                            while (originalIndex < slotCount)
                                unchanged[unchangedIndex++] = originalIndex++;
                            for (var i = slotCount - 1; i >= 0; i--)
                                if (drawOrder[i] == -1)
                                    drawOrder[i] = unchanged[--unchangedIndex];
                        }
                        timeline.setFrame(frameIndex++, this.getValue(drawOrderMap, "time", 0), drawOrder);
                    }
                    timelines.push(timeline);
                    duration = Math.max(duration, timeline.frames[timeline.getFrameCount() - 1]);
                }
                if (map.events) {
                    var timeline = new core.EventTimeline(map.events.length);
                    var frameIndex = 0;
                    for (var i = 0; i < map.events.length; i++) {
                        var eventMap = map.events[i];
                        var eventData = skeletonData.findEvent(eventMap.name);
                        if (eventData == null)
                            throw new Error("Event not found: " + eventMap.name);
                        var event_6 = new core.Event(core.Utils.toSinglePrecision(this.getValue(eventMap, "time", 0)), eventData);
                        event_6.intValue = this.getValue(eventMap, "int", eventData.intValue);
                        event_6.floatValue = this.getValue(eventMap, "float", eventData.floatValue);
                        event_6.stringValue = this.getValue(eventMap, "string", eventData.stringValue);
                        if (event_6.data.audioPath != null) {
                            event_6.volume = this.getValue(eventMap, "volume", 1);
                            event_6.balance = this.getValue(eventMap, "balance", 0);
                        }
                        timeline.setFrame(frameIndex++, event_6);
                    }
                    timelines.push(timeline);
                    duration = Math.max(duration, timeline.frames[timeline.getFrameCount() - 1]);
                }
                if (isNaN(duration)) {
                    throw new Error("Error while parsing animation, duration is NaN");
                }
                skeletonData.animations.push(new core.Animation(name, timelines, duration));
            };
            SkeletonJson.prototype.readCurve = function (map, timeline, frameIndex) {
                if (!map.curve)
                    return;
                if (map.curve === "stepped")
                    timeline.setStepped(frameIndex);
                else {
                    var curve = map.curve;
                    timeline.setCurve(frameIndex, curve, this.getValue(map, "c2", 0), this.getValue(map, "c3", 1), this.getValue(map, "c4", 1));
                }
            };
            SkeletonJson.prototype.getValue = function (map, prop, defaultValue) {
                return map[prop] !== undefined ? map[prop] : defaultValue;
            };
            SkeletonJson.blendModeFromString = function (str) {
                str = str.toLowerCase();
                if (str == "normal")
                    return core.BlendMode.Normal;
                if (str == "additive")
                    return core.BlendMode.Additive;
                if (str == "multiply")
                    return core.BlendMode.Multiply;
                if (str == "screen")
                    return core.BlendMode.Screen;
                throw new Error("Unknown blend mode: " + str);
            };
            SkeletonJson.positionModeFromString = function (str) {
                str = str.toLowerCase();
                if (str == "fixed")
                    return core.PositionMode.Fixed;
                if (str == "percent")
                    return core.PositionMode.Percent;
                throw new Error("Unknown position mode: " + str);
            };
            SkeletonJson.spacingModeFromString = function (str) {
                str = str.toLowerCase();
                if (str == "length")
                    return core.SpacingMode.Length;
                if (str == "fixed")
                    return core.SpacingMode.Fixed;
                if (str == "percent")
                    return core.SpacingMode.Percent;
                throw new Error("Unknown position mode: " + str);
            };
            SkeletonJson.rotateModeFromString = function (str) {
                str = str.toLowerCase();
                if (str == "tangent")
                    return core.RotateMode.Tangent;
                if (str == "chain")
                    return core.RotateMode.Chain;
                if (str == "chainscale")
                    return core.RotateMode.ChainScale;
                throw new Error("Unknown rotate mode: " + str);
            };
            SkeletonJson.transformModeFromString = function (str) {
                str = str.toLowerCase();
                if (str == "normal")
                    return core.TransformMode.Normal;
                if (str == "onlytranslation")
                    return core.TransformMode.OnlyTranslation;
                if (str == "norotationorreflection")
                    return core.TransformMode.NoRotationOrReflection;
                if (str == "noscale")
                    return core.TransformMode.NoScale;
                if (str == "noscaleorreflection")
                    return core.TransformMode.NoScaleOrReflection;
                throw new Error("Unknown transform mode: " + str);
            };
            return SkeletonJson;
        }());
        core.SkeletonJson = SkeletonJson;
        var LinkedMesh = (function () {
            function LinkedMesh(mesh, skin, slotIndex, parent, inheritDeform) {
                this.mesh = mesh;
                this.skin = skin;
                this.slotIndex = slotIndex;
                this.parent = parent;
                this.inheritDeform = inheritDeform;
            }
            return LinkedMesh;
        }());
    })(core = pixi_spine.core || (pixi_spine.core = {}));
})(pixi_spine || (pixi_spine = {}));
var pixi_spine;
(function (pixi_spine) {
    var core;
    (function (core) {
        var SkinEntry = (function () {
            function SkinEntry(slotIndex, name, attachment) {
                this.slotIndex = slotIndex;
                this.name = name;
                this.attachment = attachment;
            }
            return SkinEntry;
        }());
        core.SkinEntry = SkinEntry;
        var Skin = (function () {
            function Skin(name) {
                this.attachments = new Array();
                this.bones = Array();
                this.constraints = new Array();
                if (name == null)
                    throw new Error("name cannot be null.");
                this.name = name;
            }
            Skin.prototype.setAttachment = function (slotIndex, name, attachment) {
                if (attachment == null)
                    throw new Error("attachment cannot be null.");
                var attachments = this.attachments;
                if (slotIndex >= attachments.length)
                    attachments.length = slotIndex + 1;
                if (!attachments[slotIndex])
                    attachments[slotIndex] = {};
                attachments[slotIndex][name] = attachment;
            };
            Skin.prototype.addSkin = function (skin) {
                for (var i = 0; i < skin.bones.length; i++) {
                    var bone = skin.bones[i];
                    var contained = false;
                    for (var j = 0; j < this.bones.length; j++) {
                        if (this.bones[j] == bone) {
                            contained = true;
                            break;
                        }
                    }
                    if (!contained)
                        this.bones.push(bone);
                }
                for (var i = 0; i < skin.constraints.length; i++) {
                    var constraint = skin.constraints[i];
                    var contained = false;
                    for (var j = 0; j < this.constraints.length; j++) {
                        if (this.constraints[j] == constraint) {
                            contained = true;
                            break;
                        }
                    }
                    if (!contained)
                        this.constraints.push(constraint);
                }
                var attachments = skin.getAttachments();
                for (var i = 0; i < attachments.length; i++) {
                    var attachment = attachments[i];
                    this.setAttachment(attachment.slotIndex, attachment.name, attachment.attachment);
                }
            };
            Skin.prototype.copySkin = function (skin) {
                for (var i = 0; i < skin.bones.length; i++) {
                    var bone = skin.bones[i];
                    var contained = false;
                    for (var j = 0; j < this.bones.length; j++) {
                        if (this.bones[j] == bone) {
                            contained = true;
                            break;
                        }
                    }
                    if (!contained)
                        this.bones.push(bone);
                }
                for (var i = 0; i < skin.constraints.length; i++) {
                    var constraint = skin.constraints[i];
                    var contained = false;
                    for (var j = 0; j < this.constraints.length; j++) {
                        if (this.constraints[j] == constraint) {
                            contained = true;
                            break;
                        }
                    }
                    if (!contained)
                        this.constraints.push(constraint);
                }
                var attachments = skin.getAttachments();
                for (var i = 0; i < attachments.length; i++) {
                    var attachment = attachments[i];
                    if (attachment.attachment == null)
                        continue;
                    if (attachment.attachment instanceof core.MeshAttachment) {
                        attachment.attachment = attachment.attachment.newLinkedMesh();
                        this.setAttachment(attachment.slotIndex, attachment.name, attachment.attachment);
                    }
                    else {
                        attachment.attachment = attachment.attachment.copy();
                        this.setAttachment(attachment.slotIndex, attachment.name, attachment.attachment);
                    }
                }
            };
            Skin.prototype.getAttachment = function (slotIndex, name) {
                var dictionary = this.attachments[slotIndex];
                return dictionary ? dictionary[name] : null;
            };
            Skin.prototype.removeAttachment = function (slotIndex, name) {
                var dictionary = this.attachments[slotIndex];
                if (dictionary)
                    dictionary[name] = null;
            };
            Skin.prototype.getAttachments = function () {
                var entries = new Array();
                for (var i = 0; i < this.attachments.length; i++) {
                    var slotAttachments = this.attachments[i];
                    if (slotAttachments) {
                        for (var name_4 in slotAttachments) {
                            var attachment = slotAttachments[name_4];
                            if (attachment)
                                entries.push(new SkinEntry(i, name_4, attachment));
                        }
                    }
                }
                return entries;
            };
            Skin.prototype.getAttachmentsForSlot = function (slotIndex, attachments) {
                var slotAttachments = this.attachments[slotIndex];
                if (slotAttachments) {
                    for (var name_5 in slotAttachments) {
                        var attachment = slotAttachments[name_5];
                        if (attachment)
                            attachments.push(new SkinEntry(slotIndex, name_5, attachment));
                    }
                }
            };
            Skin.prototype.clear = function () {
                this.attachments.length = 0;
                this.bones.length = 0;
                this.constraints.length = 0;
            };
            Skin.prototype.attachAll = function (skeleton, oldSkin) {
                var slotIndex = 0;
                for (var i = 0; i < skeleton.slots.length; i++) {
                    var slot = skeleton.slots[i];
                    var slotAttachment = slot.getAttachment();
                    if (slotAttachment && slotIndex < oldSkin.attachments.length) {
                        var dictionary = oldSkin.attachments[slotIndex];
                        for (var key in dictionary) {
                            var skinAttachment = dictionary[key];
                            if (slotAttachment == skinAttachment) {
                                var attachment = this.getAttachment(slotIndex, key);
                                if (attachment != null)
                                    slot.setAttachment(attachment);
                                break;
                            }
                        }
                    }
                    slotIndex++;
                }
            };
            return Skin;
        }());
        core.Skin = Skin;
    })(core = pixi_spine.core || (pixi_spine.core = {}));
})(pixi_spine || (pixi_spine = {}));
var pixi_spine;
(function (pixi_spine) {
    var core;
    (function (core) {
        var Slot = (function () {
            function Slot(data, bone) {
                this.deform = new Array();
                if (data == null)
                    throw new Error("data cannot be null.");
                if (bone == null)
                    throw new Error("bone cannot be null.");
                this.data = data;
                this.bone = bone;
                this.color = new core.Color();
                this.darkColor = data.darkColor == null ? null : new core.Color();
                this.setToSetupPose();
                this.blendMode = this.data.blendMode;
            }
            Slot.prototype.getAttachment = function () {
                return this.attachment;
            };
            Slot.prototype.setAttachment = function (attachment) {
                if (this.attachment == attachment)
                    return;
                this.attachment = attachment;
                this.attachmentTime = this.bone.skeleton.time;
                this.deform.length = 0;
            };
            Slot.prototype.setAttachmentTime = function (time) {
                this.attachmentTime = this.bone.skeleton.time - time;
            };
            Slot.prototype.getAttachmentTime = function () {
                return this.bone.skeleton.time - this.attachmentTime;
            };
            Slot.prototype.setToSetupPose = function () {
                this.color.setFromColor(this.data.color);
                if (this.darkColor != null)
                    this.darkColor.setFromColor(this.data.darkColor);
                if (this.data.attachmentName == null)
                    this.attachment = null;
                else {
                    this.attachment = null;
                    this.setAttachment(this.bone.skeleton.getAttachment(this.data.index, this.data.attachmentName));
                }
            };
            return Slot;
        }());
        core.Slot = Slot;
    })(core = pixi_spine.core || (pixi_spine.core = {}));
})(pixi_spine || (pixi_spine = {}));
var pixi_spine;
(function (pixi_spine) {
    var core;
    (function (core) {
        var SlotData = (function () {
            function SlotData(index, name, boneData) {
                this.color = new core.Color(1, 1, 1, 1);
                if (index < 0)
                    throw new Error("index must be >= 0.");
                if (name == null)
                    throw new Error("name cannot be null.");
                if (boneData == null)
                    throw new Error("boneData cannot be null.");
                this.index = index;
                this.name = name;
                this.boneData = boneData;
            }
            return SlotData;
        }());
        core.SlotData = SlotData;
    })(core = pixi_spine.core || (pixi_spine.core = {}));
})(pixi_spine || (pixi_spine = {}));
var pixi_spine;
(function (pixi_spine) {
    var core;
    (function (core) {
        var Texture = (function () {
            function Texture(image) {
                this._image = image;
            }
            Texture.prototype.getImage = function () {
                return this._image;
            };
            Texture.filterFromString = function (text) {
                switch (text.toLowerCase()) {
                    case "nearest": return TextureFilter.Nearest;
                    case "linear": return TextureFilter.Linear;
                    case "mipmap": return TextureFilter.MipMap;
                    case "mipmapnearestnearest": return TextureFilter.MipMapNearestNearest;
                    case "mipmaplinearnearest": return TextureFilter.MipMapLinearNearest;
                    case "mipmapnearestlinear": return TextureFilter.MipMapNearestLinear;
                    case "mipmaplinearlinear": return TextureFilter.MipMapLinearLinear;
                    default: throw new Error("Unknown texture filter " + text);
                }
            };
            Texture.wrapFromString = function (text) {
                switch (text.toLowerCase()) {
                    case "mirroredtepeat": return TextureWrap.MirroredRepeat;
                    case "clamptoedge": return TextureWrap.ClampToEdge;
                    case "repeat": return TextureWrap.Repeat;
                    default: throw new Error("Unknown texture wrap " + text);
                }
            };
            return Texture;
        }());
        core.Texture = Texture;
        var TextureFilter;
        (function (TextureFilter) {
            TextureFilter[TextureFilter["Nearest"] = 9728] = "Nearest";
            TextureFilter[TextureFilter["Linear"] = 9729] = "Linear";
            TextureFilter[TextureFilter["MipMap"] = 9987] = "MipMap";
            TextureFilter[TextureFilter["MipMapNearestNearest"] = 9984] = "MipMapNearestNearest";
            TextureFilter[TextureFilter["MipMapLinearNearest"] = 9985] = "MipMapLinearNearest";
            TextureFilter[TextureFilter["MipMapNearestLinear"] = 9986] = "MipMapNearestLinear";
            TextureFilter[TextureFilter["MipMapLinearLinear"] = 9987] = "MipMapLinearLinear";
        })(TextureFilter = core.TextureFilter || (core.TextureFilter = {}));
        var TextureWrap;
        (function (TextureWrap) {
            TextureWrap[TextureWrap["MirroredRepeat"] = 33648] = "MirroredRepeat";
            TextureWrap[TextureWrap["ClampToEdge"] = 33071] = "ClampToEdge";
            TextureWrap[TextureWrap["Repeat"] = 10497] = "Repeat";
        })(TextureWrap = core.TextureWrap || (core.TextureWrap = {}));
        var TextureRegion = (function () {
            function TextureRegion() {
                this.size = null;
            }
            Object.defineProperty(TextureRegion.prototype, "width", {
                get: function () {
                    var tex = this.texture;
                    if (PIXI.VERSION[0] == '3') {
                        return tex.crop.width;
                    }
                    if (tex.trim) {
                        return tex.trim.width;
                    }
                    return tex.orig.width;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(TextureRegion.prototype, "height", {
                get: function () {
                    var tex = this.texture;
                    if (PIXI.VERSION[0] == '3') {
                        return tex.crop.height;
                    }
                    if (tex.trim) {
                        return tex.trim.height;
                    }
                    return tex.orig.height;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(TextureRegion.prototype, "u", {
                get: function () {
                    return this.texture._uvs.x0;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(TextureRegion.prototype, "v", {
                get: function () {
                    return this.texture._uvs.y0;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(TextureRegion.prototype, "u2", {
                get: function () {
                    return this.texture._uvs.x2;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(TextureRegion.prototype, "v2", {
                get: function () {
                    return this.texture._uvs.y2;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(TextureRegion.prototype, "offsetX", {
                get: function () {
                    var tex = this.texture;
                    return tex.trim ? tex.trim.x : 0;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(TextureRegion.prototype, "offsetY", {
                get: function () {
                    console.warn("Deprecation Warning: @Hackerham: I guess, if you are using PIXI-SPINE ATLAS region.offsetY, you want a texture, right? Use region.texture from now on.");
                    return this.spineOffsetY;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(TextureRegion.prototype, "pixiOffsetY", {
                get: function () {
                    var tex = this.texture;
                    return tex.trim ? tex.trim.y : 0;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(TextureRegion.prototype, "spineOffsetY", {
                get: function () {
                    var tex = this.texture;
                    return this.originalHeight - this.height - (tex.trim ? tex.trim.y : 0);
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(TextureRegion.prototype, "originalWidth", {
                get: function () {
                    var tex = this.texture;
                    if (PIXI.VERSION[0] == '3') {
                        if (tex.trim) {
                            return tex.trim.width;
                        }
                        return tex.crop.width;
                    }
                    return tex.orig.width;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(TextureRegion.prototype, "originalHeight", {
                get: function () {
                    var tex = this.texture;
                    if (PIXI.VERSION[0] == '3') {
                        if (tex.trim) {
                            return tex.trim.height;
                        }
                        return tex.crop.height;
                    }
                    return tex.orig.height;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(TextureRegion.prototype, "x", {
                get: function () {
                    return this.texture.frame.x;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(TextureRegion.prototype, "y", {
                get: function () {
                    return this.texture.frame.y;
                },
                enumerable: true,
                configurable: true
            });
            Object.defineProperty(TextureRegion.prototype, "rotate", {
                get: function () {
                    return this.texture.rotate !== 0;
                },
                enumerable: true,
                configurable: true
            });
            return TextureRegion;
        }());
        core.TextureRegion = TextureRegion;
    })(core = pixi_spine.core || (pixi_spine.core = {}));
})(pixi_spine || (pixi_spine = {}));
var pixi_spine;
(function (pixi_spine) {
    var core;
    (function (core) {
        var TextureAtlas = (function () {
            function TextureAtlas(atlasText, textureLoader, callback) {
                this.pages = new Array();
                this.regions = new Array();
                if (atlasText) {
                    this.addSpineAtlas(atlasText, textureLoader, callback);
                }
            }
            TextureAtlas.prototype.addTexture = function (name, texture) {
                var pages = this.pages;
                var page = null;
                for (var i = 0; i < pages.length; i++) {
                    if (pages[i].baseTexture === texture.baseTexture) {
                        page = pages[i];
                        break;
                    }
                }
                if (page === null) {
                    page = new TextureAtlasPage();
                    page.name = 'texturePage';
                    var baseTexture = texture.baseTexture;
                    page.width = baseTexture.realWidth;
                    page.height = baseTexture.realHeight;
                    page.baseTexture = baseTexture;
                    page.minFilter = page.magFilter = core.TextureFilter.Nearest;
                    page.uWrap = core.TextureWrap.ClampToEdge;
                    page.vWrap = core.TextureWrap.ClampToEdge;
                    pages.push(page);
                }
                var region = new TextureAtlasRegion();
                region.name = name;
                region.page = page;
                region.texture = texture;
                region.index = -1;
                this.regions.push(region);
                return region;
            };
            TextureAtlas.prototype.addTextureHash = function (textures, stripExtension) {
                for (var key in textures) {
                    if (textures.hasOwnProperty(key)) {
                        this.addTexture(stripExtension && key.indexOf('.') !== -1 ? key.substr(0, key.lastIndexOf('.')) : key, textures[key]);
                    }
                }
            };
            TextureAtlas.prototype.addSpineAtlas = function (atlasText, textureLoader, callback) {
                return this.load(atlasText, textureLoader, callback);
            };
            TextureAtlas.prototype.load = function (atlasText, textureLoader, callback) {
                var _this = this;
                if (textureLoader == null)
                    throw new Error("textureLoader cannot be null.");
                var reader = new TextureAtlasReader(atlasText);
                var tuple = new Array(4);
                var page = null;
                var iterateParser = function () {
                    while (true) {
                        var line = reader.readLine();
                        if (line == null) {
                            return callback && callback(_this);
                        }
                        line = line.trim();
                        if (line.length == 0)
                            page = null;
                        else if (!page) {
                            page = new TextureAtlasPage();
                            page.name = line;
                            if (reader.readTuple(tuple) == 2) {
                                page.width = parseInt(tuple[0]);
                                page.height = parseInt(tuple[1]);
                                reader.readTuple(tuple);
                            }
                            reader.readTuple(tuple);
                            page.minFilter = core.Texture.filterFromString(tuple[0]);
                            page.magFilter = core.Texture.filterFromString(tuple[1]);
                            var direction = reader.readValue();
                            page.uWrap = core.TextureWrap.ClampToEdge;
                            page.vWrap = core.TextureWrap.ClampToEdge;
                            if (direction == "x")
                                page.uWrap = core.TextureWrap.Repeat;
                            else if (direction == "y")
                                page.vWrap = core.TextureWrap.Repeat;
                            else if (direction == "xy")
                                page.uWrap = page.vWrap = core.TextureWrap.Repeat;
                            textureLoader(line, function (texture) {
                                if (texture === null) {
                                    _this.pages.splice(_this.pages.indexOf(page), 1);
                                    return callback && callback(null);
                                }
                                page.baseTexture = texture;
                                if (!texture.hasLoaded) {
                                    texture.width = page.width;
                                    texture.height = page.height;
                                }
                                _this.pages.push(page);
                                page.setFilters();
                                if (!page.width || !page.height) {
                                    page.width = texture.realWidth;
                                    page.height = texture.realHeight;
                                    if (!page.width || !page.height) {
                                        console.log("ERROR spine atlas page " + page.name + ": meshes wont work if you dont specify size in atlas (http://www.html5gamedevs.com/topic/18888-pixi-spines-and-meshes/?p=107121)");
                                    }
                                }
                                iterateParser();
                            });
                            _this.pages.push(page);
                            break;
                        }
                        else {
                            var region = new TextureAtlasRegion();
                            region.name = line;
                            region.page = page;
                            var rotateValue = reader.readValue();
                            var rotate = 0;
                            if (rotateValue.toLocaleLowerCase() == "true") {
                                rotate = 6;
                            }
                            else if (rotateValue.toLocaleLowerCase() == "false") {
                                rotate = 0;
                            }
                            else {
                                rotate = ((720 - parseFloat(rotateValue)) % 360) / 45;
                            }
                            reader.readTuple(tuple);
                            var x = parseInt(tuple[0]);
                            var y = parseInt(tuple[1]);
                            reader.readTuple(tuple);
                            var width = parseInt(tuple[0]);
                            var height = parseInt(tuple[1]);
                            var resolution = page.baseTexture.resolution;
                            x /= resolution;
                            y /= resolution;
                            width /= resolution;
                            height /= resolution;
                            var frame = new PIXI.Rectangle(x, y, rotate ? height : width, rotate ? width : height);
                            if (reader.readTuple(tuple) == 4) {
                                if (reader.readTuple(tuple) == 4) {
                                    reader.readTuple(tuple);
                                }
                            }
                            var originalWidth = parseInt(tuple[0]) / resolution;
                            var originalHeight = parseInt(tuple[1]) / resolution;
                            reader.readTuple(tuple);
                            var offsetX = parseInt(tuple[0]) / resolution;
                            var offsetY = parseInt(tuple[1]) / resolution;
                            var orig = new PIXI.Rectangle(0, 0, originalWidth, originalHeight);
                            var trim = new PIXI.Rectangle(offsetX, originalHeight - height - offsetY, width, height);
                            if (PIXI.VERSION[0] != '3') {
                                region.texture = new PIXI.Texture(region.page.baseTexture, frame, orig, trim, rotate);
                            }
                            else {
                                var frame2 = new PIXI.Rectangle(x, y, width, height);
                                var crop = frame2.clone();
                                trim.width = originalWidth;
                                trim.height = originalHeight;
                                region.texture = new PIXI.Texture(region.page.baseTexture, frame2, crop, trim, rotate);
                            }
                            region.index = parseInt(reader.readValue());
                            region.texture._updateUvs();
                            _this.regions.push(region);
                        }
                    }
                };
                iterateParser();
            };
            TextureAtlas.prototype.findRegion = function (name) {
                for (var i = 0; i < this.regions.length; i++) {
                    if (this.regions[i].name == name) {
                        return this.regions[i];
                    }
                }
                return null;
            };
            TextureAtlas.prototype.dispose = function () {
                for (var i = 0; i < this.pages.length; i++) {
                    this.pages[i].baseTexture.dispose();
                }
            };
            return TextureAtlas;
        }());
        core.TextureAtlas = TextureAtlas;
        var TextureAtlasReader = (function () {
            function TextureAtlasReader(text) {
                this.index = 0;
                this.lines = text.split(/\r\n|\r|\n/);
            }
            TextureAtlasReader.prototype.readLine = function () {
                if (this.index >= this.lines.length)
                    return null;
                return this.lines[this.index++];
            };
            TextureAtlasReader.prototype.readValue = function () {
                var line = this.readLine();
                var colon = line.indexOf(":");
                if (colon == -1)
                    throw new Error("Invalid line: " + line);
                return line.substring(colon + 1).trim();
            };
            TextureAtlasReader.prototype.readTuple = function (tuple) {
                var line = this.readLine();
                var colon = line.indexOf(":");
                if (colon == -1)
                    throw new Error("Invalid line: " + line);
                var i = 0, lastMatch = colon + 1;
                for (; i < 3; i++) {
                    var comma = line.indexOf(",", lastMatch);
                    if (comma == -1)
                        break;
                    tuple[i] = line.substr(lastMatch, comma - lastMatch).trim();
                    lastMatch = comma + 1;
                }
                tuple[i] = line.substring(lastMatch).trim();
                return i + 1;
            };
            return TextureAtlasReader;
        }());
        var TextureAtlasPage = (function () {
            function TextureAtlasPage() {
            }
            TextureAtlasPage.prototype.setFilters = function () {
                var tex = this.baseTexture;
                var filter = this.minFilter;
                if (filter == core.TextureFilter.Linear) {
                    tex.scaleMode = PIXI.SCALE_MODES.LINEAR;
                }
                else if (this.minFilter == core.TextureFilter.Nearest) {
                    tex.scaleMode = PIXI.SCALE_MODES.NEAREST;
                }
                else {
                    tex.mipmap = true;
                    if (filter == core.TextureFilter.MipMapNearestNearest) {
                        tex.scaleMode = PIXI.SCALE_MODES.NEAREST;
                    }
                    else {
                        tex.scaleMode = PIXI.SCALE_MODES.LINEAR;
                    }
                }
            };
            return TextureAtlasPage;
        }());
        core.TextureAtlasPage = TextureAtlasPage;
        var TextureAtlasRegion = (function (_super) {
            __extends(TextureAtlasRegion, _super);
            function TextureAtlasRegion() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            return TextureAtlasRegion;
        }(core.TextureRegion));
        core.TextureAtlasRegion = TextureAtlasRegion;
    })(core = pixi_spine.core || (pixi_spine.core = {}));
})(pixi_spine || (pixi_spine = {}));
var pixi_spine;
(function (pixi_spine) {
    var core;
    (function (core) {
        var TransformConstraint = (function () {
            function TransformConstraint(data, skeleton) {
                this.rotateMix = 0;
                this.translateMix = 0;
                this.scaleMix = 0;
                this.shearMix = 0;
                this.temp = new core.Vector2();
                this.active = false;
                if (data == null)
                    throw new Error("data cannot be null.");
                if (skeleton == null)
                    throw new Error("skeleton cannot be null.");
                this.data = data;
                this.rotateMix = data.rotateMix;
                this.translateMix = data.translateMix;
                this.scaleMix = data.scaleMix;
                this.shearMix = data.shearMix;
                this.bones = new Array();
                for (var i = 0; i < data.bones.length; i++)
                    this.bones.push(skeleton.findBone(data.bones[i].name));
                this.target = skeleton.findBone(data.target.name);
            }
            TransformConstraint.prototype.isActive = function () {
                return this.active;
            };
            TransformConstraint.prototype.apply = function () {
                this.update();
            };
            TransformConstraint.prototype.update = function () {
                if (this.data.local) {
                    if (this.data.relative)
                        this.applyRelativeLocal();
                    else
                        this.applyAbsoluteLocal();
                }
                else {
                    if (this.data.relative)
                        this.applyRelativeWorld();
                    else
                        this.applyAbsoluteWorld();
                }
            };
            TransformConstraint.prototype.applyAbsoluteWorld = function () {
                var rotateMix = this.rotateMix, translateMix = this.translateMix, scaleMix = this.scaleMix, shearMix = this.shearMix;
                var target = this.target;
                var targetMat = target.matrix;
                var ta = targetMat.a, tb = targetMat.c, tc = targetMat.b, td = targetMat.d;
                var degRadReflect = ta * td - tb * tc > 0 ? core.MathUtils.degRad : -core.MathUtils.degRad;
                var offsetRotation = this.data.offsetRotation * degRadReflect;
                var offsetShearY = this.data.offsetShearY * degRadReflect;
                var bones = this.bones;
                for (var i = 0, n = bones.length; i < n; i++) {
                    var bone = bones[i];
                    var modified = false;
                    var mat = bone.matrix;
                    if (rotateMix != 0) {
                        var a = mat.a, b = mat.c, c = mat.b, d = mat.d;
                        var r = Math.atan2(tc, ta) - Math.atan2(c, a) + offsetRotation;
                        if (r > core.MathUtils.PI)
                            r -= core.MathUtils.PI2;
                        else if (r < -core.MathUtils.PI)
                            r += core.MathUtils.PI2;
                        r *= rotateMix;
                        var cos = Math.cos(r), sin = Math.sin(r);
                        mat.a = cos * a - sin * c;
                        mat.c = cos * b - sin * d;
                        mat.b = sin * a + cos * c;
                        mat.d = sin * b + cos * d;
                        modified = true;
                    }
                    if (translateMix != 0) {
                        var temp = this.temp;
                        target.localToWorld(temp.set(this.data.offsetX, this.data.offsetY));
                        mat.tx += (temp.x - mat.tx) * translateMix;
                        mat.ty += (temp.y - mat.ty) * translateMix;
                        modified = true;
                    }
                    if (scaleMix > 0) {
                        var s = Math.sqrt(mat.a * mat.a + mat.b * mat.b);
                        var ts = Math.sqrt(ta * ta + tc * tc);
                        if (s > 0.00001)
                            s = (s + (ts - s + this.data.offsetScaleX) * scaleMix) / s;
                        mat.a *= s;
                        mat.b *= s;
                        s = Math.sqrt(mat.c * mat.c + mat.d * mat.d);
                        ts = Math.sqrt(tb * tb + td * td);
                        if (s > 0.00001)
                            s = (s + (ts - s + this.data.offsetScaleY) * scaleMix) / s;
                        mat.c *= s;
                        mat.d *= s;
                        modified = true;
                    }
                    if (shearMix > 0) {
                        var b = mat.c, d = mat.d;
                        var by = Math.atan2(d, b);
                        var r = Math.atan2(td, tb) - Math.atan2(tc, ta) - (by - Math.atan2(mat.b, mat.a));
                        if (r > core.MathUtils.PI)
                            r -= core.MathUtils.PI2;
                        else if (r < -core.MathUtils.PI)
                            r += core.MathUtils.PI2;
                        r = by + (r + offsetShearY) * shearMix;
                        var s = Math.sqrt(b * b + d * d);
                        mat.c = Math.cos(r) * s;
                        mat.d = Math.sin(r) * s;
                        modified = true;
                    }
                    if (modified)
                        bone.appliedValid = false;
                }
            };
            TransformConstraint.prototype.applyRelativeWorld = function () {
                var rotateMix = this.rotateMix, translateMix = this.translateMix, scaleMix = this.scaleMix, shearMix = this.shearMix;
                var target = this.target;
                var targetMat = target.matrix;
                var ta = targetMat.a, tb = targetMat.c, tc = targetMat.b, td = targetMat.d;
                var degRadReflect = ta * td - tb * tc > 0 ? core.MathUtils.degRad : -core.MathUtils.degRad;
                var offsetRotation = this.data.offsetRotation * degRadReflect, offsetShearY = this.data.offsetShearY * degRadReflect;
                var bones = this.bones;
                for (var i = 0, n = bones.length; i < n; i++) {
                    var bone = bones[i];
                    var modified = false;
                    var mat = bone.matrix;
                    if (rotateMix != 0) {
                        var a = mat.a, b = mat.c, c = mat.b, d = mat.d;
                        var r = Math.atan2(tc, ta) + offsetRotation;
                        if (r > core.MathUtils.PI)
                            r -= core.MathUtils.PI2;
                        else if (r < -core.MathUtils.PI)
                            r += core.MathUtils.PI2;
                        r *= rotateMix;
                        var cos = Math.cos(r), sin = Math.sin(r);
                        mat.a = cos * a - sin * c;
                        mat.c = cos * b - sin * d;
                        mat.b = sin * a + cos * c;
                        mat.d = sin * b + cos * d;
                        modified = true;
                    }
                    if (translateMix != 0) {
                        var temp = this.temp;
                        target.localToWorld(temp.set(this.data.offsetX, this.data.offsetY));
                        mat.tx += temp.x * translateMix;
                        mat.ty += temp.y * translateMix;
                        modified = true;
                    }
                    if (scaleMix > 0) {
                        var s = (Math.sqrt(ta * ta + tc * tc) - 1 + this.data.offsetScaleX) * scaleMix + 1;
                        mat.a *= s;
                        mat.b *= s;
                        s = (Math.sqrt(tb * tb + td * td) - 1 + this.data.offsetScaleY) * scaleMix + 1;
                        mat.c *= s;
                        mat.d *= s;
                        modified = true;
                    }
                    if (shearMix > 0) {
                        var r = Math.atan2(td, tb) - Math.atan2(tc, ta);
                        if (r > core.MathUtils.PI)
                            r -= core.MathUtils.PI2;
                        else if (r < -core.MathUtils.PI)
                            r += core.MathUtils.PI2;
                        var b = mat.c, d = mat.d;
                        r = Math.atan2(d, b) + (r - core.MathUtils.PI / 2 + offsetShearY) * shearMix;
                        var s = Math.sqrt(b * b + d * d);
                        mat.c = Math.cos(r) * s;
                        mat.d = Math.sin(r) * s;
                        modified = true;
                    }
                    if (modified)
                        bone.appliedValid = false;
                }
            };
            TransformConstraint.prototype.applyAbsoluteLocal = function () {
                var rotateMix = this.rotateMix, translateMix = this.translateMix, scaleMix = this.scaleMix, shearMix = this.shearMix;
                var target = this.target;
                if (!target.appliedValid)
                    target.updateAppliedTransform();
                var bones = this.bones;
                for (var i = 0, n = bones.length; i < n; i++) {
                    var bone = bones[i];
                    if (!bone.appliedValid)
                        bone.updateAppliedTransform();
                    var rotation = bone.arotation;
                    if (rotateMix != 0) {
                        var r = target.arotation - rotation + this.data.offsetRotation;
                        r -= (16384 - ((16384.499999999996 - r / 360) | 0)) * 360;
                        rotation += r * rotateMix;
                    }
                    var x = bone.ax, y = bone.ay;
                    if (translateMix != 0) {
                        x += (target.ax - x + this.data.offsetX) * translateMix;
                        y += (target.ay - y + this.data.offsetY) * translateMix;
                    }
                    var scaleX = bone.ascaleX, scaleY = bone.ascaleY;
                    if (scaleMix > 0) {
                        if (scaleX > 0.00001)
                            scaleX = (scaleX + (target.ascaleX - scaleX + this.data.offsetScaleX) * scaleMix) / scaleX;
                        if (scaleY > 0.00001)
                            scaleY = (scaleY + (target.ascaleY - scaleY + this.data.offsetScaleY) * scaleMix) / scaleY;
                    }
                    var shearY = bone.ashearY;
                    if (shearMix > 0) {
                        var r = target.ashearY - shearY + this.data.offsetShearY;
                        r -= (16384 - ((16384.499999999996 - r / 360) | 0)) * 360;
                        bone.shearY += r * shearMix;
                    }
                    bone.updateWorldTransformWith(x, y, rotation, scaleX, scaleY, bone.ashearX, shearY);
                }
            };
            TransformConstraint.prototype.applyRelativeLocal = function () {
                var rotateMix = this.rotateMix, translateMix = this.translateMix, scaleMix = this.scaleMix, shearMix = this.shearMix;
                var target = this.target;
                if (!target.appliedValid)
                    target.updateAppliedTransform();
                var bones = this.bones;
                for (var i = 0, n = bones.length; i < n; i++) {
                    var bone = bones[i];
                    if (!bone.appliedValid)
                        bone.updateAppliedTransform();
                    var rotation = bone.arotation;
                    if (rotateMix != 0)
                        rotation += (target.arotation + this.data.offsetRotation) * rotateMix;
                    var x = bone.ax, y = bone.ay;
                    if (translateMix != 0) {
                        x += (target.ax + this.data.offsetX) * translateMix;
                        y += (target.ay + this.data.offsetY) * translateMix;
                    }
                    var scaleX = bone.ascaleX, scaleY = bone.ascaleY;
                    if (scaleMix > 0) {
                        if (scaleX > 0.00001)
                            scaleX *= ((target.ascaleX - 1 + this.data.offsetScaleX) * scaleMix) + 1;
                        if (scaleY > 0.00001)
                            scaleY *= ((target.ascaleY - 1 + this.data.offsetScaleY) * scaleMix) + 1;
                    }
                    var shearY = bone.ashearY;
                    if (shearMix > 0)
                        shearY += (target.ashearY + this.data.offsetShearY) * shearMix;
                    bone.updateWorldTransformWith(x, y, rotation, scaleX, scaleY, bone.ashearX, shearY);
                }
            };
            return TransformConstraint;
        }());
        core.TransformConstraint = TransformConstraint;
    })(core = pixi_spine.core || (pixi_spine.core = {}));
})(pixi_spine || (pixi_spine = {}));
var pixi_spine;
(function (pixi_spine) {
    var core;
    (function (core) {
        var TransformConstraintData = (function (_super) {
            __extends(TransformConstraintData, _super);
            function TransformConstraintData(name) {
                var _this = _super.call(this, name, 0, false) || this;
                _this.bones = new Array();
                _this.rotateMix = 0;
                _this.translateMix = 0;
                _this.scaleMix = 0;
                _this.shearMix = 0;
                _this.offsetRotation = 0;
                _this.offsetX = 0;
                _this.offsetY = 0;
                _this.offsetScaleX = 0;
                _this.offsetScaleY = 0;
                _this.offsetShearY = 0;
                _this.relative = false;
                _this.local = false;
                return _this;
            }
            return TransformConstraintData;
        }(core.ConstraintData));
        core.TransformConstraintData = TransformConstraintData;
    })(core = pixi_spine.core || (pixi_spine.core = {}));
})(pixi_spine || (pixi_spine = {}));
var pixi_spine;
(function (pixi_spine) {
    var core;
    (function (core) {
        var Triangulator = (function () {
            function Triangulator() {
                this.convexPolygons = new Array();
                this.convexPolygonsIndices = new Array();
                this.indicesArray = new Array();
                this.isConcaveArray = new Array();
                this.triangles = new Array();
                this.polygonPool = new core.Pool(function () {
                    return new Array();
                });
                this.polygonIndicesPool = new core.Pool(function () {
                    return new Array();
                });
            }
            Triangulator.prototype.triangulate = function (verticesArray) {
                var vertices = verticesArray;
                var vertexCount = verticesArray.length >> 1;
                var indices = this.indicesArray;
                indices.length = 0;
                for (var i = 0; i < vertexCount; i++)
                    indices[i] = i;
                var isConcave = this.isConcaveArray;
                isConcave.length = 0;
                for (var i = 0, n = vertexCount; i < n; ++i)
                    isConcave[i] = Triangulator.isConcave(i, vertexCount, vertices, indices);
                var triangles = this.triangles;
                triangles.length = 0;
                while (vertexCount > 3) {
                    var previous = vertexCount - 1, i = 0, next = 1;
                    while (true) {
                        outer: if (!isConcave[i]) {
                            var p1 = indices[previous] << 1, p2 = indices[i] << 1, p3 = indices[next] << 1;
                            var p1x = vertices[p1], p1y = vertices[p1 + 1];
                            var p2x = vertices[p2], p2y = vertices[p2 + 1];
                            var p3x = vertices[p3], p3y = vertices[p3 + 1];
                            for (var ii = (next + 1) % vertexCount; ii != previous; ii = (ii + 1) % vertexCount) {
                                if (!isConcave[ii])
                                    continue;
                                var v = indices[ii] << 1;
                                var vx = vertices[v], vy = vertices[v + 1];
                                if (Triangulator.positiveArea(p3x, p3y, p1x, p1y, vx, vy)) {
                                    if (Triangulator.positiveArea(p1x, p1y, p2x, p2y, vx, vy)) {
                                        if (Triangulator.positiveArea(p2x, p2y, p3x, p3y, vx, vy))
                                            break outer;
                                    }
                                }
                            }
                            break;
                        }
                        if (next == 0) {
                            do {
                                if (!isConcave[i])
                                    break;
                                i--;
                            } while (i > 0);
                            break;
                        }
                        previous = i;
                        i = next;
                        next = (next + 1) % vertexCount;
                    }
                    triangles.push(indices[(vertexCount + i - 1) % vertexCount]);
                    triangles.push(indices[i]);
                    triangles.push(indices[(i + 1) % vertexCount]);
                    indices.splice(i, 1);
                    isConcave.splice(i, 1);
                    vertexCount--;
                    var previousIndex = (vertexCount + i - 1) % vertexCount;
                    var nextIndex = i == vertexCount ? 0 : i;
                    isConcave[previousIndex] = Triangulator.isConcave(previousIndex, vertexCount, vertices, indices);
                    isConcave[nextIndex] = Triangulator.isConcave(nextIndex, vertexCount, vertices, indices);
                }
                if (vertexCount == 3) {
                    triangles.push(indices[2]);
                    triangles.push(indices[0]);
                    triangles.push(indices[1]);
                }
                return triangles;
            };
            Triangulator.prototype.decompose = function (verticesArray, triangles) {
                var vertices = verticesArray;
                var convexPolygons = this.convexPolygons;
                this.polygonPool.freeAll(convexPolygons);
                convexPolygons.length = 0;
                var convexPolygonsIndices = this.convexPolygonsIndices;
                this.polygonIndicesPool.freeAll(convexPolygonsIndices);
                convexPolygonsIndices.length = 0;
                var polygonIndices = this.polygonIndicesPool.obtain();
                polygonIndices.length = 0;
                var polygon = this.polygonPool.obtain();
                polygon.length = 0;
                var fanBaseIndex = -1, lastWinding = 0;
                for (var i = 0, n = triangles.length; i < n; i += 3) {
                    var t1 = triangles[i] << 1, t2 = triangles[i + 1] << 1, t3 = triangles[i + 2] << 1;
                    var x1 = vertices[t1], y1 = vertices[t1 + 1];
                    var x2 = vertices[t2], y2 = vertices[t2 + 1];
                    var x3 = vertices[t3], y3 = vertices[t3 + 1];
                    var merged = false;
                    if (fanBaseIndex == t1) {
                        var o = polygon.length - 4;
                        var winding1 = Triangulator.winding(polygon[o], polygon[o + 1], polygon[o + 2], polygon[o + 3], x3, y3);
                        var winding2 = Triangulator.winding(x3, y3, polygon[0], polygon[1], polygon[2], polygon[3]);
                        if (winding1 == lastWinding && winding2 == lastWinding) {
                            polygon.push(x3);
                            polygon.push(y3);
                            polygonIndices.push(t3);
                            merged = true;
                        }
                    }
                    if (!merged) {
                        if (polygon.length > 0) {
                            convexPolygons.push(polygon);
                            convexPolygonsIndices.push(polygonIndices);
                        }
                        else {
                            this.polygonPool.free(polygon);
                            this.polygonIndicesPool.free(polygonIndices);
                        }
                        polygon = this.polygonPool.obtain();
                        polygon.length = 0;
                        polygon.push(x1);
                        polygon.push(y1);
                        polygon.push(x2);
                        polygon.push(y2);
                        polygon.push(x3);
                        polygon.push(y3);
                        polygonIndices = this.polygonIndicesPool.obtain();
                        polygonIndices.length = 0;
                        polygonIndices.push(t1);
                        polygonIndices.push(t2);
                        polygonIndices.push(t3);
                        lastWinding = Triangulator.winding(x1, y1, x2, y2, x3, y3);
                        fanBaseIndex = t1;
                    }
                }
                if (polygon.length > 0) {
                    convexPolygons.push(polygon);
                    convexPolygonsIndices.push(polygonIndices);
                }
                for (var i = 0, n = convexPolygons.length; i < n; i++) {
                    polygonIndices = convexPolygonsIndices[i];
                    if (polygonIndices.length == 0)
                        continue;
                    var firstIndex = polygonIndices[0];
                    var lastIndex = polygonIndices[polygonIndices.length - 1];
                    polygon = convexPolygons[i];
                    var o = polygon.length - 4;
                    var prevPrevX = polygon[o], prevPrevY = polygon[o + 1];
                    var prevX = polygon[o + 2], prevY = polygon[o + 3];
                    var firstX = polygon[0], firstY = polygon[1];
                    var secondX = polygon[2], secondY = polygon[3];
                    var winding = Triangulator.winding(prevPrevX, prevPrevY, prevX, prevY, firstX, firstY);
                    for (var ii = 0; ii < n; ii++) {
                        if (ii == i)
                            continue;
                        var otherIndices = convexPolygonsIndices[ii];
                        if (otherIndices.length != 3)
                            continue;
                        var otherFirstIndex = otherIndices[0];
                        var otherSecondIndex = otherIndices[1];
                        var otherLastIndex = otherIndices[2];
                        var otherPoly = convexPolygons[ii];
                        var x3 = otherPoly[otherPoly.length - 2], y3 = otherPoly[otherPoly.length - 1];
                        if (otherFirstIndex != firstIndex || otherSecondIndex != lastIndex)
                            continue;
                        var winding1 = Triangulator.winding(prevPrevX, prevPrevY, prevX, prevY, x3, y3);
                        var winding2 = Triangulator.winding(x3, y3, firstX, firstY, secondX, secondY);
                        if (winding1 == winding && winding2 == winding) {
                            otherPoly.length = 0;
                            otherIndices.length = 0;
                            polygon.push(x3);
                            polygon.push(y3);
                            polygonIndices.push(otherLastIndex);
                            prevPrevX = prevX;
                            prevPrevY = prevY;
                            prevX = x3;
                            prevY = y3;
                            ii = 0;
                        }
                    }
                }
                for (var i = convexPolygons.length - 1; i >= 0; i--) {
                    polygon = convexPolygons[i];
                    if (polygon.length == 0) {
                        convexPolygons.splice(i, 1);
                        this.polygonPool.free(polygon);
                        polygonIndices = convexPolygonsIndices[i];
                        convexPolygonsIndices.splice(i, 1);
                        this.polygonIndicesPool.free(polygonIndices);
                    }
                }
                return convexPolygons;
            };
            Triangulator.isConcave = function (index, vertexCount, vertices, indices) {
                var previous = indices[(vertexCount + index - 1) % vertexCount] << 1;
                var current = indices[index] << 1;
                var next = indices[(index + 1) % vertexCount] << 1;
                return !this.positiveArea(vertices[previous], vertices[previous + 1], vertices[current], vertices[current + 1], vertices[next], vertices[next + 1]);
            };
            Triangulator.positiveArea = function (p1x, p1y, p2x, p2y, p3x, p3y) {
                return p1x * (p3y - p2y) + p2x * (p1y - p3y) + p3x * (p2y - p1y) >= 0;
            };
            Triangulator.winding = function (p1x, p1y, p2x, p2y, p3x, p3y) {
                var px = p2x - p1x, py = p2y - p1y;
                return p3x * py - p3y * px + px * p1y - p1x * py >= 0 ? 1 : -1;
            };
            return Triangulator;
        }());
        core.Triangulator = Triangulator;
    })(core = pixi_spine.core || (pixi_spine.core = {}));
})(pixi_spine || (pixi_spine = {}));
var pixi_spine;
(function (pixi_spine) {
    var core;
    (function (core) {
        var IntSet = (function () {
            function IntSet() {
                this.array = new Array();
            }
            IntSet.prototype.add = function (value) {
                var contains = this.contains(value);
                this.array[value | 0] = value | 0;
                return !contains;
            };
            IntSet.prototype.contains = function (value) {
                return this.array[value | 0] != undefined;
            };
            IntSet.prototype.remove = function (value) {
                this.array[value | 0] = undefined;
            };
            IntSet.prototype.clear = function () {
                this.array.length = 0;
            };
            return IntSet;
        }());
        core.IntSet = IntSet;
        var Color = (function () {
            function Color(r, g, b, a) {
                if (r === void 0) { r = 0; }
                if (g === void 0) { g = 0; }
                if (b === void 0) { b = 0; }
                if (a === void 0) { a = 0; }
                this.r = r;
                this.g = g;
                this.b = b;
                this.a = a;
            }
            Color.prototype.set = function (r, g, b, a) {
                this.r = r;
                this.g = g;
                this.b = b;
                this.a = a;
                this.clamp();
                return this;
            };
            Color.prototype.setFromColor = function (c) {
                this.r = c.r;
                this.g = c.g;
                this.b = c.b;
                this.a = c.a;
                return this;
            };
            Color.prototype.setFromString = function (hex) {
                hex = hex.charAt(0) == '#' ? hex.substr(1) : hex;
                this.r = parseInt(hex.substr(0, 2), 16) / 255.0;
                this.g = parseInt(hex.substr(2, 2), 16) / 255.0;
                this.b = parseInt(hex.substr(4, 2), 16) / 255.0;
                this.a = (hex.length != 8 ? 255 : parseInt(hex.substr(6, 2), 16)) / 255.0;
                return this;
            };
            Color.prototype.add = function (r, g, b, a) {
                this.r += r;
                this.g += g;
                this.b += b;
                this.a += a;
                this.clamp();
                return this;
            };
            Color.prototype.clamp = function () {
                if (this.r < 0)
                    this.r = 0;
                else if (this.r > 1)
                    this.r = 1;
                if (this.g < 0)
                    this.g = 0;
                else if (this.g > 1)
                    this.g = 1;
                if (this.b < 0)
                    this.b = 0;
                else if (this.b > 1)
                    this.b = 1;
                if (this.a < 0)
                    this.a = 0;
                else if (this.a > 1)
                    this.a = 1;
                return this;
            };
            Color.rgba8888ToColor = function (color, value) {
                color.r = ((value & 0xff000000) >>> 24) / 255;
                color.g = ((value & 0x00ff0000) >>> 16) / 255;
                color.b = ((value & 0x0000ff00) >>> 8) / 255;
                color.a = ((value & 0x000000ff)) / 255;
            };
            Color.rgb888ToColor = function (color, value) {
                color.r = ((value & 0x00ff0000) >>> 16) / 255;
                color.g = ((value & 0x0000ff00) >>> 8) / 255;
                color.b = ((value & 0x000000ff)) / 255;
            };
            Color.WHITE = new Color(1, 1, 1, 1);
            Color.RED = new Color(1, 0, 0, 1);
            Color.GREEN = new Color(0, 1, 0, 1);
            Color.BLUE = new Color(0, 0, 1, 1);
            Color.MAGENTA = new Color(1, 0, 1, 1);
            return Color;
        }());
        core.Color = Color;
        var MathUtils = (function () {
            function MathUtils() {
            }
            MathUtils.clamp = function (value, min, max) {
                if (value < min)
                    return min;
                if (value > max)
                    return max;
                return value;
            };
            MathUtils.cosDeg = function (degrees) {
                return Math.cos(degrees * MathUtils.degRad);
            };
            MathUtils.sinDeg = function (degrees) {
                return Math.sin(degrees * MathUtils.degRad);
            };
            MathUtils.signum = function (value) {
                return value > 0 ? 1 : value < 0 ? -1 : 0;
            };
            MathUtils.toInt = function (x) {
                return x > 0 ? Math.floor(x) : Math.ceil(x);
            };
            MathUtils.cbrt = function (x) {
                var y = Math.pow(Math.abs(x), 1 / 3);
                return x < 0 ? -y : y;
            };
            MathUtils.randomTriangular = function (min, max) {
                return MathUtils.randomTriangularWith(min, max, (min + max) * 0.5);
            };
            MathUtils.randomTriangularWith = function (min, max, mode) {
                var u = Math.random();
                var d = max - min;
                if (u <= (mode - min) / d)
                    return min + Math.sqrt(u * d * (mode - min));
                return max - Math.sqrt((1 - u) * d * (max - mode));
            };
            MathUtils.PI = 3.1415927;
            MathUtils.PI2 = MathUtils.PI * 2;
            MathUtils.radiansToDegrees = 180 / MathUtils.PI;
            MathUtils.radDeg = MathUtils.radiansToDegrees;
            MathUtils.degreesToRadians = MathUtils.PI / 180;
            MathUtils.degRad = MathUtils.degreesToRadians;
            return MathUtils;
        }());
        core.MathUtils = MathUtils;
        var Interpolation = (function () {
            function Interpolation() {
            }
            Interpolation.prototype.apply = function (start, end, a) {
                return start + (end - start) * this.applyInternal(a);
            };
            return Interpolation;
        }());
        core.Interpolation = Interpolation;
        var Pow = (function (_super) {
            __extends(Pow, _super);
            function Pow(power) {
                var _this = _super.call(this) || this;
                _this.power = 2;
                _this.power = power;
                return _this;
            }
            Pow.prototype.applyInternal = function (a) {
                if (a <= 0.5)
                    return Math.pow(a * 2, this.power) / 2;
                return Math.pow((a - 1) * 2, this.power) / (this.power % 2 == 0 ? -2 : 2) + 1;
            };
            return Pow;
        }(Interpolation));
        core.Pow = Pow;
        var PowOut = (function (_super) {
            __extends(PowOut, _super);
            function PowOut(power) {
                return _super.call(this, power) || this;
            }
            PowOut.prototype.applyInternal = function (a) {
                return Math.pow(a - 1, this.power) * (this.power % 2 == 0 ? -1 : 1) + 1;
            };
            return PowOut;
        }(Pow));
        core.PowOut = PowOut;
        var Utils = (function () {
            function Utils() {
            }
            Utils.arrayCopy = function (source, sourceStart, dest, destStart, numElements) {
                for (var i = sourceStart, j = destStart; i < sourceStart + numElements; i++, j++) {
                    dest[j] = source[i];
                }
            };
            Utils.setArraySize = function (array, size, value) {
                if (value === void 0) { value = 0; }
                var oldSize = array.length;
                if (oldSize == size)
                    return array;
                array.length = size;
                if (oldSize < size) {
                    for (var i = oldSize; i < size; i++)
                        array[i] = value;
                }
                return array;
            };
            Utils.ensureArrayCapacity = function (array, size, value) {
                if (value === void 0) { value = 0; }
                if (array.length >= size)
                    return array;
                return Utils.setArraySize(array, size, value);
            };
            Utils.newArray = function (size, defaultValue) {
                var array = new Array(size);
                for (var i = 0; i < size; i++)
                    array[i] = defaultValue;
                return array;
            };
            Utils.newFloatArray = function (size) {
                if (Utils.SUPPORTS_TYPED_ARRAYS) {
                    return new Float32Array(size);
                }
                else {
                    var array = new Array(size);
                    for (var i = 0; i < array.length; i++)
                        array[i] = 0;
                    return array;
                }
            };
            Utils.newShortArray = function (size) {
                if (Utils.SUPPORTS_TYPED_ARRAYS) {
                    return new Int16Array(size);
                }
                else {
                    var array = new Array(size);
                    for (var i = 0; i < array.length; i++)
                        array[i] = 0;
                    return array;
                }
            };
            Utils.toFloatArray = function (array) {
                return Utils.SUPPORTS_TYPED_ARRAYS ? new Float32Array(array) : array;
            };
            Utils.toSinglePrecision = function (value) {
                return Utils.SUPPORTS_TYPED_ARRAYS ? Math.fround(value) : value;
            };
            Utils.webkit602BugfixHelper = function (alpha, blend) {
            };
            Utils.contains = function (array, element, identity) {
                if (identity === void 0) { identity = true; }
                for (var i = 0; i < array.length; i++) {
                    if (array[i] == element)
                        return true;
                }
                return false;
            };
            Utils.SUPPORTS_TYPED_ARRAYS = typeof (Float32Array) !== "undefined";
            return Utils;
        }());
        core.Utils = Utils;
        var DebugUtils = (function () {
            function DebugUtils() {
            }
            DebugUtils.logBones = function (skeleton) {
                for (var i = 0; i < skeleton.bones.length; i++) {
                    var bone = skeleton.bones[i];
                    var mat = bone.matrix;
                    console.log(bone.data.name + ", " + mat.a + ", " + mat.b + ", " + mat.c + ", " + mat.d + ", " + mat.tx + ", " + mat.ty);
                }
            };
            return DebugUtils;
        }());
        core.DebugUtils = DebugUtils;
        var Pool = (function () {
            function Pool(instantiator) {
                this.items = new Array();
                this.instantiator = instantiator;
            }
            Pool.prototype.obtain = function () {
                return this.items.length > 0 ? this.items.pop() : this.instantiator();
            };
            Pool.prototype.free = function (item) {
                if (item.reset)
                    item.reset();
                this.items.push(item);
            };
            Pool.prototype.freeAll = function (items) {
                for (var i = 0; i < items.length; i++) {
                    if (items[i].reset)
                        items[i].reset();
                    this.items[i] = items[i];
                }
            };
            Pool.prototype.clear = function () {
                this.items.length = 0;
            };
            return Pool;
        }());
        core.Pool = Pool;
        var Vector2 = (function () {
            function Vector2(x, y) {
                if (x === void 0) { x = 0; }
                if (y === void 0) { y = 0; }
                this.x = x;
                this.y = y;
            }
            Vector2.prototype.set = function (x, y) {
                this.x = x;
                this.y = y;
                return this;
            };
            Vector2.prototype.length = function () {
                var x = this.x;
                var y = this.y;
                return Math.sqrt(x * x + y * y);
            };
            Vector2.prototype.normalize = function () {
                var len = this.length();
                if (len != 0) {
                    this.x /= len;
                    this.y /= len;
                }
                return this;
            };
            return Vector2;
        }());
        core.Vector2 = Vector2;
        var TimeKeeper = (function () {
            function TimeKeeper() {
                this.maxDelta = 0.064;
                this.framesPerSecond = 0;
                this.delta = 0;
                this.totalTime = 0;
                this.lastTime = Date.now() / 1000;
                this.frameCount = 0;
                this.frameTime = 0;
            }
            TimeKeeper.prototype.update = function () {
                var now = Date.now() / 1000;
                this.delta = now - this.lastTime;
                this.frameTime += this.delta;
                this.totalTime += this.delta;
                if (this.delta > this.maxDelta)
                    this.delta = this.maxDelta;
                this.lastTime = now;
                this.frameCount++;
                if (this.frameTime > 1) {
                    this.framesPerSecond = this.frameCount / this.frameTime;
                    this.frameTime = 0;
                    this.frameCount = 0;
                }
            };
            return TimeKeeper;
        }());
        core.TimeKeeper = TimeKeeper;
        var WindowedMean = (function () {
            function WindowedMean(windowSize) {
                if (windowSize === void 0) { windowSize = 32; }
                this.addedValues = 0;
                this.lastValue = 0;
                this.mean = 0;
                this.dirty = true;
                this.values = new Array(windowSize);
            }
            WindowedMean.prototype.hasEnoughData = function () {
                return this.addedValues >= this.values.length;
            };
            WindowedMean.prototype.addValue = function (value) {
                if (this.addedValues < this.values.length)
                    this.addedValues++;
                this.values[this.lastValue++] = value;
                if (this.lastValue > this.values.length - 1)
                    this.lastValue = 0;
                this.dirty = true;
            };
            WindowedMean.prototype.getMean = function () {
                if (this.hasEnoughData()) {
                    if (this.dirty) {
                        var mean = 0;
                        for (var i = 0; i < this.values.length; i++) {
                            mean += this.values[i];
                        }
                        this.mean = mean / this.values.length;
                        this.dirty = false;
                    }
                    return this.mean;
                }
                else {
                    return 0;
                }
            };
            return WindowedMean;
        }());
        core.WindowedMean = WindowedMean;
    })(core = pixi_spine.core || (pixi_spine.core = {}));
})(pixi_spine || (pixi_spine = {}));
var pixi_spine;
(function (pixi_spine) {
    var core;
    (function (core) {
        var Attachment = (function () {
            function Attachment(name) {
                if (name == null)
                    throw new Error("name cannot be null.");
                this.name = name;
            }
            return Attachment;
        }());
        core.Attachment = Attachment;
        var VertexAttachment = (function (_super) {
            __extends(VertexAttachment, _super);
            function VertexAttachment(name) {
                var _this = _super.call(this, name) || this;
                _this.id = (VertexAttachment.nextID++ & 65535) << 11;
                _this.worldVerticesLength = 0;
                _this.deformAttachment = _this;
                return _this;
            }
            VertexAttachment.prototype.computeWorldVerticesOld = function (slot, worldVertices) {
                this.computeWorldVertices(slot, 0, this.worldVerticesLength, worldVertices, 0, 2);
            };
            VertexAttachment.prototype.computeWorldVertices = function (slot, start, count, worldVertices, offset, stride) {
                count = offset + (count >> 1) * stride;
                var skeleton = slot.bone.skeleton;
                var deformArray = slot.deform;
                var vertices = this.vertices;
                var bones = this.bones;
                if (bones == null) {
                    if (deformArray.length > 0)
                        vertices = deformArray;
                    var mat = slot.bone.matrix;
                    var x = mat.tx;
                    var y = mat.ty;
                    var a = mat.a, b = mat.c, c = mat.b, d = mat.d;
                    for (var v_1 = start, w = offset; w < count; v_1 += 2, w += stride) {
                        var vx = vertices[v_1], vy = vertices[v_1 + 1];
                        worldVertices[w] = vx * a + vy * b + x;
                        worldVertices[w + 1] = vx * c + vy * d + y;
                    }
                    return;
                }
                var v = 0, skip = 0;
                for (var i = 0; i < start; i += 2) {
                    var n = bones[v];
                    v += n + 1;
                    skip += n;
                }
                var skeletonBones = skeleton.bones;
                if (deformArray.length == 0) {
                    for (var w = offset, b = skip * 3; w < count; w += stride) {
                        var wx = 0, wy = 0;
                        var n = bones[v++];
                        n += v;
                        for (; v < n; v++, b += 3) {
                            var mat = skeletonBones[bones[v]].matrix;
                            var vx = vertices[b], vy = vertices[b + 1], weight = vertices[b + 2];
                            wx += (vx * mat.a + vy * mat.c + mat.tx) * weight;
                            wy += (vx * mat.b + vy * mat.d + mat.ty) * weight;
                        }
                        worldVertices[w] = wx;
                        worldVertices[w + 1] = wy;
                    }
                }
                else {
                    var deform = deformArray;
                    for (var w = offset, b = skip * 3, f = skip << 1; w < count; w += stride) {
                        var wx = 0, wy = 0;
                        var n = bones[v++];
                        n += v;
                        for (; v < n; v++, b += 3, f += 2) {
                            var mat = skeletonBones[bones[v]].matrix;
                            var vx = vertices[b] + deform[f], vy = vertices[b + 1] + deform[f + 1], weight = vertices[b + 2];
                            wx += (vx * mat.a + vy * mat.c + mat.tx) * weight;
                            wy += (vx * mat.b + vy * mat.d + mat.ty) * weight;
                        }
                        worldVertices[w] = wx;
                        worldVertices[w + 1] = wy;
                    }
                }
            };
            VertexAttachment.prototype.copyTo = function (attachment) {
                if (this.bones != null) {
                    attachment.bones = new Array(this.bones.length);
                    core.Utils.arrayCopy(this.bones, 0, attachment.bones, 0, this.bones.length);
                }
                else
                    attachment.bones = null;
                if (this.vertices != null) {
                    attachment.vertices = core.Utils.newFloatArray(this.vertices.length);
                    core.Utils.arrayCopy(this.vertices, 0, attachment.vertices, 0, this.vertices.length);
                }
                else
                    attachment.vertices = null;
                attachment.worldVerticesLength = this.worldVerticesLength;
                attachment.deformAttachment = this.deformAttachment;
            };
            VertexAttachment.nextID = 0;
            return VertexAttachment;
        }(Attachment));
        core.VertexAttachment = VertexAttachment;
    })(core = pixi_spine.core || (pixi_spine.core = {}));
})(pixi_spine || (pixi_spine = {}));
var pixi_spine;
(function (pixi_spine) {
    var core;
    (function (core) {
        var AttachmentType;
        (function (AttachmentType) {
            AttachmentType[AttachmentType["Region"] = 0] = "Region";
            AttachmentType[AttachmentType["BoundingBox"] = 1] = "BoundingBox";
            AttachmentType[AttachmentType["Mesh"] = 2] = "Mesh";
            AttachmentType[AttachmentType["LinkedMesh"] = 3] = "LinkedMesh";
            AttachmentType[AttachmentType["Path"] = 4] = "Path";
            AttachmentType[AttachmentType["Point"] = 5] = "Point";
            AttachmentType[AttachmentType["Clipping"] = 6] = "Clipping";
        })(AttachmentType = core.AttachmentType || (core.AttachmentType = {}));
    })(core = pixi_spine.core || (pixi_spine.core = {}));
})(pixi_spine || (pixi_spine = {}));
var pixi_spine;
(function (pixi_spine) {
    var core;
    (function (core) {
        var BoundingBoxAttachment = (function (_super) {
            __extends(BoundingBoxAttachment, _super);
            function BoundingBoxAttachment(name) {
                var _this = _super.call(this, name) || this;
                _this.color = new core.Color(1, 1, 1, 1);
                return _this;
            }
            BoundingBoxAttachment.prototype.copy = function () {
                var copy = new BoundingBoxAttachment(name);
                this.copyTo(copy);
                copy.color.setFromColor(this.color);
                return copy;
            };
            return BoundingBoxAttachment;
        }(core.VertexAttachment));
        core.BoundingBoxAttachment = BoundingBoxAttachment;
    })(core = pixi_spine.core || (pixi_spine.core = {}));
})(pixi_spine || (pixi_spine = {}));
var pixi_spine;
(function (pixi_spine) {
    var core;
    (function (core) {
        var ClippingAttachment = (function (_super) {
            __extends(ClippingAttachment, _super);
            function ClippingAttachment(name) {
                var _this = _super.call(this, name) || this;
                _this.color = new core.Color(0.2275, 0.2275, 0.8078, 1);
                return _this;
            }
            ClippingAttachment.prototype.copy = function () {
                var copy = new ClippingAttachment(name);
                this.copyTo(copy);
                copy.endSlot = this.endSlot;
                copy.color.setFromColor(this.color);
                return copy;
            };
            return ClippingAttachment;
        }(core.VertexAttachment));
        core.ClippingAttachment = ClippingAttachment;
    })(core = pixi_spine.core || (pixi_spine.core = {}));
})(pixi_spine || (pixi_spine = {}));
var pixi_spine;
(function (pixi_spine) {
    var core;
    (function (core) {
        var MeshAttachment = (function (_super) {
            __extends(MeshAttachment, _super);
            function MeshAttachment(name) {
                var _this = _super.call(this, name) || this;
                _this.color = new core.Color(1, 1, 1, 1);
                _this.tempColor = new core.Color(0, 0, 0, 0);
                return _this;
            }
            MeshAttachment.prototype.updateUVs = function (region, uvs) {
                var regionUVs = this.regionUVs;
                var n = regionUVs.length;
                if (!uvs || uvs.length != n) {
                    uvs = core.Utils.newFloatArray(n);
                }
                if (region == null) {
                    return;
                }
                var texture = region.texture;
                var r = texture._uvs;
                var w1 = region.width, h1 = region.height, w2 = region.originalWidth, h2 = region.originalHeight;
                var x = region.offsetX, y = region.pixiOffsetY;
                for (var i = 0; i < n; i += 2) {
                    var u = this.regionUVs[i], v = this.regionUVs[i + 1];
                    u = (u * w2 - x) / w1;
                    v = (v * h2 - y) / h1;
                    uvs[i] = (r.x0 * (1 - u) + r.x1 * u) * (1 - v) + (r.x3 * (1 - u) + r.x2 * u) * v;
                    uvs[i + 1] = (r.y0 * (1 - u) + r.y1 * u) * (1 - v) + (r.y3 * (1 - u) + r.y2 * u) * v;
                }
                return uvs;
            };
            MeshAttachment.prototype.getParentMesh = function () {
                return this.parentMesh;
            };
            MeshAttachment.prototype.setParentMesh = function (parentMesh) {
                this.parentMesh = parentMesh;
                if (parentMesh != null) {
                    this.bones = parentMesh.bones;
                    this.vertices = parentMesh.vertices;
                    this.worldVerticesLength = parentMesh.worldVerticesLength;
                    this.regionUVs = parentMesh.regionUVs;
                    this.triangles = parentMesh.triangles;
                    this.hullLength = parentMesh.hullLength;
                    this.worldVerticesLength = parentMesh.worldVerticesLength;
                }
            };
            MeshAttachment.prototype.copy = function () {
                if (this.parentMesh != null)
                    return this.newLinkedMesh();
                var copy = new MeshAttachment(this.name);
                copy.region = this.region;
                copy.path = this.path;
                copy.color.setFromColor(this.color);
                this.copyTo(copy);
                copy.regionUVs = new Float32Array(this.regionUVs.length);
                core.Utils.arrayCopy(this.regionUVs, 0, copy.regionUVs, 0, this.regionUVs.length);
                copy.uvs = new Array(this.uvs.length);
                core.Utils.arrayCopy(this.uvs, 0, copy.uvs, 0, this.uvs.length);
                copy.triangles = new Array(this.triangles.length);
                core.Utils.arrayCopy(this.triangles, 0, copy.triangles, 0, this.triangles.length);
                copy.hullLength = this.hullLength;
                if (this.edges != null) {
                    copy.edges = new Array(this.edges.length);
                    core.Utils.arrayCopy(this.edges, 0, copy.edges, 0, this.edges.length);
                }
                copy.width = this.width;
                copy.height = this.height;
                return copy;
            };
            MeshAttachment.prototype.newLinkedMesh = function () {
                var copy = new MeshAttachment(this.name);
                copy.region = this.region;
                copy.path = this.path;
                copy.color.setFromColor(this.color);
                copy.deformAttachment = this.deformAttachment;
                copy.setParentMesh(this.parentMesh != null ? this.parentMesh : this);
                return copy;
            };
            return MeshAttachment;
        }(core.VertexAttachment));
        core.MeshAttachment = MeshAttachment;
    })(core = pixi_spine.core || (pixi_spine.core = {}));
})(pixi_spine || (pixi_spine = {}));
var pixi_spine;
(function (pixi_spine) {
    var core;
    (function (core) {
        var PathAttachment = (function (_super) {
            __extends(PathAttachment, _super);
            function PathAttachment(name) {
                var _this = _super.call(this, name) || this;
                _this.closed = false;
                _this.constantSpeed = false;
                _this.color = new core.Color(1, 1, 1, 1);
                return _this;
            }
            PathAttachment.prototype.copy = function () {
                var copy = new PathAttachment(name);
                this.copyTo(copy);
                copy.lengths = new Array(this.lengths.length);
                core.Utils.arrayCopy(this.lengths, 0, copy.lengths, 0, this.lengths.length);
                copy.closed = closed;
                copy.constantSpeed = this.constantSpeed;
                copy.color.setFromColor(this.color);
                return copy;
            };
            return PathAttachment;
        }(core.VertexAttachment));
        core.PathAttachment = PathAttachment;
    })(core = pixi_spine.core || (pixi_spine.core = {}));
})(pixi_spine || (pixi_spine = {}));
var pixi_spine;
(function (pixi_spine) {
    var core;
    (function (core) {
        var PointAttachment = (function (_super) {
            __extends(PointAttachment, _super);
            function PointAttachment(name) {
                var _this = _super.call(this, name) || this;
                _this.color = new core.Color(0.38, 0.94, 0, 1);
                return _this;
            }
            PointAttachment.prototype.computeWorldPosition = function (bone, point) {
                var mat = bone.matrix;
                point.x = this.x * mat.a + this.y * mat.c + bone.worldX;
                point.y = this.x * mat.b + this.y * mat.d + bone.worldY;
                return point;
            };
            PointAttachment.prototype.computeWorldRotation = function (bone) {
                var mat = bone.matrix;
                var cos = core.MathUtils.cosDeg(this.rotation), sin = core.MathUtils.sinDeg(this.rotation);
                var x = cos * mat.a + sin * mat.c;
                var y = cos * mat.b + sin * mat.d;
                return Math.atan2(y, x) * core.MathUtils.radDeg;
            };
            PointAttachment.prototype.copy = function () {
                var copy = new PointAttachment(name);
                copy.x = this.x;
                copy.y = this.y;
                copy.rotation = this.rotation;
                copy.color.setFromColor(this.color);
                return copy;
            };
            return PointAttachment;
        }(core.VertexAttachment));
        core.PointAttachment = PointAttachment;
    })(core = pixi_spine.core || (pixi_spine.core = {}));
})(pixi_spine || (pixi_spine = {}));
var pixi_spine;
(function (pixi_spine) {
    var core;
    (function (core) {
        var RegionAttachment = (function (_super) {
            __extends(RegionAttachment, _super);
            function RegionAttachment(name) {
                var _this = _super.call(this, name) || this;
                _this.x = 0;
                _this.y = 0;
                _this.scaleX = 1;
                _this.scaleY = 1;
                _this.rotation = 0;
                _this.width = 0;
                _this.height = 0;
                _this.color = new core.Color(1, 1, 1, 1);
                _this.offset = core.Utils.newFloatArray(8);
                _this.uvs = core.Utils.newFloatArray(8);
                _this.tempColor = new core.Color(1, 1, 1, 1);
                return _this;
            }
            RegionAttachment.prototype.updateOffset = function () {
                var regionScaleX = this.width / this.region.originalWidth * this.scaleX;
                var regionScaleY = this.height / this.region.originalHeight * this.scaleY;
                var localX = -this.width / 2 * this.scaleX + this.region.offsetX * regionScaleX;
                var localY = -this.height / 2 * this.scaleY + this.region.offsetY * regionScaleY;
                var localX2 = localX + this.region.width * regionScaleX;
                var localY2 = localY + this.region.height * regionScaleY;
                var radians = this.rotation * Math.PI / 180;
                var cos = Math.cos(radians);
                var sin = Math.sin(radians);
                var localXCos = localX * cos + this.x;
                var localXSin = localX * sin;
                var localYCos = localY * cos + this.y;
                var localYSin = localY * sin;
                var localX2Cos = localX2 * cos + this.x;
                var localX2Sin = localX2 * sin;
                var localY2Cos = localY2 * cos + this.y;
                var localY2Sin = localY2 * sin;
                var offset = this.offset;
                offset[RegionAttachment.OX1] = localXCos - localYSin;
                offset[RegionAttachment.OY1] = localYCos + localXSin;
                offset[RegionAttachment.OX2] = localXCos - localY2Sin;
                offset[RegionAttachment.OY2] = localY2Cos + localXSin;
                offset[RegionAttachment.OX3] = localX2Cos - localY2Sin;
                offset[RegionAttachment.OY3] = localY2Cos + localX2Sin;
                offset[RegionAttachment.OX4] = localX2Cos - localYSin;
                offset[RegionAttachment.OY4] = localYCos + localX2Sin;
            };
            RegionAttachment.prototype.setRegion = function (region) {
                this.region = region;
                var uvs = this.uvs;
                if (region.rotate) {
                    uvs[2] = region.u;
                    uvs[3] = region.v2;
                    uvs[4] = region.u;
                    uvs[5] = region.v;
                    uvs[6] = region.u2;
                    uvs[7] = region.v;
                    uvs[0] = region.u2;
                    uvs[1] = region.v2;
                }
                else {
                    uvs[0] = region.u;
                    uvs[1] = region.v2;
                    uvs[2] = region.u;
                    uvs[3] = region.v;
                    uvs[4] = region.u2;
                    uvs[5] = region.v;
                    uvs[6] = region.u2;
                    uvs[7] = region.v2;
                }
            };
            RegionAttachment.prototype.computeWorldVertices = function (bone, worldVertices, offset, stride) {
                var vertexOffset = this.offset;
                var mat = bone.matrix;
                var x = mat.tx, y = mat.ty;
                var a = mat.a, b = mat.c, c = mat.b, d = mat.d;
                var offsetX = 0, offsetY = 0;
                offsetX = vertexOffset[RegionAttachment.OX1];
                offsetY = vertexOffset[RegionAttachment.OY1];
                worldVertices[offset] = offsetX * a + offsetY * b + x;
                worldVertices[offset + 1] = offsetX * c + offsetY * d + y;
                offset += stride;
                offsetX = vertexOffset[RegionAttachment.OX2];
                offsetY = vertexOffset[RegionAttachment.OY2];
                worldVertices[offset] = offsetX * a + offsetY * b + x;
                worldVertices[offset + 1] = offsetX * c + offsetY * d + y;
                offset += stride;
                offsetX = vertexOffset[RegionAttachment.OX3];
                offsetY = vertexOffset[RegionAttachment.OY3];
                worldVertices[offset] = offsetX * a + offsetY * b + x;
                worldVertices[offset + 1] = offsetX * c + offsetY * d + y;
                offset += stride;
                offsetX = vertexOffset[RegionAttachment.OX4];
                offsetY = vertexOffset[RegionAttachment.OY4];
                worldVertices[offset] = offsetX * a + offsetY * b + x;
                worldVertices[offset + 1] = offsetX * c + offsetY * d + y;
            };
            RegionAttachment.prototype.copy = function () {
                var copy = new RegionAttachment(name);
                copy.region = this.region;
                copy.rendererObject = this.rendererObject;
                copy.path = this.path;
                copy.x = this.x;
                copy.y = this.y;
                copy.scaleX = this.scaleX;
                copy.scaleY = this.scaleY;
                copy.rotation = this.rotation;
                copy.width = this.width;
                copy.height = this.height;
                core.Utils.arrayCopy(this.uvs, 0, copy.uvs, 0, 8);
                core.Utils.arrayCopy(this.offset, 0, copy.offset, 0, 8);
                copy.color.setFromColor(this.color);
                return copy;
            };
            RegionAttachment.OX1 = 0;
            RegionAttachment.OY1 = 1;
            RegionAttachment.OX2 = 2;
            RegionAttachment.OY2 = 3;
            RegionAttachment.OX3 = 4;
            RegionAttachment.OY3 = 5;
            RegionAttachment.OX4 = 6;
            RegionAttachment.OY4 = 7;
            RegionAttachment.X1 = 0;
            RegionAttachment.Y1 = 1;
            RegionAttachment.C1R = 2;
            RegionAttachment.C1G = 3;
            RegionAttachment.C1B = 4;
            RegionAttachment.C1A = 5;
            RegionAttachment.U1 = 6;
            RegionAttachment.V1 = 7;
            RegionAttachment.X2 = 8;
            RegionAttachment.Y2 = 9;
            RegionAttachment.C2R = 10;
            RegionAttachment.C2G = 11;
            RegionAttachment.C2B = 12;
            RegionAttachment.C2A = 13;
            RegionAttachment.U2 = 14;
            RegionAttachment.V2 = 15;
            RegionAttachment.X3 = 16;
            RegionAttachment.Y3 = 17;
            RegionAttachment.C3R = 18;
            RegionAttachment.C3G = 19;
            RegionAttachment.C3B = 20;
            RegionAttachment.C3A = 21;
            RegionAttachment.U3 = 22;
            RegionAttachment.V3 = 23;
            RegionAttachment.X4 = 24;
            RegionAttachment.Y4 = 25;
            RegionAttachment.C4R = 26;
            RegionAttachment.C4G = 27;
            RegionAttachment.C4B = 28;
            RegionAttachment.C4A = 29;
            RegionAttachment.U4 = 30;
            RegionAttachment.V4 = 31;
            return RegionAttachment;
        }(core.Attachment));
        core.RegionAttachment = RegionAttachment;
    })(core = pixi_spine.core || (pixi_spine.core = {}));
})(pixi_spine || (pixi_spine = {}));
var pixi_spine;
(function (pixi_spine) {
    var core;
    (function (core) {
        var JitterEffect = (function () {
            function JitterEffect(jitterX, jitterY) {
                this.jitterX = 0;
                this.jitterY = 0;
                this.jitterX = jitterX;
                this.jitterY = jitterY;
            }
            JitterEffect.prototype.begin = function (skeleton) {
            };
            JitterEffect.prototype.transform = function (position, uv, light, dark) {
                position.x += core.MathUtils.randomTriangular(-this.jitterX, this.jitterY);
                position.y += core.MathUtils.randomTriangular(-this.jitterX, this.jitterY);
            };
            JitterEffect.prototype.end = function () {
            };
            return JitterEffect;
        }());
        core.JitterEffect = JitterEffect;
    })(core = pixi_spine.core || (pixi_spine.core = {}));
})(pixi_spine || (pixi_spine = {}));
var pixi_spine;
(function (pixi_spine) {
    var core;
    (function (core) {
        var SwirlEffect = (function () {
            function SwirlEffect(radius) {
                this.centerX = 0;
                this.centerY = 0;
                this.radius = 0;
                this.angle = 0;
                this.worldX = 0;
                this.worldY = 0;
                this.radius = radius;
            }
            SwirlEffect.prototype.begin = function (skeleton) {
                this.worldX = skeleton.x + this.centerX;
                this.worldY = skeleton.y + this.centerY;
            };
            SwirlEffect.prototype.transform = function (position, uv, light, dark) {
                var radAngle = this.angle * core.MathUtils.degreesToRadians;
                var x = position.x - this.worldX;
                var y = position.y - this.worldY;
                var dist = Math.sqrt(x * x + y * y);
                if (dist < this.radius) {
                    var theta = SwirlEffect.interpolation.apply(0, radAngle, (this.radius - dist) / this.radius);
                    var cos = Math.cos(theta);
                    var sin = Math.sin(theta);
                    position.x = cos * x - sin * y + this.worldX;
                    position.y = sin * x + cos * y + this.worldY;
                }
            };
            SwirlEffect.prototype.end = function () {
            };
            SwirlEffect.interpolation = new core.PowOut(2);
            return SwirlEffect;
        }());
        core.SwirlEffect = SwirlEffect;
    })(core = pixi_spine.core || (pixi_spine.core = {}));
})(pixi_spine || (pixi_spine = {}));
(function () {
    if (!Math.fround) {
        Math.fround = Math.fround = (function (array) {
            return function (x) {
                return array[0] = x, array[0];
            };
        })(new Float32Array(1));
    }
})();
var pixi_spine;
(function (pixi_spine) {
    pixi_spine.core.Bone.yDown = true;
    var tempRgb = [0, 0, 0];
    var SpineSprite = (function (_super) {
        __extends(SpineSprite, _super);
        function SpineSprite() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.region = null;
            return _this;
        }
        return SpineSprite;
    }(PIXI.Sprite));
    pixi_spine.SpineSprite = SpineSprite;
    var SpineMesh = (function (_super) {
        __extends(SpineMesh, _super);
        function SpineMesh(texture, vertices, uvs, indices, drawMode) {
            return _super.call(this, texture, vertices, uvs, indices, drawMode) || this;
        }
        return SpineMesh;
    }(PIXI.mesh.Mesh));
    pixi_spine.SpineMesh = SpineMesh;
    var Spine = (function (_super) {
        __extends(Spine, _super);
        function Spine(spineData) {
            var _this = _super.call(this) || this;
            if (!spineData) {
                throw new Error('The spineData param is required.');
            }
            if ((typeof spineData) === "string") {
                throw new Error('spineData param cant be string. Please use spine.Spine.fromAtlas("YOUR_RESOURCE_NAME") from now on.');
            }
            _this.spineData = spineData;
            _this.skeleton = new pixi_spine.core.Skeleton(spineData);
            _this.skeleton.updateWorldTransform();
            _this.stateData = new pixi_spine.core.AnimationStateData(spineData);
            _this.state = new pixi_spine.core.AnimationState(_this.stateData);
            _this.slotContainers = [];
            _this.tempClipContainers = [];
            for (var i = 0, n = _this.skeleton.slots.length; i < n; i++) {
                var slot = _this.skeleton.slots[i];
                var attachment = slot.getAttachment();
                var slotContainer = _this.newContainer();
                _this.slotContainers.push(slotContainer);
                _this.addChild(slotContainer);
                _this.tempClipContainers.push(null);
                if (attachment instanceof pixi_spine.core.RegionAttachment) {
                    var spriteName = attachment.region.name;
                    var sprite = _this.createSprite(slot, attachment, spriteName);
                    slot.currentSprite = sprite;
                    slot.currentSpriteName = spriteName;
                    slotContainer.addChild(sprite);
                }
                else if (attachment instanceof pixi_spine.core.MeshAttachment) {
                    var mesh = _this.createMesh(slot, attachment);
                    slot.currentMesh = mesh;
                    slot.currentMeshName = attachment.name;
                    slotContainer.addChild(mesh);
                }
                else if (attachment instanceof pixi_spine.core.ClippingAttachment) {
                    _this.createGraphics(slot, attachment);
                    slotContainer.addChild(slot.clippingContainer);
                    slotContainer.addChild(slot.currentGraphics);
                }
                else {
                    continue;
                }
            }
            _this.autoUpdate = true;
            _this.tintRgb = new Float32Array([1, 1, 1]);
            return _this;
        }
        Object.defineProperty(Spine.prototype, "autoUpdate", {
            get: function () {
                return (this.updateTransform === Spine.prototype.autoUpdateTransform);
            },
            set: function (value) {
                this.updateTransform = value ? Spine.prototype.autoUpdateTransform : PIXI.Container.prototype.updateTransform;
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Spine.prototype, "tint", {
            get: function () {
                return PIXI.utils.rgb2hex(this.tintRgb);
            },
            set: function (value) {
                this.tintRgb = PIXI.utils.hex2rgb(value, this.tintRgb);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(Spine.prototype, "delayLimit", {
            get: function () {
                var limit = typeof this.localDelayLimit !== "undefined" ?
                    this.localDelayLimit : Spine.globalDelayLimit;
                return limit || Number.MAX_VALUE;
            },
            enumerable: true,
            configurable: true
        });
        Spine.prototype.update = function (dt) {
            var delayLimit = this.delayLimit;
            if (dt > delayLimit)
                dt = delayLimit;
            this.state.update(dt);
            this.state.apply(this.skeleton);
            if (!this.skeleton)
                return;
            this.skeleton.updateWorldTransform();
            var slots = this.skeleton.slots;
            var globalClr = this.color;
            var light = null, dark = null;
            if (globalClr) {
                light = globalClr.light;
                dark = globalClr.dark;
            }
            else {
                light = this.tintRgb;
            }
            var thack = PIXI.TransformBase && (this.transformHack() == 1);
            for (var i = 0, n = slots.length; i < n; i++) {
                var slot = slots[i];
                var attachment = slot.getAttachment();
                var slotContainer = this.slotContainers[i];
                if (!attachment) {
                    slotContainer.visible = false;
                    continue;
                }
                var spriteColor = null;
                var attColor = attachment.color;
                if (attachment instanceof pixi_spine.core.RegionAttachment) {
                    var region = attachment.region;
                    if (region) {
                        if (slot.currentMesh) {
                            slot.currentMesh.visible = false;
                            slot.currentMesh = null;
                            slot.currentMeshName = undefined;
                        }
                        var ar = region;
                        if (!slot.currentSpriteName || slot.currentSpriteName !== ar.name) {
                            var spriteName = ar.name;
                            if (slot.currentSprite) {
                                slot.currentSprite.visible = false;
                            }
                            slot.sprites = slot.sprites || {};
                            if (slot.sprites[spriteName] !== undefined) {
                                slot.sprites[spriteName].visible = true;
                            }
                            else {
                                var sprite = this.createSprite(slot, attachment, spriteName);
                                slotContainer.addChild(sprite);
                            }
                            slot.currentSprite = slot.sprites[spriteName];
                            slot.currentSpriteName = spriteName;
                        }
                    }
                    if (slotContainer.transform) {
                        var transform = slotContainer.transform;
                        var transAny = transform;
                        var lt = null;
                        if (transAny.matrix2d) {
                            lt = transAny.matrix2d;
                            transAny._dirtyVersion++;
                            transAny.version = transAny._dirtyVersion;
                            transAny.isStatic = true;
                            transAny.operMode = 0;
                        }
                        else {
                            if (thack) {
                                if (transAny.position) {
                                    transform = new PIXI.TransformBase();
                                    transform._parentID = -1;
                                    transform._worldID = slotContainer.transform._worldID;
                                    slotContainer.transform = transform;
                                }
                                lt = transform.localTransform;
                            }
                            else {
                                transAny.setFromMatrix(slot.bone.matrix);
                            }
                        }
                        if (lt) {
                            slot.bone.matrix.copy(lt);
                        }
                    }
                    else {
                        var lt = slotContainer.localTransform || new PIXI.Matrix();
                        slot.bone.matrix.copy(lt);
                        slotContainer.localTransform = lt;
                        slotContainer.displayObjectUpdateTransform = SlotContainerUpdateTransformV3;
                    }
                    if (slot.currentSprite.color) {
                        spriteColor = slot.currentSprite.color;
                    }
                    else {
                        tempRgb[0] = light[0] * slot.color.r * attColor.r;
                        tempRgb[1] = light[1] * slot.color.g * attColor.g;
                        tempRgb[2] = light[2] * slot.color.b * attColor.b;
                        slot.currentSprite.tint = PIXI.utils.rgb2hex(tempRgb);
                    }
                    slot.currentSprite.blendMode = slot.blendMode;
                }
                else if (attachment instanceof pixi_spine.core.MeshAttachment) {
                    if (slot.currentSprite) {
                        slot.currentSprite.visible = false;
                        slot.currentSprite = null;
                        slot.currentSpriteName = undefined;
                        if (slotContainer.transform) {
                            var transform = new PIXI.TransformStatic();
                            transform._parentID = -1;
                            transform._worldID = slotContainer.transform._worldID;
                            slotContainer.transform = transform;
                        }
                        else {
                            slotContainer.localTransform = new PIXI.Matrix();
                            slotContainer.displayObjectUpdateTransform = PIXI.DisplayObject.prototype.updateTransform;
                        }
                    }
                    if (!slot.currentMeshName || slot.currentMeshName !== attachment.name) {
                        var meshName = attachment.name;
                        if (slot.currentMesh) {
                            slot.currentMesh.visible = false;
                        }
                        slot.meshes = slot.meshes || {};
                        if (slot.meshes[meshName] !== undefined) {
                            slot.meshes[meshName].visible = true;
                        }
                        else {
                            var mesh = this.createMesh(slot, attachment);
                            slotContainer.addChild(mesh);
                        }
                        slot.currentMesh = slot.meshes[meshName];
                        slot.currentMeshName = meshName;
                    }
                    attachment.computeWorldVerticesOld(slot, slot.currentMesh.vertices);
                    if (slot.currentMesh.color) {
                        spriteColor = slot.currentMesh.color;
                    }
                    else if (PIXI.VERSION[0] !== '3') {
                        var tintRgb = slot.currentMesh.tintRgb;
                        tintRgb[0] = light[0] * slot.color.r * attColor.r;
                        tintRgb[1] = light[1] * slot.color.g * attColor.g;
                        tintRgb[2] = light[2] * slot.color.b * attColor.b;
                    }
                    slot.currentMesh.blendMode = slot.blendMode;
                }
                else if (attachment instanceof pixi_spine.core.ClippingAttachment) {
                    if (!slot.currentGraphics) {
                        this.createGraphics(slot, attachment);
                        slotContainer.addChild(slot.clippingContainer);
                        slotContainer.addChild(slot.currentGraphics);
                    }
                    this.updateGraphics(slot, attachment);
                }
                else {
                    slotContainer.visible = false;
                    continue;
                }
                slotContainer.visible = true;
                if (spriteColor) {
                    var r0 = slot.color.r * attColor.r;
                    var g0 = slot.color.g * attColor.g;
                    var b0 = slot.color.b * attColor.b;
                    spriteColor.setLight(light[0] * r0 + dark[0] * (1.0 - r0), light[1] * g0 + dark[1] * (1.0 - g0), light[2] * b0 + dark[2] * (1.0 - b0));
                    if (slot.darkColor) {
                        r0 = slot.darkColor.r;
                        g0 = slot.darkColor.g;
                        b0 = slot.darkColor.b;
                    }
                    else {
                        r0 = 0.0;
                        g0 = 0.0;
                        b0 = 0.0;
                    }
                    spriteColor.setDark(light[0] * r0 + dark[0] * (1 - r0), light[1] * g0 + dark[1] * (1 - g0), light[2] * b0 + dark[2] * (1 - b0));
                }
                slotContainer.alpha = slot.color.a;
            }
            var drawOrder = this.skeleton.drawOrder;
            var clippingAttachment = null;
            var clippingContainer = null;
            for (var i = 0, n = drawOrder.length; i < n; i++) {
                var slot = slots[drawOrder[i].data.index];
                var slotContainer = this.slotContainers[drawOrder[i].data.index];
                if (!clippingContainer) {
                    if (slotContainer.parent !== null && slotContainer.parent !== this) {
                        slotContainer.parent.removeChild(slotContainer);
                        slotContainer.parent = this;
                    }
                }
                if (slot.currentGraphics && slot.getAttachment()) {
                    clippingContainer = slot.clippingContainer;
                    clippingAttachment = slot.getAttachment();
                    clippingContainer.children.length = 0;
                    this.children[i] = slotContainer;
                    if (clippingAttachment.endSlot == slot.data) {
                        clippingAttachment.endSlot = null;
                    }
                }
                else {
                    if (clippingContainer) {
                        var c = this.tempClipContainers[i];
                        if (!c) {
                            c = this.tempClipContainers[i] = this.newContainer();
                            c.visible = false;
                        }
                        this.children[i] = c;
                        slotContainer.parent = null;
                        clippingContainer.addChild(slotContainer);
                        if (clippingAttachment.endSlot == slot.data) {
                            clippingContainer.renderable = true;
                            clippingContainer = null;
                            clippingAttachment = null;
                        }
                    }
                    else {
                        this.children[i] = slotContainer;
                    }
                }
            }
        };
        ;
        Spine.prototype.setSpriteRegion = function (attachment, sprite, region) {
            sprite.region = region;
            sprite.texture = region.texture;
            if (!region.size) {
                sprite.scale.x = attachment.scaleX * attachment.width / region.originalWidth;
                sprite.scale.y = -attachment.scaleY * attachment.height / region.originalHeight;
            }
            else {
                sprite.scale.x = region.size.width / region.originalWidth;
                sprite.scale.y = -region.size.height / region.originalHeight;
            }
        };
        Spine.prototype.setMeshRegion = function (attachment, mesh, region) {
            mesh.region = region;
            mesh.texture = region.texture;
            region.texture._updateUvs();
            attachment.updateUVs(region, mesh.uvs);
            mesh.dirty++;
        };
        Spine.prototype.autoUpdateTransform = function () {
            if (Spine.globalAutoUpdate) {
                this.lastTime = this.lastTime || Date.now();
                var timeDelta = (Date.now() - this.lastTime) * 0.001;
                this.lastTime = Date.now();
                this.update(timeDelta);
            }
            else {
                this.lastTime = 0;
            }
            PIXI.Container.prototype.updateTransform.call(this);
        };
        ;
        Spine.prototype.createSprite = function (slot, attachment, defName) {
            var region = attachment.region;
            if (slot.tempAttachment === attachment) {
                region = slot.tempRegion;
                slot.tempAttachment = null;
                slot.tempRegion = null;
            }
            var texture = region.texture;
            var sprite = this.newSprite(texture);
            sprite.rotation = attachment.rotation * pixi_spine.core.MathUtils.degRad;
            sprite.anchor.x = 0.5;
            sprite.anchor.y = 0.5;
            sprite.position.x = attachment.x;
            sprite.position.y = attachment.y;
            sprite.alpha = attachment.color.a;
            sprite.region = attachment.region;
            this.setSpriteRegion(attachment, sprite, attachment.region);
            slot.sprites = slot.sprites || {};
            slot.sprites[defName] = sprite;
            return sprite;
        };
        ;
        Spine.prototype.createMesh = function (slot, attachment) {
            var region = attachment.region;
            if (slot.tempAttachment === attachment) {
                region = slot.tempRegion;
                slot.tempAttachment = null;
                slot.tempRegion = null;
            }
            var strip = this.newMesh(region.texture, new Float32Array(attachment.regionUVs.length), new Float32Array(attachment.regionUVs.length), new Uint16Array(attachment.triangles), PIXI.mesh.Mesh.DRAW_MODES.TRIANGLES);
            strip.canvasPadding = 1.5;
            strip.alpha = attachment.color.a;
            strip.region = attachment.region;
            this.setMeshRegion(attachment, strip, region);
            slot.meshes = slot.meshes || {};
            slot.meshes[attachment.name] = strip;
            return strip;
        };
        ;
        Spine.prototype.createGraphics = function (slot, clip) {
            var graphics = this.newGraphics();
            var poly = new PIXI.Polygon([]);
            graphics.clear();
            graphics.beginFill(0xffffff, 1);
            graphics.drawPolygon(poly);
            graphics.renderable = false;
            slot.currentGraphics = graphics;
            slot.clippingContainer = this.newContainer();
            slot.clippingContainer.mask = slot.currentGraphics;
            return graphics;
        };
        Spine.prototype.updateGraphics = function (slot, clip) {
            var vertices = slot.currentGraphics.graphicsData[0].shape.points;
            var n = clip.worldVerticesLength;
            vertices.length = n;
            clip.computeWorldVertices(slot, 0, n, vertices, 0, 2);
            slot.currentGraphics.dirty++;
            slot.currentGraphics.clearDirty++;
        };
        Spine.prototype.hackTextureBySlotIndex = function (slotIndex, texture, size) {
            if (texture === void 0) { texture = null; }
            if (size === void 0) { size = null; }
            var slot = this.skeleton.slots[slotIndex];
            if (!slot) {
                return false;
            }
            var attachment = slot.getAttachment();
            var region = attachment.region;
            if (texture) {
                region = new pixi_spine.core.TextureRegion();
                region.texture = texture;
                region.size = size;
            }
            if (slot.currentSprite && slot.currentSprite.region != region) {
                this.setSpriteRegion(attachment, slot.currentSprite, region);
                slot.currentSprite.region = region;
            }
            else if (slot.currentMesh && slot.currentMesh.region != region) {
                this.setMeshRegion(attachment, slot.currentMesh, region);
            }
            else {
                slot.tempRegion = region;
                slot.tempAttachment = attachment;
            }
            return true;
        };
        Spine.prototype.hackTextureBySlotName = function (slotName, texture, size) {
            if (texture === void 0) { texture = null; }
            if (size === void 0) { size = null; }
            var index = this.skeleton.findSlotIndex(slotName);
            if (index == -1) {
                return false;
            }
            return this.hackTextureBySlotIndex(index, texture, size);
        };
        Spine.prototype.newContainer = function () {
            return new PIXI.Container();
        };
        Spine.prototype.newSprite = function (tex) {
            return new SpineSprite(tex);
        };
        Spine.prototype.newGraphics = function () {
            return new PIXI.Graphics();
        };
        Spine.prototype.newMesh = function (texture, vertices, uvs, indices, drawMode) {
            return new SpineMesh(texture, vertices, uvs, indices, drawMode);
        };
        Spine.prototype.transformHack = function () {
            return 1;
        };
        Spine.prototype.hackAttachmentGroups = function (nameSuffix, group, outGroup) {
            if (!nameSuffix) {
                return;
            }
            var list_d = [], list_n = [];
            for (var i = 0, len = this.skeleton.slots.length; i < len; i++) {
                var slot = this.skeleton.slots[i];
                var name_6 = slot.currentSpriteName || slot.currentMeshName || "";
                var target = slot.currentSprite || slot.currentMesh;
                if (name_6.endsWith(nameSuffix)) {
                    target.parentGroup = group;
                    list_n.push(target);
                }
                else if (outGroup && target) {
                    target.parentGroup = outGroup;
                    list_d.push(target);
                }
            }
            return [list_d, list_n];
        };
        ;
        Spine.prototype.destroy = function (options) {
            for (var i = 0, n = this.skeleton.slots.length; i < n; i++) {
                var slot = this.skeleton.slots[i];
                for (var name_7 in slot.meshes) {
                    slot.meshes[name_7].destroy(options);
                }
                slot.meshes = null;
                for (var name_8 in slot.sprites) {
                    slot.sprites[name_8].destroy(options);
                }
                slot.sprites = null;
            }
            for (var i = 0, n = this.slotContainers.length; i < n; i++) {
                this.slotContainers[i].destroy(options);
            }
            this.spineData = null;
            this.skeleton = null;
            this.slotContainers = null;
            this.stateData = null;
            this.state = null;
            this.tempClipContainers = null;
            _super.prototype.destroy.call(this, options);
        };
        Spine.globalAutoUpdate = true;
        Spine.globalDelayLimit = 0;
        Spine.clippingPolygon = [];
        return Spine;
    }(PIXI.Container));
    pixi_spine.Spine = Spine;
    function SlotContainerUpdateTransformV3() {
        var pt = this.parent.worldTransform;
        var wt = this.worldTransform;
        var lt = this.localTransform;
        wt.a = lt.a * pt.a + lt.b * pt.c;
        wt.b = lt.a * pt.b + lt.b * pt.d;
        wt.c = lt.c * pt.a + lt.d * pt.c;
        wt.d = lt.c * pt.b + lt.d * pt.d;
        wt.tx = lt.tx * pt.a + lt.ty * pt.c + pt.tx;
        wt.ty = lt.tx * pt.b + lt.ty * pt.d + pt.ty;
        this.worldAlpha = this.alpha * this.parent.worldAlpha;
        this._currentBounds = null;
    }
})(pixi_spine || (pixi_spine = {}));
var pixi_spine;
(function (pixi_spine) {
    PIXI.spine = pixi_spine;
    var TextureProto = PIXI.Texture.prototype;
    if (!TextureProto._updateUvs) {
        TextureProto._updateUvs = TextureProto.updateUvs;
    }
})(pixi_spine || (pixi_spine = {}));
var pixi_spine;
(function (pixi_spine) {
    var Resource = PIXI.loaders.Resource;
    function isJson(resource) {
        return resource.type == Resource.TYPE.JSON;
    }
    function isBuffer(resource) {
        return resource.xhrType == Resource.XHR_RESPONSE_TYPE.BUFFER;
    }
    Resource.setExtensionXhrType('skel', Resource.XHR_RESPONSE_TYPE.BUFFER);
    function atlasParser() {
        return function atlasParser(resource, next) {
            if (!resource.data) {
                return next();
            }
            var isJsonSpineModel = isJson(resource) && resource.data.bones;
            var isBinarySpineModel = isBuffer(resource) && (resource.extension === 'skel' || resource.metadata.spineMetadata);
            if (!isJsonSpineModel && !isBinarySpineModel) {
                return next();
            }
            var parser = null;
            var dataToParse = resource.data;
            if (isJsonSpineModel) {
                parser = new pixi_spine.core.SkeletonJson(null);
            }
            else {
                parser = new pixi_spine.core.SkeletonBinary(null);
                if (resource.data instanceof ArrayBuffer) {
                    dataToParse = new Uint8Array(resource.data);
                }
            }
            var metadata = resource.metadata || {};
            var metadataSkeletonScale = metadata ? resource.metadata.spineSkeletonScale : null;
            if (metadataSkeletonScale) {
                parser.scale = metadataSkeletonScale;
            }
            var metadataAtlas = metadata ? resource.metadata.spineAtlas : null;
            if (metadataAtlas === false) {
                return next();
            }
            if (metadataAtlas && metadataAtlas.pages) {
                parser.attachmentLoader = new pixi_spine.core.AtlasAttachmentLoader(metadataAtlas);
                resource.spineData = parser.readSkeletonData(dataToParse);
                resource.spineAtlas = metadataAtlas;
                return next();
            }
            var metadataAtlasSuffix = metadata.spineAtlasSuffix || '.atlas';
            var atlasPath = resource.url;
            var queryStringPos = atlasPath.indexOf('?');
            if (queryStringPos > 0) {
                atlasPath = atlasPath.substr(0, queryStringPos);
            }
            atlasPath = atlasPath.substr(0, atlasPath.lastIndexOf('.')) + metadataAtlasSuffix;
            if (resource.metadata && resource.metadata.spineAtlasFile) {
                atlasPath = resource.metadata.spineAtlasFile;
            }
            atlasPath = atlasPath.replace(this.baseUrl, '');
            var atlasOptions = {
                crossOrigin: resource.crossOrigin,
                xhrType: Resource.XHR_RESPONSE_TYPE.TEXT,
                metadata: metadata.spineMetadata || null,
                parentResource: resource
            };
            var imageOptions = {
                crossOrigin: resource.crossOrigin,
                metadata: metadata.imageMetadata || null,
                parentResource: resource
            };
            var baseUrl = resource.url.substr(0, resource.url.lastIndexOf('/') + 1);
            baseUrl = baseUrl.replace(this.baseUrl, '');
            var namePrefix = metadata.imageNamePrefix || (resource.name + '_atlas_page_');
            var adapter = metadata.images ? staticImageLoader(metadata.images)
                : metadata.image ? staticImageLoader({ 'default': metadata.image })
                    : metadata.imageLoader ? metadata.imageLoader(this, namePrefix, baseUrl, imageOptions)
                        : imageLoaderAdapter(this, namePrefix, baseUrl, imageOptions);
            var createSkeletonWithRawAtlas = function (rawData) {
                new pixi_spine.core.TextureAtlas(rawData, adapter, function (spineAtlas) {
                    if (spineAtlas) {
                        parser.attachmentLoader = new pixi_spine.core.AtlasAttachmentLoader(spineAtlas);
                        resource.spineData = parser.readSkeletonData(dataToParse);
                        resource.spineAtlas = spineAtlas;
                    }
                    next();
                });
            };
            if (resource.metadata && resource.metadata.atlasRawData) {
                createSkeletonWithRawAtlas(resource.metadata.atlasRawData);
            }
            else {
                this.add(resource.name + '_atlas', atlasPath, atlasOptions, function (atlasResource) {
                    if (!atlasResource.error) {
                        createSkeletonWithRawAtlas(atlasResource.data);
                    }
                    else {
                        next();
                    }
                });
            }
        };
    }
    pixi_spine.atlasParser = atlasParser;
    function imageLoaderAdapter(loader, namePrefix, baseUrl, imageOptions) {
        if (baseUrl && baseUrl.lastIndexOf('/') !== (baseUrl.length - 1)) {
            baseUrl += '/';
        }
        return function (line, callback) {
            var name = namePrefix + line;
            var url = baseUrl + line;
            var cachedResource = loader.resources[name];
            if (cachedResource) {
                function done() {
                    callback(cachedResource.texture.baseTexture);
                }
                if (cachedResource.texture) {
                    done();
                }
                else {
                    cachedResource.onAfterMiddleware.add(done);
                }
            }
            else {
                loader.add(name, url, imageOptions, function (resource) {
                    if (!resource.error) {
                        callback(resource.texture.baseTexture);
                    }
                    else {
                        callback(null);
                    }
                });
            }
        };
    }
    pixi_spine.imageLoaderAdapter = imageLoaderAdapter;
    function syncImageLoaderAdapter(baseUrl, crossOrigin) {
        if (baseUrl && baseUrl.lastIndexOf('/') !== (baseUrl.length - 1)) {
            baseUrl += '/';
        }
        return function (line, callback) {
            callback(PIXI.BaseTexture.fromImage(line, crossOrigin));
        };
    }
    pixi_spine.syncImageLoaderAdapter = syncImageLoaderAdapter;
    function staticImageLoader(pages) {
        return function (line, callback) {
            var page = pages[line] || pages['default'];
            if (page && page.baseTexture)
                callback(page.baseTexture);
            else
                callback(page);
        };
    }
    pixi_spine.staticImageLoader = staticImageLoader;
    if (PIXI.loaders.Loader) {
        PIXI.loaders.Loader.addPixiMiddleware(atlasParser);
        PIXI.loader.use(atlasParser());
    }
})(pixi_spine || (pixi_spine = {}));
//# sourceMappingURL=pixi-spine.js.map

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Game_1 = __webpack_require__(442);
var RecodeGameSystem_1 = __webpack_require__(486);
var RecodeGame = /** @class */ (function (_super) {
    __extends(RecodeGame, _super);
    function RecodeGame() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RecodeGame.prototype.createSystem = function (getUrlPath) {
        return new RecodeGameSystem_1.RecodeGameSystem(this.initViewport.bind(this), this.onReady.bind(this), getUrlPath);
    };
    RecodeGame.prototype.init = function () {
        this._system.setupMobileApproach(false);
    };
    return RecodeGame;
}(Game_1.Game));
exports.RecodeGame = RecodeGame;


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseGame_1 = __webpack_require__(443);
var GameSystem_1 = __webpack_require__(236);
var Game = /** @class */ (function (_super) {
    __extends(Game, _super);
    function Game() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Game.prototype.createSystem = function (getUrlPath, majorPerformanceCaveat) {
        return new GameSystem_1.GameSystem(this.initViewport.bind(this), this.onReady.bind(this), getUrlPath, majorPerformanceCaveat);
    };
    Game.prototype.init = function () {
        this._system.setupMobileApproach(false);
    };
    return Game;
}(BaseGame_1.BaseGame));
exports.Game = Game;


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var System_1 = __webpack_require__(52);
var DeviceType_1 = __webpack_require__(106);
var DI_1 = __webpack_require__(51);
var config_1 = __webpack_require__(484);
var BaseGame = /** @class */ (function () {
    function BaseGame(name, onStartGame, getBaseUrlPath, majorPerformanceCaveat) {
        if (getBaseUrlPath === void 0) { getBaseUrlPath = null; }
        if (majorPerformanceCaveat === void 0) { majorPerformanceCaveat = 1; }
        this._name = name;
        this._onStartGame = onStartGame;
        this._system = this.createSystem(getBaseUrlPath, majorPerformanceCaveat);
        this.init();
    }
    BaseGame.prototype.createSystem = function (getBaseUrlPath, majorPerformanceCaveat) {
        return new System_1.System(this.initViewport.bind(this), this.onReady.bind(this), getBaseUrlPath, majorPerformanceCaveat);
    };
    BaseGame.prototype.init = function () {
        //
    };
    BaseGame.prototype.initViewport = function (device, viewportRect) {
        if (device.type === DeviceType_1.DeviceType.DESKTOP) {
            viewportRect.width = config_1.DESKTOP_VIEWPORT.width;
            viewportRect.height = config_1.DESKTOP_VIEWPORT.height;
        }
        if (device.type === DeviceType_1.DeviceType.MOBILE) {
            viewportRect.width = config_1.MOBILE_VIEWPORT.width;
            viewportRect.height = config_1.MOBILE_VIEWPORT.height;
        }
    };
    BaseGame.prototype.disableContextMenu = function (canvas) {
        // const canvas = document.getElementsByTagName('canvas')[0];
        canvas.addEventListener('contextmenu', function (event) { return event.preventDefault(); });
    };
    BaseGame.prototype.onReady = function () {
        var gameContainer = new PIXI.Container();
        this._system.app.stage.addChild(gameContainer);
        this._system.container.bind(DI_1.default.PixiStageContainer).toConstantValue(gameContainer);
        this._onStartGame();
        try {
            var canvas = document.getElementById('GameCanvas');
            this.disableContextMenu(canvas);
        }
        catch (error) {
            // console.error(`Could not disable contextmenu.`);
        }
        // new DebugStats();
    };
    Object.defineProperty(BaseGame.prototype, "name", {
        get: function () {
            return this._name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseGame.prototype, "system", {
        get: function () {
            return this._system;
        },
        enumerable: true,
        configurable: true
    });
    return BaseGame;
}());
exports.BaseGame = BaseGame;


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var binding_1 = __webpack_require__(445);
var ERROR_MSGS = __webpack_require__(27);
var literal_types_1 = __webpack_require__(47);
var METADATA_KEY = __webpack_require__(18);
var metadata_reader_1 = __webpack_require__(223);
var planner_1 = __webpack_require__(446);
var resolver_1 = __webpack_require__(453);
var binding_to_syntax_1 = __webpack_require__(455);
var guid_1 = __webpack_require__(61);
var serialization_1 = __webpack_require__(89);
var container_snapshot_1 = __webpack_require__(458);
var lookup_1 = __webpack_require__(459);
var Container = (function () {
    function Container(containerOptions) {
        var options = containerOptions || {};
        if (typeof options !== "object") {
            throw new Error("" + ERROR_MSGS.CONTAINER_OPTIONS_MUST_BE_AN_OBJECT);
        }
        if (options.defaultScope === undefined) {
            options.defaultScope = literal_types_1.BindingScopeEnum.Transient;
        }
        else if (options.defaultScope !== literal_types_1.BindingScopeEnum.Singleton &&
            options.defaultScope !== literal_types_1.BindingScopeEnum.Transient &&
            options.defaultScope !== literal_types_1.BindingScopeEnum.Request) {
            throw new Error("" + ERROR_MSGS.CONTAINER_OPTIONS_INVALID_DEFAULT_SCOPE);
        }
        if (options.autoBindInjectable === undefined) {
            options.autoBindInjectable = false;
        }
        else if (typeof options.autoBindInjectable !== "boolean") {
            throw new Error("" + ERROR_MSGS.CONTAINER_OPTIONS_INVALID_AUTO_BIND_INJECTABLE);
        }
        if (options.skipBaseClassChecks === undefined) {
            options.skipBaseClassChecks = false;
        }
        else if (typeof options.skipBaseClassChecks !== "boolean") {
            throw new Error("" + ERROR_MSGS.CONTAINER_OPTIONS_INVALID_SKIP_BASE_CHECK);
        }
        this.options = {
            autoBindInjectable: options.autoBindInjectable,
            defaultScope: options.defaultScope,
            skipBaseClassChecks: options.skipBaseClassChecks
        };
        this.guid = guid_1.guid();
        this._bindingDictionary = new lookup_1.Lookup();
        this._snapshots = [];
        this._middleware = null;
        this.parent = null;
        this._metadataReader = new metadata_reader_1.MetadataReader();
    }
    Container.merge = function (container1, container2) {
        var container = new Container();
        var bindingDictionary = planner_1.getBindingDictionary(container);
        var bindingDictionary1 = planner_1.getBindingDictionary(container1);
        var bindingDictionary2 = planner_1.getBindingDictionary(container2);
        function copyDictionary(origin, destination) {
            origin.traverse(function (key, value) {
                value.forEach(function (binding) {
                    destination.add(binding.serviceIdentifier, binding.clone());
                });
            });
        }
        copyDictionary(bindingDictionary1, bindingDictionary);
        copyDictionary(bindingDictionary2, bindingDictionary);
        return container;
    };
    Container.prototype.load = function () {
        var modules = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            modules[_i] = arguments[_i];
        }
        var getHelpers = this._getContainerModuleHelpersFactory();
        for (var _a = 0, modules_1 = modules; _a < modules_1.length; _a++) {
            var currentModule = modules_1[_a];
            var containerModuleHelpers = getHelpers(currentModule.guid);
            currentModule.registry(containerModuleHelpers.bindFunction, containerModuleHelpers.unbindFunction, containerModuleHelpers.isboundFunction, containerModuleHelpers.rebindFunction);
        }
    };
    Container.prototype.loadAsync = function () {
        var modules = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            modules[_i] = arguments[_i];
        }
        return __awaiter(this, void 0, void 0, function () {
            var getHelpers, _a, modules_2, currentModule, containerModuleHelpers;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        getHelpers = this._getContainerModuleHelpersFactory();
                        _a = 0, modules_2 = modules;
                        _b.label = 1;
                    case 1:
                        if (!(_a < modules_2.length)) return [3, 4];
                        currentModule = modules_2[_a];
                        containerModuleHelpers = getHelpers(currentModule.guid);
                        return [4, currentModule.registry(containerModuleHelpers.bindFunction, containerModuleHelpers.unbindFunction, containerModuleHelpers.isboundFunction, containerModuleHelpers.rebindFunction)];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        _a++;
                        return [3, 1];
                    case 4: return [2];
                }
            });
        });
    };
    Container.prototype.unload = function () {
        var _this = this;
        var modules = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            modules[_i] = arguments[_i];
        }
        var conditionFactory = function (expected) { return function (item) {
            return item.moduleId === expected;
        }; };
        modules.forEach(function (module) {
            var condition = conditionFactory(module.guid);
            _this._bindingDictionary.removeByCondition(condition);
        });
    };
    Container.prototype.bind = function (serviceIdentifier) {
        var scope = this.options.defaultScope || literal_types_1.BindingScopeEnum.Transient;
        var binding = new binding_1.Binding(serviceIdentifier, scope);
        this._bindingDictionary.add(serviceIdentifier, binding);
        return new binding_to_syntax_1.BindingToSyntax(binding);
    };
    Container.prototype.rebind = function (serviceIdentifier) {
        this.unbind(serviceIdentifier);
        return this.bind(serviceIdentifier);
    };
    Container.prototype.unbind = function (serviceIdentifier) {
        try {
            this._bindingDictionary.remove(serviceIdentifier);
        }
        catch (e) {
            throw new Error(ERROR_MSGS.CANNOT_UNBIND + " " + serialization_1.getServiceIdentifierAsString(serviceIdentifier));
        }
    };
    Container.prototype.unbindAll = function () {
        this._bindingDictionary = new lookup_1.Lookup();
    };
    Container.prototype.isBound = function (serviceIdentifier) {
        var bound = this._bindingDictionary.hasKey(serviceIdentifier);
        if (!bound && this.parent) {
            bound = this.parent.isBound(serviceIdentifier);
        }
        return bound;
    };
    Container.prototype.isBoundNamed = function (serviceIdentifier, named) {
        return this.isBoundTagged(serviceIdentifier, METADATA_KEY.NAMED_TAG, named);
    };
    Container.prototype.isBoundTagged = function (serviceIdentifier, key, value) {
        var bound = false;
        if (this._bindingDictionary.hasKey(serviceIdentifier)) {
            var bindings = this._bindingDictionary.get(serviceIdentifier);
            var request_1 = planner_1.createMockRequest(this, serviceIdentifier, key, value);
            bound = bindings.some(function (b) { return b.constraint(request_1); });
        }
        if (!bound && this.parent) {
            bound = this.parent.isBoundTagged(serviceIdentifier, key, value);
        }
        return bound;
    };
    Container.prototype.snapshot = function () {
        this._snapshots.push(container_snapshot_1.ContainerSnapshot.of(this._bindingDictionary.clone(), this._middleware));
    };
    Container.prototype.restore = function () {
        var snapshot = this._snapshots.pop();
        if (snapshot === undefined) {
            throw new Error(ERROR_MSGS.NO_MORE_SNAPSHOTS_AVAILABLE);
        }
        this._bindingDictionary = snapshot.bindings;
        this._middleware = snapshot.middleware;
    };
    Container.prototype.createChild = function (containerOptions) {
        var child = new Container(containerOptions);
        child.parent = this;
        return child;
    };
    Container.prototype.applyMiddleware = function () {
        var middlewares = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            middlewares[_i] = arguments[_i];
        }
        var initial = (this._middleware) ? this._middleware : this._planAndResolve();
        this._middleware = middlewares.reduce(function (prev, curr) { return curr(prev); }, initial);
    };
    Container.prototype.applyCustomMetadataReader = function (metadataReader) {
        this._metadataReader = metadataReader;
    };
    Container.prototype.get = function (serviceIdentifier) {
        return this._get(false, false, literal_types_1.TargetTypeEnum.Variable, serviceIdentifier);
    };
    Container.prototype.getTagged = function (serviceIdentifier, key, value) {
        return this._get(false, false, literal_types_1.TargetTypeEnum.Variable, serviceIdentifier, key, value);
    };
    Container.prototype.getNamed = function (serviceIdentifier, named) {
        return this.getTagged(serviceIdentifier, METADATA_KEY.NAMED_TAG, named);
    };
    Container.prototype.getAll = function (serviceIdentifier) {
        return this._get(true, true, literal_types_1.TargetTypeEnum.Variable, serviceIdentifier);
    };
    Container.prototype.getAllTagged = function (serviceIdentifier, key, value) {
        return this._get(false, true, literal_types_1.TargetTypeEnum.Variable, serviceIdentifier, key, value);
    };
    Container.prototype.getAllNamed = function (serviceIdentifier, named) {
        return this.getAllTagged(serviceIdentifier, METADATA_KEY.NAMED_TAG, named);
    };
    Container.prototype.resolve = function (constructorFunction) {
        var tempContainer = new Container();
        tempContainer.bind(constructorFunction).toSelf();
        tempContainer.parent = this;
        return tempContainer.get(constructorFunction);
    };
    Container.prototype._getContainerModuleHelpersFactory = function () {
        var _this = this;
        var setModuleId = function (bindingToSyntax, moduleId) {
            bindingToSyntax._binding.moduleId = moduleId;
        };
        var getBindFunction = function (moduleId) {
            return function (serviceIdentifier) {
                var _bind = _this.bind.bind(_this);
                var bindingToSyntax = _bind(serviceIdentifier);
                setModuleId(bindingToSyntax, moduleId);
                return bindingToSyntax;
            };
        };
        var getUnbindFunction = function (moduleId) {
            return function (serviceIdentifier) {
                var _unbind = _this.unbind.bind(_this);
                _unbind(serviceIdentifier);
            };
        };
        var getIsboundFunction = function (moduleId) {
            return function (serviceIdentifier) {
                var _isBound = _this.isBound.bind(_this);
                return _isBound(serviceIdentifier);
            };
        };
        var getRebindFunction = function (moduleId) {
            return function (serviceIdentifier) {
                var _rebind = _this.rebind.bind(_this);
                var bindingToSyntax = _rebind(serviceIdentifier);
                setModuleId(bindingToSyntax, moduleId);
                return bindingToSyntax;
            };
        };
        return function (mId) { return ({
            bindFunction: getBindFunction(mId),
            isboundFunction: getIsboundFunction(mId),
            rebindFunction: getRebindFunction(mId),
            unbindFunction: getUnbindFunction(mId)
        }); };
    };
    Container.prototype._get = function (avoidConstraints, isMultiInject, targetType, serviceIdentifier, key, value) {
        var result = null;
        var defaultArgs = {
            avoidConstraints: avoidConstraints,
            contextInterceptor: function (context) { return context; },
            isMultiInject: isMultiInject,
            key: key,
            serviceIdentifier: serviceIdentifier,
            targetType: targetType,
            value: value
        };
        if (this._middleware) {
            result = this._middleware(defaultArgs);
            if (result === undefined || result === null) {
                throw new Error(ERROR_MSGS.INVALID_MIDDLEWARE_RETURN);
            }
        }
        else {
            result = this._planAndResolve()(defaultArgs);
        }
        return result;
    };
    Container.prototype._planAndResolve = function () {
        var _this = this;
        return function (args) {
            var context = planner_1.plan(_this._metadataReader, _this, args.isMultiInject, args.targetType, args.serviceIdentifier, args.key, args.value, args.avoidConstraints);
            context = args.contextInterceptor(context);
            var result = resolver_1.resolve(context);
            return result;
        };
    };
    return Container;
}());
exports.Container = Container;


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var literal_types_1 = __webpack_require__(47);
var guid_1 = __webpack_require__(61);
var Binding = (function () {
    function Binding(serviceIdentifier, scope) {
        this.guid = guid_1.guid();
        this.activated = false;
        this.serviceIdentifier = serviceIdentifier;
        this.scope = scope;
        this.type = literal_types_1.BindingTypeEnum.Invalid;
        this.constraint = function (request) { return true; };
        this.implementationType = null;
        this.cache = null;
        this.factory = null;
        this.provider = null;
        this.onActivation = null;
        this.dynamicValue = null;
    }
    Binding.prototype.clone = function () {
        var clone = new Binding(this.serviceIdentifier, this.scope);
        clone.activated = false;
        clone.implementationType = this.implementationType;
        clone.dynamicValue = this.dynamicValue;
        clone.scope = this.scope;
        clone.type = this.type;
        clone.factory = this.factory;
        clone.provider = this.provider;
        clone.constraint = this.constraint;
        clone.onActivation = this.onActivation;
        clone.cache = this.cache;
        return clone;
    };
    return Binding;
}());
exports.Binding = Binding;


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var binding_count_1 = __webpack_require__(447);
var ERROR_MSGS = __webpack_require__(27);
var literal_types_1 = __webpack_require__(47);
var METADATA_KEY = __webpack_require__(18);
var exceptions_1 = __webpack_require__(224);
var serialization_1 = __webpack_require__(89);
var context_1 = __webpack_require__(448);
var metadata_1 = __webpack_require__(36);
var plan_1 = __webpack_require__(449);
var reflection_utils_1 = __webpack_require__(450);
var request_1 = __webpack_require__(452);
var target_1 = __webpack_require__(226);
function getBindingDictionary(cntnr) {
    return cntnr._bindingDictionary;
}
exports.getBindingDictionary = getBindingDictionary;
function _createTarget(isMultiInject, targetType, serviceIdentifier, name, key, value) {
    var metadataKey = isMultiInject ? METADATA_KEY.MULTI_INJECT_TAG : METADATA_KEY.INJECT_TAG;
    var injectMetadata = new metadata_1.Metadata(metadataKey, serviceIdentifier);
    var target = new target_1.Target(targetType, name, serviceIdentifier, injectMetadata);
    if (key !== undefined) {
        var tagMetadata = new metadata_1.Metadata(key, value);
        target.metadata.push(tagMetadata);
    }
    return target;
}
function _getActiveBindings(metadataReader, avoidConstraints, context, parentRequest, target) {
    var bindings = getBindings(context.container, target.serviceIdentifier);
    var activeBindings = [];
    if (bindings.length === binding_count_1.BindingCount.NoBindingsAvailable &&
        context.container.options.autoBindInjectable &&
        typeof target.serviceIdentifier === "function" &&
        metadataReader.getConstructorMetadata(target.serviceIdentifier).compilerGeneratedMetadata) {
        context.container.bind(target.serviceIdentifier).toSelf();
        bindings = getBindings(context.container, target.serviceIdentifier);
    }
    if (!avoidConstraints) {
        activeBindings = bindings.filter(function (binding) {
            var request = new request_1.Request(binding.serviceIdentifier, context, parentRequest, binding, target);
            return binding.constraint(request);
        });
    }
    else {
        activeBindings = bindings;
    }
    _validateActiveBindingCount(target.serviceIdentifier, activeBindings, target, context.container);
    return activeBindings;
}
function _validateActiveBindingCount(serviceIdentifier, bindings, target, container) {
    switch (bindings.length) {
        case binding_count_1.BindingCount.NoBindingsAvailable:
            if (target.isOptional()) {
                return bindings;
            }
            else {
                var serviceIdentifierString = serialization_1.getServiceIdentifierAsString(serviceIdentifier);
                var msg = ERROR_MSGS.NOT_REGISTERED;
                msg += serialization_1.listMetadataForTarget(serviceIdentifierString, target);
                msg += serialization_1.listRegisteredBindingsForServiceIdentifier(container, serviceIdentifierString, getBindings);
                throw new Error(msg);
            }
        case binding_count_1.BindingCount.OnlyOneBindingAvailable:
            if (!target.isArray()) {
                return bindings;
            }
        case binding_count_1.BindingCount.MultipleBindingsAvailable:
        default:
            if (!target.isArray()) {
                var serviceIdentifierString = serialization_1.getServiceIdentifierAsString(serviceIdentifier);
                var msg = ERROR_MSGS.AMBIGUOUS_MATCH + " " + serviceIdentifierString;
                msg += serialization_1.listRegisteredBindingsForServiceIdentifier(container, serviceIdentifierString, getBindings);
                throw new Error(msg);
            }
            else {
                return bindings;
            }
    }
}
function _createSubRequests(metadataReader, avoidConstraints, serviceIdentifier, context, parentRequest, target) {
    var activeBindings;
    var childRequest;
    if (parentRequest === null) {
        activeBindings = _getActiveBindings(metadataReader, avoidConstraints, context, null, target);
        childRequest = new request_1.Request(serviceIdentifier, context, null, activeBindings, target);
        var thePlan = new plan_1.Plan(context, childRequest);
        context.addPlan(thePlan);
    }
    else {
        activeBindings = _getActiveBindings(metadataReader, avoidConstraints, context, parentRequest, target);
        childRequest = parentRequest.addChildRequest(target.serviceIdentifier, activeBindings, target);
    }
    activeBindings.forEach(function (binding) {
        var subChildRequest = null;
        if (target.isArray()) {
            subChildRequest = childRequest.addChildRequest(binding.serviceIdentifier, binding, target);
        }
        else {
            if (binding.cache) {
                return;
            }
            subChildRequest = childRequest;
        }
        if (binding.type === literal_types_1.BindingTypeEnum.Instance && binding.implementationType !== null) {
            var dependencies = reflection_utils_1.getDependencies(metadataReader, binding.implementationType);
            if (!context.container.options.skipBaseClassChecks) {
                var baseClassDependencyCount = reflection_utils_1.getBaseClassDependencyCount(metadataReader, binding.implementationType);
                if (dependencies.length < baseClassDependencyCount) {
                    var error = ERROR_MSGS.ARGUMENTS_LENGTH_MISMATCH(reflection_utils_1.getFunctionName(binding.implementationType));
                    throw new Error(error);
                }
            }
            dependencies.forEach(function (dependency) {
                _createSubRequests(metadataReader, false, dependency.serviceIdentifier, context, subChildRequest, dependency);
            });
        }
    });
}
function getBindings(container, serviceIdentifier) {
    var bindings = [];
    var bindingDictionary = getBindingDictionary(container);
    if (bindingDictionary.hasKey(serviceIdentifier)) {
        bindings = bindingDictionary.get(serviceIdentifier);
    }
    else if (container.parent !== null) {
        bindings = getBindings(container.parent, serviceIdentifier);
    }
    return bindings;
}
function plan(metadataReader, container, isMultiInject, targetType, serviceIdentifier, key, value, avoidConstraints) {
    if (avoidConstraints === void 0) { avoidConstraints = false; }
    var context = new context_1.Context(container);
    var target = _createTarget(isMultiInject, targetType, serviceIdentifier, "", key, value);
    try {
        _createSubRequests(metadataReader, avoidConstraints, serviceIdentifier, context, null, target);
        return context;
    }
    catch (error) {
        if (exceptions_1.isStackOverflowExeption(error)) {
            if (context.plan) {
                serialization_1.circularDependencyToException(context.plan.rootRequest);
            }
        }
        throw error;
    }
}
exports.plan = plan;
function createMockRequest(container, serviceIdentifier, key, value) {
    var target = new target_1.Target(literal_types_1.TargetTypeEnum.Variable, "", serviceIdentifier, new metadata_1.Metadata(key, value));
    var context = new context_1.Context(container);
    var request = new request_1.Request(serviceIdentifier, context, null, [], target);
    return request;
}
exports.createMockRequest = createMockRequest;


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var BindingCount = {
    MultipleBindingsAvailable: 2,
    NoBindingsAvailable: 0,
    OnlyOneBindingAvailable: 1
};
exports.BindingCount = BindingCount;


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var guid_1 = __webpack_require__(61);
var Context = (function () {
    function Context(container) {
        this.guid = guid_1.guid();
        this.container = container;
    }
    Context.prototype.addPlan = function (plan) {
        this.plan = plan;
    };
    Context.prototype.setCurrentRequest = function (currentRequest) {
        this.currentRequest = currentRequest;
    };
    return Context;
}());
exports.Context = Context;


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Plan = (function () {
    function Plan(parentContext, rootRequest) {
        this.parentContext = parentContext;
        this.rootRequest = rootRequest;
    }
    return Plan;
}());
exports.Plan = Plan;


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var inject_1 = __webpack_require__(225);
var ERROR_MSGS = __webpack_require__(27);
var literal_types_1 = __webpack_require__(47);
var METADATA_KEY = __webpack_require__(18);
var serialization_1 = __webpack_require__(89);
exports.getFunctionName = serialization_1.getFunctionName;
var target_1 = __webpack_require__(226);
function getDependencies(metadataReader, func) {
    var constructorName = serialization_1.getFunctionName(func);
    var targets = getTargets(metadataReader, constructorName, func, false);
    return targets;
}
exports.getDependencies = getDependencies;
function getTargets(metadataReader, constructorName, func, isBaseClass) {
    var metadata = metadataReader.getConstructorMetadata(func);
    var serviceIdentifiers = metadata.compilerGeneratedMetadata;
    if (serviceIdentifiers === undefined) {
        var msg = ERROR_MSGS.MISSING_INJECTABLE_ANNOTATION + " " + constructorName + ".";
        throw new Error(msg);
    }
    var constructorArgsMetadata = metadata.userGeneratedMetadata;
    var keys = Object.keys(constructorArgsMetadata);
    var hasUserDeclaredUnknownInjections = (func.length === 0 && keys.length > 0);
    var iterations = (hasUserDeclaredUnknownInjections) ? keys.length : func.length;
    var constructorTargets = getConstructorArgsAsTargets(isBaseClass, constructorName, serviceIdentifiers, constructorArgsMetadata, iterations);
    var propertyTargets = getClassPropsAsTargets(metadataReader, func);
    var targets = constructorTargets.concat(propertyTargets);
    return targets;
}
function getConstructorArgsAsTarget(index, isBaseClass, constructorName, serviceIdentifiers, constructorArgsMetadata) {
    var targetMetadata = constructorArgsMetadata[index.toString()] || [];
    var metadata = formatTargetMetadata(targetMetadata);
    var isManaged = metadata.unmanaged !== true;
    var serviceIdentifier = serviceIdentifiers[index];
    var injectIdentifier = (metadata.inject || metadata.multiInject);
    serviceIdentifier = (injectIdentifier) ? (injectIdentifier) : serviceIdentifier;
    if (serviceIdentifier instanceof inject_1.LazyServiceIdentifer) {
        serviceIdentifier = serviceIdentifier.unwrap();
    }
    if (isManaged) {
        var isObject = serviceIdentifier === Object;
        var isFunction = serviceIdentifier === Function;
        var isUndefined = serviceIdentifier === undefined;
        var isUnknownType = (isObject || isFunction || isUndefined);
        if (!isBaseClass && isUnknownType) {
            var msg = ERROR_MSGS.MISSING_INJECT_ANNOTATION + " argument " + index + " in class " + constructorName + ".";
            throw new Error(msg);
        }
        var target = new target_1.Target(literal_types_1.TargetTypeEnum.ConstructorArgument, metadata.targetName, serviceIdentifier);
        target.metadata = targetMetadata;
        return target;
    }
    return null;
}
function getConstructorArgsAsTargets(isBaseClass, constructorName, serviceIdentifiers, constructorArgsMetadata, iterations) {
    var targets = [];
    for (var i = 0; i < iterations; i++) {
        var index = i;
        var target = getConstructorArgsAsTarget(index, isBaseClass, constructorName, serviceIdentifiers, constructorArgsMetadata);
        if (target !== null) {
            targets.push(target);
        }
    }
    return targets;
}
function getClassPropsAsTargets(metadataReader, constructorFunc) {
    var classPropsMetadata = metadataReader.getPropertiesMetadata(constructorFunc);
    var targets = [];
    var keys = Object.keys(classPropsMetadata);
    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
        var key = keys_1[_i];
        var targetMetadata = classPropsMetadata[key];
        var metadata = formatTargetMetadata(classPropsMetadata[key]);
        var targetName = metadata.targetName || key;
        var serviceIdentifier = (metadata.inject || metadata.multiInject);
        var target = new target_1.Target(literal_types_1.TargetTypeEnum.ClassProperty, targetName, serviceIdentifier);
        target.metadata = targetMetadata;
        targets.push(target);
    }
    var baseConstructor = Object.getPrototypeOf(constructorFunc.prototype).constructor;
    if (baseConstructor !== Object) {
        var baseTargets = getClassPropsAsTargets(metadataReader, baseConstructor);
        targets = targets.concat(baseTargets);
    }
    return targets;
}
function getBaseClassDependencyCount(metadataReader, func) {
    var baseConstructor = Object.getPrototypeOf(func.prototype).constructor;
    if (baseConstructor !== Object) {
        var baseConstructorName = serialization_1.getFunctionName(baseConstructor);
        var targets = getTargets(metadataReader, baseConstructorName, baseConstructor, true);
        var metadata = targets.map(function (t) {
            return t.metadata.filter(function (m) {
                return m.key === METADATA_KEY.UNMANAGED_TAG;
            });
        });
        var unmanagedCount = [].concat.apply([], metadata).length;
        var dependencyCount = targets.length - unmanagedCount;
        if (dependencyCount > 0) {
            return dependencyCount;
        }
        else {
            return getBaseClassDependencyCount(metadataReader, baseConstructor);
        }
    }
    else {
        return 0;
    }
}
exports.getBaseClassDependencyCount = getBaseClassDependencyCount;
function formatTargetMetadata(targetMetadata) {
    var targetMetadataMap = {};
    targetMetadata.forEach(function (m) {
        targetMetadataMap[m.key.toString()] = m.value;
    });
    return {
        inject: targetMetadataMap[METADATA_KEY.INJECT_TAG],
        multiInject: targetMetadataMap[METADATA_KEY.MULTI_INJECT_TAG],
        targetName: targetMetadataMap[METADATA_KEY.NAME_TAG],
        unmanaged: targetMetadataMap[METADATA_KEY.UNMANAGED_TAG]
    };
}


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var QueryableString = (function () {
    function QueryableString(str) {
        this.str = str;
    }
    QueryableString.prototype.startsWith = function (searchString) {
        return this.str.indexOf(searchString) === 0;
    };
    QueryableString.prototype.endsWith = function (searchString) {
        var reverseString = "";
        var reverseSearchString = searchString.split("").reverse().join("");
        reverseString = this.str.split("").reverse().join("");
        return this.startsWith.call({ str: reverseString }, reverseSearchString);
    };
    QueryableString.prototype.contains = function (searchString) {
        return (this.str.indexOf(searchString) !== -1);
    };
    QueryableString.prototype.equals = function (compareString) {
        return this.str === compareString;
    };
    QueryableString.prototype.value = function () {
        return this.str;
    };
    return QueryableString;
}());
exports.QueryableString = QueryableString;


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var guid_1 = __webpack_require__(61);
var Request = (function () {
    function Request(serviceIdentifier, parentContext, parentRequest, bindings, target) {
        this.guid = guid_1.guid();
        this.serviceIdentifier = serviceIdentifier;
        this.parentContext = parentContext;
        this.parentRequest = parentRequest;
        this.target = target;
        this.childRequests = [];
        this.bindings = (Array.isArray(bindings) ? bindings : [bindings]);
        this.requestScope = parentRequest === null
            ? new Map()
            : null;
    }
    Request.prototype.addChildRequest = function (serviceIdentifier, bindings, target) {
        var child = new Request(serviceIdentifier, this.parentContext, this, bindings, target);
        this.childRequests.push(child);
        return child;
    };
    return Request;
}());
exports.Request = Request;


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ERROR_MSGS = __webpack_require__(27);
var literal_types_1 = __webpack_require__(47);
var exceptions_1 = __webpack_require__(224);
var serialization_1 = __webpack_require__(89);
var instantiation_1 = __webpack_require__(454);
var invokeFactory = function (factoryType, serviceIdentifier, fn) {
    try {
        return fn();
    }
    catch (error) {
        if (exceptions_1.isStackOverflowExeption(error)) {
            throw new Error(ERROR_MSGS.CIRCULAR_DEPENDENCY_IN_FACTORY(factoryType, serviceIdentifier.toString()));
        }
        else {
            throw error;
        }
    }
};
var _resolveRequest = function (requestScope) {
    return function (request) {
        request.parentContext.setCurrentRequest(request);
        var bindings = request.bindings;
        var childRequests = request.childRequests;
        var targetIsAnArray = request.target && request.target.isArray();
        var targetParentIsNotAnArray = !request.parentRequest ||
            !request.parentRequest.target ||
            !request.target ||
            !request.parentRequest.target.matchesArray(request.target.serviceIdentifier);
        if (targetIsAnArray && targetParentIsNotAnArray) {
            return childRequests.map(function (childRequest) {
                var _f = _resolveRequest(requestScope);
                return _f(childRequest);
            });
        }
        else {
            var result = null;
            if (request.target.isOptional() && bindings.length === 0) {
                return undefined;
            }
            var binding_1 = bindings[0];
            var isSingleton = binding_1.scope === literal_types_1.BindingScopeEnum.Singleton;
            var isRequestSingleton = binding_1.scope === literal_types_1.BindingScopeEnum.Request;
            if (isSingleton && binding_1.activated) {
                return binding_1.cache;
            }
            if (isRequestSingleton &&
                requestScope !== null &&
                requestScope.has(binding_1.guid)) {
                return requestScope.get(binding_1.guid);
            }
            if (binding_1.type === literal_types_1.BindingTypeEnum.ConstantValue) {
                result = binding_1.cache;
            }
            else if (binding_1.type === literal_types_1.BindingTypeEnum.Function) {
                result = binding_1.cache;
            }
            else if (binding_1.type === literal_types_1.BindingTypeEnum.Constructor) {
                result = binding_1.implementationType;
            }
            else if (binding_1.type === literal_types_1.BindingTypeEnum.DynamicValue && binding_1.dynamicValue !== null) {
                result = invokeFactory("toDynamicValue", binding_1.serviceIdentifier, function () { return binding_1.dynamicValue(request.parentContext); });
            }
            else if (binding_1.type === literal_types_1.BindingTypeEnum.Factory && binding_1.factory !== null) {
                result = invokeFactory("toFactory", binding_1.serviceIdentifier, function () { return binding_1.factory(request.parentContext); });
            }
            else if (binding_1.type === literal_types_1.BindingTypeEnum.Provider && binding_1.provider !== null) {
                result = invokeFactory("toProvider", binding_1.serviceIdentifier, function () { return binding_1.provider(request.parentContext); });
            }
            else if (binding_1.type === literal_types_1.BindingTypeEnum.Instance && binding_1.implementationType !== null) {
                result = instantiation_1.resolveInstance(binding_1.implementationType, childRequests, _resolveRequest(requestScope));
            }
            else {
                var serviceIdentifier = serialization_1.getServiceIdentifierAsString(request.serviceIdentifier);
                throw new Error(ERROR_MSGS.INVALID_BINDING_TYPE + " " + serviceIdentifier);
            }
            if (typeof binding_1.onActivation === "function") {
                result = binding_1.onActivation(request.parentContext, result);
            }
            if (isSingleton) {
                binding_1.cache = result;
                binding_1.activated = true;
            }
            if (isRequestSingleton &&
                requestScope !== null &&
                !requestScope.has(binding_1.guid)) {
                requestScope.set(binding_1.guid, result);
            }
            return result;
        }
    };
};
function resolve(context) {
    var _f = _resolveRequest(context.plan.rootRequest.requestScope);
    return _f(context.plan.rootRequest);
}
exports.resolve = resolve;


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var error_msgs_1 = __webpack_require__(27);
var literal_types_1 = __webpack_require__(47);
var METADATA_KEY = __webpack_require__(18);
function _injectProperties(instance, childRequests, resolveRequest) {
    var propertyInjectionsRequests = childRequests.filter(function (childRequest) {
        return (childRequest.target !== null &&
            childRequest.target.type === literal_types_1.TargetTypeEnum.ClassProperty);
    });
    var propertyInjections = propertyInjectionsRequests.map(resolveRequest);
    propertyInjectionsRequests.forEach(function (r, index) {
        var propertyName = "";
        propertyName = r.target.name.value();
        var injection = propertyInjections[index];
        instance[propertyName] = injection;
    });
    return instance;
}
function _createInstance(Func, injections) {
    return new (Func.bind.apply(Func, [void 0].concat(injections)))();
}
function _postConstruct(constr, result) {
    if (Reflect.hasMetadata(METADATA_KEY.POST_CONSTRUCT, constr)) {
        var data = Reflect.getMetadata(METADATA_KEY.POST_CONSTRUCT, constr);
        try {
            result[data.value]();
        }
        catch (e) {
            throw new Error(error_msgs_1.POST_CONSTRUCT_ERROR(constr.name, e.message));
        }
    }
}
function resolveInstance(constr, childRequests, resolveRequest) {
    var result = null;
    if (childRequests.length > 0) {
        var constructorInjectionsRequests = childRequests.filter(function (childRequest) {
            return (childRequest.target !== null && childRequest.target.type === literal_types_1.TargetTypeEnum.ConstructorArgument);
        });
        var constructorInjections = constructorInjectionsRequests.map(resolveRequest);
        result = _createInstance(constr, constructorInjections);
        result = _injectProperties(result, childRequests, resolveRequest);
    }
    else {
        result = new constr();
    }
    _postConstruct(constr, result);
    return result;
}
exports.resolveInstance = resolveInstance;


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ERROR_MSGS = __webpack_require__(27);
var literal_types_1 = __webpack_require__(47);
var binding_in_when_on_syntax_1 = __webpack_require__(456);
var binding_when_on_syntax_1 = __webpack_require__(227);
var BindingToSyntax = (function () {
    function BindingToSyntax(binding) {
        this._binding = binding;
    }
    BindingToSyntax.prototype.to = function (constructor) {
        this._binding.type = literal_types_1.BindingTypeEnum.Instance;
        this._binding.implementationType = constructor;
        return new binding_in_when_on_syntax_1.BindingInWhenOnSyntax(this._binding);
    };
    BindingToSyntax.prototype.toSelf = function () {
        if (typeof this._binding.serviceIdentifier !== "function") {
            throw new Error("" + ERROR_MSGS.INVALID_TO_SELF_VALUE);
        }
        var self = this._binding.serviceIdentifier;
        return this.to(self);
    };
    BindingToSyntax.prototype.toConstantValue = function (value) {
        this._binding.type = literal_types_1.BindingTypeEnum.ConstantValue;
        this._binding.cache = value;
        this._binding.dynamicValue = null;
        this._binding.implementationType = null;
        return new binding_when_on_syntax_1.BindingWhenOnSyntax(this._binding);
    };
    BindingToSyntax.prototype.toDynamicValue = function (func) {
        this._binding.type = literal_types_1.BindingTypeEnum.DynamicValue;
        this._binding.cache = null;
        this._binding.dynamicValue = func;
        this._binding.implementationType = null;
        return new binding_in_when_on_syntax_1.BindingInWhenOnSyntax(this._binding);
    };
    BindingToSyntax.prototype.toConstructor = function (constructor) {
        this._binding.type = literal_types_1.BindingTypeEnum.Constructor;
        this._binding.implementationType = constructor;
        return new binding_when_on_syntax_1.BindingWhenOnSyntax(this._binding);
    };
    BindingToSyntax.prototype.toFactory = function (factory) {
        this._binding.type = literal_types_1.BindingTypeEnum.Factory;
        this._binding.factory = factory;
        return new binding_when_on_syntax_1.BindingWhenOnSyntax(this._binding);
    };
    BindingToSyntax.prototype.toFunction = function (func) {
        if (typeof func !== "function") {
            throw new Error(ERROR_MSGS.INVALID_FUNCTION_BINDING);
        }
        var bindingWhenOnSyntax = this.toConstantValue(func);
        this._binding.type = literal_types_1.BindingTypeEnum.Function;
        return bindingWhenOnSyntax;
    };
    BindingToSyntax.prototype.toAutoFactory = function (serviceIdentifier) {
        this._binding.type = literal_types_1.BindingTypeEnum.Factory;
        this._binding.factory = function (context) {
            var autofactory = function () { return context.container.get(serviceIdentifier); };
            return autofactory;
        };
        return new binding_when_on_syntax_1.BindingWhenOnSyntax(this._binding);
    };
    BindingToSyntax.prototype.toProvider = function (provider) {
        this._binding.type = literal_types_1.BindingTypeEnum.Provider;
        this._binding.provider = provider;
        return new binding_when_on_syntax_1.BindingWhenOnSyntax(this._binding);
    };
    BindingToSyntax.prototype.toService = function (service) {
        this.toDynamicValue(function (context) { return context.container.get(service); });
    };
    return BindingToSyntax;
}());
exports.BindingToSyntax = BindingToSyntax;


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var binding_in_syntax_1 = __webpack_require__(457);
var binding_on_syntax_1 = __webpack_require__(140);
var binding_when_syntax_1 = __webpack_require__(141);
var BindingInWhenOnSyntax = (function () {
    function BindingInWhenOnSyntax(binding) {
        this._binding = binding;
        this._bindingWhenSyntax = new binding_when_syntax_1.BindingWhenSyntax(this._binding);
        this._bindingOnSyntax = new binding_on_syntax_1.BindingOnSyntax(this._binding);
        this._bindingInSyntax = new binding_in_syntax_1.BindingInSyntax(binding);
    }
    BindingInWhenOnSyntax.prototype.inRequestScope = function () {
        return this._bindingInSyntax.inRequestScope();
    };
    BindingInWhenOnSyntax.prototype.inSingletonScope = function () {
        return this._bindingInSyntax.inSingletonScope();
    };
    BindingInWhenOnSyntax.prototype.inTransientScope = function () {
        return this._bindingInSyntax.inTransientScope();
    };
    BindingInWhenOnSyntax.prototype.when = function (constraint) {
        return this._bindingWhenSyntax.when(constraint);
    };
    BindingInWhenOnSyntax.prototype.whenTargetNamed = function (name) {
        return this._bindingWhenSyntax.whenTargetNamed(name);
    };
    BindingInWhenOnSyntax.prototype.whenTargetIsDefault = function () {
        return this._bindingWhenSyntax.whenTargetIsDefault();
    };
    BindingInWhenOnSyntax.prototype.whenTargetTagged = function (tag, value) {
        return this._bindingWhenSyntax.whenTargetTagged(tag, value);
    };
    BindingInWhenOnSyntax.prototype.whenInjectedInto = function (parent) {
        return this._bindingWhenSyntax.whenInjectedInto(parent);
    };
    BindingInWhenOnSyntax.prototype.whenParentNamed = function (name) {
        return this._bindingWhenSyntax.whenParentNamed(name);
    };
    BindingInWhenOnSyntax.prototype.whenParentTagged = function (tag, value) {
        return this._bindingWhenSyntax.whenParentTagged(tag, value);
    };
    BindingInWhenOnSyntax.prototype.whenAnyAncestorIs = function (ancestor) {
        return this._bindingWhenSyntax.whenAnyAncestorIs(ancestor);
    };
    BindingInWhenOnSyntax.prototype.whenNoAncestorIs = function (ancestor) {
        return this._bindingWhenSyntax.whenNoAncestorIs(ancestor);
    };
    BindingInWhenOnSyntax.prototype.whenAnyAncestorNamed = function (name) {
        return this._bindingWhenSyntax.whenAnyAncestorNamed(name);
    };
    BindingInWhenOnSyntax.prototype.whenAnyAncestorTagged = function (tag, value) {
        return this._bindingWhenSyntax.whenAnyAncestorTagged(tag, value);
    };
    BindingInWhenOnSyntax.prototype.whenNoAncestorNamed = function (name) {
        return this._bindingWhenSyntax.whenNoAncestorNamed(name);
    };
    BindingInWhenOnSyntax.prototype.whenNoAncestorTagged = function (tag, value) {
        return this._bindingWhenSyntax.whenNoAncestorTagged(tag, value);
    };
    BindingInWhenOnSyntax.prototype.whenAnyAncestorMatches = function (constraint) {
        return this._bindingWhenSyntax.whenAnyAncestorMatches(constraint);
    };
    BindingInWhenOnSyntax.prototype.whenNoAncestorMatches = function (constraint) {
        return this._bindingWhenSyntax.whenNoAncestorMatches(constraint);
    };
    BindingInWhenOnSyntax.prototype.onActivation = function (handler) {
        return this._bindingOnSyntax.onActivation(handler);
    };
    return BindingInWhenOnSyntax;
}());
exports.BindingInWhenOnSyntax = BindingInWhenOnSyntax;


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var literal_types_1 = __webpack_require__(47);
var binding_when_on_syntax_1 = __webpack_require__(227);
var BindingInSyntax = (function () {
    function BindingInSyntax(binding) {
        this._binding = binding;
    }
    BindingInSyntax.prototype.inRequestScope = function () {
        this._binding.scope = literal_types_1.BindingScopeEnum.Request;
        return new binding_when_on_syntax_1.BindingWhenOnSyntax(this._binding);
    };
    BindingInSyntax.prototype.inSingletonScope = function () {
        this._binding.scope = literal_types_1.BindingScopeEnum.Singleton;
        return new binding_when_on_syntax_1.BindingWhenOnSyntax(this._binding);
    };
    BindingInSyntax.prototype.inTransientScope = function () {
        this._binding.scope = literal_types_1.BindingScopeEnum.Transient;
        return new binding_when_on_syntax_1.BindingWhenOnSyntax(this._binding);
    };
    return BindingInSyntax;
}());
exports.BindingInSyntax = BindingInSyntax;


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ContainerSnapshot = (function () {
    function ContainerSnapshot() {
    }
    ContainerSnapshot.of = function (bindings, middleware) {
        var snapshot = new ContainerSnapshot();
        snapshot.bindings = bindings;
        snapshot.middleware = middleware;
        return snapshot;
    };
    return ContainerSnapshot;
}());
exports.ContainerSnapshot = ContainerSnapshot;


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ERROR_MSGS = __webpack_require__(27);
var Lookup = (function () {
    function Lookup() {
        this._map = new Map();
    }
    Lookup.prototype.getMap = function () {
        return this._map;
    };
    Lookup.prototype.add = function (serviceIdentifier, value) {
        if (serviceIdentifier === null || serviceIdentifier === undefined) {
            throw new Error(ERROR_MSGS.NULL_ARGUMENT);
        }
        if (value === null || value === undefined) {
            throw new Error(ERROR_MSGS.NULL_ARGUMENT);
        }
        var entry = this._map.get(serviceIdentifier);
        if (entry !== undefined) {
            entry.push(value);
            this._map.set(serviceIdentifier, entry);
        }
        else {
            this._map.set(serviceIdentifier, [value]);
        }
    };
    Lookup.prototype.get = function (serviceIdentifier) {
        if (serviceIdentifier === null || serviceIdentifier === undefined) {
            throw new Error(ERROR_MSGS.NULL_ARGUMENT);
        }
        var entry = this._map.get(serviceIdentifier);
        if (entry !== undefined) {
            return entry;
        }
        else {
            throw new Error(ERROR_MSGS.KEY_NOT_FOUND);
        }
    };
    Lookup.prototype.remove = function (serviceIdentifier) {
        if (serviceIdentifier === null || serviceIdentifier === undefined) {
            throw new Error(ERROR_MSGS.NULL_ARGUMENT);
        }
        if (!this._map.delete(serviceIdentifier)) {
            throw new Error(ERROR_MSGS.KEY_NOT_FOUND);
        }
    };
    Lookup.prototype.removeByCondition = function (condition) {
        var _this = this;
        this._map.forEach(function (entries, key) {
            var updatedEntries = entries.filter(function (entry) { return !condition(entry); });
            if (updatedEntries.length > 0) {
                _this._map.set(key, updatedEntries);
            }
            else {
                _this._map.delete(key);
            }
        });
    };
    Lookup.prototype.hasKey = function (serviceIdentifier) {
        if (serviceIdentifier === null || serviceIdentifier === undefined) {
            throw new Error(ERROR_MSGS.NULL_ARGUMENT);
        }
        return this._map.has(serviceIdentifier);
    };
    Lookup.prototype.clone = function () {
        var copy = new Lookup();
        this._map.forEach(function (value, key) {
            value.forEach(function (b) { return copy.add(key, b.clone()); });
        });
        return copy;
    };
    Lookup.prototype.traverse = function (func) {
        this._map.forEach(function (value, key) {
            func(key, value);
        });
    };
    return Lookup;
}());
exports.Lookup = Lookup;


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var guid_1 = __webpack_require__(61);
var ContainerModule = (function () {
    function ContainerModule(registry) {
        this.guid = guid_1.guid();
        this.registry = registry;
    }
    return ContainerModule;
}());
exports.ContainerModule = ContainerModule;
var AsyncContainerModule = (function () {
    function AsyncContainerModule(registry) {
        this.guid = guid_1.guid();
        this.registry = registry;
    }
    return AsyncContainerModule;
}());
exports.AsyncContainerModule = AsyncContainerModule;


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ERRORS_MSGS = __webpack_require__(27);
var METADATA_KEY = __webpack_require__(18);
function injectable() {
    return function (target) {
        if (Reflect.hasOwnMetadata(METADATA_KEY.PARAM_TYPES, target)) {
            throw new Error(ERRORS_MSGS.DUPLICATED_INJECTABLE_DECORATOR);
        }
        var types = Reflect.getMetadata(METADATA_KEY.DESIGN_PARAM_TYPES, target) || [];
        Reflect.defineMetadata(METADATA_KEY.PARAM_TYPES, types, target);
        return target;
    };
}
exports.injectable = injectable;


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var metadata_1 = __webpack_require__(36);
var decorator_utils_1 = __webpack_require__(53);
function tagged(metadataKey, metadataValue) {
    return function (target, targetKey, index) {
        var metadata = new metadata_1.Metadata(metadataKey, metadataValue);
        if (typeof index === "number") {
            decorator_utils_1.tagParameter(target, targetKey, index, metadata);
        }
        else {
            decorator_utils_1.tagProperty(target, targetKey, metadata);
        }
    };
}
exports.tagged = tagged;


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var METADATA_KEY = __webpack_require__(18);
var metadata_1 = __webpack_require__(36);
var decorator_utils_1 = __webpack_require__(53);
function named(name) {
    return function (target, targetKey, index) {
        var metadata = new metadata_1.Metadata(METADATA_KEY.NAMED_TAG, name);
        if (typeof index === "number") {
            decorator_utils_1.tagParameter(target, targetKey, index, metadata);
        }
        else {
            decorator_utils_1.tagProperty(target, targetKey, metadata);
        }
    };
}
exports.named = named;


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var METADATA_KEY = __webpack_require__(18);
var metadata_1 = __webpack_require__(36);
var decorator_utils_1 = __webpack_require__(53);
function optional() {
    return function (target, targetKey, index) {
        var metadata = new metadata_1.Metadata(METADATA_KEY.OPTIONAL_TAG, true);
        if (typeof index === "number") {
            decorator_utils_1.tagParameter(target, targetKey, index, metadata);
        }
        else {
            decorator_utils_1.tagProperty(target, targetKey, metadata);
        }
    };
}
exports.optional = optional;


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var METADATA_KEY = __webpack_require__(18);
var metadata_1 = __webpack_require__(36);
var decorator_utils_1 = __webpack_require__(53);
function unmanaged() {
    return function (target, targetKey, index) {
        var metadata = new metadata_1.Metadata(METADATA_KEY.UNMANAGED_TAG, true);
        decorator_utils_1.tagParameter(target, targetKey, index, metadata);
    };
}
exports.unmanaged = unmanaged;


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var METADATA_KEY = __webpack_require__(18);
var metadata_1 = __webpack_require__(36);
var decorator_utils_1 = __webpack_require__(53);
function multiInject(serviceIdentifier) {
    return function (target, targetKey, index) {
        var metadata = new metadata_1.Metadata(METADATA_KEY.MULTI_INJECT_TAG, serviceIdentifier);
        if (typeof index === "number") {
            decorator_utils_1.tagParameter(target, targetKey, index, metadata);
        }
        else {
            decorator_utils_1.tagProperty(target, targetKey, metadata);
        }
    };
}
exports.multiInject = multiInject;


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var METADATA_KEY = __webpack_require__(18);
var metadata_1 = __webpack_require__(36);
var decorator_utils_1 = __webpack_require__(53);
function targetName(name) {
    return function (target, targetKey, index) {
        var metadata = new metadata_1.Metadata(METADATA_KEY.NAME_TAG, name);
        decorator_utils_1.tagParameter(target, targetKey, index, metadata);
    };
}
exports.targetName = targetName;


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ERRORS_MSGS = __webpack_require__(27);
var METADATA_KEY = __webpack_require__(18);
var metadata_1 = __webpack_require__(36);
function postConstruct() {
    return function (target, propertyKey, descriptor) {
        var metadata = new metadata_1.Metadata(METADATA_KEY.POST_CONSTRUCT, propertyKey);
        if (Reflect.hasOwnMetadata(METADATA_KEY.POST_CONSTRUCT, target.constructor)) {
            throw new Error(ERRORS_MSGS.MULTIPLE_POST_CONSTRUCT_METHODS);
        }
        Reflect.defineMetadata(METADATA_KEY.POST_CONSTRUCT, metadata, target.constructor);
    };
}
exports.postConstruct = postConstruct;


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.multiBindToService = function (container) {
    return function (service) {
        return function () {
            var types = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                types[_i] = arguments[_i];
            }
            return types.forEach(function (t) { return container.bind(t).toService(service); });
        };
    };
};


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = __webpack_require__(14);
/**
 * responsible for dispatching async events
 * async events - are special type of event that fires after _logic and render phases
 * used mostly for changing the state of the game
 */
var AsyncEventManager = /** @class */ (function () {
    function AsyncEventManager() {
        this._asyncEventMap = {};
    }
    AsyncEventManager.prototype.dispatchAsyncEvents = function () {
        for (var name_1 in this._asyncEventMap) {
            if (this._asyncEventMap.hasOwnProperty(name_1)) {
                var listeners = this._asyncEventMap[name_1];
                if (listeners) {
                    for (var _i = 0, listeners_1 = listeners; _i < listeners_1.length; _i++) {
                        var listener = listeners_1[_i];
                        listener.callback();
                    }
                }
            }
        }
        this.clearAsyncEvents();
    };
    AsyncEventManager.prototype.clearAsyncEvents = function () {
        delete this._asyncEventMap;
    };
    AsyncEventManager = __decorate([
        inversify_1.injectable()
    ], AsyncEventManager);
    return AsyncEventManager;
}());
exports.AsyncEventManager = AsyncEventManager;


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = __webpack_require__(14);
var CoreDI_1 = __webpack_require__(32);
/**
 * game events handler and dispatcher. represents the way of communication between modules
 * all the global events goes through this class (it should be injected into every module)
 */
var EventManagerWithAsync = /** @class */ (function () {
    function EventManagerWithAsync() {
        this._eventMap = {};
    }
    EventManagerWithAsync.prototype.on = function (id, callback, owner, priority, data) {
        if (priority === void 0) { priority = 0; }
        if (data === void 0) { data = null; }
        this.addListenerAs(false, id, callback, owner, priority, data);
    };
    EventManagerWithAsync.prototype.off = function (id, owner) {
        this.removeListenerFrom(false, id, owner);
    };
    EventManagerWithAsync.prototype.hasListener = function (id, owner) {
        return this.hasListenerAt(false, id, owner);
    };
    EventManagerWithAsync.prototype.emit = function (id) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var listeners = this._eventMap[id];
        if (listeners) {
            var length_1 = listeners.length;
            for (var i = 0; i < length_1; i++) {
                var listener = listeners[i];
                listener.callback.apply(listener, args);
                if (listeners.length !== length_1) {
                    i--;
                    length_1 = listeners.length;
                }
            }
        }
    };
    /**
     * emitting event after the call stack if cleaned (next tick)
     * @param id event id
     * @param args arguments to pass with event
     */
    EventManagerWithAsync.prototype.emitDelayed = function (id) {
        var _this = this;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        setTimeout(function () {
            _this.emit.apply(_this, [id].concat(args));
        }, 0);
    };
    EventManagerWithAsync.prototype.onAsync = function (id, callback, owner, priority, data) {
        if (priority === void 0) { priority = 0; }
        if (data === void 0) { data = null; }
        this.addListenerAs(true, id, callback, owner, priority, data);
    };
    EventManagerWithAsync.prototype.offAsync = function (id, owner) {
        this.removeListenerFrom(true, id, owner);
    };
    EventManagerWithAsync.prototype.hasAsyncListener = function (id, owner) {
        return this.hasListenerAt(true, id, owner);
    };
    EventManagerWithAsync.prototype.addListenerAs = function (isAsync, id, callback, owner, priority, data) {
        var currentEventsMap = this.getAppropriateEventMap(isAsync);
        if (!currentEventsMap[id]) {
            currentEventsMap[id] = [];
        }
        currentEventsMap[id].push({ callback: callback, owner: owner, priority: priority, data: data });
        currentEventsMap[id].sort(function (a, b) {
            return b.priority - a.priority;
        });
    };
    EventManagerWithAsync.prototype.removeListenerFrom = function (isAsync, id, owner) {
        var currentEventsMap = this.getAppropriateEventMap(isAsync);
        var listeners = currentEventsMap[id];
        var index = listeners.findIndex(function (listener) {
            return listener.owner === owner;
        });
        if (index > -1) {
            listeners.splice(index, 1);
        }
    };
    EventManagerWithAsync.prototype.hasListenerAt = function (isAsync, id, owner) {
        var currentEventsMap = this.getAppropriateEventMap(isAsync);
        var listeners = currentEventsMap[id];
        var listener = listeners.find(function (listener) {
            return listener.owner === owner;
        });
        return listener !== undefined;
    };
    EventManagerWithAsync.prototype.getAppropriateEventMap = function (isAsync) {
        return isAsync ? this._asyncEventsManager._asyncEventMap : this._eventMap;
    };
    __decorate([
        inversify_1.inject(CoreDI_1.CoreDI.IAsyncEventManager),
        __metadata("design:type", Object)
    ], EventManagerWithAsync.prototype, "_asyncEventsManager", void 0);
    EventManagerWithAsync = __decorate([
        inversify_1.injectable()
    ], EventManagerWithAsync);
    return EventManagerWithAsync;
}());
exports.EventManagerWithAsync = EventManagerWithAsync;


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Preloader = /** @class */ (function () {
    function Preloader(baseUrlPath, device) {
        this.locale = 'EN';
        this._procentageLoaded = 0;
        this._getUrlPath = baseUrlPath;
        this._isMobile = device.isMobile;
        this._device = device;
        this.resizeFunction = this.onResizeEvent.bind(this);
    }
    Preloader.prototype.getDevicePathForResource = function (resName) {
        var platformPath = this._isMobile ? 'resources/Mobile/' : 'resources/Desktop/';
        return this._getUrlPath(platformPath + resName);
    };
    Preloader.prototype.createLoadingScreen = function () {
        var _this = this;
        document.body.style.backgroundColor = 'black';
        var parentItem = document.getElementById('preloader');
        var preloaderBg = this.createLoadingPreloaderBg();
        if (preloaderBg) {
            parentItem.appendChild(preloaderBg);
        }
        var bg = this.createLoadingBarBg();
        if (bg) {
            parentItem.appendChild(bg);
        }
        var progress = this.createLoadingBarProgress(bg);
        if (progress) {
            parentItem.appendChild(progress);
        }
        var loadingText = this.createLoadingText();
        if (loadingText) {
            parentItem.appendChild(loadingText);
        }
        this.addExtraItems(parentItem);
        this._useDebugging = false;
        this.onResizeEvent();
        setTimeout(function () {
            _this.onResizeEvent();
        }, 500);
        window.addEventListener('resize', this.resizeFunction);
    };
    Preloader.prototype.addExtraItems = function (parentItem) {
    };
    Preloader.prototype.createDebuggingDiv = function (parentItem) {
        var debuggingText = document.createElement('div');
        debuggingText.id = 'debuggingElement';
        debuggingText.style.position = 'absolute';
        debuggingText.innerText = 'DEBUGGER';
        debuggingText.style.color = 'white';
        debuggingText.style.top = '50px';
        debuggingText.style.zIndex = '10000';
        this._debuggingText = debuggingText;
        parentItem.appendChild(debuggingText);
    };
    Preloader.prototype.updateDebugger = function (data) {
        var dataText = '';
        for (var key in data) {
            if (data.hasOwnProperty(key)) {
                var element = JSON.stringify(data[key]);
                dataText += "<br/>" + key + ":" + element;
            }
        }
        this._debuggingText.innerHTML = dataText;
    };
    Preloader.prototype.onResizeEvent = function () {
        var _this = this;
        setTimeout(function () {
            _this.scalePreloaderComponents();
        }, (this._device.iOS && this._device.isIOSChrome) || this._device.isIOSMobileRequestingDesktop ? 200 : 0);
    };
    Preloader.prototype.scalePreloaderComponents = function () {
        var w = 0;
        var h = 0;
        var ow = 0;
        var oh = 0;
        var scaleFactor = 1;
        var innerWidth = this._device.isSamsungNative ? window.outerWidth : window.innerWidth;
        var innerHeight = this._device.isSamsungNative ? window.outerHeight : window.innerHeight;
        h = innerHeight;
        w = innerWidth;
        if (this._device.isMobile && !this._device.iOS && !this._device.isSamsungNative) {
            ow = window.outerWidth;
            oh = window.outerHeight;
            scaleFactor = h / oh;
        }
        var divisor = this._device.isMobile ? 320 : 640;
        var logoScale = Math.max(0.5, Math.min(window.innerWidth / divisor, 1)) * scaleFactor;
        this._loadingImage.style.transform = "translateX(-50%) translateY(-50%) scale(" + logoScale + ")";
        this._loadingImage.style.left = Math.ceil(w * 0.5) + 'px';
        this._loadingImage.style.top = Math.ceil(h * 0.65) + 'px';
        this.extraResizeUpdate(w, h, scaleFactor);
        this._loaderBarBg.style.width = Math.ceil(w * 0.8) + 'px';
        this._loaderBarBg.style.height = Math.ceil(40 * scaleFactor) + 'px';
        this._loaderBarBg.style.borderRadius = Math.ceil(20 * scaleFactor) + 'px';
        this._loaderBarBg.style.left = Math.ceil(w * 0.5) + 'px';
        this._loaderBarBg.style.top = Math.ceil(h * 0.65) + 'px';
        this._loaderBarMaxWidth = w * 0.8;
        this._loaderBar.style.width = Math.ceil(this._loaderBarMaxWidth * this._procentageLoaded) + 'px';
        this._loaderBar.style.height = Math.ceil(40 * scaleFactor) + 'px';
        this._loaderBar.style.borderRadius = Math.ceil(20 * scaleFactor) + 'px';
        this._loaderBar.style.left = Math.ceil(w * 0.5) + 'px';
        this._loaderBar.style.top = Math.ceil(h * 0.65) + 'px';
        this._loadingBackground.style.width = Math.ceil(w) + 'px';
        this._loadingBackground.style.height = Math.ceil(h) + 'px';
    };
    Preloader.prototype.extraResizeUpdate = function (width, height, scaleFactor) { };
    Preloader.prototype.createFantasmaLogo = function () {
        throw new Error('Preloader::createGameLogo should be game specific');
    };
    Preloader.prototype.createGameLogo = function () {
        throw new Error('Preloader::createGameLogo should be game specific');
    };
    Preloader.prototype.createPublisherLogoPortrait = function () {
        throw new Error('Preloader::createPublisherLogoPortrait should be game specific');
    };
    Preloader.prototype.createPublisherLogoLandscape = function () {
        throw new Error('Preloader::createPublisherLogoLandscape should be game specific');
    };
    Preloader.prototype.createLoadingPreloaderBg = function () {
        var bg = document.createElement('div');
        bg.style.background = 'radial-gradient(rgb(64, 64, 64), rgb(40, 40, 40), rgb(17, 17, 17))';
        bg.id = 'preloaderBg';
        bg.style.width = '100%';
        bg.style.height = '100%';
        this._loadingBackground = bg;
        return this._loadingBackground;
    };
    Preloader.prototype.createLoadingText = function () {
        var textImage = document.createElement('img');
        textImage.id = 'loadingText';
        textImage.style.position = 'absolute';
        textImage.style.left = '50%';
        textImage.style.transform = 'translateX(-50%) translateY(-50%)';
        textImage.style.top = this._loaderBar.style.top;
        textImage.src = this.getDevicePathForResource('Loading_Text.png');
        this._loadingImage = textImage;
        return this._loadingImage;
    };
    Preloader.prototype.createLoadingBarBg = function (progress) {
        var bg;
        bg = document.createElement('div');
        if (!progress) {
            bg.id = 'barBg';
            bg.style.boxShadow = '0px 5px 10px rgba(0, 0, 0, 0.5)';
            this._loaderBarBg = bg;
        }
        else {
            bg.id = 'progress';
            this._loaderBar = bg;
        }
        bg.style.position = 'absolute';
        bg.style.width = '80%';
        bg.style.borderRadius = '20px';
        bg.style.height = '40px';
        bg.style.backgroundColor = 'rgb(34, 34, 34)';
        bg.style.display = 'grid';
        bg.style.left = '50%';
        bg.style.top = '65%';
        bg.style.transform = 'translateX(-50%) translateY(-50%)';
        return bg;
    };
    Preloader.prototype.createLoadingBarProgress = function (bg) {
        var progress = this.createLoadingBarBg(true);
        progress.style.width = '0%';
        progress.style.background = 'rgb(255, 255, 255)';
        // progress.style.border = '3px solid rgb(195, 255, 120)';
        return progress;
    };
    Preloader.prototype.calcPercentage = function (pixels) {
        return pixels / window.innerWidth;
    };
    Preloader.prototype.updateProgress = function (totalItems, currentItems) {
        var procentage = currentItems / totalItems;
        this._loaderBar.style.width = this._loaderBarMaxWidth * procentage + "px";
        this._procentageLoaded = procentage;
    };
    Preloader.prototype.endLoading = function () {
        window.removeEventListener('resize', this.onResizeEvent);
        if (this._loadingBackground) {
            this._loadingBackground.style.display = 'none';
            this.removeElement(this._loadingBackground);
        }
        if (this._loaderBar) {
            this._loaderBar.style.display = 'none';
            this.removeElement(this._loaderBar);
        }
        if (this._loaderBarBg) {
            this._loaderBarBg.style.display = 'none';
            this.removeElement(this._loaderBarBg);
        }
        if (this._loadingImage) {
            this._loadingImage.style.display = 'none';
            this.removeElement(this._loadingImage);
        }
        this.removeExtraItems();
        if (this._fantasmaLogo) {
            this._fantasmaLogo.style.display = 'none';
            this.removeElement(this._fantasmaLogo);
        }
        if (this._gameLogo) {
            this._gameLogo.style.display = 'none';
            this.removeElement(this._gameLogo);
        }
        if (this._publisherLogoPortrait) {
            this._publisherLogoPortrait.style.display = 'none';
            this.removeElement(this._publisherLogoPortrait);
        }
        if (this._publisherLogoLandscape) {
            this._publisherLogoLandscape.style.display = 'none';
            this.removeElement(this._publisherLogoLandscape);
        }
    };
    Preloader.prototype.removeExtraItems = function () { };
    Preloader.prototype.usingUnsupportedDeviceOrBrowser = function () {
    };
    Preloader.prototype.removeElement = function (element) {
        var parent = element.parentElement;
        parent.removeChild(element);
    };
    return Preloader;
}());
exports.Preloader = Preloader;


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = __webpack_require__(14);
var CoreDI_1 = __webpack_require__(32);
var Device_1 = __webpack_require__(42);
var DI_1 = __webpack_require__(51);
var UpdateManager_1 = __webpack_require__(70);
var FullscreenManager_1 = __webpack_require__(107);
var ResourcesLoader_1 = __webpack_require__(69);
var ResolutionManager_1 = __webpack_require__(143);
var SoundPlayer_1 = __webpack_require__(144);
var Translator_1 = __webpack_require__(232);
var TextStyles_1 = __webpack_require__(229);
var Layout_1 = __webpack_require__(146);
var CurrencyFormatter_1 = __webpack_require__(72);
var SpineUtils_1 = __webpack_require__(233);
var System_1 = __webpack_require__(52);
var HTMLUtils_1 = __webpack_require__(479);
var TimerUtils_1 = __webpack_require__(235);
var BasicView = /** @class */ (function () {
    function BasicView() {
        this._eventMap = {};
    }
    BasicView.prototype.init = function () {
        this._container = new PIXI.Sprite();
        this._overContainer = new PIXI.Container();
        this._parent.addChild(this._overContainer);
        this._overContainer.addChild(this._container);
        this._spineUtils = new SpineUtils_1.SpineUtils(this._resources, this._updateManager, this._container);
        this._timeUtils = new TimerUtils_1.TimerUtils(this._updateManager);
    };
    BasicView.prototype.initHTMLUtils = function () {
        var _this = this;
        if (!this._htmlUtils) {
            this._htmlUtils = new HTMLUtils_1.HTMLUtils(this.resources, this.device, this.resolutionManager);
            this.resizeHtml = function () {
                _this._htmlUtils.resizeItems();
            };
        }
    };
    BasicView.prototype.show = function () {
        this._container.visible = true;
    };
    BasicView.prototype.hide = function () {
        this._container.visible = false;
    };
    BasicView.prototype.hideContainer = function () {
        this._overContainer.visible = false;
    };
    BasicView.prototype.showContainer = function () {
        this._overContainer.visible = true;
    };
    BasicView.prototype.translate = function () { };
    BasicView.prototype.addToParent = function () {
        this._parent.addChild(this._container);
    };
    BasicView.prototype.removeFromParent = function () {
        this._parent.removeChild(this._container);
    };
    BasicView.prototype.isVisible = function () {
        return this._container.visible;
    };
    BasicView.prototype.on = function (id, callback, owner, priority, data) {
        if (priority === void 0) { priority = 0; }
        if (data === void 0) { data = null; }
        if (!this._eventMap[id]) {
            this._eventMap[id] = [];
        }
        this._eventMap[id].push({ callback: callback, owner: owner, priority: priority, data: data });
        this._eventMap[id].sort(function (a, b) {
            return b.priority - a.priority;
        });
    };
    BasicView.prototype.off = function (id, owner) {
        var listeners = this._eventMap[id];
        var index = listeners.findIndex(function (listener) {
            return listener.owner === owner;
        });
        if (index > -1) {
            listeners.splice(index, 1);
        }
    };
    BasicView.prototype.emit = function (id) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var listeners = this._eventMap[id];
        if (listeners) {
            for (var _a = 0, listeners_1 = listeners; _a < listeners_1.length; _a++) {
                var listener = listeners_1[_a];
                listener.callback.apply(listener, args);
            }
        }
    };
    BasicView.prototype.emitDelayed = function (id) {
        var _this = this;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        setTimeout(function () {
            _this.emit.apply(_this, [id].concat(args));
        }, 0);
    };
    BasicView.prototype.hasListener = function (id, owner) {
        var listeners = this._eventMap[id];
        var listener = listeners.find(function (listener) {
            return listener.owner === owner;
        });
        return !!listener;
    };
    BasicView.prototype.forceUpdateOrientation = function () {
        if (this.device.isMobile) {
            if (this._fullscreenManager.orientation === FullscreenManager_1.ScreenOrientation.LANDSCAPE) {
                this.onLandscape();
            }
            else if (this._fullscreenManager.orientation === FullscreenManager_1.ScreenOrientation.PORTRAIT) {
                this.onPortrait();
            }
        }
    };
    BasicView.prototype.onFullscreenEntered = function () { };
    BasicView.prototype.onFullscreenExited = function () { };
    BasicView.prototype.onResized = function (screenParams) {
        this.resizeHtml();
    };
    BasicView.prototype.resizeHtml = function () {
        // Will be overridden when initializing htmlutils.
    };
    Object.defineProperty(BasicView.prototype, "container", {
        get: function () {
            return this._container;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BasicView.prototype, "updateManager", {
        get: function () {
            return this._updateManager;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BasicView.prototype, "resources", {
        get: function () {
            return this._resources;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BasicView.prototype, "device", {
        get: function () {
            return this._device;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BasicView.prototype, "resolutionManager", {
        get: function () {
            return this._resolutionManager;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BasicView.prototype, "soundPlayer", {
        get: function () {
            return this._soundPlayer;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BasicView.prototype, "fullscreenManager", {
        get: function () {
            return this._fullscreenManager;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BasicView.prototype, "translator", {
        get: function () {
            return this._translator;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BasicView.prototype, "textStyles", {
        get: function () {
            return this._textStyles;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BasicView.prototype, "spineUtils", {
        get: function () {
            return this._spineUtils;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BasicView.prototype, "timeUtils", {
        get: function () {
            return this._timeUtils;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BasicView.prototype, "layout", {
        get: function () {
            return this._layout;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BasicView.prototype, "currencyFormatter", {
        get: function () {
            return this._currencyFormatter;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BasicView.prototype, "parent", {
        get: function () {
            return this._parent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BasicView.prototype, "htmlUtils", {
        get: function () {
            return this._htmlUtils;
        },
        set: function (value) {
            this._htmlUtils = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BasicView.prototype, "overContainer", {
        get: function () {
            return this._overContainer;
        },
        enumerable: true,
        configurable: true
    });
    BasicView.prototype.onLandscape = function () { };
    BasicView.prototype.onPortrait = function () { };
    __decorate([
        inversify_1.inject(CoreDI_1.CoreDI.Device),
        __metadata("design:type", Device_1.Device)
    ], BasicView.prototype, "_device", void 0);
    __decorate([
        inversify_1.inject(DI_1.default.PixiStageContainer),
        __metadata("design:type", PIXI.Container)
    ], BasicView.prototype, "_parent", void 0);
    __decorate([
        inversify_1.inject(CoreDI_1.CoreDI.UpdateManager),
        __metadata("design:type", UpdateManager_1.UpdateManager)
    ], BasicView.prototype, "_updateManager", void 0);
    __decorate([
        inversify_1.inject(CoreDI_1.CoreDI.FullscreenManager),
        __metadata("design:type", FullscreenManager_1.FullscreenManager)
    ], BasicView.prototype, "_fullscreenManager", void 0);
    __decorate([
        inversify_1.inject(CoreDI_1.CoreDI.ResourceLoader),
        __metadata("design:type", ResourcesLoader_1.ResourcesLoader)
    ], BasicView.prototype, "_resources", void 0);
    __decorate([
        inversify_1.inject(CoreDI_1.CoreDI.ResolutionManager),
        __metadata("design:type", ResolutionManager_1.ResolutionManager)
    ], BasicView.prototype, "_resolutionManager", void 0);
    __decorate([
        inversify_1.inject(DI_1.default.SoundPlayer),
        __metadata("design:type", SoundPlayer_1.SoundPlayer)
    ], BasicView.prototype, "_soundPlayer", void 0);
    __decorate([
        inversify_1.inject(DI_1.default.Translator),
        __metadata("design:type", Translator_1.Translator)
    ], BasicView.prototype, "_translator", void 0);
    __decorate([
        inversify_1.inject(DI_1.default.TextStyles),
        __metadata("design:type", TextStyles_1.TextStyles)
    ], BasicView.prototype, "_textStyles", void 0);
    __decorate([
        inversify_1.inject(DI_1.default.Layout),
        __metadata("design:type", Layout_1.Layout)
    ], BasicView.prototype, "_layout", void 0);
    __decorate([
        inversify_1.inject(DI_1.default.CurrencyFormatter),
        __metadata("design:type", CurrencyFormatter_1.CurrencyFormatter)
    ], BasicView.prototype, "_currencyFormatter", void 0);
    __decorate([
        inversify_1.inject(CoreDI_1.CoreDI.System),
        __metadata("design:type", System_1.System)
    ], BasicView.prototype, "_system", void 0);
    return BasicView;
}());
exports.BasicView = BasicView;


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DefaultFullscreenView = /** @class */ (function () {
    function DefaultFullscreenView() {
    }
    DefaultFullscreenView.prototype.handle = function (orientation) {
    };
    return DefaultFullscreenView;
}());
exports.DefaultFullscreenView = DefaultFullscreenView;


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var FullscreenManager_1 = __webpack_require__(107);
var IOSFullScreenView = /** @class */ (function () {
    function IOSFullScreenView() {
        this.scrollHand = document.createElement('div');
        this.scroll = document.createElement('div');
        this.scrollHand.className = 'scroll-hand-container scroll-hand';
        this.scroll.className = 'scroll';
        document.body.appendChild(this.scrollHand);
        document.body.appendChild(this.scroll);
        // disable scale
        document.addEventListener('gesturestart', function (e) {
            e.preventDefault();
        });
        this.hideScroll();
    }
    IOSFullScreenView.prototype.handle = function (orientation) {
        if (this.isFullscreen(orientation)) {
            this.hideScroll();
        }
        else {
            this.showScroll();
        }
    };
    IOSFullScreenView.prototype.isFullscreen = function (orientation) {
        if (orientation === FullscreenManager_1.ScreenOrientation.LANDSCAPE) {
            // for safari "window.innerHeight >= screen.width" is enough but for chrome we need to
            // have 20px navbar;
            var barHeight = 44;
            return window.innerHeight + barHeight >= screen.width;
        }
        else {
            var barHeight = 64;
            return window.innerHeight + barHeight >= screen.height;
        }
    };
    IOSFullScreenView.prototype.showScroll = function () {
        this.scrollHand.style.visibility = 'visible';
        this.scroll.style.visibility = 'visible';
    };
    IOSFullScreenView.prototype.hideScroll = function () {
        this.scrollHand.style.visibility = 'hidden';
        this.scroll.style.visibility = 'hidden';
        window.scrollBy(0, 0);
    };
    return IOSFullScreenView;
}());
exports.IOSFullScreenView = IOSFullScreenView;


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Interpolation = {
    Linear: function (v, k) {
        var m = v.length - 1;
        var f = m * k;
        var i = Math.floor(f);
        var fn = exports.Interpolation.Utils.Linear;
        if (k < 0) {
            return fn(v[0], v[1], f);
        }
        if (k > 1) {
            return fn(v[m], v[m - 1], m - f);
        }
        return fn(v[i], v[i + 1 > m ? m : i + 1], f - i);
    },
    Bezier: function (v, k) {
        var b = 0;
        var n = v.length - 1;
        var pw = Math.pow;
        var bn = exports.Interpolation.Utils.Bernstein;
        for (var i = 0; i <= n; i++) {
            b += pw(1 - k, n - i) * pw(k, i) * v[i] * bn(n, i);
        }
        return b;
    },
    CatmullRom: function (v, k) {
        var m = v.length - 1;
        var f = m * k;
        var i = Math.floor(f);
        var fn = exports.Interpolation.Utils.CatmullRom;
        if (v[0] === v[m]) {
            if (k < 0) {
                i = Math.floor(f = m * (1 + k));
            }
            return fn(v[(i - 1 + m) % m], v[i], v[(i + 1) % m], v[(i + 2) % m], f - i);
        }
        else {
            if (k < 0) {
                return v[0] - (fn(v[0], v[0], v[1], v[1], -f) - v[0]);
            }
            if (k > 1) {
                return v[m] - (fn(v[m], v[m], v[m - 1], v[m - 1], f - m) - v[m]);
            }
            return fn(v[i ? i - 1 : 0], v[i], v[m < i + 1 ? m : i + 1], v[m < i + 2 ? m : i + 2], f - i);
        }
    },
    Utils: {
        Linear: function (p0, p1, t) { return (p1 - p0) * t + p0; },
        Bernstein: function (n, i) {
            var fc = exports.Interpolation.Utils.Factorial;
            return fc(n) / fc(i) / fc(n - i);
        },
        Factorial: (function () {
            var a = [1];
            return function (n) {
                var s = 1;
                if (a[n]) {
                    return a[n];
                }
                for (var i = n; i > 1; i--) {
                    s *= i;
                }
                a[n] = s;
                return s;
            };
        })(),
        CatmullRom: function (p0, p1, p2, p3, t) {
            var v0 = (p2 - p0) * 0.5;
            var v1 = (p3 - p1) * 0.5;
            var t2 = t * t;
            var t3 = t * t2;
            return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
        }
    }
};


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * [name of the sound that triggers ducking of the music]: time of ducking and unducking
 */
Object.defineProperty(exports, "__esModule", { value: true });
var SoundsDuckingConfig = /** @class */ (function () {
    function SoundsDuckingConfig() {
        this._duckingConfig = {};
        this.init();
    }
    SoundsDuckingConfig.prototype.init = function () {
        this.setupDuckingConfigs();
        this.setupUnduckingConfigs();
    };
    SoundsDuckingConfig.prototype.hasDuckingTimeFor = function (soundName) {
        return this.hasDuckingConfigFor(soundName) && this._duckingConfig[soundName].hasOwnProperty('duckingTime');
    };
    SoundsDuckingConfig.prototype.getDuckingTimeFor = function (soundName) {
        return this._duckingConfig[soundName].duckingTime;
    };
    SoundsDuckingConfig.prototype.getDuckingSoundsFor = function (soundName) {
        return this._duckingConfig[soundName].sounds;
    };
    SoundsDuckingConfig.prototype.hasUnduckingFor = function (soundName) {
        return this._duckingConfig.hasOwnProperty(soundName) && this._duckingConfig[soundName].hasOwnProperty('unduckingTime');
    };
    SoundsDuckingConfig.prototype.getUnduckingTimeFor = function (soundName) {
        return this._duckingConfig[soundName].unduckingTime;
    };
    SoundsDuckingConfig.prototype.hasDuckingConfigFor = function (soundName) {
        return this._duckingConfig.hasOwnProperty(soundName);
    };
    SoundsDuckingConfig.prototype.setupDuckingConfigs = function () {
        // Example use.
        this.addDuckingConfig('bigwin', 300, { music: true, effects: false, voice: false });
    };
    SoundsDuckingConfig.prototype.setupUnduckingConfigs = function () { };
    SoundsDuckingConfig.prototype.addDuckingConfig = function (soundId, duckingTime, sounds) {
        if (sounds === void 0) { sounds = { music: true, effects: false, voice: false }; }
        if (this._duckingConfig[soundId]) {
            this._duckingConfig[soundId].duckingTime = duckingTime;
            this._duckingConfig[soundId].sounds = sounds;
        }
        else {
            this._duckingConfig[soundId] = { duckingTime: duckingTime, sounds: sounds };
        }
    };
    SoundsDuckingConfig.prototype.addUnduckingConfig = function (soundId, unduckingTime, sounds) {
        if (sounds === void 0) { sounds = { music: true, effects: false, voice: false }; }
        if (this._duckingConfig[soundId]) {
            this._duckingConfig[soundId].unduckingTime = unduckingTime;
            this._duckingConfig[soundId].sounds = sounds;
        }
        else {
            this._duckingConfig[soundId] = { unduckingTime: unduckingTime, sounds: sounds };
        }
    };
    return SoundsDuckingConfig;
}());
exports.SoundsDuckingConfig = SoundsDuckingConfig;


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var SpineButton_1 = __webpack_require__(234);
var Button_1 = __webpack_require__(54);
var SpineAnimation_1 = __webpack_require__(37);
var LocalizedSpineButton = /** @class */ (function (_super) {
    __extends(LocalizedSpineButton, _super);
    function LocalizedSpineButton(callback, spineUtils, resources) {
        var _this = _super.call(this, callback) || this;
        _this._locales = {};
        _this._slots = {};
        _this._spineUtils = spineUtils;
        _this._resources = resources;
        return _this;
    }
    LocalizedSpineButton.prototype.setupLocales = function (upLocale, downLocale, overLocale, disabledLocale) {
        this._locales[Button_1.ButtonState.UP] = upLocale;
        this._locales[Button_1.ButtonState.DOWN] = downLocale ? downLocale : upLocale;
        this._locales[Button_1.ButtonState.OVER] = overLocale ? overLocale : upLocale;
        this._locales[Button_1.ButtonState.DISABLED] = disabledLocale ? disabledLocale : upLocale;
    };
    LocalizedSpineButton.prototype.setupButtonSlots = function (upSlotName, downSlotName, overSlotName, disabledSlotName) {
        this._slots[Button_1.ButtonState.UP] = upSlotName;
        this._slots[Button_1.ButtonState.DOWN] = downSlotName ? downSlotName : upSlotName;
        this._slots[Button_1.ButtonState.OVER] = overSlotName ? overSlotName : upSlotName;
        this._slots[Button_1.ButtonState.DISABLED] = disabledSlotName ? disabledSlotName : upSlotName;
    };
    LocalizedSpineButton.prototype.updateFrame = function () {
        if (this._animation[this._state]) {
            this.cleanFrame();
            this._spineAnimation = new SpineAnimation_1.SpineAnimation(this._spine, this._animation[this._state], this._animationLoop[this._state], true);
            this._spineUtils.replaceElementInSpineAnimation(this._spineAnimation, this._slots[this._state], new PIXI.Sprite(this._resources.getLocaleTextImage(this._locales[this._state])));
            this._updateManager.add(this._spineAnimation);
            this._spineAnimation.start();
        }
    };
    return LocalizedSpineButton;
}(SpineButton_1.SpineButton));
exports.LocalizedSpineButton = LocalizedSpineButton;


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var HTMLPageComponent_1 = __webpack_require__(480);
var HTMLUtils = /** @class */ (function () {
    function HTMLUtils(resourceloader, device, resolutionManager) {
        this._htmlComponents = {};
        this.resources = resourceloader;
        this.device = device;
        this.resolutionManager = resolutionManager;
    }
    HTMLUtils.prototype.makeHtml = function (name, limits, htmlPath) {
        if (limits === void 0) { limits = {
            maxX: this.resolutionManager.resolution.width,
            maxY: this.resolutionManager.resolution.height,
            minX: 0,
            minY: 0,
        }; }
        if (htmlPath === void 0) { htmlPath = '/HMTL'; }
        this.removeHtml(name);
        var htmlPage = new HTMLPageComponent_1.HTMLPageComponent(this.resources, this.device, this.resolutionManager);
        htmlPage.init(limits, '/HTML/', "fantasmaHTMLComponent_" + name);
        this.addHtml(name, htmlPage);
        return htmlPage;
    };
    HTMLUtils.prototype.show = function (name) {
        if (this.hasHtml(name)) {
            this.getHtml(name).show();
        }
    };
    HTMLUtils.prototype.makeHtmlButton = function (text, onClick) {
        var button = document.createElement('button');
        button.style.position = 'absolute';
        button.style.top = '10px';
        button.style.right = '10px';
        button.style.width = '3em';
        button.style.height = '3em';
        button.style.pointerEvents = 'all';
        button.textContent = text;
        button.onclick = onClick;
        return button;
    };
    HTMLUtils.prototype.hasHtml = function (name) {
        return !!this._htmlComponents[name];
    };
    HTMLUtils.prototype.getHtml = function (name) {
        return this._htmlComponents[name] ? this._htmlComponents[name] : null;
    };
    HTMLUtils.prototype.addHtml = function (name, html) {
        this._htmlComponents[name] = html;
    };
    HTMLUtils.prototype.removeHtml = function (name) {
        if (this._htmlComponents[name]) {
            this._htmlComponents[name].destroy();
            this._htmlComponents[name] = null;
        }
    };
    HTMLUtils.prototype.resizeItems = function () {
        for (var item in this._htmlComponents) {
            if (this._htmlComponents.hasOwnProperty(item)) {
                var html = this._htmlComponents[item];
                if (html) {
                    html.resizeHTML();
                }
            }
        }
    };
    return HTMLUtils;
}());
exports.HTMLUtils = HTMLUtils;


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SpriteGraphics_1 = __webpack_require__(62);
var Scrollbar_1 = __webpack_require__(148);
var GameUtils_1 = __webpack_require__(26);
var HTMLPageComponent = /** @class */ (function () {
    function HTMLPageComponent(resourceloader, device, resolutionManager) {
        this._uiStageOffsetY = 0;
        this._uiStageMaxY = 0;
        this._hasLoaded = false;
        this._yOffset = 0;
        this._minYDrag = 0;
        this._maxYDrag = 0;
        this._resourcesPath = 'HTML/';
        this._containerId = 'FANTASMA_CONTAINER';
        this._htmlContent = '<div></div>';
        this.resources = resourceloader;
        this.device = device;
        this.resolutionManager = resolutionManager;
        this._container = new PIXI.Container();
    }
    HTMLPageComponent.prototype.destroy = function () {
        this.removeAllInput();
        this.removeElement(this._mainContainer);
        this.removeElement(this._mainBody);
        this.container.destroy();
    };
    HTMLPageComponent.prototype.removeElement = function (element) {
        var parent = element.parentElement;
        if (parent) {
            parent.removeChild(element);
        }
    };
    HTMLPageComponent.prototype.appendChild = function (item) {
        this._mainBody.appendChild(item);
    };
    HTMLPageComponent.prototype.init = function (limits, resourcePath, containerId) {
        this.setupPathsAndIds(resourcePath, containerId);
        this._gameCanvas = document.getElementById('GameCanvas');
        this.setupUiOffset(limits);
        this.setupHTML();
        this.hide();
    };
    HTMLPageComponent.prototype.show = function () {
        this._mainContainer.style.display = this.device.isIE || this.device.isMacOs ? 'block' : 'grid';
        this._mainContainer.style.visibility = 'visible';
        if (this.device.isMobile || this.device.hasTouch) {
            this._minYDrag = this._mainBody.offsetHeight - this.resolutionManager.halfResolution.height * 0.5;
            this._minYDrag *= -1;
            if (!this._scrollBar) {
                this.addScrollbar();
            }
        }
    };
    HTMLPageComponent.prototype.hide = function () {
        this._mainContainer.style.display = 'none';
        this._mainContainer.style.visibility = 'hidden';
    };
    HTMLPageComponent.prototype.setupPathsAndIds = function (resourcePath, containerId) {
        this._resourcesPath = resourcePath;
        this._containerId = containerId;
    };
    HTMLPageComponent.prototype.setupUiOffset = function (limits) {
        this._uiStageOffsetY = limits.minY;
        this._uiStageMaxY = limits.maxY;
    };
    HTMLPageComponent.prototype.setupHTML = function () {
        this.setupMainContainer();
        this.setupMainDiv();
        this._mainContainer.appendChild(this._mainBody);
        this._gameCanvas.parentElement.appendChild(this._mainContainer);
        this.resizeHTML();
        this._mainContainer.style.transformOrigin = "0px 0px";
        var totalHeight = this._uiStageMaxY - this._uiStageOffsetY;
        this._mainContainer.style.maxHeight = this._mainContainer.style.height = totalHeight + "px";
    };
    HTMLPageComponent.prototype.setupMainContainer = function () {
        this._mainContainer = document.createElement('div');
        this._mainContainer.id = this._containerId;
        this._mainContainer.style.display = 'none';
        this._mainContainer.style.position = 'absolute';
        this._mainContainer.style.visibility = 'hidden';
        this._mainContainer.style.height = this.resolutionManager.resolution.height - this._uiStageOffsetY + 'px';
        this._mainContainer.style.width = this.resolutionManager.resolution.width + 'px';
    };
    HTMLPageComponent.prototype.setupMainDiv = function () {
        this._mainBody = document.createElement('div');
        this._mainBody.innerHTML = this.getBodyContent();
        this._mainBody.classList.add('FANTASMA_HTML_COMPONENT');
        // this._mainBody.style.width = '100%';
        this._mainBody.style.width = this.device.isMobile ? this._mainContainer.style.width : '100%';
        this._mainBody.style.height = '100%';
    };
    HTMLPageComponent.prototype.getBodyContent = function () {
        return this._htmlContent;
    };
    HTMLPageComponent.prototype.setBodyContent = function (content) {
        this._htmlContent = content;
        this._mainBody.innerHTML = content;
        this.onLoadComplete();
    };
    /**
     * Only use for Iframe which is unpreffered.
     */
    HTMLPageComponent.prototype.onLoadComplete = function () {
        this._hasLoaded = true;
        if (this.device.isMobile) {
            this.setupForMobile();
        }
        else {
            this.setupInputForDesktop();
        }
    };
    HTMLPageComponent.prototype.setupInputForDesktop = function () {
        this._mainContainer.style.overflowY = 'scroll';
        this._mainContainer.style.webkitUserSelect = 'none';
        this._mainContainer.style.userSelect = 'none';
        this._mainContainer.style.msUserSelect = 'none';
        this._mainContainer.style.touchAction = 'none';
        this._mainBody.style.pointerEvents = 'none';
        this._mainBody.style.touchAction = 'none';
    };
    HTMLPageComponent.prototype.setupForMobile = function () {
        this._mainContainer.style.overflowY = 'scroll';
        this._mainContainer.style.pointerEvents = 'none';
        this._mainContainer.style.touchAction = 'none';
        this._mainBody.style.pointerEvents = 'none';
        this._mainBody.style.touchAction = 'none';
        this.setupInput();
    };
    HTMLPageComponent.prototype.addScrollbar = function () {
        var contentHeight = this._uiStageMaxY - this._uiStageOffsetY;
        var scrollBarWidth = 12;
        this._scrollBar = new Scrollbar_1.Scrollbar(scrollBarWidth, contentHeight, contentHeight, this._mainBody.scrollHeight);
        this._container.addChild(this._scrollBar);
        this._scrollBar.position.set(this.resolutionManager.resolution.width - scrollBarWidth, this._uiStageOffsetY);
    };
    HTMLPageComponent.prototype.setupInput = function () {
        this._dragInput = SpriteGraphics_1.SpriteGraphics.makeHiddenRectangle(this.resolutionManager.resolution.width, this.resolutionManager.resolution.height);
        if (false) {
            console.warn(this.resolutionManager.resolution.width, this._uiStageMaxY - this._uiStageOffsetY, this._uiStageOffsetY, this._uiStageMaxY);
            console.warn(this._dragInput);
        }
        this._dragInput.interactive = true;
        this._container.addChild(this._dragInput);
        this._dragInput.position.y = this._uiStageOffsetY;
        this._dragInput.on('touchstart', this.onInputTouchStart.bind(this));
        this._dragInput.on('mousedown', this.onInputTouchStart.bind(this));
        this.onDragStopBoundFunction = this.removeDragInput.bind(this);
    };
    HTMLPageComponent.prototype.removeAllInput = function () {
        if (this._dragInput) {
            this._dragInput.interactive = false;
            this._dragInput = null;
            this.removeDragInput();
        }
    };
    HTMLPageComponent.prototype.onInputTouchStart = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (this._isDragging) {
            return;
        }
        this._isDragging = true;
        document.addEventListener('touchend', this.onDragStopBoundFunction);
        document.addEventListener('touchcancel', this.onDragStopBoundFunction);
        document.addEventListener('mouseup', this.onDragStopBoundFunction);
        document.addEventListener('mouseleave', this.onDragStopBoundFunction);
        document.addEventListener('mouseout', this.onDragStopBoundFunction);
        this._dragStartY = event.data.global.y;
        this._dragInput.on('touchmove', this.onInputMove.bind(this));
        this._dragInput.on('mousemove', this.onInputMove.bind(this));
    };
    HTMLPageComponent.prototype.removeDragInput = function () {
        document.removeEventListener('touchend', this.onDragStopBoundFunction);
        document.removeEventListener('touchcancel', this.onDragStopBoundFunction);
        document.removeEventListener('mouseup', this.onDragStopBoundFunction);
        document.removeEventListener('mouseleave', this.onDragStopBoundFunction);
        document.removeEventListener('mouseout', this.onDragStopBoundFunction);
        if (this._dragInput) {
            this._dragInput.removeListener('touchmove');
            this._dragInput.removeListener('mousemove');
        }
        this._isDragging = false;
    };
    HTMLPageComponent.prototype.onInputMove = function (event) {
        if (this.device.isMobile) {
            this._minYDrag = this._mainBody.offsetHeight - this.resolutionManager.halfResolution.height * 0.5;
            this._minYDrag *= -1;
            if (!this._scrollBar) {
                this.addScrollbar();
            }
        }
        var deltaY = event.data.global.y - this._dragStartY;
        this._dragStartY = event.data.global.y;
        this._yOffset += deltaY;
        this._yOffset = Math.max(Math.min(this._yOffset, this._maxYDrag), this._minYDrag);
        this._mainBody.style.webkitTransform = "translateY(" + this._yOffset + "px)";
        this._mainBody.style.transform = "translateY(" + this._yOffset + "px)";
        var positionScalar = GameUtils_1.GameUtils.normalize(this._yOffset, 0, this._minYDrag);
        this._scrollBar.moveBarObject(1 - positionScalar);
    };
    HTMLPageComponent.prototype.replaceImages = function () {
        var images = this._mainBody.getElementsByTagName('img');
        var originalPath = '';
        for (var i = 0; i < images.length; i++) {
            var image = images[i];
            originalPath = image.getAttribute('src').replace('./', '');
            var imageResource = this.resources.getDevicePathForResource(this._resourcesPath + originalPath);
            image.setAttribute('src', imageResource);
        }
    };
    HTMLPageComponent.prototype.resizeHTML = function () {
        var scale = parseFloat(this._gameCanvas.style.width) / this.resolutionManager.resolution.width;
        this._mainContainer.style.webkitTransform = "scale(" + scale + ")";
        this._mainContainer.style.transform = "scale(" + scale + ")";
        this._mainContainer.style.top = this._uiStageOffsetY * scale + "px";
        this._mainContainer.style.marginLeft = "" + this._gameCanvas.style.marginLeft;
        this._mainContainer.style.marginTop = "" + this._gameCanvas.style.marginTop;
    };
    HTMLPageComponent.prototype.goToPage = function (id) {
        // TODO: If time,
        // Maybe implement as a regular HTML goto.
    };
    Object.defineProperty(HTMLPageComponent.prototype, "container", {
        get: function () {
            return this._container;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HTMLPageComponent.prototype, "mainContainer", {
        get: function () {
            return this._mainContainer;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(HTMLPageComponent.prototype, "mainBody", {
        get: function () {
            return this._mainBody;
        },
        enumerable: true,
        configurable: true
    });
    return HTMLPageComponent;
}());
exports.HTMLPageComponent = HTMLPageComponent;


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Easing_1 = __webpack_require__(16);
var GameUtils_1 = __webpack_require__(26);
var DragComponent = /** @class */ (function () {
    function DragComponent(updateManager, draggingContainer, interactiveContainer, isMobile) {
        this._maxAcceleration = 900;
        this._baseYPosition = 0;
        this._baseXPosition = 0;
        // TODO: Needs to check PPI / DPI
        this._maxYDrag = 300;
        this._minYDrag = -300;
        this._maxXDrag = 0;
        this._minXDrag = 0;
        this._interactionContainerBasePositionY = 0;
        this._interactionMaxYDrag = 300;
        this._interactionMinYDrag = -300;
        this._interactionMaxXDrag = 0;
        this._interactionMinXDrag = 0;
        this._restoreOnDragEnd = false;
        this._endDragTweenDuration = 500;
        this._endDragTweenEasing = Easing_1.Easing.Cubic.Out;
        this._lastDragMoveYPosition = 0;
        this._lastDragMoveXPosition = 0;
        this._listeningComponents = [];
        this._controllingComponents = [];
        // private _scroll: MouseWheelEvent;
        this._updateInteractiveContainerPosition = true;
        this._updateManager = updateManager;
        this._targetContainer = draggingContainer;
        this._interactionContainer = interactiveContainer;
        this._isMobile = isMobile;
        this.onDragStopBoundFunction = this.onDragStop.bind(this);
        // if (!this._isMobile && this._useMouseScroll) {
        // 	this._scroll = new MouseWheelEvent(interactiveContainer, this.onScroll.bind(this));
        // }
        this.initialize();
    }
    DragComponent.prototype.initialize = function () {
        this._interactionContainer.on('touchstart', this.onDragStart.bind(this));
        this._interactionContainer.on('mousedown', this.onDragStart.bind(this));
    };
    DragComponent.prototype.enable = function () {
        this.canDrag = true;
    };
    DragComponent.prototype.disable = function () {
        this.canDrag = false;
    };
    DragComponent.prototype.onDragStart = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (!this.canDrag) {
            return;
        }
        this.finishDragTween();
        this._containerDragStartY = this._targetContainer.y;
        this._containerDragStartX = this._targetContainer.x;
        this._dragStartY = event.data.global.y;
        this._dragStartX = event.data.global.x;
        var interactionGlobalPos = this._interactionContainer.getGlobalPosition();
        // this._dragStartOffsetPosition = {x: event.data.global.x - this._interactionContainer.x - interactionGlobalPos.x, y: this._dragStartY - this._interactionContainer.y - interactionGlobalPos.y};
        this._dragStartOffsetPosition = {
            x: this._interactionContainer.x - event.data.global.x,
            y: this._interactionContainer.y - this._dragStartY,
        };
        this._dragStartTime = event.data.originalEvent.timeStamp;
        this._lastDragMoveTime = Math.floor(event.data.originalEvent.timeStamp * 0.005);
        this._lastDragMoveYPosition = event.data.global.y;
        this._lastDragMoveXPosition = event.data.global.x;
        // this._interactionContainer.on('touchend', this.onDragStop.bind(this));
        document.addEventListener('touchend', this.onDragStopBoundFunction);
        // this._interactionContainer.on('touchcancel', this.onDragStop.bind(this));
        document.addEventListener('touchcancel', this.onDragStopBoundFunction);
        // this._interactionContainer.on('touchendoutside', this.onDragStop.bind(this));
        this._interactionContainer.on('touchmove', this.onDragMoveEvent.bind(this));
        this._interactionContainer.on('mousemove', this.onDragMoveEvent.bind(this));
        // this._interactionContainer.on('mouseup', this.onDragStop.bind(this));
        document.addEventListener('mouseup', this.onDragStopBoundFunction);
        // this._interactionContainer.on('mouseout', this.onDragStop.bind(this));
        if (this.isMobile) {
        }
        else {
            // this._interactionContainer.on('rightup', this.onDragStop.bind(this));
            document.addEventListener('rightup', this.onDragStopBoundFunction);
        }
        this.draggingStarted(event);
    };
    DragComponent.prototype.finishDragTween = function () {
        if (this._endDragTween && this._endDragTween.isPlaying) {
            this._endDragTween.stop();
            this._endDragTween = null;
        }
    };
    DragComponent.prototype.onDragStop = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (!this.isDragging) {
            return;
        }
        this.draggingFinished();
    };
    DragComponent.prototype.onForceStopDrag = function () {
        if (!this.isDragging) {
            return;
        }
        this.draggingFinished();
    };
    DragComponent.prototype.onCancelDrag = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (!this.isDragging) {
            return;
        }
    };
    DragComponent.prototype.onDragMoveEvent = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var deltaY = event.data.global.y - this._dragStartY;
        var deltaX = event.data.global.x - this._dragStartX;
        var currentTime = Math.floor(event.data.originalEvent.timeStamp * 0.005);
        if (currentTime > this._lastDragMoveTime) {
            this._lastDragMoveTime = currentTime;
            this._lastDragMoveYPosition = event.data.global.y;
            this._lastDragMoveXPosition = event.data.global.x;
        }
        if (!this._updateInteractiveContainerPosition) {
            var newY = Math.max(Math.min(deltaY + this._containerDragStartY, this._maxYDrag), this._minYDrag);
            var newX = Math.max(Math.min(deltaX + this._containerDragStartX, this._maxXDrag), this._minXDrag);
            this.updateDraggingContainer(newY, newX, 0);
        }
        this.updateInteractiveContainer(event.data.global.y, event.data.global.x, 0);
    };
    DragComponent.prototype.updateInteractiveContainer = function (y, x, fraction) {
        if (this._updateInteractiveContainerPosition) {
            y = y + this._dragStartOffsetPosition.y;
            var fractY = Math.max(0, Math.min(1, GameUtils_1.GameUtils.normalize(y, this._interactionMaxYDrag, this._interactionMinYDrag)));
            var newY = GameUtils_1.GameUtils.lerp(this._interactionMinYDrag, this._interactionMaxYDrag, fractY);
            this._interactionContainer.y = newY;
            // this._interactionContainer.x = fractX;
            var targetNewY = GameUtils_1.GameUtils.lerp(this._minYDrag, this._maxYDrag, 1 - fractY);
            // const targetNewX: number = GameUtils.lerp(this._minXDrag, this._maxXDrag, 0);
            var targetNewX = Math.max(Math.min(x - this._dragStartX + this._containerDragStartX, this._maxXDrag), this._minXDrag);
            this.updateDraggingContainer(targetNewY, targetNewX, 0);
        }
    };
    DragComponent.prototype.clearListeners = function () {
        // this._interactionContainer.removeListener('touchend');
        document.removeEventListener('touchend', this.onDragStopBoundFunction);
        // this._interactionContainer.removeListener('touchendoutside');
        this._interactionContainer.removeListener('touchmove');
        // this._interactionContainer.removeListener('touchcancel');
        document.removeEventListener('touchcancel', this.onDragStopBoundFunction);
        this._interactionContainer.removeListener('mousemove');
        // this._interactionContainer.removeListener('mouseup');
        document.removeEventListener('mouseup', this.onDragStopBoundFunction);
        // this._interactionContainer.removeListener('mouseout');
        if (this._isMobile) {
        }
        else {
            // this._interactionContainer.removeListener('rightup');
            document.removeEventListener('rightup', this.onDragStopBoundFunction);
        }
    };
    DragComponent.prototype.draggingStarted = function (event) {
        this.isDragging = true;
    };
    DragComponent.prototype.draggingFinished = function () {
        this.clearListeners();
        this._dragStartX = null;
        this._dragStartY = null;
    };
    DragComponent.prototype.updateDraggingContainer = function (newPositionY, newPositionX, fraction) {
        this._targetContainer.y = newPositionY;
        // this._targetContainer.x = newPositionX;
        var fractX = GameUtils_1.GameUtils.normalize(newPositionX, this._maxXDrag, this._minXDrag);
        var fractY = GameUtils_1.GameUtils.normalize(newPositionY, this._maxYDrag, this._minYDrag);
        var data = { x: newPositionX, y: newPositionY, fractX: fractX, fractY: fractY };
        this.updateListeners(data);
    };
    DragComponent.prototype.updateListeners = function (data) {
        // tslint:disable-next-line: prefer-for-of
        for (var item = 0; item < this._listeningComponents.length; item++) {
            var component = this._listeningComponents[item];
            component.updateFromController(data);
            // }
        }
    };
    DragComponent.prototype.addlisteningComponent = function (component) {
        if (typeof component !== 'object') {
            // console.log('Not a valid component. Needs to be of type object.');
            return;
        }
        this.bindListener(component);
    };
    DragComponent.prototype.bindListener = function (object) {
        this._listeningComponents.push(object);
    };
    DragComponent.prototype.unbindListener = function (object) {
        var index = this._listeningComponents.indexOf(object);
        this._listeningComponents.splice(index, 1);
    };
    DragComponent.prototype.removeListeningComponent = function (component) {
        if (typeof component !== 'object' || this._listeningComponents.indexOf(component) === -1) {
            return false;
        }
        var index = this._listeningComponents.indexOf(component);
        this._listeningComponents.splice(index, 1);
        return true;
    };
    DragComponent.prototype.addControllerComponent = function (component) {
        if (typeof component !== 'object') {
            return;
        }
        component.bindListener.bind(this);
        this._controllingComponents.push(component);
    };
    DragComponent.prototype.removeControllerComponent = function (component) {
        if (typeof component !== 'object' || this._controllingComponents.indexOf(component) === -1) {
            return false;
        }
        var index = this._controllingComponents.indexOf(component);
        component.unbindListener(this);
        this._controllingComponents.splice(index, 1);
        return true;
    };
    DragComponent.prototype.updateFromController = function (data) { };
    DragComponent.prototype.onScroll = function (delta) {
        var newPosY = Math.max(Math.min(this._targetContainer.y - delta.y, this._maxYDrag), this._minYDrag);
        var newPosX = Math.max(Math.min(this._targetContainer.x + delta.x, this._maxXDrag), this._minXDrag);
        this.finishDragTween();
        this.updateDraggingContainer(newPosY, newPosX, 0);
    };
    DragComponent.prototype.resetPosition = function () {
        this._interactionContainer.y = this.interactiveContainerBasePositionY;
        // this._targetContainer.y = this._baseYPosition;
    };
    Object.defineProperty(DragComponent.prototype, "interactiveContainerBasePositionY", {
        get: function () {
            return this._interactionContainerBasePositionY;
        },
        set: function (v) {
            this._interactionContainerBasePositionY = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DragComponent.prototype, "isDragging", {
        get: function () {
            return this._isDragging;
        },
        set: function (v) {
            this._isDragging = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DragComponent.prototype, "canDrag", {
        get: function () {
            return this._canDrag;
        },
        set: function (v) {
            this._canDrag = this._interactionContainer.interactive = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DragComponent.prototype, "isMobile", {
        get: function () {
            return this._isMobile;
        },
        set: function (value) {
            this._isMobile = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DragComponent.prototype, "updateManager", {
        get: function () {
            return this._updateManager;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DragComponent.prototype, "baseYPosition", {
        set: function (posY) {
            this._baseYPosition = posY;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DragComponent.prototype, "baseXPosition", {
        set: function (posX) {
            this._baseXPosition = posX;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DragComponent.prototype, "interactionMinY", {
        set: function (pos) {
            this._interactionMinYDrag = pos;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DragComponent.prototype, "interactionMinX", {
        set: function (pos) {
            this._interactionMinXDrag = pos;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DragComponent.prototype, "interactionMaxY", {
        set: function (pos) {
            this._interactionMaxYDrag = pos;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DragComponent.prototype, "interactionMaxX", {
        set: function (pos) {
            this._interactionMaxXDrag = pos;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DragComponent.prototype, "minY", {
        set: function (pos) {
            this._minYDrag = pos;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DragComponent.prototype, "minX", {
        set: function (pos) {
            this._minXDrag = pos;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DragComponent.prototype, "maxY", {
        set: function (pos) {
            this._maxYDrag = pos;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DragComponent.prototype, "maxX", {
        set: function (pos) {
            this._maxXDrag = pos;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DragComponent.prototype, "endDragTweenEasing", {
        set: function (easing) {
            this._endDragTweenEasing = easing;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DragComponent.prototype, "endDragTweenDuration", {
        set: function (duration) {
            this._endDragTweenDuration = duration;
        },
        enumerable: true,
        configurable: true
    });
    DragComponent.RESTORE_ANIMATION_DURATION = 200;
    return DragComponent;
}());
exports.DragComponent = DragComponent;


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var StaticStrings = /** @class */ (function () {
    function StaticStrings() {
    }
    StaticStrings.updateBrowser = function (locale) {
        return StaticStrings.GetValidLocaleString(StaticStrings._g_please_update_browser, locale);
    };
    StaticStrings.hardwareAcceleration = function (locale) {
        return StaticStrings.GetValidLocaleString(StaticStrings._g_please_enable_hardware_acceleration, locale);
    };
    StaticStrings.optimizedForChrome = function (locale) {
        return StaticStrings.GetValidLocaleString(StaticStrings._g_optimized_for_chrome, locale);
    };
    StaticStrings.switchBrowser = function (locale) {
        return StaticStrings.GetValidLocaleString(StaticStrings._g_please_switch_browser, locale);
    };
    StaticStrings.prettyLocale = function (locale) {
        if (typeof locale === 'string') {
            return locale.toLowerCase();
        }
        return 'en';
    };
    StaticStrings.GetValidLocaleString = function (stringMap, locale) {
        return stringMap.hasOwnProperty(StaticStrings.prettyLocale(locale)) ? stringMap[StaticStrings.prettyLocale(locale)] : stringMap.en;
    };
    StaticStrings._g_please_switch_browser = {
        en: 'Please switch browser. This one is not supported.',
        sv: 'Var snäll och byt webbläsare. Den nuvarande stöds ej.',
    };
    StaticStrings._g_please_update_browser = {
        cs: 'Aktualizujte prosím prohlížeč pro lepší výkon.',
        ru: 'Пожалуйста, обновити версию браузера для улучшения производительности.',
        el: 'Ενημερώστε το πρόγραμμα περιήγησης για καλύτερη απόδοση.',
        id: 'Perbarui browser untuk kinerja yang lebih baik.',
        nl: 'Werk de browser bij voor betere prestaties.',
        pt: 'Por favor, atualize o navegador para um melhor desempenho.',
        sl: 'Za boljše delovanje posodobite brskalnik.',
        hr: 'Ažurirajte preglednik za bolje performanse.',
        no: 'Oppdater nettleseren for bedre ytelse.',
        'pt-BR': 'Por favor, atualize o navegador para um melhor desempenho.',
        de: 'Bitte aktualisieren Sie den Browser für eine bessere Leistung.',
        bg: 'Моля, актуализирайте браузъра за по-добра производителност.',
        ja: 'パフォーマンスを向上させるには、ブラウザを更新してください。',
        th: 'โปรดอัปเดตเบราว์เซอร์เพื่อประสิทธิภาพที่ดีขึ้น',
        pl: 'Zaktualizuj przeglądarkę, aby uzyskać lepszą wydajność.',
        es: 'Actualice el navegador para un mejor rendimiento.',
        fr: 'Veuillez mettre à jour votre navigateur pour de meilleures performances.',
        ko: '더 나은 성능을 위해 브라우저를 업데이트하십시오.',
        vi: 'Vui lòng cập nhật trình duyệt để có hiệu suất tốt hơn.',
        lv: 'Lai uzlabotu veiktspēju, lūdzu, atjauniniet pārlūku.',
        lt: 'Norėdami pagerinti našumą, atnaujinkite naršyklę.',
        fi: 'Päivitä selain suorituskyvyn parantamiseksi.',
        hu: 'Kérjük, frissítse a böngészőt a jobb teljesítmény érdekében.',
        en: 'Please update browser for better performance.',
        sk: 'Aktualizujte prehliadač, aby ste dosiahli lepší výkon.',
        it: 'Aggiorna il browser per prestazioni migliori.',
        da: 'Opdater browseren for bedre ydelse.',
        sv: 'Uppdatera webbläsaren för bättre prestanda.',
        tr: 'Lütfen daha iyi performans için tarayıcıyı güncelleyin.',
        'zh-cn': '请开启硬件加速以更流畅的运行游戏。',
        'zh-tw': '請開啟硬件加速以更流暢的運行遊戲。',
    };
    StaticStrings._g_please_enable_hardware_acceleration = {
        cs: 'Chcete-li dosáhnout lepšího výkonu hry, povolte hardwarovou akceleraci.',
        ru: 'Пожалуйста, включите поддержку аппаратного ускорения в браузере для улучшения производительнсти.',
        el: 'Ενεργοποιήστε την επιτάχυνση υλικού για καλύτερη απόδοση του παιχνιδιού.',
        id: 'Harap aktifkan akselerasi perangkat keras untuk kinerja game yang lebih baik.',
        nl: 'Schakel hardwareversnelling in voor betere spelprestaties.',
        pt: 'Por favor, ative a aceleração de hardware para um melhor desempenho do jogo.',
        sl: 'Za boljše delovanje igre omogočite pospeševanje strojne opreme.',
        hr: 'Omogućite hardversko ubrzanje za bolje performanse igre.',
        no: 'Aktiver maskinvareakselerasjon for bedre spillytelse.',
        'pt-br': 'Por favor, ative a aceleração de hardware para um melhor desempenho do jogo.',
        de: 'Aktivieren Sie die Hardwarebeschleunigung für eine bessere Spieleleistung.',
        bg: 'Моля, активирайте хардуерното ускорение за по-добра производителност на играта.',
        ja: 'ゲームのパフォーマンスを向上させるには、ハードウェアアクセラレーションを有効にしてください。',
        th: 'โปรดเปิดใช้งานการเร่งด้วยฮาร์ดแวร์เพื่อประสิทธิภาพของเกมที่ดีขึ้น',
        pl: 'Włącz przyspieszenie sprzętowe, aby uzyskać lepszą wydajność gry.',
        es: 'Habilite la aceleración de hardware para un mejor rendimiento del juego.',
        fr: "Veuillez activer l'accélération matérielle pour améliorer les performances du jeu.",
        ko: '더 나은 성능을 위해 브라우저를 업데이트하십시오.',
        vi: 'Vui lòng kích hoạt tăng tốc phần cứng để có hiệu suất trò chơi tốt hơn.',
        lv: 'Lūdzu, iespējojiet aparatūras paātrinājumu, lai spēle būtu labāka.',
        lt: 'Prašome įgalinti aparatinės įrangos pagreitį, kad žaidimas būtų geresnis.',
        fi: 'Ota käyttöön laitteistokiihdytys pelin suorituskyvyn parantamiseksi.',
        hu: 'A játék jobb teljesítményéhez engedélyezze a hardveres gyorsítást.',
        en: 'Please enable hardware acceleration for better game performance.',
        sk: 'Ak chcete dosiahnuť lepší výkon hry, povoľte hardvérovú akceleráciu.',
        it: "Abilitare l'accelerazione hardware per migliorare le prestazioni del gioco.",
        da: 'Aktivér hardwareacceleration for bedre spilydelse.',
        sv: 'Aktivera maskinvaru-acceleration för bättre spelprestanda.',
        tr: 'Lütfen daha iyi oyun performansı için donanım ivmesini etkinleştirin.',
        'zh-cn': '请更新你的浏览器以更流畅的运行游戏。',
        'zh-tw': '請更新你的瀏覽器以更流暢的運行遊戲。',
    };
    StaticStrings._g_optimized_for_chrome = {
        cs: 'Tato hra byla optimalizována pro hraní v Chromu.',
        ru: 'Игра оптимизирована для работы в браузере Chrome.',
        el: 'Αυτό το παιχνίδι έχει βελτιστοποιηθεί για αναπαραγωγή στο Chrome.',
        id: 'Game ini telah dioptimalkan untuk dimainkan di Chrome.',
        nl: 'Deze game is geoptimaliseerd om in Chrome te worden gespeeld.',
        pt: 'Este jogo foi otimizado para ser jogado no Chrome.',
        sl: 'Ta igra je bila optimizirana za igranje v Chromu.',
        hr: 'Ova je igra optimizirana za igranje u Chromeu.',
        no: 'Dette spillet er optimalisert for å bli spilt i Chrome.',
        'pt-br': 'Este jogo foi otimizado para ser jogado no Chrome.',
        de: 'Dieses Spiel wurde für Chrome optimiert.',
        bg: 'Тази игра е оптимизирана за игра в Chrome.',
        ja: 'このゲームは、Chromeでプレイできるように最適化されています。',
        th: 'เกมนี้ได้รับการปรับให้เล่นใน Chrome ได้ดีที่สุด',
        pl: 'Ta gra została zoptymalizowana pod kątem grania w Chrome.',
        es: 'Este juego ha sido optimizado para jugarse en Chrome.',
        fr: 'Ce jeu a été optimisé pour être joué dans Chrome.',
        ko: '이 게임은 Chrome에서 재생되도록 최적화되었습니다.',
        vi: 'Trò chơi này đã được tối ưu hóa để chơi trong Chrome.',
        lv: 'Šī spēle ir optimizēta spēlēšanai pārlūkā Chrome.',
        lt: 'Šis žaidimas buvo optimizuotas žaisti „Chrome“.',
        fi: 'Tämä peli on optimoitu pelaamaan Chromessa.',
        hu: 'Ezt a játékot úgy optimalizálták, hogy a Chrome-ban játszhassa.',
        en: 'This game has been optimized to be played in Chrome.',
        sk: 'Táto hra bola optimalizovaná na hranie v prehliadači Chrome.',
        it: 'Questo gioco è stato ottimizzato per essere giocato in Chrome.',
        da: 'Dette spil er optimeret til at blive spillet i Chrome.',
        sv: 'Detta spel har optimerats för att spelas i Chrome.',
        tr: "Bu oyun Chrome'da oynanacak şekilde optimize edilmiştir.",
        'zh-cn': '本游戏在谷歌浏览器运行最优。',
        'zh-tw': '本遊戲在谷歌瀏覽器運行最優。',
    };
    return StaticStrings;
}());
exports.StaticStrings = StaticStrings;


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/* Web Font Loader v1.6.28 - (c) Adobe Systems, Google. License: Apache 2.0 */(function(){function aa(a,b,c){return a.call.apply(a.bind,arguments)}function ba(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}}function p(a,b,c){p=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?aa:ba;return p.apply(null,arguments)}var q=Date.now||function(){return+new Date};function ca(a,b){this.a=a;this.o=b||a;this.c=this.o.document}var da=!!window.FontFace;function t(a,b,c,d){b=a.c.createElement(b);if(c)for(var e in c)c.hasOwnProperty(e)&&("style"==e?b.style.cssText=c[e]:b.setAttribute(e,c[e]));d&&b.appendChild(a.c.createTextNode(d));return b}function u(a,b,c){a=a.c.getElementsByTagName(b)[0];a||(a=document.documentElement);a.insertBefore(c,a.lastChild)}function v(a){a.parentNode&&a.parentNode.removeChild(a)}
function w(a,b,c){b=b||[];c=c||[];for(var d=a.className.split(/\s+/),e=0;e<b.length;e+=1){for(var f=!1,g=0;g<d.length;g+=1)if(b[e]===d[g]){f=!0;break}f||d.push(b[e])}b=[];for(e=0;e<d.length;e+=1){f=!1;for(g=0;g<c.length;g+=1)if(d[e]===c[g]){f=!0;break}f||b.push(d[e])}a.className=b.join(" ").replace(/\s+/g," ").replace(/^\s+|\s+$/,"")}function y(a,b){for(var c=a.className.split(/\s+/),d=0,e=c.length;d<e;d++)if(c[d]==b)return!0;return!1}
function ea(a){return a.o.location.hostname||a.a.location.hostname}function z(a,b,c){function d(){m&&e&&f&&(m(g),m=null)}b=t(a,"link",{rel:"stylesheet",href:b,media:"all"});var e=!1,f=!0,g=null,m=c||null;da?(b.onload=function(){e=!0;d()},b.onerror=function(){e=!0;g=Error("Stylesheet failed to load");d()}):setTimeout(function(){e=!0;d()},0);u(a,"head",b)}
function A(a,b,c,d){var e=a.c.getElementsByTagName("head")[0];if(e){var f=t(a,"script",{src:b}),g=!1;f.onload=f.onreadystatechange=function(){g||this.readyState&&"loaded"!=this.readyState&&"complete"!=this.readyState||(g=!0,c&&c(null),f.onload=f.onreadystatechange=null,"HEAD"==f.parentNode.tagName&&e.removeChild(f))};e.appendChild(f);setTimeout(function(){g||(g=!0,c&&c(Error("Script load timeout")))},d||5E3);return f}return null};function B(){this.a=0;this.c=null}function C(a){a.a++;return function(){a.a--;D(a)}}function E(a,b){a.c=b;D(a)}function D(a){0==a.a&&a.c&&(a.c(),a.c=null)};function F(a){this.a=a||"-"}F.prototype.c=function(a){for(var b=[],c=0;c<arguments.length;c++)b.push(arguments[c].replace(/[\W_]+/g,"").toLowerCase());return b.join(this.a)};function G(a,b){this.c=a;this.f=4;this.a="n";var c=(b||"n4").match(/^([nio])([1-9])$/i);c&&(this.a=c[1],this.f=parseInt(c[2],10))}function fa(a){return H(a)+" "+(a.f+"00")+" 300px "+I(a.c)}function I(a){var b=[];a=a.split(/,\s*/);for(var c=0;c<a.length;c++){var d=a[c].replace(/['"]/g,"");-1!=d.indexOf(" ")||/^\d/.test(d)?b.push("'"+d+"'"):b.push(d)}return b.join(",")}function J(a){return a.a+a.f}function H(a){var b="normal";"o"===a.a?b="oblique":"i"===a.a&&(b="italic");return b}
function ga(a){var b=4,c="n",d=null;a&&((d=a.match(/(normal|oblique|italic)/i))&&d[1]&&(c=d[1].substr(0,1).toLowerCase()),(d=a.match(/([1-9]00|normal|bold)/i))&&d[1]&&(/bold/i.test(d[1])?b=7:/[1-9]00/.test(d[1])&&(b=parseInt(d[1].substr(0,1),10))));return c+b};function ha(a,b){this.c=a;this.f=a.o.document.documentElement;this.h=b;this.a=new F("-");this.j=!1!==b.events;this.g=!1!==b.classes}function ia(a){a.g&&w(a.f,[a.a.c("wf","loading")]);K(a,"loading")}function L(a){if(a.g){var b=y(a.f,a.a.c("wf","active")),c=[],d=[a.a.c("wf","loading")];b||c.push(a.a.c("wf","inactive"));w(a.f,c,d)}K(a,"inactive")}function K(a,b,c){if(a.j&&a.h[b])if(c)a.h[b](c.c,J(c));else a.h[b]()};function ja(){this.c={}}function ka(a,b,c){var d=[],e;for(e in b)if(b.hasOwnProperty(e)){var f=a.c[e];f&&d.push(f(b[e],c))}return d};function M(a,b){this.c=a;this.f=b;this.a=t(this.c,"span",{"aria-hidden":"true"},this.f)}function N(a){u(a.c,"body",a.a)}function O(a){return"display:block;position:absolute;top:-9999px;left:-9999px;font-size:300px;width:auto;height:auto;line-height:normal;margin:0;padding:0;font-variant:normal;white-space:nowrap;font-family:"+I(a.c)+";"+("font-style:"+H(a)+";font-weight:"+(a.f+"00")+";")};function P(a,b,c,d,e,f){this.g=a;this.j=b;this.a=d;this.c=c;this.f=e||3E3;this.h=f||void 0}P.prototype.start=function(){var a=this.c.o.document,b=this,c=q(),d=new Promise(function(d,e){function f(){q()-c>=b.f?e():a.fonts.load(fa(b.a),b.h).then(function(a){1<=a.length?d():setTimeout(f,25)},function(){e()})}f()}),e=null,f=new Promise(function(a,d){e=setTimeout(d,b.f)});Promise.race([f,d]).then(function(){e&&(clearTimeout(e),e=null);b.g(b.a)},function(){b.j(b.a)})};function Q(a,b,c,d,e,f,g){this.v=a;this.B=b;this.c=c;this.a=d;this.s=g||"BESbswy";this.f={};this.w=e||3E3;this.u=f||null;this.m=this.j=this.h=this.g=null;this.g=new M(this.c,this.s);this.h=new M(this.c,this.s);this.j=new M(this.c,this.s);this.m=new M(this.c,this.s);a=new G(this.a.c+",serif",J(this.a));a=O(a);this.g.a.style.cssText=a;a=new G(this.a.c+",sans-serif",J(this.a));a=O(a);this.h.a.style.cssText=a;a=new G("serif",J(this.a));a=O(a);this.j.a.style.cssText=a;a=new G("sans-serif",J(this.a));a=
O(a);this.m.a.style.cssText=a;N(this.g);N(this.h);N(this.j);N(this.m)}var R={D:"serif",C:"sans-serif"},S=null;function T(){if(null===S){var a=/AppleWebKit\/([0-9]+)(?:\.([0-9]+))/.exec(window.navigator.userAgent);S=!!a&&(536>parseInt(a[1],10)||536===parseInt(a[1],10)&&11>=parseInt(a[2],10))}return S}Q.prototype.start=function(){this.f.serif=this.j.a.offsetWidth;this.f["sans-serif"]=this.m.a.offsetWidth;this.A=q();U(this)};
function la(a,b,c){for(var d in R)if(R.hasOwnProperty(d)&&b===a.f[R[d]]&&c===a.f[R[d]])return!0;return!1}function U(a){var b=a.g.a.offsetWidth,c=a.h.a.offsetWidth,d;(d=b===a.f.serif&&c===a.f["sans-serif"])||(d=T()&&la(a,b,c));d?q()-a.A>=a.w?T()&&la(a,b,c)&&(null===a.u||a.u.hasOwnProperty(a.a.c))?V(a,a.v):V(a,a.B):ma(a):V(a,a.v)}function ma(a){setTimeout(p(function(){U(this)},a),50)}function V(a,b){setTimeout(p(function(){v(this.g.a);v(this.h.a);v(this.j.a);v(this.m.a);b(this.a)},a),0)};function W(a,b,c){this.c=a;this.a=b;this.f=0;this.m=this.j=!1;this.s=c}var X=null;W.prototype.g=function(a){var b=this.a;b.g&&w(b.f,[b.a.c("wf",a.c,J(a).toString(),"active")],[b.a.c("wf",a.c,J(a).toString(),"loading"),b.a.c("wf",a.c,J(a).toString(),"inactive")]);K(b,"fontactive",a);this.m=!0;na(this)};
W.prototype.h=function(a){var b=this.a;if(b.g){var c=y(b.f,b.a.c("wf",a.c,J(a).toString(),"active")),d=[],e=[b.a.c("wf",a.c,J(a).toString(),"loading")];c||d.push(b.a.c("wf",a.c,J(a).toString(),"inactive"));w(b.f,d,e)}K(b,"fontinactive",a);na(this)};function na(a){0==--a.f&&a.j&&(a.m?(a=a.a,a.g&&w(a.f,[a.a.c("wf","active")],[a.a.c("wf","loading"),a.a.c("wf","inactive")]),K(a,"active")):L(a.a))};function oa(a){this.j=a;this.a=new ja;this.h=0;this.f=this.g=!0}oa.prototype.load=function(a){this.c=new ca(this.j,a.context||this.j);this.g=!1!==a.events;this.f=!1!==a.classes;pa(this,new ha(this.c,a),a)};
function qa(a,b,c,d,e){var f=0==--a.h;(a.f||a.g)&&setTimeout(function(){var a=e||null,m=d||null||{};if(0===c.length&&f)L(b.a);else{b.f+=c.length;f&&(b.j=f);var h,l=[];for(h=0;h<c.length;h++){var k=c[h],n=m[k.c],r=b.a,x=k;r.g&&w(r.f,[r.a.c("wf",x.c,J(x).toString(),"loading")]);K(r,"fontloading",x);r=null;if(null===X)if(window.FontFace){var x=/Gecko.*Firefox\/(\d+)/.exec(window.navigator.userAgent),xa=/OS X.*Version\/10\..*Safari/.exec(window.navigator.userAgent)&&/Apple/.exec(window.navigator.vendor);
X=x?42<parseInt(x[1],10):xa?!1:!0}else X=!1;X?r=new P(p(b.g,b),p(b.h,b),b.c,k,b.s,n):r=new Q(p(b.g,b),p(b.h,b),b.c,k,b.s,a,n);l.push(r)}for(h=0;h<l.length;h++)l[h].start()}},0)}function pa(a,b,c){var d=[],e=c.timeout;ia(b);var d=ka(a.a,c,a.c),f=new W(a.c,b,e);a.h=d.length;b=0;for(c=d.length;b<c;b++)d[b].load(function(b,d,c){qa(a,f,b,d,c)})};function ra(a,b){this.c=a;this.a=b}
ra.prototype.load=function(a){function b(){if(f["__mti_fntLst"+d]){var c=f["__mti_fntLst"+d](),e=[],h;if(c)for(var l=0;l<c.length;l++){var k=c[l].fontfamily;void 0!=c[l].fontStyle&&void 0!=c[l].fontWeight?(h=c[l].fontStyle+c[l].fontWeight,e.push(new G(k,h))):e.push(new G(k))}a(e)}else setTimeout(function(){b()},50)}var c=this,d=c.a.projectId,e=c.a.version;if(d){var f=c.c.o;A(this.c,(c.a.api||"https://fast.fonts.net/jsapi")+"/"+d+".js"+(e?"?v="+e:""),function(e){e?a([]):(f["__MonotypeConfiguration__"+
d]=function(){return c.a},b())}).id="__MonotypeAPIScript__"+d}else a([])};function sa(a,b){this.c=a;this.a=b}sa.prototype.load=function(a){var b,c,d=this.a.urls||[],e=this.a.families||[],f=this.a.testStrings||{},g=new B;b=0;for(c=d.length;b<c;b++)z(this.c,d[b],C(g));var m=[];b=0;for(c=e.length;b<c;b++)if(d=e[b].split(":"),d[1])for(var h=d[1].split(","),l=0;l<h.length;l+=1)m.push(new G(d[0],h[l]));else m.push(new G(d[0]));E(g,function(){a(m,f)})};function ta(a,b){a?this.c=a:this.c=ua;this.a=[];this.f=[];this.g=b||""}var ua="https://fonts.googleapis.com/css";function va(a,b){for(var c=b.length,d=0;d<c;d++){var e=b[d].split(":");3==e.length&&a.f.push(e.pop());var f="";2==e.length&&""!=e[1]&&(f=":");a.a.push(e.join(f))}}
function wa(a){if(0==a.a.length)throw Error("No fonts to load!");if(-1!=a.c.indexOf("kit="))return a.c;for(var b=a.a.length,c=[],d=0;d<b;d++)c.push(a.a[d].replace(/ /g,"+"));b=a.c+"?family="+c.join("%7C");0<a.f.length&&(b+="&subset="+a.f.join(","));0<a.g.length&&(b+="&text="+encodeURIComponent(a.g));return b};function ya(a){this.f=a;this.a=[];this.c={}}
var za={latin:"BESbswy","latin-ext":"\u00e7\u00f6\u00fc\u011f\u015f",cyrillic:"\u0439\u044f\u0416",greek:"\u03b1\u03b2\u03a3",khmer:"\u1780\u1781\u1782",Hanuman:"\u1780\u1781\u1782"},Aa={thin:"1",extralight:"2","extra-light":"2",ultralight:"2","ultra-light":"2",light:"3",regular:"4",book:"4",medium:"5","semi-bold":"6",semibold:"6","demi-bold":"6",demibold:"6",bold:"7","extra-bold":"8",extrabold:"8","ultra-bold":"8",ultrabold:"8",black:"9",heavy:"9",l:"3",r:"4",b:"7"},Ba={i:"i",italic:"i",n:"n",normal:"n"},
Ca=/^(thin|(?:(?:extra|ultra)-?)?light|regular|book|medium|(?:(?:semi|demi|extra|ultra)-?)?bold|black|heavy|l|r|b|[1-9]00)?(n|i|normal|italic)?$/;
function Da(a){for(var b=a.f.length,c=0;c<b;c++){var d=a.f[c].split(":"),e=d[0].replace(/\+/g," "),f=["n4"];if(2<=d.length){var g;var m=d[1];g=[];if(m)for(var m=m.split(","),h=m.length,l=0;l<h;l++){var k;k=m[l];if(k.match(/^[\w-]+$/)){var n=Ca.exec(k.toLowerCase());if(null==n)k="";else{k=n[2];k=null==k||""==k?"n":Ba[k];n=n[1];if(null==n||""==n)n="4";else var r=Aa[n],n=r?r:isNaN(n)?"4":n.substr(0,1);k=[k,n].join("")}}else k="";k&&g.push(k)}0<g.length&&(f=g);3==d.length&&(d=d[2],g=[],d=d?d.split(","):
g,0<d.length&&(d=za[d[0]])&&(a.c[e]=d))}a.c[e]||(d=za[e])&&(a.c[e]=d);for(d=0;d<f.length;d+=1)a.a.push(new G(e,f[d]))}};function Ea(a,b){this.c=a;this.a=b}var Fa={Arimo:!0,Cousine:!0,Tinos:!0};Ea.prototype.load=function(a){var b=new B,c=this.c,d=new ta(this.a.api,this.a.text),e=this.a.families;va(d,e);var f=new ya(e);Da(f);z(c,wa(d),C(b));E(b,function(){a(f.a,f.c,Fa)})};function Ga(a,b){this.c=a;this.a=b}Ga.prototype.load=function(a){var b=this.a.id,c=this.c.o;b?A(this.c,(this.a.api||"https://use.typekit.net")+"/"+b+".js",function(b){if(b)a([]);else if(c.Typekit&&c.Typekit.config&&c.Typekit.config.fn){b=c.Typekit.config.fn;for(var e=[],f=0;f<b.length;f+=2)for(var g=b[f],m=b[f+1],h=0;h<m.length;h++)e.push(new G(g,m[h]));try{c.Typekit.load({events:!1,classes:!1,async:!0})}catch(l){}a(e)}},2E3):a([])};function Ha(a,b){this.c=a;this.f=b;this.a=[]}Ha.prototype.load=function(a){var b=this.f.id,c=this.c.o,d=this;b?(c.__webfontfontdeckmodule__||(c.__webfontfontdeckmodule__={}),c.__webfontfontdeckmodule__[b]=function(b,c){for(var g=0,m=c.fonts.length;g<m;++g){var h=c.fonts[g];d.a.push(new G(h.name,ga("font-weight:"+h.weight+";font-style:"+h.style)))}a(d.a)},A(this.c,(this.f.api||"https://f.fontdeck.com/s/css/js/")+ea(this.c)+"/"+b+".js",function(b){b&&a([])})):a([])};var Y=new oa(window);Y.a.c.custom=function(a,b){return new sa(b,a)};Y.a.c.fontdeck=function(a,b){return new Ha(b,a)};Y.a.c.monotype=function(a,b){return new ra(b,a)};Y.a.c.typekit=function(a,b){return new Ga(b,a)};Y.a.c.google=function(a,b){return new Ea(b,a)};var Z={load:p(Y.load,Y)}; true?!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return Z}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!==typeof module&&module.exports?module.exports=Z:(window.WebFont=Z,window.WebFontConfig&&Y.load(window.WebFontConfig));}());


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.DESKTOP_VIEWPORT = {
    width: 1920,
    height: 1080,
};
exports.MOBILE_VIEWPORT = {
    width: 1280,
    height: 720,
};


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MicrogamingPreloaderV2_1 = __webpack_require__(238);
var MicrogamingPreloaderUtils_1 = __webpack_require__(239);
var BaseMicrogamingPreloaderView = /** @class */ (function () {
    function BaseMicrogamingPreloaderView() {
        this._loaderBarMaxWidth = 0;
        this._progress = 0;
        this._scaleFactor = 1;
        this._screenH = 0;
        this._screenW = 0;
    }
    BaseMicrogamingPreloaderView.prototype.endLoading = function () {
        while (this._parent.firstChild) {
            this._parent.removeChild(this._parent.firstChild);
        }
    };
    BaseMicrogamingPreloaderView.prototype.updateProgress = function (totalItems, current) {
        this._progress = current / totalItems;
        if (this._progressBar) {
            this._progressBar.style.width = Math.ceil(this._loaderBarMaxWidth * this._progress) + 'px';
        }
    };
    BaseMicrogamingPreloaderView.prototype.resize = function (device) {
        var ow = 0;
        var oh = 0;
        this._screenW = device.isSamsungNative ? window.outerWidth : window.innerWidth;
        this._screenH = device.isSamsungNative ? window.outerHeight : window.innerHeight;
        if (device.isMobile && !device.iOS && !device.isSamsungNative) {
            ow = window.outerWidth;
            oh = window.outerHeight;
            this._scaleFactor = this._screenH / oh;
        }
        if (this._progressBar && this._progressBarBack) {
            this._loaderBarMaxWidth = this._screenW * 0.8;
            var barHeight = 8;
            var progressBarY = 0.8;
            this._progressBar.style.height =
                this._progressBarBack.style.height = Math.ceil(barHeight * this._scaleFactor) + 'px';
            this._progressBar.style.borderRadius =
                this._progressBarBack.style.borderRadius = Math.ceil(barHeight * 0.5 * this._scaleFactor) + 'px';
            this._progressBar.style.left =
                this._progressBarBack.style.left = Math.ceil((this._screenW - this._loaderBarMaxWidth) * 0.5) + 'px';
            this._progressBar.style.top =
                this._progressBarBack.style.top = Math.ceil(this._screenH * progressBarY) + 'px';
            this._progressBarBack.style.width = Math.ceil(this._loaderBarMaxWidth) + 'px';
            this._progressBar.style.width = Math.ceil(this._loaderBarMaxWidth * this._progress) + 'px';
        }
        var divisor = device.isMobile ? 320 : 640;
        var logoScale = Math.max(0.5, Math.min(this._screenW / divisor, 1)) * this._scaleFactor;
        if (this._loadingBackground) {
            this._loadingBackground.style.width = Math.ceil(this._screenW) + 'px';
            this._loadingBackground.style.height = Math.ceil(this._screenH) + 'px';
        }
        if (this._fantasmaLogo) {
            // Putting our brand name first.
            var centerElement = this._fantasmaLogo;
            centerElement.style.transform = "translateX(-50%) translateY(-50%) scale(" + logoScale + ")";
            centerElement.style.maxWidth = this._screenW - 20 + "px";
            centerElement.style.left = Math.ceil(this._screenW * 0.5) + 'px';
            centerElement.style.top = Math.ceil(this._screenH * 0.5) + 'px';
            if (this._publisherLogo) {
                var publisherBrand = this._publisherLogo;
                if (device.isMobile) {
                    publisherBrand.style.transform = "translateX(-50%) translateY(-50%) scale(" + logoScale * 0.25 + ")";
                }
                else {
                    publisherBrand.style.transform = "translateX(-50%) translateY(-50%) scale(" + logoScale * 0.5 + ")";
                }
                publisherBrand.style.left = Math.ceil(this._screenW * 0.5) + 'px';
                publisherBrand.style.top = Math.ceil(this._screenH * 0.15) + 'px';
            }
        }
        else {
            if (this._publisherLogoLandscape && this._publisherLogoPortrait) {
                if (device.isMobile) {
                    this._publisherLogoLandscape.style.transform = "translateX(-50%) translateY(-50%) scale(" + logoScale * 0.5 + ")";
                }
                else {
                    this._publisherLogoLandscape.style.transform = "translateX(-50%) translateY(-50%) scale(" + logoScale + ")";
                }
                this._publisherLogoLandscape.style.left = Math.ceil(this._screenW * 0.5) + 'px';
                this._publisherLogoLandscape.style.top = Math.ceil(this._screenH * 0.5) + 'px';
                this._publisherLogoPortrait.style.transform = "translateX(-50%) translateY(-50%) scale(" + logoScale + ")";
                this._publisherLogoPortrait.style.left = Math.ceil(this._screenW * 0.5) + 'px';
                this._publisherLogoPortrait.style.top = Math.ceil(this._screenH * 0.45) + 'px';
                if (device.isMobile) {
                    this._publisherLogoLandscape.style.display = this._screenW > this._screenH ? null : 'none';
                    this._publisherLogoPortrait.style.display = this._screenW > this._screenH ? 'none' : null;
                }
                else {
                    this._publisherLogoLandscape.style.display = null;
                    this._publisherLogoPortrait.style.display = 'none';
                }
            }
        }
        if (this._gameLogo) {
            this._gameLogo.style.transform = "translateX(-50%) translateY(-50%) scale(" + logoScale / 1.5 + ")";
            this._gameLogo.style.left = Math.ceil(this._screenW * 0.5) + 'px';
            this._gameLogo.style.top = Math.ceil(this._screenH * 0.45) + 'px';
        }
        if (this._disclaimer) {
            this._disclaimer.style.left = Math.ceil(this._screenW * 0.5) + 'px';
            this._disclaimer.style.top = Math.ceil(this._screenH * 0.95) + 'px';
            var maxScale = Math.max(0.1, Math.min(this._screenW / 640, 1)) * this._scaleFactor;
            this._disclaimer.style.transform = "translateX(-50%) translateY(-50%) scale(" + maxScale + ")";
        }
    };
    BaseMicrogamingPreloaderView.prototype.init = function (parent, config, getResourceUrl) {
        this._parent = parent;
        // Non-asian market.
        if (!config.setDesign) {
            // On fallback to Game Brand, don't show this background.
            if (config.hasPublisherSplash) {
                var bg = document.createElement('div');
                bg.style.background = 'radial-gradient(rgb(64, 64, 64), rgb(40, 40, 40), rgb(17, 17, 17))';
                bg.id = 'preloaderBg';
                bg.style.width = '1px';
                bg.style.height = '1px';
                bg.style.position = 'absolute';
                bg.style.top = '0px';
                bg.style.left = '0px';
                this._loadingBackground = bg;
                parent.appendChild(this._loadingBackground);
            }
        }
        if (config.contentRequired.indexOf(MicrogamingPreloaderV2_1.LoaderParts.PUBLISHER_LOGO) > -1) {
            if (config.setDesign) {
                this._publisherLogoLandscape = MicrogamingPreloaderUtils_1.MicrogamingPreloaderUtils.createPublisherLogo('PublisherSplash.jpg', getResourceUrl(config.publisherName + "_PublisherSplash.jpg"), true);
                this._publisherLogoPortrait = MicrogamingPreloaderUtils_1.MicrogamingPreloaderUtils.createPublisherLogo('PublisherSplashPortrait.jpg', getResourceUrl(config.publisherName + "_PublisherSplashPortrait.jpg"), true);
                parent.appendChild(this._publisherLogoPortrait);
                parent.appendChild(this._publisherLogoLandscape);
            }
            else {
                this._publisherLogo = MicrogamingPreloaderUtils_1.MicrogamingPreloaderUtils.createPublisherLogo('logo.png', getResourceUrl('brandFallback.png'), false);
                parent.appendChild(this._publisherLogo);
            }
        }
        if (config.contentRequired.indexOf(MicrogamingPreloaderV2_1.LoaderParts.LOADING_BAR) > -1) {
            this._progressBarBack = MicrogamingPreloaderUtils_1.MicrogamingPreloaderUtils.createBar('meter-bg-container', 'grey', 'translateX(0%) translateY(-50%)');
            parent.appendChild(this._progressBarBack);
            this._progressBar = MicrogamingPreloaderUtils_1.MicrogamingPreloaderUtils.createBar('meter-bg-bar', 'white', 'translateX(0%) translateY(-50%)');
            if (config.loadingBarColor === MicrogamingPreloaderV2_1.LoadingBarColor.MULTI_COLORED) {
                this._progressBar.style.background = 'linear-gradient(0.25turn, #e66465, #9198e5)';
            }
            parent.appendChild(this._progressBar);
        }
        if (config.contentRequired.indexOf(MicrogamingPreloaderV2_1.LoaderParts.GAME) > -1) {
            this._gameLogo = MicrogamingPreloaderUtils_1.MicrogamingPreloaderUtils.createImage('gameLogo');
            this._gameLogo.src = getResourceUrl('GAME_LOGO.png');
            parent.appendChild(this._gameLogo);
        }
        if (config.contentRequired.indexOf(MicrogamingPreloaderV2_1.LoaderParts.STUDIO) > -1) {
            this._fantasmaLogo = MicrogamingPreloaderUtils_1.MicrogamingPreloaderUtils.createImage('studioLogo');
            this._fantasmaLogo.src = getResourceUrl('Fantasma_logo.png');
            parent.appendChild(this._fantasmaLogo);
        }
        if (config.contentRequired.indexOf(MicrogamingPreloaderV2_1.LoaderParts.DISCLAIMER) > -1) {
            this._disclaimer = MicrogamingPreloaderUtils_1.MicrogamingPreloaderUtils.createDisclaimer();
            parent.appendChild(this._disclaimer);
        }
    };
    return BaseMicrogamingPreloaderView;
}());
exports.BaseMicrogamingPreloaderView = BaseMicrogamingPreloaderView;


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var GameSystem_1 = __webpack_require__(236);
var RecodeCurrencyFormatter_1 = __webpack_require__(240);
var CurrencyFormatter_1 = __webpack_require__(72);
var GameResourceLoader_1 = __webpack_require__(237);
var RecodeGameSystem = /** @class */ (function (_super) {
    __extends(RecodeGameSystem, _super);
    function RecodeGameSystem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RecodeGameSystem.prototype.getLocale = function () {
        var lang = window.V.API.Core.getCasinoState().lang;
        return lang.toLowerCase();
    };
    RecodeGameSystem.prototype.createResourceLoader = function (getBaseUrlPath) {
        return new GameResourceLoader_1.GameResourceLoader(this.device, getBaseUrlPath, this.getLocale(), this._majorCaveatPerformance);
    };
    RecodeGameSystem.prototype.createCurrencyFormatter = function () {
        return new RecodeCurrencyFormatter_1.RecodeCurrencyFormatter();
    };
    RecodeGameSystem.prototype.getCurrencyISO = function () {
        var isoCode = window.V.API.Core.getCasinoState().player.currencyIsoCode;
        if (false) {
            if (this._urlParams.customISO) {
                isoCode = this._urlParams.customISO;
                if (this._currencyFormatter) {
                    this._currencyFormatter.setCurrencyData(this._currencyFormatter.parseCurrencyFormatting(isoCode, CurrencyFormatter_1.CurrencyFormatter.CurrenciesDisplayFormat[isoCode]));
                }
            }
        }
        return isoCode;
    };
    return RecodeGameSystem;
}(GameSystem_1.GameSystem));
exports.RecodeGameSystem = RecodeGameSystem;


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(139);
var CoreDI_1 = __webpack_require__(32);
var DI_1 = __webpack_require__(51);
var Settings_1 = __webpack_require__(109);
var Views_1 = __webpack_require__(8);
var CheatModule_1 = __webpack_require__(488);
var BetButtonView_1 = __webpack_require__(492);
var MenuButtonModule_1 = __webpack_require__(493);
var MenuButtonView_1 = __webpack_require__(495);
var StopAutoplayButtonModule_1 = __webpack_require__(496);
var AutoplayMenuView_1 = __webpack_require__(248);
var BetlevelMenuView_1 = __webpack_require__(502);
var GameViewManager_1 = __webpack_require__(506);
var GameViews_1 = __webpack_require__(43);
var ParticleView_1 = __webpack_require__(507);
var RestoreScreenModule_1 = __webpack_require__(511);
var InfoPopupView_1 = __webpack_require__(252);
var SpinButtonView_1 = __webpack_require__(254);
var StopAutoplayButtonView_1 = __webpack_require__(246);
var OrientationModule_1 = __webpack_require__(512);
var LogotypeModule_1 = __webpack_require__(513);
var StatisticsWindowModule_1 = __webpack_require__(514);
var GameRulesModule_1 = __webpack_require__(515);
var PaytableView_1 = __webpack_require__(516);
var GameRulesView_1 = __webpack_require__(519);
var StatisticsWindowView_1 = __webpack_require__(520);
var LogotypeView_1 = __webpack_require__(258);
var GameWinPresentationView_1 = __webpack_require__(260);
var OrientationView_1 = __webpack_require__(255);
var GameAvalancheReelsView_1 = __webpack_require__(157);
var GameAvalancheReelsModule_1 = __webpack_require__(264);
var GameCheatView_1 = __webpack_require__(530);
var GameWinPresentationModule_1 = __webpack_require__(278);
var RespinModule_1 = __webpack_require__(540);
var RespinView_1 = __webpack_require__(280);
var GameFlowModule_1 = __webpack_require__(543);
var GameInfoModule_1 = __webpack_require__(549);
var GameInfoView_1 = __webpack_require__(553);
var GameBackgroundView_1 = __webpack_require__(557);
var GameBackgroundModule_1 = __webpack_require__(93);
var TopReelsModule_1 = __webpack_require__(558);
var TopReelsView_1 = __webpack_require__(564);
var OverTopReelEffectsView_1 = __webpack_require__(566);
var OverTopReelEffectsModule_1 = __webpack_require__(567);
var WildMeterModule_1 = __webpack_require__(568);
var WildMeterView_1 = __webpack_require__(294);
var WinLinesPresentationModule_1 = __webpack_require__(569);
var WinLinesPresentationView_1 = __webpack_require__(570);
var WinFieldModule_1 = __webpack_require__(571);
var WinFieldView_1 = __webpack_require__(572);
var GameSoundPlayer_1 = __webpack_require__(576);
var GameBigWinModule_1 = __webpack_require__(295);
var GameBigWinView_1 = __webpack_require__(580);
var GameFreeSpinsModule_1 = __webpack_require__(581);
var GameFreeSpinsView_1 = __webpack_require__(587);
var FreeSpinsTriggerModule_1 = __webpack_require__(76);
var FreeSpinsTriggerView_1 = __webpack_require__(275);
var RecodeFakeCommunicator_1 = __webpack_require__(588);
var GameRecodeLogic_1 = __webpack_require__(601);
var RecodeGameNetworkModule_1 = __webpack_require__(613);
var GameFreeSpinsInfoModule_1 = __webpack_require__(616);
var GameFreeSpinsInfoView_1 = __webpack_require__(618);
var SoundHandlerModule_1 = __webpack_require__(620);
var GameSoundManager_1 = __webpack_require__(621);
var RecodeBetlevelMenuModule_1 = __webpack_require__(622);
var RecodeAutoplayMenuModule_1 = __webpack_require__(626);
var RecodeInfoPopupModule_1 = __webpack_require__(634);
var RecodeSettingsModule_1 = __webpack_require__(636);
var RecodeModule_1 = __webpack_require__(638);
var RecodeSpinButtonModule_1 = __webpack_require__(639);
var RecodePaytableModule_1 = __webpack_require__(645);
var InFreeRoundsModule_1 = __webpack_require__(647);
var FreeRoundsScreenModule_1 = __webpack_require__(648);
var GameRecodeAnalyticsModule_1 = __webpack_require__(654);
var RecodeAutoPlayButtonView_1 = __webpack_require__(656);
var RecodeMainMenuView_1 = __webpack_require__(658);
var InFreeRoundsView_1 = __webpack_require__(329);
var RecodeAutoPlayButtonModule_1 = __webpack_require__(660);
var RecodeBetButtonModule_1 = __webpack_require__(663);
var GameSwipeInteractionView_1 = __webpack_require__(666);
var GameSettingsView_1 = __webpack_require__(668);
var GameAutoplayHandlerModule_1 = __webpack_require__(671);
var GameSwipeInteractionModule_1 = __webpack_require__(674);
var GameFreeRoundsScreenView_1 = __webpack_require__(676);
var GameStartScreenView_1 = __webpack_require__(677);
var GameStartScreenModule_1 = __webpack_require__(678);
var GameMobileSoundManager_1 = __webpack_require__(680);
var GameRecodeMainMenuModule_1 = __webpack_require__(681);
var RecodeGameInstaller = /** @class */ (function () {
    function RecodeGameInstaller() {
    }
    RecodeGameInstaller.run = function (game, otherStuff) {
        var VAPI = otherStuff;
        var container = game.system.container;
        var communicator = new RecodeFakeCommunicator_1.RecodeFakeCommunicator(VAPI);
        // communicator.addFakeResponse('');
        var gameLogic = new GameRecodeLogic_1.GameRecodeLogic(game.name, container.get(CoreDI_1.CoreDI.IEventManagerWithAsync), communicator, game.system.device);
        gameLogic.initializeConfig(container.get(CoreDI_1.CoreDI.ResourceLoader).getConfig('config.json'));
        container
            .bind(DI_1.default.ISettings)
            .to(Settings_1.Settings)
            .inSingletonScope();
        container.bind(DI_1.default.Logic).toConstantValue(gameLogic);
        container
            .bind(DI_1.default.ViewManager)
            .to(GameViewManager_1.GameViewManager)
            .inSingletonScope();
        if (game.system.device.isMobile) {
            container
                .bind(DI_1.default.SoundManager)
                .to(GameMobileSoundManager_1.GameMobileSoundManager)
                .inSingletonScope();
        }
        else {
            container
                .bind(DI_1.default.SoundManager)
                .to(GameSoundManager_1.GameSoundManager)
                .inSingletonScope();
        }
        container
            .bind(DI_1.default.SoundPlayer)
            .to(GameSoundPlayer_1.GameSoundPlayer)
            .inSingletonScope();
        container.get(DI_1.default.SoundPlayer).init();
        this.bindGameModules(container, RecodeSpinButtonModule_1.RecodeSpinButtonModule, GameAvalancheReelsModule_1.GameAvalancheReelsModule, GameBackgroundModule_1.GameBackgroundModule, GameWinPresentationModule_1.GameWinPresentationModule, GameBigWinModule_1.GameBigWinModule, RecodePaytableModule_1.RecodePaytableModule, 
        //ParticleModule,
        RecodeAutoPlayButtonModule_1.RecodeAutoPlayButtonModule, StopAutoplayButtonModule_1.StopAutoplayButtonModule, RecodeBetButtonModule_1.RecodeBetButtonModule, MenuButtonModule_1.MenuButtonModule, GameRecodeMainMenuModule_1.GameRecodeMainMenuModule, RecodeBetlevelMenuModule_1.RecodeBetlevelMenuModule, RecodeAutoplayMenuModule_1.RecodeAutoplayMenuModule, LogotypeModule_1.LogotypeModule, GameStartScreenModule_1.GameStartScreenModule, GameSwipeInteractionModule_1.GameSwipeInteractionModule, OrientationModule_1.OrientationModule, RecodeInfoPopupModule_1.RecodeInfoPopupModule, GameFreeSpinsInfoModule_1.GameFreeSpinsInfoModule, GameFreeSpinsModule_1.GameFreeSpinsModule, GameInfoModule_1.GameInfoModule, GameRulesModule_1.GameRulesModule, RecodeSettingsModule_1.RecodeSettingsModule, RespinModule_1.RespinModule, FreeSpinsTriggerModule_1.FreeSpinsTriggerModule, TopReelsModule_1.TopReelsModule, OverTopReelEffectsModule_1.OverTopReelEffectsModule, WildMeterModule_1.WildMeterModule, WinLinesPresentationModule_1.WinLinesPresentationModule, WinFieldModule_1.WinFieldModule, FreeRoundsScreenModule_1.FreeRoundsScreenModule, InFreeRoundsModule_1.InFreeRoundsModule, 
        // modules with no view
        GameRecodeAnalyticsModule_1.GameRecodeAnalyticsModule, RestoreScreenModule_1.RestoreScreenModule, GameAutoplayHandlerModule_1.GameAutoplayHandlerModule, GameFlowModule_1.GameFlowModule, RecodeGameNetworkModule_1.RecodeGameNetworkModule, SoundHandlerModule_1.SoundHandlerModule, RecodeModule_1.RecodeModule);
        if (false) {
            this.bindGameModules(container, CheatModule_1.CheatModule, StatisticsWindowModule_1.StatisticsWindowModule);
        }
        this.bindGameViews(container, { clazz: SpinButtonView_1.SpinButtonView, id: Views_1.Views.SPIN_BUTTON_VIEW }, { clazz: GameAvalancheReelsView_1.GameAvalancheReelsView, id: Views_1.Views.REELS_VIEW }, { clazz: GameBackgroundView_1.GameBackgroundView, id: Views_1.Views.BACKGROUND_VIEW }, { clazz: GameWinPresentationView_1.GameWinPresentationView, id: Views_1.Views.WIN_PRESENTATION_VIEW }, { clazz: GameBigWinView_1.GameBigWinView, id: Views_1.Views.BIG_WIN_VIEW }, { clazz: PaytableView_1.PaytableView, id: GameViews_1.GameViews.PAYTABLE_VIEW }, { clazz: ParticleView_1.ParticleView, id: Views_1.Views.PARTICLE_VIEW }, { clazz: RecodeAutoPlayButtonView_1.RecodeAutoPlayButtonView, id: Views_1.Views.AUTOPLAY_VIEW }, { clazz: StopAutoplayButtonView_1.StopAutoplayButtonView, id: Views_1.Views.STOP_AUTOPLAY_BUTTON_VIEW }, { clazz: BetButtonView_1.BetButtonView, id: Views_1.Views.BET_VIEW }, { clazz: MenuButtonView_1.MenuButtonView, id: Views_1.Views.MENUBUTTON_VIEW }, { clazz: RecodeMainMenuView_1.RecodeMainMenuView, id: Views_1.Views.MAIN_MENU_VIEW }, { clazz: BetlevelMenuView_1.BetlevelMenuView, id: Views_1.Views.BET_LEVEL_MENU_VIEW }, { clazz: AutoplayMenuView_1.AutoplayMenuView, id: Views_1.Views.AUTOPLAY_MENU_VIEW }, { clazz: LogotypeView_1.LogotypeView, id: Views_1.Views.LOGOTYPE_VIEW }, { clazz: GameStartScreenView_1.GameStartScreenView, id: Views_1.Views.STARTSCREEN_VIEW }, { clazz: GameSwipeInteractionView_1.GameSwipeInteractionView, id: Views_1.Views.SWIPE_INTERACTION_VIEW }, { clazz: OrientationView_1.OrientationView, id: Views_1.Views.ORIENTATION_NOTIFICATION_VIEW }, { clazz: InfoPopupView_1.InfoPopupView, id: Views_1.Views.INFO_POPUP_VIEW }, { clazz: GameFreeSpinsInfoView_1.GameFreeSpinsInfoView, id: Views_1.Views.FREE_SPINS_INFO_VIEW }, { clazz: GameFreeSpinsView_1.GameFreeSpinsView, id: Views_1.Views.FREE_SPINS_VIEW }, { clazz: GameInfoView_1.GameInfoView, id: Views_1.Views.INFO_VIEW }, { clazz: GameRulesView_1.GameRulesView, id: Views_1.Views.GAME_RULES_VIEW }, { clazz: GameSettingsView_1.GameSettingsView, id: Views_1.Views.SETTINGS_VIEW }, { clazz: RespinView_1.RespinView, id: GameViews_1.GameViews.RESPIN_VIEW }, { clazz: FreeSpinsTriggerView_1.FreeSpinsTriggerView, id: GameViews_1.GameViews.FREE_SPINS_TRIGGER_VIEW }, { clazz: TopReelsView_1.TopReelsView, id: GameViews_1.GameViews.TOP_REELS_VIEW }, { clazz: OverTopReelEffectsView_1.OverTopReelEffectsView, id: GameViews_1.GameViews.UNDER_TOP_REELS_VIEW }, { clazz: WildMeterView_1.WildMeterView, id: GameViews_1.GameViews.WILD_METER_VIEW }, { clazz: WinLinesPresentationView_1.WinLinesPresentationView, id: GameViews_1.GameViews.WIN_LINES_PRESENTATION_VIEW }, { clazz: WinFieldView_1.WinFieldView, id: GameViews_1.GameViews.WIN_FIELD_VIEW }, { clazz: GameFreeRoundsScreenView_1.GameFreeRoundsScreenView, id: Views_1.Views.MICROGAMING_FREEROUNDS_VIEW }, { clazz: InFreeRoundsView_1.InFreeRoundsView, id: Views_1.Views.MICROGAMING_INFREEROUNDS_VIEW });
        if (false) {
            this.bindGameViews(container, { clazz: GameCheatView_1.GameCheatView, id: Views_1.Views.CHEATS_VIEW }, { clazz: StatisticsWindowView_1.StatisticsWindowView, id: Views_1.Views.STATISTICS_WINDOW_VIEW });
        }
        if (game.system.device.isMobile) {
            /*this.bindGameViews(
                container,
            );*/
        }
        else {
            /*this.bindGameViews(
                container,

            );*/
        }
    };
    /**
     * binds like: container.bind<IModule>(DI.IModule).to(BigWinModule);
     * @param {Container} container
     * @param {{new(): IModule}} gameModuleClasses
     */
    RecodeGameInstaller.bindGameModules = function (container) {
        var gameModuleClasses = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            gameModuleClasses[_i - 1] = arguments[_i];
        }
        for (var _a = 0, gameModuleClasses_1 = gameModuleClasses; _a < gameModuleClasses_1.length; _a++) {
            var module_1 = gameModuleClasses_1[_a];
            container.bind(DI_1.default.IModule).to(module_1);
        }
    };
    RecodeGameInstaller.bindGameViews = function (container) {
        var gameViewClasses = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            gameViewClasses[_i - 1] = arguments[_i];
        }
        for (var _a = 0, gameViewClasses_1 = gameViewClasses; _a < gameViewClasses_1.length; _a++) {
            var bindInstance = gameViewClasses_1[_a];
            container.bind(bindInstance.id).to(bindInstance.clazz);
        }
    };
    return RecodeGameInstaller;
}());
exports.RecodeGameInstaller = RecodeGameInstaller;


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Module_1 = __webpack_require__(2);
var Views_1 = __webpack_require__(8);
var CheatDebuggingComponent_1 = __webpack_require__(491);
var LogicEvents_1 = __webpack_require__(11);
var LogotypeViewEvents_1 = __webpack_require__(244);
var CheatModule = /** @class */ (function (_super) {
    __extends(CheatModule, _super);
    function CheatModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheatModule.prototype.enterFirstState = function () { };
    CheatModule.prototype.setupStates = function () { };
    CheatModule.prototype.setupViews = function () {
        this.setView(Views_1.Views.CHEATS_VIEW);
    };
    CheatModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        if (false) {
            this.on(LogotypeViewEvents_1.LogotypeViewEvents.LOGOTYPE_DOUBLE_TAPPED, this.onDoubleTapLogo);
            this.on(LogicEvents_1.LogicEvents.INIT_RESPONSE, this.onInitResponse);
        }
    };
    CheatModule.prototype.onInitResponse = function () {
        this.view.addMathVersion(this.logic.mathVersion);
    };
    CheatModule.prototype.addDebuggingComponent = function () {
        if (false) {
            new CheatDebuggingComponent_1.CheatDebuggingComponent(this, this.view);
            document.addEventListener('keydown', this.keyboardInput.bind(this));
        }
    };
    CheatModule.prototype.onDoubleTapLogo = function () {
        this.switchCheatsVisibility();
    };
    CheatModule.prototype.switchCheatsVisibility = function () {
        if (this.view.isVisible()) {
            this.view.hide();
        }
        else {
            this.view.show();
        }
    };
    CheatModule.prototype.keyboardInput = function (event) {
        if (event.code === 'KeyC') {
            this.switchCheatsVisibility();
        }
    };
    return CheatModule;
}(Module_1.Module));
exports.CheatModule = CheatModule;


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var StatedDebug = /** @class */ (function () {
    function StatedDebug() {
        this._states = {};
        if (false) {
            document.addEventListener('keydown', this.keyboardInput.bind(this));
        }
    }
    StatedDebug.prototype.setModuleState = function (moduleName, stateName) {
        this._states[moduleName] = stateName;
    };
    StatedDebug.prototype.drawModulesMap = function () {
        if (false) {
            for (var key in this._states) {
                if (this._states.hasOwnProperty(key)) {
                    console.log('' + key + ' - ' + this._states[key]);
                }
            }
        }
    };
    StatedDebug.prototype.keyboardInput = function (event) {
        if (false) {
            if (event.code === 'ArrowLeft') {
                this.drawModulesMap();
            }
            if (event.code === 'ArrowRight') {
                console.log(__VERSION__ + " " + __BRANCH__ + " " + __BUILD_DATE__ + " " + __GITHASH__);
            }
        }
    };
    return StatedDebug;
}());
exports.StatedDebug = StatedDebug;


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var WinLine = /** @class */ (function () {
    function WinLine(index, symbol, positions, winPositions, win) {
        this._positions = [];
        this._winPositions = [];
        this._index = index;
        this._symbol = symbol;
        this._positions = positions;
        this._winPositions = winPositions;
        this._win = win;
    }
    Object.defineProperty(WinLine.prototype, "index", {
        get: function () {
            return this._index;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WinLine.prototype, "positions", {
        get: function () {
            return this._positions;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WinLine.prototype, "winPositions", {
        get: function () {
            return this._winPositions;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WinLine.prototype, "symbol", {
        get: function () {
            return this._symbol;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WinLine.prototype, "win", {
        get: function () {
            return this._win;
        },
        enumerable: true,
        configurable: true
    });
    return WinLine;
}());
exports.WinLine = WinLine;


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var DebuggingComponent_1 = __webpack_require__(151);
var CurrencyFormatter_1 = __webpack_require__(72);
var CheatDebuggingComponent = /** @class */ (function (_super) {
    __extends(CheatDebuggingComponent, _super);
    function CheatDebuggingComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CheatDebuggingComponent.prototype.init = function () {
        _super.prototype.init.call(this);
        this.addWindowFunction('SwitchCurrency', this.switchCurrency.bind(this));
    };
    CheatDebuggingComponent.prototype.switchCurrency = function (currencyISO) {
        var currencyData = this.view.currencyFormatter.parseCurrencyFormatting(currencyISO, CurrencyFormatter_1.CurrencyFormatter.CurrenciesDisplayFormat[currencyISO]);
        this.view.currencyFormatter.setCurrencyData(currencyData);
    };
    return CheatDebuggingComponent;
}(DebuggingComponent_1.DebuggingComponent));
exports.CheatDebuggingComponent = CheatDebuggingComponent;


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var View_1 = __webpack_require__(3);
var BetButtonViewEvents_1 = __webpack_require__(245);
__webpack_require__(59);
var BetButtonView = /** @class */ (function (_super) {
    __extends(BetButtonView, _super);
    function BetButtonView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BetButtonView.prototype.init = function () {
        _super.prototype.init.call(this);
        this._betButton = this.spineUtils.createSpineButton('BET_BUTTON.json', this.onBetButtonClicked.bind(this));
        var betButtonPosition = this.layout.getAbsolutePosition('BET_BUTTON');
        this._betButton.position.set(betButtonPosition.x, betButtonPosition.y);
        this.container.addChild(this._betButton);
    };
    BetButtonView.prototype.enableBetButton = function () {
        this._betButton.enable();
        // this._betButton.visible = true;
    };
    BetButtonView.prototype.disableBetButton = function () {
        this._betButton.disable();
    };
    BetButtonView.prototype.hideBetButton = function () {
        this._betButton.visible = false;
    };
    BetButtonView.prototype.showBetButton = function () {
        this._betButton.visible = true;
    };
    BetButtonView.prototype.onBetButtonClicked = function () {
        this.soundPlayer.play('buttonClick');
        this.emit(BetButtonViewEvents_1.BetButtonViewEvents.BET_BUTTON_CLICKED);
    };
    return BetButtonView;
}(View_1.View));
exports.BetButtonView = BetButtonView;


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Module_1 = __webpack_require__(2);
var Views_1 = __webpack_require__(8);
var FlowModuleEvents_1 = __webpack_require__(0);
var MenuButtonEvents_1 = __webpack_require__(152);
var MenuButtonViewEvents_1 = __webpack_require__(153);
var MenuButtonBasicState_1 = __webpack_require__(494);
var ReelsEvents_1 = __webpack_require__(4);
var StartScreenEvents_1 = __webpack_require__(22);
var MenuButtonModule = /** @class */ (function (_super) {
    __extends(MenuButtonModule, _super);
    function MenuButtonModule() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._autoPlayActive = false;
        _this._startscreenExitFinished = false;
        return _this;
    }
    MenuButtonModule.prototype.afterInit = function () {
        _super.prototype.afterInit.call(this);
        this.hideMenuButton();
    };
    MenuButtonModule.prototype.restore = function () {
        _super.prototype.restore.call(this);
        this.view.showMenuButton();
    };
    MenuButtonModule.prototype.setupViews = function () {
        if (this.system.shouldUseMultipleViews()) {
            this.setView(Views_1.Views.MENUBUTTON_VIEW_MOBILE);
        }
        else {
            this.setView(Views_1.Views.MENUBUTTON_VIEW);
        }
    };
    MenuButtonModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.onCurrentStateHandle(ReelsEvents_1.ReelsEvents.SPIN_ENDED);
        this.onCurrentStateHandle(ReelsEvents_1.ReelsEvents.REELS_RESPIN_STARTED);
        this.on(FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN, this.onCanSpin);
        this.onView(MenuButtonViewEvents_1.MenuButtonViewEvents.MENU_BUTTON_CLICKED, this.onMenuButtonClicked);
        this.on(StartScreenEvents_1.StartScreenEvents.EXIT_FINISHED, this.onStartScreenExitFinished);
    };
    MenuButtonModule.prototype.enterFirstState = function () {
        this.changeStateTo(MenuButtonModule.BASIC_STATE);
    };
    MenuButtonModule.prototype.setupStates = function () {
        this.addState(new MenuButtonBasicState_1.MenuButtonBasicState(this, MenuButtonModule.BASIC_STATE));
    };
    MenuButtonModule.prototype.onStartScreenExitFinished = function () {
        this._startscreenExitFinished = true;
        this.showMenuButton();
    };
    MenuButtonModule.prototype.onCanSpin = function () {
        if (this._startscreenExitFinished) {
            this.showView();
            this.showMenuButton();
        }
        this.enableMenuButton();
    };
    MenuButtonModule.prototype.showView = function () {
        this.view.show();
    };
    MenuButtonModule.prototype.hideView = function () {
        this.view.hide();
    };
    MenuButtonModule.prototype.enableMenuButton = function () {
        this.view.enableMenuButton();
    };
    MenuButtonModule.prototype.disableMenuButton = function () {
        this.view.disableMenuButton();
    };
    MenuButtonModule.prototype.showMenuButton = function () {
        this.view.showMenuButton();
    };
    MenuButtonModule.prototype.hideMenuButton = function () {
        this.view.hideMenuButton();
    };
    MenuButtonModule.prototype.onMenuButtonClicked = function () {
        this.eventManager.emit(MenuButtonEvents_1.MenuButtonEvents.MENU_BUTTON_CLICKED);
    };
    MenuButtonModule.BASIC_STATE = 'basic';
    MenuButtonModule.MENUBUTTON_CLICKED_STATE = 'menuButtonClicked';
    return MenuButtonModule;
}(Module_1.Module));
exports.MenuButtonModule = MenuButtonModule;


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var MenuButtonViewEvents_1 = __webpack_require__(153);
var MenuButtonBasicState = /** @class */ (function (_super) {
    __extends(MenuButtonBasicState, _super);
    function MenuButtonBasicState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MenuButtonBasicState.prototype.onEnterState = function () {
    };
    MenuButtonBasicState.prototype.onLeaveState = function () {
    };
    MenuButtonBasicState.prototype.setupEvents = function () {
        this.on(MenuButtonViewEvents_1.MenuButtonViewEvents.MENU_BUTTON_CLICKED, this.onMenuButtonClick);
    };
    MenuButtonBasicState.prototype.onMenuButtonClick = function () {
    };
    return MenuButtonBasicState;
}(ModuleState_1.ModuleState));
exports.MenuButtonBasicState = MenuButtonBasicState;


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var View_1 = __webpack_require__(3);
var MenuButtonViewEvents_1 = __webpack_require__(153);
__webpack_require__(59);
var MenuButtonView = /** @class */ (function (_super) {
    __extends(MenuButtonView, _super);
    function MenuButtonView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MenuButtonView.prototype.init = function () {
        _super.prototype.init.call(this);
        this._menuButton = this.spineUtils.createSpineButton('MENU_BUTTON.json', this.onMenuButtonClicked.bind(this));
        var menuButtonPosition = this.layout.getAbsolutePosition('MENU_BUTTON');
        this._menuButton.position.set(menuButtonPosition.x, menuButtonPosition.y);
        this.container.addChild(this._menuButton);
    };
    MenuButtonView.prototype.enableMenuButton = function () {
        this._menuButton.enable();
        // this._menuButton.visible = true;
    };
    MenuButtonView.prototype.disableMenuButton = function () {
        this._menuButton.disable();
    };
    MenuButtonView.prototype.hideMenuButton = function () {
        this._menuButton.visible = false;
    };
    MenuButtonView.prototype.showMenuButton = function () {
        this._menuButton.visible = true;
    };
    MenuButtonView.prototype.onMenuButtonClicked = function () {
        this.soundPlayer.play('buttonClick');
        this.emit(MenuButtonViewEvents_1.MenuButtonViewEvents.MENU_BUTTON_CLICKED);
    };
    return MenuButtonView;
}(View_1.View));
exports.MenuButtonView = MenuButtonView;


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Module_1 = __webpack_require__(2);
var StopAutoplayButtonView_1 = __webpack_require__(246);
var StopAutoplayButtonEvents_1 = __webpack_require__(30);
var Views_1 = __webpack_require__(8);
var AutoplayMenuEvents_1 = __webpack_require__(33);
var AutoplayHandlerEvents_1 = __webpack_require__(56);
var FlowModuleEvents_1 = __webpack_require__(0);
var SpinButtonEvents_1 = __webpack_require__(12);
var ScreenEvents_1 = __webpack_require__(108);
var StopAutoplayButtonModule = /** @class */ (function (_super) {
    __extends(StopAutoplayButtonModule, _super);
    function StopAutoplayButtonModule() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._isAutoplayActive = false;
        return _this;
    }
    StopAutoplayButtonModule.prototype.enterFirstState = function () {
    };
    StopAutoplayButtonModule.prototype.setupStates = function () {
    };
    StopAutoplayButtonModule.prototype.setupViews = function () {
        if (this.system.shouldUseMultipleViews()) {
            this.setView(Views_1.Views.STOP_AUTOPLAY_BUTTON_VIEW_MOBILE);
        }
        else {
            this.setView(Views_1.Views.STOP_AUTOPLAY_BUTTON_VIEW);
        }
    };
    StopAutoplayButtonModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.onView(StopAutoplayButtonView_1.StopAutoplayButtonView.STOP_AUTOPLAY_BUTTON_CLICKED, this.onStopAutoplayClicked);
        this.on(AutoplayMenuEvents_1.AutoplayMenuEvents.ACCEPTED, this.onStartAutoplay);
        this.on(AutoplayHandlerEvents_1.AutoplayHandlerEvents.AUTOPLAY_ROUNDS_FINISHED, this.onAutoplayRoundsFinished);
        this.on(AutoplayHandlerEvents_1.AutoplayHandlerEvents.START_AUTOPLAY_SPIN, this.onStartAutoPlaySpin);
        /** According to ReCode integration we need to stop autoplay on bonus games. */
        this.on(FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_START, this.onBonusGameStart);
        // this.on(FlowModuleEvents.BONUS_GAME_END, this.onBonusGameEnd);
        // this.on(BonusGameEvents.BONUS_OUTRO_FINISHED, this.onBonusGameEnd);
        this.on(SpinButtonEvents_1.SpinButtonEvents.SPIN_PRESSED_NOT_ENOUGH_MONEY, this.onNotEnoughMoney);
        this.on(ScreenEvents_1.ScreenEvents.BECAME_VISIBLE, this.onBecameVisible);
        this.on(ScreenEvents_1.ScreenEvents.BECAME_INVISIBLE, this.onBecameInvisible);
    };
    StopAutoplayButtonModule.prototype.onBecameVisible = function () {
    };
    StopAutoplayButtonModule.prototype.onBecameInvisible = function () {
        this.stopAutoplay();
    };
    StopAutoplayButtonModule.prototype.onNotEnoughMoney = function () {
        this.stopAutoplay();
    };
    StopAutoplayButtonModule.prototype.onStopAutoplayClicked = function () {
        this.stopAutoplay();
    };
    StopAutoplayButtonModule.prototype.onAutoplayRoundsFinished = function () {
        this.stopAutoplay();
    };
    StopAutoplayButtonModule.prototype.onBonusGameStart = function () {
        this.stopAutoplay();
    };
    StopAutoplayButtonModule.prototype.onStartAutoPlaySpin = function (eventId, currentSpins, totalSpins) {
        this.view.updateSpinsLeft(currentSpins, totalSpins);
    };
    // protected onBonusGameEnd(): void {
    // 	this.view.show();
    // }
    // protected onBonusGameStart(): void {
    // 	this.view.hide();
    // }
    StopAutoplayButtonModule.prototype.stopAutoplay = function () {
        if (this._isAutoplayActive) {
            this.eventManager.emit(StopAutoplayButtonEvents_1.StopAutoplayButtonEvents.STOP_AUTOPLAY_BUTTON_CLICKED);
            this.view.uninitAutoplay();
            this._isAutoplayActive = false;
        }
    };
    StopAutoplayButtonModule.prototype.onStartAutoplay = function () {
        if (!this._isAutoplayActive) {
            this._isAutoplayActive = true;
            this.view.initAutoplay();
        }
    };
    return StopAutoplayButtonModule;
}(Module_1.Module));
exports.StopAutoplayButtonModule = StopAutoplayButtonModule;


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Button_1 = __webpack_require__(54);
var SpineAnimation_1 = __webpack_require__(37);
var Spine_1 = __webpack_require__(25);
var SpinButton_1 = __webpack_require__(247);
var StopAutoplayButton = /** @class */ (function (_super) {
    __extends(StopAutoplayButton, _super);
    function StopAutoplayButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StopAutoplayButton.prototype.setState = function (value) {
        if (this._state !== value && this._updateManager) {
            this._previousState = this._state;
            this._state = value;
            switch (value) {
                case Button_1.ButtonState.DISABLED: {
                    throw new Error('Disable is impossible state for autoplay button');
                }
                case Button_1.ButtonState.DOWN: {
                    this.stopCurrentAnimation();
                    this.stopAdditionalAnimation();
                    this.startButtonAnimation('PRESSED', false, true);
                    this.onClick();
                    break;
                }
                case Button_1.ButtonState.UP: {
                    if (this._previousState === Button_1.ButtonState.OVER) {
                        this.stopAdditionalAnimation();
                    }
                    else {
                        this.stopCurrentAnimation();
                        this.stopAdditionalAnimation();
                        this.startButtonAnimation('IDLE', true);
                    }
                    break;
                }
                case Button_1.ButtonState.OVER: {
                    if (this._previousState === Button_1.ButtonState.UP) {
                        this.stopAdditionalAnimation();
                        this.startAdditionalAnimation('HOVER', true);
                    }
                    else {
                        this.stopCurrentAnimation();
                        this.stopAdditionalAnimation();
                        this.startButtonAnimation('IDLE', true);
                        this.startAdditionalAnimation('HOVER', true);
                    }
                    break;
                }
                default:
                    break;
            }
        }
    };
    StopAutoplayButton.prototype.startButtonAnimation = function (animationName, loop, dontDestroyOnComplete) {
        this._currentAnimation = new SpineAnimation_1.SpineAnimation(new Spine_1.Spine(this._resources.getSpine('SPIN_BUTTON_NOGLOW_AUTOPLAY.json')), animationName, loop, dontDestroyOnComplete);
        this._updateManager.add(this._currentAnimation);
        this.addChild(this._currentAnimation.container);
        this._currentAnimation.start();
    };
    return StopAutoplayButton;
}(SpinButton_1.SpinButton));
exports.StopAutoplayButton = StopAutoplayButton;


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var SnappingSlider_1 = __webpack_require__(499);
var AutoplaySlider = /** @class */ (function (_super) {
    __extends(AutoplaySlider, _super);
    function AutoplaySlider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AutoplaySlider.prototype.updateValue = function (value) {
        this._currentValue = value;
        if (this._sliderBox) {
            if (value === 0) {
                this._sliderBox.updateNumber('-');
            }
            else {
                var sliderBoxValue = this._showAsCurrency ? this.currencyFormatter.formatCurrency(value, true) : value.toString();
                this._sliderBox.updateNumber(sliderBoxValue);
            }
        }
        if (this._onValueChangedCallback) {
            this._onValueChangedCallback.call(this, value);
        }
    };
    Object.defineProperty(AutoplaySlider.prototype, "sliderNumberBox", {
        set: function (box) {
            this._sliderBox = box;
            this.updateValue(0);
        },
        enumerable: true,
        configurable: true
    });
    return AutoplaySlider;
}(SnappingSlider_1.SnappingSlider));
exports.AutoplaySlider = AutoplaySlider;


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Slider_1 = __webpack_require__(500);
var GameUtils_1 = __webpack_require__(26);
var SnappingSlider = /** @class */ (function (_super) {
    __extends(SnappingSlider, _super);
    function SnappingSlider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SnappingSlider.prototype.updateValues = function (values, defaultValueIndex) {
        if (defaultValueIndex === void 0) { defaultValueIndex = -1; }
        this._values = values;
        var length = values.length - 2;
        this._defaultValueIndex = defaultValueIndex;
        this._slots = [0];
        for (var i = 1; i <= length; i++) {
            this._slots.push(Math.floor((i / (this._values.length - 1)) * 100));
        }
        this._slots.push(100);
    };
    SnappingSlider.prototype.onDragEnd = function () {
        this._touchEvent = null;
        this._dragging = false;
        // const percentage = this.calcProcentage(this._dragger.position.x) / 100;
        var percentage = this._slots[this._values.indexOf(this.currentValue)] / 100;
        this._dragger.position.x = this.calcSliderPosition(percentage);
    };
    SnappingSlider.prototype.calcSliderPosition = function (percentage) {
        var max = this._sliderHalfWidth - this._draggerHalfWidth;
        var min = this._startX + this._draggerHalfWidth;
        var position = GameUtils_1.GameUtils.lerp(min, max, percentage);
        return position;
    };
    SnappingSlider.prototype.onDragMove = function () {
        // TODO: Snap during drag?
        if (this._dragging) {
            if (!this._touchEvent) {
                return;
            }
            var newPosition = this._touchEvent.getLocalPosition(this._dragger.parent);
            if (newPosition.x - this._draggerHalfWidth < this._startX) {
                this._dragger.position.x = this._startX + this._draggerHalfWidth;
                this.updateValue(this._values[0]);
            }
            else if (newPosition.x + this._draggerHalfWidth > this._sliderHalfWidth) {
                this._dragger.position.x = this._sliderHalfWidth - this._draggerHalfWidth;
                this.updateValue(this._values[this._values.length - 1]);
            }
            else {
                this._dragger.position.x = newPosition.x;
                var procentage = this.calcProcentage(newPosition.x);
                for (var i = 0; i < this._slots.length; i++) {
                    if (procentage <= this._slots[i]) {
                        this.updateValue(this._values[i]);
                        break;
                    }
                }
            }
        }
    };
    return SnappingSlider;
}(Slider_1.Slider));
exports.SnappingSlider = SnappingSlider;


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var GameUtils_1 = __webpack_require__(26);
var Slider = /** @class */ (function (_super) {
    __extends(Slider, _super);
    function Slider(slot, backgroundSprite, foregroundSprite, draggerSprite, isMobile) {
        var _this = _super.call(this) || this;
        _this._defaultValueIndex = -1;
        _this._dragging = false;
        _this._showAsCurrency = true;
        _this._slot = slot;
        _this._background = backgroundSprite;
        _this._dragger = draggerSprite;
        _this._sliderWidth = backgroundSprite.width;
        _this._foreground = foregroundSprite;
        _this._isMobile = isMobile;
        _this._startX = -_this._sliderWidth / 2;
        _this._draggerHalfWidth = draggerSprite.width / 2;
        _this._sliderHalfWidth = foregroundSprite.width / 2;
        _this.initialize(slot, backgroundSprite, foregroundSprite, draggerSprite, isMobile);
        return _this;
    }
    Object.defineProperty(Slider.prototype, "currentValue", {
        get: function () {
            return this._currentValue;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Slider.prototype, "sliderNumberBox", {
        set: function (box) {
            this._sliderBox = box;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Slider.prototype, "onValueChangedCallback", {
        set: function (value) {
            this._onValueChangedCallback = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Slider.prototype, "currencyFormatter", {
        get: function () {
            return this._currencyFormatter;
        },
        set: function (value) {
            this._currencyFormatter = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Slider.prototype, "showAsCurrency", {
        get: function () {
            return this._showAsCurrency;
        },
        set: function (value) {
            this._showAsCurrency = value;
        },
        enumerable: true,
        configurable: true
    });
    Slider.prototype.updateValues = function (values, defaultValueIndex) {
        if (defaultValueIndex === void 0) { defaultValueIndex = -1; }
        this._values = values;
        var length = values.length;
        this._slots = [];
        this._defaultValueIndex = defaultValueIndex;
        for (var i = 0; i < length; i++) {
            this._slots.push(Math.floor((i / this._values.length) * 100));
        }
    };
    Slider.prototype.reset = function () {
        this._dragger.position.x = -this._sliderWidth / 2 + this._dragger.width / 2;
        if (this._slots && this._slots.length > 0) {
            if (this._defaultValueIndex >= 0) {
                this.updateValue(this._values[this._defaultValueIndex]);
                var percentage = this._slots[this._values.indexOf(this.currentValue)] / 100;
                this._dragger.position.x = this.calcSliderPosition(percentage);
            }
            else {
                this.updateValue(this._values[0]);
            }
        }
        else {
            this.updateValue(0);
        }
    };
    Slider.prototype.initialize = function (slot, backgroundSprite, foregroundSprite, draggerSprite, isMobile) {
        this.createSlider(slot, backgroundSprite, foregroundSprite);
        this.createDragger(slot, draggerSprite, backgroundSprite.width);
        this.createMask(this._dragger, this._maskParent, backgroundSprite.width, backgroundSprite.height);
        this.setUpInputs(isMobile);
    };
    Slider.prototype.createSlider = function (slot, backgroundSprite, foregroundSprite) {
        slot.addChild(backgroundSprite);
        backgroundSprite.transform.updateTransform(slot.transform);
        backgroundSprite.scale.y *= -1; // Slots transform is flipped on y.
        backgroundSprite.anchor.set(0.5, 0.5);
        this._maskParent = new PIXI.Container();
        slot.addChild(this._maskParent);
        this._maskParent.addChild(foregroundSprite);
        foregroundSprite.transform.updateTransform(slot.transform);
        foregroundSprite.scale.y *= -1;
        foregroundSprite.anchor.set(0.5, 0.5);
    };
    Slider.prototype.createDragger = function (slot, sprite, width) {
        sprite.anchor.set(0.5, 0.5);
        slot.addChild(sprite);
        sprite.interactive = true;
        sprite.buttonMode = true;
        sprite.scale.y *= -1;
        sprite.x = -width / 2 + sprite.width / 2;
    };
    Slider.prototype.createMask = function (slot, maskSlot, width, height) {
        var mask = new PIXI.Graphics();
        mask.beginFill(0xffffff);
        mask.drawRect(slot.width / 3 - width, 0, width, height);
        mask.endFill();
        mask.y = -slot.height / 2;
        slot.addChild(mask);
        maskSlot.mask = mask;
    };
    Slider.prototype.setUpInputs = function (isMobile) {
        this._dragger.on('touchstart', this.onDragStart.bind(this));
        this._dragger.on('touchmove', this.onDragMove.bind(this));
        this._dragger.on('touchend', this.onDragEnd.bind(this));
        this._dragger.on('touchendoutside', this.onDragEnd.bind(this));
        this._dragger.on('mousedown', this.onDragStart.bind(this));
        this._dragger.on('mousemove', this.onDragMove.bind(this));
        this._dragger.on('mouseup', this.onDragEnd.bind(this));
        this._dragger.on('mouseupoutside', this.onDragEnd.bind(this));
        this._touchEvent = null;
    };
    Slider.prototype.onDragStart = function (event) {
        this._touchEvent = event.data;
        this._dragging = true;
    };
    Slider.prototype.onDragMove = function () {
        if (this._dragging) {
            if (!this._touchEvent) {
                return;
            }
            var newPosition = this._touchEvent.getLocalPosition(this._dragger.parent);
            if (newPosition.x - this._draggerHalfWidth < this._startX) {
                this._dragger.position.x = this._startX + this._draggerHalfWidth;
                this.updateValue(this._values[0]);
            }
            else if (newPosition.x + this._draggerHalfWidth > this._sliderHalfWidth) {
                this._dragger.position.x = this._sliderHalfWidth - this._draggerHalfWidth;
                this.updateValue(this._values[this._values.length - 1]);
            }
            else {
                this._dragger.position.x = newPosition.x;
                for (var i = 0; i < this._slots.length; i++) {
                    if (this.calcProcentage(newPosition.x) > this._slots[i]) {
                        this.updateValue(this._values[i]);
                    }
                }
            }
        }
    };
    Slider.prototype.calcProcentage = function (xPos) {
        var procentage = xPos + this._sliderHalfWidth - this._draggerHalfWidth;
        procentage = Math.floor((procentage / (this._sliderWidth - this._dragger.width)) * 100);
        return procentage;
    };
    Slider.prototype.updateValue = function (value) {
        this._currentValue = value;
        if (this._sliderBox) {
            var sliderBoxValue = this._showAsCurrency ? this.currencyFormatter.formatCurrency(value, true) : value.toString();
            this._sliderBox.updateNumber(sliderBoxValue);
        }
        if (this._onValueChangedCallback) {
            this._onValueChangedCallback.call(this, value);
        }
    };
    Slider.prototype.calcSliderPosition = function (percentage) {
        var max = this._sliderHalfWidth - this._draggerHalfWidth;
        var min = this._startX + this._draggerHalfWidth;
        var position = GameUtils_1.GameUtils.lerp(min, max, percentage);
        return position;
    };
    Slider.prototype.onDragEnd = function () {
        this._touchEvent = null;
        this._dragging = false;
    };
    return Slider;
}(PIXI.Sprite));
exports.Slider = Slider;


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var GameUtils_1 = __webpack_require__(26);
var SliderNumberBox = /** @class */ (function (_super) {
    __extends(SliderNumberBox, _super);
    function SliderNumberBox(buttonSprite, style, isMobile, scaleMod) {
        var _this = _super.call(this) || this;
        _this.initialize(buttonSprite, style, isMobile, scaleMod);
        return _this;
    }
    SliderNumberBox.prototype.updateNumber = function (newNumber) {
        if (!this._text) {
            return;
        }
        this._text.text = newNumber;
        this.scaleNumber(this._text);
    };
    SliderNumberBox.prototype.initialize = function (buttonSprite, style, isMobile, scaleMod) {
        this._isMobile = isMobile;
        this._scaleMod = scaleMod;
        this._buttonSprite = buttonSprite;
        this.createButton(buttonSprite);
        this.createNumber(buttonSprite, style);
    };
    SliderNumberBox.prototype.createButton = function (buttonSprite) {
        this.addChild(buttonSprite);
        buttonSprite.anchor.set(0.5, 0.5);
        return buttonSprite;
    };
    SliderNumberBox.prototype.createNumber = function (parentSprite, style) {
        this._text = new PIXI.Text('0', style);
        parentSprite.addChild(this._text);
        this._text.anchor.set(0.5, 0.5);
        return this._text;
    };
    SliderNumberBox.prototype.scaleNumber = function (text) {
        text.scale.set(1, 1);
        var maxSize = {
            x: this._buttonSprite.width * this._scaleMod,
            y: this._buttonSprite.height * this._scaleMod,
        };
        if (text.width > maxSize.x || text.height > maxSize.y) {
            GameUtils_1.GameUtils.correctSpriteScale(text, maxSize);
        }
    };
    return SliderNumberBox;
}(PIXI.Sprite));
exports.SliderNumberBox = SliderNumberBox;


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BetlevelMenuViewEvents_1 = __webpack_require__(250);
var ButtonsMenu_1 = __webpack_require__(503);
var BetlevelMenuView = /** @class */ (function (_super) {
    __extends(BetlevelMenuView, _super);
    function BetlevelMenuView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BetlevelMenuView.prototype.init = function () {
        _super.prototype.init.call(this);
        this.callback = this.setBet;
        if (this.device.isMobile) {
            this.tapDownCallback = this.onTapDown;
            this.mouseOutCallback = this.onMouseOut;
        }
        this.title = 'BET LEVEL';
    };
    BetlevelMenuView.prototype.translate = function () {
        var titleText = this.translator.getObject('BaseStrings', 'features', 'g_betlevel') || 'BET LEVEL';
        this.title = titleText.toUpperCase();
    };
    BetlevelMenuView.prototype.show = function () {
        _super.prototype.show.call(this);
        this.restoreToLastBet(this.lastBet);
    };
    BetlevelMenuView.prototype.preCallback = function (valueId) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        for (var _a = 0, _b = this._buttons; _a < _b.length; _a++) {
            var button = _b[_a];
            if (button.id !== valueId && this.validateButton(button)) {
                button.resetState();
            }
        }
    };
    BetlevelMenuView.prototype.setupButtonStates = function () {
        if (this.lastBet > this.currentBalance) {
            var maxButton = this.getHighestValidButton();
            if (maxButton) {
                this.lastBet = maxButton.id;
            }
        }
        this.restoreToLastBet(this.lastBet);
        this.preCallback(this.lastBet);
    };
    BetlevelMenuView.prototype.validateAllButtons = function () {
        var _this = this;
        this._buttons.forEach(function (button) {
            _this.validateButton(button);
        });
    };
    BetlevelMenuView.prototype.validateButton = function (button) {
        if (button.id > this.currentBalance) {
            button.disable();
            return false;
        }
        button.enable();
        return true;
    };
    BetlevelMenuView.prototype.restoreToLastBet = function (value) {
        var lastBetButton = this.findButtonByValue(value);
        if (lastBetButton) {
            lastBetButton.forceClicked();
            lastBetButton.setSelected();
        }
    };
    BetlevelMenuView.prototype.getHighestValidButton = function () {
        var highestValidValue = 0;
        for (var _i = 0, _a = this._buttons; _i < _a.length; _i++) {
            var button = _a[_i];
            if (this.validateButton(button)) {
                highestValidValue = highestValidValue < button.id ? button.id : highestValidValue;
            }
        }
        return this.findButtonByValue(highestValidValue);
    };
    BetlevelMenuView.prototype.getLowerButton = function () { };
    BetlevelMenuView.prototype.onMouseOut = function (value) {
        for (var _i = 0, _a = this._buttons; _i < _a.length; _i++) {
            var button = _a[_i];
            if (this.validateButton(button)) {
                button.resetState();
            }
        }
        this._acceptEnabled = false;
        this._acceptButton.disable();
    };
    BetlevelMenuView.prototype.onTapDown = function (value) {
        this.preCallback(value);
        this._acceptEnabled = true;
        this._acceptButton.enable();
        this.betValue = value;
    };
    BetlevelMenuView.prototype.setBet = function (value, isRealClick) {
        if (isRealClick) {
            this.soundPlayer.play('buttonClick');
        }
        this.preCallback(value);
        this._acceptEnabled = true;
        this._acceptButton.enable();
        this.betValue = value;
    };
    BetlevelMenuView.prototype.listenToMouseWheelInput = function () {
        this.blockParentPageScroll();
    };
    BetlevelMenuView.prototype.blockParentPageScroll = function () {
        // Copied from page showing example blocking scroll input depending on mouseover.
        // 2017 recommended event
        document.body.addEventListener('wheel', function (event) {
            event.preventDefault();
        }, false);
        // Before 2017, IE9, Chrome, Safari, Opera
        document.body.addEventListener('mousewheel', function (event) {
            event.preventDefault();
        }, false);
        // Old versions of Firefox
        document.body.addEventListener('DOMMouseScroll', function (event) {
            event.preventDefault();
        }, false);
    };
    BetlevelMenuView.prototype.stopListeningToMouseWheelInput = function () { };
    BetlevelMenuView.prototype.emitAccepted = function () {
        this.emit(BetlevelMenuViewEvents_1.BetlevelMenuViewEvents.ACCEPTED);
        this.lastBet = this.betValue;
    };
    BetlevelMenuView.prototype.emitButtonPressed = function () {
        this.emit(BetlevelMenuViewEvents_1.BetlevelMenuViewEvents.BUTTON_PRESSED);
    };
    BetlevelMenuView.prototype.emitCancelled = function () {
        this.emit(BetlevelMenuViewEvents_1.BetlevelMenuViewEvents.CANCELLED);
    };
    BetlevelMenuView.prototype.emitOpened = function () {
        this.emit(BetlevelMenuViewEvents_1.BetlevelMenuViewEvents.BET_LEVEL_MENU_OPENED);
    };
    BetlevelMenuView.prototype.emitClosed = function () {
        this.emit(BetlevelMenuViewEvents_1.BetlevelMenuViewEvents.BET_LEVEL_MENU_CLOSED);
    };
    BetlevelMenuView.prototype.formatText = function (text) {
        return this.currencyFormatter.formatCurrency(text, true);
    };
    BetlevelMenuView.prototype.findButtonByValue = function (value) {
        return this._buttons.find(function (button) { return button.id === value; });
    };
    Object.defineProperty(BetlevelMenuView.prototype, "betValue", {
        get: function () {
            return this._betValue;
        },
        set: function (v) {
            this._betValue = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BetlevelMenuView.prototype, "defaultBet", {
        set: function (n) {
            this._betDefault = n;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BetlevelMenuView.prototype, "lastBet", {
        get: function () {
            return this._lastBet;
        },
        set: function (value) {
            // this.restoreToLastBet(value);
            this._lastBet = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BetlevelMenuView.prototype, "currentBalance", {
        get: function () {
            return this._currentBalance;
        },
        set: function (value) {
            this._currentBalance = value;
        },
        enumerable: true,
        configurable: true
    });
    return BetlevelMenuView;
}(ButtonsMenu_1.ButtonsMenu));
exports.BetlevelMenuView = BetlevelMenuView;


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Spine_1 = __webpack_require__(25);
var View_1 = __webpack_require__(3);
var GenericButton_1 = __webpack_require__(90);
var Scrollbar_1 = __webpack_require__(148);
var DraggingComponent_1 = __webpack_require__(504);
var SpriteGraphics_1 = __webpack_require__(62);
var GameUtils_1 = __webpack_require__(26);
var ButtonsMenu = /** @class */ (function (_super) {
    __extends(ButtonsMenu, _super);
    function ButtonsMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // TODO: Place these on device instead?
        _this._buttons = [];
        _this._buttonDisabledTint = 0x111100;
        _this._buttonValues = [];
        _this._acceptEnabled = false;
        return _this;
    }
    ButtonsMenu.prototype.init = function () {
        _super.prototype.init.call(this);
        this.setupTextStyles();
        this.setupBaseLayout();
        this.setupBaseButtons();
    };
    ButtonsMenu.prototype.show = function () {
        _super.prototype.show.call(this);
        this.enableInput();
        this.emitOpened();
    };
    ButtonsMenu.prototype.hide = function () {
        _super.prototype.hide.call(this);
        this.disableInput();
        this.emitClosed();
    };
    ButtonsMenu.prototype.preCallback = function (valueId) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        for (var _a = 0, _b = this._buttons; _a < _b.length; _a++) {
            var button = _b[_a];
            if (button.id !== valueId) {
                button.resetState();
            }
        }
    };
    Object.defineProperty(ButtonsMenu.prototype, "title", {
        set: function (title) {
            this._menuTitle.text = title;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonsMenu.prototype, "callback", {
        set: function (callback) {
            this._buttonsCallback = callback;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonsMenu.prototype, "tapDownCallback", {
        set: function (callback) {
            this._tapDownCallback = callback;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonsMenu.prototype, "mouseOutCallback", {
        set: function (callback) {
            this._mouseOutCallback = callback;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonsMenu.prototype, "offset", {
        set: function (_a) {
            var xOffset = _a[0], yOffset = _a[1];
            this._xOffset = xOffset;
            this._yOffset = yOffset;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonsMenu.prototype, "buttonValues", {
        set: function (buttonValues) {
            this._buttonValues = buttonValues;
            this.generateButtons();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ButtonsMenu.prototype, "buttonDisabledTint", {
        set: function (value) {
            this._buttonDisabledTint = value;
        },
        enumerable: true,
        configurable: true
    });
    ButtonsMenu.prototype.enableInput = function () {
        if (this._draggingComponent) {
            this._draggingComponent.enable();
        }
    };
    ButtonsMenu.prototype.disableInput = function () {
        if (this._draggingComponent) {
            this._draggingComponent.disable();
        }
    };
    ButtonsMenu.prototype.emitOpened = function () {
    };
    ButtonsMenu.prototype.emitClosed = function () {
    };
    ButtonsMenu.prototype.emitButtonPressed = function () {
    };
    ButtonsMenu.prototype.emitAccepted = function () {
    };
    ButtonsMenu.prototype.emitCancelled = function () {
    };
    ButtonsMenu.prototype.onCancelPressed = function () {
        this.soundPlayer.play('buttonClick');
        this.emitCancelled();
        // this.hide();
    };
    ButtonsMenu.prototype.onAcceptPressed = function () {
        this.soundPlayer.play('buttonClick');
        this.emitAccepted();
        // this.hide();
    };
    ButtonsMenu.prototype.setupTextStyles = function () {
        this._titleStyle = this.textStyles.buttonMenuTitleStyle;
        // this._titleStyle.wordWrapWidth = this.resolutionManager.resolution.width;
        this._buttonStyle = this.textStyles.buttonBaseStyle;
        this._buttonOverStyle = this.textStyles.buttonOverStyle;
        this._buttonDownStyle = this.textStyles.buttonDownStyle;
        this._buttonDisabledStyle = this.textStyles.buttonDisabledStyle;
    };
    ButtonsMenu.prototype.setupBaseLayout = function () {
        this._spineLayout = new Spine_1.Spine(this.resources.getSpine('BOX_MENU.json'));
        this._background = this._spineLayout.slotContainers[this._spineLayout.skeleton.findSlotIndex('BACKGROUND_SOLID')];
        this._titleBackground = this._spineLayout.slotContainers[this._spineLayout.skeleton.findSlotIndex('MENU_TITLE_BACKGROUND')];
        var menuTitleBone = this._spineLayout.slotContainers[this._spineLayout.skeleton.findSlotIndex('MENU_TITLE')];
        var containerBox = this._spineLayout.slotContainers[this._spineLayout.skeleton.findSlotIndex('BOX_CONTAINER')];
        var acceptButton = this._spineLayout.slotContainers[this._spineLayout.skeleton.findSlotIndex('ACCEPT_BUTTON')];
        var acceptConfirmButton = this._spineLayout.slotContainers[this._spineLayout.skeleton.findSlotIndex('ACCEPT_BUTTON_CONFIRM')];
        var declineButton = this._spineLayout.slotContainers[this._spineLayout.skeleton.findSlotIndex('DECLINE_BUTTON')];
        var declineConfirmButton = this._spineLayout.slotContainers[this._spineLayout.skeleton.findSlotIndex('DECLINE_BUTTON_EXIT')];
        var cleanChildrenList = [containerBox, acceptButton, acceptConfirmButton, declineButton, declineConfirmButton];
        for (var _i = 0, cleanChildrenList_1 = cleanChildrenList; _i < cleanChildrenList_1.length; _i++) {
            var child = cleanChildrenList_1[_i];
            child.removeChildren();
        }
        this._background.interactive = true;
        this._menuTitle = new PIXI.Text('Title', this._titleStyle);
        this._menuTitle.anchor.set(0.5, 0.5);
        menuTitleBone.addChild(this._menuTitle);
        this._menuTitle.transform = menuTitleBone.children[0].transform;
        this.container.addChild(this._spineLayout);
        this._spineLayout.position.set(this.resolutionManager.halfResolution.width, this.resolutionManager.halfResolution.height);
        this._spineLayout.update(0);
    };
    ButtonsMenu.prototype.setupBaseButtons = function () {
        this._acceptCancelContainer = new PIXI.Container();
        this.container.addChild(this._acceptCancelContainer);
        var acceptPosition = this._spineLayout.skeleton.findBone('ACCEPT_BUTTON').data;
        var cancelPosition = this._spineLayout.skeleton.findBone('DECLINE_BUTTON').data;
        this._acceptButton = this.spineUtils.createSpineButton('ACCEPT_BUTTON.json', this.onAcceptPressed.bind(this));
        this._cancelButton = this.spineUtils.createSpineButton('DECLINE_BUTTON.json', this.onCancelPressed.bind(this));
        this._acceptButton.position.set(this.resolutionManager.halfResolution.width, this.resolutionManager.halfResolution.height);
        this._cancelButton.position.set(this.resolutionManager.halfResolution.width, this.resolutionManager.halfResolution.height);
        this._acceptButton.setTransform(this.resolutionManager.halfResolution.width + acceptPosition.x, this.resolutionManager.resolution.height - (this.resolutionManager.halfResolution.height + acceptPosition.y));
        this._cancelButton.setTransform(this.resolutionManager.halfResolution.width + cancelPosition.x, this.resolutionManager.resolution.height - (this.resolutionManager.halfResolution.height + cancelPosition.y));
        this._acceptCancelContainer.addChild(this._acceptButton);
        this._acceptCancelContainer.addChild(this._cancelButton);
        this.offset = [this._acceptButton.container.width, this._acceptButton.container.height];
    };
    ButtonsMenu.prototype.generateButtons = function () {
        if (this._buttonValues) {
            this._buttonsContainer = new PIXI.Container();
            this.container.addChildAt(this._buttonsContainer, this.container.children.length - 1);
            for (var _i = 0, _a = this._buttonValues; _i < _a.length; _i++) {
                var buttonValue = _a[_i];
                var button = this.createButton(buttonValue);
                this._buttons.push(button);
                this._buttonsContainer.addChild(button);
            }
            this.layoutButtons();
        }
    };
    ButtonsMenu.prototype.layoutButtons = function () {
        var boxMenuSkeleton = this.resources.getSpine('BOX_MENU.json');
        var boxContainer = this.spineUtils.getBoneAbsolutePosition(boxMenuSkeleton, 'BOX_CONTAINER');
        var yPosTop = this.spineUtils.getBoneAbsolutePosition(boxMenuSkeleton, 'MENU_TITLE_BONE').y;
        var slotAttachmentDataTop = this.spineUtils.getSlotAttachmentDimensions(boxMenuSkeleton, 'MENU_TITLE_BACKGROUND');
        var startY = this.resolutionManager.halfResolution.height - yPosTop + slotAttachmentDataTop.height * slotAttachmentDataTop.scale.y * 0.5;
        var acceptBone = this._spineLayout.skeleton.findBone('ACCEPT_BUTTON').data;
        var declineBone = this._spineLayout.skeleton.findBone('DECLINE_BUTTON').data;
        var buttonItem = this._buttons[0].children[0];
        var halfButtonDimension = { x: buttonItem.width * 0.5, y: buttonItem.height * 0.5 };
        var layoutLimit = {
            x: 0,
            y: this.resolutionManager.halfResolution.height - acceptBone.y - startY - halfButtonDimension.y,
        };
        var initialPos = this.spineUtils.getBoneAbsolutePosition(this.resources.getSpine('BOX_MENU.json'), 'BOX_CONTAINER');
        var startPosition = {
            x: this.resolutionManager.halfResolution.width - halfButtonDimension.x * 3,
            y: this.resolutionManager.halfResolution.height - boxContainer.y,
        };
        var xPosition = 0;
        var yPosition = 0;
        for (var button = 0; button < this._buttons.length; button++) {
            xPosition = this._xOffset * (button % 4) + startPosition.x;
            yPosition = this._yOffset * Math.floor(button / 4) + startPosition.y;
            this._buttons[button].position.set(xPosition, yPosition);
        }
        yPosition -= startY - this._yOffset;
        if (yPosition >= layoutLimit.y) {
            var scrollBarWidth = this.device.isMobile
                ? Scrollbar_1.ScrollbarConstants.SCROLLBAR_WIDTH_MOBILE
                : Scrollbar_1.ScrollbarConstants.SCROLLBAR_WIDTH;
            var scrollbarPosition = {
                x: this.resolutionManager.resolution.width - scrollBarWidth,
                // x: startPosition.x - halfButtonDimension.x - scrollBarWidth * 2,
                // y: startPosition.y - halfButtonDimension.y,
                y: startY,
            };
            var scrollbarHeight = layoutLimit.y;
            var containerVisibleHeight = layoutLimit.y;
            var containerTotalHeight = yPosition;
            this.setupButtonsMask(this.resolutionManager.resolution.width, layoutLimit.y, scrollbarPosition.y);
            this._scrollbar = this.setupScrollbar(scrollBarWidth, scrollbarHeight, containerVisibleHeight, containerTotalHeight, scrollbarPosition);
            this._draggingComponent = new DraggingComponent_1.DraggingComponent(this.updateManager, this._buttonsContainer, this._background.children[0], this.device.isMobile);
            var limits = {
                maxX: this._buttonsContainer.x,
                maxY: 0,
                minX: this._buttonsContainer.x,
                minY: -(yPosition - layoutLimit.y),
            };
            this._scrollbar.setupInteraction(this.updateManager, this._buttonsContainer, this.device.isMobile, limits);
            this._draggingComponent.canDrag = true;
            this._draggingComponent.addlisteningComponent(this._scrollbar);
            this._draggingComponent.maxY = 0;
            this._draggingComponent.minY = -(yPosition - layoutLimit.y);
        }
    };
    ButtonsMenu.prototype.setupButtonsMask = function (maskWidth, maskHeight, positionY, positionX) {
        if (positionY === void 0) { positionY = 0; }
        if (positionX === void 0) { positionX = 0; }
        var buttonsMask = SpriteGraphics_1.SpriteGraphics.makeRectangle(maskWidth, maskHeight);
        this.container.addChild(buttonsMask);
        buttonsMask.position.set(positionX, positionY);
        this._buttonsContainer.mask = buttonsMask;
    };
    ButtonsMenu.prototype.setupScrollbar = function (barWidth, barheight, containerVisibleHeight, containerTotalHeight, barposition) {
        var scrollBar = new Scrollbar_1.InteractiveScrollbar(barWidth, barheight, containerVisibleHeight, containerTotalHeight);
        this.container.addChild(scrollBar);
        scrollBar.position.set(barposition.x, barposition.y);
        return scrollBar;
    };
    ButtonsMenu.prototype.createButton = function (value) {
        // console.warn(value);
        var button = new GenericButton_1.GenericButton(this._buttonsCallback.bind(this, value));
        if (this._tapDownCallback) {
            button.tapDownCallback = this._tapDownCallback.bind(this, value);
        }
        if (this._mouseOutCallback) {
            button.mouseOutCallback = this._mouseOutCallback.bind(this, value);
        }
        button.id = value;
        var textValue = this.formatText(value);
        var up = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'MENU_BUTTONS.png'));
        var down = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'MENU_BUTTONS_WHITE.png'));
        var over = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'MENU_BUTTONS_HOVER.png'));
        var disabled = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'MENU_BUTTONS.png'));
        up.anchor.set(0.5, 0.5);
        down.anchor.set(0.5, 0.5);
        over.anchor.set(0.5, 0.5);
        disabled.anchor.set(0.5, 0.5);
        var textUp = new PIXI.Text(textValue, this._buttonStyle);
        textUp.anchor.set(0.5, 0.5);
        up.addChild(textUp);
        var textDown = new PIXI.Text(textValue, this._buttonDownStyle);
        textDown.anchor.set(0.5, 0.5);
        down.addChild(textDown);
        var textOver = new PIXI.Text(textValue, this._buttonOverStyle);
        textOver.anchor.set(0.5, 0.5);
        over.addChild(textOver);
        var textDisabled = new PIXI.Text(textValue, this._buttonDisabledStyle);
        textDisabled.anchor.set(0.5, 0.5);
        disabled.addChild(textDisabled);
        var maxSize = { x: up.width * 0.85, y: up.height * 0.9 }; // 0.9 is for button padding in this case. So the text doesn't go out to the edges of the sprite size.
        GameUtils_1.GameUtils.correctSpriteScale(textUp, maxSize);
        GameUtils_1.GameUtils.correctSpriteScale(textDown, maxSize);
        GameUtils_1.GameUtils.correctSpriteScale(textOver, maxSize);
        GameUtils_1.GameUtils.correctSpriteScale(textDisabled, maxSize);
        disabled.tint = this.buttonDisabledTint;
        button.setFrames(up, down, over, disabled);
        // button.anchor.set(0.5, 0.5);
        return button;
    };
    ButtonsMenu.prototype.formatText = function (text) {
        return text;
    };
    ButtonsMenu.prototype.setupButtonEvents = function () {
    };
    ButtonsMenu.prototype.clearButtons = function () {
        if (this._buttons.length === 0) {
            return;
        }
        for (var index = this._buttons.length; index > 0; index--) {
            var element = this._buttons[index];
            element.destroy();
        }
        this._buttonValues = [];
    };
    ButtonsMenu.Y_BUTTON_OFFSET = 90;
    return ButtonsMenu;
}(View_1.View));
exports.ButtonsMenu = ButtonsMenu;


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Easing_1 = __webpack_require__(16);
var Tween_1 = __webpack_require__(19);
var GameUtils_1 = __webpack_require__(26);
var MouseWheelEvent_1 = __webpack_require__(505);
var DraggingComponent = /** @class */ (function () {
    function DraggingComponent(updateManager, draggingContainer, interactiveContainer, isMobile, activate) {
        if (activate === void 0) { activate = true; }
        this._maxAcceleration = 900;
        this._baseYPosition = 0;
        this._baseXPosition = 0;
        // TODO: Needs to check PPI / DPI
        this._maxYDrag = 300;
        this._minYDrag = -300;
        this._maxXDrag = 0;
        this._minXDrag = 0;
        this._interactionContainerBasePositionY = 0;
        this._restoreOnDragEnd = false;
        this._endDragTweenDuration = 500;
        this._endDragTweenEasing = Easing_1.Easing.Cubic.Out;
        this._lastDragMoveYPosition = 0;
        this._lastDragMoveXPosition = 0;
        this._listeningComponents = [];
        this._controllingComponents = [];
        this._useMouseScroll = true;
        this._updateInteractiveContainerPosition = false;
        this._updateManager = updateManager;
        this._draggingContainer = draggingContainer;
        this._interactionContainer = interactiveContainer;
        this._isMobile = isMobile;
        if (!this._isMobile && this._useMouseScroll) {
            this._scroll = new MouseWheelEvent_1.MouseWheelEvent(interactiveContainer, this.onScroll.bind(this));
        }
        this.initialize();
    }
    DraggingComponent.prototype.initialize = function () {
        this._interactionContainer.on('touchstart', this.onDragStart.bind(this));
        this._interactionContainer.on('mousedown', this.onDragStart.bind(this));
    };
    DraggingComponent.prototype.enable = function () {
        this.canDrag = true;
        if (!this.isMobile && this._useMouseScroll) {
            this._scroll.startEvent();
        }
    };
    DraggingComponent.prototype.disable = function () {
        this.canDrag = false;
        if (!this.isMobile && this._useMouseScroll) {
            this._scroll.stopEvent();
        }
    };
    DraggingComponent.prototype.onDragStart = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (!this.canDrag) {
            return;
        }
        this.finishDragTween();
        this._containerDragStartY = this._draggingContainer.y;
        this._containerDragStartX = this._draggingContainer.x;
        this._dragStartY = event.data.global.y;
        this._dragStartX = event.data.global.x;
        this._dragStartTime = event.data.originalEvent.timeStamp;
        this._lastDragMoveTime = Math.floor(event.data.originalEvent.timeStamp * 0.005);
        this._lastDragMoveYPosition = event.data.global.y;
        this._lastDragMoveXPosition = event.data.global.x;
        this._interactionContainer.on('touchend', this.onDragStop.bind(this));
        this._interactionContainer.on('touchcancel', this.onDragStop.bind(this));
        this._interactionContainer.on('touchendoutside', this.onDragStop.bind(this));
        this._interactionContainer.on('touchmove', this.onDragMoveEvent.bind(this));
        this._interactionContainer.on('mousemove', this.onDragMoveEvent.bind(this));
        this._interactionContainer.on('mouseup', this.onDragStop.bind(this));
        this._interactionContainer.on('mouseout', this.onDragStop.bind(this));
        if (this.isMobile) {
        }
        else {
            this._scroll.stopEvent();
            this._interactionContainer.on('rightup', this.onDragStop.bind(this));
        }
        this.draggingStarted(event);
    };
    DraggingComponent.prototype.finishDragTween = function () {
        if (this._endDragTween && this._endDragTween.isPlaying) {
            this._endDragTween.stop();
            this._endDragTween = null;
        }
    };
    DraggingComponent.prototype.onDragStop = function (event) {
        var _this = this;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (!this.isDragging) {
            return;
        }
        var endY = event.data.global.y;
        var endX = event.data.global.x;
        var deltaY = endY - this._lastDragMoveYPosition;
        var deltaX = endX - this._lastDragMoveXPosition;
        var endTime = event.data.originalEvent.timeStamp;
        var deltaTime = (endTime - this._dragStartTime) * 0.005;
        var acceleration = Math.max(this._maxAcceleration * -1, Math.min(this._maxAcceleration, deltaY / (deltaTime === 0 ? 1 : deltaTime)));
        var tweenObject = { x: 0 };
        var goalY = Math.max(Math.min(acceleration + this._draggingContainer.y, this._maxYDrag), this._minYDrag);
        var goalX = Math.max(Math.min(acceleration + this._draggingContainer.x, this._maxXDrag), this._minXDrag);
        var startY = this._draggingContainer.y;
        var startX = this._draggingContainer.x;
        // if (deltaY / deltaTime >= SwipeInteractionView.ACCELERATION_THRESHOLD || deltaY > SwipeInteractionView.DISTANCE_THRESHOLD) {
        if (this._restoreOnDragEnd) {
            this.restoreContainerAnimated();
        }
        else {
            var tweenObject_1 = { fract: 0 };
            this._endDragTween = new Tween_1.Tween(tweenObject_1)
                .to({ fract: 1 }, this._endDragTweenDuration)
                .easing(this._endDragTweenEasing)
                .onUpdate(function () {
                var newValueY = GameUtils_1.GameUtils.lerp(_this._draggingContainer.y, goalY, tweenObject_1.fract);
                var newValueX = GameUtils_1.GameUtils.lerp(_this._draggingContainer.x, goalX, tweenObject_1.fract);
                _this.updateDraggingContainer(newValueY, newValueX, tweenObject_1.fract);
            })
                .start();
            this.updateManager.add(this._endDragTween);
        }
        this.draggingFinished();
    };
    DraggingComponent.prototype.onForceStopDrag = function () {
        if (!this.isDragging) {
            return;
        }
        if (this._restoreOnDragEnd) {
            this.restoreContainerAnimated();
        }
        this.draggingFinished();
    };
    DraggingComponent.prototype.onCancelDrag = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (!this.isDragging) {
            return;
        }
        if (this._restoreOnDragEnd) {
            this.restoreContainerAnimated();
        }
    };
    DraggingComponent.prototype.onDragMoveEvent = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var deltaY = event.data.global.y - this._dragStartY;
        var deltaX = event.data.global.x - this._dragStartX;
        // const newY: number = Math.max(Math.min(deltaY, this._maxYDrag), this._minYDrag); // For Resetting
        // const newX: number = Math.max(Math.min(deltaX, this._maxXDrag), this._minXDrag); // For Resetting
        var newY = Math.max(Math.min(deltaY + this._containerDragStartY, this._maxYDrag), this._minYDrag);
        var newX = Math.max(Math.min(deltaX + this._containerDragStartX, this._maxXDrag), this._minXDrag);
        var currentTime = Math.floor(event.data.originalEvent.timeStamp * 0.005);
        if (currentTime > this._lastDragMoveTime) {
            this._lastDragMoveTime = currentTime;
            this._lastDragMoveYPosition = event.data.global.y;
            this._lastDragMoveXPosition = event.data.global.x;
        }
        // this._draggingContainer.y = newY;
        this.updateDraggingContainer(newY, newX, 0);
        this.updateInteractiveContainer(newY, newX, 0);
    };
    DraggingComponent.prototype.updateInteractiveContainer = function (y, x, fraction) {
        if (this._updateInteractiveContainerPosition) {
            // this._draggingContainer.y = newPositionY;
            // this._draggingContainer.x = newPositionX;
            var fractX = GameUtils_1.GameUtils.normalize(x, this._maxXDrag, this._minXDrag);
            var fractY = GameUtils_1.GameUtils.normalize(y, this._maxYDrag, this._minYDrag);
            // const data = {x: newPositionX, y: newPositionY, fractX, fractY};
            // this.updateListeners(data);
            this._interactionContainer.position.set(fractX, fractY);
        }
    };
    DraggingComponent.prototype.clearListeners = function () {
        this._interactionContainer.removeListener('touchend');
        this._interactionContainer.removeListener('touchendoutside');
        this._interactionContainer.removeListener('touchmove');
        this._interactionContainer.removeListener('touchcancel');
        this._interactionContainer.removeListener('mousemove');
        this._interactionContainer.removeListener('mouseup');
        this._interactionContainer.removeListener('mouseout');
        if (this._isMobile) {
        }
        else {
            this._interactionContainer.removeListener('rightup');
        }
    };
    DraggingComponent.prototype.restoreContainerAnimated = function () {
        var _this = this;
        this._dragStartX = null;
        this._dragStartY = null;
        var tweenObject = { fract: 0 };
        this._restoreTween = new Tween_1.Tween(tweenObject)
            .to({ y: 1 }, DraggingComponent.RESTORE_ANIMATION_DURATION)
            .easing(Easing_1.Easing.Back.Out)
            .onUpdate(function () {
            var newValueY = GameUtils_1.GameUtils.lerp(_this._draggingContainer.y, _this.baseYPosition, tweenObject.fract);
            var newValueX = GameUtils_1.GameUtils.lerp(_this._draggingContainer.x, _this.baseXPosition, tweenObject.fract);
            _this.updateDraggingContainer(newValueY, newValueX, tweenObject.fract);
        })
            .start();
        this.updateManager.add(this._restoreTween);
    };
    DraggingComponent.prototype.draggingStarted = function (event) {
        this.isDragging = true;
        // this.emitDraggingStarted();
    };
    DraggingComponent.prototype.draggingFinished = function () {
        this.clearListeners();
        this._dragStartX = null;
        this._dragStartY = null;
        if (!this.isMobile) {
            this._scroll.startEvent(true);
        }
        // this.emitDraggingFinished();
    };
    DraggingComponent.prototype.updateDraggingContainer = function (newPositionY, newPositionX, fraction) {
        this._draggingContainer.y = newPositionY;
        this._draggingContainer.x = newPositionX;
        var fractX = GameUtils_1.GameUtils.normalize(newPositionX, this._maxXDrag, this._minXDrag);
        var fractY = GameUtils_1.GameUtils.normalize(newPositionY, this._maxYDrag, this._minYDrag);
        var data = { x: newPositionX, y: newPositionY, fractX: fractX, fractY: fractY };
        this.updateListeners(data);
    };
    DraggingComponent.prototype.updateListeners = function (data) {
        for (var item = 0; item < this._listeningComponents.length; item++) {
            var component = this._listeningComponents[item];
            component.updateFromController(data);
            // }
        }
    };
    DraggingComponent.prototype.addlisteningComponent = function (component) {
        if (typeof component !== 'object') {
            // console.log('Not a valid component. Needs to be of type object.');
            return;
        }
        this.bindListener(component);
    };
    DraggingComponent.prototype.bindListener = function (object) {
        this._listeningComponents.push(object);
    };
    DraggingComponent.prototype.unbindListener = function (object) {
        var index = this._listeningComponents.indexOf(object);
        this._listeningComponents.splice(index, 1);
    };
    DraggingComponent.prototype.removeListeningComponent = function (component) {
        if (typeof component !== 'object' || this._listeningComponents.indexOf(component) === -1) {
            return false;
        }
        var index = this._listeningComponents.indexOf(component);
        this._listeningComponents.splice(index, 1);
        return true;
    };
    DraggingComponent.prototype.addControllerComponent = function (component) {
        if (typeof component !== 'object') {
            return;
        }
        component.bindListener.bind(this);
        this._controllingComponents.push(component);
    };
    DraggingComponent.prototype.removeControllerComponent = function (component) {
        if (typeof component !== 'object' || this._controllingComponents.indexOf(component) === -1) {
            return false;
        }
        var index = this._controllingComponents.indexOf(component);
        component.unbindListener(this);
        this._controllingComponents.splice(index, 1);
        return true;
    };
    DraggingComponent.prototype.updateFromController = function (data) { };
    DraggingComponent.prototype.onScroll = function (delta) {
        var newPosY = Math.max(Math.min(this._draggingContainer.y - delta.y, this._maxYDrag), this._minYDrag);
        var newPosX = Math.max(Math.min(this._draggingContainer.x + delta.x, this._maxXDrag), this._minXDrag);
        this.finishDragTween();
        this.updateDraggingContainer(newPosY, newPosX, 0);
    };
    DraggingComponent.prototype.resetPosition = function () {
        this._interactionContainer.y = this.interactiveContainerBasePositionY;
        this._draggingContainer.y = this._baseYPosition;
    };
    Object.defineProperty(DraggingComponent.prototype, "interactiveContainerBasePositionY", {
        get: function () {
            return this._interactionContainerBasePositionY;
        },
        set: function (v) {
            this._interactionContainerBasePositionY = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DraggingComponent.prototype, "isDragging", {
        get: function () {
            return this._isDragging;
        },
        set: function (v) {
            this._isDragging = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DraggingComponent.prototype, "canDrag", {
        get: function () {
            return this._canDrag;
        },
        set: function (v) {
            this._canDrag = this._interactionContainer.interactive = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DraggingComponent.prototype, "isMobile", {
        get: function () {
            return this._isMobile;
        },
        set: function (value) {
            this._isMobile = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DraggingComponent.prototype, "updateManager", {
        get: function () {
            return this._updateManager;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DraggingComponent.prototype, "baseYPosition", {
        set: function (posY) {
            this._baseYPosition = posY;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DraggingComponent.prototype, "baseXPosition", {
        set: function (posX) {
            this._baseXPosition = posX;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DraggingComponent.prototype, "minY", {
        set: function (pos) {
            this._minYDrag = pos;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DraggingComponent.prototype, "minX", {
        set: function (pos) {
            this._minXDrag = pos;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DraggingComponent.prototype, "maxY", {
        set: function (pos) {
            this._maxYDrag = pos;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DraggingComponent.prototype, "maxX", {
        set: function (pos) {
            this._maxXDrag = pos;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DraggingComponent.prototype, "endDragTweenEasing", {
        set: function (easing) {
            this._endDragTweenEasing = easing;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DraggingComponent.prototype, "endDragTweenDuration", {
        set: function (duration) {
            this._endDragTweenDuration = duration;
        },
        enumerable: true,
        configurable: true
    });
    DraggingComponent.RESTORE_ANIMATION_DURATION = 200;
    return DraggingComponent;
}());
exports.DraggingComponent = DraggingComponent;


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MouseWheelEvent = /** @class */ (function () {
    /**
     * Mouse scroll event class. Add to object - setup start, stop and callback events. Outputs delta position.
     * TODO: Check regular and standardized 'wheel' event.
     * @param {*} obj
     * @param {Function} scrollCallback
     * @memberof MouseScrollEvent
     */
    function MouseWheelEvent(obj, scrollCallback) {
        this.bound = false;
        this.delta = new PIXI.Point();
        this.scrollCallback = scrollCallback;
        this.obj = obj;
        this.onMouseScroll = this._onMouseScroll.bind(this);
        // To keep the correct context when the function is removed from the eventlistener.
    }
    MouseWheelEvent.prototype._onMouseScroll = function (event) {
        if (this.preventDefault) {
            event.preventDefault();
        }
        if (typeof event.deltaX !== 'undefined') {
            this.delta.set(event.deltaX, event.deltaY);
        }
        else {
            // Firefox
            this.delta.set(event.axis === 1 ? event.detail * 60 : 0, event.axis === 2 ? event.detail * 60 : 0);
        }
        this.scrollCallback(this.delta);
    };
    MouseWheelEvent.prototype.onHover = function (event) {
        if (!this.bound) {
            document.addEventListener('mousewheel', this.onMouseScroll);
            document.addEventListener('DOMMouseScroll', this.onMouseScroll);
            this.bound = true;
        }
    };
    MouseWheelEvent.prototype.onMouseOut = function (event) {
        if (this.bound) {
            document.removeEventListener('mousewheel', this.onMouseScroll);
            document.removeEventListener('DOMMouseScroll', this.onMouseScroll);
            this.bound = false;
        }
    };
    MouseWheelEvent.prototype.stopEvent = function () {
        if (this.bound) {
            document.removeEventListener('mousewheel', this.onMouseScroll);
            document.removeEventListener('DOMMouseScroll', this.onMouseScroll);
            this.bound = false;
        }
        this.obj.removeListener('mouseover', this.onHover);
        this.obj.removeListener('mouseout', this.onMouseOut);
    };
    MouseWheelEvent.prototype.startEvent = function (hovering) {
        if (hovering === void 0) { hovering = false; }
        this.obj.on('mouseover', this.onHover.bind(this));
        this.obj.on('mouseout', this.onMouseOut.bind(this));
        if (hovering) {
            this.onHover(null);
        }
    };
    return MouseWheelEvent;
}());
exports.MouseWheelEvent = MouseWheelEvent;


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ViewManager_1 = __webpack_require__(241);
var IViewsManager_1 = __webpack_require__(243);
var GameViews_1 = __webpack_require__(43);
var Views_1 = __webpack_require__(8);
var ReelConstants_1 = __webpack_require__(10);
var View_1 = __webpack_require__(3);
var GameReelConstants_1 = __webpack_require__(34);
var GameViewManager = /** @class */ (function (_super) {
    __extends(GameViewManager, _super);
    function GameViewManager() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameViewManager.prototype.createGameSpecificViews = function () {
        _super.prototype.createGameSpecificViews.call(this);
        this.createPaytableView();
        this.createGameRulesView();
        this.createMainMenuView();
        this.createSettingsView();
        this.createGameInfoView();
        this.createStartscreenView();
        this.createFreeSpinsInfoView();
        this.createFreeSpinsView();
        this.createRespinView();
        this.createView(GameViews_1.GameViews.TOP_REELS_VIEW, IViewsManager_1.Layers.STICKY_SYMBOLS_LAYER);
        this.createView(GameViews_1.GameViews.UNDER_TOP_REELS_VIEW, IViewsManager_1.Layers.LOGOTYPE_BACKGROUND_LAYER);
        this.createView(GameViews_1.GameViews.WILD_METER_VIEW, IViewsManager_1.Layers.WIN_TEXT_LAYER);
        this.createView(GameViews_1.GameViews.WIN_LINES_PRESENTATION_VIEW, IViewsManager_1.Layers.WIN_LINES_LAYER);
        this.createView(GameViews_1.GameViews.WIN_FIELD_VIEW, IViewsManager_1.Layers.STICKY_SYMBOLS_LAYER);
        this.createView(GameViews_1.GameViews.FREE_SPINS_TRIGGER_VIEW, IViewsManager_1.Layers.POPUPS_LAYER);
        this.createMicrogamingFreeRoundsView();
        this.createMicrogamingFreeRoundsInGameView();
    };
    GameViewManager.prototype.createParticleView = function () {
        // const viewName: string = this._system.shouldUseMultipleViews() ? Views.PARTICLE_VIEW_MOBILE : Views.PARTICLE_VIEW;
        //
        // const view: ParticleView = this._container.get(viewName);
        // this._views[viewName] = view;
        // this._zOrder[viewName] = Layers.GUI_INFO_LAYER;
        //
        // if (this._system.shouldUseMultipleViews()) {
        // 	view.addStandardMobileViews(Views.PARTICLE_VIEW);
        // }
    };
    GameViewManager.prototype.createLogotypeView = function () {
        var view = this._container.get(Views_1.Views.LOGOTYPE_VIEW);
        this._views[Views_1.Views.LOGOTYPE_VIEW] = view;
        this._zOrder[Views_1.Views.LOGOTYPE_VIEW] = IViewsManager_1.Layers.INFORMATION_POPUPS_LAYER;
    };
    GameViewManager.prototype.createReelsView = function () {
        this.setupLayout();
        var reelsViewName = Views_1.Views.REELS_VIEW;
        var reelsView = this._container.get(reelsViewName);
        this._views[reelsViewName] = reelsView;
        this._zOrder[reelsViewName] = IViewsManager_1.Layers.REELS_LAYER;
        ReelConstants_1.ReelConstants.REELS_AMOUNT = 5;
        ReelConstants_1.ReelConstants.ROW_AMOUNT = 6;
        ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT = 6;
        ReelConstants_1.ReelConstants.LINES = 10;
        ReelConstants_1.ReelConstants.BOTH_WAYS = true;
    };
    GameViewManager.prototype.createFreeSpinsView = function () {
        var freeSpinsView = this._container.get(Views_1.Views.FREE_SPINS_VIEW);
        this._views[Views_1.Views.FREE_SPINS_VIEW] = freeSpinsView;
        this._zOrder[Views_1.Views.FREE_SPINS_VIEW] = IViewsManager_1.Layers.POPUPS_LAYER;
    };
    GameViewManager.prototype.createFreeSpinsInfoView = function () {
        var freeSpinsInfo = this._container.get(Views_1.Views.FREE_SPINS_INFO_VIEW);
        this._views[Views_1.Views.FREE_SPINS_INFO_VIEW] = freeSpinsInfo;
        this._zOrder[Views_1.Views.FREE_SPINS_INFO_VIEW] = IViewsManager_1.Layers.KEYPAD_LAYER;
    };
    GameViewManager.prototype.createDesktopBonusView = function () {
    };
    GameViewManager.prototype.createStartscreenView = function () {
        var gameStartscreen = this._container.get(Views_1.Views.STARTSCREEN_VIEW);
        this._views[Views_1.Views.STARTSCREEN_VIEW] = gameStartscreen;
        this._zOrder[Views_1.Views.STARTSCREEN_VIEW] = IViewsManager_1.Layers.POPUPS_LAYER;
    };
    GameViewManager.prototype.createGameRulesView = function () {
        var gameRulesView = this._container.get(Views_1.Views.GAME_RULES_VIEW);
        this._views[Views_1.Views.GAME_RULES_VIEW] = gameRulesView;
        this._zOrder[Views_1.Views.GAME_RULES_VIEW] = IViewsManager_1.Layers.OVER_POPUP2_LAYER;
    };
    GameViewManager.prototype.createSettingsView = function () {
        var settings = this._container.get(GameViews_1.GameViews.SETTINGS_VIEW);
        this._views[GameViews_1.GameViews.SETTINGS_VIEW] = settings;
        this._zOrder[GameViews_1.GameViews.SETTINGS_VIEW] = IViewsManager_1.Layers.MENU_LAYER;
    };
    GameViewManager.prototype.createMainMenuView = function () {
        var mainMenu = this._container.get(Views_1.Views.MAIN_MENU_VIEW);
        this._views[Views_1.Views.MAIN_MENU_VIEW] = mainMenu;
        this._zOrder[Views_1.Views.MAIN_MENU_VIEW] = IViewsManager_1.Layers.OVER_POPUP_LAYER;
    };
    GameViewManager.prototype.createPaytableView = function () {
        var paytableView = this._container.get(GameViews_1.GameViews.PAYTABLE_VIEW);
        this._views[GameViews_1.GameViews.PAYTABLE_VIEW] = paytableView;
        this._zOrder[GameViews_1.GameViews.PAYTABLE_VIEW] = IViewsManager_1.Layers.OVER_POPUP_LAYER;
    };
    GameViewManager.prototype.setupDesktopRespinView = function () {
    };
    GameViewManager.prototype.createBackgroundView = function () {
        var backgroundViewName = Views_1.Views.BACKGROUND_VIEW;
        var backgroundView = this._container.get(backgroundViewName);
        this._views[backgroundViewName] = backgroundView;
        this._zOrder[backgroundViewName] = IViewsManager_1.Layers.BACKGROUND_LAYER;
    };
    GameViewManager.prototype.createRespinView = function () {
        var respinView = this._container.get(GameViews_1.GameViews.RESPIN_VIEW);
        this._views[GameViews_1.GameViews.RESPIN_VIEW] = respinView;
        this._zOrder[GameViews_1.GameViews.RESPIN_VIEW] = IViewsManager_1.Layers.BONUS_LAYER;
    };
    GameViewManager.prototype.postInitialize = function () {
        _super.prototype.postInitialize.call(this);
        this._views[Views_1.Views.MAIN_MENU_VIEW].paytable = this._views[GameViews_1.GameViews.PAYTABLE_VIEW].container;
        this._views[Views_1.Views.MAIN_MENU_VIEW].settings = this._views[GameViews_1.GameViews.SETTINGS_VIEW].container;
        this._views[Views_1.Views.SWIPE_INTERACTION_VIEW].reelContainer = this._views[Views_1.Views.REELS_VIEW].container;
    };
    GameViewManager.prototype.setupLayout = function () {
        if (this.canInitializeFromLayout()) {
            GameReelConstants_1.GameReelConstants.initializeFromLayoutGameSpecific(this._layout);
        }
        else {
            throw new Error('ViewManager::createReelsView can not initialize from layout');
        }
    };
    GameViewManager.prototype.canInitializeFromLayout = function (viewType) {
        if (viewType === void 0) { viewType = View_1.ViewTypes.DESKTOP; }
        return (this._layout.isLoaded() &&
            this._layout.getPosition('TOP_REEL', viewType) !== null &&
            this._layout.getPosition('BOTTOM_REEL', viewType) !== null &&
            this._layout.getSize('SYMBOL_01', viewType) !== null);
    };
    GameViewManager.prototype.createView = function (viewName, layer) {
        var view = this._container.get(viewName);
        this._views[viewName] = view;
        this._zOrder[viewName] = layer;
    };
    return GameViewManager;
}(ViewManager_1.ViewManager));
exports.GameViewManager = GameViewManager;


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var AnimatedMaskParticle_1 = __webpack_require__(508);
var Emitter_1 = __webpack_require__(510);
var View_1 = __webpack_require__(3);
var pixi_js_1 = __webpack_require__(59);
var PARTICLE_EMITTER_NAMES;
(function (PARTICLE_EMITTER_NAMES) {
    PARTICLE_EMITTER_NAMES["Nice"] = "nice";
    PARTICLE_EMITTER_NAMES["Excellent"] = "excellent";
    PARTICLE_EMITTER_NAMES["Big"] = "big";
    PARTICLE_EMITTER_NAMES["Super"] = "super";
    PARTICLE_EMITTER_NAMES["Mega"] = "mega";
    PARTICLE_EMITTER_NAMES["Epic"] = "epic";
    PARTICLE_EMITTER_NAMES["Explosion"] = "explosion";
})(PARTICLE_EMITTER_NAMES = exports.PARTICLE_EMITTER_NAMES || (exports.PARTICLE_EMITTER_NAMES = {}));
var ParticleView = /** @class */ (function (_super) {
    __extends(ParticleView, _super);
    function ParticleView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ParticleView.prototype.init = function () {
        _super.prototype.init.call(this);
        this.setupParticleContainers();
        this.setupParticleContainersPositions();
    };
    ParticleView.prototype.setupParticleContainers = function () {
        this._bottomContainer = new pixi_js_1.Container();
        this._middleContainer = new pixi_js_1.Container();
        this.container.addChild(this._bottomContainer);
        this.container.addChild(this._middleContainer);
        this._middleContainer.name = 'mid particle container';
        this._bottomContainer.name = 'bot particle container';
    };
    ParticleView.prototype.setupParticleContainersPositions = function () {
        var bottomContainerPosition = this.layout.getAbsolutePosition('PARTICLE_COIN_EMITTER_LOW_WIN');
        var middleContainerPosition = this.layout.getAbsolutePosition('PARTICLE_COIN_EMITTER');
        var screenMiddlePosition = {
            x: this.resolutionManager.halfResolution.width,
            y: this.resolutionManager.halfResolution.height,
        };
        bottomContainerPosition = bottomContainerPosition ? bottomContainerPosition : screenMiddlePosition;
        middleContainerPosition = middleContainerPosition ? middleContainerPosition : screenMiddlePosition;
        this._bottomContainer.position.set(bottomContainerPosition.x, bottomContainerPosition.y);
        this._middleContainer.position.set(middleContainerPosition.x, middleContainerPosition.y);
    };
    ParticleView.prototype.stopCurrentParticleEmitter = function () {
        if (this._currentParticleEmitter) {
            this._currentParticleEmitter.emit = false;
        }
    };
    ParticleView.prototype.startEmitter = function (type) {
        this.stopCurrentParticleEmitter();
        switch (type) {
            case PARTICLE_EMITTER_NAMES.Nice:
                if (this._niceWinParticleEmitter) {
                    this.startParticleEmitter(this._niceWinParticleEmitter);
                }
                else {
                    this._niceWinParticleEmitter = this.setUpEmitter(PARTICLE_EMITTER_NAMES.Nice);
                    this.updateManager.add(this._niceWinParticleEmitter);
                }
                this._currentParticleEmitter = this._niceWinParticleEmitter;
                break;
            case PARTICLE_EMITTER_NAMES.Excellent:
                if (this._excellentWinParticleEmitter) {
                    this.startParticleEmitter(this._excellentWinParticleEmitter);
                }
                else {
                    this._excellentWinParticleEmitter = this.setUpEmitter(PARTICLE_EMITTER_NAMES.Excellent);
                    this.updateManager.add(this._excellentWinParticleEmitter);
                }
                this._currentParticleEmitter = this._excellentWinParticleEmitter;
                break;
            case PARTICLE_EMITTER_NAMES.Big:
                if (this._bigWinParticleEmitter) {
                    this.startParticleEmitter(this._bigWinParticleEmitter);
                }
                else {
                    this._bigWinParticleEmitter = this.setUpEmitter(PARTICLE_EMITTER_NAMES.Big);
                    this.updateManager.add(this._bigWinParticleEmitter);
                }
                this._currentParticleEmitter = this._bigWinParticleEmitter;
                break;
            case PARTICLE_EMITTER_NAMES.Super:
                if (this._superWinParticleEmitter) {
                    this.startParticleEmitter(this._superWinParticleEmitter);
                }
                else {
                    this._superWinParticleEmitter = this.setUpEmitter(PARTICLE_EMITTER_NAMES.Super);
                    this.updateManager.add(this._superWinParticleEmitter);
                }
                this._currentParticleEmitter = this._superWinParticleEmitter;
                break;
            case PARTICLE_EMITTER_NAMES.Mega:
                if (this._megaWinParticleEmitter) {
                    this.startParticleEmitter(this._megaWinParticleEmitter);
                }
                else {
                    this._megaWinParticleEmitter = this.setUpEmitter(PARTICLE_EMITTER_NAMES.Mega);
                    this.updateManager.add(this._megaWinParticleEmitter);
                }
                this._currentParticleEmitter = this._megaWinParticleEmitter;
                break;
            case PARTICLE_EMITTER_NAMES.Epic:
                if (this._epicWinParticleEmitter) {
                    this.startParticleEmitter(this._epicWinParticleEmitter);
                }
                else {
                    this._epicWinParticleEmitter = this.setUpEmitter(PARTICLE_EMITTER_NAMES.Epic);
                    this.updateManager.add(this._epicWinParticleEmitter);
                }
                this._currentParticleEmitter = this._epicWinParticleEmitter;
                break;
            case PARTICLE_EMITTER_NAMES.Explosion:
                if (this._winExplosionParticleEmitter) {
                    this.startParticleEmitter(this._winExplosionParticleEmitter);
                }
                else {
                    this._winExplosionParticleEmitter = this.setUpEmitter(PARTICLE_EMITTER_NAMES.Explosion);
                    this.updateManager.add(this._winExplosionParticleEmitter);
                }
                this._currentParticleEmitter = this._winExplosionParticleEmitter;
                break;
            default:
                break;
        }
    };
    ParticleView.prototype.setUpEmitter = function (type) {
        var particleConfig;
        var xMod;
        var yMod;
        var emitterContainer;
        switch (type) {
            case PARTICLE_EMITTER_NAMES.Nice:
                particleConfig = this.getParticlesConfig(PARTICLE_EMITTER_NAMES.Nice);
                xMod = 2;
                yMod = 1;
                emitterContainer = this._bottomContainer;
                break;
            case PARTICLE_EMITTER_NAMES.Excellent:
                particleConfig = this.getParticlesConfig(PARTICLE_EMITTER_NAMES.Excellent);
                xMod = 2;
                yMod = 1;
                emitterContainer = this._bottomContainer;
                break;
            case PARTICLE_EMITTER_NAMES.Big:
                particleConfig = this.getParticlesConfig(PARTICLE_EMITTER_NAMES.Big);
                xMod = 2;
                yMod = 2;
                emitterContainer = this._middleContainer;
                break;
            case PARTICLE_EMITTER_NAMES.Super:
                particleConfig = this.getParticlesConfig(PARTICLE_EMITTER_NAMES.Super);
                xMod = 2;
                yMod = 2;
                emitterContainer = this._middleContainer;
                break;
            case PARTICLE_EMITTER_NAMES.Mega:
                particleConfig = this.getParticlesConfig(PARTICLE_EMITTER_NAMES.Mega);
                xMod = 2;
                yMod = 2;
                emitterContainer = this._middleContainer;
                break;
            case PARTICLE_EMITTER_NAMES.Epic:
                particleConfig = this.getParticlesConfig(PARTICLE_EMITTER_NAMES.Epic);
                xMod = 2;
                yMod = 2;
                emitterContainer = this._middleContainer;
                break;
            case PARTICLE_EMITTER_NAMES.Explosion:
                particleConfig = this.getParticlesConfig(PARTICLE_EMITTER_NAMES.Explosion);
                xMod = 2;
                yMod = 2;
                emitterContainer = this._middleContainer;
                break;
            default:
                console.error('missing type');
                return;
        }
        var emitter = new Emitter_1.Emitter(emitterContainer, particleConfig, this._particleData);
        emitter.particleConstructor = AnimatedMaskParticle_1.AnimatedMaskParticle;
        // emitterContainer.position.set(this.resolutionManager.resolution.width / xMod, this.resolutionManager.resolution.height / yMod);
        return emitter;
    };
    ParticleView.prototype.getParticlesConfig = function (name) {
        var resourcePath;
        switch (name) {
            case PARTICLE_EMITTER_NAMES.Nice:
                resourcePath = 'resources/particles/NICE_WIN_COINS.json';
                break;
            case PARTICLE_EMITTER_NAMES.Excellent:
                resourcePath = 'resources/particles/EXCELLENT_WIN_COINS.json';
                break;
            case PARTICLE_EMITTER_NAMES.Big:
                resourcePath = 'resources/particles/BIG_WIN_COINS.json';
                break;
            case PARTICLE_EMITTER_NAMES.Super:
                resourcePath = 'resources/particles/SUPER_WIN_COINS.json';
                break;
            case PARTICLE_EMITTER_NAMES.Mega:
                resourcePath = 'resources/particles/MEGA_WIN_COINS.json';
                break;
            case PARTICLE_EMITTER_NAMES.Epic:
                resourcePath = 'resources/particles/EPIC_WIN_COINS.json';
                break;
            case PARTICLE_EMITTER_NAMES.Explosion:
                resourcePath = 'resources/particles/EPIC_WIN_WAVE_COINS.json';
                break;
            default:
                console.error('no name of particle provided');
                return;
        }
        var particlesConfig = [];
        this._particleData = this.resources.getParticleData(resourcePath);
        var coinFrames = this.getCoinSpritesheetAnimation();
        particlesConfig.push({
            framerate: 0.06,
            loop: true,
            particleImages: coinFrames,
        });
        return particlesConfig;
    };
    ParticleView.prototype.getCoinSpritesheetAnimation = function () {
        var coinFrames = [];
        var baseString = 'Coin_';
        var endString = '.png';
        var device = this.device.desktop ? 'DESKTOP' : 'MOBILE';
        var frameKeys = this.resources.getSpriteSheet(this.resources.getPathForResource("resources/particles/" + device + "/COIN.json"))
            ._frameKeys;
        for (var i = 1; i <= frameKeys.length; i++) {
            coinFrames.push(new PIXI.Sprite(this.resources.getSpritesheetTexture(this.resources.getPathForResource("resources/particles/" + device + "/COIN.json"), baseString + i.toString() + endString)));
        }
        coinFrames.splice(0, 1);
        return coinFrames;
    };
    ParticleView.prototype.startParticleEmitter = function (emitter) {
        this._currentParticleEmitter = emitter;
        this.updateManager.remove(this._currentParticleEmitter);
        this._currentParticleEmitter.emit = true;
        this.updateManager.add(this._currentParticleEmitter);
        this._currentParticleEmitter.start();
    };
    ParticleView.prototype.createAutoPlayButtonSprite = function () {
        return new PIXI.Sprite(this.resources.getSpritesheetTexture('resources/HUD.json', 'AUTOPLAY.png'));
    };
    return ParticleView;
}(View_1.View));
exports.ParticleView = ParticleView;


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var MaskSprite_1 = __webpack_require__(509);
__webpack_require__(222);
var AnimatedMaskParticle = /** @class */ (function (_super) {
    __extends(AnimatedMaskParticle, _super);
    function AnimatedMaskParticle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnimatedMaskParticle.parseArt = function (art) {
        var outArr = [];
        var particleArt = art;
        for (var i = 0; i < particleArt.length; ++i) {
            var data = particleArt[i];
            var output = (outArr[i] = {});
            output.particleImages = data.particleImages.slice();
            // use these values to signify that the animation should match the particle life time.
            if (data.framerate === 'matchLife') {
                // -1 means that it should be calculated
                output.framerate = -1;
                output.duration = 0;
                output.loop = false;
            }
            else {
                // determine if the animation should loop
                output.loop = !!data.loop;
                // get the framerate, default to 60
                output.framerate = (data.framerate > 0 ? data.framerate : 60);
                // determine the duration
                output.duration = (output.particleImages.length / output.framerate);
            }
        }
        return outArr;
    };
    AnimatedMaskParticle.prototype.update = function (delta) {
        var lerp = this.Particle_update(delta);
        var obj = this;
        // only animate the particle if it is still alive
        if (lerp >= 0) {
            obj.elapsed += delta;
            if (obj.elapsed + 0.000001 >= obj.duration) {
                // loop elapsed back around
                if (obj.loop) {
                    obj.elapsed = obj.elapsed % obj.duration;
                }
                else {
                    // subtract a small amount to prevent attempting to go past the end of the animation
                    obj.elapsed = obj.duration - 0.000001;
                }
            }
            var frame = (obj.elapsed * obj.framerate + 0.0000001) | 0;
            // this.texture = obj.textures[frame] || PIXI.Texture.EMPTY;
            if (!this.sprites[frame]) {
                console.error('did not find frame');
                return;
            }
            var sprite = this.sprites[frame];
            this.texture = sprite.texture;
            this.pluginName = AnimatedMaskParticle.DEFAULT_PLUGIN_NAME;
            if (sprite instanceof MaskSprite_1.MaskSprite) {
                this.maskTexture = sprite.maskTexture;
                this.pluginName = AnimatedMaskParticle.MASK_PLUGIN_NAME;
            }
        }
        return lerp;
    };
    AnimatedMaskParticle.prototype.applyArt = function (art) {
        _super.prototype.applyArt.call(this, art);
        var obj = this;
        var particleArt = art;
        this.sprites = particleArt.particleImages;
        obj.framerate = particleArt.framerate;
        obj.duration = particleArt.duration;
        obj.loop = particleArt.loop;
    };
    Object.defineProperty(AnimatedMaskParticle.prototype, "maskTexture", {
        get: function () {
            return this._maskTexture;
        },
        set: function (value) {
            this._maskTexture = value;
        },
        enumerable: true,
        configurable: true
    });
    AnimatedMaskParticle.DEFAULT_PLUGIN_NAME = 'sprite';
    AnimatedMaskParticle.MASK_PLUGIN_NAME = 'maskSprite';
    return AnimatedMaskParticle;
}(PIXI.particles.AnimatedParticle));
exports.AnimatedMaskParticle = AnimatedMaskParticle;


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var MaskSprite = /** @class */ (function (_super) {
    __extends(MaskSprite, _super);
    function MaskSprite(texture, maskTexture) {
        var _this = _super.call(this, texture) || this;
        _this._maskTexture = maskTexture;
        _this.pluginName = 'maskSprite';
        return _this;
    }
    Object.defineProperty(MaskSprite.prototype, "maskTexture", {
        get: function () {
            return this._maskTexture;
        },
        set: function (value) {
            this._maskTexture = value;
        },
        enumerable: true,
        configurable: true
    });
    return MaskSprite;
}(PIXI.Sprite));
exports.MaskSprite = MaskSprite;


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Updatable_1 = __webpack_require__(71);
var Emitter = /** @class */ (function (_super) {
    __extends(Emitter, _super);
    function Emitter(particleParent, particleImages, config) {
        var _this = _super.call(this, true) || this;
        _this._baseEmitter = new PIXI.particles.Emitter(particleParent, particleImages, config);
        return _this;
    }
    Object.defineProperty(Emitter.prototype, "emit", {
        get: function () {
            return this._baseEmitter.emit;
        },
        set: function (value) {
            this._baseEmitter.emit = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Emitter.prototype, "particleConstructor", {
        get: function () {
            return this._baseEmitter.particleConstructor;
        },
        set: function (value) {
            this._baseEmitter.particleConstructor = value;
        },
        enumerable: true,
        configurable: true
    });
    Emitter.prototype.update = function (dt) {
        this._baseEmitter.update(dt);
    };
    Emitter.prototype.stop = function () {
        _super.prototype.stop.call(this);
        this._baseEmitter.destroy();
    };
    Object.defineProperty(Emitter.prototype, "baseEmitter", {
        get: function () {
            return this._baseEmitter;
        },
        enumerable: true,
        configurable: true
    });
    return Emitter;
}(Updatable_1.Updatable));
exports.Emitter = Emitter;


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Module_1 = __webpack_require__(2);
var RestoreScreenEvents_1 = __webpack_require__(251);
var InfoPopupEvents_1 = __webpack_require__(63);
var InfoPopupTypes_1 = __webpack_require__(74);
/**
 * module handles restore window closed event (I know it's weird)
 */
var RestoreScreenModule = /** @class */ (function (_super) {
    __extends(RestoreScreenModule, _super);
    function RestoreScreenModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RestoreScreenModule.prototype.enterFirstState = function () {
    };
    RestoreScreenModule.prototype.setupStates = function () {
    };
    RestoreScreenModule.prototype.setupViews = function () {
    };
    RestoreScreenModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(InfoPopupEvents_1.InfoPopupEvents.INFO_POPUP_CLOSED, this.onInfoPopupClosed);
        this.on(InfoPopupEvents_1.InfoPopupEvents.RESTORE_POPUP_OPENED, this.onRestorePopupOpened);
    };
    RestoreScreenModule.prototype.onRestorePopupOpened = function () {
        this.eventManager.emit(RestoreScreenEvents_1.RestoreScreenEvents.RESTORE_WINDOW_OPENED);
    };
    RestoreScreenModule.prototype.onInfoPopupClosed = function (eventId, eventType) {
        if (eventType === InfoPopupTypes_1.InfoPopupTypes.RESTORE) {
            this.onRestoreScreenClicked();
        }
    };
    RestoreScreenModule.prototype.onRestoreScreenClicked = function () {
        this.eventManager.emit(RestoreScreenEvents_1.RestoreScreenEvents.RESTORE_WINDOW_CLOSED);
    };
    return RestoreScreenModule;
}(Module_1.Module));
exports.RestoreScreenModule = RestoreScreenModule;


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Module_1 = __webpack_require__(2);
var Views_1 = __webpack_require__(8);
var OrientationView_1 = __webpack_require__(255);
var OrientationEvents_1 = __webpack_require__(257);
var OrientationModule = /** @class */ (function (_super) {
    __extends(OrientationModule, _super);
    function OrientationModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrientationModule.prototype.setupViews = function () {
        this.setView(Views_1.Views.ORIENTATION_NOTIFICATION_VIEW);
    };
    OrientationModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.onViewEmitEvent(OrientationView_1.OrientationView.ORIENTATION_CHANGED_TO_PORTRAIT, OrientationEvents_1.OrientationEvents.ORIENTATION_CHANGED_TO_PORTRAIT);
        this.onViewEmitEvent(OrientationView_1.OrientationView.ORIENTATION_CHANGED_TO_LANDSCAPE, OrientationEvents_1.OrientationEvents.ORIENTATION_CHANGED_TO_LANDSCAPE);
    };
    OrientationModule.prototype.setupStates = function () {
    };
    OrientationModule.prototype.enterFirstState = function () {
    };
    return OrientationModule;
}(Module_1.Module));
exports.OrientationModule = OrientationModule;


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Module_1 = __webpack_require__(2);
var Views_1 = __webpack_require__(8);
var LogotypeView_1 = __webpack_require__(258);
var LogotypeViewEvents_1 = __webpack_require__(244);
var StartScreenEvents_1 = __webpack_require__(22);
var LogotypeModule = /** @class */ (function (_super) {
    __extends(LogotypeModule, _super);
    function LogotypeModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LogotypeModule.prototype.setupStates = function () { };
    LogotypeModule.prototype.enterFirstState = function () { };
    LogotypeModule.prototype.setupViews = function () {
        if (this.system.shouldUseMultipleViews()) {
            this.setView(Views_1.Views.LOGOTYPE_VIEW_MOBILE);
        }
        else {
            this.setView(Views_1.Views.LOGOTYPE_VIEW);
        }
    };
    LogotypeModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        if (false) {
            this.onViewEmitEvent(LogotypeView_1.LogotypeView.LOGOTYPE_DOUBLE_TAPPED, LogotypeViewEvents_1.LogotypeViewEvents.LOGOTYPE_DOUBLE_TAPPED);
        }
        this.on(StartScreenEvents_1.StartScreenEvents.INTRO_STARTED, this.onStartScreenIntroStarted);
        this.on(StartScreenEvents_1.StartScreenEvents.EXIT_FINISHED, this.onStartScreenIntroFinished);
    };
    LogotypeModule.prototype.onStartScreenIntroStarted = function () {
        this.view.hide();
    };
    LogotypeModule.prototype.onStartScreenIntroFinished = function () {
        this.view.show();
    };
    return LogotypeModule;
}(Module_1.Module));
exports.LogotypeModule = LogotypeModule;


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Module_1 = __webpack_require__(2);
var Views_1 = __webpack_require__(8);
var ReelsEvents_1 = __webpack_require__(4);
var FlowModuleEvents_1 = __webpack_require__(0);
/**
 * statistics window module
 * used for debug and telemetry purposes
 */
var StatisticsWindowModule = /** @class */ (function (_super) {
    __extends(StatisticsWindowModule, _super);
    function StatisticsWindowModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StatisticsWindowModule.prototype.enterFirstState = function () {
    };
    StatisticsWindowModule.prototype.setupStates = function () {
    };
    StatisticsWindowModule.prototype.setupViews = function () {
        this.setView(Views_1.Views.STATISTICS_WINDOW_VIEW);
    };
    StatisticsWindowModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        document.addEventListener('keydown', this.keyboardInput.bind(this));
        this.on(ReelsEvents_1.ReelsEvents.REELS_SPINNING_STARTED, this.onSpinStarted);
        this.on(FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN, this.onCanSpin);
    };
    StatisticsWindowModule.prototype.onSpinStarted = function () {
        this.view.spinMade();
        this.view.moneySpent(this.logic.getTotalBet());
    };
    StatisticsWindowModule.prototype.onCanSpin = function () {
        this.view.moneyWon(this.logic.getWin());
    };
    StatisticsWindowModule.prototype.keyboardInput = function (event) {
        if (event.code === 'Backquote') {
            this.view.toggleView();
        }
    };
    return StatisticsWindowModule;
}(Module_1.Module));
exports.StatisticsWindowModule = StatisticsWindowModule;


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Module_1 = __webpack_require__(2);
var MainMenuEvents_1 = __webpack_require__(44);
var Views_1 = __webpack_require__(8);
var GameRulesModule = /** @class */ (function (_super) {
    __extends(GameRulesModule, _super);
    function GameRulesModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameRulesModule.prototype.init = function () {
        _super.prototype.init.call(this);
        if (this.logic.config) {
            var config = this.logic.config.getConfigByName('relaxConfig');
            if (config) {
                this.view.replaceRelaxTimeStamp(config.getParameter('relax_timestamp'));
            }
        }
    };
    GameRulesModule.prototype.afterInit = function () {
        _super.prototype.afterInit.call(this);
        if (this.logic.config) {
            var rtpConfig = this.logic.config.getConfigByName('rtpValues');
            var versionConfig = this.logic.config.getConfigByName('gameVersion');
            var buildConfig = this.logic.config.getConfigByName('buildDate');
            if (rtpConfig) {
                this.view.replaceRTPData(rtpConfig);
            }
            if (versionConfig) {
                this.view.replaceGameVersion(versionConfig.getParameter('version'));
            }
            if (buildConfig) {
                this.view.replaceRelaxTimeStamp(buildConfig.getParameter('timestamp'));
            }
        }
    };
    GameRulesModule.prototype.setupStates = function () {
    };
    GameRulesModule.prototype.enterFirstState = function () {
    };
    GameRulesModule.prototype.setupViews = function () {
        this.setView(Views_1.Views.GAME_RULES_VIEW);
    };
    GameRulesModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(MainMenuEvents_1.MainMenuEvents.MAIN_MENU_INFO_OPEN, this.showGameRules);
        this.on(MainMenuEvents_1.MainMenuEvents.MAIN_MENU_SETTINGS_OPEN, this.hideGameRules);
        this.on(MainMenuEvents_1.MainMenuEvents.MAIN_MENU_PAYTABLE_OPEN, this.hideGameRules);
        this.on(MainMenuEvents_1.MainMenuEvents.MAIN_MENU_CLOSED, this.hideGameRules);
    };
    GameRulesModule.prototype.hideGameRules = function () {
        this.view.hide();
    };
    GameRulesModule.prototype.showGameRules = function () {
        this.view.show();
    };
    return GameRulesModule;
}(Module_1.Module));
exports.GameRulesModule = GameRulesModule;


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var HTMLPageView_1 = __webpack_require__(259);
var Symbols_1 = __webpack_require__(38);
var ReelConstants_1 = __webpack_require__(10);
var PaytableView = /** @class */ (function (_super) {
    __extends(PaytableView, _super);
    function PaytableView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._multiplier = 1;
        return _this;
    }
    PaytableView.prototype.init = function () {
        this.initPaytableMap();
        _super.prototype.init.call(this);
    };
    PaytableView.prototype.setupPathsAndIds = function () {
        this._resourcesPath = 'HTML/PAYTABLE/';
        this._containerId = 'FANTASMA_PAYTABLE_CONTAINER';
    };
    PaytableView.prototype.onDivComplete = function () {
        _super.prototype.onDivComplete.call(this);
    };
    PaytableView.prototype.getBodyContent = function () {
        return this.resources.getPaytableHTML();
    };
    PaytableView.prototype.getIframeContent = function () {
        return this.resources.getPaytableHTML();
    };
    PaytableView.prototype.initPaytableMap = function () {
        this._symbolHMTLPayoutMap = {};
        for (var symId in Symbols_1.Symbols) {
            if (Symbols_1.Symbols.hasOwnProperty(symId)) {
                this._symbolHMTLPayoutMap[Symbols_1.Symbols[symId]] = [];
            }
        }
    };
    PaytableView.prototype.updatePaytable = function (multiplier) {
        // After running once, store DOM references in map.
        this._multiplier = multiplier;
        if (this._hasLoaded) {
            var syms = [];
            for (var sym = Symbols_1.Symbols.WR; sym <= Symbols_1.Symbols.F10; sym++) {
                syms.push(sym);
            }
            for (var _i = 0, syms_1 = syms; _i < syms_1.length; _i++) {
                var sym = syms_1[_i];
                var symId = Symbols_1.Symbols[sym];
                for (var count = 3; count <= ReelConstants_1.ReelConstants.REELS_AMOUNT; count++) {
                    var element = this.getSymbolElement(symId, count);
                    var value = this.truncValue(this.getSymbolValue(sym, count) * this._multiplier).toString();
                    value = this.currencyFormatter.formatCurrency(value, true);
                    element.innerText = value;
                }
            }
        }
    };
    PaytableView.prototype.truncValue = function (value) {
        return Math.floor(value * 100) / 100;
    };
    PaytableView.prototype.getSymbolValue = function (symId, count) {
        return Symbols_1.SymbolPayouts.paytable[symId].values[count];
    };
    PaytableView.prototype.getSymbolElement = function (symbolId, count) {
        if (this._symbolHMTLPayoutMap[Symbols_1.Symbols[symbolId]] && this._symbolHMTLPayoutMap[Symbols_1.Symbols[symbolId]][count]) {
            return this._symbolHMTLPayoutMap[Symbols_1.Symbols[symbolId]][count];
        }
        // if (this.device.iOS || this.device.iPad) {
        this._symbolHMTLPayoutMap[Symbols_1.Symbols[symbolId]][count] = this._mainContainer.ownerDocument.getElementById(symbolId + "_" + count);
        // } else {
        // 	this._symbolHMTLPayoutMap[Symbols[symbolId]][count] = this._mainIframe.contentDocument.getElementById(`${symbolId}_${count}`);
        // }
        return this._symbolHMTLPayoutMap[Symbols_1.Symbols[symbolId]][count];
    };
    Object.defineProperty(PaytableView.prototype, "paytableValues", {
        get: function () {
            return this._paytableValues;
        },
        set: function (newValues) {
            this._paytableValues = newValues;
        },
        enumerable: true,
        configurable: true
    });
    return PaytableView;
}(HTMLPageView_1.HTMLPageView));
exports.PaytableView = PaytableView;


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @license
 * Copyright 2018 Palantir Technologies, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(518);
var shownWarnings = new Set();
/**
 * Used to exit the program and display a friendly message without the callstack.
 */
var FatalError = /** @class */ (function (_super) {
    tslib_1.__extends(FatalError, _super);
    function FatalError(message, innerError) {
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.innerError = innerError;
        _this.name = FatalError.NAME;
        // Fix prototype chain for target ES5
        Object.setPrototypeOf(_this, FatalError.prototype);
        return _this;
    }
    FatalError.NAME = "FatalError";
    return FatalError;
}(Error));
exports.FatalError = FatalError;
function isError(possibleError) {
    return possibleError != undefined && possibleError.message !== undefined;
}
exports.isError = isError;
function showWarningOnce(message) {
    if (!shownWarnings.has(message)) {
        console.warn(message);
        shownWarnings.add(message);
    }
}
exports.showWarningOnce = showWarningOnce;
function showRuleCrashWarning(message, ruleName, fileName) {
    console.warn("The '" + ruleName + "' rule threw an error in '" + fileName + "':\n" + message);
}
exports.showRuleCrashWarning = showRuleCrashWarning;


/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["__extends"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["__rest"] = __rest;
/* harmony export (immutable) */ __webpack_exports__["__decorate"] = __decorate;
/* harmony export (immutable) */ __webpack_exports__["__param"] = __param;
/* harmony export (immutable) */ __webpack_exports__["__metadata"] = __metadata;
/* harmony export (immutable) */ __webpack_exports__["__awaiter"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["__generator"] = __generator;
/* harmony export (immutable) */ __webpack_exports__["__exportStar"] = __exportStar;
/* harmony export (immutable) */ __webpack_exports__["__values"] = __values;
/* harmony export (immutable) */ __webpack_exports__["__read"] = __read;
/* harmony export (immutable) */ __webpack_exports__["__spread"] = __spread;
/* harmony export (immutable) */ __webpack_exports__["__spreadArrays"] = __spreadArrays;
/* harmony export (immutable) */ __webpack_exports__["__await"] = __await;
/* harmony export (immutable) */ __webpack_exports__["__asyncGenerator"] = __asyncGenerator;
/* harmony export (immutable) */ __webpack_exports__["__asyncDelegator"] = __asyncDelegator;
/* harmony export (immutable) */ __webpack_exports__["__asyncValues"] = __asyncValues;
/* harmony export (immutable) */ __webpack_exports__["__makeTemplateObject"] = __makeTemplateObject;
/* harmony export (immutable) */ __webpack_exports__["__importStar"] = __importStar;
/* harmony export (immutable) */ __webpack_exports__["__importDefault"] = __importDefault;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var HTMLPageView_1 = __webpack_require__(259);
var GameRulesView = /** @class */ (function (_super) {
    __extends(GameRulesView, _super);
    function GameRulesView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameRulesView.prototype.init = function () {
        _super.prototype.init.call(this);
    };
    GameRulesView.prototype.setupHTML = function () {
        _super.prototype.setupHTML.call(this);
        this.replaceGameVersion();
        this.formatGameInfoValue();
        this.bindButtons();
    };
    GameRulesView.prototype.setupPathsAndIds = function () {
        this._resourcesPath = 'HTML/GAMERULES/';
        this._containerId = 'FANTASMA_GAMERULES_CONTAINER';
    };
    GameRulesView.prototype.formatGameInfoValue = function () { };
    GameRulesView.prototype.getBodyContent = function () {
        return this.resources.getGameRulesHTML();
    };
    GameRulesView.prototype.getIframeContent = function () {
        return this.resources.getGameRulesHTML();
    };
    GameRulesView.prototype.replaceRTPData = function (config) {
        for (var data in config.record) {
            var rtpSeparator = this.translator.getObject('BaseStrings', 'generic', 'g_rtpSeparator');
            var dataValue = config.getParameter(data);
            if (data && typeof dataValue === 'number') {
                var rtpValue = String(dataValue);
                rtpValue = rtpValue.replace('.', rtpSeparator);
                this._mainBody.innerHTML = this._mainBody.innerHTML.replace("\u00A4\u00A4\u00A4" + data + "\u00A4\u00A4\u00A4", rtpValue);
            }
        }
    };
    GameRulesView.prototype.replaceGameVersion = function (version) {
        var versionItem = this.findChildWithId('¤¤¤GAMEVERSION¤¤¤', this._mainBody);
        if (version) {
            versionItem.innerText = version;
        }
        else if (versionItem) {
            versionItem.innerText = "0.6.1";
        }
    };
    GameRulesView.prototype.replaceRelaxTimeStamp = function (timestamp) {
        var versionItem = this.findChildWithId('¤¤¤BUILDDATE¤¤¤', this._mainBody);
        if (versionItem) {
            versionItem.innerText = timestamp;
        }
    };
    GameRulesView.prototype.findChildWithId = function (id, inElement) {
        var childNodes = Array.prototype.slice.call(inElement.childNodes);
        for (var _i = 0, childNodes_1 = childNodes; _i < childNodes_1.length; _i++) {
            var child = childNodes_1[_i];
            if (child && child.id) {
                if (child.id === id) {
                    return child;
                }
            }
        }
        return null;
    };
    GameRulesView.prototype.bindButtons = function () { };
    return GameRulesView;
}(HTMLPageView_1.HTMLPageView));
exports.GameRulesView = GameRulesView;


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var View_1 = __webpack_require__(3);
var RepeatingTimer_1 = __webpack_require__(521);
var StatisticsWindowView = /** @class */ (function (_super) {
    __extends(StatisticsWindowView, _super);
    function StatisticsWindowView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._spinsMade = 0;
        _this._moneyLost = 0;
        _this._moneyWon = 0;
        _this._allTextFields = [];
        return _this;
    }
    StatisticsWindowView.prototype.toggleView = function () {
        if (this.container.visible) {
            this.hide();
        }
        else {
            this.show();
        }
    };
    StatisticsWindowView.prototype.init = function () {
        _super.prototype.init.call(this);
        this.initializeBackground();
        this.initializeData();
        this.initializeTexts();
        this.placeTexts();
        this.updateTexts();
        this.initializeTimer();
        this.hide();
    };
    StatisticsWindowView.prototype.initializeTimer = function () {
        var _this = this;
        this._oneSecondTimer = new RepeatingTimer_1.RepeatingTimer(function () {
            _this.updateTexts();
        }, 1000, true);
        this.updateManager.add(this._oneSecondTimer);
    };
    StatisticsWindowView.prototype.initializeBackground = function () {
        var backgroundGraphics = new PIXI.Graphics();
        backgroundGraphics.lineStyle(5, 0x000000, 1);
        backgroundGraphics.beginFill(0x000000, 0.25);
        if (this.device.isMobile) {
            backgroundGraphics.drawRoundedRect(this.resolutionManager.halfResolution.width * 1.5, this.resolutionManager.halfResolution.height, this.resolutionManager.halfResolution.width * 0.5, this.resolutionManager.halfResolution.height, 15);
        }
        else {
            backgroundGraphics.drawRoundedRect(this.resolutionManager.halfResolution.width * 1.5, this.resolutionManager.halfResolution.height, this.resolutionManager.halfResolution.width * 0.5, this.resolutionManager.halfResolution.height, 15);
        }
        backgroundGraphics.endFill();
        this.container.addChild(backgroundGraphics);
    };
    StatisticsWindowView.prototype.initializeData = function () {
        this._sessionInitTimestamp = new Date();
    };
    StatisticsWindowView.prototype.initializeTexts = function () {
        this._textsStyle = this.textStyles.freeRoundsSmallTextStyle;
        this._timeFromSessionInitText = new PIXI.Text('', this._textsStyle);
        this._allTextFields.push(this._timeFromSessionInitText);
        this._spinsMadeText = new PIXI.Text('', this._textsStyle);
        this._allTextFields.push(this._spinsMadeText);
        this._totalMoneyLostText = new PIXI.Text('', this._textsStyle);
        this._allTextFields.push(this._totalMoneyLostText);
        this._totalMoneyWonText = new PIXI.Text('', this._textsStyle);
        this._allTextFields.push(this._totalMoneyWonText);
        this._sessionRTPText = new PIXI.Text('', this._textsStyle);
        this._allTextFields.push(this._sessionRTPText);
    };
    StatisticsWindowView.prototype.placeTexts = function () {
        for (var i = 0; i < this._allTextFields.length; i++) {
            var tf = this._allTextFields[i];
            this.container.addChild(tf);
            tf.x = this.resolutionManager.halfResolution.width * 1.5 + 50;
            tf.y = this.resolutionManager.halfResolution.height + 50 + i * 40;
        }
    };
    StatisticsWindowView.prototype.updateTexts = function () {
        var timeSpent = new Date().getTime() - this._sessionInitTimestamp.getTime();
        this._timeFromSessionInitText.text = "session time: " + new Date(timeSpent).toISOString().slice(11, 19);
        this._spinsMadeText.text = "spins: " + this._spinsMade.toString(10);
        this._totalMoneyLostText.text = "money lost: " + this._moneyLost.toString(10);
        this._totalMoneyWonText.text = "money won: " + this._moneyWon.toString(10);
        this._sessionRTPText.text = "session RTP: " + (this._moneyWon / this._moneyLost).toString(10);
    };
    StatisticsWindowView.prototype.spinMade = function () {
        this._spinsMade++;
        this.updateTexts();
    };
    StatisticsWindowView.prototype.moneySpent = function (money) {
        this._moneyLost += money;
        this.updateTexts();
    };
    StatisticsWindowView.prototype.moneyWon = function (money) {
        this._moneyWon += money;
        this.updateTexts();
    };
    return StatisticsWindowView;
}(View_1.View));
exports.StatisticsWindowView = StatisticsWindowView;


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Timer_1 = __webpack_require__(28);
var RepeatingTimer = /** @class */ (function (_super) {
    __extends(RepeatingTimer, _super);
    function RepeatingTimer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RepeatingTimer.prototype.forceStop = function () {
        this._isPlaying = false;
        this._updateManager && this._updateManager.remove(this);
    };
    RepeatingTimer.prototype.stop = function () {
        this.start();
    };
    RepeatingTimer.prototype.update = function (dt) {
        this._currentTime += dt;
        var time = this._currentTime;
        if (time - this._startTime > this._duration) {
            this._callback();
        }
    };
    return RepeatingTimer;
}(Timer_1.Timer));
exports.RepeatingTimer = RepeatingTimer;


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var UpdateManager_1 = __webpack_require__(70);
var Tween_1 = __webpack_require__(19);
var Easing_1 = __webpack_require__(16);
var Meter = /** @class */ (function (_super) {
    __extends(Meter, _super);
    function Meter(textObject, easing, formatter) {
        if (easing === void 0) { easing = Easing_1.Easing.Linear.None; }
        var _this = _super.call(this) || this;
        _this._valueWrapper = { value: 0, targetValue: 0 };
        _this._textObject = textObject;
        _this._formatter = formatter;
        _this._tween = new Tween_1.Tween(_this._valueWrapper).easing(easing).onUpdate(_this.onUpdate.bind(_this));
        _this.add(_this._tween);
        _this.onUpdate();
        return _this;
    }
    Meter.prototype.remove = function (updatable) {
        _super.prototype.remove.call(this, updatable);
    };
    /**
     * if the win meter in incrementing this changes it immediately
     * to the final value.
     * OnCompleted won't be called
     */
    Meter.prototype.snapToFinalValue = function () {
        this._tween.stop();
        this._valueWrapper.value = this._valueWrapper.targetValue;
        this.onUpdate();
    };
    Meter.prototype.set = function (value) {
        this.to(value, 0);
        this.snapToFinalValue();
        return this;
    };
    Meter.prototype.from = function (value) {
        this._tween.stop();
        this._valueWrapper.value = value;
        this._valueWrapper.targetValue = value;
        this.onUpdate();
        return this;
    };
    Meter.prototype.to = function (value, time) {
        this._valueWrapper.targetValue = value;
        if (!this._tween.updateManager) {
            this.add(this._tween);
        }
        this._tween.to({ value: value }, time).start();
        return this;
    };
    Meter.prototype.getPredictedValue = function (time) {
        return this.format(this._tween.getPredictedProperty(time, 'value'));
    };
    Meter.prototype.onUpdate = function () {
        this._textObject.text = this.format(this._valueWrapper.value);
    };
    Meter.prototype.format = function (value) {
        // return this._formatter ? this._formatter.formatCurrencyFromCents(value) : value.toFixed(2);
        return this._formatter ? this._formatter.formatCurrencyFromCents(value) : value.toFixed(2);
    };
    Object.defineProperty(Meter.prototype, "textObject", {
        get: function () {
            return this._textObject;
        },
        set: function (value) {
            this._textObject = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Meter.prototype, "onCompleteCallback", {
        set: function (value) {
            this._tween.onComplete(value);
        },
        enumerable: true,
        configurable: true
    });
    return Meter;
}(UpdateManager_1.UpdateManager));
exports.Meter = Meter;


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var GlowFilter = /** @class */ (function (_super) {
    __extends(GlowFilter, _super);
    function GlowFilter(distance, outerStrength, innerStrength, color, quality) {
        if (distance === void 0) { distance = 10; }
        if (outerStrength === void 0) { outerStrength = 4; }
        if (innerStrength === void 0) { innerStrength = 0; }
        if (color === void 0) { color = 0xffffff; }
        if (quality === void 0) { quality = 0.1; }
        var _this = this;
        var vertexSrc = '';
        var fragmentSrc = 'varying vec2 vTextureCoord;\n' +
            'varying vec4 vColor;\n' +
            '\n' +
            'uniform sampler2D uSampler;\n' +
            '\n' +
            'uniform float distance;\n' +
            'uniform float outerStrength;\n' +
            'uniform float innerStrength;\n' +
            'uniform vec4 glowColor;\n' +
            'uniform vec4 filterArea;\n' +
            'uniform vec4 filterClamp;\n' +
            'const float PI = 3.14159265358979323846264;\n' +
            '\n' +
            'void main(void) {\n' +
            '    vec2 px = vec2(1.0 / filterArea.x, 1.0 / filterArea.y);\n' +
            '    vec4 ownColor = texture2D(uSampler, vTextureCoord);\n' +
            '    vec4 curColor;\n' +
            '    float totalAlpha = 0.0;\n' +
            '    float maxTotalAlpha = 0.0;\n' +
            '    float cosAngle;\n' +
            '    float sinAngle;\n' +
            '    vec2 displaced;\n' +
            '    for (float angle = 0.0; angle <= PI * 2.0; angle += %QUALITY_DIST%) {\n' +
            '       cosAngle = cos(angle);\n' +
            '       sinAngle = sin(angle);\n' +
            '       for (float curDistance = 1.0; curDistance <= %DIST%; curDistance++) {\n' +
            '           displaced.x = vTextureCoord.x + cosAngle * curDistance * px.x;\n' +
            '           displaced.y = vTextureCoord.y + sinAngle * curDistance * px.y;\n' +
            '           curColor = texture2D(uSampler, clamp(displaced, filterClamp.xy, filterClamp.zw));\n' +
            '           totalAlpha += (distance - curDistance) * curColor.a;\n' +
            '           maxTotalAlpha += (distance - curDistance);\n' +
            '       }\n' +
            '    }\n' +
            '    maxTotalAlpha = max(maxTotalAlpha, 0.0001);\n' +
            '\n' +
            '    ownColor.a = max(ownColor.a, 0.0001);\n' +
            '    ownColor.rgb = ownColor.rgb / ownColor.a;\n' +
            '    float outerGlowAlpha = (totalAlpha / maxTotalAlpha)  * outerStrength * (1. - ownColor.a);\n' +
            '    float innerGlowAlpha = ((maxTotalAlpha - totalAlpha) / maxTotalAlpha) * innerStrength * ownColor.a;\n' +
            '    float resultAlpha = (ownColor.a + outerGlowAlpha);\n' +
            '    gl_FragColor = vec4(mix(mix(ownColor.rgb, glowColor.rgb, innerGlowAlpha / ownColor.a), glowColor.rgb, outerGlowAlpha / resultAlpha) * resultAlpha, resultAlpha);\n' +
            '}';
        _this = _super.call(this, vertexSrc, fragmentSrc
            .replace(/%QUALITY_DIST%/gi, '' + (1 / quality / distance).toFixed(7))
            .replace(/%DIST%/gi, '' + distance.toFixed(7))) || this;
        _this.uniforms.glowColor = [0, 0, 0, 1];
        _this.distance = distance;
        _this.color = color;
        _this.outerStrength = outerStrength;
        _this.innerStrength = innerStrength;
        return _this;
    }
    Object.defineProperty(GlowFilter.prototype, "color", {
        get: function () {
            return PIXI.utils.rgb2hex(this.uniforms.glowColor);
        },
        set: function (value) {
            PIXI.utils.hex2rgb(value, this.uniforms.glowColor);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GlowFilter.prototype, "distance", {
        get: function () {
            return this.uniforms.distance;
        },
        set: function (value) {
            this.uniforms.distance = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GlowFilter.prototype, "outerStrength", {
        get: function () {
            return this.uniforms.outerStrength;
        },
        set: function (value) {
            this.uniforms.outerStrength = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GlowFilter.prototype, "innerStrength", {
        get: function () {
            return this.uniforms.innerStrength;
        },
        set: function (value) {
            this.uniforms.innerStrength = value;
        },
        enumerable: true,
        configurable: true
    });
    return GlowFilter;
}(PIXI.Filter));
exports.GlowFilter = GlowFilter;


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = __webpack_require__(14);
var UpdateManager_1 = __webpack_require__(70);
var ReelSymbol_1 = __webpack_require__(156);
var ReelConstants_1 = __webpack_require__(10);
var Tween_1 = __webpack_require__(19);
var Easing_1 = __webpack_require__(16);
var Timer_1 = __webpack_require__(28);
var SpineUtils_1 = __webpack_require__(233);
var ReelsUtils_1 = __webpack_require__(112);
var View_1 = __webpack_require__(3);
var AvalancheReel = /** @class */ (function (_super) {
    __extends(AvalancheReel, _super);
    function AvalancheReel(reelIndex, startReelPosition, offsets, container, viewType) {
        if (viewType === void 0) { viewType = View_1.ViewTypes.DESKTOP; }
        var _this = _super.call(this) || this;
        // reel state flags
        _this._isSpinning = false;
        _this._initialStrip = [3, 3, 3, 3, 3, 3, 3, 3, 3, 3];
        // number of rows we're currently showing on this reel
        _this._rowsToShow = 5;
        // is there any symbols hanging in the air to drop down before new symbols will come up
        _this._hasAnythingToDropFillingTheVoid = false;
        _this._symbols = [];
        _this._reelIndex = reelIndex;
        _this._offsets = offsets;
        _this._container = container;
        _this._viewType = viewType;
        return _this;
    }
    AvalancheReel_1 = AvalancheReel;
    AvalancheReel.prototype.putSymbolOnTopOfOther = function (symPos) {
        var parent = this._symbols[symPos.y].parent;
        parent.setChildIndex(this._symbols[symPos.y], parent.children.length - 1);
    };
    AvalancheReel.prototype.setupReel = function (resources, soundPlayer) {
        this._resources = resources;
        this._soundPlayer = soundPlayer;
        this._spineUtils = new SpineUtils_1.SpineUtils(resources, this, this._container);
    };
    AvalancheReel.prototype.init = function (initialReel) {
        if (initialReel === void 0) { initialReel = null; }
        this.createReel(initialReel);
    };
    AvalancheReel.prototype.setRowsToShow = function (rowsToShow) {
        this._rowsToShow = rowsToShow;
    };
    AvalancheReel.prototype.makeCleanup = function () {
        for (var _i = 0, _a = this._symbols; _i < _a.length; _i++) {
            var sym = _a[_i];
            sym.makeCleanup();
        }
    };
    AvalancheReel.prototype.initTopVisibleSymbolIndex = function (initialReel) {
        this.topVisibleSymbolIndex = this._rowsToShow - initialReel.length;
    };
    AvalancheReel.prototype.getRowsToShow = function () {
        return this._rowsToShow;
    };
    AvalancheReel.prototype.recountSymbolsOnReel = function () {
        this.symbolsOnReel = 0;
        for (var _i = 0, _a = this._symbols; _i < _a.length; _i++) {
            var sym = _a[_i];
            if (sym.visible) {
                this.symbolsOnReel++;
            }
        }
    };
    AvalancheReel.prototype.updateVisibleRows = function () {
        for (var i = 0; i < ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT; i++) {
            if (i < ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT - this._rowsToShow) {
                this._symbols[i].visible = false;
            }
            else {
                this._symbols[i].visible = true;
            }
        }
    };
    AvalancheReel.prototype.setSymbolInPosition = function (symbols, positionIndex, symIndex, offset) {
        this._symbols[positionIndex].setSymbol(this.makeSizedSymbol(symbols[symIndex].sym, symbols[symIndex].size));
    };
    AvalancheReel.prototype.dropSymbols = function (symbols) {
        var index = 0;
        var offset = 0;
        var lastDelay = 0;
        var ifFirst = true;
        this.topVisibleSymbolIndex = this._rowsToShow - symbols.length;
        this.symbolsOnReel = symbols.length;
        for (var i = ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT - 1; i >= ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT - this._rowsToShow; i--) {
            if (index < symbols.length) {
                var symIndex = symbols.length - 1 - index;
                offset += symbols[symIndex].size.height - 1;
                this.setSymbolInPosition(symbols, i, symIndex, offset);
                this._symbols[i].visible = true;
                var yToPos = this._offsets.y + this.getYPositionForRow(i - offset);
                lastDelay =
                    index * ReelConstants_1.AvalancheConstants.TIMER_BETWEEN_SYMBOLS_NEW + this._reelIndex * ReelConstants_1.AvalancheConstants.TIMER_BETWEEN_REELS_NEW;
                var dropNewTween = this.dropNewSymbolToPosition(i, yToPos, lastDelay);
                if (ifFirst) {
                    dropNewTween.onComplete(this.onFirstSymbolDropped.bind(this));
                    ifFirst = false;
                }
                if (index === symbols.length - 1) {
                    dropNewTween.onComplete(this.onLastSymbolDropped.bind(this));
                }
                index++;
            }
            else {
                this._symbols[i].visible = false;
            }
        }
    };
    AvalancheReel.prototype.dropOldSymbolsOut = function () {
        var index = 0;
        for (var i = ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT - 1; i >= ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT - this._rowsToShow; i--) {
            var delay = index * ReelConstants_1.AvalancheConstants.TIMER_BETWEEN_SYMBOLS_OUT + this._reelIndex * ReelConstants_1.AvalancheConstants.TIMER_BETWEEN_REELS_OUT;
            var dropOutTween = new Tween_1.Tween(this._symbols[i])
                .to({ y: this._symbols[i].y + 1024 }, ReelConstants_1.AvalancheConstants.AVALANCHE_OUT_TIMER)
                .delay(delay);
            this.add(dropOutTween);
            dropOutTween.start();
            index++;
            if (i === ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT - this._rowsToShow) {
                dropOutTween.onComplete(this.onLastSymbolDroppedOut.bind(this));
            }
        }
    };
    AvalancheReel.prototype.removeAvalancheSymbols = function (positions, onFinishedCallback) {
        positions = positions.sort(function (s1, s2) { return s1.y - s2.y; });
        var isFirst = true;
        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
            var pos = positions_1[_i];
            var sym = this._symbols[this.topVisibleSymbolIndex + pos.y];
            this.playRemoveAnimationAt(sym, isFirst ? onFinishedCallback : null);
            isFirst = false;
            this._symbols.splice(this.topVisibleSymbolIndex + pos.y, 1);
            this._symbols.unshift(sym);
            this.symbolsOnReel--;
            for (var rowIndex = 0; rowIndex < ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT; rowIndex++) {
                this._symbols[rowIndex].index = rowIndex;
            }
        }
        this.symbolsOnReel = this.symbolsOnReel < 0 ? 0 : this.symbolsOnReel;
        this.topVisibleSymbolIndex += positions.length;
    };
    /**
     * handles dropping of the symbols in the air to the floor
     */
    AvalancheReel.prototype.dropElementsToFillVoids = function () {
        var _this = this;
        var offset = 0;
        var isFirstTween = true;
        this._hasAnythingToDropFillingTheVoid = false;
        for (var i = ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT - 1; i >= 0; i--) {
            // 1a. if the symbols is visible (not destroyed)
            if (this._symbols[i].visible) {
                var pos = this._symbols[i].positionOnReel;
                var height = this._symbols[i].size.height;
                // 2a. and it is not on the expected place
                if (pos !== offset + height - 1) {
                    var moveOffset = pos - (offset + height - 1);
                    var reelPosition = this.getPositionOnReel(pos, moveOffset);
                    var newYPos = this._offsets.y + this.getYPositionForRow(reelPosition);
                    // 3a. then we're dropping it down with a tween
                    var tween = this.dropExistingSymbol(i, newYPos, 0, false);
                    this._symbols[i].positionOnReel -= moveOffset;
                    this._symbols[i].setContainerParameters();
                    if (isFirstTween) {
                        isFirstTween = false;
                        this._hasAnythingToDropFillingTheVoid = true;
                        tween.onComplete(function () {
                            _this.cleanAfterFall();
                            _this._onFillingVoidsFinished(_this._reelIndex);
                        });
                    }
                }
                offset += height;
                this.topVisibleSymbolIndex = i;
            }
            else {
                // 1b. if this is a last element on reel and it is invisible it means
                // there is no symbols left on this reel
                // so top visible element has the index of top element + 1
                // so that next falling symbol we receive 1st position on the reel
                if (i === ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT - 1) {
                    this.topVisibleSymbolIndex = ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT;
                }
                return;
            }
        }
    };
    /**
     * adds new symbols after win lines were destroyed or re-spin took place
     * @param symbols - array of new symbols
     * @param onAddingFinishedCallback - callback for when symbols were added
     */
    AvalancheReel.prototype.addNewSymbols = function (symbols, onAddingFinishedCallback) {
        var _this = this;
        symbols = symbols.sort(function (s1, s2) { return s2.row - s1.row; });
        this._onAddingSymbolsFinished = onAddingFinishedCallback;
        this.symbolsOnReel += symbols.length;
        var lastTween;
        var lastDelay = 0;
        var isFirst = true;
        var firstSymbolPos;
        var firstSymbolSize;
        if (symbols.length === 0) {
            onAddingFinishedCallback && onAddingFinishedCallback();
        }
        // going through all the symbols
        for (var i = 0; i < symbols.length; i++) {
            var symbol = symbols[i];
            // taking highest visible symbol on reel
            var prevSym = this._symbols[this.topVisibleSymbolIndex];
            var prevElementReelPos = void 0;
            // taking previous symbol's reel position or setting it to -1 so that next position will be 0
            if (prevSym) {
                prevElementReelPos = prevSym.positionOnReel;
            }
            else {
                prevElementReelPos = -1;
            }
            // taking a new symbol from the reel and setting it up
            var currentSym = this._symbols[this.topVisibleSymbolIndex - 1];
            currentSym.visible = true;
            currentSym.positionOnReel = prevElementReelPos + symbol.height;
            currentSym.size = { width: 1, height: symbol.height };
            currentSym.setSymbol(this.makeSizedSymbol(symbol.symbol, currentSym.size));
            currentSym.setContainerParameters();
            // coming up with a new y position for this symbol and delay for dropping tween
            var yToPos = this._offsets.y + this.getYPositionForRow(ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT - (prevElementReelPos + 1 + symbol.height));
            lastDelay = i * ReelConstants_1.AvalancheConstants.TIMER_BETWEEN_SYMBOLS_NEW + this._reelIndex * ReelConstants_1.AvalancheConstants.TIMER_BETWEEN_REELS_NEW;
            // lastDelay = i * 10 + this._reelIndex * 30;
            // making a tween to drop a symbol onto a reel
            lastTween = this.dropNewSymbolToPosition(this.topVisibleSymbolIndex - 1, yToPos, lastDelay, AvalancheReel_1.DROP_REELS_AVALANCHE_EASING, 150);
            this.topVisibleSymbolIndex--;
            if (isFirst) {
                isFirst = false;
                firstSymbolPos = { x: this._reelIndex, y: ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT - (prevElementReelPos + 1) };
                firstSymbolSize = symbol.height;
            }
        }
        if (lastTween) {
            lastTween.onComplete(function () {
                // here is what's happening after symbols fallen down
                _this.cleanAfterFall();
                if (_this._onAddingSymbolsFinished) {
                    _this._onAddingSymbolsFinished();
                    _this._onAddingSymbolsFinished = null;
                }
                if (symbols.length > 0) {
                    // playing dropped sound for the biggest symbol size on the screen
                    _this.playNewSymbolDroppingSound(_this.getBiggestSymbolSizeOf(symbols), lastDelay);
                }
                // playing avalanche landing animation for the first falling symbol
                _this.playAvalancheLandingAnimationAt(firstSymbolPos, firstSymbolSize);
            });
        }
    };
    AvalancheReel.prototype.getBiggestSymbolSizeOf = function (symbols) {
        var biggestSize = 0;
        for (var _i = 0, symbols_1 = symbols; _i < symbols_1.length; _i++) {
            var sym = symbols_1[_i];
            if (sym.height > biggestSize) {
                biggestSize = sym.height;
            }
        }
        return biggestSize;
    };
    AvalancheReel.prototype.playAvalancheLandingAnimationAt = function (pos, height) {
        this.spineUtils
            .startSpineAnimationCreation('AVALANCHE_LAND.json', 'LAND', false)
            .position(ReelsUtils_1.ReelsUtils.getSymbolScreenPosition(pos))
            .createAndStart();
    };
    AvalancheReel.prototype.playNewSymbolDroppingSound = function (symSize, delay) {
        this.soundPlayer.play("avalancheFallingDownSize" + symSize);
    };
    /**
     * getting index position on the reel from position in array
     * @param positionIndex - array position
     * @param offset - additional offset (used for height)
     */
    AvalancheReel.prototype.getPositionOnReel = function (positionIndex, offset) {
        return ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT - 1 - positionIndex + offset;
    };
    AvalancheReel.prototype.playRemoveAnimationAt = function (sym, onCompleted) {
        sym.visible = false;
        setTimeout(function () {
            onCompleted && onCompleted();
        }, 0);
    };
    AvalancheReel.prototype.hasBounceAnimation = function (symType) {
        return false;
    };
    AvalancheReel.prototype.addBounceAnimationTo = function (symbol) {
    };
    AvalancheReel.prototype.dropNewSymbolToPosition = function (symIndex, yPosition, delay, easing, duration) {
        var _this = this;
        if (easing === void 0) { easing = Easing_1.Easing.Quadratic.In; }
        if (duration === void 0) { duration = ReelConstants_1.AvalancheConstants.AVALANCHE_NEW_TIMER; }
        this._symbols[symIndex].y =
            yPosition - ReelConstants_1.ReelConstants.getSymbolSlot(this._viewType).height * ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT - ReelConstants_1.ReelConstants.getReelsOffsets(this._viewType).y;
        var dropNewTween = new Tween_1.Tween(this._symbols[symIndex])
            .to({ y: yPosition }, duration)
            .easing(easing)
            .delay(delay);
        this.add(dropNewTween);
        dropNewTween.start();
        this.addShakingLoopToSymbol(symIndex, delay);
        if (this.hasBounceAnimation(this._symbols[symIndex].symbolType)) {
            var timeToBounce = ReelConstants_1.AvalancheConstants.AVALANCHE_NEW_TIMER + delay - AvalancheReel_1.STOP_ANIMATION_TIMER_OFFSET;
            var bounceAnimTimer = new Timer_1.Timer(function () {
                _this.addBounceAnimationTo(_this._symbols[symIndex]);
            }, timeToBounce, true);
            this.add(bounceAnimTimer);
        }
        return dropNewTween;
    };
    AvalancheReel.prototype.addShakingLoopToSymbol = function (symIndex, delay) {
        var _this = this;
        this._symbols[symIndex].container.rotation = (Math.PI / 180) * -4;
        var symRotTweenRight = new Tween_1.Tween(this._symbols[symIndex].container)
            .to({ rotation: (Math.PI / 180) * 4 }, 120)
            .yoyo(true)
            .delay(delay)
            .repeat(ReelConstants_1.AvalancheConstants.AVALANCHE_NEW_TIMER / 180)
            .onComplete(function () {
            _this._symbols[symIndex].container.rotation = 0;
        })
            .start();
        this.add(symRotTweenRight);
    };
    AvalancheReel.prototype.dropExistingSymbol = function (symIndex, yPosition, delay, shake) {
        var _this = this;
        if (shake) {
            this._symbols[symIndex].container.rotation = (Math.PI / 180) * -4;
        }
        var dropNewTween = new Tween_1.Tween(this._symbols[symIndex])
            .to({ y: yPosition }, ReelConstants_1.AvalancheConstants.AVALANCHE_REPOSITION_TIMER)
            .easing(Easing_1.Easing.SingleBounce.Out)
            .delay(delay);
        this.add(dropNewTween);
        dropNewTween.start();
        if (shake) {
            var symRotTween = new Tween_1.Tween(this._symbols[symIndex].container)
                .to({ rotation: (Math.PI / 180) * 4 }, 150)
                .repeat(ReelConstants_1.AvalancheConstants.AVALANCHE_REPOSITION_TIMER / 180)
                .yoyo(true)
                .delay(delay)
                .onComplete(function () {
                _this._symbols[symIndex].container.rotation = 0;
            })
                .start();
            this.add(symRotTween);
            symRotTween.start();
        }
        return dropNewTween;
    };
    AvalancheReel.prototype.onLastSymbolDroppedOut = function () {
        this._onReelDropOutFinished(this._reelIndex);
    };
    AvalancheReel.prototype.onFirstSymbolDropped = function () {
        this._onReelDropFirstSymbolFinished && this._onReelDropFirstSymbolFinished(this._reelIndex);
    };
    AvalancheReel.prototype.onLastSymbolDropped = function () {
        this.cleanAfterFall();
        this._onReelDropNewFinished(this._reelIndex);
    };
    AvalancheReel.prototype.cleanAfterFall = function () {
        for (var i = 0; i < ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT; i++) {
            this._symbols[i].removeContainerParemeters();
            this._symbols[i].container.rotation = 0;
        }
    };
    AvalancheReel.prototype.createReel = function (initialReel) {
        for (var rowIndex = 0; rowIndex < ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT; rowIndex++) {
            var symbolsSprite = new PIXI.Sprite();
            this.addAllSymbolsIntoSprite(symbolsSprite, this._resources);
            var symbolBackground = new PIXI.Sprite();
            this.addBackgroundsIntoSprite(symbolBackground, this._resources);
            var symbolForeground = new PIXI.Sprite();
            this.addForegroundIntoSprite(symbolForeground, this._resources);
            var symbol = this.createReelSymbol();
            symbol.init(symbolsSprite, symbolBackground, symbolForeground);
            symbol.setSpineUtils(this.spineUtils);
            symbol.setTimerUtils(this._timerUtils);
            this.setInitialSymbolAtPosition(symbol, rowIndex, this._initialStrip[rowIndex]);
            symbol.index = rowIndex;
            symbol.x = this._offsets.x;
            symbol.y = this._offsets.y + this.getYPositionForRow(rowIndex);
            this._symbols[rowIndex] = symbol;
            this._container.addChild(symbol);
        }
        if (initialReel) {
            this.symbolsOnReel = initialReel.length;
        }
    };
    AvalancheReel.prototype.addAllSymbolsIntoSprite = function (spr, resources) {
        throw new Error('AvalancheReel::addAllSymbolsIntoSprite must be overriden');
    };
    AvalancheReel.prototype.addBackgroundsIntoSprite = function (spr, resources) {
        throw new Error('AvalancheReel::addBackgroundsIntoSprite must be overriden');
    };
    AvalancheReel.prototype.addForegroundIntoSprite = function (spr, resources) {
        throw new Error('AvalancheReel::addForegroundIntoSprite must be overriden');
    };
    AvalancheReel.prototype.setInitialSymbolAtPosition = function (symbol, rowIndex, symbolID) {
        symbol.setSymbol(this.makeSizedSymbol(this._initialStrip[rowIndex], { width: 1, height: 1 }));
    };
    AvalancheReel.prototype.getYPositionForRow = function (rowIndex) {
        return rowIndex * ReelConstants_1.ReelConstants.getSymbolSlot(this._viewType).height;
    };
    AvalancheReel.prototype.makeSizedSymbol = function (symbol, size) {
        throw new Error('AvalancheReel::makeSizedSymbol must be overriden');
    };
    AvalancheReel.prototype.createReelSymbol = function () {
        return new ReelSymbol_1.ReelSymbol();
    };
    AvalancheReel.prototype.showAllSymbols = function () {
        for (var i = 0; i < this.symbolsOnReel; i++) {
            this.showSymbolAtPos(i);
        }
    };
    AvalancheReel.prototype.hideSymbolAtPos = function (pos) {
        this._symbols[pos].visible = false;
    };
    AvalancheReel.prototype.showSymbolAtPos = function (pos) {
        this._symbols[pos].visible = true;
    };
    Object.defineProperty(AvalancheReel.prototype, "soundPlayer", {
        get: function () {
            return this._soundPlayer;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AvalancheReel.prototype, "spineUtils", {
        get: function () {
            return this._spineUtils;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AvalancheReel.prototype, "onReelDropOutFinished", {
        set: function (value) {
            this._onReelDropOutFinished = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AvalancheReel.prototype, "onReelDropFirstSymbolFinished", {
        set: function (value) {
            this._onReelDropFirstSymbolFinished = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AvalancheReel.prototype, "onReelDropNewFinished", {
        set: function (value) {
            this._onReelDropNewFinished = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AvalancheReel.prototype, "onFillingVoidsFinished", {
        set: function (value) {
            this._onFillingVoidsFinished = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AvalancheReel.prototype, "onAddingSymbolsFinished", {
        set: function (value) {
            this._onAddingSymbolsFinished = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AvalancheReel.prototype, "topVisibleSymbolIndex", {
        get: function () {
            return this._topVisibleSymbolIndex;
        },
        set: function (value) {
            this._topVisibleSymbolIndex = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AvalancheReel.prototype, "symbolsOnReel", {
        get: function () {
            return this._symbolsOnReel;
        },
        set: function (value) {
            this._symbolsOnReel = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AvalancheReel.prototype, "timerUtils", {
        set: function (value) {
            this._timerUtils = value;
        },
        enumerable: true,
        configurable: true
    });
    var AvalancheReel_1;
    AvalancheReel.STOP_ANIMATION_TIMER_OFFSET = 50;
    AvalancheReel.DROP_REELS_AVALANCHE_EASING = Easing_1.Easing.Exponential.Out;
    AvalancheReel = AvalancheReel_1 = __decorate([
        inversify_1.injectable(),
        __metadata("design:paramtypes", [Number, Number, Object, PIXI.Sprite, Number])
    ], AvalancheReel);
    return AvalancheReel;
}(UpdateManager_1.UpdateManager));
exports.AvalancheReel = AvalancheReel;


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var AvalancheReelsModule_1 = __webpack_require__(23);
var SpinButtonEvents_1 = __webpack_require__(12);
var Action_1 = __webpack_require__(29);
var AvalancheReelsBasicState = /** @class */ (function (_super) {
    __extends(AvalancheReelsBasicState, _super);
    function AvalancheReelsBasicState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AvalancheReelsBasicState.prototype.onEnterState = function () {
    };
    AvalancheReelsBasicState.prototype.onLeaveState = function () {
    };
    AvalancheReelsBasicState.prototype.setupEvents = function () {
        this.on(SpinButtonEvents_1.SpinButtonEvents.SPIN_BUTTON_PRESSED, this.onSpinStartedByButton);
    };
    AvalancheReelsBasicState.prototype.onSpinStartedByButton = function () {
        if (this.module.logic.nextAction === Action_1.Action.SPIN || this.module.logic.nextAction === Action_1.Action.FREESPIN) {
            this.module.gotoState(AvalancheReelsModule_1.AvalancheReelsModule.DROPOUT_STATE);
        }
    };
    return AvalancheReelsBasicState;
}(ModuleState_1.ModuleState));
exports.AvalancheReelsBasicState = AvalancheReelsBasicState;


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var GameAvalancheReelEvents = /** @class */ (function () {
    function GameAvalancheReelEvents() {
    }
    GameAvalancheReelEvents.REMOVING_STARTED = 'GameAvalancheReelEvents::REMOVING_STARTED';
    return GameAvalancheReelEvents;
}());
exports.GameAvalancheReelEvents = GameAvalancheReelEvents;


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var AvalancheReelsInitState_1 = __webpack_require__(265);
var GameAvalancheReelsInitState = /** @class */ (function (_super) {
    __extends(GameAvalancheReelsInitState, _super);
    function GameAvalancheReelsInitState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameAvalancheReelsInitState.prototype.onInitResponse = function () {
        var logic = this.module.logic;
        if (!logic.hasRestore) {
            this.view.createReelSet(logic.getRecodeSpinResults().reels);
        }
        _super.prototype.onInitResponse.call(this);
    };
    return GameAvalancheReelsInitState;
}(AvalancheReelsInitState_1.AvalancheReelsInitState));
exports.GameAvalancheReelsInitState = GameAvalancheReelsInitState;


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var BackgroundBasicState = /** @class */ (function (_super) {
    __extends(BackgroundBasicState, _super);
    function BackgroundBasicState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BackgroundBasicState.prototype.onEnterState = function () {
    };
    BackgroundBasicState.prototype.onLeaveState = function () {
    };
    BackgroundBasicState.prototype.setupEvents = function () {
    };
    return BackgroundBasicState;
}(ModuleState_1.ModuleState));
exports.BackgroundBasicState = BackgroundBasicState;


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var DebuggingComponent_1 = __webpack_require__(151);
var BackgroundDebuggingComponent = /** @class */ (function (_super) {
    __extends(BackgroundDebuggingComponent, _super);
    function BackgroundDebuggingComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BackgroundDebuggingComponent.prototype.init = function () {
        _super.prototype.init.call(this);
        this.setupInput();
        this.addKeyFunction('KeyV', 'shakeBackground', function () {
        });
    };
    return BackgroundDebuggingComponent;
}(DebuggingComponent_1.DebuggingComponent));
exports.BackgroundDebuggingComponent = BackgroundDebuggingComponent;


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var CheatView_1 = __webpack_require__(531);
var GameCheatView = /** @class */ (function (_super) {
    __extends(GameCheatView, _super);
    function GameCheatView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameCheatView.prototype.initializeCheatsList = function () {
        _super.prototype.initializeCheatsList.call(this);
        if (this._configByCheatName) {
            this._cheats = this._configByCheatName.record;
            delete this._cheats.name;
        }
    };
    return GameCheatView;
}(CheatView_1.CheatView));
exports.GameCheatView = GameCheatView;


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var View_1 = __webpack_require__(3);
var SpriteButton_1 = __webpack_require__(55);
var GameConfig_1 = __webpack_require__(142);
var CheatView = /** @class */ (function (_super) {
    __extends(CheatView, _super);
    function CheatView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._cheats = {};
        return _this;
    }
    CheatView.prototype.init = function () {
        _super.prototype.init.call(this);
        this.container.anchor.set(0.5, 0);
        this.initConfig();
        this.initializeCheatsList();
        this.initializeBackground();
        this.initializeSpinCheatButtons();
        this.initializeInfoText();
        this.initializeDateStamp();
        this.correctContainerPositionFromDevice();
        this.hide();
    };
    CheatView.prototype.initConfig = function () {
        var gameConfig = new GameConfig_1.GameConfig();
        gameConfig.loadConfig(this.resources.getConfig('config.json'));
        if (gameConfig && gameConfig.getConfigByName('cheatsNames')) {
            this._configByCheatName = gameConfig.getConfigByName('cheatsNames');
        }
        if (gameConfig && gameConfig.getConfigByName('cheatsPaths')) {
            this._configByCheatPath = gameConfig.getConfigByName('cheatsPaths');
        }
    };
    CheatView.prototype.correctContainerPositionFromDevice = function () {
    };
    CheatView.prototype.addMathVersion = function (mathVersion) {
        this._infoText.text += " Math: " + mathVersion;
    };
    CheatView.prototype.initializeDateStamp = function () {
        var style = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 18,
            fontWeight: 'bold',
            fill: ['#ffffff'],
        });
        this._infoText = new PIXI.Text("Date: " + "2020-09-21" + " Branch:" + "master" + " Version: " + "0.6.1", style);
        this._infoText.position.set(50, 850);
        this.container.addChild(this._infoText);
    };
    CheatView.prototype.initializeSpinCheatButtons = function () {
        var _this = this;
        var style = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 18,
            fontWeight: 'bold',
            fill: ['#ffffff'],
        });
        this._currentCheat = new PIXI.Text('SpinCheats: ', style);
        this._currentCheat.position.set(65, 25);
        this.container.addChild(this._currentCheat);
        var elementsPerColumn = this.device.isMobile ? 30 : 25;
        var it = 0;
        var buttonSize = this.getButtonDimensions();
        var xOffset = 25;
        var extraYOffset = 5;
        var _loop_1 = function (cheat) {
            if (cheat) {
                var btn = this_1.createButton(cheat);
                var yOffset = it / elementsPerColumn;
                btn.position.set(50 + Math.trunc(yOffset) * (buttonSize.width + xOffset), 50 + (buttonSize.height + extraYOffset) * (it % elementsPerColumn));
                btn.callback = function () {
                    _this.setCheat(cheat, _this._cheats[cheat]);
                };
                this_1.container.addChild(btn);
                it++;
            }
        };
        var this_1 = this;
        for (var cheat in this._cheats) {
            _loop_1(cheat);
        }
    };
    CheatView.prototype.setCheat = function (cheatName, cheatText) {
        if (!this._configByCheatPath || (!this._configByCheatPath.getParameter(cheatText)
            && cheatText !== null)) {
            console.error("CheatView::path for " + cheatText + " cheat should be be added to config.json");
            return;
        }
        this._currentCheat.text = "Current cheat: " + cheatName;
        window.cheat = cheatText;
        window.cheatPath = this._configByCheatPath.getParameter(cheatText);
    };
    CheatView.prototype.initializeInfoText = function () {
        var style = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: 24,
            fontWeight: 'bold',
            fill: ['#ffffff'],
        });
        this._currentCheat = new PIXI.Text('Current cheat: ', style);
        this._currentCheat.position.set(25, -110);
        this.container.addChild(this._currentCheat);
    };
    CheatView.prototype.initializeBackground = function () {
        var backgroundGraphics = new PIXI.Graphics();
        backgroundGraphics.lineStyle(5, 0x000000, 1);
        backgroundGraphics.beginFill(0x000000, 0.25);
        if (this.device.isMobile) {
            backgroundGraphics.drawRoundedRect(0, 0, 720, 1280, 15);
        }
        else {
            backgroundGraphics.drawRoundedRect(0, 0, 1280, 870, 15);
        }
        backgroundGraphics.endFill();
        this.container.addChild(backgroundGraphics);
    };
    CheatView.prototype.initializeCheatsList = function () {
    };
    CheatView.prototype.getButtonDimensions = function () {
        return this.device.isMobile ? { width: 200, height: 35 } : { width: 150, height: 25 };
    };
    CheatView.prototype.createButton = function (caption) {
        var button = new SpriteButton_1.SpriteButton();
        var basicStyle = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: this.device.isMobile ? 24 : 18,
            fontStyle: 'italic',
            fontWeight: 'bold',
            fill: ['#ffffff', '#00ff99'],
        });
        var rectSize = this.getButtonDimensions();
        var basicSprite = new PIXI.Sprite();
        var basicGraphics = new PIXI.Graphics();
        var basicText = new PIXI.Text(caption, basicStyle);
        basicText.anchor.set(0.5);
        basicText.position.set(rectSize.width / 2, rectSize.height / 2);
        basicGraphics.lineStyle(2, 0xff00ff, 1);
        basicGraphics.beginFill(0xff00bb, 0.25);
        basicGraphics.drawRoundedRect(0, 0, rectSize.width, rectSize.height, 15);
        basicGraphics.endFill();
        basicSprite.addChild(basicGraphics);
        basicSprite.addChild(basicText);
        var hoverSprite = new PIXI.Sprite();
        var hoverGraphics = new PIXI.Graphics();
        var hoverText = new PIXI.Text(caption, basicStyle);
        hoverText.anchor.set(0.5);
        hoverText.position.set(rectSize.width / 2, rectSize.height / 2);
        hoverGraphics.lineStyle(2, 0xff88ff, 1);
        hoverGraphics.beginFill(0xff88bb, 0.25);
        hoverGraphics.drawRoundedRect(0, 0, rectSize.width, rectSize.height, 5);
        hoverGraphics.endFill();
        hoverSprite.addChild(hoverGraphics);
        hoverSprite.addChild(hoverText);
        var downSprite = new PIXI.Sprite();
        var downGraphics = new PIXI.Graphics();
        var downText = new PIXI.Text(caption, basicStyle);
        downText.anchor.set(0.5);
        downText.position.set(rectSize.width / 2, rectSize.height / 2);
        downGraphics.lineStyle(2, 0xffffff, 1);
        downGraphics.beginFill(0xffffbb, 0.25);
        downGraphics.drawRoundedRect(0, 0, rectSize.width, rectSize.height, 5);
        downGraphics.endFill();
        downSprite.addChild(downGraphics);
        downSprite.addChild(downText);
        button.setFrames(basicSprite, downSprite, hoverSprite);
        return button;
    };
    return CheatView;
}(View_1.View));
exports.CheatView = CheatView;


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var DebuggingComponent_1 = __webpack_require__(151);
var WinPresentationDebuggingComponent = /** @class */ (function (_super) {
    __extends(WinPresentationDebuggingComponent, _super);
    function WinPresentationDebuggingComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WinPresentationDebuggingComponent.prototype.init = function () {
        _super.prototype.init.call(this);
        this.addWindowFunction('showWinCounter', this.showWin.bind(this));
    };
    WinPresentationDebuggingComponent.prototype.showWin = function (winAmount, isExcellent) {
        if (isExcellent === void 0) { isExcellent = false; }
        this.view.playWinNumberCounter(winAmount, isExcellent);
    };
    return WinPresentationDebuggingComponent;
}(DebuggingComponent_1.DebuggingComponent));
exports.WinPresentationDebuggingComponent = WinPresentationDebuggingComponent;


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var ReelsEvents_1 = __webpack_require__(4);
var SwipeInteractionEvents_1 = __webpack_require__(65);
var WinPresentationModule_1 = __webpack_require__(77);
var BetlevelMenuEvents_1 = __webpack_require__(48);
var WinPresentationEvents_1 = __webpack_require__(13);
var WinPresentationIndividualState = /** @class */ (function (_super) {
    __extends(WinPresentationIndividualState, _super);
    function WinPresentationIndividualState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WinPresentationIndividualState.prototype.onEnterState = function () {
    };
    WinPresentationIndividualState.prototype.onLeaveState = function () {
        this.stopWinPresentation();
        this.view.forceKillWinNumbers();
    };
    WinPresentationIndividualState.prototype.setupEvents = function () {
        this.on(ReelsEvents_1.ReelsEvents.REELS_SPINNING_STARTED, this.onReelSpinningStarted);
        this.on(SwipeInteractionEvents_1.SwipeInteractionEvents.DRAGGING_STARTED, this.onSwipeInteractionStarted);
        this.on(BetlevelMenuEvents_1.BetlevelMenuEvents.BET_VALUE_UPDATED, this.onBetValueUpdated);
        this.on(WinPresentationEvents_1.WinPresentationEvents.COUNTUP_FINISHED, this.onCountupFinished);
    };
    WinPresentationIndividualState.prototype.onCountupFinished = function () {
    };
    WinPresentationIndividualState.prototype.onBetValueUpdated = function () {
        this.module.gotoState(WinPresentationModule_1.WinPresentationModule.BASIC);
    };
    WinPresentationIndividualState.prototype.onReelSpinningStarted = function () {
        this.module.gotoState(WinPresentationModule_1.WinPresentationModule.BASIC);
    };
    WinPresentationIndividualState.prototype.onSwipeInteractionStarted = function () {
        this.view.killCurrentWinPresentation();
        this.module.gotoState(WinPresentationModule_1.WinPresentationModule.BASIC);
    };
    WinPresentationIndividualState.prototype.stopWinPresentation = function () {
        this.emitDelayed(WinPresentationEvents_1.WinPresentationEvents.INDIVIDUAL_ANIMATION_SKIPPED);
        this.view.killCurrentWinPresentation();
        this.view.forceKillWinNumbers();
    };
    return WinPresentationIndividualState;
}(ModuleState_1.ModuleState));
exports.WinPresentationIndividualState = WinPresentationIndividualState;


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var WinPresentationInitialState_1 = __webpack_require__(159);
var WinPresentationInitialBeforeBigWin = /** @class */ (function (_super) {
    __extends(WinPresentationInitialBeforeBigWin, _super);
    function WinPresentationInitialBeforeBigWin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return WinPresentationInitialBeforeBigWin;
}(WinPresentationInitialState_1.WinPresentationInitialState));
exports.WinPresentationInitialBeforeBigWin = WinPresentationInitialBeforeBigWin;


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var WinPresentationModule_1 = __webpack_require__(77);
var SpinButtonEvents_1 = __webpack_require__(12);
var Timer_1 = __webpack_require__(28);
var WinPresentationSkippedState = /** @class */ (function (_super) {
    __extends(WinPresentationSkippedState, _super);
    function WinPresentationSkippedState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WinPresentationSkippedState.prototype.onEnterState = function () {
        var _this = this;
        this.view.killCurrentWinPresentation();
        this._skippedTimer = new Timer_1.Timer(function () {
            _this.view.forceKillWinNumbers();
            _this._skippedTimer = null;
            _this.module.gotoState(WinPresentationModule_1.WinPresentationModule.BASIC);
        }, WinPresentationSkippedState.FINAL_SKIPPED_SHOWING_TIMER, true);
        this.module.updateManager.add(this._skippedTimer);
    };
    WinPresentationSkippedState.prototype.onLeaveState = function () {
    };
    WinPresentationSkippedState.prototype.setupEvents = function () {
        this.on(SpinButtonEvents_1.SpinButtonEvents.QUICKSTOP_PRESSED, this.onQuickstopPressed);
    };
    WinPresentationSkippedState.prototype.onQuickstopPressed = function () {
        this._skippedTimer.stopWithCallback();
        this._skippedTimer = null;
    };
    WinPresentationSkippedState.FINAL_SKIPPED_SHOWING_TIMER = 1000;
    return WinPresentationSkippedState;
}(ModuleState_1.ModuleState));
exports.WinPresentationSkippedState = WinPresentationSkippedState;


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var WinPresentationBasicState_1 = __webpack_require__(279);
var GameFlowEvents_1 = __webpack_require__(57);
var GameWinPresentationModule_1 = __webpack_require__(278);
var GameWinPresentationBasicState = /** @class */ (function (_super) {
    __extends(GameWinPresentationBasicState, _super);
    function GameWinPresentationBasicState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameWinPresentationBasicState.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(GameFlowEvents_1.GameFlowEvents.HAS_WIN_WITH_MULTIPLIER, this.onHasWinWithMultiplier);
        this.on(GameFlowEvents_1.GameFlowEvents.HAS_BIGWIN_WITH_MULTIPLIER, this.onHasBigWinWithMultiplier);
        this.on(GameFlowEvents_1.GameFlowEvents.HAS_WIN_WITH_NO_MULTIPLIER, this.onHasWinWithNoMultiplier);
    };
    GameWinPresentationBasicState.prototype.onWon = function () {
    };
    GameWinPresentationBasicState.prototype.onHasWinWithMultiplier = function () {
        this.module.gotoState(GameWinPresentationModule_1.GameWinPresentationModule.WIN_WITH_MULTIPLIER_STATE);
    };
    GameWinPresentationBasicState.prototype.onHasWinWithNoMultiplier = function () {
        this.module.gotoState(GameWinPresentationModule_1.GameWinPresentationModule.WIN_NO_MULTIPLIER_STATE);
    };
    GameWinPresentationBasicState.prototype.onHasBigWinWithMultiplier = function () {
        this.module.gotoState(GameWinPresentationModule_1.GameWinPresentationModule.BIG_WIN_WITH_MULTILPLER_STATE);
    };
    return GameWinPresentationBasicState;
}(WinPresentationBasicState_1.WinPresentationBasicState));
exports.GameWinPresentationBasicState = GameWinPresentationBasicState;


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var GameWinPresentationInitialState_1 = __webpack_require__(160);
var WinPresentationEvents_1 = __webpack_require__(13);
var WildMeterEvents_1 = __webpack_require__(66);
var GameWinPresentationEvents_1 = __webpack_require__(40);
var GameWinPresentationBigWinWithMultiplierState = /** @class */ (function (_super) {
    __extends(GameWinPresentationBigWinWithMultiplierState, _super);
    function GameWinPresentationBigWinWithMultiplierState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameWinPresentationBigWinWithMultiplierState.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(WildMeterEvents_1.WildMeterEvents.WIN_METER_EXIT_WIN_ANIMATION_FINISHED, this.onWinMeterWinExitAnimationFinished);
    };
    /*
    1) win amount moves swiftly from win field to center reels
    2) Multiplier moves shortly after and hits win.
    3a) big win presentation kicks in, counting from unmultiplied amount
     */
    GameWinPresentationBigWinWithMultiplierState.prototype.startInitialWinPresentation = function () {
        var logic = this.module.logic;
        this.emit(GameWinPresentationEvents_1.GameWinPresentationEvents.COUNTING_STARTED, logic.getLastAvalancheRunningTotal());
        this.view.playWinNumberCounter(logic.getLastAvalancheRunningTotal(), false, // no countup here
        0, false);
        this.emit(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_STARTED);
    };
    GameWinPresentationBigWinWithMultiplierState.prototype.onWinMeterWinExitAnimationFinished = function () {
        this.emit(GameWinPresentationEvents_1.GameWinPresentationEvents.PRE_MULTIPLIER_BIG_WIN_FINISHED);
        this.onWinAnimationFinished();
    };
    GameWinPresentationBigWinWithMultiplierState.prototype.tryToFinishWinPresentation = function () {
    };
    return GameWinPresentationBigWinWithMultiplierState;
}(GameWinPresentationInitialState_1.GameWinPresentationInitialState));
exports.GameWinPresentationBigWinWithMultiplierState = GameWinPresentationBigWinWithMultiplierState;


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var GameWinPresentationInitialState_1 = __webpack_require__(160);
var WinPresentationEvents_1 = __webpack_require__(13);
var GameWinPresentationEvents_1 = __webpack_require__(40);
var WinUtils_1 = __webpack_require__(58);
var GameWinPresentationInitialWinNoMultiplierState = /** @class */ (function (_super) {
    __extends(GameWinPresentationInitialWinNoMultiplierState, _super);
    function GameWinPresentationInitialWinNoMultiplierState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameWinPresentationInitialWinNoMultiplierState.prototype.startInitialWinPresentation = function () {
        var logic = this.module.logic;
        !WinUtils_1.WinUtils.isBigWin(logic) && this.emit(GameWinPresentationEvents_1.GameWinPresentationEvents.COUNTING_STARTED, logic.currentSpinWin);
        this.view.playWinNumberCounter(logic.currentSpinWin, false, // no countup here
        2, false);
        this.emit(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_STARTED);
    };
    return GameWinPresentationInitialWinNoMultiplierState;
}(GameWinPresentationInitialState_1.GameWinPresentationInitialState));
exports.GameWinPresentationInitialWinNoMultiplierState = GameWinPresentationInitialWinNoMultiplierState;


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var GameWinPresentationInitialState_1 = __webpack_require__(160);
var WinPresentationEvents_1 = __webpack_require__(13);
var WildMeterEvents_1 = __webpack_require__(66);
var GameWinPresentationEvents_1 = __webpack_require__(40);
var SpinButtonEvents_1 = __webpack_require__(12);
var GameWinPresentationInitialWinWithMultiplierState = /** @class */ (function (_super) {
    __extends(GameWinPresentationInitialWinWithMultiplierState, _super);
    function GameWinPresentationInitialWinWithMultiplierState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameWinPresentationInitialWinWithMultiplierState.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(WildMeterEvents_1.WildMeterEvents.WIN_METER_EXIT_WIN_ANIMATION_FINISHED, this.onWinMeterWinExitAnimationFinished);
        this.on(GameWinPresentationEvents_1.GameWinPresentationEvents.AFTER_MULTIPLIER_COUNTING_FINISHED, this.onAfterMultiplierCountingFinished);
        this.on(SpinButtonEvents_1.SpinButtonEvents.SKIP_BY_SPIN_BUTTON_PRESSED, this.onSkipBySpinButtonClicked);
    };
    /*
    If multiplier > 1
    1) win amount moves swiftly from win field to center reels
    2) Multiplier moves shortly after and hits win.
    3b) Win counts normally from unmultiplied to multiplied amount
     */
    GameWinPresentationInitialWinWithMultiplierState.prototype.startInitialWinPresentation = function () {
        var logic = this.module.logic;
        this.emit(GameWinPresentationEvents_1.GameWinPresentationEvents.COUNTING_STARTED, logic.getLastAvalancheRunningTotal());
        this.view.playWinNumberCounter(logic.getLastAvalancheRunningTotal(), false, // no countup here
        0, false);
        this.emit(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_STARTED);
    };
    GameWinPresentationInitialWinWithMultiplierState.prototype.onWinMeterWinExitAnimationFinished = function () {
        this.emit(SpinButtonEvents_1.SpinButtonEvents.DISABLE_SPIN_BY_SPIN);
        var logic = this.module.logic;
        var playCountUpSound = true;
        this.emit(GameWinPresentationEvents_1.GameWinPresentationEvents.COUNTING_STARTED, logic.currentSpinWin - logic.getLastAvalancheRunningTotal(), playCountUpSound);
        this.view.playCountingFormToAfterMultiplier(logic.getLastAvalancheRunningTotal(), logic.currentSpinWin);
    };
    GameWinPresentationInitialWinWithMultiplierState.prototype.onSkipBySpinButtonClicked = function () {
        this.view.skipCountUp();
    };
    GameWinPresentationInitialWinWithMultiplierState.prototype.onAfterMultiplierCountingFinished = function () {
        var _this = this;
        this.module.timeUtils.createTimer(function () {
            _this.onWinAnimationFinished();
        }, 500);
    };
    GameWinPresentationInitialWinWithMultiplierState.prototype.tryToFinishWinPresentation = function () {
    };
    return GameWinPresentationInitialWinWithMultiplierState;
}(GameWinPresentationInitialState_1.GameWinPresentationInitialState));
exports.GameWinPresentationInitialWinWithMultiplierState = GameWinPresentationInitialWinWithMultiplierState;


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Module_1 = __webpack_require__(2);
var RespinView_1 = __webpack_require__(280);
var GameViews_1 = __webpack_require__(43);
var FlowModuleEvents_1 = __webpack_require__(0);
var RespinEvents_1 = __webpack_require__(92);
var RecodeLogic_1 = __webpack_require__(94);
var RespinModule = /** @class */ (function (_super) {
    __extends(RespinModule, _super);
    function RespinModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RespinModule.prototype.enterFirstState = function () {
    };
    RespinModule.prototype.setupStates = function () {
    };
    RespinModule.prototype.setupViews = function () {
        this.setView(GameViews_1.GameViews.RESPIN_VIEW);
    };
    RespinModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(FlowModuleEvents_1.FlowModuleEvents.RESPIN_WON, this.onRespinWon);
        this.onViewEmitEvent(RespinView_1.RespinView.LEAVING_RESPIN_SYMBOL, RespinEvents_1.RespinEvents.LEAVING_SCATTER_AT);
        this.onViewEmitEvent(RespinView_1.RespinView.SYMBOL_WAS_SHOT, RespinEvents_1.RespinEvents.LEAVING_SYMBOL_AT);
        this.onViewEmitEvent(RespinView_1.RespinView.RESPIN_END_ANIM_TRIGGERED, RespinEvents_1.RespinEvents.END_ANIM_TRIGGERED);
        this.onViewEmitEvent(RespinView_1.RespinView.FINISHED, RespinEvents_1.RespinEvents.RESPIN_REMOVING_FINISHED);
    };
    RespinModule.prototype.onRespinWon = function () {
        var logic = this.logic;
        if (logic.getNextRoundType() === RecodeLogic_1.RoundTypes.SCATTER_REPLACEMENT) {
            this.eventManager.emit(RespinEvents_1.RespinEvents.RESPIN_STARTED);
            this.view.tryToStartRespinSymbols(logic.getSpinResult().respinScatters);
        }
        else {
            throw new Error('RecodeRespinModule::onRespinWon round type isn\'t RoundTypes.SCATTER_REPLACEMENT');
        }
    };
    return RespinModule;
}(Module_1.Module));
exports.RespinModule = RespinModule;


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Storage_1 = __webpack_require__(150);
var ReCodeStorage = /** @class */ (function (_super) {
    __extends(ReCodeStorage, _super);
    function ReCodeStorage(apiReference) {
        var _this = _super.call(this) || this;
        _this.setStorageReference(apiReference);
        return _this;
    }
    ReCodeStorage.prototype.setItem = function (key, value) {
        this._APIReference.setItem(key, value);
    };
    ReCodeStorage.prototype.getItem = function (item) {
        return this._APIReference.getItem(item);
    };
    ReCodeStorage.prototype.getKey = function (key) {
        return this._APIReference.getKey(key);
    };
    ReCodeStorage.prototype.removeItem = function (key) {
        this._APIReference.removeItem(key);
    };
    ReCodeStorage.prototype.getLength = function () {
        return this._APIReference.getLength();
    };
    ReCodeStorage.prototype.hasItem = function (key) {
        return this._APIReference.hasItem(key);
    };
    ReCodeStorage.prototype.each = function () {
        return this._APIReference.each;
    };
    ReCodeStorage.prototype.setStorageReference = function (VAPIStorage) {
        this._APIReference = VAPIStorage;
    };
    return ReCodeStorage;
}(Storage_1.UserStorage));
exports.ReCodeStorage = ReCodeStorage;


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var RecodeLogicEvents = /** @class */ (function () {
    function RecodeLogicEvents() {
    }
    RecodeLogicEvents.FREE_GAMES_REJECTED_RESPONSE = 'RecodeLogicEvents::FREE_GAMES_REJECTED_RESPONSE';
    return RecodeLogicEvents;
}());
exports.RecodeLogicEvents = RecodeLogicEvents;


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var FlowModule_1 = __webpack_require__(35);
var FlowRestoreState_1 = __webpack_require__(287);
var FlowWhileSpinningState_1 = __webpack_require__(288);
var GameFlowBasicState_1 = __webpack_require__(545);
var GameFlowFreeSpinsState_1 = __webpack_require__(546);
var GameFlowRespinState_1 = __webpack_require__(547);
var GameFlowAvalancheState_1 = __webpack_require__(548);
var GameFlowModule = /** @class */ (function (_super) {
    __extends(GameFlowModule, _super);
    function GameFlowModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameFlowModule.prototype.setupStates = function () {
        this.addState(new GameFlowBasicState_1.GameFlowBasicState(this, FlowModule_1.FlowModule.BASIC_STATE, this.eventManager));
        this.addState(new GameFlowFreeSpinsState_1.GameFlowFreeSpinsState(this, FlowModule_1.FlowModule.FREE_SPINS_STATE, this.eventManager));
        this.addState(new FlowRestoreState_1.FlowRestoreState(this, FlowModule_1.FlowModule.RESTORE_STATE));
        this.addState(new GameFlowRespinState_1.GameFlowRespinState(this, FlowModule_1.FlowModule.RESPIN_STATE, this.eventManager));
        this.addState(new GameFlowAvalancheState_1.GameFlowAvalancheState(this, FlowModule_1.FlowModule.AVALANCHE_STATE, this.eventManager));
        this.addState(new FlowWhileSpinningState_1.FlowWhileSpinningState(this, FlowModule_1.FlowModule.WHILESPIN_STATE, this.eventManager));
    };
    return GameFlowModule;
}(FlowModule_1.FlowModule));
exports.GameFlowModule = GameFlowModule;


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var FlowModule_1 = __webpack_require__(35);
var LogicEvents_1 = __webpack_require__(11);
var QueueEventsHandler_1 = __webpack_require__(115);
var Action_1 = __webpack_require__(29);
var FlowModuleEvents_1 = __webpack_require__(0);
var BonusGameEvents_1 = __webpack_require__(78);
var FlowBonusState = /** @class */ (function (_super) {
    __extends(FlowBonusState, _super);
    function FlowBonusState(module, name, eventManager) {
        var _this = _super.call(this, module, name) || this;
        _this._queueEvents = new QueueEventsHandler_1.QueueEventsHandler(eventManager);
        return _this;
    }
    FlowBonusState.prototype.onEnterState = function () {
    };
    FlowBonusState.prototype.onLeaveState = function () {
    };
    FlowBonusState.prototype.setupEvents = function () {
        this.on(LogicEvents_1.LogicEvents.PICK_RESPONSE, this.onBonusGamePick);
        this.on(LogicEvents_1.LogicEvents.SKIPPICK_RESPONSE, this.onBonusGamePick);
        this.on(BonusGameEvents_1.BonusGameEvents.BONUS_OUTRO_FINISHED, this.onBonusOutroFinished);
    };
    FlowBonusState.prototype.onBonusGamePick = function (pickData) {
        this._queueEvents.clearEventsQueue();
        if (this.module.logic.nextAction !== Action_1.Action.PICK) {
            this._queueEvents.addEventToWaitingList(BonusGameEvents_1.BonusGameEvents.WIN_RESULT_SHOWN, FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_END);
        }
    };
    FlowBonusState.prototype.onBonusOutroFinished = function () {
        this.emit(FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN);
        switch (this.module.logic.nextAction) {
            case Action_1.Action.SPIN: {
                this.setupNextStateSpin();
                break;
            }
            case Action_1.Action.FREESPIN: {
                this.setupNextStateFreeSpin();
                break;
            }
            case Action_1.Action.RESPIN: {
                this.setupNextStateRespin();
                break;
            }
            case Action_1.Action.AVALANCHE: {
                this.setupNextStateAvalanche();
                break;
            }
            default:
                break;
        }
    };
    FlowBonusState.prototype.setupNextStateSpin = function () {
        this.module.gotoState(FlowModule_1.FlowModule.BASIC_STATE);
    };
    FlowBonusState.prototype.setupNextStateFreeSpin = function () {
        this.module.gotoState(FlowModule_1.FlowModule.FREE_SPINS_STATE);
    };
    FlowBonusState.prototype.setupNextStateRespin = function () {
        this.module.gotoState(FlowModule_1.FlowModule.RESPIN_STATE);
    };
    FlowBonusState.prototype.setupNextStateAvalanche = function () {
        this.module.gotoState(FlowModule_1.FlowModule.AVALANCHE_STATE);
    };
    return FlowBonusState;
}(ModuleState_1.ModuleState));
exports.FlowBonusState = FlowBonusState;


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var FlowBasicState_1 = __webpack_require__(284);
var FlowModuleEvents_1 = __webpack_require__(0);
var FlowModule_1 = __webpack_require__(35);
var GameFlowEvents_1 = __webpack_require__(57);
var GameAvalancheReelsEvents_1 = __webpack_require__(39);
var BigWinEvents_1 = __webpack_require__(21);
var WinPresentationEvents_1 = __webpack_require__(13);
var FreeSpinsTriggerModule_1 = __webpack_require__(76);
var GameFlowBasicState = /** @class */ (function (_super) {
    __extends(GameFlowBasicState, _super);
    function GameFlowBasicState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameFlowBasicState.prototype.hasAnyBeforeWinFeatures = function () {
        var logic = this.module.logic;
        return logic.hasWinsToHighlight();
    };
    GameFlowBasicState.prototype.addBeforeWinFeatures = function () {
        _super.prototype.addBeforeWinFeatures.call(this);
        var logic = this.module.logic;
        var eventsPairs = [];
        if (logic.hasWinsToHighlight()) {
            eventsPairs.push({
                start: GameFlowEvents_1.GameFlowEvents.HAS_WIN_SYMBOLS_TO_HIGHLIGHT,
                end: GameAvalancheReelsEvents_1.GameAvalancheReelsEvents.WIN_HIGHLIGHTING_FINISHED,
            });
        }
        if (eventsPairs.length > 0) {
            this._queueEvents.addEventsPairFlow(eventsPairs, this.decideOnNextAction.bind(this));
        }
        else {
            throw new Error("GameFlowBasicState::addBeforeWinFeatures need more events");
        }
    };
    GameFlowBasicState.prototype.setupNextStateFreeSpinsFlow = function () {
        if (this.isSpinWin()) {
            if (this.isBigWin()) {
                this._queueEvents.addEventToWaitingList(BigWinEvents_1.BigWinEvents.FINISHED, GameFlowEvents_1.GameFlowEvents.PLAY_FREE_SPINS_TRIGGER);
                this._queueEvents.addEventToWaitingList(FreeSpinsTriggerModule_1.FreeSpinsTriggerModule.FREE_SPINS_TRIGGER_FINISHED, FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
                this.setupBigWinNoIndividualNoSpin();
                this.setupCantSpinBigWin();
            }
            else {
                this._queueEvents.addEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED, GameFlowEvents_1.GameFlowEvents.PLAY_FREE_SPINS_TRIGGER);
                this._queueEvents.addEventToWaitingList(FreeSpinsTriggerModule_1.FreeSpinsTriggerModule.FREE_SPINS_TRIGGER_FINISHED, FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
                this.setupCantSpinWin();
            }
        }
        else {
            this.setupCantSpinNoWin();
            this.emit(GameFlowEvents_1.GameFlowEvents.PLAY_FREE_SPINS_TRIGGER);
            this._queueEvents.addEventToWaitingList(FreeSpinsTriggerModule_1.FreeSpinsTriggerModule.FREE_SPINS_TRIGGER_FINISHED, FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
        }
    };
    GameFlowBasicState.prototype.setupNextStateAvalancheFlow = function () {
        var _this = this;
        this._queueEvents.addFunctionCallingEventToWaitingList(FlowModuleEvents_1.FlowModuleEvents.AVALANCHE_WON, function () {
            _this.module.gotoState(FlowModule_1.FlowModule.AVALANCHE_STATE);
        });
        this.emit(FlowModuleEvents_1.FlowModuleEvents.AVALANCHE_WON);
    };
    GameFlowBasicState.prototype.setupBigWinNoWinAfterwards = function () {
        this.emit(FlowModuleEvents_1.FlowModuleEvents.WON_BIG_WIN);
    };
    return GameFlowBasicState;
}(FlowBasicState_1.FlowBasicState));
exports.GameFlowBasicState = GameFlowBasicState;


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var FlowFreeSpinsState_1 = __webpack_require__(285);
var FlowModule_1 = __webpack_require__(35);
var FlowModuleEvents_1 = __webpack_require__(0);
var GameFlowEvents_1 = __webpack_require__(57);
var GameAvalancheReelsEvents_1 = __webpack_require__(39);
var WinPresentationEvents_1 = __webpack_require__(13);
var BigWinEvents_1 = __webpack_require__(21);
var FreeSpinsEvents_1 = __webpack_require__(6);
var FreeSpinsTriggerModule_1 = __webpack_require__(76);
var GameFlowFreeSpinsState = /** @class */ (function (_super) {
    __extends(GameFlowFreeSpinsState, _super);
    function GameFlowFreeSpinsState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameFlowFreeSpinsState.prototype.hasAnyBeforeWinFeatures = function () {
        var logic = this.module.logic;
        return logic.hasWinsToHighlight();
    };
    GameFlowFreeSpinsState.prototype.addBeforeWinFeatures = function () {
        _super.prototype.addBeforeWinFeatures.call(this);
        var logic = this.module.logic;
        var eventsPairs = [];
        if (logic.hasWinsToHighlight()) {
            eventsPairs.push({
                start: GameFlowEvents_1.GameFlowEvents.HAS_WIN_SYMBOLS_TO_HIGHLIGHT,
                end: GameAvalancheReelsEvents_1.GameAvalancheReelsEvents.WIN_HIGHLIGHTING_FINISHED,
            });
        }
        if (eventsPairs.length > 0) {
            this._queueEvents.addEventsPairFlow(eventsPairs, this.decideOnNextAction.bind(this));
        }
        else {
            throw new Error("GameFlowFreeSpinsState::addBeforeWinFeatures need more events");
        }
    };
    GameFlowFreeSpinsState.prototype.setupNextStateAvalancheFlow = function () {
        var _this = this;
        this._queueEvents.addFunctionCallingEventToWaitingList(FlowModuleEvents_1.FlowModuleEvents.AVALANCHE_WON, function () {
            _this.module.gotoState(FlowModule_1.FlowModule.AVALANCHE_STATE);
        });
        this.emit(FlowModuleEvents_1.FlowModuleEvents.AVALANCHE_WON);
    };
    GameFlowFreeSpinsState.prototype.setupBigWinNoWinAfterwards = function () {
        this.emit(FlowModuleEvents_1.FlowModuleEvents.WON_BIG_WIN);
    };
    GameFlowFreeSpinsState.prototype.setupWin = function () {
        this.emit(FlowModuleEvents_1.FlowModuleEvents.WON);
        var logic = this.module.logic;
        if (logic.hasFreeSpinsRetrigger) {
            this._queueEvents.addEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED, GameFlowEvents_1.GameFlowEvents.PLAY_FREE_SPINS_TRIGGER);
            this._queueEvents.addEventToWaitingList(FreeSpinsTriggerModule_1.FreeSpinsTriggerModule.FREE_SPINS_TRIGGER_FINISHED, FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_RETRIGGER_FINISHED);
            this._queueEvents.addEventToWaitingList(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_RETRIGGER_FINISHED, FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN);
        }
        else {
            this._queueEvents.addEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED, FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN);
        }
    };
    GameFlowFreeSpinsState.prototype.setupBigWin = function () {
        this._queueEvents.addEventToWaitingList(BigWinEvents_1.BigWinEvents.FINISHED, FlowModuleEvents_1.FlowModuleEvents.WON);
        var logic = this.module.logic;
        if (logic.hasFreeSpinsRetrigger) {
            this._queueEvents.addEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED, GameFlowEvents_1.GameFlowEvents.PLAY_FREE_SPINS_TRIGGER);
            this._queueEvents.addEventToWaitingList(FreeSpinsTriggerModule_1.FreeSpinsTriggerModule.FREE_SPINS_TRIGGER_FINISHED, FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_RETRIGGER_FINISHED);
            this._queueEvents.addEventToWaitingList(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_RETRIGGER_FINISHED, FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN);
        }
        else {
            this._queueEvents.addEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED, FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN);
        }
        this.emit(FlowModuleEvents_1.FlowModuleEvents.WON_BIG_WIN);
    };
    GameFlowFreeSpinsState.prototype.setupNoWin = function () {
        this.emit(FlowModuleEvents_1.FlowModuleEvents.NO_WIN);
        var logic = this.module.logic;
        if (logic.hasFreeSpinsRetrigger) {
            this.emit(GameFlowEvents_1.GameFlowEvents.PLAY_FREE_SPINS_TRIGGER);
            this._queueEvents.addEventToWaitingList(FreeSpinsTriggerModule_1.FreeSpinsTriggerModule.FREE_SPINS_TRIGGER_FINISHED, FlowModuleEvents_1.FlowModuleEvents.FREESPINS_RETRIGGER_WIN);
            this._queueEvents.addEventToWaitingList(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_RETRIGGER_FINISHED, FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN);
        }
        else {
            this.sendOutCanSpin();
        }
    };
    return GameFlowFreeSpinsState;
}(FlowFreeSpinsState_1.FlowFreeSpinsState));
exports.GameFlowFreeSpinsState = GameFlowFreeSpinsState;


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var FlowRespinState_1 = __webpack_require__(286);
var FlowModuleEvents_1 = __webpack_require__(0);
var FlowModule_1 = __webpack_require__(35);
var BigWinEvents_1 = __webpack_require__(21);
var GameFlowEvents_1 = __webpack_require__(57);
var GameAvalancheReelsEvents_1 = __webpack_require__(39);
var GameWinUtils_1 = __webpack_require__(117);
var WinPresentationEvents_1 = __webpack_require__(13);
var GameWinPresentationEvents_1 = __webpack_require__(40);
var FreeSpinsEvents_1 = __webpack_require__(6);
var FreeSpinsTriggerModule_1 = __webpack_require__(76);
var GameFlowRespinState = /** @class */ (function (_super) {
    __extends(GameFlowRespinState, _super);
    function GameFlowRespinState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameFlowRespinState.prototype.hasAnyBeforeWinFeatures = function () {
        var logic = this.module.logic;
        return logic.hasWinsToHighlight();
    };
    GameFlowRespinState.prototype.addBeforeWinFeatures = function () {
        _super.prototype.addBeforeWinFeatures.call(this);
        var logic = this.module.logic;
        var eventsPairs = [];
        if (logic.hasWinsToHighlight()) {
            eventsPairs.push({
                start: GameFlowEvents_1.GameFlowEvents.HAS_WIN_SYMBOLS_TO_HIGHLIGHT,
                end: GameAvalancheReelsEvents_1.GameAvalancheReelsEvents.WIN_HIGHLIGHTING_FINISHED
            });
        }
        if (eventsPairs.length > 0) {
            this._queueEvents.addEventsPairFlow(eventsPairs, this.decideOnNextAction.bind(this));
        }
        else {
            throw new Error("GameFlowRespinState::addBeforeWinFeatures need more events");
        }
    };
    GameFlowRespinState.prototype.setupNextStateAvalancheFlow = function () {
        var _this = this;
        this._queueEvents.addFunctionCallingEventToWaitingList(FlowModuleEvents_1.FlowModuleEvents.AVALANCHE_WON, function () {
            _this.module.gotoState(FlowModule_1.FlowModule.AVALANCHE_STATE);
        });
        this.emit(FlowModuleEvents_1.FlowModuleEvents.AVALANCHE_WON);
    };
    GameFlowRespinState.prototype.setupBigWinNoWinAfterwards = function () {
        this.emit(FlowModuleEvents_1.FlowModuleEvents.WON_BIG_WIN);
    };
    GameFlowRespinState.prototype.setupNextStateSpinFlow = function () {
        var logic = this.module.logic;
        if (logic.getLastAvalancheMultiplier() > 1) {
            if (GameWinUtils_1.GameWinUtils.isBigWinWithMultiplier(logic)) {
                this.emit(GameFlowEvents_1.GameFlowEvents.HAS_BIGWIN_WITH_MULTIPLIER);
                this.setupWinWithBigWin();
                this.addCheckForExitFreeSpinAfterBigWin();
            }
            else {
                if (logic.getLastAvalancheRunningTotal() > 0) {
                    this.emit(GameFlowEvents_1.GameFlowEvents.HAS_WIN_WITH_MULTIPLIER);
                    this.setupWin();
                }
                else {
                    this.setupNoWin();
                }
                this.addCheckForExitFreeSpin();
            }
        }
        else {
            if (GameWinUtils_1.GameWinUtils.isBigWinNoMultiplier(logic)) {
                this.emit(GameFlowEvents_1.GameFlowEvents.HAS_BIGWIN_WITH_NO_MULTIPLIER);
                this.setupBigWin();
                this.addCheckForExitFreeSpinAfterBigWin();
            }
            else {
                if (logic.getLastAvalancheRunningTotal() > 0) {
                    this.emit(GameFlowEvents_1.GameFlowEvents.HAS_WIN_WITH_NO_MULTIPLIER);
                    this.setupWin();
                }
                else {
                    this.setupNoWin();
                }
                this.addCheckForExitFreeSpin();
            }
        }
    };
    GameFlowRespinState.prototype.addCheckForExitFreeSpinAfterBigWin = function () {
        if (this.module.logic.isFreeSpinsStarted && this.module.logic.freeSpinsLeft <= 0) {
            this._queueEvents.addFunctionCallingEventToWaitingList(BigWinEvents_1.BigWinEvents.FINISHED, this.gotoBasicState.bind(this));
        }
    };
    GameFlowRespinState.prototype.setupNextStateFreeSpinsFlow = function () {
        var logic = this.module.logic;
        if (logic.getLastAvalancheMultiplier() > 1) {
            if (GameWinUtils_1.GameWinUtils.isBigWinWithMultiplier(logic)) {
                this.emit(GameFlowEvents_1.GameFlowEvents.HAS_BIGWIN_WITH_MULTIPLIER);
                this.setupWinWithBigWinFreeSpins();
                this.addCheckForExitFreeSpinAfterBigWin();
            }
            else {
                if (logic.getLastAvalancheRunningTotal() > 0) {
                    this.emit(GameFlowEvents_1.GameFlowEvents.HAS_WIN_WITH_MULTIPLIER);
                    this.setupWinFreeSpins();
                }
                else {
                    this.setupFreeSpinsNoWin();
                }
                this.addCheckForExitFreeSpin();
            }
        }
        else {
            if (GameWinUtils_1.GameWinUtils.isBigWinNoMultiplier(logic)) {
                this.emit(GameFlowEvents_1.GameFlowEvents.HAS_BIGWIN_WITH_NO_MULTIPLIER);
                this.setupBigWinNoMultiplier();
                this.addCheckForExitFreeSpinAfterBigWin();
            }
            else {
                if (logic.getLastAvalancheRunningTotal() > 0) {
                    this.emit(GameFlowEvents_1.GameFlowEvents.HAS_WIN_WITH_NO_MULTIPLIER);
                    this.setupWinNoMultiplier();
                }
                else {
                    this.setupFreeSpinsNoWin();
                }
                this.addCheckForExitFreeSpin();
            }
        }
    };
    GameFlowRespinState.prototype.setupBigWinNoMultiplier = function () {
        var logic = this.module.logic;
        if (logic.hasFreeSpinsRetrigger) {
            this._queueEvents.addEventToWaitingList(BigWinEvents_1.BigWinEvents.FINISHED, GameFlowEvents_1.GameFlowEvents.PLAY_FREE_SPINS_TRIGGER);
            this._queueEvents.addEventToWaitingList(FreeSpinsTriggerModule_1.FreeSpinsTriggerModule.FREE_SPINS_TRIGGER_FINISHED, FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_RETRIGGER_FINISHED);
            this._queueEvents.addEventToWaitingList(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_RETRIGGER_FINISHED, FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
        }
        else if (logic.isFreeSpinsTrigger()) {
            this._queueEvents.addEventToWaitingList(BigWinEvents_1.BigWinEvents.FINISHED, GameFlowEvents_1.GameFlowEvents.PLAY_FREE_SPINS_TRIGGER);
            this._queueEvents.addEventToWaitingList(FreeSpinsTriggerModule_1.FreeSpinsTriggerModule.FREE_SPINS_TRIGGER_FINISHED, FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
        }
        else {
            this._queueEvents.addEventToWaitingList(BigWinEvents_1.BigWinEvents.FINISHED, FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
        }
        this.setupBigWinNoIndividualNoSpin();
        this.setupCantSpinBigWin();
    };
    GameFlowRespinState.prototype.setupWinNoMultiplier = function () {
        var logic = this.module.logic;
        if (logic.hasFreeSpinsRetrigger) {
            this._queueEvents.addEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED, GameFlowEvents_1.GameFlowEvents.PLAY_FREE_SPINS_TRIGGER);
            this._queueEvents.addEventToWaitingList(FreeSpinsTriggerModule_1.FreeSpinsTriggerModule.FREE_SPINS_TRIGGER_FINISHED, FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_RETRIGGER_FINISHED);
            this._queueEvents.addEventToWaitingList(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_RETRIGGER_FINISHED, FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
        }
        else if (logic.isFreeSpinsTrigger()) {
            this._queueEvents.addEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED, GameFlowEvents_1.GameFlowEvents.PLAY_FREE_SPINS_TRIGGER);
            this._queueEvents.addEventToWaitingList(FreeSpinsTriggerModule_1.FreeSpinsTriggerModule.FREE_SPINS_TRIGGER_FINISHED, FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
        }
        else {
            this._queueEvents.addEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED, FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
        }
        this.setupCantSpinWin();
    };
    GameFlowRespinState.prototype.setupFreeSpinsNoWin = function () {
        this.setupCantSpinNoWin();
        var logic = this.module.logic;
        if (logic.hasFreeSpinsRetrigger) {
            this.emit(GameFlowEvents_1.GameFlowEvents.PLAY_FREE_SPINS_TRIGGER);
            this._queueEvents.addEventToWaitingList(FreeSpinsTriggerModule_1.FreeSpinsTriggerModule.FREE_SPINS_TRIGGER_FINISHED, FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_RETRIGGER_FINISHED);
            this._queueEvents.addEventToWaitingList(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_RETRIGGER_FINISHED, FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
        }
        else if (logic.isFreeSpinsTrigger()) {
            this.emit(GameFlowEvents_1.GameFlowEvents.PLAY_FREE_SPINS_TRIGGER);
            this._queueEvents.addEventToWaitingList(FreeSpinsTriggerModule_1.FreeSpinsTriggerModule.FREE_SPINS_TRIGGER_FINISHED, FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
        }
        else {
            this.emit(FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
        }
    };
    GameFlowRespinState.prototype.setupBigWin = function () {
        var _this = this;
        this._queueEvents.addFunctionCallingEventToWaitingList(FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN, function () {
            _this.module.gotoState(FlowModule_1.FlowModule.BASIC_STATE);
        });
        this._queueEvents.addEventToWaitingList(BigWinEvents_1.BigWinEvents.FINISHED, FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN);
        this.emit(FlowModuleEvents_1.FlowModuleEvents.WON_BIG_WIN);
    };
    GameFlowRespinState.prototype.setupWin = function () {
        var _this = this;
        this._queueEvents.addFunctionCallingEventToWaitingList(FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN, function () {
            _this.module.gotoState(FlowModule_1.FlowModule.BASIC_STATE);
        });
        this._queueEvents.addEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED, FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN);
        this.emit(FlowModuleEvents_1.FlowModuleEvents.WON);
    };
    GameFlowRespinState.prototype.setupWinFreeSpins = function () {
        var logic = this.module.logic;
        if (logic.hasFreeSpinsRetrigger) {
            this._queueEvents.addEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED, GameFlowEvents_1.GameFlowEvents.PLAY_FREE_SPINS_TRIGGER);
            this._queueEvents.addEventToWaitingList(FreeSpinsTriggerModule_1.FreeSpinsTriggerModule.FREE_SPINS_TRIGGER_FINISHED, FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_RETRIGGER_FINISHED);
            this._queueEvents.addEventToWaitingList(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_RETRIGGER_FINISHED, FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
        }
        else if (logic.isFreeSpinsTrigger()) {
            this._queueEvents.addEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED, GameFlowEvents_1.GameFlowEvents.PLAY_FREE_SPINS_TRIGGER);
            this._queueEvents.addEventToWaitingList(FreeSpinsTriggerModule_1.FreeSpinsTriggerModule.FREE_SPINS_TRIGGER_FINISHED, FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
        }
        else {
            this._queueEvents.addEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED, FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
        }
        this.emit(FlowModuleEvents_1.FlowModuleEvents.WON);
    };
    GameFlowRespinState.prototype.setupWinWithBigWin = function () {
        var _this = this;
        this._queueEvents.addFunctionCallingEventToWaitingList(GameWinPresentationEvents_1.GameWinPresentationEvents.PRE_MULTIPLIER_BIG_WIN_FINISHED, function () {
            _this.setupBigWin();
        });
        this.emit(FlowModuleEvents_1.FlowModuleEvents.WON);
    };
    GameFlowRespinState.prototype.setupWinWithBigWinFreeSpins = function () {
        var _this = this;
        this._queueEvents.addFunctionCallingEventToWaitingList(GameWinPresentationEvents_1.GameWinPresentationEvents.PRE_MULTIPLIER_BIG_WIN_FINISHED, function () {
            var logic = _this.module.logic;
            if (logic.hasFreeSpinsRetrigger) {
                _this._queueEvents.addEventToWaitingList(BigWinEvents_1.BigWinEvents.FINISHED, GameFlowEvents_1.GameFlowEvents.PLAY_FREE_SPINS_TRIGGER);
                _this._queueEvents.addEventToWaitingList(FreeSpinsTriggerModule_1.FreeSpinsTriggerModule.FREE_SPINS_TRIGGER_FINISHED, FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_RETRIGGER_FINISHED);
                _this._queueEvents.addEventToWaitingList(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_RETRIGGER_FINISHED, FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
            }
            else if (logic.isFreeSpinsTrigger()) {
                _this._queueEvents.addEventToWaitingList(BigWinEvents_1.BigWinEvents.FINISHED, GameFlowEvents_1.GameFlowEvents.PLAY_FREE_SPINS_TRIGGER);
                _this._queueEvents.addEventToWaitingList(FreeSpinsTriggerModule_1.FreeSpinsTriggerModule.FREE_SPINS_TRIGGER_FINISHED, FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
            }
            else {
                _this._queueEvents.addEventToWaitingList(BigWinEvents_1.BigWinEvents.FINISHED, FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
            }
            _this.setupBigWinNoIndividualNoSpin();
            _this.setupCantSpinBigWin();
        });
        this.emit(FlowModuleEvents_1.FlowModuleEvents.WON);
    };
    return GameFlowRespinState;
}(FlowRespinState_1.FlowRespinState));
exports.GameFlowRespinState = GameFlowRespinState;


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var FlowAvalancheState_1 = __webpack_require__(283);
var AvalancheReelsEvents_1 = __webpack_require__(15);
var FlowModuleEvents_1 = __webpack_require__(0);
var FlowModule_1 = __webpack_require__(35);
var BigWinEvents_1 = __webpack_require__(21);
var GameFlowEvents_1 = __webpack_require__(57);
var GameAvalancheReelsEvents_1 = __webpack_require__(39);
var WinPresentationEvents_1 = __webpack_require__(13);
var GameWinUtils_1 = __webpack_require__(117);
var GameWinPresentationEvents_1 = __webpack_require__(40);
var FreeSpinsEvents_1 = __webpack_require__(6);
var FreeSpinsTriggerModule_1 = __webpack_require__(76);
var GameFlowAvalancheState = /** @class */ (function (_super) {
    __extends(GameFlowAvalancheState, _super);
    function GameFlowAvalancheState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameFlowAvalancheState.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(AvalancheReelsEvents_1.AvalancheReelsEvents.REMOVING_WIN_FINISHED, this.onRemovingWinFinished);
    };
    GameFlowAvalancheState.prototype.hasAnyBeforeWinFeatures = function () {
        var logic = this.module.logic;
        return logic.hasWinsToHighlight();
    };
    GameFlowAvalancheState.prototype.addBeforeWinFeatures = function () {
        _super.prototype.addBeforeWinFeatures.call(this);
        var logic = this.module.logic;
        var eventsPairs = [];
        if (logic.hasWinsToHighlight()) {
            eventsPairs.push({
                start: GameFlowEvents_1.GameFlowEvents.HAS_WIN_SYMBOLS_TO_HIGHLIGHT,
                end: GameAvalancheReelsEvents_1.GameAvalancheReelsEvents.WIN_HIGHLIGHTING_FINISHED,
            });
        }
        if (eventsPairs.length > 0) {
            this._queueEvents.addEventsPairFlow(eventsPairs, this.decideOnNextAction.bind(this));
        }
        else {
            throw new Error("GameFlowAvalancheState::addBeforeWinFeatures need more events");
        }
    };
    GameFlowAvalancheState.prototype.onRemovingWinFinished = function () {
        this.emit(FlowModuleEvents_1.FlowModuleEvents.CAN_DROP_NEW);
    };
    GameFlowAvalancheState.prototype.setupNextStateAvalancheFlow = function () {
        var _this = this;
        this._queueEvents.addFunctionCallingEventToWaitingList(FlowModuleEvents_1.FlowModuleEvents.AVALANCHE_WON, function () {
            _this.module.gotoState(FlowModule_1.FlowModule.AVALANCHE_STATE);
        });
        this.emit(FlowModuleEvents_1.FlowModuleEvents.AVALANCHE_WON);
    };
    GameFlowAvalancheState.prototype.setupBigWinNoWinAfterwards = function () {
        this.emit(FlowModuleEvents_1.FlowModuleEvents.WON_BIG_WIN);
    };
    GameFlowAvalancheState.prototype.setupNextStateFreeSpinsFlow = function () {
        var logic = this.module.logic;
        if (logic.getLastAvalancheMultiplier() > 1) {
            if (GameWinUtils_1.GameWinUtils.isBigWinWithMultiplier(logic)) {
                this.emit(GameFlowEvents_1.GameFlowEvents.HAS_BIGWIN_WITH_MULTIPLIER);
                this.setupWinWithBigWinFreeSpins();
                this.addCheckForExitFreeSpinAfterBigWin();
            }
            else {
                this.emit(GameFlowEvents_1.GameFlowEvents.HAS_WIN_WITH_MULTIPLIER);
                this.setupWinFreeSpins();
                this.addCheckForExitFreeSpin();
            }
        }
        else {
            if (GameWinUtils_1.GameWinUtils.isBigWinNoMultiplier(logic)) {
                this.emit(GameFlowEvents_1.GameFlowEvents.HAS_BIGWIN_WITH_NO_MULTIPLIER);
                this.setupBigWinNoMultiplier();
                this.addCheckForExitFreeSpinAfterBigWin();
            }
            else {
                this.emit(GameFlowEvents_1.GameFlowEvents.HAS_WIN_WITH_NO_MULTIPLIER);
                this.setupWinNoMultiplier();
                this.addCheckForExitFreeSpin();
            }
        }
    };
    GameFlowAvalancheState.prototype.addCheckForExitFreeSpinAfterBigWin = function () {
        if (this.module.logic.isFreeSpinsStarted && this.module.logic.freeSpinsLeft <= 0) {
            this._queueEvents.addFunctionCallingEventToWaitingList(BigWinEvents_1.BigWinEvents.FINISHED, this.gotoBasicState.bind(this));
        }
    };
    GameFlowAvalancheState.prototype.setupBigWinNoMultiplier = function () {
        var logic = this.module.logic;
        if (logic.hasFreeSpinsRetrigger) {
            this._queueEvents.addEventToWaitingList(BigWinEvents_1.BigWinEvents.FINISHED, FlowModuleEvents_1.FlowModuleEvents.FREESPINS_RETRIGGER_WIN);
            this._queueEvents.addEventToWaitingList(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_RETRIGGER_FINISHED, FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
        }
        else if (logic.isFreeSpinsTrigger()) {
            this._queueEvents.addEventToWaitingList(BigWinEvents_1.BigWinEvents.FINISHED, GameFlowEvents_1.GameFlowEvents.PLAY_FREE_SPINS_TRIGGER);
            this._queueEvents.addEventToWaitingList(FreeSpinsTriggerModule_1.FreeSpinsTriggerModule.FREE_SPINS_TRIGGER_FINISHED, FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
        }
        else {
            this._queueEvents.addEventToWaitingList(BigWinEvents_1.BigWinEvents.FINISHED, FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
        }
        this.setupBigWinNoIndividualNoSpin();
        this.setupCantSpinBigWin();
    };
    GameFlowAvalancheState.prototype.setupWinNoMultiplier = function () {
        var logic = this.module.logic;
        if (logic.hasFreeSpinsRetrigger) {
            this._queueEvents.addEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED, FlowModuleEvents_1.FlowModuleEvents.FREESPINS_RETRIGGER_WIN);
            this._queueEvents.addEventToWaitingList(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_RETRIGGER_FINISHED, FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
        }
        else if (logic.isFreeSpinsTrigger()) {
            this._queueEvents.addEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED, GameFlowEvents_1.GameFlowEvents.PLAY_FREE_SPINS_TRIGGER);
            this._queueEvents.addEventToWaitingList(FreeSpinsTriggerModule_1.FreeSpinsTriggerModule.FREE_SPINS_TRIGGER_FINISHED, FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
        }
        else {
            this._queueEvents.addEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED, FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
        }
        this.setupCantSpinWin();
    };
    GameFlowAvalancheState.prototype.setupNextStateSpinFlow = function () {
        var logic = this.module.logic;
        if (logic.getLastAvalancheMultiplier() > 1) {
            if (GameWinUtils_1.GameWinUtils.isBigWinWithMultiplier(logic)) {
                this.emit(GameFlowEvents_1.GameFlowEvents.HAS_BIGWIN_WITH_MULTIPLIER);
                this.setupWinWithBigWin();
                this.addCheckForExitFreeSpinAfterBigWin();
            }
            else {
                this.emit(GameFlowEvents_1.GameFlowEvents.HAS_WIN_WITH_MULTIPLIER);
                this.setupWin();
                this.addCheckForExitFreeSpin();
            }
        }
        else {
            if (GameWinUtils_1.GameWinUtils.isBigWinNoMultiplier(logic)) {
                this.emit(GameFlowEvents_1.GameFlowEvents.HAS_BIGWIN_WITH_NO_MULTIPLIER);
                this.setupBigWin();
                this.addCheckForExitFreeSpinAfterBigWin();
            }
            else {
                this.emit(GameFlowEvents_1.GameFlowEvents.HAS_WIN_WITH_NO_MULTIPLIER);
                this.setupWin();
                this.addCheckForExitFreeSpin();
            }
        }
    };
    GameFlowAvalancheState.prototype.setupBigWin = function () {
        var _this = this;
        this._queueEvents.addFunctionCallingEventToWaitingList(FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN, function () {
            _this.module.gotoState(FlowModule_1.FlowModule.BASIC_STATE);
        });
        this._queueEvents.addEventToWaitingList(BigWinEvents_1.BigWinEvents.FINISHED, FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN);
        this.emit(FlowModuleEvents_1.FlowModuleEvents.WON_BIG_WIN);
    };
    GameFlowAvalancheState.prototype.setupWin = function () {
        var _this = this;
        this._queueEvents.addFunctionCallingEventToWaitingList(FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN, function () {
            _this.module.gotoState(FlowModule_1.FlowModule.BASIC_STATE);
        });
        this._queueEvents.addEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED, FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN);
        this.emit(FlowModuleEvents_1.FlowModuleEvents.WON);
    };
    GameFlowAvalancheState.prototype.setupWinFreeSpins = function () {
        var logic = this.module.logic;
        if (logic.hasFreeSpinsRetrigger) {
            this._queueEvents.addEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED, FlowModuleEvents_1.FlowModuleEvents.FREESPINS_RETRIGGER_WIN);
            this._queueEvents.addEventToWaitingList(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_RETRIGGER_FINISHED, FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
        }
        else if (logic.isFreeSpinsTrigger()) {
            this._queueEvents.addEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED, GameFlowEvents_1.GameFlowEvents.PLAY_FREE_SPINS_TRIGGER);
            this._queueEvents.addEventToWaitingList(FreeSpinsTriggerModule_1.FreeSpinsTriggerModule.FREE_SPINS_TRIGGER_FINISHED, FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
        }
        else {
            this._queueEvents.addEventToWaitingList(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED, FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
        }
        this.emit(FlowModuleEvents_1.FlowModuleEvents.WON);
    };
    GameFlowAvalancheState.prototype.setupWinWithBigWin = function () {
        var _this = this;
        this._queueEvents.addFunctionCallingEventToWaitingList(GameWinPresentationEvents_1.GameWinPresentationEvents.PRE_MULTIPLIER_BIG_WIN_FINISHED, function () {
            _this.setupBigWin();
        });
        this.emit(FlowModuleEvents_1.FlowModuleEvents.WON);
    };
    GameFlowAvalancheState.prototype.setupWinWithBigWinFreeSpins = function () {
        var _this = this;
        this._queueEvents.addFunctionCallingEventToWaitingList(GameWinPresentationEvents_1.GameWinPresentationEvents.PRE_MULTIPLIER_BIG_WIN_FINISHED, function () {
            var logic = _this.module.logic;
            if (logic.hasFreeSpinsRetrigger) {
                _this._queueEvents.addEventToWaitingList(BigWinEvents_1.BigWinEvents.FINISHED, FlowModuleEvents_1.FlowModuleEvents.FREESPINS_RETRIGGER_WIN);
                _this._queueEvents.addEventToWaitingList(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_RETRIGGER_FINISHED, FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
            }
            else if (logic.isFreeSpinsTrigger()) {
                _this._queueEvents.addEventToWaitingList(BigWinEvents_1.BigWinEvents.FINISHED, GameFlowEvents_1.GameFlowEvents.PLAY_FREE_SPINS_TRIGGER);
                _this._queueEvents.addEventToWaitingList(FreeSpinsTriggerModule_1.FreeSpinsTriggerModule.FREE_SPINS_TRIGGER_FINISHED, FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
            }
            else {
                _this._queueEvents.addEventToWaitingList(BigWinEvents_1.BigWinEvents.FINISHED, FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN);
            }
            _this.setupBigWinNoIndividualNoSpin();
            _this.setupCantSpinBigWin();
        });
        this.emit(FlowModuleEvents_1.FlowModuleEvents.WON);
    };
    return GameFlowAvalancheState;
}(FlowAvalancheState_1.FlowAvalancheState));
exports.GameFlowAvalancheState = GameFlowAvalancheState;


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var InfoModule_1 = __webpack_require__(289);
var GameInfoModuleBasicState_1 = __webpack_require__(550);
var AvalancheReelsEvents_1 = __webpack_require__(15);
var GameInfoModuleFreeSpinsState_1 = __webpack_require__(551);
var GameWinPresentationEvents_1 = __webpack_require__(40);
var WinPresentationEvents_1 = __webpack_require__(13);
var RecodeInfoModule_1 = __webpack_require__(552);
var GameInfoModule = /** @class */ (function (_super) {
    __extends(GameInfoModule, _super);
    function GameInfoModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameInfoModule.prototype.setupStates = function () {
        _super.prototype.setupStates.call(this);
        this.addState(new GameInfoModuleBasicState_1.GameInfoModuleBasicState(this, InfoModule_1.InfoModule.BASIC));
        this.addState(new GameInfoModuleFreeSpinsState_1.GameInfoModuleFreeSpinsState(this, InfoModule_1.InfoModule.FREESPINS));
    };
    GameInfoModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.onCurrentStateHandle(AvalancheReelsEvents_1.AvalancheReelsEvents.REMOVING_WIN_FINISHED);
        this.onCurrentStateHandle(GameWinPresentationEvents_1.GameWinPresentationEvents.AFTER_MULTIPLIER_COUNTING_FINISHED);
        this.onCurrentStateHandle(WinPresentationEvents_1.WinPresentationEvents.WIN_NUMBER_SHOWN_TO_PLAYER);
    };
    return GameInfoModule;
}(RecodeInfoModule_1.RecodeInfoModule));
exports.GameInfoModule = GameInfoModule;


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var GameWinPresentationEvents_1 = __webpack_require__(40);
var RecodeInfoModuleBasicState_1 = __webpack_require__(292);
var GameWinUtils_1 = __webpack_require__(117);
var GameInfoModuleBasicState = /** @class */ (function (_super) {
    __extends(GameInfoModuleBasicState, _super);
    function GameInfoModuleBasicState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameInfoModuleBasicState.prototype.onEnterState = function () {
    };
    GameInfoModuleBasicState.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(GameWinPresentationEvents_1.GameWinPresentationEvents.AFTER_MULTIPLIER_COUNTING_FINISHED, this.onAfterMultiplierCountingFinished);
    };
    GameInfoModuleBasicState.prototype.onInitResponse = function () {
        if (this.module.logic.hasRestore) {
            this.updateBalance(this.module.logic.currentBalance);
        }
        this.updateBet();
        this.updateWin(0);
    };
    GameInfoModuleBasicState.prototype.onCanSpin = function () {
        var logic = this.module.logic;
        this.updateBalance(logic.currentBalance);
    };
    GameInfoModuleBasicState.prototype.onWinCountupFinished = function () {
        var logic = this.module.logic;
        if (!GameWinUtils_1.GameWinUtils.isBigWinWithMultiplier(logic)) {
            this.updateData();
        }
    };
    GameInfoModuleBasicState.prototype.onNoWin = function () {
    };
    GameInfoModuleBasicState.prototype.onWinShownToPlayer = function () {
        var logic = this.module.logic;
        if (logic.getLastAvalancheMultiplier() === 1) {
            this.updateWin(logic.currentSpinWin);
        }
        if (this.shouldUpdateBalance()) {
            this.updateBalance(this.module.logic.currentBalance);
        }
    };
    GameInfoModuleBasicState.prototype.onBigWinFinished = function () {
        var logic = this.module.logic;
        this.updateWin(logic.currentSpinWin);
    };
    GameInfoModuleBasicState.prototype.onWinNumberShownToPlayer = function () {
        var logic = this.module.logic;
        var win = logic.getCurrentRoundTotalWinNoMultiplier();
        if (logic.getLastAvalancheMultiplier() === 1) {
            this.updateWin(win);
            if (this.shouldUpdateBalance()) {
                this.updateBalance(this.module.logic.currentBalance);
            }
        }
    };
    GameInfoModuleBasicState.prototype.onAfterMultiplierCountingFinished = function () {
        var logic = this.module.logic;
        var win = logic.currentSpinWin;
        this.updateWin(win);
        if (this.shouldUpdateBalance()) {
            this.updateBalance(this.module.logic.currentBalance);
        }
    };
    GameInfoModuleBasicState.prototype.updateData = function () {
        if (this.shouldUpdateBalance()) {
            this.updateBalance(this.module.logic.currentBalance);
        }
    };
    return GameInfoModuleBasicState;
}(RecodeInfoModuleBasicState_1.RecodeInfoModuleBasicState));
exports.GameInfoModuleBasicState = GameInfoModuleBasicState;


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var GameWinPresentationEvents_1 = __webpack_require__(40);
var RecodeInfoModuleFreeSpinsState_1 = __webpack_require__(293);
var GameWinUtils_1 = __webpack_require__(117);
var GameInfoModuleFreeSpinsState = /** @class */ (function (_super) {
    __extends(GameInfoModuleFreeSpinsState, _super);
    function GameInfoModuleFreeSpinsState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameInfoModuleFreeSpinsState.prototype.onEnterState = function () {
        _super.prototype.onEnterState.call(this);
        var logic = this.module.logic;
        var win = logic.currentSpinWin;
        if (logic.isFreeSpinsJustWon()) {
            this.module.updateWin(win);
        }
        else if (logic.isFreeSpinsStarted && logic.hasRestore) {
            this.module.updateWin(logic.getTransTotalWin() - win);
        }
    };
    GameInfoModuleFreeSpinsState.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(GameWinPresentationEvents_1.GameWinPresentationEvents.AFTER_MULTIPLIER_COUNTING_FINISHED, this.onAfterMultiplierCountingFinished);
    };
    GameInfoModuleFreeSpinsState.prototype.onAfterMultiplierCountingFinished = function () {
        var logic = this.module.logic;
        var win = logic.getTransTotalWin();
        this.updateWin(win);
    };
    GameInfoModuleFreeSpinsState.prototype.onSpinResponse = function () {
    };
    GameInfoModuleFreeSpinsState.prototype.onNoWin = function () {
    };
    GameInfoModuleFreeSpinsState.prototype.onWinShownToPlayer = function () {
        var logic = this.module.logic;
        var win = logic.getTransTotalWin();
        if (logic.getLastAvalancheMultiplier() === 1) {
            this.updateWin(win);
        }
    };
    GameInfoModuleFreeSpinsState.prototype.onCanSpin = function () {
    };
    GameInfoModuleFreeSpinsState.prototype.onBigWinFinished = function () {
        var logic = this.module.logic;
        var spinWin = logic.getTransTotalWin();
        this.updateWin(spinWin);
    };
    GameInfoModuleFreeSpinsState.prototype.onWinCountupFinished = function () {
        var logic = this.module.logic;
        if (!GameWinUtils_1.GameWinUtils.isBigWinWithMultiplier(logic)) {
            this.updateData();
        }
    };
    GameInfoModuleFreeSpinsState.prototype.updateData = function () {
        var win = this.module.logic.getWin();
        this.updateWin(win);
    };
    return GameInfoModuleFreeSpinsState;
}(RecodeInfoModuleFreeSpinsState_1.RecodeInfoModuleFreeSpinsState));
exports.GameInfoModuleFreeSpinsState = GameInfoModuleFreeSpinsState;


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var InfoModule_1 = __webpack_require__(289);
var FreeSpinsEvents_1 = __webpack_require__(6);
var FreeRoundsScreenEvents_1 = __webpack_require__(46);
var RecodeEvents_1 = __webpack_require__(79);
var RecodeInfoModuleBasicState_1 = __webpack_require__(292);
var RecodeInfoModuleFreeSpinsState_1 = __webpack_require__(293);
var RecodeInfoModule = /** @class */ (function (_super) {
    __extends(RecodeInfoModule, _super);
    function RecodeInfoModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RecodeInfoModule.prototype.init = function () {
        _super.prototype.init.call(this);
        if (window.V.API.Core.getCasinoConfig().features.inGameControls.sound.hide) {
            this.view.soundButton.hide();
        }
    };
    RecodeInfoModule.prototype.updateBet = function () {
        var logic = this.logic;
        if (logic.hasFreeGames() && logic.currentFreeGameProgress && logic.currentFreeGameProgress.gamesPlayed > 0) {
            if (!logic.isFreeSpinsStarted) {
                this.clearWin();
            }
        }
        else if (!logic.hasFreeGames() && logic.currentFreeGameProgress && logic.currentFreeGameProgress.gamesRemaining === 0) {
            if (!logic.isFreeSpinsStarted) {
                this.clearWin();
            }
        }
        else {
            _super.prototype.updateBet.call(this);
            this.view.hideFreeBet();
            this.view.showBetValue();
        }
    };
    RecodeInfoModule.prototype.updateBalance = function () {
        var balance = this.logic.currentBalance;
        this.view.setBalance(balance);
    };
    RecodeInfoModule.prototype.restoreRoundWin = function () {
        var logic = this.logic;
        if (this.logic.isFreeSpinsStarted && this.logic.freeSpinsLeft < this.logic.freespinsTotalAwarded) {
            this.updateWin(logic.freeSpinsTotalWin - logic.getWin());
        }
        else {
            this.updateWin(0);
        }
    };
    RecodeInfoModule.prototype.setupStates = function () {
        _super.prototype.setupStates.call(this);
        this.addState(new RecodeInfoModuleBasicState_1.RecodeInfoModuleBasicState(this, InfoModule_1.InfoModule.BASIC));
        this.addState(new RecodeInfoModuleFreeSpinsState_1.RecodeInfoModuleFreeSpinsState(this, InfoModule_1.InfoModule.FREESPINS));
    };
    RecodeInfoModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.SHOWING_WIN_SUMMARY_SCREEN, this.onFreeSpinsShowingWinSummaryScreen);
        this.on(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_GAMES_STARTED, this.onFreeGamesStarted);
        this.on(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_GAMES_RESUMED, this.onFreeGamesStarted);
        this.on(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_GAMES_FINISHED, this.onFreeGamesFinished);
        this.on(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_GAMES_POSTPONED, this.onFreeGamesPostponed);
        this.on(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_GAMES_REJECTED, this.onFreeGamesRejected);
        this.on(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_GAME_EXPIRED, this.onFreeGamesExpired);
        this.on(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_ROUNDS_SCREEN_SHOWN, this.onFreeGamesScreenOpened);
        this.on(RecodeEvents_1.RecodeEvents.SERVER_SYSTEM_BALANCE_UPDATE, this.onServerSystemBalanceUpdate);
        this.on(RecodeEvents_1.RecodeEvents.SERVER_PLUGIN_SET_MUTE, this.onServerSetMute);
        this.on(RecodeEvents_1.RecodeEvents.SHOWING_ERROR, this.onShowingError);
        this.on(RecodeEvents_1.RecodeEvents.VALIDATED_BET, this.onValidatedBet);
        this.on(RecodeEvents_1.RecodeEvents.VALIDATED_BET_COIN_SIZE_CHANGED, this.onValidatedBetCoinSizeChanged);
    };
    RecodeInfoModule.prototype.onShowingError = function () { };
    RecodeInfoModule.prototype.onValidatedBet = function () {
        this.updateBet();
    };
    RecodeInfoModule.prototype.onValidatedBetCoinSizeChanged = function () {
        this.clearWin();
    };
    RecodeInfoModule.prototype.onToggleSoundEffectsOff = function () {
        if (this.logic.soundAllActive && !this.musicActive) {
            this.view.soundButton.setValue(true, true);
            this.onViewToggleAllSoundOff(null, false);
        }
    };
    RecodeInfoModule.prototype.onToggleMusicOff = function () {
        if (this.logic.soundAllActive && !this.soundActive) {
            this.view.soundButton.setValue(true, true);
            this.onViewToggleAllSoundOff(null, false);
        }
    };
    RecodeInfoModule.prototype.onServerSystemBalanceUpdate = function () {
        this.updateBalance();
    };
    RecodeInfoModule.prototype.onServerSetMute = function (eventId, mute) {
        this.view.soundButton.setValue(mute, false);
    };
    RecodeInfoModule.prototype.onFreeGamesStarted = function () {
        this.view.setFreeBet();
        this.restoreRoundWin();
        this.view.hideBetValue();
    };
    RecodeInfoModule.prototype.onFreeGamesPostponed = function () {
        this.updateBet();
    };
    RecodeInfoModule.prototype.onFreeGamesFinished = function () {
        this.updateBet();
        this.view.hideFreeBet();
        this.view.showBetValue();
    };
    RecodeInfoModule.prototype.onFreeGamesRejected = function () {
        this.updateBet();
    };
    RecodeInfoModule.prototype.onFreeGamesExpired = function () {
        this.updateBet();
    };
    RecodeInfoModule.prototype.onFreeSpinsShowingWinSummaryScreen = function () {
        this.updateBalance();
    };
    RecodeInfoModule.prototype.onFreeSpinsFinished = function () {
        _super.prototype.onFreeSpinsFinished.call(this);
        this.clearWin();
    };
    RecodeInfoModule.prototype.onFreeGamesScreenOpened = function () {
        this.view.setWins(0);
        this.logic.killRestore();
    };
    Object.defineProperty(RecodeInfoModule.prototype, "spinCumulativeWins", {
        get: function () {
            return this._spinCumulativeWins;
        },
        set: function (value) {
            this._spinCumulativeWins = value;
        },
        enumerable: true,
        configurable: true
    });
    return RecodeInfoModule;
}(InfoModule_1.InfoModule));
exports.RecodeInfoModule = RecodeInfoModule;


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var RecodeInfoView_1 = __webpack_require__(554);
var GameInfoView = /** @class */ (function (_super) {
    __extends(GameInfoView, _super);
    function GameInfoView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameInfoView.prototype.translate = function () {
        if (!this._betText) {
            return;
        }
        var betText = this.translator.getObject('BaseStrings', 'generic', 'g_bet');
        this._betText.text = betText.toUpperCase();
        var winText = this.translator.getObject('BaseStrings', 'wins', 'g_total_win');
        this._winText.text = winText.toUpperCase();
        var balanceText = this.translator.getObject('BaseStrings', 'generic', 'g_balance');
        this._balanceText.text = balanceText.toUpperCase();
    };
    return GameInfoView;
}(RecodeInfoView_1.RecodeInfoView));
exports.GameInfoView = GameInfoView;


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var InfoView_1 = __webpack_require__(555);
var RecodeInfoView = /** @class */ (function (_super) {
    __extends(RecodeInfoView, _super);
    function RecodeInfoView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RecodeInfoView.prototype.init = function () {
        _super.prototype.init.call(this);
        this.hideBankingButton();
        this._clock.visible = false;
        this._vApi = window.V.API;
        if (!this.device.isMobile && this._vApi.BonusBubble.bubbleEnabled()) {
            this.setupBonusBubbleHover();
        }
        if (this._vApi.Core.isBankingAvailable()) {
            this.setupBankingButton();
            this.setUpBankingButtonEvents();
        }
    };
    RecodeInfoView.prototype.setupBonusBubbleHover = function () {
        this._balanceText.on('mouseover', this.showBonusBubble.bind(this));
        this._balanceText.on('mouseout', this.hideBonusBubble.bind(this));
        this._balanceText.interactive = true;
    };
    RecodeInfoView.prototype.setupBankingButton = function () {
        this._bankingButton = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'BANKING.png'));
        this.spineUtils.replaceElementInSpine(this._spineLayout, 'BANKING_BUTTON', this._bankingButton);
        this._bankingButton.interactive = true;
        this._bankingButton.buttonMode = true;
    };
    RecodeInfoView.prototype.setUpBankingButtonEvents = function () {
        this._bankingButton.on(this.device.isMobile ? 'touchstart' : 'mousedown', this.openBanking.bind(this));
    };
    RecodeInfoView.prototype.openBanking = function () {
        this._vApi.Core.launchBanking();
    };
    RecodeInfoView.prototype.hideBankingButton = function () {
        this._spineLayout.slotContainers[this._spineLayout.skeleton.findSlotIndex('BANKING_BUTTON')].children[0].visible = false;
    };
    RecodeInfoView.prototype.showBonusBubble = function () {
        var worldtransform = this._balanceText.worldTransform;
        var position = this.fullscreenManager.canvasPositionToWindow({ x: worldtransform.tx, y: worldtransform.ty });
        this._vApi.BonusBubble.onBubbleTrigger(true, { x: position.x, y: position.y });
    };
    RecodeInfoView.prototype.hideBonusBubble = function () {
        this._vApi.BonusBubble.onBubbleTrigger(false, null);
    };
    RecodeInfoView.prototype.setupLayout = function () {
        _super.prototype.setupLayout.call(this);
        if (!window._canHaveFantasmaStuff) {
            var slotIndex = this._spineLayoutAnimation.container.skeleton.findSlotIndex('FANTASMA_LOGO');
            var container = this._spineLayoutAnimation.container.slotContainers[slotIndex];
            container.removeChildren();
        }
    };
    return RecodeInfoView;
}(InfoView_1.InfoView));
exports.RecodeInfoView = RecodeInfoView;


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Checkbox_1 = __webpack_require__(556);
var SpineAnimation_1 = __webpack_require__(37);
var SpriteButton_1 = __webpack_require__(55);
var Spine_1 = __webpack_require__(25);
var Timer_1 = __webpack_require__(28);
var View_1 = __webpack_require__(3);
var InfoViewEvents_1 = __webpack_require__(290);
var InfoView = /** @class */ (function (_super) {
    __extends(InfoView, _super);
    function InfoView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InfoView.prototype.init = function () {
        _super.prototype.init.call(this);
        this.setupLayout();
        this.setupTextStyles();
        this.setupValueObjects();
        this.setupGameObjects();
        this.device.isMobile ? this.setupIconObjects() : this.setupTextObjects();
        this.emitTextInitialized();
        this.setupSoundButton();
        this.startTimeInterval();
        this.setWins(0);
    };
    InfoView.prototype.translate = function () {
        if (!this._betText) {
            return;
        }
        var betText = this.translator.getObject('BaseStrings', 'generic', 'g_bet');
        this._betText.text = betText.toUpperCase();
        var winText = this.translator.getObject('BaseStrings', 'generic', 'g_win');
        this._winText.text = winText.toUpperCase();
        var balanceText = this.translator.getObject('BaseStrings', 'generic', 'g_balance');
        this._balanceText.text = balanceText.toUpperCase();
    };
    InfoView.prototype.setupFreeBetText = function () {
        var freeText = this.translator.getObject('BaseStrings', 'generic', 'g_freegames_free');
        this._freeBetText = new PIXI.Text(freeText.toUpperCase(), this._textStyle);
        this._freeBetText.transform = this._betValue.transform;
        this._betValue.parent.addChild(this._freeBetText);
        this._freeBetText.anchor.x = this._betValue.anchor.x;
        this._freeBetText.anchor.y = this._betValue.anchor.y;
    };
    InfoView.prototype.hideFreeBet = function () {
        if (this._freeBetText) {
            this._freeBetText.visible = false;
        }
    };
    InfoView.prototype.setFreeBet = function () {
        if (!this._freeBetText) {
            this.setupFreeBetText();
        }
        else {
            this._freeBetText.visible = true;
        }
        this.emitBetUpdated();
    };
    InfoView.prototype.setSoundButtonStatus = function (isOn, callCallback) {
        if (callCallback === void 0) { callCallback = false; }
        this._soundButton.setValue(isOn, callCallback);
    };
    InfoView.prototype.playEntryAnimation = function () {
        this._spineLayoutAnimation.start();
        this.updateManager.add(this._spineLayoutAnimation);
        this.container.addChild(this._spineLayout);
    };
    InfoView.prototype.switchSound = function (enabled) {
        enabled ? this.disableAllSound() : this.enableAllSound();
    };
    InfoView.prototype.hideBetValue = function () {
        this._betValue.visible = false;
    };
    InfoView.prototype.hideWinValue = function () {
        this._winValue.visible = false;
    };
    InfoView.prototype.hideBalanceValue = function () {
        this._balanceValue.visible = false;
    };
    InfoView.prototype.showBetValue = function () {
        this._betValue.visible = true;
    };
    InfoView.prototype.showWinValue = function () {
        this._winValue.visible = true;
    };
    InfoView.prototype.showBalanceValue = function () {
        this._balanceValue.visible = true;
    };
    InfoView.prototype.setBalance = function (newBalance) {
        this._balanceValue.text = this.formatToCurrency(newBalance, true);
        this.emitBalanceUpdated();
    };
    InfoView.prototype.setBet = function (betValue) {
        this._betValue.text = this.formatToCurrency(betValue, true);
        this.emitBetUpdated();
    };
    InfoView.prototype.setWins = function (winsValue) {
        this._winValue.text = this.formatToCurrency(winsValue, true);
        this.emitWinUpdated();
    };
    InfoView.prototype.setupGameObjects = function () { };
    InfoView.prototype.emitWinUpdated = function () {
        this.emit(InfoViewEvents_1.InfoViewEvents.WIN_UPDATED);
    };
    InfoView.prototype.emitBalanceUpdated = function () {
        this.emit(InfoViewEvents_1.InfoViewEvents.BALANCE_UPDATED);
    };
    InfoView.prototype.emitBetUpdated = function () {
        this.emit(InfoViewEvents_1.InfoViewEvents.BET_UPDATED);
    };
    InfoView.prototype.emitTimeUpdated = function () {
        this.emit(InfoViewEvents_1.InfoViewEvents.TIME_UPDATED);
    };
    InfoView.prototype.emitAllSoundsToggleOff = function () {
        this.emit(InfoViewEvents_1.InfoViewEvents.TOGGLE_ALL_SOUND_OFF);
    };
    InfoView.prototype.emitAllSoundsToggleOn = function () {
        this.emit(InfoViewEvents_1.InfoViewEvents.TOGGLE_ALL_SOUND_ON);
    };
    InfoView.prototype.updateAll = function () {
        this.emitBetUpdated();
        this.emitBalanceUpdated();
        this.emitWinUpdated();
    };
    InfoView.prototype.startTimeInterval = function () {
        this.updateTime();
    };
    InfoView.prototype.stopTimeInterval = function () {
        if (this._timeUpdateIntervalId) {
            window.clearInterval(this._timeUpdateIntervalId);
        }
    };
    InfoView.prototype.updateTime = function () {
        var time = new Date();
        var newTime = time.toLocaleTimeString(this.resources.getLocale());
        var character = newTime.lastIndexOf(':') === -1 ? '.' : ':';
        var newTimeText = newTime.substring(0, newTime.lastIndexOf(character));
        this._clock.text = newTimeText;
        var timer = new Timer_1.Timer(this.updateTime.bind(this), 30000, true);
        this.updateManager.add(timer);
        this.emitTimeUpdated();
    };
    InfoView.prototype.formatToCurrency = function (value, useCurrencySign) {
        return this.currencyFormatter.formatCurrency(value, useCurrencySign);
    };
    InfoView.prototype.setTransform = function (baseobject, newTransformdata, extraOffsetX, extraOffsetY) {
        if (extraOffsetX === void 0) { extraOffsetX = 0; }
        if (extraOffsetY === void 0) { extraOffsetY = 0; }
        var resolutionHeight = this.resolutionManager.resolution.height;
        var centerScreenX = this.resolutionManager.halfResolution.width;
        var centerScreenY = this.resolutionManager.halfResolution.height;
        var xPosition = centerScreenX + newTransformdata.x + extraOffsetX;
        var yPosition = resolutionHeight - (centerScreenY + newTransformdata.y + extraOffsetY);
        baseobject.setTransform(xPosition, yPosition, newTransformdata.scaleX, newTransformdata.scaleY);
    };
    InfoView.prototype.disableAllSound = function () {
        this.emitAllSoundsToggleOff();
    };
    InfoView.prototype.enableAllSound = function () {
        this.emitAllSoundsToggleOn();
    };
    InfoView.prototype.setupLayout = function () {
        this._spineLayout = new Spine_1.Spine(this.resources.getSpine('GUI_INFO.json'));
        this._spineLayoutAnimation = new SpineAnimation_1.SpineAnimation(this._spineLayout, 'ENTRY', false, true);
        this._spineLayoutAnimation.update(0);
        this._spineLayout.position.set(this.resolutionManager.halfResolution.width, this.resolutionManager.halfResolution.height);
    };
    InfoView.prototype.setupTextStyles = function () {
        var baseFontSize = this.device.isMobile ? 26 : 30;
        this._numberStyle = this.textStyles.guiInfoNumbers;
        this._textStyle = this.textStyles.guiInfoText;
        this._winFieldNumberStyle = this.textStyles.guiInfoWinFieldNumbers;
        this._winFieldTextStyle = this.textStyles.guiInfoWinFieldText;
    };
    InfoView.prototype.setupIconObjects = function () {
        var betSlot = this._spineLayout.slotContainers[this._spineLayout.skeleton.findSlotIndex('BET_TEXT')];
        var winSlot = this._spineLayout.slotContainers[this._spineLayout.skeleton.findSlotIndex('WIN_TEXT')];
        var balanceSlot = this._spineLayout.slotContainers[this._spineLayout.skeleton.findSlotIndex('BALANCE_TEXT')];
        this._betIcon = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'BET_ICON.png'));
        this._winIcon = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'WIN_ICON.png'));
        this._balanceIcon = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'BALANCE_ICON.png'));
        this._betIcon.anchor.set(0.5, 0.5);
        this._winIcon.anchor.set(0.5, 0.5);
        this._balanceIcon.anchor.set(0.5, 0.5);
        betSlot.addChild(this._betIcon);
        winSlot.addChild(this._winIcon);
        balanceSlot.addChild(this._balanceIcon);
        this._betIcon.transform = betSlot.children[0].transform;
        this._winIcon.transform = winSlot.children[0].transform;
        this._balanceIcon.transform = balanceSlot.children[0].transform;
        betSlot.children[0].destroy();
        winSlot.children[0].destroy();
        balanceSlot.children[0].destroy();
    };
    InfoView.prototype.setupValueObjects = function () {
        var betValueSlot = this._spineLayout.slotContainers[this._spineLayout.skeleton.findSlotIndex('BET_NUMBER')];
        var winValueSlot = this._spineLayout.slotContainers[this._spineLayout.skeleton.findSlotIndex('WIN_NUMBER')];
        var balanceValueSlot = this._spineLayout.slotContainers[this._spineLayout.skeleton.findSlotIndex('BALANCE_NUMBER')];
        var clockSlot = this._spineLayout.slotContainers[this._spineLayout.skeleton.findSlotIndex('CLOCK')];
        this._clock = new PIXI.Text('00:00', this._numberStyle);
        this._betValue = new PIXI.Text('', this._numberStyle);
        this._winValue = new PIXI.Text('', this._winFieldNumberStyle);
        this._balanceValue = new PIXI.Text('', this._numberStyle);
        betValueSlot.addChild(this._betValue);
        winValueSlot.addChild(this._winValue);
        balanceValueSlot.addChild(this._balanceValue);
        clockSlot.addChild(this._clock);
        this._betValue.transform = betValueSlot.children[0].transform;
        this._winValue.transform = winValueSlot.children[0].transform;
        this._balanceValue.transform = balanceValueSlot.children[0].transform;
        this._clock.transform = clockSlot.children[0].transform;
        betValueSlot.children[0].destroy();
        winValueSlot.children[0].destroy();
        balanceValueSlot.children[0].destroy();
        clockSlot.children[0].destroy();
        // this.container.addChild(this._clock);
        if (this.device.isMobile) {
            this._betValue.anchor.set(0.5, 0.5);
            this._winValue.anchor.set(0.5, 0.5);
            this._balanceValue.anchor.set(0.5, 0.5);
        }
        else {
            this._betValue.anchor.set(0, 0.5);
            this._winValue.anchor.set(0, 0.5);
            this._balanceValue.anchor.set(0, 0.5);
            var textXoffset = -10;
        }
        this._clock.anchor.set(0, 0.5);
        // this.setTransform(this._clock, clockData);
    };
    InfoView.prototype.setupTextObjects = function () {
        var betTextSlot = this._spineLayout.slotContainers[this._spineLayout.skeleton.findSlotIndex('BET_TEXT')];
        var winTextSlot = this._spineLayout.slotContainers[this._spineLayout.skeleton.findSlotIndex('WIN_TEXT')];
        var balanceTextSlot = this._spineLayout.slotContainers[this._spineLayout.skeleton.findSlotIndex('BALANCE_TEXT')];
        this._betText = new PIXI.Text('BET:', this._textStyle);
        this._winText = new PIXI.Text('WIN:', this._winFieldTextStyle);
        this._balanceText = new PIXI.Text('BALANCE:', this._textStyle);
        betTextSlot.addChild(this._betText);
        winTextSlot.addChild(this._winText);
        balanceTextSlot.addChild(this._balanceText);
        this._betText.transform = betTextSlot.children[0].transform;
        this._winText.transform = winTextSlot.children[0].transform;
        this._balanceText.transform = balanceTextSlot.children[0].transform;
        betTextSlot.children[0].destroy();
        winTextSlot.children[0].destroy();
        balanceTextSlot.children[0].destroy();
        if (this.device.isMobile) {
            this._betText.anchor.set(0.5, 0.5);
            this._winText.anchor.set(0.5, 0.5);
            this._balanceText.anchor.set(0.5, 0.5);
        }
        else {
            this._betText.anchor.set(1, 0.5);
            this._winText.anchor.set(1, 0.5);
            this._balanceText.anchor.set(1, 0.5);
            var textXoffset = -10;
        }
    };
    InfoView.prototype.emitTextInitialized = function () {
        this.emit(InfoViewEvents_1.InfoViewEvents.TEXT_INITIALIZED);
    };
    InfoView.prototype.setupSoundButton = function () {
        var soundButtonSlot = this._spineLayout.slotContainers[this._spineLayout.skeleton.findSlotIndex('SOUND')];
        var soundOnButton = new SpriteButton_1.SpriteButton();
        var soundOnButtonImg = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'SOUND_OFF_ICON.png'));
        soundOnButtonImg.anchor.set(0.5, 0.5);
        soundOnButton.setFrames(soundOnButtonImg);
        var soundOffButton = new SpriteButton_1.SpriteButton();
        var soundOffButtonImg = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'SOUND_ON_ICON.png'));
        soundOffButtonImg.anchor.set(0.5, 0.5);
        soundOffButton.setFrames(soundOffButtonImg);
        this._soundButton = new Checkbox_1.Checkbox(soundOnButton, soundOffButton, this.switchSound.bind(this));
        soundButtonSlot.addChild(soundOnButton);
        soundButtonSlot.addChild(soundOffButton);
        soundOnButton.transform = soundButtonSlot.children[0].transform;
        soundOffButton.transform = soundButtonSlot.children[0].transform;
        soundButtonSlot.children[0].destroy();
    };
    Object.defineProperty(InfoView.prototype, "soundButton", {
        get: function () {
            return this._soundButton;
        },
        enumerable: true,
        configurable: true
    });
    InfoView.MULTILINES_COUNTER_DURATION = 250;
    return InfoView;
}(View_1.View));
exports.InfoView = InfoView;


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Checkbox = /** @class */ (function () {
    function Checkbox(onButton, offButton, changedCallback) {
        this._isOn = false;
        this._onButton = onButton;
        this._offButton = offButton;
        this._changedCallback = changedCallback;
        this._onButton.callback = this.onOnButtonClicked.bind(this);
        this._offButton.callback = this.onOffButtonClicked.bind(this);
        this.updateState();
    }
    Checkbox.prototype.onOnButtonClicked = function () {
        this._onButton.visible = false;
        this._offButton.visible = true;
        this._changedCallback && this._changedCallback(false);
    };
    Checkbox.prototype.onOffButtonClicked = function () {
        this._onButton.visible = true;
        this._offButton.visible = false;
        this._changedCallback && this._changedCallback(true);
    };
    Checkbox.prototype.enable = function () {
        if (this.value) {
            this._onButton.enable();
        }
        else {
            this._offButton.enable();
        }
    };
    Checkbox.prototype.disable = function () {
        if (this.value) {
            this._onButton.disable();
        }
        else {
            this._offButton.disable();
        }
    };
    Checkbox.prototype.hide = function () {
        this._onButton.visible = false;
        this._offButton.visible = false;
    };
    Checkbox.prototype.show = function () {
        this.updateState();
    };
    Object.defineProperty(Checkbox.prototype, "changedCallback", {
        set: function (value) {
            this._changedCallback = value;
        },
        enumerable: true,
        configurable: true
    });
    Checkbox.prototype.setValue = function (isOn, callCallback) {
        if (callCallback === void 0) { callCallback = false; }
        this._isOn = isOn;
        this.updateState();
        callCallback && this._changedCallback && this._changedCallback(isOn);
    };
    Checkbox.prototype.updateState = function () {
        this._onButton.visible = this._isOn;
        this._offButton.visible = !this._isOn;
    };
    Object.defineProperty(Checkbox.prototype, "value", {
        get: function () {
            return this._isOn;
        },
        set: function (isOn) {
            this.setValue(isOn, true);
        },
        enumerable: true,
        configurable: true
    });
    return Checkbox;
}());
exports.Checkbox = Checkbox;


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BackgroundView_1 = __webpack_require__(91);
var DeviceType_1 = __webpack_require__(106);
var Tween_1 = __webpack_require__(19);
var GameBackgroundView = /** @class */ (function (_super) {
    __extends(GameBackgroundView, _super);
    function GameBackgroundView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._isInFreeSpins = false;
        return _this;
    }
    GameBackgroundView.prototype.setupSprites = function () {
        this._mainGameBackground = new PIXI.Sprite();
        this.container.addChild(this._mainGameBackground);
        this._freeSpinsBackground = new PIXI.Sprite();
        this.container.addChild(this._freeSpinsBackground);
        this._reelsBackgroundContainer = new PIXI.Sprite();
        if (this.device.type !== DeviceType_1.DeviceType.DESKTOP) {
            this.container.addChild(this._reelsBackgroundContainer);
        }
        this.playBaseBackGroundIdleAnimation();
        this.plaFreeSpinsBackGroundIdleAnimation();
        var reelsBackground = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'REEL_BACKGROUND.png'));
        var pos = this.layout.getAbsolutePosition('REEL_BACKGROUND');
        reelsBackground.position.set(pos.x, pos.y);
        this._reelsBackgroundContainer.addChild(reelsBackground);
        this.setupIdleAnimations();
    };
    GameBackgroundView.prototype.clearIdleAnimations = function () {
        this._topReelCoverAnimation && this.spineUtils.stopAndDestroyAnimation(this._topReelCoverAnimation);
        this._topReelMystEffectAnimation && this.spineUtils.stopAndDestroyAnimation(this._topReelMystEffectAnimation);
        this._rowDividerAnimation && this.spineUtils.stopAndDestroyAnimation(this._rowDividerAnimation);
    };
    GameBackgroundView.prototype.setupIdleAnimations = function () {
        this.clearIdleAnimations();
        var idleAnimationName = this._isInFreeSpins ? 'IDLE_FREESPIN' : 'IDLE';
        this._topReelCoverAnimation =
            this.spineUtils.startSpineAnimationCreation('TOP_REEL.json', idleAnimationName, true)
                .position(this.layout.getAbsolutePosition('TOP_REEL_EFFECT'))
                .createAndStart();
        this._topReelMystEffectAnimation =
            this.spineUtils.startSpineAnimationCreation('TOP_REEL_EFFECT.json', idleAnimationName, true)
                .position(this.layout.getAbsolutePosition('TOP_REEL_EFFECT'))
                .createAndStart();
        this._rowDividerAnimation =
            this.spineUtils.startSpineAnimationCreation('ROW_DIVIDER.json', idleAnimationName, true)
                .position(this.layout.getAbsolutePosition("ROW_DIVIDER_03"))
                .createAndStart();
        if (this.device.type === DeviceType_1.DeviceType.DESKTOP) {
            this.addReelFrames();
            this.createMaskForReelEffect();
        }
        this.createMaskForRowDivider();
    };
    GameBackgroundView.prototype.createMaskForRowDivider = function () {
        this._currentRowDividerMask = new PIXI.Graphics();
        var scale = this.layout.getScale('BOTTOM_REEL_MASK');
        var noScaleSize = this.layout.getSize('BOTTOM_REEL_MASK');
        var maskSize = { width: noScaleSize.width * scale.x, height: noScaleSize.height * scale.y };
        var maskPos = this.layout.getAbsolutePosition('BOTTOM_REEL_MASK');
        this._currentRowDividerMask.drawRect(0, 0, 1, 1);
        this._currentRowDividerMask.x = maskPos.x - maskSize.width / 2;
        this._currentRowDividerMask.y = maskPos.y - maskSize.height / 2 - 150;
        this._currentRowDividerMask.width = maskSize.width;
        this._currentRowDividerMask.height = 150;
        this.container.addChild(this._currentRowDividerMask);
        this._rowDividerAnimation.container.mask = this._currentRowDividerMask;
    };
    GameBackgroundView.prototype.createMaskForReelEffect = function () {
        this._topReelEffectMask = new PIXI.Graphics();
        var scale = this.layout.getScale('TOP_REEL_MASK');
        var noScaleSize = this.layout.getSize('TOP_REEL_MASK');
        var maskSize = { width: noScaleSize.width * scale.x, height: noScaleSize.height * scale.y };
        var maskPos = this.layout.getAbsolutePosition('TOP_REEL_MASK');
        this._topReelEffectMask.drawRect(0, 0, 1, 1);
        this._topReelEffectMask.x = maskPos.x - maskSize.width / 2;
        this._topReelEffectMask.y = maskPos.y - maskSize.height / 2 - 100;
        this._topReelEffectMask.width = maskSize.width;
        this._topReelEffectMask.height = maskSize.height + 100;
        this.container.addChild(this._topReelEffectMask);
        this._topReelMystEffectAnimation.container.mask = this._topReelEffectMask;
        this._topReelCoverAnimation.container.mask = this._topReelEffectMask;
    };
    GameBackgroundView.prototype.addReelFrames = function () {
        var leftFrame = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'REEL_FRAME.png'));
        leftFrame.anchor.set(0.5);
        var leftFramePos = this.layout.getAbsolutePosition('REEL_FRAME_LEFT');
        leftFrame.position.set(leftFramePos.x, leftFramePos.y);
        this._reelsBackgroundContainer.addChild(leftFrame);
        var rightFrame = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'REEL_FRAME.png'));
        rightFrame.anchor.set(0.5);
        var rightFramePos = this.layout.getAbsolutePosition('REEL_FRAME_RIGHT');
        rightFrame.position.set(rightFramePos.x, rightFramePos.y);
        this._reelsBackgroundContainer.addChild(rightFrame);
        this.container.addChild(this._reelsBackgroundContainer);
    };
    GameBackgroundView.prototype.playBaseBackGroundIdleAnimation = function () {
        this._baseGameAnimation = this.spineUtils.startSpineAnimationCreation('BASEGAME_BACKGROUND.json', 'IDLE', true)
            .container(this._mainGameBackground)
            .position(this.resolutionManager.halfResolution.width, this.resolutionManager.halfResolution.height)
            .createAndStart();
    };
    GameBackgroundView.prototype.plaFreeSpinsBackGroundIdleAnimation = function () {
        this._freeSpinsAnimation = this.spineUtils.startSpineAnimationCreation('FREESPINS_BACKGROUND.json', 'IDLE', true)
            .container(this._freeSpinsBackground)
            .position(this.resolutionManager.halfResolution.width, this.resolutionManager.halfResolution.height)
            .createAndStart();
    };
    GameBackgroundView.prototype.playStartAnimation = function () {
        this.cleanBaseBackground();
        this._baseGameAnimation = this.spineUtils.startSpineAnimationCreation('BASEGAME_BACKGROUND.json', 'GAME_START', false)
            .container(this._mainGameBackground)
            .position(this.resolutionManager.halfResolution.width, this.resolutionManager.halfResolution.height)
            .chainIdleAnimation('IDLE')
            .createAndStart();
    };
    GameBackgroundView.prototype.playEnterFreeSpinsAnimation = function () {
        this.cleanFreeSpinsBackground();
        this._freeSpinsAnimation = this.spineUtils.startSpineAnimationCreation('FREESPINS_BACKGROUND.json', 'ENTER_FREESPINS', false)
            .container(this._freeSpinsBackground)
            .position(this.resolutionManager.halfResolution.width, this.resolutionManager.halfResolution.height)
            .chainIdleAnimation('IDLE')
            .createAndStart();
        this.cleanBaseBackground();
        this._baseGameAnimation = this.spineUtils.startSpineAnimationCreation('BASEGAME_BACKGROUND.json', 'ENTER_FREESPINS', false)
            .container(this._mainGameBackground)
            .position(this.resolutionManager.halfResolution.width, this.resolutionManager.halfResolution.height)
            .createAndStart();
    };
    GameBackgroundView.prototype.playExitFreeSpinsAnimation = function () {
        this.cleanFreeSpinsBackground();
        this._freeSpinsAnimation = this.spineUtils.startSpineAnimationCreation('FREESPINS_BACKGROUND.json', 'EXIT_FREESPINS', false)
            .container(this._freeSpinsBackground)
            .position(this.resolutionManager.halfResolution.width, this.resolutionManager.halfResolution.height)
            .createAndStart();
        this.cleanBaseBackground();
        this._baseGameAnimation = this.spineUtils.startSpineAnimationCreation('BASEGAME_BACKGROUND.json', 'ENTER_FREESPINS', false)
            .container(this._mainGameBackground)
            .position(this.resolutionManager.halfResolution.width, this.resolutionManager.halfResolution.height)
            .chainIdleAnimation('IDLE')
            .createAndStart();
    };
    GameBackgroundView.prototype.cleanBaseBackground = function () {
        if (this._baseGameAnimation) {
            this.spineUtils.stopAndDestroyAnimation(this._baseGameAnimation);
            this._baseGameAnimation = null;
        }
    };
    GameBackgroundView.prototype.cleanFreeSpinsBackground = function () {
        if (this._freeSpinsAnimation) {
            this.spineUtils.stopAndDestroyAnimation(this._freeSpinsAnimation);
            this._freeSpinsAnimation = null;
        }
    };
    GameBackgroundView.prototype.initBackgrounds = function () {
        this.showMainGameBackground();
        this.emit(BackgroundView_1.BackgroundView.BACKGROUND_CREATED);
    };
    GameBackgroundView.prototype.startTransition = function () {
        this.playTransition(this._reelsBackgroundContainer);
        this.playTransition(this._topReelCoverAnimation.container);
        this.playTransition(this._rowDividerAnimation.container);
        this.playTransition(this._topReelMystEffectAnimation.container);
    };
    GameBackgroundView.prototype.playTransition = function (container) {
        var appearTween = new Tween_1.Tween(container)
            .to({ alpha: 1.0 }, BackgroundView_1.BackgroundView.TRANSFER_TIME)
            .start();
        this.updateManager.add(appearTween);
    };
    GameBackgroundView.prototype.setReelsBackgroundAlphaToZero = function () {
        this._reelsBackgroundContainer.alpha = 0;
        this._topReelCoverAnimation.container.alpha = 0;
        this._rowDividerAnimation.container.alpha = 0;
        this._topReelMystEffectAnimation.container.alpha = 0;
    };
    GameBackgroundView.prototype.hideReelBackground = function () {
        this._reelsBackgroundContainer.visible = false;
        this._topReelCoverAnimation.container.visible = false;
        this._rowDividerAnimation.container.visible = false;
        this._topReelMystEffectAnimation.container.visible = false;
    };
    GameBackgroundView.prototype.showReelBackground = function () {
        this._reelsBackgroundContainer.visible = true;
        this._topReelCoverAnimation.container.visible = true;
        this._rowDividerAnimation.container.visible = true;
        this._topReelMystEffectAnimation.container.visible = true;
    };
    Object.defineProperty(GameBackgroundView.prototype, "isInFreeSpins", {
        set: function (value) {
            this._isInFreeSpins = value;
        },
        enumerable: true,
        configurable: true
    });
    return GameBackgroundView;
}(BackgroundView_1.BackgroundView));
exports.GameBackgroundView = GameBackgroundView;


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var GameViews_1 = __webpack_require__(43);
var GameAvalancheReelsModule_1 = __webpack_require__(264);
var AvalancheReelsModule_1 = __webpack_require__(23);
var TopAvalancheReelsDropOutState_1 = __webpack_require__(559);
var TopGameAvalancheRespinState_1 = __webpack_require__(560);
var TopGameAvalancheAddSymbolsState_1 = __webpack_require__(561);
var TopGameAvalancheRemoveWinsState_1 = __webpack_require__(562);
var TopGameAvalancheReelsDropNewState_1 = __webpack_require__(563);
var TopReelsModule = /** @class */ (function (_super) {
    __extends(TopReelsModule, _super);
    function TopReelsModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TopReelsModule.prototype.setupViews = function () {
        this.setView(GameViews_1.GameViews.TOP_REELS_VIEW);
    };
    TopReelsModule.prototype.setupStates = function () {
        _super.prototype.setupStates.call(this);
        this.addState(new TopAvalancheReelsDropOutState_1.TopAvalancheReelsDropOutState(this, AvalancheReelsModule_1.AvalancheReelsModule.DROPOUT_STATE));
        this.addState(new TopGameAvalancheAddSymbolsState_1.TopGameAvalancheAddSymbolsState(this, AvalancheReelsModule_1.AvalancheReelsModule.ADD_SYMBOLS_STATE));
        this.addState(new TopGameAvalancheRespinState_1.TopGameAvalancheRespinState(this, AvalancheReelsModule_1.AvalancheReelsModule.RESPIN_STATE));
        this.addState(new TopGameAvalancheRemoveWinsState_1.TopGameAvalancheRemoveWinsState(this, AvalancheReelsModule_1.AvalancheReelsModule.REMOVE_WINS_STATE));
        this.addState(new TopGameAvalancheReelsDropNewState_1.TopGameAvalancheReelsDropNewState(this, AvalancheReelsModule_1.AvalancheReelsModule.DROPNEW_STATE));
    };
    TopReelsModule.prototype.onRemovingSymbolsFinished = function (eventID, symbols) {
    };
    TopReelsModule.prototype.onFillingVoidsFinished = function (eventID, reelNr) {
    };
    return TopReelsModule;
}(GameAvalancheReelsModule_1.GameAvalancheReelsModule));
exports.TopReelsModule = TopReelsModule;


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var AvalancheReelsDropOutState_1 = __webpack_require__(266);
var TopAvalancheReelsDropOutState = /** @class */ (function (_super) {
    __extends(TopAvalancheReelsDropOutState, _super);
    function TopAvalancheReelsDropOutState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TopAvalancheReelsDropOutState.prototype.onEnterState = function () {
        this.view.showAllSymbols();
        this.view.dropOut();
    };
    return TopAvalancheReelsDropOutState;
}(AvalancheReelsDropOutState_1.AvalancheReelsDropOutState));
exports.TopAvalancheReelsDropOutState = TopAvalancheReelsDropOutState;


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var GameAvalancheRespinState_1 = __webpack_require__(274);
var AvalancheReelsModule_1 = __webpack_require__(23);
var TopGameAvalancheRespinState = /** @class */ (function (_super) {
    __extends(TopGameAvalancheRespinState, _super);
    function TopGameAvalancheRespinState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TopGameAvalancheRespinState.prototype.onAddingNewFinished = function () {
        this.module.gotoState(AvalancheReelsModule_1.AvalancheReelsModule.BASIC_STATE);
    };
    TopGameAvalancheRespinState.prototype.onRespinFinished = function () {
        var _this = this;
        this.module.timeUtils.createTimer(function () {
            var respinScatters = _this.module.logic.getSpinResult().respinScatters;
            var removePositions = [];
            for (var _i = 0, respinScatters_1 = respinScatters; _i < respinScatters_1.length; _i++) {
                var scatterInfo = respinScatters_1[_i];
                removePositions.push(scatterInfo.respinScatterPosition);
                removePositions.push.apply(removePositions, scatterInfo.respinSymbols);
            }
            _this.view.removeRespinSymbolsFromReels(removePositions);
            _this.view.fillVoidAfterRemoval();
        }, 300);
    };
    TopGameAvalancheRespinState.prototype.onRespinSymbolsRemovalFinished = function () {
    };
    return TopGameAvalancheRespinState;
}(GameAvalancheRespinState_1.GameAvalancheRespinState));
exports.TopGameAvalancheRespinState = TopGameAvalancheRespinState;


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var GameAvalancheAddSymbolsState_1 = __webpack_require__(273);
var AvalancheReelsModule_1 = __webpack_require__(23);
var TopGameAvalancheAddSymbolsState = /** @class */ (function (_super) {
    __extends(TopGameAvalancheAddSymbolsState, _super);
    function TopGameAvalancheAddSymbolsState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TopGameAvalancheAddSymbolsState.prototype.startAddingNewSymbols = function () {
        _super.prototype.startAddingNewSymbols.call(this);
    };
    TopGameAvalancheAddSymbolsState.prototype.onAddingNewFinished = function () {
        this.module.gotoState(AvalancheReelsModule_1.AvalancheReelsModule.BASIC_STATE);
    };
    return TopGameAvalancheAddSymbolsState;
}(GameAvalancheAddSymbolsState_1.GameAvalancheAddSymbolsState));
exports.TopGameAvalancheAddSymbolsState = TopGameAvalancheAddSymbolsState;


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var GameAvalancheRemoveWinsState_1 = __webpack_require__(272);
var TopGameAvalancheRemoveWinsState = /** @class */ (function (_super) {
    __extends(TopGameAvalancheRemoveWinsState, _super);
    function TopGameAvalancheRemoveWinsState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TopGameAvalancheRemoveWinsState.prototype.startSymbolsRemoving = function () {
        var _this = this;
        var delay = GameAvalancheRemoveWinsState_1.GameAvalancheRemoveWinsState.BEFORE_REMOVE_TIMEOUT;
        this.module.timeUtils.createTimer(function () {
            var gameLogic = _this.module.logic;
            _this.view.removeSymbolsOnAvalancheWithSound(gameLogic.getSpinResult().symbolsToRemove, gameLogic.getSpinWin(), gameLogic.getTotalBet());
        }, delay);
    };
    return TopGameAvalancheRemoveWinsState;
}(GameAvalancheRemoveWinsState_1.GameAvalancheRemoveWinsState));
exports.TopGameAvalancheRemoveWinsState = TopGameAvalancheRemoveWinsState;


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var GameAvalancheReelsDropNewState_1 = __webpack_require__(271);
var AvalancheReelsModule_1 = __webpack_require__(23);
var ReelConstants_1 = __webpack_require__(10);
var ReelsEvents_1 = __webpack_require__(4);
var TopGameAvalancheReelsDropNewState = /** @class */ (function (_super) {
    __extends(TopGameAvalancheReelsDropNewState, _super);
    function TopGameAvalancheReelsDropNewState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TopGameAvalancheReelsDropNewState.prototype.onAllReelsDroppedNew = function () {
        this.module.gotoState(AvalancheReelsModule_1.AvalancheReelsModule.BASIC_STATE);
        this.emitDelayed(ReelsEvents_1.ReelsEvents.SPIN_ENDED);
    };
    TopGameAvalancheReelsDropNewState.prototype.dropNewSymbols = function () {
        var _this = this;
        this.module.timeUtils.oneFrameTimer(function () {
            _this.view.dropNew(_this.module.logic.getSpinResult().reels, ReelConstants_1.ReelConstants.ROW_AMOUNT);
        });
    };
    return TopGameAvalancheReelsDropNewState;
}(GameAvalancheReelsDropNewState_1.GameAvalancheReelsDropNewState));
exports.TopGameAvalancheReelsDropNewState = TopGameAvalancheReelsDropNewState;


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var GameAvalancheReelsView_1 = __webpack_require__(157);
var ReelConstants_1 = __webpack_require__(10);
var TopAvalancheReel_1 = __webpack_require__(565);
var Tween_1 = __webpack_require__(19);
var AvalancheReelsView_1 = __webpack_require__(75);
var TopReelsView = /** @class */ (function (_super) {
    __extends(TopReelsView, _super);
    function TopReelsView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TopReelsView.prototype.setupReelSetMaskForSpinning = function () {
        if (this.resources.hasMajorPerformanceCaveat) {
            this._currentMask = null;
            return;
        }
        this._currentMask = new PIXI.Graphics();
        var scale = this.layout.getScale('TOP_REEL_MASK');
        var noScaleSize = this.layout.getSize('TOP_REEL_MASK');
        var maskSize = { width: noScaleSize.width * scale.x, height: noScaleSize.height * scale.y };
        var maskPos = this.layout.getAbsolutePosition('TOP_REEL_MASK');
        this._currentMask.drawRect(0, 0, 1, 1);
        this._currentMask.x = maskPos.x - maskSize.width / 2;
        this._currentMask.y = maskPos.y - maskSize.height / 2;
        this._currentMask.width = maskSize.width;
        this._currentMask.height = maskSize.height;
    };
    TopReelsView.prototype.setupLayers = function () {
        this.container.children.length = 0;
        this._reels = [];
        this._reelsetContainer = new PIXI.Sprite();
        this.container.addChild(this._reelsetContainer);
        this.container.addChild(this._currentMask);
        this.container.mask = this._currentMask;
    };
    TopReelsView.prototype.createReel = function (reelIndex, startReelPosition, offsets, container) {
        return new TopAvalancheReel_1.TopAvalancheReel(reelIndex, startReelPosition, offsets, container);
    };
    TopReelsView.prototype.fillVoidAfterRemoval = function () {
        this._wasFillingVoidMessageSent = false;
        for (var reelIndex = 0; reelIndex < ReelConstants_1.ReelConstants.REELS_AMOUNT; reelIndex++) {
            this._reels[reelIndex].dropElementsToFillVoids();
        }
        if (!this.hasAnyReelsToFillVoid()) {
            this.onFillingVoidsFinished(0);
        }
    };
    TopReelsView.prototype.fadeOutSymbols = function () {
        var fadeOutTween = new Tween_1.Tween(this._reelsetContainer)
            .to({ alpha: 0 }, AvalancheReelsView_1.AvalancheReelsView.FADING_TIMER)
            .onComplete(function () {
        })
            .start();
        this.updateManager.add(fadeOutTween);
    };
    TopReelsView.prototype.fadeInSymbols = function () {
        var fadeOutTween = new Tween_1.Tween(this._reelsetContainer)
            .to({ alpha: 1 }, AvalancheReelsView_1.AvalancheReelsView.FADING_TIMER)
            .onComplete(function () {
        })
            .start();
        this.updateManager.add(fadeOutTween);
    };
    TopReelsView.prototype.addWinIndicationToSymbols = function (winLines) {
    };
    TopReelsView.prototype.tryToPlayScatterAnimationOnReel = function (reelIndex) {
    };
    TopReelsView.prototype.removeSymbolsOnAvalancheWithSound = function (symbols, win, bet) {
        var lastReelWithRemovedSymbols = 0;
        symbols.forEach(function (symPos) {
            if (symPos.x > lastReelWithRemovedSymbols) {
                lastReelWithRemovedSymbols = symPos.x;
            }
        });
        for (var reelIndex = 0; reelIndex < ReelConstants_1.ReelConstants.REELS_AMOUNT; reelIndex++) {
            var symbolsOnReel = this.getAllSymbolPositionsFromReel(reelIndex, symbols);
            if (symbolsOnReel.length) {
                this._reels[reelIndex].removeAvalancheSymbols(symbolsOnReel, null);
            }
        }
    };
    return TopReelsView;
}(GameAvalancheReelsView_1.GameAvalancheReelsView));
exports.TopReelsView = TopReelsView;


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var GameAvalancheReel_1 = __webpack_require__(261);
var TopReelSymbol_1 = __webpack_require__(263);
var Easing_1 = __webpack_require__(16);
var ReelConstants_1 = __webpack_require__(10);
var Tween_1 = __webpack_require__(19);
var GameReelConstants_1 = __webpack_require__(34);
var TopAvalancheReel = /** @class */ (function (_super) {
    __extends(TopAvalancheReel, _super);
    function TopAvalancheReel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TopAvalancheReel.prototype.createReelSymbol = function () {
        return new TopReelSymbol_1.TopReelSymbol();
    };
    TopAvalancheReel.prototype.dropNewSymbolToPosition = function (symIndex, yPosition, delay, easing, duration) {
        if (easing === void 0) { easing = Easing_1.Easing.Quadratic.In; }
        if (duration === void 0) { duration = GameReelConstants_1.GameAvalancheConstants.dropInConfig.dropDuration; }
        var symbol = this._symbols[symIndex];
        symbol.y =
            yPosition - GameReelConstants_1.GameReelConstants.getTopSymbolSlot().height * ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT - GameReelConstants_1.GameReelConstants.getReelsOffsetForRow(symIndex).y;
        var dropNewTween = new Tween_1.Tween(symbol)
            .to({ y: yPosition }, duration)
            .easing(easing)
            .delay(delay);
        this.add(dropNewTween);
        dropNewTween.start();
        return dropNewTween;
    };
    TopAvalancheReel.prototype.playRemoveAnimationAt = function (sym, onCompleted) {
        sym.visible = false;
        onCompleted && onCompleted();
    };
    return TopAvalancheReel;
}(GameAvalancheReel_1.GameAvalancheReel));
exports.TopAvalancheReel = TopAvalancheReel;


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var View_1 = __webpack_require__(3);
var OverTopReelEffectsView = /** @class */ (function (_super) {
    __extends(OverTopReelEffectsView, _super);
    function OverTopReelEffectsView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._isInFreeSpins = false;
        return _this;
    }
    OverTopReelEffectsView.prototype.init = function () {
        _super.prototype.init.call(this);
        this._currentMask = new PIXI.Graphics();
        var scale = this.layout.getScale('BOTTOM_REEL_MASK');
        var noScaleSize = this.layout.getSize('BOTTOM_REEL_MASK');
        var maskSize = { width: noScaleSize.width * scale.x, height: noScaleSize.height * scale.y };
        var maskPos = this.layout.getAbsolutePosition('BOTTOM_REEL_MASK');
        this._currentMask.drawRect(0, 0, 1, 1);
        this._currentMask.x = maskPos.x - maskSize.width / 2;
        this._currentMask.y = maskPos.y - maskSize.height / 2 - 150;
        this._currentMask.width = maskSize.width;
        this._currentMask.height = 150;
    };
    OverTopReelEffectsView.prototype.playOrdinaryDropOn = function (dropRows) {
        if (dropRows > 0) {
            var animationName = this._isInFreeSpins ? "FREESPIN_DROP_0" + dropRows : "DROP_0" + dropRows;
            var animation = this.spineUtils.startSpineAnimationCreation('ROW_DIVIDER_EFFECT.json', animationName, false)
                .position(this.layout.getAbsolutePosition("ROW_DIVIDER_03"))
                .createAndStart();
            animation.container.mask = this._currentMask;
        }
    };
    OverTopReelEffectsView.prototype.playSpecialDropIn = function (dropRows) {
        if (dropRows > 0) {
            var animationName = this._isInFreeSpins ? "FREESPIN_SPECIAL_DROP_0" + dropRows : "SPECIAL_DROP_0" + dropRows;
            var animation = this.spineUtils.startSpineAnimationCreation('ROW_DIVIDER_EFFECT.json', animationName, false)
                .position(this.layout.getAbsolutePosition("ROW_DIVIDER_03"))
                .createAndStart();
            animation.container.mask = this._currentMask;
        }
    };
    Object.defineProperty(OverTopReelEffectsView.prototype, "isInFreeSpins", {
        set: function (value) {
            this._isInFreeSpins = value;
        },
        enumerable: true,
        configurable: true
    });
    return OverTopReelEffectsView;
}(View_1.View));
exports.OverTopReelEffectsView = OverTopReelEffectsView;


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Module_1 = __webpack_require__(2);
var GameViews_1 = __webpack_require__(43);
var GameAvalancheReelsEvents_1 = __webpack_require__(39);
var Symbols_1 = __webpack_require__(38);
var StartScreenEvents_1 = __webpack_require__(22);
var FreeSpinsEvents_1 = __webpack_require__(6);
var OverTopReelEffectsModule = /** @class */ (function (_super) {
    __extends(OverTopReelEffectsModule, _super);
    function OverTopReelEffectsModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OverTopReelEffectsModule.prototype.enterFirstState = function () {
    };
    OverTopReelEffectsModule.prototype.setupStates = function () {
    };
    OverTopReelEffectsModule.prototype.restore = function () {
        _super.prototype.restore.call(this);
        if (this.logic.isFreeSpinsStarted) {
            this.view.isInFreeSpins = true;
        }
    };
    OverTopReelEffectsModule.prototype.setupViews = function () {
        this.setView(GameViews_1.GameViews.UNDER_TOP_REELS_VIEW);
    };
    OverTopReelEffectsModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(GameAvalancheReelsEvents_1.GameAvalancheReelsEvents.SYMBOL_PASSED_THROUGHT_LINE, this.onSymbolPassesThroughLine);
        this.on(StartScreenEvents_1.StartScreenEvents.INTRO_STARTED, this.onStartScreenIntroStarted);
        this.on(StartScreenEvents_1.StartScreenEvents.EXIT_FINISHED, this.onStartScreenIntroFinished);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_INTRO_STARTED, this.onFreeSpinsIntroStarted);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_RESTORE_INTRO_STARTED, this.onFreeSpinsIntroStarted);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_OUTRO_STARTED, this.onFreeSpinsOutroStarted);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_INTRO_FINISHED, this.onFreeSpinsIntroFinished);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_OUTRO_FINISHED, this.onFreeSpinsOutroFinished);
    };
    OverTopReelEffectsModule.prototype.onFreeSpinsIntroStarted = function () {
        this.view.isInFreeSpins = true;
        this.view.hide();
    };
    OverTopReelEffectsModule.prototype.onFreeSpinsOutroStarted = function () {
        this.view.isInFreeSpins = false;
        this.view.hide();
    };
    OverTopReelEffectsModule.prototype.onFreeSpinsIntroFinished = function () {
        this.view.show();
    };
    OverTopReelEffectsModule.prototype.onFreeSpinsOutroFinished = function () {
        this.view.show();
    };
    OverTopReelEffectsModule.prototype.onStartScreenIntroStarted = function () {
        this.view.hide();
    };
    OverTopReelEffectsModule.prototype.onStartScreenIntroFinished = function () {
        this.view.show();
    };
    OverTopReelEffectsModule.prototype.onSymbolPassesThroughLine = function (eventID, symbolID, newRowPos) {
        if (symbolID === Symbols_1.Symbols.TOP_WR || symbolID === Symbols_1.Symbols.WR ||
            symbolID === Symbols_1.Symbols.TOP_RS || symbolID === Symbols_1.Symbols.RS ||
            symbolID === Symbols_1.Symbols.TOP_BN || symbolID === Symbols_1.Symbols.BN) {
            this.view.playSpecialDropIn(newRowPos - 2);
        }
        else {
            this.view.playOrdinaryDropOn(newRowPos - 2);
        }
    };
    return OverTopReelEffectsModule;
}(Module_1.Module));
exports.OverTopReelEffectsModule = OverTopReelEffectsModule;


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var WildMeterView_1 = __webpack_require__(294);
var Module_1 = __webpack_require__(2);
var GameViews_1 = __webpack_require__(43);
var ReelsEvents_1 = __webpack_require__(4);
var GameAvalancheReelsEvents_1 = __webpack_require__(39);
var ReelConstants_1 = __webpack_require__(10);
var WildMeterEvents_1 = __webpack_require__(66);
var FreeSpinsEvents_1 = __webpack_require__(6);
var WinPresentationEvents_1 = __webpack_require__(13);
var StartScreenEvents_1 = __webpack_require__(22);
var TimingConstants_1 = __webpack_require__(158);
var GameBackgroundModule_1 = __webpack_require__(93);
var WildMeterModule = /** @class */ (function (_super) {
    __extends(WildMeterModule, _super);
    function WildMeterModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WildMeterModule.prototype.enterFirstState = function () {
    };
    WildMeterModule.prototype.restore = function () {
        var logic = this.logic;
        if (logic.isFreeSpinsStarted) {
            var initialWildMeterValue = logic.wildMeter - logic.getTotalWildMeterDeltas();
            var coinsOnMeter = initialWildMeterValue % 3;
            var currentMultiplierValue = 1 + (Math.floor(initialWildMeterValue / 3) * 2);
            this.view.isInFreeSpins = logic.isFreeSpinsStarted;
            this.view.currentMultiplierValue = currentMultiplierValue;
            this.view.setMultiplierValue(currentMultiplierValue);
            var animationIndex = Math.round(currentMultiplierValue / 2);
            var mpValue = currentMultiplierValue > 10 ? 10 : currentMultiplierValue;
            if (animationIndex >= WildMeterView_1.WildMeterView.MP_LVL_TO_UPGRADE_IDLE[0]) {
                this.view.updateMultiplierIdleAnimation(mpValue);
            }
            else if (coinsOnMeter > 0) {
                this.view.playMultiplierIdleAnimation(1);
            }
            coinsOnMeter > 0 && this.view.updateCoinsOnMeter(coinsOnMeter);
        }
    };
    WildMeterModule.prototype.setupStates = function () {
        this.on(ReelsEvents_1.ReelsEvents.REELS_SPINNING_STARTED, this.onSpinStarted);
        this.on(GameAvalancheReelsEvents_1.GameAvalancheReelsEvents.WIN_SYMBOLS_EXPLOSION_STARTED, this.onWinExplosionStarted);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_INTRO_STARTED, this.onFreeSpinsIntroStarted);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_OUTRO_CONTINUE_CLICKED, this.onFreeSpinsOutroContinued);
        this.on(WinPresentationEvents_1.WinPresentationEvents.WIN_NUMBER_BOUNCE_FINISHED, this.onWinBounceFinished);
        this.onViewEmitEvent(WildMeterView_1.WildMeterView.WIN_METER_WILDS_ANIMATIONS_FINISHED, WildMeterEvents_1.WildMeterEvents.WIN_METER_WILDS_ANIMATIONS_FINISHED);
        this.onViewEmitEvent(WildMeterView_1.WildMeterView.WIN_METER_EXIT_WIN_ANIMATION_STARTED, WildMeterEvents_1.WildMeterEvents.WIN_METER_EXIT_WIN_ANIMATION_STARTED);
        this.onViewEmitEvent(WildMeterView_1.WildMeterView.WIN_METER_EXIT_WIN_ANIMATION_FINISHED, WildMeterEvents_1.WildMeterEvents.WIN_METER_EXIT_WIN_ANIMATION_FINISHED);
        this.onViewEmitEvent(WildMeterView_1.WildMeterView.ADD_WILD_COIN_TO_REELS, WildMeterEvents_1.WildMeterEvents.ADD_WILD_COIN_TO_REELS);
        this.onViewEmitEvent(WildMeterView_1.WildMeterView.SEND_COIN_TO_METER, WildMeterEvents_1.WildMeterEvents.SEND_COIN_TO_METER);
        this.onViewEmitEvent(WildMeterView_1.WildMeterView.COIN_HIT_METER, WildMeterEvents_1.WildMeterEvents.COIN_HIT_METER);
        this.onViewEmitEvent(WildMeterView_1.WildMeterView.MULTIPLIER_UDPATE, WildMeterEvents_1.WildMeterEvents.MULTIPLIER_UDPATE);
        this.onViewEmitEvent(WildMeterView_1.WildMeterView.INDICATOR_LIT, WildMeterEvents_1.WildMeterEvents.INDICATOR_LIT);
        this.on(StartScreenEvents_1.StartScreenEvents.INTRO_STARTED, this.onStartScreenIntroStarted);
        this.on(GameBackgroundModule_1.GameBackgroundModule.TRANSITION_ANIMATION_STARTED, this.onTransitionAnimationStarted);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_INTRO_STARTED, this.onFreeSpinsIntroStarted);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_RESTORE_INTRO_STARTED, this.onFreeSpinsIntroStarted);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_OUTRO_STARTED, this.onFreeSpinsOutroStarted);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_INTRO_FINISHED, this.onFreeSpinsIntroFinished);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_OUTRO_FINISHED, this.onFreeSpinsOutroFinished);
    };
    WildMeterModule.prototype.onFreeSpinsOutroStarted = function () {
        this.view.hide();
    };
    WildMeterModule.prototype.onFreeSpinsIntroFinished = function () {
        this.view.show();
    };
    WildMeterModule.prototype.onFreeSpinsOutroFinished = function () {
        this.view.show();
    };
    WildMeterModule.prototype.onStartScreenIntroStarted = function () {
        this.view.setReelsContainerAlphaToZero();
    };
    WildMeterModule.prototype.onTransitionAnimationStarted = function () {
        this.view.playReelContainerTransition();
    };
    WildMeterModule.prototype.currentRoundMultiplier = function () {
        var logic = this.logic;
        if (logic.wildMeterDeltas.length) {
            var currentRoundMultiplier = Math.floor(logic.wildMeterDeltas.reduce(function (a, b) { return a + b; }) / 3);
            return currentRoundMultiplier * 2;
        }
        else {
            return 0;
        }
    };
    WildMeterModule.prototype.getFreeSpinsTotalMultiplier = function (wildMeter) {
        var defaultMultiplier = 1;
        var multiplier = Math.floor(wildMeter / 3);
        return multiplier ? multiplier * 2 + defaultMultiplier : 1;
    };
    WildMeterModule.prototype.setupViews = function () {
        this.setView(GameViews_1.GameViews.WILD_METER_VIEW);
    };
    WildMeterModule.prototype.onWinBounceFinished = function () {
        var logic = this.logic;
        if (logic.getLastAvalancheMultiplier() > 1) {
            this.view.playWinAimation();
            this.view.setMultiplierValue(logic.getLastAvalancheMultiplier(), false, true);
            this.view.setMultiplierValue(logic.getLastAvalancheMultiplier(), true, true);
        }
    };
    WildMeterModule.prototype.onFreeSpinsIntroStarted = function () {
        this.view.resetCoins();
        this.view.restoreMultiplier();
        this.view.isInFreeSpins = true;
        this.view.hide();
    };
    WildMeterModule.prototype.onFreeSpinsOutroContinued = function () {
        this.view.isInFreeSpins = false;
    };
    WildMeterModule.prototype.onSpinStarted = function () {
        var logic = this.logic;
        if (!logic.isFreeSpinsStarted) {
            this.view.fullMultiplierRestore();
        }
    };
    WildMeterModule.prototype.onWinExplosionStarted = function () {
        var _this = this;
        var logic = this.logic;
        var wildWinPositions = logic.getCurrentRoundWinningWilds();
        if (wildWinPositions.length === 0) {
            return;
        }
        var delay = 0;
        var _loop_1 = function (reelIndex) {
            var symbolsOnReel = this_1.getAllSymbolPositionsFromReel(reelIndex, wildWinPositions);
            if (symbolsOnReel.length) {
                this_1.timeUtils.createTimer(function () {
                    for (var _i = 0, symbolsOnReel_1 = symbolsOnReel; _i < symbolsOnReel_1.length; _i++) {
                        var symPos = symbolsOnReel_1[_i];
                        _this.view.addWildCoinOntoReels(symPos);
                    }
                }, delay);
                delay += TimingConstants_1.TimingConstants.SYMBOL_REMOVE_STAGGER_DELAY;
            }
        };
        var this_1 = this;
        for (var reelIndex = 0; reelIndex < ReelConstants_1.ReelConstants.REELS_AMOUNT; reelIndex++) {
            _loop_1(reelIndex);
        }
        delay += TimingConstants_1.TimingConstants.START_SEND_COINS_DELAY;
        this.timeUtils.createTimer(function () {
            _this.view.startSendingCoinsToWildMeter();
        }, delay);
    };
    // MHNOTE: Blunt copy from AvalancheReelsView. Should ideally be put in a helper class.
    WildMeterModule.prototype.getAllSymbolPositionsFromReel = function (reelIndex, symbols) {
        var syms = [];
        for (var _i = 0, symbols_1 = symbols; _i < symbols_1.length; _i++) {
            var sym = symbols_1[_i];
            if (sym.x === reelIndex) {
                syms.push(sym);
            }
        }
        return syms;
    };
    return WildMeterModule;
}(Module_1.Module));
exports.WildMeterModule = WildMeterModule;


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Module_1 = __webpack_require__(2);
var GameViews_1 = __webpack_require__(43);
var WinLinesPresentationModule = /** @class */ (function (_super) {
    __extends(WinLinesPresentationModule, _super);
    function WinLinesPresentationModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WinLinesPresentationModule.prototype.enterFirstState = function () {
    };
    WinLinesPresentationModule.prototype.setupStates = function () {
    };
    WinLinesPresentationModule.prototype.setupViews = function () {
        this.setView(GameViews_1.GameViews.WIN_LINES_PRESENTATION_VIEW);
    };
    return WinLinesPresentationModule;
}(Module_1.Module));
exports.WinLinesPresentationModule = WinLinesPresentationModule;


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var View_1 = __webpack_require__(3);
var WinLinesPresentationView = /** @class */ (function (_super) {
    __extends(WinLinesPresentationView, _super);
    function WinLinesPresentationView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WinLinesPresentationView.prototype.playWinPresentation = function (lines) {
        this._currentWinLines = lines;
        this._currentWinLineIndex = -1;
        this.playNextLine();
    };
    WinLinesPresentationView.prototype.playNextLine = function () {
        this._currentWinLineIndex++;
        if (this._currentWinLineIndex >= this._currentWinLines.length) {
            this.emitDelayed(WinLinesPresentationView.LINES_PRESENTATION_FINISHED);
        }
        else {
            this.playLine(this._currentWinLines[this._currentWinLineIndex], this.playNextLine.bind(this));
        }
    };
    WinLinesPresentationView.prototype.playLine = function (line, onFinished) {
        // this.spineUtils.startSpineAnimationCreation('WINLINES.json', this.getAnimationNameForLine(line), false)
    };
    WinLinesPresentationView.prototype.getAnimationNameForLine = function (line) {
        var direction = line.isRightToLeft ? 'RIGHT_TO_LEFT' : 'LEFT_TO_RIGHT';
        return "WINLINE_" + line.lineIndex + "_" + direction;
    };
    WinLinesPresentationView.LINES_PRESENTATION_FINISHED = 'WinLinesPresentationView::LINES_PRESENTATION_FINISHED';
    return WinLinesPresentationView;
}(View_1.View));
exports.WinLinesPresentationView = WinLinesPresentationView;


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Module_1 = __webpack_require__(2);
var GameViews_1 = __webpack_require__(43);
var GameAvalancheReelsEvents_1 = __webpack_require__(39);
var ReelsEvents_1 = __webpack_require__(4);
var WinPresentationEvents_1 = __webpack_require__(13);
var StartScreenEvents_1 = __webpack_require__(22);
var FreeSpinsEvents_1 = __webpack_require__(6);
var GameBackgroundModule_1 = __webpack_require__(93);
var WinFieldModule = /** @class */ (function (_super) {
    __extends(WinFieldModule, _super);
    function WinFieldModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WinFieldModule.prototype.enterFirstState = function () {
    };
    WinFieldModule.prototype.setupStates = function () {
    };
    WinFieldModule.prototype.setupViews = function () {
        this.setView(GameViews_1.GameViews.WIN_FIELD_VIEW);
    };
    WinFieldModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(GameAvalancheReelsEvents_1.GameAvalancheReelsEvents.WIN_HIGHLIGHTING_STARTED, this.onWinHighlightStarted);
        this.on(ReelsEvents_1.ReelsEvents.REELS_SPINNING_STARTED, this.onSpinStarted);
        this.on(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_STARTED, this.onInitialWinPresentationStarted);
        this.on(StartScreenEvents_1.StartScreenEvents.INTRO_STARTED, this.onStartScreenIntroStarted);
        this.on(GameBackgroundModule_1.GameBackgroundModule.TRANSITION_ANIMATION_STARTED, this.onTransitionAnimationStarted);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_INTRO_STARTED, this.onFreeSpinsIntroStarted);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_RESTORE_INTRO_STARTED, this.onFreeSpinsIntroStarted);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_OUTRO_STARTED, this.onFreeSpinsOutroStarted);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_INTRO_FINISHED, this.onFreeSpinsIntroFinished);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_OUTRO_FINISHED, this.onFreeSpinsOutroFinished);
    };
    WinFieldModule.prototype.onFreeSpinsOutroStarted = function () {
        this.view.hide();
    };
    WinFieldModule.prototype.onFreeSpinsIntroStarted = function () {
        this.view.hide();
    };
    WinFieldModule.prototype.onFreeSpinsIntroFinished = function () {
        this.view.show();
    };
    WinFieldModule.prototype.onFreeSpinsOutroFinished = function () {
        this.view.show();
    };
    WinFieldModule.prototype.onStartScreenIntroStarted = function () {
        this.view.setReelsContainerAlphaToZero();
    };
    WinFieldModule.prototype.onTransitionAnimationStarted = function () {
        this.view.playReelContainerTransition();
    };
    WinFieldModule.prototype.onInitialWinPresentationStarted = function () {
        this.view.fadeOutWinValue();
    };
    WinFieldModule.prototype.onWinHighlightStarted = function (eventID, totalTimer) {
        var logic = this.logic;
        this.view.countup(logic.getNextAvalancheRunningTotalInCents(), totalTimer);
    };
    WinFieldModule.prototype.onSpinStarted = function () {
        this.view.zeroWin();
        this.view.fadeInWinValue();
    };
    return WinFieldModule;
}(Module_1.Module));
exports.WinFieldModule = WinFieldModule;


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var View_1 = __webpack_require__(3);
var Easing_1 = __webpack_require__(16);
var Tween_1 = __webpack_require__(19);
var WinNumbers_1 = __webpack_require__(45);
var WinFieldConstants_1 = __webpack_require__(573);
var BackgroundView_1 = __webpack_require__(91);
var WinFieldWinNumbers_1 = __webpack_require__(574);
var WinFieldWinMeter_1 = __webpack_require__(575);
var WinFieldView = /** @class */ (function (_super) {
    __extends(WinFieldView, _super);
    function WinFieldView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._currentWinNumber = 0;
        return _this;
    }
    WinFieldView.prototype.init = function () {
        _super.prototype.init.call(this);
        this.setupWinField();
        this.setupWinNumberText();
        this.createMeter();
        this.container.addChild(this._winField);
    };
    WinFieldView.prototype.setupWinField = function () {
        this._winField = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'WIN_PRESENTATION.png'));
        var pos = this.layout.getAbsolutePosition('WIN_FIELD');
        this._winField.position.set(pos.x, pos.y);
        this._winField.anchor.set(0.5);
        var winText = new PIXI.Sprite(this.resources.getLocaleTextImage('WIN_FIELD_TEXT.png'));
        if (this.device.isMobile) {
            winText.anchor.set(0.5);
        }
        else {
            winText.anchor.set(1, 0.5);
        }
        var winTextPos = this.layout.getPosition('WIN_FIELD_TEXT');
        winText.position.set(winTextPos.x, winTextPos.y);
        this._winField.addChild(winText);
    };
    WinFieldView.prototype.setupWinNumberText = function () {
        var winNumberFont = WinFieldConstants_1.WinFieldConstants.WIN_NUMBER_FONT_NAME;
        var numberSprite = new PIXI.Sprite(this.resources.getSpritesheetTexture('NUMBERS.json', winNumberFont + "0.png"));
        var spriteWidth = numberSprite.width;
        if (this.device.isMobile) {
            this._winNumberText = new WinNumbers_1.WinNumbers(this.resources, winNumberFont);
        }
        else {
            this._winNumberText = new WinFieldWinNumbers_1.WinFieldWinNumbers(this.resources, winNumberFont);
        }
        this._winNumberText.currencyIDPrefix = WinFieldConstants_1.WinFieldConstants.CURRENCY_FONT_NAME;
        this._winNumberText.currencyISO = this.currencyFormatter.currency;
        this._winNumberText.currencySign = this.currencyFormatter.currencySign;
        this._winNumberText.numberAnchor = { x: 0.0, y: 0.5 };
        this.adjustCurrencyOffset();
        this._winNumberText.numberKerning = -10;
        var winTextNumberPos = this.layout.getPosition('WIN_FIELD_NUMBER');
        this._winNumberText.position.set(winTextNumberPos.x - spriteWidth * WinFieldConstants_1.WinFieldConstants.SCALE_TO_FIT_BOX / 2, winTextNumberPos.y);
        this._winField.addChild(this._winNumberText);
    };
    WinFieldView.prototype.adjustCurrencyOffset = function () {
        var currency = this.currencyFormatter.currency;
        if (currency === 'EUR' || currency === 'GBP' || currency === 'MYR' || currency === 'THB'
            || currency === 'JPY' || currency === 'BOB' || currency === 'CAD' || currency === 'CHF'
            || currency === 'CNY' || currency === 'COP' || currency === 'ARS' || currency === 'AUD'
            || currency === 'DKK' || currency === 'GHS' || currency === 'HKD' || currency === 'ILS'
            || currency === 'KES' || currency === 'MMK' || currency === 'MXN' || currency === 'NOK'
            || currency === 'NZD' || currency === 'PEN' || currency === 'PHP' || currency === 'RWF'
            || currency === 'SGD' || currency === 'TWD' || currency === 'ZAR') {
            this._winNumberText.currencyOffset = { x: 0, y: 0 };
        }
        else if (currency === 'PKR') {
            this._winNumberText.currencyOffset = { x: 0, y: 0 };
        }
        else if (currency === 'PLN' || currency === 'SEK') {
            this._winNumberText.currencyOffset = { x: 0, y: 0 };
        }
        else if (currency === 'CZK' || currency === 'HRK' || currency === 'HUF' || currency === 'RUB') {
            this._winNumberText.currencyOffset = { x: 0, y: 0 };
        }
        else {
            this._winNumberText.currencyOffset = { x: 0, y: 15 };
        }
    };
    WinFieldView.prototype.createMeter = function () {
        this._meter = new WinFieldWinMeter_1.WinFieldWinMeter(this._winNumberText, Easing_1.Easing.Linear.None, this.currencyFormatter, true, WinFieldConstants_1.WinFieldConstants.SCALE_TO_FIT_BOX);
        this._meter.set(0);
    };
    WinFieldView.prototype.scaleInWinValue = function () {
        var scalingTween = new Tween_1.Tween(this._winNumberText.scale)
            .to({ x: WinFieldConstants_1.WinFieldConstants.SCALING_TO_VALUE, y: WinFieldConstants_1.WinFieldConstants.SCALING_TO_VALUE }, 250)
            .start();
        this.updateManager.add(scalingTween);
    };
    WinFieldView.prototype.scaleOutWinValue = function () {
        var scalingTween = new Tween_1.Tween(this._winNumberText.scale)
            .to({ x: WinFieldConstants_1.WinFieldConstants.SCALE_TO_FIT_BOX, y: WinFieldConstants_1.WinFieldConstants.SCALE_TO_FIT_BOX }, 250)
            .start();
        this.updateManager.add(scalingTween);
    };
    WinFieldView.prototype.fadeOutWinValue = function () {
        var fadingTween = new Tween_1.Tween(this._winNumberText).to({ alpha: 0 }, 500).start();
        this.updateManager.add(fadingTween);
    };
    WinFieldView.prototype.fadeInWinValue = function () {
        this._winNumberText.alpha = 1;
    };
    WinFieldView.prototype.zeroWin = function () {
        this._meter.set(0);
        this._currentWinNumber = 0;
    };
    WinFieldView.prototype.countup = function (toValue, time) {
        this._meter.stop();
        this._meter = null;
        this.scaleInWinValue();
        this._meter = new WinFieldWinMeter_1.WinFieldWinMeter(this._winNumberText, Easing_1.Easing.Linear.None, this.currencyFormatter, true, WinFieldConstants_1.WinFieldConstants.SCALE_TO_FIT_BOX);
        this._meter.from(this._currentWinNumber).to(toValue, time).start();
        this._meter.onCompleteCallback = this.scaleOutWinValue.bind(this);
        this.updateManager.add(this._meter);
        this._currentWinNumber = toValue;
    };
    WinFieldView.prototype.setReelsContainerAlphaToZero = function () {
        this.container.alpha = 0;
    };
    WinFieldView.prototype.playReelContainerTransition = function () {
        var appearTween = new Tween_1.Tween(this.container)
            .to({ alpha: 1.0 }, BackgroundView_1.BackgroundView.TRANSFER_TIME)
            .start();
        this.updateManager.add(appearTween);
    };
    return WinFieldView;
}(View_1.View));
exports.WinFieldView = WinFieldView;


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var WinFieldConstants = /** @class */ (function () {
    function WinFieldConstants() {
    }
    WinFieldConstants.SCALE_TO_FIT_BOX = 0.35;
    WinFieldConstants.SCALING_TO_VALUE = 0.5;
    WinFieldConstants.WIN_NUMBER_FONT_NAME = 'SMALL_';
    WinFieldConstants.CURRENCY_FONT_NAME = 'MED_';
    return WinFieldConstants;
}());
exports.WinFieldConstants = WinFieldConstants;


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var WinNumbers_1 = __webpack_require__(45);
var WinFieldWinNumbers = /** @class */ (function (_super) {
    __extends(WinFieldWinNumbers, _super);
    function WinFieldWinNumbers(resources, symbolIDPrefix, texture) {
        var _this = _super.call(this, resources, symbolIDPrefix, texture) || this;
        _this._numbersContainer.anchor.set(0.0, 0.5);
        _this._autoCenterMyself = false;
        return _this;
    }
    return WinFieldWinNumbers;
}(WinNumbers_1.WinNumbers));
exports.WinFieldWinNumbers = WinFieldWinNumbers;


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var WinMeter_1 = __webpack_require__(113);
var WinFieldWinMeter = /** @class */ (function (_super) {
    __extends(WinFieldWinMeter, _super);
    function WinFieldWinMeter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WinFieldWinMeter.prototype.onUpdate = function () {
        if (this._winText) {
            if (this._valueWrapper.value === 0) {
                this._winText.visible = false;
            }
            else {
                this._winText.visible = true;
                this._winText.showNumber(this.format(this._valueWrapper.value, this._includeCurrencySign));
            }
            if (this._resolutionWidth && this._autoFitWinNumbers) {
                this.checkBounds();
            }
        }
    };
    return WinFieldWinMeter;
}(WinMeter_1.WinMeter));
exports.WinFieldWinMeter = WinFieldWinMeter;


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var SoundPlayer_1 = __webpack_require__(144);
var GameSoundPlayer = /** @class */ (function (_super) {
    __extends(GameSoundPlayer, _super);
    function GameSoundPlayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._musicToPlaySimult = [
            'mainMusic1',
            'mainMusic2',
            'mainMusic3',
        ];
        _this._isMainMusicStarted = false;
        return _this;
    }
    GameSoundPlayer.prototype.startAllMusic = function () {
        for (var _i = 0, _a = this._musicToPlaySimult; _i < _a.length; _i++) {
            var musName = _a[_i];
            var music = this._soundManager.getMusic(musName);
            if (music) {
                music.loop = true;
                music.volume = 0;
                music.play();
            }
        }
    };
    GameSoundPlayer.prototype.stopMusic = function () {
        for (var _i = 0, _a = this._musicToPlaySimult; _i < _a.length; _i++) {
            var musName = _a[_i];
            var music = this._soundManager.getMusic(musName);
            if (music) {
                music.stop();
            }
        }
        _super.prototype.stopMusic.call(this);
        this._isMainMusicStarted = false;
    };
    GameSoundPlayer.prototype.fadeCurrentMusicTo = function (musicID, transitionDuration) {
        if (transitionDuration === void 0) { transitionDuration = null; }
        if (!this._isMainMusicStarted) {
            this._isMainMusicStarted = true;
            this.startAllMusic();
        }
        _super.prototype.fadeCurrentMusicTo.call(this, musicID, transitionDuration);
    };
    GameSoundPlayer.prototype.restoreGameMusic = function (logic) {
        // NO OP
    };
    return GameSoundPlayer;
}(SoundPlayer_1.SoundPlayer));
exports.GameSoundPlayer = GameSoundPlayer;


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var BigWinView_1 = __webpack_require__(119);
var BigWinModule_1 = __webpack_require__(96);
var BigWinEvents_1 = __webpack_require__(21);
var BigWinFinalState = /** @class */ (function (_super) {
    __extends(BigWinFinalState, _super);
    function BigWinFinalState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BigWinFinalState.prototype.onEnterState = function () {
        this.emit(BigWinEvents_1.BigWinEvents.COUNTUP_FINISHED);
        this.view.playBigWinEnd();
    };
    BigWinFinalState.prototype.onLeaveState = function () {
    };
    BigWinFinalState.prototype.setupEvents = function () {
        this.on(BigWinView_1.BigWinView.SKIP_CLICKED, this.onFinishBigWin);
        this.on(BigWinView_1.BigWinView.END_ANIMATION_FINISHED, this.onEndAnimationFinished);
    };
    BigWinFinalState.prototype.onFinishBigWin = function () {
        this.view.playEndingEndAnimation();
    };
    BigWinFinalState.prototype.onEndAnimationFinished = function () {
        this.module.soundPlayer.restoreGameMusic(this.module.logic);
        this.emit(BigWinEvents_1.BigWinEvents.FINISHED);
        this.module.gotoState(BigWinModule_1.BigWinModule.BASIC_STATE);
    };
    return BigWinFinalState;
}(ModuleState_1.ModuleState));
exports.BigWinFinalState = BigWinFinalState;


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var GameBigWinPlayingState_1 = __webpack_require__(298);
var BigWinEvents_1 = __webpack_require__(21);
var GameBigWinPlayingMultiplierState = /** @class */ (function (_super) {
    __extends(GameBigWinPlayingMultiplierState, _super);
    function GameBigWinPlayingMultiplierState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameBigWinPlayingMultiplierState.prototype.onEnterState = function () {
        this.emit(BigWinEvents_1.BigWinEvents.ON_BEFORE_BIG_WIN);
        var logic = this.module.logic;
        var winStart = logic.getLastAvalancheRunningTotal();
        var win = logic.currentSpinWin;
        this.view.startWithMultiplier(winStart, win, this.getBigWinLevelFromWinNumber(win));
        this.emit(BigWinEvents_1.BigWinEvents.STARTED);
        this.emit(BigWinEvents_1.BigWinEvents.COUNTUP_STARTED);
    };
    return GameBigWinPlayingMultiplierState;
}(GameBigWinPlayingState_1.GameBigWinPlayingState));
exports.GameBigWinPlayingMultiplierState = GameBigWinPlayingMultiplierState;


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BigWinBasicState_1 = __webpack_require__(296);
var BigWinModule_1 = __webpack_require__(96);
var GameBigWinModule_1 = __webpack_require__(295);
var GameBigWinBasicState = /** @class */ (function (_super) {
    __extends(GameBigWinBasicState, _super);
    function GameBigWinBasicState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameBigWinBasicState.prototype.onBigWinWon = function () {
        var logic = this.module.logic;
        if (logic.getLastAvalancheMultiplier() > 1) {
            this.module.gotoState(GameBigWinModule_1.GameBigWinModule.PLAYINGMULTIPLIER_STATE);
        }
        else {
            this.module.gotoState(BigWinModule_1.BigWinModule.PLAYING_STATE);
        }
    };
    return GameBigWinBasicState;
}(BigWinBasicState_1.BigWinBasicState));
exports.GameBigWinBasicState = GameBigWinBasicState;


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BigWinView_1 = __webpack_require__(119);
var WinMeter_1 = __webpack_require__(113);
var Easing_1 = __webpack_require__(16);
var WinNumbers_1 = __webpack_require__(45);
var GameBigWinView = /** @class */ (function (_super) {
    __extends(GameBigWinView, _super);
    function GameBigWinView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameBigWinView.prototype.startWithMultiplier = function (fromNumber, winValue, bigWinLevel) {
        this.killAllAnimations();
        this._currentWin = winValue;
        this._bigWinLevel = bigWinLevel;
        this._currentLevel = 1;
        this._isPlayingEndingEnd = false;
        this.show();
        this.initMeterWithMultiplier(fromNumber, winValue);
        this.startInitialAnimationsWithMultiplier();
        this.showNumber("" + fromNumber);
        this.startCounting();
        this.addMeterInto();
        this.addCurrentText();
    };
    GameBigWinView.prototype.setupWinNumber = function () {
        var winNumberFont = this.getFontSize(this.device.isMobile);
        this._winNumber = new WinNumbers_1.WinNumbers(this.resources, winNumberFont);
        this._winNumber.currencyISO = this.currencyFormatter.currency;
        this._winNumber.currencySign = this.currencyFormatter.currencySign;
        this.adjustCurrencyOffset();
        this.container.addChild(this._winNumber);
    };
    GameBigWinView.prototype.adjustCurrencyOffset = function () {
        var currency = this.currencyFormatter.currency;
        if (currency === 'EUR' || currency === 'GBP' || currency === 'MYR' || currency === 'THB'
            || currency === 'JPY' || currency === 'BOB' || currency === 'CAD' || currency === 'CHF'
            || currency === 'CNY' || currency === 'COP' || currency === 'ARS' || currency === 'AUD'
            || currency === 'DKK' || currency === 'GHS' || currency === 'HKD' || currency === 'ILS'
            || currency === 'KES' || currency === 'MMK' || currency === 'MXN' || currency === 'NOK'
            || currency === 'NZD' || currency === 'PEN' || currency === 'PHP' || currency === 'RWF'
            || currency === 'SGD' || currency === 'TWD' || currency === 'ZAR') {
            this._winNumber.currencyOffset = { x: this.device.isMobile ? -20 : -20, y: 0 };
        }
        else if (currency === 'PKR') {
            this._winNumber.currencyOffset = { x: -20, y: 0 };
        }
        else if (currency === 'PLN' || currency === 'SEK') {
            this._winNumber.currencyOffset = { x: -20, y: 0 };
        }
        else if (currency === 'CZK' || currency === 'HRK' || currency === 'HUF' || currency === 'RUB') {
            this._winNumber.currencyOffset = { x: -20, y: 0 };
        }
        else {
            this._winNumber.currencyOffset = { x: 0, y: 10 };
        }
    };
    GameBigWinView.prototype.initMeterWithMultiplier = function (fromValue, toValue) {
        this._meter = new WinMeter_1.WinMeter(this._winNumber, Easing_1.Easing.Cubic.Out, this.currencyFormatter, true);
        // this._meter.setTextAdditionalOffsets(0, -25);
        this._meter.onCompleteCallback = this.onMeterFinished.bind(this);
        this._meter.from(fromValue).to(toValue, this.getCountingTime());
        this._meter.resolutionWidth = this.resolutionManager.resolution.width;
    };
    GameBigWinView.prototype.addMeterInto = function () {
        var container = this.spineUtils.findSlotContainerByName(this._currentAnimation.container, 'WIN_NUMBER');
        this._winNumber.rotation = Math.PI;
        this._winNumber.skew.y = Math.PI;
        this._winNumber.anchor.set(0.5, 0.5);
        this._winNumber.numberAnchor = { x: 0.0, y: 0.5 };
        this._winNumber.numberKerning = -25;
        container.removeChildren();
        container.addChild(this._winNumber);
    };
    GameBigWinView.prototype.startInitialAnimationsWithMultiplier = function () {
        var _this = this;
        this._backgroundAnimation = this.spineUtils
            .startSpineAnimationCreation('BIG_WINS_GLOW.json', 'START', false)
            .position(this.bigWinScreenPosition.x, this.bigWinScreenPosition.y)
            .chainIdleAnimation("IDLE" + this.getCurrentLevelAnimationPostfix())
            .container(this._backgroundContainer)
            .createAndStart();
        this._currentAnimation = this.spineUtils
            .startSpineAnimationCreation('BIG_WINS.json', 'START_MULTIPLIER', false)
            .position(this.bigWinScreenPosition.x, this.bigWinScreenPosition.y)
            .chainIdleAnimation("IDLE" + this.getCurrentLevelAnimationPostfix())
            .container(this._foregroundContainer)
            .onComplete(function () {
            _this.playBigWinLoop();
            _this.emit(BigWinView_1.BigWinView.BIG_WIN_STARTED);
        })
            .createAndStart();
        var currentEffectIndex = 1;
        var hasMoreEffects = this.resources.hasSpine("BIG_WINS_EFFECT_0" + currentEffectIndex + ".json");
        while (hasMoreEffects) {
            var effect = this.spineUtils
                .startSpineAnimationCreation("BIG_WINS_EFFECT_0" + currentEffectIndex + ".json", 'START', false)
                .position(this.bigWinScreenPosition.x, this.bigWinScreenPosition.y)
                .chainIdleAnimation("IDLE" + this.getCurrentLevelAnimationPostfix())
                .container(this.getEffectContainer(currentEffectIndex))
                .createAndStart();
            this._effectAnimation.push(effect);
            currentEffectIndex++;
            hasMoreEffects = this.resources.hasSpine("BIG_WINS_EFFECT_0" + currentEffectIndex + ".json");
        }
    };
    GameBigWinView.prototype.getEffectContainer = function (effectIndex) {
        return this._middleContainer;
    };
    return GameBigWinView;
}(BigWinView_1.BigWinView));
exports.GameBigWinView = GameBigWinView;


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var FreeSpinsModule_1 = __webpack_require__(97);
var GameFreeSpinsOutroState_1 = __webpack_require__(585);
var GameFreeSpinsIntroState_1 = __webpack_require__(586);
var GameFreeSpinsModule = /** @class */ (function (_super) {
    __extends(GameFreeSpinsModule, _super);
    function GameFreeSpinsModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameFreeSpinsModule.prototype.restore = function () {
        _super.prototype.restore.call(this);
        if (this.logic.isFreeSpinsStarted) {
            this.logic.goIntoFreeSpins();
        }
    };
    GameFreeSpinsModule.prototype.setupStates = function () {
        _super.prototype.setupStates.call(this);
        this.addState(new GameFreeSpinsOutroState_1.GameFreeSpinsOutroState(this, FreeSpinsModule_1.FreeSpinsModule.OUTRO_STATE));
        this.addState(new GameFreeSpinsIntroState_1.GameFreeSpinsIntroState(this, FreeSpinsModule_1.FreeSpinsModule.INTRO_STATE));
    };
    return GameFreeSpinsModule;
}(FreeSpinsModule_1.FreeSpinsModule));
exports.GameFreeSpinsModule = GameFreeSpinsModule;


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var FreeSpinsModule_1 = __webpack_require__(97);
var FlowModuleEvents_1 = __webpack_require__(0);
var FreeSpinsBasicState = /** @class */ (function (_super) {
    __extends(FreeSpinsBasicState, _super);
    function FreeSpinsBasicState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FreeSpinsBasicState.prototype.onEnterState = function () {
    };
    FreeSpinsBasicState.prototype.onLeaveState = function () {
    };
    FreeSpinsBasicState.prototype.setupEvents = function () {
        this.on(FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN, this.onFreeSpinWin);
    };
    FreeSpinsBasicState.prototype.onFreeSpinWin = function () {
        this.module.gotoState(FreeSpinsModule_1.FreeSpinsModule.INTRO_STATE);
    };
    return FreeSpinsBasicState;
}(ModuleState_1.ModuleState));
exports.FreeSpinsBasicState = FreeSpinsBasicState;


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var FreeSpinsModule_1 = __webpack_require__(97);
var FlowModuleEvents_1 = __webpack_require__(0);
var FreeSpinsEvents_1 = __webpack_require__(6);
var FreeSpinsProgressState = /** @class */ (function (_super) {
    __extends(FreeSpinsProgressState, _super);
    function FreeSpinsProgressState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._isWaitingForInitialAnimationToFinish = false;
        return _this;
    }
    FreeSpinsProgressState.prototype.onEnterState = function () {
        this.module.logic.isFreeSpinsStarted = true;
    };
    FreeSpinsProgressState.prototype.onLeaveState = function () {
    };
    FreeSpinsProgressState.prototype.setupEvents = function () {
        this.on(FlowModuleEvents_1.FlowModuleEvents.FREE_SPINS_FINISHED, this.onFreeSpinsFinished);
        this.on(FlowModuleEvents_1.FlowModuleEvents.FREESPINS_RETRIGGER_WIN, this.onFreeSpinsRetriggered);
        this.on(FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN, this.onCanSpin);
    };
    FreeSpinsProgressState.prototype.onFreeSpinsRetriggered = function () {
        this.view.showAddedFreespins(this.module.logic.freeSpinsAdded);
    };
    FreeSpinsProgressState.prototype.onCanSpin = function () {
        if (this.module.logic.freeSpinsLeft > 0) {
            this.emit(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPIN_STARTED);
        }
    };
    FreeSpinsProgressState.prototype.onFreeSpinsFinished = function () {
        this.finishFreeSpins();
    };
    FreeSpinsProgressState.prototype.finishFreeSpins = function () {
        this.module.logic.isFreeSpinsStarted = false;
        this.module.gotoState(FreeSpinsModule_1.FreeSpinsModule.OUTRO_STATE);
    };
    return FreeSpinsProgressState;
}(ModuleState_1.ModuleState));
exports.FreeSpinsProgressState = FreeSpinsProgressState;


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var FreeSpinsIntroState_1 = __webpack_require__(162);
var FreeSpinsEvents_1 = __webpack_require__(6);
var FreeSpinsRestoreIntroState = /** @class */ (function (_super) {
    __extends(FreeSpinsRestoreIntroState, _super);
    function FreeSpinsRestoreIntroState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FreeSpinsRestoreIntroState.prototype.onEnterState = function () {
        this.view.setFreeSpinsAmount(this.module.logic.freeSpinsLeft);
        this.view.startFreeSpinsRestoredIntro();
        this.module.logic.startFreeSpinsIntro();
        this.emit(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_RESTORE_INTRO_STARTED);
    };
    return FreeSpinsRestoreIntroState;
}(FreeSpinsIntroState_1.FreeSpinsIntroState));
exports.FreeSpinsRestoreIntroState = FreeSpinsRestoreIntroState;


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var FreeSpinsOutroState_1 = __webpack_require__(299);
var GameFreeSpinsOutroState = /** @class */ (function (_super) {
    __extends(GameFreeSpinsOutroState, _super);
    function GameFreeSpinsOutroState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameFreeSpinsOutroState.prototype.onReelsFadingOutFinished = function () {
        var logic = this.module.logic;
        var freeSpinTotalWin = logic.freeSpinsTotalWin;
        var freeSpinTotalWinInCents = freeSpinTotalWin * 100;
        this.view.showWinSummaryScreen(freeSpinTotalWinInCents);
        logic.goOutOfFreeSpin();
    };
    return GameFreeSpinsOutroState;
}(FreeSpinsOutroState_1.FreeSpinsOutroState));
exports.GameFreeSpinsOutroState = GameFreeSpinsOutroState;


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var FreeSpinsIntroState_1 = __webpack_require__(162);
var GameFreeSpinsIntroState = /** @class */ (function (_super) {
    __extends(GameFreeSpinsIntroState, _super);
    function GameFreeSpinsIntroState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameFreeSpinsIntroState.prototype.onEnterState = function () {
        _super.prototype.onEnterState.call(this);
        this.module.logic.goIntoFreeSpins();
    };
    return GameFreeSpinsIntroState;
}(FreeSpinsIntroState_1.FreeSpinsIntroState));
exports.GameFreeSpinsIntroState = GameFreeSpinsIntroState;


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var FreeSpinsView_1 = __webpack_require__(120);
var WinNumbers_1 = __webpack_require__(45);
var GameFreeSpinsView = /** @class */ (function (_super) {
    __extends(GameFreeSpinsView, _super);
    function GameFreeSpinsView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameFreeSpinsView.prototype.replaceInfoElementComponents = function () {
        _super.prototype.replaceInfoElementComponents.call(this);
        this.addWonFreeSpinsNumber(this._freeSpins);
    };
    GameFreeSpinsView.prototype.addWonFreeSpinsNumber = function (wonFreeSpins) {
        if (!(wonFreeSpins === 10 || wonFreeSpins === 15 || wonFreeSpins === 20)) {
            wonFreeSpins = 10; // TODO: temporary
        }
        var title = new PIXI.Sprite(this.resources.getLocaleTextImage("AWARDED_" + wonFreeSpins + "_FS.png"));
        this.spineUtils.replaceElementInSpineMultiTrack(this._currentFeatureAnimation, "FREE_SPINS_FEATURE_1_1_NUMBER", title);
    };
    GameFreeSpinsView.prototype.showAddedFreespins = function (addedFreeSpins) {
        var _this = this;
        var animation = this.spineUtils.startSpineAnimationCreation('TEXT_ANNOUNCEMENT.json', 'POP_UP', false)
            .position(this.layout.getAbsolutePosition('POPUP_SCREEN'))
            .onComplete(function () {
            _this.emit(FreeSpinsView_1.FreeSpinsView.RETRIGGER_FINISHED);
        })
            .createAndStart();
        animation.timeScale = 0.6;
        var retriggetText = this.createFreeSpinsRetriggerText(addedFreeSpins);
        this.spineUtils.replaceElementInSpineAnimation(animation, 'NUMBER', retriggetText);
        var bounds = retriggetText.getLocalBounds();
        var scale = Math.min(1, (this.resolutionManager.resolution.width * 0.9) / bounds.width);
        retriggetText.scale.set(scale, -scale);
        retriggetText.x = -bounds.width * scale / 2;
        retriggetText.y = bounds.height * scale / 2;
        this.emit(FreeSpinsView_1.FreeSpinsView.RETRIGGER_STARTED);
    };
    GameFreeSpinsView.prototype.createFreeSpinsRetriggerText = function (addFreeSpins) {
        var fullText = new PIXI.Sprite();
        var plus = new PIXI.Sprite(this.resources.getSpritesheetTexture('NUMBERS.json', "LARGE_PLUS.png"));
        fullText.addChild(plus);
        if (!(addFreeSpins === 10 || addFreeSpins === 15 || addFreeSpins === 20)) {
            addFreeSpins = 10; // TODO: temporary
        }
        var number = new PIXI.Sprite(this.resources.getLocaleTextImage("AWARDED_" + addFreeSpins + "_FS.png"));
        fullText.addChild(number);
        number.position.x += plus.width;
        var freespins = new PIXI.Sprite(this.resources.getLocaleTextImage("FREESPINS_RETRIGGER.png"));
        fullText.addChild(freespins);
        freespins.position.x += plus.width + number.width;
        var maxHeight = Math.max.apply(Math, fullText.children.map(function (child) { return child.height; }));
        fullText.children.forEach(function (child) {
            child.y = (maxHeight - child.height) * 0.5;
        });
        return fullText;
    };
    GameFreeSpinsView.prototype.showWinSummaryScreen = function (totalWin, maximumSizeInPixels) {
        var _this = this;
        this.killWinSummaryScreen();
        if (totalWin === 0) {
            this._winSummaryScreenAnimation = this.spineUtils
                .startSpineAnimationCreation('FREESPIN_COMPLETE_SCREEN.json', 'START', false)
                .chainIdleAnimation('IDLE')
                .onComplete(function () {
                _this.emit(FreeSpinsView_1.FreeSpinsView.SHOWING_WIN_SUMMARY_SCREEN);
            })
                .position(this.resolutionManager.halfResolution.width, this.resolutionManager.halfResolution.height)
                .container(this.container)
                .createAndStart();
            var textImage = this.getLocaleTextImage('FREESPIN_COMPLETE');
            this.spineUtils.replaceElementInSpineAnimation(this._winSummaryScreenAnimation, 'TEXT', textImage);
            this.adjustWinScreenLocalizedScale(textImage, true);
        }
        else {
            this._winSummaryScreenAnimation = this.spineUtils
                .startSpineAnimationCreation('WIN_SCREEN.json', 'START', false)
                .chainIdleAnimation('IDLE')
                .onComplete(function () {
                _this.emit(FreeSpinsView_1.FreeSpinsView.SHOWING_WIN_SUMMARY_SCREEN);
                _this.fitElementIntoScreen(winAmount_1);
            })
                .position(this.resolutionManager.halfResolution.width, this.resolutionManager.halfResolution.height)
                .container(this.container)
                .createAndStart();
            var textImage = this.getLocaleTextImage('WIN_SCREEN');
            this.spineUtils.replaceElementInSpineAnimation(this._winSummaryScreenAnimation, 'TEXT', textImage);
            this.adjustWinScreenLocalizedScale(textImage, false);
            var winAmount_1 = new WinNumbers_1.WinNumbers(this.resources, this.getWinnumberSize(this.device.isMobile));
            winAmount_1.currencyISO = this.currencyFormatter.currency;
            winAmount_1.currencySign = this.currencyFormatter.currencySign;
            winAmount_1.numberAnchor.y = 0.5;
            winAmount_1.numberKerning = -15;
            winAmount_1.showNumber(this.currencyFormatter.formatCurrencyApi(totalWin));
            this.spineUtils.replaceElementInSpineAnimation(this._winSummaryScreenAnimation, 'NUMBER', winAmount_1);
            this.fitElementIntoScreen(winAmount_1);
        }
        this._exitButton = this.spineUtils.createSpineButton('FREESPIN_BUTTON.json', this.onExitWinSummaryButtonClicked.bind(this), true, false, false, false);
        var playPosition = this.spineUtils.getBoneAbsolutePosition(this.resources.getSpine('FREESPIN_STARTSCREEN.json'), 'PLAY_BUTTON');
        playPosition.y *= -1;
        this.container.addChild(this._exitButton);
        this._exitButton.position.set(playPosition.x, playPosition.y);
        this.soundPlayer.play('freeSpinsExit');
    };
    Object.defineProperty(GameFreeSpinsView.prototype, "numberElementLimit", {
        get: function () {
            return this.resolutionManager.resolution.width * 0.65;
        },
        enumerable: true,
        configurable: true
    });
    return GameFreeSpinsView;
}(FreeSpinsView_1.FreeSpinsView));
exports.GameFreeSpinsView = GameFreeSpinsView;


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var RecodeIntegrator_1 = __webpack_require__(589);
var RecodeFakeCommunicator = /** @class */ (function (_super) {
    __extends(RecodeFakeCommunicator, _super);
    function RecodeFakeCommunicator() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._savedSpins = [];
        _this._fakeResponses = [];
        _this._fakeFSResponses = [];
        return _this;
    }
    RecodeFakeCommunicator.prototype.addFakeFSResponse = function (response) {
        this._fakeFSResponses.push(response);
    };
    RecodeFakeCommunicator.prototype.addFakeResponse = function (response) {
        this._fakeResponses.push(response);
    };
    RecodeFakeCommunicator.prototype.addInitFake = function (response) {
        this._fakeInit = response;
    };
    RecodeFakeCommunicator.prototype.init = function (gameID, callback) {
        var _this = this;
        if (this._fakeInit) {
            setTimeout(function () {
                callback(JSON.parse(_this._fakeInit));
                _this._fakeInit = '';
            }, 100);
        }
        else {
            _super.prototype.init.call(this, gameID, function (jsonData) {
                callback(jsonData);
                _this._savedInit = jsonData;
            });
        }
    };
    RecodeFakeCommunicator.prototype.spin = function (gameID, sessionID, totalBet, callback, freeRoundsData) {
        var _this = this;
        if (this._fakeResponses.length > 0) {
            setTimeout(function () {
                callback(JSON.parse(_this._fakeResponses[0]));
                _this._fakeResponses.splice(0, 1);
            }, 100);
        }
        else {
            _super.prototype.spin.call(this, gameID, sessionID, totalBet, function (jsonData) {
                callback(jsonData);
                _this._savedSpins.push({ spinData: jsonData, isFS: false });
            }, freeRoundsData);
        }
    };
    RecodeFakeCommunicator.prototype.freespin = function (callback) {
        var _this = this;
        if (this._fakeFSResponses.length > 0) {
            setTimeout(function () {
                callback(JSON.parse(_this._fakeFSResponses[0]));
                _this._fakeFSResponses.splice(0, 1);
            }, 100);
        }
        else {
            _super.prototype.freespin.call(this, function (jsonData) {
                callback(jsonData);
                _this._savedSpins.push({ spinData: jsonData, isFS: true });
            });
        }
    };
    RecodeFakeCommunicator.prototype.pick = function (chestIndex, callback, callbackObj, freeRoundsData) {
        var _this = this;
        if (this._fakeResponses.length > 0) {
            setTimeout(function () {
                callback(JSON.parse(_this._fakeResponses[0]));
                _this._fakeResponses.splice(0, 1);
            }, 100);
        }
        else {
            _super.prototype.pick.call(this, chestIndex, callback, callbackObj, freeRoundsData);
        }
    };
    RecodeFakeCommunicator.prototype.skippick = function (chestIndex, callback, callbackObj, freeRoundsData) {
        var _this = this;
        if (this._fakeResponses.length > 0) {
            setTimeout(function () {
                callback(JSON.parse(_this._fakeResponses[0]));
                _this._fakeResponses.splice(0, 1);
            }, 100);
        }
        else {
            _super.prototype.skippick.call(this, chestIndex, callback, callbackObj, freeRoundsData);
        }
    };
    RecodeFakeCommunicator.prototype.openChest = function (chestIndex, callback, callbackObj, freeRoundsData) {
        var _this = this;
        if (this._fakeResponses.length > 0) {
            setTimeout(function () {
                callback(JSON.parse(_this._fakeResponses[0]));
                _this._fakeResponses.splice(0, 1);
            }, 100);
        }
        else {
            _super.prototype.openChest.call(this, chestIndex, callback, callbackObj, freeRoundsData);
        }
    };
    RecodeFakeCommunicator.prototype.createSavedStuffFakes = function () {
        var finalText = '';
        if (this._savedInit) {
            finalText += "communicator.addInitFake('" + JSON.stringify(this._savedInit) + "');\n";
        }
        for (var _i = 0, _a = this._savedSpins; _i < _a.length; _i++) {
            var response = _a[_i];
            if (response.isFS) {
                finalText += "communicator.addFakeFSResponse('" + JSON.stringify(response.spinData) + "');\n";
            }
            else {
                finalText += "communicator.addFakeResponse('" + JSON.stringify(response.spinData) + "');\n";
            }
        }
        console.log(finalText);
    };
    return RecodeFakeCommunicator;
}(RecodeIntegrator_1.RecodeIntegrator));
exports.RecodeFakeCommunicator = RecodeFakeCommunicator;


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Communicator_1 = __webpack_require__(149);
var http = __webpack_require__(300);
var RecodeIntegrator = /** @class */ (function (_super) {
    __extends(RecodeIntegrator, _super);
    function RecodeIntegrator(vApi) {
        var _this = _super.call(this) || this;
        _this.options = {
            host: 'mobilewebserver9-recodedev.installprogram.eu',
            protocol: 'https:',
            path: '/XMan/x.x',
            method: 'POST',
            headers: { 'content-type': 'text/xml' },
        };
        _this._version = 5;
        // Described in the FAQ from ReCode.
        _this._mid = window.mgsCasinoParams.moduleID;
        _this._cid = window.mgsCasinoParams.clientID;
        _this._sid = window.mgsCasinoParams.casinoID;
        _this._vApi = vApi.API;
        _this.subscribe();
        return _this;
    }
    RecodeIntegrator.prototype.ping = function () { };
    RecodeIntegrator.prototype.requestSavedData = function () { };
    RecodeIntegrator.prototype.init = function (gameID, callback) {
        this.refresh(this._mid, this._cid, callback, null);
    };
    RecodeIntegrator.prototype.saveData = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        throw new Error('Method not implemented.');
    };
    RecodeIntegrator.prototype.getAutoplayData = function () {
        return this.vApi.Autoplay.getConfig();
    };
    RecodeIntegrator.prototype.sendRequest = function (writeString, callback) {
        var cb = function (response) {
            var str = '';
            response.on('data', function (chunk) {
                str += chunk;
            });
            response.on('end', function () {
                // console.log(str);
                callback(str);
            });
        };
        var req = http.request(this.options, cb);
        req.write(writeString);
        req.end();
    };
    RecodeIntegrator.prototype.buildPacketConfig = function (verb, mid, cid, basePacket) {
        var packetConfig = {
            verb: verb,
            mid: mid,
            cid: cid,
            pktAttributes: {
                version: this._version,
            },
            basePkt: "" + basePacket,
        };
        return packetConfig;
    };
    RecodeIntegrator.prototype.freeSpin = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
    };
    // public showBonusBubble(): void {
    // This is handled in InfoModule as it is related to the viewable balance object.
    // }
    RecodeIntegrator.prototype.spin = function (gameID, sessionID, betValue, callback, freeRoundsData) {
        var chipSize = 0;
        var numChips = 0;
        if (betValue) {
            chipSize = betValue.chipSize;
            numChips = betValue.numChips;
        }
        var basePacket;
        if (freeRoundsData) {
            basePacket = "<Request verbex=\"Spin\" chipSize=\"" + freeRoundsData.betData.chipSize + "\" numChips=\"" + freeRoundsData.betData.numChips + "\" offerId=\"" + freeRoundsData.offerID + "\" instanceId=\"" + freeRoundsData.instanceID + "\"/>";
        }
        else {
            basePacket = "<Request verbex=\"Spin\" chipSize=\"" + chipSize + "\" numChips=\"" + numChips + "\"/>";
        }
        var packetConfig = this.buildPacketConfig('AdvSlot', this._mid, this._cid, basePacket);
        this.sendPacket(packetConfig, callback, null);
    };
    /**
     *  Initialize data and refreshing the game.
     * @param mid
     * @param cid
     * @param callback
     * @param callbackObj
     */
    RecodeIntegrator.prototype.refresh = function (mid, cid, callback, callbackObj) {
        var basePacket = "<Request verbex='Refresh'/>";
        var packetConfig = this.buildPacketConfig('AdvSlot', mid, cid, basePacket);
        this.sendPacket(packetConfig, callback, callbackObj);
    };
    RecodeIntegrator.prototype.respin = function (mid, cid, callback, callbackObj) { };
    RecodeIntegrator.prototype.freespin = function (callback) {
        var basePacket = "<Request verbex='FreeSpin'/>";
        var packetConfig = this.buildPacketConfig('AdvSlot', this._mid, this._cid, basePacket);
        this.sendPacket(packetConfig, callback, null);
    };
    RecodeIntegrator.prototype.pick = function (chestIndex, callback, callbackObj, freeRoundsData) {
        var basePacket;
        if (freeRoundsData) {
            basePacket = "<Request verbex='Bonus' bonusName='ChestBonus' action='2' id='" + chestIndex + "' offerId='" + freeRoundsData.offerID + "' instanceId='" + freeRoundsData.instanceID + "'/>";
        }
        else {
            basePacket = "<Request verbex='Bonus' bonusName='ChestBonus' action='2' id='" + chestIndex + "'/>";
        }
        var packetConfig = this.buildPacketConfig('AdvSlot', this._mid, this._cid, basePacket);
        this.sendPacket(packetConfig, callback, callbackObj);
    };
    RecodeIntegrator.prototype.skippick = function (chestIndex, callback, callbackObj, freeRoundsData) {
        var basePacket;
        if (freeRoundsData) {
            basePacket = "<Request verbex='Bonus' bonusName='ChestBonus' action='1' id='" + chestIndex + "' offerId='" + freeRoundsData.offerID + "' instanceId='" + freeRoundsData.instanceID + "'/>";
        }
        else {
            basePacket = "<Request verbex='Bonus' bonusName='ChestBonus' action='1' id='" + chestIndex + "'/>";
        }
        var packetConfig = this.buildPacketConfig('AdvSlot', this._mid, this._cid, basePacket);
        this.sendPacket(packetConfig, callback, callbackObj);
    };
    RecodeIntegrator.prototype.openChest = function (chestIndex, callback, callbackObj, freeRoundsData) {
        var basePacket;
        if (freeRoundsData) {
            basePacket = "<Request verbex='Bonus' bonusName='ChestBonus' action='0' id='" + chestIndex + "' offerId='" + freeRoundsData.offerID + "' instanceId='" + freeRoundsData.instanceID + "'/>";
        }
        else {
            basePacket = "<Request verbex='Bonus' bonusName='ChestBonus' action='0' id='" + chestIndex + "'/>";
        }
        var packetConfig = this.buildPacketConfig('AdvSlot', this._mid, this._cid, basePacket);
        this.sendPacket(packetConfig, callback, callbackObj);
    };
    RecodeIntegrator.prototype.avalanche = function (mid, cid, callback, callbackObj) { };
    RecodeIntegrator.prototype.rejectFreeGames = function (offerID, instanceID, callback, callbackObj) {
        var basePacket = "<Request verbex='RejectFreeGames'><FreeGames><FreeGame offerId='" + offerID + "' instanceId='" + instanceID + "' /></FreeGames></Request>";
        var packetConfig = this.buildPacketConfig('AdvSlot', this._mid, this._cid, basePacket);
        this.sendPacket(packetConfig, callback, callbackObj);
    };
    // Api communication.
    RecodeIntegrator.prototype.api_balanceUpdate = function (playerBalance) {
        //  This should be when the change in
        // balance needs to be displayed (e.g.
        // spin started, count-up has completed).
        var event = this.getEventsList().balanceUpdate;
        this.sendEvent(event, playerBalance);
    };
    RecodeIntegrator.prototype.api_betSizeUpdate = function (betSizeAmount) {
        // This should be when the change in bet
        // needs to be displayed (e.g. player
        // changes bet in console).
        var event = this.getEventsList().betSizeUpdate;
        this.sendEvent(event, betSizeAmount);
    };
    RecodeIntegrator.prototype.api_gameplayStart = function () {
        // This would be as soon as an event
        // has started in game that should block
        // interaction, (e.g. spin button being
        // clicked, free spins has started, gamble
        // feature has started, etc.).
        var event = this.getEventsList().gameplayStart;
        this.sendEvent(event);
    };
    RecodeIntegrator.prototype.api_gameplayPause = function () {
        //         This would be as soon as an event
        // which blocked interaction in the game
        // has completed, (e.g. spin has resolved
        // and result has been shown, free spins
        // has completed, gamble feature has
        // completed, etc.).
        var event = this.getEventsList().gameplayPause;
        this.sendEvent(event);
    };
    RecodeIntegrator.prototype.api_playerInformationRecieved = function (playersBalance) {
        //         This should be when the refresh
        // packet has been received.
        var event = this.getEventsList().playerInformationRecieved;
        this.sendEvent(event, playersBalance);
    };
    RecodeIntegrator.prototype.api_gameSetMute = function (setMute) {
        //         This should be when the mute option
        // has changed.
        // Also set V.API.Core.muteSound to current value.
        this.vApi.Core.muteSound(setMute);
        var event = this.getEventsList().gameSetMute;
        this.sendEvent(event, !setMute); // Invert the value since they are using the inverted value. False : muted, True : unmuted.
    };
    RecodeIntegrator.prototype.api_winUpdate = function (winAmount) {
        // This should be when the win amount
        // needs to be displayed (e.g. count-up
        // has completed).
        var event = this.getEventsList().winUpdate;
        this.sendEvent(event, winAmount);
    };
    RecodeIntegrator.prototype.api_gamemenuOpen = function () {
        // Sent when the hamburger menu in
        // Play.Next is opened. This tells V to
        // hide certain elements that may clash
        // wth the menu.
        var event = this.getEventsList().gamemenuOpen;
        this.sendEvent(event);
    };
    RecodeIntegrator.prototype.api_gamemenuClosed = function () {
        // Sent when the hamburger menu in
        // Play.Next is closed. This te0lls V to
        // show certain elements that were
        // hidden when the menu opened.
        var event = this.getEventsList().gamemenuClosed;
        this.sendEvent(event);
    };
    RecodeIntegrator.prototype.api_autoPlayStarted = function () {
        // Sent when the game enters Autoplay
        var event = this.getEventsList().autoPlayStarted;
        this.sendEvent(event);
    };
    RecodeIntegrator.prototype.api_autoPlayStopped = function () {
        // Sent when the game exits Autoplay
        // Will probably also need to implement win and loss limit.
        //         Stop from BaseGame
        // When the game stops autoplay, it must send an autoplayStopped signal to inform the GameFramework of this. The GameFramework resets
        // the AutoPlay module by clearing the limits and amounts, and set the isActive property to false.
        // V.API.Events.getEventsList('gameEvent').autoPlayStopped
        var event = this.getEventsList().autoPlayStopped;
        this.sendEvent(event);
    };
    RecodeIntegrator.prototype.api_gameRoundCompleted = function () {
        // Sent when end of game
        // round including the win animation
        // count up stop & balance update. In
        // free spin and bonus features at the
        // end of this feature ,i.e games back to
        // base game.
        var event = this.getEventsList().gameRoundCompleted;
        this.sendEvent(event);
    };
    RecodeIntegrator.prototype.api_server_systemBalanceUpdate = function (eventName, data) {
        // Should update the in game balance. Send the correct event to eventhandler.
        this.module.onServerSystemBalanceUpdate(data.value);
    };
    RecodeIntegrator.prototype.api_server_pluginSetMute = function (eventName, options) {
        // Should mute the game sounds.
        var value = false;
        if (options) {
            if (options.value) {
                value = options.value;
            }
        }
        // Mute should be inverted because that is how they send it.
        this.module.onServerSetMute(!value);
    };
    RecodeIntegrator.prototype.api_server_gameplayResume = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // Should restore gameplay from a paused state.
        this.module.onServerGameplayResume();
    };
    RecodeIntegrator.prototype.api_server_autoPlayInterrupt = function () {
        //         Stop from BaseGame Framework
        // AutoPlay stops from the mobile HTML5 casino core GameFramework if the player limits are exceeded or any UI blocking event occurs. The
        // GameFramework will emit the autoplayInterrup signal in this scenario
        // V.API.Events.getEventsList('gameEvent').autoPlayInterrupt
        // The game must end autoplay when it receives this signal.
        // Deprecated
        // This section is deprecated by the introduction of the AutoPlay Wager Limits API. V will not inspect spin requests or response
        // packets, instead the limits are calculated by calling V.API.Autoplay.verifyWagerLimits(wagerParameters) before each spin.
        // The game framework also removes the packet listeners attached to the spin packets by adding the removePacketCheck method to the
        // PacketInspector module. The game framework displays the AutoPlay limits notification when limits are reached.
        // Translations are required for
        // the message text, “Your AutoPlay limit has been reached”.
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.module.onServerAutoplayInterrupt(args);
    };
    RecodeIntegrator.prototype.api_server_preloaderRemoved = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // BaseGame should start here, which doesn't make sense to implement acccording to ReCode docs atm.'
        // this.module.onServerPreloaderRemoved();
    };
    RecodeIntegrator.prototype.server_launchLobby = function () {
        this.vApi.Core.launchLobby();
    };
    RecodeIntegrator.prototype.server_launchBanking = function () {
        this.vApi.Core.launchBanking();
    };
    RecodeIntegrator.prototype.setModule = function (module) {
        this._module = module;
    };
    RecodeIntegrator.prototype.errorCallback = function () { };
    RecodeIntegrator.prototype.api_showCoinSizeChangedDialog = function (callback) {
        var _this = this;
        this.showingErrorDialog();
        var extraCallback = function () {
            _this.closingErrorDialog();
            _this.module.emitValidatedBetCoinSizeChanged();
            if (callback) {
                callback();
            }
        };
        this.vApi.Dialog.showCoinSizeChangedDialog(extraCallback);
    };
    /**
     * Quote from Grant: "Hello, I’ve never used Chip Size changed, coin should work in all instances. The Chip dialog looks a lot uglier!""
     *
     * @param {Function} callback
     * @memberof RecodeIntegrator
     */
    RecodeIntegrator.prototype.api_showChipSizeChangedDialog = function (callback) {
        return;
    };
    RecodeIntegrator.prototype.api_showPracticePlayProgressiveNotAllowedDialog = function (callback) {
        var _this = this;
        this.showingErrorDialog();
        var extraCallback = function () {
            _this.closingErrorDialog();
            if (callback) {
                callback();
            }
        };
        this.vApi.Dialog.showPracticePlayProgressiveNotAllowedDialog(extraCallback);
    };
    RecodeIntegrator.prototype.api_showInsufficientFundsDialog = function (callback) {
        var _this = this;
        this.showingErrorDialog();
        var extraCallback = function () {
            _this.closingErrorDialog();
            if (callback) {
                callback();
            }
        };
        this.vApi.Dialog.showInsufficientFundsDialog(extraCallback);
    };
    RecodeIntegrator.prototype.isBankingAvailable = function () {
        return this.vApi.Core.isBankingAvailable();
    };
    RecodeIntegrator.prototype.api_showErrorMessage = function (data) {
        var type = data.attributes.servercode.toLowerCase();
        this.showingErrorDialog();
        if (type && data.attributes.text) {
            this.vApi.Dialog.showErrorDialog(data.attributes.text, this.closingErrorDialog.bind(this, this.vApi.Core.launchLobby));
        }
        // if (type === 'error') {
        // 	this.vApi.Dialog.showErrorDialog(data.attributes.text, this.closingErrorDialog.bind(this, this.vApi.Core.launchLobby));
        // }
        // if (type === 'coinSizeChanged') {
        // 	this.vApi.Dialog.showCoinSizeChangedDialog(() => {
        // 		console.log('CoinSizeChanged');
        // 	});
        // }
        // if (type === 'betWillBeAdjusted') {
        // 	this.vApi.Dialog.showBetWillBeAdjustedDialog(() => {
        // 		console.log('BetSizeWillBeAdjusted');
        // 	});
        // }
        // this.vApi.Dialog.showErrorDialog(data.value, this.vApi.Core.launchLobby);
    };
    RecodeIntegrator.prototype.showingErrorDialog = function (callback) {
        if (callback === void 0) { callback = null; }
        if (this._module) {
            this._module.onShowErrorDialog();
        }
        if (callback && typeof callback === 'function') {
            callback();
        }
    };
    RecodeIntegrator.prototype.closingErrorDialog = function (callback) {
        if (callback === void 0) { callback = null; }
        if (this._module) {
            this._module.onCloseErrorDialog();
        }
        if (callback && typeof callback === 'function') {
            callback();
        }
    };
    RecodeIntegrator.prototype.getEventsList = function (id) {
        if (id === void 0) { id = 'gameEvent'; }
        return this.vApi.Events.getEventsList('gameEvent');
    };
    RecodeIntegrator.prototype.sendPacket = function (packetConfig, callback, callbackObj) {
        // console.log(`Send packet: ${JSON.stringify(packetConfig)}`);
        this.vApi.Core.sendPacket(packetConfig, callback, callbackObj);
    };
    RecodeIntegrator.prototype.sendEvent = function (eventEnum, data) {
        if (data === void 0) { data = null; }
        this.vApi.Events.sendEvent('gameEvent', eventEnum, data);
    };
    RecodeIntegrator.prototype.subscribe = function () {
        // private subscribe(gameEvent: string, callback: Function, callbackObj: any): void {
        // Needs implementation.
        var vEventTypeEnum = this.vApi.Events.getEventsTypeEnumList();
        var vGameEventEnum = this.vApi.Events.getEventsList(vEventTypeEnum.gameEvent);
        // this.vApi.Events.subscribe(vEventTypeEnum[`${gameEvent}`], this.successCallback, this);
        // this.vApi.Events.unsubscribe(vEventTypeEnum[`${gameEvent}`], this.successCallback, this);
        this.vApi.Events.subscribe('gameEvent', this.successCallback, this);
        // return this.vApi.Events.subscribe(gameEvent, callback, callbackObj);
    };
    RecodeIntegrator.prototype.unsubscribe = function () {
        // return this.vApi.Events.unsubscribe(gameEvent, callback, callbackObj);
        return this.vApi.Events.unsubscribe('gameEvent', this.successCallback, this);
    };
    RecodeIntegrator.prototype.successCallback = function (eventName, data) {
        var vEventTypeEnum = this.vApi.Events.getEventsTypeEnumList();
        var vGameEventEnum = this.vApi.Events.getEventsList(vEventTypeEnum.gameEvent);
        switch (eventName) {
            case vGameEventEnum.systemBalanceUpdate:
                this.api_server_systemBalanceUpdate(eventName, data);
                // things to do if this event is dispatched from V
                break;
            case vGameEventEnum.pluginSetMute:
                this.api_server_pluginSetMute(eventName, data);
                // things to do if this event is dispatched from V
                break;
            case vGameEventEnum.gameplayResume:
                this.api_server_gameplayResume(eventName, data);
                // things to do if this event is dispatched from V
                break;
            case vGameEventEnum.autoPlayInterrupt:
                this.api_server_autoPlayInterrupt(eventName, data);
                // things to do if this event is dispatched from V
                break;
            case vGameEventEnum.preloaderRemoved:
                this.api_server_preloaderRemoved(eventName, data);
                // things to do if this event is dispatched from V
                break;
            case vGameEventEnum.displayError:
                // this.api_showErrorMessage(eventName, data);
                break;
            default:
                break;
        }
    };
    Object.defineProperty(RecodeIntegrator.prototype, "version", {
        get: function () {
            return this._version;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecodeIntegrator.prototype, "vApi", {
        get: function () {
            return this._vApi;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecodeIntegrator.prototype, "mid", {
        get: function () {
            return this._mid;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecodeIntegrator.prototype, "cid", {
        get: function () {
            return this._cid;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecodeIntegrator.prototype, "module", {
        get: function () {
            return this._module;
        },
        enumerable: true,
        configurable: true
    });
    return RecodeIntegrator;
}(Communicator_1.Communicator));
exports.RecodeIntegrator = RecodeIntegrator;


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer, global, process) {var capability = __webpack_require__(302)
var inherits = __webpack_require__(67)
var response = __webpack_require__(303)
var stream = __webpack_require__(304)
var toArrayBuffer = __webpack_require__(598)

var IncomingMessage = response.IncomingMessage
var rStates = response.readyStates

function decideMode (preferBinary, useFetch) {
	if (capability.fetch && useFetch) {
		return 'fetch'
	} else if (capability.mozchunkedarraybuffer) {
		return 'moz-chunked-arraybuffer'
	} else if (capability.msstream) {
		return 'ms-stream'
	} else if (capability.arraybuffer && preferBinary) {
		return 'arraybuffer'
	} else if (capability.vbArray && preferBinary) {
		return 'text:vbarray'
	} else {
		return 'text'
	}
}

var ClientRequest = module.exports = function (opts) {
	var self = this
	stream.Writable.call(self)

	self._opts = opts
	self._body = []
	self._headers = {}
	if (opts.auth)
		self.setHeader('Authorization', 'Basic ' + new Buffer(opts.auth).toString('base64'))
	Object.keys(opts.headers).forEach(function (name) {
		self.setHeader(name, opts.headers[name])
	})

	var preferBinary
	var useFetch = true
	if (opts.mode === 'disable-fetch' || ('requestTimeout' in opts && !capability.abortController)) {
		// If the use of XHR should be preferred. Not typically needed.
		useFetch = false
		preferBinary = true
	} else if (opts.mode === 'prefer-streaming') {
		// If streaming is a high priority but binary compatibility and
		// the accuracy of the 'content-type' header aren't
		preferBinary = false
	} else if (opts.mode === 'allow-wrong-content-type') {
		// If streaming is more important than preserving the 'content-type' header
		preferBinary = !capability.overrideMimeType
	} else if (!opts.mode || opts.mode === 'default' || opts.mode === 'prefer-fast') {
		// Use binary if text streaming may corrupt data or the content-type header, or for speed
		preferBinary = true
	} else {
		throw new Error('Invalid value for opts.mode')
	}
	self._mode = decideMode(preferBinary, useFetch)
	self._fetchTimer = null

	self.on('finish', function () {
		self._onFinish()
	})
}

inherits(ClientRequest, stream.Writable)

ClientRequest.prototype.setHeader = function (name, value) {
	var self = this
	var lowerName = name.toLowerCase()
	// This check is not necessary, but it prevents warnings from browsers about setting unsafe
	// headers. To be honest I'm not entirely sure hiding these warnings is a good thing, but
	// http-browserify did it, so I will too.
	if (unsafeHeaders.indexOf(lowerName) !== -1)
		return

	self._headers[lowerName] = {
		name: name,
		value: value
	}
}

ClientRequest.prototype.getHeader = function (name) {
	var header = this._headers[name.toLowerCase()]
	if (header)
		return header.value
	return null
}

ClientRequest.prototype.removeHeader = function (name) {
	var self = this
	delete self._headers[name.toLowerCase()]
}

ClientRequest.prototype._onFinish = function () {
	var self = this

	if (self._destroyed)
		return
	var opts = self._opts

	var headersObj = self._headers
	var body = null
	if (opts.method !== 'GET' && opts.method !== 'HEAD') {
		if (capability.arraybuffer) {
			body = toArrayBuffer(Buffer.concat(self._body))
		} else if (capability.blobConstructor) {
			body = new global.Blob(self._body.map(function (buffer) {
				return toArrayBuffer(buffer)
			}), {
				type: (headersObj['content-type'] || {}).value || ''
			})
		} else {
			// get utf8 string
			body = Buffer.concat(self._body).toString()
		}
	}

	// create flattened list of headers
	var headersList = []
	Object.keys(headersObj).forEach(function (keyName) {
		var name = headersObj[keyName].name
		var value = headersObj[keyName].value
		if (Array.isArray(value)) {
			value.forEach(function (v) {
				headersList.push([name, v])
			})
		} else {
			headersList.push([name, value])
		}
	})

	if (self._mode === 'fetch') {
		var signal = null
		var fetchTimer = null
		if (capability.abortController) {
			var controller = new AbortController()
			signal = controller.signal
			self._fetchAbortController = controller

			if ('requestTimeout' in opts && opts.requestTimeout !== 0) {
				self._fetchTimer = global.setTimeout(function () {
					self.emit('requestTimeout')
					if (self._fetchAbortController)
						self._fetchAbortController.abort()
				}, opts.requestTimeout)
			}
		}

		global.fetch(self._opts.url, {
			method: self._opts.method,
			headers: headersList,
			body: body || undefined,
			mode: 'cors',
			credentials: opts.withCredentials ? 'include' : 'same-origin',
			signal: signal
		}).then(function (response) {
			self._fetchResponse = response
			self._connect()
		}, function (reason) {
			global.clearTimeout(self._fetchTimer)
			if (!self._destroyed)
				self.emit('error', reason)
		})
	} else {
		var xhr = self._xhr = new global.XMLHttpRequest()
		try {
			xhr.open(self._opts.method, self._opts.url, true)
		} catch (err) {
			process.nextTick(function () {
				self.emit('error', err)
			})
			return
		}

		// Can't set responseType on really old browsers
		if ('responseType' in xhr)
			xhr.responseType = self._mode.split(':')[0]

		if ('withCredentials' in xhr)
			xhr.withCredentials = !!opts.withCredentials

		if (self._mode === 'text' && 'overrideMimeType' in xhr)
			xhr.overrideMimeType('text/plain; charset=x-user-defined')

		if ('requestTimeout' in opts) {
			xhr.timeout = opts.requestTimeout
			xhr.ontimeout = function () {
				self.emit('requestTimeout')
			}
		}

		headersList.forEach(function (header) {
			xhr.setRequestHeader(header[0], header[1])
		})

		self._response = null
		xhr.onreadystatechange = function () {
			switch (xhr.readyState) {
				case rStates.LOADING:
				case rStates.DONE:
					self._onXHRProgress()
					break
			}
		}
		// Necessary for streaming in Firefox, since xhr.response is ONLY defined
		// in onprogress, not in onreadystatechange with xhr.readyState = 3
		if (self._mode === 'moz-chunked-arraybuffer') {
			xhr.onprogress = function () {
				self._onXHRProgress()
			}
		}

		xhr.onerror = function () {
			if (self._destroyed)
				return
			self.emit('error', new Error('XHR error'))
		}

		try {
			xhr.send(body)
		} catch (err) {
			process.nextTick(function () {
				self.emit('error', err)
			})
			return
		}
	}
}

/**
 * Checks if xhr.status is readable and non-zero, indicating no error.
 * Even though the spec says it should be available in readyState 3,
 * accessing it throws an exception in IE8
 */
function statusValid (xhr) {
	try {
		var status = xhr.status
		return (status !== null && status !== 0)
	} catch (e) {
		return false
	}
}

ClientRequest.prototype._onXHRProgress = function () {
	var self = this

	if (!statusValid(self._xhr) || self._destroyed)
		return

	if (!self._response)
		self._connect()

	self._response._onXHRProgress()
}

ClientRequest.prototype._connect = function () {
	var self = this

	if (self._destroyed)
		return

	self._response = new IncomingMessage(self._xhr, self._fetchResponse, self._mode, self._fetchTimer)
	self._response.on('error', function(err) {
		self.emit('error', err)
	})

	self.emit('response', self._response)
}

ClientRequest.prototype._write = function (chunk, encoding, cb) {
	var self = this

	self._body.push(chunk)
	cb()
}

ClientRequest.prototype.abort = ClientRequest.prototype.destroy = function () {
	var self = this
	self._destroyed = true
	global.clearTimeout(self._fetchTimer)
	if (self._response)
		self._response._destroyed = true
	if (self._xhr)
		self._xhr.abort()
	else if (self._fetchAbortController)
		self._fetchAbortController.abort()
}

ClientRequest.prototype.end = function (data, encoding, cb) {
	var self = this
	if (typeof data === 'function') {
		cb = data
		data = undefined
	}

	stream.Writable.prototype.end.call(self, data, encoding, cb)
}

ClientRequest.prototype.flushHeaders = function () {}
ClientRequest.prototype.setTimeout = function () {}
ClientRequest.prototype.setNoDelay = function () {}
ClientRequest.prototype.setSocketKeepAlive = function () {}

// Taken from http://www.w3.org/TR/XMLHttpRequest/#the-setrequestheader%28%29-method
var unsafeHeaders = [
	'accept-charset',
	'accept-encoding',
	'access-control-request-headers',
	'access-control-request-method',
	'connection',
	'content-length',
	'cookie',
	'cookie2',
	'date',
	'dnt',
	'expect',
	'host',
	'keep-alive',
	'origin',
	'referer',
	'te',
	'trailer',
	'transfer-encoding',
	'upgrade',
	'via'
]

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(98).Buffer, __webpack_require__(24), __webpack_require__(50)))

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 592 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 593 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = __webpack_require__(122).Buffer;
var util = __webpack_require__(595);

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}

/***/ }),
/* 595 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(24)))

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__(311);

/*<replacement>*/
var util = __webpack_require__(99);
util.inherits = __webpack_require__(67);
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(98).Buffer

module.exports = function (buf) {
	// If the buffer is backed by a Uint8Array, a faster version will work
	if (buf instanceof Uint8Array) {
		// If the buffer isn't a subarray, return the underlying ArrayBuffer
		if (buf.byteOffset === 0 && buf.byteLength === buf.buffer.byteLength) {
			return buf.buffer
		} else if (typeof buf.buffer.slice === 'function') {
			// Otherwise we need to get a proper copy
			return buf.buffer.slice(buf.byteOffset, buf.byteOffset + buf.byteLength)
		}
	}

	if (Buffer.isBuffer(buf)) {
		// This is the slow version that will work with any Buffer
		// implementation (even in old browsers)
		var arrayCopy = new Uint8Array(buf.length)
		var len = buf.length
		for (var i = 0; i < len; i++) {
			arrayCopy[i] = buf[i]
		}
		return arrayCopy.buffer
	} else {
		throw new Error('Argument must be a Buffer')
	}
}


/***/ }),
/* 599 */
/***/ (function(module, exports) {

module.exports = extend

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend() {
    var target = {}

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}


/***/ }),
/* 600 */
/***/ (function(module, exports) {

module.exports = {
  "100": "Continue",
  "101": "Switching Protocols",
  "102": "Processing",
  "200": "OK",
  "201": "Created",
  "202": "Accepted",
  "203": "Non-Authoritative Information",
  "204": "No Content",
  "205": "Reset Content",
  "206": "Partial Content",
  "207": "Multi-Status",
  "208": "Already Reported",
  "226": "IM Used",
  "300": "Multiple Choices",
  "301": "Moved Permanently",
  "302": "Found",
  "303": "See Other",
  "304": "Not Modified",
  "305": "Use Proxy",
  "307": "Temporary Redirect",
  "308": "Permanent Redirect",
  "400": "Bad Request",
  "401": "Unauthorized",
  "402": "Payment Required",
  "403": "Forbidden",
  "404": "Not Found",
  "405": "Method Not Allowed",
  "406": "Not Acceptable",
  "407": "Proxy Authentication Required",
  "408": "Request Timeout",
  "409": "Conflict",
  "410": "Gone",
  "411": "Length Required",
  "412": "Precondition Failed",
  "413": "Payload Too Large",
  "414": "URI Too Long",
  "415": "Unsupported Media Type",
  "416": "Range Not Satisfiable",
  "417": "Expectation Failed",
  "418": "I'm a teapot",
  "421": "Misdirected Request",
  "422": "Unprocessable Entity",
  "423": "Locked",
  "424": "Failed Dependency",
  "425": "Unordered Collection",
  "426": "Upgrade Required",
  "428": "Precondition Required",
  "429": "Too Many Requests",
  "431": "Request Header Fields Too Large",
  "451": "Unavailable For Legal Reasons",
  "500": "Internal Server Error",
  "501": "Not Implemented",
  "502": "Bad Gateway",
  "503": "Service Unavailable",
  "504": "Gateway Timeout",
  "505": "HTTP Version Not Supported",
  "506": "Variant Also Negotiates",
  "507": "Insufficient Storage",
  "508": "Loop Detected",
  "509": "Bandwidth Limit Exceeded",
  "510": "Not Extended",
  "511": "Network Authentication Required"
}


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var RecodeLogic_1 = __webpack_require__(94);
var GameRecodeSpinResult_1 = __webpack_require__(602);
var GameSymbol_1 = __webpack_require__(64);
var Logic_1 = __webpack_require__(73);
var GamePrototypeLogic_1 = __webpack_require__(603);
var RecodeToPrototypeConverter_1 = __webpack_require__(163);
var Action_1 = __webpack_require__(29);
var GameRecodeLogic = /** @class */ (function (_super) {
    __extends(GameRecodeLogic, _super);
    function GameRecodeLogic(gameName, eventManager, communicator, device) {
        var _this = _super.call(this, gameName, eventManager, communicator, device) || this;
        _this._realLogic = new GamePrototypeLogic_1.GamePrototypeLogic(gameName, eventManager, communicator, device);
        return _this;
    }
    Object.defineProperty(GameRecodeLogic.prototype, "_reelsHeight", {
        // Override for this Riviera star which does not use symbolheights.
        get: function () {
            return [[1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1]];
        },
        enumerable: true,
        configurable: true
    });
    GameRecodeLogic.prototype.setResultsForCurrentRound = function () {
        if (this._currentRound > 0 && this._reels[this._currentRound - 1]) {
            this.getRecodeSpinResults().setPreviousReels(this._reels[this._currentRound - 1], this._reelsHeight[0]);
        }
        this.getRecodeSpinResults().setWaysToWin(this._waysRounds[0]); // It is the same for all rounds in this Medallion.
        // this.getRecodeSpinResults().setWaysToWin(this._waysRounds[this._currentRound]);
        this.getRecodeSpinResults().setReels(this._reels[this._currentRound], this._reelsHeight[0]);
        var wins = this.getWinsFromRound(this._currentRound);
        this.getRecodeSpinResults().setWins(wins);
        this.getRecodeSpinResults().setRoundWin(this.getWinsSum(this.getWinsFromRound(this._currentRound)));
        this.getRecodeSpinResults().setNextRoundWin(this.getWinsSum(this.getWinsFromRound(this._currentRound + 1)));
        this.getRecodeSpinResults().setTotalWin(this._totalWin);
        /*	if (wins && wins.length > 0 && this.isFreeSpinsStarted) {
            this._freeSpinsMultiplier = wins[0].multiplier + 1;
        }*/
        this.setNextAction();
        // TODO: change current round values here
    };
    GameRecodeLogic.prototype.setInitResults = function () {
        if (this.isFreeSpinsStarted) {
            this.getRecodeSpinResults().setReels(this._reels[this._reels.length - 1], this._reelsHeight[0]);
        }
        else {
            this.getRecodeSpinResults().setReels(this._reels[this._currentRound], this._reelsHeight[0]);
        }
        this.setNextAction();
        // if (this.getNextRoundType() === RoundTypes.BONUS) {
        // 	this.makeNextBonusSymbolsList();
        // }
        if (this.freeSpinsLeft > 0) {
            // this.makeNextFreespin!
        }
    };
    GameRecodeLogic.prototype.parseSlot = function (data) {
        _super.prototype.parseSlot.call(this, data);
        if (this._freeSpinsLeft === 0) {
            this.parseFreeSpinTriggerSets(data);
        }
    };
    GameRecodeLogic.prototype.updateFreeSpinsTriggerSymbols = function (symbols) {
        this._freeSpinsTriggerSymbols = [];
        var reelIndex = 0;
        for (var _i = 0, symbols_1 = symbols; _i < symbols_1.length; _i++) {
            var reel = symbols_1[_i];
            this._freeSpinsTriggerSymbols.push([]);
            var rowIndex = 0;
            for (var _a = 0, reel_1 = reel; _a < reel_1.length; _a++) {
                var sym = reel_1[_a];
                this._freeSpinsTriggerSymbols[reelIndex]
                    .push(new GameSymbol_1.GameSymbol(RecodeToPrototypeConverter_1.RecodeToPrototypeConverter.gameSymbolNameToId(sym), { width: 1, height: 1 }, { x: reelIndex, y: rowIndex }));
                rowIndex++;
            }
            reelIndex++;
        }
    };
    GameRecodeLogic.prototype.parseFreeSpinTriggerSets = function (data) {
        this._freeSpinsTriggerReels = [];
        var results = data.ResultSets.Result;
        var baseName = 'BaseGame';
        for (var _i = 0, results_1 = results; _i < results_1.length; _i++) {
            var res = results_1[_i];
            var name_1 = res.attributes.name;
            if (name_1.includes(baseName)) {
                if (!res.Reels) {
                    continue;
                }
                if (!res.Reels.length) {
                    res.Reels = [res.Reels];
                }
                var lastReel = res.Reels[res.Reels.length - 1];
                var reelSymbols = lastReel.attributes.symbols.split(',');
                for (var _a = 0, reelSymbols_1 = reelSymbols; _a < reelSymbols_1.length; _a++) {
                    var sym = reelSymbols_1[_a];
                    this._freeSpinsTriggerReels.push(Number.parseInt(sym, 10));
                }
            }
        }
    };
    GameRecodeLogic.prototype.init = function (cb) {
        var _this = this;
        _super.prototype.init.call(this, function (data) {
            _this._realLogic.reactOnInit(RecodeToPrototypeConverter_1.RecodeToPrototypeConverter.convertInit(data, _this));
            cb && cb(data);
        });
    };
    GameRecodeLogic.prototype.spin = function (cb) {
        var _this = this;
        _super.prototype.spin.call(this, function (data) {
            _this._realLogic.reactOnSpin(RecodeToPrototypeConverter_1.RecodeToPrototypeConverter.convertSpin(data, _this));
            cb && cb(data);
        });
    };
    GameRecodeLogic.prototype.freespin = function (cb) {
        var _this = this;
        _super.prototype.freespin.call(this, function (data) {
            _this._realLogic.reactOnFreeSpin(RecodeToPrototypeConverter_1.RecodeToPrototypeConverter.convertSpin(data, _this));
            cb && cb(data);
        });
    };
    GameRecodeLogic.prototype.createSpinResult = function () {
        return new GameRecodeSpinResult_1.GameRecodeSpinResult();
    };
    GameRecodeLogic.prototype.startNextRound = function () {
        _super.prototype.startNextRound.call(this);
        this._realLogic.startNextRound();
    };
    GameRecodeLogic.prototype.hasWinsToHighlight = function () {
        return this._realLogic.hasWinsToHighlight();
    };
    GameRecodeLogic.prototype.getAllWinningSymbolsFromCurrentRound = function () {
        return this._realLogic.getAllWinningSymbolsFromCurrentRound();
    };
    GameRecodeLogic.prototype.getAllWinLinesFromCurrentRound = function () {
        return this._realLogic.getAllWinLinesFromCurrentRound();
    };
    GameRecodeLogic.prototype.getCurrentReelsSymbol = function (pos) {
        return this._realLogic.getCurrentReelsSymbol(pos);
    };
    GameRecodeLogic.prototype.getCurrentRoundWinningWilds = function () {
        return this._realLogic.getCurrentRoundWinningWilds();
    };
    GameRecodeLogic.prototype.getCurrentRoundTotalWinNoMultiplier = function () {
        return this._realLogic.getCurrentRoundTotalWinNoMultiplier();
    };
    GameRecodeLogic.prototype.getLastAvalancheRunningTotal = function () {
        return this._realLogic.getLastAvalancheRunningTotal() / Logic_1.Logic.CENT_TO_A_DOLLAR;
    };
    GameRecodeLogic.prototype.getLastAvalancheMultiplier = function () {
        return this._realLogic.getLastAvalancheMultiplier();
    };
    GameRecodeLogic.prototype.getNextAvalancheRunningTotalInCents = function () {
        return this._realLogic.getNextAvalancheRunningTotalInCents();
    };
    Object.defineProperty(GameRecodeLogic.prototype, "currentSpinWin", {
        get: function () {
            return this._realLogic.currentSpinWin;
        },
        enumerable: true,
        configurable: true
    });
    GameRecodeLogic.prototype.getFinalSymbolsPosition = function () {
        return this._realLogic.getFinalSymbolsPosition();
    };
    GameRecodeLogic.prototype.isFreeSpinsTrigger = function () {
        return this._realLogic.isFreeSpinsTrigger();
    };
    GameRecodeLogic.prototype.tempInitSymbolSizes = function () {
    };
    Object.defineProperty(GameRecodeLogic.prototype, "nextAction", {
        get: function () {
            return this._realLogic.nextAction;
        },
        enumerable: true,
        configurable: true
    });
    GameRecodeLogic.prototype.getSpinResult = function () {
        return this._realLogic.getSpinResult();
    };
    GameRecodeLogic.prototype.finishFreeSpins = function () {
        _super.prototype.finishFreeSpins.call(this);
        this._realLogic.forceSetNextAction(Action_1.Action.SPIN);
    };
    GameRecodeLogic.prototype.startFreeSpinsIntro = function () {
        _super.prototype.startFreeSpinsIntro.call(this);
        this._realLogic.forceSetNextAction(Action_1.Action.FREESPIN);
    };
    GameRecodeLogic.prototype.goIntoFreeSpins = function () {
        this._realLogic.forceSetIsInFreeSpins(true);
    };
    GameRecodeLogic.prototype.goOutOfFreeSpin = function () {
        this._realLogic.forceSetIsInFreeSpins(false);
    };
    Object.defineProperty(GameRecodeLogic.prototype, "freeSpinsTriggerReels", {
        get: function () {
            return this._freeSpinsTriggerReels;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GameRecodeLogic.prototype, "freeSpinsTriggerSymbols", {
        get: function () {
            return this._freeSpinsTriggerSymbols;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GameRecodeLogic.prototype, "hasFreeSpinsRetrigger", {
        get: function () {
            return this._realLogic.hasFreeSpinsRetrigger;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GameRecodeLogic.prototype, "freeSpinsAdded", {
        get: function () {
            return this._realLogic.freeSpinsAdded;
        },
        enumerable: true,
        configurable: true
    });
    return GameRecodeLogic;
}(RecodeLogic_1.RecodeLogic));
exports.GameRecodeLogic = GameRecodeLogic;


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var RecodeSpinResult_1 = __webpack_require__(282);
var GameSymbol_1 = __webpack_require__(64);
var Symbols_1 = __webpack_require__(38);
var RecodeToPrototypeConverter_1 = __webpack_require__(163);
var GameRecodeSpinResult = /** @class */ (function (_super) {
    __extends(GameRecodeSpinResult, _super);
    function GameRecodeSpinResult() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameRecodeSpinResult.prototype.makeGameSymbolFrom = function (symbol, symbolHeight, position) {
        if (symbolHeight === void 0) { symbolHeight = 1; }
        if (symbol >= 0) {
            return new GameSymbol_1.GameSymbol(RecodeToPrototypeConverter_1.RecodeToPrototypeConverter.recodeToGameSymbol(symbol), {
                width: 1,
                height: 1,
            }, position);
        }
        return null;
    };
    GameRecodeSpinResult.prototype.convertPaytableReasonToSymID = function (reason) {
        var id = reason.substr(1);
        switch (id) {
            case 'M1':
                return Symbols_1.Symbols.M1; // H1
            case 'M2':
                return Symbols_1.Symbols.M2; // H2
            case 'M3':
                return Symbols_1.Symbols.M3; // H3
            case 'M4':
                return Symbols_1.Symbols.M4; // H4
            case 'M5':
                return Symbols_1.Symbols.M5; // L1
            case 'F6':
                return Symbols_1.Symbols.F6; // L2
            case 'F7':
                return Symbols_1.Symbols.F7; // L3
            case 'F8':
                return Symbols_1.Symbols.F8; // L4
            case 'F9':
                return Symbols_1.Symbols.F9; // L5
            default:
                break;
        }
    };
    return GameRecodeSpinResult;
}(RecodeSpinResult_1.RecodeSpinResult));
exports.GameRecodeSpinResult = GameRecodeSpinResult;


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var PrototypeLogic_1 = __webpack_require__(604);
var Symbols_1 = __webpack_require__(38);
var GamePrototypeCommunicator_1 = __webpack_require__(611);
var GameSymbol_1 = __webpack_require__(64);
var ServerAvalancheReelsRound_1 = __webpack_require__(164);
var GamePrototypeSpinResult_1 = __webpack_require__(612);
var Logic_1 = __webpack_require__(73);
var RecodeToPrototypeConverter_1 = __webpack_require__(163);
var GamePrototypeLogic = /** @class */ (function (_super) {
    __extends(GamePrototypeLogic, _super);
    function GamePrototypeLogic() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /* tslint:disable */
    GamePrototypeLogic.prototype.intializeServerSymbols = function () {
        this._serverSymbols['WR'] = Symbols_1.Symbols.WR;
        this._serverSymbols['M1'] = Symbols_1.Symbols.M1;
        this._serverSymbols['M2'] = Symbols_1.Symbols.M2;
        this._serverSymbols['M3'] = Symbols_1.Symbols.M3;
        this._serverSymbols['M4'] = Symbols_1.Symbols.M4;
        this._serverSymbols['M5'] = Symbols_1.Symbols.M5;
        this._serverSymbols['F6'] = Symbols_1.Symbols.F6;
        this._serverSymbols['F7'] = Symbols_1.Symbols.F7;
        this._serverSymbols['F8'] = Symbols_1.Symbols.F8;
        this._serverSymbols['F9'] = Symbols_1.Symbols.F9;
        this._serverSymbols['F10'] = Symbols_1.Symbols.F10;
        this._serverSymbols['BN'] = Symbols_1.Symbols.BN;
        this._serverSymbols['RS'] = Symbols_1.Symbols.RS;
        RecodeToPrototypeConverter_1.RecodeToPrototypeConverter.serverSymbolNames[Symbols_1.Symbols.WR] = 'WR';
        RecodeToPrototypeConverter_1.RecodeToPrototypeConverter.serverSymbolNames[Symbols_1.Symbols.M1] = 'M1';
        RecodeToPrototypeConverter_1.RecodeToPrototypeConverter.serverSymbolNames[Symbols_1.Symbols.M2] = 'M2';
        RecodeToPrototypeConverter_1.RecodeToPrototypeConverter.serverSymbolNames[Symbols_1.Symbols.M3] = 'M3';
        RecodeToPrototypeConverter_1.RecodeToPrototypeConverter.serverSymbolNames[Symbols_1.Symbols.M4] = 'M4';
        RecodeToPrototypeConverter_1.RecodeToPrototypeConverter.serverSymbolNames[Symbols_1.Symbols.M5] = 'M5';
        RecodeToPrototypeConverter_1.RecodeToPrototypeConverter.serverSymbolNames[Symbols_1.Symbols.F6] = 'F6';
        RecodeToPrototypeConverter_1.RecodeToPrototypeConverter.serverSymbolNames[Symbols_1.Symbols.F7] = 'F7';
        RecodeToPrototypeConverter_1.RecodeToPrototypeConverter.serverSymbolNames[Symbols_1.Symbols.F8] = 'F8';
        RecodeToPrototypeConverter_1.RecodeToPrototypeConverter.serverSymbolNames[Symbols_1.Symbols.F9] = 'F9';
        RecodeToPrototypeConverter_1.RecodeToPrototypeConverter.serverSymbolNames[Symbols_1.Symbols.F10] = 'F10';
        RecodeToPrototypeConverter_1.RecodeToPrototypeConverter.serverSymbolNames[Symbols_1.Symbols.BN] = 'BN';
        RecodeToPrototypeConverter_1.RecodeToPrototypeConverter.serverSymbolNames[Symbols_1.Symbols.RS] = 'RS';
    };
    /* tslint:enable */
    GamePrototypeLogic.prototype.createCommunicator = function (communicator) {
        this._communicator = new GamePrototypeCommunicator_1.GamePrototypeCommunicator();
        // (this._communicator as GamePrototypeCommunicator).addFakeResponse('');
    };
    GamePrototypeLogic.prototype.parseAvalanches = function (data) {
        this._avalanches = [];
        var avalancheIndex = 0;
        for (var _i = 0, _a = data.generations; _i < _a.length; _i++) {
            var avalancheData = _a[_i];
            var avalanche = {
                initialSymbols: [],
                symbolsAfterRemoval: [],
                newSymbols: [],
                win: 0,
                winnings: [],
                respins: [],
                runningTotal: 0,
                wildMeter: 0,
            };
            var reelIndex = 0;
            for (var _b = 0, _c = avalancheData.symbols; _b < _c.length; _b++) {
                var reel = _c[_b];
                avalanche.initialSymbols.push([]);
                var rowIndex = 0;
                for (var _d = 0, reel_1 = reel; _d < reel_1.length; _d++) {
                    var sym = reel_1[_d];
                    avalanche.initialSymbols[reelIndex].push(new GameSymbol_1.GameSymbol(this._serverSymbols[sym], { width: 1, height: 1 }, { x: reelIndex, y: rowIndex }));
                    rowIndex++;
                }
                reelIndex++;
            }
            if (avalancheData.win) {
                avalanche.win = avalancheData.win;
            }
            if (avalancheData.hasOwnProperty('runningTotal')) {
                avalanche.runningTotal = avalancheData.runningTotal;
            }
            if (avalancheData.hasOwnProperty('wildMeter')) {
                avalanche.wildMeter = avalancheData.wildMeter;
            }
            var removedSymbols = [];
            if (avalancheData.winnings) {
                for (var _e = 0, _f = avalancheData.winnings; _e < _f.length; _e++) {
                    var win = _f[_e];
                    var winning = {
                        winType: win[0],
                        winPositions: [],
                        winLength: 0,
                        win: win[2],
                        lineIndex: win[1],
                        winSymbol: this._serverSymbols[win[4]],
                        isRightToLeft: win[5] === 1,
                    };
                    var _loop_1 = function (wl) {
                        winning.winPositions.push({ x: wl.x, y: wl.y });
                        var shouldAddSymbol = removedSymbols.findIndex(function (item) {
                            return item.x === wl.x && item.y === wl.y;
                        }) < 0;
                        if (shouldAddSymbol) {
                            removedSymbols.push({ x: wl.x, y: wl.y });
                        }
                    };
                    for (var _g = 0, _h = win[3]; _g < _h.length; _g++) {
                        var wl = _h[_g];
                        _loop_1(wl);
                    }
                    winning.winLength = winning.winPositions.length;
                    avalanche.winnings.push(winning);
                }
            }
            if (avalancheData.removal) {
                for (var _j = 0, _k = avalancheData.removal; _j < _k.length; _j++) {
                    var respinData = _k[_j];
                    var respin = { position: { x: respinData.x, y: respinData.y }, removedPositions: [] };
                    var _loop_2 = function (pos) {
                        respin.removedPositions.push({ x: pos.x, y: pos.y });
                        var shouldAddSymbol = removedSymbols.findIndex(function (item) {
                            return item.x === pos.x && item.y === pos.y;
                        }) < 0;
                        if (shouldAddSymbol) {
                            removedSymbols.push({ x: pos.x, y: pos.y });
                        }
                    };
                    for (var _l = 0, _m = respinData.removal; _l < _m.length; _l++) {
                        var pos = _m[_l];
                        _loop_2(pos);
                    }
                    removedSymbols.push({ x: respin.position.x, y: respin.position.y });
                    avalanche.respins.push(respin);
                }
            }
            var winSymbolsOnEachPosition = [0, 0, 0, 0, 0, 0];
            for (var _o = 0, removedSymbols_1 = removedSymbols; _o < removedSymbols_1.length; _o++) {
                var removedSymbol = removedSymbols_1[_o];
                winSymbolsOnEachPosition[removedSymbol.x]++;
            }
            reelIndex = 0;
            for (reelIndex = 0; reelIndex < winSymbolsOnEachPosition.length; reelIndex++) {
                var totalWinningSymbols = winSymbolsOnEachPosition[reelIndex];
                avalanche.newSymbols.push([]);
                for (var symbolIndex = 0; symbolIndex < totalWinningSymbols; symbolIndex++) {
                    var symVal = data.generations[avalancheIndex + 1].symbols[reelIndex][symbolIndex];
                    avalanche.newSymbols[reelIndex].push(new GameSymbol_1.GameSymbol(this._serverSymbols[symVal], {
                        width: 1,
                        height: 1,
                    }, { x: -1, y: -1 }));
                }
            }
            if (avalanche.respins.length > 0) {
                this._roundTypes.push(ServerAvalancheReelsRound_1.ServerEvents.RESPIN);
            }
            else if (avalanche.winnings.length > 0) {
                this._roundTypes.push(ServerAvalancheReelsRound_1.ServerEvents.AVALANCHE);
            }
            this._avalanches.push(avalanche);
            avalancheIndex++;
        }
    };
    GamePrototypeLogic.prototype.parseOtherData = function (data) {
        if (data.hasOwnProperty('spinWin')) {
            this._currentSpinWin = data.spinWin;
        }
        else {
            this._currentSpinWin = 0;
        }
    };
    GamePrototypeLogic.prototype.createSpinResult = function () {
        return new GamePrototypeSpinResult_1.GamePrototypeSpinResult();
    };
    GamePrototypeLogic.prototype.setResultsForCurrentRound = function () {
        _super.prototype.setResultsForCurrentRound.call(this);
        this.getPrototypeSpinResults().setRespinData(this._avalanches[this._currentRound]);
    };
    GamePrototypeLogic.prototype.getLastAvalancheRunningTotal = function () {
        if (this._avalanches && this._avalanches.length > 0) {
            return this._avalanches[this._avalanches.length - 1].runningTotal * Logic_1.Logic.CENT_TO_A_DOLLAR;
        }
        return 0;
    };
    GamePrototypeLogic.prototype.getLastAvalancheMultiplier = function () {
        if (this._avalanches && this._avalanches.length > 0) {
            var wildMeter = this._avalanches[this._avalanches.length - 1].wildMeter;
            if (this.isInFreeSpins) {
                return 1 + Math.floor(wildMeter / 3) * 2;
            }
            else {
                return 1 + Math.floor(wildMeter / 3);
            }
        }
        return 1;
    };
    GamePrototypeLogic.prototype.getNextAvalancheRunningTotalInCents = function () {
        if (this._avalanches && this._avalanches.length > 0) {
            if (this._currentRound + 1 >= this._avalanches.length) {
                return this._avalanches[this._avalanches.length - 1].runningTotal;
            }
            return this._avalanches[this._currentRound + 1].runningTotal;
        }
        return 0;
    };
    GamePrototypeLogic.prototype.hasWinsToHighlight = function () {
        var winningSymbols = this.getAllWinningSymbolsFromCurrentRound();
        return winningSymbols.length > 0;
    };
    GamePrototypeLogic.prototype.getAllWinningSymbolsFromCurrentRound = function () {
        var winPositions = [];
        for (var _i = 0, _a = this._avalanches[this._currentRound].winnings; _i < _a.length; _i++) {
            var wl = _a[_i];
            winPositions.push.apply(winPositions, wl.winPositions);
        }
        return winPositions;
    };
    GamePrototypeLogic.prototype.getAllWinLinesFromCurrentRound = function () {
        return this._avalanches[this._currentRound].winnings;
    };
    GamePrototypeLogic.prototype.getCurrentReelsSymbol = function (pos) {
        return this._avalanches[this._currentRound].initialSymbols[pos.x][pos.y];
    };
    GamePrototypeLogic.prototype.getCurrentRoundWinningWilds = function () {
        var winWildsPositions = [];
        for (var _i = 0, _a = this._avalanches[this._currentRound].winnings; _i < _a.length; _i++) {
            var wl = _a[_i];
            var _loop_3 = function (winPos) {
                var gs = this_1._avalanches[this_1._currentRound].initialSymbols[winPos.x][winPos.y];
                if (gs.sym === Symbols_1.Symbols.WR || gs.sym === Symbols_1.Symbols.TOP_WR) {
                    var hasItem = winWildsPositions.findIndex(function (item) {
                        return item.x === winPos.x && item.y === winPos.y;
                    }) >= 0;
                    if (!hasItem) {
                        winWildsPositions.push({ x: winPos.x, y: winPos.y });
                    }
                }
            };
            var this_1 = this;
            for (var _b = 0, _c = wl.winPositions; _b < _c.length; _b++) {
                var winPos = _c[_b];
                _loop_3(winPos);
            }
        }
        return winWildsPositions;
    };
    Object.defineProperty(GamePrototypeLogic.prototype, "currentSpinWin", {
        get: function () {
            return this._currentSpinWin * Logic_1.Logic.CENT_TO_A_DOLLAR;
        },
        enumerable: true,
        configurable: true
    });
    GamePrototypeLogic.prototype.getCurrentRoundTotalWinNoMultiplier = function () {
        var totalWin = 0;
        for (var _i = 0, _a = this._avalanches; _i < _a.length; _i++) {
            var avalanche = _a[_i];
            totalWin += avalanche.win;
        }
        return totalWin * Logic_1.Logic.CENT_TO_A_DOLLAR;
    };
    GamePrototypeLogic.prototype.getFinalSymbolsPosition = function () {
        return this._avalanches[this._avalanches.length - 1];
    };
    GamePrototypeLogic.prototype.isFreeSpinsTrigger = function () {
        var symbols = this.getFinalSymbolsPosition().initialSymbols;
        var bnSymbolsCount = 0;
        symbols.forEach(function (reel) {
            reel.forEach(function (symbol) {
                if (symbol.sym === Symbols_1.Symbols.BN && symbol.position.y >= 3) {
                    bnSymbolsCount++;
                }
            });
        });
        return bnSymbolsCount >= GamePrototypeLogic.BN_SYMBOLS_TO_TRIGGER_FS;
    };
    GamePrototypeLogic.prototype.reactOnInit = function (data) {
        _super.prototype.reactOnInit.call(this, data);
        if (data.generations) {
            this.reactOnSpin(data);
        }
    };
    GamePrototypeLogic.prototype.forceSetNextAction = function (action) {
        this._nextAction = action;
    };
    GamePrototypeLogic.BN_SYMBOLS_TO_TRIGGER_FS = 3;
    GamePrototypeLogic.PAYLINES = [
        [3, 3, 3, 3, 3],
        [4, 4, 4, 4, 4],
        [5, 5, 5, 5, 5],
        [3, 4, 5, 4, 3],
        [5, 4, 3, 4, 5],
        [4, 3, 3, 3, 4],
        [4, 5, 5, 5, 4],
        [3, 3, 4, 5, 5],
        [5, 5, 4, 3, 3],
        [4, 5, 4, 3, 4],
    ];
    return GamePrototypeLogic;
}(PrototypeLogic_1.PrototypeLogic));
exports.GamePrototypeLogic = GamePrototypeLogic;


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var PrototypeSpinResult_1 = __webpack_require__(312);
var ServerAvalancheReelsRound_1 = __webpack_require__(164);
var GameSymbol_1 = __webpack_require__(64);
var ReelConstants_1 = __webpack_require__(10);
var LogicEvents_1 = __webpack_require__(11);
var Action_1 = __webpack_require__(29);
var Logic_1 = __webpack_require__(73);
var PrototypeCommunicator_1 = __webpack_require__(316);
var RelaxStorage_1 = __webpack_require__(609);
var RelaxLogicEvents_1 = __webpack_require__(610);
var PrototypeLogic = /** @class */ (function (_super) {
    __extends(PrototypeLogic, _super);
    /* tslint:disable */
    function PrototypeLogic(gameName, eventManager, communicator, device) {
        var _this = _super.call(this, gameName, eventManager, communicator, device) || this;
        _this._roundTypes = [];
        _this._currentRound = 0;
        _this._totalRounds = 0;
        _this._beforeFSReels = [];
        _this._initialReels = [];
        _this._newSymbols = [];
        _this._stopPositions = [];
        _this._winLines = [];
        _this._currentWinLines = 0;
        _this._currentMultiplier = 1;
        _this._currentFreeSpin = 0;
        _this._serverSymbols = {};
        _this._replacements = {};
        _this._messagesQueue = [];
        _this._isInFreeRounds = false;
        _this._lastFreeSpinsTotal = -1;
        _this.intializeServerSymbols();
        return _this;
    }
    /* tslint:enable */
    PrototypeLogic.prototype.createStorage = function () {
        this._storage = new RelaxStorage_1.RelaxStorage();
    };
    PrototypeLogic.prototype.createCurrencyFormatter = function () {
        // Already set in System.
        // this._currencyFormatter = new RelaxCurrencyFormatter();
    };
    PrototypeLogic.prototype.resetRound = function () {
        _super.prototype.resetRound.call(this);
        this._currentRound = 0;
    };
    PrototypeLogic.prototype.keepAlivePing = function () {
        this.ping(null);
    };
    PrototypeLogic.prototype.saveData = function () {
        var data = _super.prototype.saveData.call(this);
        this._communicator.saveData(this._sessionID, JSON.stringify(data));
    };
    PrototypeLogic.prototype.getSavedData = function () { };
    PrototypeLogic.prototype.requestSaveData = function () {
        var _this = this;
        this._communicator.requestSavedData(this._sessionID, function (response) {
            var data = response;
            if (data && data.playerData) {
                var playerData = data.playerData;
                if (typeof playerData.quickSpinActive !== 'undefined') {
                    _this.quickSpinActive = playerData.quickSpinActive;
                }
                if (typeof playerData.spacebarSpinActive !== 'undefined') {
                    _this.spacebarSpinActive = playerData.spacebarSpinActive;
                }
                if (typeof playerData.dragReelToSpinActive !== 'undefined') {
                    _this.dragReelToSpinActive = playerData.dragReelToSpinActive;
                }
                if (typeof playerData.quickStopActive !== 'undefined') {
                    _this.quickStopActive = playerData.quickStopActive;
                }
                if (typeof playerData.fastPlayActive !== 'undefined') {
                    _this.fastPlayActive = playerData.fastPlayActive;
                }
                if (typeof playerData.soundActive !== 'undefined') {
                    _this.soundEffectsActive = playerData.soundActive;
                }
                if (typeof playerData.voiceActive !== 'undefined') {
                    _this.voiceActive = playerData.voiceActive;
                }
                if (typeof playerData.musicActive !== 'undefined') {
                    _this.musicActive = playerData.musicActive;
                }
                if (typeof playerData.soundAllActive !== 'undefined') {
                    _this.soundAllActive = playerData.soundAllActive;
                }
                if (typeof playerData.lastBet !== 'undefined') {
                    _this.lastBet = playerData.lastBet;
                    _this.betValue = playerData.lastBet;
                }
                if (typeof playerData.lastBetWasMaxBet !== 'undefined') {
                    _this._lastBetWasMaxBet = playerData.lastBetWasMaxBet;
                }
                if (typeof playerData.skipIntro !== 'undefined') {
                    _this.skipIntro = playerData.skipIntro;
                }
                if (typeof playerData.autoplayData !== 'undefined') {
                    _this.autoplayDefault = playerData.autoplayData.autoplayValue;
                }
                if (typeof playerData.lastAutoplayAmount !== 'undefined') {
                    _this.lastAutoplayAmount = playerData.lastAutoplayAmount;
                }
                _this.hasSavedData = true;
            }
        });
    };
    PrototypeLogic.prototype.replay = function () {
        this._eventManager.emit(RelaxLogicEvents_1.RelaxLogicEvents.REPLAY_RESPONSE);
        // Implement? This shows the last round.
        throw new Error("Prototypelogic::Needs to be implemented - replay");
    };
    PrototypeLogic.prototype.ping = function (cb) {
        var _this = this;
        this._communicator.ping(this._sessionID, function (result) {
            var data = JSON.parse(result);
            if (_this.hasResponseError(data)) {
                _this.parseResponseError(data);
                return;
            }
            cb && cb(data);
            _this._eventManager.emit(LogicEvents_1.LogicEvents.PING_RESPONSE);
        });
    };
    PrototypeLogic.prototype.hasResponseError = function (data) {
        if ((data && data.hasOwnProperty('errorCode')) || data.hasOwnProperty('errorcode')) {
            return true;
        }
        return false;
    };
    PrototypeLogic.prototype.parseResponseError = function (data) {
        // TODO: Handle erros.
        // errorCode or errorcode : string
        // errorMessage : string
        // this._eventManager.emit();
    };
    PrototypeLogic.prototype.init = function (cb) {
        var _this = this;
        this.parsePlayerSavedData();
        this._communicator.init(this._gameName, function (result) {
            var data = JSON.parse(result);
            _this.reactOnInit(data);
            cb && cb(data);
            _this._eventManager.emit(LogicEvents_1.LogicEvents.INIT_RESPONSE);
        });
    };
    PrototypeLogic.prototype.reactOnInit = function (data) {
        this.parseInit(data);
        if (false) {
            console.warn('init:');
            console.warn(data);
        }
    };
    PrototypeLogic.prototype.spin = function (cb) {
        var _this = this;
        this.preSpinBalance = this.currentBalance;
        this.saveData();
        var betValue = this._betValue * 100;
        this._communicator.spin(this._sessionID, betValue, function (result) {
            var data = JSON.parse(result);
            _this.reactOnSpin(data);
            cb && cb(data);
            _this._eventManager.emit(LogicEvents_1.LogicEvents.SPIN_RESPONSE);
        });
    };
    PrototypeLogic.prototype.reactOnSpin = function (data) {
        this.onceBeforeSpinSetup();
        this._spin = this.createSpinResult();
        if (false) {
            console.warn('spin:');
            console.warn(data);
        }
        this.parseSpin(data);
    };
    PrototypeLogic.prototype.freeSpin = function (cb) {
        var _this = this;
        setTimeout(function () {
            _this.reactOnFreeSpin(_this._freeSpins[_this._currentFreeSpin]);
            cb && cb(_this._freeSpins[_this._currentFreeSpin]);
            _this._eventManager.emit(LogicEvents_1.LogicEvents.SPIN_RESPONSE);
        }, 0);
    };
    PrototypeLogic.prototype.reactOnFreeSpin = function (data) {
        this._currentFreeSpin++;
        this._spin = this.createSpinResult();
        if (false) {
            console.warn('freespin:');
            console.warn(data);
        }
        this.parseSpin(data);
    };
    PrototypeLogic.prototype.respin = function (cb) {
        var _this = this;
        setTimeout(function () {
            cb && cb(null);
            _this._eventManager.emit(LogicEvents_1.LogicEvents.RESPIN_RESPONSE);
        });
    };
    PrototypeLogic.prototype.avalanche = function (cb) {
        var _this = this;
        setTimeout(function () {
            cb && cb(null);
            _this._eventManager.emit(LogicEvents_1.LogicEvents.AVALANCHE_RESPONSE);
        });
    };
    PrototypeLogic.prototype.getCurrentRoundType = function () {
        return this._roundTypes[this._currentRound];
    };
    PrototypeLogic.prototype.getNextRoundType = function () {
        if (this._currentRound < this._roundTypes.length - 1) {
            return this._roundTypes[this._currentRound + 1];
        }
        return -1;
    };
    PrototypeLogic.prototype.getRoundIndex = function () {
        return this._currentRound;
    };
    PrototypeLogic.prototype.startNextRound = function () {
        if (this._currentRound < this._totalRounds - 1) {
            this._currentRound++;
            this.setResultsForCurrentRound();
        }
        else {
            this.cleanUp();
        }
    };
    PrototypeLogic.prototype.isInFirstFreeSpin = function () {
        return this.isInFreeSpins && this.freespinsTotalAwarded === this.freeSpinsLeft + 1;
    };
    PrototypeLogic.prototype.getPrototypeSpinResults = function () {
        return this._spin;
    };
    PrototypeLogic.prototype.getCurrentReelsSymbol = function (pos) {
        return this._currentRoundSymbols.find(function (item) {
            return item.position.x === pos.x && item.position.y === pos.y;
        });
    };
    PrototypeLogic.prototype.getFreeSpinsPlayed = function () {
        return this._currentFreeSpin;
    };
    PrototypeLogic.prototype.getFreeSpinsLeft = function () {
        return this._freeSpinsLeft;
    };
    PrototypeLogic.prototype.isEnoughMoneyForSpin = function () {
        return this._balance * Logic_1.Logic.CENT_TO_A_DOLLAR >= this.getTotalBet() || this._isFreeSpinsStarted;
    };
    PrototypeLogic.prototype.intializeServerSymbols = function () {
        throw new Error("PrototypeLogic::intializeServerSymbols must be implemented in game specific class");
    };
    PrototypeLogic.prototype.parseStats = function (data) {
        this._balance = data.stats.b;
    };
    PrototypeLogic.prototype.parseMessages = function (data) {
        for (var _i = 0, _a = data.messages; _i < _a.length; _i++) {
            var mess = _a[_i];
            this._messagesQueue.push({
                message: mess.message,
                title: mess.title,
                nonIntrusive: mess.nonintrusive,
            });
        }
    };
    PrototypeLogic.prototype.parseLimits = function (limits) {
        this._defaultBet = limits.defaultBet * Logic_1.Logic.CENT_TO_A_DOLLAR;
        this._betValues = [];
        for (var _i = 0, _a = limits.legalBets; _i < _a.length; _i++) {
            var bet = _a[_i];
            this._betValues.push(bet * Logic_1.Logic.CENT_TO_A_DOLLAR);
        }
    };
    PrototypeLogic.prototype.parseRefresh = function (refreshData) {
        // TODO: This is goinng to be part of the restores. But we need a game service (for Desert eg) to determine how we set it up.
        ////////////////////////////////////////////////////////////////////
        // Set this to attributes.
        ////////////////////////////////////////////////////////////////////
        // const multiplier: number = refreshData.multiplier;
        var ended = refreshData.ended;
        // const multiplierChoices: number[] = refreshData.multiplierChoices;
        // const stops: number[] = refreshData.stops;
        var roundType = refreshData.roundType; // Unsure.
        var winnings = refreshData.winnings; // Unsure.
        var win = refreshData.win; // Setup for restore.
        var symbols = refreshData.symbols; // Should be present in all games.
        var multiplierIndex = refreshData.multiplierIndex;
        var ba = refreshData.ba; // Short form of Bet Amount.
        this.betValue = ba;
    };
    // TODO: default initialization here is temporary - should be removed when real server arrives
    PrototypeLogic.prototype.parseInit = function (data) {
        this._sessionID = data.sid;
        if (data.totalFS) {
            this._lastFreeSpinsTotal = data.totalFS;
        }
        if (data.messages) {
            this.parseMessages(data);
        }
        if (data.stats) {
            this.parseStats(data);
        }
        if (data.limits) {
            this.parseLimits(data.limits);
        }
        this._allReelsets = [];
        if (data.config && data.config.reelgrids) {
            var grids = !!data.config.reelgrids ? data.config.reelgrids : data.config.grids;
            for (var grid in grids) {
                if (grids.hasOwnProperty(grid)) {
                    var reelgrid = grids[grid];
                    var reelIndex = -1;
                    var currentReelset = { name: reelgrid.name, symbols: [], symbolsIDs: [] };
                    for (var _i = 0, _a = reelgrid.reels; _i < _a.length; _i++) {
                        var reel = _a[_i];
                        currentReelset.symbols.push([]);
                        currentReelset.symbolsIDs.push([]);
                        reelIndex++;
                        for (var _b = 0, reel_1 = reel; _b < reel_1.length; _b++) {
                            var sym = reel_1[_b];
                            currentReelset.symbols[reelIndex].push(this._serverSymbols[sym]);
                            currentReelset.symbolsIDs[reelIndex].push(sym);
                        }
                    }
                    this._allReelsets.push(currentReelset);
                }
            }
            this._currentReelset = this._allReelsets[0];
        }
        else {
            var defDataString = '[{"name":"baseGameGrid","reels":[["F9","F9","F9","F9","M4","M4","M4","M4","F8","F8","F8","F8","M3","M3","M3","M3","F9","F9","F9","WR","M1","M1","M1","F6","F6","F6","F6","M2","M2","M2","M2","F9","F9","F9","F9","M4","M4","M4","M4","F7","F7","F7","F7","M1","M1","M1","WR","M5","M5","M5","F7","F7","F7","F7","M4","F8","WR","F9","M5","F6","F6","F6","F6","M3","M3","F7","F7","F6","F6","WR","WR","F9","F9","F6","F6","M4","M4","F9","F9","F9","F9","M1","M1","M1","M1","F6","F6","F6","F6","M3","M3","M3","M3","F9","F9","F9","F9","M3","M3","M3","M3","F7","F7","M5","M5","WR","WR","M4","M4","F8","F8","M5","M5","M5","M5","F6","F6","F6","F6","M5","M5","M5","M5","F9","F9","F9","F9","M5","M5","M5","M5","F7","F7","F7","F7","M3","M3","M3","M3","F6","F6","F6","F6","M5","M5","M5","M5","M4","M4","M4","M4","F9","F9","F9","F9","M3","F8","WR","F7","F9","F6","F6","F6","F6","M2","M2","M2","M2","F8","F8","F8","F8","M5","M5","M5","M5","F6","F6","F6","F6","M4","M4","M4","M4","F8","F8","F8","F8","M1","M1","M1","M1","F9","F9","F9","F9","M4","M4","M4","M4"],["F6","F6","F6","F6","M2","M2","M2","M2","F7","F7","F7","F7","M4","M4","M4","M4","F8","F8","F8","F8","M1","M1","M1","M1","F9","F9","F9","F9","M1","M1","WR","WR","WR","WR","F8","F8","M3","M3","M3","M3","F7","F7","F7","F7","BN","F6","F6","F6","F6","M5","M5","M5","M5","M2","M2","M2","M2","F9","F9","F9","F9","M4","M4","M4","M4","F7","F7","F7","F7","BN","F8","F8","F8","BN","F7","F7","F7","BN","F6","F6","F6","F6","M4","M4","F7","F6","M2","M2","M4","M4","F6","F8","F9","BN","F7","F7","F7","BN","F6","F6","F6","F6","M1","M1","M1","M1","F8","F8","F8","F8","BN","F6","F6","F6","F6","M2","M2","M2","M2","M5","M5","M5","M5","F8","F8","F8","F8","M4","M4","M4","M4","F7","F8","F8","F8","F8","F8","F6","F9","M2","M2","M2","M2","M3","M3","M3","M3","F8","F8","M3","F9","WR","WR","WR","WR","F6","M2","F7","F7","F7","M4","M4","M4","M4","F7","F7","F7","F7","M2","M2","M2","M2","M1","M1","M1","M1","F8","F8","F8","F8","BN","F6","F6","F6","BN","F9","F9","F9","BN","F8","F8","F8","M1","M1","M1","M1","F7","F7","F7","F7"],["M5","M5","M5","M5","F7","F7","F7","F7","M3","M3","M3","M3","F8","F8","F8","F8","M4","M4","M4","M4","F9","F9","F9","F6","RSWR1","F7","F8","RSWR2","F9","F9","F9","BN","F7","F7","F7","F7","M5","M5","M5","M5","F9","F9","F7","F6","WR","WR","WR","WR","F9","F8","F8","F8","F9","F9","F9","F9","M5","M5","M5","M5","F9","F9","F9","F9","M1","M1","M1","M1","F7","F7","F7","F9","F8","WR","WR","WR","WR","F6","F8","F9","M3","M3","M3","M3","F6","F7","BN","M5","M4","F9","F9","M3","M2","RSWR1","F7","RSWR2","F8","F8","F8","M2","M2","M2","M3","F9","F7","F6","F8","M1","M1","M1","F8","F8","F8","F8","M2","M2","M2","M2","F8","F7","RSWR3","F9","RSWR4","F6","F6","F6","F6","M3","M3","M3","M3","F9","F9","F9","F9","M4","M4","M4","M4","F7","F7","F7","F7","RSWR4","F9","F9","F9","M2","M2","M2","M2","F8","F8","F8","F8","M2","M2","M2","M2","F8","F8","F7","F7","F7","RSWR2","F8","F8","F8","M3","M3","M3","F7","F9","BN","F6","F8","M5","M5","M5","M5","F7","F7","F7","F7","BN","F9","F9","F9","BN","F6","F8","F9","BN","F6","M2","F8","F8","F8","F8","M5","M5","M5","M5","F7","F7","F7","F7","M3","M3","M3","M3","F8","F8","F8","F8","M4","M4","M4","M4","F9","F9","F9","RSWR4","F6","F7","F8","RSWR1","F9","F9","F9","BN","F7","F7","F7","F7","M5","M5","M5","M5","F9","F9","F7","F6","WR","WR","WR","WR","F9","F8","F8","F8","F9","F9","F9","F9","M5","M5","M5","M5","F9","F9","F9","F9","M1","M1","M1","M1","F7","F7","F7","F9","F8","WR","WR","WR","WR","F6","F8","F9","M3","M3","M3","M3","F6","F7","BN","M5","M4","F9","F9","M3","M2","RSWR2","RSWR3","F7","F8","F8","M2","M2","M2","M3","F9","F7","RSWR3","F6","F8","M1","M1","M1","F8","F8","F8","F8","M2","M2","M2","M2","F6","RSWR1","F8","F9","F7","RSWR3","F6","F6","F6","M3","M3","M3","M3","F9","F9","F9","F9","M4","M4","M4","M4","F7","F7","F7","F7","F9","F9","F9","F9","M2","M2","M2","M2","F8","F8","F8","F8","M2","M2","M2","M2","F8","F8","F8","RSWR4","F7","F7","F7","F8","F8","F8","M3","M3","M3","F7","F9","BN","F6","F8","M5","M5","M5","M5","F7","F7","F7","F7","BN","F9","F9","F9","BN","F6","F8","F9","BN","F6","M2","F7","F8","F8","F8","F8"],["M3","M3","M3","M3","F8","F9","WR","WR","WR","WR","F7","F6","M4","M4","M4","M4","BN","F8","F8","F8","F8","BN","F9","F9","F9","F9","M1","M1","M1","M1","F8","F8","F8","F8","M5","M5","M5","M5","F6","F6","F6","F6","M2","M2","M2","M2","F8","F6","BN","F7","F7","F7","BN","M4","M4","M4","M4","F9","F9","F9","F9","M2","M2","M2","M2","F6","F6","F6","RSWR2","F8","F8","F8","F8","M5","M5","M5","M5","F9","F9","F9","F9","M1","M1","M1","M1","F7","F7","F7","BN","M3","M3","M3","M3","F8","F8","F8","F8","M2","M2","M2","M2","F6","F6","F6","F6","BN","F7","F7","F7","BN","F9","F9","F9","F7","WR","WR","WR","WR","F9","F8","F8","F8","BN","M3","M3","M3","M3","F7","F7","F7","F7","M5","M5","M5","M5","BN","F9","F9","F9","RSWR1","F9","RSWR3","F7","F7","F6","RSWR4","F9","M4","M4","M4","M4","F6","F8","WR","WR","WR","WR","F7","F9","F8","F8","F8","M5","M5","M5","M5","F9","F9","F9","RSWR3","F8","F8","F8","RSWR4","F7","F7","F7","BN","F6","F6","F6","M4","M4","M4","BN","F9","F9","F9","F9","BN","F8","F6","F6","M3","M3","RSWR3","F7","F8","RSWR4","M2","M3","M3","M3","M3","F8","F9","WR","WR","WR","WR","F7","F6","M4","M4","M4","M4","BN","F8","F8","F8","F8","BN","F9","F9","F9","F9","M1","M1","M1","M1","F8","F8","F8","BN","M5","M5","M5","M5","F6","F6","F6","F6","M2","M2","M2","M2","F8","F6","BN","F7","F7","F7","BN","M4","M4","M4","M4","F9","F9","F9","F9","M2","M2","M2","M2","F6","F6","F6","RSWR2","F8","F8","F8","F8","M5","M5","M5","M5","BN","F9","F9","F9","M1","M1","M1","M1","F7","F7","F7","BN","M3","M3","M3","M3","F8","F8","F8","F8","M2","M2","M2","M2","F6","F6","F6","F6","BN","F7","F7","F7","BN","F9","F9","F9","F7","WR","WR","WR","WR","F9","F8","F8","F8","BN","M3","M3","M3","M3","F7","F7","F7","F7","M5","M5","M5","M5","BN","F9","F9","F9","RSWR1","RSWR2","RSWR4","F6","F7","F8","F9","F9","M4","M4","M4","M4","F6","F8","WR","WR","WR","WR","F7","F9","F8","F8","F8","M5","M5","M5","M5","F9","F9","F9","RSWR3","RSWR2","F8","RSWR1","F6","F7","F7","F7","BN","F6","F6","F6","M4","M4","M4","BN","F9","F9","F9","F9","BN","F8","F6","F6","M3","M3","F7","RSWR1","F8","F6","M2"],["F6","F6","F6","F6","M2","M2","M2","M2","M4","M4","M4","M4","M3","M3","M3","M3","F8","F8","F8","F8","WR","M5","M5","M5","M5","F7","F7","F7","F7","M2","M2","M2","M2","F9","F9","F9","F9","F7","F7","F7","F7","F9","RSWR1","RSWR2","RSWR3","RSWR4","F8","F8","F9","F9","F9","WR","WR","WR","WR","F8","F8","F7","F7","F7","F7","WR","F6","F6","F6","F6","M4","M4","M4","M4","F8","F8","F8","F8","F9","F9","F9","F9","M5","M5","M5","M5","M1","M1","M1","M1","F6","F6","F6","F6","F7","F8","F8","F8","F8","M4","M4","M4","M4","M3","M3","M3","M3","F6","F6","F6","F6","M5","M5","M5","M5","M2","M2","M2","M2","M3","M3","M3","M3","M1","M1","M1","M1","F6","F6","F6","F6","M1","M1","M1","M1","M5","M5","M5","M5","F9","F9","F9","F9","RSWR2","F7","F7","F7","WR","F8","F8","F8","F7","F6","RSWR3","RSWR2","F8","RSWR1","F9","F9","F9","F9","M3","M3","M3","M3","M4","M4","M4","M4","F8","F8","F8","WR","F7","F7","F7","RSWR4","F6","F6","F6","M5","M5","WR","M2","M1","F9","F9","F9","F9","M2","M2","F8","F7","M4","F6","WR","F7","F7","M1","F7","F8","F8","F9","F9","RSWR4","F6","F6","F6","M2","M2","M2","M2","M4","M4","M4","M4","M3","M3","M3","M3","F8","F8","F8","F8","WR","M5","M5","M5","M5","F7","F7","F7","F7","M2","M2","M2","M2","F9","F9","F9","F9","F7","F7","F7","F7","F9","RSWR3","F6","RSWR1","F8","F8","F8","F9","F9","F9","WR","WR","WR","WR","F8","F8","F7","F7","WR","WR","WR","WR","F6","F6","F6","M4","M4","M4","M4","F8","F8","F8","F8","F9","F9","F9","F9","M5","M5","WR","WR","WR","WR","M1","M1","F6","F6","F6","F6","F7","F8","F8","F8","F8","M4","M4","M4","M4","M3","M3","M3","M3","F6","F6","F6","F6","M5","M5","M5","M5","M2","M2","M2","M2","M3","M3","M3","M3","M1","M1","M1","M1","F6","F6","F6","F6","M1","M1","M1","M1","M5","M5","M5","M5","F9","F9","F9","F9","RSWR2","F7","F7","F7","WR","F8","F8","F8","F7","F6","RSWR3","F9","F8","RSWR1","F9","F9","F9","F9","M3","M3","M3","M3","M4","M4","M4","M4","F8","F8","F8","WR","F7","F7","F7","RSWR4","F6","F6","F6","M5","M5","WR","M2","M1","F9","F9","F9","F9","M2","M2","F8","F7","M4","F6","WR","F7","F7","M1","F7","F8","F8","F9","F9"]]},{"name":"freeGameGrid","reels":[["F9","F9","F9","F9","M4","M4","M4","M4","F8","F8","F8","F8","M3","M3","M3","M3","F9","F9","F9","WR","M1","M1","M1","F6","F6","F6","F6","M2","M2","M2","M2","F9","F9","F9","F9","M4","M4","M4","M4","F7","F7","F7","F7","M1","M1","M1","WR","M5","M5","M5","F7","F7","F7","F7","M4","F8","WR","F9","M5","F6","F6","F6","F6","M3","M3","F7","F7","F6","F6","WR","WR","F9","F9","F6","F6","M4","M4","F9","F9","F9","F9","M1","M1","M1","M1","F6","F6","F6","F6","M3","M3","M3","M3","F9","F9","F9","F9","M3","M3","M3","M3","F7","F7","M5","M5","WR","WR","M4","M4","F8","F8","M5","M5","M5","M5","F6","F6","F6","F6","M5","M5","M5","M5","F9","F9","F9","F9","M5","M5","M5","M5","F7","F7","F7","F7","M3","M3","M3","M3","F6","F6","F6","F6","M5","M5","M5","M5","M4","M4","M4","M4","F9","F9","F9","F9","M3","F8","WR","F7","F9","F6","F6","F6","F6","M2","M2","M2","M2","F8","F8","F8","F8","M5","M5","M5","M5","F6","F6","F6","F6","M4","M4","M4","M4","F8","F8","F8","F8","M1","M1","M1","M1","F9","F9","F9","F9","M4","M4","M4","M4"],["F6","F6","F6","F6","M2","M2","M2","M2","F7","F7","F7","F7","M4","M4","M4","M4","F8","F8","F8","F8","M1","M1","M1","M1","F9","F9","F9","F9","M1","M1","M1","M1","F8","F8","F8","F8","M3","M3","M3","M3","F7","F7","F7","F7","F7","F6","F6","F6","F6","M5","M5","M5","M5","M2","M2","M2","M2","F9","F9","F9","F9","M4","M4","M4","M4","F7","F7","F7","F7","F8","F8","F8","F8","F7","F7","F7","F7","F6","F6","F6","F6","F6","M4","M4","F7","F6","M2","M2","M4","M4","F6","F8","F9","F7","F7","F7","F7","F6","F6","F6","F6","F6","M1","M1","M1","M1","F8","F8","F8","F8","F8","F6","F6","F6","F6","M2","M2","M2","M2","M5","M5","M5","M5","F8","F8","F8","F8","M4","M4","M4","M4","F7","F8","WR","WR","WR","WR","F6","F9","M2","M2","M2","M2","M3","M3","M3","M3","F8","F8","M3","F9","WR","WR","WR","WR","F6","M2","F7","F7","F7","M4","M4","M4","M4","F7","F7","F7","F7","M2","M2","M2","M2","M1","M1","M1","M1","F8","F8","F8","F8","F6","F6","F6","F6","F9","F9","F9","F9","F8","F8","F8","F8","M1","M1","M1","M1","F7","F7","F7","F7"],["M5","M5","M5","M5","F7","F7","F7","F7","M3","M3","M3","M3","F8","F8","F8","F8","M4","M4","M4","M4","F9","F9","F9","F6","RSWR1","F7","F8","RSWR2","F9","F9","F9","F9","F7","F7","F7","F7","M5","M5","M5","M5","F9","F9","F7","F6","WR","WR","WR","WR","F9","F8","F8","F8","F9","F9","F9","F9","M5","M5","M5","M5","F9","F9","F9","F9","M1","M1","M1","M1","F7","F7","F7","F9","F8","WR","WR","WR","WR","F6","F8","F9","M3","M3","M3","M3","F6","F7","F7","M5","M4","F9","F9","M3","M2","RSWR1","F7","RSWR2","F8","F8","F8","M2","M2","M2","M3","F9","F7","F6","F8","M1","M1","M1","F8","F8","F8","F8","M2","M2","M2","M2","F8","F7","RSWR3","F9","RSWR4","F6","F6","F6","F6","M3","M3","M3","M3","F9","F9","F9","F9","M4","M4","M4","M4","F7","F7","F7","F7","RSWR4","F9","F9","F9","M2","M2","M2","M2","F8","F8","F8","F8","M2","M2","M2","M2","F8","F8","F7","F7","F7","RSWR2","F8","F8","F8","M3","M3","M3","F7","F9","F6","F6","F8","M5","M5","M5","M5","F7","F7","F7","F7","F9","F9","F9","F9","F6","F6","F8","F9","F6","F6","M2","F8","F8","F8","F8","M5","M5","M5","M5","F7","F7","F7","F7","M3","M3","M3","M3","F8","F8","F8","F8","M4","M4","M4","M4","F9","F9","F9","RSWR4","F6","F7","F8","RSWR1","F9","F9","F9","F9","F7","F7","F7","F7","M5","M5","M5","M5","F9","F9","F7","F6","WR","WR","WR","WR","F9","F8","F8","F8","F9","F9","F9","F9","M5","M5","M5","M5","F9","F9","F9","F9","M1","M1","M1","M1","F7","F7","F7","F9","F8","WR","WR","WR","WR","F6","F8","F9","M3","M3","M3","M3","F6","F7","F7","M5","M4","F9","F9","M3","M2","RSWR2","RSWR3","F7","F8","F8","M2","M2","M2","M3","F9","F7","RSWR3","F6","F8","M1","M1","M1","F8","F8","F8","F8","M2","M2","M2","M2","F6","RSWR1","F8","F9","F7","RSWR3","F6","F6","F6","M3","M3","M3","M3","F9","F9","F9","F9","M4","M4","M4","M4","F7","F7","F7","F7","F9","F9","F9","F9","M2","M2","M2","M2","F8","F8","F8","F8","M2","M2","M2","M2","F8","F8","F8","RSWR4","F7","F7","F7","F8","F8","F8","M3","M3","M3","F7","F9","F6","F6","F8","M5","M5","M5","M5","F7","F7","F7","F7","F9","F9","F9","F9","F6","F6","F8","F9","F9","F6","M2","F7","F8","F8","F8","F8"],["M3","M3","M3","M3","F8","F9","WR","WR","WR","WR","F7","F6","M4","M4","M4","M4","F8","F8","F8","F8","F8","F9","F9","F9","F9","F9","M1","M1","M1","M1","F8","F8","F8","F8","M5","M5","M5","M5","F6","F6","F6","F6","M2","M2","M2","M2","F8","F6","F6","F7","F7","F7","F7","M4","M4","M4","M4","F9","F9","F9","F9","M2","M2","M2","M2","F6","F6","F6","RSWR2","F8","F8","F8","F8","M5","M5","M5","M5","F9","F9","F9","F9","M1","M1","M1","M1","F7","F7","F7","F7","M3","M3","M3","M3","F8","F8","F8","F8","M2","M2","M2","M2","F6","F6","F6","F6","F7","F7","F7","F7","F9","F9","F9","F9","F7","WR","WR","WR","WR","F9","F8","F8","F8","F8","M3","M3","M3","M3","F7","F7","F7","F7","M5","M5","M5","M5","F9","F9","F9","F9","RSWR1","F9","RSWR3","F7","F7","F6","RSWR4","F9","M4","M4","M4","M4","F6","F8","WR","WR","WR","WR","F7","F9","F8","F8","F8","M5","M5","M5","M5","F9","F9","F9","RSWR3","F8","F8","F8","RSWR4","F7","F7","F7","F6","F6","F6","F6","M4","M4","M4","M4","F9","F9","F9","F9","F8","F8","F6","F6","M3","M3","RSWR3","F7","F8","RSWR4","M2","M3","M3","M3","M3","F8","F9","WR","WR","WR","WR","F7","F6","M4","M4","M4","M4","F8","F8","F8","F8","F8","F9","F9","F9","F9","F9","M1","M1","M1","M1","F8","F8","F8","F8","M5","M5","M5","M5","F6","F6","F6","F6","M2","M2","M2","M2","F8","F6","F6","F7","F7","F7","F7","M4","M4","M4","M4","F9","F9","F9","F9","M2","M2","M2","M2","F6","F6","F6","RSWR2","F8","F8","F8","F8","M5","M5","M5","M5","F9","F9","F9","F9","M1","M1","M1","M1","F7","F7","F7","F7","M3","M3","M3","M3","F8","F8","F8","F8","M2","M2","M2","M2","F6","F6","F6","F6","F7","F7","F7","F7","F7","F9","F9","F9","F7","WR","WR","WR","WR","F9","F8","F8","F8","F8","M3","M3","M3","M3","F7","F7","F7","F7","M5","M5","M5","M5","F9","F9","F9","F9","RSWR1","RSWR2","RSWR4","F6","F7","F8","F9","F9","M4","M4","M4","M4","F6","F8","WR","WR","WR","WR","F7","F9","F8","F8","F8","M5","M5","M5","M5","F9","F9","F9","RSWR3","RSWR2","F8","RSWR1","F6","F7","F7","F7","F6","F6","F6","F6","M4","M4","M4","M4","F9","F9","F9","F9","F8","F8","F6","F6","M3","M3","F7","RSWR1","F8","F6","M2"],["F6","F6","F6","F6","M2","M2","M2","M2","M4","M4","M4","M4","M3","M3","M3","M3","F8","F8","F8","F8","WR","M5","M5","M5","M5","F7","F7","F7","F7","M2","M2","M2","M2","F9","F9","F9","F9","F7","F7","F7","F7","F9","RSWR1","RSWR2","RSWR3","RSWR4","F8","F8","F9","F9","F9","F6","F6","F8","F8","F8","F8","F7","F7","F7","F7","WR","F6","F6","F6","F6","M4","M4","M4","M4","F8","F8","F8","F8","F9","F9","F9","F9","M5","M5","M5","M5","M1","M1","M1","M1","F6","F6","F6","F6","F7","F8","F8","F8","F8","M4","M4","M4","M4","M3","M3","M3","M3","F6","F6","F6","F6","M5","M5","M5","M5","M2","M2","M2","M2","M3","M3","M3","M3","M1","M1","M1","M1","F6","F6","F6","F6","M1","M1","M1","M1","M5","M5","M5","M5","F9","F9","F9","F9","RSWR2","F7","F7","F7","WR","F8","F8","F8","F7","F6","RSWR3","RSWR2","F8","RSWR1","F9","F9","F9","F9","M3","M3","M3","M3","M4","M4","M4","M4","F8","F8","F8","WR","F7","F7","F7","RSWR4","F6","F6","F6","M5","M5","WR","M2","M1","F9","F9","F9","F9","M2","M2","F8","F7","M4","F6","WR","F7","F7","M1","F7","F8","F8","F9","F9","RSWR4","F6","F6","F6","M2","M2","M2","M2","M4","M4","M4","M4","M3","M3","M3","M3","F8","F8","F8","F8","WR","M5","M5","M5","M5","F7","F7","F7","F7","M2","M2","M2","M2","F9","F9","F9","F9","F7","F7","F7","F7","F9","RSWR3","F6","RSWR1","F8","F8","F8","F9","F9","F9","F6","F6","F8","F8","F8","F8","F7","F7","F7","F7","WR","F6","F6","F6","F6","M4","M4","M4","M4","F8","F8","F8","F8","F9","F9","F9","F9","M5","M5","M5","M5","M1","M1","M1","M1","F6","F6","F6","F6","F7","F8","F8","F8","F8","M4","M4","M4","M4","M3","M3","M3","M3","F6","F6","F6","F6","M5","M5","M5","M5","M2","M2","M2","M2","M3","M3","M3","M3","M1","M1","M1","M1","F6","F6","F6","F6","M1","M1","M1","M1","M5","M5","M5","M5","F9","F9","F9","F9","RSWR2","F7","F7","F7","WR","F8","F8","F8","F7","F6","RSWR3","F9","F8","RSWR1","F9","F9","F9","F9","M3","M3","M3","M3","M4","M4","M4","M4","F8","F8","F8","WR","F7","F7","F7","RSWR4","F6","F6","F6","M5","M5","WR","M2","M1","F9","F9","F9","F9","M2","M2","F8","F7","M4","F6","WR","F7","F7","M1","F7","F8","F8","F9","F9"]]}]';
            var defData = JSON.parse(defDataString);
            for (var _c = 0, defData_1 = defData; _c < defData_1.length; _c++) {
                var reelgrid = defData_1[_c];
                var reelIndex = -1;
                var currentReelset = { name: reelgrid.name, symbols: [], symbolsIDs: [] };
                for (var _d = 0, _e = reelgrid.reels; _d < _e.length; _d++) {
                    var reel = _e[_d];
                    currentReelset.symbols.push([]);
                    currentReelset.symbolsIDs.push([]);
                    reelIndex++;
                    for (var _f = 0, reel_2 = reel; _f < reel_2.length; _f++) {
                        var sym = reel_2[_f];
                        currentReelset.symbols[reelIndex].push(this._serverSymbols[sym]);
                        currentReelset.symbolsIDs[reelIndex].push(sym);
                    }
                }
                this._allReelsets.push(currentReelset);
            }
            this._currentReelset = this._allReelsets[0];
        }
        if (data.config && data.config.mathversion) {
            this._mathVersion = data.config.mathversion;
        }
        else {
            this._mathVersion = '';
        }
    };
    PrototypeLogic.prototype.onceBeforeSpinSetup = function () {
        this._currentFreeSpin = -1;
        this._freeSpins = [];
    };
    PrototypeLogic.prototype.parseAvalanches = function (data) {
        this._avalanches = [];
        var avalancheIndex = 0;
        for (var _i = 0, _a = data.generations; _i < _a.length; _i++) {
            var avalancheData = _a[_i];
            var avalanche = {
                initialSymbols: [],
                symbolsAfterRemoval: [],
                newSymbols: [],
                win: 0,
                winnings: [],
            };
            var reelIndex = 0;
            for (var _b = 0, _c = avalancheData.symbols; _b < _c.length; _b++) {
                var reel = _c[_b];
                avalanche.initialSymbols.push([]);
                for (var _d = 0, reel_3 = reel; _d < reel_3.length; _d++) {
                    var sym = reel_3[_d];
                    avalanche.initialSymbols[reelIndex].push(new GameSymbol_1.GameSymbol(this._serverSymbols[sym], { width: 1, height: 1 }, { x: -1, y: -1 }));
                }
                reelIndex++;
            }
            if (avalancheData.win) {
                avalanche.win = avalancheData.win;
            }
            var removedSymbols = [];
            if (avalancheData.winnings) {
                for (var _e = 0, _f = avalancheData.winnings; _e < _f.length; _e++) {
                    var win = _f[_e];
                    var winning = {
                        winType: win[0],
                        winPositions: [],
                        winLength: 0,
                        win: win[2],
                        lineIndex: win[1],
                        winSymbol: this._serverSymbols[win[4]],
                    };
                    var _loop_1 = function (wl) {
                        winning.winPositions.push({ x: wl.x, y: wl.y });
                        var shouldAddSymbol = removedSymbols.findIndex(function (item) {
                            return item.x === wl.x && item.y === wl.y;
                        }) < 0;
                        if (shouldAddSymbol) {
                            removedSymbols.push({ x: wl.x, y: wl.y });
                        }
                    };
                    for (var _g = 0, _h = win[3]; _g < _h.length; _g++) {
                        var wl = _h[_g];
                        _loop_1(wl);
                    }
                    winning.winLength = winning.winPositions.length;
                    avalanche.winnings.push(winning);
                }
            }
            var winSymbolsOnEachPosition = [0, 0, 0, 0, 0, 0];
            for (var _j = 0, removedSymbols_1 = removedSymbols; _j < removedSymbols_1.length; _j++) {
                var removedSymbol = removedSymbols_1[_j];
                winSymbolsOnEachPosition[removedSymbol.x]++;
            }
            reelIndex = 0;
            for (reelIndex = 0; reelIndex < winSymbolsOnEachPosition.length; reelIndex++) {
                var totalWinningSymbols = winSymbolsOnEachPosition[reelIndex];
                avalanche.newSymbols.push([]);
                for (var symbolIndex = 0; symbolIndex < totalWinningSymbols; symbolIndex++) {
                    var symVal = data.generations[avalancheIndex + 1].symbols[reelIndex][symbolIndex];
                    avalanche.newSymbols[reelIndex].push(new GameSymbol_1.GameSymbol(this._serverSymbols[symVal], {
                        width: 1,
                        height: 1,
                    }, { x: -1, y: -1 }));
                }
            }
            if (avalanche.winnings.length > 0) {
                this._roundTypes.push(ServerAvalancheReelsRound_1.ServerEvents.AVALANCHE);
            }
            this._avalanches.push(avalanche);
            avalancheIndex++;
        }
    };
    PrototypeLogic.prototype.parseSpin = function (data) {
        this.prepareInGameProgressValues();
        if (data.stats) {
            this._balance = data.stats.b;
            this.getPrototypeSpinResults().setBalance(data.stats.b);
        }
        if (!this.isInFreeSpins && data.totalFS) {
            this._lastFreeSpinsTotal = data.totalFS;
        }
        this._roundTypes.push(ServerAvalancheReelsRound_1.ServerEvents.SPIN);
        this.parseAvalanches(data);
        if (data.grid) {
            var currentReelsetName = data.grid;
            this.changeCurrentReelset(currentReelsetName);
        }
        if (data.replacements) {
            this._replacements = {};
            for (var replacement in data.replacements) {
                this._replacements[replacement] = data.replacements[replacement];
            }
            this.applyReplacementsToCurrentReelset();
        }
        if (data.initialSymbols) {
            var reelIndex = 0;
            for (var _i = 0, _a = data.initialSymbols; _i < _a.length; _i++) {
                var reel = _a[_i];
                var rowIndex = 0;
                for (var _b = 0, reel_4 = reel; _b < reel_4.length; _b++) {
                    var sym = reel_4[_b];
                    this._initialReels.push(new GameSymbol_1.GameSymbol(this._serverSymbols[sym], {
                        width: 1,
                        height: 1,
                    }, { x: reelIndex, y: rowIndex }));
                    this._currentRoundSymbols.push(new GameSymbol_1.GameSymbol(this._serverSymbols[sym], {
                        width: 1,
                        height: 1,
                    }, { x: reelIndex, y: rowIndex }));
                    rowIndex++;
                }
                reelIndex++;
            }
        }
        if (data.stops) {
            for (var _c = 0, _d = data.stops; _c < _d.length; _c++) {
                var stop_1 = _d[_c];
                this._stopPositions.push(stop_1);
            }
            this.getPrototypeSpinResults().setStopPositions(this._stopPositions);
        }
        if (data.totalwin) {
            this.getPrototypeSpinResults().setRoundWin(data.spinwin);
            this.getPrototypeSpinResults().setTotalWin(data.totalwin);
        }
        else if (data.cumulativeWins) {
            this.getPrototypeSpinResults().setRoundWin(data.spinwin);
        }
        if (data.mult) {
            this._currentMultiplier = data.mult;
        }
        else {
            this._currentMultiplier = 1;
        }
        if (data.hasOwnProperty('nscatters')) {
            this.getPrototypeSpinResults().scattersNum = data.nscatters;
        }
        this.parseOtherData(data);
        this.parseFreeSpinsData(data);
        this._totalRounds = this._roundTypes.length;
        this.setResultsForCurrentRound();
    };
    PrototypeLogic.prototype.parseFreeSpinsData = function (data) {
        if (data.freespins && data.freespins.length > 0) {
            this.initializeFreeSpinsFromData(data);
        }
        else {
            if (data.hasOwnProperty('spinsLeft')) {
                this.initializeFreeSpinFromData(data);
            }
            else {
                this._freeSpinsLeft = -1;
            }
        }
        this.parseTotalWin(data);
    };
    PrototypeLogic.prototype.parseTotalWin = function (data) {
        if (data.totalwin) {
            this.getPrototypeSpinResults().setRoundWin(data.spinwin);
            this.getPrototypeSpinResults().setTotalWin(data.totalwin);
        }
        else if (data.cumulativeWins) {
            this.getPrototypeSpinResults().setRoundWin(data.spinwin);
            this.getPrototypeSpinResults().setTotalWin(data.spinwin);
            this._freeSpinsTotalWin = data.cumulativeWins;
        }
    };
    PrototypeLogic.prototype.initializeFreeSpinFromData = function (data) {
        if (data.hasOwnProperty('spinsLeft')) {
            this._freeSpinsLeft = data.spinsLeft;
            if (this._freeSpinsLeft === 0) {
                this._roundTypes.push(ServerAvalancheReelsRound_1.ServerEvents.SPIN);
            }
            else {
                this._roundTypes.push(ServerAvalancheReelsRound_1.ServerEvents.FREE_SPIN);
            }
            if (this._isInFreeSpins && data.totalFS !== 0 && this._lastFreeSpinsTotal !== data.totalFS) {
                this._hasFreeSpinsRetrigger = true;
                this._freeSpinsAdded = data.totalFS - this._lastFreeSpinsTotal;
                this._lastFreeSpinsTotal = data.totalFS;
            }
            else {
                this._hasFreeSpinsRetrigger = false;
            }
        }
    };
    PrototypeLogic.prototype.initializeFreeSpinsFromData = function (data) {
        if (data.freespins && data.freespins.length > 0) {
            for (var _i = 0, _a = data.freespins; _i < _a.length; _i++) {
                var fs = _a[_i];
                this._freeSpins.push(fs);
                fs.spinsLeft = data.freespins.length - data.freespins.indexOf(fs) - 1;
            }
            this._roundTypes.push(ServerAvalancheReelsRound_1.ServerEvents.FREE_SPIN);
            this._freeSpinsLeft = this._freeSpins.length;
            this._freespinsTotalAwarded = this._freeSpins.length;
            this._currentFreeSpin = -1;
            this._beforeFSReels = [];
            for (var _b = 0, _c = this._initialReels; _b < _c.length; _b++) {
                var sym = _c[_b];
                this._beforeFSReels.push(new GameSymbol_1.GameSymbol(sym.sym, { width: 1, height: 1 }, {
                    x: sym.position.x,
                    y: sym.position.y,
                }));
            }
            this._lastFreeSpinsTotal = data.freespins[0].totalFS;
        }
    };
    PrototypeLogic.prototype.parseOtherData = function (data) {
    };
    PrototypeLogic.prototype.applyReplacementsToCurrentReelset = function () {
        for (var replacement in this._replacements) {
            this._serverSymbols[replacement] = this._serverSymbols[this._replacements[replacement]];
        }
        for (var reelIndex = 0; reelIndex < this._currentReelset.symbols.length; reelIndex++) {
            for (var rowIndex = 0; rowIndex < this._currentReelset.symbols[reelIndex].length; rowIndex++) {
                this._currentReelset.symbols[reelIndex][rowIndex] = this._serverSymbols[this._currentReelset.symbolsIDs[reelIndex][rowIndex]];
            }
        }
    };
    PrototypeLogic.prototype.changeCurrentReelset = function (currentReelsetName) {
        var currentReelsetIndex = this._allReelsets.findIndex(function (item) {
            return item.name === currentReelsetName;
        });
        if (currentReelsetIndex < 0) {
            throw new Error("PrototypeLogic::changeCurrentReelset reelset " + currentReelsetName + " not found");
        }
        this._currentReelset = this._allReelsets[currentReelsetIndex];
    };
    PrototypeLogic.prototype.positionToSymIndex = function (position) {
        return position.x * ReelConstants_1.ReelConstants.ROW_AMOUNT + position.y;
    };
    PrototypeLogic.prototype.prepareInGameProgressValues = function () {
        this._roundTypes = [];
        this._initialReels = [];
        this._stopPositions = [];
        this._currentRoundSymbols = [];
        this._newSymbols = [];
        this._currentNewSymbolsIndex = -1;
        this._winLines = [];
        this._currentRound = 0;
        this._totalRounds = 0;
        this._currentWinLines = -1;
    };
    PrototypeLogic.prototype.setNextAction = function () {
        switch (this.getNextRoundType()) {
            case ServerAvalancheReelsRound_1.ServerEvents.SPIN:
                this._nextAction = Action_1.Action.SPIN;
                break;
            case ServerAvalancheReelsRound_1.ServerEvents.AVALANCHE:
                this._nextAction = Action_1.Action.AVALANCHE;
                break;
            case ServerAvalancheReelsRound_1.ServerEvents.RESPIN:
                this._nextAction = Action_1.Action.RESPIN;
                break;
            case ServerAvalancheReelsRound_1.ServerEvents.FREE_SPIN:
                this._nextAction = Action_1.Action.FREESPIN;
                break;
            default:
                this._nextAction = Action_1.Action.SPIN;
                break;
        }
    };
    PrototypeLogic.prototype.cleanUp = function () {
        this.getPrototypeSpinResults().setWins([]);
        this.getPrototypeSpinResults().setRoundWin(0);
    };
    PrototypeLogic.prototype.setResultsForCurrentRound = function () {
        this.setNextAction();
        this.getSpinResult().setCurrentRoundSymbols(this._avalanches[this._currentRound].initialSymbols);
        this.getSpinResult().setRoundWin(this._avalanches[this._currentRound].win);
        this.getSpinResult().setSymbolsToRemove(this._avalanches[this._currentRound], []);
        if (this._avalanches[this._currentRound].newSymbols.length > 0) {
            this.getSpinResult().setSymbolsToAdd(this._avalanches[this._currentRound]);
        }
        else {
            this.getSpinResult().clearSymbolsToAdd();
        }
        this._freeSpinsTotalWin += this._avalanches[this._currentRound].win;
        this._cumulativeWin += this._avalanches[this._currentRound].win;
        this.getSpinResult().setWins(this._avalanches[this._currentRound].winnings);
    };
    PrototypeLogic.prototype.setCurrentRoundLayout = function () {
        this._currentRoundSymbols = [];
        for (var _i = 0, _a = this._newSymbols[this._currentNewSymbolsIndex]; _i < _a.length; _i++) {
            var newSym = _a[_i];
            this._currentRoundSymbols.push(new GameSymbol_1.GameSymbol(newSym.sym, newSym.size, newSym.position));
        }
    };
    PrototypeLogic.prototype.createSpinResult = function () {
        return new PrototypeSpinResult_1.PrototypeSpinResult();
    };
    PrototypeLogic.prototype.createCommunicator = function (communicator) {
        this._communicator = new PrototypeCommunicator_1.PrototypeCommunicator();
    };
    PrototypeLogic.prototype.getCurrentSymbolsFromReel = function (reelIndex) {
        var reelSymbols = [];
        for (var _i = 0, _a = this.getPrototypeSpinResults().reels[reelIndex]; _i < _a.length; _i++) {
            var sym = _a[_i];
            if (sym.position.x === reelIndex) {
                reelSymbols.push(sym.sym);
            }
        }
        return reelSymbols;
    };
    PrototypeLogic.prototype.getCurrentRoundAvalanche = function () {
        return this._avalanches[this._currentRound];
    };
    Object.defineProperty(PrototypeLogic.prototype, "currentBalance", {
        get: function () {
            return this._balance * Logic_1.Logic.CENT_TO_A_DOLLAR;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PrototypeLogic.prototype, "stopPositions", {
        get: function () {
            return this._stopPositions;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PrototypeLogic.prototype, "mathVersion", {
        get: function () {
            return this._mathVersion;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PrototypeLogic.prototype, "initialReels", {
        get: function () {
            return this._initialReels;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PrototypeLogic.prototype, "currentMultiplier", {
        get: function () {
            return this._currentMultiplier;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PrototypeLogic.prototype, "isInFreeSpins", {
        get: function () {
            return this._isInFreeSpins;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PrototypeLogic.prototype, "currentReelsetSymbols", {
        get: function () {
            return this._currentReelset.symbols;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PrototypeLogic.prototype, "currentReelset", {
        get: function () {
            return this._currentReelset;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PrototypeLogic.prototype, "currentRoundSymbols", {
        get: function () {
            return this._currentRoundSymbols;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PrototypeLogic.prototype, "newSymbols", {
        get: function () {
            return this._newSymbols;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PrototypeLogic.prototype, "messagesQueue", {
        get: function () {
            return this._messagesQueue;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PrototypeLogic.prototype, "serverTime", {
        get: function () {
            return this._serverTime;
        },
        set: function (value) {
            this._serverTime = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PrototypeLogic.prototype, "replayHttpResponse", {
        get: function () {
            return this._replayHttpResponse;
        },
        set: function (value) {
            this._replayHttpResponse = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PrototypeLogic.prototype, "freeSpinsTotalWin", {
        get: function () {
            return this._freeSpinsTotalWin * Logic_1.Logic.CENT_TO_A_DOLLAR;
        },
        enumerable: true,
        configurable: true
    });
    PrototypeLogic.prototype.forceSetIsInFreeSpins = function (value) {
        this._isInFreeSpins = value;
    };
    PrototypeLogic.prototype.getTotalBet = function () {
        return this.betValue;
    };
    PrototypeLogic.CENT_TO_DOLLAR = 0.01;
    return PrototypeLogic;
}(Logic_1.Logic));
exports.PrototypeLogic = PrototypeLogic;


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServerWinLine = /** @class */ (function () {
    function ServerWinLine() {
        this._win = 0;
        this._winSymbols = [];
        this._mainWinSymbol = -1;
        this._multiplier = 0;
    }
    ServerWinLine.prototype.addWinPosition = function (reel, row, symbol) {
        var position = { reel: reel, row: row };
        this._winSymbols.push({ position: position, symbol: symbol });
    };
    Object.defineProperty(ServerWinLine.prototype, "winSymbols", {
        get: function () {
            return this._winSymbols;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ServerWinLine.prototype, "win", {
        get: function () {
            return this._win;
        },
        set: function (value) {
            this._win = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ServerWinLine.prototype, "mainWinSymbol", {
        get: function () {
            return this._mainWinSymbol;
        },
        set: function (value) {
            this._mainWinSymbol = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ServerWinLine.prototype, "multiplier", {
        get: function () {
            return this._multiplier;
        },
        set: function (value) {
            this._multiplier = value;
        },
        enumerable: true,
        configurable: true
    });
    return ServerWinLine;
}());
exports.ServerWinLine = ServerWinLine;


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServerRandomUtils_1 = __webpack_require__(314);
var ServerSymbols_1 = __webpack_require__(165);
var ServerWaysWinChecker_1 = __webpack_require__(313);
var Reelsets;
(function (Reelsets) {
    Reelsets[Reelsets["BASIC"] = 0] = "BASIC";
    Reelsets[Reelsets["MIMIC_FS"] = 1] = "MIMIC_FS";
    Reelsets[Reelsets["FREE_SPINS"] = 2] = "FREE_SPINS";
})(Reelsets = exports.Reelsets || (exports.Reelsets = {}));
var ServerAvalancheReels = /** @class */ (function () {
    function ServerAvalancheReels() {
        this.initializeReels();
    }
    ServerAvalancheReels.prototype.initializeReels = function () {
        ServerAvalancheReels.baseGameReels = [
            [ServerSymbols_1.L4, ServerSymbols_1.H5, ServerSymbols_1.H1, ServerSymbols_1.L1, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.L1, ServerSymbols_1.L3, ServerSymbols_1.H4, ServerSymbols_1.L1, ServerSymbols_1.H3, ServerSymbols_1.L3, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.H3, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.L3, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.L2, ServerSymbols_1.L1, ServerSymbols_1.L3, ServerSymbols_1.H1, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.L3, ServerSymbols_1.H3, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.L3, ServerSymbols_1.H4, ServerSymbols_1.L1, ServerSymbols_1.L3, ServerSymbols_1.H5, ServerSymbols_1.H3, ServerSymbols_1.L3, ServerSymbols_1.L1, ServerSymbols_1.H2, ServerSymbols_1.L3, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.H3, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.L3, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.H1, ServerSymbols_1.L1, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.L1, ServerSymbols_1.L3, ServerSymbols_1.H3, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.H3, ServerSymbols_1.L3, ServerSymbols_1.L1, ServerSymbols_1.L3, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.L1, ServerSymbols_1.L3, ServerSymbols_1.H4, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.L3, ServerSymbols_1.H5, ServerSymbols_1.H3, ServerSymbols_1.H1, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.L3, ServerSymbols_1.L1, ServerSymbols_1.H1, ServerSymbols_1.L3, ServerSymbols_1.H5, ServerSymbols_1.L3, ServerSymbols_1.H4, ServerSymbols_1.L1, ServerSymbols_1.L3, ServerSymbols_1.H3, ServerSymbols_1.H5, ServerSymbols_1.L3, ServerSymbols_1.L1, ServerSymbols_1.L3, ServerSymbols_1.H4, ServerSymbols_1.L1, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.L1, ServerSymbols_1.H3, ServerSymbols_1.L3, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.H1, ServerSymbols_1.L3, ServerSymbols_1.H4, ServerSymbols_1.L1, ServerSymbols_1.L3, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.H5, ServerSymbols_1.H1, ServerSymbols_1.L3, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.L3],
            [ServerSymbols_1.L1, ServerSymbols_1.L3, ServerSymbols_1.L4, ServerSymbols_1.H1, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.H1, ServerSymbols_1.L4, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.L2, ServerSymbols_1.H1, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.H5, ServerSymbols_1.L3, ServerSymbols_1.L4, ServerSymbols_1.H2, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.H1, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.L2, ServerSymbols_1.H2, ServerSymbols_1.L4, ServerSymbols_1.H3, ServerSymbols_1.L3, ServerSymbols_1.L2, ServerSymbols_1.L3, ServerSymbols_1.H1, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.L2, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.L2, ServerSymbols_1.L4, ServerSymbols_1.H1, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.L2, ServerSymbols_1.H1, ServerSymbols_1.L4, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.L3, ServerSymbols_1.H2, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.L2, ServerSymbols_1.L3, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.H2, ServerSymbols_1.L3, ServerSymbols_1.H1, ServerSymbols_1.L2, ServerSymbols_1.L3, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.L2, ServerSymbols_1.L3, ServerSymbols_1.H1, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.L4, ServerSymbols_1.H2, ServerSymbols_1.H4, ServerSymbols_1.L2, ServerSymbols_1.L3, ServerSymbols_1.H1, ServerSymbols_1.L4, ServerSymbols_1.L3, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.H4, ServerSymbols_1.L2, ServerSymbols_1.L3, ServerSymbols_1.H2, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.H2, ServerSymbols_1.L3, ServerSymbols_1.L2, ServerSymbols_1.H4],
            [ServerSymbols_1.L3, ServerSymbols_1.L2, ServerSymbols_1.H3, ServerSymbols_1.L1, ServerSymbols_1.L4, ServerSymbols_1.H5, ServerSymbols_1.L2, ServerSymbols_1.H2, ServerSymbols_1.L1, ServerSymbols_1.L4, ServerSymbols_1.H5, ServerSymbols_1.L4, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.H2, ServerSymbols_1.L2, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.L2, ServerSymbols_1.H5, ServerSymbols_1.H4, ServerSymbols_1.L2, ServerSymbols_1.H5, ServerSymbols_1.L4, ServerSymbols_1.H2, ServerSymbols_1.L2, ServerSymbols_1.H5, ServerSymbols_1.L2, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.H2, ServerSymbols_1.L2, ServerSymbols_1.L4, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.H2, ServerSymbols_1.H5, ServerSymbols_1.L2, ServerSymbols_1.L1, ServerSymbols_1.H1, ServerSymbols_1.L2, ServerSymbols_1.H5, ServerSymbols_1.L2, ServerSymbols_1.H2, ServerSymbols_1.L4, ServerSymbols_1.L2, ServerSymbols_1.H5, ServerSymbols_1.L4, ServerSymbols_1.H5, ServerSymbols_1.L2, ServerSymbols_1.H5, ServerSymbols_1.L2, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.H2, ServerSymbols_1.H5, ServerSymbols_1.H3, ServerSymbols_1.H5, ServerSymbols_1.L4, ServerSymbols_1.L2, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.L4, ServerSymbols_1.L1, ServerSymbols_1.H2, ServerSymbols_1.L1, ServerSymbols_1.L2, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.L2, ServerSymbols_1.H2, ServerSymbols_1.H5, ServerSymbols_1.L2, ServerSymbols_1.L1, ServerSymbols_1.L4, ServerSymbols_1.H5, ServerSymbols_1.L2, ServerSymbols_1.H3, ServerSymbols_1.L2, ServerSymbols_1.L4, ServerSymbols_1.H5, ServerSymbols_1.L2, ServerSymbols_1.H5, ServerSymbols_1.L2, ServerSymbols_1.H3, ServerSymbols_1.L2, ServerSymbols_1.H5, ServerSymbols_1.L2, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.L4, ServerSymbols_1.L1, ServerSymbols_1.H2, ServerSymbols_1.L2, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.L2, ServerSymbols_1.H3, ServerSymbols_1.L1, ServerSymbols_1.L4, ServerSymbols_1.H5, ServerSymbols_1.L4, ServerSymbols_1.H5, ServerSymbols_1.L4, ServerSymbols_1.H5, ServerSymbols_1.H2, ServerSymbols_1.L2, ServerSymbols_1.H5, ServerSymbols_1.L4, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.L4, ServerSymbols_1.L2, ServerSymbols_1.H3, ServerSymbols_1.L2, ServerSymbols_1.L4, ServerSymbols_1.H5],
            [ServerSymbols_1.L1, ServerSymbols_1.L2, ServerSymbols_1.L4, ServerSymbols_1.H3, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.L2, ServerSymbols_1.L3, ServerSymbols_1.H1, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.H4, ServerSymbols_1.L2, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.H4, ServerSymbols_1.H3, ServerSymbols_1.L3, ServerSymbols_1.H2, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.H1, ServerSymbols_1.L3, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.H3, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.L4, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.L2, ServerSymbols_1.H1, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.L2, ServerSymbols_1.L4, ServerSymbols_1.H3, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.H3, ServerSymbols_1.L4, ServerSymbols_1.L2, ServerSymbols_1.L3, ServerSymbols_1.H4, ServerSymbols_1.L2, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.H3, ServerSymbols_1.L3, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.L2, ServerSymbols_1.L3, ServerSymbols_1.H3, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.L3, ServerSymbols_1.H4, ServerSymbols_1.H1, ServerSymbols_1.L4, ServerSymbols_1.L3, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.L4, ServerSymbols_1.H3, ServerSymbols_1.H5, ServerSymbols_1.L3, ServerSymbols_1.H4, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.L2, ServerSymbols_1.L3, ServerSymbols_1.H3, ServerSymbols_1.L3, ServerSymbols_1.H4, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.L2, ServerSymbols_1.H1, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.L2, ServerSymbols_1.L3, ServerSymbols_1.L2, ServerSymbols_1.H3, ServerSymbols_1.L3, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.H1, ServerSymbols_1.L3, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.L2, ServerSymbols_1.L4, ServerSymbols_1.H1, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.L2, ServerSymbols_1.H4],
            [ServerSymbols_1.H1, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.L1, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.H2, ServerSymbols_1.L1, ServerSymbols_1.L4, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.L4, ServerSymbols_1.H1, ServerSymbols_1.H5, ServerSymbols_1.L4, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.L4, ServerSymbols_1.H2, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.L1, ServerSymbols_1.L4, ServerSymbols_1.H1, ServerSymbols_1.H5, ServerSymbols_1.L4, ServerSymbols_1.L1, ServerSymbols_1.H2, ServerSymbols_1.H4, ServerSymbols_1.L1, ServerSymbols_1.L4, ServerSymbols_1.L1, ServerSymbols_1.H4, ServerSymbols_1.H3, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.H2, ServerSymbols_1.L4, ServerSymbols_1.L1, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.L4, ServerSymbols_1.L1, ServerSymbols_1.L4, ServerSymbols_1.H5, ServerSymbols_1.H2, ServerSymbols_1.L1, ServerSymbols_1.L4, ServerSymbols_1.H5, ServerSymbols_1.H1, ServerSymbols_1.L4, ServerSymbols_1.L2, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.L4, ServerSymbols_1.H2, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.L4, ServerSymbols_1.H5, ServerSymbols_1.L4, ServerSymbols_1.L1, ServerSymbols_1.L4, ServerSymbols_1.H2, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.L4, ServerSymbols_1.L1, ServerSymbols_1.H4, ServerSymbols_1.L1, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.H2, ServerSymbols_1.L4, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.L4, ServerSymbols_1.L1, ServerSymbols_1.H1, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.L4, ServerSymbols_1.H2, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.L1, ServerSymbols_1.H1, ServerSymbols_1.H5, ServerSymbols_1.L4, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.L4, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.L4, ServerSymbols_1.H1, ServerSymbols_1.L1, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.H5, ServerSymbols_1.H1, ServerSymbols_1.L1, ServerSymbols_1.L4, ServerSymbols_1.H5, ServerSymbols_1.L1],
            [ServerSymbols_1.H1, ServerSymbols_1.L1, ServerSymbols_1.H3, ServerSymbols_1.L3, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.L2, ServerSymbols_1.H5, ServerSymbols_1.L3, ServerSymbols_1.L1, ServerSymbols_1.H2, ServerSymbols_1.L2, ServerSymbols_1.H5, ServerSymbols_1.L3, ServerSymbols_1.H2, ServerSymbols_1.H5, ServerSymbols_1.L3, ServerSymbols_1.H5, ServerSymbols_1.L2, ServerSymbols_1.L1, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.L2, ServerSymbols_1.H3, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.L2, ServerSymbols_1.H5, ServerSymbols_1.L2, ServerSymbols_1.H2, ServerSymbols_1.L2, ServerSymbols_1.L3, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.L2, ServerSymbols_1.H3, ServerSymbols_1.L3, ServerSymbols_1.H5, ServerSymbols_1.L2, ServerSymbols_1.H5, ServerSymbols_1.L3, ServerSymbols_1.H5, ServerSymbols_1.L2, ServerSymbols_1.H3, ServerSymbols_1.H5, ServerSymbols_1.L3, ServerSymbols_1.H5, ServerSymbols_1.L3, ServerSymbols_1.H5, ServerSymbols_1.L2, ServerSymbols_1.H3, ServerSymbols_1.L2, ServerSymbols_1.H5, ServerSymbols_1.L3, ServerSymbols_1.L2, ServerSymbols_1.H3, ServerSymbols_1.H5, ServerSymbols_1.L2, ServerSymbols_1.L4, ServerSymbols_1.L3, ServerSymbols_1.H5, ServerSymbols_1.L3, ServerSymbols_1.L2, ServerSymbols_1.H2, ServerSymbols_1.L3, ServerSymbols_1.L2, ServerSymbols_1.L1, ServerSymbols_1.L2, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.L2, ServerSymbols_1.H3, ServerSymbols_1.L2, ServerSymbols_1.H5, ServerSymbols_1.L2, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.H2, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.L2, ServerSymbols_1.H5, ServerSymbols_1.L2, ServerSymbols_1.H5, ServerSymbols_1.L3, ServerSymbols_1.H3, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.L2, ServerSymbols_1.H5, ServerSymbols_1.L3, ServerSymbols_1.L1, ServerSymbols_1.L2, ServerSymbols_1.L3, ServerSymbols_1.H2, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.L3, ServerSymbols_1.H2, ServerSymbols_1.H5, ServerSymbols_1.L2, ServerSymbols_1.L3, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.L2, ServerSymbols_1.L3, ServerSymbols_1.H3, ServerSymbols_1.L2, ServerSymbols_1.H5, ServerSymbols_1.L3, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.H2, ServerSymbols_1.H5, ServerSymbols_1.L3],
        ];
        ServerAvalancheReels.mimicFreeSpinsReels = [
            [ServerSymbols_1.L3, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.L2, ServerSymbols_1.L3, ServerSymbols_1.L2, ServerSymbols_1.H3, ServerSymbols_1.L1, ServerSymbols_1.H4, ServerSymbols_1.L1, ServerSymbols_1.L4, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.L3, ServerSymbols_1.L1, ServerSymbols_1.H1, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.H4, ServerSymbols_1.H1, ServerSymbols_1.H4, ServerSymbols_1.L1, ServerSymbols_1.L3, ServerSymbols_1.L2, ServerSymbols_1.L1, ServerSymbols_1.L3, ServerSymbols_1.L4, ServerSymbols_1.H2, ServerSymbols_1.H5, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.L3, ServerSymbols_1.H5, ServerSymbols_1.L4, ServerSymbols_1.H3, ServerSymbols_1.L4, ServerSymbols_1.L1, ServerSymbols_1.H2, ServerSymbols_1.L3, ServerSymbols_1.H4, ServerSymbols_1.H5, ServerSymbols_1.H4, ServerSymbols_1.L1, ServerSymbols_1.L2, ServerSymbols_1.L1, ServerSymbols_1.H1, ServerSymbols_1.H4, ServerSymbols_1.L1, ServerSymbols_1.L4, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.H3, ServerSymbols_1.L1, ServerSymbols_1.L4, ServerSymbols_1.L3, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.L4, ServerSymbols_1.H5, ServerSymbols_1.L2, ServerSymbols_1.H1, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.H5, ServerSymbols_1.L4, ServerSymbols_1.H5, ServerSymbols_1.L4, ServerSymbols_1.L2, ServerSymbols_1.L1, ServerSymbols_1.H1, ServerSymbols_1.L1, ServerSymbols_1.L3, ServerSymbols_1.H1, ServerSymbols_1.L4, ServerSymbols_1.L3, ServerSymbols_1.H5, ServerSymbols_1.L2, ServerSymbols_1.H5, ServerSymbols_1.H4, ServerSymbols_1.H1, ServerSymbols_1.H4, ServerSymbols_1.L1, ServerSymbols_1.L3, ServerSymbols_1.L2, ServerSymbols_1.H5, ServerSymbols_1.L4, ServerSymbols_1.H2, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.L2, ServerSymbols_1.L3, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.H4, ServerSymbols_1.L1, ServerSymbols_1.L3, ServerSymbols_1.L2, ServerSymbols_1.H2, ServerSymbols_1.L2, ServerSymbols_1.H5, ServerSymbols_1.L2, ServerSymbols_1.L1, ServerSymbols_1.L3, ServerSymbols_1.H4, ServerSymbols_1.H2, ServerSymbols_1.L2, ServerSymbols_1.L1, ServerSymbols_1.L3, ServerSymbols_1.H3, ServerSymbols_1.H5, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.L1, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.H5],
            [ServerSymbols_1.L3, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.H3, ServerSymbols_1.L1, ServerSymbols_1.H2, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.L2, ServerSymbols_1.L1, ServerSymbols_1.H4, ServerSymbols_1.L2, ServerSymbols_1.L3, ServerSymbols_1.H2, ServerSymbols_1.L1, ServerSymbols_1.L2, ServerSymbols_1.L1, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.L1, ServerSymbols_1.H1, ServerSymbols_1.H5, ServerSymbols_1.L4, ServerSymbols_1.L3, ServerSymbols_1.H5, ServerSymbols_1.H4, ServerSymbols_1.H1, ServerSymbols_1.H4, ServerSymbols_1.L2, ServerSymbols_1.L3, ServerSymbols_1.H4, ServerSymbols_1.L1, ServerSymbols_1.L3, ServerSymbols_1.L4, ServerSymbols_1.L2, ServerSymbols_1.L1, ServerSymbols_1.H4, ServerSymbols_1.H5, ServerSymbols_1.L3, ServerSymbols_1.H1, ServerSymbols_1.L3, ServerSymbols_1.L2, ServerSymbols_1.L3, ServerSymbols_1.H3, ServerSymbols_1.L2, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.L4, ServerSymbols_1.H3, ServerSymbols_1.H5, ServerSymbols_1.H4, ServerSymbols_1.L1, ServerSymbols_1.L2, ServerSymbols_1.H2, ServerSymbols_1.L3, ServerSymbols_1.L1, ServerSymbols_1.L4, ServerSymbols_1.H5, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.H1, ServerSymbols_1.H4, ServerSymbols_1.L1, ServerSymbols_1.L4, ServerSymbols_1.L1, ServerSymbols_1.L2, ServerSymbols_1.L3, ServerSymbols_1.L4, ServerSymbols_1.H1, ServerSymbols_1.L3, ServerSymbols_1.H5, ServerSymbols_1.L3, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.H1, ServerSymbols_1.L2, ServerSymbols_1.L4, ServerSymbols_1.H5, ServerSymbols_1.L4, ServerSymbols_1.H5, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.H1, ServerSymbols_1.L4, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.L1, ServerSymbols_1.H2, ServerSymbols_1.L3, ServerSymbols_1.L4, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.L2, ServerSymbols_1.H2, ServerSymbols_1.H4, ServerSymbols_1.H5, ServerSymbols_1.L4, ServerSymbols_1.L2, ServerSymbols_1.L1, ServerSymbols_1.H2, ServerSymbols_1.L2, ServerSymbols_1.L3, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.H1, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.H5, ServerSymbols_1.L3, ServerSymbols_1.L4, ServerSymbols_1.L2, ServerSymbols_1.H1],
            [ServerSymbols_1.H1, ServerSymbols_1.L4, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.H2, ServerSymbols_1.L3, ServerSymbols_1.H5, ServerSymbols_1.L4, ServerSymbols_1.L2, ServerSymbols_1.L1, ServerSymbols_1.L2, ServerSymbols_1.L3, ServerSymbols_1.H4, ServerSymbols_1.H3, ServerSymbols_1.H5, ServerSymbols_1.L3, ServerSymbols_1.L1, ServerSymbols_1.H4, ServerSymbols_1.H5, ServerSymbols_1.H3, ServerSymbols_1.L2, ServerSymbols_1.L1, ServerSymbols_1.L3, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.H4, ServerSymbols_1.H3, ServerSymbols_1.L2, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.L1, ServerSymbols_1.L2, ServerSymbols_1.H1, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.L2, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.L2, ServerSymbols_1.L1, ServerSymbols_1.L3, ServerSymbols_1.H5, ServerSymbols_1.H1, ServerSymbols_1.L1, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.L1, ServerSymbols_1.L2, ServerSymbols_1.L4, ServerSymbols_1.H1, ServerSymbols_1.L4, ServerSymbols_1.H5, ServerSymbols_1.L4, ServerSymbols_1.H3, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.L4, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.H2, ServerSymbols_1.L1, ServerSymbols_1.L3, ServerSymbols_1.H5, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.H1, ServerSymbols_1.L2, ServerSymbols_1.L3, ServerSymbols_1.H5, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.H5, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.L3, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.H1, ServerSymbols_1.H5, ServerSymbols_1.H1, ServerSymbols_1.L2, ServerSymbols_1.H5, ServerSymbols_1.L3, ServerSymbols_1.L1, ServerSymbols_1.H3, ServerSymbols_1.L4, ServerSymbols_1.H5, ServerSymbols_1.L2, ServerSymbols_1.L1, ServerSymbols_1.L2, ServerSymbols_1.L3, ServerSymbols_1.L1, ServerSymbols_1.H2, ServerSymbols_1.L3, ServerSymbols_1.H5, ServerSymbols_1.H4, ServerSymbols_1.H5, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.H3, ServerSymbols_1.L3, ServerSymbols_1.L2, ServerSymbols_1.L4, ServerSymbols_1.L1, ServerSymbols_1.L4, ServerSymbols_1.L1, ServerSymbols_1.H2, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.L2, ServerSymbols_1.H5],
            [ServerSymbols_1.H5, ServerSymbols_1.L3, ServerSymbols_1.L4, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.H1, ServerSymbols_1.H5, ServerSymbols_1.L4, ServerSymbols_1.L3, ServerSymbols_1.H3, ServerSymbols_1.L3, ServerSymbols_1.L4, ServerSymbols_1.L3, ServerSymbols_1.L4, ServerSymbols_1.H1, ServerSymbols_1.L1, ServerSymbols_1.H4, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.L2, ServerSymbols_1.H2, ServerSymbols_1.H5, ServerSymbols_1.H4, ServerSymbols_1.L2, ServerSymbols_1.L4, ServerSymbols_1.L3, ServerSymbols_1.L2, ServerSymbols_1.L3, ServerSymbols_1.H4, ServerSymbols_1.L1, ServerSymbols_1.H3, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.L1, ServerSymbols_1.L3, ServerSymbols_1.H1, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.H4, ServerSymbols_1.L1, ServerSymbols_1.L3, ServerSymbols_1.H2, ServerSymbols_1.L3, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.L3, ServerSymbols_1.L2, ServerSymbols_1.H3, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.L2, ServerSymbols_1.L3, ServerSymbols_1.H5, ServerSymbols_1.H1, ServerSymbols_1.L3, ServerSymbols_1.H5, ServerSymbols_1.L2, ServerSymbols_1.L3, ServerSymbols_1.H4, ServerSymbols_1.H1, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.L1, ServerSymbols_1.L3, ServerSymbols_1.L4, ServerSymbols_1.H3, ServerSymbols_1.H5, ServerSymbols_1.L2, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.L3, ServerSymbols_1.H5, ServerSymbols_1.H3, ServerSymbols_1.L4, ServerSymbols_1.L1, ServerSymbols_1.L2, ServerSymbols_1.H5, ServerSymbols_1.L3, ServerSymbols_1.L4, ServerSymbols_1.L3, ServerSymbols_1.H2, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.H5, ServerSymbols_1.L3, ServerSymbols_1.H2, ServerSymbols_1.L4, ServerSymbols_1.H5, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.L4, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.L2, ServerSymbols_1.L3, ServerSymbols_1.H5, ServerSymbols_1.L4, ServerSymbols_1.H3, ServerSymbols_1.H2, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.L3, ServerSymbols_1.L4, ServerSymbols_1.H3, ServerSymbols_1.L2, ServerSymbols_1.H5, ServerSymbols_1.H4, ServerSymbols_1.L1, ServerSymbols_1.L4, ServerSymbols_1.L2, ServerSymbols_1.H4],
            [ServerSymbols_1.H4, ServerSymbols_1.L1, ServerSymbols_1.L4, ServerSymbols_1.L3, ServerSymbols_1.H5, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.L2, ServerSymbols_1.H3, ServerSymbols_1.L1, ServerSymbols_1.L2, ServerSymbols_1.H2, ServerSymbols_1.L4, ServerSymbols_1.L2, ServerSymbols_1.H2, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.L2, ServerSymbols_1.H5, ServerSymbols_1.L3, ServerSymbols_1.L4, ServerSymbols_1.H1, ServerSymbols_1.L2, ServerSymbols_1.H5, ServerSymbols_1.L3, ServerSymbols_1.H4, ServerSymbols_1.L2, ServerSymbols_1.H5, ServerSymbols_1.H1, ServerSymbols_1.H5, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.H2, ServerSymbols_1.L2, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.L1, ServerSymbols_1.L3, ServerSymbols_1.L1, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.H2, ServerSymbols_1.H4, ServerSymbols_1.H3, ServerSymbols_1.L4, ServerSymbols_1.L3, ServerSymbols_1.L4, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.L3, ServerSymbols_1.L2, ServerSymbols_1.H3, ServerSymbols_1.L2, ServerSymbols_1.H5, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.L1, ServerSymbols_1.H2, ServerSymbols_1.L3, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.H1, ServerSymbols_1.L1, ServerSymbols_1.H4, ServerSymbols_1.L2, ServerSymbols_1.L3, ServerSymbols_1.H5, ServerSymbols_1.L3, ServerSymbols_1.H3, ServerSymbols_1.L1, ServerSymbols_1.H4, ServerSymbols_1.L2, ServerSymbols_1.H5, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.H5, ServerSymbols_1.H1, ServerSymbols_1.L3, ServerSymbols_1.L1, ServerSymbols_1.L3, ServerSymbols_1.L2, ServerSymbols_1.L3, ServerSymbols_1.L2, ServerSymbols_1.H5, ServerSymbols_1.L4, ServerSymbols_1.H3, ServerSymbols_1.L4, ServerSymbols_1.H5, ServerSymbols_1.L4, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.H2, ServerSymbols_1.H5, ServerSymbols_1.L2, ServerSymbols_1.L1, ServerSymbols_1.H4, ServerSymbols_1.H1, ServerSymbols_1.L2, ServerSymbols_1.L4, ServerSymbols_1.L3, ServerSymbols_1.H4, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.H3, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.L2, ServerSymbols_1.H5, ServerSymbols_1.L3, ServerSymbols_1.L2, ServerSymbols_1.L3, ServerSymbols_1.L1],
            [ServerSymbols_1.H4, ServerSymbols_1.H1, ServerSymbols_1.L2, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.L1, ServerSymbols_1.H4, ServerSymbols_1.L1, ServerSymbols_1.L4, ServerSymbols_1.L3, ServerSymbols_1.L2, ServerSymbols_1.H2, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.L1, ServerSymbols_1.H1, ServerSymbols_1.H5, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.L2, ServerSymbols_1.H2, ServerSymbols_1.L1, ServerSymbols_1.L3, ServerSymbols_1.L2, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.L3, ServerSymbols_1.H3, ServerSymbols_1.L1, ServerSymbols_1.H4, ServerSymbols_1.H5, ServerSymbols_1.L3, ServerSymbols_1.L1, ServerSymbols_1.H4, ServerSymbols_1.H2, ServerSymbols_1.H4, ServerSymbols_1.L1, ServerSymbols_1.L2, ServerSymbols_1.L3, ServerSymbols_1.L1, ServerSymbols_1.L3, ServerSymbols_1.H2, ServerSymbols_1.L4, ServerSymbols_1.H5, ServerSymbols_1.L2, ServerSymbols_1.L3, ServerSymbols_1.H5, ServerSymbols_1.H4, ServerSymbols_1.L1, ServerSymbols_1.L3, ServerSymbols_1.H1, ServerSymbols_1.L4, ServerSymbols_1.L3, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.L4, ServerSymbols_1.H1, ServerSymbols_1.L3, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.H5, ServerSymbols_1.H4, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.H2, ServerSymbols_1.L1, ServerSymbols_1.H5, ServerSymbols_1.L3, ServerSymbols_1.L1, ServerSymbols_1.H1, ServerSymbols_1.L3, ServerSymbols_1.L2, ServerSymbols_1.L4, ServerSymbols_1.H5, ServerSymbols_1.L2, ServerSymbols_1.H5, ServerSymbols_1.H3, ServerSymbols_1.L1, ServerSymbols_1.H4, ServerSymbols_1.L1, ServerSymbols_1.L2, ServerSymbols_1.L1, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.H2, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.H2, ServerSymbols_1.H4, ServerSymbols_1.L2, ServerSymbols_1.L1, ServerSymbols_1.L3, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.H3, ServerSymbols_1.L1, ServerSymbols_1.L2, ServerSymbols_1.H4, ServerSymbols_1.H5, ServerSymbols_1.L3, ServerSymbols_1.L1, ServerSymbols_1.L4, ServerSymbols_1.H3, ServerSymbols_1.H4, ServerSymbols_1.L3, ServerSymbols_1.L4, ServerSymbols_1.L2, ServerSymbols_1.L1, ServerSymbols_1.L4, ServerSymbols_1.H3, ServerSymbols_1.L3, ServerSymbols_1.H4, ServerSymbols_1.L4, ServerSymbols_1.H4, ServerSymbols_1.H5, ServerSymbols_1.L1, ServerSymbols_1.H5],
        ];
    };
    ServerAvalancheReels.prototype.getReelset = function (reelset) {
        switch (reelset) {
            case Reelsets.BASIC:
                return ServerAvalancheReels.baseGameReels;
            case Reelsets.MIMIC_FS:
                return ServerAvalancheReels.mimicFreeSpinsReels;
            case Reelsets.FREE_SPINS:
                return ServerAvalancheReels.baseGameReels;
            default:
                return null;
        }
    };
    ServerAvalancheReels.prototype.generateReelsOrder = function () {
        var reelsOrder = ServerAvalancheReels.FIRST3REELS[ServerRandomUtils_1.ServerRandomUtils.randomInt(0, 5)].concat(ServerAvalancheReels.SECOND3REELS[ServerRandomUtils_1.ServerRandomUtils.randomInt(0, 5)]);
        return reelsOrder;
    };
    ServerAvalancheReels.prototype.generateNewCombination = function (reelset, cheats) {
        this._currentReelOrder = this.generateReelsOrder();
        if (cheats.isCheatsEnabled && cheats.firstThreeReelsCombination.length === 3) {
            this._currentReelOrder[0] = cheats.firstThreeReelsCombination[0];
            this._currentReelOrder[1] = cheats.firstThreeReelsCombination[1];
            this._currentReelOrder[2] = cheats.firstThreeReelsCombination[2];
        }
        if (cheats.isCheatsEnabled && cheats.secondThreeReelsCombination.length === 3) {
            this._currentReelOrder[3] = cheats.secondThreeReelsCombination[0];
            this._currentReelOrder[4] = cheats.secondThreeReelsCombination[1];
            this._currentReelOrder[5] = cheats.secondThreeReelsCombination[2];
        }
        var positions = [];
        var curReels = this.getReelset(reelset);
        for (var reelIndex = 0; reelIndex < curReels.length; reelIndex++) {
            var reel = curReels[this._currentReelOrder[reelIndex]];
            positions.push(ServerRandomUtils_1.ServerRandomUtils.randomInt(0, reel.length - 1));
            if (cheats.isCheatsEnabled && cheats.cheatPositions) {
                for (var i = 0; i < cheats.cheatPositions.length; i++) {
                    if (cheats.cheatPositions[i] >= 0) {
                        positions[i] = cheats.cheatPositions[i];
                    }
                }
            }
        }
        var visibleSymbols = [];
        for (var i = 0; i < ServerAvalancheReels.REELS; i++) {
            visibleSymbols[i] = [];
            for (var j = 0; j < ServerAvalancheReels.ROWS; j++) {
                var reelIndex = this._currentReelOrder[this._currentReelOrder[i]];
                visibleSymbols[i][j] = this.getSymbolFromReel(curReels, reelIndex, positions[i] + j);
            }
        }
        return { visibleReelsPositions: positions, visibleReels: visibleSymbols };
    };
    ServerAvalancheReels.prototype.killWinLinesSymbols = function (currentReels, winLines) {
        for (var _i = 0, winLines_1 = winLines; _i < winLines_1.length; _i++) {
            var wl = winLines_1[_i];
            for (var _a = 0, _b = wl.winSymbols; _a < _b.length; _a++) {
                var ws = _b[_a];
                if (currentReels.visibleReels[ws.position.reel][ws.position.row] === ServerSymbols_1.W) {
                    for (var i = 0; i < currentReels.visibleReels[ws.position.reel].length; i++) {
                        currentReels.visibleReels[ws.position.reel][i] = -1;
                    }
                }
                currentReels.visibleReels[ws.position.reel][ws.position.row] = -1;
            }
        }
        return currentReels;
    };
    ServerAvalancheReels.prototype.dropDownSymbols = function (currentReels) {
        // tslint:disable-next-line:prefer-for-of
        for (var reelIndex = 0; reelIndex < currentReels.visibleReels.length; reelIndex++) {
            // starting from (lowest sym pos - 1)
            for (var rowIndex = currentReels.visibleReels[reelIndex].length - 2; rowIndex >= 0; rowIndex--) {
                var currentRow = rowIndex;
                var isAtFinalPosition = false;
                while (!isAtFinalPosition) {
                    var curSymbol = currentReels.visibleReels[reelIndex][currentRow];
                    var symBelow = currentRow < currentReels.visibleReels[reelIndex].length - 1 ? currentReels.visibleReels[reelIndex][currentRow + 1] : -2;
                    if (curSymbol >= 0 && symBelow === -1) {
                        currentReels.visibleReels[reelIndex][currentRow + 1] = curSymbol;
                        currentReels.visibleReels[reelIndex][currentRow] = -1;
                        currentRow++;
                    }
                    else {
                        isAtFinalPosition = true;
                    }
                }
            }
        }
        return currentReels;
    };
    /**
     * returns list of new symbols
     * @param currentReels
     * @param reelset
     * @param randomMultiplier
     * @param avalancheMultiplier
     */
    ServerAvalancheReels.prototype.addNewSymbols = function (currentReels, reelset, randomMultiplier, avalancheMultiplier) {
        var specialCaseChance = ServerRandomUtils_1.ServerRandomUtils.randomInt(1, 1000);
        var specialCaseReelsOrder = [];
        var hasSpecialCase = false;
        if (specialCaseChance <= 165 && randomMultiplier === 1 && avalancheMultiplier === 1) {
            hasSpecialCase = true;
            for (var reelIndex = 0; reelIndex < ServerAvalancheReels.REELS; reelIndex++) {
                specialCaseReelsOrder.push(ServerRandomUtils_1.ServerRandomUtils.randomInt(0, 5));
            }
        }
        var curReelset = this.getReelset(reelset);
        var newSymbols = [];
        for (var i = 0; i < ServerAvalancheReels.REELS; i++) {
            newSymbols[i] = [];
            var reelIndex = void 0;
            if (hasSpecialCase) {
                reelIndex = this._currentReelOrder[i];
            }
            else {
                reelIndex = this._currentReelOrder[i];
            }
            var reelPositionToStartWith = ServerRandomUtils_1.ServerRandomUtils.randomInt(0, curReelset[reelIndex].length - 1);
            for (var j = ServerAvalancheReels.ROWS - 1; j >= 0; j--) {
                if (currentReels.visibleReels[i][j] === -1) {
                    currentReels.visibleReels[i][j] = this.getSymbolFromReel(curReelset, reelIndex, reelPositionToStartWith - j);
                    newSymbols[i].unshift(currentReels.visibleReels[i][j]);
                    currentReels.visibleReelsPositions[i]--;
                }
            }
        }
        return newSymbols;
    };
    ServerAvalancheReels.prototype.hasExpandedWildOnReel = function (reelIndex, expandedWilds) {
        if (expandedWilds) {
            for (var _i = 0, expandedWilds_1 = expandedWilds; _i < expandedWilds_1.length; _i++) {
                var ew = expandedWilds_1[_i];
                if (ew.wildPosition.reel === reelIndex) {
                    return true;
                }
            }
        }
        return false;
    };
    ServerAvalancheReels.prototype.getNonWinningSymolZzList = function (currentReels, expandedWilds) {
        var nwPositions = [];
        for (var i = 0; i < ServerAvalancheReels.REELS; i++) {
            if (!this.hasExpandedWildOnReel(i, expandedWilds)) {
                for (var j = 0; j < ServerAvalancheReels.ROWS; j++) {
                    nwPositions.push({ reel: i, row: j });
                }
            }
        }
        var winLines = new ServerWaysWinChecker_1.ServerWaysWinChecker().findWins(currentReels.visibleReels);
        var winIndexes = [];
        for (var _i = 0, winLines_2 = winLines; _i < winLines_2.length; _i++) {
            var wl = winLines_2[_i];
            var _loop_1 = function (ws) {
                var index = nwPositions.findIndex(function (winSymbol) {
                    return ws.position.reel === winSymbol.reel && ws.position.row === winSymbol.row;
                });
                if (index >= 0) {
                    winIndexes.push(index);
                }
            };
            for (var _a = 0, _b = wl.winSymbols; _a < _b.length; _a++) {
                var ws = _b[_a];
                _loop_1(ws);
            }
        }
        for (var _c = 0, winIndexes_1 = winIndexes; _c < winIndexes_1.length; _c++) {
            var wi = winIndexes_1[_c];
            nwPositions.splice(wi, 1);
        }
        return nwPositions;
    };
    ServerAvalancheReels.prototype.getSymbolFromReel = function (reels, reelIndex, index) {
        var symIndex = index;
        while (!this.isValidSymIndex(reels, reelIndex, symIndex)) {
            if (symIndex >= reels[reelIndex].length) {
                symIndex = symIndex % reels[reelIndex].length;
            }
            else if (symIndex < 0) {
                symIndex = reels[reelIndex].length + symIndex;
            }
        }
        return reels[reelIndex][symIndex];
    };
    ServerAvalancheReels.prototype.isValidSymIndex = function (reels, reelIndex, index) {
        return index >= 0 && index < reels[reelIndex].length;
    };
    ServerAvalancheReels.prototype.tryToAddMegablocks = function (currentReels) {
        var createMegablockNumber = ServerRandomUtils_1.ServerRandomUtils.randomInt(1, 100);
        this._currentMegablock = null;
        if (createMegablockNumber >= 30) {
            return this.megablockCaseSelector(currentReels);
        }
        return currentReels;
    };
    ServerAvalancheReels.prototype.megablockCaseSelector = function (currentReels) {
        var megablockNumber = ServerRandomUtils_1.ServerRandomUtils.randomInt(1, 100);
        if (megablockNumber < 95) {
            return this.megablockCommon2x2Case(currentReels);
        }
        else {
            return this.megablockUncommonCases(currentReels);
        }
    };
    ServerAvalancheReels.prototype.megablockUncommonCases = function (currentReels) {
        var caseNumber = ServerRandomUtils_1.ServerRandomUtils.randomInt(1, 5);
        console.log('Megablock uncommon case', 1, 'selected');
        switch (caseNumber) {
            case 1:
                return this.meagaBlockUncommonCase1(currentReels, null);
            case 2:
                return this.meagaBlockUncommonCase2(currentReels);
            case 3:
                return this.meagaBlockUncommonCase3(currentReels, null);
            case 4:
                return this.meagaBlockUncommonCase4(currentReels, null);
            case 5:
                return this.meagaBlockUncommonCase5(currentReels);
            default:
                break;
        }
    };
    ServerAvalancheReels.prototype.megablockCommon2x2Case = function (currentReels) {
        var size = 2;
        /*
        2x2 megablock top corner position will be uniformly distributed verticaly on rows 1,2,3,4,5. */
        var rowIndex = ServerRandomUtils_1.ServerRandomUtils.randomInt(0, 4);
        /*
        70% chance to set left corner on reel 5, otherwise on reel 4.
        */
        var reelIndex = ServerRandomUtils_1.ServerRandomUtils.randomValueWithWeights([4, 3], [7, 3]);
        /*
        20% chance to make it of low paying symbols (L4, L3, L2, L1), the rest chance will make it of high paying symbols (H5, H4, H3, H2, H1)
        */
        var symbolSet = ServerRandomUtils_1.ServerRandomUtils.randomValueWithWeights([[ServerSymbols_1.H5, ServerSymbols_1.H4, ServerSymbols_1.H3, ServerSymbols_1.H2, ServerSymbols_1.H1], [ServerSymbols_1.L4, ServerSymbols_1.L3, ServerSymbols_1.L2, ServerSymbols_1.L1]], [8, 2]);
        var weight = [];
        symbolSet.forEach(function () {
            weight.push(1);
        });
        var symbol = ServerRandomUtils_1.ServerRandomUtils.randomValueWithWeights(symbolSet, weight);
        var startPosition = { reel: reelIndex, row: rowIndex };
        return this.placeMegablockInReels(currentReels, startPosition, size, symbol);
    };
    ServerAvalancheReels.prototype.meagaBlockUncommonCase1 = function (currentReels, nextQuadrant) {
        /*
        Divide 6x6 reels into 4 areas of 3x3.
        [0] [2]
        [1] [3]
        */
        var reelQuadrants = [{ reel: 0, row: 0 }, { reel: 0, row: 3 }, { reel: 3, row: 0 }, { reel: 3, row: 3 }];
        var quadrant = 0;
        var position = null;
        /*
        Take random number 0..3 to determine which area will be used for megablock.
        */
        if (nextQuadrant) {
            console.log('nextquadrant selected:', nextQuadrant);
            quadrant = nextQuadrant;
        }
        else {
            quadrant = ServerRandomUtils_1.ServerRandomUtils.randomInt(0, 3);
            console.log('quadrant selected:', quadrant);
        }
        /*
        20% chance to make it size of 3x3, otherwise 2x2.
        */
        var size = ServerRandomUtils_1.ServerRandomUtils.randomValueWithWeights([3, 2], [2, 8]);
        /*
        If size 3x3, then set one out of 5 high paying symbols for megablock type.
        Otherwise, if 2x2: 20% chance to be L1..L4, otherwise H1..H5. 2x2 symbol should be placed in random position inside selected 3x3 area.
        */
        var symbol;
        if (size === 3) {
            console.log('size:', size);
            symbol = ServerRandomUtils_1.ServerRandomUtils.randomValueWithWeights([ServerSymbols_1.H5, ServerSymbols_1.H4, ServerSymbols_1.H3, ServerSymbols_1.H2, ServerSymbols_1.H1], [1, 1, 1, 1, 1]);
            position = { reel: reelQuadrants[quadrant].reel, row: reelQuadrants[quadrant].row };
        }
        else {
            console.log('size:', size);
            var symbolSet = ServerRandomUtils_1.ServerRandomUtils.randomValueWithWeights([[ServerSymbols_1.H5, ServerSymbols_1.H4, ServerSymbols_1.H3, ServerSymbols_1.H2, ServerSymbols_1.H1], [ServerSymbols_1.L4, ServerSymbols_1.L3, ServerSymbols_1.L2, ServerSymbols_1.L1]], [8, 2]);
            var weight = [1, 1, 1, 1, 1];
            weight.length = symbolSet.length;
            symbol = ServerRandomUtils_1.ServerRandomUtils.randomValueWithWeights(symbolSet, weight);
            var xPositionOffset = ServerRandomUtils_1.ServerRandomUtils.randomInt(0, 1);
            var yPositionOffset = ServerRandomUtils_1.ServerRandomUtils.randomInt(0, 1);
            position = { reel: reelQuadrants[quadrant].reel + xPositionOffset, row: reelQuadrants[quadrant].row + yPositionOffset };
        }
        /*
        If 30% chance successful there might be awarded another megablock.
        Select one random area of 3x3 again.
        If selected the same one as for the 1st megablock, skip awarding another block completely, otherwise do the same as for the previous one, with the new choosing of megablock symbol (can be the same as the previous one, but doesn't have to).
        */
        if (!nextQuadrant && ServerRandomUtils_1.ServerRandomUtils.randomValueWithWeights([false, true], [7, 3])) {
            var nextQuadrant_1 = ServerRandomUtils_1.ServerRandomUtils.randomInt(0, 3);
            if (nextQuadrant_1 === quadrant) {
                return this.placeMegablockInReels(currentReels, position, size, symbol);
            }
            else {
                currentReels = this.placeMegablockInReels(currentReels, position, size, symbol);
                this.meagaBlockUncommonCase1(currentReels, nextQuadrant_1);
            }
        }
        else {
            return this.placeMegablockInReels(currentReels, position, size, symbol);
        }
    };
    ServerAvalancheReels.prototype.meagaBlockUncommonCase2 = function (currentReels) {
        /*
        Size is 3x3, symbol is H1 or H2 or H3.
        */
        var symbolValue = ServerRandomUtils_1.ServerRandomUtils.randomValueWithWeights([ServerSymbols_1.H1, ServerSymbols_1.H2, ServerSymbols_1.H3], [1, 1, 1]);
        /*
        Vertical position is randomly selected to be 2, 3, 4 (top left corner of the megablock).
        */
        var rowPosition = ServerRandomUtils_1.ServerRandomUtils.randomInt(1, 3);
        /*
        Horisontal position is randomly selected to be 2, 3, 4 (top left corner of the megablock)
        */
        var reelPosition = ServerRandomUtils_1.ServerRandomUtils.randomInt(1, 3);
        var symbolPosition = { reel: reelPosition, row: rowPosition };
        return this.placeMegablockInReels(currentReels, symbolPosition, 3, symbolValue);
    };
    ServerAvalancheReels.prototype.meagaBlockUncommonCase3 = function (currentReels, nextSection) {
        /*
        Divide 6x6 reels into 2 areas of 6x3 - top and bottom.
        */
        var reelIndexes = [1, 2, 3];
        var rowIndexes = [0, 3];
        /*
        Select one area randomly.
        */
        var chosenSection;
        if (nextSection) {
            chosenSection = nextSection;
        }
        else {
            chosenSection = ServerRandomUtils_1.ServerRandomUtils.randomInt(0, 1);
        }
        /*
        20% chance to make it 3x3, otherwise 2x2.
        3x3 megablock  can be H1..H5.
        2x2 megablock 20% chance to be L1..L4, otherwise H1..H5.
        */
        var size = ServerRandomUtils_1.ServerRandomUtils.randomValueWithWeights([2, 3], [8, 2]);
        var symbol;
        if (size === 3) {
            symbol = ServerRandomUtils_1.ServerRandomUtils.randomValueWithWeights([ServerSymbols_1.H1, ServerSymbols_1.H2, ServerSymbols_1.H3, ServerSymbols_1.H4, ServerSymbols_1.H5], [1, 1, 1, 1, 1]);
        }
        else {
            var symbolSet = ServerRandomUtils_1.ServerRandomUtils.randomValueWithWeights([[ServerSymbols_1.H5, ServerSymbols_1.H4, ServerSymbols_1.H3, ServerSymbols_1.H2, ServerSymbols_1.H1], [ServerSymbols_1.L4, ServerSymbols_1.L3, ServerSymbols_1.L2, ServerSymbols_1.L1]], [8, 2]);
            var weight_1 = [];
            symbolSet.forEach(function () {
                weight_1.push(1);
            });
            symbol = ServerRandomUtils_1.ServerRandomUtils.randomValueWithWeights(symbolSet, weight_1);
        }
        /*
        Place top left corner on reels 2, 3 or 4, row 1 or 4 (depending of selected area).
        If 2x2 megablock, 50% chance to increase reel by 1, and 50% chance to increase row by 1.
        */
        var position;
        var yOffset = 0;
        var xOffset = 0;
        if (size === 2) {
            yOffset = ServerRandomUtils_1.ServerRandomUtils.randomInt(0, 1);
            xOffset = ServerRandomUtils_1.ServerRandomUtils.randomInt(0, 1);
        }
        position = { reel: reelIndexes[ServerRandomUtils_1.ServerRandomUtils.randomInt(0, 2)] + xOffset, row: rowIndexes[chosenSection] + yOffset };
        /*
        If 5% chance successful, do the same for the remaining 6x3 area.
        Select megablock symbol again, independently of the previous selection.
        */
        if (ServerRandomUtils_1.ServerRandomUtils.randomValueWithWeights([true, false], [1, 20]) && !nextSection) {
            var newChosenSection = chosenSection === 1 ? 0 : 1;
            currentReels = this.placeMegablockInReels(currentReels, position, size, symbol);
            this.meagaBlockUncommonCase3(currentReels, newChosenSection);
        }
        else {
            return this.placeMegablockInReels(currentReels, position, size, symbol);
        }
    };
    ServerAvalancheReels.prototype.meagaBlockUncommonCase4 = function (currentReels, nextSection) {
        /*
        Divide 6x6 reels into 2 areas of 3x6 - left and right.
        */
        var reelIndexes = [0, 3];
        var rowIndexes = [0, 1, 2, 3];
        /*
        Select one area randomly.
        */
        var chosenSection;
        if (nextSection) {
            chosenSection = nextSection;
        }
        else {
            chosenSection = ServerRandomUtils_1.ServerRandomUtils.randomInt(0, 1);
        }
        /*
        20% chance to make it 3x3, otherwise 2x2. 3x3 megablock can be H1..H5.
        */
        var size = ServerRandomUtils_1.ServerRandomUtils.randomValueWithWeights([2, 3], [8, 2]);
        var symbol;
        if (size === 3) {
            symbol = ServerRandomUtils_1.ServerRandomUtils.randomValueWithWeights([ServerSymbols_1.H1, ServerSymbols_1.H2, ServerSymbols_1.H3, ServerSymbols_1.H4, ServerSymbols_1.H5], [1, 1, 1, 1, 1]);
        }
        else {
            var symbolSet = ServerRandomUtils_1.ServerRandomUtils.randomValueWithWeights([[ServerSymbols_1.H5, ServerSymbols_1.H4, ServerSymbols_1.H3, ServerSymbols_1.H2, ServerSymbols_1.H1], [ServerSymbols_1.L4, ServerSymbols_1.L3, ServerSymbols_1.L2, ServerSymbols_1.L1]], [8, 2]);
            var weight_2 = [];
            symbolSet.forEach(function () {
                weight_2.push(1);
            });
            symbol = ServerRandomUtils_1.ServerRandomUtils.randomValueWithWeights(symbolSet, weight_2);
        }
        /*
        2x2 megablock 20% chance to be L1..L4, otherwise H1..H5.
        Place top left corner on reels 1 or 4, row 1,2,3,4 (depending of selected area).
        If 2x2 megablock, 50% chance to increase reel by 1, and 50% chance to increase row by 1.
        */
        var position;
        var yOffset = 0;
        var xOffset = 0;
        if (size === 2) {
            yOffset = ServerRandomUtils_1.ServerRandomUtils.randomInt(0, 1);
            xOffset = ServerRandomUtils_1.ServerRandomUtils.randomInt(0, 1);
        }
        position = { reel: reelIndexes[ServerRandomUtils_1.ServerRandomUtils.randomInt(0, 2)] + xOffset, row: rowIndexes[chosenSection] + yOffset };
        /*
        If 5% chance successful, do the same for the remaining 3x6 area.
        Select megablock symbol again, independently of the previous selection.
        */
        if (ServerRandomUtils_1.ServerRandomUtils.randomValueWithWeights([true, false], [1, 20]) && !nextSection) {
            var newChosenSection = chosenSection === 1 ? 0 : 1;
            currentReels = this.placeMegablockInReels(currentReels, position, size, symbol);
            this.meagaBlockUncommonCase3(currentReels, newChosenSection);
        }
        else {
            return this.placeMegablockInReels(currentReels, position, size, symbol);
        }
    };
    ServerAvalancheReels.prototype.meagaBlockUncommonCase5 = function (currentReels) {
        /*
        Divide 6x6 reels into 9 areas of 2x2 size.
        */
        /*
        [0] [3]	[6]
        [1] [4] [7]
        [2] [5] [8]
        */
        var reelDivitions = [{ reel: 0, row: 0 }, { reel: 0, row: 2 }, { reel: 0, row: 4 }, { reel: 2, row: 0 }, { reel: 2, row: 2 }, { reel: 2, row: 4 }, { reel: 4, row: 0 }, { reel: 4, row: 2 }, { reel: 4, row: 4 }];
        var selectedSections = [];
        var symbolValues = [];
        var highSymbolSet = [ServerSymbols_1.H1, ServerSymbols_1.H2, ServerSymbols_1.H3, ServerSymbols_1.H4, ServerSymbols_1.H5];
        var lowSymbolSet = [ServerSymbols_1.L1, ServerSymbols_1.L2, ServerSymbols_1.L3, ServerSymbols_1.L4];
        /*
        If 25% chance successful,
            do: select random area;
            fill the area with 2x2 megablock;
            20% chance megablock symbol will be L1..L4, remaining 80% megablock symbol will be H1..H5.
        */
        if (ServerRandomUtils_1.ServerRandomUtils.randomValueWithWeights([true, false], [1, 3])) {
            selectedSections.push(ServerRandomUtils_1.ServerRandomUtils.randomInt(0, 8));
            var symbolSet = ServerRandomUtils_1.ServerRandomUtils.randomValueWithWeights([highSymbolSet, lowSymbolSet], [8, 2]);
            var weight_3 = [];
            symbolSet.forEach(function () {
                weight_3.push(1);
            });
            symbolValues.push(ServerRandomUtils_1.ServerRandomUtils.randomValueWithWeights(symbolSet, weight_3));
        }
        /*
        If 25% chance successful,
            do: select random area;
            2x2 megablock;
            20% chance megablock symbol will if area not used already, fill the area with be L1..L4, remaining 80% megablock symbol will be H1..H5.
        */
        if (ServerRandomUtils_1.ServerRandomUtils.randomValueWithWeights([true, false], [1, 3])) {
            var selectedSection_1 = ServerRandomUtils_1.ServerRandomUtils.randomInt(0, 8);
            var sectionAvailable_1 = true;
            selectedSections.forEach(function (prevSelection) {
                if (prevSelection === selectedSection_1) {
                    sectionAvailable_1 = false;
                }
            });
            if (sectionAvailable_1) {
                var symbolSet = ServerRandomUtils_1.ServerRandomUtils.randomValueWithWeights([highSymbolSet, lowSymbolSet], [8, 2]);
                var weight_4 = [];
                symbolSet.forEach(function () {
                    weight_4.push(1);
                });
                symbolValues.push(ServerRandomUtils_1.ServerRandomUtils.randomValueWithWeights(symbolSet, weight_4));
            }
        }
        /*
        If 25% chance successful,
            do: select random area;
            if area not used already, fill the area with 2x2 megablock;
            20% chance megablock symbol will be L1..L4, remaining 80% megablock symbol will be H1..H5.

        This way, up to 3 megablocks may be added, but can end with no megablocks agt all as well.
        */
        if (ServerRandomUtils_1.ServerRandomUtils.randomValueWithWeights([true, false], [1, 3])) {
            var selectedSection_2 = ServerRandomUtils_1.ServerRandomUtils.randomInt(0, 8);
            var sectionAvailable_2 = true;
            selectedSections.forEach(function (prevSelection) {
                if (prevSelection === selectedSection_2) {
                    sectionAvailable_2 = false;
                }
            });
            if (sectionAvailable_2) {
                var symbolSet = ServerRandomUtils_1.ServerRandomUtils.randomValueWithWeights([highSymbolSet, lowSymbolSet], [8, 2]);
                var weight_5 = [];
                symbolSet.forEach(function () {
                    weight_5.push(1);
                });
                symbolValues.push(ServerRandomUtils_1.ServerRandomUtils.randomValueWithWeights(symbolSet, weight_5));
            }
        }
        if (symbolValues.length > 0) {
            for (var i = 0; i < symbolValues.length; i++) {
                currentReels = this.placeMegablockInReels(currentReels, reelDivitions[selectedSections[i]], 2, symbolValues[i]);
            }
            return currentReels;
        }
        else {
            return currentReels;
        }
    };
    ServerAvalancheReels.prototype.placeMegablockInReels = function (currentReels, position, size, symbol) {
        // Replace symbols in the current reelset with the one from the megablock at position with size.
        console.log('before megablock insertion', currentReels);
        console.log('symboltype', symbol, 'startposition', position);
        var isFull = true;
        for (var xPos = position.reel; xPos < position.reel + size; xPos++) {
            for (var yPos = position.row; yPos < position.row + size; yPos++) {
                if (currentReels.visibleReels[xPos][yPos] !== ServerSymbols_1.CHEST_RESPIN
                    && currentReels.visibleReels[xPos][yPos] !== ServerSymbols_1.CHEST_EXPLODE
                    && currentReels.visibleReels[xPos][yPos] !== ServerSymbols_1.CHEST_WILD
                    && currentReels.visibleReels[xPos][yPos] !== ServerSymbols_1.MIMIC_CHEST
                    && currentReels.visibleReels[xPos][yPos] !== ServerSymbols_1.W
                    && currentReels.visibleReels[xPos][yPos] !== ServerSymbols_1.E
                    && currentReels.visibleReels[xPos][yPos] !== ServerSymbols_1.SC
                    && currentReels.visibleReels[xPos][yPos] !== ServerSymbols_1.KEY) {
                    currentReels.visibleReels[xPos][yPos] = symbol;
                }
                else {
                    isFull = false;
                }
            }
        }
        this._currentMegablock = { isFull: isFull, position: position, size: size };
        console.log('after megablock insertion', symbol, currentReels);
        return currentReels;
    };
    Object.defineProperty(ServerAvalancheReels.prototype, "currentMegablock", {
        get: function () {
            return this._currentMegablock;
        },
        enumerable: true,
        configurable: true
    });
    ServerAvalancheReels.ROWS = 6;
    ServerAvalancheReels.REELS = 6;
    ServerAvalancheReels.FIRST3REELS = [
        [0, 1, 2],
        [0, 2, 1],
        [1, 0, 2],
        [1, 2, 0],
        [2, 0, 1],
        [2, 1, 0],
    ];
    ServerAvalancheReels.SECOND3REELS = [
        [3, 4, 5],
        [3, 5, 4],
        [4, 3, 5],
        [4, 5, 3],
        [5, 3, 4],
        [5, 4, 3],
    ];
    return ServerAvalancheReels;
}());
exports.ServerAvalancheReels = ServerAvalancheReels;


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServerData_1 = __webpack_require__(315);
var ServerAvalancheReelsRound_1 = __webpack_require__(164);
var ServerCheats_1 = __webpack_require__(608);
var Server = /** @class */ (function () {
    function Server() {
        this._history = [];
        this._mfsRounds = [];
        this._fsRounds = [];
        this._data = new ServerData_1.ServerData();
        this._cheats = new ServerCheats_1.ServerCheats();
        this._cheats.reset();
        window.cheats = this._cheats;
    }
    Server.prototype.init = function (choosenFeatures) {
        for (var _i = 0, choosenFeatures_1 = choosenFeatures; _i < choosenFeatures_1.length; _i++) {
            var feature = choosenFeatures_1[_i];
            this._data.activateFeature(feature);
        }
    };
    Server.prototype.spin = function () {
        this._cheats.reset();
        if (window.cheat) {
            this._cheats.isCheatsEnabled = true;
            if (window.cheat === 'noCheat') {
                this._cheats.isCheatsEnabled = false;
                this._cheats.reset();
            }
            if (window.cheat === 'simpleWin') {
                this._cheats.cheatPositions = [0, 0, 0, 0, 0, 0];
            }
            if (window.cheat === 'tmpCheat') {
                this._cheats.cheatPositions = [29, 94, 56, 0, 53, 8];
                this._cheats.firstThreeReelsCombination = [0, 1, 2];
                this._cheats.secondThreeReelsCombination = [3, 4, 5];
                this._cheats.expandedWildReels = [5];
            }
            if (window.cheat === 'simpleEW1ReelWin') {
                this._cheats.cheatPositions = [0, 0, 0, 0, 0, 0];
                this._cheats.firstThreeReelsCombination = [0, 1, 2];
                this._cheats.secondThreeReelsCombination = [3, 4, 5];
                this._cheats.expandedWildReels = [0];
            }
            if (window.cheat === 'simpleRespin') {
                this._cheats.cheatPositions = [0, 0, 0, 0, 0, 0];
                this._cheats.firstThreeReelsCombination = [0, 1, 2];
                this._cheats.secondThreeReelsCombination = [3, 4, 5];
            }
            if (window.cheat === 'addChestEW') {
                this._cheats.shouldAddChest = true;
                this._cheats.shouldNOTWinMimicFS = true;
                this._cheats.chestContent.hasExpandedWild = true;
            }
            if (window.cheat === 'addChestExpl') {
                this._cheats.shouldAddChest = true;
                this._cheats.shouldNOTWinMimicFS = true;
                this._cheats.chestContent.hasExplotion = true;
            }
            if (window.cheat === 'addChestRespin') {
                this._cheats.shouldAddChest = true;
                this._cheats.shouldNOTWinMimicFS = true;
                this._cheats.chestContent.hasRespin = true;
            }
            if (window.cheat === 'replayLastRound') {
                if (this._lastRound) {
                    return;
                }
            }
            if (window.cheat === 'simpleChest') {
                this._cheats.shouldAddChest = true;
            }
            if (window.cheat === 'winMimic') {
                this._cheats.shouldAddChest = true;
                this._cheats.chestContent.hasMimicFreeSpins = true;
            }
            if (window.cheat === 'triggerBattleFS') {
                this._cheats.shouldTriggerBattleFreeSpins = true;
            }
        }
        this._lastRound = new ServerAvalancheReelsRound_1.ServerAvalancheReelsRound();
        this._lastRound.spin(this._data, this._cheats);
        if (this._data.isInMimicFreeSpins) {
            this._cheats.isCheatsEnabled = false;
            this._mfsRounds = [];
            while (this._data.isInMimicFreeSpins) {
                var round = new ServerAvalancheReelsRound_1.ServerAvalancheReelsRound();
                round.spin(this._data, this._cheats);
                this._mfsRounds.push(round);
            }
        }
        else {
            this._mfsRounds = [];
        }
        if (this._data.isInFreeSpins) {
            this._cheats.isCheatsEnabled = false;
            this._fsRounds = [];
            while (this._data.isInFreeSpins) {
                var round = new ServerAvalancheReelsRound_1.ServerAvalancheReelsRound();
                round.spin(this._data, this._cheats);
                // this._data.addToTotalFreeSpins(round.additionalFSInThisRound);
                this._fsRounds.push(round);
            }
        }
        else {
            this._fsRounds = [];
        }
        this._history.push(this._lastRound);
        this._cheats.reset();
    };
    Server.prototype.getCurrentRoundResult = function () {
        return this._lastRound.getCurrentRoundResult();
    };
    Server.prototype.getCurrentMimicFS = function () {
        if (!this._mfsRounds) {
            return null;
        }
        var rounds = [];
        for (var _i = 0, _a = this._mfsRounds; _i < _a.length; _i++) {
            var round = _a[_i];
            rounds.push(round.getCurrentRoundResult());
        }
        return rounds;
    };
    Server.prototype.getCurrentFS = function () {
        if (!this._fsRounds) {
            return null;
        }
        var rounds = [];
        for (var _i = 0, _a = this._fsRounds; _i < _a.length; _i++) {
            var round = _a[_i];
            rounds.push(round.getCurrentRoundResult());
        }
        return rounds;
    };
    Server.prototype.hasMimicFSRounds = function () {
        return this._mfsRounds && this._mfsRounds.length > 0;
    };
    return Server;
}());
exports.Server = Server;


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServerCheats = /** @class */ (function () {
    function ServerCheats() {
        this._cheatPositions = [];
    }
    ServerCheats.prototype.reset = function () {
        this._isCheatsEnabled = false;
        this._cheatPositions = [];
        this._firstThreeReelsCombination = [];
        this._secondThreeReelsCombination = [];
        this._expandedWildReels = [];
        this._shouldTriggerFreeSpins = false;
        this._shouldAddChest = false;
        this._chestContent = { hasExplotion: false, hasRespin: false, hasExpandedWild: false, hasMimicFreeSpins: false };
        this._shouldTriggerBattleFreeSpins = false;
        this._shouldNOTWinMimicFS = false;
    };
    Object.defineProperty(ServerCheats.prototype, "cheatPositions", {
        get: function () {
            return this._cheatPositions;
        },
        set: function (value) {
            this._cheatPositions = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ServerCheats.prototype, "firstThreeReelsCombination", {
        get: function () {
            return this._firstThreeReelsCombination;
        },
        set: function (value) {
            this._firstThreeReelsCombination = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ServerCheats.prototype, "secondThreeReelsCombination", {
        get: function () {
            return this._secondThreeReelsCombination;
        },
        set: function (value) {
            this._secondThreeReelsCombination = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ServerCheats.prototype, "shouldTriggerFreeSpins", {
        get: function () {
            return this._shouldTriggerFreeSpins;
        },
        set: function (value) {
            this._shouldTriggerFreeSpins = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ServerCheats.prototype, "shouldAddChest", {
        get: function () {
            return this._shouldAddChest;
        },
        set: function (value) {
            this._shouldAddChest = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ServerCheats.prototype, "chestContent", {
        get: function () {
            return this._chestContent;
        },
        set: function (value) {
            this._chestContent = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ServerCheats.prototype, "isCheatsEnabled", {
        get: function () {
            return this._isCheatsEnabled;
        },
        set: function (value) {
            this._isCheatsEnabled = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ServerCheats.prototype, "expandedWildReels", {
        get: function () {
            return this._expandedWildReels;
        },
        set: function (value) {
            this._expandedWildReels = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ServerCheats.prototype, "shouldTriggerBattleFreeSpins", {
        get: function () {
            return this._shouldTriggerBattleFreeSpins;
        },
        set: function (value) {
            this._shouldTriggerBattleFreeSpins = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ServerCheats.prototype, "shouldNOTWinMimicFS", {
        get: function () {
            return this._shouldNOTWinMimicFS;
        },
        set: function (value) {
            this._shouldNOTWinMimicFS = value;
        },
        enumerable: true,
        configurable: true
    });
    return ServerCheats;
}());
exports.ServerCheats = ServerCheats;


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Storage_1 = __webpack_require__(150);
var RelaxStorage = /** @class */ (function (_super) {
    __extends(RelaxStorage, _super);
    function RelaxStorage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RelaxStorage.prototype.setItem = function (key, data) { };
    return RelaxStorage;
}(Storage_1.BaseStorage));
exports.RelaxStorage = RelaxStorage;


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var RelaxLogicEvents = /** @class */ (function () {
    function RelaxLogicEvents() {
    }
    RelaxLogicEvents.REPLAY_RESPONSE = 'RelaxLogicEvents::REPLAY_RESPONSE';
    RelaxLogicEvents.REPLAY_HTTP_RESPONSE = 'RelaxLogicEvents::REPLAY_HTTP_RESPONSE';
    RelaxLogicEvents.REALITY_CHECK_RECIEVED_IN_RESPONSE = 'RelaxLogicEvents::REALITY_CHECK_RECIEVED_IN_RESPONSE';
    RelaxLogicEvents.FREE_ROUNDS_SKIPPED = 'RelaxLogicEvents::FREE_ROUNDS_SKIPPED';
    RelaxLogicEvents.FREE_ROUNDS_DELETED = 'RelaxLogicEvents::FREE_ROUNDS_DELETED';
    RelaxLogicEvents.CLIENT_CONFIG_RESPONSE = 'RelaxLogicEvents::CLIENT_CONFIG_RESPONSE';
    return RelaxLogicEvents;
}());
exports.RelaxLogicEvents = RelaxLogicEvents;


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var PrototypeCommunicator_1 = __webpack_require__(316);
var GamePrototypeCommunicator = /** @class */ (function (_super) {
    __extends(GamePrototypeCommunicator, _super);
    function GamePrototypeCommunicator() {
        var _this = _super.call(this) || this;
        _this.options.path = '/simserver/Init?g=pendingwilds';
        _this.gameID = 'pendingwilds';
        return _this;
    }
    GamePrototypeCommunicator.prototype.addCheatToSpin = function () {
        _super.prototype.addCheatToSpin.call(this);
        if (window.cheatAdditionalData && window.cheatAdditionalData.length > 0) {
            this.options.path += window.cheatAdditionalData;
        }
        if (window.cheat) {
            this.options.path += window.cheatPath;
        }
    };
    return GamePrototypeCommunicator;
}(PrototypeCommunicator_1.PrototypeCommunicator));
exports.GamePrototypeCommunicator = GamePrototypeCommunicator;


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var PrototypeSpinResult_1 = __webpack_require__(312);
var SpinResult_1 = __webpack_require__(110);
var GamePrototypeSpinResult = /** @class */ (function (_super) {
    __extends(GamePrototypeSpinResult, _super);
    function GamePrototypeSpinResult() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GamePrototypeSpinResult.prototype.setRespinData = function (avalanche) {
        this._respinScatters = [];
        for (var _i = 0, _a = avalanche.respins; _i < _a.length; _i++) {
            var respin = _a[_i];
            this._respinScatters.push(new SpinResult_1.RespinScatterInfo(respin.position, respin.removedPositions));
        }
    };
    return GamePrototypeSpinResult;
}(PrototypeSpinResult_1.PrototypeSpinResult));
exports.GamePrototypeSpinResult = GamePrototypeSpinResult;


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var NetworkModule_1 = __webpack_require__(317);
var GameNetworkModule_1 = __webpack_require__(614);
var RecodeGameNetworkBasicState_1 = __webpack_require__(615);
var RecodeGameNetworkModule = /** @class */ (function (_super) {
    __extends(RecodeGameNetworkModule, _super);
    function RecodeGameNetworkModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RecodeGameNetworkModule.prototype.setupStates = function () {
        this.addState(new RecodeGameNetworkBasicState_1.RecodeGameNetworkBasicState(this, NetworkModule_1.NetworkModule.BASIC_STATE));
    };
    RecodeGameNetworkModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
    };
    return RecodeGameNetworkModule;
}(GameNetworkModule_1.GameNetworkModule));
exports.RecodeGameNetworkModule = RecodeGameNetworkModule;


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var NetworkModule_1 = __webpack_require__(317);
var GameNetworkBasicState_1 = __webpack_require__(319);
var GameNetworkModule = /** @class */ (function (_super) {
    __extends(GameNetworkModule, _super);
    function GameNetworkModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameNetworkModule.prototype.setupStates = function () {
        _super.prototype.setupStates.call(this);
        this.addState(new GameNetworkBasicState_1.GameNetworkBasicState(this, NetworkModule_1.NetworkModule.BASIC_STATE));
    };
    GameNetworkModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
    };
    return GameNetworkModule;
}(NetworkModule_1.NetworkModule));
exports.GameNetworkModule = GameNetworkModule;


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var GameNetworkBasicState_1 = __webpack_require__(319);
var RecodeGameNetworkBasicState = /** @class */ (function (_super) {
    __extends(RecodeGameNetworkBasicState, _super);
    function RecodeGameNetworkBasicState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RecodeGameNetworkBasicState.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
    };
    RecodeGameNetworkBasicState.prototype.onAvalanche = function () {
        this.module.logic.avalanche(null);
    };
    RecodeGameNetworkBasicState.prototype.onReelsRespinStarted = function () {
        this.module.logic.respin(null);
    };
    return RecodeGameNetworkBasicState;
}(GameNetworkBasicState_1.GameNetworkBasicState));
exports.RecodeGameNetworkBasicState = RecodeGameNetworkBasicState;


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var FreeSpinsInfoModule_1 = __webpack_require__(617);
var GameFreeSpinsInfoModule = /** @class */ (function (_super) {
    __extends(GameFreeSpinsInfoModule, _super);
    function GameFreeSpinsInfoModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameFreeSpinsInfoModule.prototype.restore = function () {
        var logic = this.logic;
        if (logic.isFreeSpinsStarted && logic.freeSpinsPlayed > 0) {
            this.view.show();
            this.updateSpinsLeftOnRestore();
        }
    };
    GameFreeSpinsInfoModule.prototype.updateSpinsLeftOnRestore = function () {
        this.view.setRemainingFreeSpins(this.logic.freespinsTotalAwarded, this.logic.freeSpinsPlayed);
    };
    return GameFreeSpinsInfoModule;
}(FreeSpinsInfoModule_1.FreeSpinsInfoModule));
exports.GameFreeSpinsInfoModule = GameFreeSpinsInfoModule;


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Module_1 = __webpack_require__(2);
var Views_1 = __webpack_require__(8);
var FlowModuleEvents_1 = __webpack_require__(0);
var FreeSpinsEvents_1 = __webpack_require__(6);
var ReelsEvents_1 = __webpack_require__(4);
var FreeSpinsInfoModule = /** @class */ (function (_super) {
    __extends(FreeSpinsInfoModule, _super);
    function FreeSpinsInfoModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FreeSpinsInfoModule.prototype.restore = function () {
        var logic = this.logic;
        if (logic.isFreeSpinsStarted && logic.freeSpinsPlayed > 0) {
            this.view.show();
            this.updateFreeSpinInformation();
        }
    };
    FreeSpinsInfoModule.prototype.enterFirstState = function () {
        this.view.hide();
    };
    FreeSpinsInfoModule.prototype.setupStates = function () {
    };
    FreeSpinsInfoModule.prototype.setupViews = function () {
        if (this.system.shouldUseMultipleViews()) {
            this.setView(Views_1.Views.FREE_SPINS_INFO_VIEW_MOBILE);
        }
        else {
            this.setView(Views_1.Views.FREE_SPINS_INFO_VIEW);
        }
    };
    FreeSpinsInfoModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        // this.on(ReelsEvents.SPIN_ENDED, this.onSpinEnded, 1);
        this.on(ReelsEvents_1.ReelsEvents.REELS_SPINNING_STARTED, this.onSpinStarted, 1);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_INTRO_FINISHED, this.onFreeSpinsIntroFinished);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_CONTINUE_CLICKED, this.onFreeSpinsContinueClicked);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_OUTRO_STARTED, this.onFreeSpinsOutroStarted);
        this.on(FlowModuleEvents_1.FlowModuleEvents.FREE_SPINS_FINISHED, this.onFreeSpinsFinished);
    };
    FreeSpinsInfoModule.prototype.onFreeSpinsContinueClicked = function () {
        this.view.show();
        this.updateMultiplier(1);
        this.updateFreeSpinInformation();
    };
    FreeSpinsInfoModule.prototype.onFreeSpinsOutroStarted = function () {
        this.view.hide();
    };
    FreeSpinsInfoModule.prototype.updateMultiplier = function (multiplier) {
        this.view.multiplierFreeSpins = multiplier;
    };
    FreeSpinsInfoModule.prototype.updateSpinsLeft = function () {
        if (this.logic.freeSpinsPlayed === this.logic.freespinsTotalAwarded) {
            this.view.setRemainingFreeSpins(this.logic.freespinsTotalAwarded, this.logic.freeSpinsPlayed);
        }
        else {
            this.view.setRemainingFreeSpins(this.logic.freespinsTotalAwarded, this.logic.freeSpinsPlayed + 1);
        }
    };
    FreeSpinsInfoModule.prototype.onFreeSpinsFinished = function () {
        this.updateFreeSpinInformation();
    };
    FreeSpinsInfoModule.prototype.updateFreeSpinInformation = function () {
        this.updateSpinsLeft();
    };
    FreeSpinsInfoModule.prototype.onMultiplierUpdated = function (event, multiplier) {
        this.updateFreeSpinInformation();
        this.updateMultiplier(multiplier);
    };
    FreeSpinsInfoModule.prototype.onFreeSpinsIntroFinished = function () {
        this.updateFreeSpinInformation();
    };
    /*protected onSpinEnded(): void {
        this.updateFreeSpinInformation();
    }*/
    FreeSpinsInfoModule.prototype.onSpinStarted = function () {
        this.updateFreeSpinInformation();
    };
    return FreeSpinsInfoModule;
}(Module_1.Module));
exports.FreeSpinsInfoModule = FreeSpinsInfoModule;


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var FreeSpinsInfoView_1 = __webpack_require__(619);
var DeviceType_1 = __webpack_require__(106);
var GameFreeSpinsInfoView = /** @class */ (function (_super) {
    __extends(GameFreeSpinsInfoView, _super);
    function GameFreeSpinsInfoView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameFreeSpinsInfoView.prototype.setupInfoBox = function (title, layoutName, numberLayoutName, textLayoutName, hudObjectName) {
        var pos = this.layout.getAbsolutePosition(layoutName);
        // Get the local position in relation to their parent bone (layoutName)
        var textPos = this.layout.getPosition(textLayoutName);
        var numberPos = this.layout.getPosition(numberLayoutName);
        var maxWidth = this.device.type === DeviceType_1.DeviceType.MOBILE ? 230 : 430;
        var box = new FreeSpinsInfoView_1.FreeSpinInfoBox(this.resources, 0, title, hudObjectName, -15, maxWidth);
        box.setTextPosition(textPos);
        box.setNumberPosition(numberPos);
        box.position.set(pos.x, pos.y);
        this.container.addChild(box);
        return box;
    };
    return GameFreeSpinsInfoView;
}(FreeSpinsInfoView_1.FreeSpinsInfoView));
exports.GameFreeSpinsInfoView = GameFreeSpinsInfoView;


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var View_1 = __webpack_require__(3);
var WinNumbers_1 = __webpack_require__(45);
var FreeSpinsInfoView = /** @class */ (function (_super) {
    __extends(FreeSpinsInfoView, _super);
    function FreeSpinsInfoView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._hasMiltiplier = false;
        return _this;
    }
    FreeSpinsInfoView.prototype.init = function () {
        _super.prototype.init.call(this);
        this.initInfoBoxes();
    };
    FreeSpinsInfoView.prototype.addOneFreeSpin = function () {
        this._totalFreeSpinsValue++;
        this.setRemainingFreeSpins(this._totalFreeSpinsValue, this._leftFreeSpinsValue);
    };
    FreeSpinsInfoView.prototype.addPlayedSpin = function () {
        this._leftFreeSpinsValue++;
        this.setRemainingFreeSpins(this._totalFreeSpinsValue, this._leftFreeSpinsValue);
    };
    FreeSpinsInfoView.prototype.setRemainingFreeSpins = function (totalFS, remaining) {
        try {
            this._leftFreeSpinsValue = remaining;
            this._totalFreeSpinsValue = totalFS;
            this._remainingFreeSpinsBox.updateValueWithString(remaining.toString(10) + "/" + totalFS.toString(10));
        }
        catch (e) {
        }
    };
    Object.defineProperty(FreeSpinsInfoView.prototype, "multiplierFreeSpins", {
        set: function (multiplierValue) {
            if (this._hasMiltiplier) {
                this._multiplierFreeSpinsBox.updateValue(multiplierValue);
            }
        },
        enumerable: true,
        configurable: true
    });
    FreeSpinsInfoView.prototype.initInfoBoxes = function () {
        this._bgBox = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'FREESPIN_BACKGROUND.png'));
        var bgPos = this.layout.getAbsolutePosition('FREESPIN_MENU');
        this.container.addChild(this._bgBox);
        this._bgBox.position.set(bgPos.x, bgPos.y);
        this._bgBox.anchor.set(0.5);
        this._remainingFreeSpinsBox = this.setupInfoBox('TEXT_REMAINING.png', 'FREESPIN_REMAINING', 'FREESPIN_FREESPINS_REMAINING', 'FREESPIN_REMAINING_TEXT', 'BOX_FREE_SPINS.png');
        if (this._hasMiltiplier) {
            this._multiplierFreeSpinsBox = this.setupInfoBox('TEXT_MULTIPLIER.png', 'FREESPIN_MULTIPLIER', 'FREESPIN_MULTIPLIER_NUMBER', 'FREESPIN_MULTIPLIER_TEXT', 'BOX_MULTIPLIER.png');
        }
    };
    FreeSpinsInfoView.prototype.setupTextField = function (textField, layoutName) {
        var pos = this.layout.getAbsolutePosition(layoutName);
        textField.position.set(pos.x, pos.y);
        textField.anchor.set(0.5);
        this.container.addChild(textField);
    };
    FreeSpinsInfoView.prototype.setupInfoBox = function (title, layoutName, numberLayoutName, textLayoutName, hudObjectName) {
        var pos = this.layout.getAbsolutePosition(layoutName);
        // Get the local position in relation to their parent bone (layoutName)
        var textPos = this.layout.getPosition(textLayoutName);
        var numberPos = this.layout.getPosition(numberLayoutName);
        var box = new FreeSpinInfoBox(this.resources, 0, title, hudObjectName);
        box.setTextPosition(textPos);
        box.setNumberPosition(numberPos);
        box.position.set(pos.x, pos.y);
        this.container.addChild(box);
        return box;
    };
    return FreeSpinsInfoView;
}(View_1.View));
exports.FreeSpinsInfoView = FreeSpinsInfoView;
var FreeSpinInfoBox = /** @class */ (function (_super) {
    __extends(FreeSpinInfoBox, _super);
    function FreeSpinInfoBox(resources, value, title, hudObjectName, kerning, maxWidth) {
        var _this = _super.call(this) || this;
        _this._resources = resources;
        _this._value = value;
        _this._titleText = title;
        _this._hudObjectName = hudObjectName;
        _this._kerning = kerning;
        _this._maxWidth = maxWidth;
        _this.setupObject(title);
        return _this;
    }
    FreeSpinInfoBox.prototype.updateValue = function (value) {
        this._value = value;
        this._valueText.showNumber(value.toString(10));
    };
    FreeSpinInfoBox.prototype.checkIfMaxWidthNotExceeded = function () {
        if (this._maxWidth !== undefined && this._valueText.getLocalBounds().width > this._maxWidth) {
            var scale = this._maxWidth / this._valueText.getLocalBounds().width;
            this._valueText.scale.set(scale);
        }
    };
    FreeSpinInfoBox.prototype.updateValueWithString = function (value) {
        this._valueText.showNumber(value);
        this.checkIfMaxWidthNotExceeded();
    };
    FreeSpinInfoBox.prototype.setNumberPosition = function (numberPos) {
        this._valueText.position.set(numberPos.x, numberPos.y);
    };
    FreeSpinInfoBox.prototype.setTextPosition = function (textPos) {
        this._title.position.set(textPos.x, textPos.y);
    };
    FreeSpinInfoBox.prototype.setupObject = function (titleImageName) {
        this._bg = new PIXI.Sprite(this._resources.getSpritesheetTexture('HUD.json', this._hudObjectName));
        this._bg.anchor.set(0.5);
        this._title = new PIXI.Sprite(this._resources.getLocaleTextImage(titleImageName));
        this._title.anchor.set(0.5);
        this._valueText = new WinNumbers_1.WinNumbers(this._resources, 'SMALL_');
        this._valueText.numberAnchor.y = 0.5;
        if (this._kerning) {
            this._valueText.numberKerning = this._kerning;
        }
        this.addChild(this._bg);
        this.addChild(this._title);
        this.addChild(this._valueText);
    };
    Object.defineProperty(FreeSpinInfoBox.prototype, "currentValue", {
        get: function () {
            return this._value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FreeSpinInfoBox.prototype, "title", {
        get: function () {
            return this._titleText;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FreeSpinInfoBox.prototype, "valueText", {
        get: function () {
            return this._valueText;
        },
        enumerable: true,
        configurable: true
    });
    return FreeSpinInfoBox;
}(PIXI.Sprite));
exports.FreeSpinInfoBox = FreeSpinInfoBox;


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BigWinEvents_1 = __webpack_require__(21);
var FreeSpinsEvents_1 = __webpack_require__(6);
var Module_1 = __webpack_require__(2);
var FlowModuleEvents_1 = __webpack_require__(0);
var StartScreenEvents_1 = __webpack_require__(22);
var ReelsEvents_1 = __webpack_require__(4);
var SpinButtonEvents_1 = __webpack_require__(12);
var GameAvalancheReelsEvents_1 = __webpack_require__(39);
var RespinEvents_1 = __webpack_require__(92);
var AvalancheReelsEvents_1 = __webpack_require__(15);
var WildMeterEvents_1 = __webpack_require__(66);
var GameWinPresentationEvents_1 = __webpack_require__(40);
var WinUtils_1 = __webpack_require__(58);
var GameReelsStats_1 = __webpack_require__(276);
var SoundHandlerModule = /** @class */ (function (_super) {
    __extends(SoundHandlerModule, _super);
    function SoundHandlerModule() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._currentMusicLevel = 0;
        _this._isFSIntroStarted = false;
        _this._isBigWinInProgress = false;
        return _this;
    }
    SoundHandlerModule.prototype.restore = function () {
        _super.prototype.restore.call(this);
    };
    SoundHandlerModule.prototype.enterFirstState = function () {
    };
    SoundHandlerModule.prototype.setupStates = function () {
    };
    SoundHandlerModule.prototype.setupViews = function () {
    };
    SoundHandlerModule.prototype.setupEvents = function () {
        this.on(StartScreenEvents_1.StartScreenEvents.INTRO_STARTED, this.onGameIntroStarted);
        this.on(StartScreenEvents_1.StartScreenEvents.EXIT_FINISHED, this.onGameStarted);
        this.on(SpinButtonEvents_1.SpinButtonEvents.SPIN_BUTTON_PHYSICALLY_CLICKED, this.onSpinButtonPressed);
        this.on(SpinButtonEvents_1.SpinButtonEvents.SPIN_BUTTON_SPACE_PHYSICALLY_CLICKED, this.onSpinButtonPressed);
        this.on(SpinButtonEvents_1.SpinButtonEvents.QUICKSTOP_PRESSED, this.onQuickstopPressed);
        this.on(ReelsEvents_1.ReelsEvents.REELS_SPINNING_STARTED, this.onDropOutSymbols);
        this.on(AvalancheReelsEvents_1.AvalancheReelsEvents.ALL_REELS_DROP_NEW_STARTED, this.onDropInSymbols);
        this.on(GameAvalancheReelsEvents_1.GameAvalancheReelsEvents.FILLING_VOIDS_STARTED, this.onFillingVoids);
        this.on(GameAvalancheReelsEvents_1.GameAvalancheReelsEvents.WIN_HIGHLIGHTING_FINISHED, this.onUpdateMusicLevel); // TODO: Change to symbol drop event
        this.on(GameAvalancheReelsEvents_1.GameAvalancheReelsEvents.WIN_HIGHLIGHTING_STARTED, this.killMusicLevelTimer);
        this.on(RespinEvents_1.RespinEvents.RESPIN_STARTED, this.killMusicLevelTimer);
        this.on(ReelsEvents_1.ReelsEvents.ALL_REELS_STOPPED, this.onAllReelsStopped);
        this.on(GameAvalancheReelsEvents_1.GameAvalancheReelsEvents.WIN_SYMBOLS_EXPLOSION_STARTED, this.onRemoveSymbols);
        this.on(WildMeterEvents_1.WildMeterEvents.ADD_WILD_COIN_TO_REELS, this.onAddWildCoinToReels);
        this.on(WildMeterEvents_1.WildMeterEvents.SEND_COIN_TO_METER, this.onSendCoinToMeter);
        this.on(WildMeterEvents_1.WildMeterEvents.COIN_HIT_METER, this.onCoinHitMeter);
        this.on(WildMeterEvents_1.WildMeterEvents.MULTIPLIER_UDPATE, this.onMultiplierUpdate);
        this.on(WildMeterEvents_1.WildMeterEvents.INDICATOR_LIT, this.onMultIndicatorLit);
        this.on(WildMeterEvents_1.WildMeterEvents.WIN_METER_EXIT_WIN_ANIMATION_STARTED, this.onMultFlyToWin);
        this.on(GameAvalancheReelsEvents_1.GameAvalancheReelsEvents.WIN_HIGHLIGHTING_WINLINE, this.onLineWin);
        this.on(GameAvalancheReelsEvents_1.GameAvalancheReelsEvents.WIN_HIGHLIGHTING_STARTED, this.onInitialWinStarted);
        this.on(GameAvalancheReelsEvents_1.GameAvalancheReelsEvents.WIN_HIGHLIGHTING_FINISHED, this.onInitialWinFinished);
        this.on(GameWinPresentationEvents_1.GameWinPresentationEvents.COUNTING_STARTED, this.onWinPresentationCountingStarted);
        this.on(GameWinPresentationEvents_1.GameWinPresentationEvents.AFTER_MULTIPLIER_COUNTING_FINISHED, this.onWinPresentationCountingFinished);
        this.on(BigWinEvents_1.BigWinEvents.ON_BEFORE_BIG_WIN, this.onBeforeBigWin);
        this.on(BigWinEvents_1.BigWinEvents.COUNTUP_FINISHED, this.onBigWinFinished);
        this.on(BigWinEvents_1.BigWinEvents.TRANSITION_STARTED, this.onBigWinThreshold);
        this.on(RespinEvents_1.RespinEvents.RESPIN_STARTED, this.onRespinStarted);
        this.on(RespinEvents_1.RespinEvents.LEAVING_SYMBOL_AT, this.onRespinHit);
        this.on(RespinEvents_1.RespinEvents.END_ANIM_TRIGGERED, this.onRespinEnd);
        this.on(GameAvalancheReelsEvents_1.GameAvalancheReelsEvents.SCATTER_ATTENTION_TRIGGERED, this.onScatterAttention);
        this.on(GameAvalancheReelsEvents_1.GameAvalancheReelsEvents.RESPIN_ATTENTION_TRIGGERED, this.onRespinAttention);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_INTRO_STARTED, this.onFreeSpinsIntroStarted);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_OUTRO_STARTED, this.onFreeSpinsOutroStarted);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_OUTRO_FINISHED, this.onFreeSpinsOutroFinished);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_START_READY, this.onFreeSpinsStartReady);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_CONTINUE_CLICKED, this.onFreeSpinsContinueClicked);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_RETRIGGER_STARTED, this.onFreeSpinsRetriggerStarted);
        // this.on(GameBackgroundEvents.VIEW_TRANSITION_TO_MAINGAME_COMPLETED, this.onViewTransitionToMainGameCompleted);
        this.on(FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN, this.onSpinEnded);
    };
    // protected onViewTransitionToMainGameCompleted(): void {
    //     this.soundPlayer.fadeCurrentMusicTo(`mainMusic1`, 1000);
    // }
    SoundHandlerModule.prototype.onDropOutSymbols = function () {
        this.soundPlayer.play('reelsFallOut');
    };
    SoundHandlerModule.prototype.onDropInSymbols = function () {
        var soundId = GameReelsStats_1.GameReelsStats.IS_ON_REGULATED_MARKET ? 'reelsFallIn3sec' : 'reelsFallIn';
        this.soundPlayer.play(soundId);
    };
    SoundHandlerModule.prototype.onFillingVoids = function () {
        var _this = this;
        var soundId = 'reelsFallIn';
        var minVoids = 3;
        var maxVoids = 15 - minVoids;
        var numVoids = this.logic.getSpinResult().symbolsToRemove && this.logic.getSpinResult().symbolsToRemove.length - minVoids;
        this.soundPlayer.play(soundId);
        /* Shorten sound based on number of symbols falling down */
        if (numVoids >= 0 && numVoids < maxVoids) {
            var soundLength = 1280;
            var fadeOutDuration_1 = 250;
            var minDelay = 150;
            var fadeOutDelay = minDelay + (numVoids / maxVoids * (soundLength - minDelay - fadeOutDuration_1));
            this.timeUtils.createTimer(function () {
                _this.soundPlayer.stopFadeSound(soundId, fadeOutDuration_1, null);
            }, fadeOutDelay);
        }
    };
    SoundHandlerModule.prototype.onSpinEnded = function () {
        this.startMusicLevelTimer();
    };
    SoundHandlerModule.prototype.startMusicLevelTimer = function () {
        var _this = this;
        if (this._musicLevelTimer || this._currentMusicLevel < 2 || this.logic.isFreeSpinsStarted
            || this._isFSIntroStarted) {
            return;
        }
        this._musicLevelTimer = this.timeUtils.createTimer(function () {
            _this._currentMusicLevel -= 1;
            _this.soundPlayer.fadeCurrentMusicTo("mainMusic" + _this._currentMusicLevel, 1000);
            _this.killMusicLevelTimer();
            _this.startMusicLevelTimer();
        }, SoundHandlerModule.MUSICLEVEL_DELAY_UNTIL_DECREASE);
    };
    SoundHandlerModule.prototype.killMusicLevelTimer = function () {
        if (this._musicLevelTimer) {
            this._musicLevelTimer.stop();
            this._musicLevelTimer = null;
        }
    };
    SoundHandlerModule.prototype.onUpdateMusicLevel = function () {
        var logic = this.logic;
        if (logic.isFreeSpinsStarted) {
            return;
        }
        var totalWinTimesBet = logic.getNextAvalancheRunningTotalInCents() / logic.getTotalBet();
        var musicLevel = totalWinTimesBet >= SoundHandlerModule.MUSICLEVEL_WINLIMIT_2 ? 3 :
            totalWinTimesBet >= SoundHandlerModule.MUSICLEVEL_WINLIMIT_1 ? 2 : 1;
        if (musicLevel > this._currentMusicLevel) {
            this.soundPlayer.fadeCurrentMusicTo("mainMusic" + musicLevel, 1000);
            this._currentMusicLevel = musicLevel;
        }
    };
    SoundHandlerModule.prototype.onAllReelsStopped = function () {
    };
    SoundHandlerModule.prototype.onFreeSpinsStartReady = function () {
    };
    SoundHandlerModule.prototype.startFsTimer = function () {
        var _this = this;
        if (this._fsTimer) {
            return;
        }
        this._fsTimer = this.timeUtils.createTimer(function () {
            _this.startFreeSpinsMusic();
        }, SoundHandlerModule.FS_DELAY_UNTIL_MUSIC);
    };
    SoundHandlerModule.prototype.killFsTimer = function () {
        if (this._fsTimer) {
            this._fsTimer.stop();
            this._fsTimer = null;
        }
    };
    SoundHandlerModule.prototype.onFreeSpinsIntroStarted = function () {
        this._isFSIntroStarted = true;
        this.killMusicLevelTimer();
        this.soundPlayer.fadeCurrentMusic(1000);
        this.soundPlayer.play('freeSpinsIntro');
        this.startFsTimer();
    };
    SoundHandlerModule.prototype.onFreeSpinsContinueClicked = function () {
        if (!this._fsTimer) { // Music already started
            return;
        }
        this.startFreeSpinsMusic();
    };
    SoundHandlerModule.prototype.onFreeSpinsRetriggerStarted = function () {
        this.soundPlayer.play('winRetrigger');
    };
    SoundHandlerModule.prototype.startFreeSpinsMusic = function () {
        this.killFsTimer();
        this.soundPlayer.stopMusic();
        this.soundPlayer.playMusic('freeSpinsMusic');
    };
    SoundHandlerModule.prototype.onFreeSpinsOutroStarted = function () {
        this.soundPlayer.fadeCurrentMusic(1000);
        this.soundPlayer.play('freeSpinsOutro');
    };
    SoundHandlerModule.prototype.onFreeSpinsOutroFinished = function () {
        this._isFSIntroStarted = false;
        this.soundPlayer.stopMusic();
        this.soundPlayer.fadeCurrentMusicTo('mainMusic1');
    };
    SoundHandlerModule.prototype.onGameIntroStarted = function () {
        this.soundPlayer.play('gameIntro');
    };
    SoundHandlerModule.prototype.onGameStarted = function () {
        var logic = this.logic;
        if (logic.isFreeSpinsStarted && logic.hasRestore) {
            this.soundPlayer.fadeCurrentMusicTo('freeSpinsMusic', 1000);
        }
        else {
            this.soundPlayer.fadeCurrentMusicTo("mainMusic1", 1000);
        }
    };
    SoundHandlerModule.prototype.onSpinButtonPressed = function () {
        this.soundPlayer.play('spinBtnStart');
    };
    SoundHandlerModule.prototype.onQuickstopPressed = function () {
        this.soundPlayer.play('spinBtnQuickStop');
    };
    SoundHandlerModule.prototype.onRemoveSymbols = function () {
        this.soundPlayer.play('reelsRemove');
    };
    SoundHandlerModule.prototype.onLineWin = function (event, isRightToLeft) {
        this.soundPlayer.play('winLine' + (isRightToLeft ? 'R' : 'L'));
    };
    SoundHandlerModule.prototype.onInitialWinStarted = function () {
        this.soundPlayer.play('winCountup', true);
    };
    SoundHandlerModule.prototype.onInitialWinFinished = function () {
        this.soundPlayer.stopFadeSound('winCountup', 300, null);
    };
    SoundHandlerModule.prototype.onBeforeBigWin = function () {
        var _this = this;
        this._isBigWinInProgress = true;
        this.soundPlayer.duckMusic(1000);
        this.soundPlayer.play('bigwinBuildup');
        this.timeUtils.createTimer(function () {
            if (_this._isBigWinInProgress) {
                _this.soundPlayer.play('bigwinLoop');
            }
        }, 750);
    };
    SoundHandlerModule.prototype.onBigWinThreshold = function () {
        this.soundPlayer.play('bigwinThreshold');
    };
    SoundHandlerModule.prototype.onBigWinFinished = function () {
        this._isBigWinInProgress = false;
        this.soundPlayer.stopFadeSound('bigwinLoop', 300, null);
        this.soundPlayer.play('bigwinEnd');
        this.soundPlayer.unduckMusic(2600);
    };
    SoundHandlerModule.prototype.onRespinAttention = function () {
        this.soundPlayer.play('respinAttention');
    };
    SoundHandlerModule.prototype.onRespinStarted = function () {
        this.soundPlayer.play('respinActivate');
        this.soundPlayer.play('respinMove');
    };
    SoundHandlerModule.prototype.onRespinHit = function () {
        var soundId = 'respinHit' + (Math.floor(Math.random() * 3) + 1);
        this.soundPlayer.play(soundId);
    };
    SoundHandlerModule.prototype.onRespinEnd = function () {
        this.soundPlayer.play('respinEnd');
    };
    SoundHandlerModule.prototype.onScatterAttention = function (event, scatterIndex) {
        var soundId = 'scatterAttention' + Math.min(scatterIndex, 3);
        this.soundPlayer.play(soundId);
    };
    SoundHandlerModule.prototype.onAddWildCoinToReels = function () {
        var _this = this;
        this.timeUtils.createTimer(function () {
            _this.soundPlayer.play('multWildBreak');
        }, 750);
    };
    SoundHandlerModule.prototype.onSendCoinToMeter = function () {
        this.soundPlayer.play('multCollectFly');
    };
    SoundHandlerModule.prototype.onCoinHitMeter = function () {
        this.soundPlayer.play('multCollectHit');
    };
    SoundHandlerModule.prototype.onMultiplierUpdate = function () {
        var logic = this.logic;
        var soundID = logic.isFreeSpinsStarted ? 'multUpdateFs' : 'multUpdate';
        this.soundPlayer.play(soundID);
    };
    SoundHandlerModule.prototype.onMultIndicatorLit = function () {
        this.soundPlayer.play('multCollectIndicator');
    };
    SoundHandlerModule.prototype.onMultFlyToWin = function () {
        this.soundPlayer.play('multWin');
    };
    SoundHandlerModule.prototype.onWinPresentationCountingStarted = function (eventId, value, playCountUpSound) {
        if (playCountUpSound === void 0) { playCountUpSound = false; }
        if (value >= this.logic.getTotalBet() * WinUtils_1.WinUtils.NICE_WIN_ONE_ROUND_THRESHOLD_HIGH) {
            // isExcellent
            this.soundPlayer.play('winExcellent');
            playCountUpSound && this.soundPlayer.play('winCountup', true);
        }
        else if (value >= this.logic.getTotalBet() * WinUtils_1.WinUtils.NICE_WIN_ONE_ROUND_THRESHOLD_LOW) {
            // isNice
            this.soundPlayer.play('winNice');
            playCountUpSound && this.soundPlayer.play('winCountup', true);
        }
        else {
            // normal
            this.soundPlayer.play('winNormal');
        }
    };
    SoundHandlerModule.prototype.onWinPresentationCountingFinished = function () {
        this.soundPlayer.stopFadeSound('winCountup', 300, null);
    };
    SoundHandlerModule.MUSICLEVEL_WINLIMIT_1 = 1;
    SoundHandlerModule.MUSICLEVEL_WINLIMIT_2 = 3;
    SoundHandlerModule.MUSICLEVEL_DELAY_UNTIL_DECREASE = 10000;
    SoundHandlerModule.FS_DELAY_UNTIL_MUSIC = 4450;
    return SoundHandlerModule;
}(Module_1.Module));
exports.SoundHandlerModule = SoundHandlerModule;


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var SoundManager_1 = __webpack_require__(145);
var GameSoundManager = /** @class */ (function (_super) {
    __extends(GameSoundManager, _super);
    function GameSoundManager() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameSoundManager.prototype.initVolumes = function () {
    };
    GameSoundManager.prototype.initEffects = function () {
        _super.prototype.initEffects.call(this);
        // ---- HOOKED UP
        this._effects.buttonClick = this.loader.getSound('resources/sounds/btn_general.mp3');
        this._effects.spinBtnStart = this.loader.getSound('resources/sounds/btn_spin_start.mp3');
        this._effects.gameIntro = this.loader.getSound('resources/sounds/trans_game_intro.mp3');
        this._effects.reelsFallOut = this.loader.getSound('resources/sounds/reels_fall_out.mp3');
        this._effects.reelsFallIn = this.loader.getSound('resources/sounds/reels_fall_in.mp3');
        this._effects.reelsFallIn3sec = this.loader.getSound('resources/sounds/reels_fall_in_3sec.mp3');
        this._effects.reelsRemove = this.loader.getSound('resources/sounds/reels_remove.mp3');
        this._effects.winLineL = this.loader.getSound('resources/sounds/win_indicate_lr.mp3');
        this._effects.winLineR = this.loader.getSound('resources/sounds/win_indicate_rl.mp3');
        this._effects.winCountup = this.loader.getSound('resources/sounds/win_countup.mp3');
        this._effects.winNormal = this.loader.getSound('resources/sounds/win_normal.mp3');
        this._effects.winNice = this.loader.getSound('resources/sounds/win_nice.mp3');
        this._effects.winExcellent = this.loader.getSound('resources/sounds/win_excellent.mp3');
        this._effects.winRetrigger = this.loader.getSound('resources/sounds/win_retrigger.mp3');
        this._effects.bigwinBuildup = this.loader.getSound('resources/sounds/win_bigwin_buildup.mp3');
        this._effects.bigwinLoop = this.loader.getSound('resources/sounds/music/win_bigwin_loop.mp3');
        this._effects.bigwinEnd = this.loader.getSound('resources/sounds/win_bigwin_end.mp3');
        this._effects.bigwinThreshold = this.loader.getSound('resources/sounds/win_bigwin_threshold.mp3');
        this._effects.multCollectFly = this.loader.getSound('resources/sounds/mult_collect_fly.mp3');
        this._effects.multCollectHit = this.loader.getSound('resources/sounds/mult_collect_hit.mp3');
        this._effects.multUpdate = this.loader.getSound('resources/sounds/mult_update.mp3');
        this._effects.multUpdateFs = this.loader.getSound('resources/sounds/mult_update_fs.mp3');
        this._effects.multWildBreak = this.loader.getSound('resources/sounds/mult_wildbreak.mp3');
        this._effects.multWin = this.loader.getSound('resources/sounds/mult_win.mp3');
        this._effects.respinAttention = this.loader.getSound('resources/sounds/atn_respin.mp3');
        this._effects.respinActivate = this.loader.getSound('resources/sounds/rsp_activate.mp3');
        this._effects.respinMove = this.loader.getSound('resources/sounds/rsp_move.mp3');
        this._effects.respinHit1 = this.loader.getSound('resources/sounds/rsp_hit01.mp3');
        this._effects.respinHit2 = this.loader.getSound('resources/sounds/rsp_hit02.mp3');
        this._effects.respinHit3 = this.loader.getSound('resources/sounds/rsp_hit03.mp3');
        this._effects.respinEnd = this.loader.getSound('resources/sounds/rsp_end.mp3');
        this._effects.scatterAttention1 = this.loader.getSound('resources/sounds/atn_scatter_1.mp3');
        this._effects.scatterAttention2 = this.loader.getSound('resources/sounds/atn_scatter_2.mp3');
        this._effects.scatterAttention3 = this.loader.getSound('resources/sounds/atn_scatter_3.mp3');
        this._effects.freeSpinsIntro = this.loader.getSound('resources/sounds/trans_fs_intro.mp3');
        this._effects.freeSpinsOutro = this.loader.getSound('resources/sounds/trans_fs_outro.mp3');
        // ----
        // TODO: Remove if quickstop isn't used.
        this._effects.spinBtnQuickStop = this.loader.getSound('resources/sounds/btn_spin_stop.mp3');
        // TODO: Implement when correct respin attention logic is in place.
        // TODO: Implement when correct behavior is in place
        this._effects.multCollectIndicator = this.loader.getSound('resources/sounds/mult_collect_indicator.mp3');
    };
    GameSoundManager.prototype.initMusic = function () {
        _super.prototype.initMusic.call(this);
        this._music.mainMusic1 = this.loader.getSound('resources/sounds/music/music_main_1.mp3');
        this._music.mainMusic2 = this.loader.getSound('resources/sounds/music/music_main_2.mp3');
        this._music.mainMusic3 = this.loader.getSound('resources/sounds/music/music_main_3.mp3');
        this._music.freeSpinsMusic = this.loader.getSound('resources/sounds/music/music_fs.mp3');
    };
    GameSoundManager.prototype.initVoice = function () {
        _super.prototype.initVoice.call(this);
    };
    return GameSoundManager;
}(SoundManager_1.SoundManager));
exports.GameSoundManager = GameSoundManager;


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BetlevelMenuModule_1 = __webpack_require__(623);
var RecodeEvents_1 = __webpack_require__(79);
var RecodeBetlevelMenuModule = /** @class */ (function (_super) {
    __extends(RecodeBetlevelMenuModule, _super);
    function RecodeBetlevelMenuModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RecodeBetlevelMenuModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(RecodeEvents_1.RecodeEvents.VALIDATED_BET_COIN_SIZE_CHANGED, this.onValidatedBetCoinSizeUpdated);
        this.on(RecodeEvents_1.RecodeEvents.VALIDATED_BET, this.onValidatedBet);
    };
    RecodeBetlevelMenuModule.prototype.onValidatedBetCoinSizeUpdated = function () {
        this.view.betValue = this.logic.betValue;
        this.view.restoreToLastBet(this.view.betValue);
        this.view.lastBet = this.view.betValue;
        this.updateBet();
    };
    RecodeBetlevelMenuModule.prototype.onValidatedBet = function () {
    };
    return RecodeBetlevelMenuModule;
}(BetlevelMenuModule_1.BetlevelMenuModule));
exports.RecodeBetlevelMenuModule = RecodeBetlevelMenuModule;


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Module_1 = __webpack_require__(2);
var BetButtonEvents_1 = __webpack_require__(320);
var BetlevelMenuViewEvents_1 = __webpack_require__(250);
var BetlevelMenuEvents_1 = __webpack_require__(48);
var LogicEvents_1 = __webpack_require__(11);
var BetlevelMenuBasicState_1 = __webpack_require__(624);
var BetlevelMenuOpenState_1 = __webpack_require__(625);
var Views_1 = __webpack_require__(8);
var ReelsEvents_1 = __webpack_require__(4);
var AutoplayMenuEvents_1 = __webpack_require__(33);
var BetlevelMenuModule = /** @class */ (function (_super) {
    __extends(BetlevelMenuModule, _super);
    function BetlevelMenuModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BetlevelMenuModule.prototype.setupStates = function () {
        this.addState(new BetlevelMenuBasicState_1.BetlevelMenuBasicState(this, BetlevelMenuModule.BASIC));
        this.addState(new BetlevelMenuOpenState_1.BetlevelMenuOpenState(this, BetlevelMenuModule.OPEN));
    };
    BetlevelMenuModule.prototype.enterFirstState = function () {
        this.changeStateTo(BetlevelMenuModule.BASIC);
    };
    BetlevelMenuModule.prototype.setupViews = function () {
        if (this.system.shouldUseMultipleViews()) {
            this.setView(Views_1.Views.BET_LEVEL_MENU_VIEW_MOBILE);
        }
        else {
            this.setView(Views_1.Views.BET_LEVEL_MENU_VIEW);
        }
    };
    BetlevelMenuModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(AutoplayMenuEvents_1.AutoplayMenuEvents.TRIGGER_BET_MENU, this.onAutplayTriggerBetMenu);
        this.on(BetButtonEvents_1.BetButtonEvents.BET_BUTTON_CLICKED, this.onBetButtonClicked);
        this.on(LogicEvents_1.LogicEvents.INIT_RESPONSE, this.onInitResponse);
        this.on(ReelsEvents_1.ReelsEvents.REELS_SPINNING_STARTED, this.onSpinStarted);
        this.onView(BetlevelMenuViewEvents_1.BetlevelMenuViewEvents.ACCEPTED, this.onAccepted);
        this.onView(BetlevelMenuViewEvents_1.BetlevelMenuViewEvents.CANCELLED, this.onCancelled);
        this.onViewEmitEvent(BetlevelMenuViewEvents_1.BetlevelMenuViewEvents.BET_LEVEL_MENU_CLOSED, BetlevelMenuEvents_1.BetlevelMenuEvents.BET_LEVEL_MENU_CLOSED);
        this.onViewEmitEvent(BetlevelMenuViewEvents_1.BetlevelMenuViewEvents.BET_LEVEL_MENU_OPENED, BetlevelMenuEvents_1.BetlevelMenuEvents.BET_LEVEL_MENU_OPENED);
    };
    BetlevelMenuModule.prototype.onSpinStarted = function () {
        if (this.view.isVisible()) {
            this.view.hide();
        }
    };
    BetlevelMenuModule.prototype.onAccepted = function () {
        this.logic.killRestore();
        this.updateBet();
        this.eventManager.emit(BetlevelMenuEvents_1.BetlevelMenuEvents.BET_LEVEL_MENU_SELECTED_BET_ACCEPTED);
        this.gotoState(BetlevelMenuModule.BASIC);
    };
    BetlevelMenuModule.prototype.onCancelled = function () {
        this.resetButton();
        this.eventManager.emit(BetlevelMenuEvents_1.BetlevelMenuEvents.BET_LEVEL_MENU_CANCELLED);
        this.gotoState(BetlevelMenuModule.BASIC);
    };
    BetlevelMenuModule.prototype.resetButton = function () {
        this.view.restoreToLastBet(this.view.lastBet);
    };
    BetlevelMenuModule.prototype.updateBet = function () {
        this.logic.betValue = this.view.betValue ? this.view.betValue : 1;
        if (this.logic.betValue !== this.view.betValue) {
            // Added if there is a validation in logic which doesn't allow that value to be set.
            this.view.betValue = this.logic.betValue;
            this.view.restoreToLastBet(this.view.betValue);
        }
        this.saveData();
        this.eventManager.emit(BetlevelMenuEvents_1.BetlevelMenuEvents.BET_VALUE_UPDATED);
    };
    BetlevelMenuModule.prototype.saveData = function () {
        if (this.canSaveData) {
            this.logic.saveData();
        }
    };
    Object.defineProperty(BetlevelMenuModule.prototype, "canSaveData", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    BetlevelMenuModule.prototype.onAutplayTriggerBetMenu = function () {
        this.openMenu();
    };
    BetlevelMenuModule.prototype.onBetButtonClicked = function () {
        this.openMenu();
    };
    BetlevelMenuModule.prototype.openMenu = function () {
        this.gotoState(BetlevelMenuModule.OPEN);
    };
    BetlevelMenuModule.prototype.onInitResponse = function () {
        // TODO: Verify Bet value against init data.
        this.view.buttonValues = this.logic.betValues;
        this.view.defaultBet = this.logic.defaultBetValue;
        if (this.logic.lastBet) {
            this.view.lastBet = this.logic.lastBet;
            this.view.betValue = this.logic.betValue;
        }
        else {
            this.view.lastBet = this.logic.defaultBetValue;
            this.view.betValue = this.logic.defaultBetValue;
        }
        this.updateBet();
    };
    BetlevelMenuModule.BASIC = 'BASIC';
    BetlevelMenuModule.OPEN = 'OPEN';
    return BetlevelMenuModule;
}(Module_1.Module));
exports.BetlevelMenuModule = BetlevelMenuModule;


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var BetlevelMenuBasicState = /** @class */ (function (_super) {
    __extends(BetlevelMenuBasicState, _super);
    function BetlevelMenuBasicState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BetlevelMenuBasicState.prototype.onEnterState = function () {
        this.view.hide();
    };
    BetlevelMenuBasicState.prototype.onLeaveState = function () {
        //
    };
    BetlevelMenuBasicState.prototype.setupEvents = function () {
        //
    };
    return BetlevelMenuBasicState;
}(ModuleState_1.ModuleState));
exports.BetlevelMenuBasicState = BetlevelMenuBasicState;


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var BetlevelMenuOpenState = /** @class */ (function (_super) {
    __extends(BetlevelMenuOpenState, _super);
    function BetlevelMenuOpenState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BetlevelMenuOpenState.prototype.onEnterState = function () {
        this.view.currentBalance = this.module.logic.currentBalance;
        this.setupBetButtonStates();
    };
    BetlevelMenuOpenState.prototype.setupBetButtonStates = function () {
        this.view.setupButtonStates();
        this.showView();
    };
    BetlevelMenuOpenState.prototype.showView = function () {
        this.view.show();
    };
    BetlevelMenuOpenState.prototype.onLeaveState = function () {
        //
    };
    BetlevelMenuOpenState.prototype.setupEvents = function () {
        //
    };
    return BetlevelMenuOpenState;
}(ModuleState_1.ModuleState));
exports.BetlevelMenuOpenState = BetlevelMenuOpenState;


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var AutoplayMenuModule_1 = __webpack_require__(627);
var FreeRoundsScreenEvents_1 = __webpack_require__(46);
var RecodeAutoplayMenuModule = /** @class */ (function (_super) {
    __extends(RecodeAutoplayMenuModule, _super);
    function RecodeAutoplayMenuModule() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._hideUnrequiredAutoplaySettings = true;
        return _this;
    }
    RecodeAutoplayMenuModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_GAMES_FINISHED, this.onFreeGamesFinished);
        this.on(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_GAMES_POSTPONED, this.onFreeGamesPostponed);
        this.on(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_GAMES_REJECTED, this.onFreeGamesRejected);
        this.on(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_GAME_EXPIRED, this.onFreeGamesExpired);
    };
    RecodeAutoplayMenuModule.prototype.onFreeGamesFinished = function () {
        this.setupVisibleSettings();
    };
    RecodeAutoplayMenuModule.prototype.onFreeGamesPostponed = function () {
        this.setupVisibleSettings();
    };
    RecodeAutoplayMenuModule.prototype.onFreeGamesRejected = function () {
        this.setupVisibleSettings();
    };
    RecodeAutoplayMenuModule.prototype.onFreeGamesExpired = function () {
        this.setupVisibleSettings();
    };
    RecodeAutoplayMenuModule.prototype.setupVisibleSettings = function (autoplayData) {
        if (autoplayData === void 0) { autoplayData = this.logic.autoplayData; }
        this.view.setupOptionsVisibility(autoplayData);
        // if (this._hideUnrequiredAutoplaySettings) {
        // 	this.view.hideAutoplaySettings(this._logic.autoplayData);
        // }
    };
    RecodeAutoplayMenuModule.prototype.onInitResponse = function () {
        _super.prototype.onInitResponse.call(this);
        if (this._hideUnrequiredAutoplaySettings) {
            this.view.hideAutoplaySettings(this._logic.autoplayData);
        }
    };
    RecodeAutoplayMenuModule.prototype.isSingleWinLimitAvailable = function () {
        return this._logic.autoplayData.winLimitEnabled;
    };
    RecodeAutoplayMenuModule.prototype.isWinLimitAvailable = function () {
        return this._logic.autoplayData.winLimitEnabled;
    };
    RecodeAutoplayMenuModule.prototype.isLossLimitAvailable = function () {
        return this._logic.autoplayData.lossLimitEnabled;
    };
    RecodeAutoplayMenuModule.prototype.isInFreeRounds = function () {
        return this.logic.isInFreeRounds;
    };
    RecodeAutoplayMenuModule.prototype.onAutoPlayButtonClicked = function () {
        // if (!this.isInFreeRounds() && this.regulatedMarket === 'uk') {
        // 	this.triggerBetLevelMenuAndWaitForUpdate();
        // } else {
        if (this.isInFreeRounds()) {
            this.setupVisibleSettings(this.freeRoundsAutoplayOptions);
        }
        this.showMenu();
        // }
    };
    RecodeAutoplayMenuModule.prototype.validateRequirements = function () {
        if (this.isInFreeRounds()) {
            this.enableAcceptLimitsOK();
        }
        else {
            _super.prototype.validateRequirements.call(this);
        }
    };
    RecodeAutoplayMenuModule.prototype.setupRegulatedMarket = function () {
        // if (this.getAutoplayExtraData().useWagerLimitApi && this.getAutoplayExtraData().hasCustom) {
        if (this.getAutoplayExtraData().useWagerLimitApi && this.getAutoplayExtraData().alwaysDisplayCustomScreen) {
            this._regulatedMarket = 'uk';
            !true && console.log('UK/DotCom Market');
        }
    };
    RecodeAutoplayMenuModule.prototype.getAutoplayExtraData = function () {
        return this.logic.recodeAutoplayExtraData;
    };
    Object.defineProperty(RecodeAutoplayMenuModule.prototype, "freeRoundsAutoplayOptions", {
        get: function () {
            return {
                enabled: this.logic.autoplayData.enabled,
                spinCount: this.logic.autoplayData.spinCount,
                spinDefault: this.logic.autoplayData.spinDefault,
                untilStop: false,
                maxSpinsUntilStop: NaN,
                winLimitEnabled: false,
                winLimitsAmounts: [],
                winLimitDefault: NaN,
                lossLimitEnabled: false,
                lossLimitDefault: NaN,
                lossLimitsAmounts: [],
            };
        },
        enumerable: true,
        configurable: true
    });
    return RecodeAutoplayMenuModule;
}(AutoplayMenuModule_1.AutoplayMenuModule));
exports.RecodeAutoplayMenuModule = RecodeAutoplayMenuModule;


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var AutoplayHandlerModule_1 = __webpack_require__(81);
var Views_1 = __webpack_require__(8);
var Module_1 = __webpack_require__(2);
var AutoPlayButtonEvents_1 = __webpack_require__(322);
var AutoplayMenuViewEvents_1 = __webpack_require__(249);
var LogicEvents_1 = __webpack_require__(11);
var AutoplayMenuView_1 = __webpack_require__(248);
var AutoplayMenuBasicState_1 = __webpack_require__(632);
var AutoplayMenuOpenState_1 = __webpack_require__(633);
var AutoplayMenuEvents_1 = __webpack_require__(33);
var ReelsEvents_1 = __webpack_require__(4);
var QueueEventsHandler_1 = __webpack_require__(115);
var AutoplayMenuModule = /** @class */ (function (_super) {
    __extends(AutoplayMenuModule, _super);
    function AutoplayMenuModule() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._requiredSettings = AutoplayHandlerModule_1.UnregulatedMarketAutoplaySettings;
        return _this;
    }
    AutoplayMenuModule.prototype.init = function () {
        _super.prototype.init.call(this);
        this._queueEvents = new QueueEventsHandler_1.QueueEventsHandler(this.eventManager);
        this.setupRegulatedMarket();
        this.setupMarketSettings();
    };
    AutoplayMenuModule.prototype.setupRegulatedMarket = function () {
        this._regulatedMarket = 'none';
    };
    AutoplayMenuModule.prototype.isSingleWinLimitAvailable = function () {
        return true;
    };
    AutoplayMenuModule.prototype.isWinLimitAvailable = function () {
        return true;
    };
    AutoplayMenuModule.prototype.isLossLimitAvailable = function () {
        return true;
    };
    AutoplayMenuModule.prototype.setupMarketSettings = function () {
        switch (this._regulatedMarket) {
            case 'uk':
                this._requiredSettings = AutoplayHandlerModule_1.UKRegulatedMarketAutoplaySettings;
                break;
            case 'sv':
                break;
            case 'it':
                break;
            case 'de':
                break;
            case 'da':
                break;
            default:
                break;
        }
    };
    AutoplayMenuModule.prototype.setupStates = function () {
        this.addState(new AutoplayMenuBasicState_1.AutoplayMenuBasicState(this, AutoplayMenuModule.BASIC));
        this.addState(new AutoplayMenuOpenState_1.AutoplayMenuOpenState(this, AutoplayMenuModule.OPEN));
    };
    AutoplayMenuModule.prototype.enterFirstState = function () {
        this.changeStateTo(AutoplayMenuModule.BASIC);
    };
    AutoplayMenuModule.prototype.setupViews = function () {
        if (this.system.shouldUseMultipleViews()) {
            this.setView(Views_1.Views.AUTOPLAY_MENU_VIEW_MOBILE);
        }
        else {
            this.setView(Views_1.Views.AUTOPLAY_MENU_VIEW);
        }
    };
    AutoplayMenuModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(AutoPlayButtonEvents_1.AutoPlayButtonEvents.AUTO_PLAYBUTTON_CLICKED, this.onAutoPlayButtonClicked);
        this.on(LogicEvents_1.LogicEvents.INIT_RESPONSE, this.onInitResponse);
        this.on(ReelsEvents_1.ReelsEvents.REELS_SPINNING_STARTED, this.onSpinStarted);
        this.onView(AutoplayMenuViewEvents_1.AutoplayMenuViewEvents.ACCEPTED, this.onAccepted);
        this.onView(AutoplayMenuViewEvents_1.AutoplayMenuViewEvents.CANCELLED, this.onCancelled);
        this.onView(AutoplayMenuView_1.AutoplayMenuView.WIN_LIMIT_CHANGED, this.onWinLimitChanged);
        this.onView(AutoplayMenuView_1.AutoplayMenuView.SINGLE_WIN_LIMIT_CHANGED, this.onSingleWinLimitChanged);
        this.onView(AutoplayMenuView_1.AutoplayMenuView.LOSS_LIMIT_CHANGED, this.onLimitLossChanged);
        this.onView(AutoplayMenuView_1.AutoplayMenuView.SPINS_AMOUNT_CHANGED, this.onSpinsChanged);
        this.onViewEmitEvent(AutoplayMenuViewEvents_1.AutoplayMenuViewEvents.AUTO_PLAY_MENU_CLOSED, AutoplayMenuEvents_1.AutoplayMenuEvents.AUTO_PLAY_MENU_CLOSED);
        this.onViewEmitEvent(AutoplayMenuViewEvents_1.AutoplayMenuViewEvents.AUTO_PLAY_MENU_OPENED, AutoplayMenuEvents_1.AutoplayMenuEvents.AUTO_PLAY_MENU_OPENED);
        this.onViewEmitEvent(AutoplayMenuViewEvents_1.AutoplayMenuViewEvents.UPDATE_AUTOPLAY_VALUES, AutoplayMenuEvents_1.AutoplayMenuEvents.UPDATE_AUTOPLAY_VALUES);
    };
    AutoplayMenuModule.prototype.onWinLimitChanged = function (eventID, newLimit) {
        this.winLimit = newLimit;
        this.validateRequirements();
    };
    AutoplayMenuModule.prototype.onSingleWinLimitChanged = function (eventID, newLimit) {
        this.singleWinLimit = newLimit;
        this.validateRequirements();
    };
    AutoplayMenuModule.prototype.onLimitLossChanged = function (eventID, newLimit) {
        this.lossLimit = newLimit;
        this.validateRequirements();
    };
    AutoplayMenuModule.prototype.onSpinsChanged = function (eventID, newSpins) {
        this.selectedSpins = newSpins;
        this.validateRequirements();
    };
    AutoplayMenuModule.prototype.validateRequirements = function () {
        var hasValidSettings = true;
        if (hasValidSettings && this.requiredSettings.lossLimitRequired) {
            hasValidSettings = hasValidSettings && this.hasValidLossLimit();
            if (!hasValidSettings) {
                this.view.disableMenuDueToLossLimitExceedsBet();
            }
        }
        if (hasValidSettings && this.isLossLimitAvailable()) {
            hasValidSettings = hasValidSettings && (this.isLossLimitDisabled() || this.hasValidLossLimit());
            if (!hasValidSettings) {
                this.view.disableMenuDueToLossLimitExceedsBet();
            }
        }
        if (hasValidSettings && this.requiredSettings.winLimitRequired) {
            hasValidSettings = hasValidSettings && this.hasValidWinLimit();
            if (!hasValidSettings) {
                this.view.disableMenuDueToWinLimitTooLow();
            }
        }
        if (hasValidSettings && this.requiredSettings.singleWinLimitRequired) {
            hasValidSettings = hasValidSettings && this.hasValidSingleWinLimit();
            if (!hasValidSettings) {
                this.view.disableMenuDueToSingleWinLimitTooLow();
            }
        }
        if (hasValidSettings && this.requiredSettings.maxSpinsRequired) {
            hasValidSettings = hasValidSettings && this.hasValidMaxSpins();
            if (!hasValidSettings) {
                this.view.disableMenuDueToSpinAmountTooHigh();
            }
        }
        if (hasValidSettings) {
            this.enableAcceptLimitsOK();
        }
    };
    AutoplayMenuModule.prototype.enableAcceptLimitsOK = function () {
        this.view.enableMenuLimitsOK();
    };
    AutoplayMenuModule.prototype.hasValidLossLimit = function () {
        return this.lossLimit >= this.logic.betValue;
    };
    AutoplayMenuModule.prototype.isLossLimitDisabled = function () {
        return this.lossLimit === 0;
    };
    AutoplayMenuModule.prototype.hasValidMaxSpins = function () {
        return this.view.autoplayAmount <= this.requiredSettings.maxSpins;
    };
    AutoplayMenuModule.prototype.hasValidSingleWinLimit = function () {
        return this.singleWinLimit > 0;
    };
    AutoplayMenuModule.prototype.hasValidWinLimit = function () {
        return this.winLimit > 0;
    };
    AutoplayMenuModule.prototype.onSpinStarted = function () {
        this.view.hide();
    };
    AutoplayMenuModule.prototype.onAccepted = function (eventID, autoplayRounds) {
        this.logic.lastAutoplayAmount = autoplayRounds;
        this.saveData();
        this.startAutoPlay(eventID, autoplayRounds);
        this.gotoState(AutoplayMenuModule.BASIC);
    };
    AutoplayMenuModule.prototype.saveData = function () {
        if (this.canSaveData) {
            this.logic.saveData();
        }
    };
    Object.defineProperty(AutoplayMenuModule.prototype, "canSaveData", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    AutoplayMenuModule.prototype.onCancelled = function () {
        this.gotoState(AutoplayMenuModule.BASIC);
        this.eventManager.emit(AutoplayMenuEvents_1.AutoplayMenuEvents.CANCELLED);
    };
    AutoplayMenuModule.prototype.onAutoPlayButtonClicked = function () {
        this.showMenu();
    };
    AutoplayMenuModule.prototype.showMenu = function () {
        this.gotoState(AutoplayMenuModule.OPEN);
        this.view.setSliderValues(this._logic.autoplayData, this.logic.betValue);
        this.view.resetSliders();
        this.validateRequirements();
    };
    AutoplayMenuModule.prototype.onInitResponse = function () {
        if (this.logic.autoplayData) {
            this.view.buttonValues = this.logic.autoplayData.spinCount;
        }
        else {
            this.view.buttonValues = this.logic.autoplayValues;
        }
        if (this.logic.lastAutoplayAmount) {
            this.view.autoplayAmount = this.logic.lastAutoplayAmount;
            this.view.lastAutoplayAmount = this.logic.lastAutoplayAmount;
        }
        else {
            this.view.autoplayAmount = this.logic.autoplayDefault;
            this.view.lastAutoplayAmount = this.logic.autoplayDefault;
        }
    };
    AutoplayMenuModule.prototype.startAutoPlay = function (eventID, autoplayRounds) {
        this.eventManager.emit(AutoplayMenuEvents_1.AutoplayMenuEvents.UPDATE_AUTOPLAY_VALUES, this.view.getCurrentAutoplayParameters());
        this.eventManager.emit(AutoplayMenuEvents_1.AutoplayMenuEvents.ACCEPTED, autoplayRounds);
    };
    Object.defineProperty(AutoplayMenuModule.prototype, "requiredSettings", {
        get: function () {
            return this._requiredSettings;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutoplayMenuModule.prototype, "regulatedMarket", {
        get: function () {
            return this._regulatedMarket;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutoplayMenuModule.prototype, "winLimit", {
        get: function () {
            return this._winLimit;
        },
        set: function (value) {
            this._winLimit = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutoplayMenuModule.prototype, "lossLimit", {
        get: function () {
            return this._lossLimit;
        },
        set: function (value) {
            this._lossLimit = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutoplayMenuModule.prototype, "singleWinLimit", {
        get: function () {
            return this._singleWinLimit;
        },
        set: function (value) {
            this._singleWinLimit = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutoplayMenuModule.prototype, "selectedSpins", {
        get: function () {
            return this._selectedSpins;
        },
        set: function (value) {
            this._selectedSpins = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AutoplayMenuModule.prototype, "freeRoundsAutoplayOptions", {
        get: function () {
            return {
                enabled: this.logic.autoplayData.enabled,
                spinCount: this.logic.autoplayData.spinCount,
                spinDefault: this.logic.autoplayData.spinDefault,
                untilStop: false,
                maxSpinsUntilStop: NaN,
                winLimitEnabled: false,
                winLimitsAmounts: [],
                winLimitDefault: NaN,
                lossLimitEnabled: false,
                lossLimitDefault: NaN,
                lossLimitsAmounts: [],
            };
        },
        enumerable: true,
        configurable: true
    });
    AutoplayMenuModule.BASIC = 'BASIC';
    AutoplayMenuModule.OPEN = 'OPEN';
    return AutoplayMenuModule;
}(Module_1.Module));
exports.AutoplayMenuModule = AutoplayMenuModule;


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var AutoplayHandlerModule_1 = __webpack_require__(81);
var StopAutoplayButtonEvents_1 = __webpack_require__(30);
var FlowModuleEvents_1 = __webpack_require__(0);
var MessagesAPI_1 = __webpack_require__(166);
var MainMenuEvents_1 = __webpack_require__(44);
var AutoplayInProgressState = /** @class */ (function (_super) {
    __extends(AutoplayInProgressState, _super);
    function AutoplayInProgressState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AutoplayInProgressState.prototype.onEnterState = function () {
    };
    AutoplayInProgressState.prototype.onLeaveState = function () {
    };
    AutoplayInProgressState.prototype.setupEvents = function () {
        this.on(StopAutoplayButtonEvents_1.StopAutoplayButtonEvents.STOP_AUTOPLAY_BUTTON_CLICKED, this.onAutoplayStopClicked);
        this.on(FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN, this.onCanSpin);
        this.on(FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN, this.onFreeSpinsWin);
        this.on(FlowModuleEvents_1.FlowModuleEvents.WON_BIG_WIN, this.onBigWin);
        this.on(FlowModuleEvents_1.FlowModuleEvents.NO_WIN, this.onNoWin);
        this.on(FlowModuleEvents_1.FlowModuleEvents.WON, this.onWin);
        this.on(MessagesAPI_1.MessagesAPI.AUTOPLAY_PAUSED, this.onAutoplayPaused);
        this.on(MessagesAPI_1.MessagesAPI.GAME_HARD_PAUSED, this.onAutoplayPaused);
        this.on(MainMenuEvents_1.MainMenuEvents.MAIN_MENU_OPEN, this.onAutoplayPaused);
    };
    AutoplayInProgressState.prototype.onAutoplayPaused = function () {
        this.module.gotoState(AutoplayHandlerModule_1.AutoplayHandlerModule.PAUSED);
    };
    AutoplayInProgressState.prototype.onAutoplayStopClicked = function () {
        this.module.stopAutoplay();
        this.module.gotoState(AutoplayHandlerModule_1.AutoplayHandlerModule.BASIC);
    };
    AutoplayInProgressState.prototype.onCanSpin = function () {
        this.module.tryToStartSpin();
    };
    AutoplayInProgressState.prototype.onFreeSpinsWin = function () {
        this.module.stopAutoplayOnReachingLimits();
    };
    AutoplayInProgressState.prototype.onBigWin = function () {
        this.module.bigWinUpdate();
    };
    AutoplayInProgressState.prototype.onNoWin = function () {
        this.module.stopAutoplayOnReachingLimits();
    };
    AutoplayInProgressState.prototype.onWin = function () {
        this.module.winUpdate();
    };
    return AutoplayInProgressState;
}(ModuleState_1.ModuleState));
exports.AutoplayInProgressState = AutoplayInProgressState;


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var Event = {
    /* Note: If not using handleRcIframe, one can just listen to oprg_GamePause and oprg_GameResume postMessages instead.
    But if handleRcIframe is used, rcinterval pause will not post oprg_GamePause */

    /* If this event is received, and once any unfinished round has completed, the game must disable controls,
    pause autoplay, and call reportPaused() once the game is idle */
    PAUSE_REQUESTED: 'rg_pause',

    /* Re-enable controls and resume autoplay if paused by rg feature */
    RESUME: 'rg_resume',

    /* The game does not need to handle these two */
    PAUSE: 'rg_pauseComplete',
    WARN: 'rg_pauseWarn',
    UPDATE_BALANCE: 'rg_updateBalance'
};
var States = {
    NOT_PAUSED: 0,
    PAUSE_PENDING: 1,
    PAUSE_REPORT_PENDING: 2,
    PAUSED: 3
};
var pausedState = States.NOT_PAUSED;
var pausePayload; // CustomEvent polyfill

(function () {
    if (typeof window.CustomEvent === "function") return false;

    function CustomEvent(event, params) {
        params = params || {
            bubbles: false,
            cancelable: false,
            detail: null
        };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;
    window.CustomEvent = CustomEvent;
})();

function requestPause(payload) {
    if (pausedState === States.PAUSED) {
        warn('Already paused');
    } else if (pausedState === States.PAUSE_PENDING) {
        warn('Pause already requested, waiting for the current round to end');
    }

    pausedState = States.PAUSE_PENDING;
    pausePayload = payload;
    var event = new CustomEvent(Event.PAUSE_REQUESTED);
    event.data = payload;
    window.dispatchEvent(event);
}

function paused(sessionStats) {
    pausedState = States.PAUSED;
    var event = new CustomEvent(Event.PAUSE);

    if (sessionStats) {
        if (pausePayload) {
            pausePayload.sessionresult = sessionStats;
        } else {
            pausePayload = {
                sessionresult: sessionStats
            };
        }
    }

    event.data = pausePayload;
    window.dispatchEvent(event);
    pausePayload = null;
}

function resume(payload) {
    if (pausedState === States.NOT_PAUSED) {
        warn('Requesting resume, but the game is not paused');
    }

    pausedState = States.NOT_PAUSED;
    var event = new CustomEvent(Event.RESUME);
    event.data = payload;
    window.dispatchEvent(event);
}

function warn(message) {
    var event = new CustomEvent(Event.WARN);
    event.message = message;
    window.dispatchEvent(event);
}

function updateBalance() {
    var event = new CustomEvent(Event.UPDATE_BALANCE);
    window.dispatchEvent(event);
}

var Events = {
    Event: Event,
    requestPause: requestPause,
    paused: paused,
    resume: resume,
    updateBalance: updateBalance
};

function getEventDataPayload(data) {
    if (!data || !data.payload) {
        return null;
    }

    if (typeof data.payload === 'string') {
        return JSON.parse(data.payload);
    }

    return data.payload;
}

function UrlParams(url) {
    var _this = this;

    this.vars = {};
    this.length = 0;
    decodeURIComponent(url).replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
        _this.vars[key] = value;
        _this.length++;
    });
}

UrlParams.prototype = {
    isEmpty: function isEmpty() {
        return this.length === 0;
    },
    get: function get(key) {
        if (this.vars[key]) {
            return this.vars[key];
        }

        return null;
    },
    has: function has(key) {
        if (this.vars[key]) {
            return true;
        }

        return false;
    },
    append: function append(key, value) {
        if (this.vars[key] === undefined) {
            this.length++;
        }

        this.vars[key] = value;
    }
};
var Tools = {
    getEventDataPayload: getEventDataPayload,
    UrlParams: UrlParams
};

function RcDomElement(urlParams) {
    if (!urlParams.has('rciframeurl')) {
        return {
            error: 'Error creating RC:rciframeurl is not defined'
        };
    }

    var urlString = urlParams.get('rciframeurl');

    if (!urlString || urlString === '') {
        return {
            error: "RC iFrame URL defined but invalid: ".concat(urlString, "}")
        };
    } // IE doesn't support URL/URLSearchParams


    var params = new Tools.UrlParams(urlString);

    if (params.isEmpty()) {
        urlString += '?';
    } else {
        urlString += '&';
    }

    urlString += "rchistoryurl=".concat(urlParams.get('rchistoryurl'), "&homeurl=").concat(urlParams.get('homeurl'));
    var iframeId = 'rg_rc_iframe';
    var element = document.getElementById(iframeId);

    if (!element) {
        element = document.createElement('iframe');
        element.src = urlString;
        element.id = iframeId;
        element.style.display = 'none';
        element.style.position = 'fixed';
        element.style.left = 0;
        element.style.top = 0;
        element.style.width = '100%';
        element.style.height = '100%';
        element.style.zIndex = 1001;
        element.frameBorder = 0;
        var wrapper = document.getElementById('rc_iframe_wrapper');

        if (wrapper) {
            wrapper.appendChild(element);
        } else {
            document.body.appendChild(element);
        }
    }

    return element;
}

function ClientInterval(urlParams) {
    if (!urlParams.has('rcinterval')) {
        // rcenable is true, but rcinterval is not defined - RC must be triggered by the operator');
        return false;
    }

    var rcinterval = Number(urlParams.get('rcinterval'));

    if (isNaN(rcinterval)) {
        return {
            error: "Error creating RC interval: Invalid rcinterval parameter ".concat(rcinterval)
        };
    }

    if (rcinterval <= 0) {
        // RC parameters are defined, but RC is disabled because rcinterval is 0
        return false;
    }

    var startTimeMs = Date.now();
    var initialRcElapsed = Number(urlParams.get('rcelapsed')) || 0;
    var nextRcTriggerSeconds = !initialRcElapsed ? rcinterval : rcinterval - initialRcElapsed % rcinterval;
    setTimeout(triggerRealityCheckTime, nextRcTriggerSeconds * 1000);

    function triggerRealityCheckTime() {
        var totalElapsed = initialRcElapsed + Math.round((Date.now() - startTimeMs) / 1000);
        Events.requestPause({
            realityCheck: true,
            sessionTime: totalElapsed
        });
        setTimeout(triggerRealityCheckTime, rcinterval * 1000);
    }

    return true;
}

var rciframe;
/*
 * The reality check will work in standalone mode, without operator utilizing the PostMessage API.
 * Enabled if the game gives rciframeurl as an init parameter and &rcenable is false.
 */

var standAloneMode = false;
var errors = []; // Legacy API methods relayed to the rc iframe

var OPERATOR_METHODS = ['gameLoaded', 'gameLoadedHandler', 'gamePausedHandler', 'playTimeHandler', 'handshakeSuccess', 'handshakeCompleted', 'handshakeFail', 'handshakeFailed'];

function init(params) {
    var urlParams = new Tools.UrlParams(document.location.href);

    function log(text, color) {
        if (urlParams.get('showrgdebuglog')) {
            // eslint-disable-next-line no-console
            console.log("%c".concat(text), color);
        }
    } // Default rciframeurl


    if (urlParams.get('rcenable') !== 'true') {
        if (params && params.rciframeurl && urlParams.get('rcinterval')) {
            /**
             * rcenable is false but a default rciframeurl and interval found:
             * operator post API is not enabled, but the game uses this lib for
             * reality check popup
             */
            log('RgAPI handles RC (standalone mode)', 'background: #222; color: #bada55');
            standAloneMode = true;
            urlParams.append('rciframeurl', params.rciframeurl);
        } else {
            /*
            * rcenable is false and no default rciframeurl and interval:
            * the game ifself must handle the reality check popup
            */
            log('Game handles reality check', 'background: #ff00f0; color: #ffffff');
            return;
        }
    } else {
        log('RgAPI handles RC (operator mode)', 'background: #222; color: #bada55');
    }

    rciframe = RcDomElement(urlParams);

    if (rciframe.error) {
        addError(rciframe.error);
        return;
    }

    var interval = ClientInterval(urlParams);

    if (interval.error) {
        addError(interval.error);
    }

    window.addEventListener(Events.Event.PAUSE, function (event) {
        var data = event.data;

        if (data && data.realityCheck) {
            open(data);
        }
    });
    window.addEventListener(Events.Event.RESUME, function (event) {
        var data = event.data;

        if (data && data.realityCheck) {
            close();
        }
    });
}

function addError(errorMessage) {
    errors.push(errorMessage);
}

function close() {
    if (!rciframe) {
        return;
    }

    rciframe.style.display = 'none';
}

function open(data) {
    if (!rciframe) {
        return;
    }

    if (standAloneMode && data && rciframe.contentWindow) {
        // Send reality check data when PostAPI is not enabled
        rciframe.contentWindow.postMessage({
            rgMessage: 'gprg_RealityCheckData',
            payload: data
        }, '*');
    }

    rciframe.style.display = 'block';
}

function handlePostMessage(data) {
    if (isForOperator(data) === false) {
        return;
    }

    if (rciframe && rciframe.contentWindow) {
        rciframe.contentWindow.postMessage(data, '*');
    }
}

function isForOperator(data) {
    if (!data) {
        return false;
    }

    if (data.rgMessage && data.rgMessage.indexOf('gprg_') === 0) {
        return true;
    }

    if (data.method && OPERATOR_METHODS.indexOf(data.method) >= 0) {
        return true;
    }

    return false;
}

var ExternalRealityCheck = {
    init: init,
    handlePostMessage: handlePostMessage,
    getErrors: function getErrors() {
        return errors;
    }
};
var isGameLoaded = false;
var sessionConstants = null;
var isEnabled = false;
var isListeningPauseEvents = false;

function init$1(params) {
    var urlParams = new Tools.UrlParams(document.location.href);

    if (urlParams.get('rcenable') !== 'true') {
        return;
    }

    isEnabled = true;

    if (params) {
        sessionConstants = params.sessionData;
    }
}

function addListeners() {
    if (isListeningPauseEvents) {
        return;
    }

    isListeningPauseEvents = true;
    window.addEventListener(Events.Event.PAUSE_REQUESTED, function (event) {
        var data = event.data;

        if (data && data.sessionTime) {
            post('playTimeHandler', {
                delay: data.sessionTime
            });
        }
    });
    window.addEventListener(Events.Event.PAUSE, function (event) {
        var data = event.data;

        if (!data.returnData) {
            // Pause triggered by clientInterval
            post('gamePausedHandler');
            return;
        } // Requested callback with any return data


        post(data.returnData.method, data.returnData.params);
    });
}

var callbacks = {
    operatorLoaded: function operatorLoaded() {
        // Report gameLoaded if the operator wasn't ready before
        if (isGameLoaded) {
            reportGameReady();
        }
    },
    confirmHandshake: function confirmHandshake(params) {
        addListeners();
        post(params.success);
    },
    pauseGame: function pauseGame(params) {
        var payload = {
            realityCheck: true
        };

        if (params.callback) {
            payload.returnData = {
                method: params.callback,
                params: buildPauseReturnData(params)
            };
        }

        Events.requestPause(payload);
    },
    resumeGame: function resumeGame() {
        Events.resume({
            realityCheck: true
        });
    },
    navigateTo: function navigateTo(params) {
        if (params && params.url) {
            window.location.href = params.url;
        }
    }
};

function post(method, params) {
    if (!isEnabled) {
        return;
    }

    var message = {
        method: method,
        params: params
    };
    window.parent.postMessage(message, '*');
    ExternalRealityCheck.handlePostMessage(message);
}

function buildPauseReturnData(params) {
    if (!sessionConstants) {
        return {};
    }

    var dataToReturn = {};

    if (params.return_data) {
        params.return_data.forEach(function (element) {
            dataToReturn[element] = sessionConstants[element];
        });
    }

    return JSON.stringify(dataToReturn);
}

function handlePostMessage$1(data) {
    if (!isEnabled) {
        return;
    }

    if (!data || !data.method) {
        return;
    }

    var fn = callbacks[data.method];
    var parameters;

    if (data.params) {
        parameters = data.params;
    }

    if (typeof fn === 'function') {
        fn(parameters);
    }
}

function reportGameReady() {
    isGameLoaded = true;
    post('gameLoadedHandler');
}

var LegacyAPI = {
    init: init$1,
    reportGameReady: reportGameReady,
    handlePostMessage: handlePostMessage$1,
    disable: function disable() {
        isEnabled = false;
    }
};
var version = "1.3.0";
var TARGET_ORIGIN = '*';
var isEnabled$1 = false;
var isListeningPauseEvents$1 = false;

function handlePostMessage$2(data) {
    if (!isEnabled$1) {
        return;
    }

    if (!data) {
        return;
    }

    if (!data.rgMessage) {
        return;
    }

    if (data.rgMessage.indexOf('oprg_') === -1) {
        return;
    }

    var payload = Tools.getEventDataPayload(data);

    switch (data.rgMessage) {
        case 'oprg_Ready':
            addPauseEventListeners();
            LegacyAPI.disable(); // Reporting that we are ready to receive messages...

            post$1('gprg_Ready');
            break;

        case 'oprg_GamePause':
            Events.requestPause(payload); // gprg_GamePaused will be sent once the round is finished

            break;

        case 'oprg_GameResume':
            Events.resume(payload);
            break;

        case 'oprg_NavigateGame':
            if (payload && payload.url) {
                window.location.href = payload.url;
            } else {
                warn$1('Missing payload.url');
            }

            break;

        case 'oprg_DebugSettings':
            post$1('gprg_DebugSettings', {
                id: "RgPostMessageAPI v".concat(version)
            });
            break;

        case 'oprg_DebugErrors':
            // Only reality check can have reportable errors atm.
            post$1('gprg_DebugErrors', ExternalRealityCheck.getErrors(), '*');
            break;

        case 'oprg_Ping':
            if (payload && payload.id) {
                post$1('gprg_Pong', {
                    id: payload.id
                });
            } else {
                post$1('gprg_Pong');
            }

            break;

        case 'oprg_UpdateBalance':
            Events.updateBalance();
            break;

        default:
            warn$1("Unknown rgMessage ".concat(data.rgMessage));
    }
}

function addPauseEventListeners() {
    if (isListeningPauseEvents$1) {
        return;
    }

    isListeningPauseEvents$1 = true;
    window.addEventListener(Events.Event.PAUSE_REQUESTED, function (event) {
        var data = event.data;

        if (data && data.sessionTime) {
            post$1('gprg_RealityCheckData', {
                sessionTime: data.sessionTime
            });
        }
    });
    window.addEventListener(Events.Event.PAUSE, function (event) {
        var data = event.data;
        post$1('gprg_GamePaused', data);
    });
    window.addEventListener(Events.Event.RESUME, function (event) {
        var data = event.data;
        post$1('gprg_GameResumed', data);
    });
    window.addEventListener(Events.Event.WARN, function (event) {
        var message = event.message;

        if (message) {
            warn$1(message);
        }
    });
}
/**
 * @param {string} rgMessage - message identifier
 * @param {Object} payload - message payload as an Object
 */


function post$1(rgMessage, payload) {
    if (!isEnabled$1) {
        return;
    }

    if (!rgMessage) {
        return;
    }

    var message = {
        rgMessage: rgMessage,
        payload: payload
    };
    window.parent.postMessage(message, TARGET_ORIGIN);
    ExternalRealityCheck.handlePostMessage(message);
}

function warn$1(warningMessage) {
    post$1('gprg_Warning', {
        message: warningMessage
    });
}

var PostAPI = {
    init: function init() {
        isEnabled$1 = true;
        post$1('gprg_Listening');
    },
    reportGameReady: function reportGameReady() {
        post$1('gprg_GameReady');
    },
    userAction: function userAction(action) {
        post$1('gprg_UserAction', {
            action: action
        });
    },
    gameRoundStarted: function gameRoundStarted() {
        post$1('gprg_GameRoundStart');
    },
    gameRoundEnded: function gameRoundEnded() {
        post$1('gprg_GameRoundEnd');
    },
    handlePostMessage: handlePostMessage$2
};

function CreatePauseModal() {
    var element = document.getElementById('rg_pause_modal');

    if (!element) {
        element = document.createElement('div');
        element.id = 'rg_pause_modal';
        element.style.position = 'fixed';
        element.style.left = 0;
        element.style.top = 0;
        element.style.width = '100%';
        element.style.height = '100%';
        element.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
        element.style.display = 'none';
        element.style.zIndex = 1000;

        var _rciframe = document.getElementById('rg_rc_iframe');

        if (_rciframe) {
            _rciframe.parent.insertBefore(element, _rciframe);
        } else {
            var wrapper = document.getElementById('rc_iframe_wrapper');

            if (wrapper) {
                wrapper.appendChild(element);
            } else {
                document.body.appendChild(element);
            }
        }
    }

    window.addEventListener(Events.Event.PAUSE, function (event) {
        var data = event.data;

        if (data && data.autoPlayOnly) {
            return;
        }

        element.style.display = 'block';
    });
    window.addEventListener(Events.Event.RESUME, function (event) {
        var data = event.data;

        if (data && data.autoPlayOnly) {
            return;
        }

        element.style.display = 'none';
    });
}
/**
 * @param {Boolean} bHandleRcIframe - If an iframe for rciframeurl is handled automatically.
 * @param {Object} sessionData - Data needed if supporting the old API {session_id:string, game_name:string, user_id:string}
 * @param {Object} params {rciframeurl: string} - Additional init data. If params.rciframeurl and &interval URL parameter are
 * set, this lib will handle showing the RC popup even if &rcenable is false
 */


function init$2(bHandleRcIframe, sessionData, params) {
    PostAPI.init();
    LegacyAPI.init(sessionData);
    CreatePauseModal();

    if (bHandleRcIframe) {
        ExternalRealityCheck.init(params);
    }

    window.addEventListener('message', onPostMessage);
}

function onPostMessage(event) {
    var data = event.data;

    if (!data) {
        return;
    }

    PostAPI.handlePostMessage(data);
    LegacyAPI.handlePostMessage(data);
    ExternalRealityCheck.handlePostMessage(data);
} // When game is loaded and ready


function reportGameReady$1() {
    PostAPI.reportGameReady();
    LegacyAPI.reportGameReady();
}
/**
 * Called by the game to report the game as paused
 * @param {*} sessionStats Session stats needed for some jurisdictions, needs to be reported by
 * the game here using this lib for RC without the operator (init params.rciframeurl is defined).
 * If given here, the data will be passed to the rc iframe with a gprg_RealityCheckData postMessage,
 * in event.data.sessionresult
 */


function reportPaused(sessionStats) {
    Events.paused(sessionStats);
}

function userAction(action) {
    var prefix = 'action:';

    if (action.indexOf(prefix) === 0) {
        // We are inside a wrapper - send postMessage navigate request instead
        var url = action.slice(prefix.length);
        PostAPI.userAction(url);
        return;
    }

    window.location = action;
}

var RgPostMessageAPI = {
    init: init$2,
    reportGameReady: reportGameReady$1,
    reportPaused: reportPaused,
    userAction: userAction,
    gameRoundStarted: PostAPI.gameRoundStarted,
    gameRoundEnded: PostAPI.gameRoundEnded,
};
exports.RgPostMessageAPI = RgPostMessageAPI;


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var AutoplayHandlerModule_1 = __webpack_require__(81);
var MessagesAPI_1 = __webpack_require__(166);
var FlowModuleEvents_1 = __webpack_require__(0);
var MainMenuEvents_1 = __webpack_require__(44);
var RelaxEvents_1 = __webpack_require__(167);
var StopAutoplayButtonEvents_1 = __webpack_require__(30);
var AutoplayPausedState = /** @class */ (function (_super) {
    __extends(AutoplayPausedState, _super);
    function AutoplayPausedState() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._waitingForSpin = false;
        return _this;
    }
    AutoplayPausedState.prototype.onEnterState = function () {
    };
    AutoplayPausedState.prototype.onLeaveState = function () {
    };
    AutoplayPausedState.prototype.setupEvents = function () {
        this.on(MessagesAPI_1.MessagesAPI.GAME_RESUMED, this.onTryToRestoreAutoplay);
        this.on(MainMenuEvents_1.MainMenuEvents.MAIN_MENU_CLOSED, this.onTryToRestoreAutoplay);
        this.on(FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN, this.onCanSpin);
        this.on(StopAutoplayButtonEvents_1.StopAutoplayButtonEvents.STOP_AUTOPLAY_BUTTON_CLICKED, this.onAutoplayStopClicked);
        this.on(RelaxEvents_1.RelaxEvents.SHOW_REALITY_CHECK, this.onShowRealityCheck);
    };
    AutoplayPausedState.prototype.onAutoplayStopClicked = function () {
        this.module.stopAutoplay();
        this.module.gotoState(AutoplayHandlerModule_1.AutoplayHandlerModule.BASIC);
    };
    AutoplayPausedState.prototype.onTryToRestoreAutoplay = function () {
        if (this._waitingForSpin && this.module.isWaitingForGameResume
            && this.module.isWaitingForMainMenuClose) {
            this._waitingForSpin = false;
            this.module.gotoState(AutoplayHandlerModule_1.AutoplayHandlerModule.IN_PROGRESS);
            this.module.tryToStartSpin();
        }
    };
    AutoplayPausedState.prototype.onShowRealityCheck = function () {
        this.module.gotoState(AutoplayHandlerModule_1.AutoplayHandlerModule.BASIC);
    };
    AutoplayPausedState.prototype.onCanSpin = function () {
        this._waitingForSpin = true;
        this.onTryToRestoreAutoplay();
    };
    return AutoplayPausedState;
}(ModuleState_1.ModuleState));
exports.AutoplayPausedState = AutoplayPausedState;


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var AutoplayFreeSpinsState = /** @class */ (function (_super) {
    __extends(AutoplayFreeSpinsState, _super);
    function AutoplayFreeSpinsState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AutoplayFreeSpinsState.prototype.onEnterState = function () { };
    AutoplayFreeSpinsState.prototype.onLeaveState = function () { };
    AutoplayFreeSpinsState.prototype.setupEvents = function () { };
    return AutoplayFreeSpinsState;
}(ModuleState_1.ModuleState));
exports.AutoplayFreeSpinsState = AutoplayFreeSpinsState;


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var AutoplayMenuEvents_1 = __webpack_require__(33);
var AutoplayMenuBasicState = /** @class */ (function (_super) {
    __extends(AutoplayMenuBasicState, _super);
    function AutoplayMenuBasicState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AutoplayMenuBasicState.prototype.onEnterState = function () {
        this.view.hide();
        this.module.eventManager.emit(AutoplayMenuEvents_1.AutoplayMenuEvents.AUTO_PLAY_MENU_CLOSED);
        //
    };
    AutoplayMenuBasicState.prototype.onLeaveState = function () {
        //
    };
    AutoplayMenuBasicState.prototype.setupEvents = function () {
        //
    };
    return AutoplayMenuBasicState;
}(ModuleState_1.ModuleState));
exports.AutoplayMenuBasicState = AutoplayMenuBasicState;


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var AutoplayMenuEvents_1 = __webpack_require__(33);
var AutoplayMenuOpenState = /** @class */ (function (_super) {
    __extends(AutoplayMenuOpenState, _super);
    function AutoplayMenuOpenState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AutoplayMenuOpenState.prototype.onEnterState = function () {
        this.view.show();
        this.module.eventManager.emit(AutoplayMenuEvents_1.AutoplayMenuEvents.AUTO_PLAY_MENU_OPENED);
        //
    };
    AutoplayMenuOpenState.prototype.onLeaveState = function () {
        //
    };
    AutoplayMenuOpenState.prototype.setupEvents = function () {
        //
    };
    return AutoplayMenuOpenState;
}(ModuleState_1.ModuleState));
exports.AutoplayMenuOpenState = AutoplayMenuOpenState;


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var InfoPopupModule_1 = __webpack_require__(635);
var RecodeGameAutoplayHandlerModuleEvents_1 = __webpack_require__(323);
var InfoPopupTypes_1 = __webpack_require__(74);
var InfoPopupEvents_1 = __webpack_require__(63);
var RecodeInfoPopupModule = /** @class */ (function (_super) {
    __extends(RecodeInfoPopupModule, _super);
    function RecodeInfoPopupModule() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._vApi = window.V.API;
        return _this;
    }
    RecodeInfoPopupModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(RecodeGameAutoplayHandlerModuleEvents_1.RecodeGameAutoplayHandlerModuleEvents.RECODE_AUTOPLAY_SHOW_POPUP, this.onAutoplayMessage);
    };
    RecodeInfoPopupModule.prototype.onNotEnoughMoneyToSpin = function () {
        if (this.api.isBankingAvailable()) {
            // this._vApi.Core.displayInsufficientFunds(); // Will be deprecated according to Game integration doc.
            this.api.api_showInsufficientFundsDialog(function () {
            }); // Error dialog active false on callback.
        }
        else {
            _super.prototype.onNotEnoughMoneyToSpin.call(this);
        }
    };
    RecodeInfoPopupModule.prototype.getReasonMessage = function (reason) {
        switch (reason) {
            case 'none':
            case 'spinCount':
                return '';
            case 'lossLimit':
                return '/n' + this.view.translator.getObject('BaseStrings', 'generic', 'g_LossLimitReached');
            case 'winlimit':
                return '/n' + this.view.translator.getObject('BaseStrings', 'generic', 'g_WinLimitreached');
            default:
                return '';
        }
    };
    RecodeInfoPopupModule.prototype.onAutoplayMessage = function (eventId, message, reason) {
        if (message.length === 0) {
            message = this.view.translator.getObject('BaseStrings', 'generic', 'g_autoplayStopped');
            message += this.getReasonMessage(reason);
        }
        this._currentMessageType = InfoPopupTypes_1.InfoPopupTypes.MESSAGE;
        this.view.showOKMessage(message);
        this.eventManager.emit(InfoPopupEvents_1.InfoPopupEvents.INFO_POPUP_OPENED, this._currentMessageType);
    };
    Object.defineProperty(RecodeInfoPopupModule.prototype, "api", {
        get: function () {
            return this.logic.communicator;
        },
        enumerable: true,
        configurable: true
    });
    return RecodeInfoPopupModule;
}(InfoPopupModule_1.InfoPopupModule));
exports.RecodeInfoPopupModule = RecodeInfoPopupModule;


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Module_1 = __webpack_require__(2);
var Views_1 = __webpack_require__(8);
var AutoplayHandlerEvents_1 = __webpack_require__(56);
var SpinButtonEvents_1 = __webpack_require__(12);
var InfoPopupEvents_1 = __webpack_require__(63);
var InfoPopupTypes_1 = __webpack_require__(74);
var InfoPopupView_1 = __webpack_require__(252);
/**
 * information popups module
 */
var InfoPopupModule = /** @class */ (function (_super) {
    __extends(InfoPopupModule, _super);
    function InfoPopupModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InfoPopupModule.prototype.restore = function () {
        _super.prototype.restore.call(this);
        if (this.logic.isFreeSpinsStarted && this.logic.freeSpinsPlayed === 0) {
            // Don't show the popup when restoring to FS screen.
            return;
        }
        this._currentMessageType = InfoPopupTypes_1.InfoPopupTypes.RESTORE;
        var restoreText = this.view.translator.getObject('BaseStrings', 'generic', 'g_autoplay_replayingInterruptedGame') || 'Replaying interrupted game';
        this.view.showOKMessage(restoreText);
        this.eventManager.emit(InfoPopupEvents_1.InfoPopupEvents.RESTORE_POPUP_OPENED);
    };
    InfoPopupModule.prototype.enterFirstState = function () { };
    InfoPopupModule.prototype.setupStates = function () { };
    InfoPopupModule.prototype.setupViews = function () {
        if (this.system.shouldUseMultipleViews()) {
            this.setView(Views_1.Views.INFO_POPUP_VIEW_MOBILE);
        }
        else {
            this.setView(Views_1.Views.INFO_POPUP_VIEW);
        }
    };
    InfoPopupModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.onView(InfoPopupView_1.InfoPopupView.OK_CLICKED, this.onOkClicked);
        this.onView(InfoPopupView_1.InfoPopupView.HOME_CLICKED, this.onHomeClicked);
        this.on(SpinButtonEvents_1.SpinButtonEvents.SPIN_PRESSED_NOT_ENOUGH_MONEY, this.onNotEnoughMoneyToSpin);
        this.on(AutoplayHandlerEvents_1.AutoplayHandlerEvents.AUTOPLAY_STOPPED_ON_SINGLE_WIN_LIMIT, this.onWinLimitReached);
        this.on(AutoplayHandlerEvents_1.AutoplayHandlerEvents.AUTOPLAY_STOPPED_ON_WIN_LIMIT, this.onWinLimitReached);
        this.on(AutoplayHandlerEvents_1.AutoplayHandlerEvents.AUTOPLAY_STOPPED_ON_LOSE_LIMIT, this.onLossLimitReached);
        if (false) {
            document.addEventListener('keydown', this.onKeyInput.bind(this));
        }
    };
    InfoPopupModule.prototype.onKeyInput = function (event) {
        if (event.code === 'KeyM') {
            this.view.showSimpleMessage('some some text');
        }
        if (event.code === 'KeyN') {
            this.view.showErrorMessage('some some text');
        }
        if (event.code === 'KeyR') {
            this.view.showRealityCheckWithExitOptionMessage('some some text\nsome some text\nsome some text\nsome some text\nsome some text\nsome some text\nsome some text\n');
        }
    };
    InfoPopupModule.prototype.onNotEnoughMoneyToSpin = function () {
        this._currentMessageType = InfoPopupTypes_1.InfoPopupTypes.NO_MONEY;
        var notEnoughText = this.view.translator.getObject('BaseStrings', 'generic', 'g_noMoney') || 'Not enough money to spin';
        this.view.showOKMessage(notEnoughText);
        this.eventManager.emit(InfoPopupEvents_1.InfoPopupEvents.INFO_POPUP_OPENED, this._currentMessageType);
    };
    InfoPopupModule.prototype.onWinLimitReached = function () {
        this._currentMessageType = InfoPopupTypes_1.InfoPopupTypes.WIN_LIMIT;
        var autoplayStoppedText = this.view.translator.getObject('BaseStrings', 'generic', 'g_autoplayStopped') || 'AutoPlay stopped';
        var winLimitReachedText = this.view.translator.getObject('BaseStrings', 'generic', 'g_WinLimitreached') || 'Win Limit reached';
        this.view.showOKMessage(autoplayStoppedText + ". " + winLimitReachedText);
        this.eventManager.emit(InfoPopupEvents_1.InfoPopupEvents.INFO_POPUP_OPENED, this._currentMessageType);
    };
    InfoPopupModule.prototype.onLossLimitReached = function () {
        this._currentMessageType = InfoPopupTypes_1.InfoPopupTypes.LOSS_LIMIT;
        var autoplayStoppedText = this.view.translator.getObject('BaseStrings', 'generic', 'g_autoplayStopped') || 'AutoPlay stopped';
        var lossLimitReachedText = this.view.translator.getObject('BaseStrings', 'generic', 'g_LossLimitReached') || 'Loss Limit reached';
        this.view.showOKMessage(autoplayStoppedText + ". " + lossLimitReachedText);
        this.eventManager.emit(InfoPopupEvents_1.InfoPopupEvents.INFO_POPUP_OPENED, this._currentMessageType);
    };
    InfoPopupModule.prototype.onOkClicked = function () {
        this.eventManager.emit(InfoPopupEvents_1.InfoPopupEvents.INFO_POPUP_CLOSED, this._currentMessageType);
    };
    InfoPopupModule.prototype.onHomeClicked = function () {
        this.eventManager.emit(InfoPopupEvents_1.InfoPopupEvents.INFO_POPUP_CLOSED, this._currentMessageType);
        this.eventManager.emit(InfoPopupEvents_1.InfoPopupEvents.INFO_POPUP_HOME_CLICKED);
    };
    return InfoPopupModule;
}(Module_1.Module));
exports.InfoPopupModule = InfoPopupModule;


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Settings_1 = __webpack_require__(109);
var RecodeEvents_1 = __webpack_require__(79);
var SettingsModule_1 = __webpack_require__(637);
var RecodeSettingsModule = /** @class */ (function (_super) {
    __extends(RecodeSettingsModule, _super);
    function RecodeSettingsModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RecodeSettingsModule.prototype.init = function () {
        _super.prototype.init.call(this);
        this.checkCertificationForFastPlay();
    };
    RecodeSettingsModule.prototype.checkCertificationForFastPlay = function () {
        if (window._certificationSettings && window._certificationSettings.hasOwnProperty('quickSpins')) {
            var quickspinAvailable = window._certificationSettings.quickSpins;
            this.settings.add(Settings_1.Settings.IS_QUICKSPIN_AVAILABLE, quickspinAvailable);
        }
    };
    RecodeSettingsModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(RecodeEvents_1.RecodeEvents.SERVER_PLUGIN_SET_MUTE, this.onServerSetMute);
        // Maybe we just shove the last user setting down the top bar throat since it doesn't seem to serve a usable value.
        // this.onServerSetMute(null, (window as any).V.API.Core.isSoundMuted());
    };
    RecodeSettingsModule.prototype.onServerSetMute = function (eventId, mute) {
        // mute = !mute; // They send the inverted value for some reason which is unexplainable.
        mute ? this.onAllSoundOff(null, true) : this.onAllSoundOn(null, true);
    };
    return RecodeSettingsModule;
}(SettingsModule_1.SettingsModule));
exports.RecodeSettingsModule = RecodeSettingsModule;


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Module_1 = __webpack_require__(2);
var Settings_1 = __webpack_require__(109);
var Views_1 = __webpack_require__(8);
var InfoEvents_1 = __webpack_require__(118);
var MainMenuEvents_1 = __webpack_require__(44);
var SettingsEvents_1 = __webpack_require__(95);
var SettingsViewEvents_1 = __webpack_require__(168);
var SettingsModule = /** @class */ (function (_super) {
    __extends(SettingsModule, _super);
    function SettingsModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SettingsModule.prototype.init = function () {
        _super.prototype.init.call(this);
        var savedData = {
            soundActive: this.logic.soundEffectsActive,
            musicActive: this.logic.musicActive,
            skipIntroActive: this.logic.skipIntro,
            spacebarActive: this.logic.spacebarSpinActive,
            dragReelToSpinActive: this.logic.dragReelToSpinActive,
            quickStopActive: this.logic.quickStopActive,
            fastPlayActive: this.logic.fastPlayActive,
        };
        var extraButtons = {
            responsibleGaming: this.logic.responsibleGaming,
        };
        this.view.setupSettingsViewComponents(savedData);
    };
    SettingsModule.prototype.setupStates = function () { };
    SettingsModule.prototype.enterFirstState = function () { };
    SettingsModule.prototype.setupViews = function () {
        if (this.system.shouldUseMultipleViews()) {
            this.setView(Views_1.Views.SETTINGS_VIEW_MOBILE);
        }
        else {
            this.setView(Views_1.Views.SETTINGS_VIEW);
        }
    };
    SettingsModule.prototype.showSettings = function () {
        this.view.showSettings();
    };
    SettingsModule.prototype.closeSettings = function () {
        this.view.hideSettings();
    };
    SettingsModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(MainMenuEvents_1.MainMenuEvents.MAIN_MENU_SETTINGS_OPEN, this.onMainMenuSettingsOpen);
        this.on(MainMenuEvents_1.MainMenuEvents.MAIN_MENU_SETTINGS_CLOSE, this.onMainMenuSettingsClosed);
        this.on(MainMenuEvents_1.MainMenuEvents.MAIN_MENU_CLOSED, this.onMainMenuClosed);
        this.on(MainMenuEvents_1.MainMenuEvents.MAIN_MENU_INFO_OPEN, this.onMainMenuInfoOpen);
        this.on(MainMenuEvents_1.MainMenuEvents.MAIN_MENU_PAYTABLE_OPEN, this.onMainMenuPaytableOpen);
        this.on(InfoEvents_1.InfoEvents.TOGGLE_ALL_SOUND_OFF, this.onInfoAllSoundOff);
        this.on(InfoEvents_1.InfoEvents.TOGGLE_ALL_SOUND_ON, this.onInfoAllSoundOn);
        this.onView(SettingsViewEvents_1.SettingsViewEvents.TOGGLE_SOUND_OFF, this.onSoundOff);
        this.onView(SettingsViewEvents_1.SettingsViewEvents.TOGGLE_SOUND_ON, this.onSoundOn);
        this.onView(SettingsViewEvents_1.SettingsViewEvents.TOGGLE_MUSIC_OFF, this.onMusicOff);
        this.onView(SettingsViewEvents_1.SettingsViewEvents.TOGGLE_MUSIC_ON, this.onMusicOn);
        this.onView(SettingsViewEvents_1.SettingsViewEvents.TOGGLE_SPACEBAR_OFF, this.onSpacebarOff);
        this.onView(SettingsViewEvents_1.SettingsViewEvents.TOGGLE_SPACEBAR_ON, this.onSpacebarOn);
        this.onView(SettingsViewEvents_1.SettingsViewEvents.TOGGLE_DRAG_REEL_TO_SPIN_OFF, this.onDragReelToSpinOff);
        this.onView(SettingsViewEvents_1.SettingsViewEvents.TOGGLE_DRAG_REEL_TO_SPIN_ON, this.onDragReelToSpinOn);
        this.onView(SettingsViewEvents_1.SettingsViewEvents.TOGGLE_SKIP_INTRO_OFF, this.onSkipIntroOff);
        this.onView(SettingsViewEvents_1.SettingsViewEvents.TOGGLE_SKIP_INTRO_ON, this.onSkipIntroOn);
        this.onView(SettingsViewEvents_1.SettingsViewEvents.TOGGLE_FAST_PLAY_OFF, this.onFastPlayOff);
        this.onView(SettingsViewEvents_1.SettingsViewEvents.TOGGLE_FAST_PLAY_ON, this.onFastPlayOn);
    };
    SettingsModule.prototype.onFastPlayOn = function () {
        this.eventManager.emit(SettingsEvents_1.SettingsEvents.TOGGLE_FAST_PLAY_ON);
        this.logic.fastPlayActive = true;
        this.settings.add(Settings_1.Settings.QUICKSPIN, true);
        this.saveData();
    };
    SettingsModule.prototype.onFastPlayOff = function () {
        this.eventManager.emit(SettingsEvents_1.SettingsEvents.TOGGLE_FAST_PLAY_OFF);
        this.logic.fastPlayActive = false;
        this.settings.add(Settings_1.Settings.QUICKSPIN, false);
        this.saveData();
    };
    SettingsModule.prototype.onMainMenuSettingsOpen = function () {
        this.showSettings();
    };
    SettingsModule.prototype.onMainMenuClosed = function () {
        this.closeSettings();
    };
    SettingsModule.prototype.onMainMenuSettingsClosed = function () {
        this.closeSettings();
    };
    SettingsModule.prototype.onMainMenuInfoOpen = function () {
        this.closeSettings();
    };
    SettingsModule.prototype.onMainMenuPaytableOpen = function () {
        this.closeSettings();
    };
    SettingsModule.prototype.isSoundSettingsOff = function () {
        var musicActive = this.logic.musicActive;
        var effectsActive = this.logic.soundEffectsActive;
        var soundAllActive = this.logic.soundAllActive;
        if (!musicActive && !effectsActive && soundAllActive) {
            this.emitAllSoundOff();
        }
    };
    SettingsModule.prototype.emitAllSoundOn = function () {
        this.eventManager.emit(SettingsEvents_1.SettingsEvents.TOGGLE_ALL_SOUND_ON);
    };
    SettingsModule.prototype.emitAllSoundOff = function () {
        this.eventManager.emit(SettingsEvents_1.SettingsEvents.TOGGLE_ALL_SOUND_OFF);
    };
    SettingsModule.prototype.onInfoAllSoundOff = function (eventId, clicked) {
        if (clicked === void 0) { clicked = true; }
        this.onAllSoundOff(null, clicked);
    };
    SettingsModule.prototype.onInfoAllSoundOn = function (eventId, clicked) {
        if (clicked === void 0) { clicked = true; }
        this.onAllSoundOn(null, clicked);
    };
    SettingsModule.prototype.onAllSoundOn = function (eventId, clicked) {
        if (eventId === void 0) { eventId = null; }
        if (clicked === void 0) { clicked = true; }
        this.soundPlayer.enableAllSound();
        this.settings.add(Settings_1.Settings.SOUNDS_ON, true);
        this.settings.add(Settings_1.Settings.MUSIC_ON, true);
        this.logic.soundAllActive = true;
        if (clicked) {
            this.view.allSoundsOn();
        }
        this.saveData();
    };
    SettingsModule.prototype.onAllSoundOff = function (eventId, clicked) {
        if (eventId === void 0) { eventId = null; }
        if (clicked === void 0) { clicked = true; }
        this.soundPlayer.disableAllSound();
        this.settings.add(Settings_1.Settings.SOUNDS_ON, false);
        this.settings.add(Settings_1.Settings.MUSIC_ON, false);
        this.logic.soundAllActive = false;
        if (clicked) {
            this.view.allSoundsOff();
        }
        this.saveData();
    };
    SettingsModule.prototype.onSoundOn = function () {
        this.eventManager.emit(SettingsEvents_1.SettingsEvents.TOGGLE_SOUND_EFFECTS_ON);
        this.soundPlayer.enableSounds();
        this.settings.add(Settings_1.Settings.SOUNDS_ON, true);
        this.logic.soundEffectsActive = true;
        // this.isSoundSettingsOff();
        this.saveData();
    };
    SettingsModule.prototype.onSoundOff = function () {
        this.eventManager.emit(SettingsEvents_1.SettingsEvents.TOGGLE_SOUND_EFFECTS_OFF);
        this.soundPlayer.disableSounds();
        this.settings.add(Settings_1.Settings.SOUNDS_ON, false);
        this.logic.soundEffectsActive = false;
        // this.isSoundSettingsOff();
        this.saveData();
    };
    SettingsModule.prototype.onMusicOn = function () {
        this.eventManager.emit(SettingsEvents_1.SettingsEvents.TOGGLE_MUSIC_ON);
        this.soundPlayer.enableMusic();
        this.settings.add(Settings_1.Settings.MUSIC_ON, true);
        this.logic.musicActive = true;
        // this.isSoundSettingsOff();
        this.saveData();
    };
    SettingsModule.prototype.onMusicOff = function () {
        this.eventManager.emit(SettingsEvents_1.SettingsEvents.TOGGLE_MUSIC_OFF);
        this.soundPlayer.disableMusic();
        this.settings.add(Settings_1.Settings.MUSIC_ON, false);
        this.logic.musicActive = false;
        // this.isSoundSettingsOff();
        this.saveData();
    };
    SettingsModule.prototype.onSpacebarOn = function () {
        this.eventManager.emit(SettingsEvents_1.SettingsEvents.TOGGLE_SPACEBAR_ON);
        this.logic.spacebarSpinActive = true;
        this.saveData();
    };
    SettingsModule.prototype.onSpacebarOff = function () {
        this.eventManager.emit(SettingsEvents_1.SettingsEvents.TOGGLE_SPACEBAR_OFF);
        this.logic.spacebarSpinActive = false;
        this.saveData();
    };
    SettingsModule.prototype.onDragReelToSpinOn = function () {
        this.eventManager.emit(SettingsEvents_1.SettingsEvents.TOGGLE_DRAG_REEL_TO_SPIN_ON);
        this.logic.dragReelToSpinActive = true;
        this.saveData();
    };
    SettingsModule.prototype.onDragReelToSpinOff = function () {
        this.eventManager.emit(SettingsEvents_1.SettingsEvents.TOGGLE_DRAG_REEL_TO_SPIN_OFF);
        this.logic.dragReelToSpinActive = false;
        this.saveData();
    };
    SettingsModule.prototype.onSkipIntroOn = function () {
        this.eventManager.emit(SettingsEvents_1.SettingsEvents.TOGGLE_SKIP_INTRO_ON);
        this.logic.skipIntro = true;
        this.saveData();
    };
    SettingsModule.prototype.onSkipIntroOff = function () {
        this.eventManager.emit(SettingsEvents_1.SettingsEvents.TOGGLE_SKIP_INTRO_OFF);
        this.logic.skipIntro = false;
        this.saveData();
    };
    SettingsModule.prototype.saveData = function () {
        if (this.canSaveData) {
            this.logic.saveData();
        }
    };
    Object.defineProperty(SettingsModule.prototype, "canSaveData", {
        get: function () {
            return true;
        },
        enumerable: true,
        configurable: true
    });
    return SettingsModule;
}(Module_1.Module));
exports.SettingsModule = SettingsModule;


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Module_1 = __webpack_require__(2);
var RecodeEvents_1 = __webpack_require__(79);
var RecodeLogic_1 = __webpack_require__(94);
var LogicEvents_1 = __webpack_require__(11);
var BackgroundModule_1 = __webpack_require__(277);
var FlowModuleEvents_1 = __webpack_require__(0);
var InfoEvents_1 = __webpack_require__(118);
var SpinButtonEvents_1 = __webpack_require__(12);
var StopAutoplayButtonEvents_1 = __webpack_require__(30);
var SettingsEvents_1 = __webpack_require__(95);
var FreeRoundsScreenEvents_1 = __webpack_require__(46);
var AutoplayMenuEvents_1 = __webpack_require__(33);
var BetlevelMenuEvents_1 = __webpack_require__(48);
var FreeSpinsEvents_1 = __webpack_require__(6);
var RecodeModule = /** @class */ (function (_super) {
    __extends(RecodeModule, _super);
    function RecodeModule() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._hasBetMessageWindowOnScreen = false;
        _this._initialized = false;
        _this._backgroundInitialized = false;
        _this._loadingEnded = false;
        return _this;
    }
    Object.defineProperty(RecodeModule.prototype, "api", {
        get: function () {
            return this.logic.communicator;
        },
        enumerable: true,
        configurable: true
    });
    RecodeModule.prototype.init = function () {
        _super.prototype.init.call(this);
        this.api.setModule(this);
    };
    RecodeModule.prototype.restore = function () {
        this.onClientGameplayStart();
    };
    RecodeModule.prototype.emitValidatedBetCoinSizeChanged = function () {
        this.eventManager.emit(RecodeEvents_1.RecodeEvents.VALIDATED_BET_COIN_SIZE_CHANGED);
    };
    RecodeModule.prototype.onShowErrorDialog = function () {
        this.eventManager.emit(RecodeEvents_1.RecodeEvents.SHOWING_ERROR);
    };
    RecodeModule.prototype.onCloseErrorDialog = function () {
        this.eventManager.emit(RecodeEvents_1.RecodeEvents.CLOSED_ERROR_DIALOG);
    };
    RecodeModule.prototype.onServerSystemBalanceUpdate = function (newBalance) {
        // New Balance in cents.
        // Check if the player can spin ATM.
        this._systemBalanceUpdateDirty = true;
        this._systemNewBalance = newBalance;
        if (this._canSpin === true) {
            this._systemBalanceUpdateDirty = false;
            this.logic.systemUpdateBalance(this._systemNewBalance);
            this.eventManager.emit(RecodeEvents_1.RecodeEvents.SERVER_SYSTEM_BALANCE_UPDATE, newBalance);
            this._systemNewBalance = 0;
        }
    };
    RecodeModule.prototype.onServerSetMute = function (value) {
        // options {optionType: 'MUTE', value:boolean}
        this.eventManager.emit(RecodeEvents_1.RecodeEvents.SERVER_PLUGIN_SET_MUTE, value);
    };
    RecodeModule.prototype.onServerGameplayResume = function () {
        // No data needed
        this.eventManager.emit(RecodeEvents_1.RecodeEvents.SERVER_GAMEPLAY_RESUME);
    };
    RecodeModule.prototype.onServerAutoplayInterrupt = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // No data needed
        this.eventManager.emit(RecodeEvents_1.RecodeEvents.SERVER_AUTOPLAY_INTERRUPT, args);
    };
    RecodeModule.prototype.onServerPreloaderRemoved = function () {
        // No data needed
        this.eventManager.emit(RecodeEvents_1.RecodeEvents.SERVER_PRELOADER_REMOVED);
    };
    RecodeModule.prototype.onServerLaunchLobby = function () {
        this.eventManager.emit(RecodeEvents_1.RecodeEvents.SERVER_LAUNCH_LOBBY);
    };
    RecodeModule.prototype.onServerLaunchBanking = function () {
        this.eventManager.emit(RecodeEvents_1.RecodeEvents.SERVER_LAUNCH_BANKING);
    };
    RecodeModule.prototype.setupStates = function () { };
    RecodeModule.prototype.enterFirstState = function () { };
    RecodeModule.prototype.setupViews = function () { };
    RecodeModule.prototype.setupEvents = function () {
        this.on(BackgroundModule_1.BackgroundModule.BACKGROUND_CREATED_EVENT, this.onBackgroundCreated);
        this.on(AutoplayMenuEvents_1.AutoplayMenuEvents.ACCEPTED, this.onStartAutoPlay);
        this.on(AutoplayMenuEvents_1.AutoplayMenuEvents.CANCELLED, this.onAutoplayMenuCancelled);
        this.on(AutoplayMenuEvents_1.AutoplayMenuEvents.AUTO_PLAY_MENU_OPENED, this.onAutoplayMenuOpened);
        this.on(StopAutoplayButtonEvents_1.StopAutoplayButtonEvents.STOP_AUTOPLAY_BUTTON_CLICKED, this.onStopAutoPlay);
        this.on(FlowModuleEvents_1.FlowModuleEvents.WON, this.onWon);
        this.on(FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN, this.onCanSpin);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_OUTRO_FINISHED, this.onFreeSpinsOutroFinished);
        this.on(SpinButtonEvents_1.SpinButtonEvents.SPIN_BUTTON_PRESSED, this.onSpinButtonPressed);
        this.on(SettingsEvents_1.SettingsEvents.TOGGLE_ALL_SOUND_OFF, this.onToggleSoundOff);
        this.on(SettingsEvents_1.SettingsEvents.TOGGLE_ALL_SOUND_ON, this.onToggleSoundOn);
        // Added for user input on sound icon in info bar.
        this.on(InfoEvents_1.InfoEvents.TOGGLE_ALL_SOUND_OFF, this.onToggleSoundOff);
        this.on(InfoEvents_1.InfoEvents.TOGGLE_ALL_SOUND_ON, this.onToggleSoundOn);
        this.on(LogicEvents_1.LogicEvents.INIT_RESPONSE, this.onInitResponse);
        this.on(BetlevelMenuEvents_1.BetlevelMenuEvents.BET_VALUE_UPDATED, this.onBetValueUpdated);
        this.on(BetlevelMenuEvents_1.BetlevelMenuEvents.BET_LEVEL_MENU_OPENED, this.onBetLevelMenuOpened);
        this.on(BetlevelMenuEvents_1.BetlevelMenuEvents.BET_LEVEL_MENU_CANCELLED, this.onBetLevelMenuCancelled);
        this.on(BetlevelMenuEvents_1.BetlevelMenuEvents.BET_LEVEL_MENU_SELECTED_BET_ACCEPTED, this.onBetLevelMenuAccepted);
        this.on(InfoEvents_1.InfoEvents.BALANCE_UPDATED, this.onBalanceUpdated);
        this.on(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_GAMES_FINISHED, this.onFreeGamesFinished);
        this.on(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_GAMES_POSTPONED, this.onFreeGamesPostponed);
        this.on(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_GAMES_REJECTED, this.onFreeGamesRejected);
        this.on(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_GAME_EXPIRED, this.onFreeGamesExpired);
    };
    RecodeModule.prototype.onBackgroundCreated = function () {
        // this._backgroundInitialized = true;
        // this.endLoading();
    };
    RecodeModule.prototype.onFreeGamesFinished = function () {
        if (!this.logic.hasKilledFreeGamesRestore) {
            this.validatePreviousBet();
        }
    };
    RecodeModule.prototype.onFreeGamesPostponed = function () {
        this.validatePreviousBet();
    };
    RecodeModule.prototype.onFreeGamesRejected = function () {
        this.validatePreviousBet();
    };
    RecodeModule.prototype.onFreeGamesExpired = function () {
        this.validatePreviousBet();
    };
    RecodeModule.prototype.validatePreviousBet = function () {
        if (this._hasBetMessageWindowOnScreen) {
            return;
        }
        // Restore to last bet if it was as valid one after Free Games are finished or differing from bet.
        this._hasBetMessageWindowOnScreen = this.logic.validatePreviousBet(this.emitValidatedBet.bind(this));
        if (this._hasBetMessageWindowOnScreen) {
            this.eventManager.emit(RecodeEvents_1.RecodeEvents.VALIDATED_BET_DIALOG_SHOWN);
        }
    };
    RecodeModule.prototype.emitValidatedBet = function () {
        this._hasBetMessageWindowOnScreen = false;
        this.eventManager.emit(RecodeEvents_1.RecodeEvents.VALIDATED_BET);
    };
    RecodeModule.prototype.onBalanceUpdated = function () {
        this.onClientBalanceUpdated();
    };
    RecodeModule.prototype.onBetValueUpdated = function () {
        this.api.api_betSizeUpdate(this.logic.betValue / RecodeLogic_1.RecodeLogic.CENT_TO_A_DOLLAR);
    };
    RecodeModule.prototype.onBetLevelMenuOpened = function () {
        this.onClientGameplayStart();
    };
    RecodeModule.prototype.onBetLevelMenuCancelled = function () {
        this.onClientGameplayPause();
    };
    RecodeModule.prototype.onBetLevelMenuAccepted = function () {
        this.onClientGameplayPause();
    };
    RecodeModule.prototype.onToggleSoundOff = function () {
        this.api.api_gameSetMute(true);
    };
    RecodeModule.prototype.onToggleSoundOn = function () {
        this.api.api_gameSetMute(false);
    };
    RecodeModule.prototype.onSpinButtonPressed = function () {
        this._canSpin = false;
        this.onClientGameplayStart();
    };
    RecodeModule.prototype.hasRestoreAndNoFreeGames = function () {
        return this.logic.hasRestore && !this.logic.hasFreeGames();
    };
    RecodeModule.prototype.onFreeSpinsOutroFinished = function () {
        this.validatePreviousBet();
    };
    RecodeModule.prototype.onCanSpin = function () {
        this._canSpin = true;
        if (!this._initialized) {
            return;
        }
        var logic = this.logic;
        if (this.hasRestoreAndNoFreeGames() ||
            logic.hasClearedExpiredFreeGames ||
            logic.hasKilledFreeGamesRestore ||
            logic.restoredIntoBonusGame) {
            logic.hasClearedExpiredFreeGames = false;
            logic.hasKilledFreeGamesRestore = false;
            logic.restoredIntoBonusGame = false;
            if (!logic.isFreeSpinsJustWon() && !logic.isFreeSpinsStarted) {
                this.validatePreviousBet();
            }
        }
        this.onClientGameplayPause();
        this.api.api_winUpdate(this.logic.getWin() / RecodeLogic_1.RecodeLogic.CENT_TO_A_DOLLAR); // Assuming its stored in dollars. Convert it to cents.
        // If this is pokerstars integration.
        // TODO: Setup logic for checking after Pokerstars.
        this.api.api_gameRoundCompleted();
        if (this._systemBalanceUpdateDirty === true) {
            this._systemBalanceUpdateDirty = false;
            this.logic.systemUpdateBalance(this._systemNewBalance);
            this.eventManager.emit(RecodeEvents_1.RecodeEvents.SERVER_SYSTEM_BALANCE_UPDATE);
            this._systemNewBalance = 0;
        }
    };
    RecodeModule.prototype.endLoading = function () {
        if (this._initialized && !this._loadingEnded) {
            this._loadingEnded = true;
            this.system.endLoading();
            this.onServerPreloaderRemoved();
        }
    };
    RecodeModule.prototype.onInitResponse = function () {
        this.onClientPlayerInformationReceived();
        this.endLoading();
    };
    RecodeModule.prototype.onWon = function () {
        this.onClientWinUpdate();
    };
    RecodeModule.prototype.onAutoplayMenuCancelled = function () {
        this.onClientGameplayPause();
    };
    RecodeModule.prototype.onAutoplayMenuOpened = function () {
        this.onClientGameplayStart();
    };
    RecodeModule.prototype.onStartAutoPlay = function () {
        this.onClientAutoplayStarted();
    };
    RecodeModule.prototype.onStopAutoPlay = function () {
        this.api.api_autoPlayStopped();
    };
    RecodeModule.prototype.onClientGameplayStart = function () {
        this.api.api_gameplayStart();
    };
    RecodeModule.prototype.onClientGameplayPause = function () {
        this.api.api_gameplayPause();
    };
    RecodeModule.prototype.onClientPlayerInformationReceived = function () {
        // Assuming it's provided in cents.
        var playersBalance = this.logic.currentBalanceCents;
        this.api.api_playerInformationRecieved(playersBalance);
        if (!this.logic.hasRestore) {
            this.onClientGameplayPause();
        }
        this.api.api_gameSetMute(!this.logic.soundAllActive); // The inverted value of active sound is what mute-state the sound is in.
        this._initialized = true;
        if (this._canSpin) {
            if (!(this.logic.hasRestore ||
                this.logic.hasFreeGames() ||
                this.logic.hasClearedExpiredFreeGames ||
                this.logic.hasKilledFreeGamesRestore ||
                this.logic.restoredIntoBonusGame)) {
                this.validatePreviousBet();
            }
        }
    };
    RecodeModule.prototype.onClientSetMute = function (eventId, newValue) {
        this.api.api_gameSetMute(newValue);
    };
    RecodeModule.prototype.onClientWinUpdate = function () {
        // Should be converted to "Cents"
        var winValue = this.logic.getSpinWin() / RecodeLogic_1.RecodeLogic.CENT_TO_A_DOLLAR;
        this.api.api_winUpdate(winValue);
    };
    RecodeModule.prototype.onClientGameMenuOpen = function () {
        this.api.api_gamemenuOpen();
    };
    RecodeModule.prototype.onClientGameMenuClosed = function () {
        this.api.api_gamemenuClosed();
    };
    RecodeModule.prototype.onClientAutoplayStarted = function () {
        this.api.api_autoPlayStarted();
    };
    RecodeModule.prototype.onClientGameRoundCompleted = function () {
        this.api.api_gameRoundCompleted();
    };
    RecodeModule.prototype.onClientBalanceUpdated = function () {
        // const balance: number = this.logic.getSpinBalance() / RecodeLogic.CENT_TO_A_DOLLAR;
        // Either this solution or add balance parsing to RecodeSpinResults,  Response.Player.attributes.balance.
        var balance = this.logic.currentBalanceCents;
        this.api.api_balanceUpdate(balance);
    };
    return RecodeModule;
}(Module_1.Module));
exports.RecodeModule = RecodeModule;


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var SpinButtonModule_1 = __webpack_require__(82);
var FreeRoundsScreenEvents_1 = __webpack_require__(46);
var RecodeEvents_1 = __webpack_require__(79);
var RecodeSpinButtonBasicState_1 = __webpack_require__(641);
var RecodeSpinButtonFreeSpinState_1 = __webpack_require__(642);
var RecodeSpinButtonWhileSpinningState_1 = __webpack_require__(643);
var SpinButtonEvents_1 = __webpack_require__(12);
var RecodeSpinButtonModule = /** @class */ (function (_super) {
    __extends(RecodeSpinButtonModule, _super);
    function RecodeSpinButtonModule() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._canAddKeyboardInput = false;
        _this._isWaitingForFreeGames = false;
        _this._isFreeRoundScreenOn = false;
        _this._errorDialogOpen = false;
        _this._freeSpinsIntroScreenOpened = false;
        return _this;
    }
    RecodeSpinButtonModule.prototype.afterInit = function () {
        _super.prototype.afterInit.call(this);
        this._hasQuickstop = false;
        if (window._certificationSettings && window._certificationSettings.hasOwnProperty('hideStop')) {
            this._hasQuickstop = !window._certificationSettings.hideStop;
        }
    };
    RecodeSpinButtonModule.prototype.setupCertificationSettings = function () {
        if (window._certificationSettings && window._certificationSettings.hasOwnProperty('spinDelay')) {
            this._spinTimeRegulation = window._certificationSettings.spinDelay;
        }
    };
    RecodeSpinButtonModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_ROUNDS_SCREEN_HIDDEN, this.onFreeGamesScreenClosed);
        this.on(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_ROUNDS_SCREEN_SHOWN, this.onFreeGamesScreenOpened);
        this.on(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.SOON_WILL_SHOW_FREE_ROUNDS_END, this.onSoonWillShowFreeRoundEndScreen);
        this.on(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.EXPECTED_TO_SHOW_FREE_ROUNDS_WINDOW, this.onExpectedToShowFreeRounds);
        this.on(RecodeEvents_1.RecodeEvents.CLOSED_ERROR_DIALOG, this.onCloseErrorDialog);
        this.on(RecodeEvents_1.RecodeEvents.SHOWING_ERROR, this.onShowingError);
        this.on(RecodeEvents_1.RecodeEvents.SERVER_AUTOPLAY_INTERRUPT, this.onServerAutoplayInterrupt);
        this.on(RecodeEvents_1.RecodeEvents.SERVER_GAMEPLAY_RESUME, this.onServerGameplayResume);
    };
    RecodeSpinButtonModule.prototype.onAutoplayStopClicked = function () {
        this.eventManager.emit(SpinButtonEvents_1.SpinButtonEvents.STOP_AUTOPLAY_BUTTON_PRESSED);
        if (this.logic.freeSpinsLeft <= 0 || !this._freeSpinsIntroScreenOpened) {
            this.view.uninitAutoplay();
        }
        this._isInAutoplay = false;
    };
    RecodeSpinButtonModule.prototype.onFreeSpinsIntroStarted = function () {
        _super.prototype.onFreeSpinsIntroStarted.call(this);
        this._freeSpinsIntroScreenOpened = true;
    };
    RecodeSpinButtonModule.prototype.onFreeSpinsIntroFinished = function () {
        _super.prototype.onFreeSpinsIntroFinished.call(this);
        this._freeSpinsIntroScreenOpened = false;
    };
    RecodeSpinButtonModule.prototype.setupStates = function () {
        _super.prototype.setupStates.call(this);
        this.addState(new RecodeSpinButtonBasicState_1.RecodeSpinButtonBasicState(this, SpinButtonModule_1.SpinButtonModule.BASIC_STATE));
        this.addState(new RecodeSpinButtonFreeSpinState_1.RecodeSpinButtonFreeSpinState(this, SpinButtonModule_1.SpinButtonModule.FREE_SPINS_STATE));
        this.addState(new RecodeSpinButtonWhileSpinningState_1.RecodeSpinButtonWhileSpinningState(this, SpinButtonModule_1.SpinButtonModule.REELS_SPINNING_STATE));
    };
    RecodeSpinButtonModule.prototype.onCloseErrorDialog = function () {
        this._errorDialogOpen = false;
    };
    RecodeSpinButtonModule.prototype.onShowingError = function () {
        this._errorDialogOpen = true;
    };
    RecodeSpinButtonModule.prototype.onExpectedToShowFreeRounds = function () {
        this._isWaitingForFreeGames = true;
        this.view.disableSpinButton();
        this.canSpin = false;
    };
    RecodeSpinButtonModule.prototype.onFreeGamesScreenClosed = function () {
        this._isFreeRoundScreenOn = false;
        this._canAddKeyboardInput = true;
        this.addKeyboardInput();
        if (this._isWaitingForFreeGames) {
            this._isWaitingForFreeGames = false;
            this.view.enableSpinButton();
            this.canSpin = true;
        }
    };
    RecodeSpinButtonModule.prototype.onFreeGamesScreenOpened = function () {
        this._isFreeRoundScreenOn = true;
        this._canAddKeyboardInput = false;
        this.removeKeyboardInput();
    };
    RecodeSpinButtonModule.prototype.onSoonWillShowFreeRoundEndScreen = function () {
        this._isFreeRoundScreenOn = true;
        this._canAddKeyboardInput = false;
        this.removeKeyboardInput();
        this._isWaitingForFreeGames = true;
        this.view.disableSpinButton();
        this.canSpin = false;
    };
    RecodeSpinButtonModule.prototype.addKeyboardInput = function () {
        var logic = this.logic;
        if (!logic.hasFreeGames() || this._canAddKeyboardInput) {
            _super.prototype.addKeyboardInput.call(this);
        }
    };
    RecodeSpinButtonModule.prototype.keyboardInput = function (event) {
        // space bar functionality should be removed completely (we love you Microgaming)
        /*if (!this._isFreeRoundScreenOn && !this._errorDialogOpen) {
            super.keyboardInput(event);
        }*/
    };
    RecodeSpinButtonModule.prototype.onServerAutoplayInterrupt = function () {
        this.disableSpaceInput();
    };
    RecodeSpinButtonModule.prototype.onServerGameplayResume = function () {
        this.enableSpaceInput();
    };
    RecodeSpinButtonModule.prototype.disableSpaceInput = function () {
        this._isKeyboardInputEnabled = false;
    };
    RecodeSpinButtonModule.prototype.enableSpaceInput = function () {
        this._isKeyboardInputEnabled = true;
    };
    Object.defineProperty(RecodeSpinButtonModule.prototype, "isWaitingForFreeGames", {
        get: function () {
            return this._isWaitingForFreeGames;
        },
        enumerable: true,
        configurable: true
    });
    return RecodeSpinButtonModule;
}(SpinButtonModule_1.SpinButtonModule));
exports.RecodeSpinButtonModule = RecodeSpinButtonModule;


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var SpinButtonFreeSpinsIntoState = /** @class */ (function (_super) {
    __extends(SpinButtonFreeSpinsIntoState, _super);
    function SpinButtonFreeSpinsIntoState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SpinButtonFreeSpinsIntoState.prototype.onEnterState = function () {
        this.view.hideSpinButton();
    };
    SpinButtonFreeSpinsIntoState.prototype.onLeaveState = function () { };
    SpinButtonFreeSpinsIntoState.prototype.setupEvents = function () { };
    return SpinButtonFreeSpinsIntoState;
}(ModuleState_1.ModuleState));
exports.SpinButtonFreeSpinsIntoState = SpinButtonFreeSpinsIntoState;


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var SpinButtonBasicState_1 = __webpack_require__(324);
var RecodeSpinButtonBasicState = /** @class */ (function (_super) {
    __extends(RecodeSpinButtonBasicState, _super);
    function RecodeSpinButtonBasicState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RecodeSpinButtonBasicState.prototype.onEnterState = function () {
        _super.prototype.onEnterState.call(this);
    };
    RecodeSpinButtonBasicState.prototype.onLeaveState = function () {
        _super.prototype.onLeaveState.call(this);
    };
    RecodeSpinButtonBasicState.prototype.onCanSpin = function () {
        if (!this.module.isWaitingForFreeGames) {
            _super.prototype.onCanSpin.call(this);
        }
    };
    RecodeSpinButtonBasicState.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
    };
    RecodeSpinButtonBasicState.prototype.onSpinButtonClicked = function () {
        if (this.module.hasSpinTimeRegulation()) {
            if (this.module.regulationCanSpin) {
                if (this.module.validateSpinPress()) {
                    this.trySpinIfEnoughMoneyElseEmitNotEnough();
                }
            }
        }
        else {
            if (this.module.validateSpinPress()) {
                this.trySpinIfEnoughMoneyElseEmitNotEnough();
            }
        }
    };
    RecodeSpinButtonBasicState.prototype.onReelsSpinStarted = function () {
        if (this.module.hasSpinTimeRegulation()) {
            this.module.regulationCanSpin = false;
            this.module.startRegulationSpinTimer();
        }
        _super.prototype.onReelsSpinStarted.call(this);
    };
    return RecodeSpinButtonBasicState;
}(SpinButtonBasicState_1.SpinButtonBasicState));
exports.RecodeSpinButtonBasicState = RecodeSpinButtonBasicState;


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var SpinButtonFreeSpinsState_1 = __webpack_require__(325);
var RecodeSpinButtonFreeSpinState = /** @class */ (function (_super) {
    __extends(RecodeSpinButtonFreeSpinState, _super);
    function RecodeSpinButtonFreeSpinState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RecodeSpinButtonFreeSpinState.prototype.onEnterState = function () {
        _super.prototype.onEnterState.call(this);
    };
    RecodeSpinButtonFreeSpinState.prototype.onLeaveState = function () {
        _super.prototype.onLeaveState.call(this);
    };
    RecodeSpinButtonFreeSpinState.prototype.onCanSpin = function () {
        if (!this.module.isWaitingForFreeGames) {
            _super.prototype.onCanSpin.call(this);
        }
    };
    RecodeSpinButtonFreeSpinState.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
    };
    return RecodeSpinButtonFreeSpinState;
}(SpinButtonFreeSpinsState_1.SpinButtonFreeSpinsState));
exports.RecodeSpinButtonFreeSpinState = RecodeSpinButtonFreeSpinState;


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var GameSpinButtonWhileSpinningState_1 = __webpack_require__(327);
var RecodeSpinButtonWhileSpinningState = /** @class */ (function (_super) {
    __extends(RecodeSpinButtonWhileSpinningState, _super);
    function RecodeSpinButtonWhileSpinningState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RecodeSpinButtonWhileSpinningState.prototype.onCanSpin = function () {
        if (!this.module.isWaitingForFreeGames) {
            _super.prototype.onCanSpin.call(this);
        }
    };
    return RecodeSpinButtonWhileSpinningState;
}(GameSpinButtonWhileSpinningState_1.GameSpinButtonWhileSpinningState));
exports.RecodeSpinButtonWhileSpinningState = RecodeSpinButtonWhileSpinningState;


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Timer_1 = __webpack_require__(28);
var SpinButtonEvents_1 = __webpack_require__(12);
var SpinButtonModule_1 = __webpack_require__(82);
var GameSpinButtonWhileSpinningState_1 = __webpack_require__(327);
var FlowModuleEvents_1 = __webpack_require__(0);
var GameSpinButtonModule = /** @class */ (function (_super) {
    __extends(GameSpinButtonModule, _super);
    function GameSpinButtonModule() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._spinTimeRegulation = 0;
        _this._regulationCanSpin = true;
        _this._warningPopupOpen = false;
        return _this;
    }
    GameSpinButtonModule.prototype.init = function () {
        _super.prototype.init.call(this);
        this.setupCertificationSettings();
    };
    GameSpinButtonModule.prototype.hasSpinTimeRegulation = function () {
        return this._spinTimeRegulation !== 0;
    };
    GameSpinButtonModule.prototype.startRegulationSpinTimer = function () {
        var _this = this;
        this._regulationSpinTimer = new Timer_1.Timer(function () {
            _this._regulationCanSpin = true;
            _this.currentState.handle(GameSpinButtonModule.REGULATION_SPIN_DELAY_PASSED);
        }, this._spinTimeRegulation, true);
        this.updateManager.add(this._regulationSpinTimer);
    };
    GameSpinButtonModule.prototype.setupCertificationSettings = function () {
        this._spinTimeRegulation = 0;
    };
    GameSpinButtonModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.onCurrentStateHandle(FlowModuleEvents_1.FlowModuleEvents.CAN_CONTINUE_SPIN);
        this.onCurrentStateHandle(GameSpinButtonModule.REGULATION_SPIN_DELAY_PASSED);
    };
    GameSpinButtonModule.prototype.tryEnableKeyboardInput = function () {
        if (!this._warningPopupOpen && !this._infoPopupOpen && !this._autoplayMenuOpen) {
            this._isKeyboardInputEnabled = true;
        }
    };
    GameSpinButtonModule.prototype.setupStates = function () {
        _super.prototype.setupStates.call(this);
        this.addState(new GameSpinButtonWhileSpinningState_1.GameSpinButtonWhileSpinningState(this, SpinButtonModule_1.SpinButtonModule.REELS_SPINNING_STATE));
    };
    GameSpinButtonModule.prototype.onSpinButtonClicked = function () {
        _super.prototype.onSpinButtonClicked.call(this);
        this.soundPlayer.play('spinStart');
    };
    GameSpinButtonModule.prototype.onAutoplayStopClicked = function () {
        this.eventManager.emit(SpinButtonEvents_1.SpinButtonEvents.STOP_AUTOPLAY_BUTTON_PRESSED);
        if (this.logic.freeSpinsLeft <= 0) {
            this.view.uninitAutoplay();
        }
        this._isInAutoplay = false;
    };
    Object.defineProperty(GameSpinButtonModule.prototype, "regulationCanSpin", {
        get: function () {
            return this._regulationCanSpin;
        },
        set: function (value) {
            this._regulationCanSpin = value;
        },
        enumerable: true,
        configurable: true
    });
    GameSpinButtonModule.REGULATION_SPIN_DELAY_PASSED = 'GameSpinButtonModule::REGULATION_SPIN_DELAY_PASSED';
    return GameSpinButtonModule;
}(SpinButtonModule_1.SpinButtonModule));
exports.GameSpinButtonModule = GameSpinButtonModule;


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var PaytableModule_1 = __webpack_require__(646);
var RecodeLogic_1 = __webpack_require__(94);
var RecodePaytableModule = /** @class */ (function (_super) {
    __extends(RecodePaytableModule, _super);
    function RecodePaytableModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RecodePaytableModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
    };
    RecodePaytableModule.prototype.showPaytable = function () {
        if (this.logic.hasFreeGames()) {
            this.updatePaytableFreeGames();
        }
        _super.prototype.showPaytable.call(this);
    };
    RecodePaytableModule.prototype.updatePaytableFreeGames = function () {
        var betData = this.logic.getCurrentFreeGamesData().betData;
        var multiplier = betData.chipSize * betData.numChips * RecodeLogic_1.RecodeLogic.CENT_TO_A_DOLLAR;
        this.updatePaytableValues(multiplier);
    };
    return RecodePaytableModule;
}(PaytableModule_1.PaytableModule));
exports.RecodePaytableModule = RecodePaytableModule;


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Module_1 = __webpack_require__(2);
var MainMenuEvents_1 = __webpack_require__(44);
var BetlevelMenuEvents_1 = __webpack_require__(48);
var GameViews_1 = __webpack_require__(43);
var LogicEvents_1 = __webpack_require__(11);
var PaytableModule = /** @class */ (function (_super) {
    __extends(PaytableModule, _super);
    function PaytableModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PaytableModule.prototype.setupStates = function () { };
    PaytableModule.prototype.enterFirstState = function () { };
    PaytableModule.prototype.init = function () {
        _super.prototype.init.call(this);
        this.view.paytableValues = this.logic.paytable;
        // this.view.buildPages();
    };
    PaytableModule.prototype.setupViews = function () {
        this.setView(GameViews_1.GameViews.PAYTABLE_VIEW);
    };
    PaytableModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(MainMenuEvents_1.MainMenuEvents.MAIN_MENU_PAYTABLE_OPEN, this.showPaytable);
        this.on(MainMenuEvents_1.MainMenuEvents.MAIN_MENU_SETTINGS_OPEN, this.hidePaytable);
        this.on(MainMenuEvents_1.MainMenuEvents.MAIN_MENU_INFO_OPEN, this.hidePaytable);
        this.on(MainMenuEvents_1.MainMenuEvents.MAIN_MENU_CLOSED, this.hidePaytable);
        this.on(BetlevelMenuEvents_1.BetlevelMenuEvents.BET_VALUE_UPDATED, this.onBetValueUpdated);
        this.on(LogicEvents_1.LogicEvents.INIT_RESPONSE, this.onInitResponseReceived);
    };
    PaytableModule.prototype.showPaytable = function () {
        this.view.show();
    };
    PaytableModule.prototype.hidePaytable = function () {
        this.view.hide();
    };
    PaytableModule.prototype.onInitResponseReceived = function () {
        this.onBetValueUpdated();
    };
    PaytableModule.prototype.onBetValueUpdated = function () {
        var buffer = 10000;
        var multiplier = this.logic.betValue / 20;
        multiplier = Math.floor(multiplier * buffer) / buffer;
        this.updatePaytableValues(multiplier);
    };
    PaytableModule.prototype.updatePaytableValues = function (multiplier) {
        this.view.paytableValues = this.logic.paytable;
        this.view.updatePaytable(multiplier);
    };
    return PaytableModule;
}(Module_1.Module));
exports.PaytableModule = PaytableModule;


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Module_1 = __webpack_require__(2);
var Views_1 = __webpack_require__(8);
var LogicEvents_1 = __webpack_require__(11);
var FlowModuleEvents_1 = __webpack_require__(0);
var FreeSpinsEvents_1 = __webpack_require__(6);
var StopAutoplayButtonEvents_1 = __webpack_require__(30);
var FreeRoundsScreenEvents_1 = __webpack_require__(46);
var InFreeRoundsEvents_1 = __webpack_require__(328);
var InFreeRoundsView_1 = __webpack_require__(329);
var AutoplayMenuEvents_1 = __webpack_require__(33);
var ReelsEvents_1 = __webpack_require__(4);
var InFreeRoundsModule = /** @class */ (function (_super) {
    __extends(InFreeRoundsModule, _super);
    function InFreeRoundsModule() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._isInAutoplay = false;
        _this._canEnableDiscardButton = true;
        return _this;
    }
    InFreeRoundsModule.prototype.restore = function () {
        _super.prototype.restore.call(this);
        if (this.logic.isFreeSpinsStarted) {
            this.view.disableDiscardButton();
            this.view.hideDiscardButton();
        }
    };
    InFreeRoundsModule.prototype.enterFirstState = function () { };
    InFreeRoundsModule.prototype.setupStates = function () { };
    InFreeRoundsModule.prototype.setupViews = function () {
        if (this.system.shouldUseMultipleViews()) {
            this.setView(Views_1.Views.MICROGAMING_INFREEROUNDS_VIEW_MOBILE);
        }
        else {
            this.setView(Views_1.Views.MICROGAMING_INFREEROUNDS_VIEW);
        }
    };
    InFreeRoundsModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_GAMES_STARTED, this.onFreeGamesStarted);
        this.on(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_GAMES_RESUMED, this.onFreeGamesStarted);
        this.on(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_GAMES_REJECTED, this.onFreeGamesEnded);
        this.on(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_GAMES_POSTPONED, this.onFreeGamesEnded);
        this.on(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_GAMES_FINISHED, this.onFreeGamesEnded);
        this.on(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_GAME_EXPIRED, this.onFreeGamesEnded);
        this.on(LogicEvents_1.LogicEvents.SPIN_RESPONSE, this.onSpinResponse);
        this.on(LogicEvents_1.LogicEvents.INIT_RESPONSE, this.onInitResponse);
        this.on(FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_START, this.onBonusGameStarted);
        this.on(FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_RESTORED, this.onBonusGameRestored);
        this.on(FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN, this.onCanSpin);
        this.on(ReelsEvents_1.ReelsEvents.REELS_SPINNING_STARTED, this.onReelsSpinningStarted);
        this.on(AutoplayMenuEvents_1.AutoplayMenuEvents.ACCEPTED, this.onAutoplayStarted);
        this.on(StopAutoplayButtonEvents_1.StopAutoplayButtonEvents.STOP_AUTOPLAY_BUTTON_CLICKED, this.onAutoplayStopped);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_INTRO_STARTED, this.onFreeSpinsIntroStarted);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_OUTRO_FINISHED, this.onFreeSpinsOutroFinished);
        this.onViewEmitEvent(InFreeRoundsView_1.InFreeRoundsView.DISCARD_PRESSED, InFreeRoundsEvents_1.InFreeRoundsEvents.DISCARD_PRESSED);
    };
    InFreeRoundsModule.prototype.onFreeSpinsOutroFinished = function () {
        this._canEnableDiscardButton = true;
        if (this.logic.currentFreeGameProgress &&
            this.logic.currentFreeGameProgress.gamesRemaining !== 0) {
            this.view.enableDiscardButton();
            this.view.showDiscardButton();
        }
    };
    InFreeRoundsModule.prototype.onFreeSpinsIntroStarted = function () {
        this.view.disableDiscardButton();
        this._canEnableDiscardButton = false;
        this.view.hideDiscardButton();
    };
    InFreeRoundsModule.prototype.onAutoplayStarted = function () {
        this.view.disableDiscardButton();
        this._isInAutoplay = true;
    };
    InFreeRoundsModule.prototype.onAutoplayStopped = function () {
        this._isInAutoplay = false;
    };
    InFreeRoundsModule.prototype.onFreeGamesStarted = function () {
        var logic = this.logic;
        if (logic.currentFreeGameProgress && logic.currentFreeGameProgress.gamesRemaining === 0) {
            this.view.showInGameScreen(null, logic.currentFreeGameProgress, this._isInAutoplay);
        }
        else {
            if (logic.getCurrentFreeGamesData() && logic.getCurrentFreeGamesData().gamesRemaining === 0) {
                this.view.showInGameScreen(null, logic.currentFreeGameProgress, this._isInAutoplay);
            }
            else {
                this.view.showInGameScreen(logic.getCurrentFreeGamesData(), logic.currentFreeGameProgress, this._isInAutoplay);
                if (!this.logic.isFreeSpinsStarted) {
                    this.view.enableDiscardButton();
                    this.view.showDiscardButton();
                }
            }
        }
    };
    InFreeRoundsModule.prototype.onSpinResponse = function () {
        var logic = this.logic;
        if (logic.isInFreeRounds) {
            if (logic.getCurrentFreeGamesData() && logic.getCurrentFreeGamesData().gamesRemaining === 0) {
                this.view.showInGameScreen(null, logic.currentFreeGameProgress, this._isInAutoplay);
            }
            else {
                this.view.showInGameScreen(logic.getCurrentFreeGamesData(), logic.currentFreeGameProgress, this._isInAutoplay);
            }
        }
    };
    InFreeRoundsModule.prototype.onInitResponse = function () {
        var logic = this.logic;
        if (logic.hasRestore || logic.hasBonusGameFreeGamesRestore) {
            this.view.disableDiscardButton();
        }
    };
    InFreeRoundsModule.prototype.onFreeGamesEnded = function () {
        this.view.removeScreen();
    };
    InFreeRoundsModule.prototype.onBonusGameStarted = function () {
        this.view.disableDiscardButton();
    };
    InFreeRoundsModule.prototype.onBonusGameRestored = function () {
        this.view.disableDiscardButton();
    };
    InFreeRoundsModule.prototype.onReelsSpinningStarted = function () {
        this.view.disableDiscardButton();
    };
    InFreeRoundsModule.prototype.onCanSpin = function () {
        if (!this.logic.isFreeSpinsStarted && this._canEnableDiscardButton) {
            this.view.enableDiscardButton();
        }
    };
    return InFreeRoundsModule;
}(Module_1.Module));
exports.InFreeRoundsModule = InFreeRoundsModule;


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Timer_1 = __webpack_require__(28);
var Module_1 = __webpack_require__(2);
var Views_1 = __webpack_require__(8);
var FreeGamesData_1 = __webpack_require__(281);
var LogicEvents_1 = __webpack_require__(11);
var BonusGameEvents_1 = __webpack_require__(78);
var FlowModuleEvents_1 = __webpack_require__(0);
var FreeSpinsEvents_1 = __webpack_require__(6);
var FreeRoundsScreenEvents_1 = __webpack_require__(46);
var FreeRoundsScreenView_1 = __webpack_require__(100);
var FreeRoundsBasicState_1 = __webpack_require__(650);
var FreeRoundsInGameState_1 = __webpack_require__(651);
var FreeRoundsOfferScreenState_1 = __webpack_require__(652);
var FreeRoundsResumeState_1 = __webpack_require__(653);
var InFreeRoundsEvents_1 = __webpack_require__(328);
var ReelsEvents_1 = __webpack_require__(4);
var WinPresentationEvents_1 = __webpack_require__(13);
var ReelConstants_1 = __webpack_require__(10);
var GameUtils_1 = __webpack_require__(26);
var FreeRoundsScreenModule = /** @class */ (function (_super) {
    __extends(FreeRoundsScreenModule, _super);
    function FreeRoundsScreenModule() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._waitingForRestoreRoundToBeOver = false;
        _this._waitingForFreeGamesToBeOver = false;
        _this._waitingForFreeSpinsToBeOver = false;
        _this._waitingForWinPresentationToBeOver = false;
        _this._isInfoOnTheScreen = false;
        _this._freeGamesTimers = [];
        _this._canShowExpirationWindow = true;
        _this._shouldExpireCurrentFreeGames = false;
        return _this;
    }
    FreeRoundsScreenModule.prototype.enterFirstState = function () {
        this.gotoState(FreeRoundsScreenModule.BASIC_STATE);
    };
    FreeRoundsScreenModule.prototype.setupStates = function () {
        this.addState(new FreeRoundsBasicState_1.FreeRoundsBasicState(this, FreeRoundsScreenModule.BASIC_STATE));
        this.addState(new FreeRoundsOfferScreenState_1.FreeRoundsOfferScreenState(this, FreeRoundsScreenModule.OFFER_STATE));
        this.addState(new FreeRoundsResumeState_1.FreeRoundsResumeState(this, FreeRoundsScreenModule.RESUME_STATE));
        this.addState(new FreeRoundsInGameState_1.FreeRoundsInGameState(this, FreeRoundsScreenModule.INGAME_STATE));
    };
    FreeRoundsScreenModule.prototype.setupViews = function () {
        if (this.system.shouldUseMultipleViews()) {
            this.setView(Views_1.Views.MICROGAMING_FREEROUNDS_VIEW_MOBILE);
        }
        else {
            this.setView(Views_1.Views.MICROGAMING_FREEROUNDS_VIEW);
        }
    };
    FreeRoundsScreenModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(LogicEvents_1.LogicEvents.INIT_RESPONSE, this.onInitResponse);
        this.on(LogicEvents_1.LogicEvents.SPIN_RESPONSE, this.onSpinResponse);
        this.on(FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN, this.onCanSpin);
        this.on(ReelsEvents_1.ReelsEvents.REELS_SPINNING_STARTED, this.onSpinStarted);
        this.on(WinPresentationEvents_1.WinPresentationEvents.INITIAL_ANIMATION_FINISHED, this.onInitialWinPresentationFinished);
        this.on(InFreeRoundsEvents_1.InFreeRoundsEvents.DISCARD_PRESSED, this.onInGameDiscardPressed);
        this.on(BonusGameEvents_1.BonusGameEvents.BONUS_OUTRO_FINISHED, this.onBonusOutroFinished);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_OUTRO_FINISHED, this.onFreeSpinsOutroFinished);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_INTRO_STARTED, this.onFreeSpinsIntroStarted);
        this.onView(FreeRoundsScreenView_1.FreeRoundsScreenView.PLAY_NOW_PRESSED, this.onFreeGamesStarted);
        this.onView(FreeRoundsScreenView_1.FreeRoundsScreenView.PLAY_LATER_PRESSED, this.onFreeGamesPostponed);
        this.onView(FreeRoundsScreenView_1.FreeRoundsScreenView.DISCARD_PRESSED, this.onDiscardPressed);
        this.onView(FreeRoundsScreenView_1.FreeRoundsScreenView.NEXT_OFFER_PRESSED, this.onNextOfferPressed);
        this.onView(FreeRoundsScreenView_1.FreeRoundsScreenView.BACK_TO_GAME_PRESSED, this.onBackToGamePressed);
        this.onView(FreeRoundsScreenView_1.FreeRoundsScreenView.RESUME_PRESSED, this.onResumePressed);
        this.onView(FreeRoundsScreenView_1.FreeRoundsScreenView.DISCARD_FINAL_PRESSED, this.onDiscardFinalPressed);
        this.onView(FreeRoundsScreenView_1.FreeRoundsScreenView.INFO_PRESSED, this.onInfoPressed);
        this.onView(FreeRoundsScreenView_1.FreeRoundsScreenView.EXPIRY_CONTINUE_PRESSED, this.onExpiryContinuePressed);
        this.onViewCurrentStateHandle(FreeRoundsScreenView_1.FreeRoundsScreenView.KEEP_IT_PRESSED);
        this.onViewEmitEvent(FreeRoundsScreenView_1.FreeRoundsScreenView.SCREEN_HIDDEN, FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_ROUNDS_SCREEN_HIDDEN);
        this.onViewEmitEvent(FreeRoundsScreenView_1.FreeRoundsScreenView.SCREEN_SHOWN, FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_ROUNDS_SCREEN_SHOWN);
        if (false) {
            document.addEventListener('keydown', this.keyboardInput.bind(this));
        }
    };
    FreeRoundsScreenModule.prototype.keyboardInput = function (event) {
        var fgData = new FreeGamesData_1.FreeGamesData(null);
        fgData.setData({ numChips: 5, activePaylines: 100, chipSize: 10 }, 0, '123456789', 5, 5, '123', 500, 'temp1', 'temp2', '456', 456789);
        var fgInProgress = new FreeGamesData_1.FreeGamesInProgress(null);
        fgInProgress.setData(2, 3, '123', '456', 987865413, 5, 10, 100);
        if (event.code === 'KeyQ' && event.ctrlKey) {
            this.view.showStartscreen(fgData);
        }
        if (event.code === 'KeyW' && event.ctrlKey) {
            fgData.creditType = 1;
            this.view.showStartscreen(fgData);
        }
        if (event.code === 'KeyE' && event.ctrlKey) {
            this.view.showRestoreScreen(fgInProgress, true);
        }
        if (event.code === 'KeyR' && event.ctrlKey) {
            this.view.showEndScreen(fgInProgress, 0, true);
        }
        if (event.code === 'KeyT' && event.ctrlKey) {
            this.view.showEndScreen(fgInProgress, 1, true);
        }
        if (event.code === 'KeyY' && event.ctrlKey) {
            this.view.showExpiryScreen('123', '456');
        }
        if (event.code === 'KeyU' && event.ctrlKey) {
            this.view.showDiscardQuestionsScreen(fgData);
        }
        if (event.code === 'KeyI' && event.ctrlKey) {
            this.view.showInfoText(fgData, ReelConstants_1.ReelConstants.LINES > 0, ReelConstants_1.ReelConstants.BOTH_WAYS);
        }
    };
    FreeRoundsScreenModule.prototype.stopFreeGamesTimers = function () {
        for (var _i = 0, _a = this._freeGamesTimers; _i < _a.length; _i++) {
            var timer = _a[_i];
            timer.timer.stop();
        }
        this._freeGamesTimers = [];
    };
    FreeRoundsScreenModule.prototype.setupFreeGamesTimers = function () {
        var _this = this;
        var logic = this.logic;
        var serverTimer = GameUtils_1.GameUtils.unixDateToSeconds(logic.serverTime);
        var _loop_1 = function (freeGame) {
            var endTime = GameUtils_1.GameUtils.unixDateToSeconds(freeGame.endDate);
            var timeBeforeExpiration = endTime - serverTimer;
            if (timeBeforeExpiration > 0) {
                var timer = new Timer_1.Timer(function () {
                    _this.tryToExpireFreeGame(freeGame.instanceID, freeGame.offerID);
                }, timeBeforeExpiration, true);
                this_1._freeGamesTimers.push({ timer: timer, instanceID: freeGame.instanceID, offerID: freeGame.offerID });
                this_1.updateManager.add(timer);
            }
        };
        var this_1 = this;
        for (var _i = 0, _a = logic.freeGamesData; _i < _a.length; _i++) {
            var freeGame = _a[_i];
            _loop_1(freeGame);
        }
    };
    FreeRoundsScreenModule.prototype.removeFreeGamesTimer = function (instanceID, offerID) {
        for (var i = 0; i < this._freeGamesTimers.length; i++) {
            if (this._freeGamesTimers[i].offerID === offerID && this._freeGamesTimers[i].instanceID === instanceID) {
                var timer = this._freeGamesTimers[i];
                timer.timer.stop();
                this._freeGamesTimers.splice(i, 1);
                return;
            }
        }
    };
    FreeRoundsScreenModule.prototype.hasFreeGamesTimer = function (instanceID, offerID) {
        for (var _i = 0, _a = this._freeGamesTimers; _i < _a.length; _i++) {
            var timer = _a[_i];
            if (timer.instanceID === instanceID && timer.offerID === offerID) {
                return true;
            }
        }
        return false;
    };
    FreeRoundsScreenModule.prototype.tryToExpireFreeGame = function (instanceID, offerID) {
        if (this._canShowExpirationWindow) {
            var logic = this.logic;
            var shouldSendExpiredMessage = false;
            if (this.isThisCurrentGame(instanceID, offerID)) {
                this.view.showExpiryScreen(instanceID, offerID);
                shouldSendExpiredMessage = true;
            }
            logic.recodeExpireGame(instanceID, offerID);
            this.removeFreeGamesTimer(instanceID, offerID);
            this._shouldExpireCurrentFreeGames = false;
            if (shouldSendExpiredMessage) {
                this.eventManager.emit(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_GAME_EXPIRED);
            }
        }
        else {
            this._shouldExpireCurrentFreeGames = true;
            this._toExpireFreeGamesInstanceID = instanceID;
            this._toExpireFreeGamesOfferID = offerID;
        }
    };
    FreeRoundsScreenModule.prototype.isThisCurrentGame = function (instanceID, offerID) {
        var logic = this.logic;
        return ((logic.currentFreeGameProgress &&
            instanceID === logic.currentFreeGameProgress.instanceID &&
            offerID === logic.currentFreeGameProgress.offerID) ||
            (logic.getCurrentFreeGamesData() &&
                instanceID === logic.getCurrentFreeGamesData().instanceID &&
                offerID === logic.getCurrentFreeGamesData().offerID));
    };
    FreeRoundsScreenModule.prototype.onResumePressed = function () {
        var logic = this.logic;
        if (logic.hasBonusGameFreeGamesRestore) {
            logic.recodeFreeGamesBonusGameRestore();
        }
        this.gotoState(FreeRoundsScreenModule.INGAME_STATE);
        this.eventManager.emit(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_GAMES_RESUMED);
        logic.startFreeGames();
    };
    FreeRoundsScreenModule.prototype.onNextOfferPressed = function () {
        var logic = this.logic;
        if (logic.hasFreeGames()) {
            logic.finishCurrentFreeGames();
            if (this.hasFreeGamesTimer(logic.getCurrentFreeGamesData().instanceID, logic.getCurrentFreeGamesData().offerID)) {
                this.eventManager.emit(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_GAMES_NEXT_OFFER);
                this.gotoState(FreeRoundsScreenModule.OFFER_STATE);
                this.view.showStartscreen(logic.getCurrentFreeGamesData());
            }
        }
        else {
            throw new Error('FreeRoundsScreenModule::onNextOfferPressed no free games on next offer');
        }
    };
    FreeRoundsScreenModule.prototype.onBackToGamePressed = function () {
        var logic = this.logic;
        logic.killAllFreeGames();
        this.gotoState(FreeRoundsScreenModule.BASIC_STATE);
        this.eventManager.emit(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_GAMES_FINISHED);
    };
    FreeRoundsScreenModule.prototype.onFreeGamesStarted = function () {
        this.gotoState(FreeRoundsScreenModule.INGAME_STATE);
        this.startFreeGames();
    };
    FreeRoundsScreenModule.prototype.startFreeGames = function () {
        var logic = this.logic;
        logic.startFreeGames();
        this.eventManager.emit(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_GAMES_STARTED);
    };
    FreeRoundsScreenModule.prototype.onFreeGamesPostponed = function () {
        this.gotoState(FreeRoundsScreenModule.BASIC_STATE);
        var logic = this.logic;
        logic.postponeFreeGames();
        this.eventManager.emit(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_GAMES_POSTPONED);
        if (logic.hasFreeGames() &&
            this.hasFreeGamesTimer(logic.getCurrentFreeGamesData().instanceID, logic.getCurrentFreeGamesData().offerID)) {
            this.gotoState(FreeRoundsScreenModule.OFFER_STATE);
            this.view.showStartscreen(logic.getCurrentFreeGamesData());
        }
    };
    FreeRoundsScreenModule.prototype.onInGameDiscardPressed = function () {
        this.onDiscardPressed();
    };
    FreeRoundsScreenModule.prototype.onDiscardPressed = function () {
        var logic = this.logic;
        if (logic.hasFreeGames()) {
            this._isInfoOnTheScreen = false;
            this.view.showDiscardQuestionsScreen(logic.getCurrentFreeGamesData());
        }
        else {
            throw new Error('FreeRoundsScreenModule::onDiscardPressed no free games to discard');
        }
    };
    FreeRoundsScreenModule.prototype.onDiscardFinalPressed = function () {
        this.discardFreeGames();
        var logic = this.logic;
        if (logic.hasBonusGameFreeGamesRestore) {
            logic.recodeFreeGamesBonusGameRestoreRejected();
        }
    };
    FreeRoundsScreenModule.prototype.onInfoPressed = function () {
        if (this._isInfoOnTheScreen) {
            this.view.hideInfoText();
        }
        else {
            var logic = this.logic;
            if (logic.hasFreeGames()) {
                this.view.showInfoText(logic.getCurrentFreeGamesData(), ReelConstants_1.ReelConstants.LINES > 0, ReelConstants_1.ReelConstants.BOTH_WAYS);
            }
        }
        this._isInfoOnTheScreen = !this._isInfoOnTheScreen;
    };
    FreeRoundsScreenModule.prototype.onExpiryContinuePressed = function () {
        var logic = this.logic;
        logic.clearExpiredFreeGames();
        if (logic.freeGamesData && logic.freeGamesData.length > 0) {
            this._waitingForRestoreRoundToBeOver = true;
            this.tryToShowFreeRoundsWindow();
        }
    };
    FreeRoundsScreenModule.prototype.discardFreeGames = function () {
        var logic = this.logic;
        this.removeFreeGamesTimer(logic.getCurrentFreeGamesData().instanceID, logic.getCurrentFreeGamesData().offerID);
        logic.rejectFreeGames(null);
        this._waitingForFreeSpinsToBeOver = false;
        this._waitingForFreeGamesToBeOver = false;
        this._waitingForRestoreRoundToBeOver = false;
        this._waitingForWinPresentationToBeOver = false;
        this.eventManager.emit(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_GAMES_REJECTED);
        if (logic.hasFreeGames() &&
            this.hasFreeGamesTimer(logic.getCurrentFreeGamesData().instanceID, logic.getCurrentFreeGamesData().offerID)) {
            this.gotoState(FreeRoundsScreenModule.OFFER_STATE);
            this.view.showStartscreen(logic.getCurrentFreeGamesData());
        }
    };
    FreeRoundsScreenModule.prototype.onInitResponse = function () {
        this.tryToSetupFreeGamesTimers();
        var logic = this.logic;
        if (logic.hasFreeGames() && logic.hasBonusGameFreeGamesRestore) {
            if (logic.currentFreeGameProgress ||
                logic.getCurrentFreeGamesData().gamesRemaining < logic.getCurrentFreeGamesData().gamesAwarded) {
                if (!logic.currentFreeGameProgress) {
                    logic.makeCurrenFreeGamesDataProgress();
                }
                if (this.hasFreeGamesTimer(logic.currentFreeGameProgress.instanceID, logic.currentFreeGameProgress.offerID)) {
                    this.gotoState(FreeRoundsScreenModule.RESUME_STATE);
                    this.view.showRestoreScreen(logic.currentFreeGameProgress, false);
                }
            }
            else {
                throw new Error('FreeRoundsScreenModule::onInitResponse no logic.currentFreeGameProgress on bonus game restore in free games');
            }
        }
        else if (logic.hasFreeGames() && !logic.hasRestore) {
            if (!logic.currentFreeGameProgress) {
                logic.makeCurrenFreeGamesDataProgress();
            }
            if (logic.currentFreeGameProgress && logic.currentFreeGameProgress.gamesRemaining === 0) {
                this.showEndScreen(logic.currentFreeGameProgress, (logic.getCurrentFreeGamesData() && logic.getCurrentFreeGamesData().creditType) || -1, this.hasNextOffer());
            }
            else if ((logic.currentFreeGameProgress && logic.currentFreeGameProgress.gamesPlayed > 0) ||
                logic.getCurrentFreeGamesData().gamesRemaining < logic.getCurrentFreeGamesData().gamesAwarded) {
                if (this.hasFreeGamesTimer(logic.currentFreeGameProgress.instanceID, logic.currentFreeGameProgress.offerID)) {
                    this.gotoState(FreeRoundsScreenModule.RESUME_STATE);
                    this.view.showRestoreScreen(logic.currentFreeGameProgress, true);
                }
            }
            else {
                if (this.hasFreeGamesTimer(logic.getCurrentFreeGamesData().instanceID, logic.getCurrentFreeGamesData().offerID)) {
                    this.gotoState(FreeRoundsScreenModule.OFFER_STATE);
                    this.view.showStartscreen(logic.getCurrentFreeGamesData());
                }
            }
        }
        else if (logic.hasFreeGames() && logic.hasRestore) {
            if (!logic.currentFreeGameProgress) {
                logic.makeCurrenFreeGamesDataProgress();
            }
            if (logic.isFreeSpinsStarted) {
                if (logic.currentFreeGameProgress.gamesRemaining === 0) {
                    this._waitingForFreeGamesToBeOver = true;
                }
                if (logic.currentFreeGameProgress.gamesPlayed > 0) {
                    this.view.showRestoreScreen(logic.currentFreeGameProgress, false);
                }
                else {
                    this._waitingForFreeGamesToBeOver = true;
                }
            }
            else {
                this._waitingForRestoreRoundToBeOver = true;
            }
        }
        else if (logic.hasExpiredFreeGames &&
            logic.currentFreeGameProgress &&
            (logic.currentFreeGameProgress.gamesRemaining > 0 || logic.isFreeSpinsStarted)) {
            // this.showEndScreen(logic.currentFreeGameProgress, -1, logic.freeGamesData.length > 0);
            if (logic.isFreeSpinsStarted) {
                this._waitingForFreeSpinsToBeOver = true;
                this._shouldExpireCurrentFreeGames = true;
                this._toExpireFreeGamesInstanceID = logic.currentFreeGameProgress.instanceID;
                this._toExpireFreeGamesOfferID = logic.currentFreeGameProgress.offerID;
                this.view.showRestoreScreen(logic.currentFreeGameProgress, false);
            }
            else {
                this.view.showExpiryScreen(logic.currentFreeGameProgress.instanceID, logic.currentFreeGameProgress.offerID);
            }
        }
        else if (logic.currentFreeGameProgress && logic.currentFreeGameProgress.gamesRemaining === 0) {
            if (logic.hasRestore) {
                this._waitingForFreeGamesToBeOver = true;
            }
            else {
                this.showEndScreen(logic.currentFreeGameProgress, (logic.getCurrentFreeGamesData() && logic.getCurrentFreeGamesData().creditType) || -1, false);
            }
        }
    };
    FreeRoundsScreenModule.prototype.hasNextOffer = function () {
        var logic = this.logic;
        if (logic.currentFreeGameProgress) {
            if (logic.currentFreeGameProgress.offerID === logic.getCurrentFreeGamesData().offerID &&
                logic.currentFreeGameProgress.instanceID === logic.getCurrentFreeGamesData().instanceID &&
                logic.freeGamesData.length === 1) {
                return false;
            }
            return true;
        }
        return logic.freeGamesData.length > 1;
    };
    FreeRoundsScreenModule.prototype.onSpinResponse = function () {
        var logic = this.logic;
        if (logic.isInFreeRounds) {
            if (logic.currentFreeGameProgress.gamesRemaining === 0 && !logic.isFreeSpinsJustWon()) {
                this._waitingForFreeGamesToBeOver = true;
            }
        }
    };
    FreeRoundsScreenModule.prototype.isInLastFreeSpin = function () {
        return this.logic.isFreeSpinsStarted === true && this.logic.freeSpinsLeft === 0;
    };
    FreeRoundsScreenModule.prototype.tryToSetupFreeGamesTimers = function () {
        var logic = this.logic;
        this.stopFreeGamesTimers();
        if (logic.freeGamesData) {
            this.setupFreeGamesTimers();
        }
    };
    FreeRoundsScreenModule.prototype.onBonusOutroFinished = function () {
        this._waitingForWinPresentationToBeOver = false;
        this.tryToShowFreeRoundsWindow();
    };
    FreeRoundsScreenModule.prototype.onInitialWinPresentationFinished = function () {
        if (this._waitingForWinPresentationToBeOver && !this._waitingForFreeSpinsToBeOver) {
            this._waitingForWinPresentationToBeOver = false;
            this.tryToShowFreeRoundsWindow();
        }
    };
    FreeRoundsScreenModule.prototype.onSpinStarted = function () {
        this._canShowExpirationWindow = false;
    };
    FreeRoundsScreenModule.prototype.onCanSpin = function () {
        if (this.logic.isFreeSpinsStarted) {
            this._waitingForFreeSpinsToBeOver = true;
        }
        else if (!this._waitingForFreeSpinsToBeOver) {
            this._canShowExpirationWindow = true;
            if (this._shouldExpireCurrentFreeGames) {
                this.tryToExpireFreeGame(this._toExpireFreeGamesInstanceID, this._toExpireFreeGamesOfferID);
            }
            if (this.logic.getSpinWin() > 0 && (this._waitingForRestoreRoundToBeOver || this._waitingForFreeGamesToBeOver)) {
                this.eventManager.emit(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.EXPECTED_TO_SHOW_FREE_ROUNDS_WINDOW);
                this._waitingForWinPresentationToBeOver = true;
            }
            else {
                if (this._waitingForRestoreRoundToBeOver || this._waitingForFreeGamesToBeOver) {
                    this.eventManager.emit(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.EXPECTED_TO_SHOW_FREE_ROUNDS_WINDOW);
                }
                this.tryToShowFreeRoundsWindow();
            }
        }
    };
    FreeRoundsScreenModule.prototype.runAfterFreeSpinsSequence = function () {
        this._canShowExpirationWindow = true;
        if (this._shouldExpireCurrentFreeGames) {
            this.tryToExpireFreeGame(this._toExpireFreeGamesInstanceID, this._toExpireFreeGamesOfferID);
        }
        else {
            if (this._waitingForRestoreRoundToBeOver || this._waitingForFreeGamesToBeOver) {
                this.eventManager.emit(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.EXPECTED_TO_SHOW_FREE_ROUNDS_WINDOW);
            }
            this.tryToShowFreeRoundsWindow();
        }
    };
    FreeRoundsScreenModule.prototype.onFreeSpinsIntroStarted = function () {
        this._waitingForFreeSpinsToBeOver = true;
    };
    FreeRoundsScreenModule.prototype.onFreeSpinsOutroFinished = function () {
        if (this._waitingForFreeSpinsToBeOver) {
            this._waitingForFreeSpinsToBeOver = false;
            this.runAfterFreeSpinsSequence();
        }
    };
    FreeRoundsScreenModule.prototype.showFreeRoundsWindowAccordingly = function () {
        var logic = this.logic;
        if ((logic.currentFreeGameProgress && logic.currentFreeGameProgress.gamesRemaining !== 0) ||
            logic.getCurrentFreeGamesData().gamesRemaining < logic.getCurrentFreeGamesData().gamesAwarded) {
            if (!logic.currentFreeGameProgress) {
                logic.makeCurrenFreeGamesDataProgress();
            }
            if (this.hasFreeGamesTimer(logic.currentFreeGameProgress.instanceID, logic.currentFreeGameProgress.offerID)) {
                if (logic.getCurrentFreeGamesData().gamesRemaining === logic.getCurrentFreeGamesData().gamesAwarded) {
                    this.gotoState(FreeRoundsScreenModule.OFFER_STATE);
                    this.view.showStartscreen(logic.getCurrentFreeGamesData());
                }
                else {
                    this.gotoState(FreeRoundsScreenModule.RESUME_STATE);
                    this.view.showRestoreScreen(logic.currentFreeGameProgress, true);
                }
            }
        }
        else if (logic.currentFreeGameProgress && logic.currentFreeGameProgress.gamesRemaining === 0) {
            this.startBeforeSummarySection();
        }
        else {
            if (this.hasFreeGamesTimer(logic.getCurrentFreeGamesData().instanceID, logic.getCurrentFreeGamesData().offerID)) {
                this.gotoState(FreeRoundsScreenModule.OFFER_STATE);
                this.view.showStartscreen(logic.getCurrentFreeGamesData());
            }
        }
    };
    FreeRoundsScreenModule.prototype.tryToShowFreeRoundsWindow = function () {
        var logic = this.logic;
        if (this._waitingForRestoreRoundToBeOver) {
            this._waitingForRestoreRoundToBeOver = false;
            this.showFreeRoundsWindowAccordingly();
        }
        if (this._waitingForFreeGamesToBeOver) {
            this._waitingForFreeGamesToBeOver = false;
            if (logic.currentFreeGameProgress && logic.currentFreeGameProgress.gamesRemaining === 0) {
                this.startBeforeSummarySection();
            }
            else if (logic.currentFreeGameProgress && logic.currentFreeGameProgress.gamesPlayed === 0) {
                if (this.hasFreeGamesTimer(logic.currentFreeGameProgress.instanceID, logic.currentFreeGameProgress.offerID)) {
                    this.gotoState(FreeRoundsScreenModule.OFFER_STATE);
                    this.view.showStartscreen(logic.getCurrentFreeGamesData());
                }
            }
            else if (logic.currentFreeGameProgress) {
                this.gotoState(FreeRoundsScreenModule.RESUME_STATE);
                this.view.showRestoreScreen(logic.currentFreeGameProgress, true);
            }
            else {
                throw new Error('FreeRoundsScreenModule::tryToShowFreeRoundsWindow _waitingForFreeGamesToBeOver wrong data');
            }
        }
    };
    FreeRoundsScreenModule.prototype.startBeforeSummarySection = function () {
        var _this = this;
        this.eventManager.emit(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.SOON_WILL_SHOW_FREE_ROUNDS_END);
        var logic = this.logic;
        var beforeShowingTimer = new Timer_1.Timer(function () {
            _this._waitingForFreeGamesToBeOver = false;
            _this.gotoState(FreeRoundsScreenModule.BASIC_STATE);
            var hasNextFreeGames = logic.hasNextFreeGames();
            _this.showEndScreen(logic.currentFreeGameProgress, (logic.getCurrentFreeGamesData() && logic.getCurrentFreeGamesData().creditType) || -1, hasNextFreeGames);
        }, FreeRoundsScreenModule.BEFORE_SUMMARY_DELAY, true);
        this.updateManager.add(beforeShowingTimer);
    };
    FreeRoundsScreenModule.prototype.showEndScreen = function (lastFreeGame, creditType, hasNextOffer) {
        var logic = this.logic;
        this.view.showEndScreen(logic.currentFreeGameProgress, (logic.getCurrentFreeGamesData() && logic.getCurrentFreeGamesData().creditType) || -1, hasNextOffer);
        this.removeFreeGamesTimer(logic.currentFreeGameProgress.instanceID, logic.currentFreeGameProgress.offerID);
    };
    FreeRoundsScreenModule.BASIC_STATE = 'basic';
    FreeRoundsScreenModule.OFFER_STATE = 'offer';
    FreeRoundsScreenModule.RESUME_STATE = 'resume';
    FreeRoundsScreenModule.INGAME_STATE = 'ingame';
    FreeRoundsScreenModule.BEFORE_SUMMARY_DELAY = 2000;
    return FreeRoundsScreenModule;
}(Module_1.Module));
exports.FreeRoundsScreenModule = FreeRoundsScreenModule;


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var SpriteButton_1 = __webpack_require__(55);
var Button_1 = __webpack_require__(54);
var NineSliceSpriteButton = /** @class */ (function (_super) {
    __extends(NineSliceSpriteButton, _super);
    function NineSliceSpriteButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NineSliceSpriteButton.prototype.setFrames = function (up, down, over, disabled) {
        this._frames[Button_1.ButtonState.UP] = up;
        this._frames[Button_1.ButtonState.DOWN] = down ? down : up;
        this._frames[Button_1.ButtonState.OVER] = over ? over : up;
        this._frames[Button_1.ButtonState.DISABLED] = disabled ? disabled : up;
        this.updateFrame();
    };
    NineSliceSpriteButton.prototype.setSize = function (newSize) {
        this.updateNineSliceSize(Button_1.ButtonState.UP, newSize);
        this.updateNineSliceSize(Button_1.ButtonState.DOWN, newSize);
        this.updateNineSliceSize(Button_1.ButtonState.OVER, newSize);
        this.updateNineSliceSize(Button_1.ButtonState.DISABLED, newSize);
    };
    NineSliceSpriteButton.prototype.setWidth = function (newWidth) {
        this.setFrameWidth(Button_1.ButtonState.UP, newWidth);
        this.setFrameWidth(Button_1.ButtonState.DOWN, newWidth);
        this.setFrameWidth(Button_1.ButtonState.OVER, newWidth);
        this.setFrameWidth(Button_1.ButtonState.DISABLED, newWidth);
    };
    NineSliceSpriteButton.prototype.setHeight = function (newHeight) {
        this.setFrameWidth(Button_1.ButtonState.UP, newHeight);
        this.setFrameWidth(Button_1.ButtonState.DOWN, newHeight);
        this.setFrameWidth(Button_1.ButtonState.OVER, newHeight);
        this.setFrameWidth(Button_1.ButtonState.DISABLED, newHeight);
    };
    NineSliceSpriteButton.prototype.setFrameWidth = function (stateObject, newWidth) {
        this._frames[stateObject].width = newWidth;
        this._frames[stateObject].updatePositionFromAnchor();
    };
    NineSliceSpriteButton.prototype.setFrameHeight = function (stateObject, newHeight) {
        this._frames[stateObject].height = newHeight;
        this._frames[stateObject].updatePositionFromAnchor();
    };
    NineSliceSpriteButton.prototype.updateNineSliceSize = function (stateObject, newSize) {
        this._frames[stateObject].width = newSize.width;
        this._frames[stateObject].height = newSize.height;
        this._frames[stateObject].updatePositionFromAnchor();
    };
    NineSliceSpriteButton.prototype.setAnchor = function (newPosition) {
        this._frames[Button_1.ButtonState.UP].anchor = newPosition;
        this._frames[Button_1.ButtonState.DOWN].anchor = newPosition;
        this._frames[Button_1.ButtonState.OVER].anchor = newPosition;
        this._frames[Button_1.ButtonState.DISABLED].anchor = newPosition;
        this._frames[Button_1.ButtonState.UP].updatePositionFromAnchor();
        this._frames[Button_1.ButtonState.DOWN].updatePositionFromAnchor();
        this._frames[Button_1.ButtonState.OVER].updatePositionFromAnchor();
        this._frames[Button_1.ButtonState.DISABLED].updatePositionFromAnchor();
    };
    return NineSliceSpriteButton;
}(SpriteButton_1.SpriteButton));
exports.NineSliceSpriteButton = NineSliceSpriteButton;


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var FreeRoundsBasicState = /** @class */ (function (_super) {
    __extends(FreeRoundsBasicState, _super);
    function FreeRoundsBasicState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FreeRoundsBasicState.prototype.onEnterState = function () {
    };
    FreeRoundsBasicState.prototype.onLeaveState = function () {
    };
    FreeRoundsBasicState.prototype.setupEvents = function () {
    };
    return FreeRoundsBasicState;
}(ModuleState_1.ModuleState));
exports.FreeRoundsBasicState = FreeRoundsBasicState;


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var FreeRoundsScreenView_1 = __webpack_require__(100);
var FreeRoundsScreenEvents_1 = __webpack_require__(46);
var FreeRoundsInGameState = /** @class */ (function (_super) {
    __extends(FreeRoundsInGameState, _super);
    function FreeRoundsInGameState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FreeRoundsInGameState.prototype.onEnterState = function () {
    };
    FreeRoundsInGameState.prototype.onLeaveState = function () {
    };
    FreeRoundsInGameState.prototype.setupEvents = function () {
        this.on(FreeRoundsScreenView_1.FreeRoundsScreenView.KEEP_IT_PRESSED, this.onKeepItPressed);
    };
    FreeRoundsInGameState.prototype.onKeepItPressed = function () {
        this.emit(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.RESTORE_TO_IN_GAME);
    };
    return FreeRoundsInGameState;
}(ModuleState_1.ModuleState));
exports.FreeRoundsInGameState = FreeRoundsInGameState;


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var FreeRoundsScreenView_1 = __webpack_require__(100);
var FreeRoundsOfferScreenState = /** @class */ (function (_super) {
    __extends(FreeRoundsOfferScreenState, _super);
    function FreeRoundsOfferScreenState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FreeRoundsOfferScreenState.prototype.onEnterState = function () {
    };
    FreeRoundsOfferScreenState.prototype.onLeaveState = function () {
    };
    FreeRoundsOfferScreenState.prototype.setupEvents = function () {
        this.on(FreeRoundsScreenView_1.FreeRoundsScreenView.KEEP_IT_PRESSED, this.onKeepItPressed);
    };
    FreeRoundsOfferScreenState.prototype.onKeepItPressed = function () {
        var logic = this.module.logic;
        if (logic.hasFreeGames()) {
            this.view.showStartscreen(logic.getCurrentFreeGamesData());
        }
        else {
            throw new Error('FreeRoundsOfferScreenState::onKeepItPressed no free games on next offer');
        }
    };
    return FreeRoundsOfferScreenState;
}(ModuleState_1.ModuleState));
exports.FreeRoundsOfferScreenState = FreeRoundsOfferScreenState;


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var FreeRoundsScreenView_1 = __webpack_require__(100);
var FreeRoundsResumeState = /** @class */ (function (_super) {
    __extends(FreeRoundsResumeState, _super);
    function FreeRoundsResumeState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FreeRoundsResumeState.prototype.onEnterState = function () {
    };
    FreeRoundsResumeState.prototype.onLeaveState = function () {
    };
    FreeRoundsResumeState.prototype.setupEvents = function () {
        this.on(FreeRoundsScreenView_1.FreeRoundsScreenView.KEEP_IT_PRESSED, this.onKeepItPressed);
    };
    FreeRoundsResumeState.prototype.onKeepItPressed = function () {
        var logic = this.module.logic;
        if (logic.hasFreeGames()) {
            this.view.showRestoreScreen(logic.currentFreeGameProgress, true);
        }
        else {
            throw new Error('FreeRoundsResumeState::onKeepItPressed no free games on next offer');
        }
    };
    return FreeRoundsResumeState;
}(ModuleState_1.ModuleState));
exports.FreeRoundsResumeState = FreeRoundsResumeState;


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Settings_1 = __webpack_require__(109);
var RecodeAnalyticsModule_1 = __webpack_require__(655);
var GameRecodeAnalyticsModule = /** @class */ (function (_super) {
    __extends(GameRecodeAnalyticsModule, _super);
    function GameRecodeAnalyticsModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameRecodeAnalyticsModule.prototype.setCurrentModes = function () {
        // TODO: Get RMM value.
        // const isQuickSpinAvailable = (window as any).V.API.get
        window.V.API.SlotAnalytics.setCurrencyMode('Credits');
        var hasQuickSpin = this.settings.get(Settings_1.Settings.IS_QUICKSPIN_AVAILABLE);
        window.V.API.SlotAnalytics.setQuickSpins(hasQuickSpin); // But depends on regulated market settings.
        window.V.API.SlotAnalytics.setGameSounds(Settings_1.Settings.SOUNDS_ON);
        window.V.API.SlotAnalytics.setBackgroundSounds(Settings_1.Settings.MUSIC_ON);
        window.V.API.SlotAnalytics.setWinSounds(Settings_1.Settings.SOUNDS_ON);
    };
    GameRecodeAnalyticsModule.prototype.onSpinStarted = function () {
        window.V.API.SlotAnalytics.startSpinEvent();
        if (this._isFreeSpinsStarted) {
            this._lastSpinInteractionMethod = 'FreeSpin';
        }
        else if (this._isInAutoplay) {
            this._lastSpinInteractionMethod = 'AutoPlay';
        }
        else if (this._isSpinStartedSwiping) {
            this._lastSpinInteractionMethod = 'Swipe';
        }
        else if (this.device.isMobile) {
            this._lastSpinInteractionMethod = 'Tap';
        }
        else {
            if (this._wasQuickSpin) {
                this._lastSpinInteractionMethod = 'QuickSpin';
            }
            else {
                this._lastSpinInteractionMethod = 'Click';
            }
        }
        this._isSpinStartedSwiping = false;
        this._isInAutoplay = false;
        this._wasQuickSpin = false;
    };
    GameRecodeAnalyticsModule.prototype.onCanSpin = function () {
        window.V.API.SlotAnalytics.sendSpinEvent(this._lastSpinInteractionMethod, this._wasQuickSpin);
        this._wasQuickSpin = false;
    };
    return GameRecodeAnalyticsModule;
}(RecodeAnalyticsModule_1.RecodeAnalyticsModule));
exports.GameRecodeAnalyticsModule = GameRecodeAnalyticsModule;


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Module_1 = __webpack_require__(2);
var LogicEvents_1 = __webpack_require__(11);
var FlowModuleEvents_1 = __webpack_require__(0);
var FreeSpinsEvents_1 = __webpack_require__(6);
var SpinButtonEvents_1 = __webpack_require__(12);
var SwipeInteractionEvents_1 = __webpack_require__(65);
var RecodeAnalyticsModule = /** @class */ (function (_super) {
    __extends(RecodeAnalyticsModule, _super);
    function RecodeAnalyticsModule() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._isInAutoplay = false;
        _this._isSpinStartedSwiping = false;
        _this._isFreeSpinsStarted = false;
        _this._wasQuickSpin = false;
        return _this;
    }
    RecodeAnalyticsModule.prototype.init = function () {
        _super.prototype.init.call(this);
        this.setCurrentModes();
        this.soundPlayer.allSoundsStatusChangedCallback = this.onAllSoundsStatusChanged.bind(this);
        this.soundPlayer.backgroundMusicStatusChangedCallback = this.onBackgroundMusicStatusChanged.bind(this);
        this.soundPlayer.gameSoundsStatusChangedCallback = this.onGameSoundsStatusChanged.bind(this);
    };
    RecodeAnalyticsModule.prototype.setCurrentModes = function () {
        window.V.API.SlotAnalytics.setCurrencyMode('Credits');
        window.V.API.SlotAnalytics.setQuickSpins(false);
        window.V.API.SlotAnalytics.setGameSounds(true);
        window.V.API.SlotAnalytics.setBackgroundSounds(true);
        window.V.API.SlotAnalytics.setWinSounds(false);
    };
    RecodeAnalyticsModule.prototype.enterFirstState = function () { };
    RecodeAnalyticsModule.prototype.setupStates = function () { };
    RecodeAnalyticsModule.prototype.setupEvents = function () {
        this.on(SpinButtonEvents_1.SpinButtonEvents.SPIN_BUTTON_PRESSED, this.onSpinStarted);
        this.on(LogicEvents_1.LogicEvents.SPIN_RESPONSE, this.onSpinDataReceived);
        this.on(FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN, this.onCanSpin);
        this.on(FlowModuleEvents_1.FlowModuleEvents.FREESPINS_WIN, this.onFreeSpinsWin);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_OUTRO_FINISHED, this.onFreeSpinsFinished);
        this.on(SpinButtonEvents_1.SpinButtonEvents.START_AUTOPLAY_BUTTON_PRESSED, this.onSpinStartedByAutoplay);
        this.on(SwipeInteractionEvents_1.SwipeInteractionEvents.START_SPIN, this.onSwipe);
        this.on(SpinButtonEvents_1.SpinButtonEvents.QUICKSTOP_PRESSED, this.onQuickstopPressed);
    };
    RecodeAnalyticsModule.prototype.onQuickstopPressed = function () {
        this._wasQuickSpin = true;
    };
    RecodeAnalyticsModule.prototype.onFreeSpinsWin = function () {
        this._isFreeSpinsStarted = true;
    };
    RecodeAnalyticsModule.prototype.onFreeSpinsFinished = function () {
        this._isFreeSpinsStarted = false;
    };
    RecodeAnalyticsModule.prototype.setupViews = function () { };
    RecodeAnalyticsModule.prototype.onSwipe = function () {
        this._isSpinStartedSwiping = true;
    };
    RecodeAnalyticsModule.prototype.onSpinStartedByAutoplay = function () {
        this._isInAutoplay = true;
    };
    RecodeAnalyticsModule.prototype.onSpinStarted = function () {
        window.V.API.SlotAnalytics.startSpinEvent();
        if (this._isFreeSpinsStarted) {
            this._lastSpinInteractionMethod = 'FreeSpin';
        }
        else if (this._isInAutoplay) {
            this._lastSpinInteractionMethod = 'AutoPlay';
        }
        else if (this._isSpinStartedSwiping) {
            this._lastSpinInteractionMethod = 'Swipe';
        }
        else if (this.device.isMobile) {
            this._lastSpinInteractionMethod = 'Tap';
        }
        else {
            this._lastSpinInteractionMethod = 'Click';
        }
        this._wasQuickSpin = false;
        this._isSpinStartedSwiping = false;
        this._isInAutoplay = false;
    };
    RecodeAnalyticsModule.prototype.onSpinDataReceived = function () {
        var transNumber = this.logic.transNumber;
        var CI = window.V.API.GameAnalytics.ContextItems;
        window.V.API.GameAnalytics.setContextData(CI.KEY_TRANSACTION_ID, Number.parseInt(transNumber, 10));
    };
    RecodeAnalyticsModule.prototype.onCanSpin = function () {
        window.V.API.SlotAnalytics.sendSpinEvent(this._lastSpinInteractionMethod, false);
    };
    RecodeAnalyticsModule.prototype.onAllSoundsStatusChanged = function (isEnabled) {
        window.V.API.SlotAnalytics.setBackgroundSounds(isEnabled);
        window.V.API.SlotAnalytics.setGameSounds(isEnabled);
    };
    RecodeAnalyticsModule.prototype.onBackgroundMusicStatusChanged = function (isEnabled) {
        window.V.API.SlotAnalytics.setBackgroundSounds(isEnabled);
    };
    RecodeAnalyticsModule.prototype.onGameSoundsStatusChanged = function (isEnabled) {
        window.V.API.SlotAnalytics.setGameSounds(isEnabled);
    };
    return RecodeAnalyticsModule;
}(Module_1.Module));
exports.RecodeAnalyticsModule = RecodeAnalyticsModule;


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var AutoPlayButtonView_1 = __webpack_require__(657);
var RecodeAutoPlayButtonView = /** @class */ (function (_super) {
    __extends(RecodeAutoPlayButtonView, _super);
    function RecodeAutoPlayButtonView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RecodeAutoPlayButtonView.prototype.init = function () {
        _super.prototype.init.call(this);
        if (this.checkAutoplayDisabled()) {
            this.destroyAutoplayButton();
        }
    };
    RecodeAutoPlayButtonView.prototype.checkAutoplayDisabled = function () {
        return !window.V.API.Autoplay.getConfig().enabled;
    };
    RecodeAutoPlayButtonView.prototype.destroyAutoplayButton = function () {
        this._autoplayButton.destroy();
    };
    return RecodeAutoPlayButtonView;
}(AutoPlayButtonView_1.AutoPlayButtonView));
exports.RecodeAutoPlayButtonView = RecodeAutoPlayButtonView;


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var View_1 = __webpack_require__(3);
var AutoPlayButtonViewEvents_1 = __webpack_require__(330);
__webpack_require__(59);
var AutoPlayButtonView = /** @class */ (function (_super) {
    __extends(AutoPlayButtonView, _super);
    function AutoPlayButtonView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AutoPlayButtonView.prototype.init = function () {
        _super.prototype.init.call(this);
        this._autoplayButton = this.spineUtils.createSpineButton('AUTOPLAY_BUTTON.json', this.onAutoplayButtonClicked.bind(this));
        var autoplayButtonPosition = this.layout.getAbsolutePosition('AUTOPLAY_BUTTON');
        this._autoplayButton.position.set(autoplayButtonPosition.x, autoplayButtonPosition.y);
        this.container.addChild(this._autoplayButton);
    };
    AutoPlayButtonView.prototype.enableAutoplayButton = function () {
        this._autoplayButton.enable();
        // this._autoplayButton.visible = true;
    };
    AutoPlayButtonView.prototype.disableAutoplayButton = function () {
        this._autoplayButton.disable();
    };
    AutoPlayButtonView.prototype.hideAutoplayButton = function () {
        this._autoplayButton.visible = false;
    };
    AutoPlayButtonView.prototype.showAutoplayButton = function () {
        this._autoplayButton.visible = true;
    };
    AutoPlayButtonView.prototype.onAutoplayButtonClicked = function () {
        this.soundPlayer.play('buttonClick');
        this.emit(AutoPlayButtonViewEvents_1.AutoPlayButtonViewEvents.AUTO_PLAYBUTTON_CLICKED);
    };
    return AutoPlayButtonView;
}(View_1.View));
exports.AutoPlayButtonView = AutoPlayButtonView;


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var MainMenuView_1 = __webpack_require__(659);
var MainMenuViewEvents_1 = __webpack_require__(169);
var RecodeMainMenuView = /** @class */ (function (_super) {
    __extends(RecodeMainMenuView, _super);
    function RecodeMainMenuView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RecodeMainMenuView.prototype.init = function () {
        _super.prototype.init.call(this);
        if (this.destroyLobbyButtonCheck()) {
            this.destroyLobbyButton();
        }
    };
    RecodeMainMenuView.prototype.openLobbyLink = function () {
        var vApi = window.V.API;
        vApi.Core.launchLobby();
        this.emit(MainMenuViewEvents_1.MainMenuViewEvents.MAIN_MENU_LOBBY_OPEN);
    };
    RecodeMainMenuView.prototype.destroyLobbyButton = function () {
        this._lobbyButton.destroy();
    };
    RecodeMainMenuView.prototype.destroyLobbyButtonCheck = function () {
        return !window.V.API.Core.isLobbyAvailable();
    };
    return RecodeMainMenuView;
}(MainMenuView_1.MainMenuView));
exports.RecodeMainMenuView = RecodeMainMenuView;


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var SpineAnimation_1 = __webpack_require__(37);
var SpriteButton_1 = __webpack_require__(55);
var Spine_1 = __webpack_require__(25);
var AnimationNames_1 = __webpack_require__(154);
var View_1 = __webpack_require__(3);
var MainMenuViewEvents_1 = __webpack_require__(169);
var GenericButton_1 = __webpack_require__(90);
var GameUtils_1 = __webpack_require__(26);
var MainMenuView = /** @class */ (function (_super) {
    __extends(MainMenuView, _super);
    function MainMenuView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // TODO: Retrieve link from init data or casino.
        _this._lobbyLink = 'https://www.fantasmagames.com/';
        return _this;
    }
    MainMenuView.prototype.init = function () {
        _super.prototype.init.call(this);
        this.setupMainMenu();
        this.setupButtons();
        this.setupTextStyles();
        this.setupTextObjects();
        this.addExtras();
    };
    MainMenuView.prototype.translate = function () {
        var paytableText = this.translator.getObject('BaseStrings', 'generic', 'g_paytable') || 'PAYTABLE';
        paytableText = paytableText.toUpperCase();
        this._menuTitle.text = paytableText.toUpperCase();
        this.updateTitleScale();
        this.postTranslate();
    };
    MainMenuView.prototype.showMainMenu = function () {
        this._mainMenuLayout.visible = true;
        this._visible = true;
        var animation = this.playMainLayoutAnimation(AnimationNames_1.AnimationNames.MAIN_MENU.Name.ENTER, false);
        animation.setOnComplete(this.playIdleMainMenuVisible.bind(this));
    };
    MainMenuView.prototype.hideMainMenu = function () {
        var animation = this.playMainLayoutAnimation(AnimationNames_1.AnimationNames.MAIN_MENU.Name.EXIT, false);
        animation.setOnComplete(this.playIdleMainMenuHidden.bind(this));
    };
    MainMenuView.prototype.postTranslate = function () {
        this._paytableButton.forceClicked();
        this._paytableButton.setSelected();
    };
    MainMenuView.prototype.addExtras = function () { };
    MainMenuView.prototype.playIdleMainMenuHidden = function () {
        this.playMainLayoutAnimation(AnimationNames_1.AnimationNames.MAIN_MENU.Name.IDLE_HIDDEN, true);
        this._mainMenuLayout.visible = false;
        this._visible = false;
    };
    MainMenuView.prototype.playIdleMainMenuVisible = function () {
        this.playMainLayoutAnimation(AnimationNames_1.AnimationNames.MAIN_MENU.Name.IDLE_VISIBLE, true);
    };
    MainMenuView.prototype.setupMainMenu = function () {
        this._mainMenuLayout = new Spine_1.Spine(this.resources.getSpine('MAIN_MENU.json'));
        this.playIdleMainMenuHidden();
        this._mainMenuLayout.position.set(this.resolutionManager.halfResolution.width, this.resolutionManager.halfResolution.height);
        this.container.addChild(this._mainMenuLayout);
        this._mainMenuLayout.slotContainers[this._mainMenuLayout.skeleton.findSlotIndex('BACKGROUND_SOLID')].interactive = true;
        this._backgroundObject = this._mainMenuLayout.slotContainers[this._mainMenuLayout.skeleton.findSlotIndex('MENU_ELEMENT')];
        this._backgroundObject.interactive = true;
        this._backgroundObject.children[0].visible = false;
        this._menuTitleBackground = this._mainMenuLayout.slotContainers[this._mainMenuLayout.skeleton.findSlotIndex('MENU_TITLE_BACKGROUND')];
        this._menuTitleContainer = this._mainMenuLayout.slotContainers[this._mainMenuLayout.skeleton.findSlotIndex('MENU_TITLE')];
        this._menuTitleContainer.children[0].visible = false;
    };
    MainMenuView.prototype.setupTextStyles = function () {
        this._titleTextStyle = this.textStyles.mainMenuTitle;
        this._titleTextStyle.wordWrapWidth = this.resolutionManager.resolution.width;
        this._breadTextStyle = this.textStyles.mainMenuBread;
        this._breadTextStyle.wordWrapWidth = this.resolutionManager.resolution.width;
    };
    MainMenuView.prototype.setupTextObjects = function () {
        // let paytableText: string = this.translator.getObject('BaseStrings', 'generic', 'g_paytable') || 'PAYTABLE';
        // paytableText = paytableText.toUpperCase();
        this._menuTitle = new PIXI.Text('', this._titleTextStyle);
        this._menuTitleContainer.addChild(this._menuTitle);
        this._menuTitle.anchor.set(0.5, 0.5);
        this._menuTitle.transform = this._menuTitleContainer.children[0].transform;
        this._menuTitleContainer.children[0].destroy();
        // this._menuTitleContainer.children[0].visible = false;
    };
    MainMenuView.prototype.onCloseButtonClicked = function () {
        this.soundPlayer.play('buttonClick');
        this.emit(MainMenuViewEvents_1.MainMenuViewEvents.MAIN_MENU_CLOSE_CLICKED);
    };
    MainMenuView.prototype.onPaytableButtonClicked = function (isRealClick) {
        if (isRealClick) {
            this.soundPlayer.play('buttonClick');
        }
        this.emit(MainMenuViewEvents_1.MainMenuViewEvents.MAIN_MENU_PAYTABLE_CLICKED);
        this._settingsButton.resetState();
        this._infoButton.resetState();
        this.showPaytable();
    };
    MainMenuView.prototype.onSettingsButtonClicked = function () {
        this.soundPlayer.play('buttonClick');
        this.emit(MainMenuViewEvents_1.MainMenuViewEvents.MAIN_MENU_SETTINGS_CLICKED);
        this._infoButton.resetState();
        this._paytableButton.resetState();
        this.showSettings();
    };
    MainMenuView.prototype.onInfoButtonClicked = function () {
        this.soundPlayer.play('buttonClick');
        this.emit(MainMenuViewEvents_1.MainMenuViewEvents.MAIN_MENU_INFO_CLICKED);
        this._settingsButton.resetState();
        this._paytableButton.resetState();
        this.showInfo();
    };
    MainMenuView.prototype.onLobbyButtonClicked = function () {
        this.soundPlayer.play('buttonClick');
        this.emit(MainMenuViewEvents_1.MainMenuViewEvents.MAIN_MENU_LOBBY_CLICKED);
        this.openLobbyLink();
    };
    MainMenuView.prototype.updateTitleScale = function () {
        var maxSize = {
            x: this._titleTextStyle.wordWrapWidth,
            y: this._menuTitleBackground.children[0].height,
        };
        if (this._menuTitle.width > maxSize.x || this._menuTitle.height > maxSize.y) {
            GameUtils_1.GameUtils.correctSpriteScale(this._menuTitle, maxSize);
            // this._menuTitle.scale.y *= -1;
        }
    };
    MainMenuView.prototype.showPaytable = function () {
        var paytableText = this.translator.getObject('BaseStrings', 'generic', 'g_paytable') || 'PAYTABLE';
        this._menuTitle.text = paytableText.toUpperCase();
        this.updateTitleScale();
        this.showCloseButton();
        this.emit(MainMenuViewEvents_1.MainMenuViewEvents.MAIN_MENU_PAYTABLE_OPEN);
    };
    MainMenuView.prototype.showSettings = function () {
        var settingsText = this.translator.getObject('BaseStrings', 'generic', 'g_settings') || 'SETTINGS';
        this._menuTitle.text = settingsText.toUpperCase();
        this.updateTitleScale();
        this.showConfirmButton();
        this.emit(MainMenuViewEvents_1.MainMenuViewEvents.MAIN_MENU_SETTINGS_OPEN);
    };
    MainMenuView.prototype.showInfo = function () {
        var text = this.translator.getObject('BaseStrings', 'generic', 'g_gamerules') || 'GAME RULES';
        this._menuTitle.text = text.toUpperCase();
        this.updateTitleScale();
        this.showCloseButton();
        this.emit(MainMenuViewEvents_1.MainMenuViewEvents.MAIN_MENU_INFO_OPEN);
    };
    MainMenuView.prototype.hidePaytable = function () {
        this.emit(MainMenuViewEvents_1.MainMenuViewEvents.MAIN_MENU_PAYTABLE_CLOSE);
    };
    MainMenuView.prototype.hideSettings = function () {
        this.showCloseButton();
        this.emit(MainMenuViewEvents_1.MainMenuViewEvents.MAIN_MENU_SETTINGS_CLOSE);
    };
    MainMenuView.prototype.showCloseButton = function () {
        this._closeButton.visible = true;
        this._confirmButton.visible = false;
    };
    MainMenuView.prototype.showConfirmButton = function () {
        this._confirmButton.visible = true;
        this._closeButton.visible = false;
    };
    MainMenuView.prototype.hideInfo = function () {
        this.emit(MainMenuViewEvents_1.MainMenuViewEvents.MAIN_MENU_INFO_CLOSE);
    };
    MainMenuView.prototype.openLobbyLink = function () {
        window.open(this.lobbyLink, '_blank');
        this.emit(MainMenuViewEvents_1.MainMenuViewEvents.MAIN_MENU_LOBBY_OPEN);
    };
    MainMenuView.prototype.playMainLayoutAnimation = function (animationName, loop, stopOnComplete) {
        if (stopOnComplete === void 0) { stopOnComplete = true; }
        if (this._mainAnimation) {
            this._mainAnimation.stop();
            this.updateManager.remove(this._mainAnimation);
        }
        this._mainAnimation = new SpineAnimation_1.SpineAnimation(this._mainMenuLayout, animationName, loop, true);
        if (stopOnComplete) {
            this._mainAnimation.setOnComplete(this._mainAnimation.stop.bind(this));
        }
        this.updateManager.add(this._mainAnimation);
        this._mainAnimation.start();
        return this._mainAnimation;
    };
    MainMenuView.prototype.setupButtons = function () {
        this._confirmButton = new SpriteButton_1.SpriteButton(this.onCloseButtonClicked.bind(this));
        this._closeButton = new SpriteButton_1.SpriteButton(this.onCloseButtonClicked.bind(this));
        this._paytableButton = new GenericButton_1.GenericButton(this.onPaytableButtonClicked.bind(this));
        this._settingsButton = new GenericButton_1.GenericButton(this.onSettingsButtonClicked.bind(this));
        this._infoButton = new GenericButton_1.GenericButton(this.onInfoButtonClicked.bind(this));
        this._lobbyButton = new SpriteButton_1.SpriteButton(this.onLobbyButtonClicked.bind(this));
        this._confirmButton.setFramesNames(this.resources, 'HUD.json', 'CONFIRM.png', 'CONFIRM_CLICKED.png', 'CONFIRM.png', 'CONFIRM.png');
        this._closeButton.setFramesNames(this.resources, 'HUD.json', 'EXIT_BUTTON.png', 'EXIT_BUTTON_CLICKED.png', 'EXIT_BUTTON.png', 'EXIT_BUTTON.png');
        this._lobbyButton.setFramesNames(this.resources, 'HUD.json', 'HOME_BUTTON.png', 'HOME_BUTTON_CLICKED.png', 'HOME_BUTTON.png', 'HOME_BUTTON.png');
        this._infoButton.setFramesNames(this.resources, 'HUD.json', 'INFO_BUTTON.png', 'INFO_BUTTON_CLICKED.png', 'INFO_BUTTON.png', 'INFO_BUTTON.png');
        this._settingsButton.setFramesNames(this.resources, 'HUD.json', 'SETTINGS_BUTTON.png', 'SETTINGS_BUTTON_CLICKED.png', 'SETTINGS_BUTTON.png', 'SETTINGS_BUTTON.png');
        this._paytableButton.setFramesNames(this.resources, 'HUD.json', 'PAYTABLE_BUTTON.png', 'PAYTABLE_BUTTON_CLICKED.png', 'PAYTABLE_BUTTON.png', 'PAYTABLE_BUTTON.png');
        ////////////////////////////////////////////////////////////////////
        // Get Skeleton Slots for replacement.
        ////////////////////////////////////////////////////////////////////
        var closeButtonSlot = this._mainMenuLayout.slotContainers[this._mainMenuLayout.skeleton.findSlotIndex('EXIT_BUTTON')];
        var lobbyButtonSlot = this._mainMenuLayout.slotContainers[this._mainMenuLayout.skeleton.findSlotIndex('HOME_BUTTON')];
        var paytableButtonSlot = this._mainMenuLayout.slotContainers[this._mainMenuLayout.skeleton.findSlotIndex('PAYTABLE_BUTTON')];
        var settingsButtonSlot = this._mainMenuLayout.slotContainers[this._mainMenuLayout.skeleton.findSlotIndex('SETTINGS_BUTTON')];
        var infoButtonSlot = this._mainMenuLayout.slotContainers[this._mainMenuLayout.skeleton.findSlotIndex('INFO_BUTTON')];
        ////////////////////////////////////////////////////////////////////
        // Add the new buttons to their appropriate slot.
        ////////////////////////////////////////////////////////////////////
        closeButtonSlot.addChild(this._closeButton);
        this._closeButton.transform = closeButtonSlot.children[0].transform;
        closeButtonSlot.children[0].destroy();
        closeButtonSlot.addChild(this._confirmButton);
        this._confirmButton.transform = closeButtonSlot.children[0].transform;
        paytableButtonSlot.addChild(this._paytableButton);
        this._paytableButton.transform = paytableButtonSlot.children[0].transform;
        paytableButtonSlot.children[0].destroy();
        settingsButtonSlot.addChild(this._settingsButton);
        this._settingsButton.transform = settingsButtonSlot.children[0].transform;
        settingsButtonSlot.children[0].destroy();
        lobbyButtonSlot.addChild(this._lobbyButton);
        this._lobbyButton.transform = lobbyButtonSlot.children[0].transform;
        lobbyButtonSlot.children[0].destroy();
        infoButtonSlot.addChild(this._infoButton);
        this._infoButton.transform = infoButtonSlot.children[0].transform;
        infoButtonSlot.children[0].destroy();
    };
    MainMenuView.prototype.createAndSetupMenuContainer = function (menuItem) {
        var container = new PIXI.Sprite();
        container.addChild(menuItem);
        this._backgroundObject.addChild(container);
        container.transform = this._backgroundObject.children[0].transform;
        menuItem.position.x -= this.resolutionManager.halfResolution.width;
        menuItem.position.y -= this.resolutionManager.halfResolution.height;
        menuItem.anchor.set(0.5, 0.5);
    };
    Object.defineProperty(MainMenuView.prototype, "lobbyLink", {
        get: function () {
            return this._lobbyLink;
        },
        set: function (newLink) {
            this._lobbyLink = newLink;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainMenuView.prototype, "paytable", {
        set: function (paytable) {
            this._paytable = paytable;
            this.createAndSetupMenuContainer(paytable);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainMenuView.prototype, "settings", {
        set: function (settings) {
            this._settings = settings;
            this.createAndSetupMenuContainer(settings);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MainMenuView.prototype, "rules", {
        set: function (rules) {
            this._rules = rules;
            this.createAndSetupMenuContainer(rules);
        },
        enumerable: true,
        configurable: true
    });
    return MainMenuView;
}(View_1.View));
exports.MainMenuView = MainMenuView;


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var AutoPlayButtonModule_1 = __webpack_require__(331);
var FreeRoundsScreenEvents_1 = __webpack_require__(46);
var RecodeAutoPlayButtonModule = /** @class */ (function (_super) {
    __extends(RecodeAutoPlayButtonModule, _super);
    function RecodeAutoPlayButtonModule() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._isWaitingForFreeGames = false;
        _this._isFreeRoundScreenOn = false;
        return _this;
    }
    RecodeAutoPlayButtonModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_ROUNDS_SCREEN_HIDDEN, this.onFreeGamesScreenClosed);
        this.on(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_ROUNDS_SCREEN_SHOWN, this.onFreeGamesScreenOpened);
        this.on(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.EXPECTED_TO_SHOW_FREE_ROUNDS_WINDOW, this.onExpectedToShowFreeRounds);
    };
    RecodeAutoPlayButtonModule.prototype.onFreeGamesScreenClosed = function () {
        this._isFreeRoundScreenOn = false;
        if (this._isWaitingForFreeGames) {
            this._isWaitingForFreeGames = false;
            this.onCanSpin();
        }
    };
    RecodeAutoPlayButtonModule.prototype.onFreeGamesScreenOpened = function () {
        this._isFreeRoundScreenOn = true;
    };
    RecodeAutoPlayButtonModule.prototype.onCanSpin = function () {
        if (!this._isWaitingForFreeGames) {
            _super.prototype.onCanSpin.call(this);
        }
    };
    RecodeAutoPlayButtonModule.prototype.onExpectedToShowFreeRounds = function () {
        this._isWaitingForFreeGames = true;
        this.view.disableAutoplayButton();
    };
    return RecodeAutoPlayButtonModule;
}(AutoPlayButtonModule_1.AutoPlayButtonModule));
exports.RecodeAutoPlayButtonModule = RecodeAutoPlayButtonModule;


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var StopAutoplayButtonEvents_1 = __webpack_require__(30);
var FlowModuleEvents_1 = __webpack_require__(0);
var AutoPlayButtonBasicState = /** @class */ (function (_super) {
    __extends(AutoPlayButtonBasicState, _super);
    function AutoPlayButtonBasicState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AutoPlayButtonBasicState.prototype.onEnterState = function () {
        if (!this.module.autoPlayActive && this.module.startscreenExitFinished && !this.module.logic.isFreeSpinsStarted && !this.module.logic.isFreeSpinsJustWon()) {
            this.module.showAutoplayButton();
        }
        this.module.enableAutoplayButton();
    };
    AutoPlayButtonBasicState.prototype.onLeaveState = function () {
    };
    AutoPlayButtonBasicState.prototype.setupEvents = function () {
        this.on(FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN, this.onCanSpin);
        this.on(StopAutoplayButtonEvents_1.StopAutoplayButtonEvents.STOP_AUTOPLAY_BUTTON_CLICKED, this.onStopAutoplayButtonClicked);
    };
    AutoPlayButtonBasicState.prototype.onCanSpin = function () {
        if (this.module.isFreeSpins) {
            return;
        }
        if (!this.module.autoPlayActive && this.module.startscreenExitFinished) {
            this.module.showView();
            this.module.showAutoplayButton();
        }
        this.module.enableAutoplayButton();
    };
    AutoPlayButtonBasicState.prototype.onStopAutoplayButtonClicked = function () {
        this.module.autoPlayActive = false;
        this.module.showAutoplayButton();
    };
    return AutoPlayButtonBasicState;
}(ModuleState_1.ModuleState));
exports.AutoPlayButtonBasicState = AutoPlayButtonBasicState;


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var AutoPlayButtonModule_1 = __webpack_require__(331);
var StopAutoplayButtonEvents_1 = __webpack_require__(30);
var FlowModuleEvents_1 = __webpack_require__(0);
var AutoPlayButtonWhileSpinningState = /** @class */ (function (_super) {
    __extends(AutoPlayButtonWhileSpinningState, _super);
    function AutoPlayButtonWhileSpinningState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AutoPlayButtonWhileSpinningState.prototype.onEnterState = function () {
        this.module.hideAutoplayButton();
    };
    AutoPlayButtonWhileSpinningState.prototype.onLeaveState = function () {
    };
    AutoPlayButtonWhileSpinningState.prototype.setupEvents = function () {
        this.on(StopAutoplayButtonEvents_1.StopAutoplayButtonEvents.STOP_AUTOPLAY_BUTTON_CLICKED, this.onStopAutoplayButtonClicked);
        this.on(FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN, this.onCanSpin);
    };
    AutoPlayButtonWhileSpinningState.prototype.onCanSpin = function () {
        this.module.gotoState(AutoPlayButtonModule_1.AutoPlayButtonModule.BASIC_STATE);
    };
    AutoPlayButtonWhileSpinningState.prototype.onStopAutoplayButtonClicked = function () {
        this.module.autoPlayActive = false;
    };
    return AutoPlayButtonWhileSpinningState;
}(ModuleState_1.ModuleState));
exports.AutoPlayButtonWhileSpinningState = AutoPlayButtonWhileSpinningState;


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BetButtonModule_1 = __webpack_require__(332);
var FreeRoundsScreenEvents_1 = __webpack_require__(46);
var RecodeBetButtonModule = /** @class */ (function (_super) {
    __extends(RecodeBetButtonModule, _super);
    function RecodeBetButtonModule() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._startscreenExitFinished = false;
        return _this;
    }
    RecodeBetButtonModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_GAMES_RESUMED, this.onFreegamesResumed);
        this.on(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_GAMES_STARTED, this.onFreeGamesStarted);
        this.on(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_GAMES_REJECTED, this.onFreeGamesFinished);
        this.on(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_GAMES_POSTPONED, this.onFreeGamesFinished);
        this.on(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_GAMES_FINISHED, this.onFreeGamesFinished);
        this.on(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_GAME_EXPIRED, this.onFreeGamesFinished);
    };
    RecodeBetButtonModule.prototype.onFreeGamesFinished = function () {
        if (!this.hasFreeGames() && this._startscreenExitFinished) {
            this.enableBetButton();
            this.showBetButton();
        }
    };
    RecodeBetButtonModule.prototype.onStartScreenExitFinished = function () {
        this._startscreenExitFinished = true;
        if (!this.hasFreeGames()) {
            this.showBetButton();
        }
    };
    RecodeBetButtonModule.prototype.onFreeGamesStarted = function () {
        if (this.hasFreeGames()) {
            this.hideBetButton();
        }
    };
    RecodeBetButtonModule.prototype.onFreegamesResumed = function () {
        this.hideBetButton();
    };
    RecodeBetButtonModule.prototype.enableBetButton = function () {
        if (!this.logic.isInFreeRounds) {
            _super.prototype.enableBetButton.call(this);
        }
    };
    RecodeBetButtonModule.prototype.showBetButton = function () {
        if (!this.hasFreeGames()) {
            _super.prototype.showBetButton.call(this);
        }
    };
    RecodeBetButtonModule.prototype.hasFreeSpins = function () {
        return this.logic.freespinsTotalAwarded > 0;
    };
    RecodeBetButtonModule.prototype.hasFreeGames = function () {
        return this.logic.hasFreeGames();
    };
    return RecodeBetButtonModule;
}(BetButtonModule_1.BetButtonModule));
exports.RecodeBetButtonModule = RecodeBetButtonModule;


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var StopAutoplayButtonEvents_1 = __webpack_require__(30);
var FlowModuleEvents_1 = __webpack_require__(0);
var BetButtonBasicState = /** @class */ (function (_super) {
    __extends(BetButtonBasicState, _super);
    function BetButtonBasicState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BetButtonBasicState.prototype.onEnterState = function () {
        if (!this.module.autoPlayActive && this.module.startscreenExitFinished && !this.module.logic.isFreeSpinsStarted && !this.module.logic.isFreeSpinsJustWon()) {
            this.module.showBetButton();
        }
        this.module.enableBetButton();
    };
    BetButtonBasicState.prototype.onLeaveState = function () {
    };
    BetButtonBasicState.prototype.setupEvents = function () {
        this.on(FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN, this.onCanSpin);
        this.on(StopAutoplayButtonEvents_1.StopAutoplayButtonEvents.STOP_AUTOPLAY_BUTTON_CLICKED, this.onStopAutoplayButtonClicked);
    };
    BetButtonBasicState.prototype.onCanSpin = function () {
        if (this.module.isFreeSpins) {
            return;
        }
        if (!this.module.autoPlayActive && this.module.startscreenExitFinished) {
            this.module.showView();
            this.module.showBetButton();
        }
        this.module.enableBetButton();
    };
    BetButtonBasicState.prototype.onStopAutoplayButtonClicked = function () {
        this.module.autoPlayActive = false;
        this.module.showBetButton();
    };
    return BetButtonBasicState;
}(ModuleState_1.ModuleState));
exports.BetButtonBasicState = BetButtonBasicState;


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var BetButtonModule_1 = __webpack_require__(332);
var StopAutoplayButtonEvents_1 = __webpack_require__(30);
var FlowModuleEvents_1 = __webpack_require__(0);
var BetButtonWhileSpinningState = /** @class */ (function (_super) {
    __extends(BetButtonWhileSpinningState, _super);
    function BetButtonWhileSpinningState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BetButtonWhileSpinningState.prototype.onEnterState = function () {
        this.module.hideBetButton();
    };
    BetButtonWhileSpinningState.prototype.onLeaveState = function () {
    };
    BetButtonWhileSpinningState.prototype.setupEvents = function () {
        this.on(StopAutoplayButtonEvents_1.StopAutoplayButtonEvents.STOP_AUTOPLAY_BUTTON_CLICKED, this.onStopAutoplayClicked);
        this.on(FlowModuleEvents_1.FlowModuleEvents.CAN_SPIN, this.onCanSpin);
    };
    BetButtonWhileSpinningState.prototype.onCanSpin = function () {
        this.module.gotoState(BetButtonModule_1.BetButtonModule.BASIC);
    };
    BetButtonWhileSpinningState.prototype.onStopAutoplayClicked = function () {
        this.module.autoPlayActive = false;
    };
    return BetButtonWhileSpinningState;
}(ModuleState_1.ModuleState));
exports.BetButtonWhileSpinningState = BetButtonWhileSpinningState;


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var SwipeInteractionView_1 = __webpack_require__(667);
var GameReelConstants_1 = __webpack_require__(34);
var Tween_1 = __webpack_require__(19);
var Easing_1 = __webpack_require__(16);
var GameSwipeInteractionView = /** @class */ (function (_super) {
    __extends(GameSwipeInteractionView, _super);
    function GameSwipeInteractionView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameSwipeInteractionView.prototype.initializeInteraction = function () {
        this._reelContainer = new PIXI.Sprite(PIXI.Texture.EMPTY);
        this.container.addChild(this._reelContainer);
        this._interactiveContainerBasePositionY =
            GameReelConstants_1.GameReelConstants.getTopReelsOffsets().y;
        this.setupInteractiveContainer();
    };
    GameSwipeInteractionView.prototype.setupInteractiveContainer = function () {
        var reelBox = new PIXI.Graphics();
        reelBox.drawRect(0, 0, GameReelConstants_1.GameReelConstants.getAllReelsSize().width, GameReelConstants_1.GameReelConstants.getAllReelsSize().height);
        this._interactiveContainer = new PIXI.Sprite(reelBox.generateCanvasTexture());
        reelBox.destroy();
        this._interactiveContainer.height = GameReelConstants_1.GameReelConstants.getAllReelsSize().height;
        this.container.addChild(this._interactiveContainer);
        this._interactiveContainer.position.set(GameReelConstants_1.GameReelConstants.getTopReelsOffsets().x, this._interactiveContainerBasePositionY);
        if (this.device.isMobile) {
            this._interactiveContainer.on('touchstart', this.onDragStart.bind(this));
        }
        else {
            this._interactiveContainer.on('mousedown', this.onDragStart.bind(this));
        }
    };
    GameSwipeInteractionView.prototype.onDragMoveEvent = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var deltaY = event.data.global.y - this._startDragPointY;
        var newY = Math.max(Math.min(deltaY, SwipeInteractionView_1.SwipeInteractionView.MAX_Y_REEL_DRAG), SwipeInteractionView_1.SwipeInteractionView.MIN_Y_REEL_DRAG);
        this._interactiveContainer.y = this._interactiveContainerBasePositionY + newY;
        // container with symbols separated from the Mask
        this._reelContainer.children[0].children[0].children[1].y = newY;
        if (newY > SwipeInteractionView_1.SwipeInteractionView.DISTANCE_THRESHOLD) {
            this.emitStartSpinning();
            this.draggingFinished();
        }
    };
    GameSwipeInteractionView.prototype.resetPosition = function () {
        this._interactiveContainer.y = this._interactiveContainerBasePositionY;
        this._reelContainer.children[0].children[0].children[1].y = 0;
    };
    GameSwipeInteractionView.prototype.restoreContainerAnimated = function () {
        this._startDragPointX = null;
        this._startDragPointY = null;
        var restoreTween = new Tween_1.Tween(this._reelContainer.children[0].children[0].children[1].position)
            .to({ y: SwipeInteractionView_1.SwipeInteractionView.BASE_POSITON }, SwipeInteractionView_1.SwipeInteractionView.RESTORE_ANIMATION_DURATION)
            .easing(Easing_1.Easing.Back.Out)
            .start();
        this.updateManager.add(restoreTween);
        var restoreInteractionTween = new Tween_1.Tween(this._interactiveContainer.position)
            .to({ y: this._interactiveContainerBasePositionY }, SwipeInteractionView_1.SwipeInteractionView.RESTORE_ANIMATION_DURATION)
            .easing(Easing_1.Easing.Back.Out)
            .start();
        this.updateManager.add(restoreInteractionTween);
    };
    return GameSwipeInteractionView;
}(SwipeInteractionView_1.SwipeInteractionView));
exports.GameSwipeInteractionView = GameSwipeInteractionView;


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ReelConstants_1 = __webpack_require__(10);
var Tween_1 = __webpack_require__(19);
var Easing_1 = __webpack_require__(16);
var View_1 = __webpack_require__(3);
var SwipeInteractionViewEvents_1 = __webpack_require__(333);
var SwipeInteractionView = /** @class */ (function (_super) {
    __extends(SwipeInteractionView, _super);
    function SwipeInteractionView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._isDragging = false;
        _this._startTime = 0;
        return _this;
    }
    SwipeInteractionView.prototype.init = function () {
        _super.prototype.init.call(this);
        this.initializeInteraction();
    };
    SwipeInteractionView.prototype.initializeInteraction = function () {
        this._reelContainer = new PIXI.Sprite(PIXI.Texture.EMPTY);
        this.container.addChild(this._reelContainer);
        this._interactiveContainerBasePositionY =
            ReelConstants_1.ReelConstants.getReelsOffsets().y +
                (ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT - ReelConstants_1.ReelConstants.ROW_AMOUNT) * ReelConstants_1.ReelConstants.getSymbolSlot().height;
        this.setupInteractiveContainer();
    };
    SwipeInteractionView.prototype.forceStopDrag = function () {
        if (!this._isDragging) {
            return;
        }
        this.restoreContainerAnimated();
        this.draggingFinished();
    };
    SwipeInteractionView.prototype.resetPosition = function () {
        this._interactiveContainer.y = this._interactiveContainerBasePositionY;
        this._reelContainer.y = 0;
    };
    SwipeInteractionView.prototype.levelChanged = function (level) {
        var totalLevel = level + ReelConstants_1.ReelConstants.ROW_AMOUNT;
        this._interactiveContainer.height = totalLevel * ReelConstants_1.ReelConstants.getSymbolSlot().height;
        this._interactiveContainerBasePositionY =
            ReelConstants_1.ReelConstants.getReelsOffsets().y + (ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT - totalLevel) * ReelConstants_1.ReelConstants.getSymbolSlot().height;
        this._interactiveContainer.y = this._interactiveContainerBasePositionY;
    };
    Object.defineProperty(SwipeInteractionView.prototype, "dragReelToSpinActive", {
        set: function (value) {
            if (this._interactiveContainer) {
                this._dragReelToSpinActive = this._interactiveContainer.buttonMode = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SwipeInteractionView.prototype, "canDrag", {
        set: function (v) {
            if (this._interactiveContainer) {
                this._canDrag = this._interactiveContainer.interactive = v;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SwipeInteractionView.prototype, "reelContainer", {
        set: function (reelContainer) {
            this._reelContainer.addChild(reelContainer);
            this.setupInteractiveContainer();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SwipeInteractionView.prototype, "expandedWildsReelContainer", {
        set: function (reelContainer) {
            this._reelContainer.addChild(reelContainer);
            // this.setupInteractiveContainer();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SwipeInteractionView.prototype, "multiplierWildsReelContainer", {
        set: function (reelContainer) {
            this._reelContainer.addChild(reelContainer);
            // this.setupInteractiveContainer();
        },
        enumerable: true,
        configurable: true
    });
    SwipeInteractionView.prototype.setupInteractiveContainer = function () {
        // TODO: Decouple the whole SwipeInteraction system from reel. Separate into component.
        var reelBox = new PIXI.Graphics();
        reelBox.drawRect(0, 0, ReelConstants_1.ReelConstants.getSymbolSlot().width * ReelConstants_1.ReelConstants.REELS_AMOUNT, ReelConstants_1.ReelConstants.getSymbolSlot().height * ReelConstants_1.ReelConstants.MAX_ROW_AMOUNT);
        this._interactiveContainer = new PIXI.Sprite(reelBox.generateCanvasTexture());
        reelBox.destroy();
        this._interactiveContainer.height = ReelConstants_1.ReelConstants.ROW_AMOUNT * ReelConstants_1.ReelConstants.getSymbolSlot().height;
        this.container.addChild(this._interactiveContainer);
        this._interactiveContainer.position.set(ReelConstants_1.ReelConstants.getReelsOffsets().x, this._interactiveContainerBasePositionY);
        if (this.device.isMobile) {
            this._interactiveContainer.on('touchstart', this.onDragStart.bind(this));
        }
        else {
            this._interactiveContainer.on('mousedown', this.onDragStart.bind(this));
        }
    };
    SwipeInteractionView.prototype.onDragStart = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (!this._canDrag || !this._dragReelToSpinActive) {
            return;
        }
        this._startDragPointY = event.data.global.y;
        this._startDragPointX = event.data.global.x;
        this._startTime = event.data.originalEvent.timeStamp;
        if (this.device.isMobile) {
            this._interactiveContainer.on('touchend', this.onDragStop.bind(this));
            this._interactiveContainer.on('touchendoutside', this.onDragStop.bind(this));
            this._interactiveContainer.on('touchmove', this.onDragMoveEvent.bind(this));
        }
        else {
            this._interactiveContainer.on('mousemove', this.onDragMoveEvent.bind(this));
            this._interactiveContainer.on('rightup', this.onDragStop.bind(this));
            this._interactiveContainer.on('mouseup', this.onDragStop.bind(this));
            this._interactiveContainer.on('mouseout', this.onDragStop.bind(this));
        }
        this.draggingStarted(event);
    };
    SwipeInteractionView.prototype.onDragStop = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (!this._isDragging) {
            return;
        }
        var endY = event.data.global.y;
        // const deltaY = Math.abs(endY - this._startDragPointY); // For allowing both upwards and downwards moving.
        var deltaY = endY - this._startDragPointY;
        var endTime = event.data.originalEvent.timeStamp;
        var deltaTime = (endTime - this._startTime) * 0.001;
        if (deltaY / deltaTime >= SwipeInteractionView.ACCELERATION_THRESHOLD || deltaY > SwipeInteractionView.DISTANCE_THRESHOLD) {
            this.emitStartSpinning();
        }
        else {
            this.restoreContainerAnimated();
        }
        this.draggingFinished();
    };
    SwipeInteractionView.prototype.onCancelDrag = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (!this._isDragging) {
            return;
        }
        this.restoreContainerAnimated();
    };
    SwipeInteractionView.prototype.onDragMoveEvent = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var deltaY = event.data.global.y - this._startDragPointY;
        var newY = Math.max(Math.min(deltaY, SwipeInteractionView.MAX_Y_REEL_DRAG), SwipeInteractionView.MIN_Y_REEL_DRAG);
        this._interactiveContainer.y = this._interactiveContainerBasePositionY + newY;
        this._reelContainer.y = newY;
        if (newY > SwipeInteractionView.DISTANCE_THRESHOLD) {
            this.emitStartSpinning();
            this.draggingFinished();
        }
    };
    SwipeInteractionView.prototype.clearListeners = function () {
        if (this.device.isMobile) {
            this._interactiveContainer.removeListener('touchend');
            this._interactiveContainer.removeListener('touchendoutside');
            this._interactiveContainer.removeListener('touchmove');
        }
        else {
            this._interactiveContainer.removeListener('mousemove');
            this._interactiveContainer.removeListener('rightup');
            this._interactiveContainer.removeListener('mouseup');
            this._interactiveContainer.removeListener('mouseout');
        }
    };
    SwipeInteractionView.prototype.restoreContainerAnimated = function () {
        this._startDragPointX = null;
        this._startDragPointY = null;
        var restoreTween = new Tween_1.Tween(this._reelContainer.position)
            .to({ y: SwipeInteractionView.BASE_POSITON }, SwipeInteractionView.RESTORE_ANIMATION_DURATION)
            .easing(Easing_1.Easing.Back.Out)
            .start();
        this.updateManager.add(restoreTween);
        var restoreInteractionTween = new Tween_1.Tween(this._interactiveContainer.position)
            .to({ y: this._interactiveContainerBasePositionY }, SwipeInteractionView.RESTORE_ANIMATION_DURATION)
            .easing(Easing_1.Easing.Back.Out)
            .start();
        this.updateManager.add(restoreInteractionTween);
    };
    SwipeInteractionView.prototype.draggingStarted = function (event) {
        this._isDragging = true;
        this.emitDraggingStarted();
    };
    SwipeInteractionView.prototype.draggingFinished = function () {
        this.clearListeners();
        this._startDragPointX = null;
        this._startDragPointY = null;
        this.emitDraggingFinished();
    };
    SwipeInteractionView.prototype.emitDraggingStarted = function () {
        this.emit(SwipeInteractionViewEvents_1.SwipeInteractionViewEvents.DRAGGING_STARTED);
    };
    SwipeInteractionView.prototype.emitDraggingFinished = function () {
        this.emit(SwipeInteractionViewEvents_1.SwipeInteractionViewEvents.DRAGGING_FINISHED);
    };
    SwipeInteractionView.prototype.emitStartSpinning = function () {
        this.emit(SwipeInteractionViewEvents_1.SwipeInteractionViewEvents.START_SPIN);
    };
    SwipeInteractionView.prototype.cleanUpContainer = function () {
        if (this._interactiveContainer) {
            this._interactiveContainer.destroy();
        }
    };
    // TODO: Needs to check PPI / DPI
    SwipeInteractionView.MAX_Y_REEL_DRAG = 200;
    SwipeInteractionView.MIN_Y_REEL_DRAG = 0;
    SwipeInteractionView.BASE_POSITON = 0;
    SwipeInteractionView.RESTORE_ANIMATION_DURATION = 200;
    SwipeInteractionView.ACCELERATION_THRESHOLD = 1000; // Pixels per second needed to activate the spin.
    SwipeInteractionView.DISTANCE_THRESHOLD = 199; // Pixels per second needed to activate the spin.
    return SwipeInteractionView;
}(View_1.View));
exports.SwipeInteractionView = SwipeInteractionView;


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var SettingsViewEvents_1 = __webpack_require__(168);
var RecodeSettingsView_1 = __webpack_require__(669);
var GameSettingsView = /** @class */ (function (_super) {
    __extends(GameSettingsView, _super);
    function GameSettingsView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameSettingsView.prototype.setupSettingsViewComponents = function (previousSettings) {
        this.soundActive = previousSettings.soundActive;
        this.musicActive = previousSettings.musicActive;
        this.skipIntroActive = previousSettings.skipIntroActive;
        this.dragReelToSpinActive = previousSettings.dragReelToSpinActive;
        this.setupMainLayout();
        this.setupBackgroundBars();
        this.setupTextStyles();
        this.setupCheckboxes();
        this.setupText();
        this.setupCheckboxesEvents();
        this.translateCustom();
        this.musicActive ? this.emitMusicToggleOn() : this.emitMusicToggleOff();
        this.soundActive ? this.emitSoundToggleOn() : this.emitSoundToggleOff();
        this.skipIntroActive ? this.emitSkipIntroToggleOn() : this.emitSkipIntroToggleOff();
        this.dragReelToSpinActive ? this.emitDragReelsToSpinToggleOn() : this.emitDragReelsToSpinToggleOff();
    };
    GameSettingsView.prototype.translateCustom = function () {
        var musicText = this.translator.getObject('BaseStrings', 'generic', 'g_music') || 'MUSIC';
        this._musicText.text = musicText.toUpperCase();
        var soundText = this.translator.getObject('BaseStrings', 'generic', 'g_soundEffects') || 'SOUND EFFECTS';
        this._soundText.text = soundText.toUpperCase();
        var skipIntroText = this.translator.getObject('BaseStrings', 'generic', 'g_skipintro') || 'SKIP INTRO';
        this._skipIntroText.text = skipIntroText.toUpperCase();
        var dragReelToSpinText = this.translator.getObject('BaseStrings', 'generic', 'g_dragReelToSpin') || 'DRAG REEL TO SPIN';
        this._dragReelToSpinText.text = dragReelToSpinText.toUpperCase();
        if (dragReelToSpinText.length > 55) {
            this._dragReelToSpinText.style = this._specialDescriptionStyle;
            var baseSize = this._specialDescriptionStyle.fontSize;
            var baseLineHeight = this._specialDescriptionStyle.lineHeight;
            if (typeof baseSize === 'string') {
                baseSize = parseInt(baseSize, 10);
            }
            if (typeof baseLineHeight === 'string') {
                baseLineHeight = parseInt(baseLineHeight, 10);
            }
            if (dragReelToSpinText.length > 100) {
                this._specialDescriptionStyle.fontSize = baseSize * 0.65;
                this._specialDescriptionStyle.lineHeight = baseLineHeight * 0.65;
            }
            else if (dragReelToSpinText.length > 85) {
                this._specialDescriptionStyle.fontSize = baseSize * 0.75;
                this._specialDescriptionStyle.lineHeight = baseLineHeight * 0.75;
            }
            else if (dragReelToSpinText.length > 70) {
                this._specialDescriptionStyle.fontSize = baseSize * 0.8;
                this._specialDescriptionStyle.lineHeight = baseLineHeight * 0.8;
            }
            else if (dragReelToSpinText.length > 55) {
                this._specialDescriptionStyle.fontSize = baseSize * 0.9;
                this._specialDescriptionStyle.lineHeight = baseLineHeight * 0.9;
            }
        }
        this.setDescriptionLineBreak();
    };
    GameSettingsView.prototype.setupCheckboxes = function () {
        var yOffset = this._spineLayout.skeleton.findBone('SETTINGS_TITLE_TEXTS').data.y;
        var xOffset = 0;
        var spineName = 'SETTINGS_CONFIG_BUTTON.json';
        this._musicToggle = this.setupSettingCheckbox(spineName, 'SETTINGS_CONFIG_MUSIC', this.musicActive, xOffset, yOffset);
        this._soundToggle = this.setupSettingCheckbox(spineName, 'SETTINGS_CONFIG_SOUNDEFFECTS', this.soundActive, xOffset, yOffset);
        this._dragReelToSpinToggle = this.setupSettingCheckbox(spineName, 'SETTINGS_CONFIG_DRAGTOSPIN', this.dragReelToSpinActive, xOffset, yOffset);
        this._skipIntroToggle = this.setupSettingCheckbox(spineName, 'SETTINGS_CONFIG_SKIPINTRO', this.skipIntroActive, xOffset, yOffset);
    };
    GameSettingsView.prototype.setupText = function () {
        var yOffset = this._spineLayout.skeleton.findBone('SETTINGS_TITLE_TEXTS').data.y;
        var musicTextBone = this._spineLayout.skeleton.findSlot('SETTINGS_TEXT_MUSIC').bone.data;
        musicTextBone.x -= 200;
        this._musicText = this.setupSingleText('MUSIC', {
            name: 'SETTINGS_TEXT_MUSIC',
            bone: true,
        }, 0, yOffset, musicTextBone.x, null);
        this._soundText = this.setupSingleText('SOUND', { name: 'SETTINGS_TEXT_SOUNDEFFECTS', bone: true }, 0, yOffset, musicTextBone.x, null);
        if (this.device.desktop && this.resources.getLocale() === 'de') {
            this._dragReelToSpinText = this.setupSingleText('DRAG REELS TO SPIN', { name: 'SETTINGS_TEXT_DRAGTOSPIN', bone: true }, 0, yOffset, musicTextBone.x, null, this._specialGermanDesktopsStyle);
        }
        else {
            this._dragReelToSpinText = this.setupSingleText('DRAG REELS TO SPIN', { name: 'SETTINGS_TEXT_DRAGTOSPIN', bone: true }, 0, yOffset, musicTextBone.x, null);
        }
        this._skipIntroText = this.setupSingleText('SKIP INTRO', { name: 'SETTINGS_TEXT_SKIPINTRO', bone: true }, 0, yOffset, musicTextBone.x, null);
    };
    GameSettingsView.prototype.setupCheckboxesEvents = function () {
        this._musicToggle.interactive = this._musicToggle.buttonMode = true;
        this._soundToggle.interactive = this._soundToggle.buttonMode = true;
        this._skipIntroToggle.interactive = this._skipIntroToggle.buttonMode = true;
        this._dragReelToSpinToggle.interactive = this._dragReelToSpinToggle.buttonMode = true;
        this._musicToggle.on('touchstart', this.onMusicToggle.bind(this));
        this._soundToggle.on('touchstart', this.onSoundToggle.bind(this));
        this._skipIntroToggle.on('touchstart', this.onSkipIntroToggle.bind(this));
        this._dragReelToSpinToggle.on('touchstart', this.onDragReelToSpinToggle.bind(this));
        this._musicToggle.on('mousedown', this.onMusicToggle.bind(this));
        this._soundToggle.on('mousedown', this.onSoundToggle.bind(this));
        this._skipIntroToggle.on('mousedown', this.onSkipIntroToggle.bind(this));
        this._dragReelToSpinToggle.on('mousedown', this.onDragReelToSpinToggle.bind(this));
    };
    GameSettingsView.prototype.onDragReelToSpinToggle = function () {
        this._dragReelToSpinActive = this.toggleItem(this._dragReelToSpinActive, this._dragReelToSpinToggle, this.emitDragReelsToSpinToggleOn.bind(this), this.emitDragReelsToSpinToggleOff.bind(this));
    };
    GameSettingsView.prototype.emitDragReelsToSpinToggleOn = function () {
        this.emit(SettingsViewEvents_1.SettingsViewEvents.TOGGLE_DRAG_REEL_TO_SPIN_ON);
    };
    GameSettingsView.prototype.emitDragReelsToSpinToggleOff = function () {
        this.emit(SettingsViewEvents_1.SettingsViewEvents.TOGGLE_DRAG_REEL_TO_SPIN_OFF);
    };
    Object.defineProperty(GameSettingsView.prototype, "dragReelToSpinActive", {
        get: function () {
            return this._dragReelToSpinActive;
        },
        set: function (value) {
            this._dragReelToSpinActive = value;
        },
        enumerable: true,
        configurable: true
    });
    GameSettingsView.prototype.hideDragReelOption = function () {
        this._dragReelToSpinText.visible = false;
        this._dragReelToSpinToggle.visible = false;
    };
    return GameSettingsView;
}(RecodeSettingsView_1.RecodeSettingsView));
exports.GameSettingsView = GameSettingsView;


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var SettingsView_1 = __webpack_require__(670);
var GenericButton_1 = __webpack_require__(90);
var RecodeSettingsView = /** @class */ (function (_super) {
    __extends(RecodeSettingsView, _super);
    function RecodeSettingsView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RecodeSettingsView.prototype.init = function () {
        this._spacebarActive = false;
        _super.prototype.init.call(this);
    };
    RecodeSettingsView.prototype.setupSettingsViewComponents = function (previousSettings) {
        _super.prototype.setupSettingsViewComponents.call(this, previousSettings);
        this.setupButtonsGaming();
    };
    RecodeSettingsView.prototype.onResponsibleGamingPressed = function () {
        window.V.API.Core.launchResponsibleGaming();
    };
    RecodeSettingsView.prototype.onPlayForRealPressed = function () {
    };
    RecodeSettingsView.prototype.setupButtonsGaming = function () {
        var hasLinkToResponsibleGaming = window.V.API.Core.getCasinoConfig().featureConfig.responsibleGamingLink;
        if (hasLinkToResponsibleGaming) {
            var responsibleGamingButton = this.addSettingsMenuLongButton('SETTINGS_RESPONSIBLE_GAMING', 'SETTINGS_TITLE_TEXTS', this.onResponsibleGamingPressed);
            var responsibleText = this.translator.getObject('BaseStrings', 'generic', 'g_responsiblegaming') || 'RESPONSIBLE GAMING';
            responsibleGamingButton.changeText(responsibleText.toUpperCase());
            ////////////////////////////////////////////////////////////////////
            // According to Recode: Play for real button is unwanted on QF games.
            ////////////////////////////////////////////////////////////////////
            //
            // if ((window as any).V.API.Core.getCasinoState().player.isPracticePlay) {
            // 	this.addSettingsMenuLongButton('SETTINGS_PLAYFORREAL', 'SETTINGS_TITLE_TEXTS', this.onPlayForRealPressed);
            // 	const playForRealText: string = this.translator.getObject('BaseStrings', 'generic', 'g_playforreal') || 'PLAY FOR REAL';
            // 	responsibleGamingButton.changeText(playForRealText.toUpperCase());
            // }
            responsibleGamingButton.scaleTextToFitContainer(0.85);
        }
    };
    RecodeSettingsView.prototype.addSettingsMenuLongButton = function (containerBoneName, offsetBoneName, onPressedCallback) {
        var spriteButton = new PIXI.Sprite(this.resources.getSpritesheetTexture('HUD.json', 'LONG_BUTTON.png'));
        var bone = this._spineLayout.skeleton.findBone(containerBoneName).data;
        var button = new GenericButton_1.GenericButton(onPressedCallback.bind(this), this.textStyles.smallButtonBaseStyle);
        spriteButton.anchor.set(0.5, 0.5);
        button.setFrames(spriteButton);
        this.container.addChild(button);
        var yOffset = this._spineLayout.skeleton.findBone(offsetBoneName).data.y;
        this.setTransform(button, bone, 0, yOffset);
        return button;
    };
    RecodeSettingsView.prototype.setupCheckboxes = function () {
        var yOffset = this._spineLayout.skeleton.findBone('SETTINGS_TITLE_TEXTS').data.y;
        var xOffset = 0;
        var spineName = 'SETTINGS_CONFIG_BUTTON.json';
        this._musicToggle = this.setupSettingCheckbox(spineName, 'SETTINGS_CONFIG_MUSIC', this.musicActive, xOffset, yOffset);
        this._soundToggle = this.setupSettingCheckbox(spineName, 'SETTINGS_CONFIG_SOUNDEFFECTS', this.soundActive, xOffset, yOffset);
        this._skipIntroToggle = this.setupSettingCheckbox(spineName, 'SETTINGS_CONFIG_SKIPINTRO', this.skipIntroActive, xOffset, yOffset);
    };
    RecodeSettingsView.prototype.setupCheckboxesEvents = function () {
        this._musicToggle.interactive = this._musicToggle.buttonMode = true;
        this._soundToggle.interactive = this._soundToggle.buttonMode = true;
        this._skipIntroToggle.interactive = this._skipIntroToggle.buttonMode = true;
        this._musicToggle.on('mousedown', this.onMusicToggle.bind(this));
        this._soundToggle.on('mousedown', this.onSoundToggle.bind(this));
        this._skipIntroToggle.on('mousedown', this.onSkipIntroToggle.bind(this));
    };
    RecodeSettingsView.prototype.setupText = function () {
        var yOffset = this._spineLayout.skeleton.findBone('SETTINGS_TITLE_TEXTS').data.y;
        var musicTextBone = this._spineLayout.skeleton.findSlot('SETTINGS_TEXT_MUSIC').bone.data;
        musicTextBone.x -= 200;
        this._musicText = this.setupSingleText('MUSIC', {
            name: 'SETTINGS_TEXT_MUSIC',
            bone: true,
        }, 0, yOffset, musicTextBone.x, null);
        this._soundText = this.setupSingleText('SOUND', { name: 'SETTINGS_TEXT_SOUNDEFFECTS', bone: true }, 0, yOffset, musicTextBone.x, null);
        this._skipIntroText = this.setupSingleText('SKIP INTRO', { name: 'SETTINGS_TEXT_SKIPINTRO', bone: true }, 0, yOffset, musicTextBone.x, null);
    };
    return RecodeSettingsView;
}(SettingsView_1.SettingsView));
exports.RecodeSettingsView = RecodeSettingsView;


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var SpriteGraphics_1 = __webpack_require__(62);
var Spine_1 = __webpack_require__(25);
var AnimationNames_1 = __webpack_require__(154);
var View_1 = __webpack_require__(3);
var SettingsViewEvents_1 = __webpack_require__(168);
var SettingsView = /** @class */ (function (_super) {
    __extends(SettingsView, _super);
    function SettingsView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.backgroundColor = 0xd544fa;
        _this._musicActive = true;
        _this._soundActive = true;
        _this._spacebarActive = true;
        _this._skipIntroActive = true;
        _this._dragReelToSpinActive = true;
        return _this;
    }
    SettingsView.prototype.init = function () {
        _super.prototype.init.call(this);
        this.hideSettings();
    };
    SettingsView.prototype.hideDisabledSettings = function (settings) {
    };
    SettingsView.prototype.setupSettingsViewComponents = function (previousSettings) {
        this.soundActive = previousSettings.soundActive;
        this.musicActive = previousSettings.musicActive;
        this.skipIntroActive = previousSettings.skipIntroActive;
        this.spacebarActive = previousSettings.spacebarActive;
        this.setupMainLayout();
        this.setupBackgroundBars();
        this.setupTextStyles();
        this.setupCheckboxes();
        this.setupText();
        // this.setupSubtitlesTexts();
        this.setupCheckboxesEvents();
        this.translateCustom();
        this.musicActive ? this.emitMusicToggleOn() : this.emitMusicToggleOff();
        this.soundActive ? this.emitSoundToggleOn() : this.emitSoundToggleOff();
        this.skipIntroActive ? this.emitSkipIntroToggleOn() : this.emitSkipIntroToggleOff();
        this.spacebarActive ? this.emitSpacebarToggleOn() : this.emitSpacebarToggleOff();
    };
    SettingsView.prototype.showSettings = function () {
        this.container.visible = true;
    };
    SettingsView.prototype.hideSettings = function () {
        this.container.visible = false;
    };
    SettingsView.prototype.allSoundsOff = function () {
        this.onMusicToggle(null, true);
        this.onSoundToggle(null, true);
    };
    SettingsView.prototype.allSoundsOn = function () {
        this.onMusicToggle(null, false);
        this.onSoundToggle(null, false);
    };
    SettingsView.prototype.translateCustom = function () {
        var musicText = this.translator.getObject('BaseStrings', 'generic', 'g_music') || 'MUSIC';
        this._musicText.text = musicText.toUpperCase();
        var soundText = this.translator.getObject('BaseStrings', 'generic', 'g_soundEffects') || 'SOUND EFFECTS';
        this._soundText.text = soundText.toUpperCase();
        if (this._spacebarSpinText) {
            var spacebarSpinText = this.translator.getObject('BaseStrings', 'generic', 'g_spacebartospin') || 'SPACEBAR TO SPIN';
            this._spacebarSpinText.text = spacebarSpinText.toUpperCase();
        }
        var skipIntroText = this.translator.getObject('BaseStrings', 'generic', 'g_skipintro') || 'SKIP INTRO';
        this._skipIntroText.text = skipIntroText.toUpperCase();
        this.setDescriptionLineBreak();
    };
    SettingsView.prototype.setDescriptionLineBreak = function () {
        var leftX = this._musicText.getGlobalPosition().x;
        var rightX = this._musicToggle.getGlobalPosition().x - this._musicToggle.width / 2; // offset the end of the line to the start of the musictogglebutton. This assumes the musicToggle has an anchor set at 0.5.
        var distanceX = Math.abs(rightX - leftX);
        this._descriptionStyle.wordWrapWidth = distanceX;
        this._specialGermanDesktopsStyle.wordWrapWidth = distanceX;
        this._specialDescriptionStyle.wordWrapWidth = distanceX;
    };
    SettingsView.prototype.setupResponsibleGaming = function () { };
    SettingsView.prototype.setupTextStyles = function () {
        this._descriptionStyle = this.textStyles.settingsDescription;
        this._specialGermanDesktopsStyle = new PIXI.TextStyle({
            fontFamily: this.textStyles.settingsDescription.fontFamily,
            align: 'left',
            fontSize: 30,
            fill: '#ffe846',
            leading: 7,
            lineHeight: 0.95 * 30,
            letterSpacing: 0,
            wordWrap: true,
        });
        if (this.device.desktop && this.resources.getLocale() === 'de') {
            this._specialDescriptionStyle = new PIXI.TextStyle(this._specialGermanDesktopsStyle);
        }
        else {
            this._specialDescriptionStyle = new PIXI.TextStyle(this._descriptionStyle);
        }
    };
    SettingsView.prototype.setupMainLayout = function () {
        this._spineLayout = new Spine_1.Spine(this.resources.getSpine('SETTINGS_MENU.json'));
    };
    SettingsView.prototype.setupCheckboxes = function () {
        var yOffset = this._spineLayout.skeleton.findBone('SETTINGS_TITLE_TEXTS').data.y;
        var xOffset = 0;
        var spineName = 'SETTINGS_CONFIG_BUTTON.json';
        this._musicToggle = this.setupSettingCheckbox(spineName, 'SETTINGS_CONFIG_MUSIC', this.musicActive, xOffset, yOffset);
        this._soundToggle = this.setupSettingCheckbox(spineName, 'SETTINGS_CONFIG_SOUNDEFFECTS', this.soundActive, xOffset, yOffset);
        if (!this.device.isMobile) {
            this._spacebarSpinToggle = this.setupSettingCheckbox(spineName, 'SETTINGS_CONFIG_SPACEBAR', this.spacebarActive, xOffset, yOffset);
        }
        this._skipIntroToggle = this.setupSettingCheckbox(spineName, 'SETTINGS_CONFIG_SKIPINTRO', this.skipIntroActive, xOffset, yOffset);
    };
    SettingsView.prototype.setupSettingCheckbox = function (spineAnimation, referenceBoneName, isActive, xOffset, yOffset) {
        var itemReference = new Spine_1.Spine(this.resources.getSpine(spineAnimation));
        var itemReferenceBone = this._spineLayout.skeleton.findBone(referenceBoneName).data;
        this.container.addChild(itemReference);
        this.setTransform(itemReference, itemReferenceBone, xOffset, yOffset);
        itemReference.state.setAnimation(0, this.getToggleAnimation(isActive), false);
        itemReference.update(0);
        return itemReference;
    };
    SettingsView.prototype.setupText = function () {
        var yOffset = this._spineLayout.skeleton.findBone('SETTINGS_TITLE_TEXTS').data.y;
        var musicTextBone = this._spineLayout.skeleton.findSlot('SETTINGS_TEXT_MUSIC').bone.data;
        musicTextBone.x -= 200;
        this._musicText = this.setupSingleText('MUSIC', {
            name: 'SETTINGS_TEXT_MUSIC',
            bone: true,
        }, 0, yOffset, musicTextBone.x, null);
        this._soundText = this.setupSingleText('SOUND', { name: 'SETTINGS_TEXT_SOUNDEFFECTS', bone: true }, 0, yOffset, musicTextBone.x, null);
        if (this.device.desktop) {
            this._spacebarSpinText = this.setupSingleText('SPACEBAR TO SPIN', { name: 'SETTINGS_TEXT_SPACEBAR', bone: true }, 0, yOffset, musicTextBone.x, null);
        }
        this._skipIntroText = this.setupSingleText('SKIP INTRO', { name: 'SETTINGS_TEXT_SKIPINTRO', bone: true }, 0, yOffset, musicTextBone.x, null);
        if (this.device.isMobile && this._spacebarSpinText) {
            this._spacebarSpinText.visible = false;
        }
    };
    /*
    protected setupSubtitlesTexts(): void {
        const yOffset = this._spineLayout.skeleton.findBone('SETTINGS_TITLE_TEXTS').data.y;

        this._subtitleSoundText = new PIXI.Text('SOUND', this._subtitleStyle);
        this._subtitleSpinOptionsText = new PIXI.Text('OPTIONS', this._subtitleStyle);
        // Adds both the attachment (Slot) and bone position together.
        const subtitleSoundTextBone = this._spineLayout.skeleton.findSlot('BACKGROUND_SOLID_SOUND').bone.data;
        const subtitleSpinOptsTextBone = this._spineLayout.skeleton.findSlot('BACKGROUND_SOLID_SPINOPTIONS').bone.data;
        subtitleSoundTextBone.y += (this._spineLayout.skeleton.findSlot('BACKGROUND_SOLID_SOUND')
            .attachment as PIXI.spine.core.RegionAttachment).y;
        subtitleSpinOptsTextBone.y += (this._spineLayout.skeleton.findSlot('BACKGROUND_SOLID_SPINOPTIONS')
            .attachment as PIXI.spine.core.RegionAttachment).y;

        this.setTransform(this._subtitleSoundText, subtitleSoundTextBone, 0, yOffset);
        this.setTransform(this._subtitleSpinOptionsText, subtitleSpinOptsTextBone, 0, yOffset);

        this._subtitleSoundText.anchor.set(0.5, 0.5);
        this._subtitleSpinOptionsText.anchor.set(0.5, 0.5);

        this.container.addChild(this._subtitleSoundText);
        this.container.addChild(this._subtitleSpinOptionsText);
    }
*/
    SettingsView.prototype.setupSingleText = function (text, referenceSlot, xOffset, yOffset, boneX, boneY, style) {
        if (boneX === void 0) { boneX = null; }
        if (boneY === void 0) { boneY = null; }
        var currentStyle = style ? style : this._descriptionStyle;
        var textItem = new PIXI.Text(text, currentStyle);
        var textBone = null;
        // mixing bones and slots because the Spine file has inconsistencies in naming.
        if (referenceSlot.bone) {
            textBone = this._spineLayout.skeleton.findBone(referenceSlot.name).data;
        }
        else {
            textBone = this._spineLayout.skeleton.findSlot(referenceSlot.name).bone.data;
        }
        if (boneX) {
            textBone.x = boneX;
        }
        if (boneY) {
            textBone.y = boneY;
        }
        this.setTransform(textItem, textBone, xOffset, yOffset);
        textItem.anchor.set(0, 0.5);
        this.container.addChild(textItem);
        return textItem;
    };
    SettingsView.prototype.setupBackgroundBars = function () { };
    SettingsView.prototype.createBackgroundBar = function (spineLayout, spineSlot, oldSlot) {
        var bb1Data = spineLayout.skeleton.findSlot(spineSlot).attachment;
        var y1Offset = this.spineUtils.getBoneAbsolutePosition(this._spineLayout.skeleton.data, oldSlot).y;
        var bg1 = SpriteGraphics_1.SpriteGraphics.makeRectangle(bb1Data.width, bb1Data.height, this.backgroundColor, 1);
        this.setTransform(bg1, bb1Data, 0, y1Offset);
        bg1.anchor.set(0.5, 0.5);
        this.container.addChild(bg1);
    };
    SettingsView.prototype.setTransform = function (baseobject, newTransformdata, extraOffsetX, extraOffsetY) {
        if (extraOffsetX === void 0) { extraOffsetX = 0; }
        if (extraOffsetY === void 0) { extraOffsetY = 0; }
        var resolutionHeight = this.resolutionManager.resolution.height;
        var centerScreenX = this.resolutionManager.halfResolution.width;
        var centerScreenY = this.resolutionManager.halfResolution.height;
        var xPosition = centerScreenX + newTransformdata.x + extraOffsetX;
        var yPosition = resolutionHeight - (centerScreenY + newTransformdata.y + extraOffsetY);
        baseobject.setTransform(xPosition, yPosition, newTransformdata.scaleX, newTransformdata.scaleY);
    };
    SettingsView.prototype.setupCheckboxesEvents = function () {
        this._musicToggle.interactive = this._musicToggle.buttonMode = true;
        this._soundToggle.interactive = this._soundToggle.buttonMode = true;
        this._skipIntroToggle.interactive = this._skipIntroToggle.buttonMode = true;
        if (this.device.isMobile) {
            this._musicToggle.on('touchstart', this.onMusicToggle.bind(this));
            this._soundToggle.on('touchstart', this.onSoundToggle.bind(this));
            this._skipIntroToggle.on('touchstart', this.onSkipIntroToggle.bind(this));
        }
        else {
            this._spacebarSpinToggle.interactive = this._spacebarSpinToggle.buttonMode = true;
            this._musicToggle.on('mousedown', this.onMusicToggle.bind(this));
            this._soundToggle.on('mousedown', this.onSoundToggle.bind(this));
            this._spacebarSpinToggle.on('mousedown', this.onSpacebarToggle.bind(this));
            this._skipIntroToggle.on('mousedown', this.onSkipIntroToggle.bind(this));
        }
    };
    SettingsView.prototype.toggleItem = function (bool, spineToggle, emitOn, emitOff) {
        if (bool) {
            emitOff();
        }
        else {
            emitOn();
        }
        spineToggle.state.setAnimation(0, this.getToggleAnimation(!bool), true);
        spineToggle.update(0);
        return !bool;
    };
    SettingsView.prototype.onSpacebarToggle = function () {
        this._spacebarActive = this.toggleItem(this._spacebarActive, this._spacebarSpinToggle, this.emitSpacebarToggleOn.bind(this), this.emitSpacebarToggleOff.bind(this));
    };
    SettingsView.prototype.onSkipIntroToggle = function () {
        this._skipIntroActive = this.toggleItem(this._skipIntroActive, this._skipIntroToggle, this.emitSkipIntroToggleOn.bind(this), this.emitSkipIntroToggleOff.bind(this));
    };
    SettingsView.prototype.onSoundToggle = function (event, active) {
        if (active === void 0) { active = this._soundActive; }
        if (this._soundToggle) {
            this._soundActive = this.toggleItem(active, this._soundToggle, this.emitSoundToggleOn.bind(this), this.emitSoundToggleOff.bind(this));
        }
    };
    SettingsView.prototype.onMusicToggle = function (event, active) {
        if (active === void 0) { active = this._musicActive; }
        if (this._musicToggle) {
            this._musicActive = this.toggleItem(active, this._musicToggle, this.emitMusicToggleOn.bind(this), this.emitMusicToggleOff.bind(this));
        }
    };
    SettingsView.prototype.emitMusicToggleOff = function () {
        this.emit(SettingsViewEvents_1.SettingsViewEvents.TOGGLE_MUSIC_OFF);
    };
    SettingsView.prototype.emitSoundToggleOff = function () {
        this.emit(SettingsViewEvents_1.SettingsViewEvents.TOGGLE_SOUND_OFF);
    };
    SettingsView.prototype.emitQuickspinToggleOff = function () {
        this.emit(SettingsViewEvents_1.SettingsViewEvents.TOGGLE_QUICKSPIN_OFF);
    };
    SettingsView.prototype.emitSkipIntroToggleOff = function () {
        this.emit(SettingsViewEvents_1.SettingsViewEvents.TOGGLE_SKIP_INTRO_OFF);
    };
    SettingsView.prototype.emitSkipIntroToggleOn = function () {
        this.emit(SettingsViewEvents_1.SettingsViewEvents.TOGGLE_SKIP_INTRO_ON);
    };
    SettingsView.prototype.emitSpacebarToggleOff = function () {
        this.emit(SettingsViewEvents_1.SettingsViewEvents.TOGGLE_SPACEBAR_OFF);
    };
    SettingsView.prototype.emitFastPlayToggleOff = function () {
        this.emit(SettingsViewEvents_1.SettingsViewEvents.TOGGLE_FAST_PLAY_OFF);
    };
    SettingsView.prototype.emitMusicToggleOn = function () {
        this.emit(SettingsViewEvents_1.SettingsViewEvents.TOGGLE_MUSIC_ON);
    };
    SettingsView.prototype.emitSoundToggleOn = function () {
        this.emit(SettingsViewEvents_1.SettingsViewEvents.TOGGLE_SOUND_ON);
    };
    SettingsView.prototype.emitQuickspinToggleOn = function () {
        this.emit(SettingsViewEvents_1.SettingsViewEvents.TOGGLE_QUICKSPIN_ON);
    };
    SettingsView.prototype.emitSpacebarToggleOn = function () {
        this.emit(SettingsViewEvents_1.SettingsViewEvents.TOGGLE_SPACEBAR_ON);
    };
    SettingsView.prototype.emitFastPlayToggleOn = function () {
        this.emit(SettingsViewEvents_1.SettingsViewEvents.TOGGLE_FAST_PLAY_ON);
    };
    SettingsView.prototype.getToggleAnimation = function (isActive) {
        return isActive ? AnimationNames_1.AnimationNames.SETTINGS_CONFIG_TOGGLE.Name.ACTIVE : AnimationNames_1.AnimationNames.SETTINGS_CONFIG_TOGGLE.Name.INACTIVE;
    };
    Object.defineProperty(SettingsView.prototype, "musicActive", {
        get: function () {
            return this._musicActive;
        },
        set: function (value) {
            this._musicActive = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SettingsView.prototype, "soundActive", {
        get: function () {
            return this._soundActive;
        },
        set: function (value) {
            this._soundActive = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SettingsView.prototype, "spacebarActive", {
        get: function () {
            return this._spacebarActive;
        },
        set: function (value) {
            this._spacebarActive = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SettingsView.prototype, "skipIntroActive", {
        get: function () {
            return this._skipIntroActive;
        },
        set: function (value) {
            this._skipIntroActive = value;
        },
        enumerable: true,
        configurable: true
    });
    return SettingsView;
}(View_1.View));
exports.SettingsView = SettingsView;


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var RecodeGameAutoplayHandlerModule_1 = __webpack_require__(672);
var GameAutoplayHandlerModule = /** @class */ (function (_super) {
    __extends(GameAutoplayHandlerModule, _super);
    function GameAutoplayHandlerModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameAutoplayHandlerModule.prototype.onSpinEnded = function () {
        var logic = this.logic;
        if (this._isEnabled) {
            this._totalAutoplayWin += logic.getTransTotalWin();
            this._winAmount = logic.getTransTotalWin();
        }
    };
    GameAutoplayHandlerModule.prototype.bigWinUpdate = function () {
        var logic = this.logic;
        this._isWinBigWin = true;
        this._totalAutoplayWin += logic.getTransTotalWin();
        this._winAmount = logic.getTransTotalWin();
    };
    GameAutoplayHandlerModule.prototype.winUpdate = function () {
        var logic = this.logic;
        if (!this._isWinBigWin) {
            this._totalAutoplayWin += logic.getTransTotalWin();
            this._winAmount = logic.getTransTotalWin();
        }
        else {
            this._isWinBigWin = false;
        }
    };
    return GameAutoplayHandlerModule;
}(RecodeGameAutoplayHandlerModule_1.RecodeGameAutoplayHandlerModule));
exports.GameAutoplayHandlerModule = GameAutoplayHandlerModule;


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var RecodeEvents_1 = __webpack_require__(79);
var AutoplayHandlerEvents_1 = __webpack_require__(56);
var AutoplayHandlerModule_1 = __webpack_require__(81);
var FreeRoundsScreenEvents_1 = __webpack_require__(46);
var ReelsEvents_1 = __webpack_require__(4);
var RecodeGameAutoplayHandlerModuleEvents_1 = __webpack_require__(323);
var RecodeAutoplayBasicState_1 = __webpack_require__(673);
var IAutoPlayWagerLimitReason;
(function (IAutoPlayWagerLimitReason) {
    /**
     * No limits have been exceeded.
     */
    IAutoPlayWagerLimitReason["none"] = "none";
    /**
     * Spin count limit reached
     */
    IAutoPlayWagerLimitReason["spinCount"] = "spinCount";
    /**
     * Loss limit reached
     */
    IAutoPlayWagerLimitReason["lossLimit"] = "lossLimit";
    /**
     * Win limit reached
     */
    IAutoPlayWagerLimitReason["winLimit"] = "winLimit";
})(IAutoPlayWagerLimitReason = exports.IAutoPlayWagerLimitReason || (exports.IAutoPlayWagerLimitReason = {}));
var RecodeGameAutoplayHandlerModule = /** @class */ (function (_super) {
    __extends(RecodeGameAutoplayHandlerModule, _super);
    function RecodeGameAutoplayHandlerModule() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._isEnabled = false;
        return _this;
    }
    RecodeGameAutoplayHandlerModule.prototype.setupStates = function () {
        _super.prototype.setupStates.call(this);
        this.addState(new RecodeAutoplayBasicState_1.RecodeAutoplayBasicState(this, AutoplayHandlerModule_1.AutoplayHandlerModule.BASIC));
    };
    RecodeGameAutoplayHandlerModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(RecodeEvents_1.RecodeEvents.SHOWING_ERROR, this.onShowingErrorDialog);
        this.on(RecodeEvents_1.RecodeEvents.SERVER_AUTOPLAY_INTERRUPT, this.onServerInterruptAutoplay);
        this.on(FreeRoundsScreenEvents_1.FreeRoundsScreenEvents.FREE_ROUNDS_SCREEN_SHOWN, this.onFreeRoundsScreenShow);
        this.on(ReelsEvents_1.ReelsEvents.SPIN_ENDED, this.onSpinEnded);
        this._useWagerLimitAPI = window.V.API.Autoplay.getConfig().useWagerLimitApi;
    };
    RecodeGameAutoplayHandlerModule.prototype.onFreeRoundsScreenShow = function () {
        this.stopAutoplayAndEmitRoundsFinished();
    };
    RecodeGameAutoplayHandlerModule.prototype.getLogic = function () {
        return this.logic;
    };
    RecodeGameAutoplayHandlerModule.prototype.initVAPIAutoplay = function () {
        var options = {
            spins: this._autospinsLeft,
            selectedCoinSize: this.getLogic().chipSize,
            coinSizeOptions: this.getLogic().validChips,
            selectedBetSize: this.getLogic().betValue,
            selectedCoinsBet: this.getLogic().numChips,
            betSizeOptions: this.getLogic().betValues,
            numPaylines: this.getLogic().paylines,
        };
        if (this.logic.autoplayData.winLimitEnabled) {
            options.winLimit = this._winLimit || 0;
        }
        if (this.logic.autoplayData.lossLimitEnabled) {
            options.lossLimit = this._lossLimit || 0;
        }
        var startCallback = function () {
            // This should only be used if we don't use our own implementation of the Autoplay API from V.
            // console.warn('Autoplay has started.');
        };
        var cancelCallback = function () {
            // This should only be used if we don't use our own implementation of the Autoplay API from V.
            // console.warn('Autoplay menu has been canceled.');
        };
        var context = this;
        window.V.API.Autoplay.init(options, startCallback, cancelCallback, context);
    };
    /**
     * Verifies the wager limits and current values using V WagerLimitAPI. Sets the result to member variable currentVerifyWagerResults
     */
    RecodeGameAutoplayHandlerModule.prototype.verifyWagerLimits = function () {
        var verifyWagerParameters = this.wagerLimitParameters;
        this._currentVerifyWagerAPIResults = window.V.API.Autoplay.verifyWagerLimits(verifyWagerParameters);
    };
    /**
     * Checks if autoplay should stop on wagerlimits.
     *
     * @protected
     * @returns {boolean}
     * @memberof RecodeGameAutoplayHandlerModule
     */
    RecodeGameAutoplayHandlerModule.prototype.shouldStopOnWagerLimits = function () {
        if (this._useWagerLimitAPI) {
            this.verifyWagerLimits();
            return this.currentVerifyWagerAPIResults.autoPlayLimitReached;
        }
        return false;
    };
    RecodeGameAutoplayHandlerModule.prototype.stopOnWagerLimits = function () {
        this.stopAutoplayAndEmitRoundsFinished();
        this.sendAutoplayMessage(this.currentVerifyWagerAPIResults.messageText, this.currentVerifyWagerAPIResults.limit);
    };
    RecodeGameAutoplayHandlerModule.prototype.isLastFreeGame = function () {
        var logic = this.logic;
        if (logic.currentFreeGameProgress && logic.currentFreeGameProgress.gamesRemaining === 0) {
            return true;
        }
        return false;
    };
    RecodeGameAutoplayHandlerModule.prototype.tryToStartAutoplay = function () {
        if (this.isFreeSpinsStarted()) {
            throw new Error('RecodeGameAutoplayHandlerModule::tryToStartAutoplay impossible condition');
        }
        if (this.shouldStopOnWagerLimits()) {
            this.stopOnWagerLimits();
            return;
        }
        if (this.isLastFreeGame()) {
            return;
        }
        this.logic.communicator.api_autoPlayStarted();
        _super.prototype.tryToStartAutoplay.call(this);
    };
    /**
     * this is really shitty fix, but it's hard to find another
     */
    RecodeGameAutoplayHandlerModule.prototype.forceStartAutoplay = function () {
        if (this.shouldStopOnWagerLimits()) {
            this.stopOnWagerLimits();
            return;
        }
        this.logic.communicator.api_autoPlayStarted();
        _super.prototype.tryToStartAutoplay.call(this);
    };
    RecodeGameAutoplayHandlerModule.prototype.stopAutoplay = function () {
        if (this._isEnabled) {
            this.timeUtils.killTimer(this._currentTimer);
            this.eventManager.emit(AutoplayHandlerEvents_1.AutoplayHandlerEvents.AUTOPLAY_STOPPED);
            this._isEnabled = false;
            this.logic.communicator.api_autoPlayStopped();
        }
    };
    RecodeGameAutoplayHandlerModule.prototype.onSpinEnded = function () {
        if (this._isEnabled) {
            this._totalAutoplayWin += this.logic.getWin();
            this._winAmount = this.logic.getWin();
        }
    };
    RecodeGameAutoplayHandlerModule.prototype.onBigWin = function () { };
    RecodeGameAutoplayHandlerModule.prototype.onWin = function () { };
    // Recieves the autoplayInterrupt struct
    // If the interrupt message (currently: args[1][0][1]) isn't undefined send message to info popup.
    RecodeGameAutoplayHandlerModule.prototype.onServerInterruptAutoplay = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this._isEnabled = true;
        this.stopAutoplay();
        if (!!args[1][0][1]) {
            this.sendAutoplayMessage(args[1][0][1]);
        }
        this.onAutoplayValuesUpdated(null, {
            singleWinLimit: 0,
            winLimit: 0,
            lossLimit: 0,
            stopAutoplayOnWin: false,
        });
        this.eventManager.emit(AutoplayHandlerEvents_1.AutoplayHandlerEvents.AUTOPLAY_ROUNDS_FINISHED);
    };
    RecodeGameAutoplayHandlerModule.prototype.onShowingErrorDialog = function () {
        this.stopAutoplay();
    };
    RecodeGameAutoplayHandlerModule.prototype.sendAutoplayMessage = function (message, reason) {
        this.eventManager.emit(RecodeGameAutoplayHandlerModuleEvents_1.RecodeGameAutoplayHandlerModuleEvents.RECODE_AUTOPLAY_SHOW_POPUP, message, reason);
    };
    RecodeGameAutoplayHandlerModule.prototype.winLimitStartCheck = function () {
        return this._stopOnWinLimit && this.logic.autoplayData.winLimitsAmounts.indexOf(this._winLimit) === -1;
    };
    RecodeGameAutoplayHandlerModule.prototype.lossLimitStartCheck = function () {
        return this._stopOnLossLimit && this.logic.autoplayData.lossLimitsAmounts.indexOf(this._lossLimit) === -1;
    };
    Object.defineProperty(RecodeGameAutoplayHandlerModule.prototype, "currentVerifyWagerAPIResults", {
        get: function () {
            return this._currentVerifyWagerAPIResults;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecodeGameAutoplayHandlerModule.prototype, "wagerLimitParameters", {
        get: function () {
            return { nextBetAmount: this.logic.betValue, previousWinAmount: this._winAmount, isTriggeredEffect: false };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RecodeGameAutoplayHandlerModule.prototype, "useWagerLimitAPI", {
        get: function () {
            return this._useWagerLimitAPI;
        },
        enumerable: true,
        configurable: true
    });
    return RecodeGameAutoplayHandlerModule;
}(AutoplayHandlerModule_1.AutoplayHandlerModule));
exports.RecodeGameAutoplayHandlerModule = RecodeGameAutoplayHandlerModule;


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var AutoplayBasicState_1 = __webpack_require__(321);
var AutoplayHandlerModule_1 = __webpack_require__(81);
var RecodeAutoplayBasicState = /** @class */ (function (_super) {
    __extends(RecodeAutoplayBasicState, _super);
    function RecodeAutoplayBasicState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RecodeAutoplayBasicState.prototype.onAutoPlaySettingsAccepted = function (eventId, spinsLeft) {
        if (!this.module.logic.autoplayData) {
            throw new Error('RecodeGameAutoplayHandlerModule::onAutoPlaySettingsAccepted this.logic.autoplayData is not initialized');
        }
        var recodeModule = this.module;
        recodeModule.startAutospins = recodeModule.autospinsLeft = spinsLeft;
        if (recodeModule.winLimitStartCheck() || recodeModule.lossLimitStartCheck()) {
            recodeModule.stopAutoplayAndEmitRoundsFinished();
            return;
        }
        if (recodeModule.canSpin) {
            recodeModule.winAmount = 0;
            //if (recodeModule.useWagerLimitAPI) {
            recodeModule.initVAPIAutoplay();
            //}
            recodeModule.tryToStartAutoplay();
        }
        else {
            recodeModule.isWaitingForSpinToFinish = true;
        }
        this.module.logic.lastAutoplayAmount = spinsLeft;
        this.module.gotoState(AutoplayHandlerModule_1.AutoplayHandlerModule.IN_PROGRESS);
    };
    return RecodeAutoplayBasicState;
}(AutoplayBasicState_1.AutoplayBasicState));
exports.RecodeAutoplayBasicState = RecodeAutoplayBasicState;


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var SwipeInteractionModule_1 = __webpack_require__(675);
var GameBackgroundModule_1 = __webpack_require__(93);
var GameSwipeInteractionModule = /** @class */ (function (_super) {
    __extends(GameSwipeInteractionModule, _super);
    function GameSwipeInteractionModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameSwipeInteractionModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(GameBackgroundModule_1.GameBackgroundModule.TRANSITION_ANIMATION_STARTED, this.onTransitionAnimationStarted);
    };
    GameSwipeInteractionModule.prototype.onTransitionAnimationStarted = function () {
        this.enableDrag();
    };
    return GameSwipeInteractionModule;
}(SwipeInteractionModule_1.SwipeInteractionModule));
exports.GameSwipeInteractionModule = GameSwipeInteractionModule;


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Module_1 = __webpack_require__(2);
var Views_1 = __webpack_require__(8);
var FlowModuleEvents_1 = __webpack_require__(0);
var SpinButtonEvents_1 = __webpack_require__(12);
var AvalancheReelsEvents_1 = __webpack_require__(15);
var ReelsEvents_1 = __webpack_require__(4);
var SwipeInteractionEvents_1 = __webpack_require__(65);
var SwipeInteractionViewEvents_1 = __webpack_require__(333);
var InfoPopupEvents_1 = __webpack_require__(63);
var InfoPopupTypes_1 = __webpack_require__(74);
var SettingsEvents_1 = __webpack_require__(95);
var FreeSpinsEvents_1 = __webpack_require__(6);
/**
 * handling of swipe interaction from user - starts spinning
 */
var SwipeInteractionModule = /** @class */ (function (_super) {
    __extends(SwipeInteractionModule, _super);
    function SwipeInteractionModule() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._isAutoSpinning = false;
        _this._isSwipeSpin = false;
        _this._isBonusGame = false;
        _this._isFreeSpins = false;
        _this._canSpin = true;
        return _this;
    }
    SwipeInteractionModule.prototype.setupStates = function () {
    };
    SwipeInteractionModule.prototype.enterFirstState = function () {
    };
    SwipeInteractionModule.prototype.setupViews = function () {
        if (this.system.shouldUseMultipleViews()) {
            this.setView(Views_1.Views.SWIPE_INTERACTION_VIEW_MOBILE);
        }
        else {
            this.setView(Views_1.Views.SWIPE_INTERACTION_VIEW);
        }
    };
    SwipeInteractionModule.prototype.init = function () {
        _super.prototype.init.call(this);
        this.isDragSettingActive = this.logic.dragReelToSpinActive;
    };
    SwipeInteractionModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(ReelsEvents_1.ReelsEvents.ALL_REELS_STOPPED, this.onAllReelsStopped);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_INTRO_STARTED, this.onFreeSpinStarted);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_OUTRO_FINISHED, this.onFreeSpinFinished);
        this.on(SpinButtonEvents_1.SpinButtonEvents.SPIN_BUTTON_BECOMING_VISIBLE_AND_ENABLED, this.onCanSpin);
        this.on(FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_WON, this.onBonusGameWon);
        this.on(FlowModuleEvents_1.FlowModuleEvents.BONUS_GAME_END, this.onBonusGameEnd);
        this.on(SpinButtonEvents_1.SpinButtonEvents.SPIN_BUTTON_PRESSED, this.onSpinButtonPressed);
        this.on(SpinButtonEvents_1.SpinButtonEvents.STOP_AUTOPLAY_BUTTON_PRESSED, this.onStopAutoplayButtonPressed);
        this.on(SpinButtonEvents_1.SpinButtonEvents.START_AUTOPLAY_BUTTON_PRESSED, this.onStartAutoplayButtonPressed);
        this.on(SpinButtonEvents_1.SpinButtonEvents.SPIN_PRESSED_NOT_ENOUGH_MONEY, this.onNotEnoughMoney);
        this.onView(SwipeInteractionViewEvents_1.SwipeInteractionViewEvents.START_SPIN, this.emitStartSpin);
        this.onViewEmitEvent(SwipeInteractionViewEvents_1.SwipeInteractionViewEvents.DRAGGING_STARTED, SwipeInteractionEvents_1.SwipeInteractionEvents.DRAGGING_STARTED);
        this.onViewEmitEvent(SwipeInteractionViewEvents_1.SwipeInteractionViewEvents.DRAGGING_FINISHED, SwipeInteractionEvents_1.SwipeInteractionEvents.DRAGGING_FINISHED);
        this.on(InfoPopupEvents_1.InfoPopupEvents.INFO_POPUP_CLOSED, this.onInfoPopupClosed);
        this.on(AvalancheReelsEvents_1.AvalancheReelsEvents.ALL_REELS_DROP_OUT_FINISHED, this.onAllReelsDropOutFinished);
        this.on(SettingsEvents_1.SettingsEvents.TOGGLE_DRAG_REEL_TO_SPIN_OFF, this.onSettingsToggleDragReelOff);
        this.on(SettingsEvents_1.SettingsEvents.TOGGLE_DRAG_REEL_TO_SPIN_ON, this.onSettingsToggleDragReelOn);
    };
    SwipeInteractionModule.prototype.restore = function () {
        _super.prototype.restore.call(this);
        if (this.logic.isFreeSpinsStarted) {
            this._isFreeSpins = true;
            this.disableDrag();
        }
    };
    SwipeInteractionModule.prototype.onFreeSpinStarted = function () {
        this._isFreeSpins = true;
        this.disableDrag();
    };
    SwipeInteractionModule.prototype.onFreeSpinFinished = function () {
        this._isFreeSpins = false;
        if (this.isAutoSpinning && this._isDragSettingActive) {
            return;
        }
        if (this._canSpin) {
            this.enableDrag();
        }
    };
    SwipeInteractionModule.prototype.onSettingsToggleDragReelOff = function () {
        this.view.dragReelToSpinActive = false;
    };
    SwipeInteractionModule.prototype.onSettingsToggleDragReelOn = function () {
        this.view.dragReelToSpinActive = true;
    };
    SwipeInteractionModule.prototype.onBonusGameWon = function () {
        this._isBonusGame = true;
    };
    SwipeInteractionModule.prototype.onBonusGameEnd = function () {
        this._isBonusGame = false;
    };
    SwipeInteractionModule.prototype.onInfoPopupClosed = function (eventId, eventType) {
        if (eventType === InfoPopupTypes_1.InfoPopupTypes.NO_MONEY) {
            this.enableDrag();
        }
        else if (eventType === InfoPopupTypes_1.InfoPopupTypes.RESTORE) {
            this.disableDrag();
        }
    };
    SwipeInteractionModule.prototype.onNotEnoughMoney = function () {
        this.disableDrag();
        if (this.isSwipeSpin) {
            this.view.resetPosition();
            this.isSwipeSpin = false;
        }
    };
    SwipeInteractionModule.prototype.onAllReelsDropOutFinished = function () {
        if (this.isSwipeSpin) {
            this.view.resetPosition();
            this.isSwipeSpin = false;
        }
    };
    SwipeInteractionModule.prototype.onAllReelsStopped = function () {
    };
    SwipeInteractionModule.prototype.updateLevel = function () {
    };
    SwipeInteractionModule.prototype.onCanSpin = function () {
        this._canSpin = true;
        if (this.isAutoSpinning && this._isDragSettingActive) {
            return;
        }
        this.enableDrag();
    };
    SwipeInteractionModule.prototype.onStartAutoplayButtonPressed = function () {
        this.isAutoSpinning = true;
        this.disableDrag();
    };
    SwipeInteractionModule.prototype.onStopAutoplayButtonPressed = function () {
        this.isAutoSpinning = false;
        if (!this._isBonusGame && this._canSpin) {
            this.enableDrag();
        }
    };
    SwipeInteractionModule.prototype.onSpinButtonPressed = function () {
        this.disableDrag();
    };
    SwipeInteractionModule.prototype.enableDrag = function () {
        if (!this._isFreeSpins) {
            this.view.canDrag = true;
        }
    };
    SwipeInteractionModule.prototype.disableDrag = function () {
        this._canSpin = false;
        if (!this.isSwipeSpin) {
            this.view.forceStopDrag();
        }
        this.view.canDrag = false;
    };
    SwipeInteractionModule.prototype.emitStartSpin = function () {
        this.disableDrag();
        this.isSwipeSpin = true;
        this.eventManager.emit(SwipeInteractionEvents_1.SwipeInteractionEvents.START_SPIN);
    };
    Object.defineProperty(SwipeInteractionModule.prototype, "isAutoSpinning", {
        get: function () {
            return this._isAutoSpinning;
        },
        set: function (value) {
            this._isAutoSpinning = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SwipeInteractionModule.prototype, "isSwipeSpin", {
        get: function () {
            return this._isSwipeSpin;
        },
        set: function (value) {
            this._isSwipeSpin = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SwipeInteractionModule.prototype, "isDragSettingActive", {
        get: function () {
            return this._isDragSettingActive;
        },
        set: function (value) {
            this._isDragSettingActive = this.view.dragReelToSpinActive = value;
        },
        enumerable: true,
        configurable: true
    });
    return SwipeInteractionModule;
}(Module_1.Module));
exports.SwipeInteractionModule = SwipeInteractionModule;


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var FreeRoundsScreenView_1 = __webpack_require__(100);
var SpineAnimation_1 = __webpack_require__(37);
var Spine_1 = __webpack_require__(25);
var GameFreeRoundsScreenView = /** @class */ (function (_super) {
    __extends(GameFreeRoundsScreenView, _super);
    function GameFreeRoundsScreenView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameFreeRoundsScreenView.prototype.showMenuAnimation = function (animationName, loop, stopOnComplete) {
        var _this = this;
        if (stopOnComplete === void 0) { stopOnComplete = true; }
        if (this._mainAnimation) {
            this.spineUtils.stopAndDestroyAnimation(this._mainAnimation);
        }
        var spine = new Spine_1.Spine(this.resources.getSpine('FREE-GAMES_SCREENS.json'));
        this.setupElements(spine);
        this._mainAnimation = new SpineAnimation_1.SpineAnimation(spine, animationName, loop, true);
        this._mainAnimation.container.position.set(this.resolutionManager.halfResolution.width, this.resolutionManager.halfResolution.height);
        var textureName = this.getTextureName();
        this.spineUtils.replaceElementInSpine(spine, 'GAME_LOGOTYPE', new PIXI.Sprite(this.resources.getTexture("" + textureName)));
        this.container.addChild(this._mainAnimation.container);
        if (stopOnComplete) {
            this._mainAnimation.setOnComplete(function () {
                _this._mainAnimation.stop();
            });
        }
        this.updateManager.add(this._mainAnimation);
        this._mainAnimation.start();
        return this._mainAnimation;
    };
    GameFreeRoundsScreenView.prototype.getTextureName = function () {
        switch (this.resources.getLocale().toLowerCase()) {
            case 'zh-cn':
                return 'LOGO_ZH_CN.png';
            case 'zh-tw':
                return 'LOGO_ZH_TW.png';
            default:
                return 'LOGOTYPE.png';
        }
    };
    return GameFreeRoundsScreenView;
}(FreeRoundsScreenView_1.FreeRoundsScreenView));
exports.GameFreeRoundsScreenView = GameFreeRoundsScreenView;


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var StartScreenView_1 = __webpack_require__(334);
var SpineAnimationMultiTrack_1 = __webpack_require__(147);
var SpriteGraphics_1 = __webpack_require__(62);
var Spine_1 = __webpack_require__(25);
var GameStartScreenView = /** @class */ (function (_super) {
    __extends(GameStartScreenView, _super);
    function GameStartScreenView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameStartScreenView.prototype.setupIntro = function () {
        this._introScreen = new Spine_1.Spine(this.resources.getSpine('STARTSCREEN.json', this.viewType));
        this._introFeatures = new Spine_1.Spine(this.resources.getSpine('FEATURE_SCREENS.json', this.viewType));
        this._extraBackground = SpriteGraphics_1.SpriteGraphics.makeHiddenRectangle(this.resolutionManager.resolution.width, this.resolutionManager.resolution.height);
        if (this.shouldReplaceLogoElement()) {
            var textureName = this.getTextureName();
            this.spineUtils.replaceElementInSpine(this._introFeatures, 'FEATURE_1_LOGOTYPE', new PIXI.Sprite(this.resources.getTexture(textureName + "_STARTSCREEN.png")));
        }
        var introPosition = this.layout.getCenterOfScreen(this.viewType);
        this._introFeatures.position.set(introPosition.x, introPosition.y);
        this._screenAnimations = new SpineAnimationMultiTrack_1.SpineAnimationMultiTrack(this._introScreen);
        this._featuresAnimations = new SpineAnimationMultiTrack_1.SpineAnimationMultiTrack(this._introFeatures);
        this._screenAnimations.start();
        this._featuresAnimations.start();
        this.setupTranslatedWinUpTo();
    };
    GameStartScreenView.prototype.shouldReplaceLogoElement = function () {
        return this.resources.getLocale().toLowerCase().indexOf('zh') > -1;
    };
    GameStartScreenView.prototype.getTextureName = function () {
        switch (this.resources.getLocale().toLowerCase()) {
            case 'zh-cn':
                return 'LOGO_ZH_CN';
            case 'zh-tw':
                return 'LOGO_ZH_TW';
            default:
                return '';
        }
    };
    return GameStartScreenView;
}(StartScreenView_1.StartScreenView));
exports.GameStartScreenView = GameStartScreenView;


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var StartScreenModule_1 = __webpack_require__(679);
var GameStartScreenModule = /** @class */ (function (_super) {
    __extends(GameStartScreenModule, _super);
    function GameStartScreenModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameStartScreenModule.prototype.keyboardInput = function (event) {
        if (event.code === 'Space' || event.code === 'Enter') {
            this.view.proceed();
        }
        if (event.code === 'KeyA' || event.code === 'ArrowLeft') {
            this.view.nextFeature();
        }
        if (event.code === 'KeyD' || event.code === 'ArrowRight') {
            this.view.previousFeature();
        }
    };
    return GameStartScreenModule;
}(StartScreenModule_1.StartScreenModule));
exports.GameStartScreenModule = GameStartScreenModule;


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Module_1 = __webpack_require__(2);
var Views_1 = __webpack_require__(8);
var StartScreenEvents_1 = __webpack_require__(22);
var StartScreenView_1 = __webpack_require__(334);
var StartScreenViewEvents_1 = __webpack_require__(335);
/**
 * module for start/intro screen
 * handles also keyboard input over start/intro screen
 */
var StartScreenModule = /** @class */ (function (_super) {
    __extends(StartScreenModule, _super);
    function StartScreenModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StartScreenModule.prototype.afterInit = function () {
        _super.prototype.afterInit.call(this);
        this.tryToInitiateStartScreen();
    };
    StartScreenModule.prototype.restore = function () {
        _super.prototype.restore.call(this);
        this.view.hide();
        this.onExitFinished();
    };
    StartScreenModule.prototype.setupStates = function () { };
    StartScreenModule.prototype.enterFirstState = function () { };
    StartScreenModule.prototype.setupViews = function () {
        if (this.system.shouldUseMultipleViews()) {
            this.setView(Views_1.Views.STARTSCREEN_VIEW_MOBILE);
        }
        else {
            this.setView(Views_1.Views.STARTSCREEN_VIEW);
        }
    };
    StartScreenModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.onViewEmitEvent(StartScreenViewEvents_1.StartScreenViewEvents.INTRO_FINISHED, StartScreenEvents_1.StartScreenEvents.INTRO_FINISHED);
        this.onViewEmitEvent(StartScreenViewEvents_1.StartScreenViewEvents.INTRO_STARTED, StartScreenEvents_1.StartScreenEvents.INTRO_STARTED);
        this.onViewEmitEvent(StartScreenViewEvents_1.StartScreenViewEvents.INTRO_IDLE, StartScreenEvents_1.StartScreenEvents.INTRO_IDLE);
        this.onViewEmitEvent(StartScreenViewEvents_1.StartScreenViewEvents.EXIT_STARTED, StartScreenEvents_1.StartScreenEvents.EXIT_STARTED);
        this.onViewEmitEvent(StartScreenView_1.StartScreenView.PLAY_BUTTON_CLICKED, StartScreenEvents_1.StartScreenEvents.PLAY_BUTTON_CLICKED);
        this.onView(StartScreenViewEvents_1.StartScreenViewEvents.EXIT_FINISHED, this.onExitFinished);
    };
    StartScreenModule.prototype.tryToInitiateStartScreen = function () {
        if (this.logic.skipIntro === false && this.logic.hasRestore === false) {
            this.view.playIntroAnimation();
            this.addKeyboardInput();
        }
        else {
            this.onExitFinished();
        }
    };
    StartScreenModule.prototype.onExitFinished = function () {
        this.removeKeyboardInput();
        this.view.hide();
        this.eventManager.emit(StartScreenEvents_1.StartScreenEvents.EXIT_FINISHED);
    };
    StartScreenModule.prototype.keyboardInput = function (event) {
        if (event.code === 'Space' || event.code === 'Enter') {
            this.view.proceed();
        }
        if (event.code === 'KeyA' || event.code === 'ArrowLeft') {
            this.view.previousFeature();
        }
        if (event.code === 'KeyD' || event.code === 'ArrowRight') {
            this.view.nextFeature();
        }
    };
    StartScreenModule.prototype.addKeyboardInput = function () {
        if (!this.device.isMobile && !this.logic.skipIntro) {
            this._inputFunction = this.keyboardInput.bind(this);
            document.addEventListener('keydown', this._inputFunction);
        }
    };
    StartScreenModule.prototype.removeKeyboardInput = function () {
        document.removeEventListener('keydown', this._inputFunction);
    };
    return StartScreenModule;
}(Module_1.Module));
exports.StartScreenModule = StartScreenModule;


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var SoundManager_1 = __webpack_require__(145);
var GameMobileSoundManager = /** @class */ (function (_super) {
    __extends(GameMobileSoundManager, _super);
    function GameMobileSoundManager() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameMobileSoundManager.prototype.init = function (device) {
        this._allEffects = this.loader.getSound('resources/mobileSounds/all.mp3');
        this._allEffectsConfig = this.loader.getMobileSoundConfig();
        this._effects.allSound = this._allEffects;
        _super.prototype.init.call(this, device);
    };
    GameMobileSoundManager.prototype.getSoundLength = function (id) {
        if (this._allEffects.sprites.hasOwnProperty(id)) {
            return this._allEffects.sprites[id].duration;
        }
        if (this._effects[id]) {
            return this._effects[id].duration;
        }
    };
    GameMobileSoundManager.prototype.getMusicLength = function (id) {
        return this._music[id].duration;
    };
    GameMobileSoundManager.prototype.getVoiceLength = function (id) {
        return this._allEffects.sprites[id].duration;
    };
    GameMobileSoundManager.prototype.initVolumes = function () {
    };
    GameMobileSoundManager.prototype.initEffects = function () {
        _super.prototype.initEffects.call(this);
        var curConfig = this._allEffectsConfig.spritemap;
        this._allEffects.addSprites('buttonClick', { start: curConfig.btn_general.start, end: curConfig.btn_general.end });
        this._allEffects.addSprites('spinBtnStart', { start: curConfig.btn_spin_start.start, end: curConfig.btn_spin_start.end });
        this._allEffects.addSprites('gameIntro', { start: curConfig.trans_game_intro.start, end: curConfig.trans_game_intro.end });
        this._allEffects.addSprites('reelsFallOut', { start: curConfig.reels_fall_out.start, end: curConfig.reels_fall_out.end });
        this._allEffects.addSprites('reelsFallIn', { start: curConfig.reels_fall_in.start, end: curConfig.reels_fall_in.end });
        this._allEffects.addSprites('reelsFallIn3sec', { start: curConfig.reels_fall_in_3sec.start, end: curConfig.reels_fall_in_3sec.end });
        this._allEffects.addSprites('reelsRemove', { start: curConfig.reels_remove.start, end: curConfig.reels_remove.end });
        this._allEffects.addSprites('winLineL', { start: curConfig.win_indicate_lr.start, end: curConfig.win_indicate_lr.end });
        this._allEffects.addSprites('winLineR', { start: curConfig.win_indicate_rl.start, end: curConfig.win_indicate_rl.end });
        this._allEffects.addSprites('winCountup', { start: curConfig.win_countup.start, end: curConfig.win_countup.end });
        this._allEffects.addSprites('winNormal', { start: curConfig.win_normal.start, end: curConfig.win_normal.end });
        this._allEffects.addSprites('winNice', { start: curConfig.win_nice.start, end: curConfig.win_nice.end });
        this._allEffects.addSprites('winExcellent', { start: curConfig.win_excellent.start, end: curConfig.win_excellent.end });
        this._allEffects.addSprites('winRetrigger', { start: curConfig.win_retrigger.start, end: curConfig.win_retrigger.end });
        this._allEffects.addSprites('bigwinBuildup', { start: curConfig.win_bigwin_buildup.start, end: curConfig.win_bigwin_buildup.end });
        // this._allEffects.addSprites('bigwinLoop', {start: curConfig.win_bigwin_loop.start, end: curConfig.win_bigwin_loop.end});
        this._allEffects.addSprites('bigwinEnd', { start: curConfig.win_bigwin_end.start, end: curConfig.win_bigwin_end.end });
        this._allEffects.addSprites('bigwinThreshold', { start: curConfig.win_bigwin_threshold.start, end: curConfig.win_bigwin_threshold.end });
        this._allEffects.addSprites('multCollectFly', { start: curConfig.mult_collect_fly.start, end: curConfig.mult_collect_fly.end });
        this._allEffects.addSprites('multCollectHit', { start: curConfig.mult_collect_hit.start, end: curConfig.mult_collect_hit.end });
        this._allEffects.addSprites('multUpdate', { start: curConfig.mult_update.start, end: curConfig.mult_update.end });
        this._allEffects.addSprites('multUpdateFs', { start: curConfig.mult_update_fs.start, end: curConfig.mult_update_fs.end });
        this._allEffects.addSprites('multWildBreak', { start: curConfig.mult_wildbreak.start, end: curConfig.mult_wildbreak.end });
        this._allEffects.addSprites('multWin', { start: curConfig.mult_win.start, end: curConfig.mult_win.end });
        this._allEffects.addSprites('respinAttention', { start: curConfig.atn_respin.start, end: curConfig.atn_respin.end });
        this._allEffects.addSprites('respinActivate', { start: curConfig.rsp_activate.start, end: curConfig.rsp_activate.end });
        this._allEffects.addSprites('respinMove', { start: curConfig.rsp_move.start, end: curConfig.rsp_move.end });
        this._allEffects.addSprites('respinHit1', { start: curConfig.rsp_hit01.start, end: curConfig.rsp_hit01.end });
        this._allEffects.addSprites('respinHit2', { start: curConfig.rsp_hit02.start, end: curConfig.rsp_hit02.end });
        this._allEffects.addSprites('respinHit3', { start: curConfig.rsp_hit03.start, end: curConfig.rsp_hit03.end });
        this._allEffects.addSprites('respinEnd', { start: curConfig.rsp_end.start, end: curConfig.rsp_end.end });
        this._allEffects.addSprites('scatterAttention1', { start: curConfig.atn_scatter_1.start, end: curConfig.atn_scatter_1.end });
        this._allEffects.addSprites('scatterAttention2', { start: curConfig.atn_scatter_2.start, end: curConfig.atn_scatter_2.end });
        this._allEffects.addSprites('scatterAttention3', { start: curConfig.atn_scatter_3.start, end: curConfig.atn_scatter_3.end });
        this._allEffects.addSprites('freeSpinsIntro', { start: curConfig.trans_fs_intro.start, end: curConfig.trans_fs_intro.end });
        this._allEffects.addSprites('freeSpinsOutro', { start: curConfig.trans_fs_outro.start, end: curConfig.trans_fs_outro.end });
        this._allEffects.addSprites('spinBtnQuickStop', { start: curConfig.btn_spin_stop.start, end: curConfig.btn_spin_stop.end });
        this._allEffects.addSprites('multCollectIndicator', { start: curConfig.mult_collect_indicator.start, end: curConfig.mult_collect_indicator.end });
        this._effects.bigwinLoop = this.loader.getSound('resources/sounds/music/win_bigwin_loop.mp3');
    };
    GameMobileSoundManager.prototype.initMusic = function () {
        _super.prototype.initMusic.call(this);
        this._music.mainMusic1 = this.loader.getSound('resources/sounds/music/music_main_1.mp3');
        this._music.mainMusic2 = this.loader.getSound('resources/sounds/music/music_main_2.mp3');
        this._music.mainMusic3 = this.loader.getSound('resources/sounds/music/music_main_3.mp3');
        this._music.freeSpinsMusic = this.loader.getSound('resources/sounds/music/music_fs.mp3');
    };
    GameMobileSoundManager.prototype.initVoice = function () {
        _super.prototype.initVoice.call(this);
    };
    return GameMobileSoundManager;
}(SoundManager_1.SoundManager));
exports.GameMobileSoundManager = GameMobileSoundManager;


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var MainMenuModule_1 = __webpack_require__(336);
var GameWinPresentationEvents_1 = __webpack_require__(40);
var RespinEvents_1 = __webpack_require__(92);
var GameAvalancheReelsEvents_1 = __webpack_require__(39);
var BigWinEvents_1 = __webpack_require__(21);
var GameRecodeMainMenuModule = /** @class */ (function (_super) {
    __extends(GameRecodeMainMenuModule, _super);
    function GameRecodeMainMenuModule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameRecodeMainMenuModule.prototype.setupEvents = function () {
        _super.prototype.setupEvents.call(this);
        this.on(GameWinPresentationEvents_1.GameWinPresentationEvents.COUNTING_STARTED, this.onWinCountingStarted);
        this.on(BigWinEvents_1.BigWinEvents.STARTED, this.onBigWinStarted);
        this.on(RespinEvents_1.RespinEvents.RESPIN_STARTED, this.onRespinStarted);
        this.on(GameAvalancheReelsEvents_1.GameAvalancheReelsEvents.WIN_HIGHLIGHTING_STARTED, this.onWinHighlightStarted);
    };
    GameRecodeMainMenuModule.prototype.onBigWinStarted = function () {
        this.hideMenu();
    };
    GameRecodeMainMenuModule.prototype.onWinCountingStarted = function () {
        this.hideMenu();
    };
    GameRecodeMainMenuModule.prototype.onRespinStarted = function () {
        this.hideMenu();
    };
    GameRecodeMainMenuModule.prototype.onWinHighlightStarted = function () {
        this.hideMenu();
    };
    return GameRecodeMainMenuModule;
}(MainMenuModule_1.MainMenuModule));
exports.GameRecodeMainMenuModule = GameRecodeMainMenuModule;


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var MainMenuEvents_1 = __webpack_require__(44);
var MainMenuBasicState = /** @class */ (function (_super) {
    __extends(MainMenuBasicState, _super);
    function MainMenuBasicState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MainMenuBasicState.prototype.onEnterState = function () {
        this.emit(MainMenuEvents_1.MainMenuEvents.MAIN_MENU_CLOSED);
        this.view.hideMainMenu();
        //
    };
    MainMenuBasicState.prototype.onLeaveState = function () {
        //
    };
    MainMenuBasicState.prototype.setupEvents = function () {
        //
    };
    return MainMenuBasicState;
}(ModuleState_1.ModuleState));
exports.MainMenuBasicState = MainMenuBasicState;


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ModuleState_1 = __webpack_require__(1);
var MenuButtonEvents_1 = __webpack_require__(152);
var MainMenuEvents_1 = __webpack_require__(44);
var MainMenuModule_1 = __webpack_require__(336);
var LogicEvents_1 = __webpack_require__(11);
var SpinButtonEvents_1 = __webpack_require__(12);
var FreeSpinsEvents_1 = __webpack_require__(6);
var RelaxEvents_1 = __webpack_require__(167);
var MainMenuOpenState = /** @class */ (function (_super) {
    __extends(MainMenuOpenState, _super);
    function MainMenuOpenState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MainMenuOpenState.prototype.onEnterState = function () {
        this.emit(MainMenuEvents_1.MainMenuEvents.MAIN_MENU_OPEN);
        this.showMenu();
        this.showLastMenu();
    };
    MainMenuOpenState.prototype.onLeaveState = function () {
        this.emit(MainMenuEvents_1.MainMenuEvents.MAIN_MENU_CLOSED);
    };
    MainMenuOpenState.prototype.showMenu = function () {
        this.view.showMainMenu();
    };
    MainMenuOpenState.prototype.showLastMenu = function () {
        if (this.module._lastMenu === MainMenuModule_1.MENU.SETTINGS) {
            this.emit(MainMenuEvents_1.MainMenuEvents.MAIN_MENU_SETTINGS_OPEN);
        }
        else if (this.module._lastMenu === MainMenuModule_1.MENU.INFO) {
            this.emit(MainMenuEvents_1.MainMenuEvents.MAIN_MENU_INFO_OPEN);
        }
        else {
            this.module._lastMenu === MainMenuModule_1.MENU.PAYTABLE;
            this.emit(MainMenuEvents_1.MainMenuEvents.MAIN_MENU_PAYTABLE_OPEN);
        }
    };
    MainMenuOpenState.prototype.onCloseClicked = function () {
        this.module.gotoState(MainMenuModule_1.MainMenuModule.BASIC);
    };
    MainMenuOpenState.prototype.setupEvents = function () {
        this.on(SpinButtonEvents_1.SpinButtonEvents.SPACE_BUTTON_CLICKED, this.onCloseClicked);
        this.on(MenuButtonEvents_1.MenuButtonEvents.MENU_BUTTON_CLICKED, this.onCloseClicked);
        this.on(MainMenuEvents_1.MainMenuEvents.MAIN_MENU_CLOSE_CLICKED, this.onCloseClicked);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_INTRO_STARTED, this.onCloseClicked);
        this.on(FreeSpinsEvents_1.FreeSpinsEvents.FREE_SPINS_OUTRO_STARTED, this.onCloseClicked);
        this.on(RelaxEvents_1.RelaxEvents.SHOW_REALITY_CHECK, this.onCloseClicked);
        this.on(LogicEvents_1.LogicEvents.ERROR_RESPONSE, this.onErrorResponse);
    };
    MainMenuOpenState.prototype.onErrorResponse = function () {
        this.module.gotoState(MainMenuModule_1.MainMenuModule.BASIC);
    };
    return MainMenuOpenState;
}(ModuleState_1.ModuleState));
exports.MainMenuOpenState = MainMenuOpenState;


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// LocalDev_RecodeV760/Games/FantasmaGames/hadesRiverOfSouls/js/game.js